/**
 * @license OpenTok.js 2.30.2 5b8d84a71
 *
 * Copyright (c) 2010-2025 TokBox, Inc.
 * Subject to the applicable Software Development Kit (SDK) License Agreement:
 * https://www.vonage.com/legal/communications-apis/terms-of-use/
 *
 * Date: Mon, 02 Jun 2025 20:48:47 GMT
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["OT"] = factory();
	else
		root["OT"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 366);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _debug = _interopRequireDefault(__webpack_require__(421));
var _memoize = _interopRequireDefault(__webpack_require__(129));
var _logLevels = _interopRequireDefault(__webpack_require__(130));
/**
 * @typedef {Object} Logger
 * @property {Function} error
 * @property {Function} warn
 * @property {Function} info
 * @property {Function} log
 * @property {Function} debug
 * @property {Function} spam
 */

const createLogger = (0, _memoize.default)(namespace => {
  /** @type Logger */
  const API = {};
  const setMethods = () => {
    Object.keys(_logLevels.default).forEach(name => {
      const method = _logLevels.default[name].method;
      const log = (0, _debug.default)(`OpenTok:${namespace}:${name.toLowerCase()}`);
      log.log = console[method].bind(console); // eslint-disable-line no-console
      API[name.toLowerCase()] = log;
    });
  };
  setMethods();
  return API;
});
createLogger.setLogLevel = level => {
  let oldRules;
  try {
    oldRules = (typeof window !== undefined ? window : global).localStorage.debug;
  } catch (err) {
    // will get Uncaught DOMException: Failed to read the 'localStorage' property from 'Window':
    // The document is sandboxed and lacks the 'allow-same-origin' flag.
    oldRules = '';
  }
  const newDebugRules = Object.keys(_logLevels.default).map(name => `${level >= _logLevels.default[name].priority ? '' : '-'}(autogen)?OpenTok:*:${name.toLowerCase()}`);
  const debugStr = [...newDebugRules, ...(oldRules || '').split(/[\s,]/).filter(rule => rule.indexOf('(autogen)?') === -1)].filter(x => x).join(',');
  _debug.default.enable(debugStr);
};
var _default = createLogger;
exports.default = _default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves

    Synchronous example:

    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }

    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```

    Asynchronous example:

    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```

    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof (typeof window !== undefined ? window : global) !== 'undefined') {
    local = (typeof window !== undefined ? window : global);
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(24)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _envParser = _interopRequireDefault(__webpack_require__(477));
const env = _envParser.default.parse();
var _default = env;
exports.default = _default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(417);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Promise) {function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = eventing;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _isFunction = _interopRequireDefault(__webpack_require__(20));
var _events = _interopRequireDefault(__webpack_require__(12));
var _log = _interopRequireDefault(__webpack_require__(1));
var _weakMemoizeBind = _interopRequireDefault(__webpack_require__(424));
const logging = (0, _log.default)('Events');

/**
 * This base class defines the <code>on</code>, <code>once</code>, and <code>off</code>
 * methods of objects that can dispatch events.
 *
 * @class EventDispatcher
 */
function eventing(self) {
  const ee = new _events.default();
  ee.on('newListener', eventName => {
    ee.emit(`${eventName}:added`);
  });
  ee.on('removeListener', eventName => {
    ee.emit(`${eventName}:removed`);
  });
  const eventingMixin = {
    /**
     * A map of events already dispatched.
     */

    eventsDispatched: {},
    /**
     * Adds an event handler function for one or more events.
     *
     * <p>
     * The following code adds an event handler for one event:
     * </p>
     *
     * <pre>
     * obj.on("eventName", function (event) {
     *     // This is the event handler.
     * });
     * </pre>
     *
     * <p>If you pass in multiple event names and a handler method, the handler is
     * registered for each of those events:</p>
     *
     * <pre>
     * obj.on("eventName1 eventName2",
     *        function (event) {
     *            // This is the event handler.
     *        });
     * </pre>
     *
     * <p>You can also pass in a third <code>context</code> parameter (which is optional) to
     * define the value of <code>this</code> in the handler method:</p>
     *
     * <pre>obj.on("eventName",
     *        function (event) {
     *            // This is the event handler.
     *        },
     *        obj);
     * </pre>
     *
     * <p>
     * The method also supports an alternate syntax, in which the first parameter is an object
     * that is a hash map of event names and handler functions and the second parameter (optional)
     * is the context for this in each handler:
     * </p>
     * <pre>
     * obj.on(
     *    {
     *       eventName1: function (event) {
     *               // This is the handler for eventName1.
     *           },
     *       eventName2:  function (event) {
     *               // This is the handler for eventName2.
     *           }
     *    },
     *    obj);
     * </pre>
     *
     * <p>
     * If you do not add a handler for an event, the event is ignored locally.
     * </p>
     *
     * @param {String} type The string identifying the type of event. You can specify multiple event
     * names in this string, separating them with a space. The event handler will process each of
     * the events.
     * @param {Function} handler The handler function to process the event. This function takes
     * the event object as a parameter.
     * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
     * handler function.
     *
     * @returns {EventDispatcher} The EventDispatcher object.
     *
     * @memberOf EventDispatcher
     * @method #on
     * @see <a href="#off">off()</a>
     * @see <a href="#once">once()</a>
     * @see <a href="#events">Events</a>
     */

    on(eventNames, handlerOrContext, context) {
      if (typeof eventNames === 'string' && handlerOrContext) {
        eventNames.split(' ').forEach(eventName => {
          ee.on(eventName, (0, _weakMemoizeBind.default)(handlerOrContext, context));
        });
      } else {
        Object.keys(eventNames).forEach(eventName => {
          ee.on(eventName, (0, _weakMemoizeBind.default)(eventNames[eventName], handlerOrContext));
        });
      }
      return this;
    },
    /**
     * Removes an event handler or handlers.
     *
     * <p>If you pass in one event name and a handler method, the handler is removed for that
     * event:</p>
     *
     * <pre>obj.off("eventName", eventHandler);</pre>
     *
     * <p>If you pass in multiple event names and a handler method, the handler is removed for
     * those events:</p>
     *
     * <pre>obj.off("eventName1 eventName2", eventHandler);</pre>
     *
     * <p>If you pass in an event name (or names) and <i>no</i> handler method, all handlers are
     * removed for those events:</p>
     *
     * <pre>obj.off("event1Name event2Name");</pre>
     *
     * <p>If you pass in no arguments, <i>all</i> event handlers are removed for all events
     * dispatched by the object:</p>
     *
     * <pre>obj.off();</pre>
     *
     * <p>
     * The method also supports an alternate syntax, in which the first parameter is an object that
     * is a hash map of event names and handler functions and the second parameter (optional) is
     * the context for this in each handler:
     * </p>
     * <pre>
     * obj.off(
     *    {
     *       eventName1: event1Handler,
     *       eventName2: event2Handler
     *    });
     * </pre>
     *
     * @param {String} type (Optional) The string identifying the type of event. You can
     * use a space to specify multiple events, as in "accessAllowed accessDenied
     * accessDialogClosed". If you pass in no <code>type</code> value (or other arguments),
     * all event handlers are removed for the object.
     * @param {Function} handler (Optional) The event handler function to remove. The handler
     * must be the same function object as was passed into <code>on()</code>. Be careful with
     * helpers like <code>bind()</code> that return a new function when called. If you pass in
     * no <code>handler</code>, all event handlers are removed for the specified event
     * <code>type</code>.
     * @param {Object} context (Optional) If you specify a <code>context</code>, the event handler
     * is removed for all specified events and handlers that use the specified context. (The
     * context must match the context passed into <code>on()</code>.)
     *
     * @returns {Object} The object that dispatched the event.
     *
     * @memberOf EventDispatcher
     * @method #off
     * @see <a href="#on">on()</a>
     * @see <a href="#once">once()</a>
     * @see <a href="#events">Events</a>
     */
    off(eventNames, handlerOrContext, context) {
      if (typeof eventNames === 'string') {
        this.off(eventNames.split(' '), handlerOrContext, context);
      } else if (Array.isArray(eventNames)) {
        eventNames.forEach(eventName => {
          if (handlerOrContext && (0, _isFunction.default)(handlerOrContext)) {
            ee.removeListener(eventName, (0, _weakMemoizeBind.default)(handlerOrContext, context));
          } else {
            ee.removeAllListeners(eventName);
          }
        });
      } else if (!eventNames) {
        ee.removeAllListeners();
      } else {
        Object.keys(eventNames).forEach(eventName => {
          // @todo was {foo: undefined} expected to remove all foo events?
          ee.removeListener(eventName, (0, _weakMemoizeBind.default)(eventNames[eventName], handlerOrContext));
        });
      }
      return this;
    },
    /**
     * Adds an event handler function for one or more events. Once the handler is called,
     * the specified handler method is removed as a handler for this event. (When you use
     * the <code>on()</code> method to add an event handler, the handler is <i>not</i>
     * removed when it is called.) The <code>once()</code> method is the equivilent of
     * calling the <code>on()</code>
     * method and calling <code>off()</code> the first time the handler is invoked.
     *
     * <p>
     * The following code adds a one-time event handler for one event:
     * </p>
     *
     * <pre>
     * obj.once("eventName", function (event) {
     *    // This is the event handler.
     * });
     * </pre>
     *
     * <p>If you pass in multiple event names and a handler method, the handler is registered
     * for each of those events:</p>
     *
     * <pre>obj.once("eventName1 eventName2"
     *          function (event) {
     *              // This is the event handler.
     *          });
     * </pre>
     *
     * <p>You can also pass in a third <code>context</code> parameter (which is optional) to define
     * the value of
     * <code>this</code> in the handler method:</p>
     *
     * <pre>obj.once("eventName",
     *          function (event) {
     *              // This is the event handler.
     *          },
     *          obj);
     * </pre>
     *
     * <p>
     * The method also supports an alternate syntax, in which the first parameter is an object that
     * is a hash map of event names and handler functions and the second parameter (optional) is the
     * context for this in each handler:
     * </p>
     * <pre>
     * obj.once(
     *    {
     *       eventName1: function (event) {
     *                  // This is the event handler for eventName1.
     *           },
     *       eventName2:  function (event) {
     *                  // This is the event handler for eventName1.
     *           }
     *    },
     *    obj);
     * </pre>
     *
     * @param {String} type The string identifying the type of event. You can specify multiple
     * event names in this string, separating them with a space. The event handler will process
     * the first occurence of the events. After the first event, the handler is removed (for
     * all specified events).
     * @param {Function} handler The handler function to process the event. This function takes
     * the event object as a parameter.
     * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
     * handler function.
     *
     * @returns {Object} The object that dispatched the event.
     *
     * @memberOf EventDispatcher
     * @method #once
     * @see <a href="#on">on()</a>
     * @see <a href="#off">off()</a>
     * @see <a href="#events">Events</a>
     */
    once(eventNames, handlerOrContext, context) {
      if (typeof eventNames === 'string' && handlerOrContext) {
        eventNames.split(' ').forEach(eventName => {
          ee.once(eventName, (0, _weakMemoizeBind.default)(handlerOrContext, context));
        });
      } else {
        Object.keys(eventNames).forEach(eventName => {
          ee.once(eventName, (0, _weakMemoizeBind.default)(eventNames[eventName], handlerOrContext));
        });
      }
      return this;
    },
    /**
     * Execute any listeners bound to the +event+ Event.
     *
     * Each handler will be executed.
     *
     * @param [Event] event An Event object.
     * @return this
    */
    dispatchEvent(event) {
      if (!event.type) {
        throw new Error('dispatchEvent: Event has no type');
      }
      if (!event.target) {
        event.target = this; // eslint-disable-line no-param-reassign
      }

      this.trigger(event.type, event);
      return this;
    },
    dispatchEventOnce(event, targetId) {
      if (!this.isEventDispatched(event.type, targetId)) {
        this.dispatchEvent(event);
        if (this.eventsDispatched[event.type]) {
          this.eventsDispatched[event.type].push(targetId);
        } else {
          this.eventsDispatched[event.type] = [targetId];
        }
      }
    },
    isEventDispatched(type, targetId) {
      var _this$eventsDispatche;
      return (_this$eventsDispatche = this.eventsDispatched[type]) == null ? void 0 : _this$eventsDispatche.includes(targetId);
    },
    /**
     * Execute each handler for the event called +name+.
     *
     * Each handler will be executed, and any exceptions that they throw will
     * be caught and logged
     *
     * @example
     * foo.on('bar', function(name, message) {
     *   alert("Hello " + name + ": " + message);
     * });
     *
     * foo.trigger('Vonage Video API', 'asdf'); // -> Hello Vonage Video API: asdf
     *
     * @param {String} eventName The name of this event.
     * @param {Array} arguments The arguments handlers will be called with
     *
     * @return this
     */
    trigger(eventName) {
      try {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        ee.emit(eventName, ...args);
      } catch (e) {
        logging.error('An error occurred in an event handler', e);
      }
      return this;
    },
    // Alias of trigger for easier node compatibility
    emit() {
      return self.trigger(...arguments);
    },
    /**
     * @deprecated use <a href="#on">on()</a> or <a href="#once">once()</a> instead.
     * <p>
     * This method registers a method as an event listener for a specific event.
     * <p>
     *
     * <p>
     *   If a handler is not registered for an event, the event is ignored locally. If the
     *   event listener function does not exist, the event is ignored locally.
     * </p>
     * <p>
     *   Throws an exception if the <code>listener</code> name is invalid.
     * </p>
     *
     * @param {String} type The string identifying the type of event.
     *
     * @param {Function} listener The function to be invoked when the object dispatches the event.
     *
     * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
     * handler function.
     *
     * @memberOf EventDispatcher
     * @method #addEventListener
     * @see <a href="#on">on()</a>
     * @see <a href="#once">once()</a>
     * @see <a href="#events">Events</a>
    */

    addEventListener(eventName, handler, context) {
      logging.warn('The addEventListener() method is deprecated. Use on() or once() instead.');
      return self.on(eventName, handler, context);
    },
    /**
     * @deprecated use <a href="#off">off()</a> instead.
     * <p>
     * Removes an event listener for a specific event.
     * <p>
     *
     * <p>
     *   Throws an exception if the <code>listener</code> name is invalid.
     * </p>
     *
     * @param {String} type The string identifying the type of event.
     *
     * @param {Function} listener The event listener function to remove.
     *
     * @param {Object} context (Optional) If you specify a <code>context</code>, the event
     * handler is removed for all specified events and event listeners that use the specified
     context. (The context must match the context passed into
     * <code>addEventListener()</code>.)
     *
     * @memberOf EventDispatcher
     * @method #removeEventListener
     * @see <a href="#off">off()</a>
     * @see <a href="#events">Events</a>
     */
    // See 'off' for usage.
    // @depreciated will become a private helper function in the future.
    removeEventListener(eventName, handler, context) {
      logging.warn('The removeEventListener() method is deprecated. Use off() instead.');
      return self.off(eventName, handler, context);
    },
    listenerCount(eventName) {
      return ee.listenerCount(eventName);
    }
  };
  return (0, _assign.default)(self, eventingMixin);
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _defaults = _interopRequireDefault(__webpack_require__(147));
var _shorthandSelector = _interopRequireDefault(__webpack_require__(262));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _env = _interopRequireDefault(__webpack_require__(3));
var _setDeprecatedProperty = _interopRequireDefault(__webpack_require__(264));
var _index = _interopRequireDefault(__webpack_require__(263));
var _ajax = _interopRequireDefault(__webpack_require__(265));
var _statable = _interopRequireDefault(__webpack_require__(575));
var _analytics = _interopRequireDefault(__webpack_require__(267));
var _collection = _interopRequireDefault(__webpack_require__(270));
var _domExtras = _interopRequireDefault(__webpack_require__(588));
var _error = _interopRequireDefault(__webpack_require__(272));
// The top-level namespace, also performs basic DOMElement selecting.
//
// @example Get the DOM element with the id of 'domId'
//   OTHelpers('#domId')
//
// @example Get all video elements
//   OTHelpers('video')
//
// @example Get all elements with the class name of 'foo'
//   OTHelpers('.foo')
//
// @example Get all elements with the class name of 'foo',
// and do something with the first.
//   var collection = OTHelpers('.foo');
//   console.log(collection.first);
//
//
// The second argument is the context, that is document or parent Element, to
// select from.
//
// @example Get a video element within the element with the id of 'domId'
//   OTHelpers('video', OTHelpers('#domId'))
//
//
//
// OTHelpers will accept any of the following and return a collection:
//   OTHelpers()
//   OTHelpers('css selector', optionalParentNode)
//   OTHelpers(DomNode)
//   OTHelpers([array of DomNode])
//
// The collection is a ElementCollection object, see the ElementCollection docs for usage info.
//

_shorthandSelector.default.logging = (0, _log.default)('OT.$');
_shorthandSelector.default.env = _env.default;
_shorthandSelector.default.ElementCollection = _index.default;
_shorthandSelector.default.ajax = _ajax.default;
_shorthandSelector.default.statable = _statable.default;
_shorthandSelector.default.Analytics = _analytics.default;
_shorthandSelector.default.Collection = _collection.default;
_shorthandSelector.default.domExtras = _domExtras.default;
_shorthandSelector.default.Error = _error.default;
(0, _setDeprecatedProperty.default)(_shorthandSelector.default, 'useLogHelpers', {
  value(mixin) {
    const logging = (0, _log.default)('useLogHelpersDeprecatedMixin');
    // eslint-disable-next-line no-param-reassign
    Object.keys(logging).forEach(key => {
      mixin[key] = logging[key];
    });
    return mixin;
  },
  name: 'OT.useLogHelpers',
  getWarning: 'Please use an external library for your debugging needs'
});
_shorthandSelector.default.defaults = _defaults.default;
(0, _setDeprecatedProperty.default)(_shorthandSelector.default, 'eventing', {
  value: _eventing.default,
  name: 'OT.$.eventing',
  getWarning: 'Please use an external library to create an event emitter.'
});

// TODO: Remove the need for this kind of bazzadry.
Object.keys(_shorthandSelector.default).forEach(key => {
  const component = _shorthandSelector.default[key];
  const attachments = component._attachToOTHelpers || {};
  Object.keys(attachments).forEach(attachmentName => {
    if (Object.hasOwnProperty.call(_shorthandSelector.default, attachmentName) && !(key === 'util' && attachmentName === 'bind')) {
      // eslint-disable-next-line no-console
      console.warn(`More than one module is trying to define ${attachmentName} on OTHelpers.`);
    }
    _shorthandSelector.default[attachmentName] = attachments[attachmentName];
  });
});
var _default = _shorthandSelector.default;
exports.default = _default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Note: Some of these descriptions here are more specific than the name would suggest, because we
// only use them in one place. However, this shouldn't prevent us from using the error elsewhere if
// the name fits, and we should update the description to be more general when this happens.
var _default = {
  // The API key does not match the token or session.
  AUTHENTICATION_ERROR: 'OT_AUTHENTICATION_ERROR',
  // JSON response was badly formed.
  BADLY_FORMED_RESPONSE: 'OT_BADLY_FORMED_RESPONSE',
  // Unable to publish because your browser failed to get access to your microphone. You may need to
  // fully quit and restart your browser to get it to work.
  // See https://bugs.chromium.org/p/webrtc/issues/detail?id=4799 for more details.
  CHROME_MICROPHONE_ACQUISITION_ERROR: 'OT_CHROME_MICROPHONE_ACQUISITION_ERROR',
  // Failed to connect to session.
  CONNECT_FAILED: 'OT_CONNECT_FAILED',
  // The session has exceded the maximum number of simultaneous connections.
  CONNECTION_LIMIT_EXCEEDED: 'OT_CONNECTION_LIMIT_EXCEEDED',
  // The constraints for getting user media could not be satisfied.
  CONSTRAINTS_NOT_SATISFIED: 'OT_CONSTRAINTS_NOT_SATISFIED',
  // Failed to create peer connection.
  CREATE_PEER_CONNECTION_FAILED: 'OT_CREATE_PEER_CONNECTION_FAILED',
  // Action failed due to session disconnection.
  DISCONNECTED: 'OT_DISCONNECTED',
  // Received an unexpected empty response from the server.
  EMPTY_RESPONSE_BODY: 'OT_EMPTY_RESPONSE_BODY',
  // Attempted to call getRtcStatsReport in a browser that doesn't support standard getStats API.
  GET_RTC_STATS_REPORT_NOT_SUPPORTED: 'OT_GET_RTC_STATS_REPORT_NOT_SUPPORTED',
  // The hardware to fulfil the user media request appears to exist but could not be acquired. It
  // might be in use by another application.
  HARDWARE_UNAVAILABLE: 'OT_HARDWARE_UNAVAILABLE',
  // Something went wrong while establishing WebRTC connectivity.
  ICE_WORKFLOW_FAILED: 'OT_ICE_WORKFLOW_FAILED',
  // Received an invalid HTTP status. This may be considered invalid for the endpoint only and not
  // HTTP in general.
  INVALID_HTTP_STATUS: 'OT_INVALID_HTTP_STATUS',
  // One or more parameters was not valid or not provided.
  INVALID_PARAMETER: 'OT_INVALID_PARAMETER',
  // The session id was invalid.
  INVALID_SESSION_ID: 'OT_INVALID_SESSION_ID',
  // The fetching of the stream for the video element has been aborted.
  MEDIA_ERR_ABORTED: 'OT_MEDIA_ERR_ABORTED',
  // A decoding error occurred while trying to play the stream in the video element.
  MEDIA_ERR_DECODE: 'OT_MEDIA_ERR_DECODE',
  // A network error caused the stream to stop being fetched.
  MEDIA_ERR_NETWORK: 'OT_MEDIA_ERR_NETWORK',
  // The stream has been detected to be not suitable for playback.
  MEDIA_ERR_SRC_NOT_SUPPORTED: 'OT_MEDIA_ERR_SRC_NOT_SUPPORTED',
  // The ended event on the video element fired
  MEDIA_ENDED: 'OT_MEDIA_ENDED',
  // No devices were found to provide the media stream.
  NO_DEVICES_FOUND: 'OT_NO_DEVICES_FOUND',
  // Video and audio was disabled. You need to enable at least one.
  NO_VALID_CONSTRAINTS: 'OT_NO_VALID_CONSTRAINTS',
  // Couldn't perform action due to not being connected.
  NOT_CONNECTED: 'OT_NOT_CONNECTED',
  // A resource was not found.
  NOT_FOUND: 'OT_NOT_FOUND',
  // Something in the user media request is not supported.
  NOT_SUPPORTED: 'OT_NOT_SUPPORTED',
  // Couldn't perform an action because the Peer Connection is not connected.
  PEER_CONNECTION_NOT_CONNECTED: 'OT_PEER_CONNECTION_NOT_CONNECTED',
  // An action was not permitted.
  PERMISSION_DENIED: 'OT_PERMISSION_DENIED',
  // The signal could not be sent due to the rate limit.
  RATE_LIMIT_EXCEEDED: 'OT_RATE_LIMIT_EXCEEDED',
  // Error calling OT.reportIssue(). Check the client\'s network connection.
  REPORT_ISSUE_FAILED: 'OT_REPORT_ISSUE_FAILED',
  // Screen-sharing support in this browser requires an extension, but the extension is not
  // installed.
  SCREEN_SHARING_EXTENSION_NOT_INSTALLED: 'OT_SCREEN_SHARING_EXTENSION_NOT_INSTALLED',
  // Screen-sharing support in this browser requires an extension, but one has not been registered.
  SCREEN_SHARING_EXTENSION_NOT_REGISTERED: 'OT_SCREEN_SHARING_EXTENSION_NOT_REGISTERED',
  // Screen sharing is not supported in the browser.
  SCREEN_SHARING_NOT_SUPPORTED: 'OT_SCREEN_SHARING_NOT_SUPPORTED',
  // The WebRTC connection failed during setDescription.
  SET_REMOTE_DESCRIPTION_FAILED: 'OT_SET_REMOTE_DESCRIPTION_FAILED',
  // Setting the ICE configuration failed.
  FAILED_SET_CONFIGURATION: 'OT_FAILED_SET_CONFIGURATION',
  // Rumor.Socket cannot connect when it is already connecting or connected.
  SOCKET_ALREADY_CONNECTED_CONNECTING: 'OT_SOCKET_ALREADY_CONNECTED_CONNECTING',
  // A connection was closed abnormally (that is, with no close frame being sent) when a status code
  // is expected.
  SOCKET_CLOSE_ABNORMAL: 'OT_SOCKET_CLOSE_ABNORMAL',
  // Exception was thrown during Rumor connection, possibly because of a blocked port.
  SOCKET_CLOSE_CONNECT_EXCEPTION: 'OT_SOCKET_CLOSE_CONNECT_EXCEPTION',
  // Connectivity loss was detected as it was too long since the socket received the last PONG
  // message.
  SOCKET_CLOSE_CONNECTIVITY_LOSS: 'OT_SOCKET_CLOSE_CONNECTIVITY_LOSS',
  // Falling back on this error for socket close because a more suitable one was not found.
  SOCKET_CLOSE_FALLBACK_CODE: 'OT_SOCKET_CLOSE_FALLBACK_CODE',
  // An endpoint received data within a message that was not consistent with the type of the message
  // (e.g., non-UTF-8 [RFC3629] data within a text message)
  SOCKET_CLOSE_INCONSISTENT_DATA: 'OT_SOCKET_CLOSE_INCONSISTENT_DATA',
  // No status code was provided even though one was expected.
  SOCKET_CLOSE_NO_STATUS: 'OT_SOCKET_CLOSE_NO_STATUS',
  // An endpoint received a message that violates its policy.  This is a generic status code that
  // can be returned when there is no other more suitable status code (e.g., 1003 or 1009) or if
  // there is a need to hide specific details about the policy.
  SOCKET_CLOSE_POLICY_VIOLATION: 'OT_SOCKET_CLOSE_POLICY_VIOLATION',
  // The endpoint is going away, either because of a server failure or because the browser is
  // navigating away from the page that opened the connection.
  SOCKET_CLOSE_GOING_AWAY: 'OT_SOCKET_CLOSE_GOING_AWAY',
  // A protocol error occurred.
  SOCKET_CLOSE_PROTOCOL_ERROR: 'OT_SOCKET_CLOSE_PROTOCOL_ERROR',
  // Timed out while waiting for the Rumor socket to connect.
  SOCKET_CLOSE_TIMEOUT: 'OT_SOCKET_CLOSE_TIMEOUT',
  // An endpoint received a message that is too big for it to process
  SOCKET_CLOSE_TOO_LARGE: 'OT_SOCKET_CLOSE_TOO_LARGE',
  // An endpoint encountered an unexpected condition that prevented it from fulfilling the request.
  SOCKET_CLOSE_UNEXPECTED_CONDITION: 'OT_SOCKET_CLOSE_UNEXPECTED_CONDITION',
  // An endpoint has indicated that reconnections are not available.
  SOCKET_CLOSE_UNSUPPORTED: 'OT_SOCKET_CLOSE_UNSUPPORTED',
  // Failed to create the stream in the server model.
  STREAM_CREATE_FAILED: 'OT_STREAM_CREATE_FAILED',
  // The stream was destroyed before it could be subscribed to.
  STREAM_DESTROYED: 'OT_STREAM_DESTROYED',
  // The session has exceded the maximum number of simultaneous streams.
  STREAM_LIMIT_EXCEEDED: 'OT_STREAM_LIMIT_EXCEEDED',
  // Couldn't subscribe to the stream because it was not found.
  STREAM_NOT_FOUND: 'OT_STREAM_NOT_FOUND',
  // Couldn't subscribe to stream due to unexpected error from rumor
  UNABLE_TO_SUBSCRIBE: 'OT_UNABLE_TO_SUBSCRIBE',
  // Couldn't connect due to a terms of service violation.
  TERMS_OF_SERVICE_FAILURE: 'OT_TERMS_OF_SERVICE_FAILURE',
  // A timer expired while waiting for an action to occur.
  TIMEOUT: 'OT_TIMEOUT',
  // The operation was cancelled
  CANCEL: 'OT_CANCEL',
  // Generic media abort error
  UNABLE_TO_CAPTURE_MEDIA: 'OT_UNABLE_TO_CAPTURE_MEDIA',
  // Generic/ Unknown screen share error
  UNABLE_TO_CAPTURE_SCREEN: 'OT_UNABLE_TO_CAPTURE_SCREEN',
  // The error code received was unexpected.
  UNEXPECTED_ERROR_CODE: 'OT_UNEXPECTED_ERROR_CODE',
  // Received an unexpected HTTP status.
  UNEXPECTED_HTTP_STATUS: 'OT_UNEXPECTED_HTTP_STATUS',
  // An unexpected server response was received which could not be handled.
  UNEXPECTED_SERVER_RESPONSE: 'OT_UNEXPECTED_SERVER_RESPONSE',
  // An unknown anvil error occurred.
  UNKNOWN_HTTP_ERROR: 'OT_UNKNOWN_HTTP_ERROR',
  UNSUPPORTED_BROWSER: 'OT_UNSUPPORTED_BROWSER',
  // Access to user media was denied.
  USER_MEDIA_ACCESS_DENIED: 'OT_USER_MEDIA_ACCESS_DENIED',
  // There was a cross domain error or the server responded with invalid JSON.
  XDOMAIN_OR_PARSING_ERROR: 'OT_XDOMAIN_OR_PARSING_ERROR',
  API_KEY_DISABLED: 'OT_API_KEY_DISABLED',
  // There was an error when trying to get the list of supported codecs.
  UNABLE_TO_ACCESS_MEDIA_ENGINE: 'OT_UNABLE_TO_ACCESS_MEDIA_ENGINE',
  // The proxyUrl was set after a session or publisher were created.
  SET_PROXY_URL_TIMING_ERROR: 'OT_SET_PROXY_URL_TIMING_ERROR',
  // The proxyUrl has already been set. Setting it again will not have any effect
  PROXY_URL_ALREADY_SET_ERROR: 'OT_PROXY_URL_ALREADY_SET_ERROR',
  // You cannot reset the video source on a publisher that does not currently include a video track.
  SET_VIDEO_SOURCE_FAILURE: 'OT_SET_VIDEO_SOURCE_FAILURE',
  // Invalid video source. Video source must be a valid video input deviceId
  INVALID_VIDEO_SOURCE: 'OT_INVALID_VIDEO_SOURCE',
  // The requested audio device does not have permissions to be used.
  REQUESTED_DEVICE_PERMISSION_DENIED: 'OT_REQUESTED_DEVICE_PERMISSION_DENIED',
  // Invalid output audio device ID. It must be a valid video output deviceId.
  INVALID_AUDIO_OUTPUT_SOURCE: 'OT_INVALID_AUDIO_OUTPUT_SOURCE',
  // Invalid encryption secret. Must be a string and match length requirements.
  INVALID_ENCRYPTION_SECRET: 'OT_INVALID_ENCRYPTION_SECRET'
};
exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(86),
    copyObject = __webpack_require__(44),
    createAssigner = __webpack_require__(207),
    isArrayLike = __webpack_require__(29),
    isPrototype = __webpack_require__(69),
    keys = __webpack_require__(34);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const ExceptionCodes = {
  JS_EXCEPTION: 2000,
  AUTHENTICATION_ERROR: 1004,
  INVALID_SESSION_ID: 1005,
  CONNECT_FAILED: 1006,
  CONNECT_REJECTED: 1007,
  CONNECTION_TIMEOUT: 1008,
  NOT_CONNECTED: 1010,
  INVALID_PARAMETER: 1011,
  P2P_CONNECTION_FAILED: 1013,
  API_RESPONSE_FAILURE: 1014,
  PEER_CONNECTION_NOT_CONNECTED: 1015,
  TERMS_OF_SERVICE_FAILURE: 1026,
  CONNECTION_LIMIT_EXCEEDED: 1027,
  UNABLE_TO_PUBLISH: 1500,
  UNABLE_TO_SUBSCRIBE: 1501,
  UNSUPPORTED_VIDEO_CODEC: 1502,
  UNABLE_TO_FORCE_DISCONNECT: 1520,
  UNABLE_TO_FORCE_UNPUBLISH: 1530,
  UNABLE_TO_FORCE_MUTE: 1540,
  PUBLISHER_ICE_WORKFLOW_FAILED: 1553,
  SUBSCRIBER_ICE_WORKFLOW_FAILED: 1554,
  STREAM_LIMIT_EXCEEDED: 1605,
  UNEXPECTED_SERVER_RESPONSE: 2001,
  REPORT_ISSUE_ERROR: 2011,
  SET_PROXY_URL_TIMING_ERROR: 2021,
  PROXY_URL_ALREADY_SET_ERROR: 2022,
  GET_RTC_STATS_REPORT_NOT_SUPPORTED: 2031,
  ANVIL_BADLY_FORMED_RESPONSE: 3001,
  ANVIL_INVALID_HTTP_STATUS: 3002,
  ANVIL_XDOMAIN_OR_PARSING_ERROR: 3003,
  ANVIL_UNKNOWN_HTTP_ERROR: 3004,
  ANVIL_UNEXPECTED_ERROR_CODE: 3005,
  ANVIL_EMPTY_RESPONSE_BODY: 3006,
  ANVIL_CONNECT_FAILED: 3007,
  UNABLE_TO_ACCESS_MEDIA_ENGINE: 5001
};
var _default = ExceptionCodes;
exports.default = _default;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(222);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a empty Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a empty Object, otherwise false
 */
function isEmptyObject(val) {
  return val && Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  var product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter, propFilter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 * @param {*} [thing]
 * @returns {?Array}
 */
function toArray(thing) {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  var i = thing.length;
  if (!isNumber(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

function forEachEntry(obj, fn) {
  var generator = obj && obj[Symbol.iterator];

  var iterator = generator.call(obj);

  var result;

  while ((result = iterator.next()) && !result.done) {
    var pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

function matchAll(regExp, str) {
  var matches;
  var arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

var isHTMLForm = kindOfTest('HTMLFormElement');

var hasOwnProperty = (function resolver(_hasOwnProperty) {
  return function(obj, prop) {
    return _hasOwnProperty.call(obj, prop);
  };
})(Object.prototype.hasOwnProperty);

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isEmptyObject: isEmptyObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList,
  forEachEntry: forEachEntry,
  matchAll: matchAll,
  isHTMLForm: isHTMLForm,
  hasOwnProperty: hasOwnProperty
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = otErrorFactory;
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _Errors = _interopRequireDefault(__webpack_require__(8));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require */

function otErrorFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const Errors = deps.Errors || _Errors.default;
  const OTErrorClass = deps.OTErrorClass || _ot_error_class.default;
  const names = Object.keys(Errors).map(shortName => Errors[shortName]);
  return function otError(name, plainError, code) {
    if (names.indexOf(name) === -1) {
      return new Error(`Attempt to use invalid error name (${name}). Original message: ${plainError.message}`);
    }
    if (!(plainError instanceof Error || /^\[object .*Error\]$/.test(Object.prototype.toString.call(plainError)))) {
      return new Error(`Did not pass Error as second argument: ${plainError}`);
    }

    // OTErrorClass is the deprecated OT.Error class from the docs.
    const error = new OTErrorClass(undefined, plainError.message);
    error.name = name;
    if (!plainError.stack) {
      try {
        throw plainError;
      } catch (e) {
        // IE populates the error's .stack when it is thrown, nothing to do here
      }
    }
    error.stack = plainError.stack;
    if (code) {
      error.code = code;
    }
    return error;
  };
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(189);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(576);
var v4 = __webpack_require__(577);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = EventsFactory;
var _createClass2 = _interopRequireDefault(__webpack_require__(25));
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _log = _interopRequireDefault(__webpack_require__(1));
var _Event4 = _interopRequireDefault(__webpack_require__(148));
var _eventNames = _interopRequireDefault(__webpack_require__(30));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require, max-len */

function EventsFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const logging = deps.logging || (0, _log.default)('Events');
  const Events = {};

  /**
   * The Event object defines the basic Vonage Video API event object that is passed to
   * event listeners. Other Vonage Video API event classes implement the properties and methods of
   * the Event object.</p>
   *
   * <p>For example, the Stream object dispatches a <code>streamPropertyChanged</code> event when
   * the stream's properties are updated. You add a callback for an event using the
   * <code>on()</code> method of the Stream object:</p>
   *
   * <pre>
   * stream.on("streamPropertyChanged", function (event) {
   *     alert("Properties changed for stream " + event.target.streamId);
   * });</pre>
   *
   * @class Event
   * @property {Boolean} cancelable Whether the event has a default behavior that is cancelable
   * (<code>true</code>) or not (<code>false</code>). You can cancel the default behavior by
   * calling the <code>preventDefault()</code> method of the Event object in the callback
   * function. (See <a href="#preventDefault">preventDefault()</a>.)
   *
   * @property {Object} target The object that dispatched the event.
   *
   * @property {String} type  The type of event.
   */

  /**
  * Prevents the default behavior associated with the event from taking place.
  *
  * <p>To see whether an event has a default behavior, check the <code>cancelable</code> property
  * of the event object. </p>
  *
  * <p>Call the <code>preventDefault()</code> method in the callback function for the event.</p>
  *
  * <p>The following events have default behaviors:</p>
  *
  * <ul>
  *
  *   <li><code>sessionDisconnect</code> &#151; See
  *   <a href="SessionDisconnectEvent.html#preventDefault">
  *   SessionDisconnectEvent.preventDefault()</a>.</li>
  *
  *   <li><code>streamDestroyed</code> &#151; See <a href="StreamEvent.html#preventDefault">
  *   StreamEvent.preventDefault()</a>.</li>
  *
  *   <li><code>accessDialogOpened</code> &#151; See the
  *   <a href="Publisher.html#event:accessDialogOpened">accessDialogOpened event</a>.</li>
  *
  *   <li><code>accessDenied</code> &#151; See the <a href="Publisher.html#event:accessDenied">
  *   accessDenied event</a>.</li>
  *
  * </ul>
  *
  * @method #preventDefault
  * @memberof Event
  */
  /**
  * Whether the default event behavior has been prevented via a call to
  * <code>preventDefault()</code> (<code>true</code>) or not (<code>false</code>).
  * See <a href="#preventDefault">preventDefault()</a>.
  * @method #isDefaultPrevented
  * @return {Boolean}
  * @memberof Event
  */

  /**
  * The {@link OT} class dispatches <code>exception</code> events when the Vonage Video API encounters
  * an exception (error). The ExceptionEvent object defines the properties of the event
  * object that is dispatched.
  *
  * <p>Note that you set up a callback for the <code>exception</code> event by calling the
  * <code>OT.on()</code> method.</p>
  *
  * @class ExceptionEvent
  * @property {Number} code The error code. The following is a list of error codes:</p>
  *
  * <table class="docs_table">
  *  <tbody><tr>
  *   <td>
  *   <b>code</b>
  *
  *   </td>
  *   <td>
  *   <b>title</b>
  *   </td>
  *  </tr>
  *
  *  <tr>
  *   <td>
  *   1004
  *
  *   </td>
  *   <td>
  *   Authentication error
  *   </td>
  *  </tr>
  *
  *  <tr>
  *   <td>
  *   1005
  *
  *   </td>
  *   <td>
  *   Invalid Session ID
  *   </td>
  *  </tr>
  *  <tr>
  *   <td>
  *   1006
  *
  *   </td>
  *   <td>
  *   Connect Failed
  *   </td>
  *  </tr>
  *  <tr>
  *   <td>
  *   1007
  *
  *   </td>
  *   <td>
  *   Connect Rejected
  *   </td>
  *  </tr>
  *  <tr>
  *   <td>
  *   1008
  *
  *   </td>
  *   <td>
  *   Connect Time-out
  *   </td>
  *  </tr>
  *  <tr>
  *   <td>
  *   1009
  *
  *   </td>
  *   <td>
  *   Security Error
  *   </td>
  *  </tr>
  *   <tr>
  *    <td>
  *    1010
  *
  *    </td>
  *    <td>
  *    Not Connected
  *    </td>
  *   </tr>
  *   <tr>
  *    <td>
  *    1011
  *
  *    </td>
  *    <td>
  *    Invalid Parameter
  *    </td>
  *   </tr>
  *   <tr>
  *    <td>
  *    1013
  *    </td>
  *    <td>
  *    Connection Failed
  *    </td>
  *   </tr>
  *   <tr>
  *    <td>
  *    1014
  *    </td>
  *    <td>
  *    API Response Failure
  *    </td>
  *   </tr>
  *   <tr>
  *    <td>
  *    1026
  *    </td>
  *    <td>
  *    Terms of Service Violation: Export Compliance
  *    </td>
  *   </tr>
  *  <tr>
  *    <td>
  *    1500
  *    </td>
  *    <td>
  *    Unable to Publish
  *    </td>
  *   </tr>
  *
  *  <tr>
  *    <td>
  *    1520
  *    </td>
  *    <td>
  *    Unable to Force Disconnect
  *    </td>
  *   </tr>
  *
  *  <tr>
  *    <td>
  *    1530
  *    </td>
  *    <td>
  *    Unable to Force Unpublish
  *    </td>
  *   </tr>
  *  <tr>
  *    <td>
  *    1535
  *    </td>
  *    <td>
  *    Force Unpublish on Invalid Stream
  *    </td>
  *   </tr>
  *
  *  <tr>
  *    <td>
  *    2000
  *
  *    </td>
  *    <td>
  *    Internal Error
  *    </td>
  *  </tr>
  *
  *  <tr>
  *    <td>
  *    2010
  *
  *    </td>
  *    <td>
  *    Report Issue Failure
  *    </td>
  *  </tr>
  *
  *
  *  </tbody></table>
  *
  *  <p>Check the <code>message</code> property for more details about the error.</p>
  *
  * @property {String} message The error message.
  *
  * @property {Object} target The object that the event pertains to. For an
  * <code>exception</code> event, this will be an object other than the OT object
  * (such as a Session object or a Publisher object).
  *
  * @property {String} title The error title.
  * @augments Event
  */
  Events.ExceptionEvent = function ExceptionEvent(type, message, title, code, component, target, error) {
    return new _Event4.default(type, false, {
      error,
      message,
      title,
      code,
      component,
      target
    });
  };
  Events.IssueReportedEvent = function IssueReportedEvent(type, issueId) {
    return new _Event4.default(type, false, {
      issueId
    });
  };

  // Triggered when the JS dynamic config and the DOM have loaded.
  Events.EnvLoadedEvent = function EnvLoadedEvent(type) {
    return new _Event4.default(type, false);
  };

  /**
   * Defines <code>connectionCreated</code> and <code>connectionDestroyed</code> events dispatched
   * by the {@link Session} object.
   * <p>
   * The Session object dispatches a <code>connectionCreated</code> event when a client (including
   * your own) connects to a Session. It also dispatches a <code>connectionCreated</code> event for
   * every client in the session when you first connect. (when your local client connects, the
   * Session object also dispatches a <code>sessionConnected</code> event, defined by the
   * {@link SessionConnectEvent} class.)
   * <p>
   * While you are connected to the session, the Session object dispatches a
   * <code>connectionDestroyed</code> event when another client disconnects from the Session.
   * (When you disconnect, the Session object also dispatches a <code>sessionDisconnected</code>
   * event, defined by the {@link SessionDisconnectEvent} class.)
   *
   * <h5><a name="example"></a>Example</h5>
   *
   * <p>The following code keeps a running total of the number of connections to a session
   * by monitoring the <code>connections</code> property of the <code>sessionConnect</code>,
   * <code>connectionCreated</code> and <code>connectionDestroyed</code> events:</p>
   *
   * <pre>var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
   * var sessionID = ""; // Replace with your own session ID.
   *                     // See https://tokbox.com/developer/guides/create-session/.
   * var token = ""; // Replace with a generated token that has been assigned the moderator role.
   *                 // See https://tokbox.com/developer/guides/create-token/.
   * var connectionCount = 0;
   *
   * var session = OT.initSession(apiKey, sessionID);
   * session.on("connectionCreated", function(event) {
   *    connectionCount++;
   *    displayConnectionCount();
   * });
   * session.on("connectionDestroyed", function(event) {
   *    connectionCount--;
   *    displayConnectionCount();
   * });
   * session.connect(token);
   *
   * function displayConnectionCount() {
   *     document.getElementById("connectionCountField").value = connectionCount.toString();
   * }</pre>
   *
   * <p>This example assumes that there is an input text field in the HTML DOM
   * with the <code>id</code> set to <code>"connectionCountField"</code>:</p>
   *
   * <pre>&lt;input type="text" id="connectionCountField" value="0"&gt;&lt;/input&gt;</pre>
   *
   *
   * @property {Connection} connection A Connection object for the connection that was
   * created or deleted.
   *
   * @property {Array} connections Deprecated. Use the <code>connection</code> property. A
   * <code>connectionCreated</code> or <code>connectionDestroyed</code> event is dispatched
   * for each connection created and destroyed in the session.
   *
   * @property {String} reason For a <code>connectionDestroyed</code> event,
   *  a description of why the connection ended. This property can have the following values:
   * </p>
   * <ul>
   *  <li><code>"clientDisconnected"</code> &#151; A client disconnected from the session by calling
   *     the <code>disconnect()</code> method of the Session object or by closing the browser.
   *     (See <a href="Session.html#disconnect">Session.disconnect()</a>.)</li>
   *
   *  <li><code>"forceDisconnected"</code> &#151; A moderator has disconnected the publisher
   *      from the session, by calling the <code>forceDisconnect()</code> method of the Session
   *      object. (See <a href="Session.html#forceDisconnect">Session.forceDisconnect()</a>.)</li>
   *
   *  <li><code>"mediaIdle"</code> &#151; The client was disconnected from a session
   * because it did not publish or subscribe to streams within 4 hours of
   * connecting</li>
   *
   *  <li><code>"networkDisconnected"</code> &#151; The network connection terminated abruptly
   *      (for example, the client lost their internet connection) and was detected by the
   *      Vonage Video API platform.</li>
   *
   *  <li><code>"serverRotation"</code> &#151; The client was disconnected from
   * the session because of
   * <a href="https://tokbox.com/developer/guides/server-rotation/">Video API server rotation</a>.</li>
   * </ul>
   *
   * <p>Depending on the context, this description may allow the developer to refine
   * the course of action they take in response to an event.</p>
   *
   * <p>For a <code>connectionCreated</code> event, this string is undefined.</p>
   *
   * @class ConnectionEvent
   * @augments Event
   */
  let connectionEventPluralDeprecationWarningShown = false;
  Events.ConnectionEvent = /*#__PURE__*/function (_Event) {
    (0, _inheritsLoose2.default)(ConnectionEvent, _Event);
    function ConnectionEvent(type, connection, reason) {
      return _Event.call(this, type, false, {
        connection,
        reason
      }) || this;
    }
    (0, _createClass2.default)(ConnectionEvent, [{
      key: "connections",
      get: function get() {
        if (!connectionEventPluralDeprecationWarningShown) {
          logging.warn('OT.ConnectionEvent connections property is deprecated, ' + 'use connection instead.');
          connectionEventPluralDeprecationWarningShown = true;
        }
        return [this.connection];
      }
    }]);
    return ConnectionEvent;
  }(_Event4.default);

  /**
   * StreamEvent is an event that can have the type "streamCreated" or "streamDestroyed".
   * These events are dispatched by the Session object when another client starts or
   * stops publishing a stream to a {@link Session}. For a local client's stream, the
   * Publisher object dispatches the event.
   *
   * <h4><a name="example_streamCreated"></a>Example &#151; streamCreated event dispatched
   * by the Session object</h4>
   *  <p>The following code connects to a session and sets up an event listener for when
   *    a stream published by another client is created:</p>
   *
   * <pre>
   * session.on("streamCreated", function(event) {
   *   subscriber = session.subscribe(event.stream, targetElement);
   * }).connect(token);
   * </pre>
   *
   *  <h4><a name="example_streamDestroyed"></a>Example &#151; streamDestroyed event dispatched
   * by the Session object</h4>
   *
   *    <p>The following code connects to a session and sets up an event listener for when
   *       other clients' streams end:</p>
   *
   * <pre>
   * session.on("streamDestroyed", function(event) {
   *     console.log("Stream " + event.stream.name + " ended. " + event.reason);
   * }).connect(token);
   * </pre>
   *
   * <h4><a name="example_streamCreated_publisher"></a>Example &#151; streamCreated event dispatched
   * by a Publisher object</h4>
   *  <p>The following code publishes a stream and adds an event listener for when the streaming
   * starts</p>
   *
   * <pre>
   * var publisher = session.publish(targetElement)
   *   .on("streamCreated", function(event) {
   *     console.log("Publisher started streaming.");
   *   });
   * </pre>
   *
   *  <h4><a name="example_streamDestroyed_publisher"></a>Example &#151; streamDestroyed event
   * dispatched by a Publisher object</h4>
   *
   *  <p>The following code publishes a stream, and leaves the Publisher in the HTML DOM
   * when the streaming stops:</p>
   *
   * <pre>
   * var publisher = session.publish(targetElement)
   *   .on("streamDestroyed", function(event) {
   *     event.preventDefault();
   *     console.log("Publisher stopped streaming.");
   *   });
   * </pre>
   *
   * @class StreamEvent
   *
   * @property {Boolean} cancelable   Whether the event has a default behavior that is cancelable
   *  (<code>true</code>) or not (<code>false</code>). You can cancel the default behavior by
   * calling the <code>preventDefault()</code> method of the StreamEvent object in the event
   * listener function. The <code>streamDestroyed</code> event is cancelable.
   * (See <a href="#preventDefault">preventDefault()</a>.)
   *
   * @property {String} reason For a <code>streamDestroyed</code> event,
   *  a description of why the stream was destroyed. This property can have one of the following
   *  values:
   * </p>
   * <ul>
   *  <li><code>"clientDisconnected"</code> &#151; A client disconnected from the session by calling
   *     the <code>disconnect()</code> method of the Session object or by closing the browser.
   *     (See <a href="Session.html#disconnect">Session.disconnect()</a>.)</li>
   *
   *  <li><code>"forceDisconnected"</code> &#151; A moderator has disconnected the publisher of the
   *    stream from the session, by calling the <code>forceDisconnect()</code> method of the Session
   *     object. (See <a href="Session.html#forceDisconnect">Session.forceDisconnect()</a>.)</li>
   *
   *  <li><code>"forceUnpublished"</code> &#151; A moderator has forced the publisher of the stream
   *    to stop publishing the stream, by calling the <code>forceUnpublish()</code> method of the
   *    Session object.
   *    (See <a href="Session.html#forceUnpublish">Session.forceUnpublish()</a>.)</li>
   *
   *  <li><code>"mediaStopped"</code> &#151; The user publishing the stream has stopped sharing
   *    media. For example, the user closed the window that is a source for a screen-sharing
   *    stream. Or the user disconnected a microphone that was the audio source for an audio-only
   *    stream. Or the video and audio sources are MediaStreamTrack elements and the sources of
   *    the media are stopped or destroyed.</li>
   *
   *  <li><code>"networkDisconnected"</code> &#151; The network connection terminated abruptly (for
   *      example, the client lost their internet connection) and was detected by the Vonage Video API
   *      platform.</li>
   *
   *  <li><code>"reset"</code> &#151; A Publisher’s stream was destroyed in response
   *    to a call to its <code>Publisher.destroy()</code> method.</li>
   *
   *  <li><code>"serverRotation"</code> &#151; The Publisher’s stream was destroyed because
   * the client was disconnected from the session because of
   * <a href="https://tokbox.com/developer/guides/server-rotation/">Video API server rotation</a>.</li>
   * </ul>
   *
   * <p>Depending on the context, this description may allow the developer to refine
   * the course of action they take in response to an event.</p>
   *
   * <p>For a <code>streamCreated</code> event, this string is undefined.</p>
   *
   * @property {Stream} stream A Stream object corresponding to the stream that was added (in the
   * case of a <code>streamCreated</code> event) or deleted (in the case of a
   * <code>streamDestroyed</code> event).
   *
   * @property {Array} streams Deprecated. Use the <code>stream</code> property. A
   * <code>streamCreated</code> or <code>streamDestroyed</code> event is dispatched for
   * each stream added or destroyed.
   *
   * @augments Event
   */

  let streamEventPluralDeprecationWarningShown = false;
  Events.StreamEvent = /*#__PURE__*/function (_Event2) {
    (0, _inheritsLoose2.default)(StreamEvent, _Event2);
    function StreamEvent(type, stream, reason, cancelable) {
      return _Event2.call(this, type, cancelable, {
        stream,
        reason
      }) || this;
    }
    (0, _createClass2.default)(StreamEvent, [{
      key: "streams",
      get: function get() {
        if (!streamEventPluralDeprecationWarningShown) {
          logging.warn('OT.StreamEvent streams property is deprecated, use stream instead.');
          streamEventPluralDeprecationWarningShown = true;
        }
        return [this.stream];
      }
    }]);
    return StreamEvent;
  }(_Event4.default);

  /**
  * Prevents the default behavior associated with the event from taking place.
  *
  * <p>For the <code>streamDestroyed</code> event dispatched by the Session object,
  * the default behavior is that all Subscriber objects that are subscribed to the stream are
  * unsubscribed and removed from the HTML DOM. Each Subscriber object dispatches a
  * <code>destroyed</code> event when the element is removed from the HTML DOM. If you call the
  * <code>preventDefault()</code> method in the event listener for the <code>streamDestroyed</code>
  * event, the default behavior is prevented and you can clean up Subscriber objects using your
  * own code. See
  * <a href="Session.html#getSubscribersForStream">Session.getSubscribersForStream()</a>.</p>
  * <p>
  * For the <code>streamDestroyed</code> event dispatched by a Publisher object, the default
  * behavior is that the Publisher object is removed from the HTML DOM. The Publisher object
  * dispatches a <code>destroyed</code> event when the element is removed from the HTML DOM.
  * If you call the <code>preventDefault()</code> method in the event listener for the
  * <code>streamDestroyed</code> event, the default behavior is prevented, and you can
  * retain the Publisher for reuse or clean it up using your own code.
  *</p>
  * <p>To see whether an event has a default behavior, check the <code>cancelable</code> property of
  * the event object. </p>
  *
  * <p>
  *   Call the <code>preventDefault()</code> method in the event listener function for the event.
  * </p>
  *
  * @method #preventDefault
  * @memberof StreamEvent
  */

  /**
   * The Session object dispatches SessionConnectEvent object when a session has successfully
   * connected in response to a call to the <code>connect()</code> method of the Session object.
   * <p>
   * In version 2.2, the completionHandler of the <code>Session.connect()</code> method
   * indicates success or failure in connecting to the session.
   *
   * @class SessionConnectEvent
   * @property {Array} connections Deprecated in version 2.2 (and set to an empty array). In
   * version 2.2, listen for the <code>connectionCreated</code> event dispatched by the Session
   * object. In version 2.2, the Session object dispatches a <code>connectionCreated</code> event
   * for each connection (including your own). This includes connections present when you first
   * connect to the session.
   *
   * @property {Array} streams Deprecated in version 2.2 (and set to an empty array). In version
   * 2.2, listen for the <code>streamCreated</code> event dispatched by the Session object. In
   * version 2.2, the Session object dispatches a <code>streamCreated</code> event for each stream
   * other than those published by your client. This includes streams
   * present when you first connect to the session.
   *
   * @see <a href="Session.html#connect">Session.connect()</a></p>
   * @augments Event
   */

  let sessionConnectedConnectionsDeprecationWarningShown = false;
  let sessionConnectedStreamsDeprecationWarningShown = false;
  let sessionConnectedArchivesDeprecationWarningShown = false;
  Events.SessionConnectEvent = /*#__PURE__*/function (_Event3) {
    (0, _inheritsLoose2.default)(SessionConnectEvent, _Event3);
    function SessionConnectEvent(type) {
      return _Event3.call(this, type, false) || this;
    }
    // eslint-disable-next-line class-methods-use-this
    (0, _createClass2.default)(SessionConnectEvent, [{
      key: "connections",
      get: function get() {
        if (!sessionConnectedConnectionsDeprecationWarningShown) {
          logging.warn('OT.SessionConnectedEvent no longer includes connections. Listen ' + 'for connectionCreated events instead.');
          sessionConnectedConnectionsDeprecationWarningShown = true;
        }
        return [];
      }
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "streams",
      get: function get() {
        if (!sessionConnectedStreamsDeprecationWarningShown) {
          logging.warn('OT.SessionConnectedEvent no longer includes streams. Listen for ' + 'streamCreated events instead.');
          sessionConnectedStreamsDeprecationWarningShown = true;
        }
        return [];
      }
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "archives",
      get: function get() {
        if (!sessionConnectedArchivesDeprecationWarningShown) {
          logging.warn('OT.SessionConnectedEvent no longer includes archives. Listen for ' + 'archiveStarted events instead.');
          sessionConnectedArchivesDeprecationWarningShown = true;
        }
        return [];
      }
    }]);
    return SessionConnectEvent;
  }(_Event4.default);
  Events.SessionReconnectingEvent = function SessionReconnectedEvent() {
    return new _Event4.default(_eventNames.default.SESSION_RECONNECTING, false);
  };
  Events.SessionReconnectedEvent = function SessionReconnectedEvent() {
    return new _Event4.default(_eventNames.default.SESSION_RECONNECTED);
  };

  /**
   * The Session object dispatches SessionDisconnectEvent object when a session has disconnected.
   * This event may be dispatched asynchronously in response to a successful call to the
   * <code>disconnect()</code> method of the session object.
   *
   *  <h4>
   *    <a href="example"></a>Example
   *  </h4>
   *  <p>
   *    The following code initializes a session and sets up an event listener for when a session is
   * disconnected.
   *  </p>
   * <pre>var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
   *  var sessionID = ""; // Replace with your own session ID.
   *                      // See https://tokbox.com/developer/guides/create-session/
   *  var token = ""; // Replace with a generated token that has been assigned the moderator role.
   *                  // See https://tokbox.com/developer/guides/create-token/
   *
   *  var session = OT.initSession(apiKey, sessionID);
   *  session.on("sessionDisconnected", function(event) {
   *      alert("The session disconnected. " + event.reason);
   *  });
   *  session.connect(token);
   *  </pre>
   *
   * @property {String} reason A description of why the session disconnected.
   *   This property can have the following values:
   *  </p>
   *  <ul>
   *    <li>
   *      <code>"clientDisconnected"</code> &mdash; A client disconnected from the
   *      session by calling the <code>disconnect()</code> method of the Session
   *      object or by closing the browser. ( See <a href=
   *      "Session.html#disconnect">Session.disconnect()</a>.)
   *    </li>
   *
   *    <li>
   *      <code>"forceDisconnected"</code> &mdash; A moderator has disconnected you from
   *      the session by calling the <code>forceDisconnect()</code> method of the
   *      Session object. (See <a href=
   *      "Session.html#forceDisconnect">Session.forceDisconnect()</a>.)
   *    </li>
   *
   *    <li><code>"mediaIdle"</code> &#151; The client was disconnected from
   *      the session because it did not publish or subscribe to streams within
   *      4 hours of connecting.</li>
   *
   *    <li><code>"networkDisconnected"</code> &mdash; The network connection terminated
   *    abruptly (for example, the client lost their internet connection) and was detected by
   *    the Vonage Video API platform.
   *    <p>
   *    Prior to dispatching a
   *    <code>sessionDisconnected</code> event for this reason, the Session object dispatches a
   *    <code>reconnecting</code> event, and the client attempts to reconnect to the Vonage Video API session.
   *    If the reconnection fails, the Session object dispatches a <code>sessionDisconnected</code>
   *    event with the <code>reason</code> property set to <code>"networkDisconnected"</code>.
   *    </li>
   *    <li><code>"serverRotation"</code> &#151; The client was disconnected from the session because of
   * <a href="https://tokbox.com/developer/guides/server-rotation/">Video API server rotation</a>.</li>
   *  </ul>
   *  <ul>
   *
   * @class SessionDisconnectEvent
   * @augments Event
   */
  Events.SessionDisconnectEvent = function SessionDisconnectEvent(type, reason, cancelable) {
    return new _Event4.default(type, cancelable, {
      reason
    });
  };

  /**
  * Prevents the default behavior associated with the event from taking place.
  *
  * <p>
  *   For the <code>sessionDisconnectEvent</code>, the default behavior is that all
  *   Subscriber objects are unsubscribed and removed from the HTML DOM. Each
  *   Subscriber object dispatches a <code>destroyed</code> event when the element
  *   is removed from the HTML DOM. If you call the <code>preventDefault()</code>
  *   method in the event listener for the <code>sessionDisconnect</code> event,
  *   the default behavior is prevented, and you can, optionally, clean up
  *   Subscriber objects using your own code).
  * </p>
  * <p>
  *   To see whether an event has a default behavior, check the
  *   <code>cancelable</code> property of the event object.
  * </p>
  * <p>
  *   Call the <code>preventDefault()</code> method in the event listener function
  *   for the event.
  * </p>
  *
  * @method #preventDefault
  * @memberof SessionDisconnectEvent
  */

  /**
   * The Session object dispatches a <code>streamPropertyChanged</code> event in the
   * following circumstances:
   *
   * <ul>
   *   <li> A stream has started or stopped publishing audio or video (see
   *     <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a> and
   *     <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a>).
   *     This change results from a call to the <code>publishAudio()</code> or
   *     <code>publishVideo()</code> methods of the Publish object. Note that a
   *     subscriber's video can be disabled or enabled for reasons other than the
   *     publisher disabling or enabling it. A Subscriber object dispatches
   *     <code>videoDisabled</code> and <code>videoEnabled</code> events in all
   *     conditions that cause the subscriber's stream to be disabled or enabled.
   *   </li>
   *   <li> The <code>videoDimensions</code> property of the Stream object has
   *     changed (see <a href="Stream.html#properties">Stream.videoDimensions</a>).
   *   </li>
   *   <li> The <code>videoType</code> property of the Stream object has changed.
   *     This can happen in a stream published by a mobile device. (See
   *     <a href="Stream.html#properties">Stream.videoType</a>.)
   *   </li>
   * </ul>
   *
   * @class StreamPropertyChangedEvent
   * @property {String} changedProperty The property of the stream that changed. This value
   * is either <code>"hasAudio"</code>, <code>"hasVideo"</code>, or <code>"videoDimensions"</code>.
   * @property {Object} newValue The new value of the property (after the change).
   * @property {Object} oldValue The old value of the property (before the change).
   * @property {Stream} stream The Stream object for which a property has changed.
   *
   * @see <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a></p>
   * @see <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a></p>
   * @see <a href="Stream.html#properties">Stream.videoDimensions</a></p>
   * @augments Event
   */
  Events.StreamPropertyChangedEvent = function StreamPropertyChangedEvent(type, stream, changedProperty, oldValue, newValue) {
    return new _Event4.default(type, false, {
      stream,
      changedProperty,
      oldValue,
      newValue
    });
  };

  /**
   * Dispatched when the video dimensions of the video change for a screen-sharing
   * video stream (when the user resizes the window being captured).
   *
   * @class VideoDimensionsChangedEvent
   * @property {Object} newValue The new video dimensions (after the change). This object has two
   * properties: <code>height</code> (the height, in pixels) and <code>width</code> (the width,
   * in pixels).
   * @property {Object} oldValue The old video dimensions (before the change). This object has two
   * properties: <code>height</code> (the old height, in pixels) and <code>width</code> (the old
   * width, in pixels).
   *
   * @see <a href="Publisher.html#event:videoDimensionsChanged">Publisher videoDimensionsChanged
   *   event</a>
   * @see <a href="Subscriber.html#event:videoDimensionsChanged">Subscriber videoDimensionsChanged
   *   event</a>
   * @augments Event
   */
  Events.VideoDimensionsChangedEvent = function VideoDimensionsChangedEvent(target, oldValue, newValue) {
    return new _Event4.default('videoDimensionsChanged', false, {
      target,
      oldValue,
      newValue
    });
  };

  /**
   * Defines event objects for the <code>archiveStarted</code> and <code>archiveStopped</code>
   * events. The Session object dispatches these events when an archive recording of the session
   * starts and stops.
   *
   * @property {String} id The archive ID.
   * @property {String} name The name of the archive. You can assign an archive a name when you
   * create it, using the <a href="https://tokbox.com/developer/rest">Vonage Video API REST API</a> or one
   * of the <a href="https://tokbox.com/developer/sdks/server">Vonage Video API server SDKs</a>.
   *
   * @class ArchiveEvent
   * @augments Event
   */
  Events.ArchiveEvent = function ArchiveEvent(type, archive) {
    return new _Event4.default(type, false, {
      id: archive.id,
      name: archive.name,
      status: archive.status,
      archive
    });
  };
  Events.ArchiveUpdatedEvent = function ArchiveUpdatedEvent(stream, key, oldValue, newValue) {
    return new _Event4.default('updated', false, {
      target: stream,
      changedProperty: key,
      oldValue,
      newValue
    });
  };

  /**
   * The Session object dispatches a signal event when the client receives a signal from the
   * session.
   *
   * @class SignalEvent
   * @property {String} type The type assigned to the signal (if there is one). Use the type to
   * filter signals received (by adding an event handler for signal:type1 or signal:type2, etc.)
   * @property {String} data The data string sent with the signal (if there is one).
   * @property {Connection} from The Connection corresponding to the client that sent the
   * signal.
   *
   * @see <a href="Session.html#signal">Session.signal()</a></p>
   * @see <a href="Session.html#events">Session events (signal and signal:type)</a></p>
   * @augments Event
   */
  Events.SignalEvent = function SignalEvent(type, data, from) {
    return new _Event4.default(type ? `signal:${type}` : _eventNames.default.SIGNAL, false, {
      data,
      from
    });
  };

  /**
   * The Session object dispatches a <code>cpuPerformanceChanged</code> event
   * when the CPU performance state changes.
   * The event is only dispatched on Chromium browsers (Chrome 125+, Edge 125+, and Opera 111+).
   * Events are not dispatched after disconnecting from a session, but they resume after reconnecting.
   *
   * @property {String} cpuPerformanceState The new CPU performance state. The CPU performance state can
   * be one the following: "nominal", "fair", "serious", or "critical".
   * (See <a href="https://w3c.github.io/compute-pressure/#pressure-states">this W3C specification</a>.)
   *
   * @see <a href="Session.html#event:cpuPerformanceChanged">Session cpuPerformanceChanged event</a>
   * @class CpuPerformanceChangedEvent
   * @augments Event
   */
  Events.CpuPerformanceChangedEvent = function CpuPerformanceChangedEvent(cpuPerformanceState) {
    return new _Event4.default('cpuPerformanceChanged', false, {
      cpuPerformanceState
    });
  };

  /**
   * The Subscriber object dispatches a <code>qualityScoreChanged</code>
   * event when either the audio or video quality score changes for the subscriber.
   * The scores are a heuristic value representing the expected subscriber experience.
   * The values are integers ranging from 1 to 5, with the values corresponding to
   * bad, poor, fair, good, and excellent.
   *
   * @class QualityScoreChangedEvent
   * @augments Event
   * @see <a href="Subscriber.html#event:qualityScoreChanged">Subscriber qualityScoreChanged event</a>
   *
   * @property {Object} qualityScore The current quality score for the subscriber.
   * The event contains two properties: <code>audioQualityScore</code>
   * and <code>videoQualityScore</code>. These properties are undefined if there
   * is either no audio or no video.
   *
   */
  Events.QualityScoreChangedEvent = function qualityScoreChanged(qualityScore) {
    return new _Event4.default('qualityScoreChanged', false, {
      qualityScore
    });
  };

  /**
   * Defines an event object for the <code>captionReceived</code> event dispatched by the
   * Subscriber object. The Subscriber object dispatches a <code>captionReceived</code>
   * event when the subscriber receives a caption from the transcription service.
   *
   * @property {String} caption The transcribed text.
   * @property {String} streamId The stream ID.
   * @property {Boolean} isFinal Whether a caption is finished being transcribed. This value is only relevant when using partial captions.
   *
   * @see <a href="Subscriber.html#event:captionReceived">Subscriber captionReceived
   *   event</a>
   * @see <a href="https://tokbox.com/developer/guides/live-captions/">Live Captioning</a>
   * @class CaptionReceivedEvent
   * @augments Event
   */
  Events.CaptionReceivedEvent = function CaptionReceivedEvent(caption, streamId, isFinal) {
    return new _Event4.default('caption', false, {
      caption,
      streamId,
      isFinal
    });
  };
  Events.PublisherCaptionsEnabled = function PublisherCaptionsEnabled(captionsEnabled) {
    return new _Event4.default('publisherCaptionsEnabled', false, {
      captionsEnabled
    });
  };

  /**
   * Defines an event object for the <code>mediaStreamAvailable</code> event dispatched by both
   * the Publisher and Subscriber objects. The Publisher and Subscriber objects both dispatch a <code>mediaStreamAvailable</code>
   * event when the MediaStream is available to be used in custom video elements. The Publisher and Subscriber objects should still be used to
   * control all other aspects of the video API such as muting, disconnecting, and more.
   *
   * <p>Note that the audio will play through both the custom element and the Publisher or Subscriber widget.
   * The custom elements should be muted to avoid echo.</p>
   *
   * @property {MediaStream} mediaStream The MediaStream object.
   * @see <a href="Publisher.html#event:mediaStreamAvailable">Publisher mediaStreamAvailable
   *   event</a>
   * @see <a href="Subscriber.html#event:mediaStreamAvailable">Subscriber mediaStreamAvailable
   *   event</a>
   * @class MediaStreamAvailableEvent
   * @augments Event
   */
  Events.MediaStreamAvailableEvent = function MediaStreamAvailableEvent(mediaStream) {
    return new _Event4.default('mediaStreamAvailable', false, {
      mediaStream
    });
  };
  Events.StreamUpdatedEvent = function StreamUpdatedEvent(stream, key, oldValue, newValue) {
    return new _Event4.default('updated', false, {
      target: stream,
      changedProperty: key,
      oldValue,
      newValue
    });
  };
  Events.DestroyedEvent = function DestroyedEvent(type, target, reason) {
    return new _Event4.default(type, false, {
      target,
      reason
    });
  };
  Events.ConnectionStateChangedEvent = function ConnectionStateChangedEvent(type, target, mediaMode) {
    return new _Event4.default(type, false, {
      target,
      mediaMode
    });
  };

  /**
   * Defines the event object for the <code>videoDisabled</code> and <code>videoEnabled</code>
   * events dispatched by the Subscriber.
   *
   * @class VideoEnabledChangedEvent
   *
   * @property {Boolean} cancelable Whether the event has a default behavior that is cancelable
   * (<code>true</code>) or not (<code>false</code>). You can cancel the default behavior by
   * calling the <code>preventDefault()</code> method of the event object in the callback
   * function. (See <a href="#preventDefault">preventDefault()</a>.)
   *
   * @property {String} reason The reason the video was disabled or enabled. This can be set to one
   * of the following values:
   *
   * <ul>
   *
   *   <li><code>"publishVideo"</code> &mdash; The publisher started or stopped publishing video,
   *   by calling <code>publishVideo(true)</code> or <code>publishVideo(false)</code>.</li>
   *
   *   <li><code>"quality"</code> &mdash; The sending of video can be started or stopped based on
   *   stream quality changes.
   *     <ul>
   *       <li>When subscriber audio-fallback is enabled, the Vonage Video API Media Router starts or stops
   *       sending video to the subscriber based on stream quality changes. This feature of the
   *       Vonage Video API Media Router has a subscriber drop the video stream when connectivity degrades.
   *       (The subscriber continues to receive the audio stream, if there is one.)
   *       <p>
   *       If connectivity improves to support video again, the Subscriber object dispatches
   *       a <code>videoEnabled</code> event, and the Subscriber resumes receiving video.
   *       <p>
   *       By default, the Subscriber displays a video disabled indicator when a
   *       <code>videoDisabled</code> event with this reason is dispatched and removes the indicator
   *       when the <code>videoEnabled</code> event with this reason is dispatched. You can control
   *       the display of this icon by calling the <code>setStyle()</code> method of the Subscriber,
   *       setting the <code>videoDisabledDisplayMode</code> property(or you can set the style when
   *       calling the <code>Session.subscribe()</code> method, setting the <code>style</code> property
   *       of the <code>properties</code> parameter).
   *       <p>
   *       This feature is only available in sessions that use the Vonage Video API Media Router (sessions with
   *       the <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media mode</a>
   *       set to routed), not in sessions with the media mode set to relayed.</li>
   *
   *       <li>When publisher audio-fallback is enabled, the Publisher starts or stops sending
   *       video based on stream quality changes. (The subscriber continues to receive the audio
   *       stream, if there is one.)
   *       <p>
   *       If connectivity improves to support video again, the Publisher object dispatches
   *       a <code>videoEnabled</code> event, and the Subscriber resumes receiving video.
   *       <p>
   *       By default, the Publisher displays a video disabled indicator when a
   *       <code>videoDisabled</code> event with this reason is dispatched and removes the indicator
   *       when the <code>videoEnabled</code> event with this reason is dispatched. You can control
   *       the display of this icon by calling the <code>setStyle()</code> method of the Publisher and
   *       setting the <code>videoDisabledDisplayMode</code> property, or you can set the
   *       <code>videoDisabledDisplayMode</code> property when
   *       calling the <code>OT.initPublisher()</code> method and setting the <code>style</code> property
   *       of the <code>properties</code> parameter.</li>
   *     </ul>
   *   </li>
   *
   *   <li><code>"subscribeToVideo"</code> &mdash; The subscriber started or stopped subscribing to
   *   video, by calling <code>subscribeToVideo(true)</code> or
   *   <code>subscribeToVideo(false)</code>.</li>
   *
   *   <li><code>"codecNotSupported"</code> &mdash; The subscriber stopped subscribing to video due
   *   to an incompatible codec.</li>
   *
   *   <li><code>"codecChanged"</code> &mdash; The subscriber video was enabled after a codec change
   *   from an incompatible codec.</li>
   *
   *    <li><code>"serverRotation"</code> &#151; The Publishing client was disconnected from the session because of
   * <a href="https://tokbox.com/developer/guides/server-rotation/">Video API server rotation</a>.</li>
   * </ul>
   *
   * @property {Object} target The object that dispatched the event.
   *
   * @property {String} type  The type of event: <code>"videoDisabled"</code> or
   * <code>"videoEnabled"</code>.
   *
   * @see <a href="Publisher.html#event:videoDisabled">Publisher videoDisabled event</a></p>
   * @see <a href="Publisher.html#event:videoEnabled">Publisher videoEnabled event</a></p>
   * @see <a href="Subscriber.html#event:videoDisabled">Subscriber videoDisabled event</a></p>
   * @see <a href="Subscriber.html#event:videoEnabled">Subscriber videoEnabled event</a></p>
   * @augments Event
   */
  Events.VideoEnabledChangedEvent = function VideoEnabledChangedEvent(type, properties) {
    return new _Event4.default(type, false, {
      reason: properties.reason
    });
  };
  Events.VideoDisableWarningEvent = function VideoDisableWarningEvent(type /* , properties */) {
    return new _Event4.default(type, false);
  };

  /**
   * Dispatched periodically by a Subscriber or Publisher object to indicate the audio
   * level. This event is dispatched up to 60 times per second, depending on the browser.
   *
   * @property {Number} audioLevel The audio level, from 0 to 1.0. Adjust this value logarithmically
   * for use in adjusting a user interface element, such as a volume meter. Use a moving average
   * to smooth the data.
   *
   * @class AudioLevelUpdatedEvent
   * @augments Event
   */
  Events.AudioLevelUpdatedEvent = function AudioLevelUpdatedEvent(audioLevel) {
    return new _Event4.default(_eventNames.default.AUDIO_LEVEL_UPDATED, false, {
      audioLevel
    });
  };

  /**
   * Dispatched when the audio input device is changed.
   *
   * <p> For more information, see <a href="https://tokbox.com/developer/guides/audio-video/js/#audioInputDeviceChanged">this documentation</a>.
   * @property {Object} device The audio input device.
   * This object has a <code>deviceId</code> property and a <code>label</code> property (both strings).
   *
   * @see <a href="Publisher.html#event:audioInputDeviceChanged">Publisher audioInputDeviceChanged event</a></p>
   * @see <a href="Publisher.html#setAudioSource">Publisher.setAudioSource()</a></p>
   * @class AudioInputDeviceChangedEvent
   * @augments Event
   */
  Events.AudioInputDeviceChangedEvent = function AudioInputDeviceChangedEvent(device) {
    return new _Event4.default(_eventNames.default.AUDIO_INPUT_DEVICE_CHANGED, false, {
      device
    });
  };

  /**
   * Dispatched by a Publisher when the user has stopped sharing one or all media types
   * (video, audio, or screen).
   *
   * @property {MediaStreamTrack} track The media track that has ended. This property is undefined
   * if all media tracks have stopped. Check the <code>kind</code> property of this object to
   * see if the track is an audio track or a video track.
   *
   * @class MediaStoppedEvent
   * @augments Event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamTrack
   */
  Events.MediaStoppedEvent = function MediaStoppedEvent(target, track) {
    return new _Event4.default(_eventNames.default.MEDIA_STOPPED, true, {
      target,
      track
    });
  };

  /**
   * Defines the <code>muteForced</code> event dispatched by a Session object. The Session object
   * dispatches this event when a moderator forces clients publishing streams to the session
   * to mute audio (the <code>active</code> property of the MuteForcedEvent object is set
   * to <code>true</code>), or when a moderator disables the mute audio state in the session
   * (the <code>active</code> property of the MuteForcedEvent object is set to <code>false</code>).
   *
   * @property {Boolean} active Whether the moderator has muted streams in the session (<code>true</code>)
   * or disabled the mute state in the session (<code>false</code>).
   *
   * @class MuteForcedEvent
   * @augments Event
   * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
   * @see <a href="Session.html#disableForceMute">Session.disableForceMute()</a>
   * @see <a href="Session.html#event:muteForced">Session muteForced event</a>
   * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
   * of streams in a session</a>
   */
  Events.MuteForcedEvent = function MuteForcedEvent(muteForcedInfo) {
    return new _Event4.default(_eventNames.default.MUTE_FORCED, false, muteForcedInfo);
  };

  /**
   * Dispatched by a Subscriber or Publisher object to indicate the <code>video</code> element
   * (or <code>object</code> element in Internet Explorer) was created. Add a listener for this event
   * when you set the <code>insertDefaultUI</code> option to <code>false</code> in the call to the
   * <a href="OT.html#initPublisher">OT.initPublisher()</a> method or the
   * <a href="Session.html#subscribe">Session.subscribe()</a> method. The <code>element</code>
   * property of the event object is a reference to the Publisher's <code>video</code> element
   * (or the <code>object</code> element in Internet Explorer). Add it to the HTML DOM to display the
   * video. (When you set the <code>insertDefaultUI</code> option to <code>false</code>, the
   * <code>video</code> element is not inserted into the DOM automatically.)
   * <p>
   * Add a listener for this event only if you have set the <code>insertDefaultUI</code> option to
   * <code>false</code>. If you have not set <code>insertDefaultUI</code> option
   * to <code>false</code>, do not move the <code>video</code> element (or the <code>object</code>
   * element containing the video in Internet Explorer) in the HTML DOM. Doing so causes the
   * Publisher or Subscriber object to be destroyed.
   *
   * @property {Number} element A reference to the Publisher or Subscriber's <code>video</code>
   * element (or in Internet Explorer the <code>object</code> element containing the video).
   * Add it to the HTML DOM to display the video.
   *
   * @class VideoElementCreatedEvent
   * @augments Event
   */
  Events.VideoElementCreatedEvent = function VideoElementCreatedEvent(element) {
    return new _Event4.default(_eventNames.default.VIDEO_ELEMENT_CREATED, false, {
      element
    });
  };
  return Events;
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _find = _interopRequireDefault(__webpack_require__(63));
var _findIndex = _interopRequireDefault(__webpack_require__(298));
var _intersection = _interopRequireDefault(__webpack_require__(149));
var _uniq = _interopRequireDefault(__webpack_require__(299));
var _log = _interopRequireDefault(__webpack_require__(1));
var _mediaDirection = _interopRequireDefault(__webpack_require__(300));
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
const logging = (0, _log.default)('SDPHelpers');
const START_MEDIA_SSRC = 10000;
const START_RTX_SSRC = 20000;

// Here are the structure of the rtpmap attribute and the media line, most of the
// complex Regular Expressions in this code are matching against one of these two
// formats:
// * a=rtpmap:<payload type> <encoding name>/<clock rate> [/<encoding parameters>]
// * m=<media> <port>/<number of ports> <proto> <fmts>
//
// References:
// * https://tools.ietf.org/html/rfc4566
// * http://en.wikipedia.org/wiki/Session_Description_Protocol
//
//

const SDPHelpers = {
  getSections(sdp) {
    return sdp.split(/\r\n|\r|\n/).reduce((accum, line) => {
      const match = line.match(/^m=(\w+) \d+/);
      if (match) {
        accum.sections[accum.section = match[1]] = []; // eslint-disable-line no-param-reassign
      }

      accum.sections[accum.section].push(line);
      return accum;
    }, {
      sections: {
        header: []
      },
      section: 'header'
    }).sections;
  },
  getCodecsFromSection(section) {
    const codecs = section[0].match(/m=\w+ \d+ [A-Z/]+ ([\d ]+)$/)[1].split(' ');
    const codecMap = (0, _assign.default)(...section.filter(line => line.match(/^a=rtpmap:\d+/)).map(line => line.match(/^a=rtpmap:(\d+) ([\w-]+)/).splice(1)).map(_ref => {
      let num = _ref[0],
        codec = _ref[1];
      return {
        [num]: codec
      };
    }));
    return {
      codecs,
      codecMap
    };
  },
  getCodecsAndCodecMap(sdp, mediaType) {
    const section = SDPHelpers.getSections(sdp)[mediaType];
    if (!section) {
      throw new Error(`no mediaType ${mediaType}`);
    }
    return SDPHelpers.getCodecsFromSection(section);
  },
  getCodecs(sdp, mediaType) {
    const codecsAndCodecMap = SDPHelpers.getCodecsAndCodecMap(sdp, mediaType);
    return codecsAndCodecMap.codecs.map(num => codecsAndCodecMap.codecMap[num] || 'Unknown codec');
  },
  MediaDirection: _mediaDirection.default,
  iceCredentials: {
    ufrag: 'a=ice-ufrag:',
    pwd: 'a=ice-pwd:'
  }
};

// Search through sdpLines to find the Media Line of type +mediaType+.
SDPHelpers.getMLineIndex = function getMLineIndex(sdpLines, mediaType) {
  const targetMLine = `m=${mediaType}`;

  // Find the index of the media line for +type+
  return (0, _findIndex.default)(sdpLines, line => {
    if (line.indexOf(targetMLine) !== -1) {
      return true;
    }
    return false;
  });
};

// Grab a M line of a particular +mediaType+ from sdpLines.
SDPHelpers.getMLine = function getMLine(sdpLines, mediaType) {
  const mLineIndex = SDPHelpers.getMLineIndex(sdpLines, mediaType);
  return mLineIndex > -1 ? sdpLines[mLineIndex] : void 0;
};
SDPHelpers.hasMediaType = (sdp, mediaType) => {
  const mLineRegex = new RegExp(`^m=${mediaType}`);
  const sdpLines = sdp.split('\r\n');
  return (0, _findIndex.default)(sdpLines, line => mLineRegex.test(line)) >= 0;
};
SDPHelpers.hasMLinePayloadType = function hasMLinePayloadType(sdpLines, mediaType, payloadType) {
  const mLine = SDPHelpers.getMLine(sdpLines, mediaType);
  const payloadTypes = SDPHelpers.getMLinePayloadTypes(mLine, mediaType);
  return payloadTypes.indexOf(payloadType) > -1;
};

// Extract the payload types for a give Media Line.
//
SDPHelpers.getMLinePayloadTypes = function getMLinePayloadTypes(mediaLine, mediaType) {
  const mLineSelector = new RegExp(`^m=${mediaType} \\d+(/\\d+)? [a-zA-Z0-9/]+(( [a-zA-Z0-9/]+)+)$`, 'i');

  // Get all payload types that the line supports
  const payloadTypes = mediaLine.match(mLineSelector);
  if (!payloadTypes || payloadTypes.length < 2) {
    // Error, invalid M line?
    return [];
  }
  return payloadTypes[2].trim().split(' ');
};

// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPHelpers.splitSections = function splitSections(sdp) {
  const parts = sdp.split('\nm=');
  // eslint-disable-next-line prefer-template
  return parts.map((part, index) => (index > 0 ? 'm=' + part : part).trim() + '\r\n');
};
SDPHelpers.getLinesPerSection = sdp => {
  const sections = SDPHelpers.splitSections(sdp);
  return sections.map(section => SDPHelpers.getSDPLines(section));
};
SDPHelpers.replaceDirectionInSdpLines = (mediaSdpLines, currentDirection, newDirection) => {
  const mediaSdp = mediaSdpLines.join('\r\n');
  const mediaSdpDirectionChanged = SDPHelpers.replaceDirection(mediaSdp, currentDirection, newDirection);
  return mediaSdpDirectionChanged.split('\r\n');
};
SDPHelpers.replaceDirection = (mediaSdpPart, currentDirection, newDirection) => {
  const regex = new RegExp(`a=${currentDirection}`, 'g');
  return mediaSdpPart.replace(regex, `a=${newDirection}`);
};
SDPHelpers.setSubscriberMediaSectionToInactive = mediaSection => {
  const currentDirection = _mediaDirection.default.SENDONLY;
  const newDirection = _mediaDirection.default.INACTIVE;
  return SDPHelpers.replaceDirectionInSdpLines(mediaSection, currentDirection, newDirection);
};

// Changes the media direction
SDPHelpers.changeMediaDirection = function changeMediaDirection(sdp, newDirection) {
  // Splits SDP into session part and media sections.
  const sections = SDPHelpers.splitSections(sdp);

  // Preserve the session part since we don't need to modify it.
  const sessionSdpPart = sections.shift();
  let newSdp = sessionSdpPart;
  const RECVONLY = _mediaDirection.default.RECVONLY,
    INACTIVE = _mediaDirection.default.INACTIVE;

  // Replace all the recvonly by inactive or viceversa, depending the active argument
  const currentDirection = newDirection === RECVONLY ? INACTIVE : RECVONLY;
  sections.forEach(section => {
    // Only video is set to inactive/recvonly
    const mediaSection = section.includes('m=video') ? SDPHelpers.replaceDirection(section, currentDirection, newDirection) : section;
    newSdp += mediaSection;
  });

  // Return the session and new media sections concatenated
  return newSdp;
};
SDPHelpers.removeTypesFromMLine = function removeTypesFromMLine(mediaLine, payloadTypes) {
  const typesSuffix = /[0-9 ]*$/.exec(mediaLine)[0];
  const newTypes = typesSuffix.split(' ').filter(type => type !== '' && payloadTypes.indexOf(type) === -1);
  return mediaLine.replace(typesSuffix, ` ${newTypes.join(' ')}`);
};

// Remove all references to a particular encodingName from a particular media type
//
SDPHelpers.removeMediaEncoding = function removeMediaEncoding(sdp, mediaType, encodingName) {
  let payloadTypes, i, j, parts;
  let sdpLines = sdp.split('\r\n');
  const mLineIndex = SDPHelpers.getMLineIndex(sdpLines, mediaType);
  const mLine = mLineIndex > -1 ? sdpLines[mLineIndex] : void 0;
  const typesToRemove = [];
  if (mLineIndex === -1) {
    // Error, missing M line
    return sdpLines.join('\r\n');
  }

  // Get all payload types that the line supports
  payloadTypes = SDPHelpers.getMLinePayloadTypes(mLine, mediaType);
  if (payloadTypes.length === 0) {
    // Error, invalid M line?
    return sdpLines.join('\r\n');
  }

  // Find the payloadTypes of the codecs.
  // Allows multiple matches e.g. for CN.
  for (i = mLineIndex; i < sdpLines.length; i++) {
    const codecRegex = new RegExp(encodingName, 'i');
    if (sdpLines[i].indexOf('a=rtpmap:') === 0) {
      parts = sdpLines[i].split(' ');
      if (parts.length === 2 && codecRegex.test(parts[1])) {
        typesToRemove.push(parts[0].substr(9));
      }
    }
  }
  if (!typesToRemove.length) {
    // Not found.
    return sdpLines.join('\r\n');
  }

  // Also find any rtx which reference the removed codec.
  for (i = mLineIndex; i < sdpLines.length; i++) {
    if (sdpLines[i].indexOf('a=fmtp:') === 0) {
      parts = sdpLines[i].split(' ');
      for (j = 0; j < typesToRemove.length; j++) {
        if (parts.length === 2 && parts[1] === `apt=${typesToRemove[j]}`) {
          typesToRemove.push(parts[0].substr(7));
        }
      }
    }
  }

  // Remove any rtpmap, fmtp or rtcp-fb.
  sdpLines = sdpLines.filter(line => {
    for (let i = 0; i < typesToRemove.length; i++) {
      if (line.indexOf(`a=rtpmap:${typesToRemove[i]} `) === 0 || line.indexOf(`a=fmtp:${typesToRemove[i]} `) === 0 || line.indexOf(`a=rtcp-fb:${typesToRemove[i]} `) === 0) {
        return false;
      }
    }
    return true;
  });
  if (typesToRemove.length > 0 && mLineIndex > -1) {
    // Remove all the payload types and we've removed from the media line
    sdpLines[mLineIndex] = SDPHelpers.removeTypesFromMLine(mLine, typesToRemove);
  }
  return sdpLines.join('\r\n');
};
SDPHelpers.disableMediaType = function disableMediaType(sdp, mediaType) {
  const lines = sdp.split('\r\n');
  const blocks = [];
  let block;

  // Separating SDP into blocks. This usually follows the form:
  // Header block:
  //   v=0
  //   ...
  // Audio block:
  //   m=audio
  //   ...
  // Video block:
  //   m=video
  //   ...

  lines.forEach(lineParam => {
    let line = lineParam;
    if (/^m=/.test(line)) {
      block = undefined;
    }
    if (!block) {
      block = [];
      blocks.push(block);
    }
    block.push(line);
  });

  // Now disable the block for the specified media type

  const mLineRegex = new RegExp(`^m=${mediaType} \\d+ ([^ ]+) [0-9 ]+$`);
  const fixedBlocks = blocks.map(block => {
    const match = block[0].match(mLineRegex);
    if (match) {
      return [`m=${mediaType} 0 ${match[1]} 0`, 'a=inactive', ...block.filter(line => /^c=/.test(line) || /^a=mid:/.test(line) || line === '' // This preserves the trailing newline
      )];
    }

    return block;
  });
  return [].concat(...fixedBlocks).join('\r\n');
};
SDPHelpers.removeVideoCodec = function removeVideoCodec(sdp, codec) {
  return SDPHelpers.removeMediaEncoding(sdp, 'video', codec);
};

// Used to identify whether Video media (for a given set of SDP) supports
// retransmissions.
//
// The algorithm to do could be summarised as:
//
// IF ssrc-group:FID exists AND IT HAS AT LEAST TWO IDS THEN
//    we are using RTX
// ELSE IF "a=rtpmap: (\\d+):rtxPayloadId(/\\d+)? rtx/90000"
//          AND SDPHelpers.hasMLinePayloadType(sdpLines, 'Video', rtxPayloadId)
//    we are using RTX
// ELSE
//    we are not using RTX
//
// The ELSE IF clause basically covers the case where ssrc-group:FID
// is probably malformed or missing. In that case we verify whether
// we want RTX by looking at whether it's mentioned in the video
// media line instead.
//
const isUsingRTX = function isUsingRTX(sdpLines, videoAttrs) {
  let groupFID = videoAttrs.filterByName('ssrc-group:FID');
  const missingFID = groupFID.length === 0;
  if (!missingFID) {
    groupFID = groupFID[0].value.split(' ');
  } else {
    groupFID = [];
  }
  switch (groupFID.length) {
    case 0:
    case 1:
      // possibly no RTX, double check for the RTX payload type and that
      // the Video Media line contains that payload type
      //
      // Details: Look for a rtpmap line for rtx/90000
      //  If there is one, grab the payload ID for rtx
      //    Look to see if that payload ID is listed under the payload types for the m=Video line
      //      If it is: RTX
      //  else: No RTX for you

      var rtxAttr = videoAttrs.find(attr => attr.name.indexOf('rtpmap:') === 0 && attr.value.indexOf('rtx/90000') > -1);
      if (!rtxAttr) {
        return false;
      }
      var rtxPayloadId = rtxAttr.name.split(':')[1];
      if (rtxPayloadId.indexOf('/') > -1) {
        rtxPayloadId = rtxPayloadId.split('/')[0];
      }
      return SDPHelpers.hasMLinePayloadType(sdpLines, 'video', rtxPayloadId);
    default:
      // two or more: definitely RTX
      logging.debug('SDP Helpers: There are more than two FIDs, RTX is definitely enabled');
      return true;
  }
};

// This returns an Array, which is decorated with several
// SDP specific helper methods.
//
SDPHelpers.getAttributesForMediaType = function getAttributesForMediaType(sdpLines, mediaType) {
  let ssrcStartIndex, ssrcEndIndex, regResult, ssrc, ssrcGroup, ssrcLine, msidMatch, msid, mid, midIndex;
  const mLineIndex = SDPHelpers.getMLineIndex(sdpLines, mediaType);
  const matchOtherMLines = new RegExp(`m=(?!${mediaType}).+ `, 'i');
  const matchSSRCLines = new RegExp('a=ssrc:\\d+ .*', 'i');
  const matchSSRCGroup = new RegExp('a=ssrc-group:(SIM|FID) (\\d+).*?', 'i');
  const matchAttrLine = new RegExp('a=([a-z0-9:/-]+) (.*)', 'i');
  const attrs = [];
  for (let i = mLineIndex + 1; i < sdpLines.length; i++) {
    // If we were inside an SSRC block and we've now reached an m-line, then
    // tag the previous line as the end of the SSRC block
    if (matchOtherMLines.test(sdpLines[i])) {
      if (ssrcStartIndex !== undefined) {
        ssrcEndIndex = i - 1;
      }
      break;
    }

    // Get the ssrc
    ssrcGroup = sdpLines[i].match(matchSSRCGroup);
    ssrcLine = sdpLines[i].match(matchSSRCLines);
    if (ssrcStartIndex === undefined && (ssrcGroup || ssrcLine)) {
      // We found the start of an SSRC block
      ssrcStartIndex = i;
      if (ssrcGroup) {
        ssrc = /^(FID|SIM)$/.test(ssrcGroup[1]) ? ssrcGroup[2] : ssrcGroup[1];
      }
    }

    // Get the msid
    msidMatch = sdpLines[i].match(`a=ssrc:${ssrc} msid:(.+)`);
    if (msidMatch) {
      msid = msidMatch[1];
    }

    // find where the ssrc lines end
    const isSSRCLine = matchSSRCLines.test(sdpLines[i]);
    const isSSRCGroup = matchSSRCGroup.test(sdpLines[i]);
    if (ssrcStartIndex !== undefined) {
      if (ssrcEndIndex === undefined && !isSSRCLine && !isSSRCGroup) {
        // If we were inside an SSRC block and we've now reached a non-SSRC
        // line, then tag the previous line as the end of the SSRC block
        ssrcEndIndex = i - 1;
      } else if (i === sdpLines.length - 1) {
        // If we were inside an SSRC block and we've now reached the end of the
        // offer, tag the last line as the end of the SSRC block
        ssrcEndIndex = i;
      }
    }
    const midMatch = sdpLines[i].match(/a=mid:(.+)/);
    if (midMatch) {
      mid = midMatch[1];
      midIndex = i;
    }
    regResult = matchAttrLine.exec(sdpLines[i]);
    if (regResult && regResult.length === 3) {
      attrs.push({
        lineIndex: i,
        name: regResult[1],
        value: regResult[2]
      });
    }
  }

  // / The next section decorates the attributes array
  // / with some useful helpers.

  // Store references to the start and end indices
  // of the media section for this mediaType
  attrs.ssrcStartIndex = ssrcStartIndex;
  attrs.ssrcEndIndex = ssrcEndIndex;
  attrs.msid = msid;
  attrs.mid = mid;
  attrs.midIndex = midIndex;
  attrs.isUsingRTX = isUsingRTX.bind(null, sdpLines, attrs);
  attrs.filterByName = function filterByName(name) {
    return this.filter(attr => attr.name === name);
  };
  attrs.getRtpNumber = mediaEncoding => {
    const namePattern = new RegExp('rtpmap:(.+)');
    return (0, _find.default)(attrs.map(attr => {
      const nameMatch = attr.name.match(namePattern);
      if (nameMatch && attr.value.indexOf(mediaEncoding) >= 0) {
        return nameMatch[1];
      }
      return null;
    }), attr => attr !== null);
  };
  return attrs;
};
SDPHelpers.modifyDtx = (sdp, enable) => {
  const sdpLines = sdp.split('\r\n');
  if (!SDPHelpers.getMLine(sdpLines, 'audio')) {
    logging.debug('No audio m-line, not enabling dtx.');
    return sdp;
  }
  const audioAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'audio');
  const rtpNumber = audioAttrs.getRtpNumber('opus');
  if (!rtpNumber) {
    logging.debug('Could not find rtp number for opus, not enabling dtx.');
    return sdp;
  }
  const fmtpAttr = audioAttrs.find(attr => attr.name === `fmtp:${rtpNumber}`);
  if (!fmtpAttr) {
    logging.debug('Could not find a=fmtp line for opus, not enabling dtx.');
    return sdp;
  }
  let line = sdpLines[fmtpAttr.lineIndex];
  const pattern = /usedtx=\d+([\s;]*)/;
  if (pattern.test(fmtpAttr.value)) {
    line = line.replace(pattern, enable ? 'usedtx=1$1' : '');
  } else if (enable) {
    line += '; usedtx=1';
  }

  // Trim any trailing whitespace and semicolons
  line = line.replace(/[;\s]*$/, '');
  sdpLines[fmtpAttr.lineIndex] = line;
  return sdpLines.join('\r\n');
};
const modifyStereo = (type, sdp, enable) => {
  const sdpLines = sdp.split('\r\n');
  if (!SDPHelpers.getMLine(sdpLines, 'audio')) {
    logging.debug('No audio m-line, not enabling stereo.');
    return sdp;
  }
  const audioAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'audio');
  const rtpNumber = audioAttrs.getRtpNumber('opus');
  if (!rtpNumber) {
    logging.debug('Could not find rtp number for opus, not enabling stereo.');
    return sdp;
  }
  const fmtpAttr = audioAttrs.find(attr => attr.name === `fmtp:${rtpNumber}`);
  if (!fmtpAttr) {
    logging.debug('Could not find a=fmtp line for opus, not enabling stereo.');
    return sdp;
  }
  let line = sdpLines[fmtpAttr.lineIndex];
  let pattern;
  switch (type) {
    case 'send':
      pattern = /sprop-stereo=\d+([\s;]*)/;
      if (pattern.test(fmtpAttr.value)) {
        line = line.replace(pattern, enable ? 'sprop-stereo=1$1' : '');
      } else if (enable) {
        line += '; sprop-stereo=1';
      }
      break;
    case 'receive':
      pattern = /([^-])stereo=\d+([\s;]*)/;
      if (pattern.test(fmtpAttr.value)) {
        line = line.replace(pattern, enable ? '$1stereo=1$2' : '$1');
      } else if (enable) {
        line += '; stereo=1';
      }
      break;
    default:
      throw new Error(`Invalid type ${type} passed into enableStereo`);
  }

  // Trim any trailing whitespace and semicolons
  line = line.replace(/[;\s]*$/, '');
  sdpLines[fmtpAttr.lineIndex] = line;
  return sdpLines.join('\r\n');
};
SDPHelpers.modifySendStereo = modifyStereo.bind(null, 'send');
SDPHelpers.modifyReceiveStereo = modifyStereo.bind(null, 'receive');
SDPHelpers.setAudioBitrate = (sdp, audioBitrate) => {
  const existingValue = SDPHelpers.getAudioBitrate(sdp);
  if (existingValue !== undefined) {
    logging.debug(`Audio bitrate already set to ${existingValue}, not setting audio bitrate`);
    return sdp;
  }
  const sdpLines = sdp.split('\r\n');
  if (!SDPHelpers.getMLine(sdpLines, 'audio')) {
    logging.debug('No audio m-line, not setting audio bitrate');
    return sdp;
  }
  const audioAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'audio');
  const rtpNumber = audioAttrs.getRtpNumber('opus');
  if (!rtpNumber) {
    logging.debug('Could not find rtp number for opus, not setting audio bitrate.');
    return sdp;
  }
  const fmtpAttr = audioAttrs.find(attr => attr.name === `fmtp:${rtpNumber}`);
  if (!fmtpAttr) {
    logging.debug('Could not find a=fmtp line for opus, not setting audio bitrate.');
    return sdp;
  }
  let line = sdpLines[fmtpAttr.lineIndex];
  line += `; maxaveragebitrate=${audioBitrate}`;

  // Trim any trailing whitespace and semicolons
  line = line.replace(/[;\s]*$/, '');
  sdpLines[fmtpAttr.lineIndex] = line;
  return sdpLines.join('\r\n');
};
SDPHelpers.removeVideoOrientation = sdp => {
  let sdpLines = sdp.split('\r\n');

  // We don't bother to limit this filter to only the video m-section since
  // this attribute isn't applicable to audio.
  sdpLines = sdpLines.filter(line => !line.includes('urn:3gpp:video-orientation'));
  return sdpLines.join('\r\n');
};
SDPHelpers.hasSendStereo = sdp => /[\s;]sprop-stereo=1/.test(sdp);
SDPHelpers.hasSendDtx = sdp => /[\s;]usedtx=1/.test(sdp);
SDPHelpers.hasOpusFec = sdp => /[\s;]useinbandfec=1/.test(sdp);
SDPHelpers.getAudioBitrate = sdp => {
  const result = sdp.match(/[\s;]maxaveragebitrate=(\d+)/);
  if (result) {
    return Number(result[1]);
  }
  return undefined;
};

// Safety limit of unique media SSRCs allowed in an SDP offer
SDPHelpers.MAX_SSRCS = 10;
SDPHelpers.getSSRCGroupType = videoAttrs => {
  const TYPES = ['SIM', 'FID'];

  // Note: this returns `undefined` if SDP has neither type in `TYPES`
  return TYPES.find(type => {
    const _videoAttrs$filterByN = videoAttrs.filterByName(`ssrc-group:${type}`),
      exists = _videoAttrs$filterByN[0];
    return exists;
  });
};
SDPHelpers.getSSRCGroup = videoAttrs => {
  const ssrcGroupType = SDPHelpers.getSSRCGroupType(videoAttrs);

  // The first group takes precedence
  const _videoAttrs$filterByN2 = videoAttrs.filterByName(`ssrc-group:${ssrcGroupType}`),
    ssrcGroup = _videoAttrs$filterByN2[0];
  return ssrcGroup;
};
SDPHelpers.getSSRCGroupSSRCs = videoAttrs => {
  const ssrcGroup = SDPHelpers.getSSRCGroup(videoAttrs);

  // If no group type was found, then there's nothing to filter
  if (!ssrcGroup) {
    return [];
  }
  return ssrcGroup.value.split(' ').slice(0, SDPHelpers.MAX_SSRCS);
};
SDPHelpers.getAllowedSSRCs = (videoAttrs, ssrcGroupSSRCs) => {
  // All SSRCs in the ssrc-group are allowed
  const allowedSSRCs = ssrcGroupSSRCs.slice();

  // We need to allow the SSRCs that belong to the same FID group
  videoAttrs.filterByName('ssrc-group:FID').forEach(fid => {
    const ssrcs = fid.value.split(' ');
    const isAllowed = (0, _intersection.default)(allowedSSRCs, ssrcs).length;
    if (isAllowed) {
      Array.prototype.push.apply(allowedSSRCs, ssrcs);
    }
  });
  return (0, _uniq.default)(allowedSSRCs);
};
SDPHelpers.filterExcessSSRCs = sdp => {
  const sdpLines = sdp.split('\r\n');
  const videoAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'video');
  const ssrcGroupType = SDPHelpers.getSSRCGroupType(videoAttrs);
  const ssrcGroupIndex = videoAttrs.ssrcStartIndex;

  // This is only possible in an audio-only session
  if (ssrcGroupIndex === undefined) {
    return sdp;
  }
  let allowedSSRCs;

  // Returns the SSRC ID from the SDP line if it exists, otherwise returns null
  const getSSRCid = line => {
    let ssrc = null;
    if (line.match(/^a=ssrc:(\d+)/)) {
      ssrc = RegExp.$1;
    }
    return ssrc;
  };
  if (ssrcGroupType) {
    // Update ssrc-group with allowed SSRCs
    const ssrcGroupSSRCs = SDPHelpers.getSSRCGroupSSRCs(videoAttrs);
    const ssrcGroupLine = [`a=ssrc-group:${ssrcGroupType}`, ...ssrcGroupSSRCs].join(' ');
    const indexToReplace = videoAttrs.find(attr => attr.name.startsWith('ssrc-group:')).lineIndex;
    sdpLines[indexToReplace] = ssrcGroupLine;
    allowedSSRCs = SDPHelpers.getAllowedSSRCs(videoAttrs, ssrcGroupSSRCs);
  } else {
    // No ssrc-group was defined.  No SSRCs are allowed, so all isolated
    // (non-audio) SSRCs will be removed.
    allowedSSRCs = [];

    // We want to allow through a single, isolated, video ssrc which may occur in P2P sessions
    const hasIsolatedSSRCs = videoAttrs.ssrcStartIndex;
    if (hasIsolatedSSRCs) {
      // Parse the ssrc ID
      allowedSSRCs.push(getSSRCid(sdpLines[videoAttrs.ssrcStartIndex]));
    }
  }

  // Cleans up the SDP, by removing all SSRC-related lines that aren't allowed
  const filteredSdpLines = sdpLines.filter((line, index) => {
    // Passthrough lines outside the SSRC block
    if (index < ssrcGroupIndex || index > videoAttrs.ssrcEndIndex) {
      return true;
    }
    if (index === ssrcGroupIndex) {
      if (!ssrcGroupType) {
        const ssrcID = getSSRCid(line);
        if (ssrcID) {
          return allowedSSRCs.includes(ssrcID);
        }
        // Filter out isolated SSRCs, since no ssrc-group was found
        return !/^a=ssrc:(\d+)/.test(line);
      }
      return true;
    }

    // Make sure SSRC is allowed
    const ssrcID = getSSRCid(line);
    if (ssrcID) {
      return allowedSSRCs.includes(ssrcID);
    }

    // Make sure SSRCs in FID are allowed
    if (line.match(/^a=ssrc-group:FID (\d+)/)) {
      const ssrc = RegExp.$1;
      return allowedSSRCs.includes(ssrc);
    }

    // Avoid adding more than one sim group
    return !line.match(/^a=ssrc-group:SIM /);
  });
  return filteredSdpLines.join('\r\n');
};

// Modifies +sdp+ to enable Simulcast for +numberOfStreams+.
//
// Ok, here's the plan:
//  - add the 'a=ssrc-group:SIM' line, it will have numberOfStreams ssrcs
//  - if RTX then add one 'a=ssrc-group:FID', we need to add numberOfStreams lines
//  - add numberOfStreams 'a=ssrc:...' lines for the media ssrc
//  - if RTX then add numberOfStreams 'a=ssrc:...' lines for the RTX ssrc
//
// Re: media and rtx ssrcs:
// We just generate these. The Mantis folk would like us to use sequential numbers
// here for ease of debugging. We can use the same starting number each time as well.
// We should confirm with Oscar/Jose that whether we need to verify that the numbers
// that we choose don't clash with any other ones in the SDP.
//
// I think we do need to check but I can't remember.
//
// Re: The format of the 'a=ssrc:' lines
// Just use the following pattern:
//   a=ssrc:<Media or RTX SSRC> cname:localCname
//   a=ssrc:<Media or RTX SSRC> msid:<MSID>
//
// It doesn't matter that they are all the same and are static.
//
//
SDPHelpers.enableSimulcast = function enableSimulcast(sdp, numberOfStreams) {
  let linesToAdd, i;
  const sdpLines = sdp.split('\r\n');
  if (!SDPHelpers.getMLine(sdpLines, 'video')) {
    logging.debug('No video m-line, not enabling simulcast.');
    return sdp;
  }
  const videoAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'video');
  if (videoAttrs.filterByName('ssrc-group:SIM').length > 0) {
    logging.debug('Simulcast is already enabled in this SDP, not attempting to enable again.');

    // We clean the SDP in case it somehow has SSRCs unrelated to the ssrc-group
    return SDPHelpers.filterExcessSSRCs(sdp);
  }
  if (!videoAttrs.msid) {
    logging.debug('No local stream attached, not enabling simulcast.');
    return sdp;
  }
  const usingRTX = videoAttrs.isUsingRTX();
  const mediaSSRC = [];
  const rtxSSRC = [];

  // generate new media (and rtx if needed) ssrcs
  for (i = 0; i < numberOfStreams; ++i) {
    mediaSSRC.push(START_MEDIA_SSRC + i);
    if (usingRTX) {
      rtxSSRC.push(START_RTX_SSRC + i);
    }
  }
  linesToAdd = [`a=ssrc-group:SIM ${mediaSSRC.join(' ')}`];
  if (usingRTX) {
    for (i = 0; i < numberOfStreams; ++i) {
      linesToAdd.push(`a=ssrc-group:FID ${mediaSSRC[i]} ${rtxSSRC[i]}`);
    }
  }
  for (i = 0; i < numberOfStreams; ++i) {
    linesToAdd.push(`a=ssrc:${mediaSSRC[i]} cname:localCname`, `a=ssrc:${mediaSSRC[i]} msid:${videoAttrs.msid}`);
  }
  if (usingRTX) {
    for (i = 0; i < numberOfStreams; ++i) {
      linesToAdd.push(`a=ssrc:${rtxSSRC[i]} cname:localCname`, `a=ssrc:${rtxSSRC[i]} msid:${videoAttrs.msid}`);
    }
  }

  // Replace the previous video ssrc section with our new video ssrc section by
  // deleting the old ssrcs section and inserting the new lines
  linesToAdd.unshift(videoAttrs.ssrcStartIndex, videoAttrs.ssrcEndIndex - videoAttrs.ssrcStartIndex + 1);
  sdpLines.splice(...linesToAdd);
  return sdpLines.join('\r\n');
};
SDPHelpers.reprioritizeVideoCodec = function reprioritizeVideoCodec(sdp, codec, location) {
  const lines = sdp.split('\r\n');
  const mLineIndex = SDPHelpers.getMLineIndex(lines, 'video');
  if (mLineIndex === -1) {
    return sdp;
  }
  const payloadTypes = SDPHelpers.getMLinePayloadTypes(lines[mLineIndex], 'video');
  const regex = new RegExp(`^a=rtpmap:(\\d+).* ${codec}`, 'i');
  const codecMatches = lines.map(line => line.match(regex)).filter(match => match !== null);
  if (codecMatches.length === 0) {
    return sdp;
  }
  const codecTypeCodes = codecMatches.map(match => match[1]);
  let newPayloadTypes = payloadTypes.filter(t => codecTypeCodes.indexOf(t) === -1);
  if (location === 'top') {
    newPayloadTypes.unshift(...codecTypeCodes);
  } else if (location === 'bottom') {
    newPayloadTypes.push(...codecTypeCodes);
  } else {
    logging.error(`Unexpected location param: ${location}; not changing ${codec} priority`);
    newPayloadTypes = payloadTypes;
  }
  const newMLine = lines[mLineIndex].replace(payloadTypes.join(' '), newPayloadTypes.join(' '));
  lines[mLineIndex] = newMLine;
  return lines.join('\r\n');
};
SDPHelpers.getSetupRole = sdp => {
  // eslint-disable-next-line no-restricted-syntax
  for (var _iterator = _createForOfIteratorHelperLoose(sdp.split(/\r\n|\r|\n/)), _step; !(_step = _iterator()).done;) {
    const line = _step.value;
    const match = line.match(/^a=setup:(\w+)/);
    if (match) {
      return match[1];
    }
  }
  return '';
};
SDPHelpers.setSetupRole = (sdp, setupRole) => sdp.split(/\r\n|\r|\n/).map(line => {
  if (line.match(/^a=setup:(\w+)/)) {
    return `a=setup:${setupRole}`;
  }
  return line;
}).join('\r\n');
SDPHelpers.changeSetupRole = (sdp, oldSetupRole, newSetupRole) => sdp.split(/\r\n|\r|\n/).map(line => {
  if (line.includes(`a=setup:${oldSetupRole}`)) {
    return `a=setup:${newSetupRole}`;
  }
  return line;
}).join('\r\n');
SDPHelpers.patterns = {
  // group sample: a=group:BUNDLE 0a 1v 2a 3v
  bundle: 'a=group:BUNDLE',
  // address sample: c=IN IP4 54.201.197.86
  address: 'c=IN IP4',
  // rtcp sample: a=rtcp:41511
  rtcp: 'a=rtcp:',
  // direction sample: a=sendonly
  direction: ['a=inactive', 'a=sendonly', 'a=recvonly', 'a=sendrecv'],
  // a=rtcp-rsize
  rsize: 'a=rtcp-rsize',
  // ssrc sample: a=ssrc:3 cname:1E7BE30B-C693-4570-B552-34244D6F04C1
  ssrc: 'a=ssrc:',
  // msid sample: a=msid:McwRQfjkv8dWA33jaqKHwuBh6ovY0TxNpBZB 3c18dd96-8af5-4e07-856d-0cd21e0203b8
  msid: 'a=msid:'
};

// Get index from first match starting at 'startIndex'
SDPHelpers.getIndexStartingWith = (sdpLines, patternList, startIndex) => {
  const slicedSdp = sdpLines.slice(startIndex);
  const matchIndexes = patternList.map(pattern => slicedSdp.findIndex(line => line.includes(pattern))).filter(i => i > -1);
  if (!matchIndexes.length) {
    return sdpLines.length;
  }

  // Return the first index found that matches with any of patterns
  return startIndex + Math.min(...matchIndexes);
};

// Get index from last match before 'endIndex'
SDPHelpers.getLastIndexPriorTo = (sdpLines, pattern, endIndex) => {
  // Get subarray for the first {index} number of elements
  const slicedSdp = sdpLines.slice(0, endIndex);
  const sdpMap = slicedSdp.map(line => line.includes(pattern));
  return sdpMap.lastIndexOf(true);
};

// Like String.prototype.includes, except it works with an array of
// possible values
SDPHelpers.includesAny = (sdpLine, values) => {
  for (let i = 0; i < values.length; i++) {
    if (sdpLine.includes(values[i])) {
      return true;
    }
  }
  return false;
};
SDPHelpers.isVersionLine = line => /^o=/.test(line);
SDPHelpers.getVersionLine = sdpLines => sdpLines.find(SDPHelpers.isVersionLine);
SDPHelpers.getVersion = sdpLines => {
  const origin = SDPHelpers.getVersionLine(sdpLines);
  if (origin === undefined) {
    return undefined;
  }
  // For example: o=- 2356644873 4 IN IP4 34.194.94.104
  // Will return: 4
  const version = Number(origin.match(/ (\d+) IN /)[1]);
  return Number.isInteger(version) ? version : undefined;
};
SDPHelpers.updateVersion = (sdpLines, oldVersion, newVersion) => {
  const updatedSdpLines = [...sdpLines];
  const versionLineIndex = updatedSdpLines.findIndex(line => SDPHelpers.isVersionLine(line));
  if (versionLineIndex >= 0) {
    updatedSdpLines[versionLineIndex] = updatedSdpLines[versionLineIndex].replace(` ${oldVersion} `, ` ${newVersion} `);
  }
  return updatedSdpLines;
};
SDPHelpers.isBundleLine = line => line.includes(SDPHelpers.patterns.bundle);
SDPHelpers.getBundleLine = sdpLines => sdpLines.find(SDPHelpers.isBundleLine);
SDPHelpers.createBundleLine = tracks => `${SDPHelpers.patterns.bundle} ${tracks.join(' ')}`;
SDPHelpers.updateBundleLine = (sdpLines, tracks) => {
  const updatedSdpLines = [...sdpLines];
  const bundleLine = SDPHelpers.createBundleLine(tracks);
  const bundleLineIndex = updatedSdpLines.findIndex(line => SDPHelpers.isBundleLine(line));
  if (bundleLineIndex >= 0) {
    updatedSdpLines[bundleLineIndex] = bundleLine;
  }
  return updatedSdpLines;
};
SDPHelpers.parseMLine = mLine => {
  // Given: m=audio 41511 RTP/SAVPF 111
  // Parser will return:
  // * mediaType: m=audio
  // * port: 41511
  // * transport (transport protocol and media format descriptions): RTP/SAVPF 111
  const _mLine$match = mLine.match(/^(m=(?:audio|video)) (\d+) (.+)/),
    mediaType = _mLine$match[1],
    port = _mLine$match[2],
    transport = _mLine$match[3];
  return {
    port,
    transport,
    mediaType
  };
};
SDPHelpers.disableTrack = mLine => {
  // To disable tracks, we change the port of the m-line to zero
  // For example, given the following audio track:
  //   m=audio 41511 RTP/SAVPF 111
  // Disabling it will transform it to:
  //   m=audio 0 RTP/SAVPF 111
  const _SDPHelpers$parseMLin = SDPHelpers.parseMLine(mLine),
    mediaType = _SDPHelpers$parseMLin.mediaType,
    transport = _SDPHelpers$parseMLin.transport;
  return `${mediaType} 0 ${transport}`;
};
SDPHelpers.setMediaDirection = (_sdpLines, direction) => {
  const isValidDirection = Object.values(_mediaDirection.default).includes(direction);
  if (!isValidDirection) {
    return _sdpLines;
  }
  const sdpLines = _sdpLines.slice();
  const directionIndex = sdpLines.findIndex(line => SDPHelpers.includesAny(line, SDPHelpers.patterns.direction));
  if (directionIndex === -1) {
    // Oops, like like there's no direction attribute
    return sdpLines;
  }
  sdpLines[directionIndex] = `a=${direction}`;
  return sdpLines;
};
SDPHelpers.disableTrackSection = section => {
  const mid = section.mid,
    sdp = section.sdp;

  // Remove lines for address, rtcp, rsize, ssrc and msid
  let disabledTrackSdp = sdp.filter(line => {
    const _SDPHelpers$patterns = SDPHelpers.patterns,
      address = _SDPHelpers$patterns.address,
      rtcp = _SDPHelpers$patterns.rtcp,
      rsize = _SDPHelpers$patterns.rsize,
      ssrc = _SDPHelpers$patterns.ssrc,
      msid = _SDPHelpers$patterns.msid;
    return !SDPHelpers.includesAny(line, [address, rtcp, rsize, ssrc, msid]);
  });

  // We always disable the track on the first line
  disabledTrackSdp[0] = SDPHelpers.disableTrack(sdp[0]);
  disabledTrackSdp = SDPHelpers.setMediaDirection(disabledTrackSdp, _mediaDirection.default.INACTIVE);
  return {
    mid,
    sdp: disabledTrackSdp
  };
};
SDPHelpers.isDisabledMediaSection = _ref2 => {
  let section = _ref2[0];
  return /^m=(?:video|audio) 0 RTP\/SAVPF 0/.test(section);
};
SDPHelpers.getDisabledSectionForMid = mid => {
  const isAudio = mid.includes('a');
  const mediaType = isAudio ? 'audio' : 'video';
  const disabledSection = [`m=${mediaType} 0 RTP/SAVPF 0`];
  return disabledSection;
};

/**
 * Disable media sections that are not present in track array
 * @param {Array<string>} tracks - an array of active tracks mids e.g. ['0a', '1v']
 * @param {Array<string>} sections - an array of media section line arrays
 * e.g.  [
 *        ['m=audio 52265 RTP/SAVPF 98', 'c=IN IP4 54.197.248.203', ...etc],
 *        ['m=video 52265 RTP/SAVPF 97', 'c=IN IP4 54.197.248.203', ...etc]
 *       ];
 * @returns array of media section line arrays with specified track sections disabled
 */
SDPHelpers.disableTrackSections = (tracks, sections) => sections.map(section => {
  const _SDPHelpers$getTrackM = SDPHelpers.getTrackMids(section),
    mid = _SDPHelpers$getTrackM[0];
  if (!mid || tracks.includes(mid)) {
    // If mid is null the section has been already disabled.
    // If mid is a current enabled track, we don't disable it.
    return section;
  }
  return SDPHelpers.getDisabledSectionForMid(mid);
});
SDPHelpers.getEnabledTracks = sdpLines => {
  const bundleLine = SDPHelpers.getBundleLine(sdpLines);

  // Extract the list of tracks
  // So that 'a=group:BUNDLE 0a 1v 2a 3v', returns [0a, 1v, 2a, 3v]
  const tracks = bundleLine.match(new RegExp(`^${SDPHelpers.patterns.bundle} (.+)$`))[1];
  return tracks.split(' ');
};
SDPHelpers.getDisabledTracks = (currentTracks, newTracks) =>
// Get tracks that were present in previous SDP but not in the new SDP
currentTracks.filter(track => !newTracks.includes(track));
SDPHelpers.getTrackSection = (sdpLines, mid) => {
  const midIndex = sdpLines.findIndex(line => line.includes(`a=mid:${mid}`));

  // Recall that tracks are prefixed with integers
  // (e.g., 0a, 1a, for audio; and 2v, 3v for video)
  const mediaType = mid.includes('a') ? 'audio' : 'video';

  // e.g. m=audio 41511 RTP/SAVPF 111
  const trackStartIndex = SDPHelpers.getLastIndexPriorTo(sdpLines, `m=${mediaType}`, midIndex);
  // Find the next track start index
  const trackEndIndex = SDPHelpers.getIndexStartingWith(sdpLines, ['m=audio', 'm=video'], midIndex);
  const sectionSdp = sdpLines.slice(trackStartIndex, trackEndIndex);
  return {
    mid,
    sdp: sectionSdp
  };
};
SDPHelpers.getHeaders = sdpLines => {
  // Headers consist of SDP lines from the beginning to the first track section
  const indexFirstTrack = sdpLines.findIndex(line => line.includes('m=audio') || line.includes('m=video'));
  return sdpLines.slice(0, indexFirstTrack);
};
SDPHelpers.getSDPLines = sdp => sdp.split('\r\n')
// Remove empty strings, if any
.filter(line => line);
SDPHelpers.getTrackMids = sdpLines => {
  const midPrefix = 'a=mid:';
  const midLines = sdpLines.filter(line => line.match(new RegExp(`^${midPrefix}\\d+`)));
  return midLines.map(line => line.substring(midPrefix.length));
};
SDPHelpers.getTrackSections = sdpLines => {
  const mids = SDPHelpers.getTrackMids(sdpLines);
  return mids.map(mid => SDPHelpers.getTrackSection(sdpLines, mid));
};
SDPHelpers.parseMantisSDP = sdp => {
  // Mantis may set role to actpass, which can be incorrect. We play safe and set it to passive.
  const mungedSDP = SDPHelpers.changeSetupRole(sdp, 'actpass', 'passive');
  return SDPHelpers.parseSDP(mungedSDP);
};
SDPHelpers.isMediaSectionDisabled = mediaSection => {
  const _SDPHelpers$parseMLin2 = SDPHelpers.parseMLine(mediaSection[0]),
    port = _SDPHelpers$parseMLin2.port;
  return parseInt(port, 10) === 0;
};
SDPHelpers.getSectionMid = mediaSection => {
  if (SDPHelpers.isMediaSectionDisabled(mediaSection)) {
    return null;
  }
  return SDPHelpers.getTrackMids(mediaSection)[0];
};
SDPHelpers.parseSDP = sdp => {
  const _SDPHelpers$getLinesP = SDPHelpers.getLinesPerSection(sdp),
    headers = _SDPHelpers$getLinesP[0],
    sections = _SDPHelpers$getLinesP.slice(1);
  const parsedSdp = {
    bundle: SDPHelpers.getBundleLine(headers),
    version: SDPHelpers.getVersion(headers),
    iceCredentials: SDPHelpers.getIceCredentials(headers),
    tracks: SDPHelpers.getEnabledTracks(headers),
    mediaSections: sections,
    mids: sections.map(SDPHelpers.getSectionMid),
    headers
  };
  return parsedSdp;
};
SDPHelpers.createSDP = (headers, trackSections) => {
  const sdp = [...headers];
  trackSections.forEach(section => sdp.push(...section));
  // Add empty line to the end of the SDP
  sdp.push('');
  return sdp.join('\r\n');
};
SDPHelpers.removePayloadTypeFromSection = (trackSection, payloadType) => trackSection.filter(line => !line.includes(`a=rtpmap:${payloadType} `) && !line.includes(`a=fmtp:${payloadType} `) && !line.includes(`a=rtcp-fb:${payloadType} `));
SDPHelpers.getRtxPayloadType = (trackSection, payloadType) => {
  const rtxPayloadLine = trackSection.filter(line => line.includes(`apt=${payloadType}`))[0];
  const rtxPayloadType = rtxPayloadLine == null ? void 0 : rtxPayloadLine.match(/^a=fmtp:(\d+) /)[1];
  return rtxPayloadType;
};
SDPHelpers.removeRtxPayloadTypeFromSection = (trackSection, payloadType) => {
  let trimmedSection = [...trackSection];
  // We look for rtx payload type associated with the current payload type, e.g.:
  // a=fmtp:97 apt=96;rtx-time=3000
  // We should get payload type 97 which is the rtx associated to payload type 96
  const rtxPayloadType = SDPHelpers.getRtxPayloadType(trimmedSection, payloadType);
  if (rtxPayloadType) {
    trimmedSection = SDPHelpers.removePayloadTypeFromSection(trimmedSection, rtxPayloadType);
  }
  return trimmedSection;
};
SDPHelpers.trimUnusedCodecs = (trackSection, usedCodecs) => {
  // Payload types are in the first line of the section, e.g.:
  // m=audio 41511 RTP/SAVPF 111 8 106 105
  // being the payload types: 111 8 106 105
  const currentPayloadLine = trackSection[0].split(' ');
  const payloadTypes = currentPayloadLine.slice(3);
  // We save m=audio 41511 RTP/SAVPF to build the line above
  const payloadLinePrefix = currentPayloadLine.slice(0, 3);
  const newCodecs = SDPHelpers.getCodecsFromSection(trackSection);
  let trimmedSection = [...trackSection];
  let trimmedPayloads = [];
  payloadTypes.forEach(payloadType => {
    const codecName = newCodecs.codecMap[payloadType];
    if (!usedCodecs.includes(codecName)) {
      // Remove all codecs associated lines since this is not used
      trimmedSection = SDPHelpers.removePayloadTypeFromSection(trimmedSection, payloadType);
      // Remove rtx payload type associated if needed
      trimmedSection = SDPHelpers.removeRtxPayloadTypeFromSection(trimmedSection, payloadType);
    } else {
      // This payload type has been used before so we keep it
      trimmedPayloads.push(payloadType);
      const rtxPayloadType = SDPHelpers.getRtxPayloadType(trimmedSection, payloadType);
      if (rtxPayloadType) {
        trimmedPayloads.push(rtxPayloadType);
      }
    }
  });

  // If we are trimming a section previously zeroed by Mantis, this won't have any payload, thus
  // we need to add a 0 payload, because negotiation expects to have at least one.
  const trimmedPayloadsLine = trimmedPayloads.length ? trimmedPayloads : [0];
  // Replace the mLine with its proper payload types
  trimmedSection[0] = [...payloadLinePrefix, ...trimmedPayloadsLine].join(' ');
  return trimmedSection;
};
SDPHelpers.removeUnusedCodecs = (newOffer, previousOffer) => {
  if (!previousOffer) {
    return newOffer;
  }
  const _SDPHelpers$parseSDP = SDPHelpers.parseSDP(newOffer),
    headers = _SDPHelpers$parseSDP.headers,
    mediaSections = _SDPHelpers$parseSDP.mediaSections;
  const previousSdp = SDPHelpers.parseSDP(previousOffer);
  const previousMids = previousSdp.mids;
  const previousMediaSections = previousSdp.mediaSections;

  // We only want to keep using the already used codecs
  const trimmedMediaSections = mediaSections.map(mediaSection => {
    const previousIndex = previousMids.findIndex(mid => mid === SDPHelpers.getTrackMids(mediaSection)[0]);
    if (previousIndex < 0) {
      return mediaSection;
    }
    // Array with all the codecs used for this track
    const usedCodecs = Object.values(SDPHelpers.getCodecsFromSection(previousMediaSections[previousIndex]).codecMap);
    // Filter out all the codecs added by the browser
    return SDPHelpers.trimUnusedCodecs(mediaSection, usedCodecs);
  });

  // Build munged offer with all the unused codecs removed
  // Offer is based on headers, track sections and an empty end line
  const trimmedOffer = [...headers];
  trimmedMediaSections.forEach(section => trimmedOffer.push(...section));
  // New line
  trimmedOffer.push('');
  return trimmedOffer.join('\r\n');
};
SDPHelpers.updateSDPWithNewOffer = (previousSdp, newSdp) => {
  const headers = previousSdp.headers,
    version = previousSdp.version,
    mediaSections = previousSdp.mediaSections;
  const sdpLines = SDPHelpers.getSDPLines(newSdp);
  const newVersion = SDPHelpers.getVersion(sdpLines);
  const tracks = SDPHelpers.getEnabledTracks(sdpLines);
  const sdp = {
    version: newVersion,
    tracks,
    headers: SDPHelpers.updateBundleLine(SDPHelpers.updateVersion(headers, version, newVersion), tracks),
    mediaSections: SDPHelpers.disableTrackSections(tracks, mediaSections)
  };
  sdp.mids = sdp.mediaSections.map(SDPHelpers.getSectionMid);
  return sdp;
};
SDPHelpers.isUfragLine = line => line.includes(SDPHelpers.iceCredentials.ufrag);
SDPHelpers.isPwdLine = line => line.includes(SDPHelpers.iceCredentials.pwd);

/**
 * Get ice credentials
 * @param {Array<string>} sdpLines - An array of SDP lines.
 *   Example:
 *   [
 *     ['m=audio 52265 RTP/SAVPF 98', 'c=IN IP4 54.197.248.203', ...etc],
 *     ['m=video 52265 RTP/SAVPF 97', 'c=IN IP4 54.197.248.203', ...etc]
 *   ]
 * @returns {Object} An object containing the credentials of the SDP.
 *   @property {string} ufrag - The username fragment.
 *   @property {string} pwd - The password.
 */
SDPHelpers.getIceCredentials = sdpLines => {
  const credentials = {};
  sdpLines.forEach(line => {
    if (SDPHelpers.isUfragLine(line)) {
      credentials.ufrag = line;
    } else if (SDPHelpers.isPwdLine(line)) {
      credentials.pwd = line;
    }
  });
  return credentials;
};

/**
 * Update ice credentials in one SDP with new credentials.
 * @param {Array<string>} currentSdpLines - An array of SDP lines that need to be updated with new credentials.
 * @param {Object} iceCredentials - The iceCredentials object.
 * @property {string} ufrag - A string representing the ufrag line in the ICE credentials, e.g. 'a=ice-ufrag:myUFrag'
 * @property {string} pwd - A string representing the password line in the ICE credentials, e.g. 'a=ice-pwd:myPwd'
 * @returns {Array<string>} - An array of updated SDP lines with the new credentials.
 */
SDPHelpers.updateIceCredentials = (currentSdpLines, credentials) => currentSdpLines.map(line => {
  if (SDPHelpers.isUfragLine(line)) {
    return credentials.ufrag;
  } else if (SDPHelpers.isPwdLine(line)) {
    return credentials.pwd;
  }
  return line;
});

/**
 * Add ice credentials in the media section.
 * @param {Array<string>} mediaSection - An array of SDP lines that need to be updated with credentials.
 * @param {Object} iceCredentials - The iceCredentials object.
 * @property {string} ufrag - A string representing the ufrag line in the ICE credentials, e.g. 'a=ice-ufrag:myUFrag'
 * @property {string} pwd - A string representing the password line in the ICE credentials, e.g. 'a=ice-pwd:myPwd'
 * @returns {Array<string>} - An array of updated SDP lines with the new credentials.
 */
SDPHelpers.addIceCredentialsToSection = (mediaSection, _ref3) => {
  let ufrag = _ref3.ufrag,
    pwd = _ref3.pwd;
  const mediaSectionWithCredentials = [...mediaSection];
  const midPrefix = 'a=mid:';
  const midLineIndex = mediaSectionWithCredentials.findIndex(line => line.startsWith(midPrefix));
  if (midLineIndex >= 0) {
    mediaSectionWithCredentials.splice(midLineIndex, 0, ufrag, pwd);
  }
  return mediaSectionWithCredentials;
};

/**
 * Add ice candidates in the media section.
 * @param {Array<string>} mediaSection - An array of SDP lines that need to be updated with candidates.
 * @param {Array<string>} headers - An array of SDP lines with the headers
 * @returns {Array<string>} - An array of updated SDP lines with the new candidates.
 */
SDPHelpers.addIceCandidatesToSection = (mediaSection, headers) => {
  const mediaSectionWithCredentials = [...mediaSection];
  const candidatePrefix = 'a=candidate:';
  const endCandidate = 'a=end-of-candidates';
  const candidateLines = headers.filter(line => line.startsWith(candidatePrefix) || line === endCandidate);
  const midPrefix = 'a=mid:';
  const midLineIndex = mediaSectionWithCredentials.findIndex(line => line.startsWith(midPrefix));
  if (midLineIndex >= 0 && candidateLines.length) {
    mediaSectionWithCredentials.splice(midLineIndex, 0, ...candidateLines);
  }
  return mediaSectionWithCredentials;
};

/**
 * Add ice config (credentials and candidates) in the first media section.
 * @param {Array<string>} mediaSections - An array of SDP lines that need to be updated with config.
 * @param {Array<string>} headers - An array of SDP lines with the headers.
 * @param {Object} iceCredentials - The iceCredentials object.
 * @property {string} ufrag - A string representing the ufrag line in the ICE credentials, e.g. 'a=ice-ufrag:myUFrag'
 * @property {string} pwd - A string representing the password line in the ICE credentials, e.g. 'a=ice-pwd:myPwd'
 * @returns {Array<string>} - An array of updated SDP lines with the new config.
 */
SDPHelpers.addIceConfig = (mediaSections, headers, iceCredentials) => {
  const mediaSectionsWithCredentials = [...mediaSections];
  const firstSection = mediaSections[0];
  const _SDPHelpers$getIceCre = SDPHelpers.getIceCredentials(firstSection),
    ufrag = _SDPHelpers$getIceCre.ufrag;
  // If there are no credentials in the first media section, we need to add them
  if (!ufrag) {
    const sectionWithIceCredentials = SDPHelpers.addIceCredentialsToSection(firstSection, iceCredentials);
    mediaSectionsWithCredentials[0] = SDPHelpers.addIceCandidatesToSection(sectionWithIceCredentials, headers);
  }
  return mediaSectionsWithCredentials;
};

/**
 * Update headers in a partial SDP.
 * @param {Object} currentSdp - An object with the current parsed SDP set in the PC.
 * @property {Array<string>} headers - An array of SDP lines that represent the headers.
 * @property {string} version - A string representing the SDP version.
 * @param {Object} partialSdp - An object with the new partial SDP sent by Mantis.
 * @property {Object} iceCredentials - The iceCredentials object.
 * @property {string} ufrag - A string representing the ufrag in the ICE credentials.
 * @property {string} pwd - A string representing the password in the ICECredentials.
 * @property {string} version - A string representing the SDP version.
 * @param {Array<string>} - An array with the tracks present in the SDP.
 * @returns {Array<string>} - An array of updated headers lines.
 */
SDPHelpers.updateHeadersInPartialSdp = (currentSdp, partialSdp, tracks) => {
  if (!currentSdp.headers.length) {
    // If there is no currentSdp, we don't need to update the headers, we just make sure we don't
    // have more tracks in the bundle than it should.
    return SDPHelpers.updateBundleLine(partialSdp.headers, tracks);
  }
  // Update headers with the new bundle line.
  let headers = SDPHelpers.updateBundleLine(currentSdp.headers, tracks);
  // Update headers with the new version.
  headers = SDPHelpers.updateVersion(headers, currentSdp.version, partialSdp.version);
  // In case there is a mismatch between our cached credentials and the ones Mantis sends, we
  // update the cached credentials with the new ones.
  if (currentSdp.iceCredentials.ufrag !== partialSdp.iceCredentials.ufrag) {
    headers = SDPHelpers.updateIceCredentials(headers, partialSdp.iceCredentials);
  }
  return headers;
};

/**
 * Update the first enabled media section in the current Session Description Protocol (SDP)
 * with the ICECredentials.
 *
 * This function takes a SDP `currentSdp` and ICECredentials object `iceCredentials`, and updates the
 * first enabled media section in `currentSdp` with the `iceCredentials`. The term "enabled" is determined
 * by the presence of a valid Media ID (MID) in the SDP.
 *
 * @param {Object} currentSdp - The current SDP object.
 * @property {Array<Array<string>>} mediaSections - An array representing the media sections in the SDP.
 * @property {Array<string>} mids - An array of Media IDs (MIDs) indicating the enabled media sections.
 *
 * @param {Object} iceCredentials - The iceCredentials object.
 * @property {string} ufrag - A string representing the ufrag in the ICE credentials.
 * @property {string} pwd - A string representing the password in the ICECredentials.
 *
 * @returns {Array<Object>} An array of updated media sections from the current SDP with the first
 *                         enabled section replaced by the corresponding section from the new SDP.
 */
SDPHelpers.updateFirstEnabledMediaSection = (currentSdp, iceCredentials) => {
  const mediaSections = [...currentSdp.mediaSections];
  const currentFirstEnabledSectionIndex = currentSdp.mids.findIndex(mid => mid !== null);
  if (currentFirstEnabledSectionIndex >= 0) {
    mediaSections[currentFirstEnabledSectionIndex] = SDPHelpers.updateIceCredentials(mediaSections[currentFirstEnabledSectionIndex], iceCredentials);
  }
  return mediaSections;
};
var _default = SDPHelpers;
exports.default = _default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isObject = __webpack_require__(11);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _env = _interopRequireDefault(__webpack_require__(3));
var _currentAudioOutputDevice = _interopRequireDefault(__webpack_require__(107));
var _getNativeEnumerateDevices = _interopRequireDefault(__webpack_require__(260));
var _getNativeMediaDevices = _interopRequireDefault(__webpack_require__(567));
var _currentAudioInputDevice = _interopRequireDefault(__webpack_require__(261));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable global-require */

const deviceHelpersFactory = function deviceHelpersFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const getNativeEnumerateDevices = deps.getNativeEnumerateDevices || (0, _getNativeEnumerateDevices.default)();
  const getNativeMediaDevices = deps.getNativeMediaDevices || (0, _getNativeMediaDevices.default)();
  const _ref = deps.currentAudioOutputDevice || _currentAudioOutputDevice.default,
    getCurrentAudioOutputDeviceId = _ref.getCurrentAudioOutputDeviceId;
  const _ref2 = deps.currentAudioInputDevice || _currentAudioInputDevice.default,
    getCurrentAudioInputDevice = _ref2.getCurrentAudioInputDevice;
  const env = deps.env || _env.default;
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  const deviceHelpers = {};

  // /
  // Device Helpers
  //
  // Support functions to enumerating and querying device info
  //

  const deviceKindsMap = {
    audio: 'audioInput',
    video: 'videoInput',
    audioinput: 'audioInput',
    videoinput: 'videoInput',
    audiooutput: 'audioOutput',
    audioInput: 'audioInput',
    videoInput: 'videoInput',
    audioOutput: 'audioOutput'
  };
  const enumerateDevices = () => {
    // Our mocking currently requires that this be re-evaluated each time.
    const fn = getNativeEnumerateDevices();
    return fn();
  };
  deviceHelpers.getNativeMediaDevices = () => getNativeMediaDevices();

  // Indicates whether this browser supports the enumerateDevices (getSources) API.
  //
  deviceHelpers.hasEnumerateDevicesCapability = () => typeof getNativeEnumerateDevices() === 'function';
  deviceHelpers.hasDeviceChangeCapability = () => {
    const mediaDevices = getNativeMediaDevices();
    return !!(mediaDevices && 'ondevicechange' in mediaDevices);
  };
  deviceHelpers.hasSetSinkIdCapability = () => 'setSinkId' in (windowMock == null ? void 0 : windowMock.HTMLMediaElement.prototype);
  deviceHelpers.hasAudioOutputApiSupport = () => {
    const _deps = deps,
      _deps$hasSetSinkIdCap = _deps.hasSetSinkIdCapability,
      hasSetSinkIdCapability = _deps$hasSetSinkIdCap === void 0 ? deviceHelpers.hasSetSinkIdCapability : _deps$hasSetSinkIdCap;
    const _deps2 = deps,
      _deps2$hasDeviceChang = _deps2.hasDeviceChangeCapability,
      hasDeviceChangeCapability = _deps2$hasDeviceChang === void 0 ? deviceHelpers.hasDeviceChangeCapability : _deps2$hasDeviceChang;

    // See https://jira.vonage.com/browse/VIDCS-811
    // Even though modern FF supports Audio Output API, we disable since
    // our integration tests are failing.
    return !(env != null && env.isFirefox) && hasSetSinkIdCapability() && hasDeviceChangeCapability();
  };

  // OPENTOK-40733, see https://bugs.webkit.org/show_bug.cgi?id=209739#c2
  // multiple calls to enumerateDevices fail to return video devices
  // note that this causes any devices without a camera (mac minis) to make a video gum call
  // we believe this is worth it to prevent safari video breaking
  deviceHelpers.hasEnumerateDevicesBug = () => env.isSafari && env.version === 13.1;
  deviceHelpers.getMediaDevices = () => {
    if (!deviceHelpers.hasEnumerateDevicesCapability()) {
      return Promise.reject(new Error('This browser does not support enumerateDevices APIs'));
    }
    return enumerateDevices().then(devices =>
    // Normalise the device kinds
    devices.map(device => ({
      deviceId: device.deviceId || device.id,
      label: device.label,
      kind: deviceKindsMap[device.kind]
    })));
  };
  deviceHelpers.getInputMediaDevices = () => deviceHelpers.getMediaDevices().then(devices => devices.filter(device => /^(audio|video)Input$/.test(device.kind)));
  deviceHelpers.getAudioOutputMediaDevices = () => deviceHelpers.getMediaDevices().then(devices => devices.filter(device => device.kind === 'audioOutput').map(_ref3 => {
    let deviceId = _ref3.deviceId,
      label = _ref3.label;
    return {
      deviceId,
      label
    };
  }));
  deviceHelpers.getAudioInputMediaDevices = () => deviceHelpers.getMediaDevices().then(devices => devices.filter(device => device.kind === 'audioInput').map(_ref4 => {
    let deviceId = _ref4.deviceId,
      label = _ref4.label;
    return {
      deviceId,
      label
    };
  }));
  deviceHelpers.shouldAskForDevices = () => {
    if (!deviceHelpers.hasEnumerateDevicesCapability()) {
      // Assume video and audio exists if enumerateDevices is not available
      return Promise.resolve({
        video: true,
        audio: true
      });
    }
    return deviceHelpers.getInputMediaDevices().then(devices => {
      if (devices.length === 0) {
        // If no devices reported, might as well try anyway, maybe it was just an issue with
        // device enumeration.
        return {
          video: true,
          audio: true
        };
      }
      const audioDevices = devices.filter(device => device.kind === 'audioInput');
      const videoDevices = devices.filter(device => device.kind === 'videoInput');
      if (deviceHelpers.hasEnumerateDevicesBug() && videoDevices.length === 0) {
        return {
          audio: true,
          video: true
        };
      }
      return {
        video: videoDevices.length > 0,
        audio: audioDevices.length > 0,
        videoDevices,
        audioDevices
      };
    }).catch(() => (
    // There was an error. It may be temporally. Just assume
    // all devices exist for now.
    {
      video: true,
      audio: true
    }));
  };
  deviceHelpers.getDefaultAudioOutputDeviceId = devices => {
    if (!Array.isArray(devices) || devices.length === 0) {
      return '';
    }
    const _ref5 = devices.find(device => device.deviceId === 'default') || devices[0],
      deviceId = _ref5.deviceId;
    return deviceId;
  };
  deviceHelpers.getDefaultAudioInputDevice = devices => {
    if (!Array.isArray(devices) || devices.length === 0) {
      return '';
    }
    return devices.find(device => device.deviceId === 'default') || devices[0];
  };
  deviceHelpers.hasDevice = (devicesList, deviceId) => {
    let devices = devicesList;
    if (!Array.isArray(devices)) {
      devices = [];
    }
    return devices.some(device => device.deviceId === deviceId);
  };
  deviceHelpers.getActiveAudioInputDevice = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var devices, currentDevice, defaultDevice;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return deviceHelpers.getAudioInputMediaDevices();
        case 2:
          devices = _context.sent;
          if (!(devices.length === 0)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", {
            deviceId: null,
            label: null
          });
        case 5:
          currentDevice = getCurrentAudioInputDevice();
          if (!currentDevice) {
            defaultDevice = deviceHelpers.getDefaultAudioInputDevice(devices);
            currentDevice = devices.find(device => device === defaultDevice);
          }
          return _context.abrupt("return", currentDevice);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  deviceHelpers.getActiveAudioOutputDevice = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var devices, currentDevice, defaultDeviceId;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return deviceHelpers.getAudioOutputMediaDevices();
        case 3:
          devices = _context2.sent;
          _context2.next = 9;
          break;
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](0);
          throw _context2.t0;
        case 9:
          if (!(devices.length === 0)) {
            _context2.next = 11;
            break;
          }
          return _context2.abrupt("return", {
            deviceId: null,
            label: null
          });
        case 11:
          // Let's find the current output device object in the list.
          currentDevice = devices.find(device => device.deviceId === getCurrentAudioOutputDeviceId());
          if (!currentDevice) {
            // The current audio output device is not in the list, let's return the default device instead
            defaultDeviceId = deviceHelpers.getDefaultAudioOutputDeviceId(devices);
            currentDevice = devices.find(device => device.deviceId === defaultDeviceId);
          }
          return _context2.abrupt("return", currentDevice);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return deviceHelpers;
};
var _default = deviceHelpersFactory;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 23 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 25 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _events = _interopRequireDefault(__webpack_require__(18));
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _errorCodeToErrorTitleMap = _interopRequireDefault(__webpack_require__(581));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

const logging = (0, _log.default)('GlobalExceptionHandler');
const Events = (0, _events.default)();

/**
 * The Error class is used to define the error object passed into completion handlers.
 * Each of the following methods, which execute asynchronously, includes a
 * <code>completionHandler</code> parameter:
 *
 * <ul>
 *   <li><a href="OT.html#initPublisher">OT.initPublisher()</a></li>
 *   <li><a href="OT.html#reportIssue">OT.reportIssue()</a></li>
 *   <li><a href="OT.html#setProxyUrl">OT.setProxyUrl()</a></li>
 *   <li><a href="Publisher.html#setVideoSource">Publisher.setVideoSource()</a></li>
 *   <li><a href="Session.html#connect">Session.connect()</a></li>
 *   <li><a href="Session.html#forceDisconnect">Session.forceDisconnect()</a></li>
 *   <li><a href="Session.html#forceUnpublish">Session.forceUnpublish()</a></li>
 *   <li><a href="Session.html#publish">Session.publish()</a></li>
 *   <li><a href="Session.html#subscribe">Session.subscribe()</a></li>
 *   <li><a href="Subscriber.html#getStats">Subscriber.getStats()</a></li>
 * </ul>
 *
 * <p>
 * The Error class also defines the Error thrown when the promise returned by one of
 * the following methods is rejected:
 *
 * <ul>
 *   <li><a href="OT.html#unblockAudio">OT.unblockAudio()</a></li>
 *   <li><a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a></li>
 *   <li><a href="Publisher.html#clearVideoFilter">Publisher.clearVideoFilter()</a></li>
 *   <li><a href="Publisher.html#applyAudioFilter">Publisher.applyAudioFilter()</a></li>
 *   <li><a href="Publisher.html#clearAudioFilter">Publisher.clearAudioFilter()</a></li>
 *   <li><a href="Publisher.html#getRtcStatsReport">Publisher.getRtcStatsReport()</a></li>
 *   <li><a href="Session.html#forceMuteAll">Session.forceMuteAll()</a></li>
 *   <li><a href="Session.html#forceMuteStream">Session.forceMuteStream()</a></li>
 *   <li><a href="Session.html#setEncryptionSecret">Session.setEncryptionSecret()</a><li>
 *   <li><a href="Subscriber.html#getRtcStatsReport">Subscriber.getRtcStatsReport()</a></li>
 * </ul>
 *
 * <p>
 * The <code>completionHandler</code> parameter is a function that is called when the call to
 * the asynchronous method succeeds or fails. If the asynchronous call fails, the completion
 * handler function is passed an error object (defined by the Error class). The <code>code</code>
 * and <code>message</code> properties of the error object provide details about the error.
 *
 * <p>
 * <b>Deprecation notice:</b>
 * <code>OT.Error</code> will not be defined in an upcoming version of Vonage Video API. When this happens,
 * errors emitted by the SDK will simply be instances of standard <code>Error</code> objects.
 * If your code currently checks <code>if (error instanceof OT.Error)</code> please replace it
 * <code>if (/^OT_/.test(error.name))</code>. (The <code>name</code> property for all Vonage Video API
 * errors with begins with <code>'OT_'</code>.) Note however that this code is for the
 * purposes of smoothly upgrading, and it may be more appropriate for your code to simply compare
 * against the specific error you want to handle, such as
 * <code>if (error.name === 'OT_USER_MEDIA_ACCESS_DENIED')</code>.
 *
 * @property {Number} code Deprecated &mdash; the error code. Use the <code>name</code> property,
 * not the <code>code</code> property, to identify the error programatically.
 *
 * <p>
 *   The <code>code</code> property of the Error object can be set to one of the values
 *   listed below. This property can also be set to other values, and you may want to report
 *   this value when discussing an issue with Vonage API support.
 * </p>
 *
 * <p>Errors when calling <code>Session.connect()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1004</td>
 *   <td>Authentication error. Check the error message for details. This error can result if you
 *     pass in an expired token when trying to connect to a session. It can also occur if you pass
 *     in an invalid token or API key. Make sure that you are generating the token using the
 *     current version of one of the
 *     <a href="https://tokbox.com/developer/sdks/server/">Vonage Video API server SDKs</a>.</td>
 * </tr>
 * <tr>
 *   <td>1005</td>
 *   <td>Invalid Session ID. Make sure you generate the session ID using the current version of
 *     one of the <a href="https://tokbox.com/developer/sdks/server/">Vonage Video API server
 *     SDKs</a>.</td>
 * </tr>
 * <tr>
 *   <td>1006</td>
 *   <td>Connect Failed. Unable to connect to the session. You may want to have the client check
 *     the network connection.</td>
 * </tr>
 * <tr>
 *  <td>1026</td>
 *  <td>Terms of service violation: export compliance. See the
 *    <a href="https://www.vonage.com/legal/communications-apis/terms-of-use/">Terms of Service</a>.</td>
 * </tr>
 * <tr>
 *  <td>1027</td>
 *  <td>Connection limit exceeded. The client tried to connect to a session that has exceeded
 *  limit for simultaneous connections.</td>
 * </tr>
 * <tr>
 *   <td>2001</td>
 *   <td>Connect Failed. Unexpected response from the Vonage Video API server. Try connecting again
 *     later.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors after calling <code>Session.connect()</code>:</p>
 * <table class="docs_table"><tbody>
 *   <tr>
 *     <td><b><code>code</code></b></td>
 *     <td><b>Description</b></td>
 *   </tr>
 *   <tr>
 *     <td>3001 - 3007</td>
 *     <td>Please check error name OT_HTTP_ERROR.</td>
 *   </tr>
 *   <tr>
 *     <td>4020</td>
 *     <td>Session disconnected. It seems internet connection went down.</td>
 *   </tr>
 * </tbody></table>
 * <p>Errors when calling <code>Session.forceDisconnect()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b>
 *       <code>code</code>
 *     </b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1010</td>
 *   <td>The client is not connected to the Vonage Video API session. Check that client connects
 *     successfully and has not disconnected before calling forceDisconnect().</td>
 * </tr>
 * <tr>
 *   <td>1520</td>
 *   <td>Unable to force disconnect. The client's token does not have the role set to moderator.
 *     Once the client has connected to the session, the <code>capabilities</code> property of
 *     the Session object lists the client's capabilities.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Session.forceUnpublish()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1010</td>
 *   <td>The client is not connected to the Vonage Video API session. Check that client connects
 *     successfully and has not disconnected before calling forceUnpublish().</td>
 * </tr>
 * <tr>
 *   <td>1530</td>
 *   <td>Unable to force unpublish. The client's token does not have the role set to moderator.
 *     Once the client has connected to the session, the <code>capabilities</code> property of
 *     the Session object lists the client's capabilities.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Session.publish()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1010</td>
 *   <td>The client is not connected to the Vonage Video API session. Check that the client connects
 *     successfully before trying to publish. And check that the client has not disconnected
 *     before trying to publish.</td>
 * </tr>
 * <tr>
 *   <td>1500</td>
 *   <td>Unable to Publish. This can be caused by the following:
 *
 *   <ul>
 *     <li>The client's token does not have the role set to publish or
 *     moderator. Once the client has connected to the session, the <code>capabilities</code>
 *     property of the Session object lists the client's capabilities.</li>
 *
 *     <li>The end-user has denied access to the camera or microphone.</li>
 *
 *     <li>The page is loaded on HTTP in Chrome, which requires HTTPS to access the camera and
 *     microphone.</li>
 *   </ul>
 * </td>
 * </tr>
 * <tr>
 *   <td>1553</td>
 *   <td>WebRTC ICE workflow error. This is an error that occurs when trying to establish
 *   communication between clients in the session. Try publishing again or reconnecting to
 *   the session.</td>
 * </tr>
 * <tr>
 *   <td>2001</td>
 *   <td>Publish Failed. Unexpected response from the Vonage Video API server. Try publishing again
 *     later.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Session.signal()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *     <td>400</td>
 *     <td>One of the signal properties &mdash; data, type, or to &mdash;
 *                 is invalid. Or the data cannot be parsed as JSON.</td>
 * </tr>
 * <tr>
 *   <td>404</td> <td>The to connection does not exist.</td>
 * </tr>
 * <tr>
 *   <td>413</td> <td>The type string exceeds the maximum length (128 bytes),
 *     or the data string exceeds the maximum size (8 kB).</td>
 * </tr>
 * <tr>
 *   <td>500</td>
 *   <td>The client is not connected to the Vonage Video API session. Check that the client connects
 *     successfully before trying to signal. And check that the client has not disconnected before
 *     trying to signal.</td>
 * </tr>
 * <tr>
 *   <td>2001</td>
 *   <td>Signal Failed. Unexpected response from the Vonage Video API server. Try sending the signal again
 *     later.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Session.subscribe()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b>
 *       <code>code</code>
 *     </b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *  <td>0009</td>
 *  <td>Media source not supported.</td>
 * </tr>
 * <tr>
 *   <td>0011</td>
 *   <td>Error decoding.</td>
 * </tr>
 * <tr>
 *   <td>1013</td>
 *   <td>WebRTC PeerConnection error. Try republishing the stream,
 *     resubscribing to the stream, or reconnecting to the session.</td>
 * </tr>
 * <tr>
 *  <td>1501</td>
 *  <td>Unable to subscribe to stream in a reasonable amount of time.</td>
 * </tr>
 * <tr>
 *  <td>1502</td>
 *  <td>Video format not supported in this browser.</td>
 * </tr>
 * <tr>
 *   <td>1554</td>
 *   <td>WebRTC ICE workflow error. This is an error that occurs when trying to establish
 *   communication between clients in the session. Try resubscribing to the stream or
 *   reconnecting to the session.</td>
 * </tr>
 * <tr>
 *   <td>1600</td>
 *   <td>Internal error -- WebRTC subscriber error. Try resubscribing to the stream or
 *     reconnecting to the session.</td>
 * </tr>
 * <tr>
 *  <td>1605</td>
 *  <td>Stream limit exceeded. The client tried to subscribe to a stream in a session
 *  that has exceeded the limit for simultaneous streams.</td>
 * </tr>
 * <tr>
 *   <td>2001</td>
 *   <td>Subscribe Failed. Unexpected response from the Vonage Video API server. Try subscribing again
 *     later.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>OT.initPublisher()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1004</td>
 *   <td>Authentication error. Check the error message for details. This error can result if you
 *     pass in an expired token when trying to connect to a session. It can also occur if you
 *     pass in an invalid token or API key. Make sure that you are generating the token using
 *     the current version of one of the
 *     <a href="https://tokbox.com/developer/sdks/server/">Vonage Video API server SDKs</a>.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>OT.reportIssue()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>2011</td>
 *   <td>Error calling OT.reportIssue(). Check the client's network connection.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>OT.setProxyUrl()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>
 *     2021
 *   </td>
 *   <td>
 *     Attempt to set the proxy URL after initiating a Session or Publisher object.
 *  </td>
 * </tr>
 * <tr>
 *   <td>
 *     2022
 *   </td>
 *   <td>
 *     Attempt to set the proxy URL after it has already been set (by a previous
 *     call to <code>OT.setProxyUrl()</code>).
 *  </td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Publisher.setVideoSource()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>
 *     1040
 *   </td>
 *   <td>
 *    Trying to change the video source for a publisher does not use a camera input.
 *  </td>
 * </tr>
 * <tr>
 *   <td>
 *     1041
 *   </td>
 *   <td>
 *    The <code>videoSourceId</code> parameter is not a string
 *    or the device ID for a valid video input device.
 *  </td>
 * </tr>
 * </tbody></table>
 *
 * <p>General errors that can occur when calling any method:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1011</td>
 *   <td>Invalid Parameter. Check that you have passed valid parameter values into the method
 *     call.</td>
 * </tr>
 * <tr>
 *   <td>2000</td>
 *   <td>Internal Error. Try reconnecting to the Vonage Video API session and trying the action again.</td>
 * </tr>
 * </tbody></table>
 *
 * @property {String} message The message string provides details about the error.
 *
 * <p>
 * Use the <code>name</code> property (not the <code>message</code> property) to identify the error
 * programatically.
 *
 * @property {String} name A string identifying the error. Use this property (not the
 * <code>code</code> property) to identify the error.
 *
 * <p>Note that for all errors, this string starts with <code>'OT_'</code>.
 *
 * <p>
 *   The <code>name</code> property of the Error object can be set to one of the values
 *   listed below. For unexpected errors, this property can be undefined or set to other
 *   values. You may want to report this value when discussing an issue with Vonage API support.
 * </p>
 *
 * <p>Errors that can occur when calling <code>OT.initPublisher()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_HARDWARE_UNAVAILABLE'</code></td>
 *   <td>The hardware to fulfill the user media request appears to exist but could not be acquired.
 *   It might be in use by another application.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *  <td><code>'OT_MEDIA_ENDED'</code></td>
 *  <td>The ended event on the video element fired.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_ABORTED'</code></td>
 *   <td>The fetching of the stream for the video element has been aborted.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_DECODE'</code></td>
 *   <td>A decoding error occurred while trying to play the stream in the video element.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_NETWORK'</code></td>
 *   <td>A network error caused the stream to stop being fetched.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_SRC_NOT_SUPPORTED'</code></td>
 *   <td>The stream has been detected to be not suitable for playback.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_SUPPORTED'</code></td>
 *   <td>Something in the user media request is not supported.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NO_DEVICES_FOUND'</code></td>
 *   <td>No devices were found to provide the media stream.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NO_VALID_CONSTRAINTS'</code></td>
 *   <td>Video and audio were both disabled. You need to enable at least one.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PROXY_URL_ALREADY_SET_ERROR'</code></td>
 *   <td>The proxyUrl has already been set. Setting it again will not have any effect.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_REQUESTED_DEVICE_PERMISSION_DENIED'</code></td>
 *   <td>The requested audio device does not have permissions to be used.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_NOT_SUPPORTED'</code></td>
 *   <td>Screen sharing is not supported in the browser.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNABLE_TO_CAPTURE_SCREEN'</code></td>
 *   <td>Screen sharing is not supported (and you set the <code>videoSource</code> property
 *     of the <code>options</code> parameter of <code>OT.initPublisher()</code> to
 *     <code>"application"</code>, <code>"screen"</code>, or <code>"window"</code>).
 *     Before calling <code>OT.initPublisher()</code>, you can call
 *     <a href="OT.html#checkScreenSharingCapability">OT.checkScreenSharingCapability()</a>
 *     to check if screen sharing is supported.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_EXTENSION_NOT_REGISTERED'</code></td>
 *   <td>Screen-sharing support in this browser requires an extension, but one has not been
 *   registered.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_EXTENSION_NOT_INSTALLED'</code></td>
 *   <td>Screen-sharing support in this browser requires an extension, but the extension is not
 *   installed.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>OT.reportIssue()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_REPORT_ISSUE_FAILED'</code></td>
 *   <td>Error calling OT.reportIssue(). Check the client\'s network connection.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling the <code>OT.setProxyUrl()</code> method:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>
 *     <code>'SET_PROXY_URL_TIMING_ERROR'</code>
 *   </td>
 *   <td>
 *     Attempt to set the proxy URL after initiating a Session or Publisher object.
 *  </td>
 * </tr>
 * <tr>
 *   <td>
 *     <code>'PROXY_URL_ALREADY_SET_ERROR'</code>
 *   </td>
 *   <td>
 *     Attempt to set the proxy URL after it has already been set (by a previous
 *     call to <code>OT.setProxyUrl()</code>).
 *  </td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Publisher.setVideoSource()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_VIDEO_SOURCE'</code></td>
 *   <td>The <code>videoSourceId</code> parameter is not a string
 *   or the device ID for a valid video input device.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SET_VIDEO_SOURCE_FAILURE'</code></td>
 *   <td>Trying to change the video source for a publisher does not use
 *   a camera input.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.connect()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_AUTHENTICATION_ERROR'</code></td>
 *   <td>The API key does not match the token or session.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_BADLY_FORMED_RESPONSE'</code></td>
 *   <td>The JSON response from the Vonage Video API server was badly formed.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CONNECT_FAILED'</code></td>
 *   <td>Failed to connect to session.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CONNECTION_LIMIT_EXCEEDED'</code></td>
 *   <td>The client tried to connect to a session that has exceeded the limit for
 *   simultaneous connections.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_EMPTY_RESPONSE_BODY'</code></td>
 *   <td>Received an unexpected empty response from the Vonage Video API server.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_SESSION_ID'</code></td>
 *   <td>The session ID was invalid.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_TERMS_OF_SERVICE_FAILURE'</code></td>
 *   <td>Couldn't connect due to a terms of service violation.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_HTTP_STATUS'</code></td>
 *   <td>Received an unexpected HTTP status.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_XDOMAIN_OR_PARSING_ERROR'</code></td>
 *   <td>There was a cross domain error or the server responded with invalid JSON.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_ENCRYPTION_SECRET'</code></td>
 *   <td>The encryption secret is invalid.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNSUPPORTED_BROWSER'</code></td>
 *   <td>The browser does not support end-to-end encryption.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.forceDisconnect()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>This token does not allow this action. The role must be at least moderator.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.forceMuteAll()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>This token does not allow this action. The role must be at least moderator.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code></td>
 *   <td>An internal server error.</li>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.forceMuteStream()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_FOUND'</code></td>
 *   <td>The stream ID wasn't found in this session.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>The token does not allow this action. The role must be at least moderator.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code></td>
 *   <td>An internal server error.</li>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.forceUnpublish()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>This token does not allow this action. The role must be at least moderator.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.publish()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CHROME_MICROPHONE_ACQUISITION_ERROR'</code></td>
 *   <td>Chrome fails to get access to the microphone, due to a Chrome error. To work
 *   around this issue, the end-user must restart Chrome and reload your site. This is a
 *   <a href="https://bugs.chromium.org/p/webrtc/issues/detail?id=4799">known issue</a>
 *   to be fixed in Chrome.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CONSTRAINTS_NOT_SATISFIED'</code></td>
 *   <td>The constraints for getting user media could not be satisfied.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CREATE_PEER_CONNECTION_FAILED'</code></td>
 *   <td>Failed to create a connection between this client and the subscriber or the
 *   Vonage Video API Media Router.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_HARDWARE_UNAVAILABLE'</code></td>
 *   <td>The hardware to fulfill the user media request appears to exist but could not be acquired.
 *   It might be in use by another application.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_CREATE_FAILED'</code></td>
 *   <td>The user attempted to publish in an end-to-end encryption enabled session without
 *   specifying an encryption key.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_ICE_WORKFLOW_FAILED'</code></td>
 *   <td>Something went wrong while establishing WebRTC connectivity.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_AUDIO_OUTPUT_SOURCE'</code></td>
 *   <td>Invalid output audio device ID. It must be a valid video output device ID.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_ABORTED'</code></td>
 *   <td>The fetching of the stream for the video element has been aborted.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_DECODE'</code></td>
 *   <td>A decoding error occurred while trying to play the stream in the video element.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_NETWORK'</code></td>
 *   <td>A network error caused the stream to stop being fetched.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_SRC_NOT_SUPPORTED'</code></td>
 *   <td>The stream has been detected to be not suitable for playback.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NO_DEVICES_FOUND'</code></td>
 *   <td>No devices were found to provide the media stream.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NO_VALID_CONSTRAINTS'</code></td>
 *   <td>Video and audio were both disabled. You need to enable at least one.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_SUPPORTED'</code></td>
 *   <td>Something in the user media request is not supported.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>This token does not allow publishing. The role must be at least publisher to enable
 *   this funcitonality.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_NOT_SUPPORTED'</code></td>
 *   <td>Screen sharing is not supported in the browser.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_EXTENSION_NOT_REGISTERED'</code></td>
 *   <td>Screen-sharing support in this browser requires an extension, but one has not been
 *   registered.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_EXTENSION_NOT_INSTALLED'</code></td>
 *   <td>Screen-sharing support in this browser requires an extension, but the extension is not
 *   installed.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SET_REMOTE_DESCRIPTION_FAILED'</code></td>
 *   <td>The WebRTC connection failed during setDescription.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_CREATE_FAILED'</code></td>
 *   <td>Failed to create the stream in the server model.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_TIMEOUT'</code></td>
 *   <td>Could not publish in a reasonable amount of time.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_USER_MEDIA_ACCESS_DENIED'</code></td>
 *   <td>The end-user denied permission to access hardware devices, or the end-user
 *   denied access to the screen (for a screen-sharing stream).</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNABLE_TO_CAPTURE_MEDIA'</code></td>
 *   <td>Unable to capture media. Unknown error occurred.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code></td>
 *   <td>This indicates an unexpected error from the Vonage Video API server.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.signal()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_FOUND'</code></td>
 *   <td>A resource was not found.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_RATE_LIMIT_EXCEEDED'</code></td>
 *   <td>The signal could not be sent due to the rate limit.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.subscribe()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CREATE_PEER_CONNECTION_FAILED'</code></td>
 *   <td>Failed to create a connection between this client and the stream's publisher or the
 *   Vonage Video API Media Router.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_DISCONNECTED'</code></td>
 *   <td>Action failed because the client is not connected to the session.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNABLE_TO_SUBSCRIBE'</code></td>
 *   <td>The user attempted to subscribe in an end-to-end encryption enabled session
 *    without having specified an encryption secret.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_ICE_WORKFLOW_FAILED'</code></td>
 *   <td>Something went wrong while establishing WebRTC connectivity.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_ABORTED'</code></td>
 *   <td>The fetching of the stream for the video element has been aborted.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_DECODE'</code></td>
 *   <td>A decoding error occurred while trying to play the stream in the video element.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_NETWORK'</code></td>
 *   <td>A network error caused the stream to stop being fetched.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_SRC_NOT_SUPPORTED'</code></td>
 *   <td>The stream has been detected to be not suitable for playback.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SET_REMOTE_DESCRIPTION_FAILED'</code></td>
 *   <td>The WebRTC connection failed during setDescription.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_DESTROYED'</code></td>
 *   <td>The stream was destroyed before it could be subscribed to.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_LIMIT_EXCEEDED'</code></td>
 *   <td>The client tried to subscribe to a stream in a session that has exceeded the limit
 *   for simultaneous streams.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_NOT_FOUND'</code></td>
 *   <td>Couldn't subscribe to the stream because it was not found.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNABLE_TO_SUBSCRIBE'</code></td>
 *   <td>Couldn't subscribe to stream due to unexpected error.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Subscriber.getStats()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_HTTP_ERROR'</code></td>
 *   <td>Action failed. Received invalid response from the Vonage Video API server.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when the Promise returned by the <code>OT.unblockAudio()</code>
 * method is rejected:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_ABORTED'</code></td>
 *   <td>The fetching of an audio stream has been aborted.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_NETWORK'</code></td>
 *   <td>A network error caused a stream to stop being fetched.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_DECODE'</code></td>
 *   <td>A decoding error occurred while trying to play a stream.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_SRC_NOT_SUPPORTED'</code></td>
 *   <td>A stream has been detected to be not suitable for playback.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when the Promise returned by the
 * <code>Publisher.getRtcStatsReport()</code> or
 * <code>Subscriber.getRtcStatsReport()</code> method is rejected:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PEER_CONNECTION_NOT_CONNECTED'</code></td>
 *   <td>
 *     The <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection" target="_blank">
 *     PeerConnection</a> for the Publisher or Subscriber is not connected.
 *   </td>
 * </tr>
 * <tr>
 *   <td><code>'OT_GET_RTC_STATS_REPORT_NOT_SUPPORTED'</code></td>
 *   <td>
 *     The browser does not support this method (for example, in Chrome version 57 and lower, which
 *     does not support the <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats" target="_blank">
 *     RTCPeerConnection.getStats()</a> standard).
 *   </td>
 * </tr>
 * </table>
 *
 * @class Error
 * @augments Event
 */

const OTErrorClass = function OTErrorClass(code, message) {
  Error.call(this);
  this.code = code;
  this.message = message;
};
OTErrorClass.prototype = Object.create(Error.prototype);
OTErrorClass.prototype.constructor = OTErrorClass;
(0, _eventing.default)(OTErrorClass);

/**
 * Get the title of an error by error code
 *
 * @property {Number|String} code The error code to lookup
 * @return {String} The title of the message with that code
 *
 * @example
 *
 * OTError.getTitleByCode(1006) === 'Connect Failed'
 */
OTErrorClass.getTitleByCode = function (code) {
  return _errorCodeToErrorTitleMap.default[+code];
};

// @todo redo this when we have time to tidy up
//
// @example
//
//  OTError.handleJsException("Descriptive error message", 2000, {
//      session: session,
//      target: stream|publisher|subscriber|session|etc
//  });
//
OTErrorClass.handleJsException = _ref => {
  let error = _ref.error,
    errorMsg = _ref.errorMsg,
    code = _ref.code,
    target = _ref.target,
    analytics = _ref.analytics;
  if (!target) {
    throw new Error('handleJsException requires target');
  }
  const getCode = () => code !== undefined ? code : error && error.code;
  const getMessage = () => errorMsg !== undefined ? errorMsg : error && error.message;
  const title = OTErrorClass.getTitleByCode(getCode());
  logging.error(`OT.exception :: title: ${title} (${getCode()}) msg: ${getMessage()}`);
  try {
    const options = {
      partnerId: target.session ? target.session.apiKey : target.apiKey,
      sessionId: target.session ? target.session.sessionId : target.sessionId
    };
    analytics.logError(getCode(), 'tb.exception', title, {
      details: getMessage()
    }, options);
    const event = new Events.ExceptionEvent(_eventNames.default.EXCEPTION, getMessage(), title, getCode(), target, target, error);
    if (error) {
      event.stack = error.stack;
    } else {
      // Augment the event object with a stacktrace for error reporting purposes
      try {
        throw new Error();
      } catch (caughtError) {
        event.stack = caughtError.stack;
      }
    }
    OTErrorClass.dispatchEvent(event);
  } catch (err) {
    logging.error(`OT.exception :: Failed to dispatch exception - ${err.toString()}`);
    // Don't throw an error because this is asynchronous
    // don't do an exceptionHandler because that would be recursive
  }
};
var _default = OTErrorClass;
exports.default = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _collection = _interopRequireDefault(__webpack_require__(270));
// TODO: Eliminate the need for this module, which is globally tracking these objects.

const sessionObjects = {
  // Publishers are id'd by their guid
  publishers: new _collection.default('guid'),
  // Subscribers are id'd by their widgetId
  subscribers: new _collection.default('widgetId'),
  sessions: new _collection.default()
};
var _default = sessionObjects;
exports.default = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.MEDIUM = exports.LOW = exports.CongestionLevels = exports.CRITICAL = void 0;
const CRITICAL = 2;
exports.CRITICAL = CRITICAL;
const MEDIUM = 1;
exports.MEDIUM = MEDIUM;
const LOW = 0;
exports.LOW = LOW;
const CongestionLevels = {
  CRITICAL,
  MEDIUM,
  LOW
};
exports.CongestionLevels = CongestionLevels;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(20),
    isLength = __webpack_require__(119);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Event names lookup
var _default = {
  // Activity Status for cams/mics
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  UNKNOWN: 'unknown',
  // Archive types
  PER_SESSION: 'perSession',
  PER_STREAM: 'perStream',
  // Events
  EXCEPTION: 'exception',
  ISSUE_REPORTED: 'issueReported',
  // Session Events
  SESSION_CONNECTED: 'sessionConnected',
  SESSION_RECONNECTING: 'sessionReconnecting',
  SESSION_RECONNECTED: 'sessionReconnected',
  SESSION_DISCONNECTED: 'sessionDisconnected',
  STREAM_CREATED: 'streamCreated',
  STREAM_DESTROYED: 'streamDestroyed',
  CONNECTION_CREATED: 'connectionCreated',
  CONNECTION_DESTROYED: 'connectionDestroyed',
  SIGNAL: 'signal',
  STREAM_PROPERTY_CHANGED: 'streamPropertyChanged',
  MICROPHONE_LEVEL_CHANGED: 'microphoneLevelChanged',
  // Publisher Events
  RESIZE: 'resize',
  SETTINGS_BUTTON_CLICK: 'settingsButtonClick',
  DEVICE_INACTIVE: 'deviceInactive',
  INVALID_DEVICE_NAME: 'invalidDeviceName',
  ACCESS_ALLOWED: 'accessAllowed',
  ACCESS_DENIED: 'accessDenied',
  ACCESS_DIALOG_OPENED: 'accessDialogOpened',
  ACCESS_DIALOG_CLOSED: 'accessDialogClosed',
  AUDIO_INPUT_DEVICE_CHANGED: 'audioInputDeviceChanged',
  ECHO_CANCELLATION_MODE_CHANGED: 'echoCancellationModeChanged',
  MEDIA_STOPPED: 'mediaStopped',
  PUBLISHER_DESTROYED: 'destroyed',
  MUTE_FORCED: 'muteForced',
  // Subscriber Events
  SUBSCRIBER_DESTROYED: 'destroyed',
  SUBSCRIBER_CONNECTED: 'connected',
  SUBSCRIBER_DISCONNECTED: 'disconnected',
  SUBSCRIBER_CAPTION_RECEIVED: 'captionReceived',
  // DeviceManager Events
  DEVICES_DETECTED: 'devicesDetected',
  // DevicePanel Events
  DEVICES_SELECTED: 'devicesSelected',
  CLOSE_BUTTON_CLICK: 'closeButtonClick',
  MICLEVEL: 'microphoneActivityLevel',
  MICGAINCHANGED: 'microphoneGainChanged',
  // Environment Loader
  ENV_LOADED: 'envLoaded',
  ENV_UNLOADED: 'envUnloaded',
  // Audio activity Events
  AUDIO_LEVEL_UPDATED: 'audioLevelUpdated',
  VIDEO_ELEMENT_CREATED: 'videoElementCreated'
};
exports.default = _default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _createClass2 = _interopRequireDefault(__webpack_require__(25));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _guid_storage = _interopRequireDefault(__webpack_require__(271));
var _analytics = _interopRequireDefault(__webpack_require__(267));
var _SessionInfo = _interopRequireDefault(__webpack_require__(152));
var _StaticConfig = _interopRequireDefault(__webpack_require__(48));
var _getMessagingUrl = _interopRequireDefault(__webpack_require__(582));
var _sanitizeQosData = _interopRequireDefault(__webpack_require__(584));
var _getUserAgentClientHintData = _interopRequireDefault(__webpack_require__(587));
const StaticConfig = (0, _StaticConfig.default)();
const LOG_VERSION = '2';
let AnalyticsHelper = /*#__PURE__*/function () {
  function AnalyticsHelper(_temp) {
    let _ref = _temp === void 0 ? {} : _temp,
      _ref$staticConfig = _ref.staticConfig,
      staticConfig = _ref$staticConfig === void 0 ? StaticConfig.onlyLocal() : _ref$staticConfig,
      _ref$sessionInfo = _ref.sessionInfo,
      sessionInfo = _ref$sessionInfo === void 0 ? new _SessionInfo.default() : _ref$sessionInfo,
      ajax = _ref.ajax,
      queue = _ref.queue,
      _ref$getUserAgentClie = _ref.getUserAgentClientHintData,
      getUserAgentClientHintData = _ref$getUserAgentClie === void 0 ? _getUserAgentClientHintData.default : _ref$getUserAgentClie,
      _ref$userAgentData = _ref.userAgentData,
      userAgentData = _ref$userAgentData === void 0 ? typeof navigator !== 'undefined' && navigator.userAgentData : _ref$userAgentData;
    this.getTurnServerName = iceServers => {
      let turnNoTLSServerName;
      let turnTLSServerName;

      // In case we don't find the server name we will be returning nothing
      // which will be ignored and relay server will not be present in the logs
      if (!iceServers || typeof iceServers !== 'object') return turnNoTLSServerName;
      const servers = Array.isArray(iceServers) ? iceServers : [iceServers];
      servers.forEach(server => {
        const urls = server.urls || server.url;
        const arrUrl = Array.isArray(urls) ? urls : [urls];
        arrUrl.forEach(url => {
          // Index where server name value starts
          const prefixIndex = url.indexOf(':') + 1;
          // Index of the port number
          const suffixIndex = url.lastIndexOf(':');

          // We assume that TLS turn, i.e. turns, is the one which contains
          // the domain name.
          if (url.includes('turns')) {
            turnTLSServerName = url.substring(prefixIndex, suffixIndex);
          } else {
            turnNoTLSServerName = url.substring(prefixIndex, suffixIndex);
          }
        });
      });
      return turnTLSServerName || turnNoTLSServerName;
    };
    this.ajax = ajax;
    this.queue = queue;
    this.sessionInfo = sessionInfo;
    this.getUserAgentClientHintData = getUserAgentClientHintData;
    this.userAgentData = userAgentData;

    // setting static config invokes the setter below and instantiates Analytics
    // This must be called last.
    this.staticConfig = staticConfig;
  }
  var _proto = AnalyticsHelper.prototype;
  _proto._getCachedUserAgentData = /*#__PURE__*/function () {
    var _getCachedUserAgentData2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.cachedUserAgentData) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return this.getUserAgentClientHintData(this.userAgentData);
          case 3:
            this.cachedUserAgentData = _context.sent;
          case 4:
            return _context.abrupt("return", this.cachedUserAgentData);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function _getCachedUserAgentData() {
      return _getCachedUserAgentData2.apply(this, arguments);
    }
    return _getCachedUserAgentData;
  }();
  _proto.commonQoSFields = function commonQoSFields() {
    const proxyUrl = this._analytics.proxyUrl;
    const messagingURL = this.sessionInfo.messagingURL;
    return {
      clientVersion: this.staticConfig.clientVersion,
      buildHash: this.staticConfig.buildHash,
      source: (typeof window !== undefined ? window : global).location && (typeof window !== undefined ? window : global).location.href,
      logVersion: LOG_VERSION,
      apiServer: this.staticConfig.apiUrl,
      clientSystemTime: new Date().getTime(),
      sessionId: this.sessionInfo.sessionId,
      mediaServerName: this.sessionInfo.mediaServerName,
      relayServer: this.getTurnServerName(this.sessionInfo.iceServers),
      p2p: this.sessionInfo.p2pEnabled,
      messagingServer: this.sessionInfo.messagingServer,
      messagingUrl: (0, _getMessagingUrl.default)(proxyUrl, messagingURL),
      version: this.staticConfig.version,
      partnerId: this.sessionInfo.partnerId
    };
  };
  _proto._getCommonDataFields = /*#__PURE__*/function () {
    var _getCommonDataFields2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var guid, userAgentDataFields;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _guid_storage.default.getAsync();
          case 2:
            guid = _context2.sent;
            _context2.next = 5;
            return this._getCachedUserAgentData();
          case 5:
            userAgentDataFields = _context2.sent;
            return _context2.abrupt("return", Object.assign({
              guid
            }, this.commonQoSFields(), userAgentDataFields));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function _getCommonDataFields() {
      return _getCommonDataFields2.apply(this, arguments);
    }
    return _getCommonDataFields;
  }();
  _proto.logError = function logError(code, type, message, details, options) {
    if (options === void 0) {
      options = {};
    }
    this._getCommonDataFields().then(commonDataFields => {
      const args = [code, type, message, details, Object.assign({}, commonDataFields, options)];
      AnalyticsHelper.emit('logError', ...args);
      this._analytics.logError(...args);
    });
  };
  _proto.logEvent = function logEvent(options, throttle, completionHandler) {
    if (options === void 0) {
      options = {};
    }
    this._getCommonDataFields().then(commonDataFields => {
      const logData = Object.assign({}, commonDataFields, options);
      AnalyticsHelper.emit('logEvent', logData);
      this._analytics.logEvent(logData, false, throttle, completionHandler);
    });
  };
  _proto.logQOS = function logQOS(options) {
    if (options === void 0) {
      options = {};
    }
    this._getCommonDataFields().then(commonDataFields => {
      const qosData = Object.assign({
        duration: 0
      }, commonDataFields, options);
      (0, _sanitizeQosData.default)(qosData);
      AnalyticsHelper.emit('logQOS', qosData);
      this._analytics.logQOS(qosData);
    });
  };
  (0, _createClass2.default)(AnalyticsHelper, [{
    key: "staticConfig",
    get: function get() {
      return this._staticConfig;
    },
    set: function set(staticConfig) {
      this._staticConfig = staticConfig;
      this._analytics = new _analytics.default({
        loggingUrl: this.staticConfig.loggingUrl,
        ajax: this.ajax,
        queue: this.queue
      });
    }
  }]);
  return AnalyticsHelper;
}();
exports.default = AnalyticsHelper;
(0, _eventing.default)(AnalyticsHelper);

// Changing this to a import es6 module causes a circular dependency to break
// This will be addressed in VIDCS-1110
/* eslint-disable-next-line import/no-commonjs */
module.exports = AnalyticsHelper;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var logDisabled_ = true;
var deprecationWarnings_ = true;

/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */
function extractVersion(uastring, expr, pos) {
  var match = uastring.match(expr);
  return match && match.length >= pos && parseInt(match[pos], 10);
}

// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).
function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
  if (!window.RTCPeerConnection) {
    return;
  }
  var proto = window.RTCPeerConnection.prototype;
  var nativeAddEventListener = proto.addEventListener;
  proto.addEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }
    var wrappedCallback = function(e) {
      var modifiedEvent = wrapper(e);
      if (modifiedEvent) {
        cb(modifiedEvent);
      }
    };
    this._eventMap = this._eventMap || {};
    this._eventMap[cb] = wrappedCallback;
    return nativeAddEventListener.apply(this, [nativeEventName,
      wrappedCallback]);
  };

  var nativeRemoveEventListener = proto.removeEventListener;
  proto.removeEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap
        || !this._eventMap[cb]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    var unwrappedCb = this._eventMap[cb];
    delete this._eventMap[cb];
    return nativeRemoveEventListener.apply(this, [nativeEventName,
      unwrappedCb]);
  };

  Object.defineProperty(proto, 'on' + eventNameToWrap, {
    get: function() {
      return this['_on' + eventNameToWrap];
    },
    set: function(cb) {
      if (this['_on' + eventNameToWrap]) {
        this.removeEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap]);
        delete this['_on' + eventNameToWrap];
      }
      if (cb) {
        this.addEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap] = cb);
      }
    },
    enumerable: true,
    configurable: true
  });
}

// Utility methods.
module.exports = {
  extractVersion: extractVersion,
  wrapPeerConnectionEvent: wrapPeerConnectionEvent,
  disableLog: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    logDisabled_ = bool;
    return (bool) ? 'adapter.js logging disabled' :
        'adapter.js logging enabled';
  },

  /**
   * Disable or enable deprecation warnings
   * @param {!boolean} bool set to true to disable warnings.
   */
  disableWarnings: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
  },

  log: function() {
    if (typeof window === 'object') {
      if (logDisabled_) {
        return;
      }
      if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log.apply(console, arguments);
      }
    }
  },

  /**
   * Shows a deprecation warning suggesting the modern and spec-compatible API.
   */
  deprecated: function(oldMethod, newMethod) {
    if (!deprecationWarnings_) {
      return;
    }
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod +
        ' instead.');
  },

  /**
   * Browser detector.
   *
   * @return {object} result containing browser and version
   *     properties.
   */
  detectBrowser: function(window) {
    var navigator = window && window.navigator;

    // Returned result object.
    var result = {};
    result.browser = null;
    result.version = null;

    // Fail early if it's not a browser
    if (typeof window === 'undefined' || !window.navigator) {
      result.browser = 'Not a browser.';
      return result;
    }

    if (navigator.mozGetUserMedia) { // Firefox.
      result.browser = 'firefox';
      result.version = extractVersion(navigator.userAgent,
          /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia) {
      // Chrome, Chromium, Webview, Opera.
      // Version matches Chrome/WebRTC version.
      result.browser = 'chrome';
      result.version = extractVersion(navigator.userAgent,
          /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (navigator.mediaDevices &&
        navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) { // Edge.
      result.browser = 'edge';
      result.version = extractVersion(navigator.userAgent,
          /Edge\/(\d+).(\d+)$/, 2);
    } else if (window.RTCPeerConnection &&
        navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) { // Safari.
      result.browser = 'safari';
      result.version = extractVersion(navigator.userAgent,
          /AppleWebKit\/(\d+)\./, 1);
    } else { // Default fallthrough: not supported.
      result.browser = 'Not a supported browser.';
      return result;
    }

    return result;
  }
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(43),
    getRawTag = __webpack_require__(378),
    objectToString = __webpack_require__(379);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(193),
    baseKeys = __webpack_require__(121),
    isArrayLike = __webpack_require__(29);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(46);

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue         = __webpack_require__(57)
  , isPlainFunction = __webpack_require__(214)
  , assign          = __webpack_require__(133)
  , normalizeOpts   = __webpack_require__(215)
  , contains        = __webpack_require__(216);

var d = (module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if (arguments.length < 2 || typeof dscr !== "string") {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
		w = contains.call(dscr, "w");
	} else {
		c = w = true;
		e = false;
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
});

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== "string") {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (!isValue(get)) {
		get = undefined;
	} else if (!isPlainFunction(get)) {
		options = get;
		get = set = undefined;
	} else if (!isValue(set)) {
		set = undefined;
	} else if (!isPlainFunction(set)) {
		options = set;
		set = undefined;
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
	} else {
		c = true;
		e = false;
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(534),
    baseMatchesProperty = __webpack_require__(542),
    identity = __webpack_require__(91),
    isArray = __webpack_require__(14),
    property = __webpack_require__(547);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(557),
    flatRest = __webpack_require__(144);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Widget;
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

// A mixin to encapsulate the basic widget behaviour. This needs a better name,
// it's not actually a widget. It's actually "Behaviour that can be applied to
// an object to make it support the basic Chrome widget workflow"...but that would
// probably been too long a name.
function Widget(widget, options) {
  let _mode;
  const _options = options || {};

  //
  // @param [String] mode
  //      'on', 'off', or 'auto'
  //
  widget.setDisplayMode = function (mode) {
    const newMode = mode || 'auto';
    if (_mode === newMode) {
      return;
    }
    _OTHelpers.default.removeClass(this.domElement, `OT_mode-${_mode}`);
    _OTHelpers.default.addClass(this.domElement, `OT_mode-${newMode}`);
    _mode = newMode;
  };
  widget.getDisplayMode = function () {
    return _mode;
  };
  widget.showAfterLoading = function () {
    _OTHelpers.default.removeClass(this.domElement, 'OT_hide-forced');
  };
  widget.hideWhileLoading = function () {
    _OTHelpers.default.addClass(this.domElement, 'OT_hide-forced');
  };
  widget.destroy = function () {
    if (_options.onDestroy) {
      _options.onDestroy(this.domElement);
    }
    if (this.domElement) {
      _OTHelpers.default.removeElement(this.domElement);
    }
    return widget;
  };
  widget.appendTo = function (parent) {
    // create the element under parent
    this.domElement = _OTHelpers.default.createElement(_options.nodeName || 'div', _options.htmlAttributes, _options.htmlContent);
    if (_options.onCreate) {
      _options.onCreate(this.domElement);
    }
    widget.setDisplayMode(_options.mode);
    if (_options.mode === 'auto') {
      // if the mode is auto we hold the "on mode" for 2 seconds
      // this will let the proper widgets nicely fade away and help discoverability
      _OTHelpers.default.addClass(widget.domElement, 'OT_mode-on-hold');
      setTimeout(() => {
        _OTHelpers.default.removeClass(widget.domElement, 'OT_mode-on-hold');
      }, 2000);
    }

    // add the widget to the parent
    parent.appendChild(this.domElement);
    return widget;
  };
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(80);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(377),
    getValue = __webpack_require__(382);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(16);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(86),
    baseAssignValue = __webpack_require__(64);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(406),
    Map = __webpack_require__(116),
    Promise = __webpack_require__(407),
    Set = __webpack_require__(201),
    WeakMap = __webpack_require__(202),
    baseGetTag = __webpack_require__(33),
    toSource = __webpack_require__(190);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _undefined = __webpack_require__(427)(); // Support ES3 engines

module.exports = function (val) { return val !== _undefined && val !== null; };


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(441)()
	? __webpack_require__(94).Symbol
	: __webpack_require__(444);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _createClass2 = _interopRequireDefault(__webpack_require__(25));
var _axios = _interopRequireDefault(__webpack_require__(221));
var _mapKeys = _interopRequireDefault(__webpack_require__(505));
var _pick = _interopRequireDefault(__webpack_require__(556));
var _cloneDeep = _interopRequireDefault(__webpack_require__(62));
var _log = _interopRequireDefault(__webpack_require__(1));
var _proxyUrlHelper = _interopRequireDefault(__webpack_require__(106));
/* global __PROPERTIES__ */

const logging = (0, _log.default)('StaticConfig');

/**
 * @typedef {Object} builtInConfig properties that are baked in and are injected through webpack
 * @property {String} version Build version (comes from package.json)
 * @property {String} buildHash Commit hash this build was built from
 * @property {Object} minimumVersion
 * @property {String} minimumVersion.firefox Minimum version of Firefox needed to support Vonage Video API
 * @property {String} minimumVersion.chrome Minimum version of Chrome needed to support Vonage Video API
 * @property {Boolean} debug If true sets logging level to DEBUG else sets it to WARN
 * @property {String} websiteURL Used to construct urls to the TokBox website
 * @property {String} loggingURL Where to send analytical events
 * @property {String} apiURL The API to talk to (Anvil)
*/

/** @type builtInConfig */
const builtInConfig = (0, _cloneDeep.default)({"version":"v2.30.2","buildHash":"5b8d84a71","minimumVersion":{"firefox":52,"chrome":49},"debug":false,"websiteURL":"http://www.tokbox.com","configURL":"https://config.opentok.com","ipWhitelistConfigURL":"","cdnURL":"https://static.opentok.com","loggingURL":"https://hlg.tokbox.com/prod","apiURL":"https://anvil.opentok.com"});
const whitelistAllowedRuntimeProperties = (0, _pick.default)(['apiURL', 'assetURL', 'cdnURL', 'sessionInfoOverrides', 'loggingURL']);
const liveConfigMap = {
  apiUrl: 'apiURL',
  loggingUrl: 'loggingURL'
};
const normalizeLiveConfig = (0, _mapKeys.default)(key => liveConfigMap[key]);
function staticConfigFactory(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$axios = _ref.axios,
    axios = _ref$axios === void 0 ? _axios.default : _ref$axios;
  /**
   * @class StaticConfig
   */
  let StaticConfig = /*#__PURE__*/function () {
    StaticConfig.onlyLocal = function onlyLocal() {
      const runtimeProperties = (0, _cloneDeep.default)((typeof window !== undefined ? window : global).OTProperties);
      return new StaticConfig(Object.assign({}, builtInConfig, whitelistAllowedRuntimeProperties(runtimeProperties)));
    }
    /**
     * Construct a StaticConfig instance with baked in, runtime, and live configuration
     *
     * @static
     * @param {any} { sessionId, token, useIpWhitelistConfigUrl }
     * @memberof StaticConfig
     * @return {Promise<StaticConfig>} A promise to an instance of StaticConfig
     */;
    StaticConfig.get = function get(_ref2) {
      let partnerId = _ref2.partnerId,
        token = _ref2.token,
        useIpWhitelistConfigUrl = _ref2.useIpWhitelistConfigUrl,
        proxyUrl = _ref2.proxyUrl;
      const getLiveConfig = () => {
        const localStaticConfig = this.onlyLocal();
        if (!localStaticConfig.configUrl) {
          return Promise.resolve({});
        }
        if (useIpWhitelistConfigUrl === true && !localStaticConfig.ipWhitelistConfigUrl) {
          return Promise.resolve({});
        }
        let finalConfigUrl = useIpWhitelistConfigUrl === true ? localStaticConfig.ipWhitelistConfigUrl : localStaticConfig.configUrl;
        finalConfigUrl = (0, _proxyUrlHelper.default)(finalConfigUrl, proxyUrl);
        return axios.get(`${finalConfigUrl}/project/${partnerId}/config.json`, {
          headers: {
            'X-TB-TOKEN-AUTH': token
          }
        }).then(_ref3 => {
          let data = _ref3.data;
          return data;
        });
      };
      return getLiveConfig().then(liveConfig => {
        const runtimeProperties = (0, _cloneDeep.default)((typeof window !== undefined ? window : global).OTProperties);
        const config = Object.assign({}, builtInConfig, whitelistAllowedRuntimeProperties(runtimeProperties), normalizeLiveConfig(liveConfig));
        return new StaticConfig(config);
      }).catch(err => {
        const errorMessage = 'could not reach Config Service';
        logging.error(errorMessage, err);
        return Promise.reject(new Error(errorMessage));
      });
    };
    function StaticConfig(config) {
      Object.defineProperty(this, 'config', {
        value: Object.freeze((0, _cloneDeep.default)(config))
      });
    }
    (0, _createClass2.default)(StaticConfig, [{
      key: "configUrl",
      get: function get() {
        return this.config.configURL;
      }
    }, {
      key: "ipWhitelistConfigUrl",
      get: function get() {
        return this.config.ipWhitelistConfigURL;
      }
    }, {
      key: "apiUrl",
      get: function get() {
        return this.config.apiURL;
      }
    }, {
      key: "loggingUrl",
      get: function get() {
        return this.config.loggingURL;
      }
    }, {
      key: "apiEnabled",
      get: function get() {
        return typeof this.config.apiEnabled !== 'undefined' ? this.config.apiEnabled : true;
      }
    }, {
      key: "version",
      get: function get() {
        return this.config.version;
      }
    }, {
      key: "clientVersion",
      get: function get() {
        return `js-${(this.version || 'unknown').replace('v', '')}`;
      }
    }, {
      key: "buildHash",
      get: function get() {
        return this.config.buildHash;
      }
    }, {
      key: "minimumVersion",
      get: function get() {
        return this.config.minimumVersion;
      }
    }, {
      key: "websiteUrl",
      get: function get() {
        return this.config.websiteURL;
      }
    }, {
      key: "debug",
      get: function get() {
        return this.config.debug === 'true' || this.config.debug === true;
      }
    }, {
      key: "sessionInfoOverrides",
      get: function get() {
        return this.config.sessionInfoOverrides;
      }
    }, {
      key: "cdnUrl",
      get: function get() {
        return this.config.cdnURL || `${(typeof window !== undefined ? window : global).location.protocol}//${(typeof window !== undefined ? window : global).location.host}`;
      }
    }, {
      key: "assetUrl",
      get: function get() {
        return this.config.assetURL || `${this.cdnUrl}/webrtc/${this.version}`;
      }
    }]);
    return StaticConfig;
  }();
  return StaticConfig;
}
var _default = staticConfigFactory;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(71);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = highResolutionNow;
const performance = (typeof window !== undefined ? window : global).performance || {};

/**
 * Returns the number of milliseconds since the the UNIX epoch
 *
 * When available (performance api exists), this function will not be skewed
 * by clock adjustments. Only use if you require this functionality, otherwise
 * use Date.now().
 *
 * @returns {number} Number of milliseconds since UNIX epoch
 */

function highResolutionNow() {
  if (performance.now) {
    return performance.timing.navigationStart + performance.now();
  }
  return Date.now();
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var before = __webpack_require__(624);

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

module.exports = once;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _once = _interopRequireDefault(__webpack_require__(52));
var _hasGetUserMediaCapability = _interopRequireDefault(__webpack_require__(632));
var _env = _interopRequireDefault(__webpack_require__(3));
var _hasPeerConnectionCapability = _interopRequireDefault(__webpack_require__(633));
/* eslint-disable global-require */

// Indicates whether this client supports WebRTC
//
// This is defined as: getUserMedia + PeerConnection + exceeds min browser version
//
const check = function check(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const env = deps.env || _env.default;
  const hasGetUserMediaCapability = deps.hasGetUserMediaCapability || _hasGetUserMediaCapability.default;
  const hasPeerConnectionCapability = deps.hasPeerConnectionCapability || _hasPeerConnectionCapability.default;
  if (env.name === 'Node') {
    // Node works, even though it doesn't have getUserMedia
    return true;
  }
  return hasGetUserMediaCapability() && hasPeerConnectionCapability();
};
const once = (0, _once.default)(() => check());
var _default = {
  check,
  once
};
exports.default = _default;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(193),
    baseKeysIn = __webpack_require__(401),
    isArrayLike = __webpack_require__(29);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ES3 safe
var _undefined = void 0;

module.exports = function (value) { return value !== _undefined && value !== null; };


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = eventHelper;
function eventHelper(object) {
  const eventHandlers = [];
  return {
    on(eventName, handler) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      eventHandlers.push({
        eventName,
        handler,
        args
      });
      if (object.on) {
        object.on(eventName, handler);
      } else if (object.addEventListener) {
        object.addEventListener(eventName, handler, ...args);
      } else {
        throw new Error('Object does not support events', object);
      }
    },
    off(eventName, handler) {
      if (object.off) {
        object.off(eventName, handler);
      } else if (object.removeEventListener) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }
        object.removeEventListener(eventName, handler, ...args);
      } else {
        throw new Error('Object does not support events', object);
      }
    },
    once(eventName, handler) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }
      eventHandlers.push({
        eventName,
        handler,
        args
      });
      object.once(eventName, handler);
    },
    removeAll() {
      eventHandlers.forEach(_ref => {
        let eventName = _ref.eventName,
          handler = _ref.handler,
          args = _ref.args;
        this.off(eventName, handler, ...args);
      });
      eventHandlers.splice(0, eventHandlers.length);
    }
  };
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(104);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(14),
    isKey = __webpack_require__(143),
    stringToPath = __webpack_require__(254),
    toString = __webpack_require__(61);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(544);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(80);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(648),
    findIndex = __webpack_require__(298);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(191);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(396),
    isObjectLike = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(16),
    stubFalse = __webpack_require__(397);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(87)(module)))

/***/ }),
/* 67 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.getProxyUrl = exports.errorMessages = exports.clearProxyUrl = void 0;
exports.setProxyUrl = setProxyUrl;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _objects = _interopRequireDefault(__webpack_require__(27));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _api_key = _interopRequireDefault(__webpack_require__(73));
/* eslint-disable global-require */

// import AnalyticsHelper from '../helpers/analytics';

let proxyUrl;
const errorMessages = {
  SET_PROXY_URL_TIMING_ERROR: 'The proxyUrl was set after a session or publisher was created.',
  PROXY_URL_ALREADY_SET_ERROR: 'The proxyUrl has already been set. Setting it again will not have any effect.'
};

/**
 * Sets the URL of the IP proxy server. With the IP proxy feature, the client
 * routes all internet traffic (except for media streams) via your proxy server.
 * <p>
 * You must call this method before calling any other Vonage Video API methods.
 * This ensures that the proxy server is used for Vonage Video API traffic. Otherwise,
 * the call fails, and the <code>OT</code> object dispatches an
 * <code>exception</code> event. The <code>OT</code> object also dispatches an
 * <code>exception</code> event if you call this method after having
 * previously called it.
 * <p>
 * This is available as an add-on feature. For more information, see the
 * <a href="https://tokbox.com/developer/guides/ip-proxy/">IP proxy developer
 * guide</a>.
 *
 * @method OT.setProxyUrl
 * @memberof OT
 */
exports.errorMessages = errorMessages;
function setProxyUrl(url) {
  const AnalyticsHelper = __webpack_require__(31);
  const apiKey = _api_key.default;

  // This is necessary to break a circular dependancy, but seems hacky and should be cleaned up
  const analytics = new AnalyticsHelper();
  const hasSessionInitalized = _objects.default.sessions.length() > 0;
  const hasPublisherInitalized = _objects.default.publishers.length() > 0;
  let sessionId;
  if (hasSessionInitalized) {
    const connectedSession = _objects.default.sessions.find(session => session.currentState === 'connected');
    sessionId = connectedSession ? connectedSession.sessionId : _objects.default.sessions.find().sessionId;
  } else {
    sessionId = '';
  }
  const target = {
    sessionId,
    apiKey: apiKey.value
  };
  if (hasPublisherInitalized || hasSessionInitalized) {
    const error = (0, _otError.default)()(_Errors.default.SET_PROXY_URL_TIMING_ERROR, new Error(errorMessages.SET_PROXY_URL_TIMING_ERROR), _exception_codes.default.SET_PROXY_URL_TIMING_ERROR);
    _ot_error_class.default.handleJsException({
      error,
      target,
      analytics
    });
  } else if (proxyUrl) {
    const error = (0, _otError.default)()(_Errors.default.PROXY_URL_ALREADY_SET_ERROR, new Error(errorMessages.PROXY_URL_ALREADY_SET_ERROR), _exception_codes.default.PROXY_URL_ALREADY_SET_ERROR);
    _ot_error_class.default.handleJsException({
      error,
      target,
      analytics
    });
  } else {
    // eslint-disable-next-line no-param-reassign
    proxyUrl = url;
  }
}
const getProxyUrl = () => proxyUrl;

// this method should only be exposed to tests
exports.getProxyUrl = getProxyUrl;
const clearProxyUrl = () => {
  proxyUrl = null;
};
exports.clearProxyUrl = clearProxyUrl;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _OTHelpers$env;
let value;
if ((_OTHelpers.default == null ? void 0 : (_OTHelpers$env = _OTHelpers.default.env) == null ? void 0 : _OTHelpers$env.name) === 'Node') {
  value = '';
} else {
  var _Array$prototype$slic, _Array$prototype$slic2;
  // Script embed
  const scriptSrc = (_Array$prototype$slic = Array.prototype.slice.call(document.getElementsByTagName('script'))) == null ? void 0 : (_Array$prototype$slic2 = _Array$prototype$slic.pop()) == null ? void 0 : _Array$prototype$slic2.getAttribute('src');
  const _ref = scriptSrc && scriptSrc.match(/[?&]apikey=([^&]+)/i) || [],
    apiKey = _ref[1];

  // TODO: The indirection here is due to the need to set APIKEY in testing. We should find a better
  // solution.
  value = apiKey || '';
}
var _default = {
  value
};
exports.default = _default;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = IntervalRunner;
/*
  * Executes the provided callback thanks to <code>global.setTimeout</code>.
  *
  * @param {function()} callback
  * @param {number} frequency how many times per second we want to execute the callback
  * @param {number} maxIterations the maximum amount of iterations for this runner
  * @constructor
  */

function IntervalRunner(callback, desiredFrequency, maxIterations) {
  if (maxIterations === void 0) {
    maxIterations = Infinity;
  }
  let timeoutId = null;
  let running = false;
  let iteration = 1;
  const timeBetween = 1000 / desiredFrequency;
  const loop = () => {
    if (!running || iteration > maxIterations) {
      return;
    }
    iteration += 1;
    callback();
    timeoutId = setTimeout(loop, timeBetween);
  };
  this.start = () => {
    if (running) {
      return;
    }
    running = true;
    setTimeout(loop, timeBetween);
  };
  this.stop = () => {
    (typeof window !== undefined ? window : global).clearTimeout(timeoutId);
    running = false;
  };
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = PeerConnectionFactory;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _pTimeout = _interopRequireDefault(__webpack_require__(164));
var _assign = _interopRequireDefault(__webpack_require__(9));
var _cloneDeep = _interopRequireDefault(__webpack_require__(62));
var _intersection = _interopRequireDefault(__webpack_require__(149));
var _debounce = _interopRequireDefault(__webpack_require__(296));
var _omit = _interopRequireDefault(__webpack_require__(297));
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _env = _interopRequireDefault(__webpack_require__(3));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _error = _interopRequireDefault(__webpack_require__(272));
var _createCleanupJobs = _interopRequireDefault(__webpack_require__(166));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _shouldUsePlanBSDP = _interopRequireDefault(__webpack_require__(76));
var _extractSenderId = _interopRequireDefault(__webpack_require__(651));
var _hasValidPeerConnection = _interopRequireDefault(__webpack_require__(653));
var _applySdpTransform = _interopRequireDefault(__webpack_require__(167));
var _createPeerConnection = _interopRequireDefault(__webpack_require__(654));
var _sdpTransformDefaults = _interopRequireDefault(__webpack_require__(656));
var _getStatsAdapter = _interopRequireDefault(__webpack_require__(302));
var _get_rtc_stats_report_adapter = _interopRequireDefault(__webpack_require__(305));
var _get_synchronization_sources = _interopRequireDefault(__webpack_require__(660));
var _ice_candidate_processor = _interopRequireDefault(__webpack_require__(661));
var _offer_processor = _interopRequireDefault(__webpack_require__(663));
var _peer_connection_channels = _interopRequireDefault(__webpack_require__(665));
var _subscribe_processor = _interopRequireDefault(__webpack_require__(667));
var _offerAnswerProcessor = _interopRequireDefault(__webpack_require__(668));
var _changeMediaDirection = _interopRequireDefault(__webpack_require__(670));
var _Qos = _interopRequireDefault(__webpack_require__(306));
var _needsToSwapH264Profiles = _interopRequireDefault(__webpack_require__(674));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _hasPictureInPictureBug = _interopRequireDefault(__webpack_require__(675));
var _now = _interopRequireDefault(__webpack_require__(51));
var _mediaDirection = _interopRequireDefault(__webpack_require__(300));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable one-var, no-use-before-define, no-param-reassign */
/* eslint-disable max-len, no-var, vars-on-top, global-require */

function PeerConnectionFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const hasValidPeerConnection = deps.hasValidPeerConnection || _hasValidPeerConnection.default;
  const applySdpTransform = deps.applySdpTransform || _applySdpTransform.default;
  const createPeerConnection = deps.createPeerConnection || _createPeerConnection.default;
  const env = deps.env || _env.default;
  const sdpTransformDefaults = deps.sdpTransformDefaults || _sdpTransformDefaults.default;
  const getStatsAdapter = deps.getStatsAdapter || _getStatsAdapter.default;
  const getRtcStatsReportAdapter = deps.getRtcStatsReportAdapter || _get_rtc_stats_report_adapter.default;
  const getSynchronizationSources = deps.getSynchronizationSources || _get_synchronization_sources.default;
  const IceCandidateProcessor = deps.IceCandidateProcessor || _ice_candidate_processor.default;
  const createLog = deps.logging || _log.default;
  const offerProcessor = deps.offerProcessor || _offer_processor.default;
  const PeerConnectionChannels = deps.PeerConnectionChannels || _peer_connection_channels.default;
  const subscribeProcessor = deps.subscribeProcessor || _subscribe_processor.default;
  const OfferAnswerProcessor = _offerAnswerProcessor.default;
  const _ref = deps.changeMediaDirection || _changeMediaDirection.default,
    deactivateMedia = _ref.changeMediaDirectionToInactive,
    reactivateMedia = _ref.changeMediaDirectionToRecvOnly;
  const Qos = deps.Qos || _Qos.default;
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  const debounce = deps.debounce || _debounce.default;
  const needsToSwapH264Profiles = deps.needsToSwapH264Profiles || _needsToSwapH264Profiles.default.once;
  const extractSenderId = (0, _extractSenderId.default)();
  const futureIsPeerConnectionValid = () => hasValidPeerConnection(windowMock.RTCPeerConnection);
  const NativeRTCIceCandidate = deps.NativeRTCIceCandidate || windowMock.RTCIceCandidate;
  const NativeRTCSessionDescription = deps.NativeRTCSessionDescription || windowMock.RTCSessionDescription;
  const Errors = deps.Errors || _Errors.default;
  const OTErrorClass = deps.OTErrorClass || _ot_error_class.default;
  const ExceptionCodes = deps.ExceptionCodes || _exception_codes.default;
  const hasPictureInPictureBug = deps.hasPictureInPictureBug || _hasPictureInPictureBug.default;
  // Unified-plan does not transition to failed. Plan-b used to transition after 10 secs (empirically measured)
  const DISCONNECT_TO_FAILED_TIMEOUT = 10000;

  // Helper function to forward Ice Candidates via +sendMessage+
  const iceCandidateForwarder = _ref2 => {
    let sendMessage = _ref2.sendMessage,
      logging = _ref2.logging;
    const sdpMids = {};
    return event => {
      if (event.candidate) {
        // It would be better to read the mids from the SDP
        sdpMids[event.candidate.sdpMid] = event.candidate.sdpMLineIndex;
        sendMessage('candidate', {
          candidate: event.candidate.candidate,
          sdpMid: event.candidate.sdpMid || '',
          sdpMLineIndex: event.candidate.sdpMLineIndex || 0
        });
      } else {
        logging.debug('IceCandidateForwarder: No more ICE candidates.');
      }
    };
  };
  const noop = () => {};

  /*
  * Negotiates a WebRTC PeerConnection.
  *
  * Responsible for:
  * * offer-answer exchange
  * * iceCandidates
  * * notification of remote streams being added/removed
  *
  */
  return function PeerConnection(options) {
    if (options === void 0) {
      options = {};
    }
    let hasRelayCandidates = false;
    const _options = options,
      _options$iceConfig = _options.iceConfig,
      iceConfig = _options$iceConfig === void 0 ? {
        servers: []
      } : _options$iceConfig,
      isPublisher = _options.isPublisher,
      offerOverrides = _options.offerOverrides,
      answerOverrides = _options.answerOverrides,
      p2p = _options.p2p,
      codecFlags = _options.codecFlags,
      sourceStreamId = _options.sourceStreamId,
      keyStore = _options.keyStore,
      sFrameClientStore = _options.sFrameClientStore,
      isE2ee = _options.isE2ee,
      removeUnusedCodecs = _options.removeUnusedCodecs,
      sessionId = _options.sessionId;
    // Following block can be modified by subsequent actors when SPC. Please see: addOptions
    // eslint-disable-next-line prefer-const
    let _options2 = options,
      _options2$logAnalytic = _options2.logAnalyticsEvent,
      logAnalyticsEvent = _options2$logAnalytic === void 0 ? noop : _options2$logAnalytic,
      originalSendMessage = _options2.sendMessage;
    let processingOffer = false; // Whether we are currently processing an offer
    let pendingOfferMessage; // An offer we received that is pending waiting on a previous offer
    const replaceBaselineProfile = needsToSwapH264Profiles();
    let offerMessagesReceived = 0; // number of offer or generateoffer messages received
    let renegotiationInProgress = false;
    let asyncSFrameReceiverClients = {};
    let sFrameSenderClient;
    let keyStoreChangeHandler;
    const offerAnswerProcessor = new OfferAnswerProcessor(logAnalyticsEvent);
    const cleanupJobs = (0, _createCleanupJobs.default)();
    function sendMessage(type, payload) {
      if (!hasRelayCandidates) {
        const shouldCheckForRelayCandidates = ['candidate', 'offer', 'answer', 'pranswer'].indexOf(type) > -1;
        if (shouldCheckForRelayCandidates) {
          const message = type === 'candidate' ? payload.candidate : payload.sdp;
          hasRelayCandidates = message.indexOf('typ relay') !== -1;
        }
      }
      originalSendMessage(type, payload);
    }
    const startConnectingTime = (0, _now.default)();
    logAnalyticsEvent('createPeerConnection', 'Attempt');
    const api = {};
    api.id = (0, _uuid.default)();
    const logging = createLog(`PeerConnection:${api.id}`);
    logging.debug('construct', {
      id: api.id,
      options
    });
    const sdpTransforms = sdpTransformDefaults;
    const shouldFilterCandidate = candidate => iceConfig.transportPolicy === 'relay' && candidate != null && candidate.candidate.indexOf('typ relay') === -1;
    const config = (0, _omit.default)(options, ['isPublisher', 'logAnalyticsEvent', 'offerOverrides', 'answerOverrides', 'sendMessage']);
    let _peerConnection, _channels, _offer, _answer, _transitionToFailedTimeOut;
    let _peerConnectionCompletionHandlers = [];
    const _simulcastEnabled = (() => {
      let value = config.overrideSimulcastEnabled || false;
      return {
        get() {
          return value;
        },
        set(newValueParam) {
          const newValue = Boolean(newValueParam) && config.capableSimulcastStreams > 1;
          if (newValue !== value && config.overrideSimulcastEnabled === undefined) {
            value = newValue;
            api.generateOfferAndSend();
          }
        }
      };
    })();
    const _createOfferWithIceRestart = () => {
      if (!api.iceConnectionStateIsConnected()) {
        api.generateOfferAndSend();
      } else {
        logging.debug('iceRestart is going to wait until we disconnect or negotiationNeeded' + ' and then restart ice');
      }
    };
    const _iceRestartNeeded = (() => {
      let value = false;
      return {
        get() {
          return value;
        },
        set(newValueParam) {
          const newValue = Boolean(newValueParam);
          if (newValue !== value) {
            value = newValue;
            if (value) {
              _createOfferWithIceRestart();
            }
          }
        }
      };
    })();
    const _readyToCompleteOffer = {
      clean() {
        delete this.promise;
        delete this.resolve;
        delete this.reject;
      }
    };
    _readyToCompleteOffer.promise = new Promise((resolve, reject) => {
      _readyToCompleteOffer.resolve = resolve;
      _readyToCompleteOffer.reject = reject;
    });
    let _iceProcessor = new IceCandidateProcessor();
    let _state = 'new';
    Object.defineProperty(api, 'signalingState', {
      get() {
        return _peerConnection.signalingState;
      },
      set(val) {
        // obviously they should not be doing this, but we'll mimic what the browser does.
        _peerConnection.signalingState = val;
        return val;
      }
    });
    (0, _eventing.default)(api);
    api.addOptions = opt => {
      logAnalyticsEvent = opt.logAnalyticsEvent;
    };
    api.startEncryption = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(connectionId) {
        var sFrameSenderId, sharedKey;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (isE2ee) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return extractSenderId({
                sessionId,
                connectionId
              });
            case 4:
              sFrameSenderId = _context2.sent;
              _context2.next = 7;
              return sFrameClientStore.createSender(sFrameSenderId);
            case 7:
              sFrameSenderClient = _context2.sent;
              _context2.next = 10;
              return keyStore.get();
            case 10:
              sharedKey = _context2.sent;
              _context2.next = 13;
              return sFrameSenderClient.setSenderEncryptionKey(sharedKey);
            case 13:
              keyStoreChangeHandler = key => {
                sFrameSenderClient.setSenderEncryptionKey(key);
              };
              keyStore.on('keyChanged', keyStoreChangeHandler);

              // SFrame uses the RTCRtpSender objects (transceiver.sender) to extract the video
              // and audio streams from the publisher and then encrypt them.
              _peerConnection.getTransceivers().forEach( /*#__PURE__*/function () {
                var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(transceiver) {
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return sFrameSenderClient.encrypt(sFrameSenderId, transceiver.sender);
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    api.once('iceConnected', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var proxyInfo, payload;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            proxyInfo = '';
            payload = {
              pcc: parseInt((0, _now.default)() - startConnectingTime, 10),
              hasRelayCandidates,
              proxyInfo
            };
            if (_peerConnection && _peerConnection.proxyInfo) payload.proxyInfo = _peerConnection.proxyInfo;
            logAnalyticsEvent('createPeerConnection', 'Success', payload);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    api.startDecryption = /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(connectionId, transceiver) {
        var senderId, receiver, sFrameReceiverClient;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (api.iceConnectionStateIsConnected()) {
                _context4.next = 3;
                break;
              }
              api.once('iceConnected', () => api.startDecryption(connectionId, transceiver));
              return _context4.abrupt("return");
            case 3:
              _context4.next = 5;
              return extractSenderId({
                sessionId,
                connectionId
              });
            case 5:
              senderId = _context4.sent;
              receiver = transceiver.receiver;
              _context4.next = 9;
              return getOrCreateSFrameReceiverClient(senderId);
            case 9:
              sFrameReceiverClient = _context4.sent;
              _context4.prev = 10;
              _context4.next = 13;
              return sFrameReceiverClient == null ? void 0 : sFrameReceiverClient.decrypt(senderId, receiver);
            case 13:
              _context4.next = 18;
              break;
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](10);
              logging.error(_context4.t0);
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[10, 15]]);
      }));
      return function (_x3, _x4) {
        return _ref6.apply(this, arguments);
      };
    }();
    _readyToCompleteOffer.resolve();
    const getOrCreateSFrameReceiverClient = /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(sFrameSenderId) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!asyncSFrameReceiverClients[sFrameSenderId]) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", asyncSFrameReceiverClients[sFrameSenderId]);
            case 2:
              asyncSFrameReceiverClients[sFrameSenderId] = new Promise( /*#__PURE__*/function () {
                var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(resolve) {
                  var sharedKey, sFrameReceiverClient;
                  return _regenerator.default.wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return keyStore.get();
                      case 2:
                        sharedKey = _context5.sent;
                        sFrameReceiverClient = sFrameClientStore.getReceiver(sFrameSenderId);
                        if (sFrameReceiverClient) {
                          _context5.next = 9;
                          break;
                        }
                        _context5.next = 7;
                        return sFrameClientStore.createReceiver(sFrameSenderId);
                      case 7:
                        sFrameReceiverClient = _context5.sent;
                        sFrameReceiverClient.addReceiver(sFrameSenderId);
                      case 9:
                        sFrameReceiverClient.setReceiverEncryptionKey(sFrameSenderId, sharedKey);
                        keyStore.on('keyChanged', key => {
                          sFrameReceiverClient.setReceiverEncryptionKey(sFrameSenderId, key);
                        });
                        sFrameReceiverClient.addEventListener('decryptFailed', () => {
                          api.trigger('decryptFailed');
                        });
                        sFrameReceiverClient.addEventListener('decryptionRestored', () => {
                          api.trigger('decryptRestored');
                        });
                        resolve(sFrameReceiverClient);
                      case 14:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x6) {
                  return _ref8.apply(this, arguments);
                };
              }());
              return _context6.abrupt("return", asyncSFrameReceiverClients[sFrameSenderId]);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function getOrCreateSFrameReceiverClient(_x5) {
        return _ref7.apply(this, arguments);
      };
    }();

    // Create and initialise the PeerConnection object. This deals with
    // any differences between the various browser implementations and
    // our own OTPlugin version.
    //
    // +completion+ is the function is call once we've either successfully
    // created the PeerConnection or on failure.
    //
    const internalCreatePeerConnection = completion => {
      logging.debug('internalCreatePeerConnection: called');
      if (_peerConnection) {
        logging.debug('internalCreatePeerConnection: resolving synchronously');
        completion.call(null, null, _peerConnection);
        return;
      }
      _peerConnectionCompletionHandlers.push(completion);
      if (_peerConnectionCompletionHandlers.length > 1) {
        // The PeerConnection is already being setup, just wait for
        // it to be ready.
        return;
      }
      logging.debug(`Creating peer connection config "${JSON.stringify(config)}".`);
      if (iceConfig.servers.length === 0) {
        // This should never happen unless something is misconfigured
        logging.error('No ice servers present');
        logAnalyticsEvent('Error', 'noIceServers');
      }
      if (iceConfig.transportPolicy === 'relay') {
        const isTurnUrl = url => url && url.indexOf('turn') === 0;
        iceConfig.servers = iceConfig.servers.map(providedServer => {
          const server = (0, _cloneDeep.default)(providedServer);
          if (!Array.isArray(server.urls)) {
            server.urls = [server.urls];
          }
          server.urls = server.urls.filter(isTurnUrl);
          return server.urls.length === 0 ? undefined : server;
        }).filter(server => server !== undefined);
      }
      config.iceTransportPolicy = iceConfig.transportPolicy;
      config.iceServers = iceConfig.servers;
      if (isE2ee) {
        // Let's activate the required properties to enable Insertable Streams.
        config.forceEncodedVideoInsertableStreams = true;
        config.forceEncodedAudioInsertableStreams = true;
        config.encodedInsertableStreams = true;
      }
      futureIsPeerConnectionValid().then(isValid => {
        if (!isValid) {
          logging.error('createPeerConnection: Invalid RTCPeerConnection object');
          throw new Error('Failed to create valid RTCPeerConnection object');
        }
        return createPeerConnection({
          window: windowMock,
          config
        });
      }).then( /*#__PURE__*/function () {
        var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(pc) {
          return _regenerator.default.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                attachEventsToPeerConnection(null, pc);
              case 1:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        return function (_x7) {
          return _ref9.apply(this, arguments);
        };
      }(), err => attachEventsToPeerConnection(err));
    };

    // An auxiliary function to internalCreatePeerConnection. This binds the various event
    // callbacks once the peer connection is created.
    //
    // +err+ will be non-null if an err occured while creating the PeerConnection
    // +pc+ will be the PeerConnection object itself.
    //
    // @todo if anything called in attachEventsToPeerConnection throws it will be
    // silent
    const attachEventsToPeerConnection = (err, pc) => {
      if (err) {
        triggerError({
          reason: `Failed to create PeerConnection, exception: ${err}`,
          prefix: 'NewPeerConnection'
        });
        _peerConnectionCompletionHandlers = [];
        return;
      }
      logging.debug('OT attachEventsToPeerConnection');
      _peerConnection = pc;
      if (_iceProcessor) {
        _iceProcessor.setPeerConnection(pc);
      }
      _channels = new PeerConnectionChannels(_peerConnection);
      if (config.channels) {
        _channels.addMany(config.channels);
      }
      const forwarder = iceCandidateForwarder({
        sendMessage,
        logging
      });
      const onIceCandidate = event => {
        _readyToCompleteOffer.resolve();
        if (shouldFilterCandidate(event.candidate)) {
          logging.debug('Ignore candidate', event.candidate.candidate);
          return;
        }
        forwarder(event);
      };
      const onTrackAdded = /*#__PURE__*/function () {
        var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(event) {
          return _regenerator.default.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                onRemoteTrackAdded(event);
              case 1:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        return function onTrackAdded(_x8) {
          return _ref10.apply(this, arguments);
        };
      }();
      let _previousIceState = _peerConnection.iceConnectionState;
      const onIceConnectionStateChanged = event => {
        if (_peerConnection) {
          logging.debug('iceconnectionstatechange', _peerConnection.iceConnectionState);
          if (_peerConnection.iceConnectionState === 'connected') {
            // Now that the iceConnectionState is connected, let's make sure the transitionToFailedTimeOut
            // is cleared ASAP to avoid triggering an iceConnectionStateChange event to failed.
            if (_previousIceState === 'disconnected') {
              api.clearFailedTimeout();
            }
            api.emit('iceConnected');
            _iceRestartNeeded.set(false);
          } else if (_peerConnection.iceConnectionState === 'completed' && env.isLegacyEdge) {
            // Start collecting stats later in Edge because it fails if you call it sooner
            // This can probably be fixed better in Adapter.js
            setTimeout(() => qos.startCollecting(_peerConnection), 1000);
          }
        } else {
          logging.debug('iceconnectionstatechange on peerConnection that no longer exists', api);
        }
        const newIceState = event.target.iceConnectionState;
        api.trigger('iceConnectionStateChange', newIceState);
        logAnalyticsEvent('attachEventsToPeerConnection', 'iceconnectionstatechange', newIceState);
        if (newIceState === 'disconnected') {
          if (_iceRestartNeeded.get()) {
            logging.debug('Restarting ice!');
            api.generateOfferAndSend();
          } else if (!(0, _shouldUsePlanBSDP.default)()) {
            // We only transition to failed in unified-plan
            // Plan-b will transition natively
            _transitionToFailedTimeOut = setTimeout(() => {
              const iceState = 'failed';
              logAnalyticsEvent('attachEventsToPeerConnection', 'iceconnectionstatechange', iceState);
              _previousIceState = iceState;
              api.trigger('iceConnectionStateChange', iceState);
            }, DISCONNECT_TO_FAILED_TIMEOUT);
          }
        }
        if (_previousIceState !== 'disconnected' && newIceState === 'failed') {
          // the sequence disconnected => failure would indicate an abrupt disconnection (e.g. remote
          // peer closed the browser) or a network problem. We don't want to log that has a connection
          // establishment failure. This behavior is seen only in Chrome 47+

          triggerError({
            reason: 'The stream was unable to connect due to a network error.' + ' Make sure your connection isn\'t blocked by a firewall.',
            prefix: 'ICEWorkflow'
          });
        }
        _previousIceState = newIceState;
      };
      const onNegotiationNeeded = () => {
        logAnalyticsEvent('peerConnection:negotiationNeeded', 'Event');
        if (isPublisher) {
          api.generateOfferAndSend();
        }
        api.trigger('negotiationNeeded');
      };
      _peerConnection.addEventListener('track', onTrackAdded);
      _peerConnection.addEventListener('icecandidate', onIceCandidate);
      _peerConnection.addEventListener('signalingstatechange', routeStateChanged);
      _peerConnection.addEventListener('negotiationneeded', onNegotiationNeeded);
      _peerConnection.addEventListener('iceconnectionstatechange', onIceConnectionStateChanged);
      cleanupJobs.add(() => {
        if (!_peerConnection) {
          return;
        }
        _peerConnection.removeEventListener('track', onTrackAdded);
        _peerConnection.removeEventListener('icecandidate', onIceCandidate);
        _peerConnection.removeEventListener('signalingstatechange', routeStateChanged);
        _peerConnection.removeEventListener('negotiationneeded', onNegotiationNeeded);
        _peerConnection.removeEventListener('iceconnectionstatechange', onIceConnectionStateChanged);
      });
      triggerPeerConnectionCompletion(null);
    };
    const triggerPeerConnectionCompletion = () => {
      while (_peerConnectionCompletionHandlers.length) {
        _peerConnectionCompletionHandlers.shift().call(null);
      }
    };

    // Clean up the Peer Connection and trigger the close event.
    // This function can be called safely multiple times, it will
    // only trigger the close event once (per PeerConnection object)
    const tearDownPeerConnection = () => {
      // Our connection is dead, stop processing ICE candidates
      if (_iceProcessor) {
        _iceProcessor.destroy();
        _iceProcessor = null;
      }
      _peerConnectionCompletionHandlers = [];
      qos.stopCollecting();
      cleanupJobs.releaseAll();
      _readyToCompleteOffer.clean();
      if (_peerConnection !== null) {
        if (_peerConnection.destroy) {
          // OTPlugin defines a destroy method on PCs. This allows
          // the plugin to release any resources that it's holding.
          _peerConnection.destroy();
        }
        _peerConnection = null;
        api.trigger('close');
      }
      api.off();
    };
    const routeStateChanged = event => {
      const newState = event.target.signalingState;
      api.emit('signalingStateChange', newState);
      if (newState === 'stable') {
        api.emit('signalingStateStable');
      }
      if (newState && newState !== _state) {
        _state = newState;
        logging.debug(`stateChange: ${_state}`);
        switch (_state) {
          case 'closed':
            tearDownPeerConnection();
            break;
          default:
        }
      }
    };
    const qosCallback = parsedStats => {
      parsedStats.dataChannels = _channels.sampleQos();
      api.trigger('qos', {
        parsedStats,
        simulcastEnabled: _simulcastEnabled.get()
      });
    };
    const getRemoteStreams = () => {
      let streams;
      if (_peerConnection.getRemoteStreams) {
        streams = _peerConnection.getRemoteStreams();
      } else if (_peerConnection.remoteStreams) {
        streams = _peerConnection.remoteStreams;
      } else {
        throw new Error('Invalid Peer Connection object implements no ' + 'method for retrieving remote streams');
      }

      // Force streams to be an Array, rather than a 'Sequence' object,
      // which is browser dependent and does not behaviour like an Array
      // in every case.
      return Array.prototype.slice.call(streams);
    };

    // PeerConnection signaling
    const onRemoteTrackAdded = event => {
      var _event$streams;
      const track = event.track,
        transceiver = event.transceiver;
      // To be safe we consider this event can be either RTCTrackEvent or MediaStreamEvent type.
      // - RTCTrackEvent.streams => array with all the streams associated with the added track.
      //   Only one stream should be associated to the added track.
      // - MediaStreamEvent.stream => stream added
      const stream = event.stream || ((_event$streams = event.streams) == null ? void 0 : _event$streams[0]);
      logAnalyticsEvent('createPeerConnection', 'TrackAdded');
      api.trigger('trackAdded', {
        stream,
        track,
        transceiver
      });
    };

    // ICE Negotiation messages

    const reportError = (message, reason, prefix) => {
      processingOffer = false;
      triggerError({
        reason: `PeerConnection.offerProcessor ${message}: ${reason}`,
        prefix
      });
    };

    // Process an offer that
    const processOffer = message => {
      if (processingOffer) {
        // If we get multiple pending offer messages we just handle the most recent one
        pendingOfferMessage = message;
        return;
      }
      processingOffer = true;
      logAnalyticsEvent('peerConnection:processOffer', 'Event');
      const offer = new NativeRTCSessionDescription({
        type: 'offer',
        sdp: message.content.sdp
      });
      // Relays +answer+ Answer
      const relayAnswer = answer => {
        processingOffer = false;
        if (_iceProcessor) {
          _iceProcessor.process();
        }
        sendMessage('answer', answer);
        if (!env.isLegacyEdge) {
          qos.startCollecting(_peerConnection, isPublisher);
        }
        if (pendingOfferMessage) {
          processOffer(pendingOfferMessage);
          pendingOfferMessage = null;
        }
      };
      const onRemoteVideoSupported = supported => api.trigger('remoteVideoSupported', supported);
      internalCreatePeerConnection(() => {
        offerProcessor(_peerConnection, windowMock.RTCPeerConnection, windowMock.RTCSessionDescription, NativeRTCSessionDescription, sdpTransforms, offer, codecFlags, p2p, relayAnswer, reportError, onRemoteVideoSupported, replaceBaselineProfile, sourceStreamId);
      });
    };
    const processAnswer = message => {
      logAnalyticsEvent('peerConnection:processAnswer', 'Event');
      const errorMessageFixedInChrome71 = 'Failed to parse SessionDescription. a=extmap-allow-mixed Expects at least 2 fields.';
      const failure = errorReason => {
        if (typeof errorReason.includes === 'function' && errorReason.includes(errorMessageFixedInChrome71)) {
          errorReason = 'SessionDescription issue has been fixed in Chrome 71 and above. Please update your browser.';
        }
        triggerError({
          reason: `Error while setting RemoteDescription ${errorReason}`,
          prefix: 'SetRemoteDescription'
        });
      };
      if (!message.content.sdp) {
        failure('Weird answer message, no SDP.');
        return;
      }
      _answer = new NativeRTCSessionDescription({
        type: 'answer',
        sdp: applySdpTransform(sdpTransforms, 'remote', 'answer', (0, _assign.default)({
          replaceBaselineProfile
        }, answerOverrides), message.content.sdp).local
      });
      (() => {
        const success = () => {
          logging.debug('processAnswer: setRemoteDescription Success');
          if (_iceProcessor) {
            _iceProcessor.process();
          }
        };
        _peerConnection.setRemoteDescription(_answer).then(success).catch(failure);

        // Once answer is received, the offerAnswer process is resolved.
        offerAnswerProcessor.setResolved();
      })();
      if (!env.isLegacyEdge) {
        qos.startCollecting(_peerConnection, isPublisher);
      }
    };
    const processSubscribe = onOfferCreated => {
      var _peerConnection2, _peerConnection2$sign;
      if (((_peerConnection2 = _peerConnection) == null ? void 0 : (_peerConnection2$sign = _peerConnection2.signalingState) == null ? void 0 : _peerConnection2$sign.toLowerCase()) === 'closed') {
        return;
      }
      logAnalyticsEvent('peerConnection:processSubscribe', 'Event');
      logging.debug('processSubscribe: Sending offer to subscriber.');
      let numSimulcastStreams = _simulcastEnabled.get() ? config.capableSimulcastStreams : 1;

      // When transitioning from Mantis to P2P, in order to ensure the video quality we must
      // send only one video layer, regardless that simulcast is enabled.
      const isAdaptiveP2pSourceStreamId = sourceStreamId === 'P2P' && !p2p;
      if (isAdaptiveP2pSourceStreamId) {
        numSimulcastStreams = 1;
      }
      internalCreatePeerConnection(() => {
        subscribeProcessor({
          peerConnection: _peerConnection,
          NativeRTCSessionDescription,
          sdpTransforms,
          numSimulcastStreams,
          removeVideoOrientation: hasPictureInPictureBug(),
          offerOverrides,
          offerConstraints: {
            iceRestart: _iceRestartNeeded.get()
          },
          replaceBaselineProfile,
          removeUnusedCodecs
        }).then(offer => {
          logging.debug('processSubscribe: got offer, waiting for ' + '_readyToCompleteOffer');
          _offer = offer;
          _readyToCompleteOffer.promise.then(() => onOfferCreated(_offer));
        }, error => {
          triggerError({
            reason: `subscribeProcessor ${error.message}: ${error.reason}`,
            prefix: error.prefix
          });
        });
        _iceRestartNeeded.set(false);
      });
    };
    const cleanupSFrameClients = () => {
      if (typeof keyStoreChangeHandler === 'function') {
        keyStore.off('keyChanged', keyStoreChangeHandler);
      }
      sFrameSenderClient = null;
      asyncSFrameReceiverClients = null;
    };
    api.setSendMessage = newSendMessage => {
      originalSendMessage = newSendMessage;
    };
    api.generateOfferAndSend = () => {
      const offerSender = offer => {
        logging.debug('processSubscribe: sending offer');
        sendMessage('offer', offer);
      };
      api.generateOffer(offerSender);
    };
    api.generateOffer = debounce(function (onOfferCreated) {
      if (onOfferCreated === void 0) {
        onOfferCreated = () => {};
      }
      // processSubscribe will handle offer creation, thus it is enqueued.
      offerAnswerProcessor.enqueueOfferAnswer(() => processSubscribe(onOfferCreated));
    }, 100);
    const triggerError = _ref11 => {
      let reason = _ref11.reason,
        prefix = _ref11.prefix;
      logging.error(reason, 'in state', !_peerConnection ? '(none)' : {
        connectionState: _peerConnection.connectionState,
        iceConnectionState: _peerConnection.iceConnectionState,
        iceGatheringState: _peerConnection.iceGatheringState,
        signalingState: _peerConnection.signalingState
      });
      api.trigger('error', {
        reason,
        prefix
      });
    };

    /*
    * Add a track to the underlying PeerConnection
    *
    * @param {object} track - the track to add
    * @param {object} stream - the stream to add it to
    * @return {RTCRtpSender}
    */
    api.addTrack = (track, stream) => {
      const promise = new Promise((resolve, reject) => {
        internalCreatePeerConnection(err => {
          if (err) {
            return reject(err);
          }
          resolve();
          return undefined;
        });
      }).then(() => {
        if (_peerConnection.addTrack) {
          return _peerConnection.addTrack(track, stream);
        }
        const pcStream = _peerConnection.getLocalStreams()[0];
        if (pcStream === undefined) {
          throw new Error('PeerConnection has no existing streams, cannot addTrack');
        }
        pcStream.addTrack(track);
        api.generateOfferAndSend();
        return undefined;
      }).then(() => new Promise(resolve => {
        api.once('signalingStateStable', () => {
          resolve();
        });
      }));
      return (0, _pTimeout.default)(promise, 15000, 'Renegotiation timed out');
    };
    function FakeRTCRtpSender(track) {
      this.track = track;
    }
    api.setIceConfig = newIceConfig => {
      try {
        // Firefox does not follow the spec laid out in MDN for attempts to change the certs
        // after they've already been set. The documentation states the following about certificates:
        // once the certificates have been set, this property is ignored in future calls to
        // RTCPeerConnection.setConfiguration().
        if (env.isFirefox) {
          newIceConfig.certificates = _peerConnection.getConfiguration().certificates;
        }
        _peerConnection.setConfiguration(newIceConfig);
      } catch (err) {
        throw new _error.default(`A peer connection failed to set configuration with ${err.message}`, Errors.FAILED_SET_CONFIGURATION);
      }
      _iceRestartNeeded.set(true);
      return _peerConnection;
    };

    /**
     * Remove a track from the underlying PeerConnection
     *
     * @param {RTCRtpSender} RTCRtpSender - the RTCRtpSender to remove
     */
    api.removeTrack = RTCRtpSender => {
      const promise = Promise.resolve().then(() => {
        if (RTCRtpSender instanceof FakeRTCRtpSender) {
          _peerConnection.getLocalStreams()[0].removeTrack(RTCRtpSender.track);
          api.generateOfferAndSend();
          return undefined;
        }
        return _peerConnection.removeTrack(RTCRtpSender);
      }).then(() => new Promise(resolve => {
        api.once('signalingStateStable', () => {
          resolve();
        });
      }));
      return (0, _pTimeout.default)(promise, 15000, 'Renegotiation timed out');
    };
    api.addLocalStream = webRTCStream => new Promise((resolve, reject) => {
      internalCreatePeerConnection(err => {
        if (err) {
          reject(err);
          return;
        }
        try {
          // only node does not support getTracks
          if (webRTCStream.getTracks) {
            webRTCStream.getTracks().forEach(track => _peerConnection.addTrack(track, webRTCStream));
          }
        } catch (addStreamErr) {
          reject(addStreamErr);
          return;
        }
        resolve();
      }, webRTCStream);
    });
    api.getLocalStreams = () => _peerConnection.getLocalStreams();
    api.getSenders = () => {
      if (_peerConnection.getSenders) {
        return _peerConnection.getSenders();
      }
      return _peerConnection.getLocalStreams()[0].getTracks().map(track => new FakeRTCRtpSender(track));
    };
    api.disconnect = () => {
      var _peerConnection3;
      if (_iceProcessor) {
        _iceProcessor.destroy();
        _iceProcessor = null;
      }
      if ((_peerConnection3 = _peerConnection) != null && _peerConnection3.signalingState && _peerConnection.signalingState.toLowerCase() !== 'closed') {
        _peerConnection.close();
        cleanupSFrameClients();
        setTimeout(tearDownPeerConnection);
      }
    };
    api.iceRestart = () => _iceRestartNeeded.set(true);
    api.clearFailedTimeout = () => clearTimeout(_transitionToFailedTimeOut);
    const disableMedia = shouldDisable => {
      const mediaHandler = shouldDisable ? deactivateMedia : reactivateMedia;
      const mediaHandlerPromise = new Promise(resolve => {
        offerAnswerProcessor.enqueueOfferAnswer( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
          return _regenerator.default.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return mediaHandler(_peerConnection);
              case 2:
                // No answer is expected, thus the offerAnswer process is resolved.
                offerAnswerProcessor.setResolved();
                resolve();
              case 4:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        })));
      });
      return mediaHandlerPromise;
    };

    // Change media direction to RECVONLY enables to send media.
    api.changeMediaDirectionToRecvOnly = () => disableMedia(false);

    // Change media direction to INACTIVE stops sending media.
    api.changeMediaDirectionToInactive = () => disableMedia(true);
    api.processMessage = (type, message) => {
      logging.debug(`processMessage: Received ${type} from ${message.fromAddress}`, message);
      logging.debug(message);
      switch (type) {
        case 'generateoffer':
          if (message.content && message.content.simulcastEnabled !== undefined) {
            _simulcastEnabled.set(message.content.simulcastEnabled);
          }
          api.generateOfferAndSend();
          trackRenegotiationAttempts();
          break;
        case 'offer':
          processOffer(message);
          trackRenegotiationAttempts();
          break;
        case 'answer':
        case 'pranswer':
          processAnswer(message);
          break;
        case 'candidate':
          var iceCandidate = new NativeRTCIceCandidate(message.content);
          if (_iceProcessor) {
            _iceProcessor.addIceCandidate(iceCandidate).catch(err => {
              // Sometimes you might get an error adding an iceCandidate
              // this does not mean we should fail, if we get a working candidate
              // later then we should let it work
              logging.warn(`Error while adding ICE candidate: ${JSON.stringify(iceCandidate)}: ${err.toString()}`);
            });
          }
          break;
        default:
          logging.debug(`processMessage: Received an unexpected message of type ${type} from ${message.fromAddress}: ${JSON.stringify(message)}`);
      }
      function trackRenegotiationAttempts() {
        offerMessagesReceived += 1;
        qos.handleOfferMessageReceived();
        if (offerMessagesReceived > 1) {
          logAnalyticsEvent('Renegotiation', 'Attempt');
          renegotiationInProgress = true;
        }
      }
      return api;
    };
    const _sortTransceivers = transceivers => {
      // Tranceivers are sorted in reverse order, so we only stop the first transceiver in the
      // PC once.
      const sorter = (t1, t2) => {
        // This will swap the positions between t1 and t2.
        if (t1.mid < t2.mid) {
          return 1;
        }
        // This will keep the same positions.
        if (t1.mid > t2.mid) {
          return -1;
        }
        // This should not happen, but just to be safe.
        return 0;
      };
      return transceivers.sort(sorter);
    };
    const _getTransceivers = transceiverIds => _peerConnection.getTransceivers().filter(transceiver => transceiverIds.includes(transceiver.mid));
    api.stopTransceivers = transceiverIds => {
      // transceivers provides an array of transceiver.mid. This will stop every transceiver
      // provided in the PC.
      const transceiversToStop = _getTransceivers(transceiverIds);
      _sortTransceivers(transceiversToStop).forEach(transceiver => transceiver.stop());
    };
    api.setTransceiversToInactive = transceiverIds => {
      const transceivers = _getTransceivers(transceiverIds);
      transceivers.forEach(transceiver => {
        transceiver.direction = _mediaDirection.default.INACTIVE;
      });
    };
    api.remoteStreams = () => _peerConnection ? getRemoteStreams() : [];
    api.remoteTracks = () => {
      if (!_peerConnection) {
        return [];
      }
      if (_peerConnection.getReceivers) {
        return Array.prototype.slice.apply(_peerConnection.getReceivers()).map(receiver => receiver.track);
      }
      return Array.prototype.concat.apply([], getRemoteStreams().map(stream => stream.getTracks()));
    };
    api.remoteDescription = () => _peerConnection.remoteDescription;

    /**
     * @param {function(DOMError, Array<RTCStats>)} callback
     */
    api.getStats = (track, callback) => {
      if (!_peerConnection) {
        const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
        callback(new _error.default(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
          code: errorCode
        }));
        return;
      }
      getStatsAdapter(_peerConnection, track, callback);
    };

    /**
     * @param {function(DOMError, RTCStatsReport)} callback
     */
    api.getRtcStatsReport = (track, callback) => {
      if (!_peerConnection) {
        const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
        callback(new _error.default(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
          code: errorCode
        }));
        return;
      }
      getRtcStatsReportAdapter(_peerConnection, track, callback);
    };
    api.getSynchronizationSources = callback => {
      if (!isPublisher) {
        if (!_peerConnection) {
          const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
          callback(new _error.default(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
            code: errorCode
          }));
          return;
        }
        getSynchronizationSources(_peerConnection, callback);
      }
    };
    const waitForChannel = function waitForChannel(timesToWait, label, channelOptions, completion) {
      let err;
      const channel = _channels.get(label, channelOptions);
      if (!channel) {
        if (timesToWait > 0) {
          setTimeout(waitForChannel.bind(null, timesToWait - 1, label, channelOptions, completion), 200);
          return;
        }
        err = new _error.default(`${'A channel with that label and options could not be found. ' + 'Label:'}${label}. Options: ${JSON.stringify(channelOptions)}`);
      }
      completion(err, channel);
    };
    api.getDataChannel = (label, channelOptions, completion) => {
      if (!_peerConnection) {
        completion(new _error.default('Cannot create a DataChannel before there is a connection.'));
        return;
      }
      // Wait up to 20 sec for the channel to appear, then fail
      waitForChannel(100, label, channelOptions, completion);
    };
    api.getSourceStreamId = () => sourceStreamId;
    api.iceConnectionStateIsConnected = () => _peerConnection && ['connected', 'completed'].indexOf(_peerConnection.iceConnectionState) > -1;
    api.hasTrack = track => _peerConnection.getSenders().some(sender => sender.track === track);
    api.findAndReplaceTrack = (oldTrack, newTrack) => Promise.resolve().then(() => {
      const sender = _peerConnection.getSenders().filter(s => s.track === oldTrack)[0];
      if (!sender) {
        // There is no video track to replace but this is OK
        // they probably called cycleVideo on an audio only Publisher
        // or on a Publisher that does not support the videoCodec
        return Promise.resolve();
      }
      if (typeof sender.replaceTrack !== 'function') {
        throw new Error('Sender does not support replaceTrack');
      }
      return sender.replaceTrack(newTrack);
    });
    api.hasRelayCandidates = () => hasRelayCandidates;
    api.getNegotiatedCodecs = () => {
      if (!_peerConnection.localDescription || !_peerConnection.remoteDescription) {
        return null;
      }
      const getForMediaType = mediaType => (0, _intersection.default)(_sdp_helpers.default.getCodecs(_peerConnection.localDescription.sdp, mediaType), _sdp_helpers.default.getCodecs(_peerConnection.remoteDescription.sdp, mediaType));
      return {
        audio: getForMediaType('audio'),
        video: getForMediaType('video')
      };
    };
    api.on('signalingStateStable', () => {
      if (renegotiationInProgress) {
        renegotiationInProgress = false;
        logAnalyticsEvent('Renegotiation', 'Success', api.getNegotiatedCodecs());
      }
    });
    api.on('error', _ref13 => {
      let prefix = _ref13.prefix;
      if (renegotiationInProgress && ['CreateOffer', 'SetRemoteDescription'].indexOf(prefix) !== -1) {
        renegotiationInProgress = false;
        logAnalyticsEvent('Renegotiation', 'Failure');
      }
    });
    api.on('close', () => {
      if (renegotiationInProgress) {
        renegotiationInProgress = false;
        logAnalyticsEvent('Renegotiation', 'Cancel');
      }
    });
    const qos = new Qos();
    qos.on('stats', qosCallback);
    return api;
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
const enforcesUnifiedPlan = () =>
// Chromium-based browsers version M90 logs a warning that Plan B is being removed
(_env.default.isChrome || _env.default.isElectron) && _env.default.version >= 90 || _env.default.isOpera && _env.default.version >= 76;
var _default = () => !enforcesUnifiedPlan() && (
// For legacy browsers, we still enforce Plan B
_env.default.isChrome && _env.default.version > 71 || _env.default.isChromiumEdge && _env.default.version < 90 || _env.default.isOpera && _env.default.version > 58);
exports.default = _default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const AudioFallbackVideoStates = {
  ACTIVE_VIDEO: 0,
  ACTIVE_VIDEO_WITH_WARNING: 1,
  SUSPENDED_VIDEO: 2
};
var _default = AudioFallbackVideoStates;
exports.default = _default;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _pick = _interopRequireDefault(__webpack_require__(39));
var _mapValues = _interopRequireDefault(__webpack_require__(700));
var _isObject = _interopRequireDefault(__webpack_require__(11));
var _calculateFrameRate = _interopRequireDefault(__webpack_require__(168));
const frameRateTrackers = {};
function getFrameRate(stat) {
  return Number(stat.framerateMean || stat.googFrameRateSent || stat.googFrameRateReceived || stat.googFrameRateInput || stat.googFrameRateOutput || 0);
}
function getFrames(stat) {
  return Number(stat.framesEncoded || stat.framesDecoded);
}
function calcFrameRate(stat, startTime) {
  if (getFrameRate(stat)) {
    return getFrameRate(stat);
  }
  if (!getFrames(stat)) {
    return undefined;
  }
  let frameRate = 0;
  const prevStatFrames = frameRateTrackers[stat.id] ? frameRateTrackers[stat.id].frames : 0;
  const prevTimestamp = frameRateTrackers[stat.id] ? frameRateTrackers[stat.id].timestamp : startTime;
  frameRate = (0, _calculateFrameRate.default)({
    currentStatFrames: getFrames(stat),
    currentTimestamp: stat.timestamp,
    prevStatFrames,
    prevTimestamp
  });
  frameRateTrackers[stat.id] = {
    frames: getFrames(stat),
    timestamp: stat.timestamp
  };
  return frameRate;
}
function getLinkedTrack(stat, allStats) {
  if (!allStats) {
    return {};
  }
  const linkedTrack = allStats.filter(x => x.id === stat.mediaTrackId);
  return linkedTrack.length ? linkedTrack[0] : {};
}
function totalPacketsLostReducer(totalPacketsLost, stat) {
  if ('packetsLost' in stat) {
    return totalPacketsLost + stat.packetsLost;
  }
  return totalPacketsLost;
}
const getStatsHelpers = {
  isVideoStat(stat, allStats) {
    const linkedTrack = getLinkedTrack(stat, allStats);
    // When kind is 'video', we need to check the type since there are other
    // stats with kind 'video' without the information we need.
    const isVideoKind = stat.kind === 'video' && ['outbound-rtp', 'inbound-rtp'].includes(stat.type);
    return isVideoKind || stat.mediaType === 'video' || 'googFrameWidthReceived' in stat ||
    // Old Chrome
    'googFrameWidthInput' in stat ||
    // Old Chrome
    stat.type === 'inbound-rtp' && stat.id.indexOf('Video') !== -1 ||
    // Safari
    stat.type === 'inboundrtp' && linkedTrack.frameWidth !== 0; // Edge
  },

  isAudioStat(stat, allStats) {
    const linkedTrack = getLinkedTrack(stat, allStats);
    // When kind is 'audio', we need to check the type since there are other
    // stats with kind 'audio' without the information we need.
    const isAudioKind = stat.kind === 'audio' && ['outbound-rtp', 'inbound-rtp'].includes(stat.type);
    return isAudioKind || stat.mediaType === 'audio' || 'audioInputLevel' in stat ||
    // Old Chrome
    'audioOutputLevel' in stat ||
    // Old Chrome
    stat.type === 'inbound-rtp' && stat.id.indexOf('Audio') !== -1 ||
    // Safari
    stat.type === 'inboundrtp' && linkedTrack.frameWidth === 0; // Edge;
  },

  isInboundStat(stat) {
    return 'bytesReceived' in stat || 'packetsReceived' in stat;
  },
  isOutboundStat(stat) {
    return 'bytesSent' in stat || 'packetsSent' in stat;
  },
  isVideoTrackStat(stat) {
    return stat.type === 'track' && (stat.frameHeight > 0 || stat.frameWidth > 0 || stat.framesCorrupted > 0 || stat.framesDecoded > 0 || stat.framesPerSecond > 0 || stat.framesSent > 0 || stat.framesReceived > 0);
  },
  isVideoRemoteInboundRtpStat(stat) {
    return stat.type === 'remote-inbound-rtp' && stat.kind === 'video';
  },
  isAudioRemoteInboundRtpStat(stat) {
    return stat.type === 'remote-inbound-rtp' && stat.kind === 'audio';
  },
  isVideoInboundRtpStat(stat) {
    return stat.type === 'inbound-rtp' && stat.kind === 'video';
  },
  parseStatCategory(stat) {
    const statCategory = {
      packetsLost: 0,
      packetsReceived: 0,
      bytesReceived: 0
      // frameRate is only set for video stat
    };

    if ('packetsReceived' in stat) {
      statCategory.packetsReceived = parseInt(stat.packetsReceived, 10);
    }
    if ('packetsLost' in stat) {
      statCategory.packetsLost = parseInt(stat.packetsLost, 10);
    }
    if ('bytesReceived' in stat) {
      statCategory.bytesReceived = parseInt(stat.bytesReceived, 10);
    }
    if (this.isVideoStat(stat)) {
      if ('framerateMean' in stat) {
        statCategory.frameRate = Number(stat.framerateMean);
      } else if ('googFrameRateOutput' in stat) {
        statCategory.frameRate = Number(stat.googFrameRateOutput);
      } else if ('googFrameRateInput' in stat) {
        statCategory.frameRate = Number(stat.googFrameRateInput);
      }
    }
    return statCategory;
  },
  getVideoPacketsLost(stats) {
    return stats.filter(stat => this.isVideoRemoteInboundRtpStat(stat, stats)).reduce(totalPacketsLostReducer, 0);
  },
  getAudioPacketsLost(stats) {
    return stats.filter(stat => this.isAudioRemoteInboundRtpStat(stat, stats)).reduce(totalPacketsLostReducer, 0);
  },
  normalizeTimestamp(timestamp, now) {
    if (now === void 0) {
      now = Date.now();
    }
    if ((0, _isObject.default)(timestamp) && 'getTime' in timestamp) {
      // Chrome as of 39 delivers a "kind of Date" object for timestamps
      // we duck check it and get the timestamp
      return timestamp.getTime();
    }
    if (Math.abs(timestamp / (1000 * now) - 1) < 0.05) {
      // If the timestamp is within 5% of 1000x now, we assume its unit is microseconds and
      // divide by 1000 to correct for this.
      return timestamp / 1000;
    }
    return timestamp;
  },
  normalizeStats(stats, inbound, startTime) {
    if (inbound === void 0) {
      inbound = true;
    }
    const videos = stats.filter(stat => getStatsHelpers.isVideoStat(stat, stats)).filter(stat => getStatsHelpers.isInboundStat(stat) === inbound);
    const audio = stats.filter(stat => this.isAudioStat(stat, stats)).filter(stat => this.isInboundStat(stat) === inbound)[0];

    // There may be more than one video stream (e.g., when simulcast is enabled)
    // We just need to grab one of them for its id and timestamp
    const video = videos[0];
    if (!audio && !video) {
      throw new Error('could not find stats for either audio or video');
    }
    const timestamp = getStatsHelpers.normalizeTimestamp(video ? video.timestamp : audio.timestamp);
    const otStats = {
      timestamp
    };
    if (video && !inbound && video.packetsLost === undefined) {
      video.packetsLost = this.getVideoPacketsLost(stats);
    }
    if (audio && !inbound && audio.packetsLost === undefined) {
      audio.packetsLost = this.getAudioPacketsLost(stats);
    }
    const outboundStatNames = ['packetsSent', 'packetsLost', 'bytesSent'];
    const getOutboundStats = stat => (0, _pick.default)(stat, outboundStatNames);
    const getInboundStats = stat => (0, _pick.default)(stat, ['packetsReceived', 'packetsLost', 'bytesReceived']);
    const getCommonStats = inbound ? getInboundStats : getOutboundStats;
    const accumulateVideoStats = videoArray => {
      // We want to accumulate all these stats, if they exist.
      const frameStats = ['framerateMean', 'googFrameRateSent', 'googFrameRateReceived', 'googFrameRateInput', 'googFrameRateOutput', 'framesEncoded', 'framesDecoded'];
      const outboundStatNamesWithFrames = outboundStatNames.concat(frameStats);
      const accumulatedVideo = {
        timestamp,
        id: video.id
      };
      outboundStatNamesWithFrames.forEach(statName => {
        accumulatedVideo[statName] = videoArray.map(x => Number(x[statName] || 0)).reduce((accumulator, stat) => accumulator + stat, 0);
      });
      return accumulatedVideo;
    };
    if (videos && videos.length > 0) {
      const accumulatedVideo = accumulateVideoStats(videos);
      otStats.video = Object.assign({
        frameRate: calcFrameRate(accumulatedVideo, startTime)
      }, (0, _mapValues.default)(getCommonStats(accumulatedVideo), Number));
    }
    if (audio) {
      otStats.audio = (0, _mapValues.default)(getCommonStats(audio), Number);
    }
    return otStats;
  }
};
var _default = getStatsHelpers;
exports.default = _default;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.messages = exports.default = exports.codes = void 0;
// https://tools.ietf.org/html/rfc6455#section-7.4.1
// https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code

const messages = {
  1000: 'The connection successfully completed the purpose for which it was created.',
  1001: 'The endpoint is going away, either because of a server failure or because the browser ' + 'is navigating away from the page that opened the connection.',
  1002: 'The endpoint is terminating the connection due to a protocol error. ' + '(CLOSE_PROTOCOL_ERROR)',
  1003: 'The connection is being terminated because the endpoint has indicated ' + 'that reconnections are not available. (CLOSE_UNSUPPORTED)',
  1005: 'Indicates that no status code was provided even though one was expected. ' + '(CLOSE_NO_STATUS)',
  1006: 'Used to indicate that a connection was closed abnormally (that is, with no ' + 'close frame being sent) when a status code is expected. (CLOSE_ABNORMAL)',
  1007: 'Indicates that an endpoint is terminating the connection because it has received ' + 'data within a message that was not consistent with the type of the message (e.g., ' + 'non-UTF-8 [RFC3629] data within a text message)',
  1008: 'Indicates that an endpoint is terminating the connection because it has received a ' + 'message that violates its policy.  This is a generic status code that can be returned ' + 'when there is no other more suitable status code (e.g., 1003 or 1009) or if there is a ' + 'need to hide specific details about the policy',
  1009: 'Indicates that an endpoint is terminating the connection because it has received a ' + 'message that is too big for it to process (CLOSE_TOO_LARGE)',
  1011: 'Indicates that a server is terminating the connection because it encountered an ' + 'unexpected condition that prevented it from fulfilling the request',
  // ... codes in the 4000-4999 range are available for use by applications.
  4001: 'Connectivity loss was detected as it was too long since the socket received the ' + 'last PONG message',
  4010: 'Timed out while waiting for the Rumor socket to connect.',
  4020: 'Error code unavailable.',
  4030: 'Exception was thrown during Rumor connection, possibly because of a blocked port.'
};
exports.messages = messages;
const codes = {
  CLOSE_NORMAL: 1000,
  CLOSE_GOING_AWAY: 1001,
  CLOSE_PROTOCOL_ERROR: 1002,
  CLOSE_UNSUPPORTED: 1003,
  CLOSE_NO_STATUS: 1005,
  CLOSE_ABNORMAL: 1006,
  CLOSE_INCONSISTENT_DATA: 1007,
  CLOSE_POLICY_VIOLATION: 1008,
  CLOSE_TOO_LARGE: 1009,
  CLOSE_UNEXPECTED_CONDITION: 1011,
  CLOSE_CONNECTIVITY_LOSS: 4001,
  CLOSE_TIMEOUT: 4010,
  CLOSE_FALLBACK_CODE: 4020,
  CLOSE_CONNECT_EXCEPTION: 4030,
  ALREADY_CONNECTED_CONNECTING: null
};
exports.codes = codes;
var _default = {
  messages,
  codes
};
exports.default = _default;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(81),
    arrayEach = __webpack_require__(118),
    assignValue = __webpack_require__(86),
    baseAssign = __webpack_require__(192),
    baseAssignIn = __webpack_require__(400),
    cloneBuffer = __webpack_require__(195),
    copyArray = __webpack_require__(56),
    copySymbols = __webpack_require__(403),
    copySymbolsIn = __webpack_require__(405),
    getAllKeys = __webpack_require__(198),
    getAllKeysIn = __webpack_require__(200),
    getTag = __webpack_require__(45),
    initCloneArray = __webpack_require__(408),
    initCloneByTag = __webpack_require__(409),
    initCloneObject = __webpack_require__(205),
    isArray = __webpack_require__(14),
    isBuffer = __webpack_require__(66),
    isMap = __webpack_require__(413),
    isObject = __webpack_require__(11),
    isSet = __webpack_require__(415),
    keys = __webpack_require__(34),
    keysIn = __webpack_require__(55);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(82),
    stackClear = __webpack_require__(372),
    stackDelete = __webpack_require__(373),
    stackGet = __webpack_require__(374),
    stackHas = __webpack_require__(375),
    stackSet = __webpack_require__(376);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(367),
    listCacheDelete = __webpack_require__(368),
    listCacheGet = __webpack_require__(369),
    listCacheHas = __webpack_require__(370),
    listCacheSet = __webpack_require__(371);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(54);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(42);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(391);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(64),
    eq = __webpack_require__(54);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(398),
    baseUnary = __webpack_require__(68),
    nodeUtil = __webpack_require__(120);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(91),
    overRest = __webpack_require__(208),
    setToString = __webpack_require__(127);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var objToString = Object.prototype.toString
  , id = objToString.call((function () { return arguments; })());

module.exports = function (value) { return objToString.call(value) === id; };


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var objToString = Object.prototype.toString, id = objToString.call("");

module.exports = function (value) {
	return (
		typeof value === "string" ||
		(value &&
			typeof value === "object" &&
			(value instanceof String || objToString.call(value) === id)) ||
		false
	);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(442)() ? globalThis : __webpack_require__(443);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

exports.__esModule = true;
exports.default = promiseDelay;
function promiseDelay(timeoutMs) {
  return new Promise(resolve => setTimeout(resolve, timeoutMs));
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var utils = __webpack_require__(13);
var AxiosError = __webpack_require__(49);
var envFormData = __webpack_require__(485);

function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

var predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

function isSpecCompliant(thing) {
  return thing && utils.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 * @returns {Object}
 **/

function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (envFormData || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  var metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  var visitor = options.visitor || defaultVisitor;
  var dots = options.dots;
  var indexes = options.indexes;
  var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  var useBlob = _Blob && isSpecCompliant(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    var arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        (utils.isFileList(value) || utils.endsWith(key, '[]') && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  var stack = [];

  var exposedHelpers = Object.assign(predicates, {
    defaultVisitor: defaultVisitor,
    convertValue: convertValue,
    isVisitable: isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      var result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

module.exports = toFormData;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(225).Buffer))

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(49);
var utils = __webpack_require__(13);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(89),
    isObject = __webpack_require__(11);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(521);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(527);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(117),
    setCacheAdd = __webpack_require__(537),
    setCacheHas = __webpack_require__(538);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(60),
    toKey = __webpack_require__(50);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(257),
    keys = __webpack_require__(34);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _url = _interopRequireDefault(__webpack_require__(258));
const stripTrailingSlash = url => url.replace(/\/$/, '');
const prependProxyToUrlIfNeeded = (url, proxyUrl) => {
  if (!proxyUrl) return url;
  const proxyUrlParsed = _url.default.parse(proxyUrl);
  const urlParsed = _url.default.parse(url);
  if (!proxyUrlParsed.protocol || !urlParsed.protocol) return url;
  const isSsl = proxyUrlParsed.protocol.match(/^https/);
  const isWs = urlParsed.protocol.match(/^ws/i);
  const protocol = (isWs ? 'ws' : 'http') + (isSsl ? 's' : '');
  const targetUrl = stripTrailingSlash(`${protocol}://${proxyUrlParsed.host}${proxyUrlParsed.pathname}`);
  const targetPath = stripTrailingSlash(`${urlParsed.host}${urlParsed.pathname}${urlParsed.search || ''}`);
  return `${targetUrl}/${targetPath}`;
};
var _default = prependProxyToUrlIfNeeded;
exports.default = _default;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
let currentAudioOutputDeviceId = '';
const setCurrentAudioOutputDeviceId = newDeviceId => {
  currentAudioOutputDeviceId = newDeviceId;
};
const getCurrentAudioOutputDeviceId = () => currentAudioOutputDeviceId;
const currentAudioOutputDevice = {
  getCurrentAudioOutputDeviceId,
  setCurrentAudioOutputDeviceId
};
var _default = currentAudioOutputDevice;
exports.default = _default;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = defineProperties;
var _assign = _interopRequireDefault(__webpack_require__(9));
const generatePropertyFunction = (object, getter, setter) => {
  if (getter && !setter) {
    return () => getter.call(object);
  }
  if (getter && setter) {
    return value => {
      if (value !== undefined) {
        setter.call(object, value);
      }
      return getter.call(object);
    };
  }
  return value => {
    if (value !== undefined) {
      setter.call(object, value);
    }
  };
};

/**
 * @typedef getterSetterDefinition
 * @property {function(): any} get the function called when accessing the value
 * @property {function(any): void} set the function called when setting the value
 */

/**
 * Creates primitive getters/ setters on objects
 *
 * For every key in gettersSetters, a method will be added to object.
 *
 * When the method is called with no value, it will call the getter
 * When the method is called with a value, it will call the setter with the value
 *
 * @deprecated Prefer using real getters and setters
 *
 * @param {any} object
 * @param {Object.<string, getterSetterDefinition>} getterSetters
 */

function defineProperties(object, getterSetters) {
  const mixin = {};
  Object.keys(getterSetters).forEach(key => {
    mixin[key] = generatePropertyFunction(object, getterSetters[key].get, getterSetters[key].set);
  });
  (0, _assign.default)(object, mixin);
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _NativeVideoElementWrapper = _interopRequireDefault(__webpack_require__(206));
/**
 * VideoElementFacadeFactory DI Container for VideoElementFacade
 *
 * @package
 * @param {Object} [dependencies]
 * @param {typeof NativeVideoElementWrapper} [dependencies.NativeVideoElementWrapper]
 * @return {typeof VideoElementFacade}
 */
function VideoElementFacadeFactory(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$NativeVideoEleme = _ref.NativeVideoElementWrapper,
    NativeVideoElementWrapper = _ref$NativeVideoEleme === void 0 ? (0, _NativeVideoElementWrapper.default)() : _ref$NativeVideoEleme;
  const VideoElementWrapper = NativeVideoElementWrapper;
  const defaultAudioVolume = 50;

  /**
   * Create a new VideoElementFacade
   *
   * Was used to simplify the strategy between Plugin and Native.
   *
   * @todo This needs to go.
   *
   * Note: Could VideoElementFacade not exist? Could it just be an expected interface
   * for VideoElementWrapper which could be either PluginVideoElementWrapper or
   * NativeVideoElementWrapper
   *
   * @package
   * @class
   * @param {Object} [config]
   * @param {String} [config.fallbackText] displayed when WebRTC is not supported
   * @param {Boolean} [config.muted] initial mute setting
   * @param {String} [config.fitMode] fitMode a parameter passed to VideoElementWrapper
   * @param {Object} [config._inject] @todo use the DI system
   * @param {Function} [errorHandler=() => {}] error callback function
   */
  function VideoElementFacade(_temp2) {
    let _ref2 = _temp2 === void 0 ? {} : _temp2,
      _ref2$fallbackText = _ref2.fallbackText,
      fallbackText = _ref2$fallbackText === void 0 ? 'Sorry, Web RTC is not available in your browser' : _ref2$fallbackText,
      fitMode = _ref2.fitMode,
      muted = _ref2.muted,
      _inject = _ref2._inject,
      widgetType = _ref2.widgetType;
    return new VideoElementWrapper({
      fallbackText,
      fitMode,
      muted,
      defaultAudioVolume,
      _inject,
      widgetType
    });
  }
  return VideoElementFacade;
}
var _default = VideoElementFacadeFactory;
exports.default = _default;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.adaptIceServers = adaptIceServers;
exports.parseIceServers = parseIceServers;
function adaptIceServers(iceServers) {
  return iceServers.map(iceServer => ({
    url: iceServer.url,
    // deprecated
    urls: iceServer.urls || [iceServer.url],
    username: iceServer.username,
    credential: iceServer.credential
  }));
}
function parseIceServers(message) {
  let iceServers;
  try {
    iceServers = JSON.parse(message.data).content.iceServers;
  } catch (e) {
    return [];
  }
  return adaptIceServers(iceServers);
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
/**
 * Firefox, Edge, Safari and Chrome v58+ will use the standard version
 * of getStats API.
 * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats#Browser_compatibility
 */
var _default = () => _env.default.name === 'Chrome' && _env.default.version >= 58 || ['Firefox', 'Edge', 'Safari', 'Opera'].indexOf(_env.default.name) !== -1;
exports.default = _default;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = RafRunner;
/*
  * Executes the provided callback before each paint (frequency is usually the monitors refresh
  * rate which is typically 60 times per second)
  *
  * @param {function()} callback
  * @constructor
  */

function RafRunner(callback) {
  let cancelId = null;
  let running = false;
  const loop = () => {
    if (!running) {
      return;
    }
    callback();
    cancelId = window.requestAnimationFrame(loop);
  };
  this.start = () => {
    if (running) {
      return;
    }
    running = true;
    cancelId = window.requestAnimationFrame(loop);
  };
  this.stop = () => {
    window.cancelAnimationFrame(cancelId);
    running = false;
  };
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ONE_SECOND_IN_MS = exports.ONE_MINUTE_IN_MS = void 0;
const ONE_SECOND_IN_MS = 1000;
exports.ONE_SECOND_IN_MS = ONE_SECOND_IN_MS;
const ONE_MINUTE_IN_MS = 60 * ONE_SECOND_IN_MS;
exports.ONE_MINUTE_IN_MS = ONE_MINUTE_IN_MS;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancellationError = exports.default = undefined;

var _Cancellation = __webpack_require__(707);

var _Cancellation2 = _interopRequireDefault(_Cancellation);

var _CancellationError2 = __webpack_require__(328);

var _CancellationError3 = _interopRequireDefault(_CancellationError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Cancellation2.default;
exports.CancellationError = _CancellationError3.default;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _hasOpenTokSupport = _interopRequireDefault(__webpack_require__(53));
var _env = _interopRequireDefault(__webpack_require__(3));
var _window$RTCRtpSender, _window$RTCRtpSender2;
const isCryptoSupported = !!window.crypto;

// RTCRtpScriptTransform exists on firefox but we don't support it yet
const isRTCScriptTransformSupported = !!window.RTCRtpScriptTransform && !_env.default.isFirefox;
const isInsertableStreamsSupported = !!((_window$RTCRtpSender = window.RTCRtpSender) != null && _window$RTCRtpSender.prototype.createEncodedStreams) || !!((_window$RTCRtpSender2 = window.RTCRtpSender) != null && _window$RTCRtpSender2.prototype.createdEncodedVideoStreams) || isRTCScriptTransformSupported;
const isWebWorkerSupported = !!window.Worker;
const isE2eeSupported = () => isCryptoSupported && isInsertableStreamsSupported && isWebWorkerSupported;
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  /* eslint-disable-next-line global-require */
  const hasOpenTokSupport = deps.hasOpenTokSupport || _hasOpenTokSupport.default.once;
  const hasE2eeCapability = deps.isE2eeSupported || isE2eeSupported;
  return hasOpenTokSupport() && hasE2eeCapability();
};
exports.default = _default;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(42),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(383),
    mapCacheDelete = __webpack_require__(390),
    mapCacheGet = __webpack_require__(392),
    mapCacheHas = __webpack_require__(393),
    mapCacheSet = __webpack_require__(394);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(189);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(87)(module)))

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(69),
    nativeKeys = __webpack_require__(399);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(404),
    stubArray = __webpack_require__(196);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(194);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(203);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(419),
    shortOut = __webpack_require__(209);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(54),
    isArrayLike = __webpack_require__(29),
    isIndex = __webpack_require__(67),
    isObject = __webpack_require__(11);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(117);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const logLevels = {
  error: {
    priority: 1,
    method: 'error'
  },
  warn: {
    priority: 2,
    method: 'warn'
  },
  info: {
    priority: 3,
    method: 'info'
  },
  log: {
    priority: 4,
    method: 'log'
  },
  debug: {
    priority: 5,
    method: 'debug'
  },
  spam: {
    priority: 6,
    method: 'log'
  }
};
var _default = logLevels;
exports.default = _default;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(211)() ? Object.setPrototypeOf : __webpack_require__(212);


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(57);

// prettier-ignore
var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };

module.exports = function (value) {
	if (!isValue(value)) return false;
	return hasOwnProperty.call(possibleTypes, typeof value);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(433)() ? Object.assign : __webpack_require__(434);


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(13);
var normalizeHeaderName = __webpack_require__(226);
var AxiosError = __webpack_require__(49);
var transitionalDefaults = __webpack_require__(227);
var toFormData = __webpack_require__(96);
var toURLEncodedForm = __webpack_require__(490);
var platform = __webpack_require__(135);
var formDataToJSON = __webpack_require__(228);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(229);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(229);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    var contentType = headers && headers['Content-Type'] || '';
    var hasJSONContentType = contentType.indexOf('application/json') > -1;
    var isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    var isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        var _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      var silentJSONParsing = transitional && transitional.silentJSONParsing;
      var strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(24)))

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(491);


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(235),
    createBind = __webpack_require__(510),
    createCurry = __webpack_require__(511),
    createHybrid = __webpack_require__(237),
    createPartial = __webpack_require__(525),
    getData = __webpack_require__(241),
    mergeData = __webpack_require__(526),
    setData = __webpack_require__(244),
    setWrapToString = __webpack_require__(245),
    toInteger = __webpack_require__(100);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(89),
    baseLodash = __webpack_require__(139);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    getPrototype = __webpack_require__(124),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(536),
    isObjectLike = __webpack_require__(21);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(14),
    isSymbol = __webpack_require__(71);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(551),
    overRest = __webpack_require__(208),
    setToString = __webpack_require__(127);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = audioContextFactory;
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

// TODO - Move this back within the factory once all modules have been
// converted to DI factories. This will ensure different unit tests are
// using distinct instances of AudioContext.
let context;
function audioContextFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const AudioContext = deps.AudioContext || (typeof window !== undefined ? window : global).AudioContext || (typeof window !== undefined ? window : global).webkitAudioContext;

  /*
   * Lazy instantiates an audio context and always return the same instance on following calls
   *
   * @returns {AudioContext}
   */

  return function audioContext() {
    context = context || AudioContext && new AudioContext();
    // Safari does not throw, it simply returns null when it cannot create an
    // audio context...
    // @todo report this to Apple
    if (context == null) {
      throw new Error('AudioContext could not be created, hardware limit reached.');
    }
    return context;
  };
}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
/*
 * An <code>AudioContext</code> based audio level sampler. It returns the maximum value in the
 * last 1024 samples.
 *
 * It is worth noting that the remote <code>MediaStream</code> audio analysis is currently only
 * available in FF.
 *
 * This implementation gracefully handles the case where the <code>MediaStream</code> has not
 * been set yet by returning a <code>null</code> value until the stream is set. It is up to the
 * call site to decide what to do with this value (most likely ignore it and retry later).
 *
 * @constructor
 * @param {AudioContext} audioContext an audio context instance to get an analyser node
 */
let WebAudioAudioLevelSampler = /*#__PURE__*/function () {
  function WebAudioAudioLevelSampler(audioContext) {
    this._analyser = null;
    this._timeDomainData = null;
    this._sourceNode = null;
    this._audioContext = audioContext;
  }
  var _proto = WebAudioAudioLevelSampler.prototype;
  _proto._initAudioAnalyser = function _initAudioAnalyser(mediaStream) {
    this._analyser = this._audioContext.createAnalyser();
    this._sourceNode = this._audioContext.createMediaStreamSource(mediaStream);
    this._sourceNode.connect(this._analyser);
    this._timeDomainData = new Uint8Array(this._analyser.frequencyBinCount);
  };
  _proto.webRTCStream = function webRTCStream(mediaStream) {
    if (this._sourceNode) {
      this._sourceNode.disconnect(this._analyser);
    }
    if (this._audioContext.state === 'suspended') {
      this._audioContext.resume();
    }
    this._initAudioAnalyser(mediaStream);
  };
  _proto.destroy = function destroy() {
    if (this._sourceNode) {
      this._sourceNode.disconnect(this._analyser);
    }
    this._timeDomainData = null;
  };
  _proto.sample = function sample(done) {
    if (typeof done === 'function') {
      throw new Error('sample no longer takes a callback');
    }
    if (this._analyser && this._timeDomainData) {
      this._analyser.getByteTimeDomainData(this._timeDomainData);
      // varies from 0 to 255
      let max = 0;
      for (let idx = this._timeDomainData.length - 1; idx >= 0; idx -= 1) {
        max = Math.max(max, Math.abs(this._timeDomainData[idx] - 128));
      }

      // normalize the collected level to match the range delivered by
      // the getStats' audioOutputLevel
      return max / 128;
    }
    return null;
  };
  return WebAudioAudioLevelSampler;
}();
exports.default = WebAudioAudioLevelSampler;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(90),
    eq = __webpack_require__(54),
    isIterateeCall = __webpack_require__(128),
    keysIn = __webpack_require__(55);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _intersection = _interopRequireDefault(__webpack_require__(149));
var _log = _interopRequireDefault(__webpack_require__(1));
const logging = (0, _log.default)('Event');
let Event = /*#__PURE__*/function () {
  function Event(type, cancelable, props) {
    if (cancelable === void 0) {
      cancelable = true;
    }
    if (props === void 0) {
      props = {};
    }
    this.type = type;
    this.cancelable = cancelable;
    this._defaultPrevented = false;
    const reservedKeys = (0, _intersection.default)(Object.keys(this), Object.keys(props));
    if (reservedKeys.length > 0) {
      throw new Error(`Cannot used reserved property names: ${reservedKeys.join(',')}`);
    }
    (0, _assign.default)(this, props);
  }
  var _proto = Event.prototype;
  _proto.preventDefault = function preventDefault() {
    if (this.cancelable) {
      this._defaultPrevented = true;
    } else {
      logging.warn('Event.preventDefault :: Trying to preventDefault on an ' + 'event that isn\'t cancelable');
    }
  };
  _proto.isDefaultPrevented = function isDefaultPrevented() {
    return this._defaultPrevented;
  };
  return Event;
}();
exports.default = Event;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    baseIntersection = __webpack_require__(579),
    baseRest = __webpack_require__(90),
    castArrayLikeObject = __webpack_require__(580);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(29),
    isObjectLike = __webpack_require__(21);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _createClass2 = _interopRequireDefault(__webpack_require__(25));
var _cloneDeep = _interopRequireDefault(__webpack_require__(62));
var _get2 = _interopRequireDefault(__webpack_require__(59));
/*
 * Provides an interface around the raw session info from Anvil
 *
 * @class SessionInfo
 * @param {Object} rawSessionInfo The raw session info from Anvil
 *
 */
let SessionInfo = /*#__PURE__*/function () {
  function SessionInfo(rawSessionInfo) {
    if (rawSessionInfo === void 0) {
      rawSessionInfo = {};
    }
    Object.defineProperty(this, '_rawSessionInfo', {
      value: (0, _cloneDeep.default)(rawSessionInfo)
    });
  }
  /**
   * @type {String}
   * @readonly
   */
  (0, _createClass2.default)(SessionInfo, [{
    key: "sessionId",
    get: function get() {
      return this._rawSessionInfo.session_id;
    }
    /**
     * @type {String}
     * @readonly
     */
  }, {
    key: "partnerId",
    get: function get() {
      return this._rawSessionInfo.partner_id;
    }
    /**
     * @type {String}
     * @readonly
     */
  }, {
    key: "messagingServer",
    get: function get() {
      return this._rawSessionInfo.messaging_server_url;
    }
    /**
     * @type {String}
     * @readonly
     */
  }, {
    key: "mediaServerName",
    get: function get() {
      return this._rawSessionInfo.media_server_hostname;
    }
    /**
     * @type {String}
     * @readonly
     */
  }, {
    key: "messagingURL",
    get: function get() {
      return this._rawSessionInfo.messaging_url;
    }
    /**
     * @type {String}
     * @readonly
     */
  }, {
    key: "symphonyAddress",
    get: function get() {
      return this._rawSessionInfo.symphony_address;
    }
    /**
     * @type {Array}
     * @readonly
     */
  }, {
    key: "iceServers",
    get: function get() {
      return this._rawSessionInfo.ice_servers;
    }
    /**
     * Simulcast is tri-state:
     * * true - simulcast is on for this session
     * * false - simulcast is off for this session
     * * undefined - the developer can choose
     * @type {Boolean|Undefined}
     * @readonly
     */
  }, {
    key: "simulcast",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.simulcast');
    }
    /**
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "e2ee",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.e2ee', false);
    }
    /**
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "reconnection",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.reconnection', false);
    }
    /**
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "renegotiation",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.renegotiation', false);
    }
    /**
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "p2pEnabled",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.p2p.preference.value') === 'enabled';
    }
    /**
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "hybridSession",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.hybridSession', false);
    }
    /**
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "isAdaptiveEnabled",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.p2p.preference.value') === 'adaptive';
    }
    /**
     * If this contains a valid codec, it will be prioritized
     *
     * @type {String}
     * @readonly
     */
  }, {
    key: "priorityVideoCodec",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.priorityVideoCodec', '');
    }
    /**
     * Is true if H264 codec is enabled
     *
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "h264",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.h264', true);
    }
    /**
     * Is true if VP8 codec is enabled
     *
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "vp8",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.vp8', true);
    }
    /**
     * Is true if VP9 codec is enabled
     *
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "vp9",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.vp9', true);
    }
    /**
     * Is true if SinglePeerConnection is enabled
     *
     * @type {Boolean}
     * @readonly
     */
  }, {
    key: "singlePeerConnection",
    get: function get() {
      return (0, _get2.default)(this._rawSessionInfo, 'properties.singlePeerConnection', false);
    }
    /**
     * clientCandidates can be "relay". Other values are unknown.
     *
     * @type {String|Undefined}
     * @readonly
     */
  }, {
    key: "clientCandidates",
    get: function get() {
      const rawValue = (0, _get2.default)(this._rawSessionInfo, 'properties.clientCandidates');
      return rawValue === 'relayed' ? 'relay' : rawValue;
    }
  }]);
  return SessionInfo;
}();
var _default = SessionInfo;
exports.default = _default;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = () => document.createElement('video');
exports.default = _default;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = videoOrientationFactory;
function videoOrientationFactory() {
  return {
    ROTATED_NORMAL: 0,
    ROTATED_LEFT: 270,
    ROTATED_RIGHT: 90,
    ROTATED_UPSIDE_DOWN: 180
  };
}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = createWindowMock;
var _adapter_factory = _interopRequireDefault(__webpack_require__(596));
var _log = _interopRequireDefault(__webpack_require__(1));
var _extendES5Native = _interopRequireDefault(__webpack_require__(607));
var _env = _interopRequireDefault(__webpack_require__(3));
const logging = (0, _log.default)('createWindowMock');
const windowKeys = [{
  key: 'location',
  type: 'object'
}, {
  key: 'setTimeout',
  type: 'function'
}, {
  key: 'requestAnimationFrame',
  type: 'function'
}, {
  key: 'URL',
  type: 'function'
}, {
  key: 'MediaStream',
  type: 'class'
}, {
  key: 'webkitMediaStream',
  type: 'class'
}, {
  key: 'RTCIceCandidate',
  type: 'class'
}, {
  key: 'mozRTCIceCandidate',
  type: 'class'
}, {
  key: 'RTCSessionDescription',
  type: 'class'
}, {
  key: 'mozRTCSessionDescription',
  type: 'class'
}, {
  key: 'RTCIceGatherer',
  type: 'class'
}, {
  key: 'RTCIceTransport',
  type: 'class'
}, {
  key: 'RTCDtlsTransport',
  type: 'class'
}, {
  key: 'RTCSctpTransport',
  type: 'class'
}, {
  key: 'RTCRtpReceiver',
  type: 'class'
}, {
  key: 'HTMLMediaElement',
  type: 'class'
}, {
  key: 'RTCPeerConnection',
  type: 'class'
}, {
  key: 'webkitRTCPeerConnection',
  type: 'class'
}, {
  key: 'mozRTCPeerConnection',
  type: 'class'
}, {
  key: 'MediaStreamTrack',
  type: 'class'
}, {
  key: 'RTCRtpSender',
  type: 'class'
}, {
  key: 'RTCTrackEvent',
  type: 'class'
}, {
  key: 'RTCTransceiver',
  type: 'class'
}, {
  key: 'RTCDtmfSender',
  type: 'class'
}, {
  key: 'RTCDTMFSender',
  type: 'class'
}, {
  key: 'MediaStreamTrackEvent',
  type: 'class'
}];
const navigatorKeys = [{
  key: 'userAgent',
  type: 'string'
}, {
  key: 'getUserMedia',
  type: 'function'
}, {
  key: 'getDisplayMedia',
  type: 'function'
}, {
  key: 'webkitGetUserMedia',
  type: 'function'
}, {
  key: 'mozGetUserMedia',
  type: 'function'
}];
const mediaDevicesKeys = [{
  key: 'getUserMedia',
  type: 'function'
}, {
  key: 'getDisplayMedia',
  type: 'function'
}, {
  key: 'enumerateDevices',
  type: 'function'
}, {
  key: 'getSupportedConstraints',
  type: 'function'
}, {
  key: 'addEventListener',
  type: 'function'
}, {
  key: 'removeEventListener',
  type: 'function'
}];
const bindWithStaticProperties = (context, func) => {
  if (typeof func !== 'function') {
    logging.warn('Non-function passed into bindWithStaticProperties()');
    return func;
  }
  const bound = func.bind(context);
  Object.keys(func).forEach(key => {
    bound[key] = func[key];
  });
  return bound;
};
const extendClass = ParentClass => {
  if (typeof ParentClass !== 'function') {
    logging.warn('Non-function passed into extendClass()');
    return ParentClass;
  }
  return (0, _extendES5Native.default)(ParentClass);
};
const getCopyProperties = () => (target, source, keys) => {
  keys.forEach(_ref => {
    let key = _ref.key,
      type = _ref.type;
    let value = source[key];
    if (value !== undefined) {
      switch (type) {
        case 'function':
          value = bindWithStaticProperties(source, value);
          break;
        case 'class':
          value = extendClass(value);
          break;
        case 'string':
        case 'object':
          break;
        default:
          throw new Error(`Invalid type of window key: ${type}`);
      }
      target[key] = value; // eslint-disable-line no-param-reassign
    }
  });
};

const cloneWindow = window => {
  const windowMock = {};
  const copyProperties = getCopyProperties();
  copyProperties(windowMock, window, windowKeys);
  if (window.navigator !== undefined) {
    windowMock.navigator = {};
    copyProperties(windowMock.navigator, window.navigator, navigatorKeys);
    if (window.navigator.mediaDevices !== undefined) {
      windowMock.navigator.mediaDevices = {};
      copyProperties(windowMock.navigator.mediaDevices, window.navigator.mediaDevices, mediaDevicesKeys);
    }
  }
  return windowMock;
};
function createWindowMock(window) {
  // We avoid shimming twice because adapter is not idempotent.
  // Unfortunately checking for window.adapter can be used to detect
  // adapter.js but not adapter_no_global.js, there is no reliable
  // way of detecting it.
  if (window.adapter !== undefined || _env.default.isLegacyEdge) {
    return window;
  }
  const windowMock = cloneWindow(window);
  (0, _adapter_factory.default)({
    window: windowMock
  });
  return windowMock;
}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = AudioLevelTransformer;
/*
 * Transforms a raw audio level to produce a "smoother" animation when using displaying the
 * audio level. This transformer is state-full because it needs to keep the previous average
 * value of the signal for filtering.
 *
 * It applies a low pass filter to get rid of level jumps and apply a log scale.
 *
 * @constructor
 */
function AudioLevelTransformer() {
  let averageAudioLevel = null;

  /*
   *
   * @param {number} audioLevel a level in the [0,1] range
   * @returns {number} a level in the [0,1] range transformed
   */
  this.transform = audioLevel => {
    if (averageAudioLevel === null || audioLevel >= averageAudioLevel) {
      averageAudioLevel = audioLevel;
    } else {
      // a simple low pass filter with a smoothing of 70
      averageAudioLevel = audioLevel * 0.3 + averageAudioLevel * 0.7;
    }

    // 1.5 scaling to map -30-0 dBm range to [0,1]
    const logScaled = Math.log(averageAudioLevel) / Math.LN10 / 1.5 + 1;
    return Math.min(Math.max(logScaled, 0), 1);
  };
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Chrome;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _eventing = _interopRequireDefault(__webpack_require__(6));
const values = obj => Object.keys(obj).map(key => obj[key]);

// Manages N Chrome elements
function Chrome(properties) {
  const _widgets = {};

  // Private helper function
  const _set = (name, widget) => {
    (0, _assign.default)(widget, {
      parent: this
    });
    widget.appendTo(properties.parent);
    _widgets[name] = widget;
    this[name] = widget;
  };
  if (!properties.parent) {
    // @todo raise an exception
    return;
  }
  (0, _eventing.default)(this);
  this.destroy = () => {
    this.off();
    this.hideWhileLoading();
    values(_widgets).forEach(widget => widget.destroy());
  };
  this.showAfterLoading = () => {
    values(_widgets).forEach(widget => widget.showAfterLoading());
  };
  this.hideWhileLoading = () => {
    values(_widgets).forEach(widget => widget.hideWhileLoading());
  };

  // Adds the widget to the chrome and to the DOM. Also creates a accessor
  // property for it on the chrome.
  //
  // @example
  //  chrome.set('foo', new FooWidget());
  //  chrome.foo.setDisplayMode('on');
  //
  // @example
  //  chrome.set({
  //      foo: new FooWidget(),
  //      bar: new BarWidget()
  //  });
  //  chrome.foo.setDisplayMode('on');
  //
  this.set = (widgetName, widget) => {
    if (typeof widgetName === 'string' && widget) {
      _set(widgetName, widget);
    } else {
      Object.keys(widgetName).forEach(name => {
        _set(name, widgetName[name]);
      });
    }
    return this;
  };
}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _domState = _interopRequireDefault(__webpack_require__(608));
var _events = _interopRequireDefault(__webpack_require__(18));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-use-before-define */

const Events = (0, _events.default)();
const domState = (0, _domState.default)();

// Helper to synchronise several startup tasks and then dispatch a unified
// 'envLoaded' event.

function EnvironmentLoader() {
  const environmentLoader = this;
  (0, _eventing.default)(environmentLoader);
  function isReady() {
    return domState.isDomLoaded() && !domState.isDomUnloaded();
  }
  function onLoaded() {
    if (isReady()) {
      environmentLoader.dispatchEvent(new Events.EnvLoadedEvent(_eventNames.default.ENV_LOADED));
    }
  }
  function onDomReady() {
    domState.whenUnloaded.then(onDomUnload);
    onLoaded();
  }
  function onDomUnload() {
    environmentLoader.dispatchEvent(new Events.EnvLoadedEvent(_eventNames.default.ENV_UNLOADED));
  }
  domState.whenLoaded.then(onDomReady);
  this.onLoad = function (cb, context) {
    if (isReady()) {
      cb.call(context);
      return;
    }
    environmentLoader.on(_eventNames.default.ENV_LOADED, cb, context);
  };
  this.onUnload = function (cb, context) {
    if (this.isUnloaded()) {
      cb.call(context);
      return;
    }
    environmentLoader.on(_eventNames.default.ENV_UNLOADED, cb, context);
  };
  this.isUnloaded = function () {
    return domState.isDomUnloaded();
  };
}
var _default = new EnvironmentLoader();
exports.default = _default;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var objectAssign = __webpack_require__(614);

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if ((typeof window !== undefined ? window : global).Buffer && typeof (typeof window !== undefined ? window : global).Buffer.isBuffer === 'function') {
    return (typeof window !== undefined ? window : global).Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(615);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof (typeof window !== undefined ? window : global).ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _screenSharingSources = _interopRequireDefault(__webpack_require__(622));
var _is_electron_screen_sharing_source = _interopRequireDefault(__webpack_require__(289));
var _default = videoSource => {
  if (_env.default.isElectron) {
    // Electron only supports a subset of `screenSharingSources` available on
    // other user agents
    if (videoSource === 'screen') {
      return true;
    }

    // Checks if this video source is a custom screensharing source
    return (0, _is_electron_screen_sharing_source.default)(videoSource);
  }
  return _screenSharingSources.default.indexOf(videoSource) > -1;
};
exports.default = _default;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = StreamChannel;
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _castToBoolean = _interopRequireDefault(__webpack_require__(292));
var _video_orientation = _interopRequireDefault(__webpack_require__(154));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable max-len, no-restricted-syntax, no-prototype-builtins, no-continue */

const VideoOrientation = (0, _video_orientation.default)();
const logging = (0, _log.default)('StreamChannel');

// id: String                           | mandatory | immutable
// type: String {video/audio/data/...}  | mandatory | immutable
// active: Boolean                      | mandatory | mutable
// orientation: Integer?                | optional  | mutable
// frameRate: Float                     | optional  | mutable
// height: Integer                      | optional  | mutable
// width: Integer                       | optional  | mutable
// preferredFrameRate: Float            | optional  | mutable
// preferredHeight: Integer             | optional  | mutable
// preferredWidth: Integer              | optional  | mutable
//
function StreamChannel(options) {
  this.id = options.id;
  this.type = options.type;
  this.active = (0, _castToBoolean.default)(options.active);
  this.orientation = options.orientation || VideoOrientation.ROTATED_NORMAL;
  if (options.frameRate) {
    this.frameRate = parseFloat(options.frameRate);
  }
  if (options.preferredFrameRate) {
    this.preferredFrameRate = parseFloat(options.preferredFrameRate);
  }
  if (options.preferredWidth) {
    this.preferredWidth = parseInt(options.preferredWidth, 10);
  }
  if (options.preferredHeight) {
    this.preferredHeight = parseInt(options.preferredHeight, 10);
  }
  this.width = parseInt(options.width, 10);
  this.height = parseInt(options.height, 10);

  // The defaults are used for incoming streams from pre 2015Q1 release clients.
  this.source = options.source || 'camera';
  this.fitMode = options.fitMode || 'cover';
  (0, _eventing.default)(this);

  // Returns true if a property was updated.
  this.update = function (attributes) {
    const videoDimensions = {};
    const oldVideoDimensions = {};
    for (const key in attributes) {
      if (!attributes.hasOwnProperty(key)) {
        continue;
      }

      // we shouldn't really read this before we know the key is valid
      const oldValue = this[key];
      switch (key) {
        case 'active':
          this.active = (0, _castToBoolean.default)(attributes[key]);
          break;
        case 'disableWarning':
          this.disableWarning = (0, _castToBoolean.default)(attributes[key]);
          break;
        case 'frameRate':
          this.frameRate = parseFloat(attributes[key], 10);
          break;
        case 'width':
        case 'height':
          this[key] = parseInt(attributes[key], 10);
          videoDimensions[key] = this[key];
          oldVideoDimensions[key] = oldValue;
          break;
        case 'orientation':
          this[key] = attributes[key];
          videoDimensions[key] = this[key];
          oldVideoDimensions[key] = oldValue;
          break;
        case 'fitMode':
          this[key] = attributes[key];
          break;
        case 'source':
          this[key] = attributes[key];
          break;
        case 'sourceStreamId':
          break;
        default:
          logging.debug(`Tried to update unknown key ${key} on ${this.type} channel ${this.id}`);
          return false;
      }
      this.trigger('update', this, key, oldValue, this[key]);
    }
    if (Object.keys(videoDimensions).length) {
      // To make things easier for the public API, we broadcast videoDimensions changes,
      // which is an aggregate of width, height, and orientation changes.
      this.trigger('update', this, 'videoDimensions', oldVideoDimensions, videoDimensions);
    }
    return true;
  };
}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = StylableComponent;
var _log = _interopRequireDefault(__webpack_require__(1));
var _fix_background_image_uri = _interopRequireDefault(__webpack_require__(630));
var _style2 = _interopRequireDefault(__webpack_require__(631));
var _style_hash_log_filter = _interopRequireDefault(__webpack_require__(293));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

const logging = (0, _log.default)('StylableComponent');

/* Stylable Notes
 * Some bits are controlled by multiple flags, i.e. buttonDisplayMode and nameDisplayMode.
 * When there are multiple flags how is the final setting chosen?
 * When some style bits are set updates will need to be pushed through to the Chrome
 */

// Mixes the StylableComponent behaviour into the +self+ object. It will
// also set the default styles to +initialStyles+.
//
// @note This Mixin is dependent on OT.Eventing.
//
//
// @example
//
//  function SomeObject {
//      StylableComponent(this, {
//          name: 'SomeObject',
//          foo: 'bar'
//      });
//  }
//
//  var obj = new SomeObject();
//  obj.getStyle('foo');        // => 'bar'
//  obj.setStyle('foo', 'baz')
//  obj.getStyle('foo');        // => 'baz'
//  obj.getStyle();             // => {name: 'SomeObject', foo: 'baz'}
//
function StylableComponent(self, initialStyles, showControls, logSetStyleWithPayload) {
  if (!self.trigger) {
    throw new Error('OT.StylableComponent is dependent on the eventing mixin. ' + 'Ensure that this is included in the object before StylableComponent.');
  }
  logSetStyleWithPayload = logSetStyleWithPayload || function () {};
  let _readOnly = false;

  // Broadcast style changes as the styleValueChanged event
  const onStyleChange = function onStyleChange(key, value, oldValue) {
    if (oldValue) {
      self.trigger('styleValueChanged', key, value, oldValue);
    } else {
      self.trigger('styleValueChanged', key, value);
    }
  };
  if (showControls === false) {
    initialStyles = {
      buttonDisplayMode: 'off',
      nameDisplayMode: 'off',
      audioLevelDisplayMode: 'off',
      videoDisabledDisplayMode: 'off',
      audioBlockedDisplayMode: 'off'
    };
    _readOnly = true;
    logSetStyleWithPayload({
      showControls: false
    });
  }
  const _style = new _style2.default(initialStyles, onStyleChange);

  /**
   * Returns an object that has the properties that define the current user interface controls of
   * the Publisher. You can modify the properties of this object and pass the object to the
   * <code>setStyle()</code> method of thePublisher object. (See the documentation for
   * <a href="#setStyle">setStyle()</a> to see the styles that define this object.)
   * @return {Object} The object that defines the styles of the Publisher.
   * @see <a href="#setStyle">setStyle()</a>
   * @method #getStyle
   * @memberOf Publisher
   */

  /**
   * Returns an object that has the properties that define the current user interface controls of
   * the Subscriber. You can modify the properties of this object and pass the object to the
   * <code>setStyle()</code> method of the Subscriber object. (See the documentation for
   * <a href="#setStyle">setStyle()</a> to see the styles that define this object.)
   * @return {Object} The object that defines the styles of the Subscriber.
   * @see <a href="#setStyle">setStyle()</a>
   * @method #getStyle
   * @memberOf Subscriber
   */
  // If +key+ is falsly then all styles will be returned.
  self.getStyle = function (key) {
    return _style.get(key);
  };

  /**
   * Sets properties that define the appearance of some user interface controls of the Publisher.
   *
   * <p>You can either pass one parameter or two parameters to this method.</p>
   *
   * <p>If you pass one parameter, <code>style</code>, it is an object that has the following
   * properties:
   *
   *     <ul>
   *       <li><code>audioLevelDisplayMode</code> (String) &mdash; How to display the audio level
   *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
   *       video is disabled), <code>"off"</code> (the indicator is not displayed), and
   *       <code>"on"</code> (the indicator is always displayed).</li>
   *
   *       <li><code>archiveStatusDisplayMode</code> (String) &mdash; How to display the archive
   *       status indicator. Possible values are: <code>"auto"</code> (the indicator is displayed
   *       when the session is being recorded), <code>"off"</code> (the indicator is not displayed).
   *       If you disable the archive status display indicator, you can display your own user
   *       interface notifications based on the <code>archiveStarted</code> and
   *       <code>archiveStopped</code> events dispatched by the Session object.</li>
   *
   *       <li><code>backgroundImageURI</code> (String) &mdash; A URI for an image to display as
   *       the background image when a video is not displayed. (A video may not be displayed if
   *       you call <code>publishVideo(false)</code> on the Publisher object). You can pass an http
   *       or https URI to a PNG, JPEG, or non-animated GIF file location. You can also use the
   *       <code>data</code> URI scheme (instead of http or https) and pass in base-64-encrypted
   *       PNG data, such as that obtained from the <a href="Publisher.html#getImgData">
   *       Publisher.getImgData()</a> method (for example, you could call
   *       <code>myPublisher.setStyle("backgroundImageURI", myPublisher.getImgData())</code>).
   *       If the URL or the image data is invalid, the property is ignored (the attempt to set
   *       the image fails silently).</li>
   *
   *       <li><code>buttonDisplayMode</code> (String) &mdash; How to display the microphone
   *       controls. Possible values are: <code>"auto"</code> (controls are displayed when the
   *       stream is first displayed and when the user mouses over the display), <code>"off"</code>
   *       (controls are not displayed), and <code>"on"</code> (controls are always displayed).</li>
   *
   *       <li><code>nameDisplayMode</code> (String) &#151; Whether to display the stream name.
   *       Possible values are: <code>"auto"</code> (the name is displayed when the stream is first
   *       displayed and when the user mouses over the display), <code>"off"</code> (the name is not
   *       displayed), and <code>"on"</code> (the name is always displayed).</li>
   *   </ul>
   * </p>
   *
   * <p>For example, the following code passes one parameter to the method:</p>
   *
   * <pre>myPublisher.setStyle({nameDisplayMode: "off"});</pre>
   *
   * <p>If you pass two parameters, <code>style</code> and <code>value</code>, they are
   * key-value pair that define one property of the display style. For example, the following
   * code passes two parameter values to the method:</p>
   *
   * <pre>myPublisher.setStyle("nameDisplayMode", "off");</pre>
   *
   * <p>You can set the initial settings when you call the <code>Session.publish()</code>
   * or <code>OT.initPublisher()</code> method. Pass a <code>style</code> property as part of the
   * <code>properties</code> parameter of the method.</p>
   *
   * <p>The OT object dispatches an <code>exception</code> event if you pass in an invalid style
   * to the method. The <code>code</code> property of the ExceptionEvent object is set to 1011.</p>
   *
   * @param {Object} style Either an object containing properties that define the style, or a
   * String defining this single style property to set.
   * @param {String} value The value to set for the <code>style</code> passed in. Pass a value
   * for this parameter only if the value of the <code>style</code> parameter is a String.</p>
   *
   * @see <a href="#getStyle">getStyle()</a>
   * @return {Publisher} The Publisher object
   * @see <a href="#setStyle">setStyle()</a>
   *
   * @see <a href="Session.html#subscribe">Session.publish()</a>
   * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
   * @method #setStyle
   * @memberOf Publisher
   */

  /**
   * Sets properties that define the appearance of some user interface controls of the Subscriber.
   *
   * <p>You can either pass one parameter or two parameters to this method.</p>
   *
   * <p>If you pass one parameter, <code>style</code>, it is an object that has the following
   * properties:
   *
   *     <ul>
   *       <li><code>audioBlockedDisplayMode</code> (String) &mdash; Whether to display
   *       the default audio blocked icon in Subscribers (in browsers where audio
   *       autoplay is blocked). Possible values are: <code>"auto"</code> (the default,
   *       icon is displayed when the audio is disabled) and <code>"off"</code> (the icon
   *       is not displayed). Set this to <code>"off"</code> if you want to display
   *       your own UI element showing that the audio is blocked. In response to an
   *       HTML element dispatching a <code>click</code> event, you can call the
   *       <a href="OT.html#unblockAudio">OT.unblockAudio()</a> method to start audio
   *       playback in this and all other blocked subscribers.</li>
   *
   *       <li><code>audioLevelDisplayMode</code> (String) &mdash; How to display the audio level
   *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
   *       video is disabled), <code>"off"</code> (the indicator is not displayed), and
   *       <code>"on"</code> (the indicator is always displayed).</li>
   *
   *       <li><code>backgroundImageURI</code> (String) &mdash; A URI for an image to display as
   *       the background image when a video is not displayed. (A video may not be displayed if
   *       you call <code>subscribeToVideo(false)</code> on the Publisher object). You can pass an
   *       http or https URI to a PNG, JPEG, or non-animated GIF file location. You can also use the
   *       <code>data</code> URI scheme (instead of http or https) and pass in base-64-encrypted
   *       PNG data, such as that obtained from the <a href="Subscriber.html#getImgData">
   *       Subscriber.getImgData()</a> method (for example, you could call
   *       <code>mySubscriber.setStyle("backgroundImageURI", mySubscriber.getImgData())</code>).
   *       If the URL or the image data is invalid, the property is ignored (the attempt to set
   *       the image fails silently).</li>
   *
   *       <li><code>buttonDisplayMode</code> (String) &mdash; How to display the speaker
   *       controls. Possible values are: <code>"auto"</code> (controls are displayed when the
   *       stream is first displayed and when the user mouses over the display), <code>"off"</code>
   *       (controls are not displayed), and <code>"on"</code> (controls are always displayed).</li>
   *
   *       <li><code>nameDisplayMode</code> (String) &#151; Whether to display the stream name.
   *       Possible values are: <code>"auto"</code> (the name is displayed when the stream is first
   *       displayed and when the user mouses over the display), <code>"off"</code> (the name is not
   *       displayed), and <code>"on"</code> (the name is always displayed).</li>
   *
   *       <li><code>videoDisabledDisplayMode</code> (String) &#151; Whether to display the video
   *       disabled indicator and video disabled warning icons for a Subscriber. These icons
   *       indicate that the video has been disabled (or is at risk of being disabled for
   *       the warning icon) due to poor stream quality. Possible values are: <code>"auto"</code>
   *       (the icons are automatically when the displayed video is disabled or at risk of being
   *       disabled due to poor stream quality), <code>"off"</code> (do not display the icons), and
   *       <code>"on"</code> (display the icons).</li>
   *   </ul>
   * </p>
   *
   * <p>For example, the following code passes one parameter to the method:</p>
   *
   * <pre>mySubscriber.setStyle({nameDisplayMode: "off"});</pre>
   *
   * <p>If you pass two parameters, <code>style</code> and <code>value</code>, they are key-value
   * pair that define one property of the display style. For example, the following code passes
   * two parameter values to the method:</p>
   *
   * <pre>mySubscriber.setStyle("nameDisplayMode", "off");</pre>
   *
   * <p>You can set the initial settings when you call the <code>Session.subscribe()</code> method.
   * Pass a <code>style</code> property as part of the <code>properties</code> parameter of the
   * method.</p>
   *
   * <p>The OT object dispatches an <code>exception</code> event if you pass in an invalid style
   * to the method. The <code>code</code> property of the ExceptionEvent object is set to 1011.</p>
   *
   * @param {Object} style Either an object containing properties that define the style, or a
   * String defining this single style property to set.
   * @param {String} value The value to set for the <code>style</code> passed in. Pass a value
   * for this parameter only if the value of the <code>style</code> parameter is a String.</p>
   *
   * @returns {Subscriber} The Subscriber object.
   *
   * @see <a href="#getStyle">getStyle()</a>
   * @see <a href="#setStyle">setStyle()</a>
   *
   * @see <a href="Session.html#subscribe">Session.subscribe()</a>
   * @method #setStyle
   * @memberOf Subscriber
   */

  self.setStyle = function (keyOrStyleHash, value, silent) {
    if (_readOnly) {
      logging.warn('Calling setStyle() has no effect because the' + 'showControls option was set to false');
      return this;
    }
    let styleHash;
    if (typeof keyOrStyleHash !== 'string') {
      styleHash = keyOrStyleHash;
    } else {
      styleHash = {};
      styleHash[keyOrStyleHash] = value;
    }
    if (styleHash.backgroundImageURI) {
      styleHash.backgroundImageURI = (0, _fix_background_image_uri.default)(styleHash.backgroundImageURI);
    }
    _style.setAll(styleHash, silent);
    logSetStyleWithPayload((0, _style_hash_log_filter.default)(styleHash));
    return this;
  };
}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _once = _interopRequireDefault(__webpack_require__(52));
var _log = _interopRequireDefault(__webpack_require__(1));
var _analytics = _interopRequireDefault(__webpack_require__(31));
var _hasOpenTokSupport = _interopRequireDefault(__webpack_require__(53));
var _isWebSocketSupported = _interopRequireDefault(__webpack_require__(634));
var _modal = _interopRequireDefault(__webpack_require__(635));
var _api_key = _interopRequireDefault(__webpack_require__(73));
var _environment_loader = _interopRequireDefault(__webpack_require__(158));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _userAgentParsingLogger = _interopRequireDefault(__webpack_require__(636));
var _upgrade = _interopRequireDefault(__webpack_require__(637));
var _isSupported = _interopRequireDefault(__webpack_require__(638));
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const env = deps.env || _OTHelpers.default.env;
  const Modal = deps.Modal || _modal.default;
  const createLogger = deps.createLogger || _log.default;
  const logging = createLogger('systemRequirements');
  const hasOpenTokSupport = _hasOpenTokSupport.default.once;

  // This will be logged before we even get the correct loggingUrl from
  // config.opentok.com.
  const analytics = new _analytics.default();
  const logOnce = (0, _once.default)(() => {
    analytics.logEvent({
      action: 'checkSystemRequirements',
      variation: 'notHasRequirements',
      partnerId: _api_key.default.value,
      payload: {
        userAgent: env.userAgent
      }
    });
  });
  const logUserAgentParsingOnce = (0, _once.default)(() => {
    (0, _userAgentParsingLogger.default)();
  });
  let isDialogOpen = false;
  const browserName = env.name;
  const browserVersion = env.version;
  const isMobile = env.isMobileDevice;
  const _isSupportedFactory = (0, _isSupported.default)(browserName, browserVersion),
    isSupportedButOldDefault = _isSupportedFactory.isSupportedButOld,
    isBrowserAndVersionSupportedDefault = _isSupportedFactory.isBrowserAndVersionSupported;
  return {
    /**
    * Checks if the system supports Vonage Video API for WebRTC. Note that this method is called
    * automatically when you call <code>OT.initPublisher()</code> or <code>OT.initSession()</code>,
    * and if the system doesn't support Vonage Video API, the OpenTok.js library displays a message to
    * the user. Call the <code>OT.checkSystemRequirements()</code> method before calling
    * <code>OT.initPublisher()</code> or <code>OT.initSession()</code> if you do not want the
    * library to display that message.
    *
    * @return {Number} Whether the system supports Vonage Video API for WebRTC (1) or not (0).
    * @see <a href="#upgradeSystemRequirements">OT.upgradeSystemRequirements()</a>
    * @method OT.checkSystemRequirements
    * @memberof OT
    */
    check() {
      logging.debug('OT.checkSystemRequirements()');

      // We use Number here to coerce a Boolean to 1 or 0
      const systemRequirementsMet = Number(_isWebSocketSupported.default && hasOpenTokSupport());
      logUserAgentParsingOnce();
      if (!systemRequirementsMet) {
        logOnce();
      }
      return systemRequirementsMet;
    },
    /**
    * Displays information about system requirements for Vonage Video API for WebRTC. This
    * information is displayed in an iframe element that fills the browser window.
    * <p>
    * <i>Note:</i> this information is displayed automatically when you call the
    * <code>OT.initSession()</code> or the <code>OT.initPublisher()</code> method
    * if the client does not support Vonage Video API for WebRTC.
    * </p>
    * <p><i>Note:</i> this function will be deprecated in the future.</p>
    * @see <a href="#checkSystemRequirements">OT.checkSystemRequirements()</a>
    * @method OT.upgradeSystemRequirements
    * @memberof OT
    */
    upgrade(_temp) {
      let _ref = _temp === void 0 ? {} : _temp,
        _ref$isSupportedButOl = _ref.isSupportedButOld,
        isSupportedButOld = _ref$isSupportedButOl === void 0 ? isSupportedButOldDefault() : _ref$isSupportedButOl,
        _ref$isBrowserAndVers = _ref.isBrowserAndVersionSupported,
        isBrowserAndVersionSupported = _ref$isBrowserAndVers === void 0 ? isBrowserAndVersionSupportedDefault() : _ref$isBrowserAndVers;
      // trigger after the OT environment has loaded
      _environment_loader.default.onLoad(() => {
        logging.warn('OT.upgradeSystemRequirements is deprecated.');
        if (isDialogOpen) {
          return;
        }
        const modal = new Modal(_upgrade.default);
        isDialogOpen = true;
        modal.on('close', () => {
          isDialogOpen = false;
        });
        modal.open();
        let section = isMobile ? 'mobile-' : '';
        if (isBrowserAndVersionSupported) {
          section += 'supported-install';
        } else if (isSupportedButOld) {
          section += 'upgrade-install';
        } else {
          section += 'unsupported-install';
        }
        modal.el(`#section-${section}`).style.display = 'block';
      });
    }
  };
};
exports.default = _default;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(165));
const pFinally = __webpack_require__(642);
let TimeoutError = /*#__PURE__*/function (_Error) {
  (0, _inheritsLoose2.default)(TimeoutError, _Error);
  function TimeoutError(message) {
    var _this;
    _this = _Error.call(this, message) || this;
    _this.name = 'TimeoutError';
    return _this;
  }
  return TimeoutError;
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
module.exports = (promise, ms, fallback) => new Promise((resolve, reject) => {
  if (typeof ms !== 'number' || ms < 0) {
    throw new TypeError('Expected `ms` to be a positive number');
  }
  const timer = setTimeout(() => {
    if (typeof fallback === 'function') {
      try {
        resolve(fallback());
      } catch (err) {
        reject(err);
      }
      return;
    }
    const message = typeof fallback === 'string' ? fallback : `Promise timed out after ${ms} milliseconds`;
    const err = fallback instanceof Error ? fallback : new TimeoutError(message);
    if (typeof promise.cancel === 'function') {
      promise.cancel();
    }
    reject(err);
  }, ms);
  pFinally(promise.then(resolve, reject), () => {
    clearTimeout(timer);
  });
});
module.exports.TimeoutError = TimeoutError;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(639);

var setPrototypeOf = __webpack_require__(295);

var isNativeFunction = __webpack_require__(640);

var construct = __webpack_require__(641);

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

module.exports = _wrapNativeSuper;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
function createCleanupJobs() {
  const jobs = [];
  return {
    add(job) {
      jobs.push(job);
    },
    remove(job) {
      const index = jobs.indexOf(job);
      if (index >= 0) {
        jobs.splice(index, 1);
      }
    },
    releaseAll() {
      const errors = [];
      while (jobs.length > 0) {
        const job = jobs.pop();
        try {
          job();
        } catch (err) {
          errors.push(err);
        }
      }
      const count = errors.length;
      if (count > 0) {
        throw new Error(`Failed to complete ${count} cleanup job${count === 1 ? '' : 's'}: ${errors.map(err => `<${err}>`).join(', ')}`);
      }
    }
  };
}
var _default = createCleanupJobs;
exports.default = _default;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _log = _interopRequireDefault(__webpack_require__(1));
const logging = (0, _log.default)('applySdpTransform');
var _default = (transforms, localRemote, offerAnswer, transformOptions, sdp) => {
  const transform = transforms[localRemote][offerAnswer];
  const type = `${localRemote} ${offerAnswer}`;
  const pubSub = type === 'local offer' || type === 'remote answer' ? 'publisher' : 'subscriber';
  const logPrefix = `sdpTransforms (${pubSub}): ${localRemote} ${offerAnswer}`;
  const createdReceived = localRemote === 'local' ? 'created' : 'received';
  logging.debug(`${logPrefix}: ${createdReceived}:\n${sdp}`);
  const transformedSdps = transform(transformOptions, sdp);
  if (transformedSdps.local === sdp) {
    logging.debug(`${logPrefix}: not modified`);
  } else {
    logging.debug(`${logPrefix}: modified to:\n${transformedSdps.local}`);
  }
  return transformedSdps;
};
exports.default = _default;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
/**
 * Calculates the video framerate based on current and last frames,
 * and current and last stat timestamp.
 *
 * @typedef {Object} videoFrameStatValues
 * @property {Number} currentStatFrames Frames taken from current stats.
 * @property {Number} currentTimestamp Timestamp taken from current stats.
 * @property {Number} prevStatFrames Frames taken from previous stats.
 * @property {Number} prevTimestamp Timestamp taken from previous stats.
 *
 * @param {Stats} frameStatValues
 * @returns {Number} Video frameRate
 */

const calculateFrameRate = function calculateFrameRate(videoFrameStatValues) {
  if (videoFrameStatValues === void 0) {
    videoFrameStatValues = {};
  }
  if (!videoFrameStatValues) {
    return 0;
  }
  const _videoFrameStatValues = videoFrameStatValues,
    _videoFrameStatValues2 = _videoFrameStatValues.currentStatFrames,
    currentStatFrames = _videoFrameStatValues2 === void 0 ? 0 : _videoFrameStatValues2,
    _videoFrameStatValues3 = _videoFrameStatValues.prevStatFrames,
    prevStatFrames = _videoFrameStatValues3 === void 0 ? 0 : _videoFrameStatValues3,
    _videoFrameStatValues4 = _videoFrameStatValues.currentTimestamp,
    currentTimestamp = _videoFrameStatValues4 === void 0 ? 0 : _videoFrameStatValues4,
    _videoFrameStatValues5 = _videoFrameStatValues.prevTimestamp,
    prevTimestamp = _videoFrameStatValues5 === void 0 ? 0 : _videoFrameStatValues5;
  if (currentStatFrames >= prevStatFrames && currentTimestamp > prevTimestamp) {
    const videoFrameRate = (currentStatFrames - prevStatFrames) / ((currentTimestamp - prevTimestamp) / 1000);
    return Math.round(videoFrameRate * 100) / 100;
  }
  return 0;
};
var _default = calculateFrameRate;
exports.default = _default;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _get = _interopRequireDefault(__webpack_require__(59));
const getDisplayMedia = (0, _get.default)((typeof window !== undefined ? window : global), 'navigator.getDisplayMedia', (0, _get.default)((typeof window !== undefined ? window : global), 'navigator.mediaDevices.getDisplayMedia'));
var _default = typeof getDisplayMedia === 'function';
exports.default = _default;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = generateSimpleStateMachineFactory;
var _clone = _interopRequireDefault(__webpack_require__(41));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require */

function generateSimpleStateMachineFactory() {
  // A Factory method for generating simple state machine classes.
  //
  // @usage
  //    var StateMachine = generateSimpleStateMachine('start', ['start', 'middle', 'end', {
  //      start: ['middle'],
  //      middle: ['end'],
  //      end: ['start']
  //    }]);
  //
  //    var states = new StateMachine();
  //    state.current;            // <-- start
  //    state.set('middle');
  //
  return function generateSimpleStateMachine(initialState, states, transitions) {
    const validStates = states.slice();
    const validTransitions = (0, _clone.default)(transitions);
    const isValidState = function isValidState(state) {
      return validStates.indexOf(state) !== -1;
    };
    const isValidTransition = function isValidTransition(fromState, toState) {
      return validTransitions[fromState] && validTransitions[fromState].indexOf(toState) !== -1;
    };
    return function (stateChangeFailed) {
      let currentState = initialState;
      let previousState = null;
      this.current = currentState;
      function signalChangeFailed(message, newState) {
        stateChangeFailed({
          message,
          newState,
          currentState,
          previousState
        });
      }

      // Validates +newState+. If it's invalid it triggers stateChangeFailed and returns false.
      function handleInvalidStateChanges(newState) {
        if (!isValidState(newState)) {
          signalChangeFailed(`'${newState}' is not a valid state`, newState);
          return false;
        }
        if (!isValidTransition(currentState, newState)) {
          signalChangeFailed(`'${currentState}' cannot transition to '${newState}'`, newState);
          return false;
        }
        return true;
      }
      this.set = function (newState) {
        if (!handleInvalidStateChanges(newState)) {
          return;
        }
        previousState = currentState;
        this.current = newState;
        currentState = newState;
      };
    };
  };
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = screenSharingFactory;
var _find = _interopRequireDefault(__webpack_require__(63));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _chrome_extension_helper = _interopRequireDefault(__webpack_require__(308));
var _electron_extension_helper = _interopRequireDefault(__webpack_require__(679));
var _firefox_extension_helper = _interopRequireDefault(__webpack_require__(681));
var _getDisplayMedia_extension_helper = _interopRequireDefault(__webpack_require__(315));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require */

function screenSharingFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const chromeExtensionHelper = deps.chromeExtensionHelper || (0, _chrome_extension_helper.default)();
  const electronExtensionHelper = deps.electronExtensionHelper || (0, _electron_extension_helper.default)();
  const Errors = deps.Errors || _Errors.default;
  const firefoxExtensionHelper = deps.firefoxExtensionHelper || _firefox_extension_helper.default;
  const getDisplayMediaExtensionHelper = deps.getDisplayMediaExtensionHelper || _getDisplayMedia_extension_helper.default;
  const otError = deps.otError || (0, _otError.default)();
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const screenSharing = {};
  screenSharing.extensionByKind = {};
  screenSharing.extensionClasses = {};
  screenSharing.registerExtensionHelper = (kind, helper) => {
    screenSharing.extensionClasses[kind] = helper;
    if (helper.autoRegisters && helper.isSupportedInThisBrowser) {
      screenSharing.registerExtension(kind);
    }
  };

  /**
   * Register an extension for screen-sharing support in an older version of Chrome or Opera.
   * <p>
   * <b>Note:</b> A screen-sharing extension is not required in Chrome 72+ or Opera 59+.
   * The end user is prompted to grant access to the screen, just as they would be when granting
   * access to a camera. You only need a screen-sharing extension for older versions
   * of Opera and Chrome.
   * <p>
   * Use the <code>OT.checkScreenSharingCapability()</code> method to check if an extension is
   * required, registered, and installed.
   * <p>
   * The Vonage Video API
   * <a href="https://github.com/opentok/screensharing-extensions">screensharing-extensions</a>
   * repo includes code for creating an extension for screen-sharing support.
   *
   * @param {String} kind Set this parameter to <code>"chrome"</code>. Currently, you can only
   * register a screen-sharing extension for older versions of Chrome and Opera.
   *
   * @param {String} id The ID for your screen-sharing extension. You can find this ID at
   * chrome://extensions.
   *
   * @param {Number} version The version of the screen-sharing extension from the
   * <a href="https://github.com/opentok/screensharing-extensions">screensharing-extensions</a> repo.
   * Set this if you are using version 2 or later. For example, if you are using version 2, set this
   * to 2. With version 2, the client can use the extension immediately after installing it, without
   * reloading the page.
   *
   * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
   * @see <a href="OT.html#checkScreenSharingCapability">OT.checkScreenSharingCapability()</a>
   * @method OT.registerScreenSharingExtension
   * @memberof OT
   */

  screenSharing.registerExtension = function (kind) {
    if (screenSharing.extensionClasses[kind] == null) {
      throw new Error('Unsupported kind passed to OT.registerScreenSharingExtension');
    }
    for (var _len = arguments.length, initArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      initArgs[_key - 1] = arguments[_key];
    }
    const x = screenSharing.extensionClasses[kind].register(...initArgs);
    screenSharing.extensionByKind[kind] = x;
  };
  const screenSharingPickHelper = () => {
    const foundClass = (0, _find.default)(Object.keys(screenSharing.extensionClasses).sort(
    // Try "electron" first.  Reason being, even though `getDisplayMedia`
    // is exposed in electron, developers must use the electron's
    // `desktopCapturer` instead.
    cls => cls === 'electron' ? -1 : 1), cls => screenSharing.extensionClasses[cls].isSupportedInThisBrowser);
    if (foundClass === undefined) {
      return {};
    }
    return {
      name: foundClass,
      proto: screenSharing.extensionClasses[foundClass],
      instance: screenSharing.extensionByKind[foundClass]
    };
  };
  screenSharing.pickHelper = () => screenSharingPickHelper();

  /**
   * Checks for support for publishing screen-sharing streams on the client browser. The object
   * passed to the callback function defines whether screen sharing is supported, as well as
   * which screen-sharing sources (application, screen, or window) are supported. It also indicates
   * whether an extension is required, installed, and registered (if needed).
   * <p>
   * <pre>
   * OT.checkScreenSharingCapability(function(response) {
   *   if (!response.supported || response.extensionRegistered === false) {
   *     // This browser does not support screen sharing
   *   } else if (response.extensionInstalled === false) {
   *     // Prompt to install the extension
   *   } else {
   *     // Screen sharing is available.
   *   }
   * });
   * </pre>
   * <p>
   * Chrome 72+, Firefox 52+, Safari 13+, Edge 79+, and Opera 59+ have screen-sharing
   * support built-in, with no extension required. (Note that support for the Vonage Video API
   * plugin for Internet Explorer is removed in Vonage Video API 2.17.) Screen sharing is
   * <i>not</i> supported in mobile browsers. In Electron, screen sharing is supported if
   * the <code>webPreferences.contextIsolation</code> option of the Electron BrowserWindow is
   * set to <code>false</code> or if the app uses a preload script to access the desktop capturer.
   * (The default value of <code>webPreferences.contextIsolation</code> option is <code>true</code>
   * in Electron 12 and <code>false</code> in previous versions). To publish a screen-sharing video
   * in older versions of Chrome or Opera, the client adds an extension that enables publishing a
   * screen-sharing video stream on your domain. The Vonage Video API
   * <a href="https://github.com/opentok/screensharing-extensions">screensharing-extensions</a>
   * sample includes code for creating an extension for screen-sharing support in
   * older versions of Chrome and Opera.
   * <p>
   * For more information, see the <a href="https://tokbox.com/developer/guides/screen-sharing/js/">
   * Vonage Video API Screen Sharing</a> developer guide.
   *
   * @param {function} callback The callback invoked with the support options object passed as
   * the parameter. This object has the following properties that indicate support for publishing
   * screen-sharing streams in the client:
   * <p>
   * <ul>
   *   <li>
   *     <code>extensionInstalled</code> (Boolean) &mdash;  In older versions of Chrome and Opera,
   *     this is set to <code>true</code> if the extension is installed and registered.
   *     In Chrome 72+, Firefox 52+, Safari 13+, Opera 59+, Edge 79+, and Internet Explorer,
   *     this property is undefined.
   *   </li>
   *   <li>
   *     <code>supported</code> (Boolean) &mdash; Set to <code>true</code> if screen sharing
   *     is supported in the browser. Check the <code>extensionRequired</code> property
   *     to see if the browser requires an extension for screen sharing.
   *   </li>
   *   <li>
   *     <code>supportedSources</code> (Object) &mdash; Deprecated. In older
   *     browser versions, you could select a type of screen-sharing source
   *     (such as <code>"application"</code>, <code>"browser"</code>, <code>"screen"</code>,
   *     or <code>"window"</code> by setting the <code>videoSource</code> property
   *     of the options passed into the <code>OT.initPublisher()</code> method.
   *     However, in current browsers that support screen sharing, passing in
   *     any of these values results in the same behavior &mdash; the browser
   *     displays a dialog box in which the end user selects the screen-sharing
   *     source (which can be the entire screen or a specific window). In Electron,
   *     screen sharing captures the entire screen, without prompting the user for permission.
   *   </li>
   * </ul>
   * <p> The options parameter also includes the following properties, which apply to screen-sharing
   * support in older versions of Chrome and Opera (in all other browsers these properties are
   * undefined):
   * <ul>
   *   <li>
   *     <code>extensionRequired</code> (String) &mdash; Set to <code>"chrome"</code>
   *     in older versions of Chrome and Opera, which require a screen-sharing extension
   *     to be installed. This property is undefined in other browsers.
   *   </li>
   *   <li>
   *     <code>extensionRegistered</code> (Boolean) &mdash; In older versions of Chrome and Opera,
   *     this property is set to <code>true</code> if a screen-sharing extension is registered;
   *     otherwise it is set to <code>false</code>. In other browsers (which do not require
   *     an extension), this property is undefined. Use the
   *     <code>OT.registerScreenSharingExtension()</code> method to register a screen-sharing
   *     extension in older versions of Chrome or Opera.
   *   </li>
   * </ul>
   *
   * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
   * @see <a href="OT.html#registerScreenSharingExtension">OT.registerScreenSharingExtension()</a>
   * @method OT.checkScreenSharingCapability
   * @memberof OT
   */
  screenSharing.checkCapability = callback => {
    const response = {
      supported: false,
      extensionRequired: undefined,
      extensionRegistered: undefined,
      extensionInstalled: undefined,
      supportedSources: {}
    };

    // find a supported browser

    const helper = screenSharingPickHelper();
    if (helper.name === undefined) {
      setTimeout(callback.bind(null, response));
      return;
    }
    response.supported = true;
    response.extensionRequired = helper.proto.extensionRequired ? helper.name : undefined;
    response.supportedSources = {
      screen: helper.proto.sources.screen,
      application: helper.proto.sources.application,
      window: helper.proto.sources.window,
      browser: helper.proto.sources.browser
    };
    if (!helper.instance) {
      response.extensionRegistered = false;
      if (response.extensionRequired) {
        response.extensionInstalled = false;
      }
      setTimeout(callback.bind(null, response));
      return;
    }
    response.extensionRegistered = response.extensionRequired ? true : undefined;
    helper.instance.isInstalled(installed => {
      response.extensionInstalled = response.extensionRequired || OTHelpers.env.name === 'Firefox' ? installed : undefined;
      callback(response);
    });
  };
  screenSharing.registerExtensionHelper('electron', electronExtensionHelper);
  screenSharing.registerExtensionHelper('getDisplayMedia', getDisplayMediaExtensionHelper);
  screenSharing.registerExtensionHelper('chrome', chromeExtensionHelper);
  screenSharing.registerExtensionHelper('firefox', firefoxExtensionHelper);
  const noop = () => {};
  screenSharing.getConstraints = opt => {
    const _opt$onAccessDialogOp = opt.onAccessDialogOpened,
      onAccessDialogOpened = _opt$onAccessDialogOp === void 0 ? noop : _opt$onAccessDialogOp,
      _opt$onAccessDialogCl = opt.onAccessDialogClosed,
      onAccessDialogClosed = _opt$onAccessDialogCl === void 0 ? noop : _opt$onAccessDialogCl,
      videoSource = opt.videoSource,
      constraints = opt.constraints;
    return new Promise((resolve, reject) => {
      screenSharing.checkCapability(response => {
        if (!response.supported) {
          let errorMessage = 'Screen Sharing is not supported in this browser';
          if (OTHelpers.env.isElectron) {
            errorMessage = 'Set the webPreferences.contextIsolation option of the Electron BrowserWindow' + ' to false or use a preload script to access the desktop capturer.' + ' For more information, see https://tokbox.com/developer/guides/screen-sharing/js/.';
          } else if (OTHelpers.env.name === 'Chrome' && OTHelpers.env.version > 73 && (typeof window !== undefined ? window : global).location.protocol !== 'https:') {
            errorMessage = 'https:// is required for screen sharing';
          }
          reject(otError(Errors.SCREEN_SHARING_NOT_SUPPORTED, new Error(errorMessage)));
        } else if (response.extensionRegistered === false) {
          reject(otError(Errors.SCREEN_SHARING_EXTENSION_NOT_REGISTERED, new Error('Screen Sharing support in this browser requires an extension, but ' + 'one has not been registered.')));
        } else if (response.extensionRequired && response.extensionInstalled === false) {
          reject(otError(Errors.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error('Screen Sharing support in this browser requires an extension, but ' + 'the extension is not installed.')));
        } else {
          const helper = screenSharing.pickHelper();
          if (helper.proto.getConstraintsShowsPermissionUI) {
            onAccessDialogOpened();
          }
          helper.instance.getConstraints(videoSource, constraints, (err, helperConstraints) => {
            if (helper.proto.getConstraintsShowsPermissionUI) {
              onAccessDialogClosed();
            }
            if (err) {
              reject(err);
            } else {
              resolve(helperConstraints);
            }
          });
        }
      });
    });
  };
  return screenSharing;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = interpretPeerConnectionErrorFactory;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable global-require */

function interpretPeerConnectionErrorFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const Errors = deps.Errors || _Errors.default;
  const ExceptionCodes = deps.ExceptionCodes || _exception_codes.default;
  const otError = deps.otError || (0, _otError.default)();
  const errorPrefixMap = {
    ICEWorkflow: Errors.ICE_WORKFLOW_FAILED,
    NewPeerConnection: Errors.CREATE_PEER_CONNECTION_FAILED,
    SetRemoteDescription: Errors.SET_REMOTE_DESCRIPTION_FAILED,
    Subscribe: {
      404: Errors.STREAM_NOT_FOUND,
      [ExceptionCodes.STREAM_LIMIT_EXCEEDED]: Errors.STREAM_LIMIT_EXCEEDED
    }
  };
  return function interpretPeerConnectionError(httpCode, reason, prefix, remoteConnectionId, className) {
    const message = `${(prefix ? `${prefix}: ` : '') + className} PeerConnection with connection ${remoteConnectionId} failed: ${reason}`;
    const nameOrCodeMap = errorPrefixMap[prefix] || {};
    const name = typeof nameOrCodeMap === 'string' ? nameOrCodeMap : nameOrCodeMap[httpCode];
    const defaultCode = className === 'Publisher' ? ExceptionCodes.UNABLE_TO_PUBLISH : ExceptionCodes.UNABLE_TO_SUBSCRIBE;
    if (!name) {
      const error = new Error(message);
      error.code = defaultCode;
      return error;
    }
    const code = (() => {
      if (prefix === 'ICEWorkflow') {
        return className === 'Publisher' ? ExceptionCodes.PUBLISHER_ICE_WORKFLOW_FAILED : ExceptionCodes.SUBSCRIBER_ICE_WORKFLOW_FAILED;
      }
      if (name === Errors.STREAM_LIMIT_EXCEEDED) {
        return ExceptionCodes.STREAM_LIMIT_EXCEEDED;
      }
      return defaultCode;
    })();
    return otError(name, new Error(message), code);
  };
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = setCertificatesFactory;
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable global-require, no-param-reassign */

function setCertificatesFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  const RTCPeerConnection = windowMock.RTCPeerConnection;
  return function setCertificates(pcConfig, completion) {
    if (OTHelpers.env.name === 'Firefox' && RTCPeerConnection && RTCPeerConnection.generateCertificate) {
      RTCPeerConnection.generateCertificate({
        name: 'RSASSA-PKCS1-v1_5',
        hash: 'SHA-256',
        modulusLength: 2048,
        publicExponent: new Uint8Array([1, 0, 1])
      }).catch(err => {
        completion(err);
      }).then(cert => {
        pcConfig.certificates = [cert];
        completion(undefined, pcConfig);
      });
    } else {
      setTimeout(() => {
        completion(undefined, pcConfig);
      });
    }
  };
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const DefaultParameters = {
  bandwidthCriticalThreshold: 70000,
  bandwidthFairThreshold: 0,
  packetLossCriticalThreshold: 0.15,
  packetLossCriticalThresholdMediumBw: 0.2,
  criticalCongestionPeriod: 16000
};
var _default = DefaultParameters;
exports.default = _default;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

exports.__esModule = true;
exports.default = promisify;
/**
 * promisify - Promisify a node style callback function into a promise
 *
 * Returns a promisifed version of the function, if it's callback is called
 * with a truthy error parameter the promise will be rejected. If the callback
 * is called with one argument, it's value will be resolved. If the callback
 * is called with multiple arguments, the promise will resolve to an array
 * of those arguments.
 *
 * @param {function} fn Function to promisify
 * @returns {function} Promise returning function
 */

function promisify(fn) {
  return function promisified() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise((resolve, reject) => {
      fn(...args, function (err) {
        if (err) {
          reject(err);
          return;
        }
        for (var _len2 = arguments.length, callbackArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          callbackArgs[_key2 - 1] = arguments[_key2];
        }
        if (callbackArgs.length === 1) {
          resolve(callbackArgs[0]);
          return;
        }
        resolve(callbackArgs);
      });
    });
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _createClass2 = _interopRequireDefault(__webpack_require__(25));
var _cancel = _interopRequireWildcard(__webpack_require__(114));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _eventHelper = _interopRequireDefault(__webpack_require__(58));
var _env = _interopRequireDefault(__webpack_require__(3));
var _ensureCSSUnit = _interopRequireDefault(__webpack_require__(708));
var _hasPassiveCapability = _interopRequireDefault(__webpack_require__(709));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _video_element = _interopRequireDefault(__webpack_require__(109));
var _createWidgetInitialsSvg = _interopRequireDefault(__webpack_require__(710));
var _getOrCreateContainer = _interopRequireDefault(__webpack_require__(711));
var _fixMini = _interopRequireDefault(__webpack_require__(712));
var _waitForVideoToBePlaying = _interopRequireDefault(__webpack_require__(713));
var _waitForVideoResolution3 = _interopRequireDefault(__webpack_require__(715));
var _unblockAudio = _interopRequireDefault(__webpack_require__(177));
var _amrVideoBufferError = __webpack_require__(330);
var _amrStateDurations = _interopRequireDefault(__webpack_require__(178));
var _index = _interopRequireDefault(__webpack_require__(274));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable class-methods-use-this */
/* global XMLSerializer */

const VIDEO_BUFFER_TIMEOUT = _amrStateDurations.default.VIDEO_BUFFER_TIMEOUT,
  VIDEO_LOADING_TIMEOUT = _amrStateDurations.default.VIDEO_LOADING_TIMEOUT;
const defaultLogging = (0, _log.default)('WidgetView');

// eslint-disable-next-line no-unused-vars
const typeVideoElementFacade = (0, _video_element.default)();

/**
 * WidgetViewFactory - DI factory for WidgetView
 *
 * @package
 * @param {Object} deps
 * @param {DefaultVideoElementFacadeFactory} deps.VideoElementFacade
 * @return WidgetView
 */
function WidgetViewFactory(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$logging = _ref.logging,
    logging = _ref$logging === void 0 ? defaultLogging : _ref$logging,
    _ref$OTHelpers = _ref.OTHelpers,
    OTHelpers = _ref$OTHelpers === void 0 ? _OTHelpers.default : _ref$OTHelpers,
    _ref$waitForVideoToBe = _ref.waitForVideoToBePlaying,
    waitForVideoToBePlaying = _ref$waitForVideoToBe === void 0 ? _waitForVideoToBePlaying.default : _ref$waitForVideoToBe,
    _ref$VideoElementFaca = _ref.VideoElementFacade,
    VideoElementFacade = _ref$VideoElementFaca === void 0 ? (0, _video_element.default)() : _ref$VideoElementFaca,
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? _env.default : _ref$env;
  // We pass in the real window rather than a mock because hasPassiveCapability
  // needs to attach/remove real event listeners on the window which won't work
  // using the mock window.
  const supportsPassive = (0, _hasPassiveCapability.default)({
    window: (typeof window !== undefined ? window : global)
  });
  const throwIfBindCancelled = cancellation => {
    if (cancellation.isCanceled()) {
      logging.debug('bindVideo bailing due to cancellation');
      throw new _cancel.CancellationError('CANCEL');
    }
  };

  /**
   * WidgetView - A standard abstraction used by Subscriber and Publisher for
   * displaying the video and it's UI.
   *
   * @package
   * @class
   * @param {Element} targetElement the element to attach this WidgetView to
   * @param {Object} properties
   */
  let WidgetView = /*#__PURE__*/function () {
    /** @type {typeVideoElementFacade} */

    /** @type {HTMLElement} */

    function WidgetView( /** @type {HTMLElement} */
    targetElement, _temp2) {
      let _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$insertDefaultUI = _ref2.insertDefaultUI,
        insertDefaultUI = _ref2$insertDefaultUI === void 0 ? true : _ref2$insertDefaultUI,
        _ref2$width = _ref2.width,
        width = _ref2$width === void 0 ? 264 : _ref2$width,
        _ref2$height = _ref2.height,
        height = _ref2$height === void 0 ? 198 : _ref2$height,
        _ref2$fitMode = _ref2.fitMode,
        fitMode = _ref2$fitMode === void 0 ? 'cover' : _ref2$fitMode,
        _ref2$mirror = _ref2.mirror,
        mirror = _ref2$mirror === void 0 ? false : _ref2$mirror,
        insertMode = _ref2.insertMode,
        classNames = _ref2.classNames,
        style = _ref2.style,
        widgetType = _ref2.widgetType,
        initials = _ref2.initials;
      this._videoElementFacade = void 0;
      this._container = undefined;
      this._posterContainer = document.createElement('div');
      this._widgetContainer = document.createElement('div');
      this._loading = true;
      this._audioOnly = false;
      this._showPoster = undefined;
      this._poster = undefined;
      this._cancelBind = undefined;
      (0, _eventing.default)(this);
      if (/^(contain|cover)$/.test(fitMode) === false) {
        logging.warn(`Invalid fit value "${fitMode}" passed. Only "contain" and "cover" can be used.`);
      }
      this._widgetType = widgetType;
      this._fitMode = fitMode;
      this._insertDefaultUI = insertDefaultUI;
      const userInteractionEventHandlers = (0, _eventHelper.default)(this._widgetContainer);
      userInteractionEventHandlers.on('click', this.userGesture.bind(this));
      userInteractionEventHandlers.on('touchstart', this.userGesture.bind(this), supportsPassive ? {
        passive: true
      } : false);
      this.once('destroy', () => userInteractionEventHandlers.removeAll());
      this._widgetContainer.classList.add('OT_widget-container');
      this._widgetContainer.style.width = '100%'; // container.style.width;
      this._widgetContainer.style.height = '100%'; // container.style.height;

      if (insertDefaultUI !== false) {
        this._container = (0, _getOrCreateContainer.default)(targetElement, insertMode);
        if (env.isSafari && env.isiOS && env.iOSVersion && env.iOSVersion < 11.2) {
          this._container.classList.add('OT_ForceContain');
        }
        this._container.style.width = (0, _ensureCSSUnit.default)(width);
        this._container.style.height = (0, _ensureCSSUnit.default)(height);
        this._container.style.overflow = 'hidden';
        (0, _fixMini.default)(this._container);
        if (mirror) {
          OTHelpers.addClass(this._container, 'OT_mirrored');
        }
        if (classNames) {
          // @todo Refactor to avoid passing classNames to widgetView
          classNames.trim().split(/\s+/).forEach(className => this._container.classList.add(className));
        }
        this._container.classList.add('OT_loading');
        this._container.classList.add(`OT_fit-mode-${fitMode}`);
        this._container.appendChild(this._widgetContainer);

        // Observe changes to the width and height and update the aspect ratio
        const _OTHelpers$observeSiz = OTHelpers(this._container).observeSize(() => (0, _fixMini.default)(this._container)),
          sizeObserver = _OTHelpers$observeSiz[0];

        // @todo observe if the video container or the video element get removed
        // if they do we should do some cleanup
        const videoObserver = OTHelpers.observeNodeOrChildNodeRemoval(this._container, removedNodes => {
          if (!this._videoElementFacade) {
            return;
          }
          // check if our widget container / video element was removed
          const videoRemoved = removedNodes.some(node => node === this._widgetContainer || node === this._videoElementFacade.domElement());
          if (videoRemoved) {
            this.destroyVideo();
          }
        });
        this.once('destroy', () => {
          logging.debug('disconnecting observers');
          sizeObserver.disconnect();
          videoObserver.disconnect();
        });
      }
      this._posterContainer.classList.add('OT_video-poster');
      this._widgetContainer.appendChild(this._posterContainer);
      const loadingContainer = document.createElement('div');
      loadingContainer.classList.add('OT_video-loading');
      const loadingSpinner = document.createElement('div');
      loadingSpinner.classList.add('OT_video-loading-spinner');
      loadingContainer.appendChild(loadingSpinner);
      this._widgetContainer.appendChild(loadingContainer);
      const hasBackgroundImageURI = style && style.backgroundImageURI;
      // Precedence for background is: background image, then initials.
      // If background image is not present, use initials.
      if (hasBackgroundImageURI) {
        this.setBackgroundImageURI(style.backgroundImageURI);
      } else if (initials) {
        this.setInitials(initials);
      }
    }
    var _proto = WidgetView.prototype;
    _proto.addError = function addError(errorMsg, helpMsg, classNames) {
      if (this._container) {
        var _this$_container$quer;
        this._container.innerHTML = `<p>${errorMsg}${helpMsg ? ` <span class="ot-help-message">${helpMsg}</span>` : ''}</p>`;
        OTHelpers.addClass(this._container, classNames || 'OT_subscriber_error');
        if (((_this$_container$quer = this._container.querySelector('p')) == null ? void 0 : _this$_container$quer.offsetHeight) > this._container.offsetHeight) {
          // `span` will not exist if `helpMsg` argument was undefined
          const spanElement = this._container.querySelector('span');
          if (spanElement) {
            spanElement.style.display = 'none';
          }
        }
      }
    }
    /**
     * Destroy the video
     */;
    _proto.destroy = function destroy() {
      this.emit('destroy');
      this.destroyVideo();
      if (this._container) {
        OTHelpers.removeElement(this._container);
        this._container = null;
      }
    };
    _proto.setBackgroundImageURI = function setBackgroundImageURI(bgImgURI) {
      // If initials are set, this should override.
      OTHelpers.css(this._posterContainer, 'backgroundImage', `url(${bgImgURI})`);
      OTHelpers.css(this._posterContainer, 'backgroundSize', 'contain');
      OTHelpers.css(this._posterContainer, 'opacity', '1.0');
    };
    _proto.setInitials = function setInitials(initials) {
      const initialsSvg = (0, _createWidgetInitialsSvg.default)(initials);
      const serializedSvg = new XMLSerializer().serializeToString(initialsSvg);
      OTHelpers.css(this._posterContainer, 'backgroundImage', `url('data:image/svg+xml,${serializedSvg}')`);
      OTHelpers.css(this._posterContainer, 'backgroundSize', 'auto 55%');
      OTHelpers.css(this._posterContainer, 'opacity', '1.0');
    };
    _proto.isAudioBlocked = function isAudioBlocked() {
      return Boolean(this._videoElementFacade && this._videoElementFacade.isAudioBlocked());
    };
    _proto.unblockAudio = function unblockAudio() {
      return this._videoElementFacade.unblockAudio();
    };
    _proto.userGesture = function userGesture() {
      if (this.isAudioBlocked()) {
        (0, _unblockAudio.default)().then(() => logging.debug('Successfully unblocked audio'), err => logging.error('Error retrying audio on user interaction:', err));
      }
    };
    _proto.setAudioBlockedUi = function setAudioBlockedUi(audioBlocked) {
      if (!this._container) {
        return;
      }
      if (audioBlocked) {
        this._container.classList.add('OT_container-audio-blocked');
      } else {
        this._container.classList.remove('OT_container-audio-blocked');
      }
    };
    _proto.rebindSrcObject = function rebindSrcObject() {
      if (this._videoElementFacade) {
        this._videoElementFacade._rebindSrcObject();
      }
    };
    _proto.pauseAndPlayVideoElement = function pauseAndPlayVideoElement() {
      if (this._videoElementFacade) {
        this._videoElementFacade._pauseAndPlay();
      }
    }
    // BufferVideoElement will act as pre-buffer to asure that we can play actual video/audio
    // before the bind. For that we create a plain videoElement, add the stream, play it and
    // wait to get the media flowing. We return the videoElement so it can be clean up once used.
    // In case of failure we return null.
    ;
    _proto._loadVideoBuffer =
    /*#__PURE__*/
    function () {
      var _loadVideoBuffer2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(stream, timeout, isSubscribedToVideo, deps) {
        var _deps$createElement;
        var createElement, isVideoLoaded, videoElement, videoToBePlayed;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (deps === void 0) {
                deps = {};
              }
              createElement = (_deps$createElement = deps.createElement) != null ? _deps$createElement : _index.default;
              isVideoLoaded = false;
              videoElement = createElement();
              videoElement.srcObject = stream;
              _context.prev = 5;
              if (env.isChromium) {
                // For Chromium browsers, we need to enable the video track before playing it to ensure we
                // do not see a black screen during an AMR transition. See VIDCS-3570 for more details.
                // eslint-disable-next-line no-param-reassign
                stream.getVideoTracks()[0].enabled = true;
              }
              videoToBePlayed = videoElement.play(); // Wait for the video to be loaded and playing for timeOut secs.
              _context.next = 10;
              return waitForVideoToBePlaying({
                defaultVideoElementFacade: videoElement,
                maxWaitTime: timeout,
                isBufferedStream: isSubscribedToVideo
              });
            case 10:
              isVideoLoaded = _context.sent;
              _context.next = 13;
              return videoToBePlayed;
            case 13:
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](5);
              // We are not interested in the error.
              if (env.isChromium) {
                // For Chromium browsers, we need to enable the video track before playing it to ensure we
                // do not see a black screen during an AMR transition. See VIDCS-3570 for more details.
                // eslint-disable-next-line no-param-reassign
                stream.getVideoTracks()[0].enabled = false;
              }
            case 18:
              // Clear the buffer from the DOM.
              videoElement.srcObject = null;
              videoElement.remove();
              return _context.abrupt("return", isVideoLoaded);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 15]]);
      }));
      function _loadVideoBuffer(_x, _x2, _x3, _x4) {
        return _loadVideoBuffer2.apply(this, arguments);
      }
      return _loadVideoBuffer;
    }();
    _proto._emitBindEvent = function _emitBindEvent(action, variation, options) {
      this.emit('bindEvent', action, variation, options);
    };
    _proto._createVideoElementFacade = function _createVideoElementFacade(_ref3) {
      let _inject = _ref3._inject,
        audioVolume = _ref3.audioVolume,
        fallbackText = _ref3.fallbackText,
        muted = _ref3.muted;
      this._videoElementFacade = new VideoElementFacade({
        defaultAudioVolume: parseFloat(audioVolume),
        fallbackText,
        fitMode: this._fitMode,
        _inject,
        muted,
        widgetType: this._widgetType
      });
      const videoFacadeEvents = (0, _eventHelper.default)(this._videoElementFacade);
      this._videoFacadeEvents = videoFacadeEvents;
      videoFacadeEvents.on('error', () => {
        this.trigger('error');
      });
      videoFacadeEvents.on('videoDimensionsChanged', (oldValue, newValue) => {
        this.trigger('videoDimensionsChanged', oldValue, newValue);
      });
      videoFacadeEvents.on('mediaStopped', track => {
        this.trigger('mediaStopped', track);
      });
      videoFacadeEvents.on('audioBlocked', () => this.trigger('audioBlocked'));
      videoFacadeEvents.on('audioUnblocked', () => this.trigger('audioUnblocked'));

      // makes the incoming audio streams take priority (will impact only FF OS for now)
      this._videoElementFacade.audioChannelType('telephony');
      logging.debug('Appending the video facade');
      this._videoElementFacade.appendTo(this._widgetContainer);

      // Initialize the audio volume
      if (typeof audioVolume !== 'undefined') {
        try {
          this._videoElementFacade.setAudioVolume(audioVolume);
        } catch (e) {
          logging.warn(`bindVideo ${e}`);
        }
      }
    };
    _proto._bindToStream = /*#__PURE__*/function () {
      var _bindToStream2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(webRTCStream, cancellation) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this._videoElementFacade.bindToStream(webRTCStream);
            case 3:
              _context2.next = 14;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              if (!cancellation.isCanceled()) {
                _context2.next = 12;
                break;
              }
              logging.debug('Refusing to destroyVideo as bindVideo was cancelled');
              throw new _cancel.CancellationError('CANCEL');
            case 12:
              this.destroyVideo();
              throw _context2.t0;
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 5]]);
      }));
      function _bindToStream(_x5, _x6) {
        return _bindToStream2.apply(this, arguments);
      }
      return _bindToStream;
    }();
    _proto._getNewBindCancellation = function _getNewBindCancellation() {
      if (this._cancelBind) {
        logging.debug('Cancelling last bindVideo request');
        this._cancelBind.cancel();
      }
      const cancellation = new _cancel.default();
      this._cancelBind = cancellation;
      this.once('destroy', () => cancellation.cancel());
      return cancellation;
    };
    _proto._triggerVideoElementCreated = function _triggerVideoElementCreated() {
      const triggerVideoElementCreated = element => {
        this.trigger('videoElementCreated', element);
        if (this._insertDefaultUI) {
          OTHelpers.addClass(element, 'OT_video-element');
        }
      };
      if (this._videoElementFacade.domElement()) {
        triggerVideoElementCreated(this._videoElementFacade.domElement());
      } else {
        this._videoFacadeEvents.on('videoElementCreated', element => {
          triggerVideoElementCreated(element);
        });
      }
    };
    _proto._waitForVideoResolution = /*#__PURE__*/function () {
      var _waitForVideoResolution2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(webRTCStream) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!this.audioOnly() && webRTCStream.getVideoTracks().length > 0)) {
                _context3.next = 5;
                break;
              }
              logging.debug('Waiting for correct resolution');
              _context3.next = 4;
              return (0, _waitForVideoResolution3.default)(this._videoElementFacade, 5000);
            case 4:
              logging.debug(`Resolution: ${this._videoElementFacade.videoWidth()}x${this._videoElementFacade.videoHeight()}`);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _waitForVideoResolution(_x7) {
        return _waitForVideoResolution2.apply(this, arguments);
      }
      return _waitForVideoResolution;
    }();
    _proto._tryToLoadVideoBuffer = /*#__PURE__*/function () {
      var _tryToLoadVideoBuffer2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(webRTCStream, cancellation, throwIfBufferFails, isSubscribedToVideo) {
        var removeListener, retries, loaded, error;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // Since this function is async, it can be stacked while bind is canceled.
              throwIfBindCancelled(cancellation);

              // All the logging is done at Subscriber level, we just emit actions
              // to be potentially logged
              this._emitBindEvent('loadVideoBuffer', 'Attempt');

              // Add listener in case buffer is canceled. With the function returned we can also remove the
              // listener later on if buffer is not canceled.
              removeListener = cancellation.onCancel(() => this._emitBindEvent('loadVideoBuffer', 'Cancel')); // For transitions, before binding we use the bufferVideoElement to make sure video from
              // webRTCStream is loaded and playing. We want to retry to load the video buffer as many
              // times we can inside the VIDEO_LOADING_TIMEOUT.
              retries = Math.ceil(VIDEO_LOADING_TIMEOUT / VIDEO_BUFFER_TIMEOUT);
              loaded = false;
            case 5:
              if (!(!loaded && retries)) {
                _context4.next = 13;
                break;
              }
              _context4.next = 8;
              return this._loadVideoBuffer(webRTCStream, VIDEO_BUFFER_TIMEOUT, isSubscribedToVideo);
            case 8:
              loaded = _context4.sent;
              throwIfBindCancelled(cancellation);
              retries--;
              _context4.next = 5;
              break;
            case 13:
              // Buffer hasn't been canceled, lets clear the listener.
              removeListener();
              if (loaded) {
                _context4.next = 20;
                break;
              }
              this._emitBindEvent('loadVideoBuffer', 'Failure');
              if (!throwIfBufferFails) {
                _context4.next = 19;
                break;
              }
              error = (0, _amrVideoBufferError.createAmrVideoBufferError)();
              throw error;
            case 19:
              return _context4.abrupt("return");
            case 20:
              this._emitBindEvent('loadVideoBuffer', 'Success');
              // We now want to log binding duration to monitor the blink: OPENTOK-46931
              // We propagate the event from videoFacade level to Subscriber
              this._videoFacadeEvents.on('bindEvent', (action, variation, options) => {
                this._emitBindEvent(action, variation, options);
              });
            case 22:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _tryToLoadVideoBuffer(_x8, _x9, _x10, _x11) {
        return _tryToLoadVideoBuffer2.apply(this, arguments);
      }
      return _tryToLoadVideoBuffer;
    }()
    /**
     * Bind a video to a VideoElementFacade
     *
     * @param {MediaStream} webRTCStream the MediaStream to bind
     * @param {Object} options
     * @param {Function} options.error Error callback
     * @param {Float} options.audioVolume The initial audioVolume
     * @param {Boolean} options.muted The initial mute state
     * @param {String} [options.fallbackText] The default fallbackText
     *
     * @return {Promise<undefined>}
     */
    ;
    _proto.bindVideo =
    /*#__PURE__*/
    function () {
      var _bindVideo = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(webRTCStream, _ref4, throwIfBufferFails) {
        var audioVolume, muted, fallbackText, hasVideo, isSubscribingToVideo, _inject, hasExistingElement, cancellation, whenVideoPlaying;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              audioVolume = _ref4.audioVolume, muted = _ref4.muted, fallbackText = _ref4.fallbackText, hasVideo = _ref4.hasVideo, isSubscribingToVideo = _ref4.isSubscribingToVideo, _inject = _ref4._inject;
              if (throwIfBufferFails === void 0) {
                throwIfBufferFails = false;
              }
              logging.debug('bindVideo ', {
                webRTCStream
              });
              hasExistingElement = !!this._videoElementFacade;
              cancellation = this._getNewBindCancellation();
              if (hasExistingElement) {
                _context5.next = 10;
                break;
              }
              this._createVideoElementFacade({
                _inject,
                audioVolume,
                fallbackText,
                muted
              });
              this._videoFacadeEvents.on('mediaElementEvent', action => {
                this.trigger('mediaElementEvent', action);
              });
              _context5.next = 14;
              break;
            case 10:
              if (!(webRTCStream instanceof MediaStream)) {
                _context5.next = 14;
                break;
              }
              if (!hasVideo) {
                _context5.next = 14;
                break;
              }
              _context5.next = 14;
              return this._tryToLoadVideoBuffer(webRTCStream, cancellation, throwIfBufferFails, hasVideo && isSubscribingToVideo);
            case 14:
              _context5.next = 16;
              return this._bindToStream(webRTCStream, cancellation);
            case 16:
              if (!hasExistingElement) {
                this._triggerVideoElementCreated();
              }
              throwIfBindCancelled(cancellation);
              whenVideoPlaying = waitForVideoToBePlaying({
                defaultVideoElementFacade: this._videoElementFacade,
                maxWaitTime: 5000
              });
              _context5.next = 21;
              return this._waitForVideoResolution(webRTCStream);
            case 21:
              logging.debug('Waiting for video to be playing');
              _context5.next = 24;
              return whenVideoPlaying;
            case 24:
              logging.debug('Video is playing');
              throwIfBindCancelled(cancellation);
            case 26:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function bindVideo(_x12, _x13, _x14) {
        return _bindVideo.apply(this, arguments);
      }
      return bindVideo;
    }();
    _proto.bindAudioTrackOnly = function bindAudioTrackOnly() {
      if (this._videoElementFacade) {
        this._videoElementFacade.bindAudioTrackOnly();
      }
    };
    _proto.destroyVideo = function destroyVideo() {
      if (this._videoElementFacade) {
        this._videoElementFacade.destroy();
        this._videoElementFacade = null;
      }
    };
    _proto.video = function video() {
      return this._videoElementFacade;
    };
    _proto.showPoster = function showPoster(_showPoster) {
      if (_showPoster === undefined) {
        return !OTHelpers.isDisplayNone(this._posterContainer);
      }
      this._showPoster = _showPoster;
      OTHelpers[_showPoster ? 'show' : 'hide'](this._posterContainer);
      return this.showPoster();
    };
    _proto.poster = function poster(src) {
      if (src === undefined) {
        return OTHelpers.css(this._posterContainer, 'backgroundImage');
      }
      this._poster = src;
      OTHelpers.css(this._posterContainer, 'backgroundImage', `url(${src})`);
      return this.poster();
    };
    _proto.prepareForStreamTransition = function prepareForStreamTransition() {
      var _this$_videoElementFa;
      (_this$_videoElementFa = this._videoElementFacade) == null ? void 0 : _this$_videoElementFa.prepareForStreamTransition();
    };
    _proto.loading = function loading(isLoading) {
      if (isLoading === undefined) {
        return this._loading;
      }
      this._loading = Boolean(isLoading);
      if (this._container) {
        this._container.classList[isLoading ? 'add' : 'remove']('OT_loading');
      }
      return this.loading();
    };
    _proto.audioOnly = function audioOnly(isAudioOnly) {
      if (isAudioOnly === undefined) {
        return this._audioOnly;
      }
      this._audioOnly = isAudioOnly;
      if (this._container) {
        this._container.classList[isAudioOnly ? 'add' : 'remove']('OT_audio-only');
      }
      return this.audioOnly();
    };
    _proto.domId = function domId() {
      return this._container && this._container.getAttribute('id');
    };
    _proto.setSinkId = function setSinkId(deviceId) {
      if (this._videoElementFacade) {
        return this._videoElementFacade.setSinkId(deviceId);
      }
      return undefined;
    }
    /** @return {HTMLVideoElement} */;
    (0, _createClass2.default)(WidgetView, [{
      key: "domElement",
      get: function get() {
        return this._container;
      }
    }, {
      key: "videoElement",
      get: function get() {
        return this._videoElementFacade && this._videoElementFacade.domElement() || undefined;
      }
      /**
       * The width of the video element in pixels
       * @return {Number}
       */
    }, {
      key: "width",
      get: function get() {
        return this.videoElement && this.videoElement.offsetWidth;
      }
      /**
       * The height of the video element in pixels
       * @return {Number}
       */
    }, {
      key: "height",
      get: function get() {
        return this.videoElement && this.videoElement.offsetHeight;
      }
    }]);
    return WidgetView;
  }();
  return WidgetView;
}
var _default = WidgetViewFactory;
exports.default = _default;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _objects = _interopRequireDefault(__webpack_require__(27));
var _default = () => Promise.all(_objects.default.subscribers.where().map(sub => {
  if (!sub.isAudioBlocked()) {
    return undefined;
  }

  /**
   * Causes subscribers' audio to play back in browsers where audio is blocked.
   * You must call this method in response to an HTML element dispaching
   * a <code>click</code> event.
   * <p>
   * You only need to call this method if you disable display of
   * the Subscriber's default audio playback icon (by setting the
   * <code>style.audioBlockedDisplayMode</code> property of the
   * <code>options</code> parameter of the
   * <a href="Session.html#subscribe">Session.subscribe()</a> method).
   * You may call this method in response to the user clicking an HTML element
   * that you display on the page.
   * <p>
   * The Subscriber dispatches an
   * <a href="Subscriber.html#event:audioBlocked">audioBlocked</a> event
   * if audio is blocked. In response to that event, you can display a UI
   * element to notify the end user to respond to playback subscriber audio.
   * Call the <code>OT.unblockAudio()</code> method in response to the user
   * clicking a DOM element.
   * <p>
   * <i>Note:</i> Subscriber audio is also unblocked automatically if
   * the local client gains access to the camera or microphone (for instance,
   * in response to a successful call to <code>OT.initPublisher()</code>).
   *
   * @returns Promise The promise resolves if audio playback succeeds
   * on all blocked subscribers. The promise is rejected if playback fails.
   * See <a href="Error.html">Error</a> for details.
   *
   * @see <a href="Subscriber.html#isAudioBlocked">Subscriber.isAudioBlocked()</a>
   * @see The <a href="Subscriber.html#event:audioBlocked">audioBlocked</a>
   * and <a href="Subscriber.html#event:audioUnblocked">audioUnblocked</a>
   * Subscriber events
   *
   * @method OT.unblockAudio
   * @memberof OT
   */
  return sub._.unblockAudio();
}));
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const AMRStateDurations = {
  // Publisher keeps sending media for 5 secs
  KEEP_SENDING_MEDIA_AFTER_TRANSITIONED: 5 * 1000,
  // Subscriber has 5 secs to load the video before Publisher stops sending
  VIDEO_LOADING_TIMEOUT: 5 * 1000,
  // 5 secs to load the video + 1 sec tolerance to establish the PeerConnection
  TRANSITION_TIMEOUT: (5 + 1) * 1000,
  // Send media for 3 secs to keep alive
  KEEP_SENDING_MEDIA_TO_KEEP_ALIVE: 3 * 1000,
  // Send media every 30 secs to keep alive
  KEEP_SENDING_RTCP_DELAY: 30 * 1000,
  // Worst cases observed buffer took a max of 1.x secs to load
  VIDEO_BUFFER_TIMEOUT: 2 * 1000
};
var _default = AMRStateDurations;
exports.default = _default;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAsyncIterable = exports.isAsyncGenerator = exports.isAsync = undefined;

var _asyncify = __webpack_require__(721);

var _asyncify2 = _interopRequireDefault(_asyncify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAsync(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
}

function isAsyncGenerator(fn) {
    return fn[Symbol.toStringTag] === 'AsyncGenerator';
}

function isAsyncIterable(obj) {
    return typeof obj[Symbol.asyncIterator] === 'function';
}

function wrapAsync(asyncFn) {
    if (typeof asyncFn !== 'function') throw new Error('expected a function');
    return isAsync(asyncFn) ? (0, _asyncify2.default)(asyncFn) : asyncFn;
}

exports.default = wrapAsync;
exports.isAsync = isAsync;
exports.isAsyncGenerator = isAsyncGenerator;
exports.isAsyncIterable = isAsyncIterable;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = sourceStreamId => sourceStreamId === 'P2P' ? 'RELAYED' : 'ROUTED';
exports.default = _default;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _log = _interopRequireDefault(__webpack_require__(1));
const logging = (0, _log.default)('MediaProcessorConnector');
let MediaProcessorConnector = function MediaProcessorConnector(connector) {
  var _this = this;
  this.setTrack = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(track) {
      var filteredTrack;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            filteredTrack = null;
            _context.prev = 1;
            _context.next = 4;
            return _this.connector.setTrack(track);
          case 4:
            filteredTrack = _context.sent;
            _this.originalTrack = track;
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            logging.error(`Error setting track: ${_context.t0}`);
          case 11:
            return _context.abrupt("return", filteredTrack);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
  this.destroy = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return _this.connector.destroy();
        case 3:
          _context2.next = 8;
          break;
        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2["catch"](0);
          logging.warn(`Error destroying connector: ${_context2.t0}`);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 5]]);
  }));
  this.stopOriginalTrack = () => {
    if (this.originalTrack) {
      this.originalTrack.stop();
      this.originalTrack = null;
    }
  };
  this.connector = connector;
};
MediaProcessorConnector.isValidConnector = connector => typeof (connector == null ? void 0 : connector.setTrack) === 'function' && typeof (connector == null ? void 0 : connector.destroy) === 'function';
var _default = MediaProcessorConnector;
exports.default = _default;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = PublisherFactory;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _objectDestructuringEmpty2 = _interopRequireDefault(__webpack_require__(343));
var _extends2 = _interopRequireDefault(__webpack_require__(344));
var _get = _interopRequireDefault(__webpack_require__(59));
var _assign = _interopRequireDefault(__webpack_require__(9));
var _cloneDeep = _interopRequireDefault(__webpack_require__(62));
var _find = _interopRequireDefault(__webpack_require__(63));
var _isString = _interopRequireDefault(__webpack_require__(303));
var _pick = _interopRequireDefault(__webpack_require__(39));
var _once = _interopRequireDefault(__webpack_require__(52));
var _startCase = _interopRequireDefault(__webpack_require__(740));
var _capitalize = _interopRequireDefault(__webpack_require__(282));
var _assert = _interopRequireDefault(__webpack_require__(159));
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _es6WeakMap = _interopRequireDefault(__webpack_require__(210));
var _cancel = _interopRequireWildcard(__webpack_require__(114));
var _noiseSuppression = __webpack_require__(750);
var _audioFallbackVideoStates = _interopRequireDefault(__webpack_require__(77));
var _congestionLevels = __webpack_require__(28);
var _audioFallbackCoordinator = _interopRequireDefault(__webpack_require__(751));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _promiseDelay = _interopRequireDefault(__webpack_require__(95));
var _env = _interopRequireDefault(__webpack_require__(3));
var _deviceHelpers = _interopRequireDefault(__webpack_require__(22));
var _blockCallsUntilComplete = _interopRequireDefault(__webpack_require__(753));
var _interval_runner = _interopRequireDefault(__webpack_require__(74));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _videoContentHint = __webpack_require__(317);
var _video_orientation = _interopRequireDefault(__webpack_require__(154));
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _analytics = _interopRequireDefault(__webpack_require__(31));
var _promisify = _interopRequireDefault(__webpack_require__(175));
var _isGetRtcStatsReportSupported = _interopRequireDefault(__webpack_require__(338));
var _isSecureContextRequired = _interopRequireDefault(__webpack_require__(294));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _sanitizeVideoFilter = _interopRequireDefault(__webpack_require__(345));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _get_stats_helpers = _interopRequireDefault(__webpack_require__(78));
var _Event = _interopRequireDefault(__webpack_require__(148));
var _createCleanupJobs = _interopRequireDefault(__webpack_require__(166));
var _whitelistPublisherProperties = _interopRequireDefault(__webpack_require__(754));
var _widget_view = _interopRequireDefault(__webpack_require__(176));
var _audioLevelBehaviour = _interopRequireDefault(__webpack_require__(755));
var _unblockAudio = _interopRequireDefault(__webpack_require__(177));
var _createCanvasVideoTrack = _interopRequireDefault(__webpack_require__(756));
var _getDeviceIdFromStream = _interopRequireDefault(__webpack_require__(757));
var _createStreamErrorMap = _interopRequireDefault(__webpack_require__(758));
var _getMediaModeBySourceStreamId = _interopRequireDefault(__webpack_require__(180));
var _calculateCapableSimulcastStreams = _interopRequireDefault(__webpack_require__(277));
var _createChromeMixin = _interopRequireDefault(__webpack_require__(309));
var _environment_loader = _interopRequireDefault(__webpack_require__(158));
var _events = _interopRequireDefault(__webpack_require__(18));
var _interpretPeerConnectionError = _interopRequireDefault(__webpack_require__(172));
var _microphone = _interopRequireDefault(__webpack_require__(319));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _parseIceServers = __webpack_require__(110);
var _max_delay = _interopRequireDefault(__webpack_require__(291));
var _publisher_peer_connection = _interopRequireDefault(__webpack_require__(320));
var _state = _interopRequireDefault(__webpack_require__(327));
var _stream_channel = _interopRequireDefault(__webpack_require__(161));
var _system_requirements = _interopRequireDefault(__webpack_require__(163));
var _createSendMethod = _interopRequireDefault(__webpack_require__(341));
var _mediaProcessor = _interopRequireDefault(__webpack_require__(759));
var _mediaProcessorConnector = _interopRequireDefault(__webpack_require__(181));
var _shouldLogMediaProcessorEvents = _interopRequireDefault(__webpack_require__(765));
var _audioInputDevicesChangeListener = _interopRequireDefault(__webpack_require__(766));
var _amrAudioTrackProcessor = _interopRequireDefault(__webpack_require__(768));
var _cancellation = __webpack_require__(769);
var _amrStateMachine = _interopRequireDefault(__webpack_require__(334));
var _amrStateDurations = _interopRequireDefault(__webpack_require__(178));
var _isValidAudioFilter = _interopRequireDefault(__webpack_require__(770));
var _getDefaultConfig = _interopRequireDefault(__webpack_require__(771));
var _getScalabilityModeFromContentHint = _interopRequireDefault(__webpack_require__(772));
var _setScalabilityMode = _interopRequireDefault(__webpack_require__(773));
var _getNumEncodings = _interopRequireDefault(__webpack_require__(774));
var _proxyUrl = __webpack_require__(72);
var _createPublishVideoPromiseHandlers = _interopRequireDefault(__webpack_require__(775));
var _permissionListener = _interopRequireDefault(__webpack_require__(776));
var _accessDeniedEvent = _interopRequireDefault(__webpack_require__(777));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable global-require, func-names, max-len */
/* eslint-disable no-use-before-define, no-prototype-builtins */
/* global MediaStreamTrack, MediaStreamTrackGenerator */

// @todo need to ensure logging for peer disconnected, and peer failures is intact

const defaultWidgetView = (0, _widget_view.default)();
const _allDeviceHelpers = (0, _deviceHelpers.default)(),
  getInputMediaDevices = _allDeviceHelpers.getInputMediaDevices;
function PublisherFactory(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }
  let _ref2 = _ref,
    deps = (0, _extends2.default)({}, ((0, _objectDestructuringEmpty2.default)(_ref2), _ref2));
  ['processPubOptions'].forEach(key => {
    (0, _assert.default)(deps[key], `${key} dependency must be injected into Publisher`);
  });
  const AnalyticsHelper = deps.AnalyticsHelper || _analytics.default;
  const createAudioFallbackCoordinator = deps.createAudioFallbackCoordinator || _audioFallbackCoordinator.default;
  const calculateCapableSimulcastStreams = deps.calculateCapableSimulcastStreams || _calculateCapableSimulcastStreams.default;
  const createChromeMixin = deps.createChromeMixin || (0, _createChromeMixin.default)();
  const deviceHelpers = deps.deviceHelpers || (0, _deviceHelpers.default)();
  const EnvironmentLoader = deps.EnvironmentLoader || _environment_loader.default;
  const Errors = deps.Errors || _Errors.default;
  const Events = deps.Events || (0, _events.default)();
  const ExceptionCodes = deps.ExceptionCodes || _exception_codes.default;
  const interpretPeerConnectionError = deps.interpretPeerConnectionError || (0, _interpretPeerConnectionError.default)();
  const IntervalRunner = deps.IntervalRunner || _interval_runner.default;
  const logging = deps.logging || (0, _log.default)('Publisher');
  const Microphone = deps.Microphone || (0, _microphone.default)();
  const otError = deps.otError || (0, _otError.default)();
  const OTErrorClass = deps.OTErrorClass || _ot_error_class.default;
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const parseIceServers = deps.parseIceServers || _parseIceServers.parseIceServers;
  const PUBLISH_MAX_DELAY = deps.PUBLISH_MAX_DELAY || _max_delay.default;
  const PublisherPeerConnection = deps.PublisherPeerConnection || (0, _publisher_peer_connection.default)();
  const PublishingState = deps.PublishingState || (0, _state.default)();
  const StreamChannel = deps.StreamChannel || _stream_channel.default;
  const systemRequirementsFactory = deps.systemRequirementsFactory || _system_requirements.default;
  const VideoOrientation = deps.VideoOrientation || (0, _video_orientation.default)();
  const WidgetView = deps.WidgetView || defaultWidgetView;
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  const createSendMethod = deps.createSendMethod || _createSendMethod.default;
  const MediaProcessor = deps.MediaProcessor || _mediaProcessor.default;
  const MediaProcessorConnector = _mediaProcessorConnector.default;
  const createVonageNoiseSuppression = deps.createVonageNoiseSuppression || _noiseSuppression.createVonageNoiseSuppression;
  const setScalabilityMode = deps.setScalabilityMode || _setScalabilityMode.default;
  const addAudioInputDevicesChangeListenerFactory = deps.addAudioInputDevicesChangeListenerFactory || _audioInputDevicesChangeListener.default;
  const addAudioInputDevicesChangeListener = addAudioInputDevicesChangeListenerFactory();
  const shouldLogMediaProcessorEvents = deps.shouldLogMediaProcessorEvents || _shouldLogMediaProcessorEvents.default;
  const processPubOptions = deps.processPubOptions;
  const _AMRStateDurationsDef = Object.assign({}, _amrStateDurations.default, deps.AMRStateDurations),
    KEEP_SENDING_MEDIA_AFTER_TRANSITIONED = _AMRStateDurationsDef.KEEP_SENDING_MEDIA_AFTER_TRANSITIONED,
    KEEP_SENDING_MEDIA_TO_KEEP_ALIVE = _AMRStateDurationsDef.KEEP_SENDING_MEDIA_TO_KEEP_ALIVE,
    KEEP_SENDING_RTCP_DELAY = _AMRStateDurationsDef.KEEP_SENDING_RTCP_DELAY;

  /**
   * The Publisher object  provides the mechanism through which control of the
   * published stream is accomplished. Calling the <code>OT.initPublisher()</code> method
   * creates a Publisher object. </p>
   *
   *  <p>The following code instantiates a session, and publishes an audio-video stream
   *  upon connection to the session: </p>
   *
   *  <pre>
   *  var apiKey = ''; // Replace with your API key. See https://tokbox.com/account
   *  var sessionID = ''; // Replace with your own session ID.
   *                      // See https://tokbox.com/developer/guides/create-session/.
   *  var token = ''; // Replace with a generated token that has been assigned the moderator role.
   *                  // See https://tokbox.com/developer/guides/create-token/.
   *
   *  var session = OT.initSession(apiKey, sessionID);
   *  session.connect(token, function(error) {
   *    if (error) {
   *      console.log(error.message);
   *    } else {
   *      // This example assumes that a DOM element with the ID 'publisherElement' exists
   *      var publisherProperties = {width: 400, height:300, name:"Bob's stream"};
   *      publisher = OT.initPublisher('publisherElement', publisherProperties);
   *      session.publish(publisher);
   *    }
   *  });
   *  </pre>
   *
   *      <p>This example creates a Publisher object and adds its video to a DOM element
   *      with the ID <code>publisherElement</code> by calling the <code>OT.initPublisher()</code>
   *      method. It then publishes a stream to the session by calling
   *      the <code>publish()</code> method of the Session object.</p>
   *
   * @property {Boolean} accessAllowed Whether the user has granted access to the camera
   * and microphone. The Publisher object dispatches an <code>accessAllowed</code> event when
   * the user grants access. The Publisher object dispatches an <code>accessDenied</code> event
   * when the user denies access.
   * @property {Element} element The HTML DOM element containing the Publisher. (<i>Note:</i>
   * when you set the <code>insertDefaultUI</code> option to <code>false</code> in the call to
   * <a href="OT.html#initPublisher">OT.initPublisher</a>, the <code>element</code> property
   * is undefined.)
   * @property {String} id The DOM ID of the Publisher.
   * @property {Stream} stream The {@link Stream} object corresponding the stream of
   * the Publisher.
   * @property {Session} session The {@link Session} to which the Publisher belongs.
   *
   * @see <a href="OT.html#initPublisher">OT.initPublisher</a>
   * @see <a href="Session.html#publish">Session.publish()</a>
   *
   * @class Publisher
   * @augments EventDispatcher
   */
  const Publisher = function Publisher(options) {
    var _this = this;
    if (options === void 0) {
      options = {};
    }
    let privateEvents = (0, _eventing.default)({});
    const peerConnectionMetaMap = new _es6WeakMap.default();
    const amrState = (0, _amrStateMachine.default)();

    /**
     * @typedef {Object} peerConnectionMeta
     * @property {String} remoteConnectionId The connection id of the remote side
     * @property {String} remoteSubscriberId The subscriber id of the remote side
     * @property {String} peerId The peerId of this peer connection
     * @property {String} peerConnectionId Our local identifier for this peer connection
     */

    /**
     * Retrieve meta information for this peer connection
     * @param {PublisherPeerConnection} peerConnection
     * @returns {peerConnectionMeta} meta data regarding this peer connection
     */
    const getPeerConnectionMeta = peerConnection => peerConnectionMetaMap.get(peerConnection);
    const setPeerConnectionMeta = (peerConnection, value) => peerConnectionMetaMap.set(peerConnection, value);
    (0, _eventing.default)(this);
    const streamCleanupJobs = (0, _createCleanupJobs.default)();

    /** @type AnalyticsHelperDefault */
    let analytics = new AnalyticsHelper();

    // Check that the client meets the minimum requirements, if they don't the upgrade
    // flow will be triggered.
    const systemRequirements = systemRequirementsFactory();
    if (!systemRequirements.check()) {
      systemRequirements.upgrade();
    }
    /** @type {WidgetView|null} */
    let widgetView;
    let webRTCStream;
    let publishStartTime;
    let microphone;
    let state;
    let rumorIceServers;
    let attemptStartTime;
    let audioDevices;
    let videoDevices;
    let selectedVideoInputDeviceId;
    let selectedAudioInputDeviceId;
    let _currentTrackDeviceId;
    let didPublishComplete = false;
    let activeSourceStreamId;
    let _keepSendingRtcpToMantisTimeout;
    let _restartSendingRtpToMantisCalled;
    let _videoMediaProcessorConnector;
    let _audioMediaProcessorConnector;
    const hybridSessionTransitionStartTimes = {};
    const lastIceConnectionStates = {};
    let _streamDestroyTimeout;
    const STREAM_DESTROY_DELAY = 5000;
    let pendingRumorAudioFallbackMessage = false;
    let removeDeviceChangeListener;
    let _migrationTimeoutId;
    let _previousPeerConnection;
    let _peerId;
    let _raptorUri;

    /** @type IntervalRunnerDefault | undefined */
    let connectivityAttemptPinger;

    // _session mimics the publisher.session variable except it's never set to null
    // this allows analytics to refer to it in cases where we disconnect/destroy
    // and go to log analytics and publisher.session has been set to null
    let _session;
    const _options = options,
      _enableSenderStats = _options._enableSenderStats;
    const getSession = () => this.session || _session || {
      isConnected() {
        return false;
      }
    };
    const getStreamId = () => this.streamId || '';
    const streamChannels = [];
    const mediaProcessor = new MediaProcessor();
    const amrAudioTrackProcessor = new _amrAudioTrackProcessor.default();
    this.once('publishComplete', err => {
      if (!err) {
        var _this$session;
        didPublishComplete = true;
        activeSourceStreamId = activeSourceStreamId || (_this$session = this.session) != null && _this$session.sessionInfo.p2pEnabled ? 'P2P' : 'MANTIS';
      }
    });
    this.on('sourceStreamIdChanged', newSourceStreamId => {
      activeSourceStreamId = newSourceStreamId;
      amrState.completeTransitionTo(activeSourceStreamId);
    });
    this.on('audioAcquisitionProblem', _ref3 => {
      let method = _ref3.method;
      logAnalyticsEvent('publisher:audioAcquisitionProblem', 'Event', {
        didPublishComplete,
        method
      });
    });
    function getCommonAnalyticsFields() {
      var _getSession, _getSession2, _getSession2$connecti;
      return {
        connectionId: (_getSession = getSession()) != null && _getSession.isConnected() ? (_getSession2 = getSession()) == null ? void 0 : (_getSession2$connecti = _getSession2.connection) == null ? void 0 : _getSession2$connecti.connectionId : null,
        streamId: getStreamId(),
        widgetType: 'Publisher'
      };
    }
    const onStreamAvailableError = plainError => {
      const names = Object.keys(Errors).map(shortName => Errors[shortName]);
      const error = otError(names.indexOf(plainError.name) > -1 ? plainError.name : Errors.MEDIA_ERR_ABORTED, plainError, ExceptionCodes.UNABLE_TO_PUBLISH);
      logging.error(`onStreamAvailableError ${error.name}: ${error.message}`);
      state.set('Failed');
      if (widgetView) {
        widgetView.destroy();
        widgetView = null;
      }
      const logOptions = {
        failureReason: 'GetUserMedia',
        failureCode: ExceptionCodes.UNABLE_TO_PUBLISH,
        failureMessage: `OT.Publisher failed to access camera/mic: ${error.message}`
      };
      logConnectivityEvent('Failure', {}, logOptions);
      OTErrorClass.handleJsException({
        error,
        errorMsg: logOptions.failureReason,
        code: logOptions.failureCode,
        target: this,
        analytics
      });
      this.trigger('publishComplete', error);
    };
    const onScreenSharingError = errorParam => {
      const error = (0, _cloneDeep.default)(errorParam);
      error.code = ExceptionCodes.UNABLE_TO_PUBLISH;
      logging.error(`OT.Publisher.onScreenSharingError ${error.message}`);
      state.set('Failed');
      error.message = `Screensharing: ${error.message}`;
      this.trigger('publishComplete', error);
      logConnectivityEvent('Failure', {}, {
        failureReason: 'ScreenSharing',
        failureMessage: error.message
      });
      if (widgetView) {
        widgetView.destroy();
        widgetView = null;
      }
    };

    // The user has clicked the 'deny' button in the allow access dialog, or it's
    // set to always deny, or the access was denied due to HTTP restrictions;
    const onAccessDenied = errorParam => {
      const error = (0, _cloneDeep.default)(errorParam);
      let isIframe;
      try {
        isIframe = window.self !== window.top;
      } catch (err) {
        // ignore errors, (some browsers throw a security error when accessing cross domain)
      }
      if ((typeof window !== undefined ? window : global).location.protocol !== 'https:') {
        if (isScreenSharing) {
          /*
           * in http:// the browser will deny permission without asking the
           * user. There is also no way to tell if it was denied by the
           * user, or prevented from the browser.
           */
          error.message += ' Note: https:// is required for screen sharing.';
        } else if ((0, _isSecureContextRequired.default)() && OTHelpers.env.hostName !== 'localhost') {
          error.message += ` Note: ${OTHelpers.env.name} requires HTTPS for camera and microphone access.`;
        }
      }
      if (isIframe && !isScreenSharing) {
        error.message += ' Note: Check that the iframe has the allow attribute for camera and microphone';
      }
      logging.error(error.message);
      state.set('Failed');

      // Note: The substring 'Publisher Access Denied:' is part of our api contract for now.
      // https://tokbox.com/developer/guides/publish-stream/js/#troubleshooting
      error.message = `OT.Publisher Access Denied: Permission Denied: ${error.message}`;
      error.code = ExceptionCodes.UNABLE_TO_PUBLISH;
      if (widgetView) {
        widgetView.destroy();
        widgetView = null;
      }
      logConnectivityEvent('Cancel', {
        reason: 'AccessDenied'
      });
      this.trigger('publishComplete', error);
      this.dispatchEvent((0, _accessDeniedEvent.default)('device', 'while initializing'));
    };
    const userMediaError = error => {
      // See OPENTOK-48099 for more context. In certain instances, this passed-in parameter can be malformed.
      if (!(error instanceof Error || /^\[object .*Error\]$/.test(Object.prototype.toString.call(error)))) {
        // eslint-disable-next-line no-param-reassign
        error = new Error('Unknown error has occurred. Stream is not available.');
      }
      const isPermissionError = error.name === Errors.USER_MEDIA_ACCESS_DENIED || error.name === Errors.NOT_SUPPORTED && error.originalMessage.match(/Only secure origins/);
      if (isPermissionError) {
        onAccessDenied(error);
      } else if (processPubOptions.isScreenSharing) {
        onScreenSharingError(error);
      } else {
        onStreamAvailableError(error);
      }
      throw error;
    };
    const onAccessDialogOpened = () => {
      logAnalyticsEvent('accessDialog', 'Opened');
      this.dispatchEvent(new _Event.default(_eventNames.default.ACCESS_DIALOG_OPENED, true));
    };
    const onAccessDialogClosed = () => {
      logAnalyticsEvent('accessDialog', 'Closed');
      this.dispatchEvent(new _Event.default(_eventNames.default.ACCESS_DIALOG_CLOSED, false));
    };
    const guid = (0, _uuid.default)();
    const peerConnectionsAsync = {};
    let loaded = false;
    let previousAnalyticsStats = {};
    let audioAcquisitionProblemDetected = false;
    let processedOptions = processPubOptions(options, 'OT.Publisher', () => state && state.isDestroyed());
    processedOptions.on({
      accessDialogOpened: onAccessDialogOpened,
      accessDialogClosed: onAccessDialogClosed
    });
    const _processedOptions = processedOptions,
      isScreenSharing = _processedOptions.isScreenSharing,
      isCustomAudioTrack = _processedOptions.isCustomAudioTrack,
      isCustomVideoTrack = _processedOptions.isCustomVideoTrack,
      shouldAllowAudio = _processedOptions.shouldAllowAudio,
      properties = _processedOptions.properties,
      getUserMedia = _processedOptions.getUserMedia;

    // start with undefined
    Object.defineProperty(this, 'loudness', {
      writable: false,
      value: undefined,
      configurable: true
    });
    function removeTrackListeners(trackListeners) {
      trackListeners.forEach(off => off());
    }
    const listenWithOff = (obj, event, listener) => {
      if (!obj.addEventListener) {
        // noop
        return () => {};
      }
      obj.addEventListener(event, listener);
      return () => obj.removeEventListener(event, listener);
    };
    (function handleAudioEnded() {
      const trackListeners = [];
      privateEvents.on('streamDestroy', () => removeTrackListeners(trackListeners));
      privateEvents.on('streamChange', () => {
        removeTrackListeners(trackListeners);
        const newListeners = webRTCStream.getAudioTracks().map(track => listenWithOff(track, 'ended', () => {
          // chrome audio acquisition issue
          audioAcquisitionProblemDetected = true;
          this.trigger('audioAcquisitionProblem', {
            method: 'trackEndedEvent'
          });
        }));
        trackListeners.splice(0, trackListeners.length, ...newListeners);
      });
    }).call(this);
    (function handleMuteTrack() {
      const trackListeners = [];
      privateEvents.on('streamDestroy', () => removeTrackListeners(trackListeners));
      privateEvents.on('streamChange', () => {
        removeTrackListeners(trackListeners);

        // Check if we should ignore mute/unmute events coming from the tracks.
        // Further info in shouldSkipMuteEventsFromTrack()
        if (!shouldSkipMuteEventsFromTrack()) {
          webRTCStream.getTracks().forEach(track => {
            if (track.addEventListener) {
              trackListeners.push(listenWithOff(track, 'mute', () => {
                refreshAudioVideoUI();
              }));
              trackListeners.push(listenWithOff(track, 'unmute', () => {
                refreshAudioVideoUI();
              }));
            }
          });
        }
      });
    })();

    // / Private Methods

    const shouldSkipMuteEventsFromTrack = () => {
      // Screensharing in Chrome sometimes triggers 'mute' and 'unmute'
      // repeatedly for no reason OPENTOK-37818
      // https://bugs.chromium.org/p/chromium/issues/detail?id=931033
      if (isScreenSharing) {
        return true;
      }
      // On Chrome when the custom video is static, we are receiving a mute event.
      // If videoContentHint suggests video could be static, i.e. text or detail
      // we will ignore the mute events coming from the video track.
      // Further info: OPENTOK-44289
      const staticContentHints = ['text', 'detail'];
      const isStaticContent = staticContentHints.includes(properties.videoContentHint);
      return isCustomVideoTrack && isStaticContent;
    };
    const logAnalyticsEvent = options.logAnalyticsEvent || ((action, variation, payload, logOptions, throttle) => {
      let stats = (0, _assign.default)({
        action,
        variation,
        payload
      }, getCommonAnalyticsFields(), logOptions);
      if (variation === 'Failure') {
        stats = (0, _assign.default)(previousAnalyticsStats, stats);
      }
      previousAnalyticsStats = (0, _pick.default)(stats, 'sessionId', 'connectionId', 'partnerId');
      analytics.logEvent(stats, throttle);
    });
    const enableMediaProcessorLogging = () => {
      const shouldLogEvents = shouldLogMediaProcessorEvents(this.session);
      if (!shouldLogEvents) {
        mediaProcessor.disableLogging();
        return;
      }

      // We only log events when connected to a session so this should
      // never throw
      const apiKey = this.session.apiKey;
      mediaProcessor.enableLogging(apiKey);
    };
    const logConnectivityEvent = function logConnectivityEvent(variation, payload, logOptions) {
      if (payload === void 0) {
        payload = {};
      }
      if (logOptions === void 0) {
        logOptions = {};
      }
      if (logOptions.failureReason === 'Non-fatal') {
        // we don't want to log because it was a non-fatal failure
        return;
      }
      if (variation === 'Attempt') {
        attemptStartTime = new Date().getTime();
        if (connectivityAttemptPinger) {
          connectivityAttemptPinger.stop();
          logging.error('_connectivityAttemptPinger should have been cleaned up');
        }
        connectivityAttemptPinger = new IntervalRunner(() => {
          logAnalyticsEvent('Publish', 'Attempting', payload, Object.assign({}, getCommonAnalyticsFields(), logOptions));
        }, 1 / 5, 6);
      }
      if (variation === 'Failure' || variation === 'Success' || variation === 'Cancel') {
        if (connectivityAttemptPinger) {
          connectivityAttemptPinger.stop();
          connectivityAttemptPinger = undefined;
        } else {
          logging.warn(`Received connectivity event: "${variation}" without "Attempt"`);
        }
        logAnalyticsEvent('Publish', variation, Object.assign({
          videoInputDevices: videoDevices,
          audioInputDevices: audioDevices,
          videoInputDeviceCount: videoDevices ? videoDevices.length : undefined,
          audioInputDeviceCount: audioDevices ? audioDevices.length : undefined,
          selectedVideoInputDeviceId,
          selectedAudioInputDeviceId
        }, payload), Object.assign({
          attemptDuration: new Date().getTime() - attemptStartTime
        }, logOptions));
      } else {
        logAnalyticsEvent('Publish', variation, payload, logOptions);
      }
    };
    const logRepublish = (variation, payload) => {
      logAnalyticsEvent('ICERestart', variation, payload);
    };
    const logHybridSessionTransition = (action, variation, payload) => {
      if (variation === 'Attempt') {
        hybridSessionTransitionStartTimes[action] = new Date().getTime();
        logAnalyticsEvent(action, variation, payload);
      } else if (variation === 'Failure' || variation === 'Success') {
        logAnalyticsEvent(action, variation, payload, {
          attemptDuration: new Date().getTime() - hybridSessionTransitionStartTimes[action]
        });
      }
    };
    const logRoutedToRelayedTransition = function logRoutedToRelayedTransition(variation, payload) {
      if (payload === void 0) {
        payload = {};
      }
      logHybridSessionTransition('RoutedToRelayedTransition', variation, payload);
    };
    const logRelayedToRoutedTransition = function logRelayedToRoutedTransition(variation, payload) {
      if (payload === void 0) {
        payload = {};
      }
      logHybridSessionTransition('RelayedToRoutedTransition', variation, payload);
    };

    // logs an analytics event for getStats on the first call
    const notifyGetStatsCalled = (0, _once.default)(() => {
      logAnalyticsEvent('GetStats', 'Called');
    });
    const notifyGetRtcStatsCalled = (0, _once.default)(() => {
      logAnalyticsEvent('GetRtcStatsReport', 'Called');
    });
    const recordQOS = _ref4 => {
      var _this$session2, _this$session3, _this$session3$connec, _properties$audioFall;
      let parsedStats = _ref4.parsedStats,
        simulcastEnabled = _ref4.simulcastEnabled,
        remoteConnectionId = _ref4.remoteConnectionId,
        peerId = _ref4.peerId,
        sourceStreamId = _ref4.sourceStreamId;
      const QoSBlob = {
        peerId,
        widgetType: 'Publisher',
        connectionId: (_this$session2 = this.session) != null && _this$session2.isConnected() ? (_this$session3 = this.session) == null ? void 0 : (_this$session3$connec = _this$session3.connection) == null ? void 0 : _this$session3$connec.connectionId : null,
        streamId: this.streamId,
        width: widgetView.width,
        height: widgetView.height,
        audioTrack: webRTCStream && webRTCStream.getAudioTracks().length > 0,
        hasAudio: hasAudio(),
        publishAudio: properties.publishAudio,
        videoTrack: webRTCStream && webRTCStream.getVideoTracks().length > 0,
        hasVideo: hasVideo(),
        publishVideo: properties.publishVideo,
        audioSource: isCustomAudioTrack ? 'Custom' : undefined,
        duration: publishStartTime ? Math.round((new Date().getTime() - publishStartTime.getTime()) / 1000) : 0,
        remoteConnectionId,
        scalableVideo: simulcastEnabled,
        sourceStreamId: (0, _getMediaModeBySourceStreamId.default)(sourceStreamId),
        publisherAudioFallbackEnabled: ((_properties$audioFall = properties.audioFallback) == null ? void 0 : _properties$audioFall.publisher) || false,
        cpuPerformanceState: this.session._.getCpuPerformanceState()
      };
      let videoSource = isScreenSharing && isCustomVideoTrack && 'Screen' || isScreenSharing && options.videoSource || isCustomVideoTrack && 'Custom' || properties.constraints.video && 'Camera' || null;

      // Normalize videoSource so that "application" becomes "Application"
      if ((0, _isString.default)(videoSource)) {
        videoSource = (0, _startCase.default)(videoSource);
      }
      QoSBlob.videoSource = videoSource;
      const videoDimensions = {
        videoWidth: this.videoWidth(),
        videoHeight: this.videoHeight()
      };
      const parsedAndQosStats = (0, _assign.default)({}, QoSBlob, parsedStats, videoDimensions);
      analytics.logQOS(parsedAndQosStats);
      this.trigger('qos', parsedAndQosStats);
    };

    // Returns the video dimensions. Which could either be the ones that
    // the developer specific in the videoDimensions property, or just
    // whatever the video element reports.
    //
    // If all else fails then we'll just default to 640x480
    //
    const getVideoDimensions = () => {
      var _properties$videoDime, _properties$videoDime2;
      // Values order are:
      //   - Defined by the user.
      //   - Default: VGA (640x480).
      let width = ((_properties$videoDime = properties.videoDimensions) == null ? void 0 : _properties$videoDime.width) || 640;
      let height = ((_properties$videoDime2 = properties.videoDimensions) == null ? void 0 : _properties$videoDime2.height) || 480;
      if (properties.publishVideo) {
        var _widgetView;
        // When video is on, we get the real video dimensions. If undefined, we will take the
        // previous defined width|height.
        const video = (_widgetView = widgetView) == null ? void 0 : _widgetView.video();
        width = (video == null ? void 0 : video.videoWidth()) || width;
        height = (video == null ? void 0 : video.videoHeight()) || height;
      }
      return {
        width,
        height
      };
    };

    // / Private Events

    const stateChangeFailed = changeFailed => {
      logging.error('OT.Publisher State Change Failed: ', changeFailed.message);
      logging.debug(changeFailed);
    };
    const onLoaded = () => {
      if (state.isDestroyed()) {
        // The publisher was destroyed before loading finished
        if (widgetView) {
          widgetView.destroyVideo();
        }
        return;
      }
      logging.debug('OT.Publisher.onLoaded; resolution:', `${this.videoWidth()}x${this.videoHeight()}`);
      state.set('MediaBound');

      // Try unblock audio on all subscribers
      (0, _unblockAudio.default)().catch(logging.error);

      // If we have a session and we haven't created the stream yet then
      // wait until that is complete before hiding the loading spinner
      widgetView.loading(this.session ? !this.stream : false);
      loaded = true;
    };
    const onLoadFailure = plainError => {
      // eslint-disable-next-line no-param-reassign
      const err = otError(Errors.CONNECT_FAILED, plainError, ExceptionCodes.P2P_CONNECTION_FAILED);
      err.message = `OT.Publisher PeerConnection Error: ${err.message}`;
      logConnectivityEvent('Failure', {}, {
        failureReason: 'PeerConnectionError',
        failureCode: err.code,
        failureMessage: err.message
      });
      state.set('Failed');
      this.trigger('publishComplete', err);
      OTErrorClass.handleJsException({
        error: err,
        target: this,
        analytics
      });
    };

    // Clean up our LocalMediaStream
    const cleanupLocalStream = () => {
      if (webRTCStream) {
        privateEvents.emit('streamDestroy');
        // Stop revokes our access cam and mic access for this instance
        // of localMediaStream.
        if (windowMock.MediaStreamTrack && windowMock.MediaStreamTrack.prototype.stop) {
          // Newer spec
          webRTCStream.getTracks().forEach(track => track.stop());
        } else {
          // Older spec
          webRTCStream.stop();
        }
      }
    };
    const iOSRotatedVideoFeedBugHandler = () => {
      // In iOS 15+, when the page is put on background and then restored, the publisher video feed
      // is getting rotated. A workaround is to rebind the srcObject.
      const isBuggediOS = _env.default.isiOS && _env.default.iOSVersion >= 15 && _env.default.iOSVersion < 15.2;
      const videoTrack = webRTCStream.getVideoTracks()[0];
      if (!isBuggediOS || !videoTrack) {
        return;
      }
      const visibilityHandler = () => {
        if (!document.hidden && widgetView) {
          widgetView.rebindSrcObject();
        }
      };
      document.addEventListener('visibilitychange', visibilityHandler);
    };
    const iOSBuggedLocalAudioTrackHandler = () => {
      // see https://bugs.webkit.org/show_bug.cgi?id=208209 & https://bugs.webkit.org/show_bug.cgi?id=208516
      // in iOS 13.3 and later, the audiotrack sometimes fails to unmute after receivng a phone call
      // this work around relies on the visibility of the page to see if the call is over
      const isBuggediOS = _env.default.isiOS && _env.default.iOSVersion >= 13.3;
      const audioTrack = webRTCStream.getAudioTracks()[0];
      if (isBuggediOS && audioTrack) {
        audioTrack.onmute = () => handleBuggedMutedLocalAudioTrack(audioTrack);
        // When iOS uses compact UI for phone calls, the visibility of the page is not relevant.
        // As a workaround for this specific case, when the track is back to unmuted
        // we reset the audio source. See OPENTOK-42233.
        audioTrack.onunmute = () => handleBuggedUnMutedLocalAudioTrack(audioTrack);
      }
    };
    const bindVideo = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var videoContainerOptions;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              videoContainerOptions = {
                muted: true
              };
              if (widgetView) {
                _context.next = 3;
                break;
              }
              throw new Error('Cannot bind video after widget view has been destroyed');
            case 3:
              return _context.abrupt("return", widgetView.bindVideo(webRTCStream, videoContainerOptions));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function bindVideo() {
        return _ref5.apply(this, arguments);
      };
    }();
    const onStreamAvailable = /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(webOTStream) {
        var findSelectedDeviceId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              logging.debug('OT.Publisher.onStreamAvailable');
              state.set('BindingMedia');
              if (properties.videoContentHint !== undefined) {
                (0, _videoContentHint.setVideoContentHint)(webOTStream, properties.videoContentHint);
              }
              cleanupLocalStream();
              webRTCStream = webOTStream;
              if (!properties.videoFilter) {
                _context2.next = 14;
                break;
              }
              _context2.prev = 6;
              _context2.next = 9;
              return _this.applyVideoFilter(properties.videoFilter);
            case 9:
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](6);
              logging.error(`Error applying video filter: ${_context2.t0}`);
            case 14:
              if (!properties.audioFilter) {
                _context2.next = 23;
                break;
              }
              _context2.prev = 15;
              _context2.next = 18;
              return _this.applyAudioFilter(properties.audioFilter);
            case 18:
              _context2.next = 23;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t1 = _context2["catch"](15);
              logging.error(`Error applying audio filter: ${_context2.t1}`);
            case 23:
              privateEvents.emit('streamChange');
              iOSBuggedLocalAudioTrackHandler();
              iOSRotatedVideoFeedBugHandler();
              findSelectedDeviceId = (tracks, devices) => {
                // Store the device labels to log later
                let selectedDeviceId;
                tracks.forEach(track => {
                  if (track.deviceId) {
                    selectedDeviceId = track.deviceId.toString();
                  } else if (track.label && devices) {
                    const selectedDevice = (0, _find.default)(devices, el => el.label === track.label);
                    if (selectedDevice) {
                      selectedDeviceId = selectedDevice.deviceId;
                    }
                  }
                });
                return selectedDeviceId;
              };
              selectedVideoInputDeviceId = findSelectedDeviceId(webRTCStream.getVideoTracks(), videoDevices);
              selectedAudioInputDeviceId = findSelectedDeviceId(webRTCStream.getAudioTracks(), audioDevices);
              microphone = new Microphone(webRTCStream, !properties.publishAudio);
              updateVideo();
              updateAudio();
              _this.accessAllowed = true;
              _this.dispatchEvent(new _Event.default(_eventNames.default.ACCESS_ALLOWED, false));
            case 34:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[6, 11], [15, 20]]);
      }));
      return function onStreamAvailable(_x) {
        return _ref6.apply(this, arguments);
      };
    }();
    const onPublishingTimeout = session => {
      logging.error('OT.Publisher.onPublishingTimeout');
      let errorName;
      let errorMessage;
      if (audioAcquisitionProblemDetected) {
        errorName = Errors.CHROME_MICROPHONE_ACQUISITION_ERROR;
        errorMessage = 'Unable to publish because your browser failed to get access to your ' + 'microphone. You may need to fully quit and restart your browser to get it to work. ' + 'See https://bugs.chromium.org/p/webrtc/issues/detail?id=4799 for more details.';
      } else {
        errorName = Errors.TIMEOUT;
        errorMessage = 'Could not publish in a reasonable amount of time';
      }
      const logOptions = {
        failureReason: 'ICEWorkflow',
        failureCode: ExceptionCodes.UNABLE_TO_PUBLISH,
        failureMessage: 'OT.Publisher failed to publish in a reasonable amount of time (timeout)'
      };
      logConnectivityEvent('Failure', {}, logOptions);
      OTErrorClass.handleJsException({
        errorMsg: logOptions.failureReason,
        code: logOptions.failureCode,
        target: this,
        analytics
      });
      if (session.isConnected() && this.streamId) {
        session._.streamDestroy(this.streamId);
      }

      // Disconnect immediately, rather than wait for the WebSocket to
      // reply to our destroyStream message.
      this.disconnect();

      // We're back to being a stand-alone publisher again.
      if (!state.isDestroyed()) {
        state.set('MediaBound');
      }
      this.trigger('publishComplete', otError(errorName, new Error(errorMessage), ExceptionCodes.UNABLE_TO_PUBLISH));
    };
    const onVideoError = plainErr => {
      // eslint-disable-next-line no-param-reassign
      const err = otError(Errors.MEDIA_ERR_DECODE, plainErr, ExceptionCodes.UNABLE_TO_PUBLISH);
      err.message = `OT.Publisher while playing stream: ${err.message}`;
      logging.error('OT.Publisher.onVideoError:', err);
      logAnalyticsEvent('stream', null, {
        reason: err.message
      });

      // Check if attempting to publish *before* overwriting the state
      const isAttemptingToPublish = state.isAttemptingToPublish();
      state.set('Failed');
      if (isAttemptingToPublish) {
        this.trigger('publishComplete', err);
      } else {
        // FIXME: This emits a string instead of an error here for backwards compatibility despite
        // being undocumented. When possible we should remove access to this and other undocumented
        // events, and restore emitting actual errors here.
        this.trigger('error', err.message);
      }
      OTErrorClass.handleJsException({
        error: err,
        target: this,
        analytics
      });
    };

    // Makes it easier to unit test stuff
    this._setWebRTCStream = stream => {
      webRTCStream = stream;
    };

    // Makes it easier to unit test stuff
    this._setCurrentVideoFilter = filter => {
      currentVideoFilter = filter;
    };

    // Makes it easier to unit test stuff
    this._getCurrentVideoFilter = () => currentVideoFilter;

    // Makes it easier to unit test stuff
    this._setCurrentAudioFilter = audioFilter => {
      currentAudioFilter = audioFilter;
    };

    // Makes it easier to unit test stuff
    this._getMediaProcessor = () => mediaProcessor;
    this._removePeerConnection = peerConnection => {
      var _audioFallbackCoordin;
      if (!peerConnection) {
        return;
      }
      const _getPeerConnectionMet = getPeerConnectionMeta(peerConnection),
        peerConnectionId = _getPeerConnectionMet.peerConnectionId;
      delete peerConnectionsAsync[peerConnectionId];
      peerConnection.destroy();
      (_audioFallbackCoordin = audioFallbackCoordinator) == null ? void 0 : _audioFallbackCoordin.onPeerConnectionDisconnected();
    };
    this._removeSubscriber = subscriberId => {
      const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
      if (isAdaptiveEnabled && activeSourceStreamId === 'P2P') {
        this._.startRelayedToRoutedTransition();
      }
      getPeerConnectionsBySubscriber(subscriberId).then(peerConnections => {
        peerConnections.forEach(pc => this._removePeerConnection(pc));
      });
    };
    const onPeerDisconnected = peerConnection => {
      const _getPeerConnectionMet2 = getPeerConnectionMeta(peerConnection),
        remoteSubscriberId = _getPeerConnectionMet2.remoteSubscriberId,
        peerConnectionId = _getPeerConnectionMet2.peerConnectionId;
      logging.debug('Subscriber has been disconnected from the Publisher\'s PeerConnection');
      logAnalyticsEvent('disconnect', 'PeerConnection', {
        subscriberConnection: peerConnectionId
      });
      this._removeSubscriber(remoteSubscriberId);
    };

    // @todo find out if we get onPeerDisconnected when a failure occurs.
    const onPeerConnectionFailure = /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(peerConnection, _ref7) {
        var reason, prefix, sessionInfo, _ref9, _ref9$remoteConnectio, remoteConnectionId, peerConnectionId, error, payload, logOptions, pc;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              reason = _ref7.reason, prefix = _ref7.prefix;
              sessionInfo = _this.session && _this.session.sessionInfo;
              if (!(prefix === 'ICEWorkflow' && sessionInfo && sessionInfo.reconnection && loaded)) {
                _context3.next = 5;
                break;
              }
              // @todo not sure this is the right thing to do
              logging.debug('Ignoring peer connection failure due to possibility of reconnection.');
              return _context3.abrupt("return");
            case 5:
              _ref9 = getPeerConnectionMeta(peerConnection) || {}, _ref9$remoteConnectio = _ref9.remoteConnectionId, remoteConnectionId = _ref9$remoteConnectio === void 0 ? '(not found)' : _ref9$remoteConnectio, peerConnectionId = _ref9.peerConnectionId;
              error = interpretPeerConnectionError(undefined, reason, prefix, remoteConnectionId, 'Publisher');
              payload = {
                hasRelayCandidates: peerConnection && peerConnection.hasRelayCandidates()
              };
              logOptions = {
                failureReason: prefix || 'PeerConnectionError',
                failureCode: error.code,
                failureMessage: error.message
              };
              if (state.isPublishing()) {
                // We're already publishing so this is a Non-fatal failure, must be p2p and one of our
                // peerconnections failed
                logOptions.reason = 'Non-fatal';
              } else {
                _this.trigger('publishComplete', error);
              }
              logConnectivityEvent('Failure', payload, logOptions);
              OTErrorClass.handleJsException({
                errorMsg: `OT.Publisher PeerConnection Error: ${reason}`,
                code: error.code,
                target: _this,
                analytics
              });
              _context3.next = 14;
              return peerConnectionsAsync[peerConnectionId];
            case 14:
              pc = _context3.sent;
              pc.destroy();
              delete peerConnectionsAsync[peerConnectionId];
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function onPeerConnectionFailure(_x2, _x3) {
        return _ref8.apply(this, arguments);
      };
    }();
    const isRoutedToRelayedTransitionComplete = peerConnection => {
      const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
      return isAdaptiveEnabled && peerConnection.getSourceStreamId() === 'P2P';
    };
    const onIceRestartSuccess = peerConnection => {
      const _getPeerConnectionMet3 = getPeerConnectionMeta(peerConnection),
        remoteConnectionId = _getPeerConnectionMet3.remoteConnectionId;
      logRepublish('Success', {
        remoteConnectionId
      });
    };
    const onIceRestartFailure = peerConnection => {
      const _getPeerConnectionMet4 = getPeerConnectionMeta(peerConnection),
        remoteConnectionId = _getPeerConnectionMet4.remoteConnectionId;
      logRepublish('Failure', {
        reason: 'ICEWorkflow',
        message: 'OT.Publisher PeerConnection Error: ' + 'The stream was unable to connect due to a network error.' + ' Make sure your connection isn\'t blocked by a firewall.',
        remoteConnectionId
      });
    };
    const handleDisconnect = (peerConnection, sourceStreamId) => {
      setTimeout(() => {
        if (lastIceConnectionStates[sourceStreamId] === 'disconnected' && _session._.isSocketConnected()) {
          const _getPeerConnectionMet5 = getPeerConnectionMeta(peerConnection),
            remoteConnectionId = _getPeerConnectionMet5.remoteConnectionId;
          logRepublish('Attempt', {
            remoteConnectionId
          });
          peerConnection.iceRestart();
        }
      }, 2000);
    };
    const handleConnect = /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _yield$getMantisPeerC, _yield$getP2pPeerConn, isMantisConnected, isP2PConnected;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              clearTimeout(_streamDestroyTimeout);
              if (!_this.session.sessionInfo.isAdaptiveEnabled) {
                _context4.next = 21;
                break;
              }
              _context4.next = 4;
              return getMantisPeerConnection();
            case 4:
              _context4.t0 = _yield$getMantisPeerC = _context4.sent;
              if (!(_context4.t0 == null)) {
                _context4.next = 9;
                break;
              }
              _context4.t1 = void 0;
              _context4.next = 10;
              break;
            case 9:
              _context4.t1 = _yield$getMantisPeerC.iceConnectionStateIsConnected();
            case 10:
              isMantisConnected = _context4.t1;
              _context4.next = 13;
              return getP2pPeerConnection();
            case 13:
              _context4.t2 = _yield$getP2pPeerConn = _context4.sent;
              if (!(_context4.t2 == null)) {
                _context4.next = 18;
                break;
              }
              _context4.t3 = void 0;
              _context4.next = 19;
              break;
            case 18:
              _context4.t3 = _yield$getP2pPeerConn.iceConnectionStateIsConnected();
            case 19:
              isP2PConnected = _context4.t3;
              if (isMantisConnected && isP2PConnected) {
                _stopSendingRtpToMantis();
              }
            case 21:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function handleConnect() {
        return _ref10.apply(this, arguments);
      };
    }();
    const shouldDestroyPublisher = sourceStreamId => {
      const p2pEnabled = this.session.sessionInfo.p2pEnabled;
      // We destroy the publisher if:
      // Socket is connected. Otherwise we will try to reconnect once socket reconnects.
      return _session._.isSocketConnected()
      // And this is the active leg. Inactive leg fail independently.
      && sourceStreamId === activeSourceStreamId
      // And it is not P2P. In P2P the other peer can be reconnecting.
      // If we don't detroy the Publisher, this will be destroyed once Rumors says so.
      && !p2pEnabled;
    };
    const handleFail = sourceStreamId => {
      if (!shouldDestroyPublisher(sourceStreamId)) {
        return;
      }
      const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
      if (isAdaptiveEnabled && sourceStreamId === 'P2P') {
        // In adaptive if P2P PC has failed and the socket is connected we will transition to Mantis
        this._.startRelayedToRoutedTransition();
      } else {
        // Instead of destroying the publisher straight away, we will destroy it after 5 secs
        // in order to avoid a race condition where we just got the socket connected at the
        // same moment PC transition to failed
        _streamDestroyTimeout = setTimeout(() => {
          this.session._.streamDestroy(this.streamId, sourceStreamId);
        }, STREAM_DESTROY_DELAY);
      }
    };
    const onIceConnectionStateChange = /*#__PURE__*/function () {
      var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(newState, peerConnection) {
        var sourceStreamId;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              sourceStreamId = peerConnection.getSourceStreamId();
              lastIceConnectionStates[sourceStreamId] = newState;
              if (!(newState === 'connected')) {
                _context5.next = 7;
                break;
              }
              _context5.next = 5;
              return handleConnect();
            case 5:
              _context5.next = 8;
              break;
            case 7:
              if (newState === 'disconnected') {
                handleDisconnect(peerConnection, sourceStreamId);
              } else if (newState === 'failed') {
                handleFail(sourceStreamId);
              }
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function onIceConnectionStateChange(_x4, _x5) {
        return _ref11.apply(this, arguments);
      };
    }();
    const onPeerConnected = peerConnection => {
      peerConnection.setP2PMaxBitrate();
      peerConnection.startEncryption(this.session.connection.id);
      if (isRoutedToRelayedTransitionComplete(peerConnection)) {
        logRoutedToRelayedTransition('Success');
      }
    };

    // / Private Helpers

    // Assigns +stream+ to this publisher. The publisher listens for a bunch of events on the stream
    // so it can respond to changes.

    const assignStream = stream => {
      // the Publisher only expects a stream in the PublishingToSession state
      if (state.current !== 'PublishingToSession' && !state.isPublishing()) {
        throw new Error('assignStream called when publisher is not successfully publishing');
      }
      streamCleanupJobs.releaseAll();
      this.stream = stream;
      this.stream.on('destroyed', this.disconnect, this);
      streamCleanupJobs.add(() => {
        if (this.stream) {
          this.stream.off('destroyed', this.disconnect, this);
        }
      });
      if (!state.isMigrating()) {
        state.set('Publishing');
        publishStartTime = new Date();
        this.dispatchEvent(new Events.StreamEvent('streamCreated', stream, null, false));
      }
      widgetView.loading(!loaded);
      logConnectivityEvent('Success');
      this.trigger('publishComplete', null, this);
    };

    /**
     * Provides the peer connection associated to the given peerConnectionId.
     *
     * It there is no PC associated it creates a new one and stores it so that the next call returns
     * the same instance.
     *
     * @param {Object} configuration
     * @param {string} configuration.peerConnectionId
     * @returns {Promise<Error, PublisherPeerConnection>}
     */
    const createPeerConnection = _ref12 => {
      let peerConnectionId = _ref12.peerConnectionId,
        send = _ref12.send,
        log = _ref12.log,
        logQoS = _ref12.logQoS,
        sourceStreamId = _ref12.sourceStreamId;
      if (!state.isMigrating() && getPeerConnectionById(peerConnectionId)) {
        return Promise.reject(new Error('PeerConnection already exists'));
      }

      // Calculate the number of streams to use. 1 for normal, >1 for Simulcast
      const capableSimulcastStreams = calculateCapableSimulcastStreams({
        isChromiumEdge: OTHelpers.env.isChromiumEdge,
        browserName: OTHelpers.env.name,
        isScreenSharing,
        isCustomVideoTrack,
        sessionInfo: this.session.sessionInfo,
        constraints: properties.constraints,
        videoDimensions: getVideoDimensions(),
        capableSimulcastScreenshare: properties.capableSimulcastScreenshare,
        scalableVideo: properties.scalableVideo
      });
      peerConnectionsAsync[peerConnectionId] = Promise.all([this.session._.getIceConfig(), this.session._.getVideoCodecsCompatible(webRTCStream)]).then(_ref13 => {
        var _this$session4, _this$session4$sessio, _this$session5, _this$session5$sessio;
        let iceConfig = _ref13[0],
          videoCodecsCompatible = _ref13[1];
        let pcStream = webRTCStream;
        if (!videoCodecsCompatible) {
          pcStream = webRTCStream.clone();
          const _pcStream$getVideoTra = pcStream.getVideoTracks(),
            videoTrack = _pcStream$getVideoTra[0];
          if (videoTrack) {
            videoTrack.stop();
            pcStream.removeTrack(videoTrack);
          }
        }
        const peerConnection = new PublisherPeerConnection({
          iceConfig,
          sendMessage: send,
          webRTCStream: pcStream,
          channels: properties.channels,
          capableSimulcastStreams,
          overrideSimulcastEnabled: options._enableSimulcast,
          logAnalyticsEvent: log,
          offerOverrides: {
            enableDtx: properties.enableDtx,
            enableStereo: properties.enableStereo,
            audioBitrate: properties.audioBitrate,
            priorityVideoCodec: properties._priorityVideoCodec || this.session.sessionInfo.priorityVideoCodec,
            codecFlags: properties._codecFlags || this.session._.getCodecFlags()
          },
          // FIXME - Remove answerOverrides once maxaveragebitrate is supported by Mantis
          answerOverrides: (_this$session4 = this.session) != null && (_this$session4$sessio = _this$session4.sessionInfo) != null && _this$session4$sessio.p2pEnabled ? undefined : {
            audioBitrate: properties.audioBitrate
          },
          sourceStreamId,
          isP2pEnabled: (_this$session5 = this.session) == null ? void 0 : (_this$session5$sessio = _this$session5.sessionInfo) == null ? void 0 : _this$session5$sessio.p2pEnabled,
          sessionId: this.session.id,
          keyStore: this.session.keyStore,
          sFrameClientStore: this.session.sFrameClientStore,
          isE2ee: this.session._.isE2ee(),
          audioFallbackEnabled: properties.publisherAudioFallbackEnabled,
          resolution: {
            width: this.videoWidth(),
            height: this.videoHeight()
          }
        });
        peerConnection.on({
          disconnected: () => onPeerDisconnected(peerConnection),
          error: _ref14 => {
            let reason = _ref14.reason,
              prefix = _ref14.prefix;
            return onPeerConnectionFailure(peerConnection, {
              reason,
              prefix
            });
          },
          qos: logQoS,
          iceRestartSuccess: () => onIceRestartSuccess(peerConnection),
          iceRestartFailure: () => onIceRestartFailure(peerConnection),
          iceConnectionStateChange: newState => onIceConnectionStateChange(newState, peerConnection),
          audioAcquisitionProblem: () => {
            // will be only triggered in Chrome
            audioAcquisitionProblemDetected = true;
            this.trigger('audioAcquisitionProblem', {
              method: 'getStats'
            });
          },
          audioFallbackStateChange: payload => audioFallbackCoordinator.onPeerConnectionStateChange(Object.assign({}, payload, {
            peerConnection,
            publishVideo: properties.publishVideo,
            stream: this.stream,
            peerId: getPeerConnectionMeta(peerConnection).peerId
          }))
        });
        peerConnection.once('connected', () => onPeerConnected(peerConnection));
        return new Promise((resolve, reject) => {
          const rejectOnError = err => {
            reject(err);
          };
          peerConnection.once('error', rejectOnError);
          peerConnection.init(rumorIceServers, err => {
            if (err) {
              return reject(err);
            }
            peerConnection.off('error', rejectOnError);
            resolve(peerConnection);
            return undefined;
          });
        });
      });
      return getPeerConnectionById(peerConnectionId);
    };
    const getAllPeerConnections = () => Promise.all(Object.keys(peerConnectionsAsync).map(getPeerConnectionById));
    const getPeerConnectionsBySubscriber = subscriberId => getAllPeerConnections().then(peerConnections => peerConnections.filter(peerConnection => getPeerConnectionMeta(peerConnection).remoteSubscriberId === subscriberId));
    const getPeerConnectionById = id => peerConnectionsAsync[id];
    const getPeerConnectionBySourceStreamId = sourceStreamId => {
      // Find the peerConnectionId which includes the sourceStreamId that we're looking for.
      const peerConnectionId = Object.keys(peerConnectionsAsync).find(key => key.endsWith(`~${sourceStreamId}`));
      return peerConnectionsAsync[peerConnectionId];
    };
    const getMantisPeerConnection = () => getPeerConnectionBySourceStreamId('MANTIS');
    const getP2pPeerConnection = () => getPeerConnectionBySourceStreamId('P2P');
    let chromeMixin = createChromeMixin(this, {
      name: properties.name,
      publishAudio: properties.publishAudio,
      publishVideo: properties.publishVideo,
      audioSource: properties.audioSource,
      showControls: properties.showControls,
      shouldAllowAudio,
      logAnalyticsEvent
    });
    const reset = () => {
      this.off('publishComplete', refreshAudioVideoUI);
      if (chromeMixin) {
        chromeMixin.reset();
      }
      streamCleanupJobs.releaseAll();
      this.disconnect();
      microphone = null;
      cleanupLocalStream();
      webRTCStream = null;
      if (widgetView) {
        widgetView.destroy();
        widgetView = null;
      }
      if (this.session) {
        this._.unpublishFromSession(this.session, 'reset');
      }
      if (mediaProcessor.getVideoFilter()) {
        destroyMediaProcessor();
      }
      amrAudioTrackProcessor.destroy();
      this.id = null;
      this.stream = null;
      loaded = false;
      this.session = null;
      this.streamId = null;
      if (!state.isDestroyed()) {
        state.set('NotPublishing');
      }
    };
    const hasVideo = () => {
      if (!webRTCStream || webRTCStream.getVideoTracks().length === 0) {
        return false;
      }
      // On Chrome when screensharing/custom video is static, it is swapping between 'mute' and
      // 'unmute' states periodically for no reason OPENTOK-37818
      // https://bugs.chromium.org/p/chromium/issues/detail?id=931033
      // We will ignore track.muted when screensharing and custom when videoContentHint
      // suggests video could be static, i.e. text or detail
      const staticContentHints = ['text', 'detail'];
      const isStaticContent = staticContentHints.includes(properties.videoContentHint);
      const isStaticCustom = isCustomVideoTrack && isStaticContent;
      const shouldIgnoreTrackMuteState = OTHelpers.env.isChromium && (isScreenSharing || isStaticCustom);
      return webRTCStream.getVideoTracks().reduce((isEnabled, track) => isEnabled && (!track.muted || !!shouldIgnoreTrackMuteState) && track.enabled && track.readyState !== 'ended', properties.publishVideo);
    };
    const hasAudio = () => {
      if (!webRTCStream || webRTCStream.getAudioTracks().length === 0) {
        return false;
      }
      return webRTCStream.getAudioTracks().length > 0 && webRTCStream.getAudioTracks().reduce((isEnabled, track) => isEnabled && !track.muted && track.enabled && track.readyState !== 'ended', properties.publishAudio);
    };
    const refreshAudioVideoUI = activeReason => {
      if (widgetView) {
        widgetView.audioOnly(!hasVideo());
        widgetView.showPoster(!hasVideo());
      }
      if (chromeMixin) {
        chromeMixin.setAudioOnly(!hasVideo() && hasAudio());
      }
      if (this.stream) {
        let congestionLevel;
        if (pendingRumorAudioFallbackMessage && hasVideo()) {
          congestionLevel = _congestionLevels.CongestionLevels.LOW;
          pendingRumorAudioFallbackMessage = false;
        }
        this.stream.setChannelActiveState({
          channelType: 'audio',
          activeState: hasAudio(),
          activeReason
        });
        this.stream.setChannelActiveState({
          channelType: 'video',
          activeState: hasVideo(),
          activeReason,
          congestionLevel
        });
      } else {
        // Make sure we add a listener for refreshAudioVideoUI only one time.
        this.off('publishComplete', refreshAudioVideoUI);
        this.once('publishComplete', refreshAudioVideoUI);
      }
    };
    const _getStatsWrapper = (reportType, callback) => {
      let isRtcStatsReport = false;
      if (typeof reportType === 'function') {
        /* eslint-disable-next-line no-param-reassign */
        callback = reportType;
      } else {
        isRtcStatsReport = reportType === 'rtcStatsReport';
      }
      if (isRtcStatsReport) {
        notifyGetRtcStatsCalled();
      } else {
        notifyGetStatsCalled();
      }
      if (isRtcStatsReport && !_isGetRtcStatsReportSupported.default) {
        const errorCode = ExceptionCodes.GET_RTC_STATS_REPORT_NOT_SUPPORTED;
        callback(otError(Errors.GET_RTC_STATS_REPORT_NOT_SUPPORTED, new Error(OTErrorClass.getTitleByCode(errorCode)), errorCode));
        return;
      }
      getAllPeerConnections().then(peerConnections => {
        if (peerConnections.length === 0) {
          const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
          throw otError(Errors.PEER_CONNECTION_NOT_CONNECTED, new Error(OTErrorClass.getTitleByCode(errorCode)), errorCode);
        }
        return peerConnections;
      }).then(peerConnections => {
        const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
        if (!isAdaptiveEnabled) {
          return peerConnections;
        }

        // When the session is adaptive, we only return stats for the active peer connection.
        return peerConnections.filter(pc => pc.getSourceStreamId() === activeSourceStreamId);
      }).then(peerConnections => Promise.all(peerConnections.map(peerConnection => (isRtcStatsReport ? (0, _promisify.default)(peerConnection.getRtcStatsReport.bind(peerConnection)) : (0, _promisify.default)(peerConnection.getStats.bind(peerConnection)))().then(stats => ({
        pc: peerConnection,
        stats
      }))))).then(pcsAndStats => {
        // @todo this publishStartTime is going to be so wrong in P2P
        const startTimestamp = publishStartTime ? publishStartTime.getTime() : Date.now();
        const results = pcsAndStats.map(_ref15 => {
          let pc = _ref15.pc,
            stats = _ref15.stats;
          const _getPeerConnectionMet6 = getPeerConnectionMeta(pc),
            remoteConnectionId = _getPeerConnectionMet6.remoteConnectionId,
            remoteSubscriberId = _getPeerConnectionMet6.remoteSubscriberId;
          return (0, _assign.default)(remoteConnectionId.match(/^symphony\./) ? {} : {
            subscriberId: remoteSubscriberId,
            connectionId: remoteConnectionId
          }, isRtcStatsReport ? {
            rtcStatsReport: stats
          } : {
            stats: _get_stats_helpers.default.normalizeStats(stats, false, startTimestamp)
          });
        });
        callback(null, results);
      }).catch(callback);
    };
    const _getStats = callback => _getStatsWrapper(callback);
    const _getRtcStatsReport = callback => _getStatsWrapper('rtcStatsReport', callback);
    const _createStream = (sourceStreamId, completionHandler) => {
      const streamOptions = {
        name: properties.name || '',
        streamId: this.streamId,
        subscriberAudioFallbackEnabled: properties.subscriberAudioFallbackEnabled,
        channels: streamChannels,
        minBitrate: properties.minVideoBitrate,
        sourceStreamId,
        e2ee: this.session._.isE2ee(),
        publisherAudioFallbackEnabled: properties.publisherAudioFallbackEnabled,
        customProperties: {
          initials: properties.initials
        }
      };
      this.session._.streamCreate(streamOptions, completionHandler);
    };
    const _stopSendingRtpToMantis = /*#__PURE__*/function () {
      var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var peerConnection;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _restartSendingRtpToMantisCalled = false;
              _context6.next = 3;
              return getMantisPeerConnection();
            case 3:
              peerConnection = _context6.sent;
              if (!peerConnection) {
                _context6.next = 18;
                break;
              }
              _this.trigger('sourceStreamIdChanged', 'P2P');
              if (properties.publisherAudioFallbackEnabled) {
                // Stop calculating congestion level since we will stop sending media on this peer connection
                peerConnection.disableCongestionLevelEstimation();
              }

              // We add this delay before stopping media to prevent MANTIS to consider this stream
              // as inactive after a reconnection and then destroy it.
              _context6.next = 9;
              return (0, _promiseDelay.default)(KEEP_SENDING_MEDIA_AFTER_TRANSITIONED);
            case 9:
              if (!_restartSendingRtpToMantisCalled) {
                _context6.next = 12;
                break;
              }
              logging.debug('Cancelling stop sending RTP to MANTIS.');
              return _context6.abrupt("return");
            case 12:
              // Audio is muted and video is set to inactive
              amrAudioTrackProcessor.muteAudioInPeerConnection(webRTCStream, peerConnection);
              _context6.next = 15;
              return peerConnection.changeMediaDirectionToInactive();
            case 15:
              if (!(OTHelpers.env.isFirefox && OTHelpers.env.version < 96)) {
                _context6.next = 18;
                break;
              }
              _context6.next = 18;
              return _keepSendingRtcpToMantis();
            case 18:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function _stopSendingRtpToMantis() {
        return _ref16.apply(this, arguments);
      };
    }();
    const _restartSendingRtpToMantis = /*#__PURE__*/function () {
      var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var peerConnection, _yield$getP2pPeerConn2;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _restartSendingRtpToMantisCalled = true;
              _context7.next = 3;
              return getMantisPeerConnection();
            case 3:
              peerConnection = _context7.sent;
              if (!peerConnection) {
                _context7.next = 22;
                break;
              }
              // Audio is unmuted and video is set to recvonly
              amrAudioTrackProcessor.unmuteAudioInPeerConnection(webRTCStream, peerConnection);
              _context7.next = 8;
              return peerConnection.changeMediaDirectionToRecvOnly();
            case 8:
              if (_keepSendingRtcpToMantisTimeout) {
                clearTimeout(_keepSendingRtcpToMantisTimeout);
              }
              _this.trigger('sourceStreamIdChanged', 'MANTIS');
              if (!properties.publisherAudioFallbackEnabled) {
                _context7.next = 22;
                break;
              }
              _context7.t0 = peerConnection;
              _context7.next = 14;
              return getP2pPeerConnection();
            case 14:
              _context7.t1 = _yield$getP2pPeerConn2 = _context7.sent;
              if (!(_context7.t1 == null)) {
                _context7.next = 19;
                break;
              }
              _context7.t2 = void 0;
              _context7.next = 20;
              break;
            case 19:
              _context7.t2 = _yield$getP2pPeerConn2.getAudioFallbackState();
            case 20:
              _context7.t3 = _context7.t2;
              _context7.t0.enableCongestionLevelEstimation.call(_context7.t0, _context7.t3);
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function _restartSendingRtpToMantis() {
        return _ref17.apply(this, arguments);
      };
    }();
    const _keepSendingRtcpToMantis = /*#__PURE__*/function () {
      var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        var peerConnection;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return getMantisPeerConnection();
            case 2:
              peerConnection = _context9.sent;
              if (peerConnection) {
                _keepSendingRtcpToMantisTimeout = setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
                  return _regenerator.default.wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!(activeSourceStreamId === 'P2P')) {
                          _context8.next = 9;
                          break;
                        }
                        _context8.next = 3;
                        return peerConnection.changeMediaDirectionToRecvOnly();
                      case 3:
                        _context8.next = 5;
                        return (0, _promiseDelay.default)(KEEP_SENDING_MEDIA_TO_KEEP_ALIVE);
                      case 5:
                        _context8.next = 7;
                        return peerConnection.changeMediaDirectionToInactive();
                      case 7:
                        _context8.next = 9;
                        return _keepSendingRtcpToMantis();
                      case 9:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                })), KEEP_SENDING_RTCP_DELAY);
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function _keepSendingRtcpToMantis() {
        return _ref18.apply(this, arguments);
      };
    }();
    const _transitionRoutedToRelayed = () => {
      logRoutedToRelayedTransition('Attempt');
      const processMessagingError = error => {
        const publicError = (0, _createStreamErrorMap.default)(error);
        this.trigger('streamCreateForP2PComplete', publicError);
        logRoutedToRelayedTransition('Failure', {
          reason: publicError.message
        });
      };
      if (!this.session) {
        logRoutedToRelayedTransition('Failure', {
          reason: 'Not connected to the session.'
        });
        return;
      }
      const streamCreateForP2PCompleteTimeout = setTimeout(() => {
        logRoutedToRelayedTransition('Failure', {
          reason: 'Timeout'
        });
      }, PUBLISH_MAX_DELAY);
      this.once('streamCreateForP2PComplete', () => {
        clearTimeout(streamCreateForP2PCompleteTimeout);
      });
      logging.debug('streamCreateWithSource: send a message to RUMOR for ' + `creating the stream with the sourceStreaId P2P and stream ${this.streamId}`);
      _createStream('P2P', messagingError => {
        if (messagingError) {
          processMessagingError(messagingError);
        } else {
          this.trigger('streamCreateForP2PComplete');
        }
      });
    };
    const _transitionRelayedToRouted = /*#__PURE__*/function () {
      var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(activeSourceStreamId !== 'P2P')) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return");
            case 2:
              logRelayedToRoutedTransition('Attempt');
              if (_this.session) {
                _context10.next = 6;
                break;
              }
              logRelayedToRoutedTransition('Failure', {
                reason: 'Not connected to the session.'
              });
              return _context10.abrupt("return");
            case 6:
              if (_this.streamId) {
                _context10.next = 9;
                break;
              }
              logRelayedToRoutedTransition('Failure', {
                reason: 'No streamId available'
              });
              return _context10.abrupt("return");
            case 9:
              _context10.next = 11;
              return _restartSendingRtpToMantis();
            case 11:
              _this.session._.streamDestroy(_this.streamId, 'P2P');
              _context10.t0 = _this;
              _context10.next = 15;
              return getP2pPeerConnection();
            case 15:
              _context10.t1 = _context10.sent;
              _context10.t0._removePeerConnection.call(_context10.t0, _context10.t1);
              logRelayedToRoutedTransition('Success');
              _this.trigger('streamDestroyForP2PComplete');
            case 19:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      return function _transitionRelayedToRouted() {
        return _ref20.apply(this, arguments);
      };
    }();

    // When migrating, a P2P transition is performed as a renegotiation, since we already have a PC
    // we don't need to create a new one, just generate a new offer for the PC.
    const isRoutedToRelayedTransitionDuringMigration = (type, sourceStreamId) => this.session.sessionInfo.isAdaptiveEnabled && sourceStreamId === 'P2P' && type === 'generateoffer' && state.isMigrating();
    const createSendMessage = sourceStreamId => {
      const send = createSendMethod({
        socket: this.session._.getSocket(),
        uri: _raptorUri,
        content: {
          peerId: _peerId,
          sourceStreamId
        }
      });
      return (type, content) => {
        if (type === 'offer') {
          this.trigger('connected');
        }
        send({
          type,
          content
        });
      };
    };
    const startMigrationTimeout = () => {
      _migrationTimeoutId = setTimeout(() => {
        logAnalyticsEvent('Migrate', 'Failed');
        this.destroy();
      }, this.session.MIGRATION_TIMEOUT);
    };
    this.publish = targetElement => {
      logging.debug('OT.Publisher: publish');
      if (state.isAttemptingToPublish() || state.isPublishing()) {
        reset();
      }
      state.set('GetUserMedia');
      if (properties.style) {
        this.setStyle(properties.style, null, true);
      }
      properties.classNames = 'OT_root OT_publisher';

      // Defer actually creating the publisher DOM nodes until we know
      // the DOM is actually loaded.
      EnvironmentLoader.onLoad(() => {
        logging.debug('OT.Publisher: publish: environment loaded');
        // @note If ever replacing the widgetView with a new one elsewhere, you'll need to be
        // mindful that audioLevelBehaviour has a reference to this one, and it will need to be
        // updated accordingly.
        // widgetView = new WidgetView(targetElement, properties);
        widgetView = new WidgetView(targetElement, Object.assign({}, properties, {
          widgetType: 'publisher'
        }));
        if (shouldAllowAudio) {
          (0, _audioLevelBehaviour.default)({
            publisher: this,
            widgetView
          });
        }
        widgetView.on('error', onVideoError);
        this.id = widgetView.domId();
        this.element = widgetView.domElement;
        if (this.element && chromeMixin) {
          // Only create the chrome if we have an element to insert it into
          // for insertDefautlUI:false we don't create the chrome
          chromeMixin.init(widgetView);
        }
        widgetView.on('videoDimensionsChanged', (oldValue, newValue) => {
          // Ignore this event since there is no video.
          if (!properties.publishVideo) {
            return;
          }
          if (this.stream) {
            this.stream.setVideoDimensions(newValue.width, newValue.height);
          }
          this.dispatchEvent(new Events.VideoDimensionsChangedEvent(this, oldValue, newValue));
        });
        widgetView.on('mediaStopped', track => {
          const event = new Events.MediaStoppedEvent(this, track);

          // When we have a disabled and transformed media track, we don't dispatch the event since
          // it is not a media source stop. This is the case when we call publishVideo(false) or
          // cycleVideo(), where the transformed track is stopped.
          const isDisabledTransformedTrack = (track == null ? void 0 : track.readyState) === 'ended' &&
          // Only transformed tracks have the writable property.
          // See: https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamTrackGenerator/writable
          !!(track != null && track.writable);
          if (!isDisabledTransformedTrack) {
            this.dispatchEvent(event);
          }
          if (event.isDefaultPrevented()) {
            return;
          }
          if (track) {
            const kind = String(track.kind).toLowerCase();
            // If we are publishing this kind when the track stops then
            // make sure we start publishing again if we switch to a new track
            if (kind === 'audio') {
              updateAudio();
            } else if (kind === 'video') {
              updateVideo();
            } else {
              logging.warn(`Track with invalid kind has ended: ${track.kind}`);
            }
            logAnalyticsEvent('mediaStopped', 'Event', {
              kind
            });
            return;
          }
          if (this.session) {
            this._.unpublishFromSession(this.session, 'mediaStopped');
          } else {
            this.destroy('mediaStopped');
          }
        });
        widgetView.on('videoElementCreated', element => {
          this.dispatchEvent(new Events.MediaStreamAvailableEvent(webRTCStream));
          const event = new Events.VideoElementCreatedEvent(element);
          this.dispatchEvent(event);
        });
        getUserMedia().catch(userMediaError).then( /*#__PURE__*/function () {
          var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(stream) {
            var _audioDevices, _videoDevices;
            var hasVideoFilter, hasAudioVideoDevices;
            return _regenerator.default.wrap(function _callee11$(_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  // this comes from deviceHelpers.shouldAskForDevices in a round-about way
                  audioDevices = processedOptions.audioDevices;
                  videoDevices = processedOptions.videoDevices;
                  hasVideoFilter = !!properties.videoFilter;
                  if (!properties.disableAudioInputDeviceManagement) {
                    // this is needed to refresh current audio input device after previous one was disconnected
                    removeDeviceChangeListener = addAudioInputDevicesChangeListener(_this);
                  }
                  hasAudioVideoDevices = ((_audioDevices = audioDevices) == null ? void 0 : _audioDevices.length) > 0 || ((_videoDevices = videoDevices) == null ? void 0 : _videoDevices.length) > 0;
                  _context11.next = 7;
                  return (0, _permissionListener.default)(hasAudioVideoDevices).then(listener => {
                    listener.on('accessDenied', device => {
                      _this.accessAllowed = false;
                      _this.dispatchEvent((0, _accessDeniedEvent.default)(device, 'during the call'));
                    });
                  });
                case 7:
                  if (hasVideoFilter) {
                    // We need to get the device now, before the filter is applied
                    // else the wrong device will be returned/nonsensical
                    currentDeviceId = (0, _getDeviceIdFromStream.default)(stream, videoDevices);
                  }
                  _context11.next = 10;
                  return onStreamAvailable(stream);
                case 10:
                  if (!properties.publishVideo) {
                    _this._toggleVideo(properties.publishVideo, getVideoDimensions());
                  }
                  if (!isScreenSharing && !isCustomVideoTrack
                  // For filtered video, we stored the currentDeviceId already.
                  // (see note above)
                  && !hasVideoFilter) {
                    currentDeviceId = (0, _getDeviceIdFromStream.default)(stream, videoDevices);
                    if (properties.publishVideo) {
                      setCurrentTrackDeviceId(currentDeviceId);
                    }
                  }
                  return _context11.abrupt("return", bindVideo().catch(error => {
                    if (error instanceof _cancel.CancellationError) {
                      // If we get a CancellationError, it means something newer tried
                      // to bindVideo before the old one succeeded, perhaps they called
                      // switchTracks.. It should be rare, and they shouldn't be doing
                      // this before loaded, but we'll handle it anyway.
                      return undefined;
                    }
                    throw error;
                  }).then(() => {
                    onLoaded();
                    if (!state.isDestroyed()) {
                      _this.trigger('initSuccess');
                      _this.trigger('loaded', _this);
                    }
                  }, err => {
                    logging.error(`OT.Publisher.publish failed to bind video: ${err}`);
                    onLoadFailure(err);
                  }));
                case 13:
                case "end":
                  return _context11.stop();
              }
            }, _callee11);
          }));
          return function (_x6) {
            return _ref21.apply(this, arguments);
          };
        }());
      });
      return this;
    };
    this._getVideoSenders = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", getAllPeerConnections().then(peerConnections => peerConnections[0].getSenders().filter(_ref23 => {
              let kind = _ref23.track.kind;
              return kind === 'video';
            })));
          case 1:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    this._setScalableValues = /*#__PURE__*/function () {
      var _ref24 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(scalableParam, scalableValues) {
        var senders, sender, sendParameters;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _this._getVideoSenders();
            case 2:
              senders = _context13.sent;
              sender = senders[0];
              sendParameters = sender.getParameters();
              sendParameters.encodings.forEach((encoding, index) => {
                encoding[scalableParam] = scalableValues[index]; // eslint-disable-line no-param-reassign
              });
              _context13.next = 8;
              return sender.setParameters(sendParameters);
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x7, _x8) {
        return _ref24.apply(this, arguments);
      };
    }();
    this._setScalabilityMode = /*#__PURE__*/function () {
      var _ref25 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(scalabilityMode, codecsWhitelist) {
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", setScalabilityMode(_this, scalabilityMode, codecsWhitelist));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function (_x9, _x10) {
        return _ref25.apply(this, arguments);
      };
    }();
    this._getNumEncodings = () => (0, _getNumEncodings.default)(this);
    this._setScalableFramerates = /*#__PURE__*/function () {
      var _ref26 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(frameRates) {
        var framerateValues;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              framerateValues = normalizeScalableValues(frameRates);
              if (!(framerateValues && areValidFramerates(framerateValues))) {
                _context15.next = 4;
                break;
              }
              _context15.next = 4;
              return _this._setScalableValues('maxFramerate', framerateValues);
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x11) {
        return _ref26.apply(this, arguments);
      };
    }();
    this._setScalableVideoLayers = /*#__PURE__*/function () {
      var _ref27 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(videoLayers) {
        var videoLayerValues;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              videoLayerValues = normalizeScalableValues(videoLayers);
              if (!(videoLayerValues && areValidResolutionScales(videoLayerValues))) {
                _context16.next = 4;
                break;
              }
              _context16.next = 4;
              return _this._setScalableValues('scaleResolutionDownBy', videoLayerValues);
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      return function (_x12) {
        return _ref27.apply(this, arguments);
      };
    }();
    const areValidFramerates = framerates => {
      let previousFps = 0;
      // Only 15 and 30 fps are valid values and it cannot decrease when upscaling resolutions
      return framerates.every(fps => {
        if (fps !== 15 && fps !== 30 || fps < previousFps) {
          return false;
        }
        previousFps = fps;
        return true;
      });
    };
    const areValidResolutionScales = scales => {
      // Maximum to downscale is 16 so previous scale should not be equal or greater to 17
      let previousScale = 17;
      return scales.every(scale => {
        // Only downscale values; i.e. <= 1 means to upscale, which is not valid
        if (scale < 1 || scale >= previousScale) {
          return false;
        }
        previousScale = scale;
        return true;
      });
    };
    const normalizeScalableValues = scalableValues => {
      let normalizedValues;
      // API only accepts a colon separated value string
      if (typeof scalableValues !== 'string') {
        return normalizedValues;
      }
      const scalableValuesArr = scalableValues.split(':');
      // It cannot be empty nor larger than 3 values (HD, VGA and QVGA)
      if (scalableValuesArr.length === 0 || scalableValuesArr.length > 3) {
        return normalizedValues;
      }
      if (!scalableValuesArr.every(value => !isNaN(value))) {
        return normalizedValues;
      }
      normalizedValues = scalableValuesArr.map(value => parseInt(value, 10)).reverse();
      return normalizedValues;
    };
    const haveWorkingTracks = type => webRTCStream && webRTCStream[`get${(0, _capitalize.default)(type)}Tracks`]().length > 0 && webRTCStream[`get${(0, _capitalize.default)(type)}Tracks`]().every(track => track.readyState !== 'ended');
    const updateAudio = activeReason => {
      const shouldSendAudio = haveWorkingTracks('audio') && properties.publishAudio;
      if (chromeMixin) {
        chromeMixin.setMuted(!shouldSendAudio);
      }
      if (microphone) {
        microphone.muted(!shouldSendAudio);
      }
      if (_audioMediaProcessorConnector && _audioMediaProcessorConnector.originalTrack) {
        _audioMediaProcessorConnector.originalTrack.enabled = shouldSendAudio;
      }
      refreshAudioVideoUI(activeReason);
    };

    /**
    * Starts publishing audio (if it is currently not being published)
    * when the <code>value</code> is <code>true</code>; stops publishing audio
    * (if it is currently being published) when the <code>value</code> is <code>false</code>.
    *
    * @param {Boolean} value Whether to start publishing audio (<code>true</code>)
    * or not (<code>false</code>).
    *
    * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * @see <a href="Stream.html#hasAudio">Stream.hasAudio</a>
    * @see StreamPropertyChangedEvent
    * @method #publishAudio
    * @memberOf Publisher
    */
    this.publishAudio = value => {
      logAnalyticsEvent('publishAudio', 'Attempt', {
        publishAudio: value
      });
      properties.publishAudio = value;
      try {
        updateAudio();
        logAnalyticsEvent('publishAudio', 'Success', {
          publishAudio: value
        });
      } catch (e) {
        logAnalyticsEvent('publishAudio', 'Failure', {
          message: e.message
        });
      }
      return this;
    };

    /**
    * Starts publishing captions (if it is currently not being published)
    * when the <code>value</code> is <code>true</code>; stops publishing captions
    * (if it is currently being published) when the <code>value</code> is <code>false</code>.
    *
    * <p>
    * <i>Note:</i> No captions will be published if the publisher does not have an audio source.
    *
    * <p>
    * For more information, see the
    * <a href="https://tokbox.com/developer/guides/live-captions/">Live Captions</a>
    * developer guide.
    *
    * @param {Boolean} value Whether to start publishing captions (<code>true</code>)
    * or not (<code>false</code>).
    *
    * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * @see <a href="Subscriber.html#subscribeToCaptions">subscribeToCaptions()</a>
    * @see <a href="Subscriber.html#isSubscribedToCaptions">isSubscribedToCaptions()</a>
    * @method #publishCaptions
    * @memberOf Publisher
    */

    this.publishCaptions = value => {
      logAnalyticsEvent('publishCaptions', 'Attempt', {
        publishCaptions: value
      });
      try {
        privateEvents.dispatchEvent(new Events.PublisherCaptionsEnabled(value));
        this.stream.setChannelActiveState({
          channelType: 'data',
          activeState: value
        });
        logAnalyticsEvent('publishCaptions', 'Success', {
          publishCaptions: value
        });
      } catch (e) {
        logAnalyticsEvent('publishCaptions', 'Failure', {
          message: e.message,
          publishCaptions: value
        });
      }
    };
    let updateVideoSenderParametersSentinel;

    // keeps track of if the client has called mediaStreamTrack.stop(), so that we don't restart
    // the camera if they then call publishVideo(true)
    let isTrackManuallyStopped = false;
    const updateVideo = () => {
      const shouldSendVideo = haveWorkingTracks('video') && properties.publishVideo;
      if (_env.default.name === 'Chrome' && _env.default.version >= 69) {
        (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17() {
          var executionSentinel, peerConnections;
          return _regenerator.default.wrap(function _callee17$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                if (updateVideoSenderParametersSentinel) {
                  updateVideoSenderParametersSentinel.cancel();
                }
                updateVideoSenderParametersSentinel = new _cancel.default();
                executionSentinel = updateVideoSenderParametersSentinel;
                _context17.next = 5;
                return getAllPeerConnections();
              case 5:
                peerConnections = _context17.sent;
                if (!executionSentinel.isCanceled()) {
                  // only proceed if we weren't canceled during the async operation above
                  peerConnections.forEach(peerConnection => {
                    peerConnection.setVideoActiveState(shouldSendVideo);
                  });
                }
              case 7:
              case "end":
                return _context17.stop();
            }
          }, _callee17);
        }))();
      }
      if (isCustomVideoTrack && mediaProcessor) {
        const originalTrack = mediaProcessor.getOriginalVideoTrack();
        if (originalTrack) {
          originalTrack.enabled = shouldSendVideo;
        }
      }
      if (isCustomVideoTrack && _videoMediaProcessorConnector) {
        const originalTrack = _videoMediaProcessorConnector.originalTrack;
        if (originalTrack) {
          originalTrack.enabled = shouldSendVideo;
        }
      }
      if (webRTCStream) {
        webRTCStream.getVideoTracks().forEach(track => {
          track.enabled = shouldSendVideo; // eslint-disable-line no-param-reassign
          if (track.isCreatedCanvas) {
            // eslint-disable-next-line no-param-reassign
            track.enabled = false;
          }
        });
      }
      refreshAudioVideoUI();
    };
    const destroyMediaProcessor = /*#__PURE__*/function () {
      var _ref29 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18() {
        var videoTrack;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              // We need to cache this since calling the method below will
              // clear this value.
              videoTrack = mediaProcessor.getOriginalVideoTrack(); // Note: this needs to be called before the `stop` method below.  Reversing
              // the order may cause race conditions with the MP worker.
              _context18.prev = 1;
              _context18.next = 4;
              return mediaProcessor.destroy();
            case 4:
              _context18.next = 9;
              break;
            case 6:
              _context18.prev = 6;
              _context18.t0 = _context18["catch"](1);
              logging.warn(`Error cleaning up mediaProcessor: ${_context18.t0}`);
            case 9:
              // Since no filtering is being applied, we perform some cleanup.  We
              // stop the original video track here since it's not being used
              // anymore -- this also turns off the camera LED
              videoTrack.stop();
            case 10:
            case "end":
              return _context18.stop();
          }
        }, _callee18, null, [[1, 6]]);
      }));
      return function destroyMediaProcessor() {
        return _ref29.apply(this, arguments);
      };
    }();
    const hasTrackFromDevice = deviceId =>
    // Track has been already updated by another call. This means cycleVideo, setVideoSource
    // or clearVideoFilter has already got the track from the currentDeviceId, thus we don't
    // need to duplicate the track from the same device.
    // This does not apply when a videoFilter or mediaProcessorConnector is set, since we could need to get a track from
    // the same device.
    !currentVideoFilter && !_videoMediaProcessorConnector && deviceId === getCurrentTrackDeviceId();
    const isNewTrackNeeded = (shouldHaveVideo, deviceId) => {
      if (currentVideoFilter || _videoMediaProcessorConnector) {
        // When videoFilter or mediaProcessorConnector is applied, we will get a new track always.
        return true;
      }
      if (shouldHaveVideo) {
        // When video enabled, we only get the track from a new device.
        return currentDeviceId !== deviceId;
      }

      // When video disabled, we only get the canvasTrack if video was not muted previously,
      // i.e. when deviceId is not undefined.
      return deviceId !== undefined;
    };
    let currentDeviceId;
    let currentVideoFilter;
    let currentAudioFilter;
    this._toggleVideo = (0, _blockCallsUntilComplete.default)( /*#__PURE__*/function () {
      var _ref30 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(shouldHaveVideo, videoDimensions) {
        var _vidDevices$find;
        var vidDevices, oldTrack, oldTrackDeviceId, newTrack, videoFilter, originalVideoTrack, _originalVideoTrack;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(isScreenSharing || isCustomVideoTrack || isTrackManuallyStopped)) {
                _context19.next = 2;
                break;
              }
              return _context19.abrupt("return");
            case 2:
              _context19.next = 4;
              return getVideoDevices();
            case 4:
              vidDevices = _context19.sent;
              oldTrack = getCurrentTrack();
              if (oldTrack) {
                _context19.next = 8;
                break;
              }
              throw otError(Errors.NOT_SUPPORTED, new Error('Publisher._toggleVideo cannot toggleVideo when you have no video source.'));
            case 8:
              // oldTrackDeviceId is undefined when it comes from a canvasTracks, i.e.: it is currently muted
              oldTrackDeviceId = (_vidDevices$find = vidDevices.find(device => device.label === oldTrack.label)) == null ? void 0 : _vidDevices$find.deviceId;
              if (isNewTrackNeeded(shouldHaveVideo, oldTrackDeviceId)) {
                _context19.next = 11;
                break;
              }
              return _context19.abrupt("return");
            case 11:
              if (!(oldTrack.readyState === 'ended')) {
                _context19.next = 14;
                break;
              }
              isTrackManuallyStopped = true;
              return _context19.abrupt("return");
            case 14:
              if (shouldHaveVideo && OTHelpers.env.isAndroid && OTHelpers.env.isChrome) {
                // On Chrome on Android you need to stop the previous video track OPENTOK-37206
                if (oldTrack && oldTrack.stop) {
                  oldTrack.stop();
                }
              }
              if (shouldHaveVideo) {
                _context19.next = 31;
                break;
              }
              _context19.prev = 16;
              newTrack = (0, _createCanvasVideoTrack.default)(videoDimensions);
              _context19.next = 23;
              break;
            case 20:
              _context19.prev = 20;
              _context19.t0 = _context19["catch"](16);
              return _context19.abrupt("return");
            case 23:
              if (oldTrackDeviceId) {
                // store the current deviceId to reacquire the video later
                currentDeviceId = oldTrackDeviceId;
              }
              setCurrentTrackDeviceId(newTrack.label);
              videoFilter = mediaProcessor.getVideoFilter();
              if (!videoFilter) {
                _context19.next = 30;
                break;
              }
              // Save the current video filter because we want to make sure it
              // gets enabled when the user publishes video again
              currentVideoFilter = videoFilter;
              _context19.next = 30;
              return destroyMediaProcessor();
            case 30:
              if (_videoMediaProcessorConnector) {
                _videoMediaProcessorConnector.destroy();
                _videoMediaProcessorConnector.stopOriginalTrack();
              }
            case 31:
              if (!(currentDeviceId && vidDevices.findIndex(device => device.deviceId === currentDeviceId) === -1)) {
                _context19.next = 33;
                break;
              }
              throw otError(Errors.NO_DEVICES_FOUND, new Error('Previous device no longer available - deviceId not found'));
            case 33:
              privateEvents.emit('streamDestroy');
              if (!shouldHaveVideo) {
                _context19.next = 64;
                break;
              }
              if (!hasTrackFromDevice(currentDeviceId)) {
                _context19.next = 37;
                break;
              }
              return _context19.abrupt("return");
            case 37:
              _context19.prev = 37;
              _context19.next = 40;
              return getTrackFromDeviceId(currentDeviceId);
            case 40:
              newTrack = _context19.sent;
              _context19.next = 47;
              break;
            case 43:
              _context19.prev = 43;
              _context19.t1 = _context19["catch"](37);
              logging.error(`Error getting new track for current device(${currentDeviceId}): ${_context19.t1}`);
              throw _context19.t1;
            case 47:
              if (newTrack) {
                _context19.next = 50;
                break;
              }
              logging.error('Failed to enable video. It was not possible to get a new track from the camera');
              return _context19.abrupt("return");
            case 50:
              if (!currentVideoFilter) {
                _context19.next = 59;
                break;
              }
              originalVideoTrack = mediaProcessor.getOriginalVideoTrack();
              _context19.next = 54;
              return mediaProcessor.setVideoFilter(currentVideoFilter);
            case 54:
              _context19.next = 56;
              return mediaProcessor.setMediaStream(webRTCStream);
            case 56:
              _context19.next = 58;
              return mediaProcessor.setVideoTrack(newTrack);
            case 58:
              newTrack = _context19.sent;
            case 59:
              if (!_videoMediaProcessorConnector) {
                _context19.next = 64;
                break;
              }
              originalVideoTrack = _videoMediaProcessorConnector.originalTrack;
              _context19.next = 63;
              return _videoMediaProcessorConnector.setTrack(newTrack);
            case 63:
              newTrack = _context19.sent;
            case 64:
              _context19.prev = 64;
              _context19.next = 67;
              return replaceTrackAndUpdate(oldTrack, newTrack);
            case 67:
              // We stop the original track as a final step because whatever effects
              // were applied to it should remain in effect until the new track is
              // set
              (_originalVideoTrack = originalVideoTrack) == null ? void 0 : _originalVideoTrack.stop();
              _context19.next = 73;
              break;
            case 70:
              _context19.prev = 70;
              _context19.t2 = _context19["catch"](64);
              throw _context19.t2;
            case 73:
            case "end":
              return _context19.stop();
          }
        }, _callee19, null, [[16, 20], [37, 43], [64, 70]]);
      }));
      return function (_x13, _x14) {
        return _ref30.apply(this, arguments);
      };
    }());
    const resetAudioFallbackStateOnPeerConnection = (0, _cancellation.callWithCancellation)( /*#__PURE__*/function () {
      var _ref31 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(isActive, cancellation) {
        var peerConnections;
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return getAllPeerConnections();
            case 2:
              peerConnections = _context20.sent;
              if (!cancellation.isCanceled()) {
                peerConnections.forEach(peerConnection => {
                  if (isActive) {
                    peerConnection.enableCongestionLevelEstimation();
                  } else {
                    peerConnection.disableCongestionLevelEstimation();
                  }
                });
              }
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x15, _x16) {
        return _ref31.apply(this, arguments);
      };
    }());
    const resetAudioFallbackState = () => {
      var _chromeMixin, _chromeMixin2;
      audioFallbackCoordinator.reset();
      (_chromeMixin = chromeMixin) == null ? void 0 : _chromeMixin.videoDisabledIndicator.disableVideo(false);
      (_chromeMixin2 = chromeMixin) == null ? void 0 : _chromeMixin2.videoDisabledIndicator.setWarning(false);
    };
    const onAudioFallbackActiveVideo = /*#__PURE__*/function () {
      var _ref32 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(previousState) {
        var _chromeMixin3, _chromeMixin4;
        return _regenerator.default.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              (_chromeMixin3 = chromeMixin) == null ? void 0 : _chromeMixin3.videoDisabledIndicator.disableVideo(false);
              (_chromeMixin4 = chromeMixin) == null ? void 0 : _chromeMixin4.videoDisabledIndicator.setWarning(false);
              if (previousState === _audioFallbackVideoStates.default.SUSPENDED_VIDEO) {
                _this.trigger('videoEnabled', {
                  reason: 'quality'
                });
              } else {
                _this.trigger('videoDisableWarningLifted');
              }
            case 3:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      return function onAudioFallbackActiveVideo(_x17) {
        return _ref32.apply(this, arguments);
      };
    }();
    const onAudioFallbackActiveVideoWithWarning = () => {
      if (properties.publishVideo) {
        var _chromeMixin5;
        (_chromeMixin5 = chromeMixin) == null ? void 0 : _chromeMixin5.videoDisabledIndicator.setWarning(true);
      }
      this.trigger('videoDisableWarning');
    };
    const onAudioFallbackSuspendedVideo = /*#__PURE__*/function () {
      var _ref33 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22() {
        var _chromeMixin6;
        return _regenerator.default.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (properties.publishVideo) {
                (_chromeMixin6 = chromeMixin) == null ? void 0 : _chromeMixin6.videoDisabledIndicator.disableVideo(true);
              }
              _this.trigger('videoDisabled', {
                reason: 'quality'
              });
            case 2:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      return function onAudioFallbackSuspendedVideo() {
        return _ref33.apply(this, arguments);
      };
    }();
    let audioFallbackCoordinator;
    if (properties.publisherAudioFallbackEnabled) {
      audioFallbackCoordinator = createAudioFallbackCoordinator({
        getAllPeerConnections
      });
      const audioFallbackStateHandlers = {
        [_audioFallbackVideoStates.default.ACTIVE_VIDEO]: onAudioFallbackActiveVideo,
        [_audioFallbackVideoStates.default.ACTIVE_VIDEO_WITH_WARNING]: onAudioFallbackActiveVideoWithWarning,
        [_audioFallbackVideoStates.default.SUSPENDED_VIDEO]: onAudioFallbackSuspendedVideo
      };
      audioFallbackCoordinator.on('stateChange', _ref34 => {
        let previousState = _ref34.previousState,
          audioFallbackVideoState = _ref34.state;
        try {
          audioFallbackStateHandlers[audioFallbackVideoState](previousState);
        } catch (err) {
          logging.error(`Audio fallback error: ${err}`);
          throw err;
        }
      });
    }

    /**
    * Toggles video on or off for the publisher. It causes the video to be published
    * (if it is currently not being published, the client is connected,
    * and the publisher is publishing) when the <code>value</code> is <code>true</code>;
    * it stops publishing video (if it is currently being published) when the <code>value</code>
    * is <code>false</code>.
    *
    * <p>
    * <i>Note:</i> The behavior of <code>publishVideo</code> varies depending on whether
    * the publisher is currently connected and publishing:
    * </p>
    *
    * <ul>
    * <li>Calling <code>publishVideo(true)</code> when the publisher is not connected to a session
    * causes the publisher to capture and render video locally, but it does not stream video.</li>
    *
    * <li>Calling <code>publishVideo(false)</code> when the publisher is not connected to a session
    * causes the publisher to stop capturing video locally. No video is streamed.</li>
    *
    * <li>Calling <code>publishVideo(true)</code> when the publisher is connected to a session
    * but not currently publishing causes it to capture and render video locally, but it does not stream video.</li>
    *
    * <li>Calling <code>publishVideo(false)</code> when the publisher is connected to a session
    * but not currently publishing causes the publisher to stop capturing video locally. No video is streamed.</li>
    *
    * <li>Calling <code>publishVideo(true)</code> when the publisher is both connected to a session
    * and currently publishing causes the publisher to capture and render video locally and to
    * stream video.</li>
    *
    * <li>Calling <code>publishVideo(false)</code> when the publisher is both connected to a session
    * and currently publishing causes the publisher to stop capturing video and to stream empty video frames.</li>
    * </ul>
    *
    * @param {Boolean} value Whether to start publishing video (<code>true</code>)
    * or not (<code>false</code>).
    * @param {function} callback (Optional) A function that takes in an <code><a href="Error.html">Error</a></code>
    * parameter. Upon successful completion of the method, this <code>error</code> parameter is undefined.
    * An error results if the publisher has no devices to provide the media stream or if the user media
    * request is not supported.
    *
    * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * @see <a href="Stream.html#hasVideo">Stream.hasVideo</a>
    * @see StreamPropertyChangedEvent
    * @method #publishVideo
    * @memberOf Publisher
    */
    this.publishVideo = (value, completionHandler) => {
      // Skip if the previous publish values and new ones are the same. We call completionHandler
      // separately because the onResolve method logs a `publishVideo - Success` event.
      if (properties.publishVideo === value) {
        // We want to invoke the completion handler after returning the Publisher; using
        // setTimeout moves the handler to the bottom of the stack.
        if (completionHandler) {
          setTimeout(() => {
            completionHandler();
          });
        }
        return this;
      }
      const _createPublishVideoPr = (0, _createPublishVideoPromiseHandlers.default)(completionHandler),
        onResolve = _createPublishVideoPr.onResolve,
        onReject = _createPublishVideoPr.onReject;
      logAnalyticsEvent('publishVideo', 'Attempt', {
        publishVideo: value
      });
      this._publishVideo(value).then(() => {
        logAnalyticsEvent('publishVideo', 'Success', {
          publishVideo: value
        });
        onResolve();
      }, error => {
        logAnalyticsEvent('publishVideo', 'Failure', {
          message: error.message
        });
        onReject(error);
      });
      return this;
    };
    this._publishVideo = /*#__PURE__*/function () {
      var _ref35 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(value) {
        var videoDimensions;
        return _regenerator.default.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              // Save videoDimensions to not alter video size between mute states.
              videoDimensions = getVideoDimensions();
              properties.publishVideo = value;
              if (properties.publisherAudioFallbackEnabled) {
                resetAudioFallbackStateOnPeerConnection(value);
                if (value === false && audioFallbackCoordinator.getState() !== _audioFallbackVideoStates.default.ACTIVE_VIDEO) {
                  // We will reset audio fallback state now, but rumor doesn't expect the message until we re-enable the video
                  // so we flag the message as pending
                  pendingRumorAudioFallbackMessage = true;
                  resetAudioFallbackState();
                }
              }
              _context23.next = 5;
              return Promise.all([_this._toggleVideo(properties.publishVideo, videoDimensions), updateVideo()]);
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
      return function (_x18) {
        return _ref35.apply(this, arguments);
      };
    }();

    /**
    * Sets the content hint for the video track of the publisher's stream. This allows browsers
    * to use encoding or processing methods more appropriate to the type of content.
    * <p>
    * Use this method to change the video content hit dynamically. Set the initial video content
    * hit by setting the <code>videoContentHint</code> property of the options passed into the
    * <a href="OT.html#initPublisher">OT.initPublisher()</a> method.
    * <p>
    * Chrome 60+, Safari 12.1+, Edge 79+, and Opera 47+ support video content hints.
    *
    * @param {String} videoContentHint You can set this to one of the following values:
    *    <p>
    *    <ul>
    *      <li>
    *        <code>""</code> &mdash; No hint is provided.
    *      </li>
    *      <li>
    *        <code>"motion"</code> &mdash; The track should be treated as if it contains video
    *        where motion is important. For example, you may use this setting for a screen-sharing
    *        stream that contains video.
    *      </li>
    *      <li>
    *        <code>"detail"</code> &mdash; The track should be treated as if video details
    *        are extra important. For example, you may use this setting for a screen-sharing
    *        stream that contains text content, painting, or line art.
    *      </li>
    *      <li>
    *        <code>"text"</code> &mdash; The track should be treated as if text details are
    *        extra important. For example, you may use this setting for a screen-sharing
    *        stream that contains text content.
    *      </li>
    *    </ul>
    *
    * @see <a href="#getVideoContentHint">Publisher.getVideoContentHint()</a>
    * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * @method #setVideoContentHint
    * @memberOf Publisher
    */
    this.setVideoContentHint = videoContentHint => {
      if (isScreenSharing && properties._setDefaultScalabilityMode) {
        this._setScalabilityMode((0, _getScalabilityModeFromContentHint.default)(videoContentHint));
      }
      (0, _videoContentHint.setVideoContentHint)(webRTCStream, videoContentHint);
    };

    /**
    * Returns the content hint for the video track.
    *
    * @return {String} One of the following values: <code>""</code>,
    *         <code>"motion"</code>, <code>"detail</code>, or <code>"text"</code>.
    * @see <a href="#setVideoContentHint">Publisher.setVideoContentHint()</a>
    * @method #getVideoContentHint
    * @memberOf Publisher
    */
    this.getVideoContentHint = () => (0, _videoContentHint.getVideoContentHint)(webRTCStream);

    /**
    * Deletes the Publisher object and removes it from the HTML DOM.
    * <p>
    * The Publisher object dispatches a <code>destroyed</code> event when the DOM
    * element is removed.
    * </p>
    * @method #destroy
    * @memberOf Publisher
    * @return {Publisher} The Publisher.
    */

    this.destroy = function ( /* unused */reason, quiet) {
      // @todo OPENTOK-36652 this.session should not be needed here
      if (state.isAttemptingToPublish() && this.session) {
        logConnectivityEvent('Cancel', {
          reason: 'destroy'
        });
      }
      if (state.isDestroyed()) {
        return this;
      }
      state.set('Destroyed');
      reset();
      if (processedOptions) {
        processedOptions.off();
        processedOptions = null;
      }
      if (chromeMixin) {
        chromeMixin.destroy();
        chromeMixin = null;
      }
      if (privateEvents) {
        privateEvents.off();
        privateEvents = null;
      }
      if (quiet !== true) {
        this.dispatchEvent(new Events.DestroyedEvent(_eventNames.default.PUBLISHER_DESTROYED, this, reason));
      }
      this.off();
      if (_videoMediaProcessorConnector) {
        _videoMediaProcessorConnector.destroy();
        _videoMediaProcessorConnector.stopOriginalTrack();
      }
      if (_audioMediaProcessorConnector) {
        _audioMediaProcessorConnector.destroy();
        _audioMediaProcessorConnector.stopOriginalTrack();
      }
      if (removeDeviceChangeListener !== undefined) {
        removeDeviceChangeListener();
      }
      return this;
    };

    /*
    * @methodOf Publisher
    * @private
    */
    this.disconnect = () => {
      Object.keys(peerConnectionsAsync).forEach(peerConnectionId => {
        const futurePeerConnection = getPeerConnectionById(peerConnectionId);
        delete peerConnectionsAsync[peerConnectionId];
        futurePeerConnection.then(peerConnection => this._removePeerConnection(peerConnection));
      });

      // In case the publisher is reused we need to clear the streamchannels
      streamChannels.length = 0;
    };
    this.processMessage = (type, fromConnectionId, message) => {
      const subscriberId = (0, _get.default)(message, 'params.subscriber', fromConnectionId).replace(/^INVALID-STREAM$/, fromConnectionId);
      const peerId = (0, _get.default)(message, 'content.peerId');
      const sourceStreamId = (0, _get.default)(message, 'content.sourceStreamId', 'MANTIS');

      // Symphony will not have a subscriberId so we'll fallback to using the connectionId for it.
      // Also fallback to the connectionId if it is equal to 'INVALID-STREAM' (See OPENTOK-30029).
      const peerConnectionId = `${subscriberId}~${peerId}~${sourceStreamId}`;
      logging.debug(`OT.Publisher.processMessage: Received ${type} from ${fromConnectionId} for ${peerConnectionId}`);
      logging.debug(message);
      const futurePeerConnection = getPeerConnectionById(peerConnectionId);
      const addPeerConnection = () => {
        _peerId = peerId;
        _raptorUri = message.uri;
        const send = createSendMessage(sourceStreamId);
        const log = function log(action, variation, payload, logOptions, throttle) {
          if (logOptions === void 0) {
            logOptions = {};
          }
          const transformedOptions = Object.assign({
            peerId,
            sourceStreamId: (0, _getMediaModeBySourceStreamId.default)(sourceStreamId)
          }, logOptions);
          return logAnalyticsEvent(action, variation, payload, transformedOptions, throttle);
        };
        const logQoS = qos => {
          // We only log data from the active peer connection
          if (sourceStreamId !== activeSourceStreamId) {
            return;
          }
          recordQOS(Object.assign({}, qos, {
            peerId,
            remoteConnectionId: fromConnectionId,
            sourceStreamId
          }));
        };
        createPeerConnection({
          peerConnectionId,
          send,
          log,
          logQoS,
          sourceStreamId
        }).then(peerConnection => {
          setPeerConnectionMeta(peerConnection, {
            remoteConnectionId: fromConnectionId,
            remoteSubscriberId: subscriberId,
            peerId,
            sourceStreamId,
            peerConnectionId
          });
          peerConnection.processMessage(type, message);

          // Allow this runaway promise
          // http://bluebirdjs.com/docs/warning-explanations.html#warning-a-promise-was-created-in-a-handler-but-was-not-returned-from-it
          return null;
        }).catch(err => {
          logging.error('OT.Publisher failed to create a peerConnection', err);
        });
      };
      const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
      switch (type) {
        case 'unsubscribe':
          this._removeSubscriber(subscriberId);
          break;
        default:
          if (!futurePeerConnection) {
            if (!state.isMigrating() && isAdaptiveEnabled && getP2pPeerConnection()) {
              // In the case Rumor sends two generateOffers for the P2P leg,
              // we need to ignore the second one.
              return;
            }
            addPeerConnection();
          } else {
            futurePeerConnection.then(peerConnection => {
              peerConnection.processMessage(type, message);
              if (isRoutedToRelayedTransitionDuringMigration(type, sourceStreamId)) {
                _stopSendingRtpToMantis();
              }
            });
          }
          break;
      }
    };

    /**
    * Returns the base-64-encoded string of PNG data representing the Publisher video.
    *
    *   <p>You can use the string as the value for a data URL scheme passed to the src parameter of
    *   an image file, as in the following:</p>
    *
    * <pre>
    *  var imgData = publisher.getImgData();
    *
    *  var img = document.createElement("img");
    *  img.setAttribute("src", "data:image/png;base64," + imgData);
    *  var imgWin = window.open("about:blank", "Screenshot");
    *  imgWin.document.write("&lt;body&gt;&lt;/body&gt;");
    *  imgWin.document.body.appendChild(img);
    * </pre>
    *
    * @method #getImgData
    * @memberOf Publisher
    * @return {String} The base-64 encoded string. Returns an empty string if there is no video.
    */

    this.getImgData = function () {
      if (!loaded) {
        logging.error('OT.Publisher.getImgData: Cannot getImgData before the Publisher is publishing.');
        return null;
      }
      const video = widgetView && widgetView.video();
      return video ? video.imgData() : null;
    };
    const setNewStream = newStream => {
      cleanupLocalStream();
      webRTCStream = newStream;
      privateEvents.emit('streamChange');
      microphone = new Microphone(webRTCStream, !properties.publishAudio);
    };
    const defaultReplaceTrackLogic = peerConnection => {
      peerConnection.getSenders().forEach(sender => {
        if (sender.track.kind === 'audio' && webRTCStream.getAudioTracks().length) {
          return sender.replaceTrack(webRTCStream.getAudioTracks()[0]);
        } else if (sender.track.kind === 'video' && webRTCStream.getVideoTracks().length) {
          return sender.replaceTrack(webRTCStream.getVideoTracks()[0]);
        }
        return undefined;
      });
    };
    const replaceTracks = function replaceTracks(replaceTrackLogic) {
      if (replaceTrackLogic === void 0) {
        replaceTrackLogic = defaultReplaceTrackLogic;
      }
      return getAllPeerConnections().then(peerConnections => {
        const tasks = [];
        peerConnections.map(replaceTrackLogic);
        return Promise.all(tasks);
      });
    };
    {
      let videoIndex = 0;
      const cycleVideo = /*#__PURE__*/function () {
        var _ref36 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24() {
          var oldTrack, vidDevices, hasOtherVideoDevices, newVideoDevice, deviceId;
          return _regenerator.default.wrap(function _callee24$(_context24) {
            while (1) switch (_context24.prev = _context24.next) {
              case 0:
                if (!(OTHelpers.env.isLegacyEdge || !windowMock.RTCRtpSender || typeof windowMock.RTCRtpSender.prototype.replaceTrack !== 'function')) {
                  _context24.next = 2;
                  break;
                }
                throw otError(Errors.UNSUPPORTED_BROWSER, new Error('Publisher#cycleVideo is not supported in your browser.'), ExceptionCodes.UNABLE_TO_PUBLISH);
              case 2:
                if (!(isCustomVideoTrack || isScreenSharing)) {
                  _context24.next = 4;
                  break;
                }
                throw otError(Errors.NOT_SUPPORTED, new Error('Publisher#cycleVideo: The publisher is not using a camera video source'));
              case 4:
                oldTrack = getCurrentTrack();
                if (oldTrack) {
                  _context24.next = 7;
                  break;
                }
                throw otError(Errors.NOT_SUPPORTED, new Error('Publisher#cycleVideo cannot cycleVideo when you have no video source.'));
              case 7:
                videoIndex += 1;
                _context24.next = 10;
                return getVideoDevices();
              case 10:
                vidDevices = _context24.sent;
                // different devices return the cameras in different orders
                hasOtherVideoDevices = vidDevices.filter(device => device.deviceId !== currentDeviceId).length > 0;
                if (hasOtherVideoDevices) {
                  _context24.next = 14;
                  break;
                }
                return _context24.abrupt("return", currentDeviceId);
              case 14:
                while (vidDevices[videoIndex % vidDevices.length].deviceId === currentDeviceId) {
                  videoIndex += 1;
                }
                privateEvents.emit('streamDestroy');
                newVideoDevice = vidDevices[videoIndex % vidDevices.length];
                deviceId = newVideoDevice.deviceId;
                _context24.next = 20;
                return attemptToSetVideoTrack(deviceId);
              case 20:
                return _context24.abrupt("return", currentDeviceId);
              case 21:
              case "end":
                return _context24.stop();
            }
          }, _callee24);
        }));
        return function cycleVideo() {
          return _ref36.apply(this, arguments);
        };
      }();

      /**
      * Switches the video input source used by the publisher to the next one in the list
      * of available devices.
      * <p>
      * This will result in an error (the Promise returned by the method is rejected) in the
      * following conditions:
      * <ul>
      *   <li>
      *     The user denied access to the video input device.
      *   </li>
      *   <li>
      *     The publisher is not using a camera video source. (The <code>videoSource</code>
      *     option of the <a href="OT.html#initPublisher">OT.initPublisher()</a> method was
      *     set to <code>null</code>, <code>false</code>, a MediaStreamTrack object, or
      *     <code>"screen"</code>).
      *   </li>
      *   <li>
      *     There are no video input devices (cameras) available.
      *   </li>
      *   <li>
      *     There was an error acquiring video from the video input device.
      *   </li>
      *  </ul>
      * </p>
      *
      * @method #cycleVideo
      * @memberOf Publisher
      *
      * @return {Promise} A promise that resolves when the operation completes
      * successfully. The promise resolves with an object that has a
      * <code>deviceId</code> property set to the device ID of the camera used:
      *
      * <pre>
      *   publisher.cycleVideo().then(console.log);
      *   // Output: {deviceId: "967a86e52..."}
      * </pre>
      *
      * If there is an error, the promise is rejected.
      *
      * @see <a href="#setVideoSource">Publisher.setVideoSource()</a>
      */
      this.cycleVideo = (0, _blockCallsUntilComplete.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25() {
        var deviceId;
        return _regenerator.default.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;
              _context25.next = 3;
              return cycleVideo();
            case 3:
              deviceId = _context25.sent;
              _context25.next = 10;
              break;
            case 6:
              _context25.prev = 6;
              _context25.t0 = _context25["catch"](0);
              logging.error(`Publisher#cycleVideo: could not cycle video: ${_context25.t0}`);
              throw _context25.t0;
            case 10:
              return _context25.abrupt("return", {
                deviceId
              });
            case 11:
            case "end":
              return _context25.stop();
          }
        }, _callee25, null, [[0, 6]]);
      })));
    }
    const replaceTrackAndUpdate = /*#__PURE__*/function () {
      var _ref38 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27(oldTrack, newTrack) {
        var pcs, isNewTrackFiltered, video;
        return _regenerator.default.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return getAllPeerConnections();
            case 2:
              pcs = _context27.sent;
              _context27.next = 5;
              return Promise.all(pcs.map( /*#__PURE__*/function () {
                var _ref39 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26(pc) {
                  return _regenerator.default.wrap(function _callee26$(_context26) {
                    while (1) switch (_context26.prev = _context26.next) {
                      case 0:
                        _context26.next = 2;
                        return pc.findAndReplaceTrack(oldTrack, newTrack);
                      case 2:
                        pc.setP2PMaxBitrate();
                      case 3:
                      case "end":
                        return _context26.stop();
                    }
                  }, _callee26);
                }));
                return function (_x21) {
                  return _ref39.apply(this, arguments);
                };
              }()));
            case 5:
              webRTCStream.removeTrack(oldTrack);
              webRTCStream.addTrack(newTrack);
              if (oldTrack && oldTrack.stop) {
                // We "try" since this expression will throw in browsers that don't
                // support this API.
                try {
                  isNewTrackFiltered = newTrack instanceof MediaStreamTrackGenerator
                  // Check prototype string too since instanceof is false in an iframe
                  || Object.getPrototypeOf(newTrack).toString().includes('MediaStreamTrackGenerator');
                } catch (err) {
                  isNewTrackFiltered = false;
                }

                // The oldTrack is being used as input by the MediaProcessor, so stopping
                // it will stop the newTrack as well.
                if (!isNewTrackFiltered) {
                  oldTrack.stop();
                }
              }
              if (OTHelpers.env.name === 'Firefox' || OTHelpers.env.name === 'Safari') {
                // Local video freezes on old stream without this for some reason
                _this.videoElement().srcObject = null;
                _this.videoElement().srcObject = webRTCStream;
              }
              video = widgetView && widgetView.video();
              if (video) {
                video.refreshTracks();
              }
              privateEvents.emit('streamChange');
              updateVideo();
            case 13:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }));
      return function replaceTrackAndUpdate(_x19, _x20) {
        return _ref38.apply(this, arguments);
      };
    }();
    const getTrackFromDeviceId = /*#__PURE__*/function () {
      var _ref40 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28(deviceId) {
        var _newVideoStream;
        var oldTrackDeviceId, newOptions, _processedOptions2, getUserMediaHelper, newVideoStream, _newVideoStream$getVi, track;
        return _regenerator.default.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              oldTrackDeviceId = getCurrentTrackDeviceId();
              setCurrentTrackDeviceId(deviceId);
              newOptions = (0, _cloneDeep.default)(options);
              newOptions.audioSource = null;
              newOptions.videoSource = deviceId;
              processedOptions = processPubOptions(newOptions, 'OT.Publisher.getTrackFromDeviceId', () => state && state.isDestroyed());
              processedOptions.on({
                accessDialogOpened: onAccessDialogOpened,
                accessDialogClosed: onAccessDialogClosed
              });
              _processedOptions2 = processedOptions, getUserMediaHelper = _processedOptions2.getUserMedia;
              _context28.prev = 8;
              _context28.next = 11;
              return getUserMediaHelper();
            case 11:
              newVideoStream = _context28.sent;
              _context28.next = 18;
              break;
            case 14:
              _context28.prev = 14;
              _context28.t0 = _context28["catch"](8);
              logging.error(_context28.t0);
              throw _context28.t0;
            case 18:
              _newVideoStream$getVi = (_newVideoStream = newVideoStream) == null ? void 0 : _newVideoStream.getVideoTracks(), track = _newVideoStream$getVi[0];
              if (!track) {
                setCurrentTrackDeviceId(oldTrackDeviceId);
              }
              return _context28.abrupt("return", track);
            case 21:
            case "end":
              return _context28.stop();
          }
        }, _callee28, null, [[8, 14]]);
      }));
      return function getTrackFromDeviceId(_x22) {
        return _ref40.apply(this, arguments);
      };
    }();
    const getCurrentTrack = () => {
      const _webRTCStream$getVide = webRTCStream.getVideoTracks(),
        currentTrack = _webRTCStream$getVide[0];
      return currentTrack;
    };
    const getCurrentTrackDeviceId = () => _currentTrackDeviceId;

    // _currentTrackDeviceId is the id of the device of the track already in use or being acquired
    // by getTrackFromDeviceId. Please note this is preventing to getTrackFromDeviceId twice from
    // the same device. Please see hasTrackFromDevice and getTrackFromDeviceId for more context.
    const setCurrentTrackDeviceId = deviceId => {
      _currentTrackDeviceId = deviceId;
    };
    const getVideoDevices = /*#__PURE__*/function () {
      var _ref41 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29() {
        var devices, vidDevices;
        return _regenerator.default.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return deviceHelpers.shouldAskForDevices();
            case 2:
              devices = _context29.sent;
              vidDevices = devices.videoDevices;
              if (!(!devices.video || !vidDevices || !vidDevices.length)) {
                _context29.next = 6;
                break;
              }
              throw otError(Errors.NO_DEVICES_FOUND, new Error('No video devices available'), ExceptionCodes.UNABLE_TO_PUBLISH);
            case 6:
              return _context29.abrupt("return", vidDevices);
            case 7:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }));
      return function getVideoDevices() {
        return _ref41.apply(this, arguments);
      };
    }();
    const replaceAudioTrackInPeerConnections = /*#__PURE__*/function () {
      var _ref42 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30(oldTrack, newTrack) {
        var isAdaptiveEnabled, activePeerConnection, inactivePeerConnection, pcs;
        return _regenerator.default.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (_this.session) {
                _context30.next = 2;
                break;
              }
              return _context30.abrupt("return");
            case 2:
              isAdaptiveEnabled = _this.session.sessionInfo.isAdaptiveEnabled; // If we are in an AMR session and a P2P PC, we need to change the track in the P2P PC
              // and check the Mantis PC, if we need to add the new track to the muted Mantis audio tracks and replace it.
              // activeSourceStreamId may be undefined if we haven't finished publishing yet
              if (!(activeSourceStreamId && isAdaptiveEnabled)) {
                _context30.next = 17;
                break;
              }
              _context30.next = 6;
              return getPeerConnectionBySourceStreamId(activeSourceStreamId);
            case 6:
              activePeerConnection = _context30.sent;
              _context30.next = 9;
              return activePeerConnection == null ? void 0 : activePeerConnection.findAndReplaceTrack(oldTrack, newTrack);
            case 9:
              if (!(activeSourceStreamId === 'P2P')) {
                _context30.next = 15;
                break;
              }
              _context30.next = 12;
              return getMantisPeerConnection();
            case 12:
              inactivePeerConnection = _context30.sent;
              _context30.next = 15;
              return amrAudioTrackProcessor.replaceTrackInMutedAudioTracks(inactivePeerConnection, oldTrack, newTrack);
            case 15:
              _context30.next = 22;
              break;
            case 17:
              _context30.next = 19;
              return getAllPeerConnections();
            case 19:
              pcs = _context30.sent;
              _context30.next = 22;
              return Promise.all(pcs.map(pc => pc.findAndReplaceTrack(oldTrack, newTrack)));
            case 22:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }));
      return function replaceAudioTrackInPeerConnections(_x23, _x24) {
        return _ref42.apply(this, arguments);
      };
    }();
    const replaceAudioTrack = /*#__PURE__*/function () {
      var _ref43 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31(oldTrack, newTrack) {
        var video, isFilteredTrack;
        return _regenerator.default.wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (!(oldTrack === newTrack)) {
                _context31.next = 2;
                break;
              }
              return _context31.abrupt("return");
            case 2:
              _context31.next = 4;
              return replaceAudioTrackInPeerConnections(oldTrack, newTrack);
            case 4:
              if (newTrack) {
                webRTCStream.addTrack(newTrack);
              }
              if (oldTrack) {
                webRTCStream.removeTrack(oldTrack);
              }
              video = widgetView && widgetView.video();
              if (video) {
                video.refreshTracks();
              }
              if (chromeMixin) {
                if (newTrack && !oldTrack) {
                  chromeMixin.addAudioTrack();
                }
                if (oldTrack && !newTrack) {
                  chromeMixin.removeAudioTrack();
                }
              }
              // We "try" since this expression will throw in browsers that don't
              // support this API.
              try {
                isFilteredTrack = newTrack instanceof MediaStreamTrackGenerator
                // Check prototype string too since instanceof is false in an iframe
                || Object.getPrototypeOf(newTrack).toString().includes('MediaStreamTrackGenerator');
              } catch (e) {
                isFilteredTrack = false;
              }
              if (oldTrack && oldTrack.stop && !isFilteredTrack) {
                oldTrack.stop();
              }
              if (newTrack) {
                // Turn the audio back on if the audio track stopped because it was disconnected
                updateAudio();
                microphone = new Microphone(webRTCStream, !properties.publishAudio);
              }
              privateEvents.emit('streamChange');
              refreshAudioVideoUI();
            case 14:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }));
      return function replaceAudioTrack(_x25, _x26) {
        return _ref43.apply(this, arguments);
      };
    }();
    const resetAudioSource = /*#__PURE__*/function () {
      var _ref44 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(audioTrack) {
        var audioDeviceId, newAudioTrack;
        return _regenerator.default.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              audioDeviceId = audioTrack.getSettings().deviceId;
              _context32.prev = 1;
              _context32.next = 4;
              return _this.setAudioSource(audioDeviceId);
            case 4:
              // We need to add the onmute listener to the new audio track.
              newAudioTrack = webRTCStream.getAudioTracks()[0];
              if (newAudioTrack) {
                newAudioTrack.onmute = () => handleBuggedMutedLocalAudioTrack(newAudioTrack);
                newAudioTrack.onunmute = () => handleBuggedUnMutedLocalAudioTrack(newAudioTrack);
              }
              _context32.next = 11;
              break;
            case 8:
              _context32.prev = 8;
              _context32.t0 = _context32["catch"](1);
              logging.error(_context32.t0);
            case 11:
            case "end":
              return _context32.stop();
          }
        }, _callee32, null, [[1, 8]]);
      }));
      return function resetAudioSource(_x27) {
        return _ref44.apply(this, arguments);
      };
    }();

    // this should be called when we detect a mute event from a bugged device
    const handleBuggedMutedLocalAudioTrack = audioTrack => {
      let shouldRePublishVideo = false;
      if (properties.publishVideo && document.hidden) {
        shouldRePublishVideo = true;
        // turning the video off to prevent that videotrack is ended
        this.publishVideo(false);
      }
      // trigger the handler onVisibilityChange
      const visibilityHandler = /*#__PURE__*/function () {
        var _ref45 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33() {
          return _regenerator.default.wrap(function _callee33$(_context33) {
            while (1) switch (_context33.prev = _context33.next) {
              case 0:
                if (document.hidden) {
                  _context33.next = 5;
                  break;
                }
                _context33.next = 3;
                return resetAudioSource(audioTrack);
              case 3:
                if (shouldRePublishVideo) {
                  _this.publishVideo(true);
                }
                document.removeEventListener('visibilitychange', visibilityHandler);
              case 5:
              case "end":
                return _context33.stop();
            }
          }, _callee33);
        }));
        return function visibilityHandler() {
          return _ref45.apply(this, arguments);
        };
      }();
      document.addEventListener('visibilitychange', visibilityHandler);
    };
    const handleBuggedUnMutedLocalAudioTrack = audioTrack => {
      var _this$session6;
      if (hasAudio()) {
        if (!hasVideo()) {
          // We only need to reset the audio source when the publisher is audio only.
          resetAudioSource(audioTrack);
        } else {
          // Inconsistenly the publisher shows a black frame after the incoming call with compact UI
          // ends. In order to unblock the video element we added this hack that needs to be
          // revisited.
          // We need to call pause and play again, and since we have a listener on the onpause event
          // that internally calls the play function, we only need to call pause(),
          // and the play will be automatically executed.
          this.videoElement().pause();
        }
      }
      this == null ? void 0 : (_this$session6 = this.session) == null ? void 0 : _this$session6.trigger('gsmCallEnded');
    };

    /**
    * Switches the audio input source used by the publisher. You can set the
    * <code>audioSource</code> to a device ID (string) or audio MediaStreamTrack object.
    * <p>
    * This will result in an error (the Promise returned by the method is rejected) in the
    * following conditions:
    * <ul>
    *   <li>
    *     The browser does not support this method. This method is not supported in
    *     Internet Explorer or non-Chromium versions of Edge (older than version 79).
    *   </li>
    *   <li>
    *     The publisher was not initiated with an audio source. (The <code>audioSource</code>
    *     option of the <a href="OT.html#initPublisher">OT.initPublisher()</a> method was
    *     set to <code>null</code> or <code>false</code>).
    *   </li>
    *   <li>
    *     The user denied access to the audio input device.
    *   </li>
    *   <li>
    *     There was an error acquiring audio from the audio input device or MediaStreamTrack
    *     object.
    *   </li>
    *   <li>
    *     The <code>audioSource</code> value is not a string or MediaStreamTrack object.
    *   </li>
    *   <li>
    *     The <code>audioSource</code> string is not a valid audio input device available
    *     to the browser.
    *   </li>
    *  </ul>
    * </p>
    *
    * @param {Object} audioSource The device ID (string) of an audio input device, or an audio
    * MediaStreamTrack object.
    *
    * @method #setAudioSource
    * @memberOf Publisher
    *
    * @see <a href="#getAudioSource">Publisher.getAudioSource()</a>
    *
    * @return {Promise} A promise that resolves when the operation completes successfully.
    * If there is an error, the promise is rejected.
    */
    const isSetAudioSourceSupported = !(OTHelpers.env.isLegacyEdge || !windowMock.RTCRtpSender || typeof windowMock.RTCRtpSender.prototype.replaceTrack !== 'function');
    const setAudioSourceNotSupportedError = () => otError(Errors.UNSUPPORTED_BROWSER, new Error('Publisher#setAudioSource is not supported in your browser.'));
    const setAudioSourceCancellationError = () => otError(Errors.CANCEL, new Error('Operation did not succeed due to a new request.'));
    let cancelPreviousSetAudioSourceSentinel;
    const getSetAudioSourceCancellationSentinel = () => {
      if (cancelPreviousSetAudioSourceSentinel) {
        cancelPreviousSetAudioSourceSentinel.cancel();
      }
      cancelPreviousSetAudioSourceSentinel = new _cancel.default();
      return cancelPreviousSetAudioSourceSentinel;
    };
    const setAudioSource = /*#__PURE__*/function () {
      var _ref46 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee35(audioSource) {
        var currentCancelSentinel, setStreamIfNotCancelled, prevAudioSource, newTrack, newOptions, prevLabel, prevDeviceId, _processedOptions3, getUserMediaHelper, prevOptions, previousDevice, stream;
        return _regenerator.default.wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              if (isSetAudioSourceSupported) {
                _context35.next = 2;
                break;
              }
              throw setAudioSourceNotSupportedError();
            case 2:
              currentCancelSentinel = getSetAudioSourceCancellationSentinel();
              setStreamIfNotCancelled = /*#__PURE__*/function () {
                var _ref47 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee34(stream) {
                  return _regenerator.default.wrap(function _callee34$(_context34) {
                    while (1) switch (_context34.prev = _context34.next) {
                      case 0:
                        if (!currentCancelSentinel.isCanceled()) {
                          _context34.next = 3;
                          break;
                        }
                        stream.getTracks(track => track.stop());
                        throw setAudioSourceCancellationError();
                      case 3:
                        return _context34.abrupt("return", setAudioSource(stream.getAudioTracks()[0]));
                      case 4:
                      case "end":
                        return _context34.stop();
                    }
                  }, _callee34);
                }));
                return function setStreamIfNotCancelled(_x29) {
                  return _ref47.apply(this, arguments);
                };
              }();
              prevAudioSource = _this._getAudioSource();
              if (prevAudioSource) {
                _context35.next = 7;
                break;
              }
              throw otError(Errors.NOT_SUPPORTED, new Error('Publisher#setAudioSource cannot add an audio source when you started without one.'));
            case 7:
              if (!(audioSource instanceof MediaStreamTrack)) {
                _context35.next = 26;
                break;
              }
              if (!currentCancelSentinel.isCanceled()) {
                _context35.next = 10;
                break;
              }
              throw setAudioSourceCancellationError();
            case 10:
              if (!_audioMediaProcessorConnector) {
                _context35.next = 23;
                break;
              }
              _context35.prev = 11;
              _context35.next = 14;
              return _audioMediaProcessorConnector.setTrack(audioSource);
            case 14:
              newTrack = _context35.sent;
              _context35.next = 17;
              return replaceAudioTrack(prevAudioSource, newTrack);
            case 17:
              return _context35.abrupt("return", _context35.sent);
            case 20:
              _context35.prev = 20;
              _context35.t0 = _context35["catch"](11);
              logging.error(`Error setting track on audioMediaProcessorConnector: ${_context35.t0}`);
            case 23:
              return _context35.abrupt("return", replaceAudioTrack(prevAudioSource, audioSource));
            case 26:
              if (!(typeof audioSource === 'string')) {
                _context35.next = 73;
                break;
              }
              // Must be a deviceId, call getUserMedia and get the MediaStreamTrack
              newOptions = (0, _cloneDeep.default)(options);
              newOptions.audioSource = audioSource;
              newOptions.videoSource = null;
              processedOptions = processPubOptions(newOptions, 'OT.Publisher.setAudioSource', () => currentCancelSentinel.isCanceled() || state && state.isDestroyed());
              processedOptions.on({
                accessDialogOpened: onAccessDialogOpened,
                accessDialogClosed: onAccessDialogClosed
              });
              prevLabel = prevAudioSource.label;
              prevDeviceId = prevAudioSource.getConstraints && prevAudioSource.getSettings().deviceId || undefined; // In firefox we have to stop the previous track before we get a new one
              if (prevAudioSource) {
                prevAudioSource.stop();
              }
              _processedOptions3 = processedOptions, getUserMediaHelper = _processedOptions3.getUserMedia;
              _context35.prev = 36;
              _context35.t1 = setStreamIfNotCancelled;
              _context35.next = 40;
              return getUserMediaHelper();
            case 40:
              _context35.t2 = _context35.sent;
              _context35.next = 43;
              return (0, _context35.t1)(_context35.t2);
            case 43:
              return _context35.abrupt("return", _context35.sent);
            case 46:
              _context35.prev = 46;
              _context35.t3 = _context35["catch"](36);
              if (!currentCancelSentinel.isCanceled()) {
                _context35.next = 50;
                break;
              }
              throw setAudioSourceCancellationError();
            case 50:
              prevOptions = (0, _cloneDeep.default)(options);
              prevOptions.videoSource = null;
              prevOptions.audioSource = prevDeviceId;
              if (!(!prevOptions.audioSource && prevLabel)) {
                _context35.next = 60;
                break;
              }
              _context35.next = 56;
              return getInputMediaDevices();
            case 56:
              previousDevice = _context35.sent.find(x => x.label === prevLabel);
              if (!currentCancelSentinel.isCanceled()) {
                _context35.next = 59;
                break;
              }
              throw setAudioSourceCancellationError();
            case 59:
              if (previousDevice) {
                prevOptions.audioSource = previousDevice.deviceId;
              }
            case 60:
              if (prevOptions.audioSource) {
                _context35.next = 63;
                break;
              }
              _context35.t3.message += ' (could not determine previous audio device)';
              throw otError(Errors.NOT_FOUND, _context35.t3);
            case 63:
              processedOptions = processPubOptions(prevOptions, 'OT.Publisher.setAudioSource', () => currentCancelSentinel.isCanceled() || state && state.isDestroyed());
              _context35.next = 66;
              return processedOptions.getUserMedia().catch(error => {
                // eslint-disable-next-line no-param-reassign
                error.message += ' (could not obtain previous audio device)';
                throw error;
              });
            case 66:
              stream = _context35.sent;
              _context35.next = 69;
              return setStreamIfNotCancelled(stream);
            case 69:
              _context35.t3.message += ' (reverted to previous audio device)';
              throw _context35.t3;
            case 71:
              _context35.next = 74;
              break;
            case 73:
              throw otError(Errors.INVALID_PARAMETER, new Error('Invalid parameter passed to OT.Publisher.setAudioSource(). Expected string or MediaStreamTrack.'));
            case 74:
            case "end":
              return _context35.stop();
          }
        }, _callee35, null, [[11, 20], [36, 46]]);
      }));
      return function setAudioSource(_x28) {
        return _ref46.apply(this, arguments);
      };
    }();
    this.setAudioSource = setAudioSource;

    // Internal method to get actual current track which may be MediaStreamTrackGenerator if track is filtered
    this._getAudioSource = () => {
      if (webRTCStream && webRTCStream.getAudioTracks().length > 0) {
        return webRTCStream.getAudioTracks()[0];
      }
      return null;
    };

    /**
    * Returns the MediaStreamTrack object used as the audio input source for the publisher.
    * If the publisher does not have an audio source, this method returns null.
    *
    * @method #getAudioSource
    * @memberOf Publisher
    * @see <a href="#setAudioSource">Publisher.setAudioSource()</a>
    *
    * @return {MediaStreamTrack} The audio source for the publisher (or null, if there is none).
    */
    this.getAudioSource = () => {
      if (_audioMediaProcessorConnector) {
        // If the track is being filtered we return the original track so user can get device id
        return _audioMediaProcessorConnector.originalTrack;
      }
      return this._getAudioSource();
    };

    /**
     * This method sets the video source for a publisher that is using a camera.
     * Pass in the device ID of the new video source.
     *
     * <p>
     * The following will result in errors:
     *
     * <ul>
     * <li>If the <code>videoSourceId</code> parameter is not a string
     * or the device ID for a valid video input device, the promise
     * will reject with an error with the <code>name</code> property
     * set to <code>'OT_INVALID_VIDEO_SOURCE'</code>.
     * </li>
     *
     * <li>If the publisher does not currently use a camera input, the promise
     * will reject with an error with the <code>name</code> property
     * set to <code>'OT_SET_VIDEO_SOURCE_FAILURE'</code>.
     * </li>
     * </ul>
     *
     * @param {String} videoSourceId The device ID of a video input (camera) device.
     * @method #setVideoSource
     * @memberOf Publisher
     *
     * @see <a href="OT.html#getDevices">OT.getDevices()</a>
     * @see <a href="#getVideoSource">Publisher.getVideoSource()</a>
     * @see <a href="#cycleVideo">Publisher.cycleVideo()</a>
     *
     * @return {Promise} A promise that resolves with no value when the operation
     * completes successfully. If there is an error, the promise is rejected.
     */
    const setVideoSource = /*#__PURE__*/function () {
      var _setVideoSource = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee36(videoSourceId) {
        var invalidVideoSourceOtError, setVideoSourceOtError, isAudioOnly, deviceList, isValidVideoDeviceId;
        return _regenerator.default.wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              invalidVideoSourceOtError = otError(Errors.INVALID_VIDEO_SOURCE, new Error('Invalid video source. Video source must be a valid video input deviceId'), 1041);
              setVideoSourceOtError = otError(Errors.SET_VIDEO_SOURCE_FAILURE, new Error('You cannot reset the video source on a publisher that does not currently use a camera source.'), 1040);
              if (!(OTHelpers.env.isLegacyEdge || !windowMock.RTCRtpSender || typeof windowMock.RTCRtpSender.prototype.replaceTrack !== 'function')) {
                _context36.next = 4;
                break;
              }
              throw otError(Errors.UNSUPPORTED_BROWSER, new Error('setVideoSource is not supported in your browser.'), ExceptionCodes.UNABLE_TO_PUBLISH);
            case 4:
              if (!(typeof videoSourceId !== 'string')) {
                _context36.next = 6;
                break;
              }
              throw invalidVideoSourceOtError;
            case 6:
              // we can't use hasVideo because that only checks if the video is
              isAudioOnly = !webRTCStream || webRTCStream.getVideoTracks().length === 0;
              if (!(isCustomVideoTrack || isScreenSharing || isAudioOnly)) {
                _context36.next = 9;
                break;
              }
              throw setVideoSourceOtError;
            case 9:
              _context36.next = 11;
              return getInputMediaDevices();
            case 11:
              deviceList = _context36.sent;
              isValidVideoDeviceId = deviceList.find(device => device.kind === 'videoInput' && device.deviceId === videoSourceId);
              if (isValidVideoDeviceId) {
                _context36.next = 15;
                break;
              }
              throw invalidVideoSourceOtError;
            case 15:
              _context36.next = 17;
              return attemptToSetVideoTrack(videoSourceId);
            case 17:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
      function setVideoSource(_x30) {
        return _setVideoSource.apply(this, arguments);
      }
      return setVideoSource;
    }();
    this.setVideoSource = setVideoSource;
    const attemptToSetVideoTrack = /*#__PURE__*/function () {
      var _ref48 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee37(newVideoDeviceId) {
        var _originalVideoTrack2;
        var oldDeviceID, oldTrack, videoFilterToReapplyOnAndroid, newVideoTrack, originalVideoTrack;
        return _regenerator.default.wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              oldDeviceID = currentDeviceId;
              currentDeviceId = newVideoDeviceId;

              // We shouldn't replace the track unless the video is on
              if (properties.publishVideo) {
                _context37.next = 4;
                break;
              }
              return _context37.abrupt("return");
            case 4:
              if (!hasTrackFromDevice(newVideoDeviceId)) {
                _context37.next = 6;
                break;
              }
              return _context37.abrupt("return");
            case 6:
              oldTrack = getCurrentTrack();
              if (!(properties.publishVideo && OTHelpers.env.isAndroid && (OTHelpers.env.isChrome || OTHelpers.env.isFirefox))) {
                _context37.next = 14;
                break;
              }
              if (!currentVideoFilter) {
                _context37.next = 13;
                break;
              }
              videoFilterToReapplyOnAndroid = currentVideoFilter;
              _context37.next = 12;
              return destroyMediaProcessor();
            case 12:
              currentVideoFilter = null;
            case 13:
              if (oldTrack && oldTrack.stop) {
                oldTrack.stop();
              }
            case 14:
              _context37.prev = 14;
              _context37.next = 17;
              return getTrackFromDeviceId(newVideoDeviceId);
            case 17:
              newVideoTrack = _context37.sent;
              _context37.next = 25;
              break;
            case 20:
              _context37.prev = 20;
              _context37.t0 = _context37["catch"](14);
              currentDeviceId = oldDeviceID;
              logging.error(_context37.t0);
              throw _context37.t0;
            case 25:
              if (newVideoTrack) {
                _context37.next = 28;
                break;
              }
              logging.warn('Unable to aquire video track. Moving to next device.');
              return _context37.abrupt("return");
            case 28:
              if (!currentVideoFilter) {
                _context37.next = 33;
                break;
              }
              originalVideoTrack = mediaProcessor.getOriginalVideoTrack();
              _context37.next = 32;
              return mediaProcessor.setVideoTrack(newVideoTrack);
            case 32:
              newVideoTrack = _context37.sent;
            case 33:
              if (!_videoMediaProcessorConnector) {
                _context37.next = 38;
                break;
              }
              originalVideoTrack = _videoMediaProcessorConnector.originalTrack;
              _context37.next = 37;
              return _videoMediaProcessorConnector.setTrack(newVideoTrack);
            case 37:
              newVideoTrack = _context37.sent;
            case 38:
              _context37.next = 40;
              return replaceTrackAndUpdate(oldTrack, newVideoTrack);
            case 40:
              if (!videoFilterToReapplyOnAndroid) {
                _context37.next = 43;
                break;
              }
              _context37.next = 43;
              return _this.applyVideoFilter(videoFilterToReapplyOnAndroid);
            case 43:
              // We stop the original track as a final step because whatever effects
              // were applied to it should remain in effect until the new track is
              // set
              (_originalVideoTrack2 = originalVideoTrack) == null ? void 0 : _originalVideoTrack2.stop();
              if (properties.publishVideo) {
                isTrackManuallyStopped = false;
              }
            case 45:
            case "end":
              return _context37.stop();
          }
        }, _callee37, null, [[14, 20]]);
      }));
      return function attemptToSetVideoTrack(_x31) {
        return _ref48.apply(this, arguments);
      };
    }();

    /**
    * Returns an object containing properties defining the publisher's current
    * video source.
    *
    * @method #getVideoSource
    * @memberOf Publisher
    * @see <a href="#setVideoSource">Publisher.setVideoSource()</a>
    * @see <a href="#setVideoSource">OT.initPublisher()</a>
    *
    * @return {VideoSource} The return object has the following properties:
    *
    * <p>
    * <ul>
    *   <li><code>deviceId</code> (String | null) &mdash; The device ID.</li>
    *   <li><code>type</code> (String | null) &mdash; This is set to
    *   'camera' (for a  camera-based video), 'screen' (for a screen-sharing video),
    *   or 'custom' (for a video  with a MediaStreamTrack source). </li>
    *   <li><code>track</code> (MediaStreamTrack | null) &mdash; The
    *   MediaStreamTrack for the video.</li>
    * </ul>
    * <p>
    * Any inapplicable properties will be set to null.
    */

    this.getVideoSource = () => {
      const sourceProperties = {};
      const isAudioOnly = !webRTCStream || webRTCStream.getVideoTracks().length === 0;
      sourceProperties.track = webRTCStream && properties.publishVideo && webRTCStream.getVideoTracks()[0] || null;
      sourceProperties.deviceId = !isScreenSharing && !isCustomVideoTrack && currentDeviceId ? currentDeviceId : null;
      if (isCustomVideoTrack) {
        sourceProperties.type = 'custom';
      } else if (isScreenSharing) {
        sourceProperties.type = 'screen';
      } else if (!isAudioOnly) {
        sourceProperties.type = 'camera';
      } else {
        sourceProperties.type = null;
      }
      return sourceProperties;
    };

    // API Compatibility layer for Flash Publisher, this could do with some tidyup.

    this._ = {
      privateEvents,
      setIceConfig(newIceConfig) {
        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee38() {
          var pcs;
          return _regenerator.default.wrap(function _callee38$(_context38) {
            while (1) switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return getAllPeerConnections();
              case 2:
                pcs = _context38.sent;
                pcs.forEach(pc => pc.setIceConfig(newIceConfig));
              case 4:
              case "end":
                return _context38.stop();
            }
          }, _callee38);
        }))();
      },
      publishToSession: (session, analyticsReplacement) => {
        // Check if it is already publishing, i.e. 'PublishingToSession' or 'Publishing'
        //  - 'PublishingToSession' is the state we are establishing the Publisher with Rumor.
        //  - 'Publishing' is the state of publishing to the platform.
        const isAlreadyPublishing = state.current === 'PublishingToSession' || state.isPublishing();
        if (isAlreadyPublishing) {
          logging.warn(`This publisher is already publishing to the session. If you want to
             republish, please unpublish first.`);
          return Promise.resolve();
        }
        if (analyticsReplacement) {
          analytics = analyticsReplacement;
        }
        // Add session property to Publisher
        this.session = session;
        _session = session;
        this.streamId = (0, _uuid.default)();
        logConnectivityEvent('Attempt', {
          dataChannels: properties.channels,
          properties: (0, _whitelistPublisherProperties.default)(properties)
        });
        const loadedPromise = new Promise((resolve, reject) => {
          if (loaded) {
            resolve();
            return;
          }
          this.once('initSuccess', resolve);
          this.once('destroyed', _ref49 => {
            let reason = _ref49.reason;
            let reasonDescription = '';
            if (reason) {
              reasonDescription = ` Reason: ${reason}`;
            }
            reject(new Error(`Publisher destroyed before it finished loading.${reasonDescription}`));
          });
        });
        logging.debug('publishToSession: waiting for publishComplete, which is triggered by ' + 'stream#created from rumor');
        const checkForAndSetScalabilityMode = /*#__PURE__*/function () {
          var _ref50 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee39() {
            var scalabilityMode, codecsWhitelist, isCamera, contentHint;
            return _regenerator.default.wrap(function _callee39$(_context39) {
              while (1) switch (_context39.prev = _context39.next) {
                case 0:
                  _context39.t0 = !properties.constraints.video;
                  if (_context39.t0) {
                    _context39.next = 6;
                    break;
                  }
                  _context39.next = 4;
                  return _this._getNumEncodings();
                case 4:
                  _context39.t1 = _context39.sent;
                  _context39.t0 = _context39.t1 <= 1;
                case 6:
                  if (!_context39.t0) {
                    _context39.next = 8;
                    break;
                  }
                  return _context39.abrupt("return");
                case 8:
                  codecsWhitelist = ['VP9'];
                  isCamera = !isScreenSharing && !isCustomVideoTrack;
                  if (isCamera) {
                    scalabilityMode = 'L3T3';
                  } else if (properties._setDefaultScalabilityMode && isScreenSharing) {
                    // When using private API, and screenSharing, rely on content hint.
                    contentHint = _this.getVideoContentHint();
                    scalabilityMode = (0, _getScalabilityModeFromContentHint.default)(contentHint);
                  }
                  if (scalabilityMode) {
                    _this._setScalabilityMode(scalabilityMode, codecsWhitelist);
                  }
                case 12:
                case "end":
                  return _context39.stop();
              }
            }, _callee39);
          }));
          return function checkForAndSetScalabilityMode() {
            return _ref50.apply(this, arguments);
          };
        }();
        const completedPromise = new Promise((resolve, reject) => {
          this.once('publishComplete', error => {
            if (error) {
              reject(error);
              return;
            }
            this._setScalableFramerates(properties.scalableFramerates);
            this._setScalableVideoLayers(properties.scalableVideoLayers);
            checkForAndSetScalabilityMode();

            // See OPENTOK-45935
            // Some users reuse the publisher when disconnecting and reconnecting
            // to a session. This re-synchronizes the state of the stream channels.
            if (this.stream) {
              this.stream.setChannelActiveState({
                channelType: 'audio',
                activeState: hasAudio()
              });
              this.stream.setChannelActiveState({
                channelType: 'video',
                activeState: hasVideo()
              });
            }
            logging.debug('publishToSession: got publishComplete');
            resolve();
          });
        });
        const processMessagingError = error => {
          const publicError = (0, _createStreamErrorMap.default)(error);
          logConnectivityEvent('Failure', {}, {
            failureReason: 'Publish',
            failureCode: publicError.code,
            failureMessage: publicError.message
          });
          if (state.isAttemptingToPublish()) {
            this.trigger('publishComplete', publicError);
          }
          OTErrorClass.handleJsException({
            errorMsg: error.message,
            code: publicError.code,
            target: this,
            error,
            analytics
          });
          throw publicError;
        };
        logging.debug('publishToSession: waiting for loaded');
        const streamCreatedPromise = loadedPromise.then(() => session._.getVideoCodecsCompatible(webRTCStream)).then(videoCodecsCompatible => {
          logging.debug('publishToSession: loaded');
          // Bail if this.session is gone, it means we were unpublished
          // before createStream could finish.
          if (!this.session) {
            return undefined;
          }

          // make sure we trigger an error if we are not getting any "ack" after a reasonable
          // amount of time
          const publishGuardingTo = setTimeout(() => {
            onPublishingTimeout(session);
          }, PUBLISH_MAX_DELAY);
          this.once('publishComplete', () => {
            clearTimeout(publishGuardingTo);
          });
          state.set('PublishingToSession');
          const video = videoCodecsCompatible && widgetView && widgetView.video();
          const hasVideoTrack = webRTCStream.getVideoTracks().length > 0;
          const didRequestVideo = properties.videoSource !== null && properties.videoSource !== false;
          if (video && hasVideoTrack && didRequestVideo) {
            streamChannels.push(new StreamChannel({
              id: 'video1',
              type: 'video',
              active: properties.publishVideo,
              orientation: VideoOrientation.ROTATED_NORMAL,
              frameRate: properties.frameRate,
              width: this.videoWidth(),
              height: this.videoHeight(),
              e2ee: session._.isE2ee(),
              source: (() => {
                if (isScreenSharing) {
                  return 'screen';
                }
                if (isCustomVideoTrack) {
                  return 'custom';
                }
                return 'camera';
              })(),
              fitMode: properties.fitMode
            }));
          }
          const hasAudioTrack = webRTCStream.getAudioTracks().length > 0;
          const didRequestAudio = properties.audioSource !== null && properties.audioSource !== false;

          // @todo should we just use hasAudioTrack here? if hasAudioTrack is true
          // then does it matter if didRequestAudio is false? we still have an audio
          // track for some reason!

          if (didRequestAudio && hasAudioTrack) {
            streamChannels.push(new StreamChannel({
              id: 'audio1',
              type: 'audio',
              active: properties.publishAudio
            }));
            streamChannels.push(new StreamChannel({
              id: 'caption1',
              type: 'data',
              active: properties.publishCaptions
            }));
          }
          if (_enableSenderStats) {
            streamChannels.push(new StreamChannel({
              id: 'downlinkStats1',
              type: 'data',
              active: true
            }));
          }
          // privately expose the publisher stream channels for testing purposes
          this._.streamChannels = streamChannels;
          logging.debug('publishToSession: creating rumor stream id');
          return new Promise((resolve, reject) => {
            _createStream(null, (messagingError, streamId, message) => {
              if (messagingError) {
                reject(processMessagingError(messagingError));
                return;
              }
              resolve({
                streamId,
                message
              });
            });
          });
        }).then(maybeStream => {
          if (maybeStream === undefined) {
            return;
          }
          const streamId = maybeStream.streamId,
            message = maybeStream.message;
          logging.debug('publishToSession: rumor stream id created:', streamId, '(this is different from stream#created, which requires media to actually be ' + 'flowing for mantis sessions)');
          if (streamId !== this.streamId) {
            throw new Error('streamId response does not match request');
          }
          this.streamId = streamId;
          rumorIceServers = parseIceServers(message);
        }).catch(err => {
          this.trigger('publishComplete', err);
          throw err;
        });
        return Promise.all([streamCreatedPromise, completedPromise]);
      },
      unpublishFromSession: (session, reason) => {
        if (!this.session || session.id !== this.session.id) {
          if (reason === 'unpublished') {
            const selfSessionText = this.session && this.session.id || 'no session';
            logging.warn(`The publisher ${guid} is trying to unpublish from a session ${session.id} it is not ` + `attached to (it is attached to ${selfSessionText})`);
          }
          return this;
        }
        if (session.isConnected() && (this.stream || state.isAttemptingToPublish())) {
          session._.streamDestroy(this.streamId);
        }
        streamCleanupJobs.releaseAll();

        // Disconnect immediately, rather than wait for the WebSocket to
        // reply to our destroyStream message.
        this.disconnect();
        if (state.isAttemptingToPublish()) {
          logConnectivityEvent('Cancel', {
            reason: 'unpublish'
          });
          const createErrorFromReason = () => {
            switch (reason) {
              case 'mediaStopped':
                return 'The video element fired the ended event, indicating there is an issue with the media';
              case 'unpublished':
                return 'The publisher was unpublished before it could be published';
              case 'reset':
                return 'The publisher was reset';
              default:
                return `The publisher was destroyed due to ${reason}`;
            }
          };
          const err = new Error(createErrorFromReason());
          this.trigger('publishComplete', otError(reason === 'mediaStopped' ? Errors.MEDIA_ENDED : Errors.CANCEL, err));
        }
        this.session = null;
        logAnalyticsEvent('unpublish', 'Success');
        this._.streamDestroyed(reason);
        return this;
      },
      unpublishStreamFromSession: (stream, session, reason) => {
        if (stream.id !== this.streamId) {
          logging.warn(`The publisher ${guid} is trying to destroy a stream ${stream.id} that is not attached to it`);
          return this;
        }
        return this._.unpublishFromSession(session, reason);
      },
      startMigration: function () {
        var _startMigration = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee40() {
          var _this$session7, _this$session7$sessio;
          var relayedPeerConnection, onCreateStreamError;
          return _regenerator.default.wrap(function _callee40$(_context40) {
            while (1) switch (_context40.prev = _context40.next) {
              case 0:
                state.set('Migrating');
                logAnalyticsEvent('Migrate', 'Attempt');
                startMigrationTimeout();

                // Update sender method in P2P PC because it needs to use the new Rumor. No need for
                // Mantis PC since a new PC will be created.
                _context40.next = 5;
                return getP2pPeerConnection();
              case 5:
                relayedPeerConnection = _context40.sent;
                relayedPeerConnection == null ? void 0 : relayedPeerConnection.setSendMessage(createSendMessage('P2P'));
                onCreateStreamError = error => {
                  if (error) {
                    throw new Error(error);
                  }
                };
                if (!((_this$session7 = _this.session) != null && (_this$session7$sessio = _this$session7.sessionInfo) != null && _this$session7$sessio.p2pEnabled)) {
                  _context40.next = 12;
                  break;
                }
                _createStream('P2P', onCreateStreamError);
                _context40.next = 16;
                break;
              case 12:
                _context40.next = 14;
                return getMantisPeerConnection();
              case 14:
                _previousPeerConnection = _context40.sent;
                _createStream('MANTIS', onCreateStreamError);
              case 16:
              case "end":
                return _context40.stop();
            }
          }, _callee40);
        }));
        function startMigration() {
          return _startMigration.apply(this, arguments);
        }
        return startMigration;
      }(),
      finishMigration: () => {
        clearTimeout(_migrationTimeoutId);
        const destroyPeerConnection = pc => {
          if (pc) {
            const _getPeerConnectionMet7 = getPeerConnectionMeta(pc),
              peerConnectionId = _getPeerConnectionMet7.peerConnectionId;
            delete peerConnectionsAsync[peerConnectionId];
            pc.off('iceConnectionStateChange');
            pc.destroy();
          }
        };

        // Clear previous PC
        destroyPeerConnection(_previousPeerConnection);
        _previousPeerConnection = null;

        // In case we don't transition to P2P after migration, clear P2P leg.
        if (this.session.sessionInfo.isAdaptiveEnabled && activeSourceStreamId === 'MANTIS') {
          var _getP2pPeerConnection;
          (_getP2pPeerConnection = getP2pPeerConnection()) == null ? void 0 : _getP2pPeerConnection.then(destroyPeerConnection);
        }
        state.set('Publishing');
        logAnalyticsEvent('Migrate', 'Success');
      },
      streamDestroyed: reason => {
        if (['reset'].indexOf(reason) < 0) {
          // We're back to being a stand-alone publisher again.
          if (!state.isDestroyed()) {
            state.set('MediaBound');
          }
        }
        const event = new Events.StreamEvent('streamDestroyed', this.stream, reason, true);
        this.dispatchEventOnce(event, this.streamId);
        if (!event.isDefaultPrevented()) {
          this.destroy();
        }
        this.streamId = null;
      },
      archivingStatus(status) {
        if (chromeMixin) {
          chromeMixin.setArchivingStatus(status);
        }
        return status;
      },
      webRtcStream() {
        return webRTCStream;
      },
      switchTracks() {
        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee41() {
          var stream;
          return _regenerator.default.wrap(function _callee41$(_context41) {
            while (1) switch (_context41.prev = _context41.next) {
              case 0:
                _context41.prev = 0;
                _context41.next = 3;
                return getUserMedia().catch(userMediaError);
              case 3:
                stream = _context41.sent;
                _context41.next = 10;
                break;
              case 6:
                _context41.prev = 6;
                _context41.t0 = _context41["catch"](0);
                logging.error(`OT.Publisher.switchTracks failed to getUserMedia: ${_context41.t0}`);
                throw _context41.t0;
              case 10:
                setNewStream(stream);
                _context41.prev = 11;
                bindVideo();
                _context41.next = 21;
                break;
              case 15:
                _context41.prev = 15;
                _context41.t1 = _context41["catch"](11);
                if (!(_context41.t1 instanceof _cancel.CancellationError)) {
                  _context41.next = 19;
                  break;
                }
                return _context41.abrupt("return");
              case 19:
                logging.error('Error while binding video', _context41.t1);
                throw _context41.t1;
              case 21:
                _context41.prev = 21;
                replaceTracks();
                _context41.next = 29;
                break;
              case 25:
                _context41.prev = 25;
                _context41.t2 = _context41["catch"](21);
                logging.error('Error replacing tracks', _context41.t2);
                throw _context41.t2;
              case 29:
              case "end":
                return _context41.stop();
            }
          }, _callee41, null, [[0, 6], [11, 15], [21, 25]]);
        }))();
      },
      getDataChannel(label, getOptions, completion) {
        const pc = getPeerConnectionById(Object.keys(peerConnectionsAsync)[0]);

        // @fixme this will fail if it's called before we have a PublisherPeerConnection.
        // I.e. before we have a subscriber.
        if (!pc) {
          completion(new OTHelpers.Error('Cannot create a DataChannel before there is a subscriber.'));
          return;
        }
        pc.then(peerConnection => {
          peerConnection.getDataChannel(label, getOptions, completion);
        });
      },
      iceRestart(forcedRestart) {
        if (forcedRestart === void 0) {
          forcedRestart = false;
        }
        getAllPeerConnections().then(peerConnections => {
          peerConnections.forEach(peerConnection => {
            const _getPeerConnectionMet8 = getPeerConnectionMeta(peerConnection),
              remoteConnectionId = _getPeerConnectionMet8.remoteConnectionId;
            logRepublish('Attempt', {
              remoteConnectionId
            });
            logging.debug('Publisher: ice restart attempt');
            peerConnection.iceRestart();
            if (forcedRestart) {
              peerConnection.generateOffer();
            }
          });
        });
      },
      getState() {
        return state;
      },
      demoOnlyCycleVideo: this.cycleVideo,
      testOnlyGetFramesEncoded() {
        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee42() {
          var peerConnections;
          return _regenerator.default.wrap(function _callee42$(_context42) {
            while (1) switch (_context42.prev = _context42.next) {
              case 0:
                _context42.next = 2;
                return getAllPeerConnections();
              case 2:
                peerConnections = _context42.sent;
                if (peerConnections.length) {
                  _context42.next = 5;
                  break;
                }
                throw new Error('No established PeerConnections yet');
              case 5:
                return _context42.abrupt("return", peerConnections[0]._testOnlyGetFramesEncoded());
              case 6:
              case "end":
                return _context42.stop();
            }
          }, _callee42);
        }))();
      },
      onStreamAvailable,
      startRoutedToRelayedTransition: () => {
        amrState.startTransitionToRelayed();
        _transitionRoutedToRelayed();
      },
      startRelayedToRoutedTransition: () => {
        amrState.startTransitionToRouted(_transitionRelayedToRouted);
      },
      forceMuteAudio: function () {
        logAnalyticsEvent('publishAudio', 'Attempt', {
          publishAudio: false
        });
        properties.publishAudio = false;
        try {
          updateAudio('auto');
          this.dispatchEvent(new Events.MuteForcedEvent());
          logAnalyticsEvent('publishAudio', 'Success', {
            publishAudio: false
          });
        } catch (e) {
          logAnalyticsEvent('publishAudio', 'Failure', {
            message: e.message
          });
        }
      }.bind(this),
      setCongestionLevel: function () {
        var _setCongestionLevel = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee43(level, peerId) {
          var pcs;
          return _regenerator.default.wrap(function _callee43$(_context43) {
            while (1) switch (_context43.prev = _context43.next) {
              case 0:
                if (!audioFallbackCoordinator) {
                  _context43.next = 15;
                  break;
                }
                if (!peerId) {
                  _context43.next = 8;
                  break;
                }
                _context43.next = 4;
                return getPeerConnectionById(peerId);
              case 4:
                _context43.t1 = _context43.sent;
                _context43.t0 = [_context43.t1];
                _context43.next = 11;
                break;
              case 8:
                _context43.next = 10;
                return getAllPeerConnections();
              case 10:
                _context43.t0 = _context43.sent;
              case 11:
                pcs = _context43.t0;
                pcs.forEach(pc => {
                  pc.setCongestionLevel(level);
                });
                _context43.next = 16;
                break;
              case 15:
                logging.warn('Audio Fallback is not enabled');
              case 16:
              case "end":
                return _context43.stop();
            }
          }, _callee43);
        }));
        function setCongestionLevel(_x32, _x33) {
          return _setCongestionLevel.apply(this, arguments);
        }
        return setCongestionLevel;
      }()
    };
    this.detectDevices = function () {
      logging.warn('Publisher.detectDevices() is not implemented.');
    };
    this.detectMicActivity = function () {
      logging.warn('Publisher.detectMicActivity() is not implemented.');
    };
    this.getEchoCancellationMode = function () {
      logging.warn('Publisher.getEchoCancellationMode() is not implemented.');
      return 'fullDuplex';
    };
    this.setMicrophoneGain = function () {
      logging.warn('Publisher.setMicrophoneGain() is not implemented.');
    };
    this.getMicrophoneGain = function () {
      logging.warn('Publisher.getMicrophoneGain() is not implemented.');
      return 0.5;
    };
    this.setCamera = function () {
      logging.warn('Publisher.setCamera() is not implemented.');
    };
    this.setMicrophone = function () {
      logging.warn('Publisher.setMicrophone() is not implemented.');
    };

    // Platform methods:

    this.guid = function () {
      return guid;
    };
    this.videoElement = function () {
      const video = widgetView && widgetView.video();
      return video ? video.domElement() : null;
    };
    this.setStream = assignStream;
    this.isWebRTC = true;
    this.isLoading = function () {
      return widgetView && widgetView.loading();
    };

    /**
    * Returns the width, in pixels, of the Publisher video. This may differ from the
    * <code>resolution</code> property passed in as the <code>properties</code> property
    * the options passed into the <code>OT.initPublisher()</code> method, if the browser
    * does not support the requested resolution.
    *
    * @method #videoWidth
    * @memberOf Publisher
    * @return {Number} the width, in pixels, of the Publisher video.
    */
    this.videoWidth = () => getVideoDimensions().width;

    /**
    * Returns the height, in pixels, of the Publisher video. This may differ from the
    * <code>resolution</code> property passed in as the <code>properties</code> property
    * the options passed into the <code>OT.initPublisher()</code> method, if the browser
    * does not support the requested resolution.
    *
    * @method #videoHeight
    * @memberOf Publisher
    * @return {Number} the height, in pixels, of the Publisher video.
    */
    this.videoHeight = () => getVideoDimensions().height;

    /**
    *  Returns the details on the publisher's stream quality, including the following:
    *
    * <ul>
    *
    *   <li>The total number of audio and video packets lost</li>
    *   <li>The total number of audio and video packets sent</li>
    *   <li>The total number of audio and video bytes sent</li>
    *   <li>The current average video frame rate</li>
    *
    * </ul>
    *
    * You can use these stats to assess the quality of the publisher's audio-video stream.
    *
    * @param {Function} completionHandler A function that takes the following
    * parameters:
    *
    * <ul>
    *
    *   <li><code>error</code> (<a href="Error.html">Error</a>) &mdash; Upon successful completion
    *   the method, this is undefined. An error results if the publisher is not connected to a
    *   session or if it is not publishing audio or video.</li>
    *
    *   <li><code>statsArray</code> (Array) &mdash; An array of objects defining the current
    *   audio-video statistics for the publisher. For a publisher in a routed session (one that
    *   uses the <a href="https://tokbox.com/developer/guides/create-session/#media-mode">Vonage Video API
    *   Media Router</a>), this array includes one object, defining the statistics for the single
    *   audio-media stream that is sent to the Vonage Video API Media Router. In a relayed session, the
    *   array includes an object for each subscriber to the published stream. Each object in the
    *   array contains a <code>stats</code> property that includes the following properties:
    *
    *     <p>
    *     <ul>
    *       <li><code>audio.bytesSent</code> (Number) &mdash; The total number of audio bytes
    *         sent to the subscriber (or to the Vonage Video API Media Router)</li>
    *
    *       <li><code>audio.packetsLost</code> (Number) &mdash; The total number audio packets
    *        that did not reach the subscriber (or to the Vonage Video API Media Router)</li>
    *
    *       <li><code>audio.packetsSent</code> (Number) &mdash; The total number of audio
    *        packets sent to the subscriber (or to the Vonage Video API Media Router)</li>
    *
    *       <li><code>timestamp</code> (Number) &mdash; The timestamp, in milliseconds since
    *         the Unix epoch, for when these stats were gathered</li>
    *
    *       <li><code>video.bytesSent</code> (Number) &mdash; The total video bytes sent to
    *         the subscriber (or to the Vonage Video API Media Router)</li>
    *
    *       <li><code>video.packetsLost</code> (Number) &mdash; The total number of video packets
    *         that did not reach the subscriber (or to the Vonage Video API Media Router)</li>
    *
    *       <li><code>video.packetsSent</code> (Number) &mdash; The total number of video
    *         packets sent to the subscriber</li>
    *
    *       <li><code>video.frameRate</code> (Number) &mdash; The current average video frame rate</li>
    *     </ul>
    *
    *     <p>Additionally, for a publisher in a relayed session, each object in the array contains
    *     the following two properties:
    *
    *     <ul>
    *       <li><code>connectionId</code> (String) &mdash; The unique ID of the client's
    *       connection, which matches the <code>id</code> property of the <code>connection</code>
    *       property of the <a href="Session.html#.event:connectionCreated">connectionCreated</a>
    *       event that the Session object dispatched for the remote client.</li>
    *
    *       <li><code>subscriberId</code> (String) &mdash; The unique ID of the subscriber, which
    *       matches the <code>id</code> property of the Subscriber object in the subscribing
    *       client's app.</li>
    *     </ul>
    *
    *     <p>These two properties are undefined for a publisher in a routed session.
    *
    *   </li>
    * </ul>
    *
    * @see <a href="Subscriber.html#getStats">Subscriber.getStats()</a>
    * @see <a href="#getRtcStatsReport">Publisher.getRtcStatsReport()</a>
    *
    * @method #getStats
    * @memberOf Publisher
    */
    this.getStats = function getStats(callback) {
      _getStats((err, stats) => {
        if (err) {
          callback(err);
        } else {
          callback(null, stats);
        }
      });
    };

    /**
    * Returns a promise that, on success, resolves with an array of objects that include
    * RTCStatsReport properties for the published stream. (See
    * <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport" target="_blank">
    * RTCStatsReport</a>.)
    *
    * <p>
    * For a publisher in a routed session (one that uses the
    * <a href="https://tokbox.com/developer/guides/create-session/#media-mode">Vonage Video API
    * Media Router</a>), this array includes one object, defining the statistics for the single
    * audio-media stream that is sent to the Vonage Video API Media Router. In a relayed session, the
    * array includes an object for each subscriber to the published stream. Each object in the
    * array contains an <code>rtcStatsReport</code> property that is a RTCStatsReport object.
    *
    * <p>
    * Additionally, for a publisher in a relayed session, each object in the array contains
    * the following two properties:
    *
    *     <ul>
    *
    *       <li><code>connectionId</code> (String) &mdash; The unique ID of the client's
    *       connection, which matches the <code>id</code> property of the <code>connection</code>
    *       property of the <a href="Session.html#.event:connectionCreated">connectionCreated</a>
    *       event that the Session object dispatched for the remote client.</li>
    *
    *       <li><code>subscriberId</code> (String) &mdash; The unique ID of the subscriber, which
    *       matches the <code>id</code> property of the Subscriber object in the subscribing
    *       client's app.</li>
    *
    *     </ul>
    *
    * <p>
    * These two properties are undefined for a publisher in a routed session.
    *
    * <p>
    * The Promise will be rejected in the following conditions:
    * <ul>
    *   <li>
    *     The browser does not support this method (for example, in Chrome version 57 and lower,
    *     which does not support the <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats" target="_blank">
    *     RTCPeerConnection.getStats()</a> standard).
    *   </li>
    *   <li>
    *     The <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection" target="_blank">
    *     PeerConnection</a> for the Publisher is not connected.
    *   </li>
    *  </ul>
    * </p>
    *
    * @method #getRtcStatsReport
    * @memberOf Publisher
    *
    * @see <a href="Subscriber.html#getRtcStatsReport">Subscriber.getRtcStatsReport()</a>
    *
    * @return {Promise} A promise that resolves when the operation completes successfully.
    * If there is an error, the promise is rejected.
    */
    this.getRtcStatsReport = () => new Promise((resolve, reject) => {
      _getRtcStatsReport((err, stats) => {
        if (err) {
          reject(err);
        } else {
          resolve(stats);
        }
      });
    });

    // Make read-only: element, guid, _.webRtcStream

    state = new PublishingState(stateChangeFailed);
    this.accessAllowed = false;

    /**
     * Applies a video filter for the publisher. You can apply a background blur filter.  A
     * publisher can have only one (or zero) applied at one time.  When you set a new
     * filter, a previously set filter is removed.
     *
     * <p>
     * This method is incompatible with the
     * <a href="Publisher.html#setVideoMediaProcessorConnector">Publisher.setVideoMediaProcessorConnector()</a>
     * method. Calling this method after <code>Publisher.setVideoMediaProcessorConnector(connector)</code>
     * returns a promise that is rejected with an error, with the <code>name</code> property of the error
     * set to <code>'OT_NOT_SUPPORTED'</code>. You can remove the connector by calling
     * <code>Publisher.setVideoMediaProcessorConnector(null)</code>.
     * </p>
     *
     * <p>
     * <em>Note:</em> Video filters are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     * </p>
     *
     * <p>
     * <b>Important:</b> Video filters require adequate processor support.
     * Even in supported browsers, transformers may not be stable when background
     * processes limit available processing resources. See
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/js/#client-requirements">Client requirements</a>.
     * </p>
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     The browser does not support this method.
     *   </li>
     *   <li>
     *     The publisher is not using a supported video source. (The <code>videoSource</code>
     *     option of the <a href="OT.html#initPublisher">OT.initPublisher()</a> method was
     *     set to <code>null</code>, <code>false</code>, or
     *     <code>"screen"</code>).
     *   </li>
     *   <li>
     *     A custom filter is already being used via the <code>Publisher.setVideoMediaProcessorConnector()</code> method.
     *   </li>
     *   <li>
     *     There are no video input devices (cameras) available.
     *   </li>
     *   <li>
     *     There was an error acquiring video from the video input device.
     *   </li>
     *   <li>
     *     There was an error applying the transformation filter.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can also set the initial video filter by setting a <code>videoFilter</code> option
     * when calling <a href="OT.html#initPublisher">OT.initPublisher()</a>.
     *
     * @param {Object} videoFilter An object defining the video filter to be applied. The following
     * filters are supported:
     * <ul>
     *   <li>
     *     <p>
     *     <em>Background blur filter:</em> &mdash; Set the <code>type</code> property of the object to
     *     <code>"backgroundBlur"</code>.
     *     <p>
     *     A background blur filter object includes an additional <code>blurStrength</code> property, which
     *     defines the blur radius and is optional. Set this to either <code>"low"</code> or
     *     <code>"high"</code> (the default).
     *   </li>
     *   <li>
     *     <p>
     *     <em>Background replacement filter</em> &mdash; Set the <code>type</code> property of the object to
     *     <code>"backgroundReplacement"</code>.
     *     <p>
     *     A background replacement filter object includes an additional <code>backgroundImgUrl</code> property,
     *     which defines the URL of the background image to use. Also accepted are image BLOBs
     *     (a Base64-encoded string of image data).
     *     The following image formats are supported: BMP, PNG, JPEG, and GIF.
     *     <p>
     *     <p>
     *       The background image is resized to match the dimensions of the publisher's video.
     *       For best results, use an image that has the same dimensions (or at least the same
     *       aspect ratio) as the published video. Set the <code>mirror</code> option to
     *       <code>false</code> when calling the <code>OT.initPublisher()</code> method to have
     *       the background image appear in the correct orientation (not mirrored) in
     *       the publisher's page.
     *     </p>
     *   </li>
     * </ul>
     *
     * @method #applyVideoFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#getVideoFilter">Publisher.getVideoFilter()</a>
     * @see <a href="Publisher.html#clearVideoFilter">Publisher.clearVideoFilter()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no new video filter is set.
     */
    this.applyVideoFilter = /*#__PURE__*/function () {
      var _ref51 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee44(videoFilter) {
        var sanitizedVideoFilter, isSupported, message, _webRTCStream$getVide2, originalVideoTrack, filteredVideoTrack;
        return _regenerator.default.wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              sanitizedVideoFilter = (0, _sanitizeVideoFilter.default)(videoFilter);
              logAnalyticsEvent('applyVideoFilter', 'Attempt', {
                videoFilter: sanitizedVideoFilter
              });
              _context44.prev = 2;
              if (!_videoMediaProcessorConnector) {
                _context44.next = 5;
                break;
              }
              throw otError(Errors.NOT_SUPPORTED, new Error('Cannot apply video filter when videoMediaProcessorConnector is set.'));
            case 5:
              isSupported = MediaProcessor.isSupported();
              if (isSupported) {
                _context44.next = 8;
                break;
              }
              throw otError(Errors.NOT_SUPPORTED, new Error('Browser does not support video filters (Insertable Streams and Worker APIs are required)'));
            case 8:
              if (mediaProcessor.isValidVideoFilter(videoFilter)) {
                _context44.next = 10;
                break;
              }
              throw otError(Errors.INVALID_PARAMETER, new Error('Video filter has invalid configuration'));
            case 10:
              if (webRTCStream) {
                _context44.next = 15;
                break;
              }
              message = 'Ignoring. No mediaStream';
              logAnalyticsEvent('applyVideoFilter', 'Failure', {
                message
              });
              logging.warn(message);
              return _context44.abrupt("return");
            case 15:
              if (!isScreenSharing) {
                _context44.next = 17;
                break;
              }
              throw otError(Errors.INVALID_PARAMETER, new Error('Video filters can not be applied to screen share'));
            case 17:
              enableMediaProcessorLogging();
              if (properties.publishVideo) {
                _context44.next = 22;
                break;
              }
              currentVideoFilter = videoFilter;
              logAnalyticsEvent('applyVideoFilter', 'Success', {
                videoFilter: sanitizedVideoFilter
              });
              return _context44.abrupt("return");
            case 22:
              if (!mediaProcessor.getVideoFilter()) {
                _context44.next = 37;
                break;
              }
              if (!mediaProcessor.canUpdateVideoFilter(videoFilter.type)) {
                _context44.next = 35;
                break;
              }
              _context44.prev = 24;
              _context44.next = 27;
              return mediaProcessor.updateVideoFilter(videoFilter);
            case 27:
              currentVideoFilter = videoFilter;
              logAnalyticsEvent('applyVideoFilter', 'Success', {
                videoFilter: sanitizedVideoFilter
              });
              return _context44.abrupt("return");
            case 32:
              _context44.prev = 32;
              _context44.t0 = _context44["catch"](24);
              logging.warn(`Error updating video filter: ${_context44.t0}`);
            case 35:
              _context44.next = 37;
              return _this.clearVideoFilter();
            case 37:
              _webRTCStream$getVide2 = webRTCStream.getVideoTracks(), originalVideoTrack = _webRTCStream$getVide2[0];
              if (originalVideoTrack) {
                _context44.next = 43;
                break;
              }
              message = 'Ignoring. No video';
              logAnalyticsEvent('applyVideoFilter', 'Failure', {
                message
              });
              logging.warn(message);
              return _context44.abrupt("return");
            case 43:
              _context44.next = 45;
              return mediaProcessor.setVideoFilter(videoFilter);
            case 45:
              _context44.next = 47;
              return mediaProcessor.setMediaStream(webRTCStream);
            case 47:
              filteredVideoTrack = _context44.sent;
              if (!filteredVideoTrack) {
                _context44.next = 51;
                break;
              }
              _context44.next = 51;
              return replaceTrackAndUpdate(originalVideoTrack, filteredVideoTrack);
            case 51:
              _context44.next = 58;
              break;
            case 53:
              _context44.prev = 53;
              _context44.t1 = _context44["catch"](2);
              logging.error(`Error applying video filter: ${_context44.t1}`);
              logAnalyticsEvent('applyVideoFilter', 'Failure', {
                message: _context44.t1.message
              });
              throw _context44.t1;
            case 58:
              currentVideoFilter = videoFilter;
              logAnalyticsEvent('applyVideoFilter', 'Success', {
                videoFilter: sanitizedVideoFilter
              });
            case 60:
            case "end":
              return _context44.stop();
          }
        }, _callee44, null, [[2, 53], [24, 32]]);
      }));
      return function (_x34) {
        return _ref51.apply(this, arguments);
      };
    }();

    /**
     * Returns the video filter applied used by the publisher.
     *
     * @method #getVideoFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
     * @see <a href="Publisher.html#clearVideoFilter">Publisher.clearVideoFilter()</a>
     *
     * @return {Object} The video filter being applied to the video input source used by the publisher.
     * Check the <code>type</code> property of the object to see the video filter type. The following
     * filters are supported:
     *   <ul>
     *     <li><em>Background blur filter</em> &mdash; The <code>type</code> property of the object
     *       is set to <code>"backgroundBlur"</code>. A background blur
     *       filter object includes an additional <code>blurStrength</code> property, which
     *       defines the blur radius, set to either <code>"low"</code> or <code>"high"</code>.
     *     </li>
     *     <li><em>Background replacement filter</em> &mdash; The <code>type</code> type property
     *        of the object is set to <code>"backgroundReplacement"</code>.
     *       A background replacement filter object includes an additional <code>backgroundImgUrl</code>
     *       property, which defines the URL of the background image to use.
     *     </li>
     *   </ul>
     */
    this.getVideoFilter = () => {
      logAnalyticsEvent('getVideoFilter', 'Attempt');
      logAnalyticsEvent('getVideoFilter', 'Success');
      return currentVideoFilter || null;
    };

    /**
     * Applies an audio filter for the publisher. In the current version, you can only apply an advanced noise suppression filter. A
     * publisher can have only one (or zero) filters applied at one time.  When you set a new
     * filter, any previously set filter is removed.
     *
     * <p>
     * This method is incompatible with the
     * <a href="Publisher.html#setAudioMediaProccessorConnector">Publisher.setAudioMediaProccessorConnector()</a>
     * method. Calling this method after <code>Publisher.setAudioMediaProccessorConnector(connector)</code>
     * returns a promise that is rejected with an error, with the <code>name</code> property of the error
     * set to <code>'OT_NOT_SUPPORTED'</code>. You can remove the connector by calling
     * <code>Publisher.setAudioMediaProccessorConnector(null)</code>.
     * </p>
     *
     * <p>
     * <em>Note:</em> Audio filters are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     * </p>
     *
     * <p>
     * <b>Important:</b> Audio filters require adequate processor support.
     * Even in supported browsers, transformers may not be stable when background
     * processes limit available processing resources. See
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/js/#client-requirements">Client requirements</a>.
     * </p>
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     The browser does not support this method.
     *   </li>
     *   <li>
     *     A custom filter is already being used via the <code>Publisher.setAudioMediaProcessorConnector()</code> method.
     *   </li>
     *   <li>
     *     There was an error applying the transformation filter.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can also set the initial audio filter by setting a <code>audioFilter</code> option
     * when calling <a href="OT.html#initPublisher">OT.initPublisher()</a>.
     *
     * @param {Object} audioFilter An object defining the audio filter to be applied. The following
     * filters are supported:
     * <ul>
     *   <li>
     *     <p>
     *     <em>Advanced noise suppression filter</em> &mdash; Set the <code>type</code> property of the object to
     *     <code>"advancedNoiseSuppression"</code>.
     *     </p>
     *   </li>
     * </ul>
     *
     * @method #applyAudioFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#getAudioFilter">Publisher.getAudioFilter()</a>
     * @see <a href="Publisher.html#clearAudioFilter">Publisher.clearAudioFilter()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no new video filter is set.
     */
    this.applyAudioFilter = /*#__PURE__*/function () {
      var _ref52 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee45(audioFilter) {
        var isSupported, message, _getNoiseSuppressionC, assetsDirBaseUrl, vonageNoiseSuppression, noiseSuppressionConnector;
        return _regenerator.default.wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              logAnalyticsEvent('applyAudioFilter', 'Attempt', {
                audioFilter
              });
              isSupported = MediaProcessor.isSupported();
              if (isSupported) {
                _context45.next = 4;
                break;
              }
              throw otError(Errors.NOT_SUPPORTED, new Error('Browser does not support audio filters (Insertable Streams and Worker APIs are required)'));
            case 4:
              if ((0, _isValidAudioFilter.default)(audioFilter)) {
                _context45.next = 6;
                break;
              }
              throw otError(Errors.INVALID_PARAMETER, new Error('Audio filter has invalid configuration'));
            case 6:
              if (!_audioMediaProcessorConnector) {
                _context45.next = 8;
                break;
              }
              throw otError(Errors.NOT_SUPPORTED, new Error('Cannot apply audio filter when audioMediaProcessorConnector is set.'));
            case 8:
              if (webRTCStream) {
                _context45.next = 13;
                break;
              }
              message = 'Ignoring. No mediaStream';
              logAnalyticsEvent('applyAudioFilter', 'Failure', {
                message
              });
              logging.warn(message);
              return _context45.abrupt("return");
            case 13:
              if (properties.publishAudio) {
                _context45.next = 17;
                break;
              }
              currentAudioFilter = audioFilter;
              logAnalyticsEvent('applyAudioFilter', 'Success', {
                audioFilter
              });
              return _context45.abrupt("return");
            case 17:
              if (!_this.getAudioFilter()) {
                _context45.next = 20;
                break;
              }
              _context45.next = 20;
              return _this.clearAudioFilter();
            case 20:
              _context45.prev = 20;
              if (!(audioFilter.type === 'advancedNoiseSuppression')) {
                _context45.next = 32;
                break;
              }
              _getNoiseSuppressionC = (0, _getDefaultConfig.default)({
                proxyUrl: (0, _proxyUrl.getProxyUrl)()
              }), assetsDirBaseUrl = _getNoiseSuppressionC.assetsDirBaseUrl;
              vonageNoiseSuppression = createVonageNoiseSuppression();
              _context45.next = 26;
              return vonageNoiseSuppression.init({
                assetsDirBaseUrl
              });
            case 26:
              _context45.next = 28;
              return vonageNoiseSuppression.getConnector();
            case 28:
              noiseSuppressionConnector = _context45.sent;
              _context45.next = 31;
              return _setAudioMediaProcessorConnector(noiseSuppressionConnector);
            case 31:
              currentAudioFilter = audioFilter;
            case 32:
              _context45.next = 39;
              break;
            case 34:
              _context45.prev = 34;
              _context45.t0 = _context45["catch"](20);
              logging.error(`Error applying audio filter: ${_context45.t0}`);
              logAnalyticsEvent('applyAudioFilter', 'Failure', {
                message: _context45.t0.message
              });
              throw _context45.t0;
            case 39:
              logAnalyticsEvent('applyAudioFilter', 'Success');
            case 40:
            case "end":
              return _context45.stop();
          }
        }, _callee45, null, [[20, 34]]);
      }));
      return function (_x35) {
        return _ref52.apply(this, arguments);
      };
    }();

    /**
     * Removes the audio filter being applied to the publisher.
     *
     * <p>
     * This will result in an error (the Promise returned by the method is rejected) if the
     * audio filter could not be stopped.
     *
     * @method #clearAudioFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#applyAudioFilter">Publisher.applyAudioFilter()</a>
     * @see <a href="Publisher.html#getAudioFilter">Publisher.getAudioFilter()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected.
     */
    this.clearAudioFilter = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee46() {
      var message;
      return _regenerator.default.wrap(function _callee46$(_context46) {
        while (1) switch (_context46.prev = _context46.next) {
          case 0:
            logAnalyticsEvent('clearAudioFilter', 'Attempt');
            if (!(!properties.publishAudio && _this.getAudioFilter())) {
              _context46.next = 5;
              break;
            }
            currentAudioFilter = null;
            logAnalyticsEvent('clearAudioFilter', 'Success');
            return _context46.abrupt("return");
          case 5:
            if (MediaProcessor.isSupported()) {
              _context46.next = 10;
              break;
            }
            message = 'Ignoring. "clearAudioFilter" not supported.';
            logAnalyticsEvent('clearAudioFilter', 'Success', {
              message
            });
            logging.warn(message);
            return _context46.abrupt("return");
          case 10:
            if (_this.getAudioFilter()) {
              _context46.next = 15;
              break;
            }
            message = 'Ignoring. No audio filter applied';
            logAnalyticsEvent('clearAudioFilter', 'Success', {
              message
            });
            logging.debug(message);
            return _context46.abrupt("return");
          case 15:
            if (webRTCStream) {
              _context46.next = 20;
              break;
            }
            message = 'Ignoring. No mediaStream';
            logAnalyticsEvent('clearAudioFilter', 'Success', {
              message
            });
            logging.warn(message);
            return _context46.abrupt("return");
          case 20:
            _context46.prev = 20;
            _context46.next = 23;
            return _setAudioMediaProcessorConnector(null);
          case 23:
            currentAudioFilter = null;
            _context46.next = 30;
            break;
          case 26:
            _context46.prev = 26;
            _context46.t0 = _context46["catch"](20);
            logAnalyticsEvent('clearAudioFilter', 'Failure', {
              error: _context46.t0
            });
            return _context46.abrupt("return");
          case 30:
            logAnalyticsEvent('clearAudioFilter', 'Success');
          case 31:
          case "end":
            return _context46.stop();
        }
      }, _callee46, null, [[20, 26]]);
    }));

    /**
     * Returns the audio filter used by the publisher (or null if there is no audio filter).
     *
     * @method #getAudioFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#applyAudioFilter">Publisher.applyAudioFilter()</a>
     * @see <a href="Publisher.html#clearAudioFilter">Publisher.clearAudioFilter()</a>
     *
     * @return {Object} The audio filter used by the publisher.
     * Check the <code>type</code> property of the object to see the audio filter type.
     * Currently, only the advanced noise suppression filter is supported, and the
     * <code>type</code> property is set to <code>"advancedNoiseSuppression"</code>.
     */
    this.getAudioFilter = () => {
      logAnalyticsEvent('getAudioFilter', 'Attempt');
      logAnalyticsEvent('getAudioFilter', 'Success');
      return currentAudioFilter || null;
    };

    /**
     * Sets a MediaProcessorConnector for the publisher video track.
     * A publisher can have only one video
     * <a href="https://vonage.github.io/media-processor-docs/docs/api/classes/MediaProcessorConnector">MediaProcessorConnector</a>
     * applied at one time.  When you set a new
     * connector, the previously set video connector is removed.
     *
     * <p>
     * This method is incompatible with the
     * <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
     * method. Calling this method after <code>Publisher.applyVideoFilter(filter)</code> returns
     * a promise rejected with an error, with the <code>name</code> property of the error set to
     * <code>'OT_NOT_SUPPORTED'</code>. You can clear the video filter by calling
     * <code>Publisher.clearVideoFilter()</code>.
     * </p>
     *
     * <p>
     * <em>Note:</em> MediaProcessors are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     * </p>
     *
     * <p>
     * <b>Important:</b> Media processors require adequate processor support.
     * Even in supported browsers, transformers may not be stable when background
     * processes limit available processing resources. See
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/js/#client-requirements">Client requirements</a>.
     * </p>
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     There are no video input devices (cameras) available.
     *   </li>
     *   <li>
     *     A video filter has already been applied via the <code>Publisher.applyVideoFilter()</code> method.
     *   </li>
     *   <li>
     *     There was an error acquiring video from the video input device.
     *   </li>
     *   <li>
     *     There was an error acquiring the processed track from the MediaProcessorConnector.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can clear the current connector by calling this method with <code>null</code>.
     *
     * <p>
     * For more information, see the
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/">
     * Using the Vonage Media Processor library</a>
     * developer guide.
     *
     * @param {MediaProcessorConnector} mediaProcessorConnector A MediaProcessorConnector instance.
     * See the <a href="https://vonage.github.io/media-processor-docs/docs/intro/">Vonage Media Processor
     * library docs</a>.</td>
     *
     * @method #setVideoMediaProcessorConnector
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no connector is set.
     */
    this.setVideoMediaProcessorConnector = /*#__PURE__*/function () {
      var _ref54 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee47(mediaProcessorConnector) {
        var _webRTCStream$getVide3, filteredVideoTrack, videoTrack, _webRTCStream$getVide4, originalVideoTrack, message;
        return _regenerator.default.wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Attempt', {
                message: mediaProcessorConnector ? 'setting the connector' : 'clearing the connector'
              });
              if (!_this.getVideoFilter()) {
                _context47.next = 4;
                break;
              }
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                message: 'Tried to set video MediaProcessorConnector when video filter applied.'
              });
              throw otError(Errors.NOT_SUPPORTED, new Error('setVideoMediaProcessorConnector: Cannot use this method when videoFilter is set.'));
            case 4:
              if (!_videoMediaProcessorConnector) {
                _context47.next = 14;
                break;
              }
              _webRTCStream$getVide3 = webRTCStream.getVideoTracks(), filteredVideoTrack = _webRTCStream$getVide3[0];
              _context47.next = 8;
              return getTrackFromDeviceId(currentDeviceId);
            case 8:
              videoTrack = _context47.sent;
              _context47.next = 11;
              return replaceTrackAndUpdate(filteredVideoTrack, videoTrack);
            case 11:
              _videoMediaProcessorConnector.destroy();
              _videoMediaProcessorConnector.stopOriginalTrack();
              _videoMediaProcessorConnector = null;
            case 14:
              if (mediaProcessorConnector) {
                _context47.next = 17;
                break;
              }
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Success', {
                message: 'clearing the connector'
              });
              return _context47.abrupt("return");
            case 17:
              if (MediaProcessorConnector.isValidConnector(mediaProcessorConnector)) {
                _context47.next = 20;
                break;
              }
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                message: 'Invalid MediaProcessorConnector'
              });
              throw otError(Errors.INVALID_PARAMETER, new Error('setVideoMediaProcessorConnector:  Tried to set invalid MediaProcessorConnector'));
            case 20:
              _videoMediaProcessorConnector = new MediaProcessorConnector(mediaProcessorConnector);
              _webRTCStream$getVide4 = webRTCStream.getVideoTracks(), originalVideoTrack = _webRTCStream$getVide4[0];
              if (originalVideoTrack) {
                _context47.next = 28;
                break;
              }
              message = 'Connector not set as no video track is present.';
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                message
              });
              logging.warn(`setVideoMediaProcessorConnector: ${message}`);
              _videoMediaProcessorConnector = null;
              return _context47.abrupt("return");
            case 28:
              _context47.prev = 28;
              _context47.next = 31;
              return _videoMediaProcessorConnector.setTrack(originalVideoTrack);
            case 31:
              filteredVideoTrack = _context47.sent;
              _context47.next = 34;
              return replaceTrackAndUpdate(originalVideoTrack, filteredVideoTrack);
            case 34:
              _context47.next = 42;
              break;
            case 36:
              _context47.prev = 36;
              _context47.t0 = _context47["catch"](28);
              _videoMediaProcessorConnector = null;
              logging.error(`setVideoMediaProcessorConnector: Error getting track from MediaProcessorConnector: ${_context47.t0}`);
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                message: _context47.t0.message
              });
              throw _context47.t0;
            case 42:
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Success');
            case 43:
            case "end":
              return _context47.stop();
          }
        }, _callee47, null, [[28, 36]]);
      }));
      return function (_x36) {
        return _ref54.apply(this, arguments);
      };
    }();

    /**
     * Sets a MediaProcessorConnector for the publisher audio track.
     * A publisher can have only one audio
     * <a href="https://vonage.github.io/media-processor-docs/docs/api/classes/MediaProcessorConnector">MediaProcessorConnector</a>
     * applied at one time.  When you set a new
     * connector, the previously set audio connector is removed.
     *
     * <p>
     * <em>Note:</em> MediaProcessors are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     * </p>
     *
     * <p>
     * <b>Important:</b> Media processors require adequate processor support.
     * Even in supported browsers, transformers may not be stable when background
     * processes limit available processing resources. See
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/js/#client-requirements">Client requirements</a>.
     * </p>
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     There are no audio input devices (microphones) available.
     *   </li>
     *   <li>
     *     There was an error acquiring audio from the audio input device.
     *   </li>
     *   <li>
     *     There was an error acquiring the processed track from the MediaProcessorConnector.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can clear the current connector by calling this method with <code>null</code>.
     *
     * <p>
     * For more information, see the
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/">
     * Using the Vonage Media Processor library</a>
     * developer guide.
     *
     * @param {MediaProcessorConnector} mediaProcessorConnector A MediaProcessorConnector instance.
     * See the <a href="https://vonage.github.io/media-processor-docs/docs/intro/">Vonage Media Processor
     * library docs</a>.</td>
     *
     * @method #setAudioMediaProcessorConnector
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no connector is set.
     */
    this.setAudioMediaProcessorConnector = /*#__PURE__*/function () {
      var _ref55 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee48(mediaProcessorConnector) {
        return _regenerator.default.wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Attempt', {
                message: mediaProcessorConnector ? 'setting the connector' : 'clearing the connector'
              });
              _context48.prev = 1;
              _context48.next = 4;
              return _setAudioMediaProcessorConnector(mediaProcessorConnector);
            case 4:
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Success', {
                message: mediaProcessorConnector ? undefined : 'clearing the connector'
              });
              _context48.next = 11;
              break;
            case 7:
              _context48.prev = 7;
              _context48.t0 = _context48["catch"](1);
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
                message: _context48.t0.message
              });
              throw _context48.t0;
            case 11:
            case "end":
              return _context48.stop();
          }
        }, _callee48, null, [[1, 7]]);
      }));
      return function (_x37) {
        return _ref55.apply(this, arguments);
      };
    }();
    const _setAudioMediaProcessorConnector = /*#__PURE__*/function () {
      var _ref56 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee49(mediaProcessorConnector) {
        var message, _webRTCStream$getAudi, filteredAudioTrack, _webRTCStream$getAudi2, originalAudioTrack;
        return _regenerator.default.wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (!(_this.getAudioFilter() && mediaProcessorConnector)) {
                _context49.next = 3;
                break;
              }
              message = 'Tried to set audio MediaProcessorConnector when audio filter applied.';
              throw otError(Errors.NOT_SUPPORTED, new Error(message));
            case 3:
              if (!_audioMediaProcessorConnector) {
                _context49.next = 9;
                break;
              }
              _webRTCStream$getAudi = webRTCStream.getAudioTracks(), filteredAudioTrack = _webRTCStream$getAudi[0];
              _context49.next = 7;
              return replaceAudioTrack(filteredAudioTrack, _audioMediaProcessorConnector.originalTrack);
            case 7:
              _audioMediaProcessorConnector.destroy();
              _audioMediaProcessorConnector = null;
            case 9:
              if (mediaProcessorConnector) {
                _context49.next = 11;
                break;
              }
              return _context49.abrupt("return");
            case 11:
              if (MediaProcessorConnector.isValidConnector(mediaProcessorConnector)) {
                _context49.next = 14;
                break;
              }
              message = 'Invalid MediaProcessorConnector';
              throw otError(Errors.INVALID_PARAMETER, new Error(message));
            case 14:
              _webRTCStream$getAudi2 = webRTCStream.getAudioTracks(), originalAudioTrack = _webRTCStream$getAudi2[0];
              if (originalAudioTrack) {
                _context49.next = 20;
                break;
              }
              message = 'Connector not set as no audio track is present.';
              logging.warn(`setAudioMediaProcessorConnector: ${message}`);
              _audioMediaProcessorConnector = null;
              throw new Error(message);
            case 20:
              _audioMediaProcessorConnector = new MediaProcessorConnector(mediaProcessorConnector);
              _context49.prev = 21;
              _context49.next = 24;
              return _audioMediaProcessorConnector.setTrack(originalAudioTrack);
            case 24:
              filteredAudioTrack = _context49.sent;
              _context49.next = 27;
              return replaceAudioTrack(_this._getAudioSource(), filteredAudioTrack);
            case 27:
              _context49.next = 34;
              break;
            case 29:
              _context49.prev = 29;
              _context49.t0 = _context49["catch"](21);
              _audioMediaProcessorConnector = null;
              logging.error(`setAudioMediaProcessorConnector: Error getting track from MediaProcessorConnector: ${_context49.t0}`);
              throw _context49.t0;
            case 34:
            case "end":
              return _context49.stop();
          }
        }, _callee49, null, [[21, 29]]);
      }));
      return function _setAudioMediaProcessorConnector(_x38) {
        return _ref56.apply(this, arguments);
      };
    }();

    /**
     * Removes the video filter being applied to the publisher.
     *
     * <p>
     * This will result in an error (the Promise returned by the method is rejected) if the
     * video filter could not be stopped.
     *
     * @method #clearVideoFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
     * @see <a href="Publisher.html#getVideoFilter">Publisher.getVideoFilter()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected.
     */
    this.clearVideoFilter = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee50() {
      var message, oldVideoFilter, _webRTCStream$getVide5, filteredVideoTrack, videoTrack;
      return _regenerator.default.wrap(function _callee50$(_context50) {
        while (1) switch (_context50.prev = _context50.next) {
          case 0:
            logAnalyticsEvent('clearVideoFilter', 'Attempt');
            if (!(!properties.publishVideo && !mediaProcessor.getVideoFilter())) {
              _context50.next = 5;
              break;
            }
            currentVideoFilter = null;
            logAnalyticsEvent('clearVideoFilter', 'Success');
            return _context50.abrupt("return");
          case 5:
            if (!(!mediaProcessor.getVideoFilter() && !currentVideoFilter)) {
              _context50.next = 10;
              break;
            }
            message = 'Ignoring. No video filter applied';
            logAnalyticsEvent('clearVideoFilter', 'Success', {
              message
            });
            logging.debug(message);
            return _context50.abrupt("return");
          case 10:
            if (MediaProcessor.isSupported()) {
              _context50.next = 15;
              break;
            }
            message = 'Ignoring. "clearVideoFilter" not supported.';
            logAnalyticsEvent('clearVideoFilter', 'Success', {
              message
            });
            logging.warn(message);
            return _context50.abrupt("return");
          case 15:
            if (webRTCStream) {
              _context50.next = 20;
              break;
            }
            message = 'Ignoring. No mediaStream';
            logAnalyticsEvent('clearVideoFilter', 'Success', {
              message
            });
            logging.warn(message);
            return _context50.abrupt("return");
          case 20:
            oldVideoFilter = currentVideoFilter;
            currentVideoFilter = null;
            _webRTCStream$getVide5 = webRTCStream.getVideoTracks(), filteredVideoTrack = _webRTCStream$getVide5[0];
            _context50.prev = 23;
            _context50.next = 26;
            return getTrackFromDeviceId(currentDeviceId);
          case 26:
            videoTrack = _context50.sent;
            _context50.next = 33;
            break;
          case 29:
            _context50.prev = 29;
            _context50.t0 = _context50["catch"](23);
            logging.error(_context50.t0);
            return _context50.abrupt("return");
          case 33:
            if (videoTrack) {
              _context50.next = 36;
              break;
            }
            logging.warn('Failed to clear filter because there is no video track.');
            return _context50.abrupt("return");
          case 36:
            _context50.prev = 36;
            _context50.next = 39;
            return replaceTrackAndUpdate(filteredVideoTrack, videoTrack);
          case 39:
            _context50.next = 41;
            return destroyMediaProcessor();
          case 41:
            _context50.next = 46;
            break;
          case 43:
            _context50.prev = 43;
            _context50.t1 = _context50["catch"](36);
            // Restore the previous filter since this call has failed. This way, this function can be
            // called again if needed.
            currentVideoFilter = oldVideoFilter;
          case 46:
            logAnalyticsEvent('clearVideoFilter', 'Success');
          case 47:
          case "end":
            return _context50.stop();
        }
      }, _callee50, null, [[23, 29], [36, 43]]);
    }));
  };

  /**
  * Dispatched when the user has clicked the Allow button, granting the
  * app access to the camera and microphone. The Publisher object has an
  * <code>accessAllowed</code> property which indicates whether the user
  * has granted access to the camera and microphone.
  * @see Event
  * @name accessAllowed
  * @event
  * @memberof Publisher
  */

  /**
  * Dispatched when the user has clicked the Deny button, preventing the
  * app from having access to the camera and microphone.
  * <p>
  * This event is also dispatched if the user removes the permissions after previously granting them.
  * <p>
  * <i>Note:</i> On macOS 10.15+ (Catalina), to publish a screen-sharing stream
  * the user must grant the browser access to the screen in macOS System Preferences &gt;
  * Security &amp; Privacy &gt; Privacy &gt; Screen Recording. Otherwise,
  * the Publisher will dispatch an <code>accessDenied</code> event.
  *
  * @see Event
  * @name accessDenied
  * @event
  * @memberof Publisher
  */

  /**
  * Dispatched when the Allow/Deny dialog box is opened. (This is the dialog box in which
  * the user can grant the app access to the camera and microphone.)
  * @see Event
  * @name accessDialogOpened
  * @event
  * @memberof Publisher
  */

  /**
  * Dispatched when the MediaStream is available.
  * @see Event
  * @name mediaStreamAvailable
  * @event
  * @memberof Publisher
  */

  /**
  * Dispatched when the Allow/Deny box is closed. (This is the dialog box in which the
  * user can grant the app access to the camera and microphone.)
  * @see Event
  * @name accessDialogClosed
  * @event
  * @memberof Publisher
  */

  /**
   * Dispatched when the audio input device is changed.
   *
   * @see Event
   * @see AudioInputDeviceChangedEvent
   * @name audioInputDeviceChanged
   * @event
   * @memberof Publisher
   */

  /**
  * Dispatched periodically to indicate the publisher's audio level. The event is dispatched
  * up to 60 times per second, depending on the browser. The <code>audioLevel</code> property
  * of the event is audio level, from 0 to 1.0. See {@link AudioLevelUpdatedEvent} for more
  * information.
  * <p>
  * The following example adjusts the value of a meter element that shows volume of the
  * publisher. Note that the audio level is adjusted logarithmically and a moving average
  * is applied:
  * <p>
  * <pre>
  * var movingAvg = null;
  * publisher.on('audioLevelUpdated', function(event) {
  *   if (movingAvg === null || movingAvg &lt;= event.audioLevel) {
  *     movingAvg = event.audioLevel;
  *   } else {
  *     movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
  *   }
  *
  *   // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
  *   var logLevel = (Math.log(movingAvg) / Math.LN10) / 1.5 + 1;
  *   logLevel = Math.min(Math.max(logLevel, 0), 1);
  *   document.getElementById('publisherMeter').value = logLevel;
  * });
  * </pre>
  * <p>This example shows the algorithm used by the default audio level indicator displayed
  * in an audio-only Publisher.
  *
  * @name audioLevelUpdated
  * @event
  * @memberof Publisher
  * @see AudioLevelUpdatedEvent
  */

  /**
   * The publisher has started streaming to the session.
   * @name streamCreated
   * @event
   * @memberof Publisher
   * @see StreamEvent
   * @see <a href="Session.html#publish">Session.publish()</a>
   */

  /**
   * The publisher has stopped streaming to the session. The default behavior is that
   * the Publisher object is removed from the HTML DOM. The Publisher object dispatches a
   * <code>destroyed</code> event when the element is removed from the HTML DOM. If you call the
   * <code>preventDefault()</code> method of the event object in the event listener, the default
   * behavior is prevented, and you can, optionally, retain the Publisher for reuse or clean it up
   * using your own code.
   * @name streamDestroyed
   * @event
   * @memberof Publisher
   * @see StreamEvent
   */

  /**
  * Dispatched when the Publisher element is removed from the HTML DOM. When this event
  * is dispatched, you may choose to adjust or remove HTML DOM elements related to the publisher.
  * @name destroyed
  * @event
  * @memberof Publisher
  */

  /**
  * Dispatched when the video dimensions of the video change. This can only occur in when the
  * <code>stream.videoType</code> property is set to <code>"screen"</code> (for a screen-sharing
  * video stream), when the user resizes the window being captured. This event object has a
  * <code>newValue</code> property and an <code>oldValue</code> property, representing the new and
  * old dimensions of the video. Each of these has a <code>height</code> property and a
  * <code>width</code> property, representing the height and width, in pixels.
  * @name videoDimensionsChanged
  * @event
  * @memberof Publisher
  * @see VideoDimensionsChangedEvent
  */

  /**
   * Dispatched when the video for the publisher is disabled.
   *   <p>
   *   Before sending this event, when the Publisher's stream quality deteriorates to a level
   *   that is low enough that the video stream is at risk of being disabled, the Publisher
   *   dispatches a <code>videoDisableWarning</code> event.
   *   <p>
   *   If connectivity improves to support video again, the Publisher object dispatches
   *   a <code>videoEnabled</code> event, and the Subscriber resumes receiving video.
   *   <p>
   *   By default, the Publisher displays a video disabled indicator when a
   *   <code>videoDisabled</code> event with this reason is dispatched and removes the indicator
   *   when the <code>videoEnabled</code> event with this reason is dispatched. You can control
   *   the display of this icon by setting the <code>videoDisabledDisplayMode</code> with the
   *   <code>Publisher.setStyle()</code> method or by setting the <code>videoDisabledDisplayMode</code>
   *   <code>style</code> property when initializing the Publisher with the
   *   <code>OT.initPublisher()</code> method.
   *   <p>
   *   You can enable this audio-only fallback feature, by setting the
   *   <code>publisher</code> property to <code>true</code> in the
   *   <code>audioFallbackEnabled</code> option passed
   *   into the <code>OT.initPublisher()</code> method for the publishing client. (See
   *   <a href="OT.html#initPublisher">OT.initPublisher()</a>.)</li>
   *
   * </ul>
   *
   * @see Event
   * @see <a href="Publisher.html#event:videoDisableWarning">videoDisableWarning</a> event
   * @see <a href="Publisher.html#event:videoEnabled">videoEnabled</a> event
   * @name videoDisabled
   * @event
   * @memberof Publisher
   */

  /**
   * Dispatched when the Publisher determines that the stream quality has degraded
   * and the video will be disabled if the quality degrades more. If the quality degrades further,
   * the Publisher disables the video and dispatches a <code>videoDisabled</code> event.
   * <p>
   * By default, the Publisher displays a video disabled warning indicator when this event
   * is dispatched (and the video is disabled). You can control the display of this icon by
   * calling the <code>setStyle()</code> method of the Publisher and
   * setting the <code>videoDisabledDisplayMode</code> property, or you can set the
   * <code>videoDisabledDisplayMode</code> property when calling the
   * <code>OT.initPublisher()</code> method and setting the <code>style</code> property
   * of the <code>properties</code> parameter.
   *
   * @see Event
   * @see <a href="Publisher.html#event:videoDisabled">videoDisabled</a> event
   * @see <a href="Publisher.html#event:videoDisableWarningLifted">videoDisableWarningLifted</a> event
   * @name videoDisableWarning
   * @event
   * @memberof Publisher
   */

  /**
   * Dispatched when the Publisher determines that the stream quality has improved
   * to the point at which the video being disabled is not an immediate risk. This event is
   * dispatched after the Publisher object dispatches a <code>videoDisableWarning</code> event.
   *
   * @see Event
   * @see <a href="Publisher.html#event:videoDisableWarning">videoDisableWarning</a> event
   * @see <a href="Publisher.html#event:videoDisabled">videoDisabled</a> event
   * @name videoDisableWarningLifted
   * @event
   * @memberof Publisher
   */

  /**
  * Dispatched when the Publisher's video element is created. Add a listener for this event when
  * you set the <code>insertDefaultUI</code> option to <code>false</code> in the call to the
  * <a href="OT.html#initPublisher">OT.initPublisher()</a> method. The <code>element</code>
  * property of the event object is a reference to the Publisher's <code>video</code> element
  * (or in Internet Explorer the <code>object</code> element containing the video). Add it to
  * the HTML DOM to display the video. When you set the <code>insertDefaultUI</code> option to
  * <code>false</code>, the <code>video</code> (or <code>object</code>) element is not
  * automatically inserted into the DOM.
  * <p>
  * Add a listener for this event only if you have set the <code>insertDefaultUI</code> option to
  * <code>false</code>. If you have not set <code>insertDefaultUI</code> option to
  * <code>false</code>, do not move the <code>video</code> (or <code>object</code>) element in
  * in the HTML DOM. Doing so causes the Publisher object to be destroyed.
  *
  * @name videoElementCreated
  * @event
  * @memberof Publisher
  * @see VideoElementCreatedEvent
  */

  /**
   * Dispatched when the Publisher resumes sending video to the publisher
   * after video was previously disabled.
   *
   * @see Event
   * @see <a href="Publisher.html#event:videoDisabled">videoDisabled</a> event
   * @name videoEnabled
   * @event
   * @memberof Publisher
   */

  /**
   * A moderator has forced this client to mute audio.
   *
   * @name muteForced
   * @event
   * @memberof Publisher
   * @see Event
   * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
   * @see <a href="Session.html#forceMuteStream">Session.forceMuteStream()</a>
   * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
   * of streams in a session</a>
   */

  /**
   * The user publishing the stream has stopped sharing one or all media
   * types (video, audio and/or screen). This can occur when a user disconnects a camera or
   * microphone used as a media source for the Publisher. Or it can occur when a user closes
   * a when the video and audio sources of the stream are MediaStreamTrack elements and
   * tracks are stopped or destroyed.
   *
   * @name mediaStopped
   * @event
   * @memberof Publisher
   * @see MediaStoppedEvent
   */
  return Publisher;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 183 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise, process) {var _interopRequireDefault=__webpack_require__(0);exports.__esModule=true;exports.WebglSelfieSegmentationType=exports.WarningType=exports.VonageMediaProcessor=exports.RenderingType=exports.PipelineInfoData=exports.MediapipeHelper=exports.ErrorFunction=exports.BlurRadius=exports.BackgroundTransformerType=exports.BackgroundTransformer=void 0;exports.createVonageMediaProcessor=k3;exports.getSupportedBrowserFeatures=Q2;exports.getVonageFaceDetection=H3;exports.getVonageFaceMash=C3;exports.getVonageHands=F3;exports.getVonageHolistic=L3;exports.getVonageObjectron=N3;exports.getVonagePose=J3;exports.getVonageSelfieSegmentation=w3;exports.isSupported=T3;var _regenerator=_interopRequireDefault(__webpack_require__(4));var _inheritsLoose2=_interopRequireDefault(__webpack_require__(23));var _createClass2=_interopRequireDefault(__webpack_require__(25));var _asyncToGenerator2=_interopRequireDefault(__webpack_require__(5));var _globalThis=function(Object){function get(){var _global=this||self;delete Object.prototype.__magic__;return _global;}if(typeof globalThis==="object"){return globalThis;}if(this){return get();}else{Object.defineProperty(Object.prototype,"__magic__",{configurable:true,get:get});var _global=__magic__;return _global;}}(Object);function _getRequireWildcardCache(nodeInterop){if(typeof WeakMap!=="function")return null;var cacheBabelInterop=new WeakMap();var cacheNodeInterop=new WeakMap();return(_getRequireWildcardCache=function _getRequireWildcardCache(nodeInterop){return nodeInterop?cacheNodeInterop:cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj,nodeInterop){if(!nodeInterop&&obj&&obj.__esModule){return obj;}if(obj===null||typeof obj!=="object"&&typeof obj!=="function"){return{default:obj};}var cache=_getRequireWildcardCache(nodeInterop);if(cache&&cache.has(obj)){return cache.get(obj);}var newObj={};var hasPropertyDescriptor=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var key in obj){if(key!=="default"&&Object.prototype.hasOwnProperty.call(obj,key)){var desc=hasPropertyDescriptor?Object.getOwnPropertyDescriptor(obj,key):null;if(desc&&(desc.get||desc.set)){Object.defineProperty(newObj,key,desc);}else{newObj[key]=obj[key];}}}newObj.default=obj;if(cache){cache.set(obj,newObj);}return newObj;}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it=typeof Symbol!=="undefined"&&o[Symbol.iterator]||o["@@iterator"];if(it)return(it=it.call(o)).next.bind(it);if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2;}function l2(){return new Promise((r,e)=>{typeof MediaStreamTrackProcessor>"u"||typeof MediaStreamTrackGenerator>"u"?e("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media."):r();});}let er=function er(){};er.updates={transformer_new:"New transformer",transformer_null:"Null transformer"};er.errors={transformer_none:"No transformers provided",transformer_start:"Cannot start transformer",transformer_transform:"Cannot transform frame",transformer_flush:"Cannot flush transformer",readable_null:"Readable is null",writable_null:"Writable is null"};function c2(r){return r&&r.__esModule&&Object.prototype.hasOwnProperty.call(r,"default")?r.default:r;}const rr=/* @__PURE__ */new WeakMap(),bi=/* @__PURE__ */new WeakMap(),Br=/* @__PURE__ */new WeakMap(),bo=Symbol("anyProducer"),bs=Promise.resolve(),vi=Symbol("listenerAdded"),Gi=Symbol("listenerRemoved");let so=!1;function Ir(r){if(typeof r!="string"&&typeof r!="symbol")throw new TypeError("eventName must be a string or a symbol");}function oi(r){if(typeof r!="function")throw new TypeError("listener must be a function");}function Sr(r,e){const i=bi.get(r);return i.has(e)||i.set(e,/* @__PURE__ */new Set()),i.get(e);}function jr(r,e){const i=typeof e=="string"||typeof e=="symbol"?e:bo,m=Br.get(r);return m.has(i)||m.set(i,/* @__PURE__ */new Set()),m.get(i);}function u2(r,e,i){const m=Br.get(r);if(m.has(e)){for(var _iterator=_createForOfIteratorHelperLoose(m.get(e)),_step;!(_step=_iterator()).done;){const v=_step.value;v.enqueue(i);}}if(m.has(bo)){const v=Promise.all([e,i]);for(var _iterator2=_createForOfIteratorHelperLoose(m.get(bo)),_step2;!(_step2=_iterator2()).done;){const S=_step2.value;S.enqueue(v);}}}function ys(r,e){e=Array.isArray(e)?e:[e];let i=!1,m=()=>{},v=[];const S={enqueue(L){v.push(L),m();},finish(){i=!0,m();}};for(var _iterator3=_createForOfIteratorHelperLoose(e),_step3;!(_step3=_iterator3()).done;){const L=_step3.value;jr(r,L).add(S);}return{next(){var _this=this;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(){return _regenerator.default.wrap(function _callee$(_context){while(1)switch(_context.prev=_context.next){case 0:if(!v){_context.next=20;break;}if(!(v.length===0)){_context.next=12;break;}if(!i){_context.next=6;break;}_context.t2=(v=void 0,_this.next());_context.next=9;break;case 6:_context.next=8;return new Promise(L=>{m=L;});case 8:_context.t2=_this.next();case 9:_context.t1=_context.t2;_context.next=17;break;case 12:_context.t3=!1;_context.next=15;return v.shift();case 15:_context.t4=_context.sent;_context.t1={done:_context.t3,value:_context.t4};case 17:_context.t0=_context.t1;_context.next=21;break;case 20:_context.t0={done:!0};case 21:return _context.abrupt("return",_context.t0);case 22:case"end":return _context.stop();}},_callee);}))();},return(L){var _arguments=arguments;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(){var _iterator4,_step4,T;return _regenerator.default.wrap(function _callee2$(_context2){while(1)switch(_context2.prev=_context2.next){case 0:v=void 0;for(_iterator4=_createForOfIteratorHelperLoose(e);!(_step4=_iterator4()).done;){T=_step4.value;jr(r,T).delete(S);}m();if(!(_arguments.length>0)){_context2.next=11;break;}_context2.t1=!0;_context2.next=7;return L;case 7:_context2.t2=_context2.sent;_context2.t0={done:_context2.t1,value:_context2.t2};_context2.next=12;break;case 11:_context2.t0={done:!0};case 12:return _context2.abrupt("return",_context2.t0);case 13:case"end":return _context2.stop();}},_callee2);}))();},[Symbol.asyncIterator](){return this;}};}function gs(r){if(r===void 0)return Zs;if(!Array.isArray(r))throw new TypeError("`methodNames` must be an array of strings");for(var _iterator5=_createForOfIteratorHelperLoose(r),_step5;!(_step5=_iterator5()).done;){const e=_step5.value;if(!Zs.includes(e))throw typeof e!="string"?new TypeError("`methodNames` element must be a string"):new Error(`${e} is not Emittery method`);}return r;}const lo=r=>r===vi||r===Gi;let Pi=/*#__PURE__*/function(){yo.mixin=function mixin(e,i){return i=gs(i),m=>{if(typeof m!="function")throw new TypeError("`target` must be function");for(var _iterator6=_createForOfIteratorHelperLoose(i),_step6;!(_step6=_iterator6()).done;){const L=_step6.value;if(m.prototype[L]!==void 0)throw new Error(`The property \`${L}\` already exists on \`target\``);}function v(){return Object.defineProperty(this,e,{enumerable:!1,value:new yo()}),this[e];}Object.defineProperty(m.prototype,e,{enumerable:!1,get:v});const S=L=>function(){return this[e][L](...arguments);};for(var _iterator7=_createForOfIteratorHelperLoose(i),_step7;!(_step7=_iterator7()).done;){const L=_step7.value;Object.defineProperty(m.prototype,L,{enumerable:!1,value:S(L)});}return m;};};function yo(e){if(e===void 0){e={};}rr.set(this,/* @__PURE__ */new Set()),bi.set(this,/* @__PURE__ */new Map()),Br.set(this,/* @__PURE__ */new Map()),this.debug=e.debug||{},this.debug.enabled===void 0&&(this.debug.enabled=!1),this.debug.logger||(this.debug.logger=(i,m,v,S)=>{try{S=JSON.stringify(S);}catch(_unused){S=`Object with the following keys failed to stringify: ${Object.keys(S).join(",")}`;}typeof v=="symbol"&&(v=v.toString());const L=/* @__PURE__ */new Date(),T=`${L.getHours()}:${L.getMinutes()}:${L.getSeconds()}.${L.getMilliseconds()}`;console.log(`[${T}][emittery:${i}][${m}] Event Name: ${v}
	data: ${S}`);});}var _proto=yo.prototype;_proto.logIfDebugEnabled=function logIfDebugEnabled(e,i,m){(yo.isDebugEnabled||this.debug.enabled)&&this.debug.logger(e,this.debug.name,i,m);};_proto.on=function on(e,i){oi(i),e=Array.isArray(e)?e:[e];for(var _iterator8=_createForOfIteratorHelperLoose(e),_step8;!(_step8=_iterator8()).done;){const m=_step8.value;Ir(m),Sr(this,m).add(i),this.logIfDebugEnabled("subscribe",m,void 0),lo(m)||this.emit(vi,{eventName:m,listener:i});}return this.off.bind(this,e,i);};_proto.off=function off(e,i){oi(i),e=Array.isArray(e)?e:[e];for(var _iterator9=_createForOfIteratorHelperLoose(e),_step9;!(_step9=_iterator9()).done;){const m=_step9.value;Ir(m),Sr(this,m).delete(i),this.logIfDebugEnabled("unsubscribe",m,void 0),lo(m)||this.emit(Gi,{eventName:m,listener:i});}};_proto.once=function once(e){return new Promise(i=>{const m=this.on(e,v=>{m(),i(v);});});};_proto.events=function events(e){e=Array.isArray(e)?e:[e];for(var _iterator10=_createForOfIteratorHelperLoose(e),_step10;!(_step10=_iterator10()).done;){const i=_step10.value;Ir(i);}return ys(this,e);};_proto.emit=/*#__PURE__*/function(){var _emit=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5(e,i){var m,v,S,L;return _regenerator.default.wrap(function _callee5$(_context5){while(1)switch(_context5.prev=_context5.next){case 0:Ir(e),this.logIfDebugEnabled("emit",e,i),u2(this,e,i);m=Sr(this,e),v=rr.get(this),S=[...m],L=lo(e)?[]:[...v];_context5.next=4;return bs;case 4:_context5.next=6;return Promise.all([...S.map(/*#__PURE__*/function(){var _ref=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(T){return _regenerator.default.wrap(function _callee3$(_context3){while(1)switch(_context3.prev=_context3.next){case 0:if(!m.has(T)){_context3.next=2;break;}return _context3.abrupt("return",T(i));case 2:case"end":return _context3.stop();}},_callee3);}));return function(_x3){return _ref.apply(this,arguments);};}()),...L.map(/*#__PURE__*/function(){var _ref2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(T){return _regenerator.default.wrap(function _callee4$(_context4){while(1)switch(_context4.prev=_context4.next){case 0:if(!v.has(T)){_context4.next=2;break;}return _context4.abrupt("return",T(e,i));case 2:case"end":return _context4.stop();}},_callee4);}));return function(_x4){return _ref2.apply(this,arguments);};}())]);case 6:case"end":return _context5.stop();}},_callee5,this);}));function emit(_x,_x2){return _emit.apply(this,arguments);}return emit;}();_proto.emitSerial=/*#__PURE__*/function(){var _emitSerial=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee6(e,i){var m,v,S,L,_i2,_S,T,_i3,_L;return _regenerator.default.wrap(function _callee6$(_context6){while(1)switch(_context6.prev=_context6.next){case 0:Ir(e),this.logIfDebugEnabled("emitSerial",e,i);m=Sr(this,e),v=rr.get(this),S=[...m],L=[...v];_context6.next=4;return bs;case 4:_i2=0,_S=S;case 5:if(!(_i2<_S.length)){_context6.next=14;break;}T=_S[_i2];_context6.t0=m.has(T);if(!_context6.t0){_context6.next=11;break;}_context6.next=11;return T(i);case 11:_i2++;_context6.next=5;break;case 14:_i3=0,_L=L;case 15:if(!(_i3<_L.length)){_context6.next=24;break;}T=_L[_i3];_context6.t1=v.has(T);if(!_context6.t1){_context6.next=21;break;}_context6.next=21;return T(e,i);case 21:_i3++;_context6.next=15;break;case 24:case"end":return _context6.stop();}},_callee6,this);}));function emitSerial(_x5,_x6){return _emitSerial.apply(this,arguments);}return emitSerial;}();_proto.onAny=function onAny(e){return oi(e),this.logIfDebugEnabled("subscribeAny",void 0,void 0),rr.get(this).add(e),this.emit(vi,{listener:e}),this.offAny.bind(this,e);};_proto.anyEvent=function anyEvent(){return ys(this);};_proto.offAny=function offAny(e){oi(e),this.logIfDebugEnabled("unsubscribeAny",void 0,void 0),this.emit(Gi,{listener:e}),rr.get(this).delete(e);};_proto.clearListeners=function clearListeners(e){e=Array.isArray(e)?e:[e];for(var _iterator11=_createForOfIteratorHelperLoose(e),_step11;!(_step11=_iterator11()).done;){const i=_step11.value;if(this.logIfDebugEnabled("clear",i,void 0),typeof i=="string"||typeof i=="symbol"){Sr(this,i).clear();const m=jr(this,i);for(var _iterator12=_createForOfIteratorHelperLoose(m),_step12;!(_step12=_iterator12()).done;){const v=_step12.value;v.finish();}m.clear();}else{rr.get(this).clear();for(var _iterator13=_createForOfIteratorHelperLoose(bi.get(this).values()),_step13;!(_step13=_iterator13()).done;){const m=_step13.value;m.clear();}for(var _iterator14=_createForOfIteratorHelperLoose(Br.get(this).values()),_step14;!(_step14=_iterator14()).done;){const m=_step14.value;for(var _iterator15=_createForOfIteratorHelperLoose(m),_step15;!(_step15=_iterator15()).done;){const v=_step15.value;v.finish();}m.clear();}}}};_proto.listenerCount=function listenerCount(e){e=Array.isArray(e)?e:[e];let i=0;for(var _iterator16=_createForOfIteratorHelperLoose(e),_step16;!(_step16=_iterator16()).done;){const m=_step16.value;if(typeof m=="string"){i+=rr.get(this).size+Sr(this,m).size+jr(this,m).size+jr(this).size;continue;}typeof m<"u"&&Ir(m),i+=rr.get(this).size;for(var _iterator17=_createForOfIteratorHelperLoose(bi.get(this).values()),_step17;!(_step17=_iterator17()).done;){const v=_step17.value;i+=v.size;}for(var _iterator18=_createForOfIteratorHelperLoose(Br.get(this).values()),_step18;!(_step18=_iterator18()).done;){const v=_step18.value;i+=v.size;}}return i;};_proto.bindMethods=function bindMethods(e,i){if(typeof e!="object"||e===null)throw new TypeError("`target` must be an object");i=gs(i);for(var _iterator19=_createForOfIteratorHelperLoose(i),_step19;!(_step19=_iterator19()).done;){const m=_step19.value;if(e[m]!==void 0)throw new Error(`The property \`${m}\` already exists on \`target\``);Object.defineProperty(e,m,{enumerable:!1,value:this[m].bind(this)});}};(0,_createClass2.default)(yo,null,[{key:"isDebugEnabled",get:function get(){if(typeof process!="object")return so;const _ref3=process||{env:{}},e=_ref3.env;return e.DEBUG==="emittery"||e.DEBUG==="*"||so;},set:function set(e){so=e;}}]);return yo;}();const Zs=Object.getOwnPropertyNames(Pi.prototype).filter(r=>r!=="constructor");Object.defineProperty(Pi,"listenerAdded",{value:vi,writable:!1,enumerable:!0,configurable:!1});Object.defineProperty(Pi,"listenerRemoved",{value:Gi,writable:!1,enumerable:!0,configurable:!1});var a2=Pi;const No=/* @__PURE__ */c2(a2);function d2(r){return typeof r=="object"&&r!==null&&"message"in r&&typeof r.message=="string";}function h2(r){if(d2(r))return r;try{return new Error(JSON.stringify(r));}catch(_unused2){return new Error(String(r));}}function co(r){return h2(r).message;}var f2=Object.defineProperty,m2=(r,e,i)=>e in r?f2(r,e,{enumerable:!0,configurable:!0,writable:!0,value:i}):r[e]=i,p2=(r,e,i)=>(m2(r,e+"",i),i);const b2="hlg.tokbox.com/prod/logging/vcp_webrtc",y2="https://",g2=1e4;let si;const Z2=new Uint8Array(16);function v2(){if(!si&&(si=typeof crypto<"u"&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto),!si))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return si(Z2);}const Cn=[];for(let r=0;r<256;++r)Cn.push((r+256).toString(16).slice(1));function G2(r,e){if(e===void 0){e=0;}return(Cn[r[e+0]]+Cn[r[e+1]]+Cn[r[e+2]]+Cn[r[e+3]]+"-"+Cn[r[e+4]]+Cn[r[e+5]]+"-"+Cn[r[e+6]]+Cn[r[e+7]]+"-"+Cn[r[e+8]]+Cn[r[e+9]]+"-"+Cn[r[e+10]]+Cn[r[e+11]]+Cn[r[e+12]]+Cn[r[e+13]]+Cn[r[e+14]]+Cn[r[e+15]]).toLowerCase();}const X2=typeof crypto<"u"&&crypto.randomUUID&&crypto.randomUUID.bind(crypto),vs={randomUUID:X2};function W2(r,e,i){if(vs.randomUUID&&!e&&!r)return vs.randomUUID();r=r||{};const m=r.random||(r.rng||v2)();return m[6]=m[6]&15|64,m[8]=m[8]&63|128,G2(m);}function Jo(r,e){_globalThis.vonage||(_globalThis.vonage={}),_globalThis.vonage.workerizer||(_globalThis.vonage.workerizer={});let i=_globalThis.vonage.workerizer;return i[r]||(i[r]=e),i[r];}const cr=Jo("globals",{});var Gr=/* @__PURE__ */(r=>(r.INIT="INIT",r.FORWARD="FORWARD",r.TERMINATE="TERMINATE",r.GLOBALS_SYNC="GLOBALS_SYNC",r))(Gr||{});function Os(r){return[ImageBitmap,ReadableStream,WritableStream].some(e=>r instanceof e);}let V2=0;function R2(r,e,i,m,v){const S=V2++;return r.postMessage({id:S,type:e,functionName:i,args:m},m.filter(L=>Os(L))),new Promise(L=>{v==null||v.set(S,L);});}function $r(r,e){const i=r.id,m=r.type,v=Array.isArray(e)?e:[e];postMessage({id:i,type:m,result:e},v.filter(S=>Os(S)));}const Gs=Jo("workerized",{});function Ps(){return typeof WorkerGlobalScope<"u"&&self instanceof WorkerGlobalScope;}function x2(){return _x7.apply(this,arguments);}function _x7(){_x7=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee95(){var r,e,_Gs$e$workerContext,i,m;return _regenerator.default.wrap(function _callee95$(_context95){while(1)switch(_context95.prev=_context95.next){case 0:if(!Ps()){_context95.next=4;break;}$r({type:Gr.GLOBALS_SYNC},cr);_context95.next=8;break;case 4:r=[];for(e in Gs){_Gs$e$workerContext=Gs[e].workerContext,i=_Gs$e$workerContext.worker,m=_Gs$e$workerContext.resolvers;i&&r.push(R2(i,Gr.GLOBALS_SYNC,"",[cr],m));}_context95.next=8;return Promise.all(r);case 8:case"end":return _context95.stop();}},_callee95);}));return _x7.apply(this,arguments);}function Xi(r,e){if(Array.isArray(e))e.splice(0,e.length);else if(typeof e=="object")for(const i in e)delete e[i];for(const i in r)Array.isArray(r[i])?(e[i]=[],Xi(r[i],e[i])):typeof r[i]=="object"?(e[i]={},Xi(r[i],e[i])):e[i]=r[i];}function I2(_x8,_x9){return _I.apply(this,arguments);}function _I(){_I=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee96(r,e){var i,m;return _regenerator.default.wrap(function _callee96$(_context96){while(1)switch(_context96.prev=_context96.next){case 0:i=r.functionName,m=r.args;if(e.instance){_context96.next=3;break;}throw"instance not initialized";case 3:if(i){_context96.next=5;break;}throw"missing function name to call";case 5:if(e.instance[i]){_context96.next=7;break;}throw`undefined function [${i}] in class ${e.instance.constructor.workerId}`;case 7:_context96.t0=$r;_context96.t1=r;_context96.next=11;return e.instance[i](...(m!=null?m:[]));case 11:_context96.t2=_context96.sent;(0,_context96.t0)(_context96.t1,_context96.t2);case 13:case"end":return _context96.stop();}},_callee96);}));return _I.apply(this,arguments);}const S2=Jo("registeredWorkers",{});function T2(r,e){if(!r.args)throw"Missing className while initializing worker";const _r$args=r.args,i=_r$args[0],m=_r$args[1],v=S2[i];if(v)e.instance=new v(r.args.slice(1));else throw`unknown worker class ${i}`;Xi(m,cr),$r(r,typeof e.instance!==void 0);}function Y2(_x10,_x11){return _Y.apply(this,arguments);}function _Y(){_Y=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee97(r,e){var i,m;return _regenerator.default.wrap(function _callee97$(_context97){while(1)switch(_context97.prev=_context97.next){case 0:i=r.args;if(e.instance){_context97.next=3;break;}throw"instance not initialized";case 3:_context97.t0=e.instance.terminate;if(!_context97.t0){_context97.next=8;break;}_context97.next=7;return e.instance.terminate(...(i!=null?i:[]));case 7:m=_context97.sent;case 8:$r(r,m);case 9:case"end":return _context97.stop();}},_callee97);}));return _Y.apply(this,arguments);}function w2(r){if(!r.args)throw"Missing globals while syncing";Xi(r.args[0],cr),$r(r,{});}function F2(){const r={};onmessage=/*#__PURE__*/function(){var _ref4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee7(e){var i;return _regenerator.default.wrap(function _callee7$(_context7){while(1)switch(_context7.prev=_context7.next){case 0:i=e.data;_context7.t0=i.type;_context7.next=_context7.t0===Gr.INIT?4:_context7.t0===Gr.FORWARD?6:_context7.t0===Gr.TERMINATE?8:_context7.t0===Gr.GLOBALS_SYNC?10:12;break;case 4:T2(i,r);return _context7.abrupt("break",12);case 6:I2(i,r);return _context7.abrupt("break",12);case 8:Y2(i,r);return _context7.abrupt("break",12);case 10:w2(i);return _context7.abrupt("break",12);case 12:case"end":return _context7.stop();}},_callee7);}));return function onmessage(_x12){return _ref4.apply(this,arguments);};}();}Ps()&&F2();function L2(r,e){return cr[r]||(cr[r]=e),[()=>cr[r],/*#__PURE__*/function(){var _ref5=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee8(i){return _regenerator.default.wrap(function _callee8$(_context8){while(1)switch(_context8.prev=_context8.next){case 0:cr[r]=i;_context8.next=3;return x2();case 3:case"end":return _context8.stop();}},_callee8);}));return function(_x13){return _ref5.apply(this,arguments);};}()];}function H2(r,e){return L2(r,e);}const _H=H2("metadata"),C2=_H[0],N2=_H[1];function J2(r){N2(r);}function yi(){return C2();}let ko=/*#__PURE__*/function(){function ko(e,i){p2(this,"uuid"),this.config=e,this.uuid=i!=null?i:W2();}var _proto2=ko.prototype;_proto2.send=/*#__PURE__*/function(){var _send=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee9(e){var i,m,v,_ref6,S,L,T,k;return _regenerator.default.wrap(function _callee9$(_context9){while(1)switch(_context9.prev=_context9.next){case 0:_ref6=(i=yi())!=null?i:{},S=_ref6.appId,L=_ref6.sourceType;if(!(!S||!L)){_context9.next=3;break;}return _context9.abrupt("return","metadata missing");case 3:T=new AbortController(),k=setTimeout(()=>T.abort(),g2);_context9.next=6;return((v=(m=this.config)==null?void 0:m.fetch)!=null?v:fetch)(this.getUrl(),{method:"POST",headers:this.getHeaders(),body:JSON.stringify(this.buildReport(e)),signal:T.signal});case 6:clearTimeout(k);return _context9.abrupt("return","success");case 8:case"end":return _context9.stop();}},_callee9,this);}));function send(_x14){return _send.apply(this,arguments);}return send;}();_proto2.getUrl=function getUrl(){var e;let i=(e=yi().proxyUrl)!=null?e:y2;return i+=(i.at(-1)==="/"?"":"/")+b2,i;};_proto2.getHeaders=function getHeaders(){return{"Content-Type":"application/json"};};_proto2.buildReport=function buildReport(e){const i=yi();return Object.assign({guid:this.uuid},e,{applicationId:i.appId,timestamp:Date.now(),proxyUrl:i.proxyUrl,source:i.sourceType});};return ko;}();const gi="2.0.4";let k2=/*#__PURE__*/function(){function k2(e,i){this.config=e,this.frameTransformedCount=0,this.frameFromSourceCount=0,this.startAt=0,this.reporter=new ko(e,i);}var _proto3=k2.prototype;_proto3.onFrameFromSource=/*#__PURE__*/function(){var _onFrameFromSource=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee10(){return _regenerator.default.wrap(function _callee10$(_context10){while(1)switch(_context10.prev=_context10.next){case 0:this.frameFromSourceCount++;case 1:case"end":return _context10.stop();}},_callee10,this);}));function onFrameFromSource(){return _onFrameFromSource.apply(this,arguments);}return onFrameFromSource;}();_proto3.onFrameTransformed=/*#__PURE__*/function(){var _onFrameTransformed=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee11(e,i){var m,v,S,L,T,k,tt;return _regenerator.default.wrap(function _callee11$(_context11){while(1)switch(_context11.prev=_context11.next){case 0:if(e===void 0){e={};}if(i===void 0){i=!1;}this.startAt===0&&(this.startAt=Date.now()),this.frameTransformedCount++;m=this.startAt,v=this.frameTransformedCount,S=this.frameFromSourceCount,L=Date.now(),T=(L-m)/1e3,k=v/T,tt=S/T;return _context11.abrupt("return",i||this.frameTransformedCount>=this.config.loggingIntervalFrameCount?(this.frameFromSourceCount=0,this.frameTransformedCount=0,this.startAt=L,this.reporter.config=this.config,this.reporter.send(Object.assign({},this.config.report,{variation:"QoS",fps:tt,transformedFps:k,framesTransformed:v},e))):"success");case 5:case"end":return _context11.stop();}},_callee11,this);}));function onFrameTransformed(_x15,_x16){return _onFrameTransformed.apply(this,arguments);}return onFrameTransformed;}();(0,_createClass2.default)(k2,[{key:"fps",get:function get(){const e=this.startAt,i=this.frameFromSourceCount,m=(Date.now()-e)/1e3;return i/m;}}]);return k2;}();var U2=/* @__PURE__ */(r=>(r.FPS_DROP="fps_drop",r))(U2||{}),E2=/* @__PURE__ */(r=>(r.start="start",r.transform="transform",r.flush="flush",r))(E2||{}),go=/* @__PURE__ */(r=>(r.pipeline_ended="pipeline_ended",r.pipeline_ended_with_error="pipeline_ended_with_error",r.pipeline_started="pipeline_started",r.pipeline_started_with_error="pipeline_started_with_error",r.pipeline_restarted="pipeline_restarted",r.pipeline_restarted_with_error="pipeline_restarted_with_error",r))(go||{});exports.PipelineInfoData=go;exports.ErrorFunction=E2;exports.WarningType=U2;const M2=500,z2=0.8;let A2=/*#__PURE__*/function(_No){(0,_inheritsLoose2.default)(A2,_No);function A2(e,i){var _this2;_this2=_No.call(this)||this,_this2.reporter_=new ko(),_this2.reporterQos_=new k2({loggingIntervalFrameCount:M2,report:{version:gi}}),_this2.index_=i,_this2.transformer_=e,_this2.shouldStop_=!1,_this2.isFlashed_=!1,_this2.mediaTransformerQosReportStartTimestamp_=0,_this2.videoHeight_=0,_this2.videoWidth_=0,_this2.trackExpectedRate_=-1,_this2.transformerType_="Custom","getTransformerType"in e&&(_this2.transformerType_=e.getTransformerType()),_this2.report({variation:"Create"});return _this2;}var _proto4=A2.prototype;_proto4.setTrackExpectedRate=function setTrackExpectedRate(e){this.trackExpectedRate_=e;};_proto4.start=/*#__PURE__*/function(){var _start=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee12(e){var m;return _regenerator.default.wrap(function _callee12$(_context12){while(1)switch(_context12.prev=_context12.next){case 0:if(!(this.controller_=e,this.transformer_&&typeof this.transformer_.start=="function")){_context12.next=11;break;}_context12.prev=1;_context12.next=4;return this.transformer_.start(e);case 4:_context12.next=11;break;case 6:_context12.prev=6;_context12.t0=_context12["catch"](1);this.report({message:er.errors.transformer_start,variation:"Error",error:co(_context12.t0)});m={eventMetaData:{transformerIndex:this.index_},error:_context12.t0,function:"start"/* start */};this.emit("error",m);case 11:case"end":return _context12.stop();}},_callee12,this,[[1,6]]);}));function start(_x17){return _start.apply(this,arguments);}return start;}();_proto4.transform=/*#__PURE__*/function(){var _transform=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee13(e,i){var _ref7,_ref8;var m,v,L,S;return _regenerator.default.wrap(function _callee13$(_context13){while(1)switch(_context13.prev=_context13.next){case 0:if(!(this.mediaTransformerQosReportStartTimestamp_===0&&(this.mediaTransformerQosReportStartTimestamp_=Date.now()),e instanceof VideoFrame&&(this.videoHeight_=(_ref7=e==null?void 0:e.displayHeight)!=null?_ref7:0,this.videoWidth_=(_ref8=e==null?void 0:e.displayWidth)!=null?_ref8:0),this.reporterQos_.onFrameFromSource(),this.transformer_)){_context13.next=17;break;}if(!this.shouldStop_){_context13.next=5;break;}console.warn("[Pipeline] flush from transform"),e.close(),this.flush(i),i.terminate();_context13.next=17;break;case 5:_context13.prev=5;_context13.next=8;return(v=(m=this.transformer_).transform)==null?void 0:v.call(m,e,i);case 8:this.reportQos();_context13.next=16;break;case 11:_context13.prev=11;_context13.t0=_context13["catch"](5);this.report({message:er.errors.transformer_transform,variation:"Error",error:co(_context13.t0)});L={eventMetaData:{transformerIndex:this.index_},error:_context13.t0,function:"transform"/* transform */};this.emit("error",L);case 16:if(this.trackExpectedRate_!=-1&&this.trackExpectedRate_*z2>this.reporterQos_.fps){S={eventMetaData:{transformerIndex:this.index_},warningType:"fps_drop",dropInfo:{requested:this.trackExpectedRate_,current:this.reporterQos_.fps}};this.emit("warn",S);}case 17:case"end":return _context13.stop();}},_callee13,this,[[5,11]]);}));function transform(_x18,_x19){return _transform.apply(this,arguments);}return transform;}();_proto4.flush=/*#__PURE__*/function(){var _flush=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee14(e){var m;return _regenerator.default.wrap(function _callee14$(_context14){while(1)switch(_context14.prev=_context14.next){case 0:if(!(this.transformer_&&typeof this.transformer_.flush=="function"&&!this.isFlashed_)){_context14.next=12;break;}this.isFlashed_=!0;_context14.prev=2;_context14.next=5;return this.transformer_.flush(e);case 5:_context14.next=12;break;case 7:_context14.prev=7;_context14.t0=_context14["catch"](2);this.report({message:er.errors.transformer_flush,variation:"Error",error:co(_context14.t0)});m={eventMetaData:{transformerIndex:this.index_},error:_context14.t0,function:"flush"/* flush */};this.emit("error",m);case 12:this.reportQos(!0),this.report({variation:"Delete"});case 13:case"end":return _context14.stop();}},_callee14,this,[[2,7]]);}));function flush(_x20){return _flush.apply(this,arguments);}return flush;}();_proto4.stop=function stop(){console.log("[Pipeline] Stop stream."),this.controller_&&(this.flush(this.controller_),this.controller_.terminate()),this.shouldStop_=!0;};_proto4.report=function report(e){this.reporter_.send(Object.assign({version:gi,action:"MediaTransformer",transformerType:this.transformerType_},e));};_proto4.reportQos=function reportQos(e){if(e===void 0){e=!1;}this.reporterQos_.config=Object.assign({},this.reporterQos_.config),this.reporterQos_.onFrameTransformed({version:gi,action:"MediaTransformer",transformerType:this.transformerType_,videoWidth:this.videoWidth_,videoHeight:this.videoHeight_},e);};return A2;}(No);let B2=/*#__PURE__*/function(_No2){(0,_inheritsLoose2.default)(B2,_No2);function B2(e){var _this3;_this3=_No2.call(this)||this,_this3.transformers_=[],_this3.trackExpectedRate_=-1;for(let i=0;i<e.length;i++){let m=new A2(e[i],i);m.on("error",v=>{_this3.emit("error",v);}),m.on("warn",v=>{_this3.emit("warn",v);}),_this3.transformers_.push(m);}return _this3;}var _proto5=B2.prototype;_proto5.setTrackExpectedRate=function setTrackExpectedRate(e){this.trackExpectedRate_=e;for(var _iterator20=_createForOfIteratorHelperLoose(this.transformers_),_step20;!(_step20=_iterator20()).done;){let i=_step20.value;i.setTrackExpectedRate(this.trackExpectedRate_);}};_proto5.start=/*#__PURE__*/function(){var _start2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee17(e,i){var _this4=this;var m,_iterator21,_step21,v;return _regenerator.default.wrap(function _callee17$(_context17){while(1)switch(_context17.prev=_context17.next){case 0:if(!(!this.transformers_||this.transformers_.length===0)){_context17.next=3;break;}console.log("[Pipeline] No transformers.");return _context17.abrupt("return");case 3:_context17.prev=3;m=e;for(_iterator21=_createForOfIteratorHelperLoose(this.transformers_);!(_step21=_iterator21()).done;){v=_step21.value;e=e.pipeThrough(new TransformStream(v));}e.pipeTo(i).then(/*#__PURE__*/(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee15(){return _regenerator.default.wrap(function _callee15$(_context15){while(1)switch(_context15.prev=_context15.next){case 0:console.log("[Pipeline] Setup.");_context15.next=3;return i.abort();case 3:_context15.next=5;return m.cancel();case 5:_this4.emit("pipelineInfo","pipeline_ended"/* pipeline_ended */);case 6:case"end":return _context15.stop();}},_callee15);}))).catch(/*#__PURE__*/function(){var _ref10=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee16(v){return _regenerator.default.wrap(function _callee16$(_context16){while(1)switch(_context16.prev=_context16.next){case 0:e.cancel().then(()=>{console.log("[Pipeline] Shutting down streams after abort.");}).catch(S=>{console.error("[Pipeline] Error from stream transform:",S);});_context16.next=3;return i.abort(v);case 3:_context16.next=5;return m.cancel(v);case 5:_this4.emit("pipelineInfo","pipeline_ended_with_error"/* pipeline_ended_with_error */);case 6:case"end":return _context16.stop();}},_callee16);}));return function(_x23){return _ref10.apply(this,arguments);};}());_context17.next=13;break;case 9:_context17.prev=9;_context17.t0=_context17["catch"](3);this.emit("pipelineInfo","pipeline_started_with_error"/* pipeline_started_with_error */),this.destroy();return _context17.abrupt("return");case 13:this.emit("pipelineInfo","pipeline_started"/* pipeline_started */),console.log("[Pipeline] Pipeline started.");case 14:case"end":return _context17.stop();}},_callee17,this,[[3,9]]);}));function start(_x21,_x22){return _start2.apply(this,arguments);}return start;}();_proto5.destroy=/*#__PURE__*/function(){var _destroy=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee18(){var _iterator22,_step22,e;return _regenerator.default.wrap(function _callee18$(_context18){while(1)switch(_context18.prev=_context18.next){case 0:console.log("[Pipeline] Destroying Pipeline.");for(_iterator22=_createForOfIteratorHelperLoose(this.transformers_);!(_step22=_iterator22()).done;){e=_step22.value;e.stop();}case 2:case"end":return _context18.stop();}},_callee18,this);}));function destroy(){return _destroy.apply(this,arguments);}return destroy;}();return B2;}(No);let j2=/*#__PURE__*/function(_No3){(0,_inheritsLoose2.default)(j2,_No3);function j2(){var _this5;_this5=_No3.call(this)||this,_this5.reporter_=new ko(),_this5.trackExpectedRate_=-1,_this5.report({variation:"Create"});return _this5;}/**
   * Sets the expected rate of the track per second.
   * The media processor will use this number for calculating drops in the rate.
   * This could happen when the transformation will take more time than expected.
   * This will not cause an error, just warning to the client.
   * Mostly:
   * Video: 30 frames per second
   * Audio: 50 audio data per second for OPUS
   * In case of increased frame dropping rate a warning will be emitted according to info [here](/docs/intro#errors-and-warnings-listener).
   * ***This is an optional method.***
   * @param trackExpectedRate - number holds the predicted track rate.
   */var _proto6=j2.prototype;_proto6.setTrackExpectedRate=function setTrackExpectedRate(e){this.trackExpectedRate_=e,this.pipeline_&&this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);}/**
   * Starts running the tranformation logic performed by the media processor instance.
   * When running an instance of this class on a Web worker thread the call for this function should be made by the user. See example [here](/docs/intro#webworker-code).
   * When running an instance of this class on the application main thread there is no need to call this method given it will be called by the `MediaProcessorConnector` instance.
   *
   * @param readable Readable stream associated to the media source being processed.
   * @param writable Writable stream associated to the resulting media once processed.
   *
   * @returns
   */;_proto6.transform=function transform(e,i){return this.readable_=e,this.writable_=i,this.transformInternal();}/**
   * @private
   */;_proto6.transformInternal=function transformInternal(){var _this6=this;return new Promise(/*#__PURE__*/function(){var _ref11=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee19(e,i){var m;return _regenerator.default.wrap(function _callee19$(_context19){while(1)switch(_context19.prev=_context19.next){case 0:if(!(!_this6.transformers_||_this6.transformers_.length===0)){_context19.next=3;break;}_this6.report({message:er.errors.transformer_none,variation:"Error"}),i("[MediaProcessor] Need to set transformers.");return _context19.abrupt("return");case 3:if(_this6.readable_){_context19.next=6;break;}_this6.report({variation:"Error",message:er.errors.readable_null}),i("[MediaProcessor] Readable is null.");return _context19.abrupt("return");case 6:if(_this6.writable_){_context19.next=9;break;}_this6.report({variation:"Error",message:er.errors.writable_null}),i("[MediaProcessor] Writable is null.");return _context19.abrupt("return");case 9:m=!1;_this6.pipeline_&&(m=!0,_this6.pipeline_.clearListeners(),_this6.pipeline_.destroy()),_this6.pipeline_=new B2(_this6.transformers_),_this6.pipeline_.on("warn",v=>{_this6.emit("warn",v);}),_this6.pipeline_.on("error",v=>{_this6.emit("error",v);}),_this6.pipeline_.on("pipelineInfo",v=>{m&&(v==="pipeline_started"?v=go.pipeline_restarted:v==="pipeline_started_with_error"&&(v=go.pipeline_restarted_with_error)),_this6.emit("pipelineInfo",v);}),_this6.trackExpectedRate_!=-1&&_this6.pipeline_.setTrackExpectedRate(_this6.trackExpectedRate_),_this6.pipeline_.start(_this6.readable_,_this6.writable_).then(()=>{e();}).catch(v=>{i(v);});case 11:case"end":return _context19.stop();}},_callee19);}));return function(_x24,_x25){return _ref11.apply(this,arguments);};}());}/**
   * Sets an array of transfromer instances that will be hold and ran by the media processor instance.
   * See example [here](/docs/intro#main-code)
   *
   * @param transformers An array of transformer instances.
   *
   * @returns
   */;_proto6.setTransformers=function setTransformers(e){return this.report({variation:"Update",message:er.updates.transformer_new}),this.transformers_=e,this.readable_&&this.writable_?this.transformInternal():Promise.resolve();}/**
   * Stops running the tranformation logic performed by the media processor instance.
   * @returns
   */;_proto6.destroy=function destroy(){var _this7=this;return new Promise(/*#__PURE__*/function(){var _ref12=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee20(e){return _regenerator.default.wrap(function _callee20$(_context20){while(1)switch(_context20.prev=_context20.next){case 0:_this7.pipeline_&&_this7.pipeline_.destroy(),_this7.report({variation:"Delete"}),e();case 1:case"end":return _context20.stop();}},_callee20);}));return function(_x26){return _ref12.apply(this,arguments);};}());};_proto6.report=function report(e){this.reporter_.send(Object.assign({version:gi,action:"MediaProcessor"},e));};return j2;}(No);let K2=/*#__PURE__*/function(){function K2(){this.processor_=null,this.generator_=null;}var _proto7=K2.prototype;_proto7.init=function init(e){return new Promise((i,m)=>{try{this.processor_=new MediaStreamTrackProcessor(e);}catch(v){console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${v}`),m(v);}try{e.kind==="audio"?this.generator_=new MediaStreamTrackGenerator({kind:"audio"}):e.kind==="video"?this.generator_=new MediaStreamTrackGenerator({kind:"video"}):m("kind not supported");}catch(v){console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${v}`),m(v);}i();});};_proto7.getReadable=function getReadable(){return this.processor_.readable;};_proto7.getWriteable=function getWriteable(){return this.generator_.writable;};_proto7.getProccesorTrack=function getProccesorTrack(){return this.generator_;};return K2;}();let O2=/*#__PURE__*/function(){/**
   * - When running insertable streams on the main `MediaProcessorInterface` should be instance of `MediaProcessor` class.
   * - When running insertable streams on WebWorker `MediaProcessorInterface` should be instance of bridge calss created by the user. Example can be found [here](/docs/intro.md#using-the-transformer-on-webworker)
   * @param vonageMediaProcessor - MediaProcessorInterface.
   */function O2(e){this.insertableStreamHelper_=new K2(),this.mediaProcessor_=e;}/**
   * @private
   * Sets the media stream track instance to be processed.
   *
   * @param track MediaStreamTrack (audio or video) to be processed.
   *
   * @returns New track to be used.
   */var _proto8=O2.prototype;_proto8.setTrack=function setTrack(e){return new Promise((i,m)=>{this.insertableStreamHelper_.init(e).then(()=>{this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(),this.insertableStreamHelper_.getWriteable()).then(()=>{i(this.insertableStreamHelper_.getProccesorTrack());}).catch(v=>{m(v);});}).catch(v=>{m(v);});});}/**
   * @private
   * Stops the media processing being performed.
   */;_proto8.destroy=function destroy(){return new Promise((e,i)=>{this.mediaProcessor_?this.mediaProcessor_.destroy().then(()=>{e();}).catch(m=>{i(m);}):i("no processor");});};return O2;}();var Zi=/* @__PURE__ */(r=>(r.Low="Low",r.High="High",r))(Zi||{}),P2=/* @__PURE__ */(r=>(r.BackgroundBlur="BackgroundBlur",r.VirtualBackground="VirtualBackground",r.VideoBackground="VideoBackground",r.SilhouetteBlur="SilhouetteBlur",r))(P2||{}),Zo=/* @__PURE__ */(r=>(r.FAST="FAST",r.PRECISE="PRECISE",r))(Zo||{}),Wi=/* @__PURE__ */(r=>(r.CANVAS="CANVAS",r.WEBGL="WEBGL",r))(Wi||{});exports.RenderingType=Wi;exports.WebglSelfieSegmentationType=Zo;exports.BackgroundTransformerType=P2;exports.BlurRadius=Zi;const _2=/*#__PURE__*/function(){var _ref13=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee21(){return _regenerator.default.wrap(function _callee21$(_context21){while(1)switch(_context21.prev=_context21.next){case 0:return _context21.abrupt("return",WebAssembly.validate(new Uint8Array([0,97,115,109,1,0,0,0,1,5,1,96,0,1,123,3,2,1,0,10,10,1,8,0,65,0,253,15,253,98,11])));case 1:case"end":return _context21.stop();}},_callee21);}));return function _2(){return _ref13.apply(this,arguments);};}();function T3(){return _T.apply(this,arguments);}function _T(){_T=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee98(){var _yield$Q,r,e,i,m;return _regenerator.default.wrap(function _callee98$(_context98){while(1)switch(_context98.prev=_context98.next){case 0:_context98.next=2;return Q2();case 2:_yield$Q=_context98.sent;r=_yield$Q.wasm;e=_yield$Q.insertableStreams;i=_yield$Q.simd;m=_yield$Q.webgl;if(r.supported){_context98.next=9;break;}throw r.message;case 9:if(e.supported){_context98.next=11;break;}throw e.message;case 11:if(i.supported){_context98.next=13;break;}throw i.message;case 13:if(m.supported){_context98.next=15;break;}throw m.message;case 15:case"end":return _context98.stop();}},_callee98);}));return _T.apply(this,arguments);}function Q2(){return _Q.apply(this,arguments);}function _Q(){_Q=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee99(){var r;return _regenerator.default.wrap(function _callee99$(_context99){while(1)switch(_context99.prev=_context99.next){case 0:_context99.t0={supported:typeof WebAssembly=="object"&&typeof WebAssembly.instantiate=="function",message:"Your browser does not support WebAssembly features."};_context99.next=3;return _2();case 3:_context99.t1=_context99.sent;_context99.t2={supported:_context99.t1,message:"Your browser does not support simd features."};_context99.t3={supported:!0};_context99.t4={message:"Your browser does not support gpu features.",supported:!0// This is a legacy check from the previous segmentation engine. now we just return true always
};_context99.t5=D2();_context99.t6=_s();r={wasm:_context99.t0,simd:_context99.t2,insertableStreams:_context99.t3,gpu:_context99.t4,webgl:_context99.t5,performance:_context99.t6};_context99.prev=10;_context99.next=13;return l2();case 13:_context99.next=18;break;case 15:_context99.prev=15;_context99.t7=_context99["catch"](10);r.insertableStreams.supported=!1,r.insertableStreams.message=_context99.t7;case 18:return _context99.abrupt("return",r);case 19:case"end":return _context99.stop();}},_callee99,null,[[10,15]]);}));return _Q.apply(this,arguments);}function D2(){if(!OffscreenCanvas)return{supported:!1,message:"Your browser does not support offscreen canvas"};const e=new OffscreenCanvas(0,0).getContext("webgl2");if(e){const i=e==null?void 0:e.getExtension("WEBGL_lose_context");i&&i.loseContext();}else return{supported:!1,message:"Your browser does not support webgl 2"};return{supported:!0};}function _s(){const e=new OffscreenCanvas(0,0).getContext("webgl2",{failIfMajorPerformanceCaveat:!0});if(e){const i=e==null?void 0:e.getExtension("WEBGL_lose_context");i&&i.loseContext();}else return{supported:!1,message:"Your hardware does not perform good enough to run the library efficiently"};return{supported:!0};}const Vi={};(function(){var r;function e(p){var W=0;return function(){return W<p.length?{done:!1,value:p[W++]}:{done:!0};};}var i=typeof Object.defineProperties=="function"?Object.defineProperty:function(p,W,V){return p==Array.prototype||p==Object.prototype||(p[W]=V.value),p;};function m(p){p=[typeof globalThis=="object"&&globalThis,p,typeof window=="object"&&window,typeof self=="object"&&self,typeof (typeof window !== undefined ? window : global)=="object"&&(typeof window !== undefined ? window : global)];for(var W=0;W<p.length;++W){var V=p[W];if(V&&V.Math==Math)return V;}throw Error("Cannot find global object");}var v=m(this);function S(p,W){if(W)t:{var V=v;p=p.split(".");for(var U=0;U<p.length-1;U++){var O=p[U];if(!(O in V))break t;V=V[O];}p=p[p.length-1],U=V[p],W=W(U),W!=U&&W!=null&&i(V,p,{configurable:!0,writable:!0,value:W});}}S("Symbol",function(p){function W(rt){if(this instanceof W)throw new TypeError("Symbol is not a constructor");return new V(U+(rt||"")+"_"+O++,rt);}function V(rt,K){this.g=rt,i(this,"description",{configurable:!0,writable:!0,value:K});}if(p)return p;V.prototype.toString=function(){return this.g;};var U="jscomp_symbol_"+(1e9*Math.random()>>>0)+"_",O=0;return W;}),S("Symbol.iterator",function(p){if(p)return p;p=Symbol("Symbol.iterator");for(var W="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),V=0;V<W.length;V++){var U=v[W[V]];typeof U=="function"&&typeof U.prototype[p]!="function"&&i(U.prototype,p,{configurable:!0,writable:!0,value:function value(){return L(e(this));}});}return p;});function L(p){return p={next:p},p[Symbol.iterator]=function(){return this;},p;}function T(p){var W=typeof Symbol<"u"&&Symbol.iterator&&p[Symbol.iterator];return W?W.call(p):{next:e(p)};}function k(p){if(!(p instanceof Array)){p=T(p);for(var W,V=[];!(W=p.next()).done;)V.push(W.value);p=V;}return p;}var tt=typeof Object.create=="function"?Object.create:function(p){function W(){}return W.prototype=p,new W();},st;if(typeof Object.setPrototypeOf=="function")st=Object.setPrototypeOf;else{var bt;t:{var xt={a:!0},Yt={};try{Yt.__proto__=xt,bt=Yt.a;break t;}catch(_unused4){}bt=!1;}st=bt?function(p,W){if(p.__proto__=W,p.__proto__!==W)throw new TypeError(p+" is not extensible");return p;}:null;}var at=st;function ht(p,W){if(p.prototype=tt(W.prototype),p.prototype.constructor=p,at)at(p,W);else for(var V in W)if(V!="prototype")if(Object.defineProperties){var U=Object.getOwnPropertyDescriptor(W,V);U&&Object.defineProperty(p,V,U);}else p[V]=W[V];p.ea=W.prototype;}function Ut(){this.l=!1,this.i=null,this.h=void 0,this.g=1,this.s=this.m=0,this.j=null;}function Mt(p){if(p.l)throw new TypeError("Generator is already running");p.l=!0;}Ut.prototype.o=function(p){this.h=p;};function oe(p,W){p.j={U:W,V:!0},p.g=p.m||p.s;}Ut.prototype.return=function(p){this.j={return:p},this.g=this.s;};function D(p,W,V){return p.g=V,{value:W};}function hn(p){this.g=new Ut(),this.h=p;}function bn(p,W){Mt(p.g);var V=p.g.i;return V?ge(p,"return"in V?V.return:function(U){return{value:U,done:!0};},W,p.g.return):(p.g.return(W),Kt(p));}function ge(p,W,V,U){try{var O=W.call(p.g.i,V);if(!(O instanceof Object))throw new TypeError("Iterator result "+O+" is not an object");if(!O.done)return p.g.l=!1,O;var rt=O.value;}catch(K){return p.g.i=null,oe(p.g,K),Kt(p);}return p.g.i=null,U.call(p.g,rt),Kt(p);}function Kt(p){for(;p.g.g;)try{var W=p.h(p.g);if(W)return p.g.l=!1,{value:W.value,done:!1};}catch(V){p.g.h=void 0,oe(p.g,V);}if(p.g.l=!1,p.g.j){if(W=p.g.j,p.g.j=null,W.V)throw W.U;return{value:W.return,done:!0};}return{value:void 0,done:!0};}function jn(p){this.next=function(W){return Mt(p.g),p.g.i?W=ge(p,p.g.i.next,W,p.g.o):(p.g.o(W),W=Kt(p)),W;},this.throw=function(W){return Mt(p.g),p.g.i?W=ge(p,p.g.i.throw,W,p.g.o):(oe(p.g,W),W=Kt(p)),W;},this.return=function(W){return bn(p,W);},this[Symbol.iterator]=function(){return this;};}function ue(p,W){return W=new jn(new hn(W)),at&&p.prototype&&at(W,p.prototype),W;}function yt(p,W){p instanceof String&&(p+="");var V=0,U=!1,O={next:function next(){if(!U&&V<p.length){var rt=V++;return{value:W(rt,p[rt]),done:!1};}return U=!0,{done:!0,value:void 0};}};return O[Symbol.iterator]=function(){return O;},O;}var Kn=typeof Object.assign=="function"?Object.assign:function(p,W){for(var V=1;V<arguments.length;V++){var U=arguments[V];if(U)for(var O in U)Object.prototype.hasOwnProperty.call(U,O)&&(p[O]=U[O]);}return p;};S("Object.assign",function(p){return p||Kn;}),S("Promise",function(p){function W(K){this.h=0,this.i=void 0,this.g=[],this.o=!1;var nt=this.j();try{K(nt.resolve,nt.reject);}catch(dt){nt.reject(dt);}}function V(){this.g=null;}function U(K){return K instanceof W?K:new W(function(nt){nt(K);});}if(p)return p;V.prototype.h=function(K){if(this.g==null){this.g=[];var nt=this;this.i(function(){nt.l();});}this.g.push(K);};var O=v.setTimeout;V.prototype.i=function(K){O(K,0);},V.prototype.l=function(){for(;this.g&&this.g.length;){var K=this.g;this.g=[];for(var nt=0;nt<K.length;++nt){var dt=K[nt];K[nt]=null;try{dt();}catch(vt){this.j(vt);}}}this.g=null;},V.prototype.j=function(K){this.i(function(){throw K;});},W.prototype.j=function(){function K(vt){return function(Ct){dt||(dt=!0,vt.call(nt,Ct));};}var nt=this,dt=!1;return{resolve:K(this.C),reject:K(this.l)};},W.prototype.C=function(K){if(K===this)this.l(new TypeError("A Promise cannot resolve to itself"));else if(K instanceof W)this.F(K);else{t:switch(typeof K){case"object":var nt=K!=null;break t;case"function":nt=!0;break t;default:nt=!1;}nt?this.u(K):this.m(K);}},W.prototype.u=function(K){var nt=void 0;try{nt=K.then;}catch(dt){this.l(dt);return;}typeof nt=="function"?this.G(nt,K):this.m(K);},W.prototype.l=function(K){this.s(2,K);},W.prototype.m=function(K){this.s(1,K);},W.prototype.s=function(K,nt){if(this.h!=0)throw Error("Cannot settle("+K+", "+nt+"): Promise already settled in state"+this.h);this.h=K,this.i=nt,this.h===2&&this.D(),this.A();},W.prototype.D=function(){var K=this;O(function(){if(K.B()){var nt=v.console;typeof nt<"u"&&nt.error(K.i);}},1);},W.prototype.B=function(){if(this.o)return!1;var K=v.CustomEvent,nt=v.Event,dt=v.dispatchEvent;return typeof dt>"u"?!0:(typeof K=="function"?K=new K("unhandledrejection",{cancelable:!0}):typeof nt=="function"?K=new nt("unhandledrejection",{cancelable:!0}):(K=v.document.createEvent("CustomEvent"),K.initCustomEvent("unhandledrejection",!1,!0,K)),K.promise=this,K.reason=this.i,dt(K));},W.prototype.A=function(){if(this.g!=null){for(var K=0;K<this.g.length;++K)rt.h(this.g[K]);this.g=null;}};var rt=new V();return W.prototype.F=function(K){var nt=this.j();K.J(nt.resolve,nt.reject);},W.prototype.G=function(K,nt){var dt=this.j();try{K.call(nt,dt.resolve,dt.reject);}catch(vt){dt.reject(vt);}},W.prototype.then=function(K,nt){function dt(jt,wt){return typeof jt=="function"?function(Vt){try{vt(jt(Vt));}catch(Ht){Ct(Ht);}}:wt;}var vt,Ct,Tt=new W(function(jt,wt){vt=jt,Ct=wt;});return this.J(dt(K,vt),dt(nt,Ct)),Tt;},W.prototype.catch=function(K){return this.then(void 0,K);},W.prototype.J=function(K,nt){function dt(){switch(vt.h){case 1:K(vt.i);break;case 2:nt(vt.i);break;default:throw Error("Unexpected state: "+vt.h);}}var vt=this;this.g==null?rt.h(dt):this.g.push(dt),this.o=!0;},W.resolve=U,W.reject=function(K){return new W(function(nt,dt){dt(K);});},W.race=function(K){return new W(function(nt,dt){for(var vt=T(K),Ct=vt.next();!Ct.done;Ct=vt.next())U(Ct.value).J(nt,dt);});},W.all=function(K){var nt=T(K),dt=nt.next();return dt.done?U([]):new W(function(vt,Ct){function Tt(Vt){return function(Ht){jt[Vt]=Ht,wt--,wt==0&&vt(jt);};}var jt=[],wt=0;do jt.push(void 0),wt++,U(dt.value).J(Tt(jt.length-1),Ct),dt=nt.next();while(!dt.done);});},W;}),S("Object.is",function(p){return p||function(W,V){return W===V?W!==0||1/W===1/V:W!==W&&V!==V;};}),S("Array.prototype.includes",function(p){return p||function(W,V){var U=this;U instanceof String&&(U=String(U));var O=U.length;for(V=V||0,0>V&&(V=Math.max(V+O,0));V<O;V++){var rt=U[V];if(rt===W||Object.is(rt,W))return!0;}return!1;};}),S("String.prototype.includes",function(p){return p||function(W,V){if(this==null)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(W instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return this.indexOf(W,V||0)!==-1;};}),S("Array.prototype.keys",function(p){return p||function(){return yt(this,function(W){return W;});};});var On=this||self;function Xe(p,W){p=p.split(".");var V=On;p[0]in V||typeof V.execScript>"u"||V.execScript("var "+p[0]);for(var U;p.length&&(U=p.shift());)p.length||W===void 0?V[U]&&V[U]!==Object.prototype[U]?V=V[U]:V=V[U]={}:V[U]=W;}function Lt(p,W){return W=String.fromCharCode.apply(null,W),p==null?W:p+W;}var Ye,nn=typeof TextDecoder<"u",yn,Yn=typeof TextEncoder<"u";function Vn(p){if(Yn)p=(yn||(yn=new TextEncoder())).encode(p);else{var W=void 0;W=W===void 0?!1:W;for(var V=0,U=new Uint8Array(3*p.length),O=0;O<p.length;O++){var rt=p.charCodeAt(O);if(128>rt)U[V++]=rt;else{if(2048>rt)U[V++]=rt>>6|192;else{if(55296<=rt&&57343>=rt){if(56319>=rt&&O<p.length){var K=p.charCodeAt(++O);if(56320<=K&&57343>=K){rt=1024*(rt-55296)+K-56320+65536,U[V++]=rt>>18|240,U[V++]=rt>>12&63|128,U[V++]=rt>>6&63|128,U[V++]=rt&63|128;continue;}else O--;}if(W)throw Error("Found an unpaired surrogate");rt=65533;}U[V++]=rt>>12|224,U[V++]=rt>>6&63|128;}U[V++]=rt&63|128;}}p=U.subarray(0,V);}return p;}var Ln={},rn=null;function un(p,W){W===void 0&&(W=0),gn(),W=Ln[W];for(var V=Array(Math.floor(p.length/3)),U=W[64]||"",O=0,rt=0;O<p.length-2;O+=3){var K=p[O],nt=p[O+1],dt=p[O+2],vt=W[K>>2];K=W[(K&3)<<4|nt>>4],nt=W[(nt&15)<<2|dt>>6],dt=W[dt&63],V[rt++]=vt+K+nt+dt;}switch(vt=0,dt=U,p.length-O){case 2:vt=p[O+1],dt=W[(vt&15)<<2]||U;case 1:p=p[O],V[rt]=W[p>>2]+W[(p&3)<<4|vt>>4]+dt+U;}return V.join("");}function Jn(p){var W=p.length,V=3*W/4;V%3?V=Math.floor(V):"=.".indexOf(p[W-1])!=-1&&(V="=.".indexOf(p[W-2])!=-1?V-2:V-1);var U=new Uint8Array(V),O=0;return wn(p,function(rt){U[O++]=rt;}),U.subarray(0,O);}function wn(p,W){function V(dt){for(;U<p.length;){var vt=p.charAt(U++),Ct=rn[vt];if(Ct!=null)return Ct;if(!/^[\s\xa0]*$/.test(vt))throw Error("Unknown base64 encoding at char: "+vt);}return dt;}gn();for(var U=0;;){var O=V(-1),rt=V(0),K=V(64),nt=V(64);if(nt===64&&O===-1)break;W(O<<2|rt>>4),K!=64&&(W(rt<<4&240|K>>2),nt!=64&&W(K<<6&192|nt));}}function gn(){if(!rn){rn={};for(var p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),W=["+/=","+/","-_=","-_.","-_"],V=0;5>V;V++){var U=p.concat(W[V].split(""));Ln[V]=U;for(var O=0;O<U.length;O++){var rt=U[O];rn[rt]===void 0&&(rn[rt]=O);}}}}var on=typeof Uint8Array.prototype.slice=="function",Rn;function Zn(p,W,V){return W===V?Rn||(Rn=new Uint8Array(0)):on?p.slice(W,V):new Uint8Array(p.subarray(W,V));}var be=0,We=0;function Pe(p,W){W=W===void 0?{}:W,W=W.v===void 0?!1:W.v,this.h=null,this.g=this.i=this.j=0,this.l=!1,this.v=W,p&&pe(this,p);}function pe(p,W){W=W.constructor===Uint8Array?W:W.constructor===ArrayBuffer?new Uint8Array(W):W.constructor===Array?new Uint8Array(W):W.constructor===String?Jn(W):W instanceof Uint8Array?new Uint8Array(W.buffer,W.byteOffset,W.byteLength):new Uint8Array(0),p.h=W,p.j=0,p.i=p.h.length,p.g=p.j;}Pe.prototype.reset=function(){this.g=this.j;};function ye(p){var W=p.h,V=W[p.g],U=V&127;return 128>V?(p.g+=1,U):(V=W[p.g+1],U|=(V&127)<<7,128>V?(p.g+=2,U):(V=W[p.g+2],U|=(V&127)<<14,128>V?(p.g+=3,U):(V=W[p.g+3],U|=(V&127)<<21,128>V?(p.g+=4,U):(V=W[p.g+4],U|=(V&15)<<28,128>V?(p.g+=5,U>>>0):(p.g+=5,128<=W[p.g++]&&128<=W[p.g++]&&128<=W[p.g++]&&128<=W[p.g++]&&p.g++,U)))));}function De(p){var W=p.h[p.g],V=p.h[p.g+1],U=p.h[p.g+2],O=p.h[p.g+3];return p.g+=4,V=(W<<0|V<<8|U<<16|O<<24)>>>0,p=2*(V>>31)+1,W=V>>>23&255,V&=8388607,W==255?V?NaN:1/0*p:W==0?p*Math.pow(2,-149)*V:p*Math.pow(2,W-150)*(V+Math.pow(2,23));}var Ce=[];function Pt(){this.g=new Uint8Array(64),this.h=0;}Pt.prototype.push=function(p){if(!(this.h+1<this.g.length)){var W=this.g;this.g=new Uint8Array(Math.ceil(1+2*this.g.length)),this.g.set(W);}this.g[this.h++]=p;},Pt.prototype.length=function(){return this.h;},Pt.prototype.end=function(){var p=this.g,W=this.h;return this.h=0,Zn(p,0,W);};function de(p,W){for(;127<W;)p.push(W&127|128),W>>>=7;p.push(W);}function we(p){var W={},V=W.N===void 0?!1:W.N;this.o={v:W.v===void 0?!1:W.v},this.N=V,W=this.o,Ce.length?(V=Ce.pop(),W&&(V.v=W.v),p&&pe(V,p),p=V):p=new Pe(p,W),this.g=p,this.m=this.g.g,this.h=this.i=this.l=-1,this.j=!1;}we.prototype.reset=function(){this.g.reset(),this.h=this.l=-1;};function Jt(p){var W=p.g;if((W=W.g==W.i)||(W=p.j)||(W=p.g,W=W.l||0>W.g||W.g>W.i),W)return!1;p.m=p.g.g,W=ye(p.g);var V=W&7;return V!=0&&V!=5&&V!=1&&V!=2&&V!=3&&V!=4?(p.j=!0,!1):(p.i=W,p.l=W>>>3,p.h=V,!0);}function Ze(p){switch(p.h){case 0:if(p.h!=0)Ze(p);else{for(p=p.g;p.h[p.g]&128;)p.g++;p.g++;}break;case 1:p.h!=1?Ze(p):(p=p.g,p.g+=8);break;case 2:if(p.h!=2)Ze(p);else{var W=ye(p.g);p=p.g,p.g+=W;}break;case 5:p.h!=5?Ze(p):(p=p.g,p.g+=4);break;case 3:W=p.l;do{if(!Jt(p)){p.j=!0;break;}if(p.h==4){p.l!=W&&(p.j=!0);break;}Ze(p);}while(!0);break;default:p.j=!0;}}function _t(p,W,V){var U=p.g.i,O=ye(p.g);return O=p.g.g+O,p.g.i=O,V(W,p),p.g.g=O,p.g.i=U,W;}function ae(p){var W=ye(p.g);p=p.g;var V=p.g;p.g+=W,p=p.h;var U;if(nn)(U=Ye)||(U=Ye=new TextDecoder("utf-8",{fatal:!1})),U=U.decode(p.subarray(V,V+W));else{W=V+W;for(var O=[],rt=null,K,nt,dt;V<W;)K=p[V++],128>K?O.push(K):224>K?V>=W?O.push(65533):(nt=p[V++],194>K||(nt&192)!==128?(V--,O.push(65533)):O.push((K&31)<<6|nt&63)):240>K?V>=W-1?O.push(65533):(nt=p[V++],(nt&192)!==128||K===224&&160>nt||K===237&&160<=nt||((U=p[V++])&192)!==128?(V--,O.push(65533)):O.push((K&15)<<12|(nt&63)<<6|U&63)):244>=K?V>=W-2?O.push(65533):(nt=p[V++],(nt&192)!==128||(K<<28)+(nt-144)>>30||((U=p[V++])&192)!==128||((dt=p[V++])&192)!==128?(V--,O.push(65533)):(K=(K&7)<<18|(nt&63)<<12|(U&63)<<6|dt&63,K-=65536,O.push((K>>10&1023)+55296,(K&1023)+56320))):O.push(65533),8192<=O.length&&(rt=Lt(rt,O),O.length=0);U=Lt(rt,O);}return U;}function xe(){this.h=[],this.i=0,this.g=new Pt();}function _e(p,W){W.length!==0&&(p.h.push(W),p.i+=W.length);}function me(p){var W=p.i+p.g.length();if(W===0)return new Uint8Array(0);W=new Uint8Array(W);for(var V=p.h,U=V.length,O=0,rt=0;rt<U;rt++){var K=V[rt];K.length!==0&&(W.set(K,O),O+=K.length);}return V=p.g,U=V.h,U!==0&&(W.set(V.g.subarray(0,U),O),V.h=0),p.h=[W],W;}function zt(p,W,V){if(V!=null){de(p.g,8*W+5),p=p.g;var U=V;U=(V=0>U?1:0)?-U:U,U===0?0<1/U?be=We=0:(We=0,be=2147483648):isNaN(U)?(We=0,be=2147483647):34028234663852886e22<U?(We=0,be=(V<<31|2139095040)>>>0):11754943508222875e-54>U?(U=Math.round(U/Math.pow(2,-149)),We=0,be=(V<<31|U)>>>0):(W=Math.floor(Math.log(U)/Math.LN2),U*=Math.pow(2,-W),U=Math.round(8388608*U)&8388607,We=0,be=(V<<31|W+127<<23|U)>>>0),V=be,p.push(V>>>0&255),p.push(V>>>8&255),p.push(V>>>16&255),p.push(V>>>24&255);}}var Je=typeof Uint8Array=="function";function Ae(p,W,V){if(p!=null)return typeof p=="object"?Je&&p instanceof Uint8Array?V(p):ve(p,W,V):W(p);}function ve(p,W,V){if(Array.isArray(p)){for(var U=Array(p.length),O=0;O<p.length;O++)U[O]=Ae(p[O],W,V);return Array.isArray(p)&&p.W&&an(U),U;}U={};for(O in p)U[O]=Ae(p[O],W,V);return U;}function Sn(p){return typeof p=="number"?isFinite(p)?p:String(p):p;}var $e={W:{value:!0,configurable:!0}};function an(p){return Array.isArray(p)&&!Object.isFrozen(p)&&Object.defineProperties(p,$e),p;}var fn;function he(p,W,V){var U=fn;fn=null,p||(p=U),U=this.constructor.ca,p||(p=U?[U]:[]),this.j=U?0:-1,this.i=null,this.g=p;t:{if(U=this.g.length,p=U-1,U&&(U=this.g[p],U!==null&&typeof U=="object"&&U.constructor===Object)){this.l=p-this.j,this.h=U;break t;}W!==void 0&&-1<W?(this.l=Math.max(W,p+1-this.j),this.h=null):this.l=Number.MAX_VALUE;}if(V)for(W=0;W<V.length;W++)p=V[W],p<this.l?(p+=this.j,(U=this.g[p])?an(U):this.g[p]=Ie):(fe(this),(U=this.h[p])?an(U):this.h[p]=Ie);}var Ie=Object.freeze(an([]));function fe(p){var W=p.l+p.j;p.g[W]||(p.h=p.g[W]={});}function ee(p,W,V){return W===-1?null:V!==void 0&&V||W>=p.l?p.h?p.h[W]:void 0:p.g[W+p.j];}function Be(p){var W=W===void 0?!1:W,V=ee(p,1,W);return V==null&&(V=Ie),V===Ie&&(V=an([]),At(p,1,V,W)),V;}function Qt(p,W,V){var _p;return p=ee(p,W),p=p==null?p:+p,(_p=p)!=null?_p:V===void 0?0:V;}function At(p,W,V,U){U!==void 0&&U||W>=p.l?(fe(p),p.h[W]=V):p.g[W+p.j]=V;}function vn(p,W){p.i||(p.i={});var V=p.i[1];if(!V){var U=Be(p);V=[];for(var O=0;O<U.length;O++)V[O]=new W(U[O]);p.i[1]=V;}return V;}function se(p,W,V,U){var O=vn(p,V);W=W||new V(),p=Be(p),U!=null?(O.splice(U,0,W),p.splice(U,0,Ft(W))):(O.push(W),p.push(Ft(W)));}he.prototype.toJSON=function(){var p=Ft(this);return ve(p,Sn,un);};function Ft(p,W){if(p.i)for(var V in p.i){var U=p.i[V];if(Array.isArray(U))for(var O=0;O<U.length;O++)U[O]&&Ft(U[O]);else U&&Ft(U);}return p.g;}he.prototype.toString=function(){return Ft(this).toString();};function Wt(p,W){var _p2;return p=ee(p,W),(_p2=p)!=null?_p2:0;}function ne(p,W){var _p3;return p=ee(p,W),(_p3=p)!=null?_p3:"";}function He(p,W){if(p=p.m){_e(W,W.g.end());for(var V=0;V<p.length;V++)_e(W,p[V]);}}function Dt(p,W){if(W.h==4)return!1;var V=W.m;return Ze(W),W.N||(W=Zn(W.g.h,V,W.g.g),(V=p.m)?V.push(W):p.m=[W]),!0;}function re(p,W){var V=void 0;return new(V||(V=Promise))(function(U,O){function rt(dt){try{nt(W.next(dt));}catch(vt){O(vt);}}function K(dt){try{nt(W.throw(dt));}catch(vt){O(vt);}}function nt(dt){dt.done?U(dt.value):new V(function(vt){vt(dt.value);}).then(rt,K);}nt((W=W.apply(p,void 0)).next());});}function Ne(p){he.call(this,p);}ht(Ne,he);function Bt(p,W){for(;Jt(W);)switch(W.i){case 8:var V=ye(W.g);At(p,1,V);break;case 21:V=De(W.g),At(p,2,V);break;case 26:V=ae(W),At(p,3,V);break;case 34:V=ae(W),At(p,4,V);break;default:if(!Dt(p,W))return p;}return p;}function It(p){he.call(this,p,-1,je);}ht(It,he),It.prototype.addClassification=function(p,W){se(this,p,Ne,W);};var je=[1];function Ke(p){he.call(this,p);}ht(Ke,he);function Fe(p,W){for(;Jt(W);)switch(W.i){case 13:var V=De(W.g);At(p,1,V);break;case 21:V=De(W.g),At(p,2,V);break;case 29:V=De(W.g),At(p,3,V);break;case 37:V=De(W.g),At(p,4,V);break;case 45:V=De(W.g),At(p,5,V);break;default:if(!Dt(p,W))return p;}return p;}function Ot(p){he.call(this,p,-1,ke);}ht(Ot,he);var ke=[1];function mn(p){he.call(this,p);}ht(mn,he);function qe(p,W,V){if(V=p.createShader(V===0?p.VERTEX_SHADER:p.FRAGMENT_SHADER),p.shaderSource(V,W),p.compileShader(V),!p.getShaderParameter(V,p.COMPILE_STATUS))throw Error(`Could not compile WebGL shader.

`+p.getShaderInfoLog(V));return V;}function Ue(p){return vn(p,Ne).map(function(W){return{index:Wt(W,1),Y:Qt(W,2),label:ee(W,3)!=null?ne(W,3):void 0,displayName:ee(W,4)!=null?ne(W,4):void 0};});}function Qe(p){return{x:Qt(p,1),y:Qt(p,2),z:Qt(p,3),visibility:ee(p,4)!=null?Qt(p,4):void 0};}function tn(p,W){this.h=p,this.g=W,this.l=0;}function Ge(p,W,V){return Ee(p,W),typeof p.g.canvas.transferToImageBitmap=="function"?Promise.resolve(p.g.canvas.transferToImageBitmap()):V?Promise.resolve(p.g.canvas):typeof createImageBitmap=="function"?createImageBitmap(p.g.canvas):(p.i===void 0&&(p.i=document.createElement("canvas")),new Promise(function(U){p.i.height=p.g.canvas.height,p.i.width=p.g.canvas.width,p.i.getContext("2d",{}).drawImage(p.g.canvas,0,0,p.g.canvas.width,p.g.canvas.height),U(p.i);}));}function Ee(p,W){var V=p.g;if(p.m===void 0){var U=qe(V,`
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`,0),O=qe(V,`
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`,1),rt=V.createProgram();if(V.attachShader(rt,U),V.attachShader(rt,O),V.linkProgram(rt),!V.getProgramParameter(rt,V.LINK_STATUS))throw Error(`Could not compile WebGL program.

`+V.getProgramInfoLog(rt));U=p.m=rt,V.useProgram(U),O=V.getUniformLocation(U,"sampler0"),p.j={I:V.getAttribLocation(U,"aVertex"),H:V.getAttribLocation(U,"aTex"),da:O},p.s=V.createBuffer(),V.bindBuffer(V.ARRAY_BUFFER,p.s),V.enableVertexAttribArray(p.j.I),V.vertexAttribPointer(p.j.I,2,V.FLOAT,!1,0,0),V.bufferData(V.ARRAY_BUFFER,new Float32Array([-1,-1,-1,1,1,1,1,-1]),V.STATIC_DRAW),V.bindBuffer(V.ARRAY_BUFFER,null),p.o=V.createBuffer(),V.bindBuffer(V.ARRAY_BUFFER,p.o),V.enableVertexAttribArray(p.j.H),V.vertexAttribPointer(p.j.H,2,V.FLOAT,!1,0,0),V.bufferData(V.ARRAY_BUFFER,new Float32Array([0,1,0,0,1,0,1,1]),V.STATIC_DRAW),V.bindBuffer(V.ARRAY_BUFFER,null),V.uniform1i(O,0);}U=p.j,V.useProgram(p.m),V.canvas.width=W.width,V.canvas.height=W.height,V.viewport(0,0,W.width,W.height),V.activeTexture(V.TEXTURE0),p.h.bindTexture2d(W.glName),V.enableVertexAttribArray(U.I),V.bindBuffer(V.ARRAY_BUFFER,p.s),V.vertexAttribPointer(U.I,2,V.FLOAT,!1,0,0),V.enableVertexAttribArray(U.H),V.bindBuffer(V.ARRAY_BUFFER,p.o),V.vertexAttribPointer(U.H,2,V.FLOAT,!1,0,0),V.bindFramebuffer(V.DRAW_FRAMEBUFFER?V.DRAW_FRAMEBUFFER:V.FRAMEBUFFER,null),V.clearColor(0,0,0,0),V.clear(V.COLOR_BUFFER_BIT),V.colorMask(!0,!0,!0,!0),V.drawArrays(V.TRIANGLE_FAN,0,4),V.disableVertexAttribArray(U.I),V.disableVertexAttribArray(U.H),V.bindBuffer(V.ARRAY_BUFFER,null),p.h.bindTexture2d(0);}function kn(p){this.g=p;}var Me=new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,10,9,1,7,0,65,0,253,15,26,11]);function Ve(p,W){return W+p;}function sn(p,W){window[p]=W;}function pn(p){var W=document.createElement("script");return W.setAttribute("src",p),W.setAttribute("crossorigin","anonymous"),new Promise(function(V){W.addEventListener("load",function(){V();},!1),W.addEventListener("error",function(){V();},!1),document.body.appendChild(W);});}function Le(){return re(this,function p(){return ue(p,function(W){switch(W.g){case 1:return W.m=2,D(W,WebAssembly.instantiate(Me),4);case 4:W.g=3,W.m=0;break;case 2:return W.m=0,W.j=null,W.return(!1);case 3:return W.return(!0);}});});}function Fn(p){if(this.g=p,this.listeners={},this.j={},this.F={},this.m={},this.s={},this.G=this.o=this.R=!0,this.C=Promise.resolve(),this.P="",this.B={},this.locateFile=p&&p.locateFile||Ve,typeof window=="object")var W=window.location.pathname.toString().substring(0,window.location.pathname.toString().lastIndexOf("/"))+"/";else if(typeof location<"u")W=location.pathname.toString().substring(0,location.pathname.toString().lastIndexOf("/"))+"/";else throw Error("solutions can only be loaded on a web page or in a web worker");if(this.S=W,p.options){W=T(Object.keys(p.options));for(var V=W.next();!V.done;V=W.next()){V=V.value;var U=p.options[V].default;U!==void 0&&(this.j[V]=typeof U=="function"?U():U);}}}r=Fn.prototype,r.close=function(){return this.i&&this.i.delete(),Promise.resolve();};function ze(p,W){return p.g.files===void 0?[]:typeof p.g.files=="function"?p.g.files(W):p.g.files;}function ln(p){return re(p,function W(){var V=this,U,O,rt,K,nt,dt,vt,Ct,Tt,jt,wt;return ue(W,function(Vt){switch(Vt.g){case 1:return U=V,V.R?(O=ze(V,V.j),D(Vt,Le(),2)):Vt.return();case 2:if(rt=Vt.h,typeof window=="object")return sn("createMediapipeSolutionsWasm",{locateFile:V.locateFile}),sn("createMediapipeSolutionsPackedAssets",{locateFile:V.locateFile}),dt=O.filter(function(Ht){return Ht.data!==void 0;}),vt=O.filter(function(Ht){return Ht.data===void 0;}),Ct=Promise.all(dt.map(function(Ht){var Et=Oe(U,Ht.url);if(Ht.path!==void 0){var te=Ht.path;Et=Et.then(function(ie){return U.overrideFile(te,ie),Promise.resolve(ie);});}return Et;})),Tt=Promise.all(vt.map(function(Ht){return Ht.simd===void 0||Ht.simd&&rt||!Ht.simd&&!rt?pn(U.locateFile(Ht.url,U.S)):Promise.resolve();})).then(function(){return re(U,function Ht(){var Et,te,ie=this;return ue(Ht,function(le){if(le.g==1)return Et=window.createMediapipeSolutionsWasm,te=window.createMediapipeSolutionsPackedAssets,D(le,Et(te),2);ie.h=le.h,le.g=0;});});}),jt=function(){return re(U,function Ht(){var Et=this;return ue(Ht,function(te){return Et.g.graph&&Et.g.graph.url?te=D(te,Oe(Et,Et.g.graph.url),0):(te.g=0,te=void 0),te;});});}(),D(Vt,Promise.all([Tt,Ct,jt]),7);if(typeof importScripts!="function")throw Error("solutions can only be loaded on a web page or in a web worker");return K=O.filter(function(Ht){return Ht.simd===void 0||Ht.simd&&rt||!Ht.simd&&!rt;}).map(function(Ht){return U.locateFile(Ht.url,U.S);}),importScripts.apply(null,k(K)),D(Vt,createMediapipeSolutionsWasm(Module),6);case 6:V.h=Vt.h,V.l=new OffscreenCanvas(1,1),V.h.canvas=V.l,nt=V.h.GL.createContext(V.l,{antialias:!1,alpha:!1,ba:typeof WebGL2RenderingContext<"u"?2:1}),V.h.GL.makeContextCurrent(nt),Vt.g=4;break;case 7:if(V.l=document.createElement("canvas"),wt=V.l.getContext("webgl2",{}),!wt&&(wt=V.l.getContext("webgl",{}),!wt))return alert("Failed to create WebGL canvas context when passing video frame."),Vt.return();V.D=wt,V.h.canvas=V.l,V.h.createContext(V.l,!0,!0,{});case 4:V.i=new V.h.SolutionWasm(),V.R=!1,Vt.g=0;}});});}function Gn(p){return re(p,function W(){var V=this,U,O,rt,K,nt,dt,vt,Ct;return ue(W,function(Tt){if(Tt.g==1){if(V.g.graph&&V.g.graph.url&&V.P===V.g.graph.url)return Tt.return();if(V.o=!0,!V.g.graph||!V.g.graph.url){Tt.g=2;return;}return V.P=V.g.graph.url,D(Tt,Oe(V,V.g.graph.url),3);}for(Tt.g!=2&&(U=Tt.h,V.i.loadGraph(U)),O=T(Object.keys(V.B)),rt=O.next();!rt.done;rt=O.next())K=rt.value,V.i.overrideFile(K,V.B[K]);if(V.B={},V.g.listeners)for(nt=T(V.g.listeners),dt=nt.next();!dt.done;dt=nt.next())vt=dt.value,Bn(V,vt);Ct=V.j,V.j={},V.setOptions(Ct),Tt.g=0;});});}r.reset=function(){return re(this,function p(){var W=this;return ue(p,function(V){W.i&&(W.i.reset(),W.m={},W.s={}),V.g=0;});});},r.setOptions=function(p,W){var V=this;if(W=W||this.g.options){for(var U=[],O=[],rt={},K=T(Object.keys(p)),nt=K.next();!nt.done;rt={K:rt.K,L:rt.L},nt=K.next()){var dt=nt.value;dt in this.j&&this.j[dt]===p[dt]||(this.j[dt]=p[dt],nt=W[dt],nt!==void 0&&(nt.onChange&&(rt.K=nt.onChange,rt.L=p[dt],U.push(/* @__PURE__ */function(vt){return function(){return re(V,function Ct(){var Tt,jt=this;return ue(Ct,function(wt){if(wt.g==1)return D(wt,vt.K(vt.L),2);Tt=wt.h,Tt===!0&&(jt.o=!0),wt.g=0;});});};}(rt))),nt.graphOptionXref&&(dt={valueNumber:nt.type===1?p[dt]:0,valueBoolean:nt.type===0?p[dt]:!1,valueString:nt.type===2?p[dt]:""},nt=Object.assign(Object.assign(Object.assign({},{calculatorName:"",calculatorIndex:0}),nt.graphOptionXref),dt),O.push(nt))));}(U.length!==0||O.length!==0)&&(this.o=!0,this.A=(this.A===void 0?[]:this.A).concat(O),this.u=(this.u===void 0?[]:this.u).concat(U));}};function Hn(p){return re(p,function W(){var V=this,U,O,rt,K,nt,dt,vt;return ue(W,function(Ct){switch(Ct.g){case 1:if(!V.o)return Ct.return();if(!V.u){Ct.g=2;break;}U=T(V.u),O=U.next();case 3:if(O.done){Ct.g=5;break;}return rt=O.value,D(Ct,rt(),4);case 4:O=U.next(),Ct.g=3;break;case 5:V.u=void 0;case 2:if(V.A){for(K=new V.h.GraphOptionChangeRequestList(),nt=T(V.A),dt=nt.next();!dt.done;dt=nt.next())vt=dt.value,K.push_back(vt);V.i.changeOptions(K),K.delete(),V.A=void 0;}V.o=!1,Ct.g=0;}});});}r.initialize=function(){return re(this,function p(){var W=this;return ue(p,function(V){return V.g==1?D(V,ln(W),2):V.g!=3?D(V,Gn(W),3):D(V,Hn(W),0);});});};function Oe(p,W){return re(p,function V(){var U=this,O,rt;return ue(V,function(K){return W in U.F?K.return(U.F[W]):(O=U.locateFile(W,""),rt=fetch(O).then(function(nt){return nt.arrayBuffer();}),U.F[W]=rt,K.return(rt));});});}r.overrideFile=function(p,W){this.i?this.i.overrideFile(p,W):this.B[p]=W;},r.clearOverriddenFiles=function(){this.B={},this.i&&this.i.clearOverriddenFiles();},r.send=function(p,W){return re(this,function V(){var U=this,O,rt,K,nt,dt,vt,Ct,Tt,jt;return ue(V,function(wt){switch(wt.g){case 1:return U.g.inputs?(O=1e3*(W!=null?W:performance.now()),D(wt,U.C,2)):wt.return();case 2:return D(wt,U.initialize(),3);case 3:for(rt=new U.h.PacketDataList(),K=T(Object.keys(p)),nt=K.next();!nt.done;nt=K.next())if(dt=nt.value,vt=U.g.inputs[dt]){t:{var Vt=U,Ht=p[dt];switch(vt.type){case"video":var Et=Vt.m[vt.stream];if(Et||(Et=new tn(Vt.h,Vt.D),Vt.m[vt.stream]=Et),Vt=Et,Vt.l===0&&(Vt.l=Vt.h.createTexture()),typeof HTMLVideoElement<"u"&&Ht instanceof HTMLVideoElement){var te=Ht.videoWidth;Et=Ht.videoHeight;}else typeof HTMLImageElement<"u"&&Ht instanceof HTMLImageElement?(te=Ht.naturalWidth,Et=Ht.naturalHeight):(te=Ht.width,Et=Ht.height);Et={glName:Vt.l,width:te,height:Et},te=Vt.g,te.canvas.width=Et.width,te.canvas.height=Et.height,te.activeTexture(te.TEXTURE0),Vt.h.bindTexture2d(Vt.l),te.texImage2D(te.TEXTURE_2D,0,te.RGBA,te.RGBA,te.UNSIGNED_BYTE,Ht),Vt.h.bindTexture2d(0),Vt=Et;break t;case"detections":for(Et=Vt.m[vt.stream],Et||(Et=new kn(Vt.h),Vt.m[vt.stream]=Et),Vt=Et,Vt.data||(Vt.data=new Vt.g.DetectionListData()),Vt.data.reset(Ht.length),Et=0;Et<Ht.length;++Et){te=Ht[Et];var ie=Vt.data,le=ie.setBoundingBox,Re=Et,h=te.T,y=new mn();At(y,1,h.Z),At(y,2,h.$),At(y,3,h.height),At(y,4,h.width),At(y,5,h.rotation),At(y,6,h.X);var G=h=new xe();zt(G,1,ee(y,1)),zt(G,2,ee(y,2)),zt(G,3,ee(y,3)),zt(G,4,ee(y,4)),zt(G,5,ee(y,5));var C=ee(y,6);if(C!=null&&C!=null){de(G.g,48);var z=G.g,P=C;C=0>P,P=Math.abs(P);var A=P>>>0;for(P=Math.floor((P-A)/4294967296),P>>>=0,C&&(P=~P>>>0,A=(~A>>>0)+1,4294967295<A&&(A=0,P++,4294967295<P&&(P=0))),be=A,We=P,C=be,A=We;0<A||127<C;)z.push(C&127|128),C=(C>>>7|A<<25)>>>0,A>>>=7;z.push(C);}if(He(y,G),h=me(h),le.call(ie,Re,h),te.O)for(ie=0;ie<te.O.length;++ie)y=te.O[ie],G=!!y.visibility,le=Vt.data,Re=le.addNormalizedLandmark,h=Et,y=Object.assign(Object.assign({},y),{visibility:G?y.visibility:0}),G=new Ke(),At(G,1,y.x),At(G,2,y.y),At(G,3,y.z),y.visibility&&At(G,4,y.visibility),z=y=new xe(),zt(z,1,ee(G,1)),zt(z,2,ee(G,2)),zt(z,3,ee(G,3)),zt(z,4,ee(G,4)),zt(z,5,ee(G,5)),He(G,z),y=me(y),Re.call(le,h,y);if(te.M)for(ie=0;ie<te.M.length;++ie){if(le=Vt.data,Re=le.addClassification,h=Et,y=te.M[ie],G=new Ne(),At(G,2,y.Y),y.index&&At(G,1,y.index),y.label&&At(G,3,y.label),y.displayName&&At(G,4,y.displayName),z=y=new xe(),A=ee(G,1),A!=null&&A!=null)if(de(z.g,8),C=z.g,0<=A)de(C,A);else{for(P=0;9>P;P++)C.push(A&127|128),A>>=7;C.push(1);}zt(z,2,ee(G,2)),C=ee(G,3),C!=null&&(C=Vn(C),de(z.g,26),de(z.g,C.length),_e(z,z.g.end()),_e(z,C)),C=ee(G,4),C!=null&&(C=Vn(C),de(z.g,34),de(z.g,C.length),_e(z,z.g.end()),_e(z,C)),He(G,z),y=me(y),Re.call(le,h,y);}}Vt=Vt.data;break t;default:Vt={};}}switch(Ct=Vt,Tt=vt.stream,vt.type){case"video":rt.pushTexture2d(Object.assign(Object.assign({},Ct),{stream:Tt,timestamp:O}));break;case"detections":jt=Ct,jt.stream=Tt,jt.timestamp=O,rt.pushDetectionList(jt);break;default:throw Error("Unknown input config type: '"+vt.type+"'");}}return U.i.send(rt),D(wt,U.C,4);case 4:rt.delete(),wt.g=0;}});});};function Xn(p,W,V){return re(p,function U(){var O,rt,K,nt,dt,vt,Ct=this,Tt,jt,wt,Vt,Ht,Et,te,ie;return ue(U,function(le){switch(le.g){case 1:if(!V)return le.return(W);for(O={},rt=0,K=T(Object.keys(V)),nt=K.next();!nt.done;nt=K.next())dt=nt.value,vt=V[dt],typeof vt!="string"&&vt.type==="texture"&&W[vt.stream]!==void 0&&++rt;1<rt&&(Ct.G=!1),Tt=T(Object.keys(V)),nt=Tt.next();case 2:if(nt.done){le.g=4;break;}if(jt=nt.value,wt=V[jt],typeof wt=="string")return te=O,ie=jt,D(le,An(Ct,jt,W[wt]),14);if(Vt=W[wt.stream],wt.type==="detection_list"){if(Vt){for(var Re=Vt.getRectList(),h=Vt.getLandmarksList(),y=Vt.getClassificationsList(),G=[],C=0;C<Re.size();++C){var z=Re.get(C);t:{var P=new mn();for(z=new we(z);Jt(z);)switch(z.i){case 13:var A=De(z.g);At(P,1,A);break;case 21:A=De(z.g),At(P,2,A);break;case 29:A=De(z.g),At(P,3,A);break;case 37:A=De(z.g),At(P,4,A);break;case 45:A=De(z.g),At(P,5,A);break;case 48:for(var q=z.g,ot=128,s=0,X=A=0;4>X&&128<=ot;X++)ot=q.h[q.g++],s|=(ot&127)<<7*X;if(128<=ot&&(ot=q.h[q.g++],s|=(ot&127)<<28,A|=(ot&127)>>4),128<=ot)for(X=0;5>X&&128<=ot;X++)ot=q.h[q.g++],A|=(ot&127)<<7*X+3;128>ot?(q=s>>>0,ot=A>>>0,(A=ot&2147483648)&&(q=~q+1>>>0,ot=~ot>>>0,q==0&&(ot=ot+1>>>0)),q=4294967296*ot+(q>>>0),A=A?-q:q):(q.l=!0,A=void 0),At(P,6,A);break;default:if(!Dt(P,z))break t;}}P={Z:Qt(P,1),$:Qt(P,2),height:Qt(P,3),width:Qt(P,4),rotation:Qt(P,5,0),X:Wt(P,6)},A=h.get(C);t:for(z=new Ot(),A=new we(A);Jt(A);)switch(A.i){case 10:q=_t(A,new Ke(),Fe),se(z,q,Ke,void 0);break;default:if(!Dt(z,A))break t;}z=vn(z,Ke).map(Qe),q=y.get(C);t:for(A=new It(),q=new we(q);Jt(q);)switch(q.i){case 10:A.addClassification(_t(q,new Ne(),Bt));break;default:if(!Dt(A,q))break t;}P={T:P,O:z,M:Ue(A)},G.push(P);}Re=G;}else Re=[];O[jt]=Re,le.g=7;break;}if(wt.type==="proto_list"){if(Vt){for(Re=Array(Vt.size()),h=0;h<Vt.size();h++)Re[h]=Vt.get(h);Vt.delete();}else Re=[];O[jt]=Re,le.g=7;break;}if(Vt===void 0){le.g=3;break;}if(wt.type==="float_list"){O[jt]=Vt,le.g=7;break;}if(wt.type==="proto"){O[jt]=Vt,le.g=7;break;}if(wt.type!=="texture")throw Error("Unknown output config type: '"+wt.type+"'");return Ht=Ct.s[jt],Ht||(Ht=new tn(Ct.h,Ct.D),Ct.s[jt]=Ht),D(le,Ge(Ht,Vt,Ct.G),13);case 13:Et=le.h,O[jt]=Et;case 7:wt.transform&&O[jt]&&(O[jt]=wt.transform(O[jt])),le.g=3;break;case 14:te[ie]=le.h;case 3:nt=Tt.next(),le.g=2;break;case 4:return le.return(O);}});});}function An(p,W,V){return re(p,function U(){var O=this,rt;return ue(U,function(K){return typeof V=="number"||V instanceof Uint8Array||V instanceof O.h.Uint8BlobList?K.return(V):V instanceof O.h.Texture2dDataOut?(rt=O.s[W],rt||(rt=new tn(O.h,O.D),O.s[W]=rt),K.return(Ge(rt,V,O.G))):K.return(void 0);});});}function Bn(p,W){for(var V=W.name||"$",U=[].concat(k(W.wants)),O=new p.h.StringList(),rt=T(W.wants),K=rt.next();!K.done;K=rt.next())O.push_back(K.value);rt=p.h.PacketListener.implement({onResults:function onResults(nt){for(var dt={},vt=0;vt<W.wants.length;++vt)dt[U[vt]]=nt.get(vt);var Ct=p.listeners[V];Ct&&(p.C=Xn(p,dt,W.outs).then(function(Tt){Tt=Ct(Tt);for(var jt=0;jt<W.wants.length;++jt){var wt=dt[U[jt]];typeof wt=="object"&&wt.hasOwnProperty&&wt.hasOwnProperty("delete")&&wt.delete();}Tt&&(p.C=Tt);}));}}),p.i.attachMultiListener(O,rt),O.delete();}r.onResults=function(p,W){this.listeners[W||"$"]=p;},Xe("Solution",Fn),Xe("OptionType",{BOOL:0,NUMBER:1,aa:2,0:"BOOL",1:"NUMBER",2:"STRING"});function Wn(p){switch(p===void 0&&(p=0),p){case 1:return"selfie_segmentation_landscape.tflite";default:return"selfie_segmentation.tflite";}}function xn(p){var W=this;p=p||{},this.g=new Fn({locateFile:p.locateFile,files:function files(V){return[{simd:!0,url:"selfie_segmentation_solution_simd_wasm_bin.js"},{simd:!1,url:"selfie_segmentation_solution_wasm_bin.js"},{data:!0,url:Wn(V.modelSelection)}];},graph:{url:"selfie_segmentation.binarypb"},listeners:[{wants:["segmentation_mask","image_transformed"],outs:{image:{type:"texture",stream:"image_transformed"},segmentationMask:{type:"texture",stream:"segmentation_mask"}}}],inputs:{image:{type:"video",stream:"input_frames_gpu"}},options:{useCpuInference:{type:0,graphOptionXref:{calculatorType:"InferenceCalculator",fieldName:"use_cpu_inference"},default:"iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document},selfieMode:{type:0,graphOptionXref:{calculatorType:"GlScalerCalculator",calculatorIndex:1,fieldName:"flip_horizontal"}},modelSelection:{type:1,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorModelSelection",fieldName:"int_value"},onChange:function onChange(V){return re(W,function U(){var O,rt,K=this,nt;return ue(U,function(dt){return dt.g==1?(O=Wn(V),rt="third_party/mediapipe/modules/selfie_segmentation/"+O,D(dt,Oe(K.g,O),2)):(nt=dt.h,K.g.overrideFile(rt,nt),dt.return(!0));});});}}}});}r=xn.prototype,r.close=function(){return this.g.close(),Promise.resolve();},r.onResults=function(p){this.g.onResults(p);},r.initialize=function(){return re(this,function p(){var W=this;return ue(p,function(V){return D(V,W.g.initialize(),0);});});},r.reset=function(){this.g.reset();},r.send=function(p){return re(this,function W(){var V=this;return ue(W,function(U){return D(U,V.g.send(p),0);});});},r.setOptions=function(p){this.g.setOptions(p);},Xe("SelfieSegmentation",xn),Xe("VERSION","0.1.1632777926");}).call(Vi);const Ri={};(function(){var r;function e(l){var Z=0;return function(){return Z<l.length?{done:!1,value:l[Z++]}:{done:!0};};}var i=typeof Object.defineProperties=="function"?Object.defineProperty:function(l,Z,x){return l==Array.prototype||l==Object.prototype||(l[Z]=x.value),l;};function m(l){l=[typeof globalThis=="object"&&globalThis,l,typeof window=="object"&&window,typeof self=="object"&&self,typeof (typeof window !== undefined ? window : global)=="object"&&(typeof window !== undefined ? window : global)];for(var Z=0;Z<l.length;++Z){var x=l[Z];if(x&&x.Math==Math)return x;}throw Error("Cannot find global object");}var v=m(this);function S(l,Z){if(Z)t:{var x=v;l=l.split(".");for(var Y=0;Y<l.length-1;Y++){var J=l[Y];if(!(J in x))break t;x=x[J];}l=l[l.length-1],Y=x[l],Z=Z(Y),Z!=Y&&Z!=null&&i(x,l,{configurable:!0,writable:!0,value:Z});}}S("Symbol",function(l){function Z(o){if(this instanceof Z)throw new TypeError("Symbol is not a constructor");return new x(Y+(o||"")+"_"+J++,o);}function x(o,d){this.g=o,i(this,"description",{configurable:!0,writable:!0,value:d});}if(l)return l;x.prototype.toString=function(){return this.g;};var Y="jscomp_symbol_"+(1e9*Math.random()>>>0)+"_",J=0;return Z;}),S("Symbol.iterator",function(l){if(l)return l;l=Symbol("Symbol.iterator");for(var Z="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),x=0;x<Z.length;x++){var Y=v[Z[x]];typeof Y=="function"&&typeof Y.prototype[l]!="function"&&i(Y.prototype,l,{configurable:!0,writable:!0,value:function value(){return L(e(this));}});}return l;});function L(l){return l={next:l},l[Symbol.iterator]=function(){return this;},l;}function T(l){var Z=typeof Symbol<"u"&&Symbol.iterator&&l[Symbol.iterator];return Z?Z.call(l):{next:e(l)};}function k(l){if(!(l instanceof Array)){l=T(l);for(var Z,x=[];!(Z=l.next()).done;)x.push(Z.value);l=x;}return l;}var tt=typeof Object.create=="function"?Object.create:function(l){function Z(){}return Z.prototype=l,new Z();},st;if(typeof Object.setPrototypeOf=="function")st=Object.setPrototypeOf;else{var bt;t:{var xt={a:!0},Yt={};try{Yt.__proto__=xt,bt=Yt.a;break t;}catch(_unused5){}bt=!1;}st=bt?function(l,Z){if(l.__proto__=Z,l.__proto__!==Z)throw new TypeError(l+" is not extensible");return l;}:null;}var at=st;function ht(l,Z){if(l.prototype=tt(Z.prototype),l.prototype.constructor=l,at)at(l,Z);else for(var x in Z)if(x!="prototype")if(Object.defineProperties){var Y=Object.getOwnPropertyDescriptor(Z,x);Y&&Object.defineProperty(l,x,Y);}else l[x]=Z[x];l.ra=Z.prototype;}function Ut(){this.l=!1,this.i=null,this.h=void 0,this.g=1,this.u=this.o=0,this.j=null;}function Mt(l){if(l.l)throw new TypeError("Generator is already running");l.l=!0;}Ut.prototype.s=function(l){this.h=l;};function oe(l,Z){l.j={fa:Z,ga:!0},l.g=l.o||l.u;}Ut.prototype.return=function(l){this.j={return:l},this.g=this.u;};function D(l,Z,x){return l.g=x,{value:Z};}function hn(l){this.g=new Ut(),this.h=l;}function bn(l,Z){Mt(l.g);var x=l.g.i;return x?ge(l,"return"in x?x.return:function(Y){return{value:Y,done:!0};},Z,l.g.return):(l.g.return(Z),Kt(l));}function ge(l,Z,x,Y){try{var J=Z.call(l.g.i,x);if(!(J instanceof Object))throw new TypeError("Iterator result "+J+" is not an object");if(!J.done)return l.g.l=!1,J;var o=J.value;}catch(d){return l.g.i=null,oe(l.g,d),Kt(l);}return l.g.i=null,Y.call(l.g,o),Kt(l);}function Kt(l){for(;l.g.g;)try{var Z=l.h(l.g);if(Z)return l.g.l=!1,{value:Z.value,done:!1};}catch(x){l.g.h=void 0,oe(l.g,x);}if(l.g.l=!1,l.g.j){if(Z=l.g.j,l.g.j=null,Z.ga)throw Z.fa;return{value:Z.return,done:!0};}return{value:void 0,done:!0};}function jn(l){this.next=function(Z){return Mt(l.g),l.g.i?Z=ge(l,l.g.i.next,Z,l.g.s):(l.g.s(Z),Z=Kt(l)),Z;},this.throw=function(Z){return Mt(l.g),l.g.i?Z=ge(l,l.g.i.throw,Z,l.g.s):(oe(l.g,Z),Z=Kt(l)),Z;},this.return=function(Z){return bn(l,Z);},this[Symbol.iterator]=function(){return this;};}function ue(l){function Z(Y){return l.next(Y);}function x(Y){return l.throw(Y);}return new Promise(function(Y,J){function o(d){d.done?Y(d.value):Promise.resolve(d.value).then(Z,x).then(o,J);}o(l.next());});}function yt(l){return ue(new jn(new hn(l)));}S("Promise",function(l){function Z(d){this.h=0,this.i=void 0,this.g=[],this.s=!1;var g=this.j();try{d(g.resolve,g.reject);}catch(n){g.reject(n);}}function x(){this.g=null;}function Y(d){return d instanceof Z?d:new Z(function(g){g(d);});}if(l)return l;x.prototype.h=function(d){if(this.g==null){this.g=[];var g=this;this.i(function(){g.l();});}this.g.push(d);};var J=v.setTimeout;x.prototype.i=function(d){J(d,0);},x.prototype.l=function(){for(;this.g&&this.g.length;){var d=this.g;this.g=[];for(var g=0;g<d.length;++g){var n=d[g];d[g]=null;try{n();}catch(u){this.j(u);}}}this.g=null;},x.prototype.j=function(d){this.i(function(){throw d;});},Z.prototype.j=function(){function d(u){return function(f){n||(n=!0,u.call(g,f));};}var g=this,n=!1;return{resolve:d(this.D),reject:d(this.l)};},Z.prototype.D=function(d){if(d===this)this.l(new TypeError("A Promise cannot resolve to itself"));else if(d instanceof Z)this.H(d);else{t:switch(typeof d){case"object":var g=d!=null;break t;case"function":g=!0;break t;default:g=!1;}g?this.A(d):this.o(d);}},Z.prototype.A=function(d){var g=void 0;try{g=d.then;}catch(n){this.l(n);return;}typeof g=="function"?this.I(g,d):this.o(d);},Z.prototype.l=function(d){this.u(2,d);},Z.prototype.o=function(d){this.u(1,d);},Z.prototype.u=function(d,g){if(this.h!=0)throw Error("Cannot settle("+d+", "+g+"): Promise already settled in state"+this.h);this.h=d,this.i=g,this.h===2&&this.G(),this.B();},Z.prototype.G=function(){var d=this;J(function(){if(d.C()){var g=v.console;typeof g<"u"&&g.error(d.i);}},1);},Z.prototype.C=function(){if(this.s)return!1;var d=v.CustomEvent,g=v.Event,n=v.dispatchEvent;return typeof n>"u"?!0:(typeof d=="function"?d=new d("unhandledrejection",{cancelable:!0}):typeof g=="function"?d=new g("unhandledrejection",{cancelable:!0}):(d=v.document.createEvent("CustomEvent"),d.initCustomEvent("unhandledrejection",!1,!0,d)),d.promise=this,d.reason=this.i,n(d));},Z.prototype.B=function(){if(this.g!=null){for(var d=0;d<this.g.length;++d)o.h(this.g[d]);this.g=null;}};var o=new x();return Z.prototype.H=function(d){var g=this.j();d.M(g.resolve,g.reject);},Z.prototype.I=function(d,g){var n=this.j();try{d.call(g,n.resolve,n.reject);}catch(u){n.reject(u);}},Z.prototype.then=function(d,g){function n(c,a){return typeof c=="function"?function(b){try{u(c(b));}catch(I){f(I);}}:a;}var u,f,t=new Z(function(c,a){u=c,f=a;});return this.M(n(d,u),n(g,f)),t;},Z.prototype.catch=function(d){return this.then(void 0,d);},Z.prototype.M=function(d,g){function n(){switch(u.h){case 1:d(u.i);break;case 2:g(u.i);break;default:throw Error("Unexpected state: "+u.h);}}var u=this;this.g==null?o.h(n):this.g.push(n),this.s=!0;},Z.resolve=Y,Z.reject=function(d){return new Z(function(g,n){n(d);});},Z.race=function(d){return new Z(function(g,n){for(var u=T(d),f=u.next();!f.done;f=u.next())Y(f.value).M(g,n);});},Z.all=function(d){var g=T(d),n=g.next();return n.done?Y([]):new Z(function(u,f){function t(b){return function(I){c[b]=I,a--,a==0&&u(c);};}var c=[],a=0;do c.push(void 0),a++,Y(n.value).M(t(c.length-1),f),n=g.next();while(!n.done);});},Z;});function Kn(l,Z){l instanceof String&&(l+="");var x=0,Y=!1,J={next:function next(){if(!Y&&x<l.length){var o=x++;return{value:Z(o,l[o]),done:!1};}return Y=!0,{done:!0,value:void 0};}};return J[Symbol.iterator]=function(){return J;},J;}var On=typeof Object.assign=="function"?Object.assign:function(l,Z){for(var x=1;x<arguments.length;x++){var Y=arguments[x];if(Y)for(var J in Y)Object.prototype.hasOwnProperty.call(Y,J)&&(l[J]=Y[J]);}return l;};S("Object.assign",function(l){return l||On;}),S("Object.is",function(l){return l||function(Z,x){return Z===x?Z!==0||1/Z===1/x:Z!==Z&&x!==x;};}),S("Array.prototype.includes",function(l){return l||function(Z,x){var Y=this;Y instanceof String&&(Y=String(Y));var J=Y.length;for(x=x||0,0>x&&(x=Math.max(x+J,0));x<J;x++){var o=Y[x];if(o===Z||Object.is(o,Z))return!0;}return!1;};}),S("String.prototype.includes",function(l){return l||function(Z,x){if(this==null)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(Z instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return this.indexOf(Z,x||0)!==-1;};}),S("Array.prototype.keys",function(l){return l||function(){return Kn(this,function(Z){return Z;});};});var Xe=this||self;function Lt(l,Z){l=l.split(".");var x=Xe;l[0]in x||typeof x.execScript>"u"||x.execScript("var "+l[0]);for(var Y;l.length&&(Y=l.shift());)l.length||Z===void 0?x[Y]&&x[Y]!==Object.prototype[Y]?x=x[Y]:x=x[Y]={}:x[Y]=Z;}function Ye(){throw Error("Invalid UTF8");}function nn(l,Z){return Z=String.fromCharCode.apply(null,Z),l==null?Z:l+Z;}var yn,Yn=typeof TextDecoder<"u",Vn,Ln=typeof TextEncoder<"u",rn={},un=null;function Jn(l){var Z;Z===void 0&&(Z=0),on(),Z=rn[Z];for(var x=Array(Math.floor(l.length/3)),Y=Z[64]||"",J=0,o=0;J<l.length-2;J+=3){var d=l[J],g=l[J+1],n=l[J+2],u=Z[d>>2];d=Z[(d&3)<<4|g>>4],g=Z[(g&15)<<2|n>>6],n=Z[n&63],x[o++]=u+d+g+n;}switch(u=0,n=Y,l.length-J){case 2:u=l[J+1],n=Z[(u&15)<<2]||Y;case 1:l=l[J],x[o]=Z[l>>2]+Z[(l&3)<<4|u>>4]+n+Y;}return x.join("");}function wn(l){var Z=l.length,x=3*Z/4;x%3?x=Math.floor(x):"=.".indexOf(l[Z-1])!=-1&&(x="=.".indexOf(l[Z-2])!=-1?x-2:x-1);var Y=new Uint8Array(x),J=0;return gn(l,function(o){Y[J++]=o;}),J!==x?Y.subarray(0,J):Y;}function gn(l,Z){function x(n){for(;Y<l.length;){var u=l.charAt(Y++),f=un[u];if(f!=null)return f;if(!/^[\s\xa0]*$/.test(u))throw Error("Unknown base64 encoding at char: "+u);}return n;}on();for(var Y=0;;){var J=x(-1),o=x(0),d=x(64),g=x(64);if(g===64&&J===-1)break;Z(J<<2|o>>4),d!=64&&(Z(o<<4&240|d>>2),g!=64&&Z(d<<6&192|g));}}function on(){if(!un){un={};for(var l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),Z=["+/=","+/","-_=","-_.","-_"],x=0;5>x;x++){var Y=l.concat(Z[x].split(""));rn[x]=Y;for(var J=0;J<Y.length;J++){var o=Y[J];un[o]===void 0&&(un[o]=J);}}}}var Rn=typeof Uint8Array=="function";function Zn(l){return Rn&&l!=null&&l instanceof Uint8Array;}var be;function We(l){if(this.L=l,l!==null&&l.length===0)throw Error("ByteString should be constructed with non-empty values");}var Pe=typeof Uint8Array.prototype.slice=="function",pe=0,ye=0;function De(l,Z){if(l.constructor===Uint8Array)return l;if(l.constructor===ArrayBuffer)return new Uint8Array(l);if(l.constructor===Array)return new Uint8Array(l);if(l.constructor===String)return wn(l);if(l.constructor===We)return!Z&&(Z=l.L)&&Z.constructor===Uint8Array?Z:(Z=l.L,Z=Z==null||Zn(Z)?Z:typeof Z=="string"?wn(Z):null,(l=l.L=Z)?new Uint8Array(l):be||(be=new Uint8Array(0)));if(l instanceof Uint8Array)return new Uint8Array(l.buffer,l.byteOffset,l.byteLength);throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");}function Ce(l,Z){return Error("Invalid wire type: "+l+" (at position "+Z+")");}function Pt(){return Error("Failed to read varint, encoding is invalid.");}function de(l,Z){Z=Z===void 0?{}:Z,Z=Z.v===void 0?!1:Z.v,this.h=null,this.g=this.i=this.j=0,this.v=Z,l&&we(this,l);}function we(l,Z){l.h=De(Z,l.v),l.j=0,l.i=l.h.length,l.g=l.j;}de.prototype.reset=function(){this.g=this.j;};function Jt(l){if(l.g>l.i)throw Error("Tried to read past the end of the data "+l.g+" > "+l.i);}function Ze(l){var Z=l.h,x=Z[l.g],Y=x&127;if(128>x)return l.g+=1,Jt(l),Y;if(x=Z[l.g+1],Y|=(x&127)<<7,128>x)return l.g+=2,Jt(l),Y;if(x=Z[l.g+2],Y|=(x&127)<<14,128>x)return l.g+=3,Jt(l),Y;if(x=Z[l.g+3],Y|=(x&127)<<21,128>x)return l.g+=4,Jt(l),Y;if(x=Z[l.g+4],l.g+=5,Y|=(x&15)<<28,128>x)return Jt(l),Y;if(128<=Z[l.g++]&&128<=Z[l.g++]&&128<=Z[l.g++]&&128<=Z[l.g++]&&128<=Z[l.g++])throw Pt();return Jt(l),Y;}var _t=[];function ae(){this.g=[];}ae.prototype.length=function(){return this.g.length;},ae.prototype.end=function(){var l=this.g;return this.g=[],l;};function xe(l,Z){for(;127<Z;)l.g.push(Z&127|128),Z>>>=7;l.g.push(Z);}function _e(l){var Z={},x=Z.W===void 0?!1:Z.W;this.l={v:Z.v===void 0?!1:Z.v},this.W=x,Z=this.l,_t.length?(x=_t.pop(),Z&&(x.v=Z.v),l&&we(x,l),l=x):l=new de(l,Z),this.g=l,this.j=this.g.g,this.h=this.i=-1;}_e.prototype.reset=function(){this.g.reset(),this.j=this.g.g,this.h=this.i=-1;};function me(l){var Z=l.g;if(Z.g==Z.i)return!1;l.j=l.g.g;var x=Ze(l.g)>>>0;if(Z=x>>>3,x&=7,!(0<=x&&5>=x))throw Ce(x,l.j);if(1>Z)throw Error("Invalid field number: "+Z+" (at position "+l.j+")");return l.i=Z,l.h=x,!0;}function zt(l){switch(l.h){case 0:if(l.h!=0)zt(l);else t:{l=l.g;for(var Z=l.g,x=Z+10;Z<x;)if(!(l.h[Z++]&128)){l.g=Z,Jt(l);break t;}throw Pt();}break;case 1:l=l.g,l.g+=8,Jt(l);break;case 2:l.h!=2?zt(l):(Z=Ze(l.g)>>>0,l=l.g,l.g+=Z,Jt(l));break;case 5:l=l.g,l.g+=4,Jt(l);break;case 3:Z=l.i;do{if(!me(l))throw Error("Unmatched start-group tag: stream EOF");if(l.h==4){if(l.i!=Z)throw Error("Unmatched end-group tag");break;}zt(l);}while(!0);break;default:throw Ce(l.h,l.j);}}var Je=[];function Ae(){this.i=[],this.h=0,this.g=new ae();}function ve(l,Z){Z.length!==0&&(l.i.push(Z),l.h+=Z.length);}function Sn(l,Z){if(Z=Z.ca){ve(l,l.g.end());for(var x=0;x<Z.length;x++)ve(l,Z[x]);}}var $e=typeof Symbol=="function"&&typeof Symbol()=="symbol"?Symbol(void 0):void 0;function an(l,Z){Object.isFrozen(l)||($e?l[$e]|=Z:l.N!==void 0?l.N|=Z:Object.defineProperties(l,{N:{value:Z,configurable:!0,writable:!0,enumerable:!1}}));}function fn(l){var _Z;var Z;return $e?Z=l[$e]:Z=l.N,(_Z=Z)!=null?_Z:0;}function he(l){return an(l,1),l;}function Ie(l){return Array.isArray(l)?!!(fn(l)&2):!1;}function fe(l){if(!Array.isArray(l))throw Error("cannot mark non-array as immutable");an(l,2);}function ee(l){return l!==null&&typeof l=="object"&&!Array.isArray(l)&&l.constructor===Object;}var Be=Object.freeze(he([]));function Qt(l){if(Ie(l.m))throw Error("Cannot mutate an immutable Message");}var At=typeof Symbol<"u"&&typeof Symbol.hasInstance<"u";function vn(l){return{value:l,configurable:!1,writable:!1,enumerable:!1};}function se(l,Z,x){return Z===-1?null:Z>=l.i?l.g?l.g[Z]:void 0:x!==void 0&&x&&l.g&&(x=l.g[Z],x!=null)?x:l.m[Z+l.h];}function Ft(l,Z,x,Y){Y=Y===void 0?!1:Y,Qt(l),Z<l.i&&!Y?l.m[Z+l.h]=x:(l.g||(l.g=l.m[l.i+l.h]={}))[Z]=x;}function Wt(l,Z,x,Y){x=x===void 0?!0:x,Y=Y===void 0?!1:Y;var J=se(l,Z,Y);return J==null&&(J=Be),Ie(l.m)?x&&(fe(J),Object.freeze(J)):(J===Be||Ie(J))&&(J=he(J.slice()),Ft(l,Z,J,Y)),J;}function ne(l,Z,x){var _l2;return l=se(l,Z),l=l==null?l:+l,(_l2=l)!=null?_l2:x===void 0?0:x;}function He(l,Z,x,Y){l.j||(l.j={});var J=Ie(l.m),o=l.j[x];if(!o){Y=Wt(l,x,!0,Y===void 0?!1:Y),o=[],J=J||Ie(Y);for(var d=0;d<Y.length;d++)o[d]=new Z(Y[d]),J&&fe(o[d].m);J&&(fe(o),Object.freeze(o)),l.j[x]=o;}return o;}function Dt(l,Z,x,Y,J){var o=o===void 0?!1:o;return Qt(l),o=He(l,x,Z,o),x=Y||new x(),l=Wt(l,Z),J!=null?(o.splice(J,0,x),l.splice(J,0,x.m)):(o.push(x),l.push(x.m)),x;}function re(l,Z){var _l3;return l=se(l,Z),(_l3=l)!=null?_l3:0;}function Ne(l,Z){var _l4;return l=se(l,Z),(_l4=l)!=null?_l4:"";}function Bt(l){switch(typeof l){case"number":return isFinite(l)?l:String(l);case"object":if(l&&!Array.isArray(l)){if(Zn(l))return Jn(l);if(l instanceof We){var Z=l.L;return Z=Z==null||typeof Z=="string"?Z:Rn&&Z instanceof Uint8Array?Jn(Z):null,(l.L=Z)||"";}}}return l;}function It(l){var Z=Fe;return Z=Z===void 0?Ot:Z,Ke(l,Z);}function je(l,Z){if(l!=null){if(Array.isArray(l))l=Ke(l,Z);else if(ee(l)){var x={},Y;for(Y in l)x[Y]=je(l[Y],Z);l=x;}else l=Z(l);return l;}}function Ke(l,Z){for(var x=l.slice(),Y=0;Y<x.length;Y++)x[Y]=je(x[Y],Z);return Array.isArray(l)&&fn(l)&1&&he(x),x;}function Fe(l){return l&&typeof l=="object"&&l.toJSON?l.toJSON():(l=Bt(l),Array.isArray(l)?It(l):l);}function Ot(l){return Zn(l)?new Uint8Array(l):l;}function ke(l,Z,x){l||(l=mn),mn=null;var Y=this.constructor.h;l||(l=Y?[Y]:[]),this.h=(Y?0:-1)-(this.constructor.g||0),this.j=void 0,this.m=l;t:{if(Y=this.m.length,l=Y-1,Y&&(Y=this.m[l],ee(Y))){this.i=l-this.h,this.g=Y;break t;}Z!==void 0&&-1<Z?(this.i=Math.max(Z,l+1-this.h),this.g=void 0):this.i=Number.MAX_VALUE;}if(x)for(Z=0;Z<x.length;Z++)if(l=x[Z],l<this.i)l+=this.h,(Y=this.m[l])?Array.isArray(Y)&&he(Y):this.m[l]=Be;else{Y=this.g||(this.g=this.m[this.i+this.h]={});var J=Y[l];J?Array.isArray(J)&&he(J):Y[l]=Be;}}ke.prototype.toJSON=function(){return It(this.m);},ke.prototype.toString=function(){return this.m.toString();};var mn;function qe(){ke.apply(this,arguments);}if(ht(qe,ke),At){var Ue={};Object.defineProperties(qe,(Ue[Symbol.hasInstance]=vn(function(){throw Error("Cannot perform instanceof checks for MutableMessage");}),Ue));}function Qe(l,Z,x){if(x){var Y={},J;for(J in x){var o=x[J],d=o.ja;d||(Y.F=o.pa||o.ha.P,o.ba?(Y.U=pn(o.ba),d=/* @__PURE__ */function(g){return function(n,u,f){return g.F(n,u,f,g.U);};}(Y)):o.da?(Y.T=Le(o.X.g,o.da),d=/* @__PURE__ */function(g){return function(n,u,f){return g.F(n,u,f,g.T);};}(Y)):d=Y.F,o.ja=d),d(Z,l,o.X),Y={F:Y.F,U:Y.U,T:Y.T};}}Sn(Z,l);}var tn=Symbol();function Ge(l,Z,x){return l[tn]||(l[tn]=function(Y,J){return Z(Y,J,x);});}function Ee(l){var Z=l[tn];if(!Z){var x=p(l);Z=function Z(Y,J){return W(Y,J,x);},l[tn]=Z;}return Z;}function kn(l){var Z=l.ba;if(Z)return Ee(Z);if(Z=l.oa)return Ge(l.X.g,Z,l.da);}function Me(l){var Z=kn(l),x=l.X,Y=l.ha.O;return Z?function(J,o){return Y(J,o,x,Z);}:function(J,o){return Y(J,o,x);};}function Ve(l,Z,x,Y,J,o){l=l();var d=0;for(l.length&&typeof l[0]!="number"&&(x(Z,l[0]),d++);d<l.length;){x=l[d++];for(var g=d+1;g<l.length&&typeof l[g]!="number";)g++;var n=l[d++];switch(g-=d,g){case 0:Y(Z,x,n);break;case 1:Y(Z,x,n,l[d++]);break;case 2:J(Z,x,n,l[d++],l[d++]);break;case 3:g=l[d++];var u=l[d++],f=l[d++];Array.isArray(f)?J(Z,x,n,g,u,f):o(Z,x,n,g,u,f);break;case 4:o(Z,x,n,l[d++],l[d++],l[d++],l[d++]);break;default:throw Error("unexpected number of binary field arguments: "+g);}}return Z;}var sn=Symbol();function pn(l){var Z=l[sn];if(!Z){var x=Oe(l);Z=function Z(Y,J){return U(Y,J,x);},l[sn]=Z;}return Z;}function Le(l,Z){var x=l[sn];return x||(x=function x(Y,J){return Qe(Y,J,Z);},l[sn]=x),x;}var Fn=Symbol();function ze(l,Z){l.push(Z);}function ln(l,Z,x){l.push(Z,x.P);}function Gn(l,Z,x,Y,J){var o=pn(J),d=x.P;l.push(Z,function(g,n,u){return d(g,n,u,Y,o);});}function Hn(l,Z,x,Y,J,o){var d=Le(Y,o),g=x.P;l.push(Z,function(n,u,f){return g(n,u,f,Y,d);});}function Oe(l){var Z=l[Fn];return Z||Ve(l,l[Fn]=[],ze,ln,Gn,Hn);}var Xn=Symbol();function An(l,Z){l[0]=Z;}function Bn(l,Z,x,Y){var J=x.O;l[Z]=Y?function(o,d,g){return J(o,d,g,Y);}:J;}function Wn(l,Z,x,Y,J,o){var d=x.O,g=Ee(J);l[Z]=function(n,u,f){return d(n,u,f,Y,g,o);};}function xn(l,Z,x,Y,J,o,d){var g=x.O,n=Ge(Y,J,o);l[Z]=function(u,f,t){return g(u,f,t,Y,n,d);};}function p(l){var Z=l[Xn];return Z||Ve(l,l[Xn]={},An,Bn,Wn,xn);}function W(l,Z,x){for(;me(Z)&&Z.h!=4;){var Y=Z.i,J=x[Y];if(!J){var o=x[0];o&&(o=o[Y])&&(J=x[Y]=Me(o));}if((!J||!J(Z,l,Y))&&(J=Z,Y=l,o=J.j,zt(J),!J.W)){var d=J.g.h;J=J.g.g,J=o===J?be||(be=new Uint8Array(0)):Pe?d.slice(o,J):new Uint8Array(d.subarray(o,J)),(o=Y.ca)?o.push(J):Y.ca=[J];}}return l;}function V(l,Z,x){if(Je.length){var Y=Je.pop();l&&(we(Y.g,l),Y.i=-1,Y.h=-1),l=Y;}else l=new _e(l);try{return W(new Z(),l,p(x));}finally{Z=l.g,Z.h=null,Z.j=0,Z.i=0,Z.g=0,Z.v=!1,l.i=-1,l.h=-1,100>Je.length&&Je.push(l);}}function U(l,Z,x){for(var Y=x.length,J=Y%2==1,o=J?1:0;o<Y;o+=2)(0,x[o+1])(Z,l,x[o]);Qe(l,Z,J?x[0]:void 0);}function O(l,Z){var x=new Ae();U(l,x,Oe(Z)),ve(x,x.g.end()),l=new Uint8Array(x.h),Z=x.i;for(var Y=Z.length,J=0,o=0;o<Y;o++){var d=Z[o];l.set(d,J),J+=d.length;}return x.i=[l],l;}function rt(l,Z){return{O:l,P:Z};}var K=rt(function(l,Z,x){if(l.h!==5)return!1;l=l.g;var Y=l.h[l.g],J=l.h[l.g+1],o=l.h[l.g+2],d=l.h[l.g+3];return l.g+=4,Jt(l),J=(Y<<0|J<<8|o<<16|d<<24)>>>0,l=2*(J>>31)+1,Y=J>>>23&255,J&=8388607,Ft(Z,x,Y==255?J?NaN:1/0*l:Y==0?l*Math.pow(2,-149)*J:l*Math.pow(2,Y-150)*(J+Math.pow(2,23))),!0;},function(l,Z,x){if(Z=se(Z,x),Z!=null){xe(l.g,8*x+5),l=l.g;var Y=Z;Y=(x=0>Y?1:0)?-Y:Y,Y===0?0<1/Y?pe=ye=0:(ye=0,pe=2147483648):isNaN(Y)?(ye=0,pe=2147483647):34028234663852886e22<Y?(ye=0,pe=(x<<31|2139095040)>>>0):11754943508222875e-54>Y?(Y=Math.round(Y/Math.pow(2,-149)),ye=0,pe=(x<<31|Y)>>>0):(Z=Math.floor(Math.log(Y)/Math.LN2),Y*=Math.pow(2,-Z),Y=Math.round(8388608*Y),16777216<=Y&&++Z,ye=0,pe=(x<<31|Z+127<<23|Y&8388607)>>>0),x=pe,l.g.push(x>>>0&255),l.g.push(x>>>8&255),l.g.push(x>>>16&255),l.g.push(x>>>24&255);}}),nt=rt(function(l,Z,x){if(l.h!==0)return!1;for(var Y=l.g,J=128,o=0,d=l=0;4>d&&128<=J;d++)J=Y.h[Y.g++],Jt(Y),o|=(J&127)<<7*d;if(128<=J&&(J=Y.h[Y.g++],Jt(Y),o|=(J&127)<<28,l|=(J&127)>>4),128<=J)for(d=0;5>d&&128<=J;d++)J=Y.h[Y.g++],Jt(Y),l|=(J&127)<<7*d+3;if(128>J)Y=o>>>0,J=l>>>0,(l=J&2147483648)&&(Y=~Y+1>>>0,J=~J>>>0,Y==0&&(J=J+1>>>0)),Y=4294967296*J+(Y>>>0);else throw Pt();return Ft(Z,x,l?-Y:Y),!0;},function(l,Z,x){if(Z=se(Z,x),Z!=null&&Z!=null){xe(l.g,8*x),l=l.g;var Y=Z;for(x=0>Y,Y=Math.abs(Y),Z=Y>>>0,Y=Math.floor((Y-Z)/4294967296),Y>>>=0,x&&(Y=~Y>>>0,Z=(~Z>>>0)+1,4294967295<Z&&(Z=0,Y++,4294967295<Y&&(Y=0))),pe=Z,ye=Y,x=pe,Z=ye;0<Z||127<x;)l.g.push(x&127|128),x=(x>>>7|Z<<25)>>>0,Z>>>=7;l.g.push(x);}}),dt=rt(function(l,Z,x){return l.h!==0?!1:(Ft(Z,x,Ze(l.g)),!0);},function(l,Z,x){if(Z=se(Z,x),Z!=null&&Z!=null)if(xe(l.g,8*x),l=l.g,x=Z,0<=x)xe(l,x);else{for(Z=0;9>Z;Z++)l.g.push(x&127|128),x>>=7;l.g.push(1);}}),vt=rt(function(l,Z,x){if(l.h!==2)return!1;var Y=Ze(l.g)>>>0;l=l.g;var J=l.g;l.g+=Y,Jt(l),l=l.h;var o;if(Yn)(o=yn)||(o=yn=new TextDecoder("utf-8",{fatal:!0})),o=o.decode(l.subarray(J,J+Y));else{Y=J+Y;for(var d=[],g=null,n,u,f;J<Y;)n=l[J++],128>n?d.push(n):224>n?J>=Y?Ye():(u=l[J++],194>n||(u&192)!==128?(J--,Ye()):d.push((n&31)<<6|u&63)):240>n?J>=Y-1?Ye():(u=l[J++],(u&192)!==128||n===224&&160>u||n===237&&160<=u||((o=l[J++])&192)!==128?(J--,Ye()):d.push((n&15)<<12|(u&63)<<6|o&63)):244>=n?J>=Y-2?Ye():(u=l[J++],(u&192)!==128||(n<<28)+(u-144)>>30||((o=l[J++])&192)!==128||((f=l[J++])&192)!==128?(J--,Ye()):(n=(n&7)<<18|(u&63)<<12|(o&63)<<6|f&63,n-=65536,d.push((n>>10&1023)+55296,(n&1023)+56320))):Ye(),8192<=d.length&&(g=nn(g,d),d.length=0);o=nn(g,d);}return Ft(Z,x,o),!0;},function(l,Z,x){if(Z=se(Z,x),Z!=null){var Y=!1;if(Y=Y===void 0?!1:Y,Ln){if(Y&&/(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(Z))throw Error("Found an unpaired surrogate");Z=(Vn||(Vn=new TextEncoder())).encode(Z);}else{for(var J=0,o=new Uint8Array(3*Z.length),d=0;d<Z.length;d++){var g=Z.charCodeAt(d);if(128>g)o[J++]=g;else{if(2048>g)o[J++]=g>>6|192;else{if(55296<=g&&57343>=g){if(56319>=g&&d<Z.length){var n=Z.charCodeAt(++d);if(56320<=n&&57343>=n){g=1024*(g-55296)+n-56320+65536,o[J++]=g>>18|240,o[J++]=g>>12&63|128,o[J++]=g>>6&63|128,o[J++]=g&63|128;continue;}else d--;}if(Y)throw Error("Found an unpaired surrogate");g=65533;}o[J++]=g>>12|224,o[J++]=g>>6&63|128;}o[J++]=g&63|128;}}Z=o.subarray(0,J);}xe(l.g,8*x+2),xe(l.g,Z.length),ve(l,l.g.end()),ve(l,Z);}}),Ct=rt(function(l,Z,x,Y,J){if(l.h!==2)return!1;Z=Dt(Z,x,Y),x=l.g.i,Y=Ze(l.g)>>>0;var o=l.g.g+Y,d=o-x;if(0>=d&&(l.g.i=o,J(Z,l),d=o-l.g.g),d)throw Error("Message parsing ended unexpectedly. Expected to read "+(Y+" bytes, instead read "+(Y-d)+" bytes, either the data ended unexpectedly or the message misreported its own length"));return l.g.g=o,l.g.i=x,!0;},function(l,Z,x,Y,J){if(Z=He(Z,Y,x),Z!=null)for(Y=0;Y<Z.length;Y++){var o=l;xe(o.g,8*x+2);var d=o.g.end();ve(o,d),d.push(o.h),o=d,J(Z[Y],l),d=l;var g=o.pop();for(g=d.h+d.g.length()-g;127<g;)o.push(g&127|128),g>>>=7,d.h++;o.push(g),d.h++;}});function Tt(){qe.apply(this,arguments);}if(ht(Tt,qe),At){var jt={};Object.defineProperties(Tt,(jt[Symbol.hasInstance]=vn(Object[Symbol.hasInstance]),jt));}function wt(l){Tt.call(this,l);}ht(wt,Tt);function Vt(){return[1,dt,2,K,3,vt,4,vt];}function Ht(l){Tt.call(this,l,-1,te);}ht(Ht,Tt),Ht.prototype.addClassification=function(l,Z){return Dt(this,1,wt,l,Z),this;};function Et(){return[1,Ct,wt,Vt];}var te=[1];function ie(l){Tt.call(this,l);}ht(ie,Tt);function le(){return[1,K,2,K,3,K,4,K,5,K];}function Re(l){Tt.call(this,l,-1,y);}ht(Re,Tt);function h(){return[1,Ct,ie,le];}var y=[1];function G(l){Tt.call(this,l);}ht(G,Tt);function C(){return[1,K,2,K,3,K,4,K,5,K,6,nt];}function z(l,Z,x){if(x=l.createShader(x===0?l.VERTEX_SHADER:l.FRAGMENT_SHADER),l.shaderSource(x,Z),l.compileShader(x),!l.getShaderParameter(x,l.COMPILE_STATUS))throw Error(`Could not compile WebGL shader.

`+l.getShaderInfoLog(x));return x;}function P(l){return He(l,wt,1).map(function(Z){return{index:re(Z,1),score:ne(Z,2),label:se(Z,3)!=null?Ne(Z,3):void 0,displayName:se(Z,4)!=null?Ne(Z,4):void 0};});}function A(l){return{x:ne(l,1),y:ne(l,2),z:ne(l,3),visibility:se(l,4)!=null?ne(l,4):void 0};}function q(l){return l.map(function(Z){return He(V(Z,Re,h),ie,1).map(A);});}function ot(l,Z){this.h=l,this.g=Z,this.l=0;}function s(l,Z,x){return X(l,Z),typeof l.g.canvas.transferToImageBitmap=="function"?Promise.resolve(l.g.canvas.transferToImageBitmap()):x?Promise.resolve(l.g.canvas):typeof createImageBitmap=="function"?createImageBitmap(l.g.canvas):(l.i===void 0&&(l.i=document.createElement("canvas")),new Promise(function(Y){l.i.height=l.g.canvas.height,l.i.width=l.g.canvas.width,l.i.getContext("2d",{}).drawImage(l.g.canvas,0,0,l.g.canvas.width,l.g.canvas.height),Y(l.i);}));}function X(l,Z){var x=l.g;if(l.o===void 0){var Y=z(x,`
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`,0),J=z(x,`
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`,1),o=x.createProgram();if(x.attachShader(o,Y),x.attachShader(o,J),x.linkProgram(o),!x.getProgramParameter(o,x.LINK_STATUS))throw Error(`Could not compile WebGL program.

`+x.getProgramInfoLog(o));Y=l.o=o,x.useProgram(Y),J=x.getUniformLocation(Y,"sampler0"),l.j={K:x.getAttribLocation(Y,"aVertex"),J:x.getAttribLocation(Y,"aTex"),qa:J},l.u=x.createBuffer(),x.bindBuffer(x.ARRAY_BUFFER,l.u),x.enableVertexAttribArray(l.j.K),x.vertexAttribPointer(l.j.K,2,x.FLOAT,!1,0,0),x.bufferData(x.ARRAY_BUFFER,new Float32Array([-1,-1,-1,1,1,1,1,-1]),x.STATIC_DRAW),x.bindBuffer(x.ARRAY_BUFFER,null),l.s=x.createBuffer(),x.bindBuffer(x.ARRAY_BUFFER,l.s),x.enableVertexAttribArray(l.j.J),x.vertexAttribPointer(l.j.J,2,x.FLOAT,!1,0,0),x.bufferData(x.ARRAY_BUFFER,new Float32Array([0,1,0,0,1,0,1,1]),x.STATIC_DRAW),x.bindBuffer(x.ARRAY_BUFFER,null),x.uniform1i(J,0);}Y=l.j,x.useProgram(l.o),x.canvas.width=Z.width,x.canvas.height=Z.height,x.viewport(0,0,Z.width,Z.height),x.activeTexture(x.TEXTURE0),l.h.bindTexture2d(Z.glName),x.enableVertexAttribArray(Y.K),x.bindBuffer(x.ARRAY_BUFFER,l.u),x.vertexAttribPointer(Y.K,2,x.FLOAT,!1,0,0),x.enableVertexAttribArray(Y.J),x.bindBuffer(x.ARRAY_BUFFER,l.s),x.vertexAttribPointer(Y.J,2,x.FLOAT,!1,0,0),x.bindFramebuffer(x.DRAW_FRAMEBUFFER?x.DRAW_FRAMEBUFFER:x.FRAMEBUFFER,null),x.clearColor(0,0,0,0),x.clear(x.COLOR_BUFFER_BIT),x.colorMask(!0,!0,!0,!0),x.drawArrays(x.TRIANGLE_FAN,0,4),x.disableVertexAttribArray(Y.K),x.disableVertexAttribArray(Y.J),x.bindBuffer(x.ARRAY_BUFFER,null),l.h.bindTexture2d(0);}function R(l){this.g=l;}var w=new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,10,9,1,7,0,65,0,253,15,26,11]);function N(l,Z){return Z+l;}function B(l,Z){window[l]=Z;}function M(l){var Z=document.createElement("script");return Z.setAttribute("src",l),Z.setAttribute("crossorigin","anonymous"),new Promise(function(x){Z.addEventListener("load",function(){x();},!1),Z.addEventListener("error",function(){x();},!1),document.body.appendChild(Z);});}function et(){return yt(function(l){switch(l.g){case 1:return l.o=2,D(l,WebAssembly.instantiate(w),4);case 4:l.g=3,l.o=0;break;case 2:return l.o=0,l.j=null,l.return(!1);case 3:return l.return(!0);}});}function $(l){if(this.g=l,this.listeners={},this.j={},this.H={},this.o={},this.u={},this.I=this.s=this.$=!0,this.D=Promise.resolve(),this.Z="",this.C={},this.locateFile=l&&l.locateFile||N,typeof window=="object")var Z=window.location.pathname.toString().substring(0,window.location.pathname.toString().lastIndexOf("/"))+"/";else if(typeof location<"u")Z=location.pathname.toString().substring(0,location.pathname.toString().lastIndexOf("/"))+"/";else throw Error("solutions can only be loaded on a web page or in a web worker");if(this.aa=Z,l.options){Z=T(Object.keys(l.options));for(var x=Z.next();!x.done;x=Z.next()){x=x.value;var Y=l.options[x].default;Y!==void 0&&(this.j[x]=typeof Y=="function"?Y():Y);}}}r=$.prototype,r.close=function(){return this.i&&this.i.delete(),Promise.resolve();};function ft(l){var Z,x,Y,J,o,d,g,n,u,f,t;return yt(function(c){switch(c.g){case 1:return l.$?(Z=l.g.files===void 0?[]:typeof l.g.files=="function"?l.g.files(l.j):l.g.files,D(c,et(),2)):c.return();case 2:if(x=c.h,typeof window=="object")return B("createMediapipeSolutionsWasm",{locateFile:l.locateFile}),B("createMediapipeSolutionsPackedAssets",{locateFile:l.locateFile}),d=Z.filter(function(a){return a.data!==void 0;}),g=Z.filter(function(a){return a.data===void 0;}),n=Promise.all(d.map(function(a){var b=Gt(l,a.url);if(a.path!==void 0){var I=a.path;b=b.then(function(F){return l.overrideFile(I,F),Promise.resolve(F);});}return b;})),u=Promise.all(g.map(function(a){return a.simd===void 0||a.simd&&x||!a.simd&&!x?M(l.locateFile(a.url,l.aa)):Promise.resolve();})).then(function(){var a,b,I;return yt(function(F){if(F.g==1)return a=window.createMediapipeSolutionsWasm,b=window.createMediapipeSolutionsPackedAssets,I=l,D(F,a(b),2);I.h=F.h,F.g=0;});}),f=function(){return yt(function(a){return l.g.graph&&l.g.graph.url?a=D(a,Gt(l,l.g.graph.url),0):(a.g=0,a=void 0),a;});}(),D(c,Promise.all([u,n,f]),7);if(typeof importScripts!="function")throw Error("solutions can only be loaded on a web page or in a web worker");return Y=Z.filter(function(a){return a.simd===void 0||a.simd&&x||!a.simd&&!x;}).map(function(a){return l.locateFile(a.url,l.aa);}),importScripts.apply(null,k(Y)),J=l,D(c,createMediapipeSolutionsWasm(Module),6);case 6:J.h=c.h,l.l=new OffscreenCanvas(1,1),l.h.canvas=l.l,o=l.h.GL.createContext(l.l,{antialias:!1,alpha:!1,na:typeof WebGL2RenderingContext<"u"?2:1}),l.h.GL.makeContextCurrent(o),c.g=4;break;case 7:if(l.l=document.createElement("canvas"),t=l.l.getContext("webgl2",{}),!t&&(t=l.l.getContext("webgl",{}),!t))return alert("Failed to create WebGL canvas context when passing video frame."),c.return();l.G=t,l.h.canvas=l.l,l.h.createContext(l.l,!0,!0,{});case 4:l.i=new l.h.SolutionWasm(),l.$=!1,c.g=0;}});}function gt(l){var Z,x,Y,J,o,d,g,n;return yt(function(u){if(u.g==1){if(l.g.graph&&l.g.graph.url&&l.Z===l.g.graph.url)return u.return();if(l.s=!0,!l.g.graph||!l.g.graph.url){u.g=2;return;}return l.Z=l.g.graph.url,D(u,Gt(l,l.g.graph.url),3);}for(u.g!=2&&(Z=u.h,l.i.loadGraph(Z)),x=T(Object.keys(l.C)),Y=x.next();!Y.done;Y=x.next())J=Y.value,l.i.overrideFile(J,l.C[J]);if(l.C={},l.g.listeners)for(o=T(l.g.listeners),d=o.next();!d.done;d=o.next())g=d.value,Xt(l,g);n=l.j,l.j={},l.setOptions(n),u.g=0;});}r.reset=function(){var l=this;return yt(function(Z){l.i&&(l.i.reset(),l.o={},l.u={}),Z.g=0;});},r.setOptions=function(l,Z){var x=this;if(Z=Z||this.g.options){for(var Y=[],J=[],o={},d=T(Object.keys(l)),g=d.next();!g.done;o={R:o.R,S:o.S},g=d.next()){var n=g.value;n in this.j&&this.j[n]===l[n]||(this.j[n]=l[n],g=Z[n],g!==void 0&&(g.onChange&&(o.R=g.onChange,o.S=l[n],Y.push(/* @__PURE__ */function(u){return function(){var f;return yt(function(t){if(t.g==1)return D(t,u.R(u.S),2);f=t.h,f===!0&&(x.s=!0),t.g=0;});};}(o))),g.graphOptionXref&&(n={valueNumber:g.type===1?l[n]:0,valueBoolean:g.type===0?l[n]:!1,valueString:g.type===2?l[n]:""},g=Object.assign(Object.assign(Object.assign({},{calculatorName:"",calculatorIndex:0}),g.graphOptionXref),n),J.push(g))));}(Y.length!==0||J.length!==0)&&(this.s=!0,this.B=(this.B===void 0?[]:this.B).concat(J),this.A=(this.A===void 0?[]:this.A).concat(Y));}};function Nt(l){var Z,x,Y,J,o,d,g;return yt(function(n){switch(n.g){case 1:if(!l.s)return n.return();if(!l.A){n.g=2;break;}Z=T(l.A),x=Z.next();case 3:if(x.done){n.g=5;break;}return Y=x.value,D(n,Y(),4);case 4:x=Z.next(),n.g=3;break;case 5:l.A=void 0;case 2:if(l.B){for(J=new l.h.GraphOptionChangeRequestList(),o=T(l.B),d=o.next();!d.done;d=o.next())g=d.value,J.push_back(g);l.i.changeOptions(J),J.delete(),l.B=void 0;}l.s=!1,n.g=0;}});}r.initialize=function(){var l=this;return yt(function(Z){return Z.g==1?D(Z,ft(l),2):Z.g!=3?D(Z,gt(l),3):D(Z,Nt(l),0);});};function Gt(l,Z){var x,Y;return yt(function(J){return Z in l.H?J.return(l.H[Z]):(x=l.locateFile(Z,""),Y=fetch(x).then(function(o){return o.arrayBuffer();}),l.H[Z]=Y,J.return(Y));});}r.overrideFile=function(l,Z){this.i?this.i.overrideFile(l,Z):this.C[l]=Z;},r.clearOverriddenFiles=function(){this.C={},this.i&&this.i.clearOverriddenFiles();},r.send=function(l,Z){var x=this,Y,J,o,d,g,n,u,f,t;return yt(function(c){switch(c.g){case 1:return x.g.inputs?(Y=1e3*(Z!=null?Z:performance.now()),D(c,x.D,2)):c.return();case 2:return D(c,x.initialize(),3);case 3:for(J=new x.h.PacketDataList(),o=T(Object.keys(l)),d=o.next();!d.done;d=o.next())if(g=d.value,n=x.g.inputs[g]){t:{var a=l[g];switch(n.type){case"video":var b=x.o[n.stream];if(b||(b=new ot(x.h,x.G),x.o[n.stream]=b),b.l===0&&(b.l=b.h.createTexture()),typeof HTMLVideoElement<"u"&&a instanceof HTMLVideoElement)var I=a.videoWidth,F=a.videoHeight;else typeof HTMLImageElement<"u"&&a instanceof HTMLImageElement?(I=a.naturalWidth,F=a.naturalHeight):(I=a.width,F=a.height);F={glName:b.l,width:I,height:F},I=b.g,I.canvas.width=F.width,I.canvas.height=F.height,I.activeTexture(I.TEXTURE0),b.h.bindTexture2d(b.l),I.texImage2D(I.TEXTURE_2D,0,I.RGBA,I.RGBA,I.UNSIGNED_BYTE,a),b.h.bindTexture2d(0),b=F;break t;case"detections":for(b=x.o[n.stream],b||(b=new R(x.h),x.o[n.stream]=b),b.data||(b.data=new b.g.DetectionListData()),b.data.reset(a.length),F=0;F<a.length;++F){I=a[F];var H=b.data,E=H.setBoundingBox,j=F,_=I.ea,Q=new G();if(Ft(Q,1,_.ka),Ft(Q,2,_.la),Ft(Q,3,_.height),Ft(Q,4,_.width),Ft(Q,5,_.rotation),Ft(Q,6,_.ia),_=O(Q,C),E.call(H,j,_),I.Y)for(H=0;H<I.Y.length;++H){Q=I.Y[H];var it=!!Q.visibility;E=b.data,j=E.addNormalizedLandmark,_=F,Q=Object.assign(Object.assign({},Q),{visibility:it?Q.visibility:0}),it=new ie(),Ft(it,1,Q.x),Ft(it,2,Q.y),Ft(it,3,Q.z),Q.visibility&&Ft(it,4,Q.visibility),Q=O(it,le),j.call(E,_,Q);}if(I.V)for(H=0;H<I.V.length;++H)E=b.data,j=E.addClassification,_=F,Q=I.V[H],it=new wt(),Ft(it,2,Q.score),Q.index&&Ft(it,1,Q.index),Q.label&&Ft(it,3,Q.label),Q.displayName&&Ft(it,4,Q.displayName),Q=O(it,Vt),j.call(E,_,Q);}b=b.data;break t;default:b={};}}switch(u=b,f=n.stream,n.type){case"video":J.pushTexture2d(Object.assign(Object.assign({},u),{stream:f,timestamp:Y}));break;case"detections":t=u,t.stream=f,t.timestamp=Y,J.pushDetectionList(t);break;default:throw Error("Unknown input config type: '"+n.type+"'");}}return x.i.send(J),D(c,x.D,4);case 4:J.delete(),c.g=0;}});};function lt(l,Z,x){var Y,J,o,d,g,n,u,f,t,c,a,b,I,F;return yt(function(H){switch(H.g){case 1:if(!x)return H.return(Z);for(Y={},J=0,o=T(Object.keys(x)),d=o.next();!d.done;d=o.next())g=d.value,n=x[g],typeof n!="string"&&n.type==="texture"&&Z[n.stream]!==void 0&&++J;1<J&&(l.I=!1),u=T(Object.keys(x)),d=u.next();case 2:if(d.done){H.g=4;break;}if(f=d.value,t=x[f],typeof t=="string")return I=Y,F=f,D(H,Zt(l,f,Z[t]),14);if(c=Z[t.stream],t.type==="detection_list"){if(c){for(var E=c.getRectList(),j=c.getLandmarksList(),_=c.getClassificationsList(),Q=[],it=0;it<E.size();++it){var ct=V(E.get(it),G,C);ct={ea:{ka:ne(ct,1),la:ne(ct,2),height:ne(ct,3),width:ne(ct,4),rotation:ne(ct,5,0),ia:re(ct,6)},Y:He(V(j.get(it),Re,h),ie,1).map(A),V:P(V(_.get(it),Ht,Et))},Q.push(ct);}E=Q;}else E=[];Y[f]=E,H.g=7;break;}if(t.type==="proto_list"){if(c){for(E=Array(c.size()),j=0;j<c.size();j++)E[j]=c.get(j);c.delete();}else E=[];Y[f]=E,H.g=7;break;}if(c===void 0){H.g=3;break;}if(t.type==="float_list"){Y[f]=c,H.g=7;break;}if(t.type==="proto"){Y[f]=c,H.g=7;break;}if(t.type!=="texture")throw Error("Unknown output config type: '"+t.type+"'");return a=l.u[f],a||(a=new ot(l.h,l.G),l.u[f]=a),D(H,s(a,c,l.I),13);case 13:b=H.h,Y[f]=b;case 7:t.transform&&Y[f]&&(Y[f]=t.transform(Y[f])),H.g=3;break;case 14:I[F]=H.h;case 3:d=u.next(),H.g=2;break;case 4:return H.return(Y);}});}function Zt(l,Z,x){var Y;return yt(function(J){return typeof x=="number"||x instanceof Uint8Array||x instanceof l.h.Uint8BlobList?J.return(x):x instanceof l.h.Texture2dDataOut?(Y=l.u[Z],Y||(Y=new ot(l.h,l.G),l.u[Z]=Y),J.return(s(Y,x,l.I))):J.return(void 0);});}function Xt(l,Z){for(var x=Z.name||"$",Y=[].concat(k(Z.wants)),J=new l.h.StringList(),o=T(Z.wants),d=o.next();!d.done;d=o.next())J.push_back(d.value);o=l.h.PacketListener.implement({onResults:function onResults(g){for(var n={},u=0;u<Z.wants.length;++u)n[Y[u]]=g.get(u);var f=l.listeners[x];f&&(l.D=lt(l,n,Z.outs).then(function(t){t=f(t);for(var c=0;c<Z.wants.length;++c){var a=n[Y[c]];typeof a=="object"&&a.hasOwnProperty&&a.hasOwnProperty("delete")&&a.delete();}t&&(l.D=t);}));}}),l.i.attachMultiListener(J,o),J.delete();}r.onResults=function(l,Z){this.listeners[Z||"$"]=l;},Lt("Solution",$),Lt("OptionType",{BOOL:0,NUMBER:1,ma:2,0:"BOOL",1:"NUMBER",2:"STRING"});function Rt(l){return l===void 0&&(l=0),l===1?"hand_landmark_full.tflite":"hand_landmark_lite.tflite";}function St(l){var Z=this;l=l||{},this.g=new $({locateFile:l.locateFile,files:function files(x){return[{url:"hands_solution_packed_assets_loader.js"},{simd:!1,url:"hands_solution_wasm_bin.js"},{simd:!0,url:"hands_solution_simd_wasm_bin.js"},{data:!0,url:Rt(x.modelComplexity)}];},graph:{url:"hands.binarypb"},inputs:{image:{type:"video",stream:"input_frames_gpu"}},listeners:[{wants:["multi_hand_landmarks","multi_hand_world_landmarks","image_transformed","multi_handedness"],outs:{image:"image_transformed",multiHandLandmarks:{type:"proto_list",stream:"multi_hand_landmarks",transform:q},multiHandWorldLandmarks:{type:"proto_list",stream:"multi_hand_world_landmarks",transform:q},multiHandedness:{type:"proto_list",stream:"multi_handedness",transform:function transform(x){return x.map(function(Y){return P(V(Y,Ht,Et))[0];});}}}}],options:{useCpuInference:{type:0,graphOptionXref:{calculatorType:"InferenceCalculator",fieldName:"use_cpu_inference"},default:typeof window!="object"||window.navigator===void 0?!1:"iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document},selfieMode:{type:0,graphOptionXref:{calculatorType:"GlScalerCalculator",calculatorIndex:1,fieldName:"flip_horizontal"}},maxNumHands:{type:1,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculator",fieldName:"int_value"}},modelComplexity:{type:1,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorModelComplexity",fieldName:"int_value"},onChange:function onChange(x){var Y,J,o;return yt(function(d){return d.g==1?(Y=Rt(x),J="third_party/mediapipe/modules/hand_landmark/"+Y,D(d,Gt(Z.g,Y),2)):(o=d.h,Z.g.overrideFile(J,o),d.return(!0));});}},minDetectionConfidence:{type:1,graphOptionXref:{calculatorType:"TensorsToDetectionsCalculator",calculatorName:"handlandmarktrackinggpu__palmdetectiongpu__TensorsToDetectionsCalculator",fieldName:"min_score_thresh"}},minTrackingConfidence:{type:1,graphOptionXref:{calculatorType:"ThresholdingCalculator",calculatorName:"handlandmarktrackinggpu__handlandmarkgpu__ThresholdingCalculator",fieldName:"threshold"}}}});}r=St.prototype,r.close=function(){return this.g.close(),Promise.resolve();},r.onResults=function(l){this.g.onResults(l);},r.initialize=function(){var l=this;return yt(function(Z){return D(Z,l.g.initialize(),0);});},r.reset=function(){this.g.reset();},r.send=function(l){var Z=this;return yt(function(x){return D(x,Z.g.send(l),0);});},r.setOptions=function(l){this.g.setOptions(l);},Lt("Hands",St),Lt("HAND_CONNECTIONS",[[0,1],[1,2],[2,3],[3,4],[0,5],[5,6],[6,7],[7,8],[5,9],[9,10],[10,11],[11,12],[9,13],[13,14],[14,15],[15,16],[13,17],[0,17],[17,18],[18,19],[19,20]]),Lt("VERSION","0.4.1646424915");}).call(Ri);var xi={};(function(){var r;function e(n){var u=0;return function(){return u<n.length?{done:!1,value:n[u++]}:{done:!0};};}var i=typeof Object.defineProperties=="function"?Object.defineProperty:function(n,u,f){return n==Array.prototype||n==Object.prototype||(n[u]=f.value),n;};function m(n){n=[typeof globalThis=="object"&&globalThis,n,typeof window=="object"&&window,typeof self=="object"&&self,typeof (typeof window !== undefined ? window : global)=="object"&&(typeof window !== undefined ? window : global)];for(var u=0;u<n.length;++u){var f=n[u];if(f&&f.Math==Math)return f;}throw Error("Cannot find global object");}var v=m(this);function S(n,u){if(u)t:{var f=v;n=n.split(".");for(var t=0;t<n.length-1;t++){var c=n[t];if(!(c in f))break t;f=f[c];}n=n[n.length-1],t=f[n],u=u(t),u!=t&&u!=null&&i(f,n,{configurable:!0,writable:!0,value:u});}}S("Symbol",function(n){function u(a){if(this instanceof u)throw new TypeError("Symbol is not a constructor");return new f(t+(a||"")+"_"+c++,a);}function f(a,b){this.g=a,i(this,"description",{configurable:!0,writable:!0,value:b});}if(n)return n;f.prototype.toString=function(){return this.g;};var t="jscomp_symbol_"+(1e9*Math.random()>>>0)+"_",c=0;return u;}),S("Symbol.iterator",function(n){if(n)return n;n=Symbol("Symbol.iterator");for(var u="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),f=0;f<u.length;f++){var t=v[u[f]];typeof t=="function"&&typeof t.prototype[n]!="function"&&i(t.prototype,n,{configurable:!0,writable:!0,value:function value(){return L(e(this));}});}return n;});function L(n){return n={next:n},n[Symbol.iterator]=function(){return this;},n;}function T(n){var u=typeof Symbol<"u"&&Symbol.iterator&&n[Symbol.iterator];return u?u.call(n):{next:e(n)};}function k(n){if(!(n instanceof Array)){n=T(n);for(var u,f=[];!(u=n.next()).done;)f.push(u.value);n=f;}return n;}var tt=typeof Object.create=="function"?Object.create:function(n){function u(){}return u.prototype=n,new u();},st;if(typeof Object.setPrototypeOf=="function")st=Object.setPrototypeOf;else{var bt;t:{var xt={a:!0},Yt={};try{Yt.__proto__=xt,bt=Yt.a;break t;}catch(_unused6){}bt=!1;}st=bt?function(n,u){if(n.__proto__=u,n.__proto__!==u)throw new TypeError(n+" is not extensible");return n;}:null;}var at=st;function ht(n,u){if(n.prototype=tt(u.prototype),n.prototype.constructor=n,at)at(n,u);else for(var f in u)if(f!="prototype")if(Object.defineProperties){var t=Object.getOwnPropertyDescriptor(u,f);t&&Object.defineProperty(n,f,t);}else n[f]=u[f];n.da=u.prototype;}function Ut(){this.l=!1,this.i=null,this.h=void 0,this.g=1,this.s=this.m=0,this.j=null;}function Mt(n){if(n.l)throw new TypeError("Generator is already running");n.l=!0;}Ut.prototype.o=function(n){this.h=n;};function oe(n,u){n.j={U:u,V:!0},n.g=n.m||n.s;}Ut.prototype.return=function(n){this.j={return:n},this.g=this.s;};function D(n,u,f){return n.g=f,{value:u};}function hn(n){this.g=new Ut(),this.h=n;}function bn(n,u){Mt(n.g);var f=n.g.i;return f?ge(n,"return"in f?f.return:function(t){return{value:t,done:!0};},u,n.g.return):(n.g.return(u),Kt(n));}function ge(n,u,f,t){try{var c=u.call(n.g.i,f);if(!(c instanceof Object))throw new TypeError("Iterator result "+c+" is not an object");if(!c.done)return n.g.l=!1,c;var a=c.value;}catch(b){return n.g.i=null,oe(n.g,b),Kt(n);}return n.g.i=null,t.call(n.g,a),Kt(n);}function Kt(n){for(;n.g.g;)try{var u=n.h(n.g);if(u)return n.g.l=!1,{value:u.value,done:!1};}catch(f){n.g.h=void 0,oe(n.g,f);}if(n.g.l=!1,n.g.j){if(u=n.g.j,n.g.j=null,u.V)throw u.U;return{value:u.return,done:!0};}return{value:void 0,done:!0};}function jn(n){this.next=function(u){return Mt(n.g),n.g.i?u=ge(n,n.g.i.next,u,n.g.o):(n.g.o(u),u=Kt(n)),u;},this.throw=function(u){return Mt(n.g),n.g.i?u=ge(n,n.g.i.throw,u,n.g.o):(oe(n.g,u),u=Kt(n)),u;},this.return=function(u){return bn(n,u);},this[Symbol.iterator]=function(){return this;};}function ue(n){function u(t){return n.next(t);}function f(t){return n.throw(t);}return new Promise(function(t,c){function a(b){b.done?t(b.value):Promise.resolve(b.value).then(u,f).then(a,c);}a(n.next());});}function yt(n){return ue(new jn(new hn(n)));}S("Promise",function(n){function u(b){this.h=0,this.i=void 0,this.g=[],this.o=!1;var I=this.j();try{b(I.resolve,I.reject);}catch(F){I.reject(F);}}function f(){this.g=null;}function t(b){return b instanceof u?b:new u(function(I){I(b);});}if(n)return n;f.prototype.h=function(b){if(this.g==null){this.g=[];var I=this;this.i(function(){I.l();});}this.g.push(b);};var c=v.setTimeout;f.prototype.i=function(b){c(b,0);},f.prototype.l=function(){for(;this.g&&this.g.length;){var b=this.g;this.g=[];for(var I=0;I<b.length;++I){var F=b[I];b[I]=null;try{F();}catch(H){this.j(H);}}}this.g=null;},f.prototype.j=function(b){this.i(function(){throw b;});},u.prototype.j=function(){function b(H){return function(E){F||(F=!0,H.call(I,E));};}var I=this,F=!1;return{resolve:b(this.C),reject:b(this.l)};},u.prototype.C=function(b){if(b===this)this.l(new TypeError("A Promise cannot resolve to itself"));else if(b instanceof u)this.F(b);else{t:switch(typeof b){case"object":var I=b!=null;break t;case"function":I=!0;break t;default:I=!1;}I?this.v(b):this.m(b);}},u.prototype.v=function(b){var I=void 0;try{I=b.then;}catch(F){this.l(F);return;}typeof I=="function"?this.G(I,b):this.m(b);},u.prototype.l=function(b){this.s(2,b);},u.prototype.m=function(b){this.s(1,b);},u.prototype.s=function(b,I){if(this.h!=0)throw Error("Cannot settle("+b+", "+I+"): Promise already settled in state"+this.h);this.h=b,this.i=I,this.h===2&&this.D(),this.A();},u.prototype.D=function(){var b=this;c(function(){if(b.B()){var I=v.console;typeof I<"u"&&I.error(b.i);}},1);},u.prototype.B=function(){if(this.o)return!1;var b=v.CustomEvent,I=v.Event,F=v.dispatchEvent;return typeof F>"u"?!0:(typeof b=="function"?b=new b("unhandledrejection",{cancelable:!0}):typeof I=="function"?b=new I("unhandledrejection",{cancelable:!0}):(b=v.document.createEvent("CustomEvent"),b.initCustomEvent("unhandledrejection",!1,!0,b)),b.promise=this,b.reason=this.i,F(b));},u.prototype.A=function(){if(this.g!=null){for(var b=0;b<this.g.length;++b)a.h(this.g[b]);this.g=null;}};var a=new f();return u.prototype.F=function(b){var I=this.j();b.J(I.resolve,I.reject);},u.prototype.G=function(b,I){var F=this.j();try{b.call(I,F.resolve,F.reject);}catch(H){F.reject(H);}},u.prototype.then=function(b,I){function F(_,Q){return typeof _=="function"?function(it){try{H(_(it));}catch(ct){E(ct);}}:Q;}var H,E,j=new u(function(_,Q){H=_,E=Q;});return this.J(F(b,H),F(I,E)),j;},u.prototype.catch=function(b){return this.then(void 0,b);},u.prototype.J=function(b,I){function F(){switch(H.h){case 1:b(H.i);break;case 2:I(H.i);break;default:throw Error("Unexpected state: "+H.h);}}var H=this;this.g==null?a.h(F):this.g.push(F),this.o=!0;},u.resolve=t,u.reject=function(b){return new u(function(I,F){F(b);});},u.race=function(b){return new u(function(I,F){for(var H=T(b),E=H.next();!E.done;E=H.next())t(E.value).J(I,F);});},u.all=function(b){var I=T(b),F=I.next();return F.done?t([]):new u(function(H,E){function j(it){return function(ct){_[it]=ct,Q--,Q==0&&H(_);};}var _=[],Q=0;do _.push(void 0),Q++,t(F.value).J(j(_.length-1),E),F=I.next();while(!F.done);});},u;});function Kn(n,u){n instanceof String&&(n+="");var f=0,t=!1,c={next:function next(){if(!t&&f<n.length){var a=f++;return{value:u(a,n[a]),done:!1};}return t=!0,{done:!0,value:void 0};}};return c[Symbol.iterator]=function(){return c;},c;}var On=typeof Object.assign=="function"?Object.assign:function(n,u){for(var f=1;f<arguments.length;f++){var t=arguments[f];if(t)for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&(n[c]=t[c]);}return n;};S("Object.assign",function(n){return n||On;}),S("Object.is",function(n){return n||function(u,f){return u===f?u!==0||1/u===1/f:u!==u&&f!==f;};}),S("Array.prototype.includes",function(n){return n||function(u,f){var t=this;t instanceof String&&(t=String(t));var c=t.length;for(f=f||0,0>f&&(f=Math.max(f+c,0));f<c;f++){var a=t[f];if(a===u||Object.is(a,u))return!0;}return!1;};}),S("String.prototype.includes",function(n){return n||function(u,f){if(this==null)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(u instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return this.indexOf(u,f||0)!==-1;};}),S("Array.prototype.keys",function(n){return n||function(){return Kn(this,function(u){return u;});};});var Xe=this||self;function Lt(n,u){n=n.split(".");var f=Xe;n[0]in f||typeof f.execScript>"u"||f.execScript("var "+n[0]);for(var t;n.length&&(t=n.shift());)n.length||u===void 0?f[t]&&f[t]!==Object.prototype[t]?f=f[t]:f=f[t]={}:f[t]=u;}function Ye(n){Xe.setTimeout(function(){throw n;},0);}function nn(n){Ye(n);}function yn(n,u){nn(Error("Invalid wire type: "+n+" (at position "+u+")"));}function Yn(){nn(Error("Failed to read varint, encoding is invalid."));}function Vn(n,u){return u=String.fromCharCode.apply(null,u),n==null?u:n+u;}var Ln,rn=typeof TextDecoder<"u",un,Jn=typeof TextEncoder<"u";function wn(n){if(Jn)n=(un||(un=new TextEncoder())).encode(n);else{var u=void 0;u=u===void 0?!1:u;for(var f=0,t=new Uint8Array(3*n.length),c=0;c<n.length;c++){var a=n.charCodeAt(c);if(128>a)t[f++]=a;else{if(2048>a)t[f++]=a>>6|192;else{if(55296<=a&&57343>=a){if(56319>=a&&c<n.length){var b=n.charCodeAt(++c);if(56320<=b&&57343>=b){a=1024*(a-55296)+b-56320+65536,t[f++]=a>>18|240,t[f++]=a>>12&63|128,t[f++]=a>>6&63|128,t[f++]=a&63|128;continue;}else c--;}if(u)throw Error("Found an unpaired surrogate");a=65533;}t[f++]=a>>12|224,t[f++]=a>>6&63|128;}t[f++]=a&63|128;}}n=t.subarray(0,f);}return n;}var gn={},on=null;function Rn(n){var u;u===void 0&&(u=0),We(),u=gn[u];for(var f=Array(Math.floor(n.length/3)),t=u[64]||"",c=0,a=0;c<n.length-2;c+=3){var b=n[c],I=n[c+1],F=n[c+2],H=u[b>>2];b=u[(b&3)<<4|I>>4],I=u[(I&15)<<2|F>>6],F=u[F&63],f[a++]=H+b+I+F;}switch(H=0,F=t,n.length-c){case 2:H=n[c+1],F=u[(H&15)<<2]||t;case 1:n=n[c],f[a]=u[n>>2]+u[(n&3)<<4|H>>4]+F+t;}return f.join("");}function Zn(n){var u=n.length,f=3*u/4;f%3?f=Math.floor(f):"=.".indexOf(n[u-1])!=-1&&(f="=.".indexOf(n[u-2])!=-1?f-2:f-1);var t=new Uint8Array(f),c=0;return be(n,function(a){t[c++]=a;}),t.subarray(0,c);}function be(n,u){function f(F){for(;t<n.length;){var H=n.charAt(t++),E=on[H];if(E!=null)return E;if(!/^[\s\xa0]*$/.test(H))throw Error("Unknown base64 encoding at char: "+H);}return F;}We();for(var t=0;;){var c=f(-1),a=f(0),b=f(64),I=f(64);if(I===64&&c===-1)break;u(c<<2|a>>4),b!=64&&(u(a<<4&240|b>>2),I!=64&&u(b<<6&192|I));}}function We(){if(!on){on={};for(var n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),u=["+/=","+/","-_=","-_.","-_"],f=0;5>f;f++){var t=n.concat(u[f].split(""));gn[f]=t;for(var c=0;c<t.length;c++){var a=t[c];on[a]===void 0&&(on[a]=c);}}}}var Pe=typeof Uint8Array=="function",pe;function ye(n){if(this.g=n,n!==null&&n.length===0)throw Error("ByteString should be constructed with non-empty values");}ye.prototype.toJSON=function(){if(this.g==null)var n="";else n=this.g,n=this.g=n==null||typeof n=="string"?n:Pe&&n instanceof Uint8Array?Rn(n):null;return n;};var De=typeof Uint8Array.prototype.slice=="function";function Ce(n,u,f){return u===f?pe||(pe=new Uint8Array(0)):De?n.slice(u,f):new Uint8Array(n.subarray(u,f));}var Pt=0,de=0;function we(n){if(n.constructor===Uint8Array)return n;if(n.constructor===ArrayBuffer)return new Uint8Array(n);if(n.constructor===Array)return new Uint8Array(n);if(n.constructor===String)return Zn(n);if(n.constructor===ye){if(n.g==null)var u=pe||(pe=new Uint8Array(0));else{u=Uint8Array;var f=n.g;f=f==null||Pe&&f!=null&&f instanceof Uint8Array?f:typeof f=="string"?Zn(f):null,n=n.g=f,u=new u(n);}return u;}if(n instanceof Uint8Array)return new Uint8Array(n.buffer,n.byteOffset,n.byteLength);throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");}function Jt(n,u){u=u===void 0?{}:u,u=u.u===void 0?!1:u.u,this.h=null,this.g=this.i=this.m=0,this.l=!1,this.u=u,n&&Ze(this,n);}function Ze(n,u){n.h=we(u),n.m=0,n.i=n.h.length,n.g=n.m;}Jt.prototype.reset=function(){this.g=this.m;};function _t(n){for(var u=128,f=0,t=0,c=0;4>c&&128<=u;c++)u=n.h[n.g++],f|=(u&127)<<7*c;if(128<=u&&(u=n.h[n.g++],f|=(u&127)<<28,t|=(u&127)>>4),128<=u)for(c=0;5>c&&128<=u;c++)u=n.h[n.g++],t|=(u&127)<<7*c+3;if(128>u)return n=f>>>0,u=t>>>0,(t=u&2147483648)&&(n=~n+1>>>0,u=~u>>>0,n==0&&(u=u+1>>>0)),n=4294967296*u+(n>>>0),t?-n:n;n.l=!0,Yn();}function ae(n){n.g>n.i&&(n.l=!0,nn(Error("Tried to read past the end of the data "+n.g+" > "+n.i)));}Jt.prototype.j=function(){var n=this.h,u=n[this.g],f=u&127;return 128>u?(this.g+=1,ae(this),f):(u=n[this.g+1],f|=(u&127)<<7,128>u?(this.g+=2,ae(this),f):(u=n[this.g+2],f|=(u&127)<<14,128>u?(this.g+=3,ae(this),f):(u=n[this.g+3],f|=(u&127)<<21,128>u?(this.g+=4,ae(this),f):(u=n[this.g+4],f|=(u&15)<<28,128>u?(this.g+=5,ae(this),f>>>0):(this.g+=5,128<=n[this.g++]&&128<=n[this.g++]&&128<=n[this.g++]&&128<=n[this.g++]&&128<=n[this.g++]?(this.l=!0,Yn(),f):(ae(this),f))))));},Jt.prototype.o=function(){var n=this.h[this.g],u=this.h[this.g+1],f=this.h[this.g+2],t=this.h[this.g+3];return this.g+=4,ae(this),f=(n<<0|u<<8|f<<16|t<<24)>>>0,n=2*(f>>31)+1,u=f>>>23&255,f&=8388607,u==255?f?NaN:1/0*n:u==0?n*Math.pow(2,-149)*f:n*Math.pow(2,u-150)*(f+Math.pow(2,23));};var xe=[];function _e(){this.g=new Uint8Array(64),this.h=0;}function me(n,u){if(!(n.h+1<n.g.length)){var f=n.g;n.g=new Uint8Array(Math.ceil(1+2*n.g.length)),n.g.set(f);}n.g[n.h++]=u;}_e.prototype.length=function(){return this.h;},_e.prototype.end=function(){var n=this.g,u=this.h;return this.h=0,Ce(n,0,u);};function zt(n,u){for(;127<u;)me(n,u&127|128),u>>>=7;me(n,u);}function Je(n){var u={},f=u.N===void 0?!1:u.N;this.m={u:u.u===void 0?!1:u.u},this.N=f,u=this.m,xe.length?(f=xe.pop(),u&&(f.u=u.u),n&&Ze(f,n),n=f):n=new Jt(n,u),this.g=n,this.l=this.g.g,this.h=this.i=-1,this.j=!1;}Je.prototype.reset=function(){this.g.reset(),this.h=this.i=-1;};function Ae(n){var u=n.g;if((u=u.g==u.i)||(u=n.j)||(u=n.g,u=u.l||0>u.g||u.g>u.i),u)return!1;n.l=n.g.g;var f=n.g.j();return u=f>>>3,f&=7,0<=f&&5>=f?(n.i=u,n.h=f,!0):(n.j=!0,yn(f,n.l),!1);}function ve(n){switch(n.h){case 0:if(n.h!=0)ve(n);else t:{n=n.g;for(var u=n.g,f=0;10>f;f++){if(!(n.h[u]&128)){n.g=u+1,ae(n);break t;}u++;}n.l=!0,Yn();}break;case 1:n=n.g,n.g+=8,ae(n);break;case 2:n.h!=2?ve(n):(u=n.g.j(),n=n.g,n.g+=u,ae(n));break;case 5:n=n.g,n.g+=4,ae(n);break;case 3:u=n.i;do{if(!Ae(n)){n.j=!0,nn(Error("Unmatched start-group tag: stream EOF"));break;}if(n.h==4){n.i!=u&&(n.j=!0,nn(Error("Unmatched end-group tag")));break;}ve(n);}while(!0);break;default:n.j=!0,yn(n.h,n.l);}}function Sn(n,u,f){n.N||(n=Ce(n.g.h,f,n.g.g),(f=u.o)?f.push(n):u.o=[n]);}function $e(n,u,f){var t=n.g.i,c=n.g.j(),a=n.g.g+c;if(n.g.i=a,f(u,n),f=a-n.g.g,f!==0)throw Error("Message parsing ended unexpectedly. Expected to read "+(c+" bytes, instead read "+(c-f)+" bytes, either the data ended unexpectedly or the message misreported its own length"));return n.g.g=a,n.g.i=t,u;}function an(n,u,f){var t=n.g.j();for(t=n.g.g+t;n.g.g<t;)f.push(u.call(n.g));}var fn=[];function he(){this.h=[],this.i=0,this.g=new _e();}function Ie(n,u){u.length!==0&&(n.h.push(u),n.i+=u.length);}function fe(n,u,f){zt(n.g,8*u+2),zt(n.g,f.length),Ie(n,n.g.end()),Ie(n,f);}var ee=typeof Symbol=="function"&&typeof Symbol()=="symbol"?Symbol(void 0):void 0;function Be(n,u){Object.isFrozen(n)||(ee?n[ee]|=u:n.g!==void 0?n.g|=u:Object.defineProperties(n,{g:{value:u,configurable:!0,writable:!0,enumerable:!1}}));}function Qt(n){var _u2;if(!n)return 0;var u;return ee?u=n[ee]:u=n.g,(_u2=u)!=null?_u2:0;}function At(n){return Array.isArray(n)&&Be(n,1),n;}function vn(n){if(!Array.isArray(n))throw Error("cannot mark non-array as immutable");Be(n,2);}function se(n){return n!==null&&typeof n=="object"&&n.constructor===Object;}function Ft(n){switch(typeof n){case"number":return isFinite(n)?n:String(n);case"object":return Pe&&n!=null&&n instanceof Uint8Array?Rn(n):n;default:return n;}}function Wt(n,u){if(n!=null)return Array.isArray(n)||se(n)?ne(n,u):u(n);}function ne(n,u){if(Array.isArray(n)){for(var f=Array(n.length),t=0;t<n.length;t++)f[t]=Wt(n[t],u);return Qt(n)&1&&At(f),f;}f={};for(t in n)f[t]=Wt(n[t],u);return f;}var He;function Dt(n,u,f){var t=He;He=null,n||(n=t),t=this.constructor.ba,n||(n=t?[t]:[]),this.j=(t?0:-1)-(this.constructor.$||0),this.m=this.g=null,this.h=n;t:{if(t=this.h.length,n=t-1,t&&(t=this.h[n],se(t))){this.l=n-this.j,this.i=t;break t;}u!==void 0&&-1<u?(this.l=Math.max(u,n+1-this.j),this.i=null):this.l=Number.MAX_VALUE;}if(f)for(u=0;u<f.length;u++)n=f[u],n<this.l?(n+=this.j,(t=this.h[n])?At(t):this.h[n]=re):(Ne(this),(t=this.i[n])?At(t):this.i[n]=re);}var re=Object.freeze(At([]));function Ne(n){var u=n.l+n.j;n.h[u]||(n.i=n.h[u]={});}function Bt(n,u,f){return u===-1?null:f!==void 0&&f||u>=n.l?n.i?n.i[u]:void 0:n.h[u+n.j];}function It(n,u,f){f=f===void 0?!0:f;var t=t===void 0?!1:t,c=Bt(n,u,t);return c==null&&(c=re),c===re?(c=At([]),Ot(n,u,c,t)):f&&Array.isArray(c)&&Qt(c)&2&&(c=c.slice(),Ot(n,u,c,t)),c;}function je(n){var u=It(n,3,!1);if(n.m||(n.m={}),!n.m[3]){for(var f=0;f<u.length;f++)u[f]=+u[f];n.m[3]=!0;}return u;}function Ke(n,u,f){var _n2;return n=Bt(n,u),(_n2=n)!=null?_n2:f;}function Fe(n,u,f){var _n3;return n=Bt(n,u),n=n==null?n:+n,(_n3=n)!=null?_n3:f===void 0?0:f;}function Ot(n,u,f,t){t!==void 0&&t||u>=n.l?(Ne(n),n.i[u]=f):n.h[u+n.j]=f;}function ke(n,u,f){if(f===-1)return null;n.g||(n.g={});var t=n.g[f];if(t)return t;var c=Bt(n,f,!1);return c==null?t:(u=new u(c),n.g[f]=u);}function mn(n,u,f){n.g||(n.g={});var t=n.g[f];if(!t){var c=It(n,f,!1);t=[];for(var a=Array.isArray(c)?!!(Qt(c)&2):!1,b=0;b<c.length;b++)t[b]=new u(c[b]),a&&vn(t[b].h);a&&(vn(t),Object.freeze(t)),n.g[f]=t;}return t;}function qe(n,u,f,t,c){var a=mn(n,t,u);f=f||new t(),n=It(n,u),c!=null?(a.splice(c,0,f),n.splice(c,0,Ue(f))):(a.push(f),n.push(Ue(f)));}Dt.prototype.toJSON=function(){var n=Ue(this);return ne(n,Ft);};function Ue(n){if(n.g)for(var u in n.g){var f=n.g[u];if(Array.isArray(f))for(var t=0;t<f.length;t++)f[t]&&Ue(f[t]);else f&&Ue(f);}return n.h;}Dt.prototype.toString=function(){return Ue(this).toString();};function Qe(n,u){if(n=n.o){Ie(u,u.g.end());for(var f=0;f<n.length;f++)Ie(u,n[f]);}}function tn(n){var u=n[0];switch(n.length){case 2:var f=n[1];return function(F,H,E){return u(F,H,E,f);};case 3:var t=n[1],c=n[2];return function(F,H,E){return u(F,H,E,t,c);};case 4:var a=n[1],b=n[2],I=n[3];return function(F,H,E){return u(F,H,E,a,b,I);};default:throw Error("unsupported number of parameters, expected [2-4], got "+n.length);}}function Ge(n,u,f){for(;Ae(u)&&u.h!=4;){var t=u.i,c=f[t];if(c){if(Array.isArray(c)&&(c=f[t]=tn(c)),!c(u,n,t)){t=u,c=n;var a=t.l;ve(t),Sn(t,c,a);}}else t=u,c=n,a=t.l,ve(t),Sn(t,c,a);}return n;}function Ee(n,u){var f=new he();if(u(n,f),n=f.i+f.g.length(),n===0)f=new Uint8Array(0);else{n=new Uint8Array(n);for(var t=f.h,c=t.length,a=u=0;a<c;a++){var b=t[a];b.length!==0&&(n.set(b,u),u+=b.length);}t=f.g,c=t.h,c!==0&&(n.set(t.g.subarray(0,c),u),t.h=0),f.h=[n],f=n;}return f;}function kn(n,u,f){if(fn.length){var t=fn.pop();n&&(Ze(t.g,n),t.i=-1,t.h=-1),n=t;}else n=new Je(n);try{return f(new u(),n);}finally{u=n.g,u.h=null,u.m=0,u.i=0,u.g=0,u.l=!1,u.u=!1,n.i=-1,n.h=-1,n.j=!1,100>fn.length&&fn.push(n);}}function Me(n,u,f){if(u=Bt(u,f),u!=null){zt(n.g,8*f+5),n=n.g;var t=u;t=(f=0>t?1:0)?-t:t,t===0?0<1/t?Pt=de=0:(de=0,Pt=2147483648):isNaN(t)?(de=0,Pt=2147483647):34028234663852886e22<t?(de=0,Pt=(f<<31|2139095040)>>>0):11754943508222875e-54>t?(t=Math.round(t/Math.pow(2,-149)),de=0,Pt=(f<<31|t)>>>0):(u=Math.floor(Math.log(t)/Math.LN2),t*=Math.pow(2,-u),t=Math.round(8388608*t),16777216<=t&&++u,de=0,Pt=(f<<31|u+127<<23|t&8388607)>>>0),f=Pt,me(n,f>>>0&255),me(n,f>>>8&255),me(n,f>>>16&255),me(n,f>>>24&255);}}function Ve(n,u,f){return n.h!==5?!1:(Ot(u,f,n.g.o()),!0);}function sn(n,u,f){return n.h!==5&&n.h!==2?!1:(u=It(u,f),n.h==2?an(n,Jt.prototype.o,u):u.push(n.g.o()),!0);}function pn(n,u,f){return n.h!==0?!1:(Ot(u,f,_t(n.g)),!0);}function Le(n,u,f){return n.h!==0?!1:(Ot(u,f,n.g.j()),!0);}function Fn(n,u,f){if(n.h!==2)return!1;var t=n.g.j();n=n.g;var c=n.g;n.g+=t,ae(n),n=n.h;var a;if(rn)(a=Ln)||(a=Ln=new TextDecoder("utf-8",{fatal:!1})),a=a.decode(n.subarray(c,c+t));else{t=c+t;for(var b=[],I=null,F,H,E;c<t;)F=n[c++],128>F?b.push(F):224>F?c>=t?b.push(65533):(H=n[c++],194>F||(H&192)!==128?(c--,b.push(65533)):b.push((F&31)<<6|H&63)):240>F?c>=t-1?b.push(65533):(H=n[c++],(H&192)!==128||F===224&&160>H||F===237&&160<=H||((a=n[c++])&192)!==128?(c--,b.push(65533)):b.push((F&15)<<12|(H&63)<<6|a&63)):244>=F?c>=t-2?b.push(65533):(H=n[c++],(H&192)!==128||(F<<28)+(H-144)>>30||((a=n[c++])&192)!==128||((E=n[c++])&192)!==128?(c--,b.push(65533)):(F=(F&7)<<18|(H&63)<<12|(a&63)<<6|E&63,F-=65536,b.push((F>>10&1023)+55296,(F&1023)+56320))):b.push(65533),8192<=b.length&&(I=Vn(I,b),b.length=0);a=Vn(I,b);}return Ot(u,f,a),!0;}function ze(n,u,f,t,c){if(n.h!==2)return!1;n=$e(n,new t(),c);var a=a===void 0?!1:a;return u.g||(u.g={}),t=n&&Ue(n),u.g[f]=n,Ot(u,f,t,a),!0;}function ln(n,u,f,t,c){return n.h!==2?!1:(n=$e(n,new t(),c),qe(u,f,n,t,void 0),!0);}function Gn(n,u,f){return n.h!==0&&n.h!==2?!1:(u=It(u,f),n.h==2?an(n,Jt.prototype.j,u):u.push(n.g.j()),!0);}function Hn(n,u,f){return n.h!==0?!1:(Ot(u,f,_t(n.g)),!0);}function Oe(n){Dt.call(this,n,-1,Bn);}var Xn;ht(Oe,Dt),Oe.prototype.getRows=function(){return Bt(this,1);},Oe.prototype.getCols=function(){return Bt(this,2);},Oe.prototype.getPackedDataList=function(){return je(this);},Oe.prototype.getLayout=function(){return Ke(this,4,0);};function An(n,u){return Ge(n,u,Xn||(Xn={1:Le,2:Le,3:sn,4:Hn}));}var Bn=[3];function Wn(n){Dt.call(this,n);}var xn;ht(Wn,Dt);function p(n,u){var f=Bt(n,1);if(f!=null&&f!=null){zt(u.g,8);var t=u.g;if(0<=f)zt(t,f);else{for(var c=0;9>c;c++)me(t,f&127|128),f>>=7;me(t,1);}}Me(u,n,2),t=Bt(n,3),t!=null&&fe(u,3,wn(t)),t=Bt(n,4),t!=null&&fe(u,4,wn(t)),Qe(n,u);}function W(n,u){return Ge(n,u,xn||(xn={1:Le,2:Ve,3:Fn,4:Fn}));}function V(n){Dt.call(this,n,-1,rt);}var U;ht(V,Dt),V.prototype.addClassification=function(n,u){return qe(this,1,n,Wn,u),this;};function O(n,u){return Ge(n,u,U||(U={1:[ln,Wn,W]}));}var rt=[1];function K(n){Dt.call(this,n);}var nt;ht(K,Dt);function dt(n,u){Me(u,n,1),Me(u,n,2),Me(u,n,3),Me(u,n,4),Me(u,n,5),Qe(n,u);}function vt(n,u){return Ge(n,u,nt||(nt={1:Ve,2:Ve,3:Ve,4:Ve,5:Ve}));}function Ct(n){Dt.call(this,n,-1,wt);}var Tt;ht(Ct,Dt);function jt(n,u){return Ge(n,u,Tt||(Tt={1:[ln,K,vt]}));}var wt=[1];function Vt(n){Dt.call(this,n);}var Ht;ht(Vt,Dt);function Et(n,u){Me(u,n,1),Me(u,n,2),Me(u,n,3),Me(u,n,4),Me(u,n,5);var f=Bt(n,6);if(f!=null&&f!=null){zt(u.g,48);var t=u.g,c=f;f=0>c,c=Math.abs(c);var a=c>>>0;for(c=Math.floor((c-a)/4294967296),c>>>=0,f&&(c=~c>>>0,a=(~a>>>0)+1,4294967295<a&&(a=0,c++,4294967295<c&&(c=0))),Pt=a,de=c,f=Pt,a=de;0<a||127<f;)me(t,f&127|128),f=(f>>>7|a<<25)>>>0,a>>>=7;me(t,f);}Qe(n,u);}function te(n,u){return Ge(n,u,Ht||(Ht={1:Ve,2:Ve,3:Ve,4:Ve,5:Ve,6:pn}));}function ie(n){Dt.call(this,n,-1,h);}var le;ht(ie,Dt),ie.prototype.getVertexType=function(){return Ke(this,1,0);},ie.prototype.getPrimitiveType=function(){return Ke(this,2,0);},ie.prototype.getVertexBufferList=function(){return je(this);},ie.prototype.getIndexBufferList=function(){return It(this,4);};function Re(n,u){return Ge(n,u,le||(le={1:Hn,2:Hn,3:sn,4:Gn}));}var h=[3,4];function y(n){Dt.call(this,n);}var G;ht(y,Dt),y.prototype.getMesh=function(){return ke(this,ie,1);},y.prototype.getPoseTransformMatrix=function(){return ke(this,Oe,2);};function C(n,u){return Ge(n,u,G||(G={1:[ze,ie,Re],2:[ze,Oe,An]}));}var z=[[61,146],[146,91],[91,181],[181,84],[84,17],[17,314],[314,405],[405,321],[321,375],[375,291],[61,185],[185,40],[40,39],[39,37],[37,0],[0,267],[267,269],[269,270],[270,409],[409,291],[78,95],[95,88],[88,178],[178,87],[87,14],[14,317],[317,402],[402,318],[318,324],[324,308],[78,191],[191,80],[80,81],[81,82],[82,13],[13,312],[312,311],[311,310],[310,415],[415,308]],P=[[263,249],[249,390],[390,373],[373,374],[374,380],[380,381],[381,382],[382,362],[263,466],[466,388],[388,387],[387,386],[386,385],[385,384],[384,398],[398,362]],A=[[276,283],[283,282],[282,295],[295,285],[300,293],[293,334],[334,296],[296,336]],q=[[33,7],[7,163],[163,144],[144,145],[145,153],[153,154],[154,155],[155,133],[33,246],[246,161],[161,160],[160,159],[159,158],[158,157],[157,173],[173,133]],ot=[[46,53],[53,52],[52,65],[65,55],[70,63],[63,105],[105,66],[66,107]],s=[[10,338],[338,297],[297,332],[332,284],[284,251],[251,389],[389,356],[356,454],[454,323],[323,361],[361,288],[288,397],[397,365],[365,379],[379,378],[378,400],[400,377],[377,152],[152,148],[148,176],[176,149],[149,150],[150,136],[136,172],[172,58],[58,132],[132,93],[93,234],[234,127],[127,162],[162,21],[21,54],[54,103],[103,67],[67,109],[109,10]],X=[].concat(k(z),k(P),k(A),k(q),k(ot),k(s));function R(n,u,f){if(f=n.createShader(f===0?n.VERTEX_SHADER:n.FRAGMENT_SHADER),n.shaderSource(f,u),n.compileShader(f),!n.getShaderParameter(f,n.COMPILE_STATUS))throw Error(`Could not compile WebGL shader.

`+n.getShaderInfoLog(f));return f;}function w(n){return mn(n,Wn,1).map(function(u){return{index:Ke(u,1,0),score:Fe(u,2),label:Bt(u,3)!=null?Ke(u,3,""):void 0,displayName:Bt(u,4)!=null?Ke(u,4,""):void 0};});}function N(n){return{x:Fe(n,1),y:Fe(n,2),z:Fe(n,3),visibility:Bt(n,4)!=null?Fe(n,4):void 0};}function B(n){return mn(kn(n,Ct,jt),K,1).map(N);}function M(n,u){this.h=n,this.g=u,this.l=0;}function et(n,u,f){return $(n,u),typeof n.g.canvas.transferToImageBitmap=="function"?Promise.resolve(n.g.canvas.transferToImageBitmap()):f?Promise.resolve(n.g.canvas):typeof createImageBitmap=="function"?createImageBitmap(n.g.canvas):(n.i===void 0&&(n.i=document.createElement("canvas")),new Promise(function(t){n.i.height=n.g.canvas.height,n.i.width=n.g.canvas.width,n.i.getContext("2d",{}).drawImage(n.g.canvas,0,0,n.g.canvas.width,n.g.canvas.height),t(n.i);}));}function $(n,u){var f=n.g;if(n.m===void 0){var t=R(f,`
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`,0),c=R(f,`
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`,1),a=f.createProgram();if(f.attachShader(a,t),f.attachShader(a,c),f.linkProgram(a),!f.getProgramParameter(a,f.LINK_STATUS))throw Error(`Could not compile WebGL program.

`+f.getProgramInfoLog(a));t=n.m=a,f.useProgram(t),c=f.getUniformLocation(t,"sampler0"),n.j={I:f.getAttribLocation(t,"aVertex"),H:f.getAttribLocation(t,"aTex"),ca:c},n.s=f.createBuffer(),f.bindBuffer(f.ARRAY_BUFFER,n.s),f.enableVertexAttribArray(n.j.I),f.vertexAttribPointer(n.j.I,2,f.FLOAT,!1,0,0),f.bufferData(f.ARRAY_BUFFER,new Float32Array([-1,-1,-1,1,1,1,1,-1]),f.STATIC_DRAW),f.bindBuffer(f.ARRAY_BUFFER,null),n.o=f.createBuffer(),f.bindBuffer(f.ARRAY_BUFFER,n.o),f.enableVertexAttribArray(n.j.H),f.vertexAttribPointer(n.j.H,2,f.FLOAT,!1,0,0),f.bufferData(f.ARRAY_BUFFER,new Float32Array([0,1,0,0,1,0,1,1]),f.STATIC_DRAW),f.bindBuffer(f.ARRAY_BUFFER,null),f.uniform1i(c,0);}t=n.j,f.useProgram(n.m),f.canvas.width=u.width,f.canvas.height=u.height,f.viewport(0,0,u.width,u.height),f.activeTexture(f.TEXTURE0),n.h.bindTexture2d(u.glName),f.enableVertexAttribArray(t.I),f.bindBuffer(f.ARRAY_BUFFER,n.s),f.vertexAttribPointer(t.I,2,f.FLOAT,!1,0,0),f.enableVertexAttribArray(t.H),f.bindBuffer(f.ARRAY_BUFFER,n.o),f.vertexAttribPointer(t.H,2,f.FLOAT,!1,0,0),f.bindFramebuffer(f.DRAW_FRAMEBUFFER?f.DRAW_FRAMEBUFFER:f.FRAMEBUFFER,null),f.clearColor(0,0,0,0),f.clear(f.COLOR_BUFFER_BIT),f.colorMask(!0,!0,!0,!0),f.drawArrays(f.TRIANGLE_FAN,0,4),f.disableVertexAttribArray(t.I),f.disableVertexAttribArray(t.H),f.bindBuffer(f.ARRAY_BUFFER,null),n.h.bindTexture2d(0);}function ft(n){this.g=n;}var gt=new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,10,9,1,7,0,65,0,253,15,26,11]);function Nt(n,u){return u+n;}function Gt(n,u){window[n]=u;}function lt(n){var u=document.createElement("script");return u.setAttribute("src",n),u.setAttribute("crossorigin","anonymous"),new Promise(function(f){u.addEventListener("load",function(){f();},!1),u.addEventListener("error",function(){f();},!1),document.body.appendChild(u);});}function Zt(){return yt(function(n){switch(n.g){case 1:return n.m=2,D(n,WebAssembly.instantiate(gt),4);case 4:n.g=3,n.m=0;break;case 2:return n.m=0,n.j=null,n.return(!1);case 3:return n.return(!0);}});}function Xt(n){if(this.g=n,this.listeners={},this.j={},this.F={},this.m={},this.s={},this.G=this.o=this.R=!0,this.C=Promise.resolve(),this.P="",this.B={},this.locateFile=n&&n.locateFile||Nt,typeof window=="object")var u=window.location.pathname.toString().substring(0,window.location.pathname.toString().lastIndexOf("/"))+"/";else if(typeof location<"u")u=location.pathname.toString().substring(0,location.pathname.toString().lastIndexOf("/"))+"/";else throw Error("solutions can only be loaded on a web page or in a web worker");if(this.S=u,n.options){u=T(Object.keys(n.options));for(var f=u.next();!f.done;f=u.next()){f=f.value;var t=n.options[f].default;t!==void 0&&(this.j[f]=typeof t=="function"?t():t);}}}r=Xt.prototype,r.close=function(){return this.i&&this.i.delete(),Promise.resolve();};function Rt(n){var u,f,t,c,a,b,I,F,H,E,j;return yt(function(_){switch(_.g){case 1:return n.R?(u=n.g.files===void 0?[]:typeof n.g.files=="function"?n.g.files(n.j):n.g.files,D(_,Zt(),2)):_.return();case 2:if(f=_.h,typeof window=="object")return Gt("createMediapipeSolutionsWasm",{locateFile:n.locateFile}),Gt("createMediapipeSolutionsPackedAssets",{locateFile:n.locateFile}),b=u.filter(function(Q){return Q.data!==void 0;}),I=u.filter(function(Q){return Q.data===void 0;}),F=Promise.all(b.map(function(Q){var it=Z(n,Q.url);if(Q.path!==void 0){var ct=Q.path;it=it.then(function(ut){return n.overrideFile(ct,ut),Promise.resolve(ut);});}return it;})),H=Promise.all(I.map(function(Q){return Q.simd===void 0||Q.simd&&f||!Q.simd&&!f?lt(n.locateFile(Q.url,n.S)):Promise.resolve();})).then(function(){var Q,it,ct;return yt(function(ut){if(ut.g==1)return Q=window.createMediapipeSolutionsWasm,it=window.createMediapipeSolutionsPackedAssets,ct=n,D(ut,Q(it),2);ct.h=ut.h,ut.g=0;});}),E=function(){return yt(function(Q){return n.g.graph&&n.g.graph.url?Q=D(Q,Z(n,n.g.graph.url),0):(Q.g=0,Q=void 0),Q;});}(),D(_,Promise.all([H,F,E]),7);if(typeof importScripts!="function")throw Error("solutions can only be loaded on a web page or in a web worker");return t=u.filter(function(Q){return Q.simd===void 0||Q.simd&&f||!Q.simd&&!f;}).map(function(Q){return n.locateFile(Q.url,n.S);}),importScripts.apply(null,k(t)),c=n,D(_,createMediapipeSolutionsWasm(Module),6);case 6:c.h=_.h,n.l=new OffscreenCanvas(1,1),n.h.canvas=n.l,a=n.h.GL.createContext(n.l,{antialias:!1,alpha:!1,aa:typeof WebGL2RenderingContext<"u"?2:1}),n.h.GL.makeContextCurrent(a),_.g=4;break;case 7:if(n.l=document.createElement("canvas"),j=n.l.getContext("webgl2",{}),!j&&(j=n.l.getContext("webgl",{}),!j))return alert("Failed to create WebGL canvas context when passing video frame."),_.return();n.D=j,n.h.canvas=n.l,n.h.createContext(n.l,!0,!0,{});case 4:n.i=new n.h.SolutionWasm(),n.R=!1,_.g=0;}});}function St(n){var u,f,t,c,a,b,I,F;return yt(function(H){if(H.g==1){if(n.g.graph&&n.g.graph.url&&n.P===n.g.graph.url)return H.return();if(n.o=!0,!n.g.graph||!n.g.graph.url){H.g=2;return;}return n.P=n.g.graph.url,D(H,Z(n,n.g.graph.url),3);}for(H.g!=2&&(u=H.h,n.i.loadGraph(u)),f=T(Object.keys(n.B)),t=f.next();!t.done;t=f.next())c=t.value,n.i.overrideFile(c,n.B[c]);if(n.B={},n.g.listeners)for(a=T(n.g.listeners),b=a.next();!b.done;b=a.next())I=b.value,J(n,I);F=n.j,n.j={},n.setOptions(F),H.g=0;});}r.reset=function(){var n=this;return yt(function(u){n.i&&(n.i.reset(),n.m={},n.s={}),u.g=0;});},r.setOptions=function(n,u){var f=this;if(u=u||this.g.options){for(var t=[],c=[],a={},b=T(Object.keys(n)),I=b.next();!I.done;a={K:a.K,L:a.L},I=b.next()){var F=I.value;F in this.j&&this.j[F]===n[F]||(this.j[F]=n[F],I=u[F],I!==void 0&&(I.onChange&&(a.K=I.onChange,a.L=n[F],t.push(/* @__PURE__ */function(H){return function(){var E;return yt(function(j){if(j.g==1)return D(j,H.K(H.L),2);E=j.h,E===!0&&(f.o=!0),j.g=0;});};}(a))),I.graphOptionXref&&(F={valueNumber:I.type===1?n[F]:0,valueBoolean:I.type===0?n[F]:!1,valueString:I.type===2?n[F]:""},I=Object.assign(Object.assign(Object.assign({},{calculatorName:"",calculatorIndex:0}),I.graphOptionXref),F),c.push(I))));}(t.length!==0||c.length!==0)&&(this.o=!0,this.A=(this.A===void 0?[]:this.A).concat(c),this.v=(this.v===void 0?[]:this.v).concat(t));}};function l(n){var u,f,t,c,a,b,I;return yt(function(F){switch(F.g){case 1:if(!n.o)return F.return();if(!n.v){F.g=2;break;}u=T(n.v),f=u.next();case 3:if(f.done){F.g=5;break;}return t=f.value,D(F,t(),4);case 4:f=u.next(),F.g=3;break;case 5:n.v=void 0;case 2:if(n.A){for(c=new n.h.GraphOptionChangeRequestList(),a=T(n.A),b=a.next();!b.done;b=a.next())I=b.value,c.push_back(I);n.i.changeOptions(c),c.delete(),n.A=void 0;}n.o=!1,F.g=0;}});}r.initialize=function(){var n=this;return yt(function(u){return u.g==1?D(u,Rt(n),2):u.g!=3?D(u,St(n),3):D(u,l(n),0);});};function Z(n,u){var f,t;return yt(function(c){return u in n.F?c.return(n.F[u]):(f=n.locateFile(u,""),t=fetch(f).then(function(a){return a.arrayBuffer();}),n.F[u]=t,c.return(t));});}r.overrideFile=function(n,u){this.i?this.i.overrideFile(n,u):this.B[n]=u;},r.clearOverriddenFiles=function(){this.B={},this.i&&this.i.clearOverriddenFiles();},r.send=function(n,u){var f=this,t,c,a,b,I,F,H,E,j;return yt(function(_){switch(_.g){case 1:return f.g.inputs?(t=1e3*(u!=null?u:performance.now()),D(_,f.C,2)):_.return();case 2:return D(_,f.initialize(),3);case 3:for(c=new f.h.PacketDataList(),a=T(Object.keys(n)),b=a.next();!b.done;b=a.next())if(I=b.value,F=f.g.inputs[I]){t:{var Q=n[I];switch(F.type){case"video":var it=f.m[F.stream];if(it||(it=new M(f.h,f.D),f.m[F.stream]=it),it.l===0&&(it.l=it.h.createTexture()),typeof HTMLVideoElement<"u"&&Q instanceof HTMLVideoElement)var ct=Q.videoWidth,ut=Q.videoHeight;else typeof HTMLImageElement<"u"&&Q instanceof HTMLImageElement?(ct=Q.naturalWidth,ut=Q.naturalHeight):(ct=Q.width,ut=Q.height);ut={glName:it.l,width:ct,height:ut},ct=it.g,ct.canvas.width=ut.width,ct.canvas.height=ut.height,ct.activeTexture(ct.TEXTURE0),it.h.bindTexture2d(it.l),ct.texImage2D(ct.TEXTURE_2D,0,ct.RGBA,ct.RGBA,ct.UNSIGNED_BYTE,Q),it.h.bindTexture2d(0),it=ut;break t;case"detections":for(it=f.m[F.stream],it||(it=new ft(f.h),f.m[F.stream]=it),it.data||(it.data=new it.g.DetectionListData()),it.data.reset(Q.length),ut=0;ut<Q.length;++ut){ct=Q[ut];var pt=it.data,mt=pt.setBoundingBox,kt=ut,$t=ct.T,qt=new Vt();if(Ot(qt,1,$t.X),Ot(qt,2,$t.Y),Ot(qt,3,$t.height),Ot(qt,4,$t.width),Ot(qt,5,$t.rotation),Ot(qt,6,$t.W),$t=Ee(qt,Et),mt.call(pt,kt,$t),ct.O)for(pt=0;pt<ct.O.length;++pt){qt=ct.O[pt];var Se=!!qt.visibility;mt=it.data,kt=mt.addNormalizedLandmark,$t=ut,qt=Object.assign(Object.assign({},qt),{visibility:Se?qt.visibility:0}),Se=new K(),Ot(Se,1,qt.x),Ot(Se,2,qt.y),Ot(Se,3,qt.z),qt.visibility&&Ot(Se,4,qt.visibility),qt=Ee(Se,dt),kt.call(mt,$t,qt);}if(ct.M)for(pt=0;pt<ct.M.length;++pt)mt=it.data,kt=mt.addClassification,$t=ut,qt=ct.M[pt],Se=new Wn(),Ot(Se,2,qt.score),qt.index&&Ot(Se,1,qt.index),qt.label&&Ot(Se,3,qt.label),qt.displayName&&Ot(Se,4,qt.displayName),qt=Ee(Se,p),kt.call(mt,$t,qt);}it=it.data;break t;default:it={};}}switch(H=it,E=F.stream,F.type){case"video":c.pushTexture2d(Object.assign(Object.assign({},H),{stream:E,timestamp:t}));break;case"detections":j=H,j.stream=E,j.timestamp=t,c.pushDetectionList(j);break;default:throw Error("Unknown input config type: '"+F.type+"'");}}return f.i.send(c),D(_,f.C,4);case 4:c.delete(),_.g=0;}});};function x(n,u,f){var t,c,a,b,I,F,H,E,j,_,Q,it,ct,ut;return yt(function(pt){switch(pt.g){case 1:if(!f)return pt.return(u);for(t={},c=0,a=T(Object.keys(f)),b=a.next();!b.done;b=a.next())I=b.value,F=f[I],typeof F!="string"&&F.type==="texture"&&u[F.stream]!==void 0&&++c;1<c&&(n.G=!1),H=T(Object.keys(f)),b=H.next();case 2:if(b.done){pt.g=4;break;}if(E=b.value,j=f[E],typeof j=="string")return ct=t,ut=E,D(pt,Y(n,E,u[j]),14);if(_=u[j.stream],j.type==="detection_list"){if(_){for(var mt=_.getRectList(),kt=_.getLandmarksList(),$t=_.getClassificationsList(),qt=[],Se=0;Se<mt.size();++Se){var dn=kn(mt.get(Se),Vt,te);dn={T:{X:Fe(dn,1),Y:Fe(dn,2),height:Fe(dn,3),width:Fe(dn,4),rotation:Fe(dn,5,0),W:Ke(dn,6,0)},O:B(kt.get(Se)),M:w(kn($t.get(Se),V,O))},qt.push(dn);}mt=qt;}else mt=[];t[E]=mt,pt.g=7;break;}if(j.type==="proto_list"){if(_){for(mt=Array(_.size()),kt=0;kt<_.size();kt++)mt[kt]=_.get(kt);_.delete();}else mt=[];t[E]=mt,pt.g=7;break;}if(_===void 0){pt.g=3;break;}if(j.type==="float_list"){t[E]=_,pt.g=7;break;}if(j.type==="proto"){t[E]=_,pt.g=7;break;}if(j.type!=="texture")throw Error("Unknown output config type: '"+j.type+"'");return Q=n.s[E],Q||(Q=new M(n.h,n.D),n.s[E]=Q),D(pt,et(Q,_,n.G),13);case 13:it=pt.h,t[E]=it;case 7:j.transform&&t[E]&&(t[E]=j.transform(t[E])),pt.g=3;break;case 14:ct[ut]=pt.h;case 3:b=H.next(),pt.g=2;break;case 4:return pt.return(t);}});}function Y(n,u,f){var t;return yt(function(c){return typeof f=="number"||f instanceof Uint8Array||f instanceof n.h.Uint8BlobList?c.return(f):f instanceof n.h.Texture2dDataOut?(t=n.s[u],t||(t=new M(n.h,n.D),n.s[u]=t),c.return(et(t,f,n.G))):c.return(void 0);});}function J(n,u){for(var f=u.name||"$",t=[].concat(k(u.wants)),c=new n.h.StringList(),a=T(u.wants),b=a.next();!b.done;b=a.next())c.push_back(b.value);a=n.h.PacketListener.implement({onResults:function onResults(I){for(var F={},H=0;H<u.wants.length;++H)F[t[H]]=I.get(H);var E=n.listeners[f];E&&(n.C=x(n,F,u.outs).then(function(j){j=E(j);for(var _=0;_<u.wants.length;++_){var Q=F[t[_]];typeof Q=="object"&&Q.hasOwnProperty&&Q.hasOwnProperty("delete")&&Q.delete();}j&&(n.C=j);}));}}),n.i.attachMultiListener(c,a),c.delete();}r.onResults=function(n,u){this.listeners[u||"$"]=n;},Lt("Solution",Xt),Lt("OptionType",{BOOL:0,NUMBER:1,Z:2,0:"BOOL",1:"NUMBER",2:"STRING"});function o(n){return n.map(d);}function d(n){n=kn(n,y,C);var u=n.getMesh();if(!u)return n;var f=new Float32Array(u.getVertexBufferList());u.getVertexBufferList=function(){return f;};var t=new Uint32Array(u.getIndexBufferList());return u.getIndexBufferList=function(){return t;},n;}function g(n){var u=this;n=n||{},this.g=new Xt({locateFile:n.locateFile,files:[{url:"holistic_solution_packed_assets_loader.js"},{simd:!1,url:"holistic_solution_wasm_bin.js"},{simd:!0,url:"holistic_solution_simd_wasm_bin.js"}],graph:{url:"holistic.binarypb"},inputs:{image:{type:"video",stream:"input_frames_gpu"}},listeners:[{wants:"left_hand_landmarks right_hand_landmarks face_landmarks pose_landmarks world_landmarks segmentation_mask image_transformed multi_face_geometry".split(" "),outs:{image:{type:"texture",stream:"image_transformed"},leftHandLandmarks:{type:"proto",stream:"left_hand_landmarks",transform:B},rightHandLandmarks:{type:"proto",stream:"right_hand_landmarks",transform:B},faceLandmarks:{type:"proto",stream:"face_landmarks",transform:B},poseLandmarks:{type:"proto",stream:"pose_landmarks",transform:B},ea:{type:"proto",stream:"world_landmarks",transform:B},segmentationMask:{type:"texture",stream:"segmentation_mask"},multiFaceGeometry:{type:"proto_list",stream:"multi_face_geometry",transform:o}}}],options:{useCpuInference:{type:0,graphOptionXref:{calculatorType:"InferenceCalculator",fieldName:"use_cpu_inference"},default:"iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document},enableFaceGeometry:{type:0,graphOptionXref:{calculatorName:"EnableFaceGeometryConstant",calculatorType:"ConstantSidePacketCalculator",fieldName:"bool_value"}},selfieMode:{type:0,graphOptionXref:{calculatorType:"GlScalerCalculator",calculatorIndex:1,fieldName:"flip_horizontal"}},modelComplexity:{type:1,default:1,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorModelComplexity",fieldName:"int_value"},onChange:function onChange(f){var t,c,a,b;return yt(function(I){if(I.g==1){switch(t="",f){case 1:t="pose_landmark_full.tflite";break;case 2:t="pose_landmark_heavy.tflite";break;default:t="pose_landmark_lite.tflite";}return c="third_party/mediapipe/modules/pose_landmark/"+t,a=u.g.locateFile(t,""),D(I,fetch(a),3);}return I.g!=2?D(I,I.h.arrayBuffer(),2):(b=I.h,u.g.overrideFile(c,b),D(I,u.g.reset(),0));});}},smoothLandmarks:{type:0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorSmoothLandmarks",fieldName:"bool_value"}},enableSegmentation:{type:0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorEnableSegmentation",fieldName:"bool_value"}},smoothSegmentation:{type:0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorSmoothSegmentation",fieldName:"bool_value"}},refineFaceLandmarks:{type:0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorRefineFaceLandmarks",fieldName:"bool_value"}},minDetectionConfidence:{type:1,graphOptionXref:{calculatorType:"TensorsToDetectionsCalculator",calculatorName:"holisticlandmarkgpu__poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",fieldName:"min_score_thresh"}},minTrackingConfidence:{type:1,graphOptionXref:{calculatorType:"ThresholdingCalculator",calculatorName:"holisticlandmarkgpu__poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator",fieldName:"threshold"}},cameraNear:{type:1,graphOptionXref:{calculatorType:"FaceGeometryEnvGeneratorCalculator",fieldName:"near"}},cameraFar:{type:1,graphOptionXref:{calculatorType:"FaceGeometryEnvGeneratorCalculator",fieldName:"far"}},cameraVerticalFovDegrees:{type:1,graphOptionXref:{calculatorType:"FaceGeometryEnvGeneratorCalculator",fieldName:"vertical_fov_degrees"}}}});}r=g.prototype,r.close=function(){return this.g.close(),Promise.resolve();},r.onResults=function(n){this.g.onResults(n);},r.initialize=function(){var n=this;return yt(function(u){return D(u,n.g.initialize(),0);});},r.reset=function(){this.g.reset();},r.send=function(n){var u=this;return yt(function(f){return D(f,u.g.send(n),0);});},r.setOptions=function(n){this.g.setOptions(n);},Lt("Holistic",g),Lt("FACE_GEOMETRY",{Layout:{COLUMN_MAJOR:0,ROW_MAJOR:1,0:"COLUMN_MAJOR",1:"ROW_MAJOR"},PrimitiveType:{TRIANGLE:0,0:"TRIANGLE"},VertexType:{VERTEX_PT:0,0:"VERTEX_PT"},DEFAULT_CAMERA_PARAMS:{verticalFovDegrees:63,near:1,far:1e4}}),Lt("FACEMESH_LIPS",z),Lt("FACEMESH_LEFT_EYE",P),Lt("FACEMESH_LEFT_EYEBROW",A),Lt("FACEMESH_LEFT_IRIS",[[474,475],[475,476],[476,477],[477,474]]),Lt("FACEMESH_RIGHT_EYE",q),Lt("FACEMESH_RIGHT_EYEBROW",ot),Lt("FACEMESH_RIGHT_IRIS",[[469,470],[470,471],[471,472],[472,469]]),Lt("FACEMESH_FACE_OVAL",s),Lt("FACEMESH_CONTOURS",X),Lt("FACEMESH_TESSELATION",[[127,34],[34,139],[139,127],[11,0],[0,37],[37,11],[232,231],[231,120],[120,232],[72,37],[37,39],[39,72],[128,121],[121,47],[47,128],[232,121],[121,128],[128,232],[104,69],[69,67],[67,104],[175,171],[171,148],[148,175],[118,50],[50,101],[101,118],[73,39],[39,40],[40,73],[9,151],[151,108],[108,9],[48,115],[115,131],[131,48],[194,204],[204,211],[211,194],[74,40],[40,185],[185,74],[80,42],[42,183],[183,80],[40,92],[92,186],[186,40],[230,229],[229,118],[118,230],[202,212],[212,214],[214,202],[83,18],[18,17],[17,83],[76,61],[61,146],[146,76],[160,29],[29,30],[30,160],[56,157],[157,173],[173,56],[106,204],[204,194],[194,106],[135,214],[214,192],[192,135],[203,165],[165,98],[98,203],[21,71],[71,68],[68,21],[51,45],[45,4],[4,51],[144,24],[24,23],[23,144],[77,146],[146,91],[91,77],[205,50],[50,187],[187,205],[201,200],[200,18],[18,201],[91,106],[106,182],[182,91],[90,91],[91,181],[181,90],[85,84],[84,17],[17,85],[206,203],[203,36],[36,206],[148,171],[171,140],[140,148],[92,40],[40,39],[39,92],[193,189],[189,244],[244,193],[159,158],[158,28],[28,159],[247,246],[246,161],[161,247],[236,3],[3,196],[196,236],[54,68],[68,104],[104,54],[193,168],[168,8],[8,193],[117,228],[228,31],[31,117],[189,193],[193,55],[55,189],[98,97],[97,99],[99,98],[126,47],[47,100],[100,126],[166,79],[79,218],[218,166],[155,154],[154,26],[26,155],[209,49],[49,131],[131,209],[135,136],[136,150],[150,135],[47,126],[126,217],[217,47],[223,52],[52,53],[53,223],[45,51],[51,134],[134,45],[211,170],[170,140],[140,211],[67,69],[69,108],[108,67],[43,106],[106,91],[91,43],[230,119],[119,120],[120,230],[226,130],[130,247],[247,226],[63,53],[53,52],[52,63],[238,20],[20,242],[242,238],[46,70],[70,156],[156,46],[78,62],[62,96],[96,78],[46,53],[53,63],[63,46],[143,34],[34,227],[227,143],[123,117],[117,111],[111,123],[44,125],[125,19],[19,44],[236,134],[134,51],[51,236],[216,206],[206,205],[205,216],[154,153],[153,22],[22,154],[39,37],[37,167],[167,39],[200,201],[201,208],[208,200],[36,142],[142,100],[100,36],[57,212],[212,202],[202,57],[20,60],[60,99],[99,20],[28,158],[158,157],[157,28],[35,226],[226,113],[113,35],[160,159],[159,27],[27,160],[204,202],[202,210],[210,204],[113,225],[225,46],[46,113],[43,202],[202,204],[204,43],[62,76],[76,77],[77,62],[137,123],[123,116],[116,137],[41,38],[38,72],[72,41],[203,129],[129,142],[142,203],[64,98],[98,240],[240,64],[49,102],[102,64],[64,49],[41,73],[73,74],[74,41],[212,216],[216,207],[207,212],[42,74],[74,184],[184,42],[169,170],[170,211],[211,169],[170,149],[149,176],[176,170],[105,66],[66,69],[69,105],[122,6],[6,168],[168,122],[123,147],[147,187],[187,123],[96,77],[77,90],[90,96],[65,55],[55,107],[107,65],[89,90],[90,180],[180,89],[101,100],[100,120],[120,101],[63,105],[105,104],[104,63],[93,137],[137,227],[227,93],[15,86],[86,85],[85,15],[129,102],[102,49],[49,129],[14,87],[87,86],[86,14],[55,8],[8,9],[9,55],[100,47],[47,121],[121,100],[145,23],[23,22],[22,145],[88,89],[89,179],[179,88],[6,122],[122,196],[196,6],[88,95],[95,96],[96,88],[138,172],[172,136],[136,138],[215,58],[58,172],[172,215],[115,48],[48,219],[219,115],[42,80],[80,81],[81,42],[195,3],[3,51],[51,195],[43,146],[146,61],[61,43],[171,175],[175,199],[199,171],[81,82],[82,38],[38,81],[53,46],[46,225],[225,53],[144,163],[163,110],[110,144],[52,65],[65,66],[66,52],[229,228],[228,117],[117,229],[34,127],[127,234],[234,34],[107,108],[108,69],[69,107],[109,108],[108,151],[151,109],[48,64],[64,235],[235,48],[62,78],[78,191],[191,62],[129,209],[209,126],[126,129],[111,35],[35,143],[143,111],[117,123],[123,50],[50,117],[222,65],[65,52],[52,222],[19,125],[125,141],[141,19],[221,55],[55,65],[65,221],[3,195],[195,197],[197,3],[25,7],[7,33],[33,25],[220,237],[237,44],[44,220],[70,71],[71,139],[139,70],[122,193],[193,245],[245,122],[247,130],[130,33],[33,247],[71,21],[21,162],[162,71],[170,169],[169,150],[150,170],[188,174],[174,196],[196,188],[216,186],[186,92],[92,216],[2,97],[97,167],[167,2],[141,125],[125,241],[241,141],[164,167],[167,37],[37,164],[72,38],[38,12],[12,72],[38,82],[82,13],[13,38],[63,68],[68,71],[71,63],[226,35],[35,111],[111,226],[101,50],[50,205],[205,101],[206,92],[92,165],[165,206],[209,198],[198,217],[217,209],[165,167],[167,97],[97,165],[220,115],[115,218],[218,220],[133,112],[112,243],[243,133],[239,238],[238,241],[241,239],[214,135],[135,169],[169,214],[190,173],[173,133],[133,190],[171,208],[208,32],[32,171],[125,44],[44,237],[237,125],[86,87],[87,178],[178,86],[85,86],[86,179],[179,85],[84,85],[85,180],[180,84],[83,84],[84,181],[181,83],[201,83],[83,182],[182,201],[137,93],[93,132],[132,137],[76,62],[62,183],[183,76],[61,76],[76,184],[184,61],[57,61],[61,185],[185,57],[212,57],[57,186],[186,212],[214,207],[207,187],[187,214],[34,143],[143,156],[156,34],[79,239],[239,237],[237,79],[123,137],[137,177],[177,123],[44,1],[1,4],[4,44],[201,194],[194,32],[32,201],[64,102],[102,129],[129,64],[213,215],[215,138],[138,213],[59,166],[166,219],[219,59],[242,99],[99,97],[97,242],[2,94],[94,141],[141,2],[75,59],[59,235],[235,75],[24,110],[110,228],[228,24],[25,130],[130,226],[226,25],[23,24],[24,229],[229,23],[22,23],[23,230],[230,22],[26,22],[22,231],[231,26],[112,26],[26,232],[232,112],[189,190],[190,243],[243,189],[221,56],[56,190],[190,221],[28,56],[56,221],[221,28],[27,28],[28,222],[222,27],[29,27],[27,223],[223,29],[30,29],[29,224],[224,30],[247,30],[30,225],[225,247],[238,79],[79,20],[20,238],[166,59],[59,75],[75,166],[60,75],[75,240],[240,60],[147,177],[177,215],[215,147],[20,79],[79,166],[166,20],[187,147],[147,213],[213,187],[112,233],[233,244],[244,112],[233,128],[128,245],[245,233],[128,114],[114,188],[188,128],[114,217],[217,174],[174,114],[131,115],[115,220],[220,131],[217,198],[198,236],[236,217],[198,131],[131,134],[134,198],[177,132],[132,58],[58,177],[143,35],[35,124],[124,143],[110,163],[163,7],[7,110],[228,110],[110,25],[25,228],[356,389],[389,368],[368,356],[11,302],[302,267],[267,11],[452,350],[350,349],[349,452],[302,303],[303,269],[269,302],[357,343],[343,277],[277,357],[452,453],[453,357],[357,452],[333,332],[332,297],[297,333],[175,152],[152,377],[377,175],[347,348],[348,330],[330,347],[303,304],[304,270],[270,303],[9,336],[336,337],[337,9],[278,279],[279,360],[360,278],[418,262],[262,431],[431,418],[304,408],[408,409],[409,304],[310,415],[415,407],[407,310],[270,409],[409,410],[410,270],[450,348],[348,347],[347,450],[422,430],[430,434],[434,422],[313,314],[314,17],[17,313],[306,307],[307,375],[375,306],[387,388],[388,260],[260,387],[286,414],[414,398],[398,286],[335,406],[406,418],[418,335],[364,367],[367,416],[416,364],[423,358],[358,327],[327,423],[251,284],[284,298],[298,251],[281,5],[5,4],[4,281],[373,374],[374,253],[253,373],[307,320],[320,321],[321,307],[425,427],[427,411],[411,425],[421,313],[313,18],[18,421],[321,405],[405,406],[406,321],[320,404],[404,405],[405,320],[315,16],[16,17],[17,315],[426,425],[425,266],[266,426],[377,400],[400,369],[369,377],[322,391],[391,269],[269,322],[417,465],[465,464],[464,417],[386,257],[257,258],[258,386],[466,260],[260,388],[388,466],[456,399],[399,419],[419,456],[284,332],[332,333],[333,284],[417,285],[285,8],[8,417],[346,340],[340,261],[261,346],[413,441],[441,285],[285,413],[327,460],[460,328],[328,327],[355,371],[371,329],[329,355],[392,439],[439,438],[438,392],[382,341],[341,256],[256,382],[429,420],[420,360],[360,429],[364,394],[394,379],[379,364],[277,343],[343,437],[437,277],[443,444],[444,283],[283,443],[275,440],[440,363],[363,275],[431,262],[262,369],[369,431],[297,338],[338,337],[337,297],[273,375],[375,321],[321,273],[450,451],[451,349],[349,450],[446,342],[342,467],[467,446],[293,334],[334,282],[282,293],[458,461],[461,462],[462,458],[276,353],[353,383],[383,276],[308,324],[324,325],[325,308],[276,300],[300,293],[293,276],[372,345],[345,447],[447,372],[352,345],[345,340],[340,352],[274,1],[1,19],[19,274],[456,248],[248,281],[281,456],[436,427],[427,425],[425,436],[381,256],[256,252],[252,381],[269,391],[391,393],[393,269],[200,199],[199,428],[428,200],[266,330],[330,329],[329,266],[287,273],[273,422],[422,287],[250,462],[462,328],[328,250],[258,286],[286,384],[384,258],[265,353],[353,342],[342,265],[387,259],[259,257],[257,387],[424,431],[431,430],[430,424],[342,353],[353,276],[276,342],[273,335],[335,424],[424,273],[292,325],[325,307],[307,292],[366,447],[447,345],[345,366],[271,303],[303,302],[302,271],[423,266],[266,371],[371,423],[294,455],[455,460],[460,294],[279,278],[278,294],[294,279],[271,272],[272,304],[304,271],[432,434],[434,427],[427,432],[272,407],[407,408],[408,272],[394,430],[430,431],[431,394],[395,369],[369,400],[400,395],[334,333],[333,299],[299,334],[351,417],[417,168],[168,351],[352,280],[280,411],[411,352],[325,319],[319,320],[320,325],[295,296],[296,336],[336,295],[319,403],[403,404],[404,319],[330,348],[348,349],[349,330],[293,298],[298,333],[333,293],[323,454],[454,447],[447,323],[15,16],[16,315],[315,15],[358,429],[429,279],[279,358],[14,15],[15,316],[316,14],[285,336],[336,9],[9,285],[329,349],[349,350],[350,329],[374,380],[380,252],[252,374],[318,402],[402,403],[403,318],[6,197],[197,419],[419,6],[318,319],[319,325],[325,318],[367,364],[364,365],[365,367],[435,367],[367,397],[397,435],[344,438],[438,439],[439,344],[272,271],[271,311],[311,272],[195,5],[5,281],[281,195],[273,287],[287,291],[291,273],[396,428],[428,199],[199,396],[311,271],[271,268],[268,311],[283,444],[444,445],[445,283],[373,254],[254,339],[339,373],[282,334],[334,296],[296,282],[449,347],[347,346],[346,449],[264,447],[447,454],[454,264],[336,296],[296,299],[299,336],[338,10],[10,151],[151,338],[278,439],[439,455],[455,278],[292,407],[407,415],[415,292],[358,371],[371,355],[355,358],[340,345],[345,372],[372,340],[346,347],[347,280],[280,346],[442,443],[443,282],[282,442],[19,94],[94,370],[370,19],[441,442],[442,295],[295,441],[248,419],[419,197],[197,248],[263,255],[255,359],[359,263],[440,275],[275,274],[274,440],[300,383],[383,368],[368,300],[351,412],[412,465],[465,351],[263,467],[467,466],[466,263],[301,368],[368,389],[389,301],[395,378],[378,379],[379,395],[412,351],[351,419],[419,412],[436,426],[426,322],[322,436],[2,164],[164,393],[393,2],[370,462],[462,461],[461,370],[164,0],[0,267],[267,164],[302,11],[11,12],[12,302],[268,12],[12,13],[13,268],[293,300],[300,301],[301,293],[446,261],[261,340],[340,446],[330,266],[266,425],[425,330],[426,423],[423,391],[391,426],[429,355],[355,437],[437,429],[391,327],[327,326],[326,391],[440,457],[457,438],[438,440],[341,382],[382,362],[362,341],[459,457],[457,461],[461,459],[434,430],[430,394],[394,434],[414,463],[463,362],[362,414],[396,369],[369,262],[262,396],[354,461],[461,457],[457,354],[316,403],[403,402],[402,316],[315,404],[404,403],[403,315],[314,405],[405,404],[404,314],[313,406],[406,405],[405,313],[421,418],[418,406],[406,421],[366,401],[401,361],[361,366],[306,408],[408,407],[407,306],[291,409],[409,408],[408,291],[287,410],[410,409],[409,287],[432,436],[436,410],[410,432],[434,416],[416,411],[411,434],[264,368],[368,383],[383,264],[309,438],[438,457],[457,309],[352,376],[376,401],[401,352],[274,275],[275,4],[4,274],[421,428],[428,262],[262,421],[294,327],[327,358],[358,294],[433,416],[416,367],[367,433],[289,455],[455,439],[439,289],[462,370],[370,326],[326,462],[2,326],[326,370],[370,2],[305,460],[460,455],[455,305],[254,449],[449,448],[448,254],[255,261],[261,446],[446,255],[253,450],[450,449],[449,253],[252,451],[451,450],[450,252],[256,452],[452,451],[451,256],[341,453],[453,452],[452,341],[413,464],[464,463],[463,413],[441,413],[413,414],[414,441],[258,442],[442,441],[441,258],[257,443],[443,442],[442,257],[259,444],[444,443],[443,259],[260,445],[445,444],[444,260],[467,342],[342,445],[445,467],[459,458],[458,250],[250,459],[289,392],[392,290],[290,289],[290,328],[328,460],[460,290],[376,433],[433,435],[435,376],[250,290],[290,392],[392,250],[411,416],[416,433],[433,411],[341,463],[463,464],[464,341],[453,464],[464,465],[465,453],[357,465],[465,412],[412,357],[343,412],[412,399],[399,343],[360,363],[363,440],[440,360],[437,399],[399,456],[456,437],[420,456],[456,363],[363,420],[401,435],[435,288],[288,401],[372,383],[383,353],[353,372],[339,255],[255,249],[249,339],[448,261],[261,255],[255,448],[133,243],[243,190],[190,133],[133,155],[155,112],[112,133],[33,246],[246,247],[247,33],[33,130],[130,25],[25,33],[398,384],[384,286],[286,398],[362,398],[398,414],[414,362],[362,463],[463,341],[341,362],[263,359],[359,467],[467,263],[263,249],[249,255],[255,263],[466,467],[467,260],[260,466],[75,60],[60,166],[166,75],[238,239],[239,79],[79,238],[162,127],[127,139],[139,162],[72,11],[11,37],[37,72],[121,232],[232,120],[120,121],[73,72],[72,39],[39,73],[114,128],[128,47],[47,114],[233,232],[232,128],[128,233],[103,104],[104,67],[67,103],[152,175],[175,148],[148,152],[119,118],[118,101],[101,119],[74,73],[73,40],[40,74],[107,9],[9,108],[108,107],[49,48],[48,131],[131,49],[32,194],[194,211],[211,32],[184,74],[74,185],[185,184],[191,80],[80,183],[183,191],[185,40],[40,186],[186,185],[119,230],[230,118],[118,119],[210,202],[202,214],[214,210],[84,83],[83,17],[17,84],[77,76],[76,146],[146,77],[161,160],[160,30],[30,161],[190,56],[56,173],[173,190],[182,106],[106,194],[194,182],[138,135],[135,192],[192,138],[129,203],[203,98],[98,129],[54,21],[21,68],[68,54],[5,51],[51,4],[4,5],[145,144],[144,23],[23,145],[90,77],[77,91],[91,90],[207,205],[205,187],[187,207],[83,201],[201,18],[18,83],[181,91],[91,182],[182,181],[180,90],[90,181],[181,180],[16,85],[85,17],[17,16],[205,206],[206,36],[36,205],[176,148],[148,140],[140,176],[165,92],[92,39],[39,165],[245,193],[193,244],[244,245],[27,159],[159,28],[28,27],[30,247],[247,161],[161,30],[174,236],[236,196],[196,174],[103,54],[54,104],[104,103],[55,193],[193,8],[8,55],[111,117],[117,31],[31,111],[221,189],[189,55],[55,221],[240,98],[98,99],[99,240],[142,126],[126,100],[100,142],[219,166],[166,218],[218,219],[112,155],[155,26],[26,112],[198,209],[209,131],[131,198],[169,135],[135,150],[150,169],[114,47],[47,217],[217,114],[224,223],[223,53],[53,224],[220,45],[45,134],[134,220],[32,211],[211,140],[140,32],[109,67],[67,108],[108,109],[146,43],[43,91],[91,146],[231,230],[230,120],[120,231],[113,226],[226,247],[247,113],[105,63],[63,52],[52,105],[241,238],[238,242],[242,241],[124,46],[46,156],[156,124],[95,78],[78,96],[96,95],[70,46],[46,63],[63,70],[116,143],[143,227],[227,116],[116,123],[123,111],[111,116],[1,44],[44,19],[19,1],[3,236],[236,51],[51,3],[207,216],[216,205],[205,207],[26,154],[154,22],[22,26],[165,39],[39,167],[167,165],[199,200],[200,208],[208,199],[101,36],[36,100],[100,101],[43,57],[57,202],[202,43],[242,20],[20,99],[99,242],[56,28],[28,157],[157,56],[124,35],[35,113],[113,124],[29,160],[160,27],[27,29],[211,204],[204,210],[210,211],[124,113],[113,46],[46,124],[106,43],[43,204],[204,106],[96,62],[62,77],[77,96],[227,137],[137,116],[116,227],[73,41],[41,72],[72,73],[36,203],[203,142],[142,36],[235,64],[64,240],[240,235],[48,49],[49,64],[64,48],[42,41],[41,74],[74,42],[214,212],[212,207],[207,214],[183,42],[42,184],[184,183],[210,169],[169,211],[211,210],[140,170],[170,176],[176,140],[104,105],[105,69],[69,104],[193,122],[122,168],[168,193],[50,123],[123,187],[187,50],[89,96],[96,90],[90,89],[66,65],[65,107],[107,66],[179,89],[89,180],[180,179],[119,101],[101,120],[120,119],[68,63],[63,104],[104,68],[234,93],[93,227],[227,234],[16,15],[15,85],[85,16],[209,129],[129,49],[49,209],[15,14],[14,86],[86,15],[107,55],[55,9],[9,107],[120,100],[100,121],[121,120],[153,145],[145,22],[22,153],[178,88],[88,179],[179,178],[197,6],[6,196],[196,197],[89,88],[88,96],[96,89],[135,138],[138,136],[136,135],[138,215],[215,172],[172,138],[218,115],[115,219],[219,218],[41,42],[42,81],[81,41],[5,195],[195,51],[51,5],[57,43],[43,61],[61,57],[208,171],[171,199],[199,208],[41,81],[81,38],[38,41],[224,53],[53,225],[225,224],[24,144],[144,110],[110,24],[105,52],[52,66],[66,105],[118,229],[229,117],[117,118],[227,34],[34,234],[234,227],[66,107],[107,69],[69,66],[10,109],[109,151],[151,10],[219,48],[48,235],[235,219],[183,62],[62,191],[191,183],[142,129],[129,126],[126,142],[116,111],[111,143],[143,116],[118,117],[117,50],[50,118],[223,222],[222,52],[52,223],[94,19],[19,141],[141,94],[222,221],[221,65],[65,222],[196,3],[3,197],[197,196],[45,220],[220,44],[44,45],[156,70],[70,139],[139,156],[188,122],[122,245],[245,188],[139,71],[71,162],[162,139],[149,170],[170,150],[150,149],[122,188],[188,196],[196,122],[206,216],[216,92],[92,206],[164,2],[2,167],[167,164],[242,141],[141,241],[241,242],[0,164],[164,37],[37,0],[11,72],[72,12],[12,11],[12,38],[38,13],[13,12],[70,63],[63,71],[71,70],[31,226],[226,111],[111,31],[36,101],[101,205],[205,36],[203,206],[206,165],[165,203],[126,209],[209,217],[217,126],[98,165],[165,97],[97,98],[237,220],[220,218],[218,237],[237,239],[239,241],[241,237],[210,214],[214,169],[169,210],[140,171],[171,32],[32,140],[241,125],[125,237],[237,241],[179,86],[86,178],[178,179],[180,85],[85,179],[179,180],[181,84],[84,180],[180,181],[182,83],[83,181],[181,182],[194,201],[201,182],[182,194],[177,137],[137,132],[132,177],[184,76],[76,183],[183,184],[185,61],[61,184],[184,185],[186,57],[57,185],[185,186],[216,212],[212,186],[186,216],[192,214],[214,187],[187,192],[139,34],[34,156],[156,139],[218,79],[79,237],[237,218],[147,123],[123,177],[177,147],[45,44],[44,4],[4,45],[208,201],[201,32],[32,208],[98,64],[64,129],[129,98],[192,213],[213,138],[138,192],[235,59],[59,219],[219,235],[141,242],[242,97],[97,141],[97,2],[2,141],[141,97],[240,75],[75,235],[235,240],[229,24],[24,228],[228,229],[31,25],[25,226],[226,31],[230,23],[23,229],[229,230],[231,22],[22,230],[230,231],[232,26],[26,231],[231,232],[233,112],[112,232],[232,233],[244,189],[189,243],[243,244],[189,221],[221,190],[190,189],[222,28],[28,221],[221,222],[223,27],[27,222],[222,223],[224,29],[29,223],[223,224],[225,30],[30,224],[224,225],[113,247],[247,225],[225,113],[99,60],[60,240],[240,99],[213,147],[147,215],[215,213],[60,20],[20,166],[166,60],[192,187],[187,213],[213,192],[243,112],[112,244],[244,243],[244,233],[233,245],[245,244],[245,128],[128,188],[188,245],[188,114],[114,174],[174,188],[134,131],[131,220],[220,134],[174,217],[217,236],[236,174],[236,198],[198,134],[134,236],[215,177],[177,58],[58,215],[156,143],[143,124],[124,156],[25,110],[110,7],[7,25],[31,228],[228,25],[25,31],[264,356],[356,368],[368,264],[0,11],[11,267],[267,0],[451,452],[452,349],[349,451],[267,302],[302,269],[269,267],[350,357],[357,277],[277,350],[350,452],[452,357],[357,350],[299,333],[333,297],[297,299],[396,175],[175,377],[377,396],[280,347],[347,330],[330,280],[269,303],[303,270],[270,269],[151,9],[9,337],[337,151],[344,278],[278,360],[360,344],[424,418],[418,431],[431,424],[270,304],[304,409],[409,270],[272,310],[310,407],[407,272],[322,270],[270,410],[410,322],[449,450],[450,347],[347,449],[432,422],[422,434],[434,432],[18,313],[313,17],[17,18],[291,306],[306,375],[375,291],[259,387],[387,260],[260,259],[424,335],[335,418],[418,424],[434,364],[364,416],[416,434],[391,423],[423,327],[327,391],[301,251],[251,298],[298,301],[275,281],[281,4],[4,275],[254,373],[373,253],[253,254],[375,307],[307,321],[321,375],[280,425],[425,411],[411,280],[200,421],[421,18],[18,200],[335,321],[321,406],[406,335],[321,320],[320,405],[405,321],[314,315],[315,17],[17,314],[423,426],[426,266],[266,423],[396,377],[377,369],[369,396],[270,322],[322,269],[269,270],[413,417],[417,464],[464,413],[385,386],[386,258],[258,385],[248,456],[456,419],[419,248],[298,284],[284,333],[333,298],[168,417],[417,8],[8,168],[448,346],[346,261],[261,448],[417,413],[413,285],[285,417],[326,327],[327,328],[328,326],[277,355],[355,329],[329,277],[309,392],[392,438],[438,309],[381,382],[382,256],[256,381],[279,429],[429,360],[360,279],[365,364],[364,379],[379,365],[355,277],[277,437],[437,355],[282,443],[443,283],[283,282],[281,275],[275,363],[363,281],[395,431],[431,369],[369,395],[299,297],[297,337],[337,299],[335,273],[273,321],[321,335],[348,450],[450,349],[349,348],[359,446],[446,467],[467,359],[283,293],[293,282],[282,283],[250,458],[458,462],[462,250],[300,276],[276,383],[383,300],[292,308],[308,325],[325,292],[283,276],[276,293],[293,283],[264,372],[372,447],[447,264],[346,352],[352,340],[340,346],[354,274],[274,19],[19,354],[363,456],[456,281],[281,363],[426,436],[436,425],[425,426],[380,381],[381,252],[252,380],[267,269],[269,393],[393,267],[421,200],[200,428],[428,421],[371,266],[266,329],[329,371],[432,287],[287,422],[422,432],[290,250],[250,328],[328,290],[385,258],[258,384],[384,385],[446,265],[265,342],[342,446],[386,387],[387,257],[257,386],[422,424],[424,430],[430,422],[445,342],[342,276],[276,445],[422,273],[273,424],[424,422],[306,292],[292,307],[307,306],[352,366],[366,345],[345,352],[268,271],[271,302],[302,268],[358,423],[423,371],[371,358],[327,294],[294,460],[460,327],[331,279],[279,294],[294,331],[303,271],[271,304],[304,303],[436,432],[432,427],[427,436],[304,272],[272,408],[408,304],[395,394],[394,431],[431,395],[378,395],[395,400],[400,378],[296,334],[334,299],[299,296],[6,351],[351,168],[168,6],[376,352],[352,411],[411,376],[307,325],[325,320],[320,307],[285,295],[295,336],[336,285],[320,319],[319,404],[404,320],[329,330],[330,349],[349,329],[334,293],[293,333],[333,334],[366,323],[323,447],[447,366],[316,15],[15,315],[315,316],[331,358],[358,279],[279,331],[317,14],[14,316],[316,317],[8,285],[285,9],[9,8],[277,329],[329,350],[350,277],[253,374],[374,252],[252,253],[319,318],[318,403],[403,319],[351,6],[6,419],[419,351],[324,318],[318,325],[325,324],[397,367],[367,365],[365,397],[288,435],[435,397],[397,288],[278,344],[344,439],[439,278],[310,272],[272,311],[311,310],[248,195],[195,281],[281,248],[375,273],[273,291],[291,375],[175,396],[396,199],[199,175],[312,311],[311,268],[268,312],[276,283],[283,445],[445,276],[390,373],[373,339],[339,390],[295,282],[282,296],[296,295],[448,449],[449,346],[346,448],[356,264],[264,454],[454,356],[337,336],[336,299],[299,337],[337,338],[338,151],[151,337],[294,278],[278,455],[455,294],[308,292],[292,415],[415,308],[429,358],[358,355],[355,429],[265,340],[340,372],[372,265],[352,346],[346,280],[280,352],[295,442],[442,282],[282,295],[354,19],[19,370],[370,354],[285,441],[441,295],[295,285],[195,248],[248,197],[197,195],[457,440],[440,274],[274,457],[301,300],[300,368],[368,301],[417,351],[351,465],[465,417],[251,301],[301,389],[389,251],[394,395],[395,379],[379,394],[399,412],[412,419],[419,399],[410,436],[436,322],[322,410],[326,2],[2,393],[393,326],[354,370],[370,461],[461,354],[393,164],[164,267],[267,393],[268,302],[302,12],[12,268],[312,268],[268,13],[13,312],[298,293],[293,301],[301,298],[265,446],[446,340],[340,265],[280,330],[330,425],[425,280],[322,426],[426,391],[391,322],[420,429],[429,437],[437,420],[393,391],[391,326],[326,393],[344,440],[440,438],[438,344],[458,459],[459,461],[461,458],[364,434],[434,394],[394,364],[428,396],[396,262],[262,428],[274,354],[354,457],[457,274],[317,316],[316,402],[402,317],[316,315],[315,403],[403,316],[315,314],[314,404],[404,315],[314,313],[313,405],[405,314],[313,421],[421,406],[406,313],[323,366],[366,361],[361,323],[292,306],[306,407],[407,292],[306,291],[291,408],[408,306],[291,287],[287,409],[409,291],[287,432],[432,410],[410,287],[427,434],[434,411],[411,427],[372,264],[264,383],[383,372],[459,309],[309,457],[457,459],[366,352],[352,401],[401,366],[1,274],[274,4],[4,1],[418,421],[421,262],[262,418],[331,294],[294,358],[358,331],[435,433],[433,367],[367,435],[392,289],[289,439],[439,392],[328,462],[462,326],[326,328],[94,2],[2,370],[370,94],[289,305],[305,455],[455,289],[339,254],[254,448],[448,339],[359,255],[255,446],[446,359],[254,253],[253,449],[449,254],[253,252],[252,450],[450,253],[252,256],[256,451],[451,252],[256,341],[341,452],[452,256],[414,413],[413,463],[463,414],[286,441],[441,414],[414,286],[286,258],[258,441],[441,286],[258,257],[257,442],[442,258],[257,259],[259,443],[443,257],[259,260],[260,444],[444,259],[260,467],[467,445],[445,260],[309,459],[459,250],[250,309],[305,289],[289,290],[290,305],[305,290],[290,460],[460,305],[401,376],[376,435],[435,401],[309,250],[250,392],[392,309],[376,411],[411,433],[433,376],[453,341],[341,464],[464,453],[357,453],[453,465],[465,357],[343,357],[357,412],[412,343],[437,343],[343,399],[399,437],[344,360],[360,440],[440,344],[420,437],[437,456],[456,420],[360,420],[420,363],[363,360],[361,401],[401,288],[288,361],[265,372],[372,353],[353,265],[390,339],[339,249],[249,390],[339,448],[448,255],[255,339]]),Lt("HAND_CONNECTIONS",[[0,1],[1,2],[2,3],[3,4],[0,5],[5,6],[6,7],[7,8],[5,9],[9,10],[10,11],[11,12],[9,13],[13,14],[14,15],[15,16],[13,17],[0,17],[17,18],[18,19],[19,20]]),Lt("POSE_CONNECTIONS",[[0,1],[1,2],[2,3],[3,7],[0,4],[4,5],[5,6],[6,8],[9,10],[11,12],[11,13],[13,15],[15,17],[15,19],[15,21],[17,19],[12,14],[14,16],[16,18],[16,20],[16,22],[18,20],[11,23],[12,24],[23,24],[23,25],[24,26],[25,27],[26,28],[27,29],[28,30],[29,31],[30,32],[27,31],[28,32]]),Lt("POSE_LANDMARKS",{NOSE:0,LEFT_EYE_INNER:1,LEFT_EYE:2,LEFT_EYE_OUTER:3,RIGHT_EYE_INNER:4,RIGHT_EYE:5,RIGHT_EYE_OUTER:6,LEFT_EAR:7,RIGHT_EAR:8,LEFT_RIGHT:9,RIGHT_LEFT:10,LEFT_SHOULDER:11,RIGHT_SHOULDER:12,LEFT_ELBOW:13,RIGHT_ELBOW:14,LEFT_WRIST:15,RIGHT_WRIST:16,LEFT_PINKY:17,RIGHT_PINKY:18,LEFT_INDEX:19,RIGHT_INDEX:20,LEFT_THUMB:21,RIGHT_THUMB:22,LEFT_HIP:23,RIGHT_HIP:24,LEFT_KNEE:25,RIGHT_KNEE:26,LEFT_ANKLE:27,RIGHT_ANKLE:28,LEFT_HEEL:29,RIGHT_HEEL:30,LEFT_FOOT_INDEX:31,RIGHT_FOOT_INDEX:32}),Lt("POSE_LANDMARKS_LEFT",{LEFT_EYE_INNER:1,LEFT_EYE:2,LEFT_EYE_OUTER:3,LEFT_EAR:7,LEFT_RIGHT:9,LEFT_SHOULDER:11,LEFT_ELBOW:13,LEFT_WRIST:15,LEFT_PINKY:17,LEFT_INDEX:19,LEFT_THUMB:21,LEFT_HIP:23,LEFT_KNEE:25,LEFT_ANKLE:27,LEFT_HEEL:29,LEFT_FOOT_INDEX:31}),Lt("POSE_LANDMARKS_RIGHT",{RIGHT_EYE_INNER:4,RIGHT_EYE:5,RIGHT_EYE_OUTER:6,RIGHT_EAR:8,RIGHT_LEFT:10,RIGHT_SHOULDER:12,RIGHT_ELBOW:14,RIGHT_WRIST:16,RIGHT_PINKY:18,RIGHT_INDEX:20,RIGHT_THUMB:22,RIGHT_HIP:24,RIGHT_KNEE:26,RIGHT_ANKLE:28,RIGHT_HEEL:30,RIGHT_FOOT_INDEX:32}),Lt("POSE_LANDMARKS_NEUTRAL",{NOSE:0}),Lt("matrixDataToMatrix",function(n){for(var u=n.getCols(),f=n.getRows(),t=n.getPackedDataList(),c=[],a=0;a<f;a++)c.push(Array(u));for(a=0;a<f;a++)for(var b=0;b<u;b++){var I=n.getLayout()===1?a*u+b:b*f+a;c[a][b]=t[I];}return c;}),Lt("VERSION","0.5.1635989137");}).call(xi);const Ii={};(function(){var r;function e(o){var d=0;return function(){return d<o.length?{done:!1,value:o[d++]}:{done:!0};};}var i=typeof Object.defineProperties=="function"?Object.defineProperty:function(o,d,g){return o==Array.prototype||o==Object.prototype||(o[d]=g.value),o;};function m(o){o=[typeof globalThis=="object"&&globalThis,o,typeof window=="object"&&window,typeof self=="object"&&self,typeof (typeof window !== undefined ? window : global)=="object"&&(typeof window !== undefined ? window : global)];for(var d=0;d<o.length;++d){var g=o[d];if(g&&g.Math==Math)return g;}throw Error("Cannot find global object");}var v=m(this);function S(o,d){if(d)t:{var g=v;o=o.split(".");for(var n=0;n<o.length-1;n++){var u=o[n];if(!(u in g))break t;g=g[u];}o=o[o.length-1],n=g[o],d=d(n),d!=n&&d!=null&&i(g,o,{configurable:!0,writable:!0,value:d});}}S("Symbol",function(o){function d(f){if(this instanceof d)throw new TypeError("Symbol is not a constructor");return new g(n+(f||"")+"_"+u++,f);}function g(f,t){this.g=f,i(this,"description",{configurable:!0,writable:!0,value:t});}if(o)return o;g.prototype.toString=function(){return this.g;};var n="jscomp_symbol_"+(1e9*Math.random()>>>0)+"_",u=0;return d;}),S("Symbol.iterator",function(o){if(o)return o;o=Symbol("Symbol.iterator");for(var d="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),g=0;g<d.length;g++){var n=v[d[g]];typeof n=="function"&&typeof n.prototype[o]!="function"&&i(n.prototype,o,{configurable:!0,writable:!0,value:function value(){return L(e(this));}});}return o;});function L(o){return o={next:o},o[Symbol.iterator]=function(){return this;},o;}function T(o){var d=typeof Symbol<"u"&&Symbol.iterator&&o[Symbol.iterator];return d?d.call(o):{next:e(o)};}function k(o){if(!(o instanceof Array)){o=T(o);for(var d,g=[];!(d=o.next()).done;)g.push(d.value);o=g;}return o;}var tt=typeof Object.create=="function"?Object.create:function(o){function d(){}return d.prototype=o,new d();},st;if(typeof Object.setPrototypeOf=="function")st=Object.setPrototypeOf;else{var bt;t:{var xt={a:!0},Yt={};try{Yt.__proto__=xt,bt=Yt.a;break t;}catch(_unused7){}bt=!1;}st=bt?function(o,d){if(o.__proto__=d,o.__proto__!==d)throw new TypeError(o+" is not extensible");return o;}:null;}var at=st;function ht(o,d){if(o.prototype=tt(d.prototype),o.prototype.constructor=o,at)at(o,d);else for(var g in d)if(g!="prototype")if(Object.defineProperties){var n=Object.getOwnPropertyDescriptor(d,g);n&&Object.defineProperty(o,g,n);}else o[g]=d[g];o.na=d.prototype;}function Ut(){this.l=!1,this.i=null,this.h=void 0,this.g=1,this.u=this.o=0,this.j=null;}function Mt(o){if(o.l)throw new TypeError("Generator is already running");o.l=!0;}Ut.prototype.s=function(o){this.h=o;};function oe(o,d){o.j={da:d,ea:!0},o.g=o.o||o.u;}Ut.prototype.return=function(o){this.j={return:o},this.g=this.u;};function D(o,d,g){return o.g=g,{value:d};}function hn(o){this.g=new Ut(),this.h=o;}function bn(o,d){Mt(o.g);var g=o.g.i;return g?ge(o,"return"in g?g.return:function(n){return{value:n,done:!0};},d,o.g.return):(o.g.return(d),Kt(o));}function ge(o,d,g,n){try{var u=d.call(o.g.i,g);if(!(u instanceof Object))throw new TypeError("Iterator result "+u+" is not an object");if(!u.done)return o.g.l=!1,u;var f=u.value;}catch(t){return o.g.i=null,oe(o.g,t),Kt(o);}return o.g.i=null,n.call(o.g,f),Kt(o);}function Kt(o){for(;o.g.g;)try{var d=o.h(o.g);if(d)return o.g.l=!1,{value:d.value,done:!1};}catch(g){o.g.h=void 0,oe(o.g,g);}if(o.g.l=!1,o.g.j){if(d=o.g.j,o.g.j=null,d.ea)throw d.da;return{value:d.return,done:!0};}return{value:void 0,done:!0};}function jn(o){this.next=function(d){return Mt(o.g),o.g.i?d=ge(o,o.g.i.next,d,o.g.s):(o.g.s(d),d=Kt(o)),d;},this.throw=function(d){return Mt(o.g),o.g.i?d=ge(o,o.g.i.throw,d,o.g.s):(oe(o.g,d),d=Kt(o)),d;},this.return=function(d){return bn(o,d);},this[Symbol.iterator]=function(){return this;};}function ue(o){function d(n){return o.next(n);}function g(n){return o.throw(n);}return new Promise(function(n,u){function f(t){t.done?n(t.value):Promise.resolve(t.value).then(d,g).then(f,u);}f(o.next());});}function yt(o){return ue(new jn(new hn(o)));}S("Promise",function(o){function d(t){this.h=0,this.i=void 0,this.g=[],this.s=!1;var c=this.j();try{t(c.resolve,c.reject);}catch(a){c.reject(a);}}function g(){this.g=null;}function n(t){return t instanceof d?t:new d(function(c){c(t);});}if(o)return o;g.prototype.h=function(t){if(this.g==null){this.g=[];var c=this;this.i(function(){c.l();});}this.g.push(t);};var u=v.setTimeout;g.prototype.i=function(t){u(t,0);},g.prototype.l=function(){for(;this.g&&this.g.length;){var t=this.g;this.g=[];for(var c=0;c<t.length;++c){var a=t[c];t[c]=null;try{a();}catch(b){this.j(b);}}}this.g=null;},g.prototype.j=function(t){this.i(function(){throw t;});},d.prototype.j=function(){function t(b){return function(I){a||(a=!0,b.call(c,I));};}var c=this,a=!1;return{resolve:t(this.D),reject:t(this.l)};},d.prototype.D=function(t){if(t===this)this.l(new TypeError("A Promise cannot resolve to itself"));else if(t instanceof d)this.H(t);else{t:switch(typeof t){case"object":var c=t!=null;break t;case"function":c=!0;break t;default:c=!1;}c?this.A(t):this.o(t);}},d.prototype.A=function(t){var c=void 0;try{c=t.then;}catch(a){this.l(a);return;}typeof c=="function"?this.I(c,t):this.o(t);},d.prototype.l=function(t){this.u(2,t);},d.prototype.o=function(t){this.u(1,t);},d.prototype.u=function(t,c){if(this.h!=0)throw Error("Cannot settle("+t+", "+c+"): Promise already settled in state"+this.h);this.h=t,this.i=c,this.h===2&&this.G(),this.B();},d.prototype.G=function(){var t=this;u(function(){if(t.C()){var c=v.console;typeof c<"u"&&c.error(t.i);}},1);},d.prototype.C=function(){if(this.s)return!1;var t=v.CustomEvent,c=v.Event,a=v.dispatchEvent;return typeof a>"u"?!0:(typeof t=="function"?t=new t("unhandledrejection",{cancelable:!0}):typeof c=="function"?t=new c("unhandledrejection",{cancelable:!0}):(t=v.document.createEvent("CustomEvent"),t.initCustomEvent("unhandledrejection",!1,!0,t)),t.promise=this,t.reason=this.i,a(t));},d.prototype.B=function(){if(this.g!=null){for(var t=0;t<this.g.length;++t)f.h(this.g[t]);this.g=null;}};var f=new g();return d.prototype.H=function(t){var c=this.j();t.M(c.resolve,c.reject);},d.prototype.I=function(t,c){var a=this.j();try{t.call(c,a.resolve,a.reject);}catch(b){a.reject(b);}},d.prototype.then=function(t,c){function a(H,E){return typeof H=="function"?function(j){try{b(H(j));}catch(_){I(_);}}:E;}var b,I,F=new d(function(H,E){b=H,I=E;});return this.M(a(t,b),a(c,I)),F;},d.prototype.catch=function(t){return this.then(void 0,t);},d.prototype.M=function(t,c){function a(){switch(b.h){case 1:t(b.i);break;case 2:c(b.i);break;default:throw Error("Unexpected state: "+b.h);}}var b=this;this.g==null?f.h(a):this.g.push(a),this.s=!0;},d.resolve=n,d.reject=function(t){return new d(function(c,a){a(t);});},d.race=function(t){return new d(function(c,a){for(var b=T(t),I=b.next();!I.done;I=b.next())n(I.value).M(c,a);});},d.all=function(t){var c=T(t),a=c.next();return a.done?n([]):new d(function(b,I){function F(j){return function(_){H[j]=_,E--,E==0&&b(H);};}var H=[],E=0;do H.push(void 0),E++,n(a.value).M(F(H.length-1),I),a=c.next();while(!a.done);});},d;});function Kn(o,d){o instanceof String&&(o+="");var g=0,n=!1,u={next:function next(){if(!n&&g<o.length){var f=g++;return{value:d(f,o[f]),done:!1};}return n=!0,{done:!0,value:void 0};}};return u[Symbol.iterator]=function(){return u;},u;}var On=typeof Object.assign=="function"?Object.assign:function(o,d){for(var g=1;g<arguments.length;g++){var n=arguments[g];if(n)for(var u in n)Object.prototype.hasOwnProperty.call(n,u)&&(o[u]=n[u]);}return o;};S("Object.assign",function(o){return o||On;}),S("Object.is",function(o){return o||function(d,g){return d===g?d!==0||1/d===1/g:d!==d&&g!==g;};}),S("Array.prototype.includes",function(o){return o||function(d,g){var n=this;n instanceof String&&(n=String(n));var u=n.length;for(g=g||0,0>g&&(g=Math.max(g+u,0));g<u;g++){var f=n[g];if(f===d||Object.is(f,d))return!0;}return!1;};}),S("String.prototype.includes",function(o){return o||function(d,g){if(this==null)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(d instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return this.indexOf(d,g||0)!==-1;};}),S("Array.prototype.keys",function(o){return o||function(){return Kn(this,function(d){return d;});};});var Xe=this||self;function Lt(o,d){o=o.split(".");var g=Xe;o[0]in g||typeof g.execScript>"u"||g.execScript("var "+o[0]);for(var n;o.length&&(n=o.shift());)o.length||d===void 0?g[n]&&g[n]!==Object.prototype[n]?g=g[n]:g=g[n]={}:g[n]=d;}function Ye(){throw Error("Invalid UTF8");}function nn(o,d){return d=String.fromCharCode.apply(null,d),o==null?d:o+d;}var yn,Yn=typeof TextDecoder<"u",Vn,Ln=typeof TextEncoder<"u",rn={},un=null;function Jn(o){var d;d===void 0&&(d=0),on(),d=rn[d];for(var g=Array(Math.floor(o.length/3)),n=d[64]||"",u=0,f=0;u<o.length-2;u+=3){var t=o[u],c=o[u+1],a=o[u+2],b=d[t>>2];t=d[(t&3)<<4|c>>4],c=d[(c&15)<<2|a>>6],a=d[a&63],g[f++]=b+t+c+a;}switch(b=0,a=n,o.length-u){case 2:b=o[u+1],a=d[(b&15)<<2]||n;case 1:o=o[u],g[f]=d[o>>2]+d[(o&3)<<4|b>>4]+a+n;}return g.join("");}function wn(o){var d=o.length,g=3*d/4;g%3?g=Math.floor(g):"=.".indexOf(o[d-1])!=-1&&(g="=.".indexOf(o[d-2])!=-1?g-2:g-1);var n=new Uint8Array(g),u=0;return gn(o,function(f){n[u++]=f;}),u!==g?n.subarray(0,u):n;}function gn(o,d){function g(a){for(;n<o.length;){var b=o.charAt(n++),I=un[b];if(I!=null)return I;if(!/^[\s\xa0]*$/.test(b))throw Error("Unknown base64 encoding at char: "+b);}return a;}on();for(var n=0;;){var u=g(-1),f=g(0),t=g(64),c=g(64);if(c===64&&u===-1)break;d(u<<2|f>>4),t!=64&&(d(f<<4&240|t>>2),c!=64&&d(t<<6&192|c));}}function on(){if(!un){un={};for(var o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),d=["+/=","+/","-_=","-_.","-_"],g=0;5>g;g++){var n=o.concat(d[g].split(""));rn[g]=n;for(var u=0;u<n.length;u++){var f=n[u];un[f]===void 0&&(un[f]=u);}}}}var Rn=typeof Uint8Array=="function";function Zn(o){return Rn&&o!=null&&o instanceof Uint8Array;}var be;function We(o){if(this.L=o,o!==null&&o.length===0)throw Error("ByteString should be constructed with non-empty values");}var Pe=typeof Uint8Array.prototype.slice=="function",pe=0,ye=0;function De(o,d){if(o.constructor===Uint8Array)return o;if(o.constructor===ArrayBuffer)return new Uint8Array(o);if(o.constructor===Array)return new Uint8Array(o);if(o.constructor===String)return wn(o);if(o.constructor===We)return!d&&(d=o.L)&&d.constructor===Uint8Array?d:(d=o.L,d=d==null||Zn(d)?d:typeof d=="string"?wn(d):null,(o=o.L=d)?new Uint8Array(o):be||(be=new Uint8Array(0)));if(o instanceof Uint8Array)return new Uint8Array(o.buffer,o.byteOffset,o.byteLength);throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");}function Ce(o,d){return Error("Invalid wire type: "+o+" (at position "+d+")");}function Pt(){return Error("Failed to read varint, encoding is invalid.");}function de(o,d){d=d===void 0?{}:d,d=d.v===void 0?!1:d.v,this.h=null,this.g=this.i=this.j=0,this.v=d,o&&we(this,o);}function we(o,d){o.h=De(d,o.v),o.j=0,o.i=o.h.length,o.g=o.j;}de.prototype.reset=function(){this.g=this.j;};function Jt(o){if(o.g>o.i)throw Error("Tried to read past the end of the data "+o.g+" > "+o.i);}function Ze(o){var d=o.h,g=d[o.g],n=g&127;if(128>g)return o.g+=1,Jt(o),n;if(g=d[o.g+1],n|=(g&127)<<7,128>g)return o.g+=2,Jt(o),n;if(g=d[o.g+2],n|=(g&127)<<14,128>g)return o.g+=3,Jt(o),n;if(g=d[o.g+3],n|=(g&127)<<21,128>g)return o.g+=4,Jt(o),n;if(g=d[o.g+4],o.g+=5,n|=(g&15)<<28,128>g)return Jt(o),n;if(128<=d[o.g++]&&128<=d[o.g++]&&128<=d[o.g++]&&128<=d[o.g++]&&128<=d[o.g++])throw Pt();return Jt(o),n;}var _t=[];function ae(){this.g=[];}ae.prototype.length=function(){return this.g.length;},ae.prototype.end=function(){var o=this.g;return this.g=[],o;};function xe(o,d){for(;127<d;)o.g.push(d&127|128),d>>>=7;o.g.push(d);}function _e(o){var d={},g=d.W===void 0?!1:d.W;this.l={v:d.v===void 0?!1:d.v},this.W=g,d=this.l,_t.length?(g=_t.pop(),d&&(g.v=d.v),o&&we(g,o),o=g):o=new de(o,d),this.g=o,this.j=this.g.g,this.h=this.i=-1;}_e.prototype.reset=function(){this.g.reset(),this.j=this.g.g,this.h=this.i=-1;};function me(o){var d=o.g;if(d.g==d.i)return!1;o.j=o.g.g;var g=Ze(o.g)>>>0;if(d=g>>>3,g&=7,!(0<=g&&5>=g))throw Ce(g,o.j);if(1>d)throw Error("Invalid field number: "+d+" (at position "+o.j+")");return o.i=d,o.h=g,!0;}function zt(o){switch(o.h){case 0:if(o.h!=0)zt(o);else t:{o=o.g;for(var d=o.g,g=d+10;d<g;)if(!(o.h[d++]&128)){o.g=d,Jt(o);break t;}throw Pt();}break;case 1:o=o.g,o.g+=8,Jt(o);break;case 2:o.h!=2?zt(o):(d=Ze(o.g)>>>0,o=o.g,o.g+=d,Jt(o));break;case 5:o=o.g,o.g+=4,Jt(o);break;case 3:d=o.i;do{if(!me(o))throw Error("Unmatched start-group tag: stream EOF");if(o.h==4){if(o.i!=d)throw Error("Unmatched end-group tag");break;}zt(o);}while(!0);break;default:throw Ce(o.h,o.j);}}var Je=[];function Ae(){this.i=[],this.h=0,this.g=new ae();}function ve(o,d){d.length!==0&&(o.i.push(d),o.h+=d.length);}function Sn(o,d){if(d=d.ba){ve(o,o.g.end());for(var g=0;g<d.length;g++)ve(o,d[g]);}}var $e=typeof Symbol=="function"&&typeof Symbol()=="symbol"?Symbol(void 0):void 0;function an(o,d){Object.isFrozen(o)||($e?o[$e]|=d:o.N!==void 0?o.N|=d:Object.defineProperties(o,{N:{value:d,configurable:!0,writable:!0,enumerable:!1}}));}function fn(o){var _d;var d;return $e?d=o[$e]:d=o.N,(_d=d)!=null?_d:0;}function he(o){return an(o,1),o;}function Ie(o){return Array.isArray(o)?!!(fn(o)&2):!1;}function fe(o){if(!Array.isArray(o))throw Error("cannot mark non-array as immutable");an(o,2);}function ee(o){return o!==null&&typeof o=="object"&&!Array.isArray(o)&&o.constructor===Object;}var Be=Object.freeze(he([]));function Qt(o){if(Ie(o.m))throw Error("Cannot mutate an immutable Message");}var At=typeof Symbol<"u"&&typeof Symbol.hasInstance<"u";function vn(o){return{value:o,configurable:!1,writable:!1,enumerable:!1};}function se(o,d,g){return d===-1?null:d>=o.i?o.g?o.g[d]:void 0:g!==void 0&&g&&o.g&&(g=o.g[d],g!=null)?g:o.m[d+o.h];}function Ft(o,d,g,n){n=n===void 0?!1:n,Qt(o),d<o.i&&!n?o.m[d+o.h]=g:(o.g||(o.g=o.m[o.i+o.h]={}))[d]=g;}function Wt(o,d,g,n){g=g===void 0?!0:g,n=n===void 0?!1:n;var u=se(o,d,n);return u==null&&(u=Be),Ie(o.m)?g&&(fe(u),Object.freeze(u)):(u===Be||Ie(u))&&(u=he(u.slice()),Ft(o,d,u,n)),u;}function ne(o,d,g){var _o2;return o=se(o,d),o=o==null?o:+o,(_o2=o)!=null?_o2:g===void 0?0:g;}function He(o,d,g,n){o.j||(o.j={});var u=Ie(o.m),f=o.j[g];if(!f){n=Wt(o,g,!0,n===void 0?!1:n),f=[],u=u||Ie(n);for(var t=0;t<n.length;t++)f[t]=new d(n[t]),u&&fe(f[t].m);u&&(fe(f),Object.freeze(f)),o.j[g]=f;}return f;}function Dt(o,d,g,n,u){var f=f===void 0?!1:f;return Qt(o),f=He(o,g,d,f),g=n||new g(),o=Wt(o,d),u!=null?(f.splice(u,0,g),o.splice(u,0,g.m)):(f.push(g),o.push(g.m)),g;}function re(o,d){var _o3;return o=se(o,d),(_o3=o)!=null?_o3:0;}function Ne(o,d){var _o4;return o=se(o,d),(_o4=o)!=null?_o4:"";}function Bt(o){switch(typeof o){case"number":return isFinite(o)?o:String(o);case"object":if(o&&!Array.isArray(o)){if(Zn(o))return Jn(o);if(o instanceof We){var d=o.L;return d=d==null||typeof d=="string"?d:Rn&&d instanceof Uint8Array?Jn(d):null,(o.L=d)||"";}}}return o;}function It(o){var d=Fe;return d=d===void 0?Ot:d,Ke(o,d);}function je(o,d){if(o!=null){if(Array.isArray(o))o=Ke(o,d);else if(ee(o)){var g={},n;for(n in o)g[n]=je(o[n],d);o=g;}else o=d(o);return o;}}function Ke(o,d){for(var g=o.slice(),n=0;n<g.length;n++)g[n]=je(g[n],d);return Array.isArray(o)&&fn(o)&1&&he(g),g;}function Fe(o){return o&&typeof o=="object"&&o.toJSON?o.toJSON():(o=Bt(o),Array.isArray(o)?It(o):o);}function Ot(o){return Zn(o)?new Uint8Array(o):o;}function ke(o,d,g){o||(o=mn),mn=null;var n=this.constructor.h;o||(o=n?[n]:[]),this.h=(n?0:-1)-(this.constructor.g||0),this.j=void 0,this.m=o;t:{if(n=this.m.length,o=n-1,n&&(n=this.m[o],ee(n))){this.i=o-this.h,this.g=n;break t;}d!==void 0&&-1<d?(this.i=Math.max(d,o+1-this.h),this.g=void 0):this.i=Number.MAX_VALUE;}if(g)for(d=0;d<g.length;d++)if(o=g[d],o<this.i)o+=this.h,(n=this.m[o])?Array.isArray(n)&&he(n):this.m[o]=Be;else{n=this.g||(this.g=this.m[this.i+this.h]={});var u=n[o];u?Array.isArray(u)&&he(u):n[o]=Be;}}ke.prototype.toJSON=function(){return It(this.m);},ke.prototype.toString=function(){return this.m.toString();};var mn;function qe(){ke.apply(this,arguments);}if(ht(qe,ke),At){var Ue={};Object.defineProperties(qe,(Ue[Symbol.hasInstance]=vn(function(){throw Error("Cannot perform instanceof checks for MutableMessage");}),Ue));}function Qe(o,d,g){if(g){var n={},u;for(u in g){var f=g[u],t=f.ha;t||(n.F=f.la||f.fa.P,f.aa?(n.U=pn(f.aa),t=/* @__PURE__ */function(c){return function(a,b,I){return c.F(a,b,I,c.U);};}(n)):f.ca?(n.T=Le(f.X.g,f.ca),t=/* @__PURE__ */function(c){return function(a,b,I){return c.F(a,b,I,c.T);};}(n)):t=n.F,f.ha=t),t(d,o,f.X),n={F:n.F,U:n.U,T:n.T};}}Sn(d,o);}var tn=Symbol();function Ge(o,d,g){return o[tn]||(o[tn]=function(n,u){return d(n,u,g);});}function Ee(o){var d=o[tn];if(!d){var g=p(o);d=function d(n,u){return W(n,u,g);},o[tn]=d;}return d;}function kn(o){var d=o.aa;if(d)return Ee(d);if(d=o.ka)return Ge(o.X.g,d,o.ca);}function Me(o){var d=kn(o),g=o.X,n=o.fa.O;return d?function(u,f){return n(u,f,g,d);}:function(u,f){return n(u,f,g);};}function Ve(o,d,g,n,u,f){o=o();var t=0;for(o.length&&typeof o[0]!="number"&&(g(d,o[0]),t++);t<o.length;){g=o[t++];for(var c=t+1;c<o.length&&typeof o[c]!="number";)c++;var a=o[t++];switch(c-=t,c){case 0:n(d,g,a);break;case 1:n(d,g,a,o[t++]);break;case 2:u(d,g,a,o[t++],o[t++]);break;case 3:c=o[t++];var b=o[t++],I=o[t++];Array.isArray(I)?u(d,g,a,c,b,I):f(d,g,a,c,b,I);break;case 4:f(d,g,a,o[t++],o[t++],o[t++],o[t++]);break;default:throw Error("unexpected number of binary field arguments: "+c);}}return d;}var sn=Symbol();function pn(o){var d=o[sn];if(!d){var g=Oe(o);d=function d(n,u){return U(n,u,g);},o[sn]=d;}return d;}function Le(o,d){var g=o[sn];return g||(g=function g(n,u){return Qe(n,u,d);},o[sn]=g),g;}var Fn=Symbol();function ze(o,d){o.push(d);}function ln(o,d,g){o.push(d,g.P);}function Gn(o,d,g,n,u){var f=pn(u),t=g.P;o.push(d,function(c,a,b){return t(c,a,b,n,f);});}function Hn(o,d,g,n,u,f){var t=Le(n,f),c=g.P;o.push(d,function(a,b,I){return c(a,b,I,n,t);});}function Oe(o){var d=o[Fn];return d||Ve(o,o[Fn]=[],ze,ln,Gn,Hn);}var Xn=Symbol();function An(o,d){o[0]=d;}function Bn(o,d,g,n){var u=g.O;o[d]=n?function(f,t,c){return u(f,t,c,n);}:u;}function Wn(o,d,g,n,u,f){var t=g.O,c=Ee(u);o[d]=function(a,b,I){return t(a,b,I,n,c,f);};}function xn(o,d,g,n,u,f,t){var c=g.O,a=Ge(n,u,f);o[d]=function(b,I,F){return c(b,I,F,n,a,t);};}function p(o){var d=o[Xn];return d||Ve(o,o[Xn]={},An,Bn,Wn,xn);}function W(o,d,g){for(;me(d)&&d.h!=4;){var n=d.i,u=g[n];if(!u){var f=g[0];f&&(f=f[n])&&(u=g[n]=Me(f));}if((!u||!u(d,o,n))&&(u=d,n=o,f=u.j,zt(u),!u.W)){var t=u.g.h;u=u.g.g,u=f===u?be||(be=new Uint8Array(0)):Pe?t.slice(f,u):new Uint8Array(t.subarray(f,u)),(f=n.ba)?f.push(u):n.ba=[u];}}return o;}function V(o,d,g){if(Je.length){var n=Je.pop();o&&(we(n.g,o),n.i=-1,n.h=-1),o=n;}else o=new _e(o);try{return W(new d(),o,p(g));}finally{d=o.g,d.h=null,d.j=0,d.i=0,d.g=0,d.v=!1,o.i=-1,o.h=-1,100>Je.length&&Je.push(o);}}function U(o,d,g){for(var n=g.length,u=n%2==1,f=u?1:0;f<n;f+=2)(0,g[f+1])(d,o,g[f]);Qe(o,d,u?g[0]:void 0);}function O(o,d){var g=new Ae();U(o,g,Oe(d)),ve(g,g.g.end()),o=new Uint8Array(g.h),d=g.i;for(var n=d.length,u=0,f=0;f<n;f++){var t=d[f];o.set(t,u),u+=t.length;}return g.i=[o],o;}function rt(o,d){return{O:o,P:d};}var K=rt(function(o,d,g){if(o.h!==5)return!1;o=o.g;var n=o.h[o.g],u=o.h[o.g+1],f=o.h[o.g+2],t=o.h[o.g+3];return o.g+=4,Jt(o),u=(n<<0|u<<8|f<<16|t<<24)>>>0,o=2*(u>>31)+1,n=u>>>23&255,u&=8388607,Ft(d,g,n==255?u?NaN:1/0*o:n==0?o*Math.pow(2,-149)*u:o*Math.pow(2,n-150)*(u+Math.pow(2,23))),!0;},function(o,d,g){if(d=se(d,g),d!=null){xe(o.g,8*g+5),o=o.g;var n=d;n=(g=0>n?1:0)?-n:n,n===0?0<1/n?pe=ye=0:(ye=0,pe=2147483648):isNaN(n)?(ye=0,pe=2147483647):34028234663852886e22<n?(ye=0,pe=(g<<31|2139095040)>>>0):11754943508222875e-54>n?(n=Math.round(n/Math.pow(2,-149)),ye=0,pe=(g<<31|n)>>>0):(d=Math.floor(Math.log(n)/Math.LN2),n*=Math.pow(2,-d),n=Math.round(8388608*n),16777216<=n&&++d,ye=0,pe=(g<<31|d+127<<23|n&8388607)>>>0),g=pe,o.g.push(g>>>0&255),o.g.push(g>>>8&255),o.g.push(g>>>16&255),o.g.push(g>>>24&255);}}),nt=rt(function(o,d,g){if(o.h!==0)return!1;for(var n=o.g,u=128,f=0,t=o=0;4>t&&128<=u;t++)u=n.h[n.g++],Jt(n),f|=(u&127)<<7*t;if(128<=u&&(u=n.h[n.g++],Jt(n),f|=(u&127)<<28,o|=(u&127)>>4),128<=u)for(t=0;5>t&&128<=u;t++)u=n.h[n.g++],Jt(n),o|=(u&127)<<7*t+3;if(128>u)n=f>>>0,u=o>>>0,(o=u&2147483648)&&(n=~n+1>>>0,u=~u>>>0,n==0&&(u=u+1>>>0)),n=4294967296*u+(n>>>0);else throw Pt();return Ft(d,g,o?-n:n),!0;},function(o,d,g){if(d=se(d,g),d!=null&&d!=null){xe(o.g,8*g),o=o.g;var n=d;for(g=0>n,n=Math.abs(n),d=n>>>0,n=Math.floor((n-d)/4294967296),n>>>=0,g&&(n=~n>>>0,d=(~d>>>0)+1,4294967295<d&&(d=0,n++,4294967295<n&&(n=0))),pe=d,ye=n,g=pe,d=ye;0<d||127<g;)o.g.push(g&127|128),g=(g>>>7|d<<25)>>>0,d>>>=7;o.g.push(g);}}),dt=rt(function(o,d,g){return o.h!==0?!1:(Ft(d,g,Ze(o.g)),!0);},function(o,d,g){if(d=se(d,g),d!=null&&d!=null)if(xe(o.g,8*g),o=o.g,g=d,0<=g)xe(o,g);else{for(d=0;9>d;d++)o.g.push(g&127|128),g>>=7;o.g.push(1);}}),vt=rt(function(o,d,g){if(o.h!==2)return!1;var n=Ze(o.g)>>>0;o=o.g;var u=o.g;o.g+=n,Jt(o),o=o.h;var f;if(Yn)(f=yn)||(f=yn=new TextDecoder("utf-8",{fatal:!0})),f=f.decode(o.subarray(u,u+n));else{n=u+n;for(var t=[],c=null,a,b,I;u<n;)a=o[u++],128>a?t.push(a):224>a?u>=n?Ye():(b=o[u++],194>a||(b&192)!==128?(u--,Ye()):t.push((a&31)<<6|b&63)):240>a?u>=n-1?Ye():(b=o[u++],(b&192)!==128||a===224&&160>b||a===237&&160<=b||((f=o[u++])&192)!==128?(u--,Ye()):t.push((a&15)<<12|(b&63)<<6|f&63)):244>=a?u>=n-2?Ye():(b=o[u++],(b&192)!==128||(a<<28)+(b-144)>>30||((f=o[u++])&192)!==128||((I=o[u++])&192)!==128?(u--,Ye()):(a=(a&7)<<18|(b&63)<<12|(f&63)<<6|I&63,a-=65536,t.push((a>>10&1023)+55296,(a&1023)+56320))):Ye(),8192<=t.length&&(c=nn(c,t),t.length=0);f=nn(c,t);}return Ft(d,g,f),!0;},function(o,d,g){if(d=se(d,g),d!=null){var n=!1;if(n=n===void 0?!1:n,Ln){if(n&&/(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(d))throw Error("Found an unpaired surrogate");d=(Vn||(Vn=new TextEncoder())).encode(d);}else{for(var u=0,f=new Uint8Array(3*d.length),t=0;t<d.length;t++){var c=d.charCodeAt(t);if(128>c)f[u++]=c;else{if(2048>c)f[u++]=c>>6|192;else{if(55296<=c&&57343>=c){if(56319>=c&&t<d.length){var a=d.charCodeAt(++t);if(56320<=a&&57343>=a){c=1024*(c-55296)+a-56320+65536,f[u++]=c>>18|240,f[u++]=c>>12&63|128,f[u++]=c>>6&63|128,f[u++]=c&63|128;continue;}else t--;}if(n)throw Error("Found an unpaired surrogate");c=65533;}f[u++]=c>>12|224,f[u++]=c>>6&63|128;}f[u++]=c&63|128;}}d=f.subarray(0,u);}xe(o.g,8*g+2),xe(o.g,d.length),ve(o,o.g.end()),ve(o,d);}}),Ct=rt(function(o,d,g,n,u){if(o.h!==2)return!1;d=Dt(d,g,n),g=o.g.i,n=Ze(o.g)>>>0;var f=o.g.g+n,t=f-g;if(0>=t&&(o.g.i=f,u(d,o),t=f-o.g.g),t)throw Error("Message parsing ended unexpectedly. Expected to read "+(n+" bytes, instead read "+(n-t)+" bytes, either the data ended unexpectedly or the message misreported its own length"));return o.g.g=f,o.g.i=g,!0;},function(o,d,g,n,u){if(d=He(d,n,g),d!=null)for(n=0;n<d.length;n++){var f=o;xe(f.g,8*g+2);var t=f.g.end();ve(f,t),t.push(f.h),f=t,u(d[n],o),t=o;var c=f.pop();for(c=t.h+t.g.length()-c;127<c;)f.push(c&127|128),c>>>=7,t.h++;f.push(c),t.h++;}});function Tt(){qe.apply(this,arguments);}if(ht(Tt,qe),At){var jt={};Object.defineProperties(Tt,(jt[Symbol.hasInstance]=vn(Object[Symbol.hasInstance]),jt));}function wt(o){Tt.call(this,o);}ht(wt,Tt);function Vt(){return[1,dt,2,K,3,vt,4,vt];}function Ht(o){Tt.call(this,o,-1,te);}ht(Ht,Tt),Ht.prototype.addClassification=function(o,d){return Dt(this,1,wt,o,d),this;};function Et(){return[1,Ct,wt,Vt];}var te=[1];function ie(o){Tt.call(this,o);}ht(ie,Tt);function le(){return[1,K,2,K,3,K,4,K,5,K];}function Re(o){Tt.call(this,o,-1,y);}ht(Re,Tt);function h(){return[1,Ct,ie,le];}var y=[1];function G(o){Tt.call(this,o);}ht(G,Tt);function C(){return[1,K,2,K,3,K,4,K,5,K,6,nt];}var z=[[61,146],[146,91],[91,181],[181,84],[84,17],[17,314],[314,405],[405,321],[321,375],[375,291],[61,185],[185,40],[40,39],[39,37],[37,0],[0,267],[267,269],[269,270],[270,409],[409,291],[78,95],[95,88],[88,178],[178,87],[87,14],[14,317],[317,402],[402,318],[318,324],[324,308],[78,191],[191,80],[80,81],[81,82],[82,13],[13,312],[312,311],[311,310],[310,415],[415,308]],P=[[263,249],[249,390],[390,373],[373,374],[374,380],[380,381],[381,382],[382,362],[263,466],[466,388],[388,387],[387,386],[386,385],[385,384],[384,398],[398,362]],A=[[276,283],[283,282],[282,295],[295,285],[300,293],[293,334],[334,296],[296,336]],q=[[33,7],[7,163],[163,144],[144,145],[145,153],[153,154],[154,155],[155,133],[33,246],[246,161],[161,160],[160,159],[159,158],[158,157],[157,173],[173,133]],ot=[[46,53],[53,52],[52,65],[65,55],[70,63],[63,105],[105,66],[66,107]],s=[[10,338],[338,297],[297,332],[332,284],[284,251],[251,389],[389,356],[356,454],[454,323],[323,361],[361,288],[288,397],[397,365],[365,379],[379,378],[378,400],[400,377],[377,152],[152,148],[148,176],[176,149],[149,150],[150,136],[136,172],[172,58],[58,132],[132,93],[93,234],[234,127],[127,162],[162,21],[21,54],[54,103],[103,67],[67,109],[109,10]],X=[].concat(k(z),k(P),k(A),k(q),k(ot),k(s));function R(o,d,g){if(g=o.createShader(g===0?o.VERTEX_SHADER:o.FRAGMENT_SHADER),o.shaderSource(g,d),o.compileShader(g),!o.getShaderParameter(g,o.COMPILE_STATUS))throw Error(`Could not compile WebGL shader.

`+o.getShaderInfoLog(g));return g;}function w(o){return He(o,wt,1).map(function(d){return{index:re(d,1),ga:ne(d,2),label:se(d,3)!=null?Ne(d,3):void 0,displayName:se(d,4)!=null?Ne(d,4):void 0};});}function N(o){return{x:ne(o,1),y:ne(o,2),z:ne(o,3),visibility:se(o,4)!=null?ne(o,4):void 0};}function B(o,d){this.h=o,this.g=d,this.l=0;}function M(o,d,g){return et(o,d),typeof o.g.canvas.transferToImageBitmap=="function"?Promise.resolve(o.g.canvas.transferToImageBitmap()):g?Promise.resolve(o.g.canvas):typeof createImageBitmap=="function"?createImageBitmap(o.g.canvas):(o.i===void 0&&(o.i=document.createElement("canvas")),new Promise(function(n){o.i.height=o.g.canvas.height,o.i.width=o.g.canvas.width,o.i.getContext("2d",{}).drawImage(o.g.canvas,0,0,o.g.canvas.width,o.g.canvas.height),n(o.i);}));}function et(o,d){var g=o.g;if(o.o===void 0){var n=R(g,`
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`,0),u=R(g,`
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`,1),f=g.createProgram();if(g.attachShader(f,n),g.attachShader(f,u),g.linkProgram(f),!g.getProgramParameter(f,g.LINK_STATUS))throw Error(`Could not compile WebGL program.

`+g.getProgramInfoLog(f));n=o.o=f,g.useProgram(n),u=g.getUniformLocation(n,"sampler0"),o.j={K:g.getAttribLocation(n,"aVertex"),J:g.getAttribLocation(n,"aTex"),ma:u},o.u=g.createBuffer(),g.bindBuffer(g.ARRAY_BUFFER,o.u),g.enableVertexAttribArray(o.j.K),g.vertexAttribPointer(o.j.K,2,g.FLOAT,!1,0,0),g.bufferData(g.ARRAY_BUFFER,new Float32Array([-1,-1,-1,1,1,1,1,-1]),g.STATIC_DRAW),g.bindBuffer(g.ARRAY_BUFFER,null),o.s=g.createBuffer(),g.bindBuffer(g.ARRAY_BUFFER,o.s),g.enableVertexAttribArray(o.j.J),g.vertexAttribPointer(o.j.J,2,g.FLOAT,!1,0,0),g.bufferData(g.ARRAY_BUFFER,new Float32Array([0,1,0,0,1,0,1,1]),g.STATIC_DRAW),g.bindBuffer(g.ARRAY_BUFFER,null),g.uniform1i(u,0);}n=o.j,g.useProgram(o.o),g.canvas.width=d.width,g.canvas.height=d.height,g.viewport(0,0,d.width,d.height),g.activeTexture(g.TEXTURE0),o.h.bindTexture2d(d.glName),g.enableVertexAttribArray(n.K),g.bindBuffer(g.ARRAY_BUFFER,o.u),g.vertexAttribPointer(n.K,2,g.FLOAT,!1,0,0),g.enableVertexAttribArray(n.J),g.bindBuffer(g.ARRAY_BUFFER,o.s),g.vertexAttribPointer(n.J,2,g.FLOAT,!1,0,0),g.bindFramebuffer(g.DRAW_FRAMEBUFFER?g.DRAW_FRAMEBUFFER:g.FRAMEBUFFER,null),g.clearColor(0,0,0,0),g.clear(g.COLOR_BUFFER_BIT),g.colorMask(!0,!0,!0,!0),g.drawArrays(g.TRIANGLE_FAN,0,4),g.disableVertexAttribArray(n.K),g.disableVertexAttribArray(n.J),g.bindBuffer(g.ARRAY_BUFFER,null),o.h.bindTexture2d(0);}function $(o){this.g=o;}var ft=new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,10,9,1,7,0,65,0,253,15,26,11]);function gt(o,d){return d+o;}function Nt(o,d){window[o]=d;}function Gt(o){var d=document.createElement("script");return d.setAttribute("src",o),d.setAttribute("crossorigin","anonymous"),new Promise(function(g){d.addEventListener("load",function(){g();},!1),d.addEventListener("error",function(){g();},!1),document.body.appendChild(d);});}function lt(){return yt(function(o){switch(o.g){case 1:return o.o=2,D(o,WebAssembly.instantiate(ft),4);case 4:o.g=3,o.o=0;break;case 2:return o.o=0,o.j=null,o.return(!1);case 3:return o.return(!0);}});}function Zt(o){if(this.g=o,this.listeners={},this.j={},this.H={},this.o={},this.u={},this.I=this.s=this.Z=!0,this.D=Promise.resolve(),this.Y="",this.C={},this.locateFile=o&&o.locateFile||gt,typeof window=="object")var d=window.location.pathname.toString().substring(0,window.location.pathname.toString().lastIndexOf("/"))+"/";else if(typeof location<"u")d=location.pathname.toString().substring(0,location.pathname.toString().lastIndexOf("/"))+"/";else throw Error("solutions can only be loaded on a web page or in a web worker");if(this.$=d,o.options){d=T(Object.keys(o.options));for(var g=d.next();!g.done;g=d.next()){g=g.value;var n=o.options[g].default;n!==void 0&&(this.j[g]=typeof n=="function"?n():n);}}}r=Zt.prototype,r.close=function(){return this.i&&this.i.delete(),Promise.resolve();};function Xt(o){var d,g,n,u,f,t,c,a,b,I,F;return yt(function(H){switch(H.g){case 1:return o.Z?(d=o.g.files===void 0?[]:typeof o.g.files=="function"?o.g.files(o.j):o.g.files,D(H,lt(),2)):H.return();case 2:if(g=H.h,typeof window=="object")return Nt("createMediapipeSolutionsWasm",{locateFile:o.locateFile}),Nt("createMediapipeSolutionsPackedAssets",{locateFile:o.locateFile}),t=d.filter(function(E){return E.data!==void 0;}),c=d.filter(function(E){return E.data===void 0;}),a=Promise.all(t.map(function(E){var j=l(o,E.url);if(E.path!==void 0){var _=E.path;j=j.then(function(Q){return o.overrideFile(_,Q),Promise.resolve(Q);});}return j;})),b=Promise.all(c.map(function(E){return E.simd===void 0||E.simd&&g||!E.simd&&!g?Gt(o.locateFile(E.url,o.$)):Promise.resolve();})).then(function(){var E,j,_;return yt(function(Q){if(Q.g==1)return E=window.createMediapipeSolutionsWasm,j=window.createMediapipeSolutionsPackedAssets,_=o,D(Q,E(j),2);_.h=Q.h,Q.g=0;});}),I=function(){return yt(function(E){return o.g.graph&&o.g.graph.url?E=D(E,l(o,o.g.graph.url),0):(E.g=0,E=void 0),E;});}(),D(H,Promise.all([b,a,I]),7);if(typeof importScripts!="function")throw Error("solutions can only be loaded on a web page or in a web worker");return n=d.filter(function(E){return E.simd===void 0||E.simd&&g||!E.simd&&!g;}).map(function(E){return o.locateFile(E.url,o.$);}),importScripts.apply(null,k(n)),u=o,D(H,createMediapipeSolutionsWasm(Module),6);case 6:u.h=H.h,o.l=new OffscreenCanvas(1,1),o.h.canvas=o.l,f=o.h.GL.createContext(o.l,{antialias:!1,alpha:!1,ja:typeof WebGL2RenderingContext<"u"?2:1}),o.h.GL.makeContextCurrent(f),H.g=4;break;case 7:if(o.l=document.createElement("canvas"),F=o.l.getContext("webgl2",{}),!F&&(F=o.l.getContext("webgl",{}),!F))return alert("Failed to create WebGL canvas context when passing video frame."),H.return();o.G=F,o.h.canvas=o.l,o.h.createContext(o.l,!0,!0,{});case 4:o.i=new o.h.SolutionWasm(),o.Z=!1,H.g=0;}});}function Rt(o){var d,g,n,u,f,t,c,a;return yt(function(b){if(b.g==1){if(o.g.graph&&o.g.graph.url&&o.Y===o.g.graph.url)return b.return();if(o.s=!0,!o.g.graph||!o.g.graph.url){b.g=2;return;}return o.Y=o.g.graph.url,D(b,l(o,o.g.graph.url),3);}for(b.g!=2&&(d=b.h,o.i.loadGraph(d)),g=T(Object.keys(o.C)),n=g.next();!n.done;n=g.next())u=n.value,o.i.overrideFile(u,o.C[u]);if(o.C={},o.g.listeners)for(f=T(o.g.listeners),t=f.next();!t.done;t=f.next())c=t.value,Y(o,c);a=o.j,o.j={},o.setOptions(a),b.g=0;});}r.reset=function(){var o=this;return yt(function(d){o.i&&(o.i.reset(),o.o={},o.u={}),d.g=0;});},r.setOptions=function(o,d){var g=this;if(d=d||this.g.options){for(var n=[],u=[],f={},t=T(Object.keys(o)),c=t.next();!c.done;f={R:f.R,S:f.S},c=t.next()){var a=c.value;a in this.j&&this.j[a]===o[a]||(this.j[a]=o[a],c=d[a],c!==void 0&&(c.onChange&&(f.R=c.onChange,f.S=o[a],n.push(/* @__PURE__ */function(b){return function(){var I;return yt(function(F){if(F.g==1)return D(F,b.R(b.S),2);I=F.h,I===!0&&(g.s=!0),F.g=0;});};}(f))),c.graphOptionXref&&(a={valueNumber:c.type===1?o[a]:0,valueBoolean:c.type===0?o[a]:!1,valueString:c.type===2?o[a]:""},c=Object.assign(Object.assign(Object.assign({},{calculatorName:"",calculatorIndex:0}),c.graphOptionXref),a),u.push(c))));}(n.length!==0||u.length!==0)&&(this.s=!0,this.B=(this.B===void 0?[]:this.B).concat(u),this.A=(this.A===void 0?[]:this.A).concat(n));}};function St(o){var d,g,n,u,f,t,c;return yt(function(a){switch(a.g){case 1:if(!o.s)return a.return();if(!o.A){a.g=2;break;}d=T(o.A),g=d.next();case 3:if(g.done){a.g=5;break;}return n=g.value,D(a,n(),4);case 4:g=d.next(),a.g=3;break;case 5:o.A=void 0;case 2:if(o.B){for(u=new o.h.GraphOptionChangeRequestList(),f=T(o.B),t=f.next();!t.done;t=f.next())c=t.value,u.push_back(c);o.i.changeOptions(u),u.delete(),o.B=void 0;}o.s=!1,a.g=0;}});}r.initialize=function(){var o=this;return yt(function(d){return d.g==1?D(d,Xt(o),2):d.g!=3?D(d,Rt(o),3):D(d,St(o),0);});};function l(o,d){var g,n;return yt(function(u){return d in o.H?u.return(o.H[d]):(g=o.locateFile(d,""),n=fetch(g).then(function(f){return f.arrayBuffer();}),o.H[d]=n,u.return(n));});}r.overrideFile=function(o,d){this.i?this.i.overrideFile(o,d):this.C[o]=d;},r.clearOverriddenFiles=function(){this.C={},this.i&&this.i.clearOverriddenFiles();},r.send=function(o,d){var g=this,n,u,f,t,c,a,b,I,F;return yt(function(H){switch(H.g){case 1:return g.g.inputs?(n=1e3*(d!=null?d:performance.now()),D(H,g.D,2)):H.return();case 2:return D(H,g.initialize(),3);case 3:for(u=new g.h.PacketDataList(),f=T(Object.keys(o)),t=f.next();!t.done;t=f.next())if(c=t.value,a=g.g.inputs[c]){t:{var E=o[c];switch(a.type){case"video":var j=g.o[a.stream];if(j||(j=new B(g.h,g.G),g.o[a.stream]=j),j.l===0&&(j.l=j.h.createTexture()),typeof HTMLVideoElement<"u"&&E instanceof HTMLVideoElement)var _=E.videoWidth,Q=E.videoHeight;else typeof HTMLImageElement<"u"&&E instanceof HTMLImageElement?(_=E.naturalWidth,Q=E.naturalHeight):(_=E.width,Q=E.height);Q={glName:j.l,width:_,height:Q},_=j.g,_.canvas.width=Q.width,_.canvas.height=Q.height,_.activeTexture(_.TEXTURE0),j.h.bindTexture2d(j.l),_.texImage2D(_.TEXTURE_2D,0,_.RGBA,_.RGBA,_.UNSIGNED_BYTE,E),j.h.bindTexture2d(0),j=Q;break t;case"detections":for(j=g.o[a.stream],j||(j=new $(g.h),g.o[a.stream]=j),j.data||(j.data=new j.g.DetectionListData()),j.data.reset(E.length),Q=0;Q<E.length;++Q){_=E[Q];var it=j.data,ct=it.setBoundingBox,ut=Q,pt=_.boundingBox,mt=new G();if(Ft(mt,1,pt.xCenter),Ft(mt,2,pt.yCenter),Ft(mt,3,pt.height),Ft(mt,4,pt.width),Ft(mt,5,pt.rotation),Ft(mt,6,pt.rectId),pt=O(mt,C),ct.call(it,ut,pt),_.landmarks)for(it=0;it<_.landmarks.length;++it){mt=_.landmarks[it];var kt=!!mt.visibility;ct=j.data,ut=ct.addNormalizedLandmark,pt=Q,mt=Object.assign(Object.assign({},mt),{visibility:kt?mt.visibility:0}),kt=new ie(),Ft(kt,1,mt.x),Ft(kt,2,mt.y),Ft(kt,3,mt.z),mt.visibility&&Ft(kt,4,mt.visibility),mt=O(kt,le),ut.call(ct,pt,mt);}if(_.V)for(it=0;it<_.V.length;++it)ct=j.data,ut=ct.addClassification,pt=Q,mt=_.V[it],kt=new wt(),Ft(kt,2,mt.ga),mt.index&&Ft(kt,1,mt.index),mt.label&&Ft(kt,3,mt.label),mt.displayName&&Ft(kt,4,mt.displayName),mt=O(kt,Vt),ut.call(ct,pt,mt);}j=j.data;break t;default:j={};}}switch(b=j,I=a.stream,a.type){case"video":u.pushTexture2d(Object.assign(Object.assign({},b),{stream:I,timestamp:n}));break;case"detections":F=b,F.stream=I,F.timestamp=n,u.pushDetectionList(F);break;default:throw Error("Unknown input config type: '"+a.type+"'");}}return g.i.send(u),D(H,g.D,4);case 4:u.delete(),H.g=0;}});};function Z(o,d,g){var n,u,f,t,c,a,b,I,F,H,E,j,_,Q;return yt(function(it){switch(it.g){case 1:if(!g)return it.return(d);for(n={},u=0,f=T(Object.keys(g)),t=f.next();!t.done;t=f.next())c=t.value,a=g[c],typeof a!="string"&&a.type==="texture"&&d[a.stream]!==void 0&&++u;1<u&&(o.I=!1),b=T(Object.keys(g)),t=b.next();case 2:if(t.done){it.g=4;break;}if(I=t.value,F=g[I],typeof F=="string")return _=n,Q=I,D(it,x(o,I,d[F]),14);if(H=d[F.stream],F.type==="detection_list"){if(H){for(var ct=H.getRectList(),ut=H.getLandmarksList(),pt=H.getClassificationsList(),mt=[],kt=0;kt<ct.size();++kt){var $t=V(ct.get(kt),G,C);$t={boundingBox:{xCenter:ne($t,1),yCenter:ne($t,2),height:ne($t,3),width:ne($t,4),rotation:ne($t,5,0),rectId:re($t,6)},landmarks:He(V(ut.get(kt),Re,h),ie,1).map(N),V:w(V(pt.get(kt),Ht,Et))},mt.push($t);}ct=mt;}else ct=[];n[I]=ct,it.g=7;break;}if(F.type==="proto_list"){if(H){for(ct=Array(H.size()),ut=0;ut<H.size();ut++)ct[ut]=H.get(ut);H.delete();}else ct=[];n[I]=ct,it.g=7;break;}if(H===void 0){it.g=3;break;}if(F.type==="float_list"){n[I]=H,it.g=7;break;}if(F.type==="proto"){n[I]=H,it.g=7;break;}if(F.type!=="texture")throw Error("Unknown output config type: '"+F.type+"'");return E=o.u[I],E||(E=new B(o.h,o.G),o.u[I]=E),D(it,M(E,H,o.I),13);case 13:j=it.h,n[I]=j;case 7:F.transform&&n[I]&&(n[I]=F.transform(n[I])),it.g=3;break;case 14:_[Q]=it.h;case 3:t=b.next(),it.g=2;break;case 4:return it.return(n);}});}function x(o,d,g){var n;return yt(function(u){return typeof g=="number"||g instanceof Uint8Array||g instanceof o.h.Uint8BlobList?u.return(g):g instanceof o.h.Texture2dDataOut?(n=o.u[d],n||(n=new B(o.h,o.G),o.u[d]=n),u.return(M(n,g,o.I))):u.return(void 0);});}function Y(o,d){for(var g=d.name||"$",n=[].concat(k(d.wants)),u=new o.h.StringList(),f=T(d.wants),t=f.next();!t.done;t=f.next())u.push_back(t.value);f=o.h.PacketListener.implement({onResults:function onResults(c){for(var a={},b=0;b<d.wants.length;++b)a[n[b]]=c.get(b);var I=o.listeners[g];I&&(o.D=Z(o,a,d.outs).then(function(F){F=I(F);for(var H=0;H<d.wants.length;++H){var E=a[n[H]];typeof E=="object"&&E.hasOwnProperty&&E.hasOwnProperty("delete")&&E.delete();}F&&(o.D=F);}));}}),o.i.attachMultiListener(u,f),u.delete();}r.onResults=function(o,d){this.listeners[d||"$"]=o;},Lt("Solution",Zt),Lt("OptionType",{BOOL:0,NUMBER:1,ia:2,0:"BOOL",1:"NUMBER",2:"STRING"});function J(o){var d=this;o=o||{};var g={url:"face_detection_short.binarypb"},n={type:1,graphOptionXref:{calculatorType:"TensorsToDetectionsCalculator",calculatorName:"facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator",fieldName:"min_score_thresh"}};this.g=new Zt({locateFile:o.locateFile,files:[{data:!0,url:"face_detection_short.binarypb"},{data:!0,url:"face_detection_short_range.tflite"},{simd:!0,url:"face_detection_solution_simd_wasm_bin.js"},{simd:!1,url:"face_detection_solution_wasm_bin.js"}],graph:g,listeners:[{wants:["detections","image_transformed"],outs:{image:"image_transformed",detections:{type:"detection_list",stream:"detections"}}}],inputs:{image:{type:"video",stream:"input_frames_gpu"}},options:{useCpuInference:{type:0,graphOptionXref:{calculatorType:"InferenceCalculator",fieldName:"use_cpu_inference"},default:typeof window!="object"||window.navigator===void 0?!1:"iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document},selfieMode:{type:0,graphOptionXref:{calculatorType:"GlScalerCalculator",calculatorIndex:1,fieldName:"flip_horizontal"}},model:{type:0,onChange:function onChange(u){var f,t,c,a,b,I;return yt(function(F){switch(F.g){case 1:f=u==="short"?["face_detection_short_range.tflite"]:["face_detection_full_range_sparse.tflite"],t=T(f),c=t.next();case 2:if(c.done){F.g=4;break;}return a=c.value,b="third_party/mediapipe/modules/face_detection/"+a,D(F,l(d.g,a),5);case 5:I=F.h,d.g.overrideFile(b,I),c=t.next(),F.g=2;break;case 4:return g.url=u==="short"?"face_detection_short.binarypb":"face_detection_full.binarypb",n.graphOptionXref.calculatorName=u==="short"?"facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator":"facedetectionfullrangegpu__facedetectionfullrangecommon__TensorsToDetectionsCalculator",F.return(!0);}});}},minDetectionConfidence:n}});}r=J.prototype,r.close=function(){return this.g.close(),Promise.resolve();},r.onResults=function(o){this.g.onResults(o);},r.initialize=function(){var o=this;return yt(function(d){return D(d,o.g.initialize(),0);});},r.reset=function(){this.g.reset();},r.send=function(o){var d=this;return yt(function(g){return D(g,d.g.send(o),0);});},r.setOptions=function(o){this.g.setOptions(o);},Lt("FaceDetection",J),Lt("FACEDETECTION_LIPS",z),Lt("FACEDETECTION_LEFT_EYE",P),Lt("FACEDETECTION_LEFT_EYEBROW",A),Lt("FACEDETECTION_RIGHT_EYE",q),Lt("FACEDETECTION_RIGHT_EYEBROW",ot),Lt("FACEDETECTION_FACE_OVAL",s),Lt("FACEDETECTION_CONTOURS",X),Lt("FACEDETECTION_TESSELATION",[[127,34],[34,139],[139,127],[11,0],[0,37],[37,11],[232,231],[231,120],[120,232],[72,37],[37,39],[39,72],[128,121],[121,47],[47,128],[232,121],[121,128],[128,232],[104,69],[69,67],[67,104],[175,171],[171,148],[148,175],[118,50],[50,101],[101,118],[73,39],[39,40],[40,73],[9,151],[151,108],[108,9],[48,115],[115,131],[131,48],[194,204],[204,211],[211,194],[74,40],[40,185],[185,74],[80,42],[42,183],[183,80],[40,92],[92,186],[186,40],[230,229],[229,118],[118,230],[202,212],[212,214],[214,202],[83,18],[18,17],[17,83],[76,61],[61,146],[146,76],[160,29],[29,30],[30,160],[56,157],[157,173],[173,56],[106,204],[204,194],[194,106],[135,214],[214,192],[192,135],[203,165],[165,98],[98,203],[21,71],[71,68],[68,21],[51,45],[45,4],[4,51],[144,24],[24,23],[23,144],[77,146],[146,91],[91,77],[205,50],[50,187],[187,205],[201,200],[200,18],[18,201],[91,106],[106,182],[182,91],[90,91],[91,181],[181,90],[85,84],[84,17],[17,85],[206,203],[203,36],[36,206],[148,171],[171,140],[140,148],[92,40],[40,39],[39,92],[193,189],[189,244],[244,193],[159,158],[158,28],[28,159],[247,246],[246,161],[161,247],[236,3],[3,196],[196,236],[54,68],[68,104],[104,54],[193,168],[168,8],[8,193],[117,228],[228,31],[31,117],[189,193],[193,55],[55,189],[98,97],[97,99],[99,98],[126,47],[47,100],[100,126],[166,79],[79,218],[218,166],[155,154],[154,26],[26,155],[209,49],[49,131],[131,209],[135,136],[136,150],[150,135],[47,126],[126,217],[217,47],[223,52],[52,53],[53,223],[45,51],[51,134],[134,45],[211,170],[170,140],[140,211],[67,69],[69,108],[108,67],[43,106],[106,91],[91,43],[230,119],[119,120],[120,230],[226,130],[130,247],[247,226],[63,53],[53,52],[52,63],[238,20],[20,242],[242,238],[46,70],[70,156],[156,46],[78,62],[62,96],[96,78],[46,53],[53,63],[63,46],[143,34],[34,227],[227,143],[123,117],[117,111],[111,123],[44,125],[125,19],[19,44],[236,134],[134,51],[51,236],[216,206],[206,205],[205,216],[154,153],[153,22],[22,154],[39,37],[37,167],[167,39],[200,201],[201,208],[208,200],[36,142],[142,100],[100,36],[57,212],[212,202],[202,57],[20,60],[60,99],[99,20],[28,158],[158,157],[157,28],[35,226],[226,113],[113,35],[160,159],[159,27],[27,160],[204,202],[202,210],[210,204],[113,225],[225,46],[46,113],[43,202],[202,204],[204,43],[62,76],[76,77],[77,62],[137,123],[123,116],[116,137],[41,38],[38,72],[72,41],[203,129],[129,142],[142,203],[64,98],[98,240],[240,64],[49,102],[102,64],[64,49],[41,73],[73,74],[74,41],[212,216],[216,207],[207,212],[42,74],[74,184],[184,42],[169,170],[170,211],[211,169],[170,149],[149,176],[176,170],[105,66],[66,69],[69,105],[122,6],[6,168],[168,122],[123,147],[147,187],[187,123],[96,77],[77,90],[90,96],[65,55],[55,107],[107,65],[89,90],[90,180],[180,89],[101,100],[100,120],[120,101],[63,105],[105,104],[104,63],[93,137],[137,227],[227,93],[15,86],[86,85],[85,15],[129,102],[102,49],[49,129],[14,87],[87,86],[86,14],[55,8],[8,9],[9,55],[100,47],[47,121],[121,100],[145,23],[23,22],[22,145],[88,89],[89,179],[179,88],[6,122],[122,196],[196,6],[88,95],[95,96],[96,88],[138,172],[172,136],[136,138],[215,58],[58,172],[172,215],[115,48],[48,219],[219,115],[42,80],[80,81],[81,42],[195,3],[3,51],[51,195],[43,146],[146,61],[61,43],[171,175],[175,199],[199,171],[81,82],[82,38],[38,81],[53,46],[46,225],[225,53],[144,163],[163,110],[110,144],[52,65],[65,66],[66,52],[229,228],[228,117],[117,229],[34,127],[127,234],[234,34],[107,108],[108,69],[69,107],[109,108],[108,151],[151,109],[48,64],[64,235],[235,48],[62,78],[78,191],[191,62],[129,209],[209,126],[126,129],[111,35],[35,143],[143,111],[117,123],[123,50],[50,117],[222,65],[65,52],[52,222],[19,125],[125,141],[141,19],[221,55],[55,65],[65,221],[3,195],[195,197],[197,3],[25,7],[7,33],[33,25],[220,237],[237,44],[44,220],[70,71],[71,139],[139,70],[122,193],[193,245],[245,122],[247,130],[130,33],[33,247],[71,21],[21,162],[162,71],[170,169],[169,150],[150,170],[188,174],[174,196],[196,188],[216,186],[186,92],[92,216],[2,97],[97,167],[167,2],[141,125],[125,241],[241,141],[164,167],[167,37],[37,164],[72,38],[38,12],[12,72],[38,82],[82,13],[13,38],[63,68],[68,71],[71,63],[226,35],[35,111],[111,226],[101,50],[50,205],[205,101],[206,92],[92,165],[165,206],[209,198],[198,217],[217,209],[165,167],[167,97],[97,165],[220,115],[115,218],[218,220],[133,112],[112,243],[243,133],[239,238],[238,241],[241,239],[214,135],[135,169],[169,214],[190,173],[173,133],[133,190],[171,208],[208,32],[32,171],[125,44],[44,237],[237,125],[86,87],[87,178],[178,86],[85,86],[86,179],[179,85],[84,85],[85,180],[180,84],[83,84],[84,181],[181,83],[201,83],[83,182],[182,201],[137,93],[93,132],[132,137],[76,62],[62,183],[183,76],[61,76],[76,184],[184,61],[57,61],[61,185],[185,57],[212,57],[57,186],[186,212],[214,207],[207,187],[187,214],[34,143],[143,156],[156,34],[79,239],[239,237],[237,79],[123,137],[137,177],[177,123],[44,1],[1,4],[4,44],[201,194],[194,32],[32,201],[64,102],[102,129],[129,64],[213,215],[215,138],[138,213],[59,166],[166,219],[219,59],[242,99],[99,97],[97,242],[2,94],[94,141],[141,2],[75,59],[59,235],[235,75],[24,110],[110,228],[228,24],[25,130],[130,226],[226,25],[23,24],[24,229],[229,23],[22,23],[23,230],[230,22],[26,22],[22,231],[231,26],[112,26],[26,232],[232,112],[189,190],[190,243],[243,189],[221,56],[56,190],[190,221],[28,56],[56,221],[221,28],[27,28],[28,222],[222,27],[29,27],[27,223],[223,29],[30,29],[29,224],[224,30],[247,30],[30,225],[225,247],[238,79],[79,20],[20,238],[166,59],[59,75],[75,166],[60,75],[75,240],[240,60],[147,177],[177,215],[215,147],[20,79],[79,166],[166,20],[187,147],[147,213],[213,187],[112,233],[233,244],[244,112],[233,128],[128,245],[245,233],[128,114],[114,188],[188,128],[114,217],[217,174],[174,114],[131,115],[115,220],[220,131],[217,198],[198,236],[236,217],[198,131],[131,134],[134,198],[177,132],[132,58],[58,177],[143,35],[35,124],[124,143],[110,163],[163,7],[7,110],[228,110],[110,25],[25,228],[356,389],[389,368],[368,356],[11,302],[302,267],[267,11],[452,350],[350,349],[349,452],[302,303],[303,269],[269,302],[357,343],[343,277],[277,357],[452,453],[453,357],[357,452],[333,332],[332,297],[297,333],[175,152],[152,377],[377,175],[347,348],[348,330],[330,347],[303,304],[304,270],[270,303],[9,336],[336,337],[337,9],[278,279],[279,360],[360,278],[418,262],[262,431],[431,418],[304,408],[408,409],[409,304],[310,415],[415,407],[407,310],[270,409],[409,410],[410,270],[450,348],[348,347],[347,450],[422,430],[430,434],[434,422],[313,314],[314,17],[17,313],[306,307],[307,375],[375,306],[387,388],[388,260],[260,387],[286,414],[414,398],[398,286],[335,406],[406,418],[418,335],[364,367],[367,416],[416,364],[423,358],[358,327],[327,423],[251,284],[284,298],[298,251],[281,5],[5,4],[4,281],[373,374],[374,253],[253,373],[307,320],[320,321],[321,307],[425,427],[427,411],[411,425],[421,313],[313,18],[18,421],[321,405],[405,406],[406,321],[320,404],[404,405],[405,320],[315,16],[16,17],[17,315],[426,425],[425,266],[266,426],[377,400],[400,369],[369,377],[322,391],[391,269],[269,322],[417,465],[465,464],[464,417],[386,257],[257,258],[258,386],[466,260],[260,388],[388,466],[456,399],[399,419],[419,456],[284,332],[332,333],[333,284],[417,285],[285,8],[8,417],[346,340],[340,261],[261,346],[413,441],[441,285],[285,413],[327,460],[460,328],[328,327],[355,371],[371,329],[329,355],[392,439],[439,438],[438,392],[382,341],[341,256],[256,382],[429,420],[420,360],[360,429],[364,394],[394,379],[379,364],[277,343],[343,437],[437,277],[443,444],[444,283],[283,443],[275,440],[440,363],[363,275],[431,262],[262,369],[369,431],[297,338],[338,337],[337,297],[273,375],[375,321],[321,273],[450,451],[451,349],[349,450],[446,342],[342,467],[467,446],[293,334],[334,282],[282,293],[458,461],[461,462],[462,458],[276,353],[353,383],[383,276],[308,324],[324,325],[325,308],[276,300],[300,293],[293,276],[372,345],[345,447],[447,372],[352,345],[345,340],[340,352],[274,1],[1,19],[19,274],[456,248],[248,281],[281,456],[436,427],[427,425],[425,436],[381,256],[256,252],[252,381],[269,391],[391,393],[393,269],[200,199],[199,428],[428,200],[266,330],[330,329],[329,266],[287,273],[273,422],[422,287],[250,462],[462,328],[328,250],[258,286],[286,384],[384,258],[265,353],[353,342],[342,265],[387,259],[259,257],[257,387],[424,431],[431,430],[430,424],[342,353],[353,276],[276,342],[273,335],[335,424],[424,273],[292,325],[325,307],[307,292],[366,447],[447,345],[345,366],[271,303],[303,302],[302,271],[423,266],[266,371],[371,423],[294,455],[455,460],[460,294],[279,278],[278,294],[294,279],[271,272],[272,304],[304,271],[432,434],[434,427],[427,432],[272,407],[407,408],[408,272],[394,430],[430,431],[431,394],[395,369],[369,400],[400,395],[334,333],[333,299],[299,334],[351,417],[417,168],[168,351],[352,280],[280,411],[411,352],[325,319],[319,320],[320,325],[295,296],[296,336],[336,295],[319,403],[403,404],[404,319],[330,348],[348,349],[349,330],[293,298],[298,333],[333,293],[323,454],[454,447],[447,323],[15,16],[16,315],[315,15],[358,429],[429,279],[279,358],[14,15],[15,316],[316,14],[285,336],[336,9],[9,285],[329,349],[349,350],[350,329],[374,380],[380,252],[252,374],[318,402],[402,403],[403,318],[6,197],[197,419],[419,6],[318,319],[319,325],[325,318],[367,364],[364,365],[365,367],[435,367],[367,397],[397,435],[344,438],[438,439],[439,344],[272,271],[271,311],[311,272],[195,5],[5,281],[281,195],[273,287],[287,291],[291,273],[396,428],[428,199],[199,396],[311,271],[271,268],[268,311],[283,444],[444,445],[445,283],[373,254],[254,339],[339,373],[282,334],[334,296],[296,282],[449,347],[347,346],[346,449],[264,447],[447,454],[454,264],[336,296],[296,299],[299,336],[338,10],[10,151],[151,338],[278,439],[439,455],[455,278],[292,407],[407,415],[415,292],[358,371],[371,355],[355,358],[340,345],[345,372],[372,340],[346,347],[347,280],[280,346],[442,443],[443,282],[282,442],[19,94],[94,370],[370,19],[441,442],[442,295],[295,441],[248,419],[419,197],[197,248],[263,255],[255,359],[359,263],[440,275],[275,274],[274,440],[300,383],[383,368],[368,300],[351,412],[412,465],[465,351],[263,467],[467,466],[466,263],[301,368],[368,389],[389,301],[395,378],[378,379],[379,395],[412,351],[351,419],[419,412],[436,426],[426,322],[322,436],[2,164],[164,393],[393,2],[370,462],[462,461],[461,370],[164,0],[0,267],[267,164],[302,11],[11,12],[12,302],[268,12],[12,13],[13,268],[293,300],[300,301],[301,293],[446,261],[261,340],[340,446],[330,266],[266,425],[425,330],[426,423],[423,391],[391,426],[429,355],[355,437],[437,429],[391,327],[327,326],[326,391],[440,457],[457,438],[438,440],[341,382],[382,362],[362,341],[459,457],[457,461],[461,459],[434,430],[430,394],[394,434],[414,463],[463,362],[362,414],[396,369],[369,262],[262,396],[354,461],[461,457],[457,354],[316,403],[403,402],[402,316],[315,404],[404,403],[403,315],[314,405],[405,404],[404,314],[313,406],[406,405],[405,313],[421,418],[418,406],[406,421],[366,401],[401,361],[361,366],[306,408],[408,407],[407,306],[291,409],[409,408],[408,291],[287,410],[410,409],[409,287],[432,436],[436,410],[410,432],[434,416],[416,411],[411,434],[264,368],[368,383],[383,264],[309,438],[438,457],[457,309],[352,376],[376,401],[401,352],[274,275],[275,4],[4,274],[421,428],[428,262],[262,421],[294,327],[327,358],[358,294],[433,416],[416,367],[367,433],[289,455],[455,439],[439,289],[462,370],[370,326],[326,462],[2,326],[326,370],[370,2],[305,460],[460,455],[455,305],[254,449],[449,448],[448,254],[255,261],[261,446],[446,255],[253,450],[450,449],[449,253],[252,451],[451,450],[450,252],[256,452],[452,451],[451,256],[341,453],[453,452],[452,341],[413,464],[464,463],[463,413],[441,413],[413,414],[414,441],[258,442],[442,441],[441,258],[257,443],[443,442],[442,257],[259,444],[444,443],[443,259],[260,445],[445,444],[444,260],[467,342],[342,445],[445,467],[459,458],[458,250],[250,459],[289,392],[392,290],[290,289],[290,328],[328,460],[460,290],[376,433],[433,435],[435,376],[250,290],[290,392],[392,250],[411,416],[416,433],[433,411],[341,463],[463,464],[464,341],[453,464],[464,465],[465,453],[357,465],[465,412],[412,357],[343,412],[412,399],[399,343],[360,363],[363,440],[440,360],[437,399],[399,456],[456,437],[420,456],[456,363],[363,420],[401,435],[435,288],[288,401],[372,383],[383,353],[353,372],[339,255],[255,249],[249,339],[448,261],[261,255],[255,448],[133,243],[243,190],[190,133],[133,155],[155,112],[112,133],[33,246],[246,247],[247,33],[33,130],[130,25],[25,33],[398,384],[384,286],[286,398],[362,398],[398,414],[414,362],[362,463],[463,341],[341,362],[263,359],[359,467],[467,263],[263,249],[249,255],[255,263],[466,467],[467,260],[260,466],[75,60],[60,166],[166,75],[238,239],[239,79],[79,238],[162,127],[127,139],[139,162],[72,11],[11,37],[37,72],[121,232],[232,120],[120,121],[73,72],[72,39],[39,73],[114,128],[128,47],[47,114],[233,232],[232,128],[128,233],[103,104],[104,67],[67,103],[152,175],[175,148],[148,152],[119,118],[118,101],[101,119],[74,73],[73,40],[40,74],[107,9],[9,108],[108,107],[49,48],[48,131],[131,49],[32,194],[194,211],[211,32],[184,74],[74,185],[185,184],[191,80],[80,183],[183,191],[185,40],[40,186],[186,185],[119,230],[230,118],[118,119],[210,202],[202,214],[214,210],[84,83],[83,17],[17,84],[77,76],[76,146],[146,77],[161,160],[160,30],[30,161],[190,56],[56,173],[173,190],[182,106],[106,194],[194,182],[138,135],[135,192],[192,138],[129,203],[203,98],[98,129],[54,21],[21,68],[68,54],[5,51],[51,4],[4,5],[145,144],[144,23],[23,145],[90,77],[77,91],[91,90],[207,205],[205,187],[187,207],[83,201],[201,18],[18,83],[181,91],[91,182],[182,181],[180,90],[90,181],[181,180],[16,85],[85,17],[17,16],[205,206],[206,36],[36,205],[176,148],[148,140],[140,176],[165,92],[92,39],[39,165],[245,193],[193,244],[244,245],[27,159],[159,28],[28,27],[30,247],[247,161],[161,30],[174,236],[236,196],[196,174],[103,54],[54,104],[104,103],[55,193],[193,8],[8,55],[111,117],[117,31],[31,111],[221,189],[189,55],[55,221],[240,98],[98,99],[99,240],[142,126],[126,100],[100,142],[219,166],[166,218],[218,219],[112,155],[155,26],[26,112],[198,209],[209,131],[131,198],[169,135],[135,150],[150,169],[114,47],[47,217],[217,114],[224,223],[223,53],[53,224],[220,45],[45,134],[134,220],[32,211],[211,140],[140,32],[109,67],[67,108],[108,109],[146,43],[43,91],[91,146],[231,230],[230,120],[120,231],[113,226],[226,247],[247,113],[105,63],[63,52],[52,105],[241,238],[238,242],[242,241],[124,46],[46,156],[156,124],[95,78],[78,96],[96,95],[70,46],[46,63],[63,70],[116,143],[143,227],[227,116],[116,123],[123,111],[111,116],[1,44],[44,19],[19,1],[3,236],[236,51],[51,3],[207,216],[216,205],[205,207],[26,154],[154,22],[22,26],[165,39],[39,167],[167,165],[199,200],[200,208],[208,199],[101,36],[36,100],[100,101],[43,57],[57,202],[202,43],[242,20],[20,99],[99,242],[56,28],[28,157],[157,56],[124,35],[35,113],[113,124],[29,160],[160,27],[27,29],[211,204],[204,210],[210,211],[124,113],[113,46],[46,124],[106,43],[43,204],[204,106],[96,62],[62,77],[77,96],[227,137],[137,116],[116,227],[73,41],[41,72],[72,73],[36,203],[203,142],[142,36],[235,64],[64,240],[240,235],[48,49],[49,64],[64,48],[42,41],[41,74],[74,42],[214,212],[212,207],[207,214],[183,42],[42,184],[184,183],[210,169],[169,211],[211,210],[140,170],[170,176],[176,140],[104,105],[105,69],[69,104],[193,122],[122,168],[168,193],[50,123],[123,187],[187,50],[89,96],[96,90],[90,89],[66,65],[65,107],[107,66],[179,89],[89,180],[180,179],[119,101],[101,120],[120,119],[68,63],[63,104],[104,68],[234,93],[93,227],[227,234],[16,15],[15,85],[85,16],[209,129],[129,49],[49,209],[15,14],[14,86],[86,15],[107,55],[55,9],[9,107],[120,100],[100,121],[121,120],[153,145],[145,22],[22,153],[178,88],[88,179],[179,178],[197,6],[6,196],[196,197],[89,88],[88,96],[96,89],[135,138],[138,136],[136,135],[138,215],[215,172],[172,138],[218,115],[115,219],[219,218],[41,42],[42,81],[81,41],[5,195],[195,51],[51,5],[57,43],[43,61],[61,57],[208,171],[171,199],[199,208],[41,81],[81,38],[38,41],[224,53],[53,225],[225,224],[24,144],[144,110],[110,24],[105,52],[52,66],[66,105],[118,229],[229,117],[117,118],[227,34],[34,234],[234,227],[66,107],[107,69],[69,66],[10,109],[109,151],[151,10],[219,48],[48,235],[235,219],[183,62],[62,191],[191,183],[142,129],[129,126],[126,142],[116,111],[111,143],[143,116],[118,117],[117,50],[50,118],[223,222],[222,52],[52,223],[94,19],[19,141],[141,94],[222,221],[221,65],[65,222],[196,3],[3,197],[197,196],[45,220],[220,44],[44,45],[156,70],[70,139],[139,156],[188,122],[122,245],[245,188],[139,71],[71,162],[162,139],[149,170],[170,150],[150,149],[122,188],[188,196],[196,122],[206,216],[216,92],[92,206],[164,2],[2,167],[167,164],[242,141],[141,241],[241,242],[0,164],[164,37],[37,0],[11,72],[72,12],[12,11],[12,38],[38,13],[13,12],[70,63],[63,71],[71,70],[31,226],[226,111],[111,31],[36,101],[101,205],[205,36],[203,206],[206,165],[165,203],[126,209],[209,217],[217,126],[98,165],[165,97],[97,98],[237,220],[220,218],[218,237],[237,239],[239,241],[241,237],[210,214],[214,169],[169,210],[140,171],[171,32],[32,140],[241,125],[125,237],[237,241],[179,86],[86,178],[178,179],[180,85],[85,179],[179,180],[181,84],[84,180],[180,181],[182,83],[83,181],[181,182],[194,201],[201,182],[182,194],[177,137],[137,132],[132,177],[184,76],[76,183],[183,184],[185,61],[61,184],[184,185],[186,57],[57,185],[185,186],[216,212],[212,186],[186,216],[192,214],[214,187],[187,192],[139,34],[34,156],[156,139],[218,79],[79,237],[237,218],[147,123],[123,177],[177,147],[45,44],[44,4],[4,45],[208,201],[201,32],[32,208],[98,64],[64,129],[129,98],[192,213],[213,138],[138,192],[235,59],[59,219],[219,235],[141,242],[242,97],[97,141],[97,2],[2,141],[141,97],[240,75],[75,235],[235,240],[229,24],[24,228],[228,229],[31,25],[25,226],[226,31],[230,23],[23,229],[229,230],[231,22],[22,230],[230,231],[232,26],[26,231],[231,232],[233,112],[112,232],[232,233],[244,189],[189,243],[243,244],[189,221],[221,190],[190,189],[222,28],[28,221],[221,222],[223,27],[27,222],[222,223],[224,29],[29,223],[223,224],[225,30],[30,224],[224,225],[113,247],[247,225],[225,113],[99,60],[60,240],[240,99],[213,147],[147,215],[215,213],[60,20],[20,166],[166,60],[192,187],[187,213],[213,192],[243,112],[112,244],[244,243],[244,233],[233,245],[245,244],[245,128],[128,188],[188,245],[188,114],[114,174],[174,188],[134,131],[131,220],[220,134],[174,217],[217,236],[236,174],[236,198],[198,134],[134,236],[215,177],[177,58],[58,215],[156,143],[143,124],[124,156],[25,110],[110,7],[7,25],[31,228],[228,25],[25,31],[264,356],[356,368],[368,264],[0,11],[11,267],[267,0],[451,452],[452,349],[349,451],[267,302],[302,269],[269,267],[350,357],[357,277],[277,350],[350,452],[452,357],[357,350],[299,333],[333,297],[297,299],[396,175],[175,377],[377,396],[280,347],[347,330],[330,280],[269,303],[303,270],[270,269],[151,9],[9,337],[337,151],[344,278],[278,360],[360,344],[424,418],[418,431],[431,424],[270,304],[304,409],[409,270],[272,310],[310,407],[407,272],[322,270],[270,410],[410,322],[449,450],[450,347],[347,449],[432,422],[422,434],[434,432],[18,313],[313,17],[17,18],[291,306],[306,375],[375,291],[259,387],[387,260],[260,259],[424,335],[335,418],[418,424],[434,364],[364,416],[416,434],[391,423],[423,327],[327,391],[301,251],[251,298],[298,301],[275,281],[281,4],[4,275],[254,373],[373,253],[253,254],[375,307],[307,321],[321,375],[280,425],[425,411],[411,280],[200,421],[421,18],[18,200],[335,321],[321,406],[406,335],[321,320],[320,405],[405,321],[314,315],[315,17],[17,314],[423,426],[426,266],[266,423],[396,377],[377,369],[369,396],[270,322],[322,269],[269,270],[413,417],[417,464],[464,413],[385,386],[386,258],[258,385],[248,456],[456,419],[419,248],[298,284],[284,333],[333,298],[168,417],[417,8],[8,168],[448,346],[346,261],[261,448],[417,413],[413,285],[285,417],[326,327],[327,328],[328,326],[277,355],[355,329],[329,277],[309,392],[392,438],[438,309],[381,382],[382,256],[256,381],[279,429],[429,360],[360,279],[365,364],[364,379],[379,365],[355,277],[277,437],[437,355],[282,443],[443,283],[283,282],[281,275],[275,363],[363,281],[395,431],[431,369],[369,395],[299,297],[297,337],[337,299],[335,273],[273,321],[321,335],[348,450],[450,349],[349,348],[359,446],[446,467],[467,359],[283,293],[293,282],[282,283],[250,458],[458,462],[462,250],[300,276],[276,383],[383,300],[292,308],[308,325],[325,292],[283,276],[276,293],[293,283],[264,372],[372,447],[447,264],[346,352],[352,340],[340,346],[354,274],[274,19],[19,354],[363,456],[456,281],[281,363],[426,436],[436,425],[425,426],[380,381],[381,252],[252,380],[267,269],[269,393],[393,267],[421,200],[200,428],[428,421],[371,266],[266,329],[329,371],[432,287],[287,422],[422,432],[290,250],[250,328],[328,290],[385,258],[258,384],[384,385],[446,265],[265,342],[342,446],[386,387],[387,257],[257,386],[422,424],[424,430],[430,422],[445,342],[342,276],[276,445],[422,273],[273,424],[424,422],[306,292],[292,307],[307,306],[352,366],[366,345],[345,352],[268,271],[271,302],[302,268],[358,423],[423,371],[371,358],[327,294],[294,460],[460,327],[331,279],[279,294],[294,331],[303,271],[271,304],[304,303],[436,432],[432,427],[427,436],[304,272],[272,408],[408,304],[395,394],[394,431],[431,395],[378,395],[395,400],[400,378],[296,334],[334,299],[299,296],[6,351],[351,168],[168,6],[376,352],[352,411],[411,376],[307,325],[325,320],[320,307],[285,295],[295,336],[336,285],[320,319],[319,404],[404,320],[329,330],[330,349],[349,329],[334,293],[293,333],[333,334],[366,323],[323,447],[447,366],[316,15],[15,315],[315,316],[331,358],[358,279],[279,331],[317,14],[14,316],[316,317],[8,285],[285,9],[9,8],[277,329],[329,350],[350,277],[253,374],[374,252],[252,253],[319,318],[318,403],[403,319],[351,6],[6,419],[419,351],[324,318],[318,325],[325,324],[397,367],[367,365],[365,397],[288,435],[435,397],[397,288],[278,344],[344,439],[439,278],[310,272],[272,311],[311,310],[248,195],[195,281],[281,248],[375,273],[273,291],[291,375],[175,396],[396,199],[199,175],[312,311],[311,268],[268,312],[276,283],[283,445],[445,276],[390,373],[373,339],[339,390],[295,282],[282,296],[296,295],[448,449],[449,346],[346,448],[356,264],[264,454],[454,356],[337,336],[336,299],[299,337],[337,338],[338,151],[151,337],[294,278],[278,455],[455,294],[308,292],[292,415],[415,308],[429,358],[358,355],[355,429],[265,340],[340,372],[372,265],[352,346],[346,280],[280,352],[295,442],[442,282],[282,295],[354,19],[19,370],[370,354],[285,441],[441,295],[295,285],[195,248],[248,197],[197,195],[457,440],[440,274],[274,457],[301,300],[300,368],[368,301],[417,351],[351,465],[465,417],[251,301],[301,389],[389,251],[394,395],[395,379],[379,394],[399,412],[412,419],[419,399],[410,436],[436,322],[322,410],[326,2],[2,393],[393,326],[354,370],[370,461],[461,354],[393,164],[164,267],[267,393],[268,302],[302,12],[12,268],[312,268],[268,13],[13,312],[298,293],[293,301],[301,298],[265,446],[446,340],[340,265],[280,330],[330,425],[425,280],[322,426],[426,391],[391,322],[420,429],[429,437],[437,420],[393,391],[391,326],[326,393],[344,440],[440,438],[438,344],[458,459],[459,461],[461,458],[364,434],[434,394],[394,364],[428,396],[396,262],[262,428],[274,354],[354,457],[457,274],[317,316],[316,402],[402,317],[316,315],[315,403],[403,316],[315,314],[314,404],[404,315],[314,313],[313,405],[405,314],[313,421],[421,406],[406,313],[323,366],[366,361],[361,323],[292,306],[306,407],[407,292],[306,291],[291,408],[408,306],[291,287],[287,409],[409,291],[287,432],[432,410],[410,287],[427,434],[434,411],[411,427],[372,264],[264,383],[383,372],[459,309],[309,457],[457,459],[366,352],[352,401],[401,366],[1,274],[274,4],[4,1],[418,421],[421,262],[262,418],[331,294],[294,358],[358,331],[435,433],[433,367],[367,435],[392,289],[289,439],[439,392],[328,462],[462,326],[326,328],[94,2],[2,370],[370,94],[289,305],[305,455],[455,289],[339,254],[254,448],[448,339],[359,255],[255,446],[446,359],[254,253],[253,449],[449,254],[253,252],[252,450],[450,253],[252,256],[256,451],[451,252],[256,341],[341,452],[452,256],[414,413],[413,463],[463,414],[286,441],[441,414],[414,286],[286,258],[258,441],[441,286],[258,257],[257,442],[442,258],[257,259],[259,443],[443,257],[259,260],[260,444],[444,259],[260,467],[467,445],[445,260],[309,459],[459,250],[250,309],[305,289],[289,290],[290,305],[305,290],[290,460],[460,305],[401,376],[376,435],[435,401],[309,250],[250,392],[392,309],[376,411],[411,433],[433,376],[453,341],[341,464],[464,453],[357,453],[453,465],[465,357],[343,357],[357,412],[412,343],[437,343],[343,399],[399,437],[344,360],[360,440],[440,344],[420,437],[437,456],[456,420],[360,420],[420,363],[363,360],[361,401],[401,288],[288,361],[265,372],[372,353],[353,265],[390,339],[339,249],[249,390],[339,448],[448,255],[255,339]]),Lt("VERSION","0.4.1646425229");}).call(Ii);const Si={};(function(){var r;function e(h){var y=0;return function(){return y<h.length?{done:!1,value:h[y++]}:{done:!0};};}var i=typeof Object.defineProperties=="function"?Object.defineProperty:function(h,y,G){return h==Array.prototype||h==Object.prototype||(h[y]=G.value),h;};function m(h){h=[typeof globalThis=="object"&&globalThis,h,typeof window=="object"&&window,typeof self=="object"&&self,typeof (typeof window !== undefined ? window : global)=="object"&&(typeof window !== undefined ? window : global)];for(var y=0;y<h.length;++y){var G=h[y];if(G&&G.Math==Math)return G;}throw Error("Cannot find global object");}var v=m(this);function S(h,y){if(y)t:{var G=v;h=h.split(".");for(var C=0;C<h.length-1;C++){var z=h[C];if(!(z in G))break t;G=G[z];}h=h[h.length-1],C=G[h],y=y(C),y!=C&&y!=null&&i(G,h,{configurable:!0,writable:!0,value:y});}}S("Symbol",function(h){function y(P){if(this instanceof y)throw new TypeError("Symbol is not a constructor");return new G(C+(P||"")+"_"+z++,P);}function G(P,A){this.g=P,i(this,"description",{configurable:!0,writable:!0,value:A});}if(h)return h;G.prototype.toString=function(){return this.g;};var C="jscomp_symbol_"+(1e9*Math.random()>>>0)+"_",z=0;return y;}),S("Symbol.iterator",function(h){if(h)return h;h=Symbol("Symbol.iterator");for(var y="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),G=0;G<y.length;G++){var C=v[y[G]];typeof C=="function"&&typeof C.prototype[h]!="function"&&i(C.prototype,h,{configurable:!0,writable:!0,value:function value(){return L(e(this));}});}return h;});function L(h){return h={next:h},h[Symbol.iterator]=function(){return this;},h;}function T(h){var y=typeof Symbol<"u"&&Symbol.iterator&&h[Symbol.iterator];return y?y.call(h):{next:e(h)};}function k(h){if(!(h instanceof Array)){h=T(h);for(var y,G=[];!(y=h.next()).done;)G.push(y.value);h=G;}return h;}var tt=typeof Object.create=="function"?Object.create:function(h){function y(){}return y.prototype=h,new y();},st;if(typeof Object.setPrototypeOf=="function")st=Object.setPrototypeOf;else{var bt;t:{var xt={a:!0},Yt={};try{Yt.__proto__=xt,bt=Yt.a;break t;}catch(_unused8){}bt=!1;}st=bt?function(h,y){if(h.__proto__=y,h.__proto__!==y)throw new TypeError(h+" is not extensible");return h;}:null;}var at=st;function ht(h,y){if(h.prototype=tt(y.prototype),h.prototype.constructor=h,at)at(h,y);else for(var G in y)if(G!="prototype")if(Object.defineProperties){var C=Object.getOwnPropertyDescriptor(y,G);C&&Object.defineProperty(h,G,C);}else h[G]=y[G];h.ea=y.prototype;}function Ut(){this.l=!1,this.i=null,this.h=void 0,this.g=1,this.s=this.m=0,this.j=null;}function Mt(h){if(h.l)throw new TypeError("Generator is already running");h.l=!0;}Ut.prototype.o=function(h){this.h=h;};function oe(h,y){h.j={U:y,V:!0},h.g=h.m||h.s;}Ut.prototype.return=function(h){this.j={return:h},this.g=this.s;};function D(h,y,G){return h.g=G,{value:y};}function hn(h){this.g=new Ut(),this.h=h;}function bn(h,y){Mt(h.g);var G=h.g.i;return G?ge(h,"return"in G?G.return:function(C){return{value:C,done:!0};},y,h.g.return):(h.g.return(y),Kt(h));}function ge(h,y,G,C){try{var z=y.call(h.g.i,G);if(!(z instanceof Object))throw new TypeError("Iterator result "+z+" is not an object");if(!z.done)return h.g.l=!1,z;var P=z.value;}catch(A){return h.g.i=null,oe(h.g,A),Kt(h);}return h.g.i=null,C.call(h.g,P),Kt(h);}function Kt(h){for(;h.g.g;)try{var y=h.h(h.g);if(y)return h.g.l=!1,{value:y.value,done:!1};}catch(G){h.g.h=void 0,oe(h.g,G);}if(h.g.l=!1,h.g.j){if(y=h.g.j,h.g.j=null,y.V)throw y.U;return{value:y.return,done:!0};}return{value:void 0,done:!0};}function jn(h){this.next=function(y){return Mt(h.g),h.g.i?y=ge(h,h.g.i.next,y,h.g.o):(h.g.o(y),y=Kt(h)),y;},this.throw=function(y){return Mt(h.g),h.g.i?y=ge(h,h.g.i.throw,y,h.g.o):(oe(h.g,y),y=Kt(h)),y;},this.return=function(y){return bn(h,y);},this[Symbol.iterator]=function(){return this;};}function ue(h,y){return y=new jn(new hn(y)),at&&h.prototype&&at(y,h.prototype),y;}function yt(h,y){h instanceof String&&(h+="");var G=0,C=!1,z={next:function next(){if(!C&&G<h.length){var P=G++;return{value:y(P,h[P]),done:!1};}return C=!0,{done:!0,value:void 0};}};return z[Symbol.iterator]=function(){return z;},z;}var Kn=typeof Object.assign=="function"?Object.assign:function(h,y){for(var G=1;G<arguments.length;G++){var C=arguments[G];if(C)for(var z in C)Object.prototype.hasOwnProperty.call(C,z)&&(h[z]=C[z]);}return h;};S("Object.assign",function(h){return h||Kn;}),S("Promise",function(h){function y(A){this.h=0,this.i=void 0,this.g=[],this.o=!1;var q=this.j();try{A(q.resolve,q.reject);}catch(ot){q.reject(ot);}}function G(){this.g=null;}function C(A){return A instanceof y?A:new y(function(q){q(A);});}if(h)return h;G.prototype.h=function(A){if(this.g==null){this.g=[];var q=this;this.i(function(){q.l();});}this.g.push(A);};var z=v.setTimeout;G.prototype.i=function(A){z(A,0);},G.prototype.l=function(){for(;this.g&&this.g.length;){var A=this.g;this.g=[];for(var q=0;q<A.length;++q){var ot=A[q];A[q]=null;try{ot();}catch(s){this.j(s);}}}this.g=null;},G.prototype.j=function(A){this.i(function(){throw A;});},y.prototype.j=function(){function A(s){return function(X){ot||(ot=!0,s.call(q,X));};}var q=this,ot=!1;return{resolve:A(this.C),reject:A(this.l)};},y.prototype.C=function(A){if(A===this)this.l(new TypeError("A Promise cannot resolve to itself"));else if(A instanceof y)this.F(A);else{t:switch(typeof A){case"object":var q=A!=null;break t;case"function":q=!0;break t;default:q=!1;}q?this.u(A):this.m(A);}},y.prototype.u=function(A){var q=void 0;try{q=A.then;}catch(ot){this.l(ot);return;}typeof q=="function"?this.G(q,A):this.m(A);},y.prototype.l=function(A){this.s(2,A);},y.prototype.m=function(A){this.s(1,A);},y.prototype.s=function(A,q){if(this.h!=0)throw Error("Cannot settle("+A+", "+q+"): Promise already settled in state"+this.h);this.h=A,this.i=q,this.h===2&&this.D(),this.A();},y.prototype.D=function(){var A=this;z(function(){if(A.B()){var q=v.console;typeof q<"u"&&q.error(A.i);}},1);},y.prototype.B=function(){if(this.o)return!1;var A=v.CustomEvent,q=v.Event,ot=v.dispatchEvent;return typeof ot>"u"?!0:(typeof A=="function"?A=new A("unhandledrejection",{cancelable:!0}):typeof q=="function"?A=new q("unhandledrejection",{cancelable:!0}):(A=v.document.createEvent("CustomEvent"),A.initCustomEvent("unhandledrejection",!1,!0,A)),A.promise=this,A.reason=this.i,ot(A));},y.prototype.A=function(){if(this.g!=null){for(var A=0;A<this.g.length;++A)P.h(this.g[A]);this.g=null;}};var P=new G();return y.prototype.F=function(A){var q=this.j();A.J(q.resolve,q.reject);},y.prototype.G=function(A,q){var ot=this.j();try{A.call(q,ot.resolve,ot.reject);}catch(s){ot.reject(s);}},y.prototype.then=function(A,q){function ot(w,N){return typeof w=="function"?function(B){try{s(w(B));}catch(M){X(M);}}:N;}var s,X,R=new y(function(w,N){s=w,X=N;});return this.J(ot(A,s),ot(q,X)),R;},y.prototype.catch=function(A){return this.then(void 0,A);},y.prototype.J=function(A,q){function ot(){switch(s.h){case 1:A(s.i);break;case 2:q(s.i);break;default:throw Error("Unexpected state: "+s.h);}}var s=this;this.g==null?P.h(ot):this.g.push(ot),this.o=!0;},y.resolve=C,y.reject=function(A){return new y(function(q,ot){ot(A);});},y.race=function(A){return new y(function(q,ot){for(var s=T(A),X=s.next();!X.done;X=s.next())C(X.value).J(q,ot);});},y.all=function(A){var q=T(A),ot=q.next();return ot.done?C([]):new y(function(s,X){function R(B){return function(M){w[B]=M,N--,N==0&&s(w);};}var w=[],N=0;do w.push(void 0),N++,C(ot.value).J(R(w.length-1),X),ot=q.next();while(!ot.done);});},y;}),S("Object.is",function(h){return h||function(y,G){return y===G?y!==0||1/y===1/G:y!==y&&G!==G;};}),S("Array.prototype.includes",function(h){return h||function(y,G){var C=this;C instanceof String&&(C=String(C));var z=C.length;for(G=G||0,0>G&&(G=Math.max(G+z,0));G<z;G++){var P=C[G];if(P===y||Object.is(P,y))return!0;}return!1;};}),S("String.prototype.includes",function(h){return h||function(y,G){if(this==null)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(y instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return this.indexOf(y,G||0)!==-1;};}),S("Array.prototype.keys",function(h){return h||function(){return yt(this,function(y){return y;});};});var On=this||self;function Xe(h,y){h=h.split(".");var G=On;h[0]in G||typeof G.execScript>"u"||G.execScript("var "+h[0]);for(var C;h.length&&(C=h.shift());)h.length||y===void 0?G[C]&&G[C]!==Object.prototype[C]?G=G[C]:G=G[C]={}:G[C]=y;}function Lt(h,y){return y=String.fromCharCode.apply(null,y),h==null?y:h+y;}var Ye,nn=typeof TextDecoder<"u",yn,Yn=typeof TextEncoder<"u";function Vn(h){if(Yn)h=(yn||(yn=new TextEncoder())).encode(h);else{var y=void 0;y=y===void 0?!1:y;for(var G=0,C=new Uint8Array(3*h.length),z=0;z<h.length;z++){var P=h.charCodeAt(z);if(128>P)C[G++]=P;else{if(2048>P)C[G++]=P>>6|192;else{if(55296<=P&&57343>=P){if(56319>=P&&z<h.length){var A=h.charCodeAt(++z);if(56320<=A&&57343>=A){P=1024*(P-55296)+A-56320+65536,C[G++]=P>>18|240,C[G++]=P>>12&63|128,C[G++]=P>>6&63|128,C[G++]=P&63|128;continue;}else z--;}if(y)throw Error("Found an unpaired surrogate");P=65533;}C[G++]=P>>12|224,C[G++]=P>>6&63|128;}C[G++]=P&63|128;}}h=C.subarray(0,G);}return h;}var Ln={},rn=null;function un(h,y){y===void 0&&(y=0),gn(),y=Ln[y];for(var G=Array(Math.floor(h.length/3)),C=y[64]||"",z=0,P=0;z<h.length-2;z+=3){var A=h[z],q=h[z+1],ot=h[z+2],s=y[A>>2];A=y[(A&3)<<4|q>>4],q=y[(q&15)<<2|ot>>6],ot=y[ot&63],G[P++]=s+A+q+ot;}switch(s=0,ot=C,h.length-z){case 2:s=h[z+1],ot=y[(s&15)<<2]||C;case 1:h=h[z],G[P]=y[h>>2]+y[(h&3)<<4|s>>4]+ot+C;}return G.join("");}function Jn(h){var y=h.length,G=3*y/4;G%3?G=Math.floor(G):"=.".indexOf(h[y-1])!=-1&&(G="=.".indexOf(h[y-2])!=-1?G-2:G-1);var C=new Uint8Array(G),z=0;return wn(h,function(P){C[z++]=P;}),C.subarray(0,z);}function wn(h,y){function G(ot){for(;C<h.length;){var s=h.charAt(C++),X=rn[s];if(X!=null)return X;if(!/^[\s\xa0]*$/.test(s))throw Error("Unknown base64 encoding at char: "+s);}return ot;}gn();for(var C=0;;){var z=G(-1),P=G(0),A=G(64),q=G(64);if(q===64&&z===-1)break;y(z<<2|P>>4),A!=64&&(y(P<<4&240|A>>2),q!=64&&y(A<<6&192|q));}}function gn(){if(!rn){rn={};for(var h="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),y=["+/=","+/","-_=","-_.","-_"],G=0;5>G;G++){var C=h.concat(y[G].split(""));Ln[G]=C;for(var z=0;z<C.length;z++){var P=C[z];rn[P]===void 0&&(rn[P]=z);}}}}var on=typeof Uint8Array.prototype.slice=="function",Rn;function Zn(h,y,G){return y===G?Rn||(Rn=new Uint8Array(0)):on?h.slice(y,G):new Uint8Array(h.subarray(y,G));}var be=0,We=0;function Pe(h,y){y=y===void 0?{}:y,y=y.v===void 0?!1:y.v,this.h=null,this.g=this.j=this.l=0,this.m=!1,this.v=y,h&&pe(this,h);}function pe(h,y){y=y.constructor===Uint8Array?y:y.constructor===ArrayBuffer?new Uint8Array(y):y.constructor===Array?new Uint8Array(y):y.constructor===String?Jn(y):y instanceof Uint8Array?new Uint8Array(y.buffer,y.byteOffset,y.byteLength):new Uint8Array(0),h.h=y,h.l=0,h.j=h.h.length,h.g=h.l;}Pe.prototype.reset=function(){this.g=this.l;};function ye(h){for(var y=128,G=0,C=0,z=0;4>z&&128<=y;z++)y=h.h[h.g++],G|=(y&127)<<7*z;if(128<=y&&(y=h.h[h.g++],G|=(y&127)<<28,C|=(y&127)>>4),128<=y)for(z=0;5>z&&128<=y;z++)y=h.h[h.g++],C|=(y&127)<<7*z+3;if(128>y)return h=G>>>0,y=C>>>0,(C=y&2147483648)&&(h=~h+1>>>0,y=~y>>>0,h==0&&(y=y+1>>>0)),h=4294967296*y+(h>>>0),C?-h:h;h.m=!0;}Pe.prototype.i=function(){var h=this.h,y=h[this.g],G=y&127;return 128>y?(this.g+=1,G):(y=h[this.g+1],G|=(y&127)<<7,128>y?(this.g+=2,G):(y=h[this.g+2],G|=(y&127)<<14,128>y?(this.g+=3,G):(y=h[this.g+3],G|=(y&127)<<21,128>y?(this.g+=4,G):(y=h[this.g+4],G|=(y&15)<<28,128>y?(this.g+=5,G>>>0):(this.g+=5,128<=h[this.g++]&&128<=h[this.g++]&&128<=h[this.g++]&&128<=h[this.g++]&&this.g++,G)))));},Pe.prototype.o=function(){var h=this.h[this.g],y=this.h[this.g+1],G=this.h[this.g+2],C=this.h[this.g+3];return this.g+=4,G=(h<<0|y<<8|G<<16|C<<24)>>>0,h=2*(G>>31)+1,y=G>>>23&255,G&=8388607,y==255?G?NaN:1/0*h:y==0?h*Math.pow(2,-149)*G:h*Math.pow(2,y-150)*(G+Math.pow(2,23));};var De=[];function Ce(){this.g=new Uint8Array(64),this.h=0;}Ce.prototype.push=function(h){if(!(this.h+1<this.g.length)){var y=this.g;this.g=new Uint8Array(Math.ceil(1+2*this.g.length)),this.g.set(y);}this.g[this.h++]=h;},Ce.prototype.length=function(){return this.h;},Ce.prototype.end=function(){var h=this.g,y=this.h;return this.h=0,Zn(h,0,y);};function Pt(h,y){for(;127<y;)h.push(y&127|128),y>>>=7;h.push(y);}function de(h){var y={},G=y.N===void 0?!1:y.N;this.o={v:y.v===void 0?!1:y.v},this.N=G,y=this.o,De.length?(G=De.pop(),y&&(G.v=y.v),h&&pe(G,h),h=G):h=new Pe(h,y),this.g=h,this.m=this.g.g,this.h=this.i=this.l=-1,this.j=!1;}de.prototype.reset=function(){this.g.reset(),this.h=this.l=-1;};function we(h){var y=h.g;if((y=y.g==y.j)||(y=h.j)||(y=h.g,y=y.m||0>y.g||y.g>y.j),y)return!1;h.m=h.g.g,y=h.g.i();var G=y&7;return G!=0&&G!=5&&G!=1&&G!=2&&G!=3&&G!=4?(h.j=!0,!1):(h.i=y,h.l=y>>>3,h.h=G,!0);}function Jt(h){switch(h.h){case 0:if(h.h!=0)Jt(h);else{for(h=h.g;h.h[h.g]&128;)h.g++;h.g++;}break;case 1:h.h!=1?Jt(h):(h=h.g,h.g+=8);break;case 2:if(h.h!=2)Jt(h);else{var y=h.g.i();h=h.g,h.g+=y;}break;case 5:h.h!=5?Jt(h):(h=h.g,h.g+=4);break;case 3:y=h.l;do{if(!we(h)){h.j=!0;break;}if(h.h==4){h.l!=y&&(h.j=!0);break;}Jt(h);}while(!0);break;default:h.j=!0;}}function Ze(h,y,G){var C=h.g.j,z=h.g.i(),P=h.g.g+z;if(h.g.j=P,G(y,h),G=P-h.g.g,G!==0)throw Error("Message parsing ended unexpectedly. Expected to read "+z+" bytes, instead read "+(z-G)+" bytes, either the data ended unexpectedly or the message misreported its own length");return h.g.g=P,h.g.j=C,y;}function _t(h){return h.g.o();}function ae(h){var y=h.g.i();h=h.g;var G=h.g;h.g+=y,h=h.h;var C;if(nn)(C=Ye)||(C=Ye=new TextDecoder("utf-8",{fatal:!1})),C=C.decode(h.subarray(G,G+y));else{y=G+y;for(var z=[],P=null,A,q,ot;G<y;)A=h[G++],128>A?z.push(A):224>A?G>=y?z.push(65533):(q=h[G++],194>A||(q&192)!==128?(G--,z.push(65533)):z.push((A&31)<<6|q&63)):240>A?G>=y-1?z.push(65533):(q=h[G++],(q&192)!==128||A===224&&160>q||A===237&&160<=q||((C=h[G++])&192)!==128?(G--,z.push(65533)):z.push((A&15)<<12|(q&63)<<6|C&63)):244>=A?G>=y-2?z.push(65533):(q=h[G++],(q&192)!==128||(A<<28)+(q-144)>>30||((C=h[G++])&192)!==128||((ot=h[G++])&192)!==128?(G--,z.push(65533)):(A=(A&7)<<18|(q&63)<<12|(C&63)<<6|ot&63,A-=65536,z.push((A>>10&1023)+55296,(A&1023)+56320))):z.push(65533),8192<=z.length&&(P=Lt(P,z),z.length=0);C=Lt(P,z);}return C;}function xe(h,y,G){var C=h.g.i();for(C=h.g.g+C;h.g.g<C;)G.push(y.call(h.g));}function _e(h,y){h.h==2?xe(h,Pe.prototype.o,y):y.push(_t(h));}function me(){this.h=[],this.i=0,this.g=new Ce();}function zt(h,y){y.length!==0&&(h.h.push(y),h.i+=y.length);}function Je(h){var y=h.i+h.g.length();if(y===0)return new Uint8Array(0);y=new Uint8Array(y);for(var G=h.h,C=G.length,z=0,P=0;P<C;P++){var A=G[P];A.length!==0&&(y.set(A,z),z+=A.length);}return G=h.g,C=G.h,C!==0&&(y.set(G.g.subarray(0,C),z),G.h=0),h.h=[y],y;}function Ae(h,y,G){if(G!=null){Pt(h.g,8*y+5),h=h.g;var C=G;C=(G=0>C?1:0)?-C:C,C===0?0<1/C?be=We=0:(We=0,be=2147483648):isNaN(C)?(We=0,be=2147483647):34028234663852886e22<C?(We=0,be=(G<<31|2139095040)>>>0):11754943508222875e-54>C?(C=Math.round(C/Math.pow(2,-149)),We=0,be=(G<<31|C)>>>0):(y=Math.floor(Math.log(C)/Math.LN2),C*=Math.pow(2,-y),C=Math.round(8388608*C),16777216<=C&&++y,We=0,be=(G<<31|y+127<<23|C&8388607)>>>0),G=be,h.push(G>>>0&255),h.push(G>>>8&255),h.push(G>>>16&255),h.push(G>>>24&255);}}var ve=typeof Uint8Array=="function";function Sn(h,y,G){if(h!=null)return typeof h=="object"?ve&&h instanceof Uint8Array?G(h):$e(h,y,G):y(h);}function $e(h,y,G){if(Array.isArray(h)){for(var C=Array(h.length),z=0;z<h.length;z++)C[z]=Sn(h[z],y,G);return Array.isArray(h)&&h.W&&he(C),C;}C={};for(z in h)C[z]=Sn(h[z],y,G);return C;}function an(h){return typeof h=="number"?isFinite(h)?h:String(h):h;}var fn={W:{value:!0,configurable:!0}};function he(h){return Array.isArray(h)&&!Object.isFrozen(h)&&Object.defineProperties(h,fn),h;}var Ie;function fe(h,y,G){var C=Ie;Ie=null,h||(h=C),C=this.constructor.ca,h||(h=C?[C]:[]),this.j=C?0:-1,this.m=this.g=null,this.h=h;t:{if(C=this.h.length,h=C-1,C&&(C=this.h[h],!(C===null||typeof C!="object"||Array.isArray(C)||ve&&C instanceof Uint8Array))){this.l=h-this.j,this.i=C;break t;}y!==void 0&&-1<y?(this.l=Math.max(y,h+1-this.j),this.i=null):this.l=Number.MAX_VALUE;}if(G)for(y=0;y<G.length;y++)h=G[y],h<this.l?(h+=this.j,(C=this.h[h])?he(C):this.h[h]=ee):(Be(this),(C=this.i[h])?he(C):this.i[h]=ee);}var ee=Object.freeze(he([]));function Be(h){var y=h.l+h.j;h.h[y]||(h.i=h.h[y]={});}function Qt(h,y,G){return y===-1?null:G!==void 0&&G||y>=h.l?h.i?h.i[y]:void 0:h.h[y+h.j];}function At(h,y){var G=G===void 0?!1:G,C=Qt(h,y,G);return C==null&&(C=ee),C===ee&&(C=he([]),Wt(h,y,C,G)),C;}function vn(h){var y=At(h,3);if(h.m||(h.m={}),!h.m[3]){for(var G=0;G<y.length;G++)y[G]=+y[G];h.m[3]=!0;}return y;}function se(h,y,G){var _h;return h=Qt(h,y),(_h=h)!=null?_h:G;}function Ft(h,y,G){var _h2;return h=Qt(h,y),h=h==null?h:+h,(_h2=h)!=null?_h2:G===void 0?0:G;}function Wt(h,y,G,C){C!==void 0&&C||y>=h.l?(Be(h),h.i[y]=G):h.h[y+h.j]=G;}function ne(h,y,G){if(G===-1)return null;if(h.g||(h.g={}),!h.g[G]){var C=Qt(h,G,!1);C&&(h.g[G]=new y(C));}return h.g[G];}function He(h,y){h.g||(h.g={});var G=h.g[1];if(!G){var C=At(h,1);G=[];for(var z=0;z<C.length;z++)G[z]=new y(C[z]);h.g[1]=G;}return G;}function Dt(h,y,G){var C=C===void 0?!1:C;h.g||(h.g={});var z=G&&Ne(G);h.g[y]=G,Wt(h,y,z,C);}function re(h,y,G,C){var z=He(h,G);y=y||new G(),h=At(h,1),C!=null?(z.splice(C,0,y),h.splice(C,0,Ne(y))):(z.push(y),h.push(Ne(y)));}fe.prototype.toJSON=function(){var h=Ne(this);return $e(h,an,un);};function Ne(h,y){if(h.g)for(var G in h.g){var C=h.g[G];if(Array.isArray(C))for(var z=0;z<C.length;z++)C[z]&&Ne(C[z]);else C&&Ne(C);}return h.h;}fe.prototype.toString=function(){return Ne(this).toString();};function Bt(h,y){if(h=h.o){zt(y,y.g.end());for(var G=0;G<h.length;G++)zt(y,h[G]);}}function It(h,y){if(y.h==4)return!1;var G=y.m;return Jt(y),y.N||(y=Zn(y.g.h,G,y.g.g),(G=h.o)?G.push(y):h.o=[y]),!0;}function je(h){fe.call(this,h,-1,Fe);}ht(je,fe),je.prototype.getRows=function(){return Qt(this,1);},je.prototype.getCols=function(){return Qt(this,2);},je.prototype.getPackedDataList=function(){return vn(this);},je.prototype.getLayout=function(){return se(this,4,0);};function Ke(h,y){for(;we(y);)switch(y.i){case 8:var G=y.g.i();Wt(h,1,G);break;case 16:G=y.g.i(),Wt(h,2,G);break;case 29:case 26:_e(y,h.getPackedDataList());break;case 32:G=ye(y.g),Wt(h,4,G);break;default:if(!It(h,y))return h;}return h;}var Fe=[3];function Ot(h,y){var G=void 0;return new(G||(G=Promise))(function(C,z){function P(ot){try{q(y.next(ot));}catch(s){z(s);}}function A(ot){try{q(y.throw(ot));}catch(s){z(s);}}function q(ot){ot.done?C(ot.value):new G(function(s){s(ot.value);}).then(P,A);}q((y=y.apply(h,void 0)).next());});}function ke(h){fe.call(this,h);}ht(ke,fe);function mn(h,y){for(;we(y);)switch(y.i){case 8:var G=y.g.i();Wt(h,1,G);break;case 21:G=_t(y),Wt(h,2,G);break;case 26:G=ae(y),Wt(h,3,G);break;case 34:G=ae(y),Wt(h,4,G);break;default:if(!It(h,y))return h;}return h;}function qe(h){fe.call(this,h,-1,Ue);}ht(qe,fe),qe.prototype.addClassification=function(h,y){return re(this,h,ke,y),this;};var Ue=[1];function Qe(h){fe.call(this,h);}ht(Qe,fe);function tn(h,y){for(;we(y);)switch(y.i){case 13:var G=_t(y);Wt(h,1,G);break;case 21:G=_t(y),Wt(h,2,G);break;case 29:G=_t(y),Wt(h,3,G);break;case 37:G=_t(y),Wt(h,4,G);break;case 45:G=_t(y),Wt(h,5,G);break;default:if(!It(h,y))return h;}return h;}function Ge(h){fe.call(this,h,-1,kn);}ht(Ge,fe);function Ee(h){t:{var y=new Ge();for(h=new de(h);we(h);)switch(h.i){case 10:var G=Ze(h,new Qe(),tn);re(y,G,Qe,void 0);break;default:if(!It(y,h))break t;}}return y;}var kn=[1];function Me(h){fe.call(this,h);}ht(Me,fe);function Ve(h){fe.call(this,h,-1,pn);}ht(Ve,fe),Ve.prototype.getVertexType=function(){return se(this,1,0);},Ve.prototype.getPrimitiveType=function(){return se(this,2,0);},Ve.prototype.getVertexBufferList=function(){return vn(this);},Ve.prototype.getIndexBufferList=function(){return At(this,4);};function sn(h,y){for(;we(y);)switch(y.i){case 8:var G=ye(y.g);Wt(h,1,G);break;case 16:G=ye(y.g),Wt(h,2,G);break;case 29:case 26:_e(y,h.getVertexBufferList());break;case 32:case 34:G=y;var C=h.getIndexBufferList();G.h==2?xe(G,Pe.prototype.i,C):C.push(G.g.i());break;default:if(!It(h,y))return h;}return h;}var pn=[3,4];function Le(h){fe.call(this,h);}ht(Le,fe),Le.prototype.getMesh=function(){return ne(this,Ve,1);},Le.prototype.getPoseTransformMatrix=function(){return ne(this,je,2);};function Fn(h){t:{var y=new Le();for(h=new de(h);we(h);)switch(h.i){case 10:var G=Ze(h,new Ve(),sn);Dt(y,1,G);break;case 18:G=Ze(h,new je(),Ke),Dt(y,2,G);break;default:if(!It(y,h))break t;}}return y;}function ze(h,y,G){if(G=h.createShader(G===0?h.VERTEX_SHADER:h.FRAGMENT_SHADER),h.shaderSource(G,y),h.compileShader(G),!h.getShaderParameter(G,h.COMPILE_STATUS))throw Error(`Could not compile WebGL shader.

`+h.getShaderInfoLog(G));return G;}function ln(h){return He(h,ke).map(function(y){return{index:se(y,1,0),Y:Ft(y,2),label:Qt(y,3)!=null?se(y,3,""):void 0,displayName:Qt(y,4)!=null?se(y,4,""):void 0};});}function Gn(h){return{x:Ft(h,1),y:Ft(h,2),z:Ft(h,3),visibility:Qt(h,4)!=null?Ft(h,4):void 0};}function Hn(h,y){this.h=h,this.g=y,this.l=0;}function Oe(h,y,G){return Xn(h,y),typeof h.g.canvas.transferToImageBitmap=="function"?Promise.resolve(h.g.canvas.transferToImageBitmap()):G?Promise.resolve(h.g.canvas):typeof createImageBitmap=="function"?createImageBitmap(h.g.canvas):(h.i===void 0&&(h.i=document.createElement("canvas")),new Promise(function(C){h.i.height=h.g.canvas.height,h.i.width=h.g.canvas.width,h.i.getContext("2d",{}).drawImage(h.g.canvas,0,0,h.g.canvas.width,h.g.canvas.height),C(h.i);}));}function Xn(h,y){var G=h.g;if(h.m===void 0){var C=ze(G,`
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`,0),z=ze(G,`
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`,1),P=G.createProgram();if(G.attachShader(P,C),G.attachShader(P,z),G.linkProgram(P),!G.getProgramParameter(P,G.LINK_STATUS))throw Error(`Could not compile WebGL program.

`+G.getProgramInfoLog(P));C=h.m=P,G.useProgram(C),z=G.getUniformLocation(C,"sampler0"),h.j={I:G.getAttribLocation(C,"aVertex"),H:G.getAttribLocation(C,"aTex"),da:z},h.s=G.createBuffer(),G.bindBuffer(G.ARRAY_BUFFER,h.s),G.enableVertexAttribArray(h.j.I),G.vertexAttribPointer(h.j.I,2,G.FLOAT,!1,0,0),G.bufferData(G.ARRAY_BUFFER,new Float32Array([-1,-1,-1,1,1,1,1,-1]),G.STATIC_DRAW),G.bindBuffer(G.ARRAY_BUFFER,null),h.o=G.createBuffer(),G.bindBuffer(G.ARRAY_BUFFER,h.o),G.enableVertexAttribArray(h.j.H),G.vertexAttribPointer(h.j.H,2,G.FLOAT,!1,0,0),G.bufferData(G.ARRAY_BUFFER,new Float32Array([0,1,0,0,1,0,1,1]),G.STATIC_DRAW),G.bindBuffer(G.ARRAY_BUFFER,null),G.uniform1i(z,0);}C=h.j,G.useProgram(h.m),G.canvas.width=y.width,G.canvas.height=y.height,G.viewport(0,0,y.width,y.height),G.activeTexture(G.TEXTURE0),h.h.bindTexture2d(y.glName),G.enableVertexAttribArray(C.I),G.bindBuffer(G.ARRAY_BUFFER,h.s),G.vertexAttribPointer(C.I,2,G.FLOAT,!1,0,0),G.enableVertexAttribArray(C.H),G.bindBuffer(G.ARRAY_BUFFER,h.o),G.vertexAttribPointer(C.H,2,G.FLOAT,!1,0,0),G.bindFramebuffer(G.DRAW_FRAMEBUFFER?G.DRAW_FRAMEBUFFER:G.FRAMEBUFFER,null),G.clearColor(0,0,0,0),G.clear(G.COLOR_BUFFER_BIT),G.colorMask(!0,!0,!0,!0),G.drawArrays(G.TRIANGLE_FAN,0,4),G.disableVertexAttribArray(C.I),G.disableVertexAttribArray(C.H),G.bindBuffer(G.ARRAY_BUFFER,null),h.h.bindTexture2d(0);}function An(h){this.g=h;}var Bn=new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,10,9,1,7,0,65,0,253,15,26,11]);function Wn(h,y){return y+h;}function xn(h,y){window[h]=y;}function p(h){var y=document.createElement("script");return y.setAttribute("src",h),y.setAttribute("crossorigin","anonymous"),new Promise(function(G){y.addEventListener("load",function(){G();},!1),y.addEventListener("error",function(){G();},!1),document.body.appendChild(y);});}function W(){return Ot(this,function h(){return ue(h,function(y){switch(y.g){case 1:return y.m=2,D(y,WebAssembly.instantiate(Bn),4);case 4:y.g=3,y.m=0;break;case 2:return y.m=0,y.j=null,y.return(!1);case 3:return y.return(!0);}});});}function V(h){if(this.g=h,this.listeners={},this.j={},this.F={},this.m={},this.s={},this.G=this.o=this.R=!0,this.C=Promise.resolve(),this.P="",this.B={},this.locateFile=h&&h.locateFile||Wn,typeof window=="object")var y=window.location.pathname.toString().substring(0,window.location.pathname.toString().lastIndexOf("/"))+"/";else if(typeof location<"u")y=location.pathname.toString().substring(0,location.pathname.toString().lastIndexOf("/"))+"/";else throw Error("solutions can only be loaded on a web page or in a web worker");if(this.S=y,h.options){y=T(Object.keys(h.options));for(var G=y.next();!G.done;G=y.next()){G=G.value;var C=h.options[G].default;C!==void 0&&(this.j[G]=typeof C=="function"?C():C);}}}r=V.prototype,r.close=function(){return this.i&&this.i.delete(),Promise.resolve();};function U(h,y){return h.g.files===void 0?[]:typeof h.g.files=="function"?h.g.files(y):h.g.files;}function O(h){return Ot(h,function y(){var G=this,C,z,P,A,q,ot,s,X,R,w,N;return ue(y,function(B){switch(B.g){case 1:return C=G,G.R?(z=U(G,G.j),D(B,W(),2)):B.return();case 2:if(P=B.h,typeof window=="object")return xn("createMediapipeSolutionsWasm",{locateFile:G.locateFile}),xn("createMediapipeSolutionsPackedAssets",{locateFile:G.locateFile}),ot=z.filter(function(M){return M.data!==void 0;}),s=z.filter(function(M){return M.data===void 0;}),X=Promise.all(ot.map(function(M){var et=nt(C,M.url);if(M.path!==void 0){var $=M.path;et=et.then(function(ft){return C.overrideFile($,ft),Promise.resolve(ft);});}return et;})),R=Promise.all(s.map(function(M){return M.simd===void 0||M.simd&&P||!M.simd&&!P?p(C.locateFile(M.url,C.S)):Promise.resolve();})).then(function(){return Ot(C,function M(){var et,$,ft=this;return ue(M,function(gt){if(gt.g==1)return et=window.createMediapipeSolutionsWasm,$=window.createMediapipeSolutionsPackedAssets,D(gt,et($),2);ft.h=gt.h,gt.g=0;});});}),w=function(){return Ot(C,function M(){var et=this;return ue(M,function($){return et.g.graph&&et.g.graph.url?$=D($,nt(et,et.g.graph.url),0):($.g=0,$=void 0),$;});});}(),D(B,Promise.all([R,X,w]),7);if(typeof importScripts!="function")throw Error("solutions can only be loaded on a web page or in a web worker");return A=z.filter(function(M){return M.simd===void 0||M.simd&&P||!M.simd&&!P;}).map(function(M){return C.locateFile(M.url,C.S);}),importScripts.apply(null,k(A)),D(B,createMediapipeSolutionsWasm(Module),6);case 6:G.h=B.h,G.l=new OffscreenCanvas(1,1),G.h.canvas=G.l,q=G.h.GL.createContext(G.l,{antialias:!1,alpha:!1,ba:typeof WebGL2RenderingContext<"u"?2:1}),G.h.GL.makeContextCurrent(q),B.g=4;break;case 7:if(G.l=document.createElement("canvas"),N=G.l.getContext("webgl2",{}),!N&&(N=G.l.getContext("webgl",{}),!N))return alert("Failed to create WebGL canvas context when passing video frame."),B.return();G.D=N,G.h.canvas=G.l,G.h.createContext(G.l,!0,!0,{});case 4:G.i=new G.h.SolutionWasm(),G.R=!1,B.g=0;}});});}function rt(h){return Ot(h,function y(){var G=this,C,z,P,A,q,ot,s,X;return ue(y,function(R){if(R.g==1){if(G.g.graph&&G.g.graph.url&&G.P===G.g.graph.url)return R.return();if(G.o=!0,!G.g.graph||!G.g.graph.url){R.g=2;return;}return G.P=G.g.graph.url,D(R,nt(G,G.g.graph.url),3);}for(R.g!=2&&(C=R.h,G.i.loadGraph(C)),z=T(Object.keys(G.B)),P=z.next();!P.done;P=z.next())A=P.value,G.i.overrideFile(A,G.B[A]);if(G.B={},G.g.listeners)for(q=T(G.g.listeners),ot=q.next();!ot.done;ot=q.next())s=ot.value,Ct(G,s);X=G.j,G.j={},G.setOptions(X),R.g=0;});});}r.reset=function(){return Ot(this,function h(){var y=this;return ue(h,function(G){y.i&&(y.i.reset(),y.m={},y.s={}),G.g=0;});});},r.setOptions=function(h,y){var G=this;if(y=y||this.g.options){for(var C=[],z=[],P={},A=T(Object.keys(h)),q=A.next();!q.done;P={K:P.K,L:P.L},q=A.next()){var ot=q.value;ot in this.j&&this.j[ot]===h[ot]||(this.j[ot]=h[ot],q=y[ot],q!==void 0&&(q.onChange&&(P.K=q.onChange,P.L=h[ot],C.push(/* @__PURE__ */function(s){return function(){return Ot(G,function X(){var R,w=this;return ue(X,function(N){if(N.g==1)return D(N,s.K(s.L),2);R=N.h,R===!0&&(w.o=!0),N.g=0;});});};}(P))),q.graphOptionXref&&(ot={valueNumber:q.type===1?h[ot]:0,valueBoolean:q.type===0?h[ot]:!1,valueString:q.type===2?h[ot]:""},q=Object.assign(Object.assign(Object.assign({},{calculatorName:"",calculatorIndex:0}),q.graphOptionXref),ot),z.push(q))));}(C.length!==0||z.length!==0)&&(this.o=!0,this.A=(this.A===void 0?[]:this.A).concat(z),this.u=(this.u===void 0?[]:this.u).concat(C));}};function K(h){return Ot(h,function y(){var G=this,C,z,P,A,q,ot,s;return ue(y,function(X){switch(X.g){case 1:if(!G.o)return X.return();if(!G.u){X.g=2;break;}C=T(G.u),z=C.next();case 3:if(z.done){X.g=5;break;}return P=z.value,D(X,P(),4);case 4:z=C.next(),X.g=3;break;case 5:G.u=void 0;case 2:if(G.A){for(A=new G.h.GraphOptionChangeRequestList(),q=T(G.A),ot=q.next();!ot.done;ot=q.next())s=ot.value,A.push_back(s);G.i.changeOptions(A),A.delete(),G.A=void 0;}G.o=!1,X.g=0;}});});}r.initialize=function(){return Ot(this,function h(){var y=this;return ue(h,function(G){return G.g==1?D(G,O(y),2):G.g!=3?D(G,rt(y),3):D(G,K(y),0);});});};function nt(h,y){return Ot(h,function G(){var C=this,z,P;return ue(G,function(A){return y in C.F?A.return(C.F[y]):(z=C.locateFile(y,""),P=fetch(z).then(function(q){return q.arrayBuffer();}),C.F[y]=P,A.return(P));});});}r.overrideFile=function(h,y){this.i?this.i.overrideFile(h,y):this.B[h]=y;},r.clearOverriddenFiles=function(){this.B={},this.i&&this.i.clearOverriddenFiles();},r.send=function(h,y){return Ot(this,function G(){var C=this,z,P,A,q,ot,s,X,R,w;return ue(G,function(N){switch(N.g){case 1:return C.g.inputs?(z=1e3*(y!=null?y:performance.now()),D(N,C.C,2)):N.return();case 2:return D(N,C.initialize(),3);case 3:for(P=new C.h.PacketDataList(),A=T(Object.keys(h)),q=A.next();!q.done;q=A.next())if(ot=q.value,s=C.g.inputs[ot]){t:{var B=C,M=h[ot];switch(s.type){case"video":var et=B.m[s.stream];if(et||(et=new Hn(B.h,B.D),B.m[s.stream]=et),B=et,B.l===0&&(B.l=B.h.createTexture()),typeof HTMLVideoElement<"u"&&M instanceof HTMLVideoElement){var $=M.videoWidth;et=M.videoHeight;}else typeof HTMLImageElement<"u"&&M instanceof HTMLImageElement?($=M.naturalWidth,et=M.naturalHeight):($=M.width,et=M.height);et={glName:B.l,width:$,height:et},$=B.g,$.canvas.width=et.width,$.canvas.height=et.height,$.activeTexture($.TEXTURE0),B.h.bindTexture2d(B.l),$.texImage2D($.TEXTURE_2D,0,$.RGBA,$.RGBA,$.UNSIGNED_BYTE,M),B.h.bindTexture2d(0),B=et;break t;case"detections":for(et=B.m[s.stream],et||(et=new An(B.h),B.m[s.stream]=et),B=et,B.data||(B.data=new B.g.DetectionListData()),B.data.reset(M.length),et=0;et<M.length;++et){$=M[et];var ft=B.data,gt=ft.setBoundingBox,Nt=et,Gt=$.T,lt=new Me();Wt(lt,1,Gt.Z),Wt(lt,2,Gt.$),Wt(lt,3,Gt.height),Wt(lt,4,Gt.width),Wt(lt,5,Gt.rotation),Wt(lt,6,Gt.X);var Zt=Gt=new me();Ae(Zt,1,Qt(lt,1)),Ae(Zt,2,Qt(lt,2)),Ae(Zt,3,Qt(lt,3)),Ae(Zt,4,Qt(lt,4)),Ae(Zt,5,Qt(lt,5));var Xt=Qt(lt,6);if(Xt!=null&&Xt!=null){Pt(Zt.g,48);var Rt=Zt.g,St=Xt;Xt=0>St,St=Math.abs(St);var l=St>>>0;for(St=Math.floor((St-l)/4294967296),St>>>=0,Xt&&(St=~St>>>0,l=(~l>>>0)+1,4294967295<l&&(l=0,St++,4294967295<St&&(St=0))),be=l,We=St,Xt=be,l=We;0<l||127<Xt;)Rt.push(Xt&127|128),Xt=(Xt>>>7|l<<25)>>>0,l>>>=7;Rt.push(Xt);}if(Bt(lt,Zt),Gt=Je(Gt),gt.call(ft,Nt,Gt),$.O)for(ft=0;ft<$.O.length;++ft)lt=$.O[ft],Zt=!!lt.visibility,gt=B.data,Nt=gt.addNormalizedLandmark,Gt=et,lt=Object.assign(Object.assign({},lt),{visibility:Zt?lt.visibility:0}),Zt=new Qe(),Wt(Zt,1,lt.x),Wt(Zt,2,lt.y),Wt(Zt,3,lt.z),lt.visibility&&Wt(Zt,4,lt.visibility),Rt=lt=new me(),Ae(Rt,1,Qt(Zt,1)),Ae(Rt,2,Qt(Zt,2)),Ae(Rt,3,Qt(Zt,3)),Ae(Rt,4,Qt(Zt,4)),Ae(Rt,5,Qt(Zt,5)),Bt(Zt,Rt),lt=Je(lt),Nt.call(gt,Gt,lt);if($.M)for(ft=0;ft<$.M.length;++ft){if(gt=B.data,Nt=gt.addClassification,Gt=et,lt=$.M[ft],Zt=new ke(),Wt(Zt,2,lt.Y),lt.index&&Wt(Zt,1,lt.index),lt.label&&Wt(Zt,3,lt.label),lt.displayName&&Wt(Zt,4,lt.displayName),Rt=lt=new me(),l=Qt(Zt,1),l!=null&&l!=null)if(Pt(Rt.g,8),Xt=Rt.g,0<=l)Pt(Xt,l);else{for(St=0;9>St;St++)Xt.push(l&127|128),l>>=7;Xt.push(1);}Ae(Rt,2,Qt(Zt,2)),Xt=Qt(Zt,3),Xt!=null&&(Xt=Vn(Xt),Pt(Rt.g,26),Pt(Rt.g,Xt.length),zt(Rt,Rt.g.end()),zt(Rt,Xt)),Xt=Qt(Zt,4),Xt!=null&&(Xt=Vn(Xt),Pt(Rt.g,34),Pt(Rt.g,Xt.length),zt(Rt,Rt.g.end()),zt(Rt,Xt)),Bt(Zt,Rt),lt=Je(lt),Nt.call(gt,Gt,lt);}}B=B.data;break t;default:B={};}}switch(X=B,R=s.stream,s.type){case"video":P.pushTexture2d(Object.assign(Object.assign({},X),{stream:R,timestamp:z}));break;case"detections":w=X,w.stream=R,w.timestamp=z,P.pushDetectionList(w);break;default:throw Error("Unknown input config type: '"+s.type+"'");}}return C.i.send(P),D(N,C.C,4);case 4:P.delete(),N.g=0;}});});};function dt(h,y,G){return Ot(h,function C(){var z,P,A,q,ot,s,X=this,R,w,N,B,M,et,$,ft;return ue(C,function(gt){switch(gt.g){case 1:if(!G)return gt.return(y);for(z={},P=0,A=T(Object.keys(G)),q=A.next();!q.done;q=A.next())ot=q.value,s=G[ot],typeof s!="string"&&s.type==="texture"&&y[s.stream]!==void 0&&++P;1<P&&(X.G=!1),R=T(Object.keys(G)),q=R.next();case 2:if(q.done){gt.g=4;break;}if(w=q.value,N=G[w],typeof N=="string")return $=z,ft=w,D(gt,vt(X,w,y[N]),14);if(B=y[N.stream],N.type==="detection_list"){if(B){for(var Nt=B.getRectList(),Gt=B.getLandmarksList(),lt=B.getClassificationsList(),Zt=[],Xt=0;Xt<Nt.size();++Xt){var Rt=Nt.get(Xt);t:{var St=new Me();for(Rt=new de(Rt);we(Rt);)switch(Rt.i){case 13:var l=_t(Rt);Wt(St,1,l);break;case 21:l=_t(Rt),Wt(St,2,l);break;case 29:l=_t(Rt),Wt(St,3,l);break;case 37:l=_t(Rt),Wt(St,4,l);break;case 45:l=_t(Rt),Wt(St,5,l);break;case 48:l=ye(Rt.g),Wt(St,6,l);break;default:if(!It(St,Rt))break t;}}St={Z:Ft(St,1),$:Ft(St,2),height:Ft(St,3),width:Ft(St,4),rotation:Ft(St,5,0),X:se(St,6,0)},Rt=He(Ee(Gt.get(Xt)),Qe).map(Gn);var Z=lt.get(Xt);t:for(l=new qe(),Z=new de(Z);we(Z);)switch(Z.i){case 10:l.addClassification(Ze(Z,new ke(),mn));break;default:if(!It(l,Z))break t;}St={T:St,O:Rt,M:ln(l)},Zt.push(St);}Nt=Zt;}else Nt=[];z[w]=Nt,gt.g=7;break;}if(N.type==="proto_list"){if(B){for(Nt=Array(B.size()),Gt=0;Gt<B.size();Gt++)Nt[Gt]=B.get(Gt);B.delete();}else Nt=[];z[w]=Nt,gt.g=7;break;}if(B===void 0){gt.g=3;break;}if(N.type==="float_list"){z[w]=B,gt.g=7;break;}if(N.type==="proto"){z[w]=B,gt.g=7;break;}if(N.type!=="texture")throw Error("Unknown output config type: '"+N.type+"'");return M=X.s[w],M||(M=new Hn(X.h,X.D),X.s[w]=M),D(gt,Oe(M,B,X.G),13);case 13:et=gt.h,z[w]=et;case 7:N.transform&&z[w]&&(z[w]=N.transform(z[w])),gt.g=3;break;case 14:$[ft]=gt.h;case 3:q=R.next(),gt.g=2;break;case 4:return gt.return(z);}});});}function vt(h,y,G){return Ot(h,function C(){var z=this,P;return ue(C,function(A){return typeof G=="number"||G instanceof Uint8Array||G instanceof z.h.Uint8BlobList?A.return(G):G instanceof z.h.Texture2dDataOut?(P=z.s[y],P||(P=new Hn(z.h,z.D),z.s[y]=P),A.return(Oe(P,G,z.G))):A.return(void 0);});});}function Ct(h,y){for(var G=y.name||"$",C=[].concat(k(y.wants)),z=new h.h.StringList(),P=T(y.wants),A=P.next();!A.done;A=P.next())z.push_back(A.value);P=h.h.PacketListener.implement({onResults:function onResults(q){for(var ot={},s=0;s<y.wants.length;++s)ot[C[s]]=q.get(s);var X=h.listeners[G];X&&(h.C=dt(h,ot,y.outs).then(function(R){R=X(R);for(var w=0;w<y.wants.length;++w){var N=ot[C[w]];typeof N=="object"&&N.hasOwnProperty&&N.hasOwnProperty("delete")&&N.delete();}R&&(h.C=R);}));}}),h.i.attachMultiListener(z,P),z.delete();}r.onResults=function(h,y){this.listeners[y||"$"]=h;},Xe("Solution",V),Xe("OptionType",{BOOL:0,NUMBER:1,aa:2,0:"BOOL",1:"NUMBER",2:"STRING"});function Tt(h){h=Fn(h);var y=h.getMesh();if(!y)return h;var G=new Float32Array(y.getVertexBufferList());y.getVertexBufferList=function(){return G;};var C=new Uint32Array(y.getIndexBufferList());return y.getIndexBufferList=function(){return C;},h;}var jt={files:[{url:"face_mesh_solution_packed_assets_loader.js"},{simd:!0,url:"face_mesh_solution_simd_wasm_bin.js"},{simd:!1,url:"face_mesh_solution_wasm_bin.js"}],graph:{url:"face_mesh.binarypb"},listeners:[{wants:["multi_face_geometry","image_transformed","multi_face_landmarks"],outs:{image:"image_transformed",multiFaceGeometry:{type:"proto_list",stream:"multi_face_geometry",transform:function transform(h){return h.map(Tt);}},multiFaceLandmarks:{type:"proto_list",stream:"multi_face_landmarks",transform:function transform(h){return h.map(function(y){return He(Ee(y),Qe).map(Gn);});}}}}],inputs:{image:{type:"video",stream:"input_frames_gpu"}},options:{useCpuInference:{type:0,graphOptionXref:{calculatorType:"InferenceCalculator",fieldName:"use_cpu_inference"},default:"iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document},enableFaceGeometry:{type:0,graphOptionXref:{calculatorName:"EnableFaceGeometryConstant",calculatorType:"ConstantSidePacketCalculator",fieldName:"bool_value"}},selfieMode:{type:0,graphOptionXref:{calculatorType:"GlScalerCalculator",calculatorIndex:1,fieldName:"flip_horizontal"}},maxNumFaces:{type:1,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorNumFaces",fieldName:"int_value"}},refineLandmarks:{type:0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorRefineLandmarks",fieldName:"bool_value"}},minDetectionConfidence:{type:1,graphOptionXref:{calculatorType:"TensorsToDetectionsCalculator",calculatorName:"facelandmarkfrontgpu__facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator",fieldName:"min_score_thresh"}},minTrackingConfidence:{type:1,graphOptionXref:{calculatorType:"ThresholdingCalculator",calculatorName:"facelandmarkfrontgpu__facelandmarkgpu__ThresholdingCalculator",fieldName:"threshold"}},cameraNear:{type:1,graphOptionXref:{calculatorType:"FaceGeometryEnvGeneratorCalculator",fieldName:"near"}},cameraFar:{type:1,graphOptionXref:{calculatorType:"FaceGeometryEnvGeneratorCalculator",fieldName:"far"}},cameraVerticalFovDegrees:{type:1,graphOptionXref:{calculatorType:"FaceGeometryEnvGeneratorCalculator",fieldName:"vertical_fov_degrees"}}}},wt=[[61,146],[146,91],[91,181],[181,84],[84,17],[17,314],[314,405],[405,321],[321,375],[375,291],[61,185],[185,40],[40,39],[39,37],[37,0],[0,267],[267,269],[269,270],[270,409],[409,291],[78,95],[95,88],[88,178],[178,87],[87,14],[14,317],[317,402],[402,318],[318,324],[324,308],[78,191],[191,80],[80,81],[81,82],[82,13],[13,312],[312,311],[311,310],[310,415],[415,308]],Vt=[[263,249],[249,390],[390,373],[373,374],[374,380],[380,381],[381,382],[382,362],[263,466],[466,388],[388,387],[387,386],[386,385],[385,384],[384,398],[398,362]],Ht=[[276,283],[283,282],[282,295],[295,285],[300,293],[293,334],[334,296],[296,336]],Et=[[33,7],[7,163],[163,144],[144,145],[145,153],[153,154],[154,155],[155,133],[33,246],[246,161],[161,160],[160,159],[159,158],[158,157],[157,173],[173,133]],te=[[46,53],[53,52],[52,65],[65,55],[70,63],[63,105],[105,66],[66,107]],ie=[[10,338],[338,297],[297,332],[332,284],[284,251],[251,389],[389,356],[356,454],[454,323],[323,361],[361,288],[288,397],[397,365],[365,379],[379,378],[378,400],[400,377],[377,152],[152,148],[148,176],[176,149],[149,150],[150,136],[136,172],[172,58],[58,132],[132,93],[93,234],[234,127],[127,162],[162,21],[21,54],[54,103],[103,67],[67,109],[109,10]],le=[].concat(k(wt),k(Vt),k(Ht),k(Et),k(te),k(ie));function Re(h){h=h||{},h=Object.assign(Object.assign({},jt),h),this.g=new V(h);}r=Re.prototype,r.close=function(){return this.g.close(),Promise.resolve();},r.onResults=function(h){this.g.onResults(h);},r.initialize=function(){return Ot(this,function h(){var y=this;return ue(h,function(G){return D(G,y.g.initialize(),0);});});},r.reset=function(){this.g.reset();},r.send=function(h){return Ot(this,function y(){var G=this;return ue(y,function(C){return D(C,G.g.send(h),0);});});},r.setOptions=function(h){this.g.setOptions(h);},Xe("FACE_GEOMETRY",{Layout:{COLUMN_MAJOR:0,ROW_MAJOR:1,0:"COLUMN_MAJOR",1:"ROW_MAJOR"},PrimitiveType:{TRIANGLE:0,0:"TRIANGLE"},VertexType:{VERTEX_PT:0,0:"VERTEX_PT"},DEFAULT_CAMERA_PARAMS:{verticalFovDegrees:63,near:1,far:1e4}}),Xe("FaceMesh",Re),Xe("FACEMESH_LIPS",wt),Xe("FACEMESH_LEFT_EYE",Vt),Xe("FACEMESH_LEFT_EYEBROW",Ht),Xe("FACEMESH_LEFT_IRIS",[[474,475],[475,476],[476,477],[477,474]]),Xe("FACEMESH_RIGHT_EYE",Et),Xe("FACEMESH_RIGHT_EYEBROW",te),Xe("FACEMESH_RIGHT_IRIS",[[469,470],[470,471],[471,472],[472,469]]),Xe("FACEMESH_FACE_OVAL",ie),Xe("FACEMESH_CONTOURS",le),Xe("FACEMESH_TESSELATION",[[127,34],[34,139],[139,127],[11,0],[0,37],[37,11],[232,231],[231,120],[120,232],[72,37],[37,39],[39,72],[128,121],[121,47],[47,128],[232,121],[121,128],[128,232],[104,69],[69,67],[67,104],[175,171],[171,148],[148,175],[118,50],[50,101],[101,118],[73,39],[39,40],[40,73],[9,151],[151,108],[108,9],[48,115],[115,131],[131,48],[194,204],[204,211],[211,194],[74,40],[40,185],[185,74],[80,42],[42,183],[183,80],[40,92],[92,186],[186,40],[230,229],[229,118],[118,230],[202,212],[212,214],[214,202],[83,18],[18,17],[17,83],[76,61],[61,146],[146,76],[160,29],[29,30],[30,160],[56,157],[157,173],[173,56],[106,204],[204,194],[194,106],[135,214],[214,192],[192,135],[203,165],[165,98],[98,203],[21,71],[71,68],[68,21],[51,45],[45,4],[4,51],[144,24],[24,23],[23,144],[77,146],[146,91],[91,77],[205,50],[50,187],[187,205],[201,200],[200,18],[18,201],[91,106],[106,182],[182,91],[90,91],[91,181],[181,90],[85,84],[84,17],[17,85],[206,203],[203,36],[36,206],[148,171],[171,140],[140,148],[92,40],[40,39],[39,92],[193,189],[189,244],[244,193],[159,158],[158,28],[28,159],[247,246],[246,161],[161,247],[236,3],[3,196],[196,236],[54,68],[68,104],[104,54],[193,168],[168,8],[8,193],[117,228],[228,31],[31,117],[189,193],[193,55],[55,189],[98,97],[97,99],[99,98],[126,47],[47,100],[100,126],[166,79],[79,218],[218,166],[155,154],[154,26],[26,155],[209,49],[49,131],[131,209],[135,136],[136,150],[150,135],[47,126],[126,217],[217,47],[223,52],[52,53],[53,223],[45,51],[51,134],[134,45],[211,170],[170,140],[140,211],[67,69],[69,108],[108,67],[43,106],[106,91],[91,43],[230,119],[119,120],[120,230],[226,130],[130,247],[247,226],[63,53],[53,52],[52,63],[238,20],[20,242],[242,238],[46,70],[70,156],[156,46],[78,62],[62,96],[96,78],[46,53],[53,63],[63,46],[143,34],[34,227],[227,143],[123,117],[117,111],[111,123],[44,125],[125,19],[19,44],[236,134],[134,51],[51,236],[216,206],[206,205],[205,216],[154,153],[153,22],[22,154],[39,37],[37,167],[167,39],[200,201],[201,208],[208,200],[36,142],[142,100],[100,36],[57,212],[212,202],[202,57],[20,60],[60,99],[99,20],[28,158],[158,157],[157,28],[35,226],[226,113],[113,35],[160,159],[159,27],[27,160],[204,202],[202,210],[210,204],[113,225],[225,46],[46,113],[43,202],[202,204],[204,43],[62,76],[76,77],[77,62],[137,123],[123,116],[116,137],[41,38],[38,72],[72,41],[203,129],[129,142],[142,203],[64,98],[98,240],[240,64],[49,102],[102,64],[64,49],[41,73],[73,74],[74,41],[212,216],[216,207],[207,212],[42,74],[74,184],[184,42],[169,170],[170,211],[211,169],[170,149],[149,176],[176,170],[105,66],[66,69],[69,105],[122,6],[6,168],[168,122],[123,147],[147,187],[187,123],[96,77],[77,90],[90,96],[65,55],[55,107],[107,65],[89,90],[90,180],[180,89],[101,100],[100,120],[120,101],[63,105],[105,104],[104,63],[93,137],[137,227],[227,93],[15,86],[86,85],[85,15],[129,102],[102,49],[49,129],[14,87],[87,86],[86,14],[55,8],[8,9],[9,55],[100,47],[47,121],[121,100],[145,23],[23,22],[22,145],[88,89],[89,179],[179,88],[6,122],[122,196],[196,6],[88,95],[95,96],[96,88],[138,172],[172,136],[136,138],[215,58],[58,172],[172,215],[115,48],[48,219],[219,115],[42,80],[80,81],[81,42],[195,3],[3,51],[51,195],[43,146],[146,61],[61,43],[171,175],[175,199],[199,171],[81,82],[82,38],[38,81],[53,46],[46,225],[225,53],[144,163],[163,110],[110,144],[52,65],[65,66],[66,52],[229,228],[228,117],[117,229],[34,127],[127,234],[234,34],[107,108],[108,69],[69,107],[109,108],[108,151],[151,109],[48,64],[64,235],[235,48],[62,78],[78,191],[191,62],[129,209],[209,126],[126,129],[111,35],[35,143],[143,111],[117,123],[123,50],[50,117],[222,65],[65,52],[52,222],[19,125],[125,141],[141,19],[221,55],[55,65],[65,221],[3,195],[195,197],[197,3],[25,7],[7,33],[33,25],[220,237],[237,44],[44,220],[70,71],[71,139],[139,70],[122,193],[193,245],[245,122],[247,130],[130,33],[33,247],[71,21],[21,162],[162,71],[170,169],[169,150],[150,170],[188,174],[174,196],[196,188],[216,186],[186,92],[92,216],[2,97],[97,167],[167,2],[141,125],[125,241],[241,141],[164,167],[167,37],[37,164],[72,38],[38,12],[12,72],[38,82],[82,13],[13,38],[63,68],[68,71],[71,63],[226,35],[35,111],[111,226],[101,50],[50,205],[205,101],[206,92],[92,165],[165,206],[209,198],[198,217],[217,209],[165,167],[167,97],[97,165],[220,115],[115,218],[218,220],[133,112],[112,243],[243,133],[239,238],[238,241],[241,239],[214,135],[135,169],[169,214],[190,173],[173,133],[133,190],[171,208],[208,32],[32,171],[125,44],[44,237],[237,125],[86,87],[87,178],[178,86],[85,86],[86,179],[179,85],[84,85],[85,180],[180,84],[83,84],[84,181],[181,83],[201,83],[83,182],[182,201],[137,93],[93,132],[132,137],[76,62],[62,183],[183,76],[61,76],[76,184],[184,61],[57,61],[61,185],[185,57],[212,57],[57,186],[186,212],[214,207],[207,187],[187,214],[34,143],[143,156],[156,34],[79,239],[239,237],[237,79],[123,137],[137,177],[177,123],[44,1],[1,4],[4,44],[201,194],[194,32],[32,201],[64,102],[102,129],[129,64],[213,215],[215,138],[138,213],[59,166],[166,219],[219,59],[242,99],[99,97],[97,242],[2,94],[94,141],[141,2],[75,59],[59,235],[235,75],[24,110],[110,228],[228,24],[25,130],[130,226],[226,25],[23,24],[24,229],[229,23],[22,23],[23,230],[230,22],[26,22],[22,231],[231,26],[112,26],[26,232],[232,112],[189,190],[190,243],[243,189],[221,56],[56,190],[190,221],[28,56],[56,221],[221,28],[27,28],[28,222],[222,27],[29,27],[27,223],[223,29],[30,29],[29,224],[224,30],[247,30],[30,225],[225,247],[238,79],[79,20],[20,238],[166,59],[59,75],[75,166],[60,75],[75,240],[240,60],[147,177],[177,215],[215,147],[20,79],[79,166],[166,20],[187,147],[147,213],[213,187],[112,233],[233,244],[244,112],[233,128],[128,245],[245,233],[128,114],[114,188],[188,128],[114,217],[217,174],[174,114],[131,115],[115,220],[220,131],[217,198],[198,236],[236,217],[198,131],[131,134],[134,198],[177,132],[132,58],[58,177],[143,35],[35,124],[124,143],[110,163],[163,7],[7,110],[228,110],[110,25],[25,228],[356,389],[389,368],[368,356],[11,302],[302,267],[267,11],[452,350],[350,349],[349,452],[302,303],[303,269],[269,302],[357,343],[343,277],[277,357],[452,453],[453,357],[357,452],[333,332],[332,297],[297,333],[175,152],[152,377],[377,175],[347,348],[348,330],[330,347],[303,304],[304,270],[270,303],[9,336],[336,337],[337,9],[278,279],[279,360],[360,278],[418,262],[262,431],[431,418],[304,408],[408,409],[409,304],[310,415],[415,407],[407,310],[270,409],[409,410],[410,270],[450,348],[348,347],[347,450],[422,430],[430,434],[434,422],[313,314],[314,17],[17,313],[306,307],[307,375],[375,306],[387,388],[388,260],[260,387],[286,414],[414,398],[398,286],[335,406],[406,418],[418,335],[364,367],[367,416],[416,364],[423,358],[358,327],[327,423],[251,284],[284,298],[298,251],[281,5],[5,4],[4,281],[373,374],[374,253],[253,373],[307,320],[320,321],[321,307],[425,427],[427,411],[411,425],[421,313],[313,18],[18,421],[321,405],[405,406],[406,321],[320,404],[404,405],[405,320],[315,16],[16,17],[17,315],[426,425],[425,266],[266,426],[377,400],[400,369],[369,377],[322,391],[391,269],[269,322],[417,465],[465,464],[464,417],[386,257],[257,258],[258,386],[466,260],[260,388],[388,466],[456,399],[399,419],[419,456],[284,332],[332,333],[333,284],[417,285],[285,8],[8,417],[346,340],[340,261],[261,346],[413,441],[441,285],[285,413],[327,460],[460,328],[328,327],[355,371],[371,329],[329,355],[392,439],[439,438],[438,392],[382,341],[341,256],[256,382],[429,420],[420,360],[360,429],[364,394],[394,379],[379,364],[277,343],[343,437],[437,277],[443,444],[444,283],[283,443],[275,440],[440,363],[363,275],[431,262],[262,369],[369,431],[297,338],[338,337],[337,297],[273,375],[375,321],[321,273],[450,451],[451,349],[349,450],[446,342],[342,467],[467,446],[293,334],[334,282],[282,293],[458,461],[461,462],[462,458],[276,353],[353,383],[383,276],[308,324],[324,325],[325,308],[276,300],[300,293],[293,276],[372,345],[345,447],[447,372],[352,345],[345,340],[340,352],[274,1],[1,19],[19,274],[456,248],[248,281],[281,456],[436,427],[427,425],[425,436],[381,256],[256,252],[252,381],[269,391],[391,393],[393,269],[200,199],[199,428],[428,200],[266,330],[330,329],[329,266],[287,273],[273,422],[422,287],[250,462],[462,328],[328,250],[258,286],[286,384],[384,258],[265,353],[353,342],[342,265],[387,259],[259,257],[257,387],[424,431],[431,430],[430,424],[342,353],[353,276],[276,342],[273,335],[335,424],[424,273],[292,325],[325,307],[307,292],[366,447],[447,345],[345,366],[271,303],[303,302],[302,271],[423,266],[266,371],[371,423],[294,455],[455,460],[460,294],[279,278],[278,294],[294,279],[271,272],[272,304],[304,271],[432,434],[434,427],[427,432],[272,407],[407,408],[408,272],[394,430],[430,431],[431,394],[395,369],[369,400],[400,395],[334,333],[333,299],[299,334],[351,417],[417,168],[168,351],[352,280],[280,411],[411,352],[325,319],[319,320],[320,325],[295,296],[296,336],[336,295],[319,403],[403,404],[404,319],[330,348],[348,349],[349,330],[293,298],[298,333],[333,293],[323,454],[454,447],[447,323],[15,16],[16,315],[315,15],[358,429],[429,279],[279,358],[14,15],[15,316],[316,14],[285,336],[336,9],[9,285],[329,349],[349,350],[350,329],[374,380],[380,252],[252,374],[318,402],[402,403],[403,318],[6,197],[197,419],[419,6],[318,319],[319,325],[325,318],[367,364],[364,365],[365,367],[435,367],[367,397],[397,435],[344,438],[438,439],[439,344],[272,271],[271,311],[311,272],[195,5],[5,281],[281,195],[273,287],[287,291],[291,273],[396,428],[428,199],[199,396],[311,271],[271,268],[268,311],[283,444],[444,445],[445,283],[373,254],[254,339],[339,373],[282,334],[334,296],[296,282],[449,347],[347,346],[346,449],[264,447],[447,454],[454,264],[336,296],[296,299],[299,336],[338,10],[10,151],[151,338],[278,439],[439,455],[455,278],[292,407],[407,415],[415,292],[358,371],[371,355],[355,358],[340,345],[345,372],[372,340],[346,347],[347,280],[280,346],[442,443],[443,282],[282,442],[19,94],[94,370],[370,19],[441,442],[442,295],[295,441],[248,419],[419,197],[197,248],[263,255],[255,359],[359,263],[440,275],[275,274],[274,440],[300,383],[383,368],[368,300],[351,412],[412,465],[465,351],[263,467],[467,466],[466,263],[301,368],[368,389],[389,301],[395,378],[378,379],[379,395],[412,351],[351,419],[419,412],[436,426],[426,322],[322,436],[2,164],[164,393],[393,2],[370,462],[462,461],[461,370],[164,0],[0,267],[267,164],[302,11],[11,12],[12,302],[268,12],[12,13],[13,268],[293,300],[300,301],[301,293],[446,261],[261,340],[340,446],[330,266],[266,425],[425,330],[426,423],[423,391],[391,426],[429,355],[355,437],[437,429],[391,327],[327,326],[326,391],[440,457],[457,438],[438,440],[341,382],[382,362],[362,341],[459,457],[457,461],[461,459],[434,430],[430,394],[394,434],[414,463],[463,362],[362,414],[396,369],[369,262],[262,396],[354,461],[461,457],[457,354],[316,403],[403,402],[402,316],[315,404],[404,403],[403,315],[314,405],[405,404],[404,314],[313,406],[406,405],[405,313],[421,418],[418,406],[406,421],[366,401],[401,361],[361,366],[306,408],[408,407],[407,306],[291,409],[409,408],[408,291],[287,410],[410,409],[409,287],[432,436],[436,410],[410,432],[434,416],[416,411],[411,434],[264,368],[368,383],[383,264],[309,438],[438,457],[457,309],[352,376],[376,401],[401,352],[274,275],[275,4],[4,274],[421,428],[428,262],[262,421],[294,327],[327,358],[358,294],[433,416],[416,367],[367,433],[289,455],[455,439],[439,289],[462,370],[370,326],[326,462],[2,326],[326,370],[370,2],[305,460],[460,455],[455,305],[254,449],[449,448],[448,254],[255,261],[261,446],[446,255],[253,450],[450,449],[449,253],[252,451],[451,450],[450,252],[256,452],[452,451],[451,256],[341,453],[453,452],[452,341],[413,464],[464,463],[463,413],[441,413],[413,414],[414,441],[258,442],[442,441],[441,258],[257,443],[443,442],[442,257],[259,444],[444,443],[443,259],[260,445],[445,444],[444,260],[467,342],[342,445],[445,467],[459,458],[458,250],[250,459],[289,392],[392,290],[290,289],[290,328],[328,460],[460,290],[376,433],[433,435],[435,376],[250,290],[290,392],[392,250],[411,416],[416,433],[433,411],[341,463],[463,464],[464,341],[453,464],[464,465],[465,453],[357,465],[465,412],[412,357],[343,412],[412,399],[399,343],[360,363],[363,440],[440,360],[437,399],[399,456],[456,437],[420,456],[456,363],[363,420],[401,435],[435,288],[288,401],[372,383],[383,353],[353,372],[339,255],[255,249],[249,339],[448,261],[261,255],[255,448],[133,243],[243,190],[190,133],[133,155],[155,112],[112,133],[33,246],[246,247],[247,33],[33,130],[130,25],[25,33],[398,384],[384,286],[286,398],[362,398],[398,414],[414,362],[362,463],[463,341],[341,362],[263,359],[359,467],[467,263],[263,249],[249,255],[255,263],[466,467],[467,260],[260,466],[75,60],[60,166],[166,75],[238,239],[239,79],[79,238],[162,127],[127,139],[139,162],[72,11],[11,37],[37,72],[121,232],[232,120],[120,121],[73,72],[72,39],[39,73],[114,128],[128,47],[47,114],[233,232],[232,128],[128,233],[103,104],[104,67],[67,103],[152,175],[175,148],[148,152],[119,118],[118,101],[101,119],[74,73],[73,40],[40,74],[107,9],[9,108],[108,107],[49,48],[48,131],[131,49],[32,194],[194,211],[211,32],[184,74],[74,185],[185,184],[191,80],[80,183],[183,191],[185,40],[40,186],[186,185],[119,230],[230,118],[118,119],[210,202],[202,214],[214,210],[84,83],[83,17],[17,84],[77,76],[76,146],[146,77],[161,160],[160,30],[30,161],[190,56],[56,173],[173,190],[182,106],[106,194],[194,182],[138,135],[135,192],[192,138],[129,203],[203,98],[98,129],[54,21],[21,68],[68,54],[5,51],[51,4],[4,5],[145,144],[144,23],[23,145],[90,77],[77,91],[91,90],[207,205],[205,187],[187,207],[83,201],[201,18],[18,83],[181,91],[91,182],[182,181],[180,90],[90,181],[181,180],[16,85],[85,17],[17,16],[205,206],[206,36],[36,205],[176,148],[148,140],[140,176],[165,92],[92,39],[39,165],[245,193],[193,244],[244,245],[27,159],[159,28],[28,27],[30,247],[247,161],[161,30],[174,236],[236,196],[196,174],[103,54],[54,104],[104,103],[55,193],[193,8],[8,55],[111,117],[117,31],[31,111],[221,189],[189,55],[55,221],[240,98],[98,99],[99,240],[142,126],[126,100],[100,142],[219,166],[166,218],[218,219],[112,155],[155,26],[26,112],[198,209],[209,131],[131,198],[169,135],[135,150],[150,169],[114,47],[47,217],[217,114],[224,223],[223,53],[53,224],[220,45],[45,134],[134,220],[32,211],[211,140],[140,32],[109,67],[67,108],[108,109],[146,43],[43,91],[91,146],[231,230],[230,120],[120,231],[113,226],[226,247],[247,113],[105,63],[63,52],[52,105],[241,238],[238,242],[242,241],[124,46],[46,156],[156,124],[95,78],[78,96],[96,95],[70,46],[46,63],[63,70],[116,143],[143,227],[227,116],[116,123],[123,111],[111,116],[1,44],[44,19],[19,1],[3,236],[236,51],[51,3],[207,216],[216,205],[205,207],[26,154],[154,22],[22,26],[165,39],[39,167],[167,165],[199,200],[200,208],[208,199],[101,36],[36,100],[100,101],[43,57],[57,202],[202,43],[242,20],[20,99],[99,242],[56,28],[28,157],[157,56],[124,35],[35,113],[113,124],[29,160],[160,27],[27,29],[211,204],[204,210],[210,211],[124,113],[113,46],[46,124],[106,43],[43,204],[204,106],[96,62],[62,77],[77,96],[227,137],[137,116],[116,227],[73,41],[41,72],[72,73],[36,203],[203,142],[142,36],[235,64],[64,240],[240,235],[48,49],[49,64],[64,48],[42,41],[41,74],[74,42],[214,212],[212,207],[207,214],[183,42],[42,184],[184,183],[210,169],[169,211],[211,210],[140,170],[170,176],[176,140],[104,105],[105,69],[69,104],[193,122],[122,168],[168,193],[50,123],[123,187],[187,50],[89,96],[96,90],[90,89],[66,65],[65,107],[107,66],[179,89],[89,180],[180,179],[119,101],[101,120],[120,119],[68,63],[63,104],[104,68],[234,93],[93,227],[227,234],[16,15],[15,85],[85,16],[209,129],[129,49],[49,209],[15,14],[14,86],[86,15],[107,55],[55,9],[9,107],[120,100],[100,121],[121,120],[153,145],[145,22],[22,153],[178,88],[88,179],[179,178],[197,6],[6,196],[196,197],[89,88],[88,96],[96,89],[135,138],[138,136],[136,135],[138,215],[215,172],[172,138],[218,115],[115,219],[219,218],[41,42],[42,81],[81,41],[5,195],[195,51],[51,5],[57,43],[43,61],[61,57],[208,171],[171,199],[199,208],[41,81],[81,38],[38,41],[224,53],[53,225],[225,224],[24,144],[144,110],[110,24],[105,52],[52,66],[66,105],[118,229],[229,117],[117,118],[227,34],[34,234],[234,227],[66,107],[107,69],[69,66],[10,109],[109,151],[151,10],[219,48],[48,235],[235,219],[183,62],[62,191],[191,183],[142,129],[129,126],[126,142],[116,111],[111,143],[143,116],[118,117],[117,50],[50,118],[223,222],[222,52],[52,223],[94,19],[19,141],[141,94],[222,221],[221,65],[65,222],[196,3],[3,197],[197,196],[45,220],[220,44],[44,45],[156,70],[70,139],[139,156],[188,122],[122,245],[245,188],[139,71],[71,162],[162,139],[149,170],[170,150],[150,149],[122,188],[188,196],[196,122],[206,216],[216,92],[92,206],[164,2],[2,167],[167,164],[242,141],[141,241],[241,242],[0,164],[164,37],[37,0],[11,72],[72,12],[12,11],[12,38],[38,13],[13,12],[70,63],[63,71],[71,70],[31,226],[226,111],[111,31],[36,101],[101,205],[205,36],[203,206],[206,165],[165,203],[126,209],[209,217],[217,126],[98,165],[165,97],[97,98],[237,220],[220,218],[218,237],[237,239],[239,241],[241,237],[210,214],[214,169],[169,210],[140,171],[171,32],[32,140],[241,125],[125,237],[237,241],[179,86],[86,178],[178,179],[180,85],[85,179],[179,180],[181,84],[84,180],[180,181],[182,83],[83,181],[181,182],[194,201],[201,182],[182,194],[177,137],[137,132],[132,177],[184,76],[76,183],[183,184],[185,61],[61,184],[184,185],[186,57],[57,185],[185,186],[216,212],[212,186],[186,216],[192,214],[214,187],[187,192],[139,34],[34,156],[156,139],[218,79],[79,237],[237,218],[147,123],[123,177],[177,147],[45,44],[44,4],[4,45],[208,201],[201,32],[32,208],[98,64],[64,129],[129,98],[192,213],[213,138],[138,192],[235,59],[59,219],[219,235],[141,242],[242,97],[97,141],[97,2],[2,141],[141,97],[240,75],[75,235],[235,240],[229,24],[24,228],[228,229],[31,25],[25,226],[226,31],[230,23],[23,229],[229,230],[231,22],[22,230],[230,231],[232,26],[26,231],[231,232],[233,112],[112,232],[232,233],[244,189],[189,243],[243,244],[189,221],[221,190],[190,189],[222,28],[28,221],[221,222],[223,27],[27,222],[222,223],[224,29],[29,223],[223,224],[225,30],[30,224],[224,225],[113,247],[247,225],[225,113],[99,60],[60,240],[240,99],[213,147],[147,215],[215,213],[60,20],[20,166],[166,60],[192,187],[187,213],[213,192],[243,112],[112,244],[244,243],[244,233],[233,245],[245,244],[245,128],[128,188],[188,245],[188,114],[114,174],[174,188],[134,131],[131,220],[220,134],[174,217],[217,236],[236,174],[236,198],[198,134],[134,236],[215,177],[177,58],[58,215],[156,143],[143,124],[124,156],[25,110],[110,7],[7,25],[31,228],[228,25],[25,31],[264,356],[356,368],[368,264],[0,11],[11,267],[267,0],[451,452],[452,349],[349,451],[267,302],[302,269],[269,267],[350,357],[357,277],[277,350],[350,452],[452,357],[357,350],[299,333],[333,297],[297,299],[396,175],[175,377],[377,396],[280,347],[347,330],[330,280],[269,303],[303,270],[270,269],[151,9],[9,337],[337,151],[344,278],[278,360],[360,344],[424,418],[418,431],[431,424],[270,304],[304,409],[409,270],[272,310],[310,407],[407,272],[322,270],[270,410],[410,322],[449,450],[450,347],[347,449],[432,422],[422,434],[434,432],[18,313],[313,17],[17,18],[291,306],[306,375],[375,291],[259,387],[387,260],[260,259],[424,335],[335,418],[418,424],[434,364],[364,416],[416,434],[391,423],[423,327],[327,391],[301,251],[251,298],[298,301],[275,281],[281,4],[4,275],[254,373],[373,253],[253,254],[375,307],[307,321],[321,375],[280,425],[425,411],[411,280],[200,421],[421,18],[18,200],[335,321],[321,406],[406,335],[321,320],[320,405],[405,321],[314,315],[315,17],[17,314],[423,426],[426,266],[266,423],[396,377],[377,369],[369,396],[270,322],[322,269],[269,270],[413,417],[417,464],[464,413],[385,386],[386,258],[258,385],[248,456],[456,419],[419,248],[298,284],[284,333],[333,298],[168,417],[417,8],[8,168],[448,346],[346,261],[261,448],[417,413],[413,285],[285,417],[326,327],[327,328],[328,326],[277,355],[355,329],[329,277],[309,392],[392,438],[438,309],[381,382],[382,256],[256,381],[279,429],[429,360],[360,279],[365,364],[364,379],[379,365],[355,277],[277,437],[437,355],[282,443],[443,283],[283,282],[281,275],[275,363],[363,281],[395,431],[431,369],[369,395],[299,297],[297,337],[337,299],[335,273],[273,321],[321,335],[348,450],[450,349],[349,348],[359,446],[446,467],[467,359],[283,293],[293,282],[282,283],[250,458],[458,462],[462,250],[300,276],[276,383],[383,300],[292,308],[308,325],[325,292],[283,276],[276,293],[293,283],[264,372],[372,447],[447,264],[346,352],[352,340],[340,346],[354,274],[274,19],[19,354],[363,456],[456,281],[281,363],[426,436],[436,425],[425,426],[380,381],[381,252],[252,380],[267,269],[269,393],[393,267],[421,200],[200,428],[428,421],[371,266],[266,329],[329,371],[432,287],[287,422],[422,432],[290,250],[250,328],[328,290],[385,258],[258,384],[384,385],[446,265],[265,342],[342,446],[386,387],[387,257],[257,386],[422,424],[424,430],[430,422],[445,342],[342,276],[276,445],[422,273],[273,424],[424,422],[306,292],[292,307],[307,306],[352,366],[366,345],[345,352],[268,271],[271,302],[302,268],[358,423],[423,371],[371,358],[327,294],[294,460],[460,327],[331,279],[279,294],[294,331],[303,271],[271,304],[304,303],[436,432],[432,427],[427,436],[304,272],[272,408],[408,304],[395,394],[394,431],[431,395],[378,395],[395,400],[400,378],[296,334],[334,299],[299,296],[6,351],[351,168],[168,6],[376,352],[352,411],[411,376],[307,325],[325,320],[320,307],[285,295],[295,336],[336,285],[320,319],[319,404],[404,320],[329,330],[330,349],[349,329],[334,293],[293,333],[333,334],[366,323],[323,447],[447,366],[316,15],[15,315],[315,316],[331,358],[358,279],[279,331],[317,14],[14,316],[316,317],[8,285],[285,9],[9,8],[277,329],[329,350],[350,277],[253,374],[374,252],[252,253],[319,318],[318,403],[403,319],[351,6],[6,419],[419,351],[324,318],[318,325],[325,324],[397,367],[367,365],[365,397],[288,435],[435,397],[397,288],[278,344],[344,439],[439,278],[310,272],[272,311],[311,310],[248,195],[195,281],[281,248],[375,273],[273,291],[291,375],[175,396],[396,199],[199,175],[312,311],[311,268],[268,312],[276,283],[283,445],[445,276],[390,373],[373,339],[339,390],[295,282],[282,296],[296,295],[448,449],[449,346],[346,448],[356,264],[264,454],[454,356],[337,336],[336,299],[299,337],[337,338],[338,151],[151,337],[294,278],[278,455],[455,294],[308,292],[292,415],[415,308],[429,358],[358,355],[355,429],[265,340],[340,372],[372,265],[352,346],[346,280],[280,352],[295,442],[442,282],[282,295],[354,19],[19,370],[370,354],[285,441],[441,295],[295,285],[195,248],[248,197],[197,195],[457,440],[440,274],[274,457],[301,300],[300,368],[368,301],[417,351],[351,465],[465,417],[251,301],[301,389],[389,251],[394,395],[395,379],[379,394],[399,412],[412,419],[419,399],[410,436],[436,322],[322,410],[326,2],[2,393],[393,326],[354,370],[370,461],[461,354],[393,164],[164,267],[267,393],[268,302],[302,12],[12,268],[312,268],[268,13],[13,312],[298,293],[293,301],[301,298],[265,446],[446,340],[340,265],[280,330],[330,425],[425,280],[322,426],[426,391],[391,322],[420,429],[429,437],[437,420],[393,391],[391,326],[326,393],[344,440],[440,438],[438,344],[458,459],[459,461],[461,458],[364,434],[434,394],[394,364],[428,396],[396,262],[262,428],[274,354],[354,457],[457,274],[317,316],[316,402],[402,317],[316,315],[315,403],[403,316],[315,314],[314,404],[404,315],[314,313],[313,405],[405,314],[313,421],[421,406],[406,313],[323,366],[366,361],[361,323],[292,306],[306,407],[407,292],[306,291],[291,408],[408,306],[291,287],[287,409],[409,291],[287,432],[432,410],[410,287],[427,434],[434,411],[411,427],[372,264],[264,383],[383,372],[459,309],[309,457],[457,459],[366,352],[352,401],[401,366],[1,274],[274,4],[4,1],[418,421],[421,262],[262,418],[331,294],[294,358],[358,331],[435,433],[433,367],[367,435],[392,289],[289,439],[439,392],[328,462],[462,326],[326,328],[94,2],[2,370],[370,94],[289,305],[305,455],[455,289],[339,254],[254,448],[448,339],[359,255],[255,446],[446,359],[254,253],[253,449],[449,254],[253,252],[252,450],[450,253],[252,256],[256,451],[451,252],[256,341],[341,452],[452,256],[414,413],[413,463],[463,414],[286,441],[441,414],[414,286],[286,258],[258,441],[441,286],[258,257],[257,442],[442,258],[257,259],[259,443],[443,257],[259,260],[260,444],[444,259],[260,467],[467,445],[445,260],[309,459],[459,250],[250,309],[305,289],[289,290],[290,305],[305,290],[290,460],[460,305],[401,376],[376,435],[435,401],[309,250],[250,392],[392,309],[376,411],[411,433],[433,376],[453,341],[341,464],[464,453],[357,453],[453,465],[465,357],[343,357],[357,412],[412,343],[437,343],[343,399],[399,437],[344,360],[360,440],[440,344],[420,437],[437,456],[456,420],[360,420],[420,363],[363,360],[361,401],[401,288],[288,361],[265,372],[372,353],[353,265],[390,339],[339,249],[249,390],[339,448],[448,255],[255,339]]),Xe("matrixDataToMatrix",function(h){for(var y=h.getCols(),G=h.getRows(),C=h.getPackedDataList(),z=[],P=0;P<G;P++)z.push(Array(y));for(P=0;P<G;P++)for(var A=0;A<y;A++){var q=h.getLayout()===1?P*y+A:A*G+P;z[P][A]=C[q];}return z;}),Xe("VERSION","0.4.1633559619");}).call(Si);const Ti={};(function(){var r;function e(t){var c=0;return function(){return c<t.length?{done:!1,value:t[c++]}:{done:!0};};}var i=typeof Object.defineProperties=="function"?Object.defineProperty:function(t,c,a){return t==Array.prototype||t==Object.prototype||(t[c]=a.value),t;};function m(t){t=[typeof globalThis=="object"&&globalThis,t,typeof window=="object"&&window,typeof self=="object"&&self,typeof (typeof window !== undefined ? window : global)=="object"&&(typeof window !== undefined ? window : global)];for(var c=0;c<t.length;++c){var a=t[c];if(a&&a.Math==Math)return a;}throw Error("Cannot find global object");}var v=m(this);function S(t,c){if(c)t:{var a=v;t=t.split(".");for(var b=0;b<t.length-1;b++){var I=t[b];if(!(I in a))break t;a=a[I];}t=t[t.length-1],b=a[t],c=c(b),c!=b&&c!=null&&i(a,t,{configurable:!0,writable:!0,value:c});}}S("Symbol",function(t){function c(F){if(this instanceof c)throw new TypeError("Symbol is not a constructor");return new a(b+(F||"")+"_"+I++,F);}function a(F,H){this.g=F,i(this,"description",{configurable:!0,writable:!0,value:H});}if(t)return t;a.prototype.toString=function(){return this.g;};var b="jscomp_symbol_"+(1e9*Math.random()>>>0)+"_",I=0;return c;}),S("Symbol.iterator",function(t){if(t)return t;t=Symbol("Symbol.iterator");for(var c="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),a=0;a<c.length;a++){var b=v[c[a]];typeof b=="function"&&typeof b.prototype[t]!="function"&&i(b.prototype,t,{configurable:!0,writable:!0,value:function value(){return L(e(this));}});}return t;});function L(t){return t={next:t},t[Symbol.iterator]=function(){return this;},t;}function T(t){var c=typeof Symbol<"u"&&Symbol.iterator&&t[Symbol.iterator];return c?c.call(t):{next:e(t)};}function k(t){if(!(t instanceof Array)){t=T(t);for(var c,a=[];!(c=t.next()).done;)a.push(c.value);t=a;}return t;}var tt=typeof Object.create=="function"?Object.create:function(t){function c(){}return c.prototype=t,new c();},st;if(typeof Object.setPrototypeOf=="function")st=Object.setPrototypeOf;else{var bt;t:{var xt={a:!0},Yt={};try{Yt.__proto__=xt,bt=Yt.a;break t;}catch(_unused9){}bt=!1;}st=bt?function(t,c){if(t.__proto__=c,t.__proto__!==c)throw new TypeError(t+" is not extensible");return t;}:null;}var at=st;function ht(t,c){if(t.prototype=tt(c.prototype),t.prototype.constructor=t,at)at(t,c);else for(var a in c)if(a!="prototype")if(Object.defineProperties){var b=Object.getOwnPropertyDescriptor(c,a);b&&Object.defineProperty(t,a,b);}else t[a]=c[a];t.ka=c.prototype;}function Ut(){this.l=!1,this.i=null,this.h=void 0,this.g=1,this.s=this.m=0,this.j=null;}function Mt(t){if(t.l)throw new TypeError("Generator is already running");t.l=!0;}Ut.prototype.o=function(t){this.h=t;};function oe(t,c){t.j={V:c,X:!0},t.g=t.m||t.s;}Ut.prototype.return=function(t){this.j={return:t},this.g=this.s;};function D(t,c,a){return t.g=a,{value:c};}function hn(t){this.g=new Ut(),this.h=t;}function bn(t,c){Mt(t.g);var a=t.g.i;return a?ge(t,"return"in a?a.return:function(b){return{value:b,done:!0};},c,t.g.return):(t.g.return(c),Kt(t));}function ge(t,c,a,b){try{var I=c.call(t.g.i,a);if(!(I instanceof Object))throw new TypeError("Iterator result "+I+" is not an object");if(!I.done)return t.g.l=!1,I;var F=I.value;}catch(H){return t.g.i=null,oe(t.g,H),Kt(t);}return t.g.i=null,b.call(t.g,F),Kt(t);}function Kt(t){for(;t.g.g;)try{var c=t.h(t.g);if(c)return t.g.l=!1,{value:c.value,done:!1};}catch(a){t.g.h=void 0,oe(t.g,a);}if(t.g.l=!1,t.g.j){if(c=t.g.j,t.g.j=null,c.X)throw c.V;return{value:c.return,done:!0};}return{value:void 0,done:!0};}function jn(t){this.next=function(c){return Mt(t.g),t.g.i?c=ge(t,t.g.i.next,c,t.g.o):(t.g.o(c),c=Kt(t)),c;},this.throw=function(c){return Mt(t.g),t.g.i?c=ge(t,t.g.i.throw,c,t.g.o):(oe(t.g,c),c=Kt(t)),c;},this.return=function(c){return bn(t,c);},this[Symbol.iterator]=function(){return this;};}function ue(t){function c(b){return t.next(b);}function a(b){return t.throw(b);}return new Promise(function(b,I){function F(H){H.done?b(H.value):Promise.resolve(H.value).then(c,a).then(F,I);}F(t.next());});}function yt(t){return ue(new jn(new hn(t)));}S("Promise",function(t){function c(H){this.h=0,this.i=void 0,this.g=[],this.o=!1;var E=this.j();try{H(E.resolve,E.reject);}catch(j){E.reject(j);}}function a(){this.g=null;}function b(H){return H instanceof c?H:new c(function(E){E(H);});}if(t)return t;a.prototype.h=function(H){if(this.g==null){this.g=[];var E=this;this.i(function(){E.l();});}this.g.push(H);};var I=v.setTimeout;a.prototype.i=function(H){I(H,0);},a.prototype.l=function(){for(;this.g&&this.g.length;){var H=this.g;this.g=[];for(var E=0;E<H.length;++E){var j=H[E];H[E]=null;try{j();}catch(_){this.j(_);}}}this.g=null;},a.prototype.j=function(H){this.i(function(){throw H;});},c.prototype.j=function(){function H(_){return function(Q){j||(j=!0,_.call(E,Q));};}var E=this,j=!1;return{resolve:H(this.D),reject:H(this.l)};},c.prototype.D=function(H){if(H===this)this.l(new TypeError("A Promise cannot resolve to itself"));else if(H instanceof c)this.G(H);else{t:switch(typeof H){case"object":var E=H!=null;break t;case"function":E=!0;break t;default:E=!1;}E?this.A(H):this.m(H);}},c.prototype.A=function(H){var E=void 0;try{E=H.then;}catch(j){this.l(j);return;}typeof E=="function"?this.H(E,H):this.m(H);},c.prototype.l=function(H){this.s(2,H);},c.prototype.m=function(H){this.s(1,H);},c.prototype.s=function(H,E){if(this.h!=0)throw Error("Cannot settle("+H+", "+E+"): Promise already settled in state"+this.h);this.h=H,this.i=E,this.h===2&&this.F(),this.B();},c.prototype.F=function(){var H=this;I(function(){if(H.C()){var E=v.console;typeof E<"u"&&E.error(H.i);}},1);},c.prototype.C=function(){if(this.o)return!1;var H=v.CustomEvent,E=v.Event,j=v.dispatchEvent;return typeof j>"u"?!0:(typeof H=="function"?H=new H("unhandledrejection",{cancelable:!0}):typeof E=="function"?H=new E("unhandledrejection",{cancelable:!0}):(H=v.document.createEvent("CustomEvent"),H.initCustomEvent("unhandledrejection",!1,!0,H)),H.promise=this,H.reason=this.i,j(H));},c.prototype.B=function(){if(this.g!=null){for(var H=0;H<this.g.length;++H)F.h(this.g[H]);this.g=null;}};var F=new a();return c.prototype.G=function(H){var E=this.j();H.K(E.resolve,E.reject);},c.prototype.H=function(H,E){var j=this.j();try{H.call(E,j.resolve,j.reject);}catch(_){j.reject(_);}},c.prototype.then=function(H,E){function j(ct,ut){return typeof ct=="function"?function(pt){try{_(ct(pt));}catch(mt){Q(mt);}}:ut;}var _,Q,it=new c(function(ct,ut){_=ct,Q=ut;});return this.K(j(H,_),j(E,Q)),it;},c.prototype.catch=function(H){return this.then(void 0,H);},c.prototype.K=function(H,E){function j(){switch(_.h){case 1:H(_.i);break;case 2:E(_.i);break;default:throw Error("Unexpected state: "+_.h);}}var _=this;this.g==null?F.h(j):this.g.push(j),this.o=!0;},c.resolve=b,c.reject=function(H){return new c(function(E,j){j(H);});},c.race=function(H){return new c(function(E,j){for(var _=T(H),Q=_.next();!Q.done;Q=_.next())b(Q.value).K(E,j);});},c.all=function(H){var E=T(H),j=E.next();return j.done?b([]):new c(function(_,Q){function it(pt){return function(mt){ct[pt]=mt,ut--,ut==0&&_(ct);};}var ct=[],ut=0;do ct.push(void 0),ut++,b(j.value).K(it(ct.length-1),Q),j=E.next();while(!j.done);});},c;});function Kn(t,c){t instanceof String&&(t+="");var a=0,b=!1,I={next:function next(){if(!b&&a<t.length){var F=a++;return{value:c(F,t[F]),done:!1};}return b=!0,{done:!0,value:void 0};}};return I[Symbol.iterator]=function(){return I;},I;}var On=typeof Object.assign=="function"?Object.assign:function(t,c){for(var a=1;a<arguments.length;a++){var b=arguments[a];if(b)for(var I in b)Object.prototype.hasOwnProperty.call(b,I)&&(t[I]=b[I]);}return t;};S("Object.assign",function(t){return t||On;}),S("Object.is",function(t){return t||function(c,a){return c===a?c!==0||1/c===1/a:c!==c&&a!==a;};}),S("Array.prototype.includes",function(t){return t||function(c,a){var b=this;b instanceof String&&(b=String(b));var I=b.length;for(a=a||0,0>a&&(a=Math.max(a+I,0));a<I;a++){var F=b[a];if(F===c||Object.is(F,c))return!0;}return!1;};}),S("String.prototype.includes",function(t){return t||function(c,a){if(this==null)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(c instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return this.indexOf(c,a||0)!==-1;};}),S("Array.prototype.keys",function(t){return t||function(){return Kn(this,function(c){return c;});};});var Xe=this||self;function Lt(t,c){t=t.split(".");var a=Xe;t[0]in a||typeof a.execScript>"u"||a.execScript("var "+t[0]);for(var b;t.length&&(b=t.shift());)t.length||c===void 0?a[b]&&a[b]!==Object.prototype[b]?a=a[b]:a=a[b]={}:a[b]=c;}function Ye(t){throw t;}function nn(t,c){Ye(Error("Invalid wire type: "+t+" (at position "+c+")"));}function yn(){Ye(Error("Failed to read varint, encoding is invalid."));}function Yn(t,c){return c=String.fromCharCode.apply(null,c),t==null?c:t+c;}var Vn,Ln=typeof TextDecoder<"u",rn,un=typeof TextEncoder<"u";function Jn(t){if(un)t=(rn||(rn=new TextEncoder())).encode(t);else{var c=void 0;c=c===void 0?!1:c;for(var a=0,b=new Uint8Array(3*t.length),I=0;I<t.length;I++){var F=t.charCodeAt(I);if(128>F)b[a++]=F;else{if(2048>F)b[a++]=F>>6|192;else{if(55296<=F&&57343>=F){if(56319>=F&&I<t.length){var H=t.charCodeAt(++I);if(56320<=H&&57343>=H){F=1024*(F-55296)+H-56320+65536,b[a++]=F>>18|240,b[a++]=F>>12&63|128,b[a++]=F>>6&63|128,b[a++]=F&63|128;continue;}else I--;}if(c)throw Error("Found an unpaired surrogate");F=65533;}b[a++]=F>>12|224,b[a++]=F>>6&63|128;}b[a++]=F&63|128;}}t=b.subarray(0,a);}return t;}var wn={},gn=null;function on(t){var c;c===void 0&&(c=0),be(),c=wn[c];for(var a=Array(Math.floor(t.length/3)),b=c[64]||"",I=0,F=0;I<t.length-2;I+=3){var H=t[I],E=t[I+1],j=t[I+2],_=c[H>>2];H=c[(H&3)<<4|E>>4],E=c[(E&15)<<2|j>>6],j=c[j&63],a[F++]=_+H+E+j;}switch(_=0,j=b,t.length-I){case 2:_=t[I+1],j=c[(_&15)<<2]||b;case 1:t=t[I],a[F]=c[t>>2]+c[(t&3)<<4|_>>4]+j+b;}return a.join("");}function Rn(t){var c=t.length,a=3*c/4;a%3?a=Math.floor(a):"=.".indexOf(t[c-1])!=-1&&(a="=.".indexOf(t[c-2])!=-1?a-2:a-1);var b=new Uint8Array(a),I=0;return Zn(t,function(F){b[I++]=F;}),b.subarray(0,I);}function Zn(t,c){function a(j){for(;b<t.length;){var _=t.charAt(b++),Q=gn[_];if(Q!=null)return Q;if(!/^[\s\xa0]*$/.test(_))throw Error("Unknown base64 encoding at char: "+_);}return j;}be();for(var b=0;;){var I=a(-1),F=a(0),H=a(64),E=a(64);if(E===64&&I===-1)break;c(I<<2|F>>4),H!=64&&(c(F<<4&240|H>>2),E!=64&&c(H<<6&192|E));}}function be(){if(!gn){gn={};for(var t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),c=["+/=","+/","-_=","-_.","-_"],a=0;5>a;a++){var b=t.concat(c[a].split(""));wn[a]=b;for(var I=0;I<b.length;I++){var F=b[I];gn[F]===void 0&&(gn[F]=I);}}}}var We=typeof Uint8Array=="function",Pe;function pe(t){if(this.g=t,t!==null&&t.length===0)throw Error("ByteString should be constructed with non-empty values");}var ye=typeof Uint8Array.prototype.slice=="function";function De(t,c,a){return c===a?Pe||(Pe=new Uint8Array(0)):ye?t.slice(c,a):new Uint8Array(t.subarray(c,a));}var Ce=0,Pt=0;function de(t){if(t.constructor===Uint8Array)return t;if(t.constructor===ArrayBuffer)return new Uint8Array(t);if(t.constructor===Array)return new Uint8Array(t);if(t.constructor===String)return Rn(t);if(t.constructor===pe){if(t.g==null)var c=Pe||(Pe=new Uint8Array(0));else{c=Uint8Array;var a=t.g;a=a==null||We&&a!=null&&a instanceof Uint8Array?a:typeof a=="string"?Rn(a):null,t=t.g=a,c=new c(t);}return c;}if(t instanceof Uint8Array)return new Uint8Array(t.buffer,t.byteOffset,t.byteLength);throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");}function we(t,c){c=c===void 0?{}:c,c=c.v===void 0?!1:c.v,this.h=null,this.g=this.i=this.l=0,this.j=!1,this.v=c,t&&Jt(this,t);}function Jt(t,c){t.h=de(c),t.l=0,t.i=t.h.length,t.g=t.l;}we.prototype.reset=function(){this.g=this.l;};function Ze(t){for(var c=128,a=0,b=0,I=0;4>I&&128<=c;I++)c=t.h[t.g++],a|=(c&127)<<7*I;if(128<=c&&(c=t.h[t.g++],a|=(c&127)<<28,b|=(c&127)>>4),128<=c)for(I=0;5>I&&128<=c;I++)c=t.h[t.g++],b|=(c&127)<<7*I+3;if(128>c)return t=a>>>0,c=b>>>0,(b=c&2147483648)&&(t=~t+1>>>0,c=~c>>>0,t==0&&(c=c+1>>>0)),t=4294967296*c+(t>>>0),b?-t:t;t.j=!0,yn();}function _t(t){t.g>t.i&&(t.j=!0,Ye(Error("Tried to read past the end of the data "+t.g+" > "+t.i)));}function ae(t){var c=t.h,a=c[t.g],b=a&127;return 128>a?(t.g+=1,_t(t),b):(a=c[t.g+1],b|=(a&127)<<7,128>a?(t.g+=2,_t(t),b):(a=c[t.g+2],b|=(a&127)<<14,128>a?(t.g+=3,_t(t),b):(a=c[t.g+3],b|=(a&127)<<21,128>a?(t.g+=4,_t(t),b):(a=c[t.g+4],b|=(a&15)<<28,128>a?(t.g+=5,_t(t),b>>>0):(t.g+=5,128<=c[t.g++]&&128<=c[t.g++]&&128<=c[t.g++]&&128<=c[t.g++]&&128<=c[t.g++]?(t.j=!0,yn(),b):(_t(t),b))))));}function xe(t){var c=t.h[t.g],a=t.h[t.g+1],b=t.h[t.g+2],I=t.h[t.g+3];return t.g+=4,_t(t),(c<<0|a<<8|b<<16|I<<24)>>>0;}we.prototype.m=function(){var t=xe(this),c=2*(t>>31)+1,a=t>>>23&255;return t&=8388607,a==255?t?NaN:1/0*c:a==0?c*Math.pow(2,-149)*t:c*Math.pow(2,a-150)*(t+Math.pow(2,23));};var _e=[];function me(){this.g=new Uint8Array(64),this.h=0;}function zt(t,c){if(!(t.h+1<t.g.length)){var a=t.g;t.g=new Uint8Array(Math.ceil(1+2*t.g.length)),t.g.set(a);}t.g[t.h++]=c;}me.prototype.length=function(){return this.h;},me.prototype.end=function(){var t=this.g,c=this.h;return this.h=0,De(t,0,c);};function Je(t,c){for(;127<c;)zt(t,c&127|128),c>>>=7;zt(t,c);}function Ae(t){var c={},a=c.O===void 0?!1:c.O;this.m={v:c.v===void 0?!1:c.v},this.O=a,c=this.m,_e.length?(a=_e.pop(),c&&(a.v=c.v),t&&Jt(a,t),t=a):t=new we(t,c),this.g=t,this.l=this.g.g,this.h=this.i=-1,this.j=!1;}Ae.prototype.reset=function(){this.g.reset(),this.h=this.i=-1;};function ve(t){var c=t.g;if((c=c.g==c.i)||(c=t.j)||(c=t.g,c=c.j||0>c.g||c.g>c.i),c)return!1;t.l=t.g.g;var a=ae(t.g);return c=a>>>3,a&=7,0<=a&&5>=a?(t.i=c,t.h=a,!0):(t.j=!0,nn(a,t.l),!1);}function Sn(t){switch(t.h){case 0:if(t.h!=0)Sn(t);else t:{t=t.g;for(var c=t.g,a=0;10>a;a++){if(!(t.h[c]&128)){t.g=c+1,_t(t);break t;}c++;}t.j=!0,yn();}break;case 1:t=t.g,t.g+=8,_t(t);break;case 2:t.h!=2?Sn(t):(c=ae(t.g),t=t.g,t.g+=c,_t(t));break;case 5:t=t.g,t.g+=4,_t(t);break;case 3:c=t.i;do{if(!ve(t)){t.j=!0,Ye(Error("Unmatched start-group tag: stream EOF"));break;}if(t.h==4){t.i!=c&&(t.j=!0,Ye(Error("Unmatched end-group tag")));break;}Sn(t);}while(!0);break;default:t.j=!0,nn(t.h,t.l);}}function $e(t,c,a){var b=t.g.i,I=ae(t.g),F=t.g.g+I;if(t.g.i=F,a(c,t),a=F-t.g.g,a!==0)throw Error("Message parsing ended unexpectedly. Expected to read "+(I+" bytes, instead read "+(I-a)+" bytes, either the data ended unexpectedly or the message misreported its own length"));return t.g.g=F,t.g.i=b,c;}var an=[];function fn(){this.h=[],this.i=0,this.g=new me();}function he(t,c){c.length!==0&&(t.h.push(c),t.i+=c.length);}function Ie(t,c,a){Je(t.g,8*c+2),Je(t.g,a.length),he(t,t.g.end()),he(t,a);}var fe=typeof Symbol=="function"&&typeof Symbol()=="symbol"?Symbol(void 0):void 0;function ee(t){return Object.isFrozen(t)||(fe?t[fe]|=1:t.g!==void 0?t.g|=1:Object.defineProperties(t,{g:{value:1,configurable:!0,writable:!0,enumerable:!1}})),t;}function Be(t){return t!==null&&typeof t=="object"&&t.constructor===Object;}function Qt(t){switch(typeof t){case"number":return isFinite(t)?t:String(t);case"object":if(We&&t!=null&&t instanceof Uint8Array)return on(t);if(t instanceof pe){if(t.g==null)t="";else{var c=t.g;c=c==null||typeof c=="string"?c:We&&c instanceof Uint8Array?on(c):null,t=t.g=c;}return t;}}return t;}function At(t,c){if(t!=null)return Array.isArray(t)||Be(t)?vn(t,c):c(t);}function vn(t,c){if(Array.isArray(t)){for(var a=Array(t.length),b=0;b<t.length;b++)a[b]=At(t[b],c);if(c=Array.isArray(t)){var _I2;var I;fe?I=t[fe]:I=t.g,c=((_I2=I)!=null?_I2:0)&1;}return c&&ee(a),a;}I={};for(a in t)I[a]=At(t[a],c);return I;}function se(t){return t=Qt(t),Array.isArray(t)?vn(t,se):t;}var Ft;function Wt(t,c,a){var b=Ft;Ft=null,t||(t=b),b=this.constructor.ha,t||(t=b?[b]:[]),this.i=(b?0:-1)-(this.constructor.fa||0),this.l=this.g=null,this.u=t;t:{if(b=this.u.length,t=b-1,b&&(b=this.u[t],Be(b))){this.j=t-this.i,this.h=b;break t;}c!==void 0&&-1<c?(this.j=Math.max(c,t+1-this.i),this.h=null):this.j=Number.MAX_VALUE;}if(a)for(c=0;c<a.length;c++)t=a[c],t<this.j?(t+=this.i,(b=this.u[t])?Array.isArray(b)&&ee(b):this.u[t]=ne):(He(this),(b=this.h[t])?Array.isArray(b)&&ee(b):this.h[t]=ne);}var ne=Object.freeze(ee([]));function He(t){var c=t.j+t.i;t.u[c]||(t.h=t.u[c]={});}function Dt(t,c,a){return c===-1?null:a!==void 0&&a||c>=t.j?t.h?t.h[c]:void 0:t.u[c+t.i];}function re(t,c,a){a=a===void 0?!1:a;var b=Dt(t,c,a);return b==null&&(b=ne),b===ne&&(b=ee(b.slice()),It(t,c,b,a)),b;}function Ne(t,c){var a=re(t,c);if(t.l||(t.l={}),!t.l[c]){for(var b=0;b<a.length;b++)a[b]=+a[b];t.l[c]=!0;}return a;}function Bt(t,c,a){var _t2;return t=Dt(t,c),t=t==null?t:+t,(_t2=t)!=null?_t2:a===void 0?0:a;}function It(t,c,a,b){b!==void 0&&b||c>=t.j?(He(t),t.h[c]=a):t.u[c+t.i]=a;}function je(t,c,a,b){a!==b?It(t,c,a):It(t,c,void 0,!1);}function Ke(t,c,a){if(a===-1)return null;t.g||(t.g={});var b=t.g[a];if(b)return b;var I=Dt(t,a,!1);return I==null?b:(c=new c(I),t.g[a]=c);}function Fe(t,c,a){t.g||(t.g={});var b=t.g[a];if(!b){var I=re(t,a,!1);b=[];for(var F=0;F<I.length;F++)b[F]=new c(I[F]);t.g[a]=b;}return b;}function Ot(t,c,a,b,I){var F=Fe(t,b,c);a=a||new b(),t=re(t,c),I!=null?(F.splice(I,0,a),t.splice(I,0,a.u)):(F.push(a),t.push(a.u));}Wt.prototype.toJSON=function(){return vn(this.u,se);},Wt.prototype.toString=function(){return this.u.toString();};function ke(t,c){var _t3;return t=Dt(t,c),(_t3=t)!=null?_t3:0;}function mn(t,c){var _t4;return t=Dt(t,c),(_t4=t)!=null?_t4:"";}function qe(t,c){if(t=t.m){he(c,c.g.end());for(var a=0;a<t.length;a++)he(c,t[a]);}}var Ue=Symbol();function Qe(t,c,a){return t[Ue]||(t[Ue]=function(b,I){return c(b,I,a);});}function tn(t){var c=t[Ue];if(!c){var a=t[Me]||(t[Me]=t());c=function c(b,I){return Ve(b,I,a);},t[Ue]=c;}return c;}function Ge(t){var c=t.da;if(c)return tn(c);if(c=t.ia){var a=t.Y;return delete t.Y,Qe(t.W.g,c,a);}}function Ee(t){var c=Ge(t),a=t.W,b=t.ea;return c?function(I,F){return b(I,F,a,c);}:function(I,F){return b(I,F,a);};}function kn(t){var c=t[0];switch(t.length){case 2:var a=t[1];return function(ut,pt,mt){return c(ut,pt,mt,a);};case 3:var b=t[1],I=tn(t[2]);return function(ut,pt,mt){return c(ut,pt,mt,b,I);};case 4:var F=t[1],H=t[3],E=tn(t[2]);return function(ut,pt,mt){return c(ut,pt,mt,F,E,H);};case 5:var j=t[1],_=Qe(j,t[3],t[4]);return function(ut,pt,mt){return c(ut,pt,mt,j,_);};case 6:var Q=t[1],it=t[5],ct=Qe(Q,t[3],t[4]);return function(ut,pt,mt){return c(ut,pt,mt,Q,ct,it);};default:throw Error("Unsupported number of parameters, expected [2-6], got "+t.length);}}var Me=Symbol();function Ve(t,c,a){for(;ve(c)&&c.h!=4;){var b=c.i,I=a[b];if(I)Array.isArray(I)&&(I=a[b]=kn(I));else{var F=a[0];F&&(F=F[b])&&(I=a[b]=Ee(F));}I&&I(c,t,b)||(I=c,b=t,F=I.l,Sn(I),I.O||(I=De(I.g.h,F,I.g.g),(F=b.m)?F.push(I):b.m=[I]));}return t;}function sn(t,c){var a=new fn();if(c(t,a),t=a.i+a.g.length(),t===0)a=new Uint8Array(0);else{t=new Uint8Array(t);for(var b=a.h,I=b.length,F=c=0;F<I;F++){var H=b[F];H.length!==0&&(t.set(H,c),c+=H.length);}b=a.g,I=b.h,I!==0&&(t.set(b.g.subarray(0,I),c),b.h=0),a.h=[t],a=t;}return a;}function pn(t,c,a){if(an.length){var b=an.pop();t&&(Jt(b.g,t),b.i=-1,b.h=-1),t=b;}else t=new Ae(t);try{var I=new c();return Ve(I,t,a[Me]||(a[Me]=a()));}finally{c=t.g,c.h=null,c.l=0,c.i=0,c.g=0,c.j=!1,c.v=!1,t.i=-1,t.h=-1,t.j=!1,100>an.length&&an.push(t);}}function Le(t,c,a){if(c=Dt(c,a),c!=null){Je(t.g,8*a+5),t=t.g;var b=c;b=(a=0>b?1:0)?-b:b,b===0?0<1/b?Ce=Pt=0:(Pt=0,Ce=2147483648):isNaN(b)?(Pt=0,Ce=2147483647):34028234663852886e22<b?(Pt=0,Ce=(a<<31|2139095040)>>>0):11754943508222875e-54>b?(b=Math.round(b/Math.pow(2,-149)),Pt=0,Ce=(a<<31|b)>>>0):(c=Math.floor(Math.log(b)/Math.LN2),b*=Math.pow(2,-c),b=Math.round(8388608*b),16777216<=b&&++c,Pt=0,Ce=(a<<31|c+127<<23|b&8388607)>>>0),a=Ce,zt(t,a>>>0&255),zt(t,a>>>8&255),zt(t,a>>>16&255),zt(t,a>>>24&255);}}function Fn(t,c,a){if(t.h!==1)return!1;var b=t.g;t=xe(b);var I=xe(b);b=2*(I>>31)+1;var F=I>>>20&2047;return t=4294967296*(I&1048575)+t,je(c,a,F==2047?t?NaN:1/0*b:F==0?b*Math.pow(2,-1074)*t:b*Math.pow(2,F-1075)*(t+4503599627370496),0),!0;}function ze(t,c,a){return t.h!==5?!1:(It(c,a,t.g.m()),!0);}function ln(t,c,a){if(t.h!==5&&t.h!==2)return!1;if(c=re(c,a),t.h==2){a=we.prototype.m;var b=ae(t.g);for(b=t.g.g+b;t.g.g<b;)c.push(a.call(t.g));}else c.push(t.g.m());return!0;}function Gn(t,c,a){return t.h!==5?!1:(t=t.g.m(),je(c,a,t,0),!0);}function Hn(t,c,a){return t.h!==0?!1:(It(c,a,Ze(t.g)),!0);}function Oe(t,c,a){return t.h!==0?!1:(It(c,a,ae(t.g)),!0);}function Xn(t,c,a){return t.h!==0?!1:(t=ae(t.g),je(c,a,t,0),!0);}function An(t,c,a){return t.h!==0?!1:(t=!!ae(t.g),je(c,a,t,!1),!0);}function Bn(t,c,a){if(t.h!==2)return!1;var b=ae(t.g);t=t.g;var I=t.g;t.g+=b,_t(t),t=t.h;var F;if(Ln)(F=Vn)||(F=Vn=new TextDecoder("utf-8",{fatal:!1})),F=F.decode(t.subarray(I,I+b));else{b=I+b;for(var H=[],E=null,j,_,Q;I<b;)j=t[I++],128>j?H.push(j):224>j?I>=b?H.push(65533):(_=t[I++],194>j||(_&192)!==128?(I--,H.push(65533)):H.push((j&31)<<6|_&63)):240>j?I>=b-1?H.push(65533):(_=t[I++],(_&192)!==128||j===224&&160>_||j===237&&160<=_||((F=t[I++])&192)!==128?(I--,H.push(65533)):H.push((j&15)<<12|(_&63)<<6|F&63)):244>=j?I>=b-2?H.push(65533):(_=t[I++],(_&192)!==128||(j<<28)+(_-144)>>30||((F=t[I++])&192)!==128||((Q=t[I++])&192)!==128?(I--,H.push(65533)):(j=(j&7)<<18|(_&63)<<12|(F&63)<<6|Q&63,j-=65536,H.push((j>>10&1023)+55296,(j&1023)+56320))):H.push(65533),8192<=H.length&&(E=Yn(E,H),H.length=0);F=Yn(E,H);}return It(c,a,F),!0;}function Wn(t,c,a,b,I){return t.h!==2?!1:(t=$e(t,new b(),I),c.g||(c.g={}),b=t&&t.u,c.g[a]=t,It(c,a,b,!1),!0);}function xn(t,c,a,b,I){return t.h!==2?!1:(t=$e(t,new b(),I),Ot(c,a,t,b,void 0),!0);}function p(t,c,a){return t.h!==0?!1:(It(c,a,Ze(t.g)),!0);}function W(t){Wt.call(this,t);}ht(W,Wt);function V(){return{1:Oe,2:ze,3:Bn,4:Bn};}function U(t,c){var a=Dt(t,1);if(a!=null&&a!=null){Je(c.g,8);var b=c.g;if(0<=a)Je(b,a);else{for(var I=0;9>I;I++)zt(b,a&127|128),a>>=7;zt(b,1);}}Le(c,t,2),b=Dt(t,3),b!=null&&Ie(c,3,Jn(b)),b=Dt(t,4),b!=null&&Ie(c,4,Jn(b)),qe(t,c);}function O(t){Wt.call(this,t,-1,K);}ht(O,Wt),O.prototype.addClassification=function(t,c){return Ot(this,1,t,W,c),this;};function rt(){return{1:[xn,W,V]};}var K=[1];function nt(t){Wt.call(this,t);}ht(nt,Wt);function dt(){return{1:ze,2:ze,3:ze,4:ze,5:ze};}function vt(t,c){Le(c,t,1),Le(c,t,2),Le(c,t,3),Le(c,t,4),Le(c,t,5),qe(t,c);}function Ct(t){Wt.call(this,t,-1,jt);}ht(Ct,Wt);function Tt(){return{1:[xn,nt,dt]};}var jt=[1];function wt(t){Wt.call(this,t);}ht(wt,Wt);function Vt(){return{1:ze,2:ze,3:ze,4:ze,5:ze,6:Hn};}function Ht(t,c){Le(c,t,1),Le(c,t,2),Le(c,t,3),Le(c,t,4),Le(c,t,5);var a=Dt(t,6);if(a!=null&&a!=null){Je(c.g,48);var b=c.g,I=a;a=0>I,I=Math.abs(I);var F=I>>>0;for(I=Math.floor((I-F)/4294967296),I>>>=0,a&&(I=~I>>>0,F=(~F>>>0)+1,4294967295<F&&(F=0,I++,4294967295<I&&(I=0))),Ce=F,Pt=I,a=Ce,F=Pt;0<F||127<a;)zt(b,a&127|128),a=(a>>>7|F<<25)>>>0,F>>>=7;zt(b,a);}qe(t,c);}function Et(t){Wt.call(this,t,-1,Re);}ht(Et,Wt);function te(){return{1:p,2:p,3:ln,4:[Wn,ie,le],5:Oe,6:Oe,7:ln,8:ln,9:ln};}function ie(t){Wt.call(this,t);}ht(ie,Wt);function le(){return{1:ze,2:ze,3:ze};}var Re=[3,7,8,9];function h(t){Wt.call(this,t);}ht(h,Wt);function y(){return{1:Gn,2:Gn,3:Gn};}function G(t){Wt.call(this,t);}ht(G,Wt);function C(){return{1:Gn,2:Gn,3:Gn};}function z(t){Wt.call(this,t);}ht(z,Wt);function P(){return{1:Xn,2:[Wn,G,C],3:[Wn,h,y],4:An};}function A(t){Wt.call(this,t,-1,ot);}ht(A,Wt);function q(){return{1:Xn,2:[xn,z,P],3:Gn,4:ln,5:ln,6:ln};}var ot=[2,4,5,6];function s(t){Wt.call(this,t,-1,R);}ht(s,Wt);function X(){return{1:Xn,2:[xn,A,q],3:[Wn,Et,te],4:Fn,5:ln,6:ln};}var R=[2,5,6];function w(t,c,a){if(a=t.createShader(a===0?t.VERTEX_SHADER:t.FRAGMENT_SHADER),t.shaderSource(a,c),t.compileShader(a),!t.getShaderParameter(a,t.COMPILE_STATUS))throw Error(`Could not compile WebGL shader.

`+t.getShaderInfoLog(a));return a;}function N(t){return Fe(t,W,1).map(function(c){return{index:ke(c,1),$:Bt(c,2),label:Dt(c,3)!=null?mn(c,3):void 0,displayName:Dt(c,4)!=null?mn(c,4):void 0};});}function B(t){return{x:Bt(t,1),y:Bt(t,2),z:Bt(t,3),visibility:Dt(t,4)!=null?Bt(t,4):void 0};}function M(t,c){this.h=t,this.g=c,this.l=0;}function et(t,c,a){return $(t,c),typeof t.g.canvas.transferToImageBitmap=="function"?Promise.resolve(t.g.canvas.transferToImageBitmap()):a?Promise.resolve(t.g.canvas):typeof createImageBitmap=="function"?createImageBitmap(t.g.canvas):(t.i===void 0&&(t.i=document.createElement("canvas")),new Promise(function(b){t.i.height=t.g.canvas.height,t.i.width=t.g.canvas.width,t.i.getContext("2d",{}).drawImage(t.g.canvas,0,0,t.g.canvas.width,t.g.canvas.height),b(t.i);}));}function $(t,c){var a=t.g;if(t.m===void 0){var b=w(a,`
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`,0),I=w(a,`
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`,1),F=a.createProgram();if(a.attachShader(F,b),a.attachShader(F,I),a.linkProgram(F),!a.getProgramParameter(F,a.LINK_STATUS))throw Error(`Could not compile WebGL program.

`+a.getProgramInfoLog(F));b=t.m=F,a.useProgram(b),I=a.getUniformLocation(b,"sampler0"),t.j={J:a.getAttribLocation(b,"aVertex"),I:a.getAttribLocation(b,"aTex"),ja:I},t.s=a.createBuffer(),a.bindBuffer(a.ARRAY_BUFFER,t.s),a.enableVertexAttribArray(t.j.J),a.vertexAttribPointer(t.j.J,2,a.FLOAT,!1,0,0),a.bufferData(a.ARRAY_BUFFER,new Float32Array([-1,-1,-1,1,1,1,1,-1]),a.STATIC_DRAW),a.bindBuffer(a.ARRAY_BUFFER,null),t.o=a.createBuffer(),a.bindBuffer(a.ARRAY_BUFFER,t.o),a.enableVertexAttribArray(t.j.I),a.vertexAttribPointer(t.j.I,2,a.FLOAT,!1,0,0),a.bufferData(a.ARRAY_BUFFER,new Float32Array([0,1,0,0,1,0,1,1]),a.STATIC_DRAW),a.bindBuffer(a.ARRAY_BUFFER,null),a.uniform1i(I,0);}b=t.j,a.useProgram(t.m),a.canvas.width=c.width,a.canvas.height=c.height,a.viewport(0,0,c.width,c.height),a.activeTexture(a.TEXTURE0),t.h.bindTexture2d(c.glName),a.enableVertexAttribArray(b.J),a.bindBuffer(a.ARRAY_BUFFER,t.s),a.vertexAttribPointer(b.J,2,a.FLOAT,!1,0,0),a.enableVertexAttribArray(b.I),a.bindBuffer(a.ARRAY_BUFFER,t.o),a.vertexAttribPointer(b.I,2,a.FLOAT,!1,0,0),a.bindFramebuffer(a.DRAW_FRAMEBUFFER?a.DRAW_FRAMEBUFFER:a.FRAMEBUFFER,null),a.clearColor(0,0,0,0),a.clear(a.COLOR_BUFFER_BIT),a.colorMask(!0,!0,!0,!0),a.drawArrays(a.TRIANGLE_FAN,0,4),a.disableVertexAttribArray(b.J),a.disableVertexAttribArray(b.I),a.bindBuffer(a.ARRAY_BUFFER,null),t.h.bindTexture2d(0);}function ft(t){this.g=t;}var gt=new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,10,9,1,7,0,65,0,253,15,26,11]);function Nt(t,c){return c+t;}function Gt(t,c){window[t]=c;}function lt(t){var c=document.createElement("script");return c.setAttribute("src",t),c.setAttribute("crossorigin","anonymous"),new Promise(function(a){c.addEventListener("load",function(){a();},!1),c.addEventListener("error",function(){a();},!1),document.body.appendChild(c);});}function Zt(){return yt(function(t){switch(t.g){case 1:return t.m=2,D(t,WebAssembly.instantiate(gt),4);case 4:t.g=3,t.m=0;break;case 2:return t.m=0,t.j=null,t.return(!1);case 3:return t.return(!0);}});}function Xt(t){if(this.g=t,this.listeners={},this.j={},this.G={},this.m={},this.s={},this.H=this.o=this.S=!0,this.D=Promise.resolve(),this.R="",this.C={},this.locateFile=t&&t.locateFile||Nt,typeof window=="object")var c=window.location.pathname.toString().substring(0,window.location.pathname.toString().lastIndexOf("/"))+"/";else if(typeof location<"u")c=location.pathname.toString().substring(0,location.pathname.toString().lastIndexOf("/"))+"/";else throw Error("solutions can only be loaded on a web page or in a web worker");if(this.T=c,t.options){c=T(Object.keys(t.options));for(var a=c.next();!a.done;a=c.next()){a=a.value;var b=t.options[a].default;b!==void 0&&(this.j[a]=typeof b=="function"?b():b);}}}r=Xt.prototype,r.close=function(){return this.i&&this.i.delete(),Promise.resolve();};function Rt(t){var c,a,b,I,F,H,E,j,_,Q,it;return yt(function(ct){switch(ct.g){case 1:return t.S?(c=t.g.files===void 0?[]:typeof t.g.files=="function"?t.g.files(t.j):t.g.files,D(ct,Zt(),2)):ct.return();case 2:if(a=ct.h,typeof window=="object")return Gt("createMediapipeSolutionsWasm",{locateFile:t.locateFile}),Gt("createMediapipeSolutionsPackedAssets",{locateFile:t.locateFile}),H=c.filter(function(ut){return ut.data!==void 0;}),E=c.filter(function(ut){return ut.data===void 0;}),j=Promise.all(H.map(function(ut){var pt=Z(t,ut.url);if(ut.path!==void 0){var mt=ut.path;pt=pt.then(function(kt){return t.overrideFile(mt,kt),Promise.resolve(kt);});}return pt;})),_=Promise.all(E.map(function(ut){return ut.simd===void 0||ut.simd&&a||!ut.simd&&!a?lt(t.locateFile(ut.url,t.T)):Promise.resolve();})).then(function(){var ut,pt,mt;return yt(function(kt){if(kt.g==1)return ut=window.createMediapipeSolutionsWasm,pt=window.createMediapipeSolutionsPackedAssets,mt=t,D(kt,ut(pt),2);mt.h=kt.h,kt.g=0;});}),Q=function(){return yt(function(ut){return t.g.graph&&t.g.graph.url?ut=D(ut,Z(t,t.g.graph.url),0):(ut.g=0,ut=void 0),ut;});}(),D(ct,Promise.all([_,j,Q]),7);if(typeof importScripts!="function")throw Error("solutions can only be loaded on a web page or in a web worker");return b=c.filter(function(ut){return ut.simd===void 0||ut.simd&&a||!ut.simd&&!a;}).map(function(ut){return t.locateFile(ut.url,t.T);}),importScripts.apply(null,k(b)),I=t,D(ct,createMediapipeSolutionsWasm(Module),6);case 6:I.h=ct.h,t.l=new OffscreenCanvas(1,1),t.h.canvas=t.l,F=t.h.GL.createContext(t.l,{antialias:!1,alpha:!1,ga:typeof WebGL2RenderingContext<"u"?2:1}),t.h.GL.makeContextCurrent(F),ct.g=4;break;case 7:if(t.l=document.createElement("canvas"),it=t.l.getContext("webgl2",{}),!it&&(it=t.l.getContext("webgl",{}),!it))return alert("Failed to create WebGL canvas context when passing video frame."),ct.return();t.F=it,t.h.canvas=t.l,t.h.createContext(t.l,!0,!0,{});case 4:t.i=new t.h.SolutionWasm(),t.S=!1,ct.g=0;}});}function St(t){var c,a,b,I,F,H,E,j;return yt(function(_){if(_.g==1){if(t.g.graph&&t.g.graph.url&&t.R===t.g.graph.url)return _.return();if(t.o=!0,!t.g.graph||!t.g.graph.url){_.g=2;return;}return t.R=t.g.graph.url,D(_,Z(t,t.g.graph.url),3);}for(_.g!=2&&(c=_.h,t.i.loadGraph(c)),a=T(Object.keys(t.C)),b=a.next();!b.done;b=a.next())I=b.value,t.i.overrideFile(I,t.C[I]);if(t.C={},t.g.listeners)for(F=T(t.g.listeners),H=F.next();!H.done;H=F.next())E=H.value,J(t,E);j=t.j,t.j={},t.setOptions(j),_.g=0;});}r.reset=function(){var t=this;return yt(function(c){t.i&&(t.i.reset(),t.m={},t.s={}),c.g=0;});},r.setOptions=function(t,c){var a=this;if(c=c||this.g.options){for(var b=[],I=[],F={},H=T(Object.keys(t)),E=H.next();!E.done;F={L:F.L,M:F.M},E=H.next()){var j=E.value;j in this.j&&this.j[j]===t[j]||(this.j[j]=t[j],E=c[j],E!==void 0&&(E.onChange&&(F.L=E.onChange,F.M=t[j],b.push(/* @__PURE__ */function(_){return function(){var Q;return yt(function(it){if(it.g==1)return D(it,_.L(_.M),2);Q=it.h,Q===!0&&(a.o=!0),it.g=0;});};}(F))),E.graphOptionXref&&(j={valueNumber:E.type===1?t[j]:0,valueBoolean:E.type===0?t[j]:!1,valueString:E.type===2?t[j]:""},E=Object.assign(Object.assign(Object.assign({},{calculatorName:"",calculatorIndex:0}),E.graphOptionXref),j),I.push(E))));}(b.length!==0||I.length!==0)&&(this.o=!0,this.B=(this.B===void 0?[]:this.B).concat(I),this.A=(this.A===void 0?[]:this.A).concat(b));}};function l(t){var c,a,b,I,F,H,E;return yt(function(j){switch(j.g){case 1:if(!t.o)return j.return();if(!t.A){j.g=2;break;}c=T(t.A),a=c.next();case 3:if(a.done){j.g=5;break;}return b=a.value,D(j,b(),4);case 4:a=c.next(),j.g=3;break;case 5:t.A=void 0;case 2:if(t.B){for(I=new t.h.GraphOptionChangeRequestList(),F=T(t.B),H=F.next();!H.done;H=F.next())E=H.value,I.push_back(E);t.i.changeOptions(I),I.delete(),t.B=void 0;}t.o=!1,j.g=0;}});}r.initialize=function(){var t=this;return yt(function(c){return c.g==1?D(c,Rt(t),2):c.g!=3?D(c,St(t),3):D(c,l(t),0);});};function Z(t,c){var a,b;return yt(function(I){return c in t.G?I.return(t.G[c]):(a=t.locateFile(c,""),b=fetch(a).then(function(F){return F.arrayBuffer();}),t.G[c]=b,I.return(b));});}r.overrideFile=function(t,c){this.i?this.i.overrideFile(t,c):this.C[t]=c;},r.clearOverriddenFiles=function(){this.C={},this.i&&this.i.clearOverriddenFiles();},r.send=function(t,c){var a=this,b,I,F,H,E,j,_,Q,it;return yt(function(ct){switch(ct.g){case 1:return a.g.inputs?(b=1e3*(c!=null?c:performance.now()),D(ct,a.D,2)):ct.return();case 2:return D(ct,a.initialize(),3);case 3:for(I=new a.h.PacketDataList(),F=T(Object.keys(t)),H=F.next();!H.done;H=F.next())if(E=H.value,j=a.g.inputs[E]){t:{var ut=t[E];switch(j.type){case"video":var pt=a.m[j.stream];if(pt||(pt=new M(a.h,a.F),a.m[j.stream]=pt),pt.l===0&&(pt.l=pt.h.createTexture()),typeof HTMLVideoElement<"u"&&ut instanceof HTMLVideoElement)var mt=ut.videoWidth,kt=ut.videoHeight;else typeof HTMLImageElement<"u"&&ut instanceof HTMLImageElement?(mt=ut.naturalWidth,kt=ut.naturalHeight):(mt=ut.width,kt=ut.height);kt={glName:pt.l,width:mt,height:kt},mt=pt.g,mt.canvas.width=kt.width,mt.canvas.height=kt.height,mt.activeTexture(mt.TEXTURE0),pt.h.bindTexture2d(pt.l),mt.texImage2D(mt.TEXTURE_2D,0,mt.RGBA,mt.RGBA,mt.UNSIGNED_BYTE,ut),pt.h.bindTexture2d(0),pt=kt;break t;case"detections":for(pt=a.m[j.stream],pt||(pt=new ft(a.h),a.m[j.stream]=pt),pt.data||(pt.data=new pt.g.DetectionListData()),pt.data.reset(ut.length),kt=0;kt<ut.length;++kt){mt=ut[kt];var $t=pt.data,qt=$t.setBoundingBox,Se=kt,dn=mt.U,Te=new wt();if(It(Te,1,dn.aa),It(Te,2,dn.ba),It(Te,3,dn.height),It(Te,4,dn.width),It(Te,5,dn.rotation),It(Te,6,dn.Z),dn=sn(Te,Ht),qt.call($t,Se,dn),mt.P)for($t=0;$t<mt.P.length;++$t){Te=mt.P[$t];var Tn=!!Te.visibility;qt=pt.data,Se=qt.addNormalizedLandmark,dn=kt,Te=Object.assign(Object.assign({},Te),{visibility:Tn?Te.visibility:0}),Tn=new nt(),It(Tn,1,Te.x),It(Tn,2,Te.y),It(Tn,3,Te.z),Te.visibility&&It(Tn,4,Te.visibility),Te=sn(Tn,vt),Se.call(qt,dn,Te);}if(mt.N)for($t=0;$t<mt.N.length;++$t)qt=pt.data,Se=qt.addClassification,dn=kt,Te=mt.N[$t],Tn=new W(),It(Tn,2,Te.$),Te.index&&It(Tn,1,Te.index),Te.label&&It(Tn,3,Te.label),Te.displayName&&It(Tn,4,Te.displayName),Te=sn(Tn,U),Se.call(qt,dn,Te);}pt=pt.data;break t;default:pt={};}}switch(_=pt,Q=j.stream,j.type){case"video":I.pushTexture2d(Object.assign(Object.assign({},_),{stream:Q,timestamp:b}));break;case"detections":it=_,it.stream=Q,it.timestamp=b,I.pushDetectionList(it);break;default:throw Error("Unknown input config type: '"+j.type+"'");}}return a.i.send(I),D(ct,a.D,4);case 4:I.delete(),ct.g=0;}});};function x(t,c,a){var b,I,F,H,E,j,_,Q,it,ct,ut,pt,mt,kt;return yt(function($t){switch($t.g){case 1:if(!a)return $t.return(c);for(b={},I=0,F=T(Object.keys(a)),H=F.next();!H.done;H=F.next())E=H.value,j=a[E],typeof j!="string"&&j.type==="texture"&&c[j.stream]!==void 0&&++I;1<I&&(t.H=!1),_=T(Object.keys(a)),H=_.next();case 2:if(H.done){$t.g=4;break;}if(Q=H.value,it=a[Q],typeof it=="string")return mt=b,kt=Q,D($t,Y(t,Q,c[it]),14);if(ct=c[it.stream],it.type==="detection_list"){if(ct){for(var qt=ct.getRectList(),Se=ct.getLandmarksList(),dn=ct.getClassificationsList(),Te=[],Tn=0;Tn<qt.size();++Tn){var nr=pn(qt.get(Tn),wt,Vt);nr={U:{aa:Bt(nr,1),ba:Bt(nr,2),height:Bt(nr,3),width:Bt(nr,4),rotation:Bt(nr,5,0),Z:ke(nr,6)},P:Fe(pn(Se.get(Tn),Ct,Tt),nt,1).map(B),N:N(pn(dn.get(Tn),O,rt))},Te.push(nr);}qt=Te;}else qt=[];b[Q]=qt,$t.g=7;break;}if(it.type==="proto_list"){if(ct){for(qt=Array(ct.size()),Se=0;Se<ct.size();Se++)qt[Se]=ct.get(Se);ct.delete();}else qt=[];b[Q]=qt,$t.g=7;break;}if(ct===void 0){$t.g=3;break;}if(it.type==="float_list"){b[Q]=ct,$t.g=7;break;}if(it.type==="proto"){b[Q]=ct,$t.g=7;break;}if(it.type!=="texture")throw Error("Unknown output config type: '"+it.type+"'");return ut=t.s[Q],ut||(ut=new M(t.h,t.F),t.s[Q]=ut),D($t,et(ut,ct,t.H),13);case 13:pt=$t.h,b[Q]=pt;case 7:it.transform&&b[Q]&&(b[Q]=it.transform(b[Q])),$t.g=3;break;case 14:mt[kt]=$t.h;case 3:H=_.next(),$t.g=2;break;case 4:return $t.return(b);}});}function Y(t,c,a){var b;return yt(function(I){return typeof a=="number"||a instanceof Uint8Array||a instanceof t.h.Uint8BlobList?I.return(a):a instanceof t.h.Texture2dDataOut?(b=t.s[c],b||(b=new M(t.h,t.F),t.s[c]=b),I.return(et(b,a,t.H))):I.return(void 0);});}function J(t,c){for(var a=c.name||"$",b=[].concat(k(c.wants)),I=new t.h.StringList(),F=T(c.wants),H=F.next();!H.done;H=F.next())I.push_back(H.value);F=t.h.PacketListener.implement({onResults:function onResults(E){for(var j={},_=0;_<c.wants.length;++_)j[b[_]]=E.get(_);var Q=t.listeners[a];Q&&(t.D=x(t,j,c.outs).then(function(it){it=Q(it);for(var ct=0;ct<c.wants.length;++ct){var ut=j[b[ct]];typeof ut=="object"&&ut.hasOwnProperty&&ut.hasOwnProperty("delete")&&ut.delete();}it&&(t.D=it);}));}}),t.i.attachMultiListener(I,F),I.delete();}r.onResults=function(t,c){this.listeners[c||"$"]=t;},Lt("Solution",Xt),Lt("OptionType",{BOOL:0,NUMBER:1,ca:2,0:"BOOL",1:"NUMBER",2:"STRING"});function o(t){var c=ke(t,1),a=Ke(t,h,3);return a={x:Bt(a,1),y:Bt(a,2),depth:Bt(a,3)},t=Ke(t,G,2),{id:c,point2d:a,point3d:{x:Bt(t,1),y:Bt(t,2),z:Bt(t,3)}};}function d(t){var c=pn(t,s,X);t=[],c=Fe(c,A,2);for(var a=0;a<c.length;a++)t.push({id:ke(c[a],1),keypoints:Fe(c[a],z,2).map(o),visibility:Bt(c[a],3),scale:Ne(c[a],6),translation:Ne(c[a],5),rotation:Ne(c[a],4)});return t;}function g(t){switch(t){case"Camera":return"object_detection_3d_camera.tflite";case"Chair":return"object_detection_3d_chair.tflite";case"Cup":return"object_detection_3d_cup.tflite";default:return"object_detection_3d_sneakers.tflite";}}function n(t){switch(t){case"Camera":return"Camera";case"Chair":return"Chair";case"Cup":return"Coffee cup, Mug";default:return"Footwear";}}var u={focalX:{type:1,graphOptionXref:{calculatorType:"Lift2DFrameAnnotationTo3DCalculator",fieldName:"normalized_focal_x"}},focalY:{type:1,graphOptionXref:{calculatorType:"Lift2DFrameAnnotationTo3DCalculator",fieldName:"normalized_focal_y"}},principalX:{type:1,graphOptionXref:{calculatorType:"Lift2DFrameAnnotationTo3DCalculator",fieldName:"normalized_principal_point_x"}},principalY:{type:1,graphOptionXref:{calculatorType:"Lift2DFrameAnnotationTo3DCalculator",fieldName:"normalized_principal_point_y"}},allowedLabels:{type:2,graphOptionXref:{calculatorName:"ConstantSidePacketCalculatorAllowedLabels",calculatorType:"ConstantSidePacketCalculator",fieldName:"string_value"}}};function f(t){var c=this;t=t||{},this.g=new Xt({locateFile:t.locateFile,files:[{url:"objectron_solution_packed_assets_loader.js"},{simd:!1,url:"objectron_solution_wasm_bin.js"},{simd:!0,url:"objectron_solution_simd_wasm_bin.js"}],graph:{url:"objectron.binarypb"},inputs:{image:{type:"video",stream:"input_frames_gpu"}},listeners:[{wants:["lifted_objects","image_transformed"],outs:{image:"image_transformed",objectDetections:{type:"proto",stream:"lifted_objects",transform:d}}}],options:{useCpuInference:{type:0,graphOptionXref:{calculatorType:"InferenceCalculator",fieldName:"use_cpu_inference"},default:typeof window!="object"||window.navigator===void 0?!1:"iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document},selfieMode:{type:0,default:!1,graphOptionXref:{calculatorType:"GlScalerCalculator",calculatorIndex:1,fieldName:"flip_horizontal"}},maxNumObjects:{type:1,default:5,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorMaxNumObjects",fieldName:"int_value"}},staticImageMode:{type:0,default:!0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"objectrongpusubgraph__ConstantSidePacketCalculator",fieldName:"bool_value"}},minDetectionConfidence:{type:1,default:0.5,graphOptionXref:{calculatorType:"TensorsToDetectionsCalculator",calculatorName:"objectrongpusubgraph__objectdetectionoidv4subgraph__TensorsToDetectionsCalculator",fieldName:"min_score_thresh"}},minTrackingConfidence:{type:1,default:0.99,graphOptionXref:{calculatorType:"ThresholdingCalculator",calculatorName:"objectrongpusubgraph__boxlandmarksubgraph__ThresholdingCalculator",fieldName:"threshold"}},modelName:{default:"Shoe",onChange:function onChange(a){var b,I,F,H;return yt(function(E){return E.g==1?(b=a,c.g.setOptions({allowedLabels:n(b)},u),I=g(b),F="object_detection_3d.tflite",D(E,Z(c.g,I),2)):(H=E.h,c.g.overrideFile(F,H),E.return(!0));});}},focalLength:{default:[1,1],onChange:function onChange(a){var b;return yt(function(I){return b=a,c.h=b,c.g.setOptions({focalX:b[0],focalY:b[1]},u),I.return(!0);});}},principalPoint:{default:[0,0],onChange:function onChange(a){var b;return yt(function(I){return b=a,c.i=b,c.g.setOptions({principalX:b[0],principalY:b[1]},u),I.return(!0);});}},imageSize:{onChange:function onChange(a){var b,I,F,H;return yt(function(E){if(c.h===void 0||c.i===void 0)return console.error('"focalLength" and "principalPoint" must be set if setting image size'),E.return();b=a,I=[b[0]/2,b[1]/2],F=[c.h[0]/I[0],c.h[1]/I[1]],H=[c.i[0]/I[0],c.i[1]/I[1]],c.setOptions({focalLength:F,principalPoint:H}),E.g=0;});}}}});}r=f.prototype,r.close=function(){return this.g.close(),Promise.resolve();},r.onResults=function(t){this.g.onResults(t);},r.initialize=function(){var t=this;return yt(function(c){return D(c,t.g.initialize(),0);});},r.reset=function(){this.g.reset();},r.send=function(t){var c=this;return yt(function(a){return D(a,c.g.send(t),0);});},r.setOptions=function(t){this.g.setOptions(t);},Lt("Objectron",f),Lt("BOX_CONNECTIONS",[[1,2],[2,4],[4,3],[3,1],[5,6],[6,8],[8,7],[7,5],[1,5],[2,6],[3,7],[4,8]]),Lt("BOX_KEYPOINTS",{CENTER:0,BACK_BOTTOM_LEFT:1,FRONT_BOTTOM_LEFT:2,BACK_TOP_LEFT:3,FRONT_TOP_LEFT:4,BACK_BOTTOM_RIGHT:5,FRONT_BOTTOM_RIGHT:6,BACK_TOP_RIGHT:7,FRONT_TOP_RIGHT:8}),Lt("VERSION","0.4.1636596145");}).call(Ti);const Yi={};(function(){var r;function e(s){var X=0;return function(){return X<s.length?{done:!1,value:s[X++]}:{done:!0};};}var i=typeof Object.defineProperties=="function"?Object.defineProperty:function(s,X,R){return s==Array.prototype||s==Object.prototype||(s[X]=R.value),s;};function m(s){s=[typeof globalThis=="object"&&globalThis,s,typeof window=="object"&&window,typeof self=="object"&&self,typeof (typeof window !== undefined ? window : global)=="object"&&(typeof window !== undefined ? window : global)];for(var X=0;X<s.length;++X){var R=s[X];if(R&&R.Math==Math)return R;}throw Error("Cannot find global object");}var v=m(this);function S(s,X){if(X)t:{var R=v;s=s.split(".");for(var w=0;w<s.length-1;w++){var N=s[w];if(!(N in R))break t;R=R[N];}s=s[s.length-1],w=R[s],X=X(w),X!=w&&X!=null&&i(R,s,{configurable:!0,writable:!0,value:X});}}S("Symbol",function(s){function X(B){if(this instanceof X)throw new TypeError("Symbol is not a constructor");return new R(w+(B||"")+"_"+N++,B);}function R(B,M){this.g=B,i(this,"description",{configurable:!0,writable:!0,value:M});}if(s)return s;R.prototype.toString=function(){return this.g;};var w="jscomp_symbol_"+(1e9*Math.random()>>>0)+"_",N=0;return X;}),S("Symbol.iterator",function(s){if(s)return s;s=Symbol("Symbol.iterator");for(var X="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),R=0;R<X.length;R++){var w=v[X[R]];typeof w=="function"&&typeof w.prototype[s]!="function"&&i(w.prototype,s,{configurable:!0,writable:!0,value:function value(){return L(e(this));}});}return s;});function L(s){return s={next:s},s[Symbol.iterator]=function(){return this;},s;}function T(s){var X=typeof Symbol<"u"&&Symbol.iterator&&s[Symbol.iterator];return X?X.call(s):{next:e(s)};}function k(s){if(!(s instanceof Array)){s=T(s);for(var X,R=[];!(X=s.next()).done;)R.push(X.value);s=R;}return s;}var tt=typeof Object.create=="function"?Object.create:function(s){function X(){}return X.prototype=s,new X();},st;if(typeof Object.setPrototypeOf=="function")st=Object.setPrototypeOf;else{var bt;t:{var xt={a:!0},Yt={};try{Yt.__proto__=xt,bt=Yt.a;break t;}catch(_unused10){}bt=!1;}st=bt?function(s,X){if(s.__proto__=X,s.__proto__!==X)throw new TypeError(s+" is not extensible");return s;}:null;}var at=st;function ht(s,X){if(s.prototype=tt(X.prototype),s.prototype.constructor=s,at)at(s,X);else for(var R in X)if(R!="prototype")if(Object.defineProperties){var w=Object.getOwnPropertyDescriptor(X,R);w&&Object.defineProperty(s,R,w);}else s[R]=X[R];s.ea=X.prototype;}function Ut(){this.l=!1,this.i=null,this.h=void 0,this.g=1,this.s=this.m=0,this.j=null;}function Mt(s){if(s.l)throw new TypeError("Generator is already running");s.l=!0;}Ut.prototype.o=function(s){this.h=s;};function oe(s,X){s.j={U:X,V:!0},s.g=s.m||s.s;}Ut.prototype.return=function(s){this.j={return:s},this.g=this.s;};function D(s,X,R){return s.g=R,{value:X};}function hn(s){this.g=new Ut(),this.h=s;}function bn(s,X){Mt(s.g);var R=s.g.i;return R?ge(s,"return"in R?R.return:function(w){return{value:w,done:!0};},X,s.g.return):(s.g.return(X),Kt(s));}function ge(s,X,R,w){try{var N=X.call(s.g.i,R);if(!(N instanceof Object))throw new TypeError("Iterator result "+N+" is not an object");if(!N.done)return s.g.l=!1,N;var B=N.value;}catch(M){return s.g.i=null,oe(s.g,M),Kt(s);}return s.g.i=null,w.call(s.g,B),Kt(s);}function Kt(s){for(;s.g.g;)try{var X=s.h(s.g);if(X)return s.g.l=!1,{value:X.value,done:!1};}catch(R){s.g.h=void 0,oe(s.g,R);}if(s.g.l=!1,s.g.j){if(X=s.g.j,s.g.j=null,X.V)throw X.U;return{value:X.return,done:!0};}return{value:void 0,done:!0};}function jn(s){this.next=function(X){return Mt(s.g),s.g.i?X=ge(s,s.g.i.next,X,s.g.o):(s.g.o(X),X=Kt(s)),X;},this.throw=function(X){return Mt(s.g),s.g.i?X=ge(s,s.g.i.throw,X,s.g.o):(oe(s.g,X),X=Kt(s)),X;},this.return=function(X){return bn(s,X);},this[Symbol.iterator]=function(){return this;};}function ue(s){function X(w){return s.next(w);}function R(w){return s.throw(w);}return new Promise(function(w,N){function B(M){M.done?w(M.value):Promise.resolve(M.value).then(X,R).then(B,N);}B(s.next());});}function yt(s){return ue(new jn(new hn(s)));}S("Promise",function(s){function X(M){this.h=0,this.i=void 0,this.g=[],this.o=!1;var et=this.j();try{M(et.resolve,et.reject);}catch($){et.reject($);}}function R(){this.g=null;}function w(M){return M instanceof X?M:new X(function(et){et(M);});}if(s)return s;R.prototype.h=function(M){if(this.g==null){this.g=[];var et=this;this.i(function(){et.l();});}this.g.push(M);};var N=v.setTimeout;R.prototype.i=function(M){N(M,0);},R.prototype.l=function(){for(;this.g&&this.g.length;){var M=this.g;this.g=[];for(var et=0;et<M.length;++et){var $=M[et];M[et]=null;try{$();}catch(ft){this.j(ft);}}}this.g=null;},R.prototype.j=function(M){this.i(function(){throw M;});},X.prototype.j=function(){function M(ft){return function(gt){$||($=!0,ft.call(et,gt));};}var et=this,$=!1;return{resolve:M(this.C),reject:M(this.l)};},X.prototype.C=function(M){if(M===this)this.l(new TypeError("A Promise cannot resolve to itself"));else if(M instanceof X)this.F(M);else{t:switch(typeof M){case"object":var et=M!=null;break t;case"function":et=!0;break t;default:et=!1;}et?this.v(M):this.m(M);}},X.prototype.v=function(M){var et=void 0;try{et=M.then;}catch($){this.l($);return;}typeof et=="function"?this.G(et,M):this.m(M);},X.prototype.l=function(M){this.s(2,M);},X.prototype.m=function(M){this.s(1,M);},X.prototype.s=function(M,et){if(this.h!=0)throw Error("Cannot settle("+M+", "+et+"): Promise already settled in state"+this.h);this.h=M,this.i=et,this.h===2&&this.D(),this.A();},X.prototype.D=function(){var M=this;N(function(){if(M.B()){var et=v.console;typeof et<"u"&&et.error(M.i);}},1);},X.prototype.B=function(){if(this.o)return!1;var M=v.CustomEvent,et=v.Event,$=v.dispatchEvent;return typeof $>"u"?!0:(typeof M=="function"?M=new M("unhandledrejection",{cancelable:!0}):typeof et=="function"?M=new et("unhandledrejection",{cancelable:!0}):(M=v.document.createEvent("CustomEvent"),M.initCustomEvent("unhandledrejection",!1,!0,M)),M.promise=this,M.reason=this.i,$(M));},X.prototype.A=function(){if(this.g!=null){for(var M=0;M<this.g.length;++M)B.h(this.g[M]);this.g=null;}};var B=new R();return X.prototype.F=function(M){var et=this.j();M.J(et.resolve,et.reject);},X.prototype.G=function(M,et){var $=this.j();try{M.call(et,$.resolve,$.reject);}catch(ft){$.reject(ft);}},X.prototype.then=function(M,et){function $(Gt,lt){return typeof Gt=="function"?function(Zt){try{ft(Gt(Zt));}catch(Xt){gt(Xt);}}:lt;}var ft,gt,Nt=new X(function(Gt,lt){ft=Gt,gt=lt;});return this.J($(M,ft),$(et,gt)),Nt;},X.prototype.catch=function(M){return this.then(void 0,M);},X.prototype.J=function(M,et){function $(){switch(ft.h){case 1:M(ft.i);break;case 2:et(ft.i);break;default:throw Error("Unexpected state: "+ft.h);}}var ft=this;this.g==null?B.h($):this.g.push($),this.o=!0;},X.resolve=w,X.reject=function(M){return new X(function(et,$){$(M);});},X.race=function(M){return new X(function(et,$){for(var ft=T(M),gt=ft.next();!gt.done;gt=ft.next())w(gt.value).J(et,$);});},X.all=function(M){var et=T(M),$=et.next();return $.done?w([]):new X(function(ft,gt){function Nt(Zt){return function(Xt){Gt[Zt]=Xt,lt--,lt==0&&ft(Gt);};}var Gt=[],lt=0;do Gt.push(void 0),lt++,w($.value).J(Nt(Gt.length-1),gt),$=et.next();while(!$.done);});},X;});function Kn(s,X){s instanceof String&&(s+="");var R=0,w=!1,N={next:function next(){if(!w&&R<s.length){var B=R++;return{value:X(B,s[B]),done:!1};}return w=!0,{done:!0,value:void 0};}};return N[Symbol.iterator]=function(){return N;},N;}var On=typeof Object.assign=="function"?Object.assign:function(s,X){for(var R=1;R<arguments.length;R++){var w=arguments[R];if(w)for(var N in w)Object.prototype.hasOwnProperty.call(w,N)&&(s[N]=w[N]);}return s;};S("Object.assign",function(s){return s||On;}),S("Object.is",function(s){return s||function(X,R){return X===R?X!==0||1/X===1/R:X!==X&&R!==R;};}),S("Array.prototype.includes",function(s){return s||function(X,R){var w=this;w instanceof String&&(w=String(w));var N=w.length;for(R=R||0,0>R&&(R=Math.max(R+N,0));R<N;R++){var B=w[R];if(B===X||Object.is(B,X))return!0;}return!1;};}),S("String.prototype.includes",function(s){return s||function(X,R){if(this==null)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(X instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return this.indexOf(X,R||0)!==-1;};}),S("Array.prototype.keys",function(s){return s||function(){return Kn(this,function(X){return X;});};});var Xe=this||self;function Lt(s,X){s=s.split(".");var R=Xe;s[0]in R||typeof R.execScript>"u"||R.execScript("var "+s[0]);for(var w;s.length&&(w=s.shift());)s.length||X===void 0?R[w]&&R[w]!==Object.prototype[w]?R=R[w]:R=R[w]={}:R[w]=X;}function Ye(s){Xe.setTimeout(function(){throw s;},0);}function nn(s){Ye(s);}function yn(s,X){nn(Error("Invalid wire type: "+s+" (at position "+X+")"));}function Yn(){nn(Error("Failed to read varint, encoding is invalid."));}function Vn(s,X){return X=String.fromCharCode.apply(null,X),s==null?X:s+X;}var Ln,rn=typeof TextDecoder<"u",un,Jn=typeof TextEncoder<"u";function wn(s){if(Jn)s=(un||(un=new TextEncoder())).encode(s);else{var X=void 0;X=X===void 0?!1:X;for(var R=0,w=new Uint8Array(3*s.length),N=0;N<s.length;N++){var B=s.charCodeAt(N);if(128>B)w[R++]=B;else{if(2048>B)w[R++]=B>>6|192;else{if(55296<=B&&57343>=B){if(56319>=B&&N<s.length){var M=s.charCodeAt(++N);if(56320<=M&&57343>=M){B=1024*(B-55296)+M-56320+65536,w[R++]=B>>18|240,w[R++]=B>>12&63|128,w[R++]=B>>6&63|128,w[R++]=B&63|128;continue;}else N--;}if(X)throw Error("Found an unpaired surrogate");B=65533;}w[R++]=B>>12|224,w[R++]=B>>6&63|128;}w[R++]=B&63|128;}}s=w.subarray(0,R);}return s;}var gn={},on=null;function Rn(s){var X;X===void 0&&(X=0),We(),X=gn[X];for(var R=Array(Math.floor(s.length/3)),w=X[64]||"",N=0,B=0;N<s.length-2;N+=3){var M=s[N],et=s[N+1],$=s[N+2],ft=X[M>>2];M=X[(M&3)<<4|et>>4],et=X[(et&15)<<2|$>>6],$=X[$&63],R[B++]=ft+M+et+$;}switch(ft=0,$=w,s.length-N){case 2:ft=s[N+1],$=X[(ft&15)<<2]||w;case 1:s=s[N],R[B]=X[s>>2]+X[(s&3)<<4|ft>>4]+$+w;}return R.join("");}function Zn(s){var X=s.length,R=3*X/4;R%3?R=Math.floor(R):"=.".indexOf(s[X-1])!=-1&&(R="=.".indexOf(s[X-2])!=-1?R-2:R-1);var w=new Uint8Array(R),N=0;return be(s,function(B){w[N++]=B;}),w.subarray(0,N);}function be(s,X){function R($){for(;w<s.length;){var ft=s.charAt(w++),gt=on[ft];if(gt!=null)return gt;if(!/^[\s\xa0]*$/.test(ft))throw Error("Unknown base64 encoding at char: "+ft);}return $;}We();for(var w=0;;){var N=R(-1),B=R(0),M=R(64),et=R(64);if(et===64&&N===-1)break;X(N<<2|B>>4),M!=64&&(X(B<<4&240|M>>2),et!=64&&X(M<<6&192|et));}}function We(){if(!on){on={};for(var s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),X=["+/=","+/","-_=","-_.","-_"],R=0;5>R;R++){var w=s.concat(X[R].split(""));gn[R]=w;for(var N=0;N<w.length;N++){var B=w[N];on[B]===void 0&&(on[B]=N);}}}}var Pe=typeof Uint8Array=="function",pe;function ye(s){if(this.g=s,s!==null&&s.length===0)throw Error("ByteString should be constructed with non-empty values");}ye.prototype.toJSON=function(){if(this.g==null)var s="";else s=this.g,s=this.g=s==null||typeof s=="string"?s:Pe&&s instanceof Uint8Array?Rn(s):null;return s;};var De=typeof Uint8Array.prototype.slice=="function";function Ce(s,X,R){return X===R?pe||(pe=new Uint8Array(0)):De?s.slice(X,R):new Uint8Array(s.subarray(X,R));}var Pt=0,de=0;function we(s){if(s.constructor===Uint8Array)return s;if(s.constructor===ArrayBuffer)return new Uint8Array(s);if(s.constructor===Array)return new Uint8Array(s);if(s.constructor===String)return Zn(s);if(s.constructor===ye){if(s.g==null)var X=pe||(pe=new Uint8Array(0));else{X=Uint8Array;var R=s.g;R=R==null||Pe&&R!=null&&R instanceof Uint8Array?R:typeof R=="string"?Zn(R):null,s=s.g=R,X=new X(s);}return X;}if(s instanceof Uint8Array)return new Uint8Array(s.buffer,s.byteOffset,s.byteLength);throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");}function Jt(s,X){X=X===void 0?{}:X,X=X.u===void 0?!1:X.u,this.h=null,this.g=this.i=this.l=0,this.j=!1,this.u=X,s&&Ze(this,s);}function Ze(s,X){s.h=we(X),s.l=0,s.i=s.h.length,s.g=s.l;}Jt.prototype.reset=function(){this.g=this.l;};function _t(s){s.g>s.i&&(s.j=!0,nn(Error("Tried to read past the end of the data "+s.g+" > "+s.i)));}function ae(s){var X=s.h,R=X[s.g],w=R&127;return 128>R?(s.g+=1,_t(s),w):(R=X[s.g+1],w|=(R&127)<<7,128>R?(s.g+=2,_t(s),w):(R=X[s.g+2],w|=(R&127)<<14,128>R?(s.g+=3,_t(s),w):(R=X[s.g+3],w|=(R&127)<<21,128>R?(s.g+=4,_t(s),w):(R=X[s.g+4],w|=(R&15)<<28,128>R?(s.g+=5,_t(s),w>>>0):(s.g+=5,128<=X[s.g++]&&128<=X[s.g++]&&128<=X[s.g++]&&128<=X[s.g++]&&128<=X[s.g++]?(s.j=!0,Yn(),w):(_t(s),w))))));}var xe=[];function _e(){this.g=new Uint8Array(64),this.h=0;}function me(s,X){if(!(s.h+1<s.g.length)){var R=s.g;s.g=new Uint8Array(Math.ceil(1+2*s.g.length)),s.g.set(R);}s.g[s.h++]=X;}_e.prototype.length=function(){return this.h;},_e.prototype.end=function(){var s=this.g,X=this.h;return this.h=0,Ce(s,0,X);};function zt(s,X){for(;127<X;)me(s,X&127|128),X>>>=7;me(s,X);}function Je(s){var X={},R=X.N===void 0?!1:X.N;this.m={u:X.u===void 0?!1:X.u},this.N=R,X=this.m,xe.length?(R=xe.pop(),X&&(R.u=X.u),s&&Ze(R,s),s=R):s=new Jt(s,X),this.g=s,this.l=this.g.g,this.h=this.i=-1,this.j=!1;}Je.prototype.reset=function(){this.g.reset(),this.h=this.i=-1;};function Ae(s){var X=s.g;if((X=X.g==X.i)||(X=s.j)||(X=s.g,X=X.j||0>X.g||X.g>X.i),X)return!1;s.l=s.g.g;var R=ae(s.g);return X=R>>>3,R&=7,0<=R&&5>=R?(s.i=X,s.h=R,!0):(s.j=!0,yn(R,s.l),!1);}function ve(s){switch(s.h){case 0:if(s.h!=0)ve(s);else t:{s=s.g;for(var X=s.g,R=0;10>R;R++){if(!(s.h[X]&128)){s.g=X+1,_t(s);break t;}X++;}s.j=!0,Yn();}break;case 1:s=s.g,s.g+=8,_t(s);break;case 2:s.h!=2?ve(s):(X=ae(s.g),s=s.g,s.g+=X,_t(s));break;case 5:s=s.g,s.g+=4,_t(s);break;case 3:X=s.i;do{if(!Ae(s)){s.j=!0,nn(Error("Unmatched start-group tag: stream EOF"));break;}if(s.h==4){s.i!=X&&(s.j=!0,nn(Error("Unmatched end-group tag")));break;}ve(s);}while(!0);break;default:s.j=!0,yn(s.h,s.l);}}function Sn(s,X,R){s.N||(s=Ce(s.g.h,R,s.g.g),(R=X.m)?R.push(s):X.m=[s]);}var $e=[];function an(){this.h=[],this.i=0,this.g=new _e();}function fn(s,X){X.length!==0&&(s.h.push(X),s.i+=X.length);}function he(s,X,R){zt(s.g,8*X+2),zt(s.g,R.length),fn(s,s.g.end()),fn(s,R);}var Ie=typeof Symbol=="function"&&typeof Symbol()=="symbol"?Symbol(void 0):void 0;function fe(s,X){Object.isFrozen(s)||(Ie?s[Ie]|=X:s.g!==void 0?s.g|=X:Object.defineProperties(s,{g:{value:X,configurable:!0,writable:!0,enumerable:!1}}));}function ee(s){var _X;if(!s)return 0;var X;return Ie?X=s[Ie]:X=s.g,(_X=X)!=null?_X:0;}function Be(s){return Array.isArray(s)&&fe(s,1),s;}function Qt(s){if(!Array.isArray(s))throw Error("cannot mark non-array as immutable");fe(s,2);}function At(s){return s!==null&&typeof s=="object"&&s.constructor===Object;}function vn(s){switch(typeof s){case"number":return isFinite(s)?s:String(s);case"object":return Pe&&s!=null&&s instanceof Uint8Array?Rn(s):s;default:return s;}}function se(s,X){if(s!=null)return Array.isArray(s)||At(s)?Ft(s,X):X(s);}function Ft(s,X){if(Array.isArray(s)){for(var R=Array(s.length),w=0;w<s.length;w++)R[w]=se(s[w],X);return ee(s)&1&&Be(R),R;}R={};for(w in s)R[w]=se(s[w],X);return R;}var Wt;function ne(s,X,R){var w=Wt;Wt=null,s||(s=w),w=this.constructor.ca,s||(s=w?[w]:[]),this.j=(w?0:-1)-(this.constructor.aa||0),this.i=null,this.g=s;t:{if(w=this.g.length,s=w-1,w&&(w=this.g[s],At(w))){this.l=s-this.j,this.h=w;break t;}X!==void 0&&-1<X?(this.l=Math.max(X,s+1-this.j),this.h=null):this.l=Number.MAX_VALUE;}if(R)for(X=0;X<R.length;X++)s=R[X],s<this.l?(s+=this.j,(w=this.g[s])?Be(w):this.g[s]=He):(Dt(this),(w=this.h[s])?Be(w):this.h[s]=He);}var He=Object.freeze(Be([]));function Dt(s){var X=s.l+s.j;s.g[X]||(s.h=s.g[X]={});}function re(s,X,R){return X===-1?null:R!==void 0&&R||X>=s.l?s.h?s.h[X]:void 0:s.g[X+s.j];}function Ne(s,X,R){R=R===void 0?!0:R;var w=w===void 0?!1:w,N=re(s,X,w);return N==null&&(N=He),N===He?(N=Be([]),It(s,X,N,w)):R&&Array.isArray(N)&&ee(N)&2&&(N=N.slice(),It(s,X,N,w)),N;}function Bt(s,X,R){var _s2;return s=re(s,X),s=s==null?s:+s,(_s2=s)!=null?_s2:R===void 0?0:R;}function It(s,X,R,w){w!==void 0&&w||X>=s.l?(Dt(s),s.h[X]=R):s.g[X+s.j]=R;}function je(s,X,R){s.i||(s.i={});var w=s.i[R];if(!w){var N=Ne(s,R,!1);w=[];for(var B=Array.isArray(N)?!!(ee(N)&2):!1,M=0;M<N.length;M++)w[M]=new X(N[M]),B&&Qt(w[M].g);B&&(Qt(w),Object.freeze(w)),s.i[R]=w;}return w;}function Ke(s,X,R,w,N){var B=je(s,w,X);R=R||new w(),s=Ne(s,X),N!=null?(B.splice(N,0,R),s.splice(N,0,Fe(R))):(B.push(R),s.push(Fe(R)));}ne.prototype.toJSON=function(){var s=Fe(this);return Ft(s,vn);};function Fe(s){if(s.i)for(var X in s.i){var R=s.i[X];if(Array.isArray(R))for(var w=0;w<R.length;w++)R[w]&&Fe(R[w]);else R&&Fe(R);}return s.g;}ne.prototype.toString=function(){return Fe(this).toString();};function Ot(s,X){var _s3;return s=re(s,X),(_s3=s)!=null?_s3:0;}function ke(s,X){var _s4;return s=re(s,X),(_s4=s)!=null?_s4:"";}function mn(s,X){if(s=s.m){fn(X,X.g.end());for(var R=0;R<s.length;R++)fn(X,s[R]);}}function qe(s){var X=s[0];switch(s.length){case 2:var R=s[1];return function($,ft,gt){return X($,ft,gt,R);};case 3:var w=s[1],N=s[2];return function($,ft,gt){return X($,ft,gt,w,N);};case 4:var B=s[1],M=s[2],et=s[3];return function($,ft,gt){return X($,ft,gt,B,M,et);};default:throw Error("unsupported number of parameters, expected [2-4], got "+s.length);}}function Ue(s,X,R){for(;Ae(X)&&X.h!=4;){var w=X.i,N=R[w];if(N){if(Array.isArray(N)&&(N=R[w]=qe(N)),!N(X,s,w)){w=X,N=s;var B=w.l;ve(w),Sn(w,N,B);}}else w=X,N=s,B=w.l,ve(w),Sn(w,N,B);}return s;}function Qe(s,X){var R=new an();if(X(s,R),s=R.i+R.g.length(),s===0)R=new Uint8Array(0);else{s=new Uint8Array(s);for(var w=R.h,N=w.length,B=X=0;B<N;B++){var M=w[B];M.length!==0&&(s.set(M,X),X+=M.length);}w=R.g,N=w.h,N!==0&&(s.set(w.g.subarray(0,N),X),w.h=0),R.h=[s],R=s;}return R;}function tn(s,X,R){if($e.length){var w=$e.pop();s&&(Ze(w.g,s),w.i=-1,w.h=-1),s=w;}else s=new Je(s);try{return R(new X(),s);}finally{X=s.g,X.h=null,X.l=0,X.i=0,X.g=0,X.j=!1,X.u=!1,s.i=-1,s.h=-1,s.j=!1,100>$e.length&&$e.push(s);}}function Ge(s,X,R){if(X=re(X,R),X!=null){zt(s.g,8*R+5),s=s.g;var w=X;w=(R=0>w?1:0)?-w:w,w===0?0<1/w?Pt=de=0:(de=0,Pt=2147483648):isNaN(w)?(de=0,Pt=2147483647):34028234663852886e22<w?(de=0,Pt=(R<<31|2139095040)>>>0):11754943508222875e-54>w?(w=Math.round(w/Math.pow(2,-149)),de=0,Pt=(R<<31|w)>>>0):(X=Math.floor(Math.log(w)/Math.LN2),w*=Math.pow(2,-X),w=Math.round(8388608*w),16777216<=w&&++X,de=0,Pt=(R<<31|X+127<<23|w&8388607)>>>0),R=Pt,me(s,R>>>0&255),me(s,R>>>8&255),me(s,R>>>16&255),me(s,R>>>24&255);}}function Ee(s,X,R){if(s.h!==5)return!1;s=s.g;var w=s.h[s.g],N=s.h[s.g+1],B=s.h[s.g+2],M=s.h[s.g+3];return s.g+=4,_t(s),N=(w<<0|N<<8|B<<16|M<<24)>>>0,s=2*(N>>31)+1,w=N>>>23&255,N&=8388607,It(X,R,w==255?N?NaN:1/0*s:w==0?s*Math.pow(2,-149)*N:s*Math.pow(2,w-150)*(N+Math.pow(2,23))),!0;}function kn(s,X,R){if(s.h!==0)return!1;for(var w=s.g,N=128,B=0,M=s=0;4>M&&128<=N;M++)N=w.h[w.g++],B|=(N&127)<<7*M;if(128<=N&&(N=w.h[w.g++],B|=(N&127)<<28,s|=(N&127)>>4),128<=N)for(M=0;5>M&&128<=N;M++)N=w.h[w.g++],s|=(N&127)<<7*M+3;return 128>N?(w=B>>>0,N=s>>>0,(s=N&2147483648)&&(w=~w+1>>>0,N=~N>>>0,w==0&&(N=N+1>>>0)),w=4294967296*N+(w>>>0),s=s?-w:w):(w.j=!0,Yn(),s=void 0),It(X,R,s),!0;}function Me(s,X,R){return s.h!==0?!1:(It(X,R,ae(s.g)),!0);}function Ve(s,X,R){if(s.h!==2)return!1;var w=ae(s.g);s=s.g;var N=s.g;s.g+=w,_t(s),s=s.h;var B;if(rn)(B=Ln)||(B=Ln=new TextDecoder("utf-8",{fatal:!1})),B=B.decode(s.subarray(N,N+w));else{w=N+w;for(var M=[],et=null,$,ft,gt;N<w;)$=s[N++],128>$?M.push($):224>$?N>=w?M.push(65533):(ft=s[N++],194>$||(ft&192)!==128?(N--,M.push(65533)):M.push(($&31)<<6|ft&63)):240>$?N>=w-1?M.push(65533):(ft=s[N++],(ft&192)!==128||$===224&&160>ft||$===237&&160<=ft||((B=s[N++])&192)!==128?(N--,M.push(65533)):M.push(($&15)<<12|(ft&63)<<6|B&63)):244>=$?N>=w-2?M.push(65533):(ft=s[N++],(ft&192)!==128||($<<28)+(ft-144)>>30||((B=s[N++])&192)!==128||((gt=s[N++])&192)!==128?(N--,M.push(65533)):($=($&7)<<18|(ft&63)<<12|(B&63)<<6|gt&63,$-=65536,M.push(($>>10&1023)+55296,($&1023)+56320))):M.push(65533),8192<=M.length&&(et=Vn(et,M),M.length=0);B=Vn(et,M);}return It(X,R,B),!0;}function sn(s,X,R,w,N){if(s.h!==2)return!1;var B=new w(),M=s.g.i,et=ae(s.g),$=s.g.g+et;if(s.g.i=$,N(B,s),N=$-s.g.g,N!==0)throw Error("Message parsing ended unexpectedly. Expected to read "+(et+" bytes, instead read "+(et-N)+" bytes, either the data ended unexpectedly or the message misreported its own length"));return s.g.g=$,s.g.i=M,Ke(X,R,B,w,void 0),!0;}function pn(s){ne.call(this,s);}var Le;ht(pn,ne);function Fn(s,X){var R=re(s,1);if(R!=null&&R!=null){zt(X.g,8);var w=X.g;if(0<=R)zt(w,R);else{for(var N=0;9>N;N++)me(w,R&127|128),R>>=7;me(w,1);}}Ge(X,s,2),w=re(s,3),w!=null&&he(X,3,wn(w)),w=re(s,4),w!=null&&he(X,4,wn(w)),mn(s,X);}function ze(s,X){return Ue(s,X,Le||(Le={1:Me,2:Ee,3:Ve,4:Ve}));}function ln(s){ne.call(this,s,-1,Oe);}var Gn;ht(ln,ne),ln.prototype.addClassification=function(s,X){return Ke(this,1,s,pn,X),this;};function Hn(s,X){return Ue(s,X,Gn||(Gn={1:[sn,pn,ze]}));}var Oe=[1];function Xn(s){ne.call(this,s);}var An;ht(Xn,ne);function Bn(s,X){Ge(X,s,1),Ge(X,s,2),Ge(X,s,3),Ge(X,s,4),Ge(X,s,5),mn(s,X);}function Wn(s,X){return Ue(s,X,An||(An={1:Ee,2:Ee,3:Ee,4:Ee,5:Ee}));}function xn(s){ne.call(this,s,-1,V);}var p;ht(xn,ne);function W(s,X){return Ue(s,X,p||(p={1:[sn,Xn,Wn]}));}var V=[1];function U(s){ne.call(this,s);}var O;ht(U,ne);function rt(s,X){Ge(X,s,1),Ge(X,s,2),Ge(X,s,3),Ge(X,s,4),Ge(X,s,5);var R=re(s,6);if(R!=null&&R!=null){zt(X.g,48);var w=X.g,N=R;R=0>N,N=Math.abs(N);var B=N>>>0;for(N=Math.floor((N-B)/4294967296),N>>>=0,R&&(N=~N>>>0,B=(~B>>>0)+1,4294967295<B&&(B=0,N++,4294967295<N&&(N=0))),Pt=B,de=N,R=Pt,B=de;0<B||127<R;)me(w,R&127|128),R=(R>>>7|B<<25)>>>0,B>>>=7;me(w,R);}mn(s,X);}function K(s,X){return Ue(s,X,O||(O={1:Ee,2:Ee,3:Ee,4:Ee,5:Ee,6:kn}));}function nt(s,X,R){if(R=s.createShader(R===0?s.VERTEX_SHADER:s.FRAGMENT_SHADER),s.shaderSource(R,X),s.compileShader(R),!s.getShaderParameter(R,s.COMPILE_STATUS))throw Error(`Could not compile WebGL shader.

`+s.getShaderInfoLog(R));return R;}function dt(s){return je(s,pn,1).map(function(X){return{index:Ot(X,1),X:Bt(X,2),label:re(X,3)!=null?ke(X,3):void 0,displayName:re(X,4)!=null?ke(X,4):void 0};});}function vt(s){return{x:Bt(s,1),y:Bt(s,2),z:Bt(s,3),visibility:re(s,4)!=null?Bt(s,4):void 0};}function Ct(s){return je(tn(s,xn,W),Xn,1).map(vt);}function Tt(s,X){this.h=s,this.g=X,this.l=0;}function jt(s,X,R){return wt(s,X),typeof s.g.canvas.transferToImageBitmap=="function"?Promise.resolve(s.g.canvas.transferToImageBitmap()):R?Promise.resolve(s.g.canvas):typeof createImageBitmap=="function"?createImageBitmap(s.g.canvas):(s.i===void 0&&(s.i=document.createElement("canvas")),new Promise(function(w){s.i.height=s.g.canvas.height,s.i.width=s.g.canvas.width,s.i.getContext("2d",{}).drawImage(s.g.canvas,0,0,s.g.canvas.width,s.g.canvas.height),w(s.i);}));}function wt(s,X){var R=s.g;if(s.m===void 0){var w=nt(R,`
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`,0),N=nt(R,`
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`,1),B=R.createProgram();if(R.attachShader(B,w),R.attachShader(B,N),R.linkProgram(B),!R.getProgramParameter(B,R.LINK_STATUS))throw Error(`Could not compile WebGL program.

`+R.getProgramInfoLog(B));w=s.m=B,R.useProgram(w),N=R.getUniformLocation(w,"sampler0"),s.j={I:R.getAttribLocation(w,"aVertex"),H:R.getAttribLocation(w,"aTex"),da:N},s.s=R.createBuffer(),R.bindBuffer(R.ARRAY_BUFFER,s.s),R.enableVertexAttribArray(s.j.I),R.vertexAttribPointer(s.j.I,2,R.FLOAT,!1,0,0),R.bufferData(R.ARRAY_BUFFER,new Float32Array([-1,-1,-1,1,1,1,1,-1]),R.STATIC_DRAW),R.bindBuffer(R.ARRAY_BUFFER,null),s.o=R.createBuffer(),R.bindBuffer(R.ARRAY_BUFFER,s.o),R.enableVertexAttribArray(s.j.H),R.vertexAttribPointer(s.j.H,2,R.FLOAT,!1,0,0),R.bufferData(R.ARRAY_BUFFER,new Float32Array([0,1,0,0,1,0,1,1]),R.STATIC_DRAW),R.bindBuffer(R.ARRAY_BUFFER,null),R.uniform1i(N,0);}w=s.j,R.useProgram(s.m),R.canvas.width=X.width,R.canvas.height=X.height,R.viewport(0,0,X.width,X.height),R.activeTexture(R.TEXTURE0),s.h.bindTexture2d(X.glName),R.enableVertexAttribArray(w.I),R.bindBuffer(R.ARRAY_BUFFER,s.s),R.vertexAttribPointer(w.I,2,R.FLOAT,!1,0,0),R.enableVertexAttribArray(w.H),R.bindBuffer(R.ARRAY_BUFFER,s.o),R.vertexAttribPointer(w.H,2,R.FLOAT,!1,0,0),R.bindFramebuffer(R.DRAW_FRAMEBUFFER?R.DRAW_FRAMEBUFFER:R.FRAMEBUFFER,null),R.clearColor(0,0,0,0),R.clear(R.COLOR_BUFFER_BIT),R.colorMask(!0,!0,!0,!0),R.drawArrays(R.TRIANGLE_FAN,0,4),R.disableVertexAttribArray(w.I),R.disableVertexAttribArray(w.H),R.bindBuffer(R.ARRAY_BUFFER,null),s.h.bindTexture2d(0);}function Vt(s){this.g=s;}var Ht=new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,10,9,1,7,0,65,0,253,15,26,11]);function Et(s,X){return X+s;}function te(s,X){window[s]=X;}function ie(s){var X=document.createElement("script");return X.setAttribute("src",s),X.setAttribute("crossorigin","anonymous"),new Promise(function(R){X.addEventListener("load",function(){R();},!1),X.addEventListener("error",function(){R();},!1),document.body.appendChild(X);});}function le(){return yt(function(s){switch(s.g){case 1:return s.m=2,D(s,WebAssembly.instantiate(Ht),4);case 4:s.g=3,s.m=0;break;case 2:return s.m=0,s.j=null,s.return(!1);case 3:return s.return(!0);}});}function Re(s){if(this.g=s,this.listeners={},this.j={},this.F={},this.m={},this.s={},this.G=this.o=this.R=!0,this.C=Promise.resolve(),this.P="",this.B={},this.locateFile=s&&s.locateFile||Et,typeof window=="object")var X=window.location.pathname.toString().substring(0,window.location.pathname.toString().lastIndexOf("/"))+"/";else if(typeof location<"u")X=location.pathname.toString().substring(0,location.pathname.toString().lastIndexOf("/"))+"/";else throw Error("solutions can only be loaded on a web page or in a web worker");if(this.S=X,s.options){X=T(Object.keys(s.options));for(var R=X.next();!R.done;R=X.next()){R=R.value;var w=s.options[R].default;w!==void 0&&(this.j[R]=typeof w=="function"?w():w);}}}r=Re.prototype,r.close=function(){return this.i&&this.i.delete(),Promise.resolve();};function h(s){var X,R,w,N,B,M,et,$,ft,gt,Nt;return yt(function(Gt){switch(Gt.g){case 1:return s.R?(X=s.g.files===void 0?[]:typeof s.g.files=="function"?s.g.files(s.j):s.g.files,D(Gt,le(),2)):Gt.return();case 2:if(R=Gt.h,typeof window=="object")return te("createMediapipeSolutionsWasm",{locateFile:s.locateFile}),te("createMediapipeSolutionsPackedAssets",{locateFile:s.locateFile}),M=X.filter(function(lt){return lt.data!==void 0;}),et=X.filter(function(lt){return lt.data===void 0;}),$=Promise.all(M.map(function(lt){var Zt=C(s,lt.url);if(lt.path!==void 0){var Xt=lt.path;Zt=Zt.then(function(Rt){return s.overrideFile(Xt,Rt),Promise.resolve(Rt);});}return Zt;})),ft=Promise.all(et.map(function(lt){return lt.simd===void 0||lt.simd&&R||!lt.simd&&!R?ie(s.locateFile(lt.url,s.S)):Promise.resolve();})).then(function(){var lt,Zt,Xt;return yt(function(Rt){if(Rt.g==1)return lt=window.createMediapipeSolutionsWasm,Zt=window.createMediapipeSolutionsPackedAssets,Xt=s,D(Rt,lt(Zt),2);Xt.h=Rt.h,Rt.g=0;});}),gt=function(){return yt(function(lt){return s.g.graph&&s.g.graph.url?lt=D(lt,C(s,s.g.graph.url),0):(lt.g=0,lt=void 0),lt;});}(),D(Gt,Promise.all([ft,$,gt]),7);if(typeof importScripts!="function")throw Error("solutions can only be loaded on a web page or in a web worker");return w=X.filter(function(lt){return lt.simd===void 0||lt.simd&&R||!lt.simd&&!R;}).map(function(lt){return s.locateFile(lt.url,s.S);}),importScripts.apply(null,k(w)),N=s,D(Gt,createMediapipeSolutionsWasm(Module),6);case 6:N.h=Gt.h,s.l=new OffscreenCanvas(1,1),s.h.canvas=s.l,B=s.h.GL.createContext(s.l,{antialias:!1,alpha:!1,ba:typeof WebGL2RenderingContext<"u"?2:1}),s.h.GL.makeContextCurrent(B),Gt.g=4;break;case 7:if(s.l=document.createElement("canvas"),Nt=s.l.getContext("webgl2",{}),!Nt&&(Nt=s.l.getContext("webgl",{}),!Nt))return alert("Failed to create WebGL canvas context when passing video frame."),Gt.return();s.D=Nt,s.h.canvas=s.l,s.h.createContext(s.l,!0,!0,{});case 4:s.i=new s.h.SolutionWasm(),s.R=!1,Gt.g=0;}});}function y(s){var X,R,w,N,B,M,et,$;return yt(function(ft){if(ft.g==1){if(s.g.graph&&s.g.graph.url&&s.P===s.g.graph.url)return ft.return();if(s.o=!0,!s.g.graph||!s.g.graph.url){ft.g=2;return;}return s.P=s.g.graph.url,D(ft,C(s,s.g.graph.url),3);}for(ft.g!=2&&(X=ft.h,s.i.loadGraph(X)),R=T(Object.keys(s.B)),w=R.next();!w.done;w=R.next())N=w.value,s.i.overrideFile(N,s.B[N]);if(s.B={},s.g.listeners)for(B=T(s.g.listeners),M=B.next();!M.done;M=B.next())et=M.value,A(s,et);$=s.j,s.j={},s.setOptions($),ft.g=0;});}r.reset=function(){var s=this;return yt(function(X){s.i&&(s.i.reset(),s.m={},s.s={}),X.g=0;});},r.setOptions=function(s,X){var R=this;if(X=X||this.g.options){for(var w=[],N=[],B={},M=T(Object.keys(s)),et=M.next();!et.done;B={K:B.K,L:B.L},et=M.next()){var $=et.value;$ in this.j&&this.j[$]===s[$]||(this.j[$]=s[$],et=X[$],et!==void 0&&(et.onChange&&(B.K=et.onChange,B.L=s[$],w.push(/* @__PURE__ */function(ft){return function(){var gt;return yt(function(Nt){if(Nt.g==1)return D(Nt,ft.K(ft.L),2);gt=Nt.h,gt===!0&&(R.o=!0),Nt.g=0;});};}(B))),et.graphOptionXref&&($={valueNumber:et.type===1?s[$]:0,valueBoolean:et.type===0?s[$]:!1,valueString:et.type===2?s[$]:""},et=Object.assign(Object.assign(Object.assign({},{calculatorName:"",calculatorIndex:0}),et.graphOptionXref),$),N.push(et))));}(w.length!==0||N.length!==0)&&(this.o=!0,this.A=(this.A===void 0?[]:this.A).concat(N),this.v=(this.v===void 0?[]:this.v).concat(w));}};function G(s){var X,R,w,N,B,M,et;return yt(function($){switch($.g){case 1:if(!s.o)return $.return();if(!s.v){$.g=2;break;}X=T(s.v),R=X.next();case 3:if(R.done){$.g=5;break;}return w=R.value,D($,w(),4);case 4:R=X.next(),$.g=3;break;case 5:s.v=void 0;case 2:if(s.A){for(N=new s.h.GraphOptionChangeRequestList(),B=T(s.A),M=B.next();!M.done;M=B.next())et=M.value,N.push_back(et);s.i.changeOptions(N),N.delete(),s.A=void 0;}s.o=!1,$.g=0;}});}r.initialize=function(){var s=this;return yt(function(X){return X.g==1?D(X,h(s),2):X.g!=3?D(X,y(s),3):D(X,G(s),0);});};function C(s,X){var R,w;return yt(function(N){return X in s.F?N.return(s.F[X]):(R=s.locateFile(X,""),w=fetch(R).then(function(B){return B.arrayBuffer();}),s.F[X]=w,N.return(w));});}r.overrideFile=function(s,X){this.i?this.i.overrideFile(s,X):this.B[s]=X;},r.clearOverriddenFiles=function(){this.B={},this.i&&this.i.clearOverriddenFiles();},r.send=function(s,X){var R=this,w,N,B,M,et,$,ft,gt,Nt;return yt(function(Gt){switch(Gt.g){case 1:return R.g.inputs?(w=1e3*(X!=null?X:performance.now()),D(Gt,R.C,2)):Gt.return();case 2:return D(Gt,R.initialize(),3);case 3:for(N=new R.h.PacketDataList(),B=T(Object.keys(s)),M=B.next();!M.done;M=B.next())if(et=M.value,$=R.g.inputs[et]){t:{var lt=s[et];switch($.type){case"video":var Zt=R.m[$.stream];if(Zt||(Zt=new Tt(R.h,R.D),R.m[$.stream]=Zt),Zt.l===0&&(Zt.l=Zt.h.createTexture()),typeof HTMLVideoElement<"u"&&lt instanceof HTMLVideoElement)var Xt=lt.videoWidth,Rt=lt.videoHeight;else typeof HTMLImageElement<"u"&&lt instanceof HTMLImageElement?(Xt=lt.naturalWidth,Rt=lt.naturalHeight):(Xt=lt.width,Rt=lt.height);Rt={glName:Zt.l,width:Xt,height:Rt},Xt=Zt.g,Xt.canvas.width=Rt.width,Xt.canvas.height=Rt.height,Xt.activeTexture(Xt.TEXTURE0),Zt.h.bindTexture2d(Zt.l),Xt.texImage2D(Xt.TEXTURE_2D,0,Xt.RGBA,Xt.RGBA,Xt.UNSIGNED_BYTE,lt),Zt.h.bindTexture2d(0),Zt=Rt;break t;case"detections":for(Zt=R.m[$.stream],Zt||(Zt=new Vt(R.h),R.m[$.stream]=Zt),Zt.data||(Zt.data=new Zt.g.DetectionListData()),Zt.data.reset(lt.length),Rt=0;Rt<lt.length;++Rt){Xt=lt[Rt];var St=Zt.data,l=St.setBoundingBox,Z=Rt,x=Xt.T,Y=new U();if(It(Y,1,x.Y),It(Y,2,x.Z),It(Y,3,x.height),It(Y,4,x.width),It(Y,5,x.rotation),It(Y,6,x.W),x=Qe(Y,rt),l.call(St,Z,x),Xt.O)for(St=0;St<Xt.O.length;++St){Y=Xt.O[St];var J=!!Y.visibility;l=Zt.data,Z=l.addNormalizedLandmark,x=Rt,Y=Object.assign(Object.assign({},Y),{visibility:J?Y.visibility:0}),J=new Xn(),It(J,1,Y.x),It(J,2,Y.y),It(J,3,Y.z),Y.visibility&&It(J,4,Y.visibility),Y=Qe(J,Bn),Z.call(l,x,Y);}if(Xt.M)for(St=0;St<Xt.M.length;++St)l=Zt.data,Z=l.addClassification,x=Rt,Y=Xt.M[St],J=new pn(),It(J,2,Y.X),Y.index&&It(J,1,Y.index),Y.label&&It(J,3,Y.label),Y.displayName&&It(J,4,Y.displayName),Y=Qe(J,Fn),Z.call(l,x,Y);}Zt=Zt.data;break t;default:Zt={};}}switch(ft=Zt,gt=$.stream,$.type){case"video":N.pushTexture2d(Object.assign(Object.assign({},ft),{stream:gt,timestamp:w}));break;case"detections":Nt=ft,Nt.stream=gt,Nt.timestamp=w,N.pushDetectionList(Nt);break;default:throw Error("Unknown input config type: '"+$.type+"'");}}return R.i.send(N),D(Gt,R.C,4);case 4:N.delete(),Gt.g=0;}});};function z(s,X,R){var w,N,B,M,et,$,ft,gt,Nt,Gt,lt,Zt,Xt,Rt;return yt(function(St){switch(St.g){case 1:if(!R)return St.return(X);for(w={},N=0,B=T(Object.keys(R)),M=B.next();!M.done;M=B.next())et=M.value,$=R[et],typeof $!="string"&&$.type==="texture"&&X[$.stream]!==void 0&&++N;1<N&&(s.G=!1),ft=T(Object.keys(R)),M=ft.next();case 2:if(M.done){St.g=4;break;}if(gt=M.value,Nt=R[gt],typeof Nt=="string")return Xt=w,Rt=gt,D(St,P(s,gt,X[Nt]),14);if(Gt=X[Nt.stream],Nt.type==="detection_list"){if(Gt){for(var l=Gt.getRectList(),Z=Gt.getLandmarksList(),x=Gt.getClassificationsList(),Y=[],J=0;J<l.size();++J){var o=tn(l.get(J),U,K);o={T:{Y:Bt(o,1),Z:Bt(o,2),height:Bt(o,3),width:Bt(o,4),rotation:Bt(o,5,0),W:Ot(o,6)},O:Ct(Z.get(J)),M:dt(tn(x.get(J),ln,Hn))},Y.push(o);}l=Y;}else l=[];w[gt]=l,St.g=7;break;}if(Nt.type==="proto_list"){if(Gt){for(l=Array(Gt.size()),Z=0;Z<Gt.size();Z++)l[Z]=Gt.get(Z);Gt.delete();}else l=[];w[gt]=l,St.g=7;break;}if(Gt===void 0){St.g=3;break;}if(Nt.type==="float_list"){w[gt]=Gt,St.g=7;break;}if(Nt.type==="proto"){w[gt]=Gt,St.g=7;break;}if(Nt.type!=="texture")throw Error("Unknown output config type: '"+Nt.type+"'");return lt=s.s[gt],lt||(lt=new Tt(s.h,s.D),s.s[gt]=lt),D(St,jt(lt,Gt,s.G),13);case 13:Zt=St.h,w[gt]=Zt;case 7:Nt.transform&&w[gt]&&(w[gt]=Nt.transform(w[gt])),St.g=3;break;case 14:Xt[Rt]=St.h;case 3:M=ft.next(),St.g=2;break;case 4:return St.return(w);}});}function P(s,X,R){var w;return yt(function(N){return typeof R=="number"||R instanceof Uint8Array||R instanceof s.h.Uint8BlobList?N.return(R):R instanceof s.h.Texture2dDataOut?(w=s.s[X],w||(w=new Tt(s.h,s.D),s.s[X]=w),N.return(jt(w,R,s.G))):N.return(void 0);});}function A(s,X){for(var R=X.name||"$",w=[].concat(k(X.wants)),N=new s.h.StringList(),B=T(X.wants),M=B.next();!M.done;M=B.next())N.push_back(M.value);B=s.h.PacketListener.implement({onResults:function onResults(et){for(var $={},ft=0;ft<X.wants.length;++ft)$[w[ft]]=et.get(ft);var gt=s.listeners[R];gt&&(s.C=z(s,$,X.outs).then(function(Nt){Nt=gt(Nt);for(var Gt=0;Gt<X.wants.length;++Gt){var lt=$[w[Gt]];typeof lt=="object"&&lt.hasOwnProperty&&lt.hasOwnProperty("delete")&&lt.delete();}Nt&&(s.C=Nt);}));}}),s.i.attachMultiListener(N,B),N.delete();}r.onResults=function(s,X){this.listeners[X||"$"]=s;},Lt("Solution",Re),Lt("OptionType",{BOOL:0,NUMBER:1,$:2,0:"BOOL",1:"NUMBER",2:"STRING"});function q(s){switch(s===void 0&&(s=0),s){case 1:return"pose_landmark_full.tflite";case 2:return"pose_landmark_heavy.tflite";default:return"pose_landmark_lite.tflite";}}function ot(s){var X=this;s=s||{},this.g=new Re({locateFile:s.locateFile,files:function files(R){return[{url:"pose_solution_packed_assets_loader.js"},{simd:!1,url:"pose_solution_wasm_bin.js"},{simd:!0,url:"pose_solution_simd_wasm_bin.js"},{data:!0,url:q(R.modelComplexity)}];},graph:{url:"pose_web.binarypb"},listeners:[{wants:["pose_landmarks","world_landmarks","segmentation_mask","image_transformed"],outs:{image:{type:"texture",stream:"image_transformed"},poseLandmarks:{type:"proto",stream:"pose_landmarks",transform:Ct},poseWorldLandmarks:{type:"proto",stream:"world_landmarks",transform:Ct},segmentationMask:{type:"texture",stream:"segmentation_mask"}}}],inputs:{image:{type:"video",stream:"input_frames_gpu"}},options:{useCpuInference:{type:0,graphOptionXref:{calculatorType:"InferenceCalculator",fieldName:"use_cpu_inference"},default:"iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document},selfieMode:{type:0,graphOptionXref:{calculatorType:"GlScalerCalculator",calculatorIndex:1,fieldName:"flip_horizontal"}},modelComplexity:{type:1,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorModelComplexity",fieldName:"int_value"},onChange:function onChange(R){var w,N,B;return yt(function(M){return M.g==1?(w=q(R),N="third_party/mediapipe/modules/pose_landmark/"+w,D(M,C(X.g,w),2)):(B=M.h,X.g.overrideFile(N,B),M.return(!0));});}},smoothLandmarks:{type:0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorSmoothLandmarks",fieldName:"bool_value"}},enableSegmentation:{type:0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorEnableSegmentation",fieldName:"bool_value"}},smoothSegmentation:{type:0,graphOptionXref:{calculatorType:"ConstantSidePacketCalculator",calculatorName:"ConstantSidePacketCalculatorSmoothSegmentation",fieldName:"bool_value"}},minDetectionConfidence:{type:1,graphOptionXref:{calculatorType:"TensorsToDetectionsCalculator",calculatorName:"poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",fieldName:"min_score_thresh"}},minTrackingConfidence:{type:1,graphOptionXref:{calculatorType:"ThresholdingCalculator",calculatorName:"poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator",fieldName:"threshold"}}}});}r=ot.prototype,r.reset=function(){this.g.reset();},r.close=function(){return this.g.close(),Promise.resolve();},r.onResults=function(s){this.g.onResults(s);},r.initialize=function(){var s=this;return yt(function(X){return D(X,s.g.initialize(),0);});},r.send=function(s,X){var R=this;return yt(function(w){return D(w,R.g.send(s,X),0);});},r.setOptions=function(s){this.g.setOptions(s);},Lt("Pose",ot),Lt("POSE_CONNECTIONS",[[0,1],[1,2],[2,3],[3,7],[0,4],[4,5],[5,6],[6,8],[9,10],[11,12],[11,13],[13,15],[15,17],[15,19],[15,21],[17,19],[12,14],[14,16],[16,18],[16,20],[16,22],[18,20],[11,23],[12,24],[23,24],[23,25],[24,26],[25,27],[26,28],[27,29],[28,30],[29,31],[30,32],[27,31],[28,32]]),Lt("POSE_LANDMARKS",{NOSE:0,LEFT_EYE_INNER:1,LEFT_EYE:2,LEFT_EYE_OUTER:3,RIGHT_EYE_INNER:4,RIGHT_EYE:5,RIGHT_EYE_OUTER:6,LEFT_EAR:7,RIGHT_EAR:8,LEFT_RIGHT:9,RIGHT_LEFT:10,LEFT_SHOULDER:11,RIGHT_SHOULDER:12,LEFT_ELBOW:13,RIGHT_ELBOW:14,LEFT_WRIST:15,RIGHT_WRIST:16,LEFT_PINKY:17,RIGHT_PINKY:18,LEFT_INDEX:19,RIGHT_INDEX:20,LEFT_THUMB:21,RIGHT_THUMB:22,LEFT_HIP:23,RIGHT_HIP:24,LEFT_KNEE:25,RIGHT_KNEE:26,LEFT_ANKLE:27,RIGHT_ANKLE:28,LEFT_HEEL:29,RIGHT_HEEL:30,LEFT_FOOT_INDEX:31,RIGHT_FOOT_INDEX:32}),Lt("POSE_LANDMARKS_LEFT",{LEFT_EYE_INNER:1,LEFT_EYE:2,LEFT_EYE_OUTER:3,LEFT_EAR:7,LEFT_RIGHT:9,LEFT_SHOULDER:11,LEFT_ELBOW:13,LEFT_WRIST:15,LEFT_PINKY:17,LEFT_INDEX:19,LEFT_THUMB:21,LEFT_HIP:23,LEFT_KNEE:25,LEFT_ANKLE:27,LEFT_HEEL:29,LEFT_FOOT_INDEX:31}),Lt("POSE_LANDMARKS_RIGHT",{RIGHT_EYE_INNER:4,RIGHT_EYE:5,RIGHT_EYE_OUTER:6,RIGHT_EAR:8,RIGHT_LEFT:10,RIGHT_SHOULDER:12,RIGHT_ELBOW:14,RIGHT_WRIST:16,RIGHT_PINKY:18,RIGHT_INDEX:20,RIGHT_THUMB:22,RIGHT_HIP:24,RIGHT_KNEE:26,RIGHT_ANKLE:28,RIGHT_HEEL:30,RIGHT_FOOT_INDEX:32}),Lt("POSE_LANDMARKS_NEUTRAL",{NOSE:0}),Lt("VERSION","0.5.1635988162");}).call(Yi);const $n=/*#__PURE__*/function(){function $n(){this.mediapipeMap_=/* @__PURE__ */new Map();}var _proto9=$n.prototype;_proto9.getVersion=function getVersion(e){switch(e){case"face_detection":return Ii.VERSION;case"face_mesh":return Si.VERSION;case"hands":return Ri.VERSION;case"holistic":return xi.VERSION;case"objectron":return Ti.VERSION;case"selfie_segmentation":return Vi.VERSION;case"pose":return Yi.VERSION;default:return"";}};_proto9.initialize=function initialize(e){var _this8=this;return new Promise(/*#__PURE__*/function(){var _ref14=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee22(i,m){var v,S,L;return _regenerator.default.wrap(function _callee22$(_context22){while(1)switch(_context22.prev=_context22.next){case 0:if(!(e.mediaPipeModelConfigArray.length==0)){_context22.next=3;break;}m("no model was selected");return _context22.abrupt("return");case 3:v=0;case 4:if(!(v<e.mediaPipeModelConfigArray.length)){_context22.next=45;break;}S=e.mediaPipeModelConfigArray[v];if(!_this8.mediapipeMap_.has(S.modelType)){_context22.next=9;break;}m("setting same type is not supported");return _context22.abrupt("return");case 9:if(!(typeof S.listener!="function")){_context22.next=12;break;}m(`[${S.modelType}] ResultsListener must be provided`);return _context22.abrupt("return");case 12:_context22.t0=S.modelType;_context22.next=_context22.t0==="face_mesh"?15:_context22.t0==="face_detection"?17:_context22.t0==="hands"?19:_context22.t0==="holistic"?21:_context22.t0==="objectron"?23:_context22.t0==="selfie_segmentation"?25:_context22.t0==="pose"?27:29;break;case 15:L=new Si.FaceMesh({locateFile:(T,k)=>(S.assetsUri||$n.defaultAssetsBaseUrl+"face_mesh/"+_this8.getVersion("face_mesh"))+"/"+T});return _context22.abrupt("break",31);case 17:L=new Ii.FaceDetection({locateFile:(T,k)=>(S.assetsUri||$n.defaultAssetsBaseUrl+"face_detection/"+_this8.getVersion("face_detection"))+"/"+T});return _context22.abrupt("break",31);case 19:L=new Ri.Hands({locateFile:(T,k)=>(S.assetsUri||$n.defaultAssetsBaseUrl+"hands/"+_this8.getVersion("hands"))+"/"+T});return _context22.abrupt("break",31);case 21:L=new xi.Holistic({locateFile:(T,k)=>(S.assetsUri||$n.defaultAssetsBaseUrl+"holistic/"+_this8.getVersion("holistic"))+"/"+T});return _context22.abrupt("break",31);case 23:L=new Ti.Objectron({locateFile:(T,k)=>(S.assetsUri||$n.defaultAssetsBaseUrl+"objectron/"+_this8.getVersion("objectron"))+"/"+T});return _context22.abrupt("break",31);case 25:L=new Vi.SelfieSegmentation({locateFile:(T,k)=>(S.assetsUri||$n.defaultAssetsBaseUrl+"selfie_segmentation/"+_this8.getVersion("selfie_segmentation"))+"/"+T});return _context22.abrupt("break",31);case 27:L=new Yi.Pose({locateFile:(T,k)=>(S.assetsUri||$n.defaultAssetsBaseUrl+"pose/"+_this8.getVersion("pose"))+"/"+T});return _context22.abrupt("break",31);case 29:m("unknown model type");return _context22.abrupt("return");case 31:L.onResults(S.listener),S.options&&L.setOptions(S.options);_context22.prev=32;_context22.next=35;return L.initialize();case 35:_this8.mediapipeMap_.set(S.modelType,L);_context22.next=42;break;case 38:_context22.prev=38;_context22.t1=_context22["catch"](32);m(_context22.t1);return _context22.abrupt("return");case 42:v++;_context22.next=4;break;case 45:i();case 46:case"end":return _context22.stop();}},_callee22,null,[[32,38]]);}));return function(_x27,_x28){return _ref14.apply(this,arguments);};}());};_proto9.close=function close(e){return new Promise((i,m)=>{let v=[];if(e){let S=this.mediapipeMap_.get(e);if(S)this.mediapipeMap_.delete(e),v.push(S.close());else{m("model not exit");return;}}else{for(var _iterator23=_createForOfIteratorHelperLoose(this.mediapipeMap_.entries()),_step23;!(_step23=_iterator23()).done;){const _step23$value=_step23.value,S=_step23$value[0],L=_step23$value[1];v.push(L.close());}this.mediapipeMap_.clear();}Promise.all(v).then(()=>{i();}).catch(S=>{m(S);});});};_proto9.send=function send(e,i){return new Promise((m,v)=>{let S=[];if(i){let L=this.mediapipeMap_.get(i);if(L)S.push(L.send({image:e}));else{v("model not exit");return;}}else{for(var _iterator24=_createForOfIteratorHelperLoose(this.mediapipeMap_.entries()),_step24;!(_step24=_iterator24()).done;){const _step24$value=_step24.value,L=_step24$value[0],T=_step24$value[1];S.push(T.send({image:e}));}}Promise.all(S).then(()=>{m();}).catch(L=>{v(L);});});};_proto9.reset=function reset(e){if(e){let i=this.mediapipeMap_.get(e);i&&typeof i.reset=="function"&&i.reset();}else{for(var _iterator25=_createForOfIteratorHelperLoose(this.mediapipeMap_.entries()),_step25;!(_step25=_iterator25()).done;){const _step25$value=_step25.value,i=_step25$value[0],m=_step25$value[1];m&&typeof m.reset=="function"&&m.reset();}}};return $n;}();$n.defaultAssetsBaseUrl="https://d3opqjmqzxf057.cloudfront.net/ml/mediapipe/";let Xs=$n;exports.MediapipeHelper=Xs;const ir=/* @__PURE__ */new WeakMap(),br=/* @__PURE__ */new WeakMap(),qn=/* @__PURE__ */new WeakMap(),wi=Symbol("anyProducer"),Ws=Promise.resolve(),Fi=Symbol("listenerAdded"),Li=Symbol("listenerRemoved");let Hi=!1,uo=!1;function Tr(r){if(typeof r!="string"&&typeof r!="symbol"&&typeof r!="number")throw new TypeError("`eventName` must be a string, symbol, or number");}function li(r){if(typeof r!="function")throw new TypeError("listener must be a function");}function Yr(r,e){const i=br.get(r);if(i.has(e))return i.get(e);}function Kr(r,e){const i=typeof e=="string"||typeof e=="symbol"||typeof e=="number"?e:wi,m=qn.get(r);if(m.has(i))return m.get(i);}function $2(r,e,i){const m=qn.get(r);if(m.has(e)){for(var _iterator26=_createForOfIteratorHelperLoose(m.get(e)),_step26;!(_step26=_iterator26()).done;){const v=_step26.value;v.enqueue(i);}}if(m.has(wi)){const v=Promise.all([e,i]);for(var _iterator27=_createForOfIteratorHelperLoose(m.get(wi)),_step27;!(_step27=_iterator27()).done;){const S=_step27.value;S.enqueue(v);}}}function Vs(r,e){e=Array.isArray(e)?e:[e];let i=!1,m=()=>{},v=[];const S={enqueue(L){v.push(L),m();},finish(){i=!0,m();}};for(var _iterator28=_createForOfIteratorHelperLoose(e),_step28;!(_step28=_iterator28()).done;){const L=_step28.value;let T=Kr(r,L);T||(T=/* @__PURE__ */new Set(),qn.get(r).set(L,T)),T.add(S);}return{next(){var _this9=this;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee23(){return _regenerator.default.wrap(function _callee23$(_context23){while(1)switch(_context23.prev=_context23.next){case 0:if(!v){_context23.next=20;break;}if(!(v.length===0)){_context23.next=12;break;}if(!i){_context23.next=6;break;}_context23.t2=(v=void 0,_this9.next());_context23.next=9;break;case 6:_context23.next=8;return new Promise(L=>{m=L;});case 8:_context23.t2=_this9.next();case 9:_context23.t1=_context23.t2;_context23.next=17;break;case 12:_context23.t3=!1;_context23.next=15;return v.shift();case 15:_context23.t4=_context23.sent;_context23.t1={done:_context23.t3,value:_context23.t4};case 17:_context23.t0=_context23.t1;_context23.next=21;break;case 20:_context23.t0={done:!0};case 21:return _context23.abrupt("return",_context23.t0);case 22:case"end":return _context23.stop();}},_callee23);}))();},return(L){var _arguments2=arguments;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee24(){var _iterator29,_step29,T,k;return _regenerator.default.wrap(function _callee24$(_context24){while(1)switch(_context24.prev=_context24.next){case 0:v=void 0;for(_iterator29=_createForOfIteratorHelperLoose(e);!(_step29=_iterator29()).done;){T=_step29.value;k=Kr(r,T);k&&(k.delete(S),k.size===0&&qn.get(r).delete(T));}m();if(!(_arguments2.length>0)){_context24.next=11;break;}_context24.t1=!0;_context24.next=7;return L;case 7:_context24.t2=_context24.sent;_context24.t0={done:_context24.t1,value:_context24.t2};_context24.next=12;break;case 11:_context24.t0={done:!0};case 12:return _context24.abrupt("return",_context24.t0);case 13:case"end":return _context24.stop();}},_callee24);}))();},[Symbol.asyncIterator](){return this;}};}function Rs(r){if(r===void 0)return xs;if(!Array.isArray(r))throw new TypeError("`methodNames` must be an array of strings");for(var _iterator30=_createForOfIteratorHelperLoose(r),_step30;!(_step30=_iterator30()).done;){const e=_step30.value;if(!xs.includes(e))throw typeof e!="string"?new TypeError("`methodNames` element must be a string"):new Error(`${e} is not Emittery method`);}return r;}const Hr=r=>r===Fi||r===Li;function ci(r,e,i){if(Hr(e))try{Hi=!0,r.emit(e,i);}finally{Hi=!1;}}let qr=/*#__PURE__*/function(){vo.mixin=function mixin(e,i){return i=Rs(i),m=>{if(typeof m!="function")throw new TypeError("`target` must be function");for(var _iterator31=_createForOfIteratorHelperLoose(i),_step31;!(_step31=_iterator31()).done;){const L=_step31.value;if(m.prototype[L]!==void 0)throw new Error(`The property \`${L}\` already exists on \`target\``);}function v(){return Object.defineProperty(this,e,{enumerable:!1,value:new vo()}),this[e];}Object.defineProperty(m.prototype,e,{enumerable:!1,get:v});const S=L=>function(){return this[e][L](...arguments);};for(var _iterator32=_createForOfIteratorHelperLoose(i),_step32;!(_step32=_iterator32()).done;){const L=_step32.value;Object.defineProperty(m.prototype,L,{enumerable:!1,value:S(L)});}return m;};};function vo(e){var _e$debug;if(e===void 0){e={};}ir.set(this,/* @__PURE__ */new Set()),br.set(this,/* @__PURE__ */new Map()),qn.set(this,/* @__PURE__ */new Map()),qn.get(this).set(wi,/* @__PURE__ */new Set()),this.debug=(_e$debug=e.debug)!=null?_e$debug:{},this.debug.enabled===void 0&&(this.debug.enabled=!1),this.debug.logger||(this.debug.logger=(i,m,v,S)=>{try{S=JSON.stringify(S);}catch(_unused11){S=`Object with the following keys failed to stringify: ${Object.keys(S).join(",")}`;}(typeof v=="symbol"||typeof v=="number")&&(v=v.toString());const L=/* @__PURE__ */new Date(),T=`${L.getHours()}:${L.getMinutes()}:${L.getSeconds()}.${L.getMilliseconds()}`;console.log(`[${T}][emittery:${i}][${m}] Event Name: ${v}
	data: ${S}`);});}var _proto10=vo.prototype;_proto10.logIfDebugEnabled=function logIfDebugEnabled(e,i,m){(vo.isDebugEnabled||this.debug.enabled)&&this.debug.logger(e,this.debug.name,i,m);};_proto10.on=function on(e,i){li(i),e=Array.isArray(e)?e:[e];for(var _iterator33=_createForOfIteratorHelperLoose(e),_step33;!(_step33=_iterator33()).done;){const m=_step33.value;Tr(m);let v=Yr(this,m);v||(v=/* @__PURE__ */new Set(),br.get(this).set(m,v)),v.add(i),this.logIfDebugEnabled("subscribe",m,void 0),Hr(m)||ci(this,Fi,{eventName:m,listener:i});}return this.off.bind(this,e,i);};_proto10.off=function off(e,i){li(i),e=Array.isArray(e)?e:[e];for(var _iterator34=_createForOfIteratorHelperLoose(e),_step34;!(_step34=_iterator34()).done;){const m=_step34.value;Tr(m);const v=Yr(this,m);v&&(v.delete(i),v.size===0&&br.get(this).delete(m)),this.logIfDebugEnabled("unsubscribe",m,void 0),Hr(m)||ci(this,Li,{eventName:m,listener:i});}};_proto10.once=function once(e){let i;const m=new Promise(v=>{i=this.on(e,S=>{i(),v(S);});});return m.off=i,m;};_proto10.events=function events(e){e=Array.isArray(e)?e:[e];for(var _iterator35=_createForOfIteratorHelperLoose(e),_step35;!(_step35=_iterator35()).done;){const i=_step35.value;Tr(i);}return Vs(this,e);};_proto10.emit=/*#__PURE__*/function(){var _emit2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee27(e,i){var _Yr;var m,v,S,L;return _regenerator.default.wrap(function _callee27$(_context27){while(1)switch(_context27.prev=_context27.next){case 0:if(!(Tr(e),Hr(e)&&!Hi)){_context27.next=2;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 2:this.logIfDebugEnabled("emit",e,i),$2(this,e,i);m=(_Yr=Yr(this,e))!=null?_Yr:/* @__PURE__ */new Set(),v=ir.get(this),S=[...m],L=Hr(e)?[]:[...v];_context27.next=6;return Ws;case 6:_context27.next=8;return Promise.all([...S.map(/*#__PURE__*/function(){var _ref15=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee25(T){return _regenerator.default.wrap(function _callee25$(_context25){while(1)switch(_context25.prev=_context25.next){case 0:if(!m.has(T)){_context25.next=2;break;}return _context25.abrupt("return",T(i));case 2:case"end":return _context25.stop();}},_callee25);}));return function(_x31){return _ref15.apply(this,arguments);};}()),...L.map(/*#__PURE__*/function(){var _ref16=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee26(T){return _regenerator.default.wrap(function _callee26$(_context26){while(1)switch(_context26.prev=_context26.next){case 0:if(!v.has(T)){_context26.next=2;break;}return _context26.abrupt("return",T(e,i));case 2:case"end":return _context26.stop();}},_callee26);}));return function(_x32){return _ref16.apply(this,arguments);};}())]);case 8:case"end":return _context27.stop();}},_callee27,this);}));function emit(_x29,_x30){return _emit2.apply(this,arguments);}return emit;}();_proto10.emitSerial=/*#__PURE__*/function(){var _emitSerial2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee28(e,i){var _Yr2;var m,v,S,L,_i4,_S2,T,_i5,_L2;return _regenerator.default.wrap(function _callee28$(_context28){while(1)switch(_context28.prev=_context28.next){case 0:if(!(Tr(e),Hr(e)&&!Hi)){_context28.next=2;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 2:this.logIfDebugEnabled("emitSerial",e,i);m=(_Yr2=Yr(this,e))!=null?_Yr2:/* @__PURE__ */new Set(),v=ir.get(this),S=[...m],L=[...v];_context28.next=6;return Ws;case 6:_i4=0,_S2=S;case 7:if(!(_i4<_S2.length)){_context28.next=16;break;}T=_S2[_i4];_context28.t0=m.has(T);if(!_context28.t0){_context28.next=13;break;}_context28.next=13;return T(i);case 13:_i4++;_context28.next=7;break;case 16:_i5=0,_L2=L;case 17:if(!(_i5<_L2.length)){_context28.next=26;break;}T=_L2[_i5];_context28.t1=v.has(T);if(!_context28.t1){_context28.next=23;break;}_context28.next=23;return T(e,i);case 23:_i5++;_context28.next=17;break;case 26:case"end":return _context28.stop();}},_callee28,this);}));function emitSerial(_x33,_x34){return _emitSerial2.apply(this,arguments);}return emitSerial;}();_proto10.onAny=function onAny(e){return li(e),this.logIfDebugEnabled("subscribeAny",void 0,void 0),ir.get(this).add(e),ci(this,Fi,{listener:e}),this.offAny.bind(this,e);};_proto10.anyEvent=function anyEvent(){return Vs(this);};_proto10.offAny=function offAny(e){li(e),this.logIfDebugEnabled("unsubscribeAny",void 0,void 0),ci(this,Li,{listener:e}),ir.get(this).delete(e);};_proto10.clearListeners=function clearListeners(e){e=Array.isArray(e)?e:[e];for(var _iterator36=_createForOfIteratorHelperLoose(e),_step36;!(_step36=_iterator36()).done;){const i=_step36.value;if(this.logIfDebugEnabled("clear",i,void 0),typeof i=="string"||typeof i=="symbol"||typeof i=="number"){const m=Yr(this,i);m&&m.clear();const v=Kr(this,i);if(v){for(var _iterator37=_createForOfIteratorHelperLoose(v),_step37;!(_step37=_iterator37()).done;){const S=_step37.value;S.finish();}v.clear();}}else{ir.get(this).clear();for(var _iterator38=_createForOfIteratorHelperLoose(br.get(this).entries()),_step38;!(_step38=_iterator38()).done;){const _step38$value=_step38.value,m=_step38$value[0],v=_step38$value[1];v.clear(),br.get(this).delete(m);}for(var _iterator39=_createForOfIteratorHelperLoose(qn.get(this).entries()),_step39;!(_step39=_iterator39()).done;){const _step39$value=_step39.value,m=_step39$value[0],v=_step39$value[1];for(var _iterator40=_createForOfIteratorHelperLoose(v),_step40;!(_step40=_iterator40()).done;){const S=_step40.value;S.finish();}v.clear(),qn.get(this).delete(m);}}}};_proto10.listenerCount=function listenerCount(e){var m,v,S;e=Array.isArray(e)?e:[e];let i=0;for(var _iterator41=_createForOfIteratorHelperLoose(e),_step41;!(_step41=_iterator41()).done;){const L=_step41.value;if(typeof L=="string"){var _ref17,_ref18,_ref19;i+=ir.get(this).size+((_ref17=(m=Yr(this,L))==null?void 0:m.size)!=null?_ref17:0)+((_ref18=(v=Kr(this,L))==null?void 0:v.size)!=null?_ref18:0)+((_ref19=(S=Kr(this))==null?void 0:S.size)!=null?_ref19:0);continue;}typeof L<"u"&&Tr(L),i+=ir.get(this).size;for(var _iterator42=_createForOfIteratorHelperLoose(br.get(this).values()),_step42;!(_step42=_iterator42()).done;){const T=_step42.value;i+=T.size;}for(var _iterator43=_createForOfIteratorHelperLoose(qn.get(this).values()),_step43;!(_step43=_iterator43()).done;){const T=_step43.value;i+=T.size;}}return i;};_proto10.bindMethods=function bindMethods(e,i){if(typeof e!="object"||e===null)throw new TypeError("`target` must be an object");i=Rs(i);for(var _iterator44=_createForOfIteratorHelperLoose(i),_step44;!(_step44=_iterator44()).done;){const m=_step44.value;if(e[m]!==void 0)throw new Error(`The property \`${m}\` already exists on \`target\``);Object.defineProperty(e,m,{enumerable:!1,value:this[m].bind(this)});}};(0,_createClass2.default)(vo,null,[{key:"isDebugEnabled",get:function get(){var _globalThis$process;var i;if(typeof((i=_globalThis.process)==null?void 0:i.env)!="object")return uo;const _ref20=(_globalThis$process=_globalThis.process)!=null?_globalThis$process:{env:{}},e=_ref20.env;return e.DEBUG==="emittery"||e.DEBUG==="*"||uo;},set:function set(e){uo=e;}}]);return vo;}();const xs=Object.getOwnPropertyNames(qr.prototype).filter(r=>r!=="constructor");Object.defineProperty(qr,"listenerAdded",{value:Fi,writable:!1,enumerable:!0,configurable:!1});Object.defineProperty(qr,"listenerRemoved",{value:Li,writable:!1,enumerable:!0,configurable:!1});function Uo(r,e){_globalThis.vonage||(_globalThis.vonage={}),_globalThis.vonage.workerizer||(_globalThis.vonage.workerizer={});let i=_globalThis.vonage.workerizer;return i[r]||(i[r]=e),i[r];}const kr=Uo("globals",{});var Pn=/* @__PURE__ */(r=>(r.INIT="INIT",r.FORWARD="FORWARD",r.TERMINATE="TERMINATE",r.GLOBALS_SYNC="GLOBALS_SYNC",r.EVENT="EVENT",r))(Pn||{});function Qs(r){return[ImageBitmap,ReadableStream,WritableStream].some(i=>r instanceof i);}let q2=0;function Ci(r,e,i,m,v){const S=q2++;return r.postMessage({id:S,type:e,functionName:i,args:m},m.filter(T=>Qs(T))),new Promise(T=>{v==null||v.set(S,T);});}function Ur(r,e){const i=r.id,m=r.type,v=Array.isArray(e)?e:[e];postMessage({id:i,type:m,result:e},v.filter(S=>Qs(S)));}const Ni=Uo("workerized",{});function Eo(){return typeof WorkerGlobalScope<"u"&&self instanceof WorkerGlobalScope;}function tc(){return _tc.apply(this,arguments);}function _tc(){_tc=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee100(){var r,e,_Ni$e$workerContext,i,m;return _regenerator.default.wrap(function _callee100$(_context100){while(1)switch(_context100.prev=_context100.next){case 0:if(!Eo()){_context100.next=4;break;}Ur({type:Pn.GLOBALS_SYNC},kr);_context100.next=8;break;case 4:r=[];for(e in Ni){_Ni$e$workerContext=Ni[e].workerContext,i=_Ni$e$workerContext.worker,m=_Ni$e$workerContext.resolvers;i&&r.push(Ci(i,Pn.GLOBALS_SYNC,"",[kr],m));}_context100.next=8;return Promise.all(r);case 8:case"end":return _context100.stop();}},_callee100);}));return _tc.apply(this,arguments);}function Pr(r,e){if(Array.isArray(e))e.splice(0,e.length);else if(typeof e=="object")for(const i in e)delete e[i];for(const i in r)Array.isArray(r[i])?(e[i]=[],Pr(r[i],e[i])):typeof r[i]=="object"?(e[i]={},Pr(r[i],e[i])):e[i]=r[i];}function ec(_x35,_x36,_x37,_x38){return _ec.apply(this,arguments);}function _ec(){_ec=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee102(r,e,i,m){var v;return _regenerator.default.wrap(function _callee102$(_context102){while(1)switch(_context102.prev=_context102.next){case 0:v=new e();v.addEventListener("message",/*#__PURE__*/function(){var _ref34=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee101(_ref33){var L,T,k,tt,st,bt,xt,Yt,at,ht;return _regenerator.default.wrap(function _callee101$(_context101){while(1)switch(_context101.prev=_context101.next){case 0:L=_ref33.data;_context101.t0=L.type;_context101.next=_context101.t0===Pn.GLOBALS_SYNC?4:_context101.t0===Pn.EVENT?12:17;break;case 4:if(!L.id){_context101.next=8;break;}(k=i.get((T=L.id)!=null?T:-1))==null||k(L.result),i.delete((tt=L.id)!=null?tt:-1);_context101.next=11;break;case 8:Pr((st=L.result)!=null?st:{},kr);_context101.next=11;return tc();case 11:return _context101.abrupt("break",18);case 12:at=L.result,ht=at;if(!((ht==null?void 0:ht.name)==null)){_context101.next=15;break;}throw"Missing event name";case 15:m(ht.name,ht.data);return _context101.abrupt("break",18);case 17:(xt=i.get((bt=L.id)!=null?bt:-1))==null||xt(L.result),i.delete((Yt=L.id)!=null?Yt:-1);case 18:case"end":return _context101.stop();}},_callee101);}));return function(_x121){return _ref34.apply(this,arguments);};}());_context102.next=4;return Ci(v,Pn.INIT,"",[r.workerId,kr],i);case 4:if(_context102.sent){_context102.next=6;break;}throw"Failed to instantiate workerized class";case 6:return _context102.abrupt("return",v);case 7:case"end":return _context102.stop();}},_callee102);}));return _ec.apply(this,arguments);}const or=/* @__PURE__ */new WeakMap(),yr=/* @__PURE__ */new WeakMap(),tr=/* @__PURE__ */new WeakMap(),Ji=Symbol("anyProducer"),Is=Promise.resolve(),ki=Symbol("listenerAdded"),Ui=Symbol("listenerRemoved");let Ei=!1,ao=!1;function wr(r){if(typeof r!="string"&&typeof r!="symbol"&&typeof r!="number")throw new TypeError("`eventName` must be a string, symbol, or number");}function ui(r){if(typeof r!="function")throw new TypeError("listener must be a function");}function Fr(r,e){const i=yr.get(r);if(i.has(e))return i.get(e);}function Or(r,e){const i=typeof e=="string"||typeof e=="symbol"||typeof e=="number"?e:Ji,m=tr.get(r);if(m.has(i))return m.get(i);}function nc(r,e,i){const m=tr.get(r);if(m.has(e)){for(var _iterator45=_createForOfIteratorHelperLoose(m.get(e)),_step45;!(_step45=_iterator45()).done;){const v=_step45.value;v.enqueue(i);}}if(m.has(Ji)){const v=Promise.all([e,i]);for(var _iterator46=_createForOfIteratorHelperLoose(m.get(Ji)),_step46;!(_step46=_iterator46()).done;){const S=_step46.value;S.enqueue(v);}}}function Ss(r,e){e=Array.isArray(e)?e:[e];let i=!1,m=()=>{},v=[];const S={enqueue(L){v.push(L),m();},finish(){i=!0,m();}};for(var _iterator47=_createForOfIteratorHelperLoose(e),_step47;!(_step47=_iterator47()).done;){const L=_step47.value;let T=Or(r,L);T||(T=/* @__PURE__ */new Set(),tr.get(r).set(L,T)),T.add(S);}return{next(){var _this10=this;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee29(){return _regenerator.default.wrap(function _callee29$(_context29){while(1)switch(_context29.prev=_context29.next){case 0:if(!v){_context29.next=20;break;}if(!(v.length===0)){_context29.next=12;break;}if(!i){_context29.next=6;break;}_context29.t2=(v=void 0,_this10.next());_context29.next=9;break;case 6:_context29.next=8;return new Promise(L=>{m=L;});case 8:_context29.t2=_this10.next();case 9:_context29.t1=_context29.t2;_context29.next=17;break;case 12:_context29.t3=!1;_context29.next=15;return v.shift();case 15:_context29.t4=_context29.sent;_context29.t1={done:_context29.t3,value:_context29.t4};case 17:_context29.t0=_context29.t1;_context29.next=21;break;case 20:_context29.t0={done:!0};case 21:return _context29.abrupt("return",_context29.t0);case 22:case"end":return _context29.stop();}},_callee29);}))();},return(L){var _arguments3=arguments;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee30(){var _iterator48,_step48,T,k;return _regenerator.default.wrap(function _callee30$(_context30){while(1)switch(_context30.prev=_context30.next){case 0:v=void 0;for(_iterator48=_createForOfIteratorHelperLoose(e);!(_step48=_iterator48()).done;){T=_step48.value;k=Or(r,T);k&&(k.delete(S),k.size===0&&tr.get(r).delete(T));}m();if(!(_arguments3.length>0)){_context30.next=11;break;}_context30.t1=!0;_context30.next=7;return L;case 7:_context30.t2=_context30.sent;_context30.t0={done:_context30.t1,value:_context30.t2};_context30.next=12;break;case 11:_context30.t0={done:!0};case 12:return _context30.abrupt("return",_context30.t0);case 13:case"end":return _context30.stop();}},_callee30);}))();},[Symbol.asyncIterator](){return this;}};}function Ts(r){if(r===void 0)return Ys;if(!Array.isArray(r))throw new TypeError("`methodNames` must be an array of strings");for(var _iterator49=_createForOfIteratorHelperLoose(r),_step49;!(_step49=_iterator49()).done;){const e=_step49.value;if(!Ys.includes(e))throw typeof e!="string"?new TypeError("`methodNames` element must be a string"):new Error(`${e} is not Emittery method`);}return r;}const Cr=r=>r===ki||r===Ui;function ai(r,e,i){if(Cr(e))try{Ei=!0,r.emit(e,i);}finally{Ei=!1;}}let Vr=/*#__PURE__*/function(){Vr.mixin=function mixin(e,i){return i=Ts(i),m=>{if(typeof m!="function")throw new TypeError("`target` must be function");for(var _iterator50=_createForOfIteratorHelperLoose(i),_step50;!(_step50=_iterator50()).done;){const L=_step50.value;if(m.prototype[L]!==void 0)throw new Error(`The property \`${L}\` already exists on \`target\``);}function v(){return Object.defineProperty(this,e,{enumerable:!1,value:new Vr()}),this[e];}Object.defineProperty(m.prototype,e,{enumerable:!1,get:v});const S=L=>function(){return this[e][L](...arguments);};for(var _iterator51=_createForOfIteratorHelperLoose(i),_step51;!(_step51=_iterator51()).done;){const L=_step51.value;Object.defineProperty(m.prototype,L,{enumerable:!1,value:S(L)});}return m;};};function Vr(e){if(e===void 0){e={};}var i;or.set(this,/* @__PURE__ */new Set()),yr.set(this,/* @__PURE__ */new Map()),tr.set(this,/* @__PURE__ */new Map()),tr.get(this).set(Ji,/* @__PURE__ */new Set()),this.debug=(i=e.debug)!=null?i:{},this.debug.enabled===void 0&&(this.debug.enabled=!1),this.debug.logger||(this.debug.logger=(m,v,S,L)=>{try{L=JSON.stringify(L);}catch(_unused12){L=`Object with the following keys failed to stringify: ${Object.keys(L).join(",")}`;}(typeof S=="symbol"||typeof S=="number")&&(S=S.toString());const T=/* @__PURE__ */new Date(),k=`${T.getHours()}:${T.getMinutes()}:${T.getSeconds()}.${T.getMilliseconds()}`;console.log(`[${k}][emittery:${m}][${v}] Event Name: ${S}
	data: ${L}`);});}var _proto11=Vr.prototype;_proto11.logIfDebugEnabled=function logIfDebugEnabled(e,i,m){(Vr.isDebugEnabled||this.debug.enabled)&&this.debug.logger(e,this.debug.name,i,m);};_proto11.on=function on(e,i){ui(i),e=Array.isArray(e)?e:[e];for(var _iterator52=_createForOfIteratorHelperLoose(e),_step52;!(_step52=_iterator52()).done;){const m=_step52.value;wr(m);let v=Fr(this,m);v||(v=/* @__PURE__ */new Set(),yr.get(this).set(m,v)),v.add(i),this.logIfDebugEnabled("subscribe",m,void 0),Cr(m)||ai(this,ki,{eventName:m,listener:i});}return this.off.bind(this,e,i);};_proto11.off=function off(e,i){ui(i),e=Array.isArray(e)?e:[e];for(var _iterator53=_createForOfIteratorHelperLoose(e),_step53;!(_step53=_iterator53()).done;){const m=_step53.value;wr(m);const v=Fr(this,m);v&&(v.delete(i),v.size===0&&yr.get(this).delete(m)),this.logIfDebugEnabled("unsubscribe",m,void 0),Cr(m)||ai(this,Ui,{eventName:m,listener:i});}};_proto11.once=function once(e){let i;const m=new Promise(v=>{i=this.on(e,S=>{i(),v(S);});});return m.off=i,m;};_proto11.events=function events(e){e=Array.isArray(e)?e:[e];for(var _iterator54=_createForOfIteratorHelperLoose(e),_step54;!(_step54=_iterator54()).done;){const i=_step54.value;wr(i);}return Ss(this,e);};_proto11.emit=/*#__PURE__*/function(){var _emit3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee33(e,i){var m,v,S,L,T;return _regenerator.default.wrap(function _callee33$(_context33){while(1)switch(_context33.prev=_context33.next){case 0:if(!(wr(e),Cr(e)&&!Ei)){_context33.next=2;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 2:this.logIfDebugEnabled("emit",e,i),nc(this,e,i);v=(m=Fr(this,e))!=null?m:/* @__PURE__ */new Set(),S=or.get(this),L=[...v],T=Cr(e)?[]:[...S];_context33.next=6;return Is;case 6:_context33.next=8;return Promise.all([...L.map(/*#__PURE__*/function(){var _ref21=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee31(k){return _regenerator.default.wrap(function _callee31$(_context31){while(1)switch(_context31.prev=_context31.next){case 0:if(!v.has(k)){_context31.next=2;break;}return _context31.abrupt("return",k(i));case 2:case"end":return _context31.stop();}},_callee31);}));return function(_x41){return _ref21.apply(this,arguments);};}()),...T.map(/*#__PURE__*/function(){var _ref22=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee32(k){return _regenerator.default.wrap(function _callee32$(_context32){while(1)switch(_context32.prev=_context32.next){case 0:if(!S.has(k)){_context32.next=2;break;}return _context32.abrupt("return",k(e,i));case 2:case"end":return _context32.stop();}},_callee32);}));return function(_x42){return _ref22.apply(this,arguments);};}())]);case 8:case"end":return _context33.stop();}},_callee33,this);}));function emit(_x39,_x40){return _emit3.apply(this,arguments);}return emit;}();_proto11.emitSerial=/*#__PURE__*/function(){var _emitSerial3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee34(e,i){var m,v,S,L,T,_i6,_L3,k,_i7,_T2;return _regenerator.default.wrap(function _callee34$(_context34){while(1)switch(_context34.prev=_context34.next){case 0:if(!(wr(e),Cr(e)&&!Ei)){_context34.next=2;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 2:this.logIfDebugEnabled("emitSerial",e,i);v=(m=Fr(this,e))!=null?m:/* @__PURE__ */new Set(),S=or.get(this),L=[...v],T=[...S];_context34.next=6;return Is;case 6:_i6=0,_L3=L;case 7:if(!(_i6<_L3.length)){_context34.next=16;break;}k=_L3[_i6];_context34.t0=v.has(k);if(!_context34.t0){_context34.next=13;break;}_context34.next=13;return k(i);case 13:_i6++;_context34.next=7;break;case 16:_i7=0,_T2=T;case 17:if(!(_i7<_T2.length)){_context34.next=26;break;}k=_T2[_i7];_context34.t1=S.has(k);if(!_context34.t1){_context34.next=23;break;}_context34.next=23;return k(e,i);case 23:_i7++;_context34.next=17;break;case 26:case"end":return _context34.stop();}},_callee34,this);}));function emitSerial(_x43,_x44){return _emitSerial3.apply(this,arguments);}return emitSerial;}();_proto11.onAny=function onAny(e){return ui(e),this.logIfDebugEnabled("subscribeAny",void 0,void 0),or.get(this).add(e),ai(this,ki,{listener:e}),this.offAny.bind(this,e);};_proto11.anyEvent=function anyEvent(){return Ss(this);};_proto11.offAny=function offAny(e){ui(e),this.logIfDebugEnabled("unsubscribeAny",void 0,void 0),ai(this,Ui,{listener:e}),or.get(this).delete(e);};_proto11.clearListeners=function clearListeners(e){e=Array.isArray(e)?e:[e];for(var _iterator55=_createForOfIteratorHelperLoose(e),_step55;!(_step55=_iterator55()).done;){const i=_step55.value;if(this.logIfDebugEnabled("clear",i,void 0),typeof i=="string"||typeof i=="symbol"||typeof i=="number"){const m=Fr(this,i);m&&m.clear();const v=Or(this,i);if(v){for(var _iterator56=_createForOfIteratorHelperLoose(v),_step56;!(_step56=_iterator56()).done;){const S=_step56.value;S.finish();}v.clear();}}else{or.get(this).clear();for(var _iterator57=_createForOfIteratorHelperLoose(yr.get(this).entries()),_step57;!(_step57=_iterator57()).done;){const _step57$value=_step57.value,m=_step57$value[0],v=_step57$value[1];v.clear(),yr.get(this).delete(m);}for(var _iterator58=_createForOfIteratorHelperLoose(tr.get(this).entries()),_step58;!(_step58=_iterator58()).done;){const _step58$value=_step58.value,m=_step58$value[0],v=_step58$value[1];for(var _iterator59=_createForOfIteratorHelperLoose(v),_step59;!(_step59=_iterator59()).done;){const S=_step59.value;S.finish();}v.clear(),tr.get(this).delete(m);}}}};_proto11.listenerCount=function listenerCount(e){var i,m,v,S,L,T;e=Array.isArray(e)?e:[e];let k=0;for(var _iterator60=_createForOfIteratorHelperLoose(e),_step60;!(_step60=_iterator60()).done;){const tt=_step60.value;if(typeof tt=="string"){k+=or.get(this).size+((m=(i=Fr(this,tt))==null?void 0:i.size)!=null?m:0)+((S=(v=Or(this,tt))==null?void 0:v.size)!=null?S:0)+((T=(L=Or(this))==null?void 0:L.size)!=null?T:0);continue;}typeof tt<"u"&&wr(tt),k+=or.get(this).size;for(var _iterator61=_createForOfIteratorHelperLoose(yr.get(this).values()),_step61;!(_step61=_iterator61()).done;){const st=_step61.value;k+=st.size;}for(var _iterator62=_createForOfIteratorHelperLoose(tr.get(this).values()),_step62;!(_step62=_iterator62()).done;){const st=_step62.value;k+=st.size;}}return k;};_proto11.bindMethods=function bindMethods(e,i){if(typeof e!="object"||e===null)throw new TypeError("`target` must be an object");i=Ts(i);for(var _iterator63=_createForOfIteratorHelperLoose(i),_step63;!(_step63=_iterator63()).done;){const m=_step63.value;if(e[m]!==void 0)throw new Error(`The property \`${m}\` already exists on \`target\``);Object.defineProperty(e,m,{enumerable:!1,value:this[m].bind(this)});}};(0,_createClass2.default)(Vr,null,[{key:"isDebugEnabled",get:function get(){var e,i;if(typeof((e=_globalThis.process)==null?void 0:e.env)!="object")return ao;const _ref23=(i=_globalThis.process)!=null?i:{env:{}},m=_ref23.env;return m.DEBUG==="emittery"||m.DEBUG==="*"||ao;},set:function set(e){ao=e;}}]);return Vr;}();const Ys=Object.getOwnPropertyNames(Vr.prototype).filter(r=>r!=="constructor");Object.defineProperty(Vr,"listenerAdded",{value:ki,writable:!1,enumerable:!0,configurable:!1});Object.defineProperty(Vr,"listenerRemoved",{value:Ui,writable:!1,enumerable:!0,configurable:!1});function rc(r){return r.onAny&&r.emit;}function ic(r){return r.prototype.onAny&&r.prototype.emit;}let oc=0;function sc(_x45,_x46,_x47){return _sc.apply(this,arguments);}function _sc(){_sc=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee104(r,e,i){var v,S;return _regenerator.default.wrap(function _callee104$(_context104){while(1)switch(_context104.prev=_context104.next){case 0:v=ic(r)?new Vr():{},S=oc++;return _context104.abrupt("return",(Object.getOwnPropertyNames(r.prototype).forEach(L=>{v[L]=function(){for(var _len2=arguments.length,T=new Array(_len2),_key2=0;_key2<_len2;_key2++){T[_key2]=arguments[_key2];}return Ci(e,Pn.FORWARD,L,T,i);};}),v.terminate=/*#__PURE__*/(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee103(){var _len3,L,_key3,T,_args64=arguments;return _regenerator.default.wrap(function _callee103$(_context103){while(1)switch(_context103.prev=_context103.next){case 0:for(_len3=_args64.length,L=new Array(_len3),_key3=0;_key3<_len3;_key3++){L[_key3]=_args64[_key3];}_context103.next=3;return Ci(e,Pn.TERMINATE,"",L,i);case 3:T=_context103.sent;return _context103.abrupt("return",(delete Ni[S],e.terminate(),v.workerContext.worker=void 0,T));case 5:case"end":return _context103.stop();}},_callee103);})),v.workerContext={id:S,worker:e,resolvers:i},Ni[S]=v,v));case 2:case"end":return _context104.stop();}},_callee104);}));return _sc.apply(this,arguments);}function lc(_x48,_x49){return _lc.apply(this,arguments);}function _lc(){_lc=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee105(r,e){var i,m,v;return _regenerator.default.wrap(function _callee105$(_context105){while(1)switch(_context105.prev=_context105.next){case 0:i=/* @__PURE__ */new Map();_context105.next=3;return ec(r,e,i,(S,L)=>{m!=null&&m.emit&&(m==null||m.emit(S,L));});case 3:v=_context105.sent;_context105.next=6;return sc(r,v,i);case 6:m=_context105.sent;return _context105.abrupt("return",m);case 8:case"end":return _context105.stop();}},_callee105);}));return _lc.apply(this,arguments);}function cc(_x50,_x51){return _cc.apply(this,arguments);}function _cc(){_cc=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee106(r,e){var i,m;return _regenerator.default.wrap(function _callee106$(_context106){while(1)switch(_context106.prev=_context106.next){case 0:i=r.functionName,m=r.args;if(e.instance){_context106.next=3;break;}throw"instance not initialized";case 3:if(i){_context106.next=5;break;}throw"missing function name to call";case 5:if(e.instance[i]){_context106.next=7;break;}throw`undefined function [${i}] in class ${e.instance.constructor.workerId}`;case 7:_context106.t0=Ur;_context106.t1=r;_context106.next=11;return e.instance[i](...(m!=null?m:[]));case 11:_context106.t2=_context106.sent;(0,_context106.t0)(_context106.t1,_context106.t2);case 13:case"end":return _context106.stop();}},_callee106);}));return _cc.apply(this,arguments);}const Ds=Uo("registeredWorkers",{});function uc(r,e){e.workerId=r,Eo()&&(Ds[e.workerId]=e);}function ac(r,e){if(!r.args)throw"Missing className while initializing worker";const _r$args2=r.args,i=_r$args2[0],m=_r$args2[1],v=Ds[i];if(v)e.instance=new v(r.args.slice(1));else throw`unknown worker class ${i}`;Pr(m,kr),rc(e.instance)&&e.instance.onAny((S,L)=>{Ur({type:Pn.EVENT},{name:S,data:L});}),Ur(r,typeof e.instance!==void 0);}function dc(_x52,_x53){return _dc.apply(this,arguments);}function _dc(){_dc=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee107(r,e){var i,m;return _regenerator.default.wrap(function _callee107$(_context107){while(1)switch(_context107.prev=_context107.next){case 0:i=r.args;if(e.instance){_context107.next=3;break;}throw"instance not initialized";case 3:_context107.t0=e.instance.terminate;if(!_context107.t0){_context107.next=8;break;}_context107.next=7;return e.instance.terminate(...(i!=null?i:[]));case 7:m=_context107.sent;case 8:Ur(r,m);case 9:case"end":return _context107.stop();}},_callee107);}));return _dc.apply(this,arguments);}function hc(r){if(!r.args)throw"Missing globals while syncing";Pr(r.args[0],kr),Ur(r,{});}function fc(){const r={};onmessage=/*#__PURE__*/function(){var _ref24=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee35(e){var i;return _regenerator.default.wrap(function _callee35$(_context35){while(1)switch(_context35.prev=_context35.next){case 0:i=e.data;_context35.t0=i.type;_context35.next=_context35.t0===Pn.INIT?4:_context35.t0===Pn.FORWARD?6:_context35.t0===Pn.TERMINATE?8:_context35.t0===Pn.GLOBALS_SYNC?10:12;break;case 4:ac(i,r);return _context35.abrupt("break",12);case 6:cc(i,r);return _context35.abrupt("break",12);case 8:dc(i,r);return _context35.abrupt("break",12);case 10:hc(i);return _context35.abrupt("break",12);case 12:case"end":return _context35.stop();}},_callee35);}));return function onmessage(_x54){return _ref24.apply(this,arguments);};}();}Eo()&&fc();let ws=/*#__PURE__*/function(){function ws(){}ws.createVideoReadable=/*#__PURE__*/function(){var _createVideoReadable=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee36(e){return _regenerator.default.wrap(function _callee36$(_context36){while(1)switch(_context36.prev=_context36.next){case 0:return _context36.abrupt("return",new Promise((i,m)=>{const v=document.createElement("video");let S=new AbortController(),L=new AbortController();v.addEventListener("canplay",()=>{S.abort(),v.muted=!0,v.loop=!0,v.play().then(()=>{try{const T=v.captureStream(),k=new MediaStreamTrackProcessor(T.getVideoTracks()[0]);i(k.readable);}catch(T){m(T);}});},{once:!0,signal:L.signal}),v.addEventListener("error",T=>{L.abort(),m("loading error:"+T);},{once:!0,signal:S.signal}),v.crossOrigin="anonymous",v.src=e;}));case 1:case"end":return _context36.stop();}},_callee36);}));function createVideoReadable(_x55){return _createVideoReadable.apply(this,arguments);}return createVideoReadable;}();ws.createImageCanvas=/*#__PURE__*/function(){var _createImageCanvas=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee37(e){var m;return _regenerator.default.wrap(function _callee37$(_context37){while(1)switch(_context37.prev=_context37.next){case 0:_context37.next=2;return fetch(e);case 2:_context37.next=4;return _context37.sent.blob();case 4:m=_context37.sent;_context37.next=7;return createImageBitmap(m);case 7:return _context37.abrupt("return",_context37.sent);case 8:case"end":return _context37.stop();}},_callee37);}));function createImageCanvas(_x56){return _createImageCanvas.apply(this,arguments);}return createImageCanvas;}();return ws;}();var mc=Object.defineProperty,pc=(r,e,i)=>e in r?mc(r,e,{enumerable:!0,configurable:!0,writable:!0,value:i}):r[e]=i,bc=(r,e,i)=>(pc(r,e+"",i),i);const yc="hlg.tokbox.com/prod/logging/vcp_webrtc",gc="https://",Zc=1e4;let di;const vc=new Uint8Array(16);function Gc(){if(!di&&(di=typeof crypto<"u"&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto),!di))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return di(vc);}const Nn=[];for(let r=0;r<256;++r)Nn.push((r+256).toString(16).slice(1));function Xc(r,e){if(e===void 0){e=0;}return(Nn[r[e+0]]+Nn[r[e+1]]+Nn[r[e+2]]+Nn[r[e+3]]+"-"+Nn[r[e+4]]+Nn[r[e+5]]+"-"+Nn[r[e+6]]+Nn[r[e+7]]+"-"+Nn[r[e+8]]+Nn[r[e+9]]+"-"+Nn[r[e+10]]+Nn[r[e+11]]+Nn[r[e+12]]+Nn[r[e+13]]+Nn[r[e+14]]+Nn[r[e+15]]).toLowerCase();}const Wc=typeof crypto<"u"&&crypto.randomUUID&&crypto.randomUUID.bind(crypto),Fs={randomUUID:Wc};function Vc(r,e,i){if(Fs.randomUUID&&!e&&!r)return Fs.randomUUID();r=r||{};const m=r.random||(r.rng||Gc)();return m[6]=m[6]&15|64,m[8]=m[8]&63|128,Xc(m);}function Mo(r,e){_globalThis.vonage||(_globalThis.vonage={}),_globalThis.vonage.workerizer||(_globalThis.vonage.workerizer={});let i=_globalThis.vonage.workerizer;return i[r]||(i[r]=e),i[r];}const ur=Mo("globals",{});var Xr=/* @__PURE__ */(r=>(r.INIT="INIT",r.FORWARD="FORWARD",r.TERMINATE="TERMINATE",r.GLOBALS_SYNC="GLOBALS_SYNC",r))(Xr||{});function $s(r){return[ImageBitmap,ReadableStream,WritableStream].some(e=>r instanceof e);}let Rc=0;function xc(r,e,i,m,v){const S=Rc++;return r.postMessage({id:S,type:e,functionName:i,args:m},m.filter(L=>$s(L))),new Promise(L=>{v==null||v.set(S,L);});}function ti(r,e){const i=r.id,m=r.type,v=Array.isArray(e)?e:[e];postMessage({id:i,type:m,result:e},v.filter(S=>$s(S)));}const Ls=Mo("workerized",{});function qs(){return typeof WorkerGlobalScope<"u"&&self instanceof WorkerGlobalScope;}function Ic(){return _Ic.apply(this,arguments);}function _Ic(){_Ic=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee108(){var r,e,_Ls$e$workerContext,i,m;return _regenerator.default.wrap(function _callee108$(_context108){while(1)switch(_context108.prev=_context108.next){case 0:if(!qs()){_context108.next=4;break;}ti({type:Xr.GLOBALS_SYNC},ur);_context108.next=8;break;case 4:r=[];for(e in Ls){_Ls$e$workerContext=Ls[e].workerContext,i=_Ls$e$workerContext.worker,m=_Ls$e$workerContext.resolvers;i&&r.push(xc(i,Xr.GLOBALS_SYNC,"",[ur],m));}_context108.next=8;return Promise.all(r);case 8:case"end":return _context108.stop();}},_callee108);}));return _Ic.apply(this,arguments);}function Mi(r,e){if(Array.isArray(e))e.splice(0,e.length);else if(typeof e=="object")for(const i in e)delete e[i];for(const i in r)Array.isArray(r[i])?(e[i]=[],Mi(r[i],e[i])):typeof r[i]=="object"?(e[i]={},Mi(r[i],e[i])):e[i]=r[i];}function Sc(_x57,_x58){return _Sc.apply(this,arguments);}function _Sc(){_Sc=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee109(r,e){var i,m;return _regenerator.default.wrap(function _callee109$(_context109){while(1)switch(_context109.prev=_context109.next){case 0:i=r.functionName,m=r.args;if(e.instance){_context109.next=3;break;}throw"instance not initialized";case 3:if(i){_context109.next=5;break;}throw"missing function name to call";case 5:if(e.instance[i]){_context109.next=7;break;}throw`undefined function [${i}] in class ${e.instance.constructor.workerId}`;case 7:_context109.t0=ti;_context109.t1=r;_context109.next=11;return e.instance[i](...(m!=null?m:[]));case 11:_context109.t2=_context109.sent;(0,_context109.t0)(_context109.t1,_context109.t2);case 13:case"end":return _context109.stop();}},_callee109);}));return _Sc.apply(this,arguments);}const Tc=Mo("registeredWorkers",{});function Yc(r,e){if(!r.args)throw"Missing className while initializing worker";const _r$args3=r.args,i=_r$args3[0],m=_r$args3[1],v=Tc[i];if(v)e.instance=new v(r.args.slice(1));else throw`unknown worker class ${i}`;Mi(m,ur),ti(r,typeof e.instance!==void 0);}function wc(_x59,_x60){return _wc.apply(this,arguments);}function _wc(){_wc=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee110(r,e){var i,m;return _regenerator.default.wrap(function _callee110$(_context110){while(1)switch(_context110.prev=_context110.next){case 0:i=r.args;if(e.instance){_context110.next=3;break;}throw"instance not initialized";case 3:_context110.t0=e.instance.terminate;if(!_context110.t0){_context110.next=8;break;}_context110.next=7;return e.instance.terminate(...(i!=null?i:[]));case 7:m=_context110.sent;case 8:ti(r,m);case 9:case"end":return _context110.stop();}},_callee110);}));return _wc.apply(this,arguments);}function Fc(r){if(!r.args)throw"Missing globals while syncing";Mi(r.args[0],ur),ti(r,{});}function Lc(){const r={};onmessage=/*#__PURE__*/function(){var _ref25=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee38(e){var i;return _regenerator.default.wrap(function _callee38$(_context38){while(1)switch(_context38.prev=_context38.next){case 0:i=e.data;_context38.t0=i.type;_context38.next=_context38.t0===Xr.INIT?4:_context38.t0===Xr.FORWARD?6:_context38.t0===Xr.TERMINATE?8:_context38.t0===Xr.GLOBALS_SYNC?10:12;break;case 4:Yc(i,r);return _context38.abrupt("break",12);case 6:Sc(i,r);return _context38.abrupt("break",12);case 8:wc(i,r);return _context38.abrupt("break",12);case 10:Fc(i);return _context38.abrupt("break",12);case 12:case"end":return _context38.stop();}},_callee38);}));return function onmessage(_x61){return _ref25.apply(this,arguments);};}();}qs()&&Lc();function Hc(r,e){return ur[r]||(ur[r]=e),[()=>ur[r],/*#__PURE__*/function(){var _ref26=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee39(i){return _regenerator.default.wrap(function _callee39$(_context39){while(1)switch(_context39.prev=_context39.next){case 0:ur[r]=i;_context39.next=3;return Ic();case 3:case"end":return _context39.stop();}},_callee39);}));return function(_x62){return _ref26.apply(this,arguments);};}()];}function Cc(r,e){return Hc(r,e);}const _Cc=Cc("metadata"),Nc=_Cc[0],Y3=_Cc[1];function ho(){return Nc();}let Jc=/*#__PURE__*/function(){function Jc(e){bc(this,"uuid",Vc()),this.config=e;}var _proto12=Jc.prototype;_proto12.send=/*#__PURE__*/function(){var _send2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee40(e){var i,m,v,_ref9,S,L,T,k;return _regenerator.default.wrap(function _callee40$(_context40){while(1)switch(_context40.prev=_context40.next){case 0:_ref9=(i=ho())!=null?i:{},S=_ref9.appId,L=_ref9.sourceType;if(!(!S||!L)){_context40.next=3;break;}return _context40.abrupt("return","metadata missing");case 3:T=new AbortController(),k=setTimeout(()=>T.abort(),Zc);_context40.next=6;return((v=(m=this.config)==null?void 0:m.fetch)!=null?v:fetch)(this.getUrl(),{method:"POST",headers:this.getHeaders(),body:JSON.stringify(this.buildReport(e)),signal:T.signal});case 6:clearTimeout(k);return _context40.abrupt("return","success");case 8:case"end":return _context40.stop();}},_callee40,this);}));function send(_x63){return _send2.apply(this,arguments);}return send;}();_proto12.getUrl=function getUrl(){var e;let i=(e=ho().proxyUrl)!=null?e:gc;return i+=(i.at(-1)==="/"?"":"/")+yc,i;};_proto12.getHeaders=function getHeaders(){return{"Content-Type":"application/json"};};_proto12.buildReport=function buildReport(e){const i=ho();return Object.assign({guid:this.uuid},e,{applicationId:i.appId,timestamp:Date.now(),proxyUrl:i.proxyUrl,source:i.sourceType});};return Jc;}();const kc="6.0.0-alpha.2";let zo=/*#__PURE__*/function(){function zo(){const e=new OffscreenCanvas(0,0),i=e.getContext("2d",{willReadFrequently:!0});if(!i)throw"Fail to retrieve 2d context";this.canvas=e,this.context=i;}var _proto13=zo.prototype;_proto13.setFlickeringOptions=function setFlickeringOptions(e){};_proto13.enablePostProcessing=function enablePostProcessing(){};_proto13.disablePostProcessing=function disablePostProcessing(){};_proto13.profileWebgl=/*#__PURE__*/function(){var _profileWebgl=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee41(e){return _regenerator.default.wrap(function _callee41$(_context41){while(1)switch(_context41.prev=_context41.next){case 0:return _context41.abrupt("return",[]);case 1:case"end":return _context41.stop();}},_callee41);}));function profileWebgl(_x64){return _profileWebgl.apply(this,arguments);}return profileWebgl;}();_proto13.render=/*#__PURE__*/function(){var _render=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee42(e,i){return _regenerator.default.wrap(function _callee42$(_context42){while(1)switch(_context42.prev=_context42.next){case 0:return _context42.abrupt("return",this.canvas);case 1:case"end":return _context42.stop();}},_callee42,this);}));function render(_x65,_x66){return _render.apply(this,arguments);}return render;}();_proto13.resizeCanvas=function resizeCanvas(e){const i=e.width,m=e.height;this.canvas.width=i,this.canvas.height=m;};_proto13.renderSilhouette=function renderSilhouette(e,i,m){if(m===void 0){m="none";}const v=e.width,S=e.height;this.context.save(),this.context.drawImage(i,0,0,i.width,i.height,0,0,v,S),this.context.filter="blur(5px)",this.context.globalCompositeOperation="source-in",this.context.drawImage(i,0,0,i.width,i.height,0,0,v,S),this.context.globalCompositeOperation="source-in",this.context.filter=m,this.context.drawImage(e,0,0,v,S,0,0,this.canvas.width,this.canvas.height),this.context.restore();};_proto13.destroy=function destroy(){};return zo;}();let Uc=/*#__PURE__*/function(_zo){(0,_inheritsLoose2.default)(Uc,_zo);function Uc(e){var _this11;_this11=_zo.call(this)||this,_this11.radius=e;return _this11;}var _proto14=Uc.prototype;_proto14.render=/*#__PURE__*/function(){var _render2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee43(e,i){var m;return _regenerator.default.wrap(function _callee43$(_context43){while(1)switch(_context43.prev=_context43.next){case 0:_zo.prototype.resizeCanvas.call(this,e);_context43.next=3;return createImageBitmap(i);case 3:m=_context43.sent;return _context43.abrupt("return",(this.renderSilhouette(e,m),this.context.save(),this.context.filter=`blur(${this.radius}px)`,this.context.globalCompositeOperation="destination-over",this.context.drawImage(e,0,0,e.width,e.height),this.context.restore(),_zo.prototype.render.call(this,e,i)));case 5:case"end":return _context43.stop();}},_callee43,this);}));function render(_x67,_x68){return _render2.apply(this,arguments);}return render;}();return Uc;}(zo);let Ec=/*#__PURE__*/function(_zo2){(0,_inheritsLoose2.default)(Ec,_zo2);function Ec(e){var _this12;_this12=_zo2.call(this)||this,_this12.radius=e;return _this12;}var _proto15=Ec.prototype;_proto15.render=/*#__PURE__*/function(){var _render3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee44(e,i){var m;return _regenerator.default.wrap(function _callee44$(_context44){while(1)switch(_context44.prev=_context44.next){case 0:_zo2.prototype.resizeCanvas.call(this,e);_context44.next=3;return createImageBitmap(i);case 3:m=_context44.sent;return _context44.abrupt("return",(this.renderSilhouette(e,m,`blur(${this.radius}px)`),this.context.save(),this.context.filter="none",this.context.globalCompositeOperation="destination-over",this.context.drawImage(e,0,0,e.width,e.height),this.context.restore(),_zo2.prototype.render.call(this,e,i)));case 5:case"end":return _context44.stop();}},_callee44,this);}));function render(_x69,_x70){return _render3.apply(this,arguments);}return render;}();return Ec;}(zo);let Mc=/*#__PURE__*/function(_zo3){(0,_inheritsLoose2.default)(Mc,_zo3);function Mc(){return _zo3.apply(this,arguments)||this;}var _proto16=Mc.prototype;_proto16.setBackgroundImage=function setBackgroundImage(e){this.backgroundImage=e;};_proto16.render=/*#__PURE__*/function(){var _render4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee45(e,i){var m;return _regenerator.default.wrap(function _callee45$(_context45){while(1)switch(_context45.prev=_context45.next){case 0:_zo3.prototype.resizeCanvas.call(this,e);_context45.next=3;return createImageBitmap(i);case 3:m=_context45.sent;return _context45.abrupt("return",(this.renderSilhouette(e,m),this.backgroundImage&&(this.context.save(),this.context.filter="none",this.context.globalCompositeOperation="destination-over",this.context.drawImage(this.backgroundImage,0,0,this.backgroundImage.width,this.backgroundImage.height,0,0,e.width,e.height),this.context.restore()),_zo3.prototype.render.call(this,e,i)));case 5:case"end":return _context45.stop();}},_callee45,this);}));function render(_x71,_x72){return _render4.apply(this,arguments);}return render;}();return Mc;}(zo);/* @license twgl.js 5.5.1 Copyright (c) 2015, Gregg Tavares All Rights Reserved.
Available via the MIT license.
see: http://github.com/greggman/twgl.js for details */const Ao=5120,_r=5121,Bo=5122,jo=5123,Ko=5124,Oo=5125,Po=5126,zc=32819,Ac=32820,Bc=33635,jc=5131,Kc=33640,Oc=35899,Pc=35902,_c=36269,Qc=34042,tl={};{const r=tl;r[Ao]=Int8Array,r[_r]=Uint8Array,r[Bo]=Int16Array,r[jo]=Uint16Array,r[Ko]=Int32Array,r[Oo]=Uint32Array,r[Po]=Float32Array,r[zc]=Uint16Array,r[Ac]=Uint16Array,r[Bc]=Uint16Array,r[jc]=Uint16Array,r[Kc]=Uint32Array,r[Oc]=Uint32Array,r[Pc]=Uint32Array,r[_c]=Uint32Array,r[Qc]=Uint32Array;}function _o(r){if(r instanceof Int8Array)return Ao;if(r instanceof Uint8Array||r instanceof Uint8ClampedArray)return _r;if(r instanceof Int16Array)return Bo;if(r instanceof Uint16Array)return jo;if(r instanceof Int32Array)return Ko;if(r instanceof Uint32Array)return Oo;if(r instanceof Float32Array)return Po;throw new Error("unsupported typed array type");}function el(r){if(r===Int8Array)return Ao;if(r===Uint8Array||r===Uint8ClampedArray)return _r;if(r===Int16Array)return Bo;if(r===Uint16Array)return jo;if(r===Int32Array)return Ko;if(r===Uint32Array)return Oo;if(r===Float32Array)return Po;throw new Error("unsupported typed array type");}function nl(r){const e=tl[r];if(!e)throw new Error("unknown gl type");return e;}const zi=typeof SharedArrayBuffer<"u"?function(e){return e&&e.buffer&&(e.buffer instanceof ArrayBuffer||e.buffer instanceof SharedArrayBuffer);}:function(e){return e&&e.buffer&&e.buffer instanceof ArrayBuffer;};function rl(){console.error(...arguments);}const Hs=/* @__PURE__ */new Map();function _i(r,e){if(!r||typeof r!="object")return!1;let i=Hs.get(e);i||(i=/* @__PURE__ */new WeakMap(),Hs.set(e,i));let m=i.get(r);if(m===void 0){const v=Object.prototype.toString.call(r);m=v.substring(8,v.length-1)===e,i.set(r,m);}return m;}function Dc(r,e){return typeof WebGLBuffer<"u"&&_i(e,"WebGLBuffer");}function $c(r,e){return typeof WebGLRenderbuffer<"u"&&_i(e,"WebGLRenderbuffer");}function Qo(r,e){return typeof WebGLTexture<"u"&&_i(e,"WebGLTexture");}function qc(r,e){return typeof WebGLSampler<"u"&&_i(e,"WebGLSampler");}const il=35044,Wr=34962,t1=34963,e1=34660,n1=5120,r1=5121,i1=5122,o1=5123,s1=5124,l1=5125,ol=5126,sl={attribPrefix:""};function c1(r,e,i,m,v){r.bindBuffer(e,i),r.bufferData(e,m,v||il);}function ll(r,e,i,m){if(Dc(r,e))return e;i=i||Wr;const v=r.createBuffer();return c1(r,i,v,e,m),v;}function cl(r){return r==="indices";}function u1(r){return r===Int8Array||r===Uint8Array;}function a1(r){return r.length?r:r.data;}const d1=/coord|texture/i,h1=/color|colour/i;function f1(r,e){let i;if(d1.test(r)?i=2:h1.test(r)?i=4:i=3,e%i>0)throw new Error(`Can not guess numComponents for attribute '${r}'. Tried ${i} but ${e} values is not evenly divisible by ${i}. You should specify it.`);return i;}function m1(r,e,i){return r.numComponents||r.size||f1(e,i||a1(r).length);}function ul(r,e){if(zi(r))return r;if(zi(r.data))return r.data;Array.isArray(r)&&(r={data:r});let i=r.type?Do(r.type):void 0;return i||(cl(e)?i=Uint16Array:i=Float32Array),new i(r.data);}function p1(r){return typeof r=="number"?r:r?el(r):ol;}function Do(r){return typeof r=="number"?nl(r):r||Float32Array;}function b1(r,e){return{buffer:e.buffer,numValues:2*3*4,// safely divided by 2, 3, 4
type:p1(e.type),arrayType:Do(e.type)};}function y1(r,e){const i=e.data||e,m=Do(e.type),v=i*m.BYTES_PER_ELEMENT,S=r.createBuffer();return r.bindBuffer(Wr,S),r.bufferData(Wr,v,e.drawType||il),{buffer:S,numValues:i,type:el(m),arrayType:m};}function g1(r,e,i){const m=ul(e,i);return{arrayType:m.constructor,buffer:ll(r,m,void 0,e.drawType),type:_o(m),numValues:0};}function Z1(r,e){const i={};return Object.keys(e).forEach(function(m){if(!cl(m)){const v=e[m],S=v.attrib||v.name||v.attribName||sl.attribPrefix+m;if(v.value){if(!Array.isArray(v.value)&&!zi(v.value))throw new Error("array.value is not array or typedarray");i[S]={value:v.value};}else{let L;v.buffer&&v.buffer instanceof WebGLBuffer?L=b1:typeof v=="number"||typeof v.data=="number"?L=y1:L=g1;const _L4=L(r,v,m),T=_L4.buffer,k=_L4.type,tt=_L4.numValues,st=_L4.arrayType,bt=v.normalize!==void 0?v.normalize:u1(st),xt=m1(v,m,tt);i[S]={buffer:T,numComponents:xt,type:k,normalize:bt,stride:v.stride||0,offset:v.offset||0,divisor:v.divisor===void 0?void 0:v.divisor,drawType:v.drawType};}}}),r.bindBuffer(Wr,null),i;}function v1(r,e){return e===n1||e===r1?1:e===i1||e===o1?2:e===s1||e===l1||e===ol?4:0;}const fo=["position","positions","a_position"];function G1(r,e){let i,m;for(m=0;m<fo.length&&(i=fo[m],!(i in e||(i=sl.attribPrefix+i,i in e)));++m);m===fo.length&&(i=Object.keys(e)[0]);const v=e[i];if(!v.buffer)return 1;r.bindBuffer(Wr,v.buffer);const S=r.getBufferParameter(Wr,e1);r.bindBuffer(Wr,null);const L=v1(r,v.type),T=S/L,k=v.numComponents||v.size,tt=T/k;if(tt%1!==0)throw new Error(`numComponents ${k} not correct for length ${length}`);return tt;}function X1(r,e,i){const m=Z1(r,e),v=Object.assign({},i||{});v.attribs=Object.assign({},i?i.attribs:{},m);const S=e.indices;if(S){const L=ul(S,"indices");v.indices=ll(r,L,t1),v.numElements=L.length,v.elementType=_o(L);}else v.numElements||(v.numElements=G1(r,v.attribs));return v;}function ei(r){return!!r.texStorage2D;}const al=/* @__PURE__ */function(){const r={},e={};function i(m){const v=m.constructor.name;if(!r[v]){for(const S in m)if(typeof m[S]=="number"){const L=e[m[S]];e[m[S]]=L?`${L} | ${S}`:S;}r[v]=!0;}}return function(v,S){return i(v),e[S]||(typeof S=="number"?`0x${S.toString(16)}`:S);};}(),dr={textureColor:new Uint8Array([128,192,255,255]),textureOptions:{},crossOrigin:void 0},Qr=zi,dl=/* @__PURE__ */function(){let r;return function(){return r=r||(typeof document<"u"&&document.createElement?document.createElement("canvas").getContext("2d"):null),r;};}(),Go=6406,_n=6407,en=6408,Xo=6409,Wo=6410,Nr=6402,Vo=34041,Ai=33071,W1=9728,V1=9729,hr=3553,ar=34067,Rr=32879,xr=35866,$o=34069,R1=34070,x1=34071,I1=34072,S1=34073,T1=34074,Ro=10241,xo=10240,Bi=10242,ji=10243,Cs=32882,Y1=33082,w1=33083,F1=33084,L1=33085,H1=34892,C1=34893,qo=3317,hl=3314,fl=32878,ml=3316,pl=3315,bl=32877,N1=37443,J1=37441,k1=37440,U1=33321,E1=36756,M1=33325,z1=33326,A1=33330,B1=33329,j1=33338,K1=33337,O1=33340,P1=33339,_1=33323,Q1=36757,D1=33327,$1=33328,q1=33336,tu=33335,eu=33332,nu=33331,ru=33334,iu=33333,ou=32849,su=35905,lu=36194,cu=36758,uu=35898,au=35901,du=34843,hu=34837,fu=36221,mu=36239,pu=36215,bu=36233,yu=36209,gu=36227,Zu=32856,vu=35907,Gu=36759,Xu=32855,Wu=32854,Vu=32857,Ru=34842,xu=34836,Iu=36220,Su=36238,Tu=36975,Yu=36214,wu=36232,Fu=36226,Lu=36208,Hu=33189,Cu=33190,Nu=36012,Ju=36013,ku=35056,sr=5120,cn=5121,hi=5122,Lr=5123,fi=5124,pr=5125,Un=5126,Ns=32819,Js=32820,ks=33635,Qn=5131,Mr=36193,mo=33640,Uu=35899,Eu=35902,Mu=36269,zu=34042,zr=33319,gr=33320,Ar=6403,Zr=36244,vr=36248,lr=36249,Au={};{const r=Au;r[Go]={numColorComponents:1},r[Xo]={numColorComponents:1},r[Wo]={numColorComponents:2},r[_n]={numColorComponents:3},r[en]={numColorComponents:4},r[Ar]={numColorComponents:1},r[Zr]={numColorComponents:1},r[zr]={numColorComponents:2},r[gr]={numColorComponents:2},r[_n]={numColorComponents:3},r[vr]={numColorComponents:3},r[en]={numColorComponents:4},r[lr]={numColorComponents:4},r[Nr]={numColorComponents:1},r[Vo]={numColorComponents:2};}let po;function Qi(r){if(!po){const e={};e[Go]={textureFormat:Go,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[1,2,2,4],type:[cn,Qn,Mr,Un]},e[Xo]={textureFormat:Xo,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[1,2,2,4],type:[cn,Qn,Mr,Un]},e[Wo]={textureFormat:Wo,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[2,4,4,8],type:[cn,Qn,Mr,Un]},e[_n]={textureFormat:_n,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[3,6,6,12,2],type:[cn,Qn,Mr,Un,ks]},e[en]={textureFormat:en,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[4,8,8,16,2,2],type:[cn,Qn,Mr,Un,Ns,Js]},e[Nr]={textureFormat:Nr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[2,4],type:[pr,Lr]},e[U1]={textureFormat:Ar,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[1],type:[cn]},e[E1]={textureFormat:Ar,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[1],type:[sr]},e[M1]={textureFormat:Ar,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[4,2],type:[Un,Qn]},e[z1]={textureFormat:Ar,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[4],type:[Un]},e[A1]={textureFormat:Zr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[1],type:[cn]},e[B1]={textureFormat:Zr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[1],type:[sr]},e[eu]={textureFormat:Zr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[2],type:[Lr]},e[nu]={textureFormat:Zr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[2],type:[hi]},e[ru]={textureFormat:Zr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[pr]},e[iu]={textureFormat:Zr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[fi]},e[_1]={textureFormat:zr,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[2],type:[cn]},e[Q1]={textureFormat:zr,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[2],type:[sr]},e[D1]={textureFormat:zr,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[8,4],type:[Un,Qn]},e[$1]={textureFormat:zr,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[8],type:[Un]},e[q1]={textureFormat:gr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[2],type:[cn]},e[tu]={textureFormat:gr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[2],type:[sr]},e[j1]={textureFormat:gr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[Lr]},e[K1]={textureFormat:gr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[hi]},e[O1]={textureFormat:gr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[8],type:[pr]},e[P1]={textureFormat:gr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[8],type:[fi]},e[ou]={textureFormat:_n,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[3],type:[cn]},e[su]={textureFormat:_n,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[3],type:[cn]},e[lu]={textureFormat:_n,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[3,2],type:[cn,ks]},e[cu]={textureFormat:_n,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[3],type:[sr]},e[uu]={textureFormat:_n,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[12,6,4],type:[Un,Qn,Uu]},e[au]={textureFormat:_n,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[12,6,4],type:[Un,Qn,Eu]},e[du]={textureFormat:_n,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[12,6],type:[Un,Qn]},e[hu]={textureFormat:_n,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[12],type:[Un]},e[fu]={textureFormat:vr,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[3],type:[cn]},e[mu]={textureFormat:vr,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[3],type:[sr]},e[pu]={textureFormat:vr,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[6],type:[Lr]},e[bu]={textureFormat:vr,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[6],type:[hi]},e[yu]={textureFormat:vr,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[12],type:[pr]},e[gu]={textureFormat:vr,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[12],type:[fi]},e[Zu]={textureFormat:en,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[4],type:[cn]},e[vu]={textureFormat:en,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[4],type:[cn]},e[Gu]={textureFormat:en,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[4],type:[sr]},e[Xu]={textureFormat:en,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[4,2,4],type:[cn,Js,mo]},e[Wu]={textureFormat:en,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[4,2],type:[cn,Ns]},e[Vu]={textureFormat:en,colorRenderable:!0,textureFilterable:!0,bytesPerElement:[4],type:[mo]},e[Ru]={textureFormat:en,colorRenderable:!1,textureFilterable:!0,bytesPerElement:[16,8],type:[Un,Qn]},e[xu]={textureFormat:en,colorRenderable:!1,textureFilterable:!1,bytesPerElement:[16],type:[Un]},e[Iu]={textureFormat:lr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[cn]},e[Su]={textureFormat:lr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[sr]},e[Tu]={textureFormat:lr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[mo]},e[Yu]={textureFormat:lr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[8],type:[Lr]},e[wu]={textureFormat:lr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[8],type:[hi]},e[Fu]={textureFormat:lr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[16],type:[fi]},e[Lu]={textureFormat:lr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[16],type:[pr]},e[Hu]={textureFormat:Nr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[2,4],type:[Lr,pr]},e[Cu]={textureFormat:Nr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[pr]},e[Nu]={textureFormat:Nr,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[Un]},e[ku]={textureFormat:Vo,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[zu]},e[Ju]={textureFormat:Vo,colorRenderable:!0,textureFilterable:!1,bytesPerElement:[4],type:[Mu]},Object.keys(e).forEach(function(i){const m=e[i];m.bytesPerElementMap={},m.bytesPerElement.forEach(function(v,S){const L=m.type[S];m.bytesPerElementMap[L]=v;});}),po=e;}return po[r];}function Bu(r,e){const i=Qi(r);if(!i)throw"unknown internal format";const m=i.bytesPerElementMap[e];if(m===void 0)throw"unknown internal format";return m;}function ni(r){const e=Qi(r);if(!e)throw"unknown internal format";return{format:e.textureFormat,type:e.type[0]};}function Us(r){return(r&r-1)===0;}function ju(r,e,i,m){if(!ei(r))return Us(e)&&Us(i);const v=Qi(m);if(!v)throw"unknown internal format";return v.colorRenderable&&v.textureFilterable;}function Ku(r){const e=Qi(r);if(!e)throw"unknown internal format";return e.textureFilterable;}function Ou(r,e,i){return Qr(e)?_o(e):i||cn;}function mi(r,e,i,m,v){if(v%1!==0)throw"can't guess dimensions";if(!i&&!m){const S=Math.sqrt(v/(e===ar?6:1));S%1===0?(i=S,m=S):(i=v,m=1);}else if(m){if(!i&&(i=v/m,i%1))throw"can't guess dimensions";}else if(m=v/i,m%1)throw"can't guess dimensions";return{width:i,height:m};}function Er(r,e){e.colorspaceConversion!==void 0&&r.pixelStorei(N1,e.colorspaceConversion),e.premultiplyAlpha!==void 0&&r.pixelStorei(J1,e.premultiplyAlpha),e.flipY!==void 0&&r.pixelStorei(k1,e.flipY);}function yl(r){r.pixelStorei(qo,4),ei(r)&&(r.pixelStorei(hl,0),r.pixelStorei(fl,0),r.pixelStorei(ml,0),r.pixelStorei(pl,0),r.pixelStorei(bl,0));}function Pu(r,e,i,m){m.minMag&&(i.call(r,e,Ro,m.minMag),i.call(r,e,xo,m.minMag)),m.min&&i.call(r,e,Ro,m.min),m.mag&&i.call(r,e,xo,m.mag),m.wrap&&(i.call(r,e,Bi,m.wrap),i.call(r,e,ji,m.wrap),(e===Rr||qc(r,e))&&i.call(r,e,Cs,m.wrap)),m.wrapR&&i.call(r,e,Cs,m.wrapR),m.wrapS&&i.call(r,e,Bi,m.wrapS),m.wrapT&&i.call(r,e,ji,m.wrapT),m.minLod!==void 0&&i.call(r,e,Y1,m.minLod),m.maxLod!==void 0&&i.call(r,e,w1,m.maxLod),m.baseLevel!==void 0&&i.call(r,e,F1,m.baseLevel),m.maxLevel!==void 0&&i.call(r,e,L1,m.maxLevel),m.compareFunc!==void 0&&i.call(r,e,C1,m.compareFunc),m.compareMode!==void 0&&i.call(r,e,H1,m.compareMode);}function gl(r,e,i){const m=i.target||hr;r.bindTexture(m,e),Pu(r,m,r.texParameteri,i);}function _u(r){return r=r||dr.textureColor,Qr(r)?r:new Uint8Array([r[0]*255,r[1]*255,r[2]*255,r[3]*255]);}function Io(r,e,i,m,v,S){i=i||dr.textureOptions,S=S||en;const L=i.target||hr;if(m=m||i.width,v=v||i.height,r.bindTexture(L,e),ju(r,m,v,S))r.generateMipmap(L);else{const T=Ku(S)?V1:W1;r.texParameteri(L,Ro,T),r.texParameteri(L,xo,T),r.texParameteri(L,Bi,Ai),r.texParameteri(L,ji,Ai);}}function Dr(r){return r.auto===!0||r.auto===void 0&&r.level===void 0;}function So(r,e){return e=e||{},e.cubeFaceOrder||[$o,R1,x1,I1,S1,T1];}function To(r,e){const m=So(r,e).map(function(v,S){return{face:v,ndx:S};});return m.sort(function(v,S){return v.face-S.face;}),m;}function Zl(r,e,i,m){m=m||dr.textureOptions;const v=m.target||hr,S=m.level||0;let L=i.width,T=i.height;const k=m.internalFormat||m.format||en,tt=ni(k),st=m.format||tt.format,bt=m.type||tt.type;if(Er(r,m),r.bindTexture(v,e),v===ar){const xt=i.width,Yt=i.height;let at,ht;if(xt/6===Yt)at=Yt,ht=[0,0,1,0,2,0,3,0,4,0,5,0];else if(Yt/6===xt)at=xt,ht=[0,0,0,1,0,2,0,3,0,4,0,5];else if(xt/3===Yt/2)at=xt/3,ht=[0,0,1,0,2,0,0,1,1,1,2,1];else if(xt/2===Yt/3)at=xt/2,ht=[0,0,1,0,0,1,1,1,0,2,1,2];else throw"can't figure out cube map from element: "+(i.src?i.src:i.nodeName);const Ut=dl();Ut?(Ut.canvas.width=at,Ut.canvas.height=at,L=at,T=at,To(r,m).forEach(function(Mt){const oe=ht[Mt.ndx*2+0]*at,D=ht[Mt.ndx*2+1]*at;Ut.drawImage(i,oe,D,at,at,0,0,at,at),r.texImage2D(Mt.face,S,k,st,bt,Ut.canvas);}),Ut.canvas.width=1,Ut.canvas.height=1):typeof createImageBitmap<"u"&&(L=at,T=at,To(r,m).forEach(function(Mt){const oe=ht[Mt.ndx*2+0]*at,D=ht[Mt.ndx*2+1]*at;r.texImage2D(Mt.face,S,k,at,at,0,st,bt,null),createImageBitmap(i,oe,D,at,at,{premultiplyAlpha:"none",colorSpaceConversion:"none"}).then(function(hn){Er(r,m),r.bindTexture(v,e),r.texImage2D(Mt.face,S,k,st,bt,hn),Dr(m)&&Io(r,e,m,L,T,k);});}));}else if(v===Rr||v===xr){const xt=Math.min(i.width,i.height),Yt=Math.max(i.width,i.height),at=Yt/xt;if(at%1!==0)throw"can not compute 3D dimensions of element";const ht=i.width===Yt?1:0,Ut=i.height===Yt?1:0;r.pixelStorei(qo,1),r.pixelStorei(hl,i.width),r.pixelStorei(fl,0),r.pixelStorei(bl,0),r.texImage3D(v,S,k,xt,xt,xt,0,st,bt,null);for(let Mt=0;Mt<at;++Mt){const oe=Mt*xt*ht,D=Mt*xt*Ut;r.pixelStorei(ml,oe),r.pixelStorei(pl,D),r.texSubImage3D(v,S,0,0,Mt,xt,xt,1,st,bt,i);}yl(r);}else r.texImage2D(v,S,k,st,bt,i);Dr(m)&&Io(r,e,m,L,T,k),gl(r,e,m);}function ri(){}function Qu(r){if(typeof document<"u"){const e=document.createElement("a");return e.href=r,e.hostname===location.hostname&&e.port===location.port&&e.protocol===location.protocol;}else{const e=new URL(location.href).origin;return new URL(r,location.href).origin===e;}}function Du(r,e){return e===void 0&&!Qu(r)?"anonymous":e;}function $u(r,e,i){i=i||ri;let m;if(e=e!==void 0?e:dr.crossOrigin,e=Du(r,e),typeof Image<"u"){m=new Image(),e!==void 0&&(m.crossOrigin=e);const v=function v(){m.removeEventListener("error",S),m.removeEventListener("load",L),m=null;},S=function S(){const k="couldn't load image: "+r;rl(k),i(k,m),v();},L=function L(){i(null,m),v();};return m.addEventListener("error",S),m.addEventListener("load",L),m.src=r,m;}else if(typeof ImageBitmap<"u"){let v,S;const L=function L(){i(v,S);},T={};e&&(T.mode="cors"),fetch(r,T).then(function(k){if(!k.ok)throw k;return k.blob();}).then(function(k){return createImageBitmap(k,{premultiplyAlpha:"none",colorSpaceConversion:"none"});}).then(function(k){S=k,setTimeout(L);}).catch(function(k){v=k,setTimeout(L);}),m=null;}return m;}function vl(r){return typeof ImageBitmap<"u"&&r instanceof ImageBitmap||typeof ImageData<"u"&&r instanceof ImageData||typeof HTMLElement<"u"&&r instanceof HTMLElement;}function ts(r,e,i){return vl(r)?(setTimeout(function(){i(null,r);}),r):$u(r,e,i);}function es(r,e,i){i=i||dr.textureOptions;const m=i.target||hr;if(r.bindTexture(m,e),i.color===!1)return;const v=_u(i.color);if(m===ar)for(let S=0;S<6;++S)r.texImage2D($o+S,0,en,1,1,0,en,cn,v);else m===Rr||m===xr?r.texImage3D(m,0,en,1,1,1,0,en,cn,v):r.texImage2D(m,0,en,1,1,0,en,cn,v);}function qu(r,e,i,m){return m=m||ri,i=i||dr.textureOptions,es(r,e,i),i=Object.assign({},i),ts(i.src,i.crossOrigin,function(S,L){S?m(S,e,L):(Zl(r,e,L,i),m(null,e,L));});}function ta(r,e,i,m){m=m||ri;const v=i.src;if(v.length!==6)throw"there must be 6 urls for a cubemap";const S=i.level||0,L=i.internalFormat||i.format||en,T=ni(L),k=i.format||T.format,tt=i.type||cn,st=i.target||hr;if(st!==ar)throw"target must be TEXTURE_CUBE_MAP";es(r,e,i),i=Object.assign({},i);let bt=6;const xt=[],Yt=So(r,i);let at;function ht(Ut){return function(Mt,oe){--bt,Mt?xt.push(Mt):oe.width!==oe.height?xt.push("cubemap face img is not a square: "+oe.src):(Er(r,i),r.bindTexture(st,e),bt===5?So().forEach(function(D){r.texImage2D(D,S,L,k,tt,oe);}):r.texImage2D(Ut,S,L,k,tt,oe),Dr(i)&&r.generateMipmap(st)),bt===0&&m(xt.length?xt:void 0,e,at);};}at=v.map(function(Ut,Mt){return ts(Ut,i.crossOrigin,ht(Yt[Mt]));});}function ea(r,e,i,m){m=m||ri;const v=i.src,S=i.internalFormat||i.format||en,L=ni(S),T=i.format||L.format,k=i.type||cn,tt=i.target||xr;if(tt!==Rr&&tt!==xr)throw"target must be TEXTURE_3D or TEXTURE_2D_ARRAY";es(r,e,i),i=Object.assign({},i);let st=v.length;const bt=[];let xt;const Yt=i.level||0;let at=i.width,ht=i.height;const Ut=v.length;let Mt=!0;function oe(D){return function(hn,bn){if(--st,hn)bt.push(hn);else{if(Er(r,i),r.bindTexture(tt,e),Mt){Mt=!1,at=i.width||bn.width,ht=i.height||bn.height,r.texImage3D(tt,Yt,S,at,ht,Ut,0,T,k,null);for(let ge=0;ge<Ut;++ge)r.texSubImage3D(tt,Yt,0,0,ge,at,ht,1,T,k,bn);}else{let ge=bn,Kt;(bn.width!==at||bn.height!==ht)&&(Kt=dl(),ge=Kt.canvas,Kt.canvas.width=at,Kt.canvas.height=ht,Kt.drawImage(bn,0,0,at,ht)),r.texSubImage3D(tt,Yt,0,0,D,at,ht,1,T,k,ge),Kt&&ge===Kt.canvas&&(Kt.canvas.width=0,Kt.canvas.height=0);}Dr(i)&&r.generateMipmap(tt);}st===0&&m(bt.length?bt:void 0,e,xt);};}xt=v.map(function(D,hn){return ts(D,i.crossOrigin,oe(hn));});}function na(r,e,i,m){m=m||dr.textureOptions;const v=m.target||hr;r.bindTexture(v,e);let S=m.width,L=m.height,T=m.depth;const k=m.level||0,tt=m.internalFormat||m.format||en,st=ni(tt),bt=m.format||st.format,xt=m.type||Ou(r,i,st.type);if(Qr(i))i instanceof Uint8ClampedArray&&(i=new Uint8Array(i.buffer));else{const Ut=nl(xt);i=new Ut(i);}const Yt=Bu(tt,xt),at=i.byteLength/Yt;if(at%1)throw"length wrong size for format: "+al(r,bt);let ht;if(v===Rr||v===xr){if(!S&&!L&&!T){const Ut=Math.cbrt(at);if(Ut%1!==0)throw"can't guess cube size of array of numElements: "+at;S=Ut,L=Ut,T=Ut;}else S&&(!L||!T)?(ht=mi(r,v,L,T,at/S),L=ht.width,T=ht.height):L&&(!S||!T)?(ht=mi(r,v,S,T,at/L),S=ht.width,T=ht.height):(ht=mi(r,v,S,L,at/T),S=ht.width,L=ht.height);}else ht=mi(r,v,S,L,at),S=ht.width,L=ht.height;if(yl(r),r.pixelStorei(qo,m.unpackAlignment||1),Er(r,m),v===ar){const Ut=Yt/i.BYTES_PER_ELEMENT,Mt=at/6*Ut;To(r,m).forEach(oe=>{const D=Mt*oe.ndx,hn=i.subarray(D,D+Mt);r.texImage2D(oe.face,k,tt,S,L,0,bt,xt,hn);});}else v===Rr||v===xr?r.texImage3D(v,k,tt,S,L,T,0,bt,xt,i):r.texImage2D(v,k,tt,S,L,0,bt,xt,i);return{width:S,height:L,depth:T,type:xt};}function ra(r,e,i){const m=i.target||hr;r.bindTexture(m,e);const v=i.level||0,S=i.internalFormat||i.format||en,L=ni(S),T=i.format||L.format,k=i.type||L.type;if(Er(r,i),m===ar)for(let tt=0;tt<6;++tt)r.texImage2D($o+tt,v,S,i.width,i.height,0,T,k,null);else m===Rr||m===xr?r.texImage3D(m,v,S,i.width,i.height,i.depth,0,T,k,null):r.texImage2D(m,v,S,i.width,i.height,0,T,k,null);}function Gl(r,e,i){i=i||ri,e=e||dr.textureOptions;const m=r.createTexture(),v=e.target||hr;let S=e.width||1,L=e.height||1;const T=e.internalFormat||en;r.bindTexture(v,m),v===ar&&(r.texParameteri(v,Bi,Ai),r.texParameteri(v,ji,Ai));let k=e.src;if(k){if(typeof k=="function"&&(k=k(r,e)),typeof k=="string")qu(r,m,e,i);else if(Qr(k)||Array.isArray(k)&&(typeof k[0]=="number"||Array.isArray(k[0])||Qr(k[0]))){const tt=na(r,m,k,e);S=tt.width,L=tt.height;}else Array.isArray(k)&&(typeof k[0]=="string"||vl(k[0]))?v===ar?ta(r,m,e,i):ea(r,m,e,i):(Zl(r,m,k,e),S=k.width,L=k.height);}else ra(r,m,e);return Dr(e)&&Io(r,m,e,S,L,T),gl(r,m,e),m;}const ns=rl;function Xl(r){return typeof document<"u"&&document.getElementById?document.getElementById(r):null;}const Ki=33984,Di=34962,ia=34963,oa=35713,sa=35714,la=35632,ca=35633,ua=35981,Wl=35718,aa=35721,da=35971,ha=35382,fa=35396,ma=35398,pa=35392,ba=35395,$i=5126,Vl=35664,Rl=35665,xl=35666,rs=5124,Il=35667,Sl=35668,Tl=35669,Yl=35670,wl=35671,Fl=35672,Ll=35673,Hl=35674,Cl=35675,Nl=35676,ya=35678,ga=35680,Za=35679,va=35682,Ga=35685,Xa=35686,Wa=35687,Va=35688,Ra=35689,xa=35690,Ia=36289,Sa=36292,Ta=36293,is=5125,Jl=36294,kl=36295,Ul=36296,Ya=36298,wa=36299,Fa=36300,La=36303,Ha=36306,Ca=36307,Na=36308,Ja=36311,qi=3553,to=34067,os=32879,eo=35866,ce={};function El(r,e){return ce[e].bindPoint;}function ka(r,e){return function(i){r.uniform1f(e,i);};}function Ua(r,e){return function(i){r.uniform1fv(e,i);};}function Ea(r,e){return function(i){r.uniform2fv(e,i);};}function Ma(r,e){return function(i){r.uniform3fv(e,i);};}function za(r,e){return function(i){r.uniform4fv(e,i);};}function Ml(r,e){return function(i){r.uniform1i(e,i);};}function zl(r,e){return function(i){r.uniform1iv(e,i);};}function Al(r,e){return function(i){r.uniform2iv(e,i);};}function Bl(r,e){return function(i){r.uniform3iv(e,i);};}function jl(r,e){return function(i){r.uniform4iv(e,i);};}function Aa(r,e){return function(i){r.uniform1ui(e,i);};}function Ba(r,e){return function(i){r.uniform1uiv(e,i);};}function ja(r,e){return function(i){r.uniform2uiv(e,i);};}function Ka(r,e){return function(i){r.uniform3uiv(e,i);};}function Oa(r,e){return function(i){r.uniform4uiv(e,i);};}function Pa(r,e){return function(i){r.uniformMatrix2fv(e,!1,i);};}function _a(r,e){return function(i){r.uniformMatrix3fv(e,!1,i);};}function Qa(r,e){return function(i){r.uniformMatrix4fv(e,!1,i);};}function Da(r,e){return function(i){r.uniformMatrix2x3fv(e,!1,i);};}function $a(r,e){return function(i){r.uniformMatrix3x2fv(e,!1,i);};}function qa(r,e){return function(i){r.uniformMatrix2x4fv(e,!1,i);};}function t0(r,e){return function(i){r.uniformMatrix4x2fv(e,!1,i);};}function e0(r,e){return function(i){r.uniformMatrix3x4fv(e,!1,i);};}function n0(r,e){return function(i){r.uniformMatrix4x3fv(e,!1,i);};}function Mn(r,e,i,m){const v=El(r,e);return ei(r)?function(S){let L,T;!S||Qo(r,S)?(L=S,T=null):(L=S.texture,T=S.sampler),r.uniform1i(m,i),r.activeTexture(Ki+i),r.bindTexture(v,L),r.bindSampler(i,T);}:function(S){r.uniform1i(m,i),r.activeTexture(Ki+i),r.bindTexture(v,S);};}function zn(r,e,i,m,v){const S=El(r,e),L=new Int32Array(v);for(let T=0;T<v;++T)L[T]=i+T;return ei(r)?function(T){r.uniform1iv(m,L),T.forEach(function(k,tt){r.activeTexture(Ki+L[tt]);let st,bt;!k||Qo(r,k)?(st=k,bt=null):(st=k.texture,bt=k.sampler),r.bindSampler(i,bt),r.bindTexture(S,st);});}:function(T){r.uniform1iv(m,L),T.forEach(function(k,tt){r.activeTexture(Ki+L[tt]),r.bindTexture(S,k);});};}ce[$i]={Type:Float32Array,size:4,setter:ka,arraySetter:Ua};ce[Vl]={Type:Float32Array,size:8,setter:Ea,cols:2};ce[Rl]={Type:Float32Array,size:12,setter:Ma,cols:3};ce[xl]={Type:Float32Array,size:16,setter:za,cols:4};ce[rs]={Type:Int32Array,size:4,setter:Ml,arraySetter:zl};ce[Il]={Type:Int32Array,size:8,setter:Al,cols:2};ce[Sl]={Type:Int32Array,size:12,setter:Bl,cols:3};ce[Tl]={Type:Int32Array,size:16,setter:jl,cols:4};ce[is]={Type:Uint32Array,size:4,setter:Aa,arraySetter:Ba};ce[Jl]={Type:Uint32Array,size:8,setter:ja,cols:2};ce[kl]={Type:Uint32Array,size:12,setter:Ka,cols:3};ce[Ul]={Type:Uint32Array,size:16,setter:Oa,cols:4};ce[Yl]={Type:Uint32Array,size:4,setter:Ml,arraySetter:zl};ce[wl]={Type:Uint32Array,size:8,setter:Al,cols:2};ce[Fl]={Type:Uint32Array,size:12,setter:Bl,cols:3};ce[Ll]={Type:Uint32Array,size:16,setter:jl,cols:4};ce[Hl]={Type:Float32Array,size:32,setter:Pa,rows:2,cols:2};ce[Cl]={Type:Float32Array,size:48,setter:_a,rows:3,cols:3};ce[Nl]={Type:Float32Array,size:64,setter:Qa,rows:4,cols:4};ce[Ga]={Type:Float32Array,size:32,setter:Da,rows:2,cols:3};ce[Xa]={Type:Float32Array,size:32,setter:qa,rows:2,cols:4};ce[Wa]={Type:Float32Array,size:48,setter:$a,rows:3,cols:2};ce[Va]={Type:Float32Array,size:48,setter:e0,rows:3,cols:4};ce[Ra]={Type:Float32Array,size:64,setter:t0,rows:4,cols:2};ce[xa]={Type:Float32Array,size:64,setter:n0,rows:4,cols:3};ce[ya]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:qi};ce[ga]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:to};ce[Za]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:os};ce[va]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:qi};ce[Ia]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:eo};ce[Sa]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:eo};ce[Ta]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:to};ce[Ya]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:qi};ce[wa]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:os};ce[Fa]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:to};ce[La]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:eo};ce[Ha]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:qi};ce[Ca]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:os};ce[Na]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:to};ce[Ja]={Type:null,size:0,setter:Mn,arraySetter:zn,bindPoint:eo};function no(r,e){return function(i){if(i.value)switch(r.disableVertexAttribArray(e),i.value.length){case 4:r.vertexAttrib4fv(e,i.value);break;case 3:r.vertexAttrib3fv(e,i.value);break;case 2:r.vertexAttrib2fv(e,i.value);break;case 1:r.vertexAttrib1fv(e,i.value);break;default:throw new Error("the length of a float constant value must be between 1 and 4!");}else r.bindBuffer(Di,i.buffer),r.enableVertexAttribArray(e),r.vertexAttribPointer(e,i.numComponents||i.size,i.type||$i,i.normalize||!1,i.stride||0,i.offset||0),r.vertexAttribDivisor&&r.vertexAttribDivisor(e,i.divisor||0);};}function fr(r,e){return function(i){if(i.value){if(r.disableVertexAttribArray(e),i.value.length===4)r.vertexAttrib4iv(e,i.value);else throw new Error("The length of an integer constant value must be 4!");}else r.bindBuffer(Di,i.buffer),r.enableVertexAttribArray(e),r.vertexAttribIPointer(e,i.numComponents||i.size,i.type||rs,i.stride||0,i.offset||0),r.vertexAttribDivisor&&r.vertexAttribDivisor(e,i.divisor||0);};}function ro(r,e){return function(i){if(i.value){if(r.disableVertexAttribArray(e),i.value.length===4)r.vertexAttrib4uiv(e,i.value);else throw new Error("The length of an unsigned integer constant value must be 4!");}else r.bindBuffer(Di,i.buffer),r.enableVertexAttribArray(e),r.vertexAttribIPointer(e,i.numComponents||i.size,i.type||is,i.stride||0,i.offset||0),r.vertexAttribDivisor&&r.vertexAttribDivisor(e,i.divisor||0);};}function ss(r,e,i){const m=i.size,v=i.count;return function(S){r.bindBuffer(Di,S.buffer);const L=S.size||S.numComponents||m,T=L/v,k=S.type||$i,st=ce[k].size*L,bt=S.normalize||!1,xt=S.offset||0,Yt=st/v;for(let at=0;at<v;++at)r.enableVertexAttribArray(e+at),r.vertexAttribPointer(e+at,T,k,bt,st,xt+Yt*at),r.vertexAttribDivisor&&r.vertexAttribDivisor(e+at,S.divisor||0);};}const In={};In[$i]={size:4,setter:no};In[Vl]={size:8,setter:no};In[Rl]={size:12,setter:no};In[xl]={size:16,setter:no};In[rs]={size:4,setter:fr};In[Il]={size:8,setter:fr};In[Sl]={size:12,setter:fr};In[Tl]={size:16,setter:fr};In[is]={size:4,setter:ro};In[Jl]={size:8,setter:ro};In[kl]={size:12,setter:ro};In[Ul]={size:16,setter:ro};In[Yl]={size:4,setter:fr};In[wl]={size:8,setter:fr};In[Fl]={size:12,setter:fr};In[Ll]={size:16,setter:fr};In[Hl]={size:4,setter:ss,count:2};In[Cl]={size:9,setter:ss,count:3};In[Nl]={size:16,setter:ss,count:4};const r0=/ERROR:\s*\d+:(\d+)/gi;function i0(r,e,i){if(e===void 0){e="";}if(i===void 0){i=0;}const m=[...e.matchAll(r0)],v=new Map(m.map((S,L)=>{const T=parseInt(S[1]),k=m[L+1],tt=k?k.index:e.length,st=e.substring(S.index,tt);return[T-1,st];}));return r.split(`
`).map((S,L)=>{const T=v.get(L);return`${L+1+i}: ${S}${T?`

^^^ ${T}`:""}`;}).join(`
`);}const Es=/^[ \t]*\n/;function Kl(r){let e=0;return Es.test(r)&&(e=1,r=r.replace(Es,"")),{lineOffset:e,shaderSource:r};}function o0(r,e){return r.errorCallback(e),r.callback&&setTimeout(()=>{r.callback(`${e}
${r.errors.join(`
`)}`);}),null;}function s0(r,e,i,m){if(m=m||ns,!r.getShaderParameter(i,oa)){const S=r.getShaderInfoLog(i),_Kl=Kl(r.getShaderSource(i)),L=_Kl.lineOffset,T=_Kl.shaderSource,k=`${i0(T,S,L)}
Error compiling ${al(r,e)}: ${S}`;return m(k),k;}return"";}function ls(r,e,i){let m,v,S;if(typeof e=="function"&&(i=e,e=void 0),typeof r=="function")i=r,r=void 0;else if(r&&!Array.isArray(r)){const tt=r;i=tt.errorCallback,r=tt.attribLocations,m=tt.transformFeedbackVaryings,v=tt.transformFeedbackMode,S=tt.callback;}const L=i||ns,T=[],k={errorCallback(tt){for(var _len=arguments.length,st=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){st[_key-1]=arguments[_key];}T.push(tt),L(tt,...st);},transformFeedbackVaryings:m,transformFeedbackMode:v,callback:S,errors:T};{let tt={};Array.isArray(r)?r.forEach(function(st,bt){tt[st]=e?e[bt]:bt;}):tt=r||{},k.attribLocations=tt;}return k;}const l0=["VERTEX_SHADER","FRAGMENT_SHADER"];function c0(r,e){if(e.indexOf("frag")>=0)return la;if(e.indexOf("vert")>=0)return ca;}function u0(r,e,i){const m=r.getAttachedShaders(e);for(var _iterator64=_createForOfIteratorHelperLoose(m),_step64;!(_step64=_iterator64()).done;){const v=_step64.value;i.has(v)&&r.deleteShader(v);}r.deleteProgram(e);}const a0=function a0(r){if(r===void 0){r=0;}return new Promise(e=>setTimeout(e,r));};function d0(r,e,i){const m=r.createProgram(),_ls=ls(i),v=_ls.attribLocations,S=_ls.transformFeedbackVaryings,L=_ls.transformFeedbackMode;for(let T=0;T<e.length;++T){let k=e[T];if(typeof k=="string"){const tt=Xl(k),st=tt?tt.text:k;let bt=r[l0[T]];tt&&tt.type&&(bt=c0(r,tt.type)||bt),k=r.createShader(bt),r.shaderSource(k,Kl(st).shaderSource),r.compileShader(k),r.attachShader(m,k);}}Object.entries(v).forEach(_ref27=>{let T=_ref27[0],k=_ref27[1];return r.bindAttribLocation(m,k,T);});{let T=S;T&&(T.attribs&&(T=T.attribs),Array.isArray(T)||(T=Object.keys(T)),r.transformFeedbackVaryings(m,T,L||ua));}return r.linkProgram(m),m;}function h0(r,e,i,m,v){const S=ls(i,m,v),L=new Set(e),T=d0(r,e,S);function k(tt,st){const bt=m0(tt,st,S.errorCallback);return bt&&u0(tt,st,L),bt;}if(S.callback){f0(r,T).then(()=>{const tt=k(r,T);S.callback(tt,tt?void 0:T);});return;}return k(r,T)?void 0:T;}function f0(_x73,_x74){return _f.apply(this,arguments);}function _f(){_f=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee111(r,e){var i,m,v;return _regenerator.default.wrap(function _callee111$(_context111){while(1)switch(_context111.prev=_context111.next){case 0:i=r.getExtension("KHR_parallel_shader_compile"),m=i?(S,L)=>S.getProgramParameter(L,i.COMPLETION_STATUS_KHR):()=>!0;v=0;case 2:_context111.next=4;return a0(v);case 4:v=1e3/60;case 5:if(!m(r,e)){_context111.next=2;break;}case 6:case"end":return _context111.stop();}},_callee111);}));return _f.apply(this,arguments);}function m0(r,e,i){if(i=i||ns,!r.getProgramParameter(e,sa)){const v=r.getProgramInfoLog(e);i(`Error in program linking: ${v}`);const L=r.getAttachedShaders(e).map(T=>s0(r,r.getShaderParameter(T,r.SHADER_TYPE),T,i));return`${v}
${L.filter(T=>T).join(`
`)}`;}}function p0(r,e,i,m,v){return h0(r,e,i,m,v);}function Ol(r){const e=r.name;return e.startsWith("gl_")||e.startsWith("webgl_");}const b0=/(\.|\[|]|\w+)/g,y0=r=>r>="0"&&r<="9";function g0(r,e,i,m){const v=r.split(b0).filter(T=>T!=="");let S=0,L="";for(;;){const T=v[S++];L+=T;const k=y0(T[0]),tt=k?parseInt(T):T;if(k&&(L+=v[S++]),S===v.length){i[tt]=e;break;}else{const bt=v[S++],xt=bt==="[",Yt=i[tt]||(xt?[]:{});i[tt]=Yt,i=Yt,m[L]=m[L]||/* @__PURE__ */function(at){return function(ht){Pl(at,ht);};}(Yt),L+=bt;}}}function Z0(r,e){let i=0;function m(T,k,tt){const st=k.name.endsWith("[0]"),bt=k.type,xt=ce[bt];if(!xt)throw new Error(`unknown type: 0x${bt.toString(16)}`);let Yt;if(xt.bindPoint){const at=i;i+=k.size,st?Yt=xt.arraySetter(r,bt,at,tt,k.size):Yt=xt.setter(r,bt,at,tt,k.size);}else xt.arraySetter&&st?Yt=xt.arraySetter(r,tt):Yt=xt.setter(r,tt);return Yt.location=tt,Yt;}const v={},S={},L=r.getProgramParameter(e,Wl);for(let T=0;T<L;++T){const k=r.getActiveUniform(e,T);if(Ol(k))continue;let tt=k.name;tt.endsWith("[0]")&&(tt=tt.substr(0,tt.length-3));const st=r.getUniformLocation(e,k.name);if(st){const bt=m(e,k,st);v[tt]=bt,g0(tt,bt,S,v);}}return v;}function v0(r,e){const i={},m=r.getProgramParameter(e,da);for(let v=0;v<m;++v){const S=r.getTransformFeedbackVarying(e,v);i[S.name]={index:v,type:S.type,size:S.size};}return i;}function G0(r,e){const i=r.getProgramParameter(e,Wl),m=[],v=[];for(let T=0;T<i;++T){v.push(T),m.push({});const k=r.getActiveUniform(e,T);m[T].name=k.name;}[["UNIFORM_TYPE","type"],["UNIFORM_SIZE","size"],// num elements
["UNIFORM_BLOCK_INDEX","blockNdx"],["UNIFORM_OFFSET","offset"]].forEach(function(T){const k=T[0],tt=T[1];r.getActiveUniforms(e,v,r[k]).forEach(function(st,bt){m[bt][tt]=st;});});const S={},L=r.getProgramParameter(e,ha);for(let T=0;T<L;++T){const k=r.getActiveUniformBlockName(e,T),tt={index:r.getUniformBlockIndex(e,k),usedByVertexShader:r.getActiveUniformBlockParameter(e,T,fa),usedByFragmentShader:r.getActiveUniformBlockParameter(e,T,ma),size:r.getActiveUniformBlockParameter(e,T,pa),uniformIndices:r.getActiveUniformBlockParameter(e,T,ba)};tt.used=tt.usedByVertexShader||tt.usedByFragmentShader,S[k]=tt;}return{blockSpecs:S,uniformData:m};}function Pl(r,e){for(const i in e){const m=r[i];typeof m=="function"?m(e[i]):Pl(r[i],e[i]);}}function _l(r){const i=r.uniformSetters||r,m=arguments.length<=1?0:arguments.length-1;for(let v=0;v<m;++v){const S=v+1<1||arguments.length<=v+1?undefined:arguments[v+1];if(Array.isArray(S)){const L=S.length;for(let T=0;T<L;++T)_l(i,S[T]);}else for(const L in S){const T=i[L];T&&T(S[L]);}}}function X0(r,e){const i={},m=r.getProgramParameter(e,aa);for(let v=0;v<m;++v){const S=r.getActiveAttrib(e,v);if(Ol(S))continue;const L=r.getAttribLocation(e,S.name),T=In[S.type],k=T.setter(r,L,T);k.location=L,i[S.name]=k;}return i;}function W0(r,e){for(const i in e){const m=r[i];m&&m(e[i]);}}function V0(r,e,i){i.vertexArrayObject?r.bindVertexArray(i.vertexArrayObject):(W0(e.attribSetters||e,i.attribs),i.indices&&r.bindBuffer(ia,i.indices));}function Ms(r,e){const i=Z0(r,e),m=X0(r,e),v={program:e,uniformSetters:i,attribSetters:m};return ei(r)&&(v.uniformBlockSpec=G0(r,e),v.transformFeedbackInfo=v0(r,e)),v;}const R0=/\s|{|}|;/;function x0(r,e,i,m,v){const S=ls(i,m,v),L=[];if(e=e.map(function(tt){if(!R0.test(tt)){const st=Xl(tt);if(st)tt=st.text;else{const bt=`no element with id: ${tt}`;S.errorCallback(bt),L.push(bt);}}return tt;}),L.length)return o0(S,"");const T=S.callback;T&&(S.callback=(tt,st)=>{T(tt,tt?void 0:Ms(r,st));});const k=p0(r,e,S);return k?Ms(r,k):null;}const I0=4,zs=5123;function S0(r,e,i,m,v,S){i=i===void 0?I0:i;const L=e.indices,T=e.elementType,k=m===void 0?e.numElements:m;v=v===void 0?0:v,T||L?S!==void 0?r.drawElementsInstanced(i,k,T===void 0?zs:e.elementType,v,S):r.drawElements(i,k,T===void 0?zs:e.elementType,v):S!==void 0?r.drawArraysInstanced(i,v,k,S):r.drawArrays(i,v,k);}const Ql=36160,pi=36161,T0=3553,Y0=5121,w0=6402,F0=6408,L0=33190,H0=36012,C0=35056,N0=36013,J0=32854,k0=32855,U0=36194,Dl=33189,$l=6401,ql=36168,cs=34041,Yo=36064,io=36096,t2=36128,us=33306,wo=33071,Fo=9729,E0=[{format:F0,type:Y0,min:Fo,wrap:wo},{format:cs}],Dn={};Dn[cs]=us;Dn[$l]=t2;Dn[ql]=t2;Dn[w0]=io;Dn[Dl]=io;Dn[L0]=io;Dn[H0]=io;Dn[C0]=us;Dn[N0]=us;function M0(r,e){return Dn[r]||Dn[e];}const mr={};mr[J0]=!0;mr[k0]=!0;mr[U0]=!0;mr[cs]=!0;mr[Dl]=!0;mr[$l]=!0;mr[ql]=!0;function z0(r){return mr[r];}const A0=32;function B0(r){return r>=Yo&&r<Yo+A0;}function As(r,e,i,m){const v=Ql,S=r.createFramebuffer();r.bindFramebuffer(v,S),i=i||r.drawingBufferWidth,m=m||r.drawingBufferHeight,e=e||E0;const L=[],T={framebuffer:S,attachments:[],width:i,height:m};return e.forEach(function(k,tt){let st=k.attachment;const bt=k.samples,xt=k.format;let Yt=k.attachmentPoint||M0(xt,k.internalFormat);if(Yt||(Yt=Yo+tt),B0(Yt)&&L.push(Yt),!st)if(bt!==void 0||z0(xt))st=r.createRenderbuffer(),r.bindRenderbuffer(pi,st),bt>1?r.renderbufferStorageMultisample(pi,bt,xt,i,m):r.renderbufferStorage(pi,xt,i,m);else{const at=Object.assign({},k);at.width=i,at.height=m,at.auto===void 0&&(at.auto=!1,at.min=at.min||at.minMag||Fo,at.mag=at.mag||at.minMag||Fo,at.wrapS=at.wrapS||at.wrap||wo,at.wrapT=at.wrapT||at.wrap||wo),st=Gl(r,at);}if($c(r,st))r.framebufferRenderbuffer(v,Yt,pi,st);else if(Qo(r,st))k.layer!==void 0?r.framebufferTextureLayer(v,Yt,st,k.level||0,k.layer):r.framebufferTexture2D(v,Yt,k.target||T0,st,k.level||0);else throw new Error("unknown attachment type");T.attachments.push(st);}),r.drawBuffers&&r.drawBuffers(L),T;}function j0(r,e,i){i=i||Ql,e?(r.bindFramebuffer(i,e.framebuffer),r.viewport(0,0,e.width,e.height)):(r.bindFramebuffer(i,null),r.viewport(0,0,r.drawingBufferWidth,r.drawingBufferHeight));}function En(r,e){return()=>e instanceof WebGLTexture?e:Gl(r,{src:e,wrap:r.CLAMP_TO_EDGE});}const Jr=2;let ii=/*#__PURE__*/function(){function ii(e){this.id="_";const i=e.context,m=e.width,v=e.height;this.context=i,this.options=e;const S=this.buildDefines();this.programInfo=x0(this.context,[S+this.getVertexShader(),S+this.getFragmentShader()]),this.bufferInfo=X1(this.context,this.getBuffers()),this.fbi=As(this.context,[{format:this.context.RGBA,type:this.context.UNSIGNED_BYTE,min:this.context.LINEAR,wrap:this.context.CLAMP_TO_EDGE}],m,v),this.output=this.fbi.attachments[0];}var _proto17=ii.prototype;_proto17.resizeOutput=function resizeOutput(e,i){this.fbi=As(this.context,[{format:this.context.RGBA,type:this.context.UNSIGNED_BYTE,min:this.context.LINEAR,wrap:this.context.CLAMP_TO_EDGE}],e,i),this.options.width=e,this.options.height=i,this.output=this.fbi.attachments[0];}/**
   * Return a list of defines prepend to the shaders
   * @returns Object where key is the define name and value the define value
   */;_proto17.getDefines=function getDefines(){return{};}/**
   * Return a list of buffers used by the program
   * The buffers are uploaded only once at the initialization
   * @returns Buffer map
   */;_proto17.getBuffers=function getBuffers(){return{position:{numComponents:2,data:[-1,-1,-1,1,1,-1,1,1,-1,1,1,-1]},texture_coord:{numComponents:2,data:[0,0,0,1,1,0,1,1,0,1,1,0]}};}/**
   * Build prependable string to shaders source containing the defines returned by getDefines.
   * @returns Prependable string
   */;_proto17.buildDefines=function buildDefines(){let e="";const i=this.getDefines();for(let m in i)e+=`#define ${m} ${i[m].toFixed(1)}
`;return e;}/**
   * Run the program
   * @param uniforms Data to used for the uniforms
   */;_proto17.run=function run(e){var v,S,L,T,k,tt;(v=this.profiler)==null||v.pushContext(`[${this.id}] PROG : ${this.constructor.name}`),(S=this.profiler)==null||S.pushContext(`[${this.id}] UNIFORMS`);for(const st in e)typeof e[st]=="function"&&((L=this.profiler)==null||L.pushContext(`[${this.id}] UNI : ${st}`),e[st]=e[st](),(T=this.profiler)==null||T.popContext(`[${this.id}] UNI : ${st}`));(k=this.profiler)==null||k.popContext(`[${this.id}] UNIFORMS`);const i=Date.now();let m=0;this.lastRun&&(m=(i-this.lastRun)/1e3),this.lastRun=i,this.context.viewport(0,0,this.context.canvas.width,this.context.canvas.height),this.context.useProgram(this.programInfo.program),V0(this.context,this.programInfo,this.bufferInfo),_l(this.programInfo,Object.assign({delta:m,canvas:[this.context.canvas.width,this.context.canvas.height]},e)),j0(this.context,this.options.disableFramebuffer?null:this.fbi),S0(this.context,this.bufferInfo),(tt=this.profiler)==null||tt.popContext(`[${this.id}] PROG : ${this.constructor.name}`);};_proto17.setProfiler=function setProfiler(e){this.profiler=e;};return ii;}();const K0=`precision mediump float;

varying vec2 _texture_coord;

uniform sampler2D background;
uniform sampler2D foreground;
uniform sampler2D threshold;

void main() {
  vec4 backgroundColor = texture2D(background, _texture_coord);
  vec4 foregroundColor = texture2D(foreground, _texture_coord);
  vec4 tresholdColor = texture2D(threshold, _texture_coord);
  gl_FragColor = foregroundColor * tresholdColor.a +
                 backgroundColor * (1. - tresholdColor.a);
}
`,O0=`varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
  _texture_coord.y = 1. - texture_coord.y;
}
`;let as=/*#__PURE__*/function(_ii){(0,_inheritsLoose2.default)(as,_ii);function as(){return _ii.apply(this,arguments)||this;}var _proto18=as.prototype;_proto18.getFragmentShader=function getFragmentShader(){return K0;};_proto18.getVertexShader=function getVertexShader(){return O0;};return as;}(ii);let ds=/*#__PURE__*/function(){function ds(){this.steps=[];}/**
   * Add a program pipeline to the rendering pipeline
   * @param step Program pipeline infos
   */var _proto19=ds.prototype;_proto19.addStep=function addStep(e){this.steps.push(e);}/**
   * Run the pipeline
   */;_proto19.run=/*#__PURE__*/function(){var _run=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee46(){var _iterator65,_step65,e;return _regenerator.default.wrap(function _callee46$(_context46){while(1)switch(_context46.prev=_context46.next){case 0:for(_iterator65=_createForOfIteratorHelperLoose(this.steps);!(_step65=_iterator65()).done;){e=_step65.value;e.program.run(e.getUniforms());}case 1:case"end":return _context46.stop();}},_callee46,this);}));function run(){return _run.apply(this,arguments);}return run;}();_proto19.resizeOutput=function resizeOutput(e,i){var m,v;(m=this.profiler)==null||m.pushContext(`PIP [${this.constructor.name}]`);for(var _iterator66=_createForOfIteratorHelperLoose(this.steps),_step66;!(_step66=_iterator66()).done;){const S=_step66.value;S.preventResize||S.program.resizeOutput(e,i);}(v=this.profiler)==null||v.popContext(`PIP [${this.constructor.name}]`);};_proto19.setProfiler=function setProfiler(e){this.profiler=e;for(var _iterator67=_createForOfIteratorHelperLoose(this.steps),_step67;!(_step67=_iterator67()).done;){const i=_step67.value;i.program.setProfiler(e);}};_proto19.setId=function setId(e){for(var _iterator68=_createForOfIteratorHelperLoose(this.steps),_step68;!(_step68=_iterator68()).done;){const i=_step68.value;i.program.id=e;}};return ds;}();let hs=/*#__PURE__*/function(_ds){(0,_inheritsLoose2.default)(hs,_ds);function hs(){var _this13;_this13=_ds.apply(this,arguments)||this,_this13.preciseMaskEnabled=!1;return _this13;}return hs;}(ds);let e2=/*#__PURE__*/function(_hs){(0,_inheritsLoose2.default)(e2,_hs);function e2(e){var _this14;_this14=_hs.call(this)||this,_this14.context=e,_this14.preciseMaskEnabled=!0;const i={context:e,height:e.canvas.height,width:e.canvas.width},m=new as(Object.assign({},i,{disableFramebuffer:!0}));_this14.addStep({program:m,getUniforms:()=>({background:En(e,_this14.inputBackgroundImage),foreground:En(e,_this14.inputImage),threshold:En(e,_this14.inputMask)})});return _this14;}var _proto20=e2.prototype;_proto20.setData=function setData(e,i){this.inputImage=e,this.inputMask=i;};return e2;}(hs);const P0=`precision mediump float;

varying vec2 _texture_coord;
uniform sampler2D texture;

void main() { gl_FragColor = texture2D(texture, _texture_coord); }
`,_0=`varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;
uniform bool invert_y;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
  if (invert_y) {
    _texture_coord.y = 1. - texture_coord.y;
  }
}
`;let Q0=/*#__PURE__*/function(_ii2){(0,_inheritsLoose2.default)(Q0,_ii2);function Q0(){return _ii2.apply(this,arguments)||this;}var _proto21=Q0.prototype;_proto21.getFragmentShader=function getFragmentShader(){return P0;};_proto21.getVertexShader=function getVertexShader(){return _0;};return Q0;}(ii);let D0=/*#__PURE__*/function(_ds2){(0,_inheritsLoose2.default)(D0,_ds2);function D0(e,i,m){var _this15;_this15=_ds2.call(this)||this,_this15.context=e;const v={context:e,height:m,width:i};_this15.addStep({program:new Q0(Object.assign({},v,{disableFramebuffer:!0})),getUniforms:()=>({texture:En(e,_this15.inputImage),invert_y:!0})});return _this15;}var _proto22=D0.prototype;_proto22.setData=function setData(e){this.inputImage=e;};return D0;}(ds);function n2(_x75){return _n4.apply(this,arguments);}function _n4(){_n4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee112(r){return _regenerator.default.wrap(function _callee112$(_context112){while(1)switch(_context112.prev=_context112.next){case 0:return _context112.abrupt("return",new Promise(e=>{setTimeout(()=>{e();},r);}));case 1:case"end":return _context112.stop();}},_callee112);}));return _n4.apply(this,arguments);}const $0=`precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;

vec4 loop();

void main() { gl_FragColor = loop(); }
`,q0=`varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;var fs=/* @__PURE__ */(r=>(r[r.LINEAR=0]="LINEAR",r[r.GAUSSIAN=1]="GAUSSIAN",r))(fs||{});let r2=/*#__PURE__*/function(_ii3){(0,_inheritsLoose2.default)(r2,_ii3);function r2(){return _ii3.apply(this,arguments)||this;}var _proto23=r2.prototype;_proto23.getDefines=function getDefines(){var _this$options$radius;return{RADIUS:(_this$options$radius=this.options.radius)!=null?_this$options$radius:1};};_proto23.getFragmentShader=function getFragmentShader(){return $0+this.createLoopFunction();};_proto23.getVertexShader=function getVertexShader(){return q0;};_proto23.createLoopFunction=function createLoopFunction(){var _this$options$radius2;let e=(_this$options$radius2=this.options.radius)!=null?_this$options$radius2:1;return`

        vec4 loop() {
            vec4 result = vec4(0,0,0,0);
            float factorSum = 0.;

            vec2 normalizedRadius = vec2(-${e}.) / canvas;
            vec2 normalizedIncrement = vec2(1.) / canvas;
            vec2 diff = normalizedRadius;

            for(int y=-${e}; y<${e+1}; ++y) {
                for(int x=-${e}; x<${e+1}; ++x) {
                    float factor = 1.;
                    result += factor * texture2D(texture, _texture_coord + diff);
                    factorSum += factor;
                    diff.x += normalizedIncrement.x;
                }
                diff.y += normalizedIncrement.y;
                diff.x = normalizedRadius.x;
            }
            return result / factorSum;
        }`;}// https://en.wikipedia.org/wiki/Gaussian_blur
;_proto23.getFactor=function getFactor(e,i){switch(this.options.type){case 1:return this.getLinearFactor(e,i);case 0:default:return this.getLinearFactor(e,i);}}// https://en.wikipedia.org/wiki/Gaussian_blur
;_proto23.getLinearFactor=function getLinearFactor(e,i){return 1;}// https://en.wikipedia.org/wiki/Gaussian_blur
;_proto23.getGaussianFactor=function getGaussianFactor(e,i){var _this$options$radius3;const m=Math.PI*2,v=Math.max((_this$options$radius3=this.options.radius)!=null?_this$options$radius3:1,1),S=1/(m*Math.pow(v,2)),L=-(Math.pow(e,2)+Math.pow(i,2)),T=S*L;return S*Math.pow(Math.E,T);};return r2;}(ii);const t3=`#version 300 es
// https://github.com/Volcomix/virtual-background/blob/main/src/pipelines/webgl2/jointBilateralFilterStage.ts

precision highp float;
uniform sampler2D input_frame;
uniform sampler2D segmentation_mask;
uniform sampler2D threshold;
uniform vec2 texel_size;
uniform float step;
uniform float radius;
uniform float offset;
uniform float sigma_texel;
uniform float sigma_color;

in vec2 _texture_coord;
out vec4 outColor;

float gaussian(float x, float sigma) {
  float coeff = -0.5 / (sigma * sigma * 4.0 + 1.0e-6);
  return exp((x * x) * coeff);
}

void main() {
  vec2 centerCoord = _texture_coord;
  vec3 centerColor = texture(input_frame, centerCoord).rgb;
  float newVal = 0.0;
  float spaceWeight = 0.0;
  float colorWeight = 0.0;
  float totalWeight = 0.0;
  // Subsample kernel space.
  for (float i = -radius + offset; i <= radius; i += step) {
    for (float j = -radius + offset; j <= radius; j += step) {
      vec2 shift = vec2(j, i) * texel_size;
      vec2 coord = vec2(centerCoord + shift);
      vec3 frameColor = texture(input_frame, coord).rgb;
      float threshold = texture(threshold, coord).a;
      float outVal = texture(segmentation_mask, coord).a;

      spaceWeight = gaussian(distance(centerCoord, coord), sigma_texel);
      colorWeight = gaussian(distance(centerColor, frameColor), sigma_color);
      totalWeight += spaceWeight * colorWeight;
      newVal += spaceWeight * colorWeight * outVal * threshold;
    }
  }
  newVal /= totalWeight;
  outColor = vec4(vec3(0.), newVal);
}`,e3=`#version 300 es
in vec2 position;
in vec2 texture_coord;
out vec2 _texture_coord;
void main() {
  gl_Position = vec4(position, 0.0, 1.0);
  _texture_coord = texture_coord;
}`;let n3=/*#__PURE__*/function(_ii4){(0,_inheritsLoose2.default)(n3,_ii4);function n3(){return _ii4.apply(this,arguments)||this;}var _proto24=n3.prototype;_proto24.getFragmentShader=function getFragmentShader(){return t3;};_proto24.getVertexShader=function getVertexShader(){return e3;};return n3;}(ii);let r3=/*#__PURE__*/function(_ds3){(0,_inheritsLoose2.default)(r3,_ds3);function r3(e,i,m){var _this16;_this16=_ds3.call(this)||this,_this16.context=e;const v={context:e,height:m,width:i},S=new r2(Object.assign({},v,{radius:1,type:fs.GAUSSIAN}));_this16.jointBilateral=new n3(v),_this16.addStep({program:S,getUniforms:()=>({inputs:En(e,_this16.inputMask)})}),_this16.addStep({program:_this16.jointBilateral,getUniforms:()=>{var _ref28,_ref29;var Yt,at,ht,Ut;const T=(_ref28=(Yt=_this16.inputImage)==null?void 0:Yt.width)!=null?_ref28:1,k=(_ref29=(at=_this16.inputImage)==null?void 0:at.height)!=null?_ref29:1;(ht=_this16.inputMask)==null||ht.width,(Ut=_this16.inputMask)==null||Ut.height;const tt=3,st=Math.max(1,Math.sqrt(tt)*0.66),bt=1/T,xt=1/k;return{input_frame:En(e,_this16.inputImage),segmentation_mask:En(e,_this16.inputMask),texel_size:[bt,xt],step:st,radius:tt,offset:st>1?st*0.5:0,sigma_texel:Math.max(bt,xt)*tt,sigma_color:tt// Sigma values: For simplicity, you can set the 2 sigma values to be the same - From https://docs.opencv.org/4.x/d4/d86/group__imgproc__filter.html
};}}),_this16.output=_this16.jointBilateral.output;return _this16;}var _proto25=r3.prototype;_proto25.setData=function setData(e,i){this.previousInputImage=this.inputImage?this.inputImage:e,this.previousInputMask=this.inputMask?this.inputMask:i,this.inputImage=e,this.inputMask=i;};_proto25.resizeOutput=function resizeOutput(e,i){_ds3.prototype.resizeOutput.call(this,e,i),this.output=this.jointBilateral.output;};return r3;}(ds);var i2=/* @__PURE__ */(r=>(r.PUSH="PUSH",r.POP="POP",r))(i2||{});let i3=/*#__PURE__*/function(){function i3(e){this.queries=[],this.context=e,this.extension=e.getExtension("EXT_disjoint_timer_query_webgl2");}var _proto26=i3.prototype;_proto26.start=function start(){};_proto26.stop=function stop(){this.activeQuery&&this.context.endQuery(this.extension.TIME_ELAPSED_EXT);};_proto26.pushContext=function pushContext(e){this.createQuery("PUSH",e);};_proto26.popContext=function popContext(e){this.createQuery("POP",e);};_proto26.createQuery=function createQuery(e,i){this.activeQuery&&this.context.endQuery(this.extension.TIME_ELAPSED_EXT),this.activeQuery=this.context.createQuery(),this.context.beginQuery(this.extension.TIME_ELAPSED_EXT,this.activeQuery),this.queries.push({name:i,action:e,query:this.activeQuery});};_proto26.getResolvedQueries=/*#__PURE__*/function(){var _getResolvedQueries=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee47(){var e,i;return _regenerator.default.wrap(function _callee47$(_context47){while(1)switch(_context47.prev=_context47.next){case 0:_context47.next=2;return Promise.all([...this.queries].map(i=>this.resolveQuery(i)));case 2:e=_context47.sent.filter(i=>i);for(i=1;i<e.length;++i)e[i].timestamp+=e[i-1].duration+e[i-1].timestamp;return _context47.abrupt("return",e);case 5:case"end":return _context47.stop();}},_callee47,this);}));function getResolvedQueries(){return _getResolvedQueries.apply(this,arguments);}return getResolvedQueries;}();_proto26.resolveQuery=/*#__PURE__*/function(){var _resolveQuery=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee48(e){return _regenerator.default.wrap(function _callee48$(_context48){while(1)switch(_context48.prev=_context48.next){case 0:_context48.next=2;return this.awaitQueryAvailable(e);case 2:if(_context48.sent){_context48.next=5;break;}console.log("Unawaitable query",e);return _context48.abrupt("return");case 5:if(!this.context.getParameter(this.extension.GPU_DISJOINT_EXT)){_context48.next=8;break;}console.log("Disjointed query",e);return _context48.abrupt("return");case 8:return _context48.abrupt("return",Object.assign({},e,{duration:this.context.getQueryParameter(e.query,this.context.QUERY_RESULT),timestamp:0}));case 9:case"end":return _context48.stop();}},_callee48,this);}));function resolveQuery(_x76){return _resolveQuery.apply(this,arguments);}return resolveQuery;}();_proto26.awaitQueryAvailable=/*#__PURE__*/function(){var _awaitQueryAvailable=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee49(e){var i;return _regenerator.default.wrap(function _callee49$(_context49){while(1)switch(_context49.prev=_context49.next){case 0:i=0;case 1:if(!(i<10)){_context49.next=9;break;}if(!this.context.getQueryParameter(e.query,this.context.QUERY_RESULT_AVAILABLE)){_context49.next=4;break;}return _context49.abrupt("return",e);case 4:_context49.next=6;return n2(200);case 6:++i;_context49.next=1;break;case 9:case"end":return _context49.stop();}},_callee49,this);}));function awaitQueryAvailable(_x77){return _awaitQueryAvailable.apply(this,arguments);}return awaitQueryAvailable;}();return i3;}();let oo=/*#__PURE__*/function(){function oo(){this.previousImageWidth=0,this.previousImageHeight=0,this.previousMaskWidth=Jr,this.previousMaskHeight=Jr,this.postProcessingEnabled=!0;const e=new OffscreenCanvas(0,0),i=e.getContext("webgl2");if(!i)throw"Fail to retrieve webgl2 context";this.canvas=e,this.context=i,this.improveMask=new r3(this.context,Jr,Jr);}var _proto27=oo.prototype;_proto27.enablePostProcessing=function enablePostProcessing(){this.postProcessingEnabled=!0;};_proto27.disablePostProcessing=function disablePostProcessing(){this.postProcessingEnabled=!1;};_proto27.profileWebgl=/*#__PURE__*/function(){var _profileWebgl2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee50(e){var i;return _regenerator.default.wrap(function _callee50$(_context50){while(1)switch(_context50.prev=_context50.next){case 0:i=new i3(this.context);this.profiler=i;i.start();_context50.next=5;return n2(e);case 5:this.profiler=void 0;i.stop();return _context50.abrupt("return",i.getResolvedQueries());case 8:case"end":return _context50.stop();}},_callee50,this);}));function profileWebgl(_x78){return _profileWebgl2.apply(this,arguments);}return profileWebgl;}();_proto27.render=/*#__PURE__*/function(){var _render5=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee51(e,i){var L,T,m,v,S;return _regenerator.default.wrap(function _callee51$(_context51){while(1)switch(_context51.prev=_context51.next){case 0:if(this.pipeline){_context51.next=2;break;}throw"missing pipeline";case 2:(this.previousImageHeight!==e.height||this.previousImageWidth!==e.width)&&this.resizeOutput(e.width,e.height),(this.previousMaskHeight!==i.height||this.previousMaskWidth!==i.width)&&(this.improveMask.resizeOutput(i.width,i.height),this.previousMaskWidth=i.width,this.previousMaskHeight=i.height);m="renderer";(L=this.profiler)==null||L.pushContext(m),this.improveMask.setProfiler(this.profiler),this.pipeline.setProfiler(this.profiler);_context51.next=7;return createImageBitmap(i);case 7:v=_context51.sent;S=v;this.postProcessingEnabled&&(this.improveMask.setData(e,v),this.improveMask.run(),S=this.improveMask.output);this.pipeline.setData(e,S);_context51.next=13;return this.pipeline.run();case 13:(T=this.profiler)==null||T.popContext(m);return _context51.abrupt("return",this.canvas);case 15:case"end":return _context51.stop();}},_callee51,this);}));function render(_x79,_x80){return _render5.apply(this,arguments);}return render;}();_proto27.resizeOutput=function resizeOutput(e,i){var m;this.canvas.width=e,this.canvas.height=i,(m=this.pipeline)==null||m.resizeOutput(e,i),this.previousImageWidth=e,this.previousImageHeight=i;};_proto27.destroy=function destroy(){var i;const e=(i=this.context)==null?void 0:i.getExtension("WEBGL_lose_context");e&&e.loseContext();};return oo;}();let o2=/*#__PURE__*/function(_oo){(0,_inheritsLoose2.default)(o2,_oo);function o2(){var _this17;_this17=_oo.call(this)||this,_this17.pipeline=new e2(_this17.context);const e=new OffscreenCanvas(0,0),i=e.getContext("webgl2");if(!i)throw"Fail to retrieve webgl context";_this17.backgroundImageResizerCanvas=e,_this17.backgroundImageResizerContext=i,_this17.backgroundImageResizer=new D0(_this17.backgroundImageResizerContext,0,0);return _this17;}var _proto28=o2.prototype;_proto28.setBackgroundImage=function setBackgroundImage(e){this.backgroundImage=e,this.updateBackgroundImage();};_proto28.updateBackgroundImage=function updateBackgroundImage(){const _this$canvas=this.canvas,e=_this$canvas.width,i=_this$canvas.height;this.backgroundImageResizer.resizeOutput(e,i),this.backgroundImageResizer.setData(this.backgroundImage),this.backgroundImageResizer.run(),this.pipeline.inputBackgroundImage=this.backgroundImageResizerCanvas;};_proto28.resizeOutput=function resizeOutput(e,i){_oo.prototype.resizeOutput.call(this,e,i),this.backgroundImageResizerCanvas.width=e,this.backgroundImageResizerCanvas.height=i,this.backgroundImageResizer.resizeOutput(e,i),this.updateBackgroundImage();};_proto28.destroy=function destroy(){var i;const e=(i=this.backgroundImageResizerContext)==null?void 0:i.getExtension("WEBGL_lose_context");e&&e.loseContext(),_oo.prototype.destroy.call(this);};return o2;}(oo);let o3=/*#__PURE__*/function(_o5){(0,_inheritsLoose2.default)(o3,_o5);function o3(){return _o5.apply(this,arguments)||this;}var _proto29=o3.prototype;_proto29.setBackgroundVideo=function setBackgroundVideo(e){this.frameReader=e;};_proto29.render=/*#__PURE__*/function(){var _render6=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee52(e,i){return _regenerator.default.wrap(function _callee52$(_context52){while(1)switch(_context52.prev=_context52.next){case 0:_context52.next=2;return this.readNextVideoFrame();case 2:return _context52.abrupt("return",_o5.prototype.render.call(this,e,i));case 3:case"end":return _context52.stop();}},_callee52,this);}));function render(_x81,_x82){return _render6.apply(this,arguments);}return render;}();_proto29.readNextVideoFrame=/*#__PURE__*/function(){var _readNextVideoFrame=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee53(){var i,e,m;return _regenerator.default.wrap(function _callee53$(_context53){while(1)switch(_context53.prev=_context53.next){case 0:_context53.next=2;return(i=this.frameReader)==null?void 0:i.read();case 2:e=_context53.sent;if(!(e!=null&&e.value)){_context53.next=8;break;}_context53.next=6;return createImageBitmap(e.value);case 6:m=_context53.sent;this.setBackgroundImage(m),e.value.close();case 8:case"end":return _context53.stop();}},_callee53,this);}));function readNextVideoFrame(){return _readNextVideoFrame.apply(this,arguments);}return readNextVideoFrame;}();return o3;}(o2);let Bs=/*#__PURE__*/function(){function Bs(){}var _proto30=Bs.prototype;_proto30.blurBackground=function blurBackground(e){return new Uc(e);};_proto30.blurSilhouette=function blurSilhouette(e){return new Ec(e);};_proto30.imageBackground=function imageBackground(){return new Mc();};_proto30.videoBackground=function videoBackground(){return new o3();};return Bs;}();const s3=`precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;
uniform sampler2D mask;

vec4 loop();

void main() { gl_FragColor = loop(); }
`,l3=`varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;let c3=/*#__PURE__*/function(_ii5){(0,_inheritsLoose2.default)(c3,_ii5);function c3(){return _ii5.apply(this,arguments)||this;}var _proto31=c3.prototype;_proto31.getDefines=function getDefines(){var _this$options$radius4;return{RADIUS:(_this$options$radius4=this.options.radius)!=null?_this$options$radius4:1};};_proto31.getFragmentShader=function getFragmentShader(){return s3+this.createLoopFunction();};_proto31.getVertexShader=function getVertexShader(){return l3;};_proto31.createLoopFunction=function createLoopFunction(){var _this$options$radius5;let e=(_this$options$radius5=this.options.radius)!=null?_this$options$radius5:1;return`

        vec4 loop() {
            vec4 result = vec4(0,0,0,0);
            float factorSum = 0.;

            vec2 normalizedRadius = vec2(-${e}.) / canvas;
            vec2 normalizedIncrement = vec2(1.) / canvas;
            vec2 diff = normalizedRadius;
            float maxLength = length(normalizedRadius);

            for(int y=-${e}; y<${e+1}; ++y) {
                for(int x=-${e}; x<${e+1}; ++x) {
                    float factor = (1.- texture2D(mask, _texture_coord + diff).a) * (maxLength - length(diff)) / maxLength;
                    result += factor * texture2D(texture, _texture_coord + diff);
                    factorSum += factor;
                    diff.x += normalizedIncrement.x;
                }
                diff.y += normalizedIncrement.y;
                diff.x = normalizedRadius.x;
            }
            return result / factorSum;
        }`;};return c3;}(ii);const u3=10,a3=2,d3=8;let h3=/*#__PURE__*/function(_hs2){(0,_inheritsLoose2.default)(h3,_hs2);function h3(e,i){var _this18;_this18=_hs2.call(this)||this,_this18.context=e,_this18.radius=i;const m={context:e,height:e.canvas.height,width:e.canvas.width};_this18.blur=new c3(Object.assign({},m,{radius:i},_this18.getBlurTextureSize(e.canvas.width,e.canvas.height)));const v=new as(Object.assign({},m,{disableFramebuffer:!0}));_this18.addStep({program:_this18.blur,preventResize:!0,getUniforms:()=>({texture:En(e,_this18.inputImage),mask:En(e,_this18.inputMask)})}),_this18.addStep({program:v,getUniforms:()=>({background:En(e,_this18.blur.output),foreground:En(e,_this18.inputImage),threshold:En(e,_this18.inputMask)})});return _this18;}var _proto32=h3.prototype;_proto32.getBlurTextureSize=function getBlurTextureSize(e,i){const m=this.radius>u3?d3:a3;return{width:Math.max(Jr,e/m),height:Math.max(Jr,i/m)};};_proto32.setData=function setData(e,i){this.inputImage=e,this.inputMask=i;};_proto32.resizeOutput=function resizeOutput(e,i){_hs2.prototype.resizeOutput.call(this,e,i);const m=this.getBlurTextureSize(e,i);this.blur.resizeOutput(m.width,m.height);};return h3;}(hs);let f3=/*#__PURE__*/function(_oo2){(0,_inheritsLoose2.default)(f3,_oo2);function f3(e){var _this19;_this19=_oo2.call(this)||this,_this19.pipeline=new h3(_this19.context,e),_this19.disablePostProcessing();return _this19;}return f3;}(oo);let m3=/*#__PURE__*/function(_hs3){(0,_inheritsLoose2.default)(m3,_hs3);function m3(e,i){var _this20;_this20=_hs3.call(this)||this,_this20.context=e;const m={context:e,height:e.canvas.height,width:e.canvas.width},v=new r2(Object.assign({},m,{radius:i,type:fs.GAUSSIAN})),S=new as(Object.assign({},m,{disableFramebuffer:!0}));_this20.addStep({program:v,getUniforms:()=>({texture:En(e,_this20.inputImage)})}),_this20.addStep({program:S,getUniforms:()=>({background:En(e,_this20.inputImage),foreground:En(e,v.output),threshold:En(e,_this20.inputMask)})});return _this20;}var _proto33=m3.prototype;_proto33.setData=function setData(e,i){this.inputImage=e,this.inputMask=i;};return m3;}(hs);let p3=/*#__PURE__*/function(_oo3){(0,_inheritsLoose2.default)(p3,_oo3);function p3(e){var _this21;_this21=_oo3.call(this)||this,_this21.pipeline=new m3(_this21.context,e),_this21.disablePostProcessing();return _this21;}return p3;}(oo);let b3=/*#__PURE__*/function(_e2){(0,_inheritsLoose2.default)(b3,_e2);function b3(){var _this22;_this22=_e2.apply(this,arguments)||this,_this22.preciseMaskEnabled=!0;return _this22;}var _proto34=b3.prototype;_proto34.run=/*#__PURE__*/function(){var _run2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee54(){return _regenerator.default.wrap(function _callee54$(_context54){while(1)switch(_context54.prev=_context54.next){case 0:_context54.t0=this.frameReader;if(!_context54.t0){_context54.next=6;break;}_context54.next=4;return this.readNextVideoFrame();case 4:_context54.next=6;return _e2.prototype.run.call(this);case 6:case"end":return _context54.stop();}},_callee54,this);}));function run(){return _run2.apply(this,arguments);}return run;}();_proto34.readNextVideoFrame=/*#__PURE__*/function(){var _readNextVideoFrame2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee55(){var i,e;return _regenerator.default.wrap(function _callee55$(_context55){while(1)switch(_context55.prev=_context55.next){case 0:_context55.next=2;return(i=this.frameReader)==null?void 0:i.read();case 2:e=_context55.sent;_context55.t0=e!=null&&e.value;if(!_context55.t0){_context55.next=9;break;}_context55.next=7;return createImageBitmap(e.value);case 7:this.inputBackgroundImage=_context55.sent;e.value.close();case 9:case"end":return _context55.stop();}},_callee55,this);}));function readNextVideoFrame(){return _readNextVideoFrame2.apply(this,arguments);}return readNextVideoFrame;}();(0,_createClass2.default)(b3,[{key:"reader",set:function set(e){this.frameReader=e;}}]);return b3;}(e2);let y3=/*#__PURE__*/function(_oo4){(0,_inheritsLoose2.default)(y3,_oo4);function y3(){var _this23;_this23=_oo4.call(this)||this,_this23.pipeline=new b3(_this23.context);return _this23;}var _proto35=y3.prototype;_proto35.setBackgroundVideo=function setBackgroundVideo(e){this.pipeline.reader=e;};return y3;}(oo);let js=/*#__PURE__*/function(){function js(){}var _proto36=js.prototype;_proto36.blurBackground=function blurBackground(e){return new f3(e);};_proto36.blurSilhouette=function blurSilhouette(e){return new p3(e);};_proto36.imageBackground=function imageBackground(){return new o2();};_proto36.videoBackground=function videoBackground(){return new y3();};return js;}();let g3=/*#__PURE__*/function(){function g3(e){switch(e){case Wi.CANVAS:this.factory=new Bs();break;case Wi.WEBGL:this.factory=new js();break;default:const i=_s();this.factory=i.supported?new js():new Bs();}}var _proto37=g3.prototype;_proto37.blurBackground=function blurBackground(e){return this.getFactory().blurBackground(e);};_proto37.blurSilhouette=function blurSilhouette(e){return this.getFactory().blurSilhouette(e);};_proto37.imageBackground=function imageBackground(){return this.getFactory().imageBackground();};_proto37.videoBackground=function videoBackground(){return this.getFactory().videoBackground();};_proto37.getFactory=function getFactory(){if(!this.factory)throw"Factory is not initialized";return this.factory;};return g3;}();let Z3=/*#__PURE__*/function(){function Z3(){}var _proto38=Z3.prototype;_proto38.setBackgroundOptions=function setBackgroundOptions(e){var m,v;this.renderer&&this.renderer.destroy();const i=new g3((m=e.renderingOptions)==null?void 0:m.type);switch(e.transformerType){case"BackgroundBlur":this.renderer=i.blurBackground(this.getBlurSize(e.radius));break;case"SilhouetteBlur":this.renderer=i.blurSilhouette(this.getBlurSize(e.radius));break;case"VideoBackground":const S=i.videoBackground();this.backgroundVideo&&S.setBackgroundVideo(this.backgroundVideo),this.renderer=S;break;case"VirtualBackground":const L=i.imageBackground();this.backgroundImage&&L.setBackgroundImage(this.backgroundImage),this.renderer=L;break;default:throw`Unknown rendering type [${e.transformerType}]`;}((v=e.renderingOptions)==null?void 0:v.type)===Wi.WEBGL&&(e.renderingOptions.selfieSegmentationType===Zo.PRECISE?this.renderer.enablePostProcessing():e.renderingOptions.selfieSegmentationType===Zo.FAST&&this.renderer.disablePostProcessing());};_proto38.setVideoBGReadable=function setVideoBGReadable(e){this.backgroundVideo=e.getReader();const i=this.renderer;i!=null&&i.setBackgroundVideo&&i.setBackgroundVideo(this.backgroundVideo);};_proto38.setVirtualBGImage=/*#__PURE__*/function(){var _setVirtualBGImage=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee56(e){var i;return _regenerator.default.wrap(function _callee56$(_context56){while(1)switch(_context56.prev=_context56.next){case 0:i=this.renderer;i!=null&&i.setBackgroundImage&&i.setBackgroundImage(e),this.backgroundImage=e;case 2:case"end":return _context56.stop();}},_callee56,this);}));function setVirtualBGImage(_x83){return _setVirtualBGImage.apply(this,arguments);}return setVirtualBGImage;}();_proto38.process=/*#__PURE__*/function(){var _process=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee57(e,i){return _regenerator.default.wrap(function _callee57$(_context57){while(1)switch(_context57.prev=_context57.next){case 0:if(!this.renderer){_context57.next=2;break;}return _context57.abrupt("return",this.renderer.render(e,i));case 2:case"end":return _context57.stop();}},_callee57,this);}));function process(_x84,_x85){return _process.apply(this,arguments);}return process;}();_proto38.resizeForeground=/*#__PURE__*/function(){var _resizeForeground=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee58(e,i){return _regenerator.default.wrap(function _callee58$(_context58){while(1)switch(_context58.prev=_context58.next){case 0:case"end":return _context58.stop();}},_callee58);}));function resizeForeground(_x86,_x87){return _resizeForeground.apply(this,arguments);}return resizeForeground;}();_proto38.getBlurSize=function getBlurSize(e){if(e===void 0){e=Zi.Low;}switch(e){case Zi.Low:return 5;case Zi.High:return 12;}return e;};_proto38.profile=/*#__PURE__*/function(){var _profile=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee59(e){var _ref30;var i;return _regenerator.default.wrap(function _callee59$(_context59){while(1)switch(_context59.prev=_context59.next){case 0:return _context59.abrupt("return",(_ref30=(i=this.renderer)==null?void 0:i.profileWebgl(e))!=null?_ref30:[]);case 1:case"end":return _context59.stop();}},_callee59,this);}));function profile(_x88){return _profile.apply(this,arguments);}return profile;}();return Z3;}();const v3=0.1,G3=0.7,X3="https://d3opqjmqzxf057.cloudfront.net/ml/vonage_selfie_segmenter/float16/v1/vonage_selfie_segmenter.tflite";let W3=/*#__PURE__*/function(){function W3(){this.canvas=new OffscreenCanvas(0,0),this.context=this.canvas.getContext("2d",{willReadFrequently:!0}),this.width=0,this.height=0;}var _proto39=W3.prototype;_proto39.createImageSegmenter=/*#__PURE__*/function(){var _createImageSegmenter=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee60(){return _regenerator.default.wrap(function _callee60$(_context60){while(1)switch(_context60.prev=_context60.next){case 0:if(!(!this.ImageSegmenter||!this.wasmFileset)){_context60.next=3;break;}console.warn("Mediapipe objects not loaded");return _context60.abrupt("return");case 3:_context60.next=5;return this.ImageSegmenter.createFromOptions(this.wasmFileset,{baseOptions:{// TODO: We might need to host the new version of this model.
modelAssetPath:this.modelAssetUriPath,delegate:"GPU"},runningMode:"VIDEO",outputCategoryMask:!0,outputConfidenceMasks:!0});case 5:this.imageSegmenter=_context60.sent;case 6:case"end":return _context60.stop();}},_callee60,this);}));function createImageSegmenter(){return _createImageSegmenter.apply(this,arguments);}return createImageSegmenter;}();_proto39.loadMediapipeAssets=/*#__PURE__*/function(){var _loadMediapipeAssets=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee61(e,i){var m,v,_yield$import,S,L;return _regenerator.default.wrap(function _callee61$(_context61){while(1)switch(_context61.prev=_context61.next){case 0:this.modelAssetUriPath=e||X3;m=i?`${i}/task-vision.js`:"https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.20/+esm";v=i?`${i}/wasm`:"https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.20/wasm";_context61.next=5;return(specifier=>new Promise(r=>r(`${specifier}`)).then(s=>_interopRequireWildcard(__webpack_require__(761)(s))))(/* @vite-ignore */m);case 5:_yield$import=_context61.sent;S=_yield$import.FilesetResolver;L=_yield$import.ImageSegmenter;this.ImageSegmenter=L;_context61.next=11;return S.forVisionTasks(v);case 11:this.wasmFileset=_context61.sent;case 12:case"end":return _context61.stop();}},_callee61,this);}));function loadMediapipeAssets(_x89,_x90){return _loadMediapipeAssets.apply(this,arguments);}return loadMediapipeAssets;}();_proto39.init=/*#__PURE__*/function(){var _init=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee62(e,i){return _regenerator.default.wrap(function _callee62$(_context62){while(1)switch(_context62.prev=_context62.next){case 0:_context62.next=2;return this.loadMediapipeAssets(e,i);case 2:_globalThis.document={};_context62.next=5;return this.createImageSegmenter();case 5:case"end":return _context62.stop();}},_callee62,this);}));function init(_x91,_x92){return _init.apply(this,arguments);}return init;}();_proto39.process=/*#__PURE__*/function(){var _process2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee63(e){var L,i,m,v,S,T,k;return _regenerator.default.wrap(function _callee63$(_context63){while(1)switch(_context63.prev=_context63.next){case 0:if(this.imageSegmenter){_context63.next=3;break;}console.warn("ImageSegmenter instance not available");return _context63.abrupt("return");case 3:(this.width!==e.width||this.height!==e.height)&&(this.canvas.width=this.width=e.width,this.canvas.height=this.height=e.height,this.mask&&(this.mask=new ImageData(this.width,this.height))),this.mask||(this.mask=new ImageData(this.width,this.height)),this.context.drawImage(e,0,0,e.width,e.height);i=Date.now();_context63.prev=5;(L=this.imageSegmenter)==null||L.segmentForVideo(this.context.getImageData(0,0,e.width,e.height),i,T=>{var tt;const k=(tt=T.confidenceMasks)==null?void 0:tt[0];m=k==null?void 0:k.getAsFloat32Array();});_context63.next=14;break;case 9:_context63.prev=9;_context63.t0=_context63["catch"](5);_context63.next=13;return this.createImageSegmenter();case 13:return _context63.abrupt("return");case 14:if(m){_context63.next=16;break;}return _context63.abrupt("return");case 16:if(this.previousConfidenceMask){_context63.next=19;break;}this.previousConfidenceMask=m.slice();return _context63.abrupt("return");case 19:v=m.map((T,k)=>{var st;const tt=(st=this.previousConfidenceMask)==null?void 0:st[k];return tt!==void 0?this.blend(tt,T):T;}),S=[255,0,0];for(T=0;T<(v==null?void 0:v.length);T++){k=1-v[T];k>v3?(k<G3?(this.mask.data[T*4]=S[0]*k,this.mask.data[T*4+3]=255*k):(this.mask.data[T*4]=S[0],this.mask.data[T*4+3]=255),this.mask.data[T*4+1]=S[1],this.mask.data[T*4+2]=S[2]):this.mask.data[T*4]=this.mask.data[T*4+1]=this.mask.data[T*4+2]=this.mask.data[T*4+3]=0;}return _context63.abrupt("return",(this.previousConfidenceMask=v.slice(),this.mask));case 22:case"end":return _context63.stop();}},_callee63,this,[[5,9]]);}));function process(_x93){return _process2.apply(this,arguments);}return process;}();_proto39.isGpuSupported=function isGpuSupported(){return!0;}// Typescript version of https://cs.opensource.google/mediapipe/mediapipe/+/refs/tags/v0.8.11:mediapipe/calculators/image/segmentation_smoothing_calculator.cc;l=214
;_proto39.blend=function blend(e,i){const v=-0.748699,S=-57.8051,L=291.309,T=-624.717,k=i-0.5,tt=k*k,st=1-Math.min(1,tt*(5.68842+tt*(v+tt*(S+tt*(L+tt*T)))));return i+(e-i)*(st*0.9);};return W3;}();let V3=/*#__PURE__*/function(){function V3(){this.reporter=new Jc(),this.isEnabled=!0;}var _proto40=V3.prototype;_proto40.init=/*#__PURE__*/function(){var _init2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee64(e,i){var m;return _regenerator.default.wrap(function _callee64$(_context64){while(1)switch(_context64.prev=_context64.next){case 0:this.selfieSegmentation=new W3();_context64.next=3;return(m=this.selfieSegmentation)==null?void 0:m.init(i.modelAssetUriPath,i.mediapipeBaseAssetsUri);case 3:this.backgroundFilter=new Z3();this.report({variation:"Create"});case 5:case"end":return _context64.stop();}},_callee64,this);}));function init(_x94,_x95){return _init2.apply(this,arguments);}return init;}();_proto40.transform=/*#__PURE__*/function(){var _transform2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee65(e,i){var _e$timestamp;var T,k,m,v,S,L;return _regenerator.default.wrap(function _callee65$(_context65){while(1)switch(_context65.prev=_context65.next){case 0:if(this.isEnabled){_context65.next=2;break;}return _context65.abrupt("return",i.enqueue(e));case 2:v=(_e$timestamp=e.timestamp)!=null?_e$timestamp:0;_context65.next=5;return createImageBitmap(e);case 5:S=_context65.sent;_context65.next=8;return(T=this.selfieSegmentation)==null?void 0:T.process(S);case 8:L=_context65.sent;_context65.t0=L;if(!_context65.t0){_context65.next=14;break;}_context65.next=13;return(k=this.backgroundFilter)==null?void 0:k.process(S,L);case 13:m=_context65.sent;case 14:m?(e.close(),i.enqueue(new VideoFrame(m,{timestamp:v,alpha:"discard"}))):i.enqueue(e);case 15:case"end":return _context65.stop();}},_callee65,this);}));function transform(_x96,_x97){return _transform2.apply(this,arguments);}return transform;}();_proto40.setBackgroundOptions=/*#__PURE__*/function(){var _setBackgroundOptions=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee66(e){var i;return _regenerator.default.wrap(function _callee66$(_context66){while(1)switch(_context66.prev=_context66.next){case 0:this.backgroundOptions=e;_context66.next=3;return(i=this.backgroundFilter)==null?void 0:i.setBackgroundOptions(e);case 3:this.report({variation:"Update"});case 4:case"end":return _context66.stop();}},_callee66,this);}));function setBackgroundOptions(_x98){return _setBackgroundOptions.apply(this,arguments);}return setBackgroundOptions;}();_proto40.setVideoBGReadable=/*#__PURE__*/function(){var _setVideoBGReadable=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee67(e){var i;return _regenerator.default.wrap(function _callee67$(_context67){while(1)switch(_context67.prev=_context67.next){case 0:_context67.next=2;return(i=this.backgroundFilter)==null?void 0:i.setVideoBGReadable(e);case 2:case"end":return _context67.stop();}},_callee67,this);}));function setVideoBGReadable(_x99){return _setVideoBGReadable.apply(this,arguments);}return setVideoBGReadable;}();_proto40.setVirtualBGImage=/*#__PURE__*/function(){var _setVirtualBGImage2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee68(e){var i;return _regenerator.default.wrap(function _callee68$(_context68){while(1)switch(_context68.prev=_context68.next){case 0:_context68.next=2;return(i=this.backgroundFilter)==null?void 0:i.setVirtualBGImage(e);case 2:case"end":return _context68.stop();}},_callee68,this);}));function setVirtualBGImage(_x100){return _setVirtualBGImage2.apply(this,arguments);}return setVirtualBGImage;}();_proto40.profile=/*#__PURE__*/function(){var _profile2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee69(e){var _ref31;var i;return _regenerator.default.wrap(function _callee69$(_context69){while(1)switch(_context69.prev=_context69.next){case 0:return _context69.abrupt("return",(_ref31=(i=this.backgroundFilter)==null?void 0:i.profile(e))!=null?_ref31:[]);case 1:case"end":return _context69.stop();}},_callee69,this);}));function profile(_x101){return _profile2.apply(this,arguments);}return profile;}();_proto40.getTransformerType=function getTransformerType(){var _ref32;var e;return(_ref32=(e=this.backgroundOptions)==null?void 0:e.transformerType)!=null?_ref32:"Undefined";};_proto40.enable=function enable(){this.isEnabled=!0;};_proto40.disable=function disable(){this.isEnabled=!1;};_proto40.report=function report(e){var i;this.reporter.send(Object.assign({version:kc,action:"MlTransformers",transformerType:(i=this.backgroundOptions)==null?void 0:i.transformerType,config:JSON.stringify(this.backgroundOptions)},e));};return V3;}();exports.BackgroundTransformer=V3;const ms=/*#__PURE__*/function(){function ms(){this.backgroundTransformer=new V3(),this.mediaProcessor=new j2(),this.rate=30,this.eventsQueue=[],this.frameTransformLatencyMs=[];}var _proto41=ms.prototype;_proto41.init=/*#__PURE__*/function(){var _init3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee70(e,i){return _regenerator.default.wrap(function _callee70$(_context70){while(1)switch(_context70.prev=_context70.next){case 0:this.frameTransformLatencyMs=[];_context70.next=3;return this.backgroundTransformer.init(e,i);case 3:_context70.next=5;return this.mediaProcessor.setTransformers([this.backgroundTransformer]);case 5:this.mediaProcessor.setTrackExpectedRate(this.rate);this.mediaProcessor.onAny((m,v)=>{this.resolveOnMediaProcessor?(this.resolveOnMediaProcessor({name:m,data:v}),this.resolveOnMediaProcessor=void 0):this.eventsQueue.push({name:m,data:v});});case 7:case"end":return _context70.stop();}},_callee70,this);}));function init(_x102,_x103){return _init3.apply(this,arguments);}return init;}();_proto41.enable=function enable(){this.backgroundTransformer.enable();};_proto41.disable=function disable(){this.backgroundTransformer.disable();};_proto41.onMediaProcessorEvent=/*#__PURE__*/function(){var _onMediaProcessorEvent=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee71(){return _regenerator.default.wrap(function _callee71$(_context71){while(1)switch(_context71.prev=_context71.next){case 0:_context71.next=2;return new Promise(e=>{this.eventsQueue.length>0?e(this.eventsQueue.shift()):this.resolveOnMediaProcessor=e;});case 2:return _context71.abrupt("return",_context71.sent);case 3:case"end":return _context71.stop();}},_callee71,this);}));function onMediaProcessorEvent(){return _onMediaProcessorEvent.apply(this,arguments);}return onMediaProcessorEvent;}();_proto41.setTrackExpectedRate=/*#__PURE__*/function(){var _setTrackExpectedRate=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee72(e){return _regenerator.default.wrap(function _callee72$(_context72){while(1)switch(_context72.prev=_context72.next){case 0:this.rate=e,this.mediaProcessor.setTrackExpectedRate(e);case 1:case"end":return _context72.stop();}},_callee72,this);}));function setTrackExpectedRate(_x104){return _setTrackExpectedRate.apply(this,arguments);}return setTrackExpectedRate;}();_proto41.transform=/*#__PURE__*/function(){var _transform3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee73(e,i){var m;return _regenerator.default.wrap(function _callee73$(_context73){while(1)switch(_context73.prev=_context73.next){case 0:m=performance.now();this.mediaProcessor.transform(e,i),this.frameTransformLatencyMs.push(performance.now()-m);case 2:case"end":return _context73.stop();}},_callee73,this);}));function transform(_x105,_x106){return _transform3.apply(this,arguments);}return transform;}();_proto41.setBackgroundOptions=/*#__PURE__*/function(){var _setBackgroundOptions2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee74(e){var i;return _regenerator.default.wrap(function _callee74$(_context74){while(1)switch(_context74.prev=_context74.next){case 0:_context74.next=2;return(i=this.backgroundTransformer)==null?void 0:i.setBackgroundOptions(e);case 2:case"end":return _context74.stop();}},_callee74,this);}));function setBackgroundOptions(_x107){return _setBackgroundOptions2.apply(this,arguments);}return setBackgroundOptions;}();_proto41.setVideoBGReadable=function setVideoBGReadable(e){this.backgroundTransformer.setVideoBGReadable(e);};_proto41.setVirtualBGImage=/*#__PURE__*/function(){var _setVirtualBGImage3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee75(e){return _regenerator.default.wrap(function _callee75$(_context75){while(1)switch(_context75.prev=_context75.next){case 0:_context75.next=2;return this.backgroundTransformer.setVirtualBGImage(e);case 2:case"end":return _context75.stop();}},_callee75,this);}));function setVirtualBGImage(_x108){return _setVirtualBGImage3.apply(this,arguments);}return setVirtualBGImage;}();_proto41.terminate=/*#__PURE__*/function(){var _terminate=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee76(){var i;return _regenerator.default.wrap(function _callee76$(_context76){while(1)switch(_context76.prev=_context76.next){case 0:_context76.next=2;return this.mediaProcessor.destroy();case 2:i=this.frameTransformLatencyMs.reduce((m,v)=>m+v,0)/this.frameTransformLatencyMs.length||0;console.log(`Transform latency average is: ${i} ms`);case 4:case"end":return _context76.stop();}},_callee76,this);}));function terminate(){return _terminate.apply(this,arguments);}return terminate;}();_proto41.setVonageMetadata=function setVonageMetadata(e){J2(e);};_proto41.profile=/*#__PURE__*/function(){var _profile3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee77(e){return _regenerator.default.wrap(function _callee77$(_context77){while(1)switch(_context77.prev=_context77.next){case 0:_context77.t0=JSON;_context77.next=3;return this.backgroundTransformer.profile(e);case 3:_context77.t1=_context77.sent;return _context77.abrupt("return",_context77.t0.stringify.call(_context77.t0,_context77.t1));case 5:case"end":return _context77.stop();}},_callee77,this);}));function profile(_x109){return _profile3.apply(this,arguments);}return profile;}();return ms;}();uc("ProcessorWorker",ms);let Lo=ms;const s2="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",R3=r=>Uint8Array.from(atob(r),e=>e.charCodeAt(0)),Ks=typeof self<"u"&&self.Blob&&new Blob([R3(s2)],{type:"text/javascript;charset=utf-8"});function x3(r){let e;try{if(e=Ks&&(self.URL||self.webkitURL).createObjectURL(Ks),!e)throw"";const i=new Worker(e,{name:r==null?void 0:r.name});return i.addEventListener("error",()=>{(self.URL||self.webkitURL).revokeObjectURL(e);}),i;}catch(_unused13){return new Worker("data:text/javascript;base64,"+s2,{name:r==null?void 0:r.name});}finally{e&&(self.URL||self.webkitURL).revokeObjectURL(e);}}const Oi=/*#__PURE__*/function(_qr){(0,_inheritsLoose2.default)(Oi,_qr);function Oi(e){var _this24;_this24=_qr.call(this)||this,_this24.rate=30,_this24.isEnabled=!0,_this24.config=e;return _this24;}var _proto42=Oi.prototype;_proto42.setTrackExpectedRate=/*#__PURE__*/function(){var _setTrackExpectedRate2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee78(e){var i;return _regenerator.default.wrap(function _callee78$(_context78){while(1)switch(_context78.prev=_context78.next){case 0:_context78.next=2;return this.startWorker();case 2:_context78.next=4;return(i=this.worker)==null?void 0:i.setTrackExpectedRate(e);case 4:case"end":return _context78.stop();}},_callee78,this);}));function setTrackExpectedRate(_x110){return _setTrackExpectedRate2.apply(this,arguments);}return setTrackExpectedRate;}();_proto42.setBackgroundOptions=/*#__PURE__*/function(){var _setBackgroundOptions3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee79(e){return _regenerator.default.wrap(function _callee79$(_context79){while(1)switch(_context79.prev=_context79.next){case 0:this.backgroundOptions=e;_context79.next=3;return this.updateBackgroundOptions(e);case 3:case"end":return _context79.stop();}},_callee79,this);}));function setBackgroundOptions(_x111){return _setBackgroundOptions3.apply(this,arguments);}return setBackgroundOptions;}();_proto42.transform=/*#__PURE__*/function(){var _transform4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee80(e,i){var m;return _regenerator.default.wrap(function _callee80$(_context80){while(1)switch(_context80.prev=_context80.next){case 0:_context80.next=2;return this.startWorker();case 2:_context80.next=4;return(m=this.worker)==null?void 0:m.transform(e,i);case 4:case"end":return _context80.stop();}},_callee80,this);}));function transform(_x112,_x113){return _transform4.apply(this,arguments);}return transform;}();_proto42.destroy=/*#__PURE__*/function(){var _destroy2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee81(){var e;return _regenerator.default.wrap(function _callee81$(_context81){while(1)switch(_context81.prev=_context81.next){case 0:_context81.next=2;return(e=this.worker)==null?void 0:e.terminate();case 2:this.worker=void 0;case 3:case"end":return _context81.stop();}},_callee81,this);}));function destroy(){return _destroy2.apply(this,arguments);}return destroy;}();_proto42.profile=/*#__PURE__*/function(){var _profile4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee82(e){var m,i;return _regenerator.default.wrap(function _callee82$(_context82){while(1)switch(_context82.prev=_context82.next){case 0:_context82.next=2;return(m=this.worker)==null?void 0:m.profile(e);case 2:i=_context82.sent;return _context82.abrupt("return",JSON.parse(i!=null?i:"[]"));case 4:case"end":return _context82.stop();}},_callee82,this);}));function profile(_x114){return _profile4.apply(this,arguments);}return profile;}();_proto42.enable=/*#__PURE__*/function(){var _enable=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee83(){var e;return _regenerator.default.wrap(function _callee83$(_context83){while(1)switch(_context83.prev=_context83.next){case 0:this.isEnabled=!0;_context83.next=3;return(e=this.worker)==null?void 0:e.enable();case 3:case"end":return _context83.stop();}},_callee83,this);}));function enable(){return _enable.apply(this,arguments);}return enable;}();_proto42.disable=/*#__PURE__*/function(){var _disable=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee84(){var e;return _regenerator.default.wrap(function _callee84$(_context84){while(1)switch(_context84.prev=_context84.next){case 0:this.isEnabled=!1;_context84.next=3;return(e=this.worker)==null?void 0:e.disable();case 3:case"end":return _context84.stop();}},_callee84,this);}));function disable(){return _disable.apply(this,arguments);}return disable;}();_proto42.listenWorker=/*#__PURE__*/function(){var _listenWorker=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee85(){var e,i,_yield,m,v;return _regenerator.default.wrap(function _callee85$(_context85){while(1)switch(_context85.prev=_context85.next){case 0:if(!((e=this.worker)!=null&&e.workerContext.worker)){_context85.next=20;break;}_context85.next=3;return(i=this.worker)==null?void 0:i.onMediaProcessorEvent();case 3:_yield=_context85.sent;m=_yield.name;v=_yield.data;_context85.t0=m;_context85.next=_context85.t0==="error"?9:_context85.t0==="warn"?9:_context85.t0==="pipelineInfo"?11:18;break;case 9:this.emit(m,v);return _context85.abrupt("break",18);case 11:_context85.t1=(this.emit(m,v),v);_context85.next=_context85.t1==="pipeline_ended"?14:_context85.t1==="pipeline_ended_with_error"?14:17;break;case 14:_context85.next=16;return this.destroy();case 16:return _context85.abrupt("return");case 17:return _context85.abrupt("break",18);case 18:_context85.next=0;break;case 20:case"end":return _context85.stop();}},_callee85,this);}));function listenWorker(){return _listenWorker.apply(this,arguments);}return listenWorker;}();_proto42.startWorker=/*#__PURE__*/function(){var _startWorker=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee86(){return _regenerator.default.wrap(function _callee86$(_context86){while(1)switch(_context86.prev=_context86.next){case 0:_context86.t0=!this.config||this.worker;if(_context86.t0){_context86.next=20;break;}_context86.next=4;return lc(Lo,x3);case 4:this.worker=_context86.sent;_context86.t1=this.isEnabled;if(_context86.t1){_context86.next=9;break;}_context86.next=9;return this.worker.disable();case 9:_context86.next=11;return this.worker.init(`worker_${Oi.initCount++}`,this.config);case 11:_context86.t2=this.backgroundOptions;if(!_context86.t2){_context86.next=15;break;}_context86.next=15;return this.updateBackgroundOptions(this.backgroundOptions);case 15:_context86.next=17;return this.worker.setVonageMetadata(yi());case 17:_context86.next=19;return this.setBackgroundOptions(this.config);case 19:this.listenWorker();case 20:case"end":return _context86.stop();}},_callee86,this);}));function startWorker(){return _startWorker.apply(this,arguments);}return startWorker;}();_proto42.updateBackgroundOptions=/*#__PURE__*/function(){var _updateBackgroundOptions=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee87(e){var m,v,S,i;return _regenerator.default.wrap(function _callee87$(_context87){while(1)switch(_context87.prev=_context87.next){case 0:_context87.next=2;return this.startWorker();case 2:i=e.transformerType;_context87.t0=i;_context87.next=_context87.t0==="VideoBackground"?6:_context87.t0==="VirtualBackground"?18:30;break;case 6:if(!((m=this.worker)==null)){_context87.next=10;break;}_context87.t1=void 0;_context87.next=15;break;case 10:_context87.t2=m;_context87.next=13;return ws.createVideoReadable(e.backgroundAssetUri);case 13:_context87.t3=_context87.sent;_context87.t1=_context87.t2.setVideoBGReadable.call(_context87.t2,_context87.t3);case 15:_context87.next=17;return _context87.t1;case 17:return _context87.abrupt("break",30);case 18:if(!((v=this.worker)==null)){_context87.next=22;break;}_context87.t4=void 0;_context87.next=27;break;case 22:_context87.t5=v;_context87.next=25;return ws.createImageCanvas(e.backgroundAssetUri);case 25:_context87.t6=_context87.sent;_context87.t4=_context87.t5.setVirtualBGImage.call(_context87.t5,_context87.t6);case 27:_context87.next=29;return _context87.t4;case 29:return _context87.abrupt("break",30);case 30:_context87.next=32;return(S=this.worker)==null?void 0:S.setBackgroundOptions(e);case 32:case"end":return _context87.stop();}},_callee87,this);}));function updateBackgroundOptions(_x115){return _updateBackgroundOptions.apply(this,arguments);}return updateBackgroundOptions;}();return Oi;}(qr);Oi.initCount=0;let Ho=Oi;let I3=/*#__PURE__*/function(){function I3(e){this.queries=e;}var _proto43=I3.prototype;_proto43.downloadSpeedscope=/*#__PURE__*/function(){var _downloadSpeedscope=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee88(){return _regenerator.default.wrap(function _callee88$(_context88){while(1)switch(_context88.prev=_context88.next){case 0:_context88.t0=this;_context88.next=3;return this.convertToSpeedscope();case 3:_context88.t1=_context88.sent;_context88.t0.download.call(_context88.t0,_context88.t1);case 5:case"end":return _context88.stop();}},_callee88,this);}));function downloadSpeedscope(){return _downloadSpeedscope.apply(this,arguments);}return downloadSpeedscope;}();_proto43.download=function download(e){const i=document.createElement("a");i.href=URL.createObjectURL(new Blob([e],{type:"application/json"})),i.download=`profile-${+/* @__PURE__ */new Date()}.speedscope.json`,document.body.appendChild(i),i.click(),document.body.removeChild(i);};_proto43.convertToSpeedscope=function convertToSpeedscope(){const e=[],i={},m=[];let v=0;for(var _iterator69=_createForOfIteratorHelperLoose(this.queries),_step69;!(_step69=_iterator69()).done;){const L=_step69.value;const T=[];for(var _iterator70=_createForOfIteratorHelperLoose(L),_step70;!(_step70=_iterator70()).done;){const k=_step70.value;i[k.name]===void 0&&(i[k.name]=e.length,e.push({name:k.name})),T.push({type:k.action==i2.PUSH?"O":"C",frame:i[k.name],at:k.timestamp}),v=Math.max(v,k.timestamp+k.duration);}m.push({events:T,type:"evented",name:"GPU Profile",unit:"nanoseconds",startValue:0,endValue:v});}return JSON.stringify({$schema:"https://www.speedscope.app/file-format-schema.json",shared:{frames:e},profiles:m},null,2);};return I3;}();const ps=/*#__PURE__*/function(_qr2){(0,_inheritsLoose2.default)(ps,_qr2);/**
   * Private constructor
   * Use {@link create} to instantiate the class
   * @internal
   */function ps(e){var _this25;_this25=_qr2.call(this)||this,_this25.worker=new Ho(e),_this25.connector=new O2(_this25.worker),_this25.worker.onAny((i,m)=>_this25.emit(i,m));return _this25;}/**
   * change the background option during run time using this function.
   * while using this function the media-processor will not be destroyed.
   * while using this function the library promise a full resource cleanup.
   * @param backgroundOptions - see `BackgroundOptions` definition
   */var _proto44=ps.prototype;_proto44.setBackgroundOptions=/*#__PURE__*/function(){var _setBackgroundOptions4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee89(e){return _regenerator.default.wrap(function _callee89$(_context89){while(1)switch(_context89.prev=_context89.next){case 0:_context89.next=2;return this.worker.setBackgroundOptions(e);case 2:case"end":return _context89.stop();}},_callee89,this);}));function setBackgroundOptions(_x116){return _setBackgroundOptions4.apply(this,arguments);}return setBackgroundOptions;}()/**
   * Enable the processing
   */;_proto44.enable=/*#__PURE__*/function(){var _enable2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee90(){return _regenerator.default.wrap(function _callee90$(_context90){while(1)switch(_context90.prev=_context90.next){case 0:_context90.next=2;return this.worker.enable();case 2:case"end":return _context90.stop();}},_callee90,this);}));function enable(){return _enable2.apply(this,arguments);}return enable;}()/**
   * Disable the processing
   */;_proto44.disable=/*#__PURE__*/function(){var _disable2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee91(){return _regenerator.default.wrap(function _callee91$(_context91){while(1)switch(_context91.prev=_context91.next){case 0:_context91.next=2;return this.worker.disable();case 2:case"end":return _context91.stop();}},_callee91,this);}));function disable(){return _disable2.apply(this,arguments);}return disable;}()/**
   * Sets the expected rate of the track per second.
   * The media processor will use this number for calculating drops in the rate.
   * This could happen when the transformation will take more time than expected.
   * This will not cause an error, just warning to the client.
   * Mostly:
   * Video: 30 frames per second
   * Audio: 50 audio data per second for OPUS
   * @param rate - number holds the predicted track rate. -1 for disable this monitor.
   */;_proto44.setTrackExpectedRate=function setTrackExpectedRate(e){this.worker.setTrackExpectedRate(e);}/**
   * Getter for MediaProcessorConnectorInterface connector attribute.
   * @returns - `MediaProcessorConnectorInterface` feed this return value to any vonage SDK that supports this API
   */;_proto44.getConnector=function getConnector(){return this.connector;};_proto44.profile=/*#__PURE__*/function(){var _profile5=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee92(e){return _regenerator.default.wrap(function _callee92$(_context92){while(1)switch(_context92.prev=_context92.next){case 0:return _context92.abrupt("return",this.worker.profile(e));case 1:case"end":return _context92.stop();}},_callee92,this);}));function profile(_x117){return _profile5.apply(this,arguments);}return profile;}()/**
   * @internal
   */;ps.profile=/*#__PURE__*/function(){var _profile6=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee93(e){var i;return _regenerator.default.wrap(function _callee93$(_context93){while(1)switch(_context93.prev=_context93.next){case 0:_context93.next=2;return Promise.all(this.instances.map(m=>m.profile(e)));case 2:i=_context93.sent;return _context93.abrupt("return",new I3(i));case 4:case"end":return _context93.stop();}},_callee93,this);}));function profile(_x118){return _profile6.apply(this,arguments);}return profile;}()/**
   * Asynchronous constructor of VonageMediaProcessor
   * @param config Initial MediaProcessorConfig to use
   * @returns Promise resolved with an initialized MediaProcessorConfig
   */;ps.create=/*#__PURE__*/function(){var _create=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee94(e){var i;return _regenerator.default.wrap(function _callee94$(_context94){while(1)switch(_context94.prev=_context94.next){case 0:i=new this(e);return _context94.abrupt("return",(this.instances.push(i),i));case 2:case"end":return _context94.stop();}},_callee94,this);}));function create(_x119){return _create.apply(this,arguments);}return create;}();return ps;}(qr);ps.instances=[];let Co=ps;exports.VonageMediaProcessor=Co;function w3(){return Vi;}function F3(){return Ri;}function L3(){return xi;}function H3(){return Ii;}function C3(){return Si;}function N3(){return Ti;}function J3(){return Yi;}function k3(_x120){return _k.apply(this,arguments);}function _k(){_k=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee113(r){return _regenerator.default.wrap(function _callee113$(_context113){while(1)switch(_context113.prev=_context113.next){case 0:_context113.next=2;return Co.create(r);case 2:return _context113.abrupt("return",_context113.sent);case 3:case"end":return _context113.stop();}},_callee113);}));return _k.apply(this,arguments);}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(24)))

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Capabilities;
var _hasE2eeCapability = _interopRequireDefault(__webpack_require__(115));
var _hasOpenTokSupport = _interopRequireDefault(__webpack_require__(53));
const defaultHasOpenTokSupport = _hasOpenTokSupport.default.once;

/**
 * A class defining properties of the <code>capabilities</code> property of a
 * Session object. See <a href="Session.html#properties">Session.capabilities</a>.
 * <p>
 * All Capabilities properties are undefined until you have connected to a session
 * and the Session object has dispatched the <code>sessionConnected</code> event.
 * <p>
 * For more information on token roles, see the
 * <a href="https://tokbox.com/developer/guides/create-token/">Token Creation Overview</a>.
 *
 * @class Capabilities
 *
 * @property {Number} forceDisconnect Specifies whether you can call
 * the <code>Session.forceDisconnect()</code> method (1) or not (0). To call the
 * <code>Session.forceDisconnect()</code> method,
 * the user must have a token that is assigned the role of moderator.
 * @property {Number} forceUnpublish Specifies whether you can call
 * the <code>Session.forceUnpublish()</code> method (1) or not (0). To call the
 * <code>Session.forceUnpublish()</code> method, the user must have a token that
 * is assigned the role of moderator.
 * @property {Number} forceMute Specifies whether you can call the
 * <code>Session.forceMuteStream()</code>, <code>Session.forceMuteAll()</code>, or
 * <code>Session.disableForceMute()</code>methods (1) or not (0). To call these methods,
 * the user must have a token that is assigned the role of moderator.
 * @property {Number} publish Specifies whether you can publish to the session (1) or not (0).
 * The ability to publish is based on a few factors. To publish, the user must have a token that
 * is assigned a role that supports publishing. There must be a connected camera and microphone.
 * @property {Number} subscribe Specifies whether you can subscribe to streams
 * in the session (1) or not (0).
 */
function Capabilities(permissions, deps) {
  if (deps === void 0) {
    deps = {};
  }
  /* eslint-disable-next-line global-require */
  const hasE2eeCapability = deps.hasE2eeCapability || _hasE2eeCapability.default;
  const hasOpenTokSupport = deps.hasOpenTokSupport || defaultHasOpenTokSupport;
  this.publish = permissions.indexOf('publish') !== -1 ? 1 : 0;
  this.subscribe = permissions.indexOf('subscribe') !== -1 ? 1 : 0;
  this.forceUnpublish = permissions.indexOf('forceunpublish') !== -1 ? 1 : 0;
  this.forceDisconnect = permissions.indexOf('forcedisconnect') !== -1 ? 1 : 0;
  this.forceMute = permissions.indexOf('forcemute') !== -1 ? 1 : 0;
  this.supportsE2ee = hasE2eeCapability() ? 1 : 0;
  this.supportsWebRTC = hasOpenTokSupport() ? 1 : 0;
  this.permittedTo = action => Object.prototype.hasOwnProperty.call(this, action) && this[action] === 1;
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Stream;
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _objects = _interopRequireDefault(__webpack_require__(27));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _events = _interopRequireDefault(__webpack_require__(18));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-shadow, max-len, no-use-before-define */
/* eslint-disable no-void, vars-on-top, no-var, no-restricted-syntax, no-prototype-builtins */
/* eslint-disable no-continue */

const logging = (0, _log.default)('Stream');
const Events = (0, _events.default)();
const validPropertyNames = ['name', 'archiving'];

/**
 * Specifies a stream. A stream is a representation of a published stream in a session. When a
 * client calls the <a href="Session.html#publish">Session.publish() method</a>, a new stream is
 * created. Properties of the Stream object provide information about the stream.
 *
 *  <p>When a stream is added to a session, the Session object dispatches a
 * <code>streamCreatedEvent</code>. When a stream is destroyed, the Session object dispatches a
 * <code>streamDestroyed</code> event. The StreamEvent object, which defines these event objects,
 * has a <code>stream</code> property, which is an array of Stream object. For details and a code
 * example, see {@link StreamEvent}.</p>
 *
 *  <p>When a connection to a session is made, the Session object dispatches a
 * <code>sessionConnected</code> event, defined by the SessionConnectEvent object. The
 * SessionConnectEvent object has a <code>streams</code> property, which is an array of Stream
 * objects pertaining to the streams in the session at that time. For details and a code example,
 * see {@link SessionConnectEvent}.</p>
 *
 * @class Stream
 * @property {Connection} connection The Connection object corresponding
 * to the connection that is publishing the stream. You can compare this to the
 * <code>connection</code> property of the Session object to see if the stream is being published
 * by the local web page.
 *
 * @property {Number} creationTime The timestamp for the creation
 * of the stream. This value is calculated in milliseconds. You can convert this value to a
 * Date object by calling <code>new Date(creationTime)</code>, where <code>creationTime</code> is
 * the <code>creationTime</code> property of the Stream object.
 *
 * @property {Number} frameRate The frame rate of the video stream. This property is only set if
 * the publisher of the stream specifies a frame rate when calling the
 * <code>OT.initPublisher()</code> method; otherwise, this property is undefined.
 *
 * @property {Boolean} hasAudio Whether the stream has audio. This property can change if the
 * publisher turns on or off audio (by calling
 * <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a>). When this occurs, the
 * {@link Session} object dispatches a <code>streamPropertyChanged</code> event (see
 * {@link StreamPropertyChangedEvent}).
 *
 * @property {Boolean} hasVideo Whether the stream has video. This property can change if the
 * publisher turns on or off video (by calling
 * <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a>). When this occurs, the
 * {@link Session} object dispatches a <code>streamPropertyChanged</code> event (see
 * {@link StreamPropertyChangedEvent}).
 *
 * @property {String} initials The initials for the stream. Publishers can specify the initials
 * to be displayed when the video is disabled.
 * (See the <code>initials</code> property of the <code>properties</code> parameter passed
 * into the <a href="OT.html#initPublisher">OT.initPublisher()</a> method.)
 *
 * @property {String} name The name of the stream. Publishers can specify a name when publishing
 * a stream (using the <code>publish()</code> method of the publisher's Session object).
 *
 * @property {String} streamId The unique ID of the stream.
 *
 * @property {Object} videoDimensions This object has two properties: <code>width</code> and
 * <code>height</code>. Both are numbers. The <code>width</code> property is the width of the
 * encoded stream; the <code>height</code> property is the height of the encoded stream. (These
 * are independent of the actual width of Publisher and Subscriber objects corresponding to the
 * stream.) This property can change if a stream published from a mobile device resizes, based on
 * a change in the device orientation. When the video dimensions change,
 * the {@link Session} object dispatches a <code>streamPropertyChanged</code> event
 * (see {@link StreamPropertyChangedEvent}).
 *
 * @property {String} videoType The type of video &mdash; either <code>"camera"</code>,
 * <code>"screen"</code>, or <code>"custom"</code>.
 * A <code>"screen"</code> video uses screen sharing on the publisher
 * as the video source; for other videos, this property is set to <code>"camera"</code>.
 * A <code>"custom"</code> video uses a VideoTrack element as the video source on the publisher.
 * (See the <code>videoSource</code> property of the <code>options</code> parameter passed
 * into the <a href="OT.html#initPublisher">OT.initPublisher()</a> method.)
 * The <code>videoType</code> is <code>undefined</code> when a stream is voice-only
 * (see the <a href="https://tokbox.com/developer/guides/audio-video/js/#voice">Voice-only guide</a>).
 * This property can change if a stream published from a mobile device changes from a
 * camera to a screen-sharing video type. When the video type changes, the {@link Session} object
 * dispatches a <code>streamPropertyChanged</code> event (see {@link StreamPropertyChangedEvent}).
 */

function Stream(id, name, creationTime, connection, session, channel, initials) {
  const self = this;
  let destroyedReason;
  this.id = id;
  this.streamId = id;
  this.name = name;
  this.creationTime = Number(creationTime);
  this.initials = initials || '';
  this.connection = connection;
  this.channel = channel;
  this.publisher = _objects.default.publishers.find({
    streamId: this.id
  });
  (0, _eventing.default)(this);
  const onChannelUpdate = function onChannelUpdate(channel, key, oldValue, newValue) {
    let _key = key;
    switch (_key) {
      case 'active':
        _key = channel.type === 'audio' ? 'hasAudio' : 'hasVideo';
        self[_key] = newValue;
        break;
      case 'disableWarning':
        _key = channel.type === 'audio' ? 'audioDisableWarning' : 'videoDisableWarning';
        self[_key] = newValue;
        if (!self[channel.type === 'audio' ? 'hasAudio' : 'hasVideo']) {
          return; // Do NOT event in this case.
        }

        break;
      case 'fitMode':
        _key = 'defaultFitMode';
        self[_key] = newValue;
        break;
      case 'source':
        _key = channel.type === 'audio' ? 'audioType' : 'videoType';
        self[_key] = newValue;
        break;
      case 'videoDimensions':
        self.videoDimensions = newValue;
        break;
      case 'orientation':
      case 'width':
      case 'height':
        // We dispatch this via the videoDimensions key instead so do not
        // trigger an event for them.
        return;
      default:
    }
    self.dispatchEvent(new Events.StreamUpdatedEvent(self, _key, oldValue, newValue));
  };
  const associatedWidget = function associatedWidget() {
    if (self.publisher) {
      return self.publisher;
    }
    return _objects.default.subscribers.find(subscriber => subscriber.stream && subscriber.stream.id === self.id && subscriber.session.id === session.id);
  };

  // Returns true if this stream is subscribe to.
  const isBeingSubscribedTo = function isBeingSubscribedTo() {
    // @fixme This is not strictly speaking the right test as a stream
    // can be published and subscribed by the same connection. But the
    // update features don't handle this case properly right now anyway.
    //
    // The issue is that the stream needs to know whether the stream is
    // 'owned' by a publisher or a subscriber. The reason for that is that
    // when a Publisher updates a stream channel then we need to send the
    // `streamChannelUpdate` message, whereas if a Subscriber does then we
    // need to send `subscriberChannelUpdate`. The current code will always
    // send `streamChannelUpdate`.
    return !self.publisher;
  };

  // Returns all channels that have a type of +type+.
  this.getChannelsOfType = function getChannelsOfType(type) {
    return self.channel.filter(channel => channel.type === type);
  };
  this.getChannel = function getChannel(id) {
    for (let i = 0; i < self.channel.length; ++i) {
      if (self.channel[i].id === id) {
        return self.channel[i];
      }
    }
    return null;
  };

  // implement the following using the channels
  // * hasAudio
  // * hasVideo
  // * videoDimensions

  const audioChannel = this.getChannelsOfType('audio')[0];
  const videoChannel = this.getChannelsOfType('video')[0];

  // @todo this should really be: "has at least one video/audio track" instead of
  // "the first video/audio track"
  this.hasAudio = audioChannel != null && audioChannel.active;
  this.hasVideo = videoChannel != null && videoChannel.active;
  this.videoType = videoChannel && videoChannel.source;
  this.defaultFitMode = videoChannel && videoChannel.fitMode;
  this.videoDimensions = {};
  if (videoChannel) {
    this.videoDimensions.width = videoChannel.width;
    this.videoDimensions.height = videoChannel.height;
    this.videoDimensions.orientation = videoChannel.orientation;
    videoChannel.on('update', onChannelUpdate);
    this.frameRate = videoChannel.frameRate;
  }
  if (audioChannel) {
    audioChannel.on('update', onChannelUpdate);
  }
  this.setChannelActiveState = function setChannelActiveState(_ref) {
    let channelType = _ref.channelType,
      activeState = _ref.activeState,
      activeReason = _ref.activeReason,
      congestionLevel = _ref.congestionLevel,
      subscriberId = _ref.subscriberId,
      isSubscriber = _ref.isSubscriber;
    const attributes = {
      active: activeState
    };
    if (activeReason) {
      attributes.activeReason = activeReason;
    }
    if (congestionLevel !== undefined) {
      attributes.congestionLevel = congestionLevel;
    }
    if (subscriberId) {
      attributes.subscriberId = subscriberId;
    }
    updateChannelsOfType(channelType, attributes, isSubscriber);
  };
  this.setVideoDimensions = function setVideoDimensions(width, height) {
    updateChannelsOfType('video', {
      width,
      height,
      orientation: 0
    });
  };
  this.setRestrictFrameRate = function setRestrictFrameRate(restrict) {
    updateChannelsOfType('video', {
      restrictFrameRate: restrict
    }, true);
  };
  this.setPreferredResolution = function setPreferredResolution(resolution) {
    if (!isBeingSubscribedTo()) {
      logging.warn('setPreferredResolution has no affect when called by a publisher');
      return;
    }
    if (session.sessionInfo.p2pEnabled) {
      logging.warn('Stream.setPreferredResolution will not work in a P2P Session');
      return;
    }
    if (resolution && resolution.width === void 0 && resolution.height === void 0) {
      return;
    }

    // This duplicates some of the code in updateChannelsOfType. We do this for a
    // couple of reasons:
    //   1. Because most of the work that updateChannelsOfType does is in calling
    //      getChannelsOfType, which we need to do here anyway so that we can update
    //      the value of maxResolution in the Video Channel.
    //   2. updateChannelsOfType on only sends a message to update the channel in
    //      Rumor. The client then expects to receive a subsequent channel update
    //      indicating that the update was successful. We don't receive those updates
    //      for preferredFrameRate/maxResolution so we need to complete both tasks and it's
    //      neater to do the related tasks right next to each other.
    //   3. This code shouldn't be in Stream anyway. There is way too much coupling
    //      between Stream, Session, Publisher, and Subscriber. This will eventually be
    //      fixed, and when it is then it will be easier to exact the code if it's a
    //      single piece.
    //
    const video = self.getChannelsOfType('video')[0];
    if (!video) {
      return;
    }
    if (resolution && resolution.width) {
      if (isNaN(parseInt(resolution.width, 10))) {
        throw new _OTHelpers.default.Error('stream preferred width must be an integer', 'Subscriber');
      }
      video.preferredWidth = parseInt(resolution.width, 10);
    } else {
      video.preferredWidth = void 0;
    }
    if (resolution && resolution.height) {
      if (isNaN(parseInt(resolution.height, 10))) {
        throw new _OTHelpers.default.Error('stream preferred height must be an integer', 'Subscriber');
      }
      video.preferredHeight = parseInt(resolution.height, 10);
    } else {
      video.preferredHeight = void 0;
    }
    session._.subscriberChannelUpdate(self, associatedWidget(), video, {
      preferredWidth: video.preferredWidth || 0,
      preferredHeight: video.preferredHeight || 0
    });
  };
  this.getPreferredResolution = function getPreferredResolution() {
    const videoChannel = self.getChannelsOfType('video')[0];
    if (!videoChannel || !videoChannel.preferredWidth && !videoChannel.preferredHeight) {
      return void 0;
    }
    return {
      width: videoChannel.preferredWidth,
      height: videoChannel.preferredHeight
    };
  };
  this.setPreferredFrameRate = function setPreferredFrameRate(preferredFrameRate) {
    if (!isBeingSubscribedTo()) {
      logging.warn('setPreferredFrameRate has no affect when called by a publisher');
      return;
    }
    if (session.sessionInfo.p2pEnabled) {
      logging.warn('Stream.setPreferredFrameRate will not work in a P2P Session');
      return;
    }
    if (preferredFrameRate && isNaN(parseFloat(preferredFrameRate))) {
      throw new _OTHelpers.default.Error('stream preferred frameRate must be a number', 'Subscriber');
    }

    // This duplicates some of the code in updateChannelsOfType. We do this for a
    // couple of reasons:
    //   1. Because most of the work that updateChannelsOfType does is in calling
    //      getChannelsOfType, which we need to do here anyway so that we can update
    //      the value of preferredFrameRate in the Video Channel.
    //   2. updateChannelsOfType on only sends a message to update the channel in
    //      Rumor. The client then expects to receive a subsequent channel update
    //      indicating that the update was successful. We don't receive those updates
    //      for preferredFrameRate/maxResolution so we need to complete both tasks and it's
    //      neater to do the related tasks right next to each other.
    //   3. This code shouldn't be in Stream anyway. There is way too much coupling
    //      between Stream, Session, Publisher, and Subscriber. This will eventually be
    //      fixed, and when it is then it will be easier to exact the code if it's a
    //      single piece.
    //
    const video = self.getChannelsOfType('video')[0];
    if (video) {
      video.preferredFrameRate = preferredFrameRate ? parseFloat(preferredFrameRate) : null;
      session._.subscriberChannelUpdate(self, associatedWidget(), video, {
        preferredFrameRate: video.preferredFrameRate || 0
      });
    }
  };
  this.getPreferredFrameRate = function getPreferredFrameRate() {
    const videoChannel = self.getChannelsOfType('video')[0];
    return videoChannel ? videoChannel.preferredFrameRate : null;
  };
  const updateChannelsOfType = function updateChannelsOfType(channelType, attributes, isSubscriber) {
    if (isSubscriber === void 0) {
      isSubscriber = false;
    }
    let setChannelActiveState;
    if (isSubscriber) {
      const subscriber = associatedWidget();
      setChannelActiveState = channel => session._.subscriberChannelUpdate(self, subscriber, channel, attributes);
    } else {
      setChannelActiveState = channel => session._.streamChannelUpdate(self, channel, attributes);
    }
    self.getChannelsOfType(channelType).forEach(setChannelActiveState);
  };
  this.destroyed = false;
  this.destroyedReason = void 0;
  this.destroy = function destroy(reason, quiet) {
    if (reason === void 0) {
      reason = 'clientDisconnected';
    }
    destroyedReason = reason;
    self.destroyed = true;
    self.destroyedReason = destroyedReason;
    if (quiet !== true) {
      self.dispatchEvent(new Events.DestroyedEvent('destroyed',
      // This should be eventNames.STREAM_DESTROYED, but
      // the value of that is currently shared with Session
      self, destroyedReason));
    }
  };

  // PRIVATE STUFF CALLED BY Raptor.Dispatcher
  //
  // Confusingly, this should not be called when you want to change
  // the stream properties. This is used by Raptor dispatch to notify
  // the stream that it's properties have been successfully updated
  //
  // @todo make this sane. Perhaps use setters for the properties that can
  // send the appropriate Raptor message. This would require that Streams
  // have access to their session.

  this._ = {};
  this._.updateProperty = function privateUpdateProperty(key, value) {
    if (validPropertyNames.indexOf(key) === -1) {
      logging.warn(`Unknown stream property "${key}" was modified to "${value}".`);
      return;
    }
    const oldValue = self[key];
    const newValue = value;
    switch (key) {
      case 'name':
        self[key] = newValue;
        break;
      case 'archiving':
        var widget = associatedWidget();
        if (self.publisher && widget) {
          widget._.archivingStatus(newValue);
        }
        self[key] = newValue;
        break;
      default:
    }
    const event = new Events.StreamUpdatedEvent(self, key, oldValue, newValue);
    self.dispatchEvent(event);
  };

  // Mass update, called by Raptor.Dispatcher
  this._.update = function privateUpdate(attributes) {
    for (const key in attributes) {
      if (!attributes.hasOwnProperty(key)) {
        continue;
      }
      self._.updateProperty(key, attributes[key]);
    }
  };
  this._.forceMute = function forceMute(content) {
    if (content.hasOwnProperty('channels')) {
      if (content.channels.includes('audio')) {
        if (self.publisher) {
          self.publisher._.forceMuteAudio();
        }
      }
    }
  };
  this._.updateChannel = function privateUpdateChannel(channelId, attributes) {
    const channel = self.getChannel(channelId);
    if (channel) {
      channel.update(attributes);
    }
  };
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.UNSUBSCRIBE = exports.SUBSCRIBE = exports.STATUS = exports.PONG = exports.PING = exports.MESSAGE = exports.DISCONNECT = exports.CONNECT = void 0;
// Rumor Messaging for JS
//
// https://tbwiki.tokbox.com/index.php/Rumor_:_Messaging_FrameWork
//
// @todo Rumor {
//     Add error codes for all the error cases
//     Add Dependability commands
// }

// This is used to subscribe to address/addresses. The address/addresses the
// client specifies here is registered on the server. Once any message is sent to
// that address/addresses, the client receives that message.
const SUBSCRIBE = 0;

// This is used to unsubscribe to address / addresses. Once the client unsubscribe
// to an address, it will stop getting messages sent to that address.
exports.SUBSCRIBE = SUBSCRIBE;
const UNSUBSCRIBE = 1;

// This is used to send messages to arbitrary address/ addresses. Messages can be
// anything and Rumor will not care about what is included.
exports.UNSUBSCRIBE = UNSUBSCRIBE;
const MESSAGE = 2;

// This will be the first message that the client sends to the server. It includes
// the uniqueId for that client connection and a disconnect_notify address that will
// be notified once the client disconnects.
exports.MESSAGE = MESSAGE;
const CONNECT = 3;

// This will be the message used by the server to notify an address that a
// client disconnected.
exports.CONNECT = CONNECT;
const DISCONNECT = 4;

// Enhancements to support Keepalives
exports.DISCONNECT = DISCONNECT;
const PING = 7;
exports.PING = PING;
const PONG = 8;
exports.PONG = PONG;
const STATUS = 9;
exports.STATUS = STATUS;
var _default = {
  SUBSCRIBE,
  UNSUBSCRIBE,
  MESSAGE,
  CONNECT,
  DISCONNECT,
  PING,
  PONG,
  STATUS
};
exports.default = _default;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _capabilities = _interopRequireDefault(__webpack_require__(185));
var _events = _interopRequireDefault(__webpack_require__(18));
var _connectionCapabilities = _interopRequireDefault(__webpack_require__(812));
const Events = (0, _events.default)();

/**
 * The Connection object represents a connection to a Vonage Video API session. Each client that connects
 * to a session has a unique connection, with a unique connection ID (represented by the
 * <code>id</code> property of the Connection object for the client).
 * <p>
 * The Session object has a <code>connection</code> property that is a Connection object.
 * It represents the local client's connection. (A client only has a connection once the
 * client has successfully called the <code>connect()</code> method of the {@link Session}
 * object.)
 * <p>
 * The Session object dispatches a <code>connectionCreated</code> event when each client (including
 * your own) connects to a session (and for clients that are present in the session when you
 * connect). The <code>connectionCreated</code> event object has a <code>connection</code>
 * property, which is a Connection object corresponding to the client the event pertains to.
 * <p>
 * The Stream object has a <code>connection</code> property that is a Connection object.
 * It represents the connection of the client that is publishing the stream.
 *
 * @class Connection
 * @property {String} connectionId The ID of this connection.
 * @property {Number} creationTime The timestamp for the creation of the connection. This
 * value is calculated in milliseconds.
 * You can convert this value to a Date object by calling <code>new Date(creationTime)</code>,
 * where <code>creationTime</code>
 * is the <code>creationTime</code> property of the Connection object.
 * @property {String} data A string containing metadata describing the
 * connection. When you generate a user token, you can define connection data (see the
 * <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
 */
function Connection(id, creationTime, data, capabilitiesHash, permissionsHash) {
  let destroyedReason;
  this.id = id;
  this.connectionId = id;
  this.creationTime = creationTime ? Number(creationTime) : null;
  this.data = data;
  this.capabilities = (0, _connectionCapabilities.default)(capabilitiesHash);
  this.permissions = new _capabilities.default(permissionsHash);
  this.quality = null;
  (0, _eventing.default)(this);
  this.destroy = (reason, quiet) => {
    destroyedReason = reason || 'clientDisconnected';
    if (quiet !== true) {
      this.dispatchEvent(new Events.DestroyedEvent(
      // This should be eventNames.CONNECTION_DESTROYED, but
      // the value of that is currently shared with Session
      'destroyed', this, destroyedReason));
    }
  };
  this.destroyed = () => destroyedReason !== undefined;
  this.destroyedReason = () => destroyedReason;
}
Connection.fromHash = _ref => {
  let id = _ref.id,
    creationTime = _ref.creationTime,
    data = _ref.data,
    capablities = _ref.capablities,
    permissions = _ref.permissions;
  return new Connection(id, creationTime, data, (0, _assign.default)(capablities || {}, {
    supportsWebRTC: true
  }), permissions || []);
};
var _default = Connection;
exports.default = _default;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof (typeof window !== undefined ? window : global) == 'object' && (typeof window !== undefined ? window : global) && (typeof window !== undefined ? window : global).Object === Object && (typeof window !== undefined ? window : global);

module.exports = freeGlobal;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(42);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    keys = __webpack_require__(34);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(395),
    isArguments = __webpack_require__(65),
    isArray = __webpack_require__(14),
    isBuffer = __webpack_require__(66),
    isIndex = __webpack_require__(67),
    isTypedArray = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(16);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(87)(module)))

/***/ }),
/* 196 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(123),
    getPrototype = __webpack_require__(124),
    getSymbols = __webpack_require__(122),
    stubArray = __webpack_require__(196);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(199),
    getSymbols = __webpack_require__(122),
    keys = __webpack_require__(34);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(123),
    isArray = __webpack_require__(14);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(199),
    getSymbolsIn = __webpack_require__(197),
    keysIn = __webpack_require__(55);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(42),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(42),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(16);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(125);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(89),
    getPrototype = __webpack_require__(124),
    isPrototype = __webpack_require__(69);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _eventHelper = _interopRequireDefault(__webpack_require__(58));
var _destroyObj = _interopRequireDefault(__webpack_require__(474));
var _patchSrcObject = _interopRequireDefault(__webpack_require__(475));
var _isDomElementVisible = _interopRequireDefault(__webpack_require__(476));
var _promiseDelay = _interopRequireDefault(__webpack_require__(95));
var _env = _interopRequireDefault(__webpack_require__(3));
var _noop = _interopRequireDefault(__webpack_require__(259));
var _deviceHelpers2 = _interopRequireDefault(__webpack_require__(22));
var _currentAudioOutputDevice = _interopRequireDefault(__webpack_require__(107));
var _audio_context = _interopRequireDefault(__webpack_require__(145));
var _webaudio_audio_level_sampler = _interopRequireDefault(__webpack_require__(146));
var _can_be_oriented_mixin = _interopRequireDefault(__webpack_require__(568));
var _listenForTracksEnded = _interopRequireDefault(__webpack_require__(589));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _videoElementErrorMap = _interopRequireDefault(__webpack_require__(273));
var _index = _interopRequireDefault(__webpack_require__(274));
var _mediaElementListeners = __webpack_require__(592);
/* eslint-disable no-self-assign */
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require, one-var */
/* eslint-disable no-cond-assign,  max-len, no-void, prefer-const */

const _deviceHelpers = (0, _deviceHelpers2.default)(),
  hasAudioOutputApiSupport = _deviceHelpers.hasAudioOutputApiSupport;
const getCurrentAudioOutputDeviceId = _currentAudioOutputDevice.default.getCurrentAudioOutputDeviceId;
function createDomVideoElement(fallbackText, muted) {
  const videoElement = (0, _index.default)();
  (0, _patchSrcObject.default)(videoElement);
  videoElement.innerHTML = fallbackText;
  if (muted === true) {
    videoElement.muted = 'true';
  }
  return videoElement;
}
function createDomAudioOnlyVideoElement() {
  const audioOnlyVideoElement = createDomVideoElement('');
  audioOnlyVideoElement.setAttribute('style', 'display:none');
  return audioOnlyVideoElement;
}

/**
 * NativeVideoElementWrapperFactory DI container
 *
 * @package
 * @param {any} [deps={}]
 */
function NativeVideoElementWrapperFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const audioContextProvider = deps.audioContext || (0, _audio_context.default)();
  const canBeOrientatedMixin = deps.canBeOrientatedMixin || _can_be_oriented_mixin.default;
  /** @type {Document} */
  const document = deps.document || (typeof window !== undefined ? window : global).document;
  const listenForTracksEnded = deps.listenForTracksEnded || (0, _listenForTracksEnded.default)();
  const createLog = deps.logging || _log.default;
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const videoElementErrorMap = deps.videoElementErrorMap || (0, _videoElementErrorMap.default)();
  const WebAudioLevelSampler = deps.WebaudioAudioLevelSampler || _webaudio_audio_level_sampler.default;
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  let id = 1;

  /**
   * NativeVideoElementWrapper
   *
   * @package
   * @class
   * @param {Object} options
   * @param {Object} [options._inject] injected variables @todo move to DI
   * @param {Function} [options._inject.createVideoElement] function used to create video element
   * @param {Function} [options._inject.createAudioOnlyVideoElement] function used to create audio only video element
   * @param {Boolean} [options.muted] initial mute state
   * @param {String} [options.fallbackText] text to display when not supported
   * @param {Function} errorHandler callback for when there are errors
   * @param {Number} defaultAudioVolume the initial audio volume
   */
  let NativeVideoElementWrapper = /*#__PURE__*/function () {
    /** @type {HTMLVideoElement|undefined} */

    /** @type {number|undefined} */

    function NativeVideoElementWrapper(_ref, defaultAudioVolume) {
      var _this = this;
      let _ref$_inject = _ref._inject,
        _ref$_inject2 = _ref$_inject === void 0 ? {} : _ref$_inject,
        _ref$_inject2$createV = _ref$_inject2.createVideoElement,
        _createVideoElement = _ref$_inject2$createV === void 0 ? createDomVideoElement : _ref$_inject2$createV,
        _ref$_inject2$createA = _ref$_inject2.createAudioOnlyVideoElement,
        _createAudioOnlyVideoElement = _ref$_inject2$createA === void 0 ? createDomAudioOnlyVideoElement : _ref$_inject2$createA,
        muted = _ref.muted,
        fallbackText = _ref.fallbackText,
        widgetType = _ref.widgetType;
      this._domElement = void 0;
      this._domAudioOnlyVideoElement = void 0;
      this._blockedVolume = void 0;
      this._mediaStoppedListener = void 0;
      this._audioLevelSampler = void 0;
      this._playInterrupts = 0;
      this._isVideoLoadedMetaData = false;
      this._audioOnlyVideoElementWatcher = void 0;
      this._blinkStartTime = null;
      this.logging = createLog(`NativeVideoElementWrapper:${id}`);
      id += 1;
      (0, _eventing.default)(this);
      this._defaultAudioVolume = defaultAudioVolume;
      this._widgetType = widgetType;
      this._emitVideoPlayAttempt = () => {
        this._blinkStartTime = new Date().getTime();
        this.trigger('bindEvent', 'transitionVideo', 'Attempt');
      };
      this._emitVideoPlaySuccess = () => {
        const attemptDuration = new Date().getTime() - this._blinkStartTime;
        this.trigger('bindEvent', 'transitionVideo', 'Success', {
          attemptDuration
        });
        this._blinkStartTime = null;
      };
      this._emitVideoPlayFailure = () => {
        this.trigger('bindEvent', 'transitionVideo', 'Failure');
      };
      let _videoElementMovedWarning = false;
      // / Private API

      // The video element pauses itself when it's reparented, this is
      // unfortunate. This function plays the video again and is triggered
      // on the pause event.
      const _playVideoOnPause = () => {
        if (!_videoElementMovedWarning) {
          this.logging.warn('Video element paused, auto-resuming. If you intended to do this, ' + 'use publishVideo(false) or subscribeToVideo(false) instead.');
          _videoElementMovedWarning = true;
        }
        this.play();
      };
      this._domElement = _createVideoElement(fallbackText, muted);
      this.trigger('videoElementCreated', this._domElement);
      this._domElementEvents = (0, _eventHelper.default)(this._domElement);
      this._domElementEvents.on('loadstart', () => this._onDomElementLoadStart());
      this._domElementEvents.on('timeupdate', function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _this.trigger('timeupdate', ...args);
      });
      this._domElementEvents.on('loadedmetadata', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _len2,
          args,
          _key2,
          hasSrcObject,
          _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this._isVideoLoadedMetaData = true;
              for (_len2 = _args.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = _args[_key2];
              }
              _this.trigger('loadedmetadata', ...args);

              // We can safely remove the audio only element since the video element
              // could trigger the loadedmetada, meaning it can start playing video.
              // For more info, see OPENTOK-41739.
              if (!_this._domAudioOnlyVideoElement) {
                _context.next = 10;
                break;
              }
              hasSrcObject = _this._domAudioOnlyVideoElement.srcObject;
              _this._removeAudioOnlyVideoElement();
              // We need to call play only if _domAudioOnlyVideoElement had
              // a srcObject, meaning it was used for audio.
              if (!hasSrcObject) {
                _context.next = 10;
                break;
              }
              _context.next = 9;
              return (0, _noop.default)();
            case 9:
              _this.play();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      const onError = event => {
        this.trigger('error', videoElementErrorMap(event.target.error));
      };
      this._domElementEvents.on('error', onError, false);
      this._domElementEvents.on('pause', _playVideoOnPause);
      this.on('destroyed', () => {
        this._domElementEvents.removeAll();
        if (this._domAudioOnlyVideoElementEvents) {
          this._domAudioOnlyVideoElementEvents.removeAll();
        }
      });
      canBeOrientatedMixin(this, () => this._domElement);

      // Safari subscribers needs special handling for audio-only video
      // https://bugs.webkit.org/show_bug.cgi?id=174152
      if (_env.default.isSafari && this._widgetType === 'subscriber') {
        this._domAudioOnlyVideoElement = _createAudioOnlyVideoElement();
        this._bindAudioOnlyVideoElementEvents();
      }

      // See VIDCS-3383
      // Adding some extra logging to investigate a difficult to reproduce audio issue
      if (_env.default != null && _env.default.isDev) {
        (0, _mediaElementListeners.addMediaElementListeners)(this._domAudioOnlyVideoElement || this._domElement, event => {
          this.trigger('mediaElementEvent', event);
        });
      }
    }
    var _proto = NativeVideoElementWrapper.prototype;
    _proto._onDomElementLoadStart = /*#__PURE__*/function () {
      var _onDomElementLoadStart2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this._widgetType === 'subscriber' && hasAudioOutputApiSupport())) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return this._setActiveAudioOutputDevice();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _onDomElementLoadStart() {
        return _onDomElementLoadStart2.apply(this, arguments);
      }
      return _onDomElementLoadStart;
    }();
    _proto._setActiveAudioOutputDevice = /*#__PURE__*/function () {
      var _setActiveAudioOutputDevice2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var deviceId;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              deviceId = getCurrentAudioOutputDeviceId();
              if (!(deviceId === '' || deviceId === 'default')) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return this.setSinkId(deviceId);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _setActiveAudioOutputDevice() {
        return _setActiveAudioOutputDevice2.apply(this, arguments);
      }
      return _setActiveAudioOutputDevice;
    }();
    _proto._rebindSrcObject = function _rebindSrcObject() {
      if (this._domElement) {
        this._domElement.srcObject = this._domElement.srcObject;
      }
    };
    _proto._pauseAndPlay = function _pauseAndPlay() {
      if (this._domElement) {
        this._domElement.pause();
        this._domElement.play();
      }
    };
    _proto._startAudioOnlyVideoElementWatcher = /*#__PURE__*/function () {
      var _startAudioOnlyVideoElementWatcher2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var watcherIntervalTimeout, shouldPlay;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // In Safari, after setting the srcObject the video element gets paused.
              // Calling play() is not sufficient to unpause it.
              // A workaround for this is to rebind when we detect that the video gets paused.
              // Notice that if it's iOS we need to call play() after the rebind, otherwise
              // it won't play.
              watcherIntervalTimeout = 1000;
              shouldPlay = _env.default.isiOS;
              if (this._audioOnlyVideoElementWatcher) {
                clearInterval(this._audioOnlyVideoElementWatcher);
              }
              this._audioOnlyVideoElementWatcher = setInterval(() => {
                if (this._domAudioOnlyVideoElement && this._domAudioOnlyVideoElement.paused) {
                  this._domAudioOnlyVideoElement.srcObject = this._domAudioOnlyVideoElement.srcObject;
                  if (shouldPlay) {
                    this._domAudioOnlyVideoElement.play();
                  }
                }
              }, 100);
              _context4.next = 6;
              return (0, _promiseDelay.default)(watcherIntervalTimeout);
            case 6:
              clearInterval(this._audioOnlyVideoElementWatcher);
              this._audioOnlyVideoElementWatcher = null;
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _startAudioOnlyVideoElementWatcher() {
        return _startAudioOnlyVideoElementWatcher2.apply(this, arguments);
      }
      return _startAudioOnlyVideoElementWatcher;
    }();
    _proto._removeAudioOnlyVideoElement = /*#__PURE__*/function () {
      var _removeAudioOnlyVideoElement2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this._domAudioOnlyVideoElement.srcObject = null;
              this._domAudioOnlyVideoElement.parentNode.removeChild(this._domAudioOnlyVideoElement);
              if (this._domAudioOnlyVideoElementEvents) {
                this._domAudioOnlyVideoElementEvents.removeAll();
              }
              this._domAudioOnlyVideoElement = null;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function _removeAudioOnlyVideoElement() {
        return _removeAudioOnlyVideoElement2.apply(this, arguments);
      }
      return _removeAudioOnlyVideoElement;
    }();
    _proto.requestVideoFrameCallback = function requestVideoFrameCallback(callback) {
      this._domElement.requestVideoFrameCallback(callback);
    };
    _proto.bindAudioTrackOnly = /*#__PURE__*/function () {
      var _bindAudioTrackOnly = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var videoTracks, audioTracks, _videoTracks$, videoTrack, _audioTracks$, audioTrack, isAudioOnlyVideo;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              videoTracks = this._stream.getVideoTracks();
              audioTracks = this._stream.getAudioTracks();
              _videoTracks$ = videoTracks[0], videoTrack = _videoTracks$ === void 0 ? {} : _videoTracks$;
              _audioTracks$ = audioTracks[0], audioTrack = _audioTracks$ === void 0 ? {} : _audioTracks$;
              _context6.next = 6;
              return (0, _noop.default)();
            case 6:
              isAudioOnlyVideo = !videoTrack.enabled && audioTrack.enabled;
              if (!this._isVideoLoadedMetaData && isAudioOnlyVideo && this._domAudioOnlyVideoElement) {
                this._domAudioOnlyVideoElement.srcObject = new windowMock.MediaStream(audioTracks);
                this._startAudioOnlyVideoElementWatcher();
              }
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function bindAudioTrackOnly() {
        return _bindAudioTrackOnly.apply(this, arguments);
      }
      return bindAudioTrackOnly;
    }();
    _proto._bindAudioOnlyVideoElementEvents = function _bindAudioOnlyVideoElementEvents() {
      var _this2 = this;
      this._domAudioOnlyVideoElementEvents = (0, _eventHelper.default)(this._domAudioOnlyVideoElement);

      // Safari may stop playing audio if the browser is not visible or losses
      // focus.  When it does, continue playing it.
      this._domAudioOnlyVideoElementEvents.on('pause', () => this.play());
      this._domAudioOnlyVideoElementEvents.on('timeupdate', function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        return _this2.trigger('timeupdate', ...args);
      });
      this._domAudioOnlyVideoElementEvents.on('loadedmetadata', function () {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        return _this2.trigger('loadedmetadata', ...args);
      });
    };
    _proto.whenTimeIncrements = function whenTimeIncrements(callback, context) {
      this.once('timeupdate', () => {
        callback.call(context, this);
      });
    }
    /**
     * Get the underlying DOM video element
     * @return {Element}
    */;
    _proto.domElement = function domElement() {
      return this._domElement;
    };
    _proto.videoWidth = function videoWidth() {
      return this._domElement ? Number(this._domElement[`video${this.isRotated() ? 'Height' : 'Width'}`]) : 0;
    };
    _proto.videoHeight = function videoHeight() {
      return this._domElement ? Number(this._domElement[`video${this.isRotated() ? 'Width' : 'Height'}`]) : 0;
    };
    _proto.aspectRatio = function aspectRatio() {
      return this.videoWidth() / this.videoHeight();
    };
    _proto.prepareForStreamTransition = function prepareForStreamTransition() {
      const streamImage = this._getStreamImage();
      this._domElement.poster = streamImage;
    };
    _proto._getStreamImage = function _getStreamImage() {
      const canvas = OTHelpers.createElement('canvas', {
        width: this.videoWidth(),
        height: this.videoHeight(),
        style: {
          display: 'none'
        }
      });
      document.body.appendChild(canvas);
      let imgData = null;
      try {
        canvas.getContext('2d').drawImage(this._domElement, 0, 0, canvas.width, canvas.height);
        imgData = canvas.toDataURL('image/png');
      } catch (err) {
        // Warning emitted for imgData === null below
      }
      OTHelpers.removeElement(canvas);
      if (imgData === null || imgData === 'data:,') {
        // 'data:,' is sometimes returned by canvas.toDataURL when one cannot be
        // generated.
        this.logging.warn('Cannot get image data yet');
        return null;
      }
      return imgData;
    };
    _proto.imgData = function imgData() {
      return this._getStreamImage().replace('data:image/png;base64,', '').trim();
    }
    // Append the Video DOM element to a parent node
    ;
    _proto.appendTo = function appendTo(parentDomElement) {
      parentDomElement.appendChild(this._domElement);
      if (this._domAudioOnlyVideoElement) {
        parentDomElement.appendChild(this._domAudioOnlyVideoElement);
      }
      return this;
    };
    _proto.isAudioBlocked = function isAudioBlocked() {
      return this._blockedVolume !== undefined;
    };
    _proto.unblockAudio = /*#__PURE__*/function () {
      var _unblockAudio = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var blockedVolume;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this.isAudioBlocked()) {
                _context7.next = 3;
                break;
              }
              this.logging.warn('Unexpected call to unblockAudio() without blocked audio');
              return _context7.abrupt("return");
            case 3:
              blockedVolume = this._blockedVolume;
              this._blockedVolume = undefined;
              this.setAudioVolume(blockedVolume);
              _context7.prev = 6;
              _context7.next = 9;
              return this.play();
            case 9:
              _context7.next = 16;
              break;
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](6);
              this._blockedVolume = blockedVolume;
              this._domElement.muted = true;
              throw _context7.t0;
            case 16:
              this.trigger('audioUnblocked');
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[6, 11]]);
      }));
      function unblockAudio() {
        return _unblockAudio.apply(this, arguments);
      }
      return unblockAudio;
    }() // useful for some browsers (old chrome) that show black when a peer connection
    // is renegotiated
    ;
    _proto.rebind =
    /*#__PURE__*/
    function () {
      var _rebind = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (this._domElement) {
                _context8.next = 2;
                break;
              }
              throw new Error('Can\'t rebind because _domElement no longer exists');
            case 2:
              this._playInterrupts++;
              this._domElement.srcObject = this._domElement.srcObject;
              if (this._hasAudioOnlyVideoElement()) {
                this._domAudioOnlyVideoElement.srcObject = this._domAudioOnlyVideoElement.srcObject;
              }
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function rebind() {
        return _rebind.apply(this, arguments);
      }
      return rebind;
    }();
    _proto._createAudioLevelSampler = function _createAudioLevelSampler() {
      this._removeAudioLevelSampler();
      if (this._stream.getAudioTracks().length > 0) {
        try {
          this._audioContext = audioContextProvider();
        } catch (e) {
          this.logging.warn('Failed to get AudioContext(), audio level visualisation will not work', e);
        }
        if (this._audioContext) {
          this._audioLevelSampler = new WebAudioLevelSampler(this._audioContext);
          this._audioLevelSampler.webRTCStream(this._stream);
        }
      }
    };
    _proto._removeAudioLevelSampler = function _removeAudioLevelSampler() {
      if (this._audioContext) {
        delete this._audioContext;
        delete this._audioLevelSampler;
      }
    }
    // For MediaStreams with multiple tracks, video tracks are disabled and
    // then re-enabled
    ;
    _proto._toggleVideoTracks =
    /*#__PURE__*/
    function () {
      var _toggleVideoTracks2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        var enabledTracks, hasMultipleTracks, videoTracks;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              enabledTracks = this._domElement.srcObject.getTracks().filter(track => track.enabled);
              hasMultipleTracks = enabledTracks.length > 1;
              if (!hasMultipleTracks) {
                _context9.next = 8;
                break;
              }
              videoTracks = enabledTracks.filter(track => track.kind === 'video');
              videoTracks.forEach(track => {
                track.enabled = false;
              });
              _context9.next = 7;
              return (0, _noop.default)();
            case 7:
              videoTracks.forEach(track => {
                track.enabled = true;
              });
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function _toggleVideoTracks() {
        return _toggleVideoTracks2.apply(this, arguments);
      }
      return _toggleVideoTracks;
    }();
    _proto._hasAudioOnlyVideoElement = function _hasAudioOnlyVideoElement() {
      return this._domAudioOnlyVideoElement && this._domAudioOnlyVideoElement.srcObject;
    };
    _proto.play = /*#__PURE__*/function () {
      var _play = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
        var playInterruptsOnStart, domElement, isBuggediOS, _this$_stream$getVide, _this$_stream$getVide2, videoTrack, _this$_stream$getAudi, _this$_stream$getAudi2, audioTrack, _ref3, errorName, isAbortError;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              playInterruptsOnStart = this._playInterrupts; // Which element do we try to play?  The `audio` or `video` element?
              domElement = this._hasAudioOnlyVideoElement() ? this._domAudioOnlyVideoElement : this._domElement; // In Safari, if a HTMLMediaElement property is mutated or if the element is moved,
              // a delay is needed else element may fail to play
              if (!_env.default.isSafari) {
                _context10.next = 5;
                break;
              }
              _context10.next = 5;
              return (0, _noop.default)();
            case 5:
              if (!(_env.default.isiOS && _env.default.isSafari)) {
                _context10.next = 15;
                break;
              }
              if (!(this._widgetType === 'publisher')) {
                _context10.next = 14;
                break;
              }
              isBuggediOS = _env.default.iOSVersion >= 14 && _env.default.iOSVersion <= 14.2;
              _this$_stream$getVide = this._stream.getVideoTracks(), _this$_stream$getVide2 = _this$_stream$getVide[0], videoTrack = _this$_stream$getVide2 === void 0 ? {} : _this$_stream$getVide2;
              _this$_stream$getAudi = this._stream.getAudioTracks(), _this$_stream$getAudi2 = _this$_stream$getAudi[0], audioTrack = _this$_stream$getAudi2 === void 0 ? {} : _this$_stream$getAudi2;
              /**
               * OPENTOK-41742: Prevent to call play() on a hidden video element. Otherwise the
               * readyState of the MediaStreamTrack will be ended and the publisher will stop
               * publishing video.
               * This issue happens only on iOS Safari >= 14.0 and <= 14.2
               * */
              if (!(isBuggediOS && !(0, _isDomElementVisible.default)(domElement) && videoTrack.enabled)) {
                _context10.next = 12;
                break;
              }
              return _context10.abrupt("return");
            case 12:
              if (!audioTrack.muted) {
                _context10.next = 14;
                break;
              }
              return _context10.abrupt("return");
            case 14:
              // OPENTOK-39347: Toggle video tracks, else audio maybe garbled
              this._toggleVideoTracks();
            case 15:
              _context10.prev = 15;
              // We want to measure the duration of the blink: OPENTOK-46931
              this._emitVideoPlayAttempt();
              _context10.next = 19;
              return domElement.play();
            case 19:
              this._emitVideoPlaySuccess();
              return _context10.abrupt("return");
            case 23:
              _context10.prev = 23;
              _context10.t0 = _context10["catch"](15);
              this._emitVideoPlayFailure();
              _ref3 = _context10.t0 || {}, errorName = _ref3.name;
              isAbortError = errorName === 'AbortError'; // Play request was interrupted
              if (isAbortError) {
                this._playInterrupts++;
              }
              if (!(this._playInterrupts > playInterruptsOnStart)) {
                _context10.next = 33;
                break;
              }
              _context10.next = 32;
              return this.play();
            case 32:
              return _context10.abrupt("return");
            case 33:
              throw _context10.t0;
            case 34:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[15, 23]]);
      }));
      function play() {
        return _play.apply(this, arguments);
      }
      return play;
    }();
    _proto._bindToStream = function _bindToStream(webRtcStream) {
      this._stream = webRtcStream;
      this._domElement.srcObject = webRtcStream;

      // Audio-only video won't play in Safari since the browser won't dispatch
      // the `loadedmetadata` event (since the video has unknown dimensions)
      // https://bugs.webkit.org/show_bug.cgi?id=174152
      if (this._domAudioOnlyVideoElement) {
        this.bindAudioTrackOnly();
      }
    };
    _proto.bindToStream = /*#__PURE__*/function () {
      var _bindToStream2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(webRtcStream) {
        var _this3 = this;
        var currentVideoSize, onAllEnded, onSingleEnded;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (this._domElement) {
                _context12.next = 2;
                break;
              }
              throw new Error('Can\'t bind because _domElement no longer exists');
            case 2:
              this._bindToStream(webRtcStream);
              (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
                var hasAudio;
                return _regenerator.default.wrap(function _callee11$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      _context11.prev = 0;
                      _context11.next = 3;
                      return _this3.play();
                    case 3:
                      _context11.next = 26;
                      break;
                    case 5:
                      _context11.prev = 5;
                      _context11.t0 = _context11["catch"](0);
                      hasAudio = !!webRtcStream.getAudioTracks().length;
                      if (!(_this3._hasAudioOnlyVideoElement() && _context11.t0.name === 'NotAllowedError')) {
                        _context11.next = 15;
                        break;
                      }
                      // Audio-only video failed to play.  Mute audio and try again.
                      _this3._domAudioOnlyVideoElement.muted = true;
                      _context11.next = 12;
                      return _this3.play();
                    case 12:
                      // Now that audio-only stream is playing, unmute it.
                      _this3._domAudioOnlyVideoElement.muted = false;
                      _context11.next = 26;
                      break;
                    case 15:
                      if (!hasAudio) {
                        _context11.next = 23;
                        break;
                      }
                      // Media (with audio) failed to play.  Mute audio and try again.
                      _this3._blockedVolume = _this3.getAudioVolume();
                      _this3._domElement.muted = true;
                      _context11.next = 20;
                      return _this3.play();
                    case 20:
                      _this3.trigger('audioBlocked');
                      _context11.next = 26;
                      break;
                    case 23:
                      // Media failed to play.  Mute audio, even though there's no audio
                      // track (e.g., a screenshare), and try again.
                      _this3._domElement.muted = true;
                      _context11.next = 26;
                      return _this3.play();
                    case 26:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11, null, [[0, 5]]);
              }))().catch(err => {
                this.logging.debug('.play() failed: ', err);
              });
              currentVideoSize = {
                width: this._domElement.videoWidth,
                height: this._domElement.videoHeight
              };
              this.trigger('videoDimensionsChanged', Object.assign({}, currentVideoSize), Object.assign({}, currentVideoSize));
              this._domElementEvents.on('resize', () => {
                const _this$_domElement = this._domElement,
                  width = _this$_domElement.videoWidth,
                  height = _this$_domElement.videoHeight;
                const widthChanged = width !== currentVideoSize.width;
                const heightChanged = height !== currentVideoSize.height;
                if (widthChanged || heightChanged) {
                  this.trigger('videoDimensionsChanged', Object.assign({}, currentVideoSize), {
                    width,
                    height
                  });
                  currentVideoSize.width = width;
                  currentVideoSize.height = height;
                }
              });
              onAllEnded = () => {
                try {
                  // This callback may outlive the reference to this object.  If so,
                  // then an exception will be thrown.
                  this._mediaStoppedListener.stop();
                } catch (err) {
                  // Bail, since this object was likely destroyed already and executing
                  // the rest of the code will generate exceptions as well.
                  return;
                }
                if (this._domElement) {
                  this._domElement.onended = null;
                }
                this.trigger('mediaStopped');
              };
              onSingleEnded = track => {
                this.trigger('mediaStopped', track);
              };
              this._domElement.onended = () => onAllEnded();
              this._mediaStoppedListener = listenForTracksEnded(webRtcStream, onAllEnded, onSingleEnded);
              this._createAudioLevelSampler();
              return _context12.abrupt("return", undefined);
            case 13:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function bindToStream(_x) {
        return _bindToStream2.apply(this, arguments);
      }
      return bindToStream;
    }() // Unbind the currently bound stream from the video element.
    ;
    _proto.unbindStream = function unbindStream() {
      if (this._domElement) {
        this._domElement.srcObject = null;
      }
      if (this._domAudioOnlyVideoElement) {
        this._domAudioOnlyVideoElement.srcObject = null;
      }
      this._removeAudioLevelSampler();
      return this;
    };
    _proto.setAudioVolume = function setAudioVolume(rawValue) {
      if (this.isAudioBlocked()) {
        this._blockedVolume = rawValue;
        return;
      }
      const value = parseFloat(rawValue) / 100;
      const domElements = [this.domElement()];
      if (this._domAudioOnlyVideoElement) {
        domElements.push(this._domAudioOnlyVideoElement);
      }
      domElements.forEach(domElement => {
        if (domElement) {
          domElement.volume = value;
          // In Safari on iOS setting the volume does not work but setting muted does so at
          // least this will mute when you click the mute icon
          // https://bugs.webkit.org/show_bug.cgi?id=176045
          domElement.muted = value === 0;
        }
      });
    };
    _proto.getAudioVolume = function getAudioVolume() {
      if (this.isAudioBlocked()) {
        return this._blockedVolume;
      }

      // Return the actual volume of the DOM element
      const domElement = this.domElement();
      if (domElement) {
        return domElement.muted ? 0 : domElement.volume * 100;
      }
      return this._defaultAudioVolume;
    }
    // see https://wiki.mozilla.org/WebAPI/AudioChannels
    // The audioChannelType is currently only available in Firefox. This property returns
    // "unknown" in other browser. The related HTML tag attribute is "mozaudiochannel"
    ;
    _proto.audioChannelType = function audioChannelType(type) {
      const domElement = this.domElement();
      if (type !== void 0) {
        domElement.mozAudioChannelType = type;
      }
      if ('mozAudioChannelType' in this._domElement) {
        return domElement.mozAudioChannelType;
      }
      return 'unknown';
    };
    _proto.getAudioInputLevel = function getAudioInputLevel() {
      return this._audioLevelSampler.sample();
    };
    _proto.refreshTracks = function refreshTracks() {
      if (this._mediaStoppedListener) {
        this._mediaStoppedListener.refresh();
      }
      this._createAudioLevelSampler();
    };
    _proto.destroy = function destroy() {
      // Unbind events first, otherwise 'pause' will trigger when the
      // video element is removed from the DOM.
      if (this._mediaStoppedListener) {
        this._mediaStoppedListener.stop();
      }
      this.logging.debug('removing domElementEvents');
      this._domElementEvents.removeAll();
      if (this._domAudioOnlyVideoElementEvents) {
        this._domAudioOnlyVideoElementEvents.removeAll();
      }

      // See VIDCS-3383
      if (_env.default != null && _env.default.isDev) {
        (0, _mediaElementListeners.removeMediaElementListeners)(this._domAudioOnlyVideoElement || this._domElement);
      }
      if (this._audioOnlyVideoElementWatcher) {
        clearInterval(this._audioOnlyVideoElementWatcher);
      }
      this.unbindStream();
      if (this._domElement) {
        OTHelpers.removeElement(this._domElement);
        this._domElement = null;
      }
      if (this._domAudioOnlyVideoElement) {
        OTHelpers.removeElement(this._domAudioOnlyVideoElement);
        this._domAudioOnlyVideoElement = null;
      }
      this.trigger('destroyed');
      (0, _destroyObj.default)('NativeVideoElementWrapper', this);
      return void 0;
    };
    _proto.setSinkId = function setSinkId(deviceId) {
      const videoElements = [this._domElement, this._domAudioOnlyVideoElement];
      const setSinkIdPromises = videoElements.map(videoElement => {
        if (!videoElement) {
          return undefined;
        }
        return videoElement.setSinkId(deviceId);
      });
      return Promise.all(setSinkIdPromises);
    };
    return NativeVideoElementWrapper;
  }();
  return NativeVideoElementWrapper;
}
var _default = NativeVideoElementWrapperFactory;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(90),
    isIterateeCall = __webpack_require__(128);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(126);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(425)() ? WeakMap : __webpack_require__(426);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = Object.create, getPrototypeOf = Object.getPrototypeOf, plainObject = {};

module.exports = function (/* CustomCreate*/) {
	var setPrototypeOf = Object.setPrototypeOf, customCreate = arguments[0] || create;
	if (typeof setPrototypeOf !== "function") return false;
	return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint no-proto: "off" */

// Big thanks to @WebReflection for sorting this out
// https://gist.github.com/WebReflection/5593554



var isObject         = __webpack_require__(213)
  , value            = __webpack_require__(35)
  , objIsPrototypeOf = Object.prototype.isPrototypeOf
  , defineProperty   = Object.defineProperty
  , nullDesc         = { configurable: true, enumerable: false, writable: true, value: undefined }
  , validate;

validate = function (obj, prototype) {
	value(obj);
	if (prototype === null || isObject(prototype)) return obj;
	throw new TypeError("Prototype must be null or an object");
};

module.exports = (function (status) {
	var fn, set;
	if (!status) return null;
	if (status.level === 2) {
		if (status.set) {
			set = status.set;
			fn = function (obj, prototype) {
				set.call(validate(obj, prototype), prototype);
				return obj;
			};
		} else {
			fn = function (obj, prototype) {
				validate(obj, prototype).__proto__ = prototype;
				return obj;
			};
		}
	} else {
		fn = function self(obj, prototype) {
			var isNullBase;
			validate(obj, prototype);
			isNullBase = objIsPrototypeOf.call(self.nullPolyfill, obj);
			if (isNullBase) delete self.nullPolyfill.__proto__;
			if (prototype === null) prototype = self.nullPolyfill;
			obj.__proto__ = prototype;
			if (isNullBase) defineProperty(self.nullPolyfill, "__proto__", nullDesc);
			return obj;
		};
	}
	return Object.defineProperty(fn, "level", {
		configurable: false,
		enumerable: false,
		writable: false,
		value: status.level
	});
})(
	(function () {
		var tmpObj1 = Object.create(null)
		  , tmpObj2 = {}
		  , set
		  , desc = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");

		if (desc) {
			try {
				set = desc.set; // Opera crashes at this point
				set.call(tmpObj1, tmpObj2);
			} catch (ignore) {}
			if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { set: set, level: 2 };
		}

		tmpObj1.__proto__ = tmpObj2;
		if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 2 };

		tmpObj1 = {};
		tmpObj1.__proto__ = tmpObj2;
		if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 1 };

		return false;
	})()
);

__webpack_require__(428);


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(46);

var map = { function: true, object: true };

module.exports = function (value) { return (isValue(value) && map[typeof value]) || false; };


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(431);

var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;

module.exports = function (value) {
	if (!isFunction(value)) return false;
	if (classRe.test(functionToString.call(value))) return false;
	return true;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(46);

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
module.exports = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(438)() ? String.prototype.contains : __webpack_require__(439);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArguments    = __webpack_require__(92)
  , isString       = __webpack_require__(93)
  , ArrayIterator  = __webpack_require__(440)
  , StringIterator = __webpack_require__(469)
  , iterable       = __webpack_require__(470)
  , iteratorSymbol = __webpack_require__(47).iterator;

module.exports = function (obj) {
	if (typeof iterable(obj)[iteratorSymbol] === "function") return obj[iteratorSymbol]();
	if (isArguments(obj)) return new ArrayIterator(obj);
	if (isString(obj)) return new StringIterator(obj);
	return new ArrayIterator(obj);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isSymbol = __webpack_require__(445);

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var clear    = __webpack_require__(449)
  , assign   = __webpack_require__(133)
  , callable = __webpack_require__(70)
  , value    = __webpack_require__(35)
  , d        = __webpack_require__(36)
  , autoBind = __webpack_require__(450)
  , Symbol   = __webpack_require__(47);

var defineProperty = Object.defineProperty, defineProperties = Object.defineProperties, Iterator;

module.exports = Iterator = function (list, context) {
	if (!(this instanceof Iterator)) throw new TypeError("Constructor requires 'new'");
	defineProperties(this, {
		__list__: d("w", value(list)),
		__context__: d("w", context),
		__nextIndex__: d("w", 0)
	});
	if (!context) return;
	callable(context.on);
	context.on("_add", this._onAdd);
	context.on("_delete", this._onDelete);
	context.on("_clear", this._onClear);
};

// Internal %IteratorPrototype% doesn't expose its constructor
delete Iterator.prototype.constructor;

defineProperties(
	Iterator.prototype,
	assign(
		{
			_next: d(function () {
				var i;
				if (!this.__list__) return undefined;
				if (this.__redo__) {
					i = this.__redo__.shift();
					if (i !== undefined) return i;
				}
				if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
				this._unBind();
				return undefined;
			}),
			next: d(function () {
				return this._createResult(this._next());
			}),
			_createResult: d(function (i) {
				if (i === undefined) return { done: true, value: undefined };
				return { done: false, value: this._resolve(i) };
			}),
			_resolve: d(function (i) {
				return this.__list__[i];
			}),
			_unBind: d(function () {
				this.__list__ = null;
				delete this.__redo__;
				if (!this.__context__) return;
				this.__context__.off("_add", this._onAdd);
				this.__context__.off("_delete", this._onDelete);
				this.__context__.off("_clear", this._onClear);
				this.__context__ = null;
			}),
			toString: d(function () {
				return "[object " + (this[Symbol.toStringTag] || "Object") + "]";
			})
		},
		autoBind({
			_onAdd: d(function (index) {
				if (index >= this.__nextIndex__) return;
				++this.__nextIndex__;
				if (!this.__redo__) {
					defineProperty(this, "__redo__", d("c", [index]));
					return;
				}
				this.__redo__.forEach(function (redo, i) {
					if (redo >= index) this.__redo__[i] = ++redo;
				}, this);
				this.__redo__.push(index);
			}),
			_onDelete: d(function (index) {
				var i;
				if (index >= this.__nextIndex__) return;
				--this.__nextIndex__;
				if (!this.__redo__) return;
				i = this.__redo__.indexOf(index);
				if (i !== -1) this.__redo__.splice(i, 1);
				this.__redo__.forEach(function (redo, j) {
					if (redo > index) this.__redo__[j] = --redo;
				}, this);
			}),
			_onClear: d(function () {
				if (this.__redo__) clear.call(this.__redo__);
				this.__nextIndex__ = 0;
			})
		})
	)
);

defineProperty(
	Iterator.prototype,
	Symbol.iterator,
	d(function () {
		return this;
	})
);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue       = __webpack_require__(57)
  , isObject      = __webpack_require__(132)
  , stringCoerce  = __webpack_require__(452)
  , toShortString = __webpack_require__(453);

var resolveMessage = function (message, value) {
	return message.replace("%v", toShortString(value));
};

module.exports = function (value, defaultMessage, inputOptions) {
	if (!isObject(inputOptions)) throw new TypeError(resolveMessage(defaultMessage, value));
	if (!isValue(value)) {
		if ("default" in inputOptions) return inputOptions["default"];
		if (inputOptions.isOptional) return null;
	}
	var errorMessage = stringCoerce(inputOptions.errorMessage);
	if (!isValue(errorMessage)) errorMessage = defaultMessage;
	throw new TypeError(resolveMessage(errorMessage, value));
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(480);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var AxiosURLSearchParams = __webpack_require__(224);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var hashmarkIndex = url.indexOf('#');

  if (hashmarkIndex !== -1) {
    url = url.slice(0, hashmarkIndex);
  }

  var _encode = options && options.encode || encode;

  var serializeFn = options && options.serialize;

  var serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toFormData = __webpack_require__(96);

function encode(str) {
  var charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

var prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  var _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

module.exports = AxiosURLSearchParams;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(482)
var ieee754 = __webpack_require__(483)
var isArray = __webpack_require__(484)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = (typeof window !== undefined ? window : global).TYPED_ARRAY_SUPPORT !== undefined
  ? (typeof window !== undefined ? window : global).TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

function arrayToObject(arr) {
  var obj = {};
  var keys = Object.keys(arr);
  var i;
  var len = keys.length;
  var key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    var name = path[index++];

    if (name === '__proto__') return true;

    var isNumericKey = Number.isFinite(+name);
    var isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProperty(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    var result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    var obj = {};

    utils.forEachEntry(formData, function(name, value) {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

module.exports = formDataToJSON;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var utils = __webpack_require__(13);
var settle = __webpack_require__(494);
var cookies = __webpack_require__(495);
var buildURL = __webpack_require__(223);
var buildFullPath = __webpack_require__(230);
var parseHeaders = __webpack_require__(498);
var isURLSameOrigin = __webpack_require__(499);
var transitionalDefaults = __webpack_require__(227);
var AxiosError = __webpack_require__(49);
var CanceledError = __webpack_require__(97);
var parseProtocol = __webpack_require__(500);
var platform = __webpack_require__(135);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var withXSRFToken = config.withXSRFToken;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        var xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
        if (xsrfValue) {
          requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    // false, 0 (zero number), and '' (empty string) are valid JSON values
    if (!requestData && requestData !== false && requestData !== 0 && requestData !== '') {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(496);
var combineURLs = __webpack_require__(497);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @param {boolean} allowAbsoluteUrls Set to true to allow absolute URLs
 *
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  var isRelativeURL = !isAbsoluteURL(requestedURL);
  if (baseURL && (isRelativeURL || allowAbsoluteUrls === false)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isEmptyObject(source)) {
      return utils.merge({}, target);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'withXSRFToken': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = {
  "version": "0.30.0"
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(506),
    util = __webpack_require__(508);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(91),
    metaMap = __webpack_require__(236);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(202);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(238),
    composeArgsRight = __webpack_require__(239),
    countHolders = __webpack_require__(512),
    createCtor = __webpack_require__(98),
    createRecurry = __webpack_require__(240),
    getHolder = __webpack_require__(247),
    reorder = __webpack_require__(524),
    replaceHolders = __webpack_require__(140),
    root = __webpack_require__(16);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(513),
    setData = __webpack_require__(244),
    setWrapToString = __webpack_require__(245);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(236),
    noop = __webpack_require__(242);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(89),
    baseLodash = __webpack_require__(139);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(235),
    shortOut = __webpack_require__(209);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(518),
    insertWrapDetails = __webpack_require__(519),
    setToString = __webpack_require__(127),
    updateWrapDetails = __webpack_require__(520);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(528),
    isObject = __webpack_require__(11),
    isSymbol = __webpack_require__(71);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(101),
    arraySome = __webpack_require__(250),
    cacheHas = __webpack_require__(102);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(543);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(545),
    hasPath = __webpack_require__(546);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(123),
    isFlattenable = __webpack_require__(552);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(555);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(560);
var util = __webpack_require__(561);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(562);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

exports.__esModule = true;
exports.default = noop;
function noop() {
  return new Promise(resolve => setTimeout(resolve));
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getNativeEnumerateDevicesFactory;
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require */

function getNativeEnumerateDevicesFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  return function getNativeEnumerateDevices() {
    if (windowMock.navigator.mediaDevices) {
      const mediaDevices = windowMock.navigator.mediaDevices;
      return mediaDevices.enumerateDevices && mediaDevices.enumerateDevices.bind(mediaDevices);
    }

    // @todo perhaps we should throw here?
    return undefined;
  };
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
let currentAudioInputDevice = '';
const setCurrentAudioInputDevice = newDevice => {
  currentAudioInputDevice = newDevice;
};
const getCurrentAudioInputDevice = () => currentAudioInputDevice;
var _default = {
  getCurrentAudioInputDevice,
  setCurrentAudioInputDevice
};
exports.default = _default;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _index = _interopRequireDefault(__webpack_require__(263));
const shortHandSelector = (selector, context) => new _index.default(selector, context);
var _default = shortHandSelector;
exports.default = _default;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isFunction = _interopRequireDefault(__webpack_require__(20));
var _attributes = _interopRequireDefault(__webpack_require__(569));
var _css = _interopRequireDefault(__webpack_require__(570));
var _classNames = _interopRequireDefault(__webpack_require__(571));
var _observers = _interopRequireDefault(__webpack_require__(573));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable global-require, no-param-reassign,  no-void */
/* eslint-disable prefer-rest-params, prefer-const */

const extensions = {
  attributes: _attributes.default,
  css: _css.default,
  classNames: _classNames.default,
  observers: _observers.default
};
const idRegex = /^#([\w-]*)$/;

// A helper for converting a NodeList to a JS Array
const nodeListToArray = function nodeListToArray(nodes) {
  return Array.prototype.slice.call(nodes);
};
const selectorToElementArray = function selectorToElementArray(selector, context) {
  let elements;
  if (typeof selector === 'undefined') {
    return [];
  }
  if (typeof selector === 'string') {
    elements = [];
    const idSelector = idRegex.exec(selector);
    context = context || document;
    if (idSelector && idSelector[1]) {
      const element = context.getElementById(idSelector[1]);
      if (element) {
        elements.push(element);
      }
    } else {
      elements = context.querySelectorAll(selector);
    }
  } else if (selector && (selector.nodeType || (typeof window !== undefined ? window : global).XMLHttpRequest && selector instanceof (typeof window !== undefined ? window : global).XMLHttpRequest || selector === (typeof window !== undefined ? window : global))) {
    // allow OTHelpers(DOMNode) and OTHelpers(xmlHttpRequest)
    elements = [selector];
    context = selector;
  } else if (Array.isArray(selector)) {
    elements = selector.slice();
    context = null;
  } else {
    elements = nodeListToArray(elements);
  }
  return elements;
};

// ElementCollection contains the result of calling OTHelpers.
//
// It has the following properties:
//   length
//   first
//   last
//
// It also has a get method that can be used to access elements in the collection
//
//   var videos = OTHelpers('video');
//   var firstElement = videos.get(0);               // identical to videos.first
//   var lastElement = videos.get(videos.length-1);  // identical to videos.last
//   var allVideos = videos.get();
//
//
// The collection also implements the following helper methods:
//   some, forEach, map, filter, find,
//   appendTo, after, before, remove, empty,
//   attr, center, width, height,
//   addClass, removeClass, hasClass, toggleClass,
//   on, off, once,
//   observeStyleChanges, observeNodeOrChildNodeRemoval
//
// Mostly the usage should be obvious. When in doubt, assume it functions like
// the jQuery equivalent.
//
const ElementCollection = function ElementCollection(selector, context) {
  const elements = selectorToElementArray(selector, context);
  this.context = context;
  this.toArray = function () {
    return elements;
  };
  this.length = elements.length;
  this.first = elements[0];
  this.last = elements[elements.length - 1];
  this.get = function (index) {
    if (index === void 0) {
      return elements;
    }
    return elements[index];
  };
};
ElementCollection._attachToOTHelpers = {};

// @remove
ElementCollection._attachToOTHelpers.removeElement = function (element) {
  return new ElementCollection(element).remove();
};
ElementCollection.prototype.getAsArray = function () {
  let _collection = this.get();
  if (!(0, _isFunction.default)(_collection.forEach)) {
    // It's possibly something Array-ish that isn't quite an
    // Array. Something like arguments or a NodeList
    _collection = nodeListToArray(_collection);
  }
  return _collection;
};
ElementCollection.prototype.some = function (iter, context) {
  return this.getAsArray().some(iter, context);
};
ElementCollection.prototype.forEach = function (fn, context) {
  this.getAsArray().forEach(fn, context);
  return this;
};
ElementCollection.prototype.map = function (fn, context) {
  return new ElementCollection(this.getAsArray().map(fn, context), this.context);
};
ElementCollection.prototype.filter = function (fn, context) {
  return new ElementCollection(this.getAsArray().filter(fn, context), this.context);
};
ElementCollection.prototype.find = function (selector) {
  return new ElementCollection(selector, this.first);
};

// Helper function for adding event listeners to dom elements.
// WARNING: This doesn't preserve event types, your handler could
// be getting all kinds of different parameters depending on the browser.
// You also may have different scopes depending on the browser and bubbling
// and cancelable are not supported.
ElementCollection.prototype.on = function (eventName, handler) {
  return this.forEach(element => {
    element.addEventListener(eventName, handler, false);
  });
};

// Helper function for removing event listeners from dom elements.
ElementCollection.prototype.off = function (eventName, handler) {
  return this.forEach(element => {
    element.removeEventListener(eventName, handler, false);
  });
};
ElementCollection.prototype.once = function (eventName, handler) {
  const removeAfterTrigger = function () {
    this.off(eventName, removeAfterTrigger);
    handler(...arguments);
  }.bind(this);
  return this.on(eventName, removeAfterTrigger);
};
ElementCollection.prototype.appendTo = function (parentElement) {
  if (!parentElement) {
    throw new Error('appendTo requires a DOMElement to append to.');
  }
  return this.forEach(child => {
    parentElement.appendChild(child);
  });
};
ElementCollection.prototype.append = function () {
  const parentElement = this.first;
  if (!parentElement) {
    return this;
  }
  Array.prototype.forEach.call(arguments, child => {
    parentElement.appendChild(child);
  });
  return this;
};
ElementCollection.prototype.prepend = function () {
  if (arguments.length === 0) {
    return this;
  }
  const parentElement = this.first;
  let elementsToPrepend;
  if (!parentElement) {
    return this;
  }
  elementsToPrepend = Array.prototype.slice.call(arguments);
  if (!parentElement.firstElementChild) {
    parentElement.appendChild(elementsToPrepend.shift());
  }
  elementsToPrepend.forEach(element => {
    parentElement.insertBefore(element, parentElement.firstElementChild);
  });
  return this;
};
ElementCollection.prototype.after = function (prevElement) {
  if (!prevElement) {
    throw new Error('after requires a DOMElement to insert after');
  }
  return this.forEach(element => {
    if (element.parentElement) {
      if (prevElement !== element.parentNode.lastChild) {
        element.parentElement.insertBefore(element, prevElement);
      } else {
        element.parentElement.appendChild(element);
      }
    }
  });
};
ElementCollection.prototype.before = function (nextElement) {
  if (!nextElement) {
    throw new Error('before requires a DOMElement to insert before');
  }
  return this.forEach(element => {
    if (element.parentElement) {
      element.parentElement.insertBefore(element, nextElement);
    }
  });
};
ElementCollection.prototype.remove = function () {
  return this.forEach(element => {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  });
};
ElementCollection.prototype.empty = function () {
  return this.forEach(element => {
    // elements is a "live" NodesList collection. Meaning that the collection
    // itself will be mutated as we remove elements from the DOM. This means
    // that "while there are still elements" is safer than "iterate over each
    // element" as the collection length and the elements indices will be modified
    // with each iteration.
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  });
};

// Detects when an element is not part of the document flow because
// it or one of it's ancestors has display:none.
ElementCollection.prototype.isDisplayNone = function () {
  return this.some(element => {
    if (((element == null ? void 0 : element.offsetWidth) === 0 || (element == null ? void 0 : element.offsetHeight) === 0) && new ElementCollection(element).css('display') === 'none') {
      return true;
    }
    if (element != null && element.parentNode && element != null && element.parentNode.style) {
      return new ElementCollection(element.parentNode).isDisplayNone();
    }
    return false;
  });
};
const findElementWithDisplayNone = function findElementWithDisplayNone(element) {
  if ((element.offsetWidth === 0 || element.offsetHeight === 0) && new ElementCollection(element).css('display') === 'none') {
    return element;
  }
  if (element.parentNode && element.parentNode.style) {
    return findElementWithDisplayNone(element.parentNode);
  }
  return null;
};

// @remove
ElementCollection._attachToOTHelpers.emptyElement = function (element) {
  return new ElementCollection(element).empty();
};
ElementCollection._attachToOTHelpers._findElementWithDisplayNone = findElementWithDisplayNone;
extensions.css(ElementCollection, findElementWithDisplayNone);
extensions.attributes(ElementCollection);
extensions.classNames(ElementCollection);
extensions.observers(ElementCollection);

// TODO: Deprecation logging?
// @remove
['on', 'off', 'isDisplayNone', 'show', 'hide', 'css', 'makeVisibleAndYield', 'addClass', 'removeClass'].forEach(methodName => {
  ElementCollection._attachToOTHelpers[methodName] = function /* arguments */
  () {
    const args = Array.prototype.slice.apply(arguments);
    const element = args.shift();
    const collection = new ElementCollection(element);
    return ElementCollection.prototype[methodName].apply(collection, args);
  };
});
var _default = ElementCollection;
exports.default = _default;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = setDeprecatedProperty;
var _log = _interopRequireDefault(__webpack_require__(1));
const logging = (0, _log.default)('deprecation');
function setDeprecatedProperty(object, key, _temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    defaultValue = _ref.value,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? `${key}` : _ref$name,
    _ref$getWarning = _ref.getWarning,
    getWarning = _ref$getWarning === void 0 ? '' : _ref$getWarning,
    _ref$setWarning = _ref.setWarning,
    setWarning = _ref$setWarning === void 0 ? '' : _ref$setWarning,
    _ref$canSet = _ref.canSet,
    canSet = _ref$canSet === void 0 ? false : _ref$canSet,
    _ref$warnOnSet = _ref.warnOnSet,
    warnOnSet = _ref$warnOnSet === void 0 ? false : _ref$warnOnSet;
  let value = defaultValue;
  let hasWarnedOnGet = false;
  let hasWarnedOnSet = !warnOnSet;
  const propertyDescriptor = {
    get() {
      if (!hasWarnedOnGet) {
        hasWarnedOnGet = true;
        logging.warn(`${name} is deprecated, and will be removed in the future. ${getWarning}`.trim());
      }
      return value;
    },
    set(newValue) {
      if (canSet) {
        value = newValue;
      }
      if (!hasWarnedOnSet) {
        hasWarnedOnSet = true;
        if (canSet) {
          logging.warn(`${name} is deprecated. ${setWarning}`.trim());
        } else {
          logging.warn(`${name} is deprecated, and will be removed in the future. ${setWarning}`.trim());
        }
      }
    }
  };
  Object.defineProperty(object, key, propertyDescriptor);
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _env = _interopRequireDefault(__webpack_require__(3));
var _shorthandSelector = _interopRequireDefault(__webpack_require__(262));
var _makeEverythingAttachToOTHelpers = _interopRequireDefault(__webpack_require__(266));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-void, no-param-reassign */
/* eslint-disable no-restricted-syntax, no-continue */

const browserAjax = {};
function formatPostData(data) {
  // , contentType
  // If it's a string, we assume it's properly encoded
  if (typeof data === 'string') {
    return data;
  }
  const queryString = [];
  Object.keys(data).forEach(key => {
    queryString.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
  });
  return queryString.join('&').replace(/\+/g, '%20');
}
if (_env.default.name !== 'Node') {
  browserAjax.request = function (url, options, callback) {
    const request = new (typeof window !== undefined ? window : global).XMLHttpRequest();
    const _options = options || {};
    const _method = _options.method;
    if (!_method) {
      callback(new Error('No HTTP method specified in options'));
      return;
    }
    if (options.overrideMimeType) {
      if (request.overrideMimeType) {
        request.overrideMimeType(options.overrideMimeType);
      }
      delete options.overrideMimeType;
    }

    // Setup callbacks to correctly respond to success and error callbacks. This includes
    // interpreting the responses HTTP status, which XmlHttpRequest seems to ignore
    // by default.
    if (callback) {
      (0, _shorthandSelector.default)(request).on('load', event => {
        const status = event.target.status;

        // We need to detect things that XMLHttpRequest considers a success,
        // but we consider to be failures.
        if (status >= 200 && (status < 300 || status === 304)) {
          callback(null, event);
        } else {
          callback(event);
        }
      });
      (0, _shorthandSelector.default)(request).on('error', callback);
    }
    request.open(options.method, url, true);
    if (!_options.headers) {
      _options.headers = {};
    }
    for (const name in _options.headers) {
      if (!Object.prototype.hasOwnProperty.call(_options.headers, name)) {
        continue;
      }
      request.setRequestHeader(name, _options.headers[name]);
    }
    request.send(options.body && formatPostData(options.body));
  };
  browserAjax.get = function (url, options, callback) {
    const _options = (0, _assign.default)(options || {}, {
      method: 'GET'
    });
    browserAjax.request(url, _options, callback);
  };
  browserAjax.post = function (url, options, callback) {
    const _options = (0, _assign.default)(options || {}, {
      method: 'POST'
    });
    browserAjax.request(url, _options, callback);
  };
  browserAjax.getJSON = function (url, options, callback) {
    options = options || {};
    const done = function done(error, event) {
      if (error) {
        callback(error, event && event.target && event.target.responseText);
      } else {
        let response;
        try {
          response = JSON.parse(event.target.responseText);
        } catch (e) {
          // Badly formed JSON
          callback(e, event && event.target && event.target.responseText);
          return;
        }
        callback(null, response, event);
      }
    };
    const extendedHeaders = (0, _assign.default)({
      Accept: 'application/json'
    }, options.headers || {});
    browserAjax.get(url, (0, _assign.default)(options || {}, {
      headers: extendedHeaders
    }), done);
  };
  (0, _makeEverythingAttachToOTHelpers.default)(browserAjax);
}
var _default = browserAjax;
exports.default = _default;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

const attachToOTHelpers = mod => {
  const attachments = {};
  Object.keys(mod).forEach(key => {
    attachments[key] = mod[key];
  });
  mod._attachToOTHelpers = attachments;
};
var _default = attachToOTHelpers;
exports.default = _default;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Analytics;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _log = _interopRequireDefault(__webpack_require__(1));
var _QueueRunner = _interopRequireDefault(__webpack_require__(578));
var _ajax = _interopRequireDefault(__webpack_require__(265));
var _proxyUrlHelper = _interopRequireDefault(__webpack_require__(106));
var _proxyUrl = __webpack_require__(72);
const logging = (0, _log.default)('analytics');
const clientInstanceId = (0, _uuid.default)();
const defaultQueue = new _QueueRunner.default();
function Analytics(_ref) {
  var _this = this;
  let loggingUrl = _ref.loggingUrl,
    _ref$queue = _ref.queue,
    queue = _ref$queue === void 0 ? defaultQueue : _ref$queue,
    _ref$ajax = _ref.ajax,
    ajax = _ref$ajax === void 0 ? _ajax.default : _ref$ajax;
  this.loggingUrl = loggingUrl;
  this.updateEndPoints = () => {
    if (!this.proxyUrl) {
      this.proxyUrl = (0, _proxyUrl.getProxyUrl)();
      const prependedUrl = (0, _proxyUrlHelper.default)(this.loggingUrl, this.proxyUrl);
      this.loggingUrl = prependedUrl;
    }
    this.endPoint = `${this.loggingUrl}/logging/ClientEvent`;
    this.endPointQos = `${this.loggingUrl}/logging/ClientQos`;
  };
  this.updateEndPoints();
  const reportedErrors = {};
  const post = function post(data, onComplete, isQos) {
    if (onComplete === void 0) {
      onComplete = () => {};
    }
    queue.add(callback => {
      logging.debug('sending analytics:', _this.loggingUrl, data);
      ajax.post(isQos ? _this.endPointQos : _this.endPoint, {
        body: data,
        overrideMimeType: 'text/plain',
        headers: {
          Accept: 'text/plain',
          'Content-Type': 'application/json'
        }
      }, err => {
        if (err) {
          logging.debug('Failed to send ClientEvent, moving on to the next item.');
        }
        onComplete(err || undefined);
        callback();
      });
    });
  };
  const shouldThrottleError = (code, type, partnerId) => {
    if (!partnerId) {
      return false;
    }
    const errKey = [partnerId, type, code].join('_');
    const msgLimit = 100;
    return (reportedErrors[errKey] || 0) >= msgLimit;
  };

  // Log an error via ClientEvents.
  //
  // @param [String] code
  // @param [String] type
  // @param [String] message
  // @param [Hash] details additional error details
  //
  // @param [Hash] options the options to log the client event with.
  // @option options [String] action The name of the Event that we are logging. E.g.
  //  'TokShowLoaded'. Required.
  // @option options [String] variation Usually used for Split A/B testing, when you
  //  have multiple variations of the +_action+.
  // @option options [String] payload The payload. Required.
  // @option options [String] sessionId The active OpenTok session, if there is one
  // @option options [String] connectionId The active OpenTok connectionId, if there is one
  // @option options [String] partnerId
  // @option options [String] guid ...
  // @option options [String] streamId ...
  // @option options [String] section ...
  // @option options [String] clientVersion ...
  //
  // Reports will be throttled to X reports (see exceptionLogging.messageLimitPerPartner
  // from the dynamic config for X) of each error type for each partner. Reports can be
  // disabled/enabled globally or on a per partner basis (per partner settings
  // take precedence) using exceptionLogging.enabled.
  //
  this.logError = function (code, type, message, details, options) {
    if (details === void 0) {
      details = null;
    }
    if (options === void 0) {
      options = {};
    }
    const _options = options,
      partnerId = _options.partnerId;
    if (shouldThrottleError(code, type, partnerId)) {
      // OT.log('ClientEvents.error has throttled an error of type ' + type + '.' +
      // code + ' for partner ' + (partnerId || 'No Partner Id'));
      return;
    }
    const errKey = [partnerId, type, code].join('_');
    const payload = details;
    reportedErrors[errKey] = typeof reportedErrors[errKey] !== 'undefined' ? reportedErrors[errKey] + 1 : 1;
    _this.logEvent((0, _assign.default)(options, {
      action: `${type}.${code}`,
      payload
    }), false);
  };

  // Log a client event to the analytics backend.
  //
  // @example Logs a client event called 'foo'
  //  this.logEvent({
  //      action: 'foo',
  //      payload: 'bar',
  //      sessionId: sessionId,
  //      connectionId: connectionId
  //  }, false)
  //
  // @param [Hash] data the data to log the client event with.
  // @param [Boolean] qos Whether this is a QoS event.
  // @param [Boolean] throttle A number specifying the ratio of events to be sent
  //        out of the total number of events (other events are not ignored). If not
  //        set to a number, all events are sent.
  // @param [Number] completionHandler A completion handler function to call when the
  //                 client event POST request succeeds or fails. If it fails, an error
  //                 object is passed into the function. (See throttledPost().)
  //
  this.logEvent = function (eventData, qos, throttle, completionHandler) {
    if (qos === void 0) {
      qos = false;
    }
    if (completionHandler === void 0) {
      completionHandler = () => {};
    }
    _this.updateEndPoints();
    const data = Object.assign({}, eventData, {
      clientInstanceId
    });
    if (throttle && !isNaN(throttle)) {
      if (Math.random() > throttle) {
        logging.debug('skipping sending analytics due to throttle:', data);
        return;
      }
    }
    logging.debug('queueing analytics:', _this.loggingUrl, data);
    let serializedData;
    try {
      serializedData = JSON.stringify(data);
    } catch (err) {
      completionHandler(err);
      return;
    }
    post(serializedData, completionHandler, qos);
  };

  // Log a client QOS to the analytics backend.
  // @option options [String] action The name of the Event that we are logging.
  //  E.g. 'TokShowLoaded'. Required.
  // @option options [String] variation Usually used for Split A/B testing, when
  //  you have multiple variations of the +_action+.
  // @option options [String] payload The payload. Required.
  // @option options [String] sessionId The active OpenTok session, if there is one
  // @option options [String] connectionId The active OpenTok connectionId, if there is one
  // @option options [String] partnerId
  // @option options [String] guid ...
  // @option options [String] streamId ...
  // @option options [String] section ...
  // @option options [String] clientVersion ...
  //
  this.logQOS = options => this.logEvent(options, true);
}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 269 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Collection;
var _isFunction = _interopRequireDefault(__webpack_require__(20));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-void, no-restricted-syntax, no-prototype-builtins */
/* eslint-disable no-continue, prefer-spread, prefer-rest-params */

const logging = (0, _log.default)('Collection');
function Collection(idField) {
  let _models = [];
  let _byId = {};
  const _idField = idField || 'id';
  (0, _eventing.default)(this);
  const modelProperty = function modelProperty(model, property) {
    if ((0, _isFunction.default)(model[property])) {
      return model[property]();
    }
    return model[property];
  };
  const onModelUpdate = function onModelUpdate(event) {
    this.trigger('update', event);
    this.trigger(`update:${event.target.id}`, event);
  }.bind(this);
  const onModelDestroy = function onModelDestroyed(event) {
    this.remove(event.target, event.reason);
  }.bind(this);
  this.reset = function () {
    // Stop listening on the models, they are no longer our problem
    _models.forEach(function (model) {
      model.off('updated', onModelUpdate, this);
      model.off('destroyed', onModelDestroy, this);
    }, this);
    _models = [];
    _byId = {};
  };
  this.destroy = function (reason) {
    _models.forEach(model => {
      if (model && typeof model.destroy === 'function') {
        model.destroy(reason, true);
      }
    });
    this.reset();
    this.off();
  };
  this.get = function (id) {
    return id && _byId[id] !== void 0 ? _models[_byId[id]] : void 0;
  };
  this.has = function (id) {
    return id && _byId[id] !== void 0;
  };
  this.toString = function () {
    return _models.toString();
  };

  // Return only models filtered by either a dict of properties
  // or a filter function.
  //
  // @example Return all publishers with a streamId of 1
  //   OT.publishers.where({streamId: 1})
  //
  // @example The same thing but filtering using a filter function
  //   OT.publishers.where(function(publisher) {
  //     return publisher.stream.id === 4;
  //   });
  //
  // @example The same thing but filtering using a filter function
  //          executed with a specific this
  //   OT.publishers.where(function(publisher) {
  //     return publisher.stream.id === 4;
  //   }, self);
  //
  this.where = function (attrsOrFilterFn, context) {
    if ((0, _isFunction.default)(attrsOrFilterFn)) {
      return _models.filter(attrsOrFilterFn, context);
    }
    return _models.filter(model => {
      for (const key in attrsOrFilterFn) {
        if (!attrsOrFilterFn.hasOwnProperty(key)) {
          continue;
        }
        if (modelProperty(model, key) !== attrsOrFilterFn[key]) {
          return false;
        }
      }
      return true;
    });
  };

  // Similar to where in behaviour, except that it only returns
  // the first match.
  this.find = function (attrsOrFilterFn, context) {
    let filterFn;
    if ((0, _isFunction.default)(attrsOrFilterFn)) {
      filterFn = attrsOrFilterFn;
    } else {
      filterFn = function filterFn(model) {
        for (const key in attrsOrFilterFn) {
          if (!attrsOrFilterFn.hasOwnProperty(key)) {
            continue;
          }
          if (modelProperty(model, key) !== attrsOrFilterFn[key]) {
            return false;
          }
        }
        return true;
      };
    }
    filterFn = filterFn.bind(context);
    for (let i = 0; i < _models.length; ++i) {
      if (filterFn(_models[i]) === true) {
        return _models[i];
      }
    }
    return null;
  };
  this.forEach = function (fn, context) {
    _models.forEach(fn, context);
    return this;
  };
  this.map = function (fn) {
    return _models.map(fn);
  };
  const removeModel = model => {
    const id = modelProperty(model, _idField);
    if (!this.has(id)) {
      return;
    }
    _models.splice(_byId[id], 1);
    // Shuffle everyone down one
    for (let i = _byId[id]; i < _models.length; ++i) {
      _byId[modelProperty(_models[i], _idField)] = i;
    }
    delete _byId[id];
    model.off('updated', onModelUpdate, this);
    model.off('destroyed', onModelDestroy, this);
  };
  this.add = function (model) {
    const id = modelProperty(model, _idField);
    if (this.has(id)) {
      logging.warn(`Model ${id} is already in the collection`, _models);
      return this;
    }
    _byId[id] = _models.push(model) - 1;
    model.on('updated', onModelUpdate, this);
    model.on('destroyed', onModelDestroy, this);
    this.trigger('add', model);
    this.trigger(`add:${id}`, model);
    return this;
  };
  this.replace = function (model) {
    // Remove model to replace it with the new one.
    removeModel(model);
    this.add(model);
  };
  this.remove = function (model, reason) {
    removeModel(model);
    this.trigger('remove', model, reason);
    this.trigger(`remove:${modelProperty(model, _idField)}`, model, reason);
    return this;
  };

  // Retrigger the add event behaviour for each model. You can also
  // select a subset of models to trigger using the same arguments
  // as the #where method.
  this._triggerAddEvents = function () {
    this.where.apply(this, arguments).forEach(function (model) {
      this.trigger('add', model);
      this.trigger(`add:${modelProperty(model, _idField)}`, model);
    }, this);
  };
  this.length = function () {
    return _models.length;
  };
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isFunction = _interopRequireDefault(__webpack_require__(20));
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _log = _interopRequireDefault(__webpack_require__(1));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, no-shadow */

const logging = (0, _log.default)('guidStorage');
const guidStorage = {};
let currentGuidStorage;
let currentGuid;
const isInvalidStorage = function isInvalidStorage(storageInterface) {
  return !((0, _isFunction.default)(storageInterface.get) && (0, _isFunction.default)(storageInterface.set));
};
const getClientGuid = function getClientGuid(completion) {
  if (currentGuid) {
    completion(null, currentGuid);
    return;
  }

  // It's the first time that getClientGuid has been called
  // in this page lifetime. Attempt to load any existing Guid
  // from the storage
  currentGuidStorage.get(completion);
};

/*
* Sets the methods for storing and retrieving client GUIDs persistently
* across sessions. By default, OpenTok.js attempts to use browser cookies to
* store GUIDs.
* <p>
* Pass in an object that has a <code>get()</code> method and
* a <code>set()</code> method.
* <p>
* The <code>get()</code> method must take one parameter: the callback
* method to invoke. The callback method is passed two parameters &mdash;
* the first parameter is an error object or null if the call is successful;
* and the second parameter is the GUID (a string) if successful.
* <p>
* The <code>set()</code> method must include two parameters: the GUID to set
* (a string) and the callback method to invoke. The callback method is
* passed an error object on error, or it is passed no parameter if the call is
* successful.
* <p>
* Here is an example:
* <p>
* <pre>
* var ComplexStorage = function() {
*   this.set = function(guid, completion) {
*     AwesomeBackendService.set(guid, function(response) {
*       completion(response.error || null);
*     });
*   };
*   this.get = function(completion) {
*     AwesomeBackendService.get(function(response, guid) {
*       completion(response.error || null, guid);
*     });
*   };
* };
*
* OT.overrideGuidStorage(new ComplexStorage());
* </pre>
*/
guidStorage.override = storageInterface => {
  if (isInvalidStorage(storageInterface)) {
    throw new Error('The storageInterface argument does not seem to be valid, ' + 'it must implement get and set methods');
  }
  if (currentGuidStorage === storageInterface) {
    return;
  }
  currentGuidStorage = storageInterface;

  // If a client Guid has already been assigned to this client then
  // let the new storage know about it so that it's in sync.
  if (currentGuid) {
    currentGuidStorage.set(currentGuid, error => {
      if (error) {
        logging.error(`Failed to send initial Guid value (${currentGuid}) to the newly assigned Guid Storage. The error was: ${error}`);
        // @todo error
      }
    });
  }
};

guidStorage.get = completion => {
  getClientGuid((error, guid) => {
    if (error) {
      completion(error);
      return;
    }
    if (!guid) {
      // Nothing came back, this client is entirely new.
      // generate a new Guid and persist it
      guid = (0, _uuid.default)();
      currentGuidStorage.set(guid, error => {
        if (error) {
          completion(error);
          return;
        }
        currentGuid = guid;
      });
    } else if (!currentGuid) {
      currentGuid = guid;
    }
    completion(null, currentGuid);
  });
};
guidStorage.getAsync = () => new Promise((resolve, reject) => {
  guidStorage.get((error, guid) => {
    if (error) {
      return reject(error);
    }
    return resolve(guid);
  });
});

// Implement our default storage mechanism, which sets/gets a cookie
// called 'opentok_client_id'
guidStorage.override({
  get(completion) {
    let clientId;
    try {
      clientId = (typeof window !== undefined ? window : global).localStorage.getItem('opentok_client_id');
    } catch (err) {
      // will get Uncaught DOMException: Failed to read the 'localStorage' property from 'Window':
      // The document is sandboxed and lacks the 'allow-same-origin' flag.
      if (!clientId) {
        clientId = (0, _uuid.default)();
      }
    }
    completion(null, clientId);
  },
  set(guid, completion) {
    try {
      (typeof window !== undefined ? window : global).localStorage.setItem('opentok_client_id', guid);
    } catch (err) {
      // will get Uncaught DOMException: Failed to read the 'localStorage' property from 'Window':
      // The document is sandboxed and lacks the 'allow-same-origin' flag.
    }
    completion(null);
  }
});

// Test only
guidStorage.set = guid => {
  currentGuid = guid;
};
var _default = guidStorage;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isObject = _interopRequireDefault(__webpack_require__(11));
var _env = _interopRequireDefault(__webpack_require__(3));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, no-void */
/* eslint-disable no-restricted-syntax, no-prototype-builtins, no-shadow, one-var, vars-on-top */
/* eslint-disable no-var */

let getErrorLocation;

// Properties that we'll acknowledge from the JS Error object
const safeErrorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

// OTHelpers.Error
//
// A construct to contain error information that also helps with extracting error
// context, such as stack trace.
//
// @constructor
// @memberof OTHelpers
// @method Error
//
// @param {String} message
//      Optional. The error message
//
// @param {Object} props
//      Optional. A dictionary of properties containing extra Error info.
//
//
// @example Create a simple error with juts a custom message
//   var error = new OTHelpers.Error('Something Broke!');
//   error.message === 'Something Broke!';
//
// @example Create an Error with a message and a name
//   var error = new OTHelpers.Error('Something Broke!', 'FooError');
//   error.message === 'Something Broke!';
//   error.name === 'FooError';
//
// @example Create an Error with a message, name, and custom properties
//   var error = new OTHelpers.Error('Something Broke!', 'FooError', {
//     foo: 'bar',
//     listOfImportantThings: [1,2,3,4]
//   });
//   error.message === 'Something Broke!';
//   error.name === 'FooError';
//   error.foo === 'bar';
//   error.listOfImportantThings == [1,2,3,4];
//
// @example Create an Error from a Javascript Error
//   var error = new OTHelpers.Error(domSyntaxError);
//   error.message === domSyntaxError.message;
//   error.name === domSyntaxError.name === 'SyntaxError';
//   // ...continues for each properties of domSyntaxError
//
// @references
// * https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi
// * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Stack
// * http://www.w3.org/TR/dom/#interface-domerror
//
//
// @todo
// * update usage in OTMedia
// * replace error handling in OT.js
// * normalise stack behaviour under Chrome/Node/Safari with other browsers
// * unit test for stack parsing
//
const Error_ = function Error_(message, name, props) {
  switch (arguments.length) {
    case 1:
      if ((0, _isObject.default)(message)) {
        props = message;
        name = void 0;
        message = void 0;
      }
      // Otherwise it's the message
      break;
    case 2:
      if ((0, _isObject.default)(name)) {
        props = name;
        name = void 0;
      }
      // Otherwise name is actually the name
      break;
    default:
    // FIXME: Should something go here?
  }

  if (props instanceof Error) {
    // Special handling of this due to Chrome weirdness. It seems that
    // properties of the Error object, and it's children, are not
    // enumerable in Chrome?
    for (let i = 0, num = safeErrorProps.length; i < num; ++i) {
      this[safeErrorProps[i]] = props[safeErrorProps[i]];
    }
  } else if ((0, _isObject.default)(props)) {
    // Use an custom properties that are provided
    for (const key in props) {
      if (props.hasOwnProperty(key)) {
        this[key] = props[key];
      }
    }
  }

  // If any of the fundamental properties are missing then try and
  // extract them.
  if (!(this.fileName && this.lineNumber && this.columnNumber && this.stack)) {
    const err = getErrorLocation();
    if (!this.fileName && err.fileName) {
      this.fileName = err.fileName;
    }
    if (!this.lineNumber && err.lineNumber) {
      this.lineNumber = err.lineNumber;
    }
    if (!this.columnNumber && err.columnNumber) {
      this.columnNumber = err.columnNumber;
    }
    if (!this.stack && err.stack) {
      this.stack = err.stack;
    }
  }
  if (!this.message && message) {
    this.message = message;
  }
  if ((!this.name || this.name === 'Error') && name) {
    this.name = name;
  }
};
Error_.prototype = Object.create(Error.prototype);
Error_.prototype.toString = function () {
  let locationDetails = '';
  if (this.fileName) {
    locationDetails += ` ${this.fileName}`;
  }
  if (this.lineNumber) {
    locationDetails += ` ${this.lineNumber}`;
    if (this.columnNumber) {
      locationDetails += `:${this.columnNumber}`;
    }
  }
  return `<${this.name ? `${this.name} ` : ''}${this.message}${locationDetails}>`;
};
Error_.prototype.valueOf = Error_.prototype.toString;

// Normalise err.stack so that it is the same format as the other browsers
// We skip the first two frames so that we don't capture getErrorLocation() and
// the callee.
//
// Used by Environments that support the StackTrace API. (Chrome, Node, Opera)
//
const prepareStackTrace = function prepareStackTrace(_, stack) {
  return stack.slice(2).map(frame => {
    const _f = {
      fileName: frame.getFileName(),
      linenumber: frame.getLineNumber(),
      columnNumber: frame.getColumnNumber()
    };
    if (frame.getFunctionName()) {
      _f.functionName = frame.getFunctionName();
    }
    if (frame.getMethodName()) {
      _f.methodName = frame.getMethodName();
    }
    if (frame.getThis()) {
      _f.self = frame.getThis();
    }
    return _f;
  });
};

// Black magic to retrieve error location info for various environments
getErrorLocation = function getErrorLocation() {
  const info = {};
  let callstack, errLocation, err;
  switch (_env.default.name) {
    case 'Firefox':
    case 'Safari':
      try {
        (typeof window !== undefined ? window : global).call.js.is.explody();
      } catch (e) {
        err = e;
      }
      callstack = (err.stack || '').split('\n');

      // Remove call to getErrorLocation() and the callee
      callstack.shift();
      callstack.shift();
      info.stack = callstack;
      errLocation = /@(.+?):([0-9]+)(:([0-9]+))?$/.exec(callstack[0]);
      if (errLocation) {
        info.fileName = errLocation[1];
        info.lineNumber = parseInt(errLocation[2], 10);
        if (errLocation.length > 3) {
          info.columnNumber = parseInt(errLocation[4], 10);
        }
      }
      break;
    case 'Chrome':
    case 'Node':
    case 'Opera':
      var currentPST = Error.prepareStackTrace;
      Error.prepareStackTrace = prepareStackTrace;
      err = new Error();
      info.stack = err.stack;
      Error.prepareStackTrace = currentPST;
      var topFrame = info.stack[0];
      info.lineNumber = topFrame.lineNumber;
      info.columnNumber = topFrame.columnNumber;
      info.fileName = topFrame.fileName;
      if (topFrame.functionName) {
        info.functionName = topFrame.functionName;
      }
      if (topFrame.methodName) {
        info.methodName = topFrame.methodName;
      }
      if (topFrame.self) {
        info.self = topFrame.self;
      }
      break;
    default:
      err = new Error();
      if (err.stack) {
        info.stack = err.stack.split('\n');
      }
      break;
  }
  if (err.message) {
    info.message = err.message;
  }
  return info;
};
var _default = Error_;
exports.default = _default;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = videoElementErrorMapFactory;
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require */

function videoElementErrorMapFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const Errors = deps.Errors || _Errors.default;
  const otError = deps.otError || (0, _otError.default)();

  // See http://www.w3.org/TR/2010/WD-html5-20101019/video.html#error-codes
  const videoErrorDetails = {};

  // Checking for global.MediaError for IE compatibility, just so we don't throw
  // exceptions when the script is included
  if ((typeof window !== undefined ? window : global).MediaError) {
    videoErrorDetails[(typeof window !== undefined ? window : global).MediaError.MEDIA_ERR_ABORTED] = {
      name: Errors.MEDIA_ERR_ABORTED,
      message: 'The fetching process for the media resource was aborted by the ' + 'user agent at the user\'s request.'
    };
    videoErrorDetails[(typeof window !== undefined ? window : global).MediaError.MEDIA_ERR_NETWORK] = {
      name: Errors.MEDIA_ERR_NETWORK,
      message: 'A network error of some description caused the user agent to ' + 'stop fetching the media resource, after the resource was established ' + 'to be usable.'
    };
    videoErrorDetails[(typeof window !== undefined ? window : global).MediaError.MEDIA_ERR_DECODE] = {
      name: Errors.MEDIA_ERR_DECODE,
      message: 'An error of some description occurred while decoding the media ' + 'resource, after the resource was established to be usable.'
    };
    videoErrorDetails[(typeof window !== undefined ? window : global).MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED] = {
      name: Errors.MEDIA_ERR_SRC_NOT_SUPPORTED,
      message: 'The media resource indicated by the src attribute was not ' + 'suitable.'
    };
  }
  return function videoElementErrorMap(error) {
    const errorDetails = videoErrorDetails[error.code];
    if (!errorDetails) {
      return new Error(`An unknown error occurred${error.message ? `: ${error.message}` : '.'}`);
    }
    return otError(errorDetails.name, new Error(`There was an unexpected problem with the Video Stream: ${errorDetails.message}`));
  };
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _createVideoElementUsingNativeAPI = _interopRequireDefault(__webpack_require__(153));
var _createVideoElementForSafari = _interopRequireDefault(__webpack_require__(590));
// Tries to return an always autoplayable video element
const createVideoElement = function createVideoElement(deps) {
  if (deps === void 0) {
    deps = {};
  }
  // The mocked `env` can be set to `undefined` to test some edge case(s), hence
  // the use of `hasOwnProperty` instead of the other patterns below.
  // eslint-disable-next-line no-prototype-builtins
  const env = deps.hasOwnProperty('env') ? deps.env : _env.default;
  const createVideoElementUsingNativeAPI = deps.createVideoElementUsingNativeAPI || _createVideoElementUsingNativeAPI.default;
  const createVideoElementForSafari = deps.createVideoElementForSafari || _createVideoElementForSafari.default;
  let videoElement;
  if (env != null && env.isSafari) {
    // See VIDCS-1523
    // Safari requires special handling to ensure that the video element is
    // autoplayable.
    videoElement = createVideoElementForSafari();
  } else {
    // For most browsers, once any video element is granted autoplay permission, then
    // all video elements in the execution context inherit the same permissions.  This
    // is true when if the video element was created after the browser tab/window
    // loses focus and was backgrounded.
    videoElement = createVideoElementUsingNativeAPI();
  }
  videoElement.autoplay = true;
  videoElement.playsinline = true;

  // Safari on iOS requires setAttribute OPENTOK-37229
  videoElement.setAttribute('autoplay', '');
  videoElement.setAttribute('playsinline', '');
  return videoElement;
};
var _default = createVideoElement;
exports.default = _default;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _now = _interopRequireDefault(__webpack_require__(51));
/*
 * A <code>RTCPeerConnection.getStats</code> based audio level sampler.
 *
 * It uses the <code>getStats</code> method to get the <code>audioOutputLevel</code>.
 * This implementation expects the single parameter version of the <code>getStats</code> method.
 *
 * Currently the <code>audioOutputLevel</code> stats is only supported in Chrome.
 *
 * @param {function} "getStats" function or "getSynchronizationSources" function
 * @constructor
 */
let GetAudioLevelSampler = /*#__PURE__*/function () {
  function GetAudioLevelSampler(getAudioLevel, _temp) {
    var _context;
    let _ref = _temp === void 0 ? {} : _temp,
      _ref$requestAnimation = _ref.requestAnimationFrame,
      requestAnimationFrame = _ref$requestAnimation === void 0 ? (_context = window).requestAnimationFrame.bind(_context) : _ref$requestAnimation;
    this._lastCalled = (0, _now.default)();
    this._audioLevel = undefined;
    this._running = false;
    this._requestAnimationFrame = requestAnimationFrame;
    this._getAudioLevel = getAudioLevel;
    this._startLoop();
  }
  var _proto = GetAudioLevelSampler.prototype;
  _proto._startLoop = function _startLoop() {
    if (this._running) {
      return;
    }
    this._running = true;
    this._requestAnimationFrame(this._loop.bind(this));
  };
  _proto._loop = function _loop() {
    this._getAudioLevel((error, stats) => {
      // @todo we should measure how long the getStats so that we can determine
      // our impact on the render loop, and skip frames if need to reduce our
      // CPU utilization

      // Stat entries without audio can have audioLevel 0 so we just look for the max level
      let maxLevel = null;
      if (!error) {
        for (let idx = 0; idx < stats.length; idx += 1) {
          const stat = stats[idx];
          let level = null;
          if (stat.audioOutputLevel !== undefined) {
            // the max value delivered by getStats via audioOutputLevel is 2^15
            const audioOutputLevel = parseFloat(stat.audioOutputLevel) / 32768;
            if (!isNaN(audioOutputLevel)) {
              level = audioOutputLevel;
            }
          } else if (stat.audioLevel !== undefined) {
            level = stat.audioLevel;
          }
          if (level !== null && (maxLevel === null || level > maxLevel)) {
            maxLevel = level;
          }
        }
        this._audioLevel = maxLevel;
        if (this._running && (0, _now.default)() - this._lastCalled < 10000) {
          this._requestAnimationFrame(this._loop.bind(this));
        } else {
          this._running = false;
        }
      }
    });
  };
  _proto.destroy = function destroy() {
    this._running = false;
  };
  _proto.sample = function sample(done) {
    if (typeof done === 'function') {
      throw new Error('sample no longer takes a callback');
    }
    this._startLoop();
    this._lastCalled = (0, _now.default)();
    return this._audioLevel;
  };
  return GetAudioLevelSampler;
}();
exports.default = GetAudioLevelSampler;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env node */


// SDP helpers.
var SDPUtils = {};

// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
SDPUtils.generateIdentifier = function() {
  return Math.random().toString(36).substr(2, 10);
};

// The RTCP CNAME used by all peerconnections from the same JS.
SDPUtils.localCName = SDPUtils.generateIdentifier();

// Splits SDP into lines, dealing with both CRLF and LF.
SDPUtils.splitLines = function(blob) {
  return blob.trim().split('\n').map(function(line) {
    return line.trim();
  });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPUtils.splitSections = function(blob) {
  var parts = blob.split('\nm=');
  return parts.map(function(part, index) {
    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
  });
};

// returns the session description.
SDPUtils.getDescription = function(blob) {
  var sections = SDPUtils.splitSections(blob);
  return sections && sections[0];
};

// returns the individual media sections.
SDPUtils.getMediaSections = function(blob) {
  var sections = SDPUtils.splitSections(blob);
  sections.shift();
  return sections;
};

// Returns lines that start with a certain prefix.
SDPUtils.matchPrefix = function(blob, prefix) {
  return SDPUtils.splitLines(blob).filter(function(line) {
    return line.indexOf(prefix) === 0;
  });
};

// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
SDPUtils.parseCandidate = function(line) {
  var parts;
  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  var candidate = {
    foundation: parts[0],
    component: parseInt(parts[1], 10),
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    address: parts[4], // address is an alias for ip.
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7]
  };

  for (var i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
      case 'ufrag':
        candidate.ufrag = parts[i + 1]; // for backward compability.
        candidate.usernameFragment = parts[i + 1];
        break;
      default: // extension handling, in particular ufrag
        candidate[parts[i]] = parts[i + 1];
        break;
    }
  }
  return candidate;
};

// Translates a candidate object into SDP candidate attribute.
SDPUtils.writeCandidate = function(candidate) {
  var sdp = [];
  sdp.push(candidate.foundation);
  sdp.push(candidate.component);
  sdp.push(candidate.protocol.toUpperCase());
  sdp.push(candidate.priority);
  sdp.push(candidate.address || candidate.ip);
  sdp.push(candidate.port);

  var type = candidate.type;
  sdp.push('typ');
  sdp.push(type);
  if (type !== 'host' && candidate.relatedAddress &&
      candidate.relatedPort) {
    sdp.push('raddr');
    sdp.push(candidate.relatedAddress);
    sdp.push('rport');
    sdp.push(candidate.relatedPort);
  }
  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
    sdp.push('tcptype');
    sdp.push(candidate.tcpType);
  }
  if (candidate.usernameFragment || candidate.ufrag) {
    sdp.push('ufrag');
    sdp.push(candidate.usernameFragment || candidate.ufrag);
  }
  return 'candidate:' + sdp.join(' ');
};

// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
SDPUtils.parseIceOptions = function(line) {
  return line.substr(14).split(' ');
};

// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
SDPUtils.parseRtpMap = function(line) {
  var parts = line.substr(9).split(' ');
  var parsed = {
    payloadType: parseInt(parts.shift(), 10) // was: id
  };

  parts = parts[0].split('/');

  parsed.name = parts[0];
  parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
  parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
  // legacy alias, got renamed back to channels in ORTC.
  parsed.numChannels = parsed.channels;
  return parsed;
};

// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
SDPUtils.writeRtpMap = function(codec) {
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  var channels = codec.channels || codec.numChannels || 1;
  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate +
      (channels !== 1 ? '/' + channels : '') + '\r\n';
};

// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
SDPUtils.parseExtmap = function(line) {
  var parts = line.substr(9).split(' ');
  return {
    id: parseInt(parts[0], 10),
    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
    uri: parts[1]
  };
};

// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
SDPUtils.writeExtmap = function(headerExtension) {
  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) +
      (headerExtension.direction && headerExtension.direction !== 'sendrecv'
        ? '/' + headerExtension.direction
        : '') +
      ' ' + headerExtension.uri + '\r\n';
};

// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
SDPUtils.parseFmtp = function(line) {
  var parsed = {};
  var kv;
  var parts = line.substr(line.indexOf(' ') + 1).split(';');
  for (var j = 0; j < parts.length; j++) {
    kv = parts[j].trim().split('=');
    parsed[kv[0].trim()] = kv[1];
  }
  return parsed;
};

// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeFmtp = function(codec) {
  var line = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.parameters && Object.keys(codec.parameters).length) {
    var params = [];
    Object.keys(codec.parameters).forEach(function(param) {
      if (codec.parameters[param]) {
        params.push(param + '=' + codec.parameters[param]);
      } else {
        params.push(param);
      }
    });
    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
  }
  return line;
};

// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
SDPUtils.parseRtcpFb = function(line) {
  var parts = line.substr(line.indexOf(' ') + 1).split(' ');
  return {
    type: parts.shift(),
    parameter: parts.join(' ')
  };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeRtcpFb = function(codec) {
  var lines = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
    // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type +
      (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') +
          '\r\n';
    });
  }
  return lines;
};

// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
SDPUtils.parseSsrcMedia = function(line) {
  var sp = line.indexOf(' ');
  var parts = {
    ssrc: parseInt(line.substr(7, sp - 7), 10)
  };
  var colon = line.indexOf(':', sp);
  if (colon > -1) {
    parts.attribute = line.substr(sp + 1, colon - sp - 1);
    parts.value = line.substr(colon + 1);
  } else {
    parts.attribute = line.substr(sp + 1);
  }
  return parts;
};

SDPUtils.parseSsrcGroup = function(line) {
  var parts = line.substr(13).split(' ');
  return {
    semantics: parts.shift(),
    ssrcs: parts.map(function(ssrc) {
      return parseInt(ssrc, 10);
    })
  };
};

// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
SDPUtils.getMid = function(mediaSection) {
  var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
  if (mid) {
    return mid.substr(6);
  }
};

SDPUtils.parseFingerprint = function(line) {
  var parts = line.substr(14).split(' ');
  return {
    algorithm: parts[0].toLowerCase(), // algorithm is case-sensitive in Edge.
    value: parts[1]
  };
};

// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=fingerprint:');
  // Note: a=setup line is ignored since we use the 'auto' role.
  // Note2: 'algorithm' is not case sensitive except in Edge.
  return {
    role: 'auto',
    fingerprints: lines.map(SDPUtils.parseFingerprint)
  };
};

// Serializes DTLS parameters to SDP.
SDPUtils.writeDtlsParameters = function(params, setupType) {
  var sdp = 'a=setup:' + setupType + '\r\n';
  params.fingerprints.forEach(function(fp) {
    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
  });
  return sdp;
};

// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
SDPUtils.parseCryptoLine = function(line) {
  var parts = line.substr(9).split(' ');
  return {
    tag: parseInt(parts[0], 10),
    cryptoSuite: parts[1],
    keyParams: parts[2],
    sessionParams: parts.slice(3),
  };
};

SDPUtils.writeCryptoLine = function(parameters) {
  return 'a=crypto:' + parameters.tag + ' ' +
    parameters.cryptoSuite + ' ' +
    (typeof parameters.keyParams === 'object'
      ? SDPUtils.writeCryptoKeyParams(parameters.keyParams)
      : parameters.keyParams) +
    (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') +
    '\r\n';
};

// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
SDPUtils.parseCryptoKeyParams = function(keyParams) {
  if (keyParams.indexOf('inline:') !== 0) {
    return null;
  }
  var parts = keyParams.substr(7).split('|');
  return {
    keyMethod: 'inline',
    keySalt: parts[0],
    lifeTime: parts[1],
    mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
    mkiLength: parts[2] ? parts[2].split(':')[1] : undefined,
  };
};

SDPUtils.writeCryptoKeyParams = function(keyParams) {
  return keyParams.keyMethod + ':'
    + keyParams.keySalt +
    (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') +
    (keyParams.mkiValue && keyParams.mkiLength
      ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength
      : '');
};

// Extracts all SDES paramters.
SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=crypto:');
  return lines.map(SDPUtils.parseCryptoLine);
};

// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
  var ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=ice-ufrag:')[0];
  var pwd = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=ice-pwd:')[0];
  if (!(ufrag && pwd)) {
    return null;
  }
  return {
    usernameFragment: ufrag.substr(12),
    password: pwd.substr(10),
  };
};

// Serializes ICE parameters to SDP.
SDPUtils.writeIceParameters = function(params) {
  return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' +
      'a=ice-pwd:' + params.password + '\r\n';
};

// Parses the SDP media section and returns RTCRtpParameters.
SDPUtils.parseRtpParameters = function(mediaSection) {
  var description = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: [],
    rtcp: []
  };
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  for (var i = 3; i < mline.length; i++) { // find all codecs from mline[3..]
    var pt = mline[i];
    var rtpmapline = SDPUtils.matchPrefix(
      mediaSection, 'a=rtpmap:' + pt + ' ')[0];
    if (rtpmapline) {
      var codec = SDPUtils.parseRtpMap(rtpmapline);
      var fmtps = SDPUtils.matchPrefix(
        mediaSection, 'a=fmtp:' + pt + ' ');
      // Only the first a=fmtp:<pt> is considered.
      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
      codec.rtcpFeedback = SDPUtils.matchPrefix(
        mediaSection, 'a=rtcp-fb:' + pt + ' ')
        .map(SDPUtils.parseRtcpFb);
      description.codecs.push(codec);
      // parse FEC mechanisms from rtpmap lines.
      switch (codec.name.toUpperCase()) {
        case 'RED':
        case 'ULPFEC':
          description.fecMechanisms.push(codec.name.toUpperCase());
          break;
        default: // only RED and ULPFEC are recognized as FEC mechanisms.
          break;
      }
    }
  }
  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
    description.headerExtensions.push(SDPUtils.parseExtmap(line));
  });
  // FIXME: parse rtcp.
  return description;
};

// Generates parts of the SDP media section describing the capabilities /
// parameters.
SDPUtils.writeRtpDescription = function(kind, caps) {
  var sdp = '';

  // Build the mline.
  sdp += 'm=' + kind + ' ';
  sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
  sdp += ' UDP/TLS/RTP/SAVPF ';
  sdp += caps.codecs.map(function(codec) {
    if (codec.preferredPayloadType !== undefined) {
      return codec.preferredPayloadType;
    }
    return codec.payloadType;
  }).join(' ') + '\r\n';

  sdp += 'c=IN IP4 0.0.0.0\r\n';
  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';

  // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
  caps.codecs.forEach(function(codec) {
    sdp += SDPUtils.writeRtpMap(codec);
    sdp += SDPUtils.writeFmtp(codec);
    sdp += SDPUtils.writeRtcpFb(codec);
  });
  var maxptime = 0;
  caps.codecs.forEach(function(codec) {
    if (codec.maxptime > maxptime) {
      maxptime = codec.maxptime;
    }
  });
  if (maxptime > 0) {
    sdp += 'a=maxptime:' + maxptime + '\r\n';
  }
  sdp += 'a=rtcp-mux\r\n';

  if (caps.headerExtensions) {
    caps.headerExtensions.forEach(function(extension) {
      sdp += SDPUtils.writeExtmap(extension);
    });
  }
  // FIXME: write fecMechanisms.
  return sdp;
};

// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
  var encodingParameters = [];
  var description = SDPUtils.parseRtpParameters(mediaSection);
  var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
  var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;

  // filter a=ssrc:... cname:, ignore PlanB-msid
  var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(function(line) {
      return SDPUtils.parseSsrcMedia(line);
    })
    .filter(function(parts) {
      return parts.attribute === 'cname';
    });
  var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
  var secondarySsrc;

  var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID')
    .map(function(line) {
      var parts = line.substr(17).split(' ');
      return parts.map(function(part) {
        return parseInt(part, 10);
      });
    });
  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
    secondarySsrc = flows[0][1];
  }

  description.codecs.forEach(function(codec) {
    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
      var encParam = {
        ssrc: primarySsrc,
        codecPayloadType: parseInt(codec.parameters.apt, 10)
      };
      if (primarySsrc && secondarySsrc) {
        encParam.rtx = {ssrc: secondarySsrc};
      }
      encodingParameters.push(encParam);
      if (hasRed) {
        encParam = JSON.parse(JSON.stringify(encParam));
        encParam.fec = {
          ssrc: primarySsrc,
          mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
        };
        encodingParameters.push(encParam);
      }
    }
  });
  if (encodingParameters.length === 0 && primarySsrc) {
    encodingParameters.push({
      ssrc: primarySsrc
    });
  }

  // we support both b=AS and b=TIAS but interpret AS as TIAS.
  var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
  if (bandwidth.length) {
    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(7), 10);
    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
      // use formula from JSEP to convert b=AS to TIAS value.
      bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95
          - (50 * 40 * 8);
    } else {
      bandwidth = undefined;
    }
    encodingParameters.forEach(function(params) {
      params.maxBitrate = bandwidth;
    });
  }
  return encodingParameters;
};

// parses http://draft.ortc.org/#rtcrtcpparameters*
SDPUtils.parseRtcpParameters = function(mediaSection) {
  var rtcpParameters = {};

  // Gets the first SSRC. Note tha with RTX there might be multiple
  // SSRCs.
  var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(function(line) {
      return SDPUtils.parseSsrcMedia(line);
    })
    .filter(function(obj) {
      return obj.attribute === 'cname';
    })[0];
  if (remoteSsrc) {
    rtcpParameters.cname = remoteSsrc.value;
    rtcpParameters.ssrc = remoteSsrc.ssrc;
  }

  // Edge uses the compound attribute instead of reducedSize
  // compound is !reducedSize
  var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
  rtcpParameters.reducedSize = rsize.length > 0;
  rtcpParameters.compound = rsize.length === 0;

  // parses the rtcp-mux attrіbute.
  // Note that Edge does not support unmuxed RTCP.
  var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
  rtcpParameters.mux = mux.length > 0;

  return rtcpParameters;
};

// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
SDPUtils.parseMsid = function(mediaSection) {
  var parts;
  var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
  if (spec.length === 1) {
    parts = spec[0].substr(7).split(' ');
    return {stream: parts[0], track: parts[1]};
  }
  var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(function(line) {
      return SDPUtils.parseSsrcMedia(line);
    })
    .filter(function(msidParts) {
      return msidParts.attribute === 'msid';
    });
  if (planB.length > 0) {
    parts = planB[0].value.split(' ');
    return {stream: parts[0], track: parts[1]};
  }
};

// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
SDPUtils.parseSctpDescription = function(mediaSection) {
  var mline = SDPUtils.parseMLine(mediaSection);
  var maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
  var maxMessageSize;
  if (maxSizeLine.length > 0) {
    maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
  }
  if (isNaN(maxMessageSize)) {
    maxMessageSize = 65536;
  }
  var sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
  if (sctpPort.length > 0) {
    return {
      port: parseInt(sctpPort[0].substr(12), 10),
      protocol: mline.fmt,
      maxMessageSize: maxMessageSize
    };
  }
  var sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
  if (sctpMapLines.length > 0) {
    var parts = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:')[0]
      .substr(10)
      .split(' ');
    return {
      port: parseInt(parts[0], 10),
      protocol: parts[1],
      maxMessageSize: maxMessageSize
    };
  }
};

// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
SDPUtils.writeSctpDescription = function(media, sctp) {
  var output = [];
  if (media.protocol !== 'DTLS/SCTP') {
    output = [
      'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
      'c=IN IP4 0.0.0.0\r\n',
      'a=sctp-port:' + sctp.port + '\r\n'
    ];
  } else {
    output = [
      'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
      'c=IN IP4 0.0.0.0\r\n',
      'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
    ];
  }
  if (sctp.maxMessageSize !== undefined) {
    output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
  }
  return output.join('');
};

// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
SDPUtils.generateSessionId = function() {
  return Math.random().toString().substr(2, 21);
};

// Write boilder plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
  var sessionId;
  var version = sessVer !== undefined ? sessVer : 2;
  if (sessId) {
    sessionId = sessId;
  } else {
    sessionId = SDPUtils.generateSessionId();
  }
  var user = sessUser || 'thisisadapterortc';
  // FIXME: sess-id should be an NTP timestamp.
  return 'v=0\r\n' +
      'o=' + user + ' ' + sessionId + ' ' + version +
        ' IN IP4 127.0.0.1\r\n' +
      's=-\r\n' +
      't=0 0\r\n';
};

SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
    transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
    transceiver.dtlsTransport.getLocalParameters(),
    type === 'offer' ? 'actpass' : 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.direction) {
    sdp += 'a=' + transceiver.direction + '\r\n';
  } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    // spec.
    var msid = 'msid:' + stream.id + ' ' +
        transceiver.rtpSender.track.id + '\r\n';
    sdp += 'a=' + msid;

    // for Chrome.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
};

// Gets the direction from the mediaSection or the sessionpart.
SDPUtils.getDirection = function(mediaSection, sessionpart) {
  // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
  var lines = SDPUtils.splitLines(mediaSection);
  for (var i = 0; i < lines.length; i++) {
    switch (lines[i]) {
      case 'a=sendrecv':
      case 'a=sendonly':
      case 'a=recvonly':
      case 'a=inactive':
        return lines[i].substr(2);
      default:
        // FIXME: What should happen here?
    }
  }
  if (sessionpart) {
    return SDPUtils.getDirection(sessionpart);
  }
  return 'sendrecv';
};

SDPUtils.getKind = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  return mline[0].substr(2);
};

SDPUtils.isRejected = function(mediaSection) {
  return mediaSection.split(' ', 2)[1] === '0';
};

SDPUtils.parseMLine = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var parts = lines[0].substr(2).split(' ');
  return {
    kind: parts[0],
    port: parseInt(parts[1], 10),
    protocol: parts[2],
    fmt: parts.slice(3).join(' ')
  };
};

SDPUtils.parseOLine = function(mediaSection) {
  var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
  var parts = line.substr(2).split(' ');
  return {
    username: parts[0],
    sessionId: parts[1],
    sessionVersion: parseInt(parts[2], 10),
    netType: parts[3],
    addressType: parts[4],
    address: parts[5]
  };
};

// a very naive interpretation of a valid SDP.
SDPUtils.isValidSDP = function(blob) {
  if (typeof blob !== 'string' || blob.length === 0) {
    return false;
  }
  var lines = SDPUtils.splitLines(blob);
  for (var i = 0; i < lines.length; i++) {
    if (lines[i].length < 2 || lines[i].charAt(1) !== '=') {
      return false;
    }
    // TODO: check the modifier a bit more.
  }
  return true;
};

// Expose public methods.
if (true) {
  module.exports = SDPUtils;
}


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculateCapableSimulcastStreams;
/**
 * Returns the number of streams allowed for simulcast
 * @param {Boolean} isChromiumEdge
 * @param {String} browserName
 * @param {Boolean} capableSimulcastScreenshare
 * @param {Boolean} isScreenSharing
 * @param {Boolean} isCustomVideoTrack
 * @param {Boolean} scalableVideo
 * @param {Object} sessionInfo
 * @param {Object} constraints
 * @param {Object} videoDimensions
 * @return {Number}
*/
function calculateCapableSimulcastStreams(opt) {
  const supportedBrowsers = ['Chrome', 'Safari', 'Edge', 'Opera'];
  if (supportedBrowsers.indexOf(opt.browserName) === -1 || opt.browserName === 'Edge' && !opt.isChromiumEdge || opt.isScreenSharing && !opt.capableSimulcastScreenshare || opt.sessionInfo.p2pEnabled || !opt.constraints.video && !opt.isCustomVideoTrack || opt.scalableVideo === false) {
    // We only support simulcast on Chromium browsers and Safari for routed sessions
    return 1;
  }

  // HD and above gets three streams. Otherwise they get 2.
  if (opt.videoDimensions.width > 640 && opt.videoDimensions.height > 480) {
    return 3;
  }
  return 2;
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = generateConstraintInfo;
var _merge = _interopRequireDefault(__webpack_require__(279));
var _normalizeConstraintInput = _interopRequireDefault(__webpack_require__(613));
var _isScreenSharingSource = _interopRequireDefault(__webpack_require__(160));
function createSourceConstraint(media, enableRenegotiation, usingOptionalMandatoryStyle) {
  if (!media.publish && enableRenegotiation) {
    // FIXME: I'm still not quite happy with how this works. With renegotiation, when publish
    // changes to true we shouldn't have to recalculate constraints. I think Publisher should handle
    // this override instead and this component shouldn't know anything about renegotiation.
    // Related: OPENTOK-31082
    return false;
  }
  if (typeof media.source === 'boolean') {
    return media.source;
  }
  if (usingOptionalMandatoryStyle) {
    return {
      mandatory: {
        sourceId: media.source
      }
    };
  }

  // getDisplayMedia doesn't support exact constraints
  if ((0, _isScreenSharingSource.default)(media.source)) {
    return {};
  }
  return {
    deviceId: {
      exact: media.source
    }
  };
}
function generateAudioConstraints(opt) {
  let constraints = createSourceConstraint(opt.audio, opt.enableRenegotiation, opt.usingOptionalMandatoryStyle);
  if (constraints === false) {
    return false;
  }
  const usingOptionalMandatoryStyle = opt.usingOptionalMandatoryStyle,
    enableStereo = opt.enableStereo,
    echoCancellation = opt.echoCancellation,
    noiseSuppression = opt.noiseSuppression,
    autoGainControl = opt.autoGainControl,
    disableAudioProcessing = opt.disableAudioProcessing;
  const addConstraint = constraint => {
    if (typeof constraints !== 'object') return;

    // Chrome<61 uses optional/mandatory style because a boolean is equivalent to an ideal value
    // See https://bugs.chromium.org/p/chromium/issues/detail?id=700223#c3
    if (usingOptionalMandatoryStyle) {
      (0, _merge.default)(constraints, {
        optional: []
      });
      constraints.optional.push(constraint);
    } else {
      (0, _merge.default)(constraints, constraint);
    }
  };
  if ((enableStereo || disableAudioProcessing || !echoCancellation || !noiseSuppression || !autoGainControl) && constraints === true) {
    constraints = {};
  }
  if (enableStereo) {
    addConstraint({
      channelCount: 2
    });
  }
  ['echoCancellation', 'autoGainControl', 'noiseSuppression'].forEach(audioConstraintName => {
    const constraintValue = !disableAudioProcessing && opt[audioConstraintName];
    addConstraint({
      [audioConstraintName]: constraintValue
    });
  });
  return constraints;
}
function generateVideoConstraints(opt) {
  let constraints = createSourceConstraint(opt.video, opt.enableRenegotiation, opt.usingOptionalMandatoryStyle);
  if (constraints === false) {
    return false;
  }
  const videoDimensions = opt.videoDimensions,
    frameRate = opt.frameRate,
    maxResolution = opt.maxResolution,
    facingMode = opt.facingMode,
    usingOptionalMandatoryStyle = opt.usingOptionalMandatoryStyle;
  if ((videoDimensions || frameRate || maxResolution || facingMode) && constraints === true) {
    constraints = {};
  }
  if (videoDimensions) {
    const width = videoDimensions.width;
    const height = videoDimensions.height;
    if (usingOptionalMandatoryStyle) {
      (0, _merge.default)(constraints, {
        optional: []
      });
      constraints.optional.push({
        minWidth: width
      }, {
        maxWidth: width
      }, {
        minHeight: height
      }, {
        maxHeight: height
      });
    } else {
      (0, _merge.default)(constraints, {
        width: {
          ideal: width
        },
        height: {
          ideal: height
        }
      });
    }
  }
  if (frameRate) {
    if (usingOptionalMandatoryStyle) {
      (0, _merge.default)(constraints, {
        optional: []
      });
      constraints.optional.push({
        minFrameRate: frameRate
      }, {
        maxFrameRate: frameRate
      });
    } else {
      (0, _merge.default)(constraints, {
        frameRate: {
          ideal: frameRate
        }
      });
    }
  }
  if (maxResolution) {
    if (usingOptionalMandatoryStyle) {
      (0, _merge.default)(constraints, {
        mandatory: {
          maxWidth: maxResolution.width,
          maxHeight: maxResolution.height
        }
      });
    } else {
      (0, _merge.default)(constraints, {
        width: {
          max: maxResolution.width
        },
        height: {
          max: maxResolution.height
        }
      });
    }
  }
  if (facingMode) {
    if (usingOptionalMandatoryStyle) {
      (0, _merge.default)(constraints, {
        optional: []
      });
      constraints.optional.push({
        facingMode
      });
    } else {
      (0, _merge.default)(constraints, {
        facingMode: {
          ideal: facingMode
        }
      });
    }
  }
  return constraints;
}
function generateConstraints(opt) {
  return {
    audio: generateAudioConstraints(opt),
    video: generateVideoConstraints(opt)
  };
}
function generateConstraintInfo(opt) {
  const normOpt = (0, _normalizeConstraintInput.default)(opt);
  const constraints = generateConstraints(normOpt);
  return {
    constraints,
    publishAudio: normOpt.audio.publish,
    publishVideo: normOpt.video.publish,
    frameRate: normOpt.frameRate,
    videoDimensions: normOpt.videoDimensions,
    audioDeviceId: typeof normOpt.audio.source === 'string' ? normOpt.audio.source : undefined,
    videoDeviceId: typeof normOpt.video.source === 'string' ? normOpt.video.source : undefined
  };
}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(610),
    createAssigner = __webpack_require__(207);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(64),
    eq = __webpack_require__(54);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(61),
    upperFirst = __webpack_require__(283);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(618);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 285 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(620),
    hasUnicode = __webpack_require__(285),
    unicodeToArray = __webpack_require__(621);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
const name = _env.default.name,
  version = _env.default.version,
  isChromiumEdge = _env.default.isChromiumEdge;
var _default = isChromiumEdge || name === 'Chrome' && version >= 72 || name === 'Firefox' && version >= 66 || name === 'Opera' && version >= 60 || name === 'Safari';
exports.default = _default;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
/*
the capture screen share with audio is only avaible for Chrome >= 74 & Chromium Edge >= 79, see
https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#browser_compatibility

Also note that capture audio is only avaible for the user via the checkmark in tab selection
*/
var _default = Boolean(_env.default.isChrome && _env.default.version >= 74 || _env.default.isEdge && _env.default.version >= 79);
exports.default = _default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
/* global MediaStreamTrack */
var _default = videoSource => {
  if (!_env.default.isElectron) {
    return false;
  }

  // ElectronJS sets the label to the same value for screensharing sources,
  // regardless of the DesktopCapturer source type
  return videoSource instanceof MediaStreamTrack && videoSource.label === 'Screen';
};
exports.default = _default;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(105),
    createBaseEach = __webpack_require__(627);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = 15000;
exports.default = _default;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
/**
 * castToBoolean
 *
 * @param {any} The value to cast
 * @returns {Boolean} True if value === 'true' or value === true, otherwise false.
 */

const castToBoolean = function castToBoolean(value, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }
  return value === undefined ? defaultValue : value === 'true' || value === true;
};
var _default = castToBoolean;
exports.default = _default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = styleHashLogFilter;
var _cloneDeep = _interopRequireDefault(__webpack_require__(62));
// The backgroundImageURI of the styleHash object that we log to analytics needs to be stripped down
// because base64 data blobs are often very large and can be a privacy issue if taken from the
// user's camera.
function styleHashLogFilter(styleHashInput) {
  const styleHash = (0, _cloneDeep.default)(styleHashInput);
  if (styleHash.backgroundImageURI) {
    const protocol = styleHash.backgroundImageURI.split(':')[0];
    styleHash.backgroundImageURI = ['http', 'https', 'data'].indexOf(protocol) !== -1 ? protocol : 'other';
  }
  return styleHash;
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _default = () => {
  const isBrowser = !_env.default.isNode && !_env.default.isElectron;
  if (!isBrowser) {
    return false;
  }

  // More recent browsers don't expose GUM when called in insecure context
  // From https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
  const isSecureContextRequired =
  // See https://www.chromestatus.com/feature/4924861776396288
  (_env.default.isChrome || _env.default.isOpera || _env.default.isChromiumEdge) && _env.default.version >= 74 || _env.default.isFirefox && _env.default.version >= 68 ||
  // See https://webkit.org/blog/7763/a-closer-look-into-webrtc/
  _env.default.isSafari && _env.default.version >= 11;
  return isSecureContextRequired;
};
exports.default = _default;

/***/ }),
/* 295 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11),
    now = __webpack_require__(643),
    toNumber = __webpack_require__(248);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    baseClone = __webpack_require__(80),
    baseUnset = __webpack_require__(644),
    castPath = __webpack_require__(60),
    copyObject = __webpack_require__(44),
    customOmitClone = __webpack_require__(647),
    flatRest = __webpack_require__(144),
    getAllKeysIn = __webpack_require__(200);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(246),
    baseIteratee = __webpack_require__(37),
    toInteger = __webpack_require__(100);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(649);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const MediaDirection = {
  INACTIVE: 'inactive',
  RECVONLY: 'recvonly',
  SENDONLY: 'sendonly',
  SENDRECV: 'sendrecv'
};
var _default = MediaDirection;
exports.default = _default;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
const generateKey = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(salt, secret) {
    var isExtractableKeyMaterial, isExtractableDerivedKey, enc, keyMaterial;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // isExtractableKeyMaterial and isExtractableDerivedKey indicates whether it will be possible
          // to export the key using SubtleCrypto.exportKey() or SubtleCrypto.wrapKey().
          isExtractableKeyMaterial = false;
          isExtractableDerivedKey = true;
          enc = new TextEncoder();
          _context.next = 5;
          return window.crypto.subtle.importKey('raw', enc.encode(secret), {
            name: 'PBKDF2'
          }, isExtractableKeyMaterial, ['deriveBits', 'deriveKey']);
        case 5:
          keyMaterial = _context.sent;
          return _context.abrupt("return", window.crypto.subtle.deriveKey({
            name: 'PBKDF2',
            salt: enc.encode(salt),
            iterations: 100000,
            hash: 'SHA-256'
          }, keyMaterial, {
            name: 'AES-CTR',
            length: 256
          }, isExtractableDerivedKey, ['encrypt', 'decrypt']));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function generateKey(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = generateKey;
exports.default = _default;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _toArray = _interopRequireDefault(__webpack_require__(657));
var _get_rtc_stats_report_adapter = _interopRequireDefault(__webpack_require__(305));
var _shouldUseStandardGetStats = _interopRequireDefault(__webpack_require__(111));
const shouldUseStandardGetStats = (0, _shouldUseStandardGetStats.default)();

// This returns the array-ified list of stats our users are accustomed to
var _default = (peerConnection, track, completion) => {
  (0, _get_rtc_stats_report_adapter.default)(peerConnection, track, (err, rtcStatsReport) => {
    if (err) {
      completion(err);
      return;
    }
    let stats = [];
    if (shouldUseStandardGetStats) {
      // Firefox <= 45 can't use rtcStatsReport.values OPENTOK-32755
      if (typeof rtcStatsReport.values === 'function') {
        stats = (0, _toArray.default)(rtcStatsReport.values());
      } else if (typeof rtcStatsReport.forEach !== 'function') {
        stats = Object.keys(rtcStatsReport).map(key => rtcStatsReport[key]);
      } else {
        rtcStatsReport.forEach(rtcStats => {
          stats.push(rtcStats);
        });
      }
    } else {
      rtcStatsReport.result().forEach(rtcStat => {
        const stat = {};
        rtcStat.names().forEach(name => {
          stat[name] = rtcStat.stat(name);
        });

        // fake the structure of the "new" RTC stat object
        stat.id = rtcStat.id;
        stat.type = rtcStat.type;
        stat.timestamp = rtcStat.timestamp;
        stats.push(stat);
      });
    }
    completion(null, stats);
  });
};
exports.default = _default;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isArray = __webpack_require__(14),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(659),
    keys = __webpack_require__(34);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _shouldUseStandardGetStats = _interopRequireDefault(__webpack_require__(111));
const shouldUseStandardGetStats = (0, _shouldUseStandardGetStats.default)();
const getRtcStats = (peerConnection, track, completion) => {
  peerConnection.getStats(track).then(stats => completion(null, stats)).catch(completion);
};
const getRtcStatsLegacy = (peerConnection, completion) => {
  peerConnection.getStats(stats => {
    completion(null, stats);
  }, completion);
};

// This returns the native or "raw" RtcStatsReport object
const getRtcStatsReportAdapter = (peerConnection, track, completion) => {
  if (shouldUseStandardGetStats) {
    getRtcStats(peerConnection, track, completion);
  } else {
    getRtcStatsLegacy(peerConnection, completion);
  }
};
var _default = getRtcStatsReportAdapter;
exports.default = _default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _events = __webpack_require__(12);
var _clone = _interopRequireDefault(__webpack_require__(41));
var _parseQOS = _interopRequireDefault(__webpack_require__(671));
var _TruthyChangeCounter = _interopRequireDefault(__webpack_require__(673));
var _now = _interopRequireDefault(__webpack_require__(51));
var _log = _interopRequireDefault(__webpack_require__(1));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, no-void, no-use-before-define, one-var */
/* eslint-disable no-restricted-syntax, no-prototype-builtins */

const logging = (0, _log.default)('QoS');
let Qos = /*#__PURE__*/function (_EventEmitter) {
  (0, _inheritsLoose2.default)(Qos, _EventEmitter);
  function Qos() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _EventEmitter.call(this, ...args) || this;
    _this._peerConnection = void 0;
    _this._isPublisher = void 0;
    _this.timeoutId = void 0;
    _this._creationTime = (0, _now.default)();
    _this.offerMessagesReceived = 0;
    _this.prevStats = {
      timeStamp: (0, _now.default)()
    };
    _this.changeCounters = {
      videoCodec: new _TruthyChangeCounter.default(),
      audioCodec: new _TruthyChangeCounter.default()
    };
    return _this;
  }
  var _proto = Qos.prototype;
  _proto.startCollecting = function startCollecting(peerConnection, isPublisher) {
    if (!peerConnection || !peerConnection.getStats) {
      // this peerConnection doesn't support getStats, bail
      return;
    }
    this._isPublisher = isPublisher;
    const hadPeerConnection = Boolean(this._peerConnection);
    this._peerConnection = peerConnection;
    if (hadPeerConnection) {
      return;
    }
    const collectionLoop = interval => {
      const currentTime = (0, _now.default)();

      // parseQOS pushes properties onto this object and gives it back
      const blankStats = {
        timeStamp: currentTime,
        duration: Math.round((currentTime - this._creationTime) / 1000),
        period: Math.round((currentTime - this.prevStats.timeStamp) / 1000)
      };
      (0, _parseQOS.default)(this._peerConnection, this.prevStats, blankStats, this._isPublisher, (err, parsedStats) => {
        if (err) {
          logging.error('Failed to Parse QOS Stats:', err);
          return;
        }
        this.handleParsedStats(parsedStats);

        // Recalculate the stats
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => collectionLoop(Qos.INTERVAL), interval);
      });
    };
    this.timeoutId = setTimeout(() => collectionLoop(Qos.INTERVAL - Qos.INITIAL_INTERVAL), Qos.INITIAL_INTERVAL);
  };
  _proto.stopCollecting = function stopCollecting() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this._peerConnection = null;
  };
  _proto.handleOfferMessageReceived = function handleOfferMessageReceived() {
    this.offerMessagesReceived += 1;
  };
  _proto.handleParsedStats = function handleParsedStats(parsedStats) {
    Object.keys(this.changeCounters).forEach(key => {
      this.changeCounters[key].onValue(parsedStats[key]);
      // audioCodecChangeCount, videoCodecChangeCount
      parsedStats[`${key}ChangeCount`] = this.changeCounters[key].changeCount;
    });
    parsedStats.offerMessagesReceived = this.offerMessagesReceived;
    const periodicStats = (0, _clone.default)(parsedStats);

    // The following stats are reported with cumulative values:
    const periodicDataKeys = ['audioSentBytes', 'audioSentPackets', 'audioSentPacketsLost', 'videoSentBytes', 'videoSentPackets', 'videoSentPacketsLost', 'audioRecvBytes', 'audioRecvPackets', 'audioRecvPacketsLost', 'videoRecvBytes', 'videoRecvPackets', 'videoRecvPacketsLost'];

    // This adjusts the QoS values to be periodic, rather than cumulative:
    periodicDataKeys.forEach(dataKey => {
      periodicStats[dataKey] = this.prevStats && this.prevStats[dataKey] ? parsedStats[dataKey] - this.prevStats[dataKey] : parsedStats[dataKey];
    });
    if (this.prevStats && this.prevStats.videoFramesReceived) {
      const framesReceived = parsedStats.videoFramesReceived - this.prevStats.videoFramesReceived;
      const period = parsedStats.period;
      periodicStats.videoFrameRateReceived = Math.round(framesReceived / period);
    }
    this.prevStats = parsedStats;

    // We only need framesDecoded and framesEncoded in prevStats for calculating the video framerate
    // in Firefox 96+. So we can safely delete it from periodicStats to avoid putting it in the
    // QOS log.
    delete periodicStats.framesDecoded;
    delete periodicStats.framesEncoded;
    this.emit('stats', periodicStats);
  };
  return Qos;
}(_events.EventEmitter); // Send stats after 1 sec
Qos.INITIAL_INTERVAL = 1000;
// Recalculate the stats every 30 sec
Qos.INTERVAL = 30000;
var _default = Qos;
exports.default = _default;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = priority => {
  switch (priority >> 24) {
    // eslint-disable-line no-bitwise
    case 0:
      return 'TURN/TLS';
    case 1:
      return 'TURN/TCP';
    case 2:
      return 'TURN/UDP';
    default:
      return '';
  }
};
exports.default = _default;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = chromeExtensionHelperFactory;
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _haveGetDisplayMedia = _interopRequireDefault(__webpack_require__(169));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require, no-void, prefer-rest-params, no-shadow */

function chromeExtensionHelperFactory(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$haveGetDisplayMe = _ref.haveGetDisplayMedia,
    haveGetDisplayMedia = _ref$haveGetDisplayMe === void 0 ? _haveGetDisplayMedia.default : _ref$haveGetDisplayMe,
    _ref$global = _ref.global,
    context = _ref$global === void 0 ? (typeof window !== undefined ? window : global) : _ref$global,
    _ref$Errors = _ref.Errors,
    Errors = _ref$Errors === void 0 ? _Errors.default : _ref$Errors,
    _ref$otError = _ref.otError,
    otError = _ref$otError === void 0 ? (0, _otError.default)() : _ref$otError;
  const isSupportedInThisBrowser =
  // don't bother supporting extension when we have display media
  !haveGetDisplayMedia && !!context.navigator.webkitGetUserMedia && !context.navigator.userAgent.match(/android/i) && typeof context.chrome !== 'undefined';
  return {
    isSupportedInThisBrowser,
    autoRegisters: false,
    extensionRequired: true,
    getConstraintsShowsPermissionUI: true,
    sources: {
      screen: true,
      application: false,
      window: true,
      browser: true
    },
    register(extensionID, version) {
      if (version === 2) {
        return this.registerVersion2(extensionID);
      }
      return this.registerVersion1(extensionID);
    },
    registerVersion1(extensionID) {
      if (!extensionID) {
        throw new Error('initChromeScreenSharingExtensionHelper: extensionID is required.');
      }
      const isChrome = isSupportedInThisBrowser;
      const callbackRegistry = {};
      let isInstalled = void 0;
      const prefix = `com.tokbox.screenSharing.${extensionID}`;
      const request = function request(method, payload) {
        const res = {
          payload,
          from: 'jsapi'
        };
        res[prefix] = method;
        return res;
      };
      const addCallback = function addCallback(fn, timeToWait) {
        let timeout;
        const requestId = (0, _uuid.default)();
        callbackRegistry[requestId] = function () {
          clearTimeout(timeout);
          timeout = null;
          fn(...arguments);
        };
        if (timeToWait) {
          timeout = setTimeout(() => {
            delete callbackRegistry[requestId];
            fn(otError(Errors.TIMEOUT, new Error('Timeout waiting for response to screensharing request.')));
          }, timeToWait);
        }
        return requestId;
      };
      const isAvailable = function isAvailable(callback) {
        if (!callback) {
          throw new Error('isAvailable: callback is required.');
        }
        if (!isChrome) {
          setTimeout(callback.bind(null, false));
          return;
        }
        if (isInstalled !== void 0) {
          setTimeout(callback.bind(null, isInstalled));
        } else {
          const requestId = addCallback(event => {
            if (isInstalled !== true) {
              isInstalled = event === 'extensionLoaded';
            }
            callback(isInstalled);
          }, 2000);
          const post = request('isExtensionInstalled', {
            requestId
          });
          context.postMessage(post, '*');
        }
      };
      const getConstraints = function getConstraints(source, constraints, callback) {
        if (!callback) {
          throw new Error('getSourceId: callback is required');
        }
        isAvailable(isInstalled => {
          if (!isInstalled) {
            return callback(otError(Errors.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error('Extension is not installed')));
          }
          const requestId = addCallback((event, payload) => {
            if (typeof event === 'object' && event.name && event.stack) {
              // FIXME: The callback shouldn't be overloaded like this ('event' is actually an
              // error), but I'm adding tests and don't want to refactor right now without testing
              // more thorougly.
              const error = event;
              callback(error);
            } else if (event === 'permissionDenied') {
              callback(otError(Errors.USER_MEDIA_ACCESS_DENIED, new Error('User denied access to screensharing')));
            } else {
              if (!constraints.video) {
                constraints.video = {};
              }
              if (!constraints.video.mandatory) {
                constraints.video.mandatory = {};
              }
              constraints.video.mandatory.chromeMediaSource = 'desktop';
              constraints.video.mandatory.chromeMediaSourceId = payload.sourceId;
              callback(void 0, constraints);
            }
          });
          context.postMessage(request('getSourceId', {
            requestId,
            source
          }), '*');
          return undefined;
        });
      };
      context.addEventListener('message', event => {
        if (event.origin !== context.location.origin) {
          return;
        }
        if (!(event.data != null && typeof event.data === 'object')) {
          return;
        }
        if (event.data.from !== 'extension') {
          return;
        }
        const method = event.data[prefix];
        const payload = event.data.payload;
        if (payload && payload.requestId) {
          const callback = callbackRegistry[payload.requestId];
          delete callbackRegistry[payload.requestId];
          if (callback) {
            callback(method, payload);
          }
        }
        if (method === 'extensionLoaded') {
          isInstalled = true;
        }
      });
      return {
        extensionAPIVersion: 1,
        extensionID,
        isInstalled: isAvailable,
        getConstraints
      };
    },
    registerVersion2(extensionID) {
      const isChrome = isSupportedInThisBrowser && typeof context.chrome.runtime !== 'undefined';
      const isInstalled = function isInstalled(callback) {
        if (!callback) {
          throw new Error('isAvailable: callback is required.');
        }
        if (!isChrome) {
          setTimeout(callback.bind(null, false));
          return;
        }
        context.chrome.runtime.sendMessage(extensionID, {
          type: 'isInstalled'
        }, null, response => {
          setTimeout(callback.bind(null, !!response));
        });
      };
      const getConstraints = function getConstraints(source, constraints, callback) {
        if (!callback) {
          throw new Error('getSourceId: callback is required');
        }
        isInstalled(installed => {
          if (!installed) {
            return callback(otError(Errors.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error('Extension is not installed')));
          }
          context.chrome.runtime.sendMessage(extensionID, {
            type: 'getSourceId',
            source
          }, null, data => {
            if (data.error === 'permissionDenied') {
              callback(otError(Errors.USER_MEDIA_ACCESS_DENIED, new Error('User denied access to screensharing')));
            } else if (data.error) {
              callback(new Error(`UnexpectError: ${data.error}`));
            } else {
              if (!constraints.video) {
                constraints.video = {};
              }
              if (!constraints.video.mandatory) {
                constraints.video.mandatory = {};
              }
              constraints.video.mandatory.chromeMediaSource = 'desktop';
              constraints.video.mandatory.chromeMediaSourceId = data.sourceId;
              callback(void 0, constraints);
            }
          });
          return undefined;
        });
      };
      return {
        extensionAPIVersion: 2,
        extensionID,
        isInstalled,
        getConstraints
      };
    }
  };
}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = createChromeMixinFactory;
var _log = _interopRequireDefault(__webpack_require__(1));
var _RafRunner = _interopRequireDefault(__webpack_require__(112));
var _createCleanupJobs = _interopRequireDefault(__webpack_require__(166));
var _archiving = _interopRequireDefault(__webpack_require__(676));
var _audio_level_meter = _interopRequireDefault(__webpack_require__(310));
var _audio_level_transformer = _interopRequireDefault(__webpack_require__(156));
var _backing_bar = _interopRequireDefault(__webpack_require__(311));
var _chrome3 = _interopRequireDefault(__webpack_require__(157));
var _mute_button = _interopRequireDefault(__webpack_require__(312));
var _name_panel = _interopRequireDefault(__webpack_require__(313));
var _video_disabled_indicator = _interopRequireDefault(__webpack_require__(314));
var _stylable_component = _interopRequireDefault(__webpack_require__(162));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable global-require */

function createChromeMixinFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const Archiving = deps.Archiving || _archiving.default;
  const AudioLevelMeter = deps.AudioLevelMeter || _audio_level_meter.default;
  const AudioLevelTransformer = deps.AudioLevelTransformer || _audio_level_transformer.default;
  const BackingBar = deps.BackingBar || _backing_bar.default;
  const Chrome = deps.Chrome || _chrome3.default;
  const MuteButton = deps.MuteButton || (0, _mute_button.default)();
  const NamePanel = deps.NamePanel || _name_panel.default;
  const VideoDisabledIndicator = deps.VideoDisabledIndicator || _video_disabled_indicator.default;
  const StylableComponent = deps.StylableComponent || _stylable_component.default;
  const logging = deps.logging || (0, _log.default)('createChromeMixin');
  return function createChromeMixin(publisher, _temp) {
    let _ref = _temp === void 0 ? {} : _temp,
      name = _ref.name,
      publishAudio = _ref.publishAudio,
      publishVideo = _ref.publishVideo,
      audioSource = _ref.audioSource,
      showControls = _ref.showControls,
      shouldAllowAudio = _ref.shouldAllowAudio,
      logAnalyticsEvent = _ref.logAnalyticsEvent;
    let audioLevelMeter;
    let chrome;
    let widgetView;
    const chromeMixin = {};
    const cleanupJobs = (0, _createCleanupJobs.default)();

    // If mode is false, then that is the mode. If mode is true then we'll
    // definitely display  the button, but we'll defer the model to the
    // Publishers buttonDisplayMode style property.
    const chromeButtonMode = mode => {
      if (mode === false) {
        return 'off';
      }
      const defaultMode = publisher.getStyle('buttonDisplayMode');

      // The default model is false, but it's overridden by +mode+ being true
      if (defaultMode === false) {
        return 'on';
      }

      // defaultMode is either true or auto.
      return defaultMode;
    };
    let uiPromise = new Promise((resolve, reject) => {
      chromeMixin.init = widgetViewParam => {
        if (!publisher.getStyle('showArchiveStatus')) {
          logAnalyticsEvent('showArchiveStatus', 'createChrome', {
            mode: 'off'
          });
        }
        const widgets = {
          backingBar: new BackingBar({
            nameMode: !name ? 'off' : publisher.getStyle('nameDisplayMode'),
            muteMode: chromeButtonMode(publisher.getStyle('buttonDisplayMode'))
          }),
          name: new NamePanel({
            name,
            mode: publisher.getStyle('nameDisplayMode')
          }),
          archive: new Archiving({
            show: Boolean(publisher.getStyle('showArchiveStatus')) && publisher.getStyle('archiveStatusDisplayMode') !== 'off',
            archiving: false
          }),
          muteButton: new MuteButton({
            muted: publishAudio === false,
            mode: chromeButtonMode.call(null, publisher.getStyle('buttonDisplayMode'))
          })
        };
        audioLevelMeter = new AudioLevelMeter({
          mode: publisher.getStyle('audioLevelDisplayMode')
        });
        const audioLevelTransformer = new AudioLevelTransformer();
        const audioWatcher = new _RafRunner.default(() => {
          // @FIXME
          // We force the audio level value to be zero here if audio is disabled
          // because the AudioLevelMeter cannot currently differentiate
          // between video being disabled and audio being disabled.
          // To be fixed as part of OPENTOK-29865

          const audioLevel = !publishAudio ? 0 : audioLevelTransformer.transform(publisher.loudness);
          audioLevelMeter.setValue(audioLevel);
        });
        audioLevelMeter.watchVisibilityChanged(visible => {
          if (visible) {
            audioWatcher.start();
          } else {
            audioWatcher.stop();
          }
        });
        audioLevelMeter.audioOnly(!publishVideo && publishAudio);
        widgets.audioLevel = audioLevelMeter;
        widgets.videoDisabledIndicator = new VideoDisabledIndicator({
          mode: publisher.getStyle('videoDisabledDisplayMode')
        });
        if (widgetViewParam && widgetViewParam.domElement) {
          widgetView = widgetViewParam;
          chrome = new Chrome({
            parent: widgetView.domElement
          }).set(widgets).on({
            muted: () => publisher.publishAudio(false),
            unmuted: () => publisher.publishAudio(true)
          });
          if (audioSource === null || audioSource === false) {
            chromeMixin.removeAudioTrack();
          }
          resolve();
        }
      };
      chromeMixin.reset = () => {
        // reject in case the chrome creating was still pending
        reject(new Error('Chrome still being created'));
        if (chrome) {
          chrome.destroy();
          chrome = null;
        }
      };
      chromeMixin.destroy = () => {
        chromeMixin.reset();
        cleanupJobs.releaseAll();
        uiPromise = null;
      };
    });
    uiPromise.catch(err => {
      // Only log unexpected rejections
      if (!err || err.message !== 'Chrome still being created') {
        logging.error('createChromeMixin failed to setup UI', err);
      }
    });
    chromeMixin.setAudioOnly = value => {
      if (audioLevelMeter) {
        audioLevelMeter.audioOnly(value);
      }
    };
    chromeMixin.setArchivingStatus = status => {
      if (chrome) {
        chrome.archive.setArchiving(status);
      }
    };
    chromeMixin.setMuted = muted => {
      if (chrome && chrome.muteButton) {
        chrome.muteButton.muted(muted);
      }
    };
    chromeMixin.removeAudioTrack = () => {
      if (chrome && chrome.muteButton) {
        chrome.muteButton.remove();
      }
    };
    chromeMixin.addAudioTrack = () => {
      if (chrome && chrome.muteButton) {
        chrome.muteButton.add();
      }
    };
    chromeMixin.videoDisabledIndicator = {
      disableVideo: function disableVideo() {
        var _chrome;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return (_chrome = chrome) == null ? void 0 : _chrome.videoDisabledIndicator.disableVideo(...args);
      },
      setWarning: function setWarning() {
        var _chrome2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return (_chrome2 = chrome) == null ? void 0 : _chrome2.videoDisabledIndicator.setWarning(...args);
      }
    };
    StylableComponent(publisher, {
      showArchiveStatus: true,
      nameDisplayMode: 'auto',
      buttonDisplayMode: 'auto',
      videoDisabledDisplayMode: 'auto',
      audioLevelDisplayMode: shouldAllowAudio ? 'auto' : 'off',
      archiveStatusDisplayMode: 'auto',
      backgroundImageURI: null
    }, showControls, payload => {
      logAnalyticsEvent('SetStyle', 'Publisher', payload, null, 0.1);
    });
    const onStyleValueChanged = (key, value) => {
      // enlist style change for when the the chrome is created
      uiPromise.then(() => {
        switch (key) {
          case 'nameDisplayMode':
            chrome.name.setDisplayMode(value);
            chrome.backingBar.setNameMode(value);
            break;
          case 'showArchiveStatus':
            logAnalyticsEvent('showArchiveStatus', 'styleChange', {
              mode: value ? 'on' : 'off'
            });
            chrome.archive.setShowArchiveStatus(Boolean(value));
            break;
          case 'archiveStatusDisplayMode':
            chrome.archive.setShowArchiveStatus(value !== 'off');
            break;
          case 'buttonDisplayMode':
            chrome.muteButton.setDisplayMode(value);
            chrome.backingBar.setMuteMode(value);
            break;
          case 'audioLevelDisplayMode':
            chrome.audioLevel.setDisplayMode(value);
            break;
          case 'backgroundImageURI':
            widgetView.setBackgroundImageURI(value);
            break;
          default:
        }
      });
    };
    publisher.on('styleValueChanged', onStyleValueChanged);
    cleanupJobs.add(() => publisher.off('styleValueChanged', onStyleValueChanged));
    return chromeMixin;
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = AudioLevelMeter;
var _events = _interopRequireDefault(__webpack_require__(12));
var _defineProperties = _interopRequireDefault(__webpack_require__(108));
var _widget = _interopRequireDefault(__webpack_require__(40));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable one-var, no-mixed-operators */

function AudioLevelMeter(options) {
  const _audioLevelMeter = this;
  const _eventEmitter = new _events.default();
  let _voiceOnlyIconElement;
  let _meterValueElement;
  let _value;
  let _lastComputedVisibility;

  // display the widget by default but can be hidden when calling hideWhileLoading
  let _displayAroundLoading = true;
  let _audioOnly = false;
  let _displayMode = 'auto';
  const _maxValue = options.maxValue || 1;
  const _minValue = options.minValue || 0;
  function onCreate() {
    _meterValueElement = _OTHelpers.default.createElement('div', {
      className: 'OT_audio-level-meter__value'
    }, '');
    _voiceOnlyIconElement = _OTHelpers.default.createElement('div', {
      className: 'OT_audio-level-meter__audio-only-img'
    }, '');
    const domElement = _audioLevelMeter.domElement;
    domElement.appendChild(_voiceOnlyIconElement);
    domElement.appendChild(_meterValueElement);
    _audioLevelMeter.watchVisibilityChanged(visible => {
      if (visible) {
        _OTHelpers.default.removeClass(_audioLevelMeter.domElement, 'OT_hide-forced');
      } else {
        _OTHelpers.default.addClass(_audioLevelMeter.domElement, 'OT_hide-forced');
      }
    });
  }
  function onDestroy() {
    _eventEmitter.removeAllListeners('visibilityChanged');
  }
  function updateView() {
    const percentSize = (_value - _minValue) / (_maxValue - _minValue);
    _meterValueElement.style.transform = `scale(${Math.sqrt(percentSize)})`;
  }

  // computes the visibility value from the different "inputs" variables and asynchronously triggers
  // the internal "visibilityChanged" events if the value changed from last time it was computed
  function computeVisibility() {
    const computedVisibility = (_audioOnly && _displayMode === 'auto' || _displayMode === 'on') && _displayAroundLoading;
    if (_lastComputedVisibility !== computedVisibility) {
      _lastComputedVisibility = computedVisibility;
      _eventEmitter.emit('visibilityChanged', computedVisibility);
    }
  }
  (0, _defineProperties.default)(_audioLevelMeter, {
    audioOnly: {
      get() {
        return _audioOnly;
      },
      set(audioOnly) {
        _audioOnly = audioOnly;
        computeVisibility();
      }
    }
  });
  _audioLevelMeter.setValue = function (value) {
    _value = value;
    updateView();
  };

  /**
   * Registers an callback to be executed when the visibility of the audio level meter changes.
   * "true" means the widget is shown.
   * The contracts is that the handlers should not try to change the visibility of the widget by
   * changing the value of visibility "inputs" (setting "audioOnly", "displayMode" or calling
   * "hideWhileLoading" and "showAfterLoading")
   *
   * @param {function(boolean)} cb the callback to be executed when the display value changes.
   * The callback is also executed with the last computed value when registered.
   * @returns {function} a callback to unregister the handler
   */
  _audioLevelMeter.watchVisibilityChanged = function (cb) {
    _eventEmitter.on('visibilityChanged', cb);
    Promise.resolve().then(() => {
      cb(_lastComputedVisibility);
    });
    return function stopWatching() {
      _eventEmitter.removeListener('visibilityChanged', cb);
    };
  };

  // Mixin common widget behaviour
  const widgetOptions = {
    mode: options ? options.mode : 'auto',
    nodeName: 'div',
    htmlAttributes: {
      className: 'OT_audio-level-meter'
    },
    onCreate,
    onDestroy
  };
  (0, _widget.default)(this, widgetOptions);

  // The methods underneath are mixed in by "Widget" but overridden
  // Doing so, we can bypass it and compute the display value ourselves without relying on CSS
  _audioLevelMeter.setDisplayMode = function (mode) {
    _displayMode = mode;
    computeVisibility();
  };
  _audioLevelMeter.getDisplayMode = function () {
    return _displayMode;
  };
  _audioLevelMeter.showAfterLoading = function () {
    _displayAroundLoading = true;
    computeVisibility();
  };
  _audioLevelMeter.hideWhileLoading = function () {
    _displayAroundLoading = false;
    computeVisibility();
  };

  // compute the initial visibility value
  computeVisibility();
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = BackingBar;
var _widget = _interopRequireDefault(__webpack_require__(40));
// @todo enable the following disabled rules see OPENTOK-31136 for more info

// BackingBar Chrome Widget
//
// nameMode (String)
// Whether or not the name panel is being displayed
// Possible values are: "auto" (the name is displayed
// when the stream is first displayed and when the user mouses over the display),
// "off" (the name is not displayed), and "on" (the name is displayed).
//
// muteMode (String)
// Whether or not the mute button is being displayed
// Possible values are: "auto" (the mute button is displayed
// when the stream is first displayed and when the user mouses over the display),
// "off" (the mute button is not displayed), and "on" (the mute button is displayed).
//
// displays a backing bar
// can be shown/hidden
// can be destroyed
function BackingBar(options) {
  let _nameMode = options.nameMode;
  let _muteMode = options.muteMode;
  function getDisplayMode() {
    if (_nameMode === 'on' || _muteMode === 'on') {
      return 'on';
    } else if (_nameMode === 'mini' || _muteMode === 'mini') {
      return 'mini';
    } else if (_nameMode === 'mini-auto' || _muteMode === 'mini-auto') {
      return 'mini-auto';
    } else if (_nameMode === 'auto' || _muteMode === 'auto') {
      return 'auto';
    }
    return 'off';
  }

  // Mixin common widget behaviour
  (0, _widget.default)(this, {
    mode: getDisplayMode(),
    nodeName: 'div',
    htmlContent: '',
    htmlAttributes: {
      className: 'OT_bar OT_edge-bar-item'
    }
  });
  this.setNameMode = function (nameMode) {
    _nameMode = nameMode;
    this.setDisplayMode(getDisplayMode());
  };
  this.setMuteMode = function (muteMode) {
    _muteMode = muteMode;
    this.setDisplayMode(getDisplayMode());
  };
}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = MuteButtonFactory;
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _widget = _interopRequireDefault(__webpack_require__(40));
var _defineProperties = _interopRequireDefault(__webpack_require__(108));
function MuteButtonFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const Widget = deps.Widget || _widget.default;
  return function MuteButton(options) {
    let muted = options.muted || false;
    const updateClasses = () => {
      if (muted) {
        OTHelpers.addClass(this.domElement, 'OT_active');
      } else {
        OTHelpers.removeClass(this.domElement, 'OT_active ');
      }
    };
    const onClick = () => {
      muted = !muted;
      updateClasses();
      if (muted) {
        this.parent.trigger('muted', this);
      } else {
        this.parent.trigger('unmuted', this);
      }
      return false;
    };

    // Private Event Callbacks
    const attachEvents = elem => {
      OTHelpers.on(elem, 'click', onClick);
    };
    const detachEvents = elem => {
      OTHelpers.off(elem, 'click', onClick);
    };
    (0, _defineProperties.default)(this, {
      muted: {
        get() {
          return muted;
        },
        set(m) {
          muted = m;
          updateClasses();
        }
      }
    });

    // Mixin common widget behaviour
    const classNames = muted ? 'OT_edge-bar-item OT_mute OT_active' : 'OT_edge-bar-item OT_mute';
    Widget(this, {
      mode: options.mode,
      nodeName: 'button',
      htmlContent: 'Mute',
      htmlAttributes: {
        className: classNames,
        type: 'button'
      },
      onCreate: attachEvents,
      onDestroy: detachEvents
    });
    let parentNode;
    this.remove = () => {
      if (this.domElement && this.domElement.parentNode) {
        parentNode = this.domElement.parentNode; // store in case we want to add it again
        this.domElement.parentNode.removeChild(this.domElement);
      }
    };
    this.add = () => {
      if (parentNode && this.domElement && !this.domElement.parentNode) {
        parentNode.appendChild(this.domElement);
      }
    };
  };
}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = NamePanel;
var _widget = _interopRequireDefault(__webpack_require__(40));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

// The "name" that we receive (e.g., from RUMOR) may actually be malicious HTML
// so we need to sanitize it before it gets rendered.
// See: OPENTOK-41141.
const sanitizeName = name => {
  const temp = document.createElement('div');
  temp.textContent = name;
  return temp.innerHTML;
};

// NamePanel Chrome Widget
//
// mode (String)
// Whether to display the name. Possible values are: "auto" (the name is displayed
// when the stream is first displayed and when the user mouses over the display),
// "off" (the name is not displayed), and "on" (the name is displayed).
//
// displays a name
// can be shown/hidden
// can be destroyed
function NamePanel(options) {
  let _name = options.name;
  if (!_name || _name.trim().length === '') {
    _name = null;

    // THere's no name, just flip the mode off
    options.mode = 'off';
  }
  this.setName = function (name) {
    if (!_name) {
      this.setDisplayMode('auto');
    }
    _name = sanitizeName(name);

    // The "name" is initially rendered as `innerHTML` when instantiated (as a
    // `Widget`).  That's why we don't use `textContent` here, instead.
    this.domElement.innerHTML = _name;
  }.bind(this);
  _name = sanitizeName(_name);

  // Mixin common widget behaviour
  (0, _widget.default)(this, {
    mode: options.mode,
    nodeName: 'h1',
    htmlContent: _name,
    htmlAttributes: {
      className: 'OT_name OT_edge-bar-item'
    }
  });
}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = VideoDisabledIndicator;
var _widget = _interopRequireDefault(__webpack_require__(40));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
function VideoDisabledIndicator(options) {
  let videoDisabled = false;
  let warning = false;
  const updateClasses = function (element) {
    const shouldDisplay = ['auto', 'on'].indexOf(this.getDisplayMode()) > -1;
    _OTHelpers.default.removeClass(element, 'OT_video-disabled OT_video-disabled-warning OT_active');
    if (!shouldDisplay) {
      return;
    }
    if (videoDisabled) {
      _OTHelpers.default.addClass(element, 'OT_video-disabled');
    } else if (warning) {
      _OTHelpers.default.addClass(element, 'OT_video-disabled-warning');
    }
    _OTHelpers.default.addClass(element, 'OT_active');
  }.bind(this);
  this.disableVideo = function (value) {
    videoDisabled = value;
    if (value === true) {
      warning = false;
    }
    updateClasses(this.domElement);
  };
  this.setWarning = function (value) {
    warning = value;
    updateClasses(this.domElement);
  };

  // Mixin common widget behaviour
  (0, _widget.default)(this, {
    mode: options.mode || 'auto',
    nodeName: 'div',
    htmlAttributes: {
      className: 'OT_video-disabled-indicator'
    }
  });
  const parentSetDisplayMode = this.setDisplayMode.bind(this);
  this.setDisplayMode = function (mode) {
    parentSetDisplayMode(mode);
    updateClasses(this.domElement);
  };
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _haveGetDisplayMedia = _interopRequireDefault(__webpack_require__(169));
const isSupportedInThisBrowser = () =>
// Even though getDisplayMedia is supported in Edge, we haven't gotten it
// to work with our SDK
!_env.default.isLegacyEdge &&
// Even though getDisplayMedia is exposed in Electron, devs need to use
// desktopCapturer instead
!_env.default.isElectron && _haveGetDisplayMedia.default &&
// getDisplayMedia is not supported in Android
!_env.default.isAndroid;
var _default = {
  isSupportedInThisBrowser: isSupportedInThisBrowser(),
  autoRegisters: true,
  extensionRequired: false,
  getConstraintsShowsPermissionUI: false,
  sources: {
    screen: true,
    application: false,
    window: _env.default.name !== 'Safari',
    browser: _env.default.name !== 'Safari'
  },
  register() {
    return {
      isInstalled(callback) {
        callback(undefined);
      },
      getConstraints(source, constraints, callback) {
        callback(undefined, {
          video: constraints.video,
          audio: constraints.audio
        });
      }
    };
  }
};
exports.default = _default;

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(Promise) {var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function getGlobal() {
    return typeof window !== 'undefined' ?
        window : /* istanbul ignore next */ (typeof window !== undefined ? window : global);
}
var CALLBACK_INVALID_RETURN = 'onFailure must return boolean, or delay in ms';
/**
 * Retry a promise
 *
 * Uses promiseFactory to construct promises and calls onFailure when the
 * promise rejects.
 *
 * onFailure is called with error and attempt.
 *
 * You may inspect error to decide whether to retry or not. You may use attempt
 * to control the delay/ decide how many times to retry.
 *
 * To retry: A numeric delay in milliseconds can be returned to control how long
 * between retries.
 *
 * To stop retrying: Return false/ undefined/ null.
 *
 * The returned promise will be the final promise from promiseFactory once
 * fulfilled or in the case of errors, once no longer retrying.
 *
 * @example
 *
 * const promiseEndeavour = require('../dist/promiseEndeavour.js');
 * const fetch = require('node-fetch');
 *
 * async function getDogs() {
 *   const response = await fetch('https://dog.ceo/api/breeds/list/all');
 *   return response.json();
 * }
 *
 * const retries = [100, 500, 1000];
 *
 * function retry(error, attempt) {
 *   return retries[attempt - 1] || false;
 * }
 *
 * promiseEndeavour(getDogs, retry)()
 *   .then(dogs => console.log(dogs));
 *
 * @param promiseFactory A promise returning function
 * @param onFailure A function to be called when the promise returned by promiseFactory is rejected
 * @param maxAttempts Maximum number of attempts regardless of onFailure
 * @return A function with the same interface to promiseFactory
 */
function promiseEndeavour(promiseFactory, onFailure, maxAttempts) {
    if (maxAttempts === void 0) { maxAttempts = 10; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var attempt, _loop_1, state_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attempt = 0;
                        _loop_1 = function () {
                            var _a, error_1, delay_1;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 6]);
                                        _a = {};
                                        return [4 /*yield*/, promiseFactory.apply(void 0, args)];
                                    case 1: return [2 /*return*/, (_a.value = _b.sent(), _a)];
                                    case 2:
                                        error_1 = _b.sent();
                                        delay_1 = onFailure(error_1, attempt);
                                        if (delay_1 === false || delay_1 == null || attempt >= maxAttempts) {
                                            throw error_1;
                                        }
                                        if (!(typeof delay_1 === 'number')) return [3 /*break*/, 4];
                                        return [4 /*yield*/, new Promise(function (resolve) { return getGlobal().setTimeout(resolve, delay_1); })];
                                    case 3:
                                        _b.sent();
                                        return [3 /*break*/, 5];
                                    case 4:
                                        if (delay_1 !== true) {
                                            throw new Error(CALLBACK_INVALID_RETURN);
                                        }
                                        _b.label = 5;
                                    case 5: return [3 /*break*/, 6];
                                    case 6: return [2 /*return*/];
                                }
                            });
                        };
                        _a.label = 1;
                    case 1:
                        if (!(attempt += 1) /* istanbul ignore next: condition is always true */) return [3 /*break*/, 3];
                        return [5 /*yield**/, _loop_1()];
                    case 2:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
}
/* harmony default export */ __webpack_exports__["default"] = (promiseEndeavour);
//# sourceMappingURL=promiseEndeavour.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.setVideoContentHint = exports.isValidVideoContentHint = exports.getVideoContentHint = void 0;
var _log = _interopRequireDefault(__webpack_require__(1));
const logging = (0, _log.default)('videoContentHint');
const videoContentHints = ['', 'text', 'motion', 'detail'];
const isValidVideoContentHint = hint => videoContentHints.includes(hint);
exports.isValidVideoContentHint = isValidVideoContentHint;
const getVideoTrackForStream = mediaStream => {
  var _mediaStream$getVideo;
  return mediaStream == null ? void 0 : (_mediaStream$getVideo = mediaStream.getVideoTracks()) == null ? void 0 : _mediaStream$getVideo[0];
};

/**
 * Sets contentHint for videoTrack of MediaStream
 * @param {MediaStream} mediaStream
 * @param {String} contentHint, one of "", "motion", "detail" or "text"
 */
const setVideoContentHint = (mediaStream, contentHint) => {
  if (!isValidVideoContentHint(contentHint)) {
    logging.warn('Invalid content hint. Valid content hints are "text", "detail", "motion", or ""');
    return;
  }
  const videoTrack = getVideoTrackForStream(mediaStream);
  if (!videoTrack) {
    logging.warn('Tried to set contentHint but no video track is present');
    return;
  }
  if (videoTrack.contentHint === undefined) {
    logging.warn('contentHint not supported by this browser');
    return;
  }
  videoTrack.contentHint = contentHint;
};

/**
 * Returns contentHint for videoTrack of MediaStream
 * @param {MediaStream} mediaStream
 * @returns {String} contentHint, one of "", "motion", "detail" or "text"

 */
exports.setVideoContentHint = setVideoContentHint;
const getVideoContentHint = mediaStream => {
  const videoTrack = getVideoTrackForStream(mediaStream);
  return (videoTrack == null ? void 0 : videoTrack.contentHint) || '';
};
exports.getVideoContentHint = getVideoContentHint;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const isMediaStreamTrack = source => source && typeof source === 'object' && typeof source.kind === 'string' && typeof source.stop === 'function' && typeof source.enabled === 'boolean';
var _default = isMediaStreamTrack;
exports.default = _default;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = MicrophoneFactory;
var _defineProperties = _interopRequireDefault(__webpack_require__(108));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require, no-shadow */

function MicrophoneFactory() {
  /*
   * A Publishers Microphone.
   *
   * TODO
   * * bind to changes in mute/unmute/volume/etc and respond to them
   */
  return function Microphone(webRTCStream, muted) {
    let _muted;
    (0, _defineProperties.default)(this, {
      muted: {
        get() {
          return _muted;
        },
        set(muted) {
          if (_muted === muted) {
            return;
          }
          _muted = muted;
          const audioTracks = webRTCStream.getAudioTracks();
          for (let i = 0, num = audioTracks.length; i < num; ++i) {
            audioTracks[i].enabled = !_muted;
          }
        }
      }
    });

    // Set the initial value
    if (muted !== undefined) {
      this.muted(muted === true);
    } else if (webRTCStream.getAudioTracks().length) {
      this.muted(!webRTCStream.getAudioTracks()[0].enabled);
    } else {
      this.muted(false);
    }
  };
}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = PublisherPeerConnectionFactory;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _assign = _interopRequireDefault(__webpack_require__(9));
var _pick = _interopRequireDefault(__webpack_require__(39));
var _find = _interopRequireDefault(__webpack_require__(63));
var _audioFallbackStateMachine = _interopRequireDefault(__webpack_require__(686));
var _congestionLevelEstimator = _interopRequireDefault(__webpack_require__(687));
var _networkQualityMonitor = _interopRequireDefault(__webpack_require__(694));
var _log = _interopRequireDefault(__webpack_require__(1));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _shouldForceTurn = _interopRequireDefault(__webpack_require__(324));
var _setIceConfigWithForcedTurn = _interopRequireDefault(__webpack_require__(325));
var _getMaxBitrateForResolution = _interopRequireDefault(__webpack_require__(699));
var _get_stats_helpers = _interopRequireDefault(__webpack_require__(78));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _peer_connection = _interopRequireDefault(__webpack_require__(75));
var _set_certificates = _interopRequireDefault(__webpack_require__(173));
var _watchAudioAcquisition = _interopRequireDefault(__webpack_require__(701));
var _congestionLevels = __webpack_require__(28);
var _audioFallbackVideoStates = _interopRequireDefault(__webpack_require__(77));
var _getDelayForAmrProbe = _interopRequireDefault(__webpack_require__(702));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require, func-names */

const ACTIVE_VIDEO = _audioFallbackVideoStates.default.ACTIVE_VIDEO,
  SUSPENDED_VIDEO = _audioFallbackVideoStates.default.SUSPENDED_VIDEO;
const logging = (0, _log.default)('PublisherPeerConnection');
function PublisherPeerConnectionFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const getStatsHelpers = deps.getStatsHelpers || _get_stats_helpers.default;
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const PeerConnection = deps.PeerConnection || (0, _peer_connection.default)();
  const setCertificates = deps.setCertificates || (0, _set_certificates.default)();
  const watchAudioAcquisition = deps.watchAudioAcquisition || _watchAudioAcquisition.default;
  const createAudioFallbackStateMachine = deps.createAudioFallbackStateMachine || _audioFallbackStateMachine.default;
  const createCongestionLevelEstimator = deps.createCongestionLevelEstimator || _congestionLevelEstimator.default;
  const createNetworkQualityMonitor = deps.createNetworkQualityMonitor || _networkQualityMonitor.default;
  const getDelayForAmrProbe = deps.getDelayForAmrProbe || _getDelayForAmrProbe.default;

  /**
   * @typedef {object} PublisherPeerConnectionConfig
   * @property {function(string, string=, object=, object=, boolean=)} logAnalyticsEvent
   * @property {Connection} remoteConnection
   * @property {boolean} reconnection
   * @property {MediaStream} webRTCStream
   * @property {object<string, object>} channels
   * @property {boolean} capableSimulcastStreams
   * @property {boolean} overrideSimulcastEnabled
   * @property {string} subscriberUri
   * @property {object<string, object>} offerOverrides
   * @property {object<string, object>} answerOverrides
   * @property {string} sourceStreamId
   * @property {string} isP2pEnabled
   */

  /**
   * Abstracts PeerConnection related stuff away from Publisher.
   *
   * Responsible for:
   * * setting up the underlying PeerConnection (delegates to PeerConnections)
   * * triggering a connected event when the Peer connection is opened
   * * triggering a disconnected event when the Peer connection is closed
   * * providing a destroy method
   * * providing a processMessage method
   *
   * Once the PeerConnection is connected and the video element playing it triggers
   * the connected event
   *
   * Triggers the following events
   * * connected
   * * disconnected
   *
   * @class PublisherPeerConnection
   * @constructor
   *
   * @param {PublisherPeerConnectionConfig} config
   */
  return function PublisherPeerConnection(_ref) {
    var _this = this;
    let iceConfig = _ref.iceConfig,
      webRTCStream = _ref.webRTCStream,
      channels = _ref.channels,
      sendMessage = _ref.sendMessage,
      capableSimulcastStreams = _ref.capableSimulcastStreams,
      overrideSimulcastEnabled = _ref.overrideSimulcastEnabled,
      logAnalyticsEvent = _ref.logAnalyticsEvent,
      offerOverrides = _ref.offerOverrides,
      answerOverrides = _ref.answerOverrides,
      sourceStreamId = _ref.sourceStreamId,
      isP2pEnabled = _ref.isP2pEnabled,
      sessionId = _ref.sessionId,
      keyStore = _ref.keyStore,
      sFrameClientStore = _ref.sFrameClientStore,
      isE2ee = _ref.isE2ee,
      audioFallbackEnabled = _ref.audioFallbackEnabled;
    let _peerConnection;
    let _awaitingIceRestart = false;
    let _cancelWatchAudioAcquisition;
    let audioFallbackStateMachine;
    let congestionLevelEstimator;
    let networkQualityMonitor;

    // Private
    const _onPeerClosed = function _onPeerClosed() {
      this.destroy();
      if (_awaitingIceRestart) {
        _awaitingIceRestart = false;
        this.trigger('iceRestartFailure');
      }
      this.trigger('disconnected');
    };
    const _onPeerError = function _onPeerError(_ref2) {
      let reason = _ref2.reason,
        prefix = _ref2.prefix;
      this.trigger('error', {
        reason,
        prefix
      });
    };
    const _onIceConnectionStateChange = function _onIceConnectionStateChange(state) {
      if (_awaitingIceRestart && _peerConnection.iceConnectionStateIsConnected()) {
        _awaitingIceRestart = false;
        this.trigger('iceRestartSuccess');
      }

      // watch for the Chrome bug where audio can't be acquired
      // can not use iceConnectionStateIsConnected since it is too broad
      if (state === 'connected') {
        if (OTHelpers.env.name === 'Chrome') {
          // cancel any pending watcher (in case of ice restart for example)
          if (_cancelWatchAudioAcquisition) {
            _cancelWatchAudioAcquisition();
          }
          _cancelWatchAudioAcquisition = watchAudioAcquisition(callback => _peerConnection.getStats(null, callback), () => {
            if (_peerConnection.iceConnectionStateIsConnected()) {
              this.trigger('audioAcquisitionProblem');
            }
          });
        }
        this.trigger('connected');
      }
      this.trigger('iceConnectionStateChange', state);
    };
    this._setVideoTrackEncodingActiveState = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(isActive) {
        var videoSender, parameters;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              videoSender = _this.getSenders().find(_ref4 => {
                let track = _ref4.track;
                return track.kind === 'video';
              });
              parameters = videoSender.getParameters();
              parameters.encodings.forEach(encoding => {
                // eslint-disable-next-line no-param-reassign
                encoding.active = isActive;
              });
              _context.prev = 3;
              _context.next = 6;
              return videoSender.setParameters(parameters);
            case 6:
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              logging.error(_context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 8]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    (0, _eventing.default)(this);

    // / Public API

    this.setCongestionLevel = level => {
      var _audioFallbackStateMa;
      (_audioFallbackStateMa = audioFallbackStateMachine) == null ? void 0 : _audioFallbackStateMa.setCongestionLevel(level, {
        algorithm: 'manual'
      });
    };
    this.getAudioFallbackState = () => {
      var _audioFallbackStateMa2;
      return (_audioFallbackStateMa2 = audioFallbackStateMachine) == null ? void 0 : _audioFallbackStateMa2.getState();
    };
    this.startEncryption = connectionId => {
      if (_peerConnection) {
        _peerConnection.startEncryption(connectionId);
      }
    };
    this.changeMediaDirectionToInactive = () => {
      if (_peerConnection) {
        _peerConnection.changeMediaDirectionToInactive();
      }
    };
    this.changeMediaDirectionToRecvOnly = () => {
      if (_peerConnection) {
        _peerConnection.changeMediaDirectionToRecvOnly();
      }
    };
    this.getDataChannel = function (label, options, completion) {
      _peerConnection.getDataChannel(label, options, completion);
    };
    this.getSourceStreamId = () => _peerConnection.getSourceStreamId();
    this.destroy = function () {
      var _congestionLevelEstim, _networkQualityMonito;
      (_congestionLevelEstim = congestionLevelEstimator) == null ? void 0 : _congestionLevelEstim.stop();
      (_networkQualityMonito = networkQualityMonitor) == null ? void 0 : _networkQualityMonito.stop();
      if (_cancelWatchAudioAcquisition) {
        _cancelWatchAudioAcquisition();
        _cancelWatchAudioAcquisition = null;
      }

      // Clean up our PeerConnection
      if (_peerConnection) {
        _peerConnection.disconnect();
        _peerConnection = null;
      }
      this.off();
    };
    this.setSendMessage = send => {
      _peerConnection.setSendMessage(send);
    };
    this.processMessage = function (type, message) {
      _peerConnection.processMessage(type, message);
    };
    this.addTrack = function (track, stream, callback) {
      return _peerConnection.addTrack(track, stream, callback);
    };
    this.removeTrack = function (RTCRtpSender) {
      return _peerConnection.removeTrack(RTCRtpSender);
    };
    this.getLocalStreams = function () {
      return _peerConnection.getLocalStreams();
    };

    // Init
    this.init = function (rumorIceServers, completion) {
      if ((0, _shouldForceTurn.default)(sourceStreamId)) {
        (0, _setIceConfigWithForcedTurn.default)(iceConfig);
      }
      const pcConfig = {
        iceConfig: !iceConfig.needRumorIceServersFallback ? iceConfig : (0, _assign.default)(iceConfig, {
          servers: [...rumorIceServers, ...iceConfig.servers]
        }),
        channels,
        capableSimulcastStreams,
        overrideSimulcastEnabled
      };
      setCertificates(pcConfig, (err, pcConfigWithCerts) => {
        if (err) {
          completion(err);
          return;
        }
        const peerConnectionConfig = (0, _assign.default)({
          logAnalyticsEvent,
          isPublisher: true,
          offerOverrides,
          answerOverrides,
          sourceStreamId,
          p2p: isP2pEnabled,
          sessionId,
          keyStore,
          sFrameClientStore,
          isE2ee
        }, pcConfigWithCerts);
        _peerConnection = new PeerConnection((0, _assign.default)({
          sendMessage
        }, peerConnectionConfig));
        _peerConnection.on({
          close: _onPeerClosed,
          error: _onPeerError,
          qos: _qos => this.trigger('qos', _qos),
          iceConnectionStateChange: _onIceConnectionStateChange
        }, this);
        _peerConnection.addLocalStream(webRTCStream).then(() => {
          completion(undefined);
        }).catch(completion);
      });
    };
    this.setIceConfig = newIceConfig => {
      _peerConnection.setIceConfig(newIceConfig);
    };
    this.generateOffer = () => {
      _peerConnection.generateOfferAndSend();
    };
    this.getSenders = function () {
      return _peerConnection.getSenders();
    };
    this.iceRestart = function () {
      if (_peerConnection) {
        _awaitingIceRestart = true;
        _peerConnection.iceRestart();
      }
    };
    this.hasRelayCandidates = () => _peerConnection.hasRelayCandidates();
    this.iceConnectionStateIsConnected = function () {
      return _peerConnection.iceConnectionStateIsConnected();
    };
    this.findAndReplaceTrack = (oldTrack, newTrack) => _peerConnection.findAndReplaceTrack(oldTrack, newTrack);
    this._testOnlyGetFramesEncoded = () => new Promise((resolve, reject) => {
      _peerConnection.getStats(null, (err, stats) => {
        if (err) {
          reject(err);
          return;
        }
        const videoStat = (0, _find.default)(stats, stat => getStatsHelpers.isVideoStat(stat, stats) && getStatsHelpers.isOutboundStat(stat));
        if (!videoStat) {
          reject(new Error('Could not find framesEncoded in getStats report'));
          return;
        }
        resolve((0, _pick.default)(videoStat, ['timestamp', 'framesEncoded']));
      });
    });
    this.getStats = callback => _peerConnection.getStats(null, callback);
    this.getRtcStatsReport = callback => _peerConnection.getRtcStatsReport(null, callback);
    this.setVideoActiveState = isActive => {
      this._setVideoTrackEncodingActiveState(isActive);
    };
    this.setP2PMaxBitrate = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _sender$track;
      var sender, _ref7, width, height, maxBitrate, sendParameters;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(_this.getSourceStreamId() !== 'P2P')) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            sender = _this.getSenders().find(_ref6 => {
              let kind = _ref6.track.kind;
              return kind === 'video';
            });
            if (sender) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return");
          case 5:
            _ref7 = (sender == null ? void 0 : (_sender$track = sender.track) == null ? void 0 : _sender$track.getSettings == null ? void 0 : _sender$track.getSettings()) || {}, width = _ref7.width, height = _ref7.height;
            maxBitrate = (0, _getMaxBitrateForResolution.default)(width, height);
            sendParameters = sender.getParameters();
            sendParameters.encodings.forEach(encoding => {
              encoding.maxBitrate = maxBitrate; // eslint-disable-line no-param-reassign
            });
            _context2.prev = 9;
            _context2.next = 12;
            return sender.setParameters(sendParameters);
          case 12:
            _context2.next = 16;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](9);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[9, 14]]);
    }));
    const onSuspendedVideo = function onSuspendedVideo(_temp) {
      var _congestionLevelEstim2, _networkQualityMonito2;
      let _ref8 = _temp === void 0 ? {} : _temp,
        _ref8$isAmrTransition = _ref8.isAmrTransition,
        isAmrTransition = _ref8$isAmrTransition === void 0 ? false : _ref8$isAmrTransition;
      _this._setVideoTrackEncodingActiveState(false);
      (_congestionLevelEstim2 = congestionLevelEstimator) == null ? void 0 : _congestionLevelEstim2.stop();
      (_networkQualityMonito2 = networkQualityMonitor) == null ? void 0 : _networkQualityMonito2.start(isAmrTransition ? {
        getDelayForProbeNumber: getDelayForAmrProbe
      } : {});
    };
    this.disableCongestionLevelEstimation = () => {
      if (audioFallbackEnabled) {
        var _congestionLevelEstim3, _networkQualityMonito3, _audioFallbackStateMa3;
        (_congestionLevelEstim3 = congestionLevelEstimator) == null ? void 0 : _congestionLevelEstim3.stop();
        (_networkQualityMonito3 = networkQualityMonitor) == null ? void 0 : _networkQualityMonito3.stop();
        (_audioFallbackStateMa3 = audioFallbackStateMachine) == null ? void 0 : _audioFallbackStateMa3.reset();
      }
    };
    this.enableCongestionLevelEstimation = amrAudioFallbackState => {
      if (audioFallbackEnabled) {
        var _networkQualityMonito4, _congestionLevelEstim4;
        (_networkQualityMonito4 = networkQualityMonitor) == null ? void 0 : _networkQualityMonito4.stop();
        if (amrAudioFallbackState) {
          audioFallbackStateMachine.setInternalState(amrAudioFallbackState);
          if (amrAudioFallbackState.videoState === SUSPENDED_VIDEO) {
            onSuspendedVideo({
              isAmrTransition: true
            });
            return;
          }
        } else {
          audioFallbackStateMachine.setCongestionLevel(_congestionLevels.CongestionLevels.LOW);
        }
        (_congestionLevelEstim4 = congestionLevelEstimator) == null ? void 0 : _congestionLevelEstim4.start();
      }
    };
    const initAudioFallbackStateMachine = () => {
      audioFallbackStateMachine = createAudioFallbackStateMachine({
        logAnalyticsEvent
      });
      audioFallbackStateMachine.on('stateChange', _ref9 => {
        let state = _ref9.state;
        switch (state) {
          case ACTIVE_VIDEO:
            this._setVideoTrackEncodingActiveState(true);
            break;
          case SUSPENDED_VIDEO:
            onSuspendedVideo();
            break;
          default:
            break;
        }
        this.trigger('audioFallbackStateChange', {
          state
        });
      });
      congestionLevelEstimator.on('congestionLevel', (level, metadata) => {
        var _audioFallbackStateMa4;
        (_audioFallbackStateMa4 = audioFallbackStateMachine) == null ? void 0 : _audioFallbackStateMa4.setCongestionLevel(level, metadata);
      });
      networkQualityMonitor.on('networkRecovered', () => {
        var _audioFallbackStateMa5, _congestionLevelEstim5;
        (_audioFallbackStateMa5 = audioFallbackStateMachine) == null ? void 0 : _audioFallbackStateMa5.setCongestionLevel(_congestionLevels.CongestionLevels.LOW);
        (_congestionLevelEstim5 = congestionLevelEstimator) == null ? void 0 : _congestionLevelEstim5.start();
      });
    };
    const initCongestionLevelEstimator = () => {
      congestionLevelEstimator = createCongestionLevelEstimator({
        getStats: this.getStats,
        logAnalyticsEvent
      });
      this.on('connected', () => {
        congestionLevelEstimator.start();
      });
    };
    const initVideoRecoveryProbeCoordinator = () => {
      networkQualityMonitor = createNetworkQualityMonitor({
        getStats: this.getStats,
        setVideoActive: this._setVideoTrackEncodingActiveState
      });
    };
    if (audioFallbackEnabled) {
      initVideoRecoveryProbeCoordinator();
      initCongestionLevelEstimator();
      initAudioFallbackStateMachine();
    }
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _events = _interopRequireDefault(__webpack_require__(12));
var StatsUtilsDefault = _interopRequireWildcard(__webpack_require__(691));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const INITIAL_DELAY = 1000;
const INTERVAL = 500;
const createCongestionLevelStats = function createCongestionLevelStats(getPcStats, deps) {
  if (deps === void 0) {
    deps = {};
  }
  const StatsUtils = deps.StatsUtils || StatsUtilsDefault;
  const ee = new _events.default();
  let lastAudioStats;
  let lastVideoStats;
  const resetStats = () => {
    lastAudioStats = undefined;
    lastVideoStats = undefined;
  };
  const getAudioPacketLoss = parsedStats => {
    if (lastAudioStats === undefined) {
      lastAudioStats = parsedStats;
    }
    let audioPacketLoss;
    if (parsedStats.audioReportTimestamp !== lastAudioStats.audioReportTimestamp) {
      if (parsedStats.audioFractionLost !== undefined) {
        audioPacketLoss = parsedStats.audioFractionLost;
      } else {
        audioPacketLoss = StatsUtils.getAudioPacketLoss(parsedStats, lastAudioStats);
      }
      lastAudioStats = parsedStats;
    }
    return audioPacketLoss;
  };
  const getVideoPacketLoss = parsedStats => {
    if (lastVideoStats === undefined) {
      lastVideoStats = parsedStats;
    }
    let videoPacketLoss;
    if (parsedStats.videoReportTimestamp !== lastVideoStats.videoReportTimestamp) {
      videoPacketLoss = StatsUtils.getVideoPacketLoss(parsedStats, lastVideoStats);
      lastVideoStats = parsedStats;
    }
    return videoPacketLoss;
  };
  const processStats = stats => {
    const parsedStats = StatsUtils.parseStats(stats);
    const audioPacketLoss = getAudioPacketLoss(parsedStats);
    const videoPacketLoss = getVideoPacketLoss(parsedStats);
    const bandwidth = parsedStats.bandwidth,
      videoResolution = parsedStats.videoResolution;
    ee.emit('statsAvailable', {
      audioPacketLoss,
      videoPacketLoss,
      bandwidth,
      videoResolution
    });
  };
  const getStats = () => {
    getPcStats((err, stats) => {
      if (!err) {
        processStats(stats);
      }
    });
  };
  let cancelId;
  return Object.assign(ee, {
    start() {
      if (cancelId) {
        // already started
        return;
      }
      cancelId = setTimeout(() => {
        getStats();
        cancelId = setInterval(() => {
          getStats();
        }, INTERVAL);
      }, INITIAL_DELAY);
    },
    stop() {
      // Note that clearInterval and clearTimeout are interchangeable
      clearInterval(cancelId);
      cancelId = undefined;
      resetStats();
    }
  });
};
var _default = createCongestionLevelStats;
exports.default = _default;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const createExponentialMovingAverageTracker = function createExponentialMovingAverageTracker(initialValue) {
  if (initialValue === void 0) {
    initialValue = 0;
  }
  let movingAverageValue = initialValue;
  let period = 10000;
  let lastSampleTime;
  let dataPointCount = 0;
  const getExponentialMovingAverageWeight = () => {
    const currentTime = Date.now();
    if (!lastSampleTime) {
      lastSampleTime = currentTime;
      return 1;
    }
    const diff = currentTime - lastSampleTime;
    const expWeight = 1 - Math.exp(-diff / period);
    lastSampleTime = currentTime;
    return expWeight;
  };
  return {
    setPeriod(time) {
      period = time;
    },
    getMovingAverageValue() {
      return movingAverageValue;
    },
    addValue(value) {
      if (value === undefined || isNaN(value)) return;
      const expWeight = getExponentialMovingAverageWeight();
      movingAverageValue = value * expWeight + movingAverageValue * (1 - expWeight);
      dataPointCount += 1;
    },
    reset() {
      movingAverageValue = initialValue;
      lastSampleTime = undefined;
      dataPointCount = 0;
    },
    getDataPointCount() {
      return dataPointCount;
    }
  };
};
var _default = createExponentialMovingAverageTracker;
exports.default = _default;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _time = __webpack_require__(113);
const THIRTY_SECONDS_IN_MS = 30 * _time.ONE_SECOND_IN_MS;
const TWO_MINUTES_IN_MS = 2 * _time.ONE_MINUTE_IN_MS;
const probingIntervals = [THIRTY_SECONDS_IN_MS, _time.ONE_MINUTE_IN_MS, TWO_MINUTES_IN_MS];

/** The network probes will be run at backing off time intervals e.g. 30s, 60s, 120s, 120s and so on.
 * This function takes the current probe count and returns the needed delay in ms.
 * e.g. after 2 failed probes, we run the 3rd probe. Probe count 3 -> 120s.
 */
const getDelayForProbeNumber = probeCount => {
  var _probingIntervals$pro;
  return (_probingIntervals$pro = probingIntervals[probeCount]) != null ? _probingIntervals$pro : probingIntervals[probingIntervals.length - 1];
};
var _default = getDelayForProbeNumber;
exports.default = _default;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _hasServerReflexiveCandidatesBug = _interopRequireDefault(__webpack_require__(698));
// https://jira.vonage.com/browse/OPENTOK-45642
// should force TURN for bugged iOS and Safari versions
var _default = sourceStreamId => {
  // We should only force TURN for relayed participants
  if (sourceStreamId !== 'P2P') {
    return false;
  }
  return (0, _hasServerReflexiveCandidatesBug.default)();
};
exports.default = _default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
/* eslint-disable no-param-reassign */
var _default = iceConfig => {
  // to force use TURN
  iceConfig.transportPolicy = 'relay';
  // this needs to be present since it is mandatory prop, but it can be an empty array
  iceConfig.customServers = iceConfig.customServers || [];
};
exports.default = _default;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = SubscriberPeerConnectionFactory;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _shouldForceTurn = _interopRequireDefault(__webpack_require__(324));
var _setIceConfigWithForcedTurn = _interopRequireDefault(__webpack_require__(325));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _peer_connection = _interopRequireDefault(__webpack_require__(75));
var _singlePeerConnectionAdapter = _interopRequireDefault(__webpack_require__(703));
var _set_certificates = _interopRequireDefault(__webpack_require__(173));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _watchSubscriberAudio = _interopRequireDefault(__webpack_require__(705));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable global-require, no-param-reassign, no-void, no-shadow */
/* eslint-disable func-names */
/* global RTCStatsReport */

function SubscriberPeerConnectionFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const PeerConnection = deps.PeerConnection || (0, _peer_connection.default)();
  const SinglePeerConnectionAdapter = deps.SinglePeerConnectionAdapter || (0, _singlePeerConnectionAdapter.default)();
  const setCertificates = deps.setCertificates || (0, _set_certificates.default)();
  const Errors = deps.Errors || _Errors.default;
  const ExceptionCodes = deps.ExceptionCodes || _exception_codes.default;
  const OTErrorClass = deps.OTErrorClass || _ot_error_class.default;
  const watchSubscriberAudio = deps.watchSubscriberAudio || _watchSubscriberAudio.default;

  /*
   * Abstracts PeerConnection related stuff away from Subscriber.
   *
   * Responsible for:
   * * setting up the underlying PeerConnection (delegates to PeerConnections)
   * * triggering a connected event when the Peer connection is opened
   * * triggering a disconnected event when the Peer connection is closed
   * * creating a video element when a stream is added
   * * responding to stream removed intelligently
   * * providing a destroy method
   * * providing a processMessage method
   *
   * Once the PeerConnection is connected and the video element playing it
   * triggers the connected event
   *
   * Triggers the following events
   * * connected
   * * disconnected
   * * remoteTrackAdded
   * * error
   *
   */

  return function SubscriberPeerConnection(_ref) {
    let clientCandidates = _ref.clientCandidates,
      iceConfig = _ref.iceConfig,
      send = _ref.send,
      logAnalyticsEvent = _ref.logAnalyticsEvent,
      p2p = _ref.p2p,
      codecFlags = _ref.codecFlags,
      sourceStreamId = _ref.sourceStreamId,
      remoteConnectionId = _ref.remoteConnectionId,
      _singlePeerConnectionController = _ref._singlePeerConnectionController,
      keyStore = _ref.keyStore,
      sFrameClientStore = _ref.sFrameClientStore,
      isE2ee = _ref.isE2ee,
      sessionId = _ref.sessionId;
    const _subscriberPeerConnection = this;
    let _peerConnection;
    let _destroyed = false;
    let _awaitingIceRestart = false;
    let _subscriberAudioWatcher = null;
    // _singlePeerConnectionController is also used as a flag.
    const _isSpcEnabled = !!_singlePeerConnectionController;
    const _videoTracks = [];
    const _audioTracks = [];

    // Private
    const _onPeerClosed = function _onPeerClosed() {
      this.destroy();
      if (_awaitingIceRestart) {
        this.trigger('iceRestartFailure', this);
      }
      this.trigger('disconnected', this);
    };
    const _addTrack = track => {
      const tracks = track.kind === 'video' ? _videoTracks : _audioTracks;
      // Don't add the same track twice
      if (!tracks.includes(track)) {
        tracks.push(track);
      }
    };
    const _onRemoteTrackAdded = _ref2 => {
      let track = _ref2.track,
        transceiver = _ref2.transceiver,
        stream = _ref2.stream;
      // Add track to the tracks list.
      _addTrack(track);
      this.trigger('remoteTrackAdded', stream, this);
      if (isE2ee) {
        _peerConnection.startDecryption(remoteConnectionId, transceiver);
      }
    };
    const _onRemoteVideoSupported = supported => {
      this.trigger('remoteVideoSupported', supported);
    };
    const _onDecryptFailed = () => {
      this.trigger('decryptFailed');
    };
    const _onDecryptRestored = () => {
      this.trigger('decryptRestored');
    };

    // Note: All Peer errors are fatal right now.
    const _onPeerError = function _onPeerError(_ref3) {
      let reason = _ref3.reason,
        prefix = _ref3.prefix;
      this.trigger('error', null, reason, this, prefix);
    };
    const _onIceConnectionStateChange = function _onIceConnectionStateChange(state) {
      if (_awaitingIceRestart && (state === 'connected' || state === 'completed')) {
        _awaitingIceRestart = false;
        this.trigger('iceRestartSuccess');
      }
      if (state === 'connected') {
        this.trigger('connected');
      }
      this.trigger('iceConnectionStateChange', state);
    };
    const _onsignalingStateChange = function _onsignalingStateChange(state) {
      this.trigger('signalingStateChange', state);
    };
    const _onsignalingStateStable = function _onsignalingStateStable(state) {
      this.trigger('signalingStateStable', state);
    };
    const _relayMessageToPeer = (type, content, completion) => {
      if (type === 'answer' || type === 'pranswer') {
        this.trigger('connected');
      }
      send({
        type,
        content
      }, completion);
    };
    const _getAudioStats = callback => {
      var _peerConnection2;
      const track = _audioTracks[0];
      (_peerConnection2 = _peerConnection) == null ? void 0 : _peerConnection2.getStats(track, callback);
    };
    (0, _eventing.default)(this);

    // Public

    this._hasAudioTracks = () => _audioTracks.length > 0;
    this._hasVideoTracks = () => _videoTracks.length > 0;
    this._getVideoTracks = () => _videoTracks;
    this._getAudioTracks = () => _audioTracks;
    this._getTracks = () => [..._audioTracks, ..._videoTracks];
    this.close = function () {
      if (_destroyed) {
        return;
      }
      _destroyed = true;
      if (_peerConnection) {
        _peerConnection.disconnect();
        _peerConnection = null;
      }
      this.off();
    };
    this.destroy = function () {
      this.stopAudioStatsWatcher();
      if (_destroyed) {
        return;
      }
      this.close();
    };
    this.getDataChannel = function (label, options, completion) {
      _peerConnection.getDataChannel(label, options, completion);
    };
    this.getSourceStreamId = () => _peerConnection.getSourceStreamId();
    this.processMessage = function (type, message) {
      _peerConnection.processMessage(type, message);
    };
    this.remoteDescription = function () {
      return _peerConnection.remoteDescription();
    };
    this.getStats = function (callback) {
      if (_peerConnection) {
        _peerConnection.getStats(null, callback);
      } else {
        const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
        callback(new OTHelpers.Error(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
          code: errorCode
        }));
      }
    };
    this.getAudioStats = function (callback) {
      _getAudioStats(callback);
    };
    this.getSynchronizationSources = function (callback) {
      if (!_peerConnection) {
        const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
        callback(new OTHelpers.Error(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
          code: errorCode
        }));
        return;
      }
      _peerConnection.getSynchronizationSources(callback);
    };
    this.getRtcStatsReport = function (callback) {
      if (_peerConnection) {
        _peerConnection.getRtcStatsReport(null, (error, stats) => {
          if (stats instanceof RTCStatsReport || Object.getPrototypeOf(stats).toString().includes('RTCStatsReport')) {
            // Convert RTCStatsReport to Map for consistency with SPC
            callback(error, new Map([...stats]));
          } else {
            callback(error, stats);
          }
        });
      } else {
        const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
        callback(new OTHelpers.Error(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
          code: errorCode
        }));
      }
    };
    this.setIceConfig = iceConfig => {
      _peerConnection.setIceConfig(iceConfig);
    };
    this.generateOffer = () => {
      _peerConnection.generateOfferAndSend();
    };
    this.startAudioStatsWatcher = function (disableAudioLevelStuckAt0) {
      if (!_subscriberAudioWatcher) {
        _subscriberAudioWatcher = watchSubscriberAudio(_getAudioStats, reason => {
          this.stopAudioStatsWatcher();
          this.trigger('audioLevelStuckWarning', reason);
        }, disableAudioLevelStuckAt0);
      }
    };
    this.stopAudioStatsWatcher = function () {
      if (_subscriberAudioWatcher) {
        _subscriberAudioWatcher.stop();
      }
      _subscriberAudioWatcher = null;
    };

    // Helper method used by subscribeToAudio/subscribeToVideo
    const _createSetEnabledForTracks = function _createSetEnabledForTracks(kind) {
      return function (enabled) {
        const tracks = kind === 'video' ? _videoTracks : _audioTracks;
        if (!_peerConnection) {
          // We haven't created the peer connection yet, so there are no remote streams right now.
          // Subscriber will try again after onRemoteStreamAdded so this works out ok.
          return;
        }
        _peerConnection.remoteTracks().forEach(track => {
          if (track.kind === kind && track.enabled !== enabled && tracks.includes(track)) {
            track.enabled = enabled;
          }
        });
      };
    };
    this.subscribeToAudio = _createSetEnabledForTracks('audio');
    this.subscribeToVideo = _createSetEnabledForTracks('video');
    this.hasRelayCandidates = function () {
      return _peerConnection.hasRelayCandidates();
    };
    this.iceRestart = function () {
      _awaitingIceRestart = true;
      return _peerConnection.iceRestart();
    };
    this.iceConnectionStateIsConnected = function () {
      return _peerConnection.iceConnectionStateIsConnected();
    };

    // Init
    this.init = function (completion) {
      if ((0, _shouldForceTurn.default)(sourceStreamId)) {
        (0, _setIceConfigWithForcedTurn.default)(iceConfig);
      }
      const pcConfig = {
        iceConfig
      };
      setCertificates(pcConfig, (err, pcConfigWithCerts) => {
        if (err) {
          completion(err);
          return;
        }
        const peerConnectionConfig = (0, _assign.default)({
          logAnalyticsEvent,
          clientCandidates,
          codecFlags,
          sourceStreamId,
          keyStore,
          sFrameClientStore,
          isE2ee,
          sessionId
        }, pcConfigWithCerts);
        const options = (0, _assign.default)({
          sendMessage: _relayMessageToPeer,
          p2p
        }, peerConnectionConfig, {
          remoteConnectionId
        });
        if (_isSpcEnabled) {
          // SinglePeerConnection is the interface of PeerConnection to use when SPC.
          _peerConnection = new SinglePeerConnectionAdapter(options, _singlePeerConnectionController);
        } else {
          _peerConnection = new PeerConnection(options);
        }
        _peerConnection.on({
          iceConnected: () => _subscriberPeerConnection.emit('iceConnected'),
          close: _onPeerClosed,
          trackAdded: _onRemoteTrackAdded,
          signalingStateChange: _onsignalingStateChange,
          signalingStateStable: _onsignalingStateStable,
          error: _onPeerError,
          qos: _qos => this.trigger('qos', _qos),
          iceConnectionStateChange: _onIceConnectionStateChange,
          remoteVideoSupported: _onRemoteVideoSupported,
          decryptFailed: _onDecryptFailed,
          decryptRestored: _onDecryptRestored
        }, _subscriberPeerConnection);

        // If there are already remoteStreams, add them immediately
        // (Using .remoteTracks to avoid deprecated .remoteStreams where possible.
        // FIXME: Is this even possible anyway? How could we already have remote streams in the same
        // tick the peer connection was created?)
        if (!_isSpcEnabled && _peerConnection.remoteTracks().length > 0) {
          // @todo i really don't think this branch is ever entered, it might be an artifact of the
          // unit tests
          // @todo ahh maybe reconnections?
          _peerConnection.remoteStreams().forEach(stream => {
            stream.getTracks().forEach(track => _onRemoteTrackAdded({
              stream,
              track
            }));
          });
        } else {
          completion(undefined, _subscriberPeerConnection);
        }
      });
    };
  };
}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = PublishingStateFactory;
var _generate_simple_state_machine = _interopRequireDefault(__webpack_require__(170));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require */

function PublishingStateFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const generateSimpleStateMachine = deps.generateSimpleStateMachine || (0, _generate_simple_state_machine.default)();

  // Models a Publisher's publishing State
  //
  // Valid States:
  //    NotPublishing
  //    GetUserMedia
  //    BindingMedia
  //    MediaBound
  //    PublishingToSession
  //    Publishing
  //    Failed
  //    Destroyed
  //
  //
  // Valid Transitions:
  //    NotPublishing ->
  //        GetUserMedia
  //
  //    GetUserMedia ->
  //        BindingMedia
  //      | Failed                     (Failure Reasons -> stream error, constraints,
  //                                   (permission denied
  //      | NotPublishing              (destroy()
  //
  //
  //    BindingMedia ->
  //        MediaBound
  //      | Failed                     (Failure Reasons -> Anything to do with the media
  //                                   (being invalid, the media never plays
  //      | NotPublishing              (destroy()
  //
  //    MediaBound ->
  //        PublishingToSession        (MediaBound could transition to PublishingToSession
  //                                   (if a stand-alone publish is bound to a session
  //      | Failed                     (Failure Reasons -> media issues with a stand-alone publisher
  //      | NotPublishing              (destroy()
  //
  //    PublishingToSession
  //        Publishing
  //      | Failed
  //      | NotPublishing              (destroy()
  //      | MediaBound                 (disconnect()
  //
  //
  //    Publishing ->
  //        NotPublishing              (Unpublish
  //      | Failed                     (Failure Reasons -> loss of network, media error, anything
  //                                   (that causes *all* Peer Connections to fail (less than all
  //                                   (failing is just an error, all is failure)
  //      | NotPublishing              (destroy()
  //
  //    Failed ->
  //       Destroyed
  //
  //    Destroyed ->                   (Terminal state
  //
  //

  const validStates = ['NotPublishing', 'GetUserMedia', 'BindingMedia', 'MediaBound', 'PublishingToSession', 'Publishing', 'Migrating', 'Failed', 'Destroyed'];
  const validTransitions = {
    NotPublishing: ['NotPublishing', 'GetUserMedia', 'Destroyed'],
    GetUserMedia: ['BindingMedia', 'Failed', 'NotPublishing', 'Destroyed'],
    BindingMedia: ['MediaBound', 'Failed', 'NotPublishing', 'Destroyed'],
    MediaBound: ['NotPublishing', 'PublishingToSession', 'Failed', 'Destroyed'],
    PublishingToSession: ['NotPublishing', 'Publishing', 'Failed', 'Destroyed', 'MediaBound'],
    Publishing: ['NotPublishing', 'Migrating', 'MediaBound', 'Failed', 'Destroyed'],
    Migrating: ['NotPublishing', 'MediaBound', 'Publishing', 'Failed', 'Destroyed'],
    Failed: ['Destroyed'],
    Destroyed: []
  };
  const initialState = 'NotPublishing';
  const PublishingState = generateSimpleStateMachine(initialState, validStates, validTransitions);
  PublishingState.prototype.isDestroyed = function () {
    return this.current === 'Destroyed';
  };
  PublishingState.prototype.isAttemptingToPublish = function () {
    return ['GetUserMedia', 'BindingMedia', 'MediaBound', 'PublishingToSession'].indexOf(this.current) !== -1;
  };
  PublishingState.prototype.isPublishing = function () {
    return this.current === 'Publishing' || this.current === 'Migrating';
  };
  PublishingState.prototype.isMigrating = function () {
    return this.current === 'Migrating';
  };
  return PublishingState;
}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CancellationError;
// Note: Babel does not support extending builtin types like error:
// https://phabricator.babeljs.io/T3083

/**
 * The error that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The error message.
 * @extends Error
 */
function CancellationError(message) {
  this.message = message || 'Operation has been canceled.';
  this.name = 'CancellationError';
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  }
}

CancellationError.prototype = Object.create(Error.prototype);
CancellationError.prototype.constructor = CancellationError;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var Promise = __webpack_require__(2);

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function promiseFinally(value, cb) {
    return Promise.resolve(value).then(value => Promise.resolve(cb()).then(() => value), reason => Promise.resolve(cb()).then(() => Promise.reject(reason)));
}
exports.default = promiseFinally;
//# sourceMappingURL=index.js.map


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isAmrVideoBufferError = exports.createAmrVideoBufferError = void 0;
const errorMessage = 'bufferFailed: videoBuffer failed to load or timeout';
const isAmrVideoBufferError = _ref => {
  let message = _ref.message;
  return message === errorMessage;
};
exports.isAmrVideoBufferError = isAmrVideoBufferError;
const createAmrVideoBufferError = () => new Error(errorMessage);
exports.createAmrVideoBufferError = createAmrVideoBufferError;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = SubscriberFactory;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(332));
var _cancel = __webpack_require__(114);
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _events = _interopRequireDefault(__webpack_require__(12));
var _assign = _interopRequireDefault(__webpack_require__(9));
var _defaults = _interopRequireDefault(__webpack_require__(147));
var _get = _interopRequireDefault(__webpack_require__(59));
var _merge = _interopRequireDefault(__webpack_require__(279));
var _once = _interopRequireDefault(__webpack_require__(52));
var _values = _interopRequireDefault(__webpack_require__(304));
var _debounce = _interopRequireDefault(__webpack_require__(296));
var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(716));
var _queue = _interopRequireDefault(__webpack_require__(717));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _eventHelper = _interopRequireDefault(__webpack_require__(58));
var _env = _interopRequireDefault(__webpack_require__(3));
var _amrStateMachine = _interopRequireDefault(__webpack_require__(334));
var _castToBoolean = _interopRequireDefault(__webpack_require__(292));
var _connectivityAttemptPinger = _interopRequireDefault(__webpack_require__(723));
var _connectivityState = _interopRequireDefault(__webpack_require__(724));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _waitUntil = _interopRequireDefault(__webpack_require__(337));
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _isGetRtcStatsReportSupported = _interopRequireDefault(__webpack_require__(338));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _overallTimeout = _interopRequireDefault(__webpack_require__(725));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _now = _interopRequireDefault(__webpack_require__(51));
var _RafRunner = _interopRequireDefault(__webpack_require__(112));
var _interpretSubscriberCreateError = _interopRequireDefault(__webpack_require__(726));
var _widget_view = _interopRequireDefault(__webpack_require__(176));
var _audioLevelBehaviour2 = _interopRequireDefault(__webpack_require__(727));
var _audio_level_meter = _interopRequireDefault(__webpack_require__(310));
var _audio_level_transformer = _interopRequireDefault(__webpack_require__(156));
var _backing_bar = _interopRequireDefault(__webpack_require__(311));
var _chrome3 = _interopRequireDefault(__webpack_require__(157));
var _events2 = _interopRequireDefault(__webpack_require__(18));
var _get_stats_helpers = _interopRequireDefault(__webpack_require__(78));
var _hasAudioOutputLevelStatCapability = _interopRequireDefault(__webpack_require__(728));
var _hasRemoteStreamsWithWebAudio = _interopRequireDefault(__webpack_require__(339));
var _audioLevelSampler2 = _interopRequireDefault(__webpack_require__(729));
var _interpretPeerConnectionError = _interopRequireDefault(__webpack_require__(172));
var _mute_button = _interopRequireDefault(__webpack_require__(312));
var _name_panel = _interopRequireDefault(__webpack_require__(313));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _stylable_component = _interopRequireDefault(__webpack_require__(162));
var _createWindowMock = _interopRequireDefault(__webpack_require__(155));
var _peer_connection = _interopRequireDefault(__webpack_require__(75));
var _subscriber_peer_connection = _interopRequireDefault(__webpack_require__(326));
var _state2 = _interopRequireDefault(__webpack_require__(340));
var _video_disabled_indicator = _interopRequireDefault(__webpack_require__(314));
var _AudioBlockedIndicator = _interopRequireDefault(__webpack_require__(732));
var _VideoUnsupportedIndicator = _interopRequireDefault(__webpack_require__(733));
var _watchFrameRate = _interopRequireDefault(__webpack_require__(734));
var _createSendMethod = _interopRequireDefault(__webpack_require__(341));
var _parseIceServers = __webpack_require__(110);
var _getMediaModeBySourceStreamId = _interopRequireDefault(__webpack_require__(180));
var _audioConnector2 = _interopRequireDefault(__webpack_require__(735));
var _mediaProcessorConnector = _interopRequireDefault(__webpack_require__(181));
var _amrVideoBufferError = __webpack_require__(330);
var _updateTrackOnStream = _interopRequireDefault(__webpack_require__(342));
var _time = _interopRequireDefault(__webpack_require__(113));
var _amrStates = _interopRequireDefault(__webpack_require__(335));
var _MOSScoreHelper = _interopRequireDefault(__webpack_require__(737));
var _shouldMonitorFrameRate = _interopRequireDefault(__webpack_require__(739));
const _excluded = ["AudioLevelMeter", "AudioLevelTransformer", "BackingBar", "Chrome", "env", "Errors", "Events", "ExceptionCodes", "audioLevelSamplerFactory", "getStatsHelpers", "hasAudioOutputLevelStatCapability", "hasRemoteStreamsWithWebAudio", "interpretPeerConnectionError", "logging", "MuteButton", "NamePanel", "otError", "OTErrorClass", "OTHelpers", "StylableComponent", "SubscriberPeerConnection", "SubscribingState", "VideoDisabledIndicator", "AudioBlockedIndicator", "VideoUnsupportedIndicator", "watchFrameRate", "createSendMethod", "parseIceServers", "document", "WidgetView", "createAudioConnector", "ResizeObserverPolyfill", "MediaStream", "AMRStateDurations", "createMOSScoreHelper"];
const defaultWidgetView = (0, _widget_view.default)();
const EventsDefault = (0, _events2.default)();
const errorsDefault = _Errors.default;
const interpretPeerConnectionErrorDefault = (0, _interpretPeerConnectionError.default)();
const MuteButtonDefault = (0, _mute_button.default)();
const windowMock = (0, _createWindowMock.default)((typeof window !== undefined ? window : global));
const PeerConnection = (0, _peer_connection.default)({
  global: windowMock
});
const SubscriberPeerConnectionDefault = (0, _subscriber_peer_connection.default)({
  PeerConnection
});
const loggingDefault = (0, _log.default)('Subscriber');
const otErrorDefault = (0, _otError.default)();
const DEFAULT_AUDIO_VOLUME = 100;
const isLocalStream = (stream, session) => stream.connection.id === session.connection.id;
const constructSubscriberUri = _ref => {
  let apiKey = _ref.apiKey,
    sessionId = _ref.sessionId,
    streamId = _ref.streamId,
    subscriberId = _ref.subscriberId;
  return ['/v2/partner', apiKey, 'session', sessionId, 'stream', streamId, 'subscriber', subscriberId].join('/');
};
const waitUntil = (0, _waitUntil.default)();
function normalizeAudioVolume(volume) {
  return Math.max(0, Math.min(100, parseInt(volume, 10)));
}
function determineAudioVolume(props) {
  if (props.audioVolume !== undefined) {
    return props.audioVolume;
  } else if (props.subscribeToAudio === false) {
    return 0;
  }
  return DEFAULT_AUDIO_VOLUME;
}
function SubscriberFactory(_ref2) {
  if (_ref2 === void 0) {
    _ref2 = {};
  }
  let _ref3 = _ref2,
    _ref3$AudioLevelMeter = _ref3.AudioLevelMeter,
    AudioLevelMeter = _ref3$AudioLevelMeter === void 0 ? _audio_level_meter.default : _ref3$AudioLevelMeter,
    _ref3$AudioLevelTrans = _ref3.AudioLevelTransformer,
    AudioLevelTransformer = _ref3$AudioLevelTrans === void 0 ? _audio_level_transformer.default : _ref3$AudioLevelTrans,
    _ref3$BackingBar = _ref3.BackingBar,
    BackingBar = _ref3$BackingBar === void 0 ? _backing_bar.default : _ref3$BackingBar,
    _ref3$Chrome = _ref3.Chrome,
    Chrome = _ref3$Chrome === void 0 ? _chrome3.default : _ref3$Chrome,
    _ref3$env = _ref3.env,
    env = _ref3$env === void 0 ? _env.default : _ref3$env,
    _ref3$Errors = _ref3.Errors,
    errors = _ref3$Errors === void 0 ? errorsDefault : _ref3$Errors,
    _ref3$Events = _ref3.Events,
    Events = _ref3$Events === void 0 ? EventsDefault : _ref3$Events,
    _ref3$ExceptionCodes = _ref3.ExceptionCodes,
    ExceptionCodes = _ref3$ExceptionCodes === void 0 ? _exception_codes.default : _ref3$ExceptionCodes,
    _ref3$audioLevelSampl = _ref3.audioLevelSamplerFactory,
    audioLevelSamplerFactory = _ref3$audioLevelSampl === void 0 ? _audioLevelSampler2.default : _ref3$audioLevelSampl,
    _ref3$getStatsHelpers = _ref3.getStatsHelpers,
    getStatsHelpers = _ref3$getStatsHelpers === void 0 ? _get_stats_helpers.default : _ref3$getStatsHelpers,
    _ref3$hasAudioOutputL = _ref3.hasAudioOutputLevelStatCapability,
    hasAudioOutputLevelStatCapability = _ref3$hasAudioOutputL === void 0 ? _hasAudioOutputLevelStatCapability.default : _ref3$hasAudioOutputL,
    _ref3$hasRemoteStream = _ref3.hasRemoteStreamsWithWebAudio,
    hasRemoteStreamsWithWebAudio = _ref3$hasRemoteStream === void 0 ? _hasRemoteStreamsWithWebAudio.default : _ref3$hasRemoteStream,
    _ref3$interpretPeerCo = _ref3.interpretPeerConnectionError,
    interpretPeerConnectionError = _ref3$interpretPeerCo === void 0 ? interpretPeerConnectionErrorDefault : _ref3$interpretPeerCo,
    _ref3$logging = _ref3.logging,
    logging = _ref3$logging === void 0 ? loggingDefault : _ref3$logging,
    _ref3$MuteButton = _ref3.MuteButton,
    MuteButton = _ref3$MuteButton === void 0 ? MuteButtonDefault : _ref3$MuteButton,
    _ref3$NamePanel = _ref3.NamePanel,
    NamePanel = _ref3$NamePanel === void 0 ? _name_panel.default : _ref3$NamePanel,
    _ref3$otError = _ref3.otError,
    otError = _ref3$otError === void 0 ? otErrorDefault : _ref3$otError,
    _ref3$OTErrorClass = _ref3.OTErrorClass,
    OTErrorClass = _ref3$OTErrorClass === void 0 ? _ot_error_class.default : _ref3$OTErrorClass,
    _ref3$OTHelpers = _ref3.OTHelpers,
    OTHelpers = _ref3$OTHelpers === void 0 ? _OTHelpers.default : _ref3$OTHelpers,
    _ref3$StylableCompone = _ref3.StylableComponent,
    StylableComponent = _ref3$StylableCompone === void 0 ? _stylable_component.default : _ref3$StylableCompone,
    _ref3$SubscriberPeerC = _ref3.SubscriberPeerConnection,
    SubscriberPeerConnection = _ref3$SubscriberPeerC === void 0 ? SubscriberPeerConnectionDefault : _ref3$SubscriberPeerC,
    _ref3$SubscribingStat = _ref3.SubscribingState,
    SubscribingState = _ref3$SubscribingStat === void 0 ? _state2.default : _ref3$SubscribingStat,
    _ref3$VideoDisabledIn = _ref3.VideoDisabledIndicator,
    VideoDisabledIndicator = _ref3$VideoDisabledIn === void 0 ? _video_disabled_indicator.default : _ref3$VideoDisabledIn,
    _ref3$AudioBlockedInd = _ref3.AudioBlockedIndicator,
    AudioBlockedIndicator = _ref3$AudioBlockedInd === void 0 ? _AudioBlockedIndicator.default : _ref3$AudioBlockedInd,
    _ref3$VideoUnsupporte = _ref3.VideoUnsupportedIndicator,
    VideoUnsupportedIndicator = _ref3$VideoUnsupporte === void 0 ? _VideoUnsupportedIndicator.default : _ref3$VideoUnsupporte,
    _ref3$watchFrameRate = _ref3.watchFrameRate,
    watchFrameRate = _ref3$watchFrameRate === void 0 ? _watchFrameRate.default : _ref3$watchFrameRate,
    _ref3$createSendMetho = _ref3.createSendMethod,
    createSendMethod = _ref3$createSendMetho === void 0 ? _createSendMethod.default : _ref3$createSendMetho,
    _ref3$parseIceServers = _ref3.parseIceServers,
    parseIceServers = _ref3$parseIceServers === void 0 ? _parseIceServers.parseIceServers : _ref3$parseIceServers,
    _ref3$document = _ref3.document,
    document = _ref3$document === void 0 ? (typeof window !== undefined ? window : global).document : _ref3$document,
    _ref3$WidgetView = _ref3.WidgetView,
    WidgetView = _ref3$WidgetView === void 0 ? defaultWidgetView : _ref3$WidgetView,
    _ref3$createAudioConn = _ref3.createAudioConnector,
    createAudioConnector = _ref3$createAudioConn === void 0 ? _audioConnector2.default : _ref3$createAudioConn,
    _ref3$ResizeObserverP = _ref3.ResizeObserverPolyfill,
    ResizeObserverPolyfill = _ref3$ResizeObserverP === void 0 ? _resizeObserverPolyfill.default : _ref3$ResizeObserverP,
    _ref3$MediaStream = _ref3.MediaStream,
    MediaStream = _ref3$MediaStream === void 0 ? (typeof window !== undefined ? window : global).MediaStream : _ref3$MediaStream,
    AMRStateDurations = _ref3.AMRStateDurations,
    _ref3$createMOSScoreH = _ref3.createMOSScoreHelper,
    createMOSScoreHelper = _ref3$createMOSScoreH === void 0 ? _MOSScoreHelper.default : _ref3$createMOSScoreH,
    deps = (0, _objectWithoutPropertiesLoose2.default)(_ref3, _excluded);
  const BIND_VIDEO_DELAY_MAX = 30000;
  const BIND_VIDEO_DELAY_WARNING = 15000;
  const RESIZE_DEBOUNCE_WAIT = deps.RESIZE_DEBOUNCE_WAIT || _time.default;

  /**
   * The Subscriber object is a representation of the local video element that is playing back
   * a remote stream. The Subscriber object includes methods that let you disable and enable
   * local audio playback for the subscribed stream. The <code>subscribe()</code> method of the
   * {@link Session} object returns a Subscriber object.
   *
   * @property {Element} element The HTML DOM element containing the Subscriber.
   * @property {String} id The DOM ID of the Subscriber.
   * @property {Stream} stream The stream to which you are subscribing.
   *
   * @class Subscriber
   * @augments EventDispatcher
   */
  const Subscriber = function Subscriber(targetElement, options, completionHandler) {
    var _this = this,
      _stream$getChannelsOf;
    if (options === void 0) {
      options = {};
    }
    if (completionHandler === void 0) {
      completionHandler = () => {};
    }
    if (options.analytics === undefined) {
      // @todo does anyone instantiate a Subscriber outside of `session.subscribe`?
      // it might be best to instantiate an analytics object and replace it on subscribe like
      // we do in the publisher.
      throw new Error('Subscriber requires an instance of analytics');
    }

    /** @type AnalyticsHelperDefault */
    const analytics = options.analytics;
    const _widgetId = (0, _uuid.default)();
    const _audioLevelCapable = Subscriber.hasAudioOutputLevelStatCapability() || hasRemoteStreamsWithWebAudio();
    const _subscriber = this;
    const _pcConnected = {};
    const peerConnectionsAsync = {};
    const webRTCStreams = {};
    const hybridSessionTransitionStartTimes = {};
    const _peerConnectionEvents = {};
    const updateTrackOnStream = (mediaStream, oldTrack, newTrack) => {
      if (_exposedWebRTCStream) {
        (0, _updateTrackOnStream.default)(_exposedWebRTCStream, oldTrack, newTrack);
      }
      (0, _updateTrackOnStream.default)(mediaStream, oldTrack, newTrack);
    };
    const _audioConnector = createAudioConnector(webRTCStreams, {
      updateTrackOnStream
    });

    /** @type {defaultWidgetView|null} */
    let _widgetView;
    let _chrome;
    let _muteDisplayMode;
    let _audioLevelMeter;
    let _subscribeStartTime;
    let _state;
    let _audioLevelSampler;
    let _audioLevelBehaviour;
    let _webRTCStream;
    let _videoEnabled;
    let _lastSubscribeToVideoReason;
    let _attemptStartTime;
    /** @type IntervalRunnerDefault | undefined */
    let _streamEventHandlers;
    let _isSubscribingToAudio;
    let _loaded = false;
    let _domId = targetElement || _widgetId;
    let _session = options.session;
    let _stream = options.stream;
    const _shouldUseSpc = _session._singlePeerConnectionController !== undefined;
    let _audioVolume;
    let _latestPositiveVolume;
    let _frameRateRestricted = false;
    let _frameRateWatcher;
    let _preDisconnectStats = {};
    let _congestionLevel = null;
    let _hasLoadedAtLeastOnce = false;
    let _isVideoSupported = true;
    let fallbackIceServers = [];
    let _properties = (0, _defaults.default)({}, options, {
      showControls: true,
      testNetwork: false,
      fitMode: _stream.defaultFitMode || 'cover',
      insertDefaultUI: true,
      initials: _stream.initials
    });
    let _isVideoManuallyMuted;
    let _activeSourceStreamId;
    const _isAdaptiveEnabled = _session.sessionInfo.isAdaptiveEnabled;
    const _lastConnectionStatesMap = {
      P2P: _eventNames.default.SUBSCRIBER_DISCONNECTED,
      MANTIS: _eventNames.default.SUBSCRIBER_DISCONNECTED
    };
    let _subscriberConnectionState = _eventNames.default.SUBSCRIBER_DISCONNECTED;
    let _videoMediaProcessorConnector;
    let _originalVideoTrack;
    let _senderStats;
    let _resizeObserver;
    let _exposedWebRTCStream;
    let _migrationTimeoutId;
    let _previousPeerConnection;

    // The audio stats watcher is only supported on chromium-based browsers that supports
    // the standard version of the getStats API.
    const _supportsAudioStatsWatcher = env.name === 'Chrome' && env.version >= 58 || env.isChromiumEdge || env.isOpera;
    let socket = _session._.getSocket();
    const amrState = (0, _amrStateMachine.default)(AMRStateDurations);
    amrState.on('transitionToP2PTimeout', () => {
      socket.subscriberDestroy(_stream.id, this.widgetId, _amrStates.default.P2P);
      // Unblock the transition to P2P, so we are ready to transition to Routed
      _activeSourceStreamId = _amrStates.default.P2P;
      amrState.completeTransitionTo(_activeSourceStreamId);
    });
    const getAllPeerConnections = () => (0, _values.default)(peerConnectionsAsync);
    const getPeerConnectionBySourceStreamId = sourceStreamId => peerConnectionsAsync[sourceStreamId];
    const getCurrentPeerConnection = () => peerConnectionsAsync[_activeSourceStreamId];
    const removePeerConnectionBySourceStreamId = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(sourceStreamId) {
        var peerConnection;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return peerConnectionsAsync[sourceStreamId];
            case 2:
              peerConnection = _context.sent;
              peerConnection == null ? void 0 : peerConnection.close();
              delete peerConnectionsAsync[sourceStreamId];
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function removePeerConnectionBySourceStreamId(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    const startMigrationTimeout = () => {
      _migrationTimeoutId = setTimeout(() => {
        this._destroy({
          reason: 'Migration failed'
        });
        logAnalyticsEvent('Migrate', 'Failed');
      }, _session.MIGRATION_TIMEOUT);
    };
    const removeWebRTCStream = sourceStreamId => {
      delete webRTCStreams[sourceStreamId];
    };
    const removeAllPeerConnections = () => {
      // @todo check peer connection destroy triggers disconnect, and then gets logged...
      getAllPeerConnections().forEach( /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(peerConnection) {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return peerConnection;
              case 2:
                _context2.sent.destroy();
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }());
      Object.keys(peerConnectionsAsync).forEach(key => {
        delete peerConnectionsAsync[key];
      });
    };

    // Note: `isSubscriber` is necessary to prevent changes to the publisher Stream object during self-subscribe
    // See VIDCS-1474 for more context
    const setChannelActiveStateForSubscriber = attributes => {
      _stream.setChannelActiveState(Object.assign({}, attributes, {
        isSubscriber: true
      }));
    };
    const syncUpMediaStreams = (targetStream, originalStream) => {
      (0, _updateTrackOnStream.default)(targetStream, targetStream.getAudioTracks()[0], originalStream.getAudioTracks()[0]);
      (0, _updateTrackOnStream.default)(targetStream, targetStream.getVideoTracks()[0], originalStream.getVideoTracks()[0]);
    };
    const bindWebRTCStream = /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(webRTCStream) {
        var _stream2;
        var videoContainerOptions, throwIfBufferFails;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (webRTCStream) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              // Sync the track state of the exposed stream with our current stream
              if (_exposedWebRTCStream) {
                syncUpMediaStreams(_exposedWebRTCStream, webRTCStream);
              }
              videoContainerOptions = {
                error: onVideoError,
                audioVolume: _audioVolume,
                hasVideo: (_stream2 = _stream) == null ? void 0 : _stream2.hasVideo,
                isSubscribingToVideo: _properties.subscribeToVideo
              }; // We want to catch any error in the prebuffering when transition to P2P.
              // Otherwise, we ignore it.
              throwIfBufferFails = _isAdaptiveEnabled && _activeSourceStreamId === 'P2P'; // To minimize the blip effect during a stream transition, we take a snapshot of the video stream (if available)
              // and display it instead of a blank screen.
              _widgetView.prepareForStreamTransition();
              _context3.prev = 6;
              _context3.next = 9;
              return _widgetView.bindVideo(webRTCStream, videoContainerOptions, throwIfBufferFails);
            case 9:
              _context3.next = 17;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](6);
              if (!(_context3.t0 instanceof _cancel.CancellationError || _state.isDestroyed())) {
                _context3.next = 15;
                break;
              }
              return _context3.abrupt("return");
            case 15:
              onVideoError(_context3.t0);
              throw _context3.t0;
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[6, 11]]);
      }));
      return function bindWebRTCStream(_x3) {
        return _ref6.apply(this, arguments);
      };
    }();
    const _getStatsWrapper = /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(reportType, callback) {
        var isRtcStatsReport, errorCode, pc, getStats;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              isRtcStatsReport = false;
              if (typeof reportType === 'function') {
                /* eslint-disable-next-line no-param-reassign */
                callback = reportType;
              } else {
                isRtcStatsReport = reportType === 'rtcStatsReport';
              }
              if (isRtcStatsReport) {
                notifyGetRtcStatsReportCalled();
              } else {
                notifyGetStatsCalled();
              }
              if (!(isRtcStatsReport && !_isGetRtcStatsReportSupported.default)) {
                _context4.next = 7;
                break;
              }
              errorCode = ExceptionCodes.GET_RTC_STATS_REPORT_NOT_SUPPORTED;
              callback(otError(_Errors.default.GET_RTC_STATS_REPORT_NOT_SUPPORTED, new Error(OTErrorClass.getTitleByCode(errorCode)), errorCode));
              return _context4.abrupt("return");
            case 7:
              if (getCurrentPeerConnection()) {
                _context4.next = 11;
                break;
              }
              errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
              callback(otError(errors.PEER_CONNECTION_NOT_CONNECTED, new Error(OTErrorClass.getTitleByCode(errorCode)), errorCode));
              return _context4.abrupt("return");
            case 11:
              _context4.next = 13;
              return getCurrentPeerConnection();
            case 13:
              pc = _context4.sent;
              getStats = isRtcStatsReport ? pc.getRtcStatsReport : pc.getStats;
              getStats((error, stats) => {
                if (error) {
                  if (error.code === ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED) {
                    error = otError(errors.PEER_CONNECTION_NOT_CONNECTED, error, ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED);
                  }
                  callback(error);
                } else {
                  callback(null, stats);
                }
              });
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function _getStatsWrapper(_x4, _x5) {
        return _ref7.apply(this, arguments);
      };
    }();
    const _getStats = callback => _getStatsWrapper(callback);
    const _getRtcStatsReport = callback => _getStatsWrapper('rtcStatsReport', callback);
    const _streamHasTracks = kind => {
      if (!_webRTCStream) {
        return false;
      }
      if (kind === 'video') {
        return _webRTCStream.getVideoTracks().length > 0;
      }
      return _webRTCStream.getAudioTracks().length > 0;
    };
    const logAnalyticsEvent = (action, variation, payload, options, throttle) => {
      var _session2, _session3, _session3$connection, _session$sessionInfo$, _session4, _session4$sessionInfo, _session5;
      let stats = (0, _assign.default)({
        action,
        variation,
        payload,
        streamId: _stream ? _stream.id : null,
        sessionId: _session ? _session.sessionId : null,
        connectionId: (_session2 = _session) != null && _session2.isConnected() ? (_session3 = _session) == null ? void 0 : (_session3$connection = _session3.connection) == null ? void 0 : _session3$connection.connectionId : null,
        partnerId: (_session$sessionInfo$ = (_session4 = _session) == null ? void 0 : (_session4$sessionInfo = _session4.sessionInfo) == null ? void 0 : _session4$sessionInfo.partnerId) != null ? _session$sessionInfo$ : null,
        subscriberId: _widgetId,
        widgetType: 'Subscriber',
        singlePeerConnection: !!((_session5 = _session) != null && _session5._singlePeerConnectionController)
      }, options);
      if (variation === 'Failure' || variation === 'iceconnectionstatechange' && payload === 'closed') {
        stats = (0, _assign.default)(stats, _preDisconnectStats);
      }
      const args = [stats];
      if (throttle) {
        args.push(throttle);
      }
      analytics.logEvent(...args);
    };
    const logHybridSessionTransition = (action, variation, payload) => {
      if (variation === 'Attempt') {
        hybridSessionTransitionStartTimes[action] = new Date().getTime();
        logAnalyticsEvent(action, variation, payload);
      } else if (variation === 'Failure' || variation === 'Success') {
        logAnalyticsEvent(action, variation, payload, {
          attemptDuration: new Date().getTime() - hybridSessionTransitionStartTimes[action]
        });
      }
    };
    const logRoutedToRelayedTransition = function logRoutedToRelayedTransition(variation, payload) {
      if (payload === void 0) {
        payload = {};
      }
      logHybridSessionTransition('RoutedToRelayedTransition', variation, payload);
    };
    const logRelayedToRoutedTransition = function logRelayedToRoutedTransition(variation, payload) {
      if (payload === void 0) {
        payload = {};
      }
      logHybridSessionTransition('RelayedToRoutedTransition', variation, payload);
    };
    const connectivityState = (0, _connectivityState.default)({
      onInvalidTransition(transition, from) {
        const err = `Invalid state transition: Event '${transition}' not possible in state '${from}'`;
        logging.error(err);
        logAnalyticsEvent('Subscriber:InvalidStateTransition', 'Event', {
          details: err
        });
      }
    });
    {
      const errMessage = 'Unable to subscribe to stream in a reasonable amount of time';
      // make sure we trigger an error if we are not getting any "data" after a reasonable
      // amount of time

      (0, _overallTimeout.default)({
        connectivityState,
        onWarning() {
          logConnectivityEvent('Warning', {});
        },
        onTimeout: () => {
          if (_widgetView) {
            _widgetView.addError(errMessage);
          }
          if (_state.isAttemptingToSubscribe()) {
            _state.set('Failed');
            this._disconnect({
              noStateTransition: true
            });
            const error = otError(_Errors.default.TIMEOUT, new Error(errMessage), ExceptionCodes.UNABLE_TO_SUBSCRIBE);
            connectivityState.fail({
              options: {
                failureReason: 'Subscribe',
                failureMessage: errMessage,
                failureCode: ExceptionCodes.UNABLE_TO_SUBSCRIBE
              },
              error
            });
          }
        },
        warningMs: BIND_VIDEO_DELAY_WARNING,
        timeoutMs: BIND_VIDEO_DELAY_MAX
      });
    }
    _pcConnected.promise = new Promise((resolve, reject) => {
      _pcConnected.resolve = resolve;
      _pcConnected.reject = reject;
    });
    if (_properties.testNetwork && _session.sessionInfo.p2pEnabled) {
      logging.warn('You cannot test your network with a relayed session. Use a routed session.');
    }
    const _isAutoPreferredResolution = _properties.preferredResolution === 'auto' && !_session.sessionInfo.p2pEnabled;
    this.id = _domId;
    this.widgetId = _widgetId;
    this.session = _session;
    this.stream = _properties.stream;
    _stream = _properties.stream;
    this.streamId = _stream.id;
    if (!_session) {
      OTErrorClass.handleJsException({
        errorMsg: 'OT.Subscriber must be passed a session option',
        code: 2000,
        target: this,
        analytics
      });
      return null;
    }
    (0, _eventing.default)(this);
    const qosQualityScores = {
      audioQualityScore: undefined,
      videoQualityScore: undefined
    };
    const scoreEmitter = createMOSScoreHelper();
    scoreEmitter.startMonitoringInterval({
      getStats: _getStats,
      subscriber: this,
      getCurrentPeerConnection,
      logging,
      qosQualityScores
    });
    _subscriber.once('subscribeComplete', function () {
      try {
        completionHandler(...arguments);
      } catch (err) {
        logging.error('Completion handler threw an exception', err);
      }
    });
    const onCaptionReceived = event => {
      if (event.streamId === _subscriber.streamId) {
        this.dispatchEvent(event);
        this.trigger(_eventNames.default.SUBSCRIBER_CAPTION_RECEIVED, event);
      }
    };
    _session.on('captionReceived', onCaptionReceived);
    const getVariationFromState = _ref8 => {
      let transition = _ref8.transition,
        from = _ref8.from;
      if (transition === 'fail') {
        if (from === 'connected') {
          return 'Disconnect';
        }
        return 'Failure';
      }
      if (transition === 'disconnect' && from === 'connected') {
        return 'Disconnect';
      }
      return 'Cancel';
    };
    connectivityState.observe({
      onEnterConnecting() {
        logConnectivityEvent('Attempt', null, {});
      },
      onEnterConnected() {
        logConnectivityEvent('Success', null, {});
      },
      onEnterDisconnected(state, _temp) {
        let _ref9 = _temp === void 0 ? {} : _temp,
          _ref9$options = _ref9.options,
          options = _ref9$options === void 0 ? {} : _ref9$options,
          _ref9$payload = _ref9.payload,
          payload = _ref9$payload === void 0 ? null : _ref9$payload;
        logConnectivityEvent(getVariationFromState(state), payload, options);
      }
    });
    connectivityState.observe({
      onEnterConnected: () => {
        this.trigger('subscribeComplete', undefined, this);
      },
      onEnterDisconnected: function onEnterDisconnected(_ref10, _temp2) {
        let from = _ref10.from;
        let _ref11 = _temp2 === void 0 ? {} : _temp2,
          error = _ref11.error;
        if (from === 'connecting') {
          _this.trigger('subscribeComplete', error || new Error('An unknown error occurred'), _this);
        }
      }
    });
    (0, _connectivityAttemptPinger.default)({
      connectivityState,
      logAttempt() {
        var _session6, _session7, _session7$connection;
        logAnalyticsEvent('Subscribe', 'Attempting', null, {
          connectionId: (_session6 = _session) != null && _session6.isConnected() ? (_session7 = _session) == null ? void 0 : (_session7$connection = _session7.connection) == null ? void 0 : _session7$connection.connectionId : null
        });
      }
    });
    const logConnectivityEvent = function logConnectivityEvent(variation, payload, options) {
      if (payload === void 0) {
        payload = {};
      }
      if (variation === 'Failure' || variation === 'Success' || variation === 'Cancel') {
        logAnalyticsEvent('Subscribe', variation, payload, Object.assign({}, options, {
          attemptDuration: new Date().getTime() - _attemptStartTime
        }));
      } else if (variation === 'Attempt') {
        _attemptStartTime = new Date().getTime();
        logAnalyticsEvent('Subscribe', variation, Object.assign({}, payload, {
          testNetwork: _properties.testNetwork
        }), options);
      } else {
        logAnalyticsEvent('Subscribe', variation, payload, options);
      }
    };
    const logResubscribe = (variation, payload) => {
      logAnalyticsEvent('ICERestart', variation, payload);
    };
    const recordQOS = _ref12 => {
      var _session$connection$c, _session8, _session8$connection, _properties$preferred, _properties$preferred2;
      let parsedStats = _ref12.parsedStats,
        remoteConnectionId = _ref12.remoteConnectionId,
        peerId = _ref12.peerId,
        sourceStreamId = _ref12.sourceStreamId;
      const QoSBlob = Object.assign({
        widgetType: 'Subscriber',
        width: _widgetView.width,
        height: _widgetView.height,
        audioTrack: _streamHasTracks('audio'),
        hasAudio: _stream && _stream.hasAudio,
        subscribeToAudio: _isSubscribingToAudio,
        audioVolume: this.getAudioVolume(),
        videoTrack: _streamHasTracks('video'),
        connectionId: (_session$connection$c = (_session8 = _session) == null ? void 0 : (_session8$connection = _session8.connection) == null ? void 0 : _session8$connection.connectionId) != null ? _session$connection$c : null,
        hasVideo: _stream && _stream.hasVideo,
        subscribeToVideo: _properties.subscribeToVideo,
        congestionLevel: _congestionLevel,
        streamId: _stream.id,
        subscriberId: _widgetId,
        duration: Math.round(((0, _now.default)() - _subscribeStartTime) / 1000),
        remoteConnectionId,
        peerId,
        sourceStreamId: (0, _getMediaModeBySourceStreamId.default)(sourceStreamId),
        preferredResolutionHeight: (_properties$preferred = _properties.preferredResolution) == null ? void 0 : _properties$preferred.height,
        preferredResolutionWidth: (_properties$preferred2 = _properties.preferredResolution) == null ? void 0 : _properties$preferred2.width,
        preferredFrameRate: _properties.preferredFrameRate,
        audioFallback: !_videoEnabled && _lastSubscribeToVideoReason === 'auto',
        initials: _stream.initials,
        cpuPerformanceState: _session._.getCpuPerformanceState()
      }, qosQualityScores);
      const combinedStats = (0, _assign.default)(QoSBlob, parsedStats);
      analytics.logQOS(combinedStats);
      this.trigger('qos', Object.assign({}, analytics.commonQoSFields(), combinedStats));
    };
    const stateChangeFailed = changeFailed => {
      logging.error('OT.Subscriber State Change Failed: ', changeFailed.message);
      logging.debug(changeFailed);
    };
    const onLoaded = () => {
      if (_state.isSubscribing() || !_widgetView || !_widgetView.video()) {
        return;
      }
      _loaded = true;
      if (!_hasLoadedAtLeastOnce) {
        connectivityState.connect();
        _hasLoadedAtLeastOnce = true;
      }
      logging.debug('OT.Subscriber.onLoaded');
      _state.set('Subscribing');
      _subscribeStartTime = (0, _now.default)();
      _widgetView.loading(false);
      if (_chrome) {
        _chrome.showAfterLoading();
      }
      if (_frameRateRestricted) {
        _stream.setRestrictFrameRate(true);
      }
      if (_audioLevelMeter) {
        _audioLevelMeter.audioOnly(_widgetView.audioOnly());
      }
      this.setAudioVolume(_audioVolume);
      this.trigger('loaded', this);
    };
    const isAudioOn = () => _stream && _stream.hasAudio && _isSubscribingToAudio && this.getAudioVolume() > 0 && !this.isAudioBlocked();
    const isVideoOn = () => _stream && _stream.hasVideo;
    const onAudioLevelStuckWarning = reason => {
      // `audioLevelStuckAt0` warning will be ignored either because the video is ON or audio is OFF
      const shouldIgnoreWarning = reason === 'audioLevelStuckAt0' && (!isAudioOn() || isVideoOn());
      let disableAudioLevelStuckAt0 = false;
      if (!shouldIgnoreWarning) {
        logAnalyticsEvent('subscriber:onAudioWarning', 'Event', {
          reason
        });
        if (_widgetView) {
          _widgetView.rebindSrcObject();
          logAnalyticsEvent('subscriber:rebindSrcObject', 'Called');
          if (reason === 'audioLevelStuck') {
            // Since 'audioLevelStuck' anomally was detected and the rebind already happened,
            // we don't need to do future rebinds. We can do a return here so that the watcher
            // is not restarted.
            return;
          }

          // This is to ignore future warnings of this type in order to prevent
          // periodical rebindings.
          disableAudioLevelStuckAt0 = true;
        }
      }
      startAudioStatsWatcher(disableAudioLevelStuckAt0);
    };
    const startAudioStatsWatcher = /*#__PURE__*/function () {
      var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(disableAudioLevelStuckAt0) {
        var peerConnection;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (disableAudioLevelStuckAt0 === void 0) {
                disableAudioLevelStuckAt0 = false;
              }
              if (!_supportsAudioStatsWatcher) {
                _context5.next = 6;
                break;
              }
              _context5.next = 4;
              return getCurrentPeerConnection();
            case 4:
              peerConnection = _context5.sent;
              peerConnection.startAudioStatsWatcher(disableAudioLevelStuckAt0);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function startAudioStatsWatcher(_x6) {
        return _ref13.apply(this, arguments);
      };
    }();
    const onPeerConnected = peerConnection => {
      const isAdaptiveP2pSourceStreamId = _isAdaptiveEnabled && peerConnection.getSourceStreamId() === 'P2P';
      if (isAdaptiveP2pSourceStreamId) {
        logRoutedToRelayedTransition('Success');
      }
    };
    const onPeerDisconnected = () => {
      logging.debug('OT.Subscriber has been disconnected from the Publisher\'s PeerConnection');
      connectivityState.fail({
        options: {
          failureReason: 'PeerConnectionError',
          failureCode: ExceptionCodes.UNABLE_TO_PUBLISH,
          failureMessage: 'PeerConnection disconnected'
        },
        error: otError(errors.DISCONNECTED, new Error('ClientDisconnected'))
      });
      this._disconnect({
        noStateTransition: true
      });
      if (_state.isAttemptingToSubscribe() || _state.isSubscribing()) {
        _state.set('Failed');
      }
    };
    const onVideoError = plainErr => {
      const err = otError(errors.MEDIA_ERR_DECODE, plainErr, plainErr.code || ExceptionCodes.P2P_CONNECTION_FAILED);
      err.message = `OT.Subscriber while playing stream: ${err.message}`;
      logging.error('OT.Subscriber.onVideoError');
      connectivityState.fail({
        options: {
          failureReason: 'VideoElement',
          failureMessage: err.message,
          failureCode: err.code || ExceptionCodes.P2P_CONNECTION_FAILED
        },
        error: err
      });
      const isAttemptingToSubscribe = _state.isAttemptingToSubscribe();
      _state.set('Failed');
      if (!isAttemptingToSubscribe) {
        // FIXME: This emits a string instead of an error here for backwards compatibility despite
        // being undocumented. When possible we should remove access to this and other undocumented
        // events, and restore emitting actual errors here.
        _subscriber.trigger('error', err.message);
      }
      OTErrorClass.handleJsException({
        error: err,
        code: ExceptionCodes.UNABLE_TO_SUBSCRIBE,
        // @todo why do we override the code?
        target: _subscriber,
        analytics
      });
    };
    const onSubscriberCreateError = rawError => {
      // @todo v3 These errors used to come from the peer connection hence the mention
      // of peer connection in the logs/ errors. However they actually have nothing to do
      // with the peer connection. I have chosen to keep the messages / errors the same for
      // now, but we should consider changing them
      const err = (0, _interpretSubscriberCreateError.default)(rawError);
      OTErrorClass.handleJsException({
        error: err,
        code: err.code,
        target: _subscriber,
        analytics
      });
      this._disconnect({
        noStateTransition: true
      });
      const options = {
        failureReason: 'Subscribe',
        failureMessage: `OT.Subscriber PeerConnection Error: ${err.message}`,
        failureCode: ExceptionCodes.P2P_CONNECTION_FAILED
      };
      _showError(err.code, err.message);
      connectivityState.fail({
        options,
        error: otError(err.name, new Error('Subscribe: Subscriber PeerConnection with connection (not found) ' + `failed: ${err.message}`), err.code)
      });
      if (err.name === _Errors.default.STREAM_NOT_FOUND) {
        // Usually, the subscriber should be kept in an error state when the peer connection fails
        // because it still exists in the session. But when we get a 404 that means it doesn't
        // exist, even if the session still thinks it does.
        this._destroy({
          reason: 'streamNotFound',
          noStateTransition: true
        });
      }
    };
    const onPeerConnectionFailure = (code, reason, peerConnection, prefix) => {
      if (prefix === 'SetRemoteDescription' && !_isVideoSupported && reason.match(/Unsupported video without audio for fallback/)) {
        if (_widgetView) {
          _widgetView.addError('The stream is unable to be played.', 'Your browser does not support the video format.');
        }
        let err;
        if (OTHelpers.env.name === 'Safari') {
          err = new Error('VP8 is not supported in this version of Safari. You might want to consider switching to ' + 'an H264 project. See https://tokbox.com/developer/sdks/js/safari for more information.');
        } else {
          err = new Error('Video format not supported in this browser.');
        }
        err.code = ExceptionCodes.UNSUPPORTED_VIDEO_CODEC;
        onVideoError(err);
        return;
      }
      if (prefix === 'ICEWorkflow' && _session.sessionInfo.reconnection && _loaded) {
        logging.debug('Ignoring peer connection failure due to possibility of reconnection.');
        return;
      }
      let errorCode;
      if (prefix === 'ICEWorkflow') {
        errorCode = ExceptionCodes.SUBSCRIBER_ICE_WORKFLOW_FAILED;
      } else if (code === ExceptionCodes.STREAM_LIMIT_EXCEEDED) {
        errorCode = code;
      } else {
        errorCode = ExceptionCodes.P2P_CONNECTION_FAILED;
      }
      const options = {
        failureReason: prefix || 'PeerConnectionError',
        failureMessage: `OT.Subscriber PeerConnection Error: ${reason}`,
        failureCode: errorCode
      };
      const error = interpretPeerConnectionError(code, reason, prefix, '(not found)', 'Subscriber');
      connectivityState.fail({
        options,
        error
      });
      if (_state.isAttemptingToSubscribe()) {
        // We weren't subscribing yet so this was a failure in setting
        // up the PeerConnection or receiving the initial stream.
        const payload = {
          hasRelayCandidates: peerConnection && peerConnection.hasRelayCandidates()
        };
        logAnalyticsEvent('createPeerConnection', 'Failure', payload, options);
        _state.set('Failed');
      } else if (_state.isSubscribing()) {
        // we were disconnected after we were already subscribing
        _state.set('Failed');
        this.trigger('error', reason);
      }
      this._disconnect({
        noStateTransition: true
      });
      if (Number(code) === 404) {
        // Usually, the subscriber should be kept in an error state when the peer connection fails
        // because it still exists in the session. But when we get a 404 that means it doesn't
        // exist, even if the session still thinks it does.
        this._destroy({
          noStateTransition: true
        });
      }
      OTErrorClass.handleJsException({
        error,
        errorMsg: `OT.Subscriber PeerConnection Error: ${reason}`,
        code: errorCode,
        target: this,
        analytics
      });
      _showError(code);
    };
    const hasExpectedTracks = peerConnection => {
      const hasVideoTracks = peerConnection._hasVideoTracks();
      const hasAudioTracks = peerConnection._hasAudioTracks();

      // If we're not subbing to video/audio, we don't expect those tracks in the PC
      const shouldHaveVideoTracks = _properties.subscribeToVideo;
      const shouldHaveAudioTracks = _properties.subscribeToAudio;
      const isMissingVideo = _stream && _stream.hasVideo && !hasVideoTracks && shouldHaveVideoTracks;
      const isMissingAudio = _stream && _stream.hasAudio && !hasAudioTracks && shouldHaveAudioTracks;
      return !(isMissingVideo || isMissingAudio);
    };
    const onTrackAdded = /*#__PURE__*/function () {
      var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(webRTCStream, peerConnection) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return waitUntil(() => hasExpectedTracks(peerConnection));
            case 3:
              _context6.next = 12;
              break;
            case 5:
              _context6.prev = 5;
              _context6.t0 = _context6["catch"](0);
              if (!(_context6.t0.message === 'TIMEOUT')) {
                _context6.next = 11;
                break;
              }
              // If it timeouts, let's log the error but no throw. This will allow us to be more fault
              // tolerant when video fails, e.g. video codecs incompatibility or any other reason.
              logging.error('The expected tracks never arrived');
              _context6.next = 12;
              break;
            case 11:
              throw _context6.t0;
            case 12:
              onRemoteStreamAdded.push({
                webRTCStream,
                peerConnection
              });
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 5]]);
      }));
      return function onTrackAdded(_x7, _x8) {
        return _ref14.apply(this, arguments);
      };
    }();
    const setStream = (webRTCStream, sourceStreamId) => {
      if (!_exposedWebRTCStream) {
        _exposedWebRTCStream = new MediaStream(webRTCStream);
        this.dispatchEvent(new Events.MediaStreamAvailableEvent(_exposedWebRTCStream));
      }
      _webRTCStream = webRTCStream;
      if (sourceStreamId) {
        webRTCStreams[sourceStreamId] = webRTCStream;
      }
    };
    const applyVideoMediaProcessor = /*#__PURE__*/function () {
      var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(sourceStreamId) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!_videoEnabled) {
                _context7.next = 5;
                break;
              }
              _context7.next = 3;
              return applyVideoConnectorOnStream(sourceStreamId);
            case 3:
              _context7.next = 6;
              break;
            case 5:
              _videoMediaProcessorConnector.destroy();
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function applyVideoMediaProcessor(_x9) {
        return _ref15.apply(this, arguments);
      };
    }();
    const setSubscribingOptions = () => {
      // Disable the audio/video, if needed
      this.subscribeToAudio(_isSubscribingToAudio);
      if (!(_lastSubscribeToVideoReason === 'auto' && !_properties.subscribeToVideo)) {
        // If subscriber is in audio fallback, don't set reason to 'loading'
        _lastSubscribeToVideoReason = 'loading';
        this.subscribeToVideo(_properties.subscribeToVideo, 'loading');
      }
    };
    const setStreamPreferences = (_ref16, sourceStreamId) => {
      let p2pEnabled = _ref16.p2pEnabled;
      // setting resolution and frame rate doesn't work in P2P
      if (!p2pEnabled && sourceStreamId !== 'P2P') {
        if (!_isAutoPreferredResolution) {
          this.setPreferredResolution(_properties.preferredResolution);
        }
        this.setPreferredFrameRate(_properties.preferredFrameRate);
      }
    };
    const setStreamOptions = /*#__PURE__*/function () {
      var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(sessionInfo, sourceStreamId) {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!_videoMediaProcessorConnector) {
                _context8.next = 3;
                break;
              }
              _context8.next = 3;
              return applyVideoMediaProcessor(sourceStreamId);
            case 3:
              setSubscribingOptions();
              setStreamPreferences(sessionInfo, sourceStreamId);
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function setStreamOptions(_x10, _x11) {
        return _ref17.apply(this, arguments);
      };
    }();
    const updatePeerConnectionTracks = (peerConnection, forceDisable) => {
      if (peerConnection) {
        // No peer connection if subscribingToSelf
        peerConnection._getVideoTracks().forEach(track => {
          track.enabled = !forceDisable && _stream.hasVideo && _properties.subscribeToVideo;
        });
      }
    };
    const handleBindStreamError = error => {
      if ((0, _amrVideoBufferError.isAmrVideoBufferError)(error)) {
        logging.error(`OT.Subscriber: ${error.message}`);
        // If videoBuffer failed, we complete the transition to avoid a hanging state.
        onLoaded();
        amrState.completeTransitionTo(_activeSourceStreamId);
        // If it fails when transitioning to P2P, we roll back to Routed. If it fails when
        // transitioning to Routed, then there is nothing we can do.
        if (_activeSourceStreamId === 'P2P') {
          socket.subscriberDestroy(_stream.id, this.widgetId, _activeSourceStreamId);
        }
      }
      throw error;
    };
    const bindStream = /*#__PURE__*/function () {
      var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              logAnalyticsEvent('BindStream', 'Attempt');
              _context9.prev = 1;
              _context9.next = 4;
              return bindWebRTCStream(_webRTCStream);
            case 4:
              _context9.next = 10;
              break;
            case 6:
              _context9.prev = 6;
              _context9.t0 = _context9["catch"](1);
              logAnalyticsEvent('BindStream', 'Failure', {
                message: _context9.t0.message
              });
              handleBindStreamError(_context9.t0);
            case 10:
              logAnalyticsEvent('BindStream', 'Success');
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[1, 6]]);
      }));
      return function bindStream() {
        return _ref18.apply(this, arguments);
      };
    }();
    const updateVideoProperties = () => {
      var _widgetView2, _chrome2, _chrome2$videoUnsuppo;
      const video = (_widgetView2 = _widgetView) == null ? void 0 : _widgetView2.video();
      if (video) {
        video.orientation({
          width: _stream.videoDimensions.width,
          height: _stream.videoDimensions.height,
          videoOrientation: _stream.videoDimensions.orientation
        });
      }
      (_chrome2 = _chrome) == null ? void 0 : (_chrome2$videoUnsuppo = _chrome2.videoUnsupportedIndicator) == null ? void 0 : _chrome2$videoUnsuppo.setVideoUnsupported(!_isVideoSupported);
    };
    const videoElementCreate = () => new Promise((resolve, reject) => {
      var _widgetView3;
      const video = (_widgetView3 = _widgetView) == null ? void 0 : _widgetView3.video();
      if (video != null && video.domElement()) {
        resolve();
      } else {
        _widgetView.once('videoElementCreated', resolve);
        _subscriber.once('destroyed', reject);
      }
    });
    const setAudioLevelSampler = (webRTCStream, peerConnection) => {
      // if the audioLevelSampler implementation requires a stream we need to set it now
      if (_audioLevelSampler && 'webRTCStream' in _audioLevelSampler && peerConnection._hasAudioTracks()) {
        _audioLevelSampler.webRTCStream(webRTCStream);
      }
    };
    const monitorFrameRate = peerConnection => {
      if (_frameRateWatcher) {
        _frameRateWatcher.destroy();
        _frameRateWatcher = null;
      }
      if (peerConnection) {
        _frameRateWatcher = watchFrameRate(peerConnection.getStats.bind(peerConnection));
      }
    };
    const startMonitors = (webRTCStream, peerConnection) => {
      setAudioLevelSampler(webRTCStream, peerConnection);
      if ((0, _shouldMonitorFrameRate.default)()) {
        monitorFrameRate(peerConnection);
      }
    };
    const handleAdaptiveStreamAdded = /*#__PURE__*/function () {
      var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              amrState.completeTransitionTo(_activeSourceStreamId);
              if (!(_isSubscribingToAudio && _audioConnector.audioMediaProcessorConnector)) {
                _context10.next = 11;
                break;
              }
              _context10.prev = 2;
              _context10.next = 5;
              return _audioConnector.applyAudioConnectorOnRoutedToRelayedTransition();
            case 5:
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Success', {
                message: 'Audio connector applied on routed to relayed transition.'
              });
              _context10.next = 11;
              break;
            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](2);
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
                message: _context10.t0.message
              });
            case 11:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[2, 8]]);
      }));
      return function handleAdaptiveStreamAdded() {
        return _ref19.apply(this, arguments);
      };
    }();
    const onRemoteStreamAdded = (0, _queue.default)( /*#__PURE__*/function () {
      var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(_ref20, done) {
        var webRTCStream, peerConnection, sourceStreamId, _session9, sessionInfo, forceDisable;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              webRTCStream = _ref20.webRTCStream, peerConnection = _ref20.peerConnection;
              sourceStreamId = peerConnection == null ? void 0 : peerConnection.getSourceStreamId();
              _session9 = _session, sessionInfo = _session9.sessionInfo;
              setStream(webRTCStream, sourceStreamId);
              logging.debug('OT.Subscriber.onRemoteStreamAdded with sourceStreamId', sourceStreamId);
              if (!_state.isMigrating()) {
                _state.set('BindingRemoteStream');
              }
              _context11.next = 8;
              return setStreamOptions(sessionInfo, sourceStreamId);
            case 8:
              // This is a workaround for a bug in Chrome where a track disabled on
              // the remote end doesn't fire loadedmetadata causing the subscriber to timeout
              // https://jira.tokbox.com/browse/OPENTOK-15605
              // Also https://jira.tokbox.com/browse/OPENTOK-16425
              // Also https://jira.vonage.com/browse/OPENTOK-27112
              forceDisable = !!(typeof window !== undefined ? window : global).webkitMediaStream;
              updatePeerConnectionTracks(peerConnection, forceDisable);
              _context11.prev = 10;
              _context11.next = 13;
              return bindStream();
            case 13:
              _context11.next = 19;
              break;
            case 15:
              _context11.prev = 15;
              _context11.t0 = _context11["catch"](10);
              // If bindStream throws a buffer AMR error, this is cancelled, and a transition will recover it
              if (!(0, _amrVideoBufferError.isAmrVideoBufferError)(_context11.t0)) {
                _this._destroy(_context11.t0.reason || 'Stream has failed to bind.');
              }
              return _context11.abrupt("return");
            case 19:
              startAudioStatsWatcher();
              if (!_state.isDestroyed()) {
                _context11.next = 23;
                break;
              }
              logging.error('Subscriber destroyed');
              return _context11.abrupt("return");
            case 23:
              // Enable any video streams that we previously disabled for OPENTOK-27112
              updatePeerConnectionTracks(peerConnection);
              updateVideoProperties();

              // Once videoElement is created and PC connected, the Subscriber is completed.
              _context11.next = 27;
              return videoElementCreate();
            case 27:
              _context11.next = 29;
              return _pcConnected.promise;
            case 29:
              if (!_loaded) {
                onLoaded();
              } else if (!_state.isMigrating()) {
                _state.set('Subscribing');
              }
              startMonitors(webRTCStream, peerConnection);
              if (!_isAdaptiveEnabled) {
                _context11.next = 34;
                break;
              }
              _context11.next = 34;
              return handleAdaptiveStreamAdded();
            case 34:
              // Async queue will use this callback to run next.
              done();
            case 35:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[10, 15]]);
      }));
      return function (_x12, _x13) {
        return _ref21.apply(this, arguments);
      };
    }());
    const applyVideoConnectorOnStream = /*#__PURE__*/function () {
      var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(sourceStreamId) {
        var _webRTCStreams$MANTIS, filteredVideoTrack;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              // We apply the videoFilter to the new stream
              if (sourceStreamId === 'P2P' && _originalVideoTrack) {
                // If we are transitioning to P2P, we need to restore the original track in the Mantis stream.
                // Please note we don't add a new stream when transitioning back to Mantis.
                _webRTCStreams$MANTIS = webRTCStreams.MANTIS.getVideoTracks(), filteredVideoTrack = _webRTCStreams$MANTIS[0];
                (0, _updateTrackOnStream.default)(webRTCStreams.MANTIS, filteredVideoTrack, _originalVideoTrack);
              }
              _context12.next = 3;
              return _setVideoMediaProcessorConnector();
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return function applyVideoConnectorOnStream(_x14) {
        return _ref22.apply(this, arguments);
      };
    }();
    const onRemoteVideoSupported = supported => {
      // as _isVideoSupported is true by default, this will only ever be hit if we receive
      // a onRemoteVideoSupported false, and then a onRemoteVideoSupported true. In other words
      // it will not trigger an event if video is enabled and is never disabled due to codec issues.

      if (_isVideoSupported !== supported) {
        this.dispatchEvent(new Events.VideoEnabledChangedEvent(supported ? 'videoEnabled' : 'videoDisabled', {
          reason: supported ? 'codecChanged' : 'codecNotSupported'
        }));
      }
      _isVideoSupported = supported;
    };
    const audioBlockedStateChange = value => {
      _widgetView.setAudioBlockedUi(value);
      const indicator = _chrome && _chrome.audioBlockedIndicator;
      if (indicator) {
        indicator.setAudioBlocked(value);
      }
      const videoIndicator = _chrome && _chrome.videoUnsupportedIndicator;
      if (videoIndicator) {
        videoIndicator.setVideoUnsupported(!value && !_isVideoSupported);
      }
    };
    this.on('audioBlocked', () => {
      audioBlockedStateChange(true);
    });
    this.on('audioUnblocked', () => {
      audioBlockedStateChange(false);
    });
    const connectionStateMap = {
      new: _eventNames.default.SUBSCRIBER_DISCONNECTED,
      checking: _eventNames.default.SUBSCRIBER_DISCONNECTED,
      connected: _eventNames.default.SUBSCRIBER_CONNECTED,
      completed: _eventNames.default.SUBSCRIBER_CONNECTED,
      disconnected: _eventNames.default.SUBSCRIBER_DISCONNECTED,
      failed: _eventNames.default.SUBSCRIBER_DESTROYED
    };
    const isConnectionStateChanged = (currentState, lastState) => currentState && currentState !== lastState;
    const destroyAdaptiveRelayedPeerConnection = () => {
      logging.warn('OT.Subscriber: relayed PeerConnection has failed, rolling back to routed PeerConnection');
      socket.subscriberDestroy(_stream.id, this.widgetId, 'P2P');
      logAnalyticsEvent('AMRMantisRollback', 'Event');
      _widgetView.loading(_lastConnectionStatesMap.MANTIS !== 'connected');
    };
    const handleDisconnect = sourceStreamId => {
      if (sourceStreamId !== 'P2P') {
        setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
          return _regenerator.default.wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                if (!(_lastConnectionStatesMap[sourceStreamId] === 'disconnected' && _session._.isSocketConnected())) {
                  _context13.next = 3;
                  break;
                }
                _context13.next = 3;
                return _this._.iceRestart('peer connection disconnected');
              case 3:
              case "end":
                return _context13.stop();
            }
          }, _callee13);
        })), 2000);
      }
    };
    const handleFailMantis = () => {
      if (_session._.isSocketConnected()) {
        setTimeout(() => {
          if (_lastConnectionStatesMap.MANTIS === 'destroyed') {
            this._destroy({
              reason: 'peerConnection is disconnected',
              noStateTransition: true
            });
          }
          // Allow 2s to make sure that a WebSocket reconnection hasn't triggered an iceRestart at
          // the same time the PC has failed.
        }, 2000);
      }
    };
    const handleFailAdaptive = sourceStreamId => {
      if (sourceStreamId === 'P2P') {
        // If P2P leg fails in an adaptive session, then we will proceed to destroy it so the
        // transition to Mantis is triggered.
        destroyAdaptiveRelayedPeerConnection();
      } else if (_activeSourceStreamId === 'MANTIS') {
        handleFailMantis();
      }
    };
    const handleFail = sourceStreamId => {
      const p2pEnabled = _session.sessionInfo.p2pEnabled;
      if (_isAdaptiveEnabled) {
        handleFailAdaptive(sourceStreamId);
      } else if (!p2pEnabled) {
        handleFailMantis();
      }
    };
    const updateWidgetView = currentConnectionState => {
      if (_widgetView) {
        _widgetView.loading(currentConnectionState !== _eventNames.default.SUBSCRIBER_CONNECTED);
      }
    };
    const notifyStateChange = (state, currentConnectionState, sourceStreamId) => {
      logging.debug(`OT.Subscriber.connectionStateChanged to ${state}`);
      if (_subscriberConnectionState === currentConnectionState || state === 'failed' && !_session._.isSocketConnected()) {
        return;
      }

      // Allow 2s for a posible iceRestart in Mantis PC happening by a socket reconnection.
      // Please see `handleFailMantis`
      const delayEventMs = state === 'failed' && sourceStreamId === 'MANTIS' ? 2000 : 0;
      setTimeout(() => {
        if (state !== 'failed' || _lastConnectionStatesMap[sourceStreamId] === 'destroyed') {
          this.dispatchEvent(new Events.ConnectionStateChangedEvent(currentConnectionState, this, (0, _getMediaModeBySourceStreamId.default)(sourceStreamId)));
        }
      }, delayEventMs);
    };
    const onIceConnectionStateChange = (state, peerConnection) => {
      const currentConnectionState = connectionStateMap[state];
      const sourceStreamId = peerConnection.getSourceStreamId();
      const lastConnectionState = _lastConnectionStatesMap[sourceStreamId];
      if (!isConnectionStateChanged(currentConnectionState, lastConnectionState)) return;
      _lastConnectionStatesMap[sourceStreamId] = currentConnectionState;
      if (state === 'disconnected') {
        handleDisconnect(sourceStreamId);
      } else if (state === 'failed') {
        handleFail(sourceStreamId);
        // Do nothing else in P2P, since we don't want to destroy the Subscriber or change its
        // video state to loading.
        if (sourceStreamId === 'P2P') return;
      }
      if (sourceStreamId === _activeSourceStreamId) {
        updateWidgetView(currentConnectionState);
        notifyStateChange(state, currentConnectionState, sourceStreamId);
        _subscriberConnectionState = currentConnectionState;
      }
    };
    const onIceRestartSuccess = () => {
      logResubscribe('Success');
    };
    const onIceRestartFailure = () => {
      logResubscribe('Failure', {
        reason: 'ICEWorkflow',
        message: 'OT.Subscriber PeerConnection Error: ' + 'The stream was unable to connect due to a network error.' + ' Make sure your connection isn\'t blocked by a firewall.'
      });
    };
    const streamUpdated = event => {
      const video = _widgetView && _widgetView.video();
      switch (event.changedProperty) {
        case 'videoDimensions':
          if (!video) {
            // Ignore videoDimensions updates before video is created OPENTOK-17253
            break;
          }
          video.orientation({
            width: event.newValue.width,
            height: event.newValue.height,
            videoOrientation: event.newValue.orientation
          });
          this.dispatchEvent(new Events.VideoDimensionsChangedEvent(this, event.oldValue, event.newValue));
          break;
        case 'videoDisableWarning':
          if (_chrome) {
            _chrome.videoDisabledIndicator.setWarning(event.newValue);
          }
          this.dispatchEvent(new Events.VideoDisableWarningEvent(event.newValue ? 'videoDisableWarning' : 'videoDisableWarningLifted'));
          _congestionLevel = event.newValue ? 1 : null;
          break;
        case 'hasVideo':
          // @todo setAudioOnly affects peer connections, what happens with new ones?
          setAudioOnly(!_stream.hasVideo || !_properties.subscribeToVideo);

          // Makes sure that the audio workaround for Safari is executed.
          if (env.isSafari && !_stream.hasVideo && _widgetView) {
            _widgetView.bindAudioTrackOnly();
          }
          this.dispatchEvent(new Events.VideoEnabledChangedEvent(_stream.hasVideo ? 'videoEnabled' : 'videoDisabled', {
            reason: 'publishVideo'
          }));
          break;
        case 'hasAudio':
          _muteDisplayMode.update();
          break;
        default:
      }
    };

    // Use _stream.getChannelsOfType instead of _webRTCStream.getAudioTracks
    // because its available as soon as Subscriber is instantiated.
    const _hasAudioTracks = () => _stream.getChannelsOfType('audio').length > 0;

    // / Chrome

    _muteDisplayMode = {
      get() {
        // Use buttonDisplayMode if we have an audio track, even if its muted
        return _hasAudioTracks() ? _subscriber.getStyle('buttonDisplayMode') : 'off';
      },
      update() {
        const mode = _muteDisplayMode.get();
        if (_chrome) {
          _chrome.muteButton.setDisplayMode(mode);
          _chrome.backingBar.setMuteMode(mode);
        }
      }
    };
    const updateChromeForStyleChange = (key, value /* , oldValue */) => {
      if (!_chrome) {
        return;
      }
      switch (key) {
        case 'nameDisplayMode':
          _chrome.name.setDisplayMode(value);
          _chrome.backingBar.setNameMode(value);
          break;
        case 'videoUnsupportedDisplayMode':
          _chrome.videoUnsupportedIndicator.setDisplayMode(value);
          break;
        case 'videoDisabledDisplayMode':
          _chrome.videoDisabledIndicator.setDisplayMode(value);
          break;
        case 'audioBlockedDisplayMode':
          _chrome.audioBlockedIndicator.setDisplayMode(value);
          break;
        case 'showArchiveStatus':
          _chrome.archive.setShowArchiveStatus(value);
          break;
        case 'buttonDisplayMode':
          _muteDisplayMode.update();
          break;
        case 'audioLevelDisplayMode':
          _chrome.audioLevel.setDisplayMode(value);
          break;
        case 'bugDisplayMode':
          // bugDisplayMode can't be updated but is used by some partners
          break;
        case 'backgroundImageURI':
          _widgetView.setBackgroundImageURI(value);
          break;
        default:
      }
    };
    const _createChrome = () => {
      const widgets = {
        backingBar: new BackingBar({
          nameMode: !_properties.name ? 'off' : this.getStyle('nameDisplayMode'),
          muteMode: _muteDisplayMode.get()
        }),
        name: new NamePanel({
          name: _properties.name,
          mode: this.getStyle('nameDisplayMode')
        }),
        muteButton: new MuteButton({
          muted: _audioVolume === 0,
          mode: _muteDisplayMode.get()
        })
      };
      if (_audioLevelCapable) {
        const audioLevelTransformer = new AudioLevelTransformer();
        _audioLevelMeter = new AudioLevelMeter({
          mode: _subscriber.getStyle('audioLevelDisplayMode')
        });
        const updateAudioLevel = new _RafRunner.default(() => {
          _audioLevelMeter.setValue(audioLevelTransformer.transform(this.loudness));
        });
        _audioLevelMeter.watchVisibilityChanged(visible => {
          if (visible) {
            updateAudioLevel.start();
          } else {
            updateAudioLevel.stop();
          }
        });
        _audioLevelMeter.setDisplayMode(this.getStyle('audioLevelDisplayMode'));
        _audioLevelMeter.audioOnly(false);
        widgets.audioLevel = _audioLevelMeter;
      }
      widgets.videoDisabledIndicator = new VideoDisabledIndicator({
        mode: this.getStyle('videoDisabledDisplayMode')
      });
      widgets.audioBlockedIndicator = new AudioBlockedIndicator({
        mode: this.getStyle('audioBlockedDisplayMode')
      });
      widgets.videoUnsupportedIndicator = new VideoUnsupportedIndicator({
        mode: this.getStyle('videoUnsupportedDisplayMode')
      });
      if (_widgetView && _widgetView.domElement) {
        _chrome = new Chrome({
          parent: _widgetView.domElement
        }).set(widgets).on({
          muted() {
            _subscriber.setAudioVolume(0);
          },
          unmuted() {
            _subscriber.setAudioVolume(_latestPositiveVolume);
          }
        }, this);
        // Hide the chrome until we explicitly show it
        _chrome.hideWhileLoading();
      }
    };
    const _showError = (code, message) => {
      let errorMessage;
      let helpMessage;

      // Display the error message inside the container, assuming it's
      // been created by now.
      if (_widgetView) {
        if (code === ExceptionCodes.STREAM_LIMIT_EXCEEDED) {
          errorMessage = 'The stream was unable to connect.';
          helpMessage = 'The limit for the number of media streams has been reached.';
        } else if (message === 'Tried to subscribe to an encrypted stream without enabling encryption') {
          errorMessage = 'Unable to subscribe to an encrypted stream without enabling encryption.';
          helpMessage = '';
        } else {
          errorMessage = 'The stream was unable to connect due to a network error.';
          if (_hasLoadedAtLeastOnce) {
            helpMessage = 'Ensure you have a stable connection and try again.';
          } else {
            helpMessage = 'Make sure you have a stable network connection and that it isn\'t ' + 'blocked by a firewall.';
          }
        }
        _widgetView.addError(errorMessage, helpMessage);
      }
    };
    StylableComponent(this, {
      nameDisplayMode: 'auto',
      buttonDisplayMode: 'auto',
      audioLevelDisplayMode: 'auto',
      videoDisabledDisplayMode: 'auto',
      audioBlockedDisplayMode: 'auto',
      backgroundImageURI: null,
      showArchiveStatus: true,
      showMicButton: true
    }, _properties.showControls, payload => {
      logAnalyticsEvent('SetStyle', 'Subscriber', payload, null, 0.1);
    });
    function setAudioOnly(audioOnly) {
      getAllPeerConnections().forEach( /*#__PURE__*/function () {
        var _ref24 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(peerConnection) {
          return _regenerator.default.wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return peerConnection;
              case 2:
                _context14.sent.subscribeToVideo(!audioOnly);
              case 3:
              case "end":
                return _context14.stop();
            }
          }, _callee14);
        }));
        return function (_x15) {
          return _ref24.apply(this, arguments);
        };
      }());

      // Default to audioFallback if no mediaStream or no video tracks.
      const audioFallback = audioOnly || !_webRTCStream || !_webRTCStream.getVideoTracks().length;
      if (_widgetView) {
        _widgetView.audioOnly(audioFallback);
        _widgetView.showPoster(audioFallback);
      }
      if (_audioLevelMeter) {
        _audioLevelMeter.audioOnly(audioFallback);
      }
    }

    // logs an analytics event for getStats on the first call
    const notifyGetStatsCalled = (0, _once.default)(() => {
      logAnalyticsEvent('GetStats', 'Called');
    });
    const notifyGetRtcStatsReportCalled = (0, _once.default)(() => {
      logAnalyticsEvent('GetRtcStatsReport', 'Called');
    });
    const createAudioLevelSampler = /*#__PURE__*/function () {
      var _ref25 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(peerConnection) {
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (_audioLevelBehaviour) {
                _audioLevelBehaviour.destroy();
                _audioLevelBehaviour = undefined;
              }
              _context15.prev = 1;
              _context15.next = 4;
              return waitUntil(() => peerConnection._hasAudioTracks());
            case 4:
              _context15.next = 9;
              break;
            case 6:
              _context15.prev = 6;
              _context15.t0 = _context15["catch"](1);
              return _context15.abrupt("return");
            case 9:
              // prefer the audioLevelSampler (more efficient and better responsiveness)
              _audioLevelSampler = audioLevelSamplerFactory(peerConnection);
              if (_audioLevelSampler) {
                _audioLevelBehaviour = (0, _audioLevelBehaviour2.default)({
                  subscriber: _this,
                  audioLevelSampler: _audioLevelSampler
                });
              } else if (!Object.prototype.hasOwnProperty.call(_this, 'loudness')) {
                Object.defineProperty(_this, 'loudness', {
                  value: undefined,
                  configurable: true,
                  writable: false
                });
                logging.error('No suitable audio level samplers found, audio level visualisation will not work');
              }
            case 11:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[1, 6]]);
      }));
      return function createAudioLevelSampler(_x16) {
        return _ref25.apply(this, arguments);
      };
    }();
    const setPeerConnectionEvents = (peerConnection, sourceStreamId) => {
      if (_peerConnectionEvents[sourceStreamId]) {
        _peerConnectionEvents[sourceStreamId].removeAll();
        const onDisconnected = () => {
          peerConnection.off('error', onDisconnected);
          peerConnection.off('disconnected', onDisconnected);
        };
        peerConnection.on('error', onDisconnected);
        peerConnection.on('disconnected', onDisconnected);
      }
      const peerConnectionEvents = (0, _eventHelper.default)(peerConnection);
      peerConnectionEvents.once('connected', () => onPeerConnected(peerConnection));
      peerConnectionEvents.on('disconnected', onPeerDisconnected);
      peerConnectionEvents.on('error', onPeerConnectionFailure);
      peerConnectionEvents.once('remoteTrackAdded', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16() {
        var _args16 = arguments;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return createAudioLevelSampler(peerConnection);
            case 2:
              _context16.prev = 2;
              _context16.next = 5;
              return onTrackAdded(..._args16);
            case 5:
              _context16.next = 10;
              break;
            case 7:
              _context16.prev = 7;
              _context16.t0 = _context16["catch"](2);
              logging.error(_context16.t0);
            case 10:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[2, 7]]);
      })));
      peerConnectionEvents.on('audioLevelStuckWarning', onAudioLevelStuckWarning);
      peerConnectionEvents.on('signalingStateStable', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17() {
        var video;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _subscriber.trigger('signalingStateStable');
              video = _widgetView && _widgetView.video();
              if (video && _webRTCStream) {
                if (_audioLevelSampler && 'webRTCStream' in _audioLevelSampler && peerConnection._hasAudioTracks()) {
                  _audioLevelSampler.webRTCStream(_webRTCStream);
                }
              }
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })));
      peerConnectionEvents.on('iceConnectionStateChange', state => onIceConnectionStateChange(state, peerConnection));
      peerConnectionEvents.on('iceRestartSuccess', onIceRestartSuccess);
      peerConnectionEvents.on('iceRestartFailure', onIceRestartFailure);
      peerConnectionEvents.on('remoteVideoSupported', onRemoteVideoSupported);
      peerConnectionEvents.on('decryptFailed', () => {
        this.trigger('encryptionSecretMismatch');
        logAnalyticsEvent('encryptionSecretMismatch', 'Event');
        logging.warn('Media cannot be decrypted due to an encryption secret mismatch.');
      });
      peerConnectionEvents.on('decryptRestored', () => {
        this.trigger('encryptionSecretMatch');
        logAnalyticsEvent('encryptionSecretMatch', 'Event');
      });
      _peerConnectionEvents[sourceStreamId] = peerConnectionEvents;
    };
    const _transitionRoutedToRelayed = /*#__PURE__*/function () {
      var _ref28 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18() {
        var mantisPeerConnection;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              logRoutedToRelayedTransition('Attempt');
              _context18.next = 3;
              return getPeerConnectionBySourceStreamId('MANTIS');
            case 3:
              mantisPeerConnection = _context18.sent;
              if (mantisPeerConnection != null && mantisPeerConnection.iceConnectionStateIsConnected()) {
                _context18.next = 7;
                break;
              }
              // This is for avoiding corner cases, e.g. two subscribers that join concurrently.
              // The first one will connect first to MANTIS and then receive a stream created
              // signal from RUMOR for the new P2P stream, so it will transition to Relayed.
              // The second one - that joined a few ms later - will also receive the stream created signal
              // from RUMOR, but is not connected to MANTIS yet, so this second one shouldn't attempt
              // to transition to Relayed, because 1) this means there's another subscriber that did
              // the transition, and 2) our model is MANTIS first, so we shouldn't transition to
              // Relayed in this case.
              logRoutedToRelayedTransition('Failure', {
                reason: 'Attempted to transition to Relayed without being connected in Routed mode.'
              });
              return _context18.abrupt("return");
            case 7:
              socket.subscriberCreate(_stream.id, _widgetId,
              // subscriberId
              channelsToSubscribeTo, 'P2P', _session._.isE2ee(), (err, message) => {
                if (err && !connectivityState.is('disconnected')) {
                  logRoutedToRelayedTransition('Failure', err);
                }
                logging.debug('message received when created a subscriber with source', message);
              });
            case 8:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      return function _transitionRoutedToRelayed() {
        return _ref28.apply(this, arguments);
      };
    }();
    const _transitionRelayedToRouted = /*#__PURE__*/function () {
      var _ref29 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19() {
        var peerConnection;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(_properties.testNetwork || isLocalStream(_stream, _session) || _activeSourceStreamId !== 'P2P')) {
                _context19.next = 2;
                break;
              }
              return _context19.abrupt("return");
            case 2:
              logRelayedToRoutedTransition('Attempt');
              _webRTCStream = webRTCStreams.MANTIS;
              if (!(_videoEnabled && _videoMediaProcessorConnector)) {
                _context19.next = 7;
                break;
              }
              _context19.next = 7;
              return _setVideoMediaProcessorConnector();
            case 7:
              if (!(_audioConnector.audioMediaProcessorConnector && _isSubscribingToAudio)) {
                _context19.next = 17;
                break;
              }
              _context19.prev = 8;
              _context19.next = 11;
              return _audioConnector.applyAudioConnectorOnRelayedToRoutedTransition();
            case 11:
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Success', {
                message: 'Audio connector applied on relayed to routed transition.'
              });
              _context19.next = 17;
              break;
            case 14:
              _context19.prev = 14;
              _context19.t0 = _context19["catch"](8);
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
                message: _context19.t0.message
              });
            case 17:
              _context19.next = 19;
              return bindWebRTCStream(_webRTCStream);
            case 19:
              _context19.next = 21;
              return removePeerConnectionBySourceStreamId('P2P');
            case 21:
              // Keep the loading spinner hidden so that the transition looks transparent.
              _widgetView.loading(false);
              _activeSourceStreamId = 'MANTIS';

              // remove webRTCStream
              removeWebRTCStream('P2P');
              _context19.next = 26;
              return getCurrentPeerConnection();
            case 26:
              peerConnection = _context19.sent;
              _context19.next = 29;
              return createAudioLevelSampler(peerConnection);
            case 29:
              _audioLevelSampler.webRTCStream(_webRTCStream);
              logRelayedToRoutedTransition('Success');
            case 31:
            case "end":
              return _context19.stop();
          }
        }, _callee19, null, [[8, 14]]);
      }));
      return function _transitionRelayedToRouted() {
        return _ref29.apply(this, arguments);
      };
    }();
    this._destroy = _ref30 => {
      var _session10, _session11, _session11$connection, _session$sessionInfo$2, _session12, _session12$sessionInf;
      let _ref30$reason = _ref30.reason,
        reason = _ref30$reason === void 0 ? 'Unknown' : _ref30$reason,
        quiet = _ref30.quiet,
        _ref30$noStateTransit = _ref30.noStateTransition,
        noStateTransition = _ref30$noStateTransit === void 0 ? false : _ref30$noStateTransit;
      if (_state.isDestroyed()) {
        return this;
      }
      _state.set('Destroyed');
      if (_frameRateWatcher) {
        _frameRateWatcher.destroy();
        _frameRateWatcher = null;
      }
      _preDisconnectStats = {
        sessionId: _session.sessionId,
        connectionId: (_session10 = _session) != null && _session10.isConnected() ? (_session11 = _session) == null ? void 0 : (_session11$connection = _session11.connection) == null ? void 0 : _session11$connection.connectionId : null,
        partnerId: (_session$sessionInfo$2 = (_session12 = _session) == null ? void 0 : (_session12$sessionInf = _session12.sessionInfo) == null ? void 0 : _session12$sessionInf.partnerId) != null ? _session$sessionInfo$2 : null,
        streamId: _stream && !_stream.destroyed ? _stream.id : null
      };
      this._disconnect({
        reason,
        noStateTransition
      });
      if (_chrome) {
        _chrome.destroy();
        _chrome = null;
      }
      _session.off('captionReceived', onCaptionReceived);
      if (_widgetView) {
        _widgetView.destroy();
        _widgetView.off();
        _widgetView = null;
        this.element = null;
      }
      if (_stream && !_stream.destroyed) {
        logAnalyticsEvent('unsubscribe', null, {
          streamId: _stream.id
        });
      }
      _stream.off(_streamEventHandlers, this);
      this.id = null;
      _domId = null;
      this.stream = null;
      _stream = null;
      this.streamId = null;
      this.session = null;
      _session = null;
      _properties = null;
      if (quiet !== true) {
        this.dispatchEvent(new Events.DestroyedEvent(_eventNames.default.SUBSCRIBER_DESTROYED, this, reason));
        this.off();
      }
      return this;
    };
    this.destroy = function (reason, quiet) {
      if (reason === void 0) {
        reason = 'Unsubscribe';
      }
      logging.warn('Subscriber#destroy is deprecated and will be removed. Please use Session#unsubscribe instead');
      _this._destroy({
        reason,
        quiet
      });
    };
    this._disconnect = function (_temp3) {
      let _ref31 = _temp3 === void 0 ? {} : _temp3,
        _ref31$reason = _ref31.reason,
        reason = _ref31$reason === void 0 ? 'Unknown' : _ref31$reason,
        noStateTransition = _ref31.noStateTransition;
      // known reasons:
      // forceUnpublished (publisher stream was destroyed by forceUnpublish)
      // clientDisconnected (publisher unpublished)
      // Unsubscribe (when calling session.unsubscribe)
      // Unknown (when reason is not determined)

      if (!noStateTransition && !connectivityState.is('disconnected')) {
        const error = reason === 'Unsubscribe' ? undefined : otError(errors.STREAM_DESTROYED, new Error('Stream was destroyed before it could be subscribed to'));
        connectivityState.disconnect({
          payload: {
            reason
          },
          error
        });
      }
      if (!_state.isDestroyed() && !_state.isFailed()) {
        // If we are already in the destroyed state then disconnect
        // has been called after (or from within) destroy.
        _state.set('NotSubscribing');
      }
      if (_widgetView) {
        _widgetView.destroyVideo();
      }

      // Unsubscribe us from the stream, if it hasn't already been destroyed
      if (socket.is('connected') && _stream && !_stream.destroyed) {
        // Notify the server components
        // @todo I assume we don't want to send this message, but is there anything
        // we need to do in p2p->mantis for when a peer conn is destroyed?
        socket.subscriberDestroy(_stream.id, _this.widgetId);
      }
      removeAllPeerConnections();
    };
    this.disconnect = () => {
      logging.warn('Subscriber#disconnect is deprecated and will be removed. Please use Session#unsubscribe instead');
      this._disconnect({
        reason: 'Unsubscribe'
      });
    };
    const processOffer = /*#__PURE__*/function () {
      var _ref33 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(_ref32) {
        var peerId, fromConnectionId, sourceStreamId, uri, send, log, logQoS;
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              peerId = _ref32.peerId, fromConnectionId = _ref32.fromConnectionId, sourceStreamId = _ref32.sourceStreamId;
              uri = constructSubscriberUri({
                apiKey: _session.apiKey,
                sessionId: _session.sessionId,
                streamId: _stream.id,
                subscriberId: _this.widgetId
              });
              send = createSendMethod({
                socket: _this.session._.getSocket(),
                uri,
                content: {
                  peerId,
                  sourceStreamId
                }
              });
              log = function log(action, variation, payload, options, throttle) {
                if (options === void 0) {
                  options = {};
                }
                const transformedOptions = Object.assign({
                  peerId,
                  sourceStreamId: (0, _getMediaModeBySourceStreamId.default)(sourceStreamId)
                }, options);
                return logAnalyticsEvent(action, variation, payload, transformedOptions, throttle);
              };
              logQoS = qos => {
                // We only log data from the active peer connection
                if (_activeSourceStreamId !== sourceStreamId) {
                  return;
                }
                recordQOS(Object.assign({}, qos, {
                  peerId,
                  remoteConnectionId: fromConnectionId,
                  sourceStreamId
                }));
              };
              return _context20.abrupt("return", _this._setupPeerConnection({
                send,
                log,
                logQoS,
                sourceStreamId
              }));
            case 6:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function processOffer(_x17) {
        return _ref33.apply(this, arguments);
      };
    }();

    // When migrating, a P2P transition is performed as a renegotiation, since we already have a PC
    // we don't need to create a new one, just accept the new offer.
    const isRoutedToRelayedTransitionDuringMigration = (type, sourceStreamId) => _isAdaptiveEnabled && sourceStreamId === 'P2P' && type === 'offer' && _state.isMigrating();
    this.processMessage = /*#__PURE__*/function () {
      var _ref34 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(type, fromConnectionId, message) {
        var peerId, sourceStreamId, peerConnection, relayedStream;
        return _regenerator.default.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              logging.debug(`OT.Subscriber.processMessage: Received ${type} message from ${fromConnectionId}`);
              logging.debug(message);
              peerId = (0, _get.default)(message, 'content.peerId');
              sourceStreamId = (0, _get.default)(message, 'content.sourceStreamId');
              _context21.next = 6;
              return getPeerConnectionBySourceStreamId(sourceStreamId);
            case 6:
              peerConnection = _context21.sent;
              if (!(type === 'offer' && (!peerConnection || _state.isMigrating() && sourceStreamId === 'MANTIS'))) {
                _context21.next = 14;
                break;
              }
              _context21.next = 10;
              return processOffer({
                peerId,
                fromConnectionId,
                sourceStreamId
              });
            case 10:
              peerConnection = _context21.sent;
              if (_shouldUseSpc && sourceStreamId === 'MANTIS') {
                _session._singlePeerConnectionController.addSubscriber(() => {
                  peerConnection.processMessage('offer', message);
                });
              } else {
                // Pace subscriber creation when MPC.
                _this.session._.addSubscriberToPeerConnectionsQueue(peerConnection, message);
              }
              _context21.next = 15;
              break;
            case 14:
              if (peerConnection) {
                peerConnection.processMessage(type, message);
                if (isRoutedToRelayedTransitionDuringMigration(type, sourceStreamId)) {
                  relayedStream = {
                    webRTCStream: webRTCStreams.P2P,
                    peerConnection
                  };
                  onRemoteStreamAdded.push(relayedStream);
                  _activeSourceStreamId = 'P2P';
                  logRoutedToRelayedTransition('Success');
                }
              }
            case 15:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      return function (_x18, _x19, _x20) {
        return _ref34.apply(this, arguments);
      };
    }();
    this.disableVideo = active => {
      if (!active) {
        logging.warn('Due to high packet loss and low bandwidth, video has been disabled');
      } else if (_lastSubscribeToVideoReason === 'auto' && _isVideoManuallyMuted === false) {
        logging.info('Video has been re-enabled');
      } else {
        logging.info('Video was not re-enabled because it was manually disabled');
        if (_chrome && _chrome.videoDisabledIndicator) {
          // We won't enable the video, but clear any disabled video icons we have enabled
          _chrome.videoDisabledIndicator.disableVideo(false);
        }
        return;
      }
      this.subscribeToVideo(active, 'auto');
      const payload = active ? {
        videoEnabled: true
      } : {
        videoDisabled: true
      };
      logAnalyticsEvent('updateQuality', 'video', payload);
    };

    /**
     * Returns the base-64-encoded string of PNG data representing the Subscriber video.
     *
     *  <p>You can use the string as the value for a data URL scheme passed to the src parameter of
     *  an image file, as in the following:</p>
     *
     *  <pre>
     *  var imgData = subscriber.getImgData();
     *
     *  var img = document.createElement("img");
     *  img.setAttribute("src", "data:image/png;base64," + imgData);
     *  var imgWin = window.open("about:blank", "Screenshot");
     *  imgWin.document.write("&lt;body&gt;&lt;/body&gt;");
     *  imgWin.document.body.appendChild(img);
     *  </pre>
     * @method #getImgData
     * @memberOf Subscriber
     * @return {String} The base-64 encoded string. Returns an empty string if there is no video.
     */
    this.getImgData = () => {
      if (!this.isSubscribing()) {
        logging.error('OT.Subscriber.getImgData: Cannot getImgData before the Subscriber ' + 'is subscribing.');
        return null;
      }
      const video = _widgetView && _widgetView.video();
      return video ? video.imgData() : null;
    };

    /**
    *  Returns the details on the subscriber stream quality, including the following:
    *
    * <ul>
    *
    *   <li>Total audio and video packets lost</li>
    *   <li>Total audio and video packets received</li>
    *   <li>Total audio and video bytes received</li>
    *   <li>Current average video frame rate</li>
    *
    * </ul>
    *
    * You can publish a test stream, subscribe to it (on the publishing client), and use this method
    * to check its quality. Based on the stream's quality, you can determine what video resolution is
    * supported and whether conditions support video or audio. You can then publish an appropriate
    * stream, based on the results. When using this method to test a stream published by your
    * own client, set the <code>testNetwork</code> property to <code>true</code> in the options you
    * pass into the <a href="Session.html#subscribe">Session.subscribe()</a> method. For an example,
    * see the <a href="https://github.com/opentok/opentok-network-test">opentok-network-test</a>
    * project on GitHub.
    * <p>
    * You may also use these statistics to have a Subscriber subscribe to audio-only if the audio
    * packet loss reaches a certain threshold. If you choose to do this, you should set the
    * <code>audioFallbackEnabled</code> setting to <code>false</code> when you initialize Publisher
    * objects for the session. This prevents the Vonage Video API Media Router from using its own audio-only
    * toggling implementation. (See the documentation for the
    * <a href="OT.html#initPublisher">OT.initPublisher()</a> method.) Note that <code>audioFallbackEnabled</code>
    * will be deprecated in the future. Please instead set the <code>subscriber</code> property of the
    * <code>audioFallback</code> object to <code>false</code>.
    *
    * @param {Function} completionHandler A function that takes the following
    * parameters:
    *
    * <ul>
    *
    *   <li><code>error</code> (<a href="Error.html">Error</a>) &mdash; The error property is
    *   set if the client is not connected. Upon completion of a successful call to the method,
    *   this property is undefined.</li>
    *
    *   <li><code>stats</code> (Object) &mdash; An object with the following properties:
    *     <p>
    *     <ul>
    *       <li><code>audio.bytesReceived</code> (Number) &mdash; The total number of audio bytes
    *         received by the subscriber</li>
    *       <li><code>audio.packetsLost</code> (Number) &mdash; Total audio packets that did not reach
    *         the subscriber</li>
    *       <li><code>audio.packetsReceived</code> (Number) &mdash; The total number of audio packets
    *         received by the subscriber</li>
    *       <li><code>timestamp</code> (Number) &mdash; The timestamp, in milliseconds since the Unix
    *         epoch, for when these stats were gathered</li>
    *       <li><code>video.bytesReceived</code> (Number) &mdash; The total video bytes received by
    *         the subscriber</li>
    *       <li><code>video.packetsLost</code> (Number) &mdash; The total number of video packets that
    *         did not reach the subscriber</li>
    *       <li><code>video.packetsReceived</code> (Number) &mdash; The total number of video packets
    *         received by the subscriber</li>
    *       <li><code>video.frameRate</code> (Number) &mdash; The current average video frame rate</li>
    *     </ul>
    *   </li>
    * </ul>
    *
    * @see <a href="Publisher.html#getStats">Publisher.getStats()</a>
    * @see <a href="#getRtcStatsReport">Publisher.getRtcStatsReport()</a>
    *
    * @method #getStats
    * @memberOf Subscriber
    */
    this.getStats = callback => {
      _getStats((error, stats) => {
        if (error) {
          callback(error);
          return;
        }
        const otStats = {
          timestamp: 0
        };
        stats.forEach(stat => {
          if (getStatsHelpers.isInboundStat(stat)) {
            const video = getStatsHelpers.isVideoStat(stat, stats);
            const audio = getStatsHelpers.isAudioStat(stat, stats);

            // it is safe to override the timestamp of one by another
            // if they are from the same getStats "batch" video and audio ts have the same value
            if (audio || video) {
              otStats.timestamp = getStatsHelpers.normalizeTimestamp(stat.timestamp);
            }
            if (video) {
              (0, _merge.default)(otStats, {
                video: getStatsHelpers.parseStatCategory(stat)
              });
              if (_frameRateWatcher) {
                (0, _merge.default)(otStats, {
                  video: {
                    frameRate: _frameRateWatcher.getFrameRateFromStat(stat)
                  }
                });
              }
            } else if (audio) {
              (0, _merge.default)(otStats, {
                audio: getStatsHelpers.parseStatCategory(stat)
              });
            }
          }
        });
        if (_senderStats) {
          const _senderStats2 = _senderStats,
            maxBitrateBitsPerSecond = _senderStats2.maxBitrateBitsPerSecond,
            sentEstimatedBandwidthBitsPerSecond = _senderStats2.sentEstimatedBandwidthBitsPerSecond;
          otStats.senderStats = {
            senderMaxBitrate: maxBitrateBitsPerSecond,
            senderCurrentBitrate: sentEstimatedBandwidthBitsPerSecond
          };
        }
        callback(null, otStats);
      });
    };

    /**
    * Returns a promise that, on success, resolves with an RtcStatsReport object
    * for the subscribed stream. (See
    * <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport" target="_blank">
    * RTCStatsReport</a>.)
    * <p>
    * The Promise will be rejected in the following conditions:
    * <ul>
    *   <li>
    *     The browser does not support this method (for example, in Chrome version 57 and lower,
    *     which does not support the <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats" target="_blank">
    *     RTCPeerConnection.getStats()</a> standard).
    *   </li>
    *   <li>
    *     The <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection" target="_blank">
    *     PeerConnection</a> for the Subscriber is not connected.
    *   </li>
    *  </ul>
    * </p>
    *
    * @method #getRtcStatsReport
    * @memberOf Subscriber
    *
    * @see <a href="Publisher.html#getRtcStatsReport">Publisher.getRtcStatsReport()</a>
    *
    * @return {Promise} A promise that resolves when the operation completes successfully.
    * If there is an error, the promise is rejected.
    */
    this.getRtcStatsReport = () => new Promise((resolve, reject) => {
      _getRtcStatsReport((error, rtcStatsReport) => {
        if (error) {
          reject(error);
        } else {
          resolve(rtcStatsReport);
        }
      });
    });
    function setAudioVolume(audioVolume) {
      const video = _widgetView && _widgetView.video();
      if (video) {
        try {
          video.setAudioVolume(audioVolume);
        } catch (e) {
          logging.warn(`setAudioVolume: ${e}`);
          if (_audioVolume === 0) {
            logging.info('Using subscribeToAudio to mute Audio because setAudioVolume(0) failed');
            // If we can't set the audioVolume to 0 then at least mute by setting subscribeToAudio(false)
            _subscriber.subscribeToAudio(false);
          }
        }
      }
      if (_chrome) {
        _chrome.muteButton.muted(audioVolume === 0);
      }
    }

    /**
     * Sets the audio volume, between 0 and 100, of the Subscriber.
     *
     * <p>You can set the initial volume when you call the <code>Session.subscribe()</code>
     * method. Pass a <code>audioVolume</code> property of the <code>properties</code> parameter
     * of the method.</p>
     *
     * @param {Number} value The audio volume, between 0 and 100.
     *
     * @return {Subscriber} The Subscriber object. This lets you chain method calls, as in the
     * following:
     *
     * <pre>mySubscriber.setAudioVolume(50).setStyle(newStyle);</pre>
     *
     * @see <a href="#getAudioVolume">getAudioVolume()</a>
     * @see <a href="Session.html#subscribe">Session.subscribe()</a>
     * @method #setAudioVolume
     * @memberOf Subscriber
     */

    this.setAudioVolume = requestedVolume => {
      const volume = normalizeAudioVolume(requestedVolume);
      logAnalyticsEvent('setAudioVolume', 'Attempt', {
        audioVolume: volume
      });
      if (isNaN(volume)) {
        logging.error('OT.Subscriber.setAudioVolume: value should be an integer between 0 and 100');
        logAnalyticsEvent('setAudioVolume', 'Failure', {
          message: 'value should be an integer between 0 and 100'
        });
        return this;
      }
      if (volume !== requestedVolume) {
        logging.warn('OT.Subscriber.setAudioVolume: value should be an integer between 0 and 100');
      }
      if (volume === _audioVolume) {
        setAudioVolume(_audioVolume);
        logAnalyticsEvent('setAudioVolume', 'Success', {
          audioVolume: _audioVolume,
          message: 'Requested volume is same as already set audioVolume'
        });
        return this;
      }
      if (_audioVolume > 0) {
        _latestPositiveVolume = _audioVolume;
      }
      _audioVolume = volume;
      setAudioVolume(_audioVolume);
      if (_audioVolume > 0 && !_isSubscribingToAudio) {
        // in Firefox (and others) we don't stop subscribing to audio when muted, however if we are 'unmuting' and in
        // the subscribeToAudio: false state we should subscribe to audio again

        // subscribeToAudio is going to call us with _latestPositiveVolume so we'll update it here
        _latestPositiveVolume = _audioVolume;
        this.subscribeToAudio(true);
      }
      logAnalyticsEvent('setAudioVolume', 'Success', {
        audioVolume: _audioVolume
      });
      return this;
    };

    /**
    * Returns the audio volume, between 0 and 100, of the Subscriber.
    *
    * <p>Generally you use this method in conjunction with the <code>setAudioVolume()</code>
    * method.</p>
    *
    * @return {Number} The audio volume, between 0 and 100, of the Subscriber.
    * @see <a href="#setAudioVolume">setAudioVolume()</a>
    * @method #getAudioVolume
    * @memberOf Subscriber
    */
    this.getAudioVolume = () => {
      const video = _widgetView && _widgetView.video();
      if (video) {
        try {
          return video.getAudioVolume();
        } catch (e) {
          logging.warn(`getAudioVolume ${e}`);
        }
      }
      return _audioVolume;
    };

    /**
    * Toggles audio on and off. Starts subscribing to audio (if it is available and currently
    * not being subscribed to) when the <code>value</code> is <code>true</code>; stops
    * subscribing to audio (if it is currently being subscribed to) when the <code>value</code>
    * is <code>false</code>.
    * <p>
    * <i>Note:</i> This method only affects the local playback of audio. It has no impact on the
    * audio for other connections subscribing to the same stream. If the Publisher is not
    * publishing audio, enabling the Subscriber audio will have no practical effect.
    * </p>
    *
    * @param {Boolean} value Whether to start subscribing to audio (<code>true</code>) or not
    * (<code>false</code>).
    *
    * @return {Subscriber} The Subscriber object. This lets you chain method calls, as in the
    * following:
    *
    * <pre>mySubscriber.subscribeToAudio(true).subscribeToVideo(false);</pre>
    *
    * @see <a href="#subscribeToVideo">subscribeToVideo()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    * @see <a href="StreamPropertyChangedEvent.html">StreamPropertyChangedEvent</a>
    *
    * @method #subscribeToAudio
    * @memberOf Subscriber
    */
    this.subscribeToAudio = pValue => {
      const value = (0, _castToBoolean.default)(pValue, true);
      getAllPeerConnections().forEach( /*#__PURE__*/function () {
        var _ref35 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(peerConnection) {
          return _regenerator.default.wrap(function _callee22$(_context22) {
            while (1) switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return peerConnection;
              case 2:
                _context22.sent.subscribeToAudio(value);
              case 3:
              case "end":
                return _context22.stop();
            }
          }, _callee22);
        }));
        return function (_x21) {
          return _ref35.apply(this, arguments);
        };
      }());
      if (_stream && getAllPeerConnections().length !== 0) {
        setChannelActiveStateForSubscriber({
          channelType: 'audio',
          activeState: value
        });
      }
      const changed = _isSubscribingToAudio !== value;
      _isSubscribingToAudio = value;
      if (changed) {
        this.setAudioVolume(value ? _latestPositiveVolume : 0);
      }
      if (_audioConnector.audioMediaProcessorConnector) {
        if (_isSubscribingToAudio) {
          _setAudioMediaProcessorConnector();
        } else {
          try {
            _audioConnector.resetAudioStreamAndTrack(_activeSourceStreamId);
            logAnalyticsEvent('setAudioMediaProcessorConnector', 'Success', {
              message: 'reset the audio track'
            });
          } catch (error) {
            logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
              message: `Error resetting track: ${error.message}`
            });
          }
        }
      }
      logAnalyticsEvent('subscribeToAudio', 'Event', {
        subscribeToAudio: value
      });
      return this;
    };
    const reasonMap = {
      auto: 'quality',
      publishVideo: 'publishVideo',
      subscribeToVideo: 'subscribeToVideo'
    };
    if (env.name === 'Safari') {
      const onVisibilityChange = () => {
        if (!document.hidden && _properties.subscribeToVideo) {
          logging.debug('document visibility restored in Safari - resubscribing to video');
          this.subscribeToVideo(false);
          this.subscribeToVideo(true);
        }
      };
      document.addEventListener('visibilitychange', onVisibilityChange);
      this.once('destroyed', () => {
        document.removeEventListener('visibilitychange', onVisibilityChange);
      });
    }

    /**
    * Toggles video on and off. Starts subscribing to video (if it is available and
    * currently not being subscribed to) when the <code>value</code> is <code>true</code>;
    * stops subscribing to video (if it is currently being subscribed to) when the
    * <code>value</code> is <code>false</code>.
    * <p>
    * <i>Note:</i> This method only affects the local playback of video. It has no impact on
    * the video for other connections subscribing to the same stream. If the Publisher is not
    * publishing video, enabling the Subscriber video will have no practical effect.
    * </p>
    *
    * @param {Boolean} value Whether to start subscribing to video (<code>true</code>) or not
    * (<code>false</code>).
    *
    * @return {Subscriber} The Subscriber object. This lets you chain method calls, as in the
    * following:
    *
    * <pre>mySubscriber.subscribeToVideo(true).subscribeToAudio(false);</pre>
    *
    * @see <a href="#subscribeToAudio">subscribeToAudio()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    * @see <a href="StreamPropertyChangedEvent.html">StreamPropertyChangedEvent</a>
    *
    * @method #subscribeToVideo
    * @memberOf Subscriber
    */
    this.subscribeToVideo = (pValue, reason) => {
      const enableVideo = (0, _castToBoolean.default)(pValue, true);
      const isAutoDisableVideo = !enableVideo && reason === 'auto';
      if (!reason) {
        _isVideoManuallyMuted = !enableVideo;
      }
      if (isAutoDisableVideo) {
        _congestionLevel = 2;
      }
      logAnalyticsEvent('subscribeToVideo', 'Attempt', {
        subscribeToVideo: enableVideo,
        reason
      });
      setAudioOnly(!enableVideo || !_stream.hasVideo || !_webRTCStream);
      if (_stream.hasVideo && !_streamHasTracks('video')) {
        if (enableVideo) {
          logging.info('Subscriber is audio-only due to incompatibility, can\'t subscribeToVideo.');
        }
        _properties.subscribeToVideo = false;
        logAnalyticsEvent('subscribeToVideo', 'Failure', {
          message: 'No video tracks available'
        });
        return this;
      }
      if (_chrome && _chrome.videoDisabledIndicator) {
        // If this is an auto disableVideo then we want to show the indicator, otherwise hide it again
        _chrome.videoDisabledIndicator.disableVideo(isAutoDisableVideo);
      }
      if (getAllPeerConnections().length > 0 && _session && _stream) {
        if ((enableVideo !== _properties.subscribeToVideo || reason !== _lastSubscribeToVideoReason) && !(_isVideoManuallyMuted && !!reason)) {
          setChannelActiveStateForSubscriber({
            channelType: 'video',
            activeState: enableVideo,
            activeReason: reason
          });
        }
      }
      _properties.subscribeToVideo = enableVideo;
      _lastSubscribeToVideoReason = reason;
      _videoEnabled = enableVideo;
      if (_videoMediaProcessorConnector) {
        if (_videoEnabled) {
          _setVideoMediaProcessorConnector();
        } else {
          _resetVideoStream();
        }
      }
      logAnalyticsEvent('subscribeToVideo', 'Success', {
        subscribeToVideo: enableVideo,
        reason
      });
      if (reason !== 'loading') {
        this.dispatchEvent(new Events.VideoEnabledChangedEvent(enableVideo ? 'videoEnabled' : 'videoDisabled', {
          reason: reasonMap[reason] || 'subscribeToVideo'
        }));
      }
      return this;
    };

    /**
    * Sets the preferred resolution of the subscriber's video.
    * <p>
    * Lowering the preferred resolution
    * lowers video quality on the subscribing client, but it also reduces network and CPU usage.
    * You may want to use a lower resolution based on the dimensions of subscriber's video on
    * the web page. You may want to use a resolution rate for a subscriber to a stream that is less
    * important (and smaller) than other streams.
    * <p>
    * <p>
    * This method only applies when subscribing to a stream that uses the
    * <a href="https://tokbox.com/developer/guides/scalable-video">
    * scalable video feature</a>. Scalable video is available:
    * <ul>
    *   <li>
    *     Only in sessions that use the Vonage Video API Media Router (sessions with the
    *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media
    *     mode</a> set to routed).
    *   </li>
    *   <li>
    *     Only for streams published by clients that support scalable video:
    *     clients that use the Vonage Video API iOS SDK (on certain devices), the Vonage Video API
    *     Android SDK (on certain devices), or OpenTok.js in Chrome and Safari.
    *   </li>
    * </ul>
    * <p>
    * In streams that do not use scalable video, calling this method has no effect.
    * <p>
    * <b>Note:</b> The resolution for scalable video streams automatically adjusts for each
    * subscriber, based on network conditions and CPU usage, even if you do not call this method.
    * Call this method if you want to set a maximum resolution for this subscriber.
    * <p>
    * In streams that do not use scalable video, calling this method has no effect.
    * <p>
    * Not every frame rate is available to a subscriber. When you set the preferred resolution for
    * the subscriber, OpenTok.js picks the best resolution available that matches your setting.
    * The resolutions available are based on the value of the Subscriber object's
    * <code>stream.resolution</code> property, which represents the maximum resolution available for
    * the stream. The actual resolutions available depend, dynamically, on network and CPU resources
    * available to the publisher and subscriber.
    * <p>
    * You can set the initial preferred resolution used by setting the
    * <code>preferredResolution</code> property of the <code>options</code> object you pass into the
    * <code>Session.subscribe()</code> method.
    * <p>
    * <b>Note:</b> If you set the initial preferred resolution to <code>"auto"</code> when calling
    * <code>Session.subscribe()</code>, calling <code>setPreferredResolution()</code> fails silently,
    * and you will receive a warning.
    *
    * @param {Object} resolution Set this to an object with two properties: <code>width</code> and
    * <code>height</code> (both numbers), such as <code>{width: 320, height: 240}</code>. Set this to
    * <code>null</code> to remove the preferred resolution, and the client will use the highest
    * resolution available.
    *
    * @see <a href="#setPreferredFrameRate">Subscriber.setPreferredFrameRate()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    *
    * @method #setPreferredResolution
    * @memberOf Subscriber
    */
    this.setPreferredResolution = preferredResolution => {
      _logSetPreferredResolutionEvent('Attempt', {
        preferredResolution
      });
      if (_isAutoPreferredResolution) {
        const message = 'Cannot call this method directly if in auto mode.';
        _logSetPreferredResolutionEvent('Failure', {
          preferredResolution,
          message
        });
        logging.warn(message);
        return;
      }
      if (preferredResolution === 'auto') {
        const message = "preferredResolution 'auto' cannot be set using setPreferredResolution(), it must be set in subscriberOptions property preferredResolution.";
        _logSetPreferredResolutionEvent('Failure', {
          preferredResolution,
          message
        });
        logging.warn(message);
        return;
      }
      _setPreferredResolution(preferredResolution);
    };
    const _logSetPreferredResolutionEvent = (variation, payload) => {
      if (!_isAutoPreferredResolution) {
        logAnalyticsEvent('setPreferredResolution', variation, payload);
      }
    };
    const _setPreferredResolution = preferredResolution => {
      this._preferredResolution = preferredResolution;
      if (_state.isDestroyed() || getAllPeerConnections().length === 0 && !_state.current === 'Connecting') {
        const message = 'Cannot set the max Resolution when not subscribing to a publisher';
        _logSetPreferredResolutionEvent('Failure', {
          preferredResolution,
          message
        });
        logging.warn(message);
        return;
      }
      _properties.preferredResolution = preferredResolution;
      if (_session.sessionInfo.p2pEnabled) {
        const message = 'OT.Subscriber.setPreferredResolution will not work in a P2P Session';
        _logSetPreferredResolutionEvent('Failure', {
          preferredResolution,
          message
        });
        logging.warn(message);
        return;
      }

      // We can only setPreferredResolution once the remote stream has been added. Otherwise we will save
      // the preferred resolution, and then it will be requested once the stream has been added.
      if (!_state.isStreamAdded()) {
        _logSetPreferredResolutionEvent('Pending');
        return;
      }
      const curMaxResolution = _stream.getPreferredResolution();
      const isUnchanged = curMaxResolution && preferredResolution && curMaxResolution.width === preferredResolution.width && curMaxResolution.height === preferredResolution.height || !curMaxResolution && !preferredResolution;
      if (isUnchanged) {
        _logSetPreferredResolutionEvent('Cancel');
        return;
      }
      _stream.setPreferredResolution(preferredResolution);
      _logSetPreferredResolutionEvent('Success');
    };
    const _setOptimizedResolution = (0, _debounce.default)(element => {
      if (!element) {
        return;
      }
      const videoElementWidth = element.offsetWidth;
      const videoElementHeight = element.offsetHeight;
      const deviceRatio = window.devicePixelRatio;
      const updatedPreferredResolution = {
        width: videoElementWidth * deviceRatio,
        height: videoElementHeight * deviceRatio
      };
      _setPreferredResolution(updatedPreferredResolution);
    }, RESIZE_DEBOUNCE_WAIT);
    /**
    * Sets the preferred frame rate of the subscriber's video.
    * <p>
    * Lowering the preferred frame rate
    * lowers video quality on the subscribing client, but it also reduces network and CPU usage.
    * You may want to use a lower frame rate for a subscriber to a stream that is less important
    * than other streams.
    * <p>
    * <p>
    * This method only applies when subscribing to a stream that uses the
    * <a href="https://tokbox.com/developer/guides/scalable-video">
    * scalable video feature</a>. Scalable video is available:
    * <ul>
    *   <li>
    *     Only in sessions that use the Vonage Video API Media Router (sessions with the
    *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media
    *     mode</a> set to routed).
    *   </li>
    *   <li>
    *     Only for streams published by clients that support scalable video:
    *     clients that use the Vonage Video API iOS SDK (on certain devices), the Vonage Video API
    *     Android SDK (on certain devices), or OpenTok.js in Chrome and Safari.
    *   </li>
    * </ul>
    * <p>
    * In streams that do not use scalable video, calling this method has no effect.
    * <p>
    * <b>Note:</b> The frame rate for scalable video streams automatically adjusts for each
    * subscriber, based on network conditions and CPU usage, even if you do not call this method.
    * Call this method if you want to set a maximum frame rate for this subscriber.
    * <p>
    * Not every frame rate is available to a subscriber. When you set the preferred frame rate for
    * the subscriber, OpenTok.js picks the best frame rate available that matches your setting.
    * The frame rates available are based on the value of the Subscriber object's
    * <code>stream.frameRate</code> property, which represents the maximum value available for the
    * stream. The actual frame rates available depend, dynamically, on network and CPU resources
    * available to the publisher and subscriber.
    * <p>
    * You can set the initial preferred frame rate used by setting the <code>preferredFrameRate</code>
    * property of the <code>options</code> object you pass into the <code>Session.subscribe()</code>
    * method.
    *
    * @param {Number} frameRate Set this to the desired frame rate (in frames per second). Set this to
    * <code>null</code> to remove the preferred frame rate, and the client will use the highest
    * frame rate available.
    *
    * @see <a href="#setPreferredResolution">Subscriber.setPreferredResolution()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    *
    * @method #setPreferredFrameRate
    * @memberOf Subscriber
    */
    this.setPreferredFrameRate = preferredFrameRate => {
      this._preferredFrameRate = preferredFrameRate;
      if (_state.isDestroyed() || getAllPeerConnections().length === 0 && !_state.current === 'Connecting') {
        logging.warn('Cannot set the max frameRate when not subscribing to a publisher');
        return;
      }
      _properties.preferredFrameRate = preferredFrameRate;
      if (_session.sessionInfo.p2pEnabled) {
        logging.warn('OT.Subscriber.setPreferredFrameRate will not work in a P2P Session');
        return;
      }
      const currentPreferredFrameRate = _stream.getPreferredFrameRate();
      const isUnchangedFrameRate = preferredFrameRate && currentPreferredFrameRate && currentPreferredFrameRate === preferredFrameRate || !currentPreferredFrameRate && !preferredFrameRate;
      if (isUnchangedFrameRate) {
        return;
      }
      _stream.setPreferredFrameRate(preferredFrameRate);
    };
    this.isSubscribing = () => _state.isSubscribing();
    this.isWebRTC = true;
    this.isLoading = () => _widgetView && _widgetView.loading();

    /**
     * Indicates whether the subscriber's audio is blocked because of
     * the browser's audio autoplay policy.
     *
     * @see <a href="OT.html#unblockAudio">OT.unblockAudio()</a>
     * @see The <a href="#event:audioBlocked">audioBlocked</a>
     * and <a href="#event:audioUnblocked">audioUnblocked</a>
     * Subscriber events
     * @see The <code>style.audioBlockedDisplayMode</code> property of the
     * <code>options</code> parameter of the
     * <a href="Session.html#subscribe">Session.subscribe()</a> method
     *
     * @method #isAudioBlocked
     * @memberof Subscriber
     */
    this.isAudioBlocked = () => Boolean(_widgetView && _widgetView.isAudioBlocked());
    this.videoElement = () => {
      const video = _widgetView && _widgetView.video();
      return video ? video.domElement() : null;
    };

    /**
    * Returns the width, in pixels, of the Subscriber video.
    *
    * @method #videoWidth
    * @memberOf Subscriber
    * @return {Number} the width, in pixels, of the Subscriber video.
    */
    this.videoWidth = () => {
      const video = _widgetView && _widgetView.video();
      return video ? video.videoWidth() : undefined;
    };

    /**
    * Returns the height, in pixels, of the Subscriber video.
    *
    * @method #videoHeight
    * @memberOf Subscriber
    * @return {Number} the width, in pixels, of the Subscriber video.
    */
    this.videoHeight = () => {
      const video = _widgetView && _widgetView.video();
      return video ? video.videoHeight() : undefined;
    };
    this._subscribeToSelf = () => {
      const publisher = _session.getPublisherForStream(_stream);
      if (!(publisher && publisher._.webRtcStream())) {
        connectivityState.fail({
          payload: {
            reason: 'streamNotFound'
          },
          error: otError(errors.STREAM_DESTROYED, new Error('Tried to subscribe to a local publisher, but its stream no longer exists'))
        });
      } else {
        _pcConnected.resolve();
        onRemoteStreamAdded.push({
          webRTCStream: publisher._.webRtcStream()
        });
      }
    };
    this._setupPeerConnection = /*#__PURE__*/function () {
      var _ref37 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(_ref36) {
        var send, log, logQoS, sourceStreamId;
        return _regenerator.default.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              send = _ref36.send, log = _ref36.log, logQoS = _ref36.logQoS, sourceStreamId = _ref36.sourceStreamId;
              if (_properties.testNetwork) {
                _this.setAudioVolume(0);
              }
              if (getAllPeerConnections().length === 0) {
                // @todo The subscribers states should be something like:
                // disconnected || connecting || reconnecting || connected || destroyed
                // the state of peer connections belong to the peer connection itself
                _state.set('Connecting');
              }
              _activeSourceStreamId = sourceStreamId;
              peerConnectionsAsync[sourceStreamId] = new Promise((resolve, reject) => {
                _session._.getIceConfig().then(iceConfig => {
                  var _session13;
                  if (iceConfig.needRumorIceServersFallback) {
                    iceConfig.servers = [...(fallbackIceServers || []), ...(iceConfig.servers || [])];
                  }
                  const props = {
                    iceConfig,
                    subscriberId: _this.widgetId,
                    send,
                    logAnalyticsEvent: log,
                    p2p: _session.sessionInfo.p2pEnabled,
                    sourceStreamId,
                    remoteConnectionId: _stream.connection.id,
                    // We force to use the SPC only for Mantis leg.
                    _singlePeerConnectionController: sourceStreamId === 'MANTIS' && _session._singlePeerConnectionController,
                    keyStore: _session.keyStore,
                    sFrameClientStore: _session.sFrameClientStore,
                    isE2ee: _session._.isE2ee(),
                    sessionId: (_session13 = _session) == null ? void 0 : _session13.sessionId
                  };
                  if (Object.prototype.hasOwnProperty.call(_properties, 'codecFlags')) {
                    props.codecFlags = _properties.codecFlags;
                  }
                  const peerConnection = new Subscriber.SubscriberPeerConnection(props);
                  peerConnection.once('iceConnected', _pcConnected.resolve);
                  peerConnection.once('error', _pcConnected.reject);
                  peerConnection.on('qos', logQoS);
                  setPeerConnectionEvents(peerConnection, sourceStreamId);

                  // initialize the peer connection AFTER we've added the event listeners
                  peerConnection.init(err => {
                    if (err) {
                      reject(err);
                    } else {
                      resolve(peerConnection);
                    }
                  });
                });
              });
              return _context23.abrupt("return", peerConnectionsAsync[sourceStreamId]);
            case 6:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
      return function (_x22) {
        return _ref37.apply(this, arguments);
      };
    }();

    /**
    * Restricts the frame rate of the Subscriber's video stream, when you pass in
    * <code>true</code>. When you pass in <code>false</code>, the frame rate of the video stream
    * is not restricted.
    * <p>
    * When the frame rate is restricted, the Subscriber video frame will update once or less per
    * second.
    * <p>
    * This feature is only available in sessions that use the Vonage Video API Media Router (sessions with
    * the <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media mode</a>
    * set to routed), not in sessions with the media mode set to relayed. In relayed sessions,
    * calling this method has no effect.
    * <p>
    * Restricting the subscriber frame rate has the following benefits:
    * <ul>
    *    <li>It reduces CPU usage.</li>
    *    <li>It reduces the network bandwidth consumed.</li>
    *    <li>It lets you subscribe to more streams simultaneously.</li>
    * </ul>
    * <p>
    * Reducing a subscriber's frame rate has no effect on the frame rate of the video in
    * other clients.
    *
    * @param {Boolean} value Whether to restrict the Subscriber's video frame rate
    * (<code>true</code>) or not (<code>false</code>).
    *
    * @return {Subscriber} The Subscriber object. This lets you chain method calls, as in the
    * following:
    *
    * <pre>mySubscriber.restrictFrameRate(false).subscribeToAudio(true);</pre>
    *
    * @method #restrictFrameRate
    * @memberOf Subscriber
    */
    this.restrictFrameRate = val => {
      logging.debug(`OT.Subscriber.restrictFrameRate(${val})`);
      logAnalyticsEvent('restrictFrameRate', val.toString(), {
        streamId: _stream.id
      });
      if (_session.sessionInfo.p2pEnabled) {
        logging.warn('OT.Subscriber.restrictFrameRate: Cannot restrictFrameRate on a P2P session');
      }
      if (typeof val !== 'boolean') {
        logging.error(`OT.Subscriber.restrictFrameRate: expected a boolean value got a ${typeof val}`);
      } else {
        _frameRateRestricted = val;
        _stream.setRestrictFrameRate(val);
      }
      return this;
    };
    this.on('styleValueChanged', updateChromeForStyleChange, this);
    this._ = {
      getDataChannel(label, options, completion) {
        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24() {
          return _regenerator.default.wrap(function _callee24$(_context24) {
            while (1) switch (_context24.prev = _context24.next) {
              case 0:
                if (getCurrentPeerConnection()) {
                  _context24.next = 3;
                  break;
                }
                completion(new OTHelpers.Error('Cannot create a DataChannel before there is a publisher connection.'));
                return _context24.abrupt("return");
              case 3:
                _context24.next = 5;
                return getCurrentPeerConnection();
              case 5:
                _context24.sent.getDataChannel(label, options, completion);
              case 6:
              case "end":
                return _context24.stop();
            }
          }, _callee24);
        }))();
      },
      iceRestart(reason, forcedRestart) {
        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25() {
          var sourceStreamId, peerConnection;
          return _regenerator.default.wrap(function _callee25$(_context25) {
            while (1) switch (_context25.prev = _context25.next) {
              case 0:
                if (forcedRestart === void 0) {
                  forcedRestart = false;
                }
                if (_session._.isSocketConnected()) {
                  _context25.next = 4;
                  break;
                }
                logging.debug('Subscriber: Skipping ice restart, websocket is not connected');
                return _context25.abrupt("return");
              case 4:
                sourceStreamId = _session.sessionInfo.p2pEnabled ? 'P2P' : 'MANTIS';
                _context25.next = 7;
                return getPeerConnectionBySourceStreamId(sourceStreamId);
              case 7:
                peerConnection = _context25.sent;
                if (peerConnection) {
                  _context25.next = 11;
                  break;
                }
                logging.debug('Subscriber: Skipping ice restart, we have no peer connection');
                return _context25.abrupt("return");
              case 11:
                logResubscribe('Attempt', {
                  reason
                });
                logging.debug('Subscriber: iceRestart attempt');
                peerConnection.iceRestart();
                if (forcedRestart) {
                  peerConnection.generateOffer();
                }
              case 15:
              case "end":
                return _context25.stop();
            }
          }, _callee25);
        }))();
      },
      unblockAudio: () => _widgetView && _widgetView.unblockAudio(),
      webRtcStream: () => _webRTCStream,
      setIceConfig: function () {
        var _setIceConfig = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27(iceConfig) {
          return _regenerator.default.wrap(function _callee27$(_context27) {
            while (1) switch (_context27.prev = _context27.next) {
              case 0:
                getAllPeerConnections().forEach( /*#__PURE__*/function () {
                  var _ref38 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26(pc) {
                    return _regenerator.default.wrap(function _callee26$(_context26) {
                      while (1) switch (_context26.prev = _context26.next) {
                        case 0:
                          _context26.next = 2;
                          return pc;
                        case 2:
                          return _context26.abrupt("return", _context26.sent.setIceConfig(iceConfig));
                        case 3:
                        case "end":
                          return _context26.stop();
                      }
                    }, _callee26);
                  }));
                  return function (_x24) {
                    return _ref38.apply(this, arguments);
                  };
                }());
              case 1:
              case "end":
                return _context27.stop();
            }
          }, _callee27);
        }));
        function setIceConfig(_x23) {
          return _setIceConfig.apply(this, arguments);
        }
        return setIceConfig;
      }(),
      privateEvents: new _events.default(),
      startRoutedToRelayedTransition() {
        if (_properties.testNetwork || isLocalStream(_stream, _session)) {
          // We avoid transitioning to relayed when doing a network test because we need
          // to subscribe from Mantis, or in case we're subscribing to the local stream.
          return;
        }
        amrState.startTransitionToRelayed();
        _transitionRoutedToRelayed();
      },
      startRelayedToRoutedTransition() {
        amrState.startTransitionToRouted(_transitionRelayedToRouted);
      },
      startMigration() {
        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28() {
          return _regenerator.default.wrap(function _callee28$(_context28) {
            while (1) switch (_context28.prev = _context28.next) {
              case 0:
                if (!_state.isMigrating()) {
                  _context28.next = 2;
                  break;
                }
                return _context28.abrupt("return");
              case 2:
                _state.set('Migrating');
                logAnalyticsEvent('Migrate', 'Attempt');
                startMigrationTimeout();

                // Update socket reference
                socket = _session._.getSocket();
                if (!_session.sessionInfo.p2pEnabled) {
                  _context28.next = 10;
                  break;
                }
                subscriberCreate('P2P');
                _context28.next = 14;
                break;
              case 10:
                _context28.next = 12;
                return getPeerConnectionBySourceStreamId('MANTIS');
              case 12:
                _previousPeerConnection = _context28.sent;
                subscriberCreate('MANTIS');
              case 14:
              case "end":
                return _context28.stop();
            }
          }, _callee28);
        }))();
      },
      finishMigration() {
        const destroyPeerConnection = (pc, sourceStreamId) => {
          if (pc) {
            pc.close();
            delete peerConnectionsAsync[sourceStreamId];
          }
        };

        // Clear previous PC
        destroyPeerConnection(_previousPeerConnection, 'MANTIS');
        _previousPeerConnection = null;

        // In case we don't transition to P2P after migration, clear P2P leg.
        if (_isAdaptiveEnabled && _activeSourceStreamId === 'MANTIS') {
          var _getPeerConnectionByS;
          (_getPeerConnectionByS = getPeerConnectionBySourceStreamId('P2P')) == null ? void 0 : _getPeerConnectionByS.then(pc => destroyPeerConnection(pc, 'P2P'));
        }
        clearTimeout(_migrationTimeoutId);
        logAnalyticsEvent('Migrate', 'Success');
      },
      setSinkId(deviceId) {
        const video = _widgetView && _widgetView.video();
        if (video) {
          return _widgetView.setSinkId(deviceId);
        }
        logging.debug('Called setAudioOutputDevice on a subscriber without a video element');
        return undefined;
      },
      pauseAndPlayVideoElement() {
        if (_widgetView) {
          _widgetView.pauseAndPlayVideoElement();
        }
      },
      get isSubscribingToVideo() {
        return _properties.subscribeToVideo;
      },
      getActiveSourceStreamId() {
        return _activeSourceStreamId;
      }
    };
    this._onSenderStatsReceived = content => {
      let parsedData;
      try {
        parsedData = JSON.parse(content.data);
      } catch (error) {
        logging.error(`Sender-Stats parsing failed: ${error.message}`);
        return;
      }
      _senderStats = parsedData;
    };
    _state = new SubscribingState(stateChangeFailed);
    logging.debug(`OT.Subscriber: subscribe to ${_stream.id}`);
    _state.set('Init');
    if (!_stream) {
      // @todo error
      logging.error('OT.Subscriber: No stream parameter.');
      return false;
    }
    _streamEventHandlers = {
      updated: streamUpdated
    };
    _stream.on(_streamEventHandlers, this);
    _properties.name = _properties.name || _stream.name;
    _properties.classNames = 'OT_root OT_subscriber';
    if (_properties.style) {
      this.setStyle(_properties.style, null, true);
    }
    _latestPositiveVolume = DEFAULT_AUDIO_VOLUME;
    _properties.subscribeToVideo = (0, _castToBoolean.default)(_properties.subscribeToVideo, true);
    _isVideoManuallyMuted = !_properties.subscribeToVideo;
    _properties.subscribeToAudio = (0, _castToBoolean.default)(_properties.subscribeToAudio, true);
    this.subscribeToAudio(_properties.subscribeToAudio);
    this.setAudioVolume(determineAudioVolume(_properties));
    _widgetView = new Subscriber.WidgetView(targetElement, Object.assign({}, _properties, {
      widgetType: 'subscriber'
    }));
    _widgetView.on('error', onVideoError);
    _widgetView.on('audioBlocked', () => this.trigger('audioBlocked'));
    _widgetView.on('audioUnblocked', () => this.trigger('audioUnblocked'));
    // We now log video transitions for AMR. These action are being triggered and logged
    // at this level.
    _widgetView.on('bindEvent', (action, variation, options) => {
      logAnalyticsEvent(action, variation, {}, options);
    });
    _widgetView.on('mediaElementEvent', action => {
      logAnalyticsEvent(action);
    });
    this.id = _widgetView.domId();
    _domId = _widgetView.domId();
    this.element = _widgetView.domElement;
    _widgetView.on('videoElementCreated', element => {
      const event = new Events.VideoElementCreatedEvent(element);
      const self = this;
      if (!_loaded) {
        this.once('loaded', () => {
          self.dispatchEvent(event);
        });
      } else {
        this.dispatchEvent(event);
      }
      if (_isAutoPreferredResolution && element) {
        if (element.height !== 0 && element.width !== 0) {
          _setOptimizedResolution(element);
        }
        _resizeObserver = new ResizeObserverPolyfill(() => {
          _setOptimizedResolution(element);
        });
        _resizeObserver.observe(element);
      }
    });
    _widgetView.on('destroy', () => {
      var _resizeObserver2;
      (_resizeObserver2 = _resizeObserver) == null ? void 0 : _resizeObserver2.disconnect();
    });
    if (this.element) {
      // Only create the chrome if there is an element to insert it in
      // for insertDefautlUI:false we don't create the chrome
      _createChrome.call(this);
    }
    const audio = _stream.getChannelsOfType('audio');
    const video = _stream.getChannelsOfType('video');
    const data = _stream.getChannelsOfType('data');

    // We're initalizing the flag here based on the data channel because we won't know the inital state otherwise.
    // The flag can then be mutated by subscribeToCaptions()
    let _isSubscribedToCaptions = data.some(channel => channel.id === 'caption1' && channel.active);

    /**
    * Toggles captions on and off. Starts subscribing to captions (if it is available and currently
    * not being subscribed to) when the <code>value</code> is <code>true</code>; stops
    * subscribing to captions (if it is currently being subscribed to) when the <code>value</code>
    * is <code>false</code>.
    * <p>
    * For more information, see the
    * <a href="https://tokbox.com/developer/guides/live-captions/">Live Captions</a>
    * developer guide.
    *
    * @param {Boolean} value Whether to start subscribing to captions (<code>true</code>) or not
    * (<code>false</code>).
    *
    * @see <a href="#isSubscribedToCaptions">isSubscribedToCaptions()</a>
    * @see <a href="#event:captionReceived">captionReceived</a> event
    *
    * @method #subscribeToCaptions
    * @memberOf Subscriber
    */
    this.subscribeToCaptions = /*#__PURE__*/function () {
      var _ref39 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29(value) {
        var active, attributes;
        return _regenerator.default.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              active = (0, _castToBoolean.default)(value, true);
              attributes = {
                active
              };
              _isSubscribedToCaptions = active;
              logAnalyticsEvent('subscribeToCaptions', 'Attempt', {
                subscribeToCaptions: active
              });
              socket.subscriberChannelUpdate(_stream.id, _this.widgetId, 'caption1', attributes);
              logAnalyticsEvent('subscribeToCaptions', 'Success', {
                subscribeToCaptions: active
              });
            case 6:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }));
      return function (_x25) {
        return _ref39.apply(this, arguments);
      };
    }();

    /**
     * Whether the subscriber is receiving captions. This property can change if the subscriber turns on
     * or off captioning (by calling <code>Subscriber.subscribeToCaptions()</code>).
     *
     * @class Subscriber
     * @see <a href="#subscribeToCaptions">Subscriber.subscribeToCaptions()</a>
     *
     * @method #isSubscribedToCaptions
     * @memberOf Subscriber
     */
    this.isSubscribedToCaptions = () => _isSubscribedToCaptions;
    const channelsToSubscribeTo = audio.map(channel => ({
      id: channel.id,
      type: channel.type,
      active: _properties.subscribeToAudio
    })).concat(video.map(channel => {
      const props = {
        id: channel.id,
        type: channel.type,
        active: _properties.subscribeToVideo,
        restrictFrameRate: _properties.restrictFrameRate !== undefined ? _properties.restrictFrameRate : false
      };
      if (_properties.preferredFrameRate !== undefined) {
        props.preferredFrameRate = parseFloat(_properties.preferredFrameRate);
        this._preferredFrameRate = props.preferredFrameRate;
      }
      if (_properties.preferredHeight !== undefined) {
        props.preferredHeight = parseInt(_properties.preferredHeight, 10);
      }
      if (_properties.preferredWidth !== undefined) {
        props.preferredWidth = parseInt(_properties.preferredWidth, 10);
      }
      return props;
    })).concat(data.map(channel => ({
      id: channel.id,
      type: channel.type,
      active: channel.active
    })));
    const publisherCaptionsActive = (_stream$getChannelsOf = _stream.getChannelsOfType('data')[0]) == null ? void 0 : _stream$getChannelsOf.active;
    const shouldSubscribeToSelf = !_properties.testNetwork && isLocalStream(_stream, _session) && !publisherCaptionsActive;
    const messageRumorWhenPublisherHasCaptionsListener = () => {
      var _publisher$_;
      // In the case that a publisher decides to publish captions when we are self subscribing, we will want to
      // inform rumor of the subscriber's existence via subscriberCreate
      const publisher = _session.getPublisherForStream(_stream);
      if (publisher != null && (_publisher$_ = publisher._) != null && _publisher$_.privateEvents && shouldSubscribeToSelf) {
        // We only want to call subscriberCreate once as multiple calls will cause an error
        // and we can't forsee if the publisher will toggle before the subscriber is created
        let didSubscriberCreate = false;
        publisher._.privateEvents.on('publisherCaptionsEnabled', event => {
          if (!didSubscriberCreate && event.captionsEnabled) {
            channelsToSubscribeTo.find(channel => channel.id === 'caption1').active = true;
            subscriberCreate();
            didSubscriberCreate = true;
          }
        });
      }
    };
    messageRumorWhenPublisherHasCaptionsListener();
    const subscriberCreate = function subscriberCreate(sourceStreamId) {
      if (sourceStreamId === void 0) {
        sourceStreamId = null;
      }
      if (!_state.isMigrating()) {
        connectivityState.beginConnect();
      }
      socket.subscriberCreate(_stream.id, _widgetId,
      // subscriberId
      channelsToSubscribeTo, sourceStreamId, _session._.isE2ee(), (err, message) => {
        const payload = Object.assign({
          status: message == null ? void 0 : message.status
        }, (err == null ? void 0 : err.message) && {
          error: err == null ? void 0 : err.message
        });
        logAnalyticsEvent('subscriberCreate', 'Event', payload);
        // when the publisher is destroyed before we subscribe, chances are we have been told about
        // before we get the subscriberCreate error, so this can be ignored.
        if (err && !connectivityState.is('disconnected')) {
          onSubscriberCreateError(err);
        }
        fallbackIceServers = parseIceServers(message);
      });
    };
    if (shouldSubscribeToSelf) {
      connectivityState.beginConnect();
      // bypass rumor etc and just subscribe locally
      this._subscribeToSelf();
      return this;
    }
    subscriberCreate();

    /**
     * Sets a MediaProcessorConnector for the subscriber video track.
     * A subscriber can have only one video
     * <a href="https://vonage.github.io/media-processor-docs/docs/api/classes/MediaProcessorConnector">MediaProcessorConnector</a>
     * applied at one time.  When you set a new
     * connector, the previously set video connector is removed.
     *
     * <p>
     * <em>Note:</em> MediaProcessors are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     * </p>
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     There are no video input devices (cameras) available.
     *   </li>
     *   <li>
     *     There was an error acquiring video from the video input device.
     *   </li>
     *   <li>
     *     There was an error acquiring the processed track from the MediaProcessorConnector.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can clear the current connector by calling this method with <code>null</code>.
     *
     * <p>
     * For more information, see the
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/">
     * Using the Vonage Media Processor library</a>
     * developer guide.
     *
     * @param {MediaProcessorConnector} mediaProcessorConnector A MediaProcessorConnector instance.
     * See the <a href="https://vonage.github.io/media-processor-docs/docs/intro/">Vonage Media Processor
     * library docs</a>.</td>
     *
     * @method #setVideoMediaProcessorConnector
     * @memberOf Subscriber
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no connector is set.
     */
    this.setVideoMediaProcessorConnector = /*#__PURE__*/function () {
      var _ref40 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30(mediaProcessorConnector) {
        var isTransitioning;
        return _regenerator.default.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Attempt', {
                message: mediaProcessorConnector ? 'setting the connector' : 'clearing the connector'
              });
              _clearConnector();
              if (mediaProcessorConnector) {
                _context30.next = 6;
                break;
              }
              _resetVideoStream();
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Success', {
                message: 'clearing the connector'
              });
              return _context30.abrupt("return");
            case 6:
              if (_mediaProcessorConnector.default.isValidConnector(mediaProcessorConnector)) {
                _context30.next = 9;
                break;
              }
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                message: 'Invalid MediaProcessorConnector'
              });
              throw otError(_Errors.default.INVALID_PARAMETER, new Error('setVideoMediaProcessorConnector:  Tried to set invalid MediaProcessorConnector'));
            case 9:
              _videoMediaProcessorConnector = new _mediaProcessorConnector.default(mediaProcessorConnector);

              // this is needed to avoid double filtering during AMR transitions
              isTransitioning = amrState.isTransitioning();
              if (!(isTransitioning || !_videoEnabled)) {
                _context30.next = 14;
                break;
              }
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Pending', {
                isTransitioning,
                isVideoEnabled: _videoEnabled
              });
              return _context30.abrupt("return");
            case 14:
              _resetVideoStream();
              _context30.prev = 15;
              _context30.next = 18;
              return _setVideoMediaProcessorConnector();
            case 18:
              _context30.next = 24;
              break;
            case 20:
              _context30.prev = 20;
              _context30.t0 = _context30["catch"](15);
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                message: _context30.t0.message
              });
              throw _context30.t0;
            case 24:
            case "end":
              return _context30.stop();
          }
        }, _callee30, null, [[15, 20]]);
      }));
      return function (_x26) {
        return _ref40.apply(this, arguments);
      };
    }();
    const _setVideoMediaProcessorConnector = /*#__PURE__*/function () {
      var _ref41 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31() {
        var _webRTCStream$getVide, message, filteredVideoTrack;
        return _regenerator.default.wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _webRTCStream$getVide = _webRTCStream.getVideoTracks();
              _originalVideoTrack = _webRTCStream$getVide[0];
              if (_originalVideoTrack) {
                _context31.next = 7;
                break;
              }
              message = 'Connector not set as no video is present.';
              logging.warn(`setVideoMediaProcessorConnector: ${message}`);
              _videoMediaProcessorConnector = null;
              throw Error('setVideoMediaProcessorConnector', 'Failure', {
                message
              });
            case 7:
              _context31.prev = 7;
              _context31.next = 10;
              return _videoMediaProcessorConnector.setTrack(_originalVideoTrack);
            case 10:
              filteredVideoTrack = _context31.sent;
              updateTrackOnStream(_webRTCStream, _originalVideoTrack, filteredVideoTrack);
              logAnalyticsEvent('setVideoMediaProcessorConnector', 'Success');
              _context31.next = 20;
              break;
            case 15:
              _context31.prev = 15;
              _context31.t0 = _context31["catch"](7);
              _videoMediaProcessorConnector = null;
              logging.error(`setVideoMediaProcessorConnector: Error getting track from MediaProcessorConnector: ${_context31.t0}`);
              throw Error('setVideoMediaProcessorConnector', 'Failure', {
                message: _context31.t0.message
              });
            case 20:
            case "end":
              return _context31.stop();
          }
        }, _callee31, null, [[7, 15]]);
      }));
      return function _setVideoMediaProcessorConnector() {
        return _ref41.apply(this, arguments);
      };
    }();
    const _resetVideoStream = () => {
      if (!_originalVideoTrack) {
        return;
      }
      try {
        // We need to switch to the original track so we can transform it later when resetting the connector.
        const _webRTCStream$getVide2 = _webRTCStream.getVideoTracks(),
          filteredVideoTrack = _webRTCStream$getVide2[0];
        updateTrackOnStream(_webRTCStream, filteredVideoTrack, _originalVideoTrack);
        logAnalyticsEvent('setVideoMediaProcessorConnector', 'Success', {
          message: 'reset the video track'
        });
      } catch (err) {
        logging.error(`setVideoMediaProcessorConnector: Error resetting track: ${err}`);
        throw Error('setVideoMediaProcessorConnector', 'Failure', {
          message: err.message
        });
      }
      _originalVideoTrack = null;
    };
    const _clearConnector = () => {
      var _videoMediaProcessorC;
      (_videoMediaProcessorC = _videoMediaProcessorConnector) == null ? void 0 : _videoMediaProcessorC.destroy();
      _videoMediaProcessorConnector = null;
    };

    /**
     * Sets a MediaProcessorConnector for the subscriber audio track.
     * A subscriber can have only one audio
     * <a href="https://vonage.github.io/media-processor-docs/docs/api/classes/MediaProcessorConnector">MediaProcessorConnector</a>
     * applied at one time.  When you set a new
     * connector, the previously set audio connector is removed.
     *
     * <p>
     * <em>Note:</em> MediaProcessors are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     * </p>
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     There was an error acquiring the processed track from the MediaProcessorConnector.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can clear the current connector by calling this method with <code>null</code>.
     *
     * <p>
     * For more information, see the
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/">
     * Using the Vonage Media Processor library</a>
     * developer guide.
     *
     * @param {MediaProcessorConnector} mediaProcessorConnector A MediaProcessorConnector instance.
     * See the <a href="https://vonage.github.io/media-processor-docs/docs/intro/">Vonage Media Processor
     * library docs</a>.</td>
     *
     * @method #setAudioMediaProcessorConnector
     * @memberOf Subscriber
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no connector is set.
     */
    this.setAudioMediaProcessorConnector = /*#__PURE__*/function () {
      var _ref42 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(mediaProcessorConnector) {
        var message, isTransitioning;
        return _regenerator.default.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Attempt', {
                message: mediaProcessorConnector ? 'setting the connector' : 'clearing the connector'
              });
              _audioConnector == null ? void 0 : _audioConnector.clearAudioMediaProcessorConnector(_activeSourceStreamId);
              if (mediaProcessorConnector) {
                _context32.next = 6;
                break;
              }
              _audioConnector == null ? void 0 : _audioConnector.resetAudioStreamAndTrack();
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Success', {
                message: 'clearing the connector'
              });
              return _context32.abrupt("return");
            case 6:
              if (_mediaProcessorConnector.default.isValidConnector(mediaProcessorConnector)) {
                _context32.next = 11;
                break;
              }
              message = 'Tried to set invalid MediaProcessorConnector';
              logging.error(`setAudioMediaProcessorConnector: ${message}`);
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
                message
              });
              throw otError(_Errors.default.INVALID_PARAMETER, new Error(`setAudioVideoMediaProcessorConnector: ${message}`));
            case 11:
              _audioConnector.initializeConnector(mediaProcessorConnector);
              isTransitioning = amrState.isTransitioning();
              if (!(isTransitioning || !_isSubscribingToAudio)) {
                _context32.next = 16;
                break;
              }
              // After the transition finishes, or when re-subscribing to audio, we will apply the
              // media processor to the audio track.
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Pending', {
                isTransitioning,
                subscribingToAudio: _isSubscribingToAudio
              });
              return _context32.abrupt("return");
            case 16:
              _audioConnector.resetAudioStreamAndTrack();
              _setAudioMediaProcessorConnector();
            case 18:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }));
      return function (_x27) {
        return _ref42.apply(this, arguments);
      };
    }();
    const _setAudioMediaProcessorConnector = /*#__PURE__*/function () {
      var _ref43 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33() {
        return _regenerator.default.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.prev = 0;
              _context33.next = 3;
              return _audioConnector == null ? void 0 : _audioConnector.setAudioMediaProcessorConnector(_activeSourceStreamId);
            case 3:
              _context33.next = 10;
              break;
            case 5:
              _context33.prev = 5;
              _context33.t0 = _context33["catch"](0);
              logging.error(`setAudioMediaProcessorConnector: ${_context33.t0.message}`);
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
                message: _context33.t0.message
              });
              throw _context33.t0;
            case 10:
              logAnalyticsEvent('setAudioMediaProcessorConnector', 'Success');
            case 11:
            case "end":
              return _context33.stop();
          }
        }, _callee33, null, [[0, 5]]);
      }));
      return function _setAudioMediaProcessorConnector() {
        return _ref43.apply(this, arguments);
      };
    }();

    /**
    * Dispatched when the subscriber's audio is blocked because of the
    * browser's autoplay policy.
    *
    * @see <a href="OT.html#unblockAudio">OT.unblockAudio()</a>
    * @see <a href="Subscriber.html#isAudioBlocked">Subscriber.isAudioBlocked()</a>
    * @see The <a href="#event:audioUnblocked">audioUnblocked</a> event
    * @see The <code>style.audioBlockedDisplayMode</code> property of the
    * <code>options</code> parameter of the
    * <a href="Session.html#subscribe">Session.subscribe()</a> method)
    *
    * @name audioBlocked
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when the subscriber's audio is unblocked after
    * being paused because of the browser's autoplay policy.
    * <p>
    * Subscriber audio is unblocked when any of the following occurs:
    * <ul>
    *  <li>
    *    The user clicks the default Subscriber audio playback icon
    *  </li>
    *  <li>
    *     The <a href="OT.html#unblockAudio">OT.unblockAudio()</a>
    *     method is called in response to an HTML element dispatching
    *     a <code>click</code> event (if you have disabled the default
    *     audio playback icon)
    *  </li>
    *  <li>
    *     The local client gains access to the camera or microphone
    *     (for instance, in response to a successful call to
    *     <code>OT.initPublisher()</code>).
    *  </li>
    * </ul>
    *
    * @see <a href="OT.html#unblockAudio">OT.unblockAudio()</a>
    * @see The <a href="l#event:audioBlocked">audioBlocked</a> event
    * @see The <code>style.audioBlockedDisplayMode</code> property of the
    * <code>options</code> parameter of the
    * <a href="Session.html#subscribe">Session#subscribe()</a> method)
    *
    * @name audioUnblocked
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched periodically to indicate the subscriber's audio level. The event is dispatched
    * up to 60 times per second, depending on the browser. The <code>audioLevel</code> property
    * of the event is audio level, from 0 to 1.0. See {@link AudioLevelUpdatedEvent} for more
    * information.
    * <p>
    * The following example adjusts the value of a meter element that shows volume of the
    * subscriber. Note that the audio level is adjusted logarithmically and a moving average
    * is applied:
    * <pre>
    * var movingAvg = null;
    * subscriber.on('audioLevelUpdated', function(event) {
    *   if (movingAvg === null || movingAvg &lt;= event.audioLevel) {
    *     movingAvg = event.audioLevel;
    *   } else {
    *     movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
    *   }
    *
    *   // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
    *   var logLevel = (Math.log(movingAvg) / Math.LN10) / 1.5 + 1;
    *   logLevel = Math.min(Math.max(logLevel, 0), 1);
    *   document.getElementById('subscriberMeter').value = logLevel;
    * });
    * </pre>
    * <p>This example shows the algorithm used by the default audio level indicator displayed
    * in an audio-only Subscriber.
    *
    * @name audioLevelUpdated
    * @event
    * @memberof Subscriber
    * @see AudioLevelUpdatedEvent
    */

    /**
    * Dispatched when the video for the subscriber is disabled.
    * <p>
    * The <code>reason</code> property defines the reason the video was disabled. This can be set to
    * one of the following values:
    * <p>
    *
    * <ul>
    *
    *   <li><code>"codecNotSupported"</code> &mdash; The client's browser does not support the
    *   video codec used by the stream. For example, in Safari if you connect to a
    *   <a href="https://tokbox.com/developer/guides/create-session/#media-mode">routed session</a>
    *   in a <a href="https://tokbox.com/developer/sdks/js/safari">non-Safari Vonage Video API
    *   project</a>, and you try to subscribe to a stream that includes video, the Subscriber
    *   will dispatch a <code>videoDisabled</code> event with the <code>reason</code> property
    *   set to <code>"codecNotSupported"</code>. (In routed sessions in a non-Safari project,
    *   streams use the VP8 video codec, which is not supported in Safari.) The subscriber
    *   element will also display a "Video format not supported" message. (See
    *   <a href="OT.html#getSupportedCodecs">OT.getSupportedCodecs()</a>.)</li>
    *
    *   <li><code>"publishVideo"</code> &mdash; The publisher stopped publishing video by calling
    *   <code>publishVideo(false)</code>.</li>
    *
    *   <li><code>"quality"</code> &mdash; The Vonage Video API Media Router stopped sending video
    *   to the subscriber based on stream quality changes. This feature of the Vonage Video API Media
    *   Router has a subscriber drop the video stream when connectivity degrades. (The subscriber
    *   continues to receive the audio stream, if there is one.)
    *   <p>
    *   Before sending this event, when the Subscriber's stream quality deteriorates to a level
    *   that is low enough that the video stream is at risk of being disabled, the Subscriber
    *   dispatches a <code>videoDisableWarning</code> event.
    *   <p>
    *   If connectivity improves to support video again, the Subscriber object dispatches
    *   a <code>videoEnabled</code> event, and the Subscriber resumes receiving video.
    *   <p>
    *   By default, the Subscriber displays a video disabled indicator when a
    *   <code>videoDisabled</code> event with this reason is dispatched and removes the indicator
    *   when the <code>videoEnabled</code> event with this reason is dispatched. You can control
    *   the display of this icon by calling the <code>setStyle()</code> method of the Subscriber,
    *   setting the <code>videoDisabledDisplayMode</code> property(or you can set the style when
    *   calling the <code>Session.subscribe()</code> method, setting the <code>style</code> property
    *   of the <code>properties</code> parameter).
    *   <p>
    *   This feature is only available in sessions that use the Vonage Video API Media Router (sessions with
    *   the <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media mode</a>
    *   set to routed), not in sessions with the media mode set to relayed.
    *   <p>
    *   You can disable this audio-only fallback feature by setting the
    *   <code>audioFallback.subscriber</code> property to <code>false</code>
    *   in the options you pass to the <code>OT.initPublisher()</code>
    *   method on the publishing client. (See
    *   <a href="OT.html#initPublisher">OT.initPublisher()</a>.)
    *   </li>
    *
    *   <li><code>"subscribeToVideo"</code> &mdash; The subscriber started or stopped subscribing to
    *   video, by calling <code>subscribeToVideo(false)</code>.
    *   </li>
    *
    * </ul>
    *
    * @see VideoEnabledChangedEvent
    * @see <a href="Subscriber.html#event:videoDisableWarning">videoDisableWarning</a> event
    * @see <a href="Subscriber.html#event:videoEnabled">videoEnabled</a> event
    * @name videoDisabled
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when the Vonage Video API Media Router determines that the stream quality has degraded
    * and the video will be disabled if the quality degrades more. If the quality degrades further,
    * the Subscriber disables the video and dispatches a <code>videoDisabled</code> event.
    * <p>
    * By default, the Subscriber displays a video disabled warning indicator when this event
    * is dispatched (and the video is disabled). You can control the display of this icon by
    * calling the <code>setStyle()</code> method and setting the
    * <code>videoDisabledDisplayMode</code> property (or you can set the style when calling
    * the <code>Session.subscribe()</code> method and setting the <code>style</code> property
    * of the <code>properties</code> parameter).
    * <p>
    * This feature is only available in sessions that use the Vonage Video API Media Router (sessions with
    * the <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media mode</a>
    * set to routed), not in sessions with the media mode set to relayed.
    *
    * @see Event
    * @see <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event
    * @see <a href="Subscriber.html#event:videoDisableWarningLifted">videoDisableWarningLifted</a> event
    * @name videoDisableWarning
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when the Subscriber's video element is created. Add a listener for this event when
    * you set the <code>insertDefaultUI</code> option to <code>false</code> in the call to the
    * <a href="Session.html#subscribe">Session.subscribe()</a> method. The <code>element</code>
    * property of the event object is a reference to the Subscriber's <code>video</code> element
    * (or in Internet Explorer the <code>object</code> element containing the video). Add it to
    * the HTML DOM to display the video. When you set the <code>insertDefaultUI</code> option to
    * <code>false</code>, the <code>video</code> (or <code>object</code>) element is not automatically
    * inserted into the DOM.
    * <p>
    * Add a listener for this event only if you have set the <code>insertDefaultUI</code> option to
    * <code>false</code>. If you have not set <code>insertDefaultUI</code> option to
    * <code>false</code>, do not move the <code>video</code> (or <code>object</code>) element in
    * in the HTML DOM. Doing so causes the Subscriber object to be destroyed.
    *
    * @name videoElementCreated
    * @event
    * @memberof Subscriber
    * @see VideoElementCreatedEvent
    */

    /**
    * Dispatched when the Vonage Video API Media Router determines that the stream quality has improved
    * to the point at which the video being disabled is not an immediate risk. This event is
    * dispatched after the Subscriber object dispatches a <code>videoDisableWarning</code> event.
    * <p>
    * This feature is only available in sessions that use the Vonage Video API Media Router (sessions with
    * the <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media mode</a>
    * set to routed), not in sessions with the media mode set to relayed.
    *
    * @see Event
    * @see <a href="Subscriber.html#event:videoDisableWarning">videoDisableWarning</a> event
    * @see <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event
    * @name videoDisableWarningLifted
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when the MediaStream is available.
    * @see Event
    * @name mediaStreamAvailable
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when the subscriber receives a caption from the transcription service.
    * You must first call the <a href="Subscriber.html#subscribeToCaptions">Subscriber.subscribeToCaptions()</a>
    * method (and the publisher of the stream must be publishing captions) before you receive
    * <code>captionReceived</code> events.
    *
    * @see <a href="CaptionReceivedEvent.html">CaptionReceivedEvent</a>
    * @see <a href="https://tokbox.com/developer/guides/live-captions/">Live Captioning</a>
    * @name captionReceived
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when a subscriber's media cannot be decrypted because the encryption secrets do not match.
    * In this scenario the user will still be subscribed to the stream, but the
    * video will be black and the audio will be silent. It is considered good practice
    * to communicate to the user why media is not viewable.
    *
    * @see Event
    * @see <a href="Subscriber.html#event:encryptionSecretMatch">encryptionSecretMatch</a> event
    * @see <a href="OT.html#initSession">OT.initSession</a>
    * @see <a href="Session.html#setEncryptionSecret">session.setEncryptionSecret</a>
    * @name encryptionSecretMismatch
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when a subscriber's media can be decrypted because the encryption secrets match.
    * This is only dispatched when there was previously a secret mismatch.
    *
    * @see Event
    * @see <a href="Subscriber.html#event:encryptionSecretMismatch">encryptionSecretMismatch</a> event
    * @see <a href="OT.html#initSession">OT.initSession</a>
    * @see <a href="Session.html#setEncryptionSecret">session.setEncryptionSecret</a>
    * @name encryptionSecretMatch
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when the Vonage Video API Media Router resumes sending video to the subscriber
    * after video was previously disabled.
    * <p>
    * The <code>reason</code> property defines the reason the video was enabled. This can be set to
    * one of the following values:
    * <p>
    *
    * <ul>
    *
    *   <li><code>"codecChanged"</code> &mdash; The subscriber video was enabled after
    *   a codec change from an incompatible codec.</li>
    *
    *   <li><code>"publishVideo"</code> &mdash; The publisher started publishing video by calling
    *   <code>publishVideo(true)</code>.</li>
    *
    *   <li><code>"quality"</code> &mdash; The Vonage Video API Media Router resumed sending video
    *   to the subscriber based on stream quality changes. This feature of the Vonage Video API Media
    *   Router has a subscriber drop the video stream when connectivity degrades and then resume
    *   the video stream if the stream quality improves.
    *   <p>
    *   This feature is only available in sessions that use the Vonage Video API Media Router (sessions with
    *   the <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media mode</a>
    *   set to routed), not in sessions with the media mode set to relayed.
    *   </li>
    *
    *   <li><code>"subscribeToVideo"</code> &mdash; The subscriber started or stopped subscribing to
    *   video, by calling <code>subscribeToVideo(false)</code>.
    *   </li>
    *
    * </ul>
    *
    * @see VideoEnabledChangedEvent
    * @see <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event
    * @name videoEnabled
    * @event
    * @memberof Subscriber
    */

    /**
    * Sent when the subscriber's stream has been interrupted.
    * <p>
    * In response to this event, you may want to provide a user interface notification, to let the
    * user know that the audio-video stream is temporarily disconnected and that the app is trying
    * to reconnect to it.
    * <p>
    * If the client reconnects to the stream, the Subscriber object dispatches a
    * <code>connected</code> event. Otherwise, if the client cannot reconnect to the stream,
    * the Subscriber object dispatches a <code>destroyed</code> event.
    *
    * @name disconnected
    * @event
    * @memberof Subscriber
    * @see <a href="Subscriber.html#event:connected">connected event</a>
    * @see Event
    */

    /**
    * Sent when the subscriber's stream has resumed, after the Subscriber dispatches a
    * <code>disconnected</code> event.
    *
    * @name connected
    * @event
    * @memberof Subscriber
    * @see <a href="Subscriber.html#event:disconnected">disconnected event</a>
    * @see Event
    */

    /**
    * Dispatched when the Subscriber element is removed from the HTML DOM. When this event is
    * dispatched, you may choose to adjust or remove HTML DOM elements related to the subscriber.
    * <p>
    * To prevent the Subscriber from being removed from the DOM when the stream is destroyed,
    * listen for the <a href="Session.html#event:streamDestroyed">streamDestroyed event</a>
    * dispatched by the Session object. The <code>streamDestroyed</code> event dispatched by the
    * Session object is cancelable, and calling the <code>preventDefault()</code> method of the
    * event object prevents Subscribers of the stream from being removed from the HTML DOM.
    *
    * @see Event
    * @name destroyed
    * @event
    * @memberof Subscriber
    */

    /**
    * Dispatched when the video dimensions of the video change. This can occur when the
    * <code>stream.videoType</code> property is set to <code>"screen"</code> (for a screen-sharing
    * video stream), when the user resizes the window being captured. It can also occur if the video
    * is being published by a mobile device and the user rotates the device (causing the camera
    * orientation to change). This event object has a <code>newValue</code> property and an
    * <code>oldValue</code> property, representing the new and old dimensions of the video.
    * Each of these has a <code>height</code> property and a <code>width</code> property,
    * representing the height and width, in pixels.
    * @name videoDimensionsChanged
    * @event
    * @memberof Subscriber
    * @see VideoDimensionsChangedEvent
    */

    /**
    * Dispatched when either the audio or video quality
    * score has changed. The scores are a heuristic value representing the expected subscriber experience. The values
    * range from 5 to 1, with the integer values corresponding to Excellent | Good | Fair | Poor | Bad.
    *
    * @name qualityScoreChanged
    * @event
    * @memberof Subscriber
    * @see QualityScoreChangedEvent
    */
    return this;
  };
  Subscriber.hasAudioOutputLevelStatCapability = hasAudioOutputLevelStatCapability;
  Subscriber.WidgetView = WidgetView;
  Subscriber.SubscriberPeerConnection = SubscriberPeerConnection;
  return Subscriber;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 332 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fallback = fallback;
exports.wrap = wrap;
/* istanbul ignore file */

var hasQueueMicrotask = exports.hasQueueMicrotask = typeof queueMicrotask === 'function' && queueMicrotask;
var hasSetImmediate = exports.hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
var hasNextTick = exports.hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

function fallback(fn) {
    setTimeout(fn, 0);
}

function wrap(defer) {
    return (fn, ...args) => defer(() => fn(...args));
}

var _defer;

if (hasQueueMicrotask) {
    _defer = queueMicrotask;
} else if (hasSetImmediate) {
    _defer = setImmediate;
} else if (hasNextTick) {
    _defer = process.nextTick;
} else {
    _defer = fallback;
}

exports.default = wrap(_defer);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(24)))

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _events = _interopRequireDefault(__webpack_require__(12));
var _amrStates = _interopRequireDefault(__webpack_require__(335));
var _amrStateDurations = _interopRequireDefault(__webpack_require__(178));
const createAmrStateMachine = function createAmrStateMachine(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const _AMRStateDurationsDef = Object.assign({}, _amrStateDurations.default, deps),
    TRANSITION_TIMEOUT = _AMRStateDurationsDef.TRANSITION_TIMEOUT;
  const ee = new _events.default();
  const amrStateMachine = {
    state: _amrStates.default.MANTIS,
    pendingTransitions: [],
    timeout: undefined,
    isTransitioning() {
      return this.state === _amrStates.default.TRANSITIONING;
    },
    clearTransitionTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }
    },
    startTransitionToRelayed() {
      // Transition to relayed is async, so when the transition has started we just change the state
      // to TRANSITIONING.
      this.state = _amrStates.default.TRANSITIONING;
      this.clearTransitionTimeout();
      this.timeout = setTimeout(() => {
        ee.emit('transitionToP2PTimeout');
      }, TRANSITION_TIMEOUT);
    },
    completeTransitionTo(state) {
      // Only the transition to p2p is async. We don't call completeTransitionTo for routed.
      if (state === _amrStates.default.P2P) {
        this.clearTransitionTimeout();
        this._transitionTo(state);
      }
    },
    startTransitionToRouted(processTransition) {
      if (this.state === _amrStates.default.TRANSITIONING) {
        this.pendingTransitions.push({
          to: _amrStates.default.MANTIS,
          process: processTransition
        });
      } else {
        this._transitionTo(_amrStates.default.MANTIS, processTransition);
      }
    },
    _transitionTo(state, process) {
      if (process) {
        this.state = _amrStates.default.TRANSITIONING;
        process();
      }
      this.state = state;
      this._onTransitionCompleted();
    },
    _onTransitionCompleted() {
      if (this.pendingTransitions.length) {
        const _this$pendingTransiti = this.pendingTransitions.shift(),
          to = _this$pendingTransiti.to,
          process = _this$pendingTransiti.process;
        this._transitionTo(to, process);
      }
    }
  };
  return Object.assign(ee, amrStateMachine);
};
var _default = createAmrStateMachine;
exports.default = _default;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = {
  MANTIS: 'MANTIS',
  P2P: 'P2P',
  TRANSITIONING: 'TRANSITIONING'
};
exports.default = _default;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(target, sources) {
  var n, source, key;
  for(n = 1 ; n < arguments.length ; n++) {
    source = arguments[n];
    for(key in source) {
      if (source.hasOwnProperty(key))
        target[key] = source[key];
    }
  }
  return target;
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-------------------------------------------------------------------------------------------------

var mixin = __webpack_require__(0);

//-------------------------------------------------------------------------------------------------

module.exports = {

  build: function(target, config) {
    var n, max, plugin, plugins = config.plugins;
    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n];
      if (plugin.methods)
        mixin(target, plugin.methods);
      if (plugin.properties)
        Object.defineProperties(target, plugin.properties);
    }
  },

  hook: function(fsm, name, additional) {
    var n, max, method, plugin,
        plugins = fsm.config.plugins,
        args    = [fsm.context];

    if (additional)
      args = args.concat(additional)

    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n]
      method = plugins[n][name]
      if (method)
        method.apply(plugin, args);
    }
  }

}

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-------------------------------------------------------------------------------------------------

function camelize(label) {

  if (label.length === 0)
    return label;

  var n, result, word, words = label.split(/[_-]/);

  // single word with first character already lowercase, return untouched
  if ((words.length === 1) && (words[0][0].toLowerCase() === words[0][0]))
    return label;

  result = words[0].toLowerCase();
  for(n = 1 ; n < words.length ; n++) {
    result = result + words[n].charAt(0).toUpperCase() + words[n].substring(1).toLowerCase();
  }

  return result;
}

//-------------------------------------------------------------------------------------------------

camelize.prepended = function(prepend, label) {
  label = camelize(label);
  return prepend + label[0].toUpperCase() + label.substring(1);
}

//-------------------------------------------------------------------------------------------------

module.exports = camelize;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-------------------------------------------------------------------------------------------------

var mixin    = __webpack_require__(0),
    camelize = __webpack_require__(2);

//-------------------------------------------------------------------------------------------------

function Config(options, StateMachine) {

  options = options || {};

  this.options     = options; // preserving original options can be useful (e.g visualize plugin)
  this.defaults    = StateMachine.defaults;
  this.states      = [];
  this.transitions = [];
  this.map         = {};
  this.lifecycle   = this.configureLifecycle();
  this.init        = this.configureInitTransition(options.init);
  this.data        = this.configureData(options.data);
  this.methods     = this.configureMethods(options.methods);

  this.map[this.defaults.wildcard] = {};

  this.configureTransitions(options.transitions || []);

  this.plugins = this.configurePlugins(options.plugins, StateMachine.plugin);

}

//-------------------------------------------------------------------------------------------------

mixin(Config.prototype, {

  addState: function(name) {
    if (!this.map[name]) {
      this.states.push(name);
      this.addStateLifecycleNames(name);
      this.map[name] = {};
    }
  },

  addStateLifecycleNames: function(name) {
    this.lifecycle.onEnter[name] = camelize.prepended('onEnter', name);
    this.lifecycle.onLeave[name] = camelize.prepended('onLeave', name);
    this.lifecycle.on[name]      = camelize.prepended('on',      name);
  },

  addTransition: function(name) {
    if (this.transitions.indexOf(name) < 0) {
      this.transitions.push(name);
      this.addTransitionLifecycleNames(name);
    }
  },

  addTransitionLifecycleNames: function(name) {
    this.lifecycle.onBefore[name] = camelize.prepended('onBefore', name);
    this.lifecycle.onAfter[name]  = camelize.prepended('onAfter',  name);
    this.lifecycle.on[name]       = camelize.prepended('on',       name);
  },

  mapTransition: function(transition) {
    var name = transition.name,
        from = transition.from,
        to   = transition.to;
    this.addState(from);
    if (typeof to !== 'function')
      this.addState(to);
    this.addTransition(name);
    this.map[from][name] = transition;
    return transition;
  },

  configureLifecycle: function() {
    return {
      onBefore: { transition: 'onBeforeTransition' },
      onAfter:  { transition: 'onAfterTransition'  },
      onEnter:  { state:      'onEnterState'       },
      onLeave:  { state:      'onLeaveState'       },
      on:       { transition: 'onTransition'       }
    };
  },

  configureInitTransition: function(init) {
    if (typeof init === 'string') {
      return this.mapTransition(mixin({}, this.defaults.init, { to: init, active: true }));
    }
    else if (typeof init === 'object') {
      return this.mapTransition(mixin({}, this.defaults.init, init, { active: true }));
    }
    else {
      this.addState(this.defaults.init.from);
      return this.defaults.init;
    }
  },

  configureData: function(data) {
    if (typeof data === 'function')
      return data;
    else if (typeof data === 'object')
      return function() { return data; }
    else
      return function() { return {};  }
  },

  configureMethods: function(methods) {
    return methods || {};
  },

  configurePlugins: function(plugins, builtin) {
    plugins = plugins || [];
    var n, max, plugin;
    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n];
      if (typeof plugin === 'function')
        plugins[n] = plugin = plugin()
      if (plugin.configure)
        plugin.configure(this);
    }
    return plugins
  },

  configureTransitions: function(transitions) {
    var i, n, transition, from, to, wildcard = this.defaults.wildcard;
    for(n = 0 ; n < transitions.length ; n++) {
      transition = transitions[n];
      from  = Array.isArray(transition.from) ? transition.from : [transition.from || wildcard]
      to    = transition.to || wildcard;
      for(i = 0 ; i < from.length ; i++) {
        this.mapTransition({ name: transition.name, from: from[i], to: to });
      }
    }
  },

  transitionFor: function(state, transition) {
    var wildcard = this.defaults.wildcard;
    return this.map[state][transition] ||
           this.map[wildcard][transition];
  },

  transitionsFor: function(state) {
    var wildcard = this.defaults.wildcard;
    return Object.keys(this.map[state]).concat(Object.keys(this.map[wildcard]));
  },

  allStates: function() {
    return this.states;
  },

  allTransitions: function() {
    return this.transitions;
  }

});

//-------------------------------------------------------------------------------------------------

module.exports = Config;

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


var mixin      = __webpack_require__(0),
    Exception  = __webpack_require__(6),
    plugin     = __webpack_require__(1),
    UNOBSERVED = [ null, [] ];

//-------------------------------------------------------------------------------------------------

function JSM(context, config) {
  this.context   = context;
  this.config    = config;
  this.state     = config.init.from;
  this.observers = [context];
}

//-------------------------------------------------------------------------------------------------

mixin(JSM.prototype, {

  init: function(args) {
    mixin(this.context, this.config.data.apply(this.context, args));
    plugin.hook(this, 'init');
    if (this.config.init.active)
      return this.fire(this.config.init.name, []);
  },

  is: function(state) {
    return Array.isArray(state) ? (state.indexOf(this.state) >= 0) : (this.state === state);
  },

  isPending: function() {
    return this.pending;
  },

  can: function(transition) {
    return !this.isPending() && !!this.seek(transition);
  },

  cannot: function(transition) {
    return !this.can(transition);
  },

  allStates: function() {
    return this.config.allStates();
  },

  allTransitions: function() {
    return this.config.allTransitions();
  },

  transitions: function() {
    return this.config.transitionsFor(this.state);
  },

  seek: function(transition, args) {
    var wildcard = this.config.defaults.wildcard,
        entry    = this.config.transitionFor(this.state, transition),
        to       = entry && entry.to;
    if (typeof to === 'function')
      return to.apply(this.context, args);
    else if (to === wildcard)
      return this.state
    else
      return to
  },

  fire: function(transition, args) {
    return this.transit(transition, this.state, this.seek(transition, args), args);
  },

  transit: function(transition, from, to, args) {

    var lifecycle = this.config.lifecycle,
        changed   = this.config.options.observeUnchangedState || (from !== to);

    if (!to)
      return this.context.onInvalidTransition(transition, from, to);

    if (this.isPending())
      return this.context.onPendingTransition(transition, from, to);

    this.config.addState(to);  // might need to add this state if it's unknown (e.g. conditional transition or goto)

    this.beginTransit();

    args.unshift({             // this context will be passed to each lifecycle event observer
      transition: transition,
      from:       from,
      to:         to,
      fsm:        this.context
    });

    return this.observeEvents([
                this.observersForEvent(lifecycle.onBefore.transition),
                this.observersForEvent(lifecycle.onBefore[transition]),
      changed ? this.observersForEvent(lifecycle.onLeave.state) : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onLeave[from]) : UNOBSERVED,
                this.observersForEvent(lifecycle.on.transition),
      changed ? [ 'doTransit', [ this ] ]                       : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onEnter.state) : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onEnter[to])   : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.on[to])        : UNOBSERVED,
                this.observersForEvent(lifecycle.onAfter.transition),
                this.observersForEvent(lifecycle.onAfter[transition]),
                this.observersForEvent(lifecycle.on[transition])
    ], args);
  },

  beginTransit: function()          { this.pending = true;                 },
  endTransit:   function(result)    { this.pending = false; return result; },
  failTransit:  function(result)    { this.pending = false; throw result;  },
  doTransit:    function(lifecycle) { this.state = lifecycle.to;           },

  observe: function(args) {
    if (args.length === 2) {
      var observer = {};
      observer[args[0]] = args[1];
      this.observers.push(observer);
    }
    else {
      this.observers.push(args[0]);
    }
  },

  observersForEvent: function(event) { // TODO: this could be cached
    var n = 0, max = this.observers.length, observer, result = [];
    for( ; n < max ; n++) {
      observer = this.observers[n];
      if (observer[event])
        result.push(observer);
    }
    return [ event, result, true ]
  },

  observeEvents: function(events, args, previousEvent, previousResult) {
    if (events.length === 0) {
      return this.endTransit(previousResult === undefined ? true : previousResult);
    }

    var event     = events[0][0],
        observers = events[0][1],
        pluggable = events[0][2];

    args[0].event = event;
    if (event && pluggable && event !== previousEvent)
      plugin.hook(this, 'lifecycle', args);

    if (observers.length === 0) {
      events.shift();
      return this.observeEvents(events, args, event, previousResult);
    }
    else {
      var observer = observers.shift(),
          result = observer[event].apply(observer, args);
      if (result && typeof result.then === 'function') {
        return result.then(this.observeEvents.bind(this, events, args, event))
                     .catch(this.failTransit.bind(this))
      }
      else if (result === false) {
        return this.endTransit(false);
      }
      else {
        return this.observeEvents(events, args, event, result);
      }
    }
  },

  onInvalidTransition: function(transition, from, to) {
    throw new Exception("transition is invalid in current state", transition, from, to, this.state);
  },

  onPendingTransition: function(transition, from, to) {
    throw new Exception("transition is invalid while previous transition is still in progress", transition, from, to, this.state);
  }

});

//-------------------------------------------------------------------------------------------------

module.exports = JSM;

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-----------------------------------------------------------------------------------------------

var mixin    = __webpack_require__(0),
    camelize = __webpack_require__(2),
    plugin   = __webpack_require__(1),
    Config   = __webpack_require__(3),
    JSM      = __webpack_require__(4);

//-----------------------------------------------------------------------------------------------

var PublicMethods = {
  is:                  function(state)       { return this._fsm.is(state)                                     },
  can:                 function(transition)  { return this._fsm.can(transition)                               },
  cannot:              function(transition)  { return this._fsm.cannot(transition)                            },
  observe:             function()            { return this._fsm.observe(arguments)                            },
  transitions:         function()            { return this._fsm.transitions()                                 },
  allTransitions:      function()            { return this._fsm.allTransitions()                              },
  allStates:           function()            { return this._fsm.allStates()                                   },
  onInvalidTransition: function(t, from, to) { return this._fsm.onInvalidTransition(t, from, to)              },
  onPendingTransition: function(t, from, to) { return this._fsm.onPendingTransition(t, from, to)              },
}

var PublicProperties = {
  state: {
    configurable: false,
    enumerable:   true,
    get: function() {
      return this._fsm.state;
    },
    set: function(state) {
      throw Error('use transitions to change state')
    }
  }
}

//-----------------------------------------------------------------------------------------------

function StateMachine(options) {
  return apply(this || {}, options);
}

function factory() {
  var cstor, options;
  if (typeof arguments[0] === 'function') {
    cstor   = arguments[0];
    options = arguments[1] || {};
  }
  else {
    cstor   = function() { this._fsm.apply(this, arguments) };
    options = arguments[0] || {};
  }
  var config = new Config(options, StateMachine);
  build(cstor.prototype, config);
  cstor.prototype._fsm.config = config; // convenience access to shared config without needing an instance
  return cstor;
}

//-------------------------------------------------------------------------------------------------

function apply(instance, options) {
  var config = new Config(options, StateMachine);
  build(instance, config);
  instance._fsm();
  return instance;
}

function build(target, config) {
  if ((typeof target !== 'object') || Array.isArray(target))
    throw Error('StateMachine can only be applied to objects');
  plugin.build(target, config);
  Object.defineProperties(target, PublicProperties);
  mixin(target, PublicMethods);
  mixin(target, config.methods);
  config.allTransitions().forEach(function(transition) {
    target[camelize(transition)] = function() {
      return this._fsm.fire(transition, [].slice.call(arguments))
    }
  });
  target._fsm = function() {
    this._fsm = new JSM(this, config);
    this._fsm.init(arguments);
  }
}

//-----------------------------------------------------------------------------------------------

StateMachine.version  = '3.0.1';
StateMachine.factory  = factory;
StateMachine.apply    = apply;
StateMachine.defaults = {
  wildcard: '*',
  init: {
    name: 'init',
    from: 'none'
  }
}

//===============================================================================================

module.exports = StateMachine;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(message, transition, from, to, current) {
  this.message    = message;
  this.transition = transition;
  this.from       = from;
  this.to         = to;
  this.current    = current;
}


/***/ })
/******/ ]);
});

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _interval_runner = _interopRequireDefault(__webpack_require__(74));
var _default = function _default(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$asynchronous = _ref.asynchronous,
    asynchronous = _ref$asynchronous === void 0 ? false : _ref$asynchronous;
  if (asynchronous) {
    return function (predicate, _temp2) {
      let _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$frequency = _ref2.frequency,
        frequency = _ref2$frequency === void 0 ? 10 : _ref2$frequency,
        _ref2$timeout = _ref2.timeout,
        timeout = _ref2$timeout === void 0 ? 2000 : _ref2$timeout;
      return new Promise((resolve, reject) => {
        let timeoutTimerId;
        const intervalRunner = new _interval_runner.default( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          var tryPredicate, _tryPredicate, resolvedPredicate;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _tryPredicate = function _tryPredicate3() {
                  _tryPredicate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return predicate();
                        case 3:
                          return _context.abrupt("return", _context.sent);
                        case 6:
                          _context.prev = 6;
                          _context.t0 = _context["catch"](0);
                          return _context.abrupt("return", false);
                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee, null, [[0, 6]]);
                  }));
                  return _tryPredicate.apply(this, arguments);
                };
                tryPredicate = function _tryPredicate2() {
                  return _tryPredicate.apply(this, arguments);
                };
                _context2.next = 4;
                return tryPredicate();
              case 4:
                resolvedPredicate = _context2.sent;
                if (resolvedPredicate) {
                  clearTimeout(timeoutTimerId);
                  intervalRunner.stop();
                  resolve();
                }
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })), frequency);
        timeoutTimerId = setTimeout(() => {
          intervalRunner.stop();
          reject(new Error('TIMEOUT'));
        }, timeout);
        intervalRunner.start();
      });
    };
  }
  return function (predicate, _temp3) {
    let _ref4 = _temp3 === void 0 ? {} : _temp3,
      _ref4$frequency = _ref4.frequency,
      frequency = _ref4$frequency === void 0 ? 60 : _ref4$frequency,
      _ref4$timeout = _ref4.timeout,
      timeout = _ref4$timeout === void 0 ? 2000 : _ref4$timeout;
    return new Promise((resolve, reject) => {
      let timeoutTimerId;
      const intervalRunner = new _interval_runner.default(() => {
        function tryPredicate() {
          try {
            return predicate();
          } catch (e) {
            return false;
          }
        }
        if (tryPredicate()) {
          clearTimeout(timeoutTimerId);
          intervalRunner.stop();
          resolve();
        }
      }, frequency);
      timeoutTimerId = setTimeout(() => {
        intervalRunner.stop();
        reject(new Error('TIMEOUT'));
      }, timeout);
      intervalRunner.start();
    });
  };
};
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _shouldUseStandardGetStats = _interopRequireDefault(__webpack_require__(111));
const shouldUseStandardGetStats = (0, _shouldUseStandardGetStats.default)();

// getRtcStatsReport is only supported on browsers that support the standard getStats API.
var _default = shouldUseStandardGetStats;
exports.default = _default;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
// @todo can we test for these?
var _default = () => ['Firefox', 'Safari', 'Edge', 'Chrome', 'Opera'].indexOf(_env.default.name) > -1;
exports.default = _default;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _generate_simple_state_machine = _interopRequireDefault(__webpack_require__(170));
const generateSimpleStateMachine = (0, _generate_simple_state_machine.default)();

// Models a Subscriber's subscribing State
//
// Valid States:
//     NotSubscribing            (the initial state
//     Init                      (basic setup of DOM
//     Connecting                (Failure Cases -> No Route, Bad Offer, Bad Answer
//     BindingRemoteStream       (Failure Cases -> Anything to do with the media being
//                               (invalid, the media never plays
//     Subscribing               (this is 'onLoad'
//     Failed                    (terminal state, with a reason that maps to one of the
//                               (failure cases above
//     Destroyed                 (The subscriber has been cleaned up, terminal state
//
//
// Valid Transitions:
//     NotSubscribing ->
//         Init
//
//     Init ->
//             Connecting
//           | BindingRemoteStream         (if we are subscribing to ourselves and we alreay
//                                         (have a stream
//           | NotSubscribing              (destroy()
//
//     Connecting ->
//             BindingRemoteStream
//           | NotSubscribing
//           | Failed
//           | NotSubscribing              (destroy()
//
//     BindingRemoteStream ->
//             Subscribing
//           | Failed
//           | NotSubscribing              (destroy()
//
//     Subscribing ->
//             NotSubscribing              (unsubscribe
//           | Failed                      (probably a peer connection failure after we began
//                                         (subscribing
//
//     Failed ->
//             Destroyed
//
//     Destroyed ->                        (terminal state)
//
//
// @example
//     var state = new SubscribingState(function(change) {
//       console.log(change.message);
//     });
//
//     state.set('Init');
//     state.current;                 -> 'Init'
//
//     state.set('Subscribing');      -> triggers stateChangeFailed and logs out the error message
//
//
const initialState = 'NotSubscribing';
const validStates = ['NotSubscribing', 'Init', 'Connecting', 'BindingRemoteStream', 'Subscribing', 'Migrating', 'Failed', 'Destroyed'];
const validTransitions = {
  NotSubscribing: ['NotSubscribing', 'Init', 'Destroyed'],
  Init: ['NotSubscribing', 'Connecting', 'BindingRemoteStream', 'Destroyed'],
  Connecting: ['NotSubscribing', 'BindingRemoteStream', 'Failed', 'Destroyed'],
  BindingRemoteStream: ['NotSubscribing', 'Subscribing', 'Failed', 'Destroyed', 'BindingRemoteStream'],
  Subscribing: ['NotSubscribing', 'Migrating', 'Failed', 'Destroyed', 'BindingRemoteStream'],
  Migrating: ['NotSubscribing', 'Subscribing', 'Failed', 'Destroyed', 'BindingRemoteStream'],
  Failed: ['Destroyed'],
  Destroyed: []
};
const SubscribingState = generateSimpleStateMachine(initialState, validStates, validTransitions);
SubscribingState.prototype.isDestroyed = function () {
  return this.current === 'Destroyed';
};
SubscribingState.prototype.isFailed = function () {
  return this.current === 'Failed';
};
SubscribingState.prototype.isSubscribing = function () {
  return this.current === 'Subscribing' || this.current === 'Migrating';
};
SubscribingState.prototype.isMigrating = function () {
  return this.current === 'Migrating';
};
SubscribingState.prototype.isAttemptingToSubscribe = function () {
  return ['Init', 'Connecting', 'BindingRemoteStream'].indexOf(this.current) !== -1;
};
SubscribingState.prototype.isStreamAdded = function () {
  return this.current === 'BindingRemoteStream' || this.isSubscribing();
};
var _default = SubscribingState;
exports.default = _default;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = _ref => {
  let socket = _ref.socket,
    uri = _ref.uri,
    defaultContent = _ref.content;
  return (_ref2, completion) => {
    let method = _ref2.type,
      content = _ref2.content;
    return socket.send({
      message: {
        uri,
        method,
        content: Object.assign({}, defaultContent, content)
      }
    }, completion);
  };
};
exports.default = _default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = (mediaStream, oldTrack, newTrack) => {
  if (oldTrack === newTrack || !oldTrack || !newTrack) {
    return;
  }
  mediaStream.removeTrack(oldTrack);
  mediaStream.addTrack(newTrack);
};
exports.default = _default;

/***/ }),
/* 343 */
/***/ (function(module, exports) {

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

module.exports = _objectDestructuringEmpty;

/***/ }),
/* 344 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// We don't want to use the url if it has the base64 image data
// since it can cause logging to fail
var _default = filter => {
  var _filter$backgroundImg;
  const clonedVideoFilter = Object.assign({}, filter);
  const hasEncodedBackgroundImgUrl = filter == null ? void 0 : (_filter$backgroundImg = filter.backgroundImgUrl) == null ? void 0 : _filter$backgroundImg.includes('base64');
  if (hasEncodedBackgroundImgUrl) {
    delete clonedVideoFilter.backgroundImgUrl;
  }
  return clonedVideoFilter;
};
exports.default = _default;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _mediaProcessor = __webpack_require__(760);
var _mlTransformers = __webpack_require__(184);
// This is copy pasta from @vonage/media-processor, basically.  The only
// difference is their's is an async call, whereas this one is synchronous.
const isSupported = () => typeof MediaStreamTrackProcessor !== 'undefined' && typeof MediaStreamTrackGenerator !== 'undefined';

// Vonage's low-level machine-learning-based media processor libraries
const ML = {
  isSupported,
  setMetadata: _mediaProcessor.setVonageMetadata,
  createProcessor: _mlTransformers.createVonageMediaProcessor
};
var _default = ML;
exports.default = _default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(332));
var _mlTransformers = __webpack_require__(184);
var _env = _interopRequireDefault(__webpack_require__(3));
var _getCdnUrl = _interopRequireDefault(__webpack_require__(348));
const _excluded = ["proxyUrl", "env"];
// Default configuration for @vonage/ml-transformers library
const getDefaultConfig = function getDefaultConfig(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const _deps = deps,
    proxyUrl = _deps.proxyUrl,
    _deps$env = _deps.env,
    env = _deps$env === void 0 ? _env.default : _deps$env,
    libraryOverrideOptions = (0, _objectWithoutPropertiesLoose2.default)(_deps, _excluded);
  const cdnHost = (0, _getCdnUrl.default)({
    env,
    proxyUrl
  });
  return Object.assign({
    modelAssetUriPath: `${cdnHost}/ml-transformers/v6.0.0/float16/vonage_selfie_segmenter.tflite`,
    mediapipeBaseAssetsUri: `${cdnHost}/ml-transformers/v6.0.0/mediapipe/0.10.20`,
    renderingOptions: {
      type: _mlTransformers.RenderingType.CANVAS
    }
  }, libraryOverrideOptions);
};
var _default = getDefaultConfig;
exports.default = _default;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _proxyUrlHelper = _interopRequireDefault(__webpack_require__(106));
var _env = _interopRequireDefault(__webpack_require__(3));
/*
 * Return correct opentok static CDN url given current env and proxy
 * @param {object} deps - dependency object
 *   @property {object} env - Env object containing isProd and isRel boolean fields
 *   @property {string | undefined} proxyUrl - proxyUrl
 * @returns host - CDN host url
 */
const getCdnUrl = deps => {
  const _deps$env = deps.env,
    env = _deps$env === void 0 ? _env.default : _deps$env,
    proxyUrl = deps.proxyUrl;
  let host;
  if (env.isProd) {
    host = 'https://static.opentok.com';
  } else if (env.isRel) {
    host = 'https://static.rel.tokbox.com';
  } else {
    host = 'https://www.dev.tokbox.com';
  }
  if (proxyUrl) {
    if (proxyUrl.includes('euproxy.opentok.com')) {
      host = 'https://static-eu.opentok.com';
    } else {
      host = (0, _proxyUrlHelper.default)(host, proxyUrl);
    }
  }
  return host;
};
var _default = getCdnUrl;
exports.default = _default;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = initPublisherFactory;
var _isFunction = _interopRequireDefault(__webpack_require__(20));
var _isObject = _interopRequireDefault(__webpack_require__(11));
var _log = _interopRequireDefault(__webpack_require__(1));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _isNullOrFalse = _interopRequireDefault(__webpack_require__(778));
var _objects = _interopRequireDefault(__webpack_require__(27));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _setVideoContentHintIfCanvas = _interopRequireDefault(__webpack_require__(779));
var _setScalableScreenshare = _interopRequireDefault(__webpack_require__(780));
var _index = _interopRequireDefault(__webpack_require__(182));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require, max-len,  prefer-rest-params */
/* eslint-disable no-use-before-define */

function initPublisherFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const Errors = deps.Errors || _Errors.default;
  const ExceptionCodes = deps.ExceptionCodes || _exception_codes.default;
  const logging = deps.logging || (0, _log.default)('publisherInit');
  const otError = deps.otError || (0, _otError.default)();
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const Publisher = deps.Publisher || (0, _index.default)();
  const sessionObjects = deps.sessionObjects || _objects.default;

  /**
  * <p class="mSummary">
  *   Initializes and returns a Publisher object. You can then pass this Publisher
  *   object to <code>Session.publish()</code> to publish a stream to a session.
  * </p>
  * <p>
  *   <i>Note:</i> If you intend to reuse a Publisher object to publish to different sessions
  *   (or the same session) sequentially, add an event listener for the <code>streamDestroyed</code>
  *   event dispatched by the Publisher object (when it stops publishing). In the event listener,
  *   call the <code>preventDefault()</code> method of the event object to prevent the Publisher's
  *   video from being removed from the page.
  * </p>
  *
  * @param {Object} targetElement (Optional) The DOM element or the <code>id</code> attribute of the
  * existing DOM element used to determine the location of the Publisher video in the HTML DOM. See
  * the <code>insertMode</code> property of the <code>properties</code> parameter. If you do not
  * specify a <code>targetElement</code>, the application appends a new DOM element to the HTML
  * <code>body</code>.
  *
  * <p>
  *       The application throws an error if an element with an ID set to the
  *       <code>targetElement</code> value does not exist in the HTML DOM.
  * </p>
  *
  * @param {Object} properties (Optional) This object contains the following properties (each of which
  * are optional):
  * </p>
  * <ul>
  * <li>
  *   <strong>audioBitrate</strong> (Number) &#151; The desired bitrate for the published audio,
  *   in bits per second. The supported range of values is 6,000 - 510,000. (Invalid values are
  *   ignored.) Set this value to enable high-quality audio (or to reduce bandwidth usage with
  *   lower-quality audio).
  *   <p>
  *   The following are recommended settings:
  *   <ul>
  *     <li>8,000 - 12,000 for narrowband (NB) speech</li>
  *     <li>16,000 - 20,000 for wideband (WB) speech</li>
  *     <li>28,000 - 40,000 for full-band (FB) speech</li>
  *     <li>48,000 - 64,000 for full-band (FB) music</li>
  *   </ul>
  *   </p>
  *   <p>
  *   The default value is 40,000.
  *   </p>
  *   <p>
  *     Currently, this setting is not supported in streams published in Firefox.
  *   </p>
  * </li>
  * <li>
  *   <strong>audioFallback</strong> (Object) &#151; An object containing properties that defines
  *   whether the stream will use the audio-fallback feature. The <code>audioFallback</code> object includes
  *   the following properties:
  *   <ul>
  *     <li><code>publisher</code> (Boolean) &mdash; Whether the stream will use the
  *     publisher audio-fallback feature (<code>true</code>) or not (default <code>false</code>). The
  *     publisher audio-fallback feature is available in both routed sessions (sessions that uses the
  *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">Vonage Video API Media Router</a>)
  *     and relayed sessions. With the publisher audio-fallback feature enabled, when it is determined
  *     that a Publisher's quality has degraded significantly, it disables the video in that
  *     publisher in order to preserve audio quality. For more information, see the Publisher
  *     <a href="Publisher.html#event:videoDisabled">videoDisabled</a>,
  *     <a href="Publisher.html#event:videoDisableWarning">videoDisableWarning</a>,
  *     <a href="Publisher.html#event:videoDisableWarningLifted">videoDisableWarningLifted</a>, and
  *     <a href="Publisher.html#event:videoEnabled">videoEnabled</a> events.
  *     </li>
  *
  *     <li><code>subscriber</code> (Boolean) &mdash; Whether the stream will use the
  *     subscriber audio-fallback feature (<code>true</code>) or not (<code>false</code>). The
  *     audio-fallback feature is available in sessions that use the Vonage Video API Media Router. With the
  *     audio-fallback feature enabled (the default), when the server determines that a stream's
  *     quality has degraded significantly for a specific subscriber, it disables the video in that
  *     subscriber in order to preserve audio quality. For streams that use a camera as a video
  *     source, the default setting is <code>true</code> (the audio-fallback feature is enabled).
  *     The default setting is <code>false</code> (the audio-fallback feature is disabled) for
  *     screen-sharing streams, which have the <code>videoSource</code> property set to
  *     <code>"application"</code>, <code>"screen"</code>, or <code>"window"</code> in the
  *     <code>OT.initPublisher()</code> options. For more information, see the Subscriber
  *     <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event and
  *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">the Vonage Video API Media
  *     Router and media modes</a>.
  *     </li>
  *   </ul>
  * </li>
  * <li>
  *   <strong>audioFallbackEnabled</strong> (Boolean) &#151; Deprecated. Use the <code>audioFallback.subscriber</code> property of the options object instead.
  *   This property indicates whether the stream will use the
  *   audio-fallback feature (<code>true</code>) or not (<code>false</code>). The audio-fallback
  *   feature is available in sessions that use the Vonage Video API Media Router. With the audio-fallback
  *   feature enabled (the default), when the server determines that a stream's quality has degraded
  *   significantly for a specific subscriber, it disables the video in that subscriber in order to
  *   preserve audio quality. For streams that use a camera as a video source, the default setting is
  *   <code>true</code> (the audio-fallback feature is enabled). The default setting is
  *   <code>false</code> (the audio-fallback feature is disabled) for screen-sharing streams, which
  *   have the <code>videoSource</code> property set to <code>"application"</code>,
  *   <code>"screen"</code>, or <code>"window"</code> in the <code>OT.initPublisher()</code>
  *   options. For more information, see the Subscriber
  *   <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event and
  *   <a href="https://tokbox.com/developer/guides/create-session/#media-mode">the Vonage Video API Media
  *   Router and media modes</a>.
  * </li>
  * <li>
  *   <strong>audioFilter</strong> (Object) &#151; An object containing properties that define the
  *   audio filter to be applied to the Publisher's audio stream. The following
  *   filters are supported:
  * <ul>
  *   <li>
  *     <p>
  *     <em>Advanced noise suppression filter</em> &mdash; Set the <code>type</code> property of the object to
  *     <code>"advancedNoiseSuppression"</code>.
  *     </p>
  *   </li>
  * </ul>
  *   <em>Note:</em> Audio filters are only supported in recent versions of Chrome, Electron, Opera, and Edge.
  *   They are not supported in other (non-Chromium-based) browsers or on iOS. You can check if the client
  *   supports this feature by calling the
  *   <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
  *   <p>
  *   You can change the audio filter by calling the
  *   <a href="Publisher.html#applyAudioFilter">Publisher.applyAudioFilter()</a> method.
  *   You can remove the audio filter by calling the
  *   <a href="Publisher.html#clearAudioFilter">Publisher.clearAudioFilter()</a> method.
  * </li>
  * <li>
  *   <strong>audioSource</strong> (String, MediaStreamTrack, Boolean, or null) &#151;
  *    The ID of the audio input device (such as a
  *    microphone) to be used by the publisher. You can obtain a list of available devices, including
  *    audio input devices, by calling the <a href="#getDevices">OT.getDevices()</a> method. Each
  *    device listed by the method has a unique device ID. If you pass in a device ID that does not
  *    match an existing audio input device, the call to <code>OT.initPublisher()</code> fails with an
  *    error (error code 1500, "Unable to Publish") passed to the completion handler function.
  *    <p>
  *    If you set this property to <code>null</code> or <code>false</code>, the browser does not
  *    request access to the microphone, and no audio is published.
  *    </p>
  *    <p>
  *    You can also set this property to an audio
  *    <a href="https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamTrack">
  *    MediaStreamTrack</a> object. This lets you use the object as the audio source for
  *    the published stream. For example, you can get an array of audio MediaStreamTrack objects
  *    from the <code>audioTracks</code> property of an HTMLMediaElement object. Or you can call
  *    the <code>getLocalStreams()</code> or <code>getRemoteStreams()</code> method of an
  *    RTCPeerConnection object to get an array of MediaStream objects, and then call the
  *    <code>getAudioTracks()</code> method of one of the MediaStream objects to get an audio
  *    MediaStreamTrack object.
  *    </p>
  * </li>
  * <li>
  *   <strong>autoGainControl</strong> (Boolean) &#151; Whether to enable automatic gain control
  *   for the published audio. You may want to set
  *   this to <code>false</code> when publishing high-quality audio (by setting the
  *   <code>audioBitrate</code> property of the <code>OT.initPublisher()</code> options). The
  *   default value is <code>true</code>. This setting is ignored if you set <code>disableAudioProcessing</code>
  *   to <code>true</code> (which disables echo cancellation, automatic gain control, and noise suppression for
  *   the published stream).
  * </li>
  * <li>
  *   <strong>disableAudioInputDeviceManagement</strong> (Boolean) &#151; Whether to disable automatic audio input
  *   device switching. You may want to set
  *   this to <code>true</code> if you want to handle the device management by yourself. <i>Note:</i>
  *   This is an advanced feature. Do not use without first implementing device management for your application.
  *   If you enable this, the audio input device used by the SDK <i>will not</i> be updated when the end user
  *   changes their microphone. The default value is <code>false</code>.
  * </li>
  * <li>
  *   <strong>disableAudioProcessing</strong> (Boolean) &#151; Whether to disable echo cancellation,
  *   automatic gain control, and noise suppression for the published audio. You may want to set
  *   this to <code>true</code> when publishing high-quality audio (by setting the
  *   <code>audioBitrate</code> property of the <code>OT.initPublisher()</code> options). The
  *   default value is <code>false</code>.
  * </li>
  * <li>
  *   <strong>echoCancellation</strong> (Boolean) &#151; Whether to enable echo cancellation
  *   for the published audio. You may want to set
  *   this to <code>false</code> when publishing high-quality audio (by setting the
  *   <code>audioBitrate</code> property of the <code>OT.initPublisher()</code> options). The
  *   default value is <code>true</code>. This setting is ignored if you set <code>disableAudioProcessing</code>
  *   to <code>true</code> (which disables echo cancellation, automatic gain control, and noise suppression for
  *   the published stream).
  * </li>
  * <li>
  *   <strong>enableStereo</strong> (Boolean) &#151; Whether to publish stereo audio. The default
  *   value is <code>false</code>.
  *   <p>
  *   <i>Note:</i> Some browsers (such as Chome 73+) do not support
  *   echo cancellation for stereo audio (see <a target="_blank"
  *   href="https://bugs.chromium.org/p/webrtc/issues/detail?id=10465">this
  *   Chrome issue report</a>).
  * </li>
  * <li>
  *   <strong>enableDtx</strong> (Boolean) &#151; Whether to enable
  *   <a target="_blank" href="https://datatracker.ietf.org/doc/html/rfc7587#section-3.1.3">Opus DTX</a>. The default
  *   value is <code>false</code>. Setting this to <code>true</code> can reduce bandwidth usage
  *   in streams that have long periods of silence.
  * </li>
  * <li>
  *   <strong>facingMode</strong> (String) &#151; The preferred camera position to use for the
  *   video source. Generally, this setting only applies to mobile devices. This can be set to
  *   one of the following values:
  *   <p>
  *     <ul>
  *       <li>
  *         <code>"user"</code> &mdash; The front-facing camera.
  *       </li>
  *       <li>
  *         <code>"environment"</code> &mdash; The back camera.
  *       </li>
  *       <li>
  *         <code>"left"</code> &mdash; The camera facing the user but to the left
  *         (uncommon).
  *       </li>
  *       <li>
  *         <code>"right"</code> &mdash; The camera facing the user but to the right
  *         (uncommon).
  *       </li>
  *     </ul>
  *   </p>
  * </li>
  * <li>
  *   <strong>fitMode</strong> (String) &#151; Determines how the video is displayed if the its
  *     dimensions do not match those of the DOM element. You can set this property to one of the
  *     following values:
  *     <p>
  *     <ul>
  *       <li>
  *         <code>"cover"</code> &mdash; The video is cropped if its dimensions do not match those of
  *         the DOM element. This is the default setting for videos publishing a camera feed.
  *       </li>
  *       <li>
  *         <code>"contain"</code> &mdash; The video is letterboxed if its dimensions do not match
  *         those of the DOM element. This is the default setting for screen-sharing videos.
  *       </li>
  *     </ul>
  * </li>
  * <li>
  *   <strong>frameRate</strong> (Number) &#151; The desired frame rate, in frames per second,
  *   of the video. Valid values are 30, 15, 7, and 1. The published stream will use the closest
  *   value supported on the publishing client. The frame rate can differ slightly from the value
  *   you set, depending on the browser of the client. And the video will only use the desired
  *   frame rate if the client configuration supports it.
  *   <br><br><p>If the publisher specifies a frame rate, the actual frame rate of the video stream
  *   is set as the <code>frameRate</code> property of the Stream object, though the actual frame rate
  *   will vary based on changing network and system conditions. If the developer does not specify a
  *   frame rate, this property is undefined. Also, if the video source is a video MediaStreamTrack
  *   object (see the <code>videoSource</code>), this value is ignored and the frame rate is
  *   defined by the MediaStreamTrack object, which you can get by calling the
  *   <code>getConstraints()</code> method of the MediaStreamTrack object.
  *   </p>
  *   <p>
  *   For sessions that use the Vonage Video API Media Router (sessions with
  *   the <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media mode</a>
  *   set to routed, lowering the frame rate proportionally reduces the maximum bandwidth the stream
  *   uses. However, in sessions with the media mode set to relayed, lowering the frame rate does not
  *   reduce the stream's bandwidth.
  *   </p>
  *   <p>
  *   You can also restrict the frame rate of a Subscriber's video stream. To restrict the frame rate
  *   a Subscriber, call the <code>restrictFrameRate()</code> method of the subscriber, passing in
  *   <code>true</code>.
  *   (See <a href="Subscriber.html#restrictFrameRate">Subscriber.restrictFrameRate()</a>.)
  *   </p>
  * </li>
  * <li>
  *   <strong>height</strong> (Number or String) &#151; The desired initial height of the displayed Publisher
  *   video in the HTML page (default: 198 pixels). You can specify the number of pixels as either
  *   a number (such as 300) or a string ending in "px" (such as "300px"). Or you can specify a
  *   percentage of the size of the parent element, with a string ending in "%" (such as "100%").
  *   <i>Note:</i> To resize the publisher video, adjust the CSS of the publisher's DOM element
  *   (the <code>element</code> property of the Publisher object) or (if the height is specified as
  *   a percentage) its parent DOM element (see
  *   <a href="https://tokbox.com/developer/guides/customize-ui/js/#video_resize_reposition">Resizing
  *   or repositioning a video</a>).
  * </li>
  * <li>
  *   <strong>initials</strong> (String) &#151; The initials for this stream. These initials are
  *   shown as centered, capitalized text in each Publisher and Subscriber view when the video is disabled
  *   and no <code>backgroundImageURI</code> is set. If <code>backgroundImageURI</code> is set, it takes
  *   precedence and is displayed instead of the initials.
  *   <p>
  *   The initials are also set as the <code>initials</code> property of the Stream object.
  *   <p>
  *   Any one or two-character string (of any case) will be acceptable. If invalid initials are used,
  *   then no error will be thrown and initials won't be set.
  * </li>
  * <li>
  *   <strong>insertDefaultUI</strong> (Boolean) &#151; Whether to use the default Vonage Video API UI
  *   (<code>true</code>, the default) or not (<code>false</code>). The default UI element contains
  *   user interface controls, a video loading indicator, and automatic video cropping or
  *   letterboxing, in addition to the video. (If you leave <code>insertDefaultUI</code> set to
  *   <code>true</code>, you can control individual UI settings using the <code>fitMode</code>,
  *   <code>showControls</code>, and <code>style</code> options.)
  *   <p>
  *   If you set this option to <code>false</code>, OpenTok.js does not insert a default UI element
  *   in the HTML DOM, and the <code>element</code> property of the Publisher object is undefined.
  *   Instead, the Publisher object dispatches a
  *   <a href="Publisher.html#event:videoElementCreated">videoElementCreated</a> event when
  *   the <code>video</code> element (or in Internet Explorer the <code>object</code> element
  *   containing the video) is created. The <code>element</code> property of the event object is a
  *   reference to the Publisher's <code>video</code> (or <code>object</code>) element. Add it to
  *   the HTML DOM to display the video.
  *   <p>
  *   Set this option to <code>false</code> if you want to move the Publisher's <code>video</code>
  *   (or <code>object</code>) element in the HTML DOM.
  *   <p>
  *   If you set this to <code>false</code>, do not set the <code>targetElement</code> parameter.
  *   (This results in an error passed into to the <code>OT.initPublisher()</code> callback
  *   function.) To add the video to the HTML DOM, add an event listener for the
  *   <code>videoElementCreated</code> event, and then add the <code>element</code> property of
  *   the event object into the HTML DOM.
  * </li>
  * <li>
  *   <strong>insertMode</strong> (String) &#151; Specifies how the Publisher object will be
  *   inserted in the HTML DOM. See the <code>targetElement</code> parameter. This string can
  *   have the following values:
  *   <p>
  *   <ul>
  *     <li><code>"replace"</code> &#151; The Publisher object replaces contents of the
  *       targetElement. This is the default.</li>
  *     <li><code>"after"</code> &#151; The Publisher object is a new element inserted after
  *       the targetElement in the HTML DOM. (Both the Publisher and targetElement have the
  *       same parent element.)</li>
  *     <li><code>"before"</code> &#151; The Publisher object is a new element inserted before
  *       the targetElement in the HTML DOM. (Both the Publisher and targetElement have the same
  *       parent element.)</li>
  *     <li><code>"append"</code> &#151; The Publisher object is a new element added as a child
  *       of the targetElement. If there are other child elements, the Publisher is appended as
  *       the last child element of the targetElement.</li>
  *   </ul></p>
  * <li>
  *   <strong>maxResolution</strong> (Object) &#151; Sets the maximum resolution to stream.
  *   This setting only applies to when the <code>videoSource</code> property is set to
  *   <code>"application"</code>, <code>"screen"</code>, or <code>"window"</code>
  *   (when the publisher is screen-sharing). The resolution of the
  *   stream will match the captured screen region unless the region is greater than the
  *   <code>maxResolution</code> setting. Set this to an object that has two properties:
  *   <code>width</code> and <code>height</code> (both numbers). The maximum value for each of
  *   the <code>width</code> and <code>height</code> properties is 1920, and the minimum value
  *   is 10.
  * </li>
  * <li>
  *   <strong>mirror</strong> (Boolean) &#151; Whether the publisher's video image
  *   is mirrored in the publisher's page. The default value is <code>true</code>
  *   (the video image is mirrored), except for a screen-sharing video (when the
  *   <code>videoSource</code> property is set to <code>"application"</code>,
  *   <code>"screen"</code>, or <code>"window"</code>
  *   (in which case the default is <code>false</code>). This property
  *   does not affect the display on subscribers' views of the video.
  * </li>
  * <li>
  *   <strong>name</strong> (String) &#151; The name for this stream. The name appears at
  *   the bottom of Subscriber videos. The default value is "" (an empty string). Setting
  *   this to a string longer than 1000 characters results in an runtime exception.
  * </li>
  * <li>
  *   <strong>noiseSuppression</strong> (Boolean) &#151; Whether to enable noise suppression
  *   for the published audio. You may want to set
  *   this to <code>false</code> when publishing high-quality audio (by setting the
  *   <code>audioBitrate</code> property of the <code>OT.initPublisher()</code> options). The
  *   default value is <code>true</code>. This setting is ignored if you set <code>disableAudioProcessing</code>
  *   to <code>true</code> (which disables echo cancellation, automatic gain control, and noise suppression for
  *   the published stream).
  * </li>
  * <li>
  *   <strong>publishAudio</strong> (Boolean) &#151; Whether to initially publish audio
  *   for the stream (default: <code>true</code>). This setting applies when you pass
  *   the Publisher object in a call to the <code>Session.publish()</code> method.
  * </li>
  * <li>
  *   <strong>publishVideo</strong> (Boolean) &#151; Whether to initially publish video
  *   for the stream (default: <code>true</code>). This setting applies when you pass
  *   the Publisher object in a call to the <code>Session.publish()</code> method.
  * </li>
  * <li>
  *   <strong>publishCaptions</strong> (Boolean) &#151; Whether to initially publish captions
  *   for the stream (default: <code>false</code>). This setting applies when you pass
  *   the Publisher object in a call to the <code>Session.publish()</code> method. This property will have
  *   no effect if captions have not been enabled at the session level.
  *   For more information, see the
  *   <a href="https://tokbox.com/developer/guides/live-captions/">Live Captions</a>
  *   developer guide.
  * </li>
  * <li>
  *   <strong>resolution</strong> (String) &#151; The desired resolution of the video. The format
  *   of the string is <code>"widthxheight"</code>, where the width and height are represented in
  *   pixels. Valid values are <code>"1920x1080"</code>, <code>"1280x720"</code>, <code>"640x480"</code>,
  *   and <code>"320x240"</code>. The published video will only use the desired resolution if the
  *   client configuration supports it. Some browsers and clients do not support each of these
  *   resolution settings.
  *   <br><br><p>
  *   The requested resolution of a video stream is set as the <code>videoDimensions.width</code> and
  *   <code>videoDimensions.height</code> properties of the Stream object.
  *   </p>
  *   <p>
  *   If you do not specify a resolution, the browser uses the camera's default resolution.
  *   Most physical cameras have a default resolution of 640x480, but other cameras, in particular
  *   virtual cameras, have different default resolutions. If the client system cannot support
  *   the resolution you request, the stream will use the next largest setting supported.
  *   </p>
  *   <p>
  *   The actual resolution used by the Publisher is returned by the <code>videoHeight()</code> and
  *   <code>videoWidth()</code> methods of the Publisher object. The actual resolution of a
  *   Subscriber video stream is returned by the <code>videoHeight()</code> and
  *   <code>videoWidth()</code> properties of the Subscriber object. These may differ from the values
  *   of the <code>resolution</code> property passed in as the <code>properties</code> property of the
  *   <code>OT.initPublisher()</code> method, if the browser does not support the requested
  *   resolution, this value is ignored. Also, if the video source is a video MediaStreamTrack
  *   object (see the <code>videoSource</code>), this value is ignored and the resolution
  *   is defined by the MediaStreamTrack object, which you can get by calling the
  *   <code>getConstraints()</code> method of the MediaStreamTrack object.
  *   </p>
  * </li>
  * <li>
  *   <strong>scalableScreenshare</strong> (Boolean) &#151; Whether to allow use of
  *   <a href="https://tokbox.com/developer/guides/scalable-video/">scalable video</a>
  *   for a publisher that has the <code>videoSource</code> set to <code>"screen"</code> (<code>true</code>)
  *   or not (<code>false</code>, the default).
  * </li>
  * <li>
  *   <strong>scalableVideo</strong> (Boolean) &#151; Whether to allow (<code>true</code>,
  *   the default) or disable (<code>false</code>)
  *   <a href="https://tokbox.com/developer/guides/scalable-video/">scalable video</a> for the
  *   publisher. This only applies in a routed session (one that uses the
  *   <a href="https://tokbox.com/developer/guides/create-session/#media-mode">Vonage Video API Media Router</a>).
  *   <em>Note:</em> By default, scalable video is disabled in screen-sharing videos. You can set
  *   the <code>scalableScreenshare</code> option to <code>true</code> to enable scalable video
  *   for screen-sharing streams. However, setting <code>scalableVideo</code> to <code>false</code>
  *   disables scalable video for any video source (and the <code>scalableScreenshare</code> setting
  *   is ignored for screen-sharing streams).
  * </li>
  * <li>
  *   <strong>showControls</strong> (Boolean) &#151; Whether to display the built-in user interface
  *   controls (default: <code>true</code>) for the Publisher. These controls include the name
  *   display, the audio level indicator, and the microphone control button. You can turn off all user
  *   interface controls by setting this property to <code>false</code>. You can control the display
  *   of individual user interface controls by leaving this property set to <code>true</code> (the
  *   default) and setting individual properties of the <code>style</code> property.
  * </li>
  * <li>
  *   <strong>style</strong> (Object) &#151; An object containing properties that define the initial
  *   appearance of user interface controls of the Publisher. The <code>style</code> object includes
  *   the following properties:
  *     <ul>
  *       <li><code>audioLevelDisplayMode</code> (String) &mdash; How to display the audio level
  *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
  *       video is disabled), <code>"off"</code> (the indicator is not displayed), and
  *       <code>"on"</code> (the indicator is always displayed).</li>
  *
  *       <li><code>archiveStatusDisplayMode</code> (String) &mdash; How to display the archive status
  *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
  *       session is being recorded), <code>"off"</code> (the indicator is not displayed). If you
  *       disable the archive status display indicator, you can display your own user interface
  *       notifications based on the <code>archiveStarted</code> and <code>archiveStopped</code>
  *       events dispatched by the Session object.</li>
  *
  *       <li><code>backgroundImageURI</code> (String) &mdash; A URI for an image to display as
  *       the background image when a video is not displayed. (A video may not be displayed if
  *       you call <code>publishVideo(false)</code> on the Publisher object). You can pass an http
  *       or https URI to a PNG, JPEG, or non-animated GIF file location. You can also use the
  *       <code>data</code> URI scheme (instead of http or https) and pass in base-64-encrypted
  *       PNG data, such as that obtained from the
  *       <a href="Publisher.html#getImgData">Publisher.getImgData()</a> method. (For example,
  *       you could set the property to a value returned by calling <code>getImgData()</code> on
  *       a previous Publisher object.) If the URL or the image data is invalid, the property
  *       is ignored (the attempt to set the image fails silently).</li>
  *
  *       <li><code>buttonDisplayMode</code> (String) &mdash; How to display the microphone controls
  *       Possible values are: <code>"auto"</code> (controls are displayed when the stream is first
  *       displayed and when the user mouses over the display), <code>"off"</code> (controls are not
  *       displayed), and <code>"on"</code> (controls are always displayed).</li>
  *
  *       <li><code>nameDisplayMode</code> (String) &#151; Whether to display the stream name.
  *       Possible values are: <code>"auto"</code> (the name is displayed when the stream is first
  *       displayed and when the user mouses over the display), <code>"off"</code> (the name is not
  *       displayed), and <code>"on"</code> (the name is always displayed).</li>
  *
  *       <li><code>videoDisabledDisplayMode</code> (String) &#151; Whether to display the video
  *       disabled indicator and video disabled warning icons for the Publisher. These icons
  *       indicate that the video has been disabled (or is at risk of being disabled for
  *       the warning icon) due to poor stream quality. This style only applies to the Publisher
  *       object. Possible values are: <code>"auto"</code> (the icons are automatically when the
  *       displayed video is disabled or at risk of being disabled due to poor stream quality),
  *       <code>"off"</code> (do not display the icons), and <code>"on"</code> (display the
  *       icons). The default setting is <code>"auto"</code>.
  *       </li>
  *   </ul>
  * </li>
  * <li>
  *   <strong>videoContentHint</strong> (String) &#151; Sets the content hint of
  *    the the video track of the publisher's stream. This allows browsers to use encoding
  *    or processing methods more appropriate to the type of content. You can set this to one of
  *    the following values:
  *    <p>
  *    <ul>
  *      <li>
  *        <code>""</code> &mdash; No hint is provided (the default).
  *      </li>
  *      <li>
  *        <code>"motion"</code> &mdash; The track should be treated as if it contains video
  *        where motion is important. For example, you may use this setting for a screen-sharing
  *        stream that contains video.
  *      </li>
  *      <li>
  *        <code>"detail"</code> &mdash; The track should be treated as if video details
  *        are extra important. For example, you may use this setting for a screen-sharing
  *        stream that contains text content, painting, or line art.
  *      </li>
  *      <li>
  *        <code>"text"</code> &mdash; The track should be treated as if text details are
  *        extra important. For example, you may use this setting for a screen-sharing
  *        stream that contains text content.
  *      </li>
  *    </ul>
  *    </p>
  *    <p>
  *      With the &quot;text&quot; and &quot;detailed&quot; content hints, the browser attempts to maintain
  *      high resolution, even if it must reduce the video frame rate. For the &quot;motion&quot; content hint,
  *      the browser reduces resolution to prevent the frame rate from stalling.
  *    </p>
  *    <p>
  *    You can read more about these options in the
  *    <a href="https://www.w3.org/TR/mst-content-hint/#video-content-hints">W3C Working Draft</a>.
  *    You may want to set the video content hint to optimize performance for screen-sharing
  *    videos. For example, you can set it to <code>"text"</code> when sharing a screen that contains
  *    a lot of text (such as a slideshow).
  *    </p>
  *    <p>
  *    Chrome 60+, Safari 12.1+, Edge 79+, and Opera 47+ support video content hints.
  *    </p>
  *    <p>
  *      Also see the <a href="Publisher.html#setVideoContentHint">Publisher.setVideoContentHint()</a> method
  *      and the <a href="https://tokbox.com/developer/guides/publish-stream/js/#video-content-hint">developer
  *      guide topic on this feature</a>.
  *    </p>
  * </li>
  * <li>
  *   <strong>videoFilter</strong> (Object) &#151; An object containing properties that define the
  *   video filter to be applied to the Publisher's video stream. The following
  *   filters are supported:
  *   <ul>
  *     <li>
  *       <p>
  *       <em>Background blur filter</em> &mdash; Set the <code>type</code> property of the object to
  *       <code>"backgroundBlur"</code>.
  *       <p>
  *       A background blur filter object includes an additional <code>blurStrength</code> property, which
  *       defines the blur radius and is optional. Set this to either <code>"low"</code> or
  *       <code>"high"</code> (the default).
  *     </li>
  *     <li>
  *       <p>
  *       <em>Background replacement filter</em> &mdash; Set the <code>type</code> property of the object to
  *       <code>"backgroundReplacement"</code>.
  *       <p>
  *       A background replacement filter object includes an additional <code>backgroundImgUrl</code>
  *       property, which defines the URL of the background image to use. Also accepted are image BLOBs
  *       (a Base64-encoded string of image data).
  *       The following image formats are supported: BMP, PNG, JPEG, and GIF.
  *       <p>
  *       <p>
  *         The background image is resized to match the dimensions of the publisher's video.
  *         For best results, use an image that has the same dimensions (or at least the same
  *         aspect ratio) as the published video. Set the <code>mirror</code> option to
  *         <code>false</code> when calling the <code>OT.initPublisher()</code> method to have
  *         the background image appear in the correct orientation (not mirrored) in
  *         the publisher's page.
  *       </p>
  *     </li>
  *   </ul>
  *   <em>Note:</em> Video filters are only supported in recent versions of Chrome, Electron, Opera, and Edge.
  *   They are not supported in other (non-Chromium-based) browsers or on iOS. You can check if the client
  *   supports this feature by calling the
  *   <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
  *   <p>
  *   You can change the video filter by calling the
  *   <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a> method.
  *   You can remove the video filter by calling the
  *   <a href="Publisher.html#clearVideoFilter">Publisher.clearVideoFilter()</a> method.
  * </li>
  * <li>
  *   <strong>videoSource</strong> (String, MediaStreamTrack, Boolean, or null) &#151;
  *    The ID of the video input device (such as a
  *    camera) to be used by the publisher. You can obtain a list of available devices, including
  *    video input devices, by calling the <a href="#getDevices">OT.getDevices()</a> method. Each
  *    device listed by the method has a unique device ID. If you pass in a device ID that does not
  *    match an existing video input device, the call to <code>OT.initPublisher()</code> fails with an
  *    error (error code 1500, "Unable to Publish") passed to the completion handler function.
  *    <p>
  *    If you set this property to <code>null</code> or <code>false</code>, the browser does not
  *    request access to the camera, and no video is published. In a voice-only call, set this
  *    property to <code>null</code> or <code>false</code> for each Publisher.
  *    </p>
  *   <p>
  *    To publish a screen-sharing stream, set this property to <code>"screen"</code>.
  *    In older browser versions, you could also pass in <code>"application"</code> or
  *    <code>"window"</code> to specify a type of screen-sharing source. However, in current
  *    browsers that support screen sharing, passing in any of these values results in
  *    the same behavior &mdash; the browser displays a dialog box in which the end user
  *    selects the screen-sharing source (which can be the entire screen or a specific window).
  *    In Electron, screen sharing captures the entire screen, without prompting
  *    the user for permission. For screen-sharing streams, the following are
  *    default values for other properties: <code>audioFallbackEnabled == false</code>,
  *    <code>maxResolution == {width: 1920, height: 1920}</code>, <code>mirror == false</code>,
  *    <code>scaleMode == "fit"</code>. Also, the default <code>scaleMode</code> setting for
  *    subscribers to the stream is <code>"fit"</code>. In Safari, initializing a screen-sharing
  *    publisher without a user gesture handler may throw an <code>InvalidAccessError</code> error.
  *   </p>
  *   <p>
  *    You can also set this property to a video
  *    <a href="https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamTrack">
  *    MediaStreamTrack</a> object. This lets you use the MediaStreamTrack object as the
  *    video source for the published stream. For example, you can get a CanvasCaptureMediaStream
  *    object by calling the <code>captureStream()</code> method of a HTMLCanvasElement, and then
  *    you can call the <code>getVideoTracks()</code> method of the CanvasCaptureMediaStream object
  *    to get a video MediaStreamTrack object. Or you can get an array of video MediaStreamTrack
  *    object from the <code>videoTracks</code> property of an HTMLMediaElement object. Or you can
  *    call the <code>getLocalStreams()</code> or <code>getRemoteStreams()</code> method of an
  *    RTCPeerConnection object to get an array of MediaStream objects, and then call the
  *    <code>getVideoTracks()</code> method of one of the MediaStream objects to get an array
  *    of video MediaStreamTrack objects. Note that by default the publisher uses a microphone
  *    as the audio source, so be sure to set the <code>audioSource</code> option if you want
  *    to use a MediaStreamTrack as the audio source or if you do not want to publish an audio
  *    track. The default <code>mirror</code> setting for a Publisher with a MediaStreamTrack video
  *    source is <code>false</code>. You can also call
  *    <a href="OT.html#getUserMedia">OT.getUserMedia()</a> to get a MediaStream object that uses
  *    the microphone and camera as the audio and video sources.
  *   </p>
  * </li>
  * <li>
  *   <strong>width</strong> (Number or String) &#151; The desired initial width of the displayed Publisher
  *   video in the HTML page (default: 264 pixels). You can specify the number of pixels as either
  *   a number (such as 400) or a string ending in "px" (such as "400px"). Or you can specify a
  *   percentage of the size of the parent element, with a string ending in "%" (such as "100%").
  *   <i>Note:</i> To resize the publisher video, adjust the CSS of the publisher's DOM element
  *   (the <code>element</code> property of the Publisher object) or (if the width is specified as
  *   a percentage) its parent DOM element (see
  *   <a href="https://tokbox.com/developer/guides/customize-ui/js/#video_resize_reposition">Resizing
  *   or repositioning a video</a>).
  * </li>
  * </ul>
  * @param {Function} completionHandler (Optional) A function to be called when the method succeeds
  * or fails in initializing a Publisher object. This function takes one parameter &mdash;
  * <code>error</code>. On success, the <code>error</code> object is set to <code>null</code>. On
  * failure, the <code>error</code> object has two properties: <code>code</code> (an integer) and
  * <code>message</code> (a string), which identify the cause of the failure. The method succeeds
  * when the user grants access to the camera and microphone. The method fails if the user denies
  * access to the camera and microphone. The <code>completionHandler</code> function is called
  * before the Publisher dispatches an <code>accessAllowed</code> (success) event or an
  * <code>accessDenied</code> (failure) event.
  * <p>
  * The following code adds a <code>completionHandler</code> when calling the
  * <code>OT.initPublisher()</code> method:
  * </p>
  * <pre>
  * var publisher = OT.initPublisher('publisher', null, function (error) {
  *   if (error) {
  *     console.log(error);
  *   } else {
  *     console.log("Publisher initialized.");
  *   }
  * });
  * </pre>
  *
  * @returns {Publisher} The Publisher object.
  * @see <a href="Session.html#publish">Session.publish()</a>
  * @method OT.initPublisher
  * @memberof OT
  */
  return function initPublisher(targetElement, properties, completionHandler) {
    logging.debug(`OT.initPublisher(${targetElement})`);

    // To support legacy (apikey, targetElement, properties) users
    // we check to see if targetElement is actually an apikey. Which we ignore.
    if (typeof targetElement === 'string' && !document.getElementById(targetElement)) {
      targetElement = properties;
      properties = completionHandler;
      completionHandler = arguments[3];
    }
    if (typeof targetElement === 'function') {
      completionHandler = targetElement;
      properties = undefined;
      targetElement = undefined;
    } else if ((0, _isObject.default)(targetElement) && !OTHelpers.isElementNode(targetElement)) {
      completionHandler = properties;
      properties = targetElement;
      targetElement = undefined;
    }
    if (typeof properties === 'function') {
      completionHandler = properties;
      properties = undefined;
    }
    let errMsg;
    if (properties) {
      if (!(0, _isObject.default)(properties)) {
        errMsg = 'properties argument to Publisher constructor, if provided, should be an object';
        properties = undefined;
      } else if (properties.insertDefaultUI === false && targetElement) {
        errMsg = 'You cannot specify a target element if insertDefaultUI is false';
      } else if ((0, _isNullOrFalse.default)(properties.audioSource) && (0, _isNullOrFalse.default)(properties.videoSource)) {
        errMsg = 'You cannot specify both audioSource and videoSource as null or false';
      }
    }
    (0, _setVideoContentHintIfCanvas.default)(properties);
    (0, _setScalableScreenshare.default)(properties);
    const publisher = new Publisher(properties || {});
    sessionObjects.publishers.add(publisher);
    const triggerCallback = function triggerCallback() {
      if (completionHandler && (0, _isFunction.default)(completionHandler)) {
        completionHandler(...arguments);
        completionHandler = undefined;
      }
    };
    if (errMsg !== undefined) {
      logging.error(errMsg);
      triggerCallback(otError(Errors.INVALID_PARAMETER, new Error(errMsg), ExceptionCodes.INVALID_PARAMETER));
    }
    const removeInitSuccessAndCallComplete = function removeInitSuccessAndCallComplete(err) {
      publisher.off('publishComplete', removeHandlersAndCallComplete);
      triggerCallback(err);
    };
    let removeHandlersAndCallComplete = function removeHandlersAndCallComplete(err) {
      publisher.off('initSuccess', removeInitSuccessAndCallComplete);

      // We're only handling the error case here as we're just
      // initing the publisher, not actually attempting to publish.
      if (err) {
        triggerCallback(err);
      }
    };
    publisher.once('initSuccess', removeInitSuccessAndCallComplete);
    publisher.once('publishComplete', removeHandlersAndCallComplete);
    publisher.publish(targetElement);
    return publisher;
  };
}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = SessionFactory;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _events = _interopRequireDefault(__webpack_require__(12));
var _assign = _interopRequireDefault(__webpack_require__(9));
var _findKey = _interopRequireDefault(__webpack_require__(781));
var _isFunction = _interopRequireDefault(__webpack_require__(20));
var _isObject = _interopRequireDefault(__webpack_require__(11));
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _interval_runner = _interopRequireDefault(__webpack_require__(74));
var _convertAnvilErrorCode = _interopRequireDefault(__webpack_require__(783));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _proxyUrlHelper = _interopRequireDefault(__webpack_require__(106));
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _analytics = _interopRequireDefault(__webpack_require__(31));
var _promisify = _interopRequireDefault(__webpack_require__(175));
var _testRemovingVideoCodecs = _interopRequireDefault(__webpack_require__(784));
var _validateIceConfig = _interopRequireDefault(__webpack_require__(785));
var _hasE2eeCapability = _interopRequireDefault(__webpack_require__(115));
var _hasIceRestartsCapability = _interopRequireDefault(__webpack_require__(351));
var _objects = _interopRequireDefault(__webpack_require__(27));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _shouldUseSinglePeerConnection = _interopRequireDefault(__webpack_require__(786));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _forceMuteErrors = _interopRequireDefault(__webpack_require__(789));
var _proxyUrl = __webpack_require__(72);
var _validateSecret = _interopRequireDefault(__webpack_require__(790));
var _parseIceServers = __webpack_require__(110);
var _api_key = _interopRequireDefault(__webpack_require__(73));
var _capabilities = _interopRequireDefault(__webpack_require__(185));
var _convertRumorError = _interopRequireDefault(__webpack_require__(352));
var _events2 = _interopRequireDefault(__webpack_require__(18));
var _stream = _interopRequireDefault(__webpack_require__(186));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _publisher = _interopRequireDefault(__webpack_require__(182));
var _RaptorSocket = _interopRequireDefault(__webpack_require__(791));
var _SessionDispatcher = _interopRequireDefault(__webpack_require__(359));
var _tag = _interopRequireDefault(__webpack_require__(358));
var _subscriber = _interopRequireDefault(__webpack_require__(331));
var _system_requirements = _interopRequireDefault(__webpack_require__(163));
var _getSessionInfo = _interopRequireDefault(__webpack_require__(815));
var _SessionInfo = _interopRequireDefault(__webpack_require__(152));
var _keyStore = _interopRequireDefault(__webpack_require__(818));
var _sframeClientStore = _interopRequireDefault(__webpack_require__(819));
var _init = _interopRequireDefault(__webpack_require__(349));
var _StaticConfig = _interopRequireDefault(__webpack_require__(48));
var _singlePeerConnectionController = _interopRequireDefault(__webpack_require__(824));
var _socketCloseCodes = _interopRequireDefault(__webpack_require__(79));
var _cpuPressureMonitor = _interopRequireDefault(__webpack_require__(834));
var _migrationTimeout = _interopRequireDefault(__webpack_require__(835));
/* eslint-disable no-param-reassign, global-require, func-names */
/* eslint-disable max-len */

const StaticConfigDefault = (0, _StaticConfig.default)();
function SessionFactory(deps) {
  var _global;
  if (deps === void 0) {
    deps = {};
  }
  const adaptIceServers = deps.adaptIceServers || _parseIceServers.adaptIceServers;
  /** @type {AnalyticsHelper} */
  const AnalyticsHelper = deps.AnalyticsHelper || _analytics.default;
  const APIKEY = deps.APIKEY || _api_key.default;
  const Capabilities = deps.Capabilities || _capabilities.default;
  const convertRumorError = deps.convertRumorError || _convertRumorError.default;
  const errors = deps.Errors || _Errors.default;
  const Events = deps.Events || (0, _events2.default)();
  const Stream = deps.Stream || _stream.default;
  const ExceptionCodes = deps.ExceptionCodes || _exception_codes.default;
  const hasIceRestartsCapability = deps.hasIceRestartsCapability || _hasIceRestartsCapability.default;
  const hasE2eeCapability = deps.hasE2eeCapability || _hasE2eeCapability.default;
  const logging = deps.logging || (0, _log.default)('Session');
  const otError = deps.otError || (0, _otError.default)();
  const OTErrorClass = deps.OTErrorClass || _ot_error_class.default;
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const PressureObserver = deps.PressureObserver || ((_global = (typeof window !== undefined ? window : global)) == null ? void 0 : _global.PressureObserver);

  /** @type {typeof StaticConfigDefault} */
  const StaticConfig = deps.StaticConfig || StaticConfigDefault;

  /** @type {StaticConfigDefault} */
  const localStaticConfig = deps.staticConfig || StaticConfig.onlyLocal();
  const Publisher = deps.Publisher || (0, _publisher.default)();
  const RaptorSocket = deps.RaptorSocket || (0, _RaptorSocket.default)();
  const SessionDispatcher = deps.SessionDispatcher || _SessionDispatcher.default;
  const sessionObjects = deps.sessionObjects || _objects.default;
  const sessionTag = deps.sessionTag || _tag.default;
  const socketCloseCodes = deps.socketCloseCodes || _socketCloseCodes.default;
  const Subscriber = deps.Subscriber || (0, _subscriber.default)();
  const systemRequirementsFactory = deps.systemRequirementsFactory || _system_requirements.default;
  const uuid = deps.uuid || _uuid.default;
  const validateIceConfig = (0, _validateIceConfig.default)({
    otError
  });
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  const getSessionInfo = deps.getSessionInfo || (0, _getSessionInfo.default)();
  const KeyStore = deps.KeyStore || _keyStore.default;
  const SFrameClientStore = deps.SFrameClientStore || (0, _sframeClientStore.default)();
  const SinglePeerConnectionController = deps.SinglePeerConnectionController || _singlePeerConnectionController.default;
  const initPublisher = deps.initPublisher || (0, _init.default)({
    Publisher
  });

  /**
   * The Session object returned by the <code>OT.initSession()</code> method provides access to
   * much of the Vonage Video API functionality.
   *
   * @class Session
   * @augments EventDispatcher
   *
   * @property {Capabilities} capabilities A {@link Capabilities} object that includes information
   * about the capabilities of the client. All properties of the <code>capabilities</code> object
   * are undefined until you have connected to a session and the completion handler for the
   * <code>Session.connect()</code> method has been called without error.
   * @property {Connection} connection The {@link Connection} object for this session. The
   * connection property is only available once the completion handler for the
   * <code>Session.connect()</code> method has been called successfully. See the
   * <a href="#connect">Session.connect()</a> method and the {@link Connection} class.
   * @property {String} sessionId The session ID for this session. You pass this value into the
   * <code>OT.initSession()</code> method when you create the Session object. (Note: a Session
   * object is not connected to the Vonage Video API server until you call the connect() method of the
   * object and its completion handler is called without error. See the
   * <a href="OT.html#initSession">OT.initSession()</a> and
   * the <a href="#connect">Session.connect()</a>
   * methods.) For more information on sessions and session IDs, see
   * <a href="https://tokbox.com/developer/guides/create-session/">Session creation</a>.
   */

  const Session = function Session(apiKey, sessionId, _temp) {
    var _this = this;
    let _ref = _temp === void 0 ? {} : _temp,
      iceConfig = _ref.iceConfig,
      connectionEventsSuppressed = _ref.connectionEventsSuppressed,
      _ref$ipWhitelist = _ref.ipWhitelist,
      ipWhitelist = _ref$ipWhitelist === void 0 ? false : _ref$ipWhitelist,
      initialEncryptionSecret = _ref.encryptionSecret,
      _ref$singlePeerConnec = _ref.singlePeerConnection,
      singlePeerConnection = _ref$singlePeerConnec === void 0 ? false : _ref$singlePeerConnec,
      _ref$_prioritizeVP = _ref._prioritizeVP9,
      _prioritizeVP9 = _ref$_prioritizeVP === void 0 ? false : _ref$_prioritizeVP,
      _ref$sessionMigration = _ref.sessionMigration,
      sessionMigration = _ref$sessionMigration === void 0 ? false : _ref$sessionMigration;
    this.MIGRATION_TIMEOUT = _migrationTimeout.default;
    const proxyUrl = (0, _proxyUrl.getProxyUrl)();

    /** @type AnalyticsHelperDefault */
    const analytics = new AnalyticsHelper();
    const getStream = stream => typeof stream === 'string' ? this.streams.get(stream) || {
      id: stream
    } : stream;
    (0, _eventing.default)(this);
    this._tag = sessionTag;

    // Check that the client meets the minimum requirements, if they don't the upgrade
    // flow will be triggered.
    const systemRequirements = systemRequirementsFactory();
    if (!systemRequirements.check()) {
      systemRequirements.upgrade();
    }
    if (sessionId == null) {
      sessionId = apiKey;
      apiKey = null;
    }
    validateIceConfig(iceConfig);
    this.id = sessionId;
    this.sessionId = sessionId;
    this.keyStore = new KeyStore();
    this.sFrameClientStore = new SFrameClientStore();
    let _socket;
    const _sockets = {};
    let _messagingUrl;

    /** @type IntervalRunner | undefined */
    let _connectivityAttemptPinger;
    let _token;
    let _p2p;
    let _messagingServer;
    let _attemptStartTime;
    let _configurationAttemptStartTime;
    let _iceServerDetails;
    let _isSocketReconnecting = false;
    let _apiKey = apiKey;
    const _session = this;
    let _sessionId = sessionId;
    let _connectionId = uuid();
    let _logging = logging;
    let _muteOnEntry = false;
    const _subscribersQueue = [];
    let _subscribersQueueInterval = null;
    let _e2eeSecretSet = false;
    let _useSinglePeerConnection;
    let encryptionSecret = initialEncryptionSecret;
    let _activeStreams = [];
    let disconnectComponents;
    let reset;
    let destroyPublishers;
    let destroySubscribers;
    const setState = OTHelpers.statable(this, ['disconnected', 'connecting', 'connected', 'migrating', 'disconnecting'], 'disconnected');
    this.connection = null;
    this.connections = new OTHelpers.Collection();
    this.streams = new OTHelpers.Collection();
    this.archives = new OTHelpers.Collection();
    let cpuPressureMonitor;
    let _cpuPerformanceState;
    if (PressureObserver) {
      cpuPressureMonitor = new _cpuPressureMonitor.default();
      cpuPressureMonitor.initMonitoring(PressureObserver);
      cpuPressureMonitor.startMonitoring();
      cpuPressureMonitor.on('pressureMonitorEvent', newState => {
        _cpuPerformanceState = newState;
        this.dispatchEvent(new Events.CpuPerformanceChangedEvent(newState));
      });
    }

    //--------------------------------------
    //  MESSAGE HANDLERS
    //--------------------------------------

    /*
     * The sessionConnectFailed event handler
     * @param {Error}
     */
    const sessionConnectFailed = function sessionConnectFailed(error) {
      setState('disconnected');
      if (!error.code) {
        error.code = ExceptionCodes.CONNECT_FAILED;
      }
      _logging.error(`${error.name || 'Unknown Error'}: ${error.message}`);
      OTErrorClass.handleJsException({
        error,
        target: this,
        analytics
      });
      this.trigger('sessionConnectFailed', error);
    };
    const sessionDisconnectedHandler = function sessionDisconnectedHandler(event) {
      _isSocketReconnecting = false;
      const reason = event.reason;
      this.logEvent('Connect', 'Disconnected', {
        reason: event.reason
      });
      const publicEvent = new Events.SessionDisconnectEvent('sessionDisconnected', reason.replace('networkTimedout', 'networkDisconnected'));
      if (this.isConnected()) {
        this.disconnect();
      }
      reset();
      disconnectComponents.call(this, reason);
      setTimeout(() => {
        this.dispatchEvent(publicEvent);

        // Although part of the defaultAction for sessionDisconnected we have
        // chosen to still destroy Publishers within the session as there is
        // another mechanism to stop a Publisher from being destroyed.

        // Publishers use preventDefault on the Publisher streamDestroyed event
        destroyPublishers.call(this, publicEvent.reason);
        if (!publicEvent.isDefaultPrevented()) {
          destroySubscribers.call(this, publicEvent.reason);
        }
      });
    };
    const connectionCreatedHandler = function connectionCreatedHandler(connection) {
      // With connectionEventsSuppressed, connections objects are still added internally, but they
      // don't come from rumor messages, and can't have corresponding delete events, so we don't
      // emit created events.
      if (connectionEventsSuppressed) {
        return;
      }

      // We don't broadcast events for the symphony connection
      if (connection.id.match(/^symphony\./)) {
        return;
      }
      this.dispatchEvent(new Events.ConnectionEvent(_eventNames.default.CONNECTION_CREATED, connection));
    };
    const connectionDestroyedHandler = function connectionDestroyedHandler(connection, reason) {
      // We don't broadcast events for the symphony connection
      if (connection.id.match(/^symphony\./)) {
        return;
      }

      // Don't delete the connection if it's ours. This only happens when
      // we're about to receive a session disconnected and session disconnected
      // will also clean up our connection.
      if (_socket && connection.id === _socket.id()) {
        return;
      }
      this.dispatchEvent(new Events.ConnectionEvent(_eventNames.default.CONNECTION_DESTROYED, connection, reason));
    };
    const streamCreatedHandler = function streamCreatedHandler(stream) {
      if (stream && stream.connection && (!this.connection || stream.connection.id !== this.connection.id)) {
        if (this.is('migrating') && _activeStreams.includes(stream.id)) {
          const _sessionObjects$subsc = sessionObjects.subscribers.where({
              streamId: stream.id
            }),
            subscriber = _sessionObjects$subsc[0];
          subscriber == null ? void 0 : subscriber._.startMigration();
        } else {
          _activeStreams.push(stream.id);
          this.dispatchEvent(new Events.StreamEvent(_eventNames.default.STREAM_CREATED, stream, null, false));
        }
      }
    };
    const streamPropertyModifiedHandler = function streamPropertyModifiedHandler(event) {
      const stream = event.target;
      const propertyName = event.changedProperty;
      let newValue = event.newValue;
      if (propertyName === 'videoDisableWarning' || propertyName === 'audioDisableWarning') {
        return; // These are not public properties, skip top level event for them.
      }

      if (propertyName === 'videoDimensions') {
        newValue = {
          width: newValue.width,
          height: newValue.height
        };
      }
      this.dispatchEvent(new Events.StreamPropertyChangedEvent(_eventNames.default.STREAM_PROPERTY_CHANGED, stream, propertyName, event.oldValue, newValue));
    };
    const streamDestroyedHandler = function streamDestroyedHandler(stream, reason) {
      if (reason === void 0) {
        reason = 'clientDisconnected';
      }
      _activeStreams = _activeStreams.filter(activeStream => activeStream !== stream.id);
      const event = new Events.StreamEvent('streamDestroyed', stream, reason, true);
      const disconnectAndDestroySubscribers = () => {
        // If we are subscribed to any of the streams we should unsubscribe
        sessionObjects.subscribers.where({
          streamId: stream.id
        }).filter(subscriber => subscriber.session.id === this.id && subscriber.stream).forEach(subscriber => {
          subscriber._disconnect({
            reason
          });
          if (!event.isDefaultPrevented()) {
            subscriber._destroy({
              reason,
              noStateTransition: true
            });
          }
        });
      };

      // if the stream is one of ours we delegate handling to the publisher itself.
      if (stream.connection.id === this.connection.id) {
        sessionObjects.publishers.where({
          streamId: stream.id
        }).forEach(function (publisher) {
          publisher._.unpublishStreamFromSession(stream, this, reason);
        }, this);
      } else {
        // The streamDestroyed event is only dispatched by the session when the stream is not one of ours.
        // In the case the stream is ours, the streamDestroyed is dispatched by the publisher.
        this.dispatchEvent(event);
      }
      disconnectAndDestroySubscribers();

      // @TODO Add a else with a one time warning that this no longer cleans up the publisher
    };

    const archiveCreatedHandler = function archiveCreatedHandler(archive) {
      this.dispatchEvent(new Events.ArchiveEvent('archiveStarted', archive));
    };
    const archiveDestroyedHandler = function archiveDestroyedHandler(archive) {
      this.dispatchEvent(new Events.ArchiveEvent('archiveDestroyed', archive));
    };
    const archiveUpdatedHandler = function archiveUpdatedHandler(event) {
      const archive = event.target;
      const propertyName = event.changedProperty;
      const newValue = event.newValue;
      if (propertyName === 'status' && newValue === 'stopped') {
        this.dispatchEvent(new Events.ArchiveEvent('archiveStopped', archive));
      } else {
        this.dispatchEvent(new Events.ArchiveEvent('archiveUpdated', archive));
      }
    };

    // OPENTOK-42152: When a GSM call is ended, the subscribers might have an issue
    // in which a black frame is displayed instead of video.
    // A workaround is to pause and play the subscriber's video element.
    const gsmCallEndedHandler = () => sessionObjects.subscribers.forEach(subscriber => subscriber._.pauseAndPlayVideoElement());
    const init = function init() {
      _session.token = null;
      _token = null;
      setState('disconnected');
      _socket = null;
      if (_connectivityAttemptPinger) {
        _connectivityAttemptPinger.stop();
        _connectivityAttemptPinger = null;
      }
      _session.connection = null;
      _session.capabilities = new Capabilities([], {
        hasE2eeCapability
      });
      _session.connections.destroy();
      _session.streams.destroy();
      _session.archives.destroy();
    };

    // Put ourselves into a pristine state
    reset = function reset() {
      // reset connection id now so that following calls to testNetwork and connect will share
      // the same new session id. We need to reset here because testNetwork might be call after
      // and it is always called before the session is connected
      // on initial connection we don't reset
      _connectionId = uuid();
      init();
    };
    disconnectComponents = function disconnectComponents(reason) {
      sessionObjects.publishers.where({
        session: this
      }).forEach(publisher => {
        publisher.disconnect(reason);
      });
      sessionObjects.subscribers.where({
        session: this
      }).forEach(subscriber => {
        subscriber._disconnect();
      });
    };
    destroyPublishers = function destroyPublishers(reason) {
      sessionObjects.publishers.where({
        session: this
      }).forEach(publisher => {
        publisher._.streamDestroyed(reason);
      });
    };
    destroySubscribers = function destroySubscribers(reason) {
      sessionObjects.subscribers.where({
        session: this
      }).forEach(subscriber => {
        subscriber._destroy({
          reason
        });
      });
    };
    const setSessionInfo = sessionInfo => {
      this.sessionInfo = sessionInfo;
      this._.setIceServers(this.sessionInfo.iceServers);
      _p2p = sessionInfo.p2pEnabled;
      _messagingServer = sessionInfo.messagingServer;
      const sessionInfoSuccessLogPayload = {
        features: {
          reconnection: sessionInfo.reconnection,
          renegotiation: hasIceRestartsCapability() && sessionInfo.renegotiation,
          simulcast: sessionInfo.simulcast === undefined ? false : sessionInfo.simulcast && OTHelpers.env.name === 'Chrome'
        }
      };
      if (proxyUrl) {
        sessionInfoSuccessLogPayload.proxyUrl = proxyUrl;
      }
      this.logEvent('SessionInfo', 'Success', null, sessionInfoSuccessLogPayload, {
        messagingServer: sessionInfo.messagingServer
      });
      const overrides = this.staticConfig.sessionInfoOverrides || {};
      if (_prioritizeVP9) {
        overrides.priorityVideoCodec = 'vp9';
      }
      if (overrides !== null && typeof overrides === 'object') {
        Object.keys(overrides).forEach(key => {
          Object.defineProperty(this.sessionInfo, key, {
            value: overrides[key]
          });
        });
      }
    };
    const connectMessenger = function connectMessenger() {
      _logging.debug('OT.Session: connecting to Raptor');
      const messagingUrl = (0, _proxyUrlHelper.default)(this.sessionInfo.messagingURL, proxyUrl);
      // capabilities supported by default.
      const capabilities = ['forceMute'];
      // Add Adaptive Media Routing capability if enabled for the session.
      const isAdaptiveEnabled = this.sessionInfo.isAdaptiveEnabled;
      if (isAdaptiveEnabled) {
        capabilities.push('amr');
      }
      if (_useSinglePeerConnection) {
        capabilities.push('spc');
      }
      if (sessionMigration) {
        capabilities.push('migrate');
      }
      _sockets[messagingUrl] = new RaptorSocket({
        connectionId: _connectionId,
        sessionId,
        messagingSocketUrl: messagingUrl,
        symphonyUrl: this.sessionInfo.symphonyAddress,
        dispatcher: SessionDispatcher(this, {
          connectionEventsSuppressed
        }),
        analytics,
        requestedCapabilities: capabilities
      });
      const previousSocket = _socket;
      _socket = _sockets[messagingUrl];
      _messagingUrl = messagingUrl;

      /**
       * Maps an error from RaptorSocket.connect to its corresponding name
       * @param {string} reason - Failure reason
       * @param {number} code - Error code
       * @return {string|undefined} Error name
       */
      function getErrorNameFromCode(reason, code) {
        let name;
        switch (reason) {
          case 'WebSocketConnection':
            name = (0, _findKey.default)(socketCloseCodes.codes, x => x === code);
            if (name) {
              return errors[`SOCKET_${name}`];
            }
            break;
          case 'ConnectToSession':
          case 'GetSessionState':
            switch (code) {
              case ExceptionCodes.CONNECT_FAILED:
                return errors.CONNECT_FAILED;
              case ExceptionCodes.UNEXPECTED_SERVER_RESPONSE:
                return errors.UNEXPECTED_SERVER_RESPONSE;
              case ExceptionCodes.CONNECTION_LIMIT_EXCEEDED:
                return errors.CONNECTION_LIMIT_EXCEEDED;
              default:
                break;
            }
            break;
          default:
            break;
        }
        return undefined;
      }
      _socket.connect(_token, this.sessionInfo, {
        connectionEventsSuppressed
      }, (error, sessionState) => {
        var _socket3;
        if (error) {
          const payload = {};
          let options;
          if (error.reason === 'ConnectToSession' || error.reason === 'GetSessionState') {
            const converted = convertRumorError(error);
            (0, _assign.default)(payload, {
              originalMessage: error.message,
              originalCode: error.code
            });
            error.code = converted.code;
            error.message = converted.message;
          }
          if (error.code || error.message || error.reason) {
            var _socket2;
            options = {
              failureCode: error.code,
              failureMessage: error.message,
              failureReason: error.reason,
              socketId: (_socket2 = _socket) == null ? void 0 : _socket2.socketId
            };
          }
          _socket = null;
          this.logConnectivityEvent('Failure', payload, options);
          const errorName = getErrorNameFromCode(error.reason, error.code);
          if (errorName) {
            error = otError(errorName, new Error(error.message), error.code);
          }
          sessionConnectFailed.call(this, error);
          return;
        }
        if (previousSocket) {
          // We have a new Socket, so we avoid to duplicate Rumor messages. We should not close the
          // previous socket yet beacuse we can have still Publishers/Subscriber migrating to the
          // new Rumor.
          previousSocket.muteMessages(true);
        }
        _logging.debug('OT.Session: Received session state from Raptor', sessionState);
        if (this.is('migrating')) {
          // When migrating, once new Rumor is connected, migrate all Publishers. Also return early
          // to avoid duplicating listeners.
          sessionObjects.publishers.forEach(publisher => publisher._.startMigration());
          return;
        }
        this.connection = this.connections.get((_socket3 = _socket) == null ? void 0 : _socket3.id());
        if (this.connection) {
          this.capabilities = this.connection.permissions;
        }
        setState('connected');
        this.logConnectivityEvent('Success', {
          connectionId: this.connection.id
        });

        // Listen for our own connection's destroyed event so we know when we've been disconnected.
        this.connection.on('destroyed', sessionDisconnectedHandler, this);
        this.dispatchEvent(new Events.SessionConnectEvent(_eventNames.default.SESSION_CONNECTED));
        // Listen for connection updates
        this.connections.on({
          add: connectionCreatedHandler,
          remove: connectionDestroyedHandler
        }, this);

        // Listen for stream updates
        this.streams.on({
          add: streamCreatedHandler,
          remove: streamDestroyedHandler,
          update: streamPropertyModifiedHandler
        }, this);
        this.archives.on({
          add: archiveCreatedHandler,
          remove: archiveDestroyedHandler,
          update: archiveUpdatedHandler
        }, this);
        this.connections._triggerAddEvents();
        this.streams._triggerAddEvents();
        this.archives._triggerAddEvents();

        // Listen for the gsmCallEnded event triggered by the publisher when a GSM call ends.
        const isBuggediOS = OTHelpers.env.isiOS && OTHelpers.env.iOSVersion >= 13.3;
        if (isBuggediOS) {
          this.on('gsmCallEnded', gsmCallEndedHandler);
        }
      });
    };

    // Check whether we have permissions to perform the action.
    const permittedTo = action => this.capabilities.permittedTo(action);
    const dispatchOTError = (error, completionHandler) => {
      logging.error(`${error.name}: ${error.message}`);
      if (typeof completionHandler === 'function') {
        completionHandler(error);
      }
      OTErrorClass.handleJsException({
        error,
        target: this,
        analytics
      });
    };
    const dispatchSocketIsNullError = (action, completionHandler) => {
      const socketNotDefined = `Unable to perform ${action}, you are not connected.`;
      const otErrorInstance = otError(errors.NOT_CONNECTED, new Error(socketNotDefined), 404);
      dispatchOTError(otErrorInstance, completionHandler);
      return otErrorInstance;
    };
    const dispatchMuteError = err => {
      const error = otError(err.code, new Error(err.message), err.exceptionCode);
      dispatchOTError(error);
      return error;
    };
    const checkMuteCapabilities = () => {
      if (!this.isConnected()) {
        return dispatchMuteError(_forceMuteErrors.default.NOT_CONNECTED);
      }
      if (!permittedTo('forceMute')) {
        // if this throws an error the handleJsException won't occur
        return dispatchMuteError(_forceMuteErrors.default.PERMISSION_DENIED);
      }
      return null;
    };
    const handleMuteServerError = err => {
      if (err.code === '404') {
        return dispatchMuteError(_forceMuteErrors.default.NOT_FOUND);
      } else if (err.code === '403') {
        return dispatchMuteError(_forceMuteErrors.default.PERMISSION_DENIED);
      }
      return dispatchMuteError(_forceMuteErrors.default.UNEXPECTED_SERVER_RESPONSE);
    };
    this.reportIssue = _ref2 => {
      let id = _ref2.id;
      return (0, _promisify.default)(analytics.logEvent.bind(analytics))({
        action: 'ReportIssue',
        variation: 'Event',
        connectionId: _connectionId,
        payload: {
          reportIssueId: id
        }
      }, null);
    };
    this.logEvent = function (action, variation, payload, options) {
      let event = {
        action,
        variation,
        payload,
        sessionId: _sessionId,
        messagingServer: _messagingServer,
        p2p: _p2p,
        partnerId: _apiKey,
        connectionId: _connectionId,
        singlePeerConnection: _useSinglePeerConnection
      };
      if (options) {
        event = (0, _assign.default)(options, event);
      }
      analytics.logEvent(event);
    };
    this.logConfigurationFileEvent = function (variation, payload, options) {
      if (payload === void 0) {
        payload = null;
      }
      if (options === void 0) {
        options = {};
      }
      if (variation === 'Attempt') {
        _configurationAttemptStartTime = new Date().getTime();
      } else if (variation === 'Failure' || variation === 'Success') {
        const attemptDuration = new Date().getTime() - _configurationAttemptStartTime;
        (0, _assign.default)(options, {
          attemptDuration
        });
      }
      if (proxyUrl) {
        options.proxyUrl = proxyUrl;
      }
      this.logEvent('ConfigurationFile', variation, payload, Object.assign({}, options));
    };
    this.logConnectivityEvent = function (variation, payload, options) {
      if (payload === void 0) {
        payload = null;
      }
      if (options === void 0) {
        options = {};
      }
      if (proxyUrl) {
        options.proxyUrl = proxyUrl;
      }
      if (variation === 'Attempt') {
        if (_connectivityAttemptPinger) {
          _connectivityAttemptPinger.stop();
          logging.error('_connectivityAttemptPinger should have been cleaned up');
        }
        _attemptStartTime = new Date().getTime();
        _connectivityAttemptPinger = new _interval_runner.default(() => {
          this.logEvent('Connect', 'Attempting', payload, Object.assign({}, options));
        }, 1 / 5, 6);
        _connectivityAttemptPinger.start();
      }
      if (variation === 'Failure' || variation === 'Success' || variation === 'Cancel') {
        const logConnect = _iceConfig => {
          if (_connectivityAttemptPinger) {
            _connectivityAttemptPinger.stop();
            _connectivityAttemptPinger = undefined;
          }
          this.logEvent('Connect', variation, payload, Object.assign({}, options, {
            attemptDuration: new Date().getTime() - _attemptStartTime,
            iceConfig: _iceConfig,
            ipWhitelist
          }));
        };
        if (variation === 'Success') {
          this._.getIceConfig().then(config => {
            const _iceConfig = {
              includeServers: iceConfig && iceConfig.includeServers || 'all',
              transportPolicy: config.transportPolicy
            };
            _iceConfig.servers = config.servers ? config.servers.map(server => ({
              url: server.urls
            })) : [];
            logConnect(_iceConfig);
          });
        } else {
          logConnect();
        }
      } else {
        this.logEvent('Connect', variation, payload, options);
      }
    };

    /**
    * Connects to a Vonage Video API session.
    * <p>
    *  Upon a successful connection, the completion handler (the second parameter of the method) is
    *  invoked without an error object passed in. (If there is an error connecting, the completion
    *  handler is invoked with an error object.) Make sure that you have successfully connected to the
    *  session before calling other methods of the Session object.
    * </p>
    *  <p>
    *    The Session object dispatches a <code>connectionCreated</code> event when any client
    *    (including your own) connects to the session.
    *  </p>
    *
    *  <h5>
    *  Example
    *  </h5>
    *  <p>
    *  The following code initializes a session and sets up an event listener for when the session
    *  connects:
    *  </p>
    *  <pre>
    *  var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
    *  var sessionID = ""; // Replace with your own session ID.
    *                      // See https://tokbox.com/developer/guides/create-session/.
    *  var token = ""; // Replace with a generated token.
    *                  // See https://tokbox.com/developer/guides/create-token/.
    *
    *  var session = OT.initSession(apiKey, sessionID);
    *  session.connect(token, function(error) {
    *    if (error) {
    *      console.log(error.message);
    *    } else {
    *      // You have connected to the session. You could publish a stream now.
    *    }
    *  });
    *  </pre>
    *  <p>
    *
    *  <h5>
    *  Events dispatched:
    *  </h5>
    *
    *  <p>
    *    <code>exception</code> (<a href="ExceptionEvent.html">ExceptionEvent</a>) &#151; Dispatched
    *    by the OT class locally in the event of an error.
    *  </p>
    *  <p>
    *    <code>connectionCreated</code> (<a href="ConnectionEvent.html">ConnectionEvent</a>) &#151;
    *      Dispatched by the Session object on all clients connected to the session.
    *  </p>
    *  <p>
    *    <code>sessionConnected</code> (<a href="SessionConnectEvent.html">SessionConnectEvent</a>)
    *      &#151; Dispatched locally by the Session object when the connection is established. However,
    *      you can pass a completion handler function in as the second parameter of the
    *      <code>connect()</code> and use this function instead of a listener for the
    *      <code>sessionConnected</code> event.
    *  </p>
    *
    * @param {String} token The session token. You generate a session token using our
    * <a href="https://tokbox.com/developer/sdks/server/">server-side libraries</a> or at your
    * <a href="https://tokbox.com/account">Vonage Video API account</a> page. For more information, see
    * <a href="https://tokbox.com/developer/guides/create-token/">Connection token creation</a>.
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>connect()</code> method succeeds or fails. This function takes one parameter &mdash;
    * <code>error</code> (see the <a href="Error.html">Error</a> object).
    * On success, the <code>completionHandler</code> function is not passed any
    * arguments. On error, the function is passed an <code>error</code> object parameter
    * (see the <a href="Error.html">Error</a> object). The
    * <code>error</code> object has two properties: <code>code</code> (an integer) and
    * <code>message</code> (a string), which identify the cause of the failure. The following
    * code adds a <code>completionHandler</code> when calling the <code>connect()</code> method:
    * <pre>
    * session.connect(token, function (error) {
    *   if (error) {
    *       console.log(error.message);
    *   } else {
    *     console.log("Connected to session.");
    *   }
    * });
    * </pre>
    * <p>
    * Note that upon connecting to the session, the Session object dispatches a
    * <code>sessionConnected</code> event in addition to calling the <code>completionHandler</code>.
    * The SessionConnectEvent object, which defines the <code>sessionConnected</code> event,
    * includes <code>connections</code> and <code>streams</code> properties, which
    * list the connections and streams in the session when you connect.
    * </p>
    *
    * @see SessionConnectEvent
    * @method #connect
    * @memberOf Session
    */
    this.connect = function () {
      let token;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args.length > 1 && (typeof args[0] === 'string' || typeof args[0] === 'number') && typeof args[1] === 'string') {
        if (apiKey == null) {
          _apiKey = args[0].toString();
        }
        token = args[1];
      } else {
        token = args[0];
      }

      // The completion handler is always the last argument.
      const completionHandler = args[args.length - 1];
      if (_this.is('connecting', 'connected')) {
        _logging.warn(`OT.Session: Cannot connect, the session is already ${_this.currentState}`);
        return _this;
      }
      if (_this.is('disconnecting')) {
        _logging.warn('OT.Session: trying to connect while the session is not done disconnecting.');
        _connectionId = uuid();
      }

      // On disconnects, GSI fields may be unintentionally cached and logged so we instantiate a new instance.
      analytics.sessionInfo = new _SessionInfo.default();
      init();
      setState('connecting');
      const currentConnectionId = _connectionId;
      function checkInterrupted() {
        const interrupted = _connectionId !== currentConnectionId;
        if (interrupted) {
          logging.debug('Connection was interrupted');
        }
        return interrupted;
      }
      _this.token = !(0, _isFunction.default)(token) && token;
      _token = !(0, _isFunction.default)(token) && token;
      if (completionHandler && (0, _isFunction.default)(completionHandler)) {
        let cleanup;
        const onCompleteSuccess = function onCompleteSuccess() {
          cleanup();
          for (var _len2 = arguments.length, cbArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            cbArgs[_key2] = arguments[_key2];
          }
          completionHandler(undefined, ...cbArgs);
        };
        const onCompleteFailure = function onCompleteFailure() {
          cleanup();
          completionHandler(...arguments);
        };
        cleanup = () => {
          _this.off('sessionConnected', onCompleteSuccess);
          _this.off('sessionConnectFailed', onCompleteFailure);
        };
        _this.once('sessionConnected', onCompleteSuccess);
        _this.once('sessionConnectFailed', onCompleteFailure);
      }
      if (_apiKey == null || (0, _isFunction.default)(_apiKey)) {
        setTimeout(sessionConnectFailed.bind(_this, otError(errors.AUTHENTICATION_ERROR, new Error('API Key is undefined. You must pass an API Key to initSession.'), ExceptionCodes.AUTHENTICATION_ERROR)));
        return _this;
      }
      if (!_sessionId || (0, _isObject.default)(_sessionId) || Array.isArray(_sessionId)) {
        let errorMsg;
        if (!_sessionId) {
          errorMsg = 'SessionID is undefined. You must pass a sessionID to initSession.';
        } else {
          errorMsg = 'SessionID is not a string. You must use string as the session ID passed into ' + 'OT.initSession().';
          _sessionId = _sessionId.toString();
        }
        setTimeout(sessionConnectFailed.bind(_this, otError(errors.INVALID_SESSION_ID, new Error(errorMsg), ExceptionCodes.INVALID_SESSION_ID)));
        _this.logConnectivityEvent('Attempt');
        _this.logConnectivityEvent('Failure', null, {
          failureReason: 'ConnectToSession',
          failureCode: ExceptionCodes.INVALID_SESSION_ID,
          failureMessage: errorMsg
        });
        return _this;
      }
      _this.apiKey = _apiKey.toString();
      _apiKey = _apiKey.toString();
      if (cpuPressureMonitor) {
        cpuPressureMonitor.startMonitoring();
      }
      if (encryptionSecret) {
        if (!hasE2eeCapability()) {
          setTimeout(sessionConnectFailed.bind(_this, otError(errors.UNSUPPORTED_BROWSER, new Error('E2E Encryption is not supported in your browser.'))));
          return _this;
        }
        try {
          (0, _validateSecret.default)(encryptionSecret);
          _this.keyStore.set(sessionId, encryptionSecret);
          _e2eeSecretSet = true;
        } catch (e) {
          setTimeout(sessionConnectFailed.bind(_this, otError(errors.INVALID_ENCRYPTION_SECRET, new Error(`Invalid encryptionSecret: ${e.message}`))));
          return _this;
        }
      }

      // TODO: Ugly hack, make sure APIKEY is set

      if (APIKEY.value.length === 0) {
        APIKEY.value = _apiKey;
      }
      const hasStaticConfigUrl = Boolean(StaticConfig.onlyLocal().configUrl);
      const useIpWhitelistConfigUrl = ipWhitelist === true && Boolean(StaticConfig.onlyLocal().ipWhitelistConfigUrl);
      if (!hasStaticConfigUrl && !useIpWhitelistConfigUrl) {
        _this.logConfigurationFileEvent('Event', {
          message: 'No configUrl, using local config only'
        });
      } else {
        _this.logConfigurationFileEvent('Attempt');
      }
      const futureStaticConfigDefault = hasStaticConfigUrl || useIpWhitelistConfigUrl ? StaticConfig.get({
        partnerId: _apiKey,
        token,
        useIpWhitelistConfigUrl,
        proxyUrl
      }) : Promise.resolve(StaticConfig.onlyLocal());
      const futureStaticConfig = deps.futureStaticConfig || futureStaticConfigDefault;
      futureStaticConfig.then(staticConfig => {
        if (hasStaticConfigUrl || useIpWhitelistConfigUrl) {
          _this.logConfigurationFileEvent('Success');
        }
        return staticConfig;
      }, err => {
        if (hasStaticConfigUrl || useIpWhitelistConfigUrl) {
          _this.logConfigurationFileEvent('Failure', {
            failureMessage: err.message,
            failureStack: err.stack
          });
        }
        return StaticConfig.onlyLocal();
      }).then(staticConfig => {
        _this.staticConfig = staticConfig;
        analytics.staticConfig = staticConfig;
        if (staticConfig.apiEnabled === false) {
          throw otError(errors.API_KEY_DISABLED, new Error('The API KEY has been disabled. Access to the service is currently being ' + 'restricted. Please contact support.'));
        }
        if (checkInterrupted()) {
          return undefined;
        }
        _this.logConnectivityEvent('Attempt');
        if (proxyUrl) {
          _this.logEvent('SessionInfo', 'Attempt', null, {
            proxyUrl
          });
        } else {
          _this.logEvent('SessionInfo', 'Attempt');
        }
        const onSessionInfoError = error => {
          // @todo I think we should move convertAnvilErrorCode to after we log the Failure. It's
          // a lossy process, and the more information we have in our logged failure, the better
          // we can understand the failures.
          error.code = (0, _convertAnvilErrorCode.default)(error.code);
          _this.logConnectivityEvent('Failure', null, {
            failureReason: 'GetSessionInfo',
            failureCode: error.code || 'No code',
            failureMessage: error.message,
            failureName: error.name
          });
          if (error.name) {
            error = otError(error.name, new Error(`${error.message}${error.code ? ` (${error.code})` : ''}`), error.code);
          }
          sessionConnectFailed.call(_this, error);
        };
        const onSessionInfoSuccess = sessionInfo => {
          if (checkInterrupted()) {
            return;
          }
          if (sessionInfo.partnerId && sessionInfo.partnerId !== _apiKey) {
            // The apiKey does not match, this is an error
            const reason = 'Authentication Error: The API key does not match the token or session.';
            onSessionInfoError(otError(errors.AUTHENTICATION_ERROR, new Error(reason), ExceptionCodes.AUTHENTICATION_ERROR));
            return;
          }

          // Force SPC if set by either sessionInfo or forced by initSession.
          _useSinglePeerConnection = (0, _shouldUseSinglePeerConnection.default)(sessionInfo, singlePeerConnection);
          if (_useSinglePeerConnection) {
            _this._singlePeerConnectionController = new SinglePeerConnectionController(_this);
          }
          analytics.sessionInfo = sessionInfo;
          if (_this.is('connecting')) {
            setSessionInfo(sessionInfo);
            connectMessenger.call(_this);
          }
        };
        const targetUrl = (0, _proxyUrlHelper.default)(staticConfig.apiUrl, proxyUrl);
        return getSessionInfo({
          anvilUrl: targetUrl,
          sessionId,
          token: _token,
          connectionId: _connectionId,
          clientVersion: staticConfig.clientVersion
        }).then(onSessionInfoSuccess, onSessionInfoError);
      }).catch(err => {
        sessionConnectFailed.call(_this, err);
      });
      return _this;
    };

    /**
    * Disconnects from the Vonage Video API session.
    *
    * <p>
    * Calling the <code>disconnect()</code> method ends your connection with the session. In the
    * course of terminating your connection, it also ceases publishing any stream(s) you were
    * publishing.
    * </p>
    * <p>
    * Session objects on remote clients dispatch <code>streamDestroyed</code> events for any
    * stream you were publishing. The Session object dispatches a <code>sessionDisconnected</code>
    * event locally. The Session objects on remote clients dispatch <code>connectionDestroyed</code>
    * events, letting other connections know you have left the session. The
    * {@link SessionDisconnectEvent} and {@link StreamEvent} objects that define the
    * <code>sessionDisconnect</code> and <code>connectionDestroyed</code> events each have a
    * <code>reason</code> property. The <code>reason</code> property lets the developer determine
    * whether the connection is being terminated voluntarily and whether any streams are being
    * destroyed as a byproduct of the underlying connection's voluntary destruction.
    * </p>
    * <p>
    * If the session is not currently connected, calling this method causes a warning to be logged.
    * See <a href="OT.html#setLogLevel">OT.setLogLevel()</a>.
    * </p>
    *
    * <p>
    * <i>Note:</i> If you intend to reuse a Publisher object to publish to different sessions
    * (or the same session) sequentially, add an event listener for the <code>streamDestroyed</code>
    * event dispatched by the Publisher object (when it stops publishing). In the event listener,
    * call the <code>preventDefault()</code> method of the event object to prevent the Publisher's
    * video from being removed from the page.
    * </p>
    *
    * <h5>
    * Events dispatched:
    * </h5>
    * <p>
    * <code>sessionDisconnected</code>
    * (<a href="SessionDisconnectEvent.html">SessionDisconnectEvent</a>)
    * &#151; Dispatched locally when the connection is disconnected.
    * </p>
    * <p>
    * <code>connectionDestroyed</code> (<a href="ConnectionEvent.html">ConnectionEvent</a>) &#151;
    * Dispatched on other clients, along with the <code>streamDestroyed</code> event (as warranted).
    * </p>
    *
    * <p>
    * <code>streamDestroyed</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    * Dispatched on other clients if streams are lost as a result of the session disconnecting.
    * </p>
    *
    * @method #disconnect
    * @memberOf Session
    */
    this.disconnect = function () {
      if (this._singlePeerConnectionController) {
        this._singlePeerConnectionController.destroy();
        this._singlePeerConnectionController = null;
      }
      if (cpuPressureMonitor) {
        cpuPressureMonitor.stopMonitoring();
      }
      if (_socket && _socket.isNot('disconnected')) {
        if (_socket.isNot('disconnecting')) {
          if (!_socket.isNot('connecting')) {
            this.logConnectivityEvent('Cancel');
          }
          setState('disconnecting');
          _socket.disconnect();
          this.off('gsmCallEnded', gsmCallEndedHandler);
        }
      } else {
        reset();
      }
    };
    this.destroy = function () {
      this.streams.destroy();
      this.connections.destroy();
      this.archives.destroy();
      this.disconnect();
    };

    /**
    * The <code>publish()</code> method starts publishing an audio-video stream to the session.
    * The audio-video stream is captured from a local microphone and webcam. Upon successful
    * publishing, the Session objects on all connected clients dispatch the
    * <code>streamCreated</code> event.
    * </p>
    *
    * <!--JS-ONLY-->
    * <p>You pass a Publisher object as the one parameter of the method. You can initialize a
    * Publisher object by calling the <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * method. Before calling <code>Session.publish()</code>.
    * </p>
    *
    * <p>This method takes an alternate form: <code>publish(targetElement: String | HTMLElement,
    * properties: Object, completionHandler: Function): Publisher</code> &#151; In this form, you do
    <i>not</i> pass a Publisher object into the function. Instead, you pass in a <code>targetElement</code>
    (the target HTML element or the ID of the target HTML element for the Publisher), an optional
    <code>properties</code> object that defines options for the Publisher (see
    <a href="OT.html#initPublisher">OT.initPublisher()</a>), and an optional completion handler function.
    * The method returns a new Publisher object, which starts sending an audio-video stream to the
    * session. The remainder of this documentation describes the form that takes a single Publisher
    * object as a parameter.
    *
    * <p>
    *   A local display of the published stream is created on the web page by replacing
    *         the specified element in the DOM with a streaming video display. The video stream
    *         is automatically mirrored horizontally so that users see themselves and movement
    *         in their stream in a natural way. If the width and height of the display do not match
    *         the 4:3 aspect ratio of the video signal, the video stream is cropped to fit the
    *         display.
    * </p>
    *
    * <p>
    *   If calling this method creates a new Publisher object and the Vonage Video API library does not
    *   have access to the camera or microphone, the web page alerts the user to grant access
    *   to the camera and microphone.
    * </p>
    *
    * <p>
    * The OT object dispatches an <code>exception</code> event if the user's role does not
    * include permissions required to publish. For example, if the user's role is set to subscriber,
    * then they cannot publish. You define a user's role when you create the user token
    * (see <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
    * You pass the token string as a parameter of the <code>connect()</code> method of the Session
    * object. See <a href="ExceptionEvent.html">ExceptionEvent</a> and
    * <a href="OT.html#on">OT.on()</a>.
    * </p>
    *     <p>
    *     The application throws an error if the session is not connected.
    *     </p>
    *
    * <h5>Events dispatched:</h5>
    * <p>
    * <code>exception</code> (<a href="ExceptionEvent.html">ExceptionEvent</a>) &#151; Dispatched
    * by the OT object. This can occur when user's role does not allow publishing (the
    * <code>code</code> property of event object is set to 1500); it can also occur if the
    * connection fails to connect (the <code>code</code> property of event object is set to 1013).
    * WebRTC is a peer-to-peer protocol, and it is possible that connections will fail to connect.
    * The most common cause for failure is a firewall that the protocol cannot traverse.</li>
    * </p>
    * <p>
    * <code>streamCreated</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    * The stream has been published. The Session object dispatches this on all clients
    * subscribed to the stream, as well as on the publisher's client.
    * </p>
    *
    * <h5>Example</h5>
    *
    * <p>
    *   The following example publishes a video once the session connects:
    * </p>
    * <pre>
    * var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
    * var sessionId = ""; // Replace with your own session ID.
    *                     // https://tokbox.com/developer/guides/create-session/.
    * var token = ""; // Replace with a generated token that has been assigned the publish role.
    *                 // See https://tokbox.com/developer/guides/create-token/.
    * var session = OT.initSession(apiKey, sessionID);
    * session.connect(token, function(error) {
    *   if (error) {
    *     console.log(error.message);
    *   } else {
    *     var publisherOptions = {width: 400, height:300, name:"Bob's stream"};
    *     // This assumes that there is a DOM element with the ID 'publisher':
    *     publisher = OT.initPublisher('publisher', publisherOptions);
    *     session.publish(publisher);
    *   }
    * });
    * </pre>
    *
    * @param {Publisher} publisher A Publisher object, which you initialize by calling the
    * <a href="OT.html#initPublisher">OT.initPublisher()</a> method.
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>publish()</code> method succeeds or fails. This function takes one parameter &mdash;
    * <code>error</code>. On success, the <code>completionHandler</code> function is not passed any
    * arguments. On error, the function is passed an <code>error</code> object parameter
    * (see the <a href="Error.html">Error</a> object). The
    * <code>error</code> object has two properties: <code>code</code> (an integer) and
    * <code>message</code> (a string), which identify the cause of the failure. Calling
    * <code>publish()</code> fails if the role assigned to your token is not "publisher" or
    * "moderator"; in this case the <code>error.name</code> property is set to
    * <code>"OT_PERMISSION_DENIED"</code>. Calling <code>publish()</code> also fails if the
    * client fails to connect; in this case the <code>error.name</code> property is set to
    * <code>"OT_NOT_CONNECTED"</code>. The following code adds a completion handler when
    * calling the <code>publish()</code> method:
    * <pre>
    * session.publish(publisher, null, function (error) {
    *   if (error) {
    *     console.log(error.message);
    *   } else {
    *     console.log("Publishing a stream.");
    *   }
    * });
    * </pre>
    *
    * @returns The Publisher object for this stream.
    *
    * @method #publish
    * @memberOf Session
    */
    this.publish = (publisher, properties, completionHandler) => {
      if (typeof publisher === 'function') {
        completionHandler = publisher;
        publisher = undefined;
      }
      if (typeof properties === 'function') {
        completionHandler = properties;
        properties = undefined;
      }
      completionHandler = completionHandler || function () {};
      if (!this.isConnected()) {
        analytics.logError(1010, 'OT.exception', 'We need to be connected before you can publish', null, {
          action: 'Publish',
          variation: 'Failure',
          failureReason: 'unconnected',
          failureCode: ExceptionCodes.NOT_CONNECTED,
          failureMessage: 'We need to be connected before you can publish',
          sessionId: _sessionId,
          streamId: publisher && publisher.stream ? publisher.stream.id : null,
          p2p: this.sessionInfo ? this.sessionInfo.p2pEnabled : undefined,
          messagingServer: this.sessionInfo ? this.sessionInfo.messagingServer : null,
          partnerId: _apiKey
        });
        dispatchOTError(otError(errors.NOT_CONNECTED, new Error('We need to be connected before you can publish'), ExceptionCodes.NOT_CONNECTED), completionHandler);
        return null;
      }
      if (!permittedTo('publish')) {
        const errorMessage = 'This token does not allow publishing. The role must be at least ' + '`publisher` to enable this functionality';
        const options = {
          failureReason: 'Permission',
          failureCode: ExceptionCodes.UNABLE_TO_PUBLISH,
          failureMessage: errorMessage
        };
        this.logEvent('Publish', 'Failure', null, options);
        dispatchOTError(otError(errors.PERMISSION_DENIED, new Error(errorMessage), ExceptionCodes.UNABLE_TO_PUBLISH), completionHandler);
        return null;
      }

      // If the user has passed in an ID or an element then we create a new publisher.
      const shouldInitPublisher = !publisher || typeof publisher === 'string' || OTHelpers.isElementNode(publisher);
      // If publisher is an instance of Publisher we use that Publisher.
      const shouldUsePublisher = publisher instanceof Publisher;
      if (!shouldInitPublisher && !shouldUsePublisher) {
        dispatchOTError(otError(errors.INVALID_PARAMETER, new Error('Session.publish :: First parameter passed in is neither a ' + 'string nor an instance of the Publisher'), ExceptionCodes.UNABLE_TO_PUBLISH), completionHandler);
        return undefined;
      }
      if (shouldUsePublisher) {
        // If the publisher already has a session attached to it we can
        if ('session' in publisher && publisher.session && 'sessionId' in publisher.session) {
          // send a warning message that we can't publish again.
          if (publisher.session.sessionId === this.sessionId) {
            _logging.warn(`Cannot publish ${publisher.guid()} again to ${this.sessionId}. Please call session.unpublish(publisher) first.`);
          } else {
            _logging.warn(`Cannot publish ${publisher.guid()} publisher already attached to ${publisher.session.sessionId}. Please call session.unpublish(publisher) first.`);
          }
          completionHandler(null, publisher);
          return publisher;
        }
      } else if (shouldInitPublisher) {
        // Initiate a new Publisher with the new session credentials
        publisher = initPublisher(publisher, properties);
      }
      if (_muteOnEntry) {
        publisher._.forceMuteAudio();
      }

      // Add publisher reference to the session
      publisher._.publishToSession(this, analytics).then(() => completionHandler(null, publisher), err => {
        err.message = `Session.publish :: ${err.message}`;
        _logging.error(err.code, err.message);
        completionHandler(err);
      });

      // return the embed publisher
      return publisher;
    };

    /**
    * Ceases publishing the specified publisher's audio-video stream
    * to the session. By default, the local representation of the audio-video stream is
    * removed from the web page. Upon successful termination, the Session object on every
    * connected web page dispatches
    * a <code>streamDestroyed</code> event.
    * </p>
    *
    * <p>
    * To prevent the Publisher from being removed from the DOM, add an event listener for the
    * <code>streamDestroyed</code> event dispatched by the Publisher object and call the
    * <code>preventDefault()</code> method of the event object.
    * </p>
    *
    * <p>
    * <i>Note:</i> If you intend to reuse a Publisher object to publish to different sessions
    * (or the same session) sequentially, add an event listener for the <code>streamDestroyed</code>
    * event dispatched by the Publisher object (when it stops publishing). In the event listener,
    * call the <code>preventDefault()</code> method of the event object to prevent the Publisher's
    * video from being removed from the page.
    * </p>
    *
    * <h5>Events dispatched:</h5>
    *
    * <p>
    * <code>streamDestroyed</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    * The stream associated with the Publisher has been destroyed. Dispatched on by the
    * Publisher on on the Publisher's browser. Dispatched by the Session object on
    * all other connections subscribing to the publisher's stream.
    * </p>
    *
    * <h5>Example</h5>
    *
    * The following example publishes a stream to a session and adds a Disconnect link to the
    * web page. Clicking this link causes the stream to stop being published.
    *
    * <pre>
    * &lt;script&gt;
    *   var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
    *   var sessionID = ""; // Replace with your own session ID.
    *                    // See https://tokbox.com/developer/guides/create-session/.
    *   var token = ""; // Replace with a generated token.
    *                   // See https://tokbox.com/developer/guides/create-token/.
    *   var publisher;
    *   var session = OT.initSession(apiKey, sessionID);
    *   session.connect(token, function(error) {
    *     if (error) {
    *       console.log(error.message);
    *     } else {
    *       // This assumes that there is a DOM element with the ID 'publisher':
    *       publisher = OT.initPublisher('publisher');
    *       session.publish(publisher);
    *     }
    *   });
    *
    *   function unpublish() {
    *     session.unpublish(publisher);
    *   }
    * &lt;/script&gt;
    *
    * &lt;body&gt;
    *
    *     &lt;div id="publisherContainer/&gt;
    *     &lt;br/&gt;
    *
    *     &lt;a href="javascript:unpublish()"&gt;Stop Publishing&lt;/a&gt;
    *
    * &lt;/body&gt;
    *
    * </pre>
    *
    * @see <a href="#publish">publish()</a>
    *
    * @see <a href="StreamEvent.html">streamDestroyed event</a>
    *
    * @param {Publisher} publisher</span> The Publisher object to stop streaming.
    *
    * @method #unpublish
    * @memberOf Session
    */
    this.unpublish = function (publisher) {
      if (!publisher) {
        _logging.error('OT.Session.unpublish: publisher parameter missing.');
        return;
      }

      // Unpublish the localMedia publisher
      publisher._.unpublishFromSession(this, 'unpublished');
    };

    /**
      * Sets the ICE configuration for all connections in a session. This replaces any previously
      * set ICE configurations.
      *
      * <p>
      * This feature is available for projects that use the
      * <a href="https://tokbox.com/developer/guides/configurable-turn-servers/">configurable
      * TURN server add-on</a>.
      *
      * @see <a href="OT.html#initSession">OT.initSession()</a>
      *
      * @param {IceConfig} newIceConfig This object defines the ICE configuration. It has the
      * following propoerties;
      *
      * <p>
      * <ul>
      *   <li>
      *     <code>includeServers</code></code> (String) — Set this to 'custom' and client will use
      *     only the custom TURN servers you provide in the <code>customServers</code> property
      *     of the <code>newIceConfig</code> parameter. Set this to 'all' and the client will use
      *     both the custom TURN servers you provide along with Vonage Video API TURN servers.
      *   </li>
      *
      *   <li>
      *     <code>transportPolicy</code></code> (String) — Set this to 'all' (the default) and
      *     the client will use all ICE transport types (such as host, srflx, and TURN) to establish
      *     media connectivity. Set this to 'relay' to force connectivity through TURN always
      *     and ignore all other ICE candidates.
      *   </li>
      *
      *   <li>
      *     <p>
      *     <code>customServers</code></code> (Array) — Set this to an array of objects defining
      *     your custom TURN servers. Each object corresponds to one custom TURN server, and it
      *     includes the following properties:
      *     </p>
      *     <p>
      *     <ul>
      *       <li>
      *         <code>urls</code> (String or Array of Strings) — A string or an array of strings,
      *         where each string is a URL supported by the TURN server (and this may be only one URL).
      *       </li>
      *
      *       <li>
      *         <code>username</code> (String, optional) — The username for the TURN server defined
      *         in this object.
      *       </li>
      *
      *       <li>
      *         <code>credential</code> (String, optional) — The credential string for the TURN server
      *         defined in this object.
      *       </li>
      *     </ul>
      *     </p>
      *  </li>
      *
      * </ul>
      * </p>
      *
      * @method #setIceConfig
      *
      * @memberOf Session
    */
    this.setIceConfig = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(newIceConfig) {
        var iceServerInfo, extractServersFromIceConfig, processedIceServers;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              validateIceConfig(newIceConfig);
              analytics.logEvent({
                action: 'setIceConfig',
                variation: 'Attempt',
                payload: {
                  newIceConfig
                }
              });

              // Future publishers will need the new iceConfig, which needs to be cloned due to getIceConfig behavior
              iceConfig = Object.assign({}, newIceConfig);

              // Include default servers, unless user has includeServers set to 'custom'
              if (!(newIceConfig.includeServers === 'all')) {
                _context.next = 8;
                break;
              }
              _context.next = 6;
              return _session._.getOtIceServerInfo();
            case 6:
              iceServerInfo = _context.sent;
              newIceConfig.customServers = newIceConfig.customServers.concat(iceServerInfo.servers);
            case 8:
              extractServersFromIceConfig = iceConfigObject => ({
                iceServers: iceConfigObject.customServers,
                iceTransportPolicy: iceConfigObject.transportPolicy
              });
              processedIceServers = extractServersFromIceConfig(newIceConfig);
              _context.prev = 10;
              _context.next = 13;
              return Promise.all(sessionObjects.publishers.map(pub => pub._.setIceConfig(processedIceServers)).concat(sessionObjects.subscribers.map(sub => sub._.setIceConfig(processedIceServers))));
            case 13:
              _context.next = 19;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](10);
              analytics.logEvent({
                action: 'setIceConfig',
                variation: 'Failure',
                payload: {
                  newIceConfig
                }
              });
              throw _context.t0;
            case 19:
              analytics.logEvent({
                action: 'setIceConfig',
                variation: 'Success',
                payload: {
                  newIceConfig
                }
              });
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[10, 15]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    /**
    * Subscribes to a stream that is available to the session. You can get an array of
    * available streams from the <code>streams</code> property of the <code>sessionConnected</code>
    * and <code>streamCreated</code> events (see
    * <a href="SessionConnectEvent.html">SessionConnectEvent</a> and
    * <a href="StreamEvent.html">StreamEvent</a>).
    * </p>
    * <p>
    * The subscribed stream is displayed on the local web page by replacing the specified element
    * in the DOM with a streaming video display. If the width and height of the display do not
    * match the 4:3 aspect ratio of the video signal, the video stream is cropped to fit
    * the display. If the stream lacks a video component, a blank screen with an audio indicator
    * is displayed in place of the video stream.
    * </p>
    *
    * <p>
    * The application throws an error if the session is not connected<!--JS-ONLY--> or if the
    * <code>targetElement</code> does not exist in the HTML DOM<!--/JS-ONLY-->.
    * </p>
    *
    * <h5>Example</h5>
    *
    * The following code subscribes to other clients' streams:
    *
    * <pre>
    * var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
    * var sessionID = ""; // Replace with your own session ID.
    *                     // See https://tokbox.com/developer/guides/create-session/.
    * var token = ""; // Replace with a generated token.
    *                 // See https://tokbox.com/developer/guides/create-token/.
    *
    * var session = OT.initSession(apiKey, sessionID);
    * session.on("streamCreated", function(event) {
    *   subscriber = session.subscribe(event.stream, targetElement);
    * });
    * session.connect(token);
    * </pre>
    *
    * @param {Stream} stream The Stream object representing the stream to which we are trying to
    * subscribe.
    *
    * @param {Object} targetElement (Optional) The DOM element or the <code>id</code> attribute of
    * the existing DOM element used to determine the location of the Subscriber video in the HTML
    * DOM. See the <code>insertMode</code> property of the <code>properties</code> parameter. If
    * you do not specify a <code>targetElement</code>, the application appends a new DOM element
    * to the HTML <code>body</code>.
    *
    * @param {Object} properties This is an object that contains the following properties:
    *    <ul>
    *       <li><code>audioVolume</code> (Number) &#151; The desired audio volume, between 0 and
    *       100, when the Subscriber is first opened (default: 50). After you subscribe to the
    *       stream, you can adjust the volume by calling the
    *       <a href="Subscriber.html#setAudioVolume"><code>setAudioVolume()</code> method</a> of the
    *       Subscriber object. This volume setting affects local playback only; it does not affect
    *       the stream's volume on other clients.</li>
    *
    *       <li>
    *         <code>fitMode</code> (String) &#151; Determines how the video is displayed if the its
    *           dimensions do not match those of the DOM element. You can set this property to one of
    *           the following values:
    *           <p>
    *           <ul>
    *             <li>
    *               <code>"cover"</code> &mdash; The video is cropped if its dimensions do not match
    *               those of the DOM element. This is the default setting for videos that have a
    *               camera as the source (for Stream objects with the <code>videoType</code> property
    *               set to <code>"camera"</code>).
    *             </li>
    *             <li>
    *               <code>"contain"</code> &mdash; The video is letterboxed if its dimensions do not
    *               match those of the DOM element. This is the default setting for screen-sharing
    *               videos (for Stream objects with the <code>videoType</code> property set to
    *               <code>"screen"</code>).
    *             </li>
    *           </ul>
    *       </li>
    *
    *       <li>
    *       <code>height</code> (Number or String) &#151; The desired initial height of the displayed
    *       video in the HTML page (default: 198 pixels). You can specify the number of pixels as
    *       either a number (such as 300) or a string ending in "px" (such as "300px"). Or you can
    *       specify a percentage of the size of the parent element, with a string ending in "%"
    *       (such as "100%"). <i>Note:</i> To resize the video, adjust the CSS of the subscriber's
    *       DOM element (the <code>element</code> property of the Subscriber object) or (if the
    *       height is specified as a percentage) its parent DOM element (see
    *       <a href="https://tokbox.com/developer/guides/customize-ui/js/#video_resize_reposition">
    *       Resizing or repositioning a video</a>).
    *       </li>
    *       <li>
    *       <strong>insertDefaultUI</strong> (Boolean) &#151; Whether to use the default Vonage Video API UI
    *       (<code>true</code>, the default) or not (<code>false</code>). The default UI element
    *       contains user interface controls, a video loading indicator, and automatic video cropping
    *       or letterboxing, in addition to the video. (If you leave <code>insertDefaultUI</code>
    *       set to <code>true</code>, you can control individual UI settings using the
    *       <code>fitMode</code>, <code>showControls</code>, and <code>style</code> options.)
    *       <p>
    *       If you set this option to <code>false</code>, OpenTok.js does not insert a default UI
    *       element in the HTML DOM, and the <code>element</code> property of the Subscriber object is
    *       undefined. The Subscriber object dispatches a
    *       <a href="Subscriber.html#event:videoElementCreated">videoElementCreated</a> event when
    *       the <code>video</code> element (or in Internet Explorer the <code>object</code> element
    *       containing the video) is created. The <code>element</code> property of the event object
    *       is a reference to the Subscriber's <code>video</code> (or <code>object</code>) element.
    *       Add it to the HTML DOM to display the video.
    *       <p>
    *       Set this option to <code>false</code> if you want to move the Publisher's
    *       <code>video</code> element (or its <code>object</code> element in Internet Explorer) in
    *       the HTML DOM.
    *       <p>
    *       If you set this to <code>false</code>, do not set the <code>targetElement</code>
    *       parameter. (This results in an error passed into to the <code>OT.initPublisher()</code>
    *       callback function.) To add the video to the HTML DOM, add an event listener for the
    *       <code>videoElementCreated</code> event, and then add the <code>element</code> property of
    *       the event object into the HTML DOM.
    *       </li>
    *       <li>
    *         <code>insertMode</code> (String) &#151; Specifies how the Subscriber object will
    *         be inserted in the HTML DOM. See the <code>targetElement</code> parameter. This
    *         string can have the following values:
    *         <p>
    *         <ul>
    *           <li><code>"replace"</code> &#151; The Subscriber object replaces contents of the
    *             targetElement. This is the default.</li>
    *           <li><code>"after"</code> &#151; The Subscriber object is a new element inserted
    *             after the targetElement in the HTML DOM. (Both the Subscriber and targetElement
    *             have the same parent element.)</li>
    *           <li><code>"before"</code> &#151; The Subscriber object is a new element inserted
    *             before the targetElement in the HTML DOM. (Both the Subscriber and targetElement
    *             have the same parent element.)</li>
    *           <li><code>"append"</code> &#151; The Subscriber object is a new element added as a
    *             child of the targetElement. If there are other child elements, the Subscriber is
    *             appended as the last child element of the targetElement.</li>
    *         </ul></p>
    *   <li>
    *   <code>preferredFrameRate</code> (Number) &#151; The preferred frame rate of the subscriber's
    *   video. Lowering the preferred frame rate lowers video quality on the subscribing client,
    *   but it also reduces network and CPU usage. You may want to use a lower frame rate for
    *   subscribers to a stream that is less important than other streams.
    *   <p>
    *   This property only applies when subscribing to a stream that uses the
    *   <a href="https://tokbox.com/developer/guides/scalable-video">
    *   scalable video feature</a>. Scalable video is available:
    *   <ul>
    *   <li>
    *     Only in sessions that use the Vonage Video API Media Router (sessions with the
    *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media
    *     mode</a> set to routed).
    *   </li>
    *   <li>
    *     Only for streams published by clients that support scalable video:
    *     clients that use the Vonage Video API iOS SDK (on certain devices), the Vonage Video API
    *     Android SDK (on certain devices), or OpenTok.js in Chrome and Safari.
    *   </li>
    *   </ul>
    *   <p>
    *   In streams that do not use scalable video, setting this property has no effect.
    *   <p>
    *   <b>Note:</b> The frame rate for scalable video streams automatically adjusts for each
    *   subscriber, based on network conditions and CPU usage, even if you do not call this method.
    *   Call this method if you want to set a maximum frame rate for this subscriber.
    *   <p>
    *   <p>
    *   Not every frame rate is available to a subscriber. When you set the preferred frame rate for
    *   the subscriber, OpenTok.js picks the best frame rate available that matches your setting.
    *   The frame rates available are based on the value of the Subscriber object's
    *   <code>stream.frameRate</code> property, which represents the maximum value available for the
    *   stream. The actual frame rates available depend, dynamically, on network and CPU resources
    *   available to the publisher and subscriber.
    *   <p>
    *   You can dynamically change the preferred frame rate used by calling the
    *   <code>setPreferredFrameRate()</code> method of the Subscriber object.
    *   </li>
    *   <li>
    *   <p>
    *   <code>preferredResolution</code> (String | Object) &#151; The preferred resolution of the subscriber's
    *   video. Set this to <code>"auto"</code> (a string, recommended) to have OpenTok.js
    *   set the resolution based on the subscriber's dimensions in the browser.
    *   Or set this to an object with two properties: <code>width</code> and <code>height</code>
    *   (both numbers), such as <code>{width: 320, height: 240}</code>. Lowering the preferred video
    *   resolution lowers video quality on the subscribing client, but it also reduces network and CPU
    *   usage. You may want to use a lower resolution based on the dimensions of subscriber's video on
    *   the web page (which is handled automatically with the <code>"auto"</code> setting).
    *   Or you may want to use a resolution for subscribers to a stream that is less
    *   important (and smaller) than other streams.
    * <p>
    *   <i>Note:</i> The <code>"auto"</code> resolution setting only applies
    *   when you use the default Subscriber Video element created by the SDK.
    *   It does not work if you create your own Video element in response to
    *   the <code>mediaStreamAvailable</code> event (see
    *   <a href="https://tokbox.com/developer/guides/customize-ui/js/#media-stream-available">this topic</a>).
    *   <p>
    *   This property only applies when subscribing to a stream that uses the
    *   <a href="https://tokbox.com/developer/guides/scalable-video">
    *   scalable video feature</a>. Scalable video is available:
    *   <ul>
    *   <li>
    *     Only in sessions that use the Vonage Video API Media Router (sessions with the
    *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media
    *     mode</a> set to routed).
    *   </li>
    *   <li>
    *     Only for streams published by clients that support scalable video:
    *     clients that use the Vonage Video API iOS SDK (on certain devices), the Vonage Video API
    *     Android SDK (on certain devices), or OpenTok.js in Chrome and Safari.
    *   </li>
    *   </ul>
    *   <p>
    *   In streams that do not use scalable video, setting this property has no effect.
    *   <p>
    *   Not every resolution is available to a subscriber. When you set the preferred resolution,
    *   OpenTok.js and the video encoder pick the best resolution available that matches your
    *   setting. The resolutions available depend on the resolution of the published stream.
    *   The Subscriber object's <code>stream.resolution</code> property  represents the highest
    *   resolution available for the stream. Each of the resolutions available for a stream will use
    *   the same aspect ratio. The actual resolutions available depend, dynamically, on network
    *   and CPU resources available to the publisher and subscriber.
    *   <p>
    *   You can dynamically change the preferred video resolution used by calling the
    *   <code>setPreferredResolution()</code> method of the Subscriber object.
    *   </li>
    *   <li>
    *   <code>showControls</code> (Boolean) &#151; Whether to display the built-in user interface
    *   controls for the Subscriber (default: <code>true</code>). These controls include the name
    *   display, the audio level indicator, the speaker control button, the video disabled indicator,
    *   and the video disabled warning icon. You can turn off all user interface controls by setting
    *   this property to <code>false</code>. You can control the display of individual user interface
    *   controls by leaving this property set to <code>true</code> (the default) and setting
    *   individual properties of the <code>style</code> property.
    *   </li>
    *   <li>
    *   <code>style</code> (Object) &#151; An object containing properties that define the initial
    *   appearance of user interface controls of the Subscriber. The <code>style</code> object
    *   includes the following properties:
    *     <ul>
    *       <li><code>audioBlockedDisplayMode</code> (String) &mdash; Whether to display
    *       the default audio blocked icon in Subscribers (in browsers where audio
    *       autoplay is blocked). Possible values are: <code>"auto"</code> (the default,
    *       icon is displayed when the audio is disabled) and <code>"off"</code> (the icon
    *       is not displayed). Set this to <code>"off"</code> if you want to display
    *       your own UI element showing that the audio is blocked. In response to an
    *       HTML element dispatching a <code>click</code> event, you can call the
    *       <a href="OT.html#unblockAudio">OT.unblockAudio()</a> method to start audio
    *       playback in this and all other blocked subscribers.</li>
    *
    *       <li><code>audioLevelDisplayMode</code> (String) &mdash; How to display the audio level
    *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
    *       video is disabled), <code>"off"</code> (the indicator is not displayed), and
    *       <code>"on"</code> (the indicator is always displayed).</li>
    *
    *       <li><code>backgroundImageURI</code> (String) &mdash; A URI for an image to display as
    *       the background image when a video is not displayed. (A video may not be displayed if
    *       you call <code>subscribeToVideo(false)</code> on the Subscriber object). You can pass an
    *       http or https URI to a PNG, JPEG, or non-animated GIF file location. You can also use the
    *       <code>data</code> URI scheme (instead of http or https) and pass in base-64-encrypted
    *       PNG data, such as that obtained from the
    *       <a href="Subscriber.html#getImgData">Subscriber.getImgData()</a> method. (For example,
    *       you could set the property to a value returned by calling <code>getImgData()</code> on
    *       a previous Subscriber object.) If the URL or the image data is invalid, the
    *       property is ignored (the attempt to set the image fails silently).</li>
    *
    *       <li><code>buttonDisplayMode</code> (String) &mdash; How to display the speaker controls
    *       Possible values are: <code>"auto"</code> (controls are displayed when the stream is first
    *       displayed and when the user mouses over the display), <code>"off"</code> (controls are not
    *       displayed), and <code>"on"</code> (controls are always displayed).</li>
    *
    *       <li><code>nameDisplayMode</code> (String) &#151; Whether to display the stream name.
    *       Possible values are: <code>"auto"</code> (the name is displayed when the stream is first
    *       displayed and when the user mouses over the display), <code>"off"</code> (the name is not
    *       displayed), and <code>"on"</code> (the name is always displayed).</li>
    *
    *       <li><code>videoDisabledDisplayMode</code> (String) &#151; Whether to display the video
    *       disabled indicator and video disabled warning icons for a Subscriber. These icons
    *       indicate that the video has been disabled (or is at risk of being disabled for
    *       the warning icon) due to poor stream quality. This style only applies to the Subscriber
    *       object. Possible values are: <code>"auto"</code> (the icons are automatically when the
    *       displayed video is disabled or at risk of being disabled due to poor stream quality),
    *       <code>"off"</code> (do not display the icons), and <code>"on"</code> (display the
    *       icons). The default setting is <code>"auto"</code></li>
    *   </ul>
    *   </li>
    *
    *       <li><code>subscribeToAudio</code> (Boolean) &#151; Whether to initially subscribe to audio
    *       (if available) for the stream (default: <code>true</code>).</li>
    *
    *       <li><code>subscribeToVideo</code> (Boolean) &#151; Whether to initially subscribe to video
    *       (if available) for the stream (default: <code>true</code>).</li>
    *
    *       <li><code>testNetwork</code> (Boolean) &#151; Whether, when subscribing to a stream
    *       published by the local client, you want to have the stream come from the Vonage Video API Media
    *       Router (<code>true</code>) or if you want the DOM to simply to display the local camera's
    *       video (<code>false</code>). Set this to <code>true</code> when you want to use the
    *       <a href="Subscriber.html#getStats">Subscriber.getStats()</a> method to check statistics
    *       for a stream you publish. This setting only applies to streams published by the local
    *       client in a session that uses the Vonage Video API Media Router (sessions with the
    *       <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media mode</a>
    *       set to routed), not in sessions with the media mode set to relayed. The default value is
    *       <code>false</code>.</li>
    *
    *       <li>
    *       <code>width</code> (Number or String) &#151; The desired initial width of the displayed
    *       video in the HTML page (default: 264 pixels). You can specify the number of pixels as
    *       either a number (such as 400) or a string ending in "px" (such as "400px"). Or you can
    *       specify a percentage of the size of the parent element, with a string ending in "%"
    *       (such as "100%"). <i>Note:</i> To resize the video, adjust the CSS of the subscriber's
    *       DOM element (the <code>element</code> property of the Subscriber object) or (if the
    *       width is specified as a percentage) its parent DOM element (see
    *       <a href="https://tokbox.com/developer/guides/customize-ui/js/#video_resize_reposition">
    *       Resizing or repositioning a video</a>).
    *       </li>
    *
    *    </ul>
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>subscribe()</code> method succeeds or fails. This function takes one parameter &mdash;
    * <code>error</code>. On success, the <code>completionHandler</code> function is not passed any
    * arguments. On error, the function is passed an <code>error</code> object, defined by the
    * <a href="Error.html">Error</a> class, has two properties: <code>code</code> (an integer) and
    * <code>message</code> (a string), which identify the cause of the failure. The following
    * code adds a <code>completionHandler</code> when calling the <code>subscribe()</code> method:
    * <pre>
    * session.subscribe(stream, "subscriber", null, function (error) {
    *   if (error) {
    *     console.log(error.message);
    *   } else {
    *     console.log("Subscribed to stream: " + stream.id);
    *   }
    * });
    * </pre>
    *
    * @signature subscribe(stream, targetElement, properties, completionHandler)
    * @returns {Subscriber} The Subscriber object for this stream. Stream control functions
    * are exposed through the Subscriber object.
    * @method #subscribe
    * @memberOf Session
    */
    this.subscribe = function (stream, targetElement, properties, completionHandler) {
      var _this$connection;
      if (typeof targetElement === 'function') {
        completionHandler = targetElement;
        targetElement = undefined;
        properties = undefined;
      }
      if (typeof properties === 'function') {
        completionHandler = properties;
        properties = undefined;
      }
      completionHandler = completionHandler || function () {};
      if (!((_this$connection = this.connection) != null && _this$connection.connectionId)) {
        dispatchOTError(otError(errors.NOT_CONNECTED, new Error('Session.subscribe :: Connection required to subscribe'), ExceptionCodes.UNABLE_TO_SUBSCRIBE), completionHandler);
        return undefined;
      }
      if (!stream) {
        dispatchOTError(otError(errors.INVALID_PARAMETER, new Error('Session.subscribe :: stream cannot be null'), ExceptionCodes.UNABLE_TO_SUBSCRIBE), completionHandler);
        return undefined;
      }
      if (!Object.prototype.hasOwnProperty.call(stream, 'streamId')) {
        dispatchOTError(otError(errors.INVALID_PARAMETER, new Error('Session.subscribe :: invalid stream object'), ExceptionCodes.UNABLE_TO_SUBSCRIBE), completionHandler);
        return undefined;
      }
      if (properties && properties.insertDefaultUI === false && targetElement) {
        dispatchOTError(otError(errors.INVALID_PARAMETER, new Error('You cannot specify a target element if insertDefaultUI is false'), ExceptionCodes.INVALID_PARAMETER), completionHandler);
        return undefined;
      }
      if (targetElement && targetElement.insertDefaultUI === false) {
        // You can omit the targetElement property if you set insertDefaultUI to false
        properties = targetElement;
        targetElement = undefined;
      }
      const subscriber = new Subscriber(targetElement, (0, _assign.default)(properties || {}, {
        stream,
        session: this,
        // @todo this needs to go.
        analytics
      }), err => {
        if (err) {
          dispatchOTError(err, completionHandler);
          return;
        }
        completionHandler(null, subscriber);
      });
      sessionObjects.subscribers.add(subscriber);
      return subscriber;
    };

    /**
    * Stops subscribing to a stream in the session. the display of the audio-video stream is
    * removed from the local web page.
    *
    * <h5>Example</h5>
    * <p>
    * The following code subscribes to other clients' streams. For each stream, the code also
    * adds an Unsubscribe link.
    * </p>
    * <pre>
    * var apiKey = ""; // Replace with your API key. See See https://tokbox.com/account
    * var sessionID = ""; // Replace with your own session ID.
    *                     // See https://tokbox.com/developer/guides/create-session/.
    * var token = ""; // Replace with a generated token.
    *                 // See https://tokbox.com/developer/guides/create-token/.
    * var streams = [];
    *
    * var session = OT.initSession(apiKey, sessionID);
    * session.on("streamCreated", function(event) {
    *     var stream = event.stream;
    *     displayStream(stream);
    * });
    * session.connect(token);
    *
    * function displayStream(stream) {
    *     var div = document.createElement('div');
    *     div.setAttribute('id', 'stream' + stream.streamId);
    *
    *     var subscriber = session.subscribe(stream, div);
    *     subscribers.push(subscriber);
    *
    *     var aLink = document.createElement('a');
    *     aLink.setAttribute('href', 'javascript: unsubscribe("' + subscriber.id + '")');
    *     aLink.innerHTML = "Unsubscribe";
    *
    *     var streamsContainer = document.getElementById('streamsContainer');
    *     streamsContainer.appendChild(div);
    *     streamsContainer.appendChild(aLink);
    *
    *     streams = event.streams;
    * }
    *
    * function unsubscribe(subscriberId) {
    *     console.log("unsubscribe called");
    *     for (var i = 0; i &lt; subscribers.length; i++) {
    *         var subscriber = subscribers[i];
    *         if (subscriber.id == subscriberId) {
    *             session.unsubscribe(subscriber);
    *         }
    *     }
    * }
    * </pre>
    *
    * @param {Subscriber} subscriber The Subscriber object to unsubcribe.
    *
    * @see <a href="#subscribe">subscribe()</a>
    *
    * @method #unsubscribe
    * @memberOf Session
    */
    this.unsubscribe = function (subscriber) {
      if (!subscriber) {
        const errorMsg = 'OT.Session.unsubscribe: subscriber cannot be null';
        _logging.error(errorMsg);
        throw new Error(errorMsg);
      }
      if (!subscriber.stream) {
        _logging.warn('OT.Session.unsubscribe:: tried to unsubscribe a subscriber that had no stream');
        return false;
      }
      _logging.debug(`OT.Session.unsubscribe: subscriber ${subscriber.id}`);
      subscriber._destroy({
        reason: 'Unsubscribe'
      });
      return true;
    };

    /**
    * Returns an array of local Subscriber objects for a given stream.
    *
    * @param {Stream} stream The stream for which you want to find subscribers.
    *
    * @returns {Array} An array of {@link Subscriber} objects for the specified stream.
    *
    * @see <a href="#unsubscribe">unsubscribe()</a>
    * @see <a href="Subscriber.html">Subscriber</a>
    * @see <a href="StreamEvent.html">StreamEvent</a>
    * @method #getSubscribersForStream
    * @memberOf Session
    */
    this.getSubscribersForStream = function (stream) {
      return sessionObjects.subscribers.where({
        streamId: stream.id
      });
    };

    /**
    * Returns the local Publisher object for a given stream.
    *
    * @param { Stream } stream The stream for which you want to find the Publisher.
    *
    * @returns { Publisher } A Publisher object for the specified stream. Returns
    * <code>null</code> if there is no local Publisher object
    * for the specified stream.
    *
    * @see <a href="#forceUnpublish">forceUnpublish()</a>
    * @see <a href="Subscriber.html">Subscriber</a>
    * @see <a href="StreamEvent.html">StreamEvent</a>
    *
    * @method #getPublisherForStream
    * @memberOf Session
    */
    this.getPublisherForStream = function (stream) {
      let streamId;
      let errorMsg;
      if (typeof stream === 'string') {
        streamId = stream;
      } else if (typeof stream === 'object' && stream && Object.hasOwnProperty.call(stream, 'id')) {
        streamId = stream.id;
      } else {
        errorMsg = 'Session.getPublisherForStream :: Invalid stream type';
        _logging.error(errorMsg);
        throw new Error(errorMsg);
      }
      return sessionObjects.publishers.where({
        streamId
      })[0];
    };

    // Private Session API: for internal OT use only

    this._ = {
      getProxyUrl() {
        return proxyUrl;
      },
      getCpuPerformanceState() {
        return _cpuPerformanceState;
      },
      isE2ee() {
        return _session.sessionInfo.e2ee && _e2eeSecretSet && !!_session.capabilities.supportsE2ee;
      },
      isSpc() {
        return _useSinglePeerConnection;
      },
      isSocketReconnecting() {
        return _isSocketReconnecting;
      },
      isSocketConnected() {
        var _socket4;
        return ((_socket4 = _socket) == null ? void 0 : _socket4.is('connected')) && !_isSocketReconnecting;
      },
      getSocket() {
        return _socket;
      },
      reconnecting: function () {
        _isSocketReconnecting = true;
        this.dispatchEvent(new Events.SessionReconnectingEvent());
      }.bind(this),
      reconnected: function () {
        _isSocketReconnecting = false;
        this.dispatchEvent(new Events.SessionReconnectedEvent());
        if (this.sessionInfo.reconnection) {
          var _this$session, _this$session$session;
          sessionObjects.publishers.where({
            session: this
          }).forEach(publisher => {
            publisher._.iceRestart();
          });
          if (!((_this$session = this.session) != null && (_this$session$session = _this$session.sessionInfo) != null && _this$session$session.p2pEnabled)) {
            sessionObjects.subscribers.where({
              session: this
            }).forEach(subscriber => {
              subscriber._.iceRestart('socket reconnected');
            });
          }
        }
      }.bind(this),
      // session.on("signal", function(SignalEvent))
      // session.on("signal:{type}", function(SignalEvent))
      dispatchSignal: function (fromConnection, type, data) {
        const event = new Events.SignalEvent(type, data, fromConnection);
        event.target = this;

        // signal a "signal" event
        // NOTE: trigger doesn't support defaultAction, and therefore preventDefault.
        this.trigger(_eventNames.default.SIGNAL, event);

        // signal an "signal:{type}" event" if there was a custom type
        if (type) {
          this.dispatchEvent(event);
        }
      }.bind(this),
      dispatchCaption: function (fromConnection, data) {
        let caption;
        let streamId;
        let isFinal;
        try {
          const parsedData = JSON.parse(data.data);
          caption = parsedData.caption.text;
          streamId = parsedData.streamId;
          isFinal = parsedData.isFinal;
        } catch (error) {
          _logging.error(`Caption parsing failed: ${error.message}`);
          return;
        }
        const event = new Events.CaptionReceivedEvent(caption, streamId, isFinal);
        event.target = this;
        this.trigger(_eventNames.default.SUBSCRIBER_CAPTION_RECEIVED, event);
        this.dispatchEvent(event);
      }.bind(this),
      subscriberChannelUpdate(stream, subscriber, channel, attributes) {
        if (!_socket) {
          _logging.warn('You are disconnected, cannot update subscriber properties ', attributes);
          return null;
        }
        return _socket.subscriberChannelUpdate(stream.id, subscriber.widgetId, channel.id, attributes);
      },
      streamCreate(_temp2, completion) {
        let _ref4 = _temp2 === void 0 ? {} : _temp2,
          name = _ref4.name,
          streamId = _ref4.streamId,
          subscriberAudioFallbackEnabled = _ref4.subscriberAudioFallbackEnabled,
          channels = _ref4.channels,
          minBitrate = _ref4.minBitrate,
          sourceStreamId = _ref4.sourceStreamId,
          e2ee = _ref4.e2ee,
          publisherAudioFallbackEnabled = _ref4.publisherAudioFallbackEnabled,
          customProperties = _ref4.customProperties;
        if (!_socket) {
          _logging.warn('You are disconnected, cannot create stream ', streamId);
          return;
        }
        _socket.streamCreate({
          name,
          streamId,
          subscriberAudioFallbackEnabled,
          channels,
          minBitrate,
          maxBitrate: undefined,
          // Do not expose maxBitrate to the end user,
          sourceStreamId,
          e2ee,
          publisherAudioFallbackEnabled,
          customProperties
        }, completion);
      },
      streamDestroy(streamId, sourceStreamId) {
        if (!_socket) {
          _logging.warn('You are disconnected, cannot destroy stream ', streamId);
          return;
        }
        _socket.streamDestroy(streamId, sourceStreamId);
      },
      streamChannelUpdate(stream, channel, attributes) {
        if (!_socket) {
          _logging.warn('You are disconnected, cannot update stream properties ', attributes);
          return;
        }
        _socket.streamChannelUpdate(stream.id, channel.id, attributes);
      },
      // allow these variables to be overridden in unit tests
      // it's dirty, but I figure it can be cleaned up when we implement proper DI for our unit tests
      setSocket(newSocket) {
        _socket = newSocket;
      },
      setLogging(newLogging) {
        _logging = newLogging;
      },
      setState,
      setIceServers(iceServers) {
        if (!iceServers) {
          return;
        }
        _iceServerDetails = {
          iceServers: adaptIceServers(iceServers),
          timestamp: Date.now()
        };
      },
      getOtIceServerInfo() {
        const timeElapsed = !_iceServerDetails ? Infinity : Date.now() - _iceServerDetails.timestamp;
        const validDuration = 24 * 60 * 60 * 1000; // 24 hours
        const validTimeRemaining = validDuration - timeElapsed;
        const fiveMinutes = 5 * 60 * 1000;
        if (validTimeRemaining > fiveMinutes) {
          return Promise.resolve({
            transportPolicy: _session && _session.sessionInfo && _session.sessionInfo.clientCandidates,
            servers: _iceServerDetails && _iceServerDetails.iceServers
          });
        }
        if (!_token) {
          // @todo why would this happen before connect() where a token is set?

          // Need a token for getting ICE servers from GSI
          return Promise.resolve({
            transportPolicy: _session && _session.sessionInfo && _session.sessionInfo.clientCandidates,
            servers: [],
            needRumorIceServersFallback: true
          });
        }
        const clientVersion = localStaticConfig.clientVersion;
        return getSessionInfo({
          anvilUrl: (this.staticConfig || localStaticConfig).apiUrl,
          sessionId,
          token: _token,
          connectionId: _connectionId,
          clientVersion
        }).then(sessionInfo => {
          _session._.setIceServers(sessionInfo.iceServers);
          if (!_iceServerDetails) {
            // No ICE servers provided by GSI
            return {
              transportPolicy: _session.sessionInfo.clientCandidates,
              servers: [],
              needRumorIceServersFallback: true
            };
          }
          return {
            transportPolicy: _session && _session.sessionInfo && _session.sessionInfo.clientCandidates,
            servers: _iceServerDetails && _iceServerDetails.iceServers
          };
        });
      },
      getCodecFlags: () => ({
        h264: _session.sessionInfo.h264,
        vp9: _session.sessionInfo.vp9,
        vp8: _session.sessionInfo.vp8
      }),
      getVideoCodecsCompatible: webRTCStream => (0, _testRemovingVideoCodecs.default)({
        RTCPeerConnection: windowMock.RTCPeerConnection,
        env: OTHelpers.env,
        stream: webRTCStream,
        codecFlags: _session._.getCodecFlags()
      }),
      getIceConfig: () => {
        if (!iceConfig) {
          return _session._.getOtIceServerInfo();
        }
        const transportPolicy = (() => {
          if (iceConfig && iceConfig.transportPolicy === 'relay') {
            return 'relay';
          }
          return _session.sessionInfo.clientCandidates;
        })();
        const otIceServersInfoPromise = iceConfig.includeServers === 'custom' ? Promise.resolve({
          servers: []
        }) : _session._.getOtIceServerInfo();
        return otIceServersInfoPromise.then(otIceServerInfo => (0, _assign.default)(otIceServerInfo, {
          transportPolicy,
          servers: [...otIceServerInfo.servers, ...iceConfig.customServers]
        }));
      },
      forceMute: function (muteForcedInfo) {
        this.dispatchEvent(new Events.MuteForcedEvent(muteForcedInfo));
      }.bind(this),
      enableMuteOnEntry: () => {
        _muteOnEntry = true;
      },
      addSubscriberToPeerConnectionsQueue: (pc, message) => {
        _subscribersQueue.push({
          pc,
          message
        });
        if (!_subscribersQueueInterval) {
          _subscribersQueueInterval = setInterval(() => {
            const offer = _subscribersQueue.shift();
            if (offer) {
              offer.pc.processMessage('offer', offer.message);
            } else {
              clearInterval(_subscribersQueueInterval);
              _subscribersQueueInterval = null;
            }
          }, 100);
        }
      },
      disableMuteOnEntry: () => {
        _muteOnEntry = false;
      },
      shouldAddStream: stream => {
        const id = stream.id,
          sourceStreamId = stream.sourceStreamId;
        if (!this.streams.has(id)) {
          return true;
        }

        // Find the corresponding subscriber and check if it is Mantis
        const _sessionObjects$subsc2 = sessionObjects.subscribers.where({
            streamId: id
          }),
          subscriber = _sessionObjects$subsc2[0];
        const isMantisSubscriber = subscriber && sourceStreamId === 'MANTIS';

        // We should add the stream if we are migrating and creating a new Mantis Subscriber
        return this.is('migrating') && isMantisSubscriber;
      },
      migrate: () => {
        setState('migrating');
        this.logEvent('Migrate', 'Attempt');
        const onSessionInfo = sessionInfo => {
          const currentMessagingUrl = _messagingUrl;
          analytics.sessionInfo = sessionInfo;
          setSessionInfo(sessionInfo);
          connectMessenger.call(this);
          const previousSinglePeerConnectionController = this._singlePeerConnectionController;
          if (previousSinglePeerConnectionController) {
            // Create a new SPC controller for the new Mantis
            this._singlePeerConnectionController = new SinglePeerConnectionController(this);
          }
          setTimeout(() => {
            // Disconnect old Rumor
            _sockets[currentMessagingUrl].disconnect();
            delete _sockets[currentMessagingUrl];

            // Disconnect previous publisher and subcribers
            sessionObjects.publishers.forEach(publisher => publisher._.finishMigration());
            sessionObjects.subscribers.forEach(subscriber => subscriber._.finishMigration());
            if (previousSinglePeerConnectionController) {
              previousSinglePeerConnectionController.closeAfterSubscriberRemovals();
            }
            setState('connected');
            this.trigger('migrated');
            this.logEvent('Migrate', 'Success');
          }, this.MIGRATION_TIMEOUT);
        };
        const targetUrl = (0, _proxyUrlHelper.default)(this.staticConfig.apiUrl, proxyUrl);

        // GSI
        getSessionInfo({
          anvilUrl: targetUrl,
          sessionId,
          token: _token,
          connectionId: _connectionId,
          clientVersion: this.staticConfig.clientVersion
        }).then(onSessionInfo, () => {
          _logging.error('Session migration has failed');
          this.logEvent('Migrate', 'Failed');
        });
      },
      testMigrate: () => {
        if (this.isNot('migrating')) {
          var _socket5;
          (_socket5 = _socket) == null ? void 0 : _socket5.migrateSession();
        } else {
          _logging.warn('Session is currently migrating');
        }
      },
      privateEvents: new _events.default()
    };

    /**
    * Sends a signal to each client or a specified client in the session. Specify a
    * <code>to</code> property of the <code>signal</code> parameter to limit the signal to
    * be sent to a specific client; otherwise the signal is sent to each client connected to
    * the session.
    * <p>
    * The following example sends a signal of type "foo" with a specified data payload ("hello")
    * to all clients connected to the session:
    * <pre>
    * session.signal({
    *     type: "foo",
    *     data: "hello"
    *   },
    *   function(error) {
    *     if (error) {
    *       console.log("signal error: " + error.message);
    *     } else {
    *       console.log("signal sent");
    *     }
    *   }
    * );
    * </pre>
    * <p>
    * Calling this method without specifying a recipient client (by setting the <code>to</code>
    * property of the <code>signal</code> parameter) results in multiple signals sent (one to each
    * client in the session). For information on charges for signaling, see the
    * <a href="https://www.vonage.com/communications-apis/video/pricing/">Vonage Video API pricing</a> page.
    * <p>
    * The following example sends a signal of type "foo" with a data payload ("hello") to a
    * specific client connected to the session:
    * <pre>
    * session.signal({
    *     type: "foo",
    *     to: recipientConnection; // a Connection object
    *     data: "hello"
    *   },
    *   function(error) {
    *     if (error) {
    *       console.log("signal error: " + error.message);
    *     } else {
    *       console.log("signal sent");
    *     }
    *   }
    * );
    * </pre>
    * <p>
    * Add an event handler for the <code>signal</code> event to listen for all signals sent in
    * the session. Add an event handler for the <code>signal:type</code> event to listen for
    * signals of a specified type only (replace <code>type</code>, in <code>signal:type</code>,
    * with the type of signal to listen for). The Session object dispatches these events. (See
    * <a href="#events">events</a>.)
    *
    * @param {Object} signal An object that contains the following properties defining the signal:
    * <ul>
    *   <li><code>data</code> &mdash; (String) The data to send. The limit to the length of data
    *     string is 8kB. Do not set the data string to <code>null</code> or
    *     <code>undefined</code>.</li>
    *   <li><code>retryAfterReconnect</code>&mdash; (Boolean) Upon reconnecting to the session,
    *     whether to send any signals that were initiated while disconnected. If your client loses its
    *     connection to the Vonage Video API session, due to a drop in network connectivity, the client
    *     attempts to reconnect to the session, and the Session object dispatches a
    *     <code>reconnecting</code> event. By default, signals initiated while disconnected are
    *     sent when (and if) the client reconnects to the Vonage Video API session. You can prevent this by
    *     setting the <code>retryAfterReconnect</code> property to <code>false</code>. (The default
    *     value is <code>true</code>.)
    *   <li><code>to</code> &mdash; (Connection) A <a href="Connection.html">Connection</a>
    *      object corresponding to the client that the message is to be sent to. If you do not
    *      specify this property, the signal is sent to all clients connected to the session.</li>
    *   <li><code>type</code> &mdash; (String) The type of the signal. You can use the type to
    *     filter signals when setting an event handler for the <code>signal:type</code> event
    *     (where you replace <code>type</code> with the type string). The maximum length of the
    *     <code>type</code> string is 128 characters, and it must contain only letters (A-Z and a-z),
    *     numbers (0-9), '-', '_', and '~'.</li>
    *   </li>
    * </ul>
    *
    * <p>Each property is optional. If you set none of the properties, you will send a signal
    * with no data or type to each client connected to the session.</p>
    *
    * @param {Function} completionHandler (Optional) A function that is called when sending the signal
    * succeeds or fails. This function takes one parameter &mdash; <code>error</code>.
    * On success, the <code>completionHandler</code> function is not passed any
    * arguments. On error, the function is passed an <code>error</code> object, defined by the
    * <a href="Error.html">Error</a> class. The <code>error</code> object has the following
    * properties:
    *
    * <ul>
    *   <li><code>code</code> &mdash; (Number) An error code, which can be one of the following:
    *     <table class="docs_table">
    *         <tr>
    *           <td>400</td> <td>One of the signal properties is invalid.</td>
    *         </tr>
    *         <tr>
    *           <td>404</td> <td>The client specified by the <code>to</code> property is not connected
    *                        to the session.</td>
    *         </tr>
    *         <tr>
    *           <td>413</td> <td>The <code>type</code> string exceeds the maximum length (128 bytes),
    *                        or the <code>data</code> string exceeds the maximum size (8 kB).</td>
    *         </tr>
    *         <tr>
    *           <td>500</td> <td>You are not connected to the Vonage Video API session.</td>
    *         </tr>
    *      </table>
    *   </li>
    *   <li><code>message</code> &mdash; (String) A description of the error.</li>
    * </ul>
    *
    * <p>Note that the <code>completionHandler</code> success result (<code>error == null</code>)
    * indicates that the options passed into the <code>Session.signal()</code> method are valid
    * and the signal was sent. It does <i>not</i> indicate that the signal was successfully
    * received by any of the intended recipients.
    *
    * @method #signal
    * @memberOf Session
    * @see <a href="#event:signal">signal</a> and <a href="#event:signal:type">signal:type</a> events
    */
    this.signal = function (options, completion) {
      let _options = options;
      let _completion = completion || function () {};
      if ((0, _isFunction.default)(_options)) {
        _completion = _options;
        _options = null;
      }
      if (!this.isConnected()) {
        const notConnectedErrorMsg = 'Unable to send signal - you are not connected to the session.';
        dispatchOTError(otError(errors.NOT_CONNECTED, new Error(notConnectedErrorMsg), 500), _completion);
        return;
      }
      function getErrorNameFromCode(code) {
        switch (code) {
          case 400:
          case 413:
            return errors.INVALID_PARAMETER;
          case 429:
            return errors.RATE_LIMIT_EXCEEDED;
          case 404:
            return errors.NOT_FOUND;
          case 500:
            return errors.NOT_CONNECTED;
          case 403:
            return errors.PERMISSION_DENIED;
          case 2001:
            return errors.UNEXPECTED_SERVER_RESPONSE;
          default:
            return undefined;
        }
      }
      if (!_socket) {
        dispatchSocketIsNullError('signal', _completion);
        return;
      }
      _socket.signal(_options, function (error) {
        if (error) {
          const errorName = getErrorNameFromCode(error.code);
          if (errorName) {
            error = otError(errorName, new Error(error.message), error.code);
          }
          _completion(error);
          return;
        }
        for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }
        _completion(error, ...args);
      }, this.logEvent);
      if (options && options.data && typeof options.data !== 'string') {
        _logging.warn('Signaling of anything other than Strings is deprecated. ' + 'Please update the data property to be a string.');
      }
    };

    /**
    *   Forces a remote connection to leave the session.
    *
    * <p>
    *   The <code>forceDisconnect()</code> method is normally used as a moderation tool
    *        to remove users from an ongoing session.
    * </p>
    * <p>
    *   When a connection is terminated using the <code>forceDisconnect()</code>,
    *        <code>sessionDisconnected</code>, <code>connectionDestroyed</code> and
    *        <code>streamDestroyed</code> events are dispatched in the same way as they
    *        would be if the connection had terminated itself using the <code>disconnect()</code>
    *        method. However, the <code>reason</code> property of a {@link ConnectionEvent} or
    *        {@link StreamEvent} object specifies <code>"forceDisconnected"</code> as the reason
    *        for the destruction of the connection and stream(s).
    * </p>
    * <p>
    *   While you can use the <code>forceDisconnect()</code> method to terminate your own connection,
    *        calling the <code>disconnect()</code> method is simpler.
    * </p>
    * <p>
    *   The OT object dispatches an <code>exception</code> event if the user's role
    *   does not include permissions required to force other users to disconnect.
    *   You define a user's role when you create the user token (see the
    *   <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
    *   See <a href="ExceptionEvent.html">ExceptionEvent</a> and <a href="OT.html#on">OT.on()</a>.
    * </p>
    * <p>
    *   The application throws an error if the session is not connected.
    * </p>
    *
    * <h5>Events dispatched:</h5>
    *
    * <p>
    *   <code>connectionDestroyed</code> (<a href="ConnectionEvent.html">ConnectionEvent</a>) &#151;
    *     On clients other than which had the connection terminated.
    * </p>
    * <p>
    *   <code>exception</code> (<a href="ExceptionEvent.html">ExceptionEvent</a>) &#151;
    *     The user's role does not allow forcing other user's to disconnect (<code>event.code =
    *     1530</code>),
    *   or the specified stream is not publishing to the session (<code>event.code = 1535</code>).
    * </p>
    * <p>
    *   <code>sessionDisconnected</code>
    *   (<a href="SessionDisconnectEvent.html">SessionDisconnectEvent</a>) &#151;
    *     On the client which has the connection terminated.
    * </p>
    * <p>
    *   <code>streamDestroyed</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    *     If streams are stopped as a result of the connection ending.
    * </p>
    *
    * @param {Connection} connection The connection to be disconnected from the session.
    * This value can either be a <a href="Connection.html">Connection</a> object or a connection
    * ID (which can be obtained from the <code>connectionId</code> property of the Connection object).
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>forceDiscononnect()</code> method succeeds or fails. This function takes one parameter
    * &mdash; <code>error</code>. On success, the <code>completionHandler</code> function is
    * not passed any arguments. On error, the function is passed an <code>error</code> object
    * parameter. The <code>error</code> object, defined by the <a href="Error.html">Error</a>
    * class, has two properties: <code>code</code> (an integer)
    * and <code>message</code> (a string), which identify the cause of the failure.
    * Calling <code>forceDisconnect()</code> fails if the role assigned to your
    * token is not "moderator"; in this case the <code>error.name</code> property is set to
    * <code>"OT_PERMISSION_DENIED"</code>. The following code adds a <code>completionHandler</code>
    * when calling the <code>forceDisconnect()</code> method:
    * <pre>
    * session.forceDisconnect(connection, function (error) {
    *   if (error) {
    *     console.log(error);
    *   } else {
    *     console.log("Connection forced to disconnect: " + connection.id);
    *   }
    * });
    * </pre>
    *
    * @method #forceDisconnect
    * @memberOf Session
    */

    this.forceDisconnect = function (connectionOrConnectionId, completionHandler) {
      if (!this.isConnected()) {
        const notConnectedErrorMsg = 'Cannot call forceDisconnect(). You are not ' + 'connected to the session.';
        dispatchOTError(otError(errors.NOT_CONNECTED, new Error(notConnectedErrorMsg), ExceptionCodes.NOT_CONNECTED), completionHandler);
        return;
      }
      const connectionId = typeof connectionOrConnectionId === 'string' ? connectionOrConnectionId : connectionOrConnectionId.id;
      const invalidParameterErrorMsg = 'Invalid Parameter. Check that you have passed valid parameter values into the method call.';
      if (!connectionId) {
        dispatchOTError(otError(errors.INVALID_PARAMETER, new Error(invalidParameterErrorMsg), ExceptionCodes.INVALID_PARAMETER), completionHandler);
        return;
      }
      const notPermittedErrorMsg = 'This token does not allow forceDisconnect. ' + 'The role must be at least `moderator` to enable this functionality';
      if (!permittedTo('forceDisconnect')) {
        dispatchOTError(otError(errors.PERMISSION_DENIED, new Error(notPermittedErrorMsg), ExceptionCodes.UNABLE_TO_FORCE_DISCONNECT), completionHandler);
        return;
      }
      if (!_socket) {
        dispatchSocketIsNullError('forceDisconnect', completionHandler);
        return;
      }
      _socket.forceDisconnect(connectionId, function (err) {
        if (err) {
          dispatchOTError(otError(errors.INVALID_PARAMETER, new Error(invalidParameterErrorMsg), ExceptionCodes.INVALID_PARAMETER), completionHandler);
        } else if (completionHandler && (0, _isFunction.default)(completionHandler)) {
          for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            args[_key4 - 1] = arguments[_key4];
          }
          completionHandler(err, ...args);
        }
      });
    };

    /**
    * Forces the publisher of the specified stream to stop publishing the stream.
    *
    * <p>
    * Calling this method causes the Session object to dispatch a <code>streamDestroyed</code>
    * event on all clients that are subscribed to the stream (including the client that is
    * publishing the stream). The <code>reason</code> property of the StreamEvent object is
    * set to <code>"forceUnpublished"</code>.
    * </p>
    * <p>
    * The OT object dispatches an <code>exception</code> event if the user's role
    * does not include permissions required to force other users to unpublish.
    * You define a user's role when you create the user token (see the
    * <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
    * You pass the token string as a parameter of the <code>connect()</code> method of the Session
    * object. See <a href="ExceptionEvent.html">ExceptionEvent</a> and
    * <a href="OT.html#on">OT.on()</a>.
    * </p>
    *
    * <h5>Events dispatched:</h5>
    *
    * <p>
    *   <code>exception</code> (<a href="ExceptionEvent.html">ExceptionEvent</a>) &#151;
    *     The user's role does not allow forcing other users to unpublish.
    * </p>
    * <p>
    *   <code>streamDestroyed</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    *     The stream has been unpublished. The Session object dispatches this on all clients
    *     subscribed to the stream, as well as on the publisher's client.
    * </p>
    *
    * @param {Stream} stream The stream to be unpublished.
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>forceUnpublish()</code> method succeeds or fails. This function takes one parameter
    * &mdash; <code>error</code>. On success, the <code>completionHandler</code> function is
    * not passed any arguments. On error, the function is passed an <code>error</code> object
    * parameter. The <code>error</code> object, defined by the <a href="Error.html">Error</a>
    * class, has two properties: <code>code</code> (an integer)
    * and <code>message</code> (a string), which identify the cause of the failure. Calling
    * <code>forceUnpublish()</code> fails if the role assigned to your token is not "moderator";
    * in this case the <code>error.name</code> property is set to <code>"OT_PERMISSION_DENIED"</code>.
    * The following code adds a completion handler when calling the <code>forceUnpublish()</code>
    * method:
    * <pre>
    * session.forceUnpublish(stream, function (error) {
    *   if (error) {
    *       console.log(error);
    *     } else {
    *       console.log("Connection forced to disconnect: " + connection.id);
    *     }
    *   });
    * </pre>
    *
    * @method #forceUnpublish
    * @memberOf Session
    */

    this.forceUnpublish = function (streamOrStreamId, completionHandler) {
      if (completionHandler === void 0) {
        completionHandler = () => {};
      }
      const dispatchError = err => dispatchOTError(otError(err.name, new Error(err.msg), err.code), completionHandler);
      const invalidParameterError = {
        msg: 'Invalid Parameter. Check that you have passed valid parameter values into the method call.',
        code: ExceptionCodes.INVALID_PARAMETER,
        name: errors.INVALID_PARAMETER
      };
      const notConnectedError = {
        msg: 'Cannot call forceUnpublish(). You are not connected to the session.',
        code: ExceptionCodes.NOT_CONNECTED,
        name: errors.NOT_CONNECTED
      };
      const notPermittedError = {
        msg: 'This token does not allow forceUnpublish. The role must be at least `moderator` to enable this ' + 'functionality',
        code: ExceptionCodes.UNABLE_TO_FORCE_UNPUBLISH,
        name: errors.PERMISSION_DENIED
      };
      const notFoundError = {
        msg: 'The stream does not exist.',
        name: errors.NOT_FOUND
      };
      const unexpectedError = {
        msg: 'An unexpected error occurred.',
        name: errors.UNEXPECTED_SERVER_RESPONSE,
        code: ExceptionCodes.UNEXPECTED_SERVER_RESPONSE
      };
      if (!streamOrStreamId) {
        dispatchError(invalidParameterError);
        return;
      }
      if (!_this.isConnected()) {
        dispatchError(notConnectedError);
        return;
      }
      const stream = getStream(streamOrStreamId);
      if (!permittedTo('forceUnpublish')) {
        // if this throws an error the handleJsException won't occur
        dispatchError(notPermittedError);
        return;
      }
      if (!_socket) {
        dispatchSocketIsNullError('forceUnpublish', completionHandler);
        return;
      }
      _socket.forceUnpublish(stream.id, err => {
        if (!err) {
          completionHandler(null);
          return;
        }
        if (err.code === '404') {
          dispatchError(notFoundError);
        } else if (err.code === '403') {
          dispatchError(notPermittedError);
        } else {
          dispatchError(unexpectedError);
        }
      });
    };

    /**
    * Forces a the publisher of a specified stream to mute its audio.
    *
    * <p>
    * Calling this method causes the Publisher object in the client publishing the
    * stream to dispatch a <code>muteForced</code> event.
    * </p>
    *
    * <p>
    * Check the <code>capabilities.canForceMute</code> property of the Session object to see if
    * you can call this function successfully. This is reserved for clients that have connected
    * with a token that has been assigned the moderator role (see the
    * <a href="https://tokbox.com/developer/guides/create-token/">Token Creation</a>
    * documentation).
    *
    * @param { Stream } stream The stream to be muted.
    *
    * @method #forceMuteStream
    * @memberOf Session
    * @see <a href="Session.html#properties">Session.capabilities</a>
    * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
    * @see <a href="Publisher.html#event:muteForced">Publisher muteForced event</a>
    * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
    * of streams in a session</a>
    *
    * @return {Promise} A promise that resolves with no value when the operation
    * completes successfully. The promise is rejected if there is an error. The
    * <code>name</code> property of the Error object is set to one of the following
    * values, depending the type of error:
    *
    * <p>
    * <ul>
    *
    *   <li><code>'OT_NOT_CONNECTED'</code> &mdash; The client is not connect to the session.</li>
    *
    *   <li><code>'OT_INVALID_PARAMETER'</code> &mdash; if one or more of the passed parameters are invalid.</li>
    *
    *   <li><code>'OT_PERMISSION_DENIED'</code> &mdash; The user's role does not
    *   include permissions required to force other users to mute.
    *   You define a user's role when you create the user token (see the
    *   <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
    *   You pass the token string as a parameter of the <code>connect()</code> method of the Session
    *   object.
    *   </li>
    *
    *   <li><code>'OT_NOT_FOUND'</code> &mdash; The stream wasn't found in this session.</li>
    *
    *   <li><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code> &mdash; In case of an internal server error.</li>
    *
    * <ul>
    * </p>
    */

    this.forceMuteStream = stream => new Promise((resolve, reject) => {
      const error = checkMuteCapabilities();
      if (error) {
        reject(error);
        return;
      }
      if (!stream || !stream.id) {
        reject(dispatchMuteError(_forceMuteErrors.default.INVALID_PARAMETER));
        return;
      }
      if (!_socket) {
        reject(dispatchSocketIsNullError('forceMuteStream'));
        return;
      }
      _socket.forceMuteStream(stream.id, err => {
        if (err) {
          reject(handleMuteServerError(err));
        } else {
          resolve();
        }
      });
    });

    /**
     * Forces all publishers in the session (except for those publishing excluded streams)
     * to mute audio.
     *
     * <p>
     * A stream published by the moderator calling the <code>forceMuteAll()</code> method is muted
     * along with other streams in the session, unless you add the moderator&apos;s stream (or streams) to
     * the excluded streams array.
     * </p>
     *
     * <p>
     * If you leave out the <code>excludedStreams</code> parameter, all streams in the session
     * (including those of the moderator) will stop publishing audio:
     * </p>
     *
     * <pre><code class="js">session.forceMuteAll();
     * </code></pre>
     *
     * <p>
     * Also, any streams that are published after the call to the <code>forceMuteAll()</code> method
     * are published with audio muted. You can remove the mute state of a session by calling the
     * <code>disableForceMute()</code> method of the Session object.
     * </p>
     *
     * <pre><code class="js">session.disableForceMute();
     * </code></pre>
     *
     * <p>After you call the <code>Session.disableForceMute()</code> method, new streams published
     * to the session will no longer have audio muted.</p>
     *
     * <p>
     * Calling this method causes the Publisher objects in the clients publishing
     * the streams to dispatch <code>muteForced</code> events. Also, the Session object
     * in each client connected to the session dispatches the <code>muteForced</code>
     * event (with the <code>active</code> property of the event object set to <code>true</code>).
     * </p>
     *
     * <p>
     * Check the <code>capabilities.canForceMute</code> property of the Session object to see if
     * you can call this function successfully. This is reserved for clients that have connected
     * with a token that has been assigned the moderator role (see the
     * <a href="https://tokbox.com/developer/guides/create-token/">Token Creation</a>
     * documentation).
     *
     * @param {Array} excludedStreams An array of Stream objects to be excluded from
     * being muted. Note that if you want to prevent the local client's published stream(s)
     * from being muted, include the Stream object(s) for those stream(s) in this array.
     *
     * @method #forceMuteAll
     * @memberOf Session
     *
     * @see <a href="Session.html#properties">Session.capabilities</a>
     * @see <a href="Session.html#forceMuteStream">Session.forceMuteStream()</a>
     * @see <a href="Session.html#disableForceMute">Session.disableForceMute()</a>
     * @see <a href="#event:muteForced">Session muteForced event</a>
     * @see <a href="Publisher.html#event:muteForced">Publisher muteForced event</a>
     * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
     * of streams in a session</a>
     *
     * @return {Promise} A promise that resolves with no value when the operation
     * completes successfully. The promise is rejected if there is an error. The
     * <code>name</code> property of the Error object is set to one of the following
     * values, depending the type of error:
     *
     * <p>
     * <ul>
     *
     *   <li><code>'OT_NOT_CONNECTED'</code> &mdash; The client is not connect to the session.</li>
     *
     *   <li><code>'INVALID_PARAMETER'</code> &mdash; if one or more of the passed parameters are invalid.</li>
     *
     *   <li><code>'OT_PERMISSION_DENIED'</code> &mdash; The user's role does not
     *   include permissions required to force other users to mute.
     *   You define a user's role when you create the user token (see the
     *   <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
     *   You pass the token string as a parameter of the <code>connect()</code> method of the Session
     *   object.
     *   </li>
     *
     *   <li><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code> &mdash; in case of an internal server error.</li>
     * <ul>
     * </p>
     */

    this.forceMuteAll = excludedStreams => new Promise((resolve, reject) => {
      const error = checkMuteCapabilities();
      if (error) {
        reject(error);
        return;
      }

      // Invalid parameter error should occur when an array of elements is passed where 1 or more of these elements is not
      // an instanceof OT.Stream. excludedStreams can be undefined, null or an empty array and this just means all streams
      // in the session need to be muted
      if (Array.isArray(excludedStreams) && !excludedStreams.every(stream => stream instanceof Stream) || excludedStreams && !Array.isArray(excludedStreams)) {
        reject(dispatchMuteError(_forceMuteErrors.default.INVALID_PARAMETER));
        return;
      }
      if (!_socket) {
        reject(dispatchSocketIsNullError('forceMuteAll'));
        return;
      }
      const excludedStreamIds = (excludedStreams || []).map(stream => stream.id);
      _socket.forceMuteAll(excludedStreamIds, true, err => {
        if (err) {
          reject(handleMuteServerError(err));
        } else {
          resolve();
        }
      });
    });

    /**
     * Disables the active mute state of the session. After you call this method, new streams
     * published to the session will no longer have audio muted.
     *
     * <p>
     * After you call to the <code>Session.forceMuteAll()</code> method (or a moderator in another
     * client makes a call to mute all streams), any streams published after the moderation call are
     * published with audio muted. Call the <code>disableForceMute()</code> method to remove
     * the mute state of a session (so that new published streams are not automatically muted).
     * </p>
     *
     * <p>
     * Calling this method causes the Session object in each connected clients to dispatch a
     * <code>muteForced</code> event, with the <code>active</code> flag set to <code>false</code>.
     * </p>
     *
     * <p>
     * Check the <code>capabilities.canForceMute</code> property of the Session object to see if
     * you can call this function successfully. This is reserved for clients that have connected
     * with a token that has been assigned the moderator role (see the
     * <a href="https://tokbox.com/developer/guides/create-token/">Token Creation</a>
     * documentation).
     *
     * @method #disableForceMute
     * @memberOf Session
     *
     * @see <a href="Session.html#properties">Session.capabilities</a>
     * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
     * @see <a href="#event:muteForced">muteForced event</a>
     *
     * @return {Promise} A promise that resolves with no value when the operation
     * completes successfully. The promise is rejected if there is an error. The
     * <code>name</code> property of the Error object is set to one of the following
     * values, depending the type of error:
     *
     * <p>
     * <ul>
     *
     *   <li><code>'OT_NOT_CONNECTED'</code> &mdash; The client is not connect to the session.</li>
     *
     *   <li><code>'OT_PERMISSION_DENIED'</code> &mdash; The user's role does not
     *   include permissions required to force other users to mute.
     *   You define a user's role when you create the user token (see the
     *   <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
     *   You pass the token string as a parameter of the <code>connect()</code> method of the Session
     *   object.
     *   </li>
     *
     *   <li><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code> &mdash; In case of an internal server error.</li>
     * <ul>
     * </p>
     */

    this.disableForceMute = () => new Promise((resolve, reject) => {
      const error = checkMuteCapabilities();
      if (error) {
        reject(error);
        return;
      }
      if (!_socket) {
        reject(dispatchSocketIsNullError('disableForceMute'));
        return;
      }
      _socket.forceMuteAll([], false, err => {
        if (err) {
          reject(handleMuteServerError(err));
        } else {
          resolve();
        }
      });
    });

    /**
     * Sets the encryption secret for a session with  end-to-end encryption enabled. If this method is called in a session without
     * encryption enabled the function will resolve and no error will be thrown. Users may change their set encryption key at
     * any time. See the end-to-end encryption <a href="https://tokbox.com/developer/guides/end-to-end-encryption/">
     * developer guide</a>.
     *
     * @method #setEncryptionSecret
     * @memberOf Session
     * @param {string} secret The encryption secret.
     *
     * @see <a href="OT.html#initSession">OT.initSession</a>
     * @see <a href="Subscriber.html#events">Subscriber events</a>
     *
     * @return {Promise} A promise that resolves with no value when the operation
     * completes successfully. The promise is rejected if there is an error. The
     * <code>name</code> property of the Error object is set to one of the following
     * values, depending the type of error:
     *
     * <p>
     * <ul>
     * <li><code>'OT_INVALID_ENCRYPTION_SECRET'</code>; The secret is invalid.</li>
     * <ul>
     * </p>
     *
     * A secret mismatch may occur when no error is dispatched. See
     * <a href="Subscriber.html#events">subscrriber events</a> for more information.
     */

    this.setEncryptionSecret = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(secret) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (encryptionSecret) {
                _context2.next = 3;
                break;
              }
              logging.error('Encryption secret must first be set in initSession.');
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              (0, _validateSecret.default)(secret);
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              throw otError(errors.INVALID_ENCRYPTION_SECRET, new Error(`setEncryptionSecret: ${_context2.t0.message}`));
            case 10:
              _context2.prev = 10;
              _context2.next = 13;
              return _this.keyStore.set(sessionId, secret);
            case 13:
              encryptionSecret = secret;
              _context2.next = 19;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t1 = _context2["catch"](10);
              _logging.error(`Error in setEncryptionSecret}: ${_context2.t1.message}`);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 7], [10, 16]]);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    this.isConnected = () => this.is('connected', 'migrating');
    this.capabilities = new Capabilities([], {
      hasE2eeCapability
    });
  };

  /**
   * Dispatched when an archive recording of the session starts.
   *
   * @name archiveStarted
   * @event
   * @memberof Session
   * @see ArchiveEvent
   * @see <a href="https://tokbox.com/developer/guides/archiving">Archiving overview</a>
   */

  /**
   * Dispatched when an archive recording of the session stops.
   *
   * @name archiveStopped
   * @event
   * @memberof Session
   * @see ArchiveEvent
   * @see <a href="https://tokbox.com/developer/guides/archiving">Archiving overview</a>
   */

  /**
   * Dispatched when a new client (including your own) has connected to the session, and for
   * every client in the session when you first connect. (The Session object also dispatches
   * a <code>sessionConnected</code> event when your local client connects.)
   *
   * @name connectionCreated
   * @event
   * @memberof Session
   * @see ConnectionEvent
   * @see <a href="OT.html#initSession">OT.initSession()</a>
   */

  /**
   * A client, other than your own, has disconnected from the session.
   * @name connectionDestroyed
   * @event
   * @memberof Session
   * @see ConnectionEvent
   */

  /**
   * A moderator has forced clients publishing streams to the session to mute audio (the
   * <code>active</code> property of this MuteForcedEvent object is set to <code>true</code>), or
   * a moderator has disabled the mute audio state in the session (the <code>active</code>
   * property of this MuteForcedEvent object is set to <code>false</code>).
   *
   * @name muteForced
   * @event
   * @memberof Session
   * @see MuteForcedEvent
   * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
   * @see <a href="Session.html#disableForceMute">Session.disableForceMute()</a>
   * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
   * of streams in a session</a>
   */

  /**
   * The CPU performance state has changed. This can be set to
   * one the following: "nominal", "fair", "serious", or "critical".
   *
   * @name cpuPerformanceChanged
   * @event
   * @memberof Session
   * @see CpuPerformanceChangedEvent
   */

  /**
   * The client has connected to a Vonage Video API session. This event is dispatched asynchronously
   * in response to a successful call to the <code>connect()</code> method of a Session
   * object. Before calling the <code>connect()</code> method, initialize the session by
   * calling the <code>OT.initSession()</code> method. For a code example and more details,
   * see <a href="#connect">Session.connect()</a>.
   * @name sessionConnected
   * @event
   * @memberof Session
   * @see SessionConnectEvent
   * @see <a href="#connect">Session.connect()</a>
   * @see <a href="OT.html#initSession">OT.initSession()</a>
   */

  /**
   * The client has disconnected from the session. This event may be dispatched asynchronously
   * in response to a successful call to the <code>disconnect()</code> method of the Session object.
   * The event may also be dispatched if a session connection is lost inadvertently, as in the case
   * of a lost network connection.
   * <p>
   * The default behavior is that all Subscriber objects are unsubscribed and removed from the
   * HTML DOM. Each Subscriber object dispatches a <code>destroyed</code> event when the element is
   * removed from the HTML DOM. If you call the <code>preventDefault()</code> method in the event
   * listener for the <code>sessionDisconnect</code> event, the default behavior is prevented, and
   * you can, optionally, clean up Subscriber objects using your own code.
   * <p> The <code>reason</code> property of the event object indicates the reason for the client
   * being disconnected.
   * @name sessionDisconnected
   * @event
   * @memberof Session
   * @see <a href="#disconnect">Session.disconnect()</a>
   * @see <a href="#forceDisconnect">Session.forceDisconnect()</a>
   * @see SessionDisconnectEvent
   */

  /**
   * The local client has lost its connection to a Vonage Video API session and is trying to reconnect.
   * This results from a loss in network connectivity. If the client can reconnect to the session,
   * the Session object dispatches a <code>sessionReconnected</code> event. Otherwise, if the client
   * cannot reconnect, the Session object dispatches a <code>sessionDisconnected</code> event.
   * <p>
   * In response to this event, you may want to provide a user interface notification, to let
   * the user know that the app is trying to reconnect to the session and that audio-video streams
   * are temporarily disconnected.
   *
   * @name sessionReconnecting
   * @event
   * @memberof Session
   * @see Event
   * @see <a href="#event:sessionReconnected">sessionReconnected event</a>
   * @see <a href="#event:sessionDisconnected">sessionDisconnected event</a>
   */

  /**
   * The local client has reconnected to the Vonage Video API session after its connection was lost
   * temporarily. When the connection is lost, the Session object dispatches a
   * <code>sessionReconnecting</code> event, prior to the <code>sessionReconnected</code>
   * event. If the client cannot reconnect to the session, the Session object dispatches a
   * <code>sessionDisconnected</code> event instead of this event.
   * <p>
   * Any existing publishers and subscribers are automatically reconnected when client reconnects
   * and the Session object dispatches this event.
   * <p>
   * Any signals sent by other clients while your client was disconnected are received upon
   * reconnecting. By default, signals initiated by the local client while disconnected
   * (by calling the <code>Session.signal()</code> method) are sent when the client reconnects
   * to the Vonage Video API session. You can prevent this by setting the <code>retryAfterReconnect</code>
   * property to <code>false</code> in the <code>signal</code> object you pass into the
   * <a href="#signal">Session.signal()</a> method.
   *
   * @name sessionReconnected
   * @event
   * @memberof Session
   * @see Event
   * @see <a href="#event:sessionReconnecting">sessionReconnecting event</a>
   * @see <a href="#event:sessionDisconnected">sessionDisconnected event</a>
   */

  /**
   * A new stream, published by another client, has been created on this session. For streams
   * published by your own client, the Publisher object dispatches a <code>streamCreated</code>
   * event. For a code example and more details, see {@link StreamEvent}.
   * @name streamCreated
   * @event
   * @memberof Session
   * @see StreamEvent
   * @see <a href="Session.html#publish">Session.publish()</a>
   */

  /**
   * A stream from another client has stopped publishing to the session.
   * <p>
   * The default behavior is that all Subscriber objects that are subscribed to the stream are
   * unsubscribed and removed from the HTML DOM. Each Subscriber object dispatches a
   * <code>destroyed</code> event when the element is removed from the HTML DOM. If you call the
   * <code>preventDefault()</code> method in the event listener for the
   * <code>streamDestroyed</code> event, the default behavior is prevented and you can clean up
   * a Subscriber object for the stream by calling its <code>destroy()</code> method. See
   * <a href="Session.html#getSubscribersForStream">Session.getSubscribersForStream()</a>.
   * <p>
   * For streams published by your own client, the Publisher object dispatches a
   * <code>streamDestroyed</code> event.
   * <p>
   * For a code example and more details, see {@link StreamEvent}.
   * @name streamDestroyed
   * @event
   * @memberof Session
   * @see StreamEvent
   */

  /**
   * Defines an event dispatched when property of a stream has changed. This can happen in
   * in the following conditions:
   * <p>
   * <ul>
   *   <li> A stream has started or stopped publishing audio or video (see
   *     <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a> and
   *     <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a>). Note
   *     that a subscriber's video can be disabled or enabled for reasons other than
   *     the publisher disabling or enabling it. A Subscriber object dispatches
   *     <code>videoDisabled</code> and <code>videoEnabled</code> events in all
   *     conditions that cause the subscriber's stream to be disabled or enabled.
   *   </li>
   *   <li> The <code>videoDimensions</code> property of the Stream object has
   *     changed (see <a href="Stream.html#properties">Stream.videoDimensions</a>).
   *   </li>
   *   <li> The <code>videoType</code> property of the Stream object has changed.
   *     This can happen in a stream published by a mobile device. (See
   *     <a href="Stream.html#properties">Stream.videoType</a>.)
   *   </li>
   * </ul>
   *
   * @name streamPropertyChanged
   * @event
   * @memberof Session
   * @see StreamPropertyChangedEvent
   * @see <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a>
   * @see <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a>
   * @see <a href="Stream.html#hasAudio">Stream.hasAudio</a>
   * @see <a href="Stream.html#hasVideo">Stream.hasVideo</a>
   * @see <a href="Stream.html#videoDimensions">Stream.videoDimensions</a>
   * @see <a href="Subscriber.html#event:videoDisabled">Subscriber videoDisabled event</a>
   * @see <a href="Subscriber.html#event:videoEnabled">Subscriber videoEnabled event</a>
   */

  /**
   * A signal was received from the session. The <a href="SignalEvent.html">SignalEvent</a>
   * class defines this event object. It includes the following properties:
   * <ul>
   *   <li><code>data</code> &mdash; (String) The data string sent with the signal (if there
   *       is one).</li>
   *   <li><code>from</code> &mdash; (<a href="Connection.html">Connection</a>) The Connection
   *       corresponding to the client that sent the signal.</li>
   *   <li><code>type</code> &mdash; (String) The type assigned to the signal (if there is
   *       one).</li>
   * </ul>
   * <p>
   * You can register to receive all signals sent in the session, by adding an event handler
   * for the <code>signal</code> event. For example, the following code adds an event handler
   * to process all signals sent in the session:
   * <pre>
   * session.on("signal", function(event) {
   *   console.log("Signal sent from connection: " + event.from.id);
   *   console.log("Signal data: " + event.data);
   * });
   * </pre>
   * <p>You can register for signals of a specified type by adding an event handler for the
   * <code>signal:type</code> event (replacing <code>type</code> with the actual type string
   * to filter on).
   *
   * @name signal
   * @event
   * @memberof Session
   * @see <a href="Session.html#signal">Session.signal()</a>
   * @see SignalEvent
   * @see <a href="#event:signal:type">signal:type</a> event
   */

  /**
   * A signal of the specified type was received from the session. The
   * <a href="SignalEvent.html">SignalEvent</a> class defines this event object.
   * It includes the following properties:
   * <ul>
   *   <li><code>data</code> &mdash; (String) The data string sent with the signal.</li>
   *   <li><code>from</code> &mdash; (<a href="Connection.html">Connection</a>) The Connection
   *   corresponding to the client that sent the signal.</li>
   *   <li><code>type</code> &mdash; (String) The type assigned to the signal (if there is one).
   *   </li>
   * </ul>
   * <p>
   * You can register for signals of a specified type by adding an event handler for the
   * <code>signal:type</code> event (replacing <code>type</code> with the actual type string
   * to filter on). For example, the following code adds an event handler for signals of
   * type "foo":
   * <pre>
   * session.on("signal:foo", function(event) {
   *   console.log("foo signal sent from connection " + event.from.id);
   *   console.log("Signal data: " + event.data);
   * });
   * </pre>
   * <p>
   * You can register to receive <i>all</i> signals sent in the session, by adding an event
   * handler for the <code>signal</code> event.
   *
   * @name signal:type
   * @event
   * @memberof Session
   * @see <a href="Session.html#signal">Session.signal()</a>
   * @see SignalEvent
   * @see <a href="#event:signal">signal</a> event
   */

  return Session;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _hasOpenTokSupport = _interopRequireDefault(__webpack_require__(53));
const hasOpenTokSupport = _hasOpenTokSupport.default.once;
var _default = () => hasOpenTokSupport() && (_env.default.isChromiumEdge || ['Chrome', 'Safari', 'Firefox', 'Opera'].includes(_env.default.name));
exports.default = _default;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = convertRumorError;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
const knownErrorCodes = [400, 403, 409, _exception_codes.default.CONNECTION_LIMIT_EXCEEDED];
const reasons = {
  CONNECT: 'ConnectToSession',
  SESSION_STATE: 'GetSessionState'
};

/*
 * Converts an error from RumorSocket to use generic exception codes
 * @param {Error} error - Error object with reason property
 * @return {Object} The converted error code and message
 * @property {number} code
 * @property {string} message
 */
function convertRumorError(error) {
  let code;
  let message;
  if (error.reason === reasons.CONNECT && error.code === _exception_codes.default.CONNECT_FAILED) {
    code = error.code;
    message = _ot_error_class.default.getTitleByCode(error.code);
  } else if (error.code && knownErrorCodes.indexOf(Number(error.code)) > -1) {
    code = _exception_codes.default.CONNECT_FAILED;
    switch (error.reason) {
      case reasons.CONNECT:
        switch (error.code) {
          case _exception_codes.default.CONNECTION_LIMIT_EXCEEDED:
            code = error.code;
            message = 'Cannot connect -- the limit for concurrent connections to the session ' + 'has been reached';
            break;
          default:
            message = 'Received error response to connection create message.';
            break;
        }
        break;
      case reasons.SESSION_STATE:
        message = 'Received error response to session read';
        break;
      default:
        message = '';
        break;
    }
  } else {
    code = _exception_codes.default.UNEXPECTED_SERVER_RESPONSE;
    message = 'Unexpected server response. Try this operation again later.';
  }
  return {
    code,
    message
  };
}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = serializeMessage;
function serializeMessage(message) {
  return JSON.stringify(message);
}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = _ref => {
  let logger = _ref.logger,
    obj = _ref.obj,
    eventNames = _ref.eventNames;
  eventNames.forEach(eventName => {
    obj.on(eventName, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return logger.spam('emitted', eventName, args);
    });
  });
};
exports.default = _default;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isFunction = _interopRequireDefault(__webpack_require__(20));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _RumorMessageTypes = _interopRequireDefault(__webpack_require__(187));
var _unboxFromRumorMessage = _interopRequireDefault(__webpack_require__(807));
/* eslint-disable import/no-named-as-default-member */
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable prefer-rest-params */

const logging = (0, _log.default)('Dispatcher');
const Dispatcher = function Dispatcher() {
  (0, _eventing.default)(this);
  this.callbacks = {};
};
Dispatcher.prototype.registerCallback = function (transactionId, completion) {
  this.callbacks[transactionId] = completion;
};
Dispatcher.prototype.triggerCallback = function (transactionId) {
  /* , arg1, arg2, argN-1, argN */
  if (!transactionId) {
    return;
  }
  const completion = this.callbacks[transactionId];
  if (completion && (0, _isFunction.default)(completion)) {
    const args = Array.prototype.slice.call(arguments);
    args.shift();
    completion(...args);
  }
  delete this.callbacks[transactionId];
};
Dispatcher.prototype.onClose = function (reason, messagingUrl) {
  this.emit('close', reason, messagingUrl);
};
Dispatcher.prototype.onReconnected = function () {
  this.emit('reconnected');
};
Dispatcher.prototype.onReconnecting = function () {
  this.emit('reconnecting');
};
Dispatcher.prototype.dispatch = function (rumorMessage) {
  var _message$content, _message$content$user;
  // The special casing of STATUS messages is ugly. Need to think about
  // how to better integrate this.

  if (rumorMessage.type === _RumorMessageTypes.default.STATUS) {
    var _data$mute;
    logging.debug(rumorMessage);
    let error;
    if (rumorMessage.isError) {
      let message;
      if (typeof rumorMessage.data === 'string') {
        try {
          const data = JSON.parse(rumorMessage.data);
          if (data && typeof data === 'object') {
            message = data.reason;
          }
        } catch (e) {
          logging.warn('Failed to parse rumorMessage.data', e);
        }
      }
      error = new _ot_error_class.default(rumorMessage.status, message);
    }
    const data = rumorMessage.data ? JSON.parse(rumorMessage.data) : '';
    if (data != null && (_data$mute = data.mute) != null && _data$mute.active) {
      this.dispatchMuteOnEntry();
    }
    this.triggerCallback(rumorMessage.transactionId, error, rumorMessage);
    return;
  }
  const message = (0, _unboxFromRumorMessage.default)(rumorMessage);
  if (message.resource === 'data') {
    logging.spam(`${message.signature}:`, message);
  } else {
    logging.debug(`${message.signature}:`, message);
  }
  switch (message.resource) {
    case 'session':
      this.dispatchSession(message);
      break;
    case 'connection':
      // We do not want to expose backend auriga messages to end users
      if (message != null && (_message$content = message.content) != null && (_message$content$user = _message$content.userAgent) != null && _message$content$user.includes('auriga')) {
        return;
      }
      this.dispatchConnection(message);
      break;
    case 'stream':
      this.dispatchStream(message);
      break;
    case 'stream_channel':
      this.dispatchStreamChannel(message);
      break;
    case 'subscriber':
      this.dispatchSubscriber(message);
      break;
    case 'subscriber_channel':
      this.dispatchSubscriberChannel(message);
      break;
    case 'signal':
      this.dispatchSignal(message);
      break;

    // The data channel is multi-use. Currently it is just used for call monitoring and captions, but it may have
    // additional use cases in the future.
    case 'data':
      if (message.params.channel === 'caption1') {
        this.dispatchCaption(message);
      } else if (message.params.channel === 'downlinkStats1') {
        this.dispatchSenderStats(message);
      }
      break;
    case 'archive':
      this.dispatchArchive(message);
      break;
    case 'source':
      this.dispatchSource(message);
      break;
    case 'notification':
      this.dispatchNotification(message);
      break;
    default:
      logging.debug(`Type ${message.resource} is not currently implemented`);
  }
};
Dispatcher.prototype.dispatchSession = function (message) {
  switch (message.method) {
    case 'read':
      this.emit('session#read', message.content, message.transactionId);
      break;
    case 'update':
      this.emit('session#update', message.content);
      break;
    default:
      logging.debug(`${message.signature} is not currently implemented`);
  }
};
Dispatcher.prototype.dispatchNotification = function (message) {
  switch (message.method) {
    case 'notification':
      this.emit('session#notification', message.content);
      break;
    default:
      logging.debug(`${message.signature} is not currently implemented`);
  }
};
Dispatcher.prototype.dispatchMuteOnEntry = function () {
  this.emit('session#muted');
};
Dispatcher.prototype.dispatchConnection = function (message) {
  switch (message.method) {
    case 'created':
      this.emit('connection#created', message.content);
      break;
    case 'deleted':
      this.emit('connection#deleted', message.params.connection, message.reason);
      break;
    default:
      logging.debug(`${message.signature} is not currently implemented`);
  }
};
Dispatcher.prototype.dispatchStream = function (message) {
  switch (message.method) {
    case 'created':
      this.emit('stream#created', message.content, message.transactionId);
      break;
    case 'deleted':
      this.emit('stream#deleted', message.params.stream, message.reason, message.content);
      break;
    case 'updated':
      this.emit('stream#updated', message.params.stream, message.content);
      break;
    case 'update':
      // Once rumor adds the source stream property, we will be able to filter this out for AMR
      this.emit('stream#update', message.params.stream, message.content);
      break;

    // The JSEP process
    case 'generateoffer':
    case 'answer':
    case 'pranswer':
    case 'offer':
    case 'candidate':
      this.dispatchJsep(message.method, message);
      break;
    default:
      logging.debug(`${message.signature} is not currently implemented`);
  }
};
Dispatcher.prototype.dispatchStreamChannel = function (message) {
  switch (message.method) {
    case 'updated':
      this.emit('streamChannel#updated', message.params.stream, message.params.channel, message.content);
      break;
    default:
      logging.debug(`${message.signature} is not currently implemented`);
  }
};

// Dispatch JSEP messages
//
// generateoffer:
// Request to generate a offer for another Peer (or Prism). This kicks
// off the JSEP process.
//
// answer:
// generate a response to another peers offer, this contains our constraints
// and requirements.
//
// pranswer:
// a provisional answer, i.e. not the final one.
//
// candidate
//
//
Dispatcher.prototype.dispatchJsep = function (method, message) {
  this.emit(`jsep#${method}`, message.params.stream, message.fromAddress, message);
};
Dispatcher.prototype.dispatchSubscriberChannel = function (message) {
  switch (message.method) {
    case 'updated':
      this.emit('subscriberChannel#updated', message.params.stream, message.params.channel, message.content);
      break;
    case 'update':
      // subscriberId, streamId, content
      this.emit('subscriberChannel#update', message.params.subscriber, message.params.stream, message.content);
      break;
    default:
      logging.debug(`${message.signature} is not currently implemented`);
  }
};
Dispatcher.prototype.dispatchSubscriber = function (message) {
  switch (message.method) {
    case 'created':
      this.emit('subscriber#created', message.params.stream, message.fromAddress, message.content.id);
      break;
    case 'deleted':
      this.dispatchJsep('unsubscribe', message);
      this.emit('subscriber#deleted', message.params.stream, message.fromAddress);
      break;

    // The JSEP process
    case 'generateoffer':
    case 'answer':
    case 'pranswer':
    case 'offer':
    case 'candidate':
      this.dispatchJsep(message.method, message);
      break;
    default:
      logging.debug(`${message.signature} is not currently implemented`);
  }
};
Dispatcher.prototype.dispatchSignal = function (message) {
  if (message.method !== 'signal') {
    logging.debug(`${message.signature} is not currently implemented`);
    return;
  }
  this.emit('signal', message.fromAddress, message.content);
};
Dispatcher.prototype.dispatchCaption = function (message) {
  this.emit('caption', message.fromAddress, message.content);
};
Dispatcher.prototype.dispatchSenderStats = function (message) {
  this.emit('senderStatsReceived', message.params.subscriber, message.content);
};
Dispatcher.prototype.dispatchArchive = function (message) {
  switch (message.method) {
    case 'created':
      this.emit('archive#created', message.content);
      break;
    case 'updated':
      this.emit('archive#updated', message.params.archive, message.content);
      break;
    default:
  }
};
Dispatcher.prototype.dispatchSource = function (message) {
  switch (message.method) {
    case 'create':
      this.emit('source#create', message.params.source, message.params.stream, message.reason);
      break;
    case 'delete':
      this.emit('source#delete', message.params.source, message.params.stream, message.reason);
      break;
    default:
      logging.debug(`${message.signature} is not currently implemented`);
  }
};
var _default = Dispatcher;
exports.default = _default;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _supported_crypto_scheme = _interopRequireDefault(__webpack_require__(809));
var _hasRTCPMuxCapability = _interopRequireDefault(__webpack_require__(810));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _hasBundleCapability = _interopRequireDefault(__webpack_require__(811));
var _serializeMessage = _interopRequireDefault(__webpack_require__(353));
var _StaticConfig = _interopRequireDefault(__webpack_require__(48));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-void */

const staticConfig = (0, _StaticConfig.default)().onlyLocal();
const Message = {};
Message.connections = {};
Message.connections.create = function (opt) {
  const apiKey = opt.apiKey;
  const sessionId = opt.sessionId;
  const connectionId = opt.connectionId;
  const connectionEventsSuppressed = opt.connectionEventsSuppressed;
  const capabilities = opt.capabilities;
  return (0, _serializeMessage.default)({
    method: 'create',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/connection/${connectionId}`,
    content: {
      userAgent: _OTHelpers.default.env.userAgent,
      clientVersion: staticConfig.clientVersion,
      capabilities: capabilities || [],
      connectionEventsSuppressed
    }
  });
};
Message.connections.destroy = function (opt) {
  const apiKey = opt.apiKey;
  const sessionId = opt.sessionId;
  const connectionId = opt.connectionId;
  return (0, _serializeMessage.default)({
    method: 'delete',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/connection/${connectionId}`,
    content: {}
  });
};
Message.sessions = {};
Message.sessions.get = function (apiKey, sessionId) {
  return (0, _serializeMessage.default)({
    method: 'read',
    uri: `/v2/partner/${apiKey}/session/${sessionId}`,
    content: {}
  });
};
Message.sessions.migrate = function (apiKey, sessionId) {
  return (0, _serializeMessage.default)({
    method: 'migrate',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/migrate`,
    content: {}
  });
};
Message.streams = {};
Message.streams.get = function (apiKey, sessionId, streamId) {
  return (0, _serializeMessage.default)({
    method: 'read',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}`,
    content: {}
  });
};
Message.streams.channelFromOTChannel = function (channel) {
  const raptorChannel = {
    id: channel.id,
    type: channel.type,
    active: channel.active
  };
  if (channel.type === 'video') {
    raptorChannel.width = channel.width;
    raptorChannel.height = channel.height;
    raptorChannel.orientation = channel.orientation;
    raptorChannel.frameRate = channel.frameRate;
    if (channel.source !== 'default') {
      raptorChannel.source = channel.source;
    }
    raptorChannel.fitMode = channel.fitMode;
  }
  return raptorChannel;
};
Message.streams.create = function (opt) {
  if (opt === void 0) {
    opt = {};
  }
  const _opt = opt,
    apiKey = _opt.apiKey,
    sessionId = _opt.sessionId,
    streamId = _opt.streamId,
    name = _opt.name,
    audioFallbackEnabled = _opt.audioFallbackEnabled,
    publisherAudioFallbackEnabled = _opt.publisherAudioFallbackEnabled,
    subscriberAudioFallbackEnabled = _opt.subscriberAudioFallbackEnabled,
    channels = _opt.channels,
    minBitrate = _opt.minBitrate,
    maxBitrate = _opt.maxBitrate,
    sourceStreamId = _opt.sourceStreamId,
    e2ee = _opt.e2ee,
    customProperties = _opt.customProperties;
  const messageContent = {
    id: streamId,
    name,
    audioFallbackEnabled,
    publisherAudioFallbackEnabled,
    subscriberAudioFallbackEnabled,
    channel: channels.map(channel => Message.streams.channelFromOTChannel(channel)),
    e2ee,
    customProperties
  };
  if (minBitrate) {
    messageContent.minBitrate = Math.round(minBitrate);
  }
  if (maxBitrate) {
    messageContent.maxBitrate = Math.round(maxBitrate);
  }
  if (sourceStreamId) {
    messageContent.sourceStreamId = sourceStreamId;
  }
  if (typeof e2ee === 'boolean') {
    messageContent.e2ee = e2ee;
  }
  return (0, _serializeMessage.default)({
    method: 'create',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}`,
    content: messageContent
  });
};
Message.streams.destroy = function (apiKey, sessionId, streamId, sourceStreamId) {
  const messageContent = {};
  if (sourceStreamId) {
    messageContent.sourceStreamId = sourceStreamId;
  }
  return (0, _serializeMessage.default)({
    method: 'delete',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}`,
    content: messageContent
  });
};
Message.streamChannels = {};
Message.streamChannels.update = function (apiKey, sessionId, streamId, channelId, attributes) {
  return (0, _serializeMessage.default)({
    method: 'update',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/channel/${channelId}`,
    content: attributes
  });
};
Message.subscribers = {};
Message.subscribers.create = function (opt) {
  if (opt === void 0) {
    opt = {};
  }
  const _opt2 = opt,
    apiKey = _opt2.apiKey,
    sessionId = _opt2.sessionId,
    streamId = _opt2.streamId,
    subscriberId = _opt2.subscriberId,
    connectionId = _opt2.connectionId,
    channelsToSubscribeTo = _opt2.channelsToSubscribeTo,
    sourceStreamId = _opt2.sourceStreamId,
    e2ee = _opt2.e2ee;
  const content = {
    id: subscriberId,
    connection: connectionId,
    keyManagementMethod: _supported_crypto_scheme.default,
    bundleSupport: (0, _hasBundleCapability.default)(),
    rtcpMuxSupport: (0, _hasRTCPMuxCapability.default)(),
    e2ee
  };
  if (channelsToSubscribeTo) {
    content.channel = channelsToSubscribeTo;
  }
  if (sourceStreamId) {
    content.sourceStreamId = sourceStreamId;
  }
  return (0, _serializeMessage.default)({
    method: 'create',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/subscriber/${subscriberId}`,
    content
  });
};
Message.subscribers.destroy = function (apiKey, sessionId, streamId, subscriberId, sourceStreamId) {
  const content = {};
  if (sourceStreamId) {
    content.sourceStreamId = sourceStreamId;
  }
  return (0, _serializeMessage.default)({
    method: 'delete',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/subscriber/${subscriberId}`,
    content
  });
};
Message.subscribers.update = function (apiKey, sessionId, streamId, subscriberId, attributes) {
  return (0, _serializeMessage.default)({
    method: 'update',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/subscriber/${subscriberId}`,
    content: attributes
  });
};
Message.subscriberChannels = {};
Message.subscriberChannels.update = function (apiKey, sessionId, streamId, subscriberId, channelId, attributes) {
  return (0, _serializeMessage.default)({
    method: 'update',
    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/subscriber/${subscriberId}/channel/${channelId}`,
    content: attributes
  });
};
Message.signals = {};
Message.signals.create = function (apiKey, sessionId, toAddress, type, data) {
  const content = {};
  if (type !== void 0) {
    content.type = type;
  }
  if (data !== void 0) {
    content.data = data;
  }
  return (0, _serializeMessage.default)({
    method: 'signal',
    uri: `/v2/partner/${apiKey}/session/${sessionId}${toAddress !== void 0 ? `/connection/${toAddress}` : ''}/signal/${(0, _uuid.default)()}`,
    content
  });
};
Message.forceMute = {};
Message.forceMute.update = options => {
  const apiKey = options.apiKey,
    sessionId = options.sessionId,
    streamId = options.streamId,
    active = options.active,
    excludedStreamIds = options.excludedStreamIds;
  const content = {
    reason: 'mute',
    channels: ['audio'],
    active,
    locked: false
  };
  if (excludedStreamIds) {
    content.exclusion = excludedStreamIds;
  }
  return (0, _serializeMessage.default)({
    method: 'update',
    uri: `/v2/partner/${apiKey}/session/${sessionId}${streamId ? `/stream/${streamId}` : ''}`,
    content
  });
};
var _default = Message;
exports.default = _default;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Signal;
var _clone = _interopRequireDefault(__webpack_require__(41));
var _api_key = _interopRequireDefault(__webpack_require__(73));
var _connection = _interopRequireDefault(__webpack_require__(188));
var _RaptorMessage = _interopRequireDefault(__webpack_require__(356));
var _tag = _interopRequireDefault(__webpack_require__(358));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-useless-escape, no-void, no-prototype-builtins */

const MAX_SIGNAL_DATA_LENGTH = 8192;
const MAX_SIGNAL_TYPE_LENGTH = 128;

//
// Error Codes:
// 413 - Type too long
// 400 - Type is invalid
// 413 - Data too long
// 400 - Data is invalid (can't be parsed as JSON)
// 429 - Rate limit exceeded
// 500 - Websocket connection is down
// 404 - To connection does not exist
// 400 - To is invalid
//
function Signal(sessionId, fromConnectionId, options) {
  const isInvalidType = function isInvalidType(type) {
    // Our format matches the unreserved characters from the URI RFC:
    // http://www.ietf.org/rfc/rfc3986
    return !/^[a-zA-Z0-9\-\._~]+$/.exec(type);
  };
  const validateTo = function validateTo(toAddress) {
    if (!toAddress) {
      return {
        code: 400,
        reason: 'The signal to field was invalid. Either set it to a OT.Connection, ' + 'OT.Session, or omit it entirely'
      };
    }
    if (!(toAddress instanceof _connection.default || toAddress._tag === _tag.default)) {
      return {
        code: 400,
        reason: 'The To field was invalid'
      };
    }
    return null;
  };
  const validateType = function validateType(type) {
    let error = null;
    if (type === null || type === void 0) {
      error = {
        code: 400,
        reason: 'The signal type was null or undefined. Either set it to a String value or ' + 'omit it'
      };
    } else if (type.length > MAX_SIGNAL_TYPE_LENGTH) {
      error = {
        code: 413,
        reason: `The signal type was too long, the maximum length of it is ${MAX_SIGNAL_TYPE_LENGTH} characters`
      };
    } else if (isInvalidType(type)) {
      error = {
        code: 400,
        reason: 'The signal type was invalid, it can only contain letters, ' + 'numbers, \'-\', \'_\', and \'~\'.'
      };
    }
    return error;
  };
  const validateData = function validateData(data) {
    let error = null;
    if (data === null || data === void 0) {
      error = {
        code: 400,
        reason: 'The signal data was null or undefined. Either set it to a String value or ' + 'omit it'
      };
    } else {
      try {
        if (JSON.stringify(data).length > MAX_SIGNAL_DATA_LENGTH) {
          error = {
            code: 413,
            reason: `The data field was too long, the maximum size of it is ${MAX_SIGNAL_DATA_LENGTH} characters`
          };
        }
      } catch (e) {
        error = {
          code: 400,
          reason: 'The data field was not valid JSON'
        };
      }
    }
    return error;
  };
  const validateRetryAfterReconnect = function validateRetryAfterReconnect(retryAfterReconnect) {
    let error = null;
    if (!(retryAfterReconnect === true || retryAfterReconnect === false)) {
      error = {
        code: 400,
        reason: 'The signal retryAfterReconnect was not true or false. Either set it to a Boolean ' + 'value or omit it'
      };
    }
    return error;
  };
  this.toRaptorMessage = function () {
    let to = this.to;
    if (to && typeof to !== 'string') {
      to = to.id;
    }
    return _RaptorMessage.default.signals.create(_api_key.default.value, sessionId, to, this.type, this.data);
  };
  this.toHash = function () {
    return options;
  };
  this.error = null;
  this.retryAfterReconnect = true;
  if (options) {
    if (options.hasOwnProperty('data')) {
      this.data = (0, _clone.default)(options.data);
      this.error = validateData(this.data);
    }
    if (options.hasOwnProperty('to')) {
      this.to = options.to;
      if (!this.error) {
        this.error = validateTo(this.to);
      }
    }
    if (options.hasOwnProperty('type')) {
      if (!this.error) {
        this.error = validateType(options.type);
      }
      this.type = options.type;
    }
    if (options.hasOwnProperty('retryAfterReconnect')) {
      if (!this.error) {
        this.error = validateRetryAfterReconnect(options.retryAfterReconnect);
      }
      this.retryAfterReconnect = options.retryAfterReconnect;
    }
  }
  this.valid = this.error === null;
}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// This is used to break the dependency Raptor had on Session. It only needs to be able to know
// whether an object is an instanceof a Session. The dependency was an issue for node because
// Session depends on get_user_media.js which doesn't work in node.
var _default = {};
exports.default = _default;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = SessionDispatcher;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _log = _interopRequireDefault(__webpack_require__(1));
var _objects = _interopRequireDefault(__webpack_require__(27));
var _archive = _interopRequireDefault(__webpack_require__(360));
var _now = _interopRequireDefault(__webpack_require__(51));
var _connection = _interopRequireDefault(__webpack_require__(188));
var _DelayedEventQueue = _interopRequireDefault(__webpack_require__(814));
var _Dispatcher = _interopRequireDefault(__webpack_require__(355));
var _stream = _interopRequireDefault(__webpack_require__(186));
var _stream_channel = _interopRequireDefault(__webpack_require__(161));
var _getMediaModeBySourceStreamId = _interopRequireDefault(__webpack_require__(180));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-shadow, prefer-rest-params, prefer-spread, no-param-reassign */
/* eslint-disable no-mixed-operators, no-cond-assign, one-var */

const logging = (0, _log.default)('SessionDispatcher');
function constructBareConnection(fromAddress) {
  return {
    id: fromAddress,
    creationTime: new Date().getTime(),
    data: {},
    capablities: {},
    permissions: []
  };
}
function parseStream(dict, session) {
  const channel = dict.channel.map(channel => new _stream_channel.default(channel));
  const connectionId = dict.connectionId ? dict.connectionId : dict.connection.id;
  return new _stream.default(dict.id, dict.name, dict.creationTime, session.connections.get(connectionId), session, channel, dict.customProperties && dict.customProperties.initials);
}
function parseAndAddStreamToSession(streamParams, session) {
  if (!session._.shouldAddStream(streamParams)) {
    return undefined;
  }
  const stream = parseStream(streamParams, session);
  // We call `replace` here instead of `add` to make sure we are adding the stream in all cases.
  // This function will replace the stream if any with the same id is already saved, otherwise it
  // will perform a regular `add`.
  session.streams.replace(stream);
  return stream;
}
function parseArchive(archiveParams) {
  return new _archive.default(archiveParams.id, archiveParams.name, archiveParams.status);
}
function parseAndAddArchiveToSession(archiveParams, session) {
  if (session.archives.has(archiveParams.id)) {
    return undefined;
  }
  const archive = parseArchive(archiveParams);
  session.archives.add(archive);
  return archive;
}
const DelayedSessionEvents = function DelayedSessionEvents(dispatcher) {
  const eventQueues = {};
  this.enqueue = function enqueue( /* key, arg1, arg2, ..., argN */
  ) {
    const key = arguments[0];
    const eventArgs = Array.prototype.slice.call(arguments, 1);
    if (!eventQueues[key]) {
      eventQueues[key] = new _DelayedEventQueue.default(dispatcher);
    }
    eventQueues[key].enqueue.apply(eventQueues[key], eventArgs);
  };
  this.triggerConnectionCreated = function triggerConnectionCreated(connection) {
    if (eventQueues[`connectionCreated${connection.id}`]) {
      eventQueues[`connectionCreated${connection.id}`].triggerAll();
    }
  };
  this.triggerSessionConnected = function triggerSessionConnected(connections) {
    if (eventQueues.sessionConnected) {
      eventQueues.sessionConnected.triggerAll();
    }
    connections.forEach(function (connection) {
      this.triggerConnectionCreated(connection);
    }, this);
  };
};
const unconnectedStreams = {};
function SessionDispatcher(session, _temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    connectionEventsSuppressed = _ref.connectionEventsSuppressed;
  const dispatcher = new _Dispatcher.default();
  let sessionStateReceived = false;
  const delayedSessionEvents = new DelayedSessionEvents(dispatcher);
  dispatcher.on('reconnecting', () => {
    session._.reconnecting();
  });
  dispatcher.on('reconnected', () => {
    session._.reconnected();
  });
  dispatcher.on('close', (reason, messagingUrl) => {
    var _session$_$getSocket;
    const activeSocketUrl = (_session$_$getSocket = session._.getSocket()) == null ? void 0 : _session$_$getSocket._rumor.url;
    const connection = session.connection;

    // Bail if there is no connection or the socket closed is not the active one.
    if (!connection || activeSocketUrl !== messagingUrl) {
      return;
    }
    if (connection.destroyedReason()) {
      logging.debug(`${'Socket was closed but the connection had already ' + 'been destroyed. Reason: '}${connection.destroyedReason()}`);
      return;
    }
    connection.destroy(reason);
  });

  // This method adds connections to the session both on a connection#created and
  // on a session#read. In the case of session#read sessionRead is set to true and
  // we include our own connection.
  const addConnection = function addConnection(connection, sessionRead) {
    if (session.connections.has(connection.id)) {
      // Don't add a duplicate connection, since we add them not only on connection#created, but
      // also when stream#created or signal has an associated connection.
      return session.connections.get(connection.id);
    }
    connection = _connection.default.fromHash(connection);
    if (sessionRead || session.connection && connection.id !== session.connection.id) {
      session.connections.add(connection);
      delayedSessionEvents.triggerConnectionCreated(connection);
    }
    Object.keys(unconnectedStreams).forEach(streamId => {
      const stream = unconnectedStreams[streamId];
      if (stream && connection.id === stream.connection.id) {
        // dispatch streamCreated event now that the connectionCreated has been dispatched
        parseAndAddStreamToSession(stream, session);
        delete unconnectedStreams[stream.id];
        const payload = {
          debug: sessionRead ? 'connection came in session#read' : 'connection came in connection#created',
          streamId: stream.id,
          connectionId: connection.id
        };
        session.logEvent('streamCreated', 'warning', payload);
      }
    });
    return connection;
  };
  dispatcher.on('session#read', (content, transactionId) => {
    let connection;
    const state = {};
    state.streams = [];
    state.connections = [];
    state.archives = [];
    content.connection.forEach(connectionParams => {
      connection = addConnection(connectionParams, true);
      state.connections.push(connection);
    });
    content.stream.forEach(streamParams => {
      state.streams.push(parseAndAddStreamToSession(streamParams, session));
    });
    (content.archive || content.archives).forEach(archiveParams => {
      state.archives.push(parseAndAddArchiveToSession(archiveParams, session));
    });
    dispatcher.triggerCallback(transactionId, null, state);
    sessionStateReceived = true;
    delayedSessionEvents.triggerSessionConnected(session.connections);
  });
  dispatcher.on('session#update', content => {
    if (content.reason !== 'mute') {
      logging.debug('session#update that handle this reason is not currently implemented');
      return;
    }
    const active = content.active === true;
    session._.forceMute({
      active
    });
    if (active) {
      session._.enableMuteOnEntry();
    } else {
      session._.disableMuteOnEntry();
    }
  });
  dispatcher.on('session#notification', _ref2 => {
    let reason = _ref2.reason;
    // When we receive a notification with reason: serverRotation, we should migrate to a new
    // Rumor/Mantis since the current one is going to be shut down.
    if (reason === 'serverRotation') {
      session._.migrate();
    } else {
      logging.debug(`session#notification with reason '${reason}' is not currently implemented`);
    }
  });
  dispatcher.on('session#muted', () => {
    session._.enableMuteOnEntry();
    session._.forceMute({
      active: true
    });
  });
  dispatcher.on('connection#created', connection => {
    addConnection(connection);
  });
  dispatcher.on('connection#deleted', (connection, reason) => {
    connection = session.connections.get(connection);
    if (!connection) {
      logging.warn('A connection was deleted that we do not know about');
      return;
    }
    connection.destroy(reason);
  });
  dispatcher.on('stream#created', (content, transactionId) => {
    const streamId = content.id,
      sourceStreamId = content.sourceStreamId,
      connection = content.connection;
    let stream;
    if (connectionEventsSuppressed) {
      if (connection == null || connection.id == null) {
        session.logEvent('SessionDispatcher:stream#created', 'Event', {
          connection,
          info: 'Stream did not contain a connection object. Event ignored'
        });
        return;
      }
      addConnection(connection);
    }
    const connectionId = content.connectionId || connection.id;
    if (session.connections.has(connectionId)) {
      stream = parseAndAddStreamToSession(content, session);
    } else {
      unconnectedStreams[streamId] = content;
      const payload = {
        debug: 'eventOrderError -- streamCreated event before connectionCreated',
        streamId,
        sourceStreamId: (0, _getMediaModeBySourceStreamId.default)(sourceStreamId)
      };
      session.logEvent('streamCreated', 'warning', payload);
    }
    if (stream) {
      if (stream.publisher) {
        stream.publisher.setStream(stream);
      }
      dispatcher.triggerCallback(transactionId, null, stream);
    } else if (session.sessionInfo.isAdaptiveEnabled && sourceStreamId === 'P2P') {
      // A P2P stream was created in an adaptive session, so let's request a new subscriber for it
      _objects.default.subscribers.where({
        streamId
      }).forEach(subscriber => {
        subscriber._.startRoutedToRelayedTransition();
      });
    }
  });
  dispatcher.on('stream#deleted', (streamId, reason, content) => {
    const stream = session.streams.get(streamId);
    const sourceStreamId = content.sourceStreamId;
    const subscribers = _objects.default.subscribers;
    const isAdaptiveEnabled = session.sessionInfo.isAdaptiveEnabled;
    const isAdaptiveP2pStream = isAdaptiveEnabled && sourceStreamId === 'P2P';
    if (!stream && !isAdaptiveP2pStream) {
      // Stream has been previously deleted
      return;
    }
    if (isAdaptiveP2pStream) {
      // In adaptive sessions, when the P2P stream is destroyed we need to start the transition
      // from relayed to routed.
      subscribers.where({
        streamId
      }).forEach(subscriber => {
        subscriber._.startRelayedToRoutedTransition();
      });
    } else {
      stream.destroy(reason);
    }
  });
  dispatcher.on('stream#updated', (streamId, content) => {
    const stream = session.streams.get(streamId);
    if (!stream) {
      logging.error(`A stream does not exist with the id of ${streamId}, for stream#updated message!`);
      // @todo error
      return;
    }
    stream._.update(content);
  });
  dispatcher.on('stream#update', (streamId, content) => {
    const stream = session.streams.get(streamId);
    const reason = content.reason,
      active = content.active;
    if (!stream) {
      logging.error(`A stream does not exist with the id of ${streamId}, for stream#updated message!`);
      // @todo error
      return;
    }
    if (reason !== 'mute') {
      logging.debug('stream#update that handle this reason is not currently implemented');
      return;
    }
    if (active) {
      stream._.forceMute(content);
    }
  });
  dispatcher.on('streamChannel#updated', (streamId, channelId, content) => {
    let stream;
    // In the P2P leg of AMR-enabled sessions, messages are received from both P2P and Mantis.
    // We only want to dispatch one message, see VIDCS-35.
    if (session.sessionInfo.isAdaptiveEnabled && content.sourceStreamId === 'P2P') {
      return;
    }
    if (!(streamId && (stream = session.streams.get(streamId)))) {
      logging.error('Unable to determine streamId, or the stream does not ' + 'exist, for streamChannel message!');
      // @todo error
      return;
    }
    stream._.updateChannel(channelId, content);
  });

  // Dispatch JSEP messages
  //
  // generateoffer:
  // Request to generate a offer for another Peer (or Prism). This kicks
  // off the JSEP process.
  //
  // answer:
  // generate a response to another peers offer, this contains our constraints
  // and requirements.
  //
  // pranswer:
  // a provisional answer, i.e. not the final one.
  //
  // candidate
  //
  //

  const jsepHandler = (method, streamId, fromAddress, message) => {
    let subscriberFilter;
    let actors;
    const hasStreamId = {
      streamId
    };
    const subscribers = _objects.default.subscribers;
    const publishers = _objects.default.publishers;
    if (message.params.subscriber) {
      subscriberFilter = {
        widgetId: message.params.subscriber
      };
    } else {
      // if we don't know the subscriber, we will just match the stream id
      subscriberFilter = hasStreamId;
    }

    // Determine which subscriber/publisher objects should receive this message.
    switch (method) {
      case 'offer':
        actors = [].concat(subscribers.where(subscriberFilter), publishers.where(hasStreamId)).slice(0, 1);
        break;
      case 'answer':
      case 'pranswer':
        actors = [].concat(publishers.where(hasStreamId), subscribers.where(subscriberFilter)).slice(0, 1);
        break;
      case 'generateoffer':
      case 'unsubscribe':
        actors = publishers.where(hasStreamId);
        break;
      case 'candidate':
        actors = [].concat(subscribers.where(subscriberFilter), publishers.where(hasStreamId));
        break;
      default:
        logging.debug(`jsep#${method} is not currently implemented`);
        return;
    }
    if (actors.length === 0) {
      return;
    }
    let fromConnection = session.connections.get(fromAddress);
    if (!fromConnection && fromAddress.match(/^symphony\./)) {
      fromConnection = _connection.default.fromHash({
        id: fromAddress,
        creationTime: Math.floor((0, _now.default)())
      });
      session.connections.add(fromConnection);
    }
    actors.forEach( /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(actor) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return actor.processMessage(method, fromAddress, message);
            case 3:
              _context.next = 8;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              logging.error('Error occurred during processMessage', _context.t0);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
  };
  dispatcher.on('jsep#offer', jsepHandler.bind(null, 'offer'));
  dispatcher.on('jsep#answer', jsepHandler.bind(null, 'answer'));
  dispatcher.on('jsep#pranswer', jsepHandler.bind(null, 'pranswer'));
  dispatcher.on('jsep#generateoffer', jsepHandler.bind(null, 'generateoffer'));
  dispatcher.on('jsep#unsubscribe', jsepHandler.bind(null, 'unsubscribe'));
  dispatcher.on('jsep#candidate', jsepHandler.bind(null, 'candidate'));
  dispatcher.on('subscriberChannel#updated', (streamId, channelId, content) => {
    if (!streamId || !session.streams.has(streamId)) {
      logging.error('Unable to determine streamId, or the stream does not ' + 'exist, for subscriberChannel#updated message!');
      // @todo error
      return;
    }
    session.streams.get(streamId)._.updateChannel(channelId, content);
  });
  dispatcher.on('subscriberChannel#update', (subscriberId, streamId, content) => {
    if (!streamId || !session.streams.has(streamId)) {
      logging.error('Unable to determine streamId, or the stream does not ' + 'exist, for subscriberChannel#update message!');
      // @todo error
      return;
    }

    // Hint to update for congestion control from the Media Server
    if (!_objects.default.subscribers.has(subscriberId)) {
      logging.error('Unable to determine subscriberId, or the subscriber ' + 'does not exist, for subscriberChannel#update message!');
      // @todo error
      return;
    }

    // We assume that an update on a Subscriber channel is to disableVideo
    // we may need to be more specific in the future
    _objects.default.subscribers.get(subscriberId).disableVideo(content.active);
  });

  // Note: subscriber#created and subscriber#deleted messages are available but we currently
  // don't have a use for them.

  dispatcher.on('signal', (fromAddress, content) => {
    if (connectionEventsSuppressed) {
      let connection = content.connection || content.fromConnection;
      if (connection == null || connection.id == null) {
        connection = constructBareConnection(fromAddress);
        session.logEvent('SessionDispatcher:Signal', 'Event', {
          fromAddress,
          connection: content.connection,
          fromConnection: content.fromConnection,
          info: 'Signal did not contain a connection object. One has been constructed',
          constructedConnection: connection
        });
      }
      addConnection(connection);
    }
    const signalType = content.type;
    const data = content.data;
    const fromConnection = session.connections.get(fromAddress);
    if (session.connection && fromAddress === session.connection.connectionId) {
      if (sessionStateReceived) {
        session._.dispatchSignal(fromConnection, signalType, data);
      } else {
        delayedSessionEvents.enqueue('sessionConnected', 'signal', fromAddress, signalType, data);
      }
    } else if (session.connections.get(fromAddress)) {
      session._.dispatchSignal(fromConnection, signalType, data);
    } else if (fromAddress === '') {
      // Server originated signal
      session._.dispatchSignal(null, signalType, data);
    } else {
      delayedSessionEvents.enqueue(`connectionCreated${fromAddress}`, 'signal', fromAddress, signalType, data);
    }
  });
  dispatcher.on('caption', (fromAddress, content) => {
    session._.dispatchCaption(fromAddress, content);
  });
  dispatcher.on('senderStatsReceived', (subscriberId, content) => {
    var _sessionObjects$subsc;
    (_sessionObjects$subsc = _objects.default.subscribers.get(subscriberId)) == null ? void 0 : _sessionObjects$subsc._onSenderStatsReceived(content);
  });
  dispatcher.on('archive#created', archive => {
    parseAndAddArchiveToSession(archive, session);
  });
  dispatcher.on('archive#updated', (archiveId, update) => {
    const archive = session.archives.get(archiveId);
    if (!archive) {
      logging.error(`An archive does not exist with the id of ${archiveId}, for archive#updated message!`);
      // @todo error
      return;
    }
    archive._.update(update);
  });
  dispatcher.on('source#create', (sourceStreamId, streamId, reason) => {
    const mediaMode = (0, _getMediaModeBySourceStreamId.default)(sourceStreamId);
    session.logEvent('SessionDispatcher:source#create', 'Event', {
      sourceStreamId: mediaMode,
      streamId,
      reason
    });
    logging.debug('Received a request from RUMOR to start a transition to ' + `${sourceStreamId} for the stream ID ${streamId} with the reason: ${reason}`);
    _objects.default.publishers.where({
      streamId
    }).forEach(publisher => {
      publisher._.startRoutedToRelayedTransition();
    });
  });
  dispatcher.on('source#delete', (sourceStreamId, streamId, reason) => {
    session.logEvent('SessionDispatcher:source#delete', 'Event', {
      sourceStreamId: (0, _getMediaModeBySourceStreamId.default)(sourceStreamId),
      streamId,
      reason
    });
    logging.debug('Received a request from RUMOR to start a transition from P2P ' + `to MANTIS for the stream ID ${streamId} with the reason: ${reason}`);
    _objects.default.publishers.where({
      streamId
    }).forEach(publisher => {
      publisher._.startRelayedToRoutedTransition();
    });
  });
  return dispatcher;
}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Archive;
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _events = _interopRequireDefault(__webpack_require__(18));
const Events = (0, _events.default)();
function Archive(id, name, status) {
  this.id = id;
  this.name = name;
  this.status = status;
  this._ = {};
  (0, _eventing.default)(this);

  // Mass update, called by Raptor.Dispatcher
  this._.update = attributes => {
    Object.keys(attributes).forEach(key => {
      const oldValue = this[key];
      this[key] = attributes[key];
      const event = new Events.ArchiveUpdatedEvent(this, key, oldValue, this[key]);
      this.dispatchEvent(event);
    });
  };
  this.destroy = () => {};
}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(24)))

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(828),
    baseFlatten = __webpack_require__(256),
    baseRest = __webpack_require__(90),
    isArrayLikeObject = __webpack_require__(151);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _deviceHelpers2 = _interopRequireDefault(__webpack_require__(22));
const _deviceHelpers = (0, _deviceHelpers2.default)(),
  getAudioOutputMediaDevices = _deviceHelpers.getAudioOutputMediaDevices;

/**
 * Enumerates the audio output devices (such as speakers) available to the browser.
 * <p>
 *   The method returns a Promise which resolves an array of objects corresponding to
 *   available audio output devices. Each object has two properties: <code>deviceId</code>
 *   and <code>label</code>, each of which are strings.
 * </p>
 * <p>
 *   The <code>deviceId</code> property is a unique ID for the device. You can pass
 *   the <code>deviceId</code> as the parameter of the <a href="#setAudioOutputDevice">
 *   OT.setAudioOutputDevice()</a> method. The <code>deviceId</code>
 *   property is set to undefined if the user has not previously granted access to
 *   a camera and microphone. In the case there are no audio output devices available, the property
 *   is set to `null`.
 * <p>
 * </p>
 *   The <code>label</code> property identifies the device. The <code>label</code>
 *   property is set to an empty string if the user has not previously granted access to
 *   a camera and microphone.</li>
 * </p>
 * <p>
 * <em>Notes:</em>:
 * <ul>
 *   <li>
 *     Current browser support is for desktop versions of Chrome 49+,
 *     Edge 17+, and Opera 36+.
 *   </li>
 *   <li>
 *     The browser may limit the number of returned audio output devices
 *     to one before the user has granted access to a camera or microphone.
 *   </li>
 *  </ul>
 * </p>
 *
 * @see <a href="#setAudioOutputDevice">OT.setAudioOutputDevice()</a>
 * @see <a href="#getActiveAudioOutputDevice">OT.getActiveAudioOutputDevice()</a>
 * @method OT.getAudioOutputDevices
 * @memberof OT
 */
var _default = () => getAudioOutputMediaDevices();
exports.default = _default;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _deviceHelpers = _interopRequireDefault(__webpack_require__(22));
const _activeAudioOutputDev = (0, _deviceHelpers.default)(),
  getActiveAudioOutputDevice = _activeAudioOutputDev.getActiveAudioOutputDevice;
/**
 * Returns a Promise that resolves the current audio output device.
 * <p>
 *   The method returns a Promise which resolves an object that has two properties:
 *   <code>deviceId</code> and <code>label</code>, each of which are strings.
 * </p>
 * <p>
 *   The <code>deviceId</code> property is a unique ID for the device. You can pass
 *   the <code>deviceId</code> as the parameter of the <a href="#setAudioOutputDevice">
 *   OT.setAudioOutputDevice()</a> method. The <code>deviceId</code>
 *   property is set to undefined if the user has not previously granted access to
 *   a camera and microphone.
 * <p>
 * </p>
 *   The <code>label</code> property identifies the device. The <code>label</code>
 *   property is set to an empty string if the user has not previously granted access to
 *   a camera and microphone.</li>
 * </p>
 * <p>
 *  <em>Note</em>: Current browser support is for desktop versions of Chrome 49+,
 * Edge 17+, and Opera 36+.
 * </p>
 *
 * @see <a href="#getAudioOutputDevices">OT.getAudioOutputDevices()</a>
 * @see <a href="#setAudioOutputDevice">OT.setAudioOutputDevice()</a>
 * @method OT.getActiveAudioOutputDevice
 * @memberof OT
 */
var _default = () => getActiveAudioOutputDevice();
exports.default = _default;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _currentAudioOutputDevice = _interopRequireDefault(__webpack_require__(107));
var _deviceHelpers2 = _interopRequireDefault(__webpack_require__(22));
var _noop = _interopRequireDefault(__webpack_require__(259));
var _analytics = _interopRequireDefault(__webpack_require__(31));
var _objects = _interopRequireDefault(__webpack_require__(27));
var _getActiveAudioOutputDevice = _interopRequireDefault(__webpack_require__(364));
const setCurrentAudioOutputDeviceId = _currentAudioOutputDevice.default.setCurrentAudioOutputDeviceId;
const _deviceHelpers = (0, _deviceHelpers2.default)(),
  getDefaultAudioOutputDeviceId = _deviceHelpers.getDefaultAudioOutputDeviceId,
  getAudioOutputMediaDevices = _deviceHelpers.getAudioOutputMediaDevices;
const analytics = new _analytics.default();
const logUpdateSubscriberSinkId = (variation, payload) => {
  analytics.logEvent({
    action: 'updateSubscribersSinkId',
    variation,
    payload
  });
};
const updateSinkId = newDeviceId => {
  const updateSubscribersSinkId = _objects.default.subscribers.map(subscriber => subscriber._.setSinkId(newDeviceId));
  return Promise.all(updateSubscribersSinkId);
};
const rollbackToDevice = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(rollbackDeviceId) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _noop.default)();
        case 2:
          _context.prev = 2;
          logUpdateSubscriberSinkId('Attempt', {
            deviceId: rollbackDeviceId
          });
          _context.next = 6;
          return updateSinkId(rollbackDeviceId);
        case 6:
          logUpdateSubscriberSinkId('Success', {
            deviceId: rollbackDeviceId
          });
          _context.next = 13;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          logUpdateSubscriberSinkId('Failure', {
            deviceId: rollbackDeviceId,
            error: _context.t0 == null ? void 0 : _context.t0.message
          });
          throw _context.t0;
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return function rollbackToDevice(_x) {
    return _ref.apply(this, arguments);
  };
}();
const rollbackToDefaultDevice = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var devices, defaultDeviceId;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return getAudioOutputMediaDevices();
        case 2:
          devices = _context2.sent;
          defaultDeviceId = getDefaultAudioOutputDeviceId(devices);
          _context2.prev = 4;
          _context2.next = 7;
          return rollbackToDevice(defaultDeviceId);
        case 7:
          setCurrentAudioOutputDeviceId(defaultDeviceId);
          _context2.next = 12;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](4);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 10]]);
  }));
  return function rollbackToDefaultDevice() {
    return _ref2.apply(this, arguments);
  };
}();
const onUpdateSubscriberSinkIdError = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var currentDevice;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _getActiveAudioOutputDevice.default)();
        case 2:
          currentDevice = _context3.sent;
          _context3.prev = 3;
          _context3.next = 6;
          return rollbackToDevice(currentDevice.deviceId);
        case 6:
          _context3.next = 12;
          break;
        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](3);
          _context3.next = 12;
          return rollbackToDefaultDevice();
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 8]]);
  }));
  return function onUpdateSubscriberSinkIdError() {
    return _ref3.apply(this, arguments);
  };
}();
var _default = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(deviceId) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          logUpdateSubscriberSinkId('Attempt', {
            deviceId
          });
          _context4.next = 4;
          return updateSinkId(deviceId);
        case 4:
          logUpdateSubscriberSinkId('Success', {
            deviceId
          });
          setCurrentAudioOutputDeviceId(deviceId);
          _context4.next = 14;
          break;
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](0);
          logUpdateSubscriberSinkId('Failure', {
            deviceId,
            error: _context4.t0 == null ? void 0 : _context4.t0.message
          });
          _context4.next = 13;
          return onUpdateSubscriberSinkIdError();
        case 13:
          throw _context4.t0;
        case 14:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 8]]);
  }));
  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}();
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
var _clone = _interopRequireDefault(__webpack_require__(41));
var _NativeVideoElementWrapper = _interopRequireDefault(__webpack_require__(206));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _logLevels = _interopRequireDefault(__webpack_require__(130));
var _deviceHelpers = _interopRequireDefault(__webpack_require__(22));
var _audio_context = _interopRequireDefault(__webpack_require__(145));
var _get_audio_level_sampler = _interopRequireDefault(__webpack_require__(275));
var _webaudio_audio_level_sampler = _interopRequireDefault(__webpack_require__(146));
var _interval_runner = _interopRequireDefault(__webpack_require__(74));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _getNativeEnumerateDevices = _interopRequireDefault(__webpack_require__(260));
var _index = _interopRequireDefault(__webpack_require__(109));
var _video_orientation = _interopRequireDefault(__webpack_require__(154));
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _Event = _interopRequireDefault(__webpack_require__(148));
var _StaticConfig = _interopRequireDefault(__webpack_require__(48));
var _analytics = _interopRequireDefault(__webpack_require__(31));
var _setDeprecatedProperty = _interopRequireDefault(__webpack_require__(264));
var _runtimeProperties = _interopRequireDefault(__webpack_require__(593));
var _mutableRuntimeProperties = _interopRequireDefault(__webpack_require__(594));
var _no_conflict = _interopRequireDefault(__webpack_require__(595));
var _objects = _interopRequireDefault(__webpack_require__(27));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _createWindowMock = _interopRequireDefault(__webpack_require__(155));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _api_key = _interopRequireDefault(__webpack_require__(73));
var _audio_level_transformer = _interopRequireDefault(__webpack_require__(156));
var _calculateCapableSimulcastStreams = _interopRequireDefault(__webpack_require__(277));
var _chrome = _interopRequireDefault(__webpack_require__(157));
var _environment_loader = _interopRequireDefault(__webpack_require__(158));
var _generateConstraintInfo = _interopRequireDefault(__webpack_require__(278));
var _guid_storage = _interopRequireDefault(__webpack_require__(271));
var _setLogLevel = _interopRequireDefault(__webpack_require__(623));
var _parseIceServers = __webpack_require__(110);
var _max_delay = _interopRequireDefault(__webpack_require__(291));
var _stream_channel = _interopRequireDefault(__webpack_require__(161));
var _stylable_component = _interopRequireDefault(__webpack_require__(162));
var _system_requirements = _interopRequireDefault(__webpack_require__(163));
var _peer_connection = _interopRequireDefault(__webpack_require__(75));
var _chrome_extension_helper = _interopRequireDefault(__webpack_require__(308));
var _createChromeMixin = _interopRequireDefault(__webpack_require__(309));
var _events = _interopRequireDefault(__webpack_require__(18));
var _generate_simple_state_machine = _interopRequireDefault(__webpack_require__(170));
var _get_user_media = _interopRequireDefault(__webpack_require__(677));
var _screen_sharing = _interopRequireDefault(__webpack_require__(171));
var _processPubOptions = _interopRequireDefault(__webpack_require__(682));
var _getUserMedia = _interopRequireDefault(__webpack_require__(685));
var _interpretPeerConnectionError = _interopRequireDefault(__webpack_require__(172));
var _microphone = _interopRequireDefault(__webpack_require__(319));
var _videoElementErrorMap = _interopRequireDefault(__webpack_require__(273));
var _set_certificates = _interopRequireDefault(__webpack_require__(173));
var _publisher_peer_connection = _interopRequireDefault(__webpack_require__(320));
var _subscriber_peer_connection = _interopRequireDefault(__webpack_require__(326));
var _state = _interopRequireDefault(__webpack_require__(327));
var _report_issue = _interopRequireDefault(__webpack_require__(706));
var _widget_view = _interopRequireDefault(__webpack_require__(176));
var _subscriber = _interopRequireDefault(__webpack_require__(331));
var _publisher = _interopRequireDefault(__webpack_require__(182));
var _init = _interopRequireDefault(__webpack_require__(349));
var _session = _interopRequireDefault(__webpack_require__(350));
var _init2 = _interopRequireDefault(__webpack_require__(836));
var _getSupportedCodecs = _interopRequireDefault(__webpack_require__(837));
var _hasMediaProcessorSupport = _interopRequireDefault(__webpack_require__(838));
var _hasEndToEndEncryptionSupport = _interopRequireDefault(__webpack_require__(839));
var _archive = _interopRequireDefault(__webpack_require__(360));
var _capabilities = _interopRequireDefault(__webpack_require__(185));
var _connection = _interopRequireDefault(__webpack_require__(188));
var _get_devices = _interopRequireDefault(__webpack_require__(840));
var _getAudioOutputDevices = _interopRequireDefault(__webpack_require__(363));
var _getActiveAudioOutputDevice = _interopRequireDefault(__webpack_require__(364));
var _setAudioOutputDevice = _interopRequireDefault(__webpack_require__(841));
var _Qos = _interopRequireDefault(__webpack_require__(306));
var _SessionDispatcher = _interopRequireDefault(__webpack_require__(359));
var _Signal = _interopRequireDefault(__webpack_require__(357));
var _stream = _interopRequireDefault(__webpack_require__(186));
var _state2 = _interopRequireDefault(__webpack_require__(340));
var _get_stats_helpers = _interopRequireDefault(__webpack_require__(78));
var _getStatsAdapter = _interopRequireDefault(__webpack_require__(302));
var _proxyUrl = __webpack_require__(72);
var _unblockAudio = _interopRequireDefault(__webpack_require__(177));
var _audioOutputDevicesChangeListener = _interopRequireDefault(__webpack_require__(842));
__webpack_require__(844);
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable  import/newline-after-import, no-param-reassign */

const StaticConfig = (0, _StaticConfig.default)();
const logging = (0, _log.default)('OT');
const staticConfig = StaticConfig.onlyLocal();
const systemRequirements = (0, _system_requirements.default)();

// We need to do this first because of circular dependency issues with otplugin.js. @TODO: fix this.
const OT = {};

// noConflict is constructed before we override global.OT so we keep the original value
OT.noConflict = (0, _no_conflict.default)();
(typeof window !== undefined ? window : global).OT = OT;
/* eslint-disable-next-line import/no-commonjs */
module.exports = OT;
(() => {
  let TB = OT;
  Object.defineProperty((typeof window !== undefined ? window : global), 'TB', {
    get: () => {
      if (TB === OT) {
        // eslint-disable-next-line no-console
        console.warn('window.TB is deprecated, and will be removed in the future. Please access via window.OT');
      }
      return TB;
    },
    set: _TB => {
      TB = _TB;
    },
    // We provide a setter so noConflict works
    configurable: true
  });
})();
const windowMock = (0, _createWindowMock.default)((typeof window !== undefined ? window : global));
const PeerConnection = (0, _peer_connection.default)({
  global: windowMock
});
const otError = (0, _otError.default)({});
const audioContext = (0, _audio_context.default)();
const chromeExtensionHelper = (0, _chrome_extension_helper.default)({
  otError
});
const createChromeMixin = (0, _createChromeMixin.default)();
const getNativeEnumerateDevices = (0, _getNativeEnumerateDevices.default)({
  global: windowMock
});
const deviceHelpers = (0, _deviceHelpers.default)({
  getNativeEnumerateDevices
});
const Events = (0, _events.default)();
const generateSimpleStateMachine = (0, _generate_simple_state_machine.default)();
const getUserMediaHelper = (0, _get_user_media.default)({
  otError,
  global: windowMock
});
const screenSharing = (0, _screen_sharing.default)({
  chromeExtensionHelper,
  otError
});
const processPubOptions = (0, _processPubOptions.default)({
  deviceHelpers,
  generateConstraintInfo: _generateConstraintInfo.default,
  getUserMediaHelper,
  global: windowMock,
  OTHelpers: _OTHelpers.default,
  screenSharing
});
const getUserMedia = (0, _getUserMedia.default)({
  otError,
  processPubOptions
});
const interpretPeerConnectionError = (0, _interpretPeerConnectionError.default)({
  otError
});
const Microphone = (0, _microphone.default)();
const videoElementErrorMap = (0, _videoElementErrorMap.default)({
  otError
});
const NativeVideoElementWrapper = (0, _NativeVideoElementWrapper.default)({
  global: windowMock,
  videoElementErrorMap
});
const setCertificates = (0, _set_certificates.default)({
  global: windowMock
});
const PublisherPeerConnection = (0, _publisher_peer_connection.default)({
  PeerConnection,
  setCertificates
});
const SubscriberPeerConnection = (0, _subscriber_peer_connection.default)({
  PeerConnection,
  setCertificates
});
const PublishingState = (0, _state.default)();
const reportIssue = (0, _report_issue.default)({
  otError
});
const VideoElementFacade = (0, _index.default)({
  NativeVideoElementWrapper
});
const VideoOrientation = (0, _video_orientation.default)();
const WidgetView = (0, _widget_view.default)({
  VideoElementFacade
});
const Subscriber = (0, _subscriber.default)({
  interpretPeerConnectionError,
  otError,
  SubscriberPeerConnection,
  WidgetView
});
const Publisher = (0, _publisher.default)({
  APIKEY: _api_key.default,
  createChromeMixin,
  deviceHelpers,
  EnvironmentLoader: _environment_loader.default,
  Errors: _Errors.default,
  Events,
  ExceptionCodes: _exception_codes.default,
  calculateCapableSimulcastStreams: _calculateCapableSimulcastStreams.default,
  global: windowMock,
  interpretPeerConnectionError,
  IntervalRunner: _interval_runner.default,
  Microphone,
  otError,
  OTErrorClass: _ot_error_class.default,
  OTHelpers: _OTHelpers.default,
  parseIceServers: _parseIceServers.parseIceServers,
  processPubOptions,
  PUBLISH_MAX_DELAY: _max_delay.default,
  PublisherPeerConnection,
  PublishingState,
  StreamChannel: _stream_channel.default,
  systemRequirements,
  VideoOrientation,
  WidgetView
});
const initPublisher = (0, _init.default)({
  otError,
  Publisher
});
const Session = (0, _session.default)({
  global: windowMock,
  initPublisher,
  otError,
  Publisher,
  Subscriber
});
const initSession = (0, _init2.default)({
  Session
});

// Allow events to be bound on OT
(0, _eventing.default)(OT);
(0, _setDeprecatedProperty.default)(OT, '$', {
  name: 'OT.$',
  getMessage: 'Please use an external library like jQuery to select elements from the page.',
  value: _OTHelpers.default
});

// Define the APIKEY this is a global parameter which should not change
OT.APIKEY = _api_key.default.value;
OT.AnalyserAudioLevelSampler = _webaudio_audio_level_sampler.default;
OT.Archive = _archive.default;
OT.ArchiveEvent = Events.ArchiveEvent;
OT.ArchiveUpdatedEvent = Events.ArchiveUpdatedEvent;
OT.AudioLevelTransformer = _audio_level_transformer.default;
OT.AudioLevelUpdatedEvent = Events.AudioLevelUpdatedEvent;
OT.AudioInputDeviceChangedEvent = Events.AudioInputDeviceChangedEvent;
OT.Capabilities = _capabilities.default;
OT.Chrome = _chrome.default;
OT.Connection = _connection.default;
OT.ConnectionCapabilities = OT.Connection.Capabilities;
OT.ConnectionEvent = Events.ConnectionEvent;
OT.CpuPerformanceChangedEvent = Events.CpuPerformanceChangedEvent;
Object.keys(_logLevels.default).forEach(name => {
  OT[name.toUpperCase()] = _logLevels.default[name].priority;
});
OT.NONE = 0;
OT.debug = logging.debug;
OT.error = logging.error;
OT.info = logging.info;
OT.log = logging.log;
OT.warn = logging.warn;
OT.DestroyedEvent = Events.DestroyedEvent;
OT.EnvLoadedEvent = Events.EnvLoadedEvent;

// TODO: re-expose old screenSharing api

OT.Error = _ot_error_class.default;
OT.Error.on(_eventNames.default.EXCEPTION, exceptionEvent => {
  if (exceptionEvent.target === OT.Error) {
    // Rebind target to OT if it's set to OT.Error to preserve old behaviour.
    const exceptionEventClone = (0, _clone.default)(exceptionEvent);
    exceptionEventClone.target = OT;
    OT.dispatchEvent(exceptionEventClone);
  } else {
    OT.dispatchEvent(exceptionEvent);
  }
});
OT.Event = _Event.default;
OT.ExceptionCodes = _exception_codes.default;
OT.ExceptionEvent = Events.ExceptionEvent;
OT.getDevices = _get_devices.default;
OT.getAudioOutputDevices = _getAudioOutputDevices.default;
OT.getActiveAudioOutputDevice = _getActiveAudioOutputDevice.default;
OT.setAudioOutputDevice = (0, _setAudioOutputDevice.default)();
OT.GetAudioLevelSampler = _get_audio_level_sampler.default;
OT.HAS_REQUIREMENTS = 1;
OT.IntervalRunner = _interval_runner.default;
OT.IssueReportedEvent = Events.IssueReportedEvent;
OT.MediaStoppedEvent = Events.MediaStoppedEvent;
OT.MediaStreamAvailableEvent = Events.MediaStreamAvailableEvent;
OT.Microphone = Microphone;
OT.NOT_HAS_REQUIREMENTS = 0;
OT.PeerConnection = PeerConnection;

// TODO: this is here for repel, but it doesn't belong here
OT.PeerConnection.QOS = _Qos.default;
OT.Publisher = Publisher;
OT.PublisherPeerConnection = PublisherPeerConnection;
OT.PublishingState = PublishingState;
OT.MuteForcedEvent = Events.MuteForcedEvent;
OT.Session = Session;
OT.SessionConnectEvent = Events.SessionConnectEvent;
OT.SessionDisconnectEvent = Events.SessionDisconnectEvent;
OT.SessionDispatcher = _SessionDispatcher.default;
OT.Signal = _Signal.default;
OT.SignalEvent = Events.SignalEvent;
OT.Stream = _stream.default;
OT.StreamChannel = _stream_channel.default;
OT.StreamEvent = Events.StreamEvent;
OT.StreamPropertyChangedEvent = Events.StreamPropertyChangedEvent;
OT.StreamUpdatedEvent = Events.StreamUpdatedEvent;
OT.StylableComponent = _stylable_component.default;
OT.Subscriber = Subscriber;
OT.SubscriberPeerConnection = SubscriberPeerConnection;
OT.SubscribingState = _state2.default;
OT.VideoDimensionsChangedEvent = Events.VideoDimensionsChangedEvent;
OT.VideoDisableWarningEvent = Events.VideoDisableWarningEvent;
OT.VideoElement = VideoElementFacade;
OT.VideoEnabledChangedEvent = Events.VideoEnabledChangedEvent;
OT.VideoOrientation = VideoOrientation;
OT.WidgetView = WidgetView;
OT.getSupportedCodecs = _getSupportedCodecs.default;
OT.hasMediaProcessorSupport = _hasMediaProcessorSupport.default;
OT.hasEndToEndEncryptionSupport = _hasEndToEndEncryptionSupport.default;
OT._ = {
  AnalyticsHelper: _analytics.default,
  getClientGuid: _guid_storage.default.get,
  StaticConfig
};

/**
 *
 * The currently loaded version of OpenTok.js.
 *
 * @property {string} version
 * @readonly
 * @memberof OT
 */
Object.defineProperty(OT, 'version', {
  value: staticConfig.version
});
const properties = {};
const canPropertyBeMutated = property => _mutableRuntimeProperties.default.includes(property);
(0, _setDeprecatedProperty.default)(properties, 'version', {
  value: staticConfig.version,
  name: 'OT.properties.version',
  getWarning: 'Please use OT.version instead',
  warnOnSet: true,
  setWarning: 'Mutating version has no effect'
});
_runtimeProperties.default.forEach(keyMap => {
  let value;
  let key;
  if (Array.isArray(keyMap)) {
    const propKey = keyMap[0],
      staticConfigKey = keyMap[1];
    key = propKey;
    value = staticConfig[staticConfigKey] || staticConfigKey;
  } else {
    value = staticConfig[keyMap];
    key = keyMap;
  }
  const isPropertyMutable = canPropertyBeMutated(key);
  (0, _setDeprecatedProperty.default)(properties, key, {
    value,
    name: `OT.properties.${key}`,
    warnOnSet: true,
    canSet: isPropertyMutable,
    setWarning: isPropertyMutable ? `Mutating ${key} can cause side effects` : `Mutating ${key} has no effect`
  });
});
OT.properties = properties;

// OT.addEventListener comes from eventing(OT)
OT.audioContext = audioContext;
OT.checkScreenSharingCapability = screenSharing.checkCapability;
OT.checkSystemRequirements = systemRequirements.check;
OT.components = {};

// OT.dispatchEvent comes from eventing(OT)
// OT.emit comes from eventing(OT)
OT.generateSimpleStateMachine = generateSimpleStateMachine;
OT.getErrorTitleByCode = _ot_error_class.default.getTitleByCode;
OT.getLogs = logging.getLogs;

// This is misspelled in production too, being compatible here.
OT.getStatsAdpater = _getStatsAdapter.default;
OT.getStatsHelpers = _get_stats_helpers.default;
OT.getUserMedia = getUserMedia;
OT.handleJsException = _ot_error_class.default.handleJsException;
OT.initPublisher = initPublisher;
OT.setProxyUrl = _proxyUrl.setProxyUrl;
OT.initSession = function (apiKey, sessionId, opt) {
  if (sessionId == null) {
    sessionId = apiKey;
    apiKey = null;
  }

  // Ugly hack, make sure OT.APIKEY is set
  // TODO: Yep, sure is ugly. It appears to be needed by raptor. We should fix this situation.
  // UPDATE: This hack is the only reason why we need to wrap the actual initSession.
  if (_api_key.default.value.length === 0 && apiKey) {
    _api_key.default.value = apiKey;
    OT.APIKEY = apiKey;
  }
  return initSession(apiKey, sessionId, opt);
};
const deprecatedMessage = key => `${key} is deprecated and will be removed in a future version of OpenTok`;
const warnAndReturn = (name, value) => () => {
  // eslint-disable-next-line no-console
  console.warn(deprecatedMessage(name));
  return value;
};

// discourage us and others from using these OT methods
Object.defineProperties(OT, {
  isUnloaded: {
    get: warnAndReturn('OT.isUnloaded', _environment_loader.default.isUnloaded)
  },
  onLoad: {
    get: warnAndReturn('OT.onLoad', _environment_loader.default.onLoad)
  },
  onUnload: {
    get: warnAndReturn('OT.onUnload', _environment_loader.default.onUnload)
  },
  overrideGuidStorage: {
    get: warnAndReturn('OT.overrideGuidStorage', _guid_storage.default.override)
  }
});

// OT.off comes from eventing(OT)
// OT.on comes from eventing(OT)
// OT.once comes from eventing(OT)
// OT.removeEventListener comes from eventing(OT)
// OT.trigger comes from eventing(OT)

// Exposed here for partner usage.
OT.pickScreenSharingHelper = screenSharing.pickHelper;
OT.publishers = _objects.default.publishers;
OT.registerScreenSharingExtension = screenSharing.registerExtension;
OT.registerScreenSharingExtensionHelper = screenSharing.registerExtensionHelper;
OT.reportIssue = reportIssue;
OT.sessions = _objects.default.sessions;
OT.setLogLevel = _setLogLevel.default;
OT.shouldLog = logging.shouldLog;
OT.subscribers = _objects.default.subscribers;
OT.unblockAudio = _unblockAudio.default;
OT.upgradeSystemRequirements = systemRequirements.upgrade;

// Tidy up everything on unload
_environment_loader.default.onUnload(() => {
  _objects.default.publishers.destroy();
  _objects.default.subscribers.destroy();
  _objects.default.sessions.destroy('unloaded');
});
(0, _audioOutputDevicesChangeListener.default)();

/**
 * This method is deprecated. Use <a href="#on">on()</a> or <a href="#once">once()</a> instead.
 *
 * <p>
 * Registers a method as an event listener for a specific event.
 * </p>
 *
 * <p>
 * The OT object dispatches one type of event &#151; an <code>exception</code> event. The
 * following code adds an event listener for the <code>exception</code> event:
 * </p>
 *
 * <pre>
 * OT.addEventListener("exception", exceptionHandler);
 *
 * function exceptionHandler(event) {
 *    alert("exception event. \n  code == " + event.code + "\n  message == " + event.message);
 * }
 * </pre>
 *
 * <p>
 *   If a handler is not registered for an event, the event is ignored locally. If the event
 *   listener function does not exist, the event is ignored locally.
 * </p>
 * <p>
 *   Throws an exception if the <code>listener</code> name is invalid.
 * </p>
 *
 * @param {String} type The string identifying the type of event.
 *
 * @param {Function} listener The function to be invoked when the OT object dispatches the event.
 * @see <a href="#on">on()</a>
 * @see <a href="#once">once()</a>
 * @memberof OT
 * @method addEventListener
 *
 */

/**
 * This method is deprecated. Use <a href="#off">off()</a> instead.
 *
 * <p>
 * Removes an event listener for a specific event.
 * </p>
 *
 * <p>
 *   Throws an exception if the <code>listener</code> name is invalid.
 * </p>
 *
 * @param {String} type The string identifying the type of event.
 *
 * @param {Function} listener The event listener function to remove.
 *
 * @see <a href="#off">off()</a>
 * @memberof OT
 * @method removeEventListener
 */

/**
* Adds an event handler function for one or more events.
*
* <p>
* The OT object dispatches one type of event &#151; an <code>exception</code> event. The following
* code adds an event
* listener for the <code>exception</code> event:
* </p>
*
* <pre>
* OT.on("exception", function (event) {
*   // This is the event handler.
* });
* </pre>
*
* <p>You can also pass in a third <code>context</code> parameter (which is optional) to define the
* value of
* <code>this</code> in the handler method:</p>
*
* <pre>
* OT.on("exception",
*   function (event) {
*     // This is the event handler.
*   }),
*   session
* );
* </pre>
*
* <p>
* If you do not add a handler for an event, the event is ignored locally.
* </p>
*
* @param {String} type The string identifying the type of event.
* @param {Function} handler The handler function to process the event. This function takes the event
* object as a parameter.
* @param {Object} context (Optional) Defines the value of <code>this</code> in the event handler
* function.
*
* @memberof OT
* @method on
* @see <a href="#off">off()</a>
* @see <a href="#once">once()</a>
* @see <a href="#events">Events</a>
*/

/**
* Adds an event handler function for an event. Once the handler is called, the specified handler
* method is
* removed as a handler for this event. (When you use the <code>OT.on()</code> method to add an event
* handler, the handler
* is <i>not</i> removed when it is called.) The <code>OT.once()</code> method is the equivilent of
* calling the <code>OT.on()</code>
* method and calling <code>OT.off()</code> the first time the handler is invoked.
*
* <p>
* The following code adds a one-time event handler for the <code>exception</code> event:
* </p>
*
* <pre>
* OT.once("exception", function (event) {
*   console.log(event);
* }
* </pre>
*
* <p>You can also pass in a third <code>context</code> parameter (which is optional) to define the
* value of
* <code>this</code> in the handler method:</p>
*
* <pre>
* OT.once("exception",
*   function (event) {
*     // This is the event handler.
*   },
*   session
* );
* </pre>
*
* <p>
* The method also supports an alternate syntax, in which the first parameter is an object that is a
* hash map of
* event names and handler functions and the second parameter (optional) is the context for this in
* each handler:
* </p>
* <pre>
* OT.once(
*   {exeption: function (event) {
*     // This is the event handler.
*     }
*   },
*   session
* );
* </pre>
*
* @param {String} type The string identifying the type of event. You can specify multiple event
* names in this string,
* separating them with a space. The event handler will process the first occurence of the events.
* After the first event,
* the handler is removed (for all specified events).
* @param {Function} handler The handler function to process the event. This function takes the event
* object as a parameter.
* @param {Object} context (Optional) Defines the value of <code>this</code> in the event handler
* function.
*
* @memberof OT
* @method once
* @see <a href="#on">on()</a>
* @see <a href="#once">once()</a>
* @see <a href="#events">Events</a>
*/

/**
 * Removes an event handler.
 *
 * <p>Pass in an event name and a handler method, the handler is removed for that event:</p>
 *
 * <pre>OT.off("exceptionEvent", exceptionEventHandler);</pre>
 *
 * <p>If you pass in an event name and <i>no</i> handler method, all handlers are removed for that
 * events:</p>
 *
 * <pre>OT.off("exceptionEvent");</pre>
 *
 * <p>
 * The method also supports an alternate syntax, in which the first parameter is an object that is a
 * hash map of
 * event names and handler functions and the second parameter (optional) is the context for matching
 * handlers:
 * </p>
 * <pre>
 * OT.off(
 *   {
 *     exceptionEvent: exceptionEventHandler
 *   },
 *   this
 * );
 * </pre>
 *
 * @param {String} type (Optional) The string identifying the type of event. You can use a space to
 * specify multiple events, as in "eventName1 eventName2 eventName3". If you pass in no
 * <code>type</code> value (or other arguments), all event handlers are removed for the object.
 * @param {Function} handler (Optional) The event handler function to remove. If you pass in no
 * <code>handler</code>, all event handlers are removed for the specified event <code>type</code>.
 * @param {Object} context (Optional) If you specify a <code>context</code>, the event handler is
 * removed for all specified events and handlers that use the specified context.
 *
 * @memberof OT
 * @method off
 * @see <a href="#on">on()</a>
 * @see <a href="#once">once()</a>
 * @see <a href="#events">Events</a>
 */

/**
 * Dispatched by the OT class when the app encounters an exception.
 * Note that you set up an event handler for the <code>exception</code> event by calling the
 * <code>OT.on()</code> method.
 *
 * @name exception
 * @event
 * @borrows ExceptionEvent#message as this.message
 * @memberof OT
 * @see ExceptionEvent
 */

/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(83);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(83);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(83);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(83);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(82);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 374 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(82),
    Map = __webpack_require__(116),
    MapCache = __webpack_require__(117);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(20),
    isMasked = __webpack_require__(380),
    isObject = __webpack_require__(11),
    toSource = __webpack_require__(190);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(43);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(381);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(16);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(384),
    ListCache = __webpack_require__(82),
    Map = __webpack_require__(116);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(385),
    hashDelete = __webpack_require__(386),
    hashGet = __webpack_require__(387),
    hashHas = __webpack_require__(388),
    hashSet = __webpack_require__(389);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isLength = __webpack_require__(119),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(194);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    keysIn = __webpack_require__(55);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11),
    isPrototype = __webpack_require__(69),
    nativeKeysIn = __webpack_require__(402);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    getSymbols = __webpack_require__(122);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    getSymbolsIn = __webpack_require__(197);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(42),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(42),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(125),
    cloneDataView = __webpack_require__(410),
    cloneRegExp = __webpack_require__(411),
    cloneSymbol = __webpack_require__(412),
    cloneTypedArray = __webpack_require__(204);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(125);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(43);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(414),
    baseUnary = __webpack_require__(68),
    nodeUtil = __webpack_require__(120);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(45),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(416),
    baseUnary = __webpack_require__(68),
    nodeUtil = __webpack_require__(120);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(45),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() {
  return this || (typeof self === "object" && self);
})() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(418);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Promise) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() {
    return this || (typeof self === "object" && self);
  })() || Function("return this")()
);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(420),
    defineProperty = __webpack_require__(191),
    identity = __webpack_require__(91);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 */

exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly

  var useColorsOption = getOption('colors');

  if (/^(no|off|false|disabled)$/i.test(useColorsOption)) {
    return false;
  }

  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return Boolean((typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/)));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + module.exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.setItem('debug', namespaces);
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.getItem('debug');
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

function getOption(key) {
  var storageKey = 'debug_' + key.toLowerCase();
  try {
    return exports.storage.getItem(storageKey);
  } catch (err) {
    if (typeof process !== 'undefined' && 'env' in process) {
      return process.env[storageKey.toUpperCase()];
    }
    return undefined;
  }
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (e) {}
}

module.exports = __webpack_require__(422)(exports);

var formatters = module.exports.formatters;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(24)))

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

module.exports = function setup(env) {
  createDebug.debug = createDebug['default'] = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __webpack_require__(423);

  Object.keys(env).forEach(function(key) {
    createDebug[key] = env[key];
  });

  /**
   * Active `debug` instances.
   */
  createDebug.instances = [];

  /**
   * The currently active debug mode names, and names to skip.
   */

  createDebug.names = [];
  createDebug.skips = [];

  /**
   * Map of special "%n" handling functions, for the debug "format" argument.
   *
   * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
   */

  createDebug.formatters = {};

  /**
   * Select a color.
   * @param {String} namespace
   * @return {Number}
   * @api private
   */

  function selectColor(namespace) {
    var hash = 0, i;

    for (i in namespace) {
      hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }
  createDebug.selectColor = selectColor;

  /**
   * Create a debugger with the given `namespace`.
   *
   * @param {String} namespace
   * @return {Function}
   * @api public
   */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // disabled?
      if (!debug.enabled) return;

      var self = debug;

      // set `diff` timestamp
      var curr = +new Date();
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;

      // turn the `arguments` into a proper Array
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }

      args[0] = createDebug.coerce(args[0]);

      if ('string' !== typeof args[0]) {
        // anything else let's inspect with %O
        args.unshift('%O');
      }

      // apply any `formatters` transformations
      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
        // if we encounter an escaped % then don't increase the array index
        if (match === '%%') return match;
        index++;
        var formatter = createDebug.formatters[format];
        if ('function' === typeof formatter) {
          var val = args[index];
          match = formatter.call(self, val);

          // now we need to remove `args[index]` since it's inlined in the `format`
          args.splice(index, 1);
          index--;
        }
        return match;
      });

      // apply env-specific formatting (colors, etc.)
      createDebug.formatArgs.call(self, args);

      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    //debug.formatArgs = formatArgs;
    //debug.rawLog = rawLog;

    // env-specific initialization logic for debug instances
    if ('function' === typeof createDebug.init) {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);

    return debug;
  }

  function destroy () {
    var index = createDebug.instances.indexOf(this);
    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    } else {
      return false;
    }
  }

  /**
   * Enables a debug mode by namespaces. This can include modes
   * separated by a colon and wildcards.
   *
   * @param {String} namespaces
   * @api public
   */

  function enable(namespaces) {
    createDebug.save(namespaces);

    createDebug.names = [];
    createDebug.skips = [];

    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) continue; // ignore empty strings
      namespaces = split[i].replace(/\*/g, '.*?');
      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }

  /**
   * Disable debug output.
   *
   * @api public
   */

  function disable() {
    createDebug.enable('');
  }

  /**
   * Returns true if the given mode name is enabled, false otherwise.
   *
   * @param {String} name
   * @return {Boolean}
   * @api public
   */

  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }
    var i, len;
    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }
    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Coerce `val`.
   *
   * @param {Mixed} val
   * @return {Mixed}
   * @api private
   */

  function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
  }

  createDebug.enable(createDebug.load());

  return createDebug;
}


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _es6WeakMap = _interopRequireDefault(__webpack_require__(210));
const contexts = new _es6WeakMap.default();

/**
 * This method needs to memoize fns with their context, this is
 * so that calls to off will have the same identity to the calls
 * to on.
 * @param {function} fn
 * @param {object} context
 */
function weakMemoizeBind(fn, context) {
  if (context === undefined) {
    return fn;
  }
  if (!contexts.has(context)) {
    contexts.set(context, new _es6WeakMap.default());
  }
  const fnMap = contexts.get(context);
  if (!fnMap.has(fn)) {
    fnMap.set(fn, fn.bind(context));
  }
  return fnMap.get(fn);
}
var _default = weakMemoizeBind;
exports.default = _default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var weakMap, obj;

	if (typeof WeakMap !== "function") return false;
	try {
		// WebKit doesn't support arguments and crashes
		weakMap = new WeakMap([[obj = {}, "one"], [{}, "two"], [{}, "three"]]);
	} catch (e) {
		return false;
	}
	if (String(weakMap) !== "[object WeakMap]") return false;
	if (typeof weakMap.set !== "function") return false;
	if (weakMap.set({}, 1) !== weakMap) return false;
	if (typeof weakMap.delete !== "function") return false;
	if (typeof weakMap.has !== "function") return false;
	if (weakMap.get(obj) !== "one") return false;

	return true;
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue           = __webpack_require__(46)
  , setPrototypeOf    = __webpack_require__(131)
  , object            = __webpack_require__(429)
  , ensureValue       = __webpack_require__(35)
  , randomUniq        = __webpack_require__(430)
  , d                 = __webpack_require__(36)
  , getIterator       = __webpack_require__(217)
  , forOf             = __webpack_require__(472)
  , toStringTagSymbol = __webpack_require__(47).toStringTag
  , isNative          = __webpack_require__(473)

  , isArray = Array.isArray, defineProperty = Object.defineProperty
  , objHasOwnProperty = Object.prototype.hasOwnProperty, getPrototypeOf = Object.getPrototypeOf
  , WeakMapPoly;

module.exports = WeakMapPoly = function (/* Iterable*/) {
	var iterable = arguments[0], self;

	if (!(this instanceof WeakMapPoly)) throw new TypeError("Constructor requires 'new'");
	self = isNative && setPrototypeOf && (WeakMap !== WeakMapPoly)
		? setPrototypeOf(new WeakMap(), getPrototypeOf(this)) : this;

	if (isValue(iterable)) {
		if (!isArray(iterable)) iterable = getIterator(iterable);
	}
	defineProperty(self, "__weakMapData__", d("c", "$weakMap$" + randomUniq()));
	if (!iterable) return self;
	forOf(iterable, function (val) {
		ensureValue(val);
		self.set(val[0], val[1]);
	});
	return self;
};

if (isNative) {
	if (setPrototypeOf) setPrototypeOf(WeakMapPoly, WeakMap);
	WeakMapPoly.prototype = Object.create(WeakMap.prototype, { constructor: d(WeakMapPoly) });
}

Object.defineProperties(WeakMapPoly.prototype, {
	delete: d(function (key) {
		if (objHasOwnProperty.call(object(key), this.__weakMapData__)) {
			delete key[this.__weakMapData__];
			return true;
		}
		return false;
	}),
	get: d(function (key) {
		if (!objHasOwnProperty.call(object(key), this.__weakMapData__)) return undefined;
		return key[this.__weakMapData__];
	}),
	has: d(function (key) {
		return objHasOwnProperty.call(object(key), this.__weakMapData__);
	}),
	set: d(function (key, value) {
		defineProperty(object(key), this.__weakMapData__, d("c", value));
		return this;
	}),
	toString: d(function () {
		return "[object WeakMap]";
	})
});
defineProperty(WeakMapPoly.prototype, toStringTagSymbol, d("c", "WeakMap"));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable-next-line no-empty-function
module.exports = function () {};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Workaround for http://code.google.com/p/v8/issues/detail?id=2804



var create = Object.create, shim;

if (!__webpack_require__(211)()) {
	shim = __webpack_require__(212);
}

module.exports = (function () {
	var nullObject, polyProps, desc;
	if (!shim) return create;
	if (shim.level !== 1) return create;

	nullObject = {};
	polyProps = {};
	desc = { configurable: false, enumerable: false, writable: true, value: undefined };
	Object.getOwnPropertyNames(Object.prototype).forEach(function (name) {
		if (name === "__proto__") {
			polyProps[name] = {
				configurable: true,
				enumerable: false,
				writable: true,
				value: undefined
			};
			return;
		}
		polyProps[name] = desc;
	});
	Object.defineProperties(nullObject, polyProps);

	Object.defineProperty(shim, "nullPolyfill", {
		configurable: false,
		enumerable: false,
		writable: false,
		value: nullObject
	});

	return function (prototype, props) {
		return create(prototype === null ? nullObject : prototype, props);
	};
})();


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(213);

module.exports = function (value) {
	if (!isObject(value)) throw new TypeError(value + " is not an Object");
	return value;
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var generated = Object.create(null), random = Math.random;

module.exports = function () {
	var str;
	do {
		str = random().toString(36).slice(2);
	} while (generated[str]);
	return str;
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPrototype = __webpack_require__(432);

module.exports = function (value) {
	if (typeof value !== "function") return false;

	if (!hasOwnProperty.call(value, "length")) return false;

	try {
		if (typeof value.length !== "number") return false;
		if (typeof value.call !== "function") return false;
		if (typeof value.apply !== "function") return false;
	} catch (error) {
		return false;
	}

	return !isPrototype(value);
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(132);

module.exports = function (value) {
	if (!isObject(value)) return false;
	try {
		if (!value.constructor) return false;
		return value.constructor.prototype === value;
	} catch (error) {
		return false;
	}
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys  = __webpack_require__(435)
  , value = __webpack_require__(35)
  , max   = Math.max;

module.exports = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(436)() ? Object.keys : __webpack_require__(437);


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(46);

var keys = Object.keys;

module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return str.contains("dwa") === true && str.contains("foo") === false;
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var indexOf = String.prototype.indexOf;

module.exports = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var setPrototypeOf = __webpack_require__(131)
  , contains       = __webpack_require__(216)
  , d              = __webpack_require__(36)
  , Symbol         = __webpack_require__(47)
  , Iterator       = __webpack_require__(219);

var defineProperty = Object.defineProperty, ArrayIterator;

ArrayIterator = module.exports = function (arr, kind) {
	if (!(this instanceof ArrayIterator)) throw new TypeError("Constructor requires 'new'");
	Iterator.call(this, arr);
	if (!kind) kind = "value";
	else if (contains.call(kind, "key+value")) kind = "key+value";
	else if (contains.call(kind, "key")) kind = "key";
	else kind = "value";
	defineProperty(this, "__kind__", d("", kind));
};
if (setPrototypeOf) setPrototypeOf(ArrayIterator, Iterator);

// Internal %ArrayIteratorPrototype% doesn't expose its constructor
delete ArrayIterator.prototype.constructor;

ArrayIterator.prototype = Object.create(Iterator.prototype, {
	_resolve: d(function (i) {
		if (this.__kind__ === "value") return this.__list__[i];
		if (this.__kind__ === "key+value") return [i, this.__list__[i]];
		return i;
	})
});
defineProperty(ArrayIterator.prototype, Symbol.toStringTag, d("c", "Array Iterator"));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global     = __webpack_require__(94)
  , validTypes = { object: true, symbol: true };

module.exports = function () {
	var Symbol = global.Symbol;
	var symbol;
	if (typeof Symbol !== "function") return false;
	symbol = Symbol("test symbol");
	try { String(symbol); }
	catch (e) { return false; }

	// Return 'true' also for polyfills
	if (!validTypes[typeof Symbol.iterator]) return false;
	if (!validTypes[typeof Symbol.toPrimitive]) return false;
	if (!validTypes[typeof Symbol.toStringTag]) return false;

	return true;
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};


/***/ }),
/* 443 */
/***/ (function(module, exports) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ is resolved with global context, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ES2015 Symbol polyfill for environments that do not (or partially) support it



var d                    = __webpack_require__(36)
  , validateSymbol       = __webpack_require__(218)
  , NativeSymbol         = __webpack_require__(94).Symbol
  , generateName         = __webpack_require__(446)
  , setupStandardSymbols = __webpack_require__(447)
  , setupSymbolRegistry  = __webpack_require__(448);

var create = Object.create
  , defineProperties = Object.defineProperties
  , defineProperty = Object.defineProperty;

var SymbolPolyfill, HiddenSymbol, isNativeSafe;

if (typeof NativeSymbol === "function") {
	try {
		String(NativeSymbol());
		isNativeSafe = true;
	} catch (ignore) {}
} else {
	NativeSymbol = null;
}

// Internal constructor (not one exposed) for creating Symbol instances.
// This one is used to ensure that `someSymbol instanceof Symbol` always return false
HiddenSymbol = function Symbol(description) {
	if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
	return SymbolPolyfill(description);
};

// Exposed `Symbol` constructor
// (returns instances of HiddenSymbol)
module.exports = SymbolPolyfill = function Symbol(description) {
	var symbol;
	if (this instanceof Symbol) throw new TypeError("Symbol is not a constructor");
	if (isNativeSafe) return NativeSymbol(description);
	symbol = create(HiddenSymbol.prototype);
	description = description === undefined ? "" : String(description);
	return defineProperties(symbol, {
		__description__: d("", description),
		__name__: d("", generateName(description))
	});
};

setupStandardSymbols(SymbolPolyfill);
setupSymbolRegistry(SymbolPolyfill);

// Internal tweaks for real symbol producer
defineProperties(HiddenSymbol.prototype, {
	constructor: d(SymbolPolyfill),
	toString: d("", function () { return this.__name__; })
});

// Proper implementation of methods exposed on Symbol.prototype
// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
defineProperties(SymbolPolyfill.prototype, {
	toString: d(function () { return "Symbol (" + validateSymbol(this).__description__ + ")"; }),
	valueOf: d(function () { return validateSymbol(this); })
});
defineProperty(
	SymbolPolyfill.prototype,
	SymbolPolyfill.toPrimitive,
	d("", function () {
		var symbol = validateSymbol(this);
		if (typeof symbol === "symbol") return symbol;
		return symbol.toString();
	})
);
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));

// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
);

// Note: It's important to define `toPrimitive` as last one, as some implementations
// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
// And that may invoke error in definition flow:
// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
);


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
	if (!value) return false;
	if (typeof value === "symbol") return true;
	if (!value.constructor) return false;
	if (value.constructor.name !== "Symbol") return false;
	return value[value.constructor.toStringTag] === "Symbol";
};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d = __webpack_require__(36);

var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;

var created = create(null);
module.exports = function (desc) {
	var postfix = 0, name, ie11BugWorkaround;
	while (created[desc + (postfix || "")]) ++postfix;
	desc += postfix || "";
	created[desc] = true;
	name = "@@" + desc;
	defineProperty(
		objPrototype,
		name,
		d.gs(null, function (value) {
			// For IE11 issue see:
			// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
			//    ie11-broken-getters-on-dom-objects
			// https://github.com/medikoo/es6-symbol/issues/12
			if (ie11BugWorkaround) return;
			ie11BugWorkaround = true;
			defineProperty(this, name, d(value));
			ie11BugWorkaround = false;
		})
	);
	return name;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d            = __webpack_require__(36)
  , NativeSymbol = __webpack_require__(94).Symbol;

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		// To ensure proper interoperability with other native functions (e.g. Array.from)
		// fallback to eventual native implementation of given symbol
		hasInstance: d(
			"", (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill("hasInstance")
		),
		isConcatSpreadable: d(
			"",
			(NativeSymbol && NativeSymbol.isConcatSpreadable) ||
				SymbolPolyfill("isConcatSpreadable")
		),
		iterator: d("", (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill("iterator")),
		match: d("", (NativeSymbol && NativeSymbol.match) || SymbolPolyfill("match")),
		replace: d("", (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill("replace")),
		search: d("", (NativeSymbol && NativeSymbol.search) || SymbolPolyfill("search")),
		species: d("", (NativeSymbol && NativeSymbol.species) || SymbolPolyfill("species")),
		split: d("", (NativeSymbol && NativeSymbol.split) || SymbolPolyfill("split")),
		toPrimitive: d(
			"", (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill("toPrimitive")
		),
		toStringTag: d(
			"", (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill("toStringTag")
		),
		unscopables: d(
			"", (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill("unscopables")
		)
	});
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d              = __webpack_require__(36)
  , validateSymbol = __webpack_require__(218);

var registry = Object.create(null);

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (registry[key]) return registry[key];
			return (registry[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (symbol) {
			var key;
			validateSymbol(symbol);
			for (key in registry) {
				if (registry[key] === symbol) return key;
			}
			return undefined;
		})
	});
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Inspired by Google Closure:
// http://closure-library.googlecode.com/svn/docs/
// closure_goog_array_array.js.html#goog.array.clear



var value = __webpack_require__(35);

module.exports = function () {
	value(this).length = 0;
	return this;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue             = __webpack_require__(57)
  , ensureValue         = __webpack_require__(451)
  , ensurePlainFunction = __webpack_require__(455)
  , copy                = __webpack_require__(456)
  , normalizeOptions    = __webpack_require__(215)
  , map                 = __webpack_require__(466);

var bind = Function.prototype.bind
  , defineProperty = Object.defineProperty
  , hasOwnProperty = Object.prototype.hasOwnProperty
  , define;

define = function (name, desc, options) {
	var value = ensureValue(desc) && ensurePlainFunction(desc.value), dgs;
	dgs = copy(desc);
	delete dgs.writable;
	delete dgs.value;
	dgs.get = function () {
		if (!options.overwriteDefinition && hasOwnProperty.call(this, name)) return value;
		desc.value = bind.call(value, options.resolveContext ? options.resolveContext(this) : this);
		defineProperty(this, name, desc);
		return this[name];
	};
	return dgs;
};

module.exports = function (props/*, options*/) {
	var options = normalizeOptions(arguments[1]);
	if (isValue(options.resolveContext)) ensurePlainFunction(options.resolveContext);
	return map(props, function (desc, name) { return define(name, desc, options); });
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var resolveException = __webpack_require__(220)
  , is               = __webpack_require__(57);

module.exports = function (value/*, options*/) {
	if (is(value)) return value;
	return resolveException(value, "Cannot use %v", arguments[1]);
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue  = __webpack_require__(57)
  , isObject = __webpack_require__(132);

var objectToString = Object.prototype.toString;

module.exports = function (value) {
	if (!isValue(value)) return null;
	if (isObject(value)) {
		// Reject Object.prototype.toString coercion
		var valueToString = value.toString;
		if (typeof valueToString !== "function") return null;
		if (valueToString === objectToString) return null;
		// Note: It can be object coming from other realm, still as there's no ES3 and CSP compliant
		// way to resolve its realm's Object.prototype.toString it's left as not addressed edge case
	}
	try {
		return "" + value; // Ensure implicit coercion
	} catch (error) {
		return null;
	}
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var safeToString = __webpack_require__(454);

var reNewLine = /[\n\r\u2028\u2029]/g;

module.exports = function (value) {
	var string = safeToString(value);
	if (string === null) return "<Non-coercible to string value>";
	// Trim if too long
	if (string.length > 100) string = string.slice(0, 99) + "…";
	// Replace eventual new lines
	string = string.replace(reNewLine, function (char) {
		switch (char) {
			case "\n":
				return "\\n";
			case "\r":
				return "\\r";
			case "\u2028":
				return "\\u2028";
			case "\u2029":
				return "\\u2029";
			/* istanbul ignore next */
			default:
				throw new Error("Unexpected character");
		}
	});
	return string;
};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
	try {
		return value.toString();
	} catch (error) {
		try { return String(value); }
		catch (error2) { return null; }
	}
};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var resolveException = __webpack_require__(220)
  , is               = __webpack_require__(214);

module.exports = function (value/*, options*/) {
	if (is(value)) return value;
	return resolveException(value, "%v is not a plain function", arguments[1]);
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var aFrom  = __webpack_require__(457)
  , assign = __webpack_require__(133)
  , value  = __webpack_require__(35);

module.exports = function (obj /*, propertyNames, options*/) {
	var copy = Object(value(obj)), propertyNames = arguments[1], options = Object(arguments[2]);
	if (copy !== obj && !propertyNames) return copy;
	var result = {};
	if (propertyNames) {
		aFrom(propertyNames, function (propertyName) {
			if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
		});
	} else {
		assign(result, obj);
	}
	return result;
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(458)() ? Array.from : __webpack_require__(459);


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var from = Array.from, arr, result;
	if (typeof from !== "function") return false;
	arr = ["raz", "dwa"];
	result = from(arr);
	return Boolean(result && result !== arr && result[1] === "dwa");
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var iteratorSymbol = __webpack_require__(47).iterator
  , isArguments    = __webpack_require__(92)
  , isFunction     = __webpack_require__(460)
  , toPosInt       = __webpack_require__(461)
  , callable       = __webpack_require__(70)
  , validValue     = __webpack_require__(35)
  , isValue        = __webpack_require__(46)
  , isString       = __webpack_require__(93)
  , isArray        = Array.isArray
  , call           = Function.prototype.call
  , desc           = { configurable: true, enumerable: true, writable: true, value: null }
  , defineProperty = Object.defineProperty;

// eslint-disable-next-line complexity, max-lines-per-function
module.exports = function (arrayLike /*, mapFn, thisArg*/) {
	var mapFn = arguments[1]
	  , thisArg = arguments[2]
	  , Context
	  , i
	  , j
	  , arr
	  , length
	  , code
	  , iterator
	  , result
	  , getIterator
	  , value;

	arrayLike = Object(validValue(arrayLike));

	if (isValue(mapFn)) callable(mapFn);
	if (!this || this === Array || !isFunction(this)) {
		// Result: Plain array
		if (!mapFn) {
			if (isArguments(arrayLike)) {
				// Source: Arguments
				length = arrayLike.length;
				if (length !== 1) return Array.apply(null, arrayLike);
				arr = new Array(1);
				arr[0] = arrayLike[0];
				return arr;
			}
			if (isArray(arrayLike)) {
				// Source: Array
				arr = new Array((length = arrayLike.length));
				for (i = 0; i < length; ++i) arr[i] = arrayLike[i];
				return arr;
			}
		}
		arr = [];
	} else {
		// Result: Non plain array
		Context = this;
	}

	if (!isArray(arrayLike)) {
		if ((getIterator = arrayLike[iteratorSymbol]) !== undefined) {
			// Source: Iterator
			iterator = callable(getIterator).call(arrayLike);
			if (Context) arr = new Context();
			result = iterator.next();
			i = 0;
			while (!result.done) {
				value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
				if (Context) {
					desc.value = value;
					defineProperty(arr, i, desc);
				} else {
					arr[i] = value;
				}
				result = iterator.next();
				++i;
			}
			length = i;
		} else if (isString(arrayLike)) {
			// Source: String
			length = arrayLike.length;
			if (Context) arr = new Context();
			for (i = 0, j = 0; i < length; ++i) {
				value = arrayLike[i];
				if (i + 1 < length) {
					code = value.charCodeAt(0);
					// eslint-disable-next-line max-depth
					if (code >= 0xd800 && code <= 0xdbff) value += arrayLike[++i];
				}
				value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
				if (Context) {
					desc.value = value;
					defineProperty(arr, j, desc);
				} else {
					arr[j] = value;
				}
				++j;
			}
			length = j;
		}
	}
	if (length === undefined) {
		// Source: array or array-like
		length = toPosInt(arrayLike.length);
		if (Context) arr = new Context(length);
		for (i = 0; i < length; ++i) {
			value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
			if (Context) {
				desc.value = value;
				defineProperty(arr, i, desc);
			} else {
				arr[i] = value;
			}
		}
	}
	if (Context) {
		desc.value = null;
		arr.length = length;
	}
	return arr;
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var objToString = Object.prototype.toString
  , isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);

module.exports = function (value) {
	return typeof value === "function" && isFunctionStringTag(objToString.call(value));
};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(462)
  , max       = Math.max;

module.exports = function (value) { return max(0, toInteger(value)); };


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sign  = __webpack_require__(463)
  , abs   = Math.abs
  , floor = Math.floor;

module.exports = function (value) {
	if (isNaN(value)) return 0;
	value = Number(value);
	if (value === 0 || !isFinite(value)) return value;
	return sign(value) * floor(abs(value));
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(464)() ? Math.sign : __webpack_require__(465);


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var sign = Math.sign;
	if (typeof sign !== "function") return false;
	return sign(10) === 1 && sign(-20) === -1;
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
	value = Number(value);
	if (isNaN(value) || value === 0) return value;
	return value > 0 ? 1 : -1;
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callable = __webpack_require__(70)
  , forEach  = __webpack_require__(467)
  , call     = Function.prototype.call;

module.exports = function (obj, cb /*, thisArg*/) {
	var result = {}, thisArg = arguments[2];
	callable(cb);
	forEach(obj, function (value, key, targetObj, index) {
		result[key] = call.call(cb, thisArg, value, key, targetObj, index);
	});
	return result;
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(468)("forEach");


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Internal method, used by iteration functions.
// Calls a function for each key-value pair found in object
// Optionally takes compareFn to iterate object in specific order



var callable                = __webpack_require__(70)
  , value                   = __webpack_require__(35)
  , bind                    = Function.prototype.bind
  , call                    = Function.prototype.call
  , keys                    = Object.keys
  , objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;

module.exports = function (method, defVal) {
	return function (obj, cb /*, thisArg, compareFn*/) {
		var list, thisArg = arguments[2], compareFn = arguments[3];
		obj = Object(value(obj));
		callable(cb);

		list = keys(obj);
		if (compareFn) {
			list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
		}
		if (typeof method !== "function") method = list[method];
		return call.call(method, list, function (key, index) {
			if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
			return call.call(cb, thisArg, obj[key], key, obj, index);
		});
	};
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Thanks @mathiasbynens
// http://mathiasbynens.be/notes/javascript-unicode#iterating-over-symbols



var setPrototypeOf = __webpack_require__(131)
  , d              = __webpack_require__(36)
  , Symbol         = __webpack_require__(47)
  , Iterator       = __webpack_require__(219);

var defineProperty = Object.defineProperty, StringIterator;

StringIterator = module.exports = function (str) {
	if (!(this instanceof StringIterator)) throw new TypeError("Constructor requires 'new'");
	str = String(str);
	Iterator.call(this, str);
	defineProperty(this, "__length__", d("", str.length));
};
if (setPrototypeOf) setPrototypeOf(StringIterator, Iterator);

// Internal %ArrayIteratorPrototype% doesn't expose its constructor
delete StringIterator.prototype.constructor;

StringIterator.prototype = Object.create(Iterator.prototype, {
	_next: d(function () {
		if (!this.__list__) return undefined;
		if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
		this._unBind();
		return undefined;
	}),
	_resolve: d(function (i) {
		var char = this.__list__[i], code;
		if (this.__nextIndex__ === this.__length__) return char;
		code = char.charCodeAt(0);
		if (code >= 0xd800 && code <= 0xdbff) return char + this.__list__[this.__nextIndex__++];
		return char;
	})
});
defineProperty(StringIterator.prototype, Symbol.toStringTag, d("c", "String Iterator"));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isIterable = __webpack_require__(471);

module.exports = function (value) {
	if (!isIterable(value)) throw new TypeError(value + " is not iterable");
	return value;
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArguments = __webpack_require__(92)
  , isValue     = __webpack_require__(46)
  , isString    = __webpack_require__(93);

var iteratorSymbol = __webpack_require__(47).iterator
  , isArray        = Array.isArray;

module.exports = function (value) {
	if (!isValue(value)) return false;
	if (isArray(value)) return true;
	if (isString(value)) return true;
	if (isArguments(value)) return true;
	return typeof value[iteratorSymbol] === "function";
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArguments = __webpack_require__(92)
  , callable    = __webpack_require__(70)
  , isString    = __webpack_require__(93)
  , get         = __webpack_require__(217);

var isArray = Array.isArray, call = Function.prototype.call, some = Array.prototype.some;

module.exports = function (iterable, cb /*, thisArg*/) {
	var mode, thisArg = arguments[2], result, doBreak, broken, i, length, char, code;
	if (isArray(iterable) || isArguments(iterable)) mode = "array";
	else if (isString(iterable)) mode = "string";
	else iterable = get(iterable);

	callable(cb);
	doBreak = function () {
		broken = true;
	};
	if (mode === "array") {
		some.call(iterable, function (value) {
			call.call(cb, thisArg, value, doBreak);
			return broken;
		});
		return;
	}
	if (mode === "string") {
		length = iterable.length;
		for (i = 0; i < length; ++i) {
			char = iterable[i];
			if (i + 1 < length) {
				code = char.charCodeAt(0);
				if (code >= 0xd800 && code <= 0xdbff) char += iterable[++i];
			}
			call.call(cb, thisArg, char, doBreak);
			if (broken) break;
		}
		return;
	}
	result = iterable.next();

	while (!result.done) {
		call.call(cb, thisArg, result.value, doBreak);
		if (broken) return;
		result = iterable.next();
	}
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Exports true if environment provides native `WeakMap` implementation, whatever that is.



module.exports = (function () {
	if (typeof WeakMap !== "function") return false;
	return Object.prototype.toString.call(new WeakMap()) === "[object WeakMap]";
}());


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = destroyObj;
function destroyObj(name, obj) {
  const throwErr = (action, key) => () => {
    throw new Error(`Cannot ${action} ${key}, ${name} is destroyed`);
  };
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'function') {
      // eslint-disable-next-line no-param-reassign
      obj[key] = throwErr('call', key);
    } else {
      Object.defineProperty(obj, key, {
        get: throwErr('get', key),
        set: throwErr('set', key)
      });
    }
  });
}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const patchSrcObject = el => {
  if ('srcObject' in el) {
    return;
  }
  const URL = window && window.URL;
  if ('srcObject' in window.HTMLMediaElement.prototype) {
    return;
  }
  // Shim the srcObject property, once, when HTMLMediaElement is found.
  Object.defineProperty(el, 'srcObject', {
    get() {
      return this._srcObject;
    },
    set(stream) {
      const self = this;
      // Use _srcObject as a private property for this shim
      this._srcObject = stream;
      if (this.src) {
        URL.revokeObjectURL(this.src);
      }
      if (!stream) {
        this.src = '';
        return undefined;
      }
      this.src = URL.createObjectURL(stream);
      // We need to recreate the blob url when a track is added or
      // removed. Doing it manually since we want to avoid a recursion.
      stream.addEventListener('addtrack', () => {
        if (self.src) {
          URL.revokeObjectURL(self.src);
        }
        self.src = URL.createObjectURL(stream);
      });
      stream.addEventListener('removetrack', () => {
        if (self.src) {
          URL.revokeObjectURL(self.src);
        }
        self.src = URL.createObjectURL(stream);
      });
      return this._srcObject;
    }
  });
};
var _default = patchSrcObject;
exports.default = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const isDomElement = el => {
  if (!el || typeof el.getBoundingClientRect !== 'function') {
    return false;
  }
  return true;
};

// Check if the element is partially in the ViewPort
const isInViewPort = el => {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
  const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
  return vertInView && horInView;
};

// Check whether the element or its DOM parents are hidden
// either by display='none' or visibility='hidden'
const isVisible = domElement => {
  const isVisibilityHidden = el => {
    if (el.style && el.style.visibility === 'hidden') {
      return true;
    }

    // Check if parent has visibility=hidden
    if (el.parentNode) {
      return isVisibilityHidden(el.parentNode);
    }
    return false;
  };
  return domElement.offsetParent !== null && !isVisibilityHidden(domElement);
};

/** Returns whether the HTMLDomElement is visibe or not */
var _default = domElement => isDomElement(domElement) && isInViewPort(domElement) && isVisible(domElement);
exports.default = _default;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isiOS = __webpack_require__(478);
var _isEnv = __webpack_require__(479);
var _iOSVersion = _interopRequireDefault(__webpack_require__(565));
var _getElectronVersion = _interopRequireDefault(__webpack_require__(566));
/*
 * Environment details
 *
 * Contains information about the current environment.
 *
 * @property name The name of the Environment (Chrome, FF, Node, etc)
 * @property version Usually a Float, except in Node which uses a String
 * @property userAgent The raw user agent
 * @property isiOS Whether the client is on iOS
 * @property isElectron Whether the client is Electron
 * @property isOpera Whether the client is Opera
 * @property isFirefox Whether the client is Firefox
 * @property isEdge Whether the client is isEdge (legacy or chromiumedge)
 * @property isChromiumEdge Whether the client is isChromiumEdge (version >= 79)
 * @property isLegacyEdge Whether the client is isLegacyEdge (version < 79)
 * @property isLegacyElectron Whether the client is isLegacyElectron,
 * used for testing purposes (version < 7)
 * @property isLegacyChrome Whether the client is isLegacyChrome,
 * used for testing purposes (version < 87)
 * @property isAndroid Whether the client is an Android device
 * @property protocol The protocol property of the URL
 * @property hostName The domain of the URL
 */

const isElectron = navigator => {
  var _global, _navigator;
  // eslint-disable-next-line no-param-reassign
  navigator = navigator || ((_global = (typeof window !== undefined ? window : global)) == null ? void 0 : _global.navigator);
  return ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.toLowerCase().indexOf('electron')) >= 0;
};
const isNode = () => {
  var _global2, _global2$process, _global2$process$vers;
  return typeof ((_global2 = (typeof window !== undefined ? window : global)) == null ? void 0 : (_global2$process = _global2.process) == null ? void 0 : (_global2$process$vers = _global2$process.versions) == null ? void 0 : _global2$process$vers.node) === 'string' && !isElectron();
};
let env;
const resetEnv = () => {
  env = {
    // @todo why is the default -1?;
    version: -1,
    name: 'unknown'
  };
};
const parseNode = () => {
  env.name = 'Node';
  env.isNode = true;
  env.version = parseInt(process.versions.node, 10);
  env.userAgent = `${env.name} ${env.version}`;
};
const parseBrowser = navigator => {
  // eslint-disable-next-line global-require, no-param-reassign
  navigator = navigator || (typeof window !== undefined ? window : global).navigator;
  env.userAgent = navigator.userAgent.toLowerCase(); // @todo why lowercase?
  env.name = 'unknown';
  if (env.userAgent.indexOf('opera') > -1 || env.userAgent.indexOf('opr/') > -1) {
    env.name = 'Opera';
    env.isOpera = true;
    if (/opr\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) {
      env.version = parseFloat(RegExp.$1);
    }
  } else if (env.userAgent.indexOf('firefox') > -1) {
    env.name = 'Firefox';
    env.isFirefox = true;
    if (/firefox\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) {
      env.version = parseFloat(RegExp.$1);
    }
  } else if (env.userAgent.match(/edge?\/(\d+)(?:\.\d+)+$/)) {
    env.name = 'Edge';
    env.isEdge = true;
    const version = RegExp.$1;
    env.version = parseInt(version, 10);
  } else if (env.userAgent.indexOf('chrome') > -1) {
    env.name = 'Chrome';
    env.isElectron = isElectron(navigator);
    if (!env.isElectron) {
      env.isChrome = true;
    } else {
      env.electronVersion = (0, _getElectronVersion.default)(navigator.userAgent);
    }
    if (/chrome\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) {
      env.version = parseFloat(RegExp.$1);
    }
  } else if (navigator.vendor && navigator.vendor.toLowerCase().indexOf('apple') > -1) {
    env.name = 'Safari';
    env.isSafari = true;
    env.isiPhone = (0, _isiOS.isiPhone)(navigator.userAgent);
    env.isiPad = (0, _isiOS.isiPad)(navigator.userAgent);
    env.isiOS = (0, _isiOS.isiOS)(navigator.userAgent);
    if (env.isiOS) {
      env.iOSVersion = (0, _iOSVersion.default)(navigator.userAgent);
    }
    if (/version\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) {
      env.version = parseFloat(RegExp.$1);
    } else if (/fxios\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) {
      // This gets the version from Firefox in iOS
      env.version = parseFloat(RegExp.$1);
    } else if (/crios\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) {
      // This gets the version from Chrome in iOS
      env.version = parseFloat(RegExp.$1);
    }
  } else if (env.userAgent.indexOf('applewebkit') > -1) {
    // From https://stackoverflow.com/questions/4460205/detect-ipad-iphone-webview-via-javascript
    if (env.userAgent.indexOf('version') === -1) {
      env.isIosWebView = true;
    }
  }

  // The Chromium-based Edge was released on this version
  env.isChromiumEdge = env.name === 'Edge' && env.version >= 79;

  // Prior versions ofo Edge versions were based on a proprietary, non-Chromium
  // code base
  env.isLegacyEdge = env.name === 'Edge' && env.version < 79;
  env.isLegacyElectron = env.isElectron && env.electronVersion < 16;
  env.isLegacyChrome = env.isChrome && env.version < 87;
  env.isLegacyFirefox = env.isFirefox && env.version <= 98;
  env.isChromium = !!(env.isChrome || env.isChromiumEdge || env.isElectron || env.isOpera);
  env.isAndroid = env.userAgent.indexOf('android') > -1;
  env.userAgent = navigator.userAgent;

  // eslint-disable-next-line no-undef
  env.protocol = location.protocol;
  // eslint-disable-next-line no-undef
  env.hostName = location.hostName;
  const regex = new RegExp(/(iPad|iPhone|iPod|android|webOS)/i);
  env.isMobileDevice = regex.test(env.userAgent);
  env.isProd = (0, _isEnv.isProd)();
  env.isRel = (0, _isEnv.isRel)();
  env.isDev = (0, _isEnv.isDev)();
  if (env.version === -1 || env.name === 'unknown' || env.isiOS && !env.iOSVersion) {
    env.error = true;
  }
};
const parse = navigator => {
  // We clear env since we have tests which pass in mocked user agent strings.
  resetEnv();
  if (isNode()) {
    parseNode();
  } else {
    parseBrowser(navigator);
  }
  return env;
};
var _default = {
  parse,
  isNode
};
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(24)))

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isiPhone = exports.isiPad = exports.isiOS = void 0;
const isiPhone = userAgent => /iPhone/.test(userAgent);

// This line is for detecting iPad on iOS 13+. See https://developer.apple.com/forums/thread/119186
exports.isiPhone = isiPhone;
const isiPadOniOS13Plus = userAgent => {
  try {
    return userAgent.includes('Mac') && 'ontouchend' in document;
  } catch (err) {
    // Silly rabbit, you're probably running in node, huh?
    return false;
  }
};
const isiPad = userAgent => /iPad/.test(userAgent) || isiPadOniOS13Plus(userAgent);
exports.isiPad = isiPad;
const isiOS = userAgent => isiPhone(userAgent) || isiPad(userAgent);
exports.isiOS = isiOS;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.isRel = exports.isProd = exports.isDev = void 0;
var _StaticConfig = _interopRequireDefault(__webpack_require__(48));
const StaticConfig = (0, _StaticConfig.default)();
const isEnvironment = (environmentUrl, deps) => {
  const config = deps.StaticConfig || StaticConfig.onlyLocal();
  const apiUrl = config.apiUrl;
  return apiUrl.includes(environmentUrl);
};
const isProd = function isProd(deps) {
  if (deps === void 0) {
    deps = {};
  }
  return isEnvironment('anvil.opentok.com', deps);
};
exports.isProd = isProd;
const isDev = function isDev(deps) {
  if (deps === void 0) {
    deps = {};
  }
  return isEnvironment('api.dev.opentok.com', deps);
};
exports.isDev = isDev;
const isRel = function isRel(deps) {
  if (deps === void 0) {
    deps = {};
  }
  return isEnvironment('api.rel.opentok.com', deps);
};
exports.isRel = isRel;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var utils = __webpack_require__(13);
var bind = __webpack_require__(222);
var Axios = __webpack_require__(481);
var mergeConfig = __webpack_require__(232);
var defaults = __webpack_require__(134);
var formDataToJSON = __webpack_require__(228);
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(97);
axios.CancelToken = __webpack_require__(502);
axios.isCancel = __webpack_require__(231);
axios.VERSION = __webpack_require__(233).version;
axios.toFormData = __webpack_require__(96);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(49);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(503);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(504);

axios.formToJSON = function(thing) {
  return formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
};

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var utils = __webpack_require__(13);
var buildURL = __webpack_require__(223);
var InterceptorManager = __webpack_require__(487);
var dispatchRequest = __webpack_require__(488);
var mergeConfig = __webpack_require__(232);
var buildFullPath = __webpack_require__(230);
var validator = __webpack_require__(501);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
 * @param {?Object} config
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  var paramsSerializer = config.paramsSerializer;

  if (paramsSerializer != null) {
    if (utils.isFunction(paramsSerializer)) {
      config.paramsSerializer = {
        serialize: paramsSerializer
      };
    } else {
      validator.assertOptions(paramsSerializer, {
        encode: validators.function,
        serialize: validators.function
      }, true);
    }
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 483 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 484 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// eslint-disable-next-line strict
module.exports = __webpack_require__(486);


/***/ }),
/* 486 */
/***/ (function(module, exports) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Clear all interceptors from the stack
 */
InterceptorManager.prototype.clear = function clear() {
  if (this.handlers) {
    this.handlers = [];
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var utils = __webpack_require__(13);
var transformData = __webpack_require__(489);
var isCancel = __webpack_require__(231);
var defaults = __webpack_require__(134);
var CanceledError = __webpack_require__(97);
var normalizeHeaderName = __webpack_require__(226);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    null,
    config.transformRequest
  );

  normalizeHeaderName(config.headers, 'Accept');
  normalizeHeaderName(config.headers, 'Content-Type');

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      response.status,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          reason.response.status,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var defaults = __webpack_require__(134);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Number} status HTTP status code
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, status, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers, status);
  });

  return data;
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var toFormData = __webpack_require__(96);
var platform = __webpack_require__(135);

module.exports = function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isBrowser: true,
  classes: {
    URLSearchParams: __webpack_require__(492),
    FormData: __webpack_require__(493),
    Blob: Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosURLSearchParams = __webpack_require__(224);

module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = FormData;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(49);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.slice(0, i)).toLowerCase();
    val = utils.trim(line.slice(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */
      function resolveURL(url) {
        var href = url;

        if (msie) {
          // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

    // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = __webpack_require__(233).version;
var AxiosError = __webpack_require__(49);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var CanceledError = __webpack_require__(97);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i = token._listeners.length;

    while (i-- > 0) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message, config, request) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message, config, request);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(234),
    func = convert('mapKeys', __webpack_require__(554));

func.placeholder = __webpack_require__(136);
module.exports = func;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(507),
    fallbackHolder = __webpack_require__(136);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 507 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(509),
  'assign': __webpack_require__(192),
  'clone': __webpack_require__(41),
  'curry': __webpack_require__(530),
  'forEach': __webpack_require__(118),
  'isArray': __webpack_require__(14),
  'isError': __webpack_require__(531),
  'isFunction': __webpack_require__(20),
  'isWeakMap': __webpack_require__(532),
  'iteratee': __webpack_require__(533),
  'keys': __webpack_require__(121),
  'rearg': __webpack_require__(550),
  'toInteger': __webpack_require__(100),
  'toPath': __webpack_require__(553)
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(137);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(98),
    root = __webpack_require__(16);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(126),
    createCtor = __webpack_require__(98),
    createHybrid = __webpack_require__(237),
    createRecurry = __webpack_require__(240),
    getHolder = __webpack_require__(247),
    replaceHolders = __webpack_require__(140),
    root = __webpack_require__(16);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(138),
    getData = __webpack_require__(241),
    getFuncName = __webpack_require__(514),
    lodash = __webpack_require__(516);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(515);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(138),
    LodashWrapper = __webpack_require__(243),
    baseLodash = __webpack_require__(139),
    isArray = __webpack_require__(14),
    isObjectLike = __webpack_require__(21),
    wrapperClone = __webpack_require__(517);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(138),
    LodashWrapper = __webpack_require__(243),
    copyArray = __webpack_require__(56);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 519 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(118),
    arrayIncludes = __webpack_require__(99);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(246),
    baseIsNaN = __webpack_require__(522),
    strictIndexOf = __webpack_require__(523);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 522 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(56),
    isIndex = __webpack_require__(67);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(126),
    createCtor = __webpack_require__(98),
    root = __webpack_require__(16);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(238),
    composeArgsRight = __webpack_require__(239),
    replaceHolders = __webpack_require__(140);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(248);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(529);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(137);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isObjectLike = __webpack_require__(21),
    isPlainObject = __webpack_require__(141);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(45),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(80),
    baseIteratee = __webpack_require__(37);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(535),
    getMatchData = __webpack_require__(541),
    matchesStrictComparable = __webpack_require__(253);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(81),
    baseIsEqual = __webpack_require__(142);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(81),
    equalArrays = __webpack_require__(249),
    equalByTag = __webpack_require__(539),
    equalObjects = __webpack_require__(540),
    getTag = __webpack_require__(45),
    isArray = __webpack_require__(14),
    isBuffer = __webpack_require__(66),
    isTypedArray = __webpack_require__(88);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(43),
    Uint8Array = __webpack_require__(203),
    eq = __webpack_require__(54),
    equalArrays = __webpack_require__(249),
    mapToArray = __webpack_require__(251),
    setToArray = __webpack_require__(103);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(198);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(252),
    keys = __webpack_require__(34);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(142),
    get = __webpack_require__(59),
    hasIn = __webpack_require__(255),
    isKey = __webpack_require__(143),
    isStrictComparable = __webpack_require__(252),
    matchesStrictComparable = __webpack_require__(253),
    toKey = __webpack_require__(50);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(129);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(43),
    arrayMap = __webpack_require__(38),
    isArray = __webpack_require__(14),
    isSymbol = __webpack_require__(71);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(60),
    isArguments = __webpack_require__(65),
    isArray = __webpack_require__(14),
    isIndex = __webpack_require__(67),
    isLength = __webpack_require__(119),
    toKey = __webpack_require__(50);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(548),
    basePropertyDeep = __webpack_require__(549),
    isKey = __webpack_require__(143),
    toKey = __webpack_require__(50);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 548 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(104);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(137),
    flatRest = __webpack_require__(144);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(256);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(43),
    isArguments = __webpack_require__(65),
    isArray = __webpack_require__(14);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    copyArray = __webpack_require__(56),
    isArray = __webpack_require__(14),
    isSymbol = __webpack_require__(71),
    stringToPath = __webpack_require__(254),
    toKey = __webpack_require__(50),
    toString = __webpack_require__(61);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(64),
    baseForOwn = __webpack_require__(105),
    baseIteratee = __webpack_require__(37);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(234),
    func = convert('pick', __webpack_require__(39));

func.placeholder = __webpack_require__(136);
module.exports = func;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(558),
    hasIn = __webpack_require__(255);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(104),
    baseSet = __webpack_require__(559),
    castPath = __webpack_require__(60);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(86),
    castPath = __webpack_require__(60),
    isIndex = __webpack_require__(67),
    isObject = __webpack_require__(11),
    toKey = __webpack_require__(50);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports =  true && exports &&
		!exports.nodeType && exports;
	var freeModule =  true && module &&
		!module.nodeType && module;
	var freeGlobal = typeof (typeof window !== undefined ? window : global) == 'object' && (typeof window !== undefined ? window : global);
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(87)(module)))

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(563);
exports.encode = exports.stringify = __webpack_require__(564);


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = iOSVersion;
function iOSVersion(userAgent) {
  // Make sure parser can handle versions like 15_4 and 15_4_1
  const match = userAgent.match(/OS (\d+_\d+).* like Mac/);
  if (match === null || !match[1]) {
    return undefined;
  }
  return parseFloat(match[1].replace('_', '.'));
}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const electronUserAgentRegex = /(Electron)\/([0-9]{1,}[.0-9]{0,})/;
const electronVersion = userAgent => {
  const matches = userAgent.match(electronUserAgentRegex);
  return matches && parseFloat(matches[2]);
};
var _default = electronVersion;
exports.default = _default;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  return () => windowMock.navigator && windowMock.navigator.mediaDevices;
};
exports.default = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = canBeOrientatedMixin;
var _defineProperties = _interopRequireDefault(__webpack_require__(108));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

const VideoOrientationTransforms = {
  0: 'rotate(0deg)',
  270: 'rotate(90deg)',
  90: 'rotate(-90deg)',
  180: 'rotate(180deg)'
};

// A mixin to create the orientation API implementation on +self+
// +getDomElementCallback+ is a function that the mixin will call when it wants to
// get the native Dom element for +self+.
//
// +initialOrientation+ sets the initial orientation (shockingly), it's currently unused
// so the initial value is actually undefined.
//
function canBeOrientatedMixin(self, getDomElementCallback, initialOrientation) {
  let _orientation = initialOrientation;
  (0, _defineProperties.default)(self, {
    isRotated: {
      get() {
        return this.orientation() && (this.orientation().videoOrientation === 270 || this.orientation().videoOrientation === 90);
      }
    },
    // @todo I don't think we need vendor prefixes at all anymore.
    orientation: {
      get() {
        return _orientation;
      },
      set(orientation) {
        _orientation = orientation;
        const transform = VideoOrientationTransforms[orientation.videoOrientation] || VideoOrientationTransforms.ROTATED_NORMAL;
        switch (_OTHelpers.default.env.name) {
          case 'Chrome':
          case 'Safari':
            getDomElementCallback().style.webkitTransform = transform;
            break;
          default:
            // The standard version, just Firefox, Opera, and Edge
            getDomElementCallback().style.transform = transform;
        }
        self.trigger('orientationChanged', _orientation);
      }
    },
    // see https://wiki.mozilla.org/WebAPI/AudioChannels
    // The audioChannelType is currently only available in Firefox. This property returns
    // "unknown" in other browser. The related HTML tag attribute is "mozaudiochannel"
    audioChannelType: {
      get() {
        if ('mozAudioChannelType' in this.domElement) {
          return this.domElement.mozAudioChannelType;
        }
        return 'unknown';
      },
      set(type) {
        if ('mozAudioChannelType' in this.domElement) {
          this.domElement.mozAudioChannelType = type;
        }
      }
    }
  });
}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isObject = _interopRequireDefault(__webpack_require__(11));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, no-void */

const specialDomProperties = {
  for: 'htmlFor',
  class: 'className'
};
const attributes = ElementCollection => {
  // Gets or sets the attribute called +name+ for the first element in the collection
  ElementCollection.prototype.attr = function (name, value) {
    if ((0, _isObject.default)(name)) {
      let actualName;
      Object.keys(name).forEach(key => {
        actualName = specialDomProperties[key] || key;
        this.first.setAttribute(actualName, name[key]);
      });
    } else if (value === void 0) {
      return this.first.getAttribute(specialDomProperties[name] || name);
    } else {
      this.first.setAttribute(specialDomProperties[name] || name, value);
    }
    return this;
  };

  // Removes an attribute called +name+ for the every element in the collection.
  ElementCollection.prototype.removeAttr = function (name) {
    const actualName = specialDomProperties[name] || name;
    this.forEach(element => {
      element.removeAttribute(actualName);
    });
    return this;
  };

  // Gets, and optionally sets, the html body of the first element
  // in the collection. If the +html+ is provided then the first
  // element's html body will be replaced with it.
  //
  ElementCollection.prototype.html = function (html) {
    if (html !== void 0) {
      this.first.innerHTML = html;
    }
    return this.first.innerHTML;
  };

  // Centers +element+ within the global. You can pass through the width and height
  // if you know it, if you don't they will be calculated for you.
  ElementCollection.prototype.center = function (width, height) {
    let $element;
    this.forEach(element => {
      $element = new ElementCollection(element);
      width = width || parseInt($element.width(), 10);
      height = height || parseInt($element.height(), 10);
      const marginLeft = `${-0.5 * width}px`;
      const marginTop = `${-0.5 * height}px`;
      $element.css('margin', `${marginTop} 0 0 ${marginLeft}`).addClass('OT_centered');
    });
    return this;
  };

  // @remove
  // Centers +element+ within the global. You can pass through the width and height
  // if you know it, if you don't they will be calculated for you.
  ElementCollection._attachToOTHelpers.centerElement = function (element, width, height) {
    return new ElementCollection(element).center(width, height);
  };

  /**
   * Methods to calculate element widths and heights.
   */
  const _width = function _width(element) {
    if (element.offsetWidth > 0) {
      return `${element.offsetWidth}px`;
    }
    return new ElementCollection(element).css('width');
  };
  const _height = function _height(element) {
    if (element.offsetHeight > 0) {
      return `${element.offsetHeight}px`;
    }
    return new ElementCollection(element).css('height');
  };
  ElementCollection.prototype.width = function (newWidth) {
    if (newWidth) {
      this.css('width', newWidth);
      return this;
    }
    if (this.isDisplayNone()) {
      return this.makeVisibleAndYield(element => _width(element))[0];
    }
    return _width(this.get(0));
  };

  // @remove
  ElementCollection._attachToOTHelpers.width = function (element, newWidth) {
    const ret = new ElementCollection(element).width(newWidth);
    return newWidth ? ElementCollection._attachToOTHelpers : ret;
  };
  ElementCollection.prototype.height = function (newHeight) {
    if (newHeight) {
      this.css('height', newHeight);
      return this;
    }
    if (this.isDisplayNone()) {
      // We can't get the height, probably since the element is hidden.
      return this.makeVisibleAndYield(element => _height(element))[0];
    }
    return _height(this.get(0));
  };

  // @remove
  ElementCollection._attachToOTHelpers.height = function (element, newHeight) {
    const ret = new ElementCollection(element).height(newHeight);
    return newHeight ? ElementCollection._attachToOTHelpers : ret;
  };
};
var _default = attributes;
exports.default = _default;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable import/newline-after-import, prefer-const, no-restricted-syntax */
/* eslint-disable no-prototype-builtins, no-param-reassign, one-var, no-void */

const getCompStyle = (typeof window !== undefined ? window : global).getComputedStyle;
const VENDOR_PREFIXES = {
  Firefox: 'moz',
  Opera: 'O',
  Chrome: 'Webkit',
  Safari: 'Webkit'
};
function vendorPrefix() {
  return VENDOR_PREFIXES[_env.default.name];
}
const css = (ElementCollection, findElementWithDisplayNone) => {
  const displayStateCache = {};
  const defaultDisplays = {};
  const defaultDisplayValueForElement = function defaultDisplayValueForElement(element) {
    if (defaultDisplays[element.ownerDocument] && defaultDisplays[element.ownerDocument][element.nodeName]) {
      return defaultDisplays[element.ownerDocument][element.nodeName];
    }
    if (!defaultDisplays[element.ownerDocument]) {
      defaultDisplays[element.ownerDocument] = {};
    }

    // We need to know what display value to use for this node. The easiest way
    // is to actually create a node and read it out.
    let testNode = element.ownerDocument.createElement(element.nodeName);
    let defaultDisplay;
    element.ownerDocument.body.appendChild(testNode);
    defaultDisplay = new ElementCollection(testNode).css('display');
    defaultDisplays[element.ownerDocument][element.nodeName] = defaultDisplay;
    new ElementCollection(testNode).remove();
    testNode = null;
    return defaultDisplay;
  };
  const isHidden = function isHidden(element) {
    const computedStyle = getCompStyle(element);
    return computedStyle.getPropertyValue('display') === 'none';
  };
  const getNormalisedPropName = function getNormalisedPropName(element, name) {
    if (name in element.style) {
      return name;
    }

    // Try vendored names next
    const prefix = vendorPrefix();
    const capitalName = prefix + name[0].toUpperCase() + name.slice(1);
    if (capitalName in element.style) {
      return capitalName;
    }
    return name;
  };
  const setCssProperties = function setCssProperties(element, hash) {
    const style = element.style;
    for (const cssName in hash) {
      if (hash.hasOwnProperty(cssName)) {
        style[getNormalisedPropName(element, cssName)] = hash[cssName];
      }
    }
  };
  const setCssProperty = function setCssProperty(element, name, value) {
    element.style[getNormalisedPropName(element, name)] = value;
  };
  const getCssProperty = function getCssProperty(element, unnormalisedName) {
    const name = getNormalisedPropName(element, unnormalisedName);
    const computedStyle = getCompStyle(element);
    let currentValue = computedStyle.getPropertyValue(name);
    if (currentValue === '') {
      currentValue = element.style[name];
    }
    return currentValue;
  };
  const applyCSS = function applyCSS(element, styles, callback) {
    const $element = new ElementCollection(element);
    const oldStyles = {};
    let name, ret;

    // Backup the old styles
    for (name in styles) {
      if (styles.hasOwnProperty(name)) {
        // We intentionally read out of style here, instead of using the css
        // helper. This is because the css helper uses querySelector and we
        // only want to pull values out of the style (domeElement.style) hash.
        oldStyles[name] = element.style[name];
        $element.css(name, styles[name]);
      }
    }
    ret = callback(element);

    // Restore the old styles
    for (name in styles) {
      if (styles.hasOwnProperty(name)) {
        $element.css(name, oldStyles[name] || '');
      }
    }
    return ret;
  };
  ElementCollection.prototype.show = function () {
    return this.forEach(element => {
      const display = element.style.display;
      if (display === '' || display === 'none') {
        element.style.display = displayStateCache[element] || '';
        delete displayStateCache[element];
      }
      if (isHidden(element)) {
        // It's still hidden so there's probably a stylesheet that declares this
        // element as display:none;
        displayStateCache[element] = 'none';
        element.style.display = defaultDisplayValueForElement(element);
      }
    });
  };
  ElementCollection.prototype.hide = function () {
    return this.forEach(element => {
      if (element.style.display === 'none') {
        return;
      }
      displayStateCache[element] = element.style.display;
      element.style.display = 'none';
    });
  };
  ElementCollection.prototype.css = function (nameOrHash, value) {
    if (this.length === 0) {
      // FIXME: I made this `return undefined` to preserve behaviour, but `return this` is probably
      // more consistent.
      return undefined;
    }
    if (typeof nameOrHash !== 'string') {
      return this.forEach(element => {
        setCssProperties(element, nameOrHash);
      });
    }
    if (value !== undefined) {
      return this.forEach(element => {
        setCssProperty(element, nameOrHash, value);
      });
    }
    return getCssProperty(this.first, nameOrHash, value);
  };

  // Make +element+ visible while executing +callback+.
  ElementCollection.prototype.makeVisibleAndYield = function (callback) {
    const hiddenVisually = {
      display: 'block',
      visibility: 'hidden'
    };
    const results = [];
    this.forEach(element => {
      // find whether it's the element or an ancestor that's display none and
      // then apply to whichever it is
      const targetElement = findElementWithDisplayNone(element);
      if (!targetElement) {
        results.push(void 0);
      } else {
        results.push(applyCSS(targetElement, hiddenVisually, callback));
      }
    });
    return results;
  };
};
var _default = css;
exports.default = _default;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _hasClassListCapability = _interopRequireDefault(__webpack_require__(572));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, no-bitwise */

function hasClass(element, className) {
  if (!className) {
    return false;
  }
  if ((0, _hasClassListCapability.default)()) {
    return element.classList.contains(className);
  }
  return element.className.indexOf(className) > -1;
}
function toggleClasses(element, classNames) {
  if (!classNames || classNames.length === 0) {
    return;
  }

  // Only bother targeting Element nodes, ignore Text Nodes, CDATA, etc
  if (element.nodeType !== 1) {
    return;
  }
  const numClasses = classNames.length;
  let i = 0;
  if ((0, _hasClassListCapability.default)()) {
    for (; i < numClasses; ++i) {
      element.classList.toggle(classNames[i]);
    }
    return;
  }
  let className = ` ${element.className} `.replace(/[\s+]/, ' ');
  for (; i < numClasses; ++i) {
    if (hasClass(element, classNames[i])) {
      className = className.replace(` ${classNames[i]} `, ' ');
    } else {
      className += `${classNames[i]} `;
    }
  }
  element.className = className.trim();
}
function addClass(element, classNames) {
  if (!classNames || classNames.length === 0) {
    return;
  }

  // Only bother targeting Element nodes, ignore Text Nodes, CDATA, etc
  if (element.nodeType !== 1) {
    return;
  }
  const numClasses = classNames.length;
  let i = 0;
  if ((0, _hasClassListCapability.default)()) {
    for (; i < numClasses; ++i) {
      element.classList.add(classNames[i]);
    }
    return;
  }

  // Here's our fallback to browsers that don't support element.classList

  if (!element.className && classNames.length === 1) {
    element.className = classNames.join(' ');
  } else {
    let setClass = ` ${element.className} `;
    for (; i < numClasses; ++i) {
      if (!~setClass.indexOf(` ${classNames[i]} `)) {
        setClass += `${classNames[i]} `;
      }
    }
    element.className = setClass.trim();
  }
}
function removeClass(element, classNames) {
  if (!classNames || classNames.length === 0) {
    return;
  }

  // Only bother targeting Element nodes, ignore Text Nodes, CDATA, etc
  if (element.nodeType !== 1) {
    return;
  }
  const numClasses = classNames.length;
  let i = 0;
  if ((0, _hasClassListCapability.default)()) {
    for (; i < numClasses; ++i) {
      element.classList.remove(classNames[i]);
    }
    return;
  }
  let className = ` ${element.className} `.replace(/[\s+]/, ' ');
  for (; i < numClasses; ++i) {
    className = className.replace(` ${classNames[i]} `, ' ');
  }
  element.className = className.trim();
}
const classNamesFactory = ElementCollection => {
  ElementCollection.prototype.addClass = function (value) {
    if (value) {
      const classNames = value.trim().split(/\s+/);
      this.forEach(element => {
        addClass(element, classNames);
      });
    }
    return this;
  };
  ElementCollection.prototype.removeClass = function (value) {
    if (value) {
      const classNames = value.trim().split(/\s+/);
      this.forEach(element => {
        removeClass(element, classNames);
      });
    }
    return this;
  };
  ElementCollection.prototype.toggleClass = function (value) {
    if (value) {
      const classNames = value.trim().split(/\s+/);
      this.forEach(element => {
        toggleClasses(element, classNames);
      });
    }
    return this;
  };
  ElementCollection.prototype.hasClass = function (value) {
    return this.some(element => hasClass(element, value));
  };
};
var _default = classNamesFactory;
exports.default = _default;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = () => typeof document !== 'undefined' && 'classList' in document.createElement('a');
exports.default = _default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isEmpty = _interopRequireDefault(__webpack_require__(574));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable  prefer-rest-params, no-param-reassign */

const observersFactory = ElementCollection => {
  let sizeObserverCount = 0;
  let nodeRemovalObserverCount = 0;
  const observeStyleChanges = function observeStyleChanges(element, stylesToObserve, onChange) {
    const oldStyles = {};
    const getStyle = function getStyle(style) {
      switch (style) {
        case 'width':
          return new ElementCollection(element).width();
        case 'height':
          return new ElementCollection(element).height();
        default:
          return new ElementCollection(element).css(style);
      }
    };

    // get the inital values
    stylesToObserve.forEach(style => {
      oldStyles[style] = getStyle(style);
    });
    const observer = new (typeof window !== undefined ? window : global).MutationObserver(mutations => {
      const changeSet = {};
      mutations.forEach(mutation => {
        if (mutation.attributeName !== 'style') {
          return;
        }
        const isHidden = new ElementCollection(element).isDisplayNone();
        stylesToObserve.forEach(style => {
          if (isHidden && (style === 'width' || style === 'height')) {
            return;
          }
          const newValue = getStyle(style);
          if (newValue !== oldStyles[style]) {
            changeSet[style] = [oldStyles[style], newValue];
            oldStyles[style] = newValue;
          }
        });
      });
      if (!(0, _isEmpty.default)(changeSet)) {
        // Do this after so as to help avoid infinite loops of mutations.
        setTimeout(() => {
          onChange.call(null, changeSet);
        });
      }
    });
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['style'],
      childList: false,
      characterData: false,
      subtree: false
    });
    return observer;
  };
  const observeNodeOrChildNodeRemoval = function observeNodeOrChildNodeRemoval(element, onChange) {
    const observer = new (typeof window !== undefined ? window : global).MutationObserver(mutations => {
      let removedNodes = [];
      mutations.forEach(mutation => {
        if (mutation.removedNodes.length) {
          removedNodes = removedNodes.concat(Array.prototype.slice.call(mutation.removedNodes));
        }
      });
      if (removedNodes.length) {
        // Do this after so as to help avoid infinite loops of mutations.
        setTimeout(() => {
          onChange(new ElementCollection(removedNodes));
        });
      }
    });
    observer.observe(element, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true
    });
    nodeRemovalObserverCount++;

    // Intercept the native disconnect method so we can keep a valid count
    // of the currently active node removal observers
    const nativeDisconnect = observer.disconnect;
    observer.disconnect = function () {
      nativeDisconnect.apply(observer, arguments);
      nodeRemovalObserverCount--;
    };
    return observer;
  };
  const observeSize = function observeSize(element, onChange) {
    let previousSize = {
      width: 0,
      height: 0
    };
    const interval = setInterval(() => {
      const rect = element.getBoundingClientRect();
      if (previousSize.width !== rect.width || previousSize.height !== rect.height) {
        onChange(rect, previousSize);
        previousSize = {
          width: rect.width,
          height: rect.height
        };
      }
    }, 1000 / 5);
    sizeObserverCount++;
    return {
      disconnect() {
        clearInterval(interval);
        sizeObserverCount--;
      }
    };
  };

  // Allows an +onChange+ callback to be triggered when specific style properties
  // of +element+ are notified. The callback accepts a single parameter, which is
  // a hash where the keys are the style property that changed and the values are
  // an array containing the old and new values ([oldValue, newValue]).
  //
  // Width and Height changes while the element is display: none will not be
  // fired until such time as the element becomes visible again.
  //
  // This function returns the MutationObserver itself. Once you no longer wish
  // to observe the element you should call disconnect on the observer.
  //
  // Observing changes:
  //  // observe changings to the width and height of object
  //  dimensionsObserver = OTHelpers(object).observeStyleChanges(,
  //                                                    ['width', 'height'], function(changeSet) {
  //      OT.debug("The new width and height are " +
  //                      changeSet.width[1] + ',' + changeSet.height[1]);
  //  });
  //
  // Cleaning up
  //  // stop observing changes
  //  dimensionsObserver.disconnect();
  //  dimensionsObserver = null;
  //
  ElementCollection.prototype.observeStyleChanges = function (stylesToObserve, onChange) {
    const observers = [];
    this.forEach(element => {
      observers.push(observeStyleChanges(element, stylesToObserve, onChange));
    });
    return observers;
  };

  // trigger the +onChange+ callback whenever
  // 1. +element+ is removed
  // 2. or an immediate child of +element+ is removed.
  //
  // This function returns the MutationObserver itself. Once you no longer wish
  // to observe the element you should call disconnect on the observer.
  //
  // Observing changes:
  //  // observe changings to the width and height of object
  //  nodeObserver = OTHelpers(object).observeNodeOrChildNodeRemoval(function(removedNodes) {
  //      OT.debug("Some child nodes were removed");
  //      removedNodes.forEach(function(node) {
  //          OT.debug(node);
  //      });
  //  });
  //
  // Cleaning up
  //  // stop observing changes
  //  nodeObserver.disconnect();
  //  nodeObserver = null;
  //
  ElementCollection.prototype.observeNodeOrChildNodeRemoval = function (onChange) {
    const observers = [];
    this.forEach(element => {
      observers.push(observeNodeOrChildNodeRemoval(element, onChange));
    });
    return observers;
  };

  // trigger the +onChange+ callback whenever the width or the height of the element changes
  //
  // Once you no longer wish to observe the element you should call disconnect on the observer.
  //
  // Observing changes:
  //  // observe changings to the width and height of object
  //  sizeObserver = OTHelpers(object).observeSize(function(newSize, previousSize) {
  //      OT.debug("The new width and height are " +
  //                      newSize.width + ',' + newSize.height);
  //  });
  //
  // Cleaning up
  //  // stop observing changes
  //  sizeObserver.disconnect();
  //  sizeObserver = null;
  //
  ElementCollection.prototype.observeSize = function (onChange) {
    const observers = [];
    this.forEach(element => {
      observers.push(observeSize(element, onChange));
    });
    return observers;
  };

  // @remove
  ElementCollection._attachToOTHelpers.observeStyleChanges = function (element, stylesToObserve, onChange) {
    return new ElementCollection(element).observeStyleChanges(stylesToObserve, onChange)[0];
  };

  // @remove
  ElementCollection._attachToOTHelpers.observeNodeOrChildNodeRemoval = function (element, onChange) {
    return new ElementCollection(element).observeNodeOrChildNodeRemoval(onChange)[0];
  };

  // We expose observer counts for testing purposes.
  if (!ElementCollection.__testOnly) {
    ElementCollection.__testOnly = {};
  }
  ElementCollection.__testOnly.sizeObserverCount = function () {
    return sizeObserverCount;
  };
  ElementCollection.__testOnly.nodeRemovalObserverCount = function () {
    return nodeRemovalObserverCount;
  };
};
var _default = observersFactory;
exports.default = _default;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(121),
    getTag = __webpack_require__(45),
    isArguments = __webpack_require__(65),
    isArray = __webpack_require__(14),
    isArrayLike = __webpack_require__(29),
    isBuffer = __webpack_require__(66),
    isPrototype = __webpack_require__(69),
    isTypedArray = __webpack_require__(88);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = statable;
var _isFunction = _interopRequireDefault(__webpack_require__(20));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, prefer-rest-params */

function statable(self, possibleStates, initialState, stateChanged, stateChangedFailed) {
  let previousState;
  let currentState = initialState;
  self.currentState = initialState;
  const setState = function setState(state) {
    if (currentState !== state) {
      if (possibleStates.indexOf(state) === -1) {
        if (stateChangedFailed && (0, _isFunction.default)(stateChangedFailed)) {
          stateChangedFailed('invalidState', state);
        }
        return;
      }
      self.previousState = currentState;
      previousState = currentState;
      self.currentState = state;
      currentState = state;
      if (stateChanged && (0, _isFunction.default)(stateChanged)) {
        stateChanged(state, previousState);
      }
    }
  };

  // Returns a number of states and returns true if the current state
  // is any of them.
  //
  // @example
  // if (this.is('connecting', 'connected')) {
  //   // do some stuff
  // }
  //
  self.is = function /* state0:String, state1:String, ..., stateN:String */
  () {
    return Array.prototype.indexOf.call(arguments, currentState) !== -1;
  };

  // Returns a number of states and returns true if the current state
  // is none of them.
  //
  // @example
  // if (this.isNot('connecting', 'connected')) {
  //   // do some stuff
  // }
  //
  self.isNot = function /* state0:String, state1:String, ..., stateN:String */
  () {
    return Array.prototype.indexOf.call(arguments, currentState) === -1;
  };
  return setState;
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(268);
var bytesToUuid = __webpack_require__(269);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(268);
var bytesToUuid = __webpack_require__(269);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
let QueueRunner = /*#__PURE__*/function () {
  function QueueRunner(_temp) {
    let _ref = _temp === void 0 ? {} : _temp,
      _ref$waitTime = _ref.waitTime,
      waitTime = _ref$waitTime === void 0 ? 50 : _ref$waitTime;
    this.queue = [];
    this.running = false;
    this.waitTime = waitTime;
  }
  var _proto = QueueRunner.prototype;
  _proto.add = function add(fn) {
    this.queue.push(fn);
    this.run();
  };
  _proto.run = function run() {
    if (this.running) {
      return;
    }
    this.running = true;
    const loop = () => {
      if (this.queue.length === 0) {
        this.running = false;
        return;
      }
      const fn = this.queue.shift();
      fn(() => {
        setTimeout(loop, this.waitTime);
      });
    };
    loop();
  };
  return QueueRunner;
}();
var _default = QueueRunner;
exports.default = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(101),
    arrayIncludes = __webpack_require__(99),
    arrayIncludesWith = __webpack_require__(150),
    arrayMap = __webpack_require__(38),
    baseUnary = __webpack_require__(68),
    cacheHas = __webpack_require__(102);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(151);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Errors titles by code
var _default = {
  1004: 'Authentication error',
  1005: 'Invalid Session ID',
  1006: 'Connect Failed',
  1007: 'Connect Rejected',
  1008: 'Connect Time-out',
  1009: 'Security Error',
  1010: 'Not Connected',
  1011: 'Invalid Parameter',
  1012: 'Peer-to-peer Stream Play Failed',
  1013: 'Connection Failed',
  1014: 'API Response Failure',
  1015: 'PeerConnection not connected, cannot call this method',
  1021: 'Request Timeout',
  1026: 'Terms of Service Violation: Export Compliance',
  1027: 'Connection Limit Exceeded',
  1040: 'Set Video Source Failure',
  1041: 'Invalid Video Source',
  1500: 'Unable to Publish',
  1501: 'Unable to Subscribe',
  1502: 'Unsupported Video Codec',
  1503: 'No TURN server found',
  1520: 'Unable to Force Disconnect',
  1530: 'Unable to Force Unpublish',
  1540: 'Unable to Force Mute',
  1553: 'Publisher ICEWorkflow failed',
  1554: 'Subscriber ICEWorkflow failed',
  1600: 'createOffer, createAnswer, setLocalDescription, setRemoteDescription',
  1605: 'Stream Limit Exceeded',
  2000: 'Internal Error',
  2001: 'Unexpected Server Response',
  2021: 'Proxy URL Timing Error',
  2022: 'Proxy URL Already Set Error',
  2031: 'getRtcStatsReport is not supported in this browser',
  4000: 'WebSocket Connection Failed',
  4001: 'WebSocket Network Disconnected',
  5001: 'Unable to access media engine'
};
exports.default = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _trimProxyUrl = _interopRequireDefault(__webpack_require__(583));
// if proxy is defined with https://brown.fox and messaging URL with 'wss://lazy.dog'
// it updates messagingUrl to 'wss://brown.fox/lazy.dog'
var _default = (proxyUrl, messagingUrl) => {
  if (typeof proxyUrl === 'string' && typeof messagingUrl === 'string') {
    const trimmedProxyUrl = (0, _trimProxyUrl.default)(proxyUrl);
    const _messagingUrl$match = messagingUrl.match(/(\w+:\/\/)(.*)/),
      scheme = _messagingUrl$match[1],
      host = _messagingUrl$match[2];
    return `${scheme}${trimmedProxyUrl}/${host}`;
  }
  return messagingUrl;
};
exports.default = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Given "ws://foo.vonage.com/", returns "foo.vonage.com"

const trimProxyUrl = proxyUrl => {
  const trimmedProxyUrl = proxyUrl
  // remove trailing slashes
  .replace(/\/+$/, '')
  // remove the scheme (e.g., "ws://foo.vonage.com" -> "foo.vonage.com")
  .replace(/^.*:\/+/, '');
  return trimmedProxyUrl;
};
var _default = trimProxyUrl;
exports.default = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = sanitizeQosData;
var _blacklistedStats = _interopRequireDefault(__webpack_require__(585));
var _isSessionProxied = _interopRequireDefault(__webpack_require__(586));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable one-var, no-use-before-define, no-param-reassign */
/* eslint-disable max-len, no-var, vars-on-top, global-require */

function sanitizeQosData(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const isSessionProxied = deps.isSessionProxied || _isSessionProxied.default;
  const _deps = deps,
    sessionId = _deps.sessionId;
  if (!isSessionProxied(sessionId)) {
    return;
  }
  _blacklistedStats.default.forEach(stat => {
    if (stat in deps) {
      deps[stat] = '';
    }
  });
}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// List of QoS to be filtered from payload if IP Proxy is enabled
var _default = ['audioLocalAddress', 'audioRemoteAddress', 'videoLocalAddress', 'videoRemoteAddress'];
exports.default = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _objects = _interopRequireDefault(__webpack_require__(27));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable one-var, no-use-before-define, no-param-reassign */
/* eslint-disable max-len, no-var, vars-on-top, global-require */

const sessions = _objects.default.sessions;
var _default = sessionId => {
  const session = sessions.get(sessionId);
  return session ? !!session._.getProxyUrl() : false;
};
exports.default = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
const hintToFieldMap = {
  architecture: 'event_ua_arch',
  bitness: 'event_ua_bitness',
  model: 'event_ua_model',
  platformVersion: 'event_ua_platform_version'
};
const getUserAgentClientHintData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(userAgentData) {
    var result, data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          result = {};
          if (!(userAgentData != null && userAgentData.getHighEntropyValues)) {
            _context.next = 6;
            break;
          }
          _context.next = 4;
          return userAgentData.getHighEntropyValues(Object.keys(hintToFieldMap));
        case 4:
          data = _context.sent;
          if (data) {
            Object.entries(hintToFieldMap).forEach(_ref2 => {
              let hint = _ref2[0],
                field = _ref2[1];
              if (data[hint] !== undefined) {
                result[field] = data[hint];
              }
            });
          }
        case 6:
          return _context.abrupt("return", result);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getUserAgentClientHintData(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = getUserAgentClientHintData;
exports.default = _default;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _makeEverythingAttachToOTHelpers = _interopRequireDefault(__webpack_require__(266));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

const domExtras = {};
domExtras.isElementNode = function (node) {
  return node && typeof node === 'object' && node.nodeType === 1;
};
domExtras.createElement = function (nodeName, attributes, children, doc) {
  const element = (doc || document).createElement(nodeName);
  attributes = attributes || {};
  Object.keys(attributes).forEach(name => {
    if (typeof attributes[name] === 'object') {
      if (!element[name]) {
        element[name] = {};
      }
      const subAttrs = attributes[name];
      Object.keys(subAttrs).forEach(n => {
        element[name][n] = subAttrs[n];
      });
    } else if (name === 'className') {
      element.className = attributes[name];
    } else {
      element.setAttribute(name, attributes[name]);
    }
  });
  const setChildren = function setChildren(child) {
    if (typeof child === 'string') {
      element.innerHTML += child;
    } else {
      element.appendChild(child);
    }
  };
  if (Array.isArray(children)) {
    children.forEach(setChildren);
  } else if (children) {
    setChildren(children);
  }
  return element;
};
(0, _makeEverythingAttachToOTHelpers.default)(domExtras);
var _default = domExtras;
exports.default = _default;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = listenForTracksEndedFactory;
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-use-before-define */

function listenForTracksEndedFactory() {
  function isEveryTrackEnded(stream) {
    return stream.getTracks().every(track => track.readyState === 'ended');
  }
  return function listenForTracksEnded(stream, onAllEnded, onSingleEnded) {
    const tracks = [];
    function singleTrackEndedHandler(event) {
      // We wait a fraction of a second for all ended events to be emitted before
      // determining if all tracks have ended or just a subset of them.
      setTimeout(() => {
        if (!tracks.length) {
          return;
        }
        if (isEveryTrackEnded(stream)) {
          removeAllTrackListeners();
          if (typeof onAllEnded === 'function') {
            onAllEnded();
          }
        } else {
          const track = event.target;
          removeTrackListener(track);
          if (typeof onSingleEnded === 'function') {
            onSingleEnded(track);
          }
        }
      }, 100);
    }
    function removeTrackListener(track) {
      track.onended = null; // eslint-disable-line no-param-reassign
      const index = tracks.indexOf(track);
      if (index >= 0) {
        tracks.splice(index, 1);
      }
    }
    function removeAllTrackListeners() {
      tracks.slice().forEach(removeTrackListener);
    }
    function addTrackListeners() {
      stream.getTracks().forEach(track => {
        tracks.push(track);
        const originalOnEnded = track.onended;
        // eslint-disable-next-line no-param-reassign
        track.onended = function () {
          if (originalOnEnded) {
            // When self-subscribing to a published stream, both the publisher and self-subscriber
            // are referencing the same object. After a subscriber is created, the onended listener
            // for the publisher will be overwritten unless we store it. See VIDCS-3131.
            originalOnEnded(...arguments);
          }
          singleTrackEndedHandler(...arguments);
        };
      });
    }
    addTrackListeners();
    return {
      stop: removeAllTrackListeners,
      refresh: () => {
        removeAllTrackListeners();
        addTrackListeners();
      }
    };
  };
}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _createVideoElementUsingNativeAPI = _interopRequireDefault(__webpack_require__(153));
var videoElementBufferDefault = _interopRequireWildcard(__webpack_require__(591));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// VIDCS-1523: tries to create an video element that's autoplayable
// despite the application losing focus.
// This approach is similar to what Youenn from Apple suggested.
// See https://bugs.webkit.org/show_bug.cgi?id=219318#c7
const createVideoElementForSafari = function createVideoElementForSafari(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const documentMock = deps.document || document;
  const videoElementBuffer = deps.videoElementBuffer || videoElementBufferDefault;
  const createVideoElementUsingNativeAPI = deps.createVideoElementUsingNativeAPI || _createVideoElementUsingNativeAPI.default;
  if (documentMock.hasFocus()) {
    // We create and/or top off the buffer only when we have focus, so that the video
    // elements will autoplay.
    videoElementBuffer.fillBuffer();

    // The buffer of autoplayable elements is reserved for when the
    // application doesn't have focus.  That's why we return dynamically
    // create elements instead.
    return createVideoElementUsingNativeAPI();
  }

  // Since we don't have focus, if we create a video element using
  // native APIs, then Safari will deny autoplay.  To mitigate, we
  // *try* to get one from the autoplayable bucket of video elements.
  return videoElementBuffer.getNext() || createVideoElementUsingNativeAPI();
};
var _default = createVideoElementForSafari;
exports.default = _default;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.sizeOfBuffer = exports.getNext = exports.fillBuffer = exports.clearBuffer = exports.MAX_VIDEO_ELEMENTS = void 0;
var _createVideoElementUsingNativeAPI = _interopRequireDefault(__webpack_require__(153));
const MAX_VIDEO_ELEMENTS = 20;
exports.MAX_VIDEO_ELEMENTS = MAX_VIDEO_ELEMENTS;
const videoElements = [];
const sizeOfBuffer = () => videoElements.length;
exports.sizeOfBuffer = sizeOfBuffer;
const fillBuffer = () => {
  while (sizeOfBuffer() < MAX_VIDEO_ELEMENTS) {
    const videoElement = (0, _createVideoElementUsingNativeAPI.default)();

    // This is an async method but we don't await because it's not required.  Reason
    // being, we just want to register the `play` request so that it'll inherit
    // the autoplay permission that is/was granted.
    videoElement.play().catch(() => {
      // We intentional suppress the exception, since we just want the request to
      // be queued up.
    });

    // Since we don't care about awaiting for `play()`, we immediately add the
    // element.
    videoElements.push(videoElement);
  }
};
exports.fillBuffer = fillBuffer;
const getNext = () => videoElements.shift();

// Useful for testing
exports.getNext = getNext;
const clearBuffer = () => {
  videoElements.length = 0;
};
exports.clearBuffer = clearBuffer;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.removeMediaElementListeners = exports.addMediaElementListeners = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
/* global HTMLMediaElement */
/* eslint-disable no-console */

// This is a subset of all possible HTMLMediaElement events. We leave some because we
// either don't care about it (`encrypted`) or they might be too noisy (e.g., `timeupdate`).
const mediaElementEvents = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'volumechange', 'waiting'];
const eventHandlers = {};
const isValidElementAndEnv = (mediaElement, env) => {
  if (!(env != null && env.isDev)) {
    console.debug("Not in DEV, so won't add/remove debug listeners");
    return false;
  }
  if (!(mediaElement instanceof HTMLMediaElement)) {
    console.error('mediaElementListeners: Invalid HTMLMediaElement');
    return false;
  }
  return true;
};
const addMediaElementListeners = function addMediaElementListeners(mediaElement, triggerEvent, deps) {
  if (deps === void 0) {
    deps = {};
  }
  const env = deps.env || _env.default;
  if (!isValidElementAndEnv(mediaElement, env)) return;
  mediaElementEvents.forEach(eventName => {
    eventHandlers[eventName] = event => {
      triggerEvent(`mediaElement:${eventName}`);
      console.debug(`HTMLMediaElement triggered: ${eventName}`, event);
    };
    mediaElement.addEventListener(eventName, eventHandlers[eventName]);
  });
};
exports.addMediaElementListeners = addMediaElementListeners;
const removeMediaElementListeners = function removeMediaElementListeners(mediaElement, deps) {
  if (deps === void 0) {
    deps = {};
  }
  const env = deps.env || _env.default;
  if (!isValidElementAndEnv(mediaElement, env)) return;
  mediaElementEvents.forEach(event => {
    mediaElement.removeEventListener(event, eventHandlers[event]);
    delete eventHandlers[event];
  });
};
exports.removeMediaElementListeners = removeMediaElementListeners;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const runtimeProperties = ['buildHash', 'minimumVersion', 'debug', ['websiteURL', 'websiteUrl'], ['cdnURL', 'cdnUrl'], ['loggingURL', 'loggingUrl'], ['apiURL', 'apiUrl'], ['supportSSL', true], ['cdnURLSSL', 'cdnUrl'], ['loggingURLSSL', 'loggingUrl'], ['apiURLSSL', 'apiUrl'], ['assetURL', 'assetUrl']];
var _default = runtimeProperties;
exports.default = _default;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const mutableRuntimeProperties = ['apiUrl', 'apiURL', 'apiURLSSL'];
var _default = mutableRuntimeProperties;
exports.default = _default;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = noConflict;
function noConflict() {
  const globalOT = (typeof window !== undefined ? window : global).OT;
  const globalTB = (typeof window !== undefined ? window : global).TB;
  return () => {
    const OT = (typeof window !== undefined ? window : global).OT;
    (typeof window !== undefined ? window : global).OT = globalOT;
    (typeof window !== undefined ? window : global).TB = globalTB;
    return OT;
  };
}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */



var utils = __webpack_require__(32);
// Shimming starts here.
module.exports = function(dependencies, opts) {
  var window = dependencies && dependencies.window;

  var options = {
    shimChrome: true,
    shimFirefox: true,
    shimEdge: true,
    shimSafari: true,
  };

  for (var key in opts) {
    if (hasOwnProperty.call(opts, key)) {
      options[key] = opts[key];
    }
  }

  // Utils.
  var logging = utils.log;
  var browserDetails = utils.detectBrowser(window);

  // Uncomment the line below if you want logging to occur, including logging
  // for the switch statement below. Can also be turned on in the browser via
  // adapter.disableLog(false), but then logging from the switch statement below
  // will not appear.
  // require('./utils').disableLog(false);

  // Browser shims.
  var chromeShim = __webpack_require__(597) || null;
  var edgeShim = __webpack_require__(599) || null;
  var firefoxShim = __webpack_require__(603) || null;
  var safariShim = __webpack_require__(605) || null;
  var commonShim = __webpack_require__(606) || null;

  // Export to the adapter global object visible in the browser.
  var adapter = {
    browserDetails: browserDetails,
    commonShim: commonShim,
    extractVersion: utils.extractVersion,
    disableLog: utils.disableLog,
    disableWarnings: utils.disableWarnings
  };

  // Shim browser if found.
  switch (browserDetails.browser) {
    case 'chrome':
      if (!chromeShim || !chromeShim.shimPeerConnection ||
          !options.shimChrome) {
        logging('Chrome shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming chrome.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = chromeShim;
      commonShim.shimCreateObjectURL(window);

      chromeShim.shimGetUserMedia(window);
      chromeShim.shimMediaStream(window);
      chromeShim.shimSourceObject(window);
      chromeShim.shimPeerConnection(window);
      chromeShim.shimOnTrack(window);
      chromeShim.shimAddTrackRemoveTrack(window);
      chromeShim.shimGetSendersWithDtmf(window);
      chromeShim.shimSenderReceiverGetStats(window);
      chromeShim.fixNegotiationNeeded(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'firefox':
      if (!firefoxShim || !firefoxShim.shimPeerConnection ||
          !options.shimFirefox) {
        logging('Firefox shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming firefox.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = firefoxShim;
      commonShim.shimCreateObjectURL(window);

      firefoxShim.shimGetUserMedia(window);
      firefoxShim.shimSourceObject(window);
      firefoxShim.shimPeerConnection(window);
      firefoxShim.shimOnTrack(window);
      firefoxShim.shimRemoveStream(window);
      firefoxShim.shimSenderGetStats(window);
      firefoxShim.shimReceiverGetStats(window);
      firefoxShim.shimRTCDataChannel(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'edge':
      if (!edgeShim || !edgeShim.shimPeerConnection || !options.shimEdge) {
        logging('MS edge shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming edge.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = edgeShim;
      commonShim.shimCreateObjectURL(window);

      edgeShim.shimGetUserMedia(window);
      edgeShim.shimPeerConnection(window);
      edgeShim.shimReplaceTrack(window);
      edgeShim.shimGetDisplayMedia(window);

      // the edge shim implements the full RTCIceCandidate object.

      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'safari':
      if (!safariShim || !options.shimSafari) {
        logging('Safari shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming safari.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = safariShim;
      commonShim.shimCreateObjectURL(window);

      safariShim.shimRTCIceServerUrls(window);
      safariShim.shimCreateOfferLegacy(window);
      safariShim.shimCallbacksAPI(window);
      safariShim.shimLocalStreamsAPI(window);
      safariShim.shimRemoteStreamsAPI(window);
      safariShim.shimTrackEventTransceiver(window);
      safariShim.shimGetUserMedia(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    default:
      logging('Unsupported browser!');
      break;
  }

  return adapter;
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */

var utils = __webpack_require__(32);
var logging = utils.log;

/* iterates the stats graph recursively. */
function walkStats(stats, base, resultSet) {
  if (!base || resultSet.has(base.id)) {
    return;
  }
  resultSet.set(base.id, base);
  Object.keys(base).forEach(function(name) {
    if (name.endsWith('Id')) {
      walkStats(stats, stats.get(base[name]), resultSet);
    } else if (name.endsWith('Ids')) {
      base[name].forEach(function(id) {
        walkStats(stats, stats.get(id), resultSet);
      });
    }
  });
}

/* filter getStats for a sender/receiver track. */
function filterStats(result, track, outbound) {
  var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
  var filteredResult = new Map();
  if (track === null) {
    return filteredResult;
  }
  var trackStats = [];
  result.forEach(function(value) {
    if (value.type === 'track' &&
        value.trackIdentifier === track.id) {
      trackStats.push(value);
    }
  });
  trackStats.forEach(function(trackStat) {
    result.forEach(function(stats) {
      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
        walkStats(result, stats, filteredResult);
      }
    });
  });
  return filteredResult;
}

module.exports = {
  shimGetUserMedia: __webpack_require__(598),
  shimMediaStream: function(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
  },

  shimOnTrack: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
          }
          this.addEventListener('track', this._ontrack = f);
        },
        enumerable: true,
        configurable: true
      });
      var origSetRemoteDescription =
          window.RTCPeerConnection.prototype.setRemoteDescription;
      window.RTCPeerConnection.prototype.setRemoteDescription = function() {
        var pc = this;
        if (!pc._ontrackpoly) {
          pc._ontrackpoly = function(e) {
            // onaddstream does not fire when a track is added to an existing
            // stream. But stream.onaddtrack is implemented so we use that.
            e.stream.addEventListener('addtrack', function(te) {
              var receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = pc.getReceivers().find(function(r) {
                  return r.track && r.track.id === te.track.id;
                });
              } else {
                receiver = {track: te.track};
              }

              var event = new Event('track');
              event.track = te.track;
              event.receiver = receiver;
              event.transceiver = {receiver: receiver};
              event.streams = [e.stream];
              pc.dispatchEvent(event);
            });
            e.stream.getTracks().forEach(function(track) {
              var receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = pc.getReceivers().find(function(r) {
                  return r.track && r.track.id === track.id;
                });
              } else {
                receiver = {track: track};
              }
              var event = new Event('track');
              event.track = track;
              event.receiver = receiver;
              event.transceiver = {receiver: receiver};
              event.streams = [e.stream];
              pc.dispatchEvent(event);
            });
          };
          pc.addEventListener('addstream', pc._ontrackpoly);
        }
        return origSetRemoteDescription.apply(pc, arguments);
      };
    } else {
      // even if RTCRtpTransceiver is in window, it is only used and
      // emitted in unified-plan. Unfortunately this means we need
      // to unconditionally wrap the event.
      utils.wrapPeerConnectionEvent(window, 'track', function(e) {
        if (!e.transceiver) {
          Object.defineProperty(e, 'transceiver',
            {value: {receiver: e.receiver}});
        }
        return e;
      });
    }
  },

  shimGetSendersWithDtmf: function(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === 'object' && window.RTCPeerConnection &&
        !('getSenders' in window.RTCPeerConnection.prototype) &&
        'createDTMFSender' in window.RTCPeerConnection.prototype) {
      var shimSenderWithDtmf = function(pc, track) {
        return {
          track: track,
          get dtmf() {
            if (this._dtmf === undefined) {
              if (track.kind === 'audio') {
                this._dtmf = pc.createDTMFSender(track);
              } else {
                this._dtmf = null;
              }
            }
            return this._dtmf;
          },
          _pc: pc
        };
      };

      // augment addTrack when getSenders is not available.
      if (!window.RTCPeerConnection.prototype.getSenders) {
        window.RTCPeerConnection.prototype.getSenders = function() {
          this._senders = this._senders || [];
          return this._senders.slice(); // return a copy of the internal state.
        };
        var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
          var pc = this;
          var sender = origAddTrack.apply(pc, arguments);
          if (!sender) {
            sender = shimSenderWithDtmf(pc, track);
            pc._senders.push(sender);
          }
          return sender;
        };

        var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
        window.RTCPeerConnection.prototype.removeTrack = function(sender) {
          var pc = this;
          origRemoveTrack.apply(pc, arguments);
          var idx = pc._senders.indexOf(sender);
          if (idx !== -1) {
            pc._senders.splice(idx, 1);
          }
        };
      }
      var origAddStream = window.RTCPeerConnection.prototype.addStream;
      window.RTCPeerConnection.prototype.addStream = function(stream) {
        var pc = this;
        pc._senders = pc._senders || [];
        origAddStream.apply(pc, [stream]);
        stream.getTracks().forEach(function(track) {
          pc._senders.push(shimSenderWithDtmf(pc, track));
        });
      };

      var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
      window.RTCPeerConnection.prototype.removeStream = function(stream) {
        var pc = this;
        pc._senders = pc._senders || [];
        origRemoveStream.apply(pc, [stream]);

        stream.getTracks().forEach(function(track) {
          var sender = pc._senders.find(function(s) {
            return s.track === track;
          });
          if (sender) {
            pc._senders.splice(pc._senders.indexOf(sender), 1); // remove sender
          }
        });
      };
    } else if (typeof window === 'object' && window.RTCPeerConnection &&
               'getSenders' in window.RTCPeerConnection.prototype &&
               'createDTMFSender' in window.RTCPeerConnection.prototype &&
               window.RTCRtpSender &&
               !('dtmf' in window.RTCRtpSender.prototype)) {
      var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
      window.RTCPeerConnection.prototype.getSenders = function() {
        var pc = this;
        var senders = origGetSenders.apply(pc, []);
        senders.forEach(function(sender) {
          sender._pc = pc;
        });
        return senders;
      };

      Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
        get: function() {
          if (this._dtmf === undefined) {
            if (this.track.kind === 'audio') {
              this._dtmf = this._pc.createDTMFSender(this.track);
            } else {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        }
      });
    }
  },

  shimSenderReceiverGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender && window.RTCRtpReceiver)) {
      return;
    }

    // shim sender stats.
    if (!('getStats' in window.RTCRtpSender.prototype)) {
      var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
      if (origGetSenders) {
        window.RTCPeerConnection.prototype.getSenders = function() {
          var pc = this;
          var senders = origGetSenders.apply(pc, []);
          senders.forEach(function(sender) {
            sender._pc = pc;
          });
          return senders;
        };
      }

      var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
      if (origAddTrack) {
        window.RTCPeerConnection.prototype.addTrack = function() {
          var sender = origAddTrack.apply(this, arguments);
          sender._pc = this;
          return sender;
        };
      }
      window.RTCRtpSender.prototype.getStats = function() {
        var sender = this;
        return this._pc.getStats().then(function(result) {
          /* Note: this will include stats of all senders that
           *   send a track with the same id as sender.track as
           *   it is not possible to identify the RTCRtpSender.
           */
          return filterStats(result, sender.track, true);
        });
      };
    }

    // shim receiver stats.
    if (!('getStats' in window.RTCRtpReceiver.prototype)) {
      var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
      if (origGetReceivers) {
        window.RTCPeerConnection.prototype.getReceivers = function() {
          var pc = this;
          var receivers = origGetReceivers.apply(pc, []);
          receivers.forEach(function(receiver) {
            receiver._pc = pc;
          });
          return receivers;
        };
      }
      utils.wrapPeerConnectionEvent(window, 'track', function(e) {
        e.receiver._pc = e.srcElement;
        return e;
      });
      window.RTCRtpReceiver.prototype.getStats = function() {
        var receiver = this;
        return this._pc.getStats().then(function(result) {
          return filterStats(result, receiver.track, false);
        });
      };
    }

    if (!('getStats' in window.RTCRtpSender.prototype &&
        'getStats' in window.RTCRtpReceiver.prototype)) {
      return;
    }

    // shim RTCPeerConnection.getStats(track).
    var origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function() {
      var pc = this;
      if (arguments.length > 0 &&
          arguments[0] instanceof window.MediaStreamTrack) {
        var track = arguments[0];
        var sender;
        var receiver;
        var err;
        pc.getSenders().forEach(function(s) {
          if (s.track === track) {
            if (sender) {
              err = true;
            } else {
              sender = s;
            }
          }
        });
        pc.getReceivers().forEach(function(r) {
          if (r.track === track) {
            if (receiver) {
              err = true;
            } else {
              receiver = r;
            }
          }
          return r.track === track;
        });
        if (err || (sender && receiver)) {
          return Promise.reject(new DOMException(
            'There are more than one sender or receiver for the track.',
            'InvalidAccessError'));
        } else if (sender) {
          return sender.getStats();
        } else if (receiver) {
          return receiver.getStats();
        }
        return Promise.reject(new DOMException(
          'There is no sender or receiver for the track.',
          'InvalidAccessError'));
      }
      return origGetStats.apply(pc, arguments);
    };
  },

  shimSourceObject: function(window) {
    var URL = window && window.URL;

    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        // Shim the srcObject property, once, when HTMLMediaElement is found.
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this._srcObject;
          },
          set: function(stream) {
            var self = this;
            // Use _srcObject as a private property for this shim
            this._srcObject = stream;
            if (this.src) {
              URL.revokeObjectURL(this.src);
            }

            if (!stream) {
              this.src = '';
              return undefined;
            }
            this.src = URL.createObjectURL(stream);
            // We need to recreate the blob url when a track is added or
            // removed. Doing it manually since we want to avoid a recursion.
            stream.addEventListener('addtrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
            stream.addEventListener('removetrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
          }
        });
      }
    }
  },

  shimAddTrackRemoveTrackWithNative: function(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function() {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      return Object.keys(this._shimmedLocalStreams).map(function(streamId) {
        return pc._shimmedLocalStreams[streamId][0];
      });
    };

    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
      if (!stream) {
        return origAddTrack.apply(this, arguments);
      }
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};

      var sender = origAddTrack.apply(this, arguments);
      if (!this._shimmedLocalStreams[stream.id]) {
        this._shimmedLocalStreams[stream.id] = [stream, sender];
      } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
        this._shimmedLocalStreams[stream.id].push(sender);
      }
      return sender;
    };

    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function(stream) {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};

      stream.getTracks().forEach(function(track) {
        var alreadyExists = pc.getSenders().find(function(s) {
          return s.track === track;
        });
        if (alreadyExists) {
          throw new DOMException('Track already exists.',
              'InvalidAccessError');
        }
      });
      var existingSenders = pc.getSenders();
      origAddStream.apply(this, arguments);
      var newSenders = pc.getSenders().filter(function(newSender) {
        return existingSenders.indexOf(newSender) === -1;
      });
      this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      delete this._shimmedLocalStreams[stream.id];
      return origRemoveStream.apply(this, arguments);
    };

    var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function(sender) {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      if (sender) {
        Object.keys(this._shimmedLocalStreams).forEach(function(streamId) {
          var idx = pc._shimmedLocalStreams[streamId].indexOf(sender);
          if (idx !== -1) {
            pc._shimmedLocalStreams[streamId].splice(idx, 1);
          }
          if (pc._shimmedLocalStreams[streamId].length === 1) {
            delete pc._shimmedLocalStreams[streamId];
          }
        });
      }
      return origRemoveTrack.apply(this, arguments);
    };
  },

  shimAddTrackRemoveTrack: function(window) {
    if (!window.RTCPeerConnection) {
      return;
    }
    var browserDetails = utils.detectBrowser(window);
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack &&
        browserDetails.version >= 65) {
      return this.shimAddTrackRemoveTrackWithNative(window);
    }

    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    var origGetLocalStreams = window.RTCPeerConnection.prototype
        .getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function() {
      var pc = this;
      var nativeStreams = origGetLocalStreams.apply(this);
      pc._reverseStreams = pc._reverseStreams || {};
      return nativeStreams.map(function(stream) {
        return pc._reverseStreams[stream.id];
      });
    };

    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function(stream) {
      var pc = this;
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};

      stream.getTracks().forEach(function(track) {
        var alreadyExists = pc.getSenders().find(function(s) {
          return s.track === track;
        });
        if (alreadyExists) {
          throw new DOMException('Track already exists.',
              'InvalidAccessError');
        }
      });
      // Add identity mapping for consistency with addTrack.
      // Unless this is being used with a stream from addTrack.
      if (!pc._reverseStreams[stream.id]) {
        var newStream = new window.MediaStream(stream.getTracks());
        pc._streams[stream.id] = newStream;
        pc._reverseStreams[newStream.id] = stream;
        stream = newStream;
      }
      origAddStream.apply(pc, [stream]);
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var pc = this;
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};

      origRemoveStream.apply(pc, [(pc._streams[stream.id] || stream)]);
      delete pc._reverseStreams[(pc._streams[stream.id] ?
          pc._streams[stream.id].id : stream.id)];
      delete pc._streams[stream.id];
    };

    window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
      var pc = this;
      if (pc.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      var streams = [].slice.call(arguments, 1);
      if (streams.length !== 1 ||
          !streams[0].getTracks().find(function(t) {
            return t === track;
          })) {
        // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException(
          'The adapter.js addTrack polyfill only supports a single ' +
          ' stream which is associated with the specified track.',
          'NotSupportedError');
      }

      var alreadyExists = pc.getSenders().find(function(s) {
        return s.track === track;
      });
      if (alreadyExists) {
        throw new DOMException('Track already exists.',
            'InvalidAccessError');
      }

      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};
      var oldStream = pc._streams[stream.id];
      if (oldStream) {
        // this is using odd Chrome behaviour, use with caution:
        // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
        // Note: we rely on the high-level addTrack/dtmf shim to
        // create the sender with a dtmf sender.
        oldStream.addTrack(track);

        // Trigger ONN async.
        Promise.resolve().then(function() {
          pc.dispatchEvent(new Event('negotiationneeded'));
        });
      } else {
        var newStream = new window.MediaStream([track]);
        pc._streams[stream.id] = newStream;
        pc._reverseStreams[newStream.id] = stream;
        pc.addStream(newStream);
      }
      return pc.getSenders().find(function(s) {
        return s.track === track;
      });
    };

    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
      var sdp = description.sdp;
      Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
        var externalStream = pc._reverseStreams[internalId];
        var internalStream = pc._streams[externalStream.id];
        sdp = sdp.replace(new RegExp(internalStream.id, 'g'),
            externalStream.id);
      });
      return new RTCSessionDescription({
        type: description.type,
        sdp: sdp
      });
    }
    function replaceExternalStreamId(pc, description) {
      var sdp = description.sdp;
      Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
        var externalStream = pc._reverseStreams[internalId];
        var internalStream = pc._streams[externalStream.id];
        sdp = sdp.replace(new RegExp(externalStream.id, 'g'),
            internalStream.id);
      });
      return new RTCSessionDescription({
        type: description.type,
        sdp: sdp
      });
    }
    ['createOffer', 'createAnswer'].forEach(function(method) {
      var nativeMethod = window.RTCPeerConnection.prototype[method];
      window.RTCPeerConnection.prototype[method] = function() {
        var pc = this;
        var args = arguments;
        var isLegacyCall = arguments.length &&
            typeof arguments[0] === 'function';
        if (isLegacyCall) {
          return nativeMethod.apply(pc, [
            function(description) {
              var desc = replaceInternalStreamId(pc, description);
              args[0].apply(null, [desc]);
            },
            function(err) {
              if (args[1]) {
                args[1].apply(null, err);
              }
            }, arguments[2]
          ]);
        }
        return nativeMethod.apply(pc, arguments)
        .then(function(description) {
          return replaceInternalStreamId(pc, description);
        });
      };
    });

    var origSetLocalDescription =
        window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function() {
      var pc = this;
      if (!arguments.length || !arguments[0].type) {
        return origSetLocalDescription.apply(pc, arguments);
      }
      arguments[0] = replaceExternalStreamId(pc, arguments[0]);
      return origSetLocalDescription.apply(pc, arguments);
    };

    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier

    var origLocalDescription = Object.getOwnPropertyDescriptor(
        window.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window.RTCPeerConnection.prototype,
        'localDescription', {
          get: function() {
            var pc = this;
            var description = origLocalDescription.get.apply(this);
            if (description.type === '') {
              return description;
            }
            return replaceInternalStreamId(pc, description);
          }
        });

    window.RTCPeerConnection.prototype.removeTrack = function(sender) {
      var pc = this;
      if (pc.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      // We can not yet check for sender instanceof RTCRtpSender
      // since we shim RTPSender. So we check if sender._pc is set.
      if (!sender._pc) {
        throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' +
            'does not implement interface RTCRtpSender.', 'TypeError');
      }
      var isLocal = sender._pc === pc;
      if (!isLocal) {
        throw new DOMException('Sender was not created by this connection.',
            'InvalidAccessError');
      }

      // Search for the native stream the senders track belongs to.
      pc._streams = pc._streams || {};
      var stream;
      Object.keys(pc._streams).forEach(function(streamid) {
        var hasTrack = pc._streams[streamid].getTracks().find(function(track) {
          return sender.track === track;
        });
        if (hasTrack) {
          stream = pc._streams[streamid];
        }
      });

      if (stream) {
        if (stream.getTracks().length === 1) {
          // if this is the last track of the stream, remove the stream. This
          // takes care of any shimmed _senders.
          pc.removeStream(pc._reverseStreams[stream.id]);
        } else {
          // relying on the same odd chrome behaviour as above.
          stream.removeTrack(sender.track);
        }
        pc.dispatchEvent(new Event('negotiationneeded'));
      }
    };
  },

  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    // The RTCPeerConnection object.
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        // Translate iceTransportPolicy to iceTransports,
        // see https://code.google.com/p/webrtc/issues/detail?id=4869
        // this was fixed in M56 along with unprefixing RTCPeerConnection.
        logging('PeerConnection');
        if (pcConfig && pcConfig.iceTransportPolicy) {
          pcConfig.iceTransports = pcConfig.iceTransportPolicy;
        }

        return new window.webkitRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype =
          window.webkitRTCPeerConnection.prototype;
      // wrap static methods. Currently just generateCertificate.
      if (window.webkitRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return window.webkitRTCPeerConnection.generateCertificate;
          }
        });
      }
    }
    if (!window.RTCPeerConnection) {
      return;
    }

    var origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function(selector,
        successCallback, errorCallback) {
      var pc = this;
      var args = arguments;

      // If selector is a function then we are in the old style stats so just
      // pass back the original getStats format to avoid breaking old users.
      if (arguments.length > 0 && typeof selector === 'function') {
        return origGetStats.apply(this, arguments);
      }

      // When spec-style getStats is supported, return those when called with
      // either no arguments or the selector argument is null.
      if (origGetStats.length === 0 && (arguments.length === 0 ||
          typeof arguments[0] !== 'function')) {
        return origGetStats.apply(this, []);
      }

      var fixChromeStats_ = function(response) {
        var standardReport = {};
        var reports = response.result();
        reports.forEach(function(report) {
          var standardStats = {
            id: report.id,
            timestamp: report.timestamp,
            type: {
              localcandidate: 'local-candidate',
              remotecandidate: 'remote-candidate'
            }[report.type] || report.type
          };
          report.names().forEach(function(name) {
            standardStats[name] = report.stat(name);
          });
          standardReport[standardStats.id] = standardStats;
        });

        return standardReport;
      };

      // shim getStats with maplike support
      var makeMapStats = function(stats) {
        return new Map(Object.keys(stats).map(function(key) {
          return [key, stats[key]];
        }));
      };

      if (arguments.length >= 2) {
        var successCallbackWrapper_ = function(response) {
          args[1](makeMapStats(fixChromeStats_(response)));
        };

        return origGetStats.apply(this, [successCallbackWrapper_,
          arguments[0]]);
      }

      // promise-support
      return new Promise(function(resolve, reject) {
        origGetStats.apply(pc, [
          function(response) {
            resolve(makeMapStats(fixChromeStats_(response)));
          }, reject]);
      }).then(successCallback, errorCallback);
    };

    // add promise support -- natively available in Chrome 51
    if (browserDetails.version < 51) {
      ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
          .forEach(function(method) {
            var nativeMethod = window.RTCPeerConnection.prototype[method];
            window.RTCPeerConnection.prototype[method] = function() {
              var args = arguments;
              var pc = this;
              var promise = new Promise(function(resolve, reject) {
                nativeMethod.apply(pc, [args[0], resolve, reject]);
              });
              if (args.length < 2) {
                return promise;
              }
              return promise.then(function() {
                args[1].apply(null, []);
              },
              function(err) {
                if (args.length >= 3) {
                  args[2].apply(null, [err]);
                }
              });
            };
          });
    }

    // promise support for createOffer and createAnswer. Available (without
    // bugs) since M52: crbug/619289
    if (browserDetails.version < 52) {
      ['createOffer', 'createAnswer'].forEach(function(method) {
        var nativeMethod = window.RTCPeerConnection.prototype[method];
        window.RTCPeerConnection.prototype[method] = function() {
          var pc = this;
          if (arguments.length < 1 || (arguments.length === 1 &&
              typeof arguments[0] === 'object')) {
            var opts = arguments.length === 1 ? arguments[0] : undefined;
            return new Promise(function(resolve, reject) {
              nativeMethod.apply(pc, [resolve, reject, opts]);
            });
          }
          return nativeMethod.apply(this, arguments);
        };
      });
    }

    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];
          window.RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });

    // support for addIceCandidate(null or undefined)
    var nativeAddIceCandidate =
        window.RTCPeerConnection.prototype.addIceCandidate;
    window.RTCPeerConnection.prototype.addIceCandidate = function() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };
  },

  fixNegotiationNeeded: function(window) {
    utils.wrapPeerConnectionEvent(window, 'negotiationneeded', function(e) {
      var pc = e.target;
      if (pc.signalingState !== 'stable') {
        return;
      }
      return e;
    });
  },

  shimGetDisplayMedia: function(window, getSourceId) {
    if (!window.navigator || !window.navigator.mediaDevices ||
        'getDisplayMedia' in window.navigator.mediaDevices) {
      return;
    }
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== 'function') {
      console.error('shimGetDisplayMedia: getSourceId argument is not ' +
          'a function');
      return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function(constraints) {
      return getSourceId(constraints)
        .then(function(sourceId) {
          var widthSpecified = constraints.video && constraints.video.width;
          var heightSpecified = constraints.video && constraints.video.height;
          var frameRateSpecified = constraints.video &&
            constraints.video.frameRate;
          constraints.video = {
            mandatory: {
              chromeMediaSource: 'desktop',
              chromeMediaSourceId: sourceId,
              maxFrameRate: frameRateSpecified || 3
            }
          };
          if (widthSpecified) {
            constraints.video.mandatory.maxWidth = widthSpecified;
          }
          if (heightSpecified) {
            constraints.video.mandatory.maxHeight = heightSpecified;
          }
          return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
    window.navigator.getDisplayMedia = function(constraints) {
      utils.deprecated('navigator.getDisplayMedia',
          'navigator.mediaDevices.getDisplayMedia');
      return window.navigator.mediaDevices.getDisplayMedia(constraints);
    };
  }
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */

var utils = __webpack_require__(32);
var logging = utils.log;

// Expose public methods.
module.exports = function(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;

  var constraintsToChrome_ = function(c) {
    if (typeof c !== 'object' || c.mandatory || c.optional) {
      return c;
    }
    var cc = {};
    Object.keys(c).forEach(function(key) {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }
      var r = (typeof c[key] === 'object') ? c[key] : {ideal: c[key]};
      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }
      var oldname_ = function(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return (name === 'deviceId') ? 'sourceId' : name;
      };
      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        var oc = {};
        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(function(mix) {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }
    return cc;
  };

  var shimConstraints_ = function(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && typeof constraints.audio === 'object') {
      var remap = function(obj, a, b) {
        if (a in obj && !(b in obj)) {
          obj[b] = obj[a];
          delete obj[a];
        }
      };
      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && typeof constraints.video === 'object') {
      // Shim facingMode for mobile & surface pro.
      var face = constraints.video.facingMode;
      face = face && ((typeof face === 'object') ? face : {ideal: face});
      var getSupportedFacingModeLies = browserDetails.version < 66;

      if ((face && (face.exact === 'user' || face.exact === 'environment' ||
                    face.ideal === 'user' || face.ideal === 'environment')) &&
          !(navigator.mediaDevices.getSupportedConstraints &&
            navigator.mediaDevices.getSupportedConstraints().facingMode &&
            !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;
        var matches;
        if (face.exact === 'environment' || face.ideal === 'environment') {
          matches = ['back', 'rear'];
        } else if (face.exact === 'user' || face.ideal === 'user') {
          matches = ['front'];
        }
        if (matches) {
          // Look for matches in label, or use last cam for back (typical).
          return navigator.mediaDevices.enumerateDevices()
          .then(function(devices) {
            devices = devices.filter(function(d) {
              return d.kind === 'videoinput';
            });
            var dev = devices.find(function(d) {
              return matches.some(function(match) {
                return d.label.toLowerCase().indexOf(match) !== -1;
              });
            });
            if (!dev && devices.length && matches.indexOf('back') !== -1) {
              dev = devices[devices.length - 1]; // more likely the back cam
            }
            if (dev) {
              constraints.video.deviceId = face.exact ? {exact: dev.deviceId} :
                                                        {ideal: dev.deviceId};
            }
            constraints.video = constraintsToChrome_(constraints.video);
            logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };

  var shimError_ = function(e) {
    if (browserDetails.version >= 64) {
      return e;
    }
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        PermissionDismissedError: 'NotAllowedError',
        InvalidStateError: 'NotAllowedError',
        DevicesNotFoundError: 'NotFoundError',
        ConstraintNotSatisfiedError: 'OverconstrainedError',
        TrackStartError: 'NotReadableError',
        MediaDeviceFailedDueToShutdown: 'NotAllowedError',
        MediaDeviceKillSwitchOn: 'NotAllowedError',
        TabCaptureError: 'AbortError',
        ScreenCaptureError: 'AbortError',
        DeviceCaptureError: 'AbortError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint || e.constraintName,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  var getUserMedia_ = function(constraints, onSuccess, onError) {
    shimConstraints_(constraints, function(c) {
      navigator.webkitGetUserMedia(c, onSuccess, function(e) {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };

  navigator.getUserMedia = getUserMedia_;

  // Returns the result of getUserMedia as a Promise.
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      navigator.getUserMedia(constraints, resolve, reject);
    });
  };

  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {
      getUserMedia: getUserMediaPromise_,
      enumerateDevices: function() {
        return new Promise(function(resolve) {
          var kinds = {audio: 'audioinput', video: 'videoinput'};
          return window.MediaStreamTrack.getSources(function(devices) {
            resolve(devices.map(function(device) {
              return {label: device.label,
                kind: kinds[device.kind],
                deviceId: device.id,
                groupId: ''};
            }));
          });
        });
      },
      getSupportedConstraints: function() {
        return {
          deviceId: true, echoCancellation: true, facingMode: true,
          frameRate: true, height: true, width: true
        };
      }
    };
  }

  // A shim for getUserMedia method on the mediaDevices object.
  // TODO(KaptenJansson) remove once implemented in Chrome stable.
  if (!navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices.getUserMedia = function(constraints) {
      return getUserMediaPromise_(constraints);
    };
  } else {
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(cs) {
      return shimConstraints_(cs, function(c) {
        return origGetUserMedia(c).then(function(stream) {
          if (c.audio && !stream.getAudioTracks().length ||
              c.video && !stream.getVideoTracks().length) {
            stream.getTracks().forEach(function(track) {
              track.stop();
            });
            throw new DOMException('', 'NotFoundError');
          }
          return stream;
        }, function(e) {
          return Promise.reject(shimError_(e));
        });
      });
    };
  }

  // Dummy devicechange event methods.
  // TODO(KaptenJansson) remove once implemented in Chrome stable.
  if (typeof navigator.mediaDevices.addEventListener === 'undefined') {
    navigator.mediaDevices.addEventListener = function() {
      logging('Dummy mediaDevices.addEventListener called.');
    };
  }
  if (typeof navigator.mediaDevices.removeEventListener === 'undefined') {
    navigator.mediaDevices.removeEventListener = function() {
      logging('Dummy mediaDevices.removeEventListener called.');
    };
  }
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(32);
var filterIceServers = __webpack_require__(600);
var shimRTCPeerConnection = __webpack_require__(601);

module.exports = {
  shimGetUserMedia: __webpack_require__(602),
  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    if (window.RTCIceGatherer) {
      if (!window.RTCIceCandidate) {
        window.RTCIceCandidate = function(args) {
          return args;
        };
      }
      if (!window.RTCSessionDescription) {
        window.RTCSessionDescription = function(args) {
          return args;
        };
      }
      // this adds an additional event listener to MediaStrackTrack that signals
      // when a tracks enabled property was changed. Workaround for a bug in
      // addStream, see below. No longer required in 15025+
      if (browserDetails.version < 15025) {
        var origMSTEnabled = Object.getOwnPropertyDescriptor(
            window.MediaStreamTrack.prototype, 'enabled');
        Object.defineProperty(window.MediaStreamTrack.prototype, 'enabled', {
          set: function(value) {
            origMSTEnabled.set.call(this, value);
            var ev = new Event('enabled');
            ev.enabled = value;
            this.dispatchEvent(ev);
          }
        });
      }
    }

    // ORTC defines the DTMF sender a bit different.
    // https://github.com/w3c/ortc/issues/714
    if (window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
      Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
        get: function() {
          if (this._dtmf === undefined) {
            if (this.track.kind === 'audio') {
              this._dtmf = new window.RTCDtmfSender(this);
            } else if (this.track.kind === 'video') {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        }
      });
    }
    // Edge currently only implements the RTCDtmfSender, not the
    // RTCDTMFSender alias. See http://draft.ortc.org/#rtcdtmfsender2*
    if (window.RTCDtmfSender && !window.RTCDTMFSender) {
      window.RTCDTMFSender = window.RTCDtmfSender;
    }

    var RTCPeerConnectionShim = shimRTCPeerConnection(window,
        browserDetails.version);
    window.RTCPeerConnection = function(config) {
      if (config && config.iceServers) {
        config.iceServers = filterIceServers(config.iceServers);
      }
      return new RTCPeerConnectionShim(config);
    };
    window.RTCPeerConnection.prototype = RTCPeerConnectionShim.prototype;
  },
  shimReplaceTrack: function(window) {
    // ORTC has replaceTrack -- https://github.com/w3c/ortc/issues/614
    if (window.RTCRtpSender &&
        !('replaceTrack' in window.RTCRtpSender.prototype)) {
      window.RTCRtpSender.prototype.replaceTrack =
          window.RTCRtpSender.prototype.setTrack;
    }
  },
  shimGetDisplayMedia: function(window, preferredMediaSource) {
    if (!('getDisplayMedia' in window.navigator) ||
        !window.navigator.mediaDevices ||
        'getDisplayMedia' in window.navigator.mediaDevices) {
      return;
    }
    var origGetDisplayMedia = window.navigator.getDisplayMedia;
    window.navigator.mediaDevices.getDisplayMedia = function(constraints) {
      return origGetDisplayMedia.call(window.navigator, constraints);
    };
    window.navigator.getDisplayMedia = function(constraints) {
      utils.deprecated('navigator.getDisplayMedia',
          'navigator.mediaDevices.getDisplayMedia');
      return origGetDisplayMedia.call(window.navigator, constraints);
    };
  }
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2018 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(32);
// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
module.exports = function(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function(server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;
      if (server.url && !server.urls) {
        utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
      }
      var isString = typeof urls === 'string';
      if (isString) {
        urls = [urls];
      }
      urls = urls.filter(function(url) {
        var validTurn = url.indexOf('turn:') === 0 &&
            url.indexOf('transport=udp') !== -1 &&
            url.indexOf('turn:[') === -1 &&
            !hasTurn;

        if (validTurn) {
          hasTurn = true;
          return true;
        }
        return url.indexOf('stun:') === 0 && edgeVersion >= 14393 &&
            url.indexOf('?transport=udp') === -1;
      });

      delete server.url;
      server.urls = isString ? urls[0] : urls;
      return !!urls.length;
    }
  });
};


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var SDPUtils = __webpack_require__(276);

function fixStatsType(stat) {
  return {
    inboundrtp: 'inbound-rtp',
    outboundrtp: 'outbound-rtp',
    candidatepair: 'candidate-pair',
    localcandidate: 'local-candidate',
    remotecandidate: 'remote-candidate'
  }[stat.type] || stat.type;
}

function writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
      transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
      transceiver.dtlsTransport.getLocalParameters(),
      type === 'offer' ? 'actpass' : dtlsRole || 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    var trackId = transceiver.rtpSender._initialTrackId ||
        transceiver.rtpSender.track.id;
    transceiver.rtpSender._initialTrackId = trackId;
    // spec.
    var msid = 'msid:' + (stream ? stream.id : '-') + ' ' +
        trackId + '\r\n';
    sdp += 'a=' + msid;
    // for Chrome. Legacy should no longer be required.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;

    // RTX
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
}

// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function filterIceServers(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function(server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;
      if (server.url && !server.urls) {
        console.warn('RTCIceServer.url is deprecated! Use urls instead.');
      }
      var isString = typeof urls === 'string';
      if (isString) {
        urls = [urls];
      }
      urls = urls.filter(function(url) {
        var validTurn = url.indexOf('turn:') === 0 &&
            url.indexOf('transport=udp') !== -1 &&
            url.indexOf('turn:[') === -1 &&
            !hasTurn;

        if (validTurn) {
          hasTurn = true;
          return true;
        }
        return url.indexOf('stun:') === 0 && edgeVersion >= 14393 &&
            url.indexOf('?transport=udp') === -1;
      });

      delete server.url;
      server.urls = isString ? urls[0] : urls;
      return !!urls.length;
    }
  });
}

// Determines the intersection of local and remote capabilities.
function getCommonCapabilities(localCapabilities, remoteCapabilities) {
  var commonCapabilities = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: []
  };

  var findCodecByPayloadType = function(pt, codecs) {
    pt = parseInt(pt, 10);
    for (var i = 0; i < codecs.length; i++) {
      if (codecs[i].payloadType === pt ||
          codecs[i].preferredPayloadType === pt) {
        return codecs[i];
      }
    }
  };

  var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
    var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
    var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
    return lCodec && rCodec &&
        lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
  };

  localCapabilities.codecs.forEach(function(lCodec) {
    for (var i = 0; i < remoteCapabilities.codecs.length; i++) {
      var rCodec = remoteCapabilities.codecs[i];
      if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() &&
          lCodec.clockRate === rCodec.clockRate) {
        if (lCodec.name.toLowerCase() === 'rtx' &&
            lCodec.parameters && rCodec.parameters.apt) {
          // for RTX we need to find the local rtx that has a apt
          // which points to the same local codec as the remote one.
          if (!rtxCapabilityMatches(lCodec, rCodec,
              localCapabilities.codecs, remoteCapabilities.codecs)) {
            continue;
          }
        }
        rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
        // number of channels is the highest common number of channels
        rCodec.numChannels = Math.min(lCodec.numChannels,
            rCodec.numChannels);
        // push rCodec so we reply with offerer payload type
        commonCapabilities.codecs.push(rCodec);

        // determine common feedback mechanisms
        rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
          for (var j = 0; j < lCodec.rtcpFeedback.length; j++) {
            if (lCodec.rtcpFeedback[j].type === fb.type &&
                lCodec.rtcpFeedback[j].parameter === fb.parameter) {
              return true;
            }
          }
          return false;
        });
        // FIXME: also need to determine .parameters
        //  see https://github.com/openpeer/ortc/issues/569
        break;
      }
    }
  });

  localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
    for (var i = 0; i < remoteCapabilities.headerExtensions.length;
         i++) {
      var rHeaderExtension = remoteCapabilities.headerExtensions[i];
      if (lHeaderExtension.uri === rHeaderExtension.uri) {
        commonCapabilities.headerExtensions.push(rHeaderExtension);
        break;
      }
    }
  });

  // FIXME: fecMechanisms
  return commonCapabilities;
}

// is action=setLocalDescription with type allowed in signalingState
function isActionAllowedInSignalingState(action, type, signalingState) {
  return {
    offer: {
      setLocalDescription: ['stable', 'have-local-offer'],
      setRemoteDescription: ['stable', 'have-remote-offer']
    },
    answer: {
      setLocalDescription: ['have-remote-offer', 'have-local-pranswer'],
      setRemoteDescription: ['have-local-offer', 'have-remote-pranswer']
    }
  }[type][action].indexOf(signalingState) !== -1;
}

function maybeAddCandidate(iceTransport, candidate) {
  // Edge's internal representation adds some fields therefore
  // not all fieldѕ are taken into account.
  var alreadyAdded = iceTransport.getRemoteCandidates()
      .find(function(remoteCandidate) {
        return candidate.foundation === remoteCandidate.foundation &&
            candidate.ip === remoteCandidate.ip &&
            candidate.port === remoteCandidate.port &&
            candidate.priority === remoteCandidate.priority &&
            candidate.protocol === remoteCandidate.protocol &&
            candidate.type === remoteCandidate.type;
      });
  if (!alreadyAdded) {
    iceTransport.addRemoteCandidate(candidate);
  }
  return !alreadyAdded;
}


function makeError(name, description) {
  var e = new Error(description);
  e.name = name;
  // legacy error codes from https://heycam.github.io/webidl/#idl-DOMException-error-names
  e.code = {
    NotSupportedError: 9,
    InvalidStateError: 11,
    InvalidAccessError: 15,
    TypeError: undefined,
    OperationError: undefined
  }[name];
  return e;
}

module.exports = function(window, edgeVersion) {
  // https://w3c.github.io/mediacapture-main/#mediastream
  // Helper function to add the track to the stream and
  // dispatch the event ourselves.
  function addTrackToStreamAndFireEvent(track, stream) {
    stream.addTrack(track);
    stream.dispatchEvent(new window.MediaStreamTrackEvent('addtrack',
        {track: track}));
  }

  function removeTrackFromStreamAndFireEvent(track, stream) {
    stream.removeTrack(track);
    stream.dispatchEvent(new window.MediaStreamTrackEvent('removetrack',
        {track: track}));
  }

  function fireAddTrack(pc, track, receiver, streams) {
    var trackEvent = new Event('track');
    trackEvent.track = track;
    trackEvent.receiver = receiver;
    trackEvent.transceiver = {receiver: receiver};
    trackEvent.streams = streams;
    window.setTimeout(function() {
      pc._dispatchEvent('track', trackEvent);
    });
  }

  var RTCPeerConnection = function(config) {
    var pc = this;

    var _eventTarget = document.createDocumentFragment();
    ['addEventListener', 'removeEventListener', 'dispatchEvent']
        .forEach(function(method) {
          pc[method] = _eventTarget[method].bind(_eventTarget);
        });

    this.canTrickleIceCandidates = null;

    this.needNegotiation = false;

    this.localStreams = [];
    this.remoteStreams = [];

    this._localDescription = null;
    this._remoteDescription = null;

    this.signalingState = 'stable';
    this.iceConnectionState = 'new';
    this.connectionState = 'new';
    this.iceGatheringState = 'new';

    config = JSON.parse(JSON.stringify(config || {}));

    this.usingBundle = config.bundlePolicy === 'max-bundle';
    if (config.rtcpMuxPolicy === 'negotiate') {
      throw(makeError('NotSupportedError',
          'rtcpMuxPolicy \'negotiate\' is not supported'));
    } else if (!config.rtcpMuxPolicy) {
      config.rtcpMuxPolicy = 'require';
    }

    switch (config.iceTransportPolicy) {
      case 'all':
      case 'relay':
        break;
      default:
        config.iceTransportPolicy = 'all';
        break;
    }

    switch (config.bundlePolicy) {
      case 'balanced':
      case 'max-compat':
      case 'max-bundle':
        break;
      default:
        config.bundlePolicy = 'balanced';
        break;
    }

    config.iceServers = filterIceServers(config.iceServers || [], edgeVersion);

    this._iceGatherers = [];
    if (config.iceCandidatePoolSize) {
      for (var i = config.iceCandidatePoolSize; i > 0; i--) {
        this._iceGatherers.push(new window.RTCIceGatherer({
          iceServers: config.iceServers,
          gatherPolicy: config.iceTransportPolicy
        }));
      }
    } else {
      config.iceCandidatePoolSize = 0;
    }

    this._config = config;

    // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
    // everything that is needed to describe a SDP m-line.
    this.transceivers = [];

    this._sdpSessionId = SDPUtils.generateSessionId();
    this._sdpSessionVersion = 0;

    this._dtlsRole = undefined; // role for a=setup to use in answers.

    this._isClosed = false;
  };

  Object.defineProperty(RTCPeerConnection.prototype, 'localDescription', {
    configurable: true,
    get: function() {
      return this._localDescription;
    }
  });
  Object.defineProperty(RTCPeerConnection.prototype, 'remoteDescription', {
    configurable: true,
    get: function() {
      return this._remoteDescription;
    }
  });

  // set up event handlers on prototype
  RTCPeerConnection.prototype.onicecandidate = null;
  RTCPeerConnection.prototype.onaddstream = null;
  RTCPeerConnection.prototype.ontrack = null;
  RTCPeerConnection.prototype.onremovestream = null;
  RTCPeerConnection.prototype.onsignalingstatechange = null;
  RTCPeerConnection.prototype.oniceconnectionstatechange = null;
  RTCPeerConnection.prototype.onconnectionstatechange = null;
  RTCPeerConnection.prototype.onicegatheringstatechange = null;
  RTCPeerConnection.prototype.onnegotiationneeded = null;
  RTCPeerConnection.prototype.ondatachannel = null;

  RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
    if (this._isClosed) {
      return;
    }
    this.dispatchEvent(event);
    if (typeof this['on' + name] === 'function') {
      this['on' + name](event);
    }
  };

  RTCPeerConnection.prototype._emitGatheringStateChange = function() {
    var event = new Event('icegatheringstatechange');
    this._dispatchEvent('icegatheringstatechange', event);
  };

  RTCPeerConnection.prototype.getConfiguration = function() {
    return this._config;
  };

  RTCPeerConnection.prototype.getLocalStreams = function() {
    return this.localStreams;
  };

  RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this.remoteStreams;
  };

  // internal helper to create a transceiver object.
  // (which is not yet the same as the WebRTC 1.0 transceiver)
  RTCPeerConnection.prototype._createTransceiver = function(kind, doNotAdd) {
    var hasBundleTransport = this.transceivers.length > 0;
    var transceiver = {
      track: null,
      iceGatherer: null,
      iceTransport: null,
      dtlsTransport: null,
      localCapabilities: null,
      remoteCapabilities: null,
      rtpSender: null,
      rtpReceiver: null,
      kind: kind,
      mid: null,
      sendEncodingParameters: null,
      recvEncodingParameters: null,
      stream: null,
      associatedRemoteMediaStreams: [],
      wantReceive: true
    };
    if (this.usingBundle && hasBundleTransport) {
      transceiver.iceTransport = this.transceivers[0].iceTransport;
      transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
    } else {
      var transports = this._createIceAndDtlsTransports();
      transceiver.iceTransport = transports.iceTransport;
      transceiver.dtlsTransport = transports.dtlsTransport;
    }
    if (!doNotAdd) {
      this.transceivers.push(transceiver);
    }
    return transceiver;
  };

  RTCPeerConnection.prototype.addTrack = function(track, stream) {
    if (this._isClosed) {
      throw makeError('InvalidStateError',
          'Attempted to call addTrack on a closed peerconnection.');
    }

    var alreadyExists = this.transceivers.find(function(s) {
      return s.track === track;
    });

    if (alreadyExists) {
      throw makeError('InvalidAccessError', 'Track already exists.');
    }

    var transceiver;
    for (var i = 0; i < this.transceivers.length; i++) {
      if (!this.transceivers[i].track &&
          this.transceivers[i].kind === track.kind) {
        transceiver = this.transceivers[i];
      }
    }
    if (!transceiver) {
      transceiver = this._createTransceiver(track.kind);
    }

    this._maybeFireNegotiationNeeded();

    if (this.localStreams.indexOf(stream) === -1) {
      this.localStreams.push(stream);
    }

    transceiver.track = track;
    transceiver.stream = stream;
    transceiver.rtpSender = new window.RTCRtpSender(track,
        transceiver.dtlsTransport);
    return transceiver.rtpSender;
  };

  RTCPeerConnection.prototype.addStream = function(stream) {
    var pc = this;
    if (edgeVersion >= 15025) {
      stream.getTracks().forEach(function(track) {
        pc.addTrack(track, stream);
      });
    } else {
      // Clone is necessary for local demos mostly, attaching directly
      // to two different senders does not work (build 10547).
      // Fixed in 15025 (or earlier)
      var clonedStream = stream.clone();
      stream.getTracks().forEach(function(track, idx) {
        var clonedTrack = clonedStream.getTracks()[idx];
        track.addEventListener('enabled', function(event) {
          clonedTrack.enabled = event.enabled;
        });
      });
      clonedStream.getTracks().forEach(function(track) {
        pc.addTrack(track, clonedStream);
      });
    }
  };

  RTCPeerConnection.prototype.removeTrack = function(sender) {
    if (this._isClosed) {
      throw makeError('InvalidStateError',
          'Attempted to call removeTrack on a closed peerconnection.');
    }

    if (!(sender instanceof window.RTCRtpSender)) {
      throw new TypeError('Argument 1 of RTCPeerConnection.removeTrack ' +
          'does not implement interface RTCRtpSender.');
    }

    var transceiver = this.transceivers.find(function(t) {
      return t.rtpSender === sender;
    });

    if (!transceiver) {
      throw makeError('InvalidAccessError',
          'Sender was not created by this connection.');
    }
    var stream = transceiver.stream;

    transceiver.rtpSender.stop();
    transceiver.rtpSender = null;
    transceiver.track = null;
    transceiver.stream = null;

    // remove the stream from the set of local streams
    var localStreams = this.transceivers.map(function(t) {
      return t.stream;
    });
    if (localStreams.indexOf(stream) === -1 &&
        this.localStreams.indexOf(stream) > -1) {
      this.localStreams.splice(this.localStreams.indexOf(stream), 1);
    }

    this._maybeFireNegotiationNeeded();
  };

  RTCPeerConnection.prototype.removeStream = function(stream) {
    var pc = this;
    stream.getTracks().forEach(function(track) {
      var sender = pc.getSenders().find(function(s) {
        return s.track === track;
      });
      if (sender) {
        pc.removeTrack(sender);
      }
    });
  };

  RTCPeerConnection.prototype.getSenders = function() {
    return this.transceivers.filter(function(transceiver) {
      return !!transceiver.rtpSender;
    })
    .map(function(transceiver) {
      return transceiver.rtpSender;
    });
  };

  RTCPeerConnection.prototype.getReceivers = function() {
    return this.transceivers.filter(function(transceiver) {
      return !!transceiver.rtpReceiver;
    })
    .map(function(transceiver) {
      return transceiver.rtpReceiver;
    });
  };


  RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex,
      usingBundle) {
    var pc = this;
    if (usingBundle && sdpMLineIndex > 0) {
      return this.transceivers[0].iceGatherer;
    } else if (this._iceGatherers.length) {
      return this._iceGatherers.shift();
    }
    var iceGatherer = new window.RTCIceGatherer({
      iceServers: this._config.iceServers,
      gatherPolicy: this._config.iceTransportPolicy
    });
    Object.defineProperty(iceGatherer, 'state',
        {value: 'new', writable: true}
    );

    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
    this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
      var end = !event.candidate || Object.keys(event.candidate).length === 0;
      // polyfill since RTCIceGatherer.state is not implemented in
      // Edge 10547 yet.
      iceGatherer.state = end ? 'completed' : 'gathering';
      if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) {
        pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
      }
    };
    iceGatherer.addEventListener('localcandidate',
      this.transceivers[sdpMLineIndex].bufferCandidates);
    return iceGatherer;
  };

  // start gathering from an RTCIceGatherer.
  RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
    var pc = this;
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
    if (iceGatherer.onlocalcandidate) {
      return;
    }
    var bufferedCandidateEvents =
      this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
    iceGatherer.removeEventListener('localcandidate',
      this.transceivers[sdpMLineIndex].bufferCandidates);
    iceGatherer.onlocalcandidate = function(evt) {
      if (pc.usingBundle && sdpMLineIndex > 0) {
        // if we know that we use bundle we can drop candidates with
        // ѕdpMLineIndex > 0. If we don't do this then our state gets
        // confused since we dispose the extra ice gatherer.
        return;
      }
      var event = new Event('icecandidate');
      event.candidate = {sdpMid: mid, sdpMLineIndex: sdpMLineIndex};

      var cand = evt.candidate;
      // Edge emits an empty object for RTCIceCandidateComplete‥
      var end = !cand || Object.keys(cand).length === 0;
      if (end) {
        // polyfill since RTCIceGatherer.state is not implemented in
        // Edge 10547 yet.
        if (iceGatherer.state === 'new' || iceGatherer.state === 'gathering') {
          iceGatherer.state = 'completed';
        }
      } else {
        if (iceGatherer.state === 'new') {
          iceGatherer.state = 'gathering';
        }
        // RTCIceCandidate doesn't have a component, needs to be added
        cand.component = 1;
        // also the usernameFragment. TODO: update SDP to take both variants.
        cand.ufrag = iceGatherer.getLocalParameters().usernameFragment;

        var serializedCandidate = SDPUtils.writeCandidate(cand);
        event.candidate = Object.assign(event.candidate,
            SDPUtils.parseCandidate(serializedCandidate));

        event.candidate.candidate = serializedCandidate;
        event.candidate.toJSON = function() {
          return {
            candidate: event.candidate.candidate,
            sdpMid: event.candidate.sdpMid,
            sdpMLineIndex: event.candidate.sdpMLineIndex,
            usernameFragment: event.candidate.usernameFragment
          };
        };
      }

      // update local description.
      var sections = SDPUtils.getMediaSections(pc._localDescription.sdp);
      if (!end) {
        sections[event.candidate.sdpMLineIndex] +=
            'a=' + event.candidate.candidate + '\r\n';
      } else {
        sections[event.candidate.sdpMLineIndex] +=
            'a=end-of-candidates\r\n';
      }
      pc._localDescription.sdp =
          SDPUtils.getDescription(pc._localDescription.sdp) +
          sections.join('');
      var complete = pc.transceivers.every(function(transceiver) {
        return transceiver.iceGatherer &&
            transceiver.iceGatherer.state === 'completed';
      });

      if (pc.iceGatheringState !== 'gathering') {
        pc.iceGatheringState = 'gathering';
        pc._emitGatheringStateChange();
      }

      // Emit candidate. Also emit null candidate when all gatherers are
      // complete.
      if (!end) {
        pc._dispatchEvent('icecandidate', event);
      }
      if (complete) {
        pc._dispatchEvent('icecandidate', new Event('icecandidate'));
        pc.iceGatheringState = 'complete';
        pc._emitGatheringStateChange();
      }
    };

    // emit already gathered candidates.
    window.setTimeout(function() {
      bufferedCandidateEvents.forEach(function(e) {
        iceGatherer.onlocalcandidate(e);
      });
    }, 0);
  };

  // Create ICE transport and DTLS transport.
  RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
    var pc = this;
    var iceTransport = new window.RTCIceTransport(null);
    iceTransport.onicestatechange = function() {
      pc._updateIceConnectionState();
      pc._updateConnectionState();
    };

    var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
    dtlsTransport.ondtlsstatechange = function() {
      pc._updateConnectionState();
    };
    dtlsTransport.onerror = function() {
      // onerror does not set state to failed by itself.
      Object.defineProperty(dtlsTransport, 'state',
          {value: 'failed', writable: true});
      pc._updateConnectionState();
    };

    return {
      iceTransport: iceTransport,
      dtlsTransport: dtlsTransport
    };
  };

  // Destroy ICE gatherer, ICE transport and DTLS transport.
  // Without triggering the callbacks.
  RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(
      sdpMLineIndex) {
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
    if (iceGatherer) {
      delete iceGatherer.onlocalcandidate;
      delete this.transceivers[sdpMLineIndex].iceGatherer;
    }
    var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
    if (iceTransport) {
      delete iceTransport.onicestatechange;
      delete this.transceivers[sdpMLineIndex].iceTransport;
    }
    var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
    if (dtlsTransport) {
      delete dtlsTransport.ondtlsstatechange;
      delete dtlsTransport.onerror;
      delete this.transceivers[sdpMLineIndex].dtlsTransport;
    }
  };

  // Start the RTP Sender and Receiver for a transceiver.
  RTCPeerConnection.prototype._transceive = function(transceiver,
      send, recv) {
    var params = getCommonCapabilities(transceiver.localCapabilities,
        transceiver.remoteCapabilities);
    if (send && transceiver.rtpSender) {
      params.encodings = transceiver.sendEncodingParameters;
      params.rtcp = {
        cname: SDPUtils.localCName,
        compound: transceiver.rtcpParameters.compound
      };
      if (transceiver.recvEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
      }
      transceiver.rtpSender.send(params);
    }
    if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
      // remove RTX field in Edge 14942
      if (transceiver.kind === 'video'
          && transceiver.recvEncodingParameters
          && edgeVersion < 15019) {
        transceiver.recvEncodingParameters.forEach(function(p) {
          delete p.rtx;
        });
      }
      if (transceiver.recvEncodingParameters.length) {
        params.encodings = transceiver.recvEncodingParameters;
      } else {
        params.encodings = [{}];
      }
      params.rtcp = {
        compound: transceiver.rtcpParameters.compound
      };
      if (transceiver.rtcpParameters.cname) {
        params.rtcp.cname = transceiver.rtcpParameters.cname;
      }
      if (transceiver.sendEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
      }
      transceiver.rtpReceiver.receive(params);
    }
  };

  RTCPeerConnection.prototype.setLocalDescription = function(description) {
    var pc = this;

    // Note: pranswer is not supported.
    if (['offer', 'answer'].indexOf(description.type) === -1) {
      return Promise.reject(makeError('TypeError',
          'Unsupported type "' + description.type + '"'));
    }

    if (!isActionAllowedInSignalingState('setLocalDescription',
        description.type, pc.signalingState) || pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not set local ' + description.type +
          ' in state ' + pc.signalingState));
    }

    var sections;
    var sessionpart;
    if (description.type === 'offer') {
      // VERY limited support for SDP munging. Limited to:
      // * changing the order of codecs
      sections = SDPUtils.splitSections(description.sdp);
      sessionpart = sections.shift();
      sections.forEach(function(mediaSection, sdpMLineIndex) {
        var caps = SDPUtils.parseRtpParameters(mediaSection);
        pc.transceivers[sdpMLineIndex].localCapabilities = caps;
      });

      pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
        pc._gather(transceiver.mid, sdpMLineIndex);
      });
    } else if (description.type === 'answer') {
      sections = SDPUtils.splitSections(pc._remoteDescription.sdp);
      sessionpart = sections.shift();
      var isIceLite = SDPUtils.matchPrefix(sessionpart,
          'a=ice-lite').length > 0;
      sections.forEach(function(mediaSection, sdpMLineIndex) {
        var transceiver = pc.transceivers[sdpMLineIndex];
        var iceGatherer = transceiver.iceGatherer;
        var iceTransport = transceiver.iceTransport;
        var dtlsTransport = transceiver.dtlsTransport;
        var localCapabilities = transceiver.localCapabilities;
        var remoteCapabilities = transceiver.remoteCapabilities;

        // treat bundle-only as not-rejected.
        var rejected = SDPUtils.isRejected(mediaSection) &&
            SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;

        if (!rejected && !transceiver.rejected) {
          var remoteIceParameters = SDPUtils.getIceParameters(
              mediaSection, sessionpart);
          var remoteDtlsParameters = SDPUtils.getDtlsParameters(
              mediaSection, sessionpart);
          if (isIceLite) {
            remoteDtlsParameters.role = 'server';
          }

          if (!pc.usingBundle || sdpMLineIndex === 0) {
            pc._gather(transceiver.mid, sdpMLineIndex);
            if (iceTransport.state === 'new') {
              iceTransport.start(iceGatherer, remoteIceParameters,
                  isIceLite ? 'controlling' : 'controlled');
            }
            if (dtlsTransport.state === 'new') {
              dtlsTransport.start(remoteDtlsParameters);
            }
          }

          // Calculate intersection of capabilities.
          var params = getCommonCapabilities(localCapabilities,
              remoteCapabilities);

          // Start the RTCRtpSender. The RTCRtpReceiver for this
          // transceiver has already been started in setRemoteDescription.
          pc._transceive(transceiver,
              params.codecs.length > 0,
              false);
        }
      });
    }

    pc._localDescription = {
      type: description.type,
      sdp: description.sdp
    };
    if (description.type === 'offer') {
      pc._updateSignalingState('have-local-offer');
    } else {
      pc._updateSignalingState('stable');
    }

    return Promise.resolve();
  };

  RTCPeerConnection.prototype.setRemoteDescription = function(description) {
    var pc = this;

    // Note: pranswer is not supported.
    if (['offer', 'answer'].indexOf(description.type) === -1) {
      return Promise.reject(makeError('TypeError',
          'Unsupported type "' + description.type + '"'));
    }

    if (!isActionAllowedInSignalingState('setRemoteDescription',
        description.type, pc.signalingState) || pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not set remote ' + description.type +
          ' in state ' + pc.signalingState));
    }

    var streams = {};
    pc.remoteStreams.forEach(function(stream) {
      streams[stream.id] = stream;
    });
    var receiverList = [];
    var sections = SDPUtils.splitSections(description.sdp);
    var sessionpart = sections.shift();
    var isIceLite = SDPUtils.matchPrefix(sessionpart,
        'a=ice-lite').length > 0;
    var usingBundle = SDPUtils.matchPrefix(sessionpart,
        'a=group:BUNDLE ').length > 0;
    pc.usingBundle = usingBundle;
    var iceOptions = SDPUtils.matchPrefix(sessionpart,
        'a=ice-options:')[0];
    if (iceOptions) {
      pc.canTrickleIceCandidates = iceOptions.substr(14).split(' ')
          .indexOf('trickle') >= 0;
    } else {
      pc.canTrickleIceCandidates = false;
    }

    sections.forEach(function(mediaSection, sdpMLineIndex) {
      var lines = SDPUtils.splitLines(mediaSection);
      var kind = SDPUtils.getKind(mediaSection);
      // treat bundle-only as not-rejected.
      var rejected = SDPUtils.isRejected(mediaSection) &&
          SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
      var protocol = lines[0].substr(2).split(' ')[2];

      var direction = SDPUtils.getDirection(mediaSection, sessionpart);
      var remoteMsid = SDPUtils.parseMsid(mediaSection);

      var mid = SDPUtils.getMid(mediaSection) || SDPUtils.generateIdentifier();

      // Reject datachannels which are not implemented yet.
      if (rejected || (kind === 'application' && (protocol === 'DTLS/SCTP' ||
          protocol === 'UDP/DTLS/SCTP'))) {
        // TODO: this is dangerous in the case where a non-rejected m-line
        //     becomes rejected.
        pc.transceivers[sdpMLineIndex] = {
          mid: mid,
          kind: kind,
          protocol: protocol,
          rejected: true
        };
        return;
      }

      if (!rejected && pc.transceivers[sdpMLineIndex] &&
          pc.transceivers[sdpMLineIndex].rejected) {
        // recycle a rejected transceiver.
        pc.transceivers[sdpMLineIndex] = pc._createTransceiver(kind, true);
      }

      var transceiver;
      var iceGatherer;
      var iceTransport;
      var dtlsTransport;
      var rtpReceiver;
      var sendEncodingParameters;
      var recvEncodingParameters;
      var localCapabilities;

      var track;
      // FIXME: ensure the mediaSection has rtcp-mux set.
      var remoteCapabilities = SDPUtils.parseRtpParameters(mediaSection);
      var remoteIceParameters;
      var remoteDtlsParameters;
      if (!rejected) {
        remoteIceParameters = SDPUtils.getIceParameters(mediaSection,
            sessionpart);
        remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection,
            sessionpart);
        remoteDtlsParameters.role = 'client';
      }
      recvEncodingParameters =
          SDPUtils.parseRtpEncodingParameters(mediaSection);

      var rtcpParameters = SDPUtils.parseRtcpParameters(mediaSection);

      var isComplete = SDPUtils.matchPrefix(mediaSection,
          'a=end-of-candidates', sessionpart).length > 0;
      var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:')
          .map(function(cand) {
            return SDPUtils.parseCandidate(cand);
          })
          .filter(function(cand) {
            return cand.component === 1;
          });

      // Check if we can use BUNDLE and dispose transports.
      if ((description.type === 'offer' || description.type === 'answer') &&
          !rejected && usingBundle && sdpMLineIndex > 0 &&
          pc.transceivers[sdpMLineIndex]) {
        pc._disposeIceAndDtlsTransports(sdpMLineIndex);
        pc.transceivers[sdpMLineIndex].iceGatherer =
            pc.transceivers[0].iceGatherer;
        pc.transceivers[sdpMLineIndex].iceTransport =
            pc.transceivers[0].iceTransport;
        pc.transceivers[sdpMLineIndex].dtlsTransport =
            pc.transceivers[0].dtlsTransport;
        if (pc.transceivers[sdpMLineIndex].rtpSender) {
          pc.transceivers[sdpMLineIndex].rtpSender.setTransport(
              pc.transceivers[0].dtlsTransport);
        }
        if (pc.transceivers[sdpMLineIndex].rtpReceiver) {
          pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(
              pc.transceivers[0].dtlsTransport);
        }
      }
      if (description.type === 'offer' && !rejected) {
        transceiver = pc.transceivers[sdpMLineIndex] ||
            pc._createTransceiver(kind);
        transceiver.mid = mid;

        if (!transceiver.iceGatherer) {
          transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex,
              usingBundle);
        }

        if (cands.length && transceiver.iceTransport.state === 'new') {
          if (isComplete && (!usingBundle || sdpMLineIndex === 0)) {
            transceiver.iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function(candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);

        // filter RTX until additional stuff needed for RTX is implemented
        // in adapter.js
        if (edgeVersion < 15019) {
          localCapabilities.codecs = localCapabilities.codecs.filter(
              function(codec) {
                return codec.name !== 'rtx';
              });
        }

        sendEncodingParameters = transceiver.sendEncodingParameters || [{
          ssrc: (2 * sdpMLineIndex + 2) * 1001
        }];

        // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
        var isNewTrack = false;
        if (direction === 'sendrecv' || direction === 'sendonly') {
          isNewTrack = !transceiver.rtpReceiver;
          rtpReceiver = transceiver.rtpReceiver ||
              new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);

          if (isNewTrack) {
            var stream;
            track = rtpReceiver.track;
            // FIXME: does not work with Plan B.
            if (remoteMsid && remoteMsid.stream === '-') {
              // no-op. a stream id of '-' means: no associated stream.
            } else if (remoteMsid) {
              if (!streams[remoteMsid.stream]) {
                streams[remoteMsid.stream] = new window.MediaStream();
                Object.defineProperty(streams[remoteMsid.stream], 'id', {
                  get: function() {
                    return remoteMsid.stream;
                  }
                });
              }
              Object.defineProperty(track, 'id', {
                get: function() {
                  return remoteMsid.track;
                }
              });
              stream = streams[remoteMsid.stream];
            } else {
              if (!streams.default) {
                streams.default = new window.MediaStream();
              }
              stream = streams.default;
            }
            if (stream) {
              addTrackToStreamAndFireEvent(track, stream);
              transceiver.associatedRemoteMediaStreams.push(stream);
            }
            receiverList.push([track, rtpReceiver, stream]);
          }
        } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
          transceiver.associatedRemoteMediaStreams.forEach(function(s) {
            var nativeTrack = s.getTracks().find(function(t) {
              return t.id === transceiver.rtpReceiver.track.id;
            });
            if (nativeTrack) {
              removeTrackFromStreamAndFireEvent(nativeTrack, s);
            }
          });
          transceiver.associatedRemoteMediaStreams = [];
        }

        transceiver.localCapabilities = localCapabilities;
        transceiver.remoteCapabilities = remoteCapabilities;
        transceiver.rtpReceiver = rtpReceiver;
        transceiver.rtcpParameters = rtcpParameters;
        transceiver.sendEncodingParameters = sendEncodingParameters;
        transceiver.recvEncodingParameters = recvEncodingParameters;

        // Start the RTCRtpReceiver now. The RTPSender is started in
        // setLocalDescription.
        pc._transceive(pc.transceivers[sdpMLineIndex],
            false,
            isNewTrack);
      } else if (description.type === 'answer' && !rejected) {
        transceiver = pc.transceivers[sdpMLineIndex];
        iceGatherer = transceiver.iceGatherer;
        iceTransport = transceiver.iceTransport;
        dtlsTransport = transceiver.dtlsTransport;
        rtpReceiver = transceiver.rtpReceiver;
        sendEncodingParameters = transceiver.sendEncodingParameters;
        localCapabilities = transceiver.localCapabilities;

        pc.transceivers[sdpMLineIndex].recvEncodingParameters =
            recvEncodingParameters;
        pc.transceivers[sdpMLineIndex].remoteCapabilities =
            remoteCapabilities;
        pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;

        if (cands.length && iceTransport.state === 'new') {
          if ((isIceLite || isComplete) &&
              (!usingBundle || sdpMLineIndex === 0)) {
            iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function(candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        if (!usingBundle || sdpMLineIndex === 0) {
          if (iceTransport.state === 'new') {
            iceTransport.start(iceGatherer, remoteIceParameters,
                'controlling');
          }
          if (dtlsTransport.state === 'new') {
            dtlsTransport.start(remoteDtlsParameters);
          }
        }

        // If the offer contained RTX but the answer did not,
        // remove RTX from sendEncodingParameters.
        var commonCapabilities = getCommonCapabilities(
          transceiver.localCapabilities,
          transceiver.remoteCapabilities);

        var hasRtx = commonCapabilities.codecs.filter(function(c) {
          return c.name.toLowerCase() === 'rtx';
        }).length;
        if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
          delete transceiver.sendEncodingParameters[0].rtx;
        }

        pc._transceive(transceiver,
            direction === 'sendrecv' || direction === 'recvonly',
            direction === 'sendrecv' || direction === 'sendonly');

        // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
        if (rtpReceiver &&
            (direction === 'sendrecv' || direction === 'sendonly')) {
          track = rtpReceiver.track;
          if (remoteMsid) {
            if (!streams[remoteMsid.stream]) {
              streams[remoteMsid.stream] = new window.MediaStream();
            }
            addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
            receiverList.push([track, rtpReceiver, streams[remoteMsid.stream]]);
          } else {
            if (!streams.default) {
              streams.default = new window.MediaStream();
            }
            addTrackToStreamAndFireEvent(track, streams.default);
            receiverList.push([track, rtpReceiver, streams.default]);
          }
        } else {
          // FIXME: actually the receiver should be created later.
          delete transceiver.rtpReceiver;
        }
      }
    });

    if (pc._dtlsRole === undefined) {
      pc._dtlsRole = description.type === 'offer' ? 'active' : 'passive';
    }

    pc._remoteDescription = {
      type: description.type,
      sdp: description.sdp
    };
    if (description.type === 'offer') {
      pc._updateSignalingState('have-remote-offer');
    } else {
      pc._updateSignalingState('stable');
    }
    Object.keys(streams).forEach(function(sid) {
      var stream = streams[sid];
      if (stream.getTracks().length) {
        if (pc.remoteStreams.indexOf(stream) === -1) {
          pc.remoteStreams.push(stream);
          var event = new Event('addstream');
          event.stream = stream;
          window.setTimeout(function() {
            pc._dispatchEvent('addstream', event);
          });
        }

        receiverList.forEach(function(item) {
          var track = item[0];
          var receiver = item[1];
          if (stream.id !== item[2].id) {
            return;
          }
          fireAddTrack(pc, track, receiver, [stream]);
        });
      }
    });
    receiverList.forEach(function(item) {
      if (item[2]) {
        return;
      }
      fireAddTrack(pc, item[0], item[1], []);
    });

    // check whether addIceCandidate({}) was called within four seconds after
    // setRemoteDescription.
    window.setTimeout(function() {
      if (!(pc && pc.transceivers)) {
        return;
      }
      pc.transceivers.forEach(function(transceiver) {
        if (transceiver.iceTransport &&
            transceiver.iceTransport.state === 'new' &&
            transceiver.iceTransport.getRemoteCandidates().length > 0) {
          console.warn('Timeout for addRemoteCandidate. Consider sending ' +
              'an end-of-candidates notification');
          transceiver.iceTransport.addRemoteCandidate({});
        }
      });
    }, 4000);

    return Promise.resolve();
  };

  RTCPeerConnection.prototype.close = function() {
    this.transceivers.forEach(function(transceiver) {
      /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */
      if (transceiver.iceTransport) {
        transceiver.iceTransport.stop();
      }
      if (transceiver.dtlsTransport) {
        transceiver.dtlsTransport.stop();
      }
      if (transceiver.rtpSender) {
        transceiver.rtpSender.stop();
      }
      if (transceiver.rtpReceiver) {
        transceiver.rtpReceiver.stop();
      }
    });
    // FIXME: clean up tracks, local streams, remote streams, etc
    this._isClosed = true;
    this._updateSignalingState('closed');
  };

  // Update the signaling state.
  RTCPeerConnection.prototype._updateSignalingState = function(newState) {
    this.signalingState = newState;
    var event = new Event('signalingstatechange');
    this._dispatchEvent('signalingstatechange', event);
  };

  // Determine whether to fire the negotiationneeded event.
  RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
    var pc = this;
    if (this.signalingState !== 'stable' || this.needNegotiation === true) {
      return;
    }
    this.needNegotiation = true;
    window.setTimeout(function() {
      if (pc.needNegotiation) {
        pc.needNegotiation = false;
        var event = new Event('negotiationneeded');
        pc._dispatchEvent('negotiationneeded', event);
      }
    }, 0);
  };

  // Update the ice connection state.
  RTCPeerConnection.prototype._updateIceConnectionState = function() {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      checking: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function(transceiver) {
      if (transceiver.iceTransport && !transceiver.rejected) {
        states[transceiver.iceTransport.state]++;
      }
    });

    newState = 'new';
    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.checking > 0) {
      newState = 'checking';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0) {
      newState = 'connected';
    } else if (states.completed > 0) {
      newState = 'completed';
    }

    if (newState !== this.iceConnectionState) {
      this.iceConnectionState = newState;
      var event = new Event('iceconnectionstatechange');
      this._dispatchEvent('iceconnectionstatechange', event);
    }
  };

  // Update the connection state.
  RTCPeerConnection.prototype._updateConnectionState = function() {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      connecting: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function(transceiver) {
      if (transceiver.iceTransport && transceiver.dtlsTransport &&
          !transceiver.rejected) {
        states[transceiver.iceTransport.state]++;
        states[transceiver.dtlsTransport.state]++;
      }
    });
    // ICETransport.completed and connected are the same for this purpose.
    states.connected += states.completed;

    newState = 'new';
    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.connecting > 0) {
      newState = 'connecting';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0) {
      newState = 'connected';
    }

    if (newState !== this.connectionState) {
      this.connectionState = newState;
      var event = new Event('connectionstatechange');
      this._dispatchEvent('connectionstatechange', event);
    }
  };

  RTCPeerConnection.prototype.createOffer = function() {
    var pc = this;

    if (pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createOffer after close'));
    }

    var numAudioTracks = pc.transceivers.filter(function(t) {
      return t.kind === 'audio';
    }).length;
    var numVideoTracks = pc.transceivers.filter(function(t) {
      return t.kind === 'video';
    }).length;

    // Determine number of audio and video tracks we need to send/recv.
    var offerOptions = arguments[0];
    if (offerOptions) {
      // Reject Chrome legacy constraints.
      if (offerOptions.mandatory || offerOptions.optional) {
        throw new TypeError(
            'Legacy mandatory/optional constraints not supported.');
      }
      if (offerOptions.offerToReceiveAudio !== undefined) {
        if (offerOptions.offerToReceiveAudio === true) {
          numAudioTracks = 1;
        } else if (offerOptions.offerToReceiveAudio === false) {
          numAudioTracks = 0;
        } else {
          numAudioTracks = offerOptions.offerToReceiveAudio;
        }
      }
      if (offerOptions.offerToReceiveVideo !== undefined) {
        if (offerOptions.offerToReceiveVideo === true) {
          numVideoTracks = 1;
        } else if (offerOptions.offerToReceiveVideo === false) {
          numVideoTracks = 0;
        } else {
          numVideoTracks = offerOptions.offerToReceiveVideo;
        }
      }
    }

    pc.transceivers.forEach(function(transceiver) {
      if (transceiver.kind === 'audio') {
        numAudioTracks--;
        if (numAudioTracks < 0) {
          transceiver.wantReceive = false;
        }
      } else if (transceiver.kind === 'video') {
        numVideoTracks--;
        if (numVideoTracks < 0) {
          transceiver.wantReceive = false;
        }
      }
    });

    // Create M-lines for recvonly streams.
    while (numAudioTracks > 0 || numVideoTracks > 0) {
      if (numAudioTracks > 0) {
        pc._createTransceiver('audio');
        numAudioTracks--;
      }
      if (numVideoTracks > 0) {
        pc._createTransceiver('video');
        numVideoTracks--;
      }
    }

    var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId,
        pc._sdpSessionVersion++);
    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      // For each track, create an ice gatherer, ice transport,
      // dtls transport, potentially rtpsender and rtpreceiver.
      var track = transceiver.track;
      var kind = transceiver.kind;
      var mid = transceiver.mid || SDPUtils.generateIdentifier();
      transceiver.mid = mid;

      if (!transceiver.iceGatherer) {
        transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex,
            pc.usingBundle);
      }

      var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
      // filter RTX until additional stuff needed for RTX is implemented
      // in adapter.js
      if (edgeVersion < 15019) {
        localCapabilities.codecs = localCapabilities.codecs.filter(
            function(codec) {
              return codec.name !== 'rtx';
            });
      }
      localCapabilities.codecs.forEach(function(codec) {
        // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
        // by adding level-asymmetry-allowed=1
        if (codec.name === 'H264' &&
            codec.parameters['level-asymmetry-allowed'] === undefined) {
          codec.parameters['level-asymmetry-allowed'] = '1';
        }

        // for subsequent offers, we might have to re-use the payload
        // type of the last offer.
        if (transceiver.remoteCapabilities &&
            transceiver.remoteCapabilities.codecs) {
          transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
            if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() &&
                codec.clockRate === remoteCodec.clockRate) {
              codec.preferredPayloadType = remoteCodec.payloadType;
            }
          });
        }
      });
      localCapabilities.headerExtensions.forEach(function(hdrExt) {
        var remoteExtensions = transceiver.remoteCapabilities &&
            transceiver.remoteCapabilities.headerExtensions || [];
        remoteExtensions.forEach(function(rHdrExt) {
          if (hdrExt.uri === rHdrExt.uri) {
            hdrExt.id = rHdrExt.id;
          }
        });
      });

      // generate an ssrc now, to be used later in rtpSender.send
      var sendEncodingParameters = transceiver.sendEncodingParameters || [{
        ssrc: (2 * sdpMLineIndex + 1) * 1001
      }];
      if (track) {
        // add RTX
        if (edgeVersion >= 15019 && kind === 'video' &&
            !sendEncodingParameters[0].rtx) {
          sendEncodingParameters[0].rtx = {
            ssrc: sendEncodingParameters[0].ssrc + 1
          };
        }
      }

      if (transceiver.wantReceive) {
        transceiver.rtpReceiver = new window.RTCRtpReceiver(
            transceiver.dtlsTransport, kind);
      }

      transceiver.localCapabilities = localCapabilities;
      transceiver.sendEncodingParameters = sendEncodingParameters;
    });

    // always offer BUNDLE and dispose on return if not supported.
    if (pc._config.bundlePolicy !== 'max-compat') {
      sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }
    sdp += 'a=ice-options:trickle\r\n';

    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      sdp += writeMediaSection(transceiver, transceiver.localCapabilities,
          'offer', transceiver.stream, pc._dtlsRole);
      sdp += 'a=rtcp-rsize\r\n';

      if (transceiver.iceGatherer && pc.iceGatheringState !== 'new' &&
          (sdpMLineIndex === 0 || !pc.usingBundle)) {
        transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
          cand.component = 1;
          sdp += 'a=' + SDPUtils.writeCandidate(cand) + '\r\n';
        });

        if (transceiver.iceGatherer.state === 'completed') {
          sdp += 'a=end-of-candidates\r\n';
        }
      }
    });

    var desc = new window.RTCSessionDescription({
      type: 'offer',
      sdp: sdp
    });
    return Promise.resolve(desc);
  };

  RTCPeerConnection.prototype.createAnswer = function() {
    var pc = this;

    if (pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createAnswer after close'));
    }

    if (!(pc.signalingState === 'have-remote-offer' ||
        pc.signalingState === 'have-local-pranswer')) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createAnswer in signalingState ' + pc.signalingState));
    }

    var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId,
        pc._sdpSessionVersion++);
    if (pc.usingBundle) {
      sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }
    sdp += 'a=ice-options:trickle\r\n';

    var mediaSectionsInOffer = SDPUtils.getMediaSections(
        pc._remoteDescription.sdp).length;
    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      if (sdpMLineIndex + 1 > mediaSectionsInOffer) {
        return;
      }
      if (transceiver.rejected) {
        if (transceiver.kind === 'application') {
          if (transceiver.protocol === 'DTLS/SCTP') { // legacy fmt
            sdp += 'm=application 0 DTLS/SCTP 5000\r\n';
          } else {
            sdp += 'm=application 0 ' + transceiver.protocol +
                ' webrtc-datachannel\r\n';
          }
        } else if (transceiver.kind === 'audio') {
          sdp += 'm=audio 0 UDP/TLS/RTP/SAVPF 0\r\n' +
              'a=rtpmap:0 PCMU/8000\r\n';
        } else if (transceiver.kind === 'video') {
          sdp += 'm=video 0 UDP/TLS/RTP/SAVPF 120\r\n' +
              'a=rtpmap:120 VP8/90000\r\n';
        }
        sdp += 'c=IN IP4 0.0.0.0\r\n' +
            'a=inactive\r\n' +
            'a=mid:' + transceiver.mid + '\r\n';
        return;
      }

      // FIXME: look at direction.
      if (transceiver.stream) {
        var localTrack;
        if (transceiver.kind === 'audio') {
          localTrack = transceiver.stream.getAudioTracks()[0];
        } else if (transceiver.kind === 'video') {
          localTrack = transceiver.stream.getVideoTracks()[0];
        }
        if (localTrack) {
          // add RTX
          if (edgeVersion >= 15019 && transceiver.kind === 'video' &&
              !transceiver.sendEncodingParameters[0].rtx) {
            transceiver.sendEncodingParameters[0].rtx = {
              ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
            };
          }
        }
      }

      // Calculate intersection of capabilities.
      var commonCapabilities = getCommonCapabilities(
          transceiver.localCapabilities,
          transceiver.remoteCapabilities);

      var hasRtx = commonCapabilities.codecs.filter(function(c) {
        return c.name.toLowerCase() === 'rtx';
      }).length;
      if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
        delete transceiver.sendEncodingParameters[0].rtx;
      }

      sdp += writeMediaSection(transceiver, commonCapabilities,
          'answer', transceiver.stream, pc._dtlsRole);
      if (transceiver.rtcpParameters &&
          transceiver.rtcpParameters.reducedSize) {
        sdp += 'a=rtcp-rsize\r\n';
      }
    });

    var desc = new window.RTCSessionDescription({
      type: 'answer',
      sdp: sdp
    });
    return Promise.resolve(desc);
  };

  RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
    var pc = this;
    var sections;
    if (candidate && !(candidate.sdpMLineIndex !== undefined ||
        candidate.sdpMid)) {
      return Promise.reject(new TypeError('sdpMLineIndex or sdpMid required'));
    }

    // TODO: needs to go into ops queue.
    return new Promise(function(resolve, reject) {
      if (!pc._remoteDescription) {
        return reject(makeError('InvalidStateError',
            'Can not add ICE candidate without a remote description'));
      } else if (!candidate || candidate.candidate === '') {
        for (var j = 0; j < pc.transceivers.length; j++) {
          if (pc.transceivers[j].rejected) {
            continue;
          }
          pc.transceivers[j].iceTransport.addRemoteCandidate({});
          sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
          sections[j] += 'a=end-of-candidates\r\n';
          pc._remoteDescription.sdp =
              SDPUtils.getDescription(pc._remoteDescription.sdp) +
              sections.join('');
          if (pc.usingBundle) {
            break;
          }
        }
      } else {
        var sdpMLineIndex = candidate.sdpMLineIndex;
        if (candidate.sdpMid) {
          for (var i = 0; i < pc.transceivers.length; i++) {
            if (pc.transceivers[i].mid === candidate.sdpMid) {
              sdpMLineIndex = i;
              break;
            }
          }
        }
        var transceiver = pc.transceivers[sdpMLineIndex];
        if (transceiver) {
          if (transceiver.rejected) {
            return resolve();
          }
          var cand = Object.keys(candidate.candidate).length > 0 ?
              SDPUtils.parseCandidate(candidate.candidate) : {};
          // Ignore Chrome's invalid candidates since Edge does not like them.
          if (cand.protocol === 'tcp' && (cand.port === 0 || cand.port === 9)) {
            return resolve();
          }
          // Ignore RTCP candidates, we assume RTCP-MUX.
          if (cand.component && cand.component !== 1) {
            return resolve();
          }
          // when using bundle, avoid adding candidates to the wrong
          // ice transport. And avoid adding candidates added in the SDP.
          if (sdpMLineIndex === 0 || (sdpMLineIndex > 0 &&
              transceiver.iceTransport !== pc.transceivers[0].iceTransport)) {
            if (!maybeAddCandidate(transceiver.iceTransport, cand)) {
              return reject(makeError('OperationError',
                  'Can not add ICE candidate'));
            }
          }

          // update the remoteDescription.
          var candidateString = candidate.candidate.trim();
          if (candidateString.indexOf('a=') === 0) {
            candidateString = candidateString.substr(2);
          }
          sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
          sections[sdpMLineIndex] += 'a=' +
              (cand.type ? candidateString : 'end-of-candidates')
              + '\r\n';
          pc._remoteDescription.sdp =
              SDPUtils.getDescription(pc._remoteDescription.sdp) +
              sections.join('');
        } else {
          return reject(makeError('OperationError',
              'Can not add ICE candidate'));
        }
      }
      resolve();
    });
  };

  RTCPeerConnection.prototype.getStats = function(selector) {
    if (selector && selector instanceof window.MediaStreamTrack) {
      var senderOrReceiver = null;
      this.transceivers.forEach(function(transceiver) {
        if (transceiver.rtpSender &&
            transceiver.rtpSender.track === selector) {
          senderOrReceiver = transceiver.rtpSender;
        } else if (transceiver.rtpReceiver &&
            transceiver.rtpReceiver.track === selector) {
          senderOrReceiver = transceiver.rtpReceiver;
        }
      });
      if (!senderOrReceiver) {
        throw makeError('InvalidAccessError', 'Invalid selector.');
      }
      return senderOrReceiver.getStats();
    }

    var promises = [];
    this.transceivers.forEach(function(transceiver) {
      ['rtpSender', 'rtpReceiver', 'iceGatherer', 'iceTransport',
          'dtlsTransport'].forEach(function(method) {
            if (transceiver[method]) {
              promises.push(transceiver[method].getStats());
            }
          });
    });
    return Promise.all(promises).then(function(allStats) {
      var results = new Map();
      allStats.forEach(function(stats) {
        stats.forEach(function(stat) {
          results.set(stat.id, stat);
        });
      });
      return results;
    });
  };

  // fix low-level stat names and return Map instead of object.
  var ortcObjects = ['RTCRtpSender', 'RTCRtpReceiver', 'RTCIceGatherer',
    'RTCIceTransport', 'RTCDtlsTransport'];
  ortcObjects.forEach(function(ortcObjectName) {
    var obj = window[ortcObjectName];
    if (obj && obj.prototype && obj.prototype.getStats) {
      var nativeGetstats = obj.prototype.getStats;
      obj.prototype.getStats = function() {
        return nativeGetstats.apply(this)
        .then(function(nativeStats) {
          var mapStats = new Map();
          Object.keys(nativeStats).forEach(function(id) {
            nativeStats[id].type = fixStatsType(nativeStats[id]);
            mapStats.set(id, nativeStats[id]);
          });
          return mapStats;
        });
      };
    }
  });

  // legacy callback shims. Should be moved to adapter.js some days.
  var methods = ['createOffer', 'createAnswer'];
  methods.forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[0] === 'function' ||
          typeof args[1] === 'function') { // legacy
        return nativeMethod.apply(this, [arguments[2]])
        .then(function(description) {
          if (typeof args[0] === 'function') {
            args[0].apply(null, [description]);
          }
        }, function(error) {
          if (typeof args[1] === 'function') {
            args[1].apply(null, [error]);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  methods = ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'];
  methods.forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[1] === 'function' ||
          typeof args[2] === 'function') { // legacy
        return nativeMethod.apply(this, arguments)
        .then(function() {
          if (typeof args[1] === 'function') {
            args[1].apply(null);
          }
        }, function(error) {
          if (typeof args[2] === 'function') {
            args[2].apply(null, [error]);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  // getStats is special. It doesn't have a spec legacy method yet we support
  // getStats(something, cb) without error callbacks.
  ['getStats'].forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[1] === 'function') {
        return nativeMethod.apply(this, arguments)
        .then(function() {
          if (typeof args[1] === 'function') {
            args[1].apply(null);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  return RTCPeerConnection;
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


// Expose public methods.
module.exports = function(window) {
  var navigator = window && window.navigator;

  var shimError_ = function(e) {
    return {
      name: {PermissionDeniedError: 'NotAllowedError'}[e.name] || e.name,
      message: e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name;
      }
    };
  };

  // getUserMedia error shim.
  var origGetUserMedia = navigator.mediaDevices.getUserMedia.
      bind(navigator.mediaDevices);
  navigator.mediaDevices.getUserMedia = function(c) {
    return origGetUserMedia(c).catch(function(e) {
      return Promise.reject(shimError_(e));
    });
  };
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(32);

module.exports = {
  shimGetUserMedia: __webpack_require__(604),
  shimOnTrack: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
            this.removeEventListener('addstream', this._ontrackpoly);
          }
          this.addEventListener('track', this._ontrack = f);
          this.addEventListener('addstream', this._ontrackpoly = function(e) {
            e.stream.getTracks().forEach(function(track) {
              var event = new Event('track');
              event.track = track;
              event.receiver = {track: track};
              event.transceiver = {receiver: event.receiver};
              event.streams = [e.stream];
              this.dispatchEvent(event);
            }.bind(this));
          }.bind(this));
        },
        enumerable: true,
        configurable: true
      });
    }
    if (typeof window === 'object' && window.RTCTrackEvent &&
        ('receiver' in window.RTCTrackEvent.prototype) &&
        !('transceiver' in window.RTCTrackEvent.prototype)) {
      Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get: function() {
          return {receiver: this.receiver};
        }
      });
    }
  },

  shimSourceObject: function(window) {
    // Firefox has supported mozSrcObject since FF22, unprefixed in 42.
    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        // Shim the srcObject property, once, when HTMLMediaElement is found.
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this.mozSrcObject;
          },
          set: function(stream) {
            this.mozSrcObject = stream;
          }
        });
      }
    }
  },

  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    if (typeof window !== 'object' || !(window.RTCPeerConnection ||
        window.mozRTCPeerConnection)) {
      return; // probably media.peerconnection.enabled=false in about:config
    }
    // The RTCPeerConnection object.
    if (!window.RTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        if (browserDetails.version < 38) {
          // .urls is not supported in FF < 38.
          // create RTCIceServers with a single url.
          if (pcConfig && pcConfig.iceServers) {
            var newIceServers = [];
            for (var i = 0; i < pcConfig.iceServers.length; i++) {
              var server = pcConfig.iceServers[i];
              if (server.hasOwnProperty('urls')) {
                for (var j = 0; j < server.urls.length; j++) {
                  var newServer = {
                    url: server.urls[j]
                  };
                  if (server.urls[j].indexOf('turn') === 0) {
                    newServer.username = server.username;
                    newServer.credential = server.credential;
                  }
                  newIceServers.push(newServer);
                }
              } else {
                newIceServers.push(pcConfig.iceServers[i]);
              }
            }
            pcConfig.iceServers = newIceServers;
          }
        }
        return new window.mozRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype =
          window.mozRTCPeerConnection.prototype;

      // wrap static methods. Currently just generateCertificate.
      if (window.mozRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return window.mozRTCPeerConnection.generateCertificate;
          }
        });
      }

      window.RTCSessionDescription = window.mozRTCSessionDescription;
      window.RTCIceCandidate = window.mozRTCIceCandidate;
    }

    // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];
          window.RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });

    // support for addIceCandidate(null or undefined)
    var nativeAddIceCandidate =
        window.RTCPeerConnection.prototype.addIceCandidate;
    window.RTCPeerConnection.prototype.addIceCandidate = function() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };

    // shim getStats with maplike support
    var makeMapStats = function(stats) {
      var map = new Map();
      Object.keys(stats).forEach(function(key) {
        map.set(key, stats[key]);
        map[key] = stats[key];
      });
      return map;
    };

    var modernStatsTypes = {
      inboundrtp: 'inbound-rtp',
      outboundrtp: 'outbound-rtp',
      candidatepair: 'candidate-pair',
      localcandidate: 'local-candidate',
      remotecandidate: 'remote-candidate'
    };

    var nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function(
      selector,
      onSucc,
      onErr
    ) {
      return nativeGetStats.apply(this, [selector || null])
        .then(function(stats) {
          if (browserDetails.version < 48) {
            stats = makeMapStats(stats);
          }
          if (browserDetails.version < 53 && !onSucc) {
            // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
              stats.forEach(function(stat) {
                stat.type = modernStatsTypes[stat.type] || stat.type;
              });
            } catch (e) {
              if (e.name !== 'TypeError') {
                throw e;
              }
              // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
              stats.forEach(function(stat, i) {
                stats.set(i, Object.assign({}, stat, {
                  type: modernStatsTypes[stat.type] || stat.type
                }));
              });
            }
          }
          return stats;
        })
        .then(onSucc, onErr);
    };
  },

  shimSenderGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender)) {
      return;
    }
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
      return;
    }
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) {
      window.RTCPeerConnection.prototype.getSenders = function() {
        var pc = this;
        var senders = origGetSenders.apply(pc, []);
        senders.forEach(function(sender) {
          sender._pc = pc;
        });
        return senders;
      };
    }

    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) {
      window.RTCPeerConnection.prototype.addTrack = function() {
        var sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
      };
    }
    window.RTCRtpSender.prototype.getStats = function() {
      return this.track ? this._pc.getStats(this.track) :
          Promise.resolve(new Map());
    };
  },

  shimReceiverGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender)) {
      return;
    }
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
      return;
    }
    var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) {
      window.RTCPeerConnection.prototype.getReceivers = function() {
        var pc = this;
        var receivers = origGetReceivers.apply(pc, []);
        receivers.forEach(function(receiver) {
          receiver._pc = pc;
        });
        return receivers;
      };
    }
    utils.wrapPeerConnectionEvent(window, 'track', function(e) {
      e.receiver._pc = e.srcElement;
      return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function() {
      return this._pc.getStats(this.track);
    };
  },

  shimRemoveStream: function(window) {
    if (!window.RTCPeerConnection ||
        'removeStream' in window.RTCPeerConnection.prototype) {
      return;
    }
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var pc = this;
      utils.deprecated('removeStream', 'removeTrack');
      this.getSenders().forEach(function(sender) {
        if (sender.track && stream.getTracks().indexOf(sender.track) !== -1) {
          pc.removeTrack(sender);
        }
      });
    };
  },

  shimRTCDataChannel: function(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) {
      window.RTCDataChannel = window.DataChannel;
    }
  },

  shimGetDisplayMedia: function(window, preferredMediaSource) {
    if (!window.navigator || !window.navigator.mediaDevices ||
        'getDisplayMedia' in window.navigator.mediaDevices) {
      return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function(constraints) {
      if (!(constraints && constraints.video)) {
        var err = new DOMException('getDisplayMedia without video ' +
            'constraints is undefined');
        err.name = 'NotFoundError';
        // from https://heycam.github.io/webidl/#idl-DOMException-error-names
        err.code = 8;
        return Promise.reject(err);
      }
      if (constraints.video === true) {
        constraints.video = {mediaSource: preferredMediaSource};
      } else {
        constraints.video.mediaSource = preferredMediaSource;
      }
      return window.navigator.mediaDevices.getUserMedia(constraints);
    };
    window.navigator.getDisplayMedia = function(constraints) {
      utils.deprecated('navigator.getDisplayMedia',
          'navigator.mediaDevices.getDisplayMedia');
      return window.navigator.mediaDevices.getDisplayMedia(constraints);
    };
  }
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(32);
var logging = utils.log;

// Expose public methods.
module.exports = function(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;
  var MediaStreamTrack = window && window.MediaStreamTrack;

  var shimError_ = function(e) {
    return {
      name: {
        InternalError: 'NotReadableError',
        NotSupportedError: 'TypeError',
        PermissionDeniedError: 'NotAllowedError',
        SecurityError: 'NotAllowedError'
      }[e.name] || e.name,
      message: {
        'The operation is insecure.': 'The request is not allowed by the ' +
        'user agent or the platform in the current context.'
      }[e.message] || e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  // getUserMedia constraints shim.
  var getUserMedia_ = function(constraints, onSuccess, onError) {
    var constraintsToFF37_ = function(c) {
      if (typeof c !== 'object' || c.require) {
        return c;
      }
      var require = [];
      Object.keys(c).forEach(function(key) {
        if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
          return;
        }
        var r = c[key] = (typeof c[key] === 'object') ?
            c[key] : {ideal: c[key]};
        if (r.min !== undefined ||
            r.max !== undefined || r.exact !== undefined) {
          require.push(key);
        }
        if (r.exact !== undefined) {
          if (typeof r.exact === 'number') {
            r. min = r.max = r.exact;
          } else {
            c[key] = r.exact;
          }
          delete r.exact;
        }
        if (r.ideal !== undefined) {
          c.advanced = c.advanced || [];
          var oc = {};
          if (typeof r.ideal === 'number') {
            oc[key] = {min: r.ideal, max: r.ideal};
          } else {
            oc[key] = r.ideal;
          }
          c.advanced.push(oc);
          delete r.ideal;
          if (!Object.keys(r).length) {
            delete c[key];
          }
        }
      });
      if (require.length) {
        c.require = require;
      }
      return c;
    };
    constraints = JSON.parse(JSON.stringify(constraints));
    if (browserDetails.version < 38) {
      logging('spec: ' + JSON.stringify(constraints));
      if (constraints.audio) {
        constraints.audio = constraintsToFF37_(constraints.audio);
      }
      if (constraints.video) {
        constraints.video = constraintsToFF37_(constraints.video);
      }
      logging('ff37: ' + JSON.stringify(constraints));
    }
    return navigator.mozGetUserMedia(constraints, onSuccess, function(e) {
      onError(shimError_(e));
    });
  };

  // Returns the result of getUserMedia as a Promise.
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      getUserMedia_(constraints, resolve, reject);
    });
  };

  // Shim for mediaDevices on older versions.
  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {getUserMedia: getUserMediaPromise_,
      addEventListener: function() { },
      removeEventListener: function() { }
    };
  }
  navigator.mediaDevices.enumerateDevices =
      navigator.mediaDevices.enumerateDevices || function() {
        return new Promise(function(resolve) {
          var infos = [
            {kind: 'audioinput', deviceId: 'default', label: '', groupId: ''},
            {kind: 'videoinput', deviceId: 'default', label: '', groupId: ''}
          ];
          resolve(infos);
        });
      };

  if (browserDetails.version < 41) {
    // Work around http://bugzil.la/1169665
    var orgEnumerateDevices =
        navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);
    navigator.mediaDevices.enumerateDevices = function() {
      return orgEnumerateDevices().then(undefined, function(e) {
        if (e.name === 'NotFoundError') {
          return [];
        }
        throw e;
      });
    };
  }
  if (browserDetails.version < 49) {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      return origGetUserMedia(c).then(function(stream) {
        // Work around https://bugzil.la/802326
        if (c.audio && !stream.getAudioTracks().length ||
            c.video && !stream.getVideoTracks().length) {
          stream.getTracks().forEach(function(track) {
            track.stop();
          });
          throw new DOMException('The object can not be found here.',
                                 'NotFoundError');
        }
        return stream;
      }, function(e) {
        return Promise.reject(shimError_(e));
      });
    };
  }
  if (!(browserDetails.version > 55 &&
      'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
    var remap = function(obj, a, b) {
      if (a in obj && !(b in obj)) {
        obj[b] = obj[a];
        delete obj[a];
      }
    };

    var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      if (typeof c === 'object' && typeof c.audio === 'object') {
        c = JSON.parse(JSON.stringify(c));
        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
      }
      return nativeGetUserMedia(c);
    };

    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      var nativeGetSettings = MediaStreamTrack.prototype.getSettings;
      MediaStreamTrack.prototype.getSettings = function() {
        var obj = nativeGetSettings.apply(this, arguments);
        remap(obj, 'mozAutoGainControl', 'autoGainControl');
        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
        return obj;
      };
    }

    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
      MediaStreamTrack.prototype.applyConstraints = function(c) {
        if (this.kind === 'audio' && typeof c === 'object') {
          c = JSON.parse(JSON.stringify(c));
          remap(c, 'autoGainControl', 'mozAutoGainControl');
          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
        }
        return nativeApplyConstraints.apply(this, [c]);
      };
    }
  }
  navigator.getUserMedia = function(constraints, onSuccess, onError) {
    if (browserDetails.version < 44) {
      return getUserMedia_(constraints, onSuccess, onError);
    }
    // Replace Firefox 44+'s deprecation warning with unprefixed version.
    utils.deprecated('navigator.getUserMedia',
        'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

var utils = __webpack_require__(32);

module.exports = {
  shimLocalStreamsAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getLocalStreams = function() {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        return this._localStreams;
      };
    }
    if (!('getStreamById' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getStreamById = function(id) {
        var result = null;
        if (this._localStreams) {
          this._localStreams.forEach(function(stream) {
            if (stream.id === id) {
              result = stream;
            }
          });
        }
        if (this._remoteStreams) {
          this._remoteStreams.forEach(function(stream) {
            if (stream.id === id) {
              result = stream;
            }
          });
        }
        return result;
      };
    }
    if (!('addStream' in window.RTCPeerConnection.prototype)) {
      var _addTrack = window.RTCPeerConnection.prototype.addTrack;
      window.RTCPeerConnection.prototype.addStream = function(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        if (this._localStreams.indexOf(stream) === -1) {
          this._localStreams.push(stream);
        }
        var pc = this;
        stream.getTracks().forEach(function(track) {
          _addTrack.call(pc, track, stream);
        });
      };

      window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
        if (stream) {
          if (!this._localStreams) {
            this._localStreams = [stream];
          } else if (this._localStreams.indexOf(stream) === -1) {
            this._localStreams.push(stream);
          }
        }
        return _addTrack.call(this, track, stream);
      };
    }
    if (!('removeStream' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.removeStream = function(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        var index = this._localStreams.indexOf(stream);
        if (index === -1) {
          return;
        }
        this._localStreams.splice(index, 1);
        var pc = this;
        var tracks = stream.getTracks();
        this.getSenders().forEach(function(sender) {
          if (tracks.indexOf(sender.track) !== -1) {
            pc.removeTrack(sender);
          }
        });
      };
    }
  },
  shimRemoteStreamsAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this._remoteStreams ? this._remoteStreams : [];
      };
    }
    if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
        get: function() {
          return this._onaddstream;
        },
        set: function(f) {
          if (this._onaddstream) {
            this.removeEventListener('addstream', this._onaddstream);
          }
          this.addEventListener('addstream', this._onaddstream = f);
        }
      });
      var origSetRemoteDescription =
          window.RTCPeerConnection.prototype.setRemoteDescription;
      window.RTCPeerConnection.prototype.setRemoteDescription = function() {
        var pc = this;
        if (!this._onaddstreampoly) {
          this.addEventListener('track', this._onaddstreampoly = function(e) {
            e.streams.forEach(function(stream) {
              if (!pc._remoteStreams) {
                pc._remoteStreams = [];
              }
              if (pc._remoteStreams.indexOf(stream) >= 0) {
                return;
              }
              pc._remoteStreams.push(stream);
              var event = new Event('addstream');
              event.stream = stream;
              pc.dispatchEvent(event);
            });
          });
        }
        return origSetRemoteDescription.apply(pc, arguments);
      };
    }
  },
  shimCallbacksAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    var prototype = window.RTCPeerConnection.prototype;
    var createOffer = prototype.createOffer;
    var createAnswer = prototype.createAnswer;
    var setLocalDescription = prototype.setLocalDescription;
    var setRemoteDescription = prototype.setRemoteDescription;
    var addIceCandidate = prototype.addIceCandidate;

    prototype.createOffer = function(successCallback, failureCallback) {
      var options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      var promise = createOffer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };

    prototype.createAnswer = function(successCallback, failureCallback) {
      var options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      var promise = createAnswer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };

    var withCallback = function(description, successCallback, failureCallback) {
      var promise = setLocalDescription.apply(this, [description]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;

    withCallback = function(description, successCallback, failureCallback) {
      var promise = setRemoteDescription.apply(this, [description]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;

    withCallback = function(candidate, successCallback, failureCallback) {
      var promise = addIceCandidate.apply(this, [candidate]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
  },
  shimGetUserMedia: function(window) {
    var navigator = window && window.navigator;

    if (!navigator.getUserMedia) {
      if (navigator.webkitGetUserMedia) {
        navigator.getUserMedia = navigator.webkitGetUserMedia.bind(navigator);
      } else if (navigator.mediaDevices &&
          navigator.mediaDevices.getUserMedia) {
        navigator.getUserMedia = function(constraints, cb, errcb) {
          navigator.mediaDevices.getUserMedia(constraints)
          .then(cb, errcb);
        }.bind(navigator);
      }
    }
  },
  shimRTCIceServerUrls: function(window) {
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    var OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function(pcConfig, pcConstraints) {
      if (pcConfig && pcConfig.iceServers) {
        var newIceServers = [];
        for (var i = 0; i < pcConfig.iceServers.length; i++) {
          var server = pcConfig.iceServers[i];
          if (!server.hasOwnProperty('urls') &&
              server.hasOwnProperty('url')) {
            utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
            server = JSON.parse(JSON.stringify(server));
            server.urls = server.url;
            delete server.url;
            newIceServers.push(server);
          } else {
            newIceServers.push(pcConfig.iceServers[i]);
          }
        }
        pcConfig.iceServers = newIceServers;
      }
      return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ('generateCertificate' in window.RTCPeerConnection) {
      Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get: function() {
          return OrigPeerConnection.generateCertificate;
        }
      });
    }
  },
  shimTrackEventTransceiver: function(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === 'object' && window.RTCPeerConnection &&
        ('receiver' in window.RTCTrackEvent.prototype) &&
        // can't check 'transceiver' in window.RTCTrackEvent.prototype, as it is
        // defined for some reason even when window.RTCTransceiver is not.
        !window.RTCTransceiver) {
      Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get: function() {
          return {receiver: this.receiver};
        }
      });
    }
  },

  shimCreateOfferLegacy: function(window) {
    var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function(offerOptions) {
      var pc = this;
      if (offerOptions) {
        if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
          // support bit values
          offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
        }
        var audioTransceiver = pc.getTransceivers().find(function(transceiver) {
          return transceiver.sender.track &&
              transceiver.sender.track.kind === 'audio';
        });
        if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
          if (audioTransceiver.direction === 'sendrecv') {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection('sendonly');
            } else {
              audioTransceiver.direction = 'sendonly';
            }
          } else if (audioTransceiver.direction === 'recvonly') {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection('inactive');
            } else {
              audioTransceiver.direction = 'inactive';
            }
          }
        } else if (offerOptions.offerToReceiveAudio === true &&
            !audioTransceiver) {
          pc.addTransceiver('audio');
        }


        if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
          // support bit values
          offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
        }
        var videoTransceiver = pc.getTransceivers().find(function(transceiver) {
          return transceiver.sender.track &&
              transceiver.sender.track.kind === 'video';
        });
        if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
          if (videoTransceiver.direction === 'sendrecv') {
            videoTransceiver.setDirection('sendonly');
          } else if (videoTransceiver.direction === 'recvonly') {
            videoTransceiver.setDirection('inactive');
          }
        } else if (offerOptions.offerToReceiveVideo === true &&
            !videoTransceiver) {
          pc.addTransceiver('video');
        }
      }
      return origCreateOffer.apply(pc, arguments);
    };
  }
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var SDPUtils = __webpack_require__(276);
var utils = __webpack_require__(32);

module.exports = {
  shimRTCIceCandidate: function(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || (window.RTCIceCandidate && 'foundation' in
        window.RTCIceCandidate.prototype)) {
      return;
    }

    var NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function(args) {
      // Remove the a= which shouldn't be part of the candidate string.
      if (typeof args === 'object' && args.candidate &&
          args.candidate.indexOf('a=') === 0) {
        args = JSON.parse(JSON.stringify(args));
        args.candidate = args.candidate.substr(2);
      }

      if (args.candidate && args.candidate.length) {
        // Augment the native candidate with the parsed fields.
        var nativeCandidate = new NativeRTCIceCandidate(args);
        var parsedCandidate = SDPUtils.parseCandidate(args.candidate);
        var augmentedCandidate = Object.assign(nativeCandidate,
            parsedCandidate);

        // Add a serializer that does not serialize the extra attributes.
        augmentedCandidate.toJSON = function() {
          return {
            candidate: augmentedCandidate.candidate,
            sdpMid: augmentedCandidate.sdpMid,
            sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
            usernameFragment: augmentedCandidate.usernameFragment,
          };
        };
        return augmentedCandidate;
      }
      return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;

    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    utils.wrapPeerConnectionEvent(window, 'icecandidate', function(e) {
      if (e.candidate) {
        Object.defineProperty(e, 'candidate', {
          value: new window.RTCIceCandidate(e.candidate),
          writable: 'false'
        });
      }
      return e;
    });
  },

  // shimCreateObjectURL must be called before shimSourceObject to avoid loop.

  shimCreateObjectURL: function(window) {
    var URL = window && window.URL;

    if (!(typeof window === 'object' && window.HTMLMediaElement &&
          'srcObject' in window.HTMLMediaElement.prototype &&
        URL.createObjectURL && URL.revokeObjectURL)) {
      // Only shim CreateObjectURL using srcObject if srcObject exists.
      return undefined;
    }

    var nativeCreateObjectURL = URL.createObjectURL.bind(URL);
    var nativeRevokeObjectURL = URL.revokeObjectURL.bind(URL);
    var streams = new Map(), newId = 0;

    URL.createObjectURL = function(stream) {
      if ('getTracks' in stream) {
        var url = 'polyblob:' + (++newId);
        streams.set(url, stream);
        utils.deprecated('URL.createObjectURL(stream)',
            'elem.srcObject = stream');
        return url;
      }
      return nativeCreateObjectURL(stream);
    };
    URL.revokeObjectURL = function(url) {
      nativeRevokeObjectURL(url);
      streams.delete(url);
    };

    var dsc = Object.getOwnPropertyDescriptor(window.HTMLMediaElement.prototype,
                                              'src');
    Object.defineProperty(window.HTMLMediaElement.prototype, 'src', {
      get: function() {
        return dsc.get.apply(this);
      },
      set: function(url) {
        this.srcObject = streams.get(url) || null;
        return dsc.set.apply(this, [url]);
      }
    });

    var nativeSetAttribute = window.HTMLMediaElement.prototype.setAttribute;
    window.HTMLMediaElement.prototype.setAttribute = function() {
      if (arguments.length === 2 &&
          ('' + arguments[0]).toLowerCase() === 'src') {
        this.srcObject = streams.get(arguments[1]) || null;
      }
      return nativeSetAttribute.apply(this, arguments);
    };
  },

  shimMaxMessageSize: function(window) {
    if (window.RTCSctpTransport || !window.RTCPeerConnection) {
      return;
    }
    var browserDetails = utils.detectBrowser(window);

    if (!('sctp' in window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
        get: function() {
          return typeof this._sctp === 'undefined' ? null : this._sctp;
        }
      });
    }

    var sctpInDescription = function(description) {
      var sections = SDPUtils.splitSections(description.sdp);
      sections.shift();
      return sections.some(function(mediaSection) {
        var mLine = SDPUtils.parseMLine(mediaSection);
        return mLine && mLine.kind === 'application'
            && mLine.protocol.indexOf('SCTP') !== -1;
      });
    };

    var getRemoteFirefoxVersion = function(description) {
      // TODO: Is there a better solution for detecting Firefox?
      var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
      if (match === null || match.length < 2) {
        return -1;
      }
      var version = parseInt(match[1], 10);
      // Test for NaN (yes, this is ugly)
      return version !== version ? -1 : version;
    };

    var getCanSendMaxMessageSize = function(remoteIsFirefox) {
      // Every implementation we know can send at least 64 KiB.
      // Note: Although Chrome is technically able to send up to 256 KiB, the
      //       data does not reach the other peer reliably.
      //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
      var canSendMaxMessageSize = 65536;
      if (browserDetails.browser === 'firefox') {
        if (browserDetails.version < 57) {
          if (remoteIsFirefox === -1) {
            // FF < 57 will send in 16 KiB chunks using the deprecated PPID
            // fragmentation.
            canSendMaxMessageSize = 16384;
          } else {
            // However, other FF (and RAWRTC) can reassemble PPID-fragmented
            // messages. Thus, supporting ~2 GiB when sending.
            canSendMaxMessageSize = 2147483637;
          }
        } else if (browserDetails.version < 60) {
          // Currently, all FF >= 57 will reset the remote maximum message size
          // to the default value when a data channel is created at a later
          // stage. :(
          // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
          canSendMaxMessageSize =
            browserDetails.version === 57 ? 65535 : 65536;
        } else {
          // FF >= 60 supports sending ~2 GiB
          canSendMaxMessageSize = 2147483637;
        }
      }
      return canSendMaxMessageSize;
    };

    var getMaxMessageSize = function(description, remoteIsFirefox) {
      // Note: 65536 bytes is the default value from the SDP spec. Also,
      //       every implementation we know supports receiving 65536 bytes.
      var maxMessageSize = 65536;

      // FF 57 has a slightly incorrect default remote max message size, so
      // we need to adjust it here to avoid a failure when sending.
      // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
      if (browserDetails.browser === 'firefox'
           && browserDetails.version === 57) {
        maxMessageSize = 65535;
      }

      var match = SDPUtils.matchPrefix(description.sdp, 'a=max-message-size:');
      if (match.length > 0) {
        maxMessageSize = parseInt(match[0].substr(19), 10);
      } else if (browserDetails.browser === 'firefox' &&
                  remoteIsFirefox !== -1) {
        // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
      }
      return maxMessageSize;
    };

    var origSetRemoteDescription =
        window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function() {
      var pc = this;
      pc._sctp = null;

      if (sctpInDescription(arguments[0])) {
        // Check if the remote is FF.
        var isFirefox = getRemoteFirefoxVersion(arguments[0]);

        // Get the maximum message size the local peer is capable of sending
        var canSendMMS = getCanSendMaxMessageSize(isFirefox);

        // Get the maximum message size of the remote peer.
        var remoteMMS = getMaxMessageSize(arguments[0], isFirefox);

        // Determine final maximum message size
        var maxMessageSize;
        if (canSendMMS === 0 && remoteMMS === 0) {
          maxMessageSize = Number.POSITIVE_INFINITY;
        } else if (canSendMMS === 0 || remoteMMS === 0) {
          maxMessageSize = Math.max(canSendMMS, remoteMMS);
        } else {
          maxMessageSize = Math.min(canSendMMS, remoteMMS);
        }

        // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
        // attribute.
        var sctp = {};
        Object.defineProperty(sctp, 'maxMessageSize', {
          get: function() {
            return maxMessageSize;
          }
        });
        pc._sctp = sctp;
      }

      return origSetRemoteDescription.apply(pc, arguments);
    };
  },

  shimSendThrowTypeError: function(window) {
    if (!(window.RTCPeerConnection &&
        'createDataChannel' in window.RTCPeerConnection.prototype)) {
      return;
    }

    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831

    function wrapDcSend(dc, pc) {
      var origDataChannelSend = dc.send;
      dc.send = function() {
        var data = arguments[0];
        var length = data.length || data.size || data.byteLength;
        if (dc.readyState === 'open' &&
            pc.sctp && length > pc.sctp.maxMessageSize) {
          throw new TypeError('Message too large (can send a maximum of ' +
            pc.sctp.maxMessageSize + ' bytes)');
        }
        return origDataChannelSend.apply(dc, arguments);
      };
    }
    var origCreateDataChannel =
      window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function() {
      var pc = this;
      var dataChannel = origCreateDataChannel.apply(pc, arguments);
      wrapDcSend(dataChannel, pc);
      return dataChannel;
    };
    utils.wrapPeerConnectionEvent(window, 'datachannel', function(e) {
      wrapDcSend(e.channel, e.target);
      return e;
    });
  }
};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = extendES5Native;
// We can't use ES6 classes with babel because babel invokes the super
// constructor without the new keyword. This triggers an error when used
// with RTCPeerConnection and other native classes.

const getOwnProperties = target => {
  const properties = {};
  Object.getOwnPropertyNames(target).forEach(key => {
    properties[key] = Object.getOwnPropertyDescriptor(target, key);
  });
  return properties;
};
function extendES5Native(ParentClass) {
  function ChildClass() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const instance = new ParentClass(...args);
    Object.setPrototypeOf(instance, ChildClass.prototype);
    return instance;
  }
  ChildClass.prototype = Object.create(ParentClass.prototype);
  Object.defineProperties(ChildClass.prototype, getOwnProperties(ParentClass.prototype));
  Object.keys(ParentClass).forEach(staticKey => {
    ChildClass[staticKey] = ParentClass[staticKey];
  });
  return ChildClass;
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _isPageHideSupported = _interopRequireDefault(__webpack_require__(609));
function isDomReady() {
  // if there is no document, how is the document object model ready?
  return typeof document === 'undefined' || document.readyState === 'complete' || document.readyState === 'interactive' && document.body;
}
let unloaded = false;
const domStateFactory = function domStateFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const windowMock = deps.window || window;
  const isPageHideSupported = deps.isPageHideSupported || _isPageHideSupported.default;
  const domState = {
    isDomLoaded: isDomReady,
    isDomUnloaded() {
      return unloaded;
    },
    whenUnloaded: new Promise(resolve => {
      if (typeof windowMock !== 'undefined') {
        const pagehideOrUnloadHandler = () => {
          unloaded = true;
          resolve();
        };
        const pagehideOrUnload = isPageHideSupported() ? 'pagehide' : 'unload';
        windowMock.addEventListener(pagehideOrUnload, pagehideOrUnloadHandler);
      }
    }),
    whenLoaded: new Promise(resolve => {
      if (isDomReady()) {
        resolve();
        return;
      }
      const load = () => {
        document.removeEventListener('DOMContentLoaded', load);
        document.removeEventListener('load', load);
        domState.emit('load');
        resolve();
      };
      document.addEventListener('DOMContentLoaded', load);
      document.addEventListener('load', load);
    })
  };
  (0, _eventing.default)(domState);
  return domState;
};
var _default = domStateFactory;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const windowMock = deps.window || window;
  return 'onpagehide' in windowMock;
};
exports.default = _default;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(81),
    assignMergeValue = __webpack_require__(280),
    baseFor = __webpack_require__(257),
    baseMergeDeep = __webpack_require__(611),
    isObject = __webpack_require__(11),
    keysIn = __webpack_require__(55),
    safeGet = __webpack_require__(281);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(280),
    cloneBuffer = __webpack_require__(195),
    cloneTypedArray = __webpack_require__(204),
    copyArray = __webpack_require__(56),
    initCloneObject = __webpack_require__(205),
    isArguments = __webpack_require__(65),
    isArray = __webpack_require__(14),
    isArrayLikeObject = __webpack_require__(151),
    isBuffer = __webpack_require__(66),
    isFunction = __webpack_require__(20),
    isObject = __webpack_require__(11),
    isPlainObject = __webpack_require__(141),
    isTypedArray = __webpack_require__(88),
    safeGet = __webpack_require__(281),
    toPlainObject = __webpack_require__(612);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    keysIn = __webpack_require__(55);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = normalizeConstraintInput;
var _assert = _interopRequireDefault(__webpack_require__(159));
var _capitalize = _interopRequireDefault(__webpack_require__(282));
var _log = _interopRequireDefault(__webpack_require__(1));
var _browserRejectsOptionalMandatory = _interopRequireDefault(__webpack_require__(287));
var _hasAudioScreenShareSupport = _interopRequireDefault(__webpack_require__(288));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-confusing-arrow */

const defaultLogging = (0, _log.default)('normalizeConstraintInput');
const validResolutions = {
  '320x240': {
    width: 320,
    height: 240
  },
  '320x180': {
    width: 320,
    height: 180
  },
  '640x480': {
    width: 640,
    height: 480
  },
  '640x360': {
    width: 640,
    height: 360
  },
  '1280x720': {
    width: 1280,
    height: 720
  },
  '1280x960': {
    width: 1280,
    height: 960
  },
  '1920x1080': {
    width: 1920,
    height: 1080
  }
};
const validFrameRates = [1, 7, 15, 30];
function getLogging(opt) {
  return opt._inject && opt._inject.logging || defaultLogging;
}
function lookupParam(name, param, lookup, possibilities, logging) {
  if (param === undefined) {
    return undefined;
  }
  const result = lookup(param);
  if (!result) {
    logging.warn(`Invalid ${name} passed to the Publisher. Got: ${param}, expecting one of ${possibilities}`);
  }
  return result;
}
function normalizeMediaParams(mediaType, opt) {
  const logging = getLogging(opt);
  const publish = (() => {
    const param = opt[`publish${(0, _capitalize.default)(mediaType)}`];
    if (param !== undefined) {
      return Boolean(param);
    }
    return true;
  })();
  let source = (() => {
    const param = opt[`${mediaType}Source`];
    if (param === undefined) {
      return true;
    }
    if (param === null || param === false) {
      return false;
    }
    if (typeof param === 'object') {
      if (opt[`isCustom${(0, _capitalize.default)(mediaType)}Track`]) {
        return false;
      }
      if (typeof param.deviceId !== 'string') {
        logging.warn(`Invalid ${mediaType}Source passed to Publisher. Expected either a device ID or ` + 'device.');
        return true;
      }
      return param.deviceId;
    }
    if (typeof param !== 'string') {
      logging.warn(`Ignoring invalid ${mediaType}Source parameter`);
      return true;
    }
    return param;
  })();
  if (mediaType === 'audio' && opt.isScreenSharing && !_hasAudioScreenShareSupport.default && source !== false) {
    if (opt.audioSource) {
      getLogging(opt).warn('Invalid audioSource passed to Publisher - when using screen sharing no audioSource may be ' + 'used');
    }
    source = false;
  }
  return {
    source,
    publish
  };
}
function fixChromeBug707118(env, frameRate) {
  // OPENTOK-32592: 1fps with facetime camera causes chrome to lock up intermittently. Workaround
  // is just to use 2fps instead for now.
  // https://bugs.chromium.org/p/chromium/issues/detail?id=707118
  if (env.name === 'Chrome' && env.userAgent.indexOf('Mac OS X') !== -1 && frameRate === 1) {
    return 2;
  }
  return frameRate;
}
const validFacingModes = ['user', 'environment', 'left', 'right'];
const normaliseFacingMode = (facingMode, opt) => {
  if (facingMode === undefined || validFacingModes.indexOf(facingMode) >= 0) {
    return facingMode;
  }
  const logging = getLogging(opt);

  // Ignore facingMode if its defined but an invalid value
  logging.warn(`Invalid facingMode passed to Publisher. Expected one of: ${validFacingModes.join(', ')}`);
  return undefined;
};
function normalizeConstraintInput(opt) {
  const logging = getLogging(opt);
  const env = opt.env || {};
  const isScreenSharing = opt.isScreenSharing,
    isCustomAudioTrack = opt.isCustomAudioTrack,
    isCustomVideoTrack = opt.isCustomVideoTrack;
  if (isScreenSharing && !_browserRejectsOptionalMandatory.default) {
    (0, _assert.default)(opt.usingOptionalMandatoryStyle, 'Screensharing only uses optional-mandatory constraints right now');
  }

  // Defaults audio processing constraints to true
  ['echoCancellation', 'autoGainControl', 'noiseSuppression'].forEach(constraint => {
    if (opt[constraint] !== false) {
      Object.assign(opt, {
        [constraint]: true
      });
    }
  });
  return {
    isScreenSharing,
    isCustomAudioTrack,
    isCustomVideoTrack,
    // These will be of the form { source: string | boolean, publish: boolean }
    audio: normalizeMediaParams('audio', opt),
    video: normalizeMediaParams('video', opt),
    usingOptionalMandatoryStyle: opt.usingOptionalMandatoryStyle,
    enableRenegotiation: opt.enableRenegotiation,
    enableStereo: opt.enableStereo,
    noiseSuppression: opt.noiseSuppression,
    autoGainControl: opt.autoGainControl,
    echoCancellation: opt.echoCancellation,
    disableAudioProcessing: opt.disableAudioProcessing,
    videoDimensions: lookupParam('resolution', opt.resolution, param => validResolutions[param], `"${Object.keys(validResolutions).join('", "')}"`, logging),
    frameRate: fixChromeBug707118(env, lookupParam('frameRate', opt.frameRate, param => validFrameRates.indexOf(param) !== -1 ? param : undefined, validFrameRates.join(','), logging)),
    maxResolution: function () {
      if (opt.maxResolution === undefined) {
        return isScreenSharing ? {
          width: 1920,
          height: 1920
        } : undefined;
      }
      const result = {
        width: opt.maxResolution.width,
        height: opt.maxResolution.height
      };
      Object.keys(result).forEach(dimensionName => {
        const dim = result[dimensionName];
        if (typeof dim !== 'number' || dim > 1920) {
          logging.warn(`Invalid maxResolution passed to the Publisher. maxResolution.${dimensionName} must be less than or equal to 1920`);
          result[dimensionName] = 1920;
        }
      });
      return result;
    }(),
    facingMode: normaliseFacingMode(opt.facingMode, opt)
  };
}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Promise) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(616);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(617);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(24), __webpack_require__(2)))

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(619),
    hasUnicode = __webpack_require__(285),
    stringToArray = __webpack_require__(286),
    toString = __webpack_require__(61);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(284);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 620 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = ['screen', 'window', 'tab', 'browser', 'application'];
exports.default = _default;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _once = _interopRequireDefault(__webpack_require__(52));
var _some = _interopRequireDefault(__webpack_require__(625));
var _map = _interopRequireDefault(__webpack_require__(628));
var _log = _interopRequireDefault(__webpack_require__(1));
var _logLevels = _interopRequireDefault(__webpack_require__(130));
var _StaticConfig = _interopRequireDefault(__webpack_require__(48));
const StaticConfig = (0, _StaticConfig.default)();
const PATH_TO_RELEASE_NOTES = '/opentok/webrtc/docs/js/release-notes.html';
const staticConfig = StaticConfig.onlyLocal();
const logging = (0, _log.default)('setLogLevel');
const BANNER_HEADER = `
 ██████╗ ██████╗ ███████╗███╗   ██╗████████╗ ██████╗ ██╗  ██╗
██╔═══██╗██╔══██╗██╔════╝████╗  ██║╚══██╔══╝██╔═══██╗██║ ██╔╝
██║   ██║██████╔╝█████╗  ██╔██╗ ██║   ██║   ██║   ██║█████╔╝
██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║   ██║   ██║   ██║██╔═██╗
╚██████╔╝██║     ███████╗██║ ╚████║   ██║   ╚██████╔╝██║  ██╗
 ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝`;
const printHeader = (0, _once.default)(() => {
  logging.info(`%c${BANNER_HEADER}`, 'font-family: "Fire Code", Courier, "Courier New", Consolas, "DejaVu Sans Mono"');
  logging.info(`OpenTok JS SDK ${staticConfig.version}`);
  logging.info(`Release notes: ${staticConfig.websiteUrl}${PATH_TO_RELEASE_NOTES}`);
  logging.info(`Known issues: ${staticConfig.websiteUrl}${PATH_TO_RELEASE_NOTES}l#knownIssues`);
});
function setLogLevel(level) {
  if (level === undefined || !(0, _some.default)(_logLevels.default, {
    priority: level
  }) && level !== 0) {
    const validLevelDescription = (0, _map.default)(_logLevels.default, (x, key) => `OT.${key.toUpperCase()} = ${x.priority}`).join(', ');
    logging.error(`level must be one of: OT.NONE = 0, ${validLevelDescription}`);
    logging.warn('Using OT.WARN instead');
    level = _logLevels.default.warn.priority; // eslint-disable-line no-param-reassign
  }

  _log.default.setLogLevel(level);
  if (level >= _logLevels.default.debug.priority) {
    printHeader();
  }
  const link = 'https://www.npmjs.com/package/debug#browser-support';
  logging.info(`OpenTok JS SDK now uses the debug library. More info at ${link}`);
  logging.info(`Changed log level to: ${level}`);
  return level;
}

// set default level
setLogLevel(staticConfig.debug ? _logLevels.default.debug.priority : _logLevels.default.warn.priority);
var _default = setLogLevel;
/**
  * Sets the API log level.
  * <p>
  * Calling <code>OT.setLogLevel()</code> sets the log level for runtime log messages that
  * are the Vonage Video API library generates. The default value for the log level is
  * <code>OT.ERROR</code>.
  * </p>
  * <p>
  * The Vonage Video API JavaScript library displays log messages in the debugger console (such as
  * Firebug), if one exists.
  * </p>
  * <p>
  * The following example logs the session ID to the console, by calling <code>OT.log()</code>.
  * The code also logs an error message when it attempts to publish a stream before you have
  * connected to the session (by calling <code>Session.connect()</code>).
  * </p>
  * <pre>
  * OT.setLogLevel(OT.LOG);
  * session = OT.initSession(sessionId);
  * OT.log(sessionId);
  * publisher = OT.initPublisher("publishContainer");
  * session.publish(publisher);
  * </pre>
  *
  * @param {Number} logLevel The degree of logging desired by the developer:
  *
  * <p>
  * <ul>
  *   <li>
  *     <code>OT.NONE</code> &#151; API logging is disabled.
  *   </li>
  *   <li>
  *     <code>OT.ERROR</code> &#151; Logging of errors only.
  *   </li>
  *   <li>
  *     <code>OT.WARN</code> &#151; Logging of warnings and errors.
  *   </li>
  *   <li>
  *     <code>OT.INFO</code> &#151; Logging of other useful information, in addition to
  *     warnings and errors.
  *   </li>
  *   <li>
  *     <code>OT.LOG</code> &#151; Logging of <code>OT.log()</code> messages, in addition
  *     to Vonage Video API info, warning,
  *     and error messages.
  *   </li>
  *   <li>
  *     <code>OT.DEBUG</code> &#151; Fine-grained logging of all API actions, as well as
  *     <code>OT.log()</code> messages.
  *   </li>
  * </ul>
  * </p>
  *
  * @name OT.setLogLevel
  * @memberof OT
  * @function
  * @see <a href="#log">OT.log()</a>
  */
/**
  * Sends a string to the debugger console. However, the function only logs to the console
  * if you have set the log level to <code>OT.LOG</code> or <code>OT.DEBUG</code>,
  * by calling <code>OT.setLogLevel(OT.LOG)</code> or <code>OT.setLogLevel(OT.DEBUG)</code>.
  *
  * @param {String} message The string to log.
  *
  * @name OT.log
  * @memberof OT
  * @function
  * @see <a href="#setLogLevel">OT.setLogLevel()</a>
  */
exports.default = _default;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(100);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

module.exports = before;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(250),
    baseIteratee = __webpack_require__(37),
    baseSome = __webpack_require__(626),
    isArray = __webpack_require__(14),
    isIterateeCall = __webpack_require__(128);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(290);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(29);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    baseIteratee = __webpack_require__(37),
    baseMap = __webpack_require__(629),
    isArray = __webpack_require__(14);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(290),
    isArrayLike = __webpack_require__(29);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = fixBackgroundImageURI;
// When setting the background image uri of a publisher or subscriber, we allow the use of a raw
// data blob of a png, which requires the prefix 'data:image/png;base64,'. This function
// encapsulates that transformation.
function fixBackgroundImageURI(bgImgURI) {
  if (bgImgURI.substr(0, 5) !== 'http:' && bgImgURI.substr(0, 6) !== 'https:' && bgImgURI.substr(0, 22) !== 'data:image/png;base64,') {
    return `data:image/png;base64,${bgImgURI}`;
  }
  return bgImgURI;
}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Style;
var _cloneDeep = _interopRequireDefault(__webpack_require__(62));
var _log = _interopRequireDefault(__webpack_require__(1));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable prefer-const */

const logging = (0, _log.default)('Style');
function Style(initalStyles, onStyleChange) {
  const styleApi = this;
  const _styles = {};

  // Styles with null here means every value is valid for that style
  const _validStyleValues = {
    buttonDisplayMode: ['auto', 'mini', 'mini-auto', 'off', 'on'],
    nameDisplayMode: ['auto', 'off', 'on'],
    audioLevelDisplayMode: ['auto', 'off', 'on'],
    showSettingsButton: [true, false],
    showSpeakerButton: null,
    showMicButton: [true, false],
    backgroundImageURI: null,
    showControlBar: [true, false],
    // 'showArchiveStatus' is kept for backwards compatibility.
    // 'archiveStatusDisplayMode' is the documented style name.
    showArchiveStatus: [true, false],
    archiveStatusDisplayMode: ['auto', 'off', 'on'],
    videoDisabledDisplayMode: ['auto', 'off', 'on'],
    audioBlockedDisplayMode: ['auto', 'off', 'on']
  };

  // Validates the style +key+ and also whether +value+ is valid for +key+
  const isValidStyle = function isValidStyle(key, value) {
    const valueSpec = _validStyleValues[key];
    if (valueSpec === undefined) {
      return false;
    }
    if (valueSpec === null) {
      return true;
    }
    return valueSpec.indexOf(value) !== -1;
  };
  const castValue = function castValue(value) {
    switch (value) {
      case 'true':
        return true;
      case 'false':
        return false;
      default:
        return value;
    }
  };

  // Returns a copy of the styles.
  styleApi.getAll = function () {
    return (0, _cloneDeep.default)(_styles);
  };
  styleApi.get = function (key) {
    if (key) {
      return _styles[key];
    }

    // We haven't been asked for any specific key, just return the lot
    return styleApi.getAll();
  };

  // *note:* this will not trigger onStyleChange if +silent+ is truthy
  styleApi.setAll = function (newStyles, silent) {
    Object.keys(newStyles).forEach(key => {
      styleApi.set(key, newStyles[key], silent);
    });
    return styleApi;
  };

  // *note:* this will not trigger onStyleChange if +silent+ is truthy
  styleApi.set = function (key, value, silent) {
    logging.debug(`setStyle: ${key.toString()}`);
    let oldValue;
    const newValue = castValue(value);
    if (!isValidStyle(key, newValue)) {
      logging.warn(`Style.set::Invalid style property passed ${key} : ${newValue}`);
      return styleApi;
    }
    oldValue = _styles[key];
    if (newValue !== oldValue) {
      _styles[key] = newValue;
      if (!silent) {
        onStyleChange(key, value, oldValue);
      }
    }
    return styleApi;
  };
  if (initalStyles) {
    styleApi.setAll(initalStyles, true);
  }
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _isSecureContextRequired = _interopRequireDefault(__webpack_require__(294));
const hasGetUserMediaSupport = () => {
  // Except for Safari, iOS WebKit apps don't support GUM
  if (_env.default.isIosWebView) {
    return false;
  }
  if ((0, _isSecureContextRequired.default)()) {
    return true;
  }
  return (typeof window !== undefined ? window : global).navigator.mediaDevices && (typeof window !== undefined ? window : global).navigator.mediaDevices.getUserMedia || (typeof window !== undefined ? window : global).navigator.webkitGetUserMedia || (typeof window !== undefined ? window : global).navigator.mozGetUserMedia;
};

// Indicates whether this client supports the getUserMedia API.
var _default = () => Boolean(_env.default.name !== 'Node' && hasGetUserMediaSupport());
exports.default = _default;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
// TODO Remove all PeerConnection stuff, that belongs to the messaging layer not the Media layer.
// Indicates whether this client supports the PeerConnection
// API.
//
// Chrome Issues:
// * The explicit prototype.addStream check is because webkitRTCPeerConnection was
// partially implemented, but not functional, in Chrome 22.
//
// Firefox Issues:
// * No real support before Firefox 19
// * Firefox 19 has issues with generating Offers.
// * Firefox 20 doesn't interoperate with Chrome.
//
const hasPeerConnectionCapability = () => {
  if (_env.default.name === 'Node') {
    return false;
  } else if (typeof (typeof window !== undefined ? window : global).webkitRTCPeerConnection === 'function' && !!(typeof window !== undefined ? window : global).webkitRTCPeerConnection.prototype.addTrack) {
    return true;
  } else if (typeof (typeof window !== undefined ? window : global).RTCPeerConnection === 'function') {
    return true;
  } else if (typeof (typeof window !== undefined ? window : global).mozRTCPeerConnection === 'function' && _env.default.version > 20.0) {
    return true;
  }
  return false;
};
var _default = hasPeerConnectionCapability;
exports.default = _default;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Indicates if the client supports WebSockets.
var _default = (typeof window !== undefined ? window : global).WebSocket !== undefined;
exports.default = _default;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _events = _interopRequireDefault(__webpack_require__(12));
let Modal = /*#__PURE__*/function (_Events) {
  (0, _inheritsLoose2.default)(Modal, _Events);
  function Modal(innerHTML, _temp) {
    var _this;
    let _ref = _temp === void 0 ? {} : _temp,
      _ref$destroyOnClose = _ref.destroyOnClose,
      destroyOnClose = _ref$destroyOnClose === void 0 ? true : _ref$destroyOnClose;
    _this = _Events.call(this) || this;
    _this.modalDiv = document.createElement('div');
    _this.modalDiv.classList.add('OT_ModalDialog');
    _this.modalDiv.innerHTML = innerHTML;
    const closeBtnEls = _this.modalDiv.querySelectorAll('[role=OT_close]');
    [].forEach.call(closeBtnEls, closeBtnEl => closeBtnEl.addEventListener('click', event => {
      event.preventDefault();
      _this.close();
    }));
    _this.close();
    document.body.appendChild(_this.modalDiv);
    if (destroyOnClose) {
      _this.on('closed', () => _this.destroy());
    }
    return _this;
  }
  var _proto = Modal.prototype;
  _proto.open = function open() {
    this.modalDiv.style.display = 'block';
    this.emit('opened');
  };
  _proto.close = function close() {
    this.modalDiv.style.display = 'none';
    this.emit('closed');
  };
  _proto.destroy = function destroy() {
    this.modalDiv.innerHTML = '';
    this.modalDiv.parentNode.removeChild(this.modalDiv);
    this.emit('destroyed');
  };
  _proto.el = function el(query) {
    return this.modalDiv.querySelector(query);
  };
  return Modal;
}(_events.default);
exports.default = Modal;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _analytics = _interopRequireDefault(__webpack_require__(31));
/* eslint-disable global-require */
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const env = deps.env || _env.default;
  const analytics = deps.analytics || new _analytics.default();
  analytics.logEvent({
    action: 'UserAgentParsing',
    variation: 'Attempt',
    payload: {
      userAgent: env.userAgent
    }
  });
  analytics.logEvent({
    action: 'UserAgentParsing',
    variation: env.error ? 'Failure' : 'Success',
    payload: {
      userAgent: env.userAgent
    }
  });
};
exports.default = _default;

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "<div id=\"tb_alert\"><div id=\"section-supported-install\" class=\"OT_alert\"><div class=\"OT_alert-exclamation OT_alert-check\">✓</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Supported Browser\">Supported Browser</div><div class=\"OT_alert-body\">The video component of this application is supported by your device's browser.</div></div><div id=\"section-unsupported-install\" class=\"OT_alert\"><div class=\"OT_alert-exclamation\">!</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Incompatible Browser\">Incompatible Browser</div><div class=\"OT_alert-body\">The video component of this application requires <a target=\"_blank\" href=\"https://www.google.com/chrome/\">Google Chrome</a>, <a target=\"_blank\" href=\"http://www.mozilla.org/firefox\">Firefox</a>, <a target=\"_blank\" href=\"https://www.microsoft.com/en-us/edge\">Edge</a>, or <a target=\"_blank\" href=\"https://www.apple.com/safari/\">Safari</a>.</div></div><div id=\"section-upgrade-install\" class=\"OT_alert\"><div class=\"OT_alert-exclamation\">!</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Incompatible Browser\">Incompatible Browser</div><div class=\"OT_alert-body\">The video component of this application requires a newer version of <a target=\"_blank\" href=\"https://www.google.com/chrome/\">Google Chrome</a>, <a target=\"_blank\" href=\"http://www.mozilla.org/firefox\">Firefox</a>, <a target=\"_blank\" href=\"https://www.microsoft.com/en-us/edge\">Edge</a>, <a target=\"_blank\" href=\"https://www.opera.com/download\">Opera</a>, or <a target=\"_blank\" href=\"https://www.apple.com/safari/\">Safari</a>.</div><div class=\"continue-text\"><a href=\"#\" role=\"OT_close\">Continue at my own risk.</a></div></div><div id=\"section-mobile-upgrade-install\" class=\"OT_alert\"><div class=\"OT_alert-exclamation\">!</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Incompatible Browser\">Incompatible Browser</div><div class=\"OT_alert-body\">The video component of this application requires a newer version of <a target=\"_blank\" href=\"https://www.google.com/chrome/\">Google Chrome</a>, <a target=\"_blank\" href=\"https://www.mozilla.org/en-US/firefox/browsers/mobile/\">Firefox</a>, or <a target=\"_blank\" href=\"https://www.apple.com/safari/\">Safari</a>.</div><div class=\"continue-text\"><a href=\"#\" role=\"OT_close\">Continue at my own risk.</a></div></div><div id=\"section-mobile-unsupported-install\" class=\"OT_alert\"><div class=\"OT_alert-exclamation\">!</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Incompatible Browser\">Incompatible Browser</div><div class=\"OT_alert-body\">The video component of this application is not supported on your mobile device's browser at this time.</div></div><div id=\"section-mobile-supported-install\" class=\"OT_alert\"><div class=\"OT_alert-exclamation OT_alert-check\">✓</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Supported Browser\">Supported Browser</div><div class=\"OT_alert-body\">The video component of this application is supported by your mobile device's browser.</div></div></div>";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _StaticConfig = _interopRequireDefault(__webpack_require__(48));
const staticConfig = (0, _StaticConfig.default)().onlyLocal();
const isSupportedBrowser = browser => {
  const supportedBrowsers = Object.keys(staticConfig.minimumVersion);
  return supportedBrowsers.includes(browser);
};
const isSupportedBrowserVersion = (browser, version) => {
  const minimumSupportedBrowserVersion = staticConfig.minimumVersion[browser];
  return minimumSupportedBrowserVersion <= version;
};
var _default = (browserName, browserVersion) => {
  const browser = browserName.toLowerCase();
  const supportedBrowser = isSupportedBrowser(browser);
  const supportedBrowserVersion = isSupportedBrowserVersion(browser, browserVersion);
  return {
    isBrowserAndVersionSupported: () => supportedBrowser && supportedBrowserVersion,
    isSupportedButOld: () => supportedBrowser && !supportedBrowserVersion
  };
};
exports.default = _default;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 640 */
/***/ (function(module, exports) {

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(295);

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

module.exports = _construct;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

module.exports = (promise, onFinally) => {
  onFinally = onFinally || (() => {});
  return promise.then(val => new Promise(resolve => {
    resolve(onFinally());
  }).then(() => val), err => new Promise(resolve => {
    resolve(onFinally());
  }).then(() => {
    throw err;
  }));
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(16);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(60),
    last = __webpack_require__(645),
    parent = __webpack_require__(646),
    toKey = __webpack_require__(50);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(104),
    baseSlice = __webpack_require__(284);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(141);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(37),
    isArrayLike = __webpack_require__(29),
    keys = __webpack_require__(34);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(101),
    arrayIncludes = __webpack_require__(99),
    arrayIncludesWith = __webpack_require__(150),
    cacheHas = __webpack_require__(102),
    createSet = __webpack_require__(650),
    setToArray = __webpack_require__(103);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(201),
    noop = __webpack_require__(242),
    setToArray = __webpack_require__(103);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _memoize = _interopRequireDefault(__webpack_require__(129));
var _generateKey = _interopRequireDefault(__webpack_require__(301));
var _arrayBufferToHex = _interopRequireDefault(__webpack_require__(652));
const createExtractSenderId = function createExtractSenderId(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$memoize = _ref.memoize,
    memoize = _ref$memoize === void 0 ? _memoize.default : _ref$memoize,
    _ref$generateKey = _ref.generateKey,
    generateKey = _ref$generateKey === void 0 ? _generateKey.default : _ref$generateKey,
    _ref$arrayBufferToHex = _ref.arrayBufferToHex,
    arrayBufferToHex = _ref$arrayBufferToHex === void 0 ? _arrayBufferToHex.default : _ref$arrayBufferToHex;
  const extractSenderId = memoize( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
      var sessionId, connectionId, key, exportedKey, trimmedKeyBuffer, keyAsHex;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            sessionId = _ref2.sessionId, connectionId = _ref2.connectionId;
            _context.next = 3;
            return generateKey(sessionId, connectionId);
          case 3:
            key = _context.sent;
            _context.next = 6;
            return window.crypto.subtle.exportKey('raw', key);
          case 6:
            exportedKey = _context.sent;
            trimmedKeyBuffer = [...new Uint8Array(exportedKey)]; // We trim to workaround javascript's issues with large integers
            trimmedKeyBuffer.splice(6);
            keyAsHex = arrayBufferToHex(trimmedKeyBuffer);
            return _context.abrupt("return", parseInt(keyAsHex, 16));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(),
  // Memoize cache resolver function
  _ref4 => {
    let sessionId = _ref4.sessionId,
      connectionId = _ref4.connectionId;
    return `${sessionId}${connectionId}`;
  });
  return extractSenderId;
};
var _default = createExtractSenderId;
exports.default = _default;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Converts an ArrayBuffer to a hexadecimal string
// For example: `[0xa, 0xbe, 0xef]` -> `0x0abeef`
var _default = arrayBuffer => {
  if (!Array.isArray(arrayBuffer)) {
    return null;
  }

  // Converts `[0xa, 0xbe, 0xef]` -> `0abeef`
  // (Notice that the `0x` prefix is missing)
  const hex = arrayBuffer.map(x => x.toString(16).padStart(2, '0')).join('');
  return `0x${hex}`;
};
exports.default = _default;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _log = _interopRequireDefault(__webpack_require__(1));
const logger = (0, _log.default)('hasValidPeerConnection');
function checkPeerConnection(pc) {
  return new Promise(resolve => {
    pc.addEventListener('signalingstatechange', () => resolve(true));
    pc.createOffer({
      offerToReceiveAudio: 1
    }).then(offer => pc.setLocalDescription(offer)).then(() => setTimeout(() => {
      resolve(false);
    }, 1000));
  });
}
function hasValidPeerConnection(_x) {
  return _hasValidPeerConnection.apply(this, arguments);
}
function _hasValidPeerConnection() {
  _hasValidPeerConnection = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(PeerConnection) {
    var pc;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          pc = new PeerConnection({
            iceServers: []
          });
          _context.next = 8;
          break;
        case 4:
          _context.prev = 4;
          _context.t0 = _context["catch"](0);
          logger.error('Error occurred creating PeerConnection', _context.t0);
          return _context.abrupt("return", false);
        case 8:
          _context.prev = 8;
          _context.next = 11;
          return checkPeerConnection(pc);
        case 11:
          _context.next = 18;
          break;
        case 13:
          _context.prev = 13;
          _context.t1 = _context["catch"](8);
          logger.error('Error occurred checking the validity of the PeerConnection', _context.t1);
          try {
            pc.close();
          } catch (e) {
            // ignore errors
          }
          return _context.abrupt("return", false);
        case 18:
          _context.prev = 18;
          pc.close();
          _context.next = 26;
          break;
        case 22:
          _context.prev = 22;
          _context.t2 = _context["catch"](18);
          logger.error('Error occurred closing PeerConnection', _context.t2);
          return _context.abrupt("return", false);
        case 26:
          return _context.abrupt("return", true);
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 4], [8, 13], [18, 22]]);
  }));
  return _hasValidPeerConnection.apply(this, arguments);
}
var _default = hasValidPeerConnection;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = createPeerConnection;
var _clone = _interopRequireDefault(__webpack_require__(41));
var _log = _interopRequireDefault(__webpack_require__(1));
var _env = _interopRequireDefault(__webpack_require__(3));
var _filterIceServers = _interopRequireDefault(__webpack_require__(655));
var _shouldUsePlanBSDP = _interopRequireDefault(__webpack_require__(76));
const logging = (0, _log.default)('createPeerConnection');
function createPeerConnection(_ref) {
  let window = _ref.window,
    originalConfig = _ref.config,
    constraints = _ref.constraints;
  logging.debug('called');
  const config = (0, _clone.default)(originalConfig);
  config.iceServers = (0, _filterIceServers.default)(_env.default, config.iceServers);
  if ((0, _shouldUsePlanBSDP.default)()) {
    config.sdpSemantics = 'plan-b';
  }
  const pc = new window.RTCPeerConnection(config, constraints);
  return Promise.resolve(pc);
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = filterIceServers;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _omit = _interopRequireDefault(__webpack_require__(297));
const filters = {
  Edge(iceServers) {
    let foundTurn = false;
    return iceServers.map(server => {
      if (!server) {
        return undefined;
      }
      const urls = server.urls || server.url && [server.url];
      if (!urls) {
        return undefined;
      }
      const filteredUrls = urls.filter(url => {
        const turnOk = url.indexOf('turn:') === 0 && url.indexOf('transport=udp') !== -1 && url.indexOf('turn:[') === -1 && !foundTurn;
        if (turnOk) {
          foundTurn = true;
          return true;
        }
        return url.indexOf('stun:') === 0;
      });
      if (filteredUrls.length === 0) {
        return undefined;
      }
      return (0, _assign.default)((0, _omit.default)(server, ['url', 'urls']), {
        urls: filteredUrls
      });
    }).filter(server => server !== undefined);
  },
  Safari(iceServers) {
    return iceServers.map(server => {
      if (server.urls !== undefined && server.url === undefined) {
        return server;
      }
      const urls = server.urls || server.url && [server.url];
      return (0, _assign.default)((0, _omit.default)(server, ['url', 'urls']), {
        urls
      });
    });
  }
};
function filterIceServers(env, iceServers) {
  let browserName = env.name;
  if (env.isEdge) {
    browserName = env.isLegacyEdge ? 'Edge' : 'ChromiumEdge';
  }
  const filter = filters[browserName];
  if (filter) {
    return filter(iceServers);
  }
  return iceServers;
}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _env = _interopRequireDefault(__webpack_require__(3));
const profiles = {
  h264: {
    baseline: '42001f',
    constBaseline: '42e01f'
  }
};
const replaceProfileId = _ref => {
  let sdp = _ref.sdp,
    from = _ref.from,
    to = _ref.to;
  return sdp.replace(new RegExp(`^(a=fmtp:\\d+ .*profile-level-id=)${from}`, 'gmi'), `$1${to}`);
};
var _default = {
  local: {
    offer: function offer(_temp, sdpParam) {
      let _ref2 = _temp === void 0 ? {} : _temp,
        numSimulcastStreams = _ref2.numSimulcastStreams,
        audioBitrate = _ref2.audioBitrate,
        _ref2$priorityVideoCo = _ref2.priorityVideoCodec,
        priorityVideoCodec = _ref2$priorityVideoCo === void 0 ? '' : _ref2$priorityVideoCo,
        _ref2$codecFlags = _ref2.codecFlags,
        codecFlags = _ref2$codecFlags === void 0 ? {} : _ref2$codecFlags,
        _ref2$enableStereo = _ref2.enableStereo,
        enableStereo = _ref2$enableStereo === void 0 ? false : _ref2$enableStereo,
        _ref2$enableDtx = _ref2.enableDtx,
        enableDtx = _ref2$enableDtx === void 0 ? false : _ref2$enableDtx,
        _ref2$replaceBaseline = _ref2.replaceBaselineProfile,
        replaceBaselineProfile = _ref2$replaceBaseline === void 0 ? false : _ref2$replaceBaseline,
        _ref2$removeVideoOrie = _ref2.removeVideoOrientation,
        removeVideoOrientation = _ref2$removeVideoOrie === void 0 ? false : _ref2$removeVideoOrie;
      // The SDP may have excessive or stray SSRCs.  For example, SSRCs not
      // associated with a SIM group.  We remove these before we munge, else
      // the offer may grow too large.
      // See OPENTOK-41253
      let sdp = _sdp_helpers.default.filterExcessSSRCs(sdpParam);
      if (numSimulcastStreams > 1) {
        sdp = _sdp_helpers.default.enableSimulcast(sdp, numSimulcastStreams);
      }
      if (audioBitrate > 0) {
        sdp = _sdp_helpers.default.setAudioBitrate(sdp, audioBitrate);
      }
      if (removeVideoOrientation) {
        sdp = _sdp_helpers.default.removeVideoOrientation(sdp);
      }
      sdp = _sdp_helpers.default.modifyReceiveStereo(sdp, false);
      sdp = _sdp_helpers.default.modifySendStereo(sdp, Boolean(enableStereo));
      sdp = _sdp_helpers.default.modifyDtx(sdp, Boolean(enableDtx));
      if (!_env.default.isLegacyEdge) {
        Object.keys(codecFlags).filter(codec => codecFlags[codec] === false).forEach(codec => {
          sdp = _sdp_helpers.default.removeVideoCodec(sdp, codec);
        });
      }
      if (priorityVideoCodec === 'vp9' && !_env.default.isLegacyEdge) {
        // If vp9 is prioritized, vp8 should be the fallback
        sdp = _sdp_helpers.default.reprioritizeVideoCodec(sdp, 'vp8', 'top');
        sdp = _sdp_helpers.default.reprioritizeVideoCodec(sdp, 'vp9', 'top');
      } else if (priorityVideoCodec && !_env.default.isLegacyEdge) {
        sdp = _sdp_helpers.default.reprioritizeVideoCodec(sdp, priorityVideoCodec, 'top');
      } else if (priorityVideoCodec !== 'h264') {
        sdp = _sdp_helpers.default.reprioritizeVideoCodec(sdp, 'h264', 'bottom');
      }
      let remoteSdp = sdp;
      if (replaceBaselineProfile) {
        remoteSdp = replaceProfileId({
          sdp: remoteSdp,
          from: profiles.h264.baseline,
          to: profiles.h264.constBaseline
        });
      }
      return {
        local: sdp,
        remote: remoteSdp
      };
    },
    answer: function answer(_temp2, sdpParam) {
      let _ref3 = _temp2 === void 0 ? {} : _temp2,
        audioBitrate = _ref3.audioBitrate,
        codecFlags = _ref3.codecFlags,
        _ref3$enableStereo = _ref3.enableStereo,
        enableStereo = _ref3$enableStereo === void 0 ? false : _ref3$enableStereo,
        _ref3$enableDtx = _ref3.enableDtx,
        enableDtx = _ref3$enableDtx === void 0 ? false : _ref3$enableDtx,
        _ref3$replaceBaseline = _ref3.replaceBaselineProfile,
        replaceBaselineProfile = _ref3$replaceBaseline === void 0 ? false : _ref3$replaceBaseline,
        sourceStreamId = _ref3.sourceStreamId;
      let sdp = sdpParam;
      if (audioBitrate > 0) {
        sdp = _sdp_helpers.default.setAudioBitrate(sdp, audioBitrate);
      }
      sdp = _sdp_helpers.default.modifyReceiveStereo(sdp, Boolean(enableStereo));
      sdp = _sdp_helpers.default.modifySendStereo(sdp, false);
      sdp = _sdp_helpers.default.modifyDtx(sdp, Boolean(enableDtx));
      if (sourceStreamId === 'MANTIS' && _sdp_helpers.default.getSetupRole(sdp) === 'passive') {
        sdp = _sdp_helpers.default.setSetupRole(sdp, 'active');
      }
      if (codecFlags) {
        Object.keys(codecFlags).filter(codec => codecFlags[codec] === false).forEach(codec => {
          sdp = _sdp_helpers.default.removeVideoCodec(sdp, codec);
        });
      }
      let remoteSdp = sdp;
      if (replaceBaselineProfile) {
        remoteSdp = replaceProfileId({
          sdp: remoteSdp,
          from: profiles.h264.baseline,
          to: profiles.h264.constBaseline
        });
      }
      return {
        local: sdp,
        remote: remoteSdp
      };
    }
  },
  remote: {
    offer: (_ref4, sdpParam) => {
      let _ref4$replaceBaseline = _ref4.replaceBaselineProfile,
        replaceBaselineProfile = _ref4$replaceBaseline === void 0 ? false : _ref4$replaceBaseline;
      let sdp = sdpParam;
      if (sdp.indexOf('a=rtcp-fb') === -1) {
        const rtcpFbLine = 'a=rtcp-fb:* ccm fir\r\na=rtcp-fb:* nack ';
        sdp = sdp.replace(/^m=video(.*)$/gmi, `m=video$1\r\n${rtcpFbLine}`);
      }
      if (replaceBaselineProfile) {
        sdp = replaceProfileId({
          sdp,
          from: profiles.h264.constBaseline,
          to: profiles.h264.baseline
        });
      }
      return {
        local: sdp
      };
    },
    answer: function answer(_temp3, sdpParam) {
      let _ref5 = _temp3 === void 0 ? {} : _temp3,
        audioBitrate = _ref5.audioBitrate,
        _ref5$replaceBaseline = _ref5.replaceBaselineProfile,
        replaceBaselineProfile = _ref5$replaceBaseline === void 0 ? false : _ref5$replaceBaseline;
      let sdp = sdpParam;
      if (audioBitrate > 0) {
        sdp = _sdp_helpers.default.setAudioBitrate(sdp, audioBitrate);
      }
      if (replaceBaselineProfile) {
        sdp = replaceProfileId({
          sdp,
          from: profiles.h264.constBaseline,
          to: profiles.h264.baseline
        });
      }
      return {
        local: sdp
      };
    }
  }
};
exports.default = _default;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(43),
    copyArray = __webpack_require__(56),
    getTag = __webpack_require__(45),
    isArrayLike = __webpack_require__(29),
    isString = __webpack_require__(303),
    iteratorToArray = __webpack_require__(658),
    mapToArray = __webpack_require__(251),
    setToArray = __webpack_require__(103),
    stringToArray = __webpack_require__(286),
    values = __webpack_require__(304);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),
/* 658 */
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = (peerConnection, completion) => {
  let stats = [];
  let error = null;
  if (typeof peerConnection.getReceivers === 'function') {
    const audioTrack = peerConnection.getReceivers().find(r => r.track.kind === 'audio');
    if (audioTrack) {
      stats = audioTrack.getSynchronizationSources();
    }
  } else {
    error = new Error('peerConnection does not support getReceivers function');
  }
  if (completion) {
    completion(error, stats);
  }
};
exports.default = _default;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _promisify = _interopRequireDefault(__webpack_require__(662));
// @todo enable the following disabled rules see OPENTOK-31136 for more info

/*
 * Process incoming Ice Candidates from a remote connection.
 *
 * @constructor
 * @private
 *
 * @param {PeerConection} peerConnection The PeerConnection we want to add the
 * Ice Candidates to.
 *
 * @description The Ice Candidates cannot be processed until the PeerConnection
 * has local and remote descriptions, if candidates are added too early they
 * will be put in a pending list. Once the PeerConnection is ready the pending
 * candidates will be applied.
 *
 * **note:** We assume that the PeerConnection has implemented the promisified
 * versions of addIceCandidate.
 *
 *
 * @example
 *
 *  const iceProcessor = new IceCandidateProcessor(pc);
 *  iceProcessor.process(iceMessage1);
 *  iceProcessor.process(iceMessage2);
 *  iceProcessor.process(iceMessage3);
 *
 *
 */
const IceCandidateProcessor = function IceCandidateProcessor(peerConnection) {
  this.pending = [];
  this._processBinding = this.maybeProcessPending.bind(this);
  if (peerConnection) {
    this.setPeerConnection(peerConnection);
  }
};
IceCandidateProcessor.prototype.setPeerConnection = function setPeerConnection(peerConnection) {
  if (this.pc) {
    throw new Error('Peer connection already set');
  }
  this.pc = peerConnection;
  this._forwardIceCandidate = (0, _promisify.default)(this.pc, 'addIceCandidate');
  this.pc.addEventListener('signalingstatechange', this._processBinding);
  this.maybeProcessPending();
};

/**
 * Returns true if the PeerConnection is ready to accept IceCandidates.
 *
 * @return {Boolean} True if IceCandidates can be applied, false otherwise
 *
 * @method #canAddCandidates
 * @memberof IceCandidateProcessor
 *
 */
IceCandidateProcessor.prototype.canAddCandidates = function canAddCandidates() {
  // localDescription and removeDescription are nullable, so you would expect
  // that they would be null when those descriptions have not yet been applied
  // Chrome (as of 48) seems to instead give you a RTCSessionDescription with
  // type and sdp properties set to "".
  //
  // Because of this we need to ensure that type exists and contains something.
  //
  // We first check that the peer connection is not closed to prevent
  // Firefox from throwing an InvalidStateError. See OPENTOK-29358
  //
  return !!(this.pc && this.pc.iceConnectionState !== 'closed' && this.pc.remoteDescription && this.pc.remoteDescription.type && this.pc.localDescription && this.pc.localDescription.type);
};

/**
 * Add an RTCIceCandidate to the PeerConnection. If the PeerConnection is ready
 * it will be applied immediately, otherwise it will be buffered until later.
 *
 * @param {RTCIceCandidate} iceCandidate The candidate to add.
 *
 * @returns {Promise} A promise that is resolved when the candidate is applied.
 *
 * @method #addIceCandidate
 * @memberof IceCandidateProcessor
 *
 */
IceCandidateProcessor.prototype.addIceCandidate = function addIceCandidate(iceCandidate) {
  if (this.canAddCandidates()) {
    return this._forwardIceCandidate(iceCandidate);
  }
  const pending = this.pending;
  return new Promise((resolve, reject) => {
    pending.push({
      iceCandidate,
      resolve,
      reject
    });
  });
};

/**
 * Called to attempt to process any pending candidates.
 *
 * @description This will be called automatically when needed so there's no
 * reason to call it yourself. You totally could, but surely you have better
 * things to do?
 *
 * @param {RTCIceCandidate} iceCandidate The candidate to add.
 *
 * @returns {Promise} A promise that is resolved when the candidate is applied.
 *
 * @method #addIceCandidate
 * @memberof IceCandidateProcessor
 *
 */
IceCandidateProcessor.prototype.maybeProcessPending = function maybeProcessPending() {
  if (this.canAddCandidates()) {
    this.process();
  }
};
IceCandidateProcessor.prototype.process = function process() {
  while (this.pending.length) {
    const pending = this.pending.shift();
    this._forwardIceCandidate(pending.iceCandidate).then(pending.resolve).catch(pending.reject);
  }
};
IceCandidateProcessor.prototype.destroy = function destroy() {
  if (this.pc) {
    this.pc.removeEventListener('signalingstatechange', this._processBinding);
  }
  this._processBinding = null;
  this.pc = null;
};
var _default = IceCandidateProcessor;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

exports.__esModule = true;
exports.default = promisify;
// Adapts a function that returns or promise or takes success and error
// callbacks, and returns a function that always returns a promise.

// This is used to provide backwards compatibility for WebRTC implementations,
// which used to use success and error callbacks, and now return promises.

function promisify(context, methodName) {
  const method = context[methodName];
  return function (input) {
    return new Promise((resolve, reject) => {
      const result = method.apply(context, [input, resolve, reject]);
      if (result && typeof result.then === 'function') {
        resolve(result);
      }
    });
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = offerProcessor;
var _log = _interopRequireDefault(__webpack_require__(1));
var _env = _interopRequireDefault(__webpack_require__(3));
var _applySdpTransform = _interopRequireDefault(__webpack_require__(167));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _testSupportVideo = _interopRequireDefault(__webpack_require__(664));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

const logging = (0, _log.default)('offerProcessor');

// Attempt to completely process +offer+. This will:
// * set the offer as the remote description
// * create an answer and
// * set the new answer as the location description
//
// If there are no issues, the +success+ callback will be executed on completion.
// Errors during any step will result in the +failure+ callback being executed.
//
function offerProcessor(peerConnection, RTCPeerConnection, RTCSessionDescription, NativeRTCSessionDescription, sdpTransforms, offer, codecFlags, p2p, success, failure, onVideoSupported, replaceBaselineProfile, sourceStreamId) {
  const generateErrorCallback = (message, prefix) => errorReason => {
    logging.error(message);
    logging.error(errorReason);
    if (failure) {
      failure(message, errorReason, prefix);
    }
  };
  const setLocalDescription = answer => {
    const enableStereo = _sdp_helpers.default.hasSendStereo(offer.sdp);
    const enableDtx = _sdp_helpers.default.hasSendDtx(offer.sdp);
    const audioBitrate = _sdp_helpers.default.getAudioBitrate(offer.sdp);
    const transformedSdp = (0, _applySdpTransform.default)(sdpTransforms, 'local', 'answer', {
      enableStereo,
      enableDtx,
      audioBitrate,
      replaceBaselineProfile,
      codecFlags,
      sourceStreamId
    }, answer.sdp);
    const newLocalAnswer = new NativeRTCSessionDescription({
      type: answer.type,
      sdp: transformedSdp.local
    });
    const newRemoteAnswer = {
      type: answer.type,
      sdp: transformedSdp.remote
    };
    return peerConnection.setLocalDescription(newLocalAnswer).then(() => success(newRemoteAnswer)).catch(generateErrorCallback('Error while setting LocalDescription', 'SetLocalDescription'));
  };
  const createAnswer = () => peerConnection.createAnswer().then(setLocalDescription).catch(generateErrorCallback('Error while setting createAnswer', 'CreateAnswer'));
  const newOffer = new NativeRTCSessionDescription({
    type: offer.type,
    sdp: (0, _applySdpTransform.default)(sdpTransforms, 'remote', 'offer', {
      replaceBaselineProfile
    }, offer.sdp).local
  });
  const errorCallback = generateErrorCallback('Error while setting RemoteDescription', 'SetRemoteDescription');
  const finalOfferPromise = (0, _testSupportVideo.default)(newOffer, p2p, _env.default, RTCPeerConnection, RTCSessionDescription).then(() => {
    onVideoSupported(true);
    return newOffer;
  }).catch(err => {
    onVideoSupported(false);
    if (!_sdp_helpers.default.hasMediaType(newOffer.sdp, 'audio')) {
      throw new Error('Unsupported video without audio for fallback');
    }
    logging.debug('Couldn\'t set remote description', newOffer, err, ', trying without video');
    const offerWithoutVideo = new NativeRTCSessionDescription({
      type: offer.type,
      sdp: _sdp_helpers.default.disableMediaType(newOffer.sdp, 'video')
    });
    logging.debug('offer without video', offerWithoutVideo.sdp);
    return offerWithoutVideo;
  });
  return finalOfferPromise.then(finalOffer => peerConnection.setRemoteDescription(finalOffer)).then(createAnswer).catch(errorCallback);
}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _shouldUsePlanBSDP = _interopRequireDefault(__webpack_require__(76));
const testSupportVideo = (remoteDesc, p2p, env, RTCPeerConnection, RTCSessionDescription) => {
  if (!RTCPeerConnection) {
    return Promise.resolve(true);
  }
  const pcConfig = {
    iceServers: []
  };
  if ((0, _shouldUsePlanBSDP.default)()) {
    pcConfig.sdpSemantics = 'plan-b';
  }
  const testPc = new RTCPeerConnection(pcConfig);
  const cleanup = () => {
    try {
      testPc.close();
    } catch (e) {} // eslint-disable-line no-empty
  };

  return testPc.setRemoteDescription(new RTCSessionDescription(remoteDesc)).then(() => {
    cleanup();
  }).catch(err => {
    cleanup();
    throw err;
  });
};
var _default = testSupportVideo;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = PeerConnectionChannels;
var _find = _interopRequireDefault(__webpack_require__(63));
var _data_channel = _interopRequireDefault(__webpack_require__(666));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-restricted-syntax, no-prototype-builtins */

// Contains a collection of DataChannels for a particular RTCPeerConnection
//
// @param [RTCPeerConnection] pc A native peer connection object
//
// @constructor
// @private
//
function PeerConnectionChannels(pc) {
  // / Private Data
  let channels = [];
  const api = {};
  let lastQos = {
    sentMessages: 0,
    recvMessages: 0
  };

  // / Private API

  const remove = function remove(channel) {
    channels.filter(c => channel !== c);
  };
  const add = function add(nativeChannel) {
    const channel = new _data_channel.default(nativeChannel);
    channels.push(channel);
    channel.on('close', () => {
      remove(channel);
    });
    return channel;
  };

  // / Public API

  api.add = function (label, options) {
    return add(pc.createDataChannel(label, options));
  };
  api.addMany = function (newChannels) {
    for (const label in newChannels) {
      if (newChannels.hasOwnProperty(label)) {
        api.add(label, newChannels[label]);
      }
    }
  };
  api.get = function (label, options) {
    return (0, _find.default)(channels, channel => channel.equals(label, options));
  };
  api.getOrAdd = function (label, options) {
    let channel = api.get(label, options);
    if (!channel) {
      channel = api.add(label, options);
    }
    return channel;
  };
  api.getQosData = function () {
    const qosData = {
      sentMessages: 0,
      recvMessages: 0
    };
    channels.forEach(channel => {
      qosData.sentMessages += channel.getQosData().sentMessages;
      qosData.recvMessages += channel.getQosData().recvMessages;
    });
    return qosData;
  };
  api.sampleQos = function () {
    const newQos = api.getQosData();
    const sampleQos = {
      sentMessages: newQos.sentMessages - lastQos.sentMessages,
      recvMessages: newQos.recvMessages - lastQos.recvMessages
    };
    lastQos = newQos;
    return sampleQos;
  };
  api.destroy = function () {
    channels.forEach(channel => {
      channel.close();
    });
    channels = [];
  };

  // / Init

  pc.addEventListener('datachannel', event => {
    add(event.channel);
  });
  return api;
}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = DataChannel;
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-cond-assign, no-restricted-syntax */
/* eslint-disable no-prototype-builtins */

const logging = (0, _log.default)('DataChannel');

// Wraps up a native RTCDataChannelEvent object for the message event. This is
// so we never accidentally leak the native DataChannel.
//
// @constructor
// @private
//
//
const DataChannelMessageEvent = function DataChannelMessageEvent(event) {
  this.data = event.data;
  this.source = event.source;
  this.lastEventId = event.lastEventId;
  this.origin = event.origin;
  this.timeStamp = event.timeStamp;
  this.type = event.type;
  this.ports = event.ports;
  this.path = event.path;
};

// DataChannel is a wrapper of the native browser RTCDataChannel object.
//
// It exposes an interface that is very similar to the native one except
// for the following differences:
//  * eventing is handled in a way that is consistent with the OpenTok API
//  * calls to the send method that occur before the channel is open will be
//    buffered until the channel is open (as opposed to throwing an exception)
//
// By design, there is (almost) no direct access to the native object. This is to ensure
// that we can control the underlying implementation as needed.
//
// NOTE: IT TURNS OUT THAT FF HASN'T IMPLEMENT THE LATEST PUBLISHED DATACHANNELS
// SPEC YET, SO THE INFO ABOUT maxRetransmitTime AND maxRetransmits IS WRONG. INSTEAD
// THERE IS A SINGLE PROPERTY YOU PROVIDE WHEN CREATING THE CHANNEL WHICH CONTROLS WHETHER
// THE CHANNEL IS RELAIBLE OF NOT.
//
// Two properties that will have a large bearing on channel behaviour are maxRetransmitTime
// and maxRetransmits. Descriptions of those properties are below. They are set when creating
// the initial native RTCDataChannel.
//
// maxRetransmitTime of type unsigned short, readonly , nullable
//   The RTCDataChannel.maxRetransmitTime attribute returns the length of the time global
//   (in milliseconds) during which retransmissions may occur in unreliable mode, or null if
//   unset. The attribute MUST return the value to which it was set when the RTCDataChannel was
//   created.
//
// maxRetransmits of type unsigned short, readonly , nullable
//   The RTCDataChannel.maxRetransmits attribute returns the maximum number of retransmissions
//   that are attempted in unreliable mode, or null if unset. The attribute MUST return the value
//   to which it was set when the RTCDataChannel was created.
//
// @reference http://www.w3.org/TR/webrtc/#peer-to-peer-data-api
//
// @param [RTCDataChannel] dataChannel A native data channel.
//
//
// @constructor
// @private
//
function DataChannel(dataChannel) {
  const api = {};

  // / Private Data

  const bufferedMessages = [];
  const qosData = {
    sentMessages: 0,
    recvMessages: 0
  };

  // / Private API

  const bufferMessage = function bufferMessage(data) {
    bufferedMessages.push(data);
    return api;
  };
  const sendMessage = function sendMessage(data) {
    dataChannel.send(data);
    qosData.sentMessages++;
    return api;
  };
  const flushBufferedMessages = function flushBufferedMessages() {
    let data;
    while (data = bufferedMessages.shift()) {
      api.send(data);
    }
  };
  const onOpen = function onOpen() {
    api.send = sendMessage;
    flushBufferedMessages();
  };
  const onClose = function onClose(event) {
    api.send = bufferMessage;
    api.trigger('close', event);
  };
  const onError = function onError(event) {
    logging.error(event);
  };
  const onMessage = function onMessage(domEvent) {
    const event = new DataChannelMessageEvent(domEvent);
    qosData.recvMessages++;
    api.trigger('message', event);
  };

  // / Public API

  (0, _eventing.default)(api, true);
  api.label = dataChannel.label;
  api.id = dataChannel.id;
  // api.maxRetransmitTime = dataChannel.maxRetransmitTime;
  // api.maxRetransmits = dataChannel.maxRetransmits;
  api.reliable = dataChannel.reliable;
  api.negotiated = dataChannel.negotiated;
  api.ordered = dataChannel.ordered;
  api.protocol = dataChannel.protocol;
  api._channel = dataChannel;
  api.close = function () {
    dataChannel.close();
  };
  api.equals = function (label, options) {
    if (api.label !== label) {
      return false;
    }
    for (const key in options) {
      if (options.hasOwnProperty(key)) {
        if (api[key] !== options[key]) {
          return false;
        }
      }
    }
    return true;
  };
  api.getQosData = function () {
    return qosData;
  };

  // Send initially just buffers all messages until
  // the channel is open.
  api.send = bufferMessage;

  // / Init
  dataChannel.addEventListener('open', onOpen, false);
  dataChannel.addEventListener('close', onClose, false);
  dataChannel.addEventListener('error', onError, false);
  dataChannel.addEventListener('message', onMessage, false);
  return api;
}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = subscribeProcessor;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _log = _interopRequireDefault(__webpack_require__(1));
var _applySdpTransform = _interopRequireDefault(__webpack_require__(167));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

const logging = (0, _log.default)('subscribeProcessor');

// Attempt to completely process a subscribe message. This will:
// * create an Offer
// * set the new offer as the location description
//
// If there are no issues, the Promise will resolve on completion.
// Errors during any step will result in the Promise being rejected.
//
function subscribeProcessor(_ref) {
  let peerConnection = _ref.peerConnection,
    NativeRTCSessionDescription = _ref.NativeRTCSessionDescription,
    sdpTransforms = _ref.sdpTransforms,
    numSimulcastStreams = _ref.numSimulcastStreams,
    offerOverrides = _ref.offerOverrides,
    offerConstraints = _ref.offerConstraints,
    replaceBaselineProfile = _ref.replaceBaselineProfile,
    removeVideoOrientation = _ref.removeVideoOrientation,
    removeUnusedCodecs = _ref.removeUnusedCodecs;
  const generateErrorCallback = (message, prefix) => errorReason => {
    logging.error(message, errorReason);
    const error = new Error(message);
    error.reason = errorReason;
    error.prefix = prefix;
    throw error;
  };
  const setLocalDescription = offer => {
    logging.debug('subscribeProcessor: offer created', offer);
    let sdp = offer.sdp;
    if (removeUnusedCodecs) {
      var _peerConnection$curre;
      sdp = _sdp_helpers.default.removeUnusedCodecs(sdp, (_peerConnection$curre = peerConnection.currentLocalDescription) == null ? void 0 : _peerConnection$curre.sdp);
    }
    const transformedSdp = (0, _applySdpTransform.default)(sdpTransforms, 'local', 'offer', (0, _assign.default)({
      numSimulcastStreams,
      replaceBaselineProfile,
      removeVideoOrientation
    }, offerOverrides), sdp);
    const newLocalOffer = new NativeRTCSessionDescription({
      type: offer.type,
      sdp: transformedSdp.local
    });
    const newRemoteOffer = new NativeRTCSessionDescription({
      type: offer.type,
      sdp: transformedSdp.remote
    });
    logging.debug('subscribeProcessor: setting local description');
    return peerConnection.setLocalDescription(newLocalOffer).then(() => newRemoteOffer, generateErrorCallback('Error while setting LocalDescription', 'SetLocalDescription'));
  };
  logging.debug('subscribeProcessor: creating offer');
  return peerConnection.createOffer(offerConstraints).then(setLocalDescription, generateErrorCallback('Error while creating Offer', 'CreateOffer')).then(offer => ({
    sdp: offer.sdp,
    type: offer.type
  }));
}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _offerAnswerStates = _interopRequireDefault(__webpack_require__(669));
let OfferAnswerProcessor = /*#__PURE__*/function () {
  function OfferAnswerProcessor(logAnalyticsEvent) {
    // Initial state is resolved, what it means no offer/answer is ongoing.
    this.state = _offerAnswerStates.default.RESOLVED;
    this.offerAnswerQueue = [];
    this.logAnalyticsEvent = logAnalyticsEvent;
  }
  var _proto = OfferAnswerProcessor.prototype;
  _proto.setPending = function setPending() {
    this.state = _offerAnswerStates.default.PENDING;
  };
  _proto.setResolved = function setResolved() {
    this.state = _offerAnswerStates.default.RESOLVED;
    const offerAnswer = this.offerAnswerQueue.shift();
    if (offerAnswer) {
      this.logAnalyticsEvent('dequeueOfferAnswer', 'Event');
      this.setPending();
      offerAnswer();
    }
  };
  _proto.isPending = function isPending() {
    return this.state === _offerAnswerStates.default.PENDING;
  };
  _proto.enqueueOfferAnswer = function enqueueOfferAnswer(offerAnswer) {
    if (this.isPending()) {
      this.offerAnswerQueue.push(offerAnswer);
      this.logAnalyticsEvent('enqueueOfferAnswer', 'Event');
    } else {
      this.setPending();
      offerAnswer();
    }
  };
  return OfferAnswerProcessor;
}();
var _default = OfferAnswerProcessor;
exports.default = _default;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = {
  PENDING: 'pending',
  RESOLVED: 'resolved'
};
exports.default = _default;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
const _SDPHelpers$MediaDire = _sdp_helpers.default.MediaDirection,
  RECVONLY = _SDPHelpers$MediaDire.RECVONLY,
  INACTIVE = _SDPHelpers$MediaDire.INACTIVE;
const changeMediaDirection = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(peerConnection, direction) {
    var offer, sdp, newSdp;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (peerConnection) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.next = 4;
          return peerConnection.createOffer();
        case 4:
          offer = _context.sent;
          _context.next = 7;
          return peerConnection.setLocalDescription(offer);
        case 7:
          sdp = peerConnection.remoteDescription.sdp; // replaces the 'a=recvonly' lines to 'a=inactive' or viceversa, depending on active.
          newSdp = _sdp_helpers.default.changeMediaDirection(sdp, direction);
          peerConnection.setRemoteDescription({
            type: peerConnection.remoteDescription.type,
            sdp: newSdp
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function changeMediaDirection(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Changes the RTP media direction by SDP munging
 * @param {Object} peerConnection - the peer connection to apply the change
 * @param {('recvonly' | 'inactive')} direction - The new direction that could be recvonly or
 * inactive. If it's inactive, then the peer connection will stop sending RTP media.
 */
var _default = {
  changeMediaDirectionToInactive: peerConnection => changeMediaDirection(peerConnection, INACTIVE),
  changeMediaDirectionToRecvOnly: peerConnection => changeMediaDirection(peerConnection, RECVONLY)
};
exports.default = _default;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = parseQOS;
exports.parseStatsNewAPI = parseStatsNewAPI;
exports.parseStatsOldAPI = parseStatsOldAPI;
var _log = _interopRequireDefault(__webpack_require__(1));
var _env = _interopRequireDefault(__webpack_require__(3));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _getProtocolFromPriority = _interopRequireDefault(__webpack_require__(307));
var _getLocalRelayProtocol = _interopRequireDefault(__webpack_require__(672));
var _shouldUseStandardGetStats = _interopRequireDefault(__webpack_require__(111));
var _calculateFrameRate = _interopRequireDefault(__webpack_require__(168));
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
const shouldUseStandardGetStats = (0, _shouldUseStandardGetStats.default)();
const logging = (0, _log.default)('QoS');
const requiredPublisherKeys = ['audioCodec', 'audioSentBytes', 'audioSentPackets', 'audioSentPacketsLost', 'audioRtt', 'videoCodec', 'videoHeight', 'videoHeightInput', 'videoSentBytes', 'videoFrameRateSent', 'videoSentPackets', 'videoRtt', 'videoSentPacketsLost', 'videoWidthInput', 'videoWidth', 'srtpCipher'];
const requiredSubscriberKeys = ['audioCodec', 'audioRecvBytes', 'audioRecvPackets', 'audioRecvPacketsLost', 'videoCodec', 'videoHeight', 'videoRecvBytes', 'videoRecvPackets', 'videoRecvPacketsLost', 'videoFrameRateReceived', 'videoWidth', 'srtpCipher'];

// There are two implementations of stats parsing in this file.
// 1. For Chrome: Chrome is currently using an older version of the API
// 2. For Firefox: FF is using a version that looks a lot closer to the
//    current spec.
//
// I've attempted to keep the implementations from sharing any code,
// accordingly you'll notice a bunch of duplication between them.
//
// This is acceptable as the goal is to be able to remove each implementation
// as it's no longer needed without any risk of affecting the others. If there
// was shared code between them then each removal would require an audit of
// all the others.

const rawStatsHandler = (pc, stats) => logging.debug(`Raw stats for peer conn ${pc.id}:`, stats);
const getAddress = res => {
  const port = res.portNumber || res.port;
  const ip = res.ipAddress || res.address || res.ip;
  return `${ip}:${port}`;
};

// Get Stats using the older API. Used by Chrome up until v58.
function parseStatsOldAPI(peerConnection, prevStats, currentStats, isPublisher, completion) {
  /* this parses a result if there it contains the video bitrate */
  const parseVideoStats = result => {
    if (Number(result.stat('googFrameRateSent')) > 0) {
      currentStats.videoSentBytes = Number(result.stat('bytesSent'));
      currentStats.videoSentPackets = Number(result.stat('packetsSent'));
      currentStats.videoSentPacketsLost = Number(result.stat('packetsLost'));
      // googRtt is expressed in ms, and we need to log it always in seconds. See OPENTOK-42624.
      currentStats.videoRtt = Number(result.stat('googRtt')) / 1000;
      currentStats.videoFrameRate = Number(result.stat('googFrameRateInput'));
      currentStats.videoWidth = Number(result.stat('googFrameWidthSent'));
      currentStats.videoHeight = Number(result.stat('googFrameHeightSent'));
      currentStats.videoFrameRateSent = Number(result.stat('googFrameRateSent'));
      currentStats.videoWidthInput = Number(result.stat('googFrameWidthInput'));
      currentStats.videoHeightInput = Number(result.stat('googFrameHeightInput'));
      currentStats.videoCodec = result.stat('googCodecName');
      currentStats.videoBandwidthLimitedResolution = result.stat('googBandwidthLimitedResolution') === 'true';
      currentStats.cpuLimitedResolution = result.stat('googCpuLimitedResolution') === 'true';
    } else if (Number(result.stat('googFrameRateReceived')) > 0) {
      currentStats.videoRecvBytes = Number(result.stat('bytesReceived'));
      currentStats.videoRecvPackets = Number(result.stat('packetsReceived'));
      currentStats.videoRecvPacketsLost = Number(result.stat('packetsLost'));
      currentStats.videoFrameRate = Number(result.stat('googFrameRateOutput'));
      currentStats.videoFrameRateReceived = Number(result.stat('googFrameRateReceived'));
      currentStats.videoFrameRateDecoded = Number(result.stat('googFrameRateDecoded'));
      currentStats.videoWidth = Number(result.stat('googFrameWidthReceived'));
      currentStats.videoHeight = Number(result.stat('googFrameHeightReceived'));
      currentStats.videoCodec = result.stat('googCodecName');
    }
    return null;
  };
  const parseAudioStats = result => {
    if (Number(result.stat('audioInputLevel')) > 0) {
      currentStats.audioSentPackets = Number(result.stat('packetsSent'));
      currentStats.audioSentPacketsLost = Number(result.stat('packetsLost'));
      currentStats.audioSentBytes = Number(result.stat('bytesSent'));
      currentStats.audioCodec = result.stat('googCodecName');
      // googRtt is expressed in ms, and we need to log it always in seconds. See OPENTOK-42624.
      currentStats.audioRtt = Number(result.stat('googRtt')) / 1000;
    } else if (Number(result.stat('audioOutputLevel')) > 0) {
      currentStats.audioRecvPackets = Number(result.stat('packetsReceived'));
      currentStats.audioRecvPacketsLost = Number(result.stat('packetsLost'));
      currentStats.audioRecvBytes = Number(result.stat('bytesReceived'));
      currentStats.audioCodec = result.stat('googCodecName');
    }
  };
  const parseStatsReports = stats => {
    if (stats.result) {
      const resultList = stats.result();
      rawStatsHandler(peerConnection, resultList);
      const getCandidate = (type, fromStat) => resultList.filter(x => x.id === fromStat.stat(type))[0];
      const getLocalCandidate = fromStat => getCandidate('localCandidateId', fromStat);
      const getRemoteCandidate = fromStat => getCandidate('remoteCandidateId', fromStat);
      for (let resultIndex = 0; resultIndex < resultList.length; resultIndex++) {
        const result = resultList[resultIndex];
        if (result.stat) {
          if (result.stat('googActiveConnection') === 'true') {
            if (result.stat('googChannelId').indexOf('audio') > -1) {
              currentStats.audioLocalAddress = result.stat('googLocalAddress');
              currentStats.audioRemoteAddress = result.stat('googRemoteAddress');
              currentStats.audioLocalCandidateType = result.stat('googLocalCandidateType');
              currentStats.audioRemoteCandidateType = result.stat('googRemoteCandidateType');
              currentStats.audioTransportType = result.stat('googTransportType');
              currentStats.audioLocalRelayProtocol = (0, _getProtocolFromPriority.default)(getLocalCandidate(result).stat('priority'));
              currentStats.audioRemoteRelayProtocol = (0, _getProtocolFromPriority.default)(getRemoteCandidate(result).stat('priority'));
            } else if (result.stat('googChannelId').indexOf('video') > -1) {
              currentStats.videoLocalAddress = result.stat('googLocalAddress');
              currentStats.videoRemoteAddress = result.stat('googRemoteAddress');
              currentStats.videoLocalCandidateType = result.stat('googLocalCandidateType');
              currentStats.videoRemoteCandidateType = result.stat('googRemoteCandidateType');
              currentStats.videoTransportType = result.stat('googTransportType');
              currentStats.videoLocalRelayProtocol = (0, _getProtocolFromPriority.default)(getLocalCandidate(result).stat('priority'));
              currentStats.videoRemoteRelayProtocol = (0, _getProtocolFromPriority.default)(getRemoteCandidate(result).stat('priority'));
            }
          }

          // Video BWE
          if (Number(result.stat('googAvailableSendBandwidth')) > 0) {
            currentStats.videoSentEstimatedBandwidth = Number(result.stat('googAvailableSendBandwidth'));
          }
          if (Number(result.stat('googAvailableReceiveBandwidth')) > 0) {
            currentStats.videoRecvEstimatedBandwidth = Number(result.stat('googAvailableReceiveBandwidth'));
          }
          parseAudioStats(result);
          parseVideoStats(result);
        }
      }

      // For audio-video publishers in Chrome, there are no corresponding video reports for these

      if ('videoCodec' in currentStats && !currentStats.videoLocalAddress) {
        ['LocalAddress', 'RemoteAddress', 'LocalCandidateType', 'RemoteCandidateType', 'TransportType', 'LocalRelayProtocol', 'RemoteRelayProtocol'].forEach(keySuffix => {
          currentStats[`video${keySuffix}`] = currentStats[`audio${keySuffix}`];
        });
      }
    }
    completion(null, currentStats);
  };
  peerConnection.getStats(parseStatsReports);
}

// Get Stats using the newer API.
function parseStatsNewAPI(peerConnection, prevStats, currentStats, isPublisher, completion) {
  const onStatsError = function onStatsError(error) {
    completion(error);
  };
  const parseAudioStats = (result, strippedType) => {
    if (strippedType === 'outboundrtp') {
      currentStats.audioSentPackets = result.packetsSent;
      currentStats.audioSentPacketsLost = result.packetsLost;
      currentStats.audioSentBytes = result.bytesSent;
    } else if (strippedType === 'inboundrtp') {
      currentStats.audioRecvPackets = result.packetsReceived;
      currentStats.audioRecvPacketsLost = result.packetsLost;
      currentStats.audioRecvBytes = result.bytesReceived;
    }
    // OPENTOK-36308 Safari doesn't have audioCodec but on the publisher side it can be mapped
    // to the SDP.  On the subscriber side, currentStats.audioCodec will remain undefined, and
    // will be set (possibly incorrectly) by picking the first rtpmap line out of the SDP.
    if (undefined === currentStats.audioCodec && ['Safari'].indexOf(_OTHelpers.default.env.name) !== -1 && undefined !== result.codecId) {
      const _ref = peerConnection.remoteDescription.type === 'answer' ? peerConnection.remoteDescription : peerConnection.localDescription,
        sdp = _ref.sdp;
      const lastIndex = result.codecId.lastIndexOf('_');
      const codecsAndCodecMap = _sdp_helpers.default.getCodecsAndCodecMap(sdp, 'audio');
      if (lastIndex !== -1 && codecsAndCodecMap !== undefined) {
        currentStats.audioCodec = codecsAndCodecMap.codecMap[result.codecId.substring(lastIndex + 1)];
      }
    }
  };
  const parseOutboundVideoStats = result => {
    // Maps the stat of the (canonical) field to a more readable alias
    const fieldToAliasMap = {
      packetsSent: 'videoSentPackets',
      packetsLost: 'videoSentPacketsLost',
      bytesSent: 'videoSentBytes',
      framesPerSecond: 'videoFrameRate',
      framesSent: 'videoFrameRateSent',
      framesReceived: 'videoFramesReceived',
      frameWidth: 'videoWidth',
      frameHeight: 'videoHeight'
    };
    const cummulativeStats = ['videoSentPackets', 'videoSentBytes'];

    // Stores all the defined stats
    for (const field in fieldToAliasMap) {
      if (field in result) {
        const alias = fieldToAliasMap[field];
        if (cummulativeStats.includes(alias) && Number.isSafeInteger(currentStats[alias])) {
          currentStats[alias] += result[field];
        } else {
          currentStats[alias] = result[field];
        }
      }
    }
  };
  const parseVideoStats = (result, strippedType) => {
    const getVideoFrameRate = () => {
      const haveBytes = 'videoSentBytes' in currentStats ? currentStats.videoSentBytes > 0 : currentStats.videoRecvBytes > 0;
      if (!haveBytes) {
        return 0;
      }
      let videoFrameRate = 0;
      if (_env.default.isFirefox && _env.default.version < 96) {
        videoFrameRate = Number(result.framerateMean);
      } else {
        const framesStat = strippedType === 'outboundrtp' ? 'framesEncoded' : 'framesDecoded';
        currentStats[framesStat] = result[framesStat];
        videoFrameRate = (0, _calculateFrameRate.default)({
          currentStatFrames: result[framesStat],
          currentTimestamp: result.timestamp,
          prevStatFrames: prevStats[framesStat],
          prevTimestamp: prevStats.timeStamp || Date.now()
        });
      }
      return videoFrameRate;
    };
    if (strippedType === 'outboundrtp') {
      if (result.hasOwnProperty('qualityLimitationReason')) {
        currentStats.videoBandwidthLimitedResolution = result.qualityLimitationReason === 'bandwidth';
        currentStats.cpuLimitedResolution = result.qualityLimitationReason === 'cpu';
      }
      parseOutboundVideoStats(result);
    } else if (strippedType === 'inboundrtp') {
      currentStats.videoRecvPackets = result.packetsReceived;
      currentStats.videoRecvPacketsLost = result.packetsLost;
      currentStats.videoRecvBytes = result.bytesReceived;
      currentStats.videoWidth = result.frameWidth;
      currentStats.videoHeight = result.frameHeight;
      currentStats.videoFramesReceived = result.framesReceived;
    }

    // Calculation of videoFrameRate:
    // - For Chromium based browsers:
    //   -- Publisher videoFrameRate: it's calculated in parseOutboundVideoStats().
    //   -- Subscriber videoFrameRate: it's calculated in getVideoFrameRate().
    // - For Firefox <= 95
    //   -- Obtained from frameRateMean stat in getVideoFrameRate() for both inbound and
    //      outbound video reports.
    // - For Firefox >= 96
    //   -- it's calculated in getVideoFrameRate() calculating the frameRate using
    //      on framesEncoded (outbound video) or framesDecoded (inbound video)
    // - For Safari
    //   -- Publisher videoFrameRate: it's calculated in parseOutboundVideoStats().
    //   -- Subscriber videoFrameRate: it's calculated in getVideoFrameRate().
    if (_env.default.isFirefox && ['outboundrtp', 'inboundrtp'].includes(strippedType) || !isPublisher && strippedType === 'inboundrtp') {
      currentStats.videoFrameRate = getVideoFrameRate();
    }

    // OPENTOK-36308 Safari doesn't have videoCodec but on the publisher side it can be mapped
    // to the SDP.  On the subscriber side, currentStats.videoCodec will remain undefined, and
    // will be set (possibly incorrectly) by picking the first rtpmap line out of the SDP.
    if (undefined === currentStats.videoCodec && ['Safari'].indexOf(_OTHelpers.default.env.name) !== -1 && undefined !== result.codecId) {
      const _ref2 = peerConnection.remoteDescription.type === 'answer' ? peerConnection.remoteDescription : peerConnection.localDescription,
        sdp = _ref2.sdp;
      const lastIndex = result.codecId.lastIndexOf('_');
      const codecsAndCodecMap = _sdp_helpers.default.getCodecsAndCodecMap(sdp, 'video');
      if (lastIndex !== -1 && codecsAndCodecMap !== undefined) {
        currentStats.videoCodec = codecsAndCodecMap.codecMap[result.codecId.substring(lastIndex + 1)];
      }
    }
  };
  peerConnection.getStats(null).then(stats => {
    let localCandidateType, remoteCandidateType, localAddress, localRelayProtocol, remoteAddress, transportType, frameWidth, frameHeight;
    const videoRttValues = [];

    // Calculates the average of all the roundTripTime values.
    const getVideoRttAverage = () => {
      if (videoRttValues.length === 0) {
        return null;
      }
      const positiveVideoRtts = videoRttValues.filter(videoRtt => videoRtt > 0);
      const accumulatedVideoRtt = positiveVideoRtts.reduce((acc, videoRtt) => acc + videoRtt, 0);
      const videoRttAverage = positiveVideoRtts.length ? accumulatedVideoRtt / positiveVideoRtts.length : 0;
      return videoRttAverage;
    };

    // Converts `Inbound-RTP` to `inboundrtp`
    const getStrippedType = type => type.toLowerCase().replace(/[^a-z]/g, '');
    const statsLoop = res => {
      const strippedType = getStrippedType(res.type);
      const lowercaseId = res.id.toLowerCase();
      if (/(in|out)boundrtp$/.test(strippedType)) {
        // Media type may be mapped to either `id` or `kind`
        const isRtp = /rtp/.test(lowercaseId);
        const isAudioRtp = isRtp && /audio/.test(lowercaseId);
        const isVideoRtp = isRtp && /video/.test(lowercaseId);
        const isAudio = isAudioRtp || res.kind === 'audio';
        const isVideo = isVideoRtp || res.kind === 'video';
        if (isAudio) {
          parseAudioStats(res, strippedType);
        } else if (isVideo) {
          parseVideoStats(res, strippedType);
        }
        if (res.hasOwnProperty('roundTripTime')) {
          const type = res.mediaType || res.kind;

          // roundTripTime comes on the rtcp stats and so won't be caught above
          if (type === 'video') {
            videoRttValues.push(res.roundTripTime);
          } else if (type === 'audio') {
            currentStats.audioRtt = res.roundTripTime;
          }
        }
        if (strippedType === 'remoteinboundrtp') {
          if (res.hasOwnProperty('packetsLost')) {
            const kind = res.kind;
            const key = `${kind}SentPacketsLost`;
            if (!currentStats[key]) {
              currentStats[key] = 0;
            }
            currentStats[key] += res.packetsLost;
          }
        }
      } else if (strippedType === 'transport') {
        const selectedCandidatePairId = res.selectedCandidatePairId,
          srtpCipher = res.srtpCipher;
        currentStats.srtpCipher = srtpCipher;
        if (selectedCandidatePairId) {
          localRelayProtocol = (0, _getLocalRelayProtocol.default)(selectedCandidatePairId, stats);
        }
      } else if (strippedType === 'localcandidate') {
        localCandidateType = res.candidateType;
        localAddress = getAddress(res);
        transportType = res.protocol || res.transport;
      } else if (strippedType === 'remotecandidate') {
        remoteCandidateType = res.candidateType;
        remoteAddress = getAddress(res);
      } else if (strippedType === 'track' && lowercaseId.indexOf('video') !== 0) {
        frameWidth = res.frameWidth;
        frameHeight = res.frameHeight;
        parseOutboundVideoStats(res);
      } else if (strippedType === 'mediasource') {
        if (res.hasOwnProperty('framesPerSecond')) {
          currentStats.videoFrameRate = res.framesPerSecond;
        }
        if (res.hasOwnProperty('width')) {
          currentStats.videoWidthInput = res.width;
        }
        if (res.hasOwnProperty('height')) {
          currentStats.videoHeightInput = res.height;
        }
      } else if (strippedType === 'candidatepair') {
        if (res.hasOwnProperty('availableOutgoingBitrate')) {
          const estimatedStat = `video${isPublisher ? 'Sent' : 'Recv'}EstimatedBandwidth`;
          currentStats[estimatedStat] = parseInt(res.availableOutgoingBitrate, 10);
        }
      }
    };

    // Firefox <= 45 can't use for of loop OPENTOK-32755
    if (typeof stats[Symbol.iterator] === 'function') {
      rawStatsHandler(peerConnection, Array.from(stats));
      for (var _iterator = _createForOfIteratorHelperLoose(stats), _step; !(_step = _iterator()).done;) {
        const el = _step.value;
        const res = Array.isArray(el) ? el[1] : el;
        statsLoop(res);
      }
    } else {
      rawStatsHandler(peerConnection, stats);
      for (const key in stats) {
        if (stats.hasOwnProperty(key)) {
          statsLoop(stats[key]);
        }
      }
    }
    if (peerConnection.currentRemoteDescription) {
      currentStats.useDtx = _sdp_helpers.default.hasSendDtx(peerConnection.currentRemoteDescription.sdp);
    }
    if (isPublisher) {
      currentStats.videoRtt = getVideoRttAverage();
    }
    if (currentStats.audioRecvBytes || currentStats.audioSentBytes) {
      currentStats.audioLocalCandidateType = localCandidateType;
      currentStats.audioLocalAddress = localAddress;
      currentStats.audioRemoteCandidateType = remoteCandidateType;
      currentStats.audioRemoteAddress = remoteAddress;
      currentStats.audioTransportType = transportType;
      currentStats.audioLocalRelayProtocol = localRelayProtocol;
      if (currentStats.audioCodec === undefined) {
        const _ref3 = peerConnection.remoteDescription.type === 'answer' ? peerConnection.remoteDescription : peerConnection.localDescription,
          sdp = _ref3.sdp;
        const codecs = _sdp_helpers.default.getCodecs(sdp, 'audio');
        currentStats.audioCodec = codecs[0];
      }
    }
    if (currentStats.videoRecvBytes || currentStats.videoSentBytes) {
      currentStats.videoLocalCandidateType = localCandidateType;
      currentStats.videoLocalAddress = localAddress;
      currentStats.videoRemoteCandidateType = remoteCandidateType;
      currentStats.videoRemoteAddress = remoteAddress;
      currentStats.videoTransportType = transportType;
      currentStats.videoLocalRelayProtocol = localRelayProtocol;
      if (currentStats.videoCodec === undefined) {
        const _ref4 = peerConnection.remoteDescription.type === 'answer' ? peerConnection.remoteDescription : peerConnection.localDescription,
          sdp = _ref4.sdp;
        const codecs = _sdp_helpers.default.getCodecs(sdp, 'video');
        currentStats.videoCodec = codecs[0];
      }
    }
    extendStats(currentStats, isPublisher);
    currentStats.videoWidth = currentStats.videoWidth || frameWidth;
    currentStats.videoHeight = currentStats.videoHeight || frameHeight;
    completion(null, currentStats);
  }).catch(onStatsError);
}
function parseQOS(peerConnection, prevStats, currentStats, isPublisher, completion) {
  if (shouldUseStandardGetStats) {
    return parseStatsNewAPI(peerConnection, prevStats, currentStats, isPublisher, completion);
  }
  return parseStatsOldAPI(peerConnection, prevStats, currentStats, isPublisher, completion);
}
function extendStats(stats, isPublisher) {
  const requiredKeys = isPublisher ? requiredPublisherKeys : requiredSubscriberKeys;
  requiredKeys.forEach(key => {
    if (!stats.hasOwnProperty(key)) {
      stats[key] = null;
    }
  });
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _getProtocolFromPriority = _interopRequireDefault(__webpack_require__(307));
var _default = (selectedCandidatePairId, stats) => {
  let localRelayProtocol = '';
  if (!selectedCandidatePairId || !stats) {
    return localRelayProtocol;
  }
  const activeCandidatePair = stats.get(selectedCandidatePairId);
  if (activeCandidatePair) {
    const localCandidateId = activeCandidatePair.localCandidateId;
    if (localCandidateId) {
      const localCandidate = stats.get(localCandidateId);
      if (localCandidate) {
        const relayProtocol = localCandidate.relayProtocol,
          priority = localCandidate.priority;
        if (relayProtocol) {
          const RELAY_PROTOCOL = relayProtocol.toUpperCase();
          localRelayProtocol = `TURN/${RELAY_PROTOCOL}`;
        } else {
          localRelayProtocol = (0, _getProtocolFromPriority.default)(priority);
        }
      }
    }
  }
  return localRelayProtocol;
};
exports.default = _default;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
let TruthyChangeCounter = /*#__PURE__*/function () {
  function TruthyChangeCounter() {
    this.value = null;
    this.changeCount = 0;
  }
  var _proto = TruthyChangeCounter.prototype;
  _proto.onValue = function onValue(newValue) {
    if (!newValue) {
      return;
    }
    if (newValue !== this.value) {
      if (this.value) {
        this.changeCount += 1;
      }
      this.value = newValue;
    }
  };
  return TruthyChangeCounter;
}();
exports.default = TruthyChangeCounter;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _once = _interopRequireDefault(__webpack_require__(52));
var _env = _interopRequireDefault(__webpack_require__(3));
/* eslint-disable global-require */

// Indicates whether this client needs its H264 profiles to be swapped
// Currently this is just Chrome on Android (OPENTOK-34457)
// See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8584
const check = function check(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const env = deps.env || _env.default;
  return env.name === 'Chrome' && env.userAgent.toLowerCase().indexOf('android') > -1 && env.version < 65;
};
const once = (0, _once.default)(() => check());
var _default = {
  once,
  check
};
exports.default = _default;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
// Video from iOS publishers are upside-down when viewed in picture-in-picture
// mode.
// See https://bugs.webkit.org/show_bug.cgi?id=210958
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const _deps = deps,
    _deps$env = _deps.env,
    env = _deps$env === void 0 ? _env.default : _deps$env;

  // Notice that we're only checking the iOS version, instead of the browser
  // version.  Reason being, browsers on iOS (e.g., Chrome and Firefox) are based
  // on webkit.  This means they'll all have this bug, regardless of their
  // version number.
  return !!(env.isiOS && env.iOSVersion > 10);
};
exports.default = _default;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = Archiving;
var _widget = _interopRequireDefault(__webpack_require__(40));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable one-var, no-mixed-operators,  no-param-reassign */

// Archving Chrome Widget
//
// mode (String)
// Whether to display the archving widget. Possible values are: "on" (the status is displayed
// when archiving and briefly when archving ends) and "off" (the status is not displayed)

// Whether to display the archving widget. Possible values are: "auto" (the name is displayed
// when the status is first displayed and when the user mouses over the display),
// "off" (the name is not displayed), and "on" (the name is displayed).
//
// displays a name
// can be shown/hidden
// can be destroyed
function Archiving(options) {
  let _lightBox, _light, _text, _textNode, renderStageDelayedAction;
  const self = this;
  let _archiving = options.archiving;
  const _archivingStarted = options.archivingStarted || 'Archiving on';
  const _archivingEnded = options.archivingEnded || 'Archiving off';
  let _initialState = true;
  const renderText = function renderText(text) {
    _textNode.nodeValue = text;
    _lightBox.setAttribute('title', text);
  };
  const renderStage = function renderStage() {
    if (renderStageDelayedAction) {
      clearTimeout(renderStageDelayedAction);
      renderStageDelayedAction = null;
    }
    if (_archiving) {
      _OTHelpers.default.addClass(_light, 'OT_active');
    } else {
      _OTHelpers.default.removeClass(_light, 'OT_active');
    }
    _OTHelpers.default.removeClass(self.domElement, `OT_archiving-${!_archiving ? 'on' : 'off'}`);
    _OTHelpers.default.addClass(self.domElement, `OT_archiving-${_archiving ? 'on' : 'off'}`);
    if (options.show && _archiving) {
      renderText(_archivingStarted);
      _OTHelpers.default.addClass(_text, 'OT_mode-on');
      _OTHelpers.default.removeClass(_text, 'OT_mode-auto');
      self.setDisplayMode('on');
      renderStageDelayedAction = setTimeout(() => {
        _OTHelpers.default.addClass(_text, 'OT_mode-auto');
        _OTHelpers.default.removeClass(_text, 'OT_mode-on');
      }, 5000);
    } else if (options.show && !_initialState) {
      _OTHelpers.default.addClass(_text, 'OT_mode-on');
      _OTHelpers.default.removeClass(_text, 'OT_mode-auto');
      self.setDisplayMode('on');
      renderText(_archivingEnded);
      renderStageDelayedAction = setTimeout(() => {
        self.setDisplayMode('off');
      }, 5000);
    } else {
      self.setDisplayMode('off');
    }
  };

  // Mixin common widget behaviour
  (0, _widget.default)(this, {
    mode: _archiving && options.show && 'on' || 'off',
    nodeName: 'h1',
    htmlAttributes: {
      className: 'OT_archiving OT_edge-bar-item OT_edge-bottom'
    },
    onCreate() {
      _lightBox = _OTHelpers.default.createElement('div', {
        className: 'OT_archiving-light-box'
      }, '');
      _light = _OTHelpers.default.createElement('div', {
        className: 'OT_archiving-light'
      }, '');
      _lightBox.appendChild(_light);
      _text = _OTHelpers.default.createElement('div', {
        className: 'OT_archiving-status OT_mode-on OT_edge-bar-item OT_edge-bottom'
      }, '');
      _textNode = document.createTextNode('');
      _text.appendChild(_textNode);
      self.domElement.appendChild(_lightBox);
      self.domElement.appendChild(_text);
      renderStage();
    }
  });
  this.setShowArchiveStatus = function (show) {
    options.show = show;
    if (self.domElement) {
      renderStage.call(self);
    }
  };
  this.setArchiving = function (status) {
    _archiving = status;
    _initialState = false;
    if (self.domElement) {
      renderStage.call(self);
    }
  };
}

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = getUserMediaFactory;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _isObject = _interopRequireDefault(__webpack_require__(11));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _ot_error_class = _interopRequireDefault(__webpack_require__(26));
var _promiseDelay = _interopRequireDefault(__webpack_require__(95));
var _trackUsage = _interopRequireDefault(__webpack_require__(678));
var _analytics = _interopRequireDefault(__webpack_require__(31));
var _env = _interopRequireDefault(__webpack_require__(3));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _screen_sharing = _interopRequireDefault(__webpack_require__(171));
var _getDisplayMedia_extension_helper = _interopRequireDefault(__webpack_require__(315));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require, one-var, prefer-const */
/* eslint-disable no-restricted-syntax, no-prototype-builtins, no-continue */

function getUserMediaFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const env = deps.env || _env.default;
  const Errors = deps.Errors || _Errors.default;
  const otError = deps.otError || (0, _otError.default)();
  const logging = deps.logging || (0, _log.default)('getUserMedia');
  const screenSharing = deps.screenSharing || (0, _screen_sharing.default)();
  const getDisplayMediaExtensionHelper = deps.getDisplayMediaExtensionHelper || _getDisplayMedia_extension_helper.default;
  const customGetUserMedia = deps.customGetUserMedia;
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  /** @type {AnalyticsHelper} */
  const analytics = deps.analytics || new _analytics.default();
  const navigator = windowMock.navigator,
    location = windowMock.location;
  const getGetUserMediaFn = () => {
    if (customGetUserMedia) {
      return customGetUserMedia;
    }
    if (navigator.mediaDevices) {
      var _context;
      return (_context = navigator.mediaDevices).getUserMedia.bind(_context);
    }
    return undefined;
  };
  const getUserMedia = function getUserMedia() {
    const getUserMediaFn = getGetUserMediaFn();
    if (getUserMediaFn) {
      return getUserMediaFn(...arguments);
    }
    return Promise.reject(new Error('Cannot find getUserMedia'));
  };
  const getGetDisplayMediaFn = () => {
    if (customGetUserMedia) {
      return customGetUserMedia;
    }
    if (navigator.mediaDevices && navigator.getDisplayMedia) {
      return navigator.getDisplayMedia.bind(navigator);
    }
    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
      var _context2;
      return (_context2 = navigator.mediaDevices).getDisplayMedia.bind(_context2);
    }
    return undefined;
  };
  const getDisplayMedia = function getDisplayMedia() {
    const getDisplayMediaFn = getGetDisplayMediaFn();
    if (getDisplayMediaFn) {
      return getDisplayMediaFn(...arguments);
    }
    return Promise.reject(new Error('Cannot find getDisplayMedia'));
  };
  const vendorToOTErrorDetails = (() => {
    const userMediaAccessDenied = {
      name: Errors.USER_MEDIA_ACCESS_DENIED,
      message: 'End-user denied permission to hardware devices'
    };
    const notSupported = {
      name: Errors.NOT_SUPPORTED,
      message: 'A constraint specified is not supported by the browser.'
    };
    const constraintsNotSatisfied = {
      name: Errors.CONSTRAINTS_NOT_SATISFIED,
      message: 'It\'s not possible to satisfy one or more constraints ' + 'passed into the getUserMedia function'
    };
    const noDevicesFound = {
      name: Errors.NO_DEVICES_FOUND,
      message: 'No voice or video input devices are available on this machine.'
    };
    const hardwareUnavailable = {
      name: Errors.HARDWARE_UNAVAILABLE,
      message: 'The selected voice or video devices are unavailable. Verify ' + 'that the chosen devices are not in use by another application.'
    };
    const screenCaptureError = {
      name: Errors.UNABLE_TO_CAPTURE_SCREEN,
      message: 'Unable to capture screen. Unknown error occurred'
    };
    const abortError = {
      name: Errors.UNABLE_TO_CAPTURE_MEDIA,
      message: 'Unable to capture media. Unknown error occurred'
    };

    // Mozilla error strings and the equivalent W3C names. NOT_SUPPORTED_ERROR does not
    // exist in the spec right now, so we'll include Mozilla's error description.
    // Chrome TrackStartError is triggered when the camera is already used by another app (Windows)
    const errorMap = {
      // Spec:
      AbortError: abortError,
      NotAllowedError: userMediaAccessDenied,
      NotFoundError: noDevicesFound,
      NotReadableError: hardwareUnavailable,
      OverconstrainedError: constraintsNotSatisfied,
      SecurityError: (0, _assign.default)({}, userMediaAccessDenied, {
        message: 'End-user denied permission to hardware devices or user media' + ' support may be disabled on this page'
      }),
      TypeError: constraintsNotSatisfied,
      // Old errors, probably not used anymore. @todo log usage to be removed.
      PermissionDeniedError: userMediaAccessDenied,
      PermissionDismissedError: userMediaAccessDenied,
      NotSupportedError: notSupported,
      ConstraintNotSatisfiedError: constraintsNotSatisfied,
      MandatoryUnsatisfiedError: constraintsNotSatisfied,
      OverConstrainedError: constraintsNotSatisfied,
      DevicesNotFoundError: noDevicesFound,
      NoDevicesFoundError: noDevicesFound,
      HardwareUnavailableError: hardwareUnavailable,
      SourceUnavailableError: hardwareUnavailable,
      TrackStartError: hardwareUnavailable,
      ScreenCaptureError: screenCaptureError,
      TabCaptureError: screenCaptureError
    };

    // track usage of the following keys so we know if they are still being used
    // and by which browsers/ operating systems.
    (0, _trackUsage.default)({
      objectToTrack: errorMap,
      keys: ['PermissionDeniedError', 'PermissionDismissedError', 'NotSupportedError', 'ConstraintNotSatisfiedError', 'MandatoryUnsatisfiedError', 'OverConstrainedError', 'DevicesNotFoundError', 'NoDevicesFoundError', 'HardwareUnavailableError', 'SourceUnavailableError', 'TrackStartError', 'ScreenCaptureError', 'TabCaptureError'],
      onUsage(key) {
        analytics.logEvent({
          action: 'DeprecatedPropertyUsage:getUserMedia:errorMap',
          variation: 'Event',
          payload: {
            key
          }
        });
      }
    });
    return errorMap;
  })();

  // Map vendor error strings to errors we emit
  const errorFromVendorNameAndMessage = (vendorErrorName, message) => {
    let name = vendorErrorName;
    if (name === 'AbortError' && typeof message === 'string' && message.match(/(screen|tab).?capture/i)) {
      name = 'ScreenCaptureError';
    }
    const otErrorDetails = vendorToOTErrorDetails[name];
    let error;
    if (otErrorDetails) {
      error = otError(otErrorDetails.name, new Error(`${otErrorDetails.message} (getUserMedia error: ${vendorErrorName})`));
    } else {
      error = new Error(`Unknown error while getting user media: ${vendorErrorName}`);
    }
    error.originalMessage = message;
    error.originalName = vendorErrorName;
    return error;
  };

  // Parse and normalise a getUserMedia error event from Chrome or Mozilla
  // @ref http://dev.w3.org/2011/webrtc/editor/getusermedia.html#idl-def-NavigatorUserMediaError
  const parseErrorEvent = event => {
    if ((0, _isObject.default)(event) && event.name) {
      let name = event.name,
        message = event.message;
      if (message === 'Cannot find getUserMedia' || message === 'Cannot find getDisplayMedia') {
        if (env.name === 'Chrome' && env.version > 73 && windowMock.location.protocol !== 'https:') {
          name = 'NotAllowedError';
        } else {
          name = 'NotSupportedError';
        }
      }

      // Errors in Safari have incorrect name property
      // See https://bugs.webkit.org/show_bug.cgi?id=180777
      if (env.name === 'Safari' && name === 'Error') {
        const protoName = Object.prototype.toString.call(event);
        const matches = protoName.match(/^\[object (\w+Error)\]$/);
        if (matches) {
          name = matches[1];
        }
      }
      const error = errorFromVendorNameAndMessage(name, message);
      error.constraintName = event.constraint || event.constraintName;
      if (!(error instanceof _ot_error_class.default)) {
        analytics.logEvent({
          action: 'UnexpectedError:getUserMedia:parseErrorEvent',
          variation: 'Event',
          payload: {
            name: error.name,
            message: error.message,
            originalMessage: error.originalMessage
          }
        });
      }
      return error;
    }
    if (typeof event === 'string') {
      const error = errorFromVendorNameAndMessage(event);
      analytics.logEvent({
        action: 'CheckUnreachable:getUserMedia:parseErrorEvent',
        variation: 'Event',
        payload: {
          info: 'error is string',
          error: event
        }
      });
      return error;
    }
    analytics.logEvent({
      action: 'CheckUnreachable:getUserMedia:parseErrorEvent',
      variation: 'Event',
      payload: {
        info: 'error was not string or object with name property',
        error: event
      }
    });
    return new Error('Unknown error type while getting media');
  };

  // Validates a Hash of getUserMedia constraints. Currently we only
  // check to see if there is at least one non-false constraint.
  const areInvalidConstraints = function areInvalidConstraints(constraints) {
    if (!constraints || !(0, _isObject.default)(constraints)) {
      return true;
    }
    for (const key in constraints) {
      if (!constraints.hasOwnProperty(key)) {
        continue;
      }
      if (constraints[key]) {
        return false;
      }
    }
    return true;
  };

  // A wrapper for the builtin navigator.getUserMedia. In addition to the usual
  // getUserMedia behaviour, this helper method also accepts a accessDialogOpened
  // and accessDialogClosed callback.
  //
  // @memberof OTHelpers
  // @private
  //
  // @param {Object} constraints
  //      A dictionary of constraints to pass to getUserMedia. See
  //      http://dev.w3.org/2011/webrtc/editor/getusermedia.html#idl-def-MediaStreamConstraints
  //      in the Media Capture and Streams spec for more info.
  //
  // @param {function} success
  //      Called when getUserMedia completes successfully. The callback will be passed a WebRTC
  //      Stream object.
  //
  // @param {function} failure
  //      Called when getUserMedia fails to access a user stream. It will be passed an object
  //      with a code property representing the error that occurred.
  //
  // @param {function} accessDialogOpened
  //      Called when the access allow/deny dialog is opened.
  //
  // @param {function} accessDialogClosed
  //      Called when the access allow/deny dialog is closed.
  //
  // @param {function} accessDenied
  //      Called when access is denied to the camera/mic. This will be either because
  //      the user has clicked deny or because a particular origin is permanently denied.
  //
  return function (constraints, isScreenSharing) {
    if (isScreenSharing === void 0) {
      isScreenSharing = false;
    }
    logging.debug('getUserMedia wrapper called with', constraints);
    if (areInvalidConstraints(constraints)) {
      // All constraints are false, we don't allow this. This may be valid later
      // depending on how/if we integrate data channels.
      logging.error('Couldn\'t get UserMedia: All constraints were false');
      return (0, _eventing.default)(Promise.reject(otError(Errors.NO_VALID_CONSTRAINTS, new Error('Video and Audio was disabled, you need to enable at least one'))));
    }
    const getMedia = isScreenSharing && getDisplayMediaExtensionHelper.isSupportedInThisBrowser ? getDisplayMedia : getUserMedia;
    const throttledRequest = (0, _eventing.default)(getMedia(constraints).catch(browserError => {
      // This also restores bluebird's ability to check we handle the error since we ignored
      // it when creating `finalized` above.
      const error = parseErrorEvent(browserError);
      if (error.name === Errors.UNABLE_TO_CAPTURE_SCREEN) {
        return new Promise((resolve, reject) => {
          screenSharing.checkCapability(response => {
            if (response.extensionRequired === 'chrome') {
              if (response.extensionRegistered && !response.extensionInstalled) {
                const newErr = otError(Errors.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, error);
                newErr.message = 'Screen sharing extension not installed see https://tokbox.com/developer/guides/screen-sharing/js/#chrome-extension';
                reject(newErr);
              } else if (!response.extensionRegistered) {
                const newErr = otError(Errors.SCREEN_SHARING_EXTENSION_NOT_REGISTERED, error);
                newErr.message = 'Screen sharing extension not registered see https://tokbox.com/developer/guides/screen-sharing/js/#chrome-extension';
                reject(newErr);
              }
            } else {
              reject(error);
            }
          });
        });
      }
      throw error;
    }).then(stream => {
      logging.debug('got stream:', {
        stream,
        tracks: stream.getTracks(),
        trackLabels: stream.getTracks().map(track => track.label)
      });
      return stream;
    }));

    // The 'remember me' functionality of WebRTC only functions over HTTPS, if
    // we aren't on HTTPS then we should definitely be displaying the access
    // dialog.
    //
    // If we are on HTTPS, we'll wait 500ms to see if we get a stream
    // immediately. If we do then the user had clicked 'remember me'. Otherwise
    // we assume that the accessAllowed dialog is visible.
    //
    // Otherwise, we still wait 100ms to give the client a chance to bind to the
    // event.
    //
    // @todo benchmark and see if 500ms is a reasonable number. It seems like
    // we should know a lot quicker.
    //
    const dialogOpenedDelay = location.protocol.indexOf('https') !== -1 ? 500 : 100;
    let waitingForStream = true;
    const setWaitingForStreamFalse = () => {
      waitingForStream = false;
    };
    throttledRequest.then(setWaitingForStreamFalse, setWaitingForStreamFalse);
    (0, _promiseDelay.default)(dialogOpenedDelay).then(() => {
      if (!waitingForStream) {
        return;
      }
      const closeDialog = () => {
        throttledRequest.emit('accessDialogClosed');
      };
      throttledRequest.emit('accessDialogOpened');
      throttledRequest.then(closeDialog, closeDialog);
    });
    return throttledRequest;
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = function _default(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    objectToTrack = _ref.objectToTrack,
    keys = _ref.keys,
    onUsage = _ref.onUsage;
  if (!Array.isArray(keys) && keys !== undefined) {
    throw new Error('keys must be an array, or undefined');
  }
  if (typeof onUsage !== 'function') {
    throw new Error('onUsage must be a function');
  }
  if (objectToTrack == null) {
    throw new Error('Expected objectToTrack to be a trackable object');
  }
  Object.keys(objectToTrack).forEach(key => {
    if (keys !== undefined && keys.indexOf(key) === -1) {
      return;
    }
    let value = objectToTrack[key];
    Object.defineProperty(objectToTrack, key, {
      get() {
        onUsage(key);
        return value;
      },
      set(newValue) {
        value = newValue;
        onUsage(key, value);
      },
      enumerable: true
    });
  });
};
exports.default = _default;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = electronExtensionHelperFactory;
var _env = _interopRequireDefault(__webpack_require__(3));
var _electron_desktop_capturer_helper = _interopRequireDefault(__webpack_require__(680));
var _is_electron_screen_sharing_source = _interopRequireDefault(__webpack_require__(289));
const isCallbackBasedAPI = _electron_desktop_capturer_helper.default.isCallbackBasedAPI;
let isElectronScreenSharingSource = _is_electron_screen_sharing_source.default;
let desktopCapturer = null;

// Legacy versions of Electron have a callback-based method
const getSourcesUsingCallback = (opts, callback) => {
  desktopCapturer.getSources(opts, callback);
};

// More recent versions of Electron has a promise-based method
const getSourcesUsingPromise = (opts, callback) => {
  desktopCapturer.getSources(opts).then(sources => {
    callback(undefined, sources);
  }, callback);
};
const getSourcesAdapter = () => isCallbackBasedAPI ? getSourcesUsingCallback : getSourcesUsingPromise;
const getSourcesWrapper = (source, callback) => {
  const getSources = getSourcesAdapter();
  getSources({
    types: [source]
  }, (error, sources) => {
    if (error) {
      callback(error);
      return;
    }

    // For now just pick the first source. In future we need to implement a selection
    // dialog.
    const foundSource = sources[0];
    if (!foundSource) {
      callback(new Error('Could not find Electron source for screensharing'));
      return;
    }
    const constraints = {
      audio: false,
      video: {
        mandatory: {
          chromeMediaSource: source,
          chromeMediaSourceId: foundSource.id
        }
      }
    };
    callback(undefined, constraints);
  });
};
function electronExtensionHelperFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  try {
    // Using a dynamic require here because that's the way we get desktopCapturer in electron, and
    // that's not something to bundle in.

    // We are requiring electron here to see if it's available, it's intentionally not packaged
    // and not listed in the package.json for this repository. It is expected to be found only if
    // we are running inside an Electron application.

    const globalContext = () => {
      // We need to search for the require function either in the current
      // global or, if its a window, one of its parents. This is necessary
      // in case OT is used from within an iframe (like our integration
      // tests).
      let current = (typeof window !== undefined ? window : global);
      while (typeof current.require !== 'function' && current.parent && current.parent !== current) {
        current = current.parent;
      }
      return current;
    };
    const getDesktopCapturer = () => {
      const current = globalContext();

      // In case the option 'contextIsolation' is true, the require function will be undefined,
      // so we'll expect the desktopCapturer to be exposed in window.electron.desktopCapturer by
      // the app layer within a preload file.
      // See https://www.electronjs.org/docs/tutorial/context-isolation
      const electron = current.require ? current.require('electron') : current.electron;
      return electron.desktopCapturer;
    };
    desktopCapturer = deps.desktopCapturer || (
    // Don't try to import unless in electron environment, else `require` will
    // dispatch an error message if `electron` is not found
    _env.default.isElectron ? getDesktopCapturer() : null);
    isElectronScreenSharingSource = deps.isElectronScreenSharingSource || isElectronScreenSharingSource;
  } catch (e) {
    // Ignore
  }
  return {
    isSupportedInThisBrowser: desktopCapturer !== null,
    autoRegisters: true,
    extensionRequired: false,
    getConstraintsShowsPermissionUI: false,
    sources: {
      screen: true,
      application: true,
      window: true,
      browser: true
    },
    register: () => ({
      isInstalled: callback => callback(true),
      getConstraints(source, constraints, callback) {
        if (isElectronScreenSharingSource(source)) {
          // User passed in a custom screen sharing source, so no need to call
          // "getSources" (cause we already have one).
          callback(undefined, {
            audio: true,
            video: false
          });
        } else {
          getSourcesWrapper(source, callback);
        }
      }
    })
  };
}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
// Callback-based API was removed in ElectronJS 7, which corresponds to
// Chrome 78
const isCallbackBasedAPI = _env.default.version < 78;
const isPromiseBasedAPI = !isCallbackBasedAPI;
var _default = {
  isCallbackBasedAPI,
  isPromiseBasedAPI
};
exports.default = _default;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _haveGetDisplayMedia = _interopRequireDefault(__webpack_require__(169));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, no-void */

const isSupportedInThisBrowser = () => {
  const isFirefox = _env.default.isFirefox;
  if (!isFirefox) {
    return false;
  }

  // Don't use plugin if getDisplayMedia is supported
  return !_haveGetDisplayMedia.default;
};
var _default = {
  isSupportedInThisBrowser: isSupportedInThisBrowser(),
  autoRegisters: true,
  extensionRequired: false,
  extensionInstalled: false,
  getConstraintsShowsPermissionUI: false,
  sources: {
    screen: true,
    application: false,
    window: true,
    browser: false
  },
  register() {
    return {
      isInstalled(callback) {
        // The extension sets window.OTScreenSharing in pages loaded from a matching domain
        callback(typeof OTScreenSharing === 'object');
      },
      getConstraints(source, constraints, callback) {
        constraints.video = {
          mediaSource: source
        };

        // copy constraints under the video object and removed them from the root constraint object
        if (constraints.browserWindow) {
          constraints.video.browserWindow = constraints.browserWindow;
          delete constraints.browserWindow;
        }
        if (typeof constraints.scrollWithPage !== 'undefined') {
          constraints.video.scrollWithPage = constraints.scrollWithPage;
          delete constraints.scrollWithPage;
        }
        callback(void 0, constraints);
      }
    };
  }
};
exports.default = _default;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = processPubOptionsFactory;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _assert = _interopRequireDefault(__webpack_require__(159));
var _promiseEndeavour = _interopRequireDefault(__webpack_require__(316));
var _assign = _interopRequireDefault(__webpack_require__(9));
var _defaults = _interopRequireDefault(__webpack_require__(147));
var _pick = _interopRequireDefault(__webpack_require__(39));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _log = _interopRequireDefault(__webpack_require__(1));
var _env = _interopRequireDefault(__webpack_require__(3));
var _videoContentHint = __webpack_require__(317);
var _normaliseOptions = _interopRequireDefault(__webpack_require__(683));
var _isMediaStreamTrack = _interopRequireDefault(__webpack_require__(318));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _isScreenSharingSource = _interopRequireDefault(__webpack_require__(160));
var _hasAudioScreenShareSupport = _interopRequireDefault(__webpack_require__(288));
var _generateConstraintInfo = _interopRequireDefault(__webpack_require__(278));
var _screen_sharing = _interopRequireDefault(__webpack_require__(171));
var _usingOptionalMandatoryStyle = _interopRequireDefault(__webpack_require__(684));
const otError = (0, _otError.default)();
const GET_USER_ABORT_ERROR_MSG = 'getUserMedia request was aborted';
function processPubOptionsFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  ['deviceHelpers', 'getUserMediaHelper'].forEach(key => {
    (0, _assert.default)(deps[key], `${key} dependency must be injected into processPubOptions`);
  });
  const generateConstraintInfo = deps.generateConstraintInfo || _generateConstraintInfo.default;
  const windowMock = deps.global || (typeof window !== undefined ? window : global);
  const logging = deps.logging || (0, _log.default)('processPubOptions');
  const navigator = deps.navigator || windowMock.navigator;
  const screenSharing = deps.screenSharing || (0, _screen_sharing.default)();
  const env = deps.env || _env.default;
  const usingOptionalMandatoryStyle = (0, _usingOptionalMandatoryStyle.default)({
    navigator: navigator || {}
  });
  const _deps = deps,
    deviceHelpers = _deps.deviceHelpers,
    getUserMediaHelper = _deps.getUserMediaHelper;
  return (originalOptions, logPrefix, shouldStop) => {
    var _audioFallback$publis, _ref, _audioFallback$subscr;
    const options = (0, _normaliseOptions.default)(originalOptions, logPrefix, logging);
    const isScreenSharing = (0, _isScreenSharingSource.default)(options.videoSource);
    const isCustomAudioTrack = (0, _isMediaStreamTrack.default)(options.audioSource);
    const isCustomVideoTrack = (0, _isMediaStreamTrack.default)(options.videoSource);

    // getUserMedia is required if either audio or video is: a) not custom and b) not disabled
    const isAudioGumRequired = !isCustomAudioTrack && options.audioSource !== null;
    const isVideoGumRequired = !isCustomVideoTrack && options.videoSource !== null;
    const isGumRequired = isAudioGumRequired || isVideoGumRequired;
    const isBoolean = property => typeof property === 'boolean';

    // We display audio level and allow audio fallback if we're not screensharing
    // or if we're screensharing but with a custom audio track or if we support audio
    // screensharing on the current browser
    // @todo shouldn't this take into consideration if we have audio as well?
    const shouldAllowAudio = !isScreenSharing || isCustomAudioTrack || _hasAudioScreenShareSupport.default;
    const properties = (0, _defaults.default)(options, {
      mirror: !isScreenSharing && !isCustomVideoTrack,
      publishAudio: true,
      publishVideo: true,
      showControls: true,
      fitMode: isScreenSharing ? 'contain' : 'cover',
      insertDefaultUI: true,
      enableRenegotiation: false,
      enableStereo: false,
      enableDtx: false,
      disableAudioProcessing: false,
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true
    });
    const _options$audioFallbac = options.audioFallback,
      audioFallback = _options$audioFallbac === void 0 ? {} : _options$audioFallbac,
      deprecatedAudioFallbackEnabled = options.audioFallbackEnabled;
    properties.publisherAudioFallbackEnabled = (_audioFallback$publis = audioFallback.publisher) != null ? _audioFallback$publis : false;
    properties.subscriberAudioFallbackEnabled = (_ref = (_audioFallback$subscr = audioFallback.subscriber) != null ? _audioFallback$subscr : deprecatedAudioFallbackEnabled) != null ? _ref : !isScreenSharing;
    if (properties.videoContentHint !== undefined && !(0, _videoContentHint.isValidVideoContentHint)(properties.videoContentHint)) {
      logging.warn(`${logPrefix}: Invalid content hint. Valid content hints are "text", "detail", "motion", or ""`);
      properties.videoContentHint = '';
    }
    if (properties.name) {
      properties.name = String(properties.name);
    }
    if (!isBoolean(properties.enableDtx)) {
      properties.enableDtx = false;
    }
    if (!isBoolean(properties.enableStereo)) {
      properties.enableStereo = false;
    }
    if (properties.initials) {
      // Initials should be a string up to two characters, and upper-case.
      if (typeof properties.initials !== 'string') {
        properties.initials = '';
      }
      if (properties.initials.length > 2) {
        properties.initials = '';
        logging.warn('Publisher initials cleared. Only one or two characters allowed for publisher initials.');
      }
      properties.initials = properties.initials.toUpperCase();
    }
    if (!properties.constraints) {
      const constraintInfo = generateConstraintInfo(Object.assign({
        isScreenSharing,
        isCustomAudioTrack,
        isCustomVideoTrack
      }, (0, _pick.default)(properties, ['audioSource', 'publishAudio', 'videoSource', 'publishVideo', 'resolution', 'maxResolution', 'frameRate', 'facingMode', 'enableRenegotiation', 'enableStereo', 'disableAudioProcessing', 'echoCancellation', 'noiseSuppression', 'autoGainControl']), {
        env,
        usingOptionalMandatoryStyle: usingOptionalMandatoryStyle(isScreenSharing)
      }));
      (0, _assign.default)(properties, constraintInfo);
    } else {
      logging.warn(`${logPrefix}: You have passed your own constraints not using ours`);
    }
    const processedOptions = {
      isScreenSharing,
      isCustomAudioTrack,
      isCustomVideoTrack,
      shouldAllowAudio,
      properties
    };
    (0, _eventing.default)(processedOptions);
    processedOptions.getUserMedia = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var onAccessDialogOpened, onAccessDialogClosed, stream, devices, constraints, IOS_NEW_WINDOW_BUG, IOS_NOT_READABLE_ERROR_BUG, isNotReadableError, tryGetUserMedia;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            onAccessDialogOpened = function onAccessDialogOpened() {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return processedOptions.emit('accessDialogOpened', ...args);
            };
            onAccessDialogClosed = function onAccessDialogClosed() {
              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }
              return processedOptions.emit('accessDialogClosed', ...args);
            };
            if (isGumRequired) {
              _context2.next = 7;
              break;
            }
            stream = new windowMock.MediaStream();
            if (isCustomAudioTrack) {
              stream.addTrack(options.audioSource);
            }
            if (isCustomVideoTrack) {
              stream.addTrack(options.videoSource);
            }
            return _context2.abrupt("return", stream);
          case 7:
            if (!isScreenSharing) {
              _context2.next = 15;
              break;
            }
            _context2.next = 10;
            return screenSharing.getConstraints({
              onAccessDialogOpened,
              onAccessDialogClosed,
              videoSource: options.videoSource,
              constraints: properties.constraints
            });
          case 10:
            properties.constraints = _context2.sent;
            if (!shouldStop()) {
              _context2.next = 13;
              break;
            }
            throw otError(_Errors.default.CANCEL, new Error(GET_USER_ABORT_ERROR_MSG));
          case 13:
            _context2.next = 25;
            break;
          case 15:
            _context2.next = 17;
            return deviceHelpers.shouldAskForDevices();
          case 17:
            devices = _context2.sent;
            if (!shouldStop()) {
              _context2.next = 20;
              break;
            }
            throw otError(_Errors.default.CANCEL, new Error(GET_USER_ABORT_ERROR_MSG));
          case 20:
            logging.debug(`${logPrefix}: shouldAskForDevices:`, devices);
            if (!devices.video) {
              logging.warn(`${logPrefix}: Setting video constraint to false, there are no video sources`);
              properties.constraints.video = false;
            }
            if (!devices.audio) {
              logging.warn(`${logPrefix}: Setting audio constraint to false, there are no audio sources`);
              properties.constraints.audio = false;
            }

            // @todo this side effect needs to go...
            processedOptions.videoDevices = devices.videoDevices;
            processedOptions.audioDevices = devices.audioDevices;
          case 25:
            constraints = properties.constraints;
            logging.debug(`${logPrefix}: onConstraintsFound`, constraints);
            if (!shouldStop()) {
              _context2.next = 29;
              break;
            }
            throw otError(_Errors.default.CANCEL, new Error(GET_USER_ABORT_ERROR_MSG));
          case 29:
            IOS_NEW_WINDOW_BUG = 'Failed to acquire functional stream, this might be caused by ' + 'the following iOS bug: https://bugs.webkit.org/show_bug.cgi?id=188088';
            IOS_NOT_READABLE_ERROR_BUG = 'Failed to acquire functional stream, this might ' + 'be caused by the following iOS bug: https://bugs.webkit.org/show_bug.cgi?id=204106';
            isNotReadableError = err => err.originalName === 'NotReadableError' && err.originalMessage === 'Failed starting capture of a video track';
            tryGetUserMedia = /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                var gumRequest, stream, error, gumAudioRequest, audioStream;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      gumRequest = getUserMediaHelper(constraints, isScreenSharing);
                      gumRequest.on('accessDialogOpened', onAccessDialogOpened);
                      gumRequest.on('accessDialogClosed', onAccessDialogClosed);
                      _context.prev = 3;
                      _context.next = 6;
                      return gumRequest;
                    case 6:
                      stream = _context.sent;
                      if (!(env.isiOS && properties.publishVideo && stream.getVideoTracks().length && stream.getVideoTracks()[0].readyState === 'ended')) {
                        _context.next = 11;
                        break;
                      }
                      stream.getTracks().forEach(track => track.stop());
                      error = new Error(IOS_NEW_WINDOW_BUG);
                      throw error;
                    case 11:
                      return _context.abrupt("return", stream);
                    case 14:
                      _context.prev = 14;
                      _context.t0 = _context["catch"](3);
                      if (!env.isiOS) {
                        _context.next = 34;
                        break;
                      }
                      if (!(isNotReadableError(_context.t0) && env.iOSVersion >= 13 && env.iOSVersion < 13.4)) {
                        _context.next = 32;
                        break;
                      }
                      _context.prev = 18;
                      // As a workaround, we stop the remaining audio track to dispose hardware resources.
                      // Then promiseEndeavour will retry to invoke tryGetUserMedia.
                      // This bug might be related to https://bugs.webkit.org/show_bug.cgi?id=202405
                      gumAudioRequest = getUserMediaHelper({
                        audio: true,
                        video: false
                      }, false);
                      _context.next = 22;
                      return gumAudioRequest;
                    case 22:
                      audioStream = _context.sent;
                      audioStream.getTracks().forEach(track => track.stop());
                      _context.next = 29;
                      break;
                    case 26:
                      _context.prev = 26;
                      _context.t1 = _context["catch"](18);
                      logging.debug(`${logPrefix}: error disposing audio track`, _context.t1);
                    case 29:
                      throw new Error(IOS_NOT_READABLE_ERROR_BUG);
                    case 32:
                      if (!(_context.t0.name === _Errors.default.HARDWARE_UNAVAILABLE)) {
                        _context.next = 34;
                        break;
                      }
                      throw new Error(IOS_NEW_WINDOW_BUG);
                    case 34:
                      throw _context.t0;
                    case 35:
                      _context.prev = 35;
                      // Wait a little bit before we clean up the event handlers
                      // to give 'accessDialogClosed' a chance to fire
                      setTimeout(() => {
                        gumRequest.off('accessDialogOpened', onAccessDialogOpened);
                        gumRequest.off('accessDialogClosed', onAccessDialogClosed);
                      });
                      return _context.finish(35);
                    case 38:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[3, 14, 35, 38], [18, 26]]);
              }));
              return function tryGetUserMedia() {
                return _ref3.apply(this, arguments);
              };
            }();
            _context2.next = 35;
            return (0, _promiseEndeavour.default)(tryGetUserMedia, (err, attempt) => {
              const errors = [
              // Detected the iOS new window bug. Need try again.
              // https://jira.vonage.com/browse/OPENTOK-37691
              // https://bugs.webkit.org/show_bug.cgi?id=188088
              // Fixed 4th Dec 2018 - unsure which Safari versions are fixed
              IOS_NEW_WINDOW_BUG,
              // https://jira.vonage.com/browse/OPENTOK-39914
              IOS_NOT_READABLE_ERROR_BUG];
              if (errors.includes(err.message) && attempt === 1 && !shouldStop()) {
                return 1000;
              }
              return false;
            })();
          case 35:
            stream = _context2.sent;
            if (!shouldStop()) {
              _context2.next = 39;
              break;
            }
            stream.getTracks().forEach(track => {
              track.stop();
            });
            throw otError(_Errors.default.CANCEL, new Error(GET_USER_ABORT_ERROR_MSG));
          case 39:
            if (isCustomAudioTrack) {
              stream.addTrack(options.audioSource);
            }
            if (isCustomVideoTrack) {
              stream.addTrack(options.videoSource);
            }
            return _context2.abrupt("return", stream);
          case 42:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return processedOptions;
  };
}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _clone = _interopRequireDefault(__webpack_require__(41));
var _env = _interopRequireDefault(__webpack_require__(3));
var _isMediaStreamTrack = _interopRequireDefault(__webpack_require__(318));
const normaliseOptions = (originalOptions, logPrefix, logging) => {
  const options = originalOptions && typeof originalOptions === 'object' ? (0, _clone.default)(originalOptions) : {};
  if (options.audioSource === false) {
    options.audioSource = null;
  }
  if (options.videoSource === false) {
    options.videoSource = null;
  }
  // Ignore minVideoBitrate if it's defined but not a positive number
  if (options.minVideoBitrate !== undefined && !(typeof options.minVideoBitrate === 'number' && options.minVideoBitrate > 0)) {
    logging.warn(`${logPrefix}: Invalid minVideoBitrate in publisher properties. minVideoBitrate must ` + 'be a positive number');
    delete options.minVideoBitrate;
  }
  // Ignore audioBitrate if it's defined but not between 6kb and 510kb
  if (options.audioBitrate !== undefined && !(options.audioBitrate >= 6 * 1000 && options.audioBitrate <= 510 * 1000)) {
    logging.warn(`${logPrefix}: Invalid audioBitrate in publisher properties. audioBitrate must ` + `be a number between ${6 * 1000} and ${510 * 1000} bits per second`);
    delete options.audioBitrate;
  }
  // Crashes in FF45-46 and fails to publish in FF47-48
  if (_env.default.name === 'Firefox' && _env.default.version < 49) {
    const label = 'Firefox 48 and below';
    if ((0, _isMediaStreamTrack.default)(options.audioSource)) {
      options.audioSource = null;
      logging.warn(`${logPrefix}: Cannot use custom tracks with ${label}. Setting audioSource to null`);
    }
    if ((0, _isMediaStreamTrack.default)(options.videoSource)) {
      options.videoSource = null;
      logging.warn(`${logPrefix}: Cannot use custom tracks with ${label}. Setting videoSource to null`);
    }
  }
  return options;
};
var _default = normaliseOptions;
exports.default = _default;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = usingOptionalMandatoryStyleFactory;
var _env = _interopRequireDefault(__webpack_require__(3));
var _browserRejectsOptionalMandatory = _interopRequireDefault(__webpack_require__(287));
const name = _env.default.name,
  version = _env.default.version;
function usingOptionalMandatoryStyleFactory(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$navigator = _ref.navigator,
    navigator = _ref$navigator === void 0 ? window.navigator : _ref$navigator;
  return function usingOptionalMandatoryStyle(isScreenSharing) {
    return (
      // screen sharing should not be optionalMandatory in later chome or FF or chromium edge
      // see https://bugzilla.mozilla.org/show_bug.cgi?id=1321221 for firefox getDisplayMedia
      // see https://w3c.github.io/mediacapture-screen-share/#displaymediastreamconstraints for updated getDisplayMedia
      // see https://blog.addpipe.com/standards-compliant-screen-capture-in-chrome-72/ chrome constraint info
      isScreenSharing && !_browserRejectsOptionalMandatory.default ||
      // Internet Explorer
      !(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ||
      // Chrome <=60 doesn't accept ideal constraints and advanced
      // constraints are ignored by Firefox and broken by adapter.js
      // so we revert to optional/mandatory style. This has been
      // updated in Chrome 61.
      // See OPENTOK-32149, OPENTOK-32129 and OPENTOK-32655
      // Fixed in adapter.js: https://github.com/webrtc/adapter/issues/553
      name === 'Chrome' && version < 61
    );
  };
}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = getUserMediaFactory;
var _log = _interopRequireDefault(__webpack_require__(1));
/* eslint-disable global-require */

function getUserMediaFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  ['processPubOptions'].forEach(key => {
    if (!deps[key]) {
      throw new Error(`${key} dependency must be injected into OT.getUserMedia`);
    }
  });
  const logging = deps.logging || (0, _log.default)('getUserMedia');
  const _deps = deps,
    processPubOptions = _deps.processPubOptions;

  /**
  * Gets a MediaStream object that uses a microphone and camera as the audio and video source.
  * This method returns a promise that is resolved when the user has granted permission to
  * use the camera or microphone (or both) and the MediaStream object is available. The
  * promise is rejected if there is an error in getting the media or if the end user denies
  * access to the camera or microphone.
  * <p>
  * You can use this method to get MediaStreamTrack objects to pass into the
  * <code>audioSource</code> and <code>videoSource</code> options of the
  * <a href="OT.html#initPublisher">OT.initPublisher()</a> method. For example, call this method
  * to get a MediaStream that uses the microphone and camera as the audio and video sources. Then
  * you can call <code>getVideoTracks()[0]</code> on the MediaStream object to get a video
  * MediaStreamTrack object for the camera's video. You can then add the video MediaStreamTrack
  * as a source for an HTML Video element, draw that Video element into an HTML Canvas element, and
  * apply video filters or effects to the Canvas. Then you can call the <code>captureStream()</code>
  * method of the HTMLCanvasElement object to get a MediaStream object and call
  * <code>getVideoTracks()[0]</code> on the MediaStream object to get a video MediaStreamTrack
  * object (with the video filters or effects applied). Finally, you can use the video
  * MediaStreamTrack object as the <code>videoSource</code> property of the options you pass
  * into <code>OT.initPublisher()</code>. The Vonage Video API Publisher will use the
  * video track (with the filters and effects applied) as the video source.
  * </p>
  *
  * @param {Object} options <p>(optional) Defines settings for the MediaStream object.
  * The options are the same as those defined for the
  * <a href="OT.html#initPublisher">OT.initPublisher()</a> method. However, only the following
  * properties apply for <code>OT.getUserMedia()</code>:
  * </p>
  * <p>
  * <ul>
  *   <li><code>audioSource</code></li>
  *   <li><code>autoGainControl</code></li>
  *   <li><code>disableAudioProcessing</code></li>
  *   <li><code>echoCancellation</code></li>
  *   <li><code>enableStereo</code></li>
  *   <li><code>facingMode</code></li>
  *   <li><code>frameRate</code></li>
  *   <li><code>maxResolution</code></li>
  *   <li><code>noiseSuppression</code></li>
  *   <li><code>resolution</code></li>
  *   <li><code>videoSource</code></li>
  * </ul>
  * </p>
  *
  * @return {Promise} A promise that is resolved when the user has granted permission to
  * use the camera or microphone (or both) and the MediaStream object is available. The
  * promise is rejected if there is an error in getting the media, if the end user denies
  * access to the camera or microphone, or if the method is called on Internet Explorer.
  *
  * @see The options (especially <code>audioSource</code> and <code>videoSource</code>) of the
  * <a href="OT.html#initPublisher">OT.initPublisher()</a> method
  *
  * @method OT.getUserMedia
  * @memberof OT
  */
  const getUserMedia = function getUserMedia(pubOptions) {
    if (pubOptions === void 0) {
      pubOptions = {};
    }
    const processedOptions = processPubOptions(pubOptions, 'OT.getUserMedia', () => false);
    return processedOptions.getUserMedia().catch(err => {
      logging.error(`OT.getUserMedia failed to getUserMedia: ${err}`);
      throw err;
    });
  };
  return getUserMedia;
}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _events = _interopRequireDefault(__webpack_require__(12));
var _log = _interopRequireDefault(__webpack_require__(1));
var _audioFallbackVideoStates = _interopRequireDefault(__webpack_require__(77));
var _congestionLevels = __webpack_require__(28);
const logging = (0, _log.default)('AudioFallbackState');
const createAudioFallbackStateMachine = function createAudioFallbackStateMachine(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const logAnalyticsEvent = deps.logAnalyticsEvent;
  const ee = new _events.default();
  let congestionLevel = _congestionLevels.CongestionLevels.LOW;
  let videoState = _audioFallbackVideoStates.default.ACTIVE_VIDEO;
  const logCongestionLevelChange = function logCongestionLevelChange(_congestionLevel, metadata) {
    var _metadata$resolution, _metadata$resolution2;
    if (metadata === void 0) {
      metadata = {};
    }
    logAnalyticsEvent('congestionLevelChanged', 'Event', metadata.payload, {
      congestionLevel: _congestionLevel,
      algorithm: metadata.algorithm,
      audioPL: metadata.audioPacketLoss,
      videoPL: metadata.videoPacketLoss,
      videoSentEstimatedBandwidth: parseInt(metadata.bandwidth, 10),
      videoHeight: (_metadata$resolution = metadata.resolution) == null ? void 0 : _metadata$resolution.height,
      videoWidth: (_metadata$resolution2 = metadata.resolution) == null ? void 0 : _metadata$resolution2.width
    });
  };
  const _setVideoState = state => {
    videoState = state;
    ee.emit('stateChange', {
      state
    });
  };
  const _transitionToLow = () => {
    congestionLevel = _congestionLevels.CongestionLevels.LOW;
    _setVideoState(_audioFallbackVideoStates.default.ACTIVE_VIDEO);
  };
  const _transitionToMedium = () => {
    if (congestionLevel === _congestionLevels.CongestionLevels.LOW) {
      _setVideoState(_audioFallbackVideoStates.default.ACTIVE_VIDEO_WITH_WARNING);
    }
    congestionLevel = _congestionLevels.CongestionLevels.MEDIUM;
  };
  const _transitionToCritical = () => {
    congestionLevel = _congestionLevels.CongestionLevels.CRITICAL;
    _setVideoState(_audioFallbackVideoStates.default.SUSPENDED_VIDEO);
  };
  const _transitions = {
    [_congestionLevels.CongestionLevels.LOW]: _transitionToLow,
    [_congestionLevels.CongestionLevels.MEDIUM]: _transitionToMedium,
    [_congestionLevels.CongestionLevels.CRITICAL]: _transitionToCritical
  };
  return Object.assign(ee, {
    setCongestionLevel(level, metadata) {
      if (congestionLevel === level) {
        return;
      }
      const transition = _transitions[level];
      if (transition) {
        transition(metadata);
        logCongestionLevelChange(level, metadata);
      } else {
        logging.warn(`Invalid congestion level: ${level}`);
      }
    },
    getState() {
      return {
        videoState,
        congestionLevel
      };
    },
    setInternalState(state) {
      // Sets internal state without transitions or events
      videoState = state.videoState;
      congestionLevel = state.congestionLevel;
    },
    reset() {
      congestionLevel = _congestionLevels.CongestionLevels.LOW;
      videoState = _audioFallbackVideoStates.default.ACTIVE_VIDEO;
    }
  });
};
var _default = createAudioFallbackStateMachine;
exports.default = _default;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isEqual = _interopRequireDefault(__webpack_require__(688));
var _events = _interopRequireDefault(__webpack_require__(12));
var _timeBasedCongestionLevel = _interopRequireDefault(__webpack_require__(689));
var _basicCongestionLevel = _interopRequireDefault(__webpack_require__(690));
var _congestionLevelStats = _interopRequireDefault(__webpack_require__(321));
var _exponentialMovingAverageTracker = _interopRequireDefault(__webpack_require__(322));
var _getFairQualityBandwidthForResolution = _interopRequireDefault(__webpack_require__(692));
var _congestionLevels = __webpack_require__(28);
var _congestionDataCsvHelper = _interopRequireDefault(__webpack_require__(693));
const createCongestionLevelEstimator = function createCongestionLevelEstimator(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const ee = new _events.default();
  const _deps = deps,
    getStats = _deps.getStats,
    _deps$createMovingAve = _deps.createMovingAverageTracker,
    createMovingAverageTracker = _deps$createMovingAve === void 0 ? _exponentialMovingAverageTracker.default : _deps$createMovingAve,
    _deps$createTimeBased = _deps.createTimeBasedCongestionLevel,
    createTimeBasedCongestionLevel = _deps$createTimeBased === void 0 ? _timeBasedCongestionLevel.default : _deps$createTimeBased,
    _deps$createBasicCong = _deps.createBasicCongestionLevel,
    createBasicCongestionLevel = _deps$createBasicCong === void 0 ? _basicCongestionLevel.default : _deps$createBasicCong,
    _deps$createCongestio = _deps.createCongestionLevelStats,
    createCongestionLevelStats = _deps$createCongestio === void 0 ? _congestionLevelStats.default : _deps$createCongestio,
    _deps$getFairQualityB = _deps.getFairQualityBandwidthForResolution,
    getFairQualityBandwidthForResolution = _deps$getFairQualityB === void 0 ? _getFairQualityBandwidthForResolution.default : _deps$getFairQualityB;
  const congestionLevelTimeBased = createTimeBasedCongestionLevel();
  const congestionLevelBasic = createBasicCongestionLevel();
  const audioPacketLossStats = createMovingAverageTracker();
  const videoPacketLossStats = createMovingAverageTracker();
  const bandwidthStats = createMovingAverageTracker();
  let resolution;
  const congestionDataCsvHelper = (0, _congestionDataCsvHelper.default)();
  const getTimeBasedCongestionLevel = () => {
    if (audioPacketLossStats.getDataPointCount() === 0) {
      return _congestionLevels.LOW;
    }
    return congestionLevelTimeBased.getLevel({
      audioPacketLoss: audioPacketLossStats.getMovingAverageValue()
    });
  };
  const getBasicCongestionLevel = () => {
    if (bandwidthStats.getDataPointCount() === 0 || audioPacketLossStats.getDataPointCount() === 0) {
      return _congestionLevels.LOW;
    }
    return congestionLevelBasic.getLevel({
      bandwidth: bandwidthStats.getMovingAverageValue(),
      audioPacketLoss: audioPacketLossStats.getMovingAverageValue(),
      bandwidthFairThreshold: getFairQualityBandwidthForResolution(resolution)
    });
  };
  const addLoggingDataPoint = _ref => {
    let audioPacketLoss = _ref.audioPacketLoss,
      videoPacketLoss = _ref.videoPacketLoss,
      bandwidth = _ref.bandwidth;
    congestionDataCsvHelper.addData({
      timestamp: Date.now(),
      rawAudioPL: audioPacketLoss.toFixed(3),
      rawVideoPL: videoPacketLoss.toFixed(3),
      rawBW: parseInt(bandwidth, 10),
      videoWidth: resolution.width,
      videoHeight: resolution.height,
      avgAudioPL: audioPacketLossStats.getMovingAverageValue().toFixed(3),
      avgVideoPL: videoPacketLossStats.getMovingAverageValue().toFixed(3),
      avgBW: parseInt(bandwidthStats.getMovingAverageValue(), 10)
    });
  };
  const getAlgorithmName = _ref2 => {
    let timeLevel = _ref2.timeLevel,
      basicLevel = _ref2.basicLevel;
    if (basicLevel === timeLevel) {
      return 'basic,timeBased';
    } else if (basicLevel > timeLevel) {
      return 'basic';
    }
    return 'timeBased';
  };
  const getLoggingMetadata = _ref3 => {
    let congestionLevel = _ref3.congestionLevel,
      timeLevel = _ref3.timeLevel,
      basicLevel = _ref3.basicLevel;
    if (congestionLevel === _congestionLevels.LOW) {
      return;
    }
    // eslint-disable-next-line consistent-return
    return {
      resolution,
      algorithm: getAlgorithmName({
        timeLevel,
        basicLevel
      }),
      videoPacketLoss: videoPacketLossStats.getMovingAverageValue(),
      audioPacketLoss: audioPacketLossStats.getMovingAverageValue(),
      bandwidth: bandwidthStats.getMovingAverageValue(),
      payload: congestionDataCsvHelper.getCsvString()
    };
  };
  const getCongestionLevel = () => {
    const timeLevel = getTimeBasedCongestionLevel();
    const basicLevel = getBasicCongestionLevel();
    const congestionLevel = Math.max(timeLevel, basicLevel);
    ee.emit('congestionLevel', congestionLevel, getLoggingMetadata({
      congestionLevel,
      timeLevel,
      basicLevel
    }));
  };
  const onStatsAvailable = _ref4 => {
    let audioPacketLoss = _ref4.audioPacketLoss,
      videoPacketLoss = _ref4.videoPacketLoss,
      bandwidth = _ref4.bandwidth,
      videoResolution = _ref4.videoResolution;
    if (resolution && !(0, _isEqual.default)(resolution, videoResolution)) {
      audioPacketLossStats.reset();
      videoPacketLossStats.reset();
      bandwidthStats.reset();
    }
    resolution = videoResolution;
    bandwidthStats.addValue(bandwidth);
    videoPacketLossStats.addValue(videoPacketLoss);
    audioPacketLossStats.addValue(audioPacketLoss);
    addLoggingDataPoint({
      audioPacketLoss,
      videoPacketLoss,
      bandwidth
    });
    getCongestionLevel();
  };
  const congestionLevelStats = createCongestionLevelStats(getStats);
  congestionLevelStats.on('statsAvailable', stats => {
    onStatsAvailable(stats);
  });
  return Object.assign(ee, {
    start() {
      congestionLevelStats.start();
    },
    stop() {
      congestionLevelStats.stop();
      congestionDataCsvHelper.reset();
    }
  });
};
var _default = createCongestionLevelEstimator;
exports.default = _default;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(142);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _defaultParameters = _interopRequireDefault(__webpack_require__(174));
var _congestionLevels = __webpack_require__(28);
const createTimeBasedCongestionLevel = function createTimeBasedCongestionLevel(customParams) {
  if (customParams === void 0) {
    customParams = {};
  }
  const params = Object.assign({}, _defaultParameters.default, customParams);
  let dangerZone = false;
  let dangerZoneStart;
  return {
    getLevel(_ref) {
      let audioPacketLoss = _ref.audioPacketLoss;
      if (audioPacketLoss < params.packetLossCriticalThreshold) {
        dangerZone = false;
        return _congestionLevels.LOW;
      }
      const currentTime = Date.now();
      if (!dangerZone) {
        dangerZoneStart = currentTime;
        dangerZone = true;
      }
      if (currentTime > dangerZoneStart + params.criticalCongestionPeriod) {
        return _congestionLevels.CRITICAL;
      } else if (currentTime > dangerZoneStart + params.criticalCongestionPeriod / 2) {
        return _congestionLevels.MEDIUM;
      }
      return _congestionLevels.LOW;
    }
  };
};
var _default = createTimeBasedCongestionLevel;
exports.default = _default;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _defaultParameters = _interopRequireDefault(__webpack_require__(174));
var _congestionLevels = __webpack_require__(28);
const createCongestionLevelBasic = function createCongestionLevelBasic(customParams) {
  if (customParams === void 0) {
    customParams = {};
  }
  const params = Object.assign({}, _defaultParameters.default, customParams);
  return {
    getLevel(_ref) {
      let bandwidth = _ref.bandwidth,
        audioPacketLoss = _ref.audioPacketLoss,
        bandwidthFairThreshold = _ref.bandwidthFairThreshold;
      let congestionLevel;
      if (bandwidth <= 0) {
        if (audioPacketLoss > params.packetLossCriticalThresholdMediumBw) {
          congestionLevel = _congestionLevels.CRITICAL;
        } else {
          congestionLevel = _congestionLevels.LOW;
        }
        return congestionLevel;
      }
      if (bandwidth >= bandwidthFairThreshold) {
        // LOW CONGESTION ZONE
        congestionLevel = _congestionLevels.LOW;
      } else if (bandwidth >= params.bandwidthCriticalThreshold) {
        // MEDIUM BW ZONE WITH DEPENDENCY WITH PL
        if (bandwidth >= (params.bandwidthCriticalThreshold + bandwidthFairThreshold) / 2.0) {
          // IF IN THE HIGHER MID-BAND WITH MEDIUM BW
          if (audioPacketLoss > params.packetLossCriticalThresholdMediumBw * 2.0) {
            congestionLevel = _congestionLevels.CRITICAL;
          } else {
            congestionLevel = _congestionLevels.MEDIUM;
          }
        } else if (audioPacketLoss > params.packetLossCriticalThresholdMediumBw) {
          // IF IN THE LOWER MID-BAND WITH MEDIUM BW
          congestionLevel = _congestionLevels.CRITICAL;
        } else {
          congestionLevel = _congestionLevels.MEDIUM;
        }
      } else if (audioPacketLoss > params.packetLossCriticalThreshold) {
        // CRITICAL BW ZONE WITH DEPENDENCY WITH PL
        congestionLevel = _congestionLevels.CRITICAL;
      } else {
        congestionLevel = _congestionLevels.MEDIUM;
      }
      if (congestionLevel === undefined) {
        throw new Error('undefined congestion level');
      }
      return congestionLevel;
    }
  };
};
var _default = createCongestionLevelBasic;
exports.default = _default;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.parseStats = exports.getVideoResolution = exports.getVideoPacketStats = exports.getVideoPacketLoss = exports.getSelectedCandidatePairId = exports.getBandwidth = exports.getAudioPacketStats = exports.getAudioPacketLoss = void 0;
const getPacketStats = (stats, mediaKind) => {
  const outboundRtpDataStats = stats.filter(_ref => {
    let type = _ref.type,
      kind = _ref.kind;
    return type === 'outbound-rtp' && kind === mediaKind;
  });
  const remoteInboundRtpDataStats = stats.filter(_ref2 => {
    let type = _ref2.type,
      kind = _ref2.kind;
    return type === 'remote-inbound-rtp' && kind === mediaKind;
  });
  const timestamp = remoteInboundRtpDataStats[0].timestamp;

  // We only collect fractionLost for first track, so only use this value for audioPL
  // TODO: VIDCS-1373 add video fractionLost for each simulcast layer weighted by packetsSent
  const fractionLost = remoteInboundRtpDataStats[0].fractionLost;

  // Sum total packets from all rtp stats, could be up to 3 video streams with simulcast
  const packetsSent = outboundRtpDataStats.reduce((acc, data) => acc + data.packetsSent, 0);
  const packetsLost = remoteInboundRtpDataStats.reduce((acc, data) => acc + data.packetsLost, 0);
  return {
    [`${mediaKind}ReportTimestamp`]: timestamp,
    [`${mediaKind}PacketsSent`]: packetsSent,
    [`${mediaKind}PacketsLost`]: packetsLost,
    [`${mediaKind}FractionLost`]: fractionLost
  };
};
const getVideoResolution = stats => {
  const outboundRtpDataStats = stats.filter(_ref3 => {
    let type = _ref3.type,
      kind = _ref3.kind;
    return type === 'outbound-rtp' && kind === 'video';
  }).filter(stat => stat.frameHeight !== undefined && stat.frameWidth !== undefined);

  // get largest resolution of simulcast layers
  const resolution = outboundRtpDataStats.reduce((acc, data) => ({
    width: Math.max(acc.width, data.frameWidth),
    height: Math.max(acc.height, data.frameHeight)
  }), {
    width: 0,
    height: 0
  });
  return resolution;
};
exports.getVideoResolution = getVideoResolution;
const getAudioPacketStats = stats => getPacketStats(stats, 'audio');
exports.getAudioPacketStats = getAudioPacketStats;
const getVideoPacketStats = stats => getPacketStats(stats, 'video');
exports.getVideoPacketStats = getVideoPacketStats;
const getSelectedCandidatePairId = stats => {
  const transportStats = stats.find(_ref4 => {
    let type = _ref4.type;
    return type === 'transport';
  });
  return transportStats == null ? void 0 : transportStats.selectedCandidatePairId;
};
exports.getSelectedCandidatePairId = getSelectedCandidatePairId;
const getBandwidthForCandidatePairId = (stats, selectedCandidatePairId) => {
  // eslint-disable-line consistent-return
  if (selectedCandidatePairId) {
    const candidatePairData = stats.find(_ref5 => {
      let id = _ref5.id,
        type = _ref5.type;
      return id === selectedCandidatePairId && type === 'candidate-pair';
    });
    return candidatePairData == null ? void 0 : candidatePairData.availableOutgoingBitrate;
  }
};
const getBandwidth = stats => {
  const bandwidth = getBandwidthForCandidatePairId(stats, getSelectedCandidatePairId(stats));
  if (bandwidth !== undefined) {
    return bandwidth;
  }
  const candidatePairData = stats.find(_ref6 => {
    let type = _ref6.type,
      availableOutgoingBitrate = _ref6.availableOutgoingBitrate;
    return type === 'candidate-pair' && availableOutgoingBitrate !== undefined;
  });
  return candidatePairData == null ? void 0 : candidatePairData.availableOutgoingBitrate;
};
exports.getBandwidth = getBandwidth;
const parseStats = stats => {
  const _getAudioPacketStats = getAudioPacketStats(stats),
    audioPacketsSent = _getAudioPacketStats.audioPacketsSent,
    audioPacketsLost = _getAudioPacketStats.audioPacketsLost,
    audioReportTimestamp = _getAudioPacketStats.audioReportTimestamp,
    audioFractionLost = _getAudioPacketStats.audioFractionLost;
  const _getVideoPacketStats = getVideoPacketStats(stats),
    videoPacketsSent = _getVideoPacketStats.videoPacketsSent,
    videoPacketsLost = _getVideoPacketStats.videoPacketsLost,
    videoReportTimestamp = _getVideoPacketStats.videoReportTimestamp;
  const bandwidth = getBandwidth(stats);
  const videoResolution = getVideoResolution(stats);
  return {
    bandwidth,
    audioFractionLost,
    audioReportTimestamp,
    audioPacketsSent,
    audioPacketsLost,
    videoReportTimestamp,
    videoPacketsSent,
    videoPacketsLost,
    videoResolution
  };
};
exports.parseStats = parseStats;
const safeDivide = (num, den) => {
  if (den === 0) {
    return 0;
  }
  return num / den;
};
const getPacketLoss = (type, currentParsedStats, prevParsedStats) => {
  const packetsSentDelta = currentParsedStats[`${type}PacketsSent`] - prevParsedStats[`${type}PacketsSent`];
  const packetsLostDelta = currentParsedStats[`${type}PacketsLost`] - prevParsedStats[`${type}PacketsLost`];
  return safeDivide(packetsLostDelta, packetsSentDelta);
};
const getAudioPacketLoss = (currentParsedStats, prevParsedStats) => getPacketLoss('audio', currentParsedStats, prevParsedStats);
exports.getAudioPacketLoss = getAudioPacketLoss;
const getVideoPacketLoss = (currentParsedStats, prevParsedStats) => getPacketLoss('video', currentParsedStats, prevParsedStats);
exports.getVideoPacketLoss = getVideoPacketLoss;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Values taken from 'fairQualityBitrate': https://github.com/opentok/chef-rumor/blob/master/attributes/default.rb
const fairQualityBitrateForResolution = [{
  width: '320',
  height: '180',
  fairQualityBitrate: 120000
}, {
  width: '320',
  height: '240',
  fairQualityBitrate: 120000
}, {
  width: '352',
  height: '288',
  fairQualityBitrate: 125000
}, {
  width: '480',
  height: '270',
  fairQualityBitrate: 125000
}, {
  width: '640',
  height: '360',
  fairQualityBitrate: 150000
}, {
  width: '640',
  height: '480',
  fairQualityBitrate: 150000
}, {
  width: '960',
  height: '540',
  fairQualityBitrate: 150000
}, {
  width: '1280',
  height: '720',
  fairQualityBitrate: 400000
}, {
  width: '1920',
  height: '1080',
  fairQualityBitrate: 500000
}].sort((a, b) => a.fairQualityBitrate - b.fairQualityBitrate); // ensure sorted by desc bitrate

// https://github.com/opentok/chef-rumor/blob/master/attributes/default.rb
const defaultFairQualityBitrate = 250000;
const maxQualityBitrate = fairQualityBitrateForResolution.reduce((currentMax, _ref) => {
  let fairQualityBitrate = _ref.fairQualityBitrate;
  return Math.max(currentMax, fairQualityBitrate);
}, defaultFairQualityBitrate);
const getFairQualityBandwidthForResolution = _ref2 => {
  var _fairQualityBitrateFo;
  let videoWidth = _ref2.width,
    videoHeight = _ref2.height;
  if (!videoWidth || !videoHeight) return defaultFairQualityBitrate;

  // Step function returns upper limit fair bitrate for resolution area
  // using lookup table as input data.
  const bitrate = (_fairQualityBitrateFo = fairQualityBitrateForResolution.find(_ref3 => {
    let height = _ref3.height,
      width = _ref3.width;
    return videoHeight * videoWidth <= height * width;
  })) == null ? void 0 : _fairQualityBitrateFo.fairQualityBitrate;
  return bitrate || maxQualityBitrate;
};
var _default = getFairQualityBandwidthForResolution;
exports.default = _default;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _pick = _interopRequireDefault(__webpack_require__(39));
const keys = ['timestamp', 'rawAudioPL', 'rawVideoPL', 'rawBW', 'videoWidth', 'videoHeight', 'avgAudioPL', 'avgVideoPL', 'avgBW'];
const createCongestionDataCsvHelper = function createCongestionDataCsvHelper(maxDataPoints) {
  if (maxDataPoints === void 0) {
    maxDataPoints = 10;
  }
  let loggingDataPoints = [];
  return {
    addData(data) {
      loggingDataPoints.push((0, _pick.default)(data, keys));
      if (loggingDataPoints.length > maxDataPoints) {
        // We only keep the last 10 data points for logging
        loggingDataPoints.shift();
      }
    },
    reset() {
      loggingDataPoints = [];
    },
    getCsvString() {
      const csvData = loggingDataPoints.map(dataPoint => {
        const data = keys.map(key => dataPoint[key]);
        return data.join(',');
      });
      return [keys.join(','), ...csvData].join('\r\n');
    }
  };
};
var _default = createCongestionDataCsvHelper;
exports.default = _default;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _events = _interopRequireDefault(__webpack_require__(12));
var _networkProbe3 = _interopRequireDefault(__webpack_require__(695));
var _congestionLevels = __webpack_require__(28);
var _getDelayForProbeNumber = _interopRequireDefault(__webpack_require__(323));
const createNetworkQualityMonitor = function createNetworkQualityMonitor(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const ee = new _events.default();
  const _deps = deps,
    getStats = _deps.getStats,
    setVideoActive = _deps.setVideoActive,
    _deps$createNetworkPr = _deps.createNetworkProbe,
    createNetworkProbe = _deps$createNetworkPr === void 0 ? _networkProbe3.default : _deps$createNetworkPr;
  let networkProbe;
  let timeoutId;
  const stop = () => {
    var _networkProbe, _networkProbe2;
    (_networkProbe = networkProbe) == null ? void 0 : _networkProbe.removeAllListeners();
    clearTimeout(timeoutId);
    (_networkProbe2 = networkProbe) == null ? void 0 : _networkProbe2.stop();
    networkProbe = undefined;
  };
  const start = function start(_temp) {
    let _ref = _temp === void 0 ? {} : _temp,
      _ref$getDelayForProbe = _ref.getDelayForProbeNumber,
      getDelayForProbeNumber = _ref$getDelayForProbe === void 0 ? _getDelayForProbeNumber.default : _ref$getDelayForProbe;
    if (networkProbe) {
      // ensure we never run more than one instance at the same time
      stop();
    }
    networkProbe = createNetworkProbe({
      getStats
    });
    let probeCount = 0;
    const runProbeWithDelay = () => {
      const delay = getDelayForProbeNumber(probeCount);
      probeCount++;
      timeoutId = setTimeout(() => {
        setVideoActive(true);
        networkProbe.start();
      }, delay);
    };
    networkProbe.on('probeResult', congestionLevel => {
      if (congestionLevel === _congestionLevels.LOW) {
        ee.emit('networkRecovered');
      } else {
        setVideoActive(false);
        runProbeWithDelay();
      }
    });
    runProbeWithDelay();
  };
  return Object.assign(ee, {
    start,
    stop
  });
};
var _default = createNetworkQualityMonitor;
exports.default = _default;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _events = _interopRequireDefault(__webpack_require__(12));
var _recoveryCongestionLevelCalculator = _interopRequireDefault(__webpack_require__(696));
var _congestionLevels = __webpack_require__(28);
var _log = _interopRequireDefault(__webpack_require__(1));
var _time = __webpack_require__(113);
const logger = (0, _log.default)('networkProbe');
const MAX_PROBE_TIME = 10 * _time.ONE_SECOND_IN_MS;
const createNetworkProbe = function createNetworkProbe(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const ee = new _events.default();
  const _deps = deps,
    getStats = _deps.getStats,
    _deps$createRecoveryC = _deps.createRecoveryCongestionLevelCalculator,
    createRecoveryCongestionLevelCalculator = _deps$createRecoveryC === void 0 ? _recoveryCongestionLevelCalculator.default : _deps$createRecoveryC;
  let probeStartTime;
  const congestionLevelCalculator = createRecoveryCongestionLevelCalculator({
    getStats
  });
  const stopProbeWithResult = result => {
    congestionLevelCalculator.stop();
    logger.info(`Network probe result ${result}`);
    ee.emit('probeResult', result);
  };
  congestionLevelCalculator.on('congestionLevel', congestionLevel => {
    const probeTime = Date.now() - probeStartTime;
    if (congestionLevel === _congestionLevels.CRITICAL) {
      // We stop probing immediately if we get a CRITICAL result
      stopProbeWithResult(_congestionLevels.CRITICAL);
    } else if (probeTime > MAX_PROBE_TIME) {
      if (congestionLevel === _congestionLevels.LOW) {
        stopProbeWithResult(_congestionLevels.LOW);
      } else {
        // final measurement result was MEDIUM so we keep CRITICAL level
        stopProbeWithResult(_congestionLevels.CRITICAL);
      }
    }
  });
  return Object.assign(ee, {
    start() {
      probeStartTime = Date.now();
      logger.info('Start network probe');
      congestionLevelCalculator.start();
    },
    stop() {
      logger.info('Stop network probe');
      congestionLevelCalculator.stop();
    }
  });
};
var _default = createNetworkProbe;
exports.default = _default;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _events = _interopRequireDefault(__webpack_require__(12));
var _bandwidthCongestionLevel = _interopRequireDefault(__webpack_require__(697));
var _congestionLevelStats = _interopRequireDefault(__webpack_require__(321));
var _exponentialMovingAverageTracker = _interopRequireDefault(__webpack_require__(322));
var _congestionLevels = __webpack_require__(28);
const createRecoveryCongestionLevelCalculator = function createRecoveryCongestionLevelCalculator(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const ee = new _events.default();
  const _deps = deps,
    getStats = _deps.getStats,
    _deps$createMovingAve = _deps.createMovingAverageTracker,
    createMovingAverageTracker = _deps$createMovingAve === void 0 ? _exponentialMovingAverageTracker.default : _deps$createMovingAve,
    _deps$createBandwidth = _deps.createBandwidthCongestionLevel,
    createBandwidthCongestionLevel = _deps$createBandwidth === void 0 ? _bandwidthCongestionLevel.default : _deps$createBandwidth,
    _deps$createCongestio = _deps.createCongestionLevelStats,
    createCongestionLevelStats = _deps$createCongestio === void 0 ? _congestionLevelStats.default : _deps$createCongestio;
  const bandwidthCongestionLevel = createBandwidthCongestionLevel();
  const audioPacketLossStats = createMovingAverageTracker();
  const videoPacketLossStats = createMovingAverageTracker();
  const congestionLevelStats = createCongestionLevelStats(getStats);
  const resetStats = () => {
    audioPacketLossStats.reset();
    videoPacketLossStats.reset();
  };
  const stopStatsCalculation = () => {
    congestionLevelStats.stop();
    resetStats();
  };
  const getCongestionLevel = () => {
    if (videoPacketLossStats.getDataPointCount() === 0 || audioPacketLossStats.getDataPointCount() === 0) {
      return _congestionLevels.LOW;
    }
    return bandwidthCongestionLevel.getLevel({
      audioPacketLoss: audioPacketLossStats.getMovingAverageValue(),
      videoPacketLoss: videoPacketLossStats.getMovingAverageValue()
    });
  };
  const onStatsAvailable = _ref => {
    let audioPacketLoss = _ref.audioPacketLoss,
      videoPacketLoss = _ref.videoPacketLoss;
    audioPacketLossStats.addValue(audioPacketLoss);
    videoPacketLossStats.addValue(videoPacketLoss);
    const congestionLevel = getCongestionLevel();
    ee.emit('congestionLevel', congestionLevel);
  };
  congestionLevelStats.on('statsAvailable', onStatsAvailable);
  return Object.assign(ee, {
    start() {
      congestionLevelStats.start();
    },
    stop() {
      stopStatsCalculation();
    }
  });
};
var _default = createRecoveryCongestionLevelCalculator;
exports.default = _default;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _defaultParameters = _interopRequireDefault(__webpack_require__(174));
var _congestionLevels = __webpack_require__(28);
const audioPacketLossFactor = 0.8;
const mediumFactor = 0.5;
const createBandwidthCongestionLevel = function createBandwidthCongestionLevel(customParams) {
  if (customParams === void 0) {
    customParams = {};
  }
  const params = Object.assign({}, _defaultParameters.default, customParams);
  const videoPacketLossCriticalThreshold = params.packetLossCriticalThreshold;
  const videoPacketLossMediumThreshold = videoPacketLossCriticalThreshold * mediumFactor;
  const audioPacketLossCriticalThreshold = videoPacketLossCriticalThreshold * audioPacketLossFactor;
  const audioPacketLossMediumThreshold = audioPacketLossCriticalThreshold * mediumFactor;

  // adapted from https://github.com/opentok/mantis/blob/development/src/registry/CongestionLevelPolicy.cpp#L54
  return {
    getLevel(_ref) {
      let audioPacketLoss = _ref.audioPacketLoss,
        videoPacketLoss = _ref.videoPacketLoss;
      if (audioPacketLoss > audioPacketLossCriticalThreshold || videoPacketLoss > videoPacketLossCriticalThreshold) {
        return _congestionLevels.CRITICAL;
      } else if (audioPacketLoss > audioPacketLossMediumThreshold || videoPacketLoss > videoPacketLossMediumThreshold) {
        return _congestionLevels.MEDIUM;
      }
      return _congestionLevels.LOW;
    }
  };
};
var _default = createBandwidthCongestionLevel;
exports.default = _default;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
// Some Safari users can't establish a call using server reflexive candidates
// * https://bugs.webkit.org/show_bug.cgi?id=233752
// * https://jira.vonage.com/browse/OPENTOK-45642
const hasConnectivityBug = version => version >= 15 && version < 15.4;
var _default = env => {
  // eslint-disable-next-line global-require, no-param-reassign
  env = env || _env.default;
  if (env.isiPad) {
    // UA varies in iPad depending on Desktop/Mobile site preferences. So we could have the
    // following scenarios:
    // - Safari iPad using mobile preferred.
    // - Safari iPad using desktop preferred.
    // - Webkit browser (e.g. Chrome|Firefox) using mobile preferred.
    // - Webkit browser (e.g. Chrome|Firefox) using desktop preferred.
    // When desktop preferred, we should check for the Safari version, otherwise check the
    // iOS version. However we do not have a Safari version for Chrome iPad using desktop
    // agent. Thus we will always force TURN in iPad to avoid an overcomplex logic
    return true;
  }
  if (env.isiPhone) {
    return hasConnectivityBug(env.iOSVersion);
  }
  if (env.isSafari) {
    return hasConnectivityBug(env.version);
  }
  return false;
};
exports.default = _default;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Values taken from https://github.com/opentok/chef-rumor/blob/master/attributes/default.rb#L65
const maxBitratePerResolution = [{
  width: 320,
  height: 180,
  maxBitrate: 300000
}, {
  width: 320,
  height: 240,
  maxBitrate: 400000
}, {
  width: 352,
  height: 288,
  maxBitrate: 500000
}, {
  width: 480,
  height: 270,
  maxBitrate: 550000
}, {
  width: 640,
  height: 360,
  maxBitrate: 800000
}, {
  width: 640,
  height: 480,
  maxBitrate: 800000
}, {
  width: 960,
  height: 540,
  maxBitrate: 1100000
}, {
  width: 1280,
  height: 720,
  maxBitrate: 2500000
}, {
  width: 1920,
  height: 1080,
  maxBitrate: 4500000
}].sort((a, b) => a.maxBitrate - b.maxBitrate); // ensure sorted by desc bitrate

// Use maxBitrate for 1920x1080 as default if lookup fails.
const defaultMaxBitrate = 4500000;
const getMaxBitrateForResolution = (videoWidth, videoHeight) => {
  var _maxBitratePerResolut;
  if (!videoWidth || !videoHeight) return defaultMaxBitrate;

  // Step function returns upper limit max bitrate for resolution area
  // using lookup table as input data.
  const bitrate = (_maxBitratePerResolut = maxBitratePerResolution.find(_ref => {
    let height = _ref.height,
      width = _ref.width;
    return videoHeight * videoWidth <= height * width;
  })) == null ? void 0 : _maxBitratePerResolut.maxBitrate;
  return bitrate || defaultMaxBitrate;
};
var _default = getMaxBitrateForResolution;
exports.default = _default;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(64),
    baseForOwn = __webpack_require__(105),
    baseIteratee = __webpack_require__(37);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = watchAudioAcquisition;
/*
 * Installs a watcher that will calls the given callback if the audio acquisition seems to not
 * work porperly.
 *
 * It runs every 3 seconds and poll getStats to find any sign of audio bytes sent. If it can't find
 * any it signals the anomaly by executing the given function.
 *
 * @param {function(cb: function(DOMError, Array<RTCStats>))} getStats
 *    the function to call to get the stats
 * @param {function} warningCb to be called when a potential problem is detected
 * @returns {function} cancel the watch
 */
function watchAudioAcquisition(getStats, warningCb) {
  let previousBytesSent = 0;
  let isCallbackNeeded = true;
  const isAudioStat = rtcStats => rtcStats.type === 'outbound-rtp' && rtcStats.ssrc && (rtcStats.kind === 'audio' || rtcStats.mediaType === 'audio');
  const isAnomalyDetected = currentBytesSent => currentBytesSent === previousBytesSent && isCallbackNeeded;
  const isAnomalyResolved = currentBytesSent => currentBytesSent !== previousBytesSent;
  const handleStats = (error, stats) => {
    if (error) return;
    stats.forEach(rtcStats => {
      if (isAudioStat(rtcStats)) {
        const statType = typeof rtcStats.bytesSent;
        let currentBytesSent;
        // Number.MAX_SAFE_INTEGER is a 16 digit number, but it is only 53 bits. We manually modulo
        // 15 digits to avoid big number problems.
        const maxDigit = 15;
        if (statType === 'number') {
          currentBytesSent = rtcStats.bytesSent % Math.pow(10, maxDigit);
        } else if (statType === 'string') {
          const safeIntegerBytesSent = rtcStats.bytesSent.slice(rtcStats.bytesSent.length - maxDigit);
          currentBytesSent = parseInt(safeIntegerBytesSent, 10);
        } else {
          return;
        }
        if (isAnomalyDetected(currentBytesSent)) {
          warningCb();
          // Execute the callback only once per audio loss
          isCallbackNeeded = false;
        } else if (isAnomalyResolved(currentBytesSent)) {
          // Once resolved, we may need to use the callback in future audio loss
          isCallbackNeeded = true;
        }
        previousBytesSent = currentBytesSent;
      }
    });
  };
  const audioMonitor = setInterval(() => {
    getStats(handleStats);
  }, 3000);
  return function cancel() {
    clearInterval(audioMonitor);
  };
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _time = __webpack_require__(113);
var _getDelayForProbeNumber = _interopRequireDefault(__webpack_require__(323));
const getDelayForAmrProbe = probeNumber => {
  if (probeNumber === 0) {
    return 5 * _time.ONE_SECOND_IN_MS;
  }
  return (0, _getDelayForProbeNumber.default)(probeNumber - 1);
};
var _default = getDelayForAmrProbe;
exports.default = _default;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = SinglePeerConnectionAdapterFactory;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _eventing = _interopRequireDefault(__webpack_require__(6));
var _collectStatsHelper = __webpack_require__(704);
/* global MediaStream */
/* eslint-disable global-require, no-param-reassign, no-void, no-shadow */
/* eslint-disable func-names */

const createNativeMediaStream = () => new MediaStream();
function SinglePeerConnectionAdapterFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const createMediaStream = deps.createMediaStream || createNativeMediaStream;
  return function SinglePeerConnectionAdapter(options, controller) {
    const _transceivers = {};
    const _tracks = [];
    const mediaStream = createMediaStream();
    this._id = (0, _uuid.default)();

    // Trigger wrappers to ensure events only fired once
    let _iceConnectedEmitted = false;
    const _onIceConnected = () => {
      if (!_iceConnectedEmitted) {
        this.trigger('iceConnected');
        _iceConnectedEmitted = true;
      }
    };
    let _iceConnectionStateConnectedEmitted = false;
    const _onIceConnectionStateChanged = state => {
      if (state === 'connected' && _iceConnectionStateConnectedEmitted) {
        return;
      }
      _iceConnectionStateConnectedEmitted = state === 'connected';
      this.trigger('iceConnectionStateChange', state);
    };

    // SPC events wrapper for PeerConnection
    const _onClosed = () => this.trigger('close');
    const _onRemoteVideoSupported = supported => this.trigger('remoteVideoSupported', supported);
    const _onPeerError = _ref => {
      let reason = _ref.reason,
        prefix = _ref.prefix;
      return this.trigger('error', {
        reason,
        prefix
      });
    };
    const _onQoS = qos => {
      qos.parsedStats.singlePeerConnection = true;
      this.trigger('qos', qos);
    };
    const _onSignalingStateChange = state => this.trigger('signalingStateChange', state);
    const _onSignalingStateStable = state => this.trigger('signalingStateStable', state);
    const _onDecryptFailed = () => this.trigger('decryptFailed');
    const _onDecryptRestored = () => this.trigger('decryptRestored');
    (0, _eventing.default)(this);
    const _peerConnection = controller.getPeerConnection(options, this);
    _peerConnection.on({
      iceConnected: _onIceConnected,
      close: _onClosed,
      signalingStateChange: _onSignalingStateChange,
      signalingStateStable: _onSignalingStateStable,
      error: _onPeerError,
      qos: _onQoS,
      iceConnectionStateChange: _onIceConnectionStateChanged,
      remoteVideoSupported: _onRemoteVideoSupported,
      decryptFailed: _onDecryptFailed,
      decryptRestored: _onDecryptRestored
    }, this);

    // Specific SPC logic
    this.onTrackAdded = _ref2 => {
      let track = _ref2.track,
        transceiver = _ref2.transceiver;
      _transceivers[track.id] = transceiver.mid;
      controller.addSubscriberMid(transceiver.mid, this._id);
      _tracks.push(track);
      mediaStream.addTrack(track);
      if (_peerConnection.iceConnectionStateIsConnected()) {
        // For SPC if ICE state is already connected when track is added
        // then this is not the first subscriber and we must trigger the event manually
        // using the following wrappers protect against firing events multiple times.
        _onIceConnected();
        _onIceConnectionStateChanged('connected');
      }
      this.trigger('trackAdded', {
        stream: mediaStream,
        track,
        transceiver
      });
    };
    this.disconnect = () => {
      controller.removeSubscriber(this._id, Object.values(_transceivers));
    };
    this.remoteTracks = () => _tracks;

    // SPC wrapper for PeerConnection

    this.generateOfferAndSend = () => _peerConnection.generateOfferAndSend();
    this.getDataChannel = (label, options, completion) => {
      _peerConnection.getDataChannel(label, options, completion);
    };
    this.getSourceStreamId = () => _peerConnection.getSourceStreamId();
    this.processOffer = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(message) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return controller.processOffer(message.content.sdp);
            case 2:
              message.content.sdp = _context.sent;
              _peerConnection.processMessage('offer', message);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    this.processAnswer = message => {
      message.content.sdp = controller.processAnswer(message.content.sdp);
      _peerConnection.processMessage('answer', message);
      // When Mantis sent an answer, the negotiation is done.
      controller.subscriberComplete();
    };
    this.processMessage = (type, message) => {
      if (type === 'offer') {
        this.processOffer(message);
      } else if (type === 'answer') {
        this.processAnswer(message);
      } else {
        _peerConnection.processMessage(type, message);
      }
    };
    this.remoteDescription = () => _peerConnection.remoteDescription();
    this.getStats = (track, callback) => {
      if (track) {
        // getStats for a specific track.
        _peerConnection.getStats(track, callback);
      } else {
        // getStats for all tracks.
        (0, _collectStatsHelper.collectGetStatsHelper)(_peerConnection, _tracks, callback);
      }
    };
    this.getSynchronizationSources = callback => {
      _peerConnection.getSynchronizationSources(callback);
    };
    this.getRtcStatsReport = (track, callback) => {
      if (track) {
        // getRtcStatsReport for a specific track.
        _peerConnection.getRtcStatsReport(track, callback);
      } else {
        // getRtcStatsReport for all tracks.
        (0, _collectStatsHelper.collectRtcStatsReportHelper)(_peerConnection, _tracks, callback);
      }
    };
    this.remoteStreams = () => _peerConnection.remoteStreams();
    this.hasRelayCandidates = () => _peerConnection.hasRelayCandidates();
    this.iceRestart = () => _peerConnection.iceRestart();
    this.iceConnectionStateIsConnected = () => _peerConnection.iceConnectionStateIsConnected();
    this.startDecryption = (connectionId, transceiver) => _peerConnection.startDecryption(connectionId, transceiver);
  };
}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.collectStatsHelper = exports.collectRtcStatsReportHelper = exports.collectGetStatsHelper = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _promisify = _interopRequireDefault(__webpack_require__(175));
const collectStatsHelper = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(options, callback) {
    var _options, tracks, getStats, merge, getStatsP, statsMerged, statsArray;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (options === void 0) {
            options = {};
          }
          _options = options, tracks = _options.tracks, getStats = _options.getStats, merge = _options.merge;
          getStatsP = (0, _promisify.default)(getStats);
          _context.prev = 3;
          _context.next = 6;
          return Promise.all(tracks.map(track => getStatsP(track)));
        case 6:
          statsArray = _context.sent;
          statsMerged = statsArray.reduce(merge);
          _context.next = 14;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
          callback(_context.t0);
          return _context.abrupt("return");
        case 14:
          callback(null, statsMerged);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return function collectStatsHelper(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
exports.collectStatsHelper = collectStatsHelper;
const collectGetStatsHelper = (peerConnection, tracks, callback) => {
  // getStats uses an Array for the collected stats.
  const merge = function merge(previous, stats) {
    if (previous === void 0) {
      previous = [];
    }
    return [...previous, ...stats];
  };
  collectStatsHelper({
    tracks,
    getStats: (track, completion) => peerConnection.getStats(track, completion),
    merge
  }, callback);
};
exports.collectGetStatsHelper = collectGetStatsHelper;
const collectRtcStatsReportHelper = (peerConnection, tracks, callback) => {
  // getRtcStatsReport uses an RTCStatsReport object that cannot be merged
  // so we convert it to a Map
  const mapMerge = function mapMerge(previous, stats) {
    if (previous === void 0) {
      previous = new Map();
    }
    return new Map([...previous, ...stats]);
  };
  collectStatsHelper({
    tracks,
    getStats: (track, completion) => peerConnection.getRtcStatsReport(track, completion),
    merge: mapMerge
  }, callback);
};
exports.collectRtcStatsReportHelper = collectRtcStatsReportHelper;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = watchSubscriberAudio;
/*
 * Installs a watcher that will call the given callback if the audio from a subscriber is
 arriving, but the output is having issues.
 *
 * It polls getStats every 500 ms to find
 * 1) any sign of audio bytes received, but no change in audioLevel, and totalSamplesReceived or
 * 2) any sign of audio bytes received, but audioLevel is 0, and totalSamplesReceived is increasing
 * If it finds the issue,
 * it signals the anomaly by executing the given function.
 *
 * @param {function(cb: function(DOMError, Array<RTCStats>))} getStats
 *    the function to call to get the stats
 * @param {function} warningCb to be called when a potential problem is detected
 * @param {function} disableAudioLevelStuckAt0 if true, it won't verify audioLevelStuckAt0 scenario
 * @returns {function} cancel the watch
 */
const AUDIO_STUCK_AT_0_WARNING_TIMEOUT = 3000;
function watchSubscriberAudio(getStats, warningCb, disableAudioLevelStuckAt0) {
  if (disableAudioLevelStuckAt0 === void 0) {
    disableAudioLevelStuckAt0 = false;
  }
  let lastAudioLevel = null;
  let lastTotalSamplesReceived = 0;
  let inboundAudioReceiverTrackId = null;
  let isAudioLevelStuckAt0Disabled = disableAudioLevelStuckAt0;
  const isInboundAudioRTPStream = rtcStats => rtcStats.type === 'inbound-rtp' && (rtcStats.kind || rtcStats.mediaType) === 'audio';
  const isInboundAudioReceiver = rtcStats => rtcStats.id === inboundAudioReceiverTrackId && rtcStats.type === 'track' && (rtcStats.kind || rtcStats.mediaType) === 'audio';
  const isAudioLevelStuck = (audioLevel, totalSamplesReceived) => audioLevel === lastAudioLevel && totalSamplesReceived === lastTotalSamplesReceived;
  const isAudioLevelStuckAt0 = (audioLevel, totalSamplesReceived) => !isAudioLevelStuckAt0Disabled && audioLevel === 0 && lastAudioLevel === 0 && totalSamplesReceived > lastTotalSamplesReceived;
  const initAudioLevelStuckAt0Timer = () => {
    setTimeout(() => {
      isAudioLevelStuckAt0Disabled = true;
    }, AUDIO_STUCK_AT_0_WARNING_TIMEOUT);
  };
  const watcherInterval = setInterval(() => {
    getStats((error, rtcStatsItems) => {
      if (error) {
        return;
      }
      const inboundAudioRtcStreamStat = rtcStatsItems.find(isInboundAudioRTPStream) || {};
      inboundAudioReceiverTrackId = inboundAudioRtcStreamStat.trackId;
      const inboundAudioReceiverStat = rtcStatsItems.find(isInboundAudioReceiver);
      if (inboundAudioReceiverStat) {
        const audioLevel = inboundAudioReceiverStat.audioLevel,
          totalSamplesReceived = inboundAudioReceiverStat.totalSamplesReceived;
        if (audioLevel === undefined) {
          // Let's ignore this stats in case audioLevel is undefined
          return;
        }
        if (isAudioLevelStuck(audioLevel, totalSamplesReceived)) {
          // OPENTOK-41097 - abnormal condition detected
          clearInterval(watcherInterval);
          warningCb('audioLevelStuck');
        } else if (isAudioLevelStuckAt0(audioLevel, totalSamplesReceived)) {
          // The audioLevel property should only go to 0 if a client is muted
          // OPENTOK-41073 - abnormal condition detected
          clearInterval(watcherInterval);
          warningCb('audioLevelStuckAt0');
        }
        lastAudioLevel = audioLevel;
        lastTotalSamplesReceived = totalSamplesReceived;
      }
    });
  }, 500);
  if (!disableAudioLevelStuckAt0) {
    initAudioLevelStuckAt0Timer();
  }
  return {
    stop: () => {
      clearInterval(watcherInterval);
    }
  };
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = reportIssueFactory;
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _analytics = _interopRequireDefault(__webpack_require__(31));
var _objects = _interopRequireDefault(__webpack_require__(27));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
/* eslint-disable global-require */

const defaultAnalytics = new _analytics.default();
function reportIssueFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  /** @type defaultAnalytics */
  const analytics = deps.analytics || defaultAnalytics;
  const errors = deps.errors || _Errors.default;
  const ExceptionCodes = deps.ExceptionCodes || _exception_codes.default;
  const otError = deps.otError || (0, _otError.default)();
  const sessionObjects = deps.sessionObjects || _objects.default;
  const uuid = deps.uuid || _uuid.default;

  /**
  * Report that your app experienced an issue. You can use the issue ID with
  * <a href="https://tokbox.com/developer/tools/inspector/">Inspector</a> or when discussing
  * an issue with the Vonage API support team.
  *
  * @param completionHandler {Function} A function that is called when the call to this method
  * succeeds or fails. This function has two parameters. The first parameter is an
  * <a href="Error.html">Error</a> object that is set when the call to the
  * <code>reportIssue()</code> method fails (for example, if the client is not connected to the
  * network) or <code>null</code> when the call to the <code>reportIssue()</code> method succeeds.
  * The second parameter is set to the report ID (a unique string) when the call succeeds.
  *
  * @method OT.reportIssue
  * @memberof OT
  */
  return function reportIssue(completionHandler) {
    if (completionHandler === void 0) {
      completionHandler = () => {};
    }
    const reportIssueId = uuid();
    function onDone(err) {
      if (err) {
        completionHandler(otError(errors.REPORT_ISSUE_FAILED, new Error('Error calling OT.reportIssue(). Check the client\'s network connection.'), ExceptionCodes.REPORT_ISSUE_ERROR));
      } else {
        completionHandler(null, reportIssueId);
      }
    }
    if (sessionObjects.sessions.length() === 0) {
      analytics.logEvent({
        action: 'ReportIssue',
        variation: 'Event',
        payload: {
          reportIssueId
        }
      }, null, onDone);
    } else {
      Promise.all(sessionObjects.sessions.map(session => session.reportIssue({
        id: reportIssueId
      }))).then(() => onDone(), err => onDone(err));
    }
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CancellationError = __webpack_require__(328);

var _CancellationError2 = _interopRequireDefault(_CancellationError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noop = function noop() {};

var Cancellation = function () {
  function Cancellation() {
    _classCallCheck(this, Cancellation);

    this.internalIsCanceled = false;
    this.listeners = [];
  }

  _createClass(Cancellation, [{
    key: 'isCanceled',


    /**
     * Returns `true` if cancellation has been requested; otherwise, returns `false`.
     */
    value: function isCanceled() {
      return this.internalIsCanceled;
    }

    /**
     * Issues a cancellation request.
     *
     * It is safe to call this method multiple times since all but the first call are ignored.
     */

  }, {
    key: 'cancel',
    value: function cancel() {
      // Return if cancellation has already been requested.
      if (this.internalIsCanceled) {
        return;
      }

      this.internalIsCanceled = true;

      // Notify and remove listeners
      this.listeners.forEach(function (listener) {
        return listener();
      });
      this.listeners = null;
    }

    /**
     * Throws a `CancellationError` if cancellation has been requested.
     */

  }, {
    key: 'throwIfCanceled',
    value: function throwIfCanceled() {
      if (this.internalIsCanceled) {
        throw new _CancellationError2.default('Operation has been canceled.');
      }
    }

    /**
     * Adds a listener to be notified when cancellation is requested.
     *
     * @param {Function} listener The function to be called when cancellation is requested.
     * @returns {Function} A function that, when called, removes the listener.
     */

  }, {
    key: 'onCancel',
    value: function onCancel(listener) {
      var _this = this;

      if (this.internalIsCanceled) {
        return noop;
      }

      this.listeners.push(listener);

      return function () {
        if (_this.listeners) {
          var index = _this.listeners.indexOf(listener);
          if (index !== -1) {
            _this.listeners.splice(index, 1);
          }
        }
      };
    }

    /**
     * Creates a child `Cancellation` object.
     *
     * @returns {Cancellation}
     */

  }, {
    key: 'fork',
    value: function fork() {
      if (this.internalIsCanceled) {
        return Cancellation.CANCELED;
      }

      var child = new Cancellation();
      this.onCancel(function () {
        return child.cancel();
      });
      return child;
    }
  }]);

  return Cancellation;
}();

/*
 * A `Cancellation` object that is already in the canceled state.
 */


exports.default = Cancellation;
Cancellation.CANCELED = new Cancellation();
Cancellation.CANCELED.internalIsCanceled = true;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ensureCSSUnit;
function ensureCSSUnit(measurement, defaultUnit) {
  if (defaultUnit === void 0) {
    defaultUnit = 'px';
  }
  if (String(parseFloat(measurement, 10)) === String(measurement).trim()) {
    return `${String(measurement).trim()}${defaultUnit}`;
  }
  return measurement;
}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Test via a getter in the options object to see if the passive property is accessed
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var _default = _ref => {
  let window = _ref.window;
  let supportsPassive = false;
  try {
    const opts = Object.defineProperty({}, 'passive', {
      get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {} // eslint-disable-line no-empty
  return supportsPassive;
};
exports.default = _default;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const createCircleElement = () => {
  const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle.setAttribute('cx', '50%');
  circle.setAttribute('cy', '50%');
  circle.setAttribute('r', '50%');
  circle.setAttribute('fill', '%23000000');
  return circle;
};
const createTextElement = initials => {
  const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  text.setAttribute('x', '50%');
  text.setAttribute('y', '50%');
  text.setAttribute('dy', '5%');
  text.setAttribute('line-height', '133%');
  text.setAttribute('font-size', '108');
  text.setAttribute('font-weight', '500');
  text.setAttribute('font-style', 'normal');
  text.setAttribute('fill', '%23FFFFFF');
  text.setAttribute('font-family', 'spezia,sans-serif');
  text.setAttribute('dominant-baseline', 'middle');
  text.setAttribute('text-anchor', 'middle');
  const textNode = document.createTextNode(initials);
  text.appendChild(textNode);
  return text;
};
var _default = initials => {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 300 300');
  svg.setAttribute('style', 'width: 50%; dominant-baseline: middle; text-anchor: middle;');
  const circle = createCircleElement();
  const text = createTextElement(initials);
  svg.appendChild(circle);
  svg.appendChild(text);
  return svg;
};
exports.default = _default;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = getOrCreateContainer;
var _uuid = _interopRequireDefault(__webpack_require__(17));
function getOrCreateContainer(elementOrDomId, insertMode) {
  /** @type {HTMLElement} */
  let container;
  let domId;
  if (elementOrDomId && elementOrDomId.nodeName) {
    // It looks like we were given a DOM element. Grab the id or generate
    // one if it doesn't have one.
    container = elementOrDomId;
    if (!container.getAttribute('id') || container.getAttribute('id').length === 0) {
      container.setAttribute('id', `OT_${(0, _uuid.default)()}`);
    }
    domId = container.getAttribute('id');
  } else if (elementOrDomId) {
    // We may have got an id, try and get it's DOM element.
    container = document.getElementById(elementOrDomId);
    if (container) {
      domId = elementOrDomId;
    }
  }
  if (!domId) {
    domId = `OT_${(0, _uuid.default)().replace(/-/g, '_')}`;
  }
  if (!container) {
    container = document.createElement('div');
    container.id = domId;
    container.setAttribute('id', domId);
    container.style.backgroundColor = '#000000';
    document.body.appendChild(container);
    return container;
  }
  const placeHolder = document.createElement('div');
  placeHolder.id = `OT_${(0, _uuid.default)()}`;
  switch (insertMode) {
    case 'append':
      container.appendChild(placeHolder);
      return placeHolder;
    case 'before':
      container.parentNode.insertBefore(placeHolder, container);
      return placeHolder;
    case 'after':
      container.parentNode.insertBefore(placeHolder, container.nextSibling);
      return placeHolder;
    case 'replace':
    default:
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
      return container;
  }
}

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = fixMini;
var _log = _interopRequireDefault(__webpack_require__(1));
const log = (0, _log.default)('WidgetView:fixMini');
const miniWidth = 128;
const miniHeight = 128;
const microWidth = 64;
const microHeight = 64;
function fixMini( /** @type {HTMLElement} */container) {
  const clientWidth = container.clientWidth,
    clientHeight = container.clientHeight;
  container.classList.remove('OT_micro');
  container.classList.remove('OT_mini');
  if (clientWidth < microWidth || clientHeight < microHeight) {
    container.classList.add('OT_micro');
    log.debug('OT_micro class added', {
      clientWidth,
      clientHeight,
      microWidth,
      microHeight
    });
  }
  if (clientWidth < miniWidth || clientHeight < miniHeight) {
    container.classList.add('OT_mini');
    log.debug('OT_mini class added', {
      clientWidth,
      clientHeight,
      miniWidth,
      miniHeight
    });
  }
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _promiseFinally = _interopRequireDefault(__webpack_require__(329));
var _pTimeout = _interopRequireDefault(__webpack_require__(164));
var _eventHelper = _interopRequireDefault(__webpack_require__(58));
var _index = _interopRequireDefault(__webpack_require__(109));
var _isVideoFrameBlack = _interopRequireDefault(__webpack_require__(714));
var _env = _interopRequireDefault(__webpack_require__(3));
// eslint-disable-next-line no-unused-vars
const typeVideoElementFacade = (0, _index.default)();

/**
 * Wait for the video to be playing
 * @param {Object} params
 *  @property {typeVideoElementFacade} videoElementFacade
 *  @property {Number} maxWaitTime
 *  @property {Boolean} isBufferedStream - whether or not the video is a buffered stream (has a video track, we're subscribing to video)
 *  @property {Object} deps - dependencies for the function, used for unit testing
 *
 * @returns Promise<Boolean> true if we think the video is playing, false if we timeout
 */
function waitForVideoToBePlaying(_ref) {
  let defaultVideoElementFacade = _ref.defaultVideoElementFacade,
    _ref$maxWaitTime = _ref.maxWaitTime,
    maxWaitTime = _ref$maxWaitTime === void 0 ? 5000 : _ref$maxWaitTime,
    _ref$isBufferedStream = _ref.isBufferedStream,
    isBufferedStream = _ref$isBufferedStream === void 0 ? false : _ref$isBufferedStream,
    _ref$deps = _ref.deps,
    deps = _ref$deps === void 0 ? {} : _ref$deps;
  const env = deps.env || _env.default;
  const videoElementFacade = deps.videoElementFacade || defaultVideoElementFacade;
  const isVideoFrameBlack = deps.isVideoFrameBlack || _isVideoFrameBlack.default;
  const videoElementFacadeEvents = deps.videoElementFacadeEvents || (0, _eventHelper.default)(videoElementFacade);
  const promise = new Promise(resolve => {
    // eslint-disable-next-line consistent-return
    const onVideoPlaybackHandler = videoPlaybackEvent => {
      if (!isBufferedStream || !env.isChromium) {
        // If there is no video and we're not subscribed to video, or if we're using a non-Chromium browser,
        // resolve immediately because the video frame callback will never be called or because the bug is not present on non-Chromium browsers.
        return resolve(videoPlaybackEvent);
      }
      const videoFrameCallback = (_, metadata) => {
        // During an AMR transition or any new stream bind, we check that a real video frame is displayed for Chromium browsers
        // before switching streams to eliminate the screen flicker. See VIDCS-3570.
        const hasBlackVideoFrame = isVideoFrameBlack(videoElementFacade);
        const hasMaxWaitTimeElapsed = metadata.mediaTime > maxWaitTime / 1000 - 1;
        if (!hasBlackVideoFrame || hasMaxWaitTimeElapsed) {
          // If we have a real video frame, or if we've waited 4s (maybe a webcam cover is down), we proceed.
          return resolve(videoPlaybackEvent);
        }

        // If we haven't seen a non-black video frame, we re-register the callback.
        return videoElementFacade.requestVideoFrameCallback(videoFrameCallback);
      };
      videoElementFacade.requestVideoFrameCallback(videoFrameCallback);
    };
    videoElementFacadeEvents.on('timeupdate', onVideoPlaybackHandler);
    videoElementFacadeEvents.on('loadedmetadata', onVideoPlaybackHandler);
  });
  return (0, _promiseFinally.default)((0, _pTimeout.default)(promise, maxWaitTime, () => false), () => videoElementFacadeEvents.removeAll());
}
var _default = waitForVideoToBePlaying;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const createCoords = (width, height) => {
  // Create coordinates for the four quadrants of the video frame
  const quarterWidth = width / 4;
  const quarterHeight = height / 4;
  const threeQuarterWidth = width * 3 / 4;
  const threeQuarterHeight = height * 3 / 4;
  return [[quarterWidth, quarterHeight], [quarterWidth, threeQuarterHeight], [threeQuarterWidth, quarterHeight], [threeQuarterWidth, threeQuarterHeight]];
};
const black = {
  r: 0,
  g: 0,
  b: 0
};
const isWithinTolerance = (real, expected, tolerance) => Math.abs(real - expected) <= tolerance;

// Note: For an input e.g. rgb(34, 167, 240), but due to browser processing
// output is ~rgb(47, 176, 235) and can depend on browser as well as
// publisher vs subscriber, so we allow a tolerance of 20.
const rgbTolerance = 20;
const isPixelColor = (pixel, expectedRGB) => {
  const _pixel$data = pixel.data,
    r = _pixel$data[0],
    g = _pixel$data[1],
    b = _pixel$data[2];
  return isWithinTolerance(r, expectedRGB.r, rgbTolerance) && isWithinTolerance(g, expectedRGB.g, rgbTolerance) && isWithinTolerance(b, expectedRGB.b, rgbTolerance);
};
const isVideoFrameBlack = videoElement => {
  const coords = createCoords(videoElement.videoWidth, videoElement.videoHeight);
  const canvas = document.createElement('canvas');
  canvas.width = videoElement.videoWidth;
  canvas.height = videoElement.videoHeight;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
  const hasBlackVideoFrame = coords.every(_ref => {
    let x = _ref[0],
      y = _ref[1];
    return isPixelColor(ctx.getImageData(x, y, 1, 1), black);
  });
  canvas.remove();
  return hasBlackVideoFrame;
};
var _default = isVideoFrameBlack;
exports.default = _default;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _promiseFinally = _interopRequireDefault(__webpack_require__(329));
var _pTimeout = _interopRequireDefault(__webpack_require__(164));
var _eventHelper = _interopRequireDefault(__webpack_require__(58));
var _index = _interopRequireDefault(__webpack_require__(109));
// eslint-disable-next-line no-unused-vars
const typeVideoElementFacade = (0, _index.default)();

/**
 * Returns a Promise that will resolve when the video resolution is greater than
 * 2 in either dimension, or a timeout occurs.
 *
 * @param {typeVideoElementFacade} videoElementFacade
 * @param {Number} timeoutMs
 *
 * @returns Promise<Boolean> true if resolution succeeded, false otherwise
 */
function waitForCorrectResolution(videoElementFacade, timeoutMs) {
  const videoElementFacadeEvents = (0, _eventHelper.default)(videoElementFacade);
  const promise = new Promise(resolve => {
    const checkResolution = () => {
      if (videoElementFacade.videoWidth() > 2 || videoElementFacade.videoHeight() > 2) {
        resolve(true);
      }
    };
    videoElementFacadeEvents.on('videoDimensionsChanged', checkResolution);
    checkResolution();
  });
  return (0, _promiseFinally.default)((0, _pTimeout.default)(promise, timeoutMs, () => false), () => videoElementFacadeEvents.removeAll());
}
var _default = waitForCorrectResolution;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof (typeof window !== undefined ? window : global) !== 'undefined' && (typeof window !== undefined ? window : global).Math === Math) {
        return (typeof window !== undefined ? window : global);
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (worker, concurrency) {
    var _worker = (0, _wrapAsync2.default)(worker);
    return (0, _queue2.default)((items, cb) => {
        _worker(items[0], cb);
    }, concurrency, 1);
};

var _queue = __webpack_require__(718);

var _queue2 = _interopRequireDefault(_queue);

var _wrapAsync = __webpack_require__(179);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports.default;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = queue;

var _onlyOnce = __webpack_require__(719);

var _onlyOnce2 = _interopRequireDefault(_onlyOnce);

var _setImmediate = __webpack_require__(333);

var _setImmediate2 = _interopRequireDefault(_setImmediate);

var _DoublyLinkedList = __webpack_require__(720);

var _DoublyLinkedList2 = _interopRequireDefault(_DoublyLinkedList);

var _wrapAsync = __webpack_require__(179);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function queue(worker, concurrency, payload) {
    if (concurrency == null) {
        concurrency = 1;
    } else if (concurrency === 0) {
        throw new RangeError('Concurrency must not be zero');
    }

    var _worker = (0, _wrapAsync2.default)(worker);
    var numRunning = 0;
    var workersList = [];
    const events = {
        error: [],
        drain: [],
        saturated: [],
        unsaturated: [],
        empty: []
    };

    function on(event, handler) {
        events[event].push(handler);
    }

    function once(event, handler) {
        const handleAndRemove = (...args) => {
            off(event, handleAndRemove);
            handler(...args);
        };
        events[event].push(handleAndRemove);
    }

    function off(event, handler) {
        if (!event) return Object.keys(events).forEach(ev => events[ev] = []);
        if (!handler) return events[event] = [];
        events[event] = events[event].filter(ev => ev !== handler);
    }

    function trigger(event, ...args) {
        events[event].forEach(handler => handler(...args));
    }

    var processingScheduled = false;
    function _insert(data, insertAtFront, rejectOnError, callback) {
        if (callback != null && typeof callback !== 'function') {
            throw new Error('task callback must be a function');
        }
        q.started = true;

        var res, rej;
        function promiseCallback(err, ...args) {
            // we don't care about the error, let the global error handler
            // deal with it
            if (err) return rejectOnError ? rej(err) : res();
            if (args.length <= 1) return res(args[0]);
            res(args);
        }

        var item = q._createTaskItem(data, rejectOnError ? promiseCallback : callback || promiseCallback);

        if (insertAtFront) {
            q._tasks.unshift(item);
        } else {
            q._tasks.push(item);
        }

        if (!processingScheduled) {
            processingScheduled = true;
            (0, _setImmediate2.default)(() => {
                processingScheduled = false;
                q.process();
            });
        }

        if (rejectOnError || !callback) {
            return new Promise((resolve, reject) => {
                res = resolve;
                rej = reject;
            });
        }
    }

    function _createCB(tasks) {
        return function (err, ...args) {
            numRunning -= 1;

            for (var i = 0, l = tasks.length; i < l; i++) {
                var task = tasks[i];

                var index = workersList.indexOf(task);
                if (index === 0) {
                    workersList.shift();
                } else if (index > 0) {
                    workersList.splice(index, 1);
                }

                task.callback(err, ...args);

                if (err != null) {
                    trigger('error', err, task.data);
                }
            }

            if (numRunning <= q.concurrency - q.buffer) {
                trigger('unsaturated');
            }

            if (q.idle()) {
                trigger('drain');
            }
            q.process();
        };
    }

    function _maybeDrain(data) {
        if (data.length === 0 && q.idle()) {
            // call drain immediately if there are no tasks
            (0, _setImmediate2.default)(() => trigger('drain'));
            return true;
        }
        return false;
    }

    const eventMethod = name => handler => {
        if (!handler) {
            return new Promise((resolve, reject) => {
                once(name, (err, data) => {
                    if (err) return reject(err);
                    resolve(data);
                });
            });
        }
        off(name);
        on(name, handler);
    };

    var isProcessing = false;
    var q = {
        _tasks: new _DoublyLinkedList2.default(),
        _createTaskItem(data, callback) {
            return {
                data,
                callback
            };
        },
        *[Symbol.iterator]() {
            yield* q._tasks[Symbol.iterator]();
        },
        concurrency,
        payload,
        buffer: concurrency / 4,
        started: false,
        paused: false,
        push(data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map(datum => _insert(datum, false, false, callback));
            }
            return _insert(data, false, false, callback);
        },
        pushAsync(data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map(datum => _insert(datum, false, true, callback));
            }
            return _insert(data, false, true, callback);
        },
        kill() {
            off();
            q._tasks.empty();
        },
        unshift(data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map(datum => _insert(datum, true, false, callback));
            }
            return _insert(data, true, false, callback);
        },
        unshiftAsync(data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map(datum => _insert(datum, true, true, callback));
            }
            return _insert(data, true, true, callback);
        },
        remove(testFn) {
            q._tasks.remove(testFn);
        },
        process() {
            // Avoid trying to start too many processing operations. This can occur
            // when callbacks resolve synchronously (#1267).
            if (isProcessing) {
                return;
            }
            isProcessing = true;
            while (!q.paused && numRunning < q.concurrency && q._tasks.length) {
                var tasks = [],
                    data = [];
                var l = q._tasks.length;
                if (q.payload) l = Math.min(l, q.payload);
                for (var i = 0; i < l; i++) {
                    var node = q._tasks.shift();
                    tasks.push(node);
                    workersList.push(node);
                    data.push(node.data);
                }

                numRunning += 1;

                if (q._tasks.length === 0) {
                    trigger('empty');
                }

                if (numRunning === q.concurrency) {
                    trigger('saturated');
                }

                var cb = (0, _onlyOnce2.default)(_createCB(tasks));
                _worker(data, cb);
            }
            isProcessing = false;
        },
        length() {
            return q._tasks.length;
        },
        running() {
            return numRunning;
        },
        workersList() {
            return workersList;
        },
        idle() {
            return q._tasks.length + numRunning === 0;
        },
        pause() {
            q.paused = true;
        },
        resume() {
            if (q.paused === false) {
                return;
            }
            q.paused = false;
            (0, _setImmediate2.default)(q.process);
        }
    };
    // define these as fixed properties, so people get useful errors when updating
    Object.defineProperties(q, {
        saturated: {
            writable: false,
            value: eventMethod('saturated')
        },
        unsaturated: {
            writable: false,
            value: eventMethod('unsaturated')
        },
        empty: {
            writable: false,
            value: eventMethod('empty')
        },
        drain: {
            writable: false,
            value: eventMethod('drain')
        },
        error: {
            writable: false,
            value: eventMethod('error')
        }
    });
    return q;
}
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = onlyOnce;
function onlyOnce(fn) {
    return function (...args) {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    };
}
module.exports = exports.default;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
// used for queues. This implementation assumes that the node provided by the user can be modified
// to adjust the next and last properties. We implement only the minimal functionality
// for queue support.
class DLL {
    constructor() {
        this.head = this.tail = null;
        this.length = 0;
    }

    removeLink(node) {
        if (node.prev) node.prev.next = node.next;else this.head = node.next;
        if (node.next) node.next.prev = node.prev;else this.tail = node.prev;

        node.prev = node.next = null;
        this.length -= 1;
        return node;
    }

    empty() {
        while (this.head) this.shift();
        return this;
    }

    insertAfter(node, newNode) {
        newNode.prev = node;
        newNode.next = node.next;
        if (node.next) node.next.prev = newNode;else this.tail = newNode;
        node.next = newNode;
        this.length += 1;
    }

    insertBefore(node, newNode) {
        newNode.prev = node.prev;
        newNode.next = node;
        if (node.prev) node.prev.next = newNode;else this.head = newNode;
        node.prev = newNode;
        this.length += 1;
    }

    unshift(node) {
        if (this.head) this.insertBefore(this.head, node);else setInitial(this, node);
    }

    push(node) {
        if (this.tail) this.insertAfter(this.tail, node);else setInitial(this, node);
    }

    shift() {
        return this.head && this.removeLink(this.head);
    }

    pop() {
        return this.tail && this.removeLink(this.tail);
    }

    toArray() {
        return [...this];
    }

    *[Symbol.iterator]() {
        var cur = this.head;
        while (cur) {
            yield cur.data;
            cur = cur.next;
        }
    }

    remove(testFn) {
        var curr = this.head;
        while (curr) {
            var { next } = curr;
            if (testFn(curr)) {
                this.removeLink(curr);
            }
            curr = next;
        }
        return this;
    }
}

exports.default = DLL;
function setInitial(dll, node) {
    dll.length = 1;
    dll.head = dll.tail = node;
}
module.exports = exports.default;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = asyncify;

var _initialParams = __webpack_require__(722);

var _initialParams2 = _interopRequireDefault(_initialParams);

var _setImmediate = __webpack_require__(333);

var _setImmediate2 = _interopRequireDefault(_setImmediate);

var _wrapAsync = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */
function asyncify(func) {
    if ((0, _wrapAsync.isAsync)(func)) {
        return function (...args /*, callback*/) {
            const callback = args.pop();
            const promise = func.apply(this, args);
            return handlePromise(promise, callback);
        };
    }

    return (0, _initialParams2.default)(function (args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if (result && typeof result.then === 'function') {
            return handlePromise(result, callback);
        } else {
            callback(null, result);
        }
    });
}

function handlePromise(promise, callback) {
    return promise.then(value => {
        invokeCallback(callback, null, value);
    }, err => {
        invokeCallback(callback, err && (err instanceof Error || err.message) ? err : new Error(err));
    });
}

function invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (err) {
        (0, _setImmediate2.default)(e => {
            throw e;
        }, err);
    }
}
module.exports = exports.default;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (fn) {
    return function (...args /*, callback*/) {
        var callback = args.pop();
        return fn.call(this, args, callback);
    };
};

module.exports = exports.default;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _interval_runner = _interopRequireDefault(__webpack_require__(74));
const connectivityAttemptPingerFactory = _ref => {
  let connectivityState = _ref.connectivityState,
    logAttempt = _ref.logAttempt;
  const connectivityAttemptPinger = new _interval_runner.default(logAttempt, 1 / 5, 6);
  connectivityState.observe({
    onEnterConnecting() {
      connectivityAttemptPinger.start();
    },
    onEnterDisconnected() {
      connectivityAttemptPinger.stop();
    },
    onEnterConnected() {
      connectivityAttemptPinger.stop();
    }
  });
};
var _default = connectivityAttemptPingerFactory;
exports.default = _default;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _javascriptStateMachine = _interopRequireDefault(__webpack_require__(336));
// @todo The big plan for connectivityState is to eventually use the state transitions to do
// what is necessary rather than have it duplicated and possible differences and mistakes
// around what is to occur when different states occur. Things like calling subscribeComplete
// logging, calling disconnect or destroy, should all be driven by the state of the connection

const connectivityState = _ref => {
  let onInvalidTransition = _ref.onInvalidTransition;
  return new _javascriptStateMachine.default({
    init: 'disconnected',
    transitions: [{
      name: 'beginConnect',
      from: 'disconnected',
      to: 'connecting'
    }, {
      name: 'connect',
      from: 'connecting',
      to: 'connected'
    }, {
      name: 'fail',
      from: ['connecting', 'connected'],
      to: 'disconnected'
    }, {
      name: 'cancel',
      from: ['connecting', 'connected'],
      to: 'disconnected'
    }, {
      name: 'disconnect',
      from: ['connecting', 'connected'],
      to: 'disconnected'
    }],
    methods: {
      onInvalidTransition
    }
  });
};
var _default = connectivityState;
exports.default = _default;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = _ref => {
  let connectivityState = _ref.connectivityState,
    onWarning = _ref.onWarning,
    onTimeout = _ref.onTimeout,
    warningMs = _ref.warningMs,
    timeoutMs = _ref.timeoutMs;
  const timeoutIds = [];
  const cancelBindGuards = () => {
    timeoutIds.forEach(timeoutId => clearTimeout(timeoutId));
  };
  connectivityState.observe({
    onEnterConnecting() {
      timeoutIds.push(setTimeout(onWarning, warningMs), setTimeout(onTimeout, timeoutMs));
    },
    onEnterConnected: cancelBindGuards,
    onEnterDisconnected: cancelBindGuards
  });
};
exports.default = _default;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
const otError = (0, _otError.default)();
var _default = err => {
  if (String(err.code) === '404') {
    return otError(_Errors.default.STREAM_NOT_FOUND, new Error('stream not found'), _exception_codes.default.UNABLE_TO_SUBSCRIBE);
  }
  if (String(err.code) === '409' && err.message === 'streamLimitExceeded') {
    return otError(_Errors.default.STREAM_LIMIT_EXCEEDED, new Error('The limit for concurrent streams in the session has been reached'), _exception_codes.default.STREAM_LIMIT_EXCEEDED);
  }
  if (String(err.code) === '405' && err.message === 'IncompatibleEncryptionSettings') {
    return otError(_Errors.default.UNABLE_TO_SUBSCRIBE, new Error('Tried to subscribe to an encrypted stream without enabling encryption'), _exception_codes.default.UNABLE_TO_SUBSCRIBE);
  }
  if (String(err.code) === '500' && err.message === 'Not connected.') {
    return otError(_Errors.default.UNABLE_TO_SUBSCRIBE, new Error('Tried to subscribe to a stream while disconnected.'), _exception_codes.default.UNABLE_TO_SUBSCRIBE);
  }
  return otError(_Errors.default.UNABLE_TO_SUBSCRIBE, new Error(`subscriberCreate failed with unexpected code ${err.code}: ${err.message}`), _exception_codes.default.UNEXPECTED_SERVER_RESPONSE);
};
exports.default = _default;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _now = _interopRequireDefault(__webpack_require__(51));
var _RafRunner = _interopRequireDefault(__webpack_require__(112));
var _events = _interopRequireDefault(__webpack_require__(18));
const Events = (0, _events.default)();
var _default = _ref => {
  let subscriber = _ref.subscriber,
    audioLevelSampler = _ref.audioLevelSampler;
  let loudness = 0;
  let loudnessLastAccess = 0;
  let destroyed = false;
  const audioLevelRunner = new _RafRunner.default(() => {
    const listenerCount = subscriber.listenerCount(_eventNames.default.AUDIO_LEVEL_UPDATED);
    const shouldStopWatchingAudio = () => (0, _now.default)() - loudnessLastAccess > 10000 && listenerCount === 0;
    if (shouldStopWatchingAudio()) {
      audioLevelRunner.stop();
      return;
    }
    loudness = audioLevelSampler.sample();
    if (listenerCount > 0) {
      // dispatch this old event if someone is listening...
      subscriber.dispatchEvent(new Events.AudioLevelUpdatedEvent(loudness));
    }
  });
  const audioLevelUpdatedAdded = () => audioLevelRunner.start();
  const subscriberDestroyed = () => audioLevelRunner.stop();
  const addListeners = () => {
    subscriber.on('audioLevelUpdated:added', audioLevelUpdatedAdded);
    subscriber.once(_eventNames.default.SUBSCRIBER_DESTROYED, subscriberDestroyed);
  };
  const removeListeners = () => {
    subscriber.off('audioLevelUpdated:added', audioLevelUpdatedAdded);
    subscriber.off(_eventNames.default.SUBSCRIBER_DESTROYED, subscriberDestroyed);
  };
  Object.defineProperty(subscriber, 'loudness', {
    get() {
      if (!destroyed) {
        audioLevelRunner.start();
      }
      loudnessLastAccess = (0, _now.default)();
      return loudness;
    },
    set() {
      throw new TypeError('Cannot set readonly property loudness');
    },
    configurable: true
  });
  if (subscriber.listenerCount(_eventNames.default.AUDIO_LEVEL_UPDATED)) {
    audioLevelRunner.start();
  }
  addListeners();
  return {
    destroy() {
      destroyed = true;
      audioLevelSampler.destroy();
      audioLevelRunner.stop();
      removeListeners();
      // eslint-disable-next-line no-param-reassign
      subscriber = undefined;
    }
  };
};
exports.default = _default;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
// @todo can we test for this instead?

const hasAudioOutputLevelStatCapability = () => ['Chrome', 'Opera', 'Safari'].indexOf(_env.default.name) > -1;
var _default = hasAudioOutputLevelStatCapability;
exports.default = _default;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _log = _interopRequireDefault(__webpack_require__(1));
var _get_audio_level_sampler = _interopRequireDefault(__webpack_require__(275));
var _webaudio_audio_level_sampler = _interopRequireDefault(__webpack_require__(146));
var _hasSynchronizationSourcesCapability = _interopRequireDefault(__webpack_require__(730));
var _hasRemoteStreamsWithWebAudio = _interopRequireDefault(__webpack_require__(339));
var _audio_context = _interopRequireDefault(__webpack_require__(145));
var _is_audio_context = _interopRequireDefault(__webpack_require__(731));
/* eslint-disable consistent-return */

const getAudioContext = (0, _audio_context.default)();
const logging = (0, _log.default)('Subscriber');
const audioLevelSamplerFactory = function audioLevelSamplerFactory(peerConnection, deps) {
  if (deps === void 0) {
    deps = {};
  }
  const hasGetSynchronizationSupport = deps.hasGetSynchronizationSupport;
  if (!peerConnection) return;
  if ((0, _hasRemoteStreamsWithWebAudio.default)()) {
    let audioContext;
    try {
      audioContext = deps.audioContext || getAudioContext();
    } catch (e) {
      logging.warn('Failed to get AudioContext()', e);
    }
    if ((0, _is_audio_context.default)(audioContext)) {
      return new _webaudio_audio_level_sampler.default(audioContext);
    }
  }
  if ((0, _hasSynchronizationSourcesCapability.default)({
    hasGetSynchronizationSupport
  })) {
    return new _get_audio_level_sampler.default(peerConnection.getSynchronizationSources);
  }
};
var _default = audioLevelSamplerFactory;
exports.default = _default;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
// getSynchronizationSources is currently broken for SIP calls. See https://jira.vonage.com/browse/VIDCS-40
// This is a bandaid fix. In the future we may override this to only return false when
// ssrc-audio-level is missing from the SDP

const isEnabledOverride = false;
const hasGetSynchronizationSupport = () => window.RTCRtpReceiver && 'getSynchronizationSources' in window.RTCRtpReceiver.prototype;

// Firefox also has getSynchronizationSources implemented, but we are not
// gonna use getSynchronizationSources for audio level tracking in FF
// as the implementation on FF is not that good. Hence the additional checks
// for browser versions

const hasSynchronizationSourcesCapability = function hasSynchronizationSourcesCapability(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const hasGetSyncSupport = deps.hasGetSynchronizationSupport || hasGetSynchronizationSupport;
  const isEnabled = typeof deps.isEnabled === 'boolean' ? deps.isEnabled : isEnabledOverride;
  return isEnabled && hasGetSyncSupport() && !_env.default.isFirefox;
};
var _default = hasSynchronizationSourcesCapability;
exports.default = _default;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = audioContext => (typeof window !== undefined ? window : global).AudioContext && audioContext instanceof (typeof window !== undefined ? window : global).AudioContext || (typeof window !== undefined ? window : global).webkitAudioContext && audioContext instanceof (typeof window !== undefined ? window : global).webkitAudioContext;
exports.default = _default;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = AudioBlockedIndicator;
var _widget = _interopRequireDefault(__webpack_require__(40));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
function AudioBlockedIndicator(options) {
  let audioBlocked = false;
  const updateClasses = element => {
    const shouldDisplay = ['auto', 'on'].indexOf(this.getDisplayMode()) > -1;
    _OTHelpers.default.removeClass(element, ['OT_audio-blocked', 'OT_active'].join(' '));
    if (!shouldDisplay) {
      return;
    }
    if (audioBlocked) {
      _OTHelpers.default.addClass(element, 'OT_audio-blocked');
    }
    _OTHelpers.default.addClass(element, 'OT_active');
  };
  this.setAudioBlocked = value => {
    audioBlocked = value;
    updateClasses(this.domElement);
  };

  // Mixin common widget behaviour
  (0, _widget.default)(this, {
    mode: options.mode || 'auto',
    nodeName: 'div',
    htmlAttributes: {
      className: 'OT_audio-blocked-indicator'
    }
  });
  const parentSetDisplayMode = this.setDisplayMode.bind(this);
  this.setDisplayMode = mode => {
    parentSetDisplayMode(mode);
    updateClasses(this.domElement);
  };
}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = VideoUnsupportedIndicator;
var _widget = _interopRequireDefault(__webpack_require__(40));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
function VideoUnsupportedIndicator(options) {
  let videoUnsupported = false;
  const updateClasses = element => {
    const shouldDisplay = ['auto', 'on'].indexOf(this.getDisplayMode()) > -1;
    _OTHelpers.default.removeClass(element, ['OT_active'].join(' '));
    if (!shouldDisplay || !videoUnsupported) {
      return;
    }
    _OTHelpers.default.addClass(element, 'OT_active');
  };
  this.setVideoUnsupported = value => {
    videoUnsupported = value;
    updateClasses(this.domElement);
  };

  // Mixin common widget behaviour
  (0, _widget.default)(this, {
    mode: options.mode || 'auto',
    nodeName: 'div',
    htmlAttributes: {
      className: 'OT_video-unsupported'
    },
    htmlContent: '<div class="OT_video-unsupported-bar"></div>' + '<div class="OT_video-unsupported-img"></div>' + '<span class="OT_video-unsupported-text">' + 'Video format not supported' + '</span>'
  });
  const parentSetDisplayMode = this.setDisplayMode.bind(this);
  this.setDisplayMode = mode => {
    parentSetDisplayMode(mode);
    updateClasses(this.domElement);
  };
}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _assign = _interopRequireDefault(__webpack_require__(9));
var _find = _interopRequireDefault(__webpack_require__(63));
var _pick = _interopRequireDefault(__webpack_require__(39));
var _get_stats_helpers = _interopRequireDefault(__webpack_require__(78));
var _calculateFrameRate = _interopRequireDefault(__webpack_require__(168));
const watchFrameRate = function watchFrameRate(getStats, delay) {
  if (delay === void 0) {
    delay = 5000;
  }
  let timeoutId;
  let destroyed = false;
  const lastStat = {};
  const getVideoInboundStat = function getVideoInboundStat(stats) {
    if (stats === void 0) {
      stats = [];
    }
    return (0, _find.default)(stats, stat => _get_stats_helpers.default.isVideoInboundRtpStat(stat));
  };
  const query = () => {
    if (destroyed) {
      return;
    }
    getStats((error, stats) => {
      if (destroyed) {
        return;
      }
      if (!error) {
        const stat = getVideoInboundStat(stats);
        if (stat) {
          (0, _assign.default)(lastStat, (0, _pick.default)(stat, ['timestamp', 'framesDecoded']));
        } else if (!lastStat.timestamp) {
          (0, _assign.default)(lastStat, {
            timestamp: Date.now(),
            framesDecoded: 0
          });
        }
      }
      timeoutId = setTimeout(query, delay);
    });
  };
  query();
  return {
    getFrameRateFromStat(stat) {
      return (0, _calculateFrameRate.default)({
        currentStatFrames: stat.framesDecoded,
        currentTimestamp: stat.timestamp,
        prevStatFrames: lastStat.framesDecoded,
        prevTimestamp: lastStat.timestamp
      });
    },
    destroy() {
      destroyed = true;
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }
  };
};
var _default = watchFrameRate;
exports.default = _default;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _mediaProcessorConnector = _interopRequireDefault(__webpack_require__(181));
var _log = _interopRequireDefault(__webpack_require__(1));
var _updateTrackOnStream = _interopRequireDefault(__webpack_require__(342));
var _createAudioTrackHolder = _interopRequireDefault(__webpack_require__(736));
const logging = (0, _log.default)('Subscriber');
const routedSourceStreamId = 'MANTIS';
const relayedSourceStreamId = 'P2P';
const createAudioConnector = function createAudioConnector(streams, deps) {
  if (deps === void 0) {
    deps = {};
  }
  const updateTrackOnStream = deps.updateTrackOnStream || _updateTrackOnStream.default;
  const createAudioTrackHolder = deps.createAudioTrackHolder || _createAudioTrackHolder.default;
  const mediaStreams = streams;
  let _audioMediaProcessorConnector;
  let _originalAudioTrack;
  let _audioTrackHolder;
  const clearConnectorAndAudioHolder = () => {
    var _audioMediaProcessorC;
    (_audioMediaProcessorC = _audioMediaProcessorConnector) == null ? void 0 : _audioMediaProcessorC.destroy();
    _audioMediaProcessorConnector = null;
    if (_audioTrackHolder) {
      _audioTrackHolder.srcObject = null;
      _audioTrackHolder = null;
    }
    _originalAudioTrack = null;
  };
  const applyAudioConnector = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(sourceStreamId) {
      var _mediaStreams$sourceS2;
      var _mediaStreams$sourceS, originalAudioTrack, message, error, filteredAudioTrack;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _mediaStreams$sourceS = (_mediaStreams$sourceS2 = mediaStreams[sourceStreamId]) == null ? void 0 : _mediaStreams$sourceS2.getAudioTracks(), originalAudioTrack = _mediaStreams$sourceS[0];
            if (originalAudioTrack) {
              _context.next = 7;
              break;
            }
            message = 'Connector not set as no audio track is present.';
            error = new Error(message);
            logging.error(`setAudioMediaProcessorConnector: ${message}`);
            _audioMediaProcessorConnector = null;
            throw error;
          case 7:
            _context.prev = 7;
            // We create a video element to hold a new stream containing the original audio track.
            // If the track is not used in a stream, it is stopped and no audio is heard through
            // the filtered track.
            _audioTrackHolder = createAudioTrackHolder(originalAudioTrack);
            _context.next = 11;
            return _audioMediaProcessorConnector.setTrack(originalAudioTrack);
          case 11:
            filteredAudioTrack = _context.sent;
            _originalAudioTrack = originalAudioTrack;
            updateTrackOnStream(mediaStreams[sourceStreamId], originalAudioTrack, filteredAudioTrack);
            _context.next = 20;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](7);
            clearConnectorAndAudioHolder();
            throw _context.t0;
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 16]]);
    }));
    return function applyAudioConnector(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  const resetAudioStream = sourceStreamId => {
    try {
      const _mediaStreams$sourceS3 = mediaStreams[sourceStreamId].getAudioTracks(),
        filteredAudioTrack = _mediaStreams$sourceS3[0];
      updateTrackOnStream(mediaStreams[sourceStreamId], filteredAudioTrack, _originalAudioTrack);
    } catch (error) {
      throw Error(`setAudioMediaProcessorConnector: Error resetting track: ${error.message}`);
    }
  };
  return {
    get audioMediaProcessorConnector() {
      return _audioMediaProcessorConnector;
    },
    initializeConnector(mediaProcessorConnector) {
      _audioMediaProcessorConnector = new _mediaProcessorConnector.default(mediaProcessorConnector);
    },
    setAudioMediaProcessorConnector(sourceStreamId) {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return applyAudioConnector(sourceStreamId);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    applyAudioConnectorOnRoutedToRelayedTransition() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // We restore the Mantis stream's original track, so when we transition again,
              // we can apply a filter to the unfiltered track.
              _this.resetAudioStreamAndTrack(routedSourceStreamId);
              if (_audioMediaProcessorConnector) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return applyAudioConnector(relayedSourceStreamId);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    applyAudioConnectorOnRelayedToRoutedTransition() {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_audioMediaProcessorConnector) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              _context4.next = 4;
              return applyAudioConnector(routedSourceStreamId);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    clearAudioMediaProcessorConnector(sourceStreamId) {
      if (!_originalAudioTrack) {
        return;
      }
      resetAudioStream(sourceStreamId);
      clearConnectorAndAudioHolder();
    },
    resetAudioStreamAndTrack(sourceStreamId) {
      if (!_originalAudioTrack) {
        return;
      }
      resetAudioStream(sourceStreamId);
      _originalAudioTrack = null;
    }
  };
};
var _default = createAudioConnector;
exports.default = _default;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = function _default(audioTrack, deps) {
  if (deps === void 0) {
    deps = {};
  }
  const globalDocument = deps.document || document;
  const MediaStream = deps.MediaStream || (typeof window !== undefined ? window : global).MediaStream;
  const audioTrackHolder = globalDocument.createElement('video');
  const audioStream = new MediaStream([audioTrack]);
  audioTrackHolder.srcObject = audioStream;
  return audioTrackHolder;
};
exports.default = _default;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _rtcscore = __webpack_require__(738);
var _events = _interopRequireDefault(__webpack_require__(18));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
const Events = (0, _events.default)();
const calculateBitrate = (currentStats, lastStats) => {
  const timeDeltaInSeconds = (currentStats.timestamp - lastStats.timestamp) / 1000;
  return (currentStats.bytesReceived - lastStats.bytesReceived) / timeDeltaInSeconds * 8;
};

// See https://www.w3.org/TR/webrtc-stats/#dom-rtcinboundrtpstreamstats-jitterbufferdelay
const calculateJitterBufferMovingAverage = (currentStats, lastStats) => {
  const jitterBufferEmittedCountDelta = currentStats.jitterBufferEmittedCount - lastStats.jitterBufferEmittedCount;
  const jitterBufferDelayDelta = currentStats.jitterBufferDelay - lastStats.jitterBufferDelay;
  return jitterBufferDelayDelta / jitterBufferEmittedCountDelta;
};

// This can return NaN if packetsLost and packetsReceived are both zero
const calculatePacketsLostPercentage = currentStats => currentStats.packetsLost / (currentStats.packetsLost + currentStats.packetsReceived) * 100;
const deleteUndefinedProps = statObject => {
  Object.keys(statObject).forEach(key => {
    if (statObject[key] === undefined) {
      // eslint-disable-next-line no-param-reassign
      delete statObject[key];
    }
  });
  return statObject;
};
const getVideoCodecFromStat = stat => {
  const mediaTypeAndCodec = stat.mimeType.split('/');
  const mediaType = mediaTypeAndCodec[0];
  const codec = mediaTypeAndCodec[1].toLowerCase();
  if (mediaType === 'video') {
    return codec;
  }
  return undefined;
};
const createMOSScoreHelper = () => ({
  // samplingInterval is modified by unit tests
  startMonitoringInterval(properties) {
    const getStats = properties.getStats,
      subscriber = properties.subscriber,
      getCurrentPeerConnection = properties.getCurrentPeerConnection,
      logging = properties.logging,
      qosQualityScores = properties.qosQualityScores,
      _properties$rtcScore = properties.rtcScore,
      rtcScore = _properties$rtcScore === void 0 ? _rtcscore.score : _properties$rtcScore,
      _properties$samplingI = properties.samplingInterval,
      samplingInterval = _properties$samplingI === void 0 ? 2000 : _properties$samplingI;
    let lastVideoStats;
    let lastAudioStats;
    let getStatsInterval;
    let previousAudioScore;
    let previousVideoScore;
    const getStatsCallback = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(error, stats) {
        var peerConnection, dtxEnabled, fecEnabled, rtcStats, scores, qualityScore, currentAudioScore, currentVideoScore;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!error) {
                _context.next = 4;
                break;
              }
              clearInterval(getStatsInterval);
              logging.warn(`getStats failed with "${error}"`);
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return getCurrentPeerConnection();
            case 6:
              peerConnection = _context.sent;
              dtxEnabled = _sdp_helpers.default.hasSendDtx(peerConnection.remoteDescription().sdp);
              fecEnabled = _sdp_helpers.default.hasOpusFec(peerConnection.remoteDescription().sdp);
              rtcStats = {
                audio: {
                  packetLoss: undefined,
                  bitrate: undefined,
                  roundTripTime: undefined,
                  bufferDelay: undefined,
                  fec: fecEnabled,
                  dtx: dtxEnabled
                },
                video: {
                  packetLoss: undefined,
                  bitrate: undefined,
                  roundTripTime: undefined,
                  bufferDelay: undefined,
                  codec: undefined,
                  width: undefined,
                  height: undefined,
                  expectedWidth: undefined,
                  expectedHeight: undefined,
                  frameRate: undefined,
                  expectedFrameRate: undefined
                }
              };
              stats.forEach(stat => {
                if (stat.type === 'codec') {
                  const videoCodec = getVideoCodecFromStat(stat);
                  if (videoCodec) {
                    rtcStats.video.codec = videoCodec;
                  }
                }
                if (stat.kind === 'audio') {
                  if (stat.type === 'remote-outbound-rtp') {
                    rtcStats.audio.roundTripTime = stat.totalRoundTripTime;
                  }
                  if (stat.type === 'inbound-rtp') {
                    const currAudioStats = stat;
                    rtcStats.audio.packetLoss = calculatePacketsLostPercentage(currAudioStats);
                    if (lastAudioStats) {
                      rtcStats.audio.bitrate = calculateBitrate(currAudioStats, lastAudioStats);
                      rtcStats.audio.bufferDelay = calculateJitterBufferMovingAverage(currAudioStats, lastAudioStats);
                    }
                    lastAudioStats = currAudioStats;
                  }
                }
                if (stat.kind === 'video') {
                  // RTT returns 0 in most cases for subscriber. We still keep this logic for thoroughness.
                  if (stat.type === 'remote-outbound-rtp') {
                    rtcStats.video.roundTripTime = stat.totalRoundTripTime;
                  }
                  if (stat.type === 'inbound-rtp') {
                    var _subscriber$stream;
                    const currVideoStats = stat;
                    rtcStats.video.packetLoss = calculatePacketsLostPercentage(currVideoStats);
                    if (lastVideoStats) {
                      rtcStats.video.bitrate = calculateBitrate(currVideoStats, lastVideoStats);
                      rtcStats.video.bufferDelay = calculateJitterBufferMovingAverage(currVideoStats, lastVideoStats);
                    }
                    const actualDimensions = (_subscriber$stream = subscriber.stream) == null ? void 0 : _subscriber$stream.videoDimensions;
                    if (actualDimensions) {
                      rtcStats.video.width = actualDimensions == null ? void 0 : actualDimensions.width;
                      rtcStats.video.height = actualDimensions == null ? void 0 : actualDimensions.height;
                    }
                    const preferredDimensions = subscriber == null ? void 0 : subscriber._preferredResolution;
                    if (preferredDimensions) {
                      rtcStats.video.expectedWidth = subscriber == null ? void 0 : subscriber._preferredResolution.width;
                      rtcStats.video.expectedHeight = subscriber == null ? void 0 : subscriber._preferredResolution.height;
                    }
                    rtcStats.video.frameRate = currVideoStats.framesPerSecond;
                    rtcStats.video.expectedFrameRate = subscriber == null ? void 0 : subscriber._preferredFrameRate;
                    lastVideoStats = currVideoStats;
                  }
                }
              });
              rtcStats.video = deleteUndefinedProps(rtcStats.video);
              rtcStats.audio = deleteUndefinedProps(rtcStats.audio);
              scores = rtcScore(rtcStats);
              qualityScore = {};
              currentAudioScore = Number.isNaN(scores.audio) ? undefined : scores.audio;
              currentVideoScore = Number.isNaN(scores.video) ? undefined : scores.video;
              if (qosQualityScores) {
                qosQualityScores.audioQualityScore = currentAudioScore;
                qosQualityScores.videoQualityScore = currentVideoScore;
              }
              if (scores.audio && subscriber.stream.hasAudio) {
                qualityScore.audioQualityScore = scores.audio;
              }
              if (scores.video && subscriber.stream.hasVideo) {
                qualityScore.videoQualityScore = scores.video;
              }
              if (previousVideoScore !== currentVideoScore || previousAudioScore !== currentAudioScore) {
                // Don't emit an empty object
                if (Object.keys(qualityScore).length > 0) {
                  subscriber.dispatchEvent(new Events.QualityScoreChangedEvent(qualityScore));
                }
              }
              previousAudioScore = currentAudioScore;
              previousVideoScore = currentVideoScore;
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getStatsCallback(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    getStatsInterval = setInterval(() => {
      getStats(getStatsCallback);
    }, samplingInterval);
    subscriber.on('destroyed', () => {
      clearInterval(getStatsInterval);
    });
  }
});
var _default = createMOSScoreHelper;
exports.default = _default;

/***/ }),
/* 738 */
/***/ (function(module, exports) {

/*
 * Stats
 * packetLoss: 0-100%
 * bitrate: bps
 * roundTripTime: ms
 * bufferDelay: ms
 * codec: opus / vp8 / vp9 / h264 (only used for video)
 * fec: boolean (ony used for audio)
 * dtx: boolean (ony used for audio)
 * qp: number (not used yet)
 * keyFrames: number (not used yet)
 * width: number; Resolution of the video received
 * expectedWidth: number; Resolution of the rendering widget
 * height: number; Resolution of the video received
 * expectedHeight: number; Resolution of the rendering widget
 * frameRate: number; FrameRate of the video received
 * expectedFrameRate: number; FrameRate of the video source
 */
function score(stats) {
  const scores = {};
  const { audio, video } = normalize(stats);
  if (audio) {
    // Audio MOS calculation is based on E-Model algorithm
    // Assume 20 packetization delay
    const delay = 20 + audio.bufferDelay + audio.roundTripTime / 2;
    const pl = audio.packetLoss;
    const R0 = 100;
    // Ignore audio bitrate in dtx mode
    const Ie = audio.dtx
      ? 8
      : audio.bitrate
      ? clamp(55 - 4.6 * Math.log(audio.bitrate), 0, 30)
      : 6;
    const Bpl = audio.fec ? 20 : 10;
    const Ipl = Ie + (100 - Ie) * (pl / (pl + Bpl));

    const Id = delay * 0.03 + (delay > 150 ? 0.1 * (delay - 150) : 0);
    const R = clamp(R0 - Ipl - Id, 0, 100);
    const MOS = 1 + 0.035 * R + (R * (R - 60) * (100 - R) * 7) / 1000000;

    scores.audio = clamp(Math.round(MOS * 100) / 100, 1, 5);
  }
  if (video) {
    const pixels = video.expectedWidth * video.expectedHeight;
    const codecFactor = video.codec === 'vp9' ? 1.2 : 1.0;
    const delay = video.bufferDelay + video.roundTripTime / 2;
    // These parameters are generated with a logaritmic regression
    // on some very limited test data for now
    // They are based on the bits per pixel per frame (bPPPF)
    if (video.frameRate !== 0) {
      const bPPPF = (codecFactor * video.bitrate) / pixels / video.frameRate;
      const base = clamp(0.56 * Math.log(bPPPF) + 5.36, 1, 5);
      const MOS =
        base -
        1.9 * Math.log(video.expectedFrameRate / video.frameRate) -
        delay * 0.002;
      scores.video = clamp(Math.round(MOS * 100) / 100, 1, 5);
    } else {
      scores.video = 1;
    }
  }
  return scores;
}

function normalize(stats) {
  return {
    audio: stats.audio
      ? {
          packetLoss: 0,
          bufferDelay: 50,
          roundTripTime: 50,
          fec: true,
          ...stats.audio,
        }
      : undefined,
    video: stats.video
      ? {
          packetLoss: 0,
          bufferDelay: 0,
          roundTripTime: 50,
          fec: false,
          expectedHeight: stats.video.height || 640,
          expectedWidth: stats.video.width || 480,
          frameRate: stats.video.expectedFrameRate || 30,
          expectedFrameRate: stats.video.frameRate || 30,
          ...stats.video,
        }
      : undefined,
  };
}

function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}

module.exports = { score };


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
/**
 * We need frame rate watcher in Safari because framesPerSecond is
 * always zero so we need to rely on calculating the difference of
 * framesDecoded across multiple getStats invocations.
 * See https://bugs.webkit.org/show_bug.cgi?id=172682
 * In addition, we need to calculate it in Chrome v58+ and chromium based browsers
 * since framesPerSecond is not implemented in the standard getStats API.
 * In the case of Firefox 96+, the field 'frameRateMean' was removed so we need
 * to use the frame watchet to get the frameRate.
 */
var _default = () => _env.default.isSafari || _env.default.isChromiumEdge || _env.default.isOpera || _env.default.name === 'Chrome' && _env.default.version >= 58 || _env.default.isFirefox && _env.default.version >= 96;
exports.default = _default;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(741),
    upperFirst = __webpack_require__(283);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(742),
    deburr = __webpack_require__(743),
    words = __webpack_require__(746);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 742 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(744),
    toString = __webpack_require__(61);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(745);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 745 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(747),
    hasUnicodeWord = __webpack_require__(748),
    toString = __webpack_require__(61),
    unicodeWords = __webpack_require__(749);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 747 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 748 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise, process) {var _interopRequireDefault=__webpack_require__(0);exports.__esModule=true;exports.WavExporterTransformer=exports.VonageNoiseSuppression=exports.NoiseSuppressionTransformer=void 0;exports.createVonageNoiseSuppression=createVonageNoiseSuppression;var _regenerator=_interopRequireDefault(__webpack_require__(4));var _assertThisInitialized2=_interopRequireDefault(__webpack_require__(183));var _createClass2=_interopRequireDefault(__webpack_require__(25));var _asyncToGenerator2=_interopRequireDefault(__webpack_require__(5));var _inheritsLoose2=_interopRequireDefault(__webpack_require__(23));var _wrapNativeSuper2=_interopRequireDefault(__webpack_require__(165));var _globalThis=function(Object){function get(){var _global=this||self;delete Object.prototype.__magic__;return _global;}if(typeof globalThis==="object"){return globalThis;}if(this){return get();}else{Object.defineProperty(Object.prototype,"__magic__",{configurable:true,get:get});var _global=__magic__;return _global;}}(Object);function _createForOfIteratorHelperLoose(o,allowArrayLike){var it=typeof Symbol!=="undefined"&&o[Symbol.iterator]||o["@@iterator"];if(it)return(it=it.call(o)).next.bind(it);if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2;}let createWasmMonoInstance;{var Module=(()=>{var _scriptDir=location.href;return function(moduleArg){if(moduleArg===void 0){moduleArg={};}var Module=moduleArg;var readyPromiseResolve,readyPromiseReject;Module["ready"]=new Promise((resolve,reject)=>{readyPromiseResolve=resolve;readyPromiseReject=reject;});var moduleOverrides=Object.assign({},Module);var arguments_=[];var thisProgram="./this.program";var quit_=(status,toThrow)=>{throw toThrow;};var ENVIRONMENT_IS_WEB=typeof window=="object";var ENVIRONMENT_IS_WORKER=typeof importScripts=="function";var ENVIRONMENT_IS_NODE=typeof process=="object"&&typeof process.versions=="object"&&typeof process.versions.node=="string";var scriptDirectory="";function locateFile(path){if(Module["locateFile"]){return Module["locateFile"](path,scriptDirectory);}return scriptDirectory+path;}var read_,readAsync,readBinary;if(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER){if(ENVIRONMENT_IS_WORKER){scriptDirectory=self.location.href;}else if(typeof document!="undefined"&&document.currentScript){scriptDirectory=document.currentScript.src;}if(_scriptDir){scriptDirectory=_scriptDir;}if(scriptDirectory.indexOf("blob:")!==0){scriptDirectory=scriptDirectory.substr(0,scriptDirectory.replace(/[?#].*/,"").lastIndexOf("/")+1);}else{scriptDirectory="";}{read_=url=>{var xhr=new XMLHttpRequest();xhr.open("GET",url,false);xhr.send(null);return xhr.responseText;};if(ENVIRONMENT_IS_WORKER){readBinary=url=>{var xhr=new XMLHttpRequest();xhr.open("GET",url,false);xhr.responseType="arraybuffer";xhr.send(null);return new Uint8Array(xhr.response);};}readAsync=(url,onload,onerror)=>{var xhr=new XMLHttpRequest();xhr.open("GET",url,true);xhr.responseType="arraybuffer";xhr.onload=()=>{if(xhr.status==200||xhr.status==0&&xhr.response){onload(xhr.response);return;}onerror();};xhr.onerror=onerror;xhr.send(null);};}}else{}var out=Module["print"]||console.log.bind(console);var err=Module["printErr"]||console.error.bind(console);Object.assign(Module,moduleOverrides);moduleOverrides=null;if(Module["arguments"])arguments_=Module["arguments"];if(Module["thisProgram"])thisProgram=Module["thisProgram"];if(Module["quit"])quit_=Module["quit"];var wasmBinary;if(Module["wasmBinary"])wasmBinary=Module["wasmBinary"];if(typeof WebAssembly!="object"){abort("no native wasm support detected");}var wasmMemory;var ABORT=false;var EXITSTATUS;function assert(condition,text){if(!condition){abort(text);}}var HEAP8,HEAPU8,HEAP16,HEAPU16,HEAP32,HEAPU32,HEAPF32,HEAPF64;function updateMemoryViews(){var b=wasmMemory.buffer;Module["HEAP8"]=HEAP8=new Int8Array(b);Module["HEAP16"]=HEAP16=new Int16Array(b);Module["HEAPU8"]=HEAPU8=new Uint8Array(b);Module["HEAPU16"]=HEAPU16=new Uint16Array(b);Module["HEAP32"]=HEAP32=new Int32Array(b);Module["HEAPU32"]=HEAPU32=new Uint32Array(b);Module["HEAPF32"]=HEAPF32=new Float32Array(b);Module["HEAPF64"]=HEAPF64=new Float64Array(b);}var __ATPRERUN__=[];var __ATINIT__=[];var __ATEXIT__=[];var __ATPOSTRUN__=[];var runtimeInitialized=false;var runtimeExited=false;function preRun(){if(Module["preRun"]){if(typeof Module["preRun"]=="function")Module["preRun"]=[Module["preRun"]];while(Module["preRun"].length){addOnPreRun(Module["preRun"].shift());}}callRuntimeCallbacks(__ATPRERUN__);}function initRuntime(){runtimeInitialized=true;if(!Module["noFSInit"]&&!FS.init.initialized)FS.init();FS.ignorePermissions=false;TTY.init();callRuntimeCallbacks(__ATINIT__);}function exitRuntime(){___funcs_on_exit();callRuntimeCallbacks(__ATEXIT__);FS.quit();TTY.shutdown();runtimeExited=true;}function postRun(){if(Module["postRun"]){if(typeof Module["postRun"]=="function")Module["postRun"]=[Module["postRun"]];while(Module["postRun"].length){addOnPostRun(Module["postRun"].shift());}}callRuntimeCallbacks(__ATPOSTRUN__);}function addOnPreRun(cb){__ATPRERUN__.unshift(cb);}function addOnInit(cb){__ATINIT__.unshift(cb);}function addOnPostRun(cb){__ATPOSTRUN__.unshift(cb);}var runDependencies=0;var runDependencyWatcher=null;var dependenciesFulfilled=null;function getUniqueRunDependency(id){return id;}function addRunDependency(id){runDependencies++;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies);}}function removeRunDependency(id){runDependencies--;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies);}if(runDependencies==0){if(runDependencyWatcher!==null){clearInterval(runDependencyWatcher);runDependencyWatcher=null;}if(dependenciesFulfilled){var callback=dependenciesFulfilled;dependenciesFulfilled=null;callback();}}}function abort(what){if(Module["onAbort"]){Module["onAbort"](what);}what="Aborted("+what+")";err(what);ABORT=true;EXITSTATUS=1;what+=". Build with -sASSERTIONS for more info.";var e=new WebAssembly.RuntimeError(what);readyPromiseReject(e);throw e;}var dataURIPrefix="data:application/octet-stream;base64,";var isDataURI=filename=>filename.startsWith(dataURIPrefix);var wasmBinaryFile;if(Module["locateFile"]){wasmBinaryFile="main-bin-mono.wasm";if(!isDataURI(wasmBinaryFile)){wasmBinaryFile=locateFile(wasmBinaryFile);}}else{wasmBinaryFile=new URL("main-bin-mono.wasm",location.href).href;}function getBinarySync(file){if(file==wasmBinaryFile&&wasmBinary){return new Uint8Array(wasmBinary);}if(readBinary){return readBinary(file);}throw"both async and sync fetching of the wasm failed";}function getBinaryPromise(binaryFile){if(!wasmBinary&&(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER)){if(typeof fetch=="function"){return fetch(binaryFile,{credentials:"same-origin"}).then(response=>{if(!response["ok"]){throw"failed to load wasm binary file at '"+binaryFile+"'";}return response["arrayBuffer"]();}).catch(()=>getBinarySync(binaryFile));}}return Promise.resolve().then(()=>getBinarySync(binaryFile));}function instantiateArrayBuffer(binaryFile,imports,receiver){return getBinaryPromise(binaryFile).then(binary=>WebAssembly.instantiate(binary,imports)).then(instance=>instance).then(receiver,reason=>{err(`failed to asynchronously prepare wasm: ${reason}`);abort(reason);});}function instantiateAsync(binary,binaryFile,imports,callback){if(!binary&&typeof WebAssembly.instantiateStreaming=="function"&&!isDataURI(binaryFile)&&typeof fetch=="function"){return fetch(binaryFile,{credentials:"same-origin"}).then(response=>{var result=WebAssembly.instantiateStreaming(response,imports);return result.then(callback,function(reason){err(`wasm streaming compile failed: ${reason}`);err("falling back to ArrayBuffer instantiation");return instantiateArrayBuffer(binaryFile,imports,callback);});});}return instantiateArrayBuffer(binaryFile,imports,callback);}function createWasm(){var info={"a":wasmImports};function receiveInstance(instance,module){wasmExports=instance.exports;wasmMemory=wasmExports["ua"];updateMemoryViews();wasmTable=wasmExports["wa"];addOnInit(wasmExports["va"]);removeRunDependency("wasm-instantiate");return wasmExports;}addRunDependency("wasm-instantiate");function receiveInstantiationResult(result){receiveInstance(result["instance"]);}if(Module["instantiateWasm"]){try{return Module["instantiateWasm"](info,receiveInstance);}catch(e){err(`Module.instantiateWasm callback failed with error: ${e}`);readyPromiseReject(e);}}instantiateAsync(wasmBinary,wasmBinaryFile,info,receiveInstantiationResult).catch(readyPromiseReject);return{};}var tempDouble;var tempI64;function xnnLoadWasmModuleJS(code,offset,offset_end,invalid_function_index){const tableOriginalSize=wasmTable.length;const binary=new Uint8Array(HEAPU8.slice(code+offset,code+offset_end));try{var module=new WebAssembly.Module(binary);var instance=new WebAssembly.Instance(module,{env:{memory:wasmMemory}});for(var symName in instance.exports){var value=instance.exports[symName];addFunction(value);}if(tableOriginalSize<wasmTable.length){return tableOriginalSize;}return invalid_function_index;}catch(error){console.log(error);return invalid_function_index;}}function ExitStatus(status){this.name="ExitStatus";this.message=`Program terminated with exit(${status})`;this.status=status;}var callRuntimeCallbacks=callbacks=>{while(callbacks.length>0){callbacks.shift()(Module);}};var noExitRuntime=Module["noExitRuntime"]||false;var UTF8Decoder=typeof TextDecoder!="undefined"?new TextDecoder("utf8"):undefined;var UTF8ArrayToString=(heapOrArray,idx,maxBytesToRead)=>{var endIdx=idx+maxBytesToRead;var endPtr=idx;while(heapOrArray[endPtr]&&!(endPtr>=endIdx))++endPtr;if(endPtr-idx>16&&heapOrArray.buffer&&UTF8Decoder){return UTF8Decoder.decode(heapOrArray.subarray(idx,endPtr));}var str="";while(idx<endPtr){var u0=heapOrArray[idx++];if(!(u0&128)){str+=String.fromCharCode(u0);continue;}var u1=heapOrArray[idx++]&63;if((u0&224)==192){str+=String.fromCharCode((u0&31)<<6|u1);continue;}var u2=heapOrArray[idx++]&63;if((u0&240)==224){u0=(u0&15)<<12|u1<<6|u2;}else{u0=(u0&7)<<18|u1<<12|u2<<6|heapOrArray[idx++]&63;}if(u0<65536){str+=String.fromCharCode(u0);}else{var ch=u0-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023);}}return str;};var UTF8ToString=(ptr,maxBytesToRead)=>ptr?UTF8ArrayToString(HEAPU8,ptr,maxBytesToRead):"";var ___assert_fail=(condition,filename,line,func)=>{abort(`Assertion failed: ${UTF8ToString(condition)}, at: `+[filename?UTF8ToString(filename):"unknown filename",line,func?UTF8ToString(func):"unknown function"]);};var exceptionCaught=[];var uncaughtExceptionCount=0;var ___cxa_begin_catch=ptr=>{var info=new ExceptionInfo(ptr);if(!info.get_caught()){info.set_caught(true);uncaughtExceptionCount--;}info.set_rethrown(false);exceptionCaught.push(info);___cxa_increment_exception_refcount(info.excPtr);return info.get_exception_ptr();};var exceptionLast=0;var ___cxa_end_catch=()=>{_setThrew(0,0);var info=exceptionCaught.pop();___cxa_decrement_exception_refcount(info.excPtr);exceptionLast=0;};function ExceptionInfo(excPtr){this.excPtr=excPtr;this.ptr=excPtr-24;this.set_type=function(type){HEAPU32[this.ptr+4>>2]=type;};this.get_type=function(){return HEAPU32[this.ptr+4>>2];};this.set_destructor=function(destructor){HEAPU32[this.ptr+8>>2]=destructor;};this.get_destructor=function(){return HEAPU32[this.ptr+8>>2];};this.set_caught=function(caught){caught=caught?1:0;HEAP8[this.ptr+12>>0]=caught;};this.get_caught=function(){return HEAP8[this.ptr+12>>0]!=0;};this.set_rethrown=function(rethrown){rethrown=rethrown?1:0;HEAP8[this.ptr+13>>0]=rethrown;};this.get_rethrown=function(){return HEAP8[this.ptr+13>>0]!=0;};this.init=function(type,destructor){this.set_adjusted_ptr(0);this.set_type(type);this.set_destructor(destructor);};this.set_adjusted_ptr=function(adjustedPtr){HEAPU32[this.ptr+16>>2]=adjustedPtr;};this.get_adjusted_ptr=function(){return HEAPU32[this.ptr+16>>2];};this.get_exception_ptr=function(){var isPointer=___cxa_is_pointer_type(this.get_type());if(isPointer){return HEAPU32[this.excPtr>>2];}var adjusted=this.get_adjusted_ptr();if(adjusted!==0)return adjusted;return this.excPtr;};}var ___resumeException=ptr=>{if(!exceptionLast){exceptionLast=ptr;}throw exceptionLast;};var findMatchingCatch=args=>{var thrown=exceptionLast;if(!thrown){setTempRet0(0);return 0;}var info=new ExceptionInfo(thrown);info.set_adjusted_ptr(thrown);var thrownType=info.get_type();if(!thrownType){setTempRet0(0);return thrown;}for(var arg in args){var caughtType=args[arg];if(caughtType===0||caughtType===thrownType){break;}var adjusted_ptr_addr=info.ptr+16;if(___cxa_can_catch(caughtType,thrownType,adjusted_ptr_addr)){setTempRet0(caughtType);return thrown;}}setTempRet0(thrownType);return thrown;};var ___cxa_find_matching_catch_2=()=>findMatchingCatch([]);var ___cxa_find_matching_catch_3=arg0=>findMatchingCatch([arg0]);var ___cxa_rethrow=()=>{var info=exceptionCaught.pop();if(!info){abort("no exception to throw");}var ptr=info.excPtr;if(!info.get_rethrown()){exceptionCaught.push(info);info.set_rethrown(true);info.set_caught(false);uncaughtExceptionCount++;}exceptionLast=ptr;throw exceptionLast;};var ___cxa_throw=(ptr,type,destructor)=>{var info=new ExceptionInfo(ptr);info.init(type,destructor);exceptionLast=ptr;uncaughtExceptionCount++;throw exceptionLast;};var PATH={isAbs:path=>path.charAt(0)==="/",splitPath:filename=>{var splitPathRe=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;return splitPathRe.exec(filename).slice(1);},normalizeArray:(parts,allowAboveRoot)=>{var up=0;for(var i=parts.length-1;i>=0;i--){var last=parts[i];if(last==="."){parts.splice(i,1);}else if(last===".."){parts.splice(i,1);up++;}else if(up){parts.splice(i,1);up--;}}if(allowAboveRoot){for(;up;up--){parts.unshift("..");}}return parts;},normalize:path=>{var isAbsolute=PATH.isAbs(path),trailingSlash=path.substr(-1)==="/";path=PATH.normalizeArray(path.split("/").filter(p=>!!p),!isAbsolute).join("/");if(!path&&!isAbsolute){path=".";}if(path&&trailingSlash){path+="/";}return(isAbsolute?"/":"")+path;},dirname:path=>{var result=PATH.splitPath(path),root=result[0],dir=result[1];if(!root&&!dir){return".";}if(dir){dir=dir.substr(0,dir.length-1);}return root+dir;},basename:path=>{if(path==="/")return"/";path=PATH.normalize(path);path=path.replace(/\/$/,"");var lastSlash=path.lastIndexOf("/");if(lastSlash===-1)return path;return path.substr(lastSlash+1);},join:function join(){var paths=Array.prototype.slice.call(arguments);return PATH.normalize(paths.join("/"));},join2:(l,r)=>PATH.normalize(l+"/"+r)};var initRandomFill=()=>{if(typeof crypto=="object"&&typeof crypto["getRandomValues"]=="function"){return view=>crypto.getRandomValues(view);}else abort("initRandomDevice");};var randomFill=view=>(randomFill=initRandomFill())(view);var PATH_FS={resolve:function resolve(){var resolvedPath="",resolvedAbsolute=false;for(var i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?arguments[i]:FS.cwd();if(typeof path!="string"){throw new TypeError("Arguments to path.resolve must be strings");}else if(!path){return"";}resolvedPath=path+"/"+resolvedPath;resolvedAbsolute=PATH.isAbs(path);}resolvedPath=PATH.normalizeArray(resolvedPath.split("/").filter(p=>!!p),!resolvedAbsolute).join("/");return(resolvedAbsolute?"/":"")+resolvedPath||".";},relative:(from,to)=>{from=PATH_FS.resolve(from).substr(1);to=PATH_FS.resolve(to).substr(1);function trim(arr){var start=0;for(;start<arr.length;start++){if(arr[start]!=="")break;}var end=arr.length-1;for(;end>=0;end--){if(arr[end]!=="")break;}if(start>end)return[];return arr.slice(start,end-start+1);}var fromParts=trim(from.split("/"));var toParts=trim(to.split("/"));var length=Math.min(fromParts.length,toParts.length);var samePartsLength=length;for(var i=0;i<length;i++){if(fromParts[i]!==toParts[i]){samePartsLength=i;break;}}var outputParts=[];for(var i=samePartsLength;i<fromParts.length;i++){outputParts.push("..");}outputParts=outputParts.concat(toParts.slice(samePartsLength));return outputParts.join("/");}};var FS_stdin_getChar_buffer=[];var lengthBytesUTF8=str=>{var len=0;for(var i=0;i<str.length;++i){var c=str.charCodeAt(i);if(c<=127){len++;}else if(c<=2047){len+=2;}else if(c>=55296&&c<=57343){len+=4;++i;}else{len+=3;}}return len;};var stringToUTF8Array=(str,heap,outIdx,maxBytesToWrite)=>{if(!(maxBytesToWrite>0))return 0;var startIdx=outIdx;var endIdx=outIdx+maxBytesToWrite-1;for(var i=0;i<str.length;++i){var u=str.charCodeAt(i);if(u>=55296&&u<=57343){var u1=str.charCodeAt(++i);u=65536+((u&1023)<<10)|u1&1023;}if(u<=127){if(outIdx>=endIdx)break;heap[outIdx++]=u;}else if(u<=2047){if(outIdx+1>=endIdx)break;heap[outIdx++]=192|u>>6;heap[outIdx++]=128|u&63;}else if(u<=65535){if(outIdx+2>=endIdx)break;heap[outIdx++]=224|u>>12;heap[outIdx++]=128|u>>6&63;heap[outIdx++]=128|u&63;}else{if(outIdx+3>=endIdx)break;heap[outIdx++]=240|u>>18;heap[outIdx++]=128|u>>12&63;heap[outIdx++]=128|u>>6&63;heap[outIdx++]=128|u&63;}}heap[outIdx]=0;return outIdx-startIdx;};function intArrayFromString(stringy,dontAddNull,length){var len=length>0?length:lengthBytesUTF8(stringy)+1;var u8array=new Array(len);var numBytesWritten=stringToUTF8Array(stringy,u8array,0,u8array.length);if(dontAddNull)u8array.length=numBytesWritten;return u8array;}var FS_stdin_getChar=()=>{if(!FS_stdin_getChar_buffer.length){var result=null;if(typeof window!="undefined"&&typeof window.prompt=="function"){result=window.prompt("Input: ");if(result!==null){result+="\n";}}else if(typeof readline=="function"){result=readline();if(result!==null){result+="\n";}}if(!result){return null;}FS_stdin_getChar_buffer=intArrayFromString(result,true);}return FS_stdin_getChar_buffer.shift();};var TTY={ttys:[],init(){},shutdown(){},register(dev,ops){TTY.ttys[dev]={input:[],output:[],ops:ops};FS.registerDevice(dev,TTY.stream_ops);},stream_ops:{open(stream){var tty=TTY.ttys[stream.node.rdev];if(!tty){throw new FS.ErrnoError(43);}stream.tty=tty;stream.seekable=false;},close(stream){stream.tty.ops.fsync(stream.tty);},fsync(stream){stream.tty.ops.fsync(stream.tty);},read(stream,buffer,offset,length,pos){if(!stream.tty||!stream.tty.ops.get_char){throw new FS.ErrnoError(60);}var bytesRead=0;for(var i=0;i<length;i++){var result;try{result=stream.tty.ops.get_char(stream.tty);}catch(e){throw new FS.ErrnoError(29);}if(result===undefined&&bytesRead===0){throw new FS.ErrnoError(6);}if(result===null||result===undefined)break;bytesRead++;buffer[offset+i]=result;}if(bytesRead){stream.node.timestamp=Date.now();}return bytesRead;},write(stream,buffer,offset,length,pos){if(!stream.tty||!stream.tty.ops.put_char){throw new FS.ErrnoError(60);}try{for(var i=0;i<length;i++){stream.tty.ops.put_char(stream.tty,buffer[offset+i]);}}catch(e){throw new FS.ErrnoError(29);}if(length){stream.node.timestamp=Date.now();}return i;}},default_tty_ops:{get_char(tty){return FS_stdin_getChar();},put_char(tty,val){if(val===null||val===10){out(UTF8ArrayToString(tty.output,0));tty.output=[];}else{if(val!=0)tty.output.push(val);}},fsync(tty){if(tty.output&&tty.output.length>0){out(UTF8ArrayToString(tty.output,0));tty.output=[];}},ioctl_tcgets(tty){return{c_iflag:25856,c_oflag:5,c_cflag:191,c_lflag:35387,c_cc:[3,28,127,21,4,0,1,0,17,19,26,0,18,15,23,22,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]};},ioctl_tcsets(tty,optional_actions,data){return 0;},ioctl_tiocgwinsz(tty){return[24,80];}},default_tty1_ops:{put_char(tty,val){if(val===null||val===10){err(UTF8ArrayToString(tty.output,0));tty.output=[];}else{if(val!=0)tty.output.push(val);}},fsync(tty){if(tty.output&&tty.output.length>0){err(UTF8ArrayToString(tty.output,0));tty.output=[];}}}};var zeroMemory=(address,size)=>{HEAPU8.fill(0,address,address+size);return address;};var alignMemory=(size,alignment)=>Math.ceil(size/alignment)*alignment;var mmapAlloc=size=>{size=alignMemory(size,65536);var ptr=_emscripten_builtin_memalign(65536,size);if(!ptr)return 0;return zeroMemory(ptr,size);};var MEMFS={ops_table:null,mount(mount){return MEMFS.createNode(null,"/",16384|511,0);},createNode(parent,name,mode,dev){if(FS.isBlkdev(mode)||FS.isFIFO(mode)){throw new FS.ErrnoError(63);}if(!MEMFS.ops_table){MEMFS.ops_table={dir:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr,lookup:MEMFS.node_ops.lookup,mknod:MEMFS.node_ops.mknod,rename:MEMFS.node_ops.rename,unlink:MEMFS.node_ops.unlink,rmdir:MEMFS.node_ops.rmdir,readdir:MEMFS.node_ops.readdir,symlink:MEMFS.node_ops.symlink},stream:{llseek:MEMFS.stream_ops.llseek}},file:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr},stream:{llseek:MEMFS.stream_ops.llseek,read:MEMFS.stream_ops.read,write:MEMFS.stream_ops.write,allocate:MEMFS.stream_ops.allocate,mmap:MEMFS.stream_ops.mmap,msync:MEMFS.stream_ops.msync}},link:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr,readlink:MEMFS.node_ops.readlink},stream:{}},chrdev:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr},stream:FS.chrdev_stream_ops}};}var node=FS.createNode(parent,name,mode,dev);if(FS.isDir(node.mode)){node.node_ops=MEMFS.ops_table.dir.node;node.stream_ops=MEMFS.ops_table.dir.stream;node.contents={};}else if(FS.isFile(node.mode)){node.node_ops=MEMFS.ops_table.file.node;node.stream_ops=MEMFS.ops_table.file.stream;node.usedBytes=0;node.contents=null;}else if(FS.isLink(node.mode)){node.node_ops=MEMFS.ops_table.link.node;node.stream_ops=MEMFS.ops_table.link.stream;}else if(FS.isChrdev(node.mode)){node.node_ops=MEMFS.ops_table.chrdev.node;node.stream_ops=MEMFS.ops_table.chrdev.stream;}node.timestamp=Date.now();if(parent){parent.contents[name]=node;parent.timestamp=node.timestamp;}return node;},getFileDataAsTypedArray(node){if(!node.contents)return new Uint8Array(0);if(node.contents.subarray)return node.contents.subarray(0,node.usedBytes);return new Uint8Array(node.contents);},expandFileStorage(node,newCapacity){var prevCapacity=node.contents?node.contents.length:0;if(prevCapacity>=newCapacity)return;var CAPACITY_DOUBLING_MAX=1024*1024;newCapacity=Math.max(newCapacity,prevCapacity*(prevCapacity<CAPACITY_DOUBLING_MAX?2:1.125)>>>0);if(prevCapacity!=0)newCapacity=Math.max(newCapacity,256);var oldContents=node.contents;node.contents=new Uint8Array(newCapacity);if(node.usedBytes>0)node.contents.set(oldContents.subarray(0,node.usedBytes),0);},resizeFileStorage(node,newSize){if(node.usedBytes==newSize)return;if(newSize==0){node.contents=null;node.usedBytes=0;}else{var oldContents=node.contents;node.contents=new Uint8Array(newSize);if(oldContents){node.contents.set(oldContents.subarray(0,Math.min(newSize,node.usedBytes)));}node.usedBytes=newSize;}},node_ops:{getattr(node){var attr={};attr.dev=FS.isChrdev(node.mode)?node.id:1;attr.ino=node.id;attr.mode=node.mode;attr.nlink=1;attr.uid=0;attr.gid=0;attr.rdev=node.rdev;if(FS.isDir(node.mode)){attr.size=4096;}else if(FS.isFile(node.mode)){attr.size=node.usedBytes;}else if(FS.isLink(node.mode)){attr.size=node.link.length;}else{attr.size=0;}attr.atime=new Date(node.timestamp);attr.mtime=new Date(node.timestamp);attr.ctime=new Date(node.timestamp);attr.blksize=4096;attr.blocks=Math.ceil(attr.size/attr.blksize);return attr;},setattr(node,attr){if(attr.mode!==undefined){node.mode=attr.mode;}if(attr.timestamp!==undefined){node.timestamp=attr.timestamp;}if(attr.size!==undefined){MEMFS.resizeFileStorage(node,attr.size);}},lookup(parent,name){throw FS.genericErrors[44];},mknod(parent,name,mode,dev){return MEMFS.createNode(parent,name,mode,dev);},rename(old_node,new_dir,new_name){if(FS.isDir(old_node.mode)){var new_node;try{new_node=FS.lookupNode(new_dir,new_name);}catch(e){}if(new_node){for(var i in new_node.contents){throw new FS.ErrnoError(55);}}}delete old_node.parent.contents[old_node.name];old_node.parent.timestamp=Date.now();old_node.name=new_name;new_dir.contents[new_name]=old_node;new_dir.timestamp=old_node.parent.timestamp;old_node.parent=new_dir;},unlink(parent,name){delete parent.contents[name];parent.timestamp=Date.now();},rmdir(parent,name){var node=FS.lookupNode(parent,name);for(var i in node.contents){throw new FS.ErrnoError(55);}delete parent.contents[name];parent.timestamp=Date.now();},readdir(node){var entries=[".",".."];for(var key in node.contents){if(!node.contents.hasOwnProperty(key)){continue;}entries.push(key);}return entries;},symlink(parent,newname,oldpath){var node=MEMFS.createNode(parent,newname,511|40960,0);node.link=oldpath;return node;},readlink(node){if(!FS.isLink(node.mode)){throw new FS.ErrnoError(28);}return node.link;}},stream_ops:{read(stream,buffer,offset,length,position){var contents=stream.node.contents;if(position>=stream.node.usedBytes)return 0;var size=Math.min(stream.node.usedBytes-position,length);if(size>8&&contents.subarray){buffer.set(contents.subarray(position,position+size),offset);}else{for(var i=0;i<size;i++)buffer[offset+i]=contents[position+i];}return size;},write(stream,buffer,offset,length,position,canOwn){if(!length)return 0;var node=stream.node;node.timestamp=Date.now();if(buffer.subarray&&(!node.contents||node.contents.subarray)){if(canOwn){node.contents=buffer.subarray(offset,offset+length);node.usedBytes=length;return length;}else if(node.usedBytes===0&&position===0){node.contents=buffer.slice(offset,offset+length);node.usedBytes=length;return length;}else if(position+length<=node.usedBytes){node.contents.set(buffer.subarray(offset,offset+length),position);return length;}}MEMFS.expandFileStorage(node,position+length);if(node.contents.subarray&&buffer.subarray){node.contents.set(buffer.subarray(offset,offset+length),position);}else{for(var i=0;i<length;i++){node.contents[position+i]=buffer[offset+i];}}node.usedBytes=Math.max(node.usedBytes,position+length);return length;},llseek(stream,offset,whence){var position=offset;if(whence===1){position+=stream.position;}else if(whence===2){if(FS.isFile(stream.node.mode)){position+=stream.node.usedBytes;}}if(position<0){throw new FS.ErrnoError(28);}return position;},allocate(stream,offset,length){MEMFS.expandFileStorage(stream.node,offset+length);stream.node.usedBytes=Math.max(stream.node.usedBytes,offset+length);},mmap(stream,length,position,prot,flags){if(!FS.isFile(stream.node.mode)){throw new FS.ErrnoError(43);}var ptr;var allocated;var contents=stream.node.contents;if(!(flags&2)&&contents.buffer===HEAP8.buffer){allocated=false;ptr=contents.byteOffset;}else{if(position>0||position+length<contents.length){if(contents.subarray){contents=contents.subarray(position,position+length);}else{contents=Array.prototype.slice.call(contents,position,position+length);}}allocated=true;ptr=mmapAlloc(length);if(!ptr){throw new FS.ErrnoError(48);}HEAP8.set(contents,ptr);}return{ptr:ptr,allocated:allocated};},msync(stream,buffer,offset,length,mmapFlags){MEMFS.stream_ops.write(stream,buffer,0,length,offset,false);return 0;}}};var asyncLoad=(url,onload,onerror,noRunDep)=>{var dep=!noRunDep?getUniqueRunDependency(`al ${url}`):"";readAsync(url,arrayBuffer=>{assert(arrayBuffer,`Loading data file "${url}" failed (no arrayBuffer).`);onload(new Uint8Array(arrayBuffer));if(dep)removeRunDependency(dep);},event=>{if(onerror){onerror();}else{throw`Loading data file "${url}" failed.`;}});if(dep)addRunDependency(dep);};var FS_createDataFile=(parent,name,fileData,canRead,canWrite,canOwn)=>{FS.createDataFile(parent,name,fileData,canRead,canWrite,canOwn);};var preloadPlugins=Module["preloadPlugins"]||[];var FS_handledByPreloadPlugin=(byteArray,fullname,finish,onerror)=>{if(typeof Browser!="undefined")Browser.init();var handled=false;preloadPlugins.forEach(plugin=>{if(handled)return;if(plugin["canHandle"](fullname)){plugin["handle"](byteArray,fullname,finish,onerror);handled=true;}});return handled;};var FS_createPreloadedFile=(parent,name,url,canRead,canWrite,onload,onerror,dontCreateFile,canOwn,preFinish)=>{var fullname=name?PATH_FS.resolve(PATH.join2(parent,name)):parent;var dep=getUniqueRunDependency(`cp ${fullname}`);function processData(byteArray){function finish(byteArray){if(preFinish)preFinish();if(!dontCreateFile){FS_createDataFile(parent,name,byteArray,canRead,canWrite,canOwn);}if(onload)onload();removeRunDependency(dep);}if(FS_handledByPreloadPlugin(byteArray,fullname,finish,()=>{if(onerror)onerror();removeRunDependency(dep);})){return;}finish(byteArray);}addRunDependency(dep);if(typeof url=="string"){asyncLoad(url,byteArray=>processData(byteArray),onerror);}else{processData(url);}};var FS_modeStringToFlags=str=>{var flagModes={"r":0,"r+":2,"w":512|64|1,"w+":512|64|2,"a":1024|64|1,"a+":1024|64|2};var flags=flagModes[str];if(typeof flags=="undefined"){throw new Error(`Unknown file open mode: ${str}`);}return flags;};var FS_getMode=(canRead,canWrite)=>{var mode=0;if(canRead)mode|=292|73;if(canWrite)mode|=146;return mode;};var FS={root:null,mounts:[],devices:{},streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:false,ignorePermissions:true,ErrnoError:null,genericErrors:{},filesystems:null,syncFSRequests:0,lookupPath(path,opts){if(opts===void 0){opts={};}path=PATH_FS.resolve(path);if(!path)return{path:"",node:null};var defaults={follow_mount:true,recurse_count:0};opts=Object.assign(defaults,opts);if(opts.recurse_count>8){throw new FS.ErrnoError(32);}var parts=path.split("/").filter(p=>!!p);var current=FS.root;var current_path="/";for(var i=0;i<parts.length;i++){var islast=i===parts.length-1;if(islast&&opts.parent){break;}current=FS.lookupNode(current,parts[i]);current_path=PATH.join2(current_path,parts[i]);if(FS.isMountpoint(current)){if(!islast||islast&&opts.follow_mount){current=current.mounted.root;}}if(!islast||opts.follow){var count=0;while(FS.isLink(current.mode)){var link=FS.readlink(current_path);current_path=PATH_FS.resolve(PATH.dirname(current_path),link);var lookup=FS.lookupPath(current_path,{recurse_count:opts.recurse_count+1});current=lookup.node;if(count++>40){throw new FS.ErrnoError(32);}}}}return{path:current_path,node:current};},getPath(node){var path;while(true){if(FS.isRoot(node)){var mount=node.mount.mountpoint;if(!path)return mount;return mount[mount.length-1]!=="/"?`${mount}/${path}`:mount+path;}path=path?`${node.name}/${path}`:node.name;node=node.parent;}},hashName(parentid,name){var hash=0;for(var i=0;i<name.length;i++){hash=(hash<<5)-hash+name.charCodeAt(i)|0;}return(parentid+hash>>>0)%FS.nameTable.length;},hashAddNode(node){var hash=FS.hashName(node.parent.id,node.name);node.name_next=FS.nameTable[hash];FS.nameTable[hash]=node;},hashRemoveNode(node){var hash=FS.hashName(node.parent.id,node.name);if(FS.nameTable[hash]===node){FS.nameTable[hash]=node.name_next;}else{var current=FS.nameTable[hash];while(current){if(current.name_next===node){current.name_next=node.name_next;break;}current=current.name_next;}}},lookupNode(parent,name){var errCode=FS.mayLookup(parent);if(errCode){throw new FS.ErrnoError(errCode,parent);}var hash=FS.hashName(parent.id,name);for(var node=FS.nameTable[hash];node;node=node.name_next){var nodeName=node.name;if(node.parent.id===parent.id&&nodeName===name){return node;}}return FS.lookup(parent,name);},createNode(parent,name,mode,rdev){var node=new FS.FSNode(parent,name,mode,rdev);FS.hashAddNode(node);return node;},destroyNode(node){FS.hashRemoveNode(node);},isRoot(node){return node===node.parent;},isMountpoint(node){return!!node.mounted;},isFile(mode){return(mode&61440)===32768;},isDir(mode){return(mode&61440)===16384;},isLink(mode){return(mode&61440)===40960;},isChrdev(mode){return(mode&61440)===8192;},isBlkdev(mode){return(mode&61440)===24576;},isFIFO(mode){return(mode&61440)===4096;},isSocket(mode){return(mode&49152)===49152;},flagsToPermissionString(flag){var perms=["r","w","rw"][flag&3];if(flag&512){perms+="w";}return perms;},nodePermissions(node,perms){if(FS.ignorePermissions){return 0;}if(perms.includes("r")&&!(node.mode&292)){return 2;}else if(perms.includes("w")&&!(node.mode&146)){return 2;}else if(perms.includes("x")&&!(node.mode&73)){return 2;}return 0;},mayLookup(dir){var errCode=FS.nodePermissions(dir,"x");if(errCode)return errCode;if(!dir.node_ops.lookup)return 2;return 0;},mayCreate(dir,name){try{var node=FS.lookupNode(dir,name);return 20;}catch(e){}return FS.nodePermissions(dir,"wx");},mayDelete(dir,name,isdir){var node;try{node=FS.lookupNode(dir,name);}catch(e){return e.errno;}var errCode=FS.nodePermissions(dir,"wx");if(errCode){return errCode;}if(isdir){if(!FS.isDir(node.mode)){return 54;}if(FS.isRoot(node)||FS.getPath(node)===FS.cwd()){return 10;}}else{if(FS.isDir(node.mode)){return 31;}}return 0;},mayOpen(node,flags){if(!node){return 44;}if(FS.isLink(node.mode)){return 32;}else if(FS.isDir(node.mode)){if(FS.flagsToPermissionString(flags)!=="r"||flags&512){return 31;}}return FS.nodePermissions(node,FS.flagsToPermissionString(flags));},MAX_OPEN_FDS:4096,nextfd(){for(var fd=0;fd<=FS.MAX_OPEN_FDS;fd++){if(!FS.streams[fd]){return fd;}}throw new FS.ErrnoError(33);},getStreamChecked(fd){var stream=FS.getStream(fd);if(!stream){throw new FS.ErrnoError(8);}return stream;},getStream:fd=>FS.streams[fd],createStream(stream,fd){if(fd===void 0){fd=-1;}if(!FS.FSStream){FS.FSStream=function(){this.shared={};};FS.FSStream.prototype={};Object.defineProperties(FS.FSStream.prototype,{object:{get(){return this.node;},set(val){this.node=val;}},isRead:{get(){return(this.flags&2097155)!==1;}},isWrite:{get(){return(this.flags&2097155)!==0;}},isAppend:{get(){return this.flags&1024;}},flags:{get(){return this.shared.flags;},set(val){this.shared.flags=val;}},position:{get(){return this.shared.position;},set(val){this.shared.position=val;}}});}stream=Object.assign(new FS.FSStream(),stream);if(fd==-1){fd=FS.nextfd();}stream.fd=fd;FS.streams[fd]=stream;return stream;},closeStream(fd){FS.streams[fd]=null;},chrdev_stream_ops:{open(stream){var device=FS.getDevice(stream.node.rdev);stream.stream_ops=device.stream_ops;if(stream.stream_ops.open){stream.stream_ops.open(stream);}},llseek(){throw new FS.ErrnoError(70);}},major:dev=>dev>>8,minor:dev=>dev&255,makedev:(ma,mi)=>ma<<8|mi,registerDevice(dev,ops){FS.devices[dev]={stream_ops:ops};},getDevice:dev=>FS.devices[dev],getMounts(mount){var mounts=[];var check=[mount];while(check.length){var m=check.pop();mounts.push(m);check.push.apply(check,m.mounts);}return mounts;},syncfs(populate,callback){if(typeof populate=="function"){callback=populate;populate=false;}FS.syncFSRequests++;if(FS.syncFSRequests>1){err(`warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);}var mounts=FS.getMounts(FS.root.mount);var completed=0;function doCallback(errCode){FS.syncFSRequests--;return callback(errCode);}function done(errCode){if(errCode){if(!done.errored){done.errored=true;return doCallback(errCode);}return;}if(++completed>=mounts.length){doCallback(null);}}mounts.forEach(mount=>{if(!mount.type.syncfs){return done(null);}mount.type.syncfs(mount,populate,done);});},mount(type,opts,mountpoint){var root=mountpoint==="/";var pseudo=!mountpoint;var node;if(root&&FS.root){throw new FS.ErrnoError(10);}else if(!root&&!pseudo){var lookup=FS.lookupPath(mountpoint,{follow_mount:false});mountpoint=lookup.path;node=lookup.node;if(FS.isMountpoint(node)){throw new FS.ErrnoError(10);}if(!FS.isDir(node.mode)){throw new FS.ErrnoError(54);}}var mount={type:type,opts:opts,mountpoint:mountpoint,mounts:[]};var mountRoot=type.mount(mount);mountRoot.mount=mount;mount.root=mountRoot;if(root){FS.root=mountRoot;}else if(node){node.mounted=mount;if(node.mount){node.mount.mounts.push(mount);}}return mountRoot;},unmount(mountpoint){var lookup=FS.lookupPath(mountpoint,{follow_mount:false});if(!FS.isMountpoint(lookup.node)){throw new FS.ErrnoError(28);}var node=lookup.node;var mount=node.mounted;var mounts=FS.getMounts(mount);Object.keys(FS.nameTable).forEach(hash=>{var current=FS.nameTable[hash];while(current){var next=current.name_next;if(mounts.includes(current.mount)){FS.destroyNode(current);}current=next;}});node.mounted=null;var idx=node.mount.mounts.indexOf(mount);node.mount.mounts.splice(idx,1);},lookup(parent,name){return parent.node_ops.lookup(parent,name);},mknod(path,mode,dev){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;var name=PATH.basename(path);if(!name||name==="."||name===".."){throw new FS.ErrnoError(28);}var errCode=FS.mayCreate(parent,name);if(errCode){throw new FS.ErrnoError(errCode);}if(!parent.node_ops.mknod){throw new FS.ErrnoError(63);}return parent.node_ops.mknod(parent,name,mode,dev);},create(path,mode){mode=mode!==undefined?mode:438;mode&=4095;mode|=32768;return FS.mknod(path,mode,0);},mkdir(path,mode){mode=mode!==undefined?mode:511;mode&=511|512;mode|=16384;return FS.mknod(path,mode,0);},mkdirTree(path,mode){var dirs=path.split("/");var d="";for(var i=0;i<dirs.length;++i){if(!dirs[i])continue;d+="/"+dirs[i];try{FS.mkdir(d,mode);}catch(e){if(e.errno!=20)throw e;}}},mkdev(path,mode,dev){if(typeof dev=="undefined"){dev=mode;mode=438;}mode|=8192;return FS.mknod(path,mode,dev);},symlink(oldpath,newpath){if(!PATH_FS.resolve(oldpath)){throw new FS.ErrnoError(44);}var lookup=FS.lookupPath(newpath,{parent:true});var parent=lookup.node;if(!parent){throw new FS.ErrnoError(44);}var newname=PATH.basename(newpath);var errCode=FS.mayCreate(parent,newname);if(errCode){throw new FS.ErrnoError(errCode);}if(!parent.node_ops.symlink){throw new FS.ErrnoError(63);}return parent.node_ops.symlink(parent,newname,oldpath);},rename(old_path,new_path){var old_dirname=PATH.dirname(old_path);var new_dirname=PATH.dirname(new_path);var old_name=PATH.basename(old_path);var new_name=PATH.basename(new_path);var lookup,old_dir,new_dir;lookup=FS.lookupPath(old_path,{parent:true});old_dir=lookup.node;lookup=FS.lookupPath(new_path,{parent:true});new_dir=lookup.node;if(!old_dir||!new_dir)throw new FS.ErrnoError(44);if(old_dir.mount!==new_dir.mount){throw new FS.ErrnoError(75);}var old_node=FS.lookupNode(old_dir,old_name);var relative=PATH_FS.relative(old_path,new_dirname);if(relative.charAt(0)!=="."){throw new FS.ErrnoError(28);}relative=PATH_FS.relative(new_path,old_dirname);if(relative.charAt(0)!=="."){throw new FS.ErrnoError(55);}var new_node;try{new_node=FS.lookupNode(new_dir,new_name);}catch(e){}if(old_node===new_node){return;}var isdir=FS.isDir(old_node.mode);var errCode=FS.mayDelete(old_dir,old_name,isdir);if(errCode){throw new FS.ErrnoError(errCode);}errCode=new_node?FS.mayDelete(new_dir,new_name,isdir):FS.mayCreate(new_dir,new_name);if(errCode){throw new FS.ErrnoError(errCode);}if(!old_dir.node_ops.rename){throw new FS.ErrnoError(63);}if(FS.isMountpoint(old_node)||new_node&&FS.isMountpoint(new_node)){throw new FS.ErrnoError(10);}if(new_dir!==old_dir){errCode=FS.nodePermissions(old_dir,"w");if(errCode){throw new FS.ErrnoError(errCode);}}FS.hashRemoveNode(old_node);try{old_dir.node_ops.rename(old_node,new_dir,new_name);}catch(e){throw e;}finally{FS.hashAddNode(old_node);}},rmdir(path){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;var name=PATH.basename(path);var node=FS.lookupNode(parent,name);var errCode=FS.mayDelete(parent,name,true);if(errCode){throw new FS.ErrnoError(errCode);}if(!parent.node_ops.rmdir){throw new FS.ErrnoError(63);}if(FS.isMountpoint(node)){throw new FS.ErrnoError(10);}parent.node_ops.rmdir(parent,name);FS.destroyNode(node);},readdir(path){var lookup=FS.lookupPath(path,{follow:true});var node=lookup.node;if(!node.node_ops.readdir){throw new FS.ErrnoError(54);}return node.node_ops.readdir(node);},unlink(path){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;if(!parent){throw new FS.ErrnoError(44);}var name=PATH.basename(path);var node=FS.lookupNode(parent,name);var errCode=FS.mayDelete(parent,name,false);if(errCode){throw new FS.ErrnoError(errCode);}if(!parent.node_ops.unlink){throw new FS.ErrnoError(63);}if(FS.isMountpoint(node)){throw new FS.ErrnoError(10);}parent.node_ops.unlink(parent,name);FS.destroyNode(node);},readlink(path){var lookup=FS.lookupPath(path);var link=lookup.node;if(!link){throw new FS.ErrnoError(44);}if(!link.node_ops.readlink){throw new FS.ErrnoError(28);}return PATH_FS.resolve(FS.getPath(link.parent),link.node_ops.readlink(link));},stat(path,dontFollow){var lookup=FS.lookupPath(path,{follow:!dontFollow});var node=lookup.node;if(!node){throw new FS.ErrnoError(44);}if(!node.node_ops.getattr){throw new FS.ErrnoError(63);}return node.node_ops.getattr(node);},lstat(path){return FS.stat(path,true);},chmod(path,mode,dontFollow){var node;if(typeof path=="string"){var lookup=FS.lookupPath(path,{follow:!dontFollow});node=lookup.node;}else{node=path;}if(!node.node_ops.setattr){throw new FS.ErrnoError(63);}node.node_ops.setattr(node,{mode:mode&4095|node.mode&~4095,timestamp:Date.now()});},lchmod(path,mode){FS.chmod(path,mode,true);},fchmod(fd,mode){var stream=FS.getStreamChecked(fd);FS.chmod(stream.node,mode);},chown(path,uid,gid,dontFollow){var node;if(typeof path=="string"){var lookup=FS.lookupPath(path,{follow:!dontFollow});node=lookup.node;}else{node=path;}if(!node.node_ops.setattr){throw new FS.ErrnoError(63);}node.node_ops.setattr(node,{timestamp:Date.now()});},lchown(path,uid,gid){FS.chown(path,uid,gid,true);},fchown(fd,uid,gid){var stream=FS.getStreamChecked(fd);FS.chown(stream.node,uid,gid);},truncate(path,len){if(len<0){throw new FS.ErrnoError(28);}var node;if(typeof path=="string"){var lookup=FS.lookupPath(path,{follow:true});node=lookup.node;}else{node=path;}if(!node.node_ops.setattr){throw new FS.ErrnoError(63);}if(FS.isDir(node.mode)){throw new FS.ErrnoError(31);}if(!FS.isFile(node.mode)){throw new FS.ErrnoError(28);}var errCode=FS.nodePermissions(node,"w");if(errCode){throw new FS.ErrnoError(errCode);}node.node_ops.setattr(node,{size:len,timestamp:Date.now()});},ftruncate(fd,len){var stream=FS.getStreamChecked(fd);if((stream.flags&2097155)===0){throw new FS.ErrnoError(28);}FS.truncate(stream.node,len);},utime(path,atime,mtime){var lookup=FS.lookupPath(path,{follow:true});var node=lookup.node;node.node_ops.setattr(node,{timestamp:Math.max(atime,mtime)});},open(path,flags,mode){if(path===""){throw new FS.ErrnoError(44);}flags=typeof flags=="string"?FS_modeStringToFlags(flags):flags;mode=typeof mode=="undefined"?438:mode;if(flags&64){mode=mode&4095|32768;}else{mode=0;}var node;if(typeof path=="object"){node=path;}else{path=PATH.normalize(path);try{var lookup=FS.lookupPath(path,{follow:!(flags&131072)});node=lookup.node;}catch(e){}}var created=false;if(flags&64){if(node){if(flags&128){throw new FS.ErrnoError(20);}}else{node=FS.mknod(path,mode,0);created=true;}}if(!node){throw new FS.ErrnoError(44);}if(FS.isChrdev(node.mode)){flags&=~512;}if(flags&65536&&!FS.isDir(node.mode)){throw new FS.ErrnoError(54);}if(!created){var errCode=FS.mayOpen(node,flags);if(errCode){throw new FS.ErrnoError(errCode);}}if(flags&512&&!created){FS.truncate(node,0);}flags&=~(128|512|131072);var stream=FS.createStream({node:node,path:FS.getPath(node),flags:flags,seekable:true,position:0,stream_ops:node.stream_ops,ungotten:[],error:false});if(stream.stream_ops.open){stream.stream_ops.open(stream);}if(Module["logReadFiles"]&&!(flags&1)){if(!FS.readFiles)FS.readFiles={};if(!(path in FS.readFiles)){FS.readFiles[path]=1;}}return stream;},close(stream){if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if(stream.getdents)stream.getdents=null;try{if(stream.stream_ops.close){stream.stream_ops.close(stream);}}catch(e){throw e;}finally{FS.closeStream(stream.fd);}stream.fd=null;},isClosed(stream){return stream.fd===null;},llseek(stream,offset,whence){if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if(!stream.seekable||!stream.stream_ops.llseek){throw new FS.ErrnoError(70);}if(whence!=0&&whence!=1&&whence!=2){throw new FS.ErrnoError(28);}stream.position=stream.stream_ops.llseek(stream,offset,whence);stream.ungotten=[];return stream.position;},read(stream,buffer,offset,length,position){if(length<0||position<0){throw new FS.ErrnoError(28);}if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if((stream.flags&2097155)===1){throw new FS.ErrnoError(8);}if(FS.isDir(stream.node.mode)){throw new FS.ErrnoError(31);}if(!stream.stream_ops.read){throw new FS.ErrnoError(28);}var seeking=typeof position!="undefined";if(!seeking){position=stream.position;}else if(!stream.seekable){throw new FS.ErrnoError(70);}var bytesRead=stream.stream_ops.read(stream,buffer,offset,length,position);if(!seeking)stream.position+=bytesRead;return bytesRead;},write(stream,buffer,offset,length,position,canOwn){if(length<0||position<0){throw new FS.ErrnoError(28);}if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if((stream.flags&2097155)===0){throw new FS.ErrnoError(8);}if(FS.isDir(stream.node.mode)){throw new FS.ErrnoError(31);}if(!stream.stream_ops.write){throw new FS.ErrnoError(28);}if(stream.seekable&&stream.flags&1024){FS.llseek(stream,0,2);}var seeking=typeof position!="undefined";if(!seeking){position=stream.position;}else if(!stream.seekable){throw new FS.ErrnoError(70);}var bytesWritten=stream.stream_ops.write(stream,buffer,offset,length,position,canOwn);if(!seeking)stream.position+=bytesWritten;return bytesWritten;},allocate(stream,offset,length){if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if(offset<0||length<=0){throw new FS.ErrnoError(28);}if((stream.flags&2097155)===0){throw new FS.ErrnoError(8);}if(!FS.isFile(stream.node.mode)&&!FS.isDir(stream.node.mode)){throw new FS.ErrnoError(43);}if(!stream.stream_ops.allocate){throw new FS.ErrnoError(138);}stream.stream_ops.allocate(stream,offset,length);},mmap(stream,length,position,prot,flags){if((prot&2)!==0&&(flags&2)===0&&(stream.flags&2097155)!==2){throw new FS.ErrnoError(2);}if((stream.flags&2097155)===1){throw new FS.ErrnoError(2);}if(!stream.stream_ops.mmap){throw new FS.ErrnoError(43);}return stream.stream_ops.mmap(stream,length,position,prot,flags);},msync(stream,buffer,offset,length,mmapFlags){if(!stream.stream_ops.msync){return 0;}return stream.stream_ops.msync(stream,buffer,offset,length,mmapFlags);},munmap:stream=>0,ioctl(stream,cmd,arg){if(!stream.stream_ops.ioctl){throw new FS.ErrnoError(59);}return stream.stream_ops.ioctl(stream,cmd,arg);},readFile(path,opts){if(opts===void 0){opts={};}opts.flags=opts.flags||0;opts.encoding=opts.encoding||"binary";if(opts.encoding!=="utf8"&&opts.encoding!=="binary"){throw new Error(`Invalid encoding type "${opts.encoding}"`);}var ret;var stream=FS.open(path,opts.flags);var stat=FS.stat(path);var length=stat.size;var buf=new Uint8Array(length);FS.read(stream,buf,0,length,0);if(opts.encoding==="utf8"){ret=UTF8ArrayToString(buf,0);}else if(opts.encoding==="binary"){ret=buf;}FS.close(stream);return ret;},writeFile(path,data,opts){if(opts===void 0){opts={};}opts.flags=opts.flags||577;var stream=FS.open(path,opts.flags,opts.mode);if(typeof data=="string"){var buf=new Uint8Array(lengthBytesUTF8(data)+1);var actualNumBytes=stringToUTF8Array(data,buf,0,buf.length);FS.write(stream,buf,0,actualNumBytes,undefined,opts.canOwn);}else if(ArrayBuffer.isView(data)){FS.write(stream,data,0,data.byteLength,undefined,opts.canOwn);}else{throw new Error("Unsupported data type");}FS.close(stream);},cwd:()=>FS.currentPath,chdir(path){var lookup=FS.lookupPath(path,{follow:true});if(lookup.node===null){throw new FS.ErrnoError(44);}if(!FS.isDir(lookup.node.mode)){throw new FS.ErrnoError(54);}var errCode=FS.nodePermissions(lookup.node,"x");if(errCode){throw new FS.ErrnoError(errCode);}FS.currentPath=lookup.path;},createDefaultDirectories(){FS.mkdir("/tmp");FS.mkdir("/home");FS.mkdir("/home/web_user");},createDefaultDevices(){FS.mkdir("/dev");FS.registerDevice(FS.makedev(1,3),{read:()=>0,write:(stream,buffer,offset,length,pos)=>length});FS.mkdev("/dev/null",FS.makedev(1,3));TTY.register(FS.makedev(5,0),TTY.default_tty_ops);TTY.register(FS.makedev(6,0),TTY.default_tty1_ops);FS.mkdev("/dev/tty",FS.makedev(5,0));FS.mkdev("/dev/tty1",FS.makedev(6,0));var randomBuffer=new Uint8Array(1024),randomLeft=0;var randomByte=()=>{if(randomLeft===0){randomLeft=randomFill(randomBuffer).byteLength;}return randomBuffer[--randomLeft];};FS.createDevice("/dev","random",randomByte);FS.createDevice("/dev","urandom",randomByte);FS.mkdir("/dev/shm");FS.mkdir("/dev/shm/tmp");},createSpecialDirectories(){FS.mkdir("/proc");var proc_self=FS.mkdir("/proc/self");FS.mkdir("/proc/self/fd");FS.mount({mount(){var node=FS.createNode(proc_self,"fd",16384|511,73);node.node_ops={lookup(parent,name){var fd=+name;var stream=FS.getStreamChecked(fd);var ret={parent:null,mount:{mountpoint:"fake"},node_ops:{readlink:()=>stream.path}};ret.parent=ret;return ret;}};return node;}},{},"/proc/self/fd");},createStandardStreams(){if(Module["stdin"]){FS.createDevice("/dev","stdin",Module["stdin"]);}else{FS.symlink("/dev/tty","/dev/stdin");}if(Module["stdout"]){FS.createDevice("/dev","stdout",null,Module["stdout"]);}else{FS.symlink("/dev/tty","/dev/stdout");}if(Module["stderr"]){FS.createDevice("/dev","stderr",null,Module["stderr"]);}else{FS.symlink("/dev/tty1","/dev/stderr");}var stdin=FS.open("/dev/stdin",0);var stdout=FS.open("/dev/stdout",1);var stderr=FS.open("/dev/stderr",1);},ensureErrnoError(){if(FS.ErrnoError)return;FS.ErrnoError=function ErrnoError(errno,node){this.name="ErrnoError";this.node=node;this.setErrno=function(errno){this.errno=errno;};this.setErrno(errno);this.message="FS error";};FS.ErrnoError.prototype=new Error();FS.ErrnoError.prototype.constructor=FS.ErrnoError;[44].forEach(code=>{FS.genericErrors[code]=new FS.ErrnoError(code);FS.genericErrors[code].stack="<generic error, no stack>";});},staticInit(){FS.ensureErrnoError();FS.nameTable=new Array(4096);FS.mount(MEMFS,{},"/");FS.createDefaultDirectories();FS.createDefaultDevices();FS.createSpecialDirectories();FS.filesystems={"MEMFS":MEMFS};},init(input,output,error){FS.init.initialized=true;FS.ensureErrnoError();Module["stdin"]=input||Module["stdin"];Module["stdout"]=output||Module["stdout"];Module["stderr"]=error||Module["stderr"];FS.createStandardStreams();},quit(){FS.init.initialized=false;_fflush(0);for(var i=0;i<FS.streams.length;i++){var stream=FS.streams[i];if(!stream){continue;}FS.close(stream);}},findObject(path,dontResolveLastLink){var ret=FS.analyzePath(path,dontResolveLastLink);if(!ret.exists){return null;}return ret.object;},analyzePath(path,dontResolveLastLink){try{var lookup=FS.lookupPath(path,{follow:!dontResolveLastLink});path=lookup.path;}catch(e){}var ret={isRoot:false,exists:false,error:0,name:null,path:null,object:null,parentExists:false,parentPath:null,parentObject:null};try{var lookup=FS.lookupPath(path,{parent:true});ret.parentExists=true;ret.parentPath=lookup.path;ret.parentObject=lookup.node;ret.name=PATH.basename(path);lookup=FS.lookupPath(path,{follow:!dontResolveLastLink});ret.exists=true;ret.path=lookup.path;ret.object=lookup.node;ret.name=lookup.node.name;ret.isRoot=lookup.path==="/";}catch(e){ret.error=e.errno;}return ret;},createPath(parent,path,canRead,canWrite){parent=typeof parent=="string"?parent:FS.getPath(parent);var parts=path.split("/").reverse();while(parts.length){var part=parts.pop();if(!part)continue;var current=PATH.join2(parent,part);try{FS.mkdir(current);}catch(e){}parent=current;}return current;},createFile(parent,name,properties,canRead,canWrite){var path=PATH.join2(typeof parent=="string"?parent:FS.getPath(parent),name);var mode=FS_getMode(canRead,canWrite);return FS.create(path,mode);},createDataFile(parent,name,data,canRead,canWrite,canOwn){var path=name;if(parent){parent=typeof parent=="string"?parent:FS.getPath(parent);path=name?PATH.join2(parent,name):parent;}var mode=FS_getMode(canRead,canWrite);var node=FS.create(path,mode);if(data){if(typeof data=="string"){var arr=new Array(data.length);for(var i=0,len=data.length;i<len;++i)arr[i]=data.charCodeAt(i);data=arr;}FS.chmod(node,mode|146);var stream=FS.open(node,577);FS.write(stream,data,0,data.length,0,canOwn);FS.close(stream);FS.chmod(node,mode);}},createDevice(parent,name,input,output){var path=PATH.join2(typeof parent=="string"?parent:FS.getPath(parent),name);var mode=FS_getMode(!!input,!!output);if(!FS.createDevice.major)FS.createDevice.major=64;var dev=FS.makedev(FS.createDevice.major++,0);FS.registerDevice(dev,{open(stream){stream.seekable=false;},close(stream){if(output&&output.buffer&&output.buffer.length){output(10);}},read(stream,buffer,offset,length,pos){var bytesRead=0;for(var i=0;i<length;i++){var result;try{result=input();}catch(e){throw new FS.ErrnoError(29);}if(result===undefined&&bytesRead===0){throw new FS.ErrnoError(6);}if(result===null||result===undefined)break;bytesRead++;buffer[offset+i]=result;}if(bytesRead){stream.node.timestamp=Date.now();}return bytesRead;},write(stream,buffer,offset,length,pos){for(var i=0;i<length;i++){try{output(buffer[offset+i]);}catch(e){throw new FS.ErrnoError(29);}}if(length){stream.node.timestamp=Date.now();}return i;}});return FS.mkdev(path,mode,dev);},forceLoadFile(obj){if(obj.isDevice||obj.isFolder||obj.link||obj.contents)return true;if(typeof XMLHttpRequest!="undefined"){throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");}else if(read_){try{obj.contents=intArrayFromString(read_(obj.url),true);obj.usedBytes=obj.contents.length;}catch(e){throw new FS.ErrnoError(29);}}else{throw new Error("Cannot load without read() or XMLHttpRequest.");}},createLazyFile(parent,name,url,canRead,canWrite){function LazyUint8Array(){this.lengthKnown=false;this.chunks=[];}LazyUint8Array.prototype.get=function LazyUint8Array_get(idx){if(idx>this.length-1||idx<0){return undefined;}var chunkOffset=idx%this.chunkSize;var chunkNum=idx/this.chunkSize|0;return this.getter(chunkNum)[chunkOffset];};LazyUint8Array.prototype.setDataGetter=function LazyUint8Array_setDataGetter(getter){this.getter=getter;};LazyUint8Array.prototype.cacheLength=function LazyUint8Array_cacheLength(){var xhr=new XMLHttpRequest();xhr.open("HEAD",url,false);xhr.send(null);if(!(xhr.status>=200&&xhr.status<300||xhr.status===304))throw new Error("Couldn't load "+url+". Status: "+xhr.status);var datalength=Number(xhr.getResponseHeader("Content-length"));var header;var hasByteServing=(header=xhr.getResponseHeader("Accept-Ranges"))&&header==="bytes";var usesGzip=(header=xhr.getResponseHeader("Content-Encoding"))&&header==="gzip";var chunkSize=1024*1024;if(!hasByteServing)chunkSize=datalength;var doXHR=(from,to)=>{if(from>to)throw new Error("invalid range ("+from+", "+to+") or no bytes requested!");if(to>datalength-1)throw new Error("only "+datalength+" bytes available! programmer error!");var xhr=new XMLHttpRequest();xhr.open("GET",url,false);if(datalength!==chunkSize)xhr.setRequestHeader("Range","bytes="+from+"-"+to);xhr.responseType="arraybuffer";if(xhr.overrideMimeType){xhr.overrideMimeType("text/plain; charset=x-user-defined");}xhr.send(null);if(!(xhr.status>=200&&xhr.status<300||xhr.status===304))throw new Error("Couldn't load "+url+". Status: "+xhr.status);if(xhr.response!==undefined){return new Uint8Array(xhr.response||[]);}return intArrayFromString(xhr.responseText||"",true);};var lazyArray=this;lazyArray.setDataGetter(chunkNum=>{var start=chunkNum*chunkSize;var end=(chunkNum+1)*chunkSize-1;end=Math.min(end,datalength-1);if(typeof lazyArray.chunks[chunkNum]=="undefined"){lazyArray.chunks[chunkNum]=doXHR(start,end);}if(typeof lazyArray.chunks[chunkNum]=="undefined")throw new Error("doXHR failed!");return lazyArray.chunks[chunkNum];});if(usesGzip||!datalength){chunkSize=datalength=1;datalength=this.getter(0).length;chunkSize=datalength;out("LazyFiles on gzip forces download of the whole file when length is accessed");}this._length=datalength;this._chunkSize=chunkSize;this.lengthKnown=true;};if(typeof XMLHttpRequest!="undefined"){if(!ENVIRONMENT_IS_WORKER)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var lazyArray=new LazyUint8Array();Object.defineProperties(lazyArray,{length:{get:function get(){if(!this.lengthKnown){this.cacheLength();}return this._length;}},chunkSize:{get:function get(){if(!this.lengthKnown){this.cacheLength();}return this._chunkSize;}}});var properties={isDevice:false,contents:lazyArray};}else{var properties={isDevice:false,url:url};}var node=FS.createFile(parent,name,properties,canRead,canWrite);if(properties.contents){node.contents=properties.contents;}else if(properties.url){node.contents=null;node.url=properties.url;}Object.defineProperties(node,{usedBytes:{get:function get(){return this.contents.length;}}});var stream_ops={};var keys=Object.keys(node.stream_ops);keys.forEach(key=>{var fn=node.stream_ops[key];stream_ops[key]=function forceLoadLazyFile(){FS.forceLoadFile(node);return fn.apply(null,arguments);};});function writeChunks(stream,buffer,offset,length,position){var contents=stream.node.contents;if(position>=contents.length)return 0;var size=Math.min(contents.length-position,length);if(contents.slice){for(var i=0;i<size;i++){buffer[offset+i]=contents[position+i];}}else{for(var i=0;i<size;i++){buffer[offset+i]=contents.get(position+i);}}return size;}stream_ops.read=(stream,buffer,offset,length,position)=>{FS.forceLoadFile(node);return writeChunks(stream,buffer,offset,length,position);};stream_ops.mmap=(stream,length,position,prot,flags)=>{FS.forceLoadFile(node);var ptr=mmapAlloc(length);if(!ptr){throw new FS.ErrnoError(48);}writeChunks(stream,HEAP8,ptr,length,position);return{ptr:ptr,allocated:true};};node.stream_ops=stream_ops;return node;}};var SYSCALLS={DEFAULT_POLLMASK:5,calculateAt(dirfd,path,allowEmpty){if(PATH.isAbs(path)){return path;}var dir;if(dirfd===-100){dir=FS.cwd();}else{var dirstream=SYSCALLS.getStreamFromFD(dirfd);dir=dirstream.path;}if(path.length==0){if(!allowEmpty){throw new FS.ErrnoError(44);}return dir;}return PATH.join2(dir,path);},doStat(func,path,buf){try{var stat=func(path);}catch(e){if(e&&e.node&&PATH.normalize(path)!==PATH.normalize(FS.getPath(e.node))){return-54;}throw e;}HEAP32[buf>>2]=stat.dev;HEAP32[buf+4>>2]=stat.mode;HEAPU32[buf+8>>2]=stat.nlink;HEAP32[buf+12>>2]=stat.uid;HEAP32[buf+16>>2]=stat.gid;HEAP32[buf+20>>2]=stat.rdev;tempI64=[stat.size>>>0,(tempDouble=stat.size,+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+24>>2]=tempI64[0],HEAP32[buf+28>>2]=tempI64[1];HEAP32[buf+32>>2]=4096;HEAP32[buf+36>>2]=stat.blocks;var atime=stat.atime.getTime();var mtime=stat.mtime.getTime();var ctime=stat.ctime.getTime();tempI64=[Math.floor(atime/1e3)>>>0,(tempDouble=Math.floor(atime/1e3),+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+40>>2]=tempI64[0],HEAP32[buf+44>>2]=tempI64[1];HEAPU32[buf+48>>2]=atime%1e3*1e3;tempI64=[Math.floor(mtime/1e3)>>>0,(tempDouble=Math.floor(mtime/1e3),+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+56>>2]=tempI64[0],HEAP32[buf+60>>2]=tempI64[1];HEAPU32[buf+64>>2]=mtime%1e3*1e3;tempI64=[Math.floor(ctime/1e3)>>>0,(tempDouble=Math.floor(ctime/1e3),+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+72>>2]=tempI64[0],HEAP32[buf+76>>2]=tempI64[1];HEAPU32[buf+80>>2]=ctime%1e3*1e3;tempI64=[stat.ino>>>0,(tempDouble=stat.ino,+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+88>>2]=tempI64[0],HEAP32[buf+92>>2]=tempI64[1];return 0;},doMsync(addr,stream,len,flags,offset){if(!FS.isFile(stream.node.mode)){throw new FS.ErrnoError(43);}if(flags&2){return 0;}var buffer=HEAPU8.slice(addr,addr+len);FS.msync(stream,buffer,offset,len,flags);},varargs:undefined,get(){var ret=HEAP32[+SYSCALLS.varargs>>2];SYSCALLS.varargs+=4;return ret;},getp(){return SYSCALLS.get();},getStr(ptr){var ret=UTF8ToString(ptr);return ret;},getStreamFromFD(fd){var stream=FS.getStreamChecked(fd);return stream;}};function ___syscall_fstat64(fd,buf){try{var stream=SYSCALLS.getStreamFromFD(fd);return SYSCALLS.doStat(FS.stat,stream.path,buf);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}var convertI32PairToI53Checked=(lo,hi)=>hi+2097152>>>0<4194305-!!lo?(lo>>>0)+hi*4294967296:NaN;function ___syscall_ftruncate64(fd,length_low,length_high){var length=convertI32PairToI53Checked(length_low,length_high);try{if(isNaN(length))return 61;FS.ftruncate(fd,length);return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_newfstatat(dirfd,path,buf,flags){try{path=SYSCALLS.getStr(path);var nofollow=flags&256;var allowEmpty=flags&4096;flags=flags&~6400;path=SYSCALLS.calculateAt(dirfd,path,allowEmpty);return SYSCALLS.doStat(nofollow?FS.lstat:FS.stat,path,buf);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_openat(dirfd,path,flags,varargs){SYSCALLS.varargs=varargs;try{path=SYSCALLS.getStr(path);path=SYSCALLS.calculateAt(dirfd,path);var mode=varargs?SYSCALLS.get():0;return FS.open(path,flags,mode).fd;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}var stringToUTF8=(str,outPtr,maxBytesToWrite)=>stringToUTF8Array(str,HEAPU8,outPtr,maxBytesToWrite);function ___syscall_readlinkat(dirfd,path,buf,bufsize){try{path=SYSCALLS.getStr(path);path=SYSCALLS.calculateAt(dirfd,path);if(bufsize<=0)return-28;var ret=FS.readlink(path);var len=Math.min(bufsize,lengthBytesUTF8(ret));var endChar=HEAP8[buf+len];stringToUTF8(ret,buf,bufsize+1);HEAP8[buf+len]=endChar;return len;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_renameat(olddirfd,oldpath,newdirfd,newpath){try{oldpath=SYSCALLS.getStr(oldpath);newpath=SYSCALLS.getStr(newpath);oldpath=SYSCALLS.calculateAt(olddirfd,oldpath);newpath=SYSCALLS.calculateAt(newdirfd,newpath);FS.rename(oldpath,newpath);return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_stat64(path,buf){try{path=SYSCALLS.getStr(path);return SYSCALLS.doStat(FS.stat,path,buf);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_unlinkat(dirfd,path,flags){try{path=SYSCALLS.getStr(path);path=SYSCALLS.calculateAt(dirfd,path);if(flags===0){FS.unlink(path);}else if(flags===512){FS.rmdir(path);}else{abort("Invalid flags passed to unlinkat");}return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}var __embind_register_bigint=(primitiveType,name,size,minRange,maxRange)=>{};var embind_init_charCodes=()=>{var codes=new Array(256);for(var i=0;i<256;++i){codes[i]=String.fromCharCode(i);}embind_charCodes=codes;};var embind_charCodes;var readLatin1String=ptr=>{var ret="";var c=ptr;while(HEAPU8[c]){ret+=embind_charCodes[HEAPU8[c++]];}return ret;};var awaitingDependencies={};var registeredTypes={};var typeDependencies={};var BindingError;var throwBindingError=message=>{throw new BindingError(message);};var InternalError;var throwInternalError=message=>{throw new InternalError(message);};var whenDependentTypesAreResolved=(myTypes,dependentTypes,getTypeConverters)=>{myTypes.forEach(function(type){typeDependencies[type]=dependentTypes;});function onComplete(typeConverters){var myTypeConverters=getTypeConverters(typeConverters);if(myTypeConverters.length!==myTypes.length){throwInternalError("Mismatched type converter count");}for(var i=0;i<myTypes.length;++i){registerType(myTypes[i],myTypeConverters[i]);}}var typeConverters=new Array(dependentTypes.length);var unregisteredTypes=[];var registered=0;dependentTypes.forEach((dt,i)=>{if(registeredTypes.hasOwnProperty(dt)){typeConverters[i]=registeredTypes[dt];}else{unregisteredTypes.push(dt);if(!awaitingDependencies.hasOwnProperty(dt)){awaitingDependencies[dt]=[];}awaitingDependencies[dt].push(()=>{typeConverters[i]=registeredTypes[dt];++registered;if(registered===unregisteredTypes.length){onComplete(typeConverters);}});}});if(0===unregisteredTypes.length){onComplete(typeConverters);}};function sharedRegisterType(rawType,registeredInstance,options){if(options===void 0){options={};}var name=registeredInstance.name;if(!rawType){throwBindingError(`type "${name}" must have a positive integer typeid pointer`);}if(registeredTypes.hasOwnProperty(rawType)){if(options.ignoreDuplicateRegistrations){return;}else{throwBindingError(`Cannot register type '${name}' twice`);}}registeredTypes[rawType]=registeredInstance;delete typeDependencies[rawType];if(awaitingDependencies.hasOwnProperty(rawType)){var callbacks=awaitingDependencies[rawType];delete awaitingDependencies[rawType];callbacks.forEach(cb=>cb());}}function registerType(rawType,registeredInstance,options){if(options===void 0){options={};}if(!("argPackAdvance"in registeredInstance)){throw new TypeError("registerType registeredInstance requires argPackAdvance");}return sharedRegisterType(rawType,registeredInstance,options);}var GenericWireTypeSize=8;var __embind_register_bool=(rawType,name,trueValue,falseValue)=>{name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":function fromWireType(wt){return!!wt;},"toWireType":function toWireType(destructors,o){return o?trueValue:falseValue;},"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":function readValueFromPointer(pointer){return this["fromWireType"](HEAPU8[pointer]);},destructorFunction:null});};var shallowCopyInternalPointer=o=>({count:o.count,deleteScheduled:o.deleteScheduled,preservePointerOnDelete:o.preservePointerOnDelete,ptr:o.ptr,ptrType:o.ptrType,smartPtr:o.smartPtr,smartPtrType:o.smartPtrType});var throwInstanceAlreadyDeleted=obj=>{function getInstanceTypeName(handle){return handle.$$.ptrType.registeredClass.name;}throwBindingError(getInstanceTypeName(obj)+" instance already deleted");};var finalizationRegistry=false;var detachFinalizer=handle=>{};var runDestructor=$$=>{if($$.smartPtr){$$.smartPtrType.rawDestructor($$.smartPtr);}else{$$.ptrType.registeredClass.rawDestructor($$.ptr);}};var releaseClassHandle=$$=>{$$.count.value-=1;var toDelete=0===$$.count.value;if(toDelete){runDestructor($$);}};var downcastPointer=(ptr,ptrClass,desiredClass)=>{if(ptrClass===desiredClass){return ptr;}if(undefined===desiredClass.baseClass){return null;}var rv=downcastPointer(ptr,ptrClass,desiredClass.baseClass);if(rv===null){return null;}return desiredClass.downcast(rv);};var registeredPointers={};var getInheritedInstanceCount=()=>Object.keys(registeredInstances).length;var getLiveInheritedInstances=()=>{var rv=[];for(var k in registeredInstances){if(registeredInstances.hasOwnProperty(k)){rv.push(registeredInstances[k]);}}return rv;};var deletionQueue=[];var flushPendingDeletes=()=>{while(deletionQueue.length){var obj=deletionQueue.pop();obj.$$.deleteScheduled=false;obj["delete"]();}};var delayFunction;var setDelayFunction=fn=>{delayFunction=fn;if(deletionQueue.length&&delayFunction){delayFunction(flushPendingDeletes);}};var init_embind=()=>{Module["getInheritedInstanceCount"]=getInheritedInstanceCount;Module["getLiveInheritedInstances"]=getLiveInheritedInstances;Module["flushPendingDeletes"]=flushPendingDeletes;Module["setDelayFunction"]=setDelayFunction;};var registeredInstances={};var getBasestPointer=(class_,ptr)=>{if(ptr===undefined){throwBindingError("ptr should not be undefined");}while(class_.baseClass){ptr=class_.upcast(ptr);class_=class_.baseClass;}return ptr;};var getInheritedInstance=(class_,ptr)=>{ptr=getBasestPointer(class_,ptr);return registeredInstances[ptr];};var makeClassHandle=(prototype,record)=>{if(!record.ptrType||!record.ptr){throwInternalError("makeClassHandle requires ptr and ptrType");}var hasSmartPtrType=!!record.smartPtrType;var hasSmartPtr=!!record.smartPtr;if(hasSmartPtrType!==hasSmartPtr){throwInternalError("Both smartPtrType and smartPtr must be specified");}record.count={value:1};return attachFinalizer(Object.create(prototype,{$$:{value:record}}));};function RegisteredPointer_fromWireType(ptr){var rawPointer=this.getPointee(ptr);if(!rawPointer){this.destructor(ptr);return null;}var registeredInstance=getInheritedInstance(this.registeredClass,rawPointer);if(undefined!==registeredInstance){if(0===registeredInstance.$$.count.value){registeredInstance.$$.ptr=rawPointer;registeredInstance.$$.smartPtr=ptr;return registeredInstance["clone"]();}else{var rv=registeredInstance["clone"]();this.destructor(ptr);return rv;}}function makeDefaultHandle(){if(this.isSmartPointer){return makeClassHandle(this.registeredClass.instancePrototype,{ptrType:this.pointeeType,ptr:rawPointer,smartPtrType:this,smartPtr:ptr});}else{return makeClassHandle(this.registeredClass.instancePrototype,{ptrType:this,ptr:ptr});}}var actualType=this.registeredClass.getActualType(rawPointer);var registeredPointerRecord=registeredPointers[actualType];if(!registeredPointerRecord){return makeDefaultHandle.call(this);}var toType;if(this.isConst){toType=registeredPointerRecord.constPointerType;}else{toType=registeredPointerRecord.pointerType;}var dp=downcastPointer(rawPointer,this.registeredClass,toType.registeredClass);if(dp===null){return makeDefaultHandle.call(this);}if(this.isSmartPointer){return makeClassHandle(toType.registeredClass.instancePrototype,{ptrType:toType,ptr:dp,smartPtrType:this,smartPtr:ptr});}else{return makeClassHandle(toType.registeredClass.instancePrototype,{ptrType:toType,ptr:dp});}}var attachFinalizer=handle=>{if("undefined"===typeof FinalizationRegistry){attachFinalizer=handle=>handle;return handle;}finalizationRegistry=new FinalizationRegistry(info=>{releaseClassHandle(info.$$);});attachFinalizer=handle=>{var $$=handle.$$;var hasSmartPtr=!!$$.smartPtr;if(hasSmartPtr){var info={$$:$$};finalizationRegistry.register(handle,info,handle);}return handle;};detachFinalizer=handle=>finalizationRegistry.unregister(handle);return attachFinalizer(handle);};var init_ClassHandle=()=>{Object.assign(ClassHandle.prototype,{"isAliasOf"(other){if(!(this instanceof ClassHandle)){return false;}if(!(other instanceof ClassHandle)){return false;}var leftClass=this.$$.ptrType.registeredClass;var left=this.$$.ptr;other.$$=other.$$;var rightClass=other.$$.ptrType.registeredClass;var right=other.$$.ptr;while(leftClass.baseClass){left=leftClass.upcast(left);leftClass=leftClass.baseClass;}while(rightClass.baseClass){right=rightClass.upcast(right);rightClass=rightClass.baseClass;}return leftClass===rightClass&&left===right;},"clone"(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.preservePointerOnDelete){this.$$.count.value+=1;return this;}else{var clone=attachFinalizer(Object.create(Object.getPrototypeOf(this),{$$:{value:shallowCopyInternalPointer(this.$$)}}));clone.$$.count.value+=1;clone.$$.deleteScheduled=false;return clone;}},"delete"(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete){throwBindingError("Object already scheduled for deletion");}detachFinalizer(this);releaseClassHandle(this.$$);if(!this.$$.preservePointerOnDelete){this.$$.smartPtr=undefined;this.$$.ptr=undefined;}},"isDeleted"(){return!this.$$.ptr;},"deleteLater"(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete){throwBindingError("Object already scheduled for deletion");}deletionQueue.push(this);if(deletionQueue.length===1&&delayFunction){delayFunction(flushPendingDeletes);}this.$$.deleteScheduled=true;return this;}});};function ClassHandle(){}var createNamedFunction=(name,body)=>Object.defineProperty(body,"name",{value:name});var ensureOverloadTable=(proto,methodName,humanName)=>{if(undefined===proto[methodName].overloadTable){var prevFunc=proto[methodName];proto[methodName]=function(){if(!proto[methodName].overloadTable.hasOwnProperty(arguments.length)){throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${arguments.length}) - expects one of (${proto[methodName].overloadTable})!`);}return proto[methodName].overloadTable[arguments.length].apply(this,arguments);};proto[methodName].overloadTable=[];proto[methodName].overloadTable[prevFunc.argCount]=prevFunc;}};var exposePublicSymbol=(name,value,numArguments)=>{if(Module.hasOwnProperty(name)){if(undefined===numArguments||undefined!==Module[name].overloadTable&&undefined!==Module[name].overloadTable[numArguments]){throwBindingError(`Cannot register public name '${name}' twice`);}ensureOverloadTable(Module,name,name);if(Module.hasOwnProperty(numArguments)){throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`);}Module[name].overloadTable[numArguments]=value;}else{Module[name]=value;if(undefined!==numArguments){Module[name].numArguments=numArguments;}}};var char_0=48;var char_9=57;var makeLegalFunctionName=name=>{if(undefined===name){return"_unknown";}name=name.replace(/[^a-zA-Z0-9_]/g,"$");var f=name.charCodeAt(0);if(f>=char_0&&f<=char_9){return`_${name}`;}return name;};function RegisteredClass(name,constructor,instancePrototype,rawDestructor,baseClass,getActualType,upcast,downcast){this.name=name;this.constructor=constructor;this.instancePrototype=instancePrototype;this.rawDestructor=rawDestructor;this.baseClass=baseClass;this.getActualType=getActualType;this.upcast=upcast;this.downcast=downcast;this.pureVirtualFunctions=[];}var upcastPointer=(ptr,ptrClass,desiredClass)=>{while(ptrClass!==desiredClass){if(!ptrClass.upcast){throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`);}ptr=ptrClass.upcast(ptr);ptrClass=ptrClass.baseClass;}return ptr;};function constNoSmartPtrRawPointerToWireType(destructors,handle){if(handle===null){if(this.isReference){throwBindingError(`null is not a valid ${this.name}`);}return 0;}if(!handle.$$){throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);}if(!handle.$$.ptr){throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);}var handleClass=handle.$$.ptrType.registeredClass;var ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);return ptr;}function genericPointerToWireType(destructors,handle){var ptr;if(handle===null){if(this.isReference){throwBindingError(`null is not a valid ${this.name}`);}if(this.isSmartPointer){ptr=this.rawConstructor();if(destructors!==null){destructors.push(this.rawDestructor,ptr);}return ptr;}else{return 0;}}if(!handle.$$){throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);}if(!handle.$$.ptr){throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);}if(!this.isConst&&handle.$$.ptrType.isConst){throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType?handle.$$.smartPtrType.name:handle.$$.ptrType.name} to parameter type ${this.name}`);}var handleClass=handle.$$.ptrType.registeredClass;ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);if(this.isSmartPointer){if(undefined===handle.$$.smartPtr){throwBindingError("Passing raw pointer to smart pointer is illegal");}switch(this.sharingPolicy){case 0:if(handle.$$.smartPtrType===this){ptr=handle.$$.smartPtr;}else{throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType?handle.$$.smartPtrType.name:handle.$$.ptrType.name} to parameter type ${this.name}`);}break;case 1:ptr=handle.$$.smartPtr;break;case 2:if(handle.$$.smartPtrType===this){ptr=handle.$$.smartPtr;}else{var clonedHandle=handle["clone"]();ptr=this.rawShare(ptr,Emval.toHandle(()=>clonedHandle["delete"]()));if(destructors!==null){destructors.push(this.rawDestructor,ptr);}}break;default:throwBindingError("Unsupporting sharing policy");}}return ptr;}function nonConstNoSmartPtrRawPointerToWireType(destructors,handle){if(handle===null){if(this.isReference){throwBindingError(`null is not a valid ${this.name}`);}return 0;}if(!handle.$$){throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);}if(!handle.$$.ptr){throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);}if(handle.$$.ptrType.isConst){throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`);}var handleClass=handle.$$.ptrType.registeredClass;var ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);return ptr;}function readPointer(pointer){return this["fromWireType"](HEAPU32[pointer>>2]);}var init_RegisteredPointer=()=>{Object.assign(RegisteredPointer.prototype,{getPointee(ptr){if(this.rawGetPointee){ptr=this.rawGetPointee(ptr);}return ptr;},destructor(ptr){if(this.rawDestructor){this.rawDestructor(ptr);}},"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":readPointer,"deleteObject"(handle){if(handle!==null){handle["delete"]();}},"fromWireType":RegisteredPointer_fromWireType});};function RegisteredPointer(name,registeredClass,isReference,isConst,isSmartPointer,pointeeType,sharingPolicy,rawGetPointee,rawConstructor,rawShare,rawDestructor){this.name=name;this.registeredClass=registeredClass;this.isReference=isReference;this.isConst=isConst;this.isSmartPointer=isSmartPointer;this.pointeeType=pointeeType;this.sharingPolicy=sharingPolicy;this.rawGetPointee=rawGetPointee;this.rawConstructor=rawConstructor;this.rawShare=rawShare;this.rawDestructor=rawDestructor;if(!isSmartPointer&&registeredClass.baseClass===undefined){if(isConst){this["toWireType"]=constNoSmartPtrRawPointerToWireType;this.destructorFunction=null;}else{this["toWireType"]=nonConstNoSmartPtrRawPointerToWireType;this.destructorFunction=null;}}else{this["toWireType"]=genericPointerToWireType;}}var replacePublicSymbol=(name,value,numArguments)=>{if(!Module.hasOwnProperty(name)){throwInternalError("Replacing nonexistant public symbol");}if(undefined!==Module[name].overloadTable&&undefined!==numArguments){Module[name].overloadTable[numArguments]=value;}else{Module[name]=value;Module[name].argCount=numArguments;}};var dynCallLegacy=(sig,ptr,args)=>{var f=Module["dynCall_"+sig];return args&&args.length?f.apply(null,[ptr].concat(args)):f.call(null,ptr);};var wasmTableMirror=[];var wasmTable;var getWasmTableEntry=funcPtr=>{var func=wasmTableMirror[funcPtr];if(!func){if(funcPtr>=wasmTableMirror.length)wasmTableMirror.length=funcPtr+1;wasmTableMirror[funcPtr]=func=wasmTable.get(funcPtr);}return func;};var dynCall=(sig,ptr,args)=>{if(sig.includes("j")){return dynCallLegacy(sig,ptr,args);}var rtn=getWasmTableEntry(ptr).apply(null,args);return rtn;};var getDynCaller=(sig,ptr)=>{var argCache=[];return function(){argCache.length=0;Object.assign(argCache,arguments);return dynCall(sig,ptr,argCache);};};var embind__requireFunction=(signature,rawFunction)=>{signature=readLatin1String(signature);function makeDynCaller(){if(signature.includes("j")){return getDynCaller(signature,rawFunction);}return getWasmTableEntry(rawFunction);}var fp=makeDynCaller();if(typeof fp!="function"){throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`);}return fp;};var extendError=(baseErrorType,errorName)=>{var errorClass=createNamedFunction(errorName,function(message){this.name=errorName;this.message=message;var stack=new Error(message).stack;if(stack!==undefined){this.stack=this.toString()+"\n"+stack.replace(/^Error(:[^\n]*)?\n/,"");}});errorClass.prototype=Object.create(baseErrorType.prototype);errorClass.prototype.constructor=errorClass;errorClass.prototype.toString=function(){if(this.message===undefined){return this.name;}else{return`${this.name}: ${this.message}`;}};return errorClass;};var UnboundTypeError;var getTypeName=type=>{var ptr=___getTypeName(type);var rv=readLatin1String(ptr);_free(ptr);return rv;};var throwUnboundTypeError=(message,types)=>{var unboundTypes=[];var seen={};function visit(type){if(seen[type]){return;}if(registeredTypes[type]){return;}if(typeDependencies[type]){typeDependencies[type].forEach(visit);return;}unboundTypes.push(type);seen[type]=true;}types.forEach(visit);throw new UnboundTypeError(`${message}: `+unboundTypes.map(getTypeName).join([", "]));};var __embind_register_class=(rawType,rawPointerType,rawConstPointerType,baseClassRawType,getActualTypeSignature,getActualType,upcastSignature,upcast,downcastSignature,downcast,name,destructorSignature,rawDestructor)=>{name=readLatin1String(name);getActualType=embind__requireFunction(getActualTypeSignature,getActualType);if(upcast){upcast=embind__requireFunction(upcastSignature,upcast);}if(downcast){downcast=embind__requireFunction(downcastSignature,downcast);}rawDestructor=embind__requireFunction(destructorSignature,rawDestructor);var legalFunctionName=makeLegalFunctionName(name);exposePublicSymbol(legalFunctionName,function(){throwUnboundTypeError(`Cannot construct ${name} due to unbound types`,[baseClassRawType]);});whenDependentTypesAreResolved([rawType,rawPointerType,rawConstPointerType],baseClassRawType?[baseClassRawType]:[],function(base){base=base[0];var baseClass;var basePrototype;if(baseClassRawType){baseClass=base.registeredClass;basePrototype=baseClass.instancePrototype;}else{basePrototype=ClassHandle.prototype;}var constructor=createNamedFunction(name,function(){if(Object.getPrototypeOf(this)!==instancePrototype){throw new BindingError("Use 'new' to construct "+name);}if(undefined===registeredClass.constructor_body){throw new BindingError(name+" has no accessible constructor");}var body=registeredClass.constructor_body[arguments.length];if(undefined===body){throw new BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`);}return body.apply(this,arguments);});var instancePrototype=Object.create(basePrototype,{constructor:{value:constructor}});constructor.prototype=instancePrototype;var registeredClass=new RegisteredClass(name,constructor,instancePrototype,rawDestructor,baseClass,getActualType,upcast,downcast);if(registeredClass.baseClass){if(registeredClass.baseClass.__derivedClasses===undefined){registeredClass.baseClass.__derivedClasses=[];}registeredClass.baseClass.__derivedClasses.push(registeredClass);}var referenceConverter=new RegisteredPointer(name,registeredClass,true,false,false);var pointerConverter=new RegisteredPointer(name+"*",registeredClass,false,false,false);var constPointerConverter=new RegisteredPointer(name+" const*",registeredClass,false,true,false);registeredPointers[rawType]={pointerType:pointerConverter,constPointerType:constPointerConverter};replacePublicSymbol(legalFunctionName,constructor);return[referenceConverter,pointerConverter,constPointerConverter];});};var heap32VectorToArray=(count,firstElement)=>{var array=[];for(var i=0;i<count;i++){array.push(HEAPU32[firstElement+i*4>>2]);}return array;};var runDestructors=destructors=>{while(destructors.length){var ptr=destructors.pop();var del=destructors.pop();del(ptr);}};function newFunc(constructor,argumentList){if(!(constructor instanceof Function)){throw new TypeError(`new_ called with constructor type ${typeof constructor} which is not a function`);}var dummy=createNamedFunction(constructor.name||"unknownFunctionName",function(){});dummy.prototype=constructor.prototype;var obj=new dummy();var r=constructor.apply(obj,argumentList);return r instanceof Object?r:obj;}function craftInvokerFunction(humanName,argTypes,classType,cppInvokerFunc,cppTargetFunc,isAsync){var argCount=argTypes.length;if(argCount<2){throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");}var isClassMethodFunc=argTypes[1]!==null&&classType!==null;var needsDestructorStack=false;for(var i=1;i<argTypes.length;++i){if(argTypes[i]!==null&&argTypes[i].destructorFunction===undefined){needsDestructorStack=true;break;}}var returns=argTypes[0].name!=="void";var argsList="";var argsListWired="";for(var i=0;i<argCount-2;++i){argsList+=(i!==0?", ":"")+"arg"+i;argsListWired+=(i!==0?", ":"")+"arg"+i+"Wired";}var invokerFnBody=`\n        return function (${argsList}) {\n        if (arguments.length !== ${argCount-2}) {\n          throwBindingError('function ${humanName} called with ' + arguments.length + ' arguments, expected ${argCount-2}');\n        }`;if(needsDestructorStack){invokerFnBody+="var destructors = [];\n";}var dtorStack=needsDestructorStack?"destructors":"null";var args1=["throwBindingError","invoker","fn","runDestructors","retType","classParam"];var args2=[throwBindingError,cppInvokerFunc,cppTargetFunc,runDestructors,argTypes[0],argTypes[1]];if(isClassMethodFunc){invokerFnBody+="var thisWired = classParam.toWireType("+dtorStack+", this);\n";}for(var i=0;i<argCount-2;++i){invokerFnBody+="var arg"+i+"Wired = argType"+i+".toWireType("+dtorStack+", arg"+i+"); // "+argTypes[i+2].name+"\n";args1.push("argType"+i);args2.push(argTypes[i+2]);}if(isClassMethodFunc){argsListWired="thisWired"+(argsListWired.length>0?", ":"")+argsListWired;}invokerFnBody+=(returns||isAsync?"var rv = ":"")+"invoker(fn"+(argsListWired.length>0?", ":"")+argsListWired+");\n";if(needsDestructorStack){invokerFnBody+="runDestructors(destructors);\n";}else{for(var i=isClassMethodFunc?1:2;i<argTypes.length;++i){var paramName=i===1?"thisWired":"arg"+(i-2)+"Wired";if(argTypes[i].destructorFunction!==null){invokerFnBody+=paramName+"_dtor("+paramName+"); // "+argTypes[i].name+"\n";args1.push(paramName+"_dtor");args2.push(argTypes[i].destructorFunction);}}}if(returns){invokerFnBody+="var ret = retType.fromWireType(rv);\n"+"return ret;\n";}else{}invokerFnBody+="}\n";args1.push(invokerFnBody);var invokerFn=newFunc(Function,args1).apply(null,args2);return createNamedFunction(humanName,invokerFn);}var __embind_register_class_constructor=(rawClassType,argCount,rawArgTypesAddr,invokerSignature,invoker,rawConstructor)=>{var rawArgTypes=heap32VectorToArray(argCount,rawArgTypesAddr);invoker=embind__requireFunction(invokerSignature,invoker);whenDependentTypesAreResolved([],[rawClassType],function(classType){classType=classType[0];var humanName=`constructor ${classType.name}`;if(undefined===classType.registeredClass.constructor_body){classType.registeredClass.constructor_body=[];}if(undefined!==classType.registeredClass.constructor_body[argCount-1]){throw new BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount-1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);}classType.registeredClass.constructor_body[argCount-1]=()=>{throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`,rawArgTypes);};whenDependentTypesAreResolved([],rawArgTypes,argTypes=>{argTypes.splice(1,0,null);classType.registeredClass.constructor_body[argCount-1]=craftInvokerFunction(humanName,argTypes,null,invoker,rawConstructor);return[];});return[];});};var getFunctionName=signature=>{signature=signature.trim();const argsIndex=signature.indexOf("(");if(argsIndex!==-1){return signature.substr(0,argsIndex);}else{return signature;}};var __embind_register_class_function=(rawClassType,methodName,argCount,rawArgTypesAddr,invokerSignature,rawInvoker,context,isPureVirtual,isAsync)=>{var rawArgTypes=heap32VectorToArray(argCount,rawArgTypesAddr);methodName=readLatin1String(methodName);methodName=getFunctionName(methodName);rawInvoker=embind__requireFunction(invokerSignature,rawInvoker);whenDependentTypesAreResolved([],[rawClassType],function(classType){classType=classType[0];var humanName=`${classType.name}.${methodName}`;if(methodName.startsWith("@@")){methodName=Symbol[methodName.substring(2)];}if(isPureVirtual){classType.registeredClass.pureVirtualFunctions.push(methodName);}function unboundTypesHandler(){throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`,rawArgTypes);}var proto=classType.registeredClass.instancePrototype;var method=proto[methodName];if(undefined===method||undefined===method.overloadTable&&method.className!==classType.name&&method.argCount===argCount-2){unboundTypesHandler.argCount=argCount-2;unboundTypesHandler.className=classType.name;proto[methodName]=unboundTypesHandler;}else{ensureOverloadTable(proto,methodName,humanName);proto[methodName].overloadTable[argCount-2]=unboundTypesHandler;}whenDependentTypesAreResolved([],rawArgTypes,function(argTypes){var memberFunction=craftInvokerFunction(humanName,argTypes,classType,rawInvoker,context,isAsync);if(undefined===proto[methodName].overloadTable){memberFunction.argCount=argCount-2;proto[methodName]=memberFunction;}else{proto[methodName].overloadTable[argCount-2]=memberFunction;}return[];});return[];});};function handleAllocatorInit(){Object.assign(HandleAllocator.prototype,{get(id){return this.allocated[id];},has(id){return this.allocated[id]!==undefined;},allocate(handle){var id=this.freelist.pop()||this.allocated.length;this.allocated[id]=handle;return id;},free(id){this.allocated[id]=undefined;this.freelist.push(id);}});}function HandleAllocator(){this.allocated=[undefined];this.freelist=[];}var emval_handles=new HandleAllocator();var __emval_decref=handle=>{if(handle>=emval_handles.reserved&&0===--emval_handles.get(handle).refcount){emval_handles.free(handle);}};var count_emval_handles=()=>{var count=0;for(var i=emval_handles.reserved;i<emval_handles.allocated.length;++i){if(emval_handles.allocated[i]!==undefined){++count;}}return count;};var init_emval=()=>{emval_handles.allocated.push({value:undefined},{value:null},{value:true},{value:false});emval_handles.reserved=emval_handles.allocated.length;Module["count_emval_handles"]=count_emval_handles;};var Emval={toValue:handle=>{if(!handle){throwBindingError("Cannot use deleted val. handle = "+handle);}return emval_handles.get(handle).value;},toHandle:value=>{switch(value){case undefined:return 1;case null:return 2;case true:return 3;case false:return 4;default:{return emval_handles.allocate({refcount:1,value:value});}}}};function simpleReadValueFromPointer(pointer){return this["fromWireType"](HEAP32[pointer>>2]);}var __embind_register_emval=(rawType,name)=>{name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":handle=>{var rv=Emval.toValue(handle);__emval_decref(handle);return rv;},"toWireType":(destructors,value)=>Emval.toHandle(value),"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction:null});};var embindRepr=v=>{if(v===null){return"null";}var t=typeof v;if(t==="object"||t==="array"||t==="function"){return v.toString();}else{return""+v;}};var floatReadValueFromPointer=(name,width)=>{switch(width){case 4:return function(pointer){return this["fromWireType"](HEAPF32[pointer>>2]);};case 8:return function(pointer){return this["fromWireType"](HEAPF64[pointer>>3]);};default:throw new TypeError(`invalid float width (${width}): ${name}`);}};var __embind_register_float=(rawType,name,size)=>{name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":value=>value,"toWireType":(destructors,value)=>value,"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":floatReadValueFromPointer(name,size),destructorFunction:null});};var integerReadValueFromPointer=(name,width,signed)=>{switch(width){case 1:return signed?pointer=>HEAP8[pointer>>0]:pointer=>HEAPU8[pointer>>0];case 2:return signed?pointer=>HEAP16[pointer>>1]:pointer=>HEAPU16[pointer>>1];case 4:return signed?pointer=>HEAP32[pointer>>2]:pointer=>HEAPU32[pointer>>2];default:throw new TypeError(`invalid integer width (${width}): ${name}`);}};var __embind_register_integer=(primitiveType,name,size,minRange,maxRange)=>{name=readLatin1String(name);if(maxRange===-1){maxRange=4294967295;}var fromWireType=value=>value;if(minRange===0){var bitshift=32-8*size;fromWireType=value=>value<<bitshift>>>bitshift;}var isUnsignedType=name.includes("unsigned");var checkAssertions=(value,toTypeName)=>{};var toWireType;if(isUnsignedType){toWireType=function toWireType(destructors,value){checkAssertions(value,this.name);return value>>>0;};}else{toWireType=function toWireType(destructors,value){checkAssertions(value,this.name);return value;};}registerType(primitiveType,{name:name,"fromWireType":fromWireType,"toWireType":toWireType,"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":integerReadValueFromPointer(name,size,minRange!==0),destructorFunction:null});};var __embind_register_memory_view=(rawType,dataTypeIndex,name)=>{var typeMapping=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array];var TA=typeMapping[dataTypeIndex];function decodeMemoryView(handle){var size=HEAPU32[handle>>2];var data=HEAPU32[handle+4>>2];return new TA(HEAP8.buffer,data,size);}name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":decodeMemoryView,"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":decodeMemoryView},{ignoreDuplicateRegistrations:true});};var __embind_register_std_string=(rawType,name)=>{name=readLatin1String(name);var stdStringIsUTF8=name==="std::string";registerType(rawType,{name:name,"fromWireType"(value){var length=HEAPU32[value>>2];var payload=value+4;var str;if(stdStringIsUTF8){var decodeStartPtr=payload;for(var i=0;i<=length;++i){var currentBytePtr=payload+i;if(i==length||HEAPU8[currentBytePtr]==0){var maxRead=currentBytePtr-decodeStartPtr;var stringSegment=UTF8ToString(decodeStartPtr,maxRead);if(str===undefined){str=stringSegment;}else{str+=String.fromCharCode(0);str+=stringSegment;}decodeStartPtr=currentBytePtr+1;}}}else{var a=new Array(length);for(var i=0;i<length;++i){a[i]=String.fromCharCode(HEAPU8[payload+i]);}str=a.join("");}_free(value);return str;},"toWireType"(destructors,value){if(value instanceof ArrayBuffer){value=new Uint8Array(value);}var length;var valueIsOfTypeString=typeof value=="string";if(!(valueIsOfTypeString||value instanceof Uint8Array||value instanceof Uint8ClampedArray||value instanceof Int8Array)){throwBindingError("Cannot pass non-string to std::string");}if(stdStringIsUTF8&&valueIsOfTypeString){length=lengthBytesUTF8(value);}else{length=value.length;}var base=_malloc(4+length+1);var ptr=base+4;HEAPU32[base>>2]=length;if(stdStringIsUTF8&&valueIsOfTypeString){stringToUTF8(value,ptr,length+1);}else{if(valueIsOfTypeString){for(var i=0;i<length;++i){var charCode=value.charCodeAt(i);if(charCode>255){_free(ptr);throwBindingError("String has UTF-16 code units that do not fit in 8 bits");}HEAPU8[ptr+i]=charCode;}}else{for(var i=0;i<length;++i){HEAPU8[ptr+i]=value[i];}}}if(destructors!==null){destructors.push(_free,base);}return base;},"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":readPointer,destructorFunction(ptr){_free(ptr);}});};var UTF16Decoder=typeof TextDecoder!="undefined"?new TextDecoder("utf-16le"):undefined;var UTF16ToString=(ptr,maxBytesToRead)=>{var endPtr=ptr;var idx=endPtr>>1;var maxIdx=idx+maxBytesToRead/2;while(!(idx>=maxIdx)&&HEAPU16[idx])++idx;endPtr=idx<<1;if(endPtr-ptr>32&&UTF16Decoder)return UTF16Decoder.decode(HEAPU8.subarray(ptr,endPtr));var str="";for(var i=0;!(i>=maxBytesToRead/2);++i){var codeUnit=HEAP16[ptr+i*2>>1];if(codeUnit==0)break;str+=String.fromCharCode(codeUnit);}return str;};var stringToUTF16=(str,outPtr,maxBytesToWrite)=>{if(maxBytesToWrite===undefined){maxBytesToWrite=2147483647;}if(maxBytesToWrite<2)return 0;maxBytesToWrite-=2;var startPtr=outPtr;var numCharsToWrite=maxBytesToWrite<str.length*2?maxBytesToWrite/2:str.length;for(var i=0;i<numCharsToWrite;++i){var codeUnit=str.charCodeAt(i);HEAP16[outPtr>>1]=codeUnit;outPtr+=2;}HEAP16[outPtr>>1]=0;return outPtr-startPtr;};var lengthBytesUTF16=str=>str.length*2;var UTF32ToString=(ptr,maxBytesToRead)=>{var i=0;var str="";while(!(i>=maxBytesToRead/4)){var utf32=HEAP32[ptr+i*4>>2];if(utf32==0)break;++i;if(utf32>=65536){var ch=utf32-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023);}else{str+=String.fromCharCode(utf32);}}return str;};var stringToUTF32=(str,outPtr,maxBytesToWrite)=>{if(maxBytesToWrite===undefined){maxBytesToWrite=2147483647;}if(maxBytesToWrite<4)return 0;var startPtr=outPtr;var endPtr=startPtr+maxBytesToWrite-4;for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);if(codeUnit>=55296&&codeUnit<=57343){var trailSurrogate=str.charCodeAt(++i);codeUnit=65536+((codeUnit&1023)<<10)|trailSurrogate&1023;}HEAP32[outPtr>>2]=codeUnit;outPtr+=4;if(outPtr+4>endPtr)break;}HEAP32[outPtr>>2]=0;return outPtr-startPtr;};var lengthBytesUTF32=str=>{var len=0;for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);if(codeUnit>=55296&&codeUnit<=57343)++i;len+=4;}return len;};var __embind_register_std_wstring=(rawType,charSize,name)=>{name=readLatin1String(name);var decodeString,encodeString,getHeap,lengthBytesUTF,shift;if(charSize===2){decodeString=UTF16ToString;encodeString=stringToUTF16;lengthBytesUTF=lengthBytesUTF16;getHeap=()=>HEAPU16;shift=1;}else if(charSize===4){decodeString=UTF32ToString;encodeString=stringToUTF32;lengthBytesUTF=lengthBytesUTF32;getHeap=()=>HEAPU32;shift=2;}registerType(rawType,{name:name,"fromWireType":value=>{var length=HEAPU32[value>>2];var HEAP=getHeap();var str;var decodeStartPtr=value+4;for(var i=0;i<=length;++i){var currentBytePtr=value+4+i*charSize;if(i==length||HEAP[currentBytePtr>>shift]==0){var maxReadBytes=currentBytePtr-decodeStartPtr;var stringSegment=decodeString(decodeStartPtr,maxReadBytes);if(str===undefined){str=stringSegment;}else{str+=String.fromCharCode(0);str+=stringSegment;}decodeStartPtr=currentBytePtr+charSize;}}_free(value);return str;},"toWireType":(destructors,value)=>{if(!(typeof value=="string")){throwBindingError(`Cannot pass non-string to C++ string type ${name}`);}var length=lengthBytesUTF(value);var ptr=_malloc(4+length+charSize);HEAPU32[ptr>>2]=length>>shift;encodeString(value,ptr+4,length+charSize);if(destructors!==null){destructors.push(_free,ptr);}return ptr;},"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction(ptr){_free(ptr);}});};var __embind_register_void=(rawType,name)=>{name=readLatin1String(name);registerType(rawType,{isVoid:true,name:name,"argPackAdvance":0,"fromWireType":()=>undefined,"toWireType":(destructors,o)=>undefined});};var nowIsMonotonic=1;var __emscripten_get_now_is_monotonic=()=>nowIsMonotonic;var __emval_incref=handle=>{if(handle>4){emval_handles.get(handle).refcount+=1;}};var requireRegisteredType=(rawType,humanName)=>{var impl=registeredTypes[rawType];if(undefined===impl){throwBindingError(humanName+" has unknown type "+getTypeName(rawType));}return impl;};var __emval_take_value=(type,arg)=>{type=requireRegisteredType(type,"_emval_take_value");var v=type["readValueFromPointer"](arg);return Emval.toHandle(v);};function __mmap_js(len,prot,flags,fd,offset_low,offset_high,allocated,addr){var offset=convertI32PairToI53Checked(offset_low,offset_high);try{if(isNaN(offset))return 61;var stream=SYSCALLS.getStreamFromFD(fd);var res=FS.mmap(stream,len,offset,prot,flags);var ptr=res.ptr;HEAP32[allocated>>2]=res.allocated;HEAPU32[addr>>2]=ptr;return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function __munmap_js(addr,len,prot,flags,fd,offset_low,offset_high){var offset=convertI32PairToI53Checked(offset_low,offset_high);try{if(isNaN(offset))return 61;var stream=SYSCALLS.getStreamFromFD(fd);if(prot&2){SYSCALLS.doMsync(addr,stream,len,flags,offset);}FS.munmap(stream);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}var _abort=()=>{abort("");};var _emscripten_date_now=()=>Date.now();var getHeapMax=()=>HEAPU8.length;var _emscripten_get_heap_max=()=>getHeapMax();var _emscripten_get_now;_emscripten_get_now=()=>performance.now();var _emscripten_memcpy_js=(dest,src,num)=>HEAPU8.copyWithin(dest,src,src+num);var abortOnCannotGrowMemory=requestedSize=>{abort("OOM");};var _emscripten_resize_heap=requestedSize=>{var oldSize=HEAPU8.length;requestedSize>>>=0;abortOnCannotGrowMemory(requestedSize);};var ENV={};var getExecutableName=()=>thisProgram||"./this.program";var getEnvStrings=()=>{if(!getEnvStrings.strings){var lang=(typeof navigator=="object"&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8";var env={"USER":"web_user","LOGNAME":"web_user","PATH":"/","PWD":"/","HOME":"/home/web_user","LANG":lang,"_":getExecutableName()};for(var x in ENV){if(ENV[x]===undefined)delete env[x];else env[x]=ENV[x];}var strings=[];for(var x in env){strings.push(`${x}=${env[x]}`);}getEnvStrings.strings=strings;}return getEnvStrings.strings;};var stringToAscii=(str,buffer)=>{for(var i=0;i<str.length;++i){HEAP8[buffer++>>0]=str.charCodeAt(i);}HEAP8[buffer>>0]=0;};var _environ_get=(__environ,environ_buf)=>{var bufSize=0;getEnvStrings().forEach((string,i)=>{var ptr=environ_buf+bufSize;HEAPU32[__environ+i*4>>2]=ptr;stringToAscii(string,ptr);bufSize+=string.length+1;});return 0;};var _environ_sizes_get=(penviron_count,penviron_buf_size)=>{var strings=getEnvStrings();HEAPU32[penviron_count>>2]=strings.length;var bufSize=0;strings.forEach(string=>bufSize+=string.length+1);HEAPU32[penviron_buf_size>>2]=bufSize;return 0;};var runtimeKeepaliveCounter=0;var keepRuntimeAlive=()=>noExitRuntime||runtimeKeepaliveCounter>0;var _proc_exit=code=>{EXITSTATUS=code;if(!keepRuntimeAlive()){if(Module["onExit"])Module["onExit"](code);ABORT=true;}quit_(code,new ExitStatus(code));};var exitJS=(status,implicit)=>{EXITSTATUS=status;if(!keepRuntimeAlive()){exitRuntime();}_proc_exit(status);};var _exit=exitJS;function _fd_close(fd){try{var stream=SYSCALLS.getStreamFromFD(fd);FS.close(stream);return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}var doReadv=(stream,iov,iovcnt,offset)=>{var ret=0;for(var i=0;i<iovcnt;i++){var ptr=HEAPU32[iov>>2];var len=HEAPU32[iov+4>>2];iov+=8;var curr=FS.read(stream,HEAP8,ptr,len,offset);if(curr<0)return-1;ret+=curr;if(curr<len)break;if(typeof offset!=="undefined"){offset+=curr;}}return ret;};function _fd_read(fd,iov,iovcnt,pnum){try{var stream=SYSCALLS.getStreamFromFD(fd);var num=doReadv(stream,iov,iovcnt);HEAPU32[pnum>>2]=num;return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}function _fd_seek(fd,offset_low,offset_high,whence,newOffset){var offset=convertI32PairToI53Checked(offset_low,offset_high);try{if(isNaN(offset))return 61;var stream=SYSCALLS.getStreamFromFD(fd);FS.llseek(stream,offset,whence);tempI64=[stream.position>>>0,(tempDouble=stream.position,+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[newOffset>>2]=tempI64[0],HEAP32[newOffset+4>>2]=tempI64[1];if(stream.getdents&&offset===0&&whence===0)stream.getdents=null;return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}function _fd_sync(fd){try{var stream=SYSCALLS.getStreamFromFD(fd);if(stream.stream_ops&&stream.stream_ops.fsync){return stream.stream_ops.fsync(stream);}return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}var doWritev=(stream,iov,iovcnt,offset)=>{var ret=0;for(var i=0;i<iovcnt;i++){var ptr=HEAPU32[iov>>2];var len=HEAPU32[iov+4>>2];iov+=8;var curr=FS.write(stream,HEAP8,ptr,len,offset);if(curr<0)return-1;ret+=curr;if(typeof offset!=="undefined"){offset+=curr;}}return ret;};function _fd_write(fd,iov,iovcnt,pnum){try{var stream=SYSCALLS.getStreamFromFD(fd);var num=doWritev(stream,iov,iovcnt);HEAPU32[pnum>>2]=num;return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}var _getentropy=(buffer,size)=>{randomFill(HEAPU8.subarray(buffer,buffer+size));return 0;};var isLeapYear=year=>year%4===0&&(year%100!==0||year%400===0);var arraySum=(array,index)=>{var sum=0;for(var i=0;i<=index;sum+=array[i++]){}return sum;};var MONTH_DAYS_LEAP=[31,29,31,30,31,30,31,31,30,31,30,31];var MONTH_DAYS_REGULAR=[31,28,31,30,31,30,31,31,30,31,30,31];var addDays=(date,days)=>{var newDate=new Date(date.getTime());while(days>0){var leap=isLeapYear(newDate.getFullYear());var currentMonth=newDate.getMonth();var daysInCurrentMonth=(leap?MONTH_DAYS_LEAP:MONTH_DAYS_REGULAR)[currentMonth];if(days>daysInCurrentMonth-newDate.getDate()){days-=daysInCurrentMonth-newDate.getDate()+1;newDate.setDate(1);if(currentMonth<11){newDate.setMonth(currentMonth+1);}else{newDate.setMonth(0);newDate.setFullYear(newDate.getFullYear()+1);}}else{newDate.setDate(newDate.getDate()+days);return newDate;}}return newDate;};var writeArrayToMemory=(array,buffer)=>{HEAP8.set(array,buffer);};var _strftime=(s,maxsize,format,tm)=>{var tm_zone=HEAPU32[tm+40>>2];var date={tm_sec:HEAP32[tm>>2],tm_min:HEAP32[tm+4>>2],tm_hour:HEAP32[tm+8>>2],tm_mday:HEAP32[tm+12>>2],tm_mon:HEAP32[tm+16>>2],tm_year:HEAP32[tm+20>>2],tm_wday:HEAP32[tm+24>>2],tm_yday:HEAP32[tm+28>>2],tm_isdst:HEAP32[tm+32>>2],tm_gmtoff:HEAP32[tm+36>>2],tm_zone:tm_zone?UTF8ToString(tm_zone):""};var pattern=UTF8ToString(format);var EXPANSION_RULES_1={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S","%Ec":"%c","%EC":"%C","%Ex":"%m/%d/%y","%EX":"%H:%M:%S","%Ey":"%y","%EY":"%Y","%Od":"%d","%Oe":"%e","%OH":"%H","%OI":"%I","%Om":"%m","%OM":"%M","%OS":"%S","%Ou":"%u","%OU":"%U","%OV":"%V","%Ow":"%w","%OW":"%W","%Oy":"%y"};for(var rule in EXPANSION_RULES_1){pattern=pattern.replace(new RegExp(rule,"g"),EXPANSION_RULES_1[rule]);}var WEEKDAYS=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];var MONTHS=["January","February","March","April","May","June","July","August","September","October","November","December"];function leadingSomething(value,digits,character){var str=typeof value=="number"?value.toString():value||"";while(str.length<digits){str=character[0]+str;}return str;}function leadingNulls(value,digits){return leadingSomething(value,digits,"0");}function compareByDay(date1,date2){function sgn(value){return value<0?-1:value>0?1:0;}var compare;if((compare=sgn(date1.getFullYear()-date2.getFullYear()))===0){if((compare=sgn(date1.getMonth()-date2.getMonth()))===0){compare=sgn(date1.getDate()-date2.getDate());}}return compare;}function getFirstWeekStartDate(janFourth){switch(janFourth.getDay()){case 0:return new Date(janFourth.getFullYear()-1,11,29);case 1:return janFourth;case 2:return new Date(janFourth.getFullYear(),0,3);case 3:return new Date(janFourth.getFullYear(),0,2);case 4:return new Date(janFourth.getFullYear(),0,1);case 5:return new Date(janFourth.getFullYear()-1,11,31);case 6:return new Date(janFourth.getFullYear()-1,11,30);}}function getWeekBasedYear(date){var thisDate=addDays(new Date(date.tm_year+1900,0,1),date.tm_yday);var janFourthThisYear=new Date(thisDate.getFullYear(),0,4);var janFourthNextYear=new Date(thisDate.getFullYear()+1,0,4);var firstWeekStartThisYear=getFirstWeekStartDate(janFourthThisYear);var firstWeekStartNextYear=getFirstWeekStartDate(janFourthNextYear);if(compareByDay(firstWeekStartThisYear,thisDate)<=0){if(compareByDay(firstWeekStartNextYear,thisDate)<=0){return thisDate.getFullYear()+1;}return thisDate.getFullYear();}return thisDate.getFullYear()-1;}var EXPANSION_RULES_2={"%a":date=>WEEKDAYS[date.tm_wday].substring(0,3),"%A":date=>WEEKDAYS[date.tm_wday],"%b":date=>MONTHS[date.tm_mon].substring(0,3),"%B":date=>MONTHS[date.tm_mon],"%C":date=>{var year=date.tm_year+1900;return leadingNulls(year/100|0,2);},"%d":date=>leadingNulls(date.tm_mday,2),"%e":date=>leadingSomething(date.tm_mday,2," "),"%g":date=>getWeekBasedYear(date).toString().substring(2),"%G":date=>getWeekBasedYear(date),"%H":date=>leadingNulls(date.tm_hour,2),"%I":date=>{var twelveHour=date.tm_hour;if(twelveHour==0)twelveHour=12;else if(twelveHour>12)twelveHour-=12;return leadingNulls(twelveHour,2);},"%j":date=>leadingNulls(date.tm_mday+arraySum(isLeapYear(date.tm_year+1900)?MONTH_DAYS_LEAP:MONTH_DAYS_REGULAR,date.tm_mon-1),3),"%m":date=>leadingNulls(date.tm_mon+1,2),"%M":date=>leadingNulls(date.tm_min,2),"%n":()=>"\n","%p":date=>{if(date.tm_hour>=0&&date.tm_hour<12){return"AM";}return"PM";},"%S":date=>leadingNulls(date.tm_sec,2),"%t":()=>"\t","%u":date=>date.tm_wday||7,"%U":date=>{var days=date.tm_yday+7-date.tm_wday;return leadingNulls(Math.floor(days/7),2);},"%V":date=>{var val=Math.floor((date.tm_yday+7-(date.tm_wday+6)%7)/7);if((date.tm_wday+371-date.tm_yday-2)%7<=2){val++;}if(!val){val=52;var dec31=(date.tm_wday+7-date.tm_yday-1)%7;if(dec31==4||dec31==5&&isLeapYear(date.tm_year%400-1)){val++;}}else if(val==53){var jan1=(date.tm_wday+371-date.tm_yday)%7;if(jan1!=4&&(jan1!=3||!isLeapYear(date.tm_year)))val=1;}return leadingNulls(val,2);},"%w":date=>date.tm_wday,"%W":date=>{var days=date.tm_yday+7-(date.tm_wday+6)%7;return leadingNulls(Math.floor(days/7),2);},"%y":date=>(date.tm_year+1900).toString().substring(2),"%Y":date=>date.tm_year+1900,"%z":date=>{var off=date.tm_gmtoff;var ahead=off>=0;off=Math.abs(off)/60;off=off/60*100+off%60;return(ahead?"+":"-")+String("0000"+off).slice(-4);},"%Z":date=>date.tm_zone,"%%":()=>"%"};pattern=pattern.replace(/%%/g,"\0\0");for(var rule in EXPANSION_RULES_2){if(pattern.includes(rule)){pattern=pattern.replace(new RegExp(rule,"g"),EXPANSION_RULES_2[rule](date));}}pattern=pattern.replace(/\0\0/g,"%");var bytes=intArrayFromString(pattern,false);if(bytes.length>maxsize){return 0;}writeArrayToMemory(bytes,s);return bytes.length-1;};var _strftime_l=(s,maxsize,format,tm,loc)=>_strftime(s,maxsize,format,tm);var FSNode=function FSNode(parent,name,mode,rdev){if(!parent){parent=this;}this.parent=parent;this.mount=parent.mount;this.mounted=null;this.id=FS.nextInode++;this.name=name;this.mode=mode;this.node_ops={};this.stream_ops={};this.rdev=rdev;};var readMode=292|73;var writeMode=146;Object.defineProperties(FSNode.prototype,{read:{get:function get(){return(this.mode&readMode)===readMode;},set:function set(val){val?this.mode|=readMode:this.mode&=~readMode;}},write:{get:function get(){return(this.mode&writeMode)===writeMode;},set:function set(val){val?this.mode|=writeMode:this.mode&=~writeMode;}},isFolder:{get:function get(){return FS.isDir(this.mode);}},isDevice:{get:function get(){return FS.isChrdev(this.mode);}}});FS.FSNode=FSNode;FS.createPreloadedFile=FS_createPreloadedFile;FS.staticInit();embind_init_charCodes();BindingError=Module["BindingError"]=/*#__PURE__*/function(_Error){(0,_inheritsLoose2.default)(BindingError,_Error);function BindingError(message){var _this;_this=_Error.call(this,message)||this;_this.name="BindingError";return _this;}return BindingError;}(/*#__PURE__*/(0,_wrapNativeSuper2.default)(Error));InternalError=Module["InternalError"]=/*#__PURE__*/function(_Error2){(0,_inheritsLoose2.default)(InternalError,_Error2);function InternalError(message){var _this2;_this2=_Error2.call(this,message)||this;_this2.name="InternalError";return _this2;}return InternalError;}(/*#__PURE__*/(0,_wrapNativeSuper2.default)(Error));init_ClassHandle();init_embind();init_RegisteredPointer();UnboundTypeError=Module["UnboundTypeError"]=extendError(Error,"UnboundTypeError");handleAllocatorInit();init_emval();var wasmImports={a:___assert_fail,t:___cxa_begin_catch,s:___cxa_end_catch,c:___cxa_find_matching_catch_2,j:___cxa_find_matching_catch_3,oa:___cxa_rethrow,m:___cxa_throw,g:___resumeException,ea:___syscall_fstat64,R:___syscall_ftruncate64,ca:___syscall_newfstatat,fa:___syscall_openat,_:___syscall_readlinkat,Z:___syscall_renameat,da:___syscall_stat64,X:___syscall_unlinkat,S:__embind_register_bigint,ja:__embind_register_bool,N:__embind_register_class,M:__embind_register_class_constructor,l:__embind_register_class_function,ia:__embind_register_emval,H:__embind_register_float,o:__embind_register_integer,k:__embind_register_memory_view,G:__embind_register_std_string,z:__embind_register_std_wstring,ka:__embind_register_void,ga:__emscripten_get_now_is_monotonic,sa:__emval_decref,ta:__emval_incref,q:__emval_take_value,O:__mmap_js,P:__munmap_js,b:_abort,E:_emscripten_date_now,Y:_emscripten_get_heap_max,w:_emscripten_get_now,ha:_emscripten_memcpy_js,W:_emscripten_resize_heap,$:_environ_get,aa:_environ_sizes_get,la:_exit,F:_fd_close,D:_fd_read,Q:_fd_seek,ba:_fd_sync,y:_fd_write,U:_getentropy,ra:invoke_fi,C:invoke_i,f:invoke_ii,na:invoke_iidii,qa:invoke_iif,d:invoke_iii,e:invoke_iiii,B:invoke_iiiii,v:invoke_iiiiii,K:invoke_iiiiiii,T:invoke_iij,p:invoke_v,i:invoke_vi,h:invoke_vii,r:invoke_viid,A:invoke_viidi,n:invoke_viii,pa:invoke_viiidiii,L:invoke_viiii,I:invoke_viiiidi,J:invoke_viiiii,u:invoke_viiiiiiidi,x:invoke_viiiiiiii,V:_strftime_l,ma:xnnLoadWasmModuleJS};var wasmExports=createWasm();var ___wasm_call_ctors=()=>(___wasm_call_ctors=wasmExports["va"])();var _malloc=a0=>(_malloc=wasmExports["xa"])(a0);var _free=a0=>(_free=wasmExports["ya"])(a0);var ___errno_location=()=>(___errno_location=wasmExports["za"])();var ___getTypeName=a0=>(___getTypeName=wasmExports["Aa"])(a0);var ___funcs_on_exit=()=>(___funcs_on_exit=wasmExports["Ba"])();var _fflush=Module["_fflush"]=a0=>(_fflush=Module["_fflush"]=wasmExports["Ca"])(a0);var _emscripten_builtin_memalign=(a0,a1)=>(_emscripten_builtin_memalign=wasmExports["Da"])(a0,a1);var _setThrew=(a0,a1)=>(_setThrew=wasmExports["Ea"])(a0,a1);var setTempRet0=a0=>(setTempRet0=wasmExports["Fa"])(a0);var stackSave=()=>(stackSave=wasmExports["Ga"])();var stackRestore=a0=>(stackRestore=wasmExports["Ha"])(a0);var ___cxa_decrement_exception_refcount=a0=>(___cxa_decrement_exception_refcount=wasmExports["Ia"])(a0);var ___cxa_increment_exception_refcount=a0=>(___cxa_increment_exception_refcount=wasmExports["Ja"])(a0);var ___cxa_can_catch=(a0,a1,a2)=>(___cxa_can_catch=wasmExports["Ka"])(a0,a1,a2);var ___cxa_is_pointer_type=a0=>(___cxa_is_pointer_type=wasmExports["La"])(a0);var dynCall_viijj=Module["dynCall_viijj"]=(a0,a1,a2,a3,a4,a5,a6)=>(dynCall_viijj=Module["dynCall_viijj"]=wasmExports["Ma"])(a0,a1,a2,a3,a4,a5,a6);var dynCall_viiijjj=Module["dynCall_viiijjj"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9)=>(dynCall_viiijjj=Module["dynCall_viiijjj"]=wasmExports["Na"])(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9);var dynCall_iiiij=Module["dynCall_iiiij"]=(a0,a1,a2,a3,a4,a5)=>(dynCall_iiiij=Module["dynCall_iiiij"]=wasmExports["Oa"])(a0,a1,a2,a3,a4,a5);var dynCall_jii=Module["dynCall_jii"]=(a0,a1,a2)=>(dynCall_jii=Module["dynCall_jii"]=wasmExports["Pa"])(a0,a1,a2);var dynCall_jjj=Module["dynCall_jjj"]=(a0,a1,a2,a3,a4)=>(dynCall_jjj=Module["dynCall_jjj"]=wasmExports["Qa"])(a0,a1,a2,a3,a4);var dynCall_iiiijj=Module["dynCall_iiiijj"]=(a0,a1,a2,a3,a4,a5,a6,a7)=>(dynCall_iiiijj=Module["dynCall_iiiijj"]=wasmExports["Ra"])(a0,a1,a2,a3,a4,a5,a6,a7);var dynCall_viijji=Module["dynCall_viijji"]=(a0,a1,a2,a3,a4,a5,a6,a7)=>(dynCall_viijji=Module["dynCall_viijji"]=wasmExports["Sa"])(a0,a1,a2,a3,a4,a5,a6,a7);var dynCall_iiijj=Module["dynCall_iiijj"]=(a0,a1,a2,a3,a4,a5,a6)=>(dynCall_iiijj=Module["dynCall_iiijj"]=wasmExports["Ta"])(a0,a1,a2,a3,a4,a5,a6);var dynCall_viijjj=Module["dynCall_viijjj"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8)=>(dynCall_viijjj=Module["dynCall_viijjj"]=wasmExports["Ua"])(a0,a1,a2,a3,a4,a5,a6,a7,a8);var dynCall_iij=Module["dynCall_iij"]=(a0,a1,a2,a3)=>(dynCall_iij=Module["dynCall_iij"]=wasmExports["Va"])(a0,a1,a2,a3);var dynCall_iijjiiii=Module["dynCall_iijjiiii"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9)=>(dynCall_iijjiiii=Module["dynCall_iijjiiii"]=wasmExports["Wa"])(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9);var dynCall_jiji=Module["dynCall_jiji"]=(a0,a1,a2,a3,a4)=>(dynCall_jiji=Module["dynCall_jiji"]=wasmExports["Xa"])(a0,a1,a2,a3,a4);var dynCall_viijii=Module["dynCall_viijii"]=(a0,a1,a2,a3,a4,a5,a6)=>(dynCall_viijii=Module["dynCall_viijii"]=wasmExports["Ya"])(a0,a1,a2,a3,a4,a5,a6);var dynCall_iiiiij=Module["dynCall_iiiiij"]=(a0,a1,a2,a3,a4,a5,a6)=>(dynCall_iiiiij=Module["dynCall_iiiiij"]=wasmExports["Za"])(a0,a1,a2,a3,a4,a5,a6);var dynCall_iiiiijj=Module["dynCall_iiiiijj"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8)=>(dynCall_iiiiijj=Module["dynCall_iiiiijj"]=wasmExports["_a"])(a0,a1,a2,a3,a4,a5,a6,a7,a8);var dynCall_iiiiiijj=Module["dynCall_iiiiiijj"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9)=>(dynCall_iiiiiijj=Module["dynCall_iiiiiijj"]=wasmExports["$a"])(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9);var ___start_em_js=Module["___start_em_js"]=261460;var ___stop_em_js=Module["___stop_em_js"]=262072;function invoke_ii(index,a1){var sp=stackSave();try{return getWasmTableEntry(index)(a1);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iii(index,a1,a2){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_vii(index,a1,a2){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_vi(index,a1){var sp=stackSave();try{getWasmTableEntry(index)(a1);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iiiiii(index,a1,a2,a3,a4,a5){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3,a4,a5);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iiii(index,a1,a2,a3){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_i(index){var sp=stackSave();try{return getWasmTableEntry(index)();}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiii(index,a1,a2,a3,a4){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_fi(index,a1){var sp=stackSave();try{return getWasmTableEntry(index)(a1);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iif(index,a1,a2){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iiiiiii(index,a1,a2,a3,a4,a5,a6){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_v(index){var sp=stackSave();try{getWasmTableEntry(index)();}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiiii(index,a1,a2,a3,a4,a5){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiiiiiidi(index,a1,a2,a3,a4,a5,a6,a7,a8,a9){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6,a7,a8,a9);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viii(index,a1,a2,a3){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiiidi(index,a1,a2,a3,a4,a5,a6){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiidiii(index,a1,a2,a3,a4,a5,a6,a7){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6,a7);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viid(index,a1,a2,a3){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6,a7,a8);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iiiii(index,a1,a2,a3,a4){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3,a4);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viidi(index,a1,a2,a3,a4){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iidii(index,a1,a2,a3,a4){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3,a4);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iij(index,a1,a2,a3){var sp=stackSave();try{return dynCall_iij(index,a1,a2,a3);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}var calledRun;dependenciesFulfilled=function runCaller(){if(!calledRun)run();if(!calledRun)dependenciesFulfilled=runCaller;};function run(){if(runDependencies>0){return;}preRun();if(runDependencies>0){return;}function doRun(){if(calledRun)return;calledRun=true;Module["calledRun"]=true;if(ABORT)return;initRuntime();readyPromiseResolve(Module);if(Module["onRuntimeInitialized"])Module["onRuntimeInitialized"]();postRun();}if(Module["setStatus"]){Module["setStatus"]("Running...");setTimeout(function(){setTimeout(function(){Module["setStatus"]("");},1);doRun();},1);}else{doRun();}}if(Module["preInit"]){if(typeof Module["preInit"]=="function")Module["preInit"]=[Module["preInit"]];while(Module["preInit"].length>0){Module["preInit"].pop()();}}run();return moduleArg.ready;};})();;createWasmMonoInstance=Module;}let createWasmMultiInstance;{var Module=(()=>{var _scriptDir=location.href;return function(moduleArg){if(moduleArg===void 0){moduleArg={};}var Module=moduleArg;var readyPromiseResolve,readyPromiseReject;Module["ready"]=new Promise((resolve,reject)=>{readyPromiseResolve=resolve;readyPromiseReject=reject;});var moduleOverrides=Object.assign({},Module);var arguments_=[];var thisProgram="./this.program";var quit_=(status,toThrow)=>{throw toThrow;};var ENVIRONMENT_IS_WEB=typeof window=="object";var ENVIRONMENT_IS_WORKER=typeof importScripts=="function";var ENVIRONMENT_IS_NODE=typeof process=="object"&&typeof process.versions=="object"&&typeof process.versions.node=="string";var ENVIRONMENT_IS_PTHREAD=Module["ENVIRONMENT_IS_PTHREAD"]||false;var scriptDirectory="";function locateFile(path){if(Module["locateFile"]){return Module["locateFile"](path,scriptDirectory);}return scriptDirectory+path;}var read_,readAsync,readBinary;if(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER){if(ENVIRONMENT_IS_WORKER){scriptDirectory=self.location.href;}else if(typeof document!="undefined"&&document.currentScript){scriptDirectory=document.currentScript.src;}if(_scriptDir){scriptDirectory=_scriptDir;}if(scriptDirectory.indexOf("blob:")!==0){scriptDirectory=scriptDirectory.substr(0,scriptDirectory.replace(/[?#].*/,"").lastIndexOf("/")+1);}else{scriptDirectory="";}{read_=url=>{var xhr=new XMLHttpRequest();xhr.open("GET",url,false);xhr.send(null);return xhr.responseText;};if(ENVIRONMENT_IS_WORKER){readBinary=url=>{var xhr=new XMLHttpRequest();xhr.open("GET",url,false);xhr.responseType="arraybuffer";xhr.send(null);return new Uint8Array(xhr.response);};}readAsync=(url,onload,onerror)=>{var xhr=new XMLHttpRequest();xhr.open("GET",url,true);xhr.responseType="arraybuffer";xhr.onload=()=>{if(xhr.status==200||xhr.status==0&&xhr.response){onload(xhr.response);return;}onerror();};xhr.onerror=onerror;xhr.send(null);};}}else{}var out=Module["print"]||console.log.bind(console);var err=Module["printErr"]||console.error.bind(console);Object.assign(Module,moduleOverrides);moduleOverrides=null;if(Module["arguments"])arguments_=Module["arguments"];if(Module["thisProgram"])thisProgram=Module["thisProgram"];if(Module["quit"])quit_=Module["quit"];var wasmBinary;if(Module["wasmBinary"])wasmBinary=Module["wasmBinary"];if(typeof WebAssembly!="object"){abort("no native wasm support detected");}var wasmMemory;var wasmModule;var ABORT=false;var EXITSTATUS;function assert(condition,text){if(!condition){abort(text);}}var HEAP8,HEAPU8,HEAP16,HEAPU16,HEAP32,HEAPU32,HEAPF32,HEAPF64;function updateMemoryViews(){var b=wasmMemory.buffer;Module["HEAP8"]=HEAP8=new Int8Array(b);Module["HEAP16"]=HEAP16=new Int16Array(b);Module["HEAPU8"]=HEAPU8=new Uint8Array(b);Module["HEAPU16"]=HEAPU16=new Uint16Array(b);Module["HEAP32"]=HEAP32=new Int32Array(b);Module["HEAPU32"]=HEAPU32=new Uint32Array(b);Module["HEAPF32"]=HEAPF32=new Float32Array(b);Module["HEAPF64"]=HEAPF64=new Float64Array(b);}var INITIAL_MEMORY=Module["INITIAL_MEMORY"]||134217728;if(ENVIRONMENT_IS_PTHREAD){wasmMemory=Module["wasmMemory"];}else{if(Module["wasmMemory"]){wasmMemory=Module["wasmMemory"];}else{wasmMemory=new WebAssembly.Memory({"initial":INITIAL_MEMORY/65536,"maximum":INITIAL_MEMORY/65536,"shared":true});if(!(wasmMemory.buffer instanceof SharedArrayBuffer)){err("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag");if(ENVIRONMENT_IS_NODE){err("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)");}throw Error("bad memory");}}}updateMemoryViews();INITIAL_MEMORY=wasmMemory.buffer.byteLength;var __ATPRERUN__=[];var __ATINIT__=[];var __ATEXIT__=[];var __ATPOSTRUN__=[];var runtimeInitialized=false;var runtimeExited=false;function preRun(){if(Module["preRun"]){if(typeof Module["preRun"]=="function")Module["preRun"]=[Module["preRun"]];while(Module["preRun"].length){addOnPreRun(Module["preRun"].shift());}}callRuntimeCallbacks(__ATPRERUN__);}function initRuntime(){runtimeInitialized=true;if(ENVIRONMENT_IS_PTHREAD)return;if(!Module["noFSInit"]&&!FS.init.initialized)FS.init();FS.ignorePermissions=false;TTY.init();callRuntimeCallbacks(__ATINIT__);}function exitRuntime(){if(ENVIRONMENT_IS_PTHREAD)return;___funcs_on_exit();callRuntimeCallbacks(__ATEXIT__);FS.quit();TTY.shutdown();PThread.terminateAllThreads();runtimeExited=true;}function postRun(){if(ENVIRONMENT_IS_PTHREAD)return;if(Module["postRun"]){if(typeof Module["postRun"]=="function")Module["postRun"]=[Module["postRun"]];while(Module["postRun"].length){addOnPostRun(Module["postRun"].shift());}}callRuntimeCallbacks(__ATPOSTRUN__);}function addOnPreRun(cb){__ATPRERUN__.unshift(cb);}function addOnInit(cb){__ATINIT__.unshift(cb);}function addOnPostRun(cb){__ATPOSTRUN__.unshift(cb);}var runDependencies=0;var runDependencyWatcher=null;var dependenciesFulfilled=null;function getUniqueRunDependency(id){return id;}function addRunDependency(id){runDependencies++;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies);}}function removeRunDependency(id){runDependencies--;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies);}if(runDependencies==0){if(runDependencyWatcher!==null){clearInterval(runDependencyWatcher);runDependencyWatcher=null;}if(dependenciesFulfilled){var callback=dependenciesFulfilled;dependenciesFulfilled=null;callback();}}}function abort(what){if(Module["onAbort"]){Module["onAbort"](what);}what="Aborted("+what+")";err(what);ABORT=true;EXITSTATUS=1;what+=". Build with -sASSERTIONS for more info.";var e=new WebAssembly.RuntimeError(what);readyPromiseReject(e);throw e;}var dataURIPrefix="data:application/octet-stream;base64,";var isDataURI=filename=>filename.startsWith(dataURIPrefix);var wasmBinaryFile;if(Module["locateFile"]){wasmBinaryFile="main-bin-multi.wasm";if(!isDataURI(wasmBinaryFile)){wasmBinaryFile=locateFile(wasmBinaryFile);}}else{wasmBinaryFile=new URL("main-bin-multi.wasm",location.href).href;}function getBinarySync(file){if(file==wasmBinaryFile&&wasmBinary){return new Uint8Array(wasmBinary);}if(readBinary){return readBinary(file);}throw"both async and sync fetching of the wasm failed";}function getBinaryPromise(binaryFile){if(!wasmBinary&&(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER)){if(typeof fetch=="function"){return fetch(binaryFile,{credentials:"same-origin"}).then(response=>{if(!response["ok"]){throw"failed to load wasm binary file at '"+binaryFile+"'";}return response["arrayBuffer"]();}).catch(()=>getBinarySync(binaryFile));}}return Promise.resolve().then(()=>getBinarySync(binaryFile));}function instantiateArrayBuffer(binaryFile,imports,receiver){return getBinaryPromise(binaryFile).then(binary=>WebAssembly.instantiate(binary,imports)).then(instance=>instance).then(receiver,reason=>{err(`failed to asynchronously prepare wasm: ${reason}`);abort(reason);});}function instantiateAsync(binary,binaryFile,imports,callback){if(!binary&&typeof WebAssembly.instantiateStreaming=="function"&&!isDataURI(binaryFile)&&typeof fetch=="function"){return fetch(binaryFile,{credentials:"same-origin"}).then(response=>{var result=WebAssembly.instantiateStreaming(response,imports);return result.then(callback,function(reason){err(`wasm streaming compile failed: ${reason}`);err("falling back to ArrayBuffer instantiation");return instantiateArrayBuffer(binaryFile,imports,callback);});});}return instantiateArrayBuffer(binaryFile,imports,callback);}function createWasm(){var info={"a":wasmImports};function receiveInstance(instance,module){wasmExports=instance.exports;registerTLSInit(wasmExports["Ka"]);wasmTable=wasmExports["Ga"];addOnInit(wasmExports["Ea"]);wasmModule=module;removeRunDependency("wasm-instantiate");return wasmExports;}addRunDependency("wasm-instantiate");function receiveInstantiationResult(result){receiveInstance(result["instance"],result["module"]);}if(Module["instantiateWasm"]){try{return Module["instantiateWasm"](info,receiveInstance);}catch(e){err(`Module.instantiateWasm callback failed with error: ${e}`);readyPromiseReject(e);}}instantiateAsync(wasmBinary,wasmBinaryFile,info,receiveInstantiationResult).catch(readyPromiseReject);return{};}var tempDouble;var tempI64;function xnnLoadWasmModuleJS(code,offset,offset_end,invalid_function_index){const tableOriginalSize=wasmTable.length;const binary=new Uint8Array(HEAPU8.slice(code+offset,code+offset_end));try{var module=new WebAssembly.Module(binary);var instance=new WebAssembly.Instance(module,{env:{memory:wasmMemory}});for(var symName in instance.exports){var value=instance.exports[symName];addFunction(value);}if(tableOriginalSize<wasmTable.length){return tableOriginalSize;}return invalid_function_index;}catch(error){console.log(error);return invalid_function_index;}}function ExitStatus(status){this.name="ExitStatus";this.message=`Program terminated with exit(${status})`;this.status=status;}var terminateWorker=worker=>{worker.terminate();worker.onmessage=e=>{};};var killThread=pthread_ptr=>{var worker=PThread.pthreads[pthread_ptr];delete PThread.pthreads[pthread_ptr];terminateWorker(worker);__emscripten_thread_free_data(pthread_ptr);PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker),1);worker.pthread_ptr=0;};var cancelThread=pthread_ptr=>{var worker=PThread.pthreads[pthread_ptr];worker.postMessage({"cmd":"cancel"});};var cleanupThread=pthread_ptr=>{var worker=PThread.pthreads[pthread_ptr];PThread.returnWorkerToPool(worker);};var zeroMemory=(address,size)=>{HEAPU8.fill(0,address,address+size);return address;};var spawnThread=threadParams=>{var worker=PThread.getNewWorker();if(!worker){return 6;}PThread.runningWorkers.push(worker);PThread.pthreads[threadParams.pthread_ptr]=worker;worker.pthread_ptr=threadParams.pthread_ptr;var msg={"cmd":"run","start_routine":threadParams.startRoutine,"arg":threadParams.arg,"pthread_ptr":threadParams.pthread_ptr};worker.postMessage(msg,threadParams.transferList);return 0;};var runtimeKeepaliveCounter=0;var keepRuntimeAlive=()=>noExitRuntime||runtimeKeepaliveCounter>0;var PATH={isAbs:path=>path.charAt(0)==="/",splitPath:filename=>{var splitPathRe=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;return splitPathRe.exec(filename).slice(1);},normalizeArray:(parts,allowAboveRoot)=>{var up=0;for(var i=parts.length-1;i>=0;i--){var last=parts[i];if(last==="."){parts.splice(i,1);}else if(last===".."){parts.splice(i,1);up++;}else if(up){parts.splice(i,1);up--;}}if(allowAboveRoot){for(;up;up--){parts.unshift("..");}}return parts;},normalize:path=>{var isAbsolute=PATH.isAbs(path),trailingSlash=path.substr(-1)==="/";path=PATH.normalizeArray(path.split("/").filter(p=>!!p),!isAbsolute).join("/");if(!path&&!isAbsolute){path=".";}if(path&&trailingSlash){path+="/";}return(isAbsolute?"/":"")+path;},dirname:path=>{var result=PATH.splitPath(path),root=result[0],dir=result[1];if(!root&&!dir){return".";}if(dir){dir=dir.substr(0,dir.length-1);}return root+dir;},basename:path=>{if(path==="/")return"/";path=PATH.normalize(path);path=path.replace(/\/$/,"");var lastSlash=path.lastIndexOf("/");if(lastSlash===-1)return path;return path.substr(lastSlash+1);},join:function join(){var paths=Array.prototype.slice.call(arguments);return PATH.normalize(paths.join("/"));},join2:(l,r)=>PATH.normalize(l+"/"+r)};var initRandomFill=()=>{if(typeof crypto=="object"&&typeof crypto["getRandomValues"]=="function"){return view=>(view.set(crypto.getRandomValues(new Uint8Array(view.byteLength))),view);}else abort("initRandomDevice");};var randomFill=view=>(randomFill=initRandomFill())(view);var PATH_FS={resolve:function resolve(){var resolvedPath="",resolvedAbsolute=false;for(var i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?arguments[i]:FS.cwd();if(typeof path!="string"){throw new TypeError("Arguments to path.resolve must be strings");}else if(!path){return"";}resolvedPath=path+"/"+resolvedPath;resolvedAbsolute=PATH.isAbs(path);}resolvedPath=PATH.normalizeArray(resolvedPath.split("/").filter(p=>!!p),!resolvedAbsolute).join("/");return(resolvedAbsolute?"/":"")+resolvedPath||".";},relative:(from,to)=>{from=PATH_FS.resolve(from).substr(1);to=PATH_FS.resolve(to).substr(1);function trim(arr){var start=0;for(;start<arr.length;start++){if(arr[start]!=="")break;}var end=arr.length-1;for(;end>=0;end--){if(arr[end]!=="")break;}if(start>end)return[];return arr.slice(start,end-start+1);}var fromParts=trim(from.split("/"));var toParts=trim(to.split("/"));var length=Math.min(fromParts.length,toParts.length);var samePartsLength=length;for(var i=0;i<length;i++){if(fromParts[i]!==toParts[i]){samePartsLength=i;break;}}var outputParts=[];for(var i=samePartsLength;i<fromParts.length;i++){outputParts.push("..");}outputParts=outputParts.concat(toParts.slice(samePartsLength));return outputParts.join("/");}};var UTF8Decoder=typeof TextDecoder!="undefined"?new TextDecoder("utf8"):undefined;var UTF8ArrayToString=(heapOrArray,idx,maxBytesToRead)=>{var endIdx=idx+maxBytesToRead;var endPtr=idx;while(heapOrArray[endPtr]&&!(endPtr>=endIdx))++endPtr;if(endPtr-idx>16&&heapOrArray.buffer&&UTF8Decoder){return UTF8Decoder.decode(heapOrArray.buffer instanceof SharedArrayBuffer?heapOrArray.slice(idx,endPtr):heapOrArray.subarray(idx,endPtr));}var str="";while(idx<endPtr){var u0=heapOrArray[idx++];if(!(u0&128)){str+=String.fromCharCode(u0);continue;}var u1=heapOrArray[idx++]&63;if((u0&224)==192){str+=String.fromCharCode((u0&31)<<6|u1);continue;}var u2=heapOrArray[idx++]&63;if((u0&240)==224){u0=(u0&15)<<12|u1<<6|u2;}else{u0=(u0&7)<<18|u1<<12|u2<<6|heapOrArray[idx++]&63;}if(u0<65536){str+=String.fromCharCode(u0);}else{var ch=u0-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023);}}return str;};var FS_stdin_getChar_buffer=[];var lengthBytesUTF8=str=>{var len=0;for(var i=0;i<str.length;++i){var c=str.charCodeAt(i);if(c<=127){len++;}else if(c<=2047){len+=2;}else if(c>=55296&&c<=57343){len+=4;++i;}else{len+=3;}}return len;};var stringToUTF8Array=(str,heap,outIdx,maxBytesToWrite)=>{if(!(maxBytesToWrite>0))return 0;var startIdx=outIdx;var endIdx=outIdx+maxBytesToWrite-1;for(var i=0;i<str.length;++i){var u=str.charCodeAt(i);if(u>=55296&&u<=57343){var u1=str.charCodeAt(++i);u=65536+((u&1023)<<10)|u1&1023;}if(u<=127){if(outIdx>=endIdx)break;heap[outIdx++]=u;}else if(u<=2047){if(outIdx+1>=endIdx)break;heap[outIdx++]=192|u>>6;heap[outIdx++]=128|u&63;}else if(u<=65535){if(outIdx+2>=endIdx)break;heap[outIdx++]=224|u>>12;heap[outIdx++]=128|u>>6&63;heap[outIdx++]=128|u&63;}else{if(outIdx+3>=endIdx)break;heap[outIdx++]=240|u>>18;heap[outIdx++]=128|u>>12&63;heap[outIdx++]=128|u>>6&63;heap[outIdx++]=128|u&63;}}heap[outIdx]=0;return outIdx-startIdx;};function intArrayFromString(stringy,dontAddNull,length){var len=length>0?length:lengthBytesUTF8(stringy)+1;var u8array=new Array(len);var numBytesWritten=stringToUTF8Array(stringy,u8array,0,u8array.length);if(dontAddNull)u8array.length=numBytesWritten;return u8array;}var FS_stdin_getChar=()=>{if(!FS_stdin_getChar_buffer.length){var result=null;if(typeof window!="undefined"&&typeof window.prompt=="function"){result=window.prompt("Input: ");if(result!==null){result+="\n";}}else if(typeof readline=="function"){result=readline();if(result!==null){result+="\n";}}if(!result){return null;}FS_stdin_getChar_buffer=intArrayFromString(result,true);}return FS_stdin_getChar_buffer.shift();};var TTY={ttys:[],init(){},shutdown(){},register(dev,ops){TTY.ttys[dev]={input:[],output:[],ops:ops};FS.registerDevice(dev,TTY.stream_ops);},stream_ops:{open(stream){var tty=TTY.ttys[stream.node.rdev];if(!tty){throw new FS.ErrnoError(43);}stream.tty=tty;stream.seekable=false;},close(stream){stream.tty.ops.fsync(stream.tty);},fsync(stream){stream.tty.ops.fsync(stream.tty);},read(stream,buffer,offset,length,pos){if(!stream.tty||!stream.tty.ops.get_char){throw new FS.ErrnoError(60);}var bytesRead=0;for(var i=0;i<length;i++){var result;try{result=stream.tty.ops.get_char(stream.tty);}catch(e){throw new FS.ErrnoError(29);}if(result===undefined&&bytesRead===0){throw new FS.ErrnoError(6);}if(result===null||result===undefined)break;bytesRead++;buffer[offset+i]=result;}if(bytesRead){stream.node.timestamp=Date.now();}return bytesRead;},write(stream,buffer,offset,length,pos){if(!stream.tty||!stream.tty.ops.put_char){throw new FS.ErrnoError(60);}try{for(var i=0;i<length;i++){stream.tty.ops.put_char(stream.tty,buffer[offset+i]);}}catch(e){throw new FS.ErrnoError(29);}if(length){stream.node.timestamp=Date.now();}return i;}},default_tty_ops:{get_char(tty){return FS_stdin_getChar();},put_char(tty,val){if(val===null||val===10){out(UTF8ArrayToString(tty.output,0));tty.output=[];}else{if(val!=0)tty.output.push(val);}},fsync(tty){if(tty.output&&tty.output.length>0){out(UTF8ArrayToString(tty.output,0));tty.output=[];}},ioctl_tcgets(tty){return{c_iflag:25856,c_oflag:5,c_cflag:191,c_lflag:35387,c_cc:[3,28,127,21,4,0,1,0,17,19,26,0,18,15,23,22,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]};},ioctl_tcsets(tty,optional_actions,data){return 0;},ioctl_tiocgwinsz(tty){return[24,80];}},default_tty1_ops:{put_char(tty,val){if(val===null||val===10){err(UTF8ArrayToString(tty.output,0));tty.output=[];}else{if(val!=0)tty.output.push(val);}},fsync(tty){if(tty.output&&tty.output.length>0){err(UTF8ArrayToString(tty.output,0));tty.output=[];}}}};var alignMemory=(size,alignment)=>Math.ceil(size/alignment)*alignment;var mmapAlloc=size=>{size=alignMemory(size,65536);var ptr=_emscripten_builtin_memalign(65536,size);if(!ptr)return 0;return zeroMemory(ptr,size);};var MEMFS={ops_table:null,mount(mount){return MEMFS.createNode(null,"/",16384|511,0);},createNode(parent,name,mode,dev){if(FS.isBlkdev(mode)||FS.isFIFO(mode)){throw new FS.ErrnoError(63);}if(!MEMFS.ops_table){MEMFS.ops_table={dir:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr,lookup:MEMFS.node_ops.lookup,mknod:MEMFS.node_ops.mknod,rename:MEMFS.node_ops.rename,unlink:MEMFS.node_ops.unlink,rmdir:MEMFS.node_ops.rmdir,readdir:MEMFS.node_ops.readdir,symlink:MEMFS.node_ops.symlink},stream:{llseek:MEMFS.stream_ops.llseek}},file:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr},stream:{llseek:MEMFS.stream_ops.llseek,read:MEMFS.stream_ops.read,write:MEMFS.stream_ops.write,allocate:MEMFS.stream_ops.allocate,mmap:MEMFS.stream_ops.mmap,msync:MEMFS.stream_ops.msync}},link:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr,readlink:MEMFS.node_ops.readlink},stream:{}},chrdev:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr},stream:FS.chrdev_stream_ops}};}var node=FS.createNode(parent,name,mode,dev);if(FS.isDir(node.mode)){node.node_ops=MEMFS.ops_table.dir.node;node.stream_ops=MEMFS.ops_table.dir.stream;node.contents={};}else if(FS.isFile(node.mode)){node.node_ops=MEMFS.ops_table.file.node;node.stream_ops=MEMFS.ops_table.file.stream;node.usedBytes=0;node.contents=null;}else if(FS.isLink(node.mode)){node.node_ops=MEMFS.ops_table.link.node;node.stream_ops=MEMFS.ops_table.link.stream;}else if(FS.isChrdev(node.mode)){node.node_ops=MEMFS.ops_table.chrdev.node;node.stream_ops=MEMFS.ops_table.chrdev.stream;}node.timestamp=Date.now();if(parent){parent.contents[name]=node;parent.timestamp=node.timestamp;}return node;},getFileDataAsTypedArray(node){if(!node.contents)return new Uint8Array(0);if(node.contents.subarray)return node.contents.subarray(0,node.usedBytes);return new Uint8Array(node.contents);},expandFileStorage(node,newCapacity){var prevCapacity=node.contents?node.contents.length:0;if(prevCapacity>=newCapacity)return;var CAPACITY_DOUBLING_MAX=1024*1024;newCapacity=Math.max(newCapacity,prevCapacity*(prevCapacity<CAPACITY_DOUBLING_MAX?2:1.125)>>>0);if(prevCapacity!=0)newCapacity=Math.max(newCapacity,256);var oldContents=node.contents;node.contents=new Uint8Array(newCapacity);if(node.usedBytes>0)node.contents.set(oldContents.subarray(0,node.usedBytes),0);},resizeFileStorage(node,newSize){if(node.usedBytes==newSize)return;if(newSize==0){node.contents=null;node.usedBytes=0;}else{var oldContents=node.contents;node.contents=new Uint8Array(newSize);if(oldContents){node.contents.set(oldContents.subarray(0,Math.min(newSize,node.usedBytes)));}node.usedBytes=newSize;}},node_ops:{getattr(node){var attr={};attr.dev=FS.isChrdev(node.mode)?node.id:1;attr.ino=node.id;attr.mode=node.mode;attr.nlink=1;attr.uid=0;attr.gid=0;attr.rdev=node.rdev;if(FS.isDir(node.mode)){attr.size=4096;}else if(FS.isFile(node.mode)){attr.size=node.usedBytes;}else if(FS.isLink(node.mode)){attr.size=node.link.length;}else{attr.size=0;}attr.atime=new Date(node.timestamp);attr.mtime=new Date(node.timestamp);attr.ctime=new Date(node.timestamp);attr.blksize=4096;attr.blocks=Math.ceil(attr.size/attr.blksize);return attr;},setattr(node,attr){if(attr.mode!==undefined){node.mode=attr.mode;}if(attr.timestamp!==undefined){node.timestamp=attr.timestamp;}if(attr.size!==undefined){MEMFS.resizeFileStorage(node,attr.size);}},lookup(parent,name){throw FS.genericErrors[44];},mknod(parent,name,mode,dev){return MEMFS.createNode(parent,name,mode,dev);},rename(old_node,new_dir,new_name){if(FS.isDir(old_node.mode)){var new_node;try{new_node=FS.lookupNode(new_dir,new_name);}catch(e){}if(new_node){for(var i in new_node.contents){throw new FS.ErrnoError(55);}}}delete old_node.parent.contents[old_node.name];old_node.parent.timestamp=Date.now();old_node.name=new_name;new_dir.contents[new_name]=old_node;new_dir.timestamp=old_node.parent.timestamp;old_node.parent=new_dir;},unlink(parent,name){delete parent.contents[name];parent.timestamp=Date.now();},rmdir(parent,name){var node=FS.lookupNode(parent,name);for(var i in node.contents){throw new FS.ErrnoError(55);}delete parent.contents[name];parent.timestamp=Date.now();},readdir(node){var entries=[".",".."];for(var key in node.contents){if(!node.contents.hasOwnProperty(key)){continue;}entries.push(key);}return entries;},symlink(parent,newname,oldpath){var node=MEMFS.createNode(parent,newname,511|40960,0);node.link=oldpath;return node;},readlink(node){if(!FS.isLink(node.mode)){throw new FS.ErrnoError(28);}return node.link;}},stream_ops:{read(stream,buffer,offset,length,position){var contents=stream.node.contents;if(position>=stream.node.usedBytes)return 0;var size=Math.min(stream.node.usedBytes-position,length);if(size>8&&contents.subarray){buffer.set(contents.subarray(position,position+size),offset);}else{for(var i=0;i<size;i++)buffer[offset+i]=contents[position+i];}return size;},write(stream,buffer,offset,length,position,canOwn){if(!length)return 0;var node=stream.node;node.timestamp=Date.now();if(buffer.subarray&&(!node.contents||node.contents.subarray)){if(canOwn){node.contents=buffer.subarray(offset,offset+length);node.usedBytes=length;return length;}else if(node.usedBytes===0&&position===0){node.contents=buffer.slice(offset,offset+length);node.usedBytes=length;return length;}else if(position+length<=node.usedBytes){node.contents.set(buffer.subarray(offset,offset+length),position);return length;}}MEMFS.expandFileStorage(node,position+length);if(node.contents.subarray&&buffer.subarray){node.contents.set(buffer.subarray(offset,offset+length),position);}else{for(var i=0;i<length;i++){node.contents[position+i]=buffer[offset+i];}}node.usedBytes=Math.max(node.usedBytes,position+length);return length;},llseek(stream,offset,whence){var position=offset;if(whence===1){position+=stream.position;}else if(whence===2){if(FS.isFile(stream.node.mode)){position+=stream.node.usedBytes;}}if(position<0){throw new FS.ErrnoError(28);}return position;},allocate(stream,offset,length){MEMFS.expandFileStorage(stream.node,offset+length);stream.node.usedBytes=Math.max(stream.node.usedBytes,offset+length);},mmap(stream,length,position,prot,flags){if(!FS.isFile(stream.node.mode)){throw new FS.ErrnoError(43);}var ptr;var allocated;var contents=stream.node.contents;if(!(flags&2)&&contents.buffer===HEAP8.buffer){allocated=false;ptr=contents.byteOffset;}else{if(position>0||position+length<contents.length){if(contents.subarray){contents=contents.subarray(position,position+length);}else{contents=Array.prototype.slice.call(contents,position,position+length);}}allocated=true;ptr=mmapAlloc(length);if(!ptr){throw new FS.ErrnoError(48);}HEAP8.set(contents,ptr);}return{ptr:ptr,allocated:allocated};},msync(stream,buffer,offset,length,mmapFlags){MEMFS.stream_ops.write(stream,buffer,0,length,offset,false);return 0;}}};var asyncLoad=(url,onload,onerror,noRunDep)=>{var dep=!noRunDep?getUniqueRunDependency(`al ${url}`):"";readAsync(url,arrayBuffer=>{assert(arrayBuffer,`Loading data file "${url}" failed (no arrayBuffer).`);onload(new Uint8Array(arrayBuffer));if(dep)removeRunDependency(dep);},event=>{if(onerror){onerror();}else{throw`Loading data file "${url}" failed.`;}});if(dep)addRunDependency(dep);};var FS_createDataFile=(parent,name,fileData,canRead,canWrite,canOwn)=>{FS.createDataFile(parent,name,fileData,canRead,canWrite,canOwn);};var preloadPlugins=Module["preloadPlugins"]||[];var FS_handledByPreloadPlugin=(byteArray,fullname,finish,onerror)=>{if(typeof Browser!="undefined")Browser.init();var handled=false;preloadPlugins.forEach(plugin=>{if(handled)return;if(plugin["canHandle"](fullname)){plugin["handle"](byteArray,fullname,finish,onerror);handled=true;}});return handled;};var FS_createPreloadedFile=(parent,name,url,canRead,canWrite,onload,onerror,dontCreateFile,canOwn,preFinish)=>{var fullname=name?PATH_FS.resolve(PATH.join2(parent,name)):parent;var dep=getUniqueRunDependency(`cp ${fullname}`);function processData(byteArray){function finish(byteArray){if(preFinish)preFinish();if(!dontCreateFile){FS_createDataFile(parent,name,byteArray,canRead,canWrite,canOwn);}if(onload)onload();removeRunDependency(dep);}if(FS_handledByPreloadPlugin(byteArray,fullname,finish,()=>{if(onerror)onerror();removeRunDependency(dep);})){return;}finish(byteArray);}addRunDependency(dep);if(typeof url=="string"){asyncLoad(url,byteArray=>processData(byteArray),onerror);}else{processData(url);}};var FS_modeStringToFlags=str=>{var flagModes={"r":0,"r+":2,"w":512|64|1,"w+":512|64|2,"a":1024|64|1,"a+":1024|64|2};var flags=flagModes[str];if(typeof flags=="undefined"){throw new Error(`Unknown file open mode: ${str}`);}return flags;};var FS_getMode=(canRead,canWrite)=>{var mode=0;if(canRead)mode|=292|73;if(canWrite)mode|=146;return mode;};var FS={root:null,mounts:[],devices:{},streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:false,ignorePermissions:true,ErrnoError:null,genericErrors:{},filesystems:null,syncFSRequests:0,lookupPath(path,opts){if(opts===void 0){opts={};}path=PATH_FS.resolve(path);if(!path)return{path:"",node:null};var defaults={follow_mount:true,recurse_count:0};opts=Object.assign(defaults,opts);if(opts.recurse_count>8){throw new FS.ErrnoError(32);}var parts=path.split("/").filter(p=>!!p);var current=FS.root;var current_path="/";for(var i=0;i<parts.length;i++){var islast=i===parts.length-1;if(islast&&opts.parent){break;}current=FS.lookupNode(current,parts[i]);current_path=PATH.join2(current_path,parts[i]);if(FS.isMountpoint(current)){if(!islast||islast&&opts.follow_mount){current=current.mounted.root;}}if(!islast||opts.follow){var count=0;while(FS.isLink(current.mode)){var link=FS.readlink(current_path);current_path=PATH_FS.resolve(PATH.dirname(current_path),link);var lookup=FS.lookupPath(current_path,{recurse_count:opts.recurse_count+1});current=lookup.node;if(count++>40){throw new FS.ErrnoError(32);}}}}return{path:current_path,node:current};},getPath(node){var path;while(true){if(FS.isRoot(node)){var mount=node.mount.mountpoint;if(!path)return mount;return mount[mount.length-1]!=="/"?`${mount}/${path}`:mount+path;}path=path?`${node.name}/${path}`:node.name;node=node.parent;}},hashName(parentid,name){var hash=0;for(var i=0;i<name.length;i++){hash=(hash<<5)-hash+name.charCodeAt(i)|0;}return(parentid+hash>>>0)%FS.nameTable.length;},hashAddNode(node){var hash=FS.hashName(node.parent.id,node.name);node.name_next=FS.nameTable[hash];FS.nameTable[hash]=node;},hashRemoveNode(node){var hash=FS.hashName(node.parent.id,node.name);if(FS.nameTable[hash]===node){FS.nameTable[hash]=node.name_next;}else{var current=FS.nameTable[hash];while(current){if(current.name_next===node){current.name_next=node.name_next;break;}current=current.name_next;}}},lookupNode(parent,name){var errCode=FS.mayLookup(parent);if(errCode){throw new FS.ErrnoError(errCode,parent);}var hash=FS.hashName(parent.id,name);for(var node=FS.nameTable[hash];node;node=node.name_next){var nodeName=node.name;if(node.parent.id===parent.id&&nodeName===name){return node;}}return FS.lookup(parent,name);},createNode(parent,name,mode,rdev){var node=new FS.FSNode(parent,name,mode,rdev);FS.hashAddNode(node);return node;},destroyNode(node){FS.hashRemoveNode(node);},isRoot(node){return node===node.parent;},isMountpoint(node){return!!node.mounted;},isFile(mode){return(mode&61440)===32768;},isDir(mode){return(mode&61440)===16384;},isLink(mode){return(mode&61440)===40960;},isChrdev(mode){return(mode&61440)===8192;},isBlkdev(mode){return(mode&61440)===24576;},isFIFO(mode){return(mode&61440)===4096;},isSocket(mode){return(mode&49152)===49152;},flagsToPermissionString(flag){var perms=["r","w","rw"][flag&3];if(flag&512){perms+="w";}return perms;},nodePermissions(node,perms){if(FS.ignorePermissions){return 0;}if(perms.includes("r")&&!(node.mode&292)){return 2;}else if(perms.includes("w")&&!(node.mode&146)){return 2;}else if(perms.includes("x")&&!(node.mode&73)){return 2;}return 0;},mayLookup(dir){var errCode=FS.nodePermissions(dir,"x");if(errCode)return errCode;if(!dir.node_ops.lookup)return 2;return 0;},mayCreate(dir,name){try{var node=FS.lookupNode(dir,name);return 20;}catch(e){}return FS.nodePermissions(dir,"wx");},mayDelete(dir,name,isdir){var node;try{node=FS.lookupNode(dir,name);}catch(e){return e.errno;}var errCode=FS.nodePermissions(dir,"wx");if(errCode){return errCode;}if(isdir){if(!FS.isDir(node.mode)){return 54;}if(FS.isRoot(node)||FS.getPath(node)===FS.cwd()){return 10;}}else{if(FS.isDir(node.mode)){return 31;}}return 0;},mayOpen(node,flags){if(!node){return 44;}if(FS.isLink(node.mode)){return 32;}else if(FS.isDir(node.mode)){if(FS.flagsToPermissionString(flags)!=="r"||flags&512){return 31;}}return FS.nodePermissions(node,FS.flagsToPermissionString(flags));},MAX_OPEN_FDS:4096,nextfd(){for(var fd=0;fd<=FS.MAX_OPEN_FDS;fd++){if(!FS.streams[fd]){return fd;}}throw new FS.ErrnoError(33);},getStreamChecked(fd){var stream=FS.getStream(fd);if(!stream){throw new FS.ErrnoError(8);}return stream;},getStream:fd=>FS.streams[fd],createStream(stream,fd){if(fd===void 0){fd=-1;}if(!FS.FSStream){FS.FSStream=function(){this.shared={};};FS.FSStream.prototype={};Object.defineProperties(FS.FSStream.prototype,{object:{get(){return this.node;},set(val){this.node=val;}},isRead:{get(){return(this.flags&2097155)!==1;}},isWrite:{get(){return(this.flags&2097155)!==0;}},isAppend:{get(){return this.flags&1024;}},flags:{get(){return this.shared.flags;},set(val){this.shared.flags=val;}},position:{get(){return this.shared.position;},set(val){this.shared.position=val;}}});}stream=Object.assign(new FS.FSStream(),stream);if(fd==-1){fd=FS.nextfd();}stream.fd=fd;FS.streams[fd]=stream;return stream;},closeStream(fd){FS.streams[fd]=null;},chrdev_stream_ops:{open(stream){var device=FS.getDevice(stream.node.rdev);stream.stream_ops=device.stream_ops;if(stream.stream_ops.open){stream.stream_ops.open(stream);}},llseek(){throw new FS.ErrnoError(70);}},major:dev=>dev>>8,minor:dev=>dev&255,makedev:(ma,mi)=>ma<<8|mi,registerDevice(dev,ops){FS.devices[dev]={stream_ops:ops};},getDevice:dev=>FS.devices[dev],getMounts(mount){var mounts=[];var check=[mount];while(check.length){var m=check.pop();mounts.push(m);check.push.apply(check,m.mounts);}return mounts;},syncfs(populate,callback){if(typeof populate=="function"){callback=populate;populate=false;}FS.syncFSRequests++;if(FS.syncFSRequests>1){err(`warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);}var mounts=FS.getMounts(FS.root.mount);var completed=0;function doCallback(errCode){FS.syncFSRequests--;return callback(errCode);}function done(errCode){if(errCode){if(!done.errored){done.errored=true;return doCallback(errCode);}return;}if(++completed>=mounts.length){doCallback(null);}}mounts.forEach(mount=>{if(!mount.type.syncfs){return done(null);}mount.type.syncfs(mount,populate,done);});},mount(type,opts,mountpoint){var root=mountpoint==="/";var pseudo=!mountpoint;var node;if(root&&FS.root){throw new FS.ErrnoError(10);}else if(!root&&!pseudo){var lookup=FS.lookupPath(mountpoint,{follow_mount:false});mountpoint=lookup.path;node=lookup.node;if(FS.isMountpoint(node)){throw new FS.ErrnoError(10);}if(!FS.isDir(node.mode)){throw new FS.ErrnoError(54);}}var mount={type:type,opts:opts,mountpoint:mountpoint,mounts:[]};var mountRoot=type.mount(mount);mountRoot.mount=mount;mount.root=mountRoot;if(root){FS.root=mountRoot;}else if(node){node.mounted=mount;if(node.mount){node.mount.mounts.push(mount);}}return mountRoot;},unmount(mountpoint){var lookup=FS.lookupPath(mountpoint,{follow_mount:false});if(!FS.isMountpoint(lookup.node)){throw new FS.ErrnoError(28);}var node=lookup.node;var mount=node.mounted;var mounts=FS.getMounts(mount);Object.keys(FS.nameTable).forEach(hash=>{var current=FS.nameTable[hash];while(current){var next=current.name_next;if(mounts.includes(current.mount)){FS.destroyNode(current);}current=next;}});node.mounted=null;var idx=node.mount.mounts.indexOf(mount);node.mount.mounts.splice(idx,1);},lookup(parent,name){return parent.node_ops.lookup(parent,name);},mknod(path,mode,dev){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;var name=PATH.basename(path);if(!name||name==="."||name===".."){throw new FS.ErrnoError(28);}var errCode=FS.mayCreate(parent,name);if(errCode){throw new FS.ErrnoError(errCode);}if(!parent.node_ops.mknod){throw new FS.ErrnoError(63);}return parent.node_ops.mknod(parent,name,mode,dev);},create(path,mode){mode=mode!==undefined?mode:438;mode&=4095;mode|=32768;return FS.mknod(path,mode,0);},mkdir(path,mode){mode=mode!==undefined?mode:511;mode&=511|512;mode|=16384;return FS.mknod(path,mode,0);},mkdirTree(path,mode){var dirs=path.split("/");var d="";for(var i=0;i<dirs.length;++i){if(!dirs[i])continue;d+="/"+dirs[i];try{FS.mkdir(d,mode);}catch(e){if(e.errno!=20)throw e;}}},mkdev(path,mode,dev){if(typeof dev=="undefined"){dev=mode;mode=438;}mode|=8192;return FS.mknod(path,mode,dev);},symlink(oldpath,newpath){if(!PATH_FS.resolve(oldpath)){throw new FS.ErrnoError(44);}var lookup=FS.lookupPath(newpath,{parent:true});var parent=lookup.node;if(!parent){throw new FS.ErrnoError(44);}var newname=PATH.basename(newpath);var errCode=FS.mayCreate(parent,newname);if(errCode){throw new FS.ErrnoError(errCode);}if(!parent.node_ops.symlink){throw new FS.ErrnoError(63);}return parent.node_ops.symlink(parent,newname,oldpath);},rename(old_path,new_path){var old_dirname=PATH.dirname(old_path);var new_dirname=PATH.dirname(new_path);var old_name=PATH.basename(old_path);var new_name=PATH.basename(new_path);var lookup,old_dir,new_dir;lookup=FS.lookupPath(old_path,{parent:true});old_dir=lookup.node;lookup=FS.lookupPath(new_path,{parent:true});new_dir=lookup.node;if(!old_dir||!new_dir)throw new FS.ErrnoError(44);if(old_dir.mount!==new_dir.mount){throw new FS.ErrnoError(75);}var old_node=FS.lookupNode(old_dir,old_name);var relative=PATH_FS.relative(old_path,new_dirname);if(relative.charAt(0)!=="."){throw new FS.ErrnoError(28);}relative=PATH_FS.relative(new_path,old_dirname);if(relative.charAt(0)!=="."){throw new FS.ErrnoError(55);}var new_node;try{new_node=FS.lookupNode(new_dir,new_name);}catch(e){}if(old_node===new_node){return;}var isdir=FS.isDir(old_node.mode);var errCode=FS.mayDelete(old_dir,old_name,isdir);if(errCode){throw new FS.ErrnoError(errCode);}errCode=new_node?FS.mayDelete(new_dir,new_name,isdir):FS.mayCreate(new_dir,new_name);if(errCode){throw new FS.ErrnoError(errCode);}if(!old_dir.node_ops.rename){throw new FS.ErrnoError(63);}if(FS.isMountpoint(old_node)||new_node&&FS.isMountpoint(new_node)){throw new FS.ErrnoError(10);}if(new_dir!==old_dir){errCode=FS.nodePermissions(old_dir,"w");if(errCode){throw new FS.ErrnoError(errCode);}}FS.hashRemoveNode(old_node);try{old_dir.node_ops.rename(old_node,new_dir,new_name);}catch(e){throw e;}finally{FS.hashAddNode(old_node);}},rmdir(path){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;var name=PATH.basename(path);var node=FS.lookupNode(parent,name);var errCode=FS.mayDelete(parent,name,true);if(errCode){throw new FS.ErrnoError(errCode);}if(!parent.node_ops.rmdir){throw new FS.ErrnoError(63);}if(FS.isMountpoint(node)){throw new FS.ErrnoError(10);}parent.node_ops.rmdir(parent,name);FS.destroyNode(node);},readdir(path){var lookup=FS.lookupPath(path,{follow:true});var node=lookup.node;if(!node.node_ops.readdir){throw new FS.ErrnoError(54);}return node.node_ops.readdir(node);},unlink(path){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;if(!parent){throw new FS.ErrnoError(44);}var name=PATH.basename(path);var node=FS.lookupNode(parent,name);var errCode=FS.mayDelete(parent,name,false);if(errCode){throw new FS.ErrnoError(errCode);}if(!parent.node_ops.unlink){throw new FS.ErrnoError(63);}if(FS.isMountpoint(node)){throw new FS.ErrnoError(10);}parent.node_ops.unlink(parent,name);FS.destroyNode(node);},readlink(path){var lookup=FS.lookupPath(path);var link=lookup.node;if(!link){throw new FS.ErrnoError(44);}if(!link.node_ops.readlink){throw new FS.ErrnoError(28);}return PATH_FS.resolve(FS.getPath(link.parent),link.node_ops.readlink(link));},stat(path,dontFollow){var lookup=FS.lookupPath(path,{follow:!dontFollow});var node=lookup.node;if(!node){throw new FS.ErrnoError(44);}if(!node.node_ops.getattr){throw new FS.ErrnoError(63);}return node.node_ops.getattr(node);},lstat(path){return FS.stat(path,true);},chmod(path,mode,dontFollow){var node;if(typeof path=="string"){var lookup=FS.lookupPath(path,{follow:!dontFollow});node=lookup.node;}else{node=path;}if(!node.node_ops.setattr){throw new FS.ErrnoError(63);}node.node_ops.setattr(node,{mode:mode&4095|node.mode&~4095,timestamp:Date.now()});},lchmod(path,mode){FS.chmod(path,mode,true);},fchmod(fd,mode){var stream=FS.getStreamChecked(fd);FS.chmod(stream.node,mode);},chown(path,uid,gid,dontFollow){var node;if(typeof path=="string"){var lookup=FS.lookupPath(path,{follow:!dontFollow});node=lookup.node;}else{node=path;}if(!node.node_ops.setattr){throw new FS.ErrnoError(63);}node.node_ops.setattr(node,{timestamp:Date.now()});},lchown(path,uid,gid){FS.chown(path,uid,gid,true);},fchown(fd,uid,gid){var stream=FS.getStreamChecked(fd);FS.chown(stream.node,uid,gid);},truncate(path,len){if(len<0){throw new FS.ErrnoError(28);}var node;if(typeof path=="string"){var lookup=FS.lookupPath(path,{follow:true});node=lookup.node;}else{node=path;}if(!node.node_ops.setattr){throw new FS.ErrnoError(63);}if(FS.isDir(node.mode)){throw new FS.ErrnoError(31);}if(!FS.isFile(node.mode)){throw new FS.ErrnoError(28);}var errCode=FS.nodePermissions(node,"w");if(errCode){throw new FS.ErrnoError(errCode);}node.node_ops.setattr(node,{size:len,timestamp:Date.now()});},ftruncate(fd,len){var stream=FS.getStreamChecked(fd);if((stream.flags&2097155)===0){throw new FS.ErrnoError(28);}FS.truncate(stream.node,len);},utime(path,atime,mtime){var lookup=FS.lookupPath(path,{follow:true});var node=lookup.node;node.node_ops.setattr(node,{timestamp:Math.max(atime,mtime)});},open(path,flags,mode){if(path===""){throw new FS.ErrnoError(44);}flags=typeof flags=="string"?FS_modeStringToFlags(flags):flags;mode=typeof mode=="undefined"?438:mode;if(flags&64){mode=mode&4095|32768;}else{mode=0;}var node;if(typeof path=="object"){node=path;}else{path=PATH.normalize(path);try{var lookup=FS.lookupPath(path,{follow:!(flags&131072)});node=lookup.node;}catch(e){}}var created=false;if(flags&64){if(node){if(flags&128){throw new FS.ErrnoError(20);}}else{node=FS.mknod(path,mode,0);created=true;}}if(!node){throw new FS.ErrnoError(44);}if(FS.isChrdev(node.mode)){flags&=~512;}if(flags&65536&&!FS.isDir(node.mode)){throw new FS.ErrnoError(54);}if(!created){var errCode=FS.mayOpen(node,flags);if(errCode){throw new FS.ErrnoError(errCode);}}if(flags&512&&!created){FS.truncate(node,0);}flags&=~(128|512|131072);var stream=FS.createStream({node:node,path:FS.getPath(node),flags:flags,seekable:true,position:0,stream_ops:node.stream_ops,ungotten:[],error:false});if(stream.stream_ops.open){stream.stream_ops.open(stream);}if(Module["logReadFiles"]&&!(flags&1)){if(!FS.readFiles)FS.readFiles={};if(!(path in FS.readFiles)){FS.readFiles[path]=1;}}return stream;},close(stream){if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if(stream.getdents)stream.getdents=null;try{if(stream.stream_ops.close){stream.stream_ops.close(stream);}}catch(e){throw e;}finally{FS.closeStream(stream.fd);}stream.fd=null;},isClosed(stream){return stream.fd===null;},llseek(stream,offset,whence){if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if(!stream.seekable||!stream.stream_ops.llseek){throw new FS.ErrnoError(70);}if(whence!=0&&whence!=1&&whence!=2){throw new FS.ErrnoError(28);}stream.position=stream.stream_ops.llseek(stream,offset,whence);stream.ungotten=[];return stream.position;},read(stream,buffer,offset,length,position){if(length<0||position<0){throw new FS.ErrnoError(28);}if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if((stream.flags&2097155)===1){throw new FS.ErrnoError(8);}if(FS.isDir(stream.node.mode)){throw new FS.ErrnoError(31);}if(!stream.stream_ops.read){throw new FS.ErrnoError(28);}var seeking=typeof position!="undefined";if(!seeking){position=stream.position;}else if(!stream.seekable){throw new FS.ErrnoError(70);}var bytesRead=stream.stream_ops.read(stream,buffer,offset,length,position);if(!seeking)stream.position+=bytesRead;return bytesRead;},write(stream,buffer,offset,length,position,canOwn){if(length<0||position<0){throw new FS.ErrnoError(28);}if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if((stream.flags&2097155)===0){throw new FS.ErrnoError(8);}if(FS.isDir(stream.node.mode)){throw new FS.ErrnoError(31);}if(!stream.stream_ops.write){throw new FS.ErrnoError(28);}if(stream.seekable&&stream.flags&1024){FS.llseek(stream,0,2);}var seeking=typeof position!="undefined";if(!seeking){position=stream.position;}else if(!stream.seekable){throw new FS.ErrnoError(70);}var bytesWritten=stream.stream_ops.write(stream,buffer,offset,length,position,canOwn);if(!seeking)stream.position+=bytesWritten;return bytesWritten;},allocate(stream,offset,length){if(FS.isClosed(stream)){throw new FS.ErrnoError(8);}if(offset<0||length<=0){throw new FS.ErrnoError(28);}if((stream.flags&2097155)===0){throw new FS.ErrnoError(8);}if(!FS.isFile(stream.node.mode)&&!FS.isDir(stream.node.mode)){throw new FS.ErrnoError(43);}if(!stream.stream_ops.allocate){throw new FS.ErrnoError(138);}stream.stream_ops.allocate(stream,offset,length);},mmap(stream,length,position,prot,flags){if((prot&2)!==0&&(flags&2)===0&&(stream.flags&2097155)!==2){throw new FS.ErrnoError(2);}if((stream.flags&2097155)===1){throw new FS.ErrnoError(2);}if(!stream.stream_ops.mmap){throw new FS.ErrnoError(43);}return stream.stream_ops.mmap(stream,length,position,prot,flags);},msync(stream,buffer,offset,length,mmapFlags){if(!stream.stream_ops.msync){return 0;}return stream.stream_ops.msync(stream,buffer,offset,length,mmapFlags);},munmap:stream=>0,ioctl(stream,cmd,arg){if(!stream.stream_ops.ioctl){throw new FS.ErrnoError(59);}return stream.stream_ops.ioctl(stream,cmd,arg);},readFile(path,opts){if(opts===void 0){opts={};}opts.flags=opts.flags||0;opts.encoding=opts.encoding||"binary";if(opts.encoding!=="utf8"&&opts.encoding!=="binary"){throw new Error(`Invalid encoding type "${opts.encoding}"`);}var ret;var stream=FS.open(path,opts.flags);var stat=FS.stat(path);var length=stat.size;var buf=new Uint8Array(length);FS.read(stream,buf,0,length,0);if(opts.encoding==="utf8"){ret=UTF8ArrayToString(buf,0);}else if(opts.encoding==="binary"){ret=buf;}FS.close(stream);return ret;},writeFile(path,data,opts){if(opts===void 0){opts={};}opts.flags=opts.flags||577;var stream=FS.open(path,opts.flags,opts.mode);if(typeof data=="string"){var buf=new Uint8Array(lengthBytesUTF8(data)+1);var actualNumBytes=stringToUTF8Array(data,buf,0,buf.length);FS.write(stream,buf,0,actualNumBytes,undefined,opts.canOwn);}else if(ArrayBuffer.isView(data)){FS.write(stream,data,0,data.byteLength,undefined,opts.canOwn);}else{throw new Error("Unsupported data type");}FS.close(stream);},cwd:()=>FS.currentPath,chdir(path){var lookup=FS.lookupPath(path,{follow:true});if(lookup.node===null){throw new FS.ErrnoError(44);}if(!FS.isDir(lookup.node.mode)){throw new FS.ErrnoError(54);}var errCode=FS.nodePermissions(lookup.node,"x");if(errCode){throw new FS.ErrnoError(errCode);}FS.currentPath=lookup.path;},createDefaultDirectories(){FS.mkdir("/tmp");FS.mkdir("/home");FS.mkdir("/home/web_user");},createDefaultDevices(){FS.mkdir("/dev");FS.registerDevice(FS.makedev(1,3),{read:()=>0,write:(stream,buffer,offset,length,pos)=>length});FS.mkdev("/dev/null",FS.makedev(1,3));TTY.register(FS.makedev(5,0),TTY.default_tty_ops);TTY.register(FS.makedev(6,0),TTY.default_tty1_ops);FS.mkdev("/dev/tty",FS.makedev(5,0));FS.mkdev("/dev/tty1",FS.makedev(6,0));var randomBuffer=new Uint8Array(1024),randomLeft=0;var randomByte=()=>{if(randomLeft===0){randomLeft=randomFill(randomBuffer).byteLength;}return randomBuffer[--randomLeft];};FS.createDevice("/dev","random",randomByte);FS.createDevice("/dev","urandom",randomByte);FS.mkdir("/dev/shm");FS.mkdir("/dev/shm/tmp");},createSpecialDirectories(){FS.mkdir("/proc");var proc_self=FS.mkdir("/proc/self");FS.mkdir("/proc/self/fd");FS.mount({mount(){var node=FS.createNode(proc_self,"fd",16384|511,73);node.node_ops={lookup(parent,name){var fd=+name;var stream=FS.getStreamChecked(fd);var ret={parent:null,mount:{mountpoint:"fake"},node_ops:{readlink:()=>stream.path}};ret.parent=ret;return ret;}};return node;}},{},"/proc/self/fd");},createStandardStreams(){if(Module["stdin"]){FS.createDevice("/dev","stdin",Module["stdin"]);}else{FS.symlink("/dev/tty","/dev/stdin");}if(Module["stdout"]){FS.createDevice("/dev","stdout",null,Module["stdout"]);}else{FS.symlink("/dev/tty","/dev/stdout");}if(Module["stderr"]){FS.createDevice("/dev","stderr",null,Module["stderr"]);}else{FS.symlink("/dev/tty1","/dev/stderr");}var stdin=FS.open("/dev/stdin",0);var stdout=FS.open("/dev/stdout",1);var stderr=FS.open("/dev/stderr",1);},ensureErrnoError(){if(FS.ErrnoError)return;FS.ErrnoError=function ErrnoError(errno,node){this.name="ErrnoError";this.node=node;this.setErrno=function(errno){this.errno=errno;};this.setErrno(errno);this.message="FS error";};FS.ErrnoError.prototype=new Error();FS.ErrnoError.prototype.constructor=FS.ErrnoError;[44].forEach(code=>{FS.genericErrors[code]=new FS.ErrnoError(code);FS.genericErrors[code].stack="<generic error, no stack>";});},staticInit(){FS.ensureErrnoError();FS.nameTable=new Array(4096);FS.mount(MEMFS,{},"/");FS.createDefaultDirectories();FS.createDefaultDevices();FS.createSpecialDirectories();FS.filesystems={"MEMFS":MEMFS};},init(input,output,error){FS.init.initialized=true;FS.ensureErrnoError();Module["stdin"]=input||Module["stdin"];Module["stdout"]=output||Module["stdout"];Module["stderr"]=error||Module["stderr"];FS.createStandardStreams();},quit(){FS.init.initialized=false;_fflush(0);for(var i=0;i<FS.streams.length;i++){var stream=FS.streams[i];if(!stream){continue;}FS.close(stream);}},findObject(path,dontResolveLastLink){var ret=FS.analyzePath(path,dontResolveLastLink);if(!ret.exists){return null;}return ret.object;},analyzePath(path,dontResolveLastLink){try{var lookup=FS.lookupPath(path,{follow:!dontResolveLastLink});path=lookup.path;}catch(e){}var ret={isRoot:false,exists:false,error:0,name:null,path:null,object:null,parentExists:false,parentPath:null,parentObject:null};try{var lookup=FS.lookupPath(path,{parent:true});ret.parentExists=true;ret.parentPath=lookup.path;ret.parentObject=lookup.node;ret.name=PATH.basename(path);lookup=FS.lookupPath(path,{follow:!dontResolveLastLink});ret.exists=true;ret.path=lookup.path;ret.object=lookup.node;ret.name=lookup.node.name;ret.isRoot=lookup.path==="/";}catch(e){ret.error=e.errno;}return ret;},createPath(parent,path,canRead,canWrite){parent=typeof parent=="string"?parent:FS.getPath(parent);var parts=path.split("/").reverse();while(parts.length){var part=parts.pop();if(!part)continue;var current=PATH.join2(parent,part);try{FS.mkdir(current);}catch(e){}parent=current;}return current;},createFile(parent,name,properties,canRead,canWrite){var path=PATH.join2(typeof parent=="string"?parent:FS.getPath(parent),name);var mode=FS_getMode(canRead,canWrite);return FS.create(path,mode);},createDataFile(parent,name,data,canRead,canWrite,canOwn){var path=name;if(parent){parent=typeof parent=="string"?parent:FS.getPath(parent);path=name?PATH.join2(parent,name):parent;}var mode=FS_getMode(canRead,canWrite);var node=FS.create(path,mode);if(data){if(typeof data=="string"){var arr=new Array(data.length);for(var i=0,len=data.length;i<len;++i)arr[i]=data.charCodeAt(i);data=arr;}FS.chmod(node,mode|146);var stream=FS.open(node,577);FS.write(stream,data,0,data.length,0,canOwn);FS.close(stream);FS.chmod(node,mode);}},createDevice(parent,name,input,output){var path=PATH.join2(typeof parent=="string"?parent:FS.getPath(parent),name);var mode=FS_getMode(!!input,!!output);if(!FS.createDevice.major)FS.createDevice.major=64;var dev=FS.makedev(FS.createDevice.major++,0);FS.registerDevice(dev,{open(stream){stream.seekable=false;},close(stream){if(output&&output.buffer&&output.buffer.length){output(10);}},read(stream,buffer,offset,length,pos){var bytesRead=0;for(var i=0;i<length;i++){var result;try{result=input();}catch(e){throw new FS.ErrnoError(29);}if(result===undefined&&bytesRead===0){throw new FS.ErrnoError(6);}if(result===null||result===undefined)break;bytesRead++;buffer[offset+i]=result;}if(bytesRead){stream.node.timestamp=Date.now();}return bytesRead;},write(stream,buffer,offset,length,pos){for(var i=0;i<length;i++){try{output(buffer[offset+i]);}catch(e){throw new FS.ErrnoError(29);}}if(length){stream.node.timestamp=Date.now();}return i;}});return FS.mkdev(path,mode,dev);},forceLoadFile(obj){if(obj.isDevice||obj.isFolder||obj.link||obj.contents)return true;if(typeof XMLHttpRequest!="undefined"){throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");}else if(read_){try{obj.contents=intArrayFromString(read_(obj.url),true);obj.usedBytes=obj.contents.length;}catch(e){throw new FS.ErrnoError(29);}}else{throw new Error("Cannot load without read() or XMLHttpRequest.");}},createLazyFile(parent,name,url,canRead,canWrite){function LazyUint8Array(){this.lengthKnown=false;this.chunks=[];}LazyUint8Array.prototype.get=function LazyUint8Array_get(idx){if(idx>this.length-1||idx<0){return undefined;}var chunkOffset=idx%this.chunkSize;var chunkNum=idx/this.chunkSize|0;return this.getter(chunkNum)[chunkOffset];};LazyUint8Array.prototype.setDataGetter=function LazyUint8Array_setDataGetter(getter){this.getter=getter;};LazyUint8Array.prototype.cacheLength=function LazyUint8Array_cacheLength(){var xhr=new XMLHttpRequest();xhr.open("HEAD",url,false);xhr.send(null);if(!(xhr.status>=200&&xhr.status<300||xhr.status===304))throw new Error("Couldn't load "+url+". Status: "+xhr.status);var datalength=Number(xhr.getResponseHeader("Content-length"));var header;var hasByteServing=(header=xhr.getResponseHeader("Accept-Ranges"))&&header==="bytes";var usesGzip=(header=xhr.getResponseHeader("Content-Encoding"))&&header==="gzip";var chunkSize=1024*1024;if(!hasByteServing)chunkSize=datalength;var doXHR=(from,to)=>{if(from>to)throw new Error("invalid range ("+from+", "+to+") or no bytes requested!");if(to>datalength-1)throw new Error("only "+datalength+" bytes available! programmer error!");var xhr=new XMLHttpRequest();xhr.open("GET",url,false);if(datalength!==chunkSize)xhr.setRequestHeader("Range","bytes="+from+"-"+to);xhr.responseType="arraybuffer";if(xhr.overrideMimeType){xhr.overrideMimeType("text/plain; charset=x-user-defined");}xhr.send(null);if(!(xhr.status>=200&&xhr.status<300||xhr.status===304))throw new Error("Couldn't load "+url+". Status: "+xhr.status);if(xhr.response!==undefined){return new Uint8Array(xhr.response||[]);}return intArrayFromString(xhr.responseText||"",true);};var lazyArray=this;lazyArray.setDataGetter(chunkNum=>{var start=chunkNum*chunkSize;var end=(chunkNum+1)*chunkSize-1;end=Math.min(end,datalength-1);if(typeof lazyArray.chunks[chunkNum]=="undefined"){lazyArray.chunks[chunkNum]=doXHR(start,end);}if(typeof lazyArray.chunks[chunkNum]=="undefined")throw new Error("doXHR failed!");return lazyArray.chunks[chunkNum];});if(usesGzip||!datalength){chunkSize=datalength=1;datalength=this.getter(0).length;chunkSize=datalength;out("LazyFiles on gzip forces download of the whole file when length is accessed");}this._length=datalength;this._chunkSize=chunkSize;this.lengthKnown=true;};if(typeof XMLHttpRequest!="undefined"){if(!ENVIRONMENT_IS_WORKER)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var lazyArray=new LazyUint8Array();Object.defineProperties(lazyArray,{length:{get:function get(){if(!this.lengthKnown){this.cacheLength();}return this._length;}},chunkSize:{get:function get(){if(!this.lengthKnown){this.cacheLength();}return this._chunkSize;}}});var properties={isDevice:false,contents:lazyArray};}else{var properties={isDevice:false,url:url};}var node=FS.createFile(parent,name,properties,canRead,canWrite);if(properties.contents){node.contents=properties.contents;}else if(properties.url){node.contents=null;node.url=properties.url;}Object.defineProperties(node,{usedBytes:{get:function get(){return this.contents.length;}}});var stream_ops={};var keys=Object.keys(node.stream_ops);keys.forEach(key=>{var fn=node.stream_ops[key];stream_ops[key]=function forceLoadLazyFile(){FS.forceLoadFile(node);return fn.apply(null,arguments);};});function writeChunks(stream,buffer,offset,length,position){var contents=stream.node.contents;if(position>=contents.length)return 0;var size=Math.min(contents.length-position,length);if(contents.slice){for(var i=0;i<size;i++){buffer[offset+i]=contents[position+i];}}else{for(var i=0;i<size;i++){buffer[offset+i]=contents.get(position+i);}}return size;}stream_ops.read=(stream,buffer,offset,length,position)=>{FS.forceLoadFile(node);return writeChunks(stream,buffer,offset,length,position);};stream_ops.mmap=(stream,length,position,prot,flags)=>{FS.forceLoadFile(node);var ptr=mmapAlloc(length);if(!ptr){throw new FS.ErrnoError(48);}writeChunks(stream,HEAP8,ptr,length,position);return{ptr:ptr,allocated:true};};node.stream_ops=stream_ops;return node;}};var UTF8ToString=(ptr,maxBytesToRead)=>ptr?UTF8ArrayToString(HEAPU8,ptr,maxBytesToRead):"";var SYSCALLS={DEFAULT_POLLMASK:5,calculateAt(dirfd,path,allowEmpty){if(PATH.isAbs(path)){return path;}var dir;if(dirfd===-100){dir=FS.cwd();}else{var dirstream=SYSCALLS.getStreamFromFD(dirfd);dir=dirstream.path;}if(path.length==0){if(!allowEmpty){throw new FS.ErrnoError(44);}return dir;}return PATH.join2(dir,path);},doStat(func,path,buf){try{var stat=func(path);}catch(e){if(e&&e.node&&PATH.normalize(path)!==PATH.normalize(FS.getPath(e.node))){return-54;}throw e;}HEAP32[buf>>2]=stat.dev;HEAP32[buf+4>>2]=stat.mode;HEAPU32[buf+8>>2]=stat.nlink;HEAP32[buf+12>>2]=stat.uid;HEAP32[buf+16>>2]=stat.gid;HEAP32[buf+20>>2]=stat.rdev;tempI64=[stat.size>>>0,(tempDouble=stat.size,+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+24>>2]=tempI64[0],HEAP32[buf+28>>2]=tempI64[1];HEAP32[buf+32>>2]=4096;HEAP32[buf+36>>2]=stat.blocks;var atime=stat.atime.getTime();var mtime=stat.mtime.getTime();var ctime=stat.ctime.getTime();tempI64=[Math.floor(atime/1e3)>>>0,(tempDouble=Math.floor(atime/1e3),+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+40>>2]=tempI64[0],HEAP32[buf+44>>2]=tempI64[1];HEAPU32[buf+48>>2]=atime%1e3*1e3;tempI64=[Math.floor(mtime/1e3)>>>0,(tempDouble=Math.floor(mtime/1e3),+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+56>>2]=tempI64[0],HEAP32[buf+60>>2]=tempI64[1];HEAPU32[buf+64>>2]=mtime%1e3*1e3;tempI64=[Math.floor(ctime/1e3)>>>0,(tempDouble=Math.floor(ctime/1e3),+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+72>>2]=tempI64[0],HEAP32[buf+76>>2]=tempI64[1];HEAPU32[buf+80>>2]=ctime%1e3*1e3;tempI64=[stat.ino>>>0,(tempDouble=stat.ino,+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[buf+88>>2]=tempI64[0],HEAP32[buf+92>>2]=tempI64[1];return 0;},doMsync(addr,stream,len,flags,offset){if(!FS.isFile(stream.node.mode)){throw new FS.ErrnoError(43);}if(flags&2){return 0;}var buffer=HEAPU8.slice(addr,addr+len);FS.msync(stream,buffer,offset,len,flags);},varargs:undefined,get(){var ret=HEAP32[+SYSCALLS.varargs>>2];SYSCALLS.varargs+=4;return ret;},getp(){return SYSCALLS.get();},getStr(ptr){var ret=UTF8ToString(ptr);return ret;},getStreamFromFD(fd){var stream=FS.getStreamChecked(fd);return stream;}};var withStackSave=f=>{var stack=stackSave();var ret=f();stackRestore(stack);return ret;};var convertI32PairToI53Checked=(lo,hi)=>hi+2097152>>>0<4194305-!!lo?(lo>>>0)+hi*4294967296:NaN;var proxyToMainThread=function proxyToMainThread(index,sync){var numCallArgs=arguments.length-2;var outerArgs=arguments;return withStackSave(()=>{var serializedNumCallArgs=numCallArgs;var args=stackAlloc(serializedNumCallArgs*8);var b=args>>3;for(var i=0;i<numCallArgs;i++){var arg=outerArgs[2+i];HEAPF64[b+i]=arg;}return __emscripten_run_on_main_thread_js(index,serializedNumCallArgs,args,sync);});};function _proc_exit(code){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(0,1,code);EXITSTATUS=code;if(!keepRuntimeAlive()){PThread.terminateAllThreads();if(Module["onExit"])Module["onExit"](code);ABORT=true;}quit_(code,new ExitStatus(code));}var exitJS=(status,implicit)=>{EXITSTATUS=status;if(ENVIRONMENT_IS_PTHREAD){exitOnMainThread(status);throw"unwind";}if(!keepRuntimeAlive()){exitRuntime();}_proc_exit(status);};var _exit=exitJS;var handleException=e=>{if(e instanceof ExitStatus||e=="unwind"){return EXITSTATUS;}quit_(1,e);};var PThread={unusedWorkers:[],runningWorkers:[],tlsInitFunctions:[],pthreads:{},init(){if(ENVIRONMENT_IS_PTHREAD){PThread.initWorker();}else{PThread.initMainThread();}},initMainThread(){var pthreadPoolSize=4;while(pthreadPoolSize--){PThread.allocateUnusedWorker();}addOnPreRun(()=>{addRunDependency("loading-workers");PThread.loadWasmModuleToAllWorkers(()=>removeRunDependency("loading-workers"));});},initWorker(){noExitRuntime=false;},setExitStatus:status=>{EXITSTATUS=status;},terminateAllThreads__deps:["$terminateWorker"],terminateAllThreads:()=>{for(var _iterator=_createForOfIteratorHelperLoose(PThread.runningWorkers),_step;!(_step=_iterator()).done;){var worker=_step.value;terminateWorker(worker);}for(var _iterator2=_createForOfIteratorHelperLoose(PThread.unusedWorkers),_step2;!(_step2=_iterator2()).done;){var worker=_step2.value;terminateWorker(worker);}PThread.unusedWorkers=[];PThread.runningWorkers=[];PThread.pthreads=[];},returnWorkerToPool:worker=>{var pthread_ptr=worker.pthread_ptr;delete PThread.pthreads[pthread_ptr];PThread.unusedWorkers.push(worker);PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker),1);worker.pthread_ptr=0;__emscripten_thread_free_data(pthread_ptr);},receiveObjectTransfer(data){},threadInitTLS(){PThread.tlsInitFunctions.forEach(f=>f());},loadWasmModuleToWorker:worker=>new Promise(onFinishedLoading=>{worker.onmessage=e=>{var d=e["data"];var cmd=d["cmd"];if(d["targetThread"]&&d["targetThread"]!=_pthread_self()){var targetWorker=PThread.pthreads[d["targetThread"]];if(targetWorker){targetWorker.postMessage(d,d["transferList"]);}else{err(`Internal error! Worker sent a message "${cmd}" to target pthread ${d["targetThread"]}, but that thread no longer exists!`);}return;}if(cmd==="checkMailbox"){checkMailbox();}else if(cmd==="spawnThread"){spawnThread(d);}else if(cmd==="cleanupThread"){cleanupThread(d["thread"]);}else if(cmd==="killThread"){killThread(d["thread"]);}else if(cmd==="cancelThread"){cancelThread(d["thread"]);}else if(cmd==="loaded"){worker.loaded=true;onFinishedLoading(worker);}else if(cmd==="alert"){alert(`Thread ${d["threadId"]}: ${d["text"]}`);}else if(d.target==="setimmediate"){worker.postMessage(d);}else if(cmd==="callHandler"){Module[d["handler"]](...d["args"]);}else if(cmd){err(`worker sent an unknown command ${cmd}`);}};worker.onerror=e=>{var message="worker sent an error!";err(`${message} ${e.filename}:${e.lineno}: ${e.message}`);throw e;};var handlers=[];var knownHandlers=["onExit","onAbort","print","printErr"];for(var _i=0,_knownHandlers=knownHandlers;_i<_knownHandlers.length;_i++){var handler=_knownHandlers[_i];if(Module.hasOwnProperty(handler)){handlers.push(handler);}}worker.postMessage({"cmd":"load","handlers":handlers,"urlOrBlob":Module["mainScriptUrlOrBlob"],"wasmMemory":wasmMemory,"wasmModule":wasmModule});}),loadWasmModuleToAllWorkers(onMaybeReady){if(ENVIRONMENT_IS_PTHREAD){return onMaybeReady();}let pthreadPoolReady=Promise.all(PThread.unusedWorkers.map(PThread.loadWasmModuleToWorker));pthreadPoolReady.then(onMaybeReady);},allocateUnusedWorker(){var worker;if(!Module["locateFile"]){worker=new Worker(new URL("main-bin-multi.worker.js",location.href),{type:"module"});}else{var pthreadMainJs=locateFile("main-bin-multi.worker.js");worker=new Worker(pthreadMainJs,{type:"module"});}PThread.unusedWorkers.push(worker);},getNewWorker(){if(PThread.unusedWorkers.length==0){PThread.allocateUnusedWorker();PThread.loadWasmModuleToWorker(PThread.unusedWorkers[0]);}return PThread.unusedWorkers.pop();}};Module["PThread"]=PThread;var callRuntimeCallbacks=callbacks=>{while(callbacks.length>0){callbacks.shift()(Module);}};var establishStackSpace=()=>{var pthread_ptr=_pthread_self();var stackHigh=HEAPU32[pthread_ptr+52>>2];var stackSize=HEAPU32[pthread_ptr+56>>2];var stackLow=stackHigh-stackSize;_emscripten_stack_set_limits(stackHigh,stackLow);stackRestore(stackHigh);};Module["establishStackSpace"]=establishStackSpace;function exitOnMainThread(returnCode){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(1,0,returnCode);_exit(returnCode);}var wasmTableMirror=[];var wasmTable;var getWasmTableEntry=funcPtr=>{var func=wasmTableMirror[funcPtr];if(!func){if(funcPtr>=wasmTableMirror.length)wasmTableMirror.length=funcPtr+1;wasmTableMirror[funcPtr]=func=wasmTable.get(funcPtr);}return func;};var invokeEntryPoint=(ptr,arg)=>{runtimeKeepaliveCounter=0;var result=getWasmTableEntry(ptr)(arg);function finish(result){if(keepRuntimeAlive()){PThread.setExitStatus(result);}else{__emscripten_thread_exit(result);}}finish(result);};Module["invokeEntryPoint"]=invokeEntryPoint;var noExitRuntime=Module["noExitRuntime"]||false;var registerTLSInit=tlsInitFunc=>{PThread.tlsInitFunctions.push(tlsInitFunc);};var ___assert_fail=(condition,filename,line,func)=>{abort(`Assertion failed: ${UTF8ToString(condition)}, at: `+[filename?UTF8ToString(filename):"unknown filename",line,func?UTF8ToString(func):"unknown function"]);};var exceptionCaught=[];var uncaughtExceptionCount=0;var ___cxa_begin_catch=ptr=>{var info=new ExceptionInfo(ptr);if(!info.get_caught()){info.set_caught(true);uncaughtExceptionCount--;}info.set_rethrown(false);exceptionCaught.push(info);___cxa_increment_exception_refcount(info.excPtr);return info.get_exception_ptr();};var exceptionLast=0;var ___cxa_end_catch=()=>{_setThrew(0,0);var info=exceptionCaught.pop();___cxa_decrement_exception_refcount(info.excPtr);exceptionLast=0;};function ExceptionInfo(excPtr){this.excPtr=excPtr;this.ptr=excPtr-24;this.set_type=function(type){HEAPU32[this.ptr+4>>2]=type;};this.get_type=function(){return HEAPU32[this.ptr+4>>2];};this.set_destructor=function(destructor){HEAPU32[this.ptr+8>>2]=destructor;};this.get_destructor=function(){return HEAPU32[this.ptr+8>>2];};this.set_caught=function(caught){caught=caught?1:0;HEAP8[this.ptr+12>>0]=caught;};this.get_caught=function(){return HEAP8[this.ptr+12>>0]!=0;};this.set_rethrown=function(rethrown){rethrown=rethrown?1:0;HEAP8[this.ptr+13>>0]=rethrown;};this.get_rethrown=function(){return HEAP8[this.ptr+13>>0]!=0;};this.init=function(type,destructor){this.set_adjusted_ptr(0);this.set_type(type);this.set_destructor(destructor);};this.set_adjusted_ptr=function(adjustedPtr){HEAPU32[this.ptr+16>>2]=adjustedPtr;};this.get_adjusted_ptr=function(){return HEAPU32[this.ptr+16>>2];};this.get_exception_ptr=function(){var isPointer=___cxa_is_pointer_type(this.get_type());if(isPointer){return HEAPU32[this.excPtr>>2];}var adjusted=this.get_adjusted_ptr();if(adjusted!==0)return adjusted;return this.excPtr;};}var ___resumeException=ptr=>{if(!exceptionLast){exceptionLast=ptr;}throw exceptionLast;};var findMatchingCatch=args=>{var thrown=exceptionLast;if(!thrown){setTempRet0(0);return 0;}var info=new ExceptionInfo(thrown);info.set_adjusted_ptr(thrown);var thrownType=info.get_type();if(!thrownType){setTempRet0(0);return thrown;}for(var arg in args){var caughtType=args[arg];if(caughtType===0||caughtType===thrownType){break;}var adjusted_ptr_addr=info.ptr+16;if(___cxa_can_catch(caughtType,thrownType,adjusted_ptr_addr)){setTempRet0(caughtType);return thrown;}}setTempRet0(thrownType);return thrown;};var ___cxa_find_matching_catch_2=()=>findMatchingCatch([]);var ___cxa_find_matching_catch_3=arg0=>findMatchingCatch([arg0]);var ___cxa_rethrow=()=>{var info=exceptionCaught.pop();if(!info){abort("no exception to throw");}var ptr=info.excPtr;if(!info.get_rethrown()){exceptionCaught.push(info);info.set_rethrown(true);info.set_caught(false);uncaughtExceptionCount++;}exceptionLast=ptr;throw exceptionLast;};var ___cxa_throw=(ptr,type,destructor)=>{var info=new ExceptionInfo(ptr);info.init(type,destructor);exceptionLast=ptr;uncaughtExceptionCount++;throw exceptionLast;};var ___emscripten_init_main_thread_js=tb=>{__emscripten_thread_init(tb,!ENVIRONMENT_IS_WORKER,1,!ENVIRONMENT_IS_WEB,65536,false);PThread.threadInitTLS();};var ___emscripten_thread_cleanup=thread=>{if(!ENVIRONMENT_IS_PTHREAD)cleanupThread(thread);else postMessage({"cmd":"cleanupThread","thread":thread});};function pthreadCreateProxied(pthread_ptr,attr,startRoutine,arg){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(2,1,pthread_ptr,attr,startRoutine,arg);return ___pthread_create_js(pthread_ptr,attr,startRoutine,arg);}var ___pthread_create_js=(pthread_ptr,attr,startRoutine,arg)=>{if(typeof SharedArrayBuffer=="undefined"){err("Current environment does not support SharedArrayBuffer, pthreads are not available!");return 6;}var transferList=[];var error=0;if(ENVIRONMENT_IS_PTHREAD&&(transferList.length===0||error)){return pthreadCreateProxied(pthread_ptr,attr,startRoutine,arg);}if(error)return error;var threadParams={startRoutine:startRoutine,pthread_ptr:pthread_ptr,arg:arg,transferList:transferList};if(ENVIRONMENT_IS_PTHREAD){threadParams.cmd="spawnThread";postMessage(threadParams,transferList);return 0;}return spawnThread(threadParams);};var setErrNo=value=>{HEAP32[___errno_location()>>2]=value;return value;};function ___syscall_fcntl64(fd,cmd,varargs){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(3,1,fd,cmd,varargs);SYSCALLS.varargs=varargs;try{var stream=SYSCALLS.getStreamFromFD(fd);switch(cmd){case 0:{var arg=SYSCALLS.get();if(arg<0){return-28;}while(FS.streams[arg]){arg++;}var newStream;newStream=FS.createStream(stream,arg);return newStream.fd;}case 1:case 2:return 0;case 3:return stream.flags;case 4:{var arg=SYSCALLS.get();stream.flags|=arg;return 0;}case 5:{var arg=SYSCALLS.getp();var offset=0;HEAP16[arg+offset>>1]=2;return 0;}case 6:case 7:return 0;case 16:case 8:return-28;case 9:setErrNo(28);return-1;default:{return-28;}}}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_fstat64(fd,buf){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(4,1,fd,buf);try{var stream=SYSCALLS.getStreamFromFD(fd);return SYSCALLS.doStat(FS.stat,stream.path,buf);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_ftruncate64(fd,length_low,length_high){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(5,1,fd,length_low,length_high);var length=convertI32PairToI53Checked(length_low,length_high);try{if(isNaN(length))return 61;FS.ftruncate(fd,length);return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_ioctl(fd,op,varargs){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(6,1,fd,op,varargs);SYSCALLS.varargs=varargs;try{var stream=SYSCALLS.getStreamFromFD(fd);switch(op){case 21509:{if(!stream.tty)return-59;return 0;}case 21505:{if(!stream.tty)return-59;if(stream.tty.ops.ioctl_tcgets){var termios=stream.tty.ops.ioctl_tcgets(stream);var argp=SYSCALLS.getp();HEAP32[argp>>2]=termios.c_iflag||0;HEAP32[argp+4>>2]=termios.c_oflag||0;HEAP32[argp+8>>2]=termios.c_cflag||0;HEAP32[argp+12>>2]=termios.c_lflag||0;for(var i=0;i<32;i++){HEAP8[argp+i+17>>0]=termios.c_cc[i]||0;}return 0;}return 0;}case 21510:case 21511:case 21512:{if(!stream.tty)return-59;return 0;}case 21506:case 21507:case 21508:{if(!stream.tty)return-59;if(stream.tty.ops.ioctl_tcsets){var argp=SYSCALLS.getp();var c_iflag=HEAP32[argp>>2];var c_oflag=HEAP32[argp+4>>2];var c_cflag=HEAP32[argp+8>>2];var c_lflag=HEAP32[argp+12>>2];var c_cc=[];for(var i=0;i<32;i++){c_cc.push(HEAP8[argp+i+17>>0]);}return stream.tty.ops.ioctl_tcsets(stream.tty,op,{c_iflag:c_iflag,c_oflag:c_oflag,c_cflag:c_cflag,c_lflag:c_lflag,c_cc:c_cc});}return 0;}case 21519:{if(!stream.tty)return-59;var argp=SYSCALLS.getp();HEAP32[argp>>2]=0;return 0;}case 21520:{if(!stream.tty)return-59;return-28;}case 21531:{var argp=SYSCALLS.getp();return FS.ioctl(stream,op,argp);}case 21523:{if(!stream.tty)return-59;if(stream.tty.ops.ioctl_tiocgwinsz){var winsize=stream.tty.ops.ioctl_tiocgwinsz(stream.tty);var argp=SYSCALLS.getp();HEAP16[argp>>1]=winsize[0];HEAP16[argp+2>>1]=winsize[1];}return 0;}case 21524:{if(!stream.tty)return-59;return 0;}case 21515:{if(!stream.tty)return-59;return 0;}default:return-28;}}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_lstat64(path,buf){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(7,1,path,buf);try{path=SYSCALLS.getStr(path);return SYSCALLS.doStat(FS.lstat,path,buf);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_newfstatat(dirfd,path,buf,flags){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(8,1,dirfd,path,buf,flags);try{path=SYSCALLS.getStr(path);var nofollow=flags&256;var allowEmpty=flags&4096;flags=flags&~6400;path=SYSCALLS.calculateAt(dirfd,path,allowEmpty);return SYSCALLS.doStat(nofollow?FS.lstat:FS.stat,path,buf);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_openat(dirfd,path,flags,varargs){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(9,1,dirfd,path,flags,varargs);SYSCALLS.varargs=varargs;try{path=SYSCALLS.getStr(path);path=SYSCALLS.calculateAt(dirfd,path);var mode=varargs?SYSCALLS.get():0;return FS.open(path,flags,mode).fd;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}var stringToUTF8=(str,outPtr,maxBytesToWrite)=>stringToUTF8Array(str,HEAPU8,outPtr,maxBytesToWrite);function ___syscall_readlinkat(dirfd,path,buf,bufsize){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(10,1,dirfd,path,buf,bufsize);try{path=SYSCALLS.getStr(path);path=SYSCALLS.calculateAt(dirfd,path);if(bufsize<=0)return-28;var ret=FS.readlink(path);var len=Math.min(bufsize,lengthBytesUTF8(ret));var endChar=HEAP8[buf+len];stringToUTF8(ret,buf,bufsize+1);HEAP8[buf+len]=endChar;return len;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_renameat(olddirfd,oldpath,newdirfd,newpath){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(11,1,olddirfd,oldpath,newdirfd,newpath);try{oldpath=SYSCALLS.getStr(oldpath);newpath=SYSCALLS.getStr(newpath);oldpath=SYSCALLS.calculateAt(olddirfd,oldpath);newpath=SYSCALLS.calculateAt(newdirfd,newpath);FS.rename(oldpath,newpath);return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_stat64(path,buf){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(12,1,path,buf);try{path=SYSCALLS.getStr(path);return SYSCALLS.doStat(FS.stat,path,buf);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function ___syscall_unlinkat(dirfd,path,flags){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(13,1,dirfd,path,flags);try{path=SYSCALLS.getStr(path);path=SYSCALLS.calculateAt(dirfd,path);if(flags===0){FS.unlink(path);}else if(flags===512){FS.rmdir(path);}else{abort("Invalid flags passed to unlinkat");}return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}var __embind_register_bigint=(primitiveType,name,size,minRange,maxRange)=>{};var embind_init_charCodes=()=>{var codes=new Array(256);for(var i=0;i<256;++i){codes[i]=String.fromCharCode(i);}embind_charCodes=codes;};var embind_charCodes;var readLatin1String=ptr=>{var ret="";var c=ptr;while(HEAPU8[c]){ret+=embind_charCodes[HEAPU8[c++]];}return ret;};var awaitingDependencies={};var registeredTypes={};var typeDependencies={};var BindingError;var throwBindingError=message=>{throw new BindingError(message);};var InternalError;var throwInternalError=message=>{throw new InternalError(message);};var whenDependentTypesAreResolved=(myTypes,dependentTypes,getTypeConverters)=>{myTypes.forEach(function(type){typeDependencies[type]=dependentTypes;});function onComplete(typeConverters){var myTypeConverters=getTypeConverters(typeConverters);if(myTypeConverters.length!==myTypes.length){throwInternalError("Mismatched type converter count");}for(var i=0;i<myTypes.length;++i){registerType(myTypes[i],myTypeConverters[i]);}}var typeConverters=new Array(dependentTypes.length);var unregisteredTypes=[];var registered=0;dependentTypes.forEach((dt,i)=>{if(registeredTypes.hasOwnProperty(dt)){typeConverters[i]=registeredTypes[dt];}else{unregisteredTypes.push(dt);if(!awaitingDependencies.hasOwnProperty(dt)){awaitingDependencies[dt]=[];}awaitingDependencies[dt].push(()=>{typeConverters[i]=registeredTypes[dt];++registered;if(registered===unregisteredTypes.length){onComplete(typeConverters);}});}});if(0===unregisteredTypes.length){onComplete(typeConverters);}};function sharedRegisterType(rawType,registeredInstance,options){if(options===void 0){options={};}var name=registeredInstance.name;if(!rawType){throwBindingError(`type "${name}" must have a positive integer typeid pointer`);}if(registeredTypes.hasOwnProperty(rawType)){if(options.ignoreDuplicateRegistrations){return;}else{throwBindingError(`Cannot register type '${name}' twice`);}}registeredTypes[rawType]=registeredInstance;delete typeDependencies[rawType];if(awaitingDependencies.hasOwnProperty(rawType)){var callbacks=awaitingDependencies[rawType];delete awaitingDependencies[rawType];callbacks.forEach(cb=>cb());}}function registerType(rawType,registeredInstance,options){if(options===void 0){options={};}if(!("argPackAdvance"in registeredInstance)){throw new TypeError("registerType registeredInstance requires argPackAdvance");}return sharedRegisterType(rawType,registeredInstance,options);}var GenericWireTypeSize=8;var __embind_register_bool=(rawType,name,trueValue,falseValue)=>{name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":function fromWireType(wt){return!!wt;},"toWireType":function toWireType(destructors,o){return o?trueValue:falseValue;},"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":function readValueFromPointer(pointer){return this["fromWireType"](HEAPU8[pointer]);},destructorFunction:null});};var shallowCopyInternalPointer=o=>({count:o.count,deleteScheduled:o.deleteScheduled,preservePointerOnDelete:o.preservePointerOnDelete,ptr:o.ptr,ptrType:o.ptrType,smartPtr:o.smartPtr,smartPtrType:o.smartPtrType});var throwInstanceAlreadyDeleted=obj=>{function getInstanceTypeName(handle){return handle.$$.ptrType.registeredClass.name;}throwBindingError(getInstanceTypeName(obj)+" instance already deleted");};var finalizationRegistry=false;var detachFinalizer=handle=>{};var runDestructor=$$=>{if($$.smartPtr){$$.smartPtrType.rawDestructor($$.smartPtr);}else{$$.ptrType.registeredClass.rawDestructor($$.ptr);}};var releaseClassHandle=$$=>{$$.count.value-=1;var toDelete=0===$$.count.value;if(toDelete){runDestructor($$);}};var downcastPointer=(ptr,ptrClass,desiredClass)=>{if(ptrClass===desiredClass){return ptr;}if(undefined===desiredClass.baseClass){return null;}var rv=downcastPointer(ptr,ptrClass,desiredClass.baseClass);if(rv===null){return null;}return desiredClass.downcast(rv);};var registeredPointers={};var getInheritedInstanceCount=()=>Object.keys(registeredInstances).length;var getLiveInheritedInstances=()=>{var rv=[];for(var k in registeredInstances){if(registeredInstances.hasOwnProperty(k)){rv.push(registeredInstances[k]);}}return rv;};var deletionQueue=[];var flushPendingDeletes=()=>{while(deletionQueue.length){var obj=deletionQueue.pop();obj.$$.deleteScheduled=false;obj["delete"]();}};var delayFunction;var setDelayFunction=fn=>{delayFunction=fn;if(deletionQueue.length&&delayFunction){delayFunction(flushPendingDeletes);}};var init_embind=()=>{Module["getInheritedInstanceCount"]=getInheritedInstanceCount;Module["getLiveInheritedInstances"]=getLiveInheritedInstances;Module["flushPendingDeletes"]=flushPendingDeletes;Module["setDelayFunction"]=setDelayFunction;};var registeredInstances={};var getBasestPointer=(class_,ptr)=>{if(ptr===undefined){throwBindingError("ptr should not be undefined");}while(class_.baseClass){ptr=class_.upcast(ptr);class_=class_.baseClass;}return ptr;};var getInheritedInstance=(class_,ptr)=>{ptr=getBasestPointer(class_,ptr);return registeredInstances[ptr];};var makeClassHandle=(prototype,record)=>{if(!record.ptrType||!record.ptr){throwInternalError("makeClassHandle requires ptr and ptrType");}var hasSmartPtrType=!!record.smartPtrType;var hasSmartPtr=!!record.smartPtr;if(hasSmartPtrType!==hasSmartPtr){throwInternalError("Both smartPtrType and smartPtr must be specified");}record.count={value:1};return attachFinalizer(Object.create(prototype,{$$:{value:record}}));};function RegisteredPointer_fromWireType(ptr){var rawPointer=this.getPointee(ptr);if(!rawPointer){this.destructor(ptr);return null;}var registeredInstance=getInheritedInstance(this.registeredClass,rawPointer);if(undefined!==registeredInstance){if(0===registeredInstance.$$.count.value){registeredInstance.$$.ptr=rawPointer;registeredInstance.$$.smartPtr=ptr;return registeredInstance["clone"]();}else{var rv=registeredInstance["clone"]();this.destructor(ptr);return rv;}}function makeDefaultHandle(){if(this.isSmartPointer){return makeClassHandle(this.registeredClass.instancePrototype,{ptrType:this.pointeeType,ptr:rawPointer,smartPtrType:this,smartPtr:ptr});}else{return makeClassHandle(this.registeredClass.instancePrototype,{ptrType:this,ptr:ptr});}}var actualType=this.registeredClass.getActualType(rawPointer);var registeredPointerRecord=registeredPointers[actualType];if(!registeredPointerRecord){return makeDefaultHandle.call(this);}var toType;if(this.isConst){toType=registeredPointerRecord.constPointerType;}else{toType=registeredPointerRecord.pointerType;}var dp=downcastPointer(rawPointer,this.registeredClass,toType.registeredClass);if(dp===null){return makeDefaultHandle.call(this);}if(this.isSmartPointer){return makeClassHandle(toType.registeredClass.instancePrototype,{ptrType:toType,ptr:dp,smartPtrType:this,smartPtr:ptr});}else{return makeClassHandle(toType.registeredClass.instancePrototype,{ptrType:toType,ptr:dp});}}var attachFinalizer=handle=>{if("undefined"===typeof FinalizationRegistry){attachFinalizer=handle=>handle;return handle;}finalizationRegistry=new FinalizationRegistry(info=>{releaseClassHandle(info.$$);});attachFinalizer=handle=>{var $$=handle.$$;var hasSmartPtr=!!$$.smartPtr;if(hasSmartPtr){var info={$$:$$};finalizationRegistry.register(handle,info,handle);}return handle;};detachFinalizer=handle=>finalizationRegistry.unregister(handle);return attachFinalizer(handle);};var init_ClassHandle=()=>{Object.assign(ClassHandle.prototype,{"isAliasOf"(other){if(!(this instanceof ClassHandle)){return false;}if(!(other instanceof ClassHandle)){return false;}var leftClass=this.$$.ptrType.registeredClass;var left=this.$$.ptr;other.$$=other.$$;var rightClass=other.$$.ptrType.registeredClass;var right=other.$$.ptr;while(leftClass.baseClass){left=leftClass.upcast(left);leftClass=leftClass.baseClass;}while(rightClass.baseClass){right=rightClass.upcast(right);rightClass=rightClass.baseClass;}return leftClass===rightClass&&left===right;},"clone"(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.preservePointerOnDelete){this.$$.count.value+=1;return this;}else{var clone=attachFinalizer(Object.create(Object.getPrototypeOf(this),{$$:{value:shallowCopyInternalPointer(this.$$)}}));clone.$$.count.value+=1;clone.$$.deleteScheduled=false;return clone;}},"delete"(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete){throwBindingError("Object already scheduled for deletion");}detachFinalizer(this);releaseClassHandle(this.$$);if(!this.$$.preservePointerOnDelete){this.$$.smartPtr=undefined;this.$$.ptr=undefined;}},"isDeleted"(){return!this.$$.ptr;},"deleteLater"(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete){throwBindingError("Object already scheduled for deletion");}deletionQueue.push(this);if(deletionQueue.length===1&&delayFunction){delayFunction(flushPendingDeletes);}this.$$.deleteScheduled=true;return this;}});};function ClassHandle(){}var createNamedFunction=(name,body)=>Object.defineProperty(body,"name",{value:name});var ensureOverloadTable=(proto,methodName,humanName)=>{if(undefined===proto[methodName].overloadTable){var prevFunc=proto[methodName];proto[methodName]=function(){if(!proto[methodName].overloadTable.hasOwnProperty(arguments.length)){throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${arguments.length}) - expects one of (${proto[methodName].overloadTable})!`);}return proto[methodName].overloadTable[arguments.length].apply(this,arguments);};proto[methodName].overloadTable=[];proto[methodName].overloadTable[prevFunc.argCount]=prevFunc;}};var exposePublicSymbol=(name,value,numArguments)=>{if(Module.hasOwnProperty(name)){if(undefined===numArguments||undefined!==Module[name].overloadTable&&undefined!==Module[name].overloadTable[numArguments]){throwBindingError(`Cannot register public name '${name}' twice`);}ensureOverloadTable(Module,name,name);if(Module.hasOwnProperty(numArguments)){throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`);}Module[name].overloadTable[numArguments]=value;}else{Module[name]=value;if(undefined!==numArguments){Module[name].numArguments=numArguments;}}};var char_0=48;var char_9=57;var makeLegalFunctionName=name=>{if(undefined===name){return"_unknown";}name=name.replace(/[^a-zA-Z0-9_]/g,"$");var f=name.charCodeAt(0);if(f>=char_0&&f<=char_9){return`_${name}`;}return name;};function RegisteredClass(name,constructor,instancePrototype,rawDestructor,baseClass,getActualType,upcast,downcast){this.name=name;this.constructor=constructor;this.instancePrototype=instancePrototype;this.rawDestructor=rawDestructor;this.baseClass=baseClass;this.getActualType=getActualType;this.upcast=upcast;this.downcast=downcast;this.pureVirtualFunctions=[];}var upcastPointer=(ptr,ptrClass,desiredClass)=>{while(ptrClass!==desiredClass){if(!ptrClass.upcast){throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`);}ptr=ptrClass.upcast(ptr);ptrClass=ptrClass.baseClass;}return ptr;};function constNoSmartPtrRawPointerToWireType(destructors,handle){if(handle===null){if(this.isReference){throwBindingError(`null is not a valid ${this.name}`);}return 0;}if(!handle.$$){throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);}if(!handle.$$.ptr){throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);}var handleClass=handle.$$.ptrType.registeredClass;var ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);return ptr;}function genericPointerToWireType(destructors,handle){var ptr;if(handle===null){if(this.isReference){throwBindingError(`null is not a valid ${this.name}`);}if(this.isSmartPointer){ptr=this.rawConstructor();if(destructors!==null){destructors.push(this.rawDestructor,ptr);}return ptr;}else{return 0;}}if(!handle.$$){throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);}if(!handle.$$.ptr){throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);}if(!this.isConst&&handle.$$.ptrType.isConst){throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType?handle.$$.smartPtrType.name:handle.$$.ptrType.name} to parameter type ${this.name}`);}var handleClass=handle.$$.ptrType.registeredClass;ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);if(this.isSmartPointer){if(undefined===handle.$$.smartPtr){throwBindingError("Passing raw pointer to smart pointer is illegal");}switch(this.sharingPolicy){case 0:if(handle.$$.smartPtrType===this){ptr=handle.$$.smartPtr;}else{throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType?handle.$$.smartPtrType.name:handle.$$.ptrType.name} to parameter type ${this.name}`);}break;case 1:ptr=handle.$$.smartPtr;break;case 2:if(handle.$$.smartPtrType===this){ptr=handle.$$.smartPtr;}else{var clonedHandle=handle["clone"]();ptr=this.rawShare(ptr,Emval.toHandle(()=>clonedHandle["delete"]()));if(destructors!==null){destructors.push(this.rawDestructor,ptr);}}break;default:throwBindingError("Unsupporting sharing policy");}}return ptr;}function nonConstNoSmartPtrRawPointerToWireType(destructors,handle){if(handle===null){if(this.isReference){throwBindingError(`null is not a valid ${this.name}`);}return 0;}if(!handle.$$){throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);}if(!handle.$$.ptr){throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);}if(handle.$$.ptrType.isConst){throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`);}var handleClass=handle.$$.ptrType.registeredClass;var ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);return ptr;}function readPointer(pointer){return this["fromWireType"](HEAPU32[pointer>>2]);}var init_RegisteredPointer=()=>{Object.assign(RegisteredPointer.prototype,{getPointee(ptr){if(this.rawGetPointee){ptr=this.rawGetPointee(ptr);}return ptr;},destructor(ptr){if(this.rawDestructor){this.rawDestructor(ptr);}},"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":readPointer,"deleteObject"(handle){if(handle!==null){handle["delete"]();}},"fromWireType":RegisteredPointer_fromWireType});};function RegisteredPointer(name,registeredClass,isReference,isConst,isSmartPointer,pointeeType,sharingPolicy,rawGetPointee,rawConstructor,rawShare,rawDestructor){this.name=name;this.registeredClass=registeredClass;this.isReference=isReference;this.isConst=isConst;this.isSmartPointer=isSmartPointer;this.pointeeType=pointeeType;this.sharingPolicy=sharingPolicy;this.rawGetPointee=rawGetPointee;this.rawConstructor=rawConstructor;this.rawShare=rawShare;this.rawDestructor=rawDestructor;if(!isSmartPointer&&registeredClass.baseClass===undefined){if(isConst){this["toWireType"]=constNoSmartPtrRawPointerToWireType;this.destructorFunction=null;}else{this["toWireType"]=nonConstNoSmartPtrRawPointerToWireType;this.destructorFunction=null;}}else{this["toWireType"]=genericPointerToWireType;}}var replacePublicSymbol=(name,value,numArguments)=>{if(!Module.hasOwnProperty(name)){throwInternalError("Replacing nonexistant public symbol");}if(undefined!==Module[name].overloadTable&&undefined!==numArguments){Module[name].overloadTable[numArguments]=value;}else{Module[name]=value;Module[name].argCount=numArguments;}};var dynCallLegacy=(sig,ptr,args)=>{var f=Module["dynCall_"+sig];return args&&args.length?f.apply(null,[ptr].concat(args)):f.call(null,ptr);};var dynCall=(sig,ptr,args)=>{if(sig.includes("j")){return dynCallLegacy(sig,ptr,args);}var rtn=getWasmTableEntry(ptr).apply(null,args);return rtn;};var getDynCaller=(sig,ptr)=>{var argCache=[];return function(){argCache.length=0;Object.assign(argCache,arguments);return dynCall(sig,ptr,argCache);};};var embind__requireFunction=(signature,rawFunction)=>{signature=readLatin1String(signature);function makeDynCaller(){if(signature.includes("j")){return getDynCaller(signature,rawFunction);}return getWasmTableEntry(rawFunction);}var fp=makeDynCaller();if(typeof fp!="function"){throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`);}return fp;};var extendError=(baseErrorType,errorName)=>{var errorClass=createNamedFunction(errorName,function(message){this.name=errorName;this.message=message;var stack=new Error(message).stack;if(stack!==undefined){this.stack=this.toString()+"\n"+stack.replace(/^Error(:[^\n]*)?\n/,"");}});errorClass.prototype=Object.create(baseErrorType.prototype);errorClass.prototype.constructor=errorClass;errorClass.prototype.toString=function(){if(this.message===undefined){return this.name;}else{return`${this.name}: ${this.message}`;}};return errorClass;};var UnboundTypeError;var getTypeName=type=>{var ptr=___getTypeName(type);var rv=readLatin1String(ptr);_free(ptr);return rv;};var throwUnboundTypeError=(message,types)=>{var unboundTypes=[];var seen={};function visit(type){if(seen[type]){return;}if(registeredTypes[type]){return;}if(typeDependencies[type]){typeDependencies[type].forEach(visit);return;}unboundTypes.push(type);seen[type]=true;}types.forEach(visit);throw new UnboundTypeError(`${message}: `+unboundTypes.map(getTypeName).join([", "]));};var __embind_register_class=(rawType,rawPointerType,rawConstPointerType,baseClassRawType,getActualTypeSignature,getActualType,upcastSignature,upcast,downcastSignature,downcast,name,destructorSignature,rawDestructor)=>{name=readLatin1String(name);getActualType=embind__requireFunction(getActualTypeSignature,getActualType);if(upcast){upcast=embind__requireFunction(upcastSignature,upcast);}if(downcast){downcast=embind__requireFunction(downcastSignature,downcast);}rawDestructor=embind__requireFunction(destructorSignature,rawDestructor);var legalFunctionName=makeLegalFunctionName(name);exposePublicSymbol(legalFunctionName,function(){throwUnboundTypeError(`Cannot construct ${name} due to unbound types`,[baseClassRawType]);});whenDependentTypesAreResolved([rawType,rawPointerType,rawConstPointerType],baseClassRawType?[baseClassRawType]:[],function(base){base=base[0];var baseClass;var basePrototype;if(baseClassRawType){baseClass=base.registeredClass;basePrototype=baseClass.instancePrototype;}else{basePrototype=ClassHandle.prototype;}var constructor=createNamedFunction(name,function(){if(Object.getPrototypeOf(this)!==instancePrototype){throw new BindingError("Use 'new' to construct "+name);}if(undefined===registeredClass.constructor_body){throw new BindingError(name+" has no accessible constructor");}var body=registeredClass.constructor_body[arguments.length];if(undefined===body){throw new BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`);}return body.apply(this,arguments);});var instancePrototype=Object.create(basePrototype,{constructor:{value:constructor}});constructor.prototype=instancePrototype;var registeredClass=new RegisteredClass(name,constructor,instancePrototype,rawDestructor,baseClass,getActualType,upcast,downcast);if(registeredClass.baseClass){if(registeredClass.baseClass.__derivedClasses===undefined){registeredClass.baseClass.__derivedClasses=[];}registeredClass.baseClass.__derivedClasses.push(registeredClass);}var referenceConverter=new RegisteredPointer(name,registeredClass,true,false,false);var pointerConverter=new RegisteredPointer(name+"*",registeredClass,false,false,false);var constPointerConverter=new RegisteredPointer(name+" const*",registeredClass,false,true,false);registeredPointers[rawType]={pointerType:pointerConverter,constPointerType:constPointerConverter};replacePublicSymbol(legalFunctionName,constructor);return[referenceConverter,pointerConverter,constPointerConverter];});};var heap32VectorToArray=(count,firstElement)=>{var array=[];for(var i=0;i<count;i++){array.push(HEAPU32[firstElement+i*4>>2]);}return array;};var runDestructors=destructors=>{while(destructors.length){var ptr=destructors.pop();var del=destructors.pop();del(ptr);}};function newFunc(constructor,argumentList){if(!(constructor instanceof Function)){throw new TypeError(`new_ called with constructor type ${typeof constructor} which is not a function`);}var dummy=createNamedFunction(constructor.name||"unknownFunctionName",function(){});dummy.prototype=constructor.prototype;var obj=new dummy();var r=constructor.apply(obj,argumentList);return r instanceof Object?r:obj;}function craftInvokerFunction(humanName,argTypes,classType,cppInvokerFunc,cppTargetFunc,isAsync){var argCount=argTypes.length;if(argCount<2){throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");}var isClassMethodFunc=argTypes[1]!==null&&classType!==null;var needsDestructorStack=false;for(var i=1;i<argTypes.length;++i){if(argTypes[i]!==null&&argTypes[i].destructorFunction===undefined){needsDestructorStack=true;break;}}var returns=argTypes[0].name!=="void";var argsList="";var argsListWired="";for(var i=0;i<argCount-2;++i){argsList+=(i!==0?", ":"")+"arg"+i;argsListWired+=(i!==0?", ":"")+"arg"+i+"Wired";}var invokerFnBody=`\n        return function (${argsList}) {\n        if (arguments.length !== ${argCount-2}) {\n          throwBindingError('function ${humanName} called with ' + arguments.length + ' arguments, expected ${argCount-2}');\n        }`;if(needsDestructorStack){invokerFnBody+="var destructors = [];\n";}var dtorStack=needsDestructorStack?"destructors":"null";var args1=["throwBindingError","invoker","fn","runDestructors","retType","classParam"];var args2=[throwBindingError,cppInvokerFunc,cppTargetFunc,runDestructors,argTypes[0],argTypes[1]];if(isClassMethodFunc){invokerFnBody+="var thisWired = classParam.toWireType("+dtorStack+", this);\n";}for(var i=0;i<argCount-2;++i){invokerFnBody+="var arg"+i+"Wired = argType"+i+".toWireType("+dtorStack+", arg"+i+"); // "+argTypes[i+2].name+"\n";args1.push("argType"+i);args2.push(argTypes[i+2]);}if(isClassMethodFunc){argsListWired="thisWired"+(argsListWired.length>0?", ":"")+argsListWired;}invokerFnBody+=(returns||isAsync?"var rv = ":"")+"invoker(fn"+(argsListWired.length>0?", ":"")+argsListWired+");\n";if(needsDestructorStack){invokerFnBody+="runDestructors(destructors);\n";}else{for(var i=isClassMethodFunc?1:2;i<argTypes.length;++i){var paramName=i===1?"thisWired":"arg"+(i-2)+"Wired";if(argTypes[i].destructorFunction!==null){invokerFnBody+=paramName+"_dtor("+paramName+"); // "+argTypes[i].name+"\n";args1.push(paramName+"_dtor");args2.push(argTypes[i].destructorFunction);}}}if(returns){invokerFnBody+="var ret = retType.fromWireType(rv);\n"+"return ret;\n";}else{}invokerFnBody+="}\n";args1.push(invokerFnBody);var invokerFn=newFunc(Function,args1).apply(null,args2);return createNamedFunction(humanName,invokerFn);}var __embind_register_class_constructor=(rawClassType,argCount,rawArgTypesAddr,invokerSignature,invoker,rawConstructor)=>{var rawArgTypes=heap32VectorToArray(argCount,rawArgTypesAddr);invoker=embind__requireFunction(invokerSignature,invoker);whenDependentTypesAreResolved([],[rawClassType],function(classType){classType=classType[0];var humanName=`constructor ${classType.name}`;if(undefined===classType.registeredClass.constructor_body){classType.registeredClass.constructor_body=[];}if(undefined!==classType.registeredClass.constructor_body[argCount-1]){throw new BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount-1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);}classType.registeredClass.constructor_body[argCount-1]=()=>{throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`,rawArgTypes);};whenDependentTypesAreResolved([],rawArgTypes,argTypes=>{argTypes.splice(1,0,null);classType.registeredClass.constructor_body[argCount-1]=craftInvokerFunction(humanName,argTypes,null,invoker,rawConstructor);return[];});return[];});};var getFunctionName=signature=>{signature=signature.trim();const argsIndex=signature.indexOf("(");if(argsIndex!==-1){return signature.substr(0,argsIndex);}else{return signature;}};var __embind_register_class_function=(rawClassType,methodName,argCount,rawArgTypesAddr,invokerSignature,rawInvoker,context,isPureVirtual,isAsync)=>{var rawArgTypes=heap32VectorToArray(argCount,rawArgTypesAddr);methodName=readLatin1String(methodName);methodName=getFunctionName(methodName);rawInvoker=embind__requireFunction(invokerSignature,rawInvoker);whenDependentTypesAreResolved([],[rawClassType],function(classType){classType=classType[0];var humanName=`${classType.name}.${methodName}`;if(methodName.startsWith("@@")){methodName=Symbol[methodName.substring(2)];}if(isPureVirtual){classType.registeredClass.pureVirtualFunctions.push(methodName);}function unboundTypesHandler(){throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`,rawArgTypes);}var proto=classType.registeredClass.instancePrototype;var method=proto[methodName];if(undefined===method||undefined===method.overloadTable&&method.className!==classType.name&&method.argCount===argCount-2){unboundTypesHandler.argCount=argCount-2;unboundTypesHandler.className=classType.name;proto[methodName]=unboundTypesHandler;}else{ensureOverloadTable(proto,methodName,humanName);proto[methodName].overloadTable[argCount-2]=unboundTypesHandler;}whenDependentTypesAreResolved([],rawArgTypes,function(argTypes){var memberFunction=craftInvokerFunction(humanName,argTypes,classType,rawInvoker,context,isAsync);if(undefined===proto[methodName].overloadTable){memberFunction.argCount=argCount-2;proto[methodName]=memberFunction;}else{proto[methodName].overloadTable[argCount-2]=memberFunction;}return[];});return[];});};function handleAllocatorInit(){Object.assign(HandleAllocator.prototype,{get(id){return this.allocated[id];},has(id){return this.allocated[id]!==undefined;},allocate(handle){var id=this.freelist.pop()||this.allocated.length;this.allocated[id]=handle;return id;},free(id){this.allocated[id]=undefined;this.freelist.push(id);}});}function HandleAllocator(){this.allocated=[undefined];this.freelist=[];}var emval_handles=new HandleAllocator();var __emval_decref=handle=>{if(handle>=emval_handles.reserved&&0===--emval_handles.get(handle).refcount){emval_handles.free(handle);}};var count_emval_handles=()=>{var count=0;for(var i=emval_handles.reserved;i<emval_handles.allocated.length;++i){if(emval_handles.allocated[i]!==undefined){++count;}}return count;};var init_emval=()=>{emval_handles.allocated.push({value:undefined},{value:null},{value:true},{value:false});emval_handles.reserved=emval_handles.allocated.length;Module["count_emval_handles"]=count_emval_handles;};var Emval={toValue:handle=>{if(!handle){throwBindingError("Cannot use deleted val. handle = "+handle);}return emval_handles.get(handle).value;},toHandle:value=>{switch(value){case undefined:return 1;case null:return 2;case true:return 3;case false:return 4;default:{return emval_handles.allocate({refcount:1,value:value});}}}};function simpleReadValueFromPointer(pointer){return this["fromWireType"](HEAP32[pointer>>2]);}var __embind_register_emval=(rawType,name)=>{name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":handle=>{var rv=Emval.toValue(handle);__emval_decref(handle);return rv;},"toWireType":(destructors,value)=>Emval.toHandle(value),"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction:null});};var embindRepr=v=>{if(v===null){return"null";}var t=typeof v;if(t==="object"||t==="array"||t==="function"){return v.toString();}else{return""+v;}};var floatReadValueFromPointer=(name,width)=>{switch(width){case 4:return function(pointer){return this["fromWireType"](HEAPF32[pointer>>2]);};case 8:return function(pointer){return this["fromWireType"](HEAPF64[pointer>>3]);};default:throw new TypeError(`invalid float width (${width}): ${name}`);}};var __embind_register_float=(rawType,name,size)=>{name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":value=>value,"toWireType":(destructors,value)=>value,"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":floatReadValueFromPointer(name,size),destructorFunction:null});};var integerReadValueFromPointer=(name,width,signed)=>{switch(width){case 1:return signed?pointer=>HEAP8[pointer>>0]:pointer=>HEAPU8[pointer>>0];case 2:return signed?pointer=>HEAP16[pointer>>1]:pointer=>HEAPU16[pointer>>1];case 4:return signed?pointer=>HEAP32[pointer>>2]:pointer=>HEAPU32[pointer>>2];default:throw new TypeError(`invalid integer width (${width}): ${name}`);}};var __embind_register_integer=(primitiveType,name,size,minRange,maxRange)=>{name=readLatin1String(name);if(maxRange===-1){maxRange=4294967295;}var fromWireType=value=>value;if(minRange===0){var bitshift=32-8*size;fromWireType=value=>value<<bitshift>>>bitshift;}var isUnsignedType=name.includes("unsigned");var checkAssertions=(value,toTypeName)=>{};var toWireType;if(isUnsignedType){toWireType=function toWireType(destructors,value){checkAssertions(value,this.name);return value>>>0;};}else{toWireType=function toWireType(destructors,value){checkAssertions(value,this.name);return value;};}registerType(primitiveType,{name:name,"fromWireType":fromWireType,"toWireType":toWireType,"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":integerReadValueFromPointer(name,size,minRange!==0),destructorFunction:null});};var __embind_register_memory_view=(rawType,dataTypeIndex,name)=>{var typeMapping=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array];var TA=typeMapping[dataTypeIndex];function decodeMemoryView(handle){var size=HEAPU32[handle>>2];var data=HEAPU32[handle+4>>2];return new TA(HEAP8.buffer,data,size);}name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":decodeMemoryView,"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":decodeMemoryView},{ignoreDuplicateRegistrations:true});};var __embind_register_std_string=(rawType,name)=>{name=readLatin1String(name);var stdStringIsUTF8=name==="std::string";registerType(rawType,{name:name,"fromWireType"(value){var length=HEAPU32[value>>2];var payload=value+4;var str;if(stdStringIsUTF8){var decodeStartPtr=payload;for(var i=0;i<=length;++i){var currentBytePtr=payload+i;if(i==length||HEAPU8[currentBytePtr]==0){var maxRead=currentBytePtr-decodeStartPtr;var stringSegment=UTF8ToString(decodeStartPtr,maxRead);if(str===undefined){str=stringSegment;}else{str+=String.fromCharCode(0);str+=stringSegment;}decodeStartPtr=currentBytePtr+1;}}}else{var a=new Array(length);for(var i=0;i<length;++i){a[i]=String.fromCharCode(HEAPU8[payload+i]);}str=a.join("");}_free(value);return str;},"toWireType"(destructors,value){if(value instanceof ArrayBuffer){value=new Uint8Array(value);}var length;var valueIsOfTypeString=typeof value=="string";if(!(valueIsOfTypeString||value instanceof Uint8Array||value instanceof Uint8ClampedArray||value instanceof Int8Array)){throwBindingError("Cannot pass non-string to std::string");}if(stdStringIsUTF8&&valueIsOfTypeString){length=lengthBytesUTF8(value);}else{length=value.length;}var base=_malloc(4+length+1);var ptr=base+4;HEAPU32[base>>2]=length;if(stdStringIsUTF8&&valueIsOfTypeString){stringToUTF8(value,ptr,length+1);}else{if(valueIsOfTypeString){for(var i=0;i<length;++i){var charCode=value.charCodeAt(i);if(charCode>255){_free(ptr);throwBindingError("String has UTF-16 code units that do not fit in 8 bits");}HEAPU8[ptr+i]=charCode;}}else{for(var i=0;i<length;++i){HEAPU8[ptr+i]=value[i];}}}if(destructors!==null){destructors.push(_free,base);}return base;},"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":readPointer,destructorFunction(ptr){_free(ptr);}});};var UTF16Decoder=typeof TextDecoder!="undefined"?new TextDecoder("utf-16le"):undefined;var UTF16ToString=(ptr,maxBytesToRead)=>{var endPtr=ptr;var idx=endPtr>>1;var maxIdx=idx+maxBytesToRead/2;while(!(idx>=maxIdx)&&HEAPU16[idx])++idx;endPtr=idx<<1;if(endPtr-ptr>32&&UTF16Decoder)return UTF16Decoder.decode(HEAPU8.slice(ptr,endPtr));var str="";for(var i=0;!(i>=maxBytesToRead/2);++i){var codeUnit=HEAP16[ptr+i*2>>1];if(codeUnit==0)break;str+=String.fromCharCode(codeUnit);}return str;};var stringToUTF16=(str,outPtr,maxBytesToWrite)=>{if(maxBytesToWrite===undefined){maxBytesToWrite=2147483647;}if(maxBytesToWrite<2)return 0;maxBytesToWrite-=2;var startPtr=outPtr;var numCharsToWrite=maxBytesToWrite<str.length*2?maxBytesToWrite/2:str.length;for(var i=0;i<numCharsToWrite;++i){var codeUnit=str.charCodeAt(i);HEAP16[outPtr>>1]=codeUnit;outPtr+=2;}HEAP16[outPtr>>1]=0;return outPtr-startPtr;};var lengthBytesUTF16=str=>str.length*2;var UTF32ToString=(ptr,maxBytesToRead)=>{var i=0;var str="";while(!(i>=maxBytesToRead/4)){var utf32=HEAP32[ptr+i*4>>2];if(utf32==0)break;++i;if(utf32>=65536){var ch=utf32-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023);}else{str+=String.fromCharCode(utf32);}}return str;};var stringToUTF32=(str,outPtr,maxBytesToWrite)=>{if(maxBytesToWrite===undefined){maxBytesToWrite=2147483647;}if(maxBytesToWrite<4)return 0;var startPtr=outPtr;var endPtr=startPtr+maxBytesToWrite-4;for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);if(codeUnit>=55296&&codeUnit<=57343){var trailSurrogate=str.charCodeAt(++i);codeUnit=65536+((codeUnit&1023)<<10)|trailSurrogate&1023;}HEAP32[outPtr>>2]=codeUnit;outPtr+=4;if(outPtr+4>endPtr)break;}HEAP32[outPtr>>2]=0;return outPtr-startPtr;};var lengthBytesUTF32=str=>{var len=0;for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);if(codeUnit>=55296&&codeUnit<=57343)++i;len+=4;}return len;};var __embind_register_std_wstring=(rawType,charSize,name)=>{name=readLatin1String(name);var decodeString,encodeString,getHeap,lengthBytesUTF,shift;if(charSize===2){decodeString=UTF16ToString;encodeString=stringToUTF16;lengthBytesUTF=lengthBytesUTF16;getHeap=()=>HEAPU16;shift=1;}else if(charSize===4){decodeString=UTF32ToString;encodeString=stringToUTF32;lengthBytesUTF=lengthBytesUTF32;getHeap=()=>HEAPU32;shift=2;}registerType(rawType,{name:name,"fromWireType":value=>{var length=HEAPU32[value>>2];var HEAP=getHeap();var str;var decodeStartPtr=value+4;for(var i=0;i<=length;++i){var currentBytePtr=value+4+i*charSize;if(i==length||HEAP[currentBytePtr>>shift]==0){var maxReadBytes=currentBytePtr-decodeStartPtr;var stringSegment=decodeString(decodeStartPtr,maxReadBytes);if(str===undefined){str=stringSegment;}else{str+=String.fromCharCode(0);str+=stringSegment;}decodeStartPtr=currentBytePtr+charSize;}}_free(value);return str;},"toWireType":(destructors,value)=>{if(!(typeof value=="string")){throwBindingError(`Cannot pass non-string to C++ string type ${name}`);}var length=lengthBytesUTF(value);var ptr=_malloc(4+length+charSize);HEAPU32[ptr>>2]=length>>shift;encodeString(value,ptr+4,length+charSize);if(destructors!==null){destructors.push(_free,ptr);}return ptr;},"argPackAdvance":GenericWireTypeSize,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction(ptr){_free(ptr);}});};var __embind_register_void=(rawType,name)=>{name=readLatin1String(name);registerType(rawType,{isVoid:true,name:name,"argPackAdvance":0,"fromWireType":()=>undefined,"toWireType":(destructors,o)=>undefined});};var nowIsMonotonic=1;var __emscripten_get_now_is_monotonic=()=>nowIsMonotonic;var maybeExit=()=>{if(runtimeExited){return;}if(!keepRuntimeAlive()){try{if(ENVIRONMENT_IS_PTHREAD)__emscripten_thread_exit(EXITSTATUS);else _exit(EXITSTATUS);}catch(e){handleException(e);}}};var callUserCallback=func=>{if(runtimeExited||ABORT){return;}try{func();maybeExit();}catch(e){handleException(e);}};var __emscripten_thread_mailbox_await=pthread_ptr=>{if(typeof Atomics.waitAsync==="function"){var wait=Atomics.waitAsync(HEAP32,pthread_ptr>>2,pthread_ptr);wait.value.then(checkMailbox);var waitingAsync=pthread_ptr+128;Atomics.store(HEAP32,waitingAsync>>2,1);}};Module["__emscripten_thread_mailbox_await"]=__emscripten_thread_mailbox_await;var checkMailbox=()=>{var pthread_ptr=_pthread_self();if(pthread_ptr){__emscripten_thread_mailbox_await(pthread_ptr);callUserCallback(__emscripten_check_mailbox);}};Module["checkMailbox"]=checkMailbox;var __emscripten_notify_mailbox_postmessage=(targetThreadId,currThreadId,mainThreadId)=>{if(targetThreadId==currThreadId){setTimeout(()=>checkMailbox());}else if(ENVIRONMENT_IS_PTHREAD){postMessage({"targetThread":targetThreadId,"cmd":"checkMailbox"});}else{var worker=PThread.pthreads[targetThreadId];if(!worker){return;}worker.postMessage({"cmd":"checkMailbox"});}};var proxiedJSCallArgs=[];var __emscripten_receive_on_main_thread_js=(index,callingThread,numCallArgs,args)=>{proxiedJSCallArgs.length=numCallArgs;var b=args>>3;for(var i=0;i<numCallArgs;i++){proxiedJSCallArgs[i]=HEAPF64[b+i];}var func=proxiedFunctionTable[index];PThread.currentProxiedOperationCallerThread=callingThread;var rtn=func.apply(null,proxiedJSCallArgs);PThread.currentProxiedOperationCallerThread=0;return rtn;};var __emscripten_thread_set_strongref=thread=>{};var __emval_incref=handle=>{if(handle>4){emval_handles.get(handle).refcount+=1;}};var requireRegisteredType=(rawType,humanName)=>{var impl=registeredTypes[rawType];if(undefined===impl){throwBindingError(humanName+" has unknown type "+getTypeName(rawType));}return impl;};var __emval_take_value=(type,arg)=>{type=requireRegisteredType(type,"_emval_take_value");var v=type["readValueFromPointer"](arg);return Emval.toHandle(v);};function __mmap_js(len,prot,flags,fd,offset_low,offset_high,allocated,addr){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(14,1,len,prot,flags,fd,offset_low,offset_high,allocated,addr);var offset=convertI32PairToI53Checked(offset_low,offset_high);try{if(isNaN(offset))return 61;var stream=SYSCALLS.getStreamFromFD(fd);var res=FS.mmap(stream,len,offset,prot,flags);var ptr=res.ptr;HEAP32[allocated>>2]=res.allocated;HEAPU32[addr>>2]=ptr;return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}function __munmap_js(addr,len,prot,flags,fd,offset_low,offset_high){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(15,1,addr,len,prot,flags,fd,offset_low,offset_high);var offset=convertI32PairToI53Checked(offset_low,offset_high);try{if(isNaN(offset))return 61;var stream=SYSCALLS.getStreamFromFD(fd);if(prot&2){SYSCALLS.doMsync(addr,stream,len,flags,offset);}FS.munmap(stream);}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return-e.errno;}}var _abort=()=>{abort("");};var warnOnce=text=>{if(!warnOnce.shown)warnOnce.shown={};if(!warnOnce.shown[text]){warnOnce.shown[text]=1;err(text);}};var _emscripten_check_blocking_allowed=()=>{};var _emscripten_date_now=()=>Date.now();var runtimeKeepalivePush=()=>{runtimeKeepaliveCounter+=1;};var _emscripten_exit_with_live_runtime=()=>{runtimeKeepalivePush();throw"unwind";};var getHeapMax=()=>HEAPU8.length;var _emscripten_get_heap_max=()=>getHeapMax();var _emscripten_get_now;_emscripten_get_now=()=>performance.timeOrigin+performance.now();var _emscripten_num_logical_cores=()=>navigator["hardwareConcurrency"];var abortOnCannotGrowMemory=requestedSize=>{abort("OOM");};var _emscripten_resize_heap=requestedSize=>{var oldSize=HEAPU8.length;requestedSize>>>=0;abortOnCannotGrowMemory(requestedSize);};var ENV={};var getExecutableName=()=>thisProgram||"./this.program";var getEnvStrings=()=>{if(!getEnvStrings.strings){var lang=(typeof navigator=="object"&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8";var env={"USER":"web_user","LOGNAME":"web_user","PATH":"/","PWD":"/","HOME":"/home/web_user","LANG":lang,"_":getExecutableName()};for(var x in ENV){if(ENV[x]===undefined)delete env[x];else env[x]=ENV[x];}var strings=[];for(var x in env){strings.push(`${x}=${env[x]}`);}getEnvStrings.strings=strings;}return getEnvStrings.strings;};var stringToAscii=(str,buffer)=>{for(var i=0;i<str.length;++i){HEAP8[buffer++>>0]=str.charCodeAt(i);}HEAP8[buffer>>0]=0;};var _environ_get=function _environ_get(__environ,environ_buf){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(16,1,__environ,environ_buf);var bufSize=0;getEnvStrings().forEach((string,i)=>{var ptr=environ_buf+bufSize;HEAPU32[__environ+i*4>>2]=ptr;stringToAscii(string,ptr);bufSize+=string.length+1;});return 0;};var _environ_sizes_get=function _environ_sizes_get(penviron_count,penviron_buf_size){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(17,1,penviron_count,penviron_buf_size);var strings=getEnvStrings();HEAPU32[penviron_count>>2]=strings.length;var bufSize=0;strings.forEach(string=>bufSize+=string.length+1);HEAPU32[penviron_buf_size>>2]=bufSize;return 0;};function _fd_close(fd){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(18,1,fd);try{var stream=SYSCALLS.getStreamFromFD(fd);FS.close(stream);return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}var doReadv=(stream,iov,iovcnt,offset)=>{var ret=0;for(var i=0;i<iovcnt;i++){var ptr=HEAPU32[iov>>2];var len=HEAPU32[iov+4>>2];iov+=8;var curr=FS.read(stream,HEAP8,ptr,len,offset);if(curr<0)return-1;ret+=curr;if(curr<len)break;if(typeof offset!=="undefined"){offset+=curr;}}return ret;};function _fd_read(fd,iov,iovcnt,pnum){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(19,1,fd,iov,iovcnt,pnum);try{var stream=SYSCALLS.getStreamFromFD(fd);var num=doReadv(stream,iov,iovcnt);HEAPU32[pnum>>2]=num;return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}function _fd_seek(fd,offset_low,offset_high,whence,newOffset){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(20,1,fd,offset_low,offset_high,whence,newOffset);var offset=convertI32PairToI53Checked(offset_low,offset_high);try{if(isNaN(offset))return 61;var stream=SYSCALLS.getStreamFromFD(fd);FS.llseek(stream,offset,whence);tempI64=[stream.position>>>0,(tempDouble=stream.position,+Math.abs(tempDouble)>=1?tempDouble>0?+Math.floor(tempDouble/4294967296)>>>0:~~+Math.ceil((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)],HEAP32[newOffset>>2]=tempI64[0],HEAP32[newOffset+4>>2]=tempI64[1];if(stream.getdents&&offset===0&&whence===0)stream.getdents=null;return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}function _fd_sync(fd){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(21,1,fd);try{var stream=SYSCALLS.getStreamFromFD(fd);if(stream.stream_ops&&stream.stream_ops.fsync){return stream.stream_ops.fsync(stream);}return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}var doWritev=(stream,iov,iovcnt,offset)=>{var ret=0;for(var i=0;i<iovcnt;i++){var ptr=HEAPU32[iov>>2];var len=HEAPU32[iov+4>>2];iov+=8;var curr=FS.write(stream,HEAP8,ptr,len,offset);if(curr<0)return-1;ret+=curr;if(typeof offset!=="undefined"){offset+=curr;}}return ret;};function _fd_write(fd,iov,iovcnt,pnum){if(ENVIRONMENT_IS_PTHREAD)return proxyToMainThread(22,1,fd,iov,iovcnt,pnum);try{var stream=SYSCALLS.getStreamFromFD(fd);var num=doWritev(stream,iov,iovcnt);HEAPU32[pnum>>2]=num;return 0;}catch(e){if(typeof FS=="undefined"||!(e.name==="ErrnoError"))throw e;return e.errno;}}var _getentropy=(buffer,size)=>{randomFill(HEAPU8.subarray(buffer,buffer+size));return 0;};var isLeapYear=year=>year%4===0&&(year%100!==0||year%400===0);var arraySum=(array,index)=>{var sum=0;for(var i=0;i<=index;sum+=array[i++]){}return sum;};var MONTH_DAYS_LEAP=[31,29,31,30,31,30,31,31,30,31,30,31];var MONTH_DAYS_REGULAR=[31,28,31,30,31,30,31,31,30,31,30,31];var addDays=(date,days)=>{var newDate=new Date(date.getTime());while(days>0){var leap=isLeapYear(newDate.getFullYear());var currentMonth=newDate.getMonth();var daysInCurrentMonth=(leap?MONTH_DAYS_LEAP:MONTH_DAYS_REGULAR)[currentMonth];if(days>daysInCurrentMonth-newDate.getDate()){days-=daysInCurrentMonth-newDate.getDate()+1;newDate.setDate(1);if(currentMonth<11){newDate.setMonth(currentMonth+1);}else{newDate.setMonth(0);newDate.setFullYear(newDate.getFullYear()+1);}}else{newDate.setDate(newDate.getDate()+days);return newDate;}}return newDate;};var writeArrayToMemory=(array,buffer)=>{HEAP8.set(array,buffer);};var _strftime=(s,maxsize,format,tm)=>{var tm_zone=HEAPU32[tm+40>>2];var date={tm_sec:HEAP32[tm>>2],tm_min:HEAP32[tm+4>>2],tm_hour:HEAP32[tm+8>>2],tm_mday:HEAP32[tm+12>>2],tm_mon:HEAP32[tm+16>>2],tm_year:HEAP32[tm+20>>2],tm_wday:HEAP32[tm+24>>2],tm_yday:HEAP32[tm+28>>2],tm_isdst:HEAP32[tm+32>>2],tm_gmtoff:HEAP32[tm+36>>2],tm_zone:tm_zone?UTF8ToString(tm_zone):""};var pattern=UTF8ToString(format);var EXPANSION_RULES_1={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S","%Ec":"%c","%EC":"%C","%Ex":"%m/%d/%y","%EX":"%H:%M:%S","%Ey":"%y","%EY":"%Y","%Od":"%d","%Oe":"%e","%OH":"%H","%OI":"%I","%Om":"%m","%OM":"%M","%OS":"%S","%Ou":"%u","%OU":"%U","%OV":"%V","%Ow":"%w","%OW":"%W","%Oy":"%y"};for(var rule in EXPANSION_RULES_1){pattern=pattern.replace(new RegExp(rule,"g"),EXPANSION_RULES_1[rule]);}var WEEKDAYS=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];var MONTHS=["January","February","March","April","May","June","July","August","September","October","November","December"];function leadingSomething(value,digits,character){var str=typeof value=="number"?value.toString():value||"";while(str.length<digits){str=character[0]+str;}return str;}function leadingNulls(value,digits){return leadingSomething(value,digits,"0");}function compareByDay(date1,date2){function sgn(value){return value<0?-1:value>0?1:0;}var compare;if((compare=sgn(date1.getFullYear()-date2.getFullYear()))===0){if((compare=sgn(date1.getMonth()-date2.getMonth()))===0){compare=sgn(date1.getDate()-date2.getDate());}}return compare;}function getFirstWeekStartDate(janFourth){switch(janFourth.getDay()){case 0:return new Date(janFourth.getFullYear()-1,11,29);case 1:return janFourth;case 2:return new Date(janFourth.getFullYear(),0,3);case 3:return new Date(janFourth.getFullYear(),0,2);case 4:return new Date(janFourth.getFullYear(),0,1);case 5:return new Date(janFourth.getFullYear()-1,11,31);case 6:return new Date(janFourth.getFullYear()-1,11,30);}}function getWeekBasedYear(date){var thisDate=addDays(new Date(date.tm_year+1900,0,1),date.tm_yday);var janFourthThisYear=new Date(thisDate.getFullYear(),0,4);var janFourthNextYear=new Date(thisDate.getFullYear()+1,0,4);var firstWeekStartThisYear=getFirstWeekStartDate(janFourthThisYear);var firstWeekStartNextYear=getFirstWeekStartDate(janFourthNextYear);if(compareByDay(firstWeekStartThisYear,thisDate)<=0){if(compareByDay(firstWeekStartNextYear,thisDate)<=0){return thisDate.getFullYear()+1;}return thisDate.getFullYear();}return thisDate.getFullYear()-1;}var EXPANSION_RULES_2={"%a":date=>WEEKDAYS[date.tm_wday].substring(0,3),"%A":date=>WEEKDAYS[date.tm_wday],"%b":date=>MONTHS[date.tm_mon].substring(0,3),"%B":date=>MONTHS[date.tm_mon],"%C":date=>{var year=date.tm_year+1900;return leadingNulls(year/100|0,2);},"%d":date=>leadingNulls(date.tm_mday,2),"%e":date=>leadingSomething(date.tm_mday,2," "),"%g":date=>getWeekBasedYear(date).toString().substring(2),"%G":date=>getWeekBasedYear(date),"%H":date=>leadingNulls(date.tm_hour,2),"%I":date=>{var twelveHour=date.tm_hour;if(twelveHour==0)twelveHour=12;else if(twelveHour>12)twelveHour-=12;return leadingNulls(twelveHour,2);},"%j":date=>leadingNulls(date.tm_mday+arraySum(isLeapYear(date.tm_year+1900)?MONTH_DAYS_LEAP:MONTH_DAYS_REGULAR,date.tm_mon-1),3),"%m":date=>leadingNulls(date.tm_mon+1,2),"%M":date=>leadingNulls(date.tm_min,2),"%n":()=>"\n","%p":date=>{if(date.tm_hour>=0&&date.tm_hour<12){return"AM";}return"PM";},"%S":date=>leadingNulls(date.tm_sec,2),"%t":()=>"\t","%u":date=>date.tm_wday||7,"%U":date=>{var days=date.tm_yday+7-date.tm_wday;return leadingNulls(Math.floor(days/7),2);},"%V":date=>{var val=Math.floor((date.tm_yday+7-(date.tm_wday+6)%7)/7);if((date.tm_wday+371-date.tm_yday-2)%7<=2){val++;}if(!val){val=52;var dec31=(date.tm_wday+7-date.tm_yday-1)%7;if(dec31==4||dec31==5&&isLeapYear(date.tm_year%400-1)){val++;}}else if(val==53){var jan1=(date.tm_wday+371-date.tm_yday)%7;if(jan1!=4&&(jan1!=3||!isLeapYear(date.tm_year)))val=1;}return leadingNulls(val,2);},"%w":date=>date.tm_wday,"%W":date=>{var days=date.tm_yday+7-(date.tm_wday+6)%7;return leadingNulls(Math.floor(days/7),2);},"%y":date=>(date.tm_year+1900).toString().substring(2),"%Y":date=>date.tm_year+1900,"%z":date=>{var off=date.tm_gmtoff;var ahead=off>=0;off=Math.abs(off)/60;off=off/60*100+off%60;return(ahead?"+":"-")+String("0000"+off).slice(-4);},"%Z":date=>date.tm_zone,"%%":()=>"%"};pattern=pattern.replace(/%%/g,"\0\0");for(var rule in EXPANSION_RULES_2){if(pattern.includes(rule)){pattern=pattern.replace(new RegExp(rule,"g"),EXPANSION_RULES_2[rule](date));}}pattern=pattern.replace(/\0\0/g,"%");var bytes=intArrayFromString(pattern,false);if(bytes.length>maxsize){return 0;}writeArrayToMemory(bytes,s);return bytes.length-1;};var _strftime_l=(s,maxsize,format,tm,loc)=>_strftime(s,maxsize,format,tm);PThread.init();var FSNode=function FSNode(parent,name,mode,rdev){if(!parent){parent=this;}this.parent=parent;this.mount=parent.mount;this.mounted=null;this.id=FS.nextInode++;this.name=name;this.mode=mode;this.node_ops={};this.stream_ops={};this.rdev=rdev;};var readMode=292|73;var writeMode=146;Object.defineProperties(FSNode.prototype,{read:{get:function get(){return(this.mode&readMode)===readMode;},set:function set(val){val?this.mode|=readMode:this.mode&=~readMode;}},write:{get:function get(){return(this.mode&writeMode)===writeMode;},set:function set(val){val?this.mode|=writeMode:this.mode&=~writeMode;}},isFolder:{get:function get(){return FS.isDir(this.mode);}},isDevice:{get:function get(){return FS.isChrdev(this.mode);}}});FS.FSNode=FSNode;FS.createPreloadedFile=FS_createPreloadedFile;FS.staticInit();embind_init_charCodes();BindingError=Module["BindingError"]=/*#__PURE__*/function(_Error3){(0,_inheritsLoose2.default)(BindingError,_Error3);function BindingError(message){var _this3;_this3=_Error3.call(this,message)||this;_this3.name="BindingError";return _this3;}return BindingError;}(/*#__PURE__*/(0,_wrapNativeSuper2.default)(Error));InternalError=Module["InternalError"]=/*#__PURE__*/function(_Error4){(0,_inheritsLoose2.default)(InternalError,_Error4);function InternalError(message){var _this4;_this4=_Error4.call(this,message)||this;_this4.name="InternalError";return _this4;}return InternalError;}(/*#__PURE__*/(0,_wrapNativeSuper2.default)(Error));init_ClassHandle();init_embind();init_RegisteredPointer();UnboundTypeError=Module["UnboundTypeError"]=extendError(Error,"UnboundTypeError");handleAllocatorInit();init_emval();var proxiedFunctionTable=[_proc_exit,exitOnMainThread,pthreadCreateProxied,___syscall_fcntl64,___syscall_fstat64,___syscall_ftruncate64,___syscall_ioctl,___syscall_lstat64,___syscall_newfstatat,___syscall_openat,___syscall_readlinkat,___syscall_renameat,___syscall_stat64,___syscall_unlinkat,__mmap_js,__munmap_js,_environ_get,_environ_sizes_get,_fd_close,_fd_read,_fd_seek,_fd_sync,_fd_write];var wasmImports={b:___assert_fail,w:___cxa_begin_catch,v:___cxa_end_catch,d:___cxa_find_matching_catch_2,k:___cxa_find_matching_catch_3,ya:___cxa_rethrow,n:___cxa_throw,ia:___emscripten_init_main_thread_js,E:___emscripten_thread_cleanup,fa:___pthread_create_js,h:___resumeException,oa:___syscall_fstat64,W:___syscall_ftruncate64,ma:___syscall_newfstatat,pa:___syscall_openat,ea:___syscall_readlinkat,da:___syscall_renameat,na:___syscall_stat64,aa:___syscall_unlinkat,X:__embind_register_bigint,ua:__embind_register_bool,S:__embind_register_class,R:__embind_register_class_constructor,m:__embind_register_class_function,ta:__embind_register_emval,K:__embind_register_float,q:__embind_register_integer,l:__embind_register_memory_view,J:__embind_register_std_string,B:__embind_register_std_wstring,va:__embind_register_void,sa:__emscripten_get_now_is_monotonic,ba:__emscripten_notify_mailbox_postmessage,ga:__emscripten_receive_on_main_thread_js,ha:__emscripten_thread_mailbox_await,ra:__emscripten_thread_set_strongref,Ca:__emval_decref,Da:__emval_incref,s:__emval_take_value,T:__mmap_js,U:__munmap_js,c:_abort,F:_emscripten_check_blocking_allowed,H:_emscripten_date_now,qa:_emscripten_exit_with_live_runtime,ca:_emscripten_get_heap_max,p:_emscripten_get_now,M:_emscripten_num_logical_cores,$:_emscripten_resize_heap,ja:_environ_get,ka:_environ_sizes_get,L:_exit,I:_fd_close,G:_fd_read,V:_fd_seek,la:_fd_sync,A:_fd_write,Z:_getentropy,Ba:invoke_fi,D:invoke_i,g:invoke_ii,xa:invoke_iidii,Aa:invoke_iif,e:invoke_iii,f:invoke_iiii,z:invoke_iiiii,y:invoke_iiiiii,Q:invoke_iiiiiii,Y:invoke_iij,r:invoke_v,j:invoke_vi,i:invoke_vii,t:invoke_viid,C:invoke_viidi,o:invoke_viii,za:invoke_viiidiii,u:invoke_viiii,O:invoke_viiiidi,P:invoke_viiiii,x:invoke_viiiiiiidi,N:invoke_viiiiiiii,a:wasmMemory||Module["wasmMemory"],_:_strftime_l,wa:xnnLoadWasmModuleJS};var wasmExports=createWasm();var ___wasm_call_ctors=()=>(___wasm_call_ctors=wasmExports["Ea"])();var _pthread_self=Module["_pthread_self"]=()=>(_pthread_self=Module["_pthread_self"]=wasmExports["Fa"])();var _malloc=a0=>(_malloc=wasmExports["Ha"])(a0);var _free=a0=>(_free=wasmExports["Ia"])(a0);var ___errno_location=()=>(___errno_location=wasmExports["Ja"])();var __emscripten_tls_init=Module["__emscripten_tls_init"]=()=>(__emscripten_tls_init=Module["__emscripten_tls_init"]=wasmExports["Ka"])();var _emscripten_builtin_memalign=(a0,a1)=>(_emscripten_builtin_memalign=wasmExports["La"])(a0,a1);var ___getTypeName=a0=>(___getTypeName=wasmExports["Ma"])(a0);var __embind_initialize_bindings=Module["__embind_initialize_bindings"]=()=>(__embind_initialize_bindings=Module["__embind_initialize_bindings"]=wasmExports["Na"])();var ___funcs_on_exit=()=>(___funcs_on_exit=wasmExports["Oa"])();var __emscripten_thread_init=Module["__emscripten_thread_init"]=(a0,a1,a2,a3,a4,a5)=>(__emscripten_thread_init=Module["__emscripten_thread_init"]=wasmExports["Pa"])(a0,a1,a2,a3,a4,a5);var __emscripten_thread_crashed=Module["__emscripten_thread_crashed"]=()=>(__emscripten_thread_crashed=Module["__emscripten_thread_crashed"]=wasmExports["Qa"])();var _emscripten_main_thread_process_queued_calls=()=>(_emscripten_main_thread_process_queued_calls=wasmExports["emscripten_main_thread_process_queued_calls"])();var _fflush=Module["_fflush"]=a0=>(_fflush=Module["_fflush"]=wasmExports["Ra"])(a0);var _emscripten_main_runtime_thread_id=()=>(_emscripten_main_runtime_thread_id=wasmExports["emscripten_main_runtime_thread_id"])();var __emscripten_run_on_main_thread_js=(a0,a1,a2,a3)=>(__emscripten_run_on_main_thread_js=wasmExports["Sa"])(a0,a1,a2,a3);var __emscripten_thread_free_data=a0=>(__emscripten_thread_free_data=wasmExports["Ta"])(a0);var __emscripten_thread_exit=Module["__emscripten_thread_exit"]=a0=>(__emscripten_thread_exit=Module["__emscripten_thread_exit"]=wasmExports["Ua"])(a0);var __emscripten_check_mailbox=()=>(__emscripten_check_mailbox=wasmExports["Va"])();var _setThrew=(a0,a1)=>(_setThrew=wasmExports["Wa"])(a0,a1);var setTempRet0=a0=>(setTempRet0=wasmExports["Xa"])(a0);var _emscripten_stack_set_limits=(a0,a1)=>(_emscripten_stack_set_limits=wasmExports["Ya"])(a0,a1);var stackSave=()=>(stackSave=wasmExports["Za"])();var stackRestore=a0=>(stackRestore=wasmExports["_a"])(a0);var stackAlloc=a0=>(stackAlloc=wasmExports["$a"])(a0);var ___cxa_decrement_exception_refcount=a0=>(___cxa_decrement_exception_refcount=wasmExports["ab"])(a0);var ___cxa_increment_exception_refcount=a0=>(___cxa_increment_exception_refcount=wasmExports["bb"])(a0);var ___cxa_can_catch=(a0,a1,a2)=>(___cxa_can_catch=wasmExports["cb"])(a0,a1,a2);var ___cxa_is_pointer_type=a0=>(___cxa_is_pointer_type=wasmExports["db"])(a0);var dynCall_viijj=Module["dynCall_viijj"]=(a0,a1,a2,a3,a4,a5,a6)=>(dynCall_viijj=Module["dynCall_viijj"]=wasmExports["eb"])(a0,a1,a2,a3,a4,a5,a6);var dynCall_viiijjj=Module["dynCall_viiijjj"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9)=>(dynCall_viiijjj=Module["dynCall_viiijjj"]=wasmExports["fb"])(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9);var dynCall_iiiij=Module["dynCall_iiiij"]=(a0,a1,a2,a3,a4,a5)=>(dynCall_iiiij=Module["dynCall_iiiij"]=wasmExports["gb"])(a0,a1,a2,a3,a4,a5);var dynCall_jii=Module["dynCall_jii"]=(a0,a1,a2)=>(dynCall_jii=Module["dynCall_jii"]=wasmExports["hb"])(a0,a1,a2);var dynCall_jjj=Module["dynCall_jjj"]=(a0,a1,a2,a3,a4)=>(dynCall_jjj=Module["dynCall_jjj"]=wasmExports["ib"])(a0,a1,a2,a3,a4);var dynCall_iiiijj=Module["dynCall_iiiijj"]=(a0,a1,a2,a3,a4,a5,a6,a7)=>(dynCall_iiiijj=Module["dynCall_iiiijj"]=wasmExports["jb"])(a0,a1,a2,a3,a4,a5,a6,a7);var dynCall_viijji=Module["dynCall_viijji"]=(a0,a1,a2,a3,a4,a5,a6,a7)=>(dynCall_viijji=Module["dynCall_viijji"]=wasmExports["kb"])(a0,a1,a2,a3,a4,a5,a6,a7);var dynCall_iiijj=Module["dynCall_iiijj"]=(a0,a1,a2,a3,a4,a5,a6)=>(dynCall_iiijj=Module["dynCall_iiijj"]=wasmExports["lb"])(a0,a1,a2,a3,a4,a5,a6);var dynCall_viijjj=Module["dynCall_viijjj"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8)=>(dynCall_viijjj=Module["dynCall_viijjj"]=wasmExports["mb"])(a0,a1,a2,a3,a4,a5,a6,a7,a8);var dynCall_iij=Module["dynCall_iij"]=(a0,a1,a2,a3)=>(dynCall_iij=Module["dynCall_iij"]=wasmExports["nb"])(a0,a1,a2,a3);var dynCall_iijjiiii=Module["dynCall_iijjiiii"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9)=>(dynCall_iijjiiii=Module["dynCall_iijjiiii"]=wasmExports["ob"])(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9);var dynCall_jiji=Module["dynCall_jiji"]=(a0,a1,a2,a3,a4)=>(dynCall_jiji=Module["dynCall_jiji"]=wasmExports["pb"])(a0,a1,a2,a3,a4);var dynCall_viijii=Module["dynCall_viijii"]=(a0,a1,a2,a3,a4,a5,a6)=>(dynCall_viijii=Module["dynCall_viijii"]=wasmExports["qb"])(a0,a1,a2,a3,a4,a5,a6);var dynCall_iiiiij=Module["dynCall_iiiiij"]=(a0,a1,a2,a3,a4,a5,a6)=>(dynCall_iiiiij=Module["dynCall_iiiiij"]=wasmExports["rb"])(a0,a1,a2,a3,a4,a5,a6);var dynCall_iiiiijj=Module["dynCall_iiiiijj"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8)=>(dynCall_iiiiijj=Module["dynCall_iiiiijj"]=wasmExports["sb"])(a0,a1,a2,a3,a4,a5,a6,a7,a8);var dynCall_iiiiiijj=Module["dynCall_iiiiiijj"]=(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9)=>(dynCall_iiiiiijj=Module["dynCall_iiiiiijj"]=wasmExports["tb"])(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9);var ___start_em_js=Module["___start_em_js"]=262148;var ___stop_em_js=Module["___stop_em_js"]=262760;function invoke_ii(index,a1){var sp=stackSave();try{return getWasmTableEntry(index)(a1);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iii(index,a1,a2){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_vii(index,a1,a2){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_vi(index,a1){var sp=stackSave();try{getWasmTableEntry(index)(a1);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiii(index,a1,a2,a3,a4){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iiiiii(index,a1,a2,a3,a4,a5){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3,a4,a5);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iiii(index,a1,a2,a3){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_i(index){var sp=stackSave();try{return getWasmTableEntry(index)();}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_fi(index,a1){var sp=stackSave();try{return getWasmTableEntry(index)(a1);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iif(index,a1,a2){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iiiiiii(index,a1,a2,a3,a4,a5,a6){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_v(index){var sp=stackSave();try{getWasmTableEntry(index)();}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiiii(index,a1,a2,a3,a4,a5){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiiiiiidi(index,a1,a2,a3,a4,a5,a6,a7,a8,a9){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6,a7,a8,a9);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viii(index,a1,a2,a3){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiiidi(index,a1,a2,a3,a4,a5,a6){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiidiii(index,a1,a2,a3,a4,a5,a6,a7){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6,a7);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viid(index,a1,a2,a3){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4,a5,a6,a7,a8);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iiiii(index,a1,a2,a3,a4){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3,a4);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_viidi(index,a1,a2,a3,a4){var sp=stackSave();try{getWasmTableEntry(index)(a1,a2,a3,a4);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iidii(index,a1,a2,a3,a4){var sp=stackSave();try{return getWasmTableEntry(index)(a1,a2,a3,a4);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}function invoke_iij(index,a1,a2,a3){var sp=stackSave();try{return dynCall_iij(index,a1,a2,a3);}catch(e){stackRestore(sp);if(e!==e+0)throw e;_setThrew(1,0);}}Module["wasmMemory"]=wasmMemory;Module["keepRuntimeAlive"]=keepRuntimeAlive;Module["ExitStatus"]=ExitStatus;Module["PThread"]=PThread;var calledRun;dependenciesFulfilled=function runCaller(){if(!calledRun)run();if(!calledRun)dependenciesFulfilled=runCaller;};function run(){if(runDependencies>0){return;}if(ENVIRONMENT_IS_PTHREAD){readyPromiseResolve(Module);initRuntime();startWorker(Module);return;}preRun();if(runDependencies>0){return;}function doRun(){if(calledRun)return;calledRun=true;Module["calledRun"]=true;if(ABORT)return;initRuntime();readyPromiseResolve(Module);if(Module["onRuntimeInitialized"])Module["onRuntimeInitialized"]();postRun();}if(Module["setStatus"]){Module["setStatus"]("Running...");setTimeout(function(){setTimeout(function(){Module["setStatus"]("");},1);doRun();},1);}else{doRun();}}if(Module["preInit"]){if(typeof Module["preInit"]=="function")Module["preInit"]=[Module["preInit"]];while(Module["preInit"].length>0){Module["preInit"].pop()();}}run();return moduleArg.ready;};})();;createWasmMultiInstance=Module;}let l=function l(){};l.updates={transformer_new:"New transformer",transformer_null:"Null transformer"};l.errors={transformer_none:"No transformers provided",transformer_start:"Cannot start transformer",transformer_transform:"Cannot transform frame",transformer_flush:"Cannot flush transformer",readable_null:"Readable is null",writable_null:"Writable is null"};function j(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t;}const f=/* @__PURE__ */new WeakMap(),T=/* @__PURE__ */new WeakMap(),g=/* @__PURE__ */new WeakMap(),C=Symbol("anyProducer"),U=Promise.resolve(),S=Symbol("listenerAdded"),R=Symbol("listenerRemoved");let A=false;function p(t){if(typeof t!="string"&&typeof t!="symbol")throw new TypeError("eventName must be a string or a symbol");}function b(t){if(typeof t!="function")throw new TypeError("listener must be a function");}function m(t,e){const r=T.get(t);return r.has(e)||r.set(e,/* @__PURE__ */new Set()),r.get(e);}function _(t,e){const r=typeof e=="string"||typeof e=="symbol"?e:C,s=g.get(t);return s.has(r)||s.set(r,/* @__PURE__ */new Set()),s.get(r);}function B(t,e,r){const s=g.get(t);if(s.has(e)){for(var _iterator3=_createForOfIteratorHelperLoose(s.get(e)),_step3;!(_step3=_iterator3()).done;){const i=_step3.value;i.enqueue(r);}}if(s.has(C)){const i=Promise.all([e,r]);for(var _iterator4=_createForOfIteratorHelperLoose(s.get(C)),_step4;!(_step4=_iterator4()).done;){const n=_step4.value;n.enqueue(i);}}}function D(t,e){e=Array.isArray(e)?e:[e];let r=false,s=()=>{},i=[];const n={enqueue(o){i.push(o),s();},finish(){r=true,s();}};for(var _iterator5=_createForOfIteratorHelperLoose(e),_step5;!(_step5=_iterator5()).done;){const o=_step5.value;_(t,o).add(n);}return{next(){var _this5=this;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(){return _regenerator.default.wrap(function _callee$(_context){while(1)switch(_context.prev=_context.next){case 0:if(!i){_context.next=19;break;}if(!(i.length===0)){_context.next=12;break;}if(!r){_context.next=6;break;}_context.t2=(i=void 0,_this5.next());_context.next=9;break;case 6:_context.next=8;return new Promise(o=>{s=o;});case 8:_context.t2=_this5.next();case 9:_context.t1=_context.t2;_context.next=16;break;case 12:_context.next=14;return i.shift();case 14:_context.t3=_context.sent;_context.t1={done:false,value:_context.t3};case 16:_context.t0=_context.t1;_context.next=20;break;case 19:_context.t0={done:true};case 20:return _context.abrupt("return",_context.t0);case 21:case"end":return _context.stop();}},_callee);}))();},return(o){var _arguments=arguments;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(){var _iterator6,_step6,a;return _regenerator.default.wrap(function _callee2$(_context2){while(1)switch(_context2.prev=_context2.next){case 0:i=void 0;for(_iterator6=_createForOfIteratorHelperLoose(e);!(_step6=_iterator6()).done;){a=_step6.value;_(t,a).delete(n);}s();if(!(_arguments.length>0)){_context2.next=10;break;}_context2.next=6;return o;case 6:_context2.t1=_context2.sent;_context2.t0={done:true,value:_context2.t1};_context2.next=11;break;case 10:_context2.t0={done:true};case 11:return _context2.abrupt("return",_context2.t0);case 12:case"end":return _context2.stop();}},_callee2);}))();},[Symbol.asyncIterator](){return this;}};}function $(t){if(t===void 0)return G;if(!Array.isArray(t))throw new TypeError("`methodNames` must be an array of strings");for(var _iterator7=_createForOfIteratorHelperLoose(t),_step7;!(_step7=_iterator7()).done;){const e=_step7.value;if(!G.includes(e))throw typeof e!="string"?new TypeError("`methodNames` element must be a string"):new Error(`${e} is not Emittery method`);}return t;}const M=t=>t===S||t===R;let d=/*#__PURE__*/function(){d.mixin=function mixin(e,r){return r=$(r),s=>{if(typeof s!="function")throw new TypeError("`target` must be function");for(var _iterator8=_createForOfIteratorHelperLoose(r),_step8;!(_step8=_iterator8()).done;){const o=_step8.value;if(s.prototype[o]!==void 0)throw new Error(`The property \`${o}\` already exists on \`target\``);}function i(){return Object.defineProperty(this,e,{enumerable:false,value:new d()}),this[e];}Object.defineProperty(s.prototype,e,{enumerable:false,get:i});const n=o=>function(){return this[e][o](...arguments);};for(var _iterator9=_createForOfIteratorHelperLoose(r),_step9;!(_step9=_iterator9()).done;){const o=_step9.value;Object.defineProperty(s.prototype,o,{enumerable:false,value:n(o)});}return s;};};function d(e){if(e===void 0){e={};}f.set(this,/* @__PURE__ */new Set()),T.set(this,/* @__PURE__ */new Map()),g.set(this,/* @__PURE__ */new Map()),this.debug=e.debug||{},this.debug.enabled===void 0&&(this.debug.enabled=false),this.debug.logger||(this.debug.logger=(r,s,i,n)=>{try{n=JSON.stringify(n);}catch(_unused){n=`Object with the following keys failed to stringify: ${Object.keys(n).join(",")}`;}typeof i=="symbol"&&(i=i.toString());const o=/* @__PURE__ */new Date(),a=`${o.getHours()}:${o.getMinutes()}:${o.getSeconds()}.${o.getMilliseconds()}`;console.log(`[${a}][emittery:${r}][${s}] Event Name: ${i}
	data: ${n}`);});}var _proto=d.prototype;_proto.logIfDebugEnabled=function logIfDebugEnabled(e,r,s){(d.isDebugEnabled||this.debug.enabled)&&this.debug.logger(e,this.debug.name,r,s);};_proto.on=function on(e,r){b(r),e=Array.isArray(e)?e:[e];for(var _iterator10=_createForOfIteratorHelperLoose(e),_step10;!(_step10=_iterator10()).done;){const s=_step10.value;p(s),m(this,s).add(r),this.logIfDebugEnabled("subscribe",s,void 0),M(s)||this.emit(S,{eventName:s,listener:r});}return this.off.bind(this,e,r);};_proto.off=function off(e,r){b(r),e=Array.isArray(e)?e:[e];for(var _iterator11=_createForOfIteratorHelperLoose(e),_step11;!(_step11=_iterator11()).done;){const s=_step11.value;p(s),m(this,s).delete(r),this.logIfDebugEnabled("unsubscribe",s,void 0),M(s)||this.emit(R,{eventName:s,listener:r});}};_proto.once=function once(e){return new Promise(r=>{const s=this.on(e,i=>{s(),r(i);});});};_proto.events=function events(e){e=Array.isArray(e)?e:[e];for(var _iterator12=_createForOfIteratorHelperLoose(e),_step12;!(_step12=_iterator12()).done;){const r=_step12.value;p(r);}return D(this,e);};_proto.emit=/*#__PURE__*/function(){var _emit=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5(e,r){var s,i,n,o;return _regenerator.default.wrap(function _callee5$(_context5){while(1)switch(_context5.prev=_context5.next){case 0:p(e),this.logIfDebugEnabled("emit",e,r),B(this,e,r);s=m(this,e),i=f.get(this),n=[...s],o=M(e)?[]:[...i];_context5.next=4;return U;case 4:_context5.next=6;return Promise.all([...n.map(/*#__PURE__*/function(){var _ref=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(a){return _regenerator.default.wrap(function _callee3$(_context3){while(1)switch(_context3.prev=_context3.next){case 0:if(!s.has(a)){_context3.next=2;break;}return _context3.abrupt("return",a(r));case 2:case"end":return _context3.stop();}},_callee3);}));return function(_x3){return _ref.apply(this,arguments);};}()),...o.map(/*#__PURE__*/function(){var _ref2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(a){return _regenerator.default.wrap(function _callee4$(_context4){while(1)switch(_context4.prev=_context4.next){case 0:if(!i.has(a)){_context4.next=2;break;}return _context4.abrupt("return",a(e,r));case 2:case"end":return _context4.stop();}},_callee4);}));return function(_x4){return _ref2.apply(this,arguments);};}())]);case 6:case"end":return _context5.stop();}},_callee5,this);}));function emit(_x,_x2){return _emit.apply(this,arguments);}return emit;}();_proto.emitSerial=/*#__PURE__*/function(){var _emitSerial=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee6(e,r){var s,i,n,o,_i2,_n,a,_i3,_o;return _regenerator.default.wrap(function _callee6$(_context6){while(1)switch(_context6.prev=_context6.next){case 0:p(e),this.logIfDebugEnabled("emitSerial",e,r);s=m(this,e),i=f.get(this),n=[...s],o=[...i];_context6.next=4;return U;case 4:_i2=0,_n=n;case 5:if(!(_i2<_n.length)){_context6.next=14;break;}a=_n[_i2];_context6.t0=s.has(a);if(!_context6.t0){_context6.next=11;break;}_context6.next=11;return a(r);case 11:_i2++;_context6.next=5;break;case 14:_i3=0,_o=o;case 15:if(!(_i3<_o.length)){_context6.next=24;break;}a=_o[_i3];_context6.t1=i.has(a);if(!_context6.t1){_context6.next=21;break;}_context6.next=21;return a(e,r);case 21:_i3++;_context6.next=15;break;case 24:case"end":return _context6.stop();}},_callee6,this);}));function emitSerial(_x5,_x6){return _emitSerial.apply(this,arguments);}return emitSerial;}();_proto.onAny=function onAny(e){return b(e),this.logIfDebugEnabled("subscribeAny",void 0,void 0),f.get(this).add(e),this.emit(S,{listener:e}),this.offAny.bind(this,e);};_proto.anyEvent=function anyEvent(){return D(this);};_proto.offAny=function offAny(e){b(e),this.logIfDebugEnabled("unsubscribeAny",void 0,void 0),this.emit(R,{listener:e}),f.get(this).delete(e);};_proto.clearListeners=function clearListeners(e){e=Array.isArray(e)?e:[e];for(var _iterator13=_createForOfIteratorHelperLoose(e),_step13;!(_step13=_iterator13()).done;){const r=_step13.value;if(this.logIfDebugEnabled("clear",r,void 0),typeof r=="string"||typeof r=="symbol"){m(this,r).clear();const s=_(this,r);for(var _iterator14=_createForOfIteratorHelperLoose(s),_step14;!(_step14=_iterator14()).done;){const i=_step14.value;i.finish();}s.clear();}else{f.get(this).clear();for(var _iterator15=_createForOfIteratorHelperLoose(T.get(this).values()),_step15;!(_step15=_iterator15()).done;){const s=_step15.value;s.clear();}for(var _iterator16=_createForOfIteratorHelperLoose(g.get(this).values()),_step16;!(_step16=_iterator16()).done;){const s=_step16.value;for(var _iterator17=_createForOfIteratorHelperLoose(s),_step17;!(_step17=_iterator17()).done;){const i=_step17.value;i.finish();}s.clear();}}}};_proto.listenerCount=function listenerCount(e){e=Array.isArray(e)?e:[e];let r=0;for(var _iterator18=_createForOfIteratorHelperLoose(e),_step18;!(_step18=_iterator18()).done;){const s=_step18.value;if(typeof s=="string"){r+=f.get(this).size+m(this,s).size+_(this,s).size+_(this).size;continue;}typeof s<"u"&&p(s),r+=f.get(this).size;for(var _iterator19=_createForOfIteratorHelperLoose(T.get(this).values()),_step19;!(_step19=_iterator19()).done;){const i=_step19.value;r+=i.size;}for(var _iterator20=_createForOfIteratorHelperLoose(g.get(this).values()),_step20;!(_step20=_iterator20()).done;){const i=_step20.value;r+=i.size;}}return r;};_proto.bindMethods=function bindMethods(e,r){if(typeof e!="object"||e===null)throw new TypeError("`target` must be an object");r=$(r);for(var _iterator21=_createForOfIteratorHelperLoose(r),_step21;!(_step21=_iterator21()).done;){const s=_step21.value;if(e[s]!==void 0)throw new Error(`The property \`${s}\` already exists on \`target\``);Object.defineProperty(e,s,{enumerable:false,value:this[s].bind(this)});}};(0,_createClass2.default)(d,null,[{key:"isDebugEnabled",get:function get(){if(typeof process!="object")return A;const _ref3=process||{env:{}},e=_ref3.env;return e.DEBUG==="emittery"||e.DEBUG==="*"||A;},set:function set(e){A=e;}}]);return d;}();const G=Object.getOwnPropertyNames(d.prototype).filter(t=>t!=="constructor");Object.defineProperty(d,"listenerAdded",{value:S,writable:false,enumerable:true,configurable:false});Object.defineProperty(d,"listenerRemoved",{value:R,writable:false,enumerable:true,configurable:false});var Y=d;const v=/* @__PURE__ */j(Y);function q(t){return typeof t=="object"&&t!==null&&"message"in t&&typeof t.message=="string";}function J(t){if(q(t))return t;try{return new Error(JSON.stringify(t));}catch(_unused2){return new Error(String(t));}}function I(t){return J(t).message;}var K=Object.defineProperty,X=(t,e,r)=>e in t?K(t,e,{enumerable:true,configurable:true,writable:true,value:r}):t[e]=r,Z=(t,e,r)=>(X(t,typeof e!="symbol"?e+"":e,r),r);const ee="hlg.tokbox.com/prod/logging/vcp_webrtc",re="https://",te=1e4;let w;const se=new Uint8Array(16);function ie(){if(!w&&(w=typeof crypto<"u"&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto),!w))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return w(se);}const c=[];for(let t=0;t<256;++t)c.push((t+256).toString(16).slice(1));function ne(t,e){if(e===void 0){e=0;}return(c[t[e+0]]+c[t[e+1]]+c[t[e+2]]+c[t[e+3]]+"-"+c[t[e+4]]+c[t[e+5]]+"-"+c[t[e+6]]+c[t[e+7]]+"-"+c[t[e+8]]+c[t[e+9]]+"-"+c[t[e+10]]+c[t[e+11]]+c[t[e+12]]+c[t[e+13]]+c[t[e+14]]+c[t[e+15]]).toLowerCase();}const oe=typeof crypto<"u"&&crypto.randomUUID&&crypto.randomUUID.bind(crypto),H={randomUUID:oe};function ae(t,e,r){if(H.randomUUID&&!e&&!t)return H.randomUUID();t=t||{};const s=t.random||(t.rng||ie)();if(s[6]=s[6]&15|64,s[8]=s[8]&63|128,e){r=r||0;for(let i=0;i<16;++i)e[r+i]=s[i];return e;}return ne(s);}function F(t,e){_globalThis.vonage||(_globalThis.vonage={}),_globalThis.vonage.workerizer||(_globalThis.vonage.workerizer={});let r=_globalThis.vonage.workerizer;return r[t]||(r[t]=e),r[t];}const h=F("globals",{});var u=/* @__PURE__ */(t=>(t.INIT="INIT",t.FORWARD="FORWARD",t.TERMINATE="TERMINATE",t.GLOBALS_SYNC="GLOBALS_SYNC",t))(u||{});function z(t){return[ImageBitmap,ReadableStream,WritableStream].some(r=>t instanceof r);}let ce=0;function le(t,e,r,s,i){const n=ce++;return t.postMessage({id:n,type:e,functionName:r,args:s},s.filter(a=>z(a))),new Promise(a=>{i==null||i.set(n,a);});}function y(t,e){const r=t.id,s=t.type,i=Array.isArray(e)?e:[e];postMessage({id:r,type:s,result:e},i.filter(n=>z(n)));}const Q=F("workerized",{});function V(){return typeof WorkerGlobalScope<"u"&&self instanceof WorkerGlobalScope;}function fe(){return _fe.apply(this,arguments);}function _fe(){_fe=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee59(){var t,e,_Q$e$workerContext,r,s;return _regenerator.default.wrap(function _callee59$(_context59){while(1)switch(_context59.prev=_context59.next){case 0:if(!V()){_context59.next=4;break;}y({type:u.GLOBALS_SYNC},h);_context59.next=8;break;case 4:t=[];for(e in Q){_Q$e$workerContext=Q[e].workerContext,r=_Q$e$workerContext.worker,s=_Q$e$workerContext.resolvers;r&&t.push(le(r,u.GLOBALS_SYNC,"",[h],s));}_context59.next=8;return Promise.all(t);case 8:case"end":return _context59.stop();}},_callee59);}));return _fe.apply(this,arguments);}function P(t,e){if(Array.isArray(e))e.splice(0,e.length);else if(typeof e=="object")for(const r in e)delete e[r];for(const r in t)Array.isArray(t[r])?(e[r]=[],P(t[r],e[r])):typeof t[r]=="object"?(e[r]={},P(t[r],e[r])):e[r]=t[r];}function he(_x7,_x8){return _he.apply(this,arguments);}function _he(){_he=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee60(t,e){var r,s;return _regenerator.default.wrap(function _callee60$(_context60){while(1)switch(_context60.prev=_context60.next){case 0:r=t.functionName,s=t.args;if(e.instance){_context60.next=3;break;}throw"instance not initialized";case 3:if(r){_context60.next=5;break;}throw"missing function name to call";case 5:if(e.instance[r]){_context60.next=7;break;}throw`undefined function [${r}] in class ${e.instance.constructor.workerId}`;case 7:_context60.t0=y;_context60.t1=t;_context60.next=11;return e.instance[r](...(s!=null?s:[]));case 11:_context60.t2=_context60.sent;(0,_context60.t0)(_context60.t1,_context60.t2);case 13:case"end":return _context60.stop();}},_callee60);}));return _he.apply(this,arguments);}const ue=F("registeredWorkers",{});function de(t,e){if(!t.args)throw"Missing className while initializing worker";const _t$args=t.args,r=_t$args[0],s=_t$args[1],i=ue[r];if(i)e.instance=new i(t.args.slice(1));else throw`unknown worker class ${r}`;P(s,h),y(t,typeof e.instance!==void 0);}function pe(_x9,_x10){return _pe.apply(this,arguments);}function _pe(){_pe=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee61(t,e){var r,s;return _regenerator.default.wrap(function _callee61$(_context61){while(1)switch(_context61.prev=_context61.next){case 0:r=t.args;if(e.instance){_context61.next=3;break;}throw"instance not initialized";case 3:_context61.t0=e.instance.terminate;if(!_context61.t0){_context61.next=8;break;}_context61.next=7;return e.instance.terminate(...(r!=null?r:[]));case 7:s=_context61.sent;case 8:y(t,s);case 9:case"end":return _context61.stop();}},_callee61);}));return _pe.apply(this,arguments);}function me(t){if(!t.args)throw"Missing globals while syncing";P(t.args[0],h),y(t,{});}function ge(){const t={};onmessage=/*#__PURE__*/function(){var _ref4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee7(e){var r;return _regenerator.default.wrap(function _callee7$(_context7){while(1)switch(_context7.prev=_context7.next){case 0:r=e.data;_context7.t0=r.type;_context7.next=_context7.t0===u.INIT?4:_context7.t0===u.FORWARD?6:_context7.t0===u.TERMINATE?8:_context7.t0===u.GLOBALS_SYNC?10:12;break;case 4:de(r,t);return _context7.abrupt("break",12);case 6:he(r,t);return _context7.abrupt("break",12);case 8:pe(r,t);return _context7.abrupt("break",12);case 10:me(r);return _context7.abrupt("break",12);case 12:case"end":return _context7.stop();}},_callee7);}));return function onmessage(_x11){return _ref4.apply(this,arguments);};}();}V()&&ge();function _e(t,e){return h[t]||(h[t]=e),[()=>h[t],/*#__PURE__*/function(){var _ref5=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee8(r){return _regenerator.default.wrap(function _callee8$(_context8){while(1)switch(_context8.prev=_context8.next){case 0:h[t]=r;_context8.next=3;return fe();case 3:case"end":return _context8.stop();}},_callee8);}));return function(_x12){return _ref5.apply(this,arguments);};}()];}function ye(t,e){return _e(t,e);}const _ye=ye("metadata"),be=_ye[0],we=_ye[1];function x(){return be();}let L=/*#__PURE__*/function(){function L(e,r){Z(this,"uuid"),this.config=e,this.uuid=r!=null?r:ae();}var _proto2=L.prototype;_proto2.send=/*#__PURE__*/function(){var _send=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee9(e){var r,s,i,_ref6,n,o,a,k;return _regenerator.default.wrap(function _callee9$(_context9){while(1)switch(_context9.prev=_context9.next){case 0:_ref6=(r=x())!=null?r:{},n=_ref6.appId,o=_ref6.sourceType;if(!(!n||!o)){_context9.next=3;break;}return _context9.abrupt("return","metadata missing");case 3:a=new AbortController(),k=setTimeout(()=>a.abort(),te);_context9.next=6;return((i=(s=this.config)==null?void 0:s.fetch)!=null?i:fetch)(this.getUrl(),{method:"POST",headers:this.getHeaders(),body:JSON.stringify(this.buildReport(e)),signal:a.signal});case 6:clearTimeout(k);return _context9.abrupt("return","success");case 8:case"end":return _context9.stop();}},_callee9,this);}));function send(_x13){return _send.apply(this,arguments);}return send;}();_proto2.getUrl=function getUrl(){var e;let r=(e=x().proxyUrl)!=null?e:re;return r+=(r.at(-1)==="/"?"":"/")+ee,r;};_proto2.getHeaders=function getHeaders(){return{"Content-Type":"application/json"};};_proto2.buildReport=function buildReport(e){const r=x();return Object.assign({guid:this.uuid},e,{applicationId:r.appId,timestamp:Date.now(),proxyUrl:r.proxyUrl,source:r.sourceType});};return L;}();const E="2.0.4";let Te=/*#__PURE__*/function(){function Te(e,r){this.config=e,this.frameTransformedCount=0,this.frameFromSourceCount=0,this.startAt=0,this.reporter=new L(e,r);}var _proto3=Te.prototype;_proto3.onFrameFromSource=/*#__PURE__*/function(){var _onFrameFromSource=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee10(){return _regenerator.default.wrap(function _callee10$(_context10){while(1)switch(_context10.prev=_context10.next){case 0:this.frameFromSourceCount++;case 1:case"end":return _context10.stop();}},_callee10,this);}));function onFrameFromSource(){return _onFrameFromSource.apply(this,arguments);}return onFrameFromSource;}();_proto3.onFrameTransformed=/*#__PURE__*/function(){var _onFrameTransformed=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee11(e,r){var s,i,n,o,a,k,W;return _regenerator.default.wrap(function _callee11$(_context11){while(1)switch(_context11.prev=_context11.next){case 0:if(e===void 0){e={};}if(r===void 0){r=false;}this.startAt===0&&(this.startAt=Date.now()),this.frameTransformedCount++;s=this.startAt,i=this.frameTransformedCount,n=this.frameFromSourceCount,o=Date.now(),a=(o-s)/1e3,k=i/a,W=n/a;return _context11.abrupt("return",r||this.frameTransformedCount>=this.config.loggingIntervalFrameCount?(this.frameFromSourceCount=0,this.frameTransformedCount=0,this.startAt=o,this.reporter.config=this.config,this.reporter.send(Object.assign({},this.config.report,{variation:"QoS",fps:W,transformedFps:k,framesTransformed:i},e))):"success");case 5:case"end":return _context11.stop();}},_callee11,this);}));function onFrameTransformed(_x14,_x15){return _onFrameTransformed.apply(this,arguments);}return onFrameTransformed;}();(0,_createClass2.default)(Te,[{key:"fps",get:function get(){const e=this.startAt,r=this.frameFromSourceCount,i=(Date.now()-e)/1e3;return r/i;}}]);return Te;}();var O=/* @__PURE__ */(t=>(t.pipeline_ended="pipeline_ended",t.pipeline_ended_with_error="pipeline_ended_with_error",t.pipeline_started="pipeline_started",t.pipeline_started_with_error="pipeline_started_with_error",t.pipeline_restarted="pipeline_restarted",t.pipeline_restarted_with_error="pipeline_restarted_with_error",t))(O||{});const Re=500,Pe=0.8;let ke=/*#__PURE__*/function(_v){(0,_inheritsLoose2.default)(ke,_v);function ke(e,r){var _this6;_this6=_v.call(this)||this,_this6.reporter_=new L(),_this6.reporterQos_=new Te({loggingIntervalFrameCount:Re,report:{version:E}}),_this6.index_=r,_this6.transformer_=e,_this6.shouldStop_=false,_this6.isFlashed_=false,_this6.mediaTransformerQosReportStartTimestamp_=0,_this6.videoHeight_=0,_this6.videoWidth_=0,_this6.trackExpectedRate_=-1,_this6.transformerType_="Custom","getTransformerType"in e&&(_this6.transformerType_=e.getTransformerType()),_this6.report({variation:"Create"});return _this6;}var _proto4=ke.prototype;_proto4.setTrackExpectedRate=function setTrackExpectedRate(e){this.trackExpectedRate_=e;};_proto4.start=/*#__PURE__*/function(){var _start=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee12(e){var s;return _regenerator.default.wrap(function _callee12$(_context12){while(1)switch(_context12.prev=_context12.next){case 0:if(!(this.controller_=e,this.transformer_&&typeof this.transformer_.start=="function")){_context12.next=11;break;}_context12.prev=1;_context12.next=4;return this.transformer_.start(e);case 4:_context12.next=11;break;case 6:_context12.prev=6;_context12.t0=_context12["catch"](1);this.report({message:l.errors.transformer_start,variation:"Error",error:I(_context12.t0)});s={eventMetaData:{transformerIndex:this.index_},error:_context12.t0,function:"start"/* start */};this.emit("error",s);case 11:case"end":return _context12.stop();}},_callee12,this,[[1,6]]);}));function start(_x16){return _start.apply(this,arguments);}return start;}();_proto4.transform=/*#__PURE__*/function(){var _transform=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee13(e,r){var _ref7,_ref8;var s,i,o,n;return _regenerator.default.wrap(function _callee13$(_context13){while(1)switch(_context13.prev=_context13.next){case 0:if(!(this.mediaTransformerQosReportStartTimestamp_===0&&(this.mediaTransformerQosReportStartTimestamp_=Date.now()),e instanceof VideoFrame&&(this.videoHeight_=(_ref7=e==null?void 0:e.displayHeight)!=null?_ref7:0,this.videoWidth_=(_ref8=e==null?void 0:e.displayWidth)!=null?_ref8:0),this.reporterQos_.onFrameFromSource(),this.transformer_)){_context13.next=17;break;}if(!this.shouldStop_){_context13.next=5;break;}console.warn("[Pipeline] flush from transform"),e.close(),this.flush(r),r.terminate();_context13.next=17;break;case 5:_context13.prev=5;_context13.next=8;return(i=(s=this.transformer_).transform)==null?void 0:i.call(s,e,r);case 8:this.reportQos();_context13.next=16;break;case 11:_context13.prev=11;_context13.t0=_context13["catch"](5);this.report({message:l.errors.transformer_transform,variation:"Error",error:I(_context13.t0)});o={eventMetaData:{transformerIndex:this.index_},error:_context13.t0,function:"transform"/* transform */};this.emit("error",o);case 16:if(this.trackExpectedRate_!=-1&&this.trackExpectedRate_*Pe>this.reporterQos_.fps){n={eventMetaData:{transformerIndex:this.index_},warningType:"fps_drop",dropInfo:{requested:this.trackExpectedRate_,current:this.reporterQos_.fps}};this.emit("warn",n);}case 17:case"end":return _context13.stop();}},_callee13,this,[[5,11]]);}));function transform(_x17,_x18){return _transform.apply(this,arguments);}return transform;}();_proto4.flush=/*#__PURE__*/function(){var _flush=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee14(e){var s;return _regenerator.default.wrap(function _callee14$(_context14){while(1)switch(_context14.prev=_context14.next){case 0:if(!(this.transformer_&&typeof this.transformer_.flush=="function"&&!this.isFlashed_)){_context14.next=12;break;}this.isFlashed_=true;_context14.prev=2;_context14.next=5;return this.transformer_.flush(e);case 5:_context14.next=12;break;case 7:_context14.prev=7;_context14.t0=_context14["catch"](2);this.report({message:l.errors.transformer_flush,variation:"Error",error:I(_context14.t0)});s={eventMetaData:{transformerIndex:this.index_},error:_context14.t0,function:"flush"/* flush */};this.emit("error",s);case 12:this.reportQos(true),this.report({variation:"Delete"});case 13:case"end":return _context14.stop();}},_callee14,this,[[2,7]]);}));function flush(_x19){return _flush.apply(this,arguments);}return flush;}();_proto4.stop=function stop(){console.log("[Pipeline] Stop stream."),this.controller_&&(this.flush(this.controller_),this.controller_.terminate()),this.shouldStop_=true;};_proto4.report=function report(e){this.reporter_.send(Object.assign({version:E,action:"MediaTransformer",transformerType:this.transformerType_},e));};_proto4.reportQos=function reportQos(e){if(e===void 0){e=false;}this.reporterQos_.config=Object.assign({},this.reporterQos_.config),this.reporterQos_.onFrameTransformed({version:E,action:"MediaTransformer",transformerType:this.transformerType_,videoWidth:this.videoWidth_,videoHeight:this.videoHeight_},e);};return ke;}(v);let Ae=/*#__PURE__*/function(_v2){(0,_inheritsLoose2.default)(Ae,_v2);function Ae(e){var _this7;_this7=_v2.call(this)||this,_this7.transformers_=[],_this7.trackExpectedRate_=-1;for(let r=0;r<e.length;r++){let s=new ke(e[r],r);s.on("error",i=>{_this7.emit("error",i);}),s.on("warn",i=>{_this7.emit("warn",i);}),_this7.transformers_.push(s);}return _this7;}var _proto5=Ae.prototype;_proto5.setTrackExpectedRate=function setTrackExpectedRate(e){this.trackExpectedRate_=e;for(var _iterator22=_createForOfIteratorHelperLoose(this.transformers_),_step22;!(_step22=_iterator22()).done;){let r=_step22.value;r.setTrackExpectedRate(this.trackExpectedRate_);}};_proto5.start=/*#__PURE__*/function(){var _start2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee17(e,r){var _this8=this;var s,_iterator23,_step23,i;return _regenerator.default.wrap(function _callee17$(_context17){while(1)switch(_context17.prev=_context17.next){case 0:if(!(!this.transformers_||this.transformers_.length===0)){_context17.next=3;break;}console.log("[Pipeline] No transformers.");return _context17.abrupt("return");case 3:_context17.prev=3;s=e;for(_iterator23=_createForOfIteratorHelperLoose(this.transformers_);!(_step23=_iterator23()).done;){i=_step23.value;e=e.pipeThrough(new TransformStream(i));}e.pipeTo(r).then(/*#__PURE__*/(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee15(){return _regenerator.default.wrap(function _callee15$(_context15){while(1)switch(_context15.prev=_context15.next){case 0:console.log("[Pipeline] Setup.");_context15.next=3;return r.abort();case 3:_context15.next=5;return s.cancel();case 5:_this8.emit("pipelineInfo","pipeline_ended"/* pipeline_ended */);case 6:case"end":return _context15.stop();}},_callee15);}))).catch(/*#__PURE__*/function(){var _ref10=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee16(i){return _regenerator.default.wrap(function _callee16$(_context16){while(1)switch(_context16.prev=_context16.next){case 0:e.cancel().then(()=>{console.log("[Pipeline] Shutting down streams after abort.");}).catch(n=>{console.error("[Pipeline] Error from stream transform:",n);});_context16.next=3;return r.abort(i);case 3:_context16.next=5;return s.cancel(i);case 5:_this8.emit("pipelineInfo","pipeline_ended_with_error"/* pipeline_ended_with_error */);case 6:case"end":return _context16.stop();}},_callee16);}));return function(_x22){return _ref10.apply(this,arguments);};}());_context17.next=13;break;case 9:_context17.prev=9;_context17.t0=_context17["catch"](3);this.emit("pipelineInfo","pipeline_started_with_error"/* pipeline_started_with_error */),this.destroy();return _context17.abrupt("return");case 13:this.emit("pipelineInfo","pipeline_started"/* pipeline_started */),console.log("[Pipeline] Pipeline started.");case 14:case"end":return _context17.stop();}},_callee17,this,[[3,9]]);}));function start(_x20,_x21){return _start2.apply(this,arguments);}return start;}();_proto5.destroy=/*#__PURE__*/function(){var _destroy=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee18(){var _iterator24,_step24,e;return _regenerator.default.wrap(function _callee18$(_context18){while(1)switch(_context18.prev=_context18.next){case 0:console.log("[Pipeline] Destroying Pipeline.");for(_iterator24=_createForOfIteratorHelperLoose(this.transformers_);!(_step24=_iterator24()).done;){e=_step24.value;e.stop();}case 2:case"end":return _context18.stop();}},_callee18,this);}));function destroy(){return _destroy.apply(this,arguments);}return destroy;}();return Ae;}(v);let Ce=/*#__PURE__*/function(_v3){(0,_inheritsLoose2.default)(Ce,_v3);function Ce(){var _this9;_this9=_v3.call(this)||this,_this9.reporter_=new L(),_this9.trackExpectedRate_=-1,_this9.report({variation:"Create"});return _this9;}/**
   * Sets the expected rate of the track per second.
   * The media processor will use this number for calculating drops in the rate.
   * This could happen when the transformation will take more time than expected.
   * This will not cause an error, just warning to the client.
   * Mostly:
   * Video: 30 frames per second
   * Audio: 50 audio data per second for OPUS
   * In case of increased frame dropping rate a warning will be emitted according to info [here](/docs/intro#errors-and-warnings-listener).
   * ***This is an optional method.***
   * @param trackExpectedRate - number holds the predicted track rate.
   */var _proto6=Ce.prototype;_proto6.setTrackExpectedRate=function setTrackExpectedRate(e){this.trackExpectedRate_=e,this.pipeline_&&this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);}/**
   * Starts running the tranformation logic performed by the media processor instance.
   * When running an instance of this class on a Web worker thread the call for this function should be made by the user. See example [here](/docs/intro#webworker-code).
   * When running an instance of this class on the application main thread there is no need to call this method given it will be called by the `MediaProcessorConnector` instance.
   *
   * @param readable Readable stream associated to the media source being processed.
   * @param writable Writable stream associated to the resulting media once processed.
   *
   * @returns
   */;_proto6.transform=function transform(e,r){return this.readable_=e,this.writable_=r,this.transformInternal();}/**
   * @private
   */;_proto6.transformInternal=function transformInternal(){var _this10=this;return new Promise(/*#__PURE__*/function(){var _ref11=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee19(e,r){var s;return _regenerator.default.wrap(function _callee19$(_context19){while(1)switch(_context19.prev=_context19.next){case 0:if(!(!_this10.transformers_||_this10.transformers_.length===0)){_context19.next=3;break;}_this10.report({message:l.errors.transformer_none,variation:"Error"}),r("[MediaProcessor] Need to set transformers.");return _context19.abrupt("return");case 3:if(_this10.readable_){_context19.next=6;break;}_this10.report({variation:"Error",message:l.errors.readable_null}),r("[MediaProcessor] Readable is null.");return _context19.abrupt("return");case 6:if(_this10.writable_){_context19.next=9;break;}_this10.report({variation:"Error",message:l.errors.writable_null}),r("[MediaProcessor] Writable is null.");return _context19.abrupt("return");case 9:s=false;_this10.pipeline_&&(s=true,_this10.pipeline_.clearListeners(),_this10.pipeline_.destroy()),_this10.pipeline_=new Ae(_this10.transformers_),_this10.pipeline_.on("warn",i=>{_this10.emit("warn",i);}),_this10.pipeline_.on("error",i=>{_this10.emit("error",i);}),_this10.pipeline_.on("pipelineInfo",i=>{s&&(i==="pipeline_started"?i=O.pipeline_restarted:i==="pipeline_started_with_error"&&(i=O.pipeline_restarted_with_error)),_this10.emit("pipelineInfo",i);}),_this10.trackExpectedRate_!=-1&&_this10.pipeline_.setTrackExpectedRate(_this10.trackExpectedRate_),_this10.pipeline_.start(_this10.readable_,_this10.writable_).then(()=>{e();}).catch(i=>{r(i);});case 11:case"end":return _context19.stop();}},_callee19);}));return function(_x23,_x24){return _ref11.apply(this,arguments);};}());}/**
   * Sets an array of transfromer instances that will be hold and ran by the media processor instance.
   * See example [here](/docs/intro#main-code)
   *
   * @param transformers An array of transformer instances.
   *
   * @returns
   */;_proto6.setTransformers=function setTransformers(e){return this.report({variation:"Update",message:l.updates.transformer_new}),this.transformers_=e,this.readable_&&this.writable_?this.transformInternal():Promise.resolve();}/**
   * Stops running the tranformation logic performed by the media processor instance.
   * @returns
   */;_proto6.destroy=function destroy(){var _this11=this;return new Promise(/*#__PURE__*/function(){var _ref12=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee20(e){return _regenerator.default.wrap(function _callee20$(_context20){while(1)switch(_context20.prev=_context20.next){case 0:_this11.pipeline_&&_this11.pipeline_.destroy(),_this11.report({variation:"Delete"}),e();case 1:case"end":return _context20.stop();}},_callee20);}));return function(_x25){return _ref12.apply(this,arguments);};}());};_proto6.report=function report(e){this.reporter_.send(Object.assign({version:E,action:"MediaProcessor"},e));};return Ce;}(v);let Me=/*#__PURE__*/function(){function Me(){this.processor_=null,this.generator_=null;}var _proto7=Me.prototype;_proto7.init=function init(e){return new Promise((r,s)=>{try{this.processor_=new MediaStreamTrackProcessor(e);}catch(i){console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${i}`),s(i);}try{e.kind==="audio"?this.generator_=new MediaStreamTrackGenerator({kind:"audio"}):e.kind==="video"?this.generator_=new MediaStreamTrackGenerator({kind:"video"}):s("kind not supported");}catch(i){console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${i}`),s(i);}r();});};_proto7.getReadable=function getReadable(){return this.processor_.readable;};_proto7.getWriteable=function getWriteable(){return this.generator_.writable;};_proto7.getProccesorTrack=function getProccesorTrack(){return this.generator_;};return Me;}();let Oe=/*#__PURE__*/function(){/**
   * - When running insertable streams on the main `MediaProcessorInterface` should be instance of `MediaProcessor` class.
   * - When running insertable streams on WebWorker `MediaProcessorInterface` should be instance of bridge calss created by the user. Example can be found [here](/docs/intro.md#using-the-transformer-on-webworker)
   * @param vonageMediaProcessor - MediaProcessorInterface.
   */function Oe(e){this.insertableStreamHelper_=new Me(),this.mediaProcessor_=e;}/**
   * @private
   * Sets the media stream track instance to be processed.
   *
   * @param track MediaStreamTrack (audio or video) to be processed.
   *
   * @returns New track to be used.
   */var _proto8=Oe.prototype;_proto8.setTrack=function setTrack(e){return new Promise((r,s)=>{this.insertableStreamHelper_.init(e).then(()=>{this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(),this.insertableStreamHelper_.getWriteable()).then(()=>{r(this.insertableStreamHelper_.getProccesorTrack());}).catch(i=>{s(i);});}).catch(i=>{s(i);});});}/**
   * @private
   * Stops the media processing being performed.
   */;_proto8.destroy=function destroy(){return new Promise((e,r)=>{this.mediaProcessor_?this.mediaProcessor_.destroy().then(()=>{e();}).catch(s=>{r(s);}):r("no processor");});};return Oe;}();const anyMap$1=/* @__PURE__ */new WeakMap();const eventsMap$1=/* @__PURE__ */new WeakMap();const producersMap$1=/* @__PURE__ */new WeakMap();const anyProducer$1=Symbol("anyProducer");const resolvedPromise$1=Promise.resolve();const listenerAdded$1=Symbol("listenerAdded");const listenerRemoved$1=Symbol("listenerRemoved");let canEmitMetaEvents$1=false;let isGlobalDebugEnabled$1=false;function assertEventName$1(eventName){if(typeof eventName!=="string"&&typeof eventName!=="symbol"&&typeof eventName!=="number"){throw new TypeError("`eventName` must be a string, symbol, or number");}}function assertListener$1(listener){if(typeof listener!=="function"){throw new TypeError("listener must be a function");}}function getListeners$1(instance,eventName){const events=eventsMap$1.get(instance);if(!events.has(eventName)){return;}return events.get(eventName);}function getEventProducers$1(instance,eventName){const key=typeof eventName==="string"||typeof eventName==="symbol"||typeof eventName==="number"?eventName:anyProducer$1;const producers=producersMap$1.get(instance);if(!producers.has(key)){return;}return producers.get(key);}function enqueueProducers$1(instance,eventName,eventData){const producers=producersMap$1.get(instance);if(producers.has(eventName)){for(var _iterator25=_createForOfIteratorHelperLoose(producers.get(eventName)),_step25;!(_step25=_iterator25()).done;){const producer=_step25.value;producer.enqueue(eventData);}}if(producers.has(anyProducer$1)){const item=Promise.all([eventName,eventData]);for(var _iterator26=_createForOfIteratorHelperLoose(producers.get(anyProducer$1)),_step26;!(_step26=_iterator26()).done;){const producer=_step26.value;producer.enqueue(item);}}}function iterator$1(instance,eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];let isFinished=false;let flush=()=>{};let queue=[];const producer={enqueue(item){queue.push(item);flush();},finish(){isFinished=true;flush();}};for(var _iterator27=_createForOfIteratorHelperLoose(eventNames),_step27;!(_step27=_iterator27()).done;){const eventName=_step27.value;let set=getEventProducers$1(instance,eventName);if(!set){set=/* @__PURE__ */new Set();const producers=producersMap$1.get(instance);producers.set(eventName,set);}set.add(producer);}return{next(){var _this12=this;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee21(){return _regenerator.default.wrap(function _callee21$(_context21){while(1)switch(_context21.prev=_context21.next){case 0:if(queue){_context21.next=2;break;}return _context21.abrupt("return",{done:true});case 2:if(!(queue.length===0)){_context21.next=9;break;}if(!isFinished){_context21.next=6;break;}queue=void 0;return _context21.abrupt("return",_this12.next());case 6:_context21.next=8;return new Promise(resolve=>{flush=resolve;});case 8:return _context21.abrupt("return",_this12.next());case 9:_context21.next=11;return queue.shift();case 11:_context21.t0=_context21.sent;return _context21.abrupt("return",{done:false,value:_context21.t0});case 13:case"end":return _context21.stop();}},_callee21);}))();},return(value){var _arguments2=arguments;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee22(){var _iterator28,_step28,eventName,set,producers;return _regenerator.default.wrap(function _callee22$(_context22){while(1)switch(_context22.prev=_context22.next){case 0:queue=void 0;for(_iterator28=_createForOfIteratorHelperLoose(eventNames);!(_step28=_iterator28()).done;){eventName=_step28.value;set=getEventProducers$1(instance,eventName);if(set){set.delete(producer);if(set.size===0){producers=producersMap$1.get(instance);producers.delete(eventName);}}}flush();if(!(_arguments2.length>0)){_context22.next=10;break;}_context22.next=6;return value;case 6:_context22.t1=_context22.sent;_context22.t0={done:true,value:_context22.t1};_context22.next=11;break;case 10:_context22.t0={done:true};case 11:return _context22.abrupt("return",_context22.t0);case 12:case"end":return _context22.stop();}},_callee22);}))();},[Symbol.asyncIterator](){return this;}};}function defaultMethodNamesOrAssert$1(methodNames){if(methodNames===void 0){return allEmitteryMethods$1;}if(!Array.isArray(methodNames)){throw new TypeError("`methodNames` must be an array of strings");}for(var _iterator29=_createForOfIteratorHelperLoose(methodNames),_step29;!(_step29=_iterator29()).done;){const methodName=_step29.value;if(!allEmitteryMethods$1.includes(methodName)){if(typeof methodName!=="string"){throw new TypeError("`methodNames` element must be a string");}throw new Error(`${methodName} is not Emittery method`);}}return methodNames;}const isMetaEvent$1=eventName=>eventName===listenerAdded$1||eventName===listenerRemoved$1;function emitMetaEvent$1(emitter,eventName,eventData){if(isMetaEvent$1(eventName)){try{canEmitMetaEvents$1=true;emitter.emit(eventName,eventData);}finally{canEmitMetaEvents$1=false;}}}let Emittery$1=/*#__PURE__*/function(){Emittery.mixin=function mixin(emitteryPropertyName,methodNames){methodNames=defaultMethodNamesOrAssert$1(methodNames);return target=>{if(typeof target!=="function"){throw new TypeError("`target` must be function");}for(var _iterator30=_createForOfIteratorHelperLoose(methodNames),_step30;!(_step30=_iterator30()).done;){const methodName=_step30.value;if(target.prototype[methodName]!==void 0){throw new Error(`The property \`${methodName}\` already exists on \`target\``);}}function getEmitteryProperty(){Object.defineProperty(this,emitteryPropertyName,{enumerable:false,value:new Emittery()});return this[emitteryPropertyName];}Object.defineProperty(target.prototype,emitteryPropertyName,{enumerable:false,get:getEmitteryProperty});const emitteryMethodCaller=methodName=>function(){return this[emitteryPropertyName][methodName](...arguments);};for(var _iterator31=_createForOfIteratorHelperLoose(methodNames),_step31;!(_step31=_iterator31()).done;){const methodName=_step31.value;Object.defineProperty(target.prototype,methodName,{enumerable:false,value:emitteryMethodCaller(methodName)});}return target;};};function Emittery(options){var _options$debug;if(options===void 0){options={};}anyMap$1.set(this,/* @__PURE__ */new Set());eventsMap$1.set(this,/* @__PURE__ */new Map());producersMap$1.set(this,/* @__PURE__ */new Map());producersMap$1.get(this).set(anyProducer$1,/* @__PURE__ */new Set());this.debug=(_options$debug=options.debug)!=null?_options$debug:{};if(this.debug.enabled===void 0){this.debug.enabled=false;}if(!this.debug.logger){this.debug.logger=(type,debugName,eventName,eventData)=>{try{eventData=JSON.stringify(eventData);}catch(_unused4){eventData=`Object with the following keys failed to stringify: ${Object.keys(eventData).join(",")}`;}if(typeof eventName==="symbol"||typeof eventName==="number"){eventName=eventName.toString();}const currentTime=/* @__PURE__ */new Date();const logTime=`${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);};}}var _proto9=Emittery.prototype;_proto9.logIfDebugEnabled=function logIfDebugEnabled(type,eventName,eventData){if(Emittery.isDebugEnabled||this.debug.enabled){this.debug.logger(type,this.debug.name,eventName,eventData);}};_proto9.on=function on(eventNames,listener){assertListener$1(listener);eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator32=_createForOfIteratorHelperLoose(eventNames),_step32;!(_step32=_iterator32()).done;){const eventName=_step32.value;assertEventName$1(eventName);let set=getListeners$1(this,eventName);if(!set){set=/* @__PURE__ */new Set();const events=eventsMap$1.get(this);events.set(eventName,set);}set.add(listener);this.logIfDebugEnabled("subscribe",eventName,void 0);if(!isMetaEvent$1(eventName)){emitMetaEvent$1(this,listenerAdded$1,{eventName,listener});}}return this.off.bind(this,eventNames,listener);};_proto9.off=function off(eventNames,listener){assertListener$1(listener);eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator33=_createForOfIteratorHelperLoose(eventNames),_step33;!(_step33=_iterator33()).done;){const eventName=_step33.value;assertEventName$1(eventName);const set=getListeners$1(this,eventName);if(set){set.delete(listener);if(set.size===0){const events=eventsMap$1.get(this);events.delete(eventName);}}this.logIfDebugEnabled("unsubscribe",eventName,void 0);if(!isMetaEvent$1(eventName)){emitMetaEvent$1(this,listenerRemoved$1,{eventName,listener});}}};_proto9.once=function once(eventNames){let off_;const promise=new Promise(resolve=>{off_=this.on(eventNames,data=>{off_();resolve(data);});});promise.off=off_;return promise;};_proto9.events=function events(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator34=_createForOfIteratorHelperLoose(eventNames),_step34;!(_step34=_iterator34()).done;){const eventName=_step34.value;assertEventName$1(eventName);}return iterator$1(this,eventNames);};_proto9.emit=/*#__PURE__*/function(){var _emit2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee25(eventName,eventData){var _getListeners$;var listeners,anyListeners,staticListeners,staticAnyListeners;return _regenerator.default.wrap(function _callee25$(_context25){while(1)switch(_context25.prev=_context25.next){case 0:assertEventName$1(eventName);if(!(isMetaEvent$1(eventName)&&!canEmitMetaEvents$1)){_context25.next=3;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 3:this.logIfDebugEnabled("emit",eventName,eventData);enqueueProducers$1(this,eventName,eventData);listeners=(_getListeners$=getListeners$1(this,eventName))!=null?_getListeners$:/* @__PURE__ */new Set();anyListeners=anyMap$1.get(this);staticListeners=[...listeners];staticAnyListeners=isMetaEvent$1(eventName)?[]:[...anyListeners];_context25.next=11;return resolvedPromise$1;case 11:_context25.next=13;return Promise.all([...staticListeners.map(/*#__PURE__*/function(){var _ref13=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee23(listener){return _regenerator.default.wrap(function _callee23$(_context23){while(1)switch(_context23.prev=_context23.next){case 0:if(!listeners.has(listener)){_context23.next=2;break;}return _context23.abrupt("return",listener(eventData));case 2:case"end":return _context23.stop();}},_callee23);}));return function(_x28){return _ref13.apply(this,arguments);};}()),...staticAnyListeners.map(/*#__PURE__*/function(){var _ref14=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee24(listener){return _regenerator.default.wrap(function _callee24$(_context24){while(1)switch(_context24.prev=_context24.next){case 0:if(!anyListeners.has(listener)){_context24.next=2;break;}return _context24.abrupt("return",listener(eventName,eventData));case 2:case"end":return _context24.stop();}},_callee24);}));return function(_x29){return _ref14.apply(this,arguments);};}())]);case 13:case"end":return _context25.stop();}},_callee25,this);}));function emit(_x26,_x27){return _emit2.apply(this,arguments);}return emit;}();_proto9.emitSerial=/*#__PURE__*/function(){var _emitSerial2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee26(eventName,eventData){var _getListeners$2;var listeners,anyListeners,staticListeners,staticAnyListeners,_i4,_staticListeners,listener,_i5,_staticAnyListeners;return _regenerator.default.wrap(function _callee26$(_context26){while(1)switch(_context26.prev=_context26.next){case 0:assertEventName$1(eventName);if(!(isMetaEvent$1(eventName)&&!canEmitMetaEvents$1)){_context26.next=3;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 3:this.logIfDebugEnabled("emitSerial",eventName,eventData);listeners=(_getListeners$2=getListeners$1(this,eventName))!=null?_getListeners$2:/* @__PURE__ */new Set();anyListeners=anyMap$1.get(this);staticListeners=[...listeners];staticAnyListeners=[...anyListeners];_context26.next=10;return resolvedPromise$1;case 10:_i4=0,_staticListeners=staticListeners;case 11:if(!(_i4<_staticListeners.length)){_context26.next=19;break;}listener=_staticListeners[_i4];if(!listeners.has(listener)){_context26.next=16;break;}_context26.next=16;return listener(eventData);case 16:_i4++;_context26.next=11;break;case 19:_i5=0,_staticAnyListeners=staticAnyListeners;case 20:if(!(_i5<_staticAnyListeners.length)){_context26.next=28;break;}listener=_staticAnyListeners[_i5];if(!anyListeners.has(listener)){_context26.next=25;break;}_context26.next=25;return listener(eventName,eventData);case 25:_i5++;_context26.next=20;break;case 28:case"end":return _context26.stop();}},_callee26,this);}));function emitSerial(_x30,_x31){return _emitSerial2.apply(this,arguments);}return emitSerial;}();_proto9.onAny=function onAny(listener){assertListener$1(listener);this.logIfDebugEnabled("subscribeAny",void 0,void 0);anyMap$1.get(this).add(listener);emitMetaEvent$1(this,listenerAdded$1,{listener});return this.offAny.bind(this,listener);};_proto9.anyEvent=function anyEvent(){return iterator$1(this);};_proto9.offAny=function offAny(listener){assertListener$1(listener);this.logIfDebugEnabled("unsubscribeAny",void 0,void 0);emitMetaEvent$1(this,listenerRemoved$1,{listener});anyMap$1.get(this).delete(listener);};_proto9.clearListeners=function clearListeners(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator35=_createForOfIteratorHelperLoose(eventNames),_step35;!(_step35=_iterator35()).done;){const eventName=_step35.value;this.logIfDebugEnabled("clear",eventName,void 0);if(typeof eventName==="string"||typeof eventName==="symbol"||typeof eventName==="number"){const set=getListeners$1(this,eventName);if(set){set.clear();}const producers=getEventProducers$1(this,eventName);if(producers){for(var _iterator36=_createForOfIteratorHelperLoose(producers),_step36;!(_step36=_iterator36()).done;){const producer=_step36.value;producer.finish();}producers.clear();}}else{anyMap$1.get(this).clear();for(var _iterator37=_createForOfIteratorHelperLoose(eventsMap$1.get(this).entries()),_step37;!(_step37=_iterator37()).done;){const _step37$value=_step37.value,eventName2=_step37$value[0],listeners=_step37$value[1];listeners.clear();eventsMap$1.get(this).delete(eventName2);}for(var _iterator38=_createForOfIteratorHelperLoose(producersMap$1.get(this).entries()),_step38;!(_step38=_iterator38()).done;){const _step38$value=_step38.value,eventName2=_step38$value[0],producers=_step38$value[1];for(var _iterator39=_createForOfIteratorHelperLoose(producers),_step39;!(_step39=_iterator39()).done;){const producer=_step39.value;producer.finish();}producers.clear();producersMap$1.get(this).delete(eventName2);}}}};_proto9.listenerCount=function listenerCount(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];let count=0;for(var _iterator40=_createForOfIteratorHelperLoose(eventNames),_step40;!(_step40=_iterator40()).done;){const eventName=_step40.value;if(typeof eventName==="string"){var _getListeners$1$size,_getListeners$3,_getEventProducers$1$,_getEventProducers$,_getEventProducers$1$2,_getEventProducers$2;count+=anyMap$1.get(this).size+((_getListeners$1$size=(_getListeners$3=getListeners$1(this,eventName))==null?void 0:_getListeners$3.size)!=null?_getListeners$1$size:0)+((_getEventProducers$1$=(_getEventProducers$=getEventProducers$1(this,eventName))==null?void 0:_getEventProducers$.size)!=null?_getEventProducers$1$:0)+((_getEventProducers$1$2=(_getEventProducers$2=getEventProducers$1(this))==null?void 0:_getEventProducers$2.size)!=null?_getEventProducers$1$2:0);continue;}if(typeof eventName!=="undefined"){assertEventName$1(eventName);}count+=anyMap$1.get(this).size;for(var _iterator41=_createForOfIteratorHelperLoose(eventsMap$1.get(this).values()),_step41;!(_step41=_iterator41()).done;){const value=_step41.value;count+=value.size;}for(var _iterator42=_createForOfIteratorHelperLoose(producersMap$1.get(this).values()),_step42;!(_step42=_iterator42()).done;){const value=_step42.value;count+=value.size;}}return count;};_proto9.bindMethods=function bindMethods(target,methodNames){if(typeof target!=="object"||target===null){throw new TypeError("`target` must be an object");}methodNames=defaultMethodNamesOrAssert$1(methodNames);for(var _iterator43=_createForOfIteratorHelperLoose(methodNames),_step43;!(_step43=_iterator43()).done;){const methodName=_step43.value;if(target[methodName]!==void 0){throw new Error(`The property \`${methodName}\` already exists on \`target\``);}Object.defineProperty(target,methodName,{enumerable:false,value:this[methodName].bind(this)});}};(0,_createClass2.default)(Emittery,null,[{key:"isDebugEnabled",get:function get(){var _globalThis$process,_globalThis$process2;if(typeof((_globalThis$process=_globalThis.process)==null?void 0:_globalThis$process.env)!=="object"){return isGlobalDebugEnabled$1;}const _ref15=(_globalThis$process2=_globalThis.process)!=null?_globalThis$process2:{env:{}},env=_ref15.env;return env.DEBUG==="emittery"||env.DEBUG==="*"||isGlobalDebugEnabled$1;},set:function set(newValue){isGlobalDebugEnabled$1=newValue;}}]);return Emittery;}();const allEmitteryMethods$1=Object.getOwnPropertyNames(Emittery$1.prototype).filter(v2=>v2!=="constructor");Object.defineProperty(Emittery$1,"listenerAdded",{value:listenerAdded$1,writable:false,enumerable:true,configurable:false});Object.defineProperty(Emittery$1,"listenerRemoved",{value:listenerRemoved$1,writable:false,enumerable:true,configurable:false});const version="1.0.0";let Average=/*#__PURE__*/function(){function Average(size){this.size=size;this.values=[];this.sum=0;}var _proto10=Average.prototype;_proto10.push=function push(value){this.values.push(value);this.sum+=value;while(this.size<this.values.length){var _this$values$shift;this.sum-=(_this$values$shift=this.values.shift())!=null?_this$values$shift:0;}};_proto10.value=function value(){return this.sum/Math.max(1,this.values.length);};return Average;}();const defaultAssetsDirBaseUrl$1=`https://d3opqjmqzxf057.cloudfront.net/noise-suppression/${version}`;let NoiseSuppressionTransformer=/*#__PURE__*/function(_Emittery$){(0,_inheritsLoose2.default)(NoiseSuppressionTransformer,_Emittery$);function NoiseSuppressionTransformer(){var _this13;_this13=_Emittery$.call(this)||this;_this13.isEnabled=true;_this13.internalResampleSupported=false;_this13.latency=new Average(100);_this13.transform=_this13.transformAudioData.bind((0,_assertThisInitialized2.default)(_this13));return _this13;}/**
   * Initialize the transformer.
   * It is mandatory to call this function before using the transformer
   * @param options Options used to initialize the transformer
   */var _proto11=NoiseSuppressionTransformer.prototype;_proto11.init=/*#__PURE__*/function(){var _init=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee27(options){var _options$assetsDirBas,_this$wasmTransformer2;var assetsDirBaseUrl,locateFile,numberOfThreads,result,_this$wasmTransformer,msg,i,_this$wasmTransformer3;return _regenerator.default.wrap(function _callee27$(_context27){while(1)switch(_context27.prev=_context27.next){case 0:if(options===void 0){options={};}console.log("Noise suppression transformer initialization");this.transform=options.debug?this.transformDebug.bind(this):this.transformAudioData.bind(this);assetsDirBaseUrl=(_options$assetsDirBas=options.assetsDirBaseUrl)!=null?_options$assetsDirBas:defaultAssetsDirBaseUrl$1;locateFile=name=>{return`${assetsDirBaseUrl}/${name}`;};numberOfThreads=1;_context27.next=8;return this.isMonoThread(options);case 8:if(!_context27.sent){_context27.next=14;break;}_context27.next=11;return createWasmMonoInstance({locateFile,mainScriptUrlOrBlob:locateFile("main-bin-mono.js")});case 11:this.wasmInstance=_context27.sent;_context27.next=18;break;case 14:_context27.next=16;return createWasmMultiInstance({locateFile,mainScriptUrlOrBlob:locateFile("main-bin-multi.js")});case 16:this.wasmInstance=_context27.sent;numberOfThreads=4;case 18:this.wasmTransformer=new this.wasmInstance.DtlnTransformer();_context27.next=21;return Promise.all([this.loadModel(`${assetsDirBaseUrl}/model_1.tflite`,1),this.loadModel(`${assetsDirBaseUrl}/model_2.tflite`,2)]);case 21:_context27.prev=21;_context27.next=24;return(_this$wasmTransformer=this.wasmTransformer)==null?void 0:_this$wasmTransformer.init(numberOfThreads);case 24:result=_context27.sent;_context27.next=30;break;case 27:_context27.prev=27;_context27.t0=_context27["catch"](21);if(typeof _context27.t0=="number"){msg="";for(i=0;i<500;++i){msg+=String.fromCharCode(this.wasmInstance.HEAP8[_context27.t0+i]);}console.error(msg);}else{console.error(_context27.t0);}case 30:if(!(result!==0)){_context27.next=34;break;}msg=`Fail to init wasm transformer, error code = ${result}`;console.error(msg);throw msg;case 34:this.internalResampleSupported=(_this$wasmTransformer2=this.wasmTransformer)==null?void 0:_this$wasmTransformer2.getInternalResampleSupported();if(this.internalResampleSupported){_context27.next=39;break;}msg=`Internal resampling not supported`;console.error(msg);throw msg;case 39:if(options.debug){(_this$wasmTransformer3=this.wasmTransformer)==null?void 0:_this$wasmTransformer3.enableWavExport();}console.log("Noise suppression transformer ready");case 41:case"end":return _context27.stop();}},_callee27,this,[[21,27]]);}));function init(_x32){return _init.apply(this,arguments);}return init;}()/**
   * @internal
   */;_proto11.getWav=function getWav(){if(!this.wasmTransformer){return"";}this.wasmTransformer.closeWav();const buffer=this.wasmTransformer.getWav();const base64=btoa(new Uint8Array(buffer).reduce((data,byte)=>data+String.fromCharCode(byte),""));return`data:audio/wav;base64,${base64}`;}/**
   * Tell to the transformer what preprocessing are applied before reaching this transformer
   */;_proto11.setAudioOptions=function setAudioOptions(echo_cancellation,auto_gain_control,noise_suppression,stereo_swapping,highpass_filter){var _this$wasmTransformer4;(_this$wasmTransformer4=this.wasmTransformer)==null?void 0:_this$wasmTransformer4.setAudioOptions(echo_cancellation,auto_gain_control,noise_suppression,stereo_swapping,highpass_filter);}/**
   * Enable the noise reduction
   */;_proto11.enable=function enable(){this.isEnabled=true;}/**
   * Disable the noise reduction
   */;_proto11.disable=function disable(){this.isEnabled=false;}/**
   * Return the latency of the transformation
   * The latency will be computed only if the options debug flag is true
   * Otherwise, will return 0;
   * @returns latency
   */;_proto11.getLatency=function getLatency(){return this.latency.value();}/**
   * Return the latency of processing within the wasm in nanoseconds.
   * @returns latency
   */;_proto11.getWasmLatencyNs=function getWasmLatencyNs(){var _this$wasmTransformer5,_this$wasmTransformer6;return(_this$wasmTransformer5=(_this$wasmTransformer6=this.wasmTransformer)==null?void 0:_this$wasmTransformer6.getLatencyNs())!=null?_this$wasmTransformer5:0;};_proto11.transformDebug=/*#__PURE__*/function(){var _transformDebug=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee28(data,controller){var start;return _regenerator.default.wrap(function _callee28$(_context28){while(1)switch(_context28.prev=_context28.next){case 0:_context28.prev=0;start=performance.now();_context28.next=4;return this.transformAudioData(data,controller);case 4:this.latency.push(performance.now()-start);_context28.next=10;break;case 7:_context28.prev=7;_context28.t0=_context28["catch"](0);console.error(_context28.t0);case 10:case"end":return _context28.stop();}},_callee28,this,[[0,7]]);}));function transformDebug(_x33,_x34){return _transformDebug.apply(this,arguments);}return transformDebug;}();_proto11.transformAudioData=/*#__PURE__*/function(){var _transformAudioData=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee29(data,controller){var _data,numberOfFrames,sampleRate,numberOfChannels,timestamp,dataAsFloat32,dataAsInt16,outputSize,msg,i,output,outputAsFloat32;return _regenerator.default.wrap(function _callee29$(_context29){while(1)switch(_context29.prev=_context29.next){case 0:if(!this.wasmTransformer){this.emit("warning","transformer not initialized");}if(this.isEnabled&&this.wasmTransformer){try{_data=data,numberOfFrames=_data.numberOfFrames,sampleRate=_data.sampleRate,numberOfChannels=_data.numberOfChannels,timestamp=_data.timestamp;dataAsFloat32=this.getAudioDataAsFloat32(data);dataAsInt16=this.convertTypedArray(dataAsFloat32,Int16Array,Math.pow(2,15)-1);this.wasmTransformer.getInputFrame(dataAsInt16.length).set(dataAsInt16);outputSize=0;try{outputSize=this.wasmTransformer.runAlgorithm(numberOfFrames,sampleRate,numberOfChannels);}catch(e){if(typeof e=="number"){msg="";for(i=0;i<500;++i){msg+=String.fromCharCode(this.wasmInstance.HEAP8[e+i]);}console.error(msg);}else{console.error(e);}}if(outputSize>0){output=this.wasmTransformer.getOutputFrame().slice(0,outputSize);outputAsFloat32=this.convertTypedArray(output,Float32Array,1/(Math.pow(2,15)-1));data=new AudioData({data:outputAsFloat32,format:"f32",numberOfChannels,numberOfFrames,sampleRate,timestamp});}}catch(e){console.error(e);}}controller.enqueue(data);case 3:case"end":return _context29.stop();}},_callee29,this);}));function transformAudioData(_x35,_x36){return _transformAudioData.apply(this,arguments);}return transformAudioData;}();_proto11.loadModel=/*#__PURE__*/function(){var _loadModel=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee30(url,modelIndex){var response,buffer,size,functionName,wasmBuffer,bufferUint8;return _regenerator.default.wrap(function _callee30$(_context30){while(1)switch(_context30.prev=_context30.next){case 0:if(this.wasmTransformer){_context30.next=2;break;}return _context30.abrupt("return");case 2:_context30.next=4;return fetch(url);case 4:response=_context30.sent;_context30.next=7;return response.arrayBuffer();case 7:buffer=_context30.sent;size=buffer.byteLength;functionName=`getModel${modelIndex}`;wasmBuffer=this.wasmTransformer[functionName](size);if(wasmBuffer){bufferUint8=new Uint8Array(buffer);wasmBuffer.set(bufferUint8);}case 12:case"end":return _context30.stop();}},_callee30,this);}));function loadModel(_x37,_x38){return _loadModel.apply(this,arguments);}return loadModel;}();_proto11.getAudioDataAsFloat32=function getAudioDataAsFloat32(data){return this.audioDataToTypedArray(data,Float32Array,"f32-planar");};_proto11.audioDataToTypedArray=function audioDataToTypedArray(data,typeArrayClass,format,numberOfChannels){if(numberOfChannels===void 0){numberOfChannels=data.numberOfChannels;}const size=data.numberOfFrames*numberOfChannels;const buffer=new typeArrayClass(size);for(let i=0;i<numberOfChannels;++i){const offset=data.numberOfFrames*i;const samples=buffer.subarray(offset,offset+data.numberOfFrames);data.copyTo(samples,{planeIndex:i,format});}if(numberOfChannels>1){const result=new typeArrayClass(size);for(let i=0;i<data.numberOfFrames;++i){const index=i*2;for(let j2=0;j2<numberOfChannels;++j2){result[index+j2]=buffer[i+j2*data.numberOfFrames];}}return result;}return buffer;};_proto11.convertTypedArray=function convertTypedArray(data,outputTypeArrayClass,factor){const size=data.length;const result=new outputTypeArrayClass(size);for(let i=0;i<size;++i){result[i]=data[i]*factor;}return result;};_proto11.isMonoThread=function isMonoThread(options){if(options.disableWasmMultiThread){return true;}try{const buffer=new SharedArrayBuffer(1024);if(buffer===void 0){throw new Error("not supported");}}catch(e){this.emit(`warning`,`
Multithread is not available, noise-suppresion is now running on a single thread.
This is impacting the performance and increase the latency.

To enable multithread, you need to serve the application via https with these http headers :
   - Cross-Origin-Opener-Policy: same-origin
   - Cross-Origin-Embedder-Policy: require-corp.
More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer#security_requirements

You can disable this warning by enabling disableWasmMultiThread within the noiseSuppression options.
`);return true;}return false;};return NoiseSuppressionTransformer;}(Emittery$1);exports.NoiseSuppressionTransformer=NoiseSuppressionTransformer;function createGlobalThisVariable(name,defaultValue){if(!_globalThis.vonage){_globalThis.vonage={};}if(!_globalThis.vonage.workerizer){_globalThis.vonage.workerizer={};}let globals2=_globalThis.vonage.workerizer;if(!globals2[name]){globals2[name]=defaultValue;}return globals2[name];}const globals=createGlobalThisVariable("globals",{});var CommandType=/* @__PURE__ */(CommandType2=>{CommandType2["INIT"]="INIT";CommandType2["FORWARD"]="FORWARD";CommandType2["TERMINATE"]="TERMINATE";CommandType2["GLOBALS_SYNC"]="GLOBALS_SYNC";CommandType2["EVENT"]="EVENT";return CommandType2;})(CommandType||{});function isTransferable(arg){const transferableTypes=[ImageBitmap,ReadableStream,WritableStream];return transferableTypes.some(type=>arg instanceof type);}let nextCommandId=0;function postCommand$1(worker,type,functionName,args,resolvers){const id=nextCommandId++;worker.postMessage({id,type,functionName,args},args.filter(a=>isTransferable(a)));const promise=new Promise(resolve=>{resolvers==null?void 0:resolvers.set(id,resolve);});return promise;}function postCommand(command,result){const id=command.id,type=command.type;const resultAsArray=Array.isArray(result)?result:[result];postMessage({id,type,result},resultAsArray.filter(result2=>isTransferable(result2)));}const workerized=createGlobalThisVariable("workerized",{});function isWorker(){return typeof WorkerGlobalScope!=="undefined"&&self instanceof WorkerGlobalScope;}function globalsSync(){return _globalsSync.apply(this,arguments);}function _globalsSync(){_globalsSync=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee62(){var promises,i,_workerized$i$workerC,worker,resolvers;return _regenerator.default.wrap(function _callee62$(_context62){while(1)switch(_context62.prev=_context62.next){case 0:if(!isWorker()){_context62.next=4;break;}postCommand({type:CommandType.GLOBALS_SYNC},globals);_context62.next=8;break;case 4:promises=[];for(i in workerized){_workerized$i$workerC=workerized[i].workerContext,worker=_workerized$i$workerC.worker,resolvers=_workerized$i$workerC.resolvers;if(worker){promises.push(postCommand$1(worker,CommandType.GLOBALS_SYNC,"",[globals],resolvers));}}_context62.next=8;return Promise.all(promises);case 8:case"end":return _context62.stop();}},_callee62);}));return _globalsSync.apply(this,arguments);}function copy(from,to){if(Array.isArray(to)){to.splice(0,to.length);}else if(typeof to==="object"){for(const i in to){delete to[i];}}for(const i in from){if(Array.isArray(from[i])){to[i]=[];copy(from[i],to[i]);}else if(typeof from[i]==="object"){to[i]={};copy(from[i],to[i]);}else{to[i]=from[i];}}}function createWorker(_x39,_x40,_x41,_x42){return _createWorker.apply(this,arguments);}function _createWorker(){_createWorker=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee64(workerizedClass,workerClass,resolvers,onEvent){var worker,initialized;return _regenerator.default.wrap(function _callee64$(_context64){while(1)switch(_context64.prev=_context64.next){case 0:worker=new workerClass();worker.addEventListener("message",/*#__PURE__*/function(){var _ref21=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee63(_ref20){var data,_a,_b,_c,_d,_e2,_f,_g,result,event;return _regenerator.default.wrap(function _callee63$(_context63){while(1)switch(_context63.prev=_context63.next){case 0:data=_ref20.data;_context63.t0=data.type;_context63.next=_context63.t0===CommandType.GLOBALS_SYNC?4:_context63.t0===CommandType.EVENT?13:19;break;case 4:if(!data.id){_context63.next=9;break;}(_b=resolvers.get((_a=data.id)!=null?_a:-1))==null?void 0:_b(data.result);resolvers.delete((_c=data.id)!=null?_c:-1);_context63.next=12;break;case 9:copy((_d=data.result)!=null?_d:{},globals);_context63.next=12;return globalsSync();case 12:return _context63.abrupt("break",21);case 13:result=data.result;event=result;if(!((event==null?void 0:event.name)==void 0)){_context63.next=17;break;}throw"Missing event name";case 17:onEvent(event.name,event.data);return _context63.abrupt("break",21);case 19:(_f=resolvers.get((_e2=data.id)!=null?_e2:-1))==null?void 0:_f(data.result);resolvers.delete((_g=data.id)!=null?_g:-1);case 21:case"end":return _context63.stop();}},_callee63);}));return function(_x71){return _ref21.apply(this,arguments);};}());_context64.next=4;return postCommand$1(worker,CommandType.INIT,"",[workerizedClass.workerId,globals],resolvers);case 4:initialized=_context64.sent;if(initialized){_context64.next=7;break;}throw"Failed to instantiate workerized class";case 7:return _context64.abrupt("return",worker);case 8:case"end":return _context64.stop();}},_callee64);}));return _createWorker.apply(this,arguments);}const anyMap=/* @__PURE__ */new WeakMap();const eventsMap=/* @__PURE__ */new WeakMap();const producersMap=/* @__PURE__ */new WeakMap();const anyProducer=Symbol("anyProducer");const resolvedPromise=Promise.resolve();const listenerAdded=Symbol("listenerAdded");const listenerRemoved=Symbol("listenerRemoved");let canEmitMetaEvents=false;let isGlobalDebugEnabled=false;function assertEventName(eventName){if(typeof eventName!=="string"&&typeof eventName!=="symbol"&&typeof eventName!=="number"){throw new TypeError("`eventName` must be a string, symbol, or number");}}function assertListener(listener){if(typeof listener!=="function"){throw new TypeError("listener must be a function");}}function getListeners(instance,eventName){const events=eventsMap.get(instance);if(!events.has(eventName)){return;}return events.get(eventName);}function getEventProducers(instance,eventName){const key=typeof eventName==="string"||typeof eventName==="symbol"||typeof eventName==="number"?eventName:anyProducer;const producers=producersMap.get(instance);if(!producers.has(key)){return;}return producers.get(key);}function enqueueProducers(instance,eventName,eventData){const producers=producersMap.get(instance);if(producers.has(eventName)){for(var _iterator44=_createForOfIteratorHelperLoose(producers.get(eventName)),_step44;!(_step44=_iterator44()).done;){const producer=_step44.value;producer.enqueue(eventData);}}if(producers.has(anyProducer)){const item=Promise.all([eventName,eventData]);for(var _iterator45=_createForOfIteratorHelperLoose(producers.get(anyProducer)),_step45;!(_step45=_iterator45()).done;){const producer=_step45.value;producer.enqueue(item);}}}function iterator(instance,eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];let isFinished=false;let flush=()=>{};let queue=[];const producer={enqueue(item){queue.push(item);flush();},finish(){isFinished=true;flush();}};for(var _iterator46=_createForOfIteratorHelperLoose(eventNames),_step46;!(_step46=_iterator46()).done;){const eventName=_step46.value;let set=getEventProducers(instance,eventName);if(!set){set=/* @__PURE__ */new Set();const producers=producersMap.get(instance);producers.set(eventName,set);}set.add(producer);}return{next(){var _this14=this;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee31(){return _regenerator.default.wrap(function _callee31$(_context31){while(1)switch(_context31.prev=_context31.next){case 0:if(queue){_context31.next=2;break;}return _context31.abrupt("return",{done:true});case 2:if(!(queue.length===0)){_context31.next=9;break;}if(!isFinished){_context31.next=6;break;}queue=void 0;return _context31.abrupt("return",_this14.next());case 6:_context31.next=8;return new Promise(resolve=>{flush=resolve;});case 8:return _context31.abrupt("return",_this14.next());case 9:_context31.next=11;return queue.shift();case 11:_context31.t0=_context31.sent;return _context31.abrupt("return",{done:false,value:_context31.t0});case 13:case"end":return _context31.stop();}},_callee31);}))();},return(value){var _arguments3=arguments;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee32(){var _iterator47,_step47,eventName,set,producers;return _regenerator.default.wrap(function _callee32$(_context32){while(1)switch(_context32.prev=_context32.next){case 0:queue=void 0;for(_iterator47=_createForOfIteratorHelperLoose(eventNames);!(_step47=_iterator47()).done;){eventName=_step47.value;set=getEventProducers(instance,eventName);if(set){set.delete(producer);if(set.size===0){producers=producersMap.get(instance);producers.delete(eventName);}}}flush();if(!(_arguments3.length>0)){_context32.next=10;break;}_context32.next=6;return value;case 6:_context32.t1=_context32.sent;_context32.t0={done:true,value:_context32.t1};_context32.next=11;break;case 10:_context32.t0={done:true};case 11:return _context32.abrupt("return",_context32.t0);case 12:case"end":return _context32.stop();}},_callee32);}))();},[Symbol.asyncIterator](){return this;}};}function defaultMethodNamesOrAssert(methodNames){if(methodNames===void 0){return allEmitteryMethods;}if(!Array.isArray(methodNames)){throw new TypeError("`methodNames` must be an array of strings");}for(var _iterator48=_createForOfIteratorHelperLoose(methodNames),_step48;!(_step48=_iterator48()).done;){const methodName=_step48.value;if(!allEmitteryMethods.includes(methodName)){if(typeof methodName!=="string"){throw new TypeError("`methodNames` element must be a string");}throw new Error(`${methodName} is not Emittery method`);}}return methodNames;}const isMetaEvent=eventName=>eventName===listenerAdded||eventName===listenerRemoved;function emitMetaEvent(emitter,eventName,eventData){if(isMetaEvent(eventName)){try{canEmitMetaEvents=true;emitter.emit(eventName,eventData);}finally{canEmitMetaEvents=false;}}}let Emittery2=/*#__PURE__*/function(){Emittery2.mixin=function mixin(emitteryPropertyName,methodNames){methodNames=defaultMethodNamesOrAssert(methodNames);return target=>{if(typeof target!=="function"){throw new TypeError("`target` must be function");}for(var _iterator49=_createForOfIteratorHelperLoose(methodNames),_step49;!(_step49=_iterator49()).done;){const methodName=_step49.value;if(target.prototype[methodName]!==void 0){throw new Error(`The property \`${methodName}\` already exists on \`target\``);}}function getEmitteryProperty(){Object.defineProperty(this,emitteryPropertyName,{enumerable:false,value:new Emittery2()});return this[emitteryPropertyName];}Object.defineProperty(target.prototype,emitteryPropertyName,{enumerable:false,get:getEmitteryProperty});const emitteryMethodCaller=methodName=>function(){return this[emitteryPropertyName][methodName](...arguments);};for(var _iterator50=_createForOfIteratorHelperLoose(methodNames),_step50;!(_step50=_iterator50()).done;){const methodName=_step50.value;Object.defineProperty(target.prototype,methodName,{enumerable:false,value:emitteryMethodCaller(methodName)});}return target;};};function Emittery2(options){if(options===void 0){options={};}var _a;anyMap.set(this,/* @__PURE__ */new Set());eventsMap.set(this,/* @__PURE__ */new Map());producersMap.set(this,/* @__PURE__ */new Map());producersMap.get(this).set(anyProducer,/* @__PURE__ */new Set());this.debug=(_a=options.debug)!=null?_a:{};if(this.debug.enabled===void 0){this.debug.enabled=false;}if(!this.debug.logger){this.debug.logger=(type,debugName,eventName,eventData)=>{try{eventData=JSON.stringify(eventData);}catch(_unused5){eventData=`Object with the following keys failed to stringify: ${Object.keys(eventData).join(",")}`;}if(typeof eventName==="symbol"||typeof eventName==="number"){eventName=eventName.toString();}const currentTime=/* @__PURE__ */new Date();const logTime=`${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);};}}var _proto12=Emittery2.prototype;_proto12.logIfDebugEnabled=function logIfDebugEnabled(type,eventName,eventData){if(Emittery2.isDebugEnabled||this.debug.enabled){this.debug.logger(type,this.debug.name,eventName,eventData);}};_proto12.on=function on(eventNames,listener){assertListener(listener);eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator51=_createForOfIteratorHelperLoose(eventNames),_step51;!(_step51=_iterator51()).done;){const eventName=_step51.value;assertEventName(eventName);let set=getListeners(this,eventName);if(!set){set=/* @__PURE__ */new Set();const events=eventsMap.get(this);events.set(eventName,set);}set.add(listener);this.logIfDebugEnabled("subscribe",eventName,void 0);if(!isMetaEvent(eventName)){emitMetaEvent(this,listenerAdded,{eventName,listener});}}return this.off.bind(this,eventNames,listener);};_proto12.off=function off(eventNames,listener){assertListener(listener);eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator52=_createForOfIteratorHelperLoose(eventNames),_step52;!(_step52=_iterator52()).done;){const eventName=_step52.value;assertEventName(eventName);const set=getListeners(this,eventName);if(set){set.delete(listener);if(set.size===0){const events=eventsMap.get(this);events.delete(eventName);}}this.logIfDebugEnabled("unsubscribe",eventName,void 0);if(!isMetaEvent(eventName)){emitMetaEvent(this,listenerRemoved,{eventName,listener});}}};_proto12.once=function once(eventNames){let off_;const promise=new Promise(resolve=>{off_=this.on(eventNames,data=>{off_();resolve(data);});});promise.off=off_;return promise;};_proto12.events=function events(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator53=_createForOfIteratorHelperLoose(eventNames),_step53;!(_step53=_iterator53()).done;){const eventName=_step53.value;assertEventName(eventName);}return iterator(this,eventNames);};_proto12.emit=/*#__PURE__*/function(){var _emit3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee35(eventName,eventData){var _a,listeners,anyListeners,staticListeners,staticAnyListeners;return _regenerator.default.wrap(function _callee35$(_context35){while(1)switch(_context35.prev=_context35.next){case 0:assertEventName(eventName);if(!(isMetaEvent(eventName)&&!canEmitMetaEvents)){_context35.next=3;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 3:this.logIfDebugEnabled("emit",eventName,eventData);enqueueProducers(this,eventName,eventData);listeners=(_a=getListeners(this,eventName))!=null?_a:/* @__PURE__ */new Set();anyListeners=anyMap.get(this);staticListeners=[...listeners];staticAnyListeners=isMetaEvent(eventName)?[]:[...anyListeners];_context35.next=11;return resolvedPromise;case 11:_context35.next=13;return Promise.all([...staticListeners.map(/*#__PURE__*/function(){var _ref16=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee33(listener){return _regenerator.default.wrap(function _callee33$(_context33){while(1)switch(_context33.prev=_context33.next){case 0:if(!listeners.has(listener)){_context33.next=2;break;}return _context33.abrupt("return",listener(eventData));case 2:case"end":return _context33.stop();}},_callee33);}));return function(_x45){return _ref16.apply(this,arguments);};}()),...staticAnyListeners.map(/*#__PURE__*/function(){var _ref17=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee34(listener){return _regenerator.default.wrap(function _callee34$(_context34){while(1)switch(_context34.prev=_context34.next){case 0:if(!anyListeners.has(listener)){_context34.next=2;break;}return _context34.abrupt("return",listener(eventName,eventData));case 2:case"end":return _context34.stop();}},_callee34);}));return function(_x46){return _ref17.apply(this,arguments);};}())]);case 13:case"end":return _context35.stop();}},_callee35,this);}));function emit(_x43,_x44){return _emit3.apply(this,arguments);}return emit;}();_proto12.emitSerial=/*#__PURE__*/function(){var _emitSerial3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee36(eventName,eventData){var _a,listeners,anyListeners,staticListeners,staticAnyListeners,_i6,_staticListeners2,listener,_i7,_staticAnyListeners2;return _regenerator.default.wrap(function _callee36$(_context36){while(1)switch(_context36.prev=_context36.next){case 0:assertEventName(eventName);if(!(isMetaEvent(eventName)&&!canEmitMetaEvents)){_context36.next=3;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 3:this.logIfDebugEnabled("emitSerial",eventName,eventData);listeners=(_a=getListeners(this,eventName))!=null?_a:/* @__PURE__ */new Set();anyListeners=anyMap.get(this);staticListeners=[...listeners];staticAnyListeners=[...anyListeners];_context36.next=10;return resolvedPromise;case 10:_i6=0,_staticListeners2=staticListeners;case 11:if(!(_i6<_staticListeners2.length)){_context36.next=19;break;}listener=_staticListeners2[_i6];if(!listeners.has(listener)){_context36.next=16;break;}_context36.next=16;return listener(eventData);case 16:_i6++;_context36.next=11;break;case 19:_i7=0,_staticAnyListeners2=staticAnyListeners;case 20:if(!(_i7<_staticAnyListeners2.length)){_context36.next=28;break;}listener=_staticAnyListeners2[_i7];if(!anyListeners.has(listener)){_context36.next=25;break;}_context36.next=25;return listener(eventName,eventData);case 25:_i7++;_context36.next=20;break;case 28:case"end":return _context36.stop();}},_callee36,this);}));function emitSerial(_x47,_x48){return _emitSerial3.apply(this,arguments);}return emitSerial;}();_proto12.onAny=function onAny(listener){assertListener(listener);this.logIfDebugEnabled("subscribeAny",void 0,void 0);anyMap.get(this).add(listener);emitMetaEvent(this,listenerAdded,{listener});return this.offAny.bind(this,listener);};_proto12.anyEvent=function anyEvent(){return iterator(this);};_proto12.offAny=function offAny(listener){assertListener(listener);this.logIfDebugEnabled("unsubscribeAny",void 0,void 0);emitMetaEvent(this,listenerRemoved,{listener});anyMap.get(this).delete(listener);};_proto12.clearListeners=function clearListeners(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator54=_createForOfIteratorHelperLoose(eventNames),_step54;!(_step54=_iterator54()).done;){const eventName=_step54.value;this.logIfDebugEnabled("clear",eventName,void 0);if(typeof eventName==="string"||typeof eventName==="symbol"||typeof eventName==="number"){const set=getListeners(this,eventName);if(set){set.clear();}const producers=getEventProducers(this,eventName);if(producers){for(var _iterator55=_createForOfIteratorHelperLoose(producers),_step55;!(_step55=_iterator55()).done;){const producer=_step55.value;producer.finish();}producers.clear();}}else{anyMap.get(this).clear();for(var _iterator56=_createForOfIteratorHelperLoose(eventsMap.get(this).entries()),_step56;!(_step56=_iterator56()).done;){const _step56$value=_step56.value,eventName2=_step56$value[0],listeners=_step56$value[1];listeners.clear();eventsMap.get(this).delete(eventName2);}for(var _iterator57=_createForOfIteratorHelperLoose(producersMap.get(this).entries()),_step57;!(_step57=_iterator57()).done;){const _step57$value=_step57.value,eventName2=_step57$value[0],producers=_step57$value[1];for(var _iterator58=_createForOfIteratorHelperLoose(producers),_step58;!(_step58=_iterator58()).done;){const producer=_step58.value;producer.finish();}producers.clear();producersMap.get(this).delete(eventName2);}}}};_proto12.listenerCount=function listenerCount(eventNames){var _a,_b,_c,_d,_e2,_f;eventNames=Array.isArray(eventNames)?eventNames:[eventNames];let count=0;for(var _iterator59=_createForOfIteratorHelperLoose(eventNames),_step59;!(_step59=_iterator59()).done;){const eventName=_step59.value;if(typeof eventName==="string"){count+=anyMap.get(this).size+((_b=(_a=getListeners(this,eventName))==null?void 0:_a.size)!=null?_b:0)+((_d=(_c=getEventProducers(this,eventName))==null?void 0:_c.size)!=null?_d:0)+((_f=(_e2=getEventProducers(this))==null?void 0:_e2.size)!=null?_f:0);continue;}if(typeof eventName!=="undefined"){assertEventName(eventName);}count+=anyMap.get(this).size;for(var _iterator60=_createForOfIteratorHelperLoose(eventsMap.get(this).values()),_step60;!(_step60=_iterator60()).done;){const value=_step60.value;count+=value.size;}for(var _iterator61=_createForOfIteratorHelperLoose(producersMap.get(this).values()),_step61;!(_step61=_iterator61()).done;){const value=_step61.value;count+=value.size;}}return count;};_proto12.bindMethods=function bindMethods(target,methodNames){if(typeof target!=="object"||target===null){throw new TypeError("`target` must be an object");}methodNames=defaultMethodNamesOrAssert(methodNames);for(var _iterator62=_createForOfIteratorHelperLoose(methodNames),_step62;!(_step62=_iterator62()).done;){const methodName=_step62.value;if(target[methodName]!==void 0){throw new Error(`The property \`${methodName}\` already exists on \`target\``);}Object.defineProperty(target,methodName,{enumerable:false,value:this[methodName].bind(this)});}};(0,_createClass2.default)(Emittery2,null,[{key:"isDebugEnabled",get:function get(){var _a,_b;if(typeof((_a=_globalThis.process)==null?void 0:_a.env)!=="object"){return isGlobalDebugEnabled;}const _ref18=(_b=_globalThis.process)!=null?_b:{env:{}},env=_ref18.env;return env.DEBUG==="emittery"||env.DEBUG==="*"||isGlobalDebugEnabled;},set:function set(newValue){isGlobalDebugEnabled=newValue;}}]);return Emittery2;}();const allEmitteryMethods=Object.getOwnPropertyNames(Emittery2.prototype).filter(v2=>v2!=="constructor");Object.defineProperty(Emittery2,"listenerAdded",{value:listenerAdded,writable:false,enumerable:true,configurable:false});Object.defineProperty(Emittery2,"listenerRemoved",{value:listenerRemoved,writable:false,enumerable:true,configurable:false});function isInstanceOfEmittery(instance){return instance.onAny&&instance.emit;}function isChildClassOfEmittery(input){return input.prototype.onAny&&input.prototype.emit;}let nextId=0;function createWorkerized(_x49,_x50,_x51){return _createWorkerized.apply(this,arguments);}function _createWorkerized(){_createWorkerized=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee66(workerizedClass,worker,resolvers){var isEmittery,result,id;return _regenerator.default.wrap(function _callee66$(_context66){while(1)switch(_context66.prev=_context66.next){case 0:isEmittery=isChildClassOfEmittery(workerizedClass);result=isEmittery?new Emittery2():{};id=nextId++;Object.getOwnPropertyNames(workerizedClass.prototype).forEach(functionName=>{result[functionName]=function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return postCommand$1(worker,CommandType.FORWARD,functionName,args,resolvers);};});result.terminate=/*#__PURE__*/(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee65(){var _len2,args,_key2,response,_args57=arguments;return _regenerator.default.wrap(function _callee65$(_context65){while(1)switch(_context65.prev=_context65.next){case 0:for(_len2=_args57.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=_args57[_key2];}_context65.next=3;return postCommand$1(worker,CommandType.TERMINATE,"",args,resolvers);case 3:response=_context65.sent;delete workerized[id];worker.terminate();result.workerContext.worker=void 0;return _context65.abrupt("return",response);case 8:case"end":return _context65.stop();}},_callee65);}));result.workerContext={id,worker,resolvers};workerized[id]=result;return _context66.abrupt("return",result);case 8:case"end":return _context66.stop();}},_callee66);}));return _createWorkerized.apply(this,arguments);}function workerize(_x52,_x53){return _workerize.apply(this,arguments);}function _workerize(){_workerize=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee67(workerizedClass,workerClass){var resolvers,workerized2,worker;return _regenerator.default.wrap(function _callee67$(_context67){while(1)switch(_context67.prev=_context67.next){case 0:resolvers=/* @__PURE__ */new Map();_context67.next=3;return createWorker(workerizedClass,workerClass,resolvers,(name,data)=>{if(workerized2==null?void 0:workerized2.emit){workerized2==null?void 0:workerized2.emit(name,data);}});case 3:worker=_context67.sent;_context67.next=6;return createWorkerized(workerizedClass,worker,resolvers);case 6:workerized2=_context67.sent;return _context67.abrupt("return",workerized2);case 8:case"end":return _context67.stop();}},_callee67);}));return _workerize.apply(this,arguments);}function handleCommandForward(_x54,_x55){return _handleCommandForward.apply(this,arguments);}function _handleCommandForward(){_handleCommandForward=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee68(command,context){var functionName,args;return _regenerator.default.wrap(function _callee68$(_context68){while(1)switch(_context68.prev=_context68.next){case 0:functionName=command.functionName,args=command.args;if(context.instance){_context68.next=3;break;}throw"instance not initialized";case 3:if(functionName){_context68.next=5;break;}throw"missing function name to call";case 5:if(context.instance[functionName]){_context68.next=7;break;}throw`undefined function [${functionName}] in class ${context.instance.constructor.workerId}`;case 7:_context68.t0=postCommand;_context68.t1=command;_context68.next=11;return context.instance[functionName](...(args!=null?args:[]));case 11:_context68.t2=_context68.sent;(0,_context68.t0)(_context68.t1,_context68.t2);case 13:case"end":return _context68.stop();}},_callee68);}));return _handleCommandForward.apply(this,arguments);}const registeredWorkers=createGlobalThisVariable("registeredWorkers",{});function registerWorker(id,registrable){registrable.workerId=id;if(isWorker()){registeredWorkers[registrable.workerId]=registrable;}}function handleCommandInit(command,context){if(!command.args){throw"Missing className while initializing worker";}const _command$args=command.args,className=_command$args[0],globalsValues=_command$args[1];const constructor=registeredWorkers[className];if(constructor){context.instance=new constructor(command.args.slice(1));}else{throw`unknown worker class ${className}`;}copy(globalsValues,globals);if(isInstanceOfEmittery(context.instance)){context.instance.onAny((name,data)=>{postCommand({type:CommandType.EVENT},{name,data});});}postCommand(command,typeof context.instance!==void 0);}function handleCommandTerminate(_x56,_x57){return _handleCommandTerminate.apply(this,arguments);}function _handleCommandTerminate(){_handleCommandTerminate=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee69(command,context){var args,result;return _regenerator.default.wrap(function _callee69$(_context69){while(1)switch(_context69.prev=_context69.next){case 0:args=command.args;if(context.instance){_context69.next=3;break;}throw"instance not initialized";case 3:if(!context.instance.terminate){_context69.next=7;break;}_context69.next=6;return context.instance.terminate(...(args!=null?args:[]));case 6:result=_context69.sent;case 7:postCommand(command,result);case 8:case"end":return _context69.stop();}},_callee69);}));return _handleCommandTerminate.apply(this,arguments);}function handleCommandGlobalsSync(command){if(!command.args){throw"Missing globals while syncing";}copy(command.args[0],globals);postCommand(command,{});}function initWorker(){const context={};onmessage=/*#__PURE__*/function(){var _ref19=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee37(event){var command;return _regenerator.default.wrap(function _callee37$(_context37){while(1)switch(_context37.prev=_context37.next){case 0:command=event.data;_context37.t0=command.type;_context37.next=_context37.t0===CommandType.INIT?4:_context37.t0===CommandType.FORWARD?6:_context37.t0===CommandType.TERMINATE?8:_context37.t0===CommandType.GLOBALS_SYNC?10:12;break;case 4:handleCommandInit(command,context);return _context37.abrupt("break",12);case 6:handleCommandForward(command,context);return _context37.abrupt("break",12);case 8:handleCommandTerminate(command,context);return _context37.abrupt("break",12);case 10:handleCommandGlobalsSync(command);return _context37.abrupt("break",12);case 12:case"end":return _context37.stop();}},_callee37);}));return function onmessage(_x58){return _ref19.apply(this,arguments);};}();}if(isWorker()){initWorker();}const _ProcessorWorker=/*#__PURE__*/function(_Emittery$2){(0,_inheritsLoose2.default)(_ProcessorWorker2,_Emittery$2);function _ProcessorWorker2(){var _this15;_this15=_Emittery$2.apply(this,arguments)||this;_this15.processor=new Ce();return _this15;}var _proto13=_ProcessorWorker2.prototype;_proto13.init=/*#__PURE__*/function(){var _init2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee38(options){return _regenerator.default.wrap(function _callee38$(_context38){while(1)switch(_context38.prev=_context38.next){case 0:if(options===void 0){options={};}this.transformer=new NoiseSuppressionTransformer();this.processor.onAny((name,data)=>this.emit(name,data));this.transformer.onAny((name,data)=>this.emit(name,data));_context38.next=6;return this.transformer.init(options);case 6:_context38.next=8;return this.processor.setTransformers([this.transformer]);case 8:case"end":return _context38.stop();}},_callee38,this);}));function init(_x59){return _init2.apply(this,arguments);}return init;}();_proto13.transform=function transform(readable,writable){this.processor.transform(readable,writable);};_proto13.setAudioOptions=function setAudioOptions(echo_cancellation,auto_gain_control,noise_suppression,stereo_swapping,highpass_filter){var _this$transformer;(_this$transformer=this.transformer)==null?void 0:_this$transformer.setAudioOptions(echo_cancellation,auto_gain_control,noise_suppression,stereo_swapping,highpass_filter);};_proto13.enable=function enable(){var _this$transformer2;(_this$transformer2=this.transformer)==null?void 0:_this$transformer2.enable();};_proto13.disable=function disable(){var _this$transformer3;(_this$transformer3=this.transformer)==null?void 0:_this$transformer3.disable();};_proto13.terminate=/*#__PURE__*/function(){var _terminate=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee39(){return _regenerator.default.wrap(function _callee39$(_context39){while(1)switch(_context39.prev=_context39.next){case 0:_context39.next=2;return this.processor.destroy();case 2:case"end":return _context39.stop();}},_callee39,this);}));function terminate(){return _terminate.apply(this,arguments);}return terminate;}()/**
   * @internal
   */;_proto13.getWav=function getWav(){var _this$transformer$get,_this$transformer4;return(_this$transformer$get=(_this$transformer4=this.transformer)==null?void 0:_this$transformer4.getWav())!=null?_this$transformer$get:"";}/**
   * Return the latency of the transformation
   * The latency will be computed only if the options debug flag is true
   * Otherwise, will return 0;
   * @returns latency
   */;_proto13.getLatency=function getLatency(){var _this$transformer$get2,_this$transformer5;return(_this$transformer$get2=(_this$transformer5=this.transformer)==null?void 0:_this$transformer5.getLatency())!=null?_this$transformer$get2:0;}/**
   * Return the latency of processing within the wasm in nanoseconds.
   * @returns latency
   */;_proto13.getWasmLatencyNs=function getWasmLatencyNs(){var _this$transformer$get3,_this$transformer6;return(_this$transformer$get3=(_this$transformer6=this.transformer)==null?void 0:_this$transformer6.getWasmLatencyNs())!=null?_this$transformer$get3:0;};return _ProcessorWorker2;}(Emittery$1);registerWorker("ProcessorWorker",_ProcessorWorker);let ProcessorWorker=_ProcessorWorker;const encodedJs="bGV0IGNyZWF0ZVdhc21Nb25vSW5zdGFuY2U7IHsKCnZhciBNb2R1bGUgPSAoKCkgPT4gewogIHZhciBfc2NyaXB0RGlyID0gbG9jYXRpb24uaHJlZjsKICAKICByZXR1cm4gKApmdW5jdGlvbihtb2R1bGVBcmcgPSB7fSkgewoKdmFyIE1vZHVsZT1tb2R1bGVBcmc7dmFyIHJlYWR5UHJvbWlzZVJlc29sdmUscmVhZHlQcm9taXNlUmVqZWN0O01vZHVsZVsicmVhZHkiXT1uZXcgUHJvbWlzZSgocmVzb2x2ZSxyZWplY3QpPT57cmVhZHlQcm9taXNlUmVzb2x2ZT1yZXNvbHZlO3JlYWR5UHJvbWlzZVJlamVjdD1yZWplY3R9KTt2YXIgbW9kdWxlT3ZlcnJpZGVzPU9iamVjdC5hc3NpZ24oe30sTW9kdWxlKTt2YXIgYXJndW1lbnRzXz1bXTt2YXIgdGhpc1Byb2dyYW09Ii4vdGhpcy5wcm9ncmFtIjt2YXIgcXVpdF89KHN0YXR1cyx0b1Rocm93KT0+e3Rocm93IHRvVGhyb3d9O3ZhciBFTlZJUk9OTUVOVF9JU19XRUI9dHlwZW9mIHdpbmRvdz09Im9iamVjdCI7dmFyIEVOVklST05NRU5UX0lTX1dPUktFUj10eXBlb2YgaW1wb3J0U2NyaXB0cz09ImZ1bmN0aW9uIjt2YXIgRU5WSVJPTk1FTlRfSVNfTk9ERT10eXBlb2YgcHJvY2Vzcz09Im9iamVjdCImJnR5cGVvZiBwcm9jZXNzLnZlcnNpb25zPT0ib2JqZWN0IiYmdHlwZW9mIHByb2Nlc3MudmVyc2lvbnMubm9kZT09InN0cmluZyI7dmFyIHNjcmlwdERpcmVjdG9yeT0iIjtmdW5jdGlvbiBsb2NhdGVGaWxlKHBhdGgpe2lmKE1vZHVsZVsibG9jYXRlRmlsZSJdKXtyZXR1cm4gTW9kdWxlWyJsb2NhdGVGaWxlIl0ocGF0aCxzY3JpcHREaXJlY3RvcnkpfXJldHVybiBzY3JpcHREaXJlY3RvcnkrcGF0aH12YXIgcmVhZF8scmVhZEFzeW5jLHJlYWRCaW5hcnk7aWYoRU5WSVJPTk1FTlRfSVNfV0VCfHxFTlZJUk9OTUVOVF9JU19XT1JLRVIpe2lmKEVOVklST05NRU5UX0lTX1dPUktFUil7c2NyaXB0RGlyZWN0b3J5PXNlbGYubG9jYXRpb24uaHJlZn1lbHNlIGlmKHR5cGVvZiBkb2N1bWVudCE9InVuZGVmaW5lZCImJmRvY3VtZW50LmN1cnJlbnRTY3JpcHQpe3NjcmlwdERpcmVjdG9yeT1kb2N1bWVudC5jdXJyZW50U2NyaXB0LnNyY31pZihfc2NyaXB0RGlyKXtzY3JpcHREaXJlY3Rvcnk9X3NjcmlwdERpcn1pZihzY3JpcHREaXJlY3RvcnkuaW5kZXhPZigiYmxvYjoiKSE9PTApe3NjcmlwdERpcmVjdG9yeT1zY3JpcHREaXJlY3Rvcnkuc3Vic3RyKDAsc2NyaXB0RGlyZWN0b3J5LnJlcGxhY2UoL1s/I10uKi8sIiIpLmxhc3RJbmRleE9mKCIvIikrMSl9ZWxzZXtzY3JpcHREaXJlY3Rvcnk9IiJ9e3JlYWRfPXVybD0+e3ZhciB4aHI9bmV3IFhNTEh0dHBSZXF1ZXN0O3hoci5vcGVuKCJHRVQiLHVybCxmYWxzZSk7eGhyLnNlbmQobnVsbCk7cmV0dXJuIHhoci5yZXNwb25zZVRleHR9O2lmKEVOVklST05NRU5UX0lTX1dPUktFUil7cmVhZEJpbmFyeT11cmw9Pnt2YXIgeGhyPW5ldyBYTUxIdHRwUmVxdWVzdDt4aHIub3BlbigiR0VUIix1cmwsZmFsc2UpO3hoci5yZXNwb25zZVR5cGU9ImFycmF5YnVmZmVyIjt4aHIuc2VuZChudWxsKTtyZXR1cm4gbmV3IFVpbnQ4QXJyYXkoeGhyLnJlc3BvbnNlKX19cmVhZEFzeW5jPSh1cmwsb25sb2FkLG9uZXJyb3IpPT57dmFyIHhocj1uZXcgWE1MSHR0cFJlcXVlc3Q7eGhyLm9wZW4oIkdFVCIsdXJsLHRydWUpO3hoci5yZXNwb25zZVR5cGU9ImFycmF5YnVmZmVyIjt4aHIub25sb2FkPSgpPT57aWYoeGhyLnN0YXR1cz09MjAwfHx4aHIuc3RhdHVzPT0wJiZ4aHIucmVzcG9uc2Upe29ubG9hZCh4aHIucmVzcG9uc2UpO3JldHVybn1vbmVycm9yKCl9O3hoci5vbmVycm9yPW9uZXJyb3I7eGhyLnNlbmQobnVsbCl9fX1lbHNle312YXIgb3V0PU1vZHVsZVsicHJpbnQiXXx8Y29uc29sZS5sb2cuYmluZChjb25zb2xlKTt2YXIgZXJyPU1vZHVsZVsicHJpbnRFcnIiXXx8Y29uc29sZS5lcnJvci5iaW5kKGNvbnNvbGUpO09iamVjdC5hc3NpZ24oTW9kdWxlLG1vZHVsZU92ZXJyaWRlcyk7bW9kdWxlT3ZlcnJpZGVzPW51bGw7aWYoTW9kdWxlWyJhcmd1bWVudHMiXSlhcmd1bWVudHNfPU1vZHVsZVsiYXJndW1lbnRzIl07aWYoTW9kdWxlWyJ0aGlzUHJvZ3JhbSJdKXRoaXNQcm9ncmFtPU1vZHVsZVsidGhpc1Byb2dyYW0iXTtpZihNb2R1bGVbInF1aXQiXSlxdWl0Xz1Nb2R1bGVbInF1aXQiXTt2YXIgd2FzbUJpbmFyeTtpZihNb2R1bGVbIndhc21CaW5hcnkiXSl3YXNtQmluYXJ5PU1vZHVsZVsid2FzbUJpbmFyeSJdO2lmKHR5cGVvZiBXZWJBc3NlbWJseSE9Im9iamVjdCIpe2Fib3J0KCJubyBuYXRpdmUgd2FzbSBzdXBwb3J0IGRldGVjdGVkIil9dmFyIHdhc21NZW1vcnk7dmFyIEFCT1JUPWZhbHNlO3ZhciBFWElUU1RBVFVTO2Z1bmN0aW9uIGFzc2VydChjb25kaXRpb24sdGV4dCl7aWYoIWNvbmRpdGlvbil7YWJvcnQodGV4dCl9fXZhciBIRUFQOCxIRUFQVTgsSEVBUDE2LEhFQVBVMTYsSEVBUDMyLEhFQVBVMzIsSEVBUEYzMixIRUFQRjY0O2Z1bmN0aW9uIHVwZGF0ZU1lbW9yeVZpZXdzKCl7dmFyIGI9d2FzbU1lbW9yeS5idWZmZXI7TW9kdWxlWyJIRUFQOCJdPUhFQVA4PW5ldyBJbnQ4QXJyYXkoYik7TW9kdWxlWyJIRUFQMTYiXT1IRUFQMTY9bmV3IEludDE2QXJyYXkoYik7TW9kdWxlWyJIRUFQVTgiXT1IRUFQVTg9bmV3IFVpbnQ4QXJyYXkoYik7TW9kdWxlWyJIRUFQVTE2Il09SEVBUFUxNj1uZXcgVWludDE2QXJyYXkoYik7TW9kdWxlWyJIRUFQMzIiXT1IRUFQMzI9bmV3IEludDMyQXJyYXkoYik7TW9kdWxlWyJIRUFQVTMyIl09SEVBUFUzMj1uZXcgVWludDMyQXJyYXkoYik7TW9kdWxlWyJIRUFQRjMyIl09SEVBUEYzMj1uZXcgRmxvYXQzMkFycmF5KGIpO01vZHVsZVsiSEVBUEY2NCJdPUhFQVBGNjQ9bmV3IEZsb2F0NjRBcnJheShiKX12YXIgX19BVFBSRVJVTl9fPVtdO3ZhciBfX0FUSU5JVF9fPVtdO3ZhciBfX0FURVhJVF9fPVtdO3ZhciBfX0FUUE9TVFJVTl9fPVtdO3ZhciBydW50aW1lSW5pdGlhbGl6ZWQ9ZmFsc2U7dmFyIHJ1bnRpbWVFeGl0ZWQ9ZmFsc2U7ZnVuY3Rpb24gcHJlUnVuKCl7aWYoTW9kdWxlWyJwcmVSdW4iXSl7aWYodHlwZW9mIE1vZHVsZVsicHJlUnVuIl09PSJmdW5jdGlvbiIpTW9kdWxlWyJwcmVSdW4iXT1bTW9kdWxlWyJwcmVSdW4iXV07d2hpbGUoTW9kdWxlWyJwcmVSdW4iXS5sZW5ndGgpe2FkZE9uUHJlUnVuKE1vZHVsZVsicHJlUnVuIl0uc2hpZnQoKSl9fWNhbGxSdW50aW1lQ2FsbGJhY2tzKF9fQVRQUkVSVU5fXyl9ZnVuY3Rpb24gaW5pdFJ1bnRpbWUoKXtydW50aW1lSW5pdGlhbGl6ZWQ9dHJ1ZTtpZighTW9kdWxlWyJub0ZTSW5pdCJdJiYhRlMuaW5pdC5pbml0aWFsaXplZClGUy5pbml0KCk7RlMuaWdub3JlUGVybWlzc2lvbnM9ZmFsc2U7VFRZLmluaXQoKTtjYWxsUnVudGltZUNhbGxiYWNrcyhfX0FUSU5JVF9fKX1mdW5jdGlvbiBleGl0UnVudGltZSgpe19fX2Z1bmNzX29uX2V4aXQoKTtjYWxsUnVudGltZUNhbGxiYWNrcyhfX0FURVhJVF9fKTtGUy5xdWl0KCk7VFRZLnNodXRkb3duKCk7cnVudGltZUV4aXRlZD10cnVlfWZ1bmN0aW9uIHBvc3RSdW4oKXtpZihNb2R1bGVbInBvc3RSdW4iXSl7aWYodHlwZW9mIE1vZHVsZVsicG9zdFJ1biJdPT0iZnVuY3Rpb24iKU1vZHVsZVsicG9zdFJ1biJdPVtNb2R1bGVbInBvc3RSdW4iXV07d2hpbGUoTW9kdWxlWyJwb3N0UnVuIl0ubGVuZ3RoKXthZGRPblBvc3RSdW4oTW9kdWxlWyJwb3N0UnVuIl0uc2hpZnQoKSl9fWNhbGxSdW50aW1lQ2FsbGJhY2tzKF9fQVRQT1NUUlVOX18pfWZ1bmN0aW9uIGFkZE9uUHJlUnVuKGNiKXtfX0FUUFJFUlVOX18udW5zaGlmdChjYil9ZnVuY3Rpb24gYWRkT25Jbml0KGNiKXtfX0FUSU5JVF9fLnVuc2hpZnQoY2IpfWZ1bmN0aW9uIGFkZE9uUG9zdFJ1bihjYil7X19BVFBPU1RSVU5fXy51bnNoaWZ0KGNiKX12YXIgcnVuRGVwZW5kZW5jaWVzPTA7dmFyIHJ1bkRlcGVuZGVuY3lXYXRjaGVyPW51bGw7dmFyIGRlcGVuZGVuY2llc0Z1bGZpbGxlZD1udWxsO2Z1bmN0aW9uIGdldFVuaXF1ZVJ1bkRlcGVuZGVuY3koaWQpe3JldHVybiBpZH1mdW5jdGlvbiBhZGRSdW5EZXBlbmRlbmN5KGlkKXtydW5EZXBlbmRlbmNpZXMrKztpZihNb2R1bGVbIm1vbml0b3JSdW5EZXBlbmRlbmNpZXMiXSl7TW9kdWxlWyJtb25pdG9yUnVuRGVwZW5kZW5jaWVzIl0ocnVuRGVwZW5kZW5jaWVzKX19ZnVuY3Rpb24gcmVtb3ZlUnVuRGVwZW5kZW5jeShpZCl7cnVuRGVwZW5kZW5jaWVzLS07aWYoTW9kdWxlWyJtb25pdG9yUnVuRGVwZW5kZW5jaWVzIl0pe01vZHVsZVsibW9uaXRvclJ1bkRlcGVuZGVuY2llcyJdKHJ1bkRlcGVuZGVuY2llcyl9aWYocnVuRGVwZW5kZW5jaWVzPT0wKXtpZihydW5EZXBlbmRlbmN5V2F0Y2hlciE9PW51bGwpe2NsZWFySW50ZXJ2YWwocnVuRGVwZW5kZW5jeVdhdGNoZXIpO3J1bkRlcGVuZGVuY3lXYXRjaGVyPW51bGx9aWYoZGVwZW5kZW5jaWVzRnVsZmlsbGVkKXt2YXIgY2FsbGJhY2s9ZGVwZW5kZW5jaWVzRnVsZmlsbGVkO2RlcGVuZGVuY2llc0Z1bGZpbGxlZD1udWxsO2NhbGxiYWNrKCl9fX1mdW5jdGlvbiBhYm9ydCh3aGF0KXtpZihNb2R1bGVbIm9uQWJvcnQiXSl7TW9kdWxlWyJvbkFib3J0Il0od2hhdCl9d2hhdD0iQWJvcnRlZCgiK3doYXQrIikiO2Vycih3aGF0KTtBQk9SVD10cnVlO0VYSVRTVEFUVVM9MTt3aGF0Kz0iLiBCdWlsZCB3aXRoIC1zQVNTRVJUSU9OUyBmb3IgbW9yZSBpbmZvLiI7dmFyIGU9bmV3IFdlYkFzc2VtYmx5LlJ1bnRpbWVFcnJvcih3aGF0KTtyZWFkeVByb21pc2VSZWplY3QoZSk7dGhyb3cgZX12YXIgZGF0YVVSSVByZWZpeD0iZGF0YTphcHBsaWNhdGlvbi9vY3RldC1zdHJlYW07YmFzZTY0LCI7dmFyIGlzRGF0YVVSST1maWxlbmFtZT0+ZmlsZW5hbWUuc3RhcnRzV2l0aChkYXRhVVJJUHJlZml4KTt2YXIgd2FzbUJpbmFyeUZpbGU7aWYoTW9kdWxlWyJsb2NhdGVGaWxlIl0pe3dhc21CaW5hcnlGaWxlPSJtYWluLWJpbi1tb25vLndhc20iO2lmKCFpc0RhdGFVUkkod2FzbUJpbmFyeUZpbGUpKXt3YXNtQmluYXJ5RmlsZT1sb2NhdGVGaWxlKHdhc21CaW5hcnlGaWxlKX19ZWxzZXt3YXNtQmluYXJ5RmlsZT1uZXcgVVJMKCJtYWluLWJpbi1tb25vLndhc20iLGxvY2F0aW9uLmhyZWYpLmhyZWZ9ZnVuY3Rpb24gZ2V0QmluYXJ5U3luYyhmaWxlKXtpZihmaWxlPT13YXNtQmluYXJ5RmlsZSYmd2FzbUJpbmFyeSl7cmV0dXJuIG5ldyBVaW50OEFycmF5KHdhc21CaW5hcnkpfWlmKHJlYWRCaW5hcnkpe3JldHVybiByZWFkQmluYXJ5KGZpbGUpfXRocm93ImJvdGggYXN5bmMgYW5kIHN5bmMgZmV0Y2hpbmcgb2YgdGhlIHdhc20gZmFpbGVkIn1mdW5jdGlvbiBnZXRCaW5hcnlQcm9taXNlKGJpbmFyeUZpbGUpe2lmKCF3YXNtQmluYXJ5JiYoRU5WSVJPTk1FTlRfSVNfV0VCfHxFTlZJUk9OTUVOVF9JU19XT1JLRVIpKXtpZih0eXBlb2YgZmV0Y2g9PSJmdW5jdGlvbiIpe3JldHVybiBmZXRjaChiaW5hcnlGaWxlLHtjcmVkZW50aWFsczoic2FtZS1vcmlnaW4ifSkudGhlbihyZXNwb25zZT0+e2lmKCFyZXNwb25zZVsib2siXSl7dGhyb3ciZmFpbGVkIHRvIGxvYWQgd2FzbSBiaW5hcnkgZmlsZSBhdCAnIitiaW5hcnlGaWxlKyInIn1yZXR1cm4gcmVzcG9uc2VbImFycmF5QnVmZmVyIl0oKX0pLmNhdGNoKCgpPT5nZXRCaW5hcnlTeW5jKGJpbmFyeUZpbGUpKX19cmV0dXJuIFByb21pc2UucmVzb2x2ZSgpLnRoZW4oKCk9PmdldEJpbmFyeVN5bmMoYmluYXJ5RmlsZSkpfWZ1bmN0aW9uIGluc3RhbnRpYXRlQXJyYXlCdWZmZXIoYmluYXJ5RmlsZSxpbXBvcnRzLHJlY2VpdmVyKXtyZXR1cm4gZ2V0QmluYXJ5UHJvbWlzZShiaW5hcnlGaWxlKS50aGVuKGJpbmFyeT0+V2ViQXNzZW1ibHkuaW5zdGFudGlhdGUoYmluYXJ5LGltcG9ydHMpKS50aGVuKGluc3RhbmNlPT5pbnN0YW5jZSkudGhlbihyZWNlaXZlcixyZWFzb249PntlcnIoYGZhaWxlZCB0byBhc3luY2hyb25vdXNseSBwcmVwYXJlIHdhc206ICR7cmVhc29ufWApO2Fib3J0KHJlYXNvbil9KX1mdW5jdGlvbiBpbnN0YW50aWF0ZUFzeW5jKGJpbmFyeSxiaW5hcnlGaWxlLGltcG9ydHMsY2FsbGJhY2spe2lmKCFiaW5hcnkmJnR5cGVvZiBXZWJBc3NlbWJseS5pbnN0YW50aWF0ZVN0cmVhbWluZz09ImZ1bmN0aW9uIiYmIWlzRGF0YVVSSShiaW5hcnlGaWxlKSYmdHlwZW9mIGZldGNoPT0iZnVuY3Rpb24iKXtyZXR1cm4gZmV0Y2goYmluYXJ5RmlsZSx7Y3JlZGVudGlhbHM6InNhbWUtb3JpZ2luIn0pLnRoZW4ocmVzcG9uc2U9Pnt2YXIgcmVzdWx0PVdlYkFzc2VtYmx5Lmluc3RhbnRpYXRlU3RyZWFtaW5nKHJlc3BvbnNlLGltcG9ydHMpO3JldHVybiByZXN1bHQudGhlbihjYWxsYmFjayxmdW5jdGlvbihyZWFzb24pe2Vycihgd2FzbSBzdHJlYW1pbmcgY29tcGlsZSBmYWlsZWQ6ICR7cmVhc29ufWApO2VycigiZmFsbGluZyBiYWNrIHRvIEFycmF5QnVmZmVyIGluc3RhbnRpYXRpb24iKTtyZXR1cm4gaW5zdGFudGlhdGVBcnJheUJ1ZmZlcihiaW5hcnlGaWxlLGltcG9ydHMsY2FsbGJhY2spfSl9KX1yZXR1cm4gaW5zdGFudGlhdGVBcnJheUJ1ZmZlcihiaW5hcnlGaWxlLGltcG9ydHMsY2FsbGJhY2spfWZ1bmN0aW9uIGNyZWF0ZVdhc20oKXt2YXIgaW5mbz17ImEiOndhc21JbXBvcnRzfTtmdW5jdGlvbiByZWNlaXZlSW5zdGFuY2UoaW5zdGFuY2UsbW9kdWxlKXt3YXNtRXhwb3J0cz1pbnN0YW5jZS5leHBvcnRzO3dhc21NZW1vcnk9d2FzbUV4cG9ydHNbInVhIl07dXBkYXRlTWVtb3J5Vmlld3MoKTt3YXNtVGFibGU9d2FzbUV4cG9ydHNbIndhIl07YWRkT25Jbml0KHdhc21FeHBvcnRzWyJ2YSJdKTtyZW1vdmVSdW5EZXBlbmRlbmN5KCJ3YXNtLWluc3RhbnRpYXRlIik7cmV0dXJuIHdhc21FeHBvcnRzfWFkZFJ1bkRlcGVuZGVuY3koIndhc20taW5zdGFudGlhdGUiKTtmdW5jdGlvbiByZWNlaXZlSW5zdGFudGlhdGlvblJlc3VsdChyZXN1bHQpe3JlY2VpdmVJbnN0YW5jZShyZXN1bHRbImluc3RhbmNlIl0pfWlmKE1vZHVsZVsiaW5zdGFudGlhdGVXYXNtIl0pe3RyeXtyZXR1cm4gTW9kdWxlWyJpbnN0YW50aWF0ZVdhc20iXShpbmZvLHJlY2VpdmVJbnN0YW5jZSl9Y2F0Y2goZSl7ZXJyKGBNb2R1bGUuaW5zdGFudGlhdGVXYXNtIGNhbGxiYWNrIGZhaWxlZCB3aXRoIGVycm9yOiAke2V9YCk7cmVhZHlQcm9taXNlUmVqZWN0KGUpfX1pbnN0YW50aWF0ZUFzeW5jKHdhc21CaW5hcnksd2FzbUJpbmFyeUZpbGUsaW5mbyxyZWNlaXZlSW5zdGFudGlhdGlvblJlc3VsdCkuY2F0Y2gocmVhZHlQcm9taXNlUmVqZWN0KTtyZXR1cm57fX12YXIgdGVtcERvdWJsZTt2YXIgdGVtcEk2NDtmdW5jdGlvbiB4bm5Mb2FkV2FzbU1vZHVsZUpTKGNvZGUsb2Zmc2V0LG9mZnNldF9lbmQsaW52YWxpZF9mdW5jdGlvbl9pbmRleCl7Y29uc3QgdGFibGVPcmlnaW5hbFNpemU9d2FzbVRhYmxlLmxlbmd0aDtjb25zdCBiaW5hcnk9bmV3IFVpbnQ4QXJyYXkoSEVBUFU4LnNsaWNlKGNvZGUrb2Zmc2V0LGNvZGUrb2Zmc2V0X2VuZCkpO3RyeXt2YXIgbW9kdWxlPW5ldyBXZWJBc3NlbWJseS5Nb2R1bGUoYmluYXJ5KTt2YXIgaW5zdGFuY2U9bmV3IFdlYkFzc2VtYmx5Lkluc3RhbmNlKG1vZHVsZSx7ZW52OnttZW1vcnk6d2FzbU1lbW9yeX19KTtmb3IodmFyIHN5bU5hbWUgaW4gaW5zdGFuY2UuZXhwb3J0cyl7dmFyIHZhbHVlPWluc3RhbmNlLmV4cG9ydHNbc3ltTmFtZV07YWRkRnVuY3Rpb24odmFsdWUpfWlmKHRhYmxlT3JpZ2luYWxTaXplPHdhc21UYWJsZS5sZW5ndGgpe3JldHVybiB0YWJsZU9yaWdpbmFsU2l6ZX1yZXR1cm4gaW52YWxpZF9mdW5jdGlvbl9pbmRleH1jYXRjaChlcnJvcil7Y29uc29sZS5sb2coZXJyb3IpO3JldHVybiBpbnZhbGlkX2Z1bmN0aW9uX2luZGV4fX1mdW5jdGlvbiBFeGl0U3RhdHVzKHN0YXR1cyl7dGhpcy5uYW1lPSJFeGl0U3RhdHVzIjt0aGlzLm1lc3NhZ2U9YFByb2dyYW0gdGVybWluYXRlZCB3aXRoIGV4aXQoJHtzdGF0dXN9KWA7dGhpcy5zdGF0dXM9c3RhdHVzfXZhciBjYWxsUnVudGltZUNhbGxiYWNrcz1jYWxsYmFja3M9Pnt3aGlsZShjYWxsYmFja3MubGVuZ3RoPjApe2NhbGxiYWNrcy5zaGlmdCgpKE1vZHVsZSl9fTt2YXIgbm9FeGl0UnVudGltZT1Nb2R1bGVbIm5vRXhpdFJ1bnRpbWUiXXx8ZmFsc2U7dmFyIFVURjhEZWNvZGVyPXR5cGVvZiBUZXh0RGVjb2RlciE9InVuZGVmaW5lZCI/bmV3IFRleHREZWNvZGVyKCJ1dGY4Iik6dW5kZWZpbmVkO3ZhciBVVEY4QXJyYXlUb1N0cmluZz0oaGVhcE9yQXJyYXksaWR4LG1heEJ5dGVzVG9SZWFkKT0+e3ZhciBlbmRJZHg9aWR4K21heEJ5dGVzVG9SZWFkO3ZhciBlbmRQdHI9aWR4O3doaWxlKGhlYXBPckFycmF5W2VuZFB0cl0mJiEoZW5kUHRyPj1lbmRJZHgpKSsrZW5kUHRyO2lmKGVuZFB0ci1pZHg+MTYmJmhlYXBPckFycmF5LmJ1ZmZlciYmVVRGOERlY29kZXIpe3JldHVybiBVVEY4RGVjb2Rlci5kZWNvZGUoaGVhcE9yQXJyYXkuc3ViYXJyYXkoaWR4LGVuZFB0cikpfXZhciBzdHI9IiI7d2hpbGUoaWR4PGVuZFB0cil7dmFyIHUwPWhlYXBPckFycmF5W2lkeCsrXTtpZighKHUwJjEyOCkpe3N0cis9U3RyaW5nLmZyb21DaGFyQ29kZSh1MCk7Y29udGludWV9dmFyIHUxPWhlYXBPckFycmF5W2lkeCsrXSY2MztpZigodTAmMjI0KT09MTkyKXtzdHIrPVN0cmluZy5mcm9tQ2hhckNvZGUoKHUwJjMxKTw8Nnx1MSk7Y29udGludWV9dmFyIHUyPWhlYXBPckFycmF5W2lkeCsrXSY2MztpZigodTAmMjQwKT09MjI0KXt1MD0odTAmMTUpPDwxMnx1MTw8Nnx1Mn1lbHNle3UwPSh1MCY3KTw8MTh8dTE8PDEyfHUyPDw2fGhlYXBPckFycmF5W2lkeCsrXSY2M31pZih1MDw2NTUzNil7c3RyKz1TdHJpbmcuZnJvbUNoYXJDb2RlKHUwKX1lbHNle3ZhciBjaD11MC02NTUzNjtzdHIrPVN0cmluZy5mcm9tQ2hhckNvZGUoNTUyOTZ8Y2g+PjEwLDU2MzIwfGNoJjEwMjMpfX1yZXR1cm4gc3RyfTt2YXIgVVRGOFRvU3RyaW5nPShwdHIsbWF4Qnl0ZXNUb1JlYWQpPT5wdHI/VVRGOEFycmF5VG9TdHJpbmcoSEVBUFU4LHB0cixtYXhCeXRlc1RvUmVhZCk6IiI7dmFyIF9fX2Fzc2VydF9mYWlsPShjb25kaXRpb24sZmlsZW5hbWUsbGluZSxmdW5jKT0+e2Fib3J0KGBBc3NlcnRpb24gZmFpbGVkOiAke1VURjhUb1N0cmluZyhjb25kaXRpb24pfSwgYXQ6IGArW2ZpbGVuYW1lP1VURjhUb1N0cmluZyhmaWxlbmFtZSk6InVua25vd24gZmlsZW5hbWUiLGxpbmUsZnVuYz9VVEY4VG9TdHJpbmcoZnVuYyk6InVua25vd24gZnVuY3Rpb24iXSl9O3ZhciBleGNlcHRpb25DYXVnaHQ9W107dmFyIHVuY2F1Z2h0RXhjZXB0aW9uQ291bnQ9MDt2YXIgX19fY3hhX2JlZ2luX2NhdGNoPXB0cj0+e3ZhciBpbmZvPW5ldyBFeGNlcHRpb25JbmZvKHB0cik7aWYoIWluZm8uZ2V0X2NhdWdodCgpKXtpbmZvLnNldF9jYXVnaHQodHJ1ZSk7dW5jYXVnaHRFeGNlcHRpb25Db3VudC0tfWluZm8uc2V0X3JldGhyb3duKGZhbHNlKTtleGNlcHRpb25DYXVnaHQucHVzaChpbmZvKTtfX19jeGFfaW5jcmVtZW50X2V4Y2VwdGlvbl9yZWZjb3VudChpbmZvLmV4Y1B0cik7cmV0dXJuIGluZm8uZ2V0X2V4Y2VwdGlvbl9wdHIoKX07dmFyIGV4Y2VwdGlvbkxhc3Q9MDt2YXIgX19fY3hhX2VuZF9jYXRjaD0oKT0+e19zZXRUaHJldygwLDApO3ZhciBpbmZvPWV4Y2VwdGlvbkNhdWdodC5wb3AoKTtfX19jeGFfZGVjcmVtZW50X2V4Y2VwdGlvbl9yZWZjb3VudChpbmZvLmV4Y1B0cik7ZXhjZXB0aW9uTGFzdD0wfTtmdW5jdGlvbiBFeGNlcHRpb25JbmZvKGV4Y1B0cil7dGhpcy5leGNQdHI9ZXhjUHRyO3RoaXMucHRyPWV4Y1B0ci0yNDt0aGlzLnNldF90eXBlPWZ1bmN0aW9uKHR5cGUpe0hFQVBVMzJbdGhpcy5wdHIrND4+Ml09dHlwZX07dGhpcy5nZXRfdHlwZT1mdW5jdGlvbigpe3JldHVybiBIRUFQVTMyW3RoaXMucHRyKzQ+PjJdfTt0aGlzLnNldF9kZXN0cnVjdG9yPWZ1bmN0aW9uKGRlc3RydWN0b3Ipe0hFQVBVMzJbdGhpcy5wdHIrOD4+Ml09ZGVzdHJ1Y3Rvcn07dGhpcy5nZXRfZGVzdHJ1Y3Rvcj1mdW5jdGlvbigpe3JldHVybiBIRUFQVTMyW3RoaXMucHRyKzg+PjJdfTt0aGlzLnNldF9jYXVnaHQ9ZnVuY3Rpb24oY2F1Z2h0KXtjYXVnaHQ9Y2F1Z2h0PzE6MDtIRUFQOFt0aGlzLnB0cisxMj4+MF09Y2F1Z2h0fTt0aGlzLmdldF9jYXVnaHQ9ZnVuY3Rpb24oKXtyZXR1cm4gSEVBUDhbdGhpcy5wdHIrMTI+PjBdIT0wfTt0aGlzLnNldF9yZXRocm93bj1mdW5jdGlvbihyZXRocm93bil7cmV0aHJvd249cmV0aHJvd24/MTowO0hFQVA4W3RoaXMucHRyKzEzPj4wXT1yZXRocm93bn07dGhpcy5nZXRfcmV0aHJvd249ZnVuY3Rpb24oKXtyZXR1cm4gSEVBUDhbdGhpcy5wdHIrMTM+PjBdIT0wfTt0aGlzLmluaXQ9ZnVuY3Rpb24odHlwZSxkZXN0cnVjdG9yKXt0aGlzLnNldF9hZGp1c3RlZF9wdHIoMCk7dGhpcy5zZXRfdHlwZSh0eXBlKTt0aGlzLnNldF9kZXN0cnVjdG9yKGRlc3RydWN0b3IpfTt0aGlzLnNldF9hZGp1c3RlZF9wdHI9ZnVuY3Rpb24oYWRqdXN0ZWRQdHIpe0hFQVBVMzJbdGhpcy5wdHIrMTY+PjJdPWFkanVzdGVkUHRyfTt0aGlzLmdldF9hZGp1c3RlZF9wdHI9ZnVuY3Rpb24oKXtyZXR1cm4gSEVBUFUzMlt0aGlzLnB0cisxNj4+Ml19O3RoaXMuZ2V0X2V4Y2VwdGlvbl9wdHI9ZnVuY3Rpb24oKXt2YXIgaXNQb2ludGVyPV9fX2N4YV9pc19wb2ludGVyX3R5cGUodGhpcy5nZXRfdHlwZSgpKTtpZihpc1BvaW50ZXIpe3JldHVybiBIRUFQVTMyW3RoaXMuZXhjUHRyPj4yXX12YXIgYWRqdXN0ZWQ9dGhpcy5nZXRfYWRqdXN0ZWRfcHRyKCk7aWYoYWRqdXN0ZWQhPT0wKXJldHVybiBhZGp1c3RlZDtyZXR1cm4gdGhpcy5leGNQdHJ9fXZhciBfX19yZXN1bWVFeGNlcHRpb249cHRyPT57aWYoIWV4Y2VwdGlvbkxhc3Qpe2V4Y2VwdGlvbkxhc3Q9cHRyfXRocm93IGV4Y2VwdGlvbkxhc3R9O3ZhciBmaW5kTWF0Y2hpbmdDYXRjaD1hcmdzPT57dmFyIHRocm93bj1leGNlcHRpb25MYXN0O2lmKCF0aHJvd24pe3NldFRlbXBSZXQwKDApO3JldHVybiAwfXZhciBpbmZvPW5ldyBFeGNlcHRpb25JbmZvKHRocm93bik7aW5mby5zZXRfYWRqdXN0ZWRfcHRyKHRocm93bik7dmFyIHRocm93blR5cGU9aW5mby5nZXRfdHlwZSgpO2lmKCF0aHJvd25UeXBlKXtzZXRUZW1wUmV0MCgwKTtyZXR1cm4gdGhyb3dufWZvcih2YXIgYXJnIGluIGFyZ3Mpe3ZhciBjYXVnaHRUeXBlPWFyZ3NbYXJnXTtpZihjYXVnaHRUeXBlPT09MHx8Y2F1Z2h0VHlwZT09PXRocm93blR5cGUpe2JyZWFrfXZhciBhZGp1c3RlZF9wdHJfYWRkcj1pbmZvLnB0cisxNjtpZihfX19jeGFfY2FuX2NhdGNoKGNhdWdodFR5cGUsdGhyb3duVHlwZSxhZGp1c3RlZF9wdHJfYWRkcikpe3NldFRlbXBSZXQwKGNhdWdodFR5cGUpO3JldHVybiB0aHJvd259fXNldFRlbXBSZXQwKHRocm93blR5cGUpO3JldHVybiB0aHJvd259O3ZhciBfX19jeGFfZmluZF9tYXRjaGluZ19jYXRjaF8yPSgpPT5maW5kTWF0Y2hpbmdDYXRjaChbXSk7dmFyIF9fX2N4YV9maW5kX21hdGNoaW5nX2NhdGNoXzM9YXJnMD0+ZmluZE1hdGNoaW5nQ2F0Y2goW2FyZzBdKTt2YXIgX19fY3hhX3JldGhyb3c9KCk9Pnt2YXIgaW5mbz1leGNlcHRpb25DYXVnaHQucG9wKCk7aWYoIWluZm8pe2Fib3J0KCJubyBleGNlcHRpb24gdG8gdGhyb3ciKX12YXIgcHRyPWluZm8uZXhjUHRyO2lmKCFpbmZvLmdldF9yZXRocm93bigpKXtleGNlcHRpb25DYXVnaHQucHVzaChpbmZvKTtpbmZvLnNldF9yZXRocm93bih0cnVlKTtpbmZvLnNldF9jYXVnaHQoZmFsc2UpO3VuY2F1Z2h0RXhjZXB0aW9uQ291bnQrK31leGNlcHRpb25MYXN0PXB0cjt0aHJvdyBleGNlcHRpb25MYXN0fTt2YXIgX19fY3hhX3Rocm93PShwdHIsdHlwZSxkZXN0cnVjdG9yKT0+e3ZhciBpbmZvPW5ldyBFeGNlcHRpb25JbmZvKHB0cik7aW5mby5pbml0KHR5cGUsZGVzdHJ1Y3Rvcik7ZXhjZXB0aW9uTGFzdD1wdHI7dW5jYXVnaHRFeGNlcHRpb25Db3VudCsrO3Rocm93IGV4Y2VwdGlvbkxhc3R9O3ZhciBQQVRIPXtpc0FiczpwYXRoPT5wYXRoLmNoYXJBdCgwKT09PSIvIixzcGxpdFBhdGg6ZmlsZW5hbWU9Pnt2YXIgc3BsaXRQYXRoUmU9L14oXC8/fCkoW1xzXFNdKj8pKCg/OlwuezEsMn18W15cL10rP3wpKFwuW14uXC9dKnwpKSg/OltcL10qKSQvO3JldHVybiBzcGxpdFBhdGhSZS5leGVjKGZpbGVuYW1lKS5zbGljZSgxKX0sbm9ybWFsaXplQXJyYXk6KHBhcnRzLGFsbG93QWJvdmVSb290KT0+e3ZhciB1cD0wO2Zvcih2YXIgaT1wYXJ0cy5sZW5ndGgtMTtpPj0wO2ktLSl7dmFyIGxhc3Q9cGFydHNbaV07aWYobGFzdD09PSIuIil7cGFydHMuc3BsaWNlKGksMSl9ZWxzZSBpZihsYXN0PT09Ii4uIil7cGFydHMuc3BsaWNlKGksMSk7dXArK31lbHNlIGlmKHVwKXtwYXJ0cy5zcGxpY2UoaSwxKTt1cC0tfX1pZihhbGxvd0Fib3ZlUm9vdCl7Zm9yKDt1cDt1cC0tKXtwYXJ0cy51bnNoaWZ0KCIuLiIpfX1yZXR1cm4gcGFydHN9LG5vcm1hbGl6ZTpwYXRoPT57dmFyIGlzQWJzb2x1dGU9UEFUSC5pc0FicyhwYXRoKSx0cmFpbGluZ1NsYXNoPXBhdGguc3Vic3RyKC0xKT09PSIvIjtwYXRoPVBBVEgubm9ybWFsaXplQXJyYXkocGF0aC5zcGxpdCgiLyIpLmZpbHRlcihwPT4hIXApLCFpc0Fic29sdXRlKS5qb2luKCIvIik7aWYoIXBhdGgmJiFpc0Fic29sdXRlKXtwYXRoPSIuIn1pZihwYXRoJiZ0cmFpbGluZ1NsYXNoKXtwYXRoKz0iLyJ9cmV0dXJuKGlzQWJzb2x1dGU/Ii8iOiIiKStwYXRofSxkaXJuYW1lOnBhdGg9Pnt2YXIgcmVzdWx0PVBBVEguc3BsaXRQYXRoKHBhdGgpLHJvb3Q9cmVzdWx0WzBdLGRpcj1yZXN1bHRbMV07aWYoIXJvb3QmJiFkaXIpe3JldHVybiIuIn1pZihkaXIpe2Rpcj1kaXIuc3Vic3RyKDAsZGlyLmxlbmd0aC0xKX1yZXR1cm4gcm9vdCtkaXJ9LGJhc2VuYW1lOnBhdGg9PntpZihwYXRoPT09Ii8iKXJldHVybiIvIjtwYXRoPVBBVEgubm9ybWFsaXplKHBhdGgpO3BhdGg9cGF0aC5yZXBsYWNlKC9cLyQvLCIiKTt2YXIgbGFzdFNsYXNoPXBhdGgubGFzdEluZGV4T2YoIi8iKTtpZihsYXN0U2xhc2g9PT0tMSlyZXR1cm4gcGF0aDtyZXR1cm4gcGF0aC5zdWJzdHIobGFzdFNsYXNoKzEpfSxqb2luOmZ1bmN0aW9uKCl7dmFyIHBhdGhzPUFycmF5LnByb3RvdHlwZS5zbGljZS5jYWxsKGFyZ3VtZW50cyk7cmV0dXJuIFBBVEgubm9ybWFsaXplKHBhdGhzLmpvaW4oIi8iKSl9LGpvaW4yOihsLHIpPT5QQVRILm5vcm1hbGl6ZShsKyIvIityKX07dmFyIGluaXRSYW5kb21GaWxsPSgpPT57aWYodHlwZW9mIGNyeXB0bz09Im9iamVjdCImJnR5cGVvZiBjcnlwdG9bImdldFJhbmRvbVZhbHVlcyJdPT0iZnVuY3Rpb24iKXtyZXR1cm4gdmlldz0+Y3J5cHRvLmdldFJhbmRvbVZhbHVlcyh2aWV3KX1lbHNlIGFib3J0KCJpbml0UmFuZG9tRGV2aWNlIil9O3ZhciByYW5kb21GaWxsPXZpZXc9PihyYW5kb21GaWxsPWluaXRSYW5kb21GaWxsKCkpKHZpZXcpO3ZhciBQQVRIX0ZTPXtyZXNvbHZlOmZ1bmN0aW9uKCl7dmFyIHJlc29sdmVkUGF0aD0iIixyZXNvbHZlZEFic29sdXRlPWZhbHNlO2Zvcih2YXIgaT1hcmd1bWVudHMubGVuZ3RoLTE7aT49LTEmJiFyZXNvbHZlZEFic29sdXRlO2ktLSl7dmFyIHBhdGg9aT49MD9hcmd1bWVudHNbaV06RlMuY3dkKCk7aWYodHlwZW9mIHBhdGghPSJzdHJpbmciKXt0aHJvdyBuZXcgVHlwZUVycm9yKCJBcmd1bWVudHMgdG8gcGF0aC5yZXNvbHZlIG11c3QgYmUgc3RyaW5ncyIpfWVsc2UgaWYoIXBhdGgpe3JldHVybiIifXJlc29sdmVkUGF0aD1wYXRoKyIvIityZXNvbHZlZFBhdGg7cmVzb2x2ZWRBYnNvbHV0ZT1QQVRILmlzQWJzKHBhdGgpfXJlc29sdmVkUGF0aD1QQVRILm5vcm1hbGl6ZUFycmF5KHJlc29sdmVkUGF0aC5zcGxpdCgiLyIpLmZpbHRlcihwPT4hIXApLCFyZXNvbHZlZEFic29sdXRlKS5qb2luKCIvIik7cmV0dXJuKHJlc29sdmVkQWJzb2x1dGU/Ii8iOiIiKStyZXNvbHZlZFBhdGh8fCIuIn0scmVsYXRpdmU6KGZyb20sdG8pPT57ZnJvbT1QQVRIX0ZTLnJlc29sdmUoZnJvbSkuc3Vic3RyKDEpO3RvPVBBVEhfRlMucmVzb2x2ZSh0bykuc3Vic3RyKDEpO2Z1bmN0aW9uIHRyaW0oYXJyKXt2YXIgc3RhcnQ9MDtmb3IoO3N0YXJ0PGFyci5sZW5ndGg7c3RhcnQrKyl7aWYoYXJyW3N0YXJ0XSE9PSIiKWJyZWFrfXZhciBlbmQ9YXJyLmxlbmd0aC0xO2Zvcig7ZW5kPj0wO2VuZC0tKXtpZihhcnJbZW5kXSE9PSIiKWJyZWFrfWlmKHN0YXJ0PmVuZClyZXR1cm5bXTtyZXR1cm4gYXJyLnNsaWNlKHN0YXJ0LGVuZC1zdGFydCsxKX12YXIgZnJvbVBhcnRzPXRyaW0oZnJvbS5zcGxpdCgiLyIpKTt2YXIgdG9QYXJ0cz10cmltKHRvLnNwbGl0KCIvIikpO3ZhciBsZW5ndGg9TWF0aC5taW4oZnJvbVBhcnRzLmxlbmd0aCx0b1BhcnRzLmxlbmd0aCk7dmFyIHNhbWVQYXJ0c0xlbmd0aD1sZW5ndGg7Zm9yKHZhciBpPTA7aTxsZW5ndGg7aSsrKXtpZihmcm9tUGFydHNbaV0hPT10b1BhcnRzW2ldKXtzYW1lUGFydHNMZW5ndGg9aTticmVha319dmFyIG91dHB1dFBhcnRzPVtdO2Zvcih2YXIgaT1zYW1lUGFydHNMZW5ndGg7aTxmcm9tUGFydHMubGVuZ3RoO2krKyl7b3V0cHV0UGFydHMucHVzaCgiLi4iKX1vdXRwdXRQYXJ0cz1vdXRwdXRQYXJ0cy5jb25jYXQodG9QYXJ0cy5zbGljZShzYW1lUGFydHNMZW5ndGgpKTtyZXR1cm4gb3V0cHV0UGFydHMuam9pbigiLyIpfX07dmFyIEZTX3N0ZGluX2dldENoYXJfYnVmZmVyPVtdO3ZhciBsZW5ndGhCeXRlc1VURjg9c3RyPT57dmFyIGxlbj0wO2Zvcih2YXIgaT0wO2k8c3RyLmxlbmd0aDsrK2kpe3ZhciBjPXN0ci5jaGFyQ29kZUF0KGkpO2lmKGM8PTEyNyl7bGVuKyt9ZWxzZSBpZihjPD0yMDQ3KXtsZW4rPTJ9ZWxzZSBpZihjPj01NTI5NiYmYzw9NTczNDMpe2xlbis9NDsrK2l9ZWxzZXtsZW4rPTN9fXJldHVybiBsZW59O3ZhciBzdHJpbmdUb1VURjhBcnJheT0oc3RyLGhlYXAsb3V0SWR4LG1heEJ5dGVzVG9Xcml0ZSk9PntpZighKG1heEJ5dGVzVG9Xcml0ZT4wKSlyZXR1cm4gMDt2YXIgc3RhcnRJZHg9b3V0SWR4O3ZhciBlbmRJZHg9b3V0SWR4K21heEJ5dGVzVG9Xcml0ZS0xO2Zvcih2YXIgaT0wO2k8c3RyLmxlbmd0aDsrK2kpe3ZhciB1PXN0ci5jaGFyQ29kZUF0KGkpO2lmKHU+PTU1Mjk2JiZ1PD01NzM0Myl7dmFyIHUxPXN0ci5jaGFyQ29kZUF0KCsraSk7dT02NTUzNisoKHUmMTAyMyk8PDEwKXx1MSYxMDIzfWlmKHU8PTEyNyl7aWYob3V0SWR4Pj1lbmRJZHgpYnJlYWs7aGVhcFtvdXRJZHgrK109dX1lbHNlIGlmKHU8PTIwNDcpe2lmKG91dElkeCsxPj1lbmRJZHgpYnJlYWs7aGVhcFtvdXRJZHgrK109MTkyfHU+PjY7aGVhcFtvdXRJZHgrK109MTI4fHUmNjN9ZWxzZSBpZih1PD02NTUzNSl7aWYob3V0SWR4KzI+PWVuZElkeClicmVhaztoZWFwW291dElkeCsrXT0yMjR8dT4+MTI7aGVhcFtvdXRJZHgrK109MTI4fHU+PjYmNjM7aGVhcFtvdXRJZHgrK109MTI4fHUmNjN9ZWxzZXtpZihvdXRJZHgrMz49ZW5kSWR4KWJyZWFrO2hlYXBbb3V0SWR4KytdPTI0MHx1Pj4xODtoZWFwW291dElkeCsrXT0xMjh8dT4+MTImNjM7aGVhcFtvdXRJZHgrK109MTI4fHU+PjYmNjM7aGVhcFtvdXRJZHgrK109MTI4fHUmNjN9fWhlYXBbb3V0SWR4XT0wO3JldHVybiBvdXRJZHgtc3RhcnRJZHh9O2Z1bmN0aW9uIGludEFycmF5RnJvbVN0cmluZyhzdHJpbmd5LGRvbnRBZGROdWxsLGxlbmd0aCl7dmFyIGxlbj1sZW5ndGg+MD9sZW5ndGg6bGVuZ3RoQnl0ZXNVVEY4KHN0cmluZ3kpKzE7dmFyIHU4YXJyYXk9bmV3IEFycmF5KGxlbik7dmFyIG51bUJ5dGVzV3JpdHRlbj1zdHJpbmdUb1VURjhBcnJheShzdHJpbmd5LHU4YXJyYXksMCx1OGFycmF5Lmxlbmd0aCk7aWYoZG9udEFkZE51bGwpdThhcnJheS5sZW5ndGg9bnVtQnl0ZXNXcml0dGVuO3JldHVybiB1OGFycmF5fXZhciBGU19zdGRpbl9nZXRDaGFyPSgpPT57aWYoIUZTX3N0ZGluX2dldENoYXJfYnVmZmVyLmxlbmd0aCl7dmFyIHJlc3VsdD1udWxsO2lmKHR5cGVvZiB3aW5kb3chPSJ1bmRlZmluZWQiJiZ0eXBlb2Ygd2luZG93LnByb21wdD09ImZ1bmN0aW9uIil7cmVzdWx0PXdpbmRvdy5wcm9tcHQoIklucHV0OiAiKTtpZihyZXN1bHQhPT1udWxsKXtyZXN1bHQrPSJcbiJ9fWVsc2UgaWYodHlwZW9mIHJlYWRsaW5lPT0iZnVuY3Rpb24iKXtyZXN1bHQ9cmVhZGxpbmUoKTtpZihyZXN1bHQhPT1udWxsKXtyZXN1bHQrPSJcbiJ9fWlmKCFyZXN1bHQpe3JldHVybiBudWxsfUZTX3N0ZGluX2dldENoYXJfYnVmZmVyPWludEFycmF5RnJvbVN0cmluZyhyZXN1bHQsdHJ1ZSl9cmV0dXJuIEZTX3N0ZGluX2dldENoYXJfYnVmZmVyLnNoaWZ0KCl9O3ZhciBUVFk9e3R0eXM6W10saW5pdCgpe30sc2h1dGRvd24oKXt9LHJlZ2lzdGVyKGRldixvcHMpe1RUWS50dHlzW2Rldl09e2lucHV0OltdLG91dHB1dDpbXSxvcHM6b3BzfTtGUy5yZWdpc3RlckRldmljZShkZXYsVFRZLnN0cmVhbV9vcHMpfSxzdHJlYW1fb3BzOntvcGVuKHN0cmVhbSl7dmFyIHR0eT1UVFkudHR5c1tzdHJlYW0ubm9kZS5yZGV2XTtpZighdHR5KXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0Myl9c3RyZWFtLnR0eT10dHk7c3RyZWFtLnNlZWthYmxlPWZhbHNlfSxjbG9zZShzdHJlYW0pe3N0cmVhbS50dHkub3BzLmZzeW5jKHN0cmVhbS50dHkpfSxmc3luYyhzdHJlYW0pe3N0cmVhbS50dHkub3BzLmZzeW5jKHN0cmVhbS50dHkpfSxyZWFkKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3Mpe2lmKCFzdHJlYW0udHR5fHwhc3RyZWFtLnR0eS5vcHMuZ2V0X2NoYXIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDYwKX12YXIgYnl0ZXNSZWFkPTA7Zm9yKHZhciBpPTA7aTxsZW5ndGg7aSsrKXt2YXIgcmVzdWx0O3RyeXtyZXN1bHQ9c3RyZWFtLnR0eS5vcHMuZ2V0X2NoYXIoc3RyZWFtLnR0eSl9Y2F0Y2goZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjkpfWlmKHJlc3VsdD09PXVuZGVmaW5lZCYmYnl0ZXNSZWFkPT09MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNil9aWYocmVzdWx0PT09bnVsbHx8cmVzdWx0PT09dW5kZWZpbmVkKWJyZWFrO2J5dGVzUmVhZCsrO2J1ZmZlcltvZmZzZXQraV09cmVzdWx0fWlmKGJ5dGVzUmVhZCl7c3RyZWFtLm5vZGUudGltZXN0YW1wPURhdGUubm93KCl9cmV0dXJuIGJ5dGVzUmVhZH0sd3JpdGUoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvcyl7aWYoIXN0cmVhbS50dHl8fCFzdHJlYW0udHR5Lm9wcy5wdXRfY2hhcil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNjApfXRyeXtmb3IodmFyIGk9MDtpPGxlbmd0aDtpKyspe3N0cmVhbS50dHkub3BzLnB1dF9jaGFyKHN0cmVhbS50dHksYnVmZmVyW29mZnNldCtpXSl9fWNhdGNoKGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI5KX1pZihsZW5ndGgpe3N0cmVhbS5ub2RlLnRpbWVzdGFtcD1EYXRlLm5vdygpfXJldHVybiBpfX0sZGVmYXVsdF90dHlfb3BzOntnZXRfY2hhcih0dHkpe3JldHVybiBGU19zdGRpbl9nZXRDaGFyKCl9LHB1dF9jaGFyKHR0eSx2YWwpe2lmKHZhbD09PW51bGx8fHZhbD09PTEwKXtvdXQoVVRGOEFycmF5VG9TdHJpbmcodHR5Lm91dHB1dCwwKSk7dHR5Lm91dHB1dD1bXX1lbHNle2lmKHZhbCE9MCl0dHkub3V0cHV0LnB1c2godmFsKX19LGZzeW5jKHR0eSl7aWYodHR5Lm91dHB1dCYmdHR5Lm91dHB1dC5sZW5ndGg+MCl7b3V0KFVURjhBcnJheVRvU3RyaW5nKHR0eS5vdXRwdXQsMCkpO3R0eS5vdXRwdXQ9W119fSxpb2N0bF90Y2dldHModHR5KXtyZXR1cm57Y19pZmxhZzoyNTg1NixjX29mbGFnOjUsY19jZmxhZzoxOTEsY19sZmxhZzozNTM4NyxjX2NjOlszLDI4LDEyNywyMSw0LDAsMSwwLDE3LDE5LDI2LDAsMTgsMTUsMjMsMjIsMCwwLDAsMCwwLDAsMCwwLDAsMCwwLDAsMCwwLDAsMF19fSxpb2N0bF90Y3NldHModHR5LG9wdGlvbmFsX2FjdGlvbnMsZGF0YSl7cmV0dXJuIDB9LGlvY3RsX3Rpb2Nnd2luc3oodHR5KXtyZXR1cm5bMjQsODBdfX0sZGVmYXVsdF90dHkxX29wczp7cHV0X2NoYXIodHR5LHZhbCl7aWYodmFsPT09bnVsbHx8dmFsPT09MTApe2VycihVVEY4QXJyYXlUb1N0cmluZyh0dHkub3V0cHV0LDApKTt0dHkub3V0cHV0PVtdfWVsc2V7aWYodmFsIT0wKXR0eS5vdXRwdXQucHVzaCh2YWwpfX0sZnN5bmModHR5KXtpZih0dHkub3V0cHV0JiZ0dHkub3V0cHV0Lmxlbmd0aD4wKXtlcnIoVVRGOEFycmF5VG9TdHJpbmcodHR5Lm91dHB1dCwwKSk7dHR5Lm91dHB1dD1bXX19fX07dmFyIHplcm9NZW1vcnk9KGFkZHJlc3Msc2l6ZSk9PntIRUFQVTguZmlsbCgwLGFkZHJlc3MsYWRkcmVzcytzaXplKTtyZXR1cm4gYWRkcmVzc307dmFyIGFsaWduTWVtb3J5PShzaXplLGFsaWdubWVudCk9Pk1hdGguY2VpbChzaXplL2FsaWdubWVudCkqYWxpZ25tZW50O3ZhciBtbWFwQWxsb2M9c2l6ZT0+e3NpemU9YWxpZ25NZW1vcnkoc2l6ZSw2NTUzNik7dmFyIHB0cj1fZW1zY3JpcHRlbl9idWlsdGluX21lbWFsaWduKDY1NTM2LHNpemUpO2lmKCFwdHIpcmV0dXJuIDA7cmV0dXJuIHplcm9NZW1vcnkocHRyLHNpemUpfTt2YXIgTUVNRlM9e29wc190YWJsZTpudWxsLG1vdW50KG1vdW50KXtyZXR1cm4gTUVNRlMuY3JlYXRlTm9kZShudWxsLCIvIiwxNjM4NHw1MTEsMCl9LGNyZWF0ZU5vZGUocGFyZW50LG5hbWUsbW9kZSxkZXYpe2lmKEZTLmlzQmxrZGV2KG1vZGUpfHxGUy5pc0ZJRk8obW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDYzKX1pZighTUVNRlMub3BzX3RhYmxlKXtNRU1GUy5vcHNfdGFibGU9e2Rpcjp7bm9kZTp7Z2V0YXR0cjpNRU1GUy5ub2RlX29wcy5nZXRhdHRyLHNldGF0dHI6TUVNRlMubm9kZV9vcHMuc2V0YXR0cixsb29rdXA6TUVNRlMubm9kZV9vcHMubG9va3VwLG1rbm9kOk1FTUZTLm5vZGVfb3BzLm1rbm9kLHJlbmFtZTpNRU1GUy5ub2RlX29wcy5yZW5hbWUsdW5saW5rOk1FTUZTLm5vZGVfb3BzLnVubGluayxybWRpcjpNRU1GUy5ub2RlX29wcy5ybWRpcixyZWFkZGlyOk1FTUZTLm5vZGVfb3BzLnJlYWRkaXIsc3ltbGluazpNRU1GUy5ub2RlX29wcy5zeW1saW5rfSxzdHJlYW06e2xsc2VlazpNRU1GUy5zdHJlYW1fb3BzLmxsc2Vla319LGZpbGU6e25vZGU6e2dldGF0dHI6TUVNRlMubm9kZV9vcHMuZ2V0YXR0cixzZXRhdHRyOk1FTUZTLm5vZGVfb3BzLnNldGF0dHJ9LHN0cmVhbTp7bGxzZWVrOk1FTUZTLnN0cmVhbV9vcHMubGxzZWVrLHJlYWQ6TUVNRlMuc3RyZWFtX29wcy5yZWFkLHdyaXRlOk1FTUZTLnN0cmVhbV9vcHMud3JpdGUsYWxsb2NhdGU6TUVNRlMuc3RyZWFtX29wcy5hbGxvY2F0ZSxtbWFwOk1FTUZTLnN0cmVhbV9vcHMubW1hcCxtc3luYzpNRU1GUy5zdHJlYW1fb3BzLm1zeW5jfX0sbGluazp7bm9kZTp7Z2V0YXR0cjpNRU1GUy5ub2RlX29wcy5nZXRhdHRyLHNldGF0dHI6TUVNRlMubm9kZV9vcHMuc2V0YXR0cixyZWFkbGluazpNRU1GUy5ub2RlX29wcy5yZWFkbGlua30sc3RyZWFtOnt9fSxjaHJkZXY6e25vZGU6e2dldGF0dHI6TUVNRlMubm9kZV9vcHMuZ2V0YXR0cixzZXRhdHRyOk1FTUZTLm5vZGVfb3BzLnNldGF0dHJ9LHN0cmVhbTpGUy5jaHJkZXZfc3RyZWFtX29wc319fXZhciBub2RlPUZTLmNyZWF0ZU5vZGUocGFyZW50LG5hbWUsbW9kZSxkZXYpO2lmKEZTLmlzRGlyKG5vZGUubW9kZSkpe25vZGUubm9kZV9vcHM9TUVNRlMub3BzX3RhYmxlLmRpci5ub2RlO25vZGUuc3RyZWFtX29wcz1NRU1GUy5vcHNfdGFibGUuZGlyLnN0cmVhbTtub2RlLmNvbnRlbnRzPXt9fWVsc2UgaWYoRlMuaXNGaWxlKG5vZGUubW9kZSkpe25vZGUubm9kZV9vcHM9TUVNRlMub3BzX3RhYmxlLmZpbGUubm9kZTtub2RlLnN0cmVhbV9vcHM9TUVNRlMub3BzX3RhYmxlLmZpbGUuc3RyZWFtO25vZGUudXNlZEJ5dGVzPTA7bm9kZS5jb250ZW50cz1udWxsfWVsc2UgaWYoRlMuaXNMaW5rKG5vZGUubW9kZSkpe25vZGUubm9kZV9vcHM9TUVNRlMub3BzX3RhYmxlLmxpbmsubm9kZTtub2RlLnN0cmVhbV9vcHM9TUVNRlMub3BzX3RhYmxlLmxpbmsuc3RyZWFtfWVsc2UgaWYoRlMuaXNDaHJkZXYobm9kZS5tb2RlKSl7bm9kZS5ub2RlX29wcz1NRU1GUy5vcHNfdGFibGUuY2hyZGV2Lm5vZGU7bm9kZS5zdHJlYW1fb3BzPU1FTUZTLm9wc190YWJsZS5jaHJkZXYuc3RyZWFtfW5vZGUudGltZXN0YW1wPURhdGUubm93KCk7aWYocGFyZW50KXtwYXJlbnQuY29udGVudHNbbmFtZV09bm9kZTtwYXJlbnQudGltZXN0YW1wPW5vZGUudGltZXN0YW1wfXJldHVybiBub2RlfSxnZXRGaWxlRGF0YUFzVHlwZWRBcnJheShub2RlKXtpZighbm9kZS5jb250ZW50cylyZXR1cm4gbmV3IFVpbnQ4QXJyYXkoMCk7aWYobm9kZS5jb250ZW50cy5zdWJhcnJheSlyZXR1cm4gbm9kZS5jb250ZW50cy5zdWJhcnJheSgwLG5vZGUudXNlZEJ5dGVzKTtyZXR1cm4gbmV3IFVpbnQ4QXJyYXkobm9kZS5jb250ZW50cyl9LGV4cGFuZEZpbGVTdG9yYWdlKG5vZGUsbmV3Q2FwYWNpdHkpe3ZhciBwcmV2Q2FwYWNpdHk9bm9kZS5jb250ZW50cz9ub2RlLmNvbnRlbnRzLmxlbmd0aDowO2lmKHByZXZDYXBhY2l0eT49bmV3Q2FwYWNpdHkpcmV0dXJuO3ZhciBDQVBBQ0lUWV9ET1VCTElOR19NQVg9MTAyNCoxMDI0O25ld0NhcGFjaXR5PU1hdGgubWF4KG5ld0NhcGFjaXR5LHByZXZDYXBhY2l0eSoocHJldkNhcGFjaXR5PENBUEFDSVRZX0RPVUJMSU5HX01BWD8yOjEuMTI1KT4+PjApO2lmKHByZXZDYXBhY2l0eSE9MCluZXdDYXBhY2l0eT1NYXRoLm1heChuZXdDYXBhY2l0eSwyNTYpO3ZhciBvbGRDb250ZW50cz1ub2RlLmNvbnRlbnRzO25vZGUuY29udGVudHM9bmV3IFVpbnQ4QXJyYXkobmV3Q2FwYWNpdHkpO2lmKG5vZGUudXNlZEJ5dGVzPjApbm9kZS5jb250ZW50cy5zZXQob2xkQ29udGVudHMuc3ViYXJyYXkoMCxub2RlLnVzZWRCeXRlcyksMCl9LHJlc2l6ZUZpbGVTdG9yYWdlKG5vZGUsbmV3U2l6ZSl7aWYobm9kZS51c2VkQnl0ZXM9PW5ld1NpemUpcmV0dXJuO2lmKG5ld1NpemU9PTApe25vZGUuY29udGVudHM9bnVsbDtub2RlLnVzZWRCeXRlcz0wfWVsc2V7dmFyIG9sZENvbnRlbnRzPW5vZGUuY29udGVudHM7bm9kZS5jb250ZW50cz1uZXcgVWludDhBcnJheShuZXdTaXplKTtpZihvbGRDb250ZW50cyl7bm9kZS5jb250ZW50cy5zZXQob2xkQ29udGVudHMuc3ViYXJyYXkoMCxNYXRoLm1pbihuZXdTaXplLG5vZGUudXNlZEJ5dGVzKSkpfW5vZGUudXNlZEJ5dGVzPW5ld1NpemV9fSxub2RlX29wczp7Z2V0YXR0cihub2RlKXt2YXIgYXR0cj17fTthdHRyLmRldj1GUy5pc0NocmRldihub2RlLm1vZGUpP25vZGUuaWQ6MTthdHRyLmlubz1ub2RlLmlkO2F0dHIubW9kZT1ub2RlLm1vZGU7YXR0ci5ubGluaz0xO2F0dHIudWlkPTA7YXR0ci5naWQ9MDthdHRyLnJkZXY9bm9kZS5yZGV2O2lmKEZTLmlzRGlyKG5vZGUubW9kZSkpe2F0dHIuc2l6ZT00MDk2fWVsc2UgaWYoRlMuaXNGaWxlKG5vZGUubW9kZSkpe2F0dHIuc2l6ZT1ub2RlLnVzZWRCeXRlc31lbHNlIGlmKEZTLmlzTGluayhub2RlLm1vZGUpKXthdHRyLnNpemU9bm9kZS5saW5rLmxlbmd0aH1lbHNle2F0dHIuc2l6ZT0wfWF0dHIuYXRpbWU9bmV3IERhdGUobm9kZS50aW1lc3RhbXApO2F0dHIubXRpbWU9bmV3IERhdGUobm9kZS50aW1lc3RhbXApO2F0dHIuY3RpbWU9bmV3IERhdGUobm9kZS50aW1lc3RhbXApO2F0dHIuYmxrc2l6ZT00MDk2O2F0dHIuYmxvY2tzPU1hdGguY2VpbChhdHRyLnNpemUvYXR0ci5ibGtzaXplKTtyZXR1cm4gYXR0cn0sc2V0YXR0cihub2RlLGF0dHIpe2lmKGF0dHIubW9kZSE9PXVuZGVmaW5lZCl7bm9kZS5tb2RlPWF0dHIubW9kZX1pZihhdHRyLnRpbWVzdGFtcCE9PXVuZGVmaW5lZCl7bm9kZS50aW1lc3RhbXA9YXR0ci50aW1lc3RhbXB9aWYoYXR0ci5zaXplIT09dW5kZWZpbmVkKXtNRU1GUy5yZXNpemVGaWxlU3RvcmFnZShub2RlLGF0dHIuc2l6ZSl9fSxsb29rdXAocGFyZW50LG5hbWUpe3Rocm93IEZTLmdlbmVyaWNFcnJvcnNbNDRdfSxta25vZChwYXJlbnQsbmFtZSxtb2RlLGRldil7cmV0dXJuIE1FTUZTLmNyZWF0ZU5vZGUocGFyZW50LG5hbWUsbW9kZSxkZXYpfSxyZW5hbWUob2xkX25vZGUsbmV3X2RpcixuZXdfbmFtZSl7aWYoRlMuaXNEaXIob2xkX25vZGUubW9kZSkpe3ZhciBuZXdfbm9kZTt0cnl7bmV3X25vZGU9RlMubG9va3VwTm9kZShuZXdfZGlyLG5ld19uYW1lKX1jYXRjaChlKXt9aWYobmV3X25vZGUpe2Zvcih2YXIgaSBpbiBuZXdfbm9kZS5jb250ZW50cyl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNTUpfX19ZGVsZXRlIG9sZF9ub2RlLnBhcmVudC5jb250ZW50c1tvbGRfbm9kZS5uYW1lXTtvbGRfbm9kZS5wYXJlbnQudGltZXN0YW1wPURhdGUubm93KCk7b2xkX25vZGUubmFtZT1uZXdfbmFtZTtuZXdfZGlyLmNvbnRlbnRzW25ld19uYW1lXT1vbGRfbm9kZTtuZXdfZGlyLnRpbWVzdGFtcD1vbGRfbm9kZS5wYXJlbnQudGltZXN0YW1wO29sZF9ub2RlLnBhcmVudD1uZXdfZGlyfSx1bmxpbmsocGFyZW50LG5hbWUpe2RlbGV0ZSBwYXJlbnQuY29udGVudHNbbmFtZV07cGFyZW50LnRpbWVzdGFtcD1EYXRlLm5vdygpfSxybWRpcihwYXJlbnQsbmFtZSl7dmFyIG5vZGU9RlMubG9va3VwTm9kZShwYXJlbnQsbmFtZSk7Zm9yKHZhciBpIGluIG5vZGUuY29udGVudHMpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDU1KX1kZWxldGUgcGFyZW50LmNvbnRlbnRzW25hbWVdO3BhcmVudC50aW1lc3RhbXA9RGF0ZS5ub3coKX0scmVhZGRpcihub2RlKXt2YXIgZW50cmllcz1bIi4iLCIuLiJdO2Zvcih2YXIga2V5IGluIG5vZGUuY29udGVudHMpe2lmKCFub2RlLmNvbnRlbnRzLmhhc093blByb3BlcnR5KGtleSkpe2NvbnRpbnVlfWVudHJpZXMucHVzaChrZXkpfXJldHVybiBlbnRyaWVzfSxzeW1saW5rKHBhcmVudCxuZXduYW1lLG9sZHBhdGgpe3ZhciBub2RlPU1FTUZTLmNyZWF0ZU5vZGUocGFyZW50LG5ld25hbWUsNTExfDQwOTYwLDApO25vZGUubGluaz1vbGRwYXRoO3JldHVybiBub2RlfSxyZWFkbGluayhub2RlKXtpZighRlMuaXNMaW5rKG5vZGUubW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX1yZXR1cm4gbm9kZS5saW5rfX0sc3RyZWFtX29wczp7cmVhZChzdHJlYW0sYnVmZmVyLG9mZnNldCxsZW5ndGgscG9zaXRpb24pe3ZhciBjb250ZW50cz1zdHJlYW0ubm9kZS5jb250ZW50cztpZihwb3NpdGlvbj49c3RyZWFtLm5vZGUudXNlZEJ5dGVzKXJldHVybiAwO3ZhciBzaXplPU1hdGgubWluKHN0cmVhbS5ub2RlLnVzZWRCeXRlcy1wb3NpdGlvbixsZW5ndGgpO2lmKHNpemU+OCYmY29udGVudHMuc3ViYXJyYXkpe2J1ZmZlci5zZXQoY29udGVudHMuc3ViYXJyYXkocG9zaXRpb24scG9zaXRpb24rc2l6ZSksb2Zmc2V0KX1lbHNle2Zvcih2YXIgaT0wO2k8c2l6ZTtpKyspYnVmZmVyW29mZnNldCtpXT1jb250ZW50c1twb3NpdGlvbitpXX1yZXR1cm4gc2l6ZX0sd3JpdGUoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvc2l0aW9uLGNhbk93bil7aWYoIWxlbmd0aClyZXR1cm4gMDt2YXIgbm9kZT1zdHJlYW0ubm9kZTtub2RlLnRpbWVzdGFtcD1EYXRlLm5vdygpO2lmKGJ1ZmZlci5zdWJhcnJheSYmKCFub2RlLmNvbnRlbnRzfHxub2RlLmNvbnRlbnRzLnN1YmFycmF5KSl7aWYoY2FuT3duKXtub2RlLmNvbnRlbnRzPWJ1ZmZlci5zdWJhcnJheShvZmZzZXQsb2Zmc2V0K2xlbmd0aCk7bm9kZS51c2VkQnl0ZXM9bGVuZ3RoO3JldHVybiBsZW5ndGh9ZWxzZSBpZihub2RlLnVzZWRCeXRlcz09PTAmJnBvc2l0aW9uPT09MCl7bm9kZS5jb250ZW50cz1idWZmZXIuc2xpY2Uob2Zmc2V0LG9mZnNldCtsZW5ndGgpO25vZGUudXNlZEJ5dGVzPWxlbmd0aDtyZXR1cm4gbGVuZ3RofWVsc2UgaWYocG9zaXRpb24rbGVuZ3RoPD1ub2RlLnVzZWRCeXRlcyl7bm9kZS5jb250ZW50cy5zZXQoYnVmZmVyLnN1YmFycmF5KG9mZnNldCxvZmZzZXQrbGVuZ3RoKSxwb3NpdGlvbik7cmV0dXJuIGxlbmd0aH19TUVNRlMuZXhwYW5kRmlsZVN0b3JhZ2Uobm9kZSxwb3NpdGlvbitsZW5ndGgpO2lmKG5vZGUuY29udGVudHMuc3ViYXJyYXkmJmJ1ZmZlci5zdWJhcnJheSl7bm9kZS5jb250ZW50cy5zZXQoYnVmZmVyLnN1YmFycmF5KG9mZnNldCxvZmZzZXQrbGVuZ3RoKSxwb3NpdGlvbil9ZWxzZXtmb3IodmFyIGk9MDtpPGxlbmd0aDtpKyspe25vZGUuY29udGVudHNbcG9zaXRpb24raV09YnVmZmVyW29mZnNldCtpXX19bm9kZS51c2VkQnl0ZXM9TWF0aC5tYXgobm9kZS51c2VkQnl0ZXMscG9zaXRpb24rbGVuZ3RoKTtyZXR1cm4gbGVuZ3RofSxsbHNlZWsoc3RyZWFtLG9mZnNldCx3aGVuY2Upe3ZhciBwb3NpdGlvbj1vZmZzZXQ7aWYod2hlbmNlPT09MSl7cG9zaXRpb24rPXN0cmVhbS5wb3NpdGlvbn1lbHNlIGlmKHdoZW5jZT09PTIpe2lmKEZTLmlzRmlsZShzdHJlYW0ubm9kZS5tb2RlKSl7cG9zaXRpb24rPXN0cmVhbS5ub2RlLnVzZWRCeXRlc319aWYocG9zaXRpb248MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfXJldHVybiBwb3NpdGlvbn0sYWxsb2NhdGUoc3RyZWFtLG9mZnNldCxsZW5ndGgpe01FTUZTLmV4cGFuZEZpbGVTdG9yYWdlKHN0cmVhbS5ub2RlLG9mZnNldCtsZW5ndGgpO3N0cmVhbS5ub2RlLnVzZWRCeXRlcz1NYXRoLm1heChzdHJlYW0ubm9kZS51c2VkQnl0ZXMsb2Zmc2V0K2xlbmd0aCl9LG1tYXAoc3RyZWFtLGxlbmd0aCxwb3NpdGlvbixwcm90LGZsYWdzKXtpZighRlMuaXNGaWxlKHN0cmVhbS5ub2RlLm1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0Myl9dmFyIHB0cjt2YXIgYWxsb2NhdGVkO3ZhciBjb250ZW50cz1zdHJlYW0ubm9kZS5jb250ZW50cztpZighKGZsYWdzJjIpJiZjb250ZW50cy5idWZmZXI9PT1IRUFQOC5idWZmZXIpe2FsbG9jYXRlZD1mYWxzZTtwdHI9Y29udGVudHMuYnl0ZU9mZnNldH1lbHNle2lmKHBvc2l0aW9uPjB8fHBvc2l0aW9uK2xlbmd0aDxjb250ZW50cy5sZW5ndGgpe2lmKGNvbnRlbnRzLnN1YmFycmF5KXtjb250ZW50cz1jb250ZW50cy5zdWJhcnJheShwb3NpdGlvbixwb3NpdGlvbitsZW5ndGgpfWVsc2V7Y29udGVudHM9QXJyYXkucHJvdG90eXBlLnNsaWNlLmNhbGwoY29udGVudHMscG9zaXRpb24scG9zaXRpb24rbGVuZ3RoKX19YWxsb2NhdGVkPXRydWU7cHRyPW1tYXBBbGxvYyhsZW5ndGgpO2lmKCFwdHIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ4KX1IRUFQOC5zZXQoY29udGVudHMscHRyKX1yZXR1cm57cHRyOnB0cixhbGxvY2F0ZWQ6YWxsb2NhdGVkfX0sbXN5bmMoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLG1tYXBGbGFncyl7TUVNRlMuc3RyZWFtX29wcy53cml0ZShzdHJlYW0sYnVmZmVyLDAsbGVuZ3RoLG9mZnNldCxmYWxzZSk7cmV0dXJuIDB9fX07dmFyIGFzeW5jTG9hZD0odXJsLG9ubG9hZCxvbmVycm9yLG5vUnVuRGVwKT0+e3ZhciBkZXA9IW5vUnVuRGVwP2dldFVuaXF1ZVJ1bkRlcGVuZGVuY3koYGFsICR7dXJsfWApOiIiO3JlYWRBc3luYyh1cmwsYXJyYXlCdWZmZXI9Pnthc3NlcnQoYXJyYXlCdWZmZXIsYExvYWRpbmcgZGF0YSBmaWxlICIke3VybH0iIGZhaWxlZCAobm8gYXJyYXlCdWZmZXIpLmApO29ubG9hZChuZXcgVWludDhBcnJheShhcnJheUJ1ZmZlcikpO2lmKGRlcClyZW1vdmVSdW5EZXBlbmRlbmN5KGRlcCl9LGV2ZW50PT57aWYob25lcnJvcil7b25lcnJvcigpfWVsc2V7dGhyb3dgTG9hZGluZyBkYXRhIGZpbGUgIiR7dXJsfSIgZmFpbGVkLmB9fSk7aWYoZGVwKWFkZFJ1bkRlcGVuZGVuY3koZGVwKX07dmFyIEZTX2NyZWF0ZURhdGFGaWxlPShwYXJlbnQsbmFtZSxmaWxlRGF0YSxjYW5SZWFkLGNhbldyaXRlLGNhbk93bik9PntGUy5jcmVhdGVEYXRhRmlsZShwYXJlbnQsbmFtZSxmaWxlRGF0YSxjYW5SZWFkLGNhbldyaXRlLGNhbk93bil9O3ZhciBwcmVsb2FkUGx1Z2lucz1Nb2R1bGVbInByZWxvYWRQbHVnaW5zIl18fFtdO3ZhciBGU19oYW5kbGVkQnlQcmVsb2FkUGx1Z2luPShieXRlQXJyYXksZnVsbG5hbWUsZmluaXNoLG9uZXJyb3IpPT57aWYodHlwZW9mIEJyb3dzZXIhPSJ1bmRlZmluZWQiKUJyb3dzZXIuaW5pdCgpO3ZhciBoYW5kbGVkPWZhbHNlO3ByZWxvYWRQbHVnaW5zLmZvckVhY2gocGx1Z2luPT57aWYoaGFuZGxlZClyZXR1cm47aWYocGx1Z2luWyJjYW5IYW5kbGUiXShmdWxsbmFtZSkpe3BsdWdpblsiaGFuZGxlIl0oYnl0ZUFycmF5LGZ1bGxuYW1lLGZpbmlzaCxvbmVycm9yKTtoYW5kbGVkPXRydWV9fSk7cmV0dXJuIGhhbmRsZWR9O3ZhciBGU19jcmVhdGVQcmVsb2FkZWRGaWxlPShwYXJlbnQsbmFtZSx1cmwsY2FuUmVhZCxjYW5Xcml0ZSxvbmxvYWQsb25lcnJvcixkb250Q3JlYXRlRmlsZSxjYW5Pd24scHJlRmluaXNoKT0+e3ZhciBmdWxsbmFtZT1uYW1lP1BBVEhfRlMucmVzb2x2ZShQQVRILmpvaW4yKHBhcmVudCxuYW1lKSk6cGFyZW50O3ZhciBkZXA9Z2V0VW5pcXVlUnVuRGVwZW5kZW5jeShgY3AgJHtmdWxsbmFtZX1gKTtmdW5jdGlvbiBwcm9jZXNzRGF0YShieXRlQXJyYXkpe2Z1bmN0aW9uIGZpbmlzaChieXRlQXJyYXkpe2lmKHByZUZpbmlzaClwcmVGaW5pc2goKTtpZighZG9udENyZWF0ZUZpbGUpe0ZTX2NyZWF0ZURhdGFGaWxlKHBhcmVudCxuYW1lLGJ5dGVBcnJheSxjYW5SZWFkLGNhbldyaXRlLGNhbk93bil9aWYob25sb2FkKW9ubG9hZCgpO3JlbW92ZVJ1bkRlcGVuZGVuY3koZGVwKX1pZihGU19oYW5kbGVkQnlQcmVsb2FkUGx1Z2luKGJ5dGVBcnJheSxmdWxsbmFtZSxmaW5pc2gsKCk9PntpZihvbmVycm9yKW9uZXJyb3IoKTtyZW1vdmVSdW5EZXBlbmRlbmN5KGRlcCl9KSl7cmV0dXJufWZpbmlzaChieXRlQXJyYXkpfWFkZFJ1bkRlcGVuZGVuY3koZGVwKTtpZih0eXBlb2YgdXJsPT0ic3RyaW5nIil7YXN5bmNMb2FkKHVybCxieXRlQXJyYXk9PnByb2Nlc3NEYXRhKGJ5dGVBcnJheSksb25lcnJvcil9ZWxzZXtwcm9jZXNzRGF0YSh1cmwpfX07dmFyIEZTX21vZGVTdHJpbmdUb0ZsYWdzPXN0cj0+e3ZhciBmbGFnTW9kZXM9eyJyIjowLCJyKyI6MiwidyI6NTEyfDY0fDEsIncrIjo1MTJ8NjR8MiwiYSI6MTAyNHw2NHwxLCJhKyI6MTAyNHw2NHwyfTt2YXIgZmxhZ3M9ZmxhZ01vZGVzW3N0cl07aWYodHlwZW9mIGZsYWdzPT0idW5kZWZpbmVkIil7dGhyb3cgbmV3IEVycm9yKGBVbmtub3duIGZpbGUgb3BlbiBtb2RlOiAke3N0cn1gKX1yZXR1cm4gZmxhZ3N9O3ZhciBGU19nZXRNb2RlPShjYW5SZWFkLGNhbldyaXRlKT0+e3ZhciBtb2RlPTA7aWYoY2FuUmVhZCltb2RlfD0yOTJ8NzM7aWYoY2FuV3JpdGUpbW9kZXw9MTQ2O3JldHVybiBtb2RlfTt2YXIgRlM9e3Jvb3Q6bnVsbCxtb3VudHM6W10sZGV2aWNlczp7fSxzdHJlYW1zOltdLG5leHRJbm9kZToxLG5hbWVUYWJsZTpudWxsLGN1cnJlbnRQYXRoOiIvIixpbml0aWFsaXplZDpmYWxzZSxpZ25vcmVQZXJtaXNzaW9uczp0cnVlLEVycm5vRXJyb3I6bnVsbCxnZW5lcmljRXJyb3JzOnt9LGZpbGVzeXN0ZW1zOm51bGwsc3luY0ZTUmVxdWVzdHM6MCxsb29rdXBQYXRoKHBhdGgsb3B0cz17fSl7cGF0aD1QQVRIX0ZTLnJlc29sdmUocGF0aCk7aWYoIXBhdGgpcmV0dXJue3BhdGg6IiIsbm9kZTpudWxsfTt2YXIgZGVmYXVsdHM9e2ZvbGxvd19tb3VudDp0cnVlLHJlY3Vyc2VfY291bnQ6MH07b3B0cz1PYmplY3QuYXNzaWduKGRlZmF1bHRzLG9wdHMpO2lmKG9wdHMucmVjdXJzZV9jb3VudD44KXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigzMil9dmFyIHBhcnRzPXBhdGguc3BsaXQoIi8iKS5maWx0ZXIocD0+ISFwKTt2YXIgY3VycmVudD1GUy5yb290O3ZhciBjdXJyZW50X3BhdGg9Ii8iO2Zvcih2YXIgaT0wO2k8cGFydHMubGVuZ3RoO2krKyl7dmFyIGlzbGFzdD1pPT09cGFydHMubGVuZ3RoLTE7aWYoaXNsYXN0JiZvcHRzLnBhcmVudCl7YnJlYWt9Y3VycmVudD1GUy5sb29rdXBOb2RlKGN1cnJlbnQscGFydHNbaV0pO2N1cnJlbnRfcGF0aD1QQVRILmpvaW4yKGN1cnJlbnRfcGF0aCxwYXJ0c1tpXSk7aWYoRlMuaXNNb3VudHBvaW50KGN1cnJlbnQpKXtpZighaXNsYXN0fHxpc2xhc3QmJm9wdHMuZm9sbG93X21vdW50KXtjdXJyZW50PWN1cnJlbnQubW91bnRlZC5yb290fX1pZighaXNsYXN0fHxvcHRzLmZvbGxvdyl7dmFyIGNvdW50PTA7d2hpbGUoRlMuaXNMaW5rKGN1cnJlbnQubW9kZSkpe3ZhciBsaW5rPUZTLnJlYWRsaW5rKGN1cnJlbnRfcGF0aCk7Y3VycmVudF9wYXRoPVBBVEhfRlMucmVzb2x2ZShQQVRILmRpcm5hbWUoY3VycmVudF9wYXRoKSxsaW5rKTt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgoY3VycmVudF9wYXRoLHtyZWN1cnNlX2NvdW50Om9wdHMucmVjdXJzZV9jb3VudCsxfSk7Y3VycmVudD1sb29rdXAubm9kZTtpZihjb3VudCsrPjQwKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigzMil9fX19cmV0dXJue3BhdGg6Y3VycmVudF9wYXRoLG5vZGU6Y3VycmVudH19LGdldFBhdGgobm9kZSl7dmFyIHBhdGg7d2hpbGUodHJ1ZSl7aWYoRlMuaXNSb290KG5vZGUpKXt2YXIgbW91bnQ9bm9kZS5tb3VudC5tb3VudHBvaW50O2lmKCFwYXRoKXJldHVybiBtb3VudDtyZXR1cm4gbW91bnRbbW91bnQubGVuZ3RoLTFdIT09Ii8iP2Ake21vdW50fS8ke3BhdGh9YDptb3VudCtwYXRofXBhdGg9cGF0aD9gJHtub2RlLm5hbWV9LyR7cGF0aH1gOm5vZGUubmFtZTtub2RlPW5vZGUucGFyZW50fX0saGFzaE5hbWUocGFyZW50aWQsbmFtZSl7dmFyIGhhc2g9MDtmb3IodmFyIGk9MDtpPG5hbWUubGVuZ3RoO2krKyl7aGFzaD0oaGFzaDw8NSktaGFzaCtuYW1lLmNoYXJDb2RlQXQoaSl8MH1yZXR1cm4ocGFyZW50aWQraGFzaD4+PjApJUZTLm5hbWVUYWJsZS5sZW5ndGh9LGhhc2hBZGROb2RlKG5vZGUpe3ZhciBoYXNoPUZTLmhhc2hOYW1lKG5vZGUucGFyZW50LmlkLG5vZGUubmFtZSk7bm9kZS5uYW1lX25leHQ9RlMubmFtZVRhYmxlW2hhc2hdO0ZTLm5hbWVUYWJsZVtoYXNoXT1ub2RlfSxoYXNoUmVtb3ZlTm9kZShub2RlKXt2YXIgaGFzaD1GUy5oYXNoTmFtZShub2RlLnBhcmVudC5pZCxub2RlLm5hbWUpO2lmKEZTLm5hbWVUYWJsZVtoYXNoXT09PW5vZGUpe0ZTLm5hbWVUYWJsZVtoYXNoXT1ub2RlLm5hbWVfbmV4dH1lbHNle3ZhciBjdXJyZW50PUZTLm5hbWVUYWJsZVtoYXNoXTt3aGlsZShjdXJyZW50KXtpZihjdXJyZW50Lm5hbWVfbmV4dD09PW5vZGUpe2N1cnJlbnQubmFtZV9uZXh0PW5vZGUubmFtZV9uZXh0O2JyZWFrfWN1cnJlbnQ9Y3VycmVudC5uYW1lX25leHR9fX0sbG9va3VwTm9kZShwYXJlbnQsbmFtZSl7dmFyIGVyckNvZGU9RlMubWF5TG9va3VwKHBhcmVudCk7aWYoZXJyQ29kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoZXJyQ29kZSxwYXJlbnQpfXZhciBoYXNoPUZTLmhhc2hOYW1lKHBhcmVudC5pZCxuYW1lKTtmb3IodmFyIG5vZGU9RlMubmFtZVRhYmxlW2hhc2hdO25vZGU7bm9kZT1ub2RlLm5hbWVfbmV4dCl7dmFyIG5vZGVOYW1lPW5vZGUubmFtZTtpZihub2RlLnBhcmVudC5pZD09PXBhcmVudC5pZCYmbm9kZU5hbWU9PT1uYW1lKXtyZXR1cm4gbm9kZX19cmV0dXJuIEZTLmxvb2t1cChwYXJlbnQsbmFtZSl9LGNyZWF0ZU5vZGUocGFyZW50LG5hbWUsbW9kZSxyZGV2KXt2YXIgbm9kZT1uZXcgRlMuRlNOb2RlKHBhcmVudCxuYW1lLG1vZGUscmRldik7RlMuaGFzaEFkZE5vZGUobm9kZSk7cmV0dXJuIG5vZGV9LGRlc3Ryb3lOb2RlKG5vZGUpe0ZTLmhhc2hSZW1vdmVOb2RlKG5vZGUpfSxpc1Jvb3Qobm9kZSl7cmV0dXJuIG5vZGU9PT1ub2RlLnBhcmVudH0saXNNb3VudHBvaW50KG5vZGUpe3JldHVybiEhbm9kZS5tb3VudGVkfSxpc0ZpbGUobW9kZSl7cmV0dXJuKG1vZGUmNjE0NDApPT09MzI3Njh9LGlzRGlyKG1vZGUpe3JldHVybihtb2RlJjYxNDQwKT09PTE2Mzg0fSxpc0xpbmsobW9kZSl7cmV0dXJuKG1vZGUmNjE0NDApPT09NDA5NjB9LGlzQ2hyZGV2KG1vZGUpe3JldHVybihtb2RlJjYxNDQwKT09PTgxOTJ9LGlzQmxrZGV2KG1vZGUpe3JldHVybihtb2RlJjYxNDQwKT09PTI0NTc2fSxpc0ZJRk8obW9kZSl7cmV0dXJuKG1vZGUmNjE0NDApPT09NDA5Nn0saXNTb2NrZXQobW9kZSl7cmV0dXJuKG1vZGUmNDkxNTIpPT09NDkxNTJ9LGZsYWdzVG9QZXJtaXNzaW9uU3RyaW5nKGZsYWcpe3ZhciBwZXJtcz1bInIiLCJ3IiwicnciXVtmbGFnJjNdO2lmKGZsYWcmNTEyKXtwZXJtcys9IncifXJldHVybiBwZXJtc30sbm9kZVBlcm1pc3Npb25zKG5vZGUscGVybXMpe2lmKEZTLmlnbm9yZVBlcm1pc3Npb25zKXtyZXR1cm4gMH1pZihwZXJtcy5pbmNsdWRlcygiciIpJiYhKG5vZGUubW9kZSYyOTIpKXtyZXR1cm4gMn1lbHNlIGlmKHBlcm1zLmluY2x1ZGVzKCJ3IikmJiEobm9kZS5tb2RlJjE0Nikpe3JldHVybiAyfWVsc2UgaWYocGVybXMuaW5jbHVkZXMoIngiKSYmIShub2RlLm1vZGUmNzMpKXtyZXR1cm4gMn1yZXR1cm4gMH0sbWF5TG9va3VwKGRpcil7dmFyIGVyckNvZGU9RlMubm9kZVBlcm1pc3Npb25zKGRpciwieCIpO2lmKGVyckNvZGUpcmV0dXJuIGVyckNvZGU7aWYoIWRpci5ub2RlX29wcy5sb29rdXApcmV0dXJuIDI7cmV0dXJuIDB9LG1heUNyZWF0ZShkaXIsbmFtZSl7dHJ5e3ZhciBub2RlPUZTLmxvb2t1cE5vZGUoZGlyLG5hbWUpO3JldHVybiAyMH1jYXRjaChlKXt9cmV0dXJuIEZTLm5vZGVQZXJtaXNzaW9ucyhkaXIsInd4Iil9LG1heURlbGV0ZShkaXIsbmFtZSxpc2Rpcil7dmFyIG5vZGU7dHJ5e25vZGU9RlMubG9va3VwTm9kZShkaXIsbmFtZSl9Y2F0Y2goZSl7cmV0dXJuIGUuZXJybm99dmFyIGVyckNvZGU9RlMubm9kZVBlcm1pc3Npb25zKGRpciwid3giKTtpZihlcnJDb2RlKXtyZXR1cm4gZXJyQ29kZX1pZihpc2Rpcil7aWYoIUZTLmlzRGlyKG5vZGUubW9kZSkpe3JldHVybiA1NH1pZihGUy5pc1Jvb3Qobm9kZSl8fEZTLmdldFBhdGgobm9kZSk9PT1GUy5jd2QoKSl7cmV0dXJuIDEwfX1lbHNle2lmKEZTLmlzRGlyKG5vZGUubW9kZSkpe3JldHVybiAzMX19cmV0dXJuIDB9LG1heU9wZW4obm9kZSxmbGFncyl7aWYoIW5vZGUpe3JldHVybiA0NH1pZihGUy5pc0xpbmsobm9kZS5tb2RlKSl7cmV0dXJuIDMyfWVsc2UgaWYoRlMuaXNEaXIobm9kZS5tb2RlKSl7aWYoRlMuZmxhZ3NUb1Blcm1pc3Npb25TdHJpbmcoZmxhZ3MpIT09InIifHxmbGFncyY1MTIpe3JldHVybiAzMX19cmV0dXJuIEZTLm5vZGVQZXJtaXNzaW9ucyhub2RlLEZTLmZsYWdzVG9QZXJtaXNzaW9uU3RyaW5nKGZsYWdzKSl9LE1BWF9PUEVOX0ZEUzo0MDk2LG5leHRmZCgpe2Zvcih2YXIgZmQ9MDtmZDw9RlMuTUFYX09QRU5fRkRTO2ZkKyspe2lmKCFGUy5zdHJlYW1zW2ZkXSl7cmV0dXJuIGZkfX10aHJvdyBuZXcgRlMuRXJybm9FcnJvcigzMyl9LGdldFN0cmVhbUNoZWNrZWQoZmQpe3ZhciBzdHJlYW09RlMuZ2V0U3RyZWFtKGZkKTtpZighc3RyZWFtKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig4KX1yZXR1cm4gc3RyZWFtfSxnZXRTdHJlYW06ZmQ9PkZTLnN0cmVhbXNbZmRdLGNyZWF0ZVN0cmVhbShzdHJlYW0sZmQ9LTEpe2lmKCFGUy5GU1N0cmVhbSl7RlMuRlNTdHJlYW09ZnVuY3Rpb24oKXt0aGlzLnNoYXJlZD17fX07RlMuRlNTdHJlYW0ucHJvdG90eXBlPXt9O09iamVjdC5kZWZpbmVQcm9wZXJ0aWVzKEZTLkZTU3RyZWFtLnByb3RvdHlwZSx7b2JqZWN0OntnZXQoKXtyZXR1cm4gdGhpcy5ub2RlfSxzZXQodmFsKXt0aGlzLm5vZGU9dmFsfX0saXNSZWFkOntnZXQoKXtyZXR1cm4odGhpcy5mbGFncyYyMDk3MTU1KSE9PTF9fSxpc1dyaXRlOntnZXQoKXtyZXR1cm4odGhpcy5mbGFncyYyMDk3MTU1KSE9PTB9fSxpc0FwcGVuZDp7Z2V0KCl7cmV0dXJuIHRoaXMuZmxhZ3MmMTAyNH19LGZsYWdzOntnZXQoKXtyZXR1cm4gdGhpcy5zaGFyZWQuZmxhZ3N9LHNldCh2YWwpe3RoaXMuc2hhcmVkLmZsYWdzPXZhbH19LHBvc2l0aW9uOntnZXQoKXtyZXR1cm4gdGhpcy5zaGFyZWQucG9zaXRpb259LHNldCh2YWwpe3RoaXMuc2hhcmVkLnBvc2l0aW9uPXZhbH19fSl9c3RyZWFtPU9iamVjdC5hc3NpZ24obmV3IEZTLkZTU3RyZWFtLHN0cmVhbSk7aWYoZmQ9PS0xKXtmZD1GUy5uZXh0ZmQoKX1zdHJlYW0uZmQ9ZmQ7RlMuc3RyZWFtc1tmZF09c3RyZWFtO3JldHVybiBzdHJlYW19LGNsb3NlU3RyZWFtKGZkKXtGUy5zdHJlYW1zW2ZkXT1udWxsfSxjaHJkZXZfc3RyZWFtX29wczp7b3BlbihzdHJlYW0pe3ZhciBkZXZpY2U9RlMuZ2V0RGV2aWNlKHN0cmVhbS5ub2RlLnJkZXYpO3N0cmVhbS5zdHJlYW1fb3BzPWRldmljZS5zdHJlYW1fb3BzO2lmKHN0cmVhbS5zdHJlYW1fb3BzLm9wZW4pe3N0cmVhbS5zdHJlYW1fb3BzLm9wZW4oc3RyZWFtKX19LGxsc2Vlaygpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDcwKX19LG1ham9yOmRldj0+ZGV2Pj44LG1pbm9yOmRldj0+ZGV2JjI1NSxtYWtlZGV2OihtYSxtaSk9Pm1hPDw4fG1pLHJlZ2lzdGVyRGV2aWNlKGRldixvcHMpe0ZTLmRldmljZXNbZGV2XT17c3RyZWFtX29wczpvcHN9fSxnZXREZXZpY2U6ZGV2PT5GUy5kZXZpY2VzW2Rldl0sZ2V0TW91bnRzKG1vdW50KXt2YXIgbW91bnRzPVtdO3ZhciBjaGVjaz1bbW91bnRdO3doaWxlKGNoZWNrLmxlbmd0aCl7dmFyIG09Y2hlY2sucG9wKCk7bW91bnRzLnB1c2gobSk7Y2hlY2sucHVzaC5hcHBseShjaGVjayxtLm1vdW50cyl9cmV0dXJuIG1vdW50c30sc3luY2ZzKHBvcHVsYXRlLGNhbGxiYWNrKXtpZih0eXBlb2YgcG9wdWxhdGU9PSJmdW5jdGlvbiIpe2NhbGxiYWNrPXBvcHVsYXRlO3BvcHVsYXRlPWZhbHNlfUZTLnN5bmNGU1JlcXVlc3RzKys7aWYoRlMuc3luY0ZTUmVxdWVzdHM+MSl7ZXJyKGB3YXJuaW5nOiAke0ZTLnN5bmNGU1JlcXVlc3RzfSBGUy5zeW5jZnMgb3BlcmF0aW9ucyBpbiBmbGlnaHQgYXQgb25jZSwgcHJvYmFibHkganVzdCBkb2luZyBleHRyYSB3b3JrYCl9dmFyIG1vdW50cz1GUy5nZXRNb3VudHMoRlMucm9vdC5tb3VudCk7dmFyIGNvbXBsZXRlZD0wO2Z1bmN0aW9uIGRvQ2FsbGJhY2soZXJyQ29kZSl7RlMuc3luY0ZTUmVxdWVzdHMtLTtyZXR1cm4gY2FsbGJhY2soZXJyQ29kZSl9ZnVuY3Rpb24gZG9uZShlcnJDb2RlKXtpZihlcnJDb2RlKXtpZighZG9uZS5lcnJvcmVkKXtkb25lLmVycm9yZWQ9dHJ1ZTtyZXR1cm4gZG9DYWxsYmFjayhlcnJDb2RlKX1yZXR1cm59aWYoKytjb21wbGV0ZWQ+PW1vdW50cy5sZW5ndGgpe2RvQ2FsbGJhY2sobnVsbCl9fW1vdW50cy5mb3JFYWNoKG1vdW50PT57aWYoIW1vdW50LnR5cGUuc3luY2ZzKXtyZXR1cm4gZG9uZShudWxsKX1tb3VudC50eXBlLnN5bmNmcyhtb3VudCxwb3B1bGF0ZSxkb25lKX0pfSxtb3VudCh0eXBlLG9wdHMsbW91bnRwb2ludCl7dmFyIHJvb3Q9bW91bnRwb2ludD09PSIvIjt2YXIgcHNldWRvPSFtb3VudHBvaW50O3ZhciBub2RlO2lmKHJvb3QmJkZTLnJvb3Qpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDEwKX1lbHNlIGlmKCFyb290JiYhcHNldWRvKXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgobW91bnRwb2ludCx7Zm9sbG93X21vdW50OmZhbHNlfSk7bW91bnRwb2ludD1sb29rdXAucGF0aDtub2RlPWxvb2t1cC5ub2RlO2lmKEZTLmlzTW91bnRwb2ludChub2RlKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMTApfWlmKCFGUy5pc0Rpcihub2RlLm1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig1NCl9fXZhciBtb3VudD17dHlwZTp0eXBlLG9wdHM6b3B0cyxtb3VudHBvaW50Om1vdW50cG9pbnQsbW91bnRzOltdfTt2YXIgbW91bnRSb290PXR5cGUubW91bnQobW91bnQpO21vdW50Um9vdC5tb3VudD1tb3VudDttb3VudC5yb290PW1vdW50Um9vdDtpZihyb290KXtGUy5yb290PW1vdW50Um9vdH1lbHNlIGlmKG5vZGUpe25vZGUubW91bnRlZD1tb3VudDtpZihub2RlLm1vdW50KXtub2RlLm1vdW50Lm1vdW50cy5wdXNoKG1vdW50KX19cmV0dXJuIG1vdW50Um9vdH0sdW5tb3VudChtb3VudHBvaW50KXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgobW91bnRwb2ludCx7Zm9sbG93X21vdW50OmZhbHNlfSk7aWYoIUZTLmlzTW91bnRwb2ludChsb29rdXAubm9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX12YXIgbm9kZT1sb29rdXAubm9kZTt2YXIgbW91bnQ9bm9kZS5tb3VudGVkO3ZhciBtb3VudHM9RlMuZ2V0TW91bnRzKG1vdW50KTtPYmplY3Qua2V5cyhGUy5uYW1lVGFibGUpLmZvckVhY2goaGFzaD0+e3ZhciBjdXJyZW50PUZTLm5hbWVUYWJsZVtoYXNoXTt3aGlsZShjdXJyZW50KXt2YXIgbmV4dD1jdXJyZW50Lm5hbWVfbmV4dDtpZihtb3VudHMuaW5jbHVkZXMoY3VycmVudC5tb3VudCkpe0ZTLmRlc3Ryb3lOb2RlKGN1cnJlbnQpfWN1cnJlbnQ9bmV4dH19KTtub2RlLm1vdW50ZWQ9bnVsbDt2YXIgaWR4PW5vZGUubW91bnQubW91bnRzLmluZGV4T2YobW91bnQpO25vZGUubW91bnQubW91bnRzLnNwbGljZShpZHgsMSl9LGxvb2t1cChwYXJlbnQsbmFtZSl7cmV0dXJuIHBhcmVudC5ub2RlX29wcy5sb29rdXAocGFyZW50LG5hbWUpfSxta25vZChwYXRoLG1vZGUsZGV2KXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7cGFyZW50OnRydWV9KTt2YXIgcGFyZW50PWxvb2t1cC5ub2RlO3ZhciBuYW1lPVBBVEguYmFzZW5hbWUocGF0aCk7aWYoIW5hbWV8fG5hbWU9PT0iLiJ8fG5hbWU9PT0iLi4iKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOCl9dmFyIGVyckNvZGU9RlMubWF5Q3JlYXRlKHBhcmVudCxuYW1lKTtpZihlcnJDb2RlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcihlcnJDb2RlKX1pZighcGFyZW50Lm5vZGVfb3BzLm1rbm9kKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9cmV0dXJuIHBhcmVudC5ub2RlX29wcy5ta25vZChwYXJlbnQsbmFtZSxtb2RlLGRldil9LGNyZWF0ZShwYXRoLG1vZGUpe21vZGU9bW9kZSE9PXVuZGVmaW5lZD9tb2RlOjQzODttb2RlJj00MDk1O21vZGV8PTMyNzY4O3JldHVybiBGUy5ta25vZChwYXRoLG1vZGUsMCl9LG1rZGlyKHBhdGgsbW9kZSl7bW9kZT1tb2RlIT09dW5kZWZpbmVkP21vZGU6NTExO21vZGUmPTUxMXw1MTI7bW9kZXw9MTYzODQ7cmV0dXJuIEZTLm1rbm9kKHBhdGgsbW9kZSwwKX0sbWtkaXJUcmVlKHBhdGgsbW9kZSl7dmFyIGRpcnM9cGF0aC5zcGxpdCgiLyIpO3ZhciBkPSIiO2Zvcih2YXIgaT0wO2k8ZGlycy5sZW5ndGg7KytpKXtpZighZGlyc1tpXSljb250aW51ZTtkKz0iLyIrZGlyc1tpXTt0cnl7RlMubWtkaXIoZCxtb2RlKX1jYXRjaChlKXtpZihlLmVycm5vIT0yMCl0aHJvdyBlfX19LG1rZGV2KHBhdGgsbW9kZSxkZXYpe2lmKHR5cGVvZiBkZXY9PSJ1bmRlZmluZWQiKXtkZXY9bW9kZTttb2RlPTQzOH1tb2RlfD04MTkyO3JldHVybiBGUy5ta25vZChwYXRoLG1vZGUsZGV2KX0sc3ltbGluayhvbGRwYXRoLG5ld3BhdGgpe2lmKCFQQVRIX0ZTLnJlc29sdmUob2xkcGF0aCkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ0KX12YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgobmV3cGF0aCx7cGFyZW50OnRydWV9KTt2YXIgcGFyZW50PWxvb2t1cC5ub2RlO2lmKCFwYXJlbnQpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ0KX12YXIgbmV3bmFtZT1QQVRILmJhc2VuYW1lKG5ld3BhdGgpO3ZhciBlcnJDb2RlPUZTLm1heUNyZWF0ZShwYXJlbnQsbmV3bmFtZSk7aWYoZXJyQ29kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoZXJyQ29kZSl9aWYoIXBhcmVudC5ub2RlX29wcy5zeW1saW5rKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9cmV0dXJuIHBhcmVudC5ub2RlX29wcy5zeW1saW5rKHBhcmVudCxuZXduYW1lLG9sZHBhdGgpfSxyZW5hbWUob2xkX3BhdGgsbmV3X3BhdGgpe3ZhciBvbGRfZGlybmFtZT1QQVRILmRpcm5hbWUob2xkX3BhdGgpO3ZhciBuZXdfZGlybmFtZT1QQVRILmRpcm5hbWUobmV3X3BhdGgpO3ZhciBvbGRfbmFtZT1QQVRILmJhc2VuYW1lKG9sZF9wYXRoKTt2YXIgbmV3X25hbWU9UEFUSC5iYXNlbmFtZShuZXdfcGF0aCk7dmFyIGxvb2t1cCxvbGRfZGlyLG5ld19kaXI7bG9va3VwPUZTLmxvb2t1cFBhdGgob2xkX3BhdGgse3BhcmVudDp0cnVlfSk7b2xkX2Rpcj1sb29rdXAubm9kZTtsb29rdXA9RlMubG9va3VwUGF0aChuZXdfcGF0aCx7cGFyZW50OnRydWV9KTtuZXdfZGlyPWxvb2t1cC5ub2RlO2lmKCFvbGRfZGlyfHwhbmV3X2Rpcil0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0NCk7aWYob2xkX2Rpci5tb3VudCE9PW5ld19kaXIubW91bnQpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDc1KX12YXIgb2xkX25vZGU9RlMubG9va3VwTm9kZShvbGRfZGlyLG9sZF9uYW1lKTt2YXIgcmVsYXRpdmU9UEFUSF9GUy5yZWxhdGl2ZShvbGRfcGF0aCxuZXdfZGlybmFtZSk7aWYocmVsYXRpdmUuY2hhckF0KDApIT09Ii4iKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOCl9cmVsYXRpdmU9UEFUSF9GUy5yZWxhdGl2ZShuZXdfcGF0aCxvbGRfZGlybmFtZSk7aWYocmVsYXRpdmUuY2hhckF0KDApIT09Ii4iKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig1NSl9dmFyIG5ld19ub2RlO3RyeXtuZXdfbm9kZT1GUy5sb29rdXBOb2RlKG5ld19kaXIsbmV3X25hbWUpfWNhdGNoKGUpe31pZihvbGRfbm9kZT09PW5ld19ub2RlKXtyZXR1cm59dmFyIGlzZGlyPUZTLmlzRGlyKG9sZF9ub2RlLm1vZGUpO3ZhciBlcnJDb2RlPUZTLm1heURlbGV0ZShvbGRfZGlyLG9sZF9uYW1lLGlzZGlyKTtpZihlcnJDb2RlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcihlcnJDb2RlKX1lcnJDb2RlPW5ld19ub2RlP0ZTLm1heURlbGV0ZShuZXdfZGlyLG5ld19uYW1lLGlzZGlyKTpGUy5tYXlDcmVhdGUobmV3X2RpcixuZXdfbmFtZSk7aWYoZXJyQ29kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoZXJyQ29kZSl9aWYoIW9sZF9kaXIubm9kZV9vcHMucmVuYW1lKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9aWYoRlMuaXNNb3VudHBvaW50KG9sZF9ub2RlKXx8bmV3X25vZGUmJkZTLmlzTW91bnRwb2ludChuZXdfbm9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDEwKX1pZihuZXdfZGlyIT09b2xkX2Rpcil7ZXJyQ29kZT1GUy5ub2RlUGVybWlzc2lvbnMob2xkX2RpciwidyIpO2lmKGVyckNvZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKGVyckNvZGUpfX1GUy5oYXNoUmVtb3ZlTm9kZShvbGRfbm9kZSk7dHJ5e29sZF9kaXIubm9kZV9vcHMucmVuYW1lKG9sZF9ub2RlLG5ld19kaXIsbmV3X25hbWUpfWNhdGNoKGUpe3Rocm93IGV9ZmluYWxseXtGUy5oYXNoQWRkTm9kZShvbGRfbm9kZSl9fSxybWRpcihwYXRoKXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7cGFyZW50OnRydWV9KTt2YXIgcGFyZW50PWxvb2t1cC5ub2RlO3ZhciBuYW1lPVBBVEguYmFzZW5hbWUocGF0aCk7dmFyIG5vZGU9RlMubG9va3VwTm9kZShwYXJlbnQsbmFtZSk7dmFyIGVyckNvZGU9RlMubWF5RGVsZXRlKHBhcmVudCxuYW1lLHRydWUpO2lmKGVyckNvZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKGVyckNvZGUpfWlmKCFwYXJlbnQubm9kZV9vcHMucm1kaXIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDYzKX1pZihGUy5pc01vdW50cG9pbnQobm9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDEwKX1wYXJlbnQubm9kZV9vcHMucm1kaXIocGFyZW50LG5hbWUpO0ZTLmRlc3Ryb3lOb2RlKG5vZGUpfSxyZWFkZGlyKHBhdGgpe3ZhciBsb29rdXA9RlMubG9va3VwUGF0aChwYXRoLHtmb2xsb3c6dHJ1ZX0pO3ZhciBub2RlPWxvb2t1cC5ub2RlO2lmKCFub2RlLm5vZGVfb3BzLnJlYWRkaXIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDU0KX1yZXR1cm4gbm9kZS5ub2RlX29wcy5yZWFkZGlyKG5vZGUpfSx1bmxpbmsocGF0aCl7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse3BhcmVudDp0cnVlfSk7dmFyIHBhcmVudD1sb29rdXAubm9kZTtpZighcGFyZW50KXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0NCl9dmFyIG5hbWU9UEFUSC5iYXNlbmFtZShwYXRoKTt2YXIgbm9kZT1GUy5sb29rdXBOb2RlKHBhcmVudCxuYW1lKTt2YXIgZXJyQ29kZT1GUy5tYXlEZWxldGUocGFyZW50LG5hbWUsZmFsc2UpO2lmKGVyckNvZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKGVyckNvZGUpfWlmKCFwYXJlbnQubm9kZV9vcHMudW5saW5rKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9aWYoRlMuaXNNb3VudHBvaW50KG5vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigxMCl9cGFyZW50Lm5vZGVfb3BzLnVubGluayhwYXJlbnQsbmFtZSk7RlMuZGVzdHJveU5vZGUobm9kZSl9LHJlYWRsaW5rKHBhdGgpe3ZhciBsb29rdXA9RlMubG9va3VwUGF0aChwYXRoKTt2YXIgbGluaz1sb29rdXAubm9kZTtpZighbGluayl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDQpfWlmKCFsaW5rLm5vZGVfb3BzLnJlYWRsaW5rKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOCl9cmV0dXJuIFBBVEhfRlMucmVzb2x2ZShGUy5nZXRQYXRoKGxpbmsucGFyZW50KSxsaW5rLm5vZGVfb3BzLnJlYWRsaW5rKGxpbmspKX0sc3RhdChwYXRoLGRvbnRGb2xsb3cpe3ZhciBsb29rdXA9RlMubG9va3VwUGF0aChwYXRoLHtmb2xsb3c6IWRvbnRGb2xsb3d9KTt2YXIgbm9kZT1sb29rdXAubm9kZTtpZighbm9kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDQpfWlmKCFub2RlLm5vZGVfb3BzLmdldGF0dHIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDYzKX1yZXR1cm4gbm9kZS5ub2RlX29wcy5nZXRhdHRyKG5vZGUpfSxsc3RhdChwYXRoKXtyZXR1cm4gRlMuc3RhdChwYXRoLHRydWUpfSxjaG1vZChwYXRoLG1vZGUsZG9udEZvbGxvdyl7dmFyIG5vZGU7aWYodHlwZW9mIHBhdGg9PSJzdHJpbmciKXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7Zm9sbG93OiFkb250Rm9sbG93fSk7bm9kZT1sb29rdXAubm9kZX1lbHNle25vZGU9cGF0aH1pZighbm9kZS5ub2RlX29wcy5zZXRhdHRyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9bm9kZS5ub2RlX29wcy5zZXRhdHRyKG5vZGUse21vZGU6bW9kZSY0MDk1fG5vZGUubW9kZSZ+NDA5NSx0aW1lc3RhbXA6RGF0ZS5ub3coKX0pfSxsY2htb2QocGF0aCxtb2RlKXtGUy5jaG1vZChwYXRoLG1vZGUsdHJ1ZSl9LGZjaG1vZChmZCxtb2RlKXt2YXIgc3RyZWFtPUZTLmdldFN0cmVhbUNoZWNrZWQoZmQpO0ZTLmNobW9kKHN0cmVhbS5ub2RlLG1vZGUpfSxjaG93bihwYXRoLHVpZCxnaWQsZG9udEZvbGxvdyl7dmFyIG5vZGU7aWYodHlwZW9mIHBhdGg9PSJzdHJpbmciKXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7Zm9sbG93OiFkb250Rm9sbG93fSk7bm9kZT1sb29rdXAubm9kZX1lbHNle25vZGU9cGF0aH1pZighbm9kZS5ub2RlX29wcy5zZXRhdHRyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9bm9kZS5ub2RlX29wcy5zZXRhdHRyKG5vZGUse3RpbWVzdGFtcDpEYXRlLm5vdygpfSl9LGxjaG93bihwYXRoLHVpZCxnaWQpe0ZTLmNob3duKHBhdGgsdWlkLGdpZCx0cnVlKX0sZmNob3duKGZkLHVpZCxnaWQpe3ZhciBzdHJlYW09RlMuZ2V0U3RyZWFtQ2hlY2tlZChmZCk7RlMuY2hvd24oc3RyZWFtLm5vZGUsdWlkLGdpZCl9LHRydW5jYXRlKHBhdGgsbGVuKXtpZihsZW48MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfXZhciBub2RlO2lmKHR5cGVvZiBwYXRoPT0ic3RyaW5nIil7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse2ZvbGxvdzp0cnVlfSk7bm9kZT1sb29rdXAubm9kZX1lbHNle25vZGU9cGF0aH1pZighbm9kZS5ub2RlX29wcy5zZXRhdHRyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9aWYoRlMuaXNEaXIobm9kZS5tb2RlKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMzEpfWlmKCFGUy5pc0ZpbGUobm9kZS5tb2RlKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfXZhciBlcnJDb2RlPUZTLm5vZGVQZXJtaXNzaW9ucyhub2RlLCJ3Iik7aWYoZXJyQ29kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoZXJyQ29kZSl9bm9kZS5ub2RlX29wcy5zZXRhdHRyKG5vZGUse3NpemU6bGVuLHRpbWVzdGFtcDpEYXRlLm5vdygpfSl9LGZ0cnVuY2F0ZShmZCxsZW4pe3ZhciBzdHJlYW09RlMuZ2V0U3RyZWFtQ2hlY2tlZChmZCk7aWYoKHN0cmVhbS5mbGFncyYyMDk3MTU1KT09PTApe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX1GUy50cnVuY2F0ZShzdHJlYW0ubm9kZSxsZW4pfSx1dGltZShwYXRoLGF0aW1lLG10aW1lKXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7Zm9sbG93OnRydWV9KTt2YXIgbm9kZT1sb29rdXAubm9kZTtub2RlLm5vZGVfb3BzLnNldGF0dHIobm9kZSx7dGltZXN0YW1wOk1hdGgubWF4KGF0aW1lLG10aW1lKX0pfSxvcGVuKHBhdGgsZmxhZ3MsbW9kZSl7aWYocGF0aD09PSIiKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0NCl9ZmxhZ3M9dHlwZW9mIGZsYWdzPT0ic3RyaW5nIj9GU19tb2RlU3RyaW5nVG9GbGFncyhmbGFncyk6ZmxhZ3M7bW9kZT10eXBlb2YgbW9kZT09InVuZGVmaW5lZCI/NDM4Om1vZGU7aWYoZmxhZ3MmNjQpe21vZGU9bW9kZSY0MDk1fDMyNzY4fWVsc2V7bW9kZT0wfXZhciBub2RlO2lmKHR5cGVvZiBwYXRoPT0ib2JqZWN0Iil7bm9kZT1wYXRofWVsc2V7cGF0aD1QQVRILm5vcm1hbGl6ZShwYXRoKTt0cnl7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse2ZvbGxvdzohKGZsYWdzJjEzMTA3Mil9KTtub2RlPWxvb2t1cC5ub2RlfWNhdGNoKGUpe319dmFyIGNyZWF0ZWQ9ZmFsc2U7aWYoZmxhZ3MmNjQpe2lmKG5vZGUpe2lmKGZsYWdzJjEyOCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjApfX1lbHNle25vZGU9RlMubWtub2QocGF0aCxtb2RlLDApO2NyZWF0ZWQ9dHJ1ZX19aWYoIW5vZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ0KX1pZihGUy5pc0NocmRldihub2RlLm1vZGUpKXtmbGFncyY9fjUxMn1pZihmbGFncyY2NTUzNiYmIUZTLmlzRGlyKG5vZGUubW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDU0KX1pZighY3JlYXRlZCl7dmFyIGVyckNvZGU9RlMubWF5T3Blbihub2RlLGZsYWdzKTtpZihlcnJDb2RlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcihlcnJDb2RlKX19aWYoZmxhZ3MmNTEyJiYhY3JlYXRlZCl7RlMudHJ1bmNhdGUobm9kZSwwKX1mbGFncyY9figxMjh8NTEyfDEzMTA3Mik7dmFyIHN0cmVhbT1GUy5jcmVhdGVTdHJlYW0oe25vZGU6bm9kZSxwYXRoOkZTLmdldFBhdGgobm9kZSksZmxhZ3M6ZmxhZ3Msc2Vla2FibGU6dHJ1ZSxwb3NpdGlvbjowLHN0cmVhbV9vcHM6bm9kZS5zdHJlYW1fb3BzLHVuZ290dGVuOltdLGVycm9yOmZhbHNlfSk7aWYoc3RyZWFtLnN0cmVhbV9vcHMub3Blbil7c3RyZWFtLnN0cmVhbV9vcHMub3BlbihzdHJlYW0pfWlmKE1vZHVsZVsibG9nUmVhZEZpbGVzIl0mJiEoZmxhZ3MmMSkpe2lmKCFGUy5yZWFkRmlsZXMpRlMucmVhZEZpbGVzPXt9O2lmKCEocGF0aCBpbiBGUy5yZWFkRmlsZXMpKXtGUy5yZWFkRmlsZXNbcGF0aF09MX19cmV0dXJuIHN0cmVhbX0sY2xvc2Uoc3RyZWFtKXtpZihGUy5pc0Nsb3NlZChzdHJlYW0pKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig4KX1pZihzdHJlYW0uZ2V0ZGVudHMpc3RyZWFtLmdldGRlbnRzPW51bGw7dHJ5e2lmKHN0cmVhbS5zdHJlYW1fb3BzLmNsb3NlKXtzdHJlYW0uc3RyZWFtX29wcy5jbG9zZShzdHJlYW0pfX1jYXRjaChlKXt0aHJvdyBlfWZpbmFsbHl7RlMuY2xvc2VTdHJlYW0oc3RyZWFtLmZkKX1zdHJlYW0uZmQ9bnVsbH0saXNDbG9zZWQoc3RyZWFtKXtyZXR1cm4gc3RyZWFtLmZkPT09bnVsbH0sbGxzZWVrKHN0cmVhbSxvZmZzZXQsd2hlbmNlKXtpZihGUy5pc0Nsb3NlZChzdHJlYW0pKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig4KX1pZighc3RyZWFtLnNlZWthYmxlfHwhc3RyZWFtLnN0cmVhbV9vcHMubGxzZWVrKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig3MCl9aWYod2hlbmNlIT0wJiZ3aGVuY2UhPTEmJndoZW5jZSE9Mil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfXN0cmVhbS5wb3NpdGlvbj1zdHJlYW0uc3RyZWFtX29wcy5sbHNlZWsoc3RyZWFtLG9mZnNldCx3aGVuY2UpO3N0cmVhbS51bmdvdHRlbj1bXTtyZXR1cm4gc3RyZWFtLnBvc2l0aW9ufSxyZWFkKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3NpdGlvbil7aWYobGVuZ3RoPDB8fHBvc2l0aW9uPDApe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX1pZihGUy5pc0Nsb3NlZChzdHJlYW0pKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig4KX1pZigoc3RyZWFtLmZsYWdzJjIwOTcxNTUpPT09MSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoOCl9aWYoRlMuaXNEaXIoc3RyZWFtLm5vZGUubW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDMxKX1pZighc3RyZWFtLnN0cmVhbV9vcHMucmVhZCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfXZhciBzZWVraW5nPXR5cGVvZiBwb3NpdGlvbiE9InVuZGVmaW5lZCI7aWYoIXNlZWtpbmcpe3Bvc2l0aW9uPXN0cmVhbS5wb3NpdGlvbn1lbHNlIGlmKCFzdHJlYW0uc2Vla2FibGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDcwKX12YXIgYnl0ZXNSZWFkPXN0cmVhbS5zdHJlYW1fb3BzLnJlYWQoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvc2l0aW9uKTtpZighc2Vla2luZylzdHJlYW0ucG9zaXRpb24rPWJ5dGVzUmVhZDtyZXR1cm4gYnl0ZXNSZWFkfSx3cml0ZShzdHJlYW0sYnVmZmVyLG9mZnNldCxsZW5ndGgscG9zaXRpb24sY2FuT3duKXtpZihsZW5ndGg8MHx8cG9zaXRpb248MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfWlmKEZTLmlzQ2xvc2VkKHN0cmVhbSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDgpfWlmKChzdHJlYW0uZmxhZ3MmMjA5NzE1NSk9PT0wKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig4KX1pZihGUy5pc0RpcihzdHJlYW0ubm9kZS5tb2RlKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMzEpfWlmKCFzdHJlYW0uc3RyZWFtX29wcy53cml0ZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfWlmKHN0cmVhbS5zZWVrYWJsZSYmc3RyZWFtLmZsYWdzJjEwMjQpe0ZTLmxsc2VlayhzdHJlYW0sMCwyKX12YXIgc2Vla2luZz10eXBlb2YgcG9zaXRpb24hPSJ1bmRlZmluZWQiO2lmKCFzZWVraW5nKXtwb3NpdGlvbj1zdHJlYW0ucG9zaXRpb259ZWxzZSBpZighc3RyZWFtLnNlZWthYmxlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig3MCl9dmFyIGJ5dGVzV3JpdHRlbj1zdHJlYW0uc3RyZWFtX29wcy53cml0ZShzdHJlYW0sYnVmZmVyLG9mZnNldCxsZW5ndGgscG9zaXRpb24sY2FuT3duKTtpZighc2Vla2luZylzdHJlYW0ucG9zaXRpb24rPWJ5dGVzV3JpdHRlbjtyZXR1cm4gYnl0ZXNXcml0dGVufSxhbGxvY2F0ZShzdHJlYW0sb2Zmc2V0LGxlbmd0aCl7aWYoRlMuaXNDbG9zZWQoc3RyZWFtKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoOCl9aWYob2Zmc2V0PDB8fGxlbmd0aDw9MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfWlmKChzdHJlYW0uZmxhZ3MmMjA5NzE1NSk9PT0wKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig4KX1pZighRlMuaXNGaWxlKHN0cmVhbS5ub2RlLm1vZGUpJiYhRlMuaXNEaXIoc3RyZWFtLm5vZGUubW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQzKX1pZighc3RyZWFtLnN0cmVhbV9vcHMuYWxsb2NhdGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDEzOCl9c3RyZWFtLnN0cmVhbV9vcHMuYWxsb2NhdGUoc3RyZWFtLG9mZnNldCxsZW5ndGgpfSxtbWFwKHN0cmVhbSxsZW5ndGgscG9zaXRpb24scHJvdCxmbGFncyl7aWYoKHByb3QmMikhPT0wJiYoZmxhZ3MmMik9PT0wJiYoc3RyZWFtLmZsYWdzJjIwOTcxNTUpIT09Mil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMil9aWYoKHN0cmVhbS5mbGFncyYyMDk3MTU1KT09PTEpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDIpfWlmKCFzdHJlYW0uc3RyZWFtX29wcy5tbWFwKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0Myl9cmV0dXJuIHN0cmVhbS5zdHJlYW1fb3BzLm1tYXAoc3RyZWFtLGxlbmd0aCxwb3NpdGlvbixwcm90LGZsYWdzKX0sbXN5bmMoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLG1tYXBGbGFncyl7aWYoIXN0cmVhbS5zdHJlYW1fb3BzLm1zeW5jKXtyZXR1cm4gMH1yZXR1cm4gc3RyZWFtLnN0cmVhbV9vcHMubXN5bmMoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLG1tYXBGbGFncyl9LG11bm1hcDpzdHJlYW09PjAsaW9jdGwoc3RyZWFtLGNtZCxhcmcpe2lmKCFzdHJlYW0uc3RyZWFtX29wcy5pb2N0bCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNTkpfXJldHVybiBzdHJlYW0uc3RyZWFtX29wcy5pb2N0bChzdHJlYW0sY21kLGFyZyl9LHJlYWRGaWxlKHBhdGgsb3B0cz17fSl7b3B0cy5mbGFncz1vcHRzLmZsYWdzfHwwO29wdHMuZW5jb2Rpbmc9b3B0cy5lbmNvZGluZ3x8ImJpbmFyeSI7aWYob3B0cy5lbmNvZGluZyE9PSJ1dGY4IiYmb3B0cy5lbmNvZGluZyE9PSJiaW5hcnkiKXt0aHJvdyBuZXcgRXJyb3IoYEludmFsaWQgZW5jb2RpbmcgdHlwZSAiJHtvcHRzLmVuY29kaW5nfSJgKX12YXIgcmV0O3ZhciBzdHJlYW09RlMub3BlbihwYXRoLG9wdHMuZmxhZ3MpO3ZhciBzdGF0PUZTLnN0YXQocGF0aCk7dmFyIGxlbmd0aD1zdGF0LnNpemU7dmFyIGJ1Zj1uZXcgVWludDhBcnJheShsZW5ndGgpO0ZTLnJlYWQoc3RyZWFtLGJ1ZiwwLGxlbmd0aCwwKTtpZihvcHRzLmVuY29kaW5nPT09InV0ZjgiKXtyZXQ9VVRGOEFycmF5VG9TdHJpbmcoYnVmLDApfWVsc2UgaWYob3B0cy5lbmNvZGluZz09PSJiaW5hcnkiKXtyZXQ9YnVmfUZTLmNsb3NlKHN0cmVhbSk7cmV0dXJuIHJldH0sd3JpdGVGaWxlKHBhdGgsZGF0YSxvcHRzPXt9KXtvcHRzLmZsYWdzPW9wdHMuZmxhZ3N8fDU3Nzt2YXIgc3RyZWFtPUZTLm9wZW4ocGF0aCxvcHRzLmZsYWdzLG9wdHMubW9kZSk7aWYodHlwZW9mIGRhdGE9PSJzdHJpbmciKXt2YXIgYnVmPW5ldyBVaW50OEFycmF5KGxlbmd0aEJ5dGVzVVRGOChkYXRhKSsxKTt2YXIgYWN0dWFsTnVtQnl0ZXM9c3RyaW5nVG9VVEY4QXJyYXkoZGF0YSxidWYsMCxidWYubGVuZ3RoKTtGUy53cml0ZShzdHJlYW0sYnVmLDAsYWN0dWFsTnVtQnl0ZXMsdW5kZWZpbmVkLG9wdHMuY2FuT3duKX1lbHNlIGlmKEFycmF5QnVmZmVyLmlzVmlldyhkYXRhKSl7RlMud3JpdGUoc3RyZWFtLGRhdGEsMCxkYXRhLmJ5dGVMZW5ndGgsdW5kZWZpbmVkLG9wdHMuY2FuT3duKX1lbHNle3Rocm93IG5ldyBFcnJvcigiVW5zdXBwb3J0ZWQgZGF0YSB0eXBlIil9RlMuY2xvc2Uoc3RyZWFtKX0sY3dkOigpPT5GUy5jdXJyZW50UGF0aCxjaGRpcihwYXRoKXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7Zm9sbG93OnRydWV9KTtpZihsb29rdXAubm9kZT09PW51bGwpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ0KX1pZighRlMuaXNEaXIobG9va3VwLm5vZGUubW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDU0KX12YXIgZXJyQ29kZT1GUy5ub2RlUGVybWlzc2lvbnMobG9va3VwLm5vZGUsIngiKTtpZihlcnJDb2RlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcihlcnJDb2RlKX1GUy5jdXJyZW50UGF0aD1sb29rdXAucGF0aH0sY3JlYXRlRGVmYXVsdERpcmVjdG9yaWVzKCl7RlMubWtkaXIoIi90bXAiKTtGUy5ta2RpcigiL2hvbWUiKTtGUy5ta2RpcigiL2hvbWUvd2ViX3VzZXIiKX0sY3JlYXRlRGVmYXVsdERldmljZXMoKXtGUy5ta2RpcigiL2RldiIpO0ZTLnJlZ2lzdGVyRGV2aWNlKEZTLm1ha2VkZXYoMSwzKSx7cmVhZDooKT0+MCx3cml0ZTooc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvcyk9Pmxlbmd0aH0pO0ZTLm1rZGV2KCIvZGV2L251bGwiLEZTLm1ha2VkZXYoMSwzKSk7VFRZLnJlZ2lzdGVyKEZTLm1ha2VkZXYoNSwwKSxUVFkuZGVmYXVsdF90dHlfb3BzKTtUVFkucmVnaXN0ZXIoRlMubWFrZWRldig2LDApLFRUWS5kZWZhdWx0X3R0eTFfb3BzKTtGUy5ta2RldigiL2Rldi90dHkiLEZTLm1ha2VkZXYoNSwwKSk7RlMubWtkZXYoIi9kZXYvdHR5MSIsRlMubWFrZWRldig2LDApKTt2YXIgcmFuZG9tQnVmZmVyPW5ldyBVaW50OEFycmF5KDEwMjQpLHJhbmRvbUxlZnQ9MDt2YXIgcmFuZG9tQnl0ZT0oKT0+e2lmKHJhbmRvbUxlZnQ9PT0wKXtyYW5kb21MZWZ0PXJhbmRvbUZpbGwocmFuZG9tQnVmZmVyKS5ieXRlTGVuZ3RofXJldHVybiByYW5kb21CdWZmZXJbLS1yYW5kb21MZWZ0XX07RlMuY3JlYXRlRGV2aWNlKCIvZGV2IiwicmFuZG9tIixyYW5kb21CeXRlKTtGUy5jcmVhdGVEZXZpY2UoIi9kZXYiLCJ1cmFuZG9tIixyYW5kb21CeXRlKTtGUy5ta2RpcigiL2Rldi9zaG0iKTtGUy5ta2RpcigiL2Rldi9zaG0vdG1wIil9LGNyZWF0ZVNwZWNpYWxEaXJlY3Rvcmllcygpe0ZTLm1rZGlyKCIvcHJvYyIpO3ZhciBwcm9jX3NlbGY9RlMubWtkaXIoIi9wcm9jL3NlbGYiKTtGUy5ta2RpcigiL3Byb2Mvc2VsZi9mZCIpO0ZTLm1vdW50KHttb3VudCgpe3ZhciBub2RlPUZTLmNyZWF0ZU5vZGUocHJvY19zZWxmLCJmZCIsMTYzODR8NTExLDczKTtub2RlLm5vZGVfb3BzPXtsb29rdXAocGFyZW50LG5hbWUpe3ZhciBmZD0rbmFtZTt2YXIgc3RyZWFtPUZTLmdldFN0cmVhbUNoZWNrZWQoZmQpO3ZhciByZXQ9e3BhcmVudDpudWxsLG1vdW50Onttb3VudHBvaW50OiJmYWtlIn0sbm9kZV9vcHM6e3JlYWRsaW5rOigpPT5zdHJlYW0ucGF0aH19O3JldC5wYXJlbnQ9cmV0O3JldHVybiByZXR9fTtyZXR1cm4gbm9kZX19LHt9LCIvcHJvYy9zZWxmL2ZkIil9LGNyZWF0ZVN0YW5kYXJkU3RyZWFtcygpe2lmKE1vZHVsZVsic3RkaW4iXSl7RlMuY3JlYXRlRGV2aWNlKCIvZGV2Iiwic3RkaW4iLE1vZHVsZVsic3RkaW4iXSl9ZWxzZXtGUy5zeW1saW5rKCIvZGV2L3R0eSIsIi9kZXYvc3RkaW4iKX1pZihNb2R1bGVbInN0ZG91dCJdKXtGUy5jcmVhdGVEZXZpY2UoIi9kZXYiLCJzdGRvdXQiLG51bGwsTW9kdWxlWyJzdGRvdXQiXSl9ZWxzZXtGUy5zeW1saW5rKCIvZGV2L3R0eSIsIi9kZXYvc3Rkb3V0Iil9aWYoTW9kdWxlWyJzdGRlcnIiXSl7RlMuY3JlYXRlRGV2aWNlKCIvZGV2Iiwic3RkZXJyIixudWxsLE1vZHVsZVsic3RkZXJyIl0pfWVsc2V7RlMuc3ltbGluaygiL2Rldi90dHkxIiwiL2Rldi9zdGRlcnIiKX12YXIgc3RkaW49RlMub3BlbigiL2Rldi9zdGRpbiIsMCk7dmFyIHN0ZG91dD1GUy5vcGVuKCIvZGV2L3N0ZG91dCIsMSk7dmFyIHN0ZGVycj1GUy5vcGVuKCIvZGV2L3N0ZGVyciIsMSl9LGVuc3VyZUVycm5vRXJyb3IoKXtpZihGUy5FcnJub0Vycm9yKXJldHVybjtGUy5FcnJub0Vycm9yPWZ1bmN0aW9uIEVycm5vRXJyb3IoZXJybm8sbm9kZSl7dGhpcy5uYW1lPSJFcnJub0Vycm9yIjt0aGlzLm5vZGU9bm9kZTt0aGlzLnNldEVycm5vPWZ1bmN0aW9uKGVycm5vKXt0aGlzLmVycm5vPWVycm5vfTt0aGlzLnNldEVycm5vKGVycm5vKTt0aGlzLm1lc3NhZ2U9IkZTIGVycm9yIn07RlMuRXJybm9FcnJvci5wcm90b3R5cGU9bmV3IEVycm9yO0ZTLkVycm5vRXJyb3IucHJvdG90eXBlLmNvbnN0cnVjdG9yPUZTLkVycm5vRXJyb3I7WzQ0XS5mb3JFYWNoKGNvZGU9PntGUy5nZW5lcmljRXJyb3JzW2NvZGVdPW5ldyBGUy5FcnJub0Vycm9yKGNvZGUpO0ZTLmdlbmVyaWNFcnJvcnNbY29kZV0uc3RhY2s9IjxnZW5lcmljIGVycm9yLCBubyBzdGFjaz4ifSl9LHN0YXRpY0luaXQoKXtGUy5lbnN1cmVFcnJub0Vycm9yKCk7RlMubmFtZVRhYmxlPW5ldyBBcnJheSg0MDk2KTtGUy5tb3VudChNRU1GUyx7fSwiLyIpO0ZTLmNyZWF0ZURlZmF1bHREaXJlY3RvcmllcygpO0ZTLmNyZWF0ZURlZmF1bHREZXZpY2VzKCk7RlMuY3JlYXRlU3BlY2lhbERpcmVjdG9yaWVzKCk7RlMuZmlsZXN5c3RlbXM9eyJNRU1GUyI6TUVNRlN9fSxpbml0KGlucHV0LG91dHB1dCxlcnJvcil7RlMuaW5pdC5pbml0aWFsaXplZD10cnVlO0ZTLmVuc3VyZUVycm5vRXJyb3IoKTtNb2R1bGVbInN0ZGluIl09aW5wdXR8fE1vZHVsZVsic3RkaW4iXTtNb2R1bGVbInN0ZG91dCJdPW91dHB1dHx8TW9kdWxlWyJzdGRvdXQiXTtNb2R1bGVbInN0ZGVyciJdPWVycm9yfHxNb2R1bGVbInN0ZGVyciJdO0ZTLmNyZWF0ZVN0YW5kYXJkU3RyZWFtcygpfSxxdWl0KCl7RlMuaW5pdC5pbml0aWFsaXplZD1mYWxzZTtfZmZsdXNoKDApO2Zvcih2YXIgaT0wO2k8RlMuc3RyZWFtcy5sZW5ndGg7aSsrKXt2YXIgc3RyZWFtPUZTLnN0cmVhbXNbaV07aWYoIXN0cmVhbSl7Y29udGludWV9RlMuY2xvc2Uoc3RyZWFtKX19LGZpbmRPYmplY3QocGF0aCxkb250UmVzb2x2ZUxhc3RMaW5rKXt2YXIgcmV0PUZTLmFuYWx5emVQYXRoKHBhdGgsZG9udFJlc29sdmVMYXN0TGluayk7aWYoIXJldC5leGlzdHMpe3JldHVybiBudWxsfXJldHVybiByZXQub2JqZWN0fSxhbmFseXplUGF0aChwYXRoLGRvbnRSZXNvbHZlTGFzdExpbmspe3RyeXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7Zm9sbG93OiFkb250UmVzb2x2ZUxhc3RMaW5rfSk7cGF0aD1sb29rdXAucGF0aH1jYXRjaChlKXt9dmFyIHJldD17aXNSb290OmZhbHNlLGV4aXN0czpmYWxzZSxlcnJvcjowLG5hbWU6bnVsbCxwYXRoOm51bGwsb2JqZWN0Om51bGwscGFyZW50RXhpc3RzOmZhbHNlLHBhcmVudFBhdGg6bnVsbCxwYXJlbnRPYmplY3Q6bnVsbH07dHJ5e3ZhciBsb29rdXA9RlMubG9va3VwUGF0aChwYXRoLHtwYXJlbnQ6dHJ1ZX0pO3JldC5wYXJlbnRFeGlzdHM9dHJ1ZTtyZXQucGFyZW50UGF0aD1sb29rdXAucGF0aDtyZXQucGFyZW50T2JqZWN0PWxvb2t1cC5ub2RlO3JldC5uYW1lPVBBVEguYmFzZW5hbWUocGF0aCk7bG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7Zm9sbG93OiFkb250UmVzb2x2ZUxhc3RMaW5rfSk7cmV0LmV4aXN0cz10cnVlO3JldC5wYXRoPWxvb2t1cC5wYXRoO3JldC5vYmplY3Q9bG9va3VwLm5vZGU7cmV0Lm5hbWU9bG9va3VwLm5vZGUubmFtZTtyZXQuaXNSb290PWxvb2t1cC5wYXRoPT09Ii8ifWNhdGNoKGUpe3JldC5lcnJvcj1lLmVycm5vfXJldHVybiByZXR9LGNyZWF0ZVBhdGgocGFyZW50LHBhdGgsY2FuUmVhZCxjYW5Xcml0ZSl7cGFyZW50PXR5cGVvZiBwYXJlbnQ9PSJzdHJpbmciP3BhcmVudDpGUy5nZXRQYXRoKHBhcmVudCk7dmFyIHBhcnRzPXBhdGguc3BsaXQoIi8iKS5yZXZlcnNlKCk7d2hpbGUocGFydHMubGVuZ3RoKXt2YXIgcGFydD1wYXJ0cy5wb3AoKTtpZighcGFydCljb250aW51ZTt2YXIgY3VycmVudD1QQVRILmpvaW4yKHBhcmVudCxwYXJ0KTt0cnl7RlMubWtkaXIoY3VycmVudCl9Y2F0Y2goZSl7fXBhcmVudD1jdXJyZW50fXJldHVybiBjdXJyZW50fSxjcmVhdGVGaWxlKHBhcmVudCxuYW1lLHByb3BlcnRpZXMsY2FuUmVhZCxjYW5Xcml0ZSl7dmFyIHBhdGg9UEFUSC5qb2luMih0eXBlb2YgcGFyZW50PT0ic3RyaW5nIj9wYXJlbnQ6RlMuZ2V0UGF0aChwYXJlbnQpLG5hbWUpO3ZhciBtb2RlPUZTX2dldE1vZGUoY2FuUmVhZCxjYW5Xcml0ZSk7cmV0dXJuIEZTLmNyZWF0ZShwYXRoLG1vZGUpfSxjcmVhdGVEYXRhRmlsZShwYXJlbnQsbmFtZSxkYXRhLGNhblJlYWQsY2FuV3JpdGUsY2FuT3duKXt2YXIgcGF0aD1uYW1lO2lmKHBhcmVudCl7cGFyZW50PXR5cGVvZiBwYXJlbnQ9PSJzdHJpbmciP3BhcmVudDpGUy5nZXRQYXRoKHBhcmVudCk7cGF0aD1uYW1lP1BBVEguam9pbjIocGFyZW50LG5hbWUpOnBhcmVudH12YXIgbW9kZT1GU19nZXRNb2RlKGNhblJlYWQsY2FuV3JpdGUpO3ZhciBub2RlPUZTLmNyZWF0ZShwYXRoLG1vZGUpO2lmKGRhdGEpe2lmKHR5cGVvZiBkYXRhPT0ic3RyaW5nIil7dmFyIGFycj1uZXcgQXJyYXkoZGF0YS5sZW5ndGgpO2Zvcih2YXIgaT0wLGxlbj1kYXRhLmxlbmd0aDtpPGxlbjsrK2kpYXJyW2ldPWRhdGEuY2hhckNvZGVBdChpKTtkYXRhPWFycn1GUy5jaG1vZChub2RlLG1vZGV8MTQ2KTt2YXIgc3RyZWFtPUZTLm9wZW4obm9kZSw1NzcpO0ZTLndyaXRlKHN0cmVhbSxkYXRhLDAsZGF0YS5sZW5ndGgsMCxjYW5Pd24pO0ZTLmNsb3NlKHN0cmVhbSk7RlMuY2htb2Qobm9kZSxtb2RlKX19LGNyZWF0ZURldmljZShwYXJlbnQsbmFtZSxpbnB1dCxvdXRwdXQpe3ZhciBwYXRoPVBBVEguam9pbjIodHlwZW9mIHBhcmVudD09InN0cmluZyI/cGFyZW50OkZTLmdldFBhdGgocGFyZW50KSxuYW1lKTt2YXIgbW9kZT1GU19nZXRNb2RlKCEhaW5wdXQsISFvdXRwdXQpO2lmKCFGUy5jcmVhdGVEZXZpY2UubWFqb3IpRlMuY3JlYXRlRGV2aWNlLm1ham9yPTY0O3ZhciBkZXY9RlMubWFrZWRldihGUy5jcmVhdGVEZXZpY2UubWFqb3IrKywwKTtGUy5yZWdpc3RlckRldmljZShkZXYse29wZW4oc3RyZWFtKXtzdHJlYW0uc2Vla2FibGU9ZmFsc2V9LGNsb3NlKHN0cmVhbSl7aWYob3V0cHV0JiZvdXRwdXQuYnVmZmVyJiZvdXRwdXQuYnVmZmVyLmxlbmd0aCl7b3V0cHV0KDEwKX19LHJlYWQoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvcyl7dmFyIGJ5dGVzUmVhZD0wO2Zvcih2YXIgaT0wO2k8bGVuZ3RoO2krKyl7dmFyIHJlc3VsdDt0cnl7cmVzdWx0PWlucHV0KCl9Y2F0Y2goZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjkpfWlmKHJlc3VsdD09PXVuZGVmaW5lZCYmYnl0ZXNSZWFkPT09MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNil9aWYocmVzdWx0PT09bnVsbHx8cmVzdWx0PT09dW5kZWZpbmVkKWJyZWFrO2J5dGVzUmVhZCsrO2J1ZmZlcltvZmZzZXQraV09cmVzdWx0fWlmKGJ5dGVzUmVhZCl7c3RyZWFtLm5vZGUudGltZXN0YW1wPURhdGUubm93KCl9cmV0dXJuIGJ5dGVzUmVhZH0sd3JpdGUoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvcyl7Zm9yKHZhciBpPTA7aTxsZW5ndGg7aSsrKXt0cnl7b3V0cHV0KGJ1ZmZlcltvZmZzZXQraV0pfWNhdGNoKGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI5KX19aWYobGVuZ3RoKXtzdHJlYW0ubm9kZS50aW1lc3RhbXA9RGF0ZS5ub3coKX1yZXR1cm4gaX19KTtyZXR1cm4gRlMubWtkZXYocGF0aCxtb2RlLGRldil9LGZvcmNlTG9hZEZpbGUob2JqKXtpZihvYmouaXNEZXZpY2V8fG9iai5pc0ZvbGRlcnx8b2JqLmxpbmt8fG9iai5jb250ZW50cylyZXR1cm4gdHJ1ZTtpZih0eXBlb2YgWE1MSHR0cFJlcXVlc3QhPSJ1bmRlZmluZWQiKXt0aHJvdyBuZXcgRXJyb3IoIkxhenkgbG9hZGluZyBzaG91bGQgaGF2ZSBiZWVuIHBlcmZvcm1lZCAoY29udGVudHMgc2V0KSBpbiBjcmVhdGVMYXp5RmlsZSwgYnV0IGl0IHdhcyBub3QuIExhenkgbG9hZGluZyBvbmx5IHdvcmtzIGluIHdlYiB3b3JrZXJzLiBVc2UgLS1lbWJlZC1maWxlIG9yIC0tcHJlbG9hZC1maWxlIGluIGVtY2Mgb24gdGhlIG1haW4gdGhyZWFkLiIpfWVsc2UgaWYocmVhZF8pe3RyeXtvYmouY29udGVudHM9aW50QXJyYXlGcm9tU3RyaW5nKHJlYWRfKG9iai51cmwpLHRydWUpO29iai51c2VkQnl0ZXM9b2JqLmNvbnRlbnRzLmxlbmd0aH1jYXRjaChlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOSl9fWVsc2V7dGhyb3cgbmV3IEVycm9yKCJDYW5ub3QgbG9hZCB3aXRob3V0IHJlYWQoKSBvciBYTUxIdHRwUmVxdWVzdC4iKX19LGNyZWF0ZUxhenlGaWxlKHBhcmVudCxuYW1lLHVybCxjYW5SZWFkLGNhbldyaXRlKXtmdW5jdGlvbiBMYXp5VWludDhBcnJheSgpe3RoaXMubGVuZ3RoS25vd249ZmFsc2U7dGhpcy5jaHVua3M9W119TGF6eVVpbnQ4QXJyYXkucHJvdG90eXBlLmdldD1mdW5jdGlvbiBMYXp5VWludDhBcnJheV9nZXQoaWR4KXtpZihpZHg+dGhpcy5sZW5ndGgtMXx8aWR4PDApe3JldHVybiB1bmRlZmluZWR9dmFyIGNodW5rT2Zmc2V0PWlkeCV0aGlzLmNodW5rU2l6ZTt2YXIgY2h1bmtOdW09aWR4L3RoaXMuY2h1bmtTaXplfDA7cmV0dXJuIHRoaXMuZ2V0dGVyKGNodW5rTnVtKVtjaHVua09mZnNldF19O0xhenlVaW50OEFycmF5LnByb3RvdHlwZS5zZXREYXRhR2V0dGVyPWZ1bmN0aW9uIExhenlVaW50OEFycmF5X3NldERhdGFHZXR0ZXIoZ2V0dGVyKXt0aGlzLmdldHRlcj1nZXR0ZXJ9O0xhenlVaW50OEFycmF5LnByb3RvdHlwZS5jYWNoZUxlbmd0aD1mdW5jdGlvbiBMYXp5VWludDhBcnJheV9jYWNoZUxlbmd0aCgpe3ZhciB4aHI9bmV3IFhNTEh0dHBSZXF1ZXN0O3hoci5vcGVuKCJIRUFEIix1cmwsZmFsc2UpO3hoci5zZW5kKG51bGwpO2lmKCEoeGhyLnN0YXR1cz49MjAwJiZ4aHIuc3RhdHVzPDMwMHx8eGhyLnN0YXR1cz09PTMwNCkpdGhyb3cgbmV3IEVycm9yKCJDb3VsZG4ndCBsb2FkICIrdXJsKyIuIFN0YXR1czogIit4aHIuc3RhdHVzKTt2YXIgZGF0YWxlbmd0aD1OdW1iZXIoeGhyLmdldFJlc3BvbnNlSGVhZGVyKCJDb250ZW50LWxlbmd0aCIpKTt2YXIgaGVhZGVyO3ZhciBoYXNCeXRlU2VydmluZz0oaGVhZGVyPXhoci5nZXRSZXNwb25zZUhlYWRlcigiQWNjZXB0LVJhbmdlcyIpKSYmaGVhZGVyPT09ImJ5dGVzIjt2YXIgdXNlc0d6aXA9KGhlYWRlcj14aHIuZ2V0UmVzcG9uc2VIZWFkZXIoIkNvbnRlbnQtRW5jb2RpbmciKSkmJmhlYWRlcj09PSJnemlwIjt2YXIgY2h1bmtTaXplPTEwMjQqMTAyNDtpZighaGFzQnl0ZVNlcnZpbmcpY2h1bmtTaXplPWRhdGFsZW5ndGg7dmFyIGRvWEhSPShmcm9tLHRvKT0+e2lmKGZyb20+dG8pdGhyb3cgbmV3IEVycm9yKCJpbnZhbGlkIHJhbmdlICgiK2Zyb20rIiwgIit0bysiKSBvciBubyBieXRlcyByZXF1ZXN0ZWQhIik7aWYodG8+ZGF0YWxlbmd0aC0xKXRocm93IG5ldyBFcnJvcigib25seSAiK2RhdGFsZW5ndGgrIiBieXRlcyBhdmFpbGFibGUhIHByb2dyYW1tZXIgZXJyb3IhIik7dmFyIHhocj1uZXcgWE1MSHR0cFJlcXVlc3Q7eGhyLm9wZW4oIkdFVCIsdXJsLGZhbHNlKTtpZihkYXRhbGVuZ3RoIT09Y2h1bmtTaXplKXhoci5zZXRSZXF1ZXN0SGVhZGVyKCJSYW5nZSIsImJ5dGVzPSIrZnJvbSsiLSIrdG8pO3hoci5yZXNwb25zZVR5cGU9ImFycmF5YnVmZmVyIjtpZih4aHIub3ZlcnJpZGVNaW1lVHlwZSl7eGhyLm92ZXJyaWRlTWltZVR5cGUoInRleHQvcGxhaW47IGNoYXJzZXQ9eC11c2VyLWRlZmluZWQiKX14aHIuc2VuZChudWxsKTtpZighKHhoci5zdGF0dXM+PTIwMCYmeGhyLnN0YXR1czwzMDB8fHhoci5zdGF0dXM9PT0zMDQpKXRocm93IG5ldyBFcnJvcigiQ291bGRuJ3QgbG9hZCAiK3VybCsiLiBTdGF0dXM6ICIreGhyLnN0YXR1cyk7aWYoeGhyLnJlc3BvbnNlIT09dW5kZWZpbmVkKXtyZXR1cm4gbmV3IFVpbnQ4QXJyYXkoeGhyLnJlc3BvbnNlfHxbXSl9cmV0dXJuIGludEFycmF5RnJvbVN0cmluZyh4aHIucmVzcG9uc2VUZXh0fHwiIix0cnVlKX07dmFyIGxhenlBcnJheT10aGlzO2xhenlBcnJheS5zZXREYXRhR2V0dGVyKGNodW5rTnVtPT57dmFyIHN0YXJ0PWNodW5rTnVtKmNodW5rU2l6ZTt2YXIgZW5kPShjaHVua051bSsxKSpjaHVua1NpemUtMTtlbmQ9TWF0aC5taW4oZW5kLGRhdGFsZW5ndGgtMSk7aWYodHlwZW9mIGxhenlBcnJheS5jaHVua3NbY2h1bmtOdW1dPT0idW5kZWZpbmVkIil7bGF6eUFycmF5LmNodW5rc1tjaHVua051bV09ZG9YSFIoc3RhcnQsZW5kKX1pZih0eXBlb2YgbGF6eUFycmF5LmNodW5rc1tjaHVua051bV09PSJ1bmRlZmluZWQiKXRocm93IG5ldyBFcnJvcigiZG9YSFIgZmFpbGVkISIpO3JldHVybiBsYXp5QXJyYXkuY2h1bmtzW2NodW5rTnVtXX0pO2lmKHVzZXNHemlwfHwhZGF0YWxlbmd0aCl7Y2h1bmtTaXplPWRhdGFsZW5ndGg9MTtkYXRhbGVuZ3RoPXRoaXMuZ2V0dGVyKDApLmxlbmd0aDtjaHVua1NpemU9ZGF0YWxlbmd0aDtvdXQoIkxhenlGaWxlcyBvbiBnemlwIGZvcmNlcyBkb3dubG9hZCBvZiB0aGUgd2hvbGUgZmlsZSB3aGVuIGxlbmd0aCBpcyBhY2Nlc3NlZCIpfXRoaXMuX2xlbmd0aD1kYXRhbGVuZ3RoO3RoaXMuX2NodW5rU2l6ZT1jaHVua1NpemU7dGhpcy5sZW5ndGhLbm93bj10cnVlfTtpZih0eXBlb2YgWE1MSHR0cFJlcXVlc3QhPSJ1bmRlZmluZWQiKXtpZighRU5WSVJPTk1FTlRfSVNfV09SS0VSKXRocm93IkNhbm5vdCBkbyBzeW5jaHJvbm91cyBiaW5hcnkgWEhScyBvdXRzaWRlIHdlYndvcmtlcnMgaW4gbW9kZXJuIGJyb3dzZXJzLiBVc2UgLS1lbWJlZC1maWxlIG9yIC0tcHJlbG9hZC1maWxlIGluIGVtY2MiO3ZhciBsYXp5QXJyYXk9bmV3IExhenlVaW50OEFycmF5O09iamVjdC5kZWZpbmVQcm9wZXJ0aWVzKGxhenlBcnJheSx7bGVuZ3RoOntnZXQ6ZnVuY3Rpb24oKXtpZighdGhpcy5sZW5ndGhLbm93bil7dGhpcy5jYWNoZUxlbmd0aCgpfXJldHVybiB0aGlzLl9sZW5ndGh9fSxjaHVua1NpemU6e2dldDpmdW5jdGlvbigpe2lmKCF0aGlzLmxlbmd0aEtub3duKXt0aGlzLmNhY2hlTGVuZ3RoKCl9cmV0dXJuIHRoaXMuX2NodW5rU2l6ZX19fSk7dmFyIHByb3BlcnRpZXM9e2lzRGV2aWNlOmZhbHNlLGNvbnRlbnRzOmxhenlBcnJheX19ZWxzZXt2YXIgcHJvcGVydGllcz17aXNEZXZpY2U6ZmFsc2UsdXJsOnVybH19dmFyIG5vZGU9RlMuY3JlYXRlRmlsZShwYXJlbnQsbmFtZSxwcm9wZXJ0aWVzLGNhblJlYWQsY2FuV3JpdGUpO2lmKHByb3BlcnRpZXMuY29udGVudHMpe25vZGUuY29udGVudHM9cHJvcGVydGllcy5jb250ZW50c31lbHNlIGlmKHByb3BlcnRpZXMudXJsKXtub2RlLmNvbnRlbnRzPW51bGw7bm9kZS51cmw9cHJvcGVydGllcy51cmx9T2JqZWN0LmRlZmluZVByb3BlcnRpZXMobm9kZSx7dXNlZEJ5dGVzOntnZXQ6ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5jb250ZW50cy5sZW5ndGh9fX0pO3ZhciBzdHJlYW1fb3BzPXt9O3ZhciBrZXlzPU9iamVjdC5rZXlzKG5vZGUuc3RyZWFtX29wcyk7a2V5cy5mb3JFYWNoKGtleT0+e3ZhciBmbj1ub2RlLnN0cmVhbV9vcHNba2V5XTtzdHJlYW1fb3BzW2tleV09ZnVuY3Rpb24gZm9yY2VMb2FkTGF6eUZpbGUoKXtGUy5mb3JjZUxvYWRGaWxlKG5vZGUpO3JldHVybiBmbi5hcHBseShudWxsLGFyZ3VtZW50cyl9fSk7ZnVuY3Rpb24gd3JpdGVDaHVua3Moc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvc2l0aW9uKXt2YXIgY29udGVudHM9c3RyZWFtLm5vZGUuY29udGVudHM7aWYocG9zaXRpb24+PWNvbnRlbnRzLmxlbmd0aClyZXR1cm4gMDt2YXIgc2l6ZT1NYXRoLm1pbihjb250ZW50cy5sZW5ndGgtcG9zaXRpb24sbGVuZ3RoKTtpZihjb250ZW50cy5zbGljZSl7Zm9yKHZhciBpPTA7aTxzaXplO2krKyl7YnVmZmVyW29mZnNldCtpXT1jb250ZW50c1twb3NpdGlvbitpXX19ZWxzZXtmb3IodmFyIGk9MDtpPHNpemU7aSsrKXtidWZmZXJbb2Zmc2V0K2ldPWNvbnRlbnRzLmdldChwb3NpdGlvbitpKX19cmV0dXJuIHNpemV9c3RyZWFtX29wcy5yZWFkPShzdHJlYW0sYnVmZmVyLG9mZnNldCxsZW5ndGgscG9zaXRpb24pPT57RlMuZm9yY2VMb2FkRmlsZShub2RlKTtyZXR1cm4gd3JpdGVDaHVua3Moc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvc2l0aW9uKX07c3RyZWFtX29wcy5tbWFwPShzdHJlYW0sbGVuZ3RoLHBvc2l0aW9uLHByb3QsZmxhZ3MpPT57RlMuZm9yY2VMb2FkRmlsZShub2RlKTt2YXIgcHRyPW1tYXBBbGxvYyhsZW5ndGgpO2lmKCFwdHIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ4KX13cml0ZUNodW5rcyhzdHJlYW0sSEVBUDgscHRyLGxlbmd0aCxwb3NpdGlvbik7cmV0dXJue3B0cjpwdHIsYWxsb2NhdGVkOnRydWV9fTtub2RlLnN0cmVhbV9vcHM9c3RyZWFtX29wcztyZXR1cm4gbm9kZX19O3ZhciBTWVNDQUxMUz17REVGQVVMVF9QT0xMTUFTSzo1LGNhbGN1bGF0ZUF0KGRpcmZkLHBhdGgsYWxsb3dFbXB0eSl7aWYoUEFUSC5pc0FicyhwYXRoKSl7cmV0dXJuIHBhdGh9dmFyIGRpcjtpZihkaXJmZD09PS0xMDApe2Rpcj1GUy5jd2QoKX1lbHNle3ZhciBkaXJzdHJlYW09U1lTQ0FMTFMuZ2V0U3RyZWFtRnJvbUZEKGRpcmZkKTtkaXI9ZGlyc3RyZWFtLnBhdGh9aWYocGF0aC5sZW5ndGg9PTApe2lmKCFhbGxvd0VtcHR5KXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0NCl9cmV0dXJuIGRpcn1yZXR1cm4gUEFUSC5qb2luMihkaXIscGF0aCl9LGRvU3RhdChmdW5jLHBhdGgsYnVmKXt0cnl7dmFyIHN0YXQ9ZnVuYyhwYXRoKX1jYXRjaChlKXtpZihlJiZlLm5vZGUmJlBBVEgubm9ybWFsaXplKHBhdGgpIT09UEFUSC5ub3JtYWxpemUoRlMuZ2V0UGF0aChlLm5vZGUpKSl7cmV0dXJuLTU0fXRocm93IGV9SEVBUDMyW2J1Zj4+Ml09c3RhdC5kZXY7SEVBUDMyW2J1Zis0Pj4yXT1zdGF0Lm1vZGU7SEVBUFUzMltidWYrOD4+Ml09c3RhdC5ubGluaztIRUFQMzJbYnVmKzEyPj4yXT1zdGF0LnVpZDtIRUFQMzJbYnVmKzE2Pj4yXT1zdGF0LmdpZDtIRUFQMzJbYnVmKzIwPj4yXT1zdGF0LnJkZXY7dGVtcEk2ND1bc3RhdC5zaXplPj4+MCwodGVtcERvdWJsZT1zdGF0LnNpemUsK01hdGguYWJzKHRlbXBEb3VibGUpPj0xP3RlbXBEb3VibGU+MD8rTWF0aC5mbG9vcih0ZW1wRG91YmxlLzQyOTQ5NjcyOTYpPj4+MDp+fitNYXRoLmNlaWwoKHRlbXBEb3VibGUtKyh+fnRlbXBEb3VibGU+Pj4wKSkvNDI5NDk2NzI5Nik+Pj4wOjApXSxIRUFQMzJbYnVmKzI0Pj4yXT10ZW1wSTY0WzBdLEhFQVAzMltidWYrMjg+PjJdPXRlbXBJNjRbMV07SEVBUDMyW2J1ZiszMj4+Ml09NDA5NjtIRUFQMzJbYnVmKzM2Pj4yXT1zdGF0LmJsb2Nrczt2YXIgYXRpbWU9c3RhdC5hdGltZS5nZXRUaW1lKCk7dmFyIG10aW1lPXN0YXQubXRpbWUuZ2V0VGltZSgpO3ZhciBjdGltZT1zdGF0LmN0aW1lLmdldFRpbWUoKTt0ZW1wSTY0PVtNYXRoLmZsb29yKGF0aW1lLzFlMyk+Pj4wLCh0ZW1wRG91YmxlPU1hdGguZmxvb3IoYXRpbWUvMWUzKSwrTWF0aC5hYnModGVtcERvdWJsZSk+PTE/dGVtcERvdWJsZT4wPytNYXRoLmZsb29yKHRlbXBEb3VibGUvNDI5NDk2NzI5Nik+Pj4wOn5+K01hdGguY2VpbCgodGVtcERvdWJsZS0rKH5+dGVtcERvdWJsZT4+PjApKS80Mjk0OTY3Mjk2KT4+PjA6MCldLEhFQVAzMltidWYrNDA+PjJdPXRlbXBJNjRbMF0sSEVBUDMyW2J1Zis0ND4+Ml09dGVtcEk2NFsxXTtIRUFQVTMyW2J1Zis0OD4+Ml09YXRpbWUlMWUzKjFlMzt0ZW1wSTY0PVtNYXRoLmZsb29yKG10aW1lLzFlMyk+Pj4wLCh0ZW1wRG91YmxlPU1hdGguZmxvb3IobXRpbWUvMWUzKSwrTWF0aC5hYnModGVtcERvdWJsZSk+PTE/dGVtcERvdWJsZT4wPytNYXRoLmZsb29yKHRlbXBEb3VibGUvNDI5NDk2NzI5Nik+Pj4wOn5+K01hdGguY2VpbCgodGVtcERvdWJsZS0rKH5+dGVtcERvdWJsZT4+PjApKS80Mjk0OTY3Mjk2KT4+PjA6MCldLEhFQVAzMltidWYrNTY+PjJdPXRlbXBJNjRbMF0sSEVBUDMyW2J1Zis2MD4+Ml09dGVtcEk2NFsxXTtIRUFQVTMyW2J1Zis2ND4+Ml09bXRpbWUlMWUzKjFlMzt0ZW1wSTY0PVtNYXRoLmZsb29yKGN0aW1lLzFlMyk+Pj4wLCh0ZW1wRG91YmxlPU1hdGguZmxvb3IoY3RpbWUvMWUzKSwrTWF0aC5hYnModGVtcERvdWJsZSk+PTE/dGVtcERvdWJsZT4wPytNYXRoLmZsb29yKHRlbXBEb3VibGUvNDI5NDk2NzI5Nik+Pj4wOn5+K01hdGguY2VpbCgodGVtcERvdWJsZS0rKH5+dGVtcERvdWJsZT4+PjApKS80Mjk0OTY3Mjk2KT4+PjA6MCldLEhFQVAzMltidWYrNzI+PjJdPXRlbXBJNjRbMF0sSEVBUDMyW2J1Zis3Nj4+Ml09dGVtcEk2NFsxXTtIRUFQVTMyW2J1Zis4MD4+Ml09Y3RpbWUlMWUzKjFlMzt0ZW1wSTY0PVtzdGF0Lmlubz4+PjAsKHRlbXBEb3VibGU9c3RhdC5pbm8sK01hdGguYWJzKHRlbXBEb3VibGUpPj0xP3RlbXBEb3VibGU+MD8rTWF0aC5mbG9vcih0ZW1wRG91YmxlLzQyOTQ5NjcyOTYpPj4+MDp+fitNYXRoLmNlaWwoKHRlbXBEb3VibGUtKyh+fnRlbXBEb3VibGU+Pj4wKSkvNDI5NDk2NzI5Nik+Pj4wOjApXSxIRUFQMzJbYnVmKzg4Pj4yXT10ZW1wSTY0WzBdLEhFQVAzMltidWYrOTI+PjJdPXRlbXBJNjRbMV07cmV0dXJuIDB9LGRvTXN5bmMoYWRkcixzdHJlYW0sbGVuLGZsYWdzLG9mZnNldCl7aWYoIUZTLmlzRmlsZShzdHJlYW0ubm9kZS5tb2RlKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDMpfWlmKGZsYWdzJjIpe3JldHVybiAwfXZhciBidWZmZXI9SEVBUFU4LnNsaWNlKGFkZHIsYWRkcitsZW4pO0ZTLm1zeW5jKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbixmbGFncyl9LHZhcmFyZ3M6dW5kZWZpbmVkLGdldCgpe3ZhciByZXQ9SEVBUDMyWytTWVNDQUxMUy52YXJhcmdzPj4yXTtTWVNDQUxMUy52YXJhcmdzKz00O3JldHVybiByZXR9LGdldHAoKXtyZXR1cm4gU1lTQ0FMTFMuZ2V0KCl9LGdldFN0cihwdHIpe3ZhciByZXQ9VVRGOFRvU3RyaW5nKHB0cik7cmV0dXJuIHJldH0sZ2V0U3RyZWFtRnJvbUZEKGZkKXt2YXIgc3RyZWFtPUZTLmdldFN0cmVhbUNoZWNrZWQoZmQpO3JldHVybiBzdHJlYW19fTtmdW5jdGlvbiBfX19zeXNjYWxsX2ZzdGF0NjQoZmQsYnVmKXt0cnl7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO3JldHVybiBTWVNDQUxMUy5kb1N0YXQoRlMuc3RhdCxzdHJlYW0ucGF0aCxidWYpfWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybi1lLmVycm5vfX12YXIgY29udmVydEkzMlBhaXJUb0k1M0NoZWNrZWQ9KGxvLGhpKT0+aGkrMjA5NzE1Mj4+PjA8NDE5NDMwNS0hIWxvPyhsbz4+PjApK2hpKjQyOTQ5NjcyOTY6TmFOO2Z1bmN0aW9uIF9fX3N5c2NhbGxfZnRydW5jYXRlNjQoZmQsbGVuZ3RoX2xvdyxsZW5ndGhfaGlnaCl7dmFyIGxlbmd0aD1jb252ZXJ0STMyUGFpclRvSTUzQ2hlY2tlZChsZW5ndGhfbG93LGxlbmd0aF9oaWdoKTt0cnl7aWYoaXNOYU4obGVuZ3RoKSlyZXR1cm4gNjE7RlMuZnRydW5jYXRlKGZkLGxlbmd0aCk7cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuLWUuZXJybm99fWZ1bmN0aW9uIF9fX3N5c2NhbGxfbmV3ZnN0YXRhdChkaXJmZCxwYXRoLGJ1ZixmbGFncyl7dHJ5e3BhdGg9U1lTQ0FMTFMuZ2V0U3RyKHBhdGgpO3ZhciBub2ZvbGxvdz1mbGFncyYyNTY7dmFyIGFsbG93RW1wdHk9ZmxhZ3MmNDA5NjtmbGFncz1mbGFncyZ+NjQwMDtwYXRoPVNZU0NBTExTLmNhbGN1bGF0ZUF0KGRpcmZkLHBhdGgsYWxsb3dFbXB0eSk7cmV0dXJuIFNZU0NBTExTLmRvU3RhdChub2ZvbGxvdz9GUy5sc3RhdDpGUy5zdGF0LHBhdGgsYnVmKX1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319ZnVuY3Rpb24gX19fc3lzY2FsbF9vcGVuYXQoZGlyZmQscGF0aCxmbGFncyx2YXJhcmdzKXtTWVNDQUxMUy52YXJhcmdzPXZhcmFyZ3M7dHJ5e3BhdGg9U1lTQ0FMTFMuZ2V0U3RyKHBhdGgpO3BhdGg9U1lTQ0FMTFMuY2FsY3VsYXRlQXQoZGlyZmQscGF0aCk7dmFyIG1vZGU9dmFyYXJncz9TWVNDQUxMUy5nZXQoKTowO3JldHVybiBGUy5vcGVuKHBhdGgsZmxhZ3MsbW9kZSkuZmR9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuLWUuZXJybm99fXZhciBzdHJpbmdUb1VURjg9KHN0cixvdXRQdHIsbWF4Qnl0ZXNUb1dyaXRlKT0+c3RyaW5nVG9VVEY4QXJyYXkoc3RyLEhFQVBVOCxvdXRQdHIsbWF4Qnl0ZXNUb1dyaXRlKTtmdW5jdGlvbiBfX19zeXNjYWxsX3JlYWRsaW5rYXQoZGlyZmQscGF0aCxidWYsYnVmc2l6ZSl7dHJ5e3BhdGg9U1lTQ0FMTFMuZ2V0U3RyKHBhdGgpO3BhdGg9U1lTQ0FMTFMuY2FsY3VsYXRlQXQoZGlyZmQscGF0aCk7aWYoYnVmc2l6ZTw9MClyZXR1cm4tMjg7dmFyIHJldD1GUy5yZWFkbGluayhwYXRoKTt2YXIgbGVuPU1hdGgubWluKGJ1ZnNpemUsbGVuZ3RoQnl0ZXNVVEY4KHJldCkpO3ZhciBlbmRDaGFyPUhFQVA4W2J1ZitsZW5dO3N0cmluZ1RvVVRGOChyZXQsYnVmLGJ1ZnNpemUrMSk7SEVBUDhbYnVmK2xlbl09ZW5kQ2hhcjtyZXR1cm4gbGVufWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybi1lLmVycm5vfX1mdW5jdGlvbiBfX19zeXNjYWxsX3JlbmFtZWF0KG9sZGRpcmZkLG9sZHBhdGgsbmV3ZGlyZmQsbmV3cGF0aCl7dHJ5e29sZHBhdGg9U1lTQ0FMTFMuZ2V0U3RyKG9sZHBhdGgpO25ld3BhdGg9U1lTQ0FMTFMuZ2V0U3RyKG5ld3BhdGgpO29sZHBhdGg9U1lTQ0FMTFMuY2FsY3VsYXRlQXQob2xkZGlyZmQsb2xkcGF0aCk7bmV3cGF0aD1TWVNDQUxMUy5jYWxjdWxhdGVBdChuZXdkaXJmZCxuZXdwYXRoKTtGUy5yZW5hbWUob2xkcGF0aCxuZXdwYXRoKTtyZXR1cm4gMH1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319ZnVuY3Rpb24gX19fc3lzY2FsbF9zdGF0NjQocGF0aCxidWYpe3RyeXtwYXRoPVNZU0NBTExTLmdldFN0cihwYXRoKTtyZXR1cm4gU1lTQ0FMTFMuZG9TdGF0KEZTLnN0YXQscGF0aCxidWYpfWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybi1lLmVycm5vfX1mdW5jdGlvbiBfX19zeXNjYWxsX3VubGlua2F0KGRpcmZkLHBhdGgsZmxhZ3Mpe3RyeXtwYXRoPVNZU0NBTExTLmdldFN0cihwYXRoKTtwYXRoPVNZU0NBTExTLmNhbGN1bGF0ZUF0KGRpcmZkLHBhdGgpO2lmKGZsYWdzPT09MCl7RlMudW5saW5rKHBhdGgpfWVsc2UgaWYoZmxhZ3M9PT01MTIpe0ZTLnJtZGlyKHBhdGgpfWVsc2V7YWJvcnQoIkludmFsaWQgZmxhZ3MgcGFzc2VkIHRvIHVubGlua2F0Iil9cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuLWUuZXJybm99fXZhciBfX2VtYmluZF9yZWdpc3Rlcl9iaWdpbnQ9KHByaW1pdGl2ZVR5cGUsbmFtZSxzaXplLG1pblJhbmdlLG1heFJhbmdlKT0+e307dmFyIGVtYmluZF9pbml0X2NoYXJDb2Rlcz0oKT0+e3ZhciBjb2Rlcz1uZXcgQXJyYXkoMjU2KTtmb3IodmFyIGk9MDtpPDI1NjsrK2kpe2NvZGVzW2ldPVN0cmluZy5mcm9tQ2hhckNvZGUoaSl9ZW1iaW5kX2NoYXJDb2Rlcz1jb2Rlc307dmFyIGVtYmluZF9jaGFyQ29kZXM7dmFyIHJlYWRMYXRpbjFTdHJpbmc9cHRyPT57dmFyIHJldD0iIjt2YXIgYz1wdHI7d2hpbGUoSEVBUFU4W2NdKXtyZXQrPWVtYmluZF9jaGFyQ29kZXNbSEVBUFU4W2MrK11dfXJldHVybiByZXR9O3ZhciBhd2FpdGluZ0RlcGVuZGVuY2llcz17fTt2YXIgcmVnaXN0ZXJlZFR5cGVzPXt9O3ZhciB0eXBlRGVwZW5kZW5jaWVzPXt9O3ZhciBCaW5kaW5nRXJyb3I7dmFyIHRocm93QmluZGluZ0Vycm9yPW1lc3NhZ2U9Pnt0aHJvdyBuZXcgQmluZGluZ0Vycm9yKG1lc3NhZ2UpfTt2YXIgSW50ZXJuYWxFcnJvcjt2YXIgdGhyb3dJbnRlcm5hbEVycm9yPW1lc3NhZ2U9Pnt0aHJvdyBuZXcgSW50ZXJuYWxFcnJvcihtZXNzYWdlKX07dmFyIHdoZW5EZXBlbmRlbnRUeXBlc0FyZVJlc29sdmVkPShteVR5cGVzLGRlcGVuZGVudFR5cGVzLGdldFR5cGVDb252ZXJ0ZXJzKT0+e215VHlwZXMuZm9yRWFjaChmdW5jdGlvbih0eXBlKXt0eXBlRGVwZW5kZW5jaWVzW3R5cGVdPWRlcGVuZGVudFR5cGVzfSk7ZnVuY3Rpb24gb25Db21wbGV0ZSh0eXBlQ29udmVydGVycyl7dmFyIG15VHlwZUNvbnZlcnRlcnM9Z2V0VHlwZUNvbnZlcnRlcnModHlwZUNvbnZlcnRlcnMpO2lmKG15VHlwZUNvbnZlcnRlcnMubGVuZ3RoIT09bXlUeXBlcy5sZW5ndGgpe3Rocm93SW50ZXJuYWxFcnJvcigiTWlzbWF0Y2hlZCB0eXBlIGNvbnZlcnRlciBjb3VudCIpfWZvcih2YXIgaT0wO2k8bXlUeXBlcy5sZW5ndGg7KytpKXtyZWdpc3RlclR5cGUobXlUeXBlc1tpXSxteVR5cGVDb252ZXJ0ZXJzW2ldKX19dmFyIHR5cGVDb252ZXJ0ZXJzPW5ldyBBcnJheShkZXBlbmRlbnRUeXBlcy5sZW5ndGgpO3ZhciB1bnJlZ2lzdGVyZWRUeXBlcz1bXTt2YXIgcmVnaXN0ZXJlZD0wO2RlcGVuZGVudFR5cGVzLmZvckVhY2goKGR0LGkpPT57aWYocmVnaXN0ZXJlZFR5cGVzLmhhc093blByb3BlcnR5KGR0KSl7dHlwZUNvbnZlcnRlcnNbaV09cmVnaXN0ZXJlZFR5cGVzW2R0XX1lbHNle3VucmVnaXN0ZXJlZFR5cGVzLnB1c2goZHQpO2lmKCFhd2FpdGluZ0RlcGVuZGVuY2llcy5oYXNPd25Qcm9wZXJ0eShkdCkpe2F3YWl0aW5nRGVwZW5kZW5jaWVzW2R0XT1bXX1hd2FpdGluZ0RlcGVuZGVuY2llc1tkdF0ucHVzaCgoKT0+e3R5cGVDb252ZXJ0ZXJzW2ldPXJlZ2lzdGVyZWRUeXBlc1tkdF07KytyZWdpc3RlcmVkO2lmKHJlZ2lzdGVyZWQ9PT11bnJlZ2lzdGVyZWRUeXBlcy5sZW5ndGgpe29uQ29tcGxldGUodHlwZUNvbnZlcnRlcnMpfX0pfX0pO2lmKDA9PT11bnJlZ2lzdGVyZWRUeXBlcy5sZW5ndGgpe29uQ29tcGxldGUodHlwZUNvbnZlcnRlcnMpfX07ZnVuY3Rpb24gc2hhcmVkUmVnaXN0ZXJUeXBlKHJhd1R5cGUscmVnaXN0ZXJlZEluc3RhbmNlLG9wdGlvbnM9e30pe3ZhciBuYW1lPXJlZ2lzdGVyZWRJbnN0YW5jZS5uYW1lO2lmKCFyYXdUeXBlKXt0aHJvd0JpbmRpbmdFcnJvcihgdHlwZSAiJHtuYW1lfSIgbXVzdCBoYXZlIGEgcG9zaXRpdmUgaW50ZWdlciB0eXBlaWQgcG9pbnRlcmApfWlmKHJlZ2lzdGVyZWRUeXBlcy5oYXNPd25Qcm9wZXJ0eShyYXdUeXBlKSl7aWYob3B0aW9ucy5pZ25vcmVEdXBsaWNhdGVSZWdpc3RyYXRpb25zKXtyZXR1cm59ZWxzZXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IHJlZ2lzdGVyIHR5cGUgJyR7bmFtZX0nIHR3aWNlYCl9fXJlZ2lzdGVyZWRUeXBlc1tyYXdUeXBlXT1yZWdpc3RlcmVkSW5zdGFuY2U7ZGVsZXRlIHR5cGVEZXBlbmRlbmNpZXNbcmF3VHlwZV07aWYoYXdhaXRpbmdEZXBlbmRlbmNpZXMuaGFzT3duUHJvcGVydHkocmF3VHlwZSkpe3ZhciBjYWxsYmFja3M9YXdhaXRpbmdEZXBlbmRlbmNpZXNbcmF3VHlwZV07ZGVsZXRlIGF3YWl0aW5nRGVwZW5kZW5jaWVzW3Jhd1R5cGVdO2NhbGxiYWNrcy5mb3JFYWNoKGNiPT5jYigpKX19ZnVuY3Rpb24gcmVnaXN0ZXJUeXBlKHJhd1R5cGUscmVnaXN0ZXJlZEluc3RhbmNlLG9wdGlvbnM9e30pe2lmKCEoImFyZ1BhY2tBZHZhbmNlImluIHJlZ2lzdGVyZWRJbnN0YW5jZSkpe3Rocm93IG5ldyBUeXBlRXJyb3IoInJlZ2lzdGVyVHlwZSByZWdpc3RlcmVkSW5zdGFuY2UgcmVxdWlyZXMgYXJnUGFja0FkdmFuY2UiKX1yZXR1cm4gc2hhcmVkUmVnaXN0ZXJUeXBlKHJhd1R5cGUscmVnaXN0ZXJlZEluc3RhbmNlLG9wdGlvbnMpfXZhciBHZW5lcmljV2lyZVR5cGVTaXplPTg7dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX2Jvb2w9KHJhd1R5cGUsbmFtZSx0cnVlVmFsdWUsZmFsc2VWYWx1ZSk9PntuYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7cmVnaXN0ZXJUeXBlKHJhd1R5cGUse25hbWU6bmFtZSwiZnJvbVdpcmVUeXBlIjpmdW5jdGlvbih3dCl7cmV0dXJuISF3dH0sInRvV2lyZVR5cGUiOmZ1bmN0aW9uKGRlc3RydWN0b3JzLG8pe3JldHVybiBvP3RydWVWYWx1ZTpmYWxzZVZhbHVlfSwiYXJnUGFja0FkdmFuY2UiOkdlbmVyaWNXaXJlVHlwZVNpemUsInJlYWRWYWx1ZUZyb21Qb2ludGVyIjpmdW5jdGlvbihwb2ludGVyKXtyZXR1cm4gdGhpc1siZnJvbVdpcmVUeXBlIl0oSEVBUFU4W3BvaW50ZXJdKX0sZGVzdHJ1Y3RvckZ1bmN0aW9uOm51bGx9KX07dmFyIHNoYWxsb3dDb3B5SW50ZXJuYWxQb2ludGVyPW89Pih7Y291bnQ6by5jb3VudCxkZWxldGVTY2hlZHVsZWQ6by5kZWxldGVTY2hlZHVsZWQscHJlc2VydmVQb2ludGVyT25EZWxldGU6by5wcmVzZXJ2ZVBvaW50ZXJPbkRlbGV0ZSxwdHI6by5wdHIscHRyVHlwZTpvLnB0clR5cGUsc21hcnRQdHI6by5zbWFydFB0cixzbWFydFB0clR5cGU6by5zbWFydFB0clR5cGV9KTt2YXIgdGhyb3dJbnN0YW5jZUFscmVhZHlEZWxldGVkPW9iaj0+e2Z1bmN0aW9uIGdldEluc3RhbmNlVHlwZU5hbWUoaGFuZGxlKXtyZXR1cm4gaGFuZGxlLiQkLnB0clR5cGUucmVnaXN0ZXJlZENsYXNzLm5hbWV9dGhyb3dCaW5kaW5nRXJyb3IoZ2V0SW5zdGFuY2VUeXBlTmFtZShvYmopKyIgaW5zdGFuY2UgYWxyZWFkeSBkZWxldGVkIil9O3ZhciBmaW5hbGl6YXRpb25SZWdpc3RyeT1mYWxzZTt2YXIgZGV0YWNoRmluYWxpemVyPWhhbmRsZT0+e307dmFyIHJ1bkRlc3RydWN0b3I9JCQ9PntpZigkJC5zbWFydFB0cil7JCQuc21hcnRQdHJUeXBlLnJhd0Rlc3RydWN0b3IoJCQuc21hcnRQdHIpfWVsc2V7JCQucHRyVHlwZS5yZWdpc3RlcmVkQ2xhc3MucmF3RGVzdHJ1Y3RvcigkJC5wdHIpfX07dmFyIHJlbGVhc2VDbGFzc0hhbmRsZT0kJD0+eyQkLmNvdW50LnZhbHVlLT0xO3ZhciB0b0RlbGV0ZT0wPT09JCQuY291bnQudmFsdWU7aWYodG9EZWxldGUpe3J1bkRlc3RydWN0b3IoJCQpfX07dmFyIGRvd25jYXN0UG9pbnRlcj0ocHRyLHB0ckNsYXNzLGRlc2lyZWRDbGFzcyk9PntpZihwdHJDbGFzcz09PWRlc2lyZWRDbGFzcyl7cmV0dXJuIHB0cn1pZih1bmRlZmluZWQ9PT1kZXNpcmVkQ2xhc3MuYmFzZUNsYXNzKXtyZXR1cm4gbnVsbH12YXIgcnY9ZG93bmNhc3RQb2ludGVyKHB0cixwdHJDbGFzcyxkZXNpcmVkQ2xhc3MuYmFzZUNsYXNzKTtpZihydj09PW51bGwpe3JldHVybiBudWxsfXJldHVybiBkZXNpcmVkQ2xhc3MuZG93bmNhc3QocnYpfTt2YXIgcmVnaXN0ZXJlZFBvaW50ZXJzPXt9O3ZhciBnZXRJbmhlcml0ZWRJbnN0YW5jZUNvdW50PSgpPT5PYmplY3Qua2V5cyhyZWdpc3RlcmVkSW5zdGFuY2VzKS5sZW5ndGg7dmFyIGdldExpdmVJbmhlcml0ZWRJbnN0YW5jZXM9KCk9Pnt2YXIgcnY9W107Zm9yKHZhciBrIGluIHJlZ2lzdGVyZWRJbnN0YW5jZXMpe2lmKHJlZ2lzdGVyZWRJbnN0YW5jZXMuaGFzT3duUHJvcGVydHkoaykpe3J2LnB1c2gocmVnaXN0ZXJlZEluc3RhbmNlc1trXSl9fXJldHVybiBydn07dmFyIGRlbGV0aW9uUXVldWU9W107dmFyIGZsdXNoUGVuZGluZ0RlbGV0ZXM9KCk9Pnt3aGlsZShkZWxldGlvblF1ZXVlLmxlbmd0aCl7dmFyIG9iaj1kZWxldGlvblF1ZXVlLnBvcCgpO29iai4kJC5kZWxldGVTY2hlZHVsZWQ9ZmFsc2U7b2JqWyJkZWxldGUiXSgpfX07dmFyIGRlbGF5RnVuY3Rpb247dmFyIHNldERlbGF5RnVuY3Rpb249Zm49PntkZWxheUZ1bmN0aW9uPWZuO2lmKGRlbGV0aW9uUXVldWUubGVuZ3RoJiZkZWxheUZ1bmN0aW9uKXtkZWxheUZ1bmN0aW9uKGZsdXNoUGVuZGluZ0RlbGV0ZXMpfX07dmFyIGluaXRfZW1iaW5kPSgpPT57TW9kdWxlWyJnZXRJbmhlcml0ZWRJbnN0YW5jZUNvdW50Il09Z2V0SW5oZXJpdGVkSW5zdGFuY2VDb3VudDtNb2R1bGVbImdldExpdmVJbmhlcml0ZWRJbnN0YW5jZXMiXT1nZXRMaXZlSW5oZXJpdGVkSW5zdGFuY2VzO01vZHVsZVsiZmx1c2hQZW5kaW5nRGVsZXRlcyJdPWZsdXNoUGVuZGluZ0RlbGV0ZXM7TW9kdWxlWyJzZXREZWxheUZ1bmN0aW9uIl09c2V0RGVsYXlGdW5jdGlvbn07dmFyIHJlZ2lzdGVyZWRJbnN0YW5jZXM9e307dmFyIGdldEJhc2VzdFBvaW50ZXI9KGNsYXNzXyxwdHIpPT57aWYocHRyPT09dW5kZWZpbmVkKXt0aHJvd0JpbmRpbmdFcnJvcigicHRyIHNob3VsZCBub3QgYmUgdW5kZWZpbmVkIil9d2hpbGUoY2xhc3NfLmJhc2VDbGFzcyl7cHRyPWNsYXNzXy51cGNhc3QocHRyKTtjbGFzc189Y2xhc3NfLmJhc2VDbGFzc31yZXR1cm4gcHRyfTt2YXIgZ2V0SW5oZXJpdGVkSW5zdGFuY2U9KGNsYXNzXyxwdHIpPT57cHRyPWdldEJhc2VzdFBvaW50ZXIoY2xhc3NfLHB0cik7cmV0dXJuIHJlZ2lzdGVyZWRJbnN0YW5jZXNbcHRyXX07dmFyIG1ha2VDbGFzc0hhbmRsZT0ocHJvdG90eXBlLHJlY29yZCk9PntpZighcmVjb3JkLnB0clR5cGV8fCFyZWNvcmQucHRyKXt0aHJvd0ludGVybmFsRXJyb3IoIm1ha2VDbGFzc0hhbmRsZSByZXF1aXJlcyBwdHIgYW5kIHB0clR5cGUiKX12YXIgaGFzU21hcnRQdHJUeXBlPSEhcmVjb3JkLnNtYXJ0UHRyVHlwZTt2YXIgaGFzU21hcnRQdHI9ISFyZWNvcmQuc21hcnRQdHI7aWYoaGFzU21hcnRQdHJUeXBlIT09aGFzU21hcnRQdHIpe3Rocm93SW50ZXJuYWxFcnJvcigiQm90aCBzbWFydFB0clR5cGUgYW5kIHNtYXJ0UHRyIG11c3QgYmUgc3BlY2lmaWVkIil9cmVjb3JkLmNvdW50PXt2YWx1ZToxfTtyZXR1cm4gYXR0YWNoRmluYWxpemVyKE9iamVjdC5jcmVhdGUocHJvdG90eXBlLHskJDp7dmFsdWU6cmVjb3JkfX0pKX07ZnVuY3Rpb24gUmVnaXN0ZXJlZFBvaW50ZXJfZnJvbVdpcmVUeXBlKHB0cil7dmFyIHJhd1BvaW50ZXI9dGhpcy5nZXRQb2ludGVlKHB0cik7aWYoIXJhd1BvaW50ZXIpe3RoaXMuZGVzdHJ1Y3RvcihwdHIpO3JldHVybiBudWxsfXZhciByZWdpc3RlcmVkSW5zdGFuY2U9Z2V0SW5oZXJpdGVkSW5zdGFuY2UodGhpcy5yZWdpc3RlcmVkQ2xhc3MscmF3UG9pbnRlcik7aWYodW5kZWZpbmVkIT09cmVnaXN0ZXJlZEluc3RhbmNlKXtpZigwPT09cmVnaXN0ZXJlZEluc3RhbmNlLiQkLmNvdW50LnZhbHVlKXtyZWdpc3RlcmVkSW5zdGFuY2UuJCQucHRyPXJhd1BvaW50ZXI7cmVnaXN0ZXJlZEluc3RhbmNlLiQkLnNtYXJ0UHRyPXB0cjtyZXR1cm4gcmVnaXN0ZXJlZEluc3RhbmNlWyJjbG9uZSJdKCl9ZWxzZXt2YXIgcnY9cmVnaXN0ZXJlZEluc3RhbmNlWyJjbG9uZSJdKCk7dGhpcy5kZXN0cnVjdG9yKHB0cik7cmV0dXJuIHJ2fX1mdW5jdGlvbiBtYWtlRGVmYXVsdEhhbmRsZSgpe2lmKHRoaXMuaXNTbWFydFBvaW50ZXIpe3JldHVybiBtYWtlQ2xhc3NIYW5kbGUodGhpcy5yZWdpc3RlcmVkQ2xhc3MuaW5zdGFuY2VQcm90b3R5cGUse3B0clR5cGU6dGhpcy5wb2ludGVlVHlwZSxwdHI6cmF3UG9pbnRlcixzbWFydFB0clR5cGU6dGhpcyxzbWFydFB0cjpwdHJ9KX1lbHNle3JldHVybiBtYWtlQ2xhc3NIYW5kbGUodGhpcy5yZWdpc3RlcmVkQ2xhc3MuaW5zdGFuY2VQcm90b3R5cGUse3B0clR5cGU6dGhpcyxwdHI6cHRyfSl9fXZhciBhY3R1YWxUeXBlPXRoaXMucmVnaXN0ZXJlZENsYXNzLmdldEFjdHVhbFR5cGUocmF3UG9pbnRlcik7dmFyIHJlZ2lzdGVyZWRQb2ludGVyUmVjb3JkPXJlZ2lzdGVyZWRQb2ludGVyc1thY3R1YWxUeXBlXTtpZighcmVnaXN0ZXJlZFBvaW50ZXJSZWNvcmQpe3JldHVybiBtYWtlRGVmYXVsdEhhbmRsZS5jYWxsKHRoaXMpfXZhciB0b1R5cGU7aWYodGhpcy5pc0NvbnN0KXt0b1R5cGU9cmVnaXN0ZXJlZFBvaW50ZXJSZWNvcmQuY29uc3RQb2ludGVyVHlwZX1lbHNle3RvVHlwZT1yZWdpc3RlcmVkUG9pbnRlclJlY29yZC5wb2ludGVyVHlwZX12YXIgZHA9ZG93bmNhc3RQb2ludGVyKHJhd1BvaW50ZXIsdGhpcy5yZWdpc3RlcmVkQ2xhc3MsdG9UeXBlLnJlZ2lzdGVyZWRDbGFzcyk7aWYoZHA9PT1udWxsKXtyZXR1cm4gbWFrZURlZmF1bHRIYW5kbGUuY2FsbCh0aGlzKX1pZih0aGlzLmlzU21hcnRQb2ludGVyKXtyZXR1cm4gbWFrZUNsYXNzSGFuZGxlKHRvVHlwZS5yZWdpc3RlcmVkQ2xhc3MuaW5zdGFuY2VQcm90b3R5cGUse3B0clR5cGU6dG9UeXBlLHB0cjpkcCxzbWFydFB0clR5cGU6dGhpcyxzbWFydFB0cjpwdHJ9KX1lbHNle3JldHVybiBtYWtlQ2xhc3NIYW5kbGUodG9UeXBlLnJlZ2lzdGVyZWRDbGFzcy5pbnN0YW5jZVByb3RvdHlwZSx7cHRyVHlwZTp0b1R5cGUscHRyOmRwfSl9fXZhciBhdHRhY2hGaW5hbGl6ZXI9aGFuZGxlPT57aWYoInVuZGVmaW5lZCI9PT10eXBlb2YgRmluYWxpemF0aW9uUmVnaXN0cnkpe2F0dGFjaEZpbmFsaXplcj1oYW5kbGU9PmhhbmRsZTtyZXR1cm4gaGFuZGxlfWZpbmFsaXphdGlvblJlZ2lzdHJ5PW5ldyBGaW5hbGl6YXRpb25SZWdpc3RyeShpbmZvPT57cmVsZWFzZUNsYXNzSGFuZGxlKGluZm8uJCQpfSk7YXR0YWNoRmluYWxpemVyPWhhbmRsZT0+e3ZhciAkJD1oYW5kbGUuJCQ7dmFyIGhhc1NtYXJ0UHRyPSEhJCQuc21hcnRQdHI7aWYoaGFzU21hcnRQdHIpe3ZhciBpbmZvPXskJDokJH07ZmluYWxpemF0aW9uUmVnaXN0cnkucmVnaXN0ZXIoaGFuZGxlLGluZm8saGFuZGxlKX1yZXR1cm4gaGFuZGxlfTtkZXRhY2hGaW5hbGl6ZXI9aGFuZGxlPT5maW5hbGl6YXRpb25SZWdpc3RyeS51bnJlZ2lzdGVyKGhhbmRsZSk7cmV0dXJuIGF0dGFjaEZpbmFsaXplcihoYW5kbGUpfTt2YXIgaW5pdF9DbGFzc0hhbmRsZT0oKT0+e09iamVjdC5hc3NpZ24oQ2xhc3NIYW5kbGUucHJvdG90eXBlLHsiaXNBbGlhc09mIihvdGhlcil7aWYoISh0aGlzIGluc3RhbmNlb2YgQ2xhc3NIYW5kbGUpKXtyZXR1cm4gZmFsc2V9aWYoIShvdGhlciBpbnN0YW5jZW9mIENsYXNzSGFuZGxlKSl7cmV0dXJuIGZhbHNlfXZhciBsZWZ0Q2xhc3M9dGhpcy4kJC5wdHJUeXBlLnJlZ2lzdGVyZWRDbGFzczt2YXIgbGVmdD10aGlzLiQkLnB0cjtvdGhlci4kJD1vdGhlci4kJDt2YXIgcmlnaHRDbGFzcz1vdGhlci4kJC5wdHJUeXBlLnJlZ2lzdGVyZWRDbGFzczt2YXIgcmlnaHQ9b3RoZXIuJCQucHRyO3doaWxlKGxlZnRDbGFzcy5iYXNlQ2xhc3Mpe2xlZnQ9bGVmdENsYXNzLnVwY2FzdChsZWZ0KTtsZWZ0Q2xhc3M9bGVmdENsYXNzLmJhc2VDbGFzc313aGlsZShyaWdodENsYXNzLmJhc2VDbGFzcyl7cmlnaHQ9cmlnaHRDbGFzcy51cGNhc3QocmlnaHQpO3JpZ2h0Q2xhc3M9cmlnaHRDbGFzcy5iYXNlQ2xhc3N9cmV0dXJuIGxlZnRDbGFzcz09PXJpZ2h0Q2xhc3MmJmxlZnQ9PT1yaWdodH0sImNsb25lIigpe2lmKCF0aGlzLiQkLnB0cil7dGhyb3dJbnN0YW5jZUFscmVhZHlEZWxldGVkKHRoaXMpfWlmKHRoaXMuJCQucHJlc2VydmVQb2ludGVyT25EZWxldGUpe3RoaXMuJCQuY291bnQudmFsdWUrPTE7cmV0dXJuIHRoaXN9ZWxzZXt2YXIgY2xvbmU9YXR0YWNoRmluYWxpemVyKE9iamVjdC5jcmVhdGUoT2JqZWN0LmdldFByb3RvdHlwZU9mKHRoaXMpLHskJDp7dmFsdWU6c2hhbGxvd0NvcHlJbnRlcm5hbFBvaW50ZXIodGhpcy4kJCl9fSkpO2Nsb25lLiQkLmNvdW50LnZhbHVlKz0xO2Nsb25lLiQkLmRlbGV0ZVNjaGVkdWxlZD1mYWxzZTtyZXR1cm4gY2xvbmV9fSwiZGVsZXRlIigpe2lmKCF0aGlzLiQkLnB0cil7dGhyb3dJbnN0YW5jZUFscmVhZHlEZWxldGVkKHRoaXMpfWlmKHRoaXMuJCQuZGVsZXRlU2NoZWR1bGVkJiYhdGhpcy4kJC5wcmVzZXJ2ZVBvaW50ZXJPbkRlbGV0ZSl7dGhyb3dCaW5kaW5nRXJyb3IoIk9iamVjdCBhbHJlYWR5IHNjaGVkdWxlZCBmb3IgZGVsZXRpb24iKX1kZXRhY2hGaW5hbGl6ZXIodGhpcyk7cmVsZWFzZUNsYXNzSGFuZGxlKHRoaXMuJCQpO2lmKCF0aGlzLiQkLnByZXNlcnZlUG9pbnRlck9uRGVsZXRlKXt0aGlzLiQkLnNtYXJ0UHRyPXVuZGVmaW5lZDt0aGlzLiQkLnB0cj11bmRlZmluZWR9fSwiaXNEZWxldGVkIigpe3JldHVybiF0aGlzLiQkLnB0cn0sImRlbGV0ZUxhdGVyIigpe2lmKCF0aGlzLiQkLnB0cil7dGhyb3dJbnN0YW5jZUFscmVhZHlEZWxldGVkKHRoaXMpfWlmKHRoaXMuJCQuZGVsZXRlU2NoZWR1bGVkJiYhdGhpcy4kJC5wcmVzZXJ2ZVBvaW50ZXJPbkRlbGV0ZSl7dGhyb3dCaW5kaW5nRXJyb3IoIk9iamVjdCBhbHJlYWR5IHNjaGVkdWxlZCBmb3IgZGVsZXRpb24iKX1kZWxldGlvblF1ZXVlLnB1c2godGhpcyk7aWYoZGVsZXRpb25RdWV1ZS5sZW5ndGg9PT0xJiZkZWxheUZ1bmN0aW9uKXtkZWxheUZ1bmN0aW9uKGZsdXNoUGVuZGluZ0RlbGV0ZXMpfXRoaXMuJCQuZGVsZXRlU2NoZWR1bGVkPXRydWU7cmV0dXJuIHRoaXN9fSl9O2Z1bmN0aW9uIENsYXNzSGFuZGxlKCl7fXZhciBjcmVhdGVOYW1lZEZ1bmN0aW9uPShuYW1lLGJvZHkpPT5PYmplY3QuZGVmaW5lUHJvcGVydHkoYm9keSwibmFtZSIse3ZhbHVlOm5hbWV9KTt2YXIgZW5zdXJlT3ZlcmxvYWRUYWJsZT0ocHJvdG8sbWV0aG9kTmFtZSxodW1hbk5hbWUpPT57aWYodW5kZWZpbmVkPT09cHJvdG9bbWV0aG9kTmFtZV0ub3ZlcmxvYWRUYWJsZSl7dmFyIHByZXZGdW5jPXByb3RvW21ldGhvZE5hbWVdO3Byb3RvW21ldGhvZE5hbWVdPWZ1bmN0aW9uKCl7aWYoIXByb3RvW21ldGhvZE5hbWVdLm92ZXJsb2FkVGFibGUuaGFzT3duUHJvcGVydHkoYXJndW1lbnRzLmxlbmd0aCkpe3Rocm93QmluZGluZ0Vycm9yKGBGdW5jdGlvbiAnJHtodW1hbk5hbWV9JyBjYWxsZWQgd2l0aCBhbiBpbnZhbGlkIG51bWJlciBvZiBhcmd1bWVudHMgKCR7YXJndW1lbnRzLmxlbmd0aH0pIC0gZXhwZWN0cyBvbmUgb2YgKCR7cHJvdG9bbWV0aG9kTmFtZV0ub3ZlcmxvYWRUYWJsZX0pIWApfXJldHVybiBwcm90b1ttZXRob2ROYW1lXS5vdmVybG9hZFRhYmxlW2FyZ3VtZW50cy5sZW5ndGhdLmFwcGx5KHRoaXMsYXJndW1lbnRzKX07cHJvdG9bbWV0aG9kTmFtZV0ub3ZlcmxvYWRUYWJsZT1bXTtwcm90b1ttZXRob2ROYW1lXS5vdmVybG9hZFRhYmxlW3ByZXZGdW5jLmFyZ0NvdW50XT1wcmV2RnVuY319O3ZhciBleHBvc2VQdWJsaWNTeW1ib2w9KG5hbWUsdmFsdWUsbnVtQXJndW1lbnRzKT0+e2lmKE1vZHVsZS5oYXNPd25Qcm9wZXJ0eShuYW1lKSl7aWYodW5kZWZpbmVkPT09bnVtQXJndW1lbnRzfHx1bmRlZmluZWQhPT1Nb2R1bGVbbmFtZV0ub3ZlcmxvYWRUYWJsZSYmdW5kZWZpbmVkIT09TW9kdWxlW25hbWVdLm92ZXJsb2FkVGFibGVbbnVtQXJndW1lbnRzXSl7dGhyb3dCaW5kaW5nRXJyb3IoYENhbm5vdCByZWdpc3RlciBwdWJsaWMgbmFtZSAnJHtuYW1lfScgdHdpY2VgKX1lbnN1cmVPdmVybG9hZFRhYmxlKE1vZHVsZSxuYW1lLG5hbWUpO2lmKE1vZHVsZS5oYXNPd25Qcm9wZXJ0eShudW1Bcmd1bWVudHMpKXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IHJlZ2lzdGVyIG11bHRpcGxlIG92ZXJsb2FkcyBvZiBhIGZ1bmN0aW9uIHdpdGggdGhlIHNhbWUgbnVtYmVyIG9mIGFyZ3VtZW50cyAoJHtudW1Bcmd1bWVudHN9KSFgKX1Nb2R1bGVbbmFtZV0ub3ZlcmxvYWRUYWJsZVtudW1Bcmd1bWVudHNdPXZhbHVlfWVsc2V7TW9kdWxlW25hbWVdPXZhbHVlO2lmKHVuZGVmaW5lZCE9PW51bUFyZ3VtZW50cyl7TW9kdWxlW25hbWVdLm51bUFyZ3VtZW50cz1udW1Bcmd1bWVudHN9fX07dmFyIGNoYXJfMD00ODt2YXIgY2hhcl85PTU3O3ZhciBtYWtlTGVnYWxGdW5jdGlvbk5hbWU9bmFtZT0+e2lmKHVuZGVmaW5lZD09PW5hbWUpe3JldHVybiJfdW5rbm93biJ9bmFtZT1uYW1lLnJlcGxhY2UoL1teYS16QS1aMC05X10vZywiJCIpO3ZhciBmPW5hbWUuY2hhckNvZGVBdCgwKTtpZihmPj1jaGFyXzAmJmY8PWNoYXJfOSl7cmV0dXJuYF8ke25hbWV9YH1yZXR1cm4gbmFtZX07ZnVuY3Rpb24gUmVnaXN0ZXJlZENsYXNzKG5hbWUsY29uc3RydWN0b3IsaW5zdGFuY2VQcm90b3R5cGUscmF3RGVzdHJ1Y3RvcixiYXNlQ2xhc3MsZ2V0QWN0dWFsVHlwZSx1cGNhc3QsZG93bmNhc3Qpe3RoaXMubmFtZT1uYW1lO3RoaXMuY29uc3RydWN0b3I9Y29uc3RydWN0b3I7dGhpcy5pbnN0YW5jZVByb3RvdHlwZT1pbnN0YW5jZVByb3RvdHlwZTt0aGlzLnJhd0Rlc3RydWN0b3I9cmF3RGVzdHJ1Y3Rvcjt0aGlzLmJhc2VDbGFzcz1iYXNlQ2xhc3M7dGhpcy5nZXRBY3R1YWxUeXBlPWdldEFjdHVhbFR5cGU7dGhpcy51cGNhc3Q9dXBjYXN0O3RoaXMuZG93bmNhc3Q9ZG93bmNhc3Q7dGhpcy5wdXJlVmlydHVhbEZ1bmN0aW9ucz1bXX12YXIgdXBjYXN0UG9pbnRlcj0ocHRyLHB0ckNsYXNzLGRlc2lyZWRDbGFzcyk9Pnt3aGlsZShwdHJDbGFzcyE9PWRlc2lyZWRDbGFzcyl7aWYoIXB0ckNsYXNzLnVwY2FzdCl7dGhyb3dCaW5kaW5nRXJyb3IoYEV4cGVjdGVkIG51bGwgb3IgaW5zdGFuY2Ugb2YgJHtkZXNpcmVkQ2xhc3MubmFtZX0sIGdvdCBhbiBpbnN0YW5jZSBvZiAke3B0ckNsYXNzLm5hbWV9YCl9cHRyPXB0ckNsYXNzLnVwY2FzdChwdHIpO3B0ckNsYXNzPXB0ckNsYXNzLmJhc2VDbGFzc31yZXR1cm4gcHRyfTtmdW5jdGlvbiBjb25zdE5vU21hcnRQdHJSYXdQb2ludGVyVG9XaXJlVHlwZShkZXN0cnVjdG9ycyxoYW5kbGUpe2lmKGhhbmRsZT09PW51bGwpe2lmKHRoaXMuaXNSZWZlcmVuY2Upe3Rocm93QmluZGluZ0Vycm9yKGBudWxsIGlzIG5vdCBhIHZhbGlkICR7dGhpcy5uYW1lfWApfXJldHVybiAwfWlmKCFoYW5kbGUuJCQpe3Rocm93QmluZGluZ0Vycm9yKGBDYW5ub3QgcGFzcyAiJHtlbWJpbmRSZXByKGhhbmRsZSl9IiBhcyBhICR7dGhpcy5uYW1lfWApfWlmKCFoYW5kbGUuJCQucHRyKXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IHBhc3MgZGVsZXRlZCBvYmplY3QgYXMgYSBwb2ludGVyIG9mIHR5cGUgJHt0aGlzLm5hbWV9YCl9dmFyIGhhbmRsZUNsYXNzPWhhbmRsZS4kJC5wdHJUeXBlLnJlZ2lzdGVyZWRDbGFzczt2YXIgcHRyPXVwY2FzdFBvaW50ZXIoaGFuZGxlLiQkLnB0cixoYW5kbGVDbGFzcyx0aGlzLnJlZ2lzdGVyZWRDbGFzcyk7cmV0dXJuIHB0cn1mdW5jdGlvbiBnZW5lcmljUG9pbnRlclRvV2lyZVR5cGUoZGVzdHJ1Y3RvcnMsaGFuZGxlKXt2YXIgcHRyO2lmKGhhbmRsZT09PW51bGwpe2lmKHRoaXMuaXNSZWZlcmVuY2Upe3Rocm93QmluZGluZ0Vycm9yKGBudWxsIGlzIG5vdCBhIHZhbGlkICR7dGhpcy5uYW1lfWApfWlmKHRoaXMuaXNTbWFydFBvaW50ZXIpe3B0cj10aGlzLnJhd0NvbnN0cnVjdG9yKCk7aWYoZGVzdHJ1Y3RvcnMhPT1udWxsKXtkZXN0cnVjdG9ycy5wdXNoKHRoaXMucmF3RGVzdHJ1Y3RvcixwdHIpfXJldHVybiBwdHJ9ZWxzZXtyZXR1cm4gMH19aWYoIWhhbmRsZS4kJCl7dGhyb3dCaW5kaW5nRXJyb3IoYENhbm5vdCBwYXNzICIke2VtYmluZFJlcHIoaGFuZGxlKX0iIGFzIGEgJHt0aGlzLm5hbWV9YCl9aWYoIWhhbmRsZS4kJC5wdHIpe3Rocm93QmluZGluZ0Vycm9yKGBDYW5ub3QgcGFzcyBkZWxldGVkIG9iamVjdCBhcyBhIHBvaW50ZXIgb2YgdHlwZSAke3RoaXMubmFtZX1gKX1pZighdGhpcy5pc0NvbnN0JiZoYW5kbGUuJCQucHRyVHlwZS5pc0NvbnN0KXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IGNvbnZlcnQgYXJndW1lbnQgb2YgdHlwZSAke2hhbmRsZS4kJC5zbWFydFB0clR5cGU/aGFuZGxlLiQkLnNtYXJ0UHRyVHlwZS5uYW1lOmhhbmRsZS4kJC5wdHJUeXBlLm5hbWV9IHRvIHBhcmFtZXRlciB0eXBlICR7dGhpcy5uYW1lfWApfXZhciBoYW5kbGVDbGFzcz1oYW5kbGUuJCQucHRyVHlwZS5yZWdpc3RlcmVkQ2xhc3M7cHRyPXVwY2FzdFBvaW50ZXIoaGFuZGxlLiQkLnB0cixoYW5kbGVDbGFzcyx0aGlzLnJlZ2lzdGVyZWRDbGFzcyk7aWYodGhpcy5pc1NtYXJ0UG9pbnRlcil7aWYodW5kZWZpbmVkPT09aGFuZGxlLiQkLnNtYXJ0UHRyKXt0aHJvd0JpbmRpbmdFcnJvcigiUGFzc2luZyByYXcgcG9pbnRlciB0byBzbWFydCBwb2ludGVyIGlzIGlsbGVnYWwiKX1zd2l0Y2godGhpcy5zaGFyaW5nUG9saWN5KXtjYXNlIDA6aWYoaGFuZGxlLiQkLnNtYXJ0UHRyVHlwZT09PXRoaXMpe3B0cj1oYW5kbGUuJCQuc21hcnRQdHJ9ZWxzZXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IGNvbnZlcnQgYXJndW1lbnQgb2YgdHlwZSAke2hhbmRsZS4kJC5zbWFydFB0clR5cGU/aGFuZGxlLiQkLnNtYXJ0UHRyVHlwZS5uYW1lOmhhbmRsZS4kJC5wdHJUeXBlLm5hbWV9IHRvIHBhcmFtZXRlciB0eXBlICR7dGhpcy5uYW1lfWApfWJyZWFrO2Nhc2UgMTpwdHI9aGFuZGxlLiQkLnNtYXJ0UHRyO2JyZWFrO2Nhc2UgMjppZihoYW5kbGUuJCQuc21hcnRQdHJUeXBlPT09dGhpcyl7cHRyPWhhbmRsZS4kJC5zbWFydFB0cn1lbHNle3ZhciBjbG9uZWRIYW5kbGU9aGFuZGxlWyJjbG9uZSJdKCk7cHRyPXRoaXMucmF3U2hhcmUocHRyLEVtdmFsLnRvSGFuZGxlKCgpPT5jbG9uZWRIYW5kbGVbImRlbGV0ZSJdKCkpKTtpZihkZXN0cnVjdG9ycyE9PW51bGwpe2Rlc3RydWN0b3JzLnB1c2godGhpcy5yYXdEZXN0cnVjdG9yLHB0cil9fWJyZWFrO2RlZmF1bHQ6dGhyb3dCaW5kaW5nRXJyb3IoIlVuc3VwcG9ydGluZyBzaGFyaW5nIHBvbGljeSIpfX1yZXR1cm4gcHRyfWZ1bmN0aW9uIG5vbkNvbnN0Tm9TbWFydFB0clJhd1BvaW50ZXJUb1dpcmVUeXBlKGRlc3RydWN0b3JzLGhhbmRsZSl7aWYoaGFuZGxlPT09bnVsbCl7aWYodGhpcy5pc1JlZmVyZW5jZSl7dGhyb3dCaW5kaW5nRXJyb3IoYG51bGwgaXMgbm90IGEgdmFsaWQgJHt0aGlzLm5hbWV9YCl9cmV0dXJuIDB9aWYoIWhhbmRsZS4kJCl7dGhyb3dCaW5kaW5nRXJyb3IoYENhbm5vdCBwYXNzICIke2VtYmluZFJlcHIoaGFuZGxlKX0iIGFzIGEgJHt0aGlzLm5hbWV9YCl9aWYoIWhhbmRsZS4kJC5wdHIpe3Rocm93QmluZGluZ0Vycm9yKGBDYW5ub3QgcGFzcyBkZWxldGVkIG9iamVjdCBhcyBhIHBvaW50ZXIgb2YgdHlwZSAke3RoaXMubmFtZX1gKX1pZihoYW5kbGUuJCQucHRyVHlwZS5pc0NvbnN0KXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IGNvbnZlcnQgYXJndW1lbnQgb2YgdHlwZSAke2hhbmRsZS4kJC5wdHJUeXBlLm5hbWV9IHRvIHBhcmFtZXRlciB0eXBlICR7dGhpcy5uYW1lfWApfXZhciBoYW5kbGVDbGFzcz1oYW5kbGUuJCQucHRyVHlwZS5yZWdpc3RlcmVkQ2xhc3M7dmFyIHB0cj11cGNhc3RQb2ludGVyKGhhbmRsZS4kJC5wdHIsaGFuZGxlQ2xhc3MsdGhpcy5yZWdpc3RlcmVkQ2xhc3MpO3JldHVybiBwdHJ9ZnVuY3Rpb24gcmVhZFBvaW50ZXIocG9pbnRlcil7cmV0dXJuIHRoaXNbImZyb21XaXJlVHlwZSJdKEhFQVBVMzJbcG9pbnRlcj4+Ml0pfXZhciBpbml0X1JlZ2lzdGVyZWRQb2ludGVyPSgpPT57T2JqZWN0LmFzc2lnbihSZWdpc3RlcmVkUG9pbnRlci5wcm90b3R5cGUse2dldFBvaW50ZWUocHRyKXtpZih0aGlzLnJhd0dldFBvaW50ZWUpe3B0cj10aGlzLnJhd0dldFBvaW50ZWUocHRyKX1yZXR1cm4gcHRyfSxkZXN0cnVjdG9yKHB0cil7aWYodGhpcy5yYXdEZXN0cnVjdG9yKXt0aGlzLnJhd0Rlc3RydWN0b3IocHRyKX19LCJhcmdQYWNrQWR2YW5jZSI6R2VuZXJpY1dpcmVUeXBlU2l6ZSwicmVhZFZhbHVlRnJvbVBvaW50ZXIiOnJlYWRQb2ludGVyLCJkZWxldGVPYmplY3QiKGhhbmRsZSl7aWYoaGFuZGxlIT09bnVsbCl7aGFuZGxlWyJkZWxldGUiXSgpfX0sImZyb21XaXJlVHlwZSI6UmVnaXN0ZXJlZFBvaW50ZXJfZnJvbVdpcmVUeXBlfSl9O2Z1bmN0aW9uIFJlZ2lzdGVyZWRQb2ludGVyKG5hbWUscmVnaXN0ZXJlZENsYXNzLGlzUmVmZXJlbmNlLGlzQ29uc3QsaXNTbWFydFBvaW50ZXIscG9pbnRlZVR5cGUsc2hhcmluZ1BvbGljeSxyYXdHZXRQb2ludGVlLHJhd0NvbnN0cnVjdG9yLHJhd1NoYXJlLHJhd0Rlc3RydWN0b3Ipe3RoaXMubmFtZT1uYW1lO3RoaXMucmVnaXN0ZXJlZENsYXNzPXJlZ2lzdGVyZWRDbGFzczt0aGlzLmlzUmVmZXJlbmNlPWlzUmVmZXJlbmNlO3RoaXMuaXNDb25zdD1pc0NvbnN0O3RoaXMuaXNTbWFydFBvaW50ZXI9aXNTbWFydFBvaW50ZXI7dGhpcy5wb2ludGVlVHlwZT1wb2ludGVlVHlwZTt0aGlzLnNoYXJpbmdQb2xpY3k9c2hhcmluZ1BvbGljeTt0aGlzLnJhd0dldFBvaW50ZWU9cmF3R2V0UG9pbnRlZTt0aGlzLnJhd0NvbnN0cnVjdG9yPXJhd0NvbnN0cnVjdG9yO3RoaXMucmF3U2hhcmU9cmF3U2hhcmU7dGhpcy5yYXdEZXN0cnVjdG9yPXJhd0Rlc3RydWN0b3I7aWYoIWlzU21hcnRQb2ludGVyJiZyZWdpc3RlcmVkQ2xhc3MuYmFzZUNsYXNzPT09dW5kZWZpbmVkKXtpZihpc0NvbnN0KXt0aGlzWyJ0b1dpcmVUeXBlIl09Y29uc3ROb1NtYXJ0UHRyUmF3UG9pbnRlclRvV2lyZVR5cGU7dGhpcy5kZXN0cnVjdG9yRnVuY3Rpb249bnVsbH1lbHNle3RoaXNbInRvV2lyZVR5cGUiXT1ub25Db25zdE5vU21hcnRQdHJSYXdQb2ludGVyVG9XaXJlVHlwZTt0aGlzLmRlc3RydWN0b3JGdW5jdGlvbj1udWxsfX1lbHNle3RoaXNbInRvV2lyZVR5cGUiXT1nZW5lcmljUG9pbnRlclRvV2lyZVR5cGV9fXZhciByZXBsYWNlUHVibGljU3ltYm9sPShuYW1lLHZhbHVlLG51bUFyZ3VtZW50cyk9PntpZighTW9kdWxlLmhhc093blByb3BlcnR5KG5hbWUpKXt0aHJvd0ludGVybmFsRXJyb3IoIlJlcGxhY2luZyBub25leGlzdGFudCBwdWJsaWMgc3ltYm9sIil9aWYodW5kZWZpbmVkIT09TW9kdWxlW25hbWVdLm92ZXJsb2FkVGFibGUmJnVuZGVmaW5lZCE9PW51bUFyZ3VtZW50cyl7TW9kdWxlW25hbWVdLm92ZXJsb2FkVGFibGVbbnVtQXJndW1lbnRzXT12YWx1ZX1lbHNle01vZHVsZVtuYW1lXT12YWx1ZTtNb2R1bGVbbmFtZV0uYXJnQ291bnQ9bnVtQXJndW1lbnRzfX07dmFyIGR5bkNhbGxMZWdhY3k9KHNpZyxwdHIsYXJncyk9Pnt2YXIgZj1Nb2R1bGVbImR5bkNhbGxfIitzaWddO3JldHVybiBhcmdzJiZhcmdzLmxlbmd0aD9mLmFwcGx5KG51bGwsW3B0cl0uY29uY2F0KGFyZ3MpKTpmLmNhbGwobnVsbCxwdHIpfTt2YXIgd2FzbVRhYmxlTWlycm9yPVtdO3ZhciB3YXNtVGFibGU7dmFyIGdldFdhc21UYWJsZUVudHJ5PWZ1bmNQdHI9Pnt2YXIgZnVuYz13YXNtVGFibGVNaXJyb3JbZnVuY1B0cl07aWYoIWZ1bmMpe2lmKGZ1bmNQdHI+PXdhc21UYWJsZU1pcnJvci5sZW5ndGgpd2FzbVRhYmxlTWlycm9yLmxlbmd0aD1mdW5jUHRyKzE7d2FzbVRhYmxlTWlycm9yW2Z1bmNQdHJdPWZ1bmM9d2FzbVRhYmxlLmdldChmdW5jUHRyKX1yZXR1cm4gZnVuY307dmFyIGR5bkNhbGw9KHNpZyxwdHIsYXJncyk9PntpZihzaWcuaW5jbHVkZXMoImoiKSl7cmV0dXJuIGR5bkNhbGxMZWdhY3koc2lnLHB0cixhcmdzKX12YXIgcnRuPWdldFdhc21UYWJsZUVudHJ5KHB0cikuYXBwbHkobnVsbCxhcmdzKTtyZXR1cm4gcnRufTt2YXIgZ2V0RHluQ2FsbGVyPShzaWcscHRyKT0+e3ZhciBhcmdDYWNoZT1bXTtyZXR1cm4gZnVuY3Rpb24oKXthcmdDYWNoZS5sZW5ndGg9MDtPYmplY3QuYXNzaWduKGFyZ0NhY2hlLGFyZ3VtZW50cyk7cmV0dXJuIGR5bkNhbGwoc2lnLHB0cixhcmdDYWNoZSl9fTt2YXIgZW1iaW5kX19yZXF1aXJlRnVuY3Rpb249KHNpZ25hdHVyZSxyYXdGdW5jdGlvbik9PntzaWduYXR1cmU9cmVhZExhdGluMVN0cmluZyhzaWduYXR1cmUpO2Z1bmN0aW9uIG1ha2VEeW5DYWxsZXIoKXtpZihzaWduYXR1cmUuaW5jbHVkZXMoImoiKSl7cmV0dXJuIGdldER5bkNhbGxlcihzaWduYXR1cmUscmF3RnVuY3Rpb24pfXJldHVybiBnZXRXYXNtVGFibGVFbnRyeShyYXdGdW5jdGlvbil9dmFyIGZwPW1ha2VEeW5DYWxsZXIoKTtpZih0eXBlb2YgZnAhPSJmdW5jdGlvbiIpe3Rocm93QmluZGluZ0Vycm9yKGB1bmtub3duIGZ1bmN0aW9uIHBvaW50ZXIgd2l0aCBzaWduYXR1cmUgJHtzaWduYXR1cmV9OiAke3Jhd0Z1bmN0aW9ufWApfXJldHVybiBmcH07dmFyIGV4dGVuZEVycm9yPShiYXNlRXJyb3JUeXBlLGVycm9yTmFtZSk9Pnt2YXIgZXJyb3JDbGFzcz1jcmVhdGVOYW1lZEZ1bmN0aW9uKGVycm9yTmFtZSxmdW5jdGlvbihtZXNzYWdlKXt0aGlzLm5hbWU9ZXJyb3JOYW1lO3RoaXMubWVzc2FnZT1tZXNzYWdlO3ZhciBzdGFjaz1uZXcgRXJyb3IobWVzc2FnZSkuc3RhY2s7aWYoc3RhY2shPT11bmRlZmluZWQpe3RoaXMuc3RhY2s9dGhpcy50b1N0cmluZygpKyJcbiIrc3RhY2sucmVwbGFjZSgvXkVycm9yKDpbXlxuXSopP1xuLywiIil9fSk7ZXJyb3JDbGFzcy5wcm90b3R5cGU9T2JqZWN0LmNyZWF0ZShiYXNlRXJyb3JUeXBlLnByb3RvdHlwZSk7ZXJyb3JDbGFzcy5wcm90b3R5cGUuY29uc3RydWN0b3I9ZXJyb3JDbGFzcztlcnJvckNsYXNzLnByb3RvdHlwZS50b1N0cmluZz1mdW5jdGlvbigpe2lmKHRoaXMubWVzc2FnZT09PXVuZGVmaW5lZCl7cmV0dXJuIHRoaXMubmFtZX1lbHNle3JldHVybmAke3RoaXMubmFtZX06ICR7dGhpcy5tZXNzYWdlfWB9fTtyZXR1cm4gZXJyb3JDbGFzc307dmFyIFVuYm91bmRUeXBlRXJyb3I7dmFyIGdldFR5cGVOYW1lPXR5cGU9Pnt2YXIgcHRyPV9fX2dldFR5cGVOYW1lKHR5cGUpO3ZhciBydj1yZWFkTGF0aW4xU3RyaW5nKHB0cik7X2ZyZWUocHRyKTtyZXR1cm4gcnZ9O3ZhciB0aHJvd1VuYm91bmRUeXBlRXJyb3I9KG1lc3NhZ2UsdHlwZXMpPT57dmFyIHVuYm91bmRUeXBlcz1bXTt2YXIgc2Vlbj17fTtmdW5jdGlvbiB2aXNpdCh0eXBlKXtpZihzZWVuW3R5cGVdKXtyZXR1cm59aWYocmVnaXN0ZXJlZFR5cGVzW3R5cGVdKXtyZXR1cm59aWYodHlwZURlcGVuZGVuY2llc1t0eXBlXSl7dHlwZURlcGVuZGVuY2llc1t0eXBlXS5mb3JFYWNoKHZpc2l0KTtyZXR1cm59dW5ib3VuZFR5cGVzLnB1c2godHlwZSk7c2Vlblt0eXBlXT10cnVlfXR5cGVzLmZvckVhY2godmlzaXQpO3Rocm93IG5ldyBVbmJvdW5kVHlwZUVycm9yKGAke21lc3NhZ2V9OiBgK3VuYm91bmRUeXBlcy5tYXAoZ2V0VHlwZU5hbWUpLmpvaW4oWyIsICJdKSl9O3ZhciBfX2VtYmluZF9yZWdpc3Rlcl9jbGFzcz0ocmF3VHlwZSxyYXdQb2ludGVyVHlwZSxyYXdDb25zdFBvaW50ZXJUeXBlLGJhc2VDbGFzc1Jhd1R5cGUsZ2V0QWN0dWFsVHlwZVNpZ25hdHVyZSxnZXRBY3R1YWxUeXBlLHVwY2FzdFNpZ25hdHVyZSx1cGNhc3QsZG93bmNhc3RTaWduYXR1cmUsZG93bmNhc3QsbmFtZSxkZXN0cnVjdG9yU2lnbmF0dXJlLHJhd0Rlc3RydWN0b3IpPT57bmFtZT1yZWFkTGF0aW4xU3RyaW5nKG5hbWUpO2dldEFjdHVhbFR5cGU9ZW1iaW5kX19yZXF1aXJlRnVuY3Rpb24oZ2V0QWN0dWFsVHlwZVNpZ25hdHVyZSxnZXRBY3R1YWxUeXBlKTtpZih1cGNhc3Qpe3VwY2FzdD1lbWJpbmRfX3JlcXVpcmVGdW5jdGlvbih1cGNhc3RTaWduYXR1cmUsdXBjYXN0KX1pZihkb3duY2FzdCl7ZG93bmNhc3Q9ZW1iaW5kX19yZXF1aXJlRnVuY3Rpb24oZG93bmNhc3RTaWduYXR1cmUsZG93bmNhc3QpfXJhd0Rlc3RydWN0b3I9ZW1iaW5kX19yZXF1aXJlRnVuY3Rpb24oZGVzdHJ1Y3RvclNpZ25hdHVyZSxyYXdEZXN0cnVjdG9yKTt2YXIgbGVnYWxGdW5jdGlvbk5hbWU9bWFrZUxlZ2FsRnVuY3Rpb25OYW1lKG5hbWUpO2V4cG9zZVB1YmxpY1N5bWJvbChsZWdhbEZ1bmN0aW9uTmFtZSxmdW5jdGlvbigpe3Rocm93VW5ib3VuZFR5cGVFcnJvcihgQ2Fubm90IGNvbnN0cnVjdCAke25hbWV9IGR1ZSB0byB1bmJvdW5kIHR5cGVzYCxbYmFzZUNsYXNzUmF3VHlwZV0pfSk7d2hlbkRlcGVuZGVudFR5cGVzQXJlUmVzb2x2ZWQoW3Jhd1R5cGUscmF3UG9pbnRlclR5cGUscmF3Q29uc3RQb2ludGVyVHlwZV0sYmFzZUNsYXNzUmF3VHlwZT9bYmFzZUNsYXNzUmF3VHlwZV06W10sZnVuY3Rpb24oYmFzZSl7YmFzZT1iYXNlWzBdO3ZhciBiYXNlQ2xhc3M7dmFyIGJhc2VQcm90b3R5cGU7aWYoYmFzZUNsYXNzUmF3VHlwZSl7YmFzZUNsYXNzPWJhc2UucmVnaXN0ZXJlZENsYXNzO2Jhc2VQcm90b3R5cGU9YmFzZUNsYXNzLmluc3RhbmNlUHJvdG90eXBlfWVsc2V7YmFzZVByb3RvdHlwZT1DbGFzc0hhbmRsZS5wcm90b3R5cGV9dmFyIGNvbnN0cnVjdG9yPWNyZWF0ZU5hbWVkRnVuY3Rpb24obmFtZSxmdW5jdGlvbigpe2lmKE9iamVjdC5nZXRQcm90b3R5cGVPZih0aGlzKSE9PWluc3RhbmNlUHJvdG90eXBlKXt0aHJvdyBuZXcgQmluZGluZ0Vycm9yKCJVc2UgJ25ldycgdG8gY29uc3RydWN0ICIrbmFtZSl9aWYodW5kZWZpbmVkPT09cmVnaXN0ZXJlZENsYXNzLmNvbnN0cnVjdG9yX2JvZHkpe3Rocm93IG5ldyBCaW5kaW5nRXJyb3IobmFtZSsiIGhhcyBubyBhY2Nlc3NpYmxlIGNvbnN0cnVjdG9yIil9dmFyIGJvZHk9cmVnaXN0ZXJlZENsYXNzLmNvbnN0cnVjdG9yX2JvZHlbYXJndW1lbnRzLmxlbmd0aF07aWYodW5kZWZpbmVkPT09Ym9keSl7dGhyb3cgbmV3IEJpbmRpbmdFcnJvcihgVHJpZWQgdG8gaW52b2tlIGN0b3Igb2YgJHtuYW1lfSB3aXRoIGludmFsaWQgbnVtYmVyIG9mIHBhcmFtZXRlcnMgKCR7YXJndW1lbnRzLmxlbmd0aH0pIC0gZXhwZWN0ZWQgKCR7T2JqZWN0LmtleXMocmVnaXN0ZXJlZENsYXNzLmNvbnN0cnVjdG9yX2JvZHkpLnRvU3RyaW5nKCl9KSBwYXJhbWV0ZXJzIGluc3RlYWQhYCl9cmV0dXJuIGJvZHkuYXBwbHkodGhpcyxhcmd1bWVudHMpfSk7dmFyIGluc3RhbmNlUHJvdG90eXBlPU9iamVjdC5jcmVhdGUoYmFzZVByb3RvdHlwZSx7Y29uc3RydWN0b3I6e3ZhbHVlOmNvbnN0cnVjdG9yfX0pO2NvbnN0cnVjdG9yLnByb3RvdHlwZT1pbnN0YW5jZVByb3RvdHlwZTt2YXIgcmVnaXN0ZXJlZENsYXNzPW5ldyBSZWdpc3RlcmVkQ2xhc3MobmFtZSxjb25zdHJ1Y3RvcixpbnN0YW5jZVByb3RvdHlwZSxyYXdEZXN0cnVjdG9yLGJhc2VDbGFzcyxnZXRBY3R1YWxUeXBlLHVwY2FzdCxkb3duY2FzdCk7aWYocmVnaXN0ZXJlZENsYXNzLmJhc2VDbGFzcyl7aWYocmVnaXN0ZXJlZENsYXNzLmJhc2VDbGFzcy5fX2Rlcml2ZWRDbGFzc2VzPT09dW5kZWZpbmVkKXtyZWdpc3RlcmVkQ2xhc3MuYmFzZUNsYXNzLl9fZGVyaXZlZENsYXNzZXM9W119cmVnaXN0ZXJlZENsYXNzLmJhc2VDbGFzcy5fX2Rlcml2ZWRDbGFzc2VzLnB1c2gocmVnaXN0ZXJlZENsYXNzKX12YXIgcmVmZXJlbmNlQ29udmVydGVyPW5ldyBSZWdpc3RlcmVkUG9pbnRlcihuYW1lLHJlZ2lzdGVyZWRDbGFzcyx0cnVlLGZhbHNlLGZhbHNlKTt2YXIgcG9pbnRlckNvbnZlcnRlcj1uZXcgUmVnaXN0ZXJlZFBvaW50ZXIobmFtZSsiKiIscmVnaXN0ZXJlZENsYXNzLGZhbHNlLGZhbHNlLGZhbHNlKTt2YXIgY29uc3RQb2ludGVyQ29udmVydGVyPW5ldyBSZWdpc3RlcmVkUG9pbnRlcihuYW1lKyIgY29uc3QqIixyZWdpc3RlcmVkQ2xhc3MsZmFsc2UsdHJ1ZSxmYWxzZSk7cmVnaXN0ZXJlZFBvaW50ZXJzW3Jhd1R5cGVdPXtwb2ludGVyVHlwZTpwb2ludGVyQ29udmVydGVyLGNvbnN0UG9pbnRlclR5cGU6Y29uc3RQb2ludGVyQ29udmVydGVyfTtyZXBsYWNlUHVibGljU3ltYm9sKGxlZ2FsRnVuY3Rpb25OYW1lLGNvbnN0cnVjdG9yKTtyZXR1cm5bcmVmZXJlbmNlQ29udmVydGVyLHBvaW50ZXJDb252ZXJ0ZXIsY29uc3RQb2ludGVyQ29udmVydGVyXX0pfTt2YXIgaGVhcDMyVmVjdG9yVG9BcnJheT0oY291bnQsZmlyc3RFbGVtZW50KT0+e3ZhciBhcnJheT1bXTtmb3IodmFyIGk9MDtpPGNvdW50O2krKyl7YXJyYXkucHVzaChIRUFQVTMyW2ZpcnN0RWxlbWVudCtpKjQ+PjJdKX1yZXR1cm4gYXJyYXl9O3ZhciBydW5EZXN0cnVjdG9ycz1kZXN0cnVjdG9ycz0+e3doaWxlKGRlc3RydWN0b3JzLmxlbmd0aCl7dmFyIHB0cj1kZXN0cnVjdG9ycy5wb3AoKTt2YXIgZGVsPWRlc3RydWN0b3JzLnBvcCgpO2RlbChwdHIpfX07ZnVuY3Rpb24gbmV3RnVuYyhjb25zdHJ1Y3Rvcixhcmd1bWVudExpc3Qpe2lmKCEoY29uc3RydWN0b3IgaW5zdGFuY2VvZiBGdW5jdGlvbikpe3Rocm93IG5ldyBUeXBlRXJyb3IoYG5ld18gY2FsbGVkIHdpdGggY29uc3RydWN0b3IgdHlwZSAke3R5cGVvZiBjb25zdHJ1Y3Rvcn0gd2hpY2ggaXMgbm90IGEgZnVuY3Rpb25gKX12YXIgZHVtbXk9Y3JlYXRlTmFtZWRGdW5jdGlvbihjb25zdHJ1Y3Rvci5uYW1lfHwidW5rbm93bkZ1bmN0aW9uTmFtZSIsZnVuY3Rpb24oKXt9KTtkdW1teS5wcm90b3R5cGU9Y29uc3RydWN0b3IucHJvdG90eXBlO3ZhciBvYmo9bmV3IGR1bW15O3ZhciByPWNvbnN0cnVjdG9yLmFwcGx5KG9iaixhcmd1bWVudExpc3QpO3JldHVybiByIGluc3RhbmNlb2YgT2JqZWN0P3I6b2JqfWZ1bmN0aW9uIGNyYWZ0SW52b2tlckZ1bmN0aW9uKGh1bWFuTmFtZSxhcmdUeXBlcyxjbGFzc1R5cGUsY3BwSW52b2tlckZ1bmMsY3BwVGFyZ2V0RnVuYyxpc0FzeW5jKXt2YXIgYXJnQ291bnQ9YXJnVHlwZXMubGVuZ3RoO2lmKGFyZ0NvdW50PDIpe3Rocm93QmluZGluZ0Vycm9yKCJhcmdUeXBlcyBhcnJheSBzaXplIG1pc21hdGNoISBNdXN0IGF0IGxlYXN0IGdldCByZXR1cm4gdmFsdWUgYW5kICd0aGlzJyB0eXBlcyEiKX12YXIgaXNDbGFzc01ldGhvZEZ1bmM9YXJnVHlwZXNbMV0hPT1udWxsJiZjbGFzc1R5cGUhPT1udWxsO3ZhciBuZWVkc0Rlc3RydWN0b3JTdGFjaz1mYWxzZTtmb3IodmFyIGk9MTtpPGFyZ1R5cGVzLmxlbmd0aDsrK2kpe2lmKGFyZ1R5cGVzW2ldIT09bnVsbCYmYXJnVHlwZXNbaV0uZGVzdHJ1Y3RvckZ1bmN0aW9uPT09dW5kZWZpbmVkKXtuZWVkc0Rlc3RydWN0b3JTdGFjaz10cnVlO2JyZWFrfX12YXIgcmV0dXJucz1hcmdUeXBlc1swXS5uYW1lIT09InZvaWQiO3ZhciBhcmdzTGlzdD0iIjt2YXIgYXJnc0xpc3RXaXJlZD0iIjtmb3IodmFyIGk9MDtpPGFyZ0NvdW50LTI7KytpKXthcmdzTGlzdCs9KGkhPT0wPyIsICI6IiIpKyJhcmciK2k7YXJnc0xpc3RXaXJlZCs9KGkhPT0wPyIsICI6IiIpKyJhcmciK2krIldpcmVkIn12YXIgaW52b2tlckZuQm9keT1gXG4gICAgICAgIHJldHVybiBmdW5jdGlvbiAoJHthcmdzTGlzdH0pIHtcbiAgICAgICAgaWYgKGFyZ3VtZW50cy5sZW5ndGggIT09ICR7YXJnQ291bnQtMn0pIHtcbiAgICAgICAgICB0aHJvd0JpbmRpbmdFcnJvcignZnVuY3Rpb24gJHtodW1hbk5hbWV9IGNhbGxlZCB3aXRoICcgKyBhcmd1bWVudHMubGVuZ3RoICsgJyBhcmd1bWVudHMsIGV4cGVjdGVkICR7YXJnQ291bnQtMn0nKTtcbiAgICAgICAgfWA7aWYobmVlZHNEZXN0cnVjdG9yU3RhY2spe2ludm9rZXJGbkJvZHkrPSJ2YXIgZGVzdHJ1Y3RvcnMgPSBbXTtcbiJ9dmFyIGR0b3JTdGFjaz1uZWVkc0Rlc3RydWN0b3JTdGFjaz8iZGVzdHJ1Y3RvcnMiOiJudWxsIjt2YXIgYXJnczE9WyJ0aHJvd0JpbmRpbmdFcnJvciIsImludm9rZXIiLCJmbiIsInJ1bkRlc3RydWN0b3JzIiwicmV0VHlwZSIsImNsYXNzUGFyYW0iXTt2YXIgYXJnczI9W3Rocm93QmluZGluZ0Vycm9yLGNwcEludm9rZXJGdW5jLGNwcFRhcmdldEZ1bmMscnVuRGVzdHJ1Y3RvcnMsYXJnVHlwZXNbMF0sYXJnVHlwZXNbMV1dO2lmKGlzQ2xhc3NNZXRob2RGdW5jKXtpbnZva2VyRm5Cb2R5Kz0idmFyIHRoaXNXaXJlZCA9IGNsYXNzUGFyYW0udG9XaXJlVHlwZSgiK2R0b3JTdGFjaysiLCB0aGlzKTtcbiJ9Zm9yKHZhciBpPTA7aTxhcmdDb3VudC0yOysraSl7aW52b2tlckZuQm9keSs9InZhciBhcmciK2krIldpcmVkID0gYXJnVHlwZSIraSsiLnRvV2lyZVR5cGUoIitkdG9yU3RhY2srIiwgYXJnIitpKyIpOyAvLyAiK2FyZ1R5cGVzW2krMl0ubmFtZSsiXG4iO2FyZ3MxLnB1c2goImFyZ1R5cGUiK2kpO2FyZ3MyLnB1c2goYXJnVHlwZXNbaSsyXSl9aWYoaXNDbGFzc01ldGhvZEZ1bmMpe2FyZ3NMaXN0V2lyZWQ9InRoaXNXaXJlZCIrKGFyZ3NMaXN0V2lyZWQubGVuZ3RoPjA/IiwgIjoiIikrYXJnc0xpc3RXaXJlZH1pbnZva2VyRm5Cb2R5Kz0ocmV0dXJuc3x8aXNBc3luYz8idmFyIHJ2ID0gIjoiIikrImludm9rZXIoZm4iKyhhcmdzTGlzdFdpcmVkLmxlbmd0aD4wPyIsICI6IiIpK2FyZ3NMaXN0V2lyZWQrIik7XG4iO2lmKG5lZWRzRGVzdHJ1Y3RvclN0YWNrKXtpbnZva2VyRm5Cb2R5Kz0icnVuRGVzdHJ1Y3RvcnMoZGVzdHJ1Y3RvcnMpO1xuIn1lbHNle2Zvcih2YXIgaT1pc0NsYXNzTWV0aG9kRnVuYz8xOjI7aTxhcmdUeXBlcy5sZW5ndGg7KytpKXt2YXIgcGFyYW1OYW1lPWk9PT0xPyJ0aGlzV2lyZWQiOiJhcmciKyhpLTIpKyJXaXJlZCI7aWYoYXJnVHlwZXNbaV0uZGVzdHJ1Y3RvckZ1bmN0aW9uIT09bnVsbCl7aW52b2tlckZuQm9keSs9cGFyYW1OYW1lKyJfZHRvcigiK3BhcmFtTmFtZSsiKTsgLy8gIithcmdUeXBlc1tpXS5uYW1lKyJcbiI7YXJnczEucHVzaChwYXJhbU5hbWUrIl9kdG9yIik7YXJnczIucHVzaChhcmdUeXBlc1tpXS5kZXN0cnVjdG9yRnVuY3Rpb24pfX19aWYocmV0dXJucyl7aW52b2tlckZuQm9keSs9InZhciByZXQgPSByZXRUeXBlLmZyb21XaXJlVHlwZShydik7XG4iKyJyZXR1cm4gcmV0O1xuIn1lbHNle31pbnZva2VyRm5Cb2R5Kz0ifVxuIjthcmdzMS5wdXNoKGludm9rZXJGbkJvZHkpO3ZhciBpbnZva2VyRm49bmV3RnVuYyhGdW5jdGlvbixhcmdzMSkuYXBwbHkobnVsbCxhcmdzMik7cmV0dXJuIGNyZWF0ZU5hbWVkRnVuY3Rpb24oaHVtYW5OYW1lLGludm9rZXJGbil9dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX2NsYXNzX2NvbnN0cnVjdG9yPShyYXdDbGFzc1R5cGUsYXJnQ291bnQscmF3QXJnVHlwZXNBZGRyLGludm9rZXJTaWduYXR1cmUsaW52b2tlcixyYXdDb25zdHJ1Y3Rvcik9Pnt2YXIgcmF3QXJnVHlwZXM9aGVhcDMyVmVjdG9yVG9BcnJheShhcmdDb3VudCxyYXdBcmdUeXBlc0FkZHIpO2ludm9rZXI9ZW1iaW5kX19yZXF1aXJlRnVuY3Rpb24oaW52b2tlclNpZ25hdHVyZSxpbnZva2VyKTt3aGVuRGVwZW5kZW50VHlwZXNBcmVSZXNvbHZlZChbXSxbcmF3Q2xhc3NUeXBlXSxmdW5jdGlvbihjbGFzc1R5cGUpe2NsYXNzVHlwZT1jbGFzc1R5cGVbMF07dmFyIGh1bWFuTmFtZT1gY29uc3RydWN0b3IgJHtjbGFzc1R5cGUubmFtZX1gO2lmKHVuZGVmaW5lZD09PWNsYXNzVHlwZS5yZWdpc3RlcmVkQ2xhc3MuY29uc3RydWN0b3JfYm9keSl7Y2xhc3NUeXBlLnJlZ2lzdGVyZWRDbGFzcy5jb25zdHJ1Y3Rvcl9ib2R5PVtdfWlmKHVuZGVmaW5lZCE9PWNsYXNzVHlwZS5yZWdpc3RlcmVkQ2xhc3MuY29uc3RydWN0b3JfYm9keVthcmdDb3VudC0xXSl7dGhyb3cgbmV3IEJpbmRpbmdFcnJvcihgQ2Fubm90IHJlZ2lzdGVyIG11bHRpcGxlIGNvbnN0cnVjdG9ycyB3aXRoIGlkZW50aWNhbCBudW1iZXIgb2YgcGFyYW1ldGVycyAoJHthcmdDb3VudC0xfSkgZm9yIGNsYXNzICcke2NsYXNzVHlwZS5uYW1lfSchIE92ZXJsb2FkIHJlc29sdXRpb24gaXMgY3VycmVudGx5IG9ubHkgcGVyZm9ybWVkIHVzaW5nIHRoZSBwYXJhbWV0ZXIgY291bnQsIG5vdCBhY3R1YWwgdHlwZSBpbmZvIWApfWNsYXNzVHlwZS5yZWdpc3RlcmVkQ2xhc3MuY29uc3RydWN0b3JfYm9keVthcmdDb3VudC0xXT0oKT0+e3Rocm93VW5ib3VuZFR5cGVFcnJvcihgQ2Fubm90IGNvbnN0cnVjdCAke2NsYXNzVHlwZS5uYW1lfSBkdWUgdG8gdW5ib3VuZCB0eXBlc2AscmF3QXJnVHlwZXMpfTt3aGVuRGVwZW5kZW50VHlwZXNBcmVSZXNvbHZlZChbXSxyYXdBcmdUeXBlcyxhcmdUeXBlcz0+e2FyZ1R5cGVzLnNwbGljZSgxLDAsbnVsbCk7Y2xhc3NUeXBlLnJlZ2lzdGVyZWRDbGFzcy5jb25zdHJ1Y3Rvcl9ib2R5W2FyZ0NvdW50LTFdPWNyYWZ0SW52b2tlckZ1bmN0aW9uKGh1bWFuTmFtZSxhcmdUeXBlcyxudWxsLGludm9rZXIscmF3Q29uc3RydWN0b3IpO3JldHVybltdfSk7cmV0dXJuW119KX07dmFyIGdldEZ1bmN0aW9uTmFtZT1zaWduYXR1cmU9PntzaWduYXR1cmU9c2lnbmF0dXJlLnRyaW0oKTtjb25zdCBhcmdzSW5kZXg9c2lnbmF0dXJlLmluZGV4T2YoIigiKTtpZihhcmdzSW5kZXghPT0tMSl7cmV0dXJuIHNpZ25hdHVyZS5zdWJzdHIoMCxhcmdzSW5kZXgpfWVsc2V7cmV0dXJuIHNpZ25hdHVyZX19O3ZhciBfX2VtYmluZF9yZWdpc3Rlcl9jbGFzc19mdW5jdGlvbj0ocmF3Q2xhc3NUeXBlLG1ldGhvZE5hbWUsYXJnQ291bnQscmF3QXJnVHlwZXNBZGRyLGludm9rZXJTaWduYXR1cmUscmF3SW52b2tlcixjb250ZXh0LGlzUHVyZVZpcnR1YWwsaXNBc3luYyk9Pnt2YXIgcmF3QXJnVHlwZXM9aGVhcDMyVmVjdG9yVG9BcnJheShhcmdDb3VudCxyYXdBcmdUeXBlc0FkZHIpO21ldGhvZE5hbWU9cmVhZExhdGluMVN0cmluZyhtZXRob2ROYW1lKTttZXRob2ROYW1lPWdldEZ1bmN0aW9uTmFtZShtZXRob2ROYW1lKTtyYXdJbnZva2VyPWVtYmluZF9fcmVxdWlyZUZ1bmN0aW9uKGludm9rZXJTaWduYXR1cmUscmF3SW52b2tlcik7d2hlbkRlcGVuZGVudFR5cGVzQXJlUmVzb2x2ZWQoW10sW3Jhd0NsYXNzVHlwZV0sZnVuY3Rpb24oY2xhc3NUeXBlKXtjbGFzc1R5cGU9Y2xhc3NUeXBlWzBdO3ZhciBodW1hbk5hbWU9YCR7Y2xhc3NUeXBlLm5hbWV9LiR7bWV0aG9kTmFtZX1gO2lmKG1ldGhvZE5hbWUuc3RhcnRzV2l0aCgiQEAiKSl7bWV0aG9kTmFtZT1TeW1ib2xbbWV0aG9kTmFtZS5zdWJzdHJpbmcoMildfWlmKGlzUHVyZVZpcnR1YWwpe2NsYXNzVHlwZS5yZWdpc3RlcmVkQ2xhc3MucHVyZVZpcnR1YWxGdW5jdGlvbnMucHVzaChtZXRob2ROYW1lKX1mdW5jdGlvbiB1bmJvdW5kVHlwZXNIYW5kbGVyKCl7dGhyb3dVbmJvdW5kVHlwZUVycm9yKGBDYW5ub3QgY2FsbCAke2h1bWFuTmFtZX0gZHVlIHRvIHVuYm91bmQgdHlwZXNgLHJhd0FyZ1R5cGVzKX12YXIgcHJvdG89Y2xhc3NUeXBlLnJlZ2lzdGVyZWRDbGFzcy5pbnN0YW5jZVByb3RvdHlwZTt2YXIgbWV0aG9kPXByb3RvW21ldGhvZE5hbWVdO2lmKHVuZGVmaW5lZD09PW1ldGhvZHx8dW5kZWZpbmVkPT09bWV0aG9kLm92ZXJsb2FkVGFibGUmJm1ldGhvZC5jbGFzc05hbWUhPT1jbGFzc1R5cGUubmFtZSYmbWV0aG9kLmFyZ0NvdW50PT09YXJnQ291bnQtMil7dW5ib3VuZFR5cGVzSGFuZGxlci5hcmdDb3VudD1hcmdDb3VudC0yO3VuYm91bmRUeXBlc0hhbmRsZXIuY2xhc3NOYW1lPWNsYXNzVHlwZS5uYW1lO3Byb3RvW21ldGhvZE5hbWVdPXVuYm91bmRUeXBlc0hhbmRsZXJ9ZWxzZXtlbnN1cmVPdmVybG9hZFRhYmxlKHByb3RvLG1ldGhvZE5hbWUsaHVtYW5OYW1lKTtwcm90b1ttZXRob2ROYW1lXS5vdmVybG9hZFRhYmxlW2FyZ0NvdW50LTJdPXVuYm91bmRUeXBlc0hhbmRsZXJ9d2hlbkRlcGVuZGVudFR5cGVzQXJlUmVzb2x2ZWQoW10scmF3QXJnVHlwZXMsZnVuY3Rpb24oYXJnVHlwZXMpe3ZhciBtZW1iZXJGdW5jdGlvbj1jcmFmdEludm9rZXJGdW5jdGlvbihodW1hbk5hbWUsYXJnVHlwZXMsY2xhc3NUeXBlLHJhd0ludm9rZXIsY29udGV4dCxpc0FzeW5jKTtpZih1bmRlZmluZWQ9PT1wcm90b1ttZXRob2ROYW1lXS5vdmVybG9hZFRhYmxlKXttZW1iZXJGdW5jdGlvbi5hcmdDb3VudD1hcmdDb3VudC0yO3Byb3RvW21ldGhvZE5hbWVdPW1lbWJlckZ1bmN0aW9ufWVsc2V7cHJvdG9bbWV0aG9kTmFtZV0ub3ZlcmxvYWRUYWJsZVthcmdDb3VudC0yXT1tZW1iZXJGdW5jdGlvbn1yZXR1cm5bXX0pO3JldHVybltdfSl9O2Z1bmN0aW9uIGhhbmRsZUFsbG9jYXRvckluaXQoKXtPYmplY3QuYXNzaWduKEhhbmRsZUFsbG9jYXRvci5wcm90b3R5cGUse2dldChpZCl7cmV0dXJuIHRoaXMuYWxsb2NhdGVkW2lkXX0saGFzKGlkKXtyZXR1cm4gdGhpcy5hbGxvY2F0ZWRbaWRdIT09dW5kZWZpbmVkfSxhbGxvY2F0ZShoYW5kbGUpe3ZhciBpZD10aGlzLmZyZWVsaXN0LnBvcCgpfHx0aGlzLmFsbG9jYXRlZC5sZW5ndGg7dGhpcy5hbGxvY2F0ZWRbaWRdPWhhbmRsZTtyZXR1cm4gaWR9LGZyZWUoaWQpe3RoaXMuYWxsb2NhdGVkW2lkXT11bmRlZmluZWQ7dGhpcy5mcmVlbGlzdC5wdXNoKGlkKX19KX1mdW5jdGlvbiBIYW5kbGVBbGxvY2F0b3IoKXt0aGlzLmFsbG9jYXRlZD1bdW5kZWZpbmVkXTt0aGlzLmZyZWVsaXN0PVtdfXZhciBlbXZhbF9oYW5kbGVzPW5ldyBIYW5kbGVBbGxvY2F0b3I7dmFyIF9fZW12YWxfZGVjcmVmPWhhbmRsZT0+e2lmKGhhbmRsZT49ZW12YWxfaGFuZGxlcy5yZXNlcnZlZCYmMD09PS0tZW12YWxfaGFuZGxlcy5nZXQoaGFuZGxlKS5yZWZjb3VudCl7ZW12YWxfaGFuZGxlcy5mcmVlKGhhbmRsZSl9fTt2YXIgY291bnRfZW12YWxfaGFuZGxlcz0oKT0+e3ZhciBjb3VudD0wO2Zvcih2YXIgaT1lbXZhbF9oYW5kbGVzLnJlc2VydmVkO2k8ZW12YWxfaGFuZGxlcy5hbGxvY2F0ZWQubGVuZ3RoOysraSl7aWYoZW12YWxfaGFuZGxlcy5hbGxvY2F0ZWRbaV0hPT11bmRlZmluZWQpeysrY291bnR9fXJldHVybiBjb3VudH07dmFyIGluaXRfZW12YWw9KCk9PntlbXZhbF9oYW5kbGVzLmFsbG9jYXRlZC5wdXNoKHt2YWx1ZTp1bmRlZmluZWR9LHt2YWx1ZTpudWxsfSx7dmFsdWU6dHJ1ZX0se3ZhbHVlOmZhbHNlfSk7ZW12YWxfaGFuZGxlcy5yZXNlcnZlZD1lbXZhbF9oYW5kbGVzLmFsbG9jYXRlZC5sZW5ndGg7TW9kdWxlWyJjb3VudF9lbXZhbF9oYW5kbGVzIl09Y291bnRfZW12YWxfaGFuZGxlc307dmFyIEVtdmFsPXt0b1ZhbHVlOmhhbmRsZT0+e2lmKCFoYW5kbGUpe3Rocm93QmluZGluZ0Vycm9yKCJDYW5ub3QgdXNlIGRlbGV0ZWQgdmFsLiBoYW5kbGUgPSAiK2hhbmRsZSl9cmV0dXJuIGVtdmFsX2hhbmRsZXMuZ2V0KGhhbmRsZSkudmFsdWV9LHRvSGFuZGxlOnZhbHVlPT57c3dpdGNoKHZhbHVlKXtjYXNlIHVuZGVmaW5lZDpyZXR1cm4gMTtjYXNlIG51bGw6cmV0dXJuIDI7Y2FzZSB0cnVlOnJldHVybiAzO2Nhc2UgZmFsc2U6cmV0dXJuIDQ7ZGVmYXVsdDp7cmV0dXJuIGVtdmFsX2hhbmRsZXMuYWxsb2NhdGUoe3JlZmNvdW50OjEsdmFsdWU6dmFsdWV9KX19fX07ZnVuY3Rpb24gc2ltcGxlUmVhZFZhbHVlRnJvbVBvaW50ZXIocG9pbnRlcil7cmV0dXJuIHRoaXNbImZyb21XaXJlVHlwZSJdKEhFQVAzMltwb2ludGVyPj4yXSl9dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX2VtdmFsPShyYXdUeXBlLG5hbWUpPT57bmFtZT1yZWFkTGF0aW4xU3RyaW5nKG5hbWUpO3JlZ2lzdGVyVHlwZShyYXdUeXBlLHtuYW1lOm5hbWUsImZyb21XaXJlVHlwZSI6aGFuZGxlPT57dmFyIHJ2PUVtdmFsLnRvVmFsdWUoaGFuZGxlKTtfX2VtdmFsX2RlY3JlZihoYW5kbGUpO3JldHVybiBydn0sInRvV2lyZVR5cGUiOihkZXN0cnVjdG9ycyx2YWx1ZSk9PkVtdmFsLnRvSGFuZGxlKHZhbHVlKSwiYXJnUGFja0FkdmFuY2UiOkdlbmVyaWNXaXJlVHlwZVNpemUsInJlYWRWYWx1ZUZyb21Qb2ludGVyIjpzaW1wbGVSZWFkVmFsdWVGcm9tUG9pbnRlcixkZXN0cnVjdG9yRnVuY3Rpb246bnVsbH0pfTt2YXIgZW1iaW5kUmVwcj12PT57aWYodj09PW51bGwpe3JldHVybiJudWxsIn12YXIgdD10eXBlb2YgdjtpZih0PT09Im9iamVjdCJ8fHQ9PT0iYXJyYXkifHx0PT09ImZ1bmN0aW9uIil7cmV0dXJuIHYudG9TdHJpbmcoKX1lbHNle3JldHVybiIiK3Z9fTt2YXIgZmxvYXRSZWFkVmFsdWVGcm9tUG9pbnRlcj0obmFtZSx3aWR0aCk9Pntzd2l0Y2god2lkdGgpe2Nhc2UgNDpyZXR1cm4gZnVuY3Rpb24ocG9pbnRlcil7cmV0dXJuIHRoaXNbImZyb21XaXJlVHlwZSJdKEhFQVBGMzJbcG9pbnRlcj4+Ml0pfTtjYXNlIDg6cmV0dXJuIGZ1bmN0aW9uKHBvaW50ZXIpe3JldHVybiB0aGlzWyJmcm9tV2lyZVR5cGUiXShIRUFQRjY0W3BvaW50ZXI+PjNdKX07ZGVmYXVsdDp0aHJvdyBuZXcgVHlwZUVycm9yKGBpbnZhbGlkIGZsb2F0IHdpZHRoICgke3dpZHRofSk6ICR7bmFtZX1gKX19O3ZhciBfX2VtYmluZF9yZWdpc3Rlcl9mbG9hdD0ocmF3VHlwZSxuYW1lLHNpemUpPT57bmFtZT1yZWFkTGF0aW4xU3RyaW5nKG5hbWUpO3JlZ2lzdGVyVHlwZShyYXdUeXBlLHtuYW1lOm5hbWUsImZyb21XaXJlVHlwZSI6dmFsdWU9PnZhbHVlLCJ0b1dpcmVUeXBlIjooZGVzdHJ1Y3RvcnMsdmFsdWUpPT52YWx1ZSwiYXJnUGFja0FkdmFuY2UiOkdlbmVyaWNXaXJlVHlwZVNpemUsInJlYWRWYWx1ZUZyb21Qb2ludGVyIjpmbG9hdFJlYWRWYWx1ZUZyb21Qb2ludGVyKG5hbWUsc2l6ZSksZGVzdHJ1Y3RvckZ1bmN0aW9uOm51bGx9KX07dmFyIGludGVnZXJSZWFkVmFsdWVGcm9tUG9pbnRlcj0obmFtZSx3aWR0aCxzaWduZWQpPT57c3dpdGNoKHdpZHRoKXtjYXNlIDE6cmV0dXJuIHNpZ25lZD9wb2ludGVyPT5IRUFQOFtwb2ludGVyPj4wXTpwb2ludGVyPT5IRUFQVThbcG9pbnRlcj4+MF07Y2FzZSAyOnJldHVybiBzaWduZWQ/cG9pbnRlcj0+SEVBUDE2W3BvaW50ZXI+PjFdOnBvaW50ZXI9PkhFQVBVMTZbcG9pbnRlcj4+MV07Y2FzZSA0OnJldHVybiBzaWduZWQ/cG9pbnRlcj0+SEVBUDMyW3BvaW50ZXI+PjJdOnBvaW50ZXI9PkhFQVBVMzJbcG9pbnRlcj4+Ml07ZGVmYXVsdDp0aHJvdyBuZXcgVHlwZUVycm9yKGBpbnZhbGlkIGludGVnZXIgd2lkdGggKCR7d2lkdGh9KTogJHtuYW1lfWApfX07dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX2ludGVnZXI9KHByaW1pdGl2ZVR5cGUsbmFtZSxzaXplLG1pblJhbmdlLG1heFJhbmdlKT0+e25hbWU9cmVhZExhdGluMVN0cmluZyhuYW1lKTtpZihtYXhSYW5nZT09PS0xKXttYXhSYW5nZT00Mjk0OTY3Mjk1fXZhciBmcm9tV2lyZVR5cGU9dmFsdWU9PnZhbHVlO2lmKG1pblJhbmdlPT09MCl7dmFyIGJpdHNoaWZ0PTMyLTgqc2l6ZTtmcm9tV2lyZVR5cGU9dmFsdWU9PnZhbHVlPDxiaXRzaGlmdD4+PmJpdHNoaWZ0fXZhciBpc1Vuc2lnbmVkVHlwZT1uYW1lLmluY2x1ZGVzKCJ1bnNpZ25lZCIpO3ZhciBjaGVja0Fzc2VydGlvbnM9KHZhbHVlLHRvVHlwZU5hbWUpPT57fTt2YXIgdG9XaXJlVHlwZTtpZihpc1Vuc2lnbmVkVHlwZSl7dG9XaXJlVHlwZT1mdW5jdGlvbihkZXN0cnVjdG9ycyx2YWx1ZSl7Y2hlY2tBc3NlcnRpb25zKHZhbHVlLHRoaXMubmFtZSk7cmV0dXJuIHZhbHVlPj4+MH19ZWxzZXt0b1dpcmVUeXBlPWZ1bmN0aW9uKGRlc3RydWN0b3JzLHZhbHVlKXtjaGVja0Fzc2VydGlvbnModmFsdWUsdGhpcy5uYW1lKTtyZXR1cm4gdmFsdWV9fXJlZ2lzdGVyVHlwZShwcmltaXRpdmVUeXBlLHtuYW1lOm5hbWUsImZyb21XaXJlVHlwZSI6ZnJvbVdpcmVUeXBlLCJ0b1dpcmVUeXBlIjp0b1dpcmVUeXBlLCJhcmdQYWNrQWR2YW5jZSI6R2VuZXJpY1dpcmVUeXBlU2l6ZSwicmVhZFZhbHVlRnJvbVBvaW50ZXIiOmludGVnZXJSZWFkVmFsdWVGcm9tUG9pbnRlcihuYW1lLHNpemUsbWluUmFuZ2UhPT0wKSxkZXN0cnVjdG9yRnVuY3Rpb246bnVsbH0pfTt2YXIgX19lbWJpbmRfcmVnaXN0ZXJfbWVtb3J5X3ZpZXc9KHJhd1R5cGUsZGF0YVR5cGVJbmRleCxuYW1lKT0+e3ZhciB0eXBlTWFwcGluZz1bSW50OEFycmF5LFVpbnQ4QXJyYXksSW50MTZBcnJheSxVaW50MTZBcnJheSxJbnQzMkFycmF5LFVpbnQzMkFycmF5LEZsb2F0MzJBcnJheSxGbG9hdDY0QXJyYXldO3ZhciBUQT10eXBlTWFwcGluZ1tkYXRhVHlwZUluZGV4XTtmdW5jdGlvbiBkZWNvZGVNZW1vcnlWaWV3KGhhbmRsZSl7dmFyIHNpemU9SEVBUFUzMltoYW5kbGU+PjJdO3ZhciBkYXRhPUhFQVBVMzJbaGFuZGxlKzQ+PjJdO3JldHVybiBuZXcgVEEoSEVBUDguYnVmZmVyLGRhdGEsc2l6ZSl9bmFtZT1yZWFkTGF0aW4xU3RyaW5nKG5hbWUpO3JlZ2lzdGVyVHlwZShyYXdUeXBlLHtuYW1lOm5hbWUsImZyb21XaXJlVHlwZSI6ZGVjb2RlTWVtb3J5VmlldywiYXJnUGFja0FkdmFuY2UiOkdlbmVyaWNXaXJlVHlwZVNpemUsInJlYWRWYWx1ZUZyb21Qb2ludGVyIjpkZWNvZGVNZW1vcnlWaWV3fSx7aWdub3JlRHVwbGljYXRlUmVnaXN0cmF0aW9uczp0cnVlfSl9O3ZhciBfX2VtYmluZF9yZWdpc3Rlcl9zdGRfc3RyaW5nPShyYXdUeXBlLG5hbWUpPT57bmFtZT1yZWFkTGF0aW4xU3RyaW5nKG5hbWUpO3ZhciBzdGRTdHJpbmdJc1VURjg9bmFtZT09PSJzdGQ6OnN0cmluZyI7cmVnaXN0ZXJUeXBlKHJhd1R5cGUse25hbWU6bmFtZSwiZnJvbVdpcmVUeXBlIih2YWx1ZSl7dmFyIGxlbmd0aD1IRUFQVTMyW3ZhbHVlPj4yXTt2YXIgcGF5bG9hZD12YWx1ZSs0O3ZhciBzdHI7aWYoc3RkU3RyaW5nSXNVVEY4KXt2YXIgZGVjb2RlU3RhcnRQdHI9cGF5bG9hZDtmb3IodmFyIGk9MDtpPD1sZW5ndGg7KytpKXt2YXIgY3VycmVudEJ5dGVQdHI9cGF5bG9hZCtpO2lmKGk9PWxlbmd0aHx8SEVBUFU4W2N1cnJlbnRCeXRlUHRyXT09MCl7dmFyIG1heFJlYWQ9Y3VycmVudEJ5dGVQdHItZGVjb2RlU3RhcnRQdHI7dmFyIHN0cmluZ1NlZ21lbnQ9VVRGOFRvU3RyaW5nKGRlY29kZVN0YXJ0UHRyLG1heFJlYWQpO2lmKHN0cj09PXVuZGVmaW5lZCl7c3RyPXN0cmluZ1NlZ21lbnR9ZWxzZXtzdHIrPVN0cmluZy5mcm9tQ2hhckNvZGUoMCk7c3RyKz1zdHJpbmdTZWdtZW50fWRlY29kZVN0YXJ0UHRyPWN1cnJlbnRCeXRlUHRyKzF9fX1lbHNle3ZhciBhPW5ldyBBcnJheShsZW5ndGgpO2Zvcih2YXIgaT0wO2k8bGVuZ3RoOysraSl7YVtpXT1TdHJpbmcuZnJvbUNoYXJDb2RlKEhFQVBVOFtwYXlsb2FkK2ldKX1zdHI9YS5qb2luKCIiKX1fZnJlZSh2YWx1ZSk7cmV0dXJuIHN0cn0sInRvV2lyZVR5cGUiKGRlc3RydWN0b3JzLHZhbHVlKXtpZih2YWx1ZSBpbnN0YW5jZW9mIEFycmF5QnVmZmVyKXt2YWx1ZT1uZXcgVWludDhBcnJheSh2YWx1ZSl9dmFyIGxlbmd0aDt2YXIgdmFsdWVJc09mVHlwZVN0cmluZz10eXBlb2YgdmFsdWU9PSJzdHJpbmciO2lmKCEodmFsdWVJc09mVHlwZVN0cmluZ3x8dmFsdWUgaW5zdGFuY2VvZiBVaW50OEFycmF5fHx2YWx1ZSBpbnN0YW5jZW9mIFVpbnQ4Q2xhbXBlZEFycmF5fHx2YWx1ZSBpbnN0YW5jZW9mIEludDhBcnJheSkpe3Rocm93QmluZGluZ0Vycm9yKCJDYW5ub3QgcGFzcyBub24tc3RyaW5nIHRvIHN0ZDo6c3RyaW5nIil9aWYoc3RkU3RyaW5nSXNVVEY4JiZ2YWx1ZUlzT2ZUeXBlU3RyaW5nKXtsZW5ndGg9bGVuZ3RoQnl0ZXNVVEY4KHZhbHVlKX1lbHNle2xlbmd0aD12YWx1ZS5sZW5ndGh9dmFyIGJhc2U9X21hbGxvYyg0K2xlbmd0aCsxKTt2YXIgcHRyPWJhc2UrNDtIRUFQVTMyW2Jhc2U+PjJdPWxlbmd0aDtpZihzdGRTdHJpbmdJc1VURjgmJnZhbHVlSXNPZlR5cGVTdHJpbmcpe3N0cmluZ1RvVVRGOCh2YWx1ZSxwdHIsbGVuZ3RoKzEpfWVsc2V7aWYodmFsdWVJc09mVHlwZVN0cmluZyl7Zm9yKHZhciBpPTA7aTxsZW5ndGg7KytpKXt2YXIgY2hhckNvZGU9dmFsdWUuY2hhckNvZGVBdChpKTtpZihjaGFyQ29kZT4yNTUpe19mcmVlKHB0cik7dGhyb3dCaW5kaW5nRXJyb3IoIlN0cmluZyBoYXMgVVRGLTE2IGNvZGUgdW5pdHMgdGhhdCBkbyBub3QgZml0IGluIDggYml0cyIpfUhFQVBVOFtwdHIraV09Y2hhckNvZGV9fWVsc2V7Zm9yKHZhciBpPTA7aTxsZW5ndGg7KytpKXtIRUFQVThbcHRyK2ldPXZhbHVlW2ldfX19aWYoZGVzdHJ1Y3RvcnMhPT1udWxsKXtkZXN0cnVjdG9ycy5wdXNoKF9mcmVlLGJhc2UpfXJldHVybiBiYXNlfSwiYXJnUGFja0FkdmFuY2UiOkdlbmVyaWNXaXJlVHlwZVNpemUsInJlYWRWYWx1ZUZyb21Qb2ludGVyIjpyZWFkUG9pbnRlcixkZXN0cnVjdG9yRnVuY3Rpb24ocHRyKXtfZnJlZShwdHIpfX0pfTt2YXIgVVRGMTZEZWNvZGVyPXR5cGVvZiBUZXh0RGVjb2RlciE9InVuZGVmaW5lZCI/bmV3IFRleHREZWNvZGVyKCJ1dGYtMTZsZSIpOnVuZGVmaW5lZDt2YXIgVVRGMTZUb1N0cmluZz0ocHRyLG1heEJ5dGVzVG9SZWFkKT0+e3ZhciBlbmRQdHI9cHRyO3ZhciBpZHg9ZW5kUHRyPj4xO3ZhciBtYXhJZHg9aWR4K21heEJ5dGVzVG9SZWFkLzI7d2hpbGUoIShpZHg+PW1heElkeCkmJkhFQVBVMTZbaWR4XSkrK2lkeDtlbmRQdHI9aWR4PDwxO2lmKGVuZFB0ci1wdHI+MzImJlVURjE2RGVjb2RlcilyZXR1cm4gVVRGMTZEZWNvZGVyLmRlY29kZShIRUFQVTguc3ViYXJyYXkocHRyLGVuZFB0cikpO3ZhciBzdHI9IiI7Zm9yKHZhciBpPTA7IShpPj1tYXhCeXRlc1RvUmVhZC8yKTsrK2kpe3ZhciBjb2RlVW5pdD1IRUFQMTZbcHRyK2kqMj4+MV07aWYoY29kZVVuaXQ9PTApYnJlYWs7c3RyKz1TdHJpbmcuZnJvbUNoYXJDb2RlKGNvZGVVbml0KX1yZXR1cm4gc3RyfTt2YXIgc3RyaW5nVG9VVEYxNj0oc3RyLG91dFB0cixtYXhCeXRlc1RvV3JpdGUpPT57aWYobWF4Qnl0ZXNUb1dyaXRlPT09dW5kZWZpbmVkKXttYXhCeXRlc1RvV3JpdGU9MjE0NzQ4MzY0N31pZihtYXhCeXRlc1RvV3JpdGU8MilyZXR1cm4gMDttYXhCeXRlc1RvV3JpdGUtPTI7dmFyIHN0YXJ0UHRyPW91dFB0cjt2YXIgbnVtQ2hhcnNUb1dyaXRlPW1heEJ5dGVzVG9Xcml0ZTxzdHIubGVuZ3RoKjI/bWF4Qnl0ZXNUb1dyaXRlLzI6c3RyLmxlbmd0aDtmb3IodmFyIGk9MDtpPG51bUNoYXJzVG9Xcml0ZTsrK2kpe3ZhciBjb2RlVW5pdD1zdHIuY2hhckNvZGVBdChpKTtIRUFQMTZbb3V0UHRyPj4xXT1jb2RlVW5pdDtvdXRQdHIrPTJ9SEVBUDE2W291dFB0cj4+MV09MDtyZXR1cm4gb3V0UHRyLXN0YXJ0UHRyfTt2YXIgbGVuZ3RoQnl0ZXNVVEYxNj1zdHI9PnN0ci5sZW5ndGgqMjt2YXIgVVRGMzJUb1N0cmluZz0ocHRyLG1heEJ5dGVzVG9SZWFkKT0+e3ZhciBpPTA7dmFyIHN0cj0iIjt3aGlsZSghKGk+PW1heEJ5dGVzVG9SZWFkLzQpKXt2YXIgdXRmMzI9SEVBUDMyW3B0citpKjQ+PjJdO2lmKHV0ZjMyPT0wKWJyZWFrOysraTtpZih1dGYzMj49NjU1MzYpe3ZhciBjaD11dGYzMi02NTUzNjtzdHIrPVN0cmluZy5mcm9tQ2hhckNvZGUoNTUyOTZ8Y2g+PjEwLDU2MzIwfGNoJjEwMjMpfWVsc2V7c3RyKz1TdHJpbmcuZnJvbUNoYXJDb2RlKHV0ZjMyKX19cmV0dXJuIHN0cn07dmFyIHN0cmluZ1RvVVRGMzI9KHN0cixvdXRQdHIsbWF4Qnl0ZXNUb1dyaXRlKT0+e2lmKG1heEJ5dGVzVG9Xcml0ZT09PXVuZGVmaW5lZCl7bWF4Qnl0ZXNUb1dyaXRlPTIxNDc0ODM2NDd9aWYobWF4Qnl0ZXNUb1dyaXRlPDQpcmV0dXJuIDA7dmFyIHN0YXJ0UHRyPW91dFB0cjt2YXIgZW5kUHRyPXN0YXJ0UHRyK21heEJ5dGVzVG9Xcml0ZS00O2Zvcih2YXIgaT0wO2k8c3RyLmxlbmd0aDsrK2kpe3ZhciBjb2RlVW5pdD1zdHIuY2hhckNvZGVBdChpKTtpZihjb2RlVW5pdD49NTUyOTYmJmNvZGVVbml0PD01NzM0Myl7dmFyIHRyYWlsU3Vycm9nYXRlPXN0ci5jaGFyQ29kZUF0KCsraSk7Y29kZVVuaXQ9NjU1MzYrKChjb2RlVW5pdCYxMDIzKTw8MTApfHRyYWlsU3Vycm9nYXRlJjEwMjN9SEVBUDMyW291dFB0cj4+Ml09Y29kZVVuaXQ7b3V0UHRyKz00O2lmKG91dFB0cis0PmVuZFB0cilicmVha31IRUFQMzJbb3V0UHRyPj4yXT0wO3JldHVybiBvdXRQdHItc3RhcnRQdHJ9O3ZhciBsZW5ndGhCeXRlc1VURjMyPXN0cj0+e3ZhciBsZW49MDtmb3IodmFyIGk9MDtpPHN0ci5sZW5ndGg7KytpKXt2YXIgY29kZVVuaXQ9c3RyLmNoYXJDb2RlQXQoaSk7aWYoY29kZVVuaXQ+PTU1Mjk2JiZjb2RlVW5pdDw9NTczNDMpKytpO2xlbis9NH1yZXR1cm4gbGVufTt2YXIgX19lbWJpbmRfcmVnaXN0ZXJfc3RkX3dzdHJpbmc9KHJhd1R5cGUsY2hhclNpemUsbmFtZSk9PntuYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7dmFyIGRlY29kZVN0cmluZyxlbmNvZGVTdHJpbmcsZ2V0SGVhcCxsZW5ndGhCeXRlc1VURixzaGlmdDtpZihjaGFyU2l6ZT09PTIpe2RlY29kZVN0cmluZz1VVEYxNlRvU3RyaW5nO2VuY29kZVN0cmluZz1zdHJpbmdUb1VURjE2O2xlbmd0aEJ5dGVzVVRGPWxlbmd0aEJ5dGVzVVRGMTY7Z2V0SGVhcD0oKT0+SEVBUFUxNjtzaGlmdD0xfWVsc2UgaWYoY2hhclNpemU9PT00KXtkZWNvZGVTdHJpbmc9VVRGMzJUb1N0cmluZztlbmNvZGVTdHJpbmc9c3RyaW5nVG9VVEYzMjtsZW5ndGhCeXRlc1VURj1sZW5ndGhCeXRlc1VURjMyO2dldEhlYXA9KCk9PkhFQVBVMzI7c2hpZnQ9Mn1yZWdpc3RlclR5cGUocmF3VHlwZSx7bmFtZTpuYW1lLCJmcm9tV2lyZVR5cGUiOnZhbHVlPT57dmFyIGxlbmd0aD1IRUFQVTMyW3ZhbHVlPj4yXTt2YXIgSEVBUD1nZXRIZWFwKCk7dmFyIHN0cjt2YXIgZGVjb2RlU3RhcnRQdHI9dmFsdWUrNDtmb3IodmFyIGk9MDtpPD1sZW5ndGg7KytpKXt2YXIgY3VycmVudEJ5dGVQdHI9dmFsdWUrNCtpKmNoYXJTaXplO2lmKGk9PWxlbmd0aHx8SEVBUFtjdXJyZW50Qnl0ZVB0cj4+c2hpZnRdPT0wKXt2YXIgbWF4UmVhZEJ5dGVzPWN1cnJlbnRCeXRlUHRyLWRlY29kZVN0YXJ0UHRyO3ZhciBzdHJpbmdTZWdtZW50PWRlY29kZVN0cmluZyhkZWNvZGVTdGFydFB0cixtYXhSZWFkQnl0ZXMpO2lmKHN0cj09PXVuZGVmaW5lZCl7c3RyPXN0cmluZ1NlZ21lbnR9ZWxzZXtzdHIrPVN0cmluZy5mcm9tQ2hhckNvZGUoMCk7c3RyKz1zdHJpbmdTZWdtZW50fWRlY29kZVN0YXJ0UHRyPWN1cnJlbnRCeXRlUHRyK2NoYXJTaXplfX1fZnJlZSh2YWx1ZSk7cmV0dXJuIHN0cn0sInRvV2lyZVR5cGUiOihkZXN0cnVjdG9ycyx2YWx1ZSk9PntpZighKHR5cGVvZiB2YWx1ZT09InN0cmluZyIpKXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IHBhc3Mgbm9uLXN0cmluZyB0byBDKysgc3RyaW5nIHR5cGUgJHtuYW1lfWApfXZhciBsZW5ndGg9bGVuZ3RoQnl0ZXNVVEYodmFsdWUpO3ZhciBwdHI9X21hbGxvYyg0K2xlbmd0aCtjaGFyU2l6ZSk7SEVBUFUzMltwdHI+PjJdPWxlbmd0aD4+c2hpZnQ7ZW5jb2RlU3RyaW5nKHZhbHVlLHB0cis0LGxlbmd0aCtjaGFyU2l6ZSk7aWYoZGVzdHJ1Y3RvcnMhPT1udWxsKXtkZXN0cnVjdG9ycy5wdXNoKF9mcmVlLHB0cil9cmV0dXJuIHB0cn0sImFyZ1BhY2tBZHZhbmNlIjpHZW5lcmljV2lyZVR5cGVTaXplLCJyZWFkVmFsdWVGcm9tUG9pbnRlciI6c2ltcGxlUmVhZFZhbHVlRnJvbVBvaW50ZXIsZGVzdHJ1Y3RvckZ1bmN0aW9uKHB0cil7X2ZyZWUocHRyKX19KX07dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX3ZvaWQ9KHJhd1R5cGUsbmFtZSk9PntuYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7cmVnaXN0ZXJUeXBlKHJhd1R5cGUse2lzVm9pZDp0cnVlLG5hbWU6bmFtZSwiYXJnUGFja0FkdmFuY2UiOjAsImZyb21XaXJlVHlwZSI6KCk9PnVuZGVmaW5lZCwidG9XaXJlVHlwZSI6KGRlc3RydWN0b3JzLG8pPT51bmRlZmluZWR9KX07dmFyIG5vd0lzTW9ub3RvbmljPTE7dmFyIF9fZW1zY3JpcHRlbl9nZXRfbm93X2lzX21vbm90b25pYz0oKT0+bm93SXNNb25vdG9uaWM7dmFyIF9fZW12YWxfaW5jcmVmPWhhbmRsZT0+e2lmKGhhbmRsZT40KXtlbXZhbF9oYW5kbGVzLmdldChoYW5kbGUpLnJlZmNvdW50Kz0xfX07dmFyIHJlcXVpcmVSZWdpc3RlcmVkVHlwZT0ocmF3VHlwZSxodW1hbk5hbWUpPT57dmFyIGltcGw9cmVnaXN0ZXJlZFR5cGVzW3Jhd1R5cGVdO2lmKHVuZGVmaW5lZD09PWltcGwpe3Rocm93QmluZGluZ0Vycm9yKGh1bWFuTmFtZSsiIGhhcyB1bmtub3duIHR5cGUgIitnZXRUeXBlTmFtZShyYXdUeXBlKSl9cmV0dXJuIGltcGx9O3ZhciBfX2VtdmFsX3Rha2VfdmFsdWU9KHR5cGUsYXJnKT0+e3R5cGU9cmVxdWlyZVJlZ2lzdGVyZWRUeXBlKHR5cGUsIl9lbXZhbF90YWtlX3ZhbHVlIik7dmFyIHY9dHlwZVsicmVhZFZhbHVlRnJvbVBvaW50ZXIiXShhcmcpO3JldHVybiBFbXZhbC50b0hhbmRsZSh2KX07ZnVuY3Rpb24gX19tbWFwX2pzKGxlbixwcm90LGZsYWdzLGZkLG9mZnNldF9sb3csb2Zmc2V0X2hpZ2gsYWxsb2NhdGVkLGFkZHIpe3ZhciBvZmZzZXQ9Y29udmVydEkzMlBhaXJUb0k1M0NoZWNrZWQob2Zmc2V0X2xvdyxvZmZzZXRfaGlnaCk7dHJ5e2lmKGlzTmFOKG9mZnNldCkpcmV0dXJuIDYxO3ZhciBzdHJlYW09U1lTQ0FMTFMuZ2V0U3RyZWFtRnJvbUZEKGZkKTt2YXIgcmVzPUZTLm1tYXAoc3RyZWFtLGxlbixvZmZzZXQscHJvdCxmbGFncyk7dmFyIHB0cj1yZXMucHRyO0hFQVAzMlthbGxvY2F0ZWQ+PjJdPXJlcy5hbGxvY2F0ZWQ7SEVBUFUzMlthZGRyPj4yXT1wdHI7cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuLWUuZXJybm99fWZ1bmN0aW9uIF9fbXVubWFwX2pzKGFkZHIsbGVuLHByb3QsZmxhZ3MsZmQsb2Zmc2V0X2xvdyxvZmZzZXRfaGlnaCl7dmFyIG9mZnNldD1jb252ZXJ0STMyUGFpclRvSTUzQ2hlY2tlZChvZmZzZXRfbG93LG9mZnNldF9oaWdoKTt0cnl7aWYoaXNOYU4ob2Zmc2V0KSlyZXR1cm4gNjE7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO2lmKHByb3QmMil7U1lTQ0FMTFMuZG9Nc3luYyhhZGRyLHN0cmVhbSxsZW4sZmxhZ3Msb2Zmc2V0KX1GUy5tdW5tYXAoc3RyZWFtKX1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319dmFyIF9hYm9ydD0oKT0+e2Fib3J0KCIiKX07dmFyIF9lbXNjcmlwdGVuX2RhdGVfbm93PSgpPT5EYXRlLm5vdygpO3ZhciBnZXRIZWFwTWF4PSgpPT5IRUFQVTgubGVuZ3RoO3ZhciBfZW1zY3JpcHRlbl9nZXRfaGVhcF9tYXg9KCk9PmdldEhlYXBNYXgoKTt2YXIgX2Vtc2NyaXB0ZW5fZ2V0X25vdztfZW1zY3JpcHRlbl9nZXRfbm93PSgpPT5wZXJmb3JtYW5jZS5ub3coKTt2YXIgX2Vtc2NyaXB0ZW5fbWVtY3B5X2pzPShkZXN0LHNyYyxudW0pPT5IRUFQVTguY29weVdpdGhpbihkZXN0LHNyYyxzcmMrbnVtKTt2YXIgYWJvcnRPbkNhbm5vdEdyb3dNZW1vcnk9cmVxdWVzdGVkU2l6ZT0+e2Fib3J0KCJPT00iKX07dmFyIF9lbXNjcmlwdGVuX3Jlc2l6ZV9oZWFwPXJlcXVlc3RlZFNpemU9Pnt2YXIgb2xkU2l6ZT1IRUFQVTgubGVuZ3RoO3JlcXVlc3RlZFNpemU+Pj49MDthYm9ydE9uQ2Fubm90R3Jvd01lbW9yeShyZXF1ZXN0ZWRTaXplKX07dmFyIEVOVj17fTt2YXIgZ2V0RXhlY3V0YWJsZU5hbWU9KCk9PnRoaXNQcm9ncmFtfHwiLi90aGlzLnByb2dyYW0iO3ZhciBnZXRFbnZTdHJpbmdzPSgpPT57aWYoIWdldEVudlN0cmluZ3Muc3RyaW5ncyl7dmFyIGxhbmc9KHR5cGVvZiBuYXZpZ2F0b3I9PSJvYmplY3QiJiZuYXZpZ2F0b3IubGFuZ3VhZ2VzJiZuYXZpZ2F0b3IubGFuZ3VhZ2VzWzBdfHwiQyIpLnJlcGxhY2UoIi0iLCJfIikrIi5VVEYtOCI7dmFyIGVudj17IlVTRVIiOiJ3ZWJfdXNlciIsIkxPR05BTUUiOiJ3ZWJfdXNlciIsIlBBVEgiOiIvIiwiUFdEIjoiLyIsIkhPTUUiOiIvaG9tZS93ZWJfdXNlciIsIkxBTkciOmxhbmcsIl8iOmdldEV4ZWN1dGFibGVOYW1lKCl9O2Zvcih2YXIgeCBpbiBFTlYpe2lmKEVOVlt4XT09PXVuZGVmaW5lZClkZWxldGUgZW52W3hdO2Vsc2UgZW52W3hdPUVOVlt4XX12YXIgc3RyaW5ncz1bXTtmb3IodmFyIHggaW4gZW52KXtzdHJpbmdzLnB1c2goYCR7eH09JHtlbnZbeF19YCl9Z2V0RW52U3RyaW5ncy5zdHJpbmdzPXN0cmluZ3N9cmV0dXJuIGdldEVudlN0cmluZ3Muc3RyaW5nc307dmFyIHN0cmluZ1RvQXNjaWk9KHN0cixidWZmZXIpPT57Zm9yKHZhciBpPTA7aTxzdHIubGVuZ3RoOysraSl7SEVBUDhbYnVmZmVyKys+PjBdPXN0ci5jaGFyQ29kZUF0KGkpfUhFQVA4W2J1ZmZlcj4+MF09MH07dmFyIF9lbnZpcm9uX2dldD0oX19lbnZpcm9uLGVudmlyb25fYnVmKT0+e3ZhciBidWZTaXplPTA7Z2V0RW52U3RyaW5ncygpLmZvckVhY2goKHN0cmluZyxpKT0+e3ZhciBwdHI9ZW52aXJvbl9idWYrYnVmU2l6ZTtIRUFQVTMyW19fZW52aXJvbitpKjQ+PjJdPXB0cjtzdHJpbmdUb0FzY2lpKHN0cmluZyxwdHIpO2J1ZlNpemUrPXN0cmluZy5sZW5ndGgrMX0pO3JldHVybiAwfTt2YXIgX2Vudmlyb25fc2l6ZXNfZ2V0PShwZW52aXJvbl9jb3VudCxwZW52aXJvbl9idWZfc2l6ZSk9Pnt2YXIgc3RyaW5ncz1nZXRFbnZTdHJpbmdzKCk7SEVBUFUzMltwZW52aXJvbl9jb3VudD4+Ml09c3RyaW5ncy5sZW5ndGg7dmFyIGJ1ZlNpemU9MDtzdHJpbmdzLmZvckVhY2goc3RyaW5nPT5idWZTaXplKz1zdHJpbmcubGVuZ3RoKzEpO0hFQVBVMzJbcGVudmlyb25fYnVmX3NpemU+PjJdPWJ1ZlNpemU7cmV0dXJuIDB9O3ZhciBydW50aW1lS2VlcGFsaXZlQ291bnRlcj0wO3ZhciBrZWVwUnVudGltZUFsaXZlPSgpPT5ub0V4aXRSdW50aW1lfHxydW50aW1lS2VlcGFsaXZlQ291bnRlcj4wO3ZhciBfcHJvY19leGl0PWNvZGU9PntFWElUU1RBVFVTPWNvZGU7aWYoIWtlZXBSdW50aW1lQWxpdmUoKSl7aWYoTW9kdWxlWyJvbkV4aXQiXSlNb2R1bGVbIm9uRXhpdCJdKGNvZGUpO0FCT1JUPXRydWV9cXVpdF8oY29kZSxuZXcgRXhpdFN0YXR1cyhjb2RlKSl9O3ZhciBleGl0SlM9KHN0YXR1cyxpbXBsaWNpdCk9PntFWElUU1RBVFVTPXN0YXR1cztpZigha2VlcFJ1bnRpbWVBbGl2ZSgpKXtleGl0UnVudGltZSgpfV9wcm9jX2V4aXQoc3RhdHVzKX07dmFyIF9leGl0PWV4aXRKUztmdW5jdGlvbiBfZmRfY2xvc2UoZmQpe3RyeXt2YXIgc3RyZWFtPVNZU0NBTExTLmdldFN0cmVhbUZyb21GRChmZCk7RlMuY2xvc2Uoc3RyZWFtKTtyZXR1cm4gMH1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4gZS5lcnJub319dmFyIGRvUmVhZHY9KHN0cmVhbSxpb3YsaW92Y250LG9mZnNldCk9Pnt2YXIgcmV0PTA7Zm9yKHZhciBpPTA7aTxpb3ZjbnQ7aSsrKXt2YXIgcHRyPUhFQVBVMzJbaW92Pj4yXTt2YXIgbGVuPUhFQVBVMzJbaW92KzQ+PjJdO2lvdis9ODt2YXIgY3Vycj1GUy5yZWFkKHN0cmVhbSxIRUFQOCxwdHIsbGVuLG9mZnNldCk7aWYoY3VycjwwKXJldHVybi0xO3JldCs9Y3VycjtpZihjdXJyPGxlbilicmVhaztpZih0eXBlb2Ygb2Zmc2V0IT09InVuZGVmaW5lZCIpe29mZnNldCs9Y3Vycn19cmV0dXJuIHJldH07ZnVuY3Rpb24gX2ZkX3JlYWQoZmQsaW92LGlvdmNudCxwbnVtKXt0cnl7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO3ZhciBudW09ZG9SZWFkdihzdHJlYW0saW92LGlvdmNudCk7SEVBUFUzMltwbnVtPj4yXT1udW07cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuIGUuZXJybm99fWZ1bmN0aW9uIF9mZF9zZWVrKGZkLG9mZnNldF9sb3csb2Zmc2V0X2hpZ2gsd2hlbmNlLG5ld09mZnNldCl7dmFyIG9mZnNldD1jb252ZXJ0STMyUGFpclRvSTUzQ2hlY2tlZChvZmZzZXRfbG93LG9mZnNldF9oaWdoKTt0cnl7aWYoaXNOYU4ob2Zmc2V0KSlyZXR1cm4gNjE7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO0ZTLmxsc2VlayhzdHJlYW0sb2Zmc2V0LHdoZW5jZSk7dGVtcEk2ND1bc3RyZWFtLnBvc2l0aW9uPj4+MCwodGVtcERvdWJsZT1zdHJlYW0ucG9zaXRpb24sK01hdGguYWJzKHRlbXBEb3VibGUpPj0xP3RlbXBEb3VibGU+MD8rTWF0aC5mbG9vcih0ZW1wRG91YmxlLzQyOTQ5NjcyOTYpPj4+MDp+fitNYXRoLmNlaWwoKHRlbXBEb3VibGUtKyh+fnRlbXBEb3VibGU+Pj4wKSkvNDI5NDk2NzI5Nik+Pj4wOjApXSxIRUFQMzJbbmV3T2Zmc2V0Pj4yXT10ZW1wSTY0WzBdLEhFQVAzMltuZXdPZmZzZXQrND4+Ml09dGVtcEk2NFsxXTtpZihzdHJlYW0uZ2V0ZGVudHMmJm9mZnNldD09PTAmJndoZW5jZT09PTApc3RyZWFtLmdldGRlbnRzPW51bGw7cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuIGUuZXJybm99fWZ1bmN0aW9uIF9mZF9zeW5jKGZkKXt0cnl7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO2lmKHN0cmVhbS5zdHJlYW1fb3BzJiZzdHJlYW0uc3RyZWFtX29wcy5mc3luYyl7cmV0dXJuIHN0cmVhbS5zdHJlYW1fb3BzLmZzeW5jKHN0cmVhbSl9cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuIGUuZXJybm99fXZhciBkb1dyaXRldj0oc3RyZWFtLGlvdixpb3ZjbnQsb2Zmc2V0KT0+e3ZhciByZXQ9MDtmb3IodmFyIGk9MDtpPGlvdmNudDtpKyspe3ZhciBwdHI9SEVBUFUzMltpb3Y+PjJdO3ZhciBsZW49SEVBUFUzMltpb3YrND4+Ml07aW92Kz04O3ZhciBjdXJyPUZTLndyaXRlKHN0cmVhbSxIRUFQOCxwdHIsbGVuLG9mZnNldCk7aWYoY3VycjwwKXJldHVybi0xO3JldCs9Y3VycjtpZih0eXBlb2Ygb2Zmc2V0IT09InVuZGVmaW5lZCIpe29mZnNldCs9Y3Vycn19cmV0dXJuIHJldH07ZnVuY3Rpb24gX2ZkX3dyaXRlKGZkLGlvdixpb3ZjbnQscG51bSl7dHJ5e3ZhciBzdHJlYW09U1lTQ0FMTFMuZ2V0U3RyZWFtRnJvbUZEKGZkKTt2YXIgbnVtPWRvV3JpdGV2KHN0cmVhbSxpb3YsaW92Y250KTtIRUFQVTMyW3BudW0+PjJdPW51bTtyZXR1cm4gMH1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4gZS5lcnJub319dmFyIF9nZXRlbnRyb3B5PShidWZmZXIsc2l6ZSk9PntyYW5kb21GaWxsKEhFQVBVOC5zdWJhcnJheShidWZmZXIsYnVmZmVyK3NpemUpKTtyZXR1cm4gMH07dmFyIGlzTGVhcFllYXI9eWVhcj0+eWVhciU0PT09MCYmKHllYXIlMTAwIT09MHx8eWVhciU0MDA9PT0wKTt2YXIgYXJyYXlTdW09KGFycmF5LGluZGV4KT0+e3ZhciBzdW09MDtmb3IodmFyIGk9MDtpPD1pbmRleDtzdW0rPWFycmF5W2krK10pe31yZXR1cm4gc3VtfTt2YXIgTU9OVEhfREFZU19MRUFQPVszMSwyOSwzMSwzMCwzMSwzMCwzMSwzMSwzMCwzMSwzMCwzMV07dmFyIE1PTlRIX0RBWVNfUkVHVUxBUj1bMzEsMjgsMzEsMzAsMzEsMzAsMzEsMzEsMzAsMzEsMzAsMzFdO3ZhciBhZGREYXlzPShkYXRlLGRheXMpPT57dmFyIG5ld0RhdGU9bmV3IERhdGUoZGF0ZS5nZXRUaW1lKCkpO3doaWxlKGRheXM+MCl7dmFyIGxlYXA9aXNMZWFwWWVhcihuZXdEYXRlLmdldEZ1bGxZZWFyKCkpO3ZhciBjdXJyZW50TW9udGg9bmV3RGF0ZS5nZXRNb250aCgpO3ZhciBkYXlzSW5DdXJyZW50TW9udGg9KGxlYXA/TU9OVEhfREFZU19MRUFQOk1PTlRIX0RBWVNfUkVHVUxBUilbY3VycmVudE1vbnRoXTtpZihkYXlzPmRheXNJbkN1cnJlbnRNb250aC1uZXdEYXRlLmdldERhdGUoKSl7ZGF5cy09ZGF5c0luQ3VycmVudE1vbnRoLW5ld0RhdGUuZ2V0RGF0ZSgpKzE7bmV3RGF0ZS5zZXREYXRlKDEpO2lmKGN1cnJlbnRNb250aDwxMSl7bmV3RGF0ZS5zZXRNb250aChjdXJyZW50TW9udGgrMSl9ZWxzZXtuZXdEYXRlLnNldE1vbnRoKDApO25ld0RhdGUuc2V0RnVsbFllYXIobmV3RGF0ZS5nZXRGdWxsWWVhcigpKzEpfX1lbHNle25ld0RhdGUuc2V0RGF0ZShuZXdEYXRlLmdldERhdGUoKStkYXlzKTtyZXR1cm4gbmV3RGF0ZX19cmV0dXJuIG5ld0RhdGV9O3ZhciB3cml0ZUFycmF5VG9NZW1vcnk9KGFycmF5LGJ1ZmZlcik9PntIRUFQOC5zZXQoYXJyYXksYnVmZmVyKX07dmFyIF9zdHJmdGltZT0ocyxtYXhzaXplLGZvcm1hdCx0bSk9Pnt2YXIgdG1fem9uZT1IRUFQVTMyW3RtKzQwPj4yXTt2YXIgZGF0ZT17dG1fc2VjOkhFQVAzMlt0bT4+Ml0sdG1fbWluOkhFQVAzMlt0bSs0Pj4yXSx0bV9ob3VyOkhFQVAzMlt0bSs4Pj4yXSx0bV9tZGF5OkhFQVAzMlt0bSsxMj4+Ml0sdG1fbW9uOkhFQVAzMlt0bSsxNj4+Ml0sdG1feWVhcjpIRUFQMzJbdG0rMjA+PjJdLHRtX3dkYXk6SEVBUDMyW3RtKzI0Pj4yXSx0bV95ZGF5OkhFQVAzMlt0bSsyOD4+Ml0sdG1faXNkc3Q6SEVBUDMyW3RtKzMyPj4yXSx0bV9nbXRvZmY6SEVBUDMyW3RtKzM2Pj4yXSx0bV96b25lOnRtX3pvbmU/VVRGOFRvU3RyaW5nKHRtX3pvbmUpOiIifTt2YXIgcGF0dGVybj1VVEY4VG9TdHJpbmcoZm9ybWF0KTt2YXIgRVhQQU5TSU9OX1JVTEVTXzE9eyIlYyI6IiVhICViICVkICVIOiVNOiVTICVZIiwiJUQiOiIlbS8lZC8leSIsIiVGIjoiJVktJW0tJWQiLCIlaCI6IiViIiwiJXIiOiIlSTolTTolUyAlcCIsIiVSIjoiJUg6JU0iLCIlVCI6IiVIOiVNOiVTIiwiJXgiOiIlbS8lZC8leSIsIiVYIjoiJUg6JU06JVMiLCIlRWMiOiIlYyIsIiVFQyI6IiVDIiwiJUV4IjoiJW0vJWQvJXkiLCIlRVgiOiIlSDolTTolUyIsIiVFeSI6IiV5IiwiJUVZIjoiJVkiLCIlT2QiOiIlZCIsIiVPZSI6IiVlIiwiJU9IIjoiJUgiLCIlT0kiOiIlSSIsIiVPbSI6IiVtIiwiJU9NIjoiJU0iLCIlT1MiOiIlUyIsIiVPdSI6IiV1IiwiJU9VIjoiJVUiLCIlT1YiOiIlViIsIiVPdyI6IiV3IiwiJU9XIjoiJVciLCIlT3kiOiIleSJ9O2Zvcih2YXIgcnVsZSBpbiBFWFBBTlNJT05fUlVMRVNfMSl7cGF0dGVybj1wYXR0ZXJuLnJlcGxhY2UobmV3IFJlZ0V4cChydWxlLCJnIiksRVhQQU5TSU9OX1JVTEVTXzFbcnVsZV0pfXZhciBXRUVLREFZUz1bIlN1bmRheSIsIk1vbmRheSIsIlR1ZXNkYXkiLCJXZWRuZXNkYXkiLCJUaHVyc2RheSIsIkZyaWRheSIsIlNhdHVyZGF5Il07dmFyIE1PTlRIUz1bIkphbnVhcnkiLCJGZWJydWFyeSIsIk1hcmNoIiwiQXByaWwiLCJNYXkiLCJKdW5lIiwiSnVseSIsIkF1Z3VzdCIsIlNlcHRlbWJlciIsIk9jdG9iZXIiLCJOb3ZlbWJlciIsIkRlY2VtYmVyIl07ZnVuY3Rpb24gbGVhZGluZ1NvbWV0aGluZyh2YWx1ZSxkaWdpdHMsY2hhcmFjdGVyKXt2YXIgc3RyPXR5cGVvZiB2YWx1ZT09Im51bWJlciI/dmFsdWUudG9TdHJpbmcoKTp2YWx1ZXx8IiI7d2hpbGUoc3RyLmxlbmd0aDxkaWdpdHMpe3N0cj1jaGFyYWN0ZXJbMF0rc3RyfXJldHVybiBzdHJ9ZnVuY3Rpb24gbGVhZGluZ051bGxzKHZhbHVlLGRpZ2l0cyl7cmV0dXJuIGxlYWRpbmdTb21ldGhpbmcodmFsdWUsZGlnaXRzLCIwIil9ZnVuY3Rpb24gY29tcGFyZUJ5RGF5KGRhdGUxLGRhdGUyKXtmdW5jdGlvbiBzZ24odmFsdWUpe3JldHVybiB2YWx1ZTwwPy0xOnZhbHVlPjA/MTowfXZhciBjb21wYXJlO2lmKChjb21wYXJlPXNnbihkYXRlMS5nZXRGdWxsWWVhcigpLWRhdGUyLmdldEZ1bGxZZWFyKCkpKT09PTApe2lmKChjb21wYXJlPXNnbihkYXRlMS5nZXRNb250aCgpLWRhdGUyLmdldE1vbnRoKCkpKT09PTApe2NvbXBhcmU9c2duKGRhdGUxLmdldERhdGUoKS1kYXRlMi5nZXREYXRlKCkpfX1yZXR1cm4gY29tcGFyZX1mdW5jdGlvbiBnZXRGaXJzdFdlZWtTdGFydERhdGUoamFuRm91cnRoKXtzd2l0Y2goamFuRm91cnRoLmdldERheSgpKXtjYXNlIDA6cmV0dXJuIG5ldyBEYXRlKGphbkZvdXJ0aC5nZXRGdWxsWWVhcigpLTEsMTEsMjkpO2Nhc2UgMTpyZXR1cm4gamFuRm91cnRoO2Nhc2UgMjpyZXR1cm4gbmV3IERhdGUoamFuRm91cnRoLmdldEZ1bGxZZWFyKCksMCwzKTtjYXNlIDM6cmV0dXJuIG5ldyBEYXRlKGphbkZvdXJ0aC5nZXRGdWxsWWVhcigpLDAsMik7Y2FzZSA0OnJldHVybiBuZXcgRGF0ZShqYW5Gb3VydGguZ2V0RnVsbFllYXIoKSwwLDEpO2Nhc2UgNTpyZXR1cm4gbmV3IERhdGUoamFuRm91cnRoLmdldEZ1bGxZZWFyKCktMSwxMSwzMSk7Y2FzZSA2OnJldHVybiBuZXcgRGF0ZShqYW5Gb3VydGguZ2V0RnVsbFllYXIoKS0xLDExLDMwKX19ZnVuY3Rpb24gZ2V0V2Vla0Jhc2VkWWVhcihkYXRlKXt2YXIgdGhpc0RhdGU9YWRkRGF5cyhuZXcgRGF0ZShkYXRlLnRtX3llYXIrMTkwMCwwLDEpLGRhdGUudG1feWRheSk7dmFyIGphbkZvdXJ0aFRoaXNZZWFyPW5ldyBEYXRlKHRoaXNEYXRlLmdldEZ1bGxZZWFyKCksMCw0KTt2YXIgamFuRm91cnRoTmV4dFllYXI9bmV3IERhdGUodGhpc0RhdGUuZ2V0RnVsbFllYXIoKSsxLDAsNCk7dmFyIGZpcnN0V2Vla1N0YXJ0VGhpc1llYXI9Z2V0Rmlyc3RXZWVrU3RhcnREYXRlKGphbkZvdXJ0aFRoaXNZZWFyKTt2YXIgZmlyc3RXZWVrU3RhcnROZXh0WWVhcj1nZXRGaXJzdFdlZWtTdGFydERhdGUoamFuRm91cnRoTmV4dFllYXIpO2lmKGNvbXBhcmVCeURheShmaXJzdFdlZWtTdGFydFRoaXNZZWFyLHRoaXNEYXRlKTw9MCl7aWYoY29tcGFyZUJ5RGF5KGZpcnN0V2Vla1N0YXJ0TmV4dFllYXIsdGhpc0RhdGUpPD0wKXtyZXR1cm4gdGhpc0RhdGUuZ2V0RnVsbFllYXIoKSsxfXJldHVybiB0aGlzRGF0ZS5nZXRGdWxsWWVhcigpfXJldHVybiB0aGlzRGF0ZS5nZXRGdWxsWWVhcigpLTF9dmFyIEVYUEFOU0lPTl9SVUxFU18yPXsiJWEiOmRhdGU9PldFRUtEQVlTW2RhdGUudG1fd2RheV0uc3Vic3RyaW5nKDAsMyksIiVBIjpkYXRlPT5XRUVLREFZU1tkYXRlLnRtX3dkYXldLCIlYiI6ZGF0ZT0+TU9OVEhTW2RhdGUudG1fbW9uXS5zdWJzdHJpbmcoMCwzKSwiJUIiOmRhdGU9Pk1PTlRIU1tkYXRlLnRtX21vbl0sIiVDIjpkYXRlPT57dmFyIHllYXI9ZGF0ZS50bV95ZWFyKzE5MDA7cmV0dXJuIGxlYWRpbmdOdWxscyh5ZWFyLzEwMHwwLDIpfSwiJWQiOmRhdGU9PmxlYWRpbmdOdWxscyhkYXRlLnRtX21kYXksMiksIiVlIjpkYXRlPT5sZWFkaW5nU29tZXRoaW5nKGRhdGUudG1fbWRheSwyLCIgIiksIiVnIjpkYXRlPT5nZXRXZWVrQmFzZWRZZWFyKGRhdGUpLnRvU3RyaW5nKCkuc3Vic3RyaW5nKDIpLCIlRyI6ZGF0ZT0+Z2V0V2Vla0Jhc2VkWWVhcihkYXRlKSwiJUgiOmRhdGU9PmxlYWRpbmdOdWxscyhkYXRlLnRtX2hvdXIsMiksIiVJIjpkYXRlPT57dmFyIHR3ZWx2ZUhvdXI9ZGF0ZS50bV9ob3VyO2lmKHR3ZWx2ZUhvdXI9PTApdHdlbHZlSG91cj0xMjtlbHNlIGlmKHR3ZWx2ZUhvdXI+MTIpdHdlbHZlSG91ci09MTI7cmV0dXJuIGxlYWRpbmdOdWxscyh0d2VsdmVIb3VyLDIpfSwiJWoiOmRhdGU9PmxlYWRpbmdOdWxscyhkYXRlLnRtX21kYXkrYXJyYXlTdW0oaXNMZWFwWWVhcihkYXRlLnRtX3llYXIrMTkwMCk/TU9OVEhfREFZU19MRUFQOk1PTlRIX0RBWVNfUkVHVUxBUixkYXRlLnRtX21vbi0xKSwzKSwiJW0iOmRhdGU9PmxlYWRpbmdOdWxscyhkYXRlLnRtX21vbisxLDIpLCIlTSI6ZGF0ZT0+bGVhZGluZ051bGxzKGRhdGUudG1fbWluLDIpLCIlbiI6KCk9PiJcbiIsIiVwIjpkYXRlPT57aWYoZGF0ZS50bV9ob3VyPj0wJiZkYXRlLnRtX2hvdXI8MTIpe3JldHVybiJBTSJ9cmV0dXJuIlBNIn0sIiVTIjpkYXRlPT5sZWFkaW5nTnVsbHMoZGF0ZS50bV9zZWMsMiksIiV0IjooKT0+Ilx0IiwiJXUiOmRhdGU9PmRhdGUudG1fd2RheXx8NywiJVUiOmRhdGU9Pnt2YXIgZGF5cz1kYXRlLnRtX3lkYXkrNy1kYXRlLnRtX3dkYXk7cmV0dXJuIGxlYWRpbmdOdWxscyhNYXRoLmZsb29yKGRheXMvNyksMil9LCIlViI6ZGF0ZT0+e3ZhciB2YWw9TWF0aC5mbG9vcigoZGF0ZS50bV95ZGF5KzctKGRhdGUudG1fd2RheSs2KSU3KS83KTtpZigoZGF0ZS50bV93ZGF5KzM3MS1kYXRlLnRtX3lkYXktMiklNzw9Mil7dmFsKyt9aWYoIXZhbCl7dmFsPTUyO3ZhciBkZWMzMT0oZGF0ZS50bV93ZGF5KzctZGF0ZS50bV95ZGF5LTEpJTc7aWYoZGVjMzE9PTR8fGRlYzMxPT01JiZpc0xlYXBZZWFyKGRhdGUudG1feWVhciU0MDAtMSkpe3ZhbCsrfX1lbHNlIGlmKHZhbD09NTMpe3ZhciBqYW4xPShkYXRlLnRtX3dkYXkrMzcxLWRhdGUudG1feWRheSklNztpZihqYW4xIT00JiYoamFuMSE9M3x8IWlzTGVhcFllYXIoZGF0ZS50bV95ZWFyKSkpdmFsPTF9cmV0dXJuIGxlYWRpbmdOdWxscyh2YWwsMil9LCIldyI6ZGF0ZT0+ZGF0ZS50bV93ZGF5LCIlVyI6ZGF0ZT0+e3ZhciBkYXlzPWRhdGUudG1feWRheSs3LShkYXRlLnRtX3dkYXkrNiklNztyZXR1cm4gbGVhZGluZ051bGxzKE1hdGguZmxvb3IoZGF5cy83KSwyKX0sIiV5IjpkYXRlPT4oZGF0ZS50bV95ZWFyKzE5MDApLnRvU3RyaW5nKCkuc3Vic3RyaW5nKDIpLCIlWSI6ZGF0ZT0+ZGF0ZS50bV95ZWFyKzE5MDAsIiV6IjpkYXRlPT57dmFyIG9mZj1kYXRlLnRtX2dtdG9mZjt2YXIgYWhlYWQ9b2ZmPj0wO29mZj1NYXRoLmFicyhvZmYpLzYwO29mZj1vZmYvNjAqMTAwK29mZiU2MDtyZXR1cm4oYWhlYWQ/IisiOiItIikrU3RyaW5nKCIwMDAwIitvZmYpLnNsaWNlKC00KX0sIiVaIjpkYXRlPT5kYXRlLnRtX3pvbmUsIiUlIjooKT0+IiUifTtwYXR0ZXJuPXBhdHRlcm4ucmVwbGFjZSgvJSUvZywiXDBcMCIpO2Zvcih2YXIgcnVsZSBpbiBFWFBBTlNJT05fUlVMRVNfMil7aWYocGF0dGVybi5pbmNsdWRlcyhydWxlKSl7cGF0dGVybj1wYXR0ZXJuLnJlcGxhY2UobmV3IFJlZ0V4cChydWxlLCJnIiksRVhQQU5TSU9OX1JVTEVTXzJbcnVsZV0oZGF0ZSkpfX1wYXR0ZXJuPXBhdHRlcm4ucmVwbGFjZSgvXDBcMC9nLCIlIik7dmFyIGJ5dGVzPWludEFycmF5RnJvbVN0cmluZyhwYXR0ZXJuLGZhbHNlKTtpZihieXRlcy5sZW5ndGg+bWF4c2l6ZSl7cmV0dXJuIDB9d3JpdGVBcnJheVRvTWVtb3J5KGJ5dGVzLHMpO3JldHVybiBieXRlcy5sZW5ndGgtMX07dmFyIF9zdHJmdGltZV9sPShzLG1heHNpemUsZm9ybWF0LHRtLGxvYyk9Pl9zdHJmdGltZShzLG1heHNpemUsZm9ybWF0LHRtKTt2YXIgRlNOb2RlPWZ1bmN0aW9uKHBhcmVudCxuYW1lLG1vZGUscmRldil7aWYoIXBhcmVudCl7cGFyZW50PXRoaXN9dGhpcy5wYXJlbnQ9cGFyZW50O3RoaXMubW91bnQ9cGFyZW50Lm1vdW50O3RoaXMubW91bnRlZD1udWxsO3RoaXMuaWQ9RlMubmV4dElub2RlKys7dGhpcy5uYW1lPW5hbWU7dGhpcy5tb2RlPW1vZGU7dGhpcy5ub2RlX29wcz17fTt0aGlzLnN0cmVhbV9vcHM9e307dGhpcy5yZGV2PXJkZXZ9O3ZhciByZWFkTW9kZT0yOTJ8NzM7dmFyIHdyaXRlTW9kZT0xNDY7T2JqZWN0LmRlZmluZVByb3BlcnRpZXMoRlNOb2RlLnByb3RvdHlwZSx7cmVhZDp7Z2V0OmZ1bmN0aW9uKCl7cmV0dXJuKHRoaXMubW9kZSZyZWFkTW9kZSk9PT1yZWFkTW9kZX0sc2V0OmZ1bmN0aW9uKHZhbCl7dmFsP3RoaXMubW9kZXw9cmVhZE1vZGU6dGhpcy5tb2RlJj1+cmVhZE1vZGV9fSx3cml0ZTp7Z2V0OmZ1bmN0aW9uKCl7cmV0dXJuKHRoaXMubW9kZSZ3cml0ZU1vZGUpPT09d3JpdGVNb2RlfSxzZXQ6ZnVuY3Rpb24odmFsKXt2YWw/dGhpcy5tb2RlfD13cml0ZU1vZGU6dGhpcy5tb2RlJj1+d3JpdGVNb2RlfX0saXNGb2xkZXI6e2dldDpmdW5jdGlvbigpe3JldHVybiBGUy5pc0Rpcih0aGlzLm1vZGUpfX0saXNEZXZpY2U6e2dldDpmdW5jdGlvbigpe3JldHVybiBGUy5pc0NocmRldih0aGlzLm1vZGUpfX19KTtGUy5GU05vZGU9RlNOb2RlO0ZTLmNyZWF0ZVByZWxvYWRlZEZpbGU9RlNfY3JlYXRlUHJlbG9hZGVkRmlsZTtGUy5zdGF0aWNJbml0KCk7ZW1iaW5kX2luaXRfY2hhckNvZGVzKCk7QmluZGluZ0Vycm9yPU1vZHVsZVsiQmluZGluZ0Vycm9yIl09Y2xhc3MgQmluZGluZ0Vycm9yIGV4dGVuZHMgRXJyb3J7Y29uc3RydWN0b3IobWVzc2FnZSl7c3VwZXIobWVzc2FnZSk7dGhpcy5uYW1lPSJCaW5kaW5nRXJyb3IifX07SW50ZXJuYWxFcnJvcj1Nb2R1bGVbIkludGVybmFsRXJyb3IiXT1jbGFzcyBJbnRlcm5hbEVycm9yIGV4dGVuZHMgRXJyb3J7Y29uc3RydWN0b3IobWVzc2FnZSl7c3VwZXIobWVzc2FnZSk7dGhpcy5uYW1lPSJJbnRlcm5hbEVycm9yIn19O2luaXRfQ2xhc3NIYW5kbGUoKTtpbml0X2VtYmluZCgpO2luaXRfUmVnaXN0ZXJlZFBvaW50ZXIoKTtVbmJvdW5kVHlwZUVycm9yPU1vZHVsZVsiVW5ib3VuZFR5cGVFcnJvciJdPWV4dGVuZEVycm9yKEVycm9yLCJVbmJvdW5kVHlwZUVycm9yIik7aGFuZGxlQWxsb2NhdG9ySW5pdCgpO2luaXRfZW12YWwoKTt2YXIgd2FzbUltcG9ydHM9e2E6X19fYXNzZXJ0X2ZhaWwsdDpfX19jeGFfYmVnaW5fY2F0Y2gsczpfX19jeGFfZW5kX2NhdGNoLGM6X19fY3hhX2ZpbmRfbWF0Y2hpbmdfY2F0Y2hfMixqOl9fX2N4YV9maW5kX21hdGNoaW5nX2NhdGNoXzMsb2E6X19fY3hhX3JldGhyb3csbTpfX19jeGFfdGhyb3csZzpfX19yZXN1bWVFeGNlcHRpb24sZWE6X19fc3lzY2FsbF9mc3RhdDY0LFI6X19fc3lzY2FsbF9mdHJ1bmNhdGU2NCxjYTpfX19zeXNjYWxsX25ld2ZzdGF0YXQsZmE6X19fc3lzY2FsbF9vcGVuYXQsXzpfX19zeXNjYWxsX3JlYWRsaW5rYXQsWjpfX19zeXNjYWxsX3JlbmFtZWF0LGRhOl9fX3N5c2NhbGxfc3RhdDY0LFg6X19fc3lzY2FsbF91bmxpbmthdCxTOl9fZW1iaW5kX3JlZ2lzdGVyX2JpZ2ludCxqYTpfX2VtYmluZF9yZWdpc3Rlcl9ib29sLE46X19lbWJpbmRfcmVnaXN0ZXJfY2xhc3MsTTpfX2VtYmluZF9yZWdpc3Rlcl9jbGFzc19jb25zdHJ1Y3RvcixsOl9fZW1iaW5kX3JlZ2lzdGVyX2NsYXNzX2Z1bmN0aW9uLGlhOl9fZW1iaW5kX3JlZ2lzdGVyX2VtdmFsLEg6X19lbWJpbmRfcmVnaXN0ZXJfZmxvYXQsbzpfX2VtYmluZF9yZWdpc3Rlcl9pbnRlZ2VyLGs6X19lbWJpbmRfcmVnaXN0ZXJfbWVtb3J5X3ZpZXcsRzpfX2VtYmluZF9yZWdpc3Rlcl9zdGRfc3RyaW5nLHo6X19lbWJpbmRfcmVnaXN0ZXJfc3RkX3dzdHJpbmcsa2E6X19lbWJpbmRfcmVnaXN0ZXJfdm9pZCxnYTpfX2Vtc2NyaXB0ZW5fZ2V0X25vd19pc19tb25vdG9uaWMsc2E6X19lbXZhbF9kZWNyZWYsdGE6X19lbXZhbF9pbmNyZWYscTpfX2VtdmFsX3Rha2VfdmFsdWUsTzpfX21tYXBfanMsUDpfX211bm1hcF9qcyxiOl9hYm9ydCxFOl9lbXNjcmlwdGVuX2RhdGVfbm93LFk6X2Vtc2NyaXB0ZW5fZ2V0X2hlYXBfbWF4LHc6X2Vtc2NyaXB0ZW5fZ2V0X25vdyxoYTpfZW1zY3JpcHRlbl9tZW1jcHlfanMsVzpfZW1zY3JpcHRlbl9yZXNpemVfaGVhcCwkOl9lbnZpcm9uX2dldCxhYTpfZW52aXJvbl9zaXplc19nZXQsbGE6X2V4aXQsRjpfZmRfY2xvc2UsRDpfZmRfcmVhZCxROl9mZF9zZWVrLGJhOl9mZF9zeW5jLHk6X2ZkX3dyaXRlLFU6X2dldGVudHJvcHkscmE6aW52b2tlX2ZpLEM6aW52b2tlX2ksZjppbnZva2VfaWksbmE6aW52b2tlX2lpZGlpLHFhOmludm9rZV9paWYsZDppbnZva2VfaWlpLGU6aW52b2tlX2lpaWksQjppbnZva2VfaWlpaWksdjppbnZva2VfaWlpaWlpLEs6aW52b2tlX2lpaWlpaWksVDppbnZva2VfaWlqLHA6aW52b2tlX3YsaTppbnZva2VfdmksaDppbnZva2VfdmlpLHI6aW52b2tlX3ZpaWQsQTppbnZva2VfdmlpZGksbjppbnZva2VfdmlpaSxwYTppbnZva2VfdmlpaWRpaWksTDppbnZva2VfdmlpaWksSTppbnZva2VfdmlpaWlkaSxKOmludm9rZV92aWlpaWksdTppbnZva2VfdmlpaWlpaWlkaSx4Omludm9rZV92aWlpaWlpaWksVjpfc3RyZnRpbWVfbCxtYTp4bm5Mb2FkV2FzbU1vZHVsZUpTfTt2YXIgd2FzbUV4cG9ydHM9Y3JlYXRlV2FzbSgpO3ZhciBfX193YXNtX2NhbGxfY3RvcnM9KCk9PihfX193YXNtX2NhbGxfY3RvcnM9d2FzbUV4cG9ydHNbInZhIl0pKCk7dmFyIF9tYWxsb2M9YTA9PihfbWFsbG9jPXdhc21FeHBvcnRzWyJ4YSJdKShhMCk7dmFyIF9mcmVlPWEwPT4oX2ZyZWU9d2FzbUV4cG9ydHNbInlhIl0pKGEwKTt2YXIgX19fZXJybm9fbG9jYXRpb249KCk9PihfX19lcnJub19sb2NhdGlvbj13YXNtRXhwb3J0c1siemEiXSkoKTt2YXIgX19fZ2V0VHlwZU5hbWU9YTA9PihfX19nZXRUeXBlTmFtZT13YXNtRXhwb3J0c1siQWEiXSkoYTApO3ZhciBfX19mdW5jc19vbl9leGl0PSgpPT4oX19fZnVuY3Nfb25fZXhpdD13YXNtRXhwb3J0c1siQmEiXSkoKTt2YXIgX2ZmbHVzaD1Nb2R1bGVbIl9mZmx1c2giXT1hMD0+KF9mZmx1c2g9TW9kdWxlWyJfZmZsdXNoIl09d2FzbUV4cG9ydHNbIkNhIl0pKGEwKTt2YXIgX2Vtc2NyaXB0ZW5fYnVpbHRpbl9tZW1hbGlnbj0oYTAsYTEpPT4oX2Vtc2NyaXB0ZW5fYnVpbHRpbl9tZW1hbGlnbj13YXNtRXhwb3J0c1siRGEiXSkoYTAsYTEpO3ZhciBfc2V0VGhyZXc9KGEwLGExKT0+KF9zZXRUaHJldz13YXNtRXhwb3J0c1siRWEiXSkoYTAsYTEpO3ZhciBzZXRUZW1wUmV0MD1hMD0+KHNldFRlbXBSZXQwPXdhc21FeHBvcnRzWyJGYSJdKShhMCk7dmFyIHN0YWNrU2F2ZT0oKT0+KHN0YWNrU2F2ZT13YXNtRXhwb3J0c1siR2EiXSkoKTt2YXIgc3RhY2tSZXN0b3JlPWEwPT4oc3RhY2tSZXN0b3JlPXdhc21FeHBvcnRzWyJIYSJdKShhMCk7dmFyIF9fX2N4YV9kZWNyZW1lbnRfZXhjZXB0aW9uX3JlZmNvdW50PWEwPT4oX19fY3hhX2RlY3JlbWVudF9leGNlcHRpb25fcmVmY291bnQ9d2FzbUV4cG9ydHNbIklhIl0pKGEwKTt2YXIgX19fY3hhX2luY3JlbWVudF9leGNlcHRpb25fcmVmY291bnQ9YTA9PihfX19jeGFfaW5jcmVtZW50X2V4Y2VwdGlvbl9yZWZjb3VudD13YXNtRXhwb3J0c1siSmEiXSkoYTApO3ZhciBfX19jeGFfY2FuX2NhdGNoPShhMCxhMSxhMik9PihfX19jeGFfY2FuX2NhdGNoPXdhc21FeHBvcnRzWyJLYSJdKShhMCxhMSxhMik7dmFyIF9fX2N4YV9pc19wb2ludGVyX3R5cGU9YTA9PihfX19jeGFfaXNfcG9pbnRlcl90eXBlPXdhc21FeHBvcnRzWyJMYSJdKShhMCk7dmFyIGR5bkNhbGxfdmlpamo9TW9kdWxlWyJkeW5DYWxsX3ZpaWpqIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2KT0+KGR5bkNhbGxfdmlpamo9TW9kdWxlWyJkeW5DYWxsX3ZpaWpqIl09d2FzbUV4cG9ydHNbIk1hIl0pKGEwLGExLGEyLGEzLGE0LGE1LGE2KTt2YXIgZHluQ2FsbF92aWlpampqPU1vZHVsZVsiZHluQ2FsbF92aWlpampqIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3LGE4LGE5KT0+KGR5bkNhbGxfdmlpaWpqaj1Nb2R1bGVbImR5bkNhbGxfdmlpaWpqaiJdPXdhc21FeHBvcnRzWyJOYSJdKShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCxhOSk7dmFyIGR5bkNhbGxfaWlpaWo9TW9kdWxlWyJkeW5DYWxsX2lpaWlqIl09KGEwLGExLGEyLGEzLGE0LGE1KT0+KGR5bkNhbGxfaWlpaWo9TW9kdWxlWyJkeW5DYWxsX2lpaWlqIl09d2FzbUV4cG9ydHNbIk9hIl0pKGEwLGExLGEyLGEzLGE0LGE1KTt2YXIgZHluQ2FsbF9qaWk9TW9kdWxlWyJkeW5DYWxsX2ppaSJdPShhMCxhMSxhMik9PihkeW5DYWxsX2ppaT1Nb2R1bGVbImR5bkNhbGxfamlpIl09d2FzbUV4cG9ydHNbIlBhIl0pKGEwLGExLGEyKTt2YXIgZHluQ2FsbF9qamo9TW9kdWxlWyJkeW5DYWxsX2pqaiJdPShhMCxhMSxhMixhMyxhNCk9PihkeW5DYWxsX2pqaj1Nb2R1bGVbImR5bkNhbGxfampqIl09d2FzbUV4cG9ydHNbIlFhIl0pKGEwLGExLGEyLGEzLGE0KTt2YXIgZHluQ2FsbF9paWlpamo9TW9kdWxlWyJkeW5DYWxsX2lpaWlqaiJdPShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyk9PihkeW5DYWxsX2lpaWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpaWpqIl09d2FzbUV4cG9ydHNbIlJhIl0pKGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3KTt2YXIgZHluQ2FsbF92aWlqamk9TW9kdWxlWyJkeW5DYWxsX3ZpaWpqaSJdPShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyk9PihkeW5DYWxsX3ZpaWpqaT1Nb2R1bGVbImR5bkNhbGxfdmlpamppIl09d2FzbUV4cG9ydHNbIlNhIl0pKGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3KTt2YXIgZHluQ2FsbF9paWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpamoiXT0oYTAsYTEsYTIsYTMsYTQsYTUsYTYpPT4oZHluQ2FsbF9paWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpamoiXT13YXNtRXhwb3J0c1siVGEiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYpO3ZhciBkeW5DYWxsX3ZpaWpqaj1Nb2R1bGVbImR5bkNhbGxfdmlpampqIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3LGE4KT0+KGR5bkNhbGxfdmlpampqPU1vZHVsZVsiZHluQ2FsbF92aWlqamoiXT13YXNtRXhwb3J0c1siVWEiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgpO3ZhciBkeW5DYWxsX2lpaj1Nb2R1bGVbImR5bkNhbGxfaWlqIl09KGEwLGExLGEyLGEzKT0+KGR5bkNhbGxfaWlqPU1vZHVsZVsiZHluQ2FsbF9paWoiXT13YXNtRXhwb3J0c1siVmEiXSkoYTAsYTEsYTIsYTMpO3ZhciBkeW5DYWxsX2lpamppaWlpPU1vZHVsZVsiZHluQ2FsbF9paWpqaWlpaSJdPShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCxhOSk9PihkeW5DYWxsX2lpamppaWlpPU1vZHVsZVsiZHluQ2FsbF9paWpqaWlpaSJdPXdhc21FeHBvcnRzWyJXYSJdKShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCxhOSk7dmFyIGR5bkNhbGxfamlqaT1Nb2R1bGVbImR5bkNhbGxfamlqaSJdPShhMCxhMSxhMixhMyxhNCk9PihkeW5DYWxsX2ppamk9TW9kdWxlWyJkeW5DYWxsX2ppamkiXT13YXNtRXhwb3J0c1siWGEiXSkoYTAsYTEsYTIsYTMsYTQpO3ZhciBkeW5DYWxsX3ZpaWppaT1Nb2R1bGVbImR5bkNhbGxfdmlpamlpIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2KT0+KGR5bkNhbGxfdmlpamlpPU1vZHVsZVsiZHluQ2FsbF92aWlqaWkiXT13YXNtRXhwb3J0c1siWWEiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYpO3ZhciBkeW5DYWxsX2lpaWlpaj1Nb2R1bGVbImR5bkNhbGxfaWlpaWlqIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2KT0+KGR5bkNhbGxfaWlpaWlqPU1vZHVsZVsiZHluQ2FsbF9paWlpaWoiXT13YXNtRXhwb3J0c1siWmEiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYpO3ZhciBkeW5DYWxsX2lpaWlpamo9TW9kdWxlWyJkeW5DYWxsX2lpaWlpamoiXT0oYTAsYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgpPT4oZHluQ2FsbF9paWlpaWpqPU1vZHVsZVsiZHluQ2FsbF9paWlpaWpqIl09d2FzbUV4cG9ydHNbIl9hIl0pKGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3LGE4KTt2YXIgZHluQ2FsbF9paWlpaWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpaWlpamoiXT0oYTAsYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgsYTkpPT4oZHluQ2FsbF9paWlpaWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpaWlpamoiXT13YXNtRXhwb3J0c1siJGEiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgsYTkpO3ZhciBfX19zdGFydF9lbV9qcz1Nb2R1bGVbIl9fX3N0YXJ0X2VtX2pzIl09MjYxNDYwO3ZhciBfX19zdG9wX2VtX2pzPU1vZHVsZVsiX19fc3RvcF9lbV9qcyJdPTI2MjA3MjtmdW5jdGlvbiBpbnZva2VfaWkoaW5kZXgsYTEpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWkoaW5kZXgsYTEsYTIpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMil9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV92aWkoaW5kZXgsYTEsYTIpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7Z2V0V2FzbVRhYmxlRW50cnkoaW5kZXgpKGExLGEyKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX3ZpKGluZGV4LGExKXt2YXIgc3A9c3RhY2tTYXZlKCk7dHJ5e2dldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWlpaWkoaW5kZXgsYTEsYTIsYTMsYTQsYTUpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMixhMyxhNCxhNSl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWlpKGluZGV4LGExLGEyLGEzKXt2YXIgc3A9c3RhY2tTYXZlKCk7dHJ5e3JldHVybiBnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfaShpbmRleCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtyZXR1cm4gZ2V0V2FzbVRhYmxlRW50cnkoaW5kZXgpKCl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV92aWlpaShpbmRleCxhMSxhMixhMyxhNCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfZmkoaW5kZXgsYTEpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWYoaW5kZXgsYTEsYTIpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMil9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWlpaWlpKGluZGV4LGExLGEyLGEzLGE0LGE1LGE2KXt2YXIgc3A9c3RhY2tTYXZlKCk7dHJ5e3JldHVybiBnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUsYTYpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdihpbmRleCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX3ZpaWlpaShpbmRleCxhMSxhMixhMyxhNCxhNSl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdmlpaWlpaWlkaShpbmRleCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCxhOSl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgsYTkpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdmlpaShpbmRleCxhMSxhMixhMyl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdmlpaWlkaShpbmRleCxhMSxhMixhMyxhNCxhNSxhNil7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUsYTYpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdmlpaWRpaWkoaW5kZXgsYTEsYTIsYTMsYTQsYTUsYTYsYTcpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7Z2V0V2FzbVRhYmxlRW50cnkoaW5kZXgpKGExLGEyLGEzLGE0LGE1LGE2LGE3KX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX3ZpaWQoaW5kZXgsYTEsYTIsYTMpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7Z2V0V2FzbVRhYmxlRW50cnkoaW5kZXgpKGExLGEyLGEzKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX3ZpaWlpaWlpaShpbmRleCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfaWlpaWkoaW5kZXgsYTEsYTIsYTMsYTQpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMixhMyxhNCl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV92aWlkaShpbmRleCxhMSxhMixhMyxhNCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfaWlkaWkoaW5kZXgsYTEsYTIsYTMsYTQpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMixhMyxhNCl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWooaW5kZXgsYTEsYTIsYTMpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGR5bkNhbGxfaWlqKGluZGV4LGExLGEyLGEzKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19dmFyIGNhbGxlZFJ1bjtkZXBlbmRlbmNpZXNGdWxmaWxsZWQ9ZnVuY3Rpb24gcnVuQ2FsbGVyKCl7aWYoIWNhbGxlZFJ1bilydW4oKTtpZighY2FsbGVkUnVuKWRlcGVuZGVuY2llc0Z1bGZpbGxlZD1ydW5DYWxsZXJ9O2Z1bmN0aW9uIHJ1bigpe2lmKHJ1bkRlcGVuZGVuY2llcz4wKXtyZXR1cm59cHJlUnVuKCk7aWYocnVuRGVwZW5kZW5jaWVzPjApe3JldHVybn1mdW5jdGlvbiBkb1J1bigpe2lmKGNhbGxlZFJ1bilyZXR1cm47Y2FsbGVkUnVuPXRydWU7TW9kdWxlWyJjYWxsZWRSdW4iXT10cnVlO2lmKEFCT1JUKXJldHVybjtpbml0UnVudGltZSgpO3JlYWR5UHJvbWlzZVJlc29sdmUoTW9kdWxlKTtpZihNb2R1bGVbIm9uUnVudGltZUluaXRpYWxpemVkIl0pTW9kdWxlWyJvblJ1bnRpbWVJbml0aWFsaXplZCJdKCk7cG9zdFJ1bigpfWlmKE1vZHVsZVsic2V0U3RhdHVzIl0pe01vZHVsZVsic2V0U3RhdHVzIl0oIlJ1bm5pbmcuLi4iKTtzZXRUaW1lb3V0KGZ1bmN0aW9uKCl7c2V0VGltZW91dChmdW5jdGlvbigpe01vZHVsZVsic2V0U3RhdHVzIl0oIiIpfSwxKTtkb1J1bigpfSwxKX1lbHNle2RvUnVuKCl9fWlmKE1vZHVsZVsicHJlSW5pdCJdKXtpZih0eXBlb2YgTW9kdWxlWyJwcmVJbml0Il09PSJmdW5jdGlvbiIpTW9kdWxlWyJwcmVJbml0Il09W01vZHVsZVsicHJlSW5pdCJdXTt3aGlsZShNb2R1bGVbInByZUluaXQiXS5sZW5ndGg+MCl7TW9kdWxlWyJwcmVJbml0Il0ucG9wKCkoKX19cnVuKCk7CgoKICByZXR1cm4gbW9kdWxlQXJnLnJlYWR5Cn0KKTsKfSkoKTsKOwpjcmVhdGVXYXNtTW9ub0luc3RhbmNlID0gTW9kdWxlOyB9ICAgIAogICAgCiAgICAgICAgICAgIGxldCBjcmVhdGVXYXNtTXVsdGlJbnN0YW5jZTsgewoKdmFyIE1vZHVsZSA9ICgoKSA9PiB7CiAgdmFyIF9zY3JpcHREaXIgPSBsb2NhdGlvbi5ocmVmOwogIAogIHJldHVybiAoCmZ1bmN0aW9uKG1vZHVsZUFyZyA9IHt9KSB7Cgp2YXIgTW9kdWxlPW1vZHVsZUFyZzt2YXIgcmVhZHlQcm9taXNlUmVzb2x2ZSxyZWFkeVByb21pc2VSZWplY3Q7TW9kdWxlWyJyZWFkeSJdPW5ldyBQcm9taXNlKChyZXNvbHZlLHJlamVjdCk9PntyZWFkeVByb21pc2VSZXNvbHZlPXJlc29sdmU7cmVhZHlQcm9taXNlUmVqZWN0PXJlamVjdH0pO3ZhciBtb2R1bGVPdmVycmlkZXM9T2JqZWN0LmFzc2lnbih7fSxNb2R1bGUpO3ZhciBhcmd1bWVudHNfPVtdO3ZhciB0aGlzUHJvZ3JhbT0iLi90aGlzLnByb2dyYW0iO3ZhciBxdWl0Xz0oc3RhdHVzLHRvVGhyb3cpPT57dGhyb3cgdG9UaHJvd307dmFyIEVOVklST05NRU5UX0lTX1dFQj10eXBlb2Ygd2luZG93PT0ib2JqZWN0Ijt2YXIgRU5WSVJPTk1FTlRfSVNfV09SS0VSPXR5cGVvZiBpbXBvcnRTY3JpcHRzPT0iZnVuY3Rpb24iO3ZhciBFTlZJUk9OTUVOVF9JU19OT0RFPXR5cGVvZiBwcm9jZXNzPT0ib2JqZWN0IiYmdHlwZW9mIHByb2Nlc3MudmVyc2lvbnM9PSJvYmplY3QiJiZ0eXBlb2YgcHJvY2Vzcy52ZXJzaW9ucy5ub2RlPT0ic3RyaW5nIjt2YXIgRU5WSVJPTk1FTlRfSVNfUFRIUkVBRD1Nb2R1bGVbIkVOVklST05NRU5UX0lTX1BUSFJFQUQiXXx8ZmFsc2U7dmFyIHNjcmlwdERpcmVjdG9yeT0iIjtmdW5jdGlvbiBsb2NhdGVGaWxlKHBhdGgpe2lmKE1vZHVsZVsibG9jYXRlRmlsZSJdKXtyZXR1cm4gTW9kdWxlWyJsb2NhdGVGaWxlIl0ocGF0aCxzY3JpcHREaXJlY3RvcnkpfXJldHVybiBzY3JpcHREaXJlY3RvcnkrcGF0aH12YXIgcmVhZF8scmVhZEFzeW5jLHJlYWRCaW5hcnk7aWYoRU5WSVJPTk1FTlRfSVNfV0VCfHxFTlZJUk9OTUVOVF9JU19XT1JLRVIpe2lmKEVOVklST05NRU5UX0lTX1dPUktFUil7c2NyaXB0RGlyZWN0b3J5PXNlbGYubG9jYXRpb24uaHJlZn1lbHNlIGlmKHR5cGVvZiBkb2N1bWVudCE9InVuZGVmaW5lZCImJmRvY3VtZW50LmN1cnJlbnRTY3JpcHQpe3NjcmlwdERpcmVjdG9yeT1kb2N1bWVudC5jdXJyZW50U2NyaXB0LnNyY31pZihfc2NyaXB0RGlyKXtzY3JpcHREaXJlY3Rvcnk9X3NjcmlwdERpcn1pZihzY3JpcHREaXJlY3RvcnkuaW5kZXhPZigiYmxvYjoiKSE9PTApe3NjcmlwdERpcmVjdG9yeT1zY3JpcHREaXJlY3Rvcnkuc3Vic3RyKDAsc2NyaXB0RGlyZWN0b3J5LnJlcGxhY2UoL1s/I10uKi8sIiIpLmxhc3RJbmRleE9mKCIvIikrMSl9ZWxzZXtzY3JpcHREaXJlY3Rvcnk9IiJ9e3JlYWRfPXVybD0+e3ZhciB4aHI9bmV3IFhNTEh0dHBSZXF1ZXN0O3hoci5vcGVuKCJHRVQiLHVybCxmYWxzZSk7eGhyLnNlbmQobnVsbCk7cmV0dXJuIHhoci5yZXNwb25zZVRleHR9O2lmKEVOVklST05NRU5UX0lTX1dPUktFUil7cmVhZEJpbmFyeT11cmw9Pnt2YXIgeGhyPW5ldyBYTUxIdHRwUmVxdWVzdDt4aHIub3BlbigiR0VUIix1cmwsZmFsc2UpO3hoci5yZXNwb25zZVR5cGU9ImFycmF5YnVmZmVyIjt4aHIuc2VuZChudWxsKTtyZXR1cm4gbmV3IFVpbnQ4QXJyYXkoeGhyLnJlc3BvbnNlKX19cmVhZEFzeW5jPSh1cmwsb25sb2FkLG9uZXJyb3IpPT57dmFyIHhocj1uZXcgWE1MSHR0cFJlcXVlc3Q7eGhyLm9wZW4oIkdFVCIsdXJsLHRydWUpO3hoci5yZXNwb25zZVR5cGU9ImFycmF5YnVmZmVyIjt4aHIub25sb2FkPSgpPT57aWYoeGhyLnN0YXR1cz09MjAwfHx4aHIuc3RhdHVzPT0wJiZ4aHIucmVzcG9uc2Upe29ubG9hZCh4aHIucmVzcG9uc2UpO3JldHVybn1vbmVycm9yKCl9O3hoci5vbmVycm9yPW9uZXJyb3I7eGhyLnNlbmQobnVsbCl9fX1lbHNle312YXIgb3V0PU1vZHVsZVsicHJpbnQiXXx8Y29uc29sZS5sb2cuYmluZChjb25zb2xlKTt2YXIgZXJyPU1vZHVsZVsicHJpbnRFcnIiXXx8Y29uc29sZS5lcnJvci5iaW5kKGNvbnNvbGUpO09iamVjdC5hc3NpZ24oTW9kdWxlLG1vZHVsZU92ZXJyaWRlcyk7bW9kdWxlT3ZlcnJpZGVzPW51bGw7aWYoTW9kdWxlWyJhcmd1bWVudHMiXSlhcmd1bWVudHNfPU1vZHVsZVsiYXJndW1lbnRzIl07aWYoTW9kdWxlWyJ0aGlzUHJvZ3JhbSJdKXRoaXNQcm9ncmFtPU1vZHVsZVsidGhpc1Byb2dyYW0iXTtpZihNb2R1bGVbInF1aXQiXSlxdWl0Xz1Nb2R1bGVbInF1aXQiXTt2YXIgd2FzbUJpbmFyeTtpZihNb2R1bGVbIndhc21CaW5hcnkiXSl3YXNtQmluYXJ5PU1vZHVsZVsid2FzbUJpbmFyeSJdO2lmKHR5cGVvZiBXZWJBc3NlbWJseSE9Im9iamVjdCIpe2Fib3J0KCJubyBuYXRpdmUgd2FzbSBzdXBwb3J0IGRldGVjdGVkIil9dmFyIHdhc21NZW1vcnk7dmFyIHdhc21Nb2R1bGU7dmFyIEFCT1JUPWZhbHNlO3ZhciBFWElUU1RBVFVTO2Z1bmN0aW9uIGFzc2VydChjb25kaXRpb24sdGV4dCl7aWYoIWNvbmRpdGlvbil7YWJvcnQodGV4dCl9fXZhciBIRUFQOCxIRUFQVTgsSEVBUDE2LEhFQVBVMTYsSEVBUDMyLEhFQVBVMzIsSEVBUEYzMixIRUFQRjY0O2Z1bmN0aW9uIHVwZGF0ZU1lbW9yeVZpZXdzKCl7dmFyIGI9d2FzbU1lbW9yeS5idWZmZXI7TW9kdWxlWyJIRUFQOCJdPUhFQVA4PW5ldyBJbnQ4QXJyYXkoYik7TW9kdWxlWyJIRUFQMTYiXT1IRUFQMTY9bmV3IEludDE2QXJyYXkoYik7TW9kdWxlWyJIRUFQVTgiXT1IRUFQVTg9bmV3IFVpbnQ4QXJyYXkoYik7TW9kdWxlWyJIRUFQVTE2Il09SEVBUFUxNj1uZXcgVWludDE2QXJyYXkoYik7TW9kdWxlWyJIRUFQMzIiXT1IRUFQMzI9bmV3IEludDMyQXJyYXkoYik7TW9kdWxlWyJIRUFQVTMyIl09SEVBUFUzMj1uZXcgVWludDMyQXJyYXkoYik7TW9kdWxlWyJIRUFQRjMyIl09SEVBUEYzMj1uZXcgRmxvYXQzMkFycmF5KGIpO01vZHVsZVsiSEVBUEY2NCJdPUhFQVBGNjQ9bmV3IEZsb2F0NjRBcnJheShiKX12YXIgSU5JVElBTF9NRU1PUlk9TW9kdWxlWyJJTklUSUFMX01FTU9SWSJdfHwxMzQyMTc3Mjg7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRCl7d2FzbU1lbW9yeT1Nb2R1bGVbIndhc21NZW1vcnkiXX1lbHNle2lmKE1vZHVsZVsid2FzbU1lbW9yeSJdKXt3YXNtTWVtb3J5PU1vZHVsZVsid2FzbU1lbW9yeSJdfWVsc2V7d2FzbU1lbW9yeT1uZXcgV2ViQXNzZW1ibHkuTWVtb3J5KHsiaW5pdGlhbCI6SU5JVElBTF9NRU1PUlkvNjU1MzYsIm1heGltdW0iOklOSVRJQUxfTUVNT1JZLzY1NTM2LCJzaGFyZWQiOnRydWV9KTtpZighKHdhc21NZW1vcnkuYnVmZmVyIGluc3RhbmNlb2YgU2hhcmVkQXJyYXlCdWZmZXIpKXtlcnIoInJlcXVlc3RlZCBhIHNoYXJlZCBXZWJBc3NlbWJseS5NZW1vcnkgYnV0IHRoZSByZXR1cm5lZCBidWZmZXIgaXMgbm90IGEgU2hhcmVkQXJyYXlCdWZmZXIsIGluZGljYXRpbmcgdGhhdCB3aGlsZSB0aGUgYnJvd3NlciBoYXMgU2hhcmVkQXJyYXlCdWZmZXIgaXQgZG9lcyBub3QgaGF2ZSBXZWJBc3NlbWJseSB0aHJlYWRzIHN1cHBvcnQgLSB5b3UgbWF5IG5lZWQgdG8gc2V0IGEgZmxhZyIpO2lmKEVOVklST05NRU5UX0lTX05PREUpe2VycigiKG9uIG5vZGUgeW91IG1heSBuZWVkOiAtLWV4cGVyaW1lbnRhbC13YXNtLXRocmVhZHMgLS1leHBlcmltZW50YWwtd2FzbS1idWxrLW1lbW9yeSBhbmQvb3IgcmVjZW50IHZlcnNpb24pIil9dGhyb3cgRXJyb3IoImJhZCBtZW1vcnkiKX19fXVwZGF0ZU1lbW9yeVZpZXdzKCk7SU5JVElBTF9NRU1PUlk9d2FzbU1lbW9yeS5idWZmZXIuYnl0ZUxlbmd0aDt2YXIgX19BVFBSRVJVTl9fPVtdO3ZhciBfX0FUSU5JVF9fPVtdO3ZhciBfX0FURVhJVF9fPVtdO3ZhciBfX0FUUE9TVFJVTl9fPVtdO3ZhciBydW50aW1lSW5pdGlhbGl6ZWQ9ZmFsc2U7dmFyIHJ1bnRpbWVFeGl0ZWQ9ZmFsc2U7ZnVuY3Rpb24gcHJlUnVuKCl7aWYoTW9kdWxlWyJwcmVSdW4iXSl7aWYodHlwZW9mIE1vZHVsZVsicHJlUnVuIl09PSJmdW5jdGlvbiIpTW9kdWxlWyJwcmVSdW4iXT1bTW9kdWxlWyJwcmVSdW4iXV07d2hpbGUoTW9kdWxlWyJwcmVSdW4iXS5sZW5ndGgpe2FkZE9uUHJlUnVuKE1vZHVsZVsicHJlUnVuIl0uc2hpZnQoKSl9fWNhbGxSdW50aW1lQ2FsbGJhY2tzKF9fQVRQUkVSVU5fXyl9ZnVuY3Rpb24gaW5pdFJ1bnRpbWUoKXtydW50aW1lSW5pdGlhbGl6ZWQ9dHJ1ZTtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybjtpZighTW9kdWxlWyJub0ZTSW5pdCJdJiYhRlMuaW5pdC5pbml0aWFsaXplZClGUy5pbml0KCk7RlMuaWdub3JlUGVybWlzc2lvbnM9ZmFsc2U7VFRZLmluaXQoKTtjYWxsUnVudGltZUNhbGxiYWNrcyhfX0FUSU5JVF9fKX1mdW5jdGlvbiBleGl0UnVudGltZSgpe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpcmV0dXJuO19fX2Z1bmNzX29uX2V4aXQoKTtjYWxsUnVudGltZUNhbGxiYWNrcyhfX0FURVhJVF9fKTtGUy5xdWl0KCk7VFRZLnNodXRkb3duKCk7UFRocmVhZC50ZXJtaW5hdGVBbGxUaHJlYWRzKCk7cnVudGltZUV4aXRlZD10cnVlfWZ1bmN0aW9uIHBvc3RSdW4oKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybjtpZihNb2R1bGVbInBvc3RSdW4iXSl7aWYodHlwZW9mIE1vZHVsZVsicG9zdFJ1biJdPT0iZnVuY3Rpb24iKU1vZHVsZVsicG9zdFJ1biJdPVtNb2R1bGVbInBvc3RSdW4iXV07d2hpbGUoTW9kdWxlWyJwb3N0UnVuIl0ubGVuZ3RoKXthZGRPblBvc3RSdW4oTW9kdWxlWyJwb3N0UnVuIl0uc2hpZnQoKSl9fWNhbGxSdW50aW1lQ2FsbGJhY2tzKF9fQVRQT1NUUlVOX18pfWZ1bmN0aW9uIGFkZE9uUHJlUnVuKGNiKXtfX0FUUFJFUlVOX18udW5zaGlmdChjYil9ZnVuY3Rpb24gYWRkT25Jbml0KGNiKXtfX0FUSU5JVF9fLnVuc2hpZnQoY2IpfWZ1bmN0aW9uIGFkZE9uUG9zdFJ1bihjYil7X19BVFBPU1RSVU5fXy51bnNoaWZ0KGNiKX12YXIgcnVuRGVwZW5kZW5jaWVzPTA7dmFyIHJ1bkRlcGVuZGVuY3lXYXRjaGVyPW51bGw7dmFyIGRlcGVuZGVuY2llc0Z1bGZpbGxlZD1udWxsO2Z1bmN0aW9uIGdldFVuaXF1ZVJ1bkRlcGVuZGVuY3koaWQpe3JldHVybiBpZH1mdW5jdGlvbiBhZGRSdW5EZXBlbmRlbmN5KGlkKXtydW5EZXBlbmRlbmNpZXMrKztpZihNb2R1bGVbIm1vbml0b3JSdW5EZXBlbmRlbmNpZXMiXSl7TW9kdWxlWyJtb25pdG9yUnVuRGVwZW5kZW5jaWVzIl0ocnVuRGVwZW5kZW5jaWVzKX19ZnVuY3Rpb24gcmVtb3ZlUnVuRGVwZW5kZW5jeShpZCl7cnVuRGVwZW5kZW5jaWVzLS07aWYoTW9kdWxlWyJtb25pdG9yUnVuRGVwZW5kZW5jaWVzIl0pe01vZHVsZVsibW9uaXRvclJ1bkRlcGVuZGVuY2llcyJdKHJ1bkRlcGVuZGVuY2llcyl9aWYocnVuRGVwZW5kZW5jaWVzPT0wKXtpZihydW5EZXBlbmRlbmN5V2F0Y2hlciE9PW51bGwpe2NsZWFySW50ZXJ2YWwocnVuRGVwZW5kZW5jeVdhdGNoZXIpO3J1bkRlcGVuZGVuY3lXYXRjaGVyPW51bGx9aWYoZGVwZW5kZW5jaWVzRnVsZmlsbGVkKXt2YXIgY2FsbGJhY2s9ZGVwZW5kZW5jaWVzRnVsZmlsbGVkO2RlcGVuZGVuY2llc0Z1bGZpbGxlZD1udWxsO2NhbGxiYWNrKCl9fX1mdW5jdGlvbiBhYm9ydCh3aGF0KXtpZihNb2R1bGVbIm9uQWJvcnQiXSl7TW9kdWxlWyJvbkFib3J0Il0od2hhdCl9d2hhdD0iQWJvcnRlZCgiK3doYXQrIikiO2Vycih3aGF0KTtBQk9SVD10cnVlO0VYSVRTVEFUVVM9MTt3aGF0Kz0iLiBCdWlsZCB3aXRoIC1zQVNTRVJUSU9OUyBmb3IgbW9yZSBpbmZvLiI7dmFyIGU9bmV3IFdlYkFzc2VtYmx5LlJ1bnRpbWVFcnJvcih3aGF0KTtyZWFkeVByb21pc2VSZWplY3QoZSk7dGhyb3cgZX12YXIgZGF0YVVSSVByZWZpeD0iZGF0YTphcHBsaWNhdGlvbi9vY3RldC1zdHJlYW07YmFzZTY0LCI7dmFyIGlzRGF0YVVSST1maWxlbmFtZT0+ZmlsZW5hbWUuc3RhcnRzV2l0aChkYXRhVVJJUHJlZml4KTt2YXIgd2FzbUJpbmFyeUZpbGU7aWYoTW9kdWxlWyJsb2NhdGVGaWxlIl0pe3dhc21CaW5hcnlGaWxlPSJtYWluLWJpbi1tdWx0aS53YXNtIjtpZighaXNEYXRhVVJJKHdhc21CaW5hcnlGaWxlKSl7d2FzbUJpbmFyeUZpbGU9bG9jYXRlRmlsZSh3YXNtQmluYXJ5RmlsZSl9fWVsc2V7d2FzbUJpbmFyeUZpbGU9bmV3IFVSTCgibWFpbi1iaW4tbXVsdGkud2FzbSIsbG9jYXRpb24uaHJlZikuaHJlZn1mdW5jdGlvbiBnZXRCaW5hcnlTeW5jKGZpbGUpe2lmKGZpbGU9PXdhc21CaW5hcnlGaWxlJiZ3YXNtQmluYXJ5KXtyZXR1cm4gbmV3IFVpbnQ4QXJyYXkod2FzbUJpbmFyeSl9aWYocmVhZEJpbmFyeSl7cmV0dXJuIHJlYWRCaW5hcnkoZmlsZSl9dGhyb3ciYm90aCBhc3luYyBhbmQgc3luYyBmZXRjaGluZyBvZiB0aGUgd2FzbSBmYWlsZWQifWZ1bmN0aW9uIGdldEJpbmFyeVByb21pc2UoYmluYXJ5RmlsZSl7aWYoIXdhc21CaW5hcnkmJihFTlZJUk9OTUVOVF9JU19XRUJ8fEVOVklST05NRU5UX0lTX1dPUktFUikpe2lmKHR5cGVvZiBmZXRjaD09ImZ1bmN0aW9uIil7cmV0dXJuIGZldGNoKGJpbmFyeUZpbGUse2NyZWRlbnRpYWxzOiJzYW1lLW9yaWdpbiJ9KS50aGVuKHJlc3BvbnNlPT57aWYoIXJlc3BvbnNlWyJvayJdKXt0aHJvdyJmYWlsZWQgdG8gbG9hZCB3YXNtIGJpbmFyeSBmaWxlIGF0ICciK2JpbmFyeUZpbGUrIicifXJldHVybiByZXNwb25zZVsiYXJyYXlCdWZmZXIiXSgpfSkuY2F0Y2goKCk9PmdldEJpbmFyeVN5bmMoYmluYXJ5RmlsZSkpfX1yZXR1cm4gUHJvbWlzZS5yZXNvbHZlKCkudGhlbigoKT0+Z2V0QmluYXJ5U3luYyhiaW5hcnlGaWxlKSl9ZnVuY3Rpb24gaW5zdGFudGlhdGVBcnJheUJ1ZmZlcihiaW5hcnlGaWxlLGltcG9ydHMscmVjZWl2ZXIpe3JldHVybiBnZXRCaW5hcnlQcm9taXNlKGJpbmFyeUZpbGUpLnRoZW4oYmluYXJ5PT5XZWJBc3NlbWJseS5pbnN0YW50aWF0ZShiaW5hcnksaW1wb3J0cykpLnRoZW4oaW5zdGFuY2U9Pmluc3RhbmNlKS50aGVuKHJlY2VpdmVyLHJlYXNvbj0+e2VycihgZmFpbGVkIHRvIGFzeW5jaHJvbm91c2x5IHByZXBhcmUgd2FzbTogJHtyZWFzb259YCk7YWJvcnQocmVhc29uKX0pfWZ1bmN0aW9uIGluc3RhbnRpYXRlQXN5bmMoYmluYXJ5LGJpbmFyeUZpbGUsaW1wb3J0cyxjYWxsYmFjayl7aWYoIWJpbmFyeSYmdHlwZW9mIFdlYkFzc2VtYmx5Lmluc3RhbnRpYXRlU3RyZWFtaW5nPT0iZnVuY3Rpb24iJiYhaXNEYXRhVVJJKGJpbmFyeUZpbGUpJiZ0eXBlb2YgZmV0Y2g9PSJmdW5jdGlvbiIpe3JldHVybiBmZXRjaChiaW5hcnlGaWxlLHtjcmVkZW50aWFsczoic2FtZS1vcmlnaW4ifSkudGhlbihyZXNwb25zZT0+e3ZhciByZXN1bHQ9V2ViQXNzZW1ibHkuaW5zdGFudGlhdGVTdHJlYW1pbmcocmVzcG9uc2UsaW1wb3J0cyk7cmV0dXJuIHJlc3VsdC50aGVuKGNhbGxiYWNrLGZ1bmN0aW9uKHJlYXNvbil7ZXJyKGB3YXNtIHN0cmVhbWluZyBjb21waWxlIGZhaWxlZDogJHtyZWFzb259YCk7ZXJyKCJmYWxsaW5nIGJhY2sgdG8gQXJyYXlCdWZmZXIgaW5zdGFudGlhdGlvbiIpO3JldHVybiBpbnN0YW50aWF0ZUFycmF5QnVmZmVyKGJpbmFyeUZpbGUsaW1wb3J0cyxjYWxsYmFjayl9KX0pfXJldHVybiBpbnN0YW50aWF0ZUFycmF5QnVmZmVyKGJpbmFyeUZpbGUsaW1wb3J0cyxjYWxsYmFjayl9ZnVuY3Rpb24gY3JlYXRlV2FzbSgpe3ZhciBpbmZvPXsiYSI6d2FzbUltcG9ydHN9O2Z1bmN0aW9uIHJlY2VpdmVJbnN0YW5jZShpbnN0YW5jZSxtb2R1bGUpe3dhc21FeHBvcnRzPWluc3RhbmNlLmV4cG9ydHM7cmVnaXN0ZXJUTFNJbml0KHdhc21FeHBvcnRzWyJLYSJdKTt3YXNtVGFibGU9d2FzbUV4cG9ydHNbIkdhIl07YWRkT25Jbml0KHdhc21FeHBvcnRzWyJFYSJdKTt3YXNtTW9kdWxlPW1vZHVsZTtyZW1vdmVSdW5EZXBlbmRlbmN5KCJ3YXNtLWluc3RhbnRpYXRlIik7cmV0dXJuIHdhc21FeHBvcnRzfWFkZFJ1bkRlcGVuZGVuY3koIndhc20taW5zdGFudGlhdGUiKTtmdW5jdGlvbiByZWNlaXZlSW5zdGFudGlhdGlvblJlc3VsdChyZXN1bHQpe3JlY2VpdmVJbnN0YW5jZShyZXN1bHRbImluc3RhbmNlIl0scmVzdWx0WyJtb2R1bGUiXSl9aWYoTW9kdWxlWyJpbnN0YW50aWF0ZVdhc20iXSl7dHJ5e3JldHVybiBNb2R1bGVbImluc3RhbnRpYXRlV2FzbSJdKGluZm8scmVjZWl2ZUluc3RhbmNlKX1jYXRjaChlKXtlcnIoYE1vZHVsZS5pbnN0YW50aWF0ZVdhc20gY2FsbGJhY2sgZmFpbGVkIHdpdGggZXJyb3I6ICR7ZX1gKTtyZWFkeVByb21pc2VSZWplY3QoZSl9fWluc3RhbnRpYXRlQXN5bmMod2FzbUJpbmFyeSx3YXNtQmluYXJ5RmlsZSxpbmZvLHJlY2VpdmVJbnN0YW50aWF0aW9uUmVzdWx0KS5jYXRjaChyZWFkeVByb21pc2VSZWplY3QpO3JldHVybnt9fXZhciB0ZW1wRG91YmxlO3ZhciB0ZW1wSTY0O2Z1bmN0aW9uIHhubkxvYWRXYXNtTW9kdWxlSlMoY29kZSxvZmZzZXQsb2Zmc2V0X2VuZCxpbnZhbGlkX2Z1bmN0aW9uX2luZGV4KXtjb25zdCB0YWJsZU9yaWdpbmFsU2l6ZT13YXNtVGFibGUubGVuZ3RoO2NvbnN0IGJpbmFyeT1uZXcgVWludDhBcnJheShIRUFQVTguc2xpY2UoY29kZStvZmZzZXQsY29kZStvZmZzZXRfZW5kKSk7dHJ5e3ZhciBtb2R1bGU9bmV3IFdlYkFzc2VtYmx5Lk1vZHVsZShiaW5hcnkpO3ZhciBpbnN0YW5jZT1uZXcgV2ViQXNzZW1ibHkuSW5zdGFuY2UobW9kdWxlLHtlbnY6e21lbW9yeTp3YXNtTWVtb3J5fX0pO2Zvcih2YXIgc3ltTmFtZSBpbiBpbnN0YW5jZS5leHBvcnRzKXt2YXIgdmFsdWU9aW5zdGFuY2UuZXhwb3J0c1tzeW1OYW1lXTthZGRGdW5jdGlvbih2YWx1ZSl9aWYodGFibGVPcmlnaW5hbFNpemU8d2FzbVRhYmxlLmxlbmd0aCl7cmV0dXJuIHRhYmxlT3JpZ2luYWxTaXplfXJldHVybiBpbnZhbGlkX2Z1bmN0aW9uX2luZGV4fWNhdGNoKGVycm9yKXtjb25zb2xlLmxvZyhlcnJvcik7cmV0dXJuIGludmFsaWRfZnVuY3Rpb25faW5kZXh9fWZ1bmN0aW9uIEV4aXRTdGF0dXMoc3RhdHVzKXt0aGlzLm5hbWU9IkV4aXRTdGF0dXMiO3RoaXMubWVzc2FnZT1gUHJvZ3JhbSB0ZXJtaW5hdGVkIHdpdGggZXhpdCgke3N0YXR1c30pYDt0aGlzLnN0YXR1cz1zdGF0dXN9dmFyIHRlcm1pbmF0ZVdvcmtlcj13b3JrZXI9Pnt3b3JrZXIudGVybWluYXRlKCk7d29ya2VyLm9ubWVzc2FnZT1lPT57fX07dmFyIGtpbGxUaHJlYWQ9cHRocmVhZF9wdHI9Pnt2YXIgd29ya2VyPVBUaHJlYWQucHRocmVhZHNbcHRocmVhZF9wdHJdO2RlbGV0ZSBQVGhyZWFkLnB0aHJlYWRzW3B0aHJlYWRfcHRyXTt0ZXJtaW5hdGVXb3JrZXIod29ya2VyKTtfX2Vtc2NyaXB0ZW5fdGhyZWFkX2ZyZWVfZGF0YShwdGhyZWFkX3B0cik7UFRocmVhZC5ydW5uaW5nV29ya2Vycy5zcGxpY2UoUFRocmVhZC5ydW5uaW5nV29ya2Vycy5pbmRleE9mKHdvcmtlciksMSk7d29ya2VyLnB0aHJlYWRfcHRyPTB9O3ZhciBjYW5jZWxUaHJlYWQ9cHRocmVhZF9wdHI9Pnt2YXIgd29ya2VyPVBUaHJlYWQucHRocmVhZHNbcHRocmVhZF9wdHJdO3dvcmtlci5wb3N0TWVzc2FnZSh7ImNtZCI6ImNhbmNlbCJ9KX07dmFyIGNsZWFudXBUaHJlYWQ9cHRocmVhZF9wdHI9Pnt2YXIgd29ya2VyPVBUaHJlYWQucHRocmVhZHNbcHRocmVhZF9wdHJdO1BUaHJlYWQucmV0dXJuV29ya2VyVG9Qb29sKHdvcmtlcil9O3ZhciB6ZXJvTWVtb3J5PShhZGRyZXNzLHNpemUpPT57SEVBUFU4LmZpbGwoMCxhZGRyZXNzLGFkZHJlc3Mrc2l6ZSk7cmV0dXJuIGFkZHJlc3N9O3ZhciBzcGF3blRocmVhZD10aHJlYWRQYXJhbXM9Pnt2YXIgd29ya2VyPVBUaHJlYWQuZ2V0TmV3V29ya2VyKCk7aWYoIXdvcmtlcil7cmV0dXJuIDZ9UFRocmVhZC5ydW5uaW5nV29ya2Vycy5wdXNoKHdvcmtlcik7UFRocmVhZC5wdGhyZWFkc1t0aHJlYWRQYXJhbXMucHRocmVhZF9wdHJdPXdvcmtlcjt3b3JrZXIucHRocmVhZF9wdHI9dGhyZWFkUGFyYW1zLnB0aHJlYWRfcHRyO3ZhciBtc2c9eyJjbWQiOiJydW4iLCJzdGFydF9yb3V0aW5lIjp0aHJlYWRQYXJhbXMuc3RhcnRSb3V0aW5lLCJhcmciOnRocmVhZFBhcmFtcy5hcmcsInB0aHJlYWRfcHRyIjp0aHJlYWRQYXJhbXMucHRocmVhZF9wdHJ9O3dvcmtlci5wb3N0TWVzc2FnZShtc2csdGhyZWFkUGFyYW1zLnRyYW5zZmVyTGlzdCk7cmV0dXJuIDB9O3ZhciBydW50aW1lS2VlcGFsaXZlQ291bnRlcj0wO3ZhciBrZWVwUnVudGltZUFsaXZlPSgpPT5ub0V4aXRSdW50aW1lfHxydW50aW1lS2VlcGFsaXZlQ291bnRlcj4wO3ZhciBQQVRIPXtpc0FiczpwYXRoPT5wYXRoLmNoYXJBdCgwKT09PSIvIixzcGxpdFBhdGg6ZmlsZW5hbWU9Pnt2YXIgc3BsaXRQYXRoUmU9L14oXC8/fCkoW1xzXFNdKj8pKCg/OlwuezEsMn18W15cL10rP3wpKFwuW14uXC9dKnwpKSg/OltcL10qKSQvO3JldHVybiBzcGxpdFBhdGhSZS5leGVjKGZpbGVuYW1lKS5zbGljZSgxKX0sbm9ybWFsaXplQXJyYXk6KHBhcnRzLGFsbG93QWJvdmVSb290KT0+e3ZhciB1cD0wO2Zvcih2YXIgaT1wYXJ0cy5sZW5ndGgtMTtpPj0wO2ktLSl7dmFyIGxhc3Q9cGFydHNbaV07aWYobGFzdD09PSIuIil7cGFydHMuc3BsaWNlKGksMSl9ZWxzZSBpZihsYXN0PT09Ii4uIil7cGFydHMuc3BsaWNlKGksMSk7dXArK31lbHNlIGlmKHVwKXtwYXJ0cy5zcGxpY2UoaSwxKTt1cC0tfX1pZihhbGxvd0Fib3ZlUm9vdCl7Zm9yKDt1cDt1cC0tKXtwYXJ0cy51bnNoaWZ0KCIuLiIpfX1yZXR1cm4gcGFydHN9LG5vcm1hbGl6ZTpwYXRoPT57dmFyIGlzQWJzb2x1dGU9UEFUSC5pc0FicyhwYXRoKSx0cmFpbGluZ1NsYXNoPXBhdGguc3Vic3RyKC0xKT09PSIvIjtwYXRoPVBBVEgubm9ybWFsaXplQXJyYXkocGF0aC5zcGxpdCgiLyIpLmZpbHRlcihwPT4hIXApLCFpc0Fic29sdXRlKS5qb2luKCIvIik7aWYoIXBhdGgmJiFpc0Fic29sdXRlKXtwYXRoPSIuIn1pZihwYXRoJiZ0cmFpbGluZ1NsYXNoKXtwYXRoKz0iLyJ9cmV0dXJuKGlzQWJzb2x1dGU/Ii8iOiIiKStwYXRofSxkaXJuYW1lOnBhdGg9Pnt2YXIgcmVzdWx0PVBBVEguc3BsaXRQYXRoKHBhdGgpLHJvb3Q9cmVzdWx0WzBdLGRpcj1yZXN1bHRbMV07aWYoIXJvb3QmJiFkaXIpe3JldHVybiIuIn1pZihkaXIpe2Rpcj1kaXIuc3Vic3RyKDAsZGlyLmxlbmd0aC0xKX1yZXR1cm4gcm9vdCtkaXJ9LGJhc2VuYW1lOnBhdGg9PntpZihwYXRoPT09Ii8iKXJldHVybiIvIjtwYXRoPVBBVEgubm9ybWFsaXplKHBhdGgpO3BhdGg9cGF0aC5yZXBsYWNlKC9cLyQvLCIiKTt2YXIgbGFzdFNsYXNoPXBhdGgubGFzdEluZGV4T2YoIi8iKTtpZihsYXN0U2xhc2g9PT0tMSlyZXR1cm4gcGF0aDtyZXR1cm4gcGF0aC5zdWJzdHIobGFzdFNsYXNoKzEpfSxqb2luOmZ1bmN0aW9uKCl7dmFyIHBhdGhzPUFycmF5LnByb3RvdHlwZS5zbGljZS5jYWxsKGFyZ3VtZW50cyk7cmV0dXJuIFBBVEgubm9ybWFsaXplKHBhdGhzLmpvaW4oIi8iKSl9LGpvaW4yOihsLHIpPT5QQVRILm5vcm1hbGl6ZShsKyIvIityKX07dmFyIGluaXRSYW5kb21GaWxsPSgpPT57aWYodHlwZW9mIGNyeXB0bz09Im9iamVjdCImJnR5cGVvZiBjcnlwdG9bImdldFJhbmRvbVZhbHVlcyJdPT0iZnVuY3Rpb24iKXtyZXR1cm4gdmlldz0+KHZpZXcuc2V0KGNyeXB0by5nZXRSYW5kb21WYWx1ZXMobmV3IFVpbnQ4QXJyYXkodmlldy5ieXRlTGVuZ3RoKSkpLHZpZXcpfWVsc2UgYWJvcnQoImluaXRSYW5kb21EZXZpY2UiKX07dmFyIHJhbmRvbUZpbGw9dmlldz0+KHJhbmRvbUZpbGw9aW5pdFJhbmRvbUZpbGwoKSkodmlldyk7dmFyIFBBVEhfRlM9e3Jlc29sdmU6ZnVuY3Rpb24oKXt2YXIgcmVzb2x2ZWRQYXRoPSIiLHJlc29sdmVkQWJzb2x1dGU9ZmFsc2U7Zm9yKHZhciBpPWFyZ3VtZW50cy5sZW5ndGgtMTtpPj0tMSYmIXJlc29sdmVkQWJzb2x1dGU7aS0tKXt2YXIgcGF0aD1pPj0wP2FyZ3VtZW50c1tpXTpGUy5jd2QoKTtpZih0eXBlb2YgcGF0aCE9InN0cmluZyIpe3Rocm93IG5ldyBUeXBlRXJyb3IoIkFyZ3VtZW50cyB0byBwYXRoLnJlc29sdmUgbXVzdCBiZSBzdHJpbmdzIil9ZWxzZSBpZighcGF0aCl7cmV0dXJuIiJ9cmVzb2x2ZWRQYXRoPXBhdGgrIi8iK3Jlc29sdmVkUGF0aDtyZXNvbHZlZEFic29sdXRlPVBBVEguaXNBYnMocGF0aCl9cmVzb2x2ZWRQYXRoPVBBVEgubm9ybWFsaXplQXJyYXkocmVzb2x2ZWRQYXRoLnNwbGl0KCIvIikuZmlsdGVyKHA9PiEhcCksIXJlc29sdmVkQWJzb2x1dGUpLmpvaW4oIi8iKTtyZXR1cm4ocmVzb2x2ZWRBYnNvbHV0ZT8iLyI6IiIpK3Jlc29sdmVkUGF0aHx8Ii4ifSxyZWxhdGl2ZTooZnJvbSx0byk9Pntmcm9tPVBBVEhfRlMucmVzb2x2ZShmcm9tKS5zdWJzdHIoMSk7dG89UEFUSF9GUy5yZXNvbHZlKHRvKS5zdWJzdHIoMSk7ZnVuY3Rpb24gdHJpbShhcnIpe3ZhciBzdGFydD0wO2Zvcig7c3RhcnQ8YXJyLmxlbmd0aDtzdGFydCsrKXtpZihhcnJbc3RhcnRdIT09IiIpYnJlYWt9dmFyIGVuZD1hcnIubGVuZ3RoLTE7Zm9yKDtlbmQ+PTA7ZW5kLS0pe2lmKGFycltlbmRdIT09IiIpYnJlYWt9aWYoc3RhcnQ+ZW5kKXJldHVybltdO3JldHVybiBhcnIuc2xpY2Uoc3RhcnQsZW5kLXN0YXJ0KzEpfXZhciBmcm9tUGFydHM9dHJpbShmcm9tLnNwbGl0KCIvIikpO3ZhciB0b1BhcnRzPXRyaW0odG8uc3BsaXQoIi8iKSk7dmFyIGxlbmd0aD1NYXRoLm1pbihmcm9tUGFydHMubGVuZ3RoLHRvUGFydHMubGVuZ3RoKTt2YXIgc2FtZVBhcnRzTGVuZ3RoPWxlbmd0aDtmb3IodmFyIGk9MDtpPGxlbmd0aDtpKyspe2lmKGZyb21QYXJ0c1tpXSE9PXRvUGFydHNbaV0pe3NhbWVQYXJ0c0xlbmd0aD1pO2JyZWFrfX12YXIgb3V0cHV0UGFydHM9W107Zm9yKHZhciBpPXNhbWVQYXJ0c0xlbmd0aDtpPGZyb21QYXJ0cy5sZW5ndGg7aSsrKXtvdXRwdXRQYXJ0cy5wdXNoKCIuLiIpfW91dHB1dFBhcnRzPW91dHB1dFBhcnRzLmNvbmNhdCh0b1BhcnRzLnNsaWNlKHNhbWVQYXJ0c0xlbmd0aCkpO3JldHVybiBvdXRwdXRQYXJ0cy5qb2luKCIvIil9fTt2YXIgVVRGOERlY29kZXI9dHlwZW9mIFRleHREZWNvZGVyIT0idW5kZWZpbmVkIj9uZXcgVGV4dERlY29kZXIoInV0ZjgiKTp1bmRlZmluZWQ7dmFyIFVURjhBcnJheVRvU3RyaW5nPShoZWFwT3JBcnJheSxpZHgsbWF4Qnl0ZXNUb1JlYWQpPT57dmFyIGVuZElkeD1pZHgrbWF4Qnl0ZXNUb1JlYWQ7dmFyIGVuZFB0cj1pZHg7d2hpbGUoaGVhcE9yQXJyYXlbZW5kUHRyXSYmIShlbmRQdHI+PWVuZElkeCkpKytlbmRQdHI7aWYoZW5kUHRyLWlkeD4xNiYmaGVhcE9yQXJyYXkuYnVmZmVyJiZVVEY4RGVjb2Rlcil7cmV0dXJuIFVURjhEZWNvZGVyLmRlY29kZShoZWFwT3JBcnJheS5idWZmZXIgaW5zdGFuY2VvZiBTaGFyZWRBcnJheUJ1ZmZlcj9oZWFwT3JBcnJheS5zbGljZShpZHgsZW5kUHRyKTpoZWFwT3JBcnJheS5zdWJhcnJheShpZHgsZW5kUHRyKSl9dmFyIHN0cj0iIjt3aGlsZShpZHg8ZW5kUHRyKXt2YXIgdTA9aGVhcE9yQXJyYXlbaWR4KytdO2lmKCEodTAmMTI4KSl7c3RyKz1TdHJpbmcuZnJvbUNoYXJDb2RlKHUwKTtjb250aW51ZX12YXIgdTE9aGVhcE9yQXJyYXlbaWR4KytdJjYzO2lmKCh1MCYyMjQpPT0xOTIpe3N0cis9U3RyaW5nLmZyb21DaGFyQ29kZSgodTAmMzEpPDw2fHUxKTtjb250aW51ZX12YXIgdTI9aGVhcE9yQXJyYXlbaWR4KytdJjYzO2lmKCh1MCYyNDApPT0yMjQpe3UwPSh1MCYxNSk8PDEyfHUxPDw2fHUyfWVsc2V7dTA9KHUwJjcpPDwxOHx1MTw8MTJ8dTI8PDZ8aGVhcE9yQXJyYXlbaWR4KytdJjYzfWlmKHUwPDY1NTM2KXtzdHIrPVN0cmluZy5mcm9tQ2hhckNvZGUodTApfWVsc2V7dmFyIGNoPXUwLTY1NTM2O3N0cis9U3RyaW5nLmZyb21DaGFyQ29kZSg1NTI5NnxjaD4+MTAsNTYzMjB8Y2gmMTAyMyl9fXJldHVybiBzdHJ9O3ZhciBGU19zdGRpbl9nZXRDaGFyX2J1ZmZlcj1bXTt2YXIgbGVuZ3RoQnl0ZXNVVEY4PXN0cj0+e3ZhciBsZW49MDtmb3IodmFyIGk9MDtpPHN0ci5sZW5ndGg7KytpKXt2YXIgYz1zdHIuY2hhckNvZGVBdChpKTtpZihjPD0xMjcpe2xlbisrfWVsc2UgaWYoYzw9MjA0Nyl7bGVuKz0yfWVsc2UgaWYoYz49NTUyOTYmJmM8PTU3MzQzKXtsZW4rPTQ7KytpfWVsc2V7bGVuKz0zfX1yZXR1cm4gbGVufTt2YXIgc3RyaW5nVG9VVEY4QXJyYXk9KHN0cixoZWFwLG91dElkeCxtYXhCeXRlc1RvV3JpdGUpPT57aWYoIShtYXhCeXRlc1RvV3JpdGU+MCkpcmV0dXJuIDA7dmFyIHN0YXJ0SWR4PW91dElkeDt2YXIgZW5kSWR4PW91dElkeCttYXhCeXRlc1RvV3JpdGUtMTtmb3IodmFyIGk9MDtpPHN0ci5sZW5ndGg7KytpKXt2YXIgdT1zdHIuY2hhckNvZGVBdChpKTtpZih1Pj01NTI5NiYmdTw9NTczNDMpe3ZhciB1MT1zdHIuY2hhckNvZGVBdCgrK2kpO3U9NjU1MzYrKCh1JjEwMjMpPDwxMCl8dTEmMTAyM31pZih1PD0xMjcpe2lmKG91dElkeD49ZW5kSWR4KWJyZWFrO2hlYXBbb3V0SWR4KytdPXV9ZWxzZSBpZih1PD0yMDQ3KXtpZihvdXRJZHgrMT49ZW5kSWR4KWJyZWFrO2hlYXBbb3V0SWR4KytdPTE5Mnx1Pj42O2hlYXBbb3V0SWR4KytdPTEyOHx1JjYzfWVsc2UgaWYodTw9NjU1MzUpe2lmKG91dElkeCsyPj1lbmRJZHgpYnJlYWs7aGVhcFtvdXRJZHgrK109MjI0fHU+PjEyO2hlYXBbb3V0SWR4KytdPTEyOHx1Pj42JjYzO2hlYXBbb3V0SWR4KytdPTEyOHx1JjYzfWVsc2V7aWYob3V0SWR4KzM+PWVuZElkeClicmVhaztoZWFwW291dElkeCsrXT0yNDB8dT4+MTg7aGVhcFtvdXRJZHgrK109MTI4fHU+PjEyJjYzO2hlYXBbb3V0SWR4KytdPTEyOHx1Pj42JjYzO2hlYXBbb3V0SWR4KytdPTEyOHx1JjYzfX1oZWFwW291dElkeF09MDtyZXR1cm4gb3V0SWR4LXN0YXJ0SWR4fTtmdW5jdGlvbiBpbnRBcnJheUZyb21TdHJpbmcoc3RyaW5neSxkb250QWRkTnVsbCxsZW5ndGgpe3ZhciBsZW49bGVuZ3RoPjA/bGVuZ3RoOmxlbmd0aEJ5dGVzVVRGOChzdHJpbmd5KSsxO3ZhciB1OGFycmF5PW5ldyBBcnJheShsZW4pO3ZhciBudW1CeXRlc1dyaXR0ZW49c3RyaW5nVG9VVEY4QXJyYXkoc3RyaW5neSx1OGFycmF5LDAsdThhcnJheS5sZW5ndGgpO2lmKGRvbnRBZGROdWxsKXU4YXJyYXkubGVuZ3RoPW51bUJ5dGVzV3JpdHRlbjtyZXR1cm4gdThhcnJheX12YXIgRlNfc3RkaW5fZ2V0Q2hhcj0oKT0+e2lmKCFGU19zdGRpbl9nZXRDaGFyX2J1ZmZlci5sZW5ndGgpe3ZhciByZXN1bHQ9bnVsbDtpZih0eXBlb2Ygd2luZG93IT0idW5kZWZpbmVkIiYmdHlwZW9mIHdpbmRvdy5wcm9tcHQ9PSJmdW5jdGlvbiIpe3Jlc3VsdD13aW5kb3cucHJvbXB0KCJJbnB1dDogIik7aWYocmVzdWx0IT09bnVsbCl7cmVzdWx0Kz0iXG4ifX1lbHNlIGlmKHR5cGVvZiByZWFkbGluZT09ImZ1bmN0aW9uIil7cmVzdWx0PXJlYWRsaW5lKCk7aWYocmVzdWx0IT09bnVsbCl7cmVzdWx0Kz0iXG4ifX1pZighcmVzdWx0KXtyZXR1cm4gbnVsbH1GU19zdGRpbl9nZXRDaGFyX2J1ZmZlcj1pbnRBcnJheUZyb21TdHJpbmcocmVzdWx0LHRydWUpfXJldHVybiBGU19zdGRpbl9nZXRDaGFyX2J1ZmZlci5zaGlmdCgpfTt2YXIgVFRZPXt0dHlzOltdLGluaXQoKXt9LHNodXRkb3duKCl7fSxyZWdpc3RlcihkZXYsb3BzKXtUVFkudHR5c1tkZXZdPXtpbnB1dDpbXSxvdXRwdXQ6W10sb3BzOm9wc307RlMucmVnaXN0ZXJEZXZpY2UoZGV2LFRUWS5zdHJlYW1fb3BzKX0sc3RyZWFtX29wczp7b3BlbihzdHJlYW0pe3ZhciB0dHk9VFRZLnR0eXNbc3RyZWFtLm5vZGUucmRldl07aWYoIXR0eSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDMpfXN0cmVhbS50dHk9dHR5O3N0cmVhbS5zZWVrYWJsZT1mYWxzZX0sY2xvc2Uoc3RyZWFtKXtzdHJlYW0udHR5Lm9wcy5mc3luYyhzdHJlYW0udHR5KX0sZnN5bmMoc3RyZWFtKXtzdHJlYW0udHR5Lm9wcy5mc3luYyhzdHJlYW0udHR5KX0scmVhZChzdHJlYW0sYnVmZmVyLG9mZnNldCxsZW5ndGgscG9zKXtpZighc3RyZWFtLnR0eXx8IXN0cmVhbS50dHkub3BzLmdldF9jaGFyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2MCl9dmFyIGJ5dGVzUmVhZD0wO2Zvcih2YXIgaT0wO2k8bGVuZ3RoO2krKyl7dmFyIHJlc3VsdDt0cnl7cmVzdWx0PXN0cmVhbS50dHkub3BzLmdldF9jaGFyKHN0cmVhbS50dHkpfWNhdGNoKGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI5KX1pZihyZXN1bHQ9PT11bmRlZmluZWQmJmJ5dGVzUmVhZD09PTApe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDYpfWlmKHJlc3VsdD09PW51bGx8fHJlc3VsdD09PXVuZGVmaW5lZClicmVhaztieXRlc1JlYWQrKztidWZmZXJbb2Zmc2V0K2ldPXJlc3VsdH1pZihieXRlc1JlYWQpe3N0cmVhbS5ub2RlLnRpbWVzdGFtcD1EYXRlLm5vdygpfXJldHVybiBieXRlc1JlYWR9LHdyaXRlKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3Mpe2lmKCFzdHJlYW0udHR5fHwhc3RyZWFtLnR0eS5vcHMucHV0X2NoYXIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDYwKX10cnl7Zm9yKHZhciBpPTA7aTxsZW5ndGg7aSsrKXtzdHJlYW0udHR5Lm9wcy5wdXRfY2hhcihzdHJlYW0udHR5LGJ1ZmZlcltvZmZzZXQraV0pfX1jYXRjaChlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOSl9aWYobGVuZ3RoKXtzdHJlYW0ubm9kZS50aW1lc3RhbXA9RGF0ZS5ub3coKX1yZXR1cm4gaX19LGRlZmF1bHRfdHR5X29wczp7Z2V0X2NoYXIodHR5KXtyZXR1cm4gRlNfc3RkaW5fZ2V0Q2hhcigpfSxwdXRfY2hhcih0dHksdmFsKXtpZih2YWw9PT1udWxsfHx2YWw9PT0xMCl7b3V0KFVURjhBcnJheVRvU3RyaW5nKHR0eS5vdXRwdXQsMCkpO3R0eS5vdXRwdXQ9W119ZWxzZXtpZih2YWwhPTApdHR5Lm91dHB1dC5wdXNoKHZhbCl9fSxmc3luYyh0dHkpe2lmKHR0eS5vdXRwdXQmJnR0eS5vdXRwdXQubGVuZ3RoPjApe291dChVVEY4QXJyYXlUb1N0cmluZyh0dHkub3V0cHV0LDApKTt0dHkub3V0cHV0PVtdfX0saW9jdGxfdGNnZXRzKHR0eSl7cmV0dXJue2NfaWZsYWc6MjU4NTYsY19vZmxhZzo1LGNfY2ZsYWc6MTkxLGNfbGZsYWc6MzUzODcsY19jYzpbMywyOCwxMjcsMjEsNCwwLDEsMCwxNywxOSwyNiwwLDE4LDE1LDIzLDIyLDAsMCwwLDAsMCwwLDAsMCwwLDAsMCwwLDAsMCwwLDBdfX0saW9jdGxfdGNzZXRzKHR0eSxvcHRpb25hbF9hY3Rpb25zLGRhdGEpe3JldHVybiAwfSxpb2N0bF90aW9jZ3dpbnN6KHR0eSl7cmV0dXJuWzI0LDgwXX19LGRlZmF1bHRfdHR5MV9vcHM6e3B1dF9jaGFyKHR0eSx2YWwpe2lmKHZhbD09PW51bGx8fHZhbD09PTEwKXtlcnIoVVRGOEFycmF5VG9TdHJpbmcodHR5Lm91dHB1dCwwKSk7dHR5Lm91dHB1dD1bXX1lbHNle2lmKHZhbCE9MCl0dHkub3V0cHV0LnB1c2godmFsKX19LGZzeW5jKHR0eSl7aWYodHR5Lm91dHB1dCYmdHR5Lm91dHB1dC5sZW5ndGg+MCl7ZXJyKFVURjhBcnJheVRvU3RyaW5nKHR0eS5vdXRwdXQsMCkpO3R0eS5vdXRwdXQ9W119fX19O3ZhciBhbGlnbk1lbW9yeT0oc2l6ZSxhbGlnbm1lbnQpPT5NYXRoLmNlaWwoc2l6ZS9hbGlnbm1lbnQpKmFsaWdubWVudDt2YXIgbW1hcEFsbG9jPXNpemU9PntzaXplPWFsaWduTWVtb3J5KHNpemUsNjU1MzYpO3ZhciBwdHI9X2Vtc2NyaXB0ZW5fYnVpbHRpbl9tZW1hbGlnbig2NTUzNixzaXplKTtpZighcHRyKXJldHVybiAwO3JldHVybiB6ZXJvTWVtb3J5KHB0cixzaXplKX07dmFyIE1FTUZTPXtvcHNfdGFibGU6bnVsbCxtb3VudChtb3VudCl7cmV0dXJuIE1FTUZTLmNyZWF0ZU5vZGUobnVsbCwiLyIsMTYzODR8NTExLDApfSxjcmVhdGVOb2RlKHBhcmVudCxuYW1lLG1vZGUsZGV2KXtpZihGUy5pc0Jsa2Rldihtb2RlKXx8RlMuaXNGSUZPKG1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9aWYoIU1FTUZTLm9wc190YWJsZSl7TUVNRlMub3BzX3RhYmxlPXtkaXI6e25vZGU6e2dldGF0dHI6TUVNRlMubm9kZV9vcHMuZ2V0YXR0cixzZXRhdHRyOk1FTUZTLm5vZGVfb3BzLnNldGF0dHIsbG9va3VwOk1FTUZTLm5vZGVfb3BzLmxvb2t1cCxta25vZDpNRU1GUy5ub2RlX29wcy5ta25vZCxyZW5hbWU6TUVNRlMubm9kZV9vcHMucmVuYW1lLHVubGluazpNRU1GUy5ub2RlX29wcy51bmxpbmsscm1kaXI6TUVNRlMubm9kZV9vcHMucm1kaXIscmVhZGRpcjpNRU1GUy5ub2RlX29wcy5yZWFkZGlyLHN5bWxpbms6TUVNRlMubm9kZV9vcHMuc3ltbGlua30sc3RyZWFtOntsbHNlZWs6TUVNRlMuc3RyZWFtX29wcy5sbHNlZWt9fSxmaWxlOntub2RlOntnZXRhdHRyOk1FTUZTLm5vZGVfb3BzLmdldGF0dHIsc2V0YXR0cjpNRU1GUy5ub2RlX29wcy5zZXRhdHRyfSxzdHJlYW06e2xsc2VlazpNRU1GUy5zdHJlYW1fb3BzLmxsc2VlayxyZWFkOk1FTUZTLnN0cmVhbV9vcHMucmVhZCx3cml0ZTpNRU1GUy5zdHJlYW1fb3BzLndyaXRlLGFsbG9jYXRlOk1FTUZTLnN0cmVhbV9vcHMuYWxsb2NhdGUsbW1hcDpNRU1GUy5zdHJlYW1fb3BzLm1tYXAsbXN5bmM6TUVNRlMuc3RyZWFtX29wcy5tc3luY319LGxpbms6e25vZGU6e2dldGF0dHI6TUVNRlMubm9kZV9vcHMuZ2V0YXR0cixzZXRhdHRyOk1FTUZTLm5vZGVfb3BzLnNldGF0dHIscmVhZGxpbms6TUVNRlMubm9kZV9vcHMucmVhZGxpbmt9LHN0cmVhbTp7fX0sY2hyZGV2Ontub2RlOntnZXRhdHRyOk1FTUZTLm5vZGVfb3BzLmdldGF0dHIsc2V0YXR0cjpNRU1GUy5ub2RlX29wcy5zZXRhdHRyfSxzdHJlYW06RlMuY2hyZGV2X3N0cmVhbV9vcHN9fX12YXIgbm9kZT1GUy5jcmVhdGVOb2RlKHBhcmVudCxuYW1lLG1vZGUsZGV2KTtpZihGUy5pc0Rpcihub2RlLm1vZGUpKXtub2RlLm5vZGVfb3BzPU1FTUZTLm9wc190YWJsZS5kaXIubm9kZTtub2RlLnN0cmVhbV9vcHM9TUVNRlMub3BzX3RhYmxlLmRpci5zdHJlYW07bm9kZS5jb250ZW50cz17fX1lbHNlIGlmKEZTLmlzRmlsZShub2RlLm1vZGUpKXtub2RlLm5vZGVfb3BzPU1FTUZTLm9wc190YWJsZS5maWxlLm5vZGU7bm9kZS5zdHJlYW1fb3BzPU1FTUZTLm9wc190YWJsZS5maWxlLnN0cmVhbTtub2RlLnVzZWRCeXRlcz0wO25vZGUuY29udGVudHM9bnVsbH1lbHNlIGlmKEZTLmlzTGluayhub2RlLm1vZGUpKXtub2RlLm5vZGVfb3BzPU1FTUZTLm9wc190YWJsZS5saW5rLm5vZGU7bm9kZS5zdHJlYW1fb3BzPU1FTUZTLm9wc190YWJsZS5saW5rLnN0cmVhbX1lbHNlIGlmKEZTLmlzQ2hyZGV2KG5vZGUubW9kZSkpe25vZGUubm9kZV9vcHM9TUVNRlMub3BzX3RhYmxlLmNocmRldi5ub2RlO25vZGUuc3RyZWFtX29wcz1NRU1GUy5vcHNfdGFibGUuY2hyZGV2LnN0cmVhbX1ub2RlLnRpbWVzdGFtcD1EYXRlLm5vdygpO2lmKHBhcmVudCl7cGFyZW50LmNvbnRlbnRzW25hbWVdPW5vZGU7cGFyZW50LnRpbWVzdGFtcD1ub2RlLnRpbWVzdGFtcH1yZXR1cm4gbm9kZX0sZ2V0RmlsZURhdGFBc1R5cGVkQXJyYXkobm9kZSl7aWYoIW5vZGUuY29udGVudHMpcmV0dXJuIG5ldyBVaW50OEFycmF5KDApO2lmKG5vZGUuY29udGVudHMuc3ViYXJyYXkpcmV0dXJuIG5vZGUuY29udGVudHMuc3ViYXJyYXkoMCxub2RlLnVzZWRCeXRlcyk7cmV0dXJuIG5ldyBVaW50OEFycmF5KG5vZGUuY29udGVudHMpfSxleHBhbmRGaWxlU3RvcmFnZShub2RlLG5ld0NhcGFjaXR5KXt2YXIgcHJldkNhcGFjaXR5PW5vZGUuY29udGVudHM/bm9kZS5jb250ZW50cy5sZW5ndGg6MDtpZihwcmV2Q2FwYWNpdHk+PW5ld0NhcGFjaXR5KXJldHVybjt2YXIgQ0FQQUNJVFlfRE9VQkxJTkdfTUFYPTEwMjQqMTAyNDtuZXdDYXBhY2l0eT1NYXRoLm1heChuZXdDYXBhY2l0eSxwcmV2Q2FwYWNpdHkqKHByZXZDYXBhY2l0eTxDQVBBQ0lUWV9ET1VCTElOR19NQVg/MjoxLjEyNSk+Pj4wKTtpZihwcmV2Q2FwYWNpdHkhPTApbmV3Q2FwYWNpdHk9TWF0aC5tYXgobmV3Q2FwYWNpdHksMjU2KTt2YXIgb2xkQ29udGVudHM9bm9kZS5jb250ZW50cztub2RlLmNvbnRlbnRzPW5ldyBVaW50OEFycmF5KG5ld0NhcGFjaXR5KTtpZihub2RlLnVzZWRCeXRlcz4wKW5vZGUuY29udGVudHMuc2V0KG9sZENvbnRlbnRzLnN1YmFycmF5KDAsbm9kZS51c2VkQnl0ZXMpLDApfSxyZXNpemVGaWxlU3RvcmFnZShub2RlLG5ld1NpemUpe2lmKG5vZGUudXNlZEJ5dGVzPT1uZXdTaXplKXJldHVybjtpZihuZXdTaXplPT0wKXtub2RlLmNvbnRlbnRzPW51bGw7bm9kZS51c2VkQnl0ZXM9MH1lbHNle3ZhciBvbGRDb250ZW50cz1ub2RlLmNvbnRlbnRzO25vZGUuY29udGVudHM9bmV3IFVpbnQ4QXJyYXkobmV3U2l6ZSk7aWYob2xkQ29udGVudHMpe25vZGUuY29udGVudHMuc2V0KG9sZENvbnRlbnRzLnN1YmFycmF5KDAsTWF0aC5taW4obmV3U2l6ZSxub2RlLnVzZWRCeXRlcykpKX1ub2RlLnVzZWRCeXRlcz1uZXdTaXplfX0sbm9kZV9vcHM6e2dldGF0dHIobm9kZSl7dmFyIGF0dHI9e307YXR0ci5kZXY9RlMuaXNDaHJkZXYobm9kZS5tb2RlKT9ub2RlLmlkOjE7YXR0ci5pbm89bm9kZS5pZDthdHRyLm1vZGU9bm9kZS5tb2RlO2F0dHIubmxpbms9MTthdHRyLnVpZD0wO2F0dHIuZ2lkPTA7YXR0ci5yZGV2PW5vZGUucmRldjtpZihGUy5pc0Rpcihub2RlLm1vZGUpKXthdHRyLnNpemU9NDA5Nn1lbHNlIGlmKEZTLmlzRmlsZShub2RlLm1vZGUpKXthdHRyLnNpemU9bm9kZS51c2VkQnl0ZXN9ZWxzZSBpZihGUy5pc0xpbmsobm9kZS5tb2RlKSl7YXR0ci5zaXplPW5vZGUubGluay5sZW5ndGh9ZWxzZXthdHRyLnNpemU9MH1hdHRyLmF0aW1lPW5ldyBEYXRlKG5vZGUudGltZXN0YW1wKTthdHRyLm10aW1lPW5ldyBEYXRlKG5vZGUudGltZXN0YW1wKTthdHRyLmN0aW1lPW5ldyBEYXRlKG5vZGUudGltZXN0YW1wKTthdHRyLmJsa3NpemU9NDA5NjthdHRyLmJsb2Nrcz1NYXRoLmNlaWwoYXR0ci5zaXplL2F0dHIuYmxrc2l6ZSk7cmV0dXJuIGF0dHJ9LHNldGF0dHIobm9kZSxhdHRyKXtpZihhdHRyLm1vZGUhPT11bmRlZmluZWQpe25vZGUubW9kZT1hdHRyLm1vZGV9aWYoYXR0ci50aW1lc3RhbXAhPT11bmRlZmluZWQpe25vZGUudGltZXN0YW1wPWF0dHIudGltZXN0YW1wfWlmKGF0dHIuc2l6ZSE9PXVuZGVmaW5lZCl7TUVNRlMucmVzaXplRmlsZVN0b3JhZ2Uobm9kZSxhdHRyLnNpemUpfX0sbG9va3VwKHBhcmVudCxuYW1lKXt0aHJvdyBGUy5nZW5lcmljRXJyb3JzWzQ0XX0sbWtub2QocGFyZW50LG5hbWUsbW9kZSxkZXYpe3JldHVybiBNRU1GUy5jcmVhdGVOb2RlKHBhcmVudCxuYW1lLG1vZGUsZGV2KX0scmVuYW1lKG9sZF9ub2RlLG5ld19kaXIsbmV3X25hbWUpe2lmKEZTLmlzRGlyKG9sZF9ub2RlLm1vZGUpKXt2YXIgbmV3X25vZGU7dHJ5e25ld19ub2RlPUZTLmxvb2t1cE5vZGUobmV3X2RpcixuZXdfbmFtZSl9Y2F0Y2goZSl7fWlmKG5ld19ub2RlKXtmb3IodmFyIGkgaW4gbmV3X25vZGUuY29udGVudHMpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDU1KX19fWRlbGV0ZSBvbGRfbm9kZS5wYXJlbnQuY29udGVudHNbb2xkX25vZGUubmFtZV07b2xkX25vZGUucGFyZW50LnRpbWVzdGFtcD1EYXRlLm5vdygpO29sZF9ub2RlLm5hbWU9bmV3X25hbWU7bmV3X2Rpci5jb250ZW50c1tuZXdfbmFtZV09b2xkX25vZGU7bmV3X2Rpci50aW1lc3RhbXA9b2xkX25vZGUucGFyZW50LnRpbWVzdGFtcDtvbGRfbm9kZS5wYXJlbnQ9bmV3X2Rpcn0sdW5saW5rKHBhcmVudCxuYW1lKXtkZWxldGUgcGFyZW50LmNvbnRlbnRzW25hbWVdO3BhcmVudC50aW1lc3RhbXA9RGF0ZS5ub3coKX0scm1kaXIocGFyZW50LG5hbWUpe3ZhciBub2RlPUZTLmxvb2t1cE5vZGUocGFyZW50LG5hbWUpO2Zvcih2YXIgaSBpbiBub2RlLmNvbnRlbnRzKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig1NSl9ZGVsZXRlIHBhcmVudC5jb250ZW50c1tuYW1lXTtwYXJlbnQudGltZXN0YW1wPURhdGUubm93KCl9LHJlYWRkaXIobm9kZSl7dmFyIGVudHJpZXM9WyIuIiwiLi4iXTtmb3IodmFyIGtleSBpbiBub2RlLmNvbnRlbnRzKXtpZighbm9kZS5jb250ZW50cy5oYXNPd25Qcm9wZXJ0eShrZXkpKXtjb250aW51ZX1lbnRyaWVzLnB1c2goa2V5KX1yZXR1cm4gZW50cmllc30sc3ltbGluayhwYXJlbnQsbmV3bmFtZSxvbGRwYXRoKXt2YXIgbm9kZT1NRU1GUy5jcmVhdGVOb2RlKHBhcmVudCxuZXduYW1lLDUxMXw0MDk2MCwwKTtub2RlLmxpbms9b2xkcGF0aDtyZXR1cm4gbm9kZX0scmVhZGxpbmsobm9kZSl7aWYoIUZTLmlzTGluayhub2RlLm1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOCl9cmV0dXJuIG5vZGUubGlua319LHN0cmVhbV9vcHM6e3JlYWQoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvc2l0aW9uKXt2YXIgY29udGVudHM9c3RyZWFtLm5vZGUuY29udGVudHM7aWYocG9zaXRpb24+PXN0cmVhbS5ub2RlLnVzZWRCeXRlcylyZXR1cm4gMDt2YXIgc2l6ZT1NYXRoLm1pbihzdHJlYW0ubm9kZS51c2VkQnl0ZXMtcG9zaXRpb24sbGVuZ3RoKTtpZihzaXplPjgmJmNvbnRlbnRzLnN1YmFycmF5KXtidWZmZXIuc2V0KGNvbnRlbnRzLnN1YmFycmF5KHBvc2l0aW9uLHBvc2l0aW9uK3NpemUpLG9mZnNldCl9ZWxzZXtmb3IodmFyIGk9MDtpPHNpemU7aSsrKWJ1ZmZlcltvZmZzZXQraV09Y29udGVudHNbcG9zaXRpb24raV19cmV0dXJuIHNpemV9LHdyaXRlKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3NpdGlvbixjYW5Pd24pe2lmKCFsZW5ndGgpcmV0dXJuIDA7dmFyIG5vZGU9c3RyZWFtLm5vZGU7bm9kZS50aW1lc3RhbXA9RGF0ZS5ub3coKTtpZihidWZmZXIuc3ViYXJyYXkmJighbm9kZS5jb250ZW50c3x8bm9kZS5jb250ZW50cy5zdWJhcnJheSkpe2lmKGNhbk93bil7bm9kZS5jb250ZW50cz1idWZmZXIuc3ViYXJyYXkob2Zmc2V0LG9mZnNldCtsZW5ndGgpO25vZGUudXNlZEJ5dGVzPWxlbmd0aDtyZXR1cm4gbGVuZ3RofWVsc2UgaWYobm9kZS51c2VkQnl0ZXM9PT0wJiZwb3NpdGlvbj09PTApe25vZGUuY29udGVudHM9YnVmZmVyLnNsaWNlKG9mZnNldCxvZmZzZXQrbGVuZ3RoKTtub2RlLnVzZWRCeXRlcz1sZW5ndGg7cmV0dXJuIGxlbmd0aH1lbHNlIGlmKHBvc2l0aW9uK2xlbmd0aDw9bm9kZS51c2VkQnl0ZXMpe25vZGUuY29udGVudHMuc2V0KGJ1ZmZlci5zdWJhcnJheShvZmZzZXQsb2Zmc2V0K2xlbmd0aCkscG9zaXRpb24pO3JldHVybiBsZW5ndGh9fU1FTUZTLmV4cGFuZEZpbGVTdG9yYWdlKG5vZGUscG9zaXRpb24rbGVuZ3RoKTtpZihub2RlLmNvbnRlbnRzLnN1YmFycmF5JiZidWZmZXIuc3ViYXJyYXkpe25vZGUuY29udGVudHMuc2V0KGJ1ZmZlci5zdWJhcnJheShvZmZzZXQsb2Zmc2V0K2xlbmd0aCkscG9zaXRpb24pfWVsc2V7Zm9yKHZhciBpPTA7aTxsZW5ndGg7aSsrKXtub2RlLmNvbnRlbnRzW3Bvc2l0aW9uK2ldPWJ1ZmZlcltvZmZzZXQraV19fW5vZGUudXNlZEJ5dGVzPU1hdGgubWF4KG5vZGUudXNlZEJ5dGVzLHBvc2l0aW9uK2xlbmd0aCk7cmV0dXJuIGxlbmd0aH0sbGxzZWVrKHN0cmVhbSxvZmZzZXQsd2hlbmNlKXt2YXIgcG9zaXRpb249b2Zmc2V0O2lmKHdoZW5jZT09PTEpe3Bvc2l0aW9uKz1zdHJlYW0ucG9zaXRpb259ZWxzZSBpZih3aGVuY2U9PT0yKXtpZihGUy5pc0ZpbGUoc3RyZWFtLm5vZGUubW9kZSkpe3Bvc2l0aW9uKz1zdHJlYW0ubm9kZS51c2VkQnl0ZXN9fWlmKHBvc2l0aW9uPDApe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX1yZXR1cm4gcG9zaXRpb259LGFsbG9jYXRlKHN0cmVhbSxvZmZzZXQsbGVuZ3RoKXtNRU1GUy5leHBhbmRGaWxlU3RvcmFnZShzdHJlYW0ubm9kZSxvZmZzZXQrbGVuZ3RoKTtzdHJlYW0ubm9kZS51c2VkQnl0ZXM9TWF0aC5tYXgoc3RyZWFtLm5vZGUudXNlZEJ5dGVzLG9mZnNldCtsZW5ndGgpfSxtbWFwKHN0cmVhbSxsZW5ndGgscG9zaXRpb24scHJvdCxmbGFncyl7aWYoIUZTLmlzRmlsZShzdHJlYW0ubm9kZS5tb2RlKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDMpfXZhciBwdHI7dmFyIGFsbG9jYXRlZDt2YXIgY29udGVudHM9c3RyZWFtLm5vZGUuY29udGVudHM7aWYoIShmbGFncyYyKSYmY29udGVudHMuYnVmZmVyPT09SEVBUDguYnVmZmVyKXthbGxvY2F0ZWQ9ZmFsc2U7cHRyPWNvbnRlbnRzLmJ5dGVPZmZzZXR9ZWxzZXtpZihwb3NpdGlvbj4wfHxwb3NpdGlvbitsZW5ndGg8Y29udGVudHMubGVuZ3RoKXtpZihjb250ZW50cy5zdWJhcnJheSl7Y29udGVudHM9Y29udGVudHMuc3ViYXJyYXkocG9zaXRpb24scG9zaXRpb24rbGVuZ3RoKX1lbHNle2NvbnRlbnRzPUFycmF5LnByb3RvdHlwZS5zbGljZS5jYWxsKGNvbnRlbnRzLHBvc2l0aW9uLHBvc2l0aW9uK2xlbmd0aCl9fWFsbG9jYXRlZD10cnVlO3B0cj1tbWFwQWxsb2MobGVuZ3RoKTtpZighcHRyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0OCl9SEVBUDguc2V0KGNvbnRlbnRzLHB0cil9cmV0dXJue3B0cjpwdHIsYWxsb2NhdGVkOmFsbG9jYXRlZH19LG1zeW5jKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxtbWFwRmxhZ3Mpe01FTUZTLnN0cmVhbV9vcHMud3JpdGUoc3RyZWFtLGJ1ZmZlciwwLGxlbmd0aCxvZmZzZXQsZmFsc2UpO3JldHVybiAwfX19O3ZhciBhc3luY0xvYWQ9KHVybCxvbmxvYWQsb25lcnJvcixub1J1bkRlcCk9Pnt2YXIgZGVwPSFub1J1bkRlcD9nZXRVbmlxdWVSdW5EZXBlbmRlbmN5KGBhbCAke3VybH1gKToiIjtyZWFkQXN5bmModXJsLGFycmF5QnVmZmVyPT57YXNzZXJ0KGFycmF5QnVmZmVyLGBMb2FkaW5nIGRhdGEgZmlsZSAiJHt1cmx9IiBmYWlsZWQgKG5vIGFycmF5QnVmZmVyKS5gKTtvbmxvYWQobmV3IFVpbnQ4QXJyYXkoYXJyYXlCdWZmZXIpKTtpZihkZXApcmVtb3ZlUnVuRGVwZW5kZW5jeShkZXApfSxldmVudD0+e2lmKG9uZXJyb3Ipe29uZXJyb3IoKX1lbHNle3Rocm93YExvYWRpbmcgZGF0YSBmaWxlICIke3VybH0iIGZhaWxlZC5gfX0pO2lmKGRlcClhZGRSdW5EZXBlbmRlbmN5KGRlcCl9O3ZhciBGU19jcmVhdGVEYXRhRmlsZT0ocGFyZW50LG5hbWUsZmlsZURhdGEsY2FuUmVhZCxjYW5Xcml0ZSxjYW5Pd24pPT57RlMuY3JlYXRlRGF0YUZpbGUocGFyZW50LG5hbWUsZmlsZURhdGEsY2FuUmVhZCxjYW5Xcml0ZSxjYW5Pd24pfTt2YXIgcHJlbG9hZFBsdWdpbnM9TW9kdWxlWyJwcmVsb2FkUGx1Z2lucyJdfHxbXTt2YXIgRlNfaGFuZGxlZEJ5UHJlbG9hZFBsdWdpbj0oYnl0ZUFycmF5LGZ1bGxuYW1lLGZpbmlzaCxvbmVycm9yKT0+e2lmKHR5cGVvZiBCcm93c2VyIT0idW5kZWZpbmVkIilCcm93c2VyLmluaXQoKTt2YXIgaGFuZGxlZD1mYWxzZTtwcmVsb2FkUGx1Z2lucy5mb3JFYWNoKHBsdWdpbj0+e2lmKGhhbmRsZWQpcmV0dXJuO2lmKHBsdWdpblsiY2FuSGFuZGxlIl0oZnVsbG5hbWUpKXtwbHVnaW5bImhhbmRsZSJdKGJ5dGVBcnJheSxmdWxsbmFtZSxmaW5pc2gsb25lcnJvcik7aGFuZGxlZD10cnVlfX0pO3JldHVybiBoYW5kbGVkfTt2YXIgRlNfY3JlYXRlUHJlbG9hZGVkRmlsZT0ocGFyZW50LG5hbWUsdXJsLGNhblJlYWQsY2FuV3JpdGUsb25sb2FkLG9uZXJyb3IsZG9udENyZWF0ZUZpbGUsY2FuT3duLHByZUZpbmlzaCk9Pnt2YXIgZnVsbG5hbWU9bmFtZT9QQVRIX0ZTLnJlc29sdmUoUEFUSC5qb2luMihwYXJlbnQsbmFtZSkpOnBhcmVudDt2YXIgZGVwPWdldFVuaXF1ZVJ1bkRlcGVuZGVuY3koYGNwICR7ZnVsbG5hbWV9YCk7ZnVuY3Rpb24gcHJvY2Vzc0RhdGEoYnl0ZUFycmF5KXtmdW5jdGlvbiBmaW5pc2goYnl0ZUFycmF5KXtpZihwcmVGaW5pc2gpcHJlRmluaXNoKCk7aWYoIWRvbnRDcmVhdGVGaWxlKXtGU19jcmVhdGVEYXRhRmlsZShwYXJlbnQsbmFtZSxieXRlQXJyYXksY2FuUmVhZCxjYW5Xcml0ZSxjYW5Pd24pfWlmKG9ubG9hZClvbmxvYWQoKTtyZW1vdmVSdW5EZXBlbmRlbmN5KGRlcCl9aWYoRlNfaGFuZGxlZEJ5UHJlbG9hZFBsdWdpbihieXRlQXJyYXksZnVsbG5hbWUsZmluaXNoLCgpPT57aWYob25lcnJvcilvbmVycm9yKCk7cmVtb3ZlUnVuRGVwZW5kZW5jeShkZXApfSkpe3JldHVybn1maW5pc2goYnl0ZUFycmF5KX1hZGRSdW5EZXBlbmRlbmN5KGRlcCk7aWYodHlwZW9mIHVybD09InN0cmluZyIpe2FzeW5jTG9hZCh1cmwsYnl0ZUFycmF5PT5wcm9jZXNzRGF0YShieXRlQXJyYXkpLG9uZXJyb3IpfWVsc2V7cHJvY2Vzc0RhdGEodXJsKX19O3ZhciBGU19tb2RlU3RyaW5nVG9GbGFncz1zdHI9Pnt2YXIgZmxhZ01vZGVzPXsiciI6MCwicisiOjIsInciOjUxMnw2NHwxLCJ3KyI6NTEyfDY0fDIsImEiOjEwMjR8NjR8MSwiYSsiOjEwMjR8NjR8Mn07dmFyIGZsYWdzPWZsYWdNb2Rlc1tzdHJdO2lmKHR5cGVvZiBmbGFncz09InVuZGVmaW5lZCIpe3Rocm93IG5ldyBFcnJvcihgVW5rbm93biBmaWxlIG9wZW4gbW9kZTogJHtzdHJ9YCl9cmV0dXJuIGZsYWdzfTt2YXIgRlNfZ2V0TW9kZT0oY2FuUmVhZCxjYW5Xcml0ZSk9Pnt2YXIgbW9kZT0wO2lmKGNhblJlYWQpbW9kZXw9MjkyfDczO2lmKGNhbldyaXRlKW1vZGV8PTE0NjtyZXR1cm4gbW9kZX07dmFyIEZTPXtyb290Om51bGwsbW91bnRzOltdLGRldmljZXM6e30sc3RyZWFtczpbXSxuZXh0SW5vZGU6MSxuYW1lVGFibGU6bnVsbCxjdXJyZW50UGF0aDoiLyIsaW5pdGlhbGl6ZWQ6ZmFsc2UsaWdub3JlUGVybWlzc2lvbnM6dHJ1ZSxFcnJub0Vycm9yOm51bGwsZ2VuZXJpY0Vycm9yczp7fSxmaWxlc3lzdGVtczpudWxsLHN5bmNGU1JlcXVlc3RzOjAsbG9va3VwUGF0aChwYXRoLG9wdHM9e30pe3BhdGg9UEFUSF9GUy5yZXNvbHZlKHBhdGgpO2lmKCFwYXRoKXJldHVybntwYXRoOiIiLG5vZGU6bnVsbH07dmFyIGRlZmF1bHRzPXtmb2xsb3dfbW91bnQ6dHJ1ZSxyZWN1cnNlX2NvdW50OjB9O29wdHM9T2JqZWN0LmFzc2lnbihkZWZhdWx0cyxvcHRzKTtpZihvcHRzLnJlY3Vyc2VfY291bnQ+OCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMzIpfXZhciBwYXJ0cz1wYXRoLnNwbGl0KCIvIikuZmlsdGVyKHA9PiEhcCk7dmFyIGN1cnJlbnQ9RlMucm9vdDt2YXIgY3VycmVudF9wYXRoPSIvIjtmb3IodmFyIGk9MDtpPHBhcnRzLmxlbmd0aDtpKyspe3ZhciBpc2xhc3Q9aT09PXBhcnRzLmxlbmd0aC0xO2lmKGlzbGFzdCYmb3B0cy5wYXJlbnQpe2JyZWFrfWN1cnJlbnQ9RlMubG9va3VwTm9kZShjdXJyZW50LHBhcnRzW2ldKTtjdXJyZW50X3BhdGg9UEFUSC5qb2luMihjdXJyZW50X3BhdGgscGFydHNbaV0pO2lmKEZTLmlzTW91bnRwb2ludChjdXJyZW50KSl7aWYoIWlzbGFzdHx8aXNsYXN0JiZvcHRzLmZvbGxvd19tb3VudCl7Y3VycmVudD1jdXJyZW50Lm1vdW50ZWQucm9vdH19aWYoIWlzbGFzdHx8b3B0cy5mb2xsb3cpe3ZhciBjb3VudD0wO3doaWxlKEZTLmlzTGluayhjdXJyZW50Lm1vZGUpKXt2YXIgbGluaz1GUy5yZWFkbGluayhjdXJyZW50X3BhdGgpO2N1cnJlbnRfcGF0aD1QQVRIX0ZTLnJlc29sdmUoUEFUSC5kaXJuYW1lKGN1cnJlbnRfcGF0aCksbGluayk7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKGN1cnJlbnRfcGF0aCx7cmVjdXJzZV9jb3VudDpvcHRzLnJlY3Vyc2VfY291bnQrMX0pO2N1cnJlbnQ9bG9va3VwLm5vZGU7aWYoY291bnQrKz40MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMzIpfX19fXJldHVybntwYXRoOmN1cnJlbnRfcGF0aCxub2RlOmN1cnJlbnR9fSxnZXRQYXRoKG5vZGUpe3ZhciBwYXRoO3doaWxlKHRydWUpe2lmKEZTLmlzUm9vdChub2RlKSl7dmFyIG1vdW50PW5vZGUubW91bnQubW91bnRwb2ludDtpZighcGF0aClyZXR1cm4gbW91bnQ7cmV0dXJuIG1vdW50W21vdW50Lmxlbmd0aC0xXSE9PSIvIj9gJHttb3VudH0vJHtwYXRofWA6bW91bnQrcGF0aH1wYXRoPXBhdGg/YCR7bm9kZS5uYW1lfS8ke3BhdGh9YDpub2RlLm5hbWU7bm9kZT1ub2RlLnBhcmVudH19LGhhc2hOYW1lKHBhcmVudGlkLG5hbWUpe3ZhciBoYXNoPTA7Zm9yKHZhciBpPTA7aTxuYW1lLmxlbmd0aDtpKyspe2hhc2g9KGhhc2g8PDUpLWhhc2grbmFtZS5jaGFyQ29kZUF0KGkpfDB9cmV0dXJuKHBhcmVudGlkK2hhc2g+Pj4wKSVGUy5uYW1lVGFibGUubGVuZ3RofSxoYXNoQWRkTm9kZShub2RlKXt2YXIgaGFzaD1GUy5oYXNoTmFtZShub2RlLnBhcmVudC5pZCxub2RlLm5hbWUpO25vZGUubmFtZV9uZXh0PUZTLm5hbWVUYWJsZVtoYXNoXTtGUy5uYW1lVGFibGVbaGFzaF09bm9kZX0saGFzaFJlbW92ZU5vZGUobm9kZSl7dmFyIGhhc2g9RlMuaGFzaE5hbWUobm9kZS5wYXJlbnQuaWQsbm9kZS5uYW1lKTtpZihGUy5uYW1lVGFibGVbaGFzaF09PT1ub2RlKXtGUy5uYW1lVGFibGVbaGFzaF09bm9kZS5uYW1lX25leHR9ZWxzZXt2YXIgY3VycmVudD1GUy5uYW1lVGFibGVbaGFzaF07d2hpbGUoY3VycmVudCl7aWYoY3VycmVudC5uYW1lX25leHQ9PT1ub2RlKXtjdXJyZW50Lm5hbWVfbmV4dD1ub2RlLm5hbWVfbmV4dDticmVha31jdXJyZW50PWN1cnJlbnQubmFtZV9uZXh0fX19LGxvb2t1cE5vZGUocGFyZW50LG5hbWUpe3ZhciBlcnJDb2RlPUZTLm1heUxvb2t1cChwYXJlbnQpO2lmKGVyckNvZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKGVyckNvZGUscGFyZW50KX12YXIgaGFzaD1GUy5oYXNoTmFtZShwYXJlbnQuaWQsbmFtZSk7Zm9yKHZhciBub2RlPUZTLm5hbWVUYWJsZVtoYXNoXTtub2RlO25vZGU9bm9kZS5uYW1lX25leHQpe3ZhciBub2RlTmFtZT1ub2RlLm5hbWU7aWYobm9kZS5wYXJlbnQuaWQ9PT1wYXJlbnQuaWQmJm5vZGVOYW1lPT09bmFtZSl7cmV0dXJuIG5vZGV9fXJldHVybiBGUy5sb29rdXAocGFyZW50LG5hbWUpfSxjcmVhdGVOb2RlKHBhcmVudCxuYW1lLG1vZGUscmRldil7dmFyIG5vZGU9bmV3IEZTLkZTTm9kZShwYXJlbnQsbmFtZSxtb2RlLHJkZXYpO0ZTLmhhc2hBZGROb2RlKG5vZGUpO3JldHVybiBub2RlfSxkZXN0cm95Tm9kZShub2RlKXtGUy5oYXNoUmVtb3ZlTm9kZShub2RlKX0saXNSb290KG5vZGUpe3JldHVybiBub2RlPT09bm9kZS5wYXJlbnR9LGlzTW91bnRwb2ludChub2RlKXtyZXR1cm4hIW5vZGUubW91bnRlZH0saXNGaWxlKG1vZGUpe3JldHVybihtb2RlJjYxNDQwKT09PTMyNzY4fSxpc0Rpcihtb2RlKXtyZXR1cm4obW9kZSY2MTQ0MCk9PT0xNjM4NH0saXNMaW5rKG1vZGUpe3JldHVybihtb2RlJjYxNDQwKT09PTQwOTYwfSxpc0NocmRldihtb2RlKXtyZXR1cm4obW9kZSY2MTQ0MCk9PT04MTkyfSxpc0Jsa2Rldihtb2RlKXtyZXR1cm4obW9kZSY2MTQ0MCk9PT0yNDU3Nn0saXNGSUZPKG1vZGUpe3JldHVybihtb2RlJjYxNDQwKT09PTQwOTZ9LGlzU29ja2V0KG1vZGUpe3JldHVybihtb2RlJjQ5MTUyKT09PTQ5MTUyfSxmbGFnc1RvUGVybWlzc2lvblN0cmluZyhmbGFnKXt2YXIgcGVybXM9WyJyIiwidyIsInJ3Il1bZmxhZyYzXTtpZihmbGFnJjUxMil7cGVybXMrPSJ3In1yZXR1cm4gcGVybXN9LG5vZGVQZXJtaXNzaW9ucyhub2RlLHBlcm1zKXtpZihGUy5pZ25vcmVQZXJtaXNzaW9ucyl7cmV0dXJuIDB9aWYocGVybXMuaW5jbHVkZXMoInIiKSYmIShub2RlLm1vZGUmMjkyKSl7cmV0dXJuIDJ9ZWxzZSBpZihwZXJtcy5pbmNsdWRlcygidyIpJiYhKG5vZGUubW9kZSYxNDYpKXtyZXR1cm4gMn1lbHNlIGlmKHBlcm1zLmluY2x1ZGVzKCJ4IikmJiEobm9kZS5tb2RlJjczKSl7cmV0dXJuIDJ9cmV0dXJuIDB9LG1heUxvb2t1cChkaXIpe3ZhciBlcnJDb2RlPUZTLm5vZGVQZXJtaXNzaW9ucyhkaXIsIngiKTtpZihlcnJDb2RlKXJldHVybiBlcnJDb2RlO2lmKCFkaXIubm9kZV9vcHMubG9va3VwKXJldHVybiAyO3JldHVybiAwfSxtYXlDcmVhdGUoZGlyLG5hbWUpe3RyeXt2YXIgbm9kZT1GUy5sb29rdXBOb2RlKGRpcixuYW1lKTtyZXR1cm4gMjB9Y2F0Y2goZSl7fXJldHVybiBGUy5ub2RlUGVybWlzc2lvbnMoZGlyLCJ3eCIpfSxtYXlEZWxldGUoZGlyLG5hbWUsaXNkaXIpe3ZhciBub2RlO3RyeXtub2RlPUZTLmxvb2t1cE5vZGUoZGlyLG5hbWUpfWNhdGNoKGUpe3JldHVybiBlLmVycm5vfXZhciBlcnJDb2RlPUZTLm5vZGVQZXJtaXNzaW9ucyhkaXIsInd4Iik7aWYoZXJyQ29kZSl7cmV0dXJuIGVyckNvZGV9aWYoaXNkaXIpe2lmKCFGUy5pc0Rpcihub2RlLm1vZGUpKXtyZXR1cm4gNTR9aWYoRlMuaXNSb290KG5vZGUpfHxGUy5nZXRQYXRoKG5vZGUpPT09RlMuY3dkKCkpe3JldHVybiAxMH19ZWxzZXtpZihGUy5pc0Rpcihub2RlLm1vZGUpKXtyZXR1cm4gMzF9fXJldHVybiAwfSxtYXlPcGVuKG5vZGUsZmxhZ3Mpe2lmKCFub2RlKXtyZXR1cm4gNDR9aWYoRlMuaXNMaW5rKG5vZGUubW9kZSkpe3JldHVybiAzMn1lbHNlIGlmKEZTLmlzRGlyKG5vZGUubW9kZSkpe2lmKEZTLmZsYWdzVG9QZXJtaXNzaW9uU3RyaW5nKGZsYWdzKSE9PSJyInx8ZmxhZ3MmNTEyKXtyZXR1cm4gMzF9fXJldHVybiBGUy5ub2RlUGVybWlzc2lvbnMobm9kZSxGUy5mbGFnc1RvUGVybWlzc2lvblN0cmluZyhmbGFncykpfSxNQVhfT1BFTl9GRFM6NDA5NixuZXh0ZmQoKXtmb3IodmFyIGZkPTA7ZmQ8PUZTLk1BWF9PUEVOX0ZEUztmZCsrKXtpZighRlMuc3RyZWFtc1tmZF0pe3JldHVybiBmZH19dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMzMpfSxnZXRTdHJlYW1DaGVja2VkKGZkKXt2YXIgc3RyZWFtPUZTLmdldFN0cmVhbShmZCk7aWYoIXN0cmVhbSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoOCl9cmV0dXJuIHN0cmVhbX0sZ2V0U3RyZWFtOmZkPT5GUy5zdHJlYW1zW2ZkXSxjcmVhdGVTdHJlYW0oc3RyZWFtLGZkPS0xKXtpZighRlMuRlNTdHJlYW0pe0ZTLkZTU3RyZWFtPWZ1bmN0aW9uKCl7dGhpcy5zaGFyZWQ9e319O0ZTLkZTU3RyZWFtLnByb3RvdHlwZT17fTtPYmplY3QuZGVmaW5lUHJvcGVydGllcyhGUy5GU1N0cmVhbS5wcm90b3R5cGUse29iamVjdDp7Z2V0KCl7cmV0dXJuIHRoaXMubm9kZX0sc2V0KHZhbCl7dGhpcy5ub2RlPXZhbH19LGlzUmVhZDp7Z2V0KCl7cmV0dXJuKHRoaXMuZmxhZ3MmMjA5NzE1NSkhPT0xfX0saXNXcml0ZTp7Z2V0KCl7cmV0dXJuKHRoaXMuZmxhZ3MmMjA5NzE1NSkhPT0wfX0saXNBcHBlbmQ6e2dldCgpe3JldHVybiB0aGlzLmZsYWdzJjEwMjR9fSxmbGFnczp7Z2V0KCl7cmV0dXJuIHRoaXMuc2hhcmVkLmZsYWdzfSxzZXQodmFsKXt0aGlzLnNoYXJlZC5mbGFncz12YWx9fSxwb3NpdGlvbjp7Z2V0KCl7cmV0dXJuIHRoaXMuc2hhcmVkLnBvc2l0aW9ufSxzZXQodmFsKXt0aGlzLnNoYXJlZC5wb3NpdGlvbj12YWx9fX0pfXN0cmVhbT1PYmplY3QuYXNzaWduKG5ldyBGUy5GU1N0cmVhbSxzdHJlYW0pO2lmKGZkPT0tMSl7ZmQ9RlMubmV4dGZkKCl9c3RyZWFtLmZkPWZkO0ZTLnN0cmVhbXNbZmRdPXN0cmVhbTtyZXR1cm4gc3RyZWFtfSxjbG9zZVN0cmVhbShmZCl7RlMuc3RyZWFtc1tmZF09bnVsbH0sY2hyZGV2X3N0cmVhbV9vcHM6e29wZW4oc3RyZWFtKXt2YXIgZGV2aWNlPUZTLmdldERldmljZShzdHJlYW0ubm9kZS5yZGV2KTtzdHJlYW0uc3RyZWFtX29wcz1kZXZpY2Uuc3RyZWFtX29wcztpZihzdHJlYW0uc3RyZWFtX29wcy5vcGVuKXtzdHJlYW0uc3RyZWFtX29wcy5vcGVuKHN0cmVhbSl9fSxsbHNlZWsoKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig3MCl9fSxtYWpvcjpkZXY9PmRldj4+OCxtaW5vcjpkZXY9PmRldiYyNTUsbWFrZWRldjoobWEsbWkpPT5tYTw8OHxtaSxyZWdpc3RlckRldmljZShkZXYsb3BzKXtGUy5kZXZpY2VzW2Rldl09e3N0cmVhbV9vcHM6b3BzfX0sZ2V0RGV2aWNlOmRldj0+RlMuZGV2aWNlc1tkZXZdLGdldE1vdW50cyhtb3VudCl7dmFyIG1vdW50cz1bXTt2YXIgY2hlY2s9W21vdW50XTt3aGlsZShjaGVjay5sZW5ndGgpe3ZhciBtPWNoZWNrLnBvcCgpO21vdW50cy5wdXNoKG0pO2NoZWNrLnB1c2guYXBwbHkoY2hlY2ssbS5tb3VudHMpfXJldHVybiBtb3VudHN9LHN5bmNmcyhwb3B1bGF0ZSxjYWxsYmFjayl7aWYodHlwZW9mIHBvcHVsYXRlPT0iZnVuY3Rpb24iKXtjYWxsYmFjaz1wb3B1bGF0ZTtwb3B1bGF0ZT1mYWxzZX1GUy5zeW5jRlNSZXF1ZXN0cysrO2lmKEZTLnN5bmNGU1JlcXVlc3RzPjEpe2Vycihgd2FybmluZzogJHtGUy5zeW5jRlNSZXF1ZXN0c30gRlMuc3luY2ZzIG9wZXJhdGlvbnMgaW4gZmxpZ2h0IGF0IG9uY2UsIHByb2JhYmx5IGp1c3QgZG9pbmcgZXh0cmEgd29ya2ApfXZhciBtb3VudHM9RlMuZ2V0TW91bnRzKEZTLnJvb3QubW91bnQpO3ZhciBjb21wbGV0ZWQ9MDtmdW5jdGlvbiBkb0NhbGxiYWNrKGVyckNvZGUpe0ZTLnN5bmNGU1JlcXVlc3RzLS07cmV0dXJuIGNhbGxiYWNrKGVyckNvZGUpfWZ1bmN0aW9uIGRvbmUoZXJyQ29kZSl7aWYoZXJyQ29kZSl7aWYoIWRvbmUuZXJyb3JlZCl7ZG9uZS5lcnJvcmVkPXRydWU7cmV0dXJuIGRvQ2FsbGJhY2soZXJyQ29kZSl9cmV0dXJufWlmKCsrY29tcGxldGVkPj1tb3VudHMubGVuZ3RoKXtkb0NhbGxiYWNrKG51bGwpfX1tb3VudHMuZm9yRWFjaChtb3VudD0+e2lmKCFtb3VudC50eXBlLnN5bmNmcyl7cmV0dXJuIGRvbmUobnVsbCl9bW91bnQudHlwZS5zeW5jZnMobW91bnQscG9wdWxhdGUsZG9uZSl9KX0sbW91bnQodHlwZSxvcHRzLG1vdW50cG9pbnQpe3ZhciByb290PW1vdW50cG9pbnQ9PT0iLyI7dmFyIHBzZXVkbz0hbW91bnRwb2ludDt2YXIgbm9kZTtpZihyb290JiZGUy5yb290KXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigxMCl9ZWxzZSBpZighcm9vdCYmIXBzZXVkbyl7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKG1vdW50cG9pbnQse2ZvbGxvd19tb3VudDpmYWxzZX0pO21vdW50cG9pbnQ9bG9va3VwLnBhdGg7bm9kZT1sb29rdXAubm9kZTtpZihGUy5pc01vdW50cG9pbnQobm9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDEwKX1pZighRlMuaXNEaXIobm9kZS5tb2RlKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNTQpfX12YXIgbW91bnQ9e3R5cGU6dHlwZSxvcHRzOm9wdHMsbW91bnRwb2ludDptb3VudHBvaW50LG1vdW50czpbXX07dmFyIG1vdW50Um9vdD10eXBlLm1vdW50KG1vdW50KTttb3VudFJvb3QubW91bnQ9bW91bnQ7bW91bnQucm9vdD1tb3VudFJvb3Q7aWYocm9vdCl7RlMucm9vdD1tb3VudFJvb3R9ZWxzZSBpZihub2RlKXtub2RlLm1vdW50ZWQ9bW91bnQ7aWYobm9kZS5tb3VudCl7bm9kZS5tb3VudC5tb3VudHMucHVzaChtb3VudCl9fXJldHVybiBtb3VudFJvb3R9LHVubW91bnQobW91bnRwb2ludCl7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKG1vdW50cG9pbnQse2ZvbGxvd19tb3VudDpmYWxzZX0pO2lmKCFGUy5pc01vdW50cG9pbnQobG9va3VwLm5vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOCl9dmFyIG5vZGU9bG9va3VwLm5vZGU7dmFyIG1vdW50PW5vZGUubW91bnRlZDt2YXIgbW91bnRzPUZTLmdldE1vdW50cyhtb3VudCk7T2JqZWN0LmtleXMoRlMubmFtZVRhYmxlKS5mb3JFYWNoKGhhc2g9Pnt2YXIgY3VycmVudD1GUy5uYW1lVGFibGVbaGFzaF07d2hpbGUoY3VycmVudCl7dmFyIG5leHQ9Y3VycmVudC5uYW1lX25leHQ7aWYobW91bnRzLmluY2x1ZGVzKGN1cnJlbnQubW91bnQpKXtGUy5kZXN0cm95Tm9kZShjdXJyZW50KX1jdXJyZW50PW5leHR9fSk7bm9kZS5tb3VudGVkPW51bGw7dmFyIGlkeD1ub2RlLm1vdW50Lm1vdW50cy5pbmRleE9mKG1vdW50KTtub2RlLm1vdW50Lm1vdW50cy5zcGxpY2UoaWR4LDEpfSxsb29rdXAocGFyZW50LG5hbWUpe3JldHVybiBwYXJlbnQubm9kZV9vcHMubG9va3VwKHBhcmVudCxuYW1lKX0sbWtub2QocGF0aCxtb2RlLGRldil7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse3BhcmVudDp0cnVlfSk7dmFyIHBhcmVudD1sb29rdXAubm9kZTt2YXIgbmFtZT1QQVRILmJhc2VuYW1lKHBhdGgpO2lmKCFuYW1lfHxuYW1lPT09Ii4ifHxuYW1lPT09Ii4uIil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfXZhciBlcnJDb2RlPUZTLm1heUNyZWF0ZShwYXJlbnQsbmFtZSk7aWYoZXJyQ29kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoZXJyQ29kZSl9aWYoIXBhcmVudC5ub2RlX29wcy5ta25vZCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNjMpfXJldHVybiBwYXJlbnQubm9kZV9vcHMubWtub2QocGFyZW50LG5hbWUsbW9kZSxkZXYpfSxjcmVhdGUocGF0aCxtb2RlKXttb2RlPW1vZGUhPT11bmRlZmluZWQ/bW9kZTo0Mzg7bW9kZSY9NDA5NTttb2RlfD0zMjc2ODtyZXR1cm4gRlMubWtub2QocGF0aCxtb2RlLDApfSxta2RpcihwYXRoLG1vZGUpe21vZGU9bW9kZSE9PXVuZGVmaW5lZD9tb2RlOjUxMTttb2RlJj01MTF8NTEyO21vZGV8PTE2Mzg0O3JldHVybiBGUy5ta25vZChwYXRoLG1vZGUsMCl9LG1rZGlyVHJlZShwYXRoLG1vZGUpe3ZhciBkaXJzPXBhdGguc3BsaXQoIi8iKTt2YXIgZD0iIjtmb3IodmFyIGk9MDtpPGRpcnMubGVuZ3RoOysraSl7aWYoIWRpcnNbaV0pY29udGludWU7ZCs9Ii8iK2RpcnNbaV07dHJ5e0ZTLm1rZGlyKGQsbW9kZSl9Y2F0Y2goZSl7aWYoZS5lcnJubyE9MjApdGhyb3cgZX19fSxta2RldihwYXRoLG1vZGUsZGV2KXtpZih0eXBlb2YgZGV2PT0idW5kZWZpbmVkIil7ZGV2PW1vZGU7bW9kZT00Mzh9bW9kZXw9ODE5MjtyZXR1cm4gRlMubWtub2QocGF0aCxtb2RlLGRldil9LHN5bWxpbmsob2xkcGF0aCxuZXdwYXRoKXtpZighUEFUSF9GUy5yZXNvbHZlKG9sZHBhdGgpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0NCl9dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKG5ld3BhdGgse3BhcmVudDp0cnVlfSk7dmFyIHBhcmVudD1sb29rdXAubm9kZTtpZighcGFyZW50KXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0NCl9dmFyIG5ld25hbWU9UEFUSC5iYXNlbmFtZShuZXdwYXRoKTt2YXIgZXJyQ29kZT1GUy5tYXlDcmVhdGUocGFyZW50LG5ld25hbWUpO2lmKGVyckNvZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKGVyckNvZGUpfWlmKCFwYXJlbnQubm9kZV9vcHMuc3ltbGluayl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNjMpfXJldHVybiBwYXJlbnQubm9kZV9vcHMuc3ltbGluayhwYXJlbnQsbmV3bmFtZSxvbGRwYXRoKX0scmVuYW1lKG9sZF9wYXRoLG5ld19wYXRoKXt2YXIgb2xkX2Rpcm5hbWU9UEFUSC5kaXJuYW1lKG9sZF9wYXRoKTt2YXIgbmV3X2Rpcm5hbWU9UEFUSC5kaXJuYW1lKG5ld19wYXRoKTt2YXIgb2xkX25hbWU9UEFUSC5iYXNlbmFtZShvbGRfcGF0aCk7dmFyIG5ld19uYW1lPVBBVEguYmFzZW5hbWUobmV3X3BhdGgpO3ZhciBsb29rdXAsb2xkX2RpcixuZXdfZGlyO2xvb2t1cD1GUy5sb29rdXBQYXRoKG9sZF9wYXRoLHtwYXJlbnQ6dHJ1ZX0pO29sZF9kaXI9bG9va3VwLm5vZGU7bG9va3VwPUZTLmxvb2t1cFBhdGgobmV3X3BhdGgse3BhcmVudDp0cnVlfSk7bmV3X2Rpcj1sb29rdXAubm9kZTtpZighb2xkX2Rpcnx8IW5ld19kaXIpdGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDQpO2lmKG9sZF9kaXIubW91bnQhPT1uZXdfZGlyLm1vdW50KXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig3NSl9dmFyIG9sZF9ub2RlPUZTLmxvb2t1cE5vZGUob2xkX2RpcixvbGRfbmFtZSk7dmFyIHJlbGF0aXZlPVBBVEhfRlMucmVsYXRpdmUob2xkX3BhdGgsbmV3X2Rpcm5hbWUpO2lmKHJlbGF0aXZlLmNoYXJBdCgwKSE9PSIuIil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfXJlbGF0aXZlPVBBVEhfRlMucmVsYXRpdmUobmV3X3BhdGgsb2xkX2Rpcm5hbWUpO2lmKHJlbGF0aXZlLmNoYXJBdCgwKSE9PSIuIil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNTUpfXZhciBuZXdfbm9kZTt0cnl7bmV3X25vZGU9RlMubG9va3VwTm9kZShuZXdfZGlyLG5ld19uYW1lKX1jYXRjaChlKXt9aWYob2xkX25vZGU9PT1uZXdfbm9kZSl7cmV0dXJufXZhciBpc2Rpcj1GUy5pc0RpcihvbGRfbm9kZS5tb2RlKTt2YXIgZXJyQ29kZT1GUy5tYXlEZWxldGUob2xkX2RpcixvbGRfbmFtZSxpc2Rpcik7aWYoZXJyQ29kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoZXJyQ29kZSl9ZXJyQ29kZT1uZXdfbm9kZT9GUy5tYXlEZWxldGUobmV3X2RpcixuZXdfbmFtZSxpc2Rpcik6RlMubWF5Q3JlYXRlKG5ld19kaXIsbmV3X25hbWUpO2lmKGVyckNvZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKGVyckNvZGUpfWlmKCFvbGRfZGlyLm5vZGVfb3BzLnJlbmFtZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNjMpfWlmKEZTLmlzTW91bnRwb2ludChvbGRfbm9kZSl8fG5ld19ub2RlJiZGUy5pc01vdW50cG9pbnQobmV3X25vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigxMCl9aWYobmV3X2RpciE9PW9sZF9kaXIpe2VyckNvZGU9RlMubm9kZVBlcm1pc3Npb25zKG9sZF9kaXIsInciKTtpZihlcnJDb2RlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcihlcnJDb2RlKX19RlMuaGFzaFJlbW92ZU5vZGUob2xkX25vZGUpO3RyeXtvbGRfZGlyLm5vZGVfb3BzLnJlbmFtZShvbGRfbm9kZSxuZXdfZGlyLG5ld19uYW1lKX1jYXRjaChlKXt0aHJvdyBlfWZpbmFsbHl7RlMuaGFzaEFkZE5vZGUob2xkX25vZGUpfX0scm1kaXIocGF0aCl7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse3BhcmVudDp0cnVlfSk7dmFyIHBhcmVudD1sb29rdXAubm9kZTt2YXIgbmFtZT1QQVRILmJhc2VuYW1lKHBhdGgpO3ZhciBub2RlPUZTLmxvb2t1cE5vZGUocGFyZW50LG5hbWUpO3ZhciBlcnJDb2RlPUZTLm1heURlbGV0ZShwYXJlbnQsbmFtZSx0cnVlKTtpZihlcnJDb2RlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcihlcnJDb2RlKX1pZighcGFyZW50Lm5vZGVfb3BzLnJtZGlyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9aWYoRlMuaXNNb3VudHBvaW50KG5vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigxMCl9cGFyZW50Lm5vZGVfb3BzLnJtZGlyKHBhcmVudCxuYW1lKTtGUy5kZXN0cm95Tm9kZShub2RlKX0scmVhZGRpcihwYXRoKXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7Zm9sbG93OnRydWV9KTt2YXIgbm9kZT1sb29rdXAubm9kZTtpZighbm9kZS5ub2RlX29wcy5yZWFkZGlyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig1NCl9cmV0dXJuIG5vZGUubm9kZV9vcHMucmVhZGRpcihub2RlKX0sdW5saW5rKHBhdGgpe3ZhciBsb29rdXA9RlMubG9va3VwUGF0aChwYXRoLHtwYXJlbnQ6dHJ1ZX0pO3ZhciBwYXJlbnQ9bG9va3VwLm5vZGU7aWYoIXBhcmVudCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDQpfXZhciBuYW1lPVBBVEguYmFzZW5hbWUocGF0aCk7dmFyIG5vZGU9RlMubG9va3VwTm9kZShwYXJlbnQsbmFtZSk7dmFyIGVyckNvZGU9RlMubWF5RGVsZXRlKHBhcmVudCxuYW1lLGZhbHNlKTtpZihlcnJDb2RlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcihlcnJDb2RlKX1pZighcGFyZW50Lm5vZGVfb3BzLnVubGluayl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNjMpfWlmKEZTLmlzTW91bnRwb2ludChub2RlKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMTApfXBhcmVudC5ub2RlX29wcy51bmxpbmsocGFyZW50LG5hbWUpO0ZTLmRlc3Ryb3lOb2RlKG5vZGUpfSxyZWFkbGluayhwYXRoKXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCk7dmFyIGxpbms9bG9va3VwLm5vZGU7aWYoIWxpbmspe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ0KX1pZighbGluay5ub2RlX29wcy5yZWFkbGluayl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjgpfXJldHVybiBQQVRIX0ZTLnJlc29sdmUoRlMuZ2V0UGF0aChsaW5rLnBhcmVudCksbGluay5ub2RlX29wcy5yZWFkbGluayhsaW5rKSl9LHN0YXQocGF0aCxkb250Rm9sbG93KXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7Zm9sbG93OiFkb250Rm9sbG93fSk7dmFyIG5vZGU9bG9va3VwLm5vZGU7aWYoIW5vZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ0KX1pZighbm9kZS5ub2RlX29wcy5nZXRhdHRyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig2Myl9cmV0dXJuIG5vZGUubm9kZV9vcHMuZ2V0YXR0cihub2RlKX0sbHN0YXQocGF0aCl7cmV0dXJuIEZTLnN0YXQocGF0aCx0cnVlKX0sY2htb2QocGF0aCxtb2RlLGRvbnRGb2xsb3cpe3ZhciBub2RlO2lmKHR5cGVvZiBwYXRoPT0ic3RyaW5nIil7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse2ZvbGxvdzohZG9udEZvbGxvd30pO25vZGU9bG9va3VwLm5vZGV9ZWxzZXtub2RlPXBhdGh9aWYoIW5vZGUubm9kZV9vcHMuc2V0YXR0cil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNjMpfW5vZGUubm9kZV9vcHMuc2V0YXR0cihub2RlLHttb2RlOm1vZGUmNDA5NXxub2RlLm1vZGUmfjQwOTUsdGltZXN0YW1wOkRhdGUubm93KCl9KX0sbGNobW9kKHBhdGgsbW9kZSl7RlMuY2htb2QocGF0aCxtb2RlLHRydWUpfSxmY2htb2QoZmQsbW9kZSl7dmFyIHN0cmVhbT1GUy5nZXRTdHJlYW1DaGVja2VkKGZkKTtGUy5jaG1vZChzdHJlYW0ubm9kZSxtb2RlKX0sY2hvd24ocGF0aCx1aWQsZ2lkLGRvbnRGb2xsb3cpe3ZhciBub2RlO2lmKHR5cGVvZiBwYXRoPT0ic3RyaW5nIil7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse2ZvbGxvdzohZG9udEZvbGxvd30pO25vZGU9bG9va3VwLm5vZGV9ZWxzZXtub2RlPXBhdGh9aWYoIW5vZGUubm9kZV9vcHMuc2V0YXR0cil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNjMpfW5vZGUubm9kZV9vcHMuc2V0YXR0cihub2RlLHt0aW1lc3RhbXA6RGF0ZS5ub3coKX0pfSxsY2hvd24ocGF0aCx1aWQsZ2lkKXtGUy5jaG93bihwYXRoLHVpZCxnaWQsdHJ1ZSl9LGZjaG93bihmZCx1aWQsZ2lkKXt2YXIgc3RyZWFtPUZTLmdldFN0cmVhbUNoZWNrZWQoZmQpO0ZTLmNob3duKHN0cmVhbS5ub2RlLHVpZCxnaWQpfSx0cnVuY2F0ZShwYXRoLGxlbil7aWYobGVuPDApe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX12YXIgbm9kZTtpZih0eXBlb2YgcGF0aD09InN0cmluZyIpe3ZhciBsb29rdXA9RlMubG9va3VwUGF0aChwYXRoLHtmb2xsb3c6dHJ1ZX0pO25vZGU9bG9va3VwLm5vZGV9ZWxzZXtub2RlPXBhdGh9aWYoIW5vZGUubm9kZV9vcHMuc2V0YXR0cil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNjMpfWlmKEZTLmlzRGlyKG5vZGUubW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDMxKX1pZighRlMuaXNGaWxlKG5vZGUubW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX12YXIgZXJyQ29kZT1GUy5ub2RlUGVybWlzc2lvbnMobm9kZSwidyIpO2lmKGVyckNvZGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKGVyckNvZGUpfW5vZGUubm9kZV9vcHMuc2V0YXR0cihub2RlLHtzaXplOmxlbix0aW1lc3RhbXA6RGF0ZS5ub3coKX0pfSxmdHJ1bmNhdGUoZmQsbGVuKXt2YXIgc3RyZWFtPUZTLmdldFN0cmVhbUNoZWNrZWQoZmQpO2lmKChzdHJlYW0uZmxhZ3MmMjA5NzE1NSk9PT0wKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOCl9RlMudHJ1bmNhdGUoc3RyZWFtLm5vZGUsbGVuKX0sdXRpbWUocGF0aCxhdGltZSxtdGltZSl7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse2ZvbGxvdzp0cnVlfSk7dmFyIG5vZGU9bG9va3VwLm5vZGU7bm9kZS5ub2RlX29wcy5zZXRhdHRyKG5vZGUse3RpbWVzdGFtcDpNYXRoLm1heChhdGltZSxtdGltZSl9KX0sb3BlbihwYXRoLGZsYWdzLG1vZGUpe2lmKHBhdGg9PT0iIil7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDQpfWZsYWdzPXR5cGVvZiBmbGFncz09InN0cmluZyI/RlNfbW9kZVN0cmluZ1RvRmxhZ3MoZmxhZ3MpOmZsYWdzO21vZGU9dHlwZW9mIG1vZGU9PSJ1bmRlZmluZWQiPzQzODptb2RlO2lmKGZsYWdzJjY0KXttb2RlPW1vZGUmNDA5NXwzMjc2OH1lbHNle21vZGU9MH12YXIgbm9kZTtpZih0eXBlb2YgcGF0aD09Im9iamVjdCIpe25vZGU9cGF0aH1lbHNle3BhdGg9UEFUSC5ub3JtYWxpemUocGF0aCk7dHJ5e3ZhciBsb29rdXA9RlMubG9va3VwUGF0aChwYXRoLHtmb2xsb3c6IShmbGFncyYxMzEwNzIpfSk7bm9kZT1sb29rdXAubm9kZX1jYXRjaChlKXt9fXZhciBjcmVhdGVkPWZhbHNlO2lmKGZsYWdzJjY0KXtpZihub2RlKXtpZihmbGFncyYxMjgpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDIwKX19ZWxzZXtub2RlPUZTLm1rbm9kKHBhdGgsbW9kZSwwKTtjcmVhdGVkPXRydWV9fWlmKCFub2RlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0NCl9aWYoRlMuaXNDaHJkZXYobm9kZS5tb2RlKSl7ZmxhZ3MmPX41MTJ9aWYoZmxhZ3MmNjU1MzYmJiFGUy5pc0Rpcihub2RlLm1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig1NCl9aWYoIWNyZWF0ZWQpe3ZhciBlcnJDb2RlPUZTLm1heU9wZW4obm9kZSxmbGFncyk7aWYoZXJyQ29kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoZXJyQ29kZSl9fWlmKGZsYWdzJjUxMiYmIWNyZWF0ZWQpe0ZTLnRydW5jYXRlKG5vZGUsMCl9ZmxhZ3MmPX4oMTI4fDUxMnwxMzEwNzIpO3ZhciBzdHJlYW09RlMuY3JlYXRlU3RyZWFtKHtub2RlOm5vZGUscGF0aDpGUy5nZXRQYXRoKG5vZGUpLGZsYWdzOmZsYWdzLHNlZWthYmxlOnRydWUscG9zaXRpb246MCxzdHJlYW1fb3BzOm5vZGUuc3RyZWFtX29wcyx1bmdvdHRlbjpbXSxlcnJvcjpmYWxzZX0pO2lmKHN0cmVhbS5zdHJlYW1fb3BzLm9wZW4pe3N0cmVhbS5zdHJlYW1fb3BzLm9wZW4oc3RyZWFtKX1pZihNb2R1bGVbImxvZ1JlYWRGaWxlcyJdJiYhKGZsYWdzJjEpKXtpZighRlMucmVhZEZpbGVzKUZTLnJlYWRGaWxlcz17fTtpZighKHBhdGggaW4gRlMucmVhZEZpbGVzKSl7RlMucmVhZEZpbGVzW3BhdGhdPTF9fXJldHVybiBzdHJlYW19LGNsb3NlKHN0cmVhbSl7aWYoRlMuaXNDbG9zZWQoc3RyZWFtKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoOCl9aWYoc3RyZWFtLmdldGRlbnRzKXN0cmVhbS5nZXRkZW50cz1udWxsO3RyeXtpZihzdHJlYW0uc3RyZWFtX29wcy5jbG9zZSl7c3RyZWFtLnN0cmVhbV9vcHMuY2xvc2Uoc3RyZWFtKX19Y2F0Y2goZSl7dGhyb3cgZX1maW5hbGx5e0ZTLmNsb3NlU3RyZWFtKHN0cmVhbS5mZCl9c3RyZWFtLmZkPW51bGx9LGlzQ2xvc2VkKHN0cmVhbSl7cmV0dXJuIHN0cmVhbS5mZD09PW51bGx9LGxsc2VlayhzdHJlYW0sb2Zmc2V0LHdoZW5jZSl7aWYoRlMuaXNDbG9zZWQoc3RyZWFtKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoOCl9aWYoIXN0cmVhbS5zZWVrYWJsZXx8IXN0cmVhbS5zdHJlYW1fb3BzLmxsc2Vlayl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNzApfWlmKHdoZW5jZSE9MCYmd2hlbmNlIT0xJiZ3aGVuY2UhPTIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX1zdHJlYW0ucG9zaXRpb249c3RyZWFtLnN0cmVhbV9vcHMubGxzZWVrKHN0cmVhbSxvZmZzZXQsd2hlbmNlKTtzdHJlYW0udW5nb3R0ZW49W107cmV0dXJuIHN0cmVhbS5wb3NpdGlvbn0scmVhZChzdHJlYW0sYnVmZmVyLG9mZnNldCxsZW5ndGgscG9zaXRpb24pe2lmKGxlbmd0aDwwfHxwb3NpdGlvbjwwKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOCl9aWYoRlMuaXNDbG9zZWQoc3RyZWFtKSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoOCl9aWYoKHN0cmVhbS5mbGFncyYyMDk3MTU1KT09PTEpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDgpfWlmKEZTLmlzRGlyKHN0cmVhbS5ub2RlLm1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigzMSl9aWYoIXN0cmVhbS5zdHJlYW1fb3BzLnJlYWQpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX12YXIgc2Vla2luZz10eXBlb2YgcG9zaXRpb24hPSJ1bmRlZmluZWQiO2lmKCFzZWVraW5nKXtwb3NpdGlvbj1zdHJlYW0ucG9zaXRpb259ZWxzZSBpZighc3RyZWFtLnNlZWthYmxlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig3MCl9dmFyIGJ5dGVzUmVhZD1zdHJlYW0uc3RyZWFtX29wcy5yZWFkKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3NpdGlvbik7aWYoIXNlZWtpbmcpc3RyZWFtLnBvc2l0aW9uKz1ieXRlc1JlYWQ7cmV0dXJuIGJ5dGVzUmVhZH0sd3JpdGUoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvc2l0aW9uLGNhbk93bil7aWYobGVuZ3RoPDB8fHBvc2l0aW9uPDApe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX1pZihGUy5pc0Nsb3NlZChzdHJlYW0pKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig4KX1pZigoc3RyZWFtLmZsYWdzJjIwOTcxNTUpPT09MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoOCl9aWYoRlMuaXNEaXIoc3RyZWFtLm5vZGUubW9kZSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDMxKX1pZighc3RyZWFtLnN0cmVhbV9vcHMud3JpdGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX1pZihzdHJlYW0uc2Vla2FibGUmJnN0cmVhbS5mbGFncyYxMDI0KXtGUy5sbHNlZWsoc3RyZWFtLDAsMil9dmFyIHNlZWtpbmc9dHlwZW9mIHBvc2l0aW9uIT0idW5kZWZpbmVkIjtpZighc2Vla2luZyl7cG9zaXRpb249c3RyZWFtLnBvc2l0aW9ufWVsc2UgaWYoIXN0cmVhbS5zZWVrYWJsZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNzApfXZhciBieXRlc1dyaXR0ZW49c3RyZWFtLnN0cmVhbV9vcHMud3JpdGUoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvc2l0aW9uLGNhbk93bik7aWYoIXNlZWtpbmcpc3RyZWFtLnBvc2l0aW9uKz1ieXRlc1dyaXR0ZW47cmV0dXJuIGJ5dGVzV3JpdHRlbn0sYWxsb2NhdGUoc3RyZWFtLG9mZnNldCxsZW5ndGgpe2lmKEZTLmlzQ2xvc2VkKHN0cmVhbSkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDgpfWlmKG9mZnNldDwwfHxsZW5ndGg8PTApe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI4KX1pZigoc3RyZWFtLmZsYWdzJjIwOTcxNTUpPT09MCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoOCl9aWYoIUZTLmlzRmlsZShzdHJlYW0ubm9kZS5tb2RlKSYmIUZTLmlzRGlyKHN0cmVhbS5ub2RlLm1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0Myl9aWYoIXN0cmVhbS5zdHJlYW1fb3BzLmFsbG9jYXRlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigxMzgpfXN0cmVhbS5zdHJlYW1fb3BzLmFsbG9jYXRlKHN0cmVhbSxvZmZzZXQsbGVuZ3RoKX0sbW1hcChzdHJlYW0sbGVuZ3RoLHBvc2l0aW9uLHByb3QsZmxhZ3Mpe2lmKChwcm90JjIpIT09MCYmKGZsYWdzJjIpPT09MCYmKHN0cmVhbS5mbGFncyYyMDk3MTU1KSE9PTIpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDIpfWlmKChzdHJlYW0uZmxhZ3MmMjA5NzE1NSk9PT0xKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyKX1pZighc3RyZWFtLnN0cmVhbV9vcHMubW1hcCl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoNDMpfXJldHVybiBzdHJlYW0uc3RyZWFtX29wcy5tbWFwKHN0cmVhbSxsZW5ndGgscG9zaXRpb24scHJvdCxmbGFncyl9LG1zeW5jKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxtbWFwRmxhZ3Mpe2lmKCFzdHJlYW0uc3RyZWFtX29wcy5tc3luYyl7cmV0dXJuIDB9cmV0dXJuIHN0cmVhbS5zdHJlYW1fb3BzLm1zeW5jKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxtbWFwRmxhZ3MpfSxtdW5tYXA6c3RyZWFtPT4wLGlvY3RsKHN0cmVhbSxjbWQsYXJnKXtpZighc3RyZWFtLnN0cmVhbV9vcHMuaW9jdGwpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDU5KX1yZXR1cm4gc3RyZWFtLnN0cmVhbV9vcHMuaW9jdGwoc3RyZWFtLGNtZCxhcmcpfSxyZWFkRmlsZShwYXRoLG9wdHM9e30pe29wdHMuZmxhZ3M9b3B0cy5mbGFnc3x8MDtvcHRzLmVuY29kaW5nPW9wdHMuZW5jb2Rpbmd8fCJiaW5hcnkiO2lmKG9wdHMuZW5jb2RpbmchPT0idXRmOCImJm9wdHMuZW5jb2RpbmchPT0iYmluYXJ5Iil7dGhyb3cgbmV3IEVycm9yKGBJbnZhbGlkIGVuY29kaW5nIHR5cGUgIiR7b3B0cy5lbmNvZGluZ30iYCl9dmFyIHJldDt2YXIgc3RyZWFtPUZTLm9wZW4ocGF0aCxvcHRzLmZsYWdzKTt2YXIgc3RhdD1GUy5zdGF0KHBhdGgpO3ZhciBsZW5ndGg9c3RhdC5zaXplO3ZhciBidWY9bmV3IFVpbnQ4QXJyYXkobGVuZ3RoKTtGUy5yZWFkKHN0cmVhbSxidWYsMCxsZW5ndGgsMCk7aWYob3B0cy5lbmNvZGluZz09PSJ1dGY4Iil7cmV0PVVURjhBcnJheVRvU3RyaW5nKGJ1ZiwwKX1lbHNlIGlmKG9wdHMuZW5jb2Rpbmc9PT0iYmluYXJ5Iil7cmV0PWJ1Zn1GUy5jbG9zZShzdHJlYW0pO3JldHVybiByZXR9LHdyaXRlRmlsZShwYXRoLGRhdGEsb3B0cz17fSl7b3B0cy5mbGFncz1vcHRzLmZsYWdzfHw1Nzc7dmFyIHN0cmVhbT1GUy5vcGVuKHBhdGgsb3B0cy5mbGFncyxvcHRzLm1vZGUpO2lmKHR5cGVvZiBkYXRhPT0ic3RyaW5nIil7dmFyIGJ1Zj1uZXcgVWludDhBcnJheShsZW5ndGhCeXRlc1VURjgoZGF0YSkrMSk7dmFyIGFjdHVhbE51bUJ5dGVzPXN0cmluZ1RvVVRGOEFycmF5KGRhdGEsYnVmLDAsYnVmLmxlbmd0aCk7RlMud3JpdGUoc3RyZWFtLGJ1ZiwwLGFjdHVhbE51bUJ5dGVzLHVuZGVmaW5lZCxvcHRzLmNhbk93bil9ZWxzZSBpZihBcnJheUJ1ZmZlci5pc1ZpZXcoZGF0YSkpe0ZTLndyaXRlKHN0cmVhbSxkYXRhLDAsZGF0YS5ieXRlTGVuZ3RoLHVuZGVmaW5lZCxvcHRzLmNhbk93bil9ZWxzZXt0aHJvdyBuZXcgRXJyb3IoIlVuc3VwcG9ydGVkIGRhdGEgdHlwZSIpfUZTLmNsb3NlKHN0cmVhbSl9LGN3ZDooKT0+RlMuY3VycmVudFBhdGgsY2hkaXIocGF0aCl7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse2ZvbGxvdzp0cnVlfSk7aWYobG9va3VwLm5vZGU9PT1udWxsKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0NCl9aWYoIUZTLmlzRGlyKGxvb2t1cC5ub2RlLm1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig1NCl9dmFyIGVyckNvZGU9RlMubm9kZVBlcm1pc3Npb25zKGxvb2t1cC5ub2RlLCJ4Iik7aWYoZXJyQ29kZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoZXJyQ29kZSl9RlMuY3VycmVudFBhdGg9bG9va3VwLnBhdGh9LGNyZWF0ZURlZmF1bHREaXJlY3Rvcmllcygpe0ZTLm1rZGlyKCIvdG1wIik7RlMubWtkaXIoIi9ob21lIik7RlMubWtkaXIoIi9ob21lL3dlYl91c2VyIil9LGNyZWF0ZURlZmF1bHREZXZpY2VzKCl7RlMubWtkaXIoIi9kZXYiKTtGUy5yZWdpc3RlckRldmljZShGUy5tYWtlZGV2KDEsMykse3JlYWQ6KCk9PjAsd3JpdGU6KHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3MpPT5sZW5ndGh9KTtGUy5ta2RldigiL2Rldi9udWxsIixGUy5tYWtlZGV2KDEsMykpO1RUWS5yZWdpc3RlcihGUy5tYWtlZGV2KDUsMCksVFRZLmRlZmF1bHRfdHR5X29wcyk7VFRZLnJlZ2lzdGVyKEZTLm1ha2VkZXYoNiwwKSxUVFkuZGVmYXVsdF90dHkxX29wcyk7RlMubWtkZXYoIi9kZXYvdHR5IixGUy5tYWtlZGV2KDUsMCkpO0ZTLm1rZGV2KCIvZGV2L3R0eTEiLEZTLm1ha2VkZXYoNiwwKSk7dmFyIHJhbmRvbUJ1ZmZlcj1uZXcgVWludDhBcnJheSgxMDI0KSxyYW5kb21MZWZ0PTA7dmFyIHJhbmRvbUJ5dGU9KCk9PntpZihyYW5kb21MZWZ0PT09MCl7cmFuZG9tTGVmdD1yYW5kb21GaWxsKHJhbmRvbUJ1ZmZlcikuYnl0ZUxlbmd0aH1yZXR1cm4gcmFuZG9tQnVmZmVyWy0tcmFuZG9tTGVmdF19O0ZTLmNyZWF0ZURldmljZSgiL2RldiIsInJhbmRvbSIscmFuZG9tQnl0ZSk7RlMuY3JlYXRlRGV2aWNlKCIvZGV2IiwidXJhbmRvbSIscmFuZG9tQnl0ZSk7RlMubWtkaXIoIi9kZXYvc2htIik7RlMubWtkaXIoIi9kZXYvc2htL3RtcCIpfSxjcmVhdGVTcGVjaWFsRGlyZWN0b3JpZXMoKXtGUy5ta2RpcigiL3Byb2MiKTt2YXIgcHJvY19zZWxmPUZTLm1rZGlyKCIvcHJvYy9zZWxmIik7RlMubWtkaXIoIi9wcm9jL3NlbGYvZmQiKTtGUy5tb3VudCh7bW91bnQoKXt2YXIgbm9kZT1GUy5jcmVhdGVOb2RlKHByb2Nfc2VsZiwiZmQiLDE2Mzg0fDUxMSw3Myk7bm9kZS5ub2RlX29wcz17bG9va3VwKHBhcmVudCxuYW1lKXt2YXIgZmQ9K25hbWU7dmFyIHN0cmVhbT1GUy5nZXRTdHJlYW1DaGVja2VkKGZkKTt2YXIgcmV0PXtwYXJlbnQ6bnVsbCxtb3VudDp7bW91bnRwb2ludDoiZmFrZSJ9LG5vZGVfb3BzOntyZWFkbGluazooKT0+c3RyZWFtLnBhdGh9fTtyZXQucGFyZW50PXJldDtyZXR1cm4gcmV0fX07cmV0dXJuIG5vZGV9fSx7fSwiL3Byb2Mvc2VsZi9mZCIpfSxjcmVhdGVTdGFuZGFyZFN0cmVhbXMoKXtpZihNb2R1bGVbInN0ZGluIl0pe0ZTLmNyZWF0ZURldmljZSgiL2RldiIsInN0ZGluIixNb2R1bGVbInN0ZGluIl0pfWVsc2V7RlMuc3ltbGluaygiL2Rldi90dHkiLCIvZGV2L3N0ZGluIil9aWYoTW9kdWxlWyJzdGRvdXQiXSl7RlMuY3JlYXRlRGV2aWNlKCIvZGV2Iiwic3Rkb3V0IixudWxsLE1vZHVsZVsic3Rkb3V0Il0pfWVsc2V7RlMuc3ltbGluaygiL2Rldi90dHkiLCIvZGV2L3N0ZG91dCIpfWlmKE1vZHVsZVsic3RkZXJyIl0pe0ZTLmNyZWF0ZURldmljZSgiL2RldiIsInN0ZGVyciIsbnVsbCxNb2R1bGVbInN0ZGVyciJdKX1lbHNle0ZTLnN5bWxpbmsoIi9kZXYvdHR5MSIsIi9kZXYvc3RkZXJyIil9dmFyIHN0ZGluPUZTLm9wZW4oIi9kZXYvc3RkaW4iLDApO3ZhciBzdGRvdXQ9RlMub3BlbigiL2Rldi9zdGRvdXQiLDEpO3ZhciBzdGRlcnI9RlMub3BlbigiL2Rldi9zdGRlcnIiLDEpfSxlbnN1cmVFcnJub0Vycm9yKCl7aWYoRlMuRXJybm9FcnJvcilyZXR1cm47RlMuRXJybm9FcnJvcj1mdW5jdGlvbiBFcnJub0Vycm9yKGVycm5vLG5vZGUpe3RoaXMubmFtZT0iRXJybm9FcnJvciI7dGhpcy5ub2RlPW5vZGU7dGhpcy5zZXRFcnJubz1mdW5jdGlvbihlcnJubyl7dGhpcy5lcnJubz1lcnJub307dGhpcy5zZXRFcnJubyhlcnJubyk7dGhpcy5tZXNzYWdlPSJGUyBlcnJvciJ9O0ZTLkVycm5vRXJyb3IucHJvdG90eXBlPW5ldyBFcnJvcjtGUy5FcnJub0Vycm9yLnByb3RvdHlwZS5jb25zdHJ1Y3Rvcj1GUy5FcnJub0Vycm9yO1s0NF0uZm9yRWFjaChjb2RlPT57RlMuZ2VuZXJpY0Vycm9yc1tjb2RlXT1uZXcgRlMuRXJybm9FcnJvcihjb2RlKTtGUy5nZW5lcmljRXJyb3JzW2NvZGVdLnN0YWNrPSI8Z2VuZXJpYyBlcnJvciwgbm8gc3RhY2s+In0pfSxzdGF0aWNJbml0KCl7RlMuZW5zdXJlRXJybm9FcnJvcigpO0ZTLm5hbWVUYWJsZT1uZXcgQXJyYXkoNDA5Nik7RlMubW91bnQoTUVNRlMse30sIi8iKTtGUy5jcmVhdGVEZWZhdWx0RGlyZWN0b3JpZXMoKTtGUy5jcmVhdGVEZWZhdWx0RGV2aWNlcygpO0ZTLmNyZWF0ZVNwZWNpYWxEaXJlY3RvcmllcygpO0ZTLmZpbGVzeXN0ZW1zPXsiTUVNRlMiOk1FTUZTfX0saW5pdChpbnB1dCxvdXRwdXQsZXJyb3Ipe0ZTLmluaXQuaW5pdGlhbGl6ZWQ9dHJ1ZTtGUy5lbnN1cmVFcnJub0Vycm9yKCk7TW9kdWxlWyJzdGRpbiJdPWlucHV0fHxNb2R1bGVbInN0ZGluIl07TW9kdWxlWyJzdGRvdXQiXT1vdXRwdXR8fE1vZHVsZVsic3Rkb3V0Il07TW9kdWxlWyJzdGRlcnIiXT1lcnJvcnx8TW9kdWxlWyJzdGRlcnIiXTtGUy5jcmVhdGVTdGFuZGFyZFN0cmVhbXMoKX0scXVpdCgpe0ZTLmluaXQuaW5pdGlhbGl6ZWQ9ZmFsc2U7X2ZmbHVzaCgwKTtmb3IodmFyIGk9MDtpPEZTLnN0cmVhbXMubGVuZ3RoO2krKyl7dmFyIHN0cmVhbT1GUy5zdHJlYW1zW2ldO2lmKCFzdHJlYW0pe2NvbnRpbnVlfUZTLmNsb3NlKHN0cmVhbSl9fSxmaW5kT2JqZWN0KHBhdGgsZG9udFJlc29sdmVMYXN0TGluayl7dmFyIHJldD1GUy5hbmFseXplUGF0aChwYXRoLGRvbnRSZXNvbHZlTGFzdExpbmspO2lmKCFyZXQuZXhpc3RzKXtyZXR1cm4gbnVsbH1yZXR1cm4gcmV0Lm9iamVjdH0sYW5hbHl6ZVBhdGgocGF0aCxkb250UmVzb2x2ZUxhc3RMaW5rKXt0cnl7dmFyIGxvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse2ZvbGxvdzohZG9udFJlc29sdmVMYXN0TGlua30pO3BhdGg9bG9va3VwLnBhdGh9Y2F0Y2goZSl7fXZhciByZXQ9e2lzUm9vdDpmYWxzZSxleGlzdHM6ZmFsc2UsZXJyb3I6MCxuYW1lOm51bGwscGF0aDpudWxsLG9iamVjdDpudWxsLHBhcmVudEV4aXN0czpmYWxzZSxwYXJlbnRQYXRoOm51bGwscGFyZW50T2JqZWN0Om51bGx9O3RyeXt2YXIgbG9va3VwPUZTLmxvb2t1cFBhdGgocGF0aCx7cGFyZW50OnRydWV9KTtyZXQucGFyZW50RXhpc3RzPXRydWU7cmV0LnBhcmVudFBhdGg9bG9va3VwLnBhdGg7cmV0LnBhcmVudE9iamVjdD1sb29rdXAubm9kZTtyZXQubmFtZT1QQVRILmJhc2VuYW1lKHBhdGgpO2xvb2t1cD1GUy5sb29rdXBQYXRoKHBhdGgse2ZvbGxvdzohZG9udFJlc29sdmVMYXN0TGlua30pO3JldC5leGlzdHM9dHJ1ZTtyZXQucGF0aD1sb29rdXAucGF0aDtyZXQub2JqZWN0PWxvb2t1cC5ub2RlO3JldC5uYW1lPWxvb2t1cC5ub2RlLm5hbWU7cmV0LmlzUm9vdD1sb29rdXAucGF0aD09PSIvIn1jYXRjaChlKXtyZXQuZXJyb3I9ZS5lcnJub31yZXR1cm4gcmV0fSxjcmVhdGVQYXRoKHBhcmVudCxwYXRoLGNhblJlYWQsY2FuV3JpdGUpe3BhcmVudD10eXBlb2YgcGFyZW50PT0ic3RyaW5nIj9wYXJlbnQ6RlMuZ2V0UGF0aChwYXJlbnQpO3ZhciBwYXJ0cz1wYXRoLnNwbGl0KCIvIikucmV2ZXJzZSgpO3doaWxlKHBhcnRzLmxlbmd0aCl7dmFyIHBhcnQ9cGFydHMucG9wKCk7aWYoIXBhcnQpY29udGludWU7dmFyIGN1cnJlbnQ9UEFUSC5qb2luMihwYXJlbnQscGFydCk7dHJ5e0ZTLm1rZGlyKGN1cnJlbnQpfWNhdGNoKGUpe31wYXJlbnQ9Y3VycmVudH1yZXR1cm4gY3VycmVudH0sY3JlYXRlRmlsZShwYXJlbnQsbmFtZSxwcm9wZXJ0aWVzLGNhblJlYWQsY2FuV3JpdGUpe3ZhciBwYXRoPVBBVEguam9pbjIodHlwZW9mIHBhcmVudD09InN0cmluZyI/cGFyZW50OkZTLmdldFBhdGgocGFyZW50KSxuYW1lKTt2YXIgbW9kZT1GU19nZXRNb2RlKGNhblJlYWQsY2FuV3JpdGUpO3JldHVybiBGUy5jcmVhdGUocGF0aCxtb2RlKX0sY3JlYXRlRGF0YUZpbGUocGFyZW50LG5hbWUsZGF0YSxjYW5SZWFkLGNhbldyaXRlLGNhbk93bil7dmFyIHBhdGg9bmFtZTtpZihwYXJlbnQpe3BhcmVudD10eXBlb2YgcGFyZW50PT0ic3RyaW5nIj9wYXJlbnQ6RlMuZ2V0UGF0aChwYXJlbnQpO3BhdGg9bmFtZT9QQVRILmpvaW4yKHBhcmVudCxuYW1lKTpwYXJlbnR9dmFyIG1vZGU9RlNfZ2V0TW9kZShjYW5SZWFkLGNhbldyaXRlKTt2YXIgbm9kZT1GUy5jcmVhdGUocGF0aCxtb2RlKTtpZihkYXRhKXtpZih0eXBlb2YgZGF0YT09InN0cmluZyIpe3ZhciBhcnI9bmV3IEFycmF5KGRhdGEubGVuZ3RoKTtmb3IodmFyIGk9MCxsZW49ZGF0YS5sZW5ndGg7aTxsZW47KytpKWFycltpXT1kYXRhLmNoYXJDb2RlQXQoaSk7ZGF0YT1hcnJ9RlMuY2htb2Qobm9kZSxtb2RlfDE0Nik7dmFyIHN0cmVhbT1GUy5vcGVuKG5vZGUsNTc3KTtGUy53cml0ZShzdHJlYW0sZGF0YSwwLGRhdGEubGVuZ3RoLDAsY2FuT3duKTtGUy5jbG9zZShzdHJlYW0pO0ZTLmNobW9kKG5vZGUsbW9kZSl9fSxjcmVhdGVEZXZpY2UocGFyZW50LG5hbWUsaW5wdXQsb3V0cHV0KXt2YXIgcGF0aD1QQVRILmpvaW4yKHR5cGVvZiBwYXJlbnQ9PSJzdHJpbmciP3BhcmVudDpGUy5nZXRQYXRoKHBhcmVudCksbmFtZSk7dmFyIG1vZGU9RlNfZ2V0TW9kZSghIWlucHV0LCEhb3V0cHV0KTtpZighRlMuY3JlYXRlRGV2aWNlLm1ham9yKUZTLmNyZWF0ZURldmljZS5tYWpvcj02NDt2YXIgZGV2PUZTLm1ha2VkZXYoRlMuY3JlYXRlRGV2aWNlLm1ham9yKyssMCk7RlMucmVnaXN0ZXJEZXZpY2UoZGV2LHtvcGVuKHN0cmVhbSl7c3RyZWFtLnNlZWthYmxlPWZhbHNlfSxjbG9zZShzdHJlYW0pe2lmKG91dHB1dCYmb3V0cHV0LmJ1ZmZlciYmb3V0cHV0LmJ1ZmZlci5sZW5ndGgpe291dHB1dCgxMCl9fSxyZWFkKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3Mpe3ZhciBieXRlc1JlYWQ9MDtmb3IodmFyIGk9MDtpPGxlbmd0aDtpKyspe3ZhciByZXN1bHQ7dHJ5e3Jlc3VsdD1pbnB1dCgpfWNhdGNoKGUpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDI5KX1pZihyZXN1bHQ9PT11bmRlZmluZWQmJmJ5dGVzUmVhZD09PTApe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDYpfWlmKHJlc3VsdD09PW51bGx8fHJlc3VsdD09PXVuZGVmaW5lZClicmVhaztieXRlc1JlYWQrKztidWZmZXJbb2Zmc2V0K2ldPXJlc3VsdH1pZihieXRlc1JlYWQpe3N0cmVhbS5ub2RlLnRpbWVzdGFtcD1EYXRlLm5vdygpfXJldHVybiBieXRlc1JlYWR9LHdyaXRlKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3Mpe2Zvcih2YXIgaT0wO2k8bGVuZ3RoO2krKyl7dHJ5e291dHB1dChidWZmZXJbb2Zmc2V0K2ldKX1jYXRjaChlKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcigyOSl9fWlmKGxlbmd0aCl7c3RyZWFtLm5vZGUudGltZXN0YW1wPURhdGUubm93KCl9cmV0dXJuIGl9fSk7cmV0dXJuIEZTLm1rZGV2KHBhdGgsbW9kZSxkZXYpfSxmb3JjZUxvYWRGaWxlKG9iail7aWYob2JqLmlzRGV2aWNlfHxvYmouaXNGb2xkZXJ8fG9iai5saW5rfHxvYmouY29udGVudHMpcmV0dXJuIHRydWU7aWYodHlwZW9mIFhNTEh0dHBSZXF1ZXN0IT0idW5kZWZpbmVkIil7dGhyb3cgbmV3IEVycm9yKCJMYXp5IGxvYWRpbmcgc2hvdWxkIGhhdmUgYmVlbiBwZXJmb3JtZWQgKGNvbnRlbnRzIHNldCkgaW4gY3JlYXRlTGF6eUZpbGUsIGJ1dCBpdCB3YXMgbm90LiBMYXp5IGxvYWRpbmcgb25seSB3b3JrcyBpbiB3ZWIgd29ya2Vycy4gVXNlIC0tZW1iZWQtZmlsZSBvciAtLXByZWxvYWQtZmlsZSBpbiBlbWNjIG9uIHRoZSBtYWluIHRocmVhZC4iKX1lbHNlIGlmKHJlYWRfKXt0cnl7b2JqLmNvbnRlbnRzPWludEFycmF5RnJvbVN0cmluZyhyZWFkXyhvYmoudXJsKSx0cnVlKTtvYmoudXNlZEJ5dGVzPW9iai5jb250ZW50cy5sZW5ndGh9Y2F0Y2goZSl7dGhyb3cgbmV3IEZTLkVycm5vRXJyb3IoMjkpfX1lbHNle3Rocm93IG5ldyBFcnJvcigiQ2Fubm90IGxvYWQgd2l0aG91dCByZWFkKCkgb3IgWE1MSHR0cFJlcXVlc3QuIil9fSxjcmVhdGVMYXp5RmlsZShwYXJlbnQsbmFtZSx1cmwsY2FuUmVhZCxjYW5Xcml0ZSl7ZnVuY3Rpb24gTGF6eVVpbnQ4QXJyYXkoKXt0aGlzLmxlbmd0aEtub3duPWZhbHNlO3RoaXMuY2h1bmtzPVtdfUxhenlVaW50OEFycmF5LnByb3RvdHlwZS5nZXQ9ZnVuY3Rpb24gTGF6eVVpbnQ4QXJyYXlfZ2V0KGlkeCl7aWYoaWR4PnRoaXMubGVuZ3RoLTF8fGlkeDwwKXtyZXR1cm4gdW5kZWZpbmVkfXZhciBjaHVua09mZnNldD1pZHgldGhpcy5jaHVua1NpemU7dmFyIGNodW5rTnVtPWlkeC90aGlzLmNodW5rU2l6ZXwwO3JldHVybiB0aGlzLmdldHRlcihjaHVua051bSlbY2h1bmtPZmZzZXRdfTtMYXp5VWludDhBcnJheS5wcm90b3R5cGUuc2V0RGF0YUdldHRlcj1mdW5jdGlvbiBMYXp5VWludDhBcnJheV9zZXREYXRhR2V0dGVyKGdldHRlcil7dGhpcy5nZXR0ZXI9Z2V0dGVyfTtMYXp5VWludDhBcnJheS5wcm90b3R5cGUuY2FjaGVMZW5ndGg9ZnVuY3Rpb24gTGF6eVVpbnQ4QXJyYXlfY2FjaGVMZW5ndGgoKXt2YXIgeGhyPW5ldyBYTUxIdHRwUmVxdWVzdDt4aHIub3BlbigiSEVBRCIsdXJsLGZhbHNlKTt4aHIuc2VuZChudWxsKTtpZighKHhoci5zdGF0dXM+PTIwMCYmeGhyLnN0YXR1czwzMDB8fHhoci5zdGF0dXM9PT0zMDQpKXRocm93IG5ldyBFcnJvcigiQ291bGRuJ3QgbG9hZCAiK3VybCsiLiBTdGF0dXM6ICIreGhyLnN0YXR1cyk7dmFyIGRhdGFsZW5ndGg9TnVtYmVyKHhoci5nZXRSZXNwb25zZUhlYWRlcigiQ29udGVudC1sZW5ndGgiKSk7dmFyIGhlYWRlcjt2YXIgaGFzQnl0ZVNlcnZpbmc9KGhlYWRlcj14aHIuZ2V0UmVzcG9uc2VIZWFkZXIoIkFjY2VwdC1SYW5nZXMiKSkmJmhlYWRlcj09PSJieXRlcyI7dmFyIHVzZXNHemlwPShoZWFkZXI9eGhyLmdldFJlc3BvbnNlSGVhZGVyKCJDb250ZW50LUVuY29kaW5nIikpJiZoZWFkZXI9PT0iZ3ppcCI7dmFyIGNodW5rU2l6ZT0xMDI0KjEwMjQ7aWYoIWhhc0J5dGVTZXJ2aW5nKWNodW5rU2l6ZT1kYXRhbGVuZ3RoO3ZhciBkb1hIUj0oZnJvbSx0byk9PntpZihmcm9tPnRvKXRocm93IG5ldyBFcnJvcigiaW52YWxpZCByYW5nZSAoIitmcm9tKyIsICIrdG8rIikgb3Igbm8gYnl0ZXMgcmVxdWVzdGVkISIpO2lmKHRvPmRhdGFsZW5ndGgtMSl0aHJvdyBuZXcgRXJyb3IoIm9ubHkgIitkYXRhbGVuZ3RoKyIgYnl0ZXMgYXZhaWxhYmxlISBwcm9ncmFtbWVyIGVycm9yISIpO3ZhciB4aHI9bmV3IFhNTEh0dHBSZXF1ZXN0O3hoci5vcGVuKCJHRVQiLHVybCxmYWxzZSk7aWYoZGF0YWxlbmd0aCE9PWNodW5rU2l6ZSl4aHIuc2V0UmVxdWVzdEhlYWRlcigiUmFuZ2UiLCJieXRlcz0iK2Zyb20rIi0iK3RvKTt4aHIucmVzcG9uc2VUeXBlPSJhcnJheWJ1ZmZlciI7aWYoeGhyLm92ZXJyaWRlTWltZVR5cGUpe3hoci5vdmVycmlkZU1pbWVUeXBlKCJ0ZXh0L3BsYWluOyBjaGFyc2V0PXgtdXNlci1kZWZpbmVkIil9eGhyLnNlbmQobnVsbCk7aWYoISh4aHIuc3RhdHVzPj0yMDAmJnhoci5zdGF0dXM8MzAwfHx4aHIuc3RhdHVzPT09MzA0KSl0aHJvdyBuZXcgRXJyb3IoIkNvdWxkbid0IGxvYWQgIit1cmwrIi4gU3RhdHVzOiAiK3hoci5zdGF0dXMpO2lmKHhoci5yZXNwb25zZSE9PXVuZGVmaW5lZCl7cmV0dXJuIG5ldyBVaW50OEFycmF5KHhoci5yZXNwb25zZXx8W10pfXJldHVybiBpbnRBcnJheUZyb21TdHJpbmcoeGhyLnJlc3BvbnNlVGV4dHx8IiIsdHJ1ZSl9O3ZhciBsYXp5QXJyYXk9dGhpcztsYXp5QXJyYXkuc2V0RGF0YUdldHRlcihjaHVua051bT0+e3ZhciBzdGFydD1jaHVua051bSpjaHVua1NpemU7dmFyIGVuZD0oY2h1bmtOdW0rMSkqY2h1bmtTaXplLTE7ZW5kPU1hdGgubWluKGVuZCxkYXRhbGVuZ3RoLTEpO2lmKHR5cGVvZiBsYXp5QXJyYXkuY2h1bmtzW2NodW5rTnVtXT09InVuZGVmaW5lZCIpe2xhenlBcnJheS5jaHVua3NbY2h1bmtOdW1dPWRvWEhSKHN0YXJ0LGVuZCl9aWYodHlwZW9mIGxhenlBcnJheS5jaHVua3NbY2h1bmtOdW1dPT0idW5kZWZpbmVkIil0aHJvdyBuZXcgRXJyb3IoImRvWEhSIGZhaWxlZCEiKTtyZXR1cm4gbGF6eUFycmF5LmNodW5rc1tjaHVua051bV19KTtpZih1c2VzR3ppcHx8IWRhdGFsZW5ndGgpe2NodW5rU2l6ZT1kYXRhbGVuZ3RoPTE7ZGF0YWxlbmd0aD10aGlzLmdldHRlcigwKS5sZW5ndGg7Y2h1bmtTaXplPWRhdGFsZW5ndGg7b3V0KCJMYXp5RmlsZXMgb24gZ3ppcCBmb3JjZXMgZG93bmxvYWQgb2YgdGhlIHdob2xlIGZpbGUgd2hlbiBsZW5ndGggaXMgYWNjZXNzZWQiKX10aGlzLl9sZW5ndGg9ZGF0YWxlbmd0aDt0aGlzLl9jaHVua1NpemU9Y2h1bmtTaXplO3RoaXMubGVuZ3RoS25vd249dHJ1ZX07aWYodHlwZW9mIFhNTEh0dHBSZXF1ZXN0IT0idW5kZWZpbmVkIil7aWYoIUVOVklST05NRU5UX0lTX1dPUktFUil0aHJvdyJDYW5ub3QgZG8gc3luY2hyb25vdXMgYmluYXJ5IFhIUnMgb3V0c2lkZSB3ZWJ3b3JrZXJzIGluIG1vZGVybiBicm93c2Vycy4gVXNlIC0tZW1iZWQtZmlsZSBvciAtLXByZWxvYWQtZmlsZSBpbiBlbWNjIjt2YXIgbGF6eUFycmF5PW5ldyBMYXp5VWludDhBcnJheTtPYmplY3QuZGVmaW5lUHJvcGVydGllcyhsYXp5QXJyYXkse2xlbmd0aDp7Z2V0OmZ1bmN0aW9uKCl7aWYoIXRoaXMubGVuZ3RoS25vd24pe3RoaXMuY2FjaGVMZW5ndGgoKX1yZXR1cm4gdGhpcy5fbGVuZ3RofX0sY2h1bmtTaXplOntnZXQ6ZnVuY3Rpb24oKXtpZighdGhpcy5sZW5ndGhLbm93bil7dGhpcy5jYWNoZUxlbmd0aCgpfXJldHVybiB0aGlzLl9jaHVua1NpemV9fX0pO3ZhciBwcm9wZXJ0aWVzPXtpc0RldmljZTpmYWxzZSxjb250ZW50czpsYXp5QXJyYXl9fWVsc2V7dmFyIHByb3BlcnRpZXM9e2lzRGV2aWNlOmZhbHNlLHVybDp1cmx9fXZhciBub2RlPUZTLmNyZWF0ZUZpbGUocGFyZW50LG5hbWUscHJvcGVydGllcyxjYW5SZWFkLGNhbldyaXRlKTtpZihwcm9wZXJ0aWVzLmNvbnRlbnRzKXtub2RlLmNvbnRlbnRzPXByb3BlcnRpZXMuY29udGVudHN9ZWxzZSBpZihwcm9wZXJ0aWVzLnVybCl7bm9kZS5jb250ZW50cz1udWxsO25vZGUudXJsPXByb3BlcnRpZXMudXJsfU9iamVjdC5kZWZpbmVQcm9wZXJ0aWVzKG5vZGUse3VzZWRCeXRlczp7Z2V0OmZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMuY29udGVudHMubGVuZ3RofX19KTt2YXIgc3RyZWFtX29wcz17fTt2YXIga2V5cz1PYmplY3Qua2V5cyhub2RlLnN0cmVhbV9vcHMpO2tleXMuZm9yRWFjaChrZXk9Pnt2YXIgZm49bm9kZS5zdHJlYW1fb3BzW2tleV07c3RyZWFtX29wc1trZXldPWZ1bmN0aW9uIGZvcmNlTG9hZExhenlGaWxlKCl7RlMuZm9yY2VMb2FkRmlsZShub2RlKTtyZXR1cm4gZm4uYXBwbHkobnVsbCxhcmd1bWVudHMpfX0pO2Z1bmN0aW9uIHdyaXRlQ2h1bmtzKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3NpdGlvbil7dmFyIGNvbnRlbnRzPXN0cmVhbS5ub2RlLmNvbnRlbnRzO2lmKHBvc2l0aW9uPj1jb250ZW50cy5sZW5ndGgpcmV0dXJuIDA7dmFyIHNpemU9TWF0aC5taW4oY29udGVudHMubGVuZ3RoLXBvc2l0aW9uLGxlbmd0aCk7aWYoY29udGVudHMuc2xpY2Upe2Zvcih2YXIgaT0wO2k8c2l6ZTtpKyspe2J1ZmZlcltvZmZzZXQraV09Y29udGVudHNbcG9zaXRpb24raV19fWVsc2V7Zm9yKHZhciBpPTA7aTxzaXplO2krKyl7YnVmZmVyW29mZnNldCtpXT1jb250ZW50cy5nZXQocG9zaXRpb24raSl9fXJldHVybiBzaXplfXN0cmVhbV9vcHMucmVhZD0oc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuZ3RoLHBvc2l0aW9uKT0+e0ZTLmZvcmNlTG9hZEZpbGUobm9kZSk7cmV0dXJuIHdyaXRlQ2h1bmtzKHN0cmVhbSxidWZmZXIsb2Zmc2V0LGxlbmd0aCxwb3NpdGlvbil9O3N0cmVhbV9vcHMubW1hcD0oc3RyZWFtLGxlbmd0aCxwb3NpdGlvbixwcm90LGZsYWdzKT0+e0ZTLmZvcmNlTG9hZEZpbGUobm9kZSk7dmFyIHB0cj1tbWFwQWxsb2MobGVuZ3RoKTtpZighcHRyKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0OCl9d3JpdGVDaHVua3Moc3RyZWFtLEhFQVA4LHB0cixsZW5ndGgscG9zaXRpb24pO3JldHVybntwdHI6cHRyLGFsbG9jYXRlZDp0cnVlfX07bm9kZS5zdHJlYW1fb3BzPXN0cmVhbV9vcHM7cmV0dXJuIG5vZGV9fTt2YXIgVVRGOFRvU3RyaW5nPShwdHIsbWF4Qnl0ZXNUb1JlYWQpPT5wdHI/VVRGOEFycmF5VG9TdHJpbmcoSEVBUFU4LHB0cixtYXhCeXRlc1RvUmVhZCk6IiI7dmFyIFNZU0NBTExTPXtERUZBVUxUX1BPTExNQVNLOjUsY2FsY3VsYXRlQXQoZGlyZmQscGF0aCxhbGxvd0VtcHR5KXtpZihQQVRILmlzQWJzKHBhdGgpKXtyZXR1cm4gcGF0aH12YXIgZGlyO2lmKGRpcmZkPT09LTEwMCl7ZGlyPUZTLmN3ZCgpfWVsc2V7dmFyIGRpcnN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZGlyZmQpO2Rpcj1kaXJzdHJlYW0ucGF0aH1pZihwYXRoLmxlbmd0aD09MCl7aWYoIWFsbG93RW1wdHkpe3Rocm93IG5ldyBGUy5FcnJub0Vycm9yKDQ0KX1yZXR1cm4gZGlyfXJldHVybiBQQVRILmpvaW4yKGRpcixwYXRoKX0sZG9TdGF0KGZ1bmMscGF0aCxidWYpe3RyeXt2YXIgc3RhdD1mdW5jKHBhdGgpfWNhdGNoKGUpe2lmKGUmJmUubm9kZSYmUEFUSC5ub3JtYWxpemUocGF0aCkhPT1QQVRILm5vcm1hbGl6ZShGUy5nZXRQYXRoKGUubm9kZSkpKXtyZXR1cm4tNTR9dGhyb3cgZX1IRUFQMzJbYnVmPj4yXT1zdGF0LmRldjtIRUFQMzJbYnVmKzQ+PjJdPXN0YXQubW9kZTtIRUFQVTMyW2J1Zis4Pj4yXT1zdGF0Lm5saW5rO0hFQVAzMltidWYrMTI+PjJdPXN0YXQudWlkO0hFQVAzMltidWYrMTY+PjJdPXN0YXQuZ2lkO0hFQVAzMltidWYrMjA+PjJdPXN0YXQucmRldjt0ZW1wSTY0PVtzdGF0LnNpemU+Pj4wLCh0ZW1wRG91YmxlPXN0YXQuc2l6ZSwrTWF0aC5hYnModGVtcERvdWJsZSk+PTE/dGVtcERvdWJsZT4wPytNYXRoLmZsb29yKHRlbXBEb3VibGUvNDI5NDk2NzI5Nik+Pj4wOn5+K01hdGguY2VpbCgodGVtcERvdWJsZS0rKH5+dGVtcERvdWJsZT4+PjApKS80Mjk0OTY3Mjk2KT4+PjA6MCldLEhFQVAzMltidWYrMjQ+PjJdPXRlbXBJNjRbMF0sSEVBUDMyW2J1ZisyOD4+Ml09dGVtcEk2NFsxXTtIRUFQMzJbYnVmKzMyPj4yXT00MDk2O0hFQVAzMltidWYrMzY+PjJdPXN0YXQuYmxvY2tzO3ZhciBhdGltZT1zdGF0LmF0aW1lLmdldFRpbWUoKTt2YXIgbXRpbWU9c3RhdC5tdGltZS5nZXRUaW1lKCk7dmFyIGN0aW1lPXN0YXQuY3RpbWUuZ2V0VGltZSgpO3RlbXBJNjQ9W01hdGguZmxvb3IoYXRpbWUvMWUzKT4+PjAsKHRlbXBEb3VibGU9TWF0aC5mbG9vcihhdGltZS8xZTMpLCtNYXRoLmFicyh0ZW1wRG91YmxlKT49MT90ZW1wRG91YmxlPjA/K01hdGguZmxvb3IodGVtcERvdWJsZS80Mjk0OTY3Mjk2KT4+PjA6fn4rTWF0aC5jZWlsKCh0ZW1wRG91YmxlLSsofn50ZW1wRG91YmxlPj4+MCkpLzQyOTQ5NjcyOTYpPj4+MDowKV0sSEVBUDMyW2J1Zis0MD4+Ml09dGVtcEk2NFswXSxIRUFQMzJbYnVmKzQ0Pj4yXT10ZW1wSTY0WzFdO0hFQVBVMzJbYnVmKzQ4Pj4yXT1hdGltZSUxZTMqMWUzO3RlbXBJNjQ9W01hdGguZmxvb3IobXRpbWUvMWUzKT4+PjAsKHRlbXBEb3VibGU9TWF0aC5mbG9vcihtdGltZS8xZTMpLCtNYXRoLmFicyh0ZW1wRG91YmxlKT49MT90ZW1wRG91YmxlPjA/K01hdGguZmxvb3IodGVtcERvdWJsZS80Mjk0OTY3Mjk2KT4+PjA6fn4rTWF0aC5jZWlsKCh0ZW1wRG91YmxlLSsofn50ZW1wRG91YmxlPj4+MCkpLzQyOTQ5NjcyOTYpPj4+MDowKV0sSEVBUDMyW2J1Zis1Nj4+Ml09dGVtcEk2NFswXSxIRUFQMzJbYnVmKzYwPj4yXT10ZW1wSTY0WzFdO0hFQVBVMzJbYnVmKzY0Pj4yXT1tdGltZSUxZTMqMWUzO3RlbXBJNjQ9W01hdGguZmxvb3IoY3RpbWUvMWUzKT4+PjAsKHRlbXBEb3VibGU9TWF0aC5mbG9vcihjdGltZS8xZTMpLCtNYXRoLmFicyh0ZW1wRG91YmxlKT49MT90ZW1wRG91YmxlPjA/K01hdGguZmxvb3IodGVtcERvdWJsZS80Mjk0OTY3Mjk2KT4+PjA6fn4rTWF0aC5jZWlsKCh0ZW1wRG91YmxlLSsofn50ZW1wRG91YmxlPj4+MCkpLzQyOTQ5NjcyOTYpPj4+MDowKV0sSEVBUDMyW2J1Zis3Mj4+Ml09dGVtcEk2NFswXSxIRUFQMzJbYnVmKzc2Pj4yXT10ZW1wSTY0WzFdO0hFQVBVMzJbYnVmKzgwPj4yXT1jdGltZSUxZTMqMWUzO3RlbXBJNjQ9W3N0YXQuaW5vPj4+MCwodGVtcERvdWJsZT1zdGF0LmlubywrTWF0aC5hYnModGVtcERvdWJsZSk+PTE/dGVtcERvdWJsZT4wPytNYXRoLmZsb29yKHRlbXBEb3VibGUvNDI5NDk2NzI5Nik+Pj4wOn5+K01hdGguY2VpbCgodGVtcERvdWJsZS0rKH5+dGVtcERvdWJsZT4+PjApKS80Mjk0OTY3Mjk2KT4+PjA6MCldLEhFQVAzMltidWYrODg+PjJdPXRlbXBJNjRbMF0sSEVBUDMyW2J1Zis5Mj4+Ml09dGVtcEk2NFsxXTtyZXR1cm4gMH0sZG9Nc3luYyhhZGRyLHN0cmVhbSxsZW4sZmxhZ3Msb2Zmc2V0KXtpZighRlMuaXNGaWxlKHN0cmVhbS5ub2RlLm1vZGUpKXt0aHJvdyBuZXcgRlMuRXJybm9FcnJvcig0Myl9aWYoZmxhZ3MmMil7cmV0dXJuIDB9dmFyIGJ1ZmZlcj1IRUFQVTguc2xpY2UoYWRkcixhZGRyK2xlbik7RlMubXN5bmMoc3RyZWFtLGJ1ZmZlcixvZmZzZXQsbGVuLGZsYWdzKX0sdmFyYXJnczp1bmRlZmluZWQsZ2V0KCl7dmFyIHJldD1IRUFQMzJbK1NZU0NBTExTLnZhcmFyZ3M+PjJdO1NZU0NBTExTLnZhcmFyZ3MrPTQ7cmV0dXJuIHJldH0sZ2V0cCgpe3JldHVybiBTWVNDQUxMUy5nZXQoKX0sZ2V0U3RyKHB0cil7dmFyIHJldD1VVEY4VG9TdHJpbmcocHRyKTtyZXR1cm4gcmV0fSxnZXRTdHJlYW1Gcm9tRkQoZmQpe3ZhciBzdHJlYW09RlMuZ2V0U3RyZWFtQ2hlY2tlZChmZCk7cmV0dXJuIHN0cmVhbX19O3ZhciB3aXRoU3RhY2tTYXZlPWY9Pnt2YXIgc3RhY2s9c3RhY2tTYXZlKCk7dmFyIHJldD1mKCk7c3RhY2tSZXN0b3JlKHN0YWNrKTtyZXR1cm4gcmV0fTt2YXIgY29udmVydEkzMlBhaXJUb0k1M0NoZWNrZWQ9KGxvLGhpKT0+aGkrMjA5NzE1Mj4+PjA8NDE5NDMwNS0hIWxvPyhsbz4+PjApK2hpKjQyOTQ5NjcyOTY6TmFOO3ZhciBwcm94eVRvTWFpblRocmVhZD1mdW5jdGlvbihpbmRleCxzeW5jKXt2YXIgbnVtQ2FsbEFyZ3M9YXJndW1lbnRzLmxlbmd0aC0yO3ZhciBvdXRlckFyZ3M9YXJndW1lbnRzO3JldHVybiB3aXRoU3RhY2tTYXZlKCgpPT57dmFyIHNlcmlhbGl6ZWROdW1DYWxsQXJncz1udW1DYWxsQXJnczt2YXIgYXJncz1zdGFja0FsbG9jKHNlcmlhbGl6ZWROdW1DYWxsQXJncyo4KTt2YXIgYj1hcmdzPj4zO2Zvcih2YXIgaT0wO2k8bnVtQ2FsbEFyZ3M7aSsrKXt2YXIgYXJnPW91dGVyQXJnc1syK2ldO0hFQVBGNjRbYitpXT1hcmd9cmV0dXJuIF9fZW1zY3JpcHRlbl9ydW5fb25fbWFpbl90aHJlYWRfanMoaW5kZXgsc2VyaWFsaXplZE51bUNhbGxBcmdzLGFyZ3Msc3luYyl9KX07ZnVuY3Rpb24gX3Byb2NfZXhpdChjb2RlKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCgwLDEsY29kZSk7RVhJVFNUQVRVUz1jb2RlO2lmKCFrZWVwUnVudGltZUFsaXZlKCkpe1BUaHJlYWQudGVybWluYXRlQWxsVGhyZWFkcygpO2lmKE1vZHVsZVsib25FeGl0Il0pTW9kdWxlWyJvbkV4aXQiXShjb2RlKTtBQk9SVD10cnVlfXF1aXRfKGNvZGUsbmV3IEV4aXRTdGF0dXMoY29kZSkpfXZhciBleGl0SlM9KHN0YXR1cyxpbXBsaWNpdCk9PntFWElUU1RBVFVTPXN0YXR1cztpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXtleGl0T25NYWluVGhyZWFkKHN0YXR1cyk7dGhyb3cidW53aW5kIn1pZigha2VlcFJ1bnRpbWVBbGl2ZSgpKXtleGl0UnVudGltZSgpfV9wcm9jX2V4aXQoc3RhdHVzKX07dmFyIF9leGl0PWV4aXRKUzt2YXIgaGFuZGxlRXhjZXB0aW9uPWU9PntpZihlIGluc3RhbmNlb2YgRXhpdFN0YXR1c3x8ZT09InVud2luZCIpe3JldHVybiBFWElUU1RBVFVTfXF1aXRfKDEsZSl9O3ZhciBQVGhyZWFkPXt1bnVzZWRXb3JrZXJzOltdLHJ1bm5pbmdXb3JrZXJzOltdLHRsc0luaXRGdW5jdGlvbnM6W10scHRocmVhZHM6e30saW5pdCgpe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpe1BUaHJlYWQuaW5pdFdvcmtlcigpfWVsc2V7UFRocmVhZC5pbml0TWFpblRocmVhZCgpfX0saW5pdE1haW5UaHJlYWQoKXt2YXIgcHRocmVhZFBvb2xTaXplPTQ7d2hpbGUocHRocmVhZFBvb2xTaXplLS0pe1BUaHJlYWQuYWxsb2NhdGVVbnVzZWRXb3JrZXIoKX1hZGRPblByZVJ1bigoKT0+e2FkZFJ1bkRlcGVuZGVuY3koImxvYWRpbmctd29ya2VycyIpO1BUaHJlYWQubG9hZFdhc21Nb2R1bGVUb0FsbFdvcmtlcnMoKCk9PnJlbW92ZVJ1bkRlcGVuZGVuY3koImxvYWRpbmctd29ya2VycyIpKX0pfSxpbml0V29ya2VyKCl7bm9FeGl0UnVudGltZT1mYWxzZX0sc2V0RXhpdFN0YXR1czpzdGF0dXM9PntFWElUU1RBVFVTPXN0YXR1c30sdGVybWluYXRlQWxsVGhyZWFkc19fZGVwczpbIiR0ZXJtaW5hdGVXb3JrZXIiXSx0ZXJtaW5hdGVBbGxUaHJlYWRzOigpPT57Zm9yKHZhciB3b3JrZXIgb2YgUFRocmVhZC5ydW5uaW5nV29ya2Vycyl7dGVybWluYXRlV29ya2VyKHdvcmtlcil9Zm9yKHZhciB3b3JrZXIgb2YgUFRocmVhZC51bnVzZWRXb3JrZXJzKXt0ZXJtaW5hdGVXb3JrZXIod29ya2VyKX1QVGhyZWFkLnVudXNlZFdvcmtlcnM9W107UFRocmVhZC5ydW5uaW5nV29ya2Vycz1bXTtQVGhyZWFkLnB0aHJlYWRzPVtdfSxyZXR1cm5Xb3JrZXJUb1Bvb2w6d29ya2VyPT57dmFyIHB0aHJlYWRfcHRyPXdvcmtlci5wdGhyZWFkX3B0cjtkZWxldGUgUFRocmVhZC5wdGhyZWFkc1twdGhyZWFkX3B0cl07UFRocmVhZC51bnVzZWRXb3JrZXJzLnB1c2god29ya2VyKTtQVGhyZWFkLnJ1bm5pbmdXb3JrZXJzLnNwbGljZShQVGhyZWFkLnJ1bm5pbmdXb3JrZXJzLmluZGV4T2Yod29ya2VyKSwxKTt3b3JrZXIucHRocmVhZF9wdHI9MDtfX2Vtc2NyaXB0ZW5fdGhyZWFkX2ZyZWVfZGF0YShwdGhyZWFkX3B0cil9LHJlY2VpdmVPYmplY3RUcmFuc2ZlcihkYXRhKXt9LHRocmVhZEluaXRUTFMoKXtQVGhyZWFkLnRsc0luaXRGdW5jdGlvbnMuZm9yRWFjaChmPT5mKCkpfSxsb2FkV2FzbU1vZHVsZVRvV29ya2VyOndvcmtlcj0+bmV3IFByb21pc2Uob25GaW5pc2hlZExvYWRpbmc9Pnt3b3JrZXIub25tZXNzYWdlPWU9Pnt2YXIgZD1lWyJkYXRhIl07dmFyIGNtZD1kWyJjbWQiXTtpZihkWyJ0YXJnZXRUaHJlYWQiXSYmZFsidGFyZ2V0VGhyZWFkIl0hPV9wdGhyZWFkX3NlbGYoKSl7dmFyIHRhcmdldFdvcmtlcj1QVGhyZWFkLnB0aHJlYWRzW2RbInRhcmdldFRocmVhZCJdXTtpZih0YXJnZXRXb3JrZXIpe3RhcmdldFdvcmtlci5wb3N0TWVzc2FnZShkLGRbInRyYW5zZmVyTGlzdCJdKX1lbHNle2VycihgSW50ZXJuYWwgZXJyb3IhIFdvcmtlciBzZW50IGEgbWVzc2FnZSAiJHtjbWR9IiB0byB0YXJnZXQgcHRocmVhZCAke2RbInRhcmdldFRocmVhZCJdfSwgYnV0IHRoYXQgdGhyZWFkIG5vIGxvbmdlciBleGlzdHMhYCl9cmV0dXJufWlmKGNtZD09PSJjaGVja01haWxib3giKXtjaGVja01haWxib3goKX1lbHNlIGlmKGNtZD09PSJzcGF3blRocmVhZCIpe3NwYXduVGhyZWFkKGQpfWVsc2UgaWYoY21kPT09ImNsZWFudXBUaHJlYWQiKXtjbGVhbnVwVGhyZWFkKGRbInRocmVhZCJdKX1lbHNlIGlmKGNtZD09PSJraWxsVGhyZWFkIil7a2lsbFRocmVhZChkWyJ0aHJlYWQiXSl9ZWxzZSBpZihjbWQ9PT0iY2FuY2VsVGhyZWFkIil7Y2FuY2VsVGhyZWFkKGRbInRocmVhZCJdKX1lbHNlIGlmKGNtZD09PSJsb2FkZWQiKXt3b3JrZXIubG9hZGVkPXRydWU7b25GaW5pc2hlZExvYWRpbmcod29ya2VyKX1lbHNlIGlmKGNtZD09PSJhbGVydCIpe2FsZXJ0KGBUaHJlYWQgJHtkWyJ0aHJlYWRJZCJdfTogJHtkWyJ0ZXh0Il19YCl9ZWxzZSBpZihkLnRhcmdldD09PSJzZXRpbW1lZGlhdGUiKXt3b3JrZXIucG9zdE1lc3NhZ2UoZCl9ZWxzZSBpZihjbWQ9PT0iY2FsbEhhbmRsZXIiKXtNb2R1bGVbZFsiaGFuZGxlciJdXSguLi5kWyJhcmdzIl0pfWVsc2UgaWYoY21kKXtlcnIoYHdvcmtlciBzZW50IGFuIHVua25vd24gY29tbWFuZCAke2NtZH1gKX19O3dvcmtlci5vbmVycm9yPWU9Pnt2YXIgbWVzc2FnZT0id29ya2VyIHNlbnQgYW4gZXJyb3IhIjtlcnIoYCR7bWVzc2FnZX0gJHtlLmZpbGVuYW1lfToke2UubGluZW5vfTogJHtlLm1lc3NhZ2V9YCk7dGhyb3cgZX07dmFyIGhhbmRsZXJzPVtdO3ZhciBrbm93bkhhbmRsZXJzPVsib25FeGl0Iiwib25BYm9ydCIsInByaW50IiwicHJpbnRFcnIiXTtmb3IodmFyIGhhbmRsZXIgb2Yga25vd25IYW5kbGVycyl7aWYoTW9kdWxlLmhhc093blByb3BlcnR5KGhhbmRsZXIpKXtoYW5kbGVycy5wdXNoKGhhbmRsZXIpfX13b3JrZXIucG9zdE1lc3NhZ2UoeyJjbWQiOiJsb2FkIiwiaGFuZGxlcnMiOmhhbmRsZXJzLCJ1cmxPckJsb2IiOk1vZHVsZVsibWFpblNjcmlwdFVybE9yQmxvYiJdLCJ3YXNtTWVtb3J5Ijp3YXNtTWVtb3J5LCJ3YXNtTW9kdWxlIjp3YXNtTW9kdWxlfSl9KSxsb2FkV2FzbU1vZHVsZVRvQWxsV29ya2Vycyhvbk1heWJlUmVhZHkpe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpe3JldHVybiBvbk1heWJlUmVhZHkoKX1sZXQgcHRocmVhZFBvb2xSZWFkeT1Qcm9taXNlLmFsbChQVGhyZWFkLnVudXNlZFdvcmtlcnMubWFwKFBUaHJlYWQubG9hZFdhc21Nb2R1bGVUb1dvcmtlcikpO3B0aHJlYWRQb29sUmVhZHkudGhlbihvbk1heWJlUmVhZHkpfSxhbGxvY2F0ZVVudXNlZFdvcmtlcigpe3ZhciB3b3JrZXI7aWYoIU1vZHVsZVsibG9jYXRlRmlsZSJdKXt3b3JrZXI9bmV3IFdvcmtlcihuZXcgVVJMKCJtYWluLWJpbi1tdWx0aS53b3JrZXIuanMiLGxvY2F0aW9uLmhyZWYpLHt0eXBlOiJtb2R1bGUifSl9ZWxzZXt2YXIgcHRocmVhZE1haW5Kcz1sb2NhdGVGaWxlKCJtYWluLWJpbi1tdWx0aS53b3JrZXIuanMiKTt3b3JrZXI9bmV3IFdvcmtlcihwdGhyZWFkTWFpbkpzLHt0eXBlOiJtb2R1bGUifSl9UFRocmVhZC51bnVzZWRXb3JrZXJzLnB1c2god29ya2VyKX0sZ2V0TmV3V29ya2VyKCl7aWYoUFRocmVhZC51bnVzZWRXb3JrZXJzLmxlbmd0aD09MCl7UFRocmVhZC5hbGxvY2F0ZVVudXNlZFdvcmtlcigpO1BUaHJlYWQubG9hZFdhc21Nb2R1bGVUb1dvcmtlcihQVGhyZWFkLnVudXNlZFdvcmtlcnNbMF0pfXJldHVybiBQVGhyZWFkLnVudXNlZFdvcmtlcnMucG9wKCl9fTtNb2R1bGVbIlBUaHJlYWQiXT1QVGhyZWFkO3ZhciBjYWxsUnVudGltZUNhbGxiYWNrcz1jYWxsYmFja3M9Pnt3aGlsZShjYWxsYmFja3MubGVuZ3RoPjApe2NhbGxiYWNrcy5zaGlmdCgpKE1vZHVsZSl9fTt2YXIgZXN0YWJsaXNoU3RhY2tTcGFjZT0oKT0+e3ZhciBwdGhyZWFkX3B0cj1fcHRocmVhZF9zZWxmKCk7dmFyIHN0YWNrSGlnaD1IRUFQVTMyW3B0aHJlYWRfcHRyKzUyPj4yXTt2YXIgc3RhY2tTaXplPUhFQVBVMzJbcHRocmVhZF9wdHIrNTY+PjJdO3ZhciBzdGFja0xvdz1zdGFja0hpZ2gtc3RhY2tTaXplO19lbXNjcmlwdGVuX3N0YWNrX3NldF9saW1pdHMoc3RhY2tIaWdoLHN0YWNrTG93KTtzdGFja1Jlc3RvcmUoc3RhY2tIaWdoKX07TW9kdWxlWyJlc3RhYmxpc2hTdGFja1NwYWNlIl09ZXN0YWJsaXNoU3RhY2tTcGFjZTtmdW5jdGlvbiBleGl0T25NYWluVGhyZWFkKHJldHVybkNvZGUpe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpcmV0dXJuIHByb3h5VG9NYWluVGhyZWFkKDEsMCxyZXR1cm5Db2RlKTtfZXhpdChyZXR1cm5Db2RlKX12YXIgd2FzbVRhYmxlTWlycm9yPVtdO3ZhciB3YXNtVGFibGU7dmFyIGdldFdhc21UYWJsZUVudHJ5PWZ1bmNQdHI9Pnt2YXIgZnVuYz13YXNtVGFibGVNaXJyb3JbZnVuY1B0cl07aWYoIWZ1bmMpe2lmKGZ1bmNQdHI+PXdhc21UYWJsZU1pcnJvci5sZW5ndGgpd2FzbVRhYmxlTWlycm9yLmxlbmd0aD1mdW5jUHRyKzE7d2FzbVRhYmxlTWlycm9yW2Z1bmNQdHJdPWZ1bmM9d2FzbVRhYmxlLmdldChmdW5jUHRyKX1yZXR1cm4gZnVuY307dmFyIGludm9rZUVudHJ5UG9pbnQ9KHB0cixhcmcpPT57cnVudGltZUtlZXBhbGl2ZUNvdW50ZXI9MDt2YXIgcmVzdWx0PWdldFdhc21UYWJsZUVudHJ5KHB0cikoYXJnKTtmdW5jdGlvbiBmaW5pc2gocmVzdWx0KXtpZihrZWVwUnVudGltZUFsaXZlKCkpe1BUaHJlYWQuc2V0RXhpdFN0YXR1cyhyZXN1bHQpfWVsc2V7X19lbXNjcmlwdGVuX3RocmVhZF9leGl0KHJlc3VsdCl9fWZpbmlzaChyZXN1bHQpfTtNb2R1bGVbImludm9rZUVudHJ5UG9pbnQiXT1pbnZva2VFbnRyeVBvaW50O3ZhciBub0V4aXRSdW50aW1lPU1vZHVsZVsibm9FeGl0UnVudGltZSJdfHxmYWxzZTt2YXIgcmVnaXN0ZXJUTFNJbml0PXRsc0luaXRGdW5jPT57UFRocmVhZC50bHNJbml0RnVuY3Rpb25zLnB1c2godGxzSW5pdEZ1bmMpfTt2YXIgX19fYXNzZXJ0X2ZhaWw9KGNvbmRpdGlvbixmaWxlbmFtZSxsaW5lLGZ1bmMpPT57YWJvcnQoYEFzc2VydGlvbiBmYWlsZWQ6ICR7VVRGOFRvU3RyaW5nKGNvbmRpdGlvbil9LCBhdDogYCtbZmlsZW5hbWU/VVRGOFRvU3RyaW5nKGZpbGVuYW1lKToidW5rbm93biBmaWxlbmFtZSIsbGluZSxmdW5jP1VURjhUb1N0cmluZyhmdW5jKToidW5rbm93biBmdW5jdGlvbiJdKX07dmFyIGV4Y2VwdGlvbkNhdWdodD1bXTt2YXIgdW5jYXVnaHRFeGNlcHRpb25Db3VudD0wO3ZhciBfX19jeGFfYmVnaW5fY2F0Y2g9cHRyPT57dmFyIGluZm89bmV3IEV4Y2VwdGlvbkluZm8ocHRyKTtpZighaW5mby5nZXRfY2F1Z2h0KCkpe2luZm8uc2V0X2NhdWdodCh0cnVlKTt1bmNhdWdodEV4Y2VwdGlvbkNvdW50LS19aW5mby5zZXRfcmV0aHJvd24oZmFsc2UpO2V4Y2VwdGlvbkNhdWdodC5wdXNoKGluZm8pO19fX2N4YV9pbmNyZW1lbnRfZXhjZXB0aW9uX3JlZmNvdW50KGluZm8uZXhjUHRyKTtyZXR1cm4gaW5mby5nZXRfZXhjZXB0aW9uX3B0cigpfTt2YXIgZXhjZXB0aW9uTGFzdD0wO3ZhciBfX19jeGFfZW5kX2NhdGNoPSgpPT57X3NldFRocmV3KDAsMCk7dmFyIGluZm89ZXhjZXB0aW9uQ2F1Z2h0LnBvcCgpO19fX2N4YV9kZWNyZW1lbnRfZXhjZXB0aW9uX3JlZmNvdW50KGluZm8uZXhjUHRyKTtleGNlcHRpb25MYXN0PTB9O2Z1bmN0aW9uIEV4Y2VwdGlvbkluZm8oZXhjUHRyKXt0aGlzLmV4Y1B0cj1leGNQdHI7dGhpcy5wdHI9ZXhjUHRyLTI0O3RoaXMuc2V0X3R5cGU9ZnVuY3Rpb24odHlwZSl7SEVBUFUzMlt0aGlzLnB0cis0Pj4yXT10eXBlfTt0aGlzLmdldF90eXBlPWZ1bmN0aW9uKCl7cmV0dXJuIEhFQVBVMzJbdGhpcy5wdHIrND4+Ml19O3RoaXMuc2V0X2Rlc3RydWN0b3I9ZnVuY3Rpb24oZGVzdHJ1Y3Rvcil7SEVBUFUzMlt0aGlzLnB0cis4Pj4yXT1kZXN0cnVjdG9yfTt0aGlzLmdldF9kZXN0cnVjdG9yPWZ1bmN0aW9uKCl7cmV0dXJuIEhFQVBVMzJbdGhpcy5wdHIrOD4+Ml19O3RoaXMuc2V0X2NhdWdodD1mdW5jdGlvbihjYXVnaHQpe2NhdWdodD1jYXVnaHQ/MTowO0hFQVA4W3RoaXMucHRyKzEyPj4wXT1jYXVnaHR9O3RoaXMuZ2V0X2NhdWdodD1mdW5jdGlvbigpe3JldHVybiBIRUFQOFt0aGlzLnB0cisxMj4+MF0hPTB9O3RoaXMuc2V0X3JldGhyb3duPWZ1bmN0aW9uKHJldGhyb3duKXtyZXRocm93bj1yZXRocm93bj8xOjA7SEVBUDhbdGhpcy5wdHIrMTM+PjBdPXJldGhyb3dufTt0aGlzLmdldF9yZXRocm93bj1mdW5jdGlvbigpe3JldHVybiBIRUFQOFt0aGlzLnB0cisxMz4+MF0hPTB9O3RoaXMuaW5pdD1mdW5jdGlvbih0eXBlLGRlc3RydWN0b3Ipe3RoaXMuc2V0X2FkanVzdGVkX3B0cigwKTt0aGlzLnNldF90eXBlKHR5cGUpO3RoaXMuc2V0X2Rlc3RydWN0b3IoZGVzdHJ1Y3Rvcil9O3RoaXMuc2V0X2FkanVzdGVkX3B0cj1mdW5jdGlvbihhZGp1c3RlZFB0cil7SEVBUFUzMlt0aGlzLnB0cisxNj4+Ml09YWRqdXN0ZWRQdHJ9O3RoaXMuZ2V0X2FkanVzdGVkX3B0cj1mdW5jdGlvbigpe3JldHVybiBIRUFQVTMyW3RoaXMucHRyKzE2Pj4yXX07dGhpcy5nZXRfZXhjZXB0aW9uX3B0cj1mdW5jdGlvbigpe3ZhciBpc1BvaW50ZXI9X19fY3hhX2lzX3BvaW50ZXJfdHlwZSh0aGlzLmdldF90eXBlKCkpO2lmKGlzUG9pbnRlcil7cmV0dXJuIEhFQVBVMzJbdGhpcy5leGNQdHI+PjJdfXZhciBhZGp1c3RlZD10aGlzLmdldF9hZGp1c3RlZF9wdHIoKTtpZihhZGp1c3RlZCE9PTApcmV0dXJuIGFkanVzdGVkO3JldHVybiB0aGlzLmV4Y1B0cn19dmFyIF9fX3Jlc3VtZUV4Y2VwdGlvbj1wdHI9PntpZighZXhjZXB0aW9uTGFzdCl7ZXhjZXB0aW9uTGFzdD1wdHJ9dGhyb3cgZXhjZXB0aW9uTGFzdH07dmFyIGZpbmRNYXRjaGluZ0NhdGNoPWFyZ3M9Pnt2YXIgdGhyb3duPWV4Y2VwdGlvbkxhc3Q7aWYoIXRocm93bil7c2V0VGVtcFJldDAoMCk7cmV0dXJuIDB9dmFyIGluZm89bmV3IEV4Y2VwdGlvbkluZm8odGhyb3duKTtpbmZvLnNldF9hZGp1c3RlZF9wdHIodGhyb3duKTt2YXIgdGhyb3duVHlwZT1pbmZvLmdldF90eXBlKCk7aWYoIXRocm93blR5cGUpe3NldFRlbXBSZXQwKDApO3JldHVybiB0aHJvd259Zm9yKHZhciBhcmcgaW4gYXJncyl7dmFyIGNhdWdodFR5cGU9YXJnc1thcmddO2lmKGNhdWdodFR5cGU9PT0wfHxjYXVnaHRUeXBlPT09dGhyb3duVHlwZSl7YnJlYWt9dmFyIGFkanVzdGVkX3B0cl9hZGRyPWluZm8ucHRyKzE2O2lmKF9fX2N4YV9jYW5fY2F0Y2goY2F1Z2h0VHlwZSx0aHJvd25UeXBlLGFkanVzdGVkX3B0cl9hZGRyKSl7c2V0VGVtcFJldDAoY2F1Z2h0VHlwZSk7cmV0dXJuIHRocm93bn19c2V0VGVtcFJldDAodGhyb3duVHlwZSk7cmV0dXJuIHRocm93bn07dmFyIF9fX2N4YV9maW5kX21hdGNoaW5nX2NhdGNoXzI9KCk9PmZpbmRNYXRjaGluZ0NhdGNoKFtdKTt2YXIgX19fY3hhX2ZpbmRfbWF0Y2hpbmdfY2F0Y2hfMz1hcmcwPT5maW5kTWF0Y2hpbmdDYXRjaChbYXJnMF0pO3ZhciBfX19jeGFfcmV0aHJvdz0oKT0+e3ZhciBpbmZvPWV4Y2VwdGlvbkNhdWdodC5wb3AoKTtpZighaW5mbyl7YWJvcnQoIm5vIGV4Y2VwdGlvbiB0byB0aHJvdyIpfXZhciBwdHI9aW5mby5leGNQdHI7aWYoIWluZm8uZ2V0X3JldGhyb3duKCkpe2V4Y2VwdGlvbkNhdWdodC5wdXNoKGluZm8pO2luZm8uc2V0X3JldGhyb3duKHRydWUpO2luZm8uc2V0X2NhdWdodChmYWxzZSk7dW5jYXVnaHRFeGNlcHRpb25Db3VudCsrfWV4Y2VwdGlvbkxhc3Q9cHRyO3Rocm93IGV4Y2VwdGlvbkxhc3R9O3ZhciBfX19jeGFfdGhyb3c9KHB0cix0eXBlLGRlc3RydWN0b3IpPT57dmFyIGluZm89bmV3IEV4Y2VwdGlvbkluZm8ocHRyKTtpbmZvLmluaXQodHlwZSxkZXN0cnVjdG9yKTtleGNlcHRpb25MYXN0PXB0cjt1bmNhdWdodEV4Y2VwdGlvbkNvdW50Kys7dGhyb3cgZXhjZXB0aW9uTGFzdH07dmFyIF9fX2Vtc2NyaXB0ZW5faW5pdF9tYWluX3RocmVhZF9qcz10Yj0+e19fZW1zY3JpcHRlbl90aHJlYWRfaW5pdCh0YiwhRU5WSVJPTk1FTlRfSVNfV09SS0VSLDEsIUVOVklST05NRU5UX0lTX1dFQiw2NTUzNixmYWxzZSk7UFRocmVhZC50aHJlYWRJbml0VExTKCl9O3ZhciBfX19lbXNjcmlwdGVuX3RocmVhZF9jbGVhbnVwPXRocmVhZD0+e2lmKCFFTlZJUk9OTUVOVF9JU19QVEhSRUFEKWNsZWFudXBUaHJlYWQodGhyZWFkKTtlbHNlIHBvc3RNZXNzYWdlKHsiY21kIjoiY2xlYW51cFRocmVhZCIsInRocmVhZCI6dGhyZWFkfSl9O2Z1bmN0aW9uIHB0aHJlYWRDcmVhdGVQcm94aWVkKHB0aHJlYWRfcHRyLGF0dHIsc3RhcnRSb3V0aW5lLGFyZyl7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRClyZXR1cm4gcHJveHlUb01haW5UaHJlYWQoMiwxLHB0aHJlYWRfcHRyLGF0dHIsc3RhcnRSb3V0aW5lLGFyZyk7cmV0dXJuIF9fX3B0aHJlYWRfY3JlYXRlX2pzKHB0aHJlYWRfcHRyLGF0dHIsc3RhcnRSb3V0aW5lLGFyZyl9dmFyIF9fX3B0aHJlYWRfY3JlYXRlX2pzPShwdGhyZWFkX3B0cixhdHRyLHN0YXJ0Um91dGluZSxhcmcpPT57aWYodHlwZW9mIFNoYXJlZEFycmF5QnVmZmVyPT0idW5kZWZpbmVkIil7ZXJyKCJDdXJyZW50IGVudmlyb25tZW50IGRvZXMgbm90IHN1cHBvcnQgU2hhcmVkQXJyYXlCdWZmZXIsIHB0aHJlYWRzIGFyZSBub3QgYXZhaWxhYmxlISIpO3JldHVybiA2fXZhciB0cmFuc2Zlckxpc3Q9W107dmFyIGVycm9yPTA7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRCYmKHRyYW5zZmVyTGlzdC5sZW5ndGg9PT0wfHxlcnJvcikpe3JldHVybiBwdGhyZWFkQ3JlYXRlUHJveGllZChwdGhyZWFkX3B0cixhdHRyLHN0YXJ0Um91dGluZSxhcmcpfWlmKGVycm9yKXJldHVybiBlcnJvcjt2YXIgdGhyZWFkUGFyYW1zPXtzdGFydFJvdXRpbmU6c3RhcnRSb3V0aW5lLHB0aHJlYWRfcHRyOnB0aHJlYWRfcHRyLGFyZzphcmcsdHJhbnNmZXJMaXN0OnRyYW5zZmVyTGlzdH07aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRCl7dGhyZWFkUGFyYW1zLmNtZD0ic3Bhd25UaHJlYWQiO3Bvc3RNZXNzYWdlKHRocmVhZFBhcmFtcyx0cmFuc2Zlckxpc3QpO3JldHVybiAwfXJldHVybiBzcGF3blRocmVhZCh0aHJlYWRQYXJhbXMpfTt2YXIgc2V0RXJyTm89dmFsdWU9PntIRUFQMzJbX19fZXJybm9fbG9jYXRpb24oKT4+Ml09dmFsdWU7cmV0dXJuIHZhbHVlfTtmdW5jdGlvbiBfX19zeXNjYWxsX2ZjbnRsNjQoZmQsY21kLHZhcmFyZ3Mpe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpcmV0dXJuIHByb3h5VG9NYWluVGhyZWFkKDMsMSxmZCxjbWQsdmFyYXJncyk7U1lTQ0FMTFMudmFyYXJncz12YXJhcmdzO3RyeXt2YXIgc3RyZWFtPVNZU0NBTExTLmdldFN0cmVhbUZyb21GRChmZCk7c3dpdGNoKGNtZCl7Y2FzZSAwOnt2YXIgYXJnPVNZU0NBTExTLmdldCgpO2lmKGFyZzwwKXtyZXR1cm4tMjh9d2hpbGUoRlMuc3RyZWFtc1thcmddKXthcmcrK312YXIgbmV3U3RyZWFtO25ld1N0cmVhbT1GUy5jcmVhdGVTdHJlYW0oc3RyZWFtLGFyZyk7cmV0dXJuIG5ld1N0cmVhbS5mZH1jYXNlIDE6Y2FzZSAyOnJldHVybiAwO2Nhc2UgMzpyZXR1cm4gc3RyZWFtLmZsYWdzO2Nhc2UgNDp7dmFyIGFyZz1TWVNDQUxMUy5nZXQoKTtzdHJlYW0uZmxhZ3N8PWFyZztyZXR1cm4gMH1jYXNlIDU6e3ZhciBhcmc9U1lTQ0FMTFMuZ2V0cCgpO3ZhciBvZmZzZXQ9MDtIRUFQMTZbYXJnK29mZnNldD4+MV09MjtyZXR1cm4gMH1jYXNlIDY6Y2FzZSA3OnJldHVybiAwO2Nhc2UgMTY6Y2FzZSA4OnJldHVybi0yODtjYXNlIDk6c2V0RXJyTm8oMjgpO3JldHVybi0xO2RlZmF1bHQ6e3JldHVybi0yOH19fWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybi1lLmVycm5vfX1mdW5jdGlvbiBfX19zeXNjYWxsX2ZzdGF0NjQoZmQsYnVmKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCg0LDEsZmQsYnVmKTt0cnl7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO3JldHVybiBTWVNDQUxMUy5kb1N0YXQoRlMuc3RhdCxzdHJlYW0ucGF0aCxidWYpfWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybi1lLmVycm5vfX1mdW5jdGlvbiBfX19zeXNjYWxsX2Z0cnVuY2F0ZTY0KGZkLGxlbmd0aF9sb3csbGVuZ3RoX2hpZ2gpe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpcmV0dXJuIHByb3h5VG9NYWluVGhyZWFkKDUsMSxmZCxsZW5ndGhfbG93LGxlbmd0aF9oaWdoKTt2YXIgbGVuZ3RoPWNvbnZlcnRJMzJQYWlyVG9JNTNDaGVja2VkKGxlbmd0aF9sb3csbGVuZ3RoX2hpZ2gpO3RyeXtpZihpc05hTihsZW5ndGgpKXJldHVybiA2MTtGUy5mdHJ1bmNhdGUoZmQsbGVuZ3RoKTtyZXR1cm4gMH1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319ZnVuY3Rpb24gX19fc3lzY2FsbF9pb2N0bChmZCxvcCx2YXJhcmdzKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCg2LDEsZmQsb3AsdmFyYXJncyk7U1lTQ0FMTFMudmFyYXJncz12YXJhcmdzO3RyeXt2YXIgc3RyZWFtPVNZU0NBTExTLmdldFN0cmVhbUZyb21GRChmZCk7c3dpdGNoKG9wKXtjYXNlIDIxNTA5OntpZighc3RyZWFtLnR0eSlyZXR1cm4tNTk7cmV0dXJuIDB9Y2FzZSAyMTUwNTp7aWYoIXN0cmVhbS50dHkpcmV0dXJuLTU5O2lmKHN0cmVhbS50dHkub3BzLmlvY3RsX3RjZ2V0cyl7dmFyIHRlcm1pb3M9c3RyZWFtLnR0eS5vcHMuaW9jdGxfdGNnZXRzKHN0cmVhbSk7dmFyIGFyZ3A9U1lTQ0FMTFMuZ2V0cCgpO0hFQVAzMlthcmdwPj4yXT10ZXJtaW9zLmNfaWZsYWd8fDA7SEVBUDMyW2FyZ3ArND4+Ml09dGVybWlvcy5jX29mbGFnfHwwO0hFQVAzMlthcmdwKzg+PjJdPXRlcm1pb3MuY19jZmxhZ3x8MDtIRUFQMzJbYXJncCsxMj4+Ml09dGVybWlvcy5jX2xmbGFnfHwwO2Zvcih2YXIgaT0wO2k8MzI7aSsrKXtIRUFQOFthcmdwK2krMTc+PjBdPXRlcm1pb3MuY19jY1tpXXx8MH1yZXR1cm4gMH1yZXR1cm4gMH1jYXNlIDIxNTEwOmNhc2UgMjE1MTE6Y2FzZSAyMTUxMjp7aWYoIXN0cmVhbS50dHkpcmV0dXJuLTU5O3JldHVybiAwfWNhc2UgMjE1MDY6Y2FzZSAyMTUwNzpjYXNlIDIxNTA4OntpZighc3RyZWFtLnR0eSlyZXR1cm4tNTk7aWYoc3RyZWFtLnR0eS5vcHMuaW9jdGxfdGNzZXRzKXt2YXIgYXJncD1TWVNDQUxMUy5nZXRwKCk7dmFyIGNfaWZsYWc9SEVBUDMyW2FyZ3A+PjJdO3ZhciBjX29mbGFnPUhFQVAzMlthcmdwKzQ+PjJdO3ZhciBjX2NmbGFnPUhFQVAzMlthcmdwKzg+PjJdO3ZhciBjX2xmbGFnPUhFQVAzMlthcmdwKzEyPj4yXTt2YXIgY19jYz1bXTtmb3IodmFyIGk9MDtpPDMyO2krKyl7Y19jYy5wdXNoKEhFQVA4W2FyZ3AraSsxNz4+MF0pfXJldHVybiBzdHJlYW0udHR5Lm9wcy5pb2N0bF90Y3NldHMoc3RyZWFtLnR0eSxvcCx7Y19pZmxhZzpjX2lmbGFnLGNfb2ZsYWc6Y19vZmxhZyxjX2NmbGFnOmNfY2ZsYWcsY19sZmxhZzpjX2xmbGFnLGNfY2M6Y19jY30pfXJldHVybiAwfWNhc2UgMjE1MTk6e2lmKCFzdHJlYW0udHR5KXJldHVybi01OTt2YXIgYXJncD1TWVNDQUxMUy5nZXRwKCk7SEVBUDMyW2FyZ3A+PjJdPTA7cmV0dXJuIDB9Y2FzZSAyMTUyMDp7aWYoIXN0cmVhbS50dHkpcmV0dXJuLTU5O3JldHVybi0yOH1jYXNlIDIxNTMxOnt2YXIgYXJncD1TWVNDQUxMUy5nZXRwKCk7cmV0dXJuIEZTLmlvY3RsKHN0cmVhbSxvcCxhcmdwKX1jYXNlIDIxNTIzOntpZighc3RyZWFtLnR0eSlyZXR1cm4tNTk7aWYoc3RyZWFtLnR0eS5vcHMuaW9jdGxfdGlvY2d3aW5zeil7dmFyIHdpbnNpemU9c3RyZWFtLnR0eS5vcHMuaW9jdGxfdGlvY2d3aW5zeihzdHJlYW0udHR5KTt2YXIgYXJncD1TWVNDQUxMUy5nZXRwKCk7SEVBUDE2W2FyZ3A+PjFdPXdpbnNpemVbMF07SEVBUDE2W2FyZ3ArMj4+MV09d2luc2l6ZVsxXX1yZXR1cm4gMH1jYXNlIDIxNTI0OntpZighc3RyZWFtLnR0eSlyZXR1cm4tNTk7cmV0dXJuIDB9Y2FzZSAyMTUxNTp7aWYoIXN0cmVhbS50dHkpcmV0dXJuLTU5O3JldHVybiAwfWRlZmF1bHQ6cmV0dXJuLTI4fX1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319ZnVuY3Rpb24gX19fc3lzY2FsbF9sc3RhdDY0KHBhdGgsYnVmKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCg3LDEscGF0aCxidWYpO3RyeXtwYXRoPVNZU0NBTExTLmdldFN0cihwYXRoKTtyZXR1cm4gU1lTQ0FMTFMuZG9TdGF0KEZTLmxzdGF0LHBhdGgsYnVmKX1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319ZnVuY3Rpb24gX19fc3lzY2FsbF9uZXdmc3RhdGF0KGRpcmZkLHBhdGgsYnVmLGZsYWdzKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCg4LDEsZGlyZmQscGF0aCxidWYsZmxhZ3MpO3RyeXtwYXRoPVNZU0NBTExTLmdldFN0cihwYXRoKTt2YXIgbm9mb2xsb3c9ZmxhZ3MmMjU2O3ZhciBhbGxvd0VtcHR5PWZsYWdzJjQwOTY7ZmxhZ3M9ZmxhZ3MmfjY0MDA7cGF0aD1TWVNDQUxMUy5jYWxjdWxhdGVBdChkaXJmZCxwYXRoLGFsbG93RW1wdHkpO3JldHVybiBTWVNDQUxMUy5kb1N0YXQobm9mb2xsb3c/RlMubHN0YXQ6RlMuc3RhdCxwYXRoLGJ1Zil9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuLWUuZXJybm99fWZ1bmN0aW9uIF9fX3N5c2NhbGxfb3BlbmF0KGRpcmZkLHBhdGgsZmxhZ3MsdmFyYXJncyl7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRClyZXR1cm4gcHJveHlUb01haW5UaHJlYWQoOSwxLGRpcmZkLHBhdGgsZmxhZ3MsdmFyYXJncyk7U1lTQ0FMTFMudmFyYXJncz12YXJhcmdzO3RyeXtwYXRoPVNZU0NBTExTLmdldFN0cihwYXRoKTtwYXRoPVNZU0NBTExTLmNhbGN1bGF0ZUF0KGRpcmZkLHBhdGgpO3ZhciBtb2RlPXZhcmFyZ3M/U1lTQ0FMTFMuZ2V0KCk6MDtyZXR1cm4gRlMub3BlbihwYXRoLGZsYWdzLG1vZGUpLmZkfWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybi1lLmVycm5vfX12YXIgc3RyaW5nVG9VVEY4PShzdHIsb3V0UHRyLG1heEJ5dGVzVG9Xcml0ZSk9PnN0cmluZ1RvVVRGOEFycmF5KHN0cixIRUFQVTgsb3V0UHRyLG1heEJ5dGVzVG9Xcml0ZSk7ZnVuY3Rpb24gX19fc3lzY2FsbF9yZWFkbGlua2F0KGRpcmZkLHBhdGgsYnVmLGJ1ZnNpemUpe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpcmV0dXJuIHByb3h5VG9NYWluVGhyZWFkKDEwLDEsZGlyZmQscGF0aCxidWYsYnVmc2l6ZSk7dHJ5e3BhdGg9U1lTQ0FMTFMuZ2V0U3RyKHBhdGgpO3BhdGg9U1lTQ0FMTFMuY2FsY3VsYXRlQXQoZGlyZmQscGF0aCk7aWYoYnVmc2l6ZTw9MClyZXR1cm4tMjg7dmFyIHJldD1GUy5yZWFkbGluayhwYXRoKTt2YXIgbGVuPU1hdGgubWluKGJ1ZnNpemUsbGVuZ3RoQnl0ZXNVVEY4KHJldCkpO3ZhciBlbmRDaGFyPUhFQVA4W2J1ZitsZW5dO3N0cmluZ1RvVVRGOChyZXQsYnVmLGJ1ZnNpemUrMSk7SEVBUDhbYnVmK2xlbl09ZW5kQ2hhcjtyZXR1cm4gbGVufWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybi1lLmVycm5vfX1mdW5jdGlvbiBfX19zeXNjYWxsX3JlbmFtZWF0KG9sZGRpcmZkLG9sZHBhdGgsbmV3ZGlyZmQsbmV3cGF0aCl7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRClyZXR1cm4gcHJveHlUb01haW5UaHJlYWQoMTEsMSxvbGRkaXJmZCxvbGRwYXRoLG5ld2RpcmZkLG5ld3BhdGgpO3RyeXtvbGRwYXRoPVNZU0NBTExTLmdldFN0cihvbGRwYXRoKTtuZXdwYXRoPVNZU0NBTExTLmdldFN0cihuZXdwYXRoKTtvbGRwYXRoPVNZU0NBTExTLmNhbGN1bGF0ZUF0KG9sZGRpcmZkLG9sZHBhdGgpO25ld3BhdGg9U1lTQ0FMTFMuY2FsY3VsYXRlQXQobmV3ZGlyZmQsbmV3cGF0aCk7RlMucmVuYW1lKG9sZHBhdGgsbmV3cGF0aCk7cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuLWUuZXJybm99fWZ1bmN0aW9uIF9fX3N5c2NhbGxfc3RhdDY0KHBhdGgsYnVmKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCgxMiwxLHBhdGgsYnVmKTt0cnl7cGF0aD1TWVNDQUxMUy5nZXRTdHIocGF0aCk7cmV0dXJuIFNZU0NBTExTLmRvU3RhdChGUy5zdGF0LHBhdGgsYnVmKX1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319ZnVuY3Rpb24gX19fc3lzY2FsbF91bmxpbmthdChkaXJmZCxwYXRoLGZsYWdzKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCgxMywxLGRpcmZkLHBhdGgsZmxhZ3MpO3RyeXtwYXRoPVNZU0NBTExTLmdldFN0cihwYXRoKTtwYXRoPVNZU0NBTExTLmNhbGN1bGF0ZUF0KGRpcmZkLHBhdGgpO2lmKGZsYWdzPT09MCl7RlMudW5saW5rKHBhdGgpfWVsc2UgaWYoZmxhZ3M9PT01MTIpe0ZTLnJtZGlyKHBhdGgpfWVsc2V7YWJvcnQoIkludmFsaWQgZmxhZ3MgcGFzc2VkIHRvIHVubGlua2F0Iil9cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuLWUuZXJybm99fXZhciBfX2VtYmluZF9yZWdpc3Rlcl9iaWdpbnQ9KHByaW1pdGl2ZVR5cGUsbmFtZSxzaXplLG1pblJhbmdlLG1heFJhbmdlKT0+e307dmFyIGVtYmluZF9pbml0X2NoYXJDb2Rlcz0oKT0+e3ZhciBjb2Rlcz1uZXcgQXJyYXkoMjU2KTtmb3IodmFyIGk9MDtpPDI1NjsrK2kpe2NvZGVzW2ldPVN0cmluZy5mcm9tQ2hhckNvZGUoaSl9ZW1iaW5kX2NoYXJDb2Rlcz1jb2Rlc307dmFyIGVtYmluZF9jaGFyQ29kZXM7dmFyIHJlYWRMYXRpbjFTdHJpbmc9cHRyPT57dmFyIHJldD0iIjt2YXIgYz1wdHI7d2hpbGUoSEVBUFU4W2NdKXtyZXQrPWVtYmluZF9jaGFyQ29kZXNbSEVBUFU4W2MrK11dfXJldHVybiByZXR9O3ZhciBhd2FpdGluZ0RlcGVuZGVuY2llcz17fTt2YXIgcmVnaXN0ZXJlZFR5cGVzPXt9O3ZhciB0eXBlRGVwZW5kZW5jaWVzPXt9O3ZhciBCaW5kaW5nRXJyb3I7dmFyIHRocm93QmluZGluZ0Vycm9yPW1lc3NhZ2U9Pnt0aHJvdyBuZXcgQmluZGluZ0Vycm9yKG1lc3NhZ2UpfTt2YXIgSW50ZXJuYWxFcnJvcjt2YXIgdGhyb3dJbnRlcm5hbEVycm9yPW1lc3NhZ2U9Pnt0aHJvdyBuZXcgSW50ZXJuYWxFcnJvcihtZXNzYWdlKX07dmFyIHdoZW5EZXBlbmRlbnRUeXBlc0FyZVJlc29sdmVkPShteVR5cGVzLGRlcGVuZGVudFR5cGVzLGdldFR5cGVDb252ZXJ0ZXJzKT0+e215VHlwZXMuZm9yRWFjaChmdW5jdGlvbih0eXBlKXt0eXBlRGVwZW5kZW5jaWVzW3R5cGVdPWRlcGVuZGVudFR5cGVzfSk7ZnVuY3Rpb24gb25Db21wbGV0ZSh0eXBlQ29udmVydGVycyl7dmFyIG15VHlwZUNvbnZlcnRlcnM9Z2V0VHlwZUNvbnZlcnRlcnModHlwZUNvbnZlcnRlcnMpO2lmKG15VHlwZUNvbnZlcnRlcnMubGVuZ3RoIT09bXlUeXBlcy5sZW5ndGgpe3Rocm93SW50ZXJuYWxFcnJvcigiTWlzbWF0Y2hlZCB0eXBlIGNvbnZlcnRlciBjb3VudCIpfWZvcih2YXIgaT0wO2k8bXlUeXBlcy5sZW5ndGg7KytpKXtyZWdpc3RlclR5cGUobXlUeXBlc1tpXSxteVR5cGVDb252ZXJ0ZXJzW2ldKX19dmFyIHR5cGVDb252ZXJ0ZXJzPW5ldyBBcnJheShkZXBlbmRlbnRUeXBlcy5sZW5ndGgpO3ZhciB1bnJlZ2lzdGVyZWRUeXBlcz1bXTt2YXIgcmVnaXN0ZXJlZD0wO2RlcGVuZGVudFR5cGVzLmZvckVhY2goKGR0LGkpPT57aWYocmVnaXN0ZXJlZFR5cGVzLmhhc093blByb3BlcnR5KGR0KSl7dHlwZUNvbnZlcnRlcnNbaV09cmVnaXN0ZXJlZFR5cGVzW2R0XX1lbHNle3VucmVnaXN0ZXJlZFR5cGVzLnB1c2goZHQpO2lmKCFhd2FpdGluZ0RlcGVuZGVuY2llcy5oYXNPd25Qcm9wZXJ0eShkdCkpe2F3YWl0aW5nRGVwZW5kZW5jaWVzW2R0XT1bXX1hd2FpdGluZ0RlcGVuZGVuY2llc1tkdF0ucHVzaCgoKT0+e3R5cGVDb252ZXJ0ZXJzW2ldPXJlZ2lzdGVyZWRUeXBlc1tkdF07KytyZWdpc3RlcmVkO2lmKHJlZ2lzdGVyZWQ9PT11bnJlZ2lzdGVyZWRUeXBlcy5sZW5ndGgpe29uQ29tcGxldGUodHlwZUNvbnZlcnRlcnMpfX0pfX0pO2lmKDA9PT11bnJlZ2lzdGVyZWRUeXBlcy5sZW5ndGgpe29uQ29tcGxldGUodHlwZUNvbnZlcnRlcnMpfX07ZnVuY3Rpb24gc2hhcmVkUmVnaXN0ZXJUeXBlKHJhd1R5cGUscmVnaXN0ZXJlZEluc3RhbmNlLG9wdGlvbnM9e30pe3ZhciBuYW1lPXJlZ2lzdGVyZWRJbnN0YW5jZS5uYW1lO2lmKCFyYXdUeXBlKXt0aHJvd0JpbmRpbmdFcnJvcihgdHlwZSAiJHtuYW1lfSIgbXVzdCBoYXZlIGEgcG9zaXRpdmUgaW50ZWdlciB0eXBlaWQgcG9pbnRlcmApfWlmKHJlZ2lzdGVyZWRUeXBlcy5oYXNPd25Qcm9wZXJ0eShyYXdUeXBlKSl7aWYob3B0aW9ucy5pZ25vcmVEdXBsaWNhdGVSZWdpc3RyYXRpb25zKXtyZXR1cm59ZWxzZXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IHJlZ2lzdGVyIHR5cGUgJyR7bmFtZX0nIHR3aWNlYCl9fXJlZ2lzdGVyZWRUeXBlc1tyYXdUeXBlXT1yZWdpc3RlcmVkSW5zdGFuY2U7ZGVsZXRlIHR5cGVEZXBlbmRlbmNpZXNbcmF3VHlwZV07aWYoYXdhaXRpbmdEZXBlbmRlbmNpZXMuaGFzT3duUHJvcGVydHkocmF3VHlwZSkpe3ZhciBjYWxsYmFja3M9YXdhaXRpbmdEZXBlbmRlbmNpZXNbcmF3VHlwZV07ZGVsZXRlIGF3YWl0aW5nRGVwZW5kZW5jaWVzW3Jhd1R5cGVdO2NhbGxiYWNrcy5mb3JFYWNoKGNiPT5jYigpKX19ZnVuY3Rpb24gcmVnaXN0ZXJUeXBlKHJhd1R5cGUscmVnaXN0ZXJlZEluc3RhbmNlLG9wdGlvbnM9e30pe2lmKCEoImFyZ1BhY2tBZHZhbmNlImluIHJlZ2lzdGVyZWRJbnN0YW5jZSkpe3Rocm93IG5ldyBUeXBlRXJyb3IoInJlZ2lzdGVyVHlwZSByZWdpc3RlcmVkSW5zdGFuY2UgcmVxdWlyZXMgYXJnUGFja0FkdmFuY2UiKX1yZXR1cm4gc2hhcmVkUmVnaXN0ZXJUeXBlKHJhd1R5cGUscmVnaXN0ZXJlZEluc3RhbmNlLG9wdGlvbnMpfXZhciBHZW5lcmljV2lyZVR5cGVTaXplPTg7dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX2Jvb2w9KHJhd1R5cGUsbmFtZSx0cnVlVmFsdWUsZmFsc2VWYWx1ZSk9PntuYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7cmVnaXN0ZXJUeXBlKHJhd1R5cGUse25hbWU6bmFtZSwiZnJvbVdpcmVUeXBlIjpmdW5jdGlvbih3dCl7cmV0dXJuISF3dH0sInRvV2lyZVR5cGUiOmZ1bmN0aW9uKGRlc3RydWN0b3JzLG8pe3JldHVybiBvP3RydWVWYWx1ZTpmYWxzZVZhbHVlfSwiYXJnUGFja0FkdmFuY2UiOkdlbmVyaWNXaXJlVHlwZVNpemUsInJlYWRWYWx1ZUZyb21Qb2ludGVyIjpmdW5jdGlvbihwb2ludGVyKXtyZXR1cm4gdGhpc1siZnJvbVdpcmVUeXBlIl0oSEVBUFU4W3BvaW50ZXJdKX0sZGVzdHJ1Y3RvckZ1bmN0aW9uOm51bGx9KX07dmFyIHNoYWxsb3dDb3B5SW50ZXJuYWxQb2ludGVyPW89Pih7Y291bnQ6by5jb3VudCxkZWxldGVTY2hlZHVsZWQ6by5kZWxldGVTY2hlZHVsZWQscHJlc2VydmVQb2ludGVyT25EZWxldGU6by5wcmVzZXJ2ZVBvaW50ZXJPbkRlbGV0ZSxwdHI6by5wdHIscHRyVHlwZTpvLnB0clR5cGUsc21hcnRQdHI6by5zbWFydFB0cixzbWFydFB0clR5cGU6by5zbWFydFB0clR5cGV9KTt2YXIgdGhyb3dJbnN0YW5jZUFscmVhZHlEZWxldGVkPW9iaj0+e2Z1bmN0aW9uIGdldEluc3RhbmNlVHlwZU5hbWUoaGFuZGxlKXtyZXR1cm4gaGFuZGxlLiQkLnB0clR5cGUucmVnaXN0ZXJlZENsYXNzLm5hbWV9dGhyb3dCaW5kaW5nRXJyb3IoZ2V0SW5zdGFuY2VUeXBlTmFtZShvYmopKyIgaW5zdGFuY2UgYWxyZWFkeSBkZWxldGVkIil9O3ZhciBmaW5hbGl6YXRpb25SZWdpc3RyeT1mYWxzZTt2YXIgZGV0YWNoRmluYWxpemVyPWhhbmRsZT0+e307dmFyIHJ1bkRlc3RydWN0b3I9JCQ9PntpZigkJC5zbWFydFB0cil7JCQuc21hcnRQdHJUeXBlLnJhd0Rlc3RydWN0b3IoJCQuc21hcnRQdHIpfWVsc2V7JCQucHRyVHlwZS5yZWdpc3RlcmVkQ2xhc3MucmF3RGVzdHJ1Y3RvcigkJC5wdHIpfX07dmFyIHJlbGVhc2VDbGFzc0hhbmRsZT0kJD0+eyQkLmNvdW50LnZhbHVlLT0xO3ZhciB0b0RlbGV0ZT0wPT09JCQuY291bnQudmFsdWU7aWYodG9EZWxldGUpe3J1bkRlc3RydWN0b3IoJCQpfX07dmFyIGRvd25jYXN0UG9pbnRlcj0ocHRyLHB0ckNsYXNzLGRlc2lyZWRDbGFzcyk9PntpZihwdHJDbGFzcz09PWRlc2lyZWRDbGFzcyl7cmV0dXJuIHB0cn1pZih1bmRlZmluZWQ9PT1kZXNpcmVkQ2xhc3MuYmFzZUNsYXNzKXtyZXR1cm4gbnVsbH12YXIgcnY9ZG93bmNhc3RQb2ludGVyKHB0cixwdHJDbGFzcyxkZXNpcmVkQ2xhc3MuYmFzZUNsYXNzKTtpZihydj09PW51bGwpe3JldHVybiBudWxsfXJldHVybiBkZXNpcmVkQ2xhc3MuZG93bmNhc3QocnYpfTt2YXIgcmVnaXN0ZXJlZFBvaW50ZXJzPXt9O3ZhciBnZXRJbmhlcml0ZWRJbnN0YW5jZUNvdW50PSgpPT5PYmplY3Qua2V5cyhyZWdpc3RlcmVkSW5zdGFuY2VzKS5sZW5ndGg7dmFyIGdldExpdmVJbmhlcml0ZWRJbnN0YW5jZXM9KCk9Pnt2YXIgcnY9W107Zm9yKHZhciBrIGluIHJlZ2lzdGVyZWRJbnN0YW5jZXMpe2lmKHJlZ2lzdGVyZWRJbnN0YW5jZXMuaGFzT3duUHJvcGVydHkoaykpe3J2LnB1c2gocmVnaXN0ZXJlZEluc3RhbmNlc1trXSl9fXJldHVybiBydn07dmFyIGRlbGV0aW9uUXVldWU9W107dmFyIGZsdXNoUGVuZGluZ0RlbGV0ZXM9KCk9Pnt3aGlsZShkZWxldGlvblF1ZXVlLmxlbmd0aCl7dmFyIG9iaj1kZWxldGlvblF1ZXVlLnBvcCgpO29iai4kJC5kZWxldGVTY2hlZHVsZWQ9ZmFsc2U7b2JqWyJkZWxldGUiXSgpfX07dmFyIGRlbGF5RnVuY3Rpb247dmFyIHNldERlbGF5RnVuY3Rpb249Zm49PntkZWxheUZ1bmN0aW9uPWZuO2lmKGRlbGV0aW9uUXVldWUubGVuZ3RoJiZkZWxheUZ1bmN0aW9uKXtkZWxheUZ1bmN0aW9uKGZsdXNoUGVuZGluZ0RlbGV0ZXMpfX07dmFyIGluaXRfZW1iaW5kPSgpPT57TW9kdWxlWyJnZXRJbmhlcml0ZWRJbnN0YW5jZUNvdW50Il09Z2V0SW5oZXJpdGVkSW5zdGFuY2VDb3VudDtNb2R1bGVbImdldExpdmVJbmhlcml0ZWRJbnN0YW5jZXMiXT1nZXRMaXZlSW5oZXJpdGVkSW5zdGFuY2VzO01vZHVsZVsiZmx1c2hQZW5kaW5nRGVsZXRlcyJdPWZsdXNoUGVuZGluZ0RlbGV0ZXM7TW9kdWxlWyJzZXREZWxheUZ1bmN0aW9uIl09c2V0RGVsYXlGdW5jdGlvbn07dmFyIHJlZ2lzdGVyZWRJbnN0YW5jZXM9e307dmFyIGdldEJhc2VzdFBvaW50ZXI9KGNsYXNzXyxwdHIpPT57aWYocHRyPT09dW5kZWZpbmVkKXt0aHJvd0JpbmRpbmdFcnJvcigicHRyIHNob3VsZCBub3QgYmUgdW5kZWZpbmVkIil9d2hpbGUoY2xhc3NfLmJhc2VDbGFzcyl7cHRyPWNsYXNzXy51cGNhc3QocHRyKTtjbGFzc189Y2xhc3NfLmJhc2VDbGFzc31yZXR1cm4gcHRyfTt2YXIgZ2V0SW5oZXJpdGVkSW5zdGFuY2U9KGNsYXNzXyxwdHIpPT57cHRyPWdldEJhc2VzdFBvaW50ZXIoY2xhc3NfLHB0cik7cmV0dXJuIHJlZ2lzdGVyZWRJbnN0YW5jZXNbcHRyXX07dmFyIG1ha2VDbGFzc0hhbmRsZT0ocHJvdG90eXBlLHJlY29yZCk9PntpZighcmVjb3JkLnB0clR5cGV8fCFyZWNvcmQucHRyKXt0aHJvd0ludGVybmFsRXJyb3IoIm1ha2VDbGFzc0hhbmRsZSByZXF1aXJlcyBwdHIgYW5kIHB0clR5cGUiKX12YXIgaGFzU21hcnRQdHJUeXBlPSEhcmVjb3JkLnNtYXJ0UHRyVHlwZTt2YXIgaGFzU21hcnRQdHI9ISFyZWNvcmQuc21hcnRQdHI7aWYoaGFzU21hcnRQdHJUeXBlIT09aGFzU21hcnRQdHIpe3Rocm93SW50ZXJuYWxFcnJvcigiQm90aCBzbWFydFB0clR5cGUgYW5kIHNtYXJ0UHRyIG11c3QgYmUgc3BlY2lmaWVkIil9cmVjb3JkLmNvdW50PXt2YWx1ZToxfTtyZXR1cm4gYXR0YWNoRmluYWxpemVyKE9iamVjdC5jcmVhdGUocHJvdG90eXBlLHskJDp7dmFsdWU6cmVjb3JkfX0pKX07ZnVuY3Rpb24gUmVnaXN0ZXJlZFBvaW50ZXJfZnJvbVdpcmVUeXBlKHB0cil7dmFyIHJhd1BvaW50ZXI9dGhpcy5nZXRQb2ludGVlKHB0cik7aWYoIXJhd1BvaW50ZXIpe3RoaXMuZGVzdHJ1Y3RvcihwdHIpO3JldHVybiBudWxsfXZhciByZWdpc3RlcmVkSW5zdGFuY2U9Z2V0SW5oZXJpdGVkSW5zdGFuY2UodGhpcy5yZWdpc3RlcmVkQ2xhc3MscmF3UG9pbnRlcik7aWYodW5kZWZpbmVkIT09cmVnaXN0ZXJlZEluc3RhbmNlKXtpZigwPT09cmVnaXN0ZXJlZEluc3RhbmNlLiQkLmNvdW50LnZhbHVlKXtyZWdpc3RlcmVkSW5zdGFuY2UuJCQucHRyPXJhd1BvaW50ZXI7cmVnaXN0ZXJlZEluc3RhbmNlLiQkLnNtYXJ0UHRyPXB0cjtyZXR1cm4gcmVnaXN0ZXJlZEluc3RhbmNlWyJjbG9uZSJdKCl9ZWxzZXt2YXIgcnY9cmVnaXN0ZXJlZEluc3RhbmNlWyJjbG9uZSJdKCk7dGhpcy5kZXN0cnVjdG9yKHB0cik7cmV0dXJuIHJ2fX1mdW5jdGlvbiBtYWtlRGVmYXVsdEhhbmRsZSgpe2lmKHRoaXMuaXNTbWFydFBvaW50ZXIpe3JldHVybiBtYWtlQ2xhc3NIYW5kbGUodGhpcy5yZWdpc3RlcmVkQ2xhc3MuaW5zdGFuY2VQcm90b3R5cGUse3B0clR5cGU6dGhpcy5wb2ludGVlVHlwZSxwdHI6cmF3UG9pbnRlcixzbWFydFB0clR5cGU6dGhpcyxzbWFydFB0cjpwdHJ9KX1lbHNle3JldHVybiBtYWtlQ2xhc3NIYW5kbGUodGhpcy5yZWdpc3RlcmVkQ2xhc3MuaW5zdGFuY2VQcm90b3R5cGUse3B0clR5cGU6dGhpcyxwdHI6cHRyfSl9fXZhciBhY3R1YWxUeXBlPXRoaXMucmVnaXN0ZXJlZENsYXNzLmdldEFjdHVhbFR5cGUocmF3UG9pbnRlcik7dmFyIHJlZ2lzdGVyZWRQb2ludGVyUmVjb3JkPXJlZ2lzdGVyZWRQb2ludGVyc1thY3R1YWxUeXBlXTtpZighcmVnaXN0ZXJlZFBvaW50ZXJSZWNvcmQpe3JldHVybiBtYWtlRGVmYXVsdEhhbmRsZS5jYWxsKHRoaXMpfXZhciB0b1R5cGU7aWYodGhpcy5pc0NvbnN0KXt0b1R5cGU9cmVnaXN0ZXJlZFBvaW50ZXJSZWNvcmQuY29uc3RQb2ludGVyVHlwZX1lbHNle3RvVHlwZT1yZWdpc3RlcmVkUG9pbnRlclJlY29yZC5wb2ludGVyVHlwZX12YXIgZHA9ZG93bmNhc3RQb2ludGVyKHJhd1BvaW50ZXIsdGhpcy5yZWdpc3RlcmVkQ2xhc3MsdG9UeXBlLnJlZ2lzdGVyZWRDbGFzcyk7aWYoZHA9PT1udWxsKXtyZXR1cm4gbWFrZURlZmF1bHRIYW5kbGUuY2FsbCh0aGlzKX1pZih0aGlzLmlzU21hcnRQb2ludGVyKXtyZXR1cm4gbWFrZUNsYXNzSGFuZGxlKHRvVHlwZS5yZWdpc3RlcmVkQ2xhc3MuaW5zdGFuY2VQcm90b3R5cGUse3B0clR5cGU6dG9UeXBlLHB0cjpkcCxzbWFydFB0clR5cGU6dGhpcyxzbWFydFB0cjpwdHJ9KX1lbHNle3JldHVybiBtYWtlQ2xhc3NIYW5kbGUodG9UeXBlLnJlZ2lzdGVyZWRDbGFzcy5pbnN0YW5jZVByb3RvdHlwZSx7cHRyVHlwZTp0b1R5cGUscHRyOmRwfSl9fXZhciBhdHRhY2hGaW5hbGl6ZXI9aGFuZGxlPT57aWYoInVuZGVmaW5lZCI9PT10eXBlb2YgRmluYWxpemF0aW9uUmVnaXN0cnkpe2F0dGFjaEZpbmFsaXplcj1oYW5kbGU9PmhhbmRsZTtyZXR1cm4gaGFuZGxlfWZpbmFsaXphdGlvblJlZ2lzdHJ5PW5ldyBGaW5hbGl6YXRpb25SZWdpc3RyeShpbmZvPT57cmVsZWFzZUNsYXNzSGFuZGxlKGluZm8uJCQpfSk7YXR0YWNoRmluYWxpemVyPWhhbmRsZT0+e3ZhciAkJD1oYW5kbGUuJCQ7dmFyIGhhc1NtYXJ0UHRyPSEhJCQuc21hcnRQdHI7aWYoaGFzU21hcnRQdHIpe3ZhciBpbmZvPXskJDokJH07ZmluYWxpemF0aW9uUmVnaXN0cnkucmVnaXN0ZXIoaGFuZGxlLGluZm8saGFuZGxlKX1yZXR1cm4gaGFuZGxlfTtkZXRhY2hGaW5hbGl6ZXI9aGFuZGxlPT5maW5hbGl6YXRpb25SZWdpc3RyeS51bnJlZ2lzdGVyKGhhbmRsZSk7cmV0dXJuIGF0dGFjaEZpbmFsaXplcihoYW5kbGUpfTt2YXIgaW5pdF9DbGFzc0hhbmRsZT0oKT0+e09iamVjdC5hc3NpZ24oQ2xhc3NIYW5kbGUucHJvdG90eXBlLHsiaXNBbGlhc09mIihvdGhlcil7aWYoISh0aGlzIGluc3RhbmNlb2YgQ2xhc3NIYW5kbGUpKXtyZXR1cm4gZmFsc2V9aWYoIShvdGhlciBpbnN0YW5jZW9mIENsYXNzSGFuZGxlKSl7cmV0dXJuIGZhbHNlfXZhciBsZWZ0Q2xhc3M9dGhpcy4kJC5wdHJUeXBlLnJlZ2lzdGVyZWRDbGFzczt2YXIgbGVmdD10aGlzLiQkLnB0cjtvdGhlci4kJD1vdGhlci4kJDt2YXIgcmlnaHRDbGFzcz1vdGhlci4kJC5wdHJUeXBlLnJlZ2lzdGVyZWRDbGFzczt2YXIgcmlnaHQ9b3RoZXIuJCQucHRyO3doaWxlKGxlZnRDbGFzcy5iYXNlQ2xhc3Mpe2xlZnQ9bGVmdENsYXNzLnVwY2FzdChsZWZ0KTtsZWZ0Q2xhc3M9bGVmdENsYXNzLmJhc2VDbGFzc313aGlsZShyaWdodENsYXNzLmJhc2VDbGFzcyl7cmlnaHQ9cmlnaHRDbGFzcy51cGNhc3QocmlnaHQpO3JpZ2h0Q2xhc3M9cmlnaHRDbGFzcy5iYXNlQ2xhc3N9cmV0dXJuIGxlZnRDbGFzcz09PXJpZ2h0Q2xhc3MmJmxlZnQ9PT1yaWdodH0sImNsb25lIigpe2lmKCF0aGlzLiQkLnB0cil7dGhyb3dJbnN0YW5jZUFscmVhZHlEZWxldGVkKHRoaXMpfWlmKHRoaXMuJCQucHJlc2VydmVQb2ludGVyT25EZWxldGUpe3RoaXMuJCQuY291bnQudmFsdWUrPTE7cmV0dXJuIHRoaXN9ZWxzZXt2YXIgY2xvbmU9YXR0YWNoRmluYWxpemVyKE9iamVjdC5jcmVhdGUoT2JqZWN0LmdldFByb3RvdHlwZU9mKHRoaXMpLHskJDp7dmFsdWU6c2hhbGxvd0NvcHlJbnRlcm5hbFBvaW50ZXIodGhpcy4kJCl9fSkpO2Nsb25lLiQkLmNvdW50LnZhbHVlKz0xO2Nsb25lLiQkLmRlbGV0ZVNjaGVkdWxlZD1mYWxzZTtyZXR1cm4gY2xvbmV9fSwiZGVsZXRlIigpe2lmKCF0aGlzLiQkLnB0cil7dGhyb3dJbnN0YW5jZUFscmVhZHlEZWxldGVkKHRoaXMpfWlmKHRoaXMuJCQuZGVsZXRlU2NoZWR1bGVkJiYhdGhpcy4kJC5wcmVzZXJ2ZVBvaW50ZXJPbkRlbGV0ZSl7dGhyb3dCaW5kaW5nRXJyb3IoIk9iamVjdCBhbHJlYWR5IHNjaGVkdWxlZCBmb3IgZGVsZXRpb24iKX1kZXRhY2hGaW5hbGl6ZXIodGhpcyk7cmVsZWFzZUNsYXNzSGFuZGxlKHRoaXMuJCQpO2lmKCF0aGlzLiQkLnByZXNlcnZlUG9pbnRlck9uRGVsZXRlKXt0aGlzLiQkLnNtYXJ0UHRyPXVuZGVmaW5lZDt0aGlzLiQkLnB0cj11bmRlZmluZWR9fSwiaXNEZWxldGVkIigpe3JldHVybiF0aGlzLiQkLnB0cn0sImRlbGV0ZUxhdGVyIigpe2lmKCF0aGlzLiQkLnB0cil7dGhyb3dJbnN0YW5jZUFscmVhZHlEZWxldGVkKHRoaXMpfWlmKHRoaXMuJCQuZGVsZXRlU2NoZWR1bGVkJiYhdGhpcy4kJC5wcmVzZXJ2ZVBvaW50ZXJPbkRlbGV0ZSl7dGhyb3dCaW5kaW5nRXJyb3IoIk9iamVjdCBhbHJlYWR5IHNjaGVkdWxlZCBmb3IgZGVsZXRpb24iKX1kZWxldGlvblF1ZXVlLnB1c2godGhpcyk7aWYoZGVsZXRpb25RdWV1ZS5sZW5ndGg9PT0xJiZkZWxheUZ1bmN0aW9uKXtkZWxheUZ1bmN0aW9uKGZsdXNoUGVuZGluZ0RlbGV0ZXMpfXRoaXMuJCQuZGVsZXRlU2NoZWR1bGVkPXRydWU7cmV0dXJuIHRoaXN9fSl9O2Z1bmN0aW9uIENsYXNzSGFuZGxlKCl7fXZhciBjcmVhdGVOYW1lZEZ1bmN0aW9uPShuYW1lLGJvZHkpPT5PYmplY3QuZGVmaW5lUHJvcGVydHkoYm9keSwibmFtZSIse3ZhbHVlOm5hbWV9KTt2YXIgZW5zdXJlT3ZlcmxvYWRUYWJsZT0ocHJvdG8sbWV0aG9kTmFtZSxodW1hbk5hbWUpPT57aWYodW5kZWZpbmVkPT09cHJvdG9bbWV0aG9kTmFtZV0ub3ZlcmxvYWRUYWJsZSl7dmFyIHByZXZGdW5jPXByb3RvW21ldGhvZE5hbWVdO3Byb3RvW21ldGhvZE5hbWVdPWZ1bmN0aW9uKCl7aWYoIXByb3RvW21ldGhvZE5hbWVdLm92ZXJsb2FkVGFibGUuaGFzT3duUHJvcGVydHkoYXJndW1lbnRzLmxlbmd0aCkpe3Rocm93QmluZGluZ0Vycm9yKGBGdW5jdGlvbiAnJHtodW1hbk5hbWV9JyBjYWxsZWQgd2l0aCBhbiBpbnZhbGlkIG51bWJlciBvZiBhcmd1bWVudHMgKCR7YXJndW1lbnRzLmxlbmd0aH0pIC0gZXhwZWN0cyBvbmUgb2YgKCR7cHJvdG9bbWV0aG9kTmFtZV0ub3ZlcmxvYWRUYWJsZX0pIWApfXJldHVybiBwcm90b1ttZXRob2ROYW1lXS5vdmVybG9hZFRhYmxlW2FyZ3VtZW50cy5sZW5ndGhdLmFwcGx5KHRoaXMsYXJndW1lbnRzKX07cHJvdG9bbWV0aG9kTmFtZV0ub3ZlcmxvYWRUYWJsZT1bXTtwcm90b1ttZXRob2ROYW1lXS5vdmVybG9hZFRhYmxlW3ByZXZGdW5jLmFyZ0NvdW50XT1wcmV2RnVuY319O3ZhciBleHBvc2VQdWJsaWNTeW1ib2w9KG5hbWUsdmFsdWUsbnVtQXJndW1lbnRzKT0+e2lmKE1vZHVsZS5oYXNPd25Qcm9wZXJ0eShuYW1lKSl7aWYodW5kZWZpbmVkPT09bnVtQXJndW1lbnRzfHx1bmRlZmluZWQhPT1Nb2R1bGVbbmFtZV0ub3ZlcmxvYWRUYWJsZSYmdW5kZWZpbmVkIT09TW9kdWxlW25hbWVdLm92ZXJsb2FkVGFibGVbbnVtQXJndW1lbnRzXSl7dGhyb3dCaW5kaW5nRXJyb3IoYENhbm5vdCByZWdpc3RlciBwdWJsaWMgbmFtZSAnJHtuYW1lfScgdHdpY2VgKX1lbnN1cmVPdmVybG9hZFRhYmxlKE1vZHVsZSxuYW1lLG5hbWUpO2lmKE1vZHVsZS5oYXNPd25Qcm9wZXJ0eShudW1Bcmd1bWVudHMpKXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IHJlZ2lzdGVyIG11bHRpcGxlIG92ZXJsb2FkcyBvZiBhIGZ1bmN0aW9uIHdpdGggdGhlIHNhbWUgbnVtYmVyIG9mIGFyZ3VtZW50cyAoJHtudW1Bcmd1bWVudHN9KSFgKX1Nb2R1bGVbbmFtZV0ub3ZlcmxvYWRUYWJsZVtudW1Bcmd1bWVudHNdPXZhbHVlfWVsc2V7TW9kdWxlW25hbWVdPXZhbHVlO2lmKHVuZGVmaW5lZCE9PW51bUFyZ3VtZW50cyl7TW9kdWxlW25hbWVdLm51bUFyZ3VtZW50cz1udW1Bcmd1bWVudHN9fX07dmFyIGNoYXJfMD00ODt2YXIgY2hhcl85PTU3O3ZhciBtYWtlTGVnYWxGdW5jdGlvbk5hbWU9bmFtZT0+e2lmKHVuZGVmaW5lZD09PW5hbWUpe3JldHVybiJfdW5rbm93biJ9bmFtZT1uYW1lLnJlcGxhY2UoL1teYS16QS1aMC05X10vZywiJCIpO3ZhciBmPW5hbWUuY2hhckNvZGVBdCgwKTtpZihmPj1jaGFyXzAmJmY8PWNoYXJfOSl7cmV0dXJuYF8ke25hbWV9YH1yZXR1cm4gbmFtZX07ZnVuY3Rpb24gUmVnaXN0ZXJlZENsYXNzKG5hbWUsY29uc3RydWN0b3IsaW5zdGFuY2VQcm90b3R5cGUscmF3RGVzdHJ1Y3RvcixiYXNlQ2xhc3MsZ2V0QWN0dWFsVHlwZSx1cGNhc3QsZG93bmNhc3Qpe3RoaXMubmFtZT1uYW1lO3RoaXMuY29uc3RydWN0b3I9Y29uc3RydWN0b3I7dGhpcy5pbnN0YW5jZVByb3RvdHlwZT1pbnN0YW5jZVByb3RvdHlwZTt0aGlzLnJhd0Rlc3RydWN0b3I9cmF3RGVzdHJ1Y3Rvcjt0aGlzLmJhc2VDbGFzcz1iYXNlQ2xhc3M7dGhpcy5nZXRBY3R1YWxUeXBlPWdldEFjdHVhbFR5cGU7dGhpcy51cGNhc3Q9dXBjYXN0O3RoaXMuZG93bmNhc3Q9ZG93bmNhc3Q7dGhpcy5wdXJlVmlydHVhbEZ1bmN0aW9ucz1bXX12YXIgdXBjYXN0UG9pbnRlcj0ocHRyLHB0ckNsYXNzLGRlc2lyZWRDbGFzcyk9Pnt3aGlsZShwdHJDbGFzcyE9PWRlc2lyZWRDbGFzcyl7aWYoIXB0ckNsYXNzLnVwY2FzdCl7dGhyb3dCaW5kaW5nRXJyb3IoYEV4cGVjdGVkIG51bGwgb3IgaW5zdGFuY2Ugb2YgJHtkZXNpcmVkQ2xhc3MubmFtZX0sIGdvdCBhbiBpbnN0YW5jZSBvZiAke3B0ckNsYXNzLm5hbWV9YCl9cHRyPXB0ckNsYXNzLnVwY2FzdChwdHIpO3B0ckNsYXNzPXB0ckNsYXNzLmJhc2VDbGFzc31yZXR1cm4gcHRyfTtmdW5jdGlvbiBjb25zdE5vU21hcnRQdHJSYXdQb2ludGVyVG9XaXJlVHlwZShkZXN0cnVjdG9ycyxoYW5kbGUpe2lmKGhhbmRsZT09PW51bGwpe2lmKHRoaXMuaXNSZWZlcmVuY2Upe3Rocm93QmluZGluZ0Vycm9yKGBudWxsIGlzIG5vdCBhIHZhbGlkICR7dGhpcy5uYW1lfWApfXJldHVybiAwfWlmKCFoYW5kbGUuJCQpe3Rocm93QmluZGluZ0Vycm9yKGBDYW5ub3QgcGFzcyAiJHtlbWJpbmRSZXByKGhhbmRsZSl9IiBhcyBhICR7dGhpcy5uYW1lfWApfWlmKCFoYW5kbGUuJCQucHRyKXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IHBhc3MgZGVsZXRlZCBvYmplY3QgYXMgYSBwb2ludGVyIG9mIHR5cGUgJHt0aGlzLm5hbWV9YCl9dmFyIGhhbmRsZUNsYXNzPWhhbmRsZS4kJC5wdHJUeXBlLnJlZ2lzdGVyZWRDbGFzczt2YXIgcHRyPXVwY2FzdFBvaW50ZXIoaGFuZGxlLiQkLnB0cixoYW5kbGVDbGFzcyx0aGlzLnJlZ2lzdGVyZWRDbGFzcyk7cmV0dXJuIHB0cn1mdW5jdGlvbiBnZW5lcmljUG9pbnRlclRvV2lyZVR5cGUoZGVzdHJ1Y3RvcnMsaGFuZGxlKXt2YXIgcHRyO2lmKGhhbmRsZT09PW51bGwpe2lmKHRoaXMuaXNSZWZlcmVuY2Upe3Rocm93QmluZGluZ0Vycm9yKGBudWxsIGlzIG5vdCBhIHZhbGlkICR7dGhpcy5uYW1lfWApfWlmKHRoaXMuaXNTbWFydFBvaW50ZXIpe3B0cj10aGlzLnJhd0NvbnN0cnVjdG9yKCk7aWYoZGVzdHJ1Y3RvcnMhPT1udWxsKXtkZXN0cnVjdG9ycy5wdXNoKHRoaXMucmF3RGVzdHJ1Y3RvcixwdHIpfXJldHVybiBwdHJ9ZWxzZXtyZXR1cm4gMH19aWYoIWhhbmRsZS4kJCl7dGhyb3dCaW5kaW5nRXJyb3IoYENhbm5vdCBwYXNzICIke2VtYmluZFJlcHIoaGFuZGxlKX0iIGFzIGEgJHt0aGlzLm5hbWV9YCl9aWYoIWhhbmRsZS4kJC5wdHIpe3Rocm93QmluZGluZ0Vycm9yKGBDYW5ub3QgcGFzcyBkZWxldGVkIG9iamVjdCBhcyBhIHBvaW50ZXIgb2YgdHlwZSAke3RoaXMubmFtZX1gKX1pZighdGhpcy5pc0NvbnN0JiZoYW5kbGUuJCQucHRyVHlwZS5pc0NvbnN0KXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IGNvbnZlcnQgYXJndW1lbnQgb2YgdHlwZSAke2hhbmRsZS4kJC5zbWFydFB0clR5cGU/aGFuZGxlLiQkLnNtYXJ0UHRyVHlwZS5uYW1lOmhhbmRsZS4kJC5wdHJUeXBlLm5hbWV9IHRvIHBhcmFtZXRlciB0eXBlICR7dGhpcy5uYW1lfWApfXZhciBoYW5kbGVDbGFzcz1oYW5kbGUuJCQucHRyVHlwZS5yZWdpc3RlcmVkQ2xhc3M7cHRyPXVwY2FzdFBvaW50ZXIoaGFuZGxlLiQkLnB0cixoYW5kbGVDbGFzcyx0aGlzLnJlZ2lzdGVyZWRDbGFzcyk7aWYodGhpcy5pc1NtYXJ0UG9pbnRlcil7aWYodW5kZWZpbmVkPT09aGFuZGxlLiQkLnNtYXJ0UHRyKXt0aHJvd0JpbmRpbmdFcnJvcigiUGFzc2luZyByYXcgcG9pbnRlciB0byBzbWFydCBwb2ludGVyIGlzIGlsbGVnYWwiKX1zd2l0Y2godGhpcy5zaGFyaW5nUG9saWN5KXtjYXNlIDA6aWYoaGFuZGxlLiQkLnNtYXJ0UHRyVHlwZT09PXRoaXMpe3B0cj1oYW5kbGUuJCQuc21hcnRQdHJ9ZWxzZXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IGNvbnZlcnQgYXJndW1lbnQgb2YgdHlwZSAke2hhbmRsZS4kJC5zbWFydFB0clR5cGU/aGFuZGxlLiQkLnNtYXJ0UHRyVHlwZS5uYW1lOmhhbmRsZS4kJC5wdHJUeXBlLm5hbWV9IHRvIHBhcmFtZXRlciB0eXBlICR7dGhpcy5uYW1lfWApfWJyZWFrO2Nhc2UgMTpwdHI9aGFuZGxlLiQkLnNtYXJ0UHRyO2JyZWFrO2Nhc2UgMjppZihoYW5kbGUuJCQuc21hcnRQdHJUeXBlPT09dGhpcyl7cHRyPWhhbmRsZS4kJC5zbWFydFB0cn1lbHNle3ZhciBjbG9uZWRIYW5kbGU9aGFuZGxlWyJjbG9uZSJdKCk7cHRyPXRoaXMucmF3U2hhcmUocHRyLEVtdmFsLnRvSGFuZGxlKCgpPT5jbG9uZWRIYW5kbGVbImRlbGV0ZSJdKCkpKTtpZihkZXN0cnVjdG9ycyE9PW51bGwpe2Rlc3RydWN0b3JzLnB1c2godGhpcy5yYXdEZXN0cnVjdG9yLHB0cil9fWJyZWFrO2RlZmF1bHQ6dGhyb3dCaW5kaW5nRXJyb3IoIlVuc3VwcG9ydGluZyBzaGFyaW5nIHBvbGljeSIpfX1yZXR1cm4gcHRyfWZ1bmN0aW9uIG5vbkNvbnN0Tm9TbWFydFB0clJhd1BvaW50ZXJUb1dpcmVUeXBlKGRlc3RydWN0b3JzLGhhbmRsZSl7aWYoaGFuZGxlPT09bnVsbCl7aWYodGhpcy5pc1JlZmVyZW5jZSl7dGhyb3dCaW5kaW5nRXJyb3IoYG51bGwgaXMgbm90IGEgdmFsaWQgJHt0aGlzLm5hbWV9YCl9cmV0dXJuIDB9aWYoIWhhbmRsZS4kJCl7dGhyb3dCaW5kaW5nRXJyb3IoYENhbm5vdCBwYXNzICIke2VtYmluZFJlcHIoaGFuZGxlKX0iIGFzIGEgJHt0aGlzLm5hbWV9YCl9aWYoIWhhbmRsZS4kJC5wdHIpe3Rocm93QmluZGluZ0Vycm9yKGBDYW5ub3QgcGFzcyBkZWxldGVkIG9iamVjdCBhcyBhIHBvaW50ZXIgb2YgdHlwZSAke3RoaXMubmFtZX1gKX1pZihoYW5kbGUuJCQucHRyVHlwZS5pc0NvbnN0KXt0aHJvd0JpbmRpbmdFcnJvcihgQ2Fubm90IGNvbnZlcnQgYXJndW1lbnQgb2YgdHlwZSAke2hhbmRsZS4kJC5wdHJUeXBlLm5hbWV9IHRvIHBhcmFtZXRlciB0eXBlICR7dGhpcy5uYW1lfWApfXZhciBoYW5kbGVDbGFzcz1oYW5kbGUuJCQucHRyVHlwZS5yZWdpc3RlcmVkQ2xhc3M7dmFyIHB0cj11cGNhc3RQb2ludGVyKGhhbmRsZS4kJC5wdHIsaGFuZGxlQ2xhc3MsdGhpcy5yZWdpc3RlcmVkQ2xhc3MpO3JldHVybiBwdHJ9ZnVuY3Rpb24gcmVhZFBvaW50ZXIocG9pbnRlcil7cmV0dXJuIHRoaXNbImZyb21XaXJlVHlwZSJdKEhFQVBVMzJbcG9pbnRlcj4+Ml0pfXZhciBpbml0X1JlZ2lzdGVyZWRQb2ludGVyPSgpPT57T2JqZWN0LmFzc2lnbihSZWdpc3RlcmVkUG9pbnRlci5wcm90b3R5cGUse2dldFBvaW50ZWUocHRyKXtpZih0aGlzLnJhd0dldFBvaW50ZWUpe3B0cj10aGlzLnJhd0dldFBvaW50ZWUocHRyKX1yZXR1cm4gcHRyfSxkZXN0cnVjdG9yKHB0cil7aWYodGhpcy5yYXdEZXN0cnVjdG9yKXt0aGlzLnJhd0Rlc3RydWN0b3IocHRyKX19LCJhcmdQYWNrQWR2YW5jZSI6R2VuZXJpY1dpcmVUeXBlU2l6ZSwicmVhZFZhbHVlRnJvbVBvaW50ZXIiOnJlYWRQb2ludGVyLCJkZWxldGVPYmplY3QiKGhhbmRsZSl7aWYoaGFuZGxlIT09bnVsbCl7aGFuZGxlWyJkZWxldGUiXSgpfX0sImZyb21XaXJlVHlwZSI6UmVnaXN0ZXJlZFBvaW50ZXJfZnJvbVdpcmVUeXBlfSl9O2Z1bmN0aW9uIFJlZ2lzdGVyZWRQb2ludGVyKG5hbWUscmVnaXN0ZXJlZENsYXNzLGlzUmVmZXJlbmNlLGlzQ29uc3QsaXNTbWFydFBvaW50ZXIscG9pbnRlZVR5cGUsc2hhcmluZ1BvbGljeSxyYXdHZXRQb2ludGVlLHJhd0NvbnN0cnVjdG9yLHJhd1NoYXJlLHJhd0Rlc3RydWN0b3Ipe3RoaXMubmFtZT1uYW1lO3RoaXMucmVnaXN0ZXJlZENsYXNzPXJlZ2lzdGVyZWRDbGFzczt0aGlzLmlzUmVmZXJlbmNlPWlzUmVmZXJlbmNlO3RoaXMuaXNDb25zdD1pc0NvbnN0O3RoaXMuaXNTbWFydFBvaW50ZXI9aXNTbWFydFBvaW50ZXI7dGhpcy5wb2ludGVlVHlwZT1wb2ludGVlVHlwZTt0aGlzLnNoYXJpbmdQb2xpY3k9c2hhcmluZ1BvbGljeTt0aGlzLnJhd0dldFBvaW50ZWU9cmF3R2V0UG9pbnRlZTt0aGlzLnJhd0NvbnN0cnVjdG9yPXJhd0NvbnN0cnVjdG9yO3RoaXMucmF3U2hhcmU9cmF3U2hhcmU7dGhpcy5yYXdEZXN0cnVjdG9yPXJhd0Rlc3RydWN0b3I7aWYoIWlzU21hcnRQb2ludGVyJiZyZWdpc3RlcmVkQ2xhc3MuYmFzZUNsYXNzPT09dW5kZWZpbmVkKXtpZihpc0NvbnN0KXt0aGlzWyJ0b1dpcmVUeXBlIl09Y29uc3ROb1NtYXJ0UHRyUmF3UG9pbnRlclRvV2lyZVR5cGU7dGhpcy5kZXN0cnVjdG9yRnVuY3Rpb249bnVsbH1lbHNle3RoaXNbInRvV2lyZVR5cGUiXT1ub25Db25zdE5vU21hcnRQdHJSYXdQb2ludGVyVG9XaXJlVHlwZTt0aGlzLmRlc3RydWN0b3JGdW5jdGlvbj1udWxsfX1lbHNle3RoaXNbInRvV2lyZVR5cGUiXT1nZW5lcmljUG9pbnRlclRvV2lyZVR5cGV9fXZhciByZXBsYWNlUHVibGljU3ltYm9sPShuYW1lLHZhbHVlLG51bUFyZ3VtZW50cyk9PntpZighTW9kdWxlLmhhc093blByb3BlcnR5KG5hbWUpKXt0aHJvd0ludGVybmFsRXJyb3IoIlJlcGxhY2luZyBub25leGlzdGFudCBwdWJsaWMgc3ltYm9sIil9aWYodW5kZWZpbmVkIT09TW9kdWxlW25hbWVdLm92ZXJsb2FkVGFibGUmJnVuZGVmaW5lZCE9PW51bUFyZ3VtZW50cyl7TW9kdWxlW25hbWVdLm92ZXJsb2FkVGFibGVbbnVtQXJndW1lbnRzXT12YWx1ZX1lbHNle01vZHVsZVtuYW1lXT12YWx1ZTtNb2R1bGVbbmFtZV0uYXJnQ291bnQ9bnVtQXJndW1lbnRzfX07dmFyIGR5bkNhbGxMZWdhY3k9KHNpZyxwdHIsYXJncyk9Pnt2YXIgZj1Nb2R1bGVbImR5bkNhbGxfIitzaWddO3JldHVybiBhcmdzJiZhcmdzLmxlbmd0aD9mLmFwcGx5KG51bGwsW3B0cl0uY29uY2F0KGFyZ3MpKTpmLmNhbGwobnVsbCxwdHIpfTt2YXIgZHluQ2FsbD0oc2lnLHB0cixhcmdzKT0+e2lmKHNpZy5pbmNsdWRlcygiaiIpKXtyZXR1cm4gZHluQ2FsbExlZ2FjeShzaWcscHRyLGFyZ3MpfXZhciBydG49Z2V0V2FzbVRhYmxlRW50cnkocHRyKS5hcHBseShudWxsLGFyZ3MpO3JldHVybiBydG59O3ZhciBnZXREeW5DYWxsZXI9KHNpZyxwdHIpPT57dmFyIGFyZ0NhY2hlPVtdO3JldHVybiBmdW5jdGlvbigpe2FyZ0NhY2hlLmxlbmd0aD0wO09iamVjdC5hc3NpZ24oYXJnQ2FjaGUsYXJndW1lbnRzKTtyZXR1cm4gZHluQ2FsbChzaWcscHRyLGFyZ0NhY2hlKX19O3ZhciBlbWJpbmRfX3JlcXVpcmVGdW5jdGlvbj0oc2lnbmF0dXJlLHJhd0Z1bmN0aW9uKT0+e3NpZ25hdHVyZT1yZWFkTGF0aW4xU3RyaW5nKHNpZ25hdHVyZSk7ZnVuY3Rpb24gbWFrZUR5bkNhbGxlcigpe2lmKHNpZ25hdHVyZS5pbmNsdWRlcygiaiIpKXtyZXR1cm4gZ2V0RHluQ2FsbGVyKHNpZ25hdHVyZSxyYXdGdW5jdGlvbil9cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KHJhd0Z1bmN0aW9uKX12YXIgZnA9bWFrZUR5bkNhbGxlcigpO2lmKHR5cGVvZiBmcCE9ImZ1bmN0aW9uIil7dGhyb3dCaW5kaW5nRXJyb3IoYHVua25vd24gZnVuY3Rpb24gcG9pbnRlciB3aXRoIHNpZ25hdHVyZSAke3NpZ25hdHVyZX06ICR7cmF3RnVuY3Rpb259YCl9cmV0dXJuIGZwfTt2YXIgZXh0ZW5kRXJyb3I9KGJhc2VFcnJvclR5cGUsZXJyb3JOYW1lKT0+e3ZhciBlcnJvckNsYXNzPWNyZWF0ZU5hbWVkRnVuY3Rpb24oZXJyb3JOYW1lLGZ1bmN0aW9uKG1lc3NhZ2Upe3RoaXMubmFtZT1lcnJvck5hbWU7dGhpcy5tZXNzYWdlPW1lc3NhZ2U7dmFyIHN0YWNrPW5ldyBFcnJvcihtZXNzYWdlKS5zdGFjaztpZihzdGFjayE9PXVuZGVmaW5lZCl7dGhpcy5zdGFjaz10aGlzLnRvU3RyaW5nKCkrIlxuIitzdGFjay5yZXBsYWNlKC9eRXJyb3IoOlteXG5dKik/XG4vLCIiKX19KTtlcnJvckNsYXNzLnByb3RvdHlwZT1PYmplY3QuY3JlYXRlKGJhc2VFcnJvclR5cGUucHJvdG90eXBlKTtlcnJvckNsYXNzLnByb3RvdHlwZS5jb25zdHJ1Y3Rvcj1lcnJvckNsYXNzO2Vycm9yQ2xhc3MucHJvdG90eXBlLnRvU3RyaW5nPWZ1bmN0aW9uKCl7aWYodGhpcy5tZXNzYWdlPT09dW5kZWZpbmVkKXtyZXR1cm4gdGhpcy5uYW1lfWVsc2V7cmV0dXJuYCR7dGhpcy5uYW1lfTogJHt0aGlzLm1lc3NhZ2V9YH19O3JldHVybiBlcnJvckNsYXNzfTt2YXIgVW5ib3VuZFR5cGVFcnJvcjt2YXIgZ2V0VHlwZU5hbWU9dHlwZT0+e3ZhciBwdHI9X19fZ2V0VHlwZU5hbWUodHlwZSk7dmFyIHJ2PXJlYWRMYXRpbjFTdHJpbmcocHRyKTtfZnJlZShwdHIpO3JldHVybiBydn07dmFyIHRocm93VW5ib3VuZFR5cGVFcnJvcj0obWVzc2FnZSx0eXBlcyk9Pnt2YXIgdW5ib3VuZFR5cGVzPVtdO3ZhciBzZWVuPXt9O2Z1bmN0aW9uIHZpc2l0KHR5cGUpe2lmKHNlZW5bdHlwZV0pe3JldHVybn1pZihyZWdpc3RlcmVkVHlwZXNbdHlwZV0pe3JldHVybn1pZih0eXBlRGVwZW5kZW5jaWVzW3R5cGVdKXt0eXBlRGVwZW5kZW5jaWVzW3R5cGVdLmZvckVhY2godmlzaXQpO3JldHVybn11bmJvdW5kVHlwZXMucHVzaCh0eXBlKTtzZWVuW3R5cGVdPXRydWV9dHlwZXMuZm9yRWFjaCh2aXNpdCk7dGhyb3cgbmV3IFVuYm91bmRUeXBlRXJyb3IoYCR7bWVzc2FnZX06IGArdW5ib3VuZFR5cGVzLm1hcChnZXRUeXBlTmFtZSkuam9pbihbIiwgIl0pKX07dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX2NsYXNzPShyYXdUeXBlLHJhd1BvaW50ZXJUeXBlLHJhd0NvbnN0UG9pbnRlclR5cGUsYmFzZUNsYXNzUmF3VHlwZSxnZXRBY3R1YWxUeXBlU2lnbmF0dXJlLGdldEFjdHVhbFR5cGUsdXBjYXN0U2lnbmF0dXJlLHVwY2FzdCxkb3duY2FzdFNpZ25hdHVyZSxkb3duY2FzdCxuYW1lLGRlc3RydWN0b3JTaWduYXR1cmUscmF3RGVzdHJ1Y3Rvcik9PntuYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7Z2V0QWN0dWFsVHlwZT1lbWJpbmRfX3JlcXVpcmVGdW5jdGlvbihnZXRBY3R1YWxUeXBlU2lnbmF0dXJlLGdldEFjdHVhbFR5cGUpO2lmKHVwY2FzdCl7dXBjYXN0PWVtYmluZF9fcmVxdWlyZUZ1bmN0aW9uKHVwY2FzdFNpZ25hdHVyZSx1cGNhc3QpfWlmKGRvd25jYXN0KXtkb3duY2FzdD1lbWJpbmRfX3JlcXVpcmVGdW5jdGlvbihkb3duY2FzdFNpZ25hdHVyZSxkb3duY2FzdCl9cmF3RGVzdHJ1Y3Rvcj1lbWJpbmRfX3JlcXVpcmVGdW5jdGlvbihkZXN0cnVjdG9yU2lnbmF0dXJlLHJhd0Rlc3RydWN0b3IpO3ZhciBsZWdhbEZ1bmN0aW9uTmFtZT1tYWtlTGVnYWxGdW5jdGlvbk5hbWUobmFtZSk7ZXhwb3NlUHVibGljU3ltYm9sKGxlZ2FsRnVuY3Rpb25OYW1lLGZ1bmN0aW9uKCl7dGhyb3dVbmJvdW5kVHlwZUVycm9yKGBDYW5ub3QgY29uc3RydWN0ICR7bmFtZX0gZHVlIHRvIHVuYm91bmQgdHlwZXNgLFtiYXNlQ2xhc3NSYXdUeXBlXSl9KTt3aGVuRGVwZW5kZW50VHlwZXNBcmVSZXNvbHZlZChbcmF3VHlwZSxyYXdQb2ludGVyVHlwZSxyYXdDb25zdFBvaW50ZXJUeXBlXSxiYXNlQ2xhc3NSYXdUeXBlP1tiYXNlQ2xhc3NSYXdUeXBlXTpbXSxmdW5jdGlvbihiYXNlKXtiYXNlPWJhc2VbMF07dmFyIGJhc2VDbGFzczt2YXIgYmFzZVByb3RvdHlwZTtpZihiYXNlQ2xhc3NSYXdUeXBlKXtiYXNlQ2xhc3M9YmFzZS5yZWdpc3RlcmVkQ2xhc3M7YmFzZVByb3RvdHlwZT1iYXNlQ2xhc3MuaW5zdGFuY2VQcm90b3R5cGV9ZWxzZXtiYXNlUHJvdG90eXBlPUNsYXNzSGFuZGxlLnByb3RvdHlwZX12YXIgY29uc3RydWN0b3I9Y3JlYXRlTmFtZWRGdW5jdGlvbihuYW1lLGZ1bmN0aW9uKCl7aWYoT2JqZWN0LmdldFByb3RvdHlwZU9mKHRoaXMpIT09aW5zdGFuY2VQcm90b3R5cGUpe3Rocm93IG5ldyBCaW5kaW5nRXJyb3IoIlVzZSAnbmV3JyB0byBjb25zdHJ1Y3QgIituYW1lKX1pZih1bmRlZmluZWQ9PT1yZWdpc3RlcmVkQ2xhc3MuY29uc3RydWN0b3JfYm9keSl7dGhyb3cgbmV3IEJpbmRpbmdFcnJvcihuYW1lKyIgaGFzIG5vIGFjY2Vzc2libGUgY29uc3RydWN0b3IiKX12YXIgYm9keT1yZWdpc3RlcmVkQ2xhc3MuY29uc3RydWN0b3JfYm9keVthcmd1bWVudHMubGVuZ3RoXTtpZih1bmRlZmluZWQ9PT1ib2R5KXt0aHJvdyBuZXcgQmluZGluZ0Vycm9yKGBUcmllZCB0byBpbnZva2UgY3RvciBvZiAke25hbWV9IHdpdGggaW52YWxpZCBudW1iZXIgb2YgcGFyYW1ldGVycyAoJHthcmd1bWVudHMubGVuZ3RofSkgLSBleHBlY3RlZCAoJHtPYmplY3Qua2V5cyhyZWdpc3RlcmVkQ2xhc3MuY29uc3RydWN0b3JfYm9keSkudG9TdHJpbmcoKX0pIHBhcmFtZXRlcnMgaW5zdGVhZCFgKX1yZXR1cm4gYm9keS5hcHBseSh0aGlzLGFyZ3VtZW50cyl9KTt2YXIgaW5zdGFuY2VQcm90b3R5cGU9T2JqZWN0LmNyZWF0ZShiYXNlUHJvdG90eXBlLHtjb25zdHJ1Y3Rvcjp7dmFsdWU6Y29uc3RydWN0b3J9fSk7Y29uc3RydWN0b3IucHJvdG90eXBlPWluc3RhbmNlUHJvdG90eXBlO3ZhciByZWdpc3RlcmVkQ2xhc3M9bmV3IFJlZ2lzdGVyZWRDbGFzcyhuYW1lLGNvbnN0cnVjdG9yLGluc3RhbmNlUHJvdG90eXBlLHJhd0Rlc3RydWN0b3IsYmFzZUNsYXNzLGdldEFjdHVhbFR5cGUsdXBjYXN0LGRvd25jYXN0KTtpZihyZWdpc3RlcmVkQ2xhc3MuYmFzZUNsYXNzKXtpZihyZWdpc3RlcmVkQ2xhc3MuYmFzZUNsYXNzLl9fZGVyaXZlZENsYXNzZXM9PT11bmRlZmluZWQpe3JlZ2lzdGVyZWRDbGFzcy5iYXNlQ2xhc3MuX19kZXJpdmVkQ2xhc3Nlcz1bXX1yZWdpc3RlcmVkQ2xhc3MuYmFzZUNsYXNzLl9fZGVyaXZlZENsYXNzZXMucHVzaChyZWdpc3RlcmVkQ2xhc3MpfXZhciByZWZlcmVuY2VDb252ZXJ0ZXI9bmV3IFJlZ2lzdGVyZWRQb2ludGVyKG5hbWUscmVnaXN0ZXJlZENsYXNzLHRydWUsZmFsc2UsZmFsc2UpO3ZhciBwb2ludGVyQ29udmVydGVyPW5ldyBSZWdpc3RlcmVkUG9pbnRlcihuYW1lKyIqIixyZWdpc3RlcmVkQ2xhc3MsZmFsc2UsZmFsc2UsZmFsc2UpO3ZhciBjb25zdFBvaW50ZXJDb252ZXJ0ZXI9bmV3IFJlZ2lzdGVyZWRQb2ludGVyKG5hbWUrIiBjb25zdCoiLHJlZ2lzdGVyZWRDbGFzcyxmYWxzZSx0cnVlLGZhbHNlKTtyZWdpc3RlcmVkUG9pbnRlcnNbcmF3VHlwZV09e3BvaW50ZXJUeXBlOnBvaW50ZXJDb252ZXJ0ZXIsY29uc3RQb2ludGVyVHlwZTpjb25zdFBvaW50ZXJDb252ZXJ0ZXJ9O3JlcGxhY2VQdWJsaWNTeW1ib2wobGVnYWxGdW5jdGlvbk5hbWUsY29uc3RydWN0b3IpO3JldHVybltyZWZlcmVuY2VDb252ZXJ0ZXIscG9pbnRlckNvbnZlcnRlcixjb25zdFBvaW50ZXJDb252ZXJ0ZXJdfSl9O3ZhciBoZWFwMzJWZWN0b3JUb0FycmF5PShjb3VudCxmaXJzdEVsZW1lbnQpPT57dmFyIGFycmF5PVtdO2Zvcih2YXIgaT0wO2k8Y291bnQ7aSsrKXthcnJheS5wdXNoKEhFQVBVMzJbZmlyc3RFbGVtZW50K2kqND4+Ml0pfXJldHVybiBhcnJheX07dmFyIHJ1bkRlc3RydWN0b3JzPWRlc3RydWN0b3JzPT57d2hpbGUoZGVzdHJ1Y3RvcnMubGVuZ3RoKXt2YXIgcHRyPWRlc3RydWN0b3JzLnBvcCgpO3ZhciBkZWw9ZGVzdHJ1Y3RvcnMucG9wKCk7ZGVsKHB0cil9fTtmdW5jdGlvbiBuZXdGdW5jKGNvbnN0cnVjdG9yLGFyZ3VtZW50TGlzdCl7aWYoIShjb25zdHJ1Y3RvciBpbnN0YW5jZW9mIEZ1bmN0aW9uKSl7dGhyb3cgbmV3IFR5cGVFcnJvcihgbmV3XyBjYWxsZWQgd2l0aCBjb25zdHJ1Y3RvciB0eXBlICR7dHlwZW9mIGNvbnN0cnVjdG9yfSB3aGljaCBpcyBub3QgYSBmdW5jdGlvbmApfXZhciBkdW1teT1jcmVhdGVOYW1lZEZ1bmN0aW9uKGNvbnN0cnVjdG9yLm5hbWV8fCJ1bmtub3duRnVuY3Rpb25OYW1lIixmdW5jdGlvbigpe30pO2R1bW15LnByb3RvdHlwZT1jb25zdHJ1Y3Rvci5wcm90b3R5cGU7dmFyIG9iaj1uZXcgZHVtbXk7dmFyIHI9Y29uc3RydWN0b3IuYXBwbHkob2JqLGFyZ3VtZW50TGlzdCk7cmV0dXJuIHIgaW5zdGFuY2VvZiBPYmplY3Q/cjpvYmp9ZnVuY3Rpb24gY3JhZnRJbnZva2VyRnVuY3Rpb24oaHVtYW5OYW1lLGFyZ1R5cGVzLGNsYXNzVHlwZSxjcHBJbnZva2VyRnVuYyxjcHBUYXJnZXRGdW5jLGlzQXN5bmMpe3ZhciBhcmdDb3VudD1hcmdUeXBlcy5sZW5ndGg7aWYoYXJnQ291bnQ8Mil7dGhyb3dCaW5kaW5nRXJyb3IoImFyZ1R5cGVzIGFycmF5IHNpemUgbWlzbWF0Y2ghIE11c3QgYXQgbGVhc3QgZ2V0IHJldHVybiB2YWx1ZSBhbmQgJ3RoaXMnIHR5cGVzISIpfXZhciBpc0NsYXNzTWV0aG9kRnVuYz1hcmdUeXBlc1sxXSE9PW51bGwmJmNsYXNzVHlwZSE9PW51bGw7dmFyIG5lZWRzRGVzdHJ1Y3RvclN0YWNrPWZhbHNlO2Zvcih2YXIgaT0xO2k8YXJnVHlwZXMubGVuZ3RoOysraSl7aWYoYXJnVHlwZXNbaV0hPT1udWxsJiZhcmdUeXBlc1tpXS5kZXN0cnVjdG9yRnVuY3Rpb249PT11bmRlZmluZWQpe25lZWRzRGVzdHJ1Y3RvclN0YWNrPXRydWU7YnJlYWt9fXZhciByZXR1cm5zPWFyZ1R5cGVzWzBdLm5hbWUhPT0idm9pZCI7dmFyIGFyZ3NMaXN0PSIiO3ZhciBhcmdzTGlzdFdpcmVkPSIiO2Zvcih2YXIgaT0wO2k8YXJnQ291bnQtMjsrK2kpe2FyZ3NMaXN0Kz0oaSE9PTA/IiwgIjoiIikrImFyZyIraTthcmdzTGlzdFdpcmVkKz0oaSE9PTA/IiwgIjoiIikrImFyZyIraSsiV2lyZWQifXZhciBpbnZva2VyRm5Cb2R5PWBcbiAgICAgICAgcmV0dXJuIGZ1bmN0aW9uICgke2FyZ3NMaXN0fSkge1xuICAgICAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCAhPT0gJHthcmdDb3VudC0yfSkge1xuICAgICAgICAgIHRocm93QmluZGluZ0Vycm9yKCdmdW5jdGlvbiAke2h1bWFuTmFtZX0gY2FsbGVkIHdpdGggJyArIGFyZ3VtZW50cy5sZW5ndGggKyAnIGFyZ3VtZW50cywgZXhwZWN0ZWQgJHthcmdDb3VudC0yfScpO1xuICAgICAgICB9YDtpZihuZWVkc0Rlc3RydWN0b3JTdGFjayl7aW52b2tlckZuQm9keSs9InZhciBkZXN0cnVjdG9ycyA9IFtdO1xuIn12YXIgZHRvclN0YWNrPW5lZWRzRGVzdHJ1Y3RvclN0YWNrPyJkZXN0cnVjdG9ycyI6Im51bGwiO3ZhciBhcmdzMT1bInRocm93QmluZGluZ0Vycm9yIiwiaW52b2tlciIsImZuIiwicnVuRGVzdHJ1Y3RvcnMiLCJyZXRUeXBlIiwiY2xhc3NQYXJhbSJdO3ZhciBhcmdzMj1bdGhyb3dCaW5kaW5nRXJyb3IsY3BwSW52b2tlckZ1bmMsY3BwVGFyZ2V0RnVuYyxydW5EZXN0cnVjdG9ycyxhcmdUeXBlc1swXSxhcmdUeXBlc1sxXV07aWYoaXNDbGFzc01ldGhvZEZ1bmMpe2ludm9rZXJGbkJvZHkrPSJ2YXIgdGhpc1dpcmVkID0gY2xhc3NQYXJhbS50b1dpcmVUeXBlKCIrZHRvclN0YWNrKyIsIHRoaXMpO1xuIn1mb3IodmFyIGk9MDtpPGFyZ0NvdW50LTI7KytpKXtpbnZva2VyRm5Cb2R5Kz0idmFyIGFyZyIraSsiV2lyZWQgPSBhcmdUeXBlIitpKyIudG9XaXJlVHlwZSgiK2R0b3JTdGFjaysiLCBhcmciK2krIik7IC8vICIrYXJnVHlwZXNbaSsyXS5uYW1lKyJcbiI7YXJnczEucHVzaCgiYXJnVHlwZSIraSk7YXJnczIucHVzaChhcmdUeXBlc1tpKzJdKX1pZihpc0NsYXNzTWV0aG9kRnVuYyl7YXJnc0xpc3RXaXJlZD0idGhpc1dpcmVkIisoYXJnc0xpc3RXaXJlZC5sZW5ndGg+MD8iLCAiOiIiKSthcmdzTGlzdFdpcmVkfWludm9rZXJGbkJvZHkrPShyZXR1cm5zfHxpc0FzeW5jPyJ2YXIgcnYgPSAiOiIiKSsiaW52b2tlcihmbiIrKGFyZ3NMaXN0V2lyZWQubGVuZ3RoPjA/IiwgIjoiIikrYXJnc0xpc3RXaXJlZCsiKTtcbiI7aWYobmVlZHNEZXN0cnVjdG9yU3RhY2spe2ludm9rZXJGbkJvZHkrPSJydW5EZXN0cnVjdG9ycyhkZXN0cnVjdG9ycyk7XG4ifWVsc2V7Zm9yKHZhciBpPWlzQ2xhc3NNZXRob2RGdW5jPzE6MjtpPGFyZ1R5cGVzLmxlbmd0aDsrK2kpe3ZhciBwYXJhbU5hbWU9aT09PTE/InRoaXNXaXJlZCI6ImFyZyIrKGktMikrIldpcmVkIjtpZihhcmdUeXBlc1tpXS5kZXN0cnVjdG9yRnVuY3Rpb24hPT1udWxsKXtpbnZva2VyRm5Cb2R5Kz1wYXJhbU5hbWUrIl9kdG9yKCIrcGFyYW1OYW1lKyIpOyAvLyAiK2FyZ1R5cGVzW2ldLm5hbWUrIlxuIjthcmdzMS5wdXNoKHBhcmFtTmFtZSsiX2R0b3IiKTthcmdzMi5wdXNoKGFyZ1R5cGVzW2ldLmRlc3RydWN0b3JGdW5jdGlvbil9fX1pZihyZXR1cm5zKXtpbnZva2VyRm5Cb2R5Kz0idmFyIHJldCA9IHJldFR5cGUuZnJvbVdpcmVUeXBlKHJ2KTtcbiIrInJldHVybiByZXQ7XG4ifWVsc2V7fWludm9rZXJGbkJvZHkrPSJ9XG4iO2FyZ3MxLnB1c2goaW52b2tlckZuQm9keSk7dmFyIGludm9rZXJGbj1uZXdGdW5jKEZ1bmN0aW9uLGFyZ3MxKS5hcHBseShudWxsLGFyZ3MyKTtyZXR1cm4gY3JlYXRlTmFtZWRGdW5jdGlvbihodW1hbk5hbWUsaW52b2tlckZuKX12YXIgX19lbWJpbmRfcmVnaXN0ZXJfY2xhc3NfY29uc3RydWN0b3I9KHJhd0NsYXNzVHlwZSxhcmdDb3VudCxyYXdBcmdUeXBlc0FkZHIsaW52b2tlclNpZ25hdHVyZSxpbnZva2VyLHJhd0NvbnN0cnVjdG9yKT0+e3ZhciByYXdBcmdUeXBlcz1oZWFwMzJWZWN0b3JUb0FycmF5KGFyZ0NvdW50LHJhd0FyZ1R5cGVzQWRkcik7aW52b2tlcj1lbWJpbmRfX3JlcXVpcmVGdW5jdGlvbihpbnZva2VyU2lnbmF0dXJlLGludm9rZXIpO3doZW5EZXBlbmRlbnRUeXBlc0FyZVJlc29sdmVkKFtdLFtyYXdDbGFzc1R5cGVdLGZ1bmN0aW9uKGNsYXNzVHlwZSl7Y2xhc3NUeXBlPWNsYXNzVHlwZVswXTt2YXIgaHVtYW5OYW1lPWBjb25zdHJ1Y3RvciAke2NsYXNzVHlwZS5uYW1lfWA7aWYodW5kZWZpbmVkPT09Y2xhc3NUeXBlLnJlZ2lzdGVyZWRDbGFzcy5jb25zdHJ1Y3Rvcl9ib2R5KXtjbGFzc1R5cGUucmVnaXN0ZXJlZENsYXNzLmNvbnN0cnVjdG9yX2JvZHk9W119aWYodW5kZWZpbmVkIT09Y2xhc3NUeXBlLnJlZ2lzdGVyZWRDbGFzcy5jb25zdHJ1Y3Rvcl9ib2R5W2FyZ0NvdW50LTFdKXt0aHJvdyBuZXcgQmluZGluZ0Vycm9yKGBDYW5ub3QgcmVnaXN0ZXIgbXVsdGlwbGUgY29uc3RydWN0b3JzIHdpdGggaWRlbnRpY2FsIG51bWJlciBvZiBwYXJhbWV0ZXJzICgke2FyZ0NvdW50LTF9KSBmb3IgY2xhc3MgJyR7Y2xhc3NUeXBlLm5hbWV9JyEgT3ZlcmxvYWQgcmVzb2x1dGlvbiBpcyBjdXJyZW50bHkgb25seSBwZXJmb3JtZWQgdXNpbmcgdGhlIHBhcmFtZXRlciBjb3VudCwgbm90IGFjdHVhbCB0eXBlIGluZm8hYCl9Y2xhc3NUeXBlLnJlZ2lzdGVyZWRDbGFzcy5jb25zdHJ1Y3Rvcl9ib2R5W2FyZ0NvdW50LTFdPSgpPT57dGhyb3dVbmJvdW5kVHlwZUVycm9yKGBDYW5ub3QgY29uc3RydWN0ICR7Y2xhc3NUeXBlLm5hbWV9IGR1ZSB0byB1bmJvdW5kIHR5cGVzYCxyYXdBcmdUeXBlcyl9O3doZW5EZXBlbmRlbnRUeXBlc0FyZVJlc29sdmVkKFtdLHJhd0FyZ1R5cGVzLGFyZ1R5cGVzPT57YXJnVHlwZXMuc3BsaWNlKDEsMCxudWxsKTtjbGFzc1R5cGUucmVnaXN0ZXJlZENsYXNzLmNvbnN0cnVjdG9yX2JvZHlbYXJnQ291bnQtMV09Y3JhZnRJbnZva2VyRnVuY3Rpb24oaHVtYW5OYW1lLGFyZ1R5cGVzLG51bGwsaW52b2tlcixyYXdDb25zdHJ1Y3Rvcik7cmV0dXJuW119KTtyZXR1cm5bXX0pfTt2YXIgZ2V0RnVuY3Rpb25OYW1lPXNpZ25hdHVyZT0+e3NpZ25hdHVyZT1zaWduYXR1cmUudHJpbSgpO2NvbnN0IGFyZ3NJbmRleD1zaWduYXR1cmUuaW5kZXhPZigiKCIpO2lmKGFyZ3NJbmRleCE9PS0xKXtyZXR1cm4gc2lnbmF0dXJlLnN1YnN0cigwLGFyZ3NJbmRleCl9ZWxzZXtyZXR1cm4gc2lnbmF0dXJlfX07dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX2NsYXNzX2Z1bmN0aW9uPShyYXdDbGFzc1R5cGUsbWV0aG9kTmFtZSxhcmdDb3VudCxyYXdBcmdUeXBlc0FkZHIsaW52b2tlclNpZ25hdHVyZSxyYXdJbnZva2VyLGNvbnRleHQsaXNQdXJlVmlydHVhbCxpc0FzeW5jKT0+e3ZhciByYXdBcmdUeXBlcz1oZWFwMzJWZWN0b3JUb0FycmF5KGFyZ0NvdW50LHJhd0FyZ1R5cGVzQWRkcik7bWV0aG9kTmFtZT1yZWFkTGF0aW4xU3RyaW5nKG1ldGhvZE5hbWUpO21ldGhvZE5hbWU9Z2V0RnVuY3Rpb25OYW1lKG1ldGhvZE5hbWUpO3Jhd0ludm9rZXI9ZW1iaW5kX19yZXF1aXJlRnVuY3Rpb24oaW52b2tlclNpZ25hdHVyZSxyYXdJbnZva2VyKTt3aGVuRGVwZW5kZW50VHlwZXNBcmVSZXNvbHZlZChbXSxbcmF3Q2xhc3NUeXBlXSxmdW5jdGlvbihjbGFzc1R5cGUpe2NsYXNzVHlwZT1jbGFzc1R5cGVbMF07dmFyIGh1bWFuTmFtZT1gJHtjbGFzc1R5cGUubmFtZX0uJHttZXRob2ROYW1lfWA7aWYobWV0aG9kTmFtZS5zdGFydHNXaXRoKCJAQCIpKXttZXRob2ROYW1lPVN5bWJvbFttZXRob2ROYW1lLnN1YnN0cmluZygyKV19aWYoaXNQdXJlVmlydHVhbCl7Y2xhc3NUeXBlLnJlZ2lzdGVyZWRDbGFzcy5wdXJlVmlydHVhbEZ1bmN0aW9ucy5wdXNoKG1ldGhvZE5hbWUpfWZ1bmN0aW9uIHVuYm91bmRUeXBlc0hhbmRsZXIoKXt0aHJvd1VuYm91bmRUeXBlRXJyb3IoYENhbm5vdCBjYWxsICR7aHVtYW5OYW1lfSBkdWUgdG8gdW5ib3VuZCB0eXBlc2AscmF3QXJnVHlwZXMpfXZhciBwcm90bz1jbGFzc1R5cGUucmVnaXN0ZXJlZENsYXNzLmluc3RhbmNlUHJvdG90eXBlO3ZhciBtZXRob2Q9cHJvdG9bbWV0aG9kTmFtZV07aWYodW5kZWZpbmVkPT09bWV0aG9kfHx1bmRlZmluZWQ9PT1tZXRob2Qub3ZlcmxvYWRUYWJsZSYmbWV0aG9kLmNsYXNzTmFtZSE9PWNsYXNzVHlwZS5uYW1lJiZtZXRob2QuYXJnQ291bnQ9PT1hcmdDb3VudC0yKXt1bmJvdW5kVHlwZXNIYW5kbGVyLmFyZ0NvdW50PWFyZ0NvdW50LTI7dW5ib3VuZFR5cGVzSGFuZGxlci5jbGFzc05hbWU9Y2xhc3NUeXBlLm5hbWU7cHJvdG9bbWV0aG9kTmFtZV09dW5ib3VuZFR5cGVzSGFuZGxlcn1lbHNle2Vuc3VyZU92ZXJsb2FkVGFibGUocHJvdG8sbWV0aG9kTmFtZSxodW1hbk5hbWUpO3Byb3RvW21ldGhvZE5hbWVdLm92ZXJsb2FkVGFibGVbYXJnQ291bnQtMl09dW5ib3VuZFR5cGVzSGFuZGxlcn13aGVuRGVwZW5kZW50VHlwZXNBcmVSZXNvbHZlZChbXSxyYXdBcmdUeXBlcyxmdW5jdGlvbihhcmdUeXBlcyl7dmFyIG1lbWJlckZ1bmN0aW9uPWNyYWZ0SW52b2tlckZ1bmN0aW9uKGh1bWFuTmFtZSxhcmdUeXBlcyxjbGFzc1R5cGUscmF3SW52b2tlcixjb250ZXh0LGlzQXN5bmMpO2lmKHVuZGVmaW5lZD09PXByb3RvW21ldGhvZE5hbWVdLm92ZXJsb2FkVGFibGUpe21lbWJlckZ1bmN0aW9uLmFyZ0NvdW50PWFyZ0NvdW50LTI7cHJvdG9bbWV0aG9kTmFtZV09bWVtYmVyRnVuY3Rpb259ZWxzZXtwcm90b1ttZXRob2ROYW1lXS5vdmVybG9hZFRhYmxlW2FyZ0NvdW50LTJdPW1lbWJlckZ1bmN0aW9ufXJldHVybltdfSk7cmV0dXJuW119KX07ZnVuY3Rpb24gaGFuZGxlQWxsb2NhdG9ySW5pdCgpe09iamVjdC5hc3NpZ24oSGFuZGxlQWxsb2NhdG9yLnByb3RvdHlwZSx7Z2V0KGlkKXtyZXR1cm4gdGhpcy5hbGxvY2F0ZWRbaWRdfSxoYXMoaWQpe3JldHVybiB0aGlzLmFsbG9jYXRlZFtpZF0hPT11bmRlZmluZWR9LGFsbG9jYXRlKGhhbmRsZSl7dmFyIGlkPXRoaXMuZnJlZWxpc3QucG9wKCl8fHRoaXMuYWxsb2NhdGVkLmxlbmd0aDt0aGlzLmFsbG9jYXRlZFtpZF09aGFuZGxlO3JldHVybiBpZH0sZnJlZShpZCl7dGhpcy5hbGxvY2F0ZWRbaWRdPXVuZGVmaW5lZDt0aGlzLmZyZWVsaXN0LnB1c2goaWQpfX0pfWZ1bmN0aW9uIEhhbmRsZUFsbG9jYXRvcigpe3RoaXMuYWxsb2NhdGVkPVt1bmRlZmluZWRdO3RoaXMuZnJlZWxpc3Q9W119dmFyIGVtdmFsX2hhbmRsZXM9bmV3IEhhbmRsZUFsbG9jYXRvcjt2YXIgX19lbXZhbF9kZWNyZWY9aGFuZGxlPT57aWYoaGFuZGxlPj1lbXZhbF9oYW5kbGVzLnJlc2VydmVkJiYwPT09LS1lbXZhbF9oYW5kbGVzLmdldChoYW5kbGUpLnJlZmNvdW50KXtlbXZhbF9oYW5kbGVzLmZyZWUoaGFuZGxlKX19O3ZhciBjb3VudF9lbXZhbF9oYW5kbGVzPSgpPT57dmFyIGNvdW50PTA7Zm9yKHZhciBpPWVtdmFsX2hhbmRsZXMucmVzZXJ2ZWQ7aTxlbXZhbF9oYW5kbGVzLmFsbG9jYXRlZC5sZW5ndGg7KytpKXtpZihlbXZhbF9oYW5kbGVzLmFsbG9jYXRlZFtpXSE9PXVuZGVmaW5lZCl7Kytjb3VudH19cmV0dXJuIGNvdW50fTt2YXIgaW5pdF9lbXZhbD0oKT0+e2VtdmFsX2hhbmRsZXMuYWxsb2NhdGVkLnB1c2goe3ZhbHVlOnVuZGVmaW5lZH0se3ZhbHVlOm51bGx9LHt2YWx1ZTp0cnVlfSx7dmFsdWU6ZmFsc2V9KTtlbXZhbF9oYW5kbGVzLnJlc2VydmVkPWVtdmFsX2hhbmRsZXMuYWxsb2NhdGVkLmxlbmd0aDtNb2R1bGVbImNvdW50X2VtdmFsX2hhbmRsZXMiXT1jb3VudF9lbXZhbF9oYW5kbGVzfTt2YXIgRW12YWw9e3RvVmFsdWU6aGFuZGxlPT57aWYoIWhhbmRsZSl7dGhyb3dCaW5kaW5nRXJyb3IoIkNhbm5vdCB1c2UgZGVsZXRlZCB2YWwuIGhhbmRsZSA9ICIraGFuZGxlKX1yZXR1cm4gZW12YWxfaGFuZGxlcy5nZXQoaGFuZGxlKS52YWx1ZX0sdG9IYW5kbGU6dmFsdWU9Pntzd2l0Y2godmFsdWUpe2Nhc2UgdW5kZWZpbmVkOnJldHVybiAxO2Nhc2UgbnVsbDpyZXR1cm4gMjtjYXNlIHRydWU6cmV0dXJuIDM7Y2FzZSBmYWxzZTpyZXR1cm4gNDtkZWZhdWx0OntyZXR1cm4gZW12YWxfaGFuZGxlcy5hbGxvY2F0ZSh7cmVmY291bnQ6MSx2YWx1ZTp2YWx1ZX0pfX19fTtmdW5jdGlvbiBzaW1wbGVSZWFkVmFsdWVGcm9tUG9pbnRlcihwb2ludGVyKXtyZXR1cm4gdGhpc1siZnJvbVdpcmVUeXBlIl0oSEVBUDMyW3BvaW50ZXI+PjJdKX12YXIgX19lbWJpbmRfcmVnaXN0ZXJfZW12YWw9KHJhd1R5cGUsbmFtZSk9PntuYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7cmVnaXN0ZXJUeXBlKHJhd1R5cGUse25hbWU6bmFtZSwiZnJvbVdpcmVUeXBlIjpoYW5kbGU9Pnt2YXIgcnY9RW12YWwudG9WYWx1ZShoYW5kbGUpO19fZW12YWxfZGVjcmVmKGhhbmRsZSk7cmV0dXJuIHJ2fSwidG9XaXJlVHlwZSI6KGRlc3RydWN0b3JzLHZhbHVlKT0+RW12YWwudG9IYW5kbGUodmFsdWUpLCJhcmdQYWNrQWR2YW5jZSI6R2VuZXJpY1dpcmVUeXBlU2l6ZSwicmVhZFZhbHVlRnJvbVBvaW50ZXIiOnNpbXBsZVJlYWRWYWx1ZUZyb21Qb2ludGVyLGRlc3RydWN0b3JGdW5jdGlvbjpudWxsfSl9O3ZhciBlbWJpbmRSZXByPXY9PntpZih2PT09bnVsbCl7cmV0dXJuIm51bGwifXZhciB0PXR5cGVvZiB2O2lmKHQ9PT0ib2JqZWN0Inx8dD09PSJhcnJheSJ8fHQ9PT0iZnVuY3Rpb24iKXtyZXR1cm4gdi50b1N0cmluZygpfWVsc2V7cmV0dXJuIiIrdn19O3ZhciBmbG9hdFJlYWRWYWx1ZUZyb21Qb2ludGVyPShuYW1lLHdpZHRoKT0+e3N3aXRjaCh3aWR0aCl7Y2FzZSA0OnJldHVybiBmdW5jdGlvbihwb2ludGVyKXtyZXR1cm4gdGhpc1siZnJvbVdpcmVUeXBlIl0oSEVBUEYzMltwb2ludGVyPj4yXSl9O2Nhc2UgODpyZXR1cm4gZnVuY3Rpb24ocG9pbnRlcil7cmV0dXJuIHRoaXNbImZyb21XaXJlVHlwZSJdKEhFQVBGNjRbcG9pbnRlcj4+M10pfTtkZWZhdWx0OnRocm93IG5ldyBUeXBlRXJyb3IoYGludmFsaWQgZmxvYXQgd2lkdGggKCR7d2lkdGh9KTogJHtuYW1lfWApfX07dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX2Zsb2F0PShyYXdUeXBlLG5hbWUsc2l6ZSk9PntuYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7cmVnaXN0ZXJUeXBlKHJhd1R5cGUse25hbWU6bmFtZSwiZnJvbVdpcmVUeXBlIjp2YWx1ZT0+dmFsdWUsInRvV2lyZVR5cGUiOihkZXN0cnVjdG9ycyx2YWx1ZSk9PnZhbHVlLCJhcmdQYWNrQWR2YW5jZSI6R2VuZXJpY1dpcmVUeXBlU2l6ZSwicmVhZFZhbHVlRnJvbVBvaW50ZXIiOmZsb2F0UmVhZFZhbHVlRnJvbVBvaW50ZXIobmFtZSxzaXplKSxkZXN0cnVjdG9yRnVuY3Rpb246bnVsbH0pfTt2YXIgaW50ZWdlclJlYWRWYWx1ZUZyb21Qb2ludGVyPShuYW1lLHdpZHRoLHNpZ25lZCk9Pntzd2l0Y2god2lkdGgpe2Nhc2UgMTpyZXR1cm4gc2lnbmVkP3BvaW50ZXI9PkhFQVA4W3BvaW50ZXI+PjBdOnBvaW50ZXI9PkhFQVBVOFtwb2ludGVyPj4wXTtjYXNlIDI6cmV0dXJuIHNpZ25lZD9wb2ludGVyPT5IRUFQMTZbcG9pbnRlcj4+MV06cG9pbnRlcj0+SEVBUFUxNltwb2ludGVyPj4xXTtjYXNlIDQ6cmV0dXJuIHNpZ25lZD9wb2ludGVyPT5IRUFQMzJbcG9pbnRlcj4+Ml06cG9pbnRlcj0+SEVBUFUzMltwb2ludGVyPj4yXTtkZWZhdWx0OnRocm93IG5ldyBUeXBlRXJyb3IoYGludmFsaWQgaW50ZWdlciB3aWR0aCAoJHt3aWR0aH0pOiAke25hbWV9YCl9fTt2YXIgX19lbWJpbmRfcmVnaXN0ZXJfaW50ZWdlcj0ocHJpbWl0aXZlVHlwZSxuYW1lLHNpemUsbWluUmFuZ2UsbWF4UmFuZ2UpPT57bmFtZT1yZWFkTGF0aW4xU3RyaW5nKG5hbWUpO2lmKG1heFJhbmdlPT09LTEpe21heFJhbmdlPTQyOTQ5NjcyOTV9dmFyIGZyb21XaXJlVHlwZT12YWx1ZT0+dmFsdWU7aWYobWluUmFuZ2U9PT0wKXt2YXIgYml0c2hpZnQ9MzItOCpzaXplO2Zyb21XaXJlVHlwZT12YWx1ZT0+dmFsdWU8PGJpdHNoaWZ0Pj4+Yml0c2hpZnR9dmFyIGlzVW5zaWduZWRUeXBlPW5hbWUuaW5jbHVkZXMoInVuc2lnbmVkIik7dmFyIGNoZWNrQXNzZXJ0aW9ucz0odmFsdWUsdG9UeXBlTmFtZSk9Pnt9O3ZhciB0b1dpcmVUeXBlO2lmKGlzVW5zaWduZWRUeXBlKXt0b1dpcmVUeXBlPWZ1bmN0aW9uKGRlc3RydWN0b3JzLHZhbHVlKXtjaGVja0Fzc2VydGlvbnModmFsdWUsdGhpcy5uYW1lKTtyZXR1cm4gdmFsdWU+Pj4wfX1lbHNle3RvV2lyZVR5cGU9ZnVuY3Rpb24oZGVzdHJ1Y3RvcnMsdmFsdWUpe2NoZWNrQXNzZXJ0aW9ucyh2YWx1ZSx0aGlzLm5hbWUpO3JldHVybiB2YWx1ZX19cmVnaXN0ZXJUeXBlKHByaW1pdGl2ZVR5cGUse25hbWU6bmFtZSwiZnJvbVdpcmVUeXBlIjpmcm9tV2lyZVR5cGUsInRvV2lyZVR5cGUiOnRvV2lyZVR5cGUsImFyZ1BhY2tBZHZhbmNlIjpHZW5lcmljV2lyZVR5cGVTaXplLCJyZWFkVmFsdWVGcm9tUG9pbnRlciI6aW50ZWdlclJlYWRWYWx1ZUZyb21Qb2ludGVyKG5hbWUsc2l6ZSxtaW5SYW5nZSE9PTApLGRlc3RydWN0b3JGdW5jdGlvbjpudWxsfSl9O3ZhciBfX2VtYmluZF9yZWdpc3Rlcl9tZW1vcnlfdmlldz0ocmF3VHlwZSxkYXRhVHlwZUluZGV4LG5hbWUpPT57dmFyIHR5cGVNYXBwaW5nPVtJbnQ4QXJyYXksVWludDhBcnJheSxJbnQxNkFycmF5LFVpbnQxNkFycmF5LEludDMyQXJyYXksVWludDMyQXJyYXksRmxvYXQzMkFycmF5LEZsb2F0NjRBcnJheV07dmFyIFRBPXR5cGVNYXBwaW5nW2RhdGFUeXBlSW5kZXhdO2Z1bmN0aW9uIGRlY29kZU1lbW9yeVZpZXcoaGFuZGxlKXt2YXIgc2l6ZT1IRUFQVTMyW2hhbmRsZT4+Ml07dmFyIGRhdGE9SEVBUFUzMltoYW5kbGUrND4+Ml07cmV0dXJuIG5ldyBUQShIRUFQOC5idWZmZXIsZGF0YSxzaXplKX1uYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7cmVnaXN0ZXJUeXBlKHJhd1R5cGUse25hbWU6bmFtZSwiZnJvbVdpcmVUeXBlIjpkZWNvZGVNZW1vcnlWaWV3LCJhcmdQYWNrQWR2YW5jZSI6R2VuZXJpY1dpcmVUeXBlU2l6ZSwicmVhZFZhbHVlRnJvbVBvaW50ZXIiOmRlY29kZU1lbW9yeVZpZXd9LHtpZ25vcmVEdXBsaWNhdGVSZWdpc3RyYXRpb25zOnRydWV9KX07dmFyIF9fZW1iaW5kX3JlZ2lzdGVyX3N0ZF9zdHJpbmc9KHJhd1R5cGUsbmFtZSk9PntuYW1lPXJlYWRMYXRpbjFTdHJpbmcobmFtZSk7dmFyIHN0ZFN0cmluZ0lzVVRGOD1uYW1lPT09InN0ZDo6c3RyaW5nIjtyZWdpc3RlclR5cGUocmF3VHlwZSx7bmFtZTpuYW1lLCJmcm9tV2lyZVR5cGUiKHZhbHVlKXt2YXIgbGVuZ3RoPUhFQVBVMzJbdmFsdWU+PjJdO3ZhciBwYXlsb2FkPXZhbHVlKzQ7dmFyIHN0cjtpZihzdGRTdHJpbmdJc1VURjgpe3ZhciBkZWNvZGVTdGFydFB0cj1wYXlsb2FkO2Zvcih2YXIgaT0wO2k8PWxlbmd0aDsrK2kpe3ZhciBjdXJyZW50Qnl0ZVB0cj1wYXlsb2FkK2k7aWYoaT09bGVuZ3RofHxIRUFQVThbY3VycmVudEJ5dGVQdHJdPT0wKXt2YXIgbWF4UmVhZD1jdXJyZW50Qnl0ZVB0ci1kZWNvZGVTdGFydFB0cjt2YXIgc3RyaW5nU2VnbWVudD1VVEY4VG9TdHJpbmcoZGVjb2RlU3RhcnRQdHIsbWF4UmVhZCk7aWYoc3RyPT09dW5kZWZpbmVkKXtzdHI9c3RyaW5nU2VnbWVudH1lbHNle3N0cis9U3RyaW5nLmZyb21DaGFyQ29kZSgwKTtzdHIrPXN0cmluZ1NlZ21lbnR9ZGVjb2RlU3RhcnRQdHI9Y3VycmVudEJ5dGVQdHIrMX19fWVsc2V7dmFyIGE9bmV3IEFycmF5KGxlbmd0aCk7Zm9yKHZhciBpPTA7aTxsZW5ndGg7KytpKXthW2ldPVN0cmluZy5mcm9tQ2hhckNvZGUoSEVBUFU4W3BheWxvYWQraV0pfXN0cj1hLmpvaW4oIiIpfV9mcmVlKHZhbHVlKTtyZXR1cm4gc3RyfSwidG9XaXJlVHlwZSIoZGVzdHJ1Y3RvcnMsdmFsdWUpe2lmKHZhbHVlIGluc3RhbmNlb2YgQXJyYXlCdWZmZXIpe3ZhbHVlPW5ldyBVaW50OEFycmF5KHZhbHVlKX12YXIgbGVuZ3RoO3ZhciB2YWx1ZUlzT2ZUeXBlU3RyaW5nPXR5cGVvZiB2YWx1ZT09InN0cmluZyI7aWYoISh2YWx1ZUlzT2ZUeXBlU3RyaW5nfHx2YWx1ZSBpbnN0YW5jZW9mIFVpbnQ4QXJyYXl8fHZhbHVlIGluc3RhbmNlb2YgVWludDhDbGFtcGVkQXJyYXl8fHZhbHVlIGluc3RhbmNlb2YgSW50OEFycmF5KSl7dGhyb3dCaW5kaW5nRXJyb3IoIkNhbm5vdCBwYXNzIG5vbi1zdHJpbmcgdG8gc3RkOjpzdHJpbmciKX1pZihzdGRTdHJpbmdJc1VURjgmJnZhbHVlSXNPZlR5cGVTdHJpbmcpe2xlbmd0aD1sZW5ndGhCeXRlc1VURjgodmFsdWUpfWVsc2V7bGVuZ3RoPXZhbHVlLmxlbmd0aH12YXIgYmFzZT1fbWFsbG9jKDQrbGVuZ3RoKzEpO3ZhciBwdHI9YmFzZSs0O0hFQVBVMzJbYmFzZT4+Ml09bGVuZ3RoO2lmKHN0ZFN0cmluZ0lzVVRGOCYmdmFsdWVJc09mVHlwZVN0cmluZyl7c3RyaW5nVG9VVEY4KHZhbHVlLHB0cixsZW5ndGgrMSl9ZWxzZXtpZih2YWx1ZUlzT2ZUeXBlU3RyaW5nKXtmb3IodmFyIGk9MDtpPGxlbmd0aDsrK2kpe3ZhciBjaGFyQ29kZT12YWx1ZS5jaGFyQ29kZUF0KGkpO2lmKGNoYXJDb2RlPjI1NSl7X2ZyZWUocHRyKTt0aHJvd0JpbmRpbmdFcnJvcigiU3RyaW5nIGhhcyBVVEYtMTYgY29kZSB1bml0cyB0aGF0IGRvIG5vdCBmaXQgaW4gOCBiaXRzIil9SEVBUFU4W3B0citpXT1jaGFyQ29kZX19ZWxzZXtmb3IodmFyIGk9MDtpPGxlbmd0aDsrK2kpe0hFQVBVOFtwdHIraV09dmFsdWVbaV19fX1pZihkZXN0cnVjdG9ycyE9PW51bGwpe2Rlc3RydWN0b3JzLnB1c2goX2ZyZWUsYmFzZSl9cmV0dXJuIGJhc2V9LCJhcmdQYWNrQWR2YW5jZSI6R2VuZXJpY1dpcmVUeXBlU2l6ZSwicmVhZFZhbHVlRnJvbVBvaW50ZXIiOnJlYWRQb2ludGVyLGRlc3RydWN0b3JGdW5jdGlvbihwdHIpe19mcmVlKHB0cil9fSl9O3ZhciBVVEYxNkRlY29kZXI9dHlwZW9mIFRleHREZWNvZGVyIT0idW5kZWZpbmVkIj9uZXcgVGV4dERlY29kZXIoInV0Zi0xNmxlIik6dW5kZWZpbmVkO3ZhciBVVEYxNlRvU3RyaW5nPShwdHIsbWF4Qnl0ZXNUb1JlYWQpPT57dmFyIGVuZFB0cj1wdHI7dmFyIGlkeD1lbmRQdHI+PjE7dmFyIG1heElkeD1pZHgrbWF4Qnl0ZXNUb1JlYWQvMjt3aGlsZSghKGlkeD49bWF4SWR4KSYmSEVBUFUxNltpZHhdKSsraWR4O2VuZFB0cj1pZHg8PDE7aWYoZW5kUHRyLXB0cj4zMiYmVVRGMTZEZWNvZGVyKXJldHVybiBVVEYxNkRlY29kZXIuZGVjb2RlKEhFQVBVOC5zbGljZShwdHIsZW5kUHRyKSk7dmFyIHN0cj0iIjtmb3IodmFyIGk9MDshKGk+PW1heEJ5dGVzVG9SZWFkLzIpOysraSl7dmFyIGNvZGVVbml0PUhFQVAxNltwdHIraSoyPj4xXTtpZihjb2RlVW5pdD09MClicmVhaztzdHIrPVN0cmluZy5mcm9tQ2hhckNvZGUoY29kZVVuaXQpfXJldHVybiBzdHJ9O3ZhciBzdHJpbmdUb1VURjE2PShzdHIsb3V0UHRyLG1heEJ5dGVzVG9Xcml0ZSk9PntpZihtYXhCeXRlc1RvV3JpdGU9PT11bmRlZmluZWQpe21heEJ5dGVzVG9Xcml0ZT0yMTQ3NDgzNjQ3fWlmKG1heEJ5dGVzVG9Xcml0ZTwyKXJldHVybiAwO21heEJ5dGVzVG9Xcml0ZS09Mjt2YXIgc3RhcnRQdHI9b3V0UHRyO3ZhciBudW1DaGFyc1RvV3JpdGU9bWF4Qnl0ZXNUb1dyaXRlPHN0ci5sZW5ndGgqMj9tYXhCeXRlc1RvV3JpdGUvMjpzdHIubGVuZ3RoO2Zvcih2YXIgaT0wO2k8bnVtQ2hhcnNUb1dyaXRlOysraSl7dmFyIGNvZGVVbml0PXN0ci5jaGFyQ29kZUF0KGkpO0hFQVAxNltvdXRQdHI+PjFdPWNvZGVVbml0O291dFB0cis9Mn1IRUFQMTZbb3V0UHRyPj4xXT0wO3JldHVybiBvdXRQdHItc3RhcnRQdHJ9O3ZhciBsZW5ndGhCeXRlc1VURjE2PXN0cj0+c3RyLmxlbmd0aCoyO3ZhciBVVEYzMlRvU3RyaW5nPShwdHIsbWF4Qnl0ZXNUb1JlYWQpPT57dmFyIGk9MDt2YXIgc3RyPSIiO3doaWxlKCEoaT49bWF4Qnl0ZXNUb1JlYWQvNCkpe3ZhciB1dGYzMj1IRUFQMzJbcHRyK2kqND4+Ml07aWYodXRmMzI9PTApYnJlYWs7KytpO2lmKHV0ZjMyPj02NTUzNil7dmFyIGNoPXV0ZjMyLTY1NTM2O3N0cis9U3RyaW5nLmZyb21DaGFyQ29kZSg1NTI5NnxjaD4+MTAsNTYzMjB8Y2gmMTAyMyl9ZWxzZXtzdHIrPVN0cmluZy5mcm9tQ2hhckNvZGUodXRmMzIpfX1yZXR1cm4gc3RyfTt2YXIgc3RyaW5nVG9VVEYzMj0oc3RyLG91dFB0cixtYXhCeXRlc1RvV3JpdGUpPT57aWYobWF4Qnl0ZXNUb1dyaXRlPT09dW5kZWZpbmVkKXttYXhCeXRlc1RvV3JpdGU9MjE0NzQ4MzY0N31pZihtYXhCeXRlc1RvV3JpdGU8NClyZXR1cm4gMDt2YXIgc3RhcnRQdHI9b3V0UHRyO3ZhciBlbmRQdHI9c3RhcnRQdHIrbWF4Qnl0ZXNUb1dyaXRlLTQ7Zm9yKHZhciBpPTA7aTxzdHIubGVuZ3RoOysraSl7dmFyIGNvZGVVbml0PXN0ci5jaGFyQ29kZUF0KGkpO2lmKGNvZGVVbml0Pj01NTI5NiYmY29kZVVuaXQ8PTU3MzQzKXt2YXIgdHJhaWxTdXJyb2dhdGU9c3RyLmNoYXJDb2RlQXQoKytpKTtjb2RlVW5pdD02NTUzNisoKGNvZGVVbml0JjEwMjMpPDwxMCl8dHJhaWxTdXJyb2dhdGUmMTAyM31IRUFQMzJbb3V0UHRyPj4yXT1jb2RlVW5pdDtvdXRQdHIrPTQ7aWYob3V0UHRyKzQ+ZW5kUHRyKWJyZWFrfUhFQVAzMltvdXRQdHI+PjJdPTA7cmV0dXJuIG91dFB0ci1zdGFydFB0cn07dmFyIGxlbmd0aEJ5dGVzVVRGMzI9c3RyPT57dmFyIGxlbj0wO2Zvcih2YXIgaT0wO2k8c3RyLmxlbmd0aDsrK2kpe3ZhciBjb2RlVW5pdD1zdHIuY2hhckNvZGVBdChpKTtpZihjb2RlVW5pdD49NTUyOTYmJmNvZGVVbml0PD01NzM0MykrK2k7bGVuKz00fXJldHVybiBsZW59O3ZhciBfX2VtYmluZF9yZWdpc3Rlcl9zdGRfd3N0cmluZz0ocmF3VHlwZSxjaGFyU2l6ZSxuYW1lKT0+e25hbWU9cmVhZExhdGluMVN0cmluZyhuYW1lKTt2YXIgZGVjb2RlU3RyaW5nLGVuY29kZVN0cmluZyxnZXRIZWFwLGxlbmd0aEJ5dGVzVVRGLHNoaWZ0O2lmKGNoYXJTaXplPT09Mil7ZGVjb2RlU3RyaW5nPVVURjE2VG9TdHJpbmc7ZW5jb2RlU3RyaW5nPXN0cmluZ1RvVVRGMTY7bGVuZ3RoQnl0ZXNVVEY9bGVuZ3RoQnl0ZXNVVEYxNjtnZXRIZWFwPSgpPT5IRUFQVTE2O3NoaWZ0PTF9ZWxzZSBpZihjaGFyU2l6ZT09PTQpe2RlY29kZVN0cmluZz1VVEYzMlRvU3RyaW5nO2VuY29kZVN0cmluZz1zdHJpbmdUb1VURjMyO2xlbmd0aEJ5dGVzVVRGPWxlbmd0aEJ5dGVzVVRGMzI7Z2V0SGVhcD0oKT0+SEVBUFUzMjtzaGlmdD0yfXJlZ2lzdGVyVHlwZShyYXdUeXBlLHtuYW1lOm5hbWUsImZyb21XaXJlVHlwZSI6dmFsdWU9Pnt2YXIgbGVuZ3RoPUhFQVBVMzJbdmFsdWU+PjJdO3ZhciBIRUFQPWdldEhlYXAoKTt2YXIgc3RyO3ZhciBkZWNvZGVTdGFydFB0cj12YWx1ZSs0O2Zvcih2YXIgaT0wO2k8PWxlbmd0aDsrK2kpe3ZhciBjdXJyZW50Qnl0ZVB0cj12YWx1ZSs0K2kqY2hhclNpemU7aWYoaT09bGVuZ3RofHxIRUFQW2N1cnJlbnRCeXRlUHRyPj5zaGlmdF09PTApe3ZhciBtYXhSZWFkQnl0ZXM9Y3VycmVudEJ5dGVQdHItZGVjb2RlU3RhcnRQdHI7dmFyIHN0cmluZ1NlZ21lbnQ9ZGVjb2RlU3RyaW5nKGRlY29kZVN0YXJ0UHRyLG1heFJlYWRCeXRlcyk7aWYoc3RyPT09dW5kZWZpbmVkKXtzdHI9c3RyaW5nU2VnbWVudH1lbHNle3N0cis9U3RyaW5nLmZyb21DaGFyQ29kZSgwKTtzdHIrPXN0cmluZ1NlZ21lbnR9ZGVjb2RlU3RhcnRQdHI9Y3VycmVudEJ5dGVQdHIrY2hhclNpemV9fV9mcmVlKHZhbHVlKTtyZXR1cm4gc3RyfSwidG9XaXJlVHlwZSI6KGRlc3RydWN0b3JzLHZhbHVlKT0+e2lmKCEodHlwZW9mIHZhbHVlPT0ic3RyaW5nIikpe3Rocm93QmluZGluZ0Vycm9yKGBDYW5ub3QgcGFzcyBub24tc3RyaW5nIHRvIEMrKyBzdHJpbmcgdHlwZSAke25hbWV9YCl9dmFyIGxlbmd0aD1sZW5ndGhCeXRlc1VURih2YWx1ZSk7dmFyIHB0cj1fbWFsbG9jKDQrbGVuZ3RoK2NoYXJTaXplKTtIRUFQVTMyW3B0cj4+Ml09bGVuZ3RoPj5zaGlmdDtlbmNvZGVTdHJpbmcodmFsdWUscHRyKzQsbGVuZ3RoK2NoYXJTaXplKTtpZihkZXN0cnVjdG9ycyE9PW51bGwpe2Rlc3RydWN0b3JzLnB1c2goX2ZyZWUscHRyKX1yZXR1cm4gcHRyfSwiYXJnUGFja0FkdmFuY2UiOkdlbmVyaWNXaXJlVHlwZVNpemUsInJlYWRWYWx1ZUZyb21Qb2ludGVyIjpzaW1wbGVSZWFkVmFsdWVGcm9tUG9pbnRlcixkZXN0cnVjdG9yRnVuY3Rpb24ocHRyKXtfZnJlZShwdHIpfX0pfTt2YXIgX19lbWJpbmRfcmVnaXN0ZXJfdm9pZD0ocmF3VHlwZSxuYW1lKT0+e25hbWU9cmVhZExhdGluMVN0cmluZyhuYW1lKTtyZWdpc3RlclR5cGUocmF3VHlwZSx7aXNWb2lkOnRydWUsbmFtZTpuYW1lLCJhcmdQYWNrQWR2YW5jZSI6MCwiZnJvbVdpcmVUeXBlIjooKT0+dW5kZWZpbmVkLCJ0b1dpcmVUeXBlIjooZGVzdHJ1Y3RvcnMsbyk9PnVuZGVmaW5lZH0pfTt2YXIgbm93SXNNb25vdG9uaWM9MTt2YXIgX19lbXNjcmlwdGVuX2dldF9ub3dfaXNfbW9ub3RvbmljPSgpPT5ub3dJc01vbm90b25pYzt2YXIgbWF5YmVFeGl0PSgpPT57aWYocnVudGltZUV4aXRlZCl7cmV0dXJufWlmKCFrZWVwUnVudGltZUFsaXZlKCkpe3RyeXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKV9fZW1zY3JpcHRlbl90aHJlYWRfZXhpdChFWElUU1RBVFVTKTtlbHNlIF9leGl0KEVYSVRTVEFUVVMpfWNhdGNoKGUpe2hhbmRsZUV4Y2VwdGlvbihlKX19fTt2YXIgY2FsbFVzZXJDYWxsYmFjaz1mdW5jPT57aWYocnVudGltZUV4aXRlZHx8QUJPUlQpe3JldHVybn10cnl7ZnVuYygpO21heWJlRXhpdCgpfWNhdGNoKGUpe2hhbmRsZUV4Y2VwdGlvbihlKX19O3ZhciBfX2Vtc2NyaXB0ZW5fdGhyZWFkX21haWxib3hfYXdhaXQ9cHRocmVhZF9wdHI9PntpZih0eXBlb2YgQXRvbWljcy53YWl0QXN5bmM9PT0iZnVuY3Rpb24iKXt2YXIgd2FpdD1BdG9taWNzLndhaXRBc3luYyhIRUFQMzIscHRocmVhZF9wdHI+PjIscHRocmVhZF9wdHIpO3dhaXQudmFsdWUudGhlbihjaGVja01haWxib3gpO3ZhciB3YWl0aW5nQXN5bmM9cHRocmVhZF9wdHIrMTI4O0F0b21pY3Muc3RvcmUoSEVBUDMyLHdhaXRpbmdBc3luYz4+MiwxKX19O01vZHVsZVsiX19lbXNjcmlwdGVuX3RocmVhZF9tYWlsYm94X2F3YWl0Il09X19lbXNjcmlwdGVuX3RocmVhZF9tYWlsYm94X2F3YWl0O3ZhciBjaGVja01haWxib3g9KCk9Pnt2YXIgcHRocmVhZF9wdHI9X3B0aHJlYWRfc2VsZigpO2lmKHB0aHJlYWRfcHRyKXtfX2Vtc2NyaXB0ZW5fdGhyZWFkX21haWxib3hfYXdhaXQocHRocmVhZF9wdHIpO2NhbGxVc2VyQ2FsbGJhY2soX19lbXNjcmlwdGVuX2NoZWNrX21haWxib3gpfX07TW9kdWxlWyJjaGVja01haWxib3giXT1jaGVja01haWxib3g7dmFyIF9fZW1zY3JpcHRlbl9ub3RpZnlfbWFpbGJveF9wb3N0bWVzc2FnZT0odGFyZ2V0VGhyZWFkSWQsY3VyclRocmVhZElkLG1haW5UaHJlYWRJZCk9PntpZih0YXJnZXRUaHJlYWRJZD09Y3VyclRocmVhZElkKXtzZXRUaW1lb3V0KCgpPT5jaGVja01haWxib3goKSl9ZWxzZSBpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXtwb3N0TWVzc2FnZSh7InRhcmdldFRocmVhZCI6dGFyZ2V0VGhyZWFkSWQsImNtZCI6ImNoZWNrTWFpbGJveCJ9KX1lbHNle3ZhciB3b3JrZXI9UFRocmVhZC5wdGhyZWFkc1t0YXJnZXRUaHJlYWRJZF07aWYoIXdvcmtlcil7cmV0dXJufXdvcmtlci5wb3N0TWVzc2FnZSh7ImNtZCI6ImNoZWNrTWFpbGJveCJ9KX19O3ZhciBwcm94aWVkSlNDYWxsQXJncz1bXTt2YXIgX19lbXNjcmlwdGVuX3JlY2VpdmVfb25fbWFpbl90aHJlYWRfanM9KGluZGV4LGNhbGxpbmdUaHJlYWQsbnVtQ2FsbEFyZ3MsYXJncyk9Pntwcm94aWVkSlNDYWxsQXJncy5sZW5ndGg9bnVtQ2FsbEFyZ3M7dmFyIGI9YXJncz4+Mztmb3IodmFyIGk9MDtpPG51bUNhbGxBcmdzO2krKyl7cHJveGllZEpTQ2FsbEFyZ3NbaV09SEVBUEY2NFtiK2ldfXZhciBmdW5jPXByb3hpZWRGdW5jdGlvblRhYmxlW2luZGV4XTtQVGhyZWFkLmN1cnJlbnRQcm94aWVkT3BlcmF0aW9uQ2FsbGVyVGhyZWFkPWNhbGxpbmdUaHJlYWQ7dmFyIHJ0bj1mdW5jLmFwcGx5KG51bGwscHJveGllZEpTQ2FsbEFyZ3MpO1BUaHJlYWQuY3VycmVudFByb3hpZWRPcGVyYXRpb25DYWxsZXJUaHJlYWQ9MDtyZXR1cm4gcnRufTt2YXIgX19lbXNjcmlwdGVuX3RocmVhZF9zZXRfc3Ryb25ncmVmPXRocmVhZD0+e307dmFyIF9fZW12YWxfaW5jcmVmPWhhbmRsZT0+e2lmKGhhbmRsZT40KXtlbXZhbF9oYW5kbGVzLmdldChoYW5kbGUpLnJlZmNvdW50Kz0xfX07dmFyIHJlcXVpcmVSZWdpc3RlcmVkVHlwZT0ocmF3VHlwZSxodW1hbk5hbWUpPT57dmFyIGltcGw9cmVnaXN0ZXJlZFR5cGVzW3Jhd1R5cGVdO2lmKHVuZGVmaW5lZD09PWltcGwpe3Rocm93QmluZGluZ0Vycm9yKGh1bWFuTmFtZSsiIGhhcyB1bmtub3duIHR5cGUgIitnZXRUeXBlTmFtZShyYXdUeXBlKSl9cmV0dXJuIGltcGx9O3ZhciBfX2VtdmFsX3Rha2VfdmFsdWU9KHR5cGUsYXJnKT0+e3R5cGU9cmVxdWlyZVJlZ2lzdGVyZWRUeXBlKHR5cGUsIl9lbXZhbF90YWtlX3ZhbHVlIik7dmFyIHY9dHlwZVsicmVhZFZhbHVlRnJvbVBvaW50ZXIiXShhcmcpO3JldHVybiBFbXZhbC50b0hhbmRsZSh2KX07ZnVuY3Rpb24gX19tbWFwX2pzKGxlbixwcm90LGZsYWdzLGZkLG9mZnNldF9sb3csb2Zmc2V0X2hpZ2gsYWxsb2NhdGVkLGFkZHIpe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpcmV0dXJuIHByb3h5VG9NYWluVGhyZWFkKDE0LDEsbGVuLHByb3QsZmxhZ3MsZmQsb2Zmc2V0X2xvdyxvZmZzZXRfaGlnaCxhbGxvY2F0ZWQsYWRkcik7dmFyIG9mZnNldD1jb252ZXJ0STMyUGFpclRvSTUzQ2hlY2tlZChvZmZzZXRfbG93LG9mZnNldF9oaWdoKTt0cnl7aWYoaXNOYU4ob2Zmc2V0KSlyZXR1cm4gNjE7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO3ZhciByZXM9RlMubW1hcChzdHJlYW0sbGVuLG9mZnNldCxwcm90LGZsYWdzKTt2YXIgcHRyPXJlcy5wdHI7SEVBUDMyW2FsbG9jYXRlZD4+Ml09cmVzLmFsbG9jYXRlZDtIRUFQVTMyW2FkZHI+PjJdPXB0cjtyZXR1cm4gMH1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319ZnVuY3Rpb24gX19tdW5tYXBfanMoYWRkcixsZW4scHJvdCxmbGFncyxmZCxvZmZzZXRfbG93LG9mZnNldF9oaWdoKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCgxNSwxLGFkZHIsbGVuLHByb3QsZmxhZ3MsZmQsb2Zmc2V0X2xvdyxvZmZzZXRfaGlnaCk7dmFyIG9mZnNldD1jb252ZXJ0STMyUGFpclRvSTUzQ2hlY2tlZChvZmZzZXRfbG93LG9mZnNldF9oaWdoKTt0cnl7aWYoaXNOYU4ob2Zmc2V0KSlyZXR1cm4gNjE7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO2lmKHByb3QmMil7U1lTQ0FMTFMuZG9Nc3luYyhhZGRyLHN0cmVhbSxsZW4sZmxhZ3Msb2Zmc2V0KX1GUy5tdW5tYXAoc3RyZWFtKX1jYXRjaChlKXtpZih0eXBlb2YgRlM9PSJ1bmRlZmluZWQifHwhKGUubmFtZT09PSJFcnJub0Vycm9yIikpdGhyb3cgZTtyZXR1cm4tZS5lcnJub319dmFyIF9hYm9ydD0oKT0+e2Fib3J0KCIiKX07dmFyIHdhcm5PbmNlPXRleHQ9PntpZighd2Fybk9uY2Uuc2hvd24pd2Fybk9uY2Uuc2hvd249e307aWYoIXdhcm5PbmNlLnNob3duW3RleHRdKXt3YXJuT25jZS5zaG93blt0ZXh0XT0xO2Vycih0ZXh0KX19O3ZhciBfZW1zY3JpcHRlbl9jaGVja19ibG9ja2luZ19hbGxvd2VkPSgpPT57fTt2YXIgX2Vtc2NyaXB0ZW5fZGF0ZV9ub3c9KCk9PkRhdGUubm93KCk7dmFyIHJ1bnRpbWVLZWVwYWxpdmVQdXNoPSgpPT57cnVudGltZUtlZXBhbGl2ZUNvdW50ZXIrPTF9O3ZhciBfZW1zY3JpcHRlbl9leGl0X3dpdGhfbGl2ZV9ydW50aW1lPSgpPT57cnVudGltZUtlZXBhbGl2ZVB1c2goKTt0aHJvdyJ1bndpbmQifTt2YXIgZ2V0SGVhcE1heD0oKT0+SEVBUFU4Lmxlbmd0aDt2YXIgX2Vtc2NyaXB0ZW5fZ2V0X2hlYXBfbWF4PSgpPT5nZXRIZWFwTWF4KCk7dmFyIF9lbXNjcmlwdGVuX2dldF9ub3c7X2Vtc2NyaXB0ZW5fZ2V0X25vdz0oKT0+cGVyZm9ybWFuY2UudGltZU9yaWdpbitwZXJmb3JtYW5jZS5ub3coKTt2YXIgX2Vtc2NyaXB0ZW5fbnVtX2xvZ2ljYWxfY29yZXM9KCk9Pm5hdmlnYXRvclsiaGFyZHdhcmVDb25jdXJyZW5jeSJdO3ZhciBhYm9ydE9uQ2Fubm90R3Jvd01lbW9yeT1yZXF1ZXN0ZWRTaXplPT57YWJvcnQoIk9PTSIpfTt2YXIgX2Vtc2NyaXB0ZW5fcmVzaXplX2hlYXA9cmVxdWVzdGVkU2l6ZT0+e3ZhciBvbGRTaXplPUhFQVBVOC5sZW5ndGg7cmVxdWVzdGVkU2l6ZT4+Pj0wO2Fib3J0T25DYW5ub3RHcm93TWVtb3J5KHJlcXVlc3RlZFNpemUpfTt2YXIgRU5WPXt9O3ZhciBnZXRFeGVjdXRhYmxlTmFtZT0oKT0+dGhpc1Byb2dyYW18fCIuL3RoaXMucHJvZ3JhbSI7dmFyIGdldEVudlN0cmluZ3M9KCk9PntpZighZ2V0RW52U3RyaW5ncy5zdHJpbmdzKXt2YXIgbGFuZz0odHlwZW9mIG5hdmlnYXRvcj09Im9iamVjdCImJm5hdmlnYXRvci5sYW5ndWFnZXMmJm5hdmlnYXRvci5sYW5ndWFnZXNbMF18fCJDIikucmVwbGFjZSgiLSIsIl8iKSsiLlVURi04Ijt2YXIgZW52PXsiVVNFUiI6IndlYl91c2VyIiwiTE9HTkFNRSI6IndlYl91c2VyIiwiUEFUSCI6Ii8iLCJQV0QiOiIvIiwiSE9NRSI6Ii9ob21lL3dlYl91c2VyIiwiTEFORyI6bGFuZywiXyI6Z2V0RXhlY3V0YWJsZU5hbWUoKX07Zm9yKHZhciB4IGluIEVOVil7aWYoRU5WW3hdPT09dW5kZWZpbmVkKWRlbGV0ZSBlbnZbeF07ZWxzZSBlbnZbeF09RU5WW3hdfXZhciBzdHJpbmdzPVtdO2Zvcih2YXIgeCBpbiBlbnYpe3N0cmluZ3MucHVzaChgJHt4fT0ke2Vudlt4XX1gKX1nZXRFbnZTdHJpbmdzLnN0cmluZ3M9c3RyaW5nc31yZXR1cm4gZ2V0RW52U3RyaW5ncy5zdHJpbmdzfTt2YXIgc3RyaW5nVG9Bc2NpaT0oc3RyLGJ1ZmZlcik9Pntmb3IodmFyIGk9MDtpPHN0ci5sZW5ndGg7KytpKXtIRUFQOFtidWZmZXIrKz4+MF09c3RyLmNoYXJDb2RlQXQoaSl9SEVBUDhbYnVmZmVyPj4wXT0wfTt2YXIgX2Vudmlyb25fZ2V0PWZ1bmN0aW9uKF9fZW52aXJvbixlbnZpcm9uX2J1Zil7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRClyZXR1cm4gcHJveHlUb01haW5UaHJlYWQoMTYsMSxfX2Vudmlyb24sZW52aXJvbl9idWYpO3ZhciBidWZTaXplPTA7Z2V0RW52U3RyaW5ncygpLmZvckVhY2goKHN0cmluZyxpKT0+e3ZhciBwdHI9ZW52aXJvbl9idWYrYnVmU2l6ZTtIRUFQVTMyW19fZW52aXJvbitpKjQ+PjJdPXB0cjtzdHJpbmdUb0FzY2lpKHN0cmluZyxwdHIpO2J1ZlNpemUrPXN0cmluZy5sZW5ndGgrMX0pO3JldHVybiAwfTt2YXIgX2Vudmlyb25fc2l6ZXNfZ2V0PWZ1bmN0aW9uKHBlbnZpcm9uX2NvdW50LHBlbnZpcm9uX2J1Zl9zaXplKXtpZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXJldHVybiBwcm94eVRvTWFpblRocmVhZCgxNywxLHBlbnZpcm9uX2NvdW50LHBlbnZpcm9uX2J1Zl9zaXplKTt2YXIgc3RyaW5ncz1nZXRFbnZTdHJpbmdzKCk7SEVBUFUzMltwZW52aXJvbl9jb3VudD4+Ml09c3RyaW5ncy5sZW5ndGg7dmFyIGJ1ZlNpemU9MDtzdHJpbmdzLmZvckVhY2goc3RyaW5nPT5idWZTaXplKz1zdHJpbmcubGVuZ3RoKzEpO0hFQVBVMzJbcGVudmlyb25fYnVmX3NpemU+PjJdPWJ1ZlNpemU7cmV0dXJuIDB9O2Z1bmN0aW9uIF9mZF9jbG9zZShmZCl7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRClyZXR1cm4gcHJveHlUb01haW5UaHJlYWQoMTgsMSxmZCk7dHJ5e3ZhciBzdHJlYW09U1lTQ0FMTFMuZ2V0U3RyZWFtRnJvbUZEKGZkKTtGUy5jbG9zZShzdHJlYW0pO3JldHVybiAwfWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybiBlLmVycm5vfX12YXIgZG9SZWFkdj0oc3RyZWFtLGlvdixpb3ZjbnQsb2Zmc2V0KT0+e3ZhciByZXQ9MDtmb3IodmFyIGk9MDtpPGlvdmNudDtpKyspe3ZhciBwdHI9SEVBUFUzMltpb3Y+PjJdO3ZhciBsZW49SEVBUFUzMltpb3YrND4+Ml07aW92Kz04O3ZhciBjdXJyPUZTLnJlYWQoc3RyZWFtLEhFQVA4LHB0cixsZW4sb2Zmc2V0KTtpZihjdXJyPDApcmV0dXJuLTE7cmV0Kz1jdXJyO2lmKGN1cnI8bGVuKWJyZWFrO2lmKHR5cGVvZiBvZmZzZXQhPT0idW5kZWZpbmVkIil7b2Zmc2V0Kz1jdXJyfX1yZXR1cm4gcmV0fTtmdW5jdGlvbiBfZmRfcmVhZChmZCxpb3YsaW92Y250LHBudW0pe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpcmV0dXJuIHByb3h5VG9NYWluVGhyZWFkKDE5LDEsZmQsaW92LGlvdmNudCxwbnVtKTt0cnl7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO3ZhciBudW09ZG9SZWFkdihzdHJlYW0saW92LGlvdmNudCk7SEVBUFUzMltwbnVtPj4yXT1udW07cmV0dXJuIDB9Y2F0Y2goZSl7aWYodHlwZW9mIEZTPT0idW5kZWZpbmVkInx8IShlLm5hbWU9PT0iRXJybm9FcnJvciIpKXRocm93IGU7cmV0dXJuIGUuZXJybm99fWZ1bmN0aW9uIF9mZF9zZWVrKGZkLG9mZnNldF9sb3csb2Zmc2V0X2hpZ2gsd2hlbmNlLG5ld09mZnNldCl7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRClyZXR1cm4gcHJveHlUb01haW5UaHJlYWQoMjAsMSxmZCxvZmZzZXRfbG93LG9mZnNldF9oaWdoLHdoZW5jZSxuZXdPZmZzZXQpO3ZhciBvZmZzZXQ9Y29udmVydEkzMlBhaXJUb0k1M0NoZWNrZWQob2Zmc2V0X2xvdyxvZmZzZXRfaGlnaCk7dHJ5e2lmKGlzTmFOKG9mZnNldCkpcmV0dXJuIDYxO3ZhciBzdHJlYW09U1lTQ0FMTFMuZ2V0U3RyZWFtRnJvbUZEKGZkKTtGUy5sbHNlZWsoc3RyZWFtLG9mZnNldCx3aGVuY2UpO3RlbXBJNjQ9W3N0cmVhbS5wb3NpdGlvbj4+PjAsKHRlbXBEb3VibGU9c3RyZWFtLnBvc2l0aW9uLCtNYXRoLmFicyh0ZW1wRG91YmxlKT49MT90ZW1wRG91YmxlPjA/K01hdGguZmxvb3IodGVtcERvdWJsZS80Mjk0OTY3Mjk2KT4+PjA6fn4rTWF0aC5jZWlsKCh0ZW1wRG91YmxlLSsofn50ZW1wRG91YmxlPj4+MCkpLzQyOTQ5NjcyOTYpPj4+MDowKV0sSEVBUDMyW25ld09mZnNldD4+Ml09dGVtcEk2NFswXSxIRUFQMzJbbmV3T2Zmc2V0KzQ+PjJdPXRlbXBJNjRbMV07aWYoc3RyZWFtLmdldGRlbnRzJiZvZmZzZXQ9PT0wJiZ3aGVuY2U9PT0wKXN0cmVhbS5nZXRkZW50cz1udWxsO3JldHVybiAwfWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybiBlLmVycm5vfX1mdW5jdGlvbiBfZmRfc3luYyhmZCl7aWYoRU5WSVJPTk1FTlRfSVNfUFRIUkVBRClyZXR1cm4gcHJveHlUb01haW5UaHJlYWQoMjEsMSxmZCk7dHJ5e3ZhciBzdHJlYW09U1lTQ0FMTFMuZ2V0U3RyZWFtRnJvbUZEKGZkKTtpZihzdHJlYW0uc3RyZWFtX29wcyYmc3RyZWFtLnN0cmVhbV9vcHMuZnN5bmMpe3JldHVybiBzdHJlYW0uc3RyZWFtX29wcy5mc3luYyhzdHJlYW0pfXJldHVybiAwfWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybiBlLmVycm5vfX12YXIgZG9Xcml0ZXY9KHN0cmVhbSxpb3YsaW92Y250LG9mZnNldCk9Pnt2YXIgcmV0PTA7Zm9yKHZhciBpPTA7aTxpb3ZjbnQ7aSsrKXt2YXIgcHRyPUhFQVBVMzJbaW92Pj4yXTt2YXIgbGVuPUhFQVBVMzJbaW92KzQ+PjJdO2lvdis9ODt2YXIgY3Vycj1GUy53cml0ZShzdHJlYW0sSEVBUDgscHRyLGxlbixvZmZzZXQpO2lmKGN1cnI8MClyZXR1cm4tMTtyZXQrPWN1cnI7aWYodHlwZW9mIG9mZnNldCE9PSJ1bmRlZmluZWQiKXtvZmZzZXQrPWN1cnJ9fXJldHVybiByZXR9O2Z1bmN0aW9uIF9mZF93cml0ZShmZCxpb3YsaW92Y250LHBudW0pe2lmKEVOVklST05NRU5UX0lTX1BUSFJFQUQpcmV0dXJuIHByb3h5VG9NYWluVGhyZWFkKDIyLDEsZmQsaW92LGlvdmNudCxwbnVtKTt0cnl7dmFyIHN0cmVhbT1TWVNDQUxMUy5nZXRTdHJlYW1Gcm9tRkQoZmQpO3ZhciBudW09ZG9Xcml0ZXYoc3RyZWFtLGlvdixpb3ZjbnQpO0hFQVBVMzJbcG51bT4+Ml09bnVtO3JldHVybiAwfWNhdGNoKGUpe2lmKHR5cGVvZiBGUz09InVuZGVmaW5lZCJ8fCEoZS5uYW1lPT09IkVycm5vRXJyb3IiKSl0aHJvdyBlO3JldHVybiBlLmVycm5vfX12YXIgX2dldGVudHJvcHk9KGJ1ZmZlcixzaXplKT0+e3JhbmRvbUZpbGwoSEVBUFU4LnN1YmFycmF5KGJ1ZmZlcixidWZmZXIrc2l6ZSkpO3JldHVybiAwfTt2YXIgaXNMZWFwWWVhcj15ZWFyPT55ZWFyJTQ9PT0wJiYoeWVhciUxMDAhPT0wfHx5ZWFyJTQwMD09PTApO3ZhciBhcnJheVN1bT0oYXJyYXksaW5kZXgpPT57dmFyIHN1bT0wO2Zvcih2YXIgaT0wO2k8PWluZGV4O3N1bSs9YXJyYXlbaSsrXSl7fXJldHVybiBzdW19O3ZhciBNT05USF9EQVlTX0xFQVA9WzMxLDI5LDMxLDMwLDMxLDMwLDMxLDMxLDMwLDMxLDMwLDMxXTt2YXIgTU9OVEhfREFZU19SRUdVTEFSPVszMSwyOCwzMSwzMCwzMSwzMCwzMSwzMSwzMCwzMSwzMCwzMV07dmFyIGFkZERheXM9KGRhdGUsZGF5cyk9Pnt2YXIgbmV3RGF0ZT1uZXcgRGF0ZShkYXRlLmdldFRpbWUoKSk7d2hpbGUoZGF5cz4wKXt2YXIgbGVhcD1pc0xlYXBZZWFyKG5ld0RhdGUuZ2V0RnVsbFllYXIoKSk7dmFyIGN1cnJlbnRNb250aD1uZXdEYXRlLmdldE1vbnRoKCk7dmFyIGRheXNJbkN1cnJlbnRNb250aD0obGVhcD9NT05USF9EQVlTX0xFQVA6TU9OVEhfREFZU19SRUdVTEFSKVtjdXJyZW50TW9udGhdO2lmKGRheXM+ZGF5c0luQ3VycmVudE1vbnRoLW5ld0RhdGUuZ2V0RGF0ZSgpKXtkYXlzLT1kYXlzSW5DdXJyZW50TW9udGgtbmV3RGF0ZS5nZXREYXRlKCkrMTtuZXdEYXRlLnNldERhdGUoMSk7aWYoY3VycmVudE1vbnRoPDExKXtuZXdEYXRlLnNldE1vbnRoKGN1cnJlbnRNb250aCsxKX1lbHNle25ld0RhdGUuc2V0TW9udGgoMCk7bmV3RGF0ZS5zZXRGdWxsWWVhcihuZXdEYXRlLmdldEZ1bGxZZWFyKCkrMSl9fWVsc2V7bmV3RGF0ZS5zZXREYXRlKG5ld0RhdGUuZ2V0RGF0ZSgpK2RheXMpO3JldHVybiBuZXdEYXRlfX1yZXR1cm4gbmV3RGF0ZX07dmFyIHdyaXRlQXJyYXlUb01lbW9yeT0oYXJyYXksYnVmZmVyKT0+e0hFQVA4LnNldChhcnJheSxidWZmZXIpfTt2YXIgX3N0cmZ0aW1lPShzLG1heHNpemUsZm9ybWF0LHRtKT0+e3ZhciB0bV96b25lPUhFQVBVMzJbdG0rNDA+PjJdO3ZhciBkYXRlPXt0bV9zZWM6SEVBUDMyW3RtPj4yXSx0bV9taW46SEVBUDMyW3RtKzQ+PjJdLHRtX2hvdXI6SEVBUDMyW3RtKzg+PjJdLHRtX21kYXk6SEVBUDMyW3RtKzEyPj4yXSx0bV9tb246SEVBUDMyW3RtKzE2Pj4yXSx0bV95ZWFyOkhFQVAzMlt0bSsyMD4+Ml0sdG1fd2RheTpIRUFQMzJbdG0rMjQ+PjJdLHRtX3lkYXk6SEVBUDMyW3RtKzI4Pj4yXSx0bV9pc2RzdDpIRUFQMzJbdG0rMzI+PjJdLHRtX2dtdG9mZjpIRUFQMzJbdG0rMzY+PjJdLHRtX3pvbmU6dG1fem9uZT9VVEY4VG9TdHJpbmcodG1fem9uZSk6IiJ9O3ZhciBwYXR0ZXJuPVVURjhUb1N0cmluZyhmb3JtYXQpO3ZhciBFWFBBTlNJT05fUlVMRVNfMT17IiVjIjoiJWEgJWIgJWQgJUg6JU06JVMgJVkiLCIlRCI6IiVtLyVkLyV5IiwiJUYiOiIlWS0lbS0lZCIsIiVoIjoiJWIiLCIlciI6IiVJOiVNOiVTICVwIiwiJVIiOiIlSDolTSIsIiVUIjoiJUg6JU06JVMiLCIleCI6IiVtLyVkLyV5IiwiJVgiOiIlSDolTTolUyIsIiVFYyI6IiVjIiwiJUVDIjoiJUMiLCIlRXgiOiIlbS8lZC8leSIsIiVFWCI6IiVIOiVNOiVTIiwiJUV5IjoiJXkiLCIlRVkiOiIlWSIsIiVPZCI6IiVkIiwiJU9lIjoiJWUiLCIlT0giOiIlSCIsIiVPSSI6IiVJIiwiJU9tIjoiJW0iLCIlT00iOiIlTSIsIiVPUyI6IiVTIiwiJU91IjoiJXUiLCIlT1UiOiIlVSIsIiVPViI6IiVWIiwiJU93IjoiJXciLCIlT1ciOiIlVyIsIiVPeSI6IiV5In07Zm9yKHZhciBydWxlIGluIEVYUEFOU0lPTl9SVUxFU18xKXtwYXR0ZXJuPXBhdHRlcm4ucmVwbGFjZShuZXcgUmVnRXhwKHJ1bGUsImciKSxFWFBBTlNJT05fUlVMRVNfMVtydWxlXSl9dmFyIFdFRUtEQVlTPVsiU3VuZGF5IiwiTW9uZGF5IiwiVHVlc2RheSIsIldlZG5lc2RheSIsIlRodXJzZGF5IiwiRnJpZGF5IiwiU2F0dXJkYXkiXTt2YXIgTU9OVEhTPVsiSmFudWFyeSIsIkZlYnJ1YXJ5IiwiTWFyY2giLCJBcHJpbCIsIk1heSIsIkp1bmUiLCJKdWx5IiwiQXVndXN0IiwiU2VwdGVtYmVyIiwiT2N0b2JlciIsIk5vdmVtYmVyIiwiRGVjZW1iZXIiXTtmdW5jdGlvbiBsZWFkaW5nU29tZXRoaW5nKHZhbHVlLGRpZ2l0cyxjaGFyYWN0ZXIpe3ZhciBzdHI9dHlwZW9mIHZhbHVlPT0ibnVtYmVyIj92YWx1ZS50b1N0cmluZygpOnZhbHVlfHwiIjt3aGlsZShzdHIubGVuZ3RoPGRpZ2l0cyl7c3RyPWNoYXJhY3RlclswXStzdHJ9cmV0dXJuIHN0cn1mdW5jdGlvbiBsZWFkaW5nTnVsbHModmFsdWUsZGlnaXRzKXtyZXR1cm4gbGVhZGluZ1NvbWV0aGluZyh2YWx1ZSxkaWdpdHMsIjAiKX1mdW5jdGlvbiBjb21wYXJlQnlEYXkoZGF0ZTEsZGF0ZTIpe2Z1bmN0aW9uIHNnbih2YWx1ZSl7cmV0dXJuIHZhbHVlPDA/LTE6dmFsdWU+MD8xOjB9dmFyIGNvbXBhcmU7aWYoKGNvbXBhcmU9c2duKGRhdGUxLmdldEZ1bGxZZWFyKCktZGF0ZTIuZ2V0RnVsbFllYXIoKSkpPT09MCl7aWYoKGNvbXBhcmU9c2duKGRhdGUxLmdldE1vbnRoKCktZGF0ZTIuZ2V0TW9udGgoKSkpPT09MCl7Y29tcGFyZT1zZ24oZGF0ZTEuZ2V0RGF0ZSgpLWRhdGUyLmdldERhdGUoKSl9fXJldHVybiBjb21wYXJlfWZ1bmN0aW9uIGdldEZpcnN0V2Vla1N0YXJ0RGF0ZShqYW5Gb3VydGgpe3N3aXRjaChqYW5Gb3VydGguZ2V0RGF5KCkpe2Nhc2UgMDpyZXR1cm4gbmV3IERhdGUoamFuRm91cnRoLmdldEZ1bGxZZWFyKCktMSwxMSwyOSk7Y2FzZSAxOnJldHVybiBqYW5Gb3VydGg7Y2FzZSAyOnJldHVybiBuZXcgRGF0ZShqYW5Gb3VydGguZ2V0RnVsbFllYXIoKSwwLDMpO2Nhc2UgMzpyZXR1cm4gbmV3IERhdGUoamFuRm91cnRoLmdldEZ1bGxZZWFyKCksMCwyKTtjYXNlIDQ6cmV0dXJuIG5ldyBEYXRlKGphbkZvdXJ0aC5nZXRGdWxsWWVhcigpLDAsMSk7Y2FzZSA1OnJldHVybiBuZXcgRGF0ZShqYW5Gb3VydGguZ2V0RnVsbFllYXIoKS0xLDExLDMxKTtjYXNlIDY6cmV0dXJuIG5ldyBEYXRlKGphbkZvdXJ0aC5nZXRGdWxsWWVhcigpLTEsMTEsMzApfX1mdW5jdGlvbiBnZXRXZWVrQmFzZWRZZWFyKGRhdGUpe3ZhciB0aGlzRGF0ZT1hZGREYXlzKG5ldyBEYXRlKGRhdGUudG1feWVhcisxOTAwLDAsMSksZGF0ZS50bV95ZGF5KTt2YXIgamFuRm91cnRoVGhpc1llYXI9bmV3IERhdGUodGhpc0RhdGUuZ2V0RnVsbFllYXIoKSwwLDQpO3ZhciBqYW5Gb3VydGhOZXh0WWVhcj1uZXcgRGF0ZSh0aGlzRGF0ZS5nZXRGdWxsWWVhcigpKzEsMCw0KTt2YXIgZmlyc3RXZWVrU3RhcnRUaGlzWWVhcj1nZXRGaXJzdFdlZWtTdGFydERhdGUoamFuRm91cnRoVGhpc1llYXIpO3ZhciBmaXJzdFdlZWtTdGFydE5leHRZZWFyPWdldEZpcnN0V2Vla1N0YXJ0RGF0ZShqYW5Gb3VydGhOZXh0WWVhcik7aWYoY29tcGFyZUJ5RGF5KGZpcnN0V2Vla1N0YXJ0VGhpc1llYXIsdGhpc0RhdGUpPD0wKXtpZihjb21wYXJlQnlEYXkoZmlyc3RXZWVrU3RhcnROZXh0WWVhcix0aGlzRGF0ZSk8PTApe3JldHVybiB0aGlzRGF0ZS5nZXRGdWxsWWVhcigpKzF9cmV0dXJuIHRoaXNEYXRlLmdldEZ1bGxZZWFyKCl9cmV0dXJuIHRoaXNEYXRlLmdldEZ1bGxZZWFyKCktMX12YXIgRVhQQU5TSU9OX1JVTEVTXzI9eyIlYSI6ZGF0ZT0+V0VFS0RBWVNbZGF0ZS50bV93ZGF5XS5zdWJzdHJpbmcoMCwzKSwiJUEiOmRhdGU9PldFRUtEQVlTW2RhdGUudG1fd2RheV0sIiViIjpkYXRlPT5NT05USFNbZGF0ZS50bV9tb25dLnN1YnN0cmluZygwLDMpLCIlQiI6ZGF0ZT0+TU9OVEhTW2RhdGUudG1fbW9uXSwiJUMiOmRhdGU9Pnt2YXIgeWVhcj1kYXRlLnRtX3llYXIrMTkwMDtyZXR1cm4gbGVhZGluZ051bGxzKHllYXIvMTAwfDAsMil9LCIlZCI6ZGF0ZT0+bGVhZGluZ051bGxzKGRhdGUudG1fbWRheSwyKSwiJWUiOmRhdGU9PmxlYWRpbmdTb21ldGhpbmcoZGF0ZS50bV9tZGF5LDIsIiAiKSwiJWciOmRhdGU9PmdldFdlZWtCYXNlZFllYXIoZGF0ZSkudG9TdHJpbmcoKS5zdWJzdHJpbmcoMiksIiVHIjpkYXRlPT5nZXRXZWVrQmFzZWRZZWFyKGRhdGUpLCIlSCI6ZGF0ZT0+bGVhZGluZ051bGxzKGRhdGUudG1faG91ciwyKSwiJUkiOmRhdGU9Pnt2YXIgdHdlbHZlSG91cj1kYXRlLnRtX2hvdXI7aWYodHdlbHZlSG91cj09MCl0d2VsdmVIb3VyPTEyO2Vsc2UgaWYodHdlbHZlSG91cj4xMil0d2VsdmVIb3VyLT0xMjtyZXR1cm4gbGVhZGluZ051bGxzKHR3ZWx2ZUhvdXIsMil9LCIlaiI6ZGF0ZT0+bGVhZGluZ051bGxzKGRhdGUudG1fbWRheSthcnJheVN1bShpc0xlYXBZZWFyKGRhdGUudG1feWVhcisxOTAwKT9NT05USF9EQVlTX0xFQVA6TU9OVEhfREFZU19SRUdVTEFSLGRhdGUudG1fbW9uLTEpLDMpLCIlbSI6ZGF0ZT0+bGVhZGluZ051bGxzKGRhdGUudG1fbW9uKzEsMiksIiVNIjpkYXRlPT5sZWFkaW5nTnVsbHMoZGF0ZS50bV9taW4sMiksIiVuIjooKT0+IlxuIiwiJXAiOmRhdGU9PntpZihkYXRlLnRtX2hvdXI+PTAmJmRhdGUudG1faG91cjwxMil7cmV0dXJuIkFNIn1yZXR1cm4iUE0ifSwiJVMiOmRhdGU9PmxlYWRpbmdOdWxscyhkYXRlLnRtX3NlYywyKSwiJXQiOigpPT4iXHQiLCIldSI6ZGF0ZT0+ZGF0ZS50bV93ZGF5fHw3LCIlVSI6ZGF0ZT0+e3ZhciBkYXlzPWRhdGUudG1feWRheSs3LWRhdGUudG1fd2RheTtyZXR1cm4gbGVhZGluZ051bGxzKE1hdGguZmxvb3IoZGF5cy83KSwyKX0sIiVWIjpkYXRlPT57dmFyIHZhbD1NYXRoLmZsb29yKChkYXRlLnRtX3lkYXkrNy0oZGF0ZS50bV93ZGF5KzYpJTcpLzcpO2lmKChkYXRlLnRtX3dkYXkrMzcxLWRhdGUudG1feWRheS0yKSU3PD0yKXt2YWwrK31pZighdmFsKXt2YWw9NTI7dmFyIGRlYzMxPShkYXRlLnRtX3dkYXkrNy1kYXRlLnRtX3lkYXktMSklNztpZihkZWMzMT09NHx8ZGVjMzE9PTUmJmlzTGVhcFllYXIoZGF0ZS50bV95ZWFyJTQwMC0xKSl7dmFsKyt9fWVsc2UgaWYodmFsPT01Myl7dmFyIGphbjE9KGRhdGUudG1fd2RheSszNzEtZGF0ZS50bV95ZGF5KSU3O2lmKGphbjEhPTQmJihqYW4xIT0zfHwhaXNMZWFwWWVhcihkYXRlLnRtX3llYXIpKSl2YWw9MX1yZXR1cm4gbGVhZGluZ051bGxzKHZhbCwyKX0sIiV3IjpkYXRlPT5kYXRlLnRtX3dkYXksIiVXIjpkYXRlPT57dmFyIGRheXM9ZGF0ZS50bV95ZGF5KzctKGRhdGUudG1fd2RheSs2KSU3O3JldHVybiBsZWFkaW5nTnVsbHMoTWF0aC5mbG9vcihkYXlzLzcpLDIpfSwiJXkiOmRhdGU9PihkYXRlLnRtX3llYXIrMTkwMCkudG9TdHJpbmcoKS5zdWJzdHJpbmcoMiksIiVZIjpkYXRlPT5kYXRlLnRtX3llYXIrMTkwMCwiJXoiOmRhdGU9Pnt2YXIgb2ZmPWRhdGUudG1fZ210b2ZmO3ZhciBhaGVhZD1vZmY+PTA7b2ZmPU1hdGguYWJzKG9mZikvNjA7b2ZmPW9mZi82MCoxMDArb2ZmJTYwO3JldHVybihhaGVhZD8iKyI6Ii0iKStTdHJpbmcoIjAwMDAiK29mZikuc2xpY2UoLTQpfSwiJVoiOmRhdGU9PmRhdGUudG1fem9uZSwiJSUiOigpPT4iJSJ9O3BhdHRlcm49cGF0dGVybi5yZXBsYWNlKC8lJS9nLCJcMFwwIik7Zm9yKHZhciBydWxlIGluIEVYUEFOU0lPTl9SVUxFU18yKXtpZihwYXR0ZXJuLmluY2x1ZGVzKHJ1bGUpKXtwYXR0ZXJuPXBhdHRlcm4ucmVwbGFjZShuZXcgUmVnRXhwKHJ1bGUsImciKSxFWFBBTlNJT05fUlVMRVNfMltydWxlXShkYXRlKSl9fXBhdHRlcm49cGF0dGVybi5yZXBsYWNlKC9cMFwwL2csIiUiKTt2YXIgYnl0ZXM9aW50QXJyYXlGcm9tU3RyaW5nKHBhdHRlcm4sZmFsc2UpO2lmKGJ5dGVzLmxlbmd0aD5tYXhzaXplKXtyZXR1cm4gMH13cml0ZUFycmF5VG9NZW1vcnkoYnl0ZXMscyk7cmV0dXJuIGJ5dGVzLmxlbmd0aC0xfTt2YXIgX3N0cmZ0aW1lX2w9KHMsbWF4c2l6ZSxmb3JtYXQsdG0sbG9jKT0+X3N0cmZ0aW1lKHMsbWF4c2l6ZSxmb3JtYXQsdG0pO1BUaHJlYWQuaW5pdCgpO3ZhciBGU05vZGU9ZnVuY3Rpb24ocGFyZW50LG5hbWUsbW9kZSxyZGV2KXtpZighcGFyZW50KXtwYXJlbnQ9dGhpc310aGlzLnBhcmVudD1wYXJlbnQ7dGhpcy5tb3VudD1wYXJlbnQubW91bnQ7dGhpcy5tb3VudGVkPW51bGw7dGhpcy5pZD1GUy5uZXh0SW5vZGUrKzt0aGlzLm5hbWU9bmFtZTt0aGlzLm1vZGU9bW9kZTt0aGlzLm5vZGVfb3BzPXt9O3RoaXMuc3RyZWFtX29wcz17fTt0aGlzLnJkZXY9cmRldn07dmFyIHJlYWRNb2RlPTI5Mnw3Mzt2YXIgd3JpdGVNb2RlPTE0NjtPYmplY3QuZGVmaW5lUHJvcGVydGllcyhGU05vZGUucHJvdG90eXBlLHtyZWFkOntnZXQ6ZnVuY3Rpb24oKXtyZXR1cm4odGhpcy5tb2RlJnJlYWRNb2RlKT09PXJlYWRNb2RlfSxzZXQ6ZnVuY3Rpb24odmFsKXt2YWw/dGhpcy5tb2RlfD1yZWFkTW9kZTp0aGlzLm1vZGUmPX5yZWFkTW9kZX19LHdyaXRlOntnZXQ6ZnVuY3Rpb24oKXtyZXR1cm4odGhpcy5tb2RlJndyaXRlTW9kZSk9PT13cml0ZU1vZGV9LHNldDpmdW5jdGlvbih2YWwpe3ZhbD90aGlzLm1vZGV8PXdyaXRlTW9kZTp0aGlzLm1vZGUmPX53cml0ZU1vZGV9fSxpc0ZvbGRlcjp7Z2V0OmZ1bmN0aW9uKCl7cmV0dXJuIEZTLmlzRGlyKHRoaXMubW9kZSl9fSxpc0RldmljZTp7Z2V0OmZ1bmN0aW9uKCl7cmV0dXJuIEZTLmlzQ2hyZGV2KHRoaXMubW9kZSl9fX0pO0ZTLkZTTm9kZT1GU05vZGU7RlMuY3JlYXRlUHJlbG9hZGVkRmlsZT1GU19jcmVhdGVQcmVsb2FkZWRGaWxlO0ZTLnN0YXRpY0luaXQoKTtlbWJpbmRfaW5pdF9jaGFyQ29kZXMoKTtCaW5kaW5nRXJyb3I9TW9kdWxlWyJCaW5kaW5nRXJyb3IiXT1jbGFzcyBCaW5kaW5nRXJyb3IgZXh0ZW5kcyBFcnJvcntjb25zdHJ1Y3RvcihtZXNzYWdlKXtzdXBlcihtZXNzYWdlKTt0aGlzLm5hbWU9IkJpbmRpbmdFcnJvciJ9fTtJbnRlcm5hbEVycm9yPU1vZHVsZVsiSW50ZXJuYWxFcnJvciJdPWNsYXNzIEludGVybmFsRXJyb3IgZXh0ZW5kcyBFcnJvcntjb25zdHJ1Y3RvcihtZXNzYWdlKXtzdXBlcihtZXNzYWdlKTt0aGlzLm5hbWU9IkludGVybmFsRXJyb3IifX07aW5pdF9DbGFzc0hhbmRsZSgpO2luaXRfZW1iaW5kKCk7aW5pdF9SZWdpc3RlcmVkUG9pbnRlcigpO1VuYm91bmRUeXBlRXJyb3I9TW9kdWxlWyJVbmJvdW5kVHlwZUVycm9yIl09ZXh0ZW5kRXJyb3IoRXJyb3IsIlVuYm91bmRUeXBlRXJyb3IiKTtoYW5kbGVBbGxvY2F0b3JJbml0KCk7aW5pdF9lbXZhbCgpO3ZhciBwcm94aWVkRnVuY3Rpb25UYWJsZT1bX3Byb2NfZXhpdCxleGl0T25NYWluVGhyZWFkLHB0aHJlYWRDcmVhdGVQcm94aWVkLF9fX3N5c2NhbGxfZmNudGw2NCxfX19zeXNjYWxsX2ZzdGF0NjQsX19fc3lzY2FsbF9mdHJ1bmNhdGU2NCxfX19zeXNjYWxsX2lvY3RsLF9fX3N5c2NhbGxfbHN0YXQ2NCxfX19zeXNjYWxsX25ld2ZzdGF0YXQsX19fc3lzY2FsbF9vcGVuYXQsX19fc3lzY2FsbF9yZWFkbGlua2F0LF9fX3N5c2NhbGxfcmVuYW1lYXQsX19fc3lzY2FsbF9zdGF0NjQsX19fc3lzY2FsbF91bmxpbmthdCxfX21tYXBfanMsX19tdW5tYXBfanMsX2Vudmlyb25fZ2V0LF9lbnZpcm9uX3NpemVzX2dldCxfZmRfY2xvc2UsX2ZkX3JlYWQsX2ZkX3NlZWssX2ZkX3N5bmMsX2ZkX3dyaXRlXTt2YXIgd2FzbUltcG9ydHM9e2I6X19fYXNzZXJ0X2ZhaWwsdzpfX19jeGFfYmVnaW5fY2F0Y2gsdjpfX19jeGFfZW5kX2NhdGNoLGQ6X19fY3hhX2ZpbmRfbWF0Y2hpbmdfY2F0Y2hfMixrOl9fX2N4YV9maW5kX21hdGNoaW5nX2NhdGNoXzMseWE6X19fY3hhX3JldGhyb3csbjpfX19jeGFfdGhyb3csaWE6X19fZW1zY3JpcHRlbl9pbml0X21haW5fdGhyZWFkX2pzLEU6X19fZW1zY3JpcHRlbl90aHJlYWRfY2xlYW51cCxmYTpfX19wdGhyZWFkX2NyZWF0ZV9qcyxoOl9fX3Jlc3VtZUV4Y2VwdGlvbixvYTpfX19zeXNjYWxsX2ZzdGF0NjQsVzpfX19zeXNjYWxsX2Z0cnVuY2F0ZTY0LG1hOl9fX3N5c2NhbGxfbmV3ZnN0YXRhdCxwYTpfX19zeXNjYWxsX29wZW5hdCxlYTpfX19zeXNjYWxsX3JlYWRsaW5rYXQsZGE6X19fc3lzY2FsbF9yZW5hbWVhdCxuYTpfX19zeXNjYWxsX3N0YXQ2NCxhYTpfX19zeXNjYWxsX3VubGlua2F0LFg6X19lbWJpbmRfcmVnaXN0ZXJfYmlnaW50LHVhOl9fZW1iaW5kX3JlZ2lzdGVyX2Jvb2wsUzpfX2VtYmluZF9yZWdpc3Rlcl9jbGFzcyxSOl9fZW1iaW5kX3JlZ2lzdGVyX2NsYXNzX2NvbnN0cnVjdG9yLG06X19lbWJpbmRfcmVnaXN0ZXJfY2xhc3NfZnVuY3Rpb24sdGE6X19lbWJpbmRfcmVnaXN0ZXJfZW12YWwsSzpfX2VtYmluZF9yZWdpc3Rlcl9mbG9hdCxxOl9fZW1iaW5kX3JlZ2lzdGVyX2ludGVnZXIsbDpfX2VtYmluZF9yZWdpc3Rlcl9tZW1vcnlfdmlldyxKOl9fZW1iaW5kX3JlZ2lzdGVyX3N0ZF9zdHJpbmcsQjpfX2VtYmluZF9yZWdpc3Rlcl9zdGRfd3N0cmluZyx2YTpfX2VtYmluZF9yZWdpc3Rlcl92b2lkLHNhOl9fZW1zY3JpcHRlbl9nZXRfbm93X2lzX21vbm90b25pYyxiYTpfX2Vtc2NyaXB0ZW5fbm90aWZ5X21haWxib3hfcG9zdG1lc3NhZ2UsZ2E6X19lbXNjcmlwdGVuX3JlY2VpdmVfb25fbWFpbl90aHJlYWRfanMsaGE6X19lbXNjcmlwdGVuX3RocmVhZF9tYWlsYm94X2F3YWl0LHJhOl9fZW1zY3JpcHRlbl90aHJlYWRfc2V0X3N0cm9uZ3JlZixDYTpfX2VtdmFsX2RlY3JlZixEYTpfX2VtdmFsX2luY3JlZixzOl9fZW12YWxfdGFrZV92YWx1ZSxUOl9fbW1hcF9qcyxVOl9fbXVubWFwX2pzLGM6X2Fib3J0LEY6X2Vtc2NyaXB0ZW5fY2hlY2tfYmxvY2tpbmdfYWxsb3dlZCxIOl9lbXNjcmlwdGVuX2RhdGVfbm93LHFhOl9lbXNjcmlwdGVuX2V4aXRfd2l0aF9saXZlX3J1bnRpbWUsY2E6X2Vtc2NyaXB0ZW5fZ2V0X2hlYXBfbWF4LHA6X2Vtc2NyaXB0ZW5fZ2V0X25vdyxNOl9lbXNjcmlwdGVuX251bV9sb2dpY2FsX2NvcmVzLCQ6X2Vtc2NyaXB0ZW5fcmVzaXplX2hlYXAsamE6X2Vudmlyb25fZ2V0LGthOl9lbnZpcm9uX3NpemVzX2dldCxMOl9leGl0LEk6X2ZkX2Nsb3NlLEc6X2ZkX3JlYWQsVjpfZmRfc2VlayxsYTpfZmRfc3luYyxBOl9mZF93cml0ZSxaOl9nZXRlbnRyb3B5LEJhOmludm9rZV9maSxEOmludm9rZV9pLGc6aW52b2tlX2lpLHhhOmludm9rZV9paWRpaSxBYTppbnZva2VfaWlmLGU6aW52b2tlX2lpaSxmOmludm9rZV9paWlpLHo6aW52b2tlX2lpaWlpLHk6aW52b2tlX2lpaWlpaSxROmludm9rZV9paWlpaWlpLFk6aW52b2tlX2lpaixyOmludm9rZV92LGo6aW52b2tlX3ZpLGk6aW52b2tlX3ZpaSx0Omludm9rZV92aWlkLEM6aW52b2tlX3ZpaWRpLG86aW52b2tlX3ZpaWksemE6aW52b2tlX3ZpaWlkaWlpLHU6aW52b2tlX3ZpaWlpLE86aW52b2tlX3ZpaWlpZGksUDppbnZva2VfdmlpaWlpLHg6aW52b2tlX3ZpaWlpaWlpZGksTjppbnZva2VfdmlpaWlpaWlpLGE6d2FzbU1lbW9yeXx8TW9kdWxlWyJ3YXNtTWVtb3J5Il0sXzpfc3RyZnRpbWVfbCx3YTp4bm5Mb2FkV2FzbU1vZHVsZUpTfTt2YXIgd2FzbUV4cG9ydHM9Y3JlYXRlV2FzbSgpO3ZhciBfX193YXNtX2NhbGxfY3RvcnM9KCk9PihfX193YXNtX2NhbGxfY3RvcnM9d2FzbUV4cG9ydHNbIkVhIl0pKCk7dmFyIF9wdGhyZWFkX3NlbGY9TW9kdWxlWyJfcHRocmVhZF9zZWxmIl09KCk9PihfcHRocmVhZF9zZWxmPU1vZHVsZVsiX3B0aHJlYWRfc2VsZiJdPXdhc21FeHBvcnRzWyJGYSJdKSgpO3ZhciBfbWFsbG9jPWEwPT4oX21hbGxvYz13YXNtRXhwb3J0c1siSGEiXSkoYTApO3ZhciBfZnJlZT1hMD0+KF9mcmVlPXdhc21FeHBvcnRzWyJJYSJdKShhMCk7dmFyIF9fX2Vycm5vX2xvY2F0aW9uPSgpPT4oX19fZXJybm9fbG9jYXRpb249d2FzbUV4cG9ydHNbIkphIl0pKCk7dmFyIF9fZW1zY3JpcHRlbl90bHNfaW5pdD1Nb2R1bGVbIl9fZW1zY3JpcHRlbl90bHNfaW5pdCJdPSgpPT4oX19lbXNjcmlwdGVuX3Rsc19pbml0PU1vZHVsZVsiX19lbXNjcmlwdGVuX3Rsc19pbml0Il09d2FzbUV4cG9ydHNbIkthIl0pKCk7dmFyIF9lbXNjcmlwdGVuX2J1aWx0aW5fbWVtYWxpZ249KGEwLGExKT0+KF9lbXNjcmlwdGVuX2J1aWx0aW5fbWVtYWxpZ249d2FzbUV4cG9ydHNbIkxhIl0pKGEwLGExKTt2YXIgX19fZ2V0VHlwZU5hbWU9YTA9PihfX19nZXRUeXBlTmFtZT13YXNtRXhwb3J0c1siTWEiXSkoYTApO3ZhciBfX2VtYmluZF9pbml0aWFsaXplX2JpbmRpbmdzPU1vZHVsZVsiX19lbWJpbmRfaW5pdGlhbGl6ZV9iaW5kaW5ncyJdPSgpPT4oX19lbWJpbmRfaW5pdGlhbGl6ZV9iaW5kaW5ncz1Nb2R1bGVbIl9fZW1iaW5kX2luaXRpYWxpemVfYmluZGluZ3MiXT13YXNtRXhwb3J0c1siTmEiXSkoKTt2YXIgX19fZnVuY3Nfb25fZXhpdD0oKT0+KF9fX2Z1bmNzX29uX2V4aXQ9d2FzbUV4cG9ydHNbIk9hIl0pKCk7dmFyIF9fZW1zY3JpcHRlbl90aHJlYWRfaW5pdD1Nb2R1bGVbIl9fZW1zY3JpcHRlbl90aHJlYWRfaW5pdCJdPShhMCxhMSxhMixhMyxhNCxhNSk9PihfX2Vtc2NyaXB0ZW5fdGhyZWFkX2luaXQ9TW9kdWxlWyJfX2Vtc2NyaXB0ZW5fdGhyZWFkX2luaXQiXT13YXNtRXhwb3J0c1siUGEiXSkoYTAsYTEsYTIsYTMsYTQsYTUpO3ZhciBfX2Vtc2NyaXB0ZW5fdGhyZWFkX2NyYXNoZWQ9TW9kdWxlWyJfX2Vtc2NyaXB0ZW5fdGhyZWFkX2NyYXNoZWQiXT0oKT0+KF9fZW1zY3JpcHRlbl90aHJlYWRfY3Jhc2hlZD1Nb2R1bGVbIl9fZW1zY3JpcHRlbl90aHJlYWRfY3Jhc2hlZCJdPXdhc21FeHBvcnRzWyJRYSJdKSgpO3ZhciBfZW1zY3JpcHRlbl9tYWluX3RocmVhZF9wcm9jZXNzX3F1ZXVlZF9jYWxscz0oKT0+KF9lbXNjcmlwdGVuX21haW5fdGhyZWFkX3Byb2Nlc3NfcXVldWVkX2NhbGxzPXdhc21FeHBvcnRzWyJlbXNjcmlwdGVuX21haW5fdGhyZWFkX3Byb2Nlc3NfcXVldWVkX2NhbGxzIl0pKCk7dmFyIF9mZmx1c2g9TW9kdWxlWyJfZmZsdXNoIl09YTA9PihfZmZsdXNoPU1vZHVsZVsiX2ZmbHVzaCJdPXdhc21FeHBvcnRzWyJSYSJdKShhMCk7dmFyIF9lbXNjcmlwdGVuX21haW5fcnVudGltZV90aHJlYWRfaWQ9KCk9PihfZW1zY3JpcHRlbl9tYWluX3J1bnRpbWVfdGhyZWFkX2lkPXdhc21FeHBvcnRzWyJlbXNjcmlwdGVuX21haW5fcnVudGltZV90aHJlYWRfaWQiXSkoKTt2YXIgX19lbXNjcmlwdGVuX3J1bl9vbl9tYWluX3RocmVhZF9qcz0oYTAsYTEsYTIsYTMpPT4oX19lbXNjcmlwdGVuX3J1bl9vbl9tYWluX3RocmVhZF9qcz13YXNtRXhwb3J0c1siU2EiXSkoYTAsYTEsYTIsYTMpO3ZhciBfX2Vtc2NyaXB0ZW5fdGhyZWFkX2ZyZWVfZGF0YT1hMD0+KF9fZW1zY3JpcHRlbl90aHJlYWRfZnJlZV9kYXRhPXdhc21FeHBvcnRzWyJUYSJdKShhMCk7dmFyIF9fZW1zY3JpcHRlbl90aHJlYWRfZXhpdD1Nb2R1bGVbIl9fZW1zY3JpcHRlbl90aHJlYWRfZXhpdCJdPWEwPT4oX19lbXNjcmlwdGVuX3RocmVhZF9leGl0PU1vZHVsZVsiX19lbXNjcmlwdGVuX3RocmVhZF9leGl0Il09d2FzbUV4cG9ydHNbIlVhIl0pKGEwKTt2YXIgX19lbXNjcmlwdGVuX2NoZWNrX21haWxib3g9KCk9PihfX2Vtc2NyaXB0ZW5fY2hlY2tfbWFpbGJveD13YXNtRXhwb3J0c1siVmEiXSkoKTt2YXIgX3NldFRocmV3PShhMCxhMSk9Pihfc2V0VGhyZXc9d2FzbUV4cG9ydHNbIldhIl0pKGEwLGExKTt2YXIgc2V0VGVtcFJldDA9YTA9PihzZXRUZW1wUmV0MD13YXNtRXhwb3J0c1siWGEiXSkoYTApO3ZhciBfZW1zY3JpcHRlbl9zdGFja19zZXRfbGltaXRzPShhMCxhMSk9PihfZW1zY3JpcHRlbl9zdGFja19zZXRfbGltaXRzPXdhc21FeHBvcnRzWyJZYSJdKShhMCxhMSk7dmFyIHN0YWNrU2F2ZT0oKT0+KHN0YWNrU2F2ZT13YXNtRXhwb3J0c1siWmEiXSkoKTt2YXIgc3RhY2tSZXN0b3JlPWEwPT4oc3RhY2tSZXN0b3JlPXdhc21FeHBvcnRzWyJfYSJdKShhMCk7dmFyIHN0YWNrQWxsb2M9YTA9PihzdGFja0FsbG9jPXdhc21FeHBvcnRzWyIkYSJdKShhMCk7dmFyIF9fX2N4YV9kZWNyZW1lbnRfZXhjZXB0aW9uX3JlZmNvdW50PWEwPT4oX19fY3hhX2RlY3JlbWVudF9leGNlcHRpb25fcmVmY291bnQ9d2FzbUV4cG9ydHNbImFiIl0pKGEwKTt2YXIgX19fY3hhX2luY3JlbWVudF9leGNlcHRpb25fcmVmY291bnQ9YTA9PihfX19jeGFfaW5jcmVtZW50X2V4Y2VwdGlvbl9yZWZjb3VudD13YXNtRXhwb3J0c1siYmIiXSkoYTApO3ZhciBfX19jeGFfY2FuX2NhdGNoPShhMCxhMSxhMik9PihfX19jeGFfY2FuX2NhdGNoPXdhc21FeHBvcnRzWyJjYiJdKShhMCxhMSxhMik7dmFyIF9fX2N4YV9pc19wb2ludGVyX3R5cGU9YTA9PihfX19jeGFfaXNfcG9pbnRlcl90eXBlPXdhc21FeHBvcnRzWyJkYiJdKShhMCk7dmFyIGR5bkNhbGxfdmlpamo9TW9kdWxlWyJkeW5DYWxsX3ZpaWpqIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2KT0+KGR5bkNhbGxfdmlpamo9TW9kdWxlWyJkeW5DYWxsX3ZpaWpqIl09d2FzbUV4cG9ydHNbImViIl0pKGEwLGExLGEyLGEzLGE0LGE1LGE2KTt2YXIgZHluQ2FsbF92aWlpampqPU1vZHVsZVsiZHluQ2FsbF92aWlpampqIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3LGE4LGE5KT0+KGR5bkNhbGxfdmlpaWpqaj1Nb2R1bGVbImR5bkNhbGxfdmlpaWpqaiJdPXdhc21FeHBvcnRzWyJmYiJdKShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCxhOSk7dmFyIGR5bkNhbGxfaWlpaWo9TW9kdWxlWyJkeW5DYWxsX2lpaWlqIl09KGEwLGExLGEyLGEzLGE0LGE1KT0+KGR5bkNhbGxfaWlpaWo9TW9kdWxlWyJkeW5DYWxsX2lpaWlqIl09d2FzbUV4cG9ydHNbImdiIl0pKGEwLGExLGEyLGEzLGE0LGE1KTt2YXIgZHluQ2FsbF9qaWk9TW9kdWxlWyJkeW5DYWxsX2ppaSJdPShhMCxhMSxhMik9PihkeW5DYWxsX2ppaT1Nb2R1bGVbImR5bkNhbGxfamlpIl09d2FzbUV4cG9ydHNbImhiIl0pKGEwLGExLGEyKTt2YXIgZHluQ2FsbF9qamo9TW9kdWxlWyJkeW5DYWxsX2pqaiJdPShhMCxhMSxhMixhMyxhNCk9PihkeW5DYWxsX2pqaj1Nb2R1bGVbImR5bkNhbGxfampqIl09d2FzbUV4cG9ydHNbImliIl0pKGEwLGExLGEyLGEzLGE0KTt2YXIgZHluQ2FsbF9paWlpamo9TW9kdWxlWyJkeW5DYWxsX2lpaWlqaiJdPShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyk9PihkeW5DYWxsX2lpaWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpaWpqIl09d2FzbUV4cG9ydHNbImpiIl0pKGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3KTt2YXIgZHluQ2FsbF92aWlqamk9TW9kdWxlWyJkeW5DYWxsX3ZpaWpqaSJdPShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyk9PihkeW5DYWxsX3ZpaWpqaT1Nb2R1bGVbImR5bkNhbGxfdmlpamppIl09d2FzbUV4cG9ydHNbImtiIl0pKGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3KTt2YXIgZHluQ2FsbF9paWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpamoiXT0oYTAsYTEsYTIsYTMsYTQsYTUsYTYpPT4oZHluQ2FsbF9paWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpamoiXT13YXNtRXhwb3J0c1sibGIiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYpO3ZhciBkeW5DYWxsX3ZpaWpqaj1Nb2R1bGVbImR5bkNhbGxfdmlpampqIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3LGE4KT0+KGR5bkNhbGxfdmlpampqPU1vZHVsZVsiZHluQ2FsbF92aWlqamoiXT13YXNtRXhwb3J0c1sibWIiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgpO3ZhciBkeW5DYWxsX2lpaj1Nb2R1bGVbImR5bkNhbGxfaWlqIl09KGEwLGExLGEyLGEzKT0+KGR5bkNhbGxfaWlqPU1vZHVsZVsiZHluQ2FsbF9paWoiXT13YXNtRXhwb3J0c1sibmIiXSkoYTAsYTEsYTIsYTMpO3ZhciBkeW5DYWxsX2lpamppaWlpPU1vZHVsZVsiZHluQ2FsbF9paWpqaWlpaSJdPShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCxhOSk9PihkeW5DYWxsX2lpamppaWlpPU1vZHVsZVsiZHluQ2FsbF9paWpqaWlpaSJdPXdhc21FeHBvcnRzWyJvYiJdKShhMCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCxhOSk7dmFyIGR5bkNhbGxfamlqaT1Nb2R1bGVbImR5bkNhbGxfamlqaSJdPShhMCxhMSxhMixhMyxhNCk9PihkeW5DYWxsX2ppamk9TW9kdWxlWyJkeW5DYWxsX2ppamkiXT13YXNtRXhwb3J0c1sicGIiXSkoYTAsYTEsYTIsYTMsYTQpO3ZhciBkeW5DYWxsX3ZpaWppaT1Nb2R1bGVbImR5bkNhbGxfdmlpamlpIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2KT0+KGR5bkNhbGxfdmlpamlpPU1vZHVsZVsiZHluQ2FsbF92aWlqaWkiXT13YXNtRXhwb3J0c1sicWIiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYpO3ZhciBkeW5DYWxsX2lpaWlpaj1Nb2R1bGVbImR5bkNhbGxfaWlpaWlqIl09KGEwLGExLGEyLGEzLGE0LGE1LGE2KT0+KGR5bkNhbGxfaWlpaWlqPU1vZHVsZVsiZHluQ2FsbF9paWlpaWoiXT13YXNtRXhwb3J0c1sicmIiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYpO3ZhciBkeW5DYWxsX2lpaWlpamo9TW9kdWxlWyJkeW5DYWxsX2lpaWlpamoiXT0oYTAsYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgpPT4oZHluQ2FsbF9paWlpaWpqPU1vZHVsZVsiZHluQ2FsbF9paWlpaWpqIl09d2FzbUV4cG9ydHNbInNiIl0pKGEwLGExLGEyLGEzLGE0LGE1LGE2LGE3LGE4KTt2YXIgZHluQ2FsbF9paWlpaWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpaWlpamoiXT0oYTAsYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgsYTkpPT4oZHluQ2FsbF9paWlpaWlqaj1Nb2R1bGVbImR5bkNhbGxfaWlpaWlpamoiXT13YXNtRXhwb3J0c1sidGIiXSkoYTAsYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgsYTkpO3ZhciBfX19zdGFydF9lbV9qcz1Nb2R1bGVbIl9fX3N0YXJ0X2VtX2pzIl09MjYyMTQ4O3ZhciBfX19zdG9wX2VtX2pzPU1vZHVsZVsiX19fc3RvcF9lbV9qcyJdPTI2Mjc2MDtmdW5jdGlvbiBpbnZva2VfaWkoaW5kZXgsYTEpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWkoaW5kZXgsYTEsYTIpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMil9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV92aWkoaW5kZXgsYTEsYTIpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7Z2V0V2FzbVRhYmxlRW50cnkoaW5kZXgpKGExLGEyKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX3ZpKGluZGV4LGExKXt2YXIgc3A9c3RhY2tTYXZlKCk7dHJ5e2dldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV92aWlpaShpbmRleCxhMSxhMixhMyxhNCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfaWlpaWlpKGluZGV4LGExLGEyLGEzLGE0LGE1KXt2YXIgc3A9c3RhY2tTYXZlKCk7dHJ5e3JldHVybiBnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfaWlpaShpbmRleCxhMSxhMixhMyl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtyZXR1cm4gZ2V0V2FzbVRhYmxlRW50cnkoaW5kZXgpKGExLGEyLGEzKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX2koaW5kZXgpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KSgpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfZmkoaW5kZXgsYTEpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWYoaW5kZXgsYTEsYTIpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMil9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWlpaWlpKGluZGV4LGExLGEyLGEzLGE0LGE1LGE2KXt2YXIgc3A9c3RhY2tTYXZlKCk7dHJ5e3JldHVybiBnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUsYTYpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdihpbmRleCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX3ZpaWlpaShpbmRleCxhMSxhMixhMyxhNCxhNSl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdmlpaWlpaWlkaShpbmRleCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCxhOSl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgsYTkpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdmlpaShpbmRleCxhMSxhMixhMyl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdmlpaWlkaShpbmRleCxhMSxhMixhMyxhNCxhNSxhNil7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUsYTYpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfdmlpaWRpaWkoaW5kZXgsYTEsYTIsYTMsYTQsYTUsYTYsYTcpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7Z2V0V2FzbVRhYmxlRW50cnkoaW5kZXgpKGExLGEyLGEzLGE0LGE1LGE2LGE3KX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX3ZpaWQoaW5kZXgsYTEsYTIsYTMpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7Z2V0V2FzbVRhYmxlRW50cnkoaW5kZXgpKGExLGEyLGEzKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19ZnVuY3Rpb24gaW52b2tlX3ZpaWlpaWlpaShpbmRleCxhMSxhMixhMyxhNCxhNSxhNixhNyxhOCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQsYTUsYTYsYTcsYTgpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfaWlpaWkoaW5kZXgsYTEsYTIsYTMsYTQpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMixhMyxhNCl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV92aWlkaShpbmRleCxhMSxhMixhMyxhNCl7dmFyIHNwPXN0YWNrU2F2ZSgpO3RyeXtnZXRXYXNtVGFibGVFbnRyeShpbmRleCkoYTEsYTIsYTMsYTQpfWNhdGNoKGUpe3N0YWNrUmVzdG9yZShzcCk7aWYoZSE9PWUrMCl0aHJvdyBlO19zZXRUaHJldygxLDApfX1mdW5jdGlvbiBpbnZva2VfaWlkaWkoaW5kZXgsYTEsYTIsYTMsYTQpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGdldFdhc21UYWJsZUVudHJ5KGluZGV4KShhMSxhMixhMyxhNCl9Y2F0Y2goZSl7c3RhY2tSZXN0b3JlKHNwKTtpZihlIT09ZSswKXRocm93IGU7X3NldFRocmV3KDEsMCl9fWZ1bmN0aW9uIGludm9rZV9paWooaW5kZXgsYTEsYTIsYTMpe3ZhciBzcD1zdGFja1NhdmUoKTt0cnl7cmV0dXJuIGR5bkNhbGxfaWlqKGluZGV4LGExLGEyLGEzKX1jYXRjaChlKXtzdGFja1Jlc3RvcmUoc3ApO2lmKGUhPT1lKzApdGhyb3cgZTtfc2V0VGhyZXcoMSwwKX19TW9kdWxlWyJ3YXNtTWVtb3J5Il09d2FzbU1lbW9yeTtNb2R1bGVbImtlZXBSdW50aW1lQWxpdmUiXT1rZWVwUnVudGltZUFsaXZlO01vZHVsZVsiRXhpdFN0YXR1cyJdPUV4aXRTdGF0dXM7TW9kdWxlWyJQVGhyZWFkIl09UFRocmVhZDt2YXIgY2FsbGVkUnVuO2RlcGVuZGVuY2llc0Z1bGZpbGxlZD1mdW5jdGlvbiBydW5DYWxsZXIoKXtpZighY2FsbGVkUnVuKXJ1bigpO2lmKCFjYWxsZWRSdW4pZGVwZW5kZW5jaWVzRnVsZmlsbGVkPXJ1bkNhbGxlcn07ZnVuY3Rpb24gcnVuKCl7aWYocnVuRGVwZW5kZW5jaWVzPjApe3JldHVybn1pZihFTlZJUk9OTUVOVF9JU19QVEhSRUFEKXtyZWFkeVByb21pc2VSZXNvbHZlKE1vZHVsZSk7aW5pdFJ1bnRpbWUoKTtzdGFydFdvcmtlcihNb2R1bGUpO3JldHVybn1wcmVSdW4oKTtpZihydW5EZXBlbmRlbmNpZXM+MCl7cmV0dXJufWZ1bmN0aW9uIGRvUnVuKCl7aWYoY2FsbGVkUnVuKXJldHVybjtjYWxsZWRSdW49dHJ1ZTtNb2R1bGVbImNhbGxlZFJ1biJdPXRydWU7aWYoQUJPUlQpcmV0dXJuO2luaXRSdW50aW1lKCk7cmVhZHlQcm9taXNlUmVzb2x2ZShNb2R1bGUpO2lmKE1vZHVsZVsib25SdW50aW1lSW5pdGlhbGl6ZWQiXSlNb2R1bGVbIm9uUnVudGltZUluaXRpYWxpemVkIl0oKTtwb3N0UnVuKCl9aWYoTW9kdWxlWyJzZXRTdGF0dXMiXSl7TW9kdWxlWyJzZXRTdGF0dXMiXSgiUnVubmluZy4uLiIpO3NldFRpbWVvdXQoZnVuY3Rpb24oKXtzZXRUaW1lb3V0KGZ1bmN0aW9uKCl7TW9kdWxlWyJzZXRTdGF0dXMiXSgiIil9LDEpO2RvUnVuKCl9LDEpfWVsc2V7ZG9SdW4oKX19aWYoTW9kdWxlWyJwcmVJbml0Il0pe2lmKHR5cGVvZiBNb2R1bGVbInByZUluaXQiXT09ImZ1bmN0aW9uIilNb2R1bGVbInByZUluaXQiXT1bTW9kdWxlWyJwcmVJbml0Il1dO3doaWxlKE1vZHVsZVsicHJlSW5pdCJdLmxlbmd0aD4wKXtNb2R1bGVbInByZUluaXQiXS5wb3AoKSgpfX1ydW4oKTsKCgogIHJldHVybiBtb2R1bGVBcmcucmVhZHkKfQopOwp9KSgpOwo7CmNyZWF0ZVdhc21NdWx0aUluc3RhbmNlID0gTW9kdWxlOyB9ICAgIAogICAgCiAgICAgICAgICAgICFmdW5jdGlvbigpeyJ1c2Ugc3RyaWN0IjtjbGFzcyBse31mdW5jdGlvbiBqKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGUmJk9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHkuY2FsbChlLCJkZWZhdWx0Iik/ZS5kZWZhdWx0OmV9bC51cGRhdGVzPXt0cmFuc2Zvcm1lcl9uZXc6Ik5ldyB0cmFuc2Zvcm1lciIsdHJhbnNmb3JtZXJfbnVsbDoiTnVsbCB0cmFuc2Zvcm1lciJ9LGwuZXJyb3JzPXt0cmFuc2Zvcm1lcl9ub25lOiJObyB0cmFuc2Zvcm1lcnMgcHJvdmlkZWQiLHRyYW5zZm9ybWVyX3N0YXJ0OiJDYW5ub3Qgc3RhcnQgdHJhbnNmb3JtZXIiLHRyYW5zZm9ybWVyX3RyYW5zZm9ybToiQ2Fubm90IHRyYW5zZm9ybSBmcmFtZSIsdHJhbnNmb3JtZXJfZmx1c2g6IkNhbm5vdCBmbHVzaCB0cmFuc2Zvcm1lciIscmVhZGFibGVfbnVsbDoiUmVhZGFibGUgaXMgbnVsbCIsd3JpdGFibGVfbnVsbDoiV3JpdGFibGUgaXMgbnVsbCJ9O2NvbnN0IGU9bmV3IFdlYWtNYXAsdD1uZXcgV2Vha01hcCxyPW5ldyBXZWFrTWFwLG89U3ltYm9sKCJhbnlQcm9kdWNlciIpLGE9UHJvbWlzZS5yZXNvbHZlKCksYz1TeW1ib2woImxpc3RlbmVyQWRkZWQiKSxmPVN5bWJvbCgibGlzdGVuZXJSZW1vdmVkIik7bGV0IGg9ITE7ZnVuY3Rpb24gcChlKXtpZigic3RyaW5nIiE9dHlwZW9mIGUmJiJzeW1ib2wiIT10eXBlb2YgZSl0aHJvdyBuZXcgVHlwZUVycm9yKCJldmVudE5hbWUgbXVzdCBiZSBhIHN0cmluZyBvciBhIHN5bWJvbCIpfWZ1bmN0aW9uIGIoZSl7aWYoImZ1bmN0aW9uIiE9dHlwZW9mIGUpdGhyb3cgbmV3IFR5cGVFcnJvcigibGlzdGVuZXIgbXVzdCBiZSBhIGZ1bmN0aW9uIil9ZnVuY3Rpb24gbShlLHIpe2NvbnN0IG89dC5nZXQoZSk7cmV0dXJuIG8uaGFzKHIpfHxvLnNldChyLG5ldyBTZXQpLG8uZ2V0KHIpfWZ1bmN0aW9uIF8oZSx0KXtjb25zdCBhPSJzdHJpbmciPT10eXBlb2YgdHx8InN5bWJvbCI9PXR5cGVvZiB0P3Q6byxjPXIuZ2V0KGUpO3JldHVybiBjLmhhcyhhKXx8Yy5zZXQoYSxuZXcgU2V0KSxjLmdldChhKX1mdW5jdGlvbiBEKGUsdCl7dD1BcnJheS5pc0FycmF5KHQpP3Q6W3RdO2xldCByPSExLHM9KCk9Pnt9LG89W107Y29uc3QgYT17ZW5xdWV1ZShlKXtvLnB1c2goZSkscygpfSxmaW5pc2goKXtyPSEwLHMoKX19O2Zvcihjb25zdCBjIG9mIHQpXyhlLGMpLmFkZChhKTtyZXR1cm57YXN5bmMgbmV4dCgpe3JldHVybiBvPzA9PT1vLmxlbmd0aD9yPyhvPXZvaWQgMCx0aGlzLm5leHQoKSk6KGF3YWl0IG5ldyBQcm9taXNlKChlPT57cz1lfSkpLHRoaXMubmV4dCgpKTp7ZG9uZTohMSx2YWx1ZTphd2FpdCBvLnNoaWZ0KCl9Ontkb25lOiEwfX0sYXN5bmMgcmV0dXJuKHIpe289dm9pZCAwO2Zvcihjb25zdCBvIG9mIHQpXyhlLG8pLmRlbGV0ZShhKTtyZXR1cm4gcygpLGFyZ3VtZW50cy5sZW5ndGg+MD97ZG9uZTohMCx2YWx1ZTphd2FpdCByfTp7ZG9uZTohMH19LFtTeW1ib2wuYXN5bmNJdGVyYXRvcl0oKXtyZXR1cm4gdGhpc319fWZ1bmN0aW9uICQoZSl7aWYodm9pZCAwPT09ZSlyZXR1cm4gdTtpZighQXJyYXkuaXNBcnJheShlKSl0aHJvdyBuZXcgVHlwZUVycm9yKCJgbWV0aG9kTmFtZXNgIG11c3QgYmUgYW4gYXJyYXkgb2Ygc3RyaW5ncyIpO2Zvcihjb25zdCB0IG9mIGUpaWYoIXUuaW5jbHVkZXModCkpdGhyb3cic3RyaW5nIiE9dHlwZW9mIHQ/bmV3IFR5cGVFcnJvcigiYG1ldGhvZE5hbWVzYCBlbGVtZW50IG11c3QgYmUgYSBzdHJpbmciKTpuZXcgRXJyb3IoYCR7dH0gaXMgbm90IEVtaXR0ZXJ5IG1ldGhvZGApO3JldHVybiBlfWNvbnN0IE09ZT0+ZT09PWN8fGU9PT1mO2NsYXNzIGR7c3RhdGljIG1peGluKGUsdCl7cmV0dXJuIHQ9JCh0KSxyPT57aWYoImZ1bmN0aW9uIiE9dHlwZW9mIHIpdGhyb3cgbmV3IFR5cGVFcnJvcigiYHRhcmdldGAgbXVzdCBiZSBmdW5jdGlvbiIpO2Zvcihjb25zdCBlIG9mIHQpaWYodm9pZCAwIT09ci5wcm90b3R5cGVbZV0pdGhyb3cgbmV3IEVycm9yKGBUaGUgcHJvcGVydHkgXGAke2V9XGAgYWxyZWFkeSBleGlzdHMgb24gXGB0YXJnZXRcYGApO09iamVjdC5kZWZpbmVQcm9wZXJ0eShyLnByb3RvdHlwZSxlLHtlbnVtZXJhYmxlOiExLGdldDpmdW5jdGlvbiBpKCl7cmV0dXJuIE9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0aGlzLGUse2VudW1lcmFibGU6ITEsdmFsdWU6bmV3IGR9KSx0aGlzW2VdfX0pO2NvbnN0IG49dD0+ZnVuY3Rpb24oLi4ucil7cmV0dXJuIHRoaXNbZV1bdF0oLi4ucil9O2Zvcihjb25zdCBlIG9mIHQpT2JqZWN0LmRlZmluZVByb3BlcnR5KHIucHJvdG90eXBlLGUse2VudW1lcmFibGU6ITEsdmFsdWU6bihlKX0pO3JldHVybiByfX1zdGF0aWMgZ2V0IGlzRGVidWdFbmFibGVkKCl7aWYoIm9iamVjdCIhPXR5cGVvZiBwcm9jZXNzKXJldHVybiBoO2NvbnN0e2VudjplfT1wcm9jZXNzfHx7ZW52Ont9fTtyZXR1cm4iZW1pdHRlcnkiPT09ZS5ERUJVR3x8IioiPT09ZS5ERUJVR3x8aH1zdGF0aWMgc2V0IGlzRGVidWdFbmFibGVkKGUpe2g9ZX1jb25zdHJ1Y3RvcihvPXt9KXtlLnNldCh0aGlzLG5ldyBTZXQpLHQuc2V0KHRoaXMsbmV3IE1hcCksci5zZXQodGhpcyxuZXcgTWFwKSx0aGlzLmRlYnVnPW8uZGVidWd8fHt9LHZvaWQgMD09PXRoaXMuZGVidWcuZW5hYmxlZCYmKHRoaXMuZGVidWcuZW5hYmxlZD0hMSksdGhpcy5kZWJ1Zy5sb2dnZXJ8fCh0aGlzLmRlYnVnLmxvZ2dlcj0oZSx0LHIsbyk9Pnt0cnl7bz1KU09OLnN0cmluZ2lmeShvKX1jYXRjaHtvPWBPYmplY3Qgd2l0aCB0aGUgZm9sbG93aW5nIGtleXMgZmFpbGVkIHRvIHN0cmluZ2lmeTogJHtPYmplY3Qua2V5cyhvKS5qb2luKCIsIil9YH0ic3ltYm9sIj09dHlwZW9mIHImJihyPXIudG9TdHJpbmcoKSk7Y29uc3QgYT1uZXcgRGF0ZSxjPWAke2EuZ2V0SG91cnMoKX06JHthLmdldE1pbnV0ZXMoKX06JHthLmdldFNlY29uZHMoKX0uJHthLmdldE1pbGxpc2Vjb25kcygpfWA7Y29uc29sZS5sb2coYFske2N9XVtlbWl0dGVyeToke2V9XVske3R9XSBFdmVudCBOYW1lOiAke3J9XG5cdGRhdGE6ICR7b31gKX0pfWxvZ0lmRGVidWdFbmFibGVkKGUsdCxyKXsoZC5pc0RlYnVnRW5hYmxlZHx8dGhpcy5kZWJ1Zy5lbmFibGVkKSYmdGhpcy5kZWJ1Zy5sb2dnZXIoZSx0aGlzLmRlYnVnLm5hbWUsdCxyKX1vbihlLHQpe2IodCksZT1BcnJheS5pc0FycmF5KGUpP2U6W2VdO2Zvcihjb25zdCByIG9mIGUpcChyKSxtKHRoaXMscikuYWRkKHQpLHRoaXMubG9nSWZEZWJ1Z0VuYWJsZWQoInN1YnNjcmliZSIscix2b2lkIDApLE0ocil8fHRoaXMuZW1pdChjLHtldmVudE5hbWU6cixsaXN0ZW5lcjp0fSk7cmV0dXJuIHRoaXMub2ZmLmJpbmQodGhpcyxlLHQpfW9mZihlLHQpe2IodCksZT1BcnJheS5pc0FycmF5KGUpP2U6W2VdO2Zvcihjb25zdCByIG9mIGUpcChyKSxtKHRoaXMscikuZGVsZXRlKHQpLHRoaXMubG9nSWZEZWJ1Z0VuYWJsZWQoInVuc3Vic2NyaWJlIixyLHZvaWQgMCksTShyKXx8dGhpcy5lbWl0KGYse2V2ZW50TmFtZTpyLGxpc3RlbmVyOnR9KX1vbmNlKGUpe3JldHVybiBuZXcgUHJvbWlzZSgodD0+e2NvbnN0IHI9dGhpcy5vbihlLChlPT57cigpLHQoZSl9KSl9KSl9ZXZlbnRzKGUpe2U9QXJyYXkuaXNBcnJheShlKT9lOltlXTtmb3IoY29uc3QgdCBvZiBlKXAodCk7cmV0dXJuIEQodGhpcyxlKX1hc3luYyBlbWl0KHQsYyl7cCh0KSx0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJlbWl0Iix0LGMpLGZ1bmN0aW9uIEIoZSx0LGEpe2NvbnN0IGM9ci5nZXQoZSk7aWYoYy5oYXModCkpZm9yKGNvbnN0IHIgb2YgYy5nZXQodCkpci5lbnF1ZXVlKGEpO2lmKGMuaGFzKG8pKXtjb25zdCBlPVByb21pc2UuYWxsKFt0LGFdKTtmb3IoY29uc3QgdCBvZiBjLmdldChvKSl0LmVucXVldWUoZSl9fSh0aGlzLHQsYyk7Y29uc3QgZj1tKHRoaXMsdCksaD1lLmdldCh0aGlzKSx1PVsuLi5mXSxnPU0odCk/W106Wy4uLmhdO2F3YWl0IGEsYXdhaXQgUHJvbWlzZS5hbGwoWy4uLnUubWFwKChhc3luYyBlPT57aWYoZi5oYXMoZSkpcmV0dXJuIGUoYyl9KSksLi4uZy5tYXAoKGFzeW5jIGU9PntpZihoLmhhcyhlKSlyZXR1cm4gZSh0LGMpfSkpXSl9YXN5bmMgZW1pdFNlcmlhbCh0LHIpe3AodCksdGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgiZW1pdFNlcmlhbCIsdCxyKTtjb25zdCBvPW0odGhpcyx0KSxjPWUuZ2V0KHRoaXMpLGY9Wy4uLm9dLGg9Wy4uLmNdO2F3YWl0IGE7Zm9yKGNvbnN0IGUgb2YgZilvLmhhcyhlKSYmYXdhaXQgZShyKTtmb3IoY29uc3QgZSBvZiBoKWMuaGFzKGUpJiZhd2FpdCBlKHQscil9b25BbnkodCl7cmV0dXJuIGIodCksdGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgic3Vic2NyaWJlQW55Iix2b2lkIDAsdm9pZCAwKSxlLmdldCh0aGlzKS5hZGQodCksdGhpcy5lbWl0KGMse2xpc3RlbmVyOnR9KSx0aGlzLm9mZkFueS5iaW5kKHRoaXMsdCl9YW55RXZlbnQoKXtyZXR1cm4gRCh0aGlzKX1vZmZBbnkodCl7Yih0KSx0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJ1bnN1YnNjcmliZUFueSIsdm9pZCAwLHZvaWQgMCksdGhpcy5lbWl0KGYse2xpc3RlbmVyOnR9KSxlLmdldCh0aGlzKS5kZWxldGUodCl9Y2xlYXJMaXN0ZW5lcnMobyl7bz1BcnJheS5pc0FycmF5KG8pP286W29dO2Zvcihjb25zdCBhIG9mIG8paWYodGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgiY2xlYXIiLGEsdm9pZCAwKSwic3RyaW5nIj09dHlwZW9mIGF8fCJzeW1ib2wiPT10eXBlb2YgYSl7bSh0aGlzLGEpLmNsZWFyKCk7Y29uc3QgZT1fKHRoaXMsYSk7Zm9yKGNvbnN0IHQgb2YgZSl0LmZpbmlzaCgpO2UuY2xlYXIoKX1lbHNle2UuZ2V0KHRoaXMpLmNsZWFyKCk7Zm9yKGNvbnN0IGUgb2YgdC5nZXQodGhpcykudmFsdWVzKCkpZS5jbGVhcigpO2Zvcihjb25zdCBlIG9mIHIuZ2V0KHRoaXMpLnZhbHVlcygpKXtmb3IoY29uc3QgdCBvZiBlKXQuZmluaXNoKCk7ZS5jbGVhcigpfX19bGlzdGVuZXJDb3VudChvKXtvPUFycmF5LmlzQXJyYXkobyk/bzpbb107bGV0IGE9MDtmb3IoY29uc3QgYyBvZiBvKWlmKCJzdHJpbmciIT10eXBlb2YgYyl7dHlwZW9mIGM8InUiJiZwKGMpLGErPWUuZ2V0KHRoaXMpLnNpemU7Zm9yKGNvbnN0IGUgb2YgdC5nZXQodGhpcykudmFsdWVzKCkpYSs9ZS5zaXplO2Zvcihjb25zdCBlIG9mIHIuZ2V0KHRoaXMpLnZhbHVlcygpKWErPWUuc2l6ZX1lbHNlIGErPWUuZ2V0KHRoaXMpLnNpemUrbSh0aGlzLGMpLnNpemUrXyh0aGlzLGMpLnNpemUrXyh0aGlzKS5zaXplO3JldHVybiBhfWJpbmRNZXRob2RzKGUsdCl7aWYoIm9iamVjdCIhPXR5cGVvZiBlfHxudWxsPT09ZSl0aHJvdyBuZXcgVHlwZUVycm9yKCJgdGFyZ2V0YCBtdXN0IGJlIGFuIG9iamVjdCIpO3Q9JCh0KTtmb3IoY29uc3QgciBvZiB0KXtpZih2b2lkIDAhPT1lW3JdKXRocm93IG5ldyBFcnJvcihgVGhlIHByb3BlcnR5IFxgJHtyfVxgIGFscmVhZHkgZXhpc3RzIG9uIFxgdGFyZ2V0XGBgKTtPYmplY3QuZGVmaW5lUHJvcGVydHkoZSxyLHtlbnVtZXJhYmxlOiExLHZhbHVlOnRoaXNbcl0uYmluZCh0aGlzKX0pfX19Y29uc3QgdT1PYmplY3QuZ2V0T3duUHJvcGVydHlOYW1lcyhkLnByb3RvdHlwZSkuZmlsdGVyKChlPT4iY29uc3RydWN0b3IiIT09ZSkpO09iamVjdC5kZWZpbmVQcm9wZXJ0eShkLCJsaXN0ZW5lckFkZGVkIix7dmFsdWU6Yyx3cml0YWJsZTohMSxlbnVtZXJhYmxlOiEwLGNvbmZpZ3VyYWJsZTohMX0pLE9iamVjdC5kZWZpbmVQcm9wZXJ0eShkLCJsaXN0ZW5lclJlbW92ZWQiLHt2YWx1ZTpmLHdyaXRhYmxlOiExLGVudW1lcmFibGU6ITAsY29uZmlndXJhYmxlOiExfSk7Y29uc3QgZz1qKGQpO2Z1bmN0aW9uIEkoZSl7cmV0dXJuIGZ1bmN0aW9uIEooZSl7aWYoZnVuY3Rpb24gcShlKXtyZXR1cm4ib2JqZWN0Ij09dHlwZW9mIGUmJm51bGwhPT1lJiYibWVzc2FnZSJpbiBlJiYic3RyaW5nIj09dHlwZW9mIGUubWVzc2FnZX0oZSkpcmV0dXJuIGU7dHJ5e3JldHVybiBuZXcgRXJyb3IoSlNPTi5zdHJpbmdpZnkoZSkpfWNhdGNoe3JldHVybiBuZXcgRXJyb3IoU3RyaW5nKGUpKX19KGUpLm1lc3NhZ2V9dmFyIHc9T2JqZWN0LmRlZmluZVByb3BlcnR5LFo9KGUsdCxyKT0+KCgoZSx0LHIpPT57dCBpbiBlP3coZSx0LHtlbnVtZXJhYmxlOiEwLGNvbmZpZ3VyYWJsZTohMCx3cml0YWJsZTohMCx2YWx1ZTpyfSk6ZVt0XT1yfSkoZSwic3ltYm9sIiE9dHlwZW9mIHQ/dCsiIjp0LHIpLHIpO2xldCB2O2NvbnN0IEU9bmV3IFVpbnQ4QXJyYXkoMTYpO2Z1bmN0aW9uIGllKCl7aWYoIXYmJih2PXR5cGVvZiBjcnlwdG88InUiJiZjcnlwdG8uZ2V0UmFuZG9tVmFsdWVzJiZjcnlwdG8uZ2V0UmFuZG9tVmFsdWVzLmJpbmQoY3J5cHRvKSwhdikpdGhyb3cgbmV3IEVycm9yKCJjcnlwdG8uZ2V0UmFuZG9tVmFsdWVzKCkgbm90IHN1cHBvcnRlZC4gU2VlIGh0dHBzOi8vZ2l0aHViLmNvbS91dWlkanMvdXVpZCNnZXRyYW5kb212YWx1ZXMtbm90LXN1cHBvcnRlZCIpO3JldHVybiB2KEUpfWNvbnN0IEE9W107Zm9yKGxldCBSZT0wO1JlPDI1NjsrK1JlKUEucHVzaCgoUmUrMjU2KS50b1N0cmluZygxNikuc2xpY2UoMSkpO2NvbnN0IFQ9e3JhbmRvbVVVSUQ6dHlwZW9mIGNyeXB0bzwidSImJmNyeXB0by5yYW5kb21VVUlEJiZjcnlwdG8ucmFuZG9tVVVJRC5iaW5kKGNyeXB0byl9O2Z1bmN0aW9uIGFlKGUsdCxyKXtpZihULnJhbmRvbVVVSUQmJiF0JiYhZSlyZXR1cm4gVC5yYW5kb21VVUlEKCk7Y29uc3Qgbz0oZT1lfHx7fSkucmFuZG9tfHwoZS5ybmd8fGllKSgpO2lmKG9bNl09MTUmb1s2XXw2NCxvWzhdPTYzJm9bOF18MTI4LHQpe3I9cnx8MDtmb3IobGV0IGU9MDtlPDE2OysrZSl0W3IrZV09b1tlXTtyZXR1cm4gdH1yZXR1cm4gZnVuY3Rpb24gbmUoZSx0PTApe3JldHVybihBW2VbdCswXV0rQVtlW3QrMV1dK0FbZVt0KzJdXStBW2VbdCszXV0rIi0iK0FbZVt0KzRdXStBW2VbdCs1XV0rIi0iK0FbZVt0KzZdXStBW2VbdCs3XV0rIi0iK0FbZVt0KzhdXStBW2VbdCs5XV0rIi0iK0FbZVt0KzEwXV0rQVtlW3QrMTFdXStBW2VbdCsxMl1dK0FbZVt0KzEzXV0rQVtlW3QrMTRdXStBW2VbdCsxNV1dKS50b0xvd2VyQ2FzZSgpfShvKX1mdW5jdGlvbiBGKGUsdCl7Z2xvYmFsVGhpcy52b25hZ2V8fChnbG9iYWxUaGlzLnZvbmFnZT17fSksZ2xvYmFsVGhpcy52b25hZ2Uud29ya2VyaXplcnx8KGdsb2JhbFRoaXMudm9uYWdlLndvcmtlcml6ZXI9e30pO2xldCByPWdsb2JhbFRoaXMudm9uYWdlLndvcmtlcml6ZXI7cmV0dXJuIHJbZV18fChyW2VdPXQpLHJbZV19Y29uc3QgUz1GKCJnbG9iYWxzIix7fSk7dmFyIE49KGU9PihlLklOSVQ9IklOSVQiLGUuRk9SV0FSRD0iRk9SV0FSRCIsZS5URVJNSU5BVEU9IlRFUk1JTkFURSIsZS5HTE9CQUxTX1NZTkM9IkdMT0JBTFNfU1lOQyIsZSkpKE58fHt9KTtmdW5jdGlvbiB6KGUpe3JldHVybltJbWFnZUJpdG1hcCxSZWFkYWJsZVN0cmVhbSxXcml0YWJsZVN0cmVhbV0uc29tZSgodD0+ZSBpbnN0YW5jZW9mIHQpKX1sZXQgTz0wO2Z1bmN0aW9uIGxlKGUsdCxyLG8sYSl7Y29uc3QgYz1PKys7cmV0dXJuIGUucG9zdE1lc3NhZ2Uoe2lkOmMsdHlwZTp0LGZ1bmN0aW9uTmFtZTpyLGFyZ3M6b30sby5maWx0ZXIoKGU9PnooZSkpKSksbmV3IFByb21pc2UoKGU9PntudWxsPT1hfHxhLnNldChjLGUpfSkpfWZ1bmN0aW9uIHkoZSx0KXtjb25zdHtpZDpyLHR5cGU6b309ZSxhPUFycmF5LmlzQXJyYXkodCk/dDpbdF07cG9zdE1lc3NhZ2Uoe2lkOnIsdHlwZTpvLHJlc3VsdDp0fSxhLmZpbHRlcigoZT0+eihlKSkpKX1jb25zdCBrPUYoIndvcmtlcml6ZWQiLHt9KTtmdW5jdGlvbiBWKCl7cmV0dXJuIHR5cGVvZiBXb3JrZXJHbG9iYWxTY29wZTwidSImJnNlbGYgaW5zdGFuY2VvZiBXb3JrZXJHbG9iYWxTY29wZX1mdW5jdGlvbiBQKGUsdCl7aWYoQXJyYXkuaXNBcnJheSh0KSl0LnNwbGljZSgwLHQubGVuZ3RoKTtlbHNlIGlmKCJvYmplY3QiPT10eXBlb2YgdClmb3IoY29uc3QgciBpbiB0KWRlbGV0ZSB0W3JdO2Zvcihjb25zdCByIGluIGUpQXJyYXkuaXNBcnJheShlW3JdKT8odFtyXT1bXSxQKGVbcl0sdFtyXSkpOiJvYmplY3QiPT10eXBlb2YgZVtyXT8odFtyXT17fSxQKGVbcl0sdFtyXSkpOnRbcl09ZVtyXX1jb25zdCBSPUYoInJlZ2lzdGVyZWRXb3JrZXJzIix7fSk7ZnVuY3Rpb24gX2UoZSx0KXtyZXR1cm4gU1tlXXx8KFNbZV09dCksWygpPT5TW2VdLGFzeW5jIHQ9PntTW2VdPXQsYXdhaXQgYXN5bmMgZnVuY3Rpb24gZmUoKXtpZihWKCkpeSh7dHlwZTpOLkdMT0JBTFNfU1lOQ30sUyk7ZWxzZXtjb25zdCBlPVtdO2Zvcihjb25zdCB0IGluIGspe2NvbnN0e3dvcmtlcjpyLHJlc29sdmVyczpvfT1rW3RdLndvcmtlckNvbnRleHQ7ciYmZS5wdXNoKGxlKHIsTi5HTE9CQUxTX1NZTkMsIiIsW1NdLG8pKX1hd2FpdCBQcm9taXNlLmFsbChlKX19KCl9XX1WKCkmJmZ1bmN0aW9uIGdlKCl7Y29uc3QgZT17fTtvbm1lc3NhZ2U9YXN5bmMgdD0+e2NvbnN0IHI9dC5kYXRhO3N3aXRjaChyLnR5cGUpe2Nhc2UgTi5JTklUOiFmdW5jdGlvbiBkZShlLHQpe2lmKCFlLmFyZ3MpdGhyb3ciTWlzc2luZyBjbGFzc05hbWUgd2hpbGUgaW5pdGlhbGl6aW5nIHdvcmtlciI7Y29uc3RbcixvXT1lLmFyZ3MsYT1SW3JdO2lmKCFhKXRocm93YHVua25vd24gd29ya2VyIGNsYXNzICR7cn1gO3QuaW5zdGFuY2U9bmV3IGEoZS5hcmdzLnNsaWNlKDEpKSxQKG8sUykseShlLHZvaWQgMCE9PXR5cGVvZiB0Lmluc3RhbmNlKX0ocixlKTticmVhaztjYXNlIE4uRk9SV0FSRDohYXN5bmMgZnVuY3Rpb24gaGUoZSx0KXtjb25zdHtmdW5jdGlvbk5hbWU6cixhcmdzOm99PWU7aWYoIXQuaW5zdGFuY2UpdGhyb3ciaW5zdGFuY2Ugbm90IGluaXRpYWxpemVkIjtpZighcil0aHJvdyJtaXNzaW5nIGZ1bmN0aW9uIG5hbWUgdG8gY2FsbCI7aWYoIXQuaW5zdGFuY2Vbcl0pdGhyb3dgdW5kZWZpbmVkIGZ1bmN0aW9uIFske3J9XSBpbiBjbGFzcyAke3QuaW5zdGFuY2UuY29uc3RydWN0b3Iud29ya2VySWR9YDt5KGUsYXdhaXQgdC5pbnN0YW5jZVtyXSguLi5vPz9bXSkpfShyLGUpO2JyZWFrO2Nhc2UgTi5URVJNSU5BVEU6IWFzeW5jIGZ1bmN0aW9uIHBlKGUsdCl7Y29uc3R7YXJnczpyfT1lO2lmKCF0Lmluc3RhbmNlKXRocm93Imluc3RhbmNlIG5vdCBpbml0aWFsaXplZCI7bGV0IG87dC5pbnN0YW5jZS50ZXJtaW5hdGUmJihvPWF3YWl0IHQuaW5zdGFuY2UudGVybWluYXRlKC4uLnI/P1tdKSkseShlLG8pfShyLGUpO2JyZWFrO2Nhc2UgTi5HTE9CQUxTX1NZTkM6IWZ1bmN0aW9uIG1lKGUpe2lmKCFlLmFyZ3MpdGhyb3ciTWlzc2luZyBnbG9iYWxzIHdoaWxlIHN5bmNpbmciO1AoZS5hcmdzWzBdLFMpLHkoZSx7fSl9KHIpfX19KCk7Y29uc3RbQyxXXT1mdW5jdGlvbiB5ZShlLHQpe3JldHVybiBfZShlLHQpfSgibWV0YWRhdGEiKTtmdW5jdGlvbiB4KCl7cmV0dXJuIEMoKX1jbGFzcyBMe2NvbnN0cnVjdG9yKGUsdCl7Wih0aGlzLCJ1dWlkIiksdGhpcy5jb25maWc9ZSx0aGlzLnV1aWQ9dD8/YWUoKX1hc3luYyBzZW5kKGUpe3ZhciB0LHIsbztjb25zdHthcHBJZDphLHNvdXJjZVR5cGU6Y309bnVsbCE9KHQ9eCgpKT90Ont9O2lmKCFhfHwhYylyZXR1cm4ibWV0YWRhdGEgbWlzc2luZyI7Y29uc3QgZj1uZXcgQWJvcnRDb250cm9sbGVyLGg9c2V0VGltZW91dCgoKCk9PmYuYWJvcnQoKSksMWU0KTtyZXR1cm4gYXdhaXQobnVsbCE9KG89bnVsbD09KHI9dGhpcy5jb25maWcpP3ZvaWQgMDpyLmZldGNoKT9vOmZldGNoKSh0aGlzLmdldFVybCgpLHttZXRob2Q6IlBPU1QiLGhlYWRlcnM6dGhpcy5nZXRIZWFkZXJzKCksYm9keTpKU09OLnN0cmluZ2lmeSh0aGlzLmJ1aWxkUmVwb3J0KGUpKSxzaWduYWw6Zi5zaWduYWx9KSxjbGVhclRpbWVvdXQoaCksInN1Y2Nlc3MifWdldFVybCgpe3ZhciBlO2xldCB0PW51bGwhPShlPXgoKS5wcm94eVVybCk/ZToiaHR0cHM6Ly8iO3JldHVybiB0Kz0oIi8iPT09dC5hdCgtMSk/IiI6Ii8iKSsiaGxnLnRva2JveC5jb20vcHJvZC9sb2dnaW5nL3ZjcF93ZWJydGMiLHR9Z2V0SGVhZGVycygpe3JldHVybnsiQ29udGVudC1UeXBlIjoiYXBwbGljYXRpb24vanNvbiJ9fWJ1aWxkUmVwb3J0KGUpe2NvbnN0IHQ9eCgpO3JldHVybntndWlkOnRoaXMudXVpZCwuLi5lLGFwcGxpY2F0aW9uSWQ6dC5hcHBJZCx0aW1lc3RhbXA6RGF0ZS5ub3coKSxwcm94eVVybDp0LnByb3h5VXJsLHNvdXJjZTp0LnNvdXJjZVR5cGV9fX1jb25zdCBVPSIyLjAuNCI7Y2xhc3MgVGV7Y29uc3RydWN0b3IoZSx0KXt0aGlzLmNvbmZpZz1lLHRoaXMuZnJhbWVUcmFuc2Zvcm1lZENvdW50PTAsdGhpcy5mcmFtZUZyb21Tb3VyY2VDb3VudD0wLHRoaXMuc3RhcnRBdD0wLHRoaXMucmVwb3J0ZXI9bmV3IEwoZSx0KX1hc3luYyBvbkZyYW1lRnJvbVNvdXJjZSgpe3RoaXMuZnJhbWVGcm9tU291cmNlQ291bnQrK31nZXQgZnBzKCl7Y29uc3R7c3RhcnRBdDplLGZyYW1lRnJvbVNvdXJjZUNvdW50OnR9PXRoaXM7cmV0dXJuIHQvKChEYXRlLm5vdygpLWUpLzFlMyl9YXN5bmMgb25GcmFtZVRyYW5zZm9ybWVkKGU9e30sdD0hMSl7MD09PXRoaXMuc3RhcnRBdCYmKHRoaXMuc3RhcnRBdD1EYXRlLm5vdygpKSx0aGlzLmZyYW1lVHJhbnNmb3JtZWRDb3VudCsrO2NvbnN0e3N0YXJ0QXQ6cixmcmFtZVRyYW5zZm9ybWVkQ291bnQ6byxmcmFtZUZyb21Tb3VyY2VDb3VudDphfT10aGlzLGM9RGF0ZS5ub3coKSxmPShjLXIpLzFlMyxoPW8vZix1PWEvZjtyZXR1cm4gdHx8dGhpcy5mcmFtZVRyYW5zZm9ybWVkQ291bnQ+PXRoaXMuY29uZmlnLmxvZ2dpbmdJbnRlcnZhbEZyYW1lQ291bnQ/KHRoaXMuZnJhbWVGcm9tU291cmNlQ291bnQ9MCx0aGlzLmZyYW1lVHJhbnNmb3JtZWRDb3VudD0wLHRoaXMuc3RhcnRBdD1jLHRoaXMucmVwb3J0ZXIuY29uZmlnPXRoaXMuY29uZmlnLHRoaXMucmVwb3J0ZXIuc2VuZCh7Li4udGhpcy5jb25maWcucmVwb3J0LHZhcmlhdGlvbjoiUW9TIixmcHM6dSx0cmFuc2Zvcm1lZEZwczpoLGZyYW1lc1RyYW5zZm9ybWVkOm8sLi4uZX0pKToic3VjY2VzcyJ9fXZhciBHPShlPT4oZS5waXBlbGluZV9lbmRlZD0icGlwZWxpbmVfZW5kZWQiLGUucGlwZWxpbmVfZW5kZWRfd2l0aF9lcnJvcj0icGlwZWxpbmVfZW5kZWRfd2l0aF9lcnJvciIsZS5waXBlbGluZV9zdGFydGVkPSJwaXBlbGluZV9zdGFydGVkIixlLnBpcGVsaW5lX3N0YXJ0ZWRfd2l0aF9lcnJvcj0icGlwZWxpbmVfc3RhcnRlZF93aXRoX2Vycm9yIixlLnBpcGVsaW5lX3Jlc3RhcnRlZD0icGlwZWxpbmVfcmVzdGFydGVkIixlLnBpcGVsaW5lX3Jlc3RhcnRlZF93aXRoX2Vycm9yPSJwaXBlbGluZV9yZXN0YXJ0ZWRfd2l0aF9lcnJvciIsZSkpKEd8fHt9KTtjbGFzcyBrZSBleHRlbmRzIGd7Y29uc3RydWN0b3IoZSx0KXtzdXBlcigpLHRoaXMucmVwb3J0ZXJfPW5ldyBMLHRoaXMucmVwb3J0ZXJRb3NfPW5ldyBUZSh7bG9nZ2luZ0ludGVydmFsRnJhbWVDb3VudDo1MDAscmVwb3J0Ont2ZXJzaW9uOlV9fSksdGhpcy5pbmRleF89dCx0aGlzLnRyYW5zZm9ybWVyXz1lLHRoaXMuc2hvdWxkU3RvcF89ITEsdGhpcy5pc0ZsYXNoZWRfPSExLHRoaXMubWVkaWFUcmFuc2Zvcm1lclFvc1JlcG9ydFN0YXJ0VGltZXN0YW1wXz0wLHRoaXMudmlkZW9IZWlnaHRfPTAsdGhpcy52aWRlb1dpZHRoXz0wLHRoaXMudHJhY2tFeHBlY3RlZFJhdGVfPS0xLHRoaXMudHJhbnNmb3JtZXJUeXBlXz0iQ3VzdG9tIiwiZ2V0VHJhbnNmb3JtZXJUeXBlImluIGUmJih0aGlzLnRyYW5zZm9ybWVyVHlwZV89ZS5nZXRUcmFuc2Zvcm1lclR5cGUoKSksdGhpcy5yZXBvcnQoe3ZhcmlhdGlvbjoiQ3JlYXRlIn0pfXNldFRyYWNrRXhwZWN0ZWRSYXRlKGUpe3RoaXMudHJhY2tFeHBlY3RlZFJhdGVfPWV9YXN5bmMgc3RhcnQoZSl7aWYodGhpcy5jb250cm9sbGVyXz1lLHRoaXMudHJhbnNmb3JtZXJfJiYiZnVuY3Rpb24iPT10eXBlb2YgdGhpcy50cmFuc2Zvcm1lcl8uc3RhcnQpdHJ5e2F3YWl0IHRoaXMudHJhbnNmb3JtZXJfLnN0YXJ0KGUpfWNhdGNoKHQpe3RoaXMucmVwb3J0KHttZXNzYWdlOmwuZXJyb3JzLnRyYW5zZm9ybWVyX3N0YXJ0LHZhcmlhdGlvbjoiRXJyb3IiLGVycm9yOkkodCl9KTtjb25zdCBlPXtldmVudE1ldGFEYXRhOnt0cmFuc2Zvcm1lckluZGV4OnRoaXMuaW5kZXhffSxlcnJvcjp0LGZ1bmN0aW9uOiJzdGFydCJ9O3RoaXMuZW1pdCgiZXJyb3IiLGUpfX1hc3luYyB0cmFuc2Zvcm0oZSx0KXt2YXIgcixvO2lmKDA9PT10aGlzLm1lZGlhVHJhbnNmb3JtZXJRb3NSZXBvcnRTdGFydFRpbWVzdGFtcF8mJih0aGlzLm1lZGlhVHJhbnNmb3JtZXJRb3NSZXBvcnRTdGFydFRpbWVzdGFtcF89RGF0ZS5ub3coKSksZSBpbnN0YW5jZW9mIFZpZGVvRnJhbWUmJih0aGlzLnZpZGVvSGVpZ2h0Xz0obnVsbD09ZT92b2lkIDA6ZS5kaXNwbGF5SGVpZ2h0KT8/MCx0aGlzLnZpZGVvV2lkdGhfPShudWxsPT1lP3ZvaWQgMDplLmRpc3BsYXlXaWR0aCk/PzApLHRoaXMucmVwb3J0ZXJRb3NfLm9uRnJhbWVGcm9tU291cmNlKCksdGhpcy50cmFuc2Zvcm1lcl8paWYodGhpcy5zaG91bGRTdG9wXyljb25zb2xlLndhcm4oIltQaXBlbGluZV0gZmx1c2ggZnJvbSB0cmFuc2Zvcm0iKSxlLmNsb3NlKCksdGhpcy5mbHVzaCh0KSx0LnRlcm1pbmF0ZSgpO2Vsc2V7dHJ5e2F3YWl0KG51bGw9PShvPShyPXRoaXMudHJhbnNmb3JtZXJfKS50cmFuc2Zvcm0pP3ZvaWQgMDpvLmNhbGwocixlLHQpKSx0aGlzLnJlcG9ydFFvcygpfWNhdGNoKGEpe3RoaXMucmVwb3J0KHttZXNzYWdlOmwuZXJyb3JzLnRyYW5zZm9ybWVyX3RyYW5zZm9ybSx2YXJpYXRpb246IkVycm9yIixlcnJvcjpJKGEpfSk7Y29uc3QgZT17ZXZlbnRNZXRhRGF0YTp7dHJhbnNmb3JtZXJJbmRleDp0aGlzLmluZGV4X30sZXJyb3I6YSxmdW5jdGlvbjoidHJhbnNmb3JtIn07dGhpcy5lbWl0KCJlcnJvciIsZSl9aWYoLTEhPXRoaXMudHJhY2tFeHBlY3RlZFJhdGVfJiYuOCp0aGlzLnRyYWNrRXhwZWN0ZWRSYXRlXz50aGlzLnJlcG9ydGVyUW9zXy5mcHMpe2NvbnN0IGU9e2V2ZW50TWV0YURhdGE6e3RyYW5zZm9ybWVySW5kZXg6dGhpcy5pbmRleF99LHdhcm5pbmdUeXBlOiJmcHNfZHJvcCIsZHJvcEluZm86e3JlcXVlc3RlZDp0aGlzLnRyYWNrRXhwZWN0ZWRSYXRlXyxjdXJyZW50OnRoaXMucmVwb3J0ZXJRb3NfLmZwc319O3RoaXMuZW1pdCgid2FybiIsZSl9fX1hc3luYyBmbHVzaChlKXtpZih0aGlzLnRyYW5zZm9ybWVyXyYmImZ1bmN0aW9uIj09dHlwZW9mIHRoaXMudHJhbnNmb3JtZXJfLmZsdXNoJiYhdGhpcy5pc0ZsYXNoZWRfKXt0aGlzLmlzRmxhc2hlZF89ITA7dHJ5e2F3YWl0IHRoaXMudHJhbnNmb3JtZXJfLmZsdXNoKGUpfWNhdGNoKHQpe3RoaXMucmVwb3J0KHttZXNzYWdlOmwuZXJyb3JzLnRyYW5zZm9ybWVyX2ZsdXNoLHZhcmlhdGlvbjoiRXJyb3IiLGVycm9yOkkodCl9KTtjb25zdCBlPXtldmVudE1ldGFEYXRhOnt0cmFuc2Zvcm1lckluZGV4OnRoaXMuaW5kZXhffSxlcnJvcjp0LGZ1bmN0aW9uOiJmbHVzaCJ9O3RoaXMuZW1pdCgiZXJyb3IiLGUpfX10aGlzLnJlcG9ydFFvcyghMCksdGhpcy5yZXBvcnQoe3ZhcmlhdGlvbjoiRGVsZXRlIn0pfXN0b3AoKXtjb25zb2xlLmxvZygiW1BpcGVsaW5lXSBTdG9wIHN0cmVhbS4iKSx0aGlzLmNvbnRyb2xsZXJfJiYodGhpcy5mbHVzaCh0aGlzLmNvbnRyb2xsZXJfKSx0aGlzLmNvbnRyb2xsZXJfLnRlcm1pbmF0ZSgpKSx0aGlzLnNob3VsZFN0b3BfPSEwfXJlcG9ydChlKXt0aGlzLnJlcG9ydGVyXy5zZW5kKHt2ZXJzaW9uOlUsYWN0aW9uOiJNZWRpYVRyYW5zZm9ybWVyIix0cmFuc2Zvcm1lclR5cGU6dGhpcy50cmFuc2Zvcm1lclR5cGVfLC4uLmV9KX1yZXBvcnRRb3MoZT0hMSl7dGhpcy5yZXBvcnRlclFvc18uY29uZmlnPXsuLi50aGlzLnJlcG9ydGVyUW9zXy5jb25maWd9LHRoaXMucmVwb3J0ZXJRb3NfLm9uRnJhbWVUcmFuc2Zvcm1lZCh7dmVyc2lvbjpVLGFjdGlvbjoiTWVkaWFUcmFuc2Zvcm1lciIsdHJhbnNmb3JtZXJUeXBlOnRoaXMudHJhbnNmb3JtZXJUeXBlXyx2aWRlb1dpZHRoOnRoaXMudmlkZW9XaWR0aF8sdmlkZW9IZWlnaHQ6dGhpcy52aWRlb0hlaWdodF99LGUpfX1jbGFzcyBBZSBleHRlbmRzIGd7Y29uc3RydWN0b3IoZSl7c3VwZXIoKSx0aGlzLnRyYW5zZm9ybWVyc189W10sdGhpcy50cmFja0V4cGVjdGVkUmF0ZV89LTE7Zm9yKGxldCB0PTA7dDxlLmxlbmd0aDt0Kyspe2xldCByPW5ldyBrZShlW3RdLHQpO3Iub24oImVycm9yIiwoZT0+e3RoaXMuZW1pdCgiZXJyb3IiLGUpfSkpLHIub24oIndhcm4iLChlPT57dGhpcy5lbWl0KCJ3YXJuIixlKX0pKSx0aGlzLnRyYW5zZm9ybWVyc18ucHVzaChyKX19c2V0VHJhY2tFeHBlY3RlZFJhdGUoZSl7dGhpcy50cmFja0V4cGVjdGVkUmF0ZV89ZTtmb3IobGV0IHQgb2YgdGhpcy50cmFuc2Zvcm1lcnNfKXQuc2V0VHJhY2tFeHBlY3RlZFJhdGUodGhpcy50cmFja0V4cGVjdGVkUmF0ZV8pfWFzeW5jIHN0YXJ0KGUsdCl7aWYodGhpcy50cmFuc2Zvcm1lcnNfJiYwIT09dGhpcy50cmFuc2Zvcm1lcnNfLmxlbmd0aCl7dHJ5e2xldCByPWU7Zm9yKGxldCB0IG9mIHRoaXMudHJhbnNmb3JtZXJzXyllPWUucGlwZVRocm91Z2gobmV3IFRyYW5zZm9ybVN0cmVhbSh0KSk7ZS5waXBlVG8odCkudGhlbigoYXN5bmMoKT0+e2NvbnNvbGUubG9nKCJbUGlwZWxpbmVdIFNldHVwLiIpLGF3YWl0IHQuYWJvcnQoKSxhd2FpdCByLmNhbmNlbCgpLHRoaXMuZW1pdCgicGlwZWxpbmVJbmZvIiwicGlwZWxpbmVfZW5kZWQiKX0pKS5jYXRjaCgoYXN5bmMgbz0+e2UuY2FuY2VsKCkudGhlbigoKCk9Pntjb25zb2xlLmxvZygiW1BpcGVsaW5lXSBTaHV0dGluZyBkb3duIHN0cmVhbXMgYWZ0ZXIgYWJvcnQuIil9KSkuY2F0Y2goKGU9Pntjb25zb2xlLmVycm9yKCJbUGlwZWxpbmVdIEVycm9yIGZyb20gc3RyZWFtIHRyYW5zZm9ybToiLGUpfSkpLGF3YWl0IHQuYWJvcnQobyksYXdhaXQgci5jYW5jZWwobyksdGhpcy5lbWl0KCJwaXBlbGluZUluZm8iLCJwaXBlbGluZV9lbmRlZF93aXRoX2Vycm9yIil9KSl9Y2F0Y2h7cmV0dXJuIHRoaXMuZW1pdCgicGlwZWxpbmVJbmZvIiwicGlwZWxpbmVfc3RhcnRlZF93aXRoX2Vycm9yIiksdm9pZCB0aGlzLmRlc3Ryb3koKX10aGlzLmVtaXQoInBpcGVsaW5lSW5mbyIsInBpcGVsaW5lX3N0YXJ0ZWQiKSxjb25zb2xlLmxvZygiW1BpcGVsaW5lXSBQaXBlbGluZSBzdGFydGVkLiIpfWVsc2UgY29uc29sZS5sb2coIltQaXBlbGluZV0gTm8gdHJhbnNmb3JtZXJzLiIpfWFzeW5jIGRlc3Ryb3koKXtjb25zb2xlLmxvZygiW1BpcGVsaW5lXSBEZXN0cm95aW5nIFBpcGVsaW5lLiIpO2ZvcihsZXQgZSBvZiB0aGlzLnRyYW5zZm9ybWVyc18pZS5zdG9wKCl9fWNsYXNzIENlIGV4dGVuZHMgZ3tjb25zdHJ1Y3Rvcigpe3N1cGVyKCksdGhpcy5yZXBvcnRlcl89bmV3IEwsdGhpcy50cmFja0V4cGVjdGVkUmF0ZV89LTEsdGhpcy5yZXBvcnQoe3ZhcmlhdGlvbjoiQ3JlYXRlIn0pfXNldFRyYWNrRXhwZWN0ZWRSYXRlKGUpe3RoaXMudHJhY2tFeHBlY3RlZFJhdGVfPWUsdGhpcy5waXBlbGluZV8mJnRoaXMucGlwZWxpbmVfLnNldFRyYWNrRXhwZWN0ZWRSYXRlKHRoaXMudHJhY2tFeHBlY3RlZFJhdGVfKX10cmFuc2Zvcm0oZSx0KXtyZXR1cm4gdGhpcy5yZWFkYWJsZV89ZSx0aGlzLndyaXRhYmxlXz10LHRoaXMudHJhbnNmb3JtSW50ZXJuYWwoKX10cmFuc2Zvcm1JbnRlcm5hbCgpe3JldHVybiBuZXcgUHJvbWlzZSgoYXN5bmMoZSx0KT0+e2lmKCF0aGlzLnRyYW5zZm9ybWVyc198fDA9PT10aGlzLnRyYW5zZm9ybWVyc18ubGVuZ3RoKXJldHVybiB0aGlzLnJlcG9ydCh7bWVzc2FnZTpsLmVycm9ycy50cmFuc2Zvcm1lcl9ub25lLHZhcmlhdGlvbjoiRXJyb3IifSksdm9pZCB0KCJbTWVkaWFQcm9jZXNzb3JdIE5lZWQgdG8gc2V0IHRyYW5zZm9ybWVycy4iKTtpZighdGhpcy5yZWFkYWJsZV8pcmV0dXJuIHRoaXMucmVwb3J0KHt2YXJpYXRpb246IkVycm9yIixtZXNzYWdlOmwuZXJyb3JzLnJlYWRhYmxlX251bGx9KSx2b2lkIHQoIltNZWRpYVByb2Nlc3Nvcl0gUmVhZGFibGUgaXMgbnVsbC4iKTtpZighdGhpcy53cml0YWJsZV8pcmV0dXJuIHRoaXMucmVwb3J0KHt2YXJpYXRpb246IkVycm9yIixtZXNzYWdlOmwuZXJyb3JzLndyaXRhYmxlX251bGx9KSx2b2lkIHQoIltNZWRpYVByb2Nlc3Nvcl0gV3JpdGFibGUgaXMgbnVsbC4iKTtsZXQgcj0hMTt0aGlzLnBpcGVsaW5lXyYmKHI9ITAsdGhpcy5waXBlbGluZV8uY2xlYXJMaXN0ZW5lcnMoKSx0aGlzLnBpcGVsaW5lXy5kZXN0cm95KCkpLHRoaXMucGlwZWxpbmVfPW5ldyBBZSh0aGlzLnRyYW5zZm9ybWVyc18pLHRoaXMucGlwZWxpbmVfLm9uKCJ3YXJuIiwoZT0+e3RoaXMuZW1pdCgid2FybiIsZSl9KSksdGhpcy5waXBlbGluZV8ub24oImVycm9yIiwoZT0+e3RoaXMuZW1pdCgiZXJyb3IiLGUpfSkpLHRoaXMucGlwZWxpbmVfLm9uKCJwaXBlbGluZUluZm8iLChlPT57ciYmKCJwaXBlbGluZV9zdGFydGVkIj09PWU/ZT1HLnBpcGVsaW5lX3Jlc3RhcnRlZDoicGlwZWxpbmVfc3RhcnRlZF93aXRoX2Vycm9yIj09PWUmJihlPUcucGlwZWxpbmVfcmVzdGFydGVkX3dpdGhfZXJyb3IpKSx0aGlzLmVtaXQoInBpcGVsaW5lSW5mbyIsZSl9KSksLTEhPXRoaXMudHJhY2tFeHBlY3RlZFJhdGVfJiZ0aGlzLnBpcGVsaW5lXy5zZXRUcmFja0V4cGVjdGVkUmF0ZSh0aGlzLnRyYWNrRXhwZWN0ZWRSYXRlXyksdGhpcy5waXBlbGluZV8uc3RhcnQodGhpcy5yZWFkYWJsZV8sdGhpcy53cml0YWJsZV8pLnRoZW4oKCgpPT57ZSgpfSkpLmNhdGNoKChlPT57dChlKX0pKX0pKX1zZXRUcmFuc2Zvcm1lcnMoZSl7cmV0dXJuIHRoaXMucmVwb3J0KHt2YXJpYXRpb246IlVwZGF0ZSIsbWVzc2FnZTpsLnVwZGF0ZXMudHJhbnNmb3JtZXJfbmV3fSksdGhpcy50cmFuc2Zvcm1lcnNfPWUsdGhpcy5yZWFkYWJsZV8mJnRoaXMud3JpdGFibGVfP3RoaXMudHJhbnNmb3JtSW50ZXJuYWwoKTpQcm9taXNlLnJlc29sdmUoKX1kZXN0cm95KCl7cmV0dXJuIG5ldyBQcm9taXNlKChhc3luYyBlPT57dGhpcy5waXBlbGluZV8mJnRoaXMucGlwZWxpbmVfLmRlc3Ryb3koKSx0aGlzLnJlcG9ydCh7dmFyaWF0aW9uOiJEZWxldGUifSksZSgpfSkpfXJlcG9ydChlKXt0aGlzLnJlcG9ydGVyXy5zZW5kKHt2ZXJzaW9uOlUsYWN0aW9uOiJNZWRpYVByb2Nlc3NvciIsLi4uZX0pfX1jb25zdCBRPW5ldyBXZWFrTWFwLEg9bmV3IFdlYWtNYXAsWT1uZXcgV2Vha01hcCxLPVN5bWJvbCgiYW55UHJvZHVjZXIiKSxYPVByb21pc2UucmVzb2x2ZSgpLGVlPVN5bWJvbCgibGlzdGVuZXJBZGRlZCIpLHRlPVN5bWJvbCgibGlzdGVuZXJSZW1vdmVkIik7bGV0IHJlPSExLHNlPSExO2Z1bmN0aW9uIGFzc2VydEV2ZW50TmFtZSQxKGUpe2lmKCJzdHJpbmciIT10eXBlb2YgZSYmInN5bWJvbCIhPXR5cGVvZiBlJiYibnVtYmVyIiE9dHlwZW9mIGUpdGhyb3cgbmV3IFR5cGVFcnJvcigiYGV2ZW50TmFtZWAgbXVzdCBiZSBhIHN0cmluZywgc3ltYm9sLCBvciBudW1iZXIiKX1mdW5jdGlvbiBhc3NlcnRMaXN0ZW5lciQxKGUpe2lmKCJmdW5jdGlvbiIhPXR5cGVvZiBlKXRocm93IG5ldyBUeXBlRXJyb3IoImxpc3RlbmVyIG11c3QgYmUgYSBmdW5jdGlvbiIpfWZ1bmN0aW9uIGdldExpc3RlbmVycyQxKGUsdCl7Y29uc3Qgcj1ILmdldChlKTtpZihyLmhhcyh0KSlyZXR1cm4gci5nZXQodCl9ZnVuY3Rpb24gZ2V0RXZlbnRQcm9kdWNlcnMkMShlLHQpe2NvbnN0IHI9InN0cmluZyI9PXR5cGVvZiB0fHwic3ltYm9sIj09dHlwZW9mIHR8fCJudW1iZXIiPT10eXBlb2YgdD90Okssbz1ZLmdldChlKTtpZihvLmhhcyhyKSlyZXR1cm4gby5nZXQocil9ZnVuY3Rpb24gaXRlcmF0b3IkMShlLHQpe3Q9QXJyYXkuaXNBcnJheSh0KT90Olt0XTtsZXQgcj0hMSxmbHVzaD0oKT0+e30sbz1bXTtjb25zdCBhPXtlbnF1ZXVlKGUpe28ucHVzaChlKSxmbHVzaCgpfSxmaW5pc2goKXtyPSEwLGZsdXNoKCl9fTtmb3IoY29uc3QgYyBvZiB0KXtsZXQgdD1nZXRFdmVudFByb2R1Y2VycyQxKGUsYyk7aWYoIXQpe3Q9bmV3IFNldDtZLmdldChlKS5zZXQoYyx0KX10LmFkZChhKX1yZXR1cm57YXN5bmMgbmV4dCgpe3JldHVybiBvPzA9PT1vLmxlbmd0aD9yPyhvPXZvaWQgMCx0aGlzLm5leHQoKSk6KGF3YWl0IG5ldyBQcm9taXNlKChlPT57Zmx1c2g9ZX0pKSx0aGlzLm5leHQoKSk6e2RvbmU6ITEsdmFsdWU6YXdhaXQgby5zaGlmdCgpfTp7ZG9uZTohMH19LGFzeW5jIHJldHVybihyKXtvPXZvaWQgMDtmb3IoY29uc3QgbyBvZiB0KXtjb25zdCB0PWdldEV2ZW50UHJvZHVjZXJzJDEoZSxvKTtpZih0JiYodC5kZWxldGUoYSksMD09PXQuc2l6ZSkpe1kuZ2V0KGUpLmRlbGV0ZShvKX19cmV0dXJuIGZsdXNoKCksYXJndW1lbnRzLmxlbmd0aD4wP3tkb25lOiEwLHZhbHVlOmF3YWl0IHJ9Ontkb25lOiEwfX0sW1N5bWJvbC5hc3luY0l0ZXJhdG9yXSgpe3JldHVybiB0aGlzfX19ZnVuY3Rpb24gZGVmYXVsdE1ldGhvZE5hbWVzT3JBc3NlcnQkMShlKXtpZih2b2lkIDA9PT1lKXJldHVybiBjZTtpZighQXJyYXkuaXNBcnJheShlKSl0aHJvdyBuZXcgVHlwZUVycm9yKCJgbWV0aG9kTmFtZXNgIG11c3QgYmUgYW4gYXJyYXkgb2Ygc3RyaW5ncyIpO2Zvcihjb25zdCB0IG9mIGUpaWYoIWNlLmluY2x1ZGVzKHQpKXtpZigic3RyaW5nIiE9dHlwZW9mIHQpdGhyb3cgbmV3IFR5cGVFcnJvcigiYG1ldGhvZE5hbWVzYCBlbGVtZW50IG11c3QgYmUgYSBzdHJpbmciKTt0aHJvdyBuZXcgRXJyb3IoYCR7dH0gaXMgbm90IEVtaXR0ZXJ5IG1ldGhvZGApfXJldHVybiBlfWNvbnN0IGlzTWV0YUV2ZW50JDE9ZT0+ZT09PWVlfHxlPT09dGU7ZnVuY3Rpb24gZW1pdE1ldGFFdmVudCQxKGUsdCxyKXtpZihpc01ldGFFdmVudCQxKHQpKXRyeXtyZT0hMCxlLmVtaXQodCxyKX1maW5hbGx5e3JlPSExfX1sZXQgb2U9Y2xhc3MgRW1pdHRlcnkye3N0YXRpYyBtaXhpbihlLHQpe3JldHVybiB0PWRlZmF1bHRNZXRob2ROYW1lc09yQXNzZXJ0JDEodCkscj0+e2lmKCJmdW5jdGlvbiIhPXR5cGVvZiByKXRocm93IG5ldyBUeXBlRXJyb3IoImB0YXJnZXRgIG11c3QgYmUgZnVuY3Rpb24iKTtmb3IoY29uc3QgZSBvZiB0KWlmKHZvaWQgMCE9PXIucHJvdG90eXBlW2VdKXRocm93IG5ldyBFcnJvcihgVGhlIHByb3BlcnR5IFxgJHtlfVxgIGFscmVhZHkgZXhpc3RzIG9uIFxgdGFyZ2V0XGBgKTtPYmplY3QuZGVmaW5lUHJvcGVydHkoci5wcm90b3R5cGUsZSx7ZW51bWVyYWJsZTohMSxnZXQ6ZnVuY3Rpb24gZ2V0RW1pdHRlcnlQcm9wZXJ0eSgpe3JldHVybiBPYmplY3QuZGVmaW5lUHJvcGVydHkodGhpcyxlLHtlbnVtZXJhYmxlOiExLHZhbHVlOm5ldyBFbWl0dGVyeTJ9KSx0aGlzW2VdfX0pO2NvbnN0IGVtaXR0ZXJ5TWV0aG9kQ2FsbGVyPXQ9PmZ1bmN0aW9uKC4uLnIpe3JldHVybiB0aGlzW2VdW3RdKC4uLnIpfTtmb3IoY29uc3QgZSBvZiB0KU9iamVjdC5kZWZpbmVQcm9wZXJ0eShyLnByb3RvdHlwZSxlLHtlbnVtZXJhYmxlOiExLHZhbHVlOmVtaXR0ZXJ5TWV0aG9kQ2FsbGVyKGUpfSk7cmV0dXJuIHJ9fXN0YXRpYyBnZXQgaXNEZWJ1Z0VuYWJsZWQoKXtpZigib2JqZWN0IiE9dHlwZW9mIGdsb2JhbFRoaXMucHJvY2Vzcz8uZW52KXJldHVybiBzZTtjb25zdHtlbnY6ZX09Z2xvYmFsVGhpcy5wcm9jZXNzPz97ZW52Ont9fTtyZXR1cm4iZW1pdHRlcnkiPT09ZS5ERUJVR3x8IioiPT09ZS5ERUJVR3x8c2V9c3RhdGljIHNldCBpc0RlYnVnRW5hYmxlZChlKXtzZT1lfWNvbnN0cnVjdG9yKGU9e30pe1Euc2V0KHRoaXMsbmV3IFNldCksSC5zZXQodGhpcyxuZXcgTWFwKSxZLnNldCh0aGlzLG5ldyBNYXApLFkuZ2V0KHRoaXMpLnNldChLLG5ldyBTZXQpLHRoaXMuZGVidWc9ZS5kZWJ1Zz8/e30sdm9pZCAwPT09dGhpcy5kZWJ1Zy5lbmFibGVkJiYodGhpcy5kZWJ1Zy5lbmFibGVkPSExKSx0aGlzLmRlYnVnLmxvZ2dlcnx8KHRoaXMuZGVidWcubG9nZ2VyPShlLHQscixvKT0+e3RyeXtvPUpTT04uc3RyaW5naWZ5KG8pfWNhdGNoe289YE9iamVjdCB3aXRoIHRoZSBmb2xsb3dpbmcga2V5cyBmYWlsZWQgdG8gc3RyaW5naWZ5OiAke09iamVjdC5rZXlzKG8pLmpvaW4oIiwiKX1gfSJzeW1ib2wiIT10eXBlb2YgciYmIm51bWJlciIhPXR5cGVvZiByfHwocj1yLnRvU3RyaW5nKCkpO2NvbnN0IGE9bmV3IERhdGUsYz1gJHthLmdldEhvdXJzKCl9OiR7YS5nZXRNaW51dGVzKCl9OiR7YS5nZXRTZWNvbmRzKCl9LiR7YS5nZXRNaWxsaXNlY29uZHMoKX1gO2NvbnNvbGUubG9nKGBbJHtjfV1bZW1pdHRlcnk6JHtlfV1bJHt0fV0gRXZlbnQgTmFtZTogJHtyfVxuXHRkYXRhOiAke299YCl9KX1sb2dJZkRlYnVnRW5hYmxlZChlLHQscil7KEVtaXR0ZXJ5Mi5pc0RlYnVnRW5hYmxlZHx8dGhpcy5kZWJ1Zy5lbmFibGVkKSYmdGhpcy5kZWJ1Zy5sb2dnZXIoZSx0aGlzLmRlYnVnLm5hbWUsdCxyKX1vbihlLHQpe2Fzc2VydExpc3RlbmVyJDEodCksZT1BcnJheS5pc0FycmF5KGUpP2U6W2VdO2Zvcihjb25zdCByIG9mIGUpe2Fzc2VydEV2ZW50TmFtZSQxKHIpO2xldCBlPWdldExpc3RlbmVycyQxKHRoaXMscik7aWYoIWUpe2U9bmV3IFNldDtILmdldCh0aGlzKS5zZXQocixlKX1lLmFkZCh0KSx0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJzdWJzY3JpYmUiLHIsdm9pZCAwKSxpc01ldGFFdmVudCQxKHIpfHxlbWl0TWV0YUV2ZW50JDEodGhpcyxlZSx7ZXZlbnROYW1lOnIsbGlzdGVuZXI6dH0pfXJldHVybiB0aGlzLm9mZi5iaW5kKHRoaXMsZSx0KX1vZmYoZSx0KXthc3NlcnRMaXN0ZW5lciQxKHQpLGU9QXJyYXkuaXNBcnJheShlKT9lOltlXTtmb3IoY29uc3QgciBvZiBlKXthc3NlcnRFdmVudE5hbWUkMShyKTtjb25zdCBlPWdldExpc3RlbmVycyQxKHRoaXMscik7aWYoZSYmKGUuZGVsZXRlKHQpLDA9PT1lLnNpemUpKXtILmdldCh0aGlzKS5kZWxldGUocil9dGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgidW5zdWJzY3JpYmUiLHIsdm9pZCAwKSxpc01ldGFFdmVudCQxKHIpfHxlbWl0TWV0YUV2ZW50JDEodGhpcyx0ZSx7ZXZlbnROYW1lOnIsbGlzdGVuZXI6dH0pfX1vbmNlKGUpe2xldCB0O2NvbnN0IHI9bmV3IFByb21pc2UoKHI9Pnt0PXRoaXMub24oZSwoZT0+e3QoKSxyKGUpfSkpfSkpO3JldHVybiByLm9mZj10LHJ9ZXZlbnRzKGUpe2U9QXJyYXkuaXNBcnJheShlKT9lOltlXTtmb3IoY29uc3QgdCBvZiBlKWFzc2VydEV2ZW50TmFtZSQxKHQpO3JldHVybiBpdGVyYXRvciQxKHRoaXMsZSl9YXN5bmMgZW1pdChlLHQpe2lmKGFzc2VydEV2ZW50TmFtZSQxKGUpLGlzTWV0YUV2ZW50JDEoZSkmJiFyZSl0aHJvdyBuZXcgVHlwZUVycm9yKCJgZXZlbnROYW1lYCBjYW5ub3QgYmUgbWV0YSBldmVudCBgbGlzdGVuZXJBZGRlZGAgb3IgYGxpc3RlbmVyUmVtb3ZlZGAiKTt0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJlbWl0IixlLHQpLGZ1bmN0aW9uIGVucXVldWVQcm9kdWNlcnMkMShlLHQscil7Y29uc3Qgbz1ZLmdldChlKTtpZihvLmhhcyh0KSlmb3IoY29uc3QgYSBvZiBvLmdldCh0KSlhLmVucXVldWUocik7aWYoby5oYXMoSykpe2NvbnN0IGU9UHJvbWlzZS5hbGwoW3Qscl0pO2Zvcihjb25zdCB0IG9mIG8uZ2V0KEspKXQuZW5xdWV1ZShlKX19KHRoaXMsZSx0KTtjb25zdCByPWdldExpc3RlbmVycyQxKHRoaXMsZSk/P25ldyBTZXQsbz1RLmdldCh0aGlzKSxhPVsuLi5yXSxjPWlzTWV0YUV2ZW50JDEoZSk/W106Wy4uLm9dO2F3YWl0IFgsYXdhaXQgUHJvbWlzZS5hbGwoWy4uLmEubWFwKChhc3luYyBlPT57aWYoci5oYXMoZSkpcmV0dXJuIGUodCl9KSksLi4uYy5tYXAoKGFzeW5jIHI9PntpZihvLmhhcyhyKSlyZXR1cm4gcihlLHQpfSkpXSl9YXN5bmMgZW1pdFNlcmlhbChlLHQpe2lmKGFzc2VydEV2ZW50TmFtZSQxKGUpLGlzTWV0YUV2ZW50JDEoZSkmJiFyZSl0aHJvdyBuZXcgVHlwZUVycm9yKCJgZXZlbnROYW1lYCBjYW5ub3QgYmUgbWV0YSBldmVudCBgbGlzdGVuZXJBZGRlZGAgb3IgYGxpc3RlbmVyUmVtb3ZlZGAiKTt0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJlbWl0U2VyaWFsIixlLHQpO2NvbnN0IHI9Z2V0TGlzdGVuZXJzJDEodGhpcyxlKT8/bmV3IFNldCxvPVEuZ2V0KHRoaXMpLGE9Wy4uLnJdLGM9Wy4uLm9dO2F3YWl0IFg7Zm9yKGNvbnN0IGYgb2YgYSlyLmhhcyhmKSYmYXdhaXQgZih0KTtmb3IoY29uc3QgZiBvZiBjKW8uaGFzKGYpJiZhd2FpdCBmKGUsdCl9b25BbnkoZSl7cmV0dXJuIGFzc2VydExpc3RlbmVyJDEoZSksdGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgic3Vic2NyaWJlQW55Iix2b2lkIDAsdm9pZCAwKSxRLmdldCh0aGlzKS5hZGQoZSksZW1pdE1ldGFFdmVudCQxKHRoaXMsZWUse2xpc3RlbmVyOmV9KSx0aGlzLm9mZkFueS5iaW5kKHRoaXMsZSl9YW55RXZlbnQoKXtyZXR1cm4gaXRlcmF0b3IkMSh0aGlzKX1vZmZBbnkoZSl7YXNzZXJ0TGlzdGVuZXIkMShlKSx0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJ1bnN1YnNjcmliZUFueSIsdm9pZCAwLHZvaWQgMCksZW1pdE1ldGFFdmVudCQxKHRoaXMsdGUse2xpc3RlbmVyOmV9KSxRLmdldCh0aGlzKS5kZWxldGUoZSl9Y2xlYXJMaXN0ZW5lcnMoZSl7ZT1BcnJheS5pc0FycmF5KGUpP2U6W2VdO2Zvcihjb25zdCB0IG9mIGUpaWYodGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgiY2xlYXIiLHQsdm9pZCAwKSwic3RyaW5nIj09dHlwZW9mIHR8fCJzeW1ib2wiPT10eXBlb2YgdHx8Im51bWJlciI9PXR5cGVvZiB0KXtjb25zdCBlPWdldExpc3RlbmVycyQxKHRoaXMsdCk7ZSYmZS5jbGVhcigpO2NvbnN0IHI9Z2V0RXZlbnRQcm9kdWNlcnMkMSh0aGlzLHQpO2lmKHIpe2Zvcihjb25zdCBlIG9mIHIpZS5maW5pc2goKTtyLmNsZWFyKCl9fWVsc2V7US5nZXQodGhpcykuY2xlYXIoKTtmb3IoY29uc3RbZSx0XW9mIEguZ2V0KHRoaXMpLmVudHJpZXMoKSl0LmNsZWFyKCksSC5nZXQodGhpcykuZGVsZXRlKGUpO2Zvcihjb25zdFtlLHRdb2YgWS5nZXQodGhpcykuZW50cmllcygpKXtmb3IoY29uc3QgZSBvZiB0KWUuZmluaXNoKCk7dC5jbGVhcigpLFkuZ2V0KHRoaXMpLmRlbGV0ZShlKX19fWxpc3RlbmVyQ291bnQoZSl7ZT1BcnJheS5pc0FycmF5KGUpP2U6W2VdO2xldCB0PTA7Zm9yKGNvbnN0IHIgb2YgZSlpZigic3RyaW5nIiE9dHlwZW9mIHIpe3ZvaWQgMCE9PXImJmFzc2VydEV2ZW50TmFtZSQxKHIpLHQrPVEuZ2V0KHRoaXMpLnNpemU7Zm9yKGNvbnN0IGUgb2YgSC5nZXQodGhpcykudmFsdWVzKCkpdCs9ZS5zaXplO2Zvcihjb25zdCBlIG9mIFkuZ2V0KHRoaXMpLnZhbHVlcygpKXQrPWUuc2l6ZX1lbHNlIHQrPVEuZ2V0KHRoaXMpLnNpemUrKGdldExpc3RlbmVycyQxKHRoaXMscik/LnNpemU/PzApKyhnZXRFdmVudFByb2R1Y2VycyQxKHRoaXMscik/LnNpemU/PzApKyhnZXRFdmVudFByb2R1Y2VycyQxKHRoaXMpPy5zaXplPz8wKTtyZXR1cm4gdH1iaW5kTWV0aG9kcyhlLHQpe2lmKCJvYmplY3QiIT10eXBlb2YgZXx8bnVsbD09PWUpdGhyb3cgbmV3IFR5cGVFcnJvcigiYHRhcmdldGAgbXVzdCBiZSBhbiBvYmplY3QiKTt0PWRlZmF1bHRNZXRob2ROYW1lc09yQXNzZXJ0JDEodCk7Zm9yKGNvbnN0IHIgb2YgdCl7aWYodm9pZCAwIT09ZVtyXSl0aHJvdyBuZXcgRXJyb3IoYFRoZSBwcm9wZXJ0eSBcYCR7cn1cYCBhbHJlYWR5IGV4aXN0cyBvbiBcYHRhcmdldFxgYCk7T2JqZWN0LmRlZmluZVByb3BlcnR5KGUscix7ZW51bWVyYWJsZTohMSx2YWx1ZTp0aGlzW3JdLmJpbmQodGhpcyl9KX19fTtjb25zdCBjZT1PYmplY3QuZ2V0T3duUHJvcGVydHlOYW1lcyhvZS5wcm90b3R5cGUpLmZpbHRlcigoZT0+ImNvbnN0cnVjdG9yIiE9PWUpKTtPYmplY3QuZGVmaW5lUHJvcGVydHkob2UsImxpc3RlbmVyQWRkZWQiLHt2YWx1ZTplZSx3cml0YWJsZTohMSxlbnVtZXJhYmxlOiEwLGNvbmZpZ3VyYWJsZTohMX0pLE9iamVjdC5kZWZpbmVQcm9wZXJ0eShvZSwibGlzdGVuZXJSZW1vdmVkIix7dmFsdWU6dGUsd3JpdGFibGU6ITEsZW51bWVyYWJsZTohMCxjb25maWd1cmFibGU6ITF9KTtjbGFzcyBBdmVyYWdle2NvbnN0cnVjdG9yKGUpe3RoaXMuc2l6ZT1lLHRoaXMudmFsdWVzPVtdLHRoaXMuc3VtPTB9cHVzaChlKXtmb3IodGhpcy52YWx1ZXMucHVzaChlKSx0aGlzLnN1bSs9ZTt0aGlzLnNpemU8dGhpcy52YWx1ZXMubGVuZ3RoOyl0aGlzLnN1bS09dGhpcy52YWx1ZXMuc2hpZnQoKT8/MH12YWx1ZSgpe3JldHVybiB0aGlzLnN1bS9NYXRoLm1heCgxLHRoaXMudmFsdWVzLmxlbmd0aCl9fWNsYXNzIE5vaXNlU3VwcHJlc3Npb25UcmFuc2Zvcm1lciBleHRlbmRzIG9le2NvbnN0cnVjdG9yKCl7c3VwZXIoKSx0aGlzLmlzRW5hYmxlZD0hMCx0aGlzLmludGVybmFsUmVzYW1wbGVTdXBwb3J0ZWQ9ITEsdGhpcy5sYXRlbmN5PW5ldyBBdmVyYWdlKDEwMCksdGhpcy50cmFuc2Zvcm09dGhpcy50cmFuc2Zvcm1BdWRpb0RhdGEuYmluZCh0aGlzKX1hc3luYyBpbml0KGU9e30pe2NvbnNvbGUubG9nKCJOb2lzZSBzdXBwcmVzc2lvbiB0cmFuc2Zvcm1lciBpbml0aWFsaXphdGlvbiIpLHRoaXMudHJhbnNmb3JtPWUuZGVidWc/dGhpcy50cmFuc2Zvcm1EZWJ1Zy5iaW5kKHRoaXMpOnRoaXMudHJhbnNmb3JtQXVkaW9EYXRhLmJpbmQodGhpcyk7Y29uc3QgdD1lLmFzc2V0c0RpckJhc2VVcmw/PyJodHRwczovL2Qzb3Bxam1xenhmMDU3LmNsb3VkZnJvbnQubmV0L25vaXNlLXN1cHByZXNzaW9uLzEuMC4wIixsb2NhdGVGaWxlPWU9PmAke3R9LyR7ZX1gO2xldCByLG89MTthd2FpdCB0aGlzLmlzTW9ub1RocmVhZChlKT90aGlzLndhc21JbnN0YW5jZT1hd2FpdCBjcmVhdGVXYXNtTW9ub0luc3RhbmNlKHtsb2NhdGVGaWxlOmxvY2F0ZUZpbGUsbWFpblNjcmlwdFVybE9yQmxvYjpsb2NhdGVGaWxlKCJtYWluLWJpbi1tb25vLmpzIil9KToodGhpcy53YXNtSW5zdGFuY2U9YXdhaXQgY3JlYXRlV2FzbU11bHRpSW5zdGFuY2Uoe2xvY2F0ZUZpbGU6bG9jYXRlRmlsZSxtYWluU2NyaXB0VXJsT3JCbG9iOmxvY2F0ZUZpbGUoIm1haW4tYmluLW11bHRpLmpzIil9KSxvPTQpLHRoaXMud2FzbVRyYW5zZm9ybWVyPW5ldyB0aGlzLndhc21JbnN0YW5jZS5EdGxuVHJhbnNmb3JtZXIsYXdhaXQgUHJvbWlzZS5hbGwoW3RoaXMubG9hZE1vZGVsKGAke3R9L21vZGVsXzEudGZsaXRlYCwxKSx0aGlzLmxvYWRNb2RlbChgJHt0fS9tb2RlbF8yLnRmbGl0ZWAsMildKTt0cnl7cj1hd2FpdCh0aGlzLndhc21UcmFuc2Zvcm1lcj8uaW5pdChvKSl9Y2F0Y2goYSl7aWYoIm51bWJlciI9PXR5cGVvZiBhKXtsZXQgZT0iIjtmb3IobGV0IHQ9MDt0PDUwMDsrK3QpZSs9U3RyaW5nLmZyb21DaGFyQ29kZSh0aGlzLndhc21JbnN0YW5jZS5IRUFQOFthK3RdKTtjb25zb2xlLmVycm9yKGUpfWVsc2UgY29uc29sZS5lcnJvcihhKX1pZigwIT09cil7Y29uc3QgZT1gRmFpbCB0byBpbml0IHdhc20gdHJhbnNmb3JtZXIsIGVycm9yIGNvZGUgPSAke3J9YDt0aHJvdyBjb25zb2xlLmVycm9yKGUpLGV9aWYodGhpcy5pbnRlcm5hbFJlc2FtcGxlU3VwcG9ydGVkPXRoaXMud2FzbVRyYW5zZm9ybWVyPy5nZXRJbnRlcm5hbFJlc2FtcGxlU3VwcG9ydGVkKCksIXRoaXMuaW50ZXJuYWxSZXNhbXBsZVN1cHBvcnRlZCl7Y29uc3QgZT0iSW50ZXJuYWwgcmVzYW1wbGluZyBub3Qgc3VwcG9ydGVkIjt0aHJvdyBjb25zb2xlLmVycm9yKGUpLGV9ZS5kZWJ1ZyYmdGhpcy53YXNtVHJhbnNmb3JtZXI/LmVuYWJsZVdhdkV4cG9ydCgpLGNvbnNvbGUubG9nKCJOb2lzZSBzdXBwcmVzc2lvbiB0cmFuc2Zvcm1lciByZWFkeSIpfWdldFdhdigpe2lmKCF0aGlzLndhc21UcmFuc2Zvcm1lcilyZXR1cm4iIjt0aGlzLndhc21UcmFuc2Zvcm1lci5jbG9zZVdhdigpO2NvbnN0IGU9dGhpcy53YXNtVHJhbnNmb3JtZXIuZ2V0V2F2KCk7cmV0dXJuYGRhdGE6YXVkaW8vd2F2O2Jhc2U2NCwke2J0b2EobmV3IFVpbnQ4QXJyYXkoZSkucmVkdWNlKCgoZSx0KT0+ZStTdHJpbmcuZnJvbUNoYXJDb2RlKHQpKSwiIikpfWB9c2V0QXVkaW9PcHRpb25zKGUsdCxyLG8sYSl7dGhpcy53YXNtVHJhbnNmb3JtZXI/LnNldEF1ZGlvT3B0aW9ucyhlLHQscixvLGEpfWVuYWJsZSgpe3RoaXMuaXNFbmFibGVkPSEwfWRpc2FibGUoKXt0aGlzLmlzRW5hYmxlZD0hMX1nZXRMYXRlbmN5KCl7cmV0dXJuIHRoaXMubGF0ZW5jeS52YWx1ZSgpfWdldFdhc21MYXRlbmN5TnMoKXtyZXR1cm4gdGhpcy53YXNtVHJhbnNmb3JtZXI/LmdldExhdGVuY3lOcygpPz8wfWFzeW5jIHRyYW5zZm9ybURlYnVnKGUsdCl7dHJ5e2NvbnN0IHI9cGVyZm9ybWFuY2Uubm93KCk7YXdhaXQgdGhpcy50cmFuc2Zvcm1BdWRpb0RhdGEoZSx0KSx0aGlzLmxhdGVuY3kucHVzaChwZXJmb3JtYW5jZS5ub3coKS1yKX1jYXRjaChyKXtjb25zb2xlLmVycm9yKHIpfX1hc3luYyB0cmFuc2Zvcm1BdWRpb0RhdGEoZSx0KXtpZih0aGlzLndhc21UcmFuc2Zvcm1lcnx8dGhpcy5lbWl0KCJ3YXJuaW5nIiwidHJhbnNmb3JtZXIgbm90IGluaXRpYWxpemVkIiksdGhpcy5pc0VuYWJsZWQmJnRoaXMud2FzbVRyYW5zZm9ybWVyKXRyeXtjb25zdHtudW1iZXJPZkZyYW1lczp0LHNhbXBsZVJhdGU6byxudW1iZXJPZkNoYW5uZWxzOmEsdGltZXN0YW1wOmN9PWUsZj10aGlzLmdldEF1ZGlvRGF0YUFzRmxvYXQzMihlKSxoPXRoaXMuY29udmVydFR5cGVkQXJyYXkoZixJbnQxNkFycmF5LDMyNzY3KTt0aGlzLndhc21UcmFuc2Zvcm1lci5nZXRJbnB1dEZyYW1lKGgubGVuZ3RoKS5zZXQoaCk7bGV0IHU9MDt0cnl7dT10aGlzLndhc21UcmFuc2Zvcm1lci5ydW5BbGdvcml0aG0odCxvLGEpfWNhdGNoKHIpe2lmKCJudW1iZXIiPT10eXBlb2Ygcil7bGV0IGU9IiI7Zm9yKGxldCB0PTA7dDw1MDA7Kyt0KWUrPVN0cmluZy5mcm9tQ2hhckNvZGUodGhpcy53YXNtSW5zdGFuY2UuSEVBUDhbcit0XSk7Y29uc29sZS5lcnJvcihlKX1lbHNlIGNvbnNvbGUuZXJyb3Iocil9aWYodT4wKXtjb25zdCByPXRoaXMud2FzbVRyYW5zZm9ybWVyLmdldE91dHB1dEZyYW1lKCkuc2xpY2UoMCx1KSxmPXRoaXMuY29udmVydFR5cGVkQXJyYXkocixGbG9hdDMyQXJyYXksMS8zMjc2Nyk7ZT1uZXcgQXVkaW9EYXRhKHtkYXRhOmYsZm9ybWF0OiJmMzIiLG51bWJlck9mQ2hhbm5lbHM6YSxudW1iZXJPZkZyYW1lczp0LHNhbXBsZVJhdGU6byx0aW1lc3RhbXA6Y30pfX1jYXRjaChyKXtjb25zb2xlLmVycm9yKHIpfXQuZW5xdWV1ZShlKX1hc3luYyBsb2FkTW9kZWwoZSx0KXtpZighdGhpcy53YXNtVHJhbnNmb3JtZXIpcmV0dXJuO2NvbnN0IHI9YXdhaXQgZmV0Y2goZSksbz1hd2FpdCByLmFycmF5QnVmZmVyKCksYT1vLmJ5dGVMZW5ndGgsYz1gZ2V0TW9kZWwke3R9YCxmPXRoaXMud2FzbVRyYW5zZm9ybWVyW2NdKGEpO2lmKGYpe2NvbnN0IGU9bmV3IFVpbnQ4QXJyYXkobyk7Zi5zZXQoZSl9fWdldEF1ZGlvRGF0YUFzRmxvYXQzMihlKXtyZXR1cm4gdGhpcy5hdWRpb0RhdGFUb1R5cGVkQXJyYXkoZSxGbG9hdDMyQXJyYXksImYzMi1wbGFuYXIiKX1hdWRpb0RhdGFUb1R5cGVkQXJyYXkoZSx0LHIsbz1lLm51bWJlck9mQ2hhbm5lbHMpe2NvbnN0IGE9ZS5udW1iZXJPZkZyYW1lcypvLGM9bmV3IHQoYSk7Zm9yKGxldCBmPTA7ZjxvOysrZil7Y29uc3QgdD1lLm51bWJlck9mRnJhbWVzKmYsbz1jLnN1YmFycmF5KHQsdCtlLm51bWJlck9mRnJhbWVzKTtlLmNvcHlUbyhvLHtwbGFuZUluZGV4OmYsZm9ybWF0OnJ9KX1pZihvPjEpe2NvbnN0IHI9bmV3IHQoYSk7Zm9yKGxldCB0PTA7dDxlLm51bWJlck9mRnJhbWVzOysrdCl7Y29uc3QgYT0yKnQ7Zm9yKGxldCBmPTA7ZjxvOysrZilyW2ErZl09Y1t0K2YqZS5udW1iZXJPZkZyYW1lc119cmV0dXJuIHJ9cmV0dXJuIGN9Y29udmVydFR5cGVkQXJyYXkoZSx0LHIpe2NvbnN0IG89ZS5sZW5ndGgsYT1uZXcgdChvKTtmb3IobGV0IGM9MDtjPG87KytjKWFbY109ZVtjXSpyO3JldHVybiBhfWlzTW9ub1RocmVhZChlKXtpZihlLmRpc2FibGVXYXNtTXVsdGlUaHJlYWQpcmV0dXJuITA7dHJ5e2lmKHZvaWQgMD09PW5ldyBTaGFyZWRBcnJheUJ1ZmZlcigxMDI0KSl0aHJvdyBuZXcgRXJyb3IoIm5vdCBzdXBwb3J0ZWQiKX1jYXRjaCh0KXtyZXR1cm4gdGhpcy5lbWl0KCJ3YXJuaW5nIiwiXG5NdWx0aXRocmVhZCBpcyBub3QgYXZhaWxhYmxlLCBub2lzZS1zdXBwcmVzaW9uIGlzIG5vdyBydW5uaW5nIG9uIGEgc2luZ2xlIHRocmVhZC5cblRoaXMgaXMgaW1wYWN0aW5nIHRoZSBwZXJmb3JtYW5jZSBhbmQgaW5jcmVhc2UgdGhlIGxhdGVuY3kuXG5cblRvIGVuYWJsZSBtdWx0aXRocmVhZCwgeW91IG5lZWQgdG8gc2VydmUgdGhlIGFwcGxpY2F0aW9uIHZpYSBodHRwcyB3aXRoIHRoZXNlIGh0dHAgaGVhZGVycyA6XG4gICAtIENyb3NzLU9yaWdpbi1PcGVuZXItUG9saWN5OiBzYW1lLW9yaWdpblxuICAgLSBDcm9zcy1PcmlnaW4tRW1iZWRkZXItUG9saWN5OiByZXF1aXJlLWNvcnAuXG5Nb3JlIGluZm86IGh0dHBzOi8vZGV2ZWxvcGVyLm1vemlsbGEub3JnL2VuLVVTL2RvY3MvV2ViL0phdmFTY3JpcHQvUmVmZXJlbmNlL0dsb2JhbF9PYmplY3RzL1NoYXJlZEFycmF5QnVmZmVyI3NlY3VyaXR5X3JlcXVpcmVtZW50c1xuXG5Zb3UgY2FuIGRpc2FibGUgdGhpcyB3YXJuaW5nIGJ5IGVuYWJsaW5nIGRpc2FibGVXYXNtTXVsdGlUaHJlYWQgd2l0aGluIHRoZSBub2lzZVN1cHByZXNzaW9uIG9wdGlvbnMuXG4iKSwhMH1yZXR1cm4hMX19ZnVuY3Rpb24gY3JlYXRlR2xvYmFsVGhpc1ZhcmlhYmxlKGUsdCl7Z2xvYmFsVGhpcy52b25hZ2V8fChnbG9iYWxUaGlzLnZvbmFnZT17fSksZ2xvYmFsVGhpcy52b25hZ2Uud29ya2VyaXplcnx8KGdsb2JhbFRoaXMudm9uYWdlLndvcmtlcml6ZXI9e30pO2xldCByPWdsb2JhbFRoaXMudm9uYWdlLndvcmtlcml6ZXI7cmV0dXJuIHJbZV18fChyW2VdPXQpLHJbZV19Y29uc3QgdWU9Y3JlYXRlR2xvYmFsVGhpc1ZhcmlhYmxlKCJnbG9iYWxzIix7fSk7dmFyIGJlPShlPT4oZS5JTklUPSJJTklUIixlLkZPUldBUkQ9IkZPUldBUkQiLGUuVEVSTUlOQVRFPSJURVJNSU5BVEUiLGUuR0xPQkFMU19TWU5DPSJHTE9CQUxTX1NZTkMiLGUuRVZFTlQ9IkVWRU5UIixlKSkoYmV8fHt9KTtmdW5jdGlvbiBwb3N0Q29tbWFuZChlLHQpe2NvbnN0e2lkOnIsdHlwZTpvfT1lLGE9QXJyYXkuaXNBcnJheSh0KT90Olt0XTtwb3N0TWVzc2FnZSh7aWQ6cix0eXBlOm8scmVzdWx0OnR9LGEuZmlsdGVyKChlPT5mdW5jdGlvbiBpc1RyYW5zZmVyYWJsZShlKXtyZXR1cm5bSW1hZ2VCaXRtYXAsUmVhZGFibGVTdHJlYW0sV3JpdGFibGVTdHJlYW1dLnNvbWUoKHQ9PmUgaW5zdGFuY2VvZiB0KSl9KGUpKSkpfWZ1bmN0aW9uIGlzV29ya2VyKCl7cmV0dXJuInVuZGVmaW5lZCIhPXR5cGVvZiBXb3JrZXJHbG9iYWxTY29wZSYmc2VsZiBpbnN0YW5jZW9mIFdvcmtlckdsb2JhbFNjb3BlfWZ1bmN0aW9uIGNvcHkoZSx0KXtpZihBcnJheS5pc0FycmF5KHQpKXQuc3BsaWNlKDAsdC5sZW5ndGgpO2Vsc2UgaWYoIm9iamVjdCI9PXR5cGVvZiB0KWZvcihjb25zdCByIGluIHQpZGVsZXRlIHRbcl07Zm9yKGNvbnN0IHIgaW4gZSlBcnJheS5pc0FycmF5KGVbcl0pPyh0W3JdPVtdLGNvcHkoZVtyXSx0W3JdKSk6Im9iamVjdCI9PXR5cGVvZiBlW3JdPyh0W3JdPXt9LGNvcHkoZVtyXSx0W3JdKSk6dFtyXT1lW3JdfWNyZWF0ZUdsb2JhbFRoaXNWYXJpYWJsZSgid29ya2VyaXplZCIse30pO2NvbnN0IHdlPW5ldyBXZWFrTWFwLHZlPW5ldyBXZWFrTWFwLEVlPW5ldyBXZWFrTWFwLFNlPVN5bWJvbCgiYW55UHJvZHVjZXIiKSxJZT1Qcm9taXNlLnJlc29sdmUoKSwkZT1TeW1ib2woImxpc3RlbmVyQWRkZWQiKSxOZT1TeW1ib2woImxpc3RlbmVyUmVtb3ZlZCIpO2xldCBQZT0hMSxEZT0hMTtmdW5jdGlvbiBhc3NlcnRFdmVudE5hbWUoZSl7aWYoInN0cmluZyIhPXR5cGVvZiBlJiYic3ltYm9sIiE9dHlwZW9mIGUmJiJudW1iZXIiIT10eXBlb2YgZSl0aHJvdyBuZXcgVHlwZUVycm9yKCJgZXZlbnROYW1lYCBtdXN0IGJlIGEgc3RyaW5nLCBzeW1ib2wsIG9yIG51bWJlciIpfWZ1bmN0aW9uIGFzc2VydExpc3RlbmVyKGUpe2lmKCJmdW5jdGlvbiIhPXR5cGVvZiBlKXRocm93IG5ldyBUeXBlRXJyb3IoImxpc3RlbmVyIG11c3QgYmUgYSBmdW5jdGlvbiIpfWZ1bmN0aW9uIGdldExpc3RlbmVycyhlLHQpe2NvbnN0IHI9dmUuZ2V0KGUpO2lmKHIuaGFzKHQpKXJldHVybiByLmdldCh0KX1mdW5jdGlvbiBnZXRFdmVudFByb2R1Y2VycyhlLHQpe2NvbnN0IHI9InN0cmluZyI9PXR5cGVvZiB0fHwic3ltYm9sIj09dHlwZW9mIHR8fCJudW1iZXIiPT10eXBlb2YgdD90OlNlLG89RWUuZ2V0KGUpO2lmKG8uaGFzKHIpKXJldHVybiBvLmdldChyKX1mdW5jdGlvbiBpdGVyYXRvcihlLHQpe3Q9QXJyYXkuaXNBcnJheSh0KT90Olt0XTtsZXQgcj0hMSxmbHVzaD0oKT0+e30sbz1bXTtjb25zdCBhPXtlbnF1ZXVlKGUpe28ucHVzaChlKSxmbHVzaCgpfSxmaW5pc2goKXtyPSEwLGZsdXNoKCl9fTtmb3IoY29uc3QgYyBvZiB0KXtsZXQgdD1nZXRFdmVudFByb2R1Y2VycyhlLGMpO2lmKCF0KXt0PW5ldyBTZXQ7RWUuZ2V0KGUpLnNldChjLHQpfXQuYWRkKGEpfXJldHVybnthc3luYyBuZXh0KCl7cmV0dXJuIG8/MD09PW8ubGVuZ3RoP3I/KG89dm9pZCAwLHRoaXMubmV4dCgpKTooYXdhaXQgbmV3IFByb21pc2UoKGU9PntmbHVzaD1lfSkpLHRoaXMubmV4dCgpKTp7ZG9uZTohMSx2YWx1ZTphd2FpdCBvLnNoaWZ0KCl9Ontkb25lOiEwfX0sYXN5bmMgcmV0dXJuKHIpe289dm9pZCAwO2Zvcihjb25zdCBvIG9mIHQpe2NvbnN0IHQ9Z2V0RXZlbnRQcm9kdWNlcnMoZSxvKTtpZih0JiYodC5kZWxldGUoYSksMD09PXQuc2l6ZSkpe0VlLmdldChlKS5kZWxldGUobyl9fXJldHVybiBmbHVzaCgpLGFyZ3VtZW50cy5sZW5ndGg+MD97ZG9uZTohMCx2YWx1ZTphd2FpdCByfTp7ZG9uZTohMH19LFtTeW1ib2wuYXN5bmNJdGVyYXRvcl0oKXtyZXR1cm4gdGhpc319fWZ1bmN0aW9uIGRlZmF1bHRNZXRob2ROYW1lc09yQXNzZXJ0KGUpe2lmKHZvaWQgMD09PWUpcmV0dXJuIE9lO2lmKCFBcnJheS5pc0FycmF5KGUpKXRocm93IG5ldyBUeXBlRXJyb3IoImBtZXRob2ROYW1lc2AgbXVzdCBiZSBhbiBhcnJheSBvZiBzdHJpbmdzIik7Zm9yKGNvbnN0IHQgb2YgZSlpZighT2UuaW5jbHVkZXModCkpe2lmKCJzdHJpbmciIT10eXBlb2YgdCl0aHJvdyBuZXcgVHlwZUVycm9yKCJgbWV0aG9kTmFtZXNgIGVsZW1lbnQgbXVzdCBiZSBhIHN0cmluZyIpO3Rocm93IG5ldyBFcnJvcihgJHt0fSBpcyBub3QgRW1pdHRlcnkgbWV0aG9kYCl9cmV0dXJuIGV9Y29uc3QgaXNNZXRhRXZlbnQ9ZT0+ZT09PSRlfHxlPT09TmU7ZnVuY3Rpb24gZW1pdE1ldGFFdmVudChlLHQscil7aWYoaXNNZXRhRXZlbnQodCkpdHJ5e1BlPSEwLGUuZW1pdCh0LHIpfWZpbmFsbHl7UGU9ITF9fWNsYXNzIEVtaXR0ZXJ5e3N0YXRpYyBtaXhpbihlLHQpe3JldHVybiB0PWRlZmF1bHRNZXRob2ROYW1lc09yQXNzZXJ0KHQpLHI9PntpZigiZnVuY3Rpb24iIT10eXBlb2Ygcil0aHJvdyBuZXcgVHlwZUVycm9yKCJgdGFyZ2V0YCBtdXN0IGJlIGZ1bmN0aW9uIik7Zm9yKGNvbnN0IGUgb2YgdClpZih2b2lkIDAhPT1yLnByb3RvdHlwZVtlXSl0aHJvdyBuZXcgRXJyb3IoYFRoZSBwcm9wZXJ0eSBcYCR7ZX1cYCBhbHJlYWR5IGV4aXN0cyBvbiBcYHRhcmdldFxgYCk7T2JqZWN0LmRlZmluZVByb3BlcnR5KHIucHJvdG90eXBlLGUse2VudW1lcmFibGU6ITEsZ2V0OmZ1bmN0aW9uIGdldEVtaXR0ZXJ5UHJvcGVydHkoKXtyZXR1cm4gT2JqZWN0LmRlZmluZVByb3BlcnR5KHRoaXMsZSx7ZW51bWVyYWJsZTohMSx2YWx1ZTpuZXcgRW1pdHRlcnl9KSx0aGlzW2VdfX0pO2NvbnN0IGVtaXR0ZXJ5TWV0aG9kQ2FsbGVyPXQ9PmZ1bmN0aW9uKC4uLnIpe3JldHVybiB0aGlzW2VdW3RdKC4uLnIpfTtmb3IoY29uc3QgZSBvZiB0KU9iamVjdC5kZWZpbmVQcm9wZXJ0eShyLnByb3RvdHlwZSxlLHtlbnVtZXJhYmxlOiExLHZhbHVlOmVtaXR0ZXJ5TWV0aG9kQ2FsbGVyKGUpfSk7cmV0dXJuIHJ9fXN0YXRpYyBnZXQgaXNEZWJ1Z0VuYWJsZWQoKXt2YXIgZSx0O2lmKCJvYmplY3QiIT10eXBlb2YobnVsbD09KGU9Z2xvYmFsVGhpcy5wcm9jZXNzKT92b2lkIDA6ZS5lbnYpKXJldHVybiBEZTtjb25zdHtlbnY6cn09bnVsbCE9KHQ9Z2xvYmFsVGhpcy5wcm9jZXNzKT90OntlbnY6e319O3JldHVybiJlbWl0dGVyeSI9PT1yLkRFQlVHfHwiKiI9PT1yLkRFQlVHfHxEZX1zdGF0aWMgc2V0IGlzRGVidWdFbmFibGVkKGUpe0RlPWV9Y29uc3RydWN0b3IoZT17fSl7dmFyIHQ7d2Uuc2V0KHRoaXMsbmV3IFNldCksdmUuc2V0KHRoaXMsbmV3IE1hcCksRWUuc2V0KHRoaXMsbmV3IE1hcCksRWUuZ2V0KHRoaXMpLnNldChTZSxuZXcgU2V0KSx0aGlzLmRlYnVnPW51bGwhPSh0PWUuZGVidWcpP3Q6e30sdm9pZCAwPT09dGhpcy5kZWJ1Zy5lbmFibGVkJiYodGhpcy5kZWJ1Zy5lbmFibGVkPSExKSx0aGlzLmRlYnVnLmxvZ2dlcnx8KHRoaXMuZGVidWcubG9nZ2VyPShlLHQscixvKT0+e3RyeXtvPUpTT04uc3RyaW5naWZ5KG8pfWNhdGNoe289YE9iamVjdCB3aXRoIHRoZSBmb2xsb3dpbmcga2V5cyBmYWlsZWQgdG8gc3RyaW5naWZ5OiAke09iamVjdC5rZXlzKG8pLmpvaW4oIiwiKX1gfSJzeW1ib2wiIT10eXBlb2YgciYmIm51bWJlciIhPXR5cGVvZiByfHwocj1yLnRvU3RyaW5nKCkpO2NvbnN0IGE9bmV3IERhdGUsYz1gJHthLmdldEhvdXJzKCl9OiR7YS5nZXRNaW51dGVzKCl9OiR7YS5nZXRTZWNvbmRzKCl9LiR7YS5nZXRNaWxsaXNlY29uZHMoKX1gO2NvbnNvbGUubG9nKGBbJHtjfV1bZW1pdHRlcnk6JHtlfV1bJHt0fV0gRXZlbnQgTmFtZTogJHtyfVxuXHRkYXRhOiAke299YCl9KX1sb2dJZkRlYnVnRW5hYmxlZChlLHQscil7KEVtaXR0ZXJ5LmlzRGVidWdFbmFibGVkfHx0aGlzLmRlYnVnLmVuYWJsZWQpJiZ0aGlzLmRlYnVnLmxvZ2dlcihlLHRoaXMuZGVidWcubmFtZSx0LHIpfW9uKGUsdCl7YXNzZXJ0TGlzdGVuZXIodCksZT1BcnJheS5pc0FycmF5KGUpP2U6W2VdO2Zvcihjb25zdCByIG9mIGUpe2Fzc2VydEV2ZW50TmFtZShyKTtsZXQgZT1nZXRMaXN0ZW5lcnModGhpcyxyKTtpZighZSl7ZT1uZXcgU2V0O3ZlLmdldCh0aGlzKS5zZXQocixlKX1lLmFkZCh0KSx0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJzdWJzY3JpYmUiLHIsdm9pZCAwKSxpc01ldGFFdmVudChyKXx8ZW1pdE1ldGFFdmVudCh0aGlzLCRlLHtldmVudE5hbWU6cixsaXN0ZW5lcjp0fSl9cmV0dXJuIHRoaXMub2ZmLmJpbmQodGhpcyxlLHQpfW9mZihlLHQpe2Fzc2VydExpc3RlbmVyKHQpLGU9QXJyYXkuaXNBcnJheShlKT9lOltlXTtmb3IoY29uc3QgciBvZiBlKXthc3NlcnRFdmVudE5hbWUocik7Y29uc3QgZT1nZXRMaXN0ZW5lcnModGhpcyxyKTtpZihlJiYoZS5kZWxldGUodCksMD09PWUuc2l6ZSkpe3ZlLmdldCh0aGlzKS5kZWxldGUocil9dGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgidW5zdWJzY3JpYmUiLHIsdm9pZCAwKSxpc01ldGFFdmVudChyKXx8ZW1pdE1ldGFFdmVudCh0aGlzLE5lLHtldmVudE5hbWU6cixsaXN0ZW5lcjp0fSl9fW9uY2UoZSl7bGV0IHQ7Y29uc3Qgcj1uZXcgUHJvbWlzZSgocj0+e3Q9dGhpcy5vbihlLChlPT57dCgpLHIoZSl9KSl9KSk7cmV0dXJuIHIub2ZmPXQscn1ldmVudHMoZSl7ZT1BcnJheS5pc0FycmF5KGUpP2U6W2VdO2Zvcihjb25zdCB0IG9mIGUpYXNzZXJ0RXZlbnROYW1lKHQpO3JldHVybiBpdGVyYXRvcih0aGlzLGUpfWFzeW5jIGVtaXQoZSx0KXt2YXIgcjtpZihhc3NlcnRFdmVudE5hbWUoZSksaXNNZXRhRXZlbnQoZSkmJiFQZSl0aHJvdyBuZXcgVHlwZUVycm9yKCJgZXZlbnROYW1lYCBjYW5ub3QgYmUgbWV0YSBldmVudCBgbGlzdGVuZXJBZGRlZGAgb3IgYGxpc3RlbmVyUmVtb3ZlZGAiKTt0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJlbWl0IixlLHQpLGZ1bmN0aW9uIGVucXVldWVQcm9kdWNlcnMoZSx0LHIpe2NvbnN0IG89RWUuZ2V0KGUpO2lmKG8uaGFzKHQpKWZvcihjb25zdCBhIG9mIG8uZ2V0KHQpKWEuZW5xdWV1ZShyKTtpZihvLmhhcyhTZSkpe2NvbnN0IGU9UHJvbWlzZS5hbGwoW3Qscl0pO2Zvcihjb25zdCB0IG9mIG8uZ2V0KFNlKSl0LmVucXVldWUoZSl9fSh0aGlzLGUsdCk7Y29uc3Qgbz1udWxsIT0ocj1nZXRMaXN0ZW5lcnModGhpcyxlKSk/cjpuZXcgU2V0LGE9d2UuZ2V0KHRoaXMpLGM9Wy4uLm9dLGY9aXNNZXRhRXZlbnQoZSk/W106Wy4uLmFdO2F3YWl0IEllLGF3YWl0IFByb21pc2UuYWxsKFsuLi5jLm1hcCgoYXN5bmMgZT0+e2lmKG8uaGFzKGUpKXJldHVybiBlKHQpfSkpLC4uLmYubWFwKChhc3luYyByPT57aWYoYS5oYXMocikpcmV0dXJuIHIoZSx0KX0pKV0pfWFzeW5jIGVtaXRTZXJpYWwoZSx0KXt2YXIgcjtpZihhc3NlcnRFdmVudE5hbWUoZSksaXNNZXRhRXZlbnQoZSkmJiFQZSl0aHJvdyBuZXcgVHlwZUVycm9yKCJgZXZlbnROYW1lYCBjYW5ub3QgYmUgbWV0YSBldmVudCBgbGlzdGVuZXJBZGRlZGAgb3IgYGxpc3RlbmVyUmVtb3ZlZGAiKTt0aGlzLmxvZ0lmRGVidWdFbmFibGVkKCJlbWl0U2VyaWFsIixlLHQpO2NvbnN0IG89bnVsbCE9KHI9Z2V0TGlzdGVuZXJzKHRoaXMsZSkpP3I6bmV3IFNldCxhPXdlLmdldCh0aGlzKSxjPVsuLi5vXSxmPVsuLi5hXTthd2FpdCBJZTtmb3IoY29uc3QgaCBvZiBjKW8uaGFzKGgpJiZhd2FpdCBoKHQpO2Zvcihjb25zdCBoIG9mIGYpYS5oYXMoaCkmJmF3YWl0IGgoZSx0KX1vbkFueShlKXtyZXR1cm4gYXNzZXJ0TGlzdGVuZXIoZSksdGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgic3Vic2NyaWJlQW55Iix2b2lkIDAsdm9pZCAwKSx3ZS5nZXQodGhpcykuYWRkKGUpLGVtaXRNZXRhRXZlbnQodGhpcywkZSx7bGlzdGVuZXI6ZX0pLHRoaXMub2ZmQW55LmJpbmQodGhpcyxlKX1hbnlFdmVudCgpe3JldHVybiBpdGVyYXRvcih0aGlzKX1vZmZBbnkoZSl7YXNzZXJ0TGlzdGVuZXIoZSksdGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgidW5zdWJzY3JpYmVBbnkiLHZvaWQgMCx2b2lkIDApLGVtaXRNZXRhRXZlbnQodGhpcyxOZSx7bGlzdGVuZXI6ZX0pLHdlLmdldCh0aGlzKS5kZWxldGUoZSl9Y2xlYXJMaXN0ZW5lcnMoZSl7ZT1BcnJheS5pc0FycmF5KGUpP2U6W2VdO2Zvcihjb25zdCB0IG9mIGUpaWYodGhpcy5sb2dJZkRlYnVnRW5hYmxlZCgiY2xlYXIiLHQsdm9pZCAwKSwic3RyaW5nIj09dHlwZW9mIHR8fCJzeW1ib2wiPT10eXBlb2YgdHx8Im51bWJlciI9PXR5cGVvZiB0KXtjb25zdCBlPWdldExpc3RlbmVycyh0aGlzLHQpO2UmJmUuY2xlYXIoKTtjb25zdCByPWdldEV2ZW50UHJvZHVjZXJzKHRoaXMsdCk7aWYocil7Zm9yKGNvbnN0IGUgb2YgcillLmZpbmlzaCgpO3IuY2xlYXIoKX19ZWxzZXt3ZS5nZXQodGhpcykuY2xlYXIoKTtmb3IoY29uc3RbZSx0XW9mIHZlLmdldCh0aGlzKS5lbnRyaWVzKCkpdC5jbGVhcigpLHZlLmdldCh0aGlzKS5kZWxldGUoZSk7Zm9yKGNvbnN0W2UsdF1vZiBFZS5nZXQodGhpcykuZW50cmllcygpKXtmb3IoY29uc3QgZSBvZiB0KWUuZmluaXNoKCk7dC5jbGVhcigpLEVlLmdldCh0aGlzKS5kZWxldGUoZSl9fX1saXN0ZW5lckNvdW50KGUpe3ZhciB0LHIsbyxhLGMsZjtlPUFycmF5LmlzQXJyYXkoZSk/ZTpbZV07bGV0IGg9MDtmb3IoY29uc3QgdSBvZiBlKWlmKCJzdHJpbmciIT10eXBlb2YgdSl7dm9pZCAwIT09dSYmYXNzZXJ0RXZlbnROYW1lKHUpLGgrPXdlLmdldCh0aGlzKS5zaXplO2Zvcihjb25zdCBlIG9mIHZlLmdldCh0aGlzKS52YWx1ZXMoKSloKz1lLnNpemU7Zm9yKGNvbnN0IGUgb2YgRWUuZ2V0KHRoaXMpLnZhbHVlcygpKWgrPWUuc2l6ZX1lbHNlIGgrPXdlLmdldCh0aGlzKS5zaXplKyhudWxsIT0ocj1udWxsPT0odD1nZXRMaXN0ZW5lcnModGhpcyx1KSk/dm9pZCAwOnQuc2l6ZSk/cjowKSsobnVsbCE9KGE9bnVsbD09KG89Z2V0RXZlbnRQcm9kdWNlcnModGhpcyx1KSk/dm9pZCAwOm8uc2l6ZSk/YTowKSsobnVsbCE9KGY9bnVsbD09KGM9Z2V0RXZlbnRQcm9kdWNlcnModGhpcykpP3ZvaWQgMDpjLnNpemUpP2Y6MCk7cmV0dXJuIGh9YmluZE1ldGhvZHMoZSx0KXtpZigib2JqZWN0IiE9dHlwZW9mIGV8fG51bGw9PT1lKXRocm93IG5ldyBUeXBlRXJyb3IoImB0YXJnZXRgIG11c3QgYmUgYW4gb2JqZWN0Iik7dD1kZWZhdWx0TWV0aG9kTmFtZXNPckFzc2VydCh0KTtmb3IoY29uc3QgciBvZiB0KXtpZih2b2lkIDAhPT1lW3JdKXRocm93IG5ldyBFcnJvcihgVGhlIHByb3BlcnR5IFxgJHtyfVxgIGFscmVhZHkgZXhpc3RzIG9uIFxgdGFyZ2V0XGBgKTtPYmplY3QuZGVmaW5lUHJvcGVydHkoZSxyLHtlbnVtZXJhYmxlOiExLHZhbHVlOnRoaXNbcl0uYmluZCh0aGlzKX0pfX19Y29uc3QgT2U9T2JqZWN0LmdldE93blByb3BlcnR5TmFtZXMoRW1pdHRlcnkucHJvdG90eXBlKS5maWx0ZXIoKGU9PiJjb25zdHJ1Y3RvciIhPT1lKSk7T2JqZWN0LmRlZmluZVByb3BlcnR5KEVtaXR0ZXJ5LCJsaXN0ZW5lckFkZGVkIix7dmFsdWU6JGUsd3JpdGFibGU6ITEsZW51bWVyYWJsZTohMCxjb25maWd1cmFibGU6ITF9KSxPYmplY3QuZGVmaW5lUHJvcGVydHkoRW1pdHRlcnksImxpc3RlbmVyUmVtb3ZlZCIse3ZhbHVlOk5lLHdyaXRhYmxlOiExLGVudW1lcmFibGU6ITAsY29uZmlndXJhYmxlOiExfSk7Y29uc3QgTWU9Y3JlYXRlR2xvYmFsVGhpc1ZhcmlhYmxlKCJyZWdpc3RlcmVkV29ya2VycyIse30pO2lzV29ya2VyKCkmJmZ1bmN0aW9uIGluaXRXb3JrZXIoKXtjb25zdCBlPXt9O29ubWVzc2FnZT1hc3luYyB0PT57Y29uc3Qgcj10LmRhdGE7c3dpdGNoKHIudHlwZSl7Y2FzZSBiZS5JTklUOiFmdW5jdGlvbiBoYW5kbGVDb21tYW5kSW5pdChlLHQpe2lmKCFlLmFyZ3MpdGhyb3ciTWlzc2luZyBjbGFzc05hbWUgd2hpbGUgaW5pdGlhbGl6aW5nIHdvcmtlciI7Y29uc3RbcixvXT1lLmFyZ3MsYT1NZVtyXTtpZighYSl0aHJvd2B1bmtub3duIHdvcmtlciBjbGFzcyAke3J9YDt0Lmluc3RhbmNlPW5ldyBhKGUuYXJncy5zbGljZSgxKSksY29weShvLHVlKSxmdW5jdGlvbiBpc0luc3RhbmNlT2ZFbWl0dGVyeShlKXtyZXR1cm4gZS5vbkFueSYmZS5lbWl0fSh0Lmluc3RhbmNlKSYmdC5pbnN0YW5jZS5vbkFueSgoKGUsdCk9Pntwb3N0Q29tbWFuZCh7dHlwZTpiZS5FVkVOVH0se25hbWU6ZSxkYXRhOnR9KX0pKSxwb3N0Q29tbWFuZChlLHZvaWQgMCE9PXR5cGVvZiB0Lmluc3RhbmNlKX0ocixlKTticmVhaztjYXNlIGJlLkZPUldBUkQ6IWFzeW5jIGZ1bmN0aW9uIGhhbmRsZUNvbW1hbmRGb3J3YXJkKGUsdCl7Y29uc3R7ZnVuY3Rpb25OYW1lOnIsYXJnczpvfT1lO2lmKCF0Lmluc3RhbmNlKXRocm93Imluc3RhbmNlIG5vdCBpbml0aWFsaXplZCI7aWYoIXIpdGhyb3cibWlzc2luZyBmdW5jdGlvbiBuYW1lIHRvIGNhbGwiO2lmKCF0Lmluc3RhbmNlW3JdKXRocm93YHVuZGVmaW5lZCBmdW5jdGlvbiBbJHtyfV0gaW4gY2xhc3MgJHt0Lmluc3RhbmNlLmNvbnN0cnVjdG9yLndvcmtlcklkfWA7cG9zdENvbW1hbmQoZSxhd2FpdCB0Lmluc3RhbmNlW3JdKC4uLm51bGwhPW8/bzpbXSkpfShyLGUpO2JyZWFrO2Nhc2UgYmUuVEVSTUlOQVRFOiFhc3luYyBmdW5jdGlvbiBoYW5kbGVDb21tYW5kVGVybWluYXRlKGUsdCl7Y29uc3R7YXJnczpyfT1lO2lmKCF0Lmluc3RhbmNlKXRocm93Imluc3RhbmNlIG5vdCBpbml0aWFsaXplZCI7bGV0IG87dC5pbnN0YW5jZS50ZXJtaW5hdGUmJihvPWF3YWl0IHQuaW5zdGFuY2UudGVybWluYXRlKC4uLm51bGwhPXI/cjpbXSkpLHBvc3RDb21tYW5kKGUsbyl9KHIsZSk7YnJlYWs7Y2FzZSBiZS5HTE9CQUxTX1NZTkM6IWZ1bmN0aW9uIGhhbmRsZUNvbW1hbmRHbG9iYWxzU3luYyhlKXtpZighZS5hcmdzKXRocm93Ik1pc3NpbmcgZ2xvYmFscyB3aGlsZSBzeW5jaW5nIjtjb3B5KGUuYXJnc1swXSx1ZSkscG9zdENvbW1hbmQoZSx7fSl9KHIpfX19KCk7IWZ1bmN0aW9uIHJlZ2lzdGVyV29ya2VyKGUsdCl7dC53b3JrZXJJZD1lLGlzV29ya2VyKCkmJihNZVt0LndvcmtlcklkXT10KX0oIlByb2Nlc3NvcldvcmtlciIsY2xhc3MgX1Byb2Nlc3NvcldvcmtlciBleHRlbmRzIG9le2NvbnN0cnVjdG9yKCl7c3VwZXIoLi4uYXJndW1lbnRzKSx0aGlzLnByb2Nlc3Nvcj1uZXcgQ2V9YXN5bmMgaW5pdChlPXt9KXt0aGlzLnRyYW5zZm9ybWVyPW5ldyBOb2lzZVN1cHByZXNzaW9uVHJhbnNmb3JtZXIsdGhpcy5wcm9jZXNzb3Iub25BbnkoKChlLHQpPT50aGlzLmVtaXQoZSx0KSkpLHRoaXMudHJhbnNmb3JtZXIub25BbnkoKChlLHQpPT50aGlzLmVtaXQoZSx0KSkpLGF3YWl0IHRoaXMudHJhbnNmb3JtZXIuaW5pdChlKSxhd2FpdCB0aGlzLnByb2Nlc3Nvci5zZXRUcmFuc2Zvcm1lcnMoW3RoaXMudHJhbnNmb3JtZXJdKX10cmFuc2Zvcm0oZSx0KXt0aGlzLnByb2Nlc3Nvci50cmFuc2Zvcm0oZSx0KX1zZXRBdWRpb09wdGlvbnMoZSx0LHIsbyxhKXt0aGlzLnRyYW5zZm9ybWVyPy5zZXRBdWRpb09wdGlvbnMoZSx0LHIsbyxhKX1lbmFibGUoKXt0aGlzLnRyYW5zZm9ybWVyPy5lbmFibGUoKX1kaXNhYmxlKCl7dGhpcy50cmFuc2Zvcm1lcj8uZGlzYWJsZSgpfWFzeW5jIHRlcm1pbmF0ZSgpe2F3YWl0IHRoaXMucHJvY2Vzc29yLmRlc3Ryb3koKX1nZXRXYXYoKXtyZXR1cm4gdGhpcy50cmFuc2Zvcm1lcj8uZ2V0V2F2KCk/PyIifWdldExhdGVuY3koKXtyZXR1cm4gdGhpcy50cmFuc2Zvcm1lcj8uZ2V0TGF0ZW5jeSgpPz8wfWdldFdhc21MYXRlbmN5TnMoKXtyZXR1cm4gdGhpcy50cmFuc2Zvcm1lcj8uZ2V0V2FzbUxhdGVuY3lOcygpPz8wfX0pfSgpOwo=";const blob=typeof window!=="undefined"&&window.Blob&&new Blob([atob(encodedJs)],{type:"text/javascript;charset=utf-8"});function WorkerWrapper(){let objURL;try{objURL=blob&&(window.URL||window.webkitURL).createObjectURL(blob);if(!objURL)throw"";return new Worker(objURL);}catch(e){return new Worker("data:application/javascript;base64,"+encodedJs);}finally{objURL&&(window.URL||window.webkitURL).revokeObjectURL(objURL);}}let ProcessorMain=/*#__PURE__*/function(_Emittery$3){(0,_inheritsLoose2.default)(ProcessorMain,_Emittery$3);function ProcessorMain(){var _this16;_this16=_Emittery$3.apply(this,arguments)||this;_this16.isEnabled=true;return _this16;}var _proto14=ProcessorMain.prototype;_proto14.init=/*#__PURE__*/function(){var _init3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee40(options){return _regenerator.default.wrap(function _callee40$(_context40){while(1)switch(_context40.prev=_context40.next){case 0:if(options===void 0){options={};}_context40.next=3;return this.startWorker(options);case 3:case"end":return _context40.stop();}},_callee40,this);}));function init(_x60){return _init3.apply(this,arguments);}return init;}();_proto14.enable=/*#__PURE__*/function(){var _enable=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee41(){var _this$worker;return _regenerator.default.wrap(function _callee41$(_context41){while(1)switch(_context41.prev=_context41.next){case 0:this.isEnabled=true;_context41.next=3;return(_this$worker=this.worker)==null?void 0:_this$worker.enable();case 3:case"end":return _context41.stop();}},_callee41,this);}));function enable(){return _enable.apply(this,arguments);}return enable;}();_proto14.disable=/*#__PURE__*/function(){var _disable=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee42(){var _this$worker2;return _regenerator.default.wrap(function _callee42$(_context42){while(1)switch(_context42.prev=_context42.next){case 0:this.isEnabled=false;_context42.next=3;return(_this$worker2=this.worker)==null?void 0:_this$worker2.disable();case 3:case"end":return _context42.stop();}},_callee42,this);}));function disable(){return _disable.apply(this,arguments);}return disable;}();_proto14.transform=/*#__PURE__*/function(){var _transform2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee43(readable,writable){var _this$worker3;return _regenerator.default.wrap(function _callee43$(_context43){while(1)switch(_context43.prev=_context43.next){case 0:_context43.next=2;return this.startWorker();case 2:_context43.next=4;return(_this$worker3=this.worker)==null?void 0:_this$worker3.transform(readable,writable);case 4:case"end":return _context43.stop();}},_callee43,this);}));function transform(_x61,_x62){return _transform2.apply(this,arguments);}return transform;}();_proto14.destroy=/*#__PURE__*/function(){var _destroy2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee44(){var _this$worker4;return _regenerator.default.wrap(function _callee44$(_context44){while(1)switch(_context44.prev=_context44.next){case 0:_context44.next=2;return(_this$worker4=this.worker)==null?void 0:_this$worker4.terminate();case 2:this.worker=void 0;case 3:case"end":return _context44.stop();}},_callee44,this);}));function destroy(){return _destroy2.apply(this,arguments);}return destroy;}();_proto14.setAudioOptions=/*#__PURE__*/function(){var _setAudioOptions=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee45(echo_cancellation,auto_gain_control,noise_suppression,stereo_swapping,highpass_filter){var _this$worker5;return _regenerator.default.wrap(function _callee45$(_context45){while(1)switch(_context45.prev=_context45.next){case 0:_context45.next=2;return(_this$worker5=this.worker)==null?void 0:_this$worker5.setAudioOptions(echo_cancellation,auto_gain_control,noise_suppression,stereo_swapping,highpass_filter);case 2:case"end":return _context45.stop();}},_callee45,this);}));function setAudioOptions(_x63,_x64,_x65,_x66,_x67){return _setAudioOptions.apply(this,arguments);}return setAudioOptions;}()/**
   * Return the latency of the transformation
   * The latency will be computed only if the options debug flag is true
   * Otherwise, will return 0;
   * @returns latency
   */;_proto14.getLatency=/*#__PURE__*/function(){var _getLatency=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee46(){var _this$worker$getLaten,_this$worker6;return _regenerator.default.wrap(function _callee46$(_context46){while(1)switch(_context46.prev=_context46.next){case 0:return _context46.abrupt("return",(_this$worker$getLaten=(_this$worker6=this.worker)==null?void 0:_this$worker6.getLatency())!=null?_this$worker$getLaten:0);case 1:case"end":return _context46.stop();}},_callee46,this);}));function getLatency(){return _getLatency.apply(this,arguments);}return getLatency;}()/**
   * Return the latency of processing within the wasm in nanoseconds.
   * @returns latency
   */;_proto14.getWasmLatencyNs=/*#__PURE__*/function(){var _getWasmLatencyNs=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee47(){var _this$worker$getWasmL,_this$worker7;return _regenerator.default.wrap(function _callee47$(_context47){while(1)switch(_context47.prev=_context47.next){case 0:return _context47.abrupt("return",(_this$worker$getWasmL=(_this$worker7=this.worker)==null?void 0:_this$worker7.getWasmLatencyNs())!=null?_this$worker$getWasmL:0);case 1:case"end":return _context47.stop();}},_callee47,this);}));function getWasmLatencyNs(){return _getWasmLatencyNs.apply(this,arguments);}return getWasmLatencyNs;}();_proto14.startWorker=/*#__PURE__*/function(){var _startWorker=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee48(options){return _regenerator.default.wrap(function _callee48$(_context48){while(1)switch(_context48.prev=_context48.next){case 0:if(options===void 0){options={};}if(!this.worker){_context48.next=3;break;}return _context48.abrupt("return");case 3:_context48.next=5;return workerize(ProcessorWorker,WorkerWrapper);case 5:this.worker=_context48.sent;this.worker.onAny((name,data)=>this.emit(name,data));_context48.next=9;return this.worker.init(options);case 9:if(this.isEnabled){_context48.next=12;break;}_context48.next=12;return this.worker.disable();case 12:case"end":return _context48.stop();}},_callee48,this);}));function startWorker(_x68){return _startWorker.apply(this,arguments);}return startWorker;}()/**
   * Delete the noise suppression
   */;_proto14.close=/*#__PURE__*/function(){var _close=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee49(){var _this$worker8;return _regenerator.default.wrap(function _callee49$(_context49){while(1)switch(_context49.prev=_context49.next){case 0:_context49.next=2;return(_this$worker8=this.worker)==null?void 0:_this$worker8.terminate();case 2:case"end":return _context49.stop();}},_callee49,this);}));function close(){return _close.apply(this,arguments);}return close;}()/**
   * @internal
   */;_proto14.getWav=/*#__PURE__*/function(){var _getWav=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee50(){var _yield$this$worker$ge,_this$worker9;return _regenerator.default.wrap(function _callee50$(_context50){while(1)switch(_context50.prev=_context50.next){case 0:_context50.next=2;return(_this$worker9=this.worker)==null?void 0:_this$worker9.getWav();case 2:_context50.t0=_yield$this$worker$ge=_context50.sent;if(!(_context50.t0!=null)){_context50.next=7;break;}_context50.t1=_yield$this$worker$ge;_context50.next=8;break;case 7:_context50.t1="";case 8:return _context50.abrupt("return",_context50.t1);case 9:case"end":return _context50.stop();}},_callee50,this);}));function getWav(){return _getWav.apply(this,arguments);}return getWav;}();return ProcessorMain;}(Emittery$1);let VonageNoiseSuppression=/*#__PURE__*/function(_Emittery$4){(0,_inheritsLoose2.default)(VonageNoiseSuppression,_Emittery$4);function VonageNoiseSuppression(){return _Emittery$4.apply(this,arguments)||this;}var _proto15=VonageNoiseSuppression.prototype;/**
   * Initialize the transformer.
   * It is mandatory to call this function before using the NoiseSuppression
   * @param options Options used to initialize the transformer
   */_proto15.init=/*#__PURE__*/function(){var _init4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee51(options){return _regenerator.default.wrap(function _callee51$(_context51){while(1)switch(_context51.prev=_context51.next){case 0:if(options===void 0){options={};}this.worker=new ProcessorMain();this.worker.onAny((name,data)=>this.emit(name,data));_context51.next=5;return this.worker.init(options);case 5:this.connector=new Oe(this.worker);case 6:case"end":return _context51.stop();}},_callee51,this);}));function init(_x69){return _init4.apply(this,arguments);}return init;}()/**
   * MediaProcessorConnector getter
   * @returns connector
   */;_proto15.getConnector=function getConnector(){return this.connector;}/**
   * Delete the noise suppression
   */;_proto15.close=/*#__PURE__*/function(){var _close2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee52(){var _this$worker10;return _regenerator.default.wrap(function _callee52$(_context52){while(1)switch(_context52.prev=_context52.next){case 0:_context52.next=2;return(_this$worker10=this.worker)==null?void 0:_this$worker10.close();case 2:case"end":return _context52.stop();}},_callee52,this);}));function close(){return _close2.apply(this,arguments);}return close;}()/**
   * Enable the noise reduction
   */;_proto15.enable=/*#__PURE__*/function(){var _enable2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee53(){var _this$worker11;return _regenerator.default.wrap(function _callee53$(_context53){while(1)switch(_context53.prev=_context53.next){case 0:_context53.next=2;return(_this$worker11=this.worker)==null?void 0:_this$worker11.enable();case 2:case"end":return _context53.stop();}},_callee53,this);}));function enable(){return _enable2.apply(this,arguments);}return enable;}()/**
   * Disable the noise reduction
   */;_proto15.disable=/*#__PURE__*/function(){var _disable2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee54(){var _this$worker12;return _regenerator.default.wrap(function _callee54$(_context54){while(1)switch(_context54.prev=_context54.next){case 0:_context54.next=2;return(_this$worker12=this.worker)==null?void 0:_this$worker12.disable();case 2:case"end":return _context54.stop();}},_callee54,this);}));function disable(){return _disable2.apply(this,arguments);}return disable;}()/**
   * Return the latency of the transformation
   * The latency will be computed only if the options debug flag is true
   * Otherwise, will return 0;
   * @returns latency
   */;_proto15.getLatency=/*#__PURE__*/function(){var _getLatency2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee55(){var _this$worker$getLaten2,_this$worker13;return _regenerator.default.wrap(function _callee55$(_context55){while(1)switch(_context55.prev=_context55.next){case 0:return _context55.abrupt("return",(_this$worker$getLaten2=(_this$worker13=this.worker)==null?void 0:_this$worker13.getLatency())!=null?_this$worker$getLaten2:0);case 1:case"end":return _context55.stop();}},_callee55,this);}));function getLatency(){return _getLatency2.apply(this,arguments);}return getLatency;}()/**
   * Return the latency of processing within the wasm in nanoseconds.
   * @returns latency
   */;_proto15.getWasmLatencyNs=/*#__PURE__*/function(){var _getWasmLatencyNs2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee56(){var _this$worker$getWasmL2,_this$worker14;return _regenerator.default.wrap(function _callee56$(_context56){while(1)switch(_context56.prev=_context56.next){case 0:return _context56.abrupt("return",(_this$worker$getWasmL2=(_this$worker14=this.worker)==null?void 0:_this$worker14.getWasmLatencyNs())!=null?_this$worker$getWasmL2:0);case 1:case"end":return _context56.stop();}},_callee56,this);}));function getWasmLatencyNs(){return _getWasmLatencyNs2.apply(this,arguments);}return getWasmLatencyNs;}()/**
   * @internal
   */;_proto15.getWav=/*#__PURE__*/function(){var _getWav2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee57(){var _yield$this$worker$ge2,_this$worker15;return _regenerator.default.wrap(function _callee57$(_context57){while(1)switch(_context57.prev=_context57.next){case 0:_context57.next=2;return(_this$worker15=this.worker)==null?void 0:_this$worker15.getWav();case 2:_context57.t0=_yield$this$worker$ge2=_context57.sent;if(!(_context57.t0!=null)){_context57.next=7;break;}_context57.t1=_yield$this$worker$ge2;_context57.next=8;break;case 7:_context57.t1="";case 8:return _context57.abrupt("return",_context57.t1);case 9:case"end":return _context57.stop();}},_callee57,this);}));function getWav(){return _getWav2.apply(this,arguments);}return getWav;}();return VonageNoiseSuppression;}(Emittery$1);exports.VonageNoiseSuppression=VonageNoiseSuppression;function createVonageNoiseSuppression(){return new VonageNoiseSuppression();}const defaultAssetsDirBaseUrl=`https://d3opqjmqzxf057.cloudfront.net/noise-suppression/${version}`;let WavExporterTransformer=/*#__PURE__*/function(){function WavExporterTransformer(){}var _proto16=WavExporterTransformer.prototype;_proto16.init=/*#__PURE__*/function(){var _init5=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee58(options){var _options$assetsDirBas2;var assetsDirBaseUrl,locateFile;return _regenerator.default.wrap(function _callee58$(_context58){while(1)switch(_context58.prev=_context58.next){case 0:if(options===void 0){options={};}console.log("Wav exporter transformer initialization");assetsDirBaseUrl=(_options$assetsDirBas2=options.assetsDirBaseUrl)!=null?_options$assetsDirBas2:defaultAssetsDirBaseUrl;locateFile=name=>`${assetsDirBaseUrl}/${name}`;_context58.next=6;return createWasmMonoInstance({locateFile,mainScriptUrlOrBlob:locateFile("main-bin-mono.js")});case 6:this.wasmInstance=_context58.sent;console.log("Wav exporter transformer ready");case 8:case"end":return _context58.stop();}},_callee58,this);}));function init(_x70){return _init5.apply(this,arguments);}return init;}();_proto16.transform=function transform(data,controller){if(!this.wasmTransformer){this.wasmTransformer=new this.wasmInstance.WavExporter(data.sampleRate,1);}if(this.wasmTransformer){const dataAsInt16=this.getAudioDataAsInt16(data);const inputFrame=this.wasmTransformer.getInputFrame(dataAsInt16.length);inputFrame.set(dataAsInt16);this.wasmTransformer.push(data.numberOfFrames,data.sampleRate,data.numberOfChannels);}controller.enqueue(data);};_proto16.getWav=function getWav(){if(!this.wasmTransformer){return"";}this.wasmTransformer.close();const buffer=this.wasmTransformer.getWav();const base64=btoa(new Uint8Array(buffer).reduce((data,byte)=>data+String.fromCharCode(byte),""));return`data:audio/wav;base64,${base64}`;};_proto16.getAudioDataAsInt16=function getAudioDataAsInt16(data){const dataAsFloat32=this.getAudioDataAsFloat32(data);const result=new Int16Array(dataAsFloat32.length);for(let i=0;i<dataAsFloat32.length;++i){result[i]=Math.round(dataAsFloat32[i]*((1<<16)-1));}return result;};_proto16.getAudioDataAsFloat32=function getAudioDataAsFloat32(data){return this.audioDataToTypedArray(data,Float32Array,"f32-planar",1);};_proto16.audioDataToTypedArray=function audioDataToTypedArray(data,typeArrayClass,format,numberOfChannels){if(numberOfChannels===void 0){numberOfChannels=data.numberOfChannels;}const size=data.numberOfFrames*numberOfChannels;const buffer=new typeArrayClass(size);for(let i=0;i<numberOfChannels;++i){const offset=data.numberOfFrames*i;const samples=buffer.subarray(offset,offset+data.numberOfFrames);data.copyTo(samples,{planeIndex:i,format});}return buffer;};return WavExporterTransformer;}();exports.WavExporterTransformer=WavExporterTransformer;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(24)))

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _events = _interopRequireDefault(__webpack_require__(12));
var _audioFallbackVideoStateMachine = _interopRequireDefault(__webpack_require__(752));
var _audioFallbackVideoStates = _interopRequireDefault(__webpack_require__(77));
var _congestionLevels = __webpack_require__(28);
const ACTIVE_VIDEO = _audioFallbackVideoStates.default.ACTIVE_VIDEO,
  ACTIVE_VIDEO_WITH_WARNING = _audioFallbackVideoStates.default.ACTIVE_VIDEO_WITH_WARNING,
  SUSPENDED_VIDEO = _audioFallbackVideoStates.default.SUSPENDED_VIDEO;
const createAudioFallbackCoordinator = _ref => {
  let getAllPeerConnections = _ref.getAllPeerConnections;
  const ee = new _events.default();
  const audioFallbackStateMachine = (0, _audioFallbackVideoStateMachine.default)();
  audioFallbackStateMachine.on('stateChange', function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ee.emit('stateChange', ...args);
  });
  const calculateState = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var pcs, publisherVideoState;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAllPeerConnections();
          case 2:
            pcs = _context.sent;
            publisherVideoState = pcs.reduce((acc, pc) => {
              var _pc$getAudioFallbackS;
              return Math.max(acc, (_pc$getAudioFallbackS = pc.getAudioFallbackState()) == null ? void 0 : _pc$getAudioFallbackS.videoState);
            }, ACTIVE_VIDEO);
            audioFallbackStateMachine.setState(publisherVideoState);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function calculateState() {
      return _ref2.apply(this, arguments);
    };
  }();
  const onPeerConnectionStateChange = _ref3 => {
    let videoState = _ref3.state,
      peerConnection = _ref3.peerConnection,
      publishVideo = _ref3.publishVideo,
      stream = _ref3.stream,
      peerId = _ref3.peerId;
    if (publishVideo) {
      const subscriberId = peerConnection.getSourceStreamId() === 'MANTIS' ? undefined : peerId;
      const setStreamChannelActiveState = _ref4 => {
        let activeState = _ref4.activeState,
          congestionLevel = _ref4.congestionLevel;
        stream.setChannelActiveState({
          activeState,
          congestionLevel,
          channelType: 'video',
          activeReason: 'auto',
          subscriberId
        });
      };
      switch (videoState) {
        case ACTIVE_VIDEO:
          setStreamChannelActiveState({
            activeState: true,
            congestionLevel: _congestionLevels.LOW
          });
          break;
        case ACTIVE_VIDEO_WITH_WARNING:
          setStreamChannelActiveState({
            activeState: true,
            congestionLevel: _congestionLevels.MEDIUM
          });
          break;
        case SUSPENDED_VIDEO:
          setStreamChannelActiveState({
            activeState: false,
            congestionLevel: _congestionLevels.CRITICAL
          });
          break;
        default:
          break;
      }
    }
    calculateState();
  };
  return Object.assign(ee, {
    onPeerConnectionStateChange,
    onPeerConnectionDisconnected: () => {
      calculateState();
    },
    reset: () => audioFallbackStateMachine.reset(),
    getState: () => audioFallbackStateMachine.getState()
  });
};
var _default = createAudioFallbackCoordinator;
exports.default = _default;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _events = _interopRequireDefault(__webpack_require__(12));
var _audioFallbackVideoStates = _interopRequireDefault(__webpack_require__(77));
const createAudioFallbackVideoStateMachine = () => {
  const ee = new _events.default();
  let state = _audioFallbackVideoStates.default.ACTIVE_VIDEO;
  return Object.assign(ee, {
    getState() {
      return state;
    },
    setState(newState) {
      if (!Object.values(_audioFallbackVideoStates.default).includes(newState)) {
        throw new Error('Invalid video state: ', newState);
      }
      if (newState === state) {
        return;
      }
      const previousState = state;
      state = newState;
      ee.emit('stateChange', {
        state,
        previousState
      });
    },
    reset() {
      state = _audioFallbackVideoStates.default.ACTIVE_VIDEO;
    }
  });
};
var _default = createAudioFallbackVideoStateMachine;
exports.default = _default;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = blockCallsUntilComplete;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
// Block subsequent calls to an async function until the previous call has completed
// Throws an error if you call the function too soon.
function blockCallsUntilComplete(fn) {
  let blocked = false;
  return /*#__PURE__*/function () {
    var _blocker = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _len,
        args,
        _key,
        _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!blocked) {
              _context.next = 2;
              break;
            }
            throw new Error('The previous call to this function has not yet completed.');
          case 2:
            blocked = true;
            _context.prev = 3;
            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }
            _context.next = 7;
            return fn.call(this, ...args);
          case 7:
            return _context.abrupt("return", _context.sent);
          case 8:
            _context.prev = 8;
            blocked = false;
            return _context.finish(8);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[3,, 8, 11]]);
    }));
    function blocker() {
      return _blocker.apply(this, arguments);
    }
    return blocker;
  }();
}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _pick = _interopRequireDefault(__webpack_require__(39));
var _sanitizeVideoFilter = _interopRequireDefault(__webpack_require__(345));
var _style_hash_log_filter = _interopRequireDefault(__webpack_require__(293));
// We whitelist property keys for logging purposes
var _default = x => {
  const whitelistedProperties = (0, _pick.default)(x, ['audioDeviceId', 'audioFallback', 'audioFallbackEnabled', 'audioSource', 'audioFilter', 'channels', 'classNames', 'constraints', 'disableAudioInputDeviceManagement', 'disableAudioProcessing', 'echoCancellation', 'noiseSuppression', 'autoGainControl', 'enableRenegotiation', 'enableStereo', 'facingMode', 'fitMode', 'frameRate', 'height', 'insertDefaultUI', 'insertMode', 'audioBitrate', 'maxResolution', 'minVideoBitrate', 'mirror', 'name', 'publishAudio', 'publishVideo', 'publishCaptions', 'resolution', 'scalableScreenshare', 'scalableVideo', 'showControls', 'style', 'videoContentHint', 'videoDeviceId', 'videoDimensions', 'videoFilter', 'videoSource', 'width']);
  if (whitelistedProperties.style) {
    whitelistedProperties.style = (0, _style_hash_log_filter.default)(whitelistedProperties.style);
  }
  if (whitelistedProperties.videoFilter) {
    whitelistedProperties.videoFilter = (0, _sanitizeVideoFilter.default)(whitelistedProperties.videoFilter);
  }
  return whitelistedProperties;
};
exports.default = _default;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _now = _interopRequireDefault(__webpack_require__(51));
var _RafRunner = _interopRequireDefault(__webpack_require__(112));
var _events = _interopRequireDefault(__webpack_require__(18));
const Events = (0, _events.default)();
var _default = _ref => {
  let publisher = _ref.publisher,
    widgetView = _ref.widgetView;
  let loudness = 0;
  let loudnessLastAccess = 0;
  const audioLevelRunner = new _RafRunner.default(() => {
    const listenerCount = publisher.listenerCount(_eventNames.default.AUDIO_LEVEL_UPDATED);
    const shouldStopWatchingAudio = () => (0, _now.default)() - loudnessLastAccess > 10000 && listenerCount === 0;
    if (shouldStopWatchingAudio()) {
      audioLevelRunner.stop();
      return;
    }
    const video = widgetView && widgetView.video();
    if (video) {
      const audioInputLevel = video.getAudioInputLevel();
      loudness = audioInputLevel;
      if (listenerCount > 0) {
        // dispatch this old event if someone is listening...
        publisher.dispatchEvent(new Events.AudioLevelUpdatedEvent(audioInputLevel));
      }
    }
  });
  Object.defineProperty(publisher, 'loudness', {
    get() {
      audioLevelRunner.start();
      loudnessLastAccess = (0, _now.default)();
      return loudness;
    },
    set() {
      throw new TypeError('Cannot set readonly property loudness');
    }
  });
  if (publisher.listenerCount(_eventNames.default.AUDIO_LEVEL_UPDATED)) {
    audioLevelRunner.start();
  }
  publisher.on('audioLevelUpdated:added', () => {
    audioLevelRunner.start();
  });
  publisher.once(_eventNames.default.PUBLISHER_DESTROYED, () => {
    audioLevelRunner.stop();
  });
};
exports.default = _default;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = createCanvasVideoTrack;
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
const otError = (0, _otError.default)();
function createCanvasVideoTrack(dimensions) {
  const canvas = document.createElement('canvas');
  if (!canvas.captureStream) {
    throw otError(_Errors.default.NOT_SUPPORTED, new Error('Your browser does not support HTMLCanvasElement.captureStream()'));
  }
  canvas.width = dimensions.width;
  canvas.height = dimensions.height;
  canvas.getContext('2d').fillRect(0, 0, 1, 1);
  const _canvas$captureStream = canvas.captureStream().getVideoTracks(),
    canvasTrack = _canvas$captureStream[0];
  canvasTrack.isCreatedCanvas = true;

  // we never actually intend to send frames from the canvas so it gets disabled
  canvasTrack.enabled = false;
  return canvasTrack;
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// This strategy will work on modern browsers
const getDeviceIdFromSettings = videoTrack => videoTrack.getSettings && videoTrack.getSettings().deviceId;

// Legacy browsers, like Firefox 52, require this strategy
const getDeviceIdFromConstraints = videoTrack => {
  let deviceId;
  if (videoTrack.getConstraints && videoTrack.getConstraints().deviceId) {
    deviceId = videoTrack.getConstraints().deviceId.exact;
  }
  return deviceId;
};

// Look for the current device Id in the device list.
const getDeviceIdFromDevicesList = (videoTrack, videoDevices) => {
  let deviceId;
  if (videoDevices && videoDevices.length) {
    const currentDevice = videoDevices.find(device => device.label === videoTrack.label);
    if (currentDevice) {
      deviceId = currentDevice.deviceId;
    }
  }
  return deviceId;
};
const getDeviceId = (videoTrack, videoDevices) => getDeviceIdFromSettings(videoTrack) || getDeviceIdFromConstraints(videoTrack) || getDeviceIdFromDevicesList(videoTrack, videoDevices);
var _default = (stream, videoDevices) => {
  if (!stream) {
    return null;
  }
  const _stream$getVideoTrack = stream.getVideoTracks(),
    videoTrack = _stream$getVideoTrack[0];
  if (!videoTrack) {
    return null;
  }
  return getDeviceId(videoTrack, videoDevices);
};
exports.default = _default;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _otError = _interopRequireDefault(__webpack_require__(15));
const otError = (0, _otError.default)();
var _default = error => {
  // @todo Can we provide more specific errors for these codes? Are these still the only
  // codes that we expect?
  // Error codes: https://github.com/opentok/rumor-reloaded/blob/develop/rumor/src/main/java/com/tokbox/symphony/control/ErrorResponses.java
  const expectedErrorCodes = ['403',
  // FORBIDDEN ERRORS: forbiddenConnection
  '404',
  // NOT FOUND ERRORS: streamNotFound
  '409' // CONFLICT ERRORS: streamLimitExceeded
  ];

  const errorCodeStr = String(error.code);
  if (errorCodeStr === '405' && error.message === 'IncompatibleEncryptionSettings') {
    return otError(_Errors.default.STREAM_CREATE_FAILED, new Error('IncompatibleEncryptionSettings: Tried to publish a stream to an encrypted session without enabling encryption'), _exception_codes.default.UNABLE_TO_PUBLISH);
  }
  return expectedErrorCodes.includes(errorCodeStr) ? otError(_Errors.default.STREAM_CREATE_FAILED, new Error(`Failed to create stream in server model: ${error.message}`), _exception_codes.default.UNABLE_TO_PUBLISH) : otError(_Errors.default.UNEXPECTED_SERVER_RESPONSE, new Error(`Unexpected server response: ${error.message}`), _exception_codes.default.UNEXPECTED_SERVER_RESPONSE);
};
exports.default = _default;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _log = _interopRequireDefault(__webpack_require__(1));
var _env = _interopRequireDefault(__webpack_require__(3));
var _ml = _interopRequireDefault(__webpack_require__(346));
var _mediaTransform = _interopRequireDefault(__webpack_require__(762));
var _proxyUrl = __webpack_require__(72);
const logging = (0, _log.default)('MediaProcessor');
function MediaProcessor(deps) {
  var _this = this;
  if (deps === void 0) {
    deps = {};
  }
  const _deps = deps,
    _deps$ML = _deps.ML,
    ML = _deps$ML === void 0 ? _ml.default : _deps$ML,
    _deps$MediaTransform = _deps.MediaTransform,
    MediaTransform = _deps$MediaTransform === void 0 ? _mediaTransform.default : _deps$MediaTransform,
    _deps$getProxyUrl = _deps.getProxyUrl,
    getProxyUrl = _deps$getProxyUrl === void 0 ? _proxyUrl.getProxyUrl : _deps$getProxyUrl;
  let connector;
  let processor;
  let videoFilter;
  let originalVideoTrack;
  this.isValidVideoFilter = filter => {
    const type = filter.type;
    return MediaTransform.isSupported(type) && MediaTransform.isValidConfig(filter);
  };
  this.canUpdateVideoFilter = filterType => ['backgroundBlur', 'backgroundReplacement'].includes(filterType);
  this.updateVideoFilter = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(filter) {
      var type, configurator, fullConfig;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            type = filter.type;
            if (_this.canUpdateVideoFilter(type)) {
              _context.next = 4;
              break;
            }
            logging.warn(`Ignoring: filter "${type}" doesn't support real-time updates`);
            return _context.abrupt("return");
          case 4:
            configurator = MediaTransform.getConfigurator(type); // The config passed in may be a simplified configuration missing URLs for static
            // assets, for example.  We need the "full configuration".
            fullConfig = configurator.getConfig(Object.assign({
              proxyUrl: getProxyUrl()
            }, filter));
            _context.next = 8;
            return processor.setBackgroundOptions(fullConfig);
          case 8:
            videoFilter = filter;
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
  this.setVideoFilter = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(newVideoFilter) {
      var type, configurator, fullConfig, hasFilterAlready;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            type = newVideoFilter.type;
            configurator = MediaTransform.getConfigurator(type);
            if (configurator) {
              _context2.next = 5;
              break;
            }
            logging.warn(`Ignoring: filter "${type}" isn't supported`);
            return _context2.abrupt("return");
          case 5:
            // The config passed in may be a simplified configuration missing URLs for static
            // assets, for example.  We need the "full configuration".
            fullConfig = configurator.getConfig(Object.assign({
              proxyUrl: getProxyUrl()
            }, newVideoFilter));
            if (fullConfig) {
              _context2.next = 9;
              break;
            }
            logging.warn(`Ignoring: couldn't configure filter ${type}`);
            return _context2.abrupt("return");
          case 9:
            hasFilterAlready = !!_this.getVideoFilter();
            if (!hasFilterAlready) {
              _context2.next = 20;
              break;
            }
            _context2.prev = 11;
            _context2.next = 14;
            return _this.destroy();
          case 14:
            _context2.next = 20;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](11);
            logging.warn(`Ignoring, couldn't remove previous filter: ${_context2.t0}`);
            return _context2.abrupt("return");
          case 20:
            _context2.next = 22;
            return ML.createProcessor(fullConfig);
          case 22:
            processor = _context2.sent;
            _context2.next = 25;
            return processor.getConnector();
          case 25:
            connector = _context2.sent;
            videoFilter = newVideoFilter;
          case 27:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[11, 16]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  this.getVideoFilter = () => videoFilter;
  this.getOriginalVideoTrack = () => originalVideoTrack;
  this.setMediaStream = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(stream) {
      var _stream$getVideoTrack, videoTrack, filteredVideoTrack;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _stream$getVideoTrack = stream.getVideoTracks(), videoTrack = _stream$getVideoTrack[0];
            if (videoTrack) {
              _context3.next = 4;
              break;
            }
            logging.warn('Ignoring. No video track found');
            return _context3.abrupt("return", null);
          case 4:
            // Returning null, instead of undefined, to be consistent with the case
            // above
            filteredVideoTrack = null;
            _context3.prev = 5;
            _context3.next = 8;
            return connector.setTrack(videoTrack);
          case 8:
            filteredVideoTrack = _context3.sent;
            originalVideoTrack = videoTrack;
            _context3.next = 15;
            break;
          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](5);
            logging.error(`Error setting media stream: ${_context3.t0}`);
          case 15:
            return _context3.abrupt("return", filteredVideoTrack);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[5, 12]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  this.setVideoTrack = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(videoTrack) {
      var filteredVideoTrack;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            filteredVideoTrack = null;
            _context4.prev = 1;
            _context4.next = 4;
            return connector.setTrack(videoTrack);
          case 4:
            filteredVideoTrack = _context4.sent;
            originalVideoTrack = videoTrack;
            _context4.next = 11;
            break;
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](1);
            logging.error(`Error setting video track: ${_context4.t0}`);
          case 11:
            return _context4.abrupt("return", filteredVideoTrack);
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  // Needed to make unit testing easier
  this._setConnector = newConnector => {
    connector = newConnector;
  };
  this.destroy = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return connector.destroy();
        case 3:
          _context5.next = 8;
          break;
        case 5:
          _context5.prev = 5;
          _context5.t0 = _context5["catch"](0);
          logging.warn(`Error destroying connector: ${_context5.t0}`);
        case 8:
          connector = null;
          videoFilter = null;
          originalVideoTrack = null;
        case 11:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 5]]);
  }));
  this.enableLogging = apiKey => {
    if (!apiKey) {
      logging.warn('Error enabling logging: invalid API key');
      return;
    }
    const metadata = {
      appId: apiKey,
      sourceType: 'video'
    };
    const proxyUrl = getProxyUrl();
    if (proxyUrl) {
      metadata.proxyUrl = proxyUrl;
    }
    ML.setMetadata(metadata);
  };
  this.disableLogging = () => {
    // ML doesn't have an explicit method to disable logging (e.g.,
    // `ML.disableLogging`).  Instead, clearing metadata disables it.
    ML.setMetadata();
  };
}
MediaProcessor.isSupported = function (deps) {
  if (deps === void 0) {
    deps = {};
  }
  const _deps2 = deps,
    _deps2$env = _deps2.env,
    env = _deps2$env === void 0 ? _env.default : _deps2$env,
    _deps2$ML = _deps2.ML,
    ML = _deps2$ML === void 0 ? _ml.default : _deps2$ML;

  // Even though other browsers may support this API, we're going to limit it
  // to just Chromium-based browsers for now.
  return !!env.isChromium && ML.isSupported();
};
var _default = MediaProcessor;
exports.default = _default;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise, process) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.WarningType = exports.VonageSourceType = exports.PipelineInfoData = exports.MediaProcessorConnector = exports.MediaProcessor = exports.ErrorFunction = void 0;
exports.getVonageMetadata = x;
exports.isSupported = Ie;
exports.setVonageMetadata = xe;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _createClass2 = _interopRequireDefault(__webpack_require__(25));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _globalThis = function (Object) {
  function get() {
    var _global = this || self;
    delete Object.prototype.__magic__;
    return _global;
  }
  if (typeof globalThis === "object") {
    return globalThis;
  }
  if (this) {
    return get();
  } else {
    Object.defineProperty(Object.prototype, "__magic__", {
      configurable: true,
      get: get
    });
    var _global = __magic__;
    return _global;
  }
}(Object);
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Ie() {
  return new Promise((t, e) => {
    typeof MediaStreamTrackProcessor > "u" || typeof MediaStreamTrackGenerator > "u" ? e("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.") : t();
  });
}
let l = function l() {};
l.updates = {
  transformer_new: "New transformer",
  transformer_null: "Null transformer"
};
l.errors = {
  transformer_none: "No transformers provided",
  transformer_start: "Cannot start transformer",
  transformer_transform: "Cannot transform frame",
  transformer_flush: "Cannot flush transformer",
  readable_null: "Readable is null",
  writable_null: "Writable is null"
};
function j(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
const f = /* @__PURE__ */new WeakMap(),
  T = /* @__PURE__ */new WeakMap(),
  g = /* @__PURE__ */new WeakMap(),
  C = Symbol("anyProducer"),
  U = Promise.resolve(),
  S = Symbol("listenerAdded"),
  R = Symbol("listenerRemoved");
let A = !1;
function p(t) {
  if (typeof t != "string" && typeof t != "symbol") throw new TypeError("eventName must be a string or a symbol");
}
function b(t) {
  if (typeof t != "function") throw new TypeError("listener must be a function");
}
function m(t, e) {
  const r = T.get(t);
  return r.has(e) || r.set(e, /* @__PURE__ */new Set()), r.get(e);
}
function _(t, e) {
  const r = typeof e == "string" || typeof e == "symbol" ? e : C,
    s = g.get(t);
  return s.has(r) || s.set(r, /* @__PURE__ */new Set()), s.get(r);
}
function B(t, e, r) {
  const s = g.get(t);
  if (s.has(e)) {
    for (var _iterator = _createForOfIteratorHelperLoose(s.get(e)), _step; !(_step = _iterator()).done;) {
      const i = _step.value;
      i.enqueue(r);
    }
  }
  if (s.has(C)) {
    const i = Promise.all([e, r]);
    for (var _iterator2 = _createForOfIteratorHelperLoose(s.get(C)), _step2; !(_step2 = _iterator2()).done;) {
      const n = _step2.value;
      n.enqueue(i);
    }
  }
}
function D(t, e) {
  e = Array.isArray(e) ? e : [e];
  let r = !1,
    s = () => {},
    i = [];
  const n = {
    enqueue(o) {
      i.push(o), s();
    },
    finish() {
      r = !0, s();
    }
  };
  for (var _iterator3 = _createForOfIteratorHelperLoose(e), _step3; !(_step3 = _iterator3()).done;) {
    const o = _step3.value;
    _(t, o).add(n);
  }
  return {
    next() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!i) {
                _context.next = 20;
                break;
              }
              if (!(i.length === 0)) {
                _context.next = 12;
                break;
              }
              if (!r) {
                _context.next = 6;
                break;
              }
              _context.t2 = (i = void 0, _this.next());
              _context.next = 9;
              break;
            case 6:
              _context.next = 8;
              return new Promise(o => {
                s = o;
              });
            case 8:
              _context.t2 = _this.next();
            case 9:
              _context.t1 = _context.t2;
              _context.next = 17;
              break;
            case 12:
              _context.t3 = !1;
              _context.next = 15;
              return i.shift();
            case 15:
              _context.t4 = _context.sent;
              _context.t1 = {
                done: _context.t3,
                value: _context.t4
              };
            case 17:
              _context.t0 = _context.t1;
              _context.next = 21;
              break;
            case 20:
              _context.t0 = {
                done: !0
              };
            case 21:
              return _context.abrupt("return", _context.t0);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    return(o) {
      var _arguments = arguments;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _iterator4, _step4, a;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              i = void 0;
              for (_iterator4 = _createForOfIteratorHelperLoose(e); !(_step4 = _iterator4()).done;) {
                a = _step4.value;
                _(t, a).delete(n);
              }
              s();
              if (!(_arguments.length > 0)) {
                _context2.next = 11;
                break;
              }
              _context2.t1 = !0;
              _context2.next = 7;
              return o;
            case 7:
              _context2.t2 = _context2.sent;
              _context2.t0 = {
                done: _context2.t1,
                value: _context2.t2
              };
              _context2.next = 12;
              break;
            case 11:
              _context2.t0 = {
                done: !0
              };
            case 12:
              return _context2.abrupt("return", _context2.t0);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function $(t) {
  if (t === void 0) return G;
  if (!Array.isArray(t)) throw new TypeError("`methodNames` must be an array of strings");
  for (var _iterator5 = _createForOfIteratorHelperLoose(t), _step5; !(_step5 = _iterator5()).done;) {
    const e = _step5.value;
    if (!G.includes(e)) throw typeof e != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${e} is not Emittery method`);
  }
  return t;
}
const M = t => t === S || t === R;
let d = /*#__PURE__*/function () {
  d.mixin = function mixin(e, r) {
    return r = $(r), s => {
      if (typeof s != "function") throw new TypeError("`target` must be function");
      for (var _iterator6 = _createForOfIteratorHelperLoose(r), _step6; !(_step6 = _iterator6()).done;) {
        const o = _step6.value;
        if (s.prototype[o] !== void 0) throw new Error(`The property \`${o}\` already exists on \`target\``);
      }
      function i() {
        return Object.defineProperty(this, e, {
          enumerable: !1,
          value: new d()
        }), this[e];
      }
      Object.defineProperty(s.prototype, e, {
        enumerable: !1,
        get: i
      });
      const n = o => function () {
        return this[e][o](...arguments);
      };
      for (var _iterator7 = _createForOfIteratorHelperLoose(r), _step7; !(_step7 = _iterator7()).done;) {
        const o = _step7.value;
        Object.defineProperty(s.prototype, o, {
          enumerable: !1,
          value: n(o)
        });
      }
      return s;
    };
  };
  function d(e) {
    if (e === void 0) {
      e = {};
    }
    f.set(this, /* @__PURE__ */new Set()), T.set(this, /* @__PURE__ */new Map()), g.set(this, /* @__PURE__ */new Map()), this.debug = e.debug || {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (r, s, i, n) => {
      try {
        n = JSON.stringify(n);
      } catch (_unused) {
        n = `Object with the following keys failed to stringify: ${Object.keys(n).join(",")}`;
      }
      typeof i == "symbol" && (i = i.toString());
      const o = /* @__PURE__ */new Date(),
        a = `${o.getHours()}:${o.getMinutes()}:${o.getSeconds()}.${o.getMilliseconds()}`;
      console.log(`[${a}][emittery:${r}][${s}] Event Name: ${i}
	data: ${n}`);
    });
  }
  var _proto = d.prototype;
  _proto.logIfDebugEnabled = function logIfDebugEnabled(e, r, s) {
    (d.isDebugEnabled || this.debug.enabled) && this.debug.logger(e, this.debug.name, r, s);
  };
  _proto.on = function on(e, r) {
    b(r), e = Array.isArray(e) ? e : [e];
    for (var _iterator8 = _createForOfIteratorHelperLoose(e), _step8; !(_step8 = _iterator8()).done;) {
      const s = _step8.value;
      p(s), m(this, s).add(r), this.logIfDebugEnabled("subscribe", s, void 0), M(s) || this.emit(S, {
        eventName: s,
        listener: r
      });
    }
    return this.off.bind(this, e, r);
  };
  _proto.off = function off(e, r) {
    b(r), e = Array.isArray(e) ? e : [e];
    for (var _iterator9 = _createForOfIteratorHelperLoose(e), _step9; !(_step9 = _iterator9()).done;) {
      const s = _step9.value;
      p(s), m(this, s).delete(r), this.logIfDebugEnabled("unsubscribe", s, void 0), M(s) || this.emit(R, {
        eventName: s,
        listener: r
      });
    }
  };
  _proto.once = function once(e) {
    return new Promise(r => {
      const s = this.on(e, i => {
        s(), r(i);
      });
    });
  };
  _proto.events = function events(e) {
    e = Array.isArray(e) ? e : [e];
    for (var _iterator10 = _createForOfIteratorHelperLoose(e), _step10; !(_step10 = _iterator10()).done;) {
      const r = _step10.value;
      p(r);
    }
    return D(this, e);
  };
  _proto.emit = /*#__PURE__*/function () {
    var _emit = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(e, r) {
      var s, i, n, o;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            p(e), this.logIfDebugEnabled("emit", e, r), B(this, e, r);
            s = m(this, e), i = f.get(this), n = [...s], o = M(e) ? [] : [...i];
            _context5.next = 4;
            return U;
          case 4:
            _context5.next = 6;
            return Promise.all([...n.map( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(a) {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!s.has(a)) {
                        _context3.next = 2;
                        break;
                      }
                      return _context3.abrupt("return", a(r));
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }()), ...o.map( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(a) {
                return _regenerator.default.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      if (!i.has(a)) {
                        _context4.next = 2;
                        break;
                      }
                      return _context4.abrupt("return", a(e, r));
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }())]);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function emit(_x, _x2) {
      return _emit.apply(this, arguments);
    }
    return emit;
  }();
  _proto.emitSerial = /*#__PURE__*/function () {
    var _emitSerial = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(e, r) {
      var s, i, n, o, _i, _n, a, _i2, _o;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            p(e), this.logIfDebugEnabled("emitSerial", e, r);
            s = m(this, e), i = f.get(this), n = [...s], o = [...i];
            _context6.next = 4;
            return U;
          case 4:
            _i = 0, _n = n;
          case 5:
            if (!(_i < _n.length)) {
              _context6.next = 14;
              break;
            }
            a = _n[_i];
            _context6.t0 = s.has(a);
            if (!_context6.t0) {
              _context6.next = 11;
              break;
            }
            _context6.next = 11;
            return a(r);
          case 11:
            _i++;
            _context6.next = 5;
            break;
          case 14:
            _i2 = 0, _o = o;
          case 15:
            if (!(_i2 < _o.length)) {
              _context6.next = 24;
              break;
            }
            a = _o[_i2];
            _context6.t1 = i.has(a);
            if (!_context6.t1) {
              _context6.next = 21;
              break;
            }
            _context6.next = 21;
            return a(e, r);
          case 21:
            _i2++;
            _context6.next = 15;
            break;
          case 24:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function emitSerial(_x5, _x6) {
      return _emitSerial.apply(this, arguments);
    }
    return emitSerial;
  }();
  _proto.onAny = function onAny(e) {
    return b(e), this.logIfDebugEnabled("subscribeAny", void 0, void 0), f.get(this).add(e), this.emit(S, {
      listener: e
    }), this.offAny.bind(this, e);
  };
  _proto.anyEvent = function anyEvent() {
    return D(this);
  };
  _proto.offAny = function offAny(e) {
    b(e), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), this.emit(R, {
      listener: e
    }), f.get(this).delete(e);
  };
  _proto.clearListeners = function clearListeners(e) {
    e = Array.isArray(e) ? e : [e];
    for (var _iterator11 = _createForOfIteratorHelperLoose(e), _step11; !(_step11 = _iterator11()).done;) {
      const r = _step11.value;
      if (this.logIfDebugEnabled("clear", r, void 0), typeof r == "string" || typeof r == "symbol") {
        m(this, r).clear();
        const s = _(this, r);
        for (var _iterator12 = _createForOfIteratorHelperLoose(s), _step12; !(_step12 = _iterator12()).done;) {
          const i = _step12.value;
          i.finish();
        }
        s.clear();
      } else {
        f.get(this).clear();
        for (var _iterator13 = _createForOfIteratorHelperLoose(T.get(this).values()), _step13; !(_step13 = _iterator13()).done;) {
          const s = _step13.value;
          s.clear();
        }
        for (var _iterator14 = _createForOfIteratorHelperLoose(g.get(this).values()), _step14; !(_step14 = _iterator14()).done;) {
          const s = _step14.value;
          for (var _iterator15 = _createForOfIteratorHelperLoose(s), _step15; !(_step15 = _iterator15()).done;) {
            const i = _step15.value;
            i.finish();
          }
          s.clear();
        }
      }
    }
  };
  _proto.listenerCount = function listenerCount(e) {
    e = Array.isArray(e) ? e : [e];
    let r = 0;
    for (var _iterator16 = _createForOfIteratorHelperLoose(e), _step16; !(_step16 = _iterator16()).done;) {
      const s = _step16.value;
      if (typeof s == "string") {
        r += f.get(this).size + m(this, s).size + _(this, s).size + _(this).size;
        continue;
      }
      typeof s < "u" && p(s), r += f.get(this).size;
      for (var _iterator17 = _createForOfIteratorHelperLoose(T.get(this).values()), _step17; !(_step17 = _iterator17()).done;) {
        const i = _step17.value;
        r += i.size;
      }
      for (var _iterator18 = _createForOfIteratorHelperLoose(g.get(this).values()), _step18; !(_step18 = _iterator18()).done;) {
        const i = _step18.value;
        r += i.size;
      }
    }
    return r;
  };
  _proto.bindMethods = function bindMethods(e, r) {
    if (typeof e != "object" || e === null) throw new TypeError("`target` must be an object");
    r = $(r);
    for (var _iterator19 = _createForOfIteratorHelperLoose(r), _step19; !(_step19 = _iterator19()).done;) {
      const s = _step19.value;
      if (e[s] !== void 0) throw new Error(`The property \`${s}\` already exists on \`target\``);
      Object.defineProperty(e, s, {
        enumerable: !1,
        value: this[s].bind(this)
      });
    }
  };
  (0, _createClass2.default)(d, null, [{
    key: "isDebugEnabled",
    get: function get() {
      if (typeof process != "object") return A;
      const _ref3 = process || {
          env: {}
        },
        e = _ref3.env;
      return e.DEBUG === "emittery" || e.DEBUG === "*" || A;
    },
    set: function set(e) {
      A = e;
    }
  }]);
  return d;
}();
const G = Object.getOwnPropertyNames(d.prototype).filter(t => t !== "constructor");
Object.defineProperty(d, "listenerAdded", {
  value: S,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(d, "listenerRemoved", {
  value: R,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
var Y = d;
const v = /* @__PURE__ */j(Y);
function q(t) {
  return typeof t == "object" && t !== null && "message" in t && typeof t.message == "string";
}
function J(t) {
  if (q(t)) return t;
  try {
    return new Error(JSON.stringify(t));
  } catch (_unused2) {
    return new Error(String(t));
  }
}
function I(t) {
  return J(t).message;
}
var K = Object.defineProperty,
  X = (t, e, r) => e in t ? K(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r,
  Z = (t, e, r) => (X(t, typeof e != "symbol" ? e + "" : e, r), r),
  N = /* @__PURE__ */(t => (t.automation = "automation", t.test = "test", t.vbc = "vbc", t.video = "video", t.voice = "voice", t))(N || {});
exports.VonageSourceType = N;
const ee = "hlg.tokbox.com/prod/logging/vcp_webrtc",
  re = "https://",
  te = 1e4;
let w;
const se = new Uint8Array(16);
function ie() {
  if (!w && (w = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !w)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return w(se);
}
const c = [];
for (let t = 0; t < 256; ++t) c.push((t + 256).toString(16).slice(1));
function ne(t, e) {
  if (e === void 0) {
    e = 0;
  }
  return (c[t[e + 0]] + c[t[e + 1]] + c[t[e + 2]] + c[t[e + 3]] + "-" + c[t[e + 4]] + c[t[e + 5]] + "-" + c[t[e + 6]] + c[t[e + 7]] + "-" + c[t[e + 8]] + c[t[e + 9]] + "-" + c[t[e + 10]] + c[t[e + 11]] + c[t[e + 12]] + c[t[e + 13]] + c[t[e + 14]] + c[t[e + 15]]).toLowerCase();
}
const oe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto),
  H = {
    randomUUID: oe
  };
function ae(t, e, r) {
  if (H.randomUUID && !e && !t) return H.randomUUID();
  t = t || {};
  const s = t.random || (t.rng || ie)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, e) {
    r = r || 0;
    for (let i = 0; i < 16; ++i) e[r + i] = s[i];
    return e;
  }
  return ne(s);
}
function F(t, e) {
  _globalThis.vonage || (_globalThis.vonage = {}), _globalThis.vonage.workerizer || (_globalThis.vonage.workerizer = {});
  let r = _globalThis.vonage.workerizer;
  return r[t] || (r[t] = e), r[t];
}
const h = F("globals", {});
var u = /* @__PURE__ */(t => (t.INIT = "INIT", t.FORWARD = "FORWARD", t.TERMINATE = "TERMINATE", t.GLOBALS_SYNC = "GLOBALS_SYNC", t))(u || {});
function z(t) {
  return [ImageBitmap, ReadableStream, WritableStream].some(r => t instanceof r);
}
let ce = 0;
function le(t, e, r, s, i) {
  const n = ce++;
  return t.postMessage({
    id: n,
    type: e,
    functionName: r,
    args: s
  }, s.filter(a => z(a))), new Promise(a => {
    i == null || i.set(n, a);
  });
}
function y(t, e) {
  const r = t.id,
    s = t.type,
    i = Array.isArray(e) ? e : [e];
  postMessage({
    id: r,
    type: s,
    result: e
  }, i.filter(n => z(n)));
}
const Q = F("workerized", {});
function V() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
function fe() {
  return _fe.apply(this, arguments);
}
function _fe() {
  _fe = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21() {
    var t, e, _Q$e$workerContext, r, s;
    return _regenerator.default.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          if (!V()) {
            _context21.next = 4;
            break;
          }
          y({
            type: u.GLOBALS_SYNC
          }, h);
          _context21.next = 8;
          break;
        case 4:
          t = [];
          for (e in Q) {
            _Q$e$workerContext = Q[e].workerContext, r = _Q$e$workerContext.worker, s = _Q$e$workerContext.resolvers;
            r && t.push(le(r, u.GLOBALS_SYNC, "", [h], s));
          }
          _context21.next = 8;
          return Promise.all(t);
        case 8:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _fe.apply(this, arguments);
}
function P(t, e) {
  if (Array.isArray(e)) e.splice(0, e.length);else if (typeof e == "object") for (const r in e) delete e[r];
  for (const r in t) Array.isArray(t[r]) ? (e[r] = [], P(t[r], e[r])) : typeof t[r] == "object" ? (e[r] = {}, P(t[r], e[r])) : e[r] = t[r];
}
function he(_x7, _x8) {
  return _he.apply(this, arguments);
}
function _he() {
  _he = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(t, e) {
    var r, s;
    return _regenerator.default.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          r = t.functionName, s = t.args;
          if (e.instance) {
            _context22.next = 3;
            break;
          }
          throw "instance not initialized";
        case 3:
          if (r) {
            _context22.next = 5;
            break;
          }
          throw "missing function name to call";
        case 5:
          if (e.instance[r]) {
            _context22.next = 7;
            break;
          }
          throw `undefined function [${r}] in class ${e.instance.constructor.workerId}`;
        case 7:
          _context22.t0 = y;
          _context22.t1 = t;
          _context22.next = 11;
          return e.instance[r](...(s != null ? s : []));
        case 11:
          _context22.t2 = _context22.sent;
          (0, _context22.t0)(_context22.t1, _context22.t2);
        case 13:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _he.apply(this, arguments);
}
const ue = F("registeredWorkers", {});
function de(t, e) {
  if (!t.args) throw "Missing className while initializing worker";
  const _t$args = t.args,
    r = _t$args[0],
    s = _t$args[1],
    i = ue[r];
  if (i) e.instance = new i(t.args.slice(1));else throw `unknown worker class ${r}`;
  P(s, h), y(t, typeof e.instance !== void 0);
}
function pe(_x9, _x10) {
  return _pe.apply(this, arguments);
}
function _pe() {
  _pe = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(t, e) {
    var r, s;
    return _regenerator.default.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          r = t.args;
          if (e.instance) {
            _context23.next = 3;
            break;
          }
          throw "instance not initialized";
        case 3:
          _context23.t0 = e.instance.terminate;
          if (!_context23.t0) {
            _context23.next = 8;
            break;
          }
          _context23.next = 7;
          return e.instance.terminate(...(r != null ? r : []));
        case 7:
          s = _context23.sent;
        case 8:
          y(t, s);
        case 9:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _pe.apply(this, arguments);
}
function me(t) {
  if (!t.args) throw "Missing globals while syncing";
  P(t.args[0], h), y(t, {});
}
function ge() {
  const t = {};
  onmessage = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(e) {
      var r;
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            r = e.data;
            _context7.t0 = r.type;
            _context7.next = _context7.t0 === u.INIT ? 4 : _context7.t0 === u.FORWARD ? 6 : _context7.t0 === u.TERMINATE ? 8 : _context7.t0 === u.GLOBALS_SYNC ? 10 : 12;
            break;
          case 4:
            de(r, t);
            return _context7.abrupt("break", 12);
          case 6:
            he(r, t);
            return _context7.abrupt("break", 12);
          case 8:
            pe(r, t);
            return _context7.abrupt("break", 12);
          case 10:
            me(r);
            return _context7.abrupt("break", 12);
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function onmessage(_x11) {
      return _ref4.apply(this, arguments);
    };
  }();
}
V() && ge();
function _e(t, e) {
  return h[t] || (h[t] = e), [() => h[t], /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(r) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            h[t] = r;
            _context8.next = 3;
            return fe();
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x12) {
      return _ref5.apply(this, arguments);
    };
  }()];
}
function ye(t, e) {
  return _e(t, e);
}
const _ye = ye("metadata"),
  be = _ye[0],
  we = _ye[1];
function xe(t) {
  we(t);
}
function x() {
  return be();
}
let L = /*#__PURE__*/function () {
  function L(e, r) {
    Z(this, "uuid"), this.config = e, this.uuid = r != null ? r : ae();
  }
  var _proto2 = L.prototype;
  _proto2.send = /*#__PURE__*/function () {
    var _send = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(e) {
      var r, s, i, _ref6, n, o, a, k;
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _ref6 = (r = x()) != null ? r : {}, n = _ref6.appId, o = _ref6.sourceType;
            if (!(!n || !o)) {
              _context9.next = 3;
              break;
            }
            return _context9.abrupt("return", "metadata missing");
          case 3:
            a = new AbortController(), k = setTimeout(() => a.abort(), te);
            _context9.next = 6;
            return ((i = (s = this.config) == null ? void 0 : s.fetch) != null ? i : fetch)(this.getUrl(), {
              method: "POST",
              headers: this.getHeaders(),
              body: JSON.stringify(this.buildReport(e)),
              signal: a.signal
            });
          case 6:
            clearTimeout(k);
            return _context9.abrupt("return", "success");
          case 8:
          case "end":
            return _context9.stop();
        }
      }, _callee9, this);
    }));
    function send(_x13) {
      return _send.apply(this, arguments);
    }
    return send;
  }();
  _proto2.getUrl = function getUrl() {
    var e;
    let r = (e = x().proxyUrl) != null ? e : re;
    return r += (r.at(-1) === "/" ? "" : "/") + ee, r;
  };
  _proto2.getHeaders = function getHeaders() {
    return {
      "Content-Type": "application/json"
    };
  };
  _proto2.buildReport = function buildReport(e) {
    const r = x();
    return Object.assign({
      guid: this.uuid
    }, e, {
      applicationId: r.appId,
      timestamp: Date.now(),
      proxyUrl: r.proxyUrl,
      source: r.sourceType
    });
  };
  return L;
}();
const E = "2.0.4";
let Te = /*#__PURE__*/function () {
  function Te(e, r) {
    this.config = e, this.frameTransformedCount = 0, this.frameFromSourceCount = 0, this.startAt = 0, this.reporter = new L(e, r);
  }
  var _proto3 = Te.prototype;
  _proto3.onFrameFromSource = /*#__PURE__*/function () {
    var _onFrameFromSource = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            this.frameFromSourceCount++;
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10, this);
    }));
    function onFrameFromSource() {
      return _onFrameFromSource.apply(this, arguments);
    }
    return onFrameFromSource;
  }();
  _proto3.onFrameTransformed = /*#__PURE__*/function () {
    var _onFrameTransformed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(e, r) {
      var s, i, n, o, a, k, W;
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            if (e === void 0) {
              e = {};
            }
            if (r === void 0) {
              r = !1;
            }
            this.startAt === 0 && (this.startAt = Date.now()), this.frameTransformedCount++;
            s = this.startAt, i = this.frameTransformedCount, n = this.frameFromSourceCount, o = Date.now(), a = (o - s) / 1e3, k = i / a, W = n / a;
            return _context11.abrupt("return", r || this.frameTransformedCount >= this.config.loggingIntervalFrameCount ? (this.frameFromSourceCount = 0, this.frameTransformedCount = 0, this.startAt = o, this.reporter.config = this.config, this.reporter.send(Object.assign({}, this.config.report, {
              variation: "QoS",
              fps: W,
              transformedFps: k,
              framesTransformed: i
            }, e))) : "success");
          case 5:
          case "end":
            return _context11.stop();
        }
      }, _callee11, this);
    }));
    function onFrameTransformed(_x14, _x15) {
      return _onFrameTransformed.apply(this, arguments);
    }
    return onFrameTransformed;
  }();
  (0, _createClass2.default)(Te, [{
    key: "fps",
    get: function get() {
      const e = this.startAt,
        r = this.frameFromSourceCount,
        i = (Date.now() - e) / 1e3;
      return r / i;
    }
  }]);
  return Te;
}();
var Ee = /* @__PURE__ */(t => (t.FPS_DROP = "fps_drop", t))(Ee || {}),
  Se = /* @__PURE__ */(t => (t.start = "start", t.transform = "transform", t.flush = "flush", t))(Se || {}),
  O = /* @__PURE__ */(t => (t.pipeline_ended = "pipeline_ended", t.pipeline_ended_with_error = "pipeline_ended_with_error", t.pipeline_started = "pipeline_started", t.pipeline_started_with_error = "pipeline_started_with_error", t.pipeline_restarted = "pipeline_restarted", t.pipeline_restarted_with_error = "pipeline_restarted_with_error", t))(O || {});
exports.PipelineInfoData = O;
exports.ErrorFunction = Se;
exports.WarningType = Ee;
const Re = 500,
  Pe = 0.8;
let ke = /*#__PURE__*/function (_v) {
  (0, _inheritsLoose2.default)(ke, _v);
  function ke(e, r) {
    var _this2;
    _this2 = _v.call(this) || this, _this2.reporter_ = new L(), _this2.reporterQos_ = new Te({
      loggingIntervalFrameCount: Re,
      report: {
        version: E
      }
    }), _this2.index_ = r, _this2.transformer_ = e, _this2.shouldStop_ = !1, _this2.isFlashed_ = !1, _this2.mediaTransformerQosReportStartTimestamp_ = 0, _this2.videoHeight_ = 0, _this2.videoWidth_ = 0, _this2.trackExpectedRate_ = -1, _this2.transformerType_ = "Custom", "getTransformerType" in e && (_this2.transformerType_ = e.getTransformerType()), _this2.report({
      variation: "Create"
    });
    return _this2;
  }
  var _proto4 = ke.prototype;
  _proto4.setTrackExpectedRate = function setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e;
  };
  _proto4.start = /*#__PURE__*/function () {
    var _start = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(e) {
      var s;
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            if (!(this.controller_ = e, this.transformer_ && typeof this.transformer_.start == "function")) {
              _context12.next = 11;
              break;
            }
            _context12.prev = 1;
            _context12.next = 4;
            return this.transformer_.start(e);
          case 4:
            _context12.next = 11;
            break;
          case 6:
            _context12.prev = 6;
            _context12.t0 = _context12["catch"](1);
            this.report({
              message: l.errors.transformer_start,
              variation: "Error",
              error: I(_context12.t0)
            });
            s = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context12.t0,
              function: "start"
              /* start */
            };

            this.emit("error", s);
          case 11:
          case "end":
            return _context12.stop();
        }
      }, _callee12, this, [[1, 6]]);
    }));
    function start(_x16) {
      return _start.apply(this, arguments);
    }
    return start;
  }();
  _proto4.transform = /*#__PURE__*/function () {
    var _transform = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(e, r) {
      var _ref7, _ref8;
      var s, i, o, n;
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            if (!(this.mediaTransformerQosReportStartTimestamp_ === 0 && (this.mediaTransformerQosReportStartTimestamp_ = Date.now()), e instanceof VideoFrame && (this.videoHeight_ = (_ref7 = e == null ? void 0 : e.displayHeight) != null ? _ref7 : 0, this.videoWidth_ = (_ref8 = e == null ? void 0 : e.displayWidth) != null ? _ref8 : 0), this.reporterQos_.onFrameFromSource(), this.transformer_)) {
              _context13.next = 17;
              break;
            }
            if (!this.shouldStop_) {
              _context13.next = 5;
              break;
            }
            console.warn("[Pipeline] flush from transform"), e.close(), this.flush(r), r.terminate();
            _context13.next = 17;
            break;
          case 5:
            _context13.prev = 5;
            _context13.next = 8;
            return (i = (s = this.transformer_).transform) == null ? void 0 : i.call(s, e, r);
          case 8:
            this.reportQos();
            _context13.next = 16;
            break;
          case 11:
            _context13.prev = 11;
            _context13.t0 = _context13["catch"](5);
            this.report({
              message: l.errors.transformer_transform,
              variation: "Error",
              error: I(_context13.t0)
            });
            o = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context13.t0,
              function: "transform"
              /* transform */
            };

            this.emit("error", o);
          case 16:
            if (this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * Pe > this.reporterQos_.fps) {
              n = {
                eventMetaData: {
                  transformerIndex: this.index_
                },
                warningType: "fps_drop",
                dropInfo: {
                  requested: this.trackExpectedRate_,
                  current: this.reporterQos_.fps
                }
              };
              this.emit("warn", n);
            }
          case 17:
          case "end":
            return _context13.stop();
        }
      }, _callee13, this, [[5, 11]]);
    }));
    function transform(_x17, _x18) {
      return _transform.apply(this, arguments);
    }
    return transform;
  }();
  _proto4.flush = /*#__PURE__*/function () {
    var _flush = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(e) {
      var s;
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            if (!(this.transformer_ && typeof this.transformer_.flush == "function" && !this.isFlashed_)) {
              _context14.next = 12;
              break;
            }
            this.isFlashed_ = !0;
            _context14.prev = 2;
            _context14.next = 5;
            return this.transformer_.flush(e);
          case 5:
            _context14.next = 12;
            break;
          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](2);
            this.report({
              message: l.errors.transformer_flush,
              variation: "Error",
              error: I(_context14.t0)
            });
            s = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context14.t0,
              function: "flush"
              /* flush */
            };

            this.emit("error", s);
          case 12:
            this.reportQos(!0), this.report({
              variation: "Delete"
            });
          case 13:
          case "end":
            return _context14.stop();
        }
      }, _callee14, this, [[2, 7]]);
    }));
    function flush(_x19) {
      return _flush.apply(this, arguments);
    }
    return flush;
  }();
  _proto4.stop = function stop() {
    console.log("[Pipeline] Stop stream."), this.controller_ && (this.flush(this.controller_), this.controller_.terminate()), this.shouldStop_ = !0;
  };
  _proto4.report = function report(e) {
    this.reporter_.send(Object.assign({
      version: E,
      action: "MediaTransformer",
      transformerType: this.transformerType_
    }, e));
  };
  _proto4.reportQos = function reportQos(e) {
    if (e === void 0) {
      e = !1;
    }
    this.reporterQos_.config = Object.assign({}, this.reporterQos_.config), this.reporterQos_.onFrameTransformed({
      version: E,
      action: "MediaTransformer",
      transformerType: this.transformerType_,
      videoWidth: this.videoWidth_,
      videoHeight: this.videoHeight_
    }, e);
  };
  return ke;
}(v);
let Ae = /*#__PURE__*/function (_v2) {
  (0, _inheritsLoose2.default)(Ae, _v2);
  function Ae(e) {
    var _this3;
    _this3 = _v2.call(this) || this, _this3.transformers_ = [], _this3.trackExpectedRate_ = -1;
    for (let r = 0; r < e.length; r++) {
      let s = new ke(e[r], r);
      s.on("error", i => {
        _this3.emit("error", i);
      }), s.on("warn", i => {
        _this3.emit("warn", i);
      }), _this3.transformers_.push(s);
    }
    return _this3;
  }
  var _proto5 = Ae.prototype;
  _proto5.setTrackExpectedRate = function setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e;
    for (var _iterator20 = _createForOfIteratorHelperLoose(this.transformers_), _step20; !(_step20 = _iterator20()).done;) {
      let r = _step20.value;
      r.setTrackExpectedRate(this.trackExpectedRate_);
    }
  };
  _proto5.start = /*#__PURE__*/function () {
    var _start2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(e, r) {
      var _this4 = this;
      var s, _iterator21, _step21, i;
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            if (!(!this.transformers_ || this.transformers_.length === 0)) {
              _context17.next = 3;
              break;
            }
            console.log("[Pipeline] No transformers.");
            return _context17.abrupt("return");
          case 3:
            _context17.prev = 3;
            s = e;
            for (_iterator21 = _createForOfIteratorHelperLoose(this.transformers_); !(_step21 = _iterator21()).done;) {
              i = _step21.value;
              e = e.pipeThrough(new TransformStream(i));
            }
            e.pipeTo(r).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15() {
              return _regenerator.default.wrap(function _callee15$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    console.log("[Pipeline] Setup.");
                    _context15.next = 3;
                    return r.abort();
                  case 3:
                    _context15.next = 5;
                    return s.cancel();
                  case 5:
                    _this4.emit("pipelineInfo", "pipeline_ended"
                    /* pipeline_ended */);
                  case 6:
                  case "end":
                    return _context15.stop();
                }
              }, _callee15);
            }))).catch( /*#__PURE__*/function () {
              var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(i) {
                return _regenerator.default.wrap(function _callee16$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      e.cancel().then(() => {
                        console.log("[Pipeline] Shutting down streams after abort.");
                      }).catch(n => {
                        console.error("[Pipeline] Error from stream transform:", n);
                      });
                      _context16.next = 3;
                      return r.abort(i);
                    case 3:
                      _context16.next = 5;
                      return s.cancel(i);
                    case 5:
                      _this4.emit("pipelineInfo", "pipeline_ended_with_error"
                      /* pipeline_ended_with_error */);
                    case 6:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              }));
              return function (_x22) {
                return _ref10.apply(this, arguments);
              };
            }());
            _context17.next = 13;
            break;
          case 9:
            _context17.prev = 9;
            _context17.t0 = _context17["catch"](3);
            this.emit("pipelineInfo", "pipeline_started_with_error"
            /* pipeline_started_with_error */), this.destroy();
            return _context17.abrupt("return");
          case 13:
            this.emit("pipelineInfo", "pipeline_started"
            /* pipeline_started */), console.log("[Pipeline] Pipeline started.");
          case 14:
          case "end":
            return _context17.stop();
        }
      }, _callee17, this, [[3, 9]]);
    }));
    function start(_x20, _x21) {
      return _start2.apply(this, arguments);
    }
    return start;
  }();
  _proto5.destroy = /*#__PURE__*/function () {
    var _destroy = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18() {
      var _iterator22, _step22, e;
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            console.log("[Pipeline] Destroying Pipeline.");
            for (_iterator22 = _createForOfIteratorHelperLoose(this.transformers_); !(_step22 = _iterator22()).done;) {
              e = _step22.value;
              e.stop();
            }
          case 2:
          case "end":
            return _context18.stop();
        }
      }, _callee18, this);
    }));
    function destroy() {
      return _destroy.apply(this, arguments);
    }
    return destroy;
  }();
  return Ae;
}(v);
let Ce = /*#__PURE__*/function (_v3) {
  (0, _inheritsLoose2.default)(Ce, _v3);
  function Ce() {
    var _this5;
    _this5 = _v3.call(this) || this, _this5.reporter_ = new L(), _this5.trackExpectedRate_ = -1, _this5.report({
      variation: "Create"
    });
    return _this5;
  }
  /**
   * Sets the expected rate of the track per second.
   * The media processor will use this number for calculating drops in the rate.
   * This could happen when the transformation will take more time than expected.
   * This will not cause an error, just warning to the client.
   * Mostly:
   * Video: 30 frames per second
   * Audio: 50 audio data per second for OPUS
   * In case of increased frame dropping rate a warning will be emitted according to info [here](/docs/intro#errors-and-warnings-listener).
   * ***This is an optional method.***
   * @param trackExpectedRate - number holds the predicted track rate.
   */
  var _proto6 = Ce.prototype;
  _proto6.setTrackExpectedRate = function setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e, this.pipeline_ && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
  }
  /**
   * Starts running the tranformation logic performed by the media processor instance.
   * When running an instance of this class on a Web worker thread the call for this function should be made by the user. See example [here](/docs/intro#webworker-code).
   * When running an instance of this class on the application main thread there is no need to call this method given it will be called by the `MediaProcessorConnector` instance.
   *
   * @param readable Readable stream associated to the media source being processed.
   * @param writable Writable stream associated to the resulting media once processed.
   *
   * @returns
   */;
  _proto6.transform = function transform(e, r) {
    return this.readable_ = e, this.writable_ = r, this.transformInternal();
  }
  /**
   * @private
   */;
  _proto6.transformInternal = function transformInternal() {
    var _this6 = this;
    return new Promise( /*#__PURE__*/function () {
      var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(e, r) {
        var s;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(!_this6.transformers_ || _this6.transformers_.length === 0)) {
                _context19.next = 3;
                break;
              }
              _this6.report({
                message: l.errors.transformer_none,
                variation: "Error"
              }), r("[MediaProcessor] Need to set transformers.");
              return _context19.abrupt("return");
            case 3:
              if (_this6.readable_) {
                _context19.next = 6;
                break;
              }
              _this6.report({
                variation: "Error",
                message: l.errors.readable_null
              }), r("[MediaProcessor] Readable is null.");
              return _context19.abrupt("return");
            case 6:
              if (_this6.writable_) {
                _context19.next = 9;
                break;
              }
              _this6.report({
                variation: "Error",
                message: l.errors.writable_null
              }), r("[MediaProcessor] Writable is null.");
              return _context19.abrupt("return");
            case 9:
              s = !1;
              _this6.pipeline_ && (s = !0, _this6.pipeline_.clearListeners(), _this6.pipeline_.destroy()), _this6.pipeline_ = new Ae(_this6.transformers_), _this6.pipeline_.on("warn", i => {
                _this6.emit("warn", i);
              }), _this6.pipeline_.on("error", i => {
                _this6.emit("error", i);
              }), _this6.pipeline_.on("pipelineInfo", i => {
                s && (i === "pipeline_started" ? i = O.pipeline_restarted : i === "pipeline_started_with_error" && (i = O.pipeline_restarted_with_error)), _this6.emit("pipelineInfo", i);
              }), _this6.trackExpectedRate_ != -1 && _this6.pipeline_.setTrackExpectedRate(_this6.trackExpectedRate_), _this6.pipeline_.start(_this6.readable_, _this6.writable_).then(() => {
                e();
              }).catch(i => {
                r(i);
              });
            case 11:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return function (_x23, _x24) {
        return _ref11.apply(this, arguments);
      };
    }());
  }
  /**
   * Sets an array of transfromer instances that will be hold and ran by the media processor instance.
   * See example [here](/docs/intro#main-code)
   *
   * @param transformers An array of transformer instances.
   *
   * @returns
   */;
  _proto6.setTransformers = function setTransformers(e) {
    return this.report({
      variation: "Update",
      message: l.updates.transformer_new
    }), this.transformers_ = e, this.readable_ && this.writable_ ? this.transformInternal() : Promise.resolve();
  }
  /**
   * Stops running the tranformation logic performed by the media processor instance.
   * @returns
   */;
  _proto6.destroy = function destroy() {
    var _this7 = this;
    return new Promise( /*#__PURE__*/function () {
      var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(e) {
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _this7.pipeline_ && _this7.pipeline_.destroy(), _this7.report({
                variation: "Delete"
              }), e();
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x25) {
        return _ref12.apply(this, arguments);
      };
    }());
  };
  _proto6.report = function report(e) {
    this.reporter_.send(Object.assign({
      version: E,
      action: "MediaProcessor"
    }, e));
  };
  return Ce;
}(v);
exports.MediaProcessor = Ce;
let Me = /*#__PURE__*/function () {
  function Me() {
    this.processor_ = null, this.generator_ = null;
  }
  var _proto7 = Me.prototype;
  _proto7.init = function init(e) {
    return new Promise((r, s) => {
      try {
        this.processor_ = new MediaStreamTrackProcessor(e);
      } catch (i) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${i}`), s(i);
      }
      try {
        e.kind === "audio" ? this.generator_ = new MediaStreamTrackGenerator({
          kind: "audio"
        }) : e.kind === "video" ? this.generator_ = new MediaStreamTrackGenerator({
          kind: "video"
        }) : s("kind not supported");
      } catch (i) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${i}`), s(i);
      }
      r();
    });
  };
  _proto7.getReadable = function getReadable() {
    return this.processor_.readable;
  };
  _proto7.getWriteable = function getWriteable() {
    return this.generator_.writable;
  };
  _proto7.getProccesorTrack = function getProccesorTrack() {
    return this.generator_;
  };
  return Me;
}();
let Oe = /*#__PURE__*/function () {
  /**
   * - When running insertable streams on the main `MediaProcessorInterface` should be instance of `MediaProcessor` class.
   * - When running insertable streams on WebWorker `MediaProcessorInterface` should be instance of bridge calss created by the user. Example can be found [here](/docs/intro.md#using-the-transformer-on-webworker)
   * @param vonageMediaProcessor - MediaProcessorInterface.
   */
  function Oe(e) {
    this.insertableStreamHelper_ = new Me(), this.mediaProcessor_ = e;
  }
  /**
   * @private
   * Sets the media stream track instance to be processed.
   *
   * @param track MediaStreamTrack (audio or video) to be processed.
   *
   * @returns New track to be used.
   */
  var _proto8 = Oe.prototype;
  _proto8.setTrack = function setTrack(e) {
    return new Promise((r, s) => {
      this.insertableStreamHelper_.init(e).then(() => {
        this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(() => {
          r(this.insertableStreamHelper_.getProccesorTrack());
        }).catch(i => {
          s(i);
        });
      }).catch(i => {
        s(i);
      });
    });
  }
  /**
   * @private
   * Stops the media processing being performed.
   */;
  _proto8.destroy = function destroy() {
    return new Promise((e, r) => {
      this.mediaProcessor_ ? this.mediaProcessor_.destroy().then(() => {
        e();
      }).catch(s => {
        r(s);
      }) : r("no processor");
    });
  };
  return Oe;
}();
exports.MediaProcessorConnector = Oe;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(24)))

/***/ }),
/* 761 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 761;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _backgroundReplacementConfig = _interopRequireDefault(__webpack_require__(763));
var _backgroundBlurConfig = _interopRequireDefault(__webpack_require__(764));
/* eslint-disable global-require */

// These are all the transformers we support
const filterToConfiguratorMap = {
  backgroundBlur: _backgroundBlurConfig.default,
  backgroundReplacement: _backgroundReplacementConfig.default
};
const isSupported = type => !!filterToConfiguratorMap[type];
const getConfigurator = type => {
  if (!isSupported(type)) {
    return null;
  }
  return filterToConfiguratorMap[type];
};
const isValidConfig = config => {
  const type = config.type;
  if (!isSupported(type)) {
    return false;
  }
  return getConfigurator(type).isValidConfig(config);
};
const MediaTransform = {
  isSupported,
  getConfigurator,
  isValidConfig
};
var _default = MediaTransform;
exports.default = _default;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _getDefaultConfig = _interopRequireDefault(__webpack_require__(347));
const isSupportedImage = url =>
// Check if image is a BLOB
/^data:image\/(?:png|jpeg|bmp|gif);base64/.test(url) ||
// Check if URL is a supported image type
/\.(?:png|jpe?g|bmp|gif)$/i.test(url);
const isValidConfig = config => {
  if ((config == null ? void 0 : config.type) !== 'backgroundReplacement') {
    return false;
  }
  const backgroundImgUrl = config.backgroundImgUrl;
  return isSupportedImage(backgroundImgUrl);
};
const BackgroundReplacementConfig = {
  isValidConfig,
  getConfig: function getConfig(opt) {
    if (opt === void 0) {
      opt = {};
    }
    const config = Object.assign({}, (0, _getDefaultConfig.default)(opt), {
      transformerType: 'VirtualBackground'
    });
    const _opt = opt,
      backgroundImgUrl = _opt.backgroundImgUrl;
    if (isSupportedImage(backgroundImgUrl)) {
      config.backgroundAssetUri = backgroundImgUrl;
    }
    return config;
  }
};
var _default = BackgroundReplacementConfig;
exports.default = _default;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _mlTransformers = __webpack_require__(184);
var _getDefaultConfig = _interopRequireDefault(__webpack_require__(347));
const defaultBlurRadius = _mlTransformers.BlurRadius.High;
const isValidBlurStrength = blurStrength => blurStrength === 'low' || blurStrength === 'high';
const toBlurRadius = blurStrength => blurStrength === 'low' ? _mlTransformers.BlurRadius.Low : _mlTransformers.BlurRadius.High;
const isValidConfig = config => {
  if ((config == null ? void 0 : config.type) !== 'backgroundBlur') {
    return false;
  }

  // blurStrength is optional.  If defined, then make sure it's valid.
  const blurStrength = config.blurStrength;
  return blurStrength ? isValidBlurStrength(blurStrength) : true;
};
const BackgroundBlurConfig = {
  isValidConfig,
  getConfig: function getConfig(opt) {
    if (opt === void 0) {
      opt = {};
    }
    const config = Object.assign({}, (0, _getDefaultConfig.default)(opt), {
      transformerType: 'BackgroundBlur',
      radius: defaultBlurRadius
    });
    const _opt = opt,
      blurStrength = _opt.blurStrength;
    if (isValidBlurStrength(blurStrength)) {
      config.radius = toBlurRadius(blurStrength);
    }
    return config;
  }
};
var _default = BackgroundBlurConfig;
exports.default = _default;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = session => {
  if (!session) {
    // Logs must be tagged to the API key, which we'll only know after we
    // connect to a session.
    return false;
  }

  // Logs must be linked the the API
  return !!session.apiKey;
};
exports.default = _default;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _audioInputDevicesChangeHandler = _interopRequireDefault(__webpack_require__(767));
var _deviceHelpers = _interopRequireDefault(__webpack_require__(22));
var _events = _interopRequireDefault(__webpack_require__(18));
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const getAudioInputDevicesChangeHandler = deps.getAudioInputDevicesChangeHandler || _audioInputDevicesChangeHandler.default;
  const getNativeMediaDevicesFactory = deps.getNativeMediaDevicesFactory || _deviceHelpers.default;
  const audioInputDevicesChangeHandler = getAudioInputDevicesChangeHandler();
  const _getNativeMediaDevice = getNativeMediaDevicesFactory(),
    getNativeMediaDevices = _getNativeMediaDevice.getNativeMediaDevices;
  const Events = (0, _events.default)();
  const audioInputDevicesChangeListener = publisher => {
    let isProcessing = false;
    const deviceChangeListener = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var device;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isProcessing) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              isProcessing = true;
              _context.next = 5;
              return audioInputDevicesChangeHandler();
            case 5:
              device = _context.sent;
              isProcessing = false;
              _context.next = 9;
              return publisher.setAudioSource(device.deviceId);
            case 9:
              publisher.dispatchEvent(Events.AudioInputDeviceChangedEvent(device));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function deviceChangeListener() {
        return _ref.apply(this, arguments);
      };
    }();
    // In order to keep the current device ID synchronized, let's listen to the device change event
    const mediaDevices = getNativeMediaDevices();
    mediaDevices.addEventListener('devicechange', deviceChangeListener);
    const removeAudioInputDevicesChangeListener = () => {
      mediaDevices.removeEventListener('devicechange', deviceChangeListener);
    };
    return removeAudioInputDevicesChangeListener;
  };
  return audioInputDevicesChangeListener;
};
exports.default = _default;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _deviceHelpers = _interopRequireDefault(__webpack_require__(22));
var _currentAudioInputDevice = _interopRequireDefault(__webpack_require__(261));
/* eslint-disable consistent-return */
/* eslint-disable global-require */
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const _ref = deps.deviceHelpers || (0, _deviceHelpers.default)(),
    getAudioInputMediaDevices = _ref.getAudioInputMediaDevices,
    getDefaultAudioInputDevice = _ref.getDefaultAudioInputDevice,
    hasDevice = _ref.hasDevice;
  const _ref2 = deps.currentAudioOutputDevice || _currentAudioInputDevice.default,
    getCurrentAudioInputDevice = _ref2.getCurrentAudioInputDevice,
    setCurrentAudioInputDevice = _ref2.setCurrentAudioInputDevice;
  const audioInputDevicesChangeHandler = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var devices, currentAudioInputDevice, isStillConnected, newDevice;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAudioInputMediaDevices();
          case 2:
            devices = _context.sent;
            if (!(devices.length === 0)) {
              _context.next = 6;
              break;
            }
            setCurrentAudioInputDevice('');
            return _context.abrupt("return");
          case 6:
            currentAudioInputDevice = getCurrentAudioInputDevice();
            isStillConnected = hasDevice(devices, currentAudioInputDevice.deviceId);
            newDevice = getDefaultAudioInputDevice(devices);
            if (!(isStillConnected && currentAudioInputDevice.label === newDevice.label)) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return");
          case 11:
            // Since the current output device was removed, let's use the default device.
            setCurrentAudioInputDevice(newDevice);
            return _context.abrupt("return", newDevice);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function audioInputDevicesChangeHandler() {
      return _ref3.apply(this, arguments);
    };
  }();
  return audioInputDevicesChangeHandler;
};
exports.default = _default;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _log = _interopRequireDefault(__webpack_require__(1));
let _default = function _default(deps) {
  var _this = this;
  if (deps === void 0) {
    deps = {};
  }
  this.replaceTrackInMutedAudioTracks = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(peerConnection, oldTrack, newTrack) {
      var newClonedTrack, oldClonedTrack;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!!_this.mutedMantisAudioTracksInAMR[newTrack.id] && peerConnection != null && peerConnection.hasTrack(_this.mutedMantisAudioTracksInAMR[newTrack.id]))) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            // If it is not muted, the ID is not present, or the PC does not have the cloned track,
            // we clone the track, disable it, and replace it.
            newClonedTrack = newTrack.clone();
            newClonedTrack.enabled = false;

            // When a track is cloned, the ID changes but is otherwise identical. Thus,
            // we need to find the old cloned track by the (original, pre-cloned) ID,
            // since we cannot use strict equality to find it, and replace it with a new cloned track.
            oldClonedTrack = _this.mutedMantisAudioTracksInAMR[oldTrack.id];
            _context.prev = 5;
            _context.next = 8;
            return peerConnection.findAndReplaceTrack(oldClonedTrack, newClonedTrack);
          case 8:
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](5);
            _this.logging.error(`Error swapping AMR audio track: ${_context.t0}`);
            return _context.abrupt("return");
          case 14:
            // Save it, so it can be restored once unmuted.
            _this.mutedMantisAudioTracksInAMR[newTrack.id] = newClonedTrack;
            delete _this.mutedMantisAudioTracksInAMR[oldTrack.id];
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 10]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  this.unmuteAudioInPeerConnection = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(webRTCStream, peerConnection) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            // Replace the cloned muted tracks by the original tracks.
            webRTCStream.getAudioTracks().forEach( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(track) {
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 3;
                      return peerConnection.findAndReplaceTrack(_this.mutedMantisAudioTracksInAMR[track.id], track);
                    case 3:
                      _context2.next = 8;
                      break;
                    case 5:
                      _context2.prev = 5;
                      _context2.t0 = _context2["catch"](0);
                      return _context2.abrupt("return");
                    case 8:
                      delete _this.mutedMantisAudioTracksInAMR[track.id];
                    case 9:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[0, 5]]);
              }));
              return function (_x6) {
                return _ref3.apply(this, arguments);
              };
            }());
            _this.amrAudioMuted = false;
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
  this.muteAudioInPeerConnection = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(webRTCStream, peerConnection) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!_this.amrAudioMuted) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            _this.amrAudioMuted = true;
            // Mute all audio tracks for the given PC. Please note we don't want
            // to mute the stream since this can be used by another PC. Thus, we
            // first clone the audio track, and then mute it.
            webRTCStream.getAudioTracks().forEach( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(track) {
                var audioTrack;
                return _regenerator.default.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      audioTrack = track.clone();
                      audioTrack.enabled = false;
                      // Best effort: if we fail to replace the track, we will keep the original one. In case
                      // there is more than one track, we will try to replace as many as possible.
                      // Potential errors: replaceTrack not supported in old browsers, negotiation required.
                      _context4.prev = 2;
                      _context4.next = 5;
                      return peerConnection.findAndReplaceTrack(track, audioTrack);
                    case 5:
                      _context4.next = 10;
                      break;
                    case 7:
                      _context4.prev = 7;
                      _context4.t0 = _context4["catch"](2);
                      return _context4.abrupt("return");
                    case 10:
                      // Save it, so it can be restored once unmuted.
                      _this.mutedMantisAudioTracksInAMR[track.id] = audioTrack;
                    case 11:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[2, 7]]);
              }));
              return function (_x9) {
                return _ref5.apply(this, arguments);
              };
            }());
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
  this.destroy = () => {
    Object.entries(this.mutedMantisAudioTracksInAMR).forEach(_ref6 => {
      let id = _ref6[0],
        track = _ref6[1];
      track == null ? void 0 : track.stop();
      delete this.mutedMantisAudioTracksInAMR[id];
    });
    this.amrAudioMuted = false;
  };
  this.logging = deps.logging || (0, _log.default)('AMRTrackProcessor');
  this.mutedMantisAudioTracksInAMR = {};
  this.amrAudioMuted = false;
};
exports.default = _default;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.createCancellationFactory = exports.callWithCancellation = void 0;
var _cancel = _interopRequireDefault(__webpack_require__(114));
const createCancellationFactory = () => {
  let cancellation = new _cancel.default();
  return () => {
    cancellation.cancel();
    cancellation = new _cancel.default();
    return cancellation;
  };
};
exports.createCancellationFactory = createCancellationFactory;
const callWithCancellation = fn => {
  const getCancellation = createCancellationFactory();
  return function () {
    const cancellation = getCancellation();
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return fn(...args, cancellation);
  };
};
exports.callWithCancellation = callWithCancellation;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const AUDIO_FILTERS = ['advancedNoiseSuppression'];
var _default = audioFilter => AUDIO_FILTERS.includes(audioFilter == null ? void 0 : audioFilter.type);
exports.default = _default;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _getCdnUrl = _interopRequireDefault(__webpack_require__(348));
const getDefaultConfig = function getDefaultConfig(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const _deps = deps,
    proxyUrl = _deps.proxyUrl,
    _deps$env = _deps.env,
    env = _deps$env === void 0 ? _env.default : _deps$env;
  const cdnHost = (0, _getCdnUrl.default)({
    env,
    proxyUrl
  });
  return {
    assetsDirBaseUrl: `${cdnHost}/noise-suppression/v1.0.0`
  };
};
var _default = getDefaultConfig;
exports.default = _default;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = contentHint => {
  let scalabilityMode;
  switch (contentHint) {
    case 'motion':
      scalabilityMode = 'L3T1';
      break;
    case 'detail':
    case 'text':
    case '':
    default:
      scalabilityMode = 'L1T3';
      break;
  }
  return scalabilityMode;
};
exports.default = _default;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
/* eslint-disable no-param-reassign */
const setScalabilityMode = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(publisher, scalabilityMode, codecsWhitelist) {
    var _yield$publisher$_get, sender, senderParameters, _senderParameters$cod, allowedCodecs, hasAnyAllowedCodec;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (codecsWhitelist === void 0) {
            codecsWhitelist = null;
          }
          if (!(!scalabilityMode || !publisher)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.next = 5;
          return publisher._getVideoSenders();
        case 5:
          _yield$publisher$_get = _context.sent;
          sender = _yield$publisher$_get[0];
          if (sender) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return");
        case 9:
          senderParameters = sender.getParameters();
          if (!Array.isArray(codecsWhitelist)) {
            _context.next = 15;
            break;
          }
          allowedCodecs = codecsWhitelist.map(codec => codec.toLowerCase());
          hasAnyAllowedCodec = (_senderParameters$cod = senderParameters.codecs) == null ? void 0 : _senderParameters$cod.some(codec => {
            var _codec$mimeType$split;
            return allowedCodecs.includes((_codec$mimeType$split = codec.mimeType.split('/')[1]) == null ? void 0 : _codec$mimeType$split.toLowerCase());
          });
          if (hasAnyAllowedCodec) {
            _context.next = 15;
            break;
          }
          return _context.abrupt("return");
        case 15:
          senderParameters.encodings.forEach(encoding => {
            encoding.scalabilityMode = scalabilityMode; // eslint-disable-line no-param-reassign
          });
          _context.prev = 16;
          _context.next = 19;
          return sender.setParameters(senderParameters);
        case 19:
          _context.next = 24;
          break;
        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](16);
          // eslint-disable-next-line no-console
          console.error(`Unable to set scalabilityMode. ${_context.t0.message}`);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[16, 21]]);
  }));
  return function setScalabilityMode(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _default = setScalabilityMode;
exports.default = _default;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
const getNumEncodings = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(publisher) {
    var _yield$publisher$_get, sender, _sender$getParameters, encodings;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (publisher) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", 0);
        case 2:
          _context.next = 4;
          return publisher._getVideoSenders();
        case 4:
          _yield$publisher$_get = _context.sent;
          sender = _yield$publisher$_get[0];
          if (sender) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", 0);
        case 8:
          _sender$getParameters = sender.getParameters(), encodings = _sender$getParameters.encodings;
          return _context.abrupt("return", Array.isArray(encodings) ? encodings.length : 0);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getNumEncodings(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = getNumEncodings;
exports.default = _default;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = function _default(completionHandler) {
  if (completionHandler === void 0) {
    completionHandler = () => {};
  }
  return {
    onResolve: function onResolve() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      completionHandler(undefined, ...args);
    },
    onReject: function onReject() {
      completionHandler(...arguments);
    }
  };
};
exports.default = _default;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _events = _interopRequireDefault(__webpack_require__(12));
/*
 * Creates a permission listener for detecting changes in microphone and camera permissions.
 *
 * @function createMediaPermissionListener
 * @param {boolean} hasAudioVideoDevices - Indicates if the user has been publishing audio and video.
 * @returns {Promise<EventEmitter & { createMediaPermissionListener: Function, device: string }>}
 * An EventEmitter instance with additional properties `createMediaPermissionListener` and `device`.
 *
 */
const createMediaPermissionListener = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(hasAudioVideoDevices, deps) {
    var ee, navigator, videoPermissionStatus, audioPermissionStatus, createPermissionListeners, onAudioPermissionChanged, onVideoPermissionChanged, removeAudioListener, removeVideoListener;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (deps === void 0) {
            deps = {};
          }
          ee = new _events.default();
          navigator = deps.navigator || (typeof window !== undefined ? window : global).navigator;
          createPermissionListeners = /*#__PURE__*/function () {
            var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!(typeof navigator.permissions !== 'undefined' && typeof navigator.permissions.query === 'function')) {
                      _context.next = 12;
                      break;
                    }
                    _context.prev = 1;
                    _context.next = 4;
                    return navigator.permissions.query({
                      name: 'camera'
                    });
                  case 4:
                    videoPermissionStatus = _context.sent;
                    _context.next = 7;
                    return navigator.permissions.query({
                      name: 'microphone'
                    });
                  case 7:
                    audioPermissionStatus = _context.sent;
                    _context.next = 12;
                    break;
                  case 10:
                    _context.prev = 10;
                    _context.t0 = _context["catch"](1);
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[1, 10]]);
            }));
            return function createPermissionListeners() {
              return _ref2.apply(this, arguments);
            };
          }();
          _context2.next = 6;
          return createPermissionListeners();
        case 6:
          onAudioPermissionChanged = () => {
            if (audioPermissionStatus.state === 'denied' && hasAudioVideoDevices) {
              ee.emit('accessDenied', 'microphone');
            }
          };
          onVideoPermissionChanged = () => {
            if (videoPermissionStatus.state === 'denied' && hasAudioVideoDevices) {
              ee.emit('accessDenied', 'camera');
            }
          };
          removeAudioListener = () => {
            audioPermissionStatus.removeEventListener('change', onAudioPermissionChanged);
          };
          removeVideoListener = () => {
            videoPermissionStatus.removeEventListener('change', onVideoPermissionChanged);
          };
          if (videoPermissionStatus && audioPermissionStatus) {
            audioPermissionStatus.addEventListener('change', () => {
              onAudioPermissionChanged();
              removeAudioListener();
            });
            videoPermissionStatus.addEventListener('change', () => {
              onVideoPermissionChanged();
              removeVideoListener();
            });
          }
          return _context2.abrupt("return", ee);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function createMediaPermissionListener(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = createMediaPermissionListener;
exports.default = _default;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _eventNames = _interopRequireDefault(__webpack_require__(30));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _events = _interopRequireDefault(__webpack_require__(18));
const Events = (0, _events.default)();
var _default = (device, step) => new Events.ExceptionEvent(_eventNames.default.ACCESS_DENIED, `${device} permission denied ${step}`, 'accessDenied', _exception_codes.default.UNABLE_TO_PUBLISH);
exports.default = _default;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const isNullOrFalse = value => value === null || value === false;
var _default = isNullOrFalse;
exports.default = _default;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = properties => {
  var _properties$videoSour;
  const isCanvas = !!(properties && (_properties$videoSour = properties.videoSource) != null && _properties$videoSour.canvas);
  const hasVideoContentHint = !!(properties && 'videoContentHint' in properties);
  // eslint-disable-next-line no-param-reassign
  if (isCanvas && !hasVideoContentHint) properties.videoContentHint = 'detail';
};
exports.default = _default;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _isScreenSharingSource = _interopRequireDefault(__webpack_require__(160));
/* eslint-disable no-param-reassign */

const supportsScalableScreenShare = properties => !!(properties != null && properties.scalableScreenshare);
var _default = properties => {
  var _properties;
  if (!properties) {
    properties = {};
  }
  const isScreenshare = !!(0, _isScreenSharingSource.default)((_properties = properties) == null ? void 0 : _properties.videoSource);

  // eslint-disable-next-line no-unused-expressions
  properties.capableSimulcastScreenshare = isScreenshare && supportsScalableScreenShare(properties);
};
exports.default = _default;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindKey = __webpack_require__(782),
    baseForOwn = __webpack_require__(105),
    baseIteratee = __webpack_require__(37);

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
}

module.exports = findKey;


/***/ }),
/* 782 */
/***/ (function(module, exports) {

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

module.exports = baseFindKey;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = convertAnvilErrorCode;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
function convertAnvilErrorCode(code) {
  switch (code) {
    case _exception_codes.default.AUTHENTICATION_ERROR:
    case _exception_codes.default.INVALID_SESSION_ID:
    case _exception_codes.default.TERMS_OF_SERVICE_FAILURE:
    case _exception_codes.default.UNEXPECTED_SERVER_RESPONSE:
      return code;
    case _exception_codes.default.ANVIL_EMPTY_RESPONSE_BODY:
    case _exception_codes.default.ANVIL_CONNECT_FAILED:
      return _exception_codes.default.CONNECT_FAILED;
    case _exception_codes.default.ANVIL_BADLY_FORMED_RESPONSE:
    case _exception_codes.default.ANVIL_INVALID_HTTP_STATUS:
    case _exception_codes.default.ANVIL_XDOMAIN_OR_PARSING_ERROR:
    case _exception_codes.default.ANVIL_UNKNOWN_HTTP_ERROR:
    case _exception_codes.default.ANVIL_UNEXPECTED_ERROR_CODE:
    default:
      return _exception_codes.default.UNEXPECTED_SERVER_RESPONSE;
  }
}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _shouldUsePlanBSDP = _interopRequireDefault(__webpack_require__(76));
var _default = _ref => {
  let RTCPeerConnection = _ref.RTCPeerConnection,
    env = _ref.env,
    stream = _ref.stream,
    codecFlags = _ref.codecFlags;
  if (env.isLegacyEdge) {
    // Edge supports all codecs and the following test doesn't work
    return true;
  }
  let localPc;
  let remotePc;
  const cleanup = () => {
    try {
      localPc.close();
    } catch (e) {} // eslint-disable-line no-empty
    try {
      remotePc.close();
    } catch (e) {} // eslint-disable-line no-empty
    localPc = null;
    remotePc = null;
  };
  try {
    const pcConfig = {
      iceServers: []
    };
    if ((0, _shouldUsePlanBSDP.default)()) {
      pcConfig.sdpSemantics = 'plan-b';
    }
    localPc = new RTCPeerConnection(pcConfig);
    remotePc = new RTCPeerConnection(pcConfig);
    stream.getTracks().forEach(track => localPc.addTrack(track, stream));
  } catch (e) {
    cleanup();
    return Promise.resolve(false);
  }
  return localPc.createOffer().then(offer => {
    const newOffer = {
      type: offer.type,
      sdp: offer.sdp
    };
    Object.keys(codecFlags).forEach(codec => {
      if (!codecFlags[codec]) {
        newOffer.sdp = _sdp_helpers.default.removeVideoCodec(newOffer.sdp, codec);
      }
    });
    return remotePc.setRemoteDescription(newOffer);
  }).then(() => true).catch(() => false).then(result => {
    cleanup();
    return result;
  });
};
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _Errors = _interopRequireDefault(__webpack_require__(8));
const INVALID_PARAMETER = _Errors.default.INVALID_PARAMETER;
const validateIceConfig = _ref => {
  let otError = _ref.otError;
  return config => {
    if (!config) {
      return;
    }
    const check = (cond, msg) => {
      if (!cond) {
        throw otError(INVALID_PARAMETER, new Error(`iceConfig invalid: ${msg}`));
      }
    };
    if ('includeServers' in config) {
      check(['all', 'custom'].indexOf(config.includeServers) !== -1, '.includeServers must be all or custom');
    }
    if ('transportPolicy' in config) {
      check(['all', 'relay'].indexOf(config.transportPolicy) !== -1, '.transportPolicy must be all or relay');
    }
    check(Array.isArray(config.customServers), '.customServers must be an array');
    if (config.includeServers === 'custom' && config.transportPolicy === 'relay') {
      check(Array.isArray(config.customServers) && config.customServers.length > 0, '.customServers must be a non empty array if .includeServers=custom and .transportPolicy=relay');
    }
    config.customServers.forEach(server => {
      check(server.urls || !('url' in server), 'ice servers need .urls, not .url');
      check(typeof server.urls === 'string' || Array.isArray(server.urls), 'ice server .urls must be a string or an array');
      check(!server.username || typeof server.username === 'string', 'ice server .username must be a string if present');
      check(!server.credential || typeof server.credential === 'string', 'ice server .credential must be a string if present');
    });
  };
};
var _default = validateIceConfig;
exports.default = _default;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _browserSupportsSinglePeerConnection = _interopRequireDefault(__webpack_require__(787));
// SPC is only available if defined by sessionInfo or forced by flag
// and browser supports it.
var _default = (sessionInfo, overrideSinglePeerConnection) => {
  const _ref = sessionInfo || {},
    p2pEnabled = _ref.p2pEnabled,
    singlePeerConnection = _ref.singlePeerConnection;
  if (p2pEnabled) {
    // SPC is not available for P2P sessions.
    return false;
  }

  // We override sessionInfo when internal flag is not true.
  const forceDisabled = overrideSinglePeerConnection !== true;

  // We use singlePeerConnection flag from GSI by default.
  const isSinglePeerConnectionEnabled = !!singlePeerConnection && !forceDisabled;
  return isSinglePeerConnectionEnabled && (0, _browserSupportsSinglePeerConnection.default)();
};
exports.default = _default;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _singlePeerConnectionSupportedBrowsers = _interopRequireDefault(__webpack_require__(788));
var _default = () => {
  const isBrowserSupported = _env.default.isChromium || _env.default.isFirefox || _env.default.isSafari;
  if (!isBrowserSupported) {
    return false;
  }
  const name = _env.default.name,
    version = _env.default.version;
  const minimumVersion = _singlePeerConnectionSupportedBrowsers.default[name];
  const isVersionSupported = version >= minimumVersion;
  return isVersionSupported;
};
exports.default = _default;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Minimum versions are from October 2023. Further info: https://www.browsers.fyi/feed/
var _default = {
  Chrome: 118,
  Firefox: 118,
  Safari: 17,
  Edge: 118,
  Opera: 104
};
exports.default = _default;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _default = {
  NOT_CONNECTED: {
    code: _Errors.default.NOT_CONNECTED,
    message: 'Cannot use forceMute functionality. You are not connected to the session.',
    exceptionCode: _exception_codes.default.NOT_CONNECTED
  },
  PERMISSION_DENIED: {
    code: _Errors.default.PERMISSION_DENIED,
    message: 'This token does not allow forceMute usage. The role must be at least `moderator` to enable this ' + 'functionality',
    exceptionCode: _exception_codes.default.UNABLE_TO_FORCE_MUTE
  },
  INVALID_PARAMETER: {
    code: _Errors.default.INVALID_PARAMETER,
    message: 'Invalid Parameter. Check that you have passed valid parameter values into the method call.',
    exceptionCode: _exception_codes.default.INVALID_PARAMETER
  },
  NOT_FOUND: {
    code: _Errors.default.NOT_FOUND,
    message: 'The stream does not exist.'
  },
  UNEXPECTED_SERVER_RESPONSE: {
    code: _Errors.default.UNEXPECTED_SERVER_RESPONSE,
    message: 'An unexpected error occurred.',
    exceptionCode: _exception_codes.default.UNEXPECTED_SERVER_RESPONSE
  }
};
exports.default = _default;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const minSecretLength = 8;
const maxSecretLength = 256;
const validateSecret = secret => {
  if (typeof secret !== 'string') {
    throw new Error('secret must be a string');
  } else if (secret.length < minSecretLength) {
    throw new Error('secret must have at least 8 characters');
  } else if (secret.length > maxSecretLength) {
    throw new Error('secret must not exceed 256 characters');
  }
};
var _default = validateSecret;
exports.default = _default;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = RaptorSocketFactory;
var _isFunction = _interopRequireDefault(__webpack_require__(20));
var _assign = _interopRequireDefault(__webpack_require__(9));
var _once = _interopRequireDefault(__webpack_require__(52));
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _serializeMessage = _interopRequireDefault(__webpack_require__(353));
var _defaultRumorSocket = _interopRequireDefault(__webpack_require__(792));
var _log = _interopRequireDefault(__webpack_require__(1));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _hasE2eeCapability = _interopRequireDefault(__webpack_require__(115));
var _hasIceRestartsCapability = _interopRequireDefault(__webpack_require__(351));
var _hasRenegotiationCapability = _interopRequireDefault(__webpack_require__(806));
var _convertRumorError = _interopRequireDefault(__webpack_require__(352));
var _Dispatcher = _interopRequireDefault(__webpack_require__(355));
var _RaptorMessage = _interopRequireDefault(__webpack_require__(356));
var _OTHelpers = _interopRequireDefault(__webpack_require__(7));
var _Signal = _interopRequireDefault(__webpack_require__(357));
var _SignalError = _interopRequireDefault(__webpack_require__(813));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require, one-var */
/* eslint-disable prefer-rest-params, prefer-const, no-shadow, max-len */

function RaptorSocketFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const convertRumorError = deps.convertRumorError || _convertRumorError.default;
  const Dispatcher = deps.Dispatcher || _Dispatcher.default;
  const ExceptionCodes = deps.ExceptionCodes || _exception_codes.default;
  const hasIceRestartsCapability = deps.hasIceRestartsCapability || _hasIceRestartsCapability.default;
  const hasRenegotiationCapability = deps.hasRenegotiationCapability || _hasRenegotiationCapability.default;
  const hasE2eeCapability = deps.hasE2eeCapability || _hasE2eeCapability.default;
  const logging = deps.logging || (0, _log.default)('RaptorSocket');
  const RaptorMessage = deps.Message || _RaptorMessage.default;
  const OTHelpers = deps.OTHelpers || _OTHelpers.default;
  const RumorSocket = deps.RumorSocket || (0, _defaultRumorSocket.default)();
  const Signal = deps.Signal || _Signal.default;
  const SignalError = deps.SignalError || _SignalError.default;

  // The Dispatcher bit is purely to make testing simpler, it defaults to a new Dispatcher so in
  // normal operation you would omit it.
  const RaptorSocket = function RaptorSocket(_ref) {
    var _this = this;
    let connectionId = _ref.connectionId,
      sessionId = _ref.sessionId,
      messagingSocketUrl = _ref.messagingSocketUrl,
      symphonyUrl = _ref.symphonyUrl,
      dispatcher = _ref.dispatcher,
      analytics = _ref.analytics,
      _ref$requestedCapabil = _ref.requestedCapabilities,
      requestedCapabilities = _ref$requestedCapabil === void 0 ? [] : _ref$requestedCapabil;
    let _apiKey, _sessionId, _token, _sessionInfo, _completion, _p2p, _messagingServer, _rumorErrored, _isMuted;
    const _states = ['disconnected', 'connecting', 'connected', 'error', 'disconnecting'];
    const _dispatcher = dispatcher || new Dispatcher();

    // // Private API
    const setState = OTHelpers.statable(this, _states, 'disconnected');
    const logAnalyticsEvent = function logAnalyticsEvent(opt) {
      if (!opt.action || !opt.variation) {
        logging.debug('Expected action and variation');
      }
      analytics.logEvent((0, _assign.default)({
        sessionId: _sessionId,
        partnerId: _apiKey,
        p2p: _p2p,
        messagingServer: _messagingServer,
        connectionId
      }, opt));
    };
    const onConnectComplete = function onConnectComplete() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const error = args[0];
      if (error) {
        setState('error');
      } else {
        setState('connected');
      }
      _completion(...args);
    };
    const onClose = err => {
      let reason = 'clientDisconnected';
      if (!this.is('disconnecting') && _rumorErrored) {
        reason = 'networkDisconnected';
      }
      if (err && err.code === 4001) {
        reason = 'networkTimedout';
      }
      setState('disconnected');
      _dispatcher.onClose(reason, messagingSocketUrl);
    };
    const onError = err => {
      _rumorErrored = true;
      logging.error(err);
    };
    // @todo what does having an error mean? Are they always fatal? Are we disconnected now?

    const onReconnecting = () => {
      _dispatcher.onReconnecting();
    };
    const onReconnected = () => {
      logAnalyticsEvent({
        action: 'Reconnect',
        variation: 'Success',
        retries: this._rumor.reconnectRetriesCount(),
        messageQueueSize: this._rumor.messageQueueSize(),
        socketId: this.socketId
      });
      _dispatcher.onReconnected();
    };
    const onReconnectAttempt = () => {
      logAnalyticsEvent({
        action: 'Reconnect',
        variation: 'Attempt',
        retries: this._rumor.reconnectRetriesCount(),
        messageQueueSize: this._rumor.messageQueueSize(),
        socketId: this.socketId
      });
    };
    const onReconnectFailure = error => {
      if (error.message === 'connectionLimitExceeded') {
        error.code = ExceptionCodes.CONNECTION_LIMIT_EXCEEDED;
      }
      error.reason = 'ConnectToSession';
      const converted = convertRumorError(error);
      logAnalyticsEvent({
        action: 'Reconnect',
        variation: 'Failure',
        failureReason: error.reason,
        failureCode: converted.code,
        failureMessage: converted.message,
        messageQueueSize: this._rumor.messageQueueSize(),
        socketId: this.socketId
      });
    };

    // // Public API

    Object.defineProperty(this, 'socketId', {
      get() {
        return this._rumor.socketID;
      }
    });
    this.connect = function connect(token, sessionInfo, opt, completion) {
      if (!this.is('disconnected', 'error')) {
        logging.warn('Cannot connect the Raptor Socket as it is currently connected. You should ' + 'disconnect first.');
        return;
      }
      setState('connecting');
      _apiKey = sessionInfo.partnerId;
      _sessionId = sessionInfo.sessionId;
      _p2p = sessionInfo.p2pEnabled;
      _messagingServer = sessionInfo.messagingServer;
      _token = token;
      _completion = completion;
      _sessionInfo = {
        apiKey: _apiKey,
        sessionId: _sessionId
      };
      const rumorChannel = `/v2/partner/${_apiKey}/session/${_sessionId}`;
      this._rumor = new RaptorSocket.RumorSocket({
        messagingURL: messagingSocketUrl,
        notifyDisconnectAddress: symphonyUrl,
        connectionId,
        sessionId,
        enableReconnection: sessionInfo.reconnection,
        p2pEnabled: sessionInfo.p2pEnabled || false
      });
      this._rumor.on('close', onClose);
      this._rumor.on('error', onError);
      this._rumor.on('reconnecting', onReconnecting);
      this._rumor.on('reconnectAttempt', onReconnectAttempt);
      this._rumor.on('reconnectFailure', onReconnectFailure);
      this._rumor.on('reconnected', onReconnected);
      this._rumor.on('message', msg => {
        if (!_isMuted) {
          _dispatcher.dispatch(msg);
        }
      });
      const onStartupError = error => {
        onConnectComplete({
          reason: 'WebSocketConnection',
          code: error.code,
          message: error.message
        });
      };
      this._rumor.once('error', onStartupError);
      this._rumor.once('open', () => {
        this._rumor.removeListener('error', onStartupError);
        logging.debug(`connected. Subscribing to ${rumorChannel} on ${messagingSocketUrl}`);
        this._rumor.subscribe([rumorChannel]);
        const capabilities = requestedCapabilities;
        const supportRenegotiation = (RaptorSocket.hasIceRestartsCapability() || RaptorSocket.hasRenegotiationCapability()) && sessionInfo.renegotiation;
        if (supportRenegotiation) {
          capabilities.push('renegotiation');
        }
        const supportE2ee = RaptorSocket.hasE2eeCapability() && sessionInfo.e2ee;
        if (supportE2ee) {
          capabilities.push('e2ee');
        }

        // connect to session
        const connectMessage = RaptorMessage.connections.create({
          apiKey: _apiKey,
          sessionId: _sessionId,
          connectionId: this._rumor.id,
          connectionEventsSuppressed: opt.connectionEventsSuppressed,
          capabilities
        });
        const futureOwnConnection = new Promise(resolve => {
          const processConnectionCreated = message => {
            if (message.id === this._rumor.id) {
              resolve(message);
              dispatcher.off('connection#created', processConnectionCreated);
            }
          };
          dispatcher.on('connection#created', processConnectionCreated);
        });
        this.publish(connectMessage, {
          'X-TB-TOKEN-AUTH': _token
        }, true, (error, reply) => {
          if (error) {
            if (error.message === 'connectionLimitExceeded') {
              error.code = ExceptionCodes.CONNECTION_LIMIT_EXCEEDED;
            }
            onConnectComplete({
              reason: 'ConnectToSession',
              code: error.code,
              message: error.message,
              socketId: this.socketId
            });
            return;
          }
          const replyData = reply && reply.data ? JSON.parse(reply.data) : null;
          if (replyData) {
            if (!replyData.connection || replyData.connection.length === 0) {
              replyData.connection = [];
              if (Array.isArray(replyData.stream)) {
                replyData.stream.forEach(_ref2 => {
                  let connection = _ref2.connection;
                  return replyData.connection.push(connection);
                });
              }
            }
          }
          const onSessionState = (error, sessionState) => {
            if (error) {
              onConnectComplete({
                reason: 'GetSessionState',
                code: error.code,
                message: error.message,
                socketId: this.socketId
              });
            } else {
              onConnectComplete(undefined, sessionState);
            }
          };
          futureOwnConnection.then(ownConnection => {
            // in the case of not receiving our own connection, we add it here.
            // this is important under connectionEventSuppressed as rumor does
            // not give us our own connection in the initial ack to our connect
            // message
            if (!replyData.connection.some(conn => conn.id === ownConnection.id)) {
              replyData.connection.unshift(ownConnection);
            }
            const transactionId = (0, _uuid.default)();
            _dispatcher.registerCallback(transactionId, onSessionState);
            _dispatcher.emit('session#read', replyData, transactionId);
          });
        });
      });
    };
    this.disconnect = function () {
      if (this.is('disconnected')) {
        return;
      }
      setState('disconnecting');
      this._rumor.disconnect();
    };

    // Publishes +message+ to the Symphony app server.
    //
    // The completion handler is optional, as is the headers
    // dict, but if you provide the completion handler it must
    // be the last argument.
    //
    this.publish = function (message, headers, retryAfterReconnect, completion) {
      completion = completion || function () {};
      const completionOnce = (0, _once.default)(completion);
      const transactionId = (0, _uuid.default)();
      logging.debug(`Publish (ID:${transactionId}) ${message}`);
      if (this._rumor.readyState !== RumorSocket.OPEN || this._rumor.reconnecting && !retryAfterReconnect) {
        // TODO: This duplicates the same logic in rumor.
        const error = new Error('Not connected.');
        error.code = 500;
        completionOnce(error);
        logging.error('cannot publish until the socket is connected.');
        return undefined;
      }
      _dispatcher.registerCallback(transactionId, completionOnce);
      this._rumor.publish([symphonyUrl], message, (0, _assign.default)({}, headers, {
        'Content-Type': 'application/x-raptor+v2',
        'TRANSACTION-ID': transactionId,
        'X-TB-FROM-ADDRESS': this._rumor.id
      }), retryAfterReconnect, function (err) {
        // We want to propagate errors from rumor here. In particular, errors
        // related to not receiving a reply due to disconnection. However, when
        // a reply is received, the dispatcher may transform the reply, and may
        // generate an error that would not be recognized here. This isn't the
        // only awkward outcome related to the dispatcher design, and there are
        // plans to address this technical debt: OPENTOK-27994.
        if (err) {
          completionOnce(...arguments);
        }
      });
      return transactionId;
    };

    /**
     * Like publish, but automaitcally serializes the message parameter
     */
    this.send = function (_ref3, completion) {
      let message = _ref3.message,
        headers = _ref3.headers,
        _ref3$retryAfterRecon = _ref3.retryAfterReconnect,
        retryAfterReconnect = _ref3$retryAfterRecon === void 0 ? true : _ref3$retryAfterRecon;
      if (completion === void 0) {
        completion = () => {};
      }
      _this.publish((0, _serializeMessage.default)(message), headers, retryAfterReconnect, completion);
    };
    this.migrateSession = function () {
      this.publish(RaptorMessage.sessions.migrate(_apiKey, _sessionId), {}, true);
    };

    // Register a new stream against _sessionId
    this.streamCreate = function (options, completion) {
      if (options === void 0) {
        options = {};
      }
      if (completion === void 0) {
        completion = () => {};
      }
      const _options = options,
        name = _options.name,
        streamId = _options.streamId,
        subscriberAudioFallbackEnabled = _options.subscriberAudioFallbackEnabled,
        channels = _options.channels,
        minBitrate = _options.minBitrate,
        maxBitrate = _options.maxBitrate,
        sourceStreamId = _options.sourceStreamId,
        e2ee = _options.e2ee,
        publisherAudioFallbackEnabled = _options.publisherAudioFallbackEnabled,
        customProperties = _options.customProperties;
      const streamCreateOpts = {
        apiKey: _apiKey,
        sessionId: _sessionId,
        streamId,
        name,
        audioFallbackEnabled: subscriberAudioFallbackEnabled,
        // deprecated, to be removed when rumor in production
        subscriberAudioFallbackEnabled,
        channels,
        minBitrate,
        maxBitrate,
        sourceStreamId,
        e2ee,
        publisherAudioFallbackEnabled,
        customProperties
      };
      const message = RaptorMessage.streams.create(streamCreateOpts);
      this.publish(message, {}, true, (error, message) => {
        completion(error, streamId, message);
      });
    };
    this.streamDestroy = function (streamId, sourceStreamId) {
      this.publish(RaptorMessage.streams.destroy(_apiKey, _sessionId, streamId, sourceStreamId), {}, true);
    };
    this.streamChannelUpdate = function (streamId, channelId, attributes) {
      this.publish(RaptorMessage.streamChannels.update(_apiKey, _sessionId, streamId, channelId, attributes), {}, true);
    };
    this.subscriberCreate = function (streamId, subscriberId, channelsToSubscribeTo, sourceStreamId, e2ee, completion) {
      const subscriberCreateOpts = {
        apiKey: _apiKey,
        sessionId: _sessionId,
        streamId,
        subscriberId,
        connectionId: this._rumor.id,
        channelsToSubscribeTo,
        sourceStreamId,
        e2ee
      };
      this.publish(RaptorMessage.subscribers.create(subscriberCreateOpts), {}, true, completion);
    };
    this.subscriberDestroy = function (streamId, subscriberId, sourceStreamId) {
      this.publish(RaptorMessage.subscribers.destroy(_apiKey, _sessionId, streamId, subscriberId, sourceStreamId), {}, true);
    };
    this.subscriberUpdate = function (streamId, subscriberId, attributes) {
      this.publish(RaptorMessage.subscribers.update(_apiKey, _sessionId, streamId, subscriberId, attributes), {}, true);
    };
    this.subscriberChannelUpdate = function (streamId, subscriberId, channelId, attributes) {
      this.publish(RaptorMessage.subscriberChannels.update(_apiKey, _sessionId, streamId, subscriberId, channelId, attributes), {}, true);
    };
    this.forceDisconnect = function (connectionIdToDisconnect, completion) {
      this.publish(RaptorMessage.connections.destroy({
        apiKey: _apiKey,
        sessionId: _sessionId,
        connectionId: connectionIdToDisconnect
      }), {}, true, completion);
    };
    this.forceUnpublish = function (streamIdToUnpublish, completion) {
      this.publish(RaptorMessage.streams.destroy(_apiKey, _sessionId, streamIdToUnpublish), {}, true, completion);
    };
    this.forceMuteStream = function (streamId, completion) {
      const options = {
        streamId,
        active: true
      };
      this.publish(RaptorMessage.forceMute.update(Object.assign({}, _sessionInfo, options)), {}, true, completion);
    };
    this.forceMuteAll = function (excludedStreamIds, active, completion) {
      const options = {
        excludedStreamIds,
        active
      };
      this.publish(RaptorMessage.forceMute.update(Object.assign({}, _sessionInfo, options)), {}, true, completion);
    };
    this.signal = function (options, completion, logEventFn) {
      const signal = new Signal(_sessionId, this._rumor.id, options || {});
      if (!signal.valid) {
        if (completion && (0, _isFunction.default)(completion)) {
          completion(new SignalError(signal.error.code, signal.error.reason), signal.toHash());
        }
        return;
      }
      this.publish(signal.toRaptorMessage(), {}, signal.retryAfterReconnect, err => {
        let error, errorCode, errorMessage;
        const expectedErrorCodes = [400, 403, 404, 413, 500];
        if (err) {
          const parsedErrorCode = parseInt(err.code, 10);
          if (expectedErrorCodes.includes(parsedErrorCode)) {
            errorCode = parsedErrorCode;
            errorMessage = err.message;
          } else {
            errorCode = ExceptionCodes.UNEXPECTED_SERVER_RESPONSE;
            errorMessage = 'Unexpected server response. Try this operation again later.';
          }
          error = new SignalError(errorCode, errorMessage);
        } else {
          const typeStr = signal.data ? typeof signal.data : null;
          logEventFn('signal', 'send', {
            type: typeStr
          });
        }
        if (completion && (0, _isFunction.default)(completion)) {
          completion(error, signal.toHash());
        }
      });
    };
    this.muteMessages = mute => {
      _isMuted = mute;
    };
    this.id = function () {
      return this._rumor && this._rumor.id;
    };
  };
  RaptorSocket.hasIceRestartsCapability = hasIceRestartsCapability;
  RaptorSocket.hasRenegotiationCapability = hasRenegotiationCapability;
  RaptorSocket.hasE2eeCapability = hasE2eeCapability;
  RaptorSocket.RumorSocket = RumorSocket;
  return RaptorSocket;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = defaultRumorSocket;
var _events = _interopRequireDefault(__webpack_require__(12));
var _createCounter = _interopRequireDefault(__webpack_require__(793));
var _log = _interopRequireDefault(__webpack_require__(1));
var _ReconnectableSocket = _interopRequireDefault(__webpack_require__(794));
var _RumorSocket = _interopRequireDefault(__webpack_require__(799));
var _WebSocket = _interopRequireDefault(__webpack_require__(804));
var _analytics = _interopRequireDefault(__webpack_require__(31));
function defaultRumorSocket(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$WebSocket = _ref.WebSocket,
    WebSocket = _ref$WebSocket === void 0 ? _WebSocket.default : _ref$WebSocket;
  const allocateId = (0, _createCounter.default)();
  const ReconnectableSocket = (0, _ReconnectableSocket.default)({
    AnalyticsHelper: _analytics.default,
    EventEmitter: _events.default,
    WebSocket,
    logging: _log.default,
    allocateId
  });
  const RumorSocket = (0, _RumorSocket.default)({
    EventEmitter: _events.default,
    ReconnectableSocket,
    logging: _log.default,
    allocateId
  });
  return RumorSocket;
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createCounter;
function createCounter() {
  let current = 0;
  return () => {
    current += 1;
    return current;
  };
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _createClass2 = _interopRequireDefault(__webpack_require__(25));
var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(183));
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _logEvents = _interopRequireDefault(__webpack_require__(354));
var _socketCloseCodes = __webpack_require__(79);
var _Timer = _interopRequireDefault(__webpack_require__(795));
var _eventHelper = _interopRequireDefault(__webpack_require__(58));
var _createReadyStateMachine = _interopRequireDefault(__webpack_require__(796));
var _drainWebSocket = _interopRequireDefault(__webpack_require__(798));
/* eslint-disable no-constant-condition */

const removeReturnVal = fn => function () {
  fn(...arguments);
};
const isValidCode = code => code === 1000 || code >= 3000 && code <= 4999;
const CLOSE_TIMEOUT = _socketCloseCodes.codes.CLOSE_TIMEOUT;
var _default = _ref => {
  var _class;
  let AnalyticsHelper = _ref.AnalyticsHelper,
    EventEmitter = _ref.EventEmitter,
    WebSocket = _ref.WebSocket,
    logging = _ref.logging,
    allocateId = _ref.allocateId,
    _ref$BUFFER_DRAIN_INT = _ref.BUFFER_DRAIN_INTERVAL,
    BUFFER_DRAIN_INTERVAL = _ref$BUFFER_DRAIN_INT === void 0 ? 100 : _ref$BUFFER_DRAIN_INT,
    _ref$BUFFER_DRAIN_MAX = _ref.BUFFER_DRAIN_MAX_RETRIES,
    BUFFER_DRAIN_MAX_RETRIES = _ref$BUFFER_DRAIN_MAX === void 0 ? 10 : _ref$BUFFER_DRAIN_MAX;
  return _class = /*#__PURE__*/function (_EventEmitter) {
    (0, _inheritsLoose2.default)(ReconnectableSocket, _EventEmitter);
    function ReconnectableSocket(opt) {
      var _this;
      _this = _EventEmitter.call(this) || this;
      _this._url = void 0;
      _this._id = allocateId();
      _this._logger = logging(`ReconnectableSocket:${_this._id}`);
      _this._webSocket = void 0;
      _this._connectTimer = void 0;
      _this._pingTimer = void 0;
      _this._pingWarningTimer = void 0;
      _this._disconnectTimer = void 0;
      _this._queuedMessages = [];
      _this._draining = false;
      _this._analytics = new AnalyticsHelper();
      _this._logAnalyticsEvent = _ref2 => {
        let action = _ref2.action,
          variation = _ref2.variation,
          payload = _ref2.payload;
        _this._analytics.logEvent({
          action,
          variation,
          payload,
          sessionId: _this.sessionId,
          connectionId: _this.connectionId,
          p2p: _this.p2pEnabled
        });
      };
      const url = opt.url,
        connectionId = opt.connectionId,
        sessionId = opt.sessionId,
        p2pEnabled = opt.p2pEnabled,
        _opt$connectTimeout = opt.connectTimeout,
        connectTimeout = _opt$connectTimeout === void 0 ? 15000 : _opt$connectTimeout,
        _opt$pingThreshold = opt.pingThreshold,
        pingThreshold = _opt$pingThreshold === void 0 ? 3000 : _opt$pingThreshold,
        _opt$pingWarningDelay = opt.pingWarningDelay,
        pingWarningDelay = _opt$pingWarningDelay === void 0 ? 100 : _opt$pingWarningDelay,
        _opt$disconnectThresh = opt.disconnectThreshold,
        disconnectThreshold = _opt$disconnectThresh === void 0 ? 5900 : _opt$disconnectThresh,
        _opt$reconnectMaxDura = opt.reconnectMaxDuration,
        reconnectMaxDuration = _opt$reconnectMaxDura === void 0 ? 60000 : _opt$reconnectMaxDura;
      if (!url) {
        throw new Error('Must provide url');
      }
      _this.connectionId = connectionId;
      _this.sessionId = sessionId;
      _this.p2pEnabled = p2pEnabled;
      _this.readyStateMachine = (0, _createReadyStateMachine.default)({
        reconnectMaxDuration,
        CLOSED: ReconnectableSocket.CLOSED,
        CLOSING: ReconnectableSocket.CLOSING
      });
      _this._url = url;
      (0, _logEvents.default)({
        logger: _this._logger,
        obj: (0, _assertThisInitialized2.default)(_this),
        eventNames: ['error', 'open', 'message', 'needsPing', 'reconnecting', 'reconnectAttempt', 'reconnectFailure', 'reconnected', 'close']
      });
      _this.readyStateMachine.observe('onEnterOpen', _ref3 => {
        let from = _ref3.from;
        _this._resetPingTimers();
        _this._resetDisconnectTimer();
        _this._connectTimer.clear();
        if (from === 'reconnecting') {
          _this._queuedMessages.forEach(msg => _this.send(msg, true));
          _this._queuedMessages = [];
          _this.emit('reconnected');
          _this._logAnalyticsEvent({
            action: 'WebSocket:reconnect',
            variation: 'Success'
          });
        } else {
          _this.emit('open');
          _this._logAnalyticsEvent({
            action: 'WebSocket:open'
          });
        }
      });
      _this.readyStateMachine.observe('onEnterClosed', (_ref4, error) => {
        let from = _ref4.from,
          code = _ref4.code,
          reason = _ref4.reason;
        _this.emit('close', error);
        if (from === 'reconnecting') {
          _this._logAnalyticsEvent({
            action: 'WebSocket:reconnect',
            variation: 'Failure',
            payload: {
              code,
              reason
            }
          });
        }
      });
      _this.readyStateMachine.observe('onEnterClosing', removeReturnVal( /*#__PURE__*/function () {
        var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref5, _ref6) {
          var from, code, reason;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                from = _ref5.from;
                code = _ref6.code, reason = _ref6.reason;
                _this._clearTimers();
                _context.next = 5;
                return _this._clearSocket({
                  drain: from === 'open',
                  code,
                  reason
                });
              case 5:
                if (from === 'reconnecting') {
                  _this.emit('reconnectFailure', {
                    code,
                    reason
                  });
                  _this._logAnalyticsEvent({
                    action: 'WebSocket:reconnect',
                    variation: 'Failure'
                  });
                }
                setTimeout(() => {
                  _this.readyStateMachine.closed({
                    code,
                    reason
                  });
                });
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref7.apply(this, arguments);
        };
      }()));
      _this.readyStateMachine.observe('onEnterReconnecting', () => {
        _this.emit('reconnecting');
        _this._logAnalyticsEvent({
          action: 'WebSocket:reconnect',
          variation: 'Attempt'
        });
      });
      _this.readyStateMachine.observe('onDisconnect', removeReturnVal( /*#__PURE__*/function () {
        var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref8, _ref9) {
          var from, to, code, reason;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                from = _ref8.from, to = _ref8.to;
                code = _ref9.code, reason = _ref9.reason;
                if (!(to === 'reconnecting')) {
                  _context2.next = 12;
                  break;
                }
                if (!_this._draining) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("return");
              case 5:
                _this._clearTimers();
                _this.emit('reconnectAttempt');
                _context2.next = 9;
                return _this._clearSocket({
                  drain: from === 'open',
                  code,
                  reason
                });
              case 9:
                _this._createSocket();
                _context2.next = 13;
                break;
              case 12:
                _this._logAnalyticsEvent({
                  action: 'WebSocket:disconnect',
                  payload: {
                    code,
                    reason
                  }
                });
              case 13:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x3, _x4) {
          return _ref10.apply(this, arguments);
        };
      }()));
      const createTimer = (name, duration) => new _Timer.default({
        name,
        duration,
        logger: _this._logger
      });
      _this._connectTimer = createTimer('connect', connectTimeout);
      _this._pingTimer = createTimer('ping', pingThreshold);
      _this._pingWarningTimer = createTimer('pingWarning', pingWarningDelay);
      _this._disconnectTimer = createTimer('disconnect', disconnectThreshold);
      _this._createSocket();
      return _this;
    }
    var _proto = ReconnectableSocket.prototype;
    _proto._createSocket = function _createSocket() {
      const ws = new WebSocket(this.url);
      ws.binaryType = 'arraybuffer';
      const wsEvents = (0, _eventHelper.default)(ws);
      wsEvents.on('open', () => {
        this.readyStateMachine.open();
      });
      wsEvents.on('close', _ref11 => {
        let code = _ref11.code,
          reason = _ref11.reason;
        this.readyStateMachine.disconnect({
          code,
          reason
        });
      });
      wsEvents.on('error', event => {
        this.emit('error', event);
      });
      wsEvents.on('message', event => {
        if (this.readyState !== ReconnectableSocket.CLOSING) {
          // Without this you can receive a message while we are closing the socket and we end up
          // trying to reconnect again afterwards
          this._resetDisconnectTimer();
        }
        this.emit('message', event);
      });
      this._webSocket = ws;
      this._webSocketEvents = wsEvents;
      this._connectTimer.reset(() => {
        const closeData = {
          code: CLOSE_TIMEOUT,
          reason: 'Timeout while opening connection'
        };
        const error = new Error(closeData.reason);
        error.code = CLOSE_TIMEOUT;
        this.emit('error', error);
        this.readyStateMachine.disconnect(closeData);
      });
    };
    _proto._clearSocket = /*#__PURE__*/function () {
      var _clearSocket2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_temp) {
        var _ref12, _ref12$drain, drain, code, reason;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref12 = _temp === void 0 ? {} : _temp, _ref12$drain = _ref12.drain, drain = _ref12$drain === void 0 ? false : _ref12$drain, code = _ref12.code, reason = _ref12.reason;
              this._draining = true;
              if (this._webSocketEvents) {
                this._webSocketEvents.removeAll();
              }
              if (!(this._webSocket.readyState !== ReconnectableSocket.CLOSED)) {
                _context3.next = 9;
                break;
              }
              if (!drain) {
                _context3.next = 7;
                break;
              }
              _context3.next = 7;
              return (0, _drainWebSocket.default)(this._webSocket, {
                BUFFER_DRAIN_INTERVAL,
                BUFFER_DRAIN_MAX_RETRIES
              });
            case 7:
              this._logAnalyticsEvent({
                action: 'WebSocket:close',
                payload: {
                  code,
                  reason
                },
                variation: 'Attempt'
              });
              try {
                if (!isValidCode(code) || code === undefined && reason === undefined) {
                  // because IE
                  this._webSocket.close();
                } else {
                  this._webSocket.close(code, reason);
                }
                this._logAnalyticsEvent({
                  action: 'WebSocket:close',
                  payload: {
                    code,
                    reason
                  },
                  variation: 'Success'
                });
              } catch (err) {
                logging.error('Could not close websocket', err);
                this._logAnalyticsEvent({
                  action: 'WebSocket:close',
                  payload: {
                    err
                  },
                  variation: 'Failure'
                });
              }
            case 9:
              this._draining = false;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _clearSocket(_x5) {
        return _clearSocket2.apply(this, arguments);
      }
      return _clearSocket;
    }();
    _proto.send = function send(data, retryAfterReconnect) {
      if (retryAfterReconnect === void 0) {
        retryAfterReconnect = true;
      }
      // send deviates from WebSocket a little in that it returns a status instead of nothing.

      if (this.readyState === ReconnectableSocket.OPEN) {
        this._resetPingTimers();
      }
      const sendMessage = () => {
        try {
          this._webSocket.send(data);
          return 'sent';
        } catch (err) {
          if (this._webSocket.readyState === WebSocket.OPEN) {
            // On the other hand, there is a known bug in Firefox where .send throws an exception
            // even though it's open:
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1204727
            this._logger.debug('webSocket.send threw exception even though it was open:', err);
            return 'dropped';
          }
          throw err;
        }
      };
      if (this.readyStateMachine.state === 'reconnecting') {
        // the old socket is still open, let's send the message there as well.
        if (this._webSocket.readyState === WebSocket.OPEN) {
          try {
            sendMessage();
          } catch (err) {
            // but lets ignore any errors so that we can queue it as wel
          }
        }
        if (retryAfterReconnect) {
          this._queuedMessages.push(data);
          return 'queued';
        }
        this._logger.debug('Dropping message during reconnection since retryAfterReconnect is false:', data);
        return 'dropped';
      }
      return sendMessage();
    };
    _proto.close = function close(code, reason) {
      if (this.readyState === ReconnectableSocket.CLOSING) {
        throw new Error('Can not call close on a closing ReconnectableSocket');
      }
      if (this.readyState === ReconnectableSocket.CLOSED) {
        throw new Error('Can not call close on an already closed ReconnectableSocket');
      }
      this.readyStateMachine.close({
        code,
        reason
      });
    };
    _proto._resetPingTimers = function _resetPingTimers() {
      this._pingWarningTimer.clear();
      this._pingTimer.reset(() => {
        this._pingWarningTimer.reset(() => {
          this._logger.warn('Did not send message after needsPing event. Other side may ' + 'disconnect.');
        });
        this.emit('needsPing');
      });
    };
    _proto._resetDisconnectTimer = function _resetDisconnectTimer() {
      this._disconnectTimer.reset(() => this.readyStateMachine.disconnect({
        code: CLOSE_TIMEOUT,
        reason: 'No activity'
      }));
    };
    _proto._clearTimers = function _clearTimers() {
      [this._disconnectTimer, this._connectTimer, this._pingTimer, this._pingWarningTimer].forEach(timer => timer.clear());
    };
    (0, _createClass2.default)(ReconnectableSocket, [{
      key: "url",
      get: function get() {
        return typeof this._url === 'function' ? this._url() : this._url;
      }
    }, {
      key: "reconnecting",
      get: function get() {
        return this.readyStateMachine.state === 'reconnecting';
      }
    }, {
      key: "binaryType",
      get: function get() {
        return this._webSocket.binaryType;
      }
    }, {
      key: "bufferedAmount",
      get: function get() {
        return this._webSocket.bufferedAmount;
      }
    }, {
      key: "protocol",
      get: function get() {
        return this._webSocket.protocol;
      }
    }, {
      key: "extensions",
      get: function get() {
        return this._webSocket.extensions;
      }
    }, {
      key: "readyState",
      get: function get() {
        const STATE_MAP = {
          reconnecting: ReconnectableSocket.OPEN,
          open: ReconnectableSocket.OPEN,
          closing: ReconnectableSocket.CLOSING,
          closed: ReconnectableSocket.CLOSED,
          connecting: ReconnectableSocket.CONNECTING
        };
        return STATE_MAP[this.readyStateMachine.state];
      }
    }]);
    return ReconnectableSocket;
  }(EventEmitter), _class.CONNECTING = WebSocket.CONNECTING, _class.OPEN = WebSocket.OPEN, _class.CLOSING = WebSocket.CLOSING, _class.CLOSED = WebSocket.CLOSED, _class;
};
exports.default = _default;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// Tracks one timer so that when you reset it you can't accidentally get multiple timers.
let Timer = /*#__PURE__*/function () {
  function Timer(_ref) {
    let name = _ref.name,
      logger = _ref.logger,
      duration = _ref.duration;
    this.name = void 0;
    this.logger = void 0;
    this.duration = void 0;
    this.currId = void 0;
    this.name = name;
    this.logger = logger;
    this.duration = duration;
  }
  var _proto = Timer.prototype;
  _proto.reset = function reset(callback) {
    this.clear();
    const id = setTimeout(() => {
      if (this.currId === undefined) {
        // This shouldn't be necessary, except for this bug in jasmine's fake clock:
        // https://github.com/jasmine/jasmine/issues/1426
        return;
      }
      this.logger.spam(`${this.name} timer with id ${this.currId} expired, entering callback`);
      this.currId = undefined;
      callback();
    }, this.duration);
    this.currId = id;
    this.logger.spam(`Started ${this.name} timer with id ${this.currId}, expires in ` + `${this.duration}ms`);
  };
  _proto.clear = function clear() {
    if (this.currId === undefined) {
      return;
    }
    clearTimeout(this.currId);
    this.logger.spam(`Cleared ${this.name} timer with id ${this.currId}`);
    this.currId = undefined;
  };
  _proto.isRunning = function isRunning() {
    return this.currId !== undefined;
  };
  return Timer;
}();
exports.default = Timer;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _javascriptStateMachine = _interopRequireDefault(__webpack_require__(336));
var _elapsed = _interopRequireDefault(__webpack_require__(797));
var _socketCloseCodes = __webpack_require__(79);
var _log = _interopRequireDefault(__webpack_require__(1));
const logger = (0, _log.default)('ReconnectableSocketStateMachine');
const CLOSE_UNSUPPORTED = _socketCloseCodes.codes.CLOSE_UNSUPPORTED,
  CLOSE_UNEXPECTED_CONDITION = _socketCloseCodes.codes.CLOSE_UNEXPECTED_CONDITION;
var _default = _ref => {
  let reconnectMaxDuration = _ref.reconnectMaxDuration,
    CLOSED = _ref.CLOSED,
    CLOSING = _ref.CLOSING;
  let hasReconnectMaxDurationElapsed;
  function handleDisconnect(_ref2) {
    let code = _ref2.code;
    if (this.state === 'open' || !hasReconnectMaxDurationElapsed) {
      hasReconnectMaxDurationElapsed = (0, _elapsed.default)(reconnectMaxDuration);
    }
    const shouldReconnect = reconnectMaxDuration > 0 && !hasReconnectMaxDurationElapsed() && [CLOSE_UNSUPPORTED, CLOSE_UNEXPECTED_CONDITION].indexOf(code) === -1 && [CLOSED, CLOSING].indexOf(this.readyState) === -1;
    if (shouldReconnect) {
      return 'reconnecting';
    }
    return 'closing';
  }
  return new _javascriptStateMachine.default({
    init: 'connecting',
    methods: {
      onInvalidTransition(transition, from, to) {
        logger.error('Invalid state transition', {
          transition,
          from,
          to
        });
      }
    },
    transitions: [{
      name: 'open',
      from: ['connecting', 'reconnecting'],
      to: 'open'
    }, {
      name: 'close',
      from: ['connecting', 'reconnecting', 'open'],
      to: 'closing'
    }, {
      name: 'closed',
      from: 'closing',
      to: 'closed'
    }, {
      name: 'disconnect',
      from: ['reconnecting', 'open', 'connecting'],
      to: handleDisconnect
    }]
  });
};
exports.default = _default;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = timeInMilliseconds => {
  let hasElapsed = false;
  setTimeout(() => {
    hasElapsed = true;
  }, timeInMilliseconds);
  return () => hasElapsed;
};
exports.default = _default;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _promiseDelay = _interopRequireDefault(__webpack_require__(95));
var _default = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(webSocket, _temp) {
    var _ref2, _ref2$BUFFER_DRAIN_IN, BUFFER_DRAIN_INTERVAL, _ref2$BUFFER_DRAIN_MA, BUFFER_DRAIN_MAX_RETRIES, attemptNo;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _temp === void 0 ? {} : _temp, _ref2$BUFFER_DRAIN_IN = _ref2.BUFFER_DRAIN_INTERVAL, BUFFER_DRAIN_INTERVAL = _ref2$BUFFER_DRAIN_IN === void 0 ? 100 : _ref2$BUFFER_DRAIN_IN, _ref2$BUFFER_DRAIN_MA = _ref2.BUFFER_DRAIN_MAX_RETRIES, BUFFER_DRAIN_MAX_RETRIES = _ref2$BUFFER_DRAIN_MA === void 0 ? 10 : _ref2$BUFFER_DRAIN_MA;
          attemptNo = 0;
        case 2:
          if (!(attemptNo < BUFFER_DRAIN_MAX_RETRIES)) {
            _context.next = 10;
            break;
          }
          if (!(webSocket.bufferedAmount === 0)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("break", 10);
        case 5:
          _context.next = 7;
          return (0, _promiseDelay.default)(BUFFER_DRAIN_INTERVAL);
        case 7:
          attemptNo += 1;
          _context.next = 2;
          break;
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
exports.default = _default;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _createClass2 = _interopRequireDefault(__webpack_require__(25));
var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(183));
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _logEvents = _interopRequireDefault(__webpack_require__(354));
var _RumorMessage = _interopRequireDefault(__webpack_require__(800));
var RumorMessageTypes = _interopRequireWildcard(__webpack_require__(187));
var _SocketError = _interopRequireDefault(__webpack_require__(803));
var _socketCloseCodes = __webpack_require__(79);
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// @todo enable the following disabled rules see OPENTOK-31136 for more info
var _default = _ref => {
  var _class;
  let EventEmitter = _ref.EventEmitter,
    ReconnectableSocket = _ref.ReconnectableSocket,
    logging = _ref.logging,
    allocateId = _ref.allocateId;
  return _class = /*#__PURE__*/function (_EventEmitter) {
    (0, _inheritsLoose2.default)(RumorSocket, _EventEmitter);
    function RumorSocket(_ref2) {
      var _this;
      let messagingURL = _ref2.messagingURL,
        notifyDisconnectAddress = _ref2.notifyDisconnectAddress,
        connectionId = _ref2.connectionId,
        sessionId = _ref2.sessionId,
        enableReconnection = _ref2.enableReconnection,
        _ref2$pingThreshold = _ref2.pingThreshold,
        pingThreshold = _ref2$pingThreshold === void 0 ? 2000 : _ref2$pingThreshold,
        _ref2$disconnectThres = _ref2.disconnectThreshold,
        disconnectThreshold = _ref2$disconnectThres === void 0 ? (enableReconnection ? 3 : 25) * pingThreshold - 100 : _ref2$disconnectThres,
        _ref2$reconnectMaxDur = _ref2.reconnectMaxDuration,
        reconnectMaxDuration = _ref2$reconnectMaxDur === void 0 ? enableReconnection ? 60000 : 0 : _ref2$reconnectMaxDur,
        p2pEnabled = _ref2.p2pEnabled;
      _this = _EventEmitter.call(this) || this;
      _this.url = void 0;
      _this.id = void 0;
      _this._opened = false;
      _this._socket = void 0;
      _this._reconnectAttempts = 0;
      _this._socketID = (0, _uuid.default)();
      _this._receivedTransactionIDs = [];
      _this._notifyDisconnectAddress = void 0;
      _this._enableReconnection = void 0;
      _this._pendingMessages = [];
      _this._logger = logging(`RumorSocket:${allocateId()}`);
      (0, _logEvents.default)({
        logger: _this._logger,
        obj: (0, _assertThisInitialized2.default)(_this),
        eventNames: ['open', 'message', 'error', 'reconnecting', 'reconnectAttempt', 'reconnectFailure', 'reconnected', 'close']
      });
      _this.url = messagingURL;
      _this.id = connectionId;
      _this._notifyDisconnectAddress = notifyDisconnectAddress;
      _this._enableReconnection = enableReconnection;
      _this.on('error', socketError => {
        _this._logger.error(socketError.message);
      });
      try {
        _this._socket = new ReconnectableSocket({
          url: () => !_this._enableReconnection ? _this.url : [_this.url, _this.url.indexOf('?') >= 0 ? '&' : '?', `socketId=${_this._socketID}`, _this._socket && _this._socket.reconnecting ? '&reconnect=true' : '', `&attempt=${(0, _uuid.default)()}`].join(''),
          pingThreshold,
          disconnectThreshold,
          reconnectMaxDuration,
          connectionId,
          sessionId,
          p2pEnabled
        });
      } catch (e) {
        _this._logger.error(e);
        _this.emit('error', new _SocketError.default(_socketCloseCodes.codes.CLOSE_CONNECT_EXCEPTION));
      }
      const onOpen = () => {
        _this._opened = true;
        _this._socket.send(_RumorMessage.default.Connect(_this.id, notifyDisconnectAddress).serialize());
        _this.emit('open', _this.id);
      };
      _this._socket.once('open', onOpen);
      _this._socket.on('message', event => _this._receiveMessage(event));
      _this._socket.once('close', closeEvent => {
        _this._logger.debug(`ReconnectableSocket closed (code: ${closeEvent.code})`);
        _this._clearPendingMessages();

        // We don't emit an error for these close codes because they are normal and TIMEOUT has a
        // dedicated error and we would duplicate it here.
        const CLOSE_NORMAL = _socketCloseCodes.codes.CLOSE_NORMAL,
          CLOSE_GOING_AWAY = _socketCloseCodes.codes.CLOSE_GOING_AWAY,
          CLOSE_TIMEOUT = _socketCloseCodes.codes.CLOSE_TIMEOUT;
        if ([CLOSE_NORMAL, CLOSE_GOING_AWAY, CLOSE_TIMEOUT].indexOf(closeEvent.code) === -1) {
          _this.emit('error', new _SocketError.default(closeEvent.code));
        }
        _this.emit('close', closeEvent);
      });
      _this._socket.on('error', _ref3 => {
        let code = _ref3.code;
        return _this.emit('error', new _SocketError.default(code));
      });
      _this._socket.on('needsPing', () => {
        _this._socket.send(_RumorMessage.default.Ping().serialize());
      });
      _this._socket.on('reconnecting', () => {
        if (!_this._opened) {
          return;
        } // ignore reconnect events when we haven't opened yet
        _this._clearPendingMessagesWhichShouldntRetry();
        _this.emit('reconnecting');
        _this._reconnectAttempts = 0;
      });
      _this._socket.on('reconnectAttempt', () => {
        if (!_this._opened) {
          return;
        } // ignore reconnect events when we haven't opened yet
        _this._reconnectAttempts += 1;

        // TODO: Although this should be ok if the socket is already closed since ReconnectableSocket
        // will just drop it due to retryAfterReconnect=false, it should be tested.
        _this._socket.send(_RumorMessage.default.Disconnect('1').serialize(), false);
        _this.emit('reconnectAttempt');
      });
      _this._socket.on('reconnected', () => {
        if (!_this._opened) {
          onOpen();
          return;
        } // ignore reconnect events when we haven't opened yet
        // Resend pending messages (unacknowledged messages)
        _this._pendingMessages.forEach(msg => {
          _this._socket.send(msg.rumorMessage.serialize());
        });
        _this.emit('reconnected');
      });
      _this._socket.on('reconnectFailure', () => {
        if (!_this._opened) {
          return;
        } // ignore reconnect events when we haven't opened yet
        _this._logger.debug('Reconnecting failed as connectivity was not restored within ' + `${reconnectMaxDuration}ms`);

        // TODO: This was picked when porting over the old code, but we should be able to set use a
        // better code and message here.
        _this.emit('reconnectFailure', new _SocketError.default());
      });
      return _this;
    }
    var _proto = RumorSocket.prototype;
    _proto._clearPendingMessagesWhichShouldntRetry = function _clearPendingMessagesWhichShouldntRetry() {
      const messagesToClear = this._pendingMessages.filter(message => !message.retryAfterReconnect);
      this._pendingMessages = this._pendingMessages.filter(message => message.retryAfterReconnect);
      messagesToClear.forEach(message => {
        const error = new Error('Not connected.');
        error.code = 500;
        message.completion(error);
      });
    };
    _proto._clearPendingMessages = function _clearPendingMessages() {
      this._pendingMessages.forEach(message => {
        const error = new Error('Not connected.');
        error.code = 500;
        message.completion(error);
      });
      this._pendingMessages = [];
    };
    _proto._sendAck = function _sendAck(msg) {
      this._socket.send(_RumorMessage.default.Status([msg.fromAddress], {
        'TRANSACTION-ID': msg.headers['TRANSACTION-ID'],
        'X-TB-FROM-ADDRESS': this.id
      }).serialize());
    };
    _proto._receiveMessage = function _receiveMessage(messageEvent) {
      var _msgData, _msgData$content;
      const msg = _RumorMessage.default.deserialize(messageEvent.data);
      if (msg.type === RumorMessageTypes.PONG) {
        return;
      }
      let msgData;
      if (msg.data) {
        try {
          msgData = JSON.parse(msg.data);
        } catch (e) {
          this._logger.error(`Failed to parse JSON with error ${e}`);
        }
      }
      if (((_msgData = msgData) == null ? void 0 : (_msgData$content = _msgData.content) == null ? void 0 : _msgData$content.type) === 'data') {
        this._logger.spam('Received:', msg);
      } else {
        this._logger.debug('Received:', msg);
      }
      if (msg.transactionId) {
        // remove pending message
        this._pendingMessages = this._pendingMessages.filter(pendingMessage => {
          if (pendingMessage.rumorMessage.transactionId === msg.transactionId) {
            this._logger.debug('Marking', msg.transactionId, ' as received');
            pendingMessage.completion(undefined, msg);
          }
          return pendingMessage.rumorMessage.transactionId !== msg.transactionId;
        });
      }
      if (msg.transactionId && msg.type !== RumorMessageTypes.STATUS) {
        // 1) ack it!
        this._sendAck(msg);

        // Have we seen this transaction before?
        if (this._receivedTransactionIDs.indexOf(msg.transactionId) >= 0) {
          // We've handled this transactionId before, but the ACK
          // must have been lost. That's ok, we've told the server
          // so we can just ignore this message now.
          return;
        }
        this._receivedTransactionIDs.push(msg.transactionId);
      }
      this.emit('message', msg);
    };
    _proto.publish = function publish(topics, message, headers, retryAfterReconnect, completion) {
      if (completion === void 0) {
        completion = () => {};
      }
      // TODO: Instead of completion, sending a message should return an event emitter which emits:
      // - sent: if connected, emitted on next tick, if reconnecting, emitted on reconnected
      // - ack: received ack for this message from server
      // - error: won't receive ack (not connected / dropped)
      // Also should have .status obtained from ReconnectableSocket.send

      const rumorMessage = _RumorMessage.default.Publish(topics, message, headers);

      // We always use retryAfterReconnect=false on ReconnectableSocket because rumor does additional
      // retries based on the ack status of messages which ReconnectableSocket doesn't know about,
      // and we don't want these retry strategies to conflict.
      const status = this._socket.send(rumorMessage.serialize(), false);
      if (status === 'dropped' && !retryAfterReconnect) {
        const error = new Error('Not connected.');
        error.code = 500;
        completion(error);
        return;
      }
      this._pendingMessages.push({
        rumorMessage,
        retryAfterReconnect,
        completion
      });
    };
    _proto.subscribe = function subscribe(topics) {
      this._socket.send(_RumorMessage.default.Subscribe(topics).serialize());
    };
    _proto.unsubscribe = function unsubscribe(topics) {
      this._socket.send(_RumorMessage.default.Unsubscribe(topics).serialize());
    };
    _proto.disconnect = function disconnect() {
      if (this.readyState === RumorSocket.OPEN) {
        this._socket.send(_RumorMessage.default.Disconnect().serialize());
      }
      if (this._socket.readyState !== ReconnectableSocket.CLOSED && this._socket.readyState !== ReconnectableSocket.CLOSING) {
        const CLOSE_NORMAL = _socketCloseCodes.codes.CLOSE_NORMAL;
        this._socket.close(CLOSE_NORMAL, _socketCloseCodes.messages[CLOSE_NORMAL]);
      }
    };
    _proto.status = function status(toAddress, transactionId) {
      this._socket.send(_RumorMessage.default.Status(toAddress, {
        'TRANSACTION-ID': transactionId,
        'X-TB-FROM-ADDRESS': this.id
      }).serialize());
    };
    _proto.reconnectRetriesCount = function reconnectRetriesCount() {
      return this._reconnectAttempts;
    };
    _proto.messageQueueSize = function messageQueueSize() {
      return this._pendingMessages.length;
    }

    // This could do with some reconciliation. Also with logger name now.
    ;
    (0, _createClass2.default)(RumorSocket, [{
      key: "readyState",
      get: function get() {
        return this._socket ? this._socket.readyState : ReconnectableSocket.CONNECTING;
      }
    }, {
      key: "reconnecting",
      get: function get() {
        return this._opened && this._socket && this._socket.reconnecting;
      }

      // Messages which have not yet been acknowledged
    }, {
      key: "socketID",
      get: function get() {
        return this._socketID;
      }
    }]);
    return RumorSocket;
  }(EventEmitter), _class.CONNECTING = ReconnectableSocket.CONNECTING, _class.OPEN = ReconnectableSocket.OPEN, _class.CLOSING = ReconnectableSocket.CLOSING, _class.CLOSED = ReconnectableSocket.CLOSED, _class;
};
exports.default = _default;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _uuid = _interopRequireDefault(__webpack_require__(17));
var _encoding = __webpack_require__(801);
var RumorMessageTypes = _interopRequireWildcard(__webpack_require__(187));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable one-var, no-restricted-syntax, no-prototype-builtins */
/* eslint-disable no-continue, prefer-const, no-bitwise, no-mixed-operators, no-param-reassign */

const toArrayBuffer = buffer => {
  const ab = new ArrayBuffer(buffer.length);
  const view = new Uint8Array(ab);
  for (let i = 0; i < buffer.length; ++i) {
    view[i] = buffer[i];
  }
  return ab;
};

// @references
// * https://tbwiki.tokbox.com/index.php/Rumor_Message_Packet
// * https://tbwiki.tokbox.com/index.php/Rumor_Protocol
//
let RumorMessage = /*#__PURE__*/function () {
  function RumorMessage(type, toAddress, headers, data) {
    this.type = void 0;
    this.toAddress = void 0;
    this.headers = void 0;
    this.data = void 0;
    this.type = type;
    this.toAddress = toAddress;
    this.headers = headers;
    this.data = data;
    this.fromAddress = this.headers['X-TB-FROM-ADDRESS'];
    this.transactionId = this.headers['TRANSACTION-ID'];
    this.status = this.headers.STATUS;

    // Only status messages will have a status header. So a missing status header
    // does not indicate an eror.
    this.isError = this.status && this.status[0] !== '2';
  }
  var _proto = RumorMessage.prototype;
  _proto.serialize = function serialize() {
    let strArray, dataView, i, j;
    let offset = 8;
    let cBuf = 7;
    const address = [];
    const headerKey = [];
    const headerVal = [];

    // The number of addresses
    cBuf++;

    // Write out the address.
    for (i = 0; i < this.toAddress.length; i++) {
      /* jshint newcap:false */
      address.push(new _encoding.TextEncoder().encode(this.toAddress[i]));
      cBuf += 2;
      cBuf += address[i].length;
    }

    // The number of parameters
    cBuf++;

    // Write out the params
    i = 0;
    for (const key in this.headers) {
      // eslint-disable-line one-var
      if (!this.headers.hasOwnProperty(key)) {
        continue;
      }
      headerKey.push(new _encoding.TextEncoder().encode(key));
      headerVal.push(new _encoding.TextEncoder().encode(this.headers[key]));
      cBuf += 4;
      cBuf += headerKey[i].length;
      cBuf += headerVal[i].length;
      i++;
    }
    dataView = new _encoding.TextEncoder('utf-8').encode(this.data);
    cBuf += dataView.length;

    // Let's allocate a binary blob of this size
    const buffer = new ArrayBuffer(cBuf);
    const uint8View = new Uint8Array(buffer, 0, cBuf);

    // We don't include the header in the lenght.
    cBuf -= 4;

    // Write out size (in network order)
    uint8View[0] = (cBuf & 0xFF000000) >>> 24;
    uint8View[1] = (cBuf & 0x00FF0000) >>> 16;
    uint8View[2] = (cBuf & 0x0000FF00) >>> 8;
    uint8View[3] = (cBuf & 0x000000FF) >>> 0;

    // Write out reserved bytes
    uint8View[4] = 0;
    uint8View[5] = 0;

    // Write out message type
    uint8View[6] = this.type;
    uint8View[7] = this.toAddress.length;

    // Now just copy over the encoded values..
    for (i = 0; i < address.length; i++) {
      strArray = address[i];
      uint8View[offset++] = strArray.length >> 8 & 0xFF;
      uint8View[offset++] = strArray.length >> 0 & 0xFF;
      for (j = 0; j < strArray.length; j++) {
        uint8View[offset++] = strArray[j];
      }
    }
    uint8View[offset++] = headerKey.length;

    // Write out the params
    for (i = 0; i < headerKey.length; i++) {
      strArray = headerKey[i];
      uint8View[offset++] = strArray.length >> 8 & 0xFF;
      uint8View[offset++] = strArray.length >> 0 & 0xFF;
      for (j = 0; j < strArray.length; j++) {
        uint8View[offset++] = strArray[j];
      }
      strArray = headerVal[i];
      uint8View[offset++] = strArray.length >> 8 & 0xFF;
      uint8View[offset++] = strArray.length >> 0 & 0xFF;
      for (j = 0; j < strArray.length; j++) {
        uint8View[offset++] = strArray[j];
      }
    }

    // And finally the data
    for (i = 0; i < dataView.length; i++) {
      uint8View[offset++] = dataView[i];
    }
    return buffer;
  };
  RumorMessage.deserialize = function deserialize(buffer) {
    if ((typeof window !== undefined ? window : global).Buffer && (typeof window !== undefined ? window : global).Buffer.isBuffer(buffer)) {
      buffer = toArrayBuffer(buffer);
    }
    let type, strView, headerlen, headers, keyStr, valStr, length, i;
    let offset = 8;
    const uint8View = new Uint8Array(buffer);
    type = uint8View[6];
    const address = [];
    for (i = 0; i < uint8View[7]; i++) {
      length = uint8View[offset++] << 8;
      length += uint8View[offset++];
      strView = new Uint8Array(buffer, offset, length);
      /* jshint newcap:false */
      address[i] = new _encoding.TextDecoder('utf-8').decode(strView);
      offset += length;
    }
    headerlen = uint8View[offset++];
    headers = {};
    for (i = 0; i < headerlen; i++) {
      length = uint8View[offset++] << 8;
      length += uint8View[offset++];
      strView = new Uint8Array(buffer, offset, length);
      keyStr = new _encoding.TextDecoder('utf-8').decode(strView);
      offset += length;
      length = uint8View[offset++] << 8;
      length += uint8View[offset++];
      strView = new Uint8Array(buffer, offset, length);
      valStr = new _encoding.TextDecoder('utf-8').decode(strView);
      headers[keyStr] = valStr;
      offset += length;
    }
    const dataView = new Uint8Array(buffer, offset);
    const data = new _encoding.TextDecoder('utf-8').decode(dataView);
    return new RumorMessage(type, address, headers, data);
  };
  RumorMessage.Connect = function Connect(uniqueId, notifyDisconnectAddress) {
    const headers = {
      uniqueId,
      'TRANSACTION-ID': (0, _uuid.default)(),
      notifyDisconnectAddress
    };
    return new RumorMessage(RumorMessageTypes.CONNECT, [], headers, '');
  };
  RumorMessage.Disconnect = function Disconnect(reconnect) {
    return new RumorMessage(RumorMessageTypes.DISCONNECT, [], {
      reconnect
    }, '');
  };
  RumorMessage.Subscribe = function Subscribe(topics) {
    return new RumorMessage(RumorMessageTypes.SUBSCRIBE, topics, {}, '');
  };
  RumorMessage.Unsubscribe = function Unsubscribe(topics) {
    return new RumorMessage(RumorMessageTypes.UNSUBSCRIBE, topics, {}, '');
  };
  RumorMessage.Publish = function Publish(topics, message, headers) {
    return new RumorMessage(RumorMessageTypes.MESSAGE, topics, headers || {}, message || '');
  };
  RumorMessage.Status = function Status(topics, headers) {
    return new RumorMessage(RumorMessageTypes.STATUS, topics, headers || {}, '');
  }

  // This message is used to implement keepalives on the persistent
  // socket connection between the client and server. Every time the
  // client sends a PING to the server, the server will respond with
  // a PONG.
  ;
  RumorMessage.Ping = function Ping() {
    return new RumorMessage(RumorMessageTypes.PING, [], {}, '');
  };
  return RumorMessage;
}();
exports.default = RumorMessage;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.TextEncoder = exports.TextDecoder = void 0;
var TextEncoding = _interopRequireWildcard(__webpack_require__(802));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Unfortunately it looks like the text-encoding module always returns its implementations of
// TextEncoder and TextDecoder, so we wrap it here to expose the global (window) ones, if available.

const TextEncoder = (typeof window !== undefined ? window : global).TextEncoder || TextEncoding.TextEncoder;
exports.TextEncoder = TextEncoder;
const TextDecoder = (typeof window !== undefined ? window : global).TextDecoder || TextEncoding.TextDecoder;
exports.TextDecoder = TextDecoder;

/***/ }),
/* 802 */
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextEncoder", function() { return TextEncoder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextDecoder", function() { return TextDecoder; });


// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

//
// Utilities
//

/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */
function inRange(a, min, max) {
  return min <= a && a <= max;
}

/**
 * @param {*} o
 * @return {Object}
 */
function ToDictionary(o) {
  if (o === undefined) return {};
  if (o === Object(o)) return o;
  throw TypeError('Could not convert argument to dictionary');
}

/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */
function stringToCodePoints(string) {
  // https://heycam.github.io/webidl/#dfn-obtain-unicode

  // 1. Let S be the DOMString value.
  var s = String(string);

  // 2. Let n be the length of S.
  var n = s.length;

  // 3. Initialize i to 0.
  var i = 0;

  // 4. Initialize U to be an empty sequence of Unicode characters.
  var u = [];

  // 5. While i < n:
  while (i < n) {

    // 1. Let c be the code unit in S at index i.
    var c = s.charCodeAt(i);

    // 2. Depending on the value of c:

    // c < 0xD800 or c > 0xDFFF
    if (c < 0xD800 || c > 0xDFFF) {
      // Append to U the Unicode character with code point c.
      u.push(c);
    }

    // 0xDC00 ≤ c ≤ 0xDFFF
    else if (0xDC00 <= c && c <= 0xDFFF) {
      // Append to U a U+FFFD REPLACEMENT CHARACTER.
      u.push(0xFFFD);
    }

    // 0xD800 ≤ c ≤ 0xDBFF
    else if (0xD800 <= c && c <= 0xDBFF) {
      // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
      // CHARACTER.
      if (i === n - 1) {
        u.push(0xFFFD);
      }
      // 2. Otherwise, i < n−1:
      else {
        // 1. Let d be the code unit in S at index i+1.
        var d = string.charCodeAt(i + 1);

        // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
        if (0xDC00 <= d && d <= 0xDFFF) {
          // 1. Let a be c & 0x3FF.
          var a = c & 0x3FF;

          // 2. Let b be d & 0x3FF.
          var b = d & 0x3FF;

          // 3. Append to U the Unicode character with code point
          // 2^16+2^10*a+b.
          u.push(0x10000 + (a << 10) + b);

          // 4. Set i to i+1.
          i += 1;
        }

        // 3. Otherwise, d < 0xDC00 or d > 0xDFFF. Append to U a
        // U+FFFD REPLACEMENT CHARACTER.
        else  {
          u.push(0xFFFD);
        }
      }
    }

    // 3. Set i to i+1.
    i += 1;
  }

  // 6. Return U.
  return u;
}

/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */
function codePointsToString(code_points) {
  var s = '';
  for (var i = 0; i < code_points.length; ++i) {
    var cp = code_points[i];
    if (cp <= 0xFFFF) {
      s += String.fromCharCode(cp);
    } else {
      cp -= 0x10000;
      s += String.fromCharCode((cp >> 10) + 0xD800,
                               (cp & 0x3FF) + 0xDC00);
    }
  }
  return s;
}


//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//

//
// 3. Terminology
//

/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var end_of_stream = -1;

/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */
function Stream(tokens) {
  /** @type {!Array.<number>} */
  this.tokens = [].slice.call(tokens);
}

Stream.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },

  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
   read: function() {
    if (!this.tokens.length)
      return end_of_stream;
     return this.tokens.shift();
   },

  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(token) {
    if (Array.isArray(token)) {
      var tokens = /**@type {!Array.<number>}*/(token);
      while (tokens.length)
        this.tokens.unshift(tokens.pop());
    } else {
      this.tokens.unshift(token);
    }
  },

  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(token) {
    if (Array.isArray(token)) {
      var tokens = /**@type {!Array.<number>}*/(token);
      while (tokens.length)
        this.tokens.push(tokens.shift());
    } else {
      this.tokens.push(token);
    }
  }
};

//
// 4. Encodings
//

// 4.1 Encoders and decoders

/** @const */
var finished = -1;

/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */
function decoderError(fatal, opt_code_point) {
  if (fatal)
    throw TypeError('Decoder error');
  return opt_code_point || 0xFFFD;
}

/** @interface */
function Decoder() {}
Decoder.prototype = {
  /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point, or |finished|.
   */
  handler: function(stream, bite) {}
};

/** @interface */
function Encoder() {}
Encoder.prototype = {
  /**
   * @param {Stream} stream The stream of code points being encoded.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit, or |finished|.
   */
  handler: function(stream, code_point) {}
};

//
// 7. API
//

/** @const */ var DEFAULT_ENCODING = 'utf-8';

// 7.1 Interface TextDecoder

/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */
function TextDecoder(encoding, options) {
  if (!(this instanceof TextDecoder)) {
    return new TextDecoder(encoding, options);
  }
  encoding = encoding !== undefined ? String(encoding).toLowerCase() : DEFAULT_ENCODING;
  if (encoding !== DEFAULT_ENCODING) {
    throw new Error('Encoding not supported. Only utf-8 is supported');
  }
  options = ToDictionary(options);

  /** @private @type {boolean} */
  this._streaming = false;
  /** @private @type {boolean} */
  this._BOMseen = false;
  /** @private @type {?Decoder} */
  this._decoder = null;
  /** @private @type {boolean} */
  this._fatal = Boolean(options['fatal']);
  /** @private @type {boolean} */
  this._ignoreBOM = Boolean(options['ignoreBOM']);

  Object.defineProperty(this, 'encoding', {value: 'utf-8'});
  Object.defineProperty(this, 'fatal', {value: this._fatal});
  Object.defineProperty(this, 'ignoreBOM', {value: this._ignoreBOM});
}

TextDecoder.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function decode(input, options) {
    var bytes;
    if (typeof input === 'object' && input instanceof ArrayBuffer) {
      bytes = new Uint8Array(input);
    } else if (typeof input === 'object' && 'buffer' in input &&
               input.buffer instanceof ArrayBuffer) {
      bytes = new Uint8Array(input.buffer,
                             input.byteOffset,
                             input.byteLength);
    } else {
      bytes = new Uint8Array(0);
    }

    options = ToDictionary(options);

    if (!this._streaming) {
      this._decoder = new UTF8Decoder({fatal: this._fatal});
      this._BOMseen = false;
    }
    this._streaming = Boolean(options['stream']);

    var input_stream = new Stream(bytes);

    var code_points = [];

    /** @type {?(number|!Array.<number>)} */
    var result;

    while (!input_stream.endOfStream()) {
      result = this._decoder.handler(input_stream, input_stream.read());
      if (result === finished)
        break;
      if (result === null)
        continue;
      if (Array.isArray(result))
        code_points.push.apply(code_points, /**@type {!Array.<number>}*/(result));
      else
        code_points.push(result);
    }
    if (!this._streaming) {
      do {
        result = this._decoder.handler(input_stream, input_stream.read());
        if (result === finished)
          break;
        if (result === null)
          continue;
        if (Array.isArray(result))
          code_points.push.apply(code_points, /**@type {!Array.<number>}*/(result));
        else
          code_points.push(result);
      } while (!input_stream.endOfStream());
      this._decoder = null;
    }

    if (code_points.length) {
      // If encoding is one of utf-8, utf-16be, and utf-16le, and
      // ignore BOM flag and BOM seen flag are unset, run these
      // subsubsteps:
      if (['utf-8'].indexOf(this.encoding) !== -1 &&
          !this._ignoreBOM && !this._BOMseen) {
        // If token is U+FEFF, set BOM seen flag.
        if (code_points[0] === 0xFEFF) {
          this._BOMseen = true;
          code_points.shift();
        } else {
          // Otherwise, if token is not end-of-stream, set BOM seen
          // flag and append token to output.
          this._BOMseen = true;
        }
      }
    }

    return codePointsToString(code_points);
  }
};

// 7.2 Interface TextEncoder

/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */
function TextEncoder(encoding, options) {
  if (!(this instanceof TextEncoder))
    return new TextEncoder(encoding, options);
  encoding = encoding !== undefined ? String(encoding).toLowerCase() : DEFAULT_ENCODING;
  if (encoding !== DEFAULT_ENCODING) {
    throw new Error('Encoding not supported. Only utf-8 is supported');
  }
  options = ToDictionary(options);

  /** @private @type {boolean} */
  this._streaming = false;
  /** @private @type {?Encoder} */
  this._encoder = null;
  /** @private @type {{fatal: boolean}} */
  this._options = {fatal: Boolean(options['fatal'])};

  Object.defineProperty(this, 'encoding', {value: 'utf-8'});
}

TextEncoder.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function encode(opt_string, options) {
    opt_string = opt_string ? String(opt_string) : '';
    options = ToDictionary(options);

    // NOTE: This option is nonstandard. None of the encodings
    // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
    // so streaming is not necessary.
    if (!this._streaming)
      this._encoder = new UTF8Encoder(this._options);
    this._streaming = Boolean(options['stream']);

    var bytes = [];
    var input_stream = new Stream(stringToCodePoints(opt_string));
    /** @type {?(number|!Array.<number>)} */
    var result;
    while (!input_stream.endOfStream()) {
      result = this._encoder.handler(input_stream, input_stream.read());
      if (result === finished)
        break;
      if (Array.isArray(result))
        bytes.push.apply(bytes, /**@type {!Array.<number>}*/(result));
      else
        bytes.push(result);
    }
    if (!this._streaming) {
      while (true) {
        result = this._encoder.handler(input_stream, input_stream.read());
        if (result === finished)
          break;
        if (Array.isArray(result))
          bytes.push.apply(bytes, /**@type {!Array.<number>}*/(result));
        else
          bytes.push(result);
      }
      this._encoder = null;
    }
    return new Uint8Array(bytes);
  }
};

//
// 8. The encoding
//

// 8.1 utf-8

/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */
function UTF8Decoder(options) {
  var fatal = options.fatal;

  // utf-8's decoder's has an associated utf-8 code point, utf-8
  // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
  // lower boundary (initially 0x80), and a utf-8 upper boundary
  // (initially 0xBF).
  var /** @type {number} */ utf8_code_point = 0,
      /** @type {number} */ utf8_bytes_seen = 0,
      /** @type {number} */ utf8_bytes_needed = 0,
      /** @type {number} */ utf8_lower_boundary = 0x80,
      /** @type {number} */ utf8_upper_boundary = 0xBF;

  /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */
  this.handler = function(stream, bite) {
    // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
    // set utf-8 bytes needed to 0 and return error.
    if (bite === end_of_stream && utf8_bytes_needed !== 0) {
      utf8_bytes_needed = 0;
      return decoderError(fatal);
    }

    // 2. If byte is end-of-stream, return finished.
    if (bite === end_of_stream)
      return finished;

    // 3. If utf-8 bytes needed is 0, based on byte:
    if (utf8_bytes_needed === 0) {

      // 0x00 to 0x7F
      if (inRange(bite, 0x00, 0x7F)) {
        // Return a code point whose value is byte.
        return bite;
      }

      // 0xC2 to 0xDF
      if (inRange(bite, 0xC2, 0xDF)) {
        // Set utf-8 bytes needed to 1 and utf-8 code point to byte
        // − 0xC0.
        utf8_bytes_needed = 1;
        utf8_code_point = bite - 0xC0;
      }

      // 0xE0 to 0xEF
      else if (inRange(bite, 0xE0, 0xEF)) {
        // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
        if (bite === 0xE0)
          utf8_lower_boundary = 0xA0;
        // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
        if (bite === 0xED)
          utf8_upper_boundary = 0x9F;
        // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
        // byte − 0xE0.
        utf8_bytes_needed = 2;
        utf8_code_point = bite - 0xE0;
      }

      // 0xF0 to 0xF4
      else if (inRange(bite, 0xF0, 0xF4)) {
        // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
        if (bite === 0xF0)
          utf8_lower_boundary = 0x90;
        // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
        if (bite === 0xF4)
          utf8_upper_boundary = 0x8F;
        // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
        // byte − 0xF0.
        utf8_bytes_needed = 3;
        utf8_code_point = bite - 0xF0;
      }

      // Otherwise
      else {
        // Return error.
        return decoderError(fatal);
      }

      // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
      // point to utf-8 code point << (6 × utf-8 bytes needed) and
      // return continue.
      utf8_code_point = utf8_code_point << (6 * utf8_bytes_needed);
      return null;
    }

    // 4. If byte is not in the range utf-8 lower boundary to utf-8
    // upper boundary, run these substeps:
    if (!inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {

      // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
      // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
      // utf-8 upper boundary to 0xBF.
      utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
      utf8_lower_boundary = 0x80;
      utf8_upper_boundary = 0xBF;

      // 2. Prepend byte to stream.
      stream.prepend(bite);

      // 3. Return error.
      return decoderError(fatal);
    }

    // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
    // to 0xBF.
    utf8_lower_boundary = 0x80;
    utf8_upper_boundary = 0xBF;

    // 6. Increase utf-8 bytes seen by one and set utf-8 code point
    // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
    // needed − utf-8 bytes seen)).
    utf8_bytes_seen += 1;
    utf8_code_point += (bite - 0x80) << (6 * (utf8_bytes_needed - utf8_bytes_seen));

    // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
    // continue.
    if (utf8_bytes_seen !== utf8_bytes_needed)
      return null;

    // 8. Let code point be utf-8 code point.
    var code_point = utf8_code_point;

    // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
    // seen to 0.
    utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;

    // 10. Return a code point whose value is code point.
    return code_point;
  };
}

/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */
function UTF8Encoder(options) {
  var fatal = options.fatal;
  /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */
  this.handler = function(stream, code_point) {
    // 1. If code point is end-of-stream, return finished.
    if (code_point === end_of_stream)
      return finished;

    // 2. If code point is in the range U+0000 to U+007F, return a
    // byte whose value is code point.
    if (inRange(code_point, 0x0000, 0x007f))
      return code_point;

    // 3. Set count and offset based on the range code point is in:
    var count, offset;
    // U+0080 to U+07FF:    1 and 0xC0
    if (inRange(code_point, 0x0080, 0x07FF)) {
      count = 1;
      offset = 0xC0;
    }
    // U+0800 to U+FFFF:    2 and 0xE0
    else if (inRange(code_point, 0x0800, 0xFFFF)) {
      count = 2;
      offset = 0xE0;
    }
    // U+10000 to U+10FFFF: 3 and 0xF0
    else if (inRange(code_point, 0x10000, 0x10FFFF)) {
      count = 3;
      offset = 0xF0;
    }

    // 4.Let bytes be a byte sequence whose first byte is (code
    // point >> (6 × count)) + offset.
    var bytes = [(code_point >> (6 * count)) + offset];

    // 5. Run these substeps while count is greater than 0:
    while (count > 0) {

      // 1. Set temp to code point >> (6 × (count − 1)).
      var temp = code_point >> (6 * (count - 1));

      // 2. Append to bytes 0x80 | (temp & 0x3F).
      bytes.push(0x80 | (temp & 0x3F));

      // 3. Decrease count by one.
      count -= 1;
    }

    // 6. Return bytes bytes, in order.
    return bytes;
  };
}




/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var socketCloseCodes = _interopRequireWildcard(__webpack_require__(79));
var _Errors = _interopRequireDefault(__webpack_require__(8));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
let SocketError = function SocketError(code) {
  this.code = void 0;
  this.message = void 0;
  this.name = void 0;
  this.code = socketCloseCodes.codes.CLOSE_FALLBACK_CODE;
  if (Object.values(socketCloseCodes.codes).includes(code)) {
    this.code = code;
    switch (this.code) {
      case socketCloseCodes.codes.CLOSE_GOING_AWAY:
      case socketCloseCodes.codes.CLOSE_PROTOCOL_ERROR:
      case socketCloseCodes.codes.CLOSE_UNSUPPORTED:
      case socketCloseCodes.codes.CLOSE_NO_STATUS:
      case socketCloseCodes.codes.CLOSE_ABNORMAL:
      case socketCloseCodes.codes.CLOSE_INCONSISTENT_DATA:
      case socketCloseCodes.codes.CLOSE_POLICY_VIOLATION:
      case socketCloseCodes.codes.CLOSE_TOO_LARGE:
      case socketCloseCodes.codes.CLOSE_UNEXPECTED_CONDITION:
      case socketCloseCodes.codes.CLOSE_CONNECTIVITY_LOSS:
      case socketCloseCodes.codes.CLOSE_CONNECT_EXCEPTION:
      case socketCloseCodes.codes.CLOSE_TIMEOUT:
        this.name = _Errors.default.DISCONNECTED;
        this.message = 'Action failed due to session disconnection.';
        return;
      default:
        break;
    }
  }
  this.message = socketCloseCodes.messages[this.code] || 'No message available from code.';
};
exports.default = SocketError;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _ws = _interopRequireDefault(__webpack_require__(805));
var _default = (() => {
  if ((typeof window !== undefined ? window : global).WebSocket) {
    return (typeof window !== undefined ? window : global).WebSocket;
  }
  return _ws.default;
})();
exports.default = _default;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  throw new Error(
    'ws does not work in the browser. Browser clients must use the native ' +
      'WebSocket object'
  );
};


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _hasOpenTokSupport = _interopRequireDefault(__webpack_require__(53));
var _env = _interopRequireDefault(__webpack_require__(3));
const name = _env.default.name;
const hasOpenTokSupport = _hasOpenTokSupport.default.once;
var _default = () => hasOpenTokSupport() && ['Chrome', 'Firefox', 'Safari'].indexOf(name) > -1;
exports.default = _default;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = unboxFromRumorMessage;
var _deserializeMessage = _interopRequireDefault(__webpack_require__(808));
function unboxFromRumorMessage(rumorMessage) {
  const message = (0, _deserializeMessage.default)(rumorMessage.data);
  message.transactionId = rumorMessage.transactionId;
  message.fromAddress = rumorMessage.headers['X-TB-FROM-ADDRESS'];
  return message;
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = deserializeMessage;
// Deserialising a Raptor message mainly means doing a JSON.parse on it.
// We do decorate the final message with a few extra helper properies though.
//
// These include:
// * typeName: A human readable version of the Raptor type. E.g. STREAM instead of 102
// * actionName: A human readable version of the Raptor action. E.g. CREATE instead of 101
// * signature: typeName and actionName combined. This is mainly for debugging. E.g. A type
//    of 102 and an action of 101 would result in a signature of "STREAM:CREATE"
//
function deserializeMessage(msg) {
  if (msg.length === 0) {
    return {};
  }
  const message = JSON.parse(msg);
  const bits = message.uri.substr(1).split('/');

  // Remove the Raptor protocol version
  bits.shift();
  if (bits[bits.length - 1] === '') {
    bits.pop();
  }
  message.params = {};
  for (let i = 0, numBits = bits.length; i < numBits - 1; i += 2) {
    message.params[bits[i]] = bits[i + 1];
  }

  // extract the resource name. We special case 'channel' slightly, as
  // 'subscriber_channel' or 'stream_channel' is more useful for us
  // than 'channel' alone.
  if (bits.length % 2 === 0) {
    if (bits[bits.length - 2] === 'channel' && bits.length > 6) {
      message.resource = `${bits[bits.length - 4]}_${bits[bits.length - 2]}`;
    } else {
      message.resource = bits[bits.length - 2];
    }
  } else if (bits[bits.length - 1] === 'channel' && bits.length > 5) {
    message.resource = `${bits[bits.length - 3]}_${bits[bits.length - 1]}`;
  } else {
    message.resource = bits[bits.length - 1];
  }
  message.signature = `${message.resource}#${message.method}`;
  return message;
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = 'DTLS_SRTP';
exports.default = _default;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _hasOpenTokSupport = _interopRequireDefault(__webpack_require__(53));
const hasOpenTokSupport = _hasOpenTokSupport.default.once;

// Indicates if the browser supports RTCP Mux
//
// Broadly:
// * All recent versions of WebRTC (both Chrome and Firefox) support RtcpMux
var _default = () => hasOpenTokSupport();
exports.default = _default;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _env = _interopRequireDefault(__webpack_require__(3));
var _hasOpenTokSupport = _interopRequireDefault(__webpack_require__(53));
const hasOpenTokSupport = _hasOpenTokSupport.default.once;

// TODO Remove all transport stuff, that belongs to the messaging layer not the Media layer.
// Indicates if the browser supports bundle
//
// Broadly:
// * Firefox support bundle
// * Chrome support bundle
// * We assume NodeJs supports bundle (e.g. 'you're on your own' mode)
//
var _default = () => hasOpenTokSupport() && (_env.default.name === 'Chrome' || _env.default.name === 'Firefox' || _env.default.name === 'Node' || _env.default.name === 'Safari' || _env.default.name === 'Edge');
exports.default = _default;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = capabilitiesFromHash;
function capabilitiesFromHash(_ref) {
  let supportsWebRTC = _ref.supportsWebRTC;
  return {
    supportsWebRTC: supportsWebRTC === 'true' || supportsWebRTC === true
  };
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = SignalError;
function SignalError(code, message) {
  this.code = code;
  this.message = message;

  // Undocumented. Left in for backwards compatibility:
  this.reason = message;
}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable prefer-rest-params, no-cond-assign */

const DelayedEventQueue = function DelayedEventQueue(eventDispatcher) {
  const queue = [];
  this.enqueue = function enqueue( /* arg1, arg2, ..., argN */
  ) {
    queue.push(Array.prototype.slice.call(arguments));
  };
  this.triggerAll = function triggerAll() {
    let event;

    // Array.prototype.shift is actually pretty inefficient for longer Arrays,
    // this is because after the first element is removed it reshuffles every
    // remaining element up one (1). This involves way too many allocations and
    // deallocations as the queue size increases.
    //
    // A more efficient version could be written by keeping an index to the current
    // 'first' element in the Array and increasing that by one whenever an element
    // is removed. The elements that are infront of the index have been 'deleted'.
    // Periodically the front of the Array could be spliced off to reclaim the space.
    //
    // 1. http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.9
    //
    //
    // TLDR: Array.prototype.shift is O(n), where n is the array length,
    // instead of the expected O(1). You can implement your own shift that runs
    // in amortised constant time.
    //
    // @todo benchmark and see if we should actually care about shift's performance
    // for our common queue sizes.
    //
    while (event = queue.shift()) {
      eventDispatcher.trigger(...event);
    }
  };
};
var _default = DelayedEventQueue;
exports.default = _default;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _url = _interopRequireDefault(__webpack_require__(258));
var _axios = _interopRequireDefault(__webpack_require__(221));
var _promiseEndeavour = _interopRequireDefault(__webpack_require__(316));
var _get = _interopRequireDefault(__webpack_require__(59));
var _assign = _interopRequireDefault(__webpack_require__(9));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _SessionInfo = _interopRequireDefault(__webpack_require__(152));
var _mapErrorCodeToName = _interopRequireDefault(__webpack_require__(816));
var _mapStatusCodeToErrorCode = _interopRequireDefault(__webpack_require__(817));
const LANGUAGE = {
  EMPTY_RESPONSE: 'Response body was empty, probably due to connectivity loss',
  BADLY_FORMED: 'Unknown error: JSON response was badly formed',
  NO_ERROR: 'No error message',
  UNEXPECTED_SERVER_RESPONSE: details => `Unexpected server response (${details}). Try this operation again later.`
};
const RETRY_DELAYS = [0, 600, 1200];

/**
 * @typedef {Object} getSessionInfoConfig Configuration
 * @property {String} anvilUrl The base anvil url
 * @property {String} sessionId The id of the session to retrieve info for
 * @property {String} token The token used for authentication
 * @property {String} clientVersion The client version passed to Anvil
 * @property {String} connectionId The connection id passed to Anvil
 *
 * @typedef {Object} getSessionDependencies
 * @property {String=} axios
 */

/**
 * Factory for injecting dependencies into and returning a getSessionInfo function
 *
 * @param {getSessionDependencies} dependencies
 * @returns {getSessionInfo}
 */
function getSessionInfoFactory(_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$axios = _ref.axios,
    axios = _ref$axios === void 0 ? _axios.default : _ref$axios,
    _ref$retryDelays = _ref.retryDelays,
    retryDelays = _ref$retryDelays === void 0 ? RETRY_DELAYS : _ref$retryDelays;
  /**
   * getSessionInfo - Fetch session details from Anvil and return a SessionInfo object
   *
   * @function getSessionInfo
   * @param {getSessionInfoConfig} config
   * @returns {Promise<SessionInfo>} The session info
   */
  function getSessionInfo( /** @type getSessionInfoConfig */_ref2) {
    let anvilUrl = _ref2.anvilUrl,
      sessionId = _ref2.sessionId,
      token = _ref2.token,
      clientVersion = _ref2.clientVersion,
      connectionId = _ref2.connectionId;
    const parts = _url.default.parse(anvilUrl, true);
    const targetUrl = _url.default.format({
      protocol: parts.protocol,
      auth: parts.auth,
      host: parts.host,
      pathname: _url.default.resolve((parts.pathname || '').replace(/\/?$/, '/'), `session/${sessionId}`),
      query: Object.assign({}, parts.query, {
        extended: true
      })
    });
    return axios.get(targetUrl, {
      validateStatus: status => status >= 200 && status < 300,
      headers: {
        'X-OPENTOK-AUTH': token,
        'X-TB-VERSION': 1,
        'X-TB-CLIENT-VERSION': clientVersion,
        'X-TB-CONNECTIONID': connectionId,
        Accept: 'application/json'
      }
    })
    // general http connectivity and status errors from axios
    .catch(error => {
      if (error.response) {
        const newError = new Error(LANGUAGE.UNEXPECTED_SERVER_RESPONSE(`${error.response.statusCode}${error.response.status ? ` ${error.response.status}` : ''}`));
        newError.code = _exception_codes.default.ANVIL_INVALID_HTTP_STATUS;
        newError.name = (0, _mapErrorCodeToName.default)(newError.code);
        throw newError;
      } else if (error.request) {
        const newError = new Error(LANGUAGE.CONNECT_FAILED);
        newError.code = _exception_codes.default.ANVIL_CONNECT_FAILED;
        newError.name = (0, _mapErrorCodeToName.default)(newError.code);
        throw newError;
      } else {
        const code = _exception_codes.default.ANVIL_UNKNOWN_HTTP_ERROR;
        const name = (0, _mapErrorCodeToName.default)(error.code);
        (0, _assign.default)(error, {
          code,
          name
        });
        throw error;
      }
    }).then(_ref3 => {
      let data = _ref3.data;
      if (typeof data === 'string') {
        // axios could not decode JSON
        if (data.length > 0) {
          try {
            JSON.parse(data);
          } catch (err) {
            err.message = LANGUAGE.UNEXPECTED_SERVER_RESPONSE(err.toString());
            err.code = _exception_codes.default.ANVIL_XDOMAIN_OR_PARSING_ERROR;
            err.name = (0, _mapErrorCodeToName.default)(err.code);
            throw err;
          }
        }
        const error = new Error(data.length === 0 ? LANGUAGE.EMPTY_RESPONSE : LANGUAGE.BADLY_FORMED);
        error.code = data.length === 0 ? _exception_codes.default.ANVIL_EMPTY_RESPONSE_BODY : _exception_codes.default.ANVIL_BADLY_FORMED_RESPONSE;
        error.name = (0, _mapErrorCodeToName.default)(error.code);
        throw error;
      }
      if (data === null || data.length === 0) {
        // anvil returned empty session info
        const error = new Error(LANGUAGE.EMPTY_RESPONSE);
        error.code = _exception_codes.default.ANVIL_EMPTY_RESPONSE_BODY;
        error.name = (0, _mapErrorCodeToName.default)(error.code);
        throw error;
      }
      const _data$filter = data.filter(node => node.error != null),
        errorNode = _data$filter[0];
      if (errorNode) {
        const code = (0, _mapStatusCodeToErrorCode.default)((0, _get.default)(errorNode, 'error.code', '500'));
        if ((0, _get.default)(errorNode, 'error.errorMessage.message') === 'Invalid token format') {
          errorNode.error.errorMessage.message += ` Token: ${token}`;
        }
        const error = new Error((0, _get.default)(errorNode, 'error.errorMessage.message', code === undefined ? `Unknown error: ${errorNode.error.code}` : LANGUAGE.NO_ERROR));
        error.code = code || _exception_codes.default.ANVIL_UNEXPECTED_ERROR_CODE;
        error.name = (0, _mapErrorCodeToName.default)(error.code);
        throw error;
      }
      return new _SessionInfo.default(data[0]);
    });
  }
  const getSessionInfoRetry = (0, _promiseEndeavour.default)(getSessionInfo, (error, attempt) => error.code && error.code >= 3000 && error.code <= 3007 && retryDelays[attempt]);
  return getSessionInfoRetry;
}
var _default = getSessionInfoFactory;
exports.default = _default;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _Errors = _interopRequireDefault(__webpack_require__(8));
const errorMap = {
  [_exception_codes.default.ANVIL_BADLY_FORMED_RESPONSE]: _Errors.default.BADLY_FORMED_RESPONSE,
  [_exception_codes.default.ANVIL_INVALID_HTTP_STATUS]: _Errors.default.INVALID_HTTP_STATUS,
  [_exception_codes.default.ANVIL_XDOMAIN_OR_PARSING_ERROR]: _Errors.default.XDOMAIN_OR_PARSING_ERROR,
  [_exception_codes.default.ANVIL_UNKNOWN_HTTP_ERROR]: _Errors.default.UNKNOWN_HTTP_ERROR,
  [_exception_codes.default.ANVIL_UNEXPECTED_ERROR_CODE]: _Errors.default.UNEXPECTED_ERROR_CODE,
  [_exception_codes.default.ANVIL_EMPTY_RESPONSE_BODY]: _Errors.default.EMPTY_RESPONSE_BODY,
  [_exception_codes.default.ANVIL_CONNECT_FAILED]: _Errors.default.CONNECT_FAILED,
  [_exception_codes.default.AUTHENTICATION_ERROR]: _Errors.default.AUTHENTICATION_ERROR,
  [_exception_codes.default.INVALID_SESSION_ID]: _Errors.default.INVALID_SESSION_ID,
  [_exception_codes.default.TERMS_OF_SERVICE_FAILURE]: _Errors.default.TERMS_OF_SERVICE_FAILURE,
  [_exception_codes.default.UNEXPECTED_SERVER_RESPONSE]: _Errors.default.UNEXPECTED_SERVER_RESPONSE
};

/**
 * Maps an error from SessionInfo.get to its corresponding name
 * @param {number} code - Error code
 * @return {string|undefined} Error name
 */
function mapErrorCodeToName(code) {
  return errorMap[code];
}
var _default = mapErrorCodeToName;
exports.default = _default;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
const statusCodeToExceptionCode = {
  400: _exception_codes.default.INVALID_SESSION_ID,
  403: _exception_codes.default.AUTHENTICATION_ERROR,
  404: _exception_codes.default.INVALID_SESSION_ID,
  409: _exception_codes.default.TERMS_OF_SERVICE_FAILURE,
  500: _exception_codes.default.UNEXPECTED_SERVER_RESPONSE
};

/**
 * Maps an Anvil status code error to an exception code
 * @param {number} code - Anvil status code
 * @return {string|undefined} Exception code
 */
function mapStatusCodeToErrorCode(code) {
  return statusCodeToExceptionCode[code];
}
var _default = mapStatusCodeToErrorCode;
exports.default = _default;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _events = _interopRequireDefault(__webpack_require__(12));
var _generateKey = _interopRequireDefault(__webpack_require__(301));
let KeyStore = /*#__PURE__*/function (_EventEmitter) {
  (0, _inheritsLoose2.default)(KeyStore, _EventEmitter);
  function KeyStore(deps) {
    var _this;
    if (deps === void 0) {
      deps = {};
    }
    _this = _EventEmitter.call(this) || this;
    _this._generateKey = deps.generateKey || _generateKey.default;
    return _this;
  }
  var _proto = KeyStore.prototype;
  _proto.set = /*#__PURE__*/function () {
    var _set = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(sessionId, secret) {
      var key;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.keyPromise = this._generateKey(sessionId, secret);
            _context.next = 3;
            return this.keyPromise;
          case 3:
            key = _context.sent;
            this.emit('keyChanged', key);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function set(_x, _x2) {
      return _set.apply(this, arguments);
    }
    return set;
  }();
  _proto.get = /*#__PURE__*/function () {
    var _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var key;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.keyPromise;
          case 2:
            key = _context2.sent;
            return _context2.abrupt("return", key);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function get() {
      return _get.apply(this, arguments);
    }
    return get;
  }();
  _proto.clear = function clear() {
    this.keyPromise = undefined;
  };
  return KeyStore;
}(_events.default);
var _default = KeyStore;
exports.default = _default;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = SFrameClientStoreFactory;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _objectDestructuringEmpty2 = _interopRequireDefault(__webpack_require__(343));
var _extends2 = _interopRequireDefault(__webpack_require__(344));
var _standardSFrameClient = _interopRequireDefault(__webpack_require__(820));
function SFrameClientStoreFactory(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }
  let _ref2 = _ref,
    deps = (0, _extends2.default)({}, ((0, _objectDestructuringEmpty2.default)(_ref2), _ref2));
  let sframe;
  const createClient = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(senderId) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", sframe.create(senderId));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function createClient(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  const SFrameClientStore = function SFrameClientStore() {
    var _this = this;
    this._clientStore = {};
    sframe = deps.sframe || _standardSFrameClient.default;

    // Useful for unit tests
    this._initClientStore = clientStore => {
      this._clientStore = clientStore;
    };
    this.createSender = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(senderId) {
        var _this$_clientStore$se;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (senderId === void 0) {
                senderId = 0;
              }
              if (!_this.getSender(senderId)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", _this.getSender(senderId));
            case 3:
              if (!_this._clientStore[senderId]) {
                _this._clientStore[senderId] = {};
              }
              _context2.prev = 4;
              _context2.next = 7;
              return createClient(senderId);
            case 7:
              _this._clientStore[senderId].sender = _context2.sent;
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](4);
              (_this$_clientStore$se = _this._clientStore[senderId]) == null ? true : delete _this$_clientStore$se.sender;
            case 13:
              return _context2.abrupt("return", _this.getSender(senderId));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[4, 10]]);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();
    this.createReceiver = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(senderId) {
        var _this$_clientStore$se2;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.getReceiver(senderId)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", _this.getReceiver(senderId));
            case 2:
              if (!_this._clientStore[senderId]) {
                _this._clientStore[senderId] = {};
              }
              _context3.prev = 3;
              _context3.next = 6;
              return createClient(senderId);
            case 6:
              _this._clientStore[senderId].receiver = _context3.sent;
              _context3.next = 12;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](3);
              (_this$_clientStore$se2 = _this._clientStore[senderId]) == null ? true : delete _this$_clientStore$se2.receiver;
            case 12:
              return _context3.abrupt("return", _this.getReceiver(senderId));
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[3, 9]]);
      }));
      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }();
    this.getSender = senderId => {
      var _this$_clientStore$se3;
      return (_this$_clientStore$se3 = this._clientStore[senderId]) == null ? void 0 : _this$_clientStore$se3.sender;
    };
    this.getReceiver = senderId => {
      var _this$_clientStore$se4;
      return (_this$_clientStore$se4 = this._clientStore[senderId]) == null ? void 0 : _this$_clientStore$se4.receiver;
    };
    this.deleteReceiver = senderId => {
      var _this$_clientStore$se5;
      (_this$_clientStore$se5 = this._clientStore[senderId]) == null ? true : delete _this$_clientStore$se5.receiver;
    };
    this.deleteSender = senderId => {
      var _this$_clientStore$se6;
      (_this$_clientStore$se6 = this._clientStore[senderId]) == null ? true : delete _this$_clientStore$se6.sender;
    };
  };
  return SFrameClientStore;
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _jsSframe = __webpack_require__(821);
var _normalizeKey = _interopRequireDefault(__webpack_require__(823));
var _log = _interopRequireDefault(__webpack_require__(1));
const logger = (0, _log.default)('StandardSFrameClient');
const addDecryptEventsToClient = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(client) {
    var pendingDecryptionRestored, onError, onSuccess, onWarning;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return client.setEnableOnSuccess(true);
        case 2:
          pendingDecryptionRestored = false; // The SFrame client dispatches events error or success for every frame but we only want to surface
          // state changes e.g. authentication error -> success means we emit 'decryptionRestored'.
          // To achieve this we add a listener only for error at first, then when an authentication error event
          // is fired we surface the decryptFailed event and add the success event listener. When a success event
          // is fired we remove the success listener and surface the decryptionRestored event.
          // Other potential error or warning events are not surfaced but logged.
          onError = e => {
            if ((e == null ? void 0 : e.subtype) === 'FailedToAuthenticate' && !pendingDecryptionRestored) {
              pendingDecryptionRestored = true;
              client.addEventListener('success', onSuccess); // eslint-disable-line no-use-before-define
              client.dispatchEvent(new Event('decryptFailed'));
            } else if ((e == null ? void 0 : e.subtype) !== 'FailedToAuthenticate') {
              logger.error(`SFrameClient error: type ${e.subtype} message ${e.message}`);
            }
          };
          onSuccess = () => {
            client.removeEventListener('success', onSuccess);
            client.dispatchEvent(new Event('decryptionRestored'));
            pendingDecryptionRestored = false;
          };
          onWarning = e => {
            logger.warn(`SFrameClient warning: type ${e.subtype} message ${e.message}`);
          };
          client.addEventListener('error', onError);
          client.addEventListener('warning', onWarning);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function addDecryptEventsToClient(_x) {
    return _ref.apply(this, arguments);
  };
}();
const create = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(senderId, deps) {
    var SFrameClient, normalizeKey, client;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (deps === void 0) {
            deps = {};
          }
          SFrameClient = deps.SFrameClient || _jsSframe.Client;
          normalizeKey = deps.normalizeKey || _normalizeKey.default;
          _context4.next = 5;
          return SFrameClient.create(senderId);
        case 5:
          client = _context4.sent;
          // Cache original method, since we need to ensure it's compatible
          // with it's legacy SFrame counterpart
          client._setReceiverEncryptionKey = client.setReceiverEncryptionKey;
          client.setReceiverEncryptionKey = /*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_senderId, key) {
              var normalizedKey;
              return _regenerator.default.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return normalizeKey(key);
                  case 2:
                    normalizedKey = _context2.sent;
                    return _context2.abrupt("return", client._setReceiverEncryptionKey(_senderId, normalizedKey));
                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x4, _x5) {
              return _ref3.apply(this, arguments);
            };
          }();

          // Cache original method, since we need to ensure it's compatible
          // with it's legacy SFrame counterpart
          client._setSenderEncryptionKey = client.setSenderEncryptionKey;
          client.setSenderEncryptionKey = /*#__PURE__*/function () {
            var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(key) {
              var normalizedKey;
              return _regenerator.default.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return normalizeKey(key);
                  case 2:
                    normalizedKey = _context3.sent;
                    return _context3.abrupt("return", client._setSenderEncryptionKey(normalizedKey));
                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function (_x6) {
              return _ref4.apply(this, arguments);
            };
          }();
          addDecryptEventsToClient(client);
          return _context4.abrupt("return", client);
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function create(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
const StandardSFrameClient = {
  create
};
var _default = StandardSFrameClient;
exports.default = _default;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Promise, process, __dirname, Buffer) {
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_require__.p;

        let url = '';

        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }

        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }

        return url + relativeUrl;
      }
"use strict";var _interopRequireDefault=__webpack_require__(0);exports.__esModule=true;exports.VideoCodec=exports.EncryptionEngineEventType=exports.Codec=exports.Client=exports.AudioCodec=void 0;var _regenerator=_interopRequireDefault(__webpack_require__(4));var _wrapNativeSuper2=_interopRequireDefault(__webpack_require__(165));var _inheritsLoose2=_interopRequireDefault(__webpack_require__(23));var _createClass2=_interopRequireDefault(__webpack_require__(25));var _asyncToGenerator2=_interopRequireDefault(__webpack_require__(5));var _globalThis=function(Object){function get(){var _global=this||self;delete Object.prototype.__magic__;return _global;}if(typeof globalThis==="object"){return globalThis;}if(this){return get();}else{Object.defineProperty(Object.prototype,"__magic__",{configurable:true,get:get});var _global=__magic__;return _global;}}(Object);function _createForOfIteratorHelperLoose(o,allowArrayLike){var it=typeof Symbol!=="undefined"&&o[Symbol.iterator]||o["@@iterator"];if(it)return(it=it.call(o)).next.bind(it);if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2;}var Codec=/* @__PURE__ */(Codec2=>{Codec2[Codec2["VP8"]=0]="VP8";Codec2[Codec2["H264"]=1]="H264";Codec2[Codec2["OPUS"]=2]="OPUS";Codec2[Codec2["VP9"]=3]="VP9";Codec2[Codec2["H265"]=4]="H265";Codec2[Codec2["AV1"]=5]="AV1";return Codec2;})(Codec||{});exports.Codec=Codec;var VideoCodec=/* @__PURE__ */(VideoCodec2=>{VideoCodec2[VideoCodec2["VP8"]=0/* VP8 */]="VP8";VideoCodec2[VideoCodec2["H264"]=1/* H264 */]="H264";VideoCodec2[VideoCodec2["VP9"]=3/* VP9 */]="VP9";VideoCodec2[VideoCodec2["H265"]=4/* H265 */]="H265";VideoCodec2[VideoCodec2["AV1"]=5/* AV1 */]="AV1";return VideoCodec2;})(VideoCodec||{});exports.VideoCodec=VideoCodec;var AudioCodec=/* @__PURE__ */(AudioCodec2=>{AudioCodec2[AudioCodec2["OPUS"]=2/* OPUS */]="OPUS";return AudioCodec2;})(AudioCodec||{});exports.AudioCodec=AudioCodec;var EncryptionEngineEventType=/* @__PURE__ */(EncryptionEngineEventType2=>{EncryptionEngineEventType2["Error"]="Error";EncryptionEngineEventType2["UnsupportedCodec"]="UnsupportedCodec";EncryptionEngineEventType2["FailedToAuthenticate"]="FailedToAuthenticate";EncryptionEngineEventType2["SkippedDecrypting"]="SkippedDecrypting";EncryptionEngineEventType2["Success"]="Success";return EncryptionEngineEventType2;})(EncryptionEngineEventType||{});exports.EncryptionEngineEventType=EncryptionEngineEventType;function createGlobalThisVariable(name,defaultValue){if(!_globalThis.vonage){_globalThis.vonage={};}if(!_globalThis.vonage.workerizer){_globalThis.vonage.workerizer={};}let globals2=_globalThis.vonage.workerizer;if(!globals2[name]){globals2[name]=defaultValue;}return globals2[name];}const globals=createGlobalThisVariable("globals",{});var CommandType=/* @__PURE__ */(CommandType2=>{CommandType2["INIT"]="INIT";CommandType2["FORWARD"]="FORWARD";CommandType2["TERMINATE"]="TERMINATE";CommandType2["GLOBALS_SYNC"]="GLOBALS_SYNC";CommandType2["EVENT"]="EVENT";return CommandType2;})(CommandType||{});function isTransferable(arg){const transferableTypes=[ImageBitmap,ReadableStream,WritableStream];return transferableTypes.some(type=>arg instanceof type);}let nextCommandId=0;function postCommand$1(worker,type,functionName,args,resolvers){const id=nextCommandId++;worker.postMessage({id,type,functionName,args},args.filter(a=>isTransferable(a)));const promise=new Promise(resolve=>{resolvers==null?void 0:resolvers.set(id,resolve);});return promise;}function postCommand(command,result){const id=command.id,type=command.type;const resultAsArray=Array.isArray(result)?result:[result];postMessage({id,type,result},resultAsArray.filter(result2=>isTransferable(result2)));}const workerized=createGlobalThisVariable("workerized",{});function isWorker(){return typeof WorkerGlobalScope!=="undefined"&&self instanceof WorkerGlobalScope;}function globalsSync(){return _globalsSync.apply(this,arguments);}function _globalsSync(){_globalsSync=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee38(){var promises,i,_workerized$i$workerC,worker,resolvers;return _regenerator.default.wrap(function _callee38$(_context38){while(1)switch(_context38.prev=_context38.next){case 0:if(!isWorker()){_context38.next=4;break;}postCommand({type:CommandType.GLOBALS_SYNC},globals);_context38.next=8;break;case 4:promises=[];for(i in workerized){_workerized$i$workerC=workerized[i].workerContext,worker=_workerized$i$workerC.worker,resolvers=_workerized$i$workerC.resolvers;if(worker){promises.push(postCommand$1(worker,CommandType.GLOBALS_SYNC,"",[globals],resolvers));}}_context38.next=8;return Promise.all(promises);case 8:case"end":return _context38.stop();}},_callee38);}));return _globalsSync.apply(this,arguments);}function copy(from,to){if(Array.isArray(to)){to.splice(0,to.length);}else if(typeof to==="object"){for(const i in to){delete to[i];}}for(const i in from){if(Array.isArray(from[i])){to[i]=[];copy(from[i],to[i]);}else if(typeof from[i]==="object"){to[i]={};copy(from[i],to[i]);}else{to[i]=from[i];}}}function createWorker(_x,_x2,_x3,_x4){return _createWorker.apply(this,arguments);}function _createWorker(){_createWorker=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee40(workerizedClass,workerClass,resolvers,onEvent){var worker,initialized;return _regenerator.default.wrap(function _callee40$(_context40){while(1)switch(_context40.prev=_context40.next){case 0:worker=new workerClass();worker.addEventListener("message",/*#__PURE__*/function(){var _ref13=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee39(_ref12){var data,_a,_b,_c,_d,_e,_f,_g,result,event;return _regenerator.default.wrap(function _callee39$(_context39){while(1)switch(_context39.prev=_context39.next){case 0:data=_ref12.data;_context39.t0=data.type;_context39.next=_context39.t0===CommandType.GLOBALS_SYNC?4:_context39.t0===CommandType.EVENT?13:19;break;case 4:if(!data.id){_context39.next=9;break;}(_b=resolvers.get((_a=data.id)!=null?_a:-1))==null?void 0:_b(data.result);resolvers.delete((_c=data.id)!=null?_c:-1);_context39.next=12;break;case 9:copy((_d=data.result)!=null?_d:{},globals);_context39.next=12;return globalsSync();case 12:return _context39.abrupt("break",21);case 13:result=data.result;event=result;if(!((event==null?void 0:event.name)==void 0)){_context39.next=17;break;}throw"Missing event name";case 17:onEvent(event.name,event.data);return _context39.abrupt("break",21);case 19:(_f=resolvers.get((_e=data.id)!=null?_e:-1))==null?void 0:_f(data.result);resolvers.delete((_g=data.id)!=null?_g:-1);case 21:case"end":return _context39.stop();}},_callee39);}));return function(_x56){return _ref13.apply(this,arguments);};}());_context40.next=4;return postCommand$1(worker,CommandType.INIT,"",[workerizedClass.workerId,globals],resolvers);case 4:initialized=_context40.sent;if(initialized){_context40.next=7;break;}throw"Failed to instantiate workerized class";case 7:return _context40.abrupt("return",worker);case 8:case"end":return _context40.stop();}},_callee40);}));return _createWorker.apply(this,arguments);}const anyMap$1=/* @__PURE__ */new WeakMap();const eventsMap$1=/* @__PURE__ */new WeakMap();const producersMap$1=/* @__PURE__ */new WeakMap();const anyProducer$1=Symbol("anyProducer");const resolvedPromise$1=Promise.resolve();const listenerAdded$1=Symbol("listenerAdded");const listenerRemoved$1=Symbol("listenerRemoved");let canEmitMetaEvents$1=false;let isGlobalDebugEnabled$1=false;function assertEventName$1(eventName){if(typeof eventName!=="string"&&typeof eventName!=="symbol"&&typeof eventName!=="number"){throw new TypeError("`eventName` must be a string, symbol, or number");}}function assertListener$1(listener){if(typeof listener!=="function"){throw new TypeError("listener must be a function");}}function getListeners$1(instance,eventName){const events=eventsMap$1.get(instance);if(!events.has(eventName)){return;}return events.get(eventName);}function getEventProducers$1(instance,eventName){const key=typeof eventName==="string"||typeof eventName==="symbol"||typeof eventName==="number"?eventName:anyProducer$1;const producers=producersMap$1.get(instance);if(!producers.has(key)){return;}return producers.get(key);}function enqueueProducers$1(instance,eventName,eventData){const producers=producersMap$1.get(instance);if(producers.has(eventName)){for(var _iterator=_createForOfIteratorHelperLoose(producers.get(eventName)),_step;!(_step=_iterator()).done;){const producer=_step.value;producer.enqueue(eventData);}}if(producers.has(anyProducer$1)){const item=Promise.all([eventName,eventData]);for(var _iterator2=_createForOfIteratorHelperLoose(producers.get(anyProducer$1)),_step2;!(_step2=_iterator2()).done;){const producer=_step2.value;producer.enqueue(item);}}}function iterator$1(instance,eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];let isFinished=false;let flush=()=>{};let queue=[];const producer={enqueue(item){queue.push(item);flush();},finish(){isFinished=true;flush();}};for(var _iterator3=_createForOfIteratorHelperLoose(eventNames),_step3;!(_step3=_iterator3()).done;){const eventName=_step3.value;let set=getEventProducers$1(instance,eventName);if(!set){set=/* @__PURE__ */new Set();const producers=producersMap$1.get(instance);producers.set(eventName,set);}set.add(producer);}return{next(){var _this=this;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(){return _regenerator.default.wrap(function _callee$(_context){while(1)switch(_context.prev=_context.next){case 0:if(queue){_context.next=2;break;}return _context.abrupt("return",{done:true});case 2:if(!(queue.length===0)){_context.next=9;break;}if(!isFinished){_context.next=6;break;}queue=void 0;return _context.abrupt("return",_this.next());case 6:_context.next=8;return new Promise(resolve=>{flush=resolve;});case 8:return _context.abrupt("return",_this.next());case 9:_context.next=11;return queue.shift();case 11:_context.t0=_context.sent;return _context.abrupt("return",{done:false,value:_context.t0});case 13:case"end":return _context.stop();}},_callee);}))();},return(value){var _arguments=arguments;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(){var _iterator4,_step4,eventName,set,producers;return _regenerator.default.wrap(function _callee2$(_context2){while(1)switch(_context2.prev=_context2.next){case 0:queue=void 0;for(_iterator4=_createForOfIteratorHelperLoose(eventNames);!(_step4=_iterator4()).done;){eventName=_step4.value;set=getEventProducers$1(instance,eventName);if(set){set.delete(producer);if(set.size===0){producers=producersMap$1.get(instance);producers.delete(eventName);}}}flush();if(!(_arguments.length>0)){_context2.next=10;break;}_context2.next=6;return value;case 6:_context2.t1=_context2.sent;_context2.t0={done:true,value:_context2.t1};_context2.next=11;break;case 10:_context2.t0={done:true};case 11:return _context2.abrupt("return",_context2.t0);case 12:case"end":return _context2.stop();}},_callee2);}))();},[Symbol.asyncIterator](){return this;}};}function defaultMethodNamesOrAssert$1(methodNames){if(methodNames===void 0){return allEmitteryMethods$1;}if(!Array.isArray(methodNames)){throw new TypeError("`methodNames` must be an array of strings");}for(var _iterator5=_createForOfIteratorHelperLoose(methodNames),_step5;!(_step5=_iterator5()).done;){const methodName=_step5.value;if(!allEmitteryMethods$1.includes(methodName)){if(typeof methodName!=="string"){throw new TypeError("`methodNames` element must be a string");}throw new Error(`${methodName} is not Emittery method`);}}return methodNames;}const isMetaEvent$1=eventName=>eventName===listenerAdded$1||eventName===listenerRemoved$1;function emitMetaEvent$1(emitter,eventName,eventData){if(isMetaEvent$1(eventName)){try{canEmitMetaEvents$1=true;emitter.emit(eventName,eventData);}finally{canEmitMetaEvents$1=false;}}}let Emittery$1=/*#__PURE__*/function(){Emittery.mixin=function mixin(emitteryPropertyName,methodNames){methodNames=defaultMethodNamesOrAssert$1(methodNames);return target=>{if(typeof target!=="function"){throw new TypeError("`target` must be function");}for(var _iterator6=_createForOfIteratorHelperLoose(methodNames),_step6;!(_step6=_iterator6()).done;){const methodName=_step6.value;if(target.prototype[methodName]!==void 0){throw new Error(`The property \`${methodName}\` already exists on \`target\``);}}function getEmitteryProperty(){Object.defineProperty(this,emitteryPropertyName,{enumerable:false,value:new Emittery()});return this[emitteryPropertyName];}Object.defineProperty(target.prototype,emitteryPropertyName,{enumerable:false,get:getEmitteryProperty});const emitteryMethodCaller=methodName=>function(){return this[emitteryPropertyName][methodName](...arguments);};for(var _iterator7=_createForOfIteratorHelperLoose(methodNames),_step7;!(_step7=_iterator7()).done;){const methodName=_step7.value;Object.defineProperty(target.prototype,methodName,{enumerable:false,value:emitteryMethodCaller(methodName)});}return target;};};function Emittery(options){if(options===void 0){options={};}var _a;anyMap$1.set(this,/* @__PURE__ */new Set());eventsMap$1.set(this,/* @__PURE__ */new Map());producersMap$1.set(this,/* @__PURE__ */new Map());producersMap$1.get(this).set(anyProducer$1,/* @__PURE__ */new Set());this.debug=(_a=options.debug)!=null?_a:{};if(this.debug.enabled===void 0){this.debug.enabled=false;}if(!this.debug.logger){this.debug.logger=(type,debugName,eventName,eventData)=>{try{eventData=JSON.stringify(eventData);}catch(_unused){eventData=`Object with the following keys failed to stringify: ${Object.keys(eventData).join(",")}`;}if(typeof eventName==="symbol"||typeof eventName==="number"){eventName=eventName.toString();}const currentTime=/* @__PURE__ */new Date();const logTime=`${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);};}}var _proto=Emittery.prototype;_proto.logIfDebugEnabled=function logIfDebugEnabled(type,eventName,eventData){if(Emittery.isDebugEnabled||this.debug.enabled){this.debug.logger(type,this.debug.name,eventName,eventData);}};_proto.on=function on(eventNames,listener){assertListener$1(listener);eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator8=_createForOfIteratorHelperLoose(eventNames),_step8;!(_step8=_iterator8()).done;){const eventName=_step8.value;assertEventName$1(eventName);let set=getListeners$1(this,eventName);if(!set){set=/* @__PURE__ */new Set();const events=eventsMap$1.get(this);events.set(eventName,set);}set.add(listener);this.logIfDebugEnabled("subscribe",eventName,void 0);if(!isMetaEvent$1(eventName)){emitMetaEvent$1(this,listenerAdded$1,{eventName,listener});}}return this.off.bind(this,eventNames,listener);};_proto.off=function off(eventNames,listener){assertListener$1(listener);eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator9=_createForOfIteratorHelperLoose(eventNames),_step9;!(_step9=_iterator9()).done;){const eventName=_step9.value;assertEventName$1(eventName);const set=getListeners$1(this,eventName);if(set){set.delete(listener);if(set.size===0){const events=eventsMap$1.get(this);events.delete(eventName);}}this.logIfDebugEnabled("unsubscribe",eventName,void 0);if(!isMetaEvent$1(eventName)){emitMetaEvent$1(this,listenerRemoved$1,{eventName,listener});}}};_proto.once=function once(eventNames){let off_;const promise=new Promise(resolve=>{off_=this.on(eventNames,data=>{off_();resolve(data);});});promise.off=off_;return promise;};_proto.events=function events(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator10=_createForOfIteratorHelperLoose(eventNames),_step10;!(_step10=_iterator10()).done;){const eventName=_step10.value;assertEventName$1(eventName);}return iterator$1(this,eventNames);};_proto.emit=/*#__PURE__*/function(){var _emit=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5(eventName,eventData){var _a,listeners,anyListeners,staticListeners,staticAnyListeners;return _regenerator.default.wrap(function _callee5$(_context5){while(1)switch(_context5.prev=_context5.next){case 0:assertEventName$1(eventName);if(!(isMetaEvent$1(eventName)&&!canEmitMetaEvents$1)){_context5.next=3;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 3:this.logIfDebugEnabled("emit",eventName,eventData);enqueueProducers$1(this,eventName,eventData);listeners=(_a=getListeners$1(this,eventName))!=null?_a:/* @__PURE__ */new Set();anyListeners=anyMap$1.get(this);staticListeners=[...listeners];staticAnyListeners=isMetaEvent$1(eventName)?[]:[...anyListeners];_context5.next=11;return resolvedPromise$1;case 11:_context5.next=13;return Promise.all([...staticListeners.map(/*#__PURE__*/function(){var _ref=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(listener){return _regenerator.default.wrap(function _callee3$(_context3){while(1)switch(_context3.prev=_context3.next){case 0:if(!listeners.has(listener)){_context3.next=2;break;}return _context3.abrupt("return",listener(eventData));case 2:case"end":return _context3.stop();}},_callee3);}));return function(_x7){return _ref.apply(this,arguments);};}()),...staticAnyListeners.map(/*#__PURE__*/function(){var _ref2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(listener){return _regenerator.default.wrap(function _callee4$(_context4){while(1)switch(_context4.prev=_context4.next){case 0:if(!anyListeners.has(listener)){_context4.next=2;break;}return _context4.abrupt("return",listener(eventName,eventData));case 2:case"end":return _context4.stop();}},_callee4);}));return function(_x8){return _ref2.apply(this,arguments);};}())]);case 13:case"end":return _context5.stop();}},_callee5,this);}));function emit(_x5,_x6){return _emit.apply(this,arguments);}return emit;}();_proto.emitSerial=/*#__PURE__*/function(){var _emitSerial=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee6(eventName,eventData){var _a,listeners,anyListeners,staticListeners,staticAnyListeners,_i,_staticListeners,listener,_i2,_staticAnyListeners;return _regenerator.default.wrap(function _callee6$(_context6){while(1)switch(_context6.prev=_context6.next){case 0:assertEventName$1(eventName);if(!(isMetaEvent$1(eventName)&&!canEmitMetaEvents$1)){_context6.next=3;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 3:this.logIfDebugEnabled("emitSerial",eventName,eventData);listeners=(_a=getListeners$1(this,eventName))!=null?_a:/* @__PURE__ */new Set();anyListeners=anyMap$1.get(this);staticListeners=[...listeners];staticAnyListeners=[...anyListeners];_context6.next=10;return resolvedPromise$1;case 10:_i=0,_staticListeners=staticListeners;case 11:if(!(_i<_staticListeners.length)){_context6.next=19;break;}listener=_staticListeners[_i];if(!listeners.has(listener)){_context6.next=16;break;}_context6.next=16;return listener(eventData);case 16:_i++;_context6.next=11;break;case 19:_i2=0,_staticAnyListeners=staticAnyListeners;case 20:if(!(_i2<_staticAnyListeners.length)){_context6.next=28;break;}listener=_staticAnyListeners[_i2];if(!anyListeners.has(listener)){_context6.next=25;break;}_context6.next=25;return listener(eventName,eventData);case 25:_i2++;_context6.next=20;break;case 28:case"end":return _context6.stop();}},_callee6,this);}));function emitSerial(_x9,_x10){return _emitSerial.apply(this,arguments);}return emitSerial;}();_proto.onAny=function onAny(listener){assertListener$1(listener);this.logIfDebugEnabled("subscribeAny",void 0,void 0);anyMap$1.get(this).add(listener);emitMetaEvent$1(this,listenerAdded$1,{listener});return this.offAny.bind(this,listener);};_proto.anyEvent=function anyEvent(){return iterator$1(this);};_proto.offAny=function offAny(listener){assertListener$1(listener);this.logIfDebugEnabled("unsubscribeAny",void 0,void 0);emitMetaEvent$1(this,listenerRemoved$1,{listener});anyMap$1.get(this).delete(listener);};_proto.clearListeners=function clearListeners(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator11=_createForOfIteratorHelperLoose(eventNames),_step11;!(_step11=_iterator11()).done;){const eventName=_step11.value;this.logIfDebugEnabled("clear",eventName,void 0);if(typeof eventName==="string"||typeof eventName==="symbol"||typeof eventName==="number"){const set=getListeners$1(this,eventName);if(set){set.clear();}const producers=getEventProducers$1(this,eventName);if(producers){for(var _iterator12=_createForOfIteratorHelperLoose(producers),_step12;!(_step12=_iterator12()).done;){const producer=_step12.value;producer.finish();}producers.clear();}}else{anyMap$1.get(this).clear();for(var _iterator13=_createForOfIteratorHelperLoose(eventsMap$1.get(this).entries()),_step13;!(_step13=_iterator13()).done;){const _step13$value=_step13.value,eventName2=_step13$value[0],listeners=_step13$value[1];listeners.clear();eventsMap$1.get(this).delete(eventName2);}for(var _iterator14=_createForOfIteratorHelperLoose(producersMap$1.get(this).entries()),_step14;!(_step14=_iterator14()).done;){const _step14$value=_step14.value,eventName2=_step14$value[0],producers=_step14$value[1];for(var _iterator15=_createForOfIteratorHelperLoose(producers),_step15;!(_step15=_iterator15()).done;){const producer=_step15.value;producer.finish();}producers.clear();producersMap$1.get(this).delete(eventName2);}}}};_proto.listenerCount=function listenerCount(eventNames){var _a,_b,_c,_d,_e,_f;eventNames=Array.isArray(eventNames)?eventNames:[eventNames];let count=0;for(var _iterator16=_createForOfIteratorHelperLoose(eventNames),_step16;!(_step16=_iterator16()).done;){const eventName=_step16.value;if(typeof eventName==="string"){count+=anyMap$1.get(this).size+((_b=(_a=getListeners$1(this,eventName))==null?void 0:_a.size)!=null?_b:0)+((_d=(_c=getEventProducers$1(this,eventName))==null?void 0:_c.size)!=null?_d:0)+((_f=(_e=getEventProducers$1(this))==null?void 0:_e.size)!=null?_f:0);continue;}if(typeof eventName!=="undefined"){assertEventName$1(eventName);}count+=anyMap$1.get(this).size;for(var _iterator17=_createForOfIteratorHelperLoose(eventsMap$1.get(this).values()),_step17;!(_step17=_iterator17()).done;){const value=_step17.value;count+=value.size;}for(var _iterator18=_createForOfIteratorHelperLoose(producersMap$1.get(this).values()),_step18;!(_step18=_iterator18()).done;){const value=_step18.value;count+=value.size;}}return count;};_proto.bindMethods=function bindMethods(target,methodNames){if(typeof target!=="object"||target===null){throw new TypeError("`target` must be an object");}methodNames=defaultMethodNamesOrAssert$1(methodNames);for(var _iterator19=_createForOfIteratorHelperLoose(methodNames),_step19;!(_step19=_iterator19()).done;){const methodName=_step19.value;if(target[methodName]!==void 0){throw new Error(`The property \`${methodName}\` already exists on \`target\``);}Object.defineProperty(target,methodName,{enumerable:false,value:this[methodName].bind(this)});}};(0,_createClass2.default)(Emittery,null,[{key:"isDebugEnabled",get:function get(){var _a,_b;if(typeof((_a=_globalThis.process)==null?void 0:_a.env)!=="object"){return isGlobalDebugEnabled$1;}const _ref3=(_b=_globalThis.process)!=null?_b:{env:{}},env=_ref3.env;return env.DEBUG==="emittery"||env.DEBUG==="*"||isGlobalDebugEnabled$1;},set:function set(newValue){isGlobalDebugEnabled$1=newValue;}}]);return Emittery;}();const allEmitteryMethods$1=Object.getOwnPropertyNames(Emittery$1.prototype).filter(v=>v!=="constructor");Object.defineProperty(Emittery$1,"listenerAdded",{value:listenerAdded$1,writable:false,enumerable:true,configurable:false});Object.defineProperty(Emittery$1,"listenerRemoved",{value:listenerRemoved$1,writable:false,enumerable:true,configurable:false});function isInstanceOfEmittery(instance){return instance.onAny&&instance.emit;}function isChildClassOfEmittery(input){return input.prototype.onAny&&input.prototype.emit;}let nextId=0;function createWorkerized(_x11,_x12,_x13){return _createWorkerized.apply(this,arguments);}function _createWorkerized(){_createWorkerized=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee42(workerizedClass,worker,resolvers){var isEmittery,result,id;return _regenerator.default.wrap(function _callee42$(_context42){while(1)switch(_context42.prev=_context42.next){case 0:isEmittery=isChildClassOfEmittery(workerizedClass);result=isEmittery?new Emittery$1():{};id=nextId++;Object.getOwnPropertyNames(workerizedClass.prototype).forEach(functionName=>{result[functionName]=function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return postCommand$1(worker,CommandType.FORWARD,functionName,args,resolvers);};});result.terminate=/*#__PURE__*/(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee41(){var _len2,args,_key2,response,_args41=arguments;return _regenerator.default.wrap(function _callee41$(_context41){while(1)switch(_context41.prev=_context41.next){case 0:for(_len2=_args41.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=_args41[_key2];}_context41.next=3;return postCommand$1(worker,CommandType.TERMINATE,"",args,resolvers);case 3:response=_context41.sent;delete workerized[id];worker.terminate();result.workerContext.worker=void 0;return _context41.abrupt("return",response);case 8:case"end":return _context41.stop();}},_callee41);}));result.workerContext={id,worker,resolvers};workerized[id]=result;return _context42.abrupt("return",result);case 8:case"end":return _context42.stop();}},_callee42);}));return _createWorkerized.apply(this,arguments);}function workerize(_x14,_x15){return _workerize.apply(this,arguments);}function _workerize(){_workerize=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee43(workerizedClass,workerClass){var resolvers,workerized2,worker;return _regenerator.default.wrap(function _callee43$(_context43){while(1)switch(_context43.prev=_context43.next){case 0:resolvers=/* @__PURE__ */new Map();_context43.next=3;return createWorker(workerizedClass,workerClass,resolvers,(name,data)=>{if(workerized2==null?void 0:workerized2.emit){workerized2==null?void 0:workerized2.emit(name,data);}});case 3:worker=_context43.sent;_context43.next=6;return createWorkerized(workerizedClass,worker,resolvers);case 6:workerized2=_context43.sent;return _context43.abrupt("return",workerized2);case 8:case"end":return _context43.stop();}},_callee43);}));return _workerize.apply(this,arguments);}function handleCommandForward(_x16,_x17){return _handleCommandForward.apply(this,arguments);}function _handleCommandForward(){_handleCommandForward=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee44(command,context){var functionName,args;return _regenerator.default.wrap(function _callee44$(_context44){while(1)switch(_context44.prev=_context44.next){case 0:functionName=command.functionName,args=command.args;if(context.instance){_context44.next=3;break;}throw"instance not initialized";case 3:if(functionName){_context44.next=5;break;}throw"missing function name to call";case 5:if(context.instance[functionName]){_context44.next=7;break;}throw`undefined function [${functionName}] in class ${context.instance.constructor.workerId}`;case 7:_context44.t0=postCommand;_context44.t1=command;_context44.next=11;return context.instance[functionName](...(args!=null?args:[]));case 11:_context44.t2=_context44.sent;(0,_context44.t0)(_context44.t1,_context44.t2);case 13:case"end":return _context44.stop();}},_callee44);}));return _handleCommandForward.apply(this,arguments);}const registeredWorkers=createGlobalThisVariable("registeredWorkers",{});function registerWorker(id,registrable){registrable.workerId=id;if(isWorker()){registeredWorkers[registrable.workerId]=registrable;}}function handleCommandInit(command,context){if(!command.args){throw"Missing className while initializing worker";}const _command$args=command.args,className=_command$args[0],globalsValues=_command$args[1];const constructor=registeredWorkers[className];if(constructor){context.instance=new constructor(command.args.slice(1));}else{throw`unknown worker class ${className}`;}copy(globalsValues,globals);if(isInstanceOfEmittery(context.instance)){context.instance.onAny((name,data)=>{postCommand({type:CommandType.EVENT},{name,data});});}postCommand(command,typeof context.instance!==void 0);}function handleCommandTerminate(_x18,_x19){return _handleCommandTerminate.apply(this,arguments);}function _handleCommandTerminate(){_handleCommandTerminate=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee45(command,context){var args,result;return _regenerator.default.wrap(function _callee45$(_context45){while(1)switch(_context45.prev=_context45.next){case 0:args=command.args;if(context.instance){_context45.next=3;break;}throw"instance not initialized";case 3:if(!context.instance.terminate){_context45.next=7;break;}_context45.next=6;return context.instance.terminate(...(args!=null?args:[]));case 6:result=_context45.sent;case 7:postCommand(command,result);case 8:case"end":return _context45.stop();}},_callee45);}));return _handleCommandTerminate.apply(this,arguments);}function handleCommandGlobalsSync(command){if(!command.args){throw"Missing globals while syncing";}copy(command.args[0],globals);postCommand(command,{});}function initWorker(){const context={};onmessage=/*#__PURE__*/function(){var _ref4=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee7(event){var command;return _regenerator.default.wrap(function _callee7$(_context7){while(1)switch(_context7.prev=_context7.next){case 0:command=event.data;_context7.t0=command.type;_context7.next=_context7.t0===CommandType.INIT?4:_context7.t0===CommandType.FORWARD?6:_context7.t0===CommandType.TERMINATE?8:_context7.t0===CommandType.GLOBALS_SYNC?10:12;break;case 4:handleCommandInit(command,context);return _context7.abrupt("break",12);case 6:handleCommandForward(command,context);return _context7.abrupt("break",12);case 8:handleCommandTerminate(command,context);return _context7.abrupt("break",12);case 10:handleCommandGlobalsSync(command);return _context7.abrupt("break",12);case 12:case"end":return _context7.stop();}},_callee7);}));return function onmessage(_x20){return _ref4.apply(this,arguments);};}();}if(isWorker()){initWorker();}var Module=(()=>{var _scriptDir=({ url: getAbsoluteUrl('node_modules/@vonage/js-sframe/dist/js-sframe.es.js') }).url;return function(Module2){Module2=Module2||{};var Module2=typeof Module2!="undefined"?Module2:{};var readyPromiseResolve,readyPromiseReject;Module2["ready"]=new Promise(function(resolve,reject){readyPromiseResolve=resolve;readyPromiseReject=reject;});var moduleOverrides=Object.assign({},Module2);var quit_=(status,toThrow)=>{throw toThrow;};var ENVIRONMENT_IS_WEB=typeof window=="object";var ENVIRONMENT_IS_WORKER=typeof importScripts=="function";var ENVIRONMENT_IS_NODE=typeof process=="object"&&typeof process.versions=="object"&&typeof process.versions.node=="string";var scriptDirectory="";function locateFile(path){if(Module2["locateFile"]){return Module2["locateFile"](path,scriptDirectory);}return scriptDirectory+path;}var read_,readAsync,readBinary;function logExceptionOnExit(e){if(e instanceof ExitStatus)return;let toLog=e;err("exiting due to exception: "+toLog);}if(ENVIRONMENT_IS_NODE){if(ENVIRONMENT_IS_WORKER){scriptDirectory=__webpack_require__(361).dirname(scriptDirectory)+"/";}else{scriptDirectory=__dirname+"/";}var fs,nodePath;if(true){fs=__webpack_require__(822);nodePath=__webpack_require__(361);}read_=(filename,binary)=>{var ret=tryParseAsDataURI(filename);if(ret){return binary?ret:ret.toString();}filename=nodePath["normalize"](filename);return fs.readFileSync(filename,binary?void 0:"utf8");};readBinary=filename=>{var ret=read_(filename,true);if(!ret.buffer){ret=new Uint8Array(ret);}return ret;};readAsync=(filename,onload,onerror)=>{var ret=tryParseAsDataURI(filename);if(ret){onload(ret);}filename=nodePath["normalize"](filename);fs.readFile(filename,function(err2,data){if(err2)onerror(err2);else onload(data.buffer);});};if(process["argv"].length>1){process["argv"][1].replace(/\\/g,"/");}process["argv"].slice(2);process["on"]("uncaughtException",function(ex){if(!(ex instanceof ExitStatus)){throw ex;}});process["on"]("unhandledRejection",function(reason){throw reason;});quit_=(status,toThrow)=>{if(keepRuntimeAlive()){process["exitCode"]=status;throw toThrow;}logExceptionOnExit(toThrow);process["exit"](status);};Module2["inspect"]=function(){return"[Emscripten Module object]";};}else if(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER){if(ENVIRONMENT_IS_WORKER){scriptDirectory=self.location.href;}else if(typeof document!="undefined"&&document.currentScript){scriptDirectory=document.currentScript.src;}if(_scriptDir){scriptDirectory=_scriptDir;}if(scriptDirectory.indexOf("blob:")!==0){scriptDirectory=scriptDirectory.substr(0,scriptDirectory.replace(/[?#].*/,"").lastIndexOf("/")+1);}else{scriptDirectory="";}{read_=url=>{try{var xhr=new XMLHttpRequest();xhr.open("GET",url,false);xhr.send(null);return xhr.responseText;}catch(err2){var data=tryParseAsDataURI(url);if(data){return intArrayToString(data);}throw err2;}};if(ENVIRONMENT_IS_WORKER){readBinary=url=>{try{var xhr=new XMLHttpRequest();xhr.open("GET",url,false);xhr.responseType="arraybuffer";xhr.send(null);return new Uint8Array(xhr.response);}catch(err2){var data=tryParseAsDataURI(url);if(data){return data;}throw err2;}};}readAsync=(url,onload,onerror)=>{var xhr=new XMLHttpRequest();xhr.open("GET",url,true);xhr.responseType="arraybuffer";xhr.onload=()=>{if(xhr.status==200||xhr.status==0&&xhr.response){onload(xhr.response);return;}var data=tryParseAsDataURI(url);if(data){onload(data.buffer);return;}onerror();};xhr.onerror=onerror;xhr.send(null);};}}else;Module2["print"]||console.log.bind(console);var err=Module2["printErr"]||console.warn.bind(console);Object.assign(Module2,moduleOverrides);moduleOverrides=null;if(Module2["arguments"])Module2["arguments"];if(Module2["thisProgram"])Module2["thisProgram"];if(Module2["quit"])quit_=Module2["quit"];var wasmBinary;if(Module2["wasmBinary"])wasmBinary=Module2["wasmBinary"];var noExitRuntime=Module2["noExitRuntime"]||true;if(typeof WebAssembly!="object"){abort("no native wasm support detected");}var wasmMemory;var ABORT=false;var EXITSTATUS;function assert(condition,text){if(!condition){abort(text);}}var UTF8Decoder=typeof TextDecoder!="undefined"?new TextDecoder("utf8"):void 0;function UTF8ArrayToString(heapOrArray,idx,maxBytesToRead){var endIdx=idx+maxBytesToRead;var endPtr=idx;while(heapOrArray[endPtr]&&!(endPtr>=endIdx))++endPtr;if(endPtr-idx>16&&heapOrArray.buffer&&UTF8Decoder){return UTF8Decoder.decode(heapOrArray.subarray(idx,endPtr));}var str="";while(idx<endPtr){var u0=heapOrArray[idx++];if(!(u0&128)){str+=String.fromCharCode(u0);continue;}var u1=heapOrArray[idx++]&63;if((u0&224)==192){str+=String.fromCharCode((u0&31)<<6|u1);continue;}var u2=heapOrArray[idx++]&63;if((u0&240)==224){u0=(u0&15)<<12|u1<<6|u2;}else{u0=(u0&7)<<18|u1<<12|u2<<6|heapOrArray[idx++]&63;}if(u0<65536){str+=String.fromCharCode(u0);}else{var ch=u0-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023);}}return str;}function UTF8ToString(ptr,maxBytesToRead){return ptr?UTF8ArrayToString(HEAPU8,ptr,maxBytesToRead):"";}function stringToUTF8Array(str,heap,outIdx,maxBytesToWrite){if(!(maxBytesToWrite>0))return 0;var startIdx=outIdx;var endIdx=outIdx+maxBytesToWrite-1;for(var i=0;i<str.length;++i){var u=str.charCodeAt(i);if(u>=55296&&u<=57343){var u1=str.charCodeAt(++i);u=65536+((u&1023)<<10)|u1&1023;}if(u<=127){if(outIdx>=endIdx)break;heap[outIdx++]=u;}else if(u<=2047){if(outIdx+1>=endIdx)break;heap[outIdx++]=192|u>>6;heap[outIdx++]=128|u&63;}else if(u<=65535){if(outIdx+2>=endIdx)break;heap[outIdx++]=224|u>>12;heap[outIdx++]=128|u>>6&63;heap[outIdx++]=128|u&63;}else{if(outIdx+3>=endIdx)break;heap[outIdx++]=240|u>>18;heap[outIdx++]=128|u>>12&63;heap[outIdx++]=128|u>>6&63;heap[outIdx++]=128|u&63;}}heap[outIdx]=0;return outIdx-startIdx;}function stringToUTF8(str,outPtr,maxBytesToWrite){return stringToUTF8Array(str,HEAPU8,outPtr,maxBytesToWrite);}function lengthBytesUTF8(str){var len=0;for(var i=0;i<str.length;++i){var c=str.charCodeAt(i);if(c<=127){len++;}else if(c<=2047){len+=2;}else if(c>=55296&&c<=57343){len+=4;++i;}else{len+=3;}}return len;}var buffer,HEAP8,HEAPU8,HEAP16,HEAPU16,HEAP32,HEAPU32,HEAPF32,HEAP64,HEAPU64,HEAPF64;function updateGlobalBufferAndViews(buf){buffer=buf;Module2["HEAP8"]=HEAP8=new Int8Array(buf);Module2["HEAP16"]=HEAP16=new Int16Array(buf);Module2["HEAP32"]=HEAP32=new Int32Array(buf);Module2["HEAPU8"]=HEAPU8=new Uint8Array(buf);Module2["HEAPU16"]=HEAPU16=new Uint16Array(buf);Module2["HEAPU32"]=HEAPU32=new Uint32Array(buf);Module2["HEAPF32"]=HEAPF32=new Float32Array(buf);Module2["HEAPF64"]=HEAPF64=new Float64Array(buf);Module2["HEAP64"]=HEAP64=new BigInt64Array(buf);Module2["HEAPU64"]=HEAPU64=new BigUint64Array(buf);}Module2["INITIAL_MEMORY"]||16777216;var wasmTable;var __ATPRERUN__=[];var __ATINIT__=[];var __ATMAIN__=[];var __ATPOSTRUN__=[];function keepRuntimeAlive(){return noExitRuntime;}function preRun(){if(Module2["preRun"]){if(typeof Module2["preRun"]=="function")Module2["preRun"]=[Module2["preRun"]];while(Module2["preRun"].length){addOnPreRun(Module2["preRun"].shift());}}callRuntimeCallbacks(__ATPRERUN__);}function initRuntime(){callRuntimeCallbacks(__ATINIT__);}function preMain(){callRuntimeCallbacks(__ATMAIN__);}function postRun(){if(Module2["postRun"]){if(typeof Module2["postRun"]=="function")Module2["postRun"]=[Module2["postRun"]];while(Module2["postRun"].length){addOnPostRun(Module2["postRun"].shift());}}callRuntimeCallbacks(__ATPOSTRUN__);}function addOnPreRun(cb){__ATPRERUN__.unshift(cb);}function addOnInit(cb){__ATINIT__.unshift(cb);}function addOnPostRun(cb){__ATPOSTRUN__.unshift(cb);}var runDependencies=0;var dependenciesFulfilled=null;function addRunDependency(id){runDependencies++;if(Module2["monitorRunDependencies"]){Module2["monitorRunDependencies"](runDependencies);}}function removeRunDependency(id){runDependencies--;if(Module2["monitorRunDependencies"]){Module2["monitorRunDependencies"](runDependencies);}if(runDependencies==0){if(dependenciesFulfilled){var callback=dependenciesFulfilled;dependenciesFulfilled=null;callback();}}}function abort(what){{if(Module2["onAbort"]){Module2["onAbort"](what);}}what="Aborted("+what+")";err(what);ABORT=true;EXITSTATUS=1;what+=". Build with -sASSERTIONS for more info.";var e=new WebAssembly.RuntimeError(what);readyPromiseReject(e);throw e;}var dataURIPrefix="data:application/octet-stream;base64,";function isDataURI(filename){return filename.startsWith(dataURIPrefix);}function isFileURI(filename){return filename.startsWith("file://");}var wasmBinaryFile;wasmBinaryFile="data:application/octet-stream;base64,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";if(!isDataURI(wasmBinaryFile)){wasmBinaryFile=locateFile(wasmBinaryFile);}function getBinary(file){try{if(file==wasmBinaryFile&&wasmBinary){return new Uint8Array(wasmBinary);}var binary=tryParseAsDataURI(file);if(binary){return binary;}if(readBinary){return readBinary(file);}throw"both async and sync fetching of the wasm failed";}catch(err2){abort(err2);}}function getBinaryPromise(){if(!wasmBinary&&(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER)){if(typeof fetch=="function"&&!isFileURI(wasmBinaryFile)){return fetch(wasmBinaryFile,{credentials:"same-origin"}).then(function(response){if(!response["ok"]){throw"failed to load wasm binary file at '"+wasmBinaryFile+"'";}return response["arrayBuffer"]();}).catch(function(){return getBinary(wasmBinaryFile);});}else{if(readAsync){return new Promise(function(resolve,reject){readAsync(wasmBinaryFile,function(response){resolve(new Uint8Array(response));},reject);});}}}return Promise.resolve().then(function(){return getBinary(wasmBinaryFile);});}function createWasm(){var info={"a":asmLibraryArg};function receiveInstance(instance,module){var exports2=instance.exports;Module2["asm"]=exports2;wasmMemory=Module2["asm"]["v"];updateGlobalBufferAndViews(wasmMemory.buffer);wasmTable=Module2["asm"]["y"];addOnInit(Module2["asm"]["w"]);removeRunDependency();}addRunDependency();function receiveInstantiationResult(result){receiveInstance(result["instance"]);}function instantiateArrayBuffer(receiver){return getBinaryPromise().then(function(binary){return WebAssembly.instantiate(binary,info);}).then(function(instance){return instance;}).then(receiver,function(reason){err("failed to asynchronously prepare wasm: "+reason);abort(reason);});}function instantiateAsync(){if(!wasmBinary&&typeof WebAssembly.instantiateStreaming=="function"&&!isDataURI(wasmBinaryFile)&&!isFileURI(wasmBinaryFile)&&!ENVIRONMENT_IS_NODE&&typeof fetch=="function"){return fetch(wasmBinaryFile,{credentials:"same-origin"}).then(function(response){var result=WebAssembly.instantiateStreaming(response,info);return result.then(receiveInstantiationResult,function(reason){err("wasm streaming compile failed: "+reason);err("falling back to ArrayBuffer instantiation");return instantiateArrayBuffer(receiveInstantiationResult);});});}else{return instantiateArrayBuffer(receiveInstantiationResult);}}if(Module2["instantiateWasm"]){try{var exports=Module2["instantiateWasm"](info,receiveInstance);return exports;}catch(e){err("Module.instantiateWasm callback failed with error: "+e);readyPromiseReject(e);}}instantiateAsync().catch(readyPromiseReject);return{};}function ExitStatus(status){this.name="ExitStatus";this.message="Program terminated with exit("+status+")";this.status=status;}function callRuntimeCallbacks(callbacks){while(callbacks.length>0){callbacks.shift()(Module2);}}function handleException(e){if(e instanceof ExitStatus||e=="unwind"){return EXITSTATUS;}quit_(1,e);}function intArrayToString(array){var ret=[];for(var i=0;i<array.length;i++){var chr=array[i];if(chr>255){chr&=255;}ret.push(String.fromCharCode(chr));}return ret.join("");}function ___assert_fail(condition,filename,line,func){abort("Assertion failed: "+UTF8ToString(condition)+", at: "+[filename?UTF8ToString(filename):"unknown filename",line,func?UTF8ToString(func):"unknown function"]);}function embindRepr(v){if(v===null){return"null";}var t=typeof v;if(t==="object"||t==="array"||t==="function"){return v.toString();}else{return""+v;}}function embind_init_charCodes(){var codes=new Array(256);for(var i=0;i<256;++i){codes[i]=String.fromCharCode(i);}embind_charCodes=codes;}var embind_charCodes=void 0;function readLatin1String(ptr){var ret="";var c=ptr;while(HEAPU8[c]){ret+=embind_charCodes[HEAPU8[c++]];}return ret;}var awaitingDependencies={};var registeredTypes={};var typeDependencies={};var char_0=48;var char_9=57;function makeLegalFunctionName(name){if(void 0===name){return"_unknown";}name=name.replace(/[^a-zA-Z0-9_]/g,"$");var f=name.charCodeAt(0);if(f>=char_0&&f<=char_9){return"_"+name;}return name;}function createNamedFunction(name,body){name=makeLegalFunctionName(name);return function(){return body.apply(this,arguments);};}function extendError(baseErrorType,errorName){var errorClass=createNamedFunction(errorName,function(message){this.name=errorName;this.message=message;var stack=new Error(message).stack;if(stack!==void 0){this.stack=this.toString()+"\n"+stack.replace(/^Error(:[^\n]*)?\n/,"");}});errorClass.prototype=Object.create(baseErrorType.prototype);errorClass.prototype.constructor=errorClass;errorClass.prototype.toString=function(){if(this.message===void 0){return this.name;}else{return this.name+": "+this.message;}};return errorClass;}var BindingError=void 0;function throwBindingError(message){throw new BindingError(message);}var InternalError=void 0;function throwInternalError(message){throw new InternalError(message);}function whenDependentTypesAreResolved(myTypes,dependentTypes,getTypeConverters){myTypes.forEach(function(type){typeDependencies[type]=dependentTypes;});function onComplete(typeConverters2){var myTypeConverters=getTypeConverters(typeConverters2);if(myTypeConverters.length!==myTypes.length){throwInternalError("Mismatched type converter count");}for(var i=0;i<myTypes.length;++i){registerType(myTypes[i],myTypeConverters[i]);}}var typeConverters=new Array(dependentTypes.length);var unregisteredTypes=[];var registered=0;dependentTypes.forEach((dt,i)=>{if(registeredTypes.hasOwnProperty(dt)){typeConverters[i]=registeredTypes[dt];}else{unregisteredTypes.push(dt);if(!awaitingDependencies.hasOwnProperty(dt)){awaitingDependencies[dt]=[];}awaitingDependencies[dt].push(()=>{typeConverters[i]=registeredTypes[dt];++registered;if(registered===unregisteredTypes.length){onComplete(typeConverters);}});}});if(0===unregisteredTypes.length){onComplete(typeConverters);}}function registerType(rawType,registeredInstance,options){if(options===void 0){options={};}if(!("argPackAdvance"in registeredInstance)){throw new TypeError("registerType registeredInstance requires argPackAdvance");}var name=registeredInstance.name;if(!rawType){throwBindingError('type "'+name+'" must have a positive integer typeid pointer');}if(registeredTypes.hasOwnProperty(rawType)){if(options.ignoreDuplicateRegistrations){return;}else{throwBindingError("Cannot register type '"+name+"' twice");}}registeredTypes[rawType]=registeredInstance;delete typeDependencies[rawType];if(awaitingDependencies.hasOwnProperty(rawType)){var callbacks=awaitingDependencies[rawType];delete awaitingDependencies[rawType];callbacks.forEach(cb=>cb());}}function integerReadValueFromPointer(name,shift,signed){switch(shift){case 0:return signed?function readS8FromPointer(pointer){return HEAP8[pointer];}:function readU8FromPointer(pointer){return HEAPU8[pointer];};case 1:return signed?function readS16FromPointer(pointer){return HEAP16[pointer>>1];}:function readU16FromPointer(pointer){return HEAPU16[pointer>>1];};case 2:return signed?function readS32FromPointer(pointer){return HEAP32[pointer>>2];}:function readU32FromPointer(pointer){return HEAPU32[pointer>>2];};case 3:return signed?function readS64FromPointer(pointer){return HEAP64[pointer>>3];}:function readU64FromPointer(pointer){return HEAPU64[pointer>>3];};default:throw new TypeError("Unknown integer type: "+name);}}function __embind_register_bigint(primitiveType,name,size,minRange,maxRange){name=readLatin1String(name);var shift=getShiftFromSize(size);var isUnsignedType=name.indexOf("u")!=-1;if(isUnsignedType){maxRange=(1n<<64n)-1n;}registerType(primitiveType,{name,"fromWireType":function fromWireType(value){return value;},"toWireType":function toWireType(destructors,value){if(typeof value!="bigint"&&typeof value!="number"){throw new TypeError('Cannot convert "'+embindRepr(value)+'" to '+this.name);}if(value<minRange||value>maxRange){throw new TypeError('Passing a number "'+embindRepr(value)+'" from JS side to C/C++ side to an argument of type "'+name+'", which is outside the valid range ['+minRange+", "+maxRange+"]!");}return value;},"argPackAdvance":8,"readValueFromPointer":integerReadValueFromPointer(name,shift,!isUnsignedType),destructorFunction:null});}function getShiftFromSize(size){switch(size){case 1:return 0;case 2:return 1;case 4:return 2;case 8:return 3;default:throw new TypeError("Unknown type size: "+size);}}function __embind_register_bool(rawType,name,size,trueValue,falseValue){var shift=getShiftFromSize(size);name=readLatin1String(name);registerType(rawType,{name,"fromWireType":function fromWireType(wt){return!!wt;},"toWireType":function toWireType(destructors,o){return o?trueValue:falseValue;},"argPackAdvance":8,"readValueFromPointer":function readValueFromPointer(pointer){var heap;if(size===1){heap=HEAP8;}else if(size===2){heap=HEAP16;}else if(size===4){heap=HEAP32;}else{throw new TypeError("Unknown boolean type size: "+name);}return this["fromWireType"](heap[pointer>>shift]);},destructorFunction:null});}function ClassHandle_isAliasOf(other){if(!(this instanceof ClassHandle)){return false;}if(!(other instanceof ClassHandle)){return false;}var leftClass=this.$$.ptrType.registeredClass;var left=this.$$.ptr;var rightClass=other.$$.ptrType.registeredClass;var right=other.$$.ptr;while(leftClass.baseClass){left=leftClass.upcast(left);leftClass=leftClass.baseClass;}while(rightClass.baseClass){right=rightClass.upcast(right);rightClass=rightClass.baseClass;}return leftClass===rightClass&&left===right;}function shallowCopyInternalPointer(o){return{count:o.count,deleteScheduled:o.deleteScheduled,preservePointerOnDelete:o.preservePointerOnDelete,ptr:o.ptr,ptrType:o.ptrType,smartPtr:o.smartPtr,smartPtrType:o.smartPtrType};}function throwInstanceAlreadyDeleted(obj){function getInstanceTypeName(handle){return handle.$$.ptrType.registeredClass.name;}throwBindingError(getInstanceTypeName(obj)+" instance already deleted");}var finalizationRegistry=false;function detachFinalizer(handle){}function runDestructor($$){if($$.smartPtr){$$.smartPtrType.rawDestructor($$.smartPtr);}else{$$.ptrType.registeredClass.rawDestructor($$.ptr);}}function releaseClassHandle($$){$$.count.value-=1;var toDelete=0===$$.count.value;if(toDelete){runDestructor($$);}}function downcastPointer(ptr,ptrClass,desiredClass){if(ptrClass===desiredClass){return ptr;}if(void 0===desiredClass.baseClass){return null;}var rv=downcastPointer(ptr,ptrClass,desiredClass.baseClass);if(rv===null){return null;}return desiredClass.downcast(rv);}var registeredPointers={};function getInheritedInstanceCount(){return Object.keys(registeredInstances).length;}function getLiveInheritedInstances(){var rv=[];for(var k in registeredInstances){if(registeredInstances.hasOwnProperty(k)){rv.push(registeredInstances[k]);}}return rv;}var deletionQueue=[];function flushPendingDeletes(){while(deletionQueue.length){var obj=deletionQueue.pop();obj.$$.deleteScheduled=false;obj["delete"]();}}var delayFunction=void 0;function setDelayFunction(fn){delayFunction=fn;if(deletionQueue.length&&delayFunction){delayFunction(flushPendingDeletes);}}function init_embind(){Module2["getInheritedInstanceCount"]=getInheritedInstanceCount;Module2["getLiveInheritedInstances"]=getLiveInheritedInstances;Module2["flushPendingDeletes"]=flushPendingDeletes;Module2["setDelayFunction"]=setDelayFunction;}var registeredInstances={};function getBasestPointer(class_,ptr){if(ptr===void 0){throwBindingError("ptr should not be undefined");}while(class_.baseClass){ptr=class_.upcast(ptr);class_=class_.baseClass;}return ptr;}function getInheritedInstance(class_,ptr){ptr=getBasestPointer(class_,ptr);return registeredInstances[ptr];}function makeClassHandle(prototype,record){if(!record.ptrType||!record.ptr){throwInternalError("makeClassHandle requires ptr and ptrType");}var hasSmartPtrType=!!record.smartPtrType;var hasSmartPtr=!!record.smartPtr;if(hasSmartPtrType!==hasSmartPtr){throwInternalError("Both smartPtrType and smartPtr must be specified");}record.count={value:1};return attachFinalizer(Object.create(prototype,{$$:{value:record}}));}function RegisteredPointer_fromWireType(ptr){var rawPointer=this.getPointee(ptr);if(!rawPointer){this.destructor(ptr);return null;}var registeredInstance=getInheritedInstance(this.registeredClass,rawPointer);if(void 0!==registeredInstance){if(0===registeredInstance.$$.count.value){registeredInstance.$$.ptr=rawPointer;registeredInstance.$$.smartPtr=ptr;return registeredInstance["clone"]();}else{var rv=registeredInstance["clone"]();this.destructor(ptr);return rv;}}function makeDefaultHandle(){if(this.isSmartPointer){return makeClassHandle(this.registeredClass.instancePrototype,{ptrType:this.pointeeType,ptr:rawPointer,smartPtrType:this,smartPtr:ptr});}else{return makeClassHandle(this.registeredClass.instancePrototype,{ptrType:this,ptr});}}var actualType=this.registeredClass.getActualType(rawPointer);var registeredPointerRecord=registeredPointers[actualType];if(!registeredPointerRecord){return makeDefaultHandle.call(this);}var toType;if(this.isConst){toType=registeredPointerRecord.constPointerType;}else{toType=registeredPointerRecord.pointerType;}var dp=downcastPointer(rawPointer,this.registeredClass,toType.registeredClass);if(dp===null){return makeDefaultHandle.call(this);}if(this.isSmartPointer){return makeClassHandle(toType.registeredClass.instancePrototype,{ptrType:toType,ptr:dp,smartPtrType:this,smartPtr:ptr});}else{return makeClassHandle(toType.registeredClass.instancePrototype,{ptrType:toType,ptr:dp});}}function attachFinalizer(handle){if("undefined"===typeof FinalizationRegistry){attachFinalizer=handle2=>handle2;return handle;}finalizationRegistry=new FinalizationRegistry(info=>{releaseClassHandle(info.$$);});attachFinalizer=handle2=>{var $$=handle2.$$;var hasSmartPtr=!!$$.smartPtr;if(hasSmartPtr){var info={$$};finalizationRegistry.register(handle2,info,handle2);}return handle2;};detachFinalizer=handle2=>finalizationRegistry.unregister(handle2);return attachFinalizer(handle);}function ClassHandle_clone(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.preservePointerOnDelete){this.$$.count.value+=1;return this;}else{var clone=attachFinalizer(Object.create(Object.getPrototypeOf(this),{$$:{value:shallowCopyInternalPointer(this.$$)}}));clone.$$.count.value+=1;clone.$$.deleteScheduled=false;return clone;}}function ClassHandle_delete(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete){throwBindingError("Object already scheduled for deletion");}detachFinalizer(this);releaseClassHandle(this.$$);if(!this.$$.preservePointerOnDelete){this.$$.smartPtr=void 0;this.$$.ptr=void 0;}}function ClassHandle_isDeleted(){return!this.$$.ptr;}function ClassHandle_deleteLater(){if(!this.$$.ptr){throwInstanceAlreadyDeleted(this);}if(this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete){throwBindingError("Object already scheduled for deletion");}deletionQueue.push(this);if(deletionQueue.length===1&&delayFunction){delayFunction(flushPendingDeletes);}this.$$.deleteScheduled=true;return this;}function init_ClassHandle(){ClassHandle.prototype["isAliasOf"]=ClassHandle_isAliasOf;ClassHandle.prototype["clone"]=ClassHandle_clone;ClassHandle.prototype["delete"]=ClassHandle_delete;ClassHandle.prototype["isDeleted"]=ClassHandle_isDeleted;ClassHandle.prototype["deleteLater"]=ClassHandle_deleteLater;}function ClassHandle(){}function ensureOverloadTable(proto,methodName,humanName){if(void 0===proto[methodName].overloadTable){var prevFunc=proto[methodName];proto[methodName]=function(){if(!proto[methodName].overloadTable.hasOwnProperty(arguments.length)){throwBindingError("Function '"+humanName+"' called with an invalid number of arguments ("+arguments.length+") - expects one of ("+proto[methodName].overloadTable+")!");}return proto[methodName].overloadTable[arguments.length].apply(this,arguments);};proto[methodName].overloadTable=[];proto[methodName].overloadTable[prevFunc.argCount]=prevFunc;}}function exposePublicSymbol(name,value,numArguments){if(Module2.hasOwnProperty(name)){if(void 0===numArguments||void 0!==Module2[name].overloadTable&&void 0!==Module2[name].overloadTable[numArguments]){throwBindingError("Cannot register public name '"+name+"' twice");}ensureOverloadTable(Module2,name,name);if(Module2.hasOwnProperty(numArguments)){throwBindingError("Cannot register multiple overloads of a function with the same number of arguments ("+numArguments+")!");}Module2[name].overloadTable[numArguments]=value;}else{Module2[name]=value;if(void 0!==numArguments){Module2[name].numArguments=numArguments;}}}function RegisteredClass(name,constructor,instancePrototype,rawDestructor,baseClass,getActualType,upcast,downcast){this.name=name;this.constructor=constructor;this.instancePrototype=instancePrototype;this.rawDestructor=rawDestructor;this.baseClass=baseClass;this.getActualType=getActualType;this.upcast=upcast;this.downcast=downcast;this.pureVirtualFunctions=[];}function upcastPointer(ptr,ptrClass,desiredClass){while(ptrClass!==desiredClass){if(!ptrClass.upcast){throwBindingError("Expected null or instance of "+desiredClass.name+", got an instance of "+ptrClass.name);}ptr=ptrClass.upcast(ptr);ptrClass=ptrClass.baseClass;}return ptr;}function constNoSmartPtrRawPointerToWireType(destructors,handle){if(handle===null){if(this.isReference){throwBindingError("null is not a valid "+this.name);}return 0;}if(!handle.$$){throwBindingError('Cannot pass "'+embindRepr(handle)+'" as a '+this.name);}if(!handle.$$.ptr){throwBindingError("Cannot pass deleted object as a pointer of type "+this.name);}var handleClass=handle.$$.ptrType.registeredClass;var ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);return ptr;}function genericPointerToWireType(destructors,handle){var ptr;if(handle===null){if(this.isReference){throwBindingError("null is not a valid "+this.name);}if(this.isSmartPointer){ptr=this.rawConstructor();if(destructors!==null){destructors.push(this.rawDestructor,ptr);}return ptr;}else{return 0;}}if(!handle.$$){throwBindingError('Cannot pass "'+embindRepr(handle)+'" as a '+this.name);}if(!handle.$$.ptr){throwBindingError("Cannot pass deleted object as a pointer of type "+this.name);}if(!this.isConst&&handle.$$.ptrType.isConst){throwBindingError("Cannot convert argument of type "+(handle.$$.smartPtrType?handle.$$.smartPtrType.name:handle.$$.ptrType.name)+" to parameter type "+this.name);}var handleClass=handle.$$.ptrType.registeredClass;ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);if(this.isSmartPointer){if(void 0===handle.$$.smartPtr){throwBindingError("Passing raw pointer to smart pointer is illegal");}switch(this.sharingPolicy){case 0:if(handle.$$.smartPtrType===this){ptr=handle.$$.smartPtr;}else{throwBindingError("Cannot convert argument of type "+(handle.$$.smartPtrType?handle.$$.smartPtrType.name:handle.$$.ptrType.name)+" to parameter type "+this.name);}break;case 1:ptr=handle.$$.smartPtr;break;case 2:if(handle.$$.smartPtrType===this){ptr=handle.$$.smartPtr;}else{var clonedHandle=handle["clone"]();ptr=this.rawShare(ptr,Emval.toHandle(function(){clonedHandle["delete"]();}));if(destructors!==null){destructors.push(this.rawDestructor,ptr);}}break;default:throwBindingError("Unsupporting sharing policy");}}return ptr;}function nonConstNoSmartPtrRawPointerToWireType(destructors,handle){if(handle===null){if(this.isReference){throwBindingError("null is not a valid "+this.name);}return 0;}if(!handle.$$){throwBindingError('Cannot pass "'+embindRepr(handle)+'" as a '+this.name);}if(!handle.$$.ptr){throwBindingError("Cannot pass deleted object as a pointer of type "+this.name);}if(handle.$$.ptrType.isConst){throwBindingError("Cannot convert argument of type "+handle.$$.ptrType.name+" to parameter type "+this.name);}var handleClass=handle.$$.ptrType.registeredClass;var ptr=upcastPointer(handle.$$.ptr,handleClass,this.registeredClass);return ptr;}function simpleReadValueFromPointer(pointer){return this["fromWireType"](HEAP32[pointer>>2]);}function RegisteredPointer_getPointee(ptr){if(this.rawGetPointee){ptr=this.rawGetPointee(ptr);}return ptr;}function RegisteredPointer_destructor(ptr){if(this.rawDestructor){this.rawDestructor(ptr);}}function RegisteredPointer_deleteObject(handle){if(handle!==null){handle["delete"]();}}function init_RegisteredPointer(){RegisteredPointer.prototype.getPointee=RegisteredPointer_getPointee;RegisteredPointer.prototype.destructor=RegisteredPointer_destructor;RegisteredPointer.prototype["argPackAdvance"]=8;RegisteredPointer.prototype["readValueFromPointer"]=simpleReadValueFromPointer;RegisteredPointer.prototype["deleteObject"]=RegisteredPointer_deleteObject;RegisteredPointer.prototype["fromWireType"]=RegisteredPointer_fromWireType;}function RegisteredPointer(name,registeredClass,isReference,isConst,isSmartPointer,pointeeType,sharingPolicy,rawGetPointee,rawConstructor,rawShare,rawDestructor){this.name=name;this.registeredClass=registeredClass;this.isReference=isReference;this.isConst=isConst;this.isSmartPointer=isSmartPointer;this.pointeeType=pointeeType;this.sharingPolicy=sharingPolicy;this.rawGetPointee=rawGetPointee;this.rawConstructor=rawConstructor;this.rawShare=rawShare;this.rawDestructor=rawDestructor;if(!isSmartPointer&&registeredClass.baseClass===void 0){if(isConst){this["toWireType"]=constNoSmartPtrRawPointerToWireType;this.destructorFunction=null;}else{this["toWireType"]=nonConstNoSmartPtrRawPointerToWireType;this.destructorFunction=null;}}else{this["toWireType"]=genericPointerToWireType;}}function replacePublicSymbol(name,value,numArguments){if(!Module2.hasOwnProperty(name)){throwInternalError("Replacing nonexistant public symbol");}if(void 0!==Module2[name].overloadTable&&void 0!==numArguments){Module2[name].overloadTable[numArguments]=value;}else{Module2[name]=value;Module2[name].argCount=numArguments;}}var wasmTableMirror=[];function getWasmTableEntry(funcPtr){var func=wasmTableMirror[funcPtr];if(!func){if(funcPtr>=wasmTableMirror.length)wasmTableMirror.length=funcPtr+1;wasmTableMirror[funcPtr]=func=wasmTable.get(funcPtr);}return func;}function embind__requireFunction(signature,rawFunction){signature=readLatin1String(signature);function makeDynCaller(){return getWasmTableEntry(rawFunction);}var fp=makeDynCaller();if(typeof fp!="function"){throwBindingError("unknown function pointer with signature "+signature+": "+rawFunction);}return fp;}var UnboundTypeError=void 0;function getTypeName(type){var ptr=___getTypeName(type);var rv=readLatin1String(ptr);_free(ptr);return rv;}function throwUnboundTypeError(message,types){var unboundTypes=[];var seen={};function visit(type){if(seen[type]){return;}if(registeredTypes[type]){return;}if(typeDependencies[type]){typeDependencies[type].forEach(visit);return;}unboundTypes.push(type);seen[type]=true;}types.forEach(visit);throw new UnboundTypeError(message+": "+unboundTypes.map(getTypeName).join([", "]));}function __embind_register_class(rawType,rawPointerType,rawConstPointerType,baseClassRawType,getActualTypeSignature,getActualType,upcastSignature,upcast,downcastSignature,downcast,name,destructorSignature,rawDestructor){name=readLatin1String(name);getActualType=embind__requireFunction(getActualTypeSignature,getActualType);if(upcast){upcast=embind__requireFunction(upcastSignature,upcast);}if(downcast){downcast=embind__requireFunction(downcastSignature,downcast);}rawDestructor=embind__requireFunction(destructorSignature,rawDestructor);var legalFunctionName=makeLegalFunctionName(name);exposePublicSymbol(legalFunctionName,function(){throwUnboundTypeError("Cannot construct "+name+" due to unbound types",[baseClassRawType]);});whenDependentTypesAreResolved([rawType,rawPointerType,rawConstPointerType],baseClassRawType?[baseClassRawType]:[],function(base){base=base[0];var baseClass;var basePrototype;if(baseClassRawType){baseClass=base.registeredClass;basePrototype=baseClass.instancePrototype;}else{basePrototype=ClassHandle.prototype;}var constructor=createNamedFunction(legalFunctionName,function(){if(Object.getPrototypeOf(this)!==instancePrototype){throw new BindingError("Use 'new' to construct "+name);}if(void 0===registeredClass.constructor_body){throw new BindingError(name+" has no accessible constructor");}var body=registeredClass.constructor_body[arguments.length];if(void 0===body){throw new BindingError("Tried to invoke ctor of "+name+" with invalid number of parameters ("+arguments.length+") - expected ("+Object.keys(registeredClass.constructor_body).toString()+") parameters instead!");}return body.apply(this,arguments);});var instancePrototype=Object.create(basePrototype,{constructor:{value:constructor}});constructor.prototype=instancePrototype;var registeredClass=new RegisteredClass(name,constructor,instancePrototype,rawDestructor,baseClass,getActualType,upcast,downcast);var referenceConverter=new RegisteredPointer(name,registeredClass,true,false,false);var pointerConverter=new RegisteredPointer(name+"*",registeredClass,false,false,false);var constPointerConverter=new RegisteredPointer(name+" const*",registeredClass,false,true,false);registeredPointers[rawType]={pointerType:pointerConverter,constPointerType:constPointerConverter};replacePublicSymbol(legalFunctionName,constructor);return[referenceConverter,pointerConverter,constPointerConverter];});}function heap32VectorToArray(count,firstElement){var array=[];for(var i=0;i<count;i++){array.push(HEAPU32[firstElement+i*4>>2]);}return array;}function runDestructors(destructors){while(destructors.length){var ptr=destructors.pop();var del=destructors.pop();del(ptr);}}function craftInvokerFunction(humanName,argTypes,classType,cppInvokerFunc,cppTargetFunc){var argCount=argTypes.length;if(argCount<2){throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");}var isClassMethodFunc=argTypes[1]!==null&&classType!==null;var needsDestructorStack=false;for(var i=1;i<argTypes.length;++i){if(argTypes[i]!==null&&argTypes[i].destructorFunction===void 0){needsDestructorStack=true;break;}}var returns=argTypes[0].name!=="void";var expectedArgCount=argCount-2;var argsWired=new Array(expectedArgCount);var invokerFuncArgs=[];var destructors=[];return function(){if(arguments.length!==expectedArgCount){throwBindingError("function "+humanName+" called with "+arguments.length+" arguments, expected "+expectedArgCount+" args!");}destructors.length=0;var thisWired;invokerFuncArgs.length=isClassMethodFunc?2:1;invokerFuncArgs[0]=cppTargetFunc;if(isClassMethodFunc){thisWired=argTypes[1]["toWireType"](destructors,this);invokerFuncArgs[1]=thisWired;}for(var i2=0;i2<expectedArgCount;++i2){argsWired[i2]=argTypes[i2+2]["toWireType"](destructors,arguments[i2]);invokerFuncArgs.push(argsWired[i2]);}var rv=cppInvokerFunc.apply(null,invokerFuncArgs);function onDone(rv2){if(needsDestructorStack){runDestructors(destructors);}else{for(var i3=isClassMethodFunc?1:2;i3<argTypes.length;i3++){var param=i3===1?thisWired:argsWired[i3-2];if(argTypes[i3].destructorFunction!==null){argTypes[i3].destructorFunction(param);}}}if(returns){return argTypes[0]["fromWireType"](rv2);}}return onDone(rv);};}function __embind_register_class_constructor(rawClassType,argCount,rawArgTypesAddr,invokerSignature,invoker,rawConstructor){assert(argCount>0);var rawArgTypes=heap32VectorToArray(argCount,rawArgTypesAddr);invoker=embind__requireFunction(invokerSignature,invoker);whenDependentTypesAreResolved([],[rawClassType],function(classType){classType=classType[0];var humanName="constructor "+classType.name;if(void 0===classType.registeredClass.constructor_body){classType.registeredClass.constructor_body=[];}if(void 0!==classType.registeredClass.constructor_body[argCount-1]){throw new BindingError("Cannot register multiple constructors with identical number of parameters ("+(argCount-1)+") for class '"+classType.name+"'! Overload resolution is currently only performed using the parameter count, not actual type info!");}classType.registeredClass.constructor_body[argCount-1]=()=>{throwUnboundTypeError("Cannot construct "+classType.name+" due to unbound types",rawArgTypes);};whenDependentTypesAreResolved([],rawArgTypes,function(argTypes){argTypes.splice(1,0,null);classType.registeredClass.constructor_body[argCount-1]=craftInvokerFunction(humanName,argTypes,null,invoker,rawConstructor);return[];});return[];});}function __embind_register_class_function(rawClassType,methodName,argCount,rawArgTypesAddr,invokerSignature,rawInvoker,context,isPureVirtual){var rawArgTypes=heap32VectorToArray(argCount,rawArgTypesAddr);methodName=readLatin1String(methodName);rawInvoker=embind__requireFunction(invokerSignature,rawInvoker);whenDependentTypesAreResolved([],[rawClassType],function(classType){classType=classType[0];var humanName=classType.name+"."+methodName;if(methodName.startsWith("@@")){methodName=Symbol[methodName.substring(2)];}if(isPureVirtual){classType.registeredClass.pureVirtualFunctions.push(methodName);}function unboundTypesHandler(){throwUnboundTypeError("Cannot call "+humanName+" due to unbound types",rawArgTypes);}var proto=classType.registeredClass.instancePrototype;var method=proto[methodName];if(void 0===method||void 0===method.overloadTable&&method.className!==classType.name&&method.argCount===argCount-2){unboundTypesHandler.argCount=argCount-2;unboundTypesHandler.className=classType.name;proto[methodName]=unboundTypesHandler;}else{ensureOverloadTable(proto,methodName,humanName);proto[methodName].overloadTable[argCount-2]=unboundTypesHandler;}whenDependentTypesAreResolved([],rawArgTypes,function(argTypes){var memberFunction=craftInvokerFunction(humanName,argTypes,classType,rawInvoker,context);if(void 0===proto[methodName].overloadTable){memberFunction.argCount=argCount-2;proto[methodName]=memberFunction;}else{proto[methodName].overloadTable[argCount-2]=memberFunction;}return[];});return[];});}var emval_free_list=[];var emval_handle_array=[{},{value:void 0},{value:null},{value:true},{value:false}];function __emval_decref(handle){if(handle>4&&0===--emval_handle_array[handle].refcount){emval_handle_array[handle]=void 0;emval_free_list.push(handle);}}function count_emval_handles(){var count=0;for(var i=5;i<emval_handle_array.length;++i){if(emval_handle_array[i]!==void 0){++count;}}return count;}function get_first_emval(){for(var i=5;i<emval_handle_array.length;++i){if(emval_handle_array[i]!==void 0){return emval_handle_array[i];}}return null;}function init_emval(){Module2["count_emval_handles"]=count_emval_handles;Module2["get_first_emval"]=get_first_emval;}var Emval={toValue:handle=>{if(!handle){throwBindingError("Cannot use deleted val. handle = "+handle);}return emval_handle_array[handle].value;},toHandle:value=>{switch(value){case void 0:return 1;case null:return 2;case true:return 3;case false:return 4;default:{var handle=emval_free_list.length?emval_free_list.pop():emval_handle_array.length;emval_handle_array[handle]={refcount:1,value};return handle;}}}};function __embind_register_emval(rawType,name){name=readLatin1String(name);registerType(rawType,{name,"fromWireType":function fromWireType(handle){var rv=Emval.toValue(handle);__emval_decref(handle);return rv;},"toWireType":function toWireType(destructors,value){return Emval.toHandle(value);},"argPackAdvance":8,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction:null});}function enumReadValueFromPointer(name,shift,signed){switch(shift){case 0:return function(pointer){var heap=signed?HEAP8:HEAPU8;return this["fromWireType"](heap[pointer]);};case 1:return function(pointer){var heap=signed?HEAP16:HEAPU16;return this["fromWireType"](heap[pointer>>1]);};case 2:return function(pointer){var heap=signed?HEAP32:HEAPU32;return this["fromWireType"](heap[pointer>>2]);};default:throw new TypeError("Unknown integer type: "+name);}}function __embind_register_enum(rawType,name,size,isSigned){var shift=getShiftFromSize(size);name=readLatin1String(name);function ctor(){}ctor.values={};registerType(rawType,{name,constructor:ctor,"fromWireType":function fromWireType(c){return this.constructor.values[c];},"toWireType":function toWireType(destructors,c){return c.value;},"argPackAdvance":8,"readValueFromPointer":enumReadValueFromPointer(name,shift,isSigned),destructorFunction:null});exposePublicSymbol(name,ctor);}function requireRegisteredType(rawType,humanName){var impl=registeredTypes[rawType];if(void 0===impl){throwBindingError(humanName+" has unknown type "+getTypeName(rawType));}return impl;}function __embind_register_enum_value(rawEnumType,name,enumValue){var enumType=requireRegisteredType(rawEnumType,"enum");name=readLatin1String(name);var Enum=enumType.constructor;var Value=Object.create(enumType.constructor.prototype,{value:{value:enumValue},constructor:{value:createNamedFunction(enumType.name+"_"+name,function(){})}});Enum.values[enumValue]=Value;Enum[name]=Value;}function floatReadValueFromPointer(name,shift){switch(shift){case 2:return function(pointer){return this["fromWireType"](HEAPF32[pointer>>2]);};case 3:return function(pointer){return this["fromWireType"](HEAPF64[pointer>>3]);};default:throw new TypeError("Unknown float type: "+name);}}function __embind_register_float(rawType,name,size){var shift=getShiftFromSize(size);name=readLatin1String(name);registerType(rawType,{name,"fromWireType":function fromWireType(value){return value;},"toWireType":function toWireType(destructors,value){return value;},"argPackAdvance":8,"readValueFromPointer":floatReadValueFromPointer(name,shift),destructorFunction:null});}function __embind_register_integer(primitiveType,name,size,minRange,maxRange){name=readLatin1String(name);var shift=getShiftFromSize(size);var fromWireType=value=>value;if(minRange===0){var bitshift=32-8*size;fromWireType=value=>value<<bitshift>>>bitshift;}var isUnsignedType=name.includes("unsigned");var checkAssertions=(value,toTypeName)=>{};var toWireType;if(isUnsignedType){toWireType=function toWireType(destructors,value){checkAssertions(value,this.name);return value>>>0;};}else{toWireType=function toWireType(destructors,value){checkAssertions(value,this.name);return value;};}registerType(primitiveType,{name,"fromWireType":fromWireType,"toWireType":toWireType,"argPackAdvance":8,"readValueFromPointer":integerReadValueFromPointer(name,shift,minRange!==0),destructorFunction:null});}function __embind_register_memory_view(rawType,dataTypeIndex,name){var typeMapping=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array,BigInt64Array,BigUint64Array];var TA=typeMapping[dataTypeIndex];function decodeMemoryView(handle){handle=handle>>2;var heap=HEAPU32;var size=heap[handle];var data=heap[handle+1];return new TA(buffer,data,size);}name=readLatin1String(name);registerType(rawType,{name,"fromWireType":decodeMemoryView,"argPackAdvance":8,"readValueFromPointer":decodeMemoryView},{ignoreDuplicateRegistrations:true});}function __embind_register_std_string(rawType,name){name=readLatin1String(name);var stdStringIsUTF8=name==="std::string";registerType(rawType,{name,"fromWireType":function fromWireType(value){var length=HEAPU32[value>>2];var payload=value+4;var str;if(stdStringIsUTF8){var decodeStartPtr=payload;for(var i=0;i<=length;++i){var currentBytePtr=payload+i;if(i==length||HEAPU8[currentBytePtr]==0){var maxRead=currentBytePtr-decodeStartPtr;var stringSegment=UTF8ToString(decodeStartPtr,maxRead);if(str===void 0){str=stringSegment;}else{str+=String.fromCharCode(0);str+=stringSegment;}decodeStartPtr=currentBytePtr+1;}}}else{var a=new Array(length);for(var i=0;i<length;++i){a[i]=String.fromCharCode(HEAPU8[payload+i]);}str=a.join("");}_free(value);return str;},"toWireType":function toWireType(destructors,value){if(value instanceof ArrayBuffer){value=new Uint8Array(value);}var length;var valueIsOfTypeString=typeof value=="string";if(!(valueIsOfTypeString||value instanceof Uint8Array||value instanceof Uint8ClampedArray||value instanceof Int8Array)){throwBindingError("Cannot pass non-string to std::string");}if(stdStringIsUTF8&&valueIsOfTypeString){length=lengthBytesUTF8(value);}else{length=value.length;}var base=_malloc(4+length+1);var ptr=base+4;HEAPU32[base>>2]=length;if(stdStringIsUTF8&&valueIsOfTypeString){stringToUTF8(value,ptr,length+1);}else{if(valueIsOfTypeString){for(var i=0;i<length;++i){var charCode=value.charCodeAt(i);if(charCode>255){_free(ptr);throwBindingError("String has UTF-16 code units that do not fit in 8 bits");}HEAPU8[ptr+i]=charCode;}}else{for(var i=0;i<length;++i){HEAPU8[ptr+i]=value[i];}}}if(destructors!==null){destructors.push(_free,base);}return base;},"argPackAdvance":8,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction:function destructorFunction(ptr){_free(ptr);}});}var UTF16Decoder=typeof TextDecoder!="undefined"?new TextDecoder("utf-16le"):void 0;function UTF16ToString(ptr,maxBytesToRead){var endPtr=ptr;var idx=endPtr>>1;var maxIdx=idx+maxBytesToRead/2;while(!(idx>=maxIdx)&&HEAPU16[idx])++idx;endPtr=idx<<1;if(endPtr-ptr>32&&UTF16Decoder)return UTF16Decoder.decode(HEAPU8.subarray(ptr,endPtr));var str="";for(var i=0;!(i>=maxBytesToRead/2);++i){var codeUnit=HEAP16[ptr+i*2>>1];if(codeUnit==0)break;str+=String.fromCharCode(codeUnit);}return str;}function stringToUTF16(str,outPtr,maxBytesToWrite){if(maxBytesToWrite===void 0){maxBytesToWrite=2147483647;}if(maxBytesToWrite<2)return 0;maxBytesToWrite-=2;var startPtr=outPtr;var numCharsToWrite=maxBytesToWrite<str.length*2?maxBytesToWrite/2:str.length;for(var i=0;i<numCharsToWrite;++i){var codeUnit=str.charCodeAt(i);HEAP16[outPtr>>1]=codeUnit;outPtr+=2;}HEAP16[outPtr>>1]=0;return outPtr-startPtr;}function lengthBytesUTF16(str){return str.length*2;}function UTF32ToString(ptr,maxBytesToRead){var i=0;var str="";while(!(i>=maxBytesToRead/4)){var utf32=HEAP32[ptr+i*4>>2];if(utf32==0)break;++i;if(utf32>=65536){var ch=utf32-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023);}else{str+=String.fromCharCode(utf32);}}return str;}function stringToUTF32(str,outPtr,maxBytesToWrite){if(maxBytesToWrite===void 0){maxBytesToWrite=2147483647;}if(maxBytesToWrite<4)return 0;var startPtr=outPtr;var endPtr=startPtr+maxBytesToWrite-4;for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);if(codeUnit>=55296&&codeUnit<=57343){var trailSurrogate=str.charCodeAt(++i);codeUnit=65536+((codeUnit&1023)<<10)|trailSurrogate&1023;}HEAP32[outPtr>>2]=codeUnit;outPtr+=4;if(outPtr+4>endPtr)break;}HEAP32[outPtr>>2]=0;return outPtr-startPtr;}function lengthBytesUTF32(str){var len=0;for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);if(codeUnit>=55296&&codeUnit<=57343)++i;len+=4;}return len;}function __embind_register_std_wstring(rawType,charSize,name){name=readLatin1String(name);var decodeString,encodeString,getHeap,lengthBytesUTF,shift;if(charSize===2){decodeString=UTF16ToString;encodeString=stringToUTF16;lengthBytesUTF=lengthBytesUTF16;getHeap=()=>HEAPU16;shift=1;}else if(charSize===4){decodeString=UTF32ToString;encodeString=stringToUTF32;lengthBytesUTF=lengthBytesUTF32;getHeap=()=>HEAPU32;shift=2;}registerType(rawType,{name,"fromWireType":function fromWireType(value){var length=HEAPU32[value>>2];var HEAP=getHeap();var str;var decodeStartPtr=value+4;for(var i=0;i<=length;++i){var currentBytePtr=value+4+i*charSize;if(i==length||HEAP[currentBytePtr>>shift]==0){var maxReadBytes=currentBytePtr-decodeStartPtr;var stringSegment=decodeString(decodeStartPtr,maxReadBytes);if(str===void 0){str=stringSegment;}else{str+=String.fromCharCode(0);str+=stringSegment;}decodeStartPtr=currentBytePtr+charSize;}}_free(value);return str;},"toWireType":function toWireType(destructors,value){if(!(typeof value=="string")){throwBindingError("Cannot pass non-string to C++ string type "+name);}var length=lengthBytesUTF(value);var ptr=_malloc(4+length+charSize);HEAPU32[ptr>>2]=length>>shift;encodeString(value,ptr+4,length+charSize);if(destructors!==null){destructors.push(_free,ptr);}return ptr;},"argPackAdvance":8,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction:function destructorFunction(ptr){_free(ptr);}});}function __embind_register_void(rawType,name){name=readLatin1String(name);registerType(rawType,{isVoid:true,name,"argPackAdvance":0,"fromWireType":function fromWireType(){return void 0;},"toWireType":function toWireType(destructors,o){return void 0;}});}function __emval_incref(handle){if(handle>4){emval_handle_array[handle].refcount+=1;}}function __emval_take_value(type,arg){type=requireRegisteredType(type,"_emval_take_value");var v=type["readValueFromPointer"](arg);return Emval.toHandle(v);}function _abort(){abort("");}function _emscripten_memcpy_big(dest,src,num){HEAPU8.copyWithin(dest,src,src+num);}function abortOnCannotGrowMemory(requestedSize){abort("OOM");}function _emscripten_resize_heap(requestedSize){HEAPU8.length;abortOnCannotGrowMemory();}function _proc_exit(code){EXITSTATUS=code;if(!keepRuntimeAlive()){if(Module2["onExit"])Module2["onExit"](code);ABORT=true;}quit_(code,new ExitStatus(code));}function exitJS(status,implicit){EXITSTATUS=status;_proc_exit(status);}embind_init_charCodes();BindingError=Module2["BindingError"]=extendError(Error,"BindingError");InternalError=Module2["InternalError"]=extendError(Error,"InternalError");init_ClassHandle();init_embind();init_RegisteredPointer();UnboundTypeError=Module2["UnboundTypeError"]=extendError(Error,"UnboundTypeError");init_emval();var decodeBase64=typeof atob=="function"?atob:function(input){var keyStr="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";var output="";var chr1,chr2,chr3;var enc1,enc2,enc3,enc4;var i=0;input=input.replace(/[^A-Za-z0-9\+\/\=]/g,"");do{enc1=keyStr.indexOf(input.charAt(i++));enc2=keyStr.indexOf(input.charAt(i++));enc3=keyStr.indexOf(input.charAt(i++));enc4=keyStr.indexOf(input.charAt(i++));chr1=enc1<<2|enc2>>4;chr2=(enc2&15)<<4|enc3>>2;chr3=(enc3&3)<<6|enc4;output=output+String.fromCharCode(chr1);if(enc3!==64){output=output+String.fromCharCode(chr2);}if(enc4!==64){output=output+String.fromCharCode(chr3);}}while(i<input.length);return output;};function intArrayFromBase64(s){if(typeof ENVIRONMENT_IS_NODE=="boolean"&&ENVIRONMENT_IS_NODE){var buf=Buffer.from(s,"base64");return new Uint8Array(buf["buffer"],buf["byteOffset"],buf["byteLength"]);}try{var decoded=decodeBase64(s);var bytes=new Uint8Array(decoded.length);for(var i=0;i<decoded.length;++i){bytes[i]=decoded.charCodeAt(i);}return bytes;}catch(_){throw new Error("Converting base64 string to bytes failed.");}}function tryParseAsDataURI(filename){if(!isDataURI(filename)){return;}return intArrayFromBase64(filename.slice(dataURIPrefix.length));}var asmLibraryArg={"a":___assert_fail,"l":__embind_register_bigint,"s":__embind_register_bool,"u":__embind_register_class,"o":__embind_register_class_constructor,"e":__embind_register_class_function,"r":__embind_register_emval,"g":__embind_register_enum,"f":__embind_register_enum_value,"k":__embind_register_float,"c":__embind_register_integer,"b":__embind_register_memory_view,"j":__embind_register_std_string,"h":__embind_register_std_wstring,"t":__embind_register_void,"m":__emval_decref,"n":__emval_incref,"i":__emval_take_value,"d":_abort,"q":_emscripten_memcpy_big,"p":_emscripten_resize_heap};createWasm();Module2["___wasm_call_ctors"]=function(){return(Module2["___wasm_call_ctors"]=Module2["asm"]["w"]).apply(null,arguments);};Module2["_main"]=function(){return(Module2["_main"]=Module2["asm"]["x"]).apply(null,arguments);};var _free=Module2["_free"]=function(){return(_free=Module2["_free"]=Module2["asm"]["z"]).apply(null,arguments);};var _malloc=Module2["_malloc"]=function(){return(_malloc=Module2["_malloc"]=Module2["asm"]["A"]).apply(null,arguments);};var ___getTypeName=Module2["___getTypeName"]=function(){return(___getTypeName=Module2["___getTypeName"]=Module2["asm"]["B"]).apply(null,arguments);};Module2["__embind_initialize_bindings"]=function(){return(Module2["__embind_initialize_bindings"]=Module2["asm"]["C"]).apply(null,arguments);};var calledRun;dependenciesFulfilled=function runCaller(){if(!calledRun)run();if(!calledRun)dependenciesFulfilled=runCaller;};function callMain(args){var entryFunction=Module2["_main"];var argc=0;var argv=0;try{var ret=entryFunction(argc,argv);exitJS(ret,true);return ret;}catch(e){return handleException(e);}}function run(args){if(runDependencies>0){return;}preRun();if(runDependencies>0){return;}function doRun(){if(calledRun)return;calledRun=true;Module2["calledRun"]=true;if(ABORT)return;initRuntime();preMain();readyPromiseResolve(Module2);if(Module2["onRuntimeInitialized"])Module2["onRuntimeInitialized"]();if(shouldRunNow)callMain();postRun();}if(Module2["setStatus"]){Module2["setStatus"]("Running...");setTimeout(function(){setTimeout(function(){Module2["setStatus"]("");},1);doRun();},1);}else{doRun();}}if(Module2["preInit"]){if(typeof Module2["preInit"]=="function")Module2["preInit"]=[Module2["preInit"]];while(Module2["preInit"].length>0){Module2["preInit"].pop()();}}var shouldRunNow=true;if(Module2["noInitialRun"])shouldRunNow=false;run();return Module2.ready;};})();function createWasmInstance(){return _createWasmInstance.apply(this,arguments);}function _createWasmInstance(){_createWasmInstance=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee46(){return _regenerator.default.wrap(function _callee46$(_context46){while(1)switch(_context46.prev=_context46.next){case 0:return _context46.abrupt("return",Module());case 1:case"end":return _context46.stop();}},_callee46);}));return _createWasmInstance.apply(this,arguments);}const anyMap=/* @__PURE__ */new WeakMap();const eventsMap=/* @__PURE__ */new WeakMap();const producersMap=/* @__PURE__ */new WeakMap();const anyProducer=Symbol("anyProducer");const resolvedPromise=Promise.resolve();const listenerAdded=Symbol("listenerAdded");const listenerRemoved=Symbol("listenerRemoved");let canEmitMetaEvents=false;let isGlobalDebugEnabled=false;function assertEventName(eventName){if(typeof eventName!=="string"&&typeof eventName!=="symbol"&&typeof eventName!=="number"){throw new TypeError("`eventName` must be a string, symbol, or number");}}function assertListener(listener){if(typeof listener!=="function"){throw new TypeError("listener must be a function");}}function getListeners(instance,eventName){const events=eventsMap.get(instance);if(!events.has(eventName)){return;}return events.get(eventName);}function getEventProducers(instance,eventName){const key=typeof eventName==="string"||typeof eventName==="symbol"||typeof eventName==="number"?eventName:anyProducer;const producers=producersMap.get(instance);if(!producers.has(key)){return;}return producers.get(key);}function enqueueProducers(instance,eventName,eventData){const producers=producersMap.get(instance);if(producers.has(eventName)){for(var _iterator20=_createForOfIteratorHelperLoose(producers.get(eventName)),_step20;!(_step20=_iterator20()).done;){const producer=_step20.value;producer.enqueue(eventData);}}if(producers.has(anyProducer)){const item=Promise.all([eventName,eventData]);for(var _iterator21=_createForOfIteratorHelperLoose(producers.get(anyProducer)),_step21;!(_step21=_iterator21()).done;){const producer=_step21.value;producer.enqueue(item);}}}function iterator(instance,eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];let isFinished=false;let flush=()=>{};let queue=[];const producer={enqueue(item){queue.push(item);flush();},finish(){isFinished=true;flush();}};for(var _iterator22=_createForOfIteratorHelperLoose(eventNames),_step22;!(_step22=_iterator22()).done;){const eventName=_step22.value;let set=getEventProducers(instance,eventName);if(!set){set=/* @__PURE__ */new Set();const producers=producersMap.get(instance);producers.set(eventName,set);}set.add(producer);}return{next(){var _this2=this;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee8(){return _regenerator.default.wrap(function _callee8$(_context8){while(1)switch(_context8.prev=_context8.next){case 0:if(queue){_context8.next=2;break;}return _context8.abrupt("return",{done:true});case 2:if(!(queue.length===0)){_context8.next=9;break;}if(!isFinished){_context8.next=6;break;}queue=void 0;return _context8.abrupt("return",_this2.next());case 6:_context8.next=8;return new Promise(resolve=>{flush=resolve;});case 8:return _context8.abrupt("return",_this2.next());case 9:_context8.next=11;return queue.shift();case 11:_context8.t0=_context8.sent;return _context8.abrupt("return",{done:false,value:_context8.t0});case 13:case"end":return _context8.stop();}},_callee8);}))();},return(value){var _arguments2=arguments;return(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee9(){var _iterator23,_step23,eventName,set,producers;return _regenerator.default.wrap(function _callee9$(_context9){while(1)switch(_context9.prev=_context9.next){case 0:queue=void 0;for(_iterator23=_createForOfIteratorHelperLoose(eventNames);!(_step23=_iterator23()).done;){eventName=_step23.value;set=getEventProducers(instance,eventName);if(set){set.delete(producer);if(set.size===0){producers=producersMap.get(instance);producers.delete(eventName);}}}flush();if(!(_arguments2.length>0)){_context9.next=10;break;}_context9.next=6;return value;case 6:_context9.t1=_context9.sent;_context9.t0={done:true,value:_context9.t1};_context9.next=11;break;case 10:_context9.t0={done:true};case 11:return _context9.abrupt("return",_context9.t0);case 12:case"end":return _context9.stop();}},_callee9);}))();},[Symbol.asyncIterator](){return this;}};}function defaultMethodNamesOrAssert(methodNames){if(methodNames===void 0){return allEmitteryMethods;}if(!Array.isArray(methodNames)){throw new TypeError("`methodNames` must be an array of strings");}for(var _iterator24=_createForOfIteratorHelperLoose(methodNames),_step24;!(_step24=_iterator24()).done;){const methodName=_step24.value;if(!allEmitteryMethods.includes(methodName)){if(typeof methodName!=="string"){throw new TypeError("`methodNames` element must be a string");}throw new Error(`${methodName} is not Emittery method`);}}return methodNames;}const isMetaEvent=eventName=>eventName===listenerAdded||eventName===listenerRemoved;function emitMetaEvent(emitter,eventName,eventData){if(isMetaEvent(eventName)){try{canEmitMetaEvents=true;emitter.emit(eventName,eventData);}finally{canEmitMetaEvents=false;}}}let Emittery2=/*#__PURE__*/function(){Emittery2.mixin=function mixin(emitteryPropertyName,methodNames){methodNames=defaultMethodNamesOrAssert(methodNames);return target=>{if(typeof target!=="function"){throw new TypeError("`target` must be function");}for(var _iterator25=_createForOfIteratorHelperLoose(methodNames),_step25;!(_step25=_iterator25()).done;){const methodName=_step25.value;if(target.prototype[methodName]!==void 0){throw new Error(`The property \`${methodName}\` already exists on \`target\``);}}function getEmitteryProperty(){Object.defineProperty(this,emitteryPropertyName,{enumerable:false,value:new Emittery2()});return this[emitteryPropertyName];}Object.defineProperty(target.prototype,emitteryPropertyName,{enumerable:false,get:getEmitteryProperty});const emitteryMethodCaller=methodName=>function(){return this[emitteryPropertyName][methodName](...arguments);};for(var _iterator26=_createForOfIteratorHelperLoose(methodNames),_step26;!(_step26=_iterator26()).done;){const methodName=_step26.value;Object.defineProperty(target.prototype,methodName,{enumerable:false,value:emitteryMethodCaller(methodName)});}return target;};};function Emittery2(options){var _options$debug;if(options===void 0){options={};}anyMap.set(this,/* @__PURE__ */new Set());eventsMap.set(this,/* @__PURE__ */new Map());producersMap.set(this,/* @__PURE__ */new Map());producersMap.get(this).set(anyProducer,/* @__PURE__ */new Set());this.debug=(_options$debug=options.debug)!=null?_options$debug:{};if(this.debug.enabled===void 0){this.debug.enabled=false;}if(!this.debug.logger){this.debug.logger=(type,debugName,eventName,eventData)=>{try{eventData=JSON.stringify(eventData);}catch(_unused2){eventData=`Object with the following keys failed to stringify: ${Object.keys(eventData).join(",")}`;}if(typeof eventName==="symbol"||typeof eventName==="number"){eventName=eventName.toString();}const currentTime=/* @__PURE__ */new Date();const logTime=`${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);};}}var _proto2=Emittery2.prototype;_proto2.logIfDebugEnabled=function logIfDebugEnabled(type,eventName,eventData){if(Emittery2.isDebugEnabled||this.debug.enabled){this.debug.logger(type,this.debug.name,eventName,eventData);}};_proto2.on=function on(eventNames,listener){assertListener(listener);eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator27=_createForOfIteratorHelperLoose(eventNames),_step27;!(_step27=_iterator27()).done;){const eventName=_step27.value;assertEventName(eventName);let set=getListeners(this,eventName);if(!set){set=/* @__PURE__ */new Set();const events=eventsMap.get(this);events.set(eventName,set);}set.add(listener);this.logIfDebugEnabled("subscribe",eventName,void 0);if(!isMetaEvent(eventName)){emitMetaEvent(this,listenerAdded,{eventName,listener});}}return this.off.bind(this,eventNames,listener);};_proto2.off=function off(eventNames,listener){assertListener(listener);eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator28=_createForOfIteratorHelperLoose(eventNames),_step28;!(_step28=_iterator28()).done;){const eventName=_step28.value;assertEventName(eventName);const set=getListeners(this,eventName);if(set){set.delete(listener);if(set.size===0){const events=eventsMap.get(this);events.delete(eventName);}}this.logIfDebugEnabled("unsubscribe",eventName,void 0);if(!isMetaEvent(eventName)){emitMetaEvent(this,listenerRemoved,{eventName,listener});}}};_proto2.once=function once(eventNames){let off_;const promise=new Promise(resolve=>{off_=this.on(eventNames,data=>{off_();resolve(data);});});promise.off=off_;return promise;};_proto2.events=function events(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator29=_createForOfIteratorHelperLoose(eventNames),_step29;!(_step29=_iterator29()).done;){const eventName=_step29.value;assertEventName(eventName);}return iterator(this,eventNames);};_proto2.emit=/*#__PURE__*/function(){var _emit2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee12(eventName,eventData){var _getListeners;var listeners,anyListeners,staticListeners,staticAnyListeners;return _regenerator.default.wrap(function _callee12$(_context12){while(1)switch(_context12.prev=_context12.next){case 0:assertEventName(eventName);if(!(isMetaEvent(eventName)&&!canEmitMetaEvents)){_context12.next=3;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 3:this.logIfDebugEnabled("emit",eventName,eventData);enqueueProducers(this,eventName,eventData);listeners=(_getListeners=getListeners(this,eventName))!=null?_getListeners:/* @__PURE__ */new Set();anyListeners=anyMap.get(this);staticListeners=[...listeners];staticAnyListeners=isMetaEvent(eventName)?[]:[...anyListeners];_context12.next=11;return resolvedPromise;case 11:_context12.next=13;return Promise.all([...staticListeners.map(/*#__PURE__*/function(){var _ref5=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee10(listener){return _regenerator.default.wrap(function _callee10$(_context10){while(1)switch(_context10.prev=_context10.next){case 0:if(!listeners.has(listener)){_context10.next=2;break;}return _context10.abrupt("return",listener(eventData));case 2:case"end":return _context10.stop();}},_callee10);}));return function(_x23){return _ref5.apply(this,arguments);};}()),...staticAnyListeners.map(/*#__PURE__*/function(){var _ref6=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee11(listener){return _regenerator.default.wrap(function _callee11$(_context11){while(1)switch(_context11.prev=_context11.next){case 0:if(!anyListeners.has(listener)){_context11.next=2;break;}return _context11.abrupt("return",listener(eventName,eventData));case 2:case"end":return _context11.stop();}},_callee11);}));return function(_x24){return _ref6.apply(this,arguments);};}())]);case 13:case"end":return _context12.stop();}},_callee12,this);}));function emit(_x21,_x22){return _emit2.apply(this,arguments);}return emit;}();_proto2.emitSerial=/*#__PURE__*/function(){var _emitSerial2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee13(eventName,eventData){var _getListeners2;var listeners,anyListeners,staticListeners,staticAnyListeners,_i3,_staticListeners2,listener,_i4,_staticAnyListeners2;return _regenerator.default.wrap(function _callee13$(_context13){while(1)switch(_context13.prev=_context13.next){case 0:assertEventName(eventName);if(!(isMetaEvent(eventName)&&!canEmitMetaEvents)){_context13.next=3;break;}throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");case 3:this.logIfDebugEnabled("emitSerial",eventName,eventData);listeners=(_getListeners2=getListeners(this,eventName))!=null?_getListeners2:/* @__PURE__ */new Set();anyListeners=anyMap.get(this);staticListeners=[...listeners];staticAnyListeners=[...anyListeners];_context13.next=10;return resolvedPromise;case 10:_i3=0,_staticListeners2=staticListeners;case 11:if(!(_i3<_staticListeners2.length)){_context13.next=19;break;}listener=_staticListeners2[_i3];if(!listeners.has(listener)){_context13.next=16;break;}_context13.next=16;return listener(eventData);case 16:_i3++;_context13.next=11;break;case 19:_i4=0,_staticAnyListeners2=staticAnyListeners;case 20:if(!(_i4<_staticAnyListeners2.length)){_context13.next=28;break;}listener=_staticAnyListeners2[_i4];if(!anyListeners.has(listener)){_context13.next=25;break;}_context13.next=25;return listener(eventName,eventData);case 25:_i4++;_context13.next=20;break;case 28:case"end":return _context13.stop();}},_callee13,this);}));function emitSerial(_x25,_x26){return _emitSerial2.apply(this,arguments);}return emitSerial;}();_proto2.onAny=function onAny(listener){assertListener(listener);this.logIfDebugEnabled("subscribeAny",void 0,void 0);anyMap.get(this).add(listener);emitMetaEvent(this,listenerAdded,{listener});return this.offAny.bind(this,listener);};_proto2.anyEvent=function anyEvent(){return iterator(this);};_proto2.offAny=function offAny(listener){assertListener(listener);this.logIfDebugEnabled("unsubscribeAny",void 0,void 0);emitMetaEvent(this,listenerRemoved,{listener});anyMap.get(this).delete(listener);};_proto2.clearListeners=function clearListeners(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];for(var _iterator30=_createForOfIteratorHelperLoose(eventNames),_step30;!(_step30=_iterator30()).done;){const eventName=_step30.value;this.logIfDebugEnabled("clear",eventName,void 0);if(typeof eventName==="string"||typeof eventName==="symbol"||typeof eventName==="number"){const set=getListeners(this,eventName);if(set){set.clear();}const producers=getEventProducers(this,eventName);if(producers){for(var _iterator31=_createForOfIteratorHelperLoose(producers),_step31;!(_step31=_iterator31()).done;){const producer=_step31.value;producer.finish();}producers.clear();}}else{anyMap.get(this).clear();for(var _iterator32=_createForOfIteratorHelperLoose(eventsMap.get(this).entries()),_step32;!(_step32=_iterator32()).done;){const _step32$value=_step32.value,eventName2=_step32$value[0],listeners=_step32$value[1];listeners.clear();eventsMap.get(this).delete(eventName2);}for(var _iterator33=_createForOfIteratorHelperLoose(producersMap.get(this).entries()),_step33;!(_step33=_iterator33()).done;){const _step33$value=_step33.value,eventName2=_step33$value[0],producers=_step33$value[1];for(var _iterator34=_createForOfIteratorHelperLoose(producers),_step34;!(_step34=_iterator34()).done;){const producer=_step34.value;producer.finish();}producers.clear();producersMap.get(this).delete(eventName2);}}}};_proto2.listenerCount=function listenerCount(eventNames){eventNames=Array.isArray(eventNames)?eventNames:[eventNames];let count=0;for(var _iterator35=_createForOfIteratorHelperLoose(eventNames),_step35;!(_step35=_iterator35()).done;){const eventName=_step35.value;if(typeof eventName==="string"){var _getListeners$size,_getListeners3,_getEventProducers$si,_getEventProducers,_getEventProducers$si2,_getEventProducers2;count+=anyMap.get(this).size+((_getListeners$size=(_getListeners3=getListeners(this,eventName))==null?void 0:_getListeners3.size)!=null?_getListeners$size:0)+((_getEventProducers$si=(_getEventProducers=getEventProducers(this,eventName))==null?void 0:_getEventProducers.size)!=null?_getEventProducers$si:0)+((_getEventProducers$si2=(_getEventProducers2=getEventProducers(this))==null?void 0:_getEventProducers2.size)!=null?_getEventProducers$si2:0);continue;}if(typeof eventName!=="undefined"){assertEventName(eventName);}count+=anyMap.get(this).size;for(var _iterator36=_createForOfIteratorHelperLoose(eventsMap.get(this).values()),_step36;!(_step36=_iterator36()).done;){const value=_step36.value;count+=value.size;}for(var _iterator37=_createForOfIteratorHelperLoose(producersMap.get(this).values()),_step37;!(_step37=_iterator37()).done;){const value=_step37.value;count+=value.size;}}return count;};_proto2.bindMethods=function bindMethods(target,methodNames){if(typeof target!=="object"||target===null){throw new TypeError("`target` must be an object");}methodNames=defaultMethodNamesOrAssert(methodNames);for(var _iterator38=_createForOfIteratorHelperLoose(methodNames),_step38;!(_step38=_iterator38()).done;){const methodName=_step38.value;if(target[methodName]!==void 0){throw new Error(`The property \`${methodName}\` already exists on \`target\``);}Object.defineProperty(target,methodName,{enumerable:false,value:this[methodName].bind(this)});}};(0,_createClass2.default)(Emittery2,null,[{key:"isDebugEnabled",get:function get(){var _globalThis$process,_globalThis$process2;if(typeof((_globalThis$process=_globalThis.process)==null?void 0:_globalThis$process.env)!=="object"){return isGlobalDebugEnabled;}const _ref7=(_globalThis$process2=_globalThis.process)!=null?_globalThis$process2:{env:{}},env=_ref7.env;return env.DEBUG==="emittery"||env.DEBUG==="*"||isGlobalDebugEnabled;},set:function set(newValue){isGlobalDebugEnabled=newValue;}}]);return Emittery2;}();const allEmitteryMethods=Object.getOwnPropertyNames(Emittery2.prototype).filter(v=>v!=="constructor");Object.defineProperty(Emittery2,"listenerAdded",{value:listenerAdded,writable:false,enumerable:true,configurable:false});Object.defineProperty(Emittery2,"listenerRemoved",{value:listenerRemoved,writable:false,enumerable:true,configurable:false});const _EncryptionEngine=/*#__PURE__*/function(_Emittery){(0,_inheritsLoose2.default)(_EncryptionEngine,_Emittery);function _EncryptionEngine(){var _this3;_this3=_Emittery.apply(this,arguments)||this;_this3.isDecryptionEnabled=true;_this3.payloadTypes={};_this3.isOnSuccessEnabled=false;_this3.ignoreCodecErrors=false;_this3.isDtxEnabled=false;return _this3;}var _proto3=_EncryptionEngine.prototype;_proto3.init=/*#__PURE__*/function(){var _init=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee14(){return _regenerator.default.wrap(function _callee14$(_context14){while(1)switch(_context14.prev=_context14.next){case 0:_context14.prev=0;_context14.next=3;return createWasmInstance();case 3:this.instance=_context14.sent;this.encryptor=new this.instance.SFrameEngine(this.instance.EngineType.ENCRYPTOR,this.instance.CipherSuite.AES_CTR_128_HMAC_SHA256_80);this.decryptor=new this.instance.SFrameEngine(this.instance.EngineType.DECRYPTOR,this.instance.CipherSuite.AES_CTR_128_HMAC_SHA256_80);self.addEventListener("rtctransform",e=>{console.log("rtctransform",e);const _e$transformer=e.transformer,_e$transformer$option=_e$transformer.options,type=_e$transformer$option.type,id=_e$transformer$option.id,readable=_e$transformer.readable,writable=_e$transformer.writable;switch(type){case"encrypt":this.encrypt(id,readable,writable);break;case"decrypt":this.decrypt(id,readable,writable);break;}});_context14.next=12;break;case 9:_context14.prev=9;_context14.t0=_context14["catch"](0);console.error("INIT ERRROR",_context14.t0);case 12:case"end":return _context14.stop();}},_callee14,this,[[0,9]]);}));function init(){return _init.apply(this,arguments);}return init;}();_proto3.setEnableOnSuccess=/*#__PURE__*/function(){var _setEnableOnSuccess=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee15(enabled){return _regenerator.default.wrap(function _callee15$(_context15){while(1)switch(_context15.prev=_context15.next){case 0:this.isOnSuccessEnabled=enabled;case 1:case"end":return _context15.stop();}},_callee15,this);}));function setEnableOnSuccess(_x27){return _setEnableOnSuccess.apply(this,arguments);}return setEnableOnSuccess;}();_proto3.setIgnoreCodecErrors=function setIgnoreCodecErrors(ignore){this.ignoreCodecErrors=ignore;};_proto3.setDtxEnabled=function setDtxEnabled(enabled){this.isDtxEnabled=enabled;};_proto3.enableDecryption=function enableDecryption(){var _this$decryptor;this.isDecryptionEnabled=true;(_this$decryptor=this.decryptor)==null?void 0:_this$decryptor.setEnabled(this.isDecryptionEnabled);};_proto3.disableDecryption=function disableDecryption(){var _this$decryptor2;this.isDecryptionEnabled=false;(_this$decryptor2=this.decryptor)==null?void 0:_this$decryptor2.setEnabled(this.isDecryptionEnabled);};_proto3.setKey=function setKey(key){if(!this.encryptor||!this.decryptor){console.error("Engine must be initialized");throw"Engine must be initialized";}this.updateEngineKey(this.encryptor,key);this.updateEngineKey(this.decryptor,key);};_proto3.addPayloadTypes=function addPayloadTypes(payloadTypes){this.payloadTypes=Object.assign({},this.payloadTypes,payloadTypes);};_proto3.removeKey=function removeKey(kid){if(!this.encryptor||!this.decryptor){console.error("Engine must be initialized");throw"Engine must be initialized";}this.encryptor.removeBaseKey(BigInt(kid));this.decryptor.removeBaseKey(BigInt(kid));};_proto3.encrypt=function encrypt(kid,readable,writable){this.transformStream(readable,writable,frame=>{if(!this.encryptor){console.error("Engine must be initialized");throw"Engine must be initialized";}this.processFrame(this.encryptor,kid,frame);});};_proto3.decrypt=function decrypt(kid,readable,writable){this.transformStream(readable,writable,frame=>{if(!this.decryptor){console.error("Engine must be initialized");throw"Engine must be initialized";}this.processFrame(this.decryptor,kid,frame);});}/**
   * Specify which media codec is use by the connection.
   * @param audio Audio codec
   * @param video Video codec
   */;_proto3.setCodecs=function setCodecs(audio,video){if(audio!==void 0){this.audioCodec=audio;}if(video!==void 0){this.videoCodec=video;}};_proto3.transformStream=/*#__PURE__*/function(){var _transformStream=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee16(readable,writable,transform){var reader,writer,_yield$reader$read,frame;return _regenerator.default.wrap(function _callee16$(_context16){while(1)switch(_context16.prev=_context16.next){case 0:reader=readable.getReader();writer=writable.getWriter();case 2:if(false){}_context16.prev=3;_context16.next=6;return reader.read();case 6:_yield$reader$read=_context16.sent;frame=_yield$reader$read.value;transform(frame);_context16.next=11;return writer.ready;case 11:_context16.next=13;return writer.write(frame);case 13:_context16.next=18;break;case 15:_context16.prev=15;_context16.t0=_context16["catch"](3);console.log("ERROR",_context16.t0);case 18:_context16.next=2;break;case 20:case"end":return _context16.stop();}},_callee16,null,[[3,15]]);}));function transformStream(_x28,_x29,_x30){return _transformStream.apply(this,arguments);}return transformStream;}();_proto3.updateEngineKey=function updateEngineKey(engine,key){const buffer=engine.getKeyBuffer(key.key.length);let keyData=key.key;if(typeof keyData==="string"){keyData=Uint8Array.from(keyData.split("").map(v=>v.charCodeAt(0)));}buffer.set(keyData);engine.addOrUpdateBaseKey(BigInt(key.kid));};_proto3.processFrame=function processFrame(engine,kid,frame){var _this$instance,_this$instance2,_this$instance3,_this$instance4,_this$instance5;if(frame.data.byteLength===0){if(frame instanceof RTCEncodedAudioFrame&&this.isDtxEnabled){return;}this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:`EMPTY ${frame instanceof RTCEncodedAudioFrame?"AUDIO":"VIDEO"} FRAME`});return;}if(!this.instance){console.error("Engine must be initialized");throw"Not initialized";}let codec;if(this.audioCodec!==void 0&&frame instanceof RTCEncodedAudioFrame){codec=this.audioCodec;}else if(this.videoCodec!==void 0&&frame instanceof RTCEncodedVideoFrame){codec=this.videoCodec;}else{const metadata=frame.getMetadata();codec=this.payloadTypes[metadata.payloadType];}switch(codec){case Codec.VP8:engine.setSkipOffset((_this$instance=this.instance)==null?void 0:_this$instance.SkipOffset.VP8);break;case Codec.H264:engine.setSkipOffset((_this$instance2=this.instance)==null?void 0:_this$instance2.SkipOffset.H264);break;case Codec.OPUS:engine.setSkipOffset((_this$instance3=this.instance)==null?void 0:_this$instance3.SkipOffset.OPUS);break;case Codec.VP9:engine.setSkipOffset((_this$instance4=this.instance)==null?void 0:_this$instance4.SkipOffset.VP9);break;default:engine.setSkipOffset((_this$instance5=this.instance)==null?void 0:_this$instance5.SkipOffset.UNSUPPORTED);if(this.ignoreCodecErrors){break;}this.emit("warning",{subtype:EncryptionEngineEventType.UnsupportedCodec,id:kid,message:"Unknown codec"});break;}const input=new Uint8Array(frame.data);const output=this.runEngineAlgorithm(engine,kid,input);const status=engine.getStatus();if(status===this.instance.Status.OK&&output.byteLength>0){frame.data=new ArrayBuffer(output.byteLength);new Uint8Array(frame.data).set(output);if(this.isOnSuccessEnabled){this.emit("success",{subtype:EncryptionEngineEventType.Success,id:kid,message:"SUCCESS",codec});}}else{switch(status){case this.instance.Status.FAILED_TO_AUTHENTICATE:this.emit("error",{subtype:EncryptionEngineEventType.FailedToAuthenticate,id:kid,message:"ERROR: FAILED_TO_AUTHENTICATE",codec});break;case this.instance.Status.FAILED_TO_DECRYPT:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: FAILED_TO_DECRYPT",codec});break;case this.instance.Status.FAILED_TO_DECRYPT_UNSUPPORTED_MEDIA_CODEC:if(this.ignoreCodecErrors){frame.data=new ArrayBuffer(input.byteLength);new Uint8Array(frame.data).fill(0);break;}console.log("foo ",status);this.emit("error",{subtype:EncryptionEngineEventType.UnsupportedCodec,id:kid,message:"ERROR: FAILED_TO_DECRYPT_UNSUPPORTED_MEDIA_CODEC",codec});break;case this.instance.Status.FAILED_TO_ENCRYPT:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: FAILED_TO_ENCRYPT",codec});break;case this.instance.Status.FAILED_TO_ENCRYPT_UNSUPPORTED_MEDIA_CODEC:if(this.ignoreCodecErrors){frame.data=new ArrayBuffer(input.byteLength);new Uint8Array(frame.data).fill(0);break;}this.emit("error",{subtype:EncryptionEngineEventType.UnsupportedCodec,id:kid,message:"ERROR: FAILED_TO_ENCRYPT_UNSUPPORTED_MEDIA_CODEC",codec});break;case this.instance.Status.FAIL_PARSE_CODEC_HEADER:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: FAIL_PARSE_CODEC_HEADER",codec});break;case this.instance.Status.FAILED_TO_ENCRYPT_PARSE_CODEC_HEADER:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: FAILED_TO_ENCRYPT_PARSE_CODEC_HEADER",codec});break;case this.instance.Status.FAILED_TO_DECRYPT_PARSE_CODEC_HEADER:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: FAILED_TO_ENCRYPT_PARSE_CODEC_HEADER",codec});break;case this.instance.Status.NULL_INPUT_FRAME:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: NULL_INPUT_FRAME",codec});break;case this.instance.Status.NULL_OUTPUT_FRAME:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: NULL_OUTPUT_FRAME",codec});break;case this.instance.Status.UNKNOWN:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: UNKNOWN",codec});break;case this.instance.Status.OK:this.emit("error",{subtype:EncryptionEngineEventType.Error,id:kid,message:"ERROR: EMPTY OUTPUT",codec});break;case this.instance.Status.WARNING_SKIPPED_DECRYPTING:this.emit("warning",{subtype:EncryptionEngineEventType.SkippedDecrypting,id:kid,message:"WARNING: SKIPPED DECRYPTING",codec});break;}}};_proto3.runEngineAlgorithm=function runEngineAlgorithm(engine,kid,data){try{const buffer=engine.getInputFrame(data.length);buffer.set(data);const size=engine.runAlgorithm(BigInt(kid));return engine.getOutputFrame().slice(0,size);}catch(e){console.log("FAIL",data.length,e);return new Uint8Array([]);}};return _EncryptionEngine;}(Emittery2);registerWorker("encryption-engine",_EncryptionEngine);let EncryptionEngine=_EncryptionEngine;const encodedJs="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";const blob=typeof window!=="undefined"&&window.Blob&&new Blob([atob(encodedJs)],{type:"text/javascript;charset=utf-8"});function WorkerWrapper(){let objURL;try{objURL=blob&&(window.URL||window.webkitURL).createObjectURL(blob);if(!objURL)throw"";return new Worker(objURL);}catch(e){return new Worker("data:application/javascript;base64,"+encodedJs);}finally{objURL&&(window.URL||window.webkitURL).revokeObjectURL(objURL);}}const getCodecFromMimeType=mimeType=>{const mime=mimeType.toLowerCase();if(mime.includes("vp8")){return Codec.VP8;}else if(mime.includes("h264")){return Codec.H264;}else if(mime.includes("opus")){return Codec.OPUS;}else if(mime.includes("vp9")){return Codec.VP9;}else if(mime.includes("h265")){return Codec.H265;}else if(mime.includes("av1")){return Codec.AV1;}};const POLL_GET_STATS_TIMEOUT=5e3;let Client=/*#__PURE__*/function(_EventTarget){(0,_inheritsLoose2.default)(Client,_EventTarget);/**
   * @private
   */function Client(senderId,config){var _this4;if(senderId===void 0){senderId=0;}_this4=_EventTarget.call(this)||this;_this4.senderId=senderId;_this4.config=config;return _this4;}/**
   * Private async constructor
   * @internal
   */var _proto4=Client.prototype;_proto4.init=/*#__PURE__*/function(){var _init2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee17(){return _regenerator.default.wrap(function _callee17$(_context17){while(1)switch(_context17.prev=_context17.next){case 0:_context17.next=2;return workerize(EncryptionEngine,WorkerWrapper);case 2:this.worker=_context17.sent;_context17.next=5;return this.worker.init();case 5:this.worker.onAny((name,payload)=>{const event=new Event(name);event.subtype=payload.subtype;event.id=payload.id;event.message=payload.message;event.codec=payload.codec;this.dispatchEvent(event);});case 6:case"end":return _context17.stop();}},_callee17,this);}));function init(){return _init2.apply(this,arguments);}return init;}()/**
   * Static async constructor
   * @param senderId Sender id
   * @param config Encryption engine configuration
   * @returns Initialized client
   */;Client.create=/*#__PURE__*/function(){var _create=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee18(senderId,config){var result;return _regenerator.default.wrap(function _callee18$(_context18){while(1)switch(_context18.prev=_context18.next){case 0:if(config===void 0){config={};}result=new Client(senderId,config);_context18.next=4;return result.init();case 4:return _context18.abrupt("return",result);case 5:case"end":return _context18.stop();}},_callee18);}));function create(_x31,_x32){return _create.apply(this,arguments);}return create;}()/**
   * Enable or disable decryption
   * @param enabled Should decryption being enabled or disabled
   */;_proto4.setEnableDecryption=/*#__PURE__*/function(){var _setEnableDecryption=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee19(enabled){var _this$worker,_this$worker2;return _regenerator.default.wrap(function _callee19$(_context19){while(1)switch(_context19.prev=_context19.next){case 0:if(!enabled){_context19.next=5;break;}_context19.next=3;return(_this$worker=this.worker)==null?void 0:_this$worker.enableDecryption();case 3:_context19.next=7;break;case 5:_context19.next=7;return(_this$worker2=this.worker)==null?void 0:_this$worker2.disableDecryption();case 7:case"end":return _context19.stop();}},_callee19,this);}));function setEnableDecryption(_x33){return _setEnableDecryption.apply(this,arguments);}return setEnableDecryption;}()/**
   * Enable or disable success event triggering
   * @param enabled Should success event being triggered
   */;_proto4.setEnableOnSuccess=/*#__PURE__*/function(){var _setEnableOnSuccess2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee20(enabled){var _this$worker3;return _regenerator.default.wrap(function _callee20$(_context20){while(1)switch(_context20.prev=_context20.next){case 0:_context20.next=2;return(_this$worker3=this.worker)==null?void 0:_this$worker3.setEnableOnSuccess(enabled);case 2:case"end":return _context20.stop();}},_callee20,this);}));function setEnableOnSuccess(_x34){return _setEnableOnSuccess2.apply(this,arguments);}return setEnableOnSuccess;}()/**
   * Set sender encryption key
   * @param key key content
   */;_proto4.setSenderEncryptionKey=/*#__PURE__*/function(){var _setSenderEncryptionKey=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee21(key){var _this$worker4;return _regenerator.default.wrap(function _callee21$(_context21){while(1)switch(_context21.prev=_context21.next){case 0:_context21.next=2;return(_this$worker4=this.worker)==null?void 0:_this$worker4.setKey({kid:this.senderId,key});case 2:case"end":return _context21.stop();}},_callee21,this);}));function setSenderEncryptionKey(_x35){return _setSenderEncryptionKey.apply(this,arguments);}return setSenderEncryptionKey;}()/**
   * Register a new receiver
   *
   * This function is there to ensure compatibility with sframe.js.
   * addReceiver can be call directly without setReceiverEncryptionKey before.
   * @param receiverKid key id of the receiver
   */;_proto4.addReceiver=/*#__PURE__*/function(){var _addReceiver=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee22(receiverKid){var _this$worker5;return _regenerator.default.wrap(function _callee22$(_context22){while(1)switch(_context22.prev=_context22.next){case 0:_context22.next=2;return(_this$worker5=this.worker)==null?void 0:_this$worker5.setKey({kid:receiverKid,key:""});case 2:case"end":return _context22.stop();}},_callee22,this);}));function addReceiver(_x36){return _addReceiver.apply(this,arguments);}return addReceiver;}()/**
   * Set a receiver key
   * @param receiverKid key id of the receiver
   * @param key key content
   */;_proto4.setReceiverEncryptionKey=/*#__PURE__*/function(){var _setReceiverEncryptionKey=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee23(receiverKid,key){var _this$worker6;return _regenerator.default.wrap(function _callee23$(_context23){while(1)switch(_context23.prev=_context23.next){case 0:_context23.next=2;return(_this$worker6=this.worker)==null?void 0:_this$worker6.setKey({kid:receiverKid,key});case 2:case"end":return _context23.stop();}},_callee23,this);}));function setReceiverEncryptionKey(_x37,_x38){return _setReceiverEncryptionKey.apply(this,arguments);}return setReceiverEncryptionKey;}()/**
   * Remove a receiver
   * @param receiverKid key id of the receiver
   */;_proto4.deleteReceiver=/*#__PURE__*/function(){var _deleteReceiver=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee24(receiverKid){var _this$worker7;return _regenerator.default.wrap(function _callee24$(_context24){while(1)switch(_context24.prev=_context24.next){case 0:_context24.next=2;return(_this$worker7=this.worker)==null?void 0:_this$worker7.removeKey(receiverKid);case 2:case"end":return _context24.stop();}},_callee24,this);}));function deleteReceiver(_x39){return _deleteReceiver.apply(this,arguments);}return deleteReceiver;}()/**
   * Encrypt a stream
   * @param receiverKid key id of the receiver
   * @param sender Sender to encrypt
   */;_proto4.encrypt=/*#__PURE__*/function(){var _encrypt=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee25(kid,sender){return _regenerator.default.wrap(function _callee25$(_context25){while(1)switch(_context25.prev=_context25.next){case 0:return _context25.abrupt("return",this.createPipeline(kid,sender,"encrypt"));case 1:case"end":return _context25.stop();}},_callee25,this);}));function encrypt(_x40,_x41){return _encrypt.apply(this,arguments);}return encrypt;}()/**
   * Encrypt a stream
   * @param receiverKid key id of the receiver
   * @param receiver Receiver to encrypt
   */;_proto4.decrypt=/*#__PURE__*/function(){var _decrypt=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee26(kid,receiver){return _regenerator.default.wrap(function _callee26$(_context26){while(1)switch(_context26.prev=_context26.next){case 0:return _context26.abrupt("return",this.createPipeline(kid,receiver,"decrypt"));case 1:case"end":return _context26.stop();}},_callee26,this);}));function decrypt(_x42,_x43){return _decrypt.apply(this,arguments);}return decrypt;}()/**
   * Bind stream transformation pipeline based on supported feature
   * @internal
   */;_proto4.createPipeline=/*#__PURE__*/function(){var _createPipeline=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee27(kid,streamable,type){var _streamable$track;var _this$worker8,_streamable$createEnc,readable,writable,_this$worker9,_streamable$track2,_streamable$track3,worker,_this$worker10,_this$worker11;return _regenerator.default.wrap(function _callee27$(_context27){while(1)switch(_context27.prev=_context27.next){case 0:if(!(((_streamable$track=streamable.track)==null?void 0:_streamable$track.kind)==="audio")){_context27.next=3;break;}_context27.next=3;return this.setDtxFromCodecs(streamable);case 3:if(!streamable.createEncodedStreams){_context27.next=18;break;}_context27.next=6;return this.updateWorkerWithParameters(streamable.getParameters());case 6:_context27.prev=6;_streamable$createEnc=streamable.createEncodedStreams(),readable=_streamable$createEnc.readable,writable=_streamable$createEnc.writable;_context27.next=10;return(_this$worker8=this.worker)==null?void 0:_this$worker8[type](kid,readable,writable);case 10:_context27.next=16;break;case 12:_context27.prev=12;_context27.t0=_context27["catch"](6);console.error("Fail to retrieve streams",_context27.t0);throw _context27.t0;case 16:_context27.next=44;break;case 18:if(!window.RTCRtpScriptTransform){_context27.next=43;break;}worker=(_this$worker9=this.worker)==null?void 0:_this$worker9.workerContext.worker;streamable.transform=new window.RTCRtpScriptTransform(worker,{type,id:kid});if(!(((_streamable$track2=streamable.track)==null?void 0:_streamable$track2.kind)==="audio")){_context27.next=26;break;}_context27.next=24;return this._setCodecs(Codec.OPUS);case 24:_context27.next=41;break;case 26:if(!(((_streamable$track3=streamable.track)==null?void 0:_streamable$track3.kind)==="video")){_context27.next=41;break;}_context27.prev=27;_context27.next=30;return(_this$worker10=this.worker)==null?void 0:_this$worker10.setIgnoreCodecErrors(true);case 30:_context27.next=32;return this.setCodecsFromStats(streamable);case 32:_context27.next=37;break;case 34:_context27.prev=34;_context27.t1=_context27["catch"](27);throw _context27.t1;case 37:_context27.prev=37;_context27.next=40;return(_this$worker11=this.worker)==null?void 0:_this$worker11.setIgnoreCodecErrors(false);case 40:return _context27.finish(37);case 41:_context27.next=44;break;case 43:throw"Unsupported stream processing";case 44:case"end":return _context27.stop();}},_callee27,this,[[6,12],[27,34,37,41]]);}));function createPipeline(_x44,_x45,_x46){return _createPipeline.apply(this,arguments);}return createPipeline;}()/**
   * Destructor
   * Must be call whenever the Client won't be use anymore
   */;_proto4.close=/*#__PURE__*/function(){var _close=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee28(){var _this$worker12;return _regenerator.default.wrap(function _callee28$(_context28){while(1)switch(_context28.prev=_context28.next){case 0:_context28.next=2;return(_this$worker12=this.worker)==null?void 0:_this$worker12.terminate();case 2:case"end":return _context28.stop();}},_callee28,this);}));function close(){return _close.apply(this,arguments);}return close;}();_proto4._setCodecs=/*#__PURE__*/function(){var _setCodecs2=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee29(audioCodec,videoCodec){var _this$worker13;return _regenerator.default.wrap(function _callee29$(_context29){while(1)switch(_context29.prev=_context29.next){case 0:_context29.next=2;return(_this$worker13=this.worker)==null?void 0:_this$worker13.setCodecs(audioCodec,videoCodec);case 2:case"end":return _context29.stop();}},_callee29,this);}));function _setCodecs(_x47,_x48){return _setCodecs2.apply(this,arguments);}return _setCodecs;}()/**
   * Specify which codec is use by the connection
   * @param audio Audio codec
   * @param video Video codec
   */;_proto4.setCodecs=/*#__PURE__*/function(){var _setCodecs3=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee30(audio,video){var audioCodec,videoCodec;return _regenerator.default.wrap(function _callee30$(_context30){while(1)switch(_context30.prev=_context30.next){case 0:audioCodec=audio;videoCodec=audio;_context30.next=4;return this._setCodecs(audioCodec,videoCodec);case 4:case"end":return _context30.stop();}},_callee30,this);}));function setCodecs(_x49,_x50){return _setCodecs3.apply(this,arguments);}return setCodecs;}();_proto4.setCodecsFromStats=/*#__PURE__*/function(){var _setCodecsFromStats=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee35(streamable){var getVideoCodec,pollUntilCodecAvailable,videoCodec;return _regenerator.default.wrap(function _callee35$(_context35){while(1)switch(_context35.prev=_context35.next){case 0:getVideoCodec=/*#__PURE__*/function(){var _ref8=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee32(){var stats,videoCodec2;return _regenerator.default.wrap(function _callee32$(_context32){while(1)switch(_context32.prev=_context32.next){case 0:_context32.next=2;return streamable.getStats();case 2:stats=_context32.sent;videoCodec2=void 0;stats.forEach(/*#__PURE__*/function(){var _ref9=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee31(report){return _regenerator.default.wrap(function _callee31$(_context31){while(1)switch(_context31.prev=_context31.next){case 0:if(report.type==="codec"){if(report.mimeType.includes("video")){videoCodec2=getCodecFromMimeType(report.mimeType);}}case 1:case"end":return _context31.stop();}},_callee31);}));return function(_x52){return _ref9.apply(this,arguments);};}());return _context32.abrupt("return",videoCodec2);case 6:case"end":return _context32.stop();}},_callee32);}));return function getVideoCodec(){return _ref8.apply(this,arguments);};}();pollUntilCodecAvailable=/*#__PURE__*/function(){var _ref10=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee34(timeout){var startTime,resolve,reject,promise,poll;return _regenerator.default.wrap(function _callee34$(_context34){while(1)switch(_context34.prev=_context34.next){case 0:if(timeout===void 0){timeout=POLL_GET_STATS_TIMEOUT;}startTime=performance.now();promise=new Promise((res,rej)=>{resolve=res;reject=rej;});poll=/*#__PURE__*/function(){var _ref11=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee33(){var codec;return _regenerator.default.wrap(function _callee33$(_context33){while(1)switch(_context33.prev=_context33.next){case 0:_context33.prev=0;_context33.next=3;return getVideoCodec();case 3:codec=_context33.sent;if(!(codec!==void 0)){_context33.next=6;break;}return _context33.abrupt("return",resolve(codec));case 6:_context33.next=11;break;case 8:_context33.prev=8;_context33.t0=_context33["catch"](0);reject(_context33.t0);case 11:if(performance.now()-startTime>timeout){reject(new Error("Timeout: receiver codec not found in stats"));}setTimeout(()=>poll(),100);case 13:case"end":return _context33.stop();}},_callee33,null,[[0,8]]);}));return function poll(){return _ref11.apply(this,arguments);};}();poll();return _context34.abrupt("return",promise);case 6:case"end":return _context34.stop();}},_callee34);}));return function pollUntilCodecAvailable(_x53){return _ref10.apply(this,arguments);};}();_context35.next=4;return pollUntilCodecAvailable();case 4:videoCodec=_context35.sent;_context35.next=7;return this._setCodecs(void 0,videoCodec);case 7:case"end":return _context35.stop();}},_callee35,this);}));function setCodecsFromStats(_x51){return _setCodecsFromStats.apply(this,arguments);}return setCodecsFromStats;}();_proto4.setDtxFromCodecs=/*#__PURE__*/function(){var _setDtxFromCodecs=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee36(streamable){var _this$worker14;var getDtxState,isDtxEnabled;return _regenerator.default.wrap(function _callee36$(_context36){while(1)switch(_context36.prev=_context36.next){case 0:getDtxState=()=>{const parameters=streamable.getParameters();const codecs=parameters.codecs;return codecs.some(codec=>{var _codec$sdpFmtpLine;const mime=codec.mimeType.toLowerCase();return mime.includes("opus")&&((_codec$sdpFmtpLine=codec.sdpFmtpLine)==null?void 0:_codec$sdpFmtpLine.includes("usedtx=1"));});};isDtxEnabled=getDtxState();_context36.next=4;return(_this$worker14=this.worker)==null?void 0:_this$worker14.setDtxEnabled(isDtxEnabled);case 4:case"end":return _context36.stop();}},_callee36,this);}));function setDtxFromCodecs(_x54){return _setDtxFromCodecs.apply(this,arguments);}return setDtxFromCodecs;}()/**
   * @internal
   */;_proto4.updateWorkerWithParameters=/*#__PURE__*/function(){var _updateWorkerWithParameters=(0,_asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee37(parameters){var payloadTypes;return _regenerator.default.wrap(function _callee37$(_context37){while(1)switch(_context37.prev=_context37.next){case 0:if(this.worker){_context37.next=2;break;}throw"Client not initialized, missing worker";case 2:if(!(parameters.codecs.length===0)){_context37.next=4;break;}throw"Empty codecs list, ensure your connection are in a proper state";case 4:payloadTypes=this.getPayloadTypesFromCodecs(parameters.codecs);_context37.next=7;return this.worker.addPayloadTypes(payloadTypes);case 7:case"end":return _context37.stop();}},_callee37,this);}));function updateWorkerWithParameters(_x55){return _updateWorkerWithParameters.apply(this,arguments);}return updateWorkerWithParameters;}()/**
   * @internal
   */;_proto4.getPayloadTypesFromCodecs=function getPayloadTypesFromCodecs(codecs){const result={};for(var _iterator39=_createForOfIteratorHelperLoose(codecs),_step39;!(_step39=_iterator39()).done;){const codec=_step39.value;codec.mimeType.toLowerCase();const payloadType=getCodecFromMimeType(codec.mimeType);if(payloadType!==void 0){result[codec.payloadType]=payloadType;}}return result;};return Client;}(/*#__PURE__*/(0,_wrapNativeSuper2.default)(EventTarget));exports.Client=Client;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(24), "/", __webpack_require__(225).Buffer))

/***/ }),
/* 822 */
/***/ (function(module, exports) {



/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
// Normalizes CrytoKey by either passing it through (e.g., if already an array
// buffer or an invalid type) or casts it to an array buffer
const normalizeKey = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(key) {
    var _window, _window2;
    var exportedKey;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (key instanceof ((_window = window) == null ? void 0 : _window.CryptoKey)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", key);
        case 2:
          _context.next = 4;
          return (_window2 = window) == null ? void 0 : _window2.crypto.subtle.exportKey('raw', key);
        case 4:
          exportedKey = _context.sent;
          return _context.abrupt("return", new Uint8Array(exportedKey));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function normalizeKey(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = normalizeKey;
exports.default = _default;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _arrayRemoveItem = _interopRequireDefault(__webpack_require__(825));
var _peer_connection = _interopRequireDefault(__webpack_require__(75));
var _subscriberPeerConnectionQueue = _interopRequireDefault(__webpack_require__(826));
var _peerConnectionSDP = _interopRequireDefault(__webpack_require__(827));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _waitUntil = _interopRequireDefault(__webpack_require__(337));
const PeerConnectionDefault = (0, _peer_connection.default)();
const waitUntil = (0, _waitUntil.default)();
let SinglePeerConnectionController = /*#__PURE__*/function () {
  function SinglePeerConnectionController(session, deps) {
    if (deps === void 0) {
      deps = {};
    }
    this.createPeerConnectionSDP = deps.createPeerConnectionSDP || _peerConnectionSDP.default;
    this._session = session;
    this.PeerConnection = deps.PeerConnection || PeerConnectionDefault;
    this.sdpHelpers = deps.helpers || _sdp_helpers.default;
    this.createSubscriberPeerConnectionQueue = deps.createSubscriberPeerConnectionQueue || _subscriberPeerConnectionQueue.default;
    // Allocate 1s to allow peer connections to close by default. When no all PCs have been closed,
    // we are safe to timeout since remaining PCs disconnection will be noop.
    this._drainTimeout = deps.drainTimeout || 1000;
    this._init();
  }
  var _proto = SinglePeerConnectionController.prototype;
  _proto._init = function _init() {
    this._reset();
  };
  _proto._reset = function _reset() {
    this._originalSendMessages = {};
    this._tracks = [];
    this._currentAndPreviousMids = [];
    this._subscriberPcs = {};
    this._peerConnectionSDP = this.createPeerConnectionSDP({
      logEvent: this._session.logEvent
    });
    this._subscriberQueue = this.createSubscriberPeerConnectionQueue();
    this._subscriberPcsToAdd = [];
    this._sendMessage = () => {};
    if (this._peerConnection) {
      this._peerConnection.disconnect();
      this._peerConnection = null;
    }
  };
  _proto._parseOptions = function _parseOptions(options) {
    return Object.assign({}, options, {
      // Create only one RTCDtlsTransport
      bundlePolicy: 'max-bundle',
      // We always remove unused codecs after iceRestart in SPC
      removeUnusedCodecs: true,
      sendMessage: (type, payload) => {
        const content = Object.assign({}, payload);
        if (content.sdp) {
          const partialSdp = this._peerConnectionSDP.getPartialSdp(type, content.sdp);
          content.sdp = partialSdp;
        }
        const completion = this._createSendMessageErrorHandler(type, content);
        const _this$_subscriberPcsT = this._subscriberPcsToAdd,
          pendingSubscriberPc = _this$_subscriberPcsT[0];
        const send = this._originalSendMessages[pendingSubscriberPc == null ? void 0 : pendingSubscriberPc._id] || this._sendMessage;
        send(type, content, completion);
        if (type === 'answer') {
          this._subscriberPcsToAdd.shift();
          // We only send an answer when Mantis previously sent an offer, i.e. we added a new
          // subscriber. Therefore at this point we can consider the negotiation done.
          this.subscriberComplete();
        }
      }
    });
  };
  _proto._addListeners = function _addListeners() {
    if (!this._peerConnection) {
      return;
    }

    // override the trackAdded listener so we can route the tracks to the proper subscriber.
    this._peerConnection.on('trackAdded', _ref => {
      let track = _ref.track,
        transceiver = _ref.transceiver;
      const _this$_subscriberPcsT2 = this._subscriberPcsToAdd,
        subscriberPc = _this$_subscriberPcsT2[0];
      if (!subscriberPc || this._currentAndPreviousMids.includes(transceiver.mid)) {
        return;
      }
      // We store all tracks per Subscriber.
      this._subscriberPcs[subscriberPc._id].push(track.id);
      // Also store all tracks per SinglePeerConnection
      this._tracks.push(track.id);
      this._currentAndPreviousMids.push(transceiver.mid);
      subscriberPc.onTrackAdded({
        track,
        transceiver
      });
    });
  };
  _proto._removeMessageSender = function _removeMessageSender(subscriberPcId) {
    delete this._originalSendMessages[subscriberPcId];
    this._sendMessage = this._getLatestSendMessage();
  };
  _proto._generateOffer = /*#__PURE__*/function () {
    var _generateOffer2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(resolve => {
              const createAnswer = () => {
                const answer = this._peerConnectionSDP.createSdp();
                this._peerConnection.processMessage('answer', {
                  content: {
                    sdp: answer
                  }
                });
                resolve();
              };
              this._peerConnection.generateOffer(createAnswer);
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function _generateOffer() {
      return _generateOffer2.apply(this, arguments);
    }
    return _generateOffer;
  }();
  _proto._removeSubscriber = function _removeSubscriber(subscriberPcId) {
    delete this._subscriberPcs[subscriberPcId];
    this._removeMessageSender(subscriberPcId);
  };
  _proto._stopTransceivers = function _stopTransceivers(transceiverIds) {
    // Update the saved remote description.
    this._peerConnectionSDP.removeMids(transceiverIds);
    // Stop transceivers in local description.
    this._peerConnection.stopTransceivers(transceiverIds);
  };
  _proto._setTransceiverToInactive = function _setTransceiverToInactive(transceiverId) {
    // Update the saved remote description.
    this._peerConnectionSDP.setTrackToInactive(transceiverId);
    // Set transceivers to inactive in local description.
    this._peerConnection.setTransceiversToInactive([transceiverId]);
  };
  _proto._getLatestSendMessage = function _getLatestSendMessage() {
    const _Object$values$slice = Object.values(this._originalSendMessages).slice(-1),
      sendMessage = _Object$values$slice[0];
    return sendMessage || function () {};
  };
  _proto._createSendMessageErrorHandler = function _createSendMessageErrorHandler(type, content) {
    const handler = (error, message) => {
      // If the corresponding stream does not longer exist, we are going to try using
      // another sendMessage.
      if (error && (message == null ? void 0 : message.status) === '404') {
        const subscriberPcIds = Object.keys(this._originalSendMessages);
        if (subscriberPcIds.length) {
          const subscriberPcId = subscriberPcIds.find(subPcId => this._originalSendMessages[subPcId] === this._sendMessage);
          // We delete this sendMessage because its correponding stream doesn't exist.
          this._removeMessageSender(subscriberPcId);
          // We try to send the message again.
          this._sendMessage(type, content, handler);
        }
      }
    };
    return handler;
  }

  // Singleton to make sure we are using only one PC when SPC. If SPC, we will add Subscriber
  // specific options to handle analytics and negotiation per Subscriber. This will take care
  // to send the answer back to Rumor by its respective Subscriber and not multiple answers.
  // It will instantiate a new regular PC for all other cases.
  ;
  _proto.getPeerConnection = function getPeerConnection(opt, subscriberPc) {
    this._subscriberPcsToAdd.push(subscriberPc);
    this._sendMessage = opt.sendMessage;
    this._originalSendMessages[subscriberPc._id] = this._sendMessage;
    if (this._peerConnection) {
      this._peerConnection.addOptions(opt);
    } else {
      const parsedOptions = this._parseOptions(opt);
      this._peerConnection = new this.PeerConnection(parsedOptions);

      // Add listeners, which will take care all the tracks for all the subs and if any
      // negotiation needed.
      this._addListeners();
    }
    this._subscriberPcs[subscriberPc._id] = [];
    return this._peerConnection;
  };
  _proto.removeSubscriber = function removeSubscriber(subscriberPcId, transceiversIds) {
    var _this = this;
    this._subscriberQueue.enqueue( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var transceiversIdsToStop, isHeadMid, headMid;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            transceiversIdsToStop = transceiversIds;
            isHeadMid = _this._peerConnectionSDP.isHead(subscriberPcId); // Remove the subscriber at controller level.
            _this._removeSubscriber(subscriberPcId);
            if (Object.keys(_this._subscriberPcs).length) {
              _context2.next = 6;
              break;
            }
            // Reset all components since we have no subscriber left. Then return,
            // nothing else to do here.
            _this._reset();
            return _context2.abrupt("return");
          case 6:
            // Remove the subscriber from the PC. If the corresponding media section isn't the first mSection,
            // this section won't own the credentials for the PC, thus we are safe to stop transceiver and remove it.
            // However if the media section is first in the SDP, it will own the credentials, so we set it to inactive instead of removing it.
            // This will prevent an iceRestart.
            if (isHeadMid) {
              headMid = _this._peerConnectionSDP.getHeadMid();
              _this._setTransceiverToInactive(headMid);
              transceiversIdsToStop = transceiversIds.filter(id => id !== headMid);
            }
            _this._stopTransceivers(transceiversIdsToStop);
            _context2.next = 10;
            return _this._generateOffer();
          case 10:
            _this._subscriberQueue.dequeueAndProcessNext();
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
  };
  _proto.generateOfferWithIceRestart = function generateOfferWithIceRestart() {
    this._peerConnection.iceRestart();
    this._peerConnection.generateOfferAndSend();
  };
  _proto.removeTrack = function removeTrack(track, subscriberPcId) {
    const trackId = track == null ? void 0 : track.id;
    if (trackId) {
      (0, _arrayRemoveItem.default)(this._tracks, trackId);
      (0, _arrayRemoveItem.default)(this._subscriberPcs[subscriberPcId] || [], trackId);
    }
  };
  _proto.destroy = function destroy() {
    this._reset();
    this._session = null;
  };
  _proto.addSubscriber = function addSubscriber(subscriberCreate) {
    this._subscriberQueue.enqueue(subscriberCreate);
  };
  _proto.addSubscriberMid = function addSubscriberMid(mid, subscriberPcId) {
    this._peerConnectionSDP.addSubscriberMid(mid, subscriberPcId);
  };
  _proto.subscriberComplete = function subscriberComplete() {
    this._subscriberQueue.dequeueAndProcessNext();
  };
  _proto.processAnswer = function processAnswer(sdp) {
    return this._peerConnectionSDP.processAnswer(sdp);
  };
  _proto.processOffer = /*#__PURE__*/function () {
    var _processOffer = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(sdp) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", this._peerConnectionSDP.processOffer(sdp));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function processOffer(_x) {
      return _processOffer.apply(this, arguments);
    }
    return processOffer;
  }();
  _proto.closeAfterSubscriberRemovals = /*#__PURE__*/function () {
    var _closeAfterSubscriberRemovals = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return waitUntil(() => Object.keys(this._subscriberPcs).length === 0, {
              timeout: this._drainTimeout
            });
          case 3:
            _context4.next = 7;
            break;
          case 5:
            _context4.prev = 5;
            _context4.t0 = _context4["catch"](0);
          case 7:
            this.destroy();
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this, [[0, 5]]);
    }));
    function closeAfterSubscriberRemovals() {
      return _closeAfterSubscriberRemovals.apply(this, arguments);
    }
    return closeAfterSubscriberRemovals;
  }();
  return SinglePeerConnectionController;
}();
var _default = SinglePeerConnectionController;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
const removeItem = (array, itemToRemove) => {
  array.forEach((item, index) => {
    const itemId = item.id || item;
    const itemToRemoveId = itemToRemove.id || itemToRemove;
    if (itemId === itemToRemoveId) {
      array.splice(index, 1);
    }
  });
};
var _default = removeItem;
exports.default = _default;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
/* eslint-disable no-underscore-dangle */
const finalTaskDelay = 100;
const createSubscriberPeerConnectionQueue = () => {
  const queue = [];
  let isProcessing = false;
  let timeoutId;
  let finalTask;
  const processFinalTaskWithDelay = () => {
    timeoutId = setTimeout(() => {
      timeoutId = undefined;
      isProcessing = true;
      finalTask();
      finalTask = undefined;
    }, finalTaskDelay);
  };
  const enqueue = task => {
    if (isProcessing) {
      queue.push(task);
    } else {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      isProcessing = true;
      task();
    }
  };
  const finallyTask = task => {
    finalTask = task;
    if (isProcessing) {
      return;
    }
    if (timeoutId) {
      // do nothing, we have updated the finalTask but we need not extend the time
      return;
    }
    processFinalTaskWithDelay();
  };
  const dequeueAndProcessNext = () => {
    const nextProcess = queue.shift();
    if (nextProcess) {
      nextProcess();
    } else {
      if (finalTask) {
        processFinalTaskWithDelay();
      }
      isProcessing = false;
    }
  };
  return {
    enqueue,
    finally: finallyTask,
    dequeueAndProcessNext
  };
};
var _default = createSubscriberPeerConnectionQueue;
exports.default = _default;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _difference = _interopRequireDefault(__webpack_require__(362));
var _getPartialSdpAnswer = _interopRequireDefault(__webpack_require__(829));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _getPartialIceRestartSdpOffer = _interopRequireDefault(__webpack_require__(830));
var _getFullRemoteSdp = _interopRequireDefault(__webpack_require__(831));
const createPeerConnectionSDP = function createPeerConnectionSDP(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const logEvent = deps.logEvent;
  const sdpHelpers = deps.helpers || _sdp_helpers.default;
  const getFullRemoteSdp = deps.getFullRemoteSdp || (0, _getFullRemoteSdp.default)();
  const peerConnectionSDP = {
    sdp: {
      mids: [],
      mediaSections: [],
      headers: [],
      bundle: null,
      version: null,
      tracks: [],
      iceCredentials: {}
    },
    subscribePcIdsByMid: {},
    updateParsedSdp(sdp) {
      Object.assign(this.sdp, sdp);
    },
    updateSdpWithNewOffer(sdp) {
      const parsedSdp = sdpHelpers.updateSDPWithNewOffer({
        mediaSections: this.sdp.mediaSections,
        headers: this.sdp.headers,
        version: this.sdp.version
      }, sdp.sdp);
      Object.assign(this.sdp, parsedSdp);
    },
    setOfferAndCreateAnswer(offer) {
      this.updateSdpWithNewOffer(offer);
      return sdpHelpers.createSDP(this.sdp.headers, this.sdp.mediaSections);
    },
    createSdp() {
      return sdpHelpers.createSDP(this.sdp.headers, this.sdp.mediaSections);
    },
    addSubscriberMid(mid, subscriberPcId) {
      this.subscribePcIdsByMid[mid] = subscriberPcId;
    },
    removeMidAndTrack(mid) {
      this.sdp.tracks = this.sdp.tracks.filter(track => track !== mid);
      const index = this.sdp.mids.findIndex(m => m === mid);
      if (index < 0) {
        return;
      }
      this.sdp.mids[index] = null;

      // Disable mediaSection for mid
      this.sdp.mediaSections[index] = sdpHelpers.getDisabledSectionForMid(mid);
    },
    updateSdpHeaders() {
      // We only update headers when removing tracks with no iceRestart. Thus no new ice
      // credentials. Every time headers are updated, it is a new version
      const newVersion = this.sdp.version + 1;
      this.sdp.headers = sdpHelpers.updateVersion(this.sdp.headers, this.sdp.version, newVersion);
      this.sdp.version = newVersion;

      // Update bundle with the current tracks
      this.sdp.headers = sdpHelpers.updateBundleLine(this.sdp.headers, this.sdp.tracks);
      this.sdp.bundle = sdpHelpers.getBundleLine(this.sdp.headers);
    },
    processAnswer(newSdp) {
      // In order to prevent a media sections mismatch with Mantis, we extract the minimum
      // information from Mantis answer:
      //  - version
      //  - iceCredentials
      //  - first enabled media section
      // We need iceCredentials because they are new and we don't have them, and we also need the
      // first enabled media section because is one containing the credentials. Once gathered, we
      // update the cached SDP with this new information.
      const _sdpHelpers$parseMant = sdpHelpers.parseMantisSDP(newSdp),
        version = _sdpHelpers$parseMant.version,
        tracks = _sdpHelpers$parseMant.tracks,
        iceCredentials = _sdpHelpers$parseMant.iceCredentials;
      const missingMids = (0, _difference.default)(this.sdp.tracks, tracks);
      if (missingMids.length) {
        logEvent('peerConnection:spcAnswerMismatch', 'Event', missingMids);
      }
      const updatedHeaders = sdpHelpers.updateVersion(this.sdp.headers, this.sdp.version, version);
      this.sdp.version = version;
      this.sdp.headers = sdpHelpers.updateIceCredentials(updatedHeaders, iceCredentials);
      this.sdp.iceCredentials = iceCredentials;
      this.sdp.mediaSections = sdpHelpers.updateFirstEnabledMediaSection(this.sdp, iceCredentials);
      return sdpHelpers.createSDP(this.sdp.headers, this.sdp.mediaSections);
    },
    getPartialSdpAnswer(newAnswer) {
      if (!this.midsToAdd) {
        return newAnswer;
      }
      const partialSdp = (0, _getPartialSdpAnswer.default)(sdpHelpers.parseSDP(newAnswer), this.midsToAdd);
      this.midsToAdd = undefined;
      return sdpHelpers.createSDP(partialSdp.headers, partialSdp.mediaSections);
    },
    getIceRestartPartialSdp(newOffer) {
      const partialSdp = (0, _getPartialIceRestartSdpOffer.default)(sdpHelpers.parseSDP(newOffer));
      return sdpHelpers.createSDP(partialSdp.headers, partialSdp.mediaSections);
    },
    getPartialSdp(type, fullSdp) {
      if (type === 'answer') {
        return this.getPartialSdpAnswer(fullSdp);
      }
      return this.getIceRestartPartialSdp(fullSdp);
    },
    processOffer(sdp) {
      const parsedRemoteSdp = sdpHelpers.parseMantisSDP(sdp);
      const missingMids = (0, _difference.default)(this.sdp.tracks, parsedRemoteSdp.tracks);
      if (missingMids.length !== 0) {
        logEvent('peerConnection:spcOfferMismatch', 'Event', missingMids);
      }

      // Add only mids that are not currently present in the cached SDP.
      this.midsToAdd = (0, _difference.default)(parsedRemoteSdp.mids, this.sdp.mids);
      const fullSdp = getFullRemoteSdp('offer', parsedRemoteSdp, this.sdp);
      this.updateParsedSdp(fullSdp);
      return sdpHelpers.createSDP(fullSdp.headers, fullSdp.mediaSections);
    },
    removeMids(mids) {
      mids.forEach(mid => {
        this.removeMidAndTrack(mid);
        delete this.subscribePcIdsByMid[mid];
      });
      this.updateSdpHeaders();
    },
    setTrackToInactive(mid) {
      const index = this.sdp.mids.findIndex(m => m === mid);
      this.sdp.mediaSections[index] = sdpHelpers.setSubscriberMediaSectionToInactive(this.sdp.mediaSections[index]);
    },
    getHeadMid() {
      return this.sdp.mids.find(mid => mid !== null);
    },
    isHead(subscriberPcId) {
      const headMid = this.getHeadMid();
      return this.subscribePcIdsByMid[headMid] === subscriberPcId;
    }
  };
  return peerConnectionSDP;
};
var _default = createPeerConnectionSDP;
exports.default = _default;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(101),
    arrayIncludes = __webpack_require__(99),
    arrayIncludesWith = __webpack_require__(150),
    arrayMap = __webpack_require__(38),
    baseUnary = __webpack_require__(68),
    cacheHas = __webpack_require__(102);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _log = _interopRequireDefault(__webpack_require__(1));
const logging = (0, _log.default)('partialSdp');
/**
 * Construct partialSdp answer with only header and new track media sections
 * @param {ParsedSdp} newAnswer - full local remote answer from the PC
 * @param {Array<string>} newMids - array of mids of tracks added in this operation
 * @returns {ParsedSdp} partialSdp - partialSdp containing only the new headers and
 * the media sections of the new tracks.
 */
const getPartialSdpAnswer = (newAnswer, newMids) => {
  logging.debug('full answer: ', newAnswer);
  const newlyAddedMediaSections = newAnswer.mediaSections.filter(mediaSection => {
    const includesSomeId = newMids.some(mid => {
      const mediaSectionString = mediaSection.join('');
      const hasSection = mediaSectionString.includes(`a=mid:${mid}`);
      return hasSection;
    });
    return includesSomeId;
  });
  const partialAnswer = {
    headers: newAnswer.headers,
    mediaSections: newlyAddedMediaSections
  };
  logging.debug('partial answer: ', partialAnswer);
  return partialAnswer;
};
var _default = getPartialSdpAnswer;
exports.default = _default;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _log = _interopRequireDefault(__webpack_require__(1));
const logging = (0, _log.default)('partialSdp');
/**
 * creates a partialSdp object with header and first mediaSection only
 * @param {ParsedSdp} offer - new remote offer generated by PC
 * @returns partialSdp containing new header and first mediaSection only
 */
const getPartialIceRestartSdpOffer = offer => {
  logging.debug('full offer: ', offer);
  const headMid = offer.mids.find(mid => mid !== null);
  const headMediaSection = offer.mediaSections.find(section => {
    const mediaSectionString = section.join('');
    const isHead = mediaSectionString.includes(`a=mid:${headMid}`);
    return isHead;
  });
  const partialOffer = {
    headers: offer.headers,
    mediaSections: [headMediaSection]
  };
  logging.debug('partial offer: ', partialOffer);
  return partialOffer;
};
var _default = getPartialIceRestartSdpOffer;
exports.default = _default;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _getMediaSectionsForAnswer = _interopRequireDefault(__webpack_require__(832));
var _getMediaSectionsForOffer = _interopRequireDefault(__webpack_require__(833));
var _log = _interopRequireDefault(__webpack_require__(1));
const logging = (0, _log.default)('partialSdp');
const isPartialSdp = sdp => sdp.tracks.length !== sdp.mids.length;
const createGetFullRemoteSdp = function createGetFullRemoteSdp(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const getMediaSectionsForAnswer = deps.getMediaSectionsForAnswer || _getMediaSectionsForAnswer.default;
  const getMediaSectionsForOffer = deps.getMediaSectionsForOffer || _getMediaSectionsForOffer.default;
  const getFullSdpFromPartial = (type, partialSdp, currentSdp) => {
    const isAnswer = type === 'answer';
    const version = Math.max(partialSdp.version, currentSdp.version || 0);
    const getMediaSections = isAnswer ? getMediaSectionsForAnswer : getMediaSectionsForOffer;
    const mediaSections = getMediaSections(partialSdp, currentSdp);
    const mids = mediaSections.map(_sdp_helpers.default.getSectionMid);
    const tracks = mids.filter(mid => mid !== null);
    let headers;
    if (isAnswer) {
      headers = partialSdp.headers;
    } else {
      // We update the headers so bundle and credentials are the correct ones. Please note bundle
      // can have a different order in Mantis and Client.
      headers = _sdp_helpers.default.updateHeadersInPartialSdp(currentSdp, partialSdp, tracks);
    }
    return {
      headers,
      version,
      bundle: _sdp_helpers.default.createBundleLine(tracks),
      tracks,
      mediaSections,
      mids,
      iceCredentials: partialSdp.iceCredentials
    };
  };
  const getFullRemoteSdp = (type, newRemoteSdp, currentRemoteSdp) => {
    if (!isPartialSdp(newRemoteSdp) && !currentRemoteSdp.bundle) {
      // This is a full SDP and it is the first received. When a full SDP comes after several SDP,
      // we don't return it since we want to merge the cached SDP and this full one. This can
      // happen, e.g., when SDPs come out of order.
      return newRemoteSdp;
    }
    logging.debug('partial remote sdp: ', newRemoteSdp);
    let partialSdp;
    if (currentRemoteSdp.bundle) {
      partialSdp = newRemoteSdp;
    } else {
      // This is a partial SDP, however it is the first one we have received (none cached yet), we
      // may need to add ICE credentials to the first enabled section.
      const mediaSections = newRemoteSdp.mediaSections,
        iceCredentials = newRemoteSdp.iceCredentials,
        headers = newRemoteSdp.headers;
      partialSdp = Object.assign({}, newRemoteSdp, {
        mediaSections: _sdp_helpers.default.addIceConfig(mediaSections, headers, iceCredentials)
      });
    }
    return getFullSdpFromPartial(type, partialSdp, currentRemoteSdp);
  };
  return getFullRemoteSdp;
};
var _default = createGetFullRemoteSdp;
exports.default = _default;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
/**
 * Construct the full SDP media section array  combining the mantis partial answer and current local description
 * @param {*} partialRemoteAnswer - partial answer SDP from mantis
 * @param {*} currentRemoteDescription - current remote description on PC
 * @returns {Array<Array<string>>} - An array of mediaSection arrays
 */
const getMediaSectionsForAnswer = (partialRemoteAnswer, currentRemoteDescription) => {
  // This is an answer to our ICE restart offer, so the head media section has changed
  const newHeadMid = partialRemoteAnswer.mids[0];
  const tracksToDisable = currentRemoteDescription.tracks.slice(0, currentRemoteDescription.tracks.indexOf(newHeadMid)).filter(mid => mid !== null);
  const newHeadIndex = currentRemoteDescription.mids.indexOf(newHeadMid);
  // Any tracks in the SDP before the new head must be disabled
  const disabledMediaSections = currentRemoteDescription.mediaSections.slice(0, newHeadIndex).map(section => {
    const _SDPHelpers$getTrackM = _sdp_helpers.default.getTrackMids(section),
      mid = _SDPHelpers$getTrackM[0];
    if (mid && tracksToDisable.includes(mid)) {
      return _sdp_helpers.default.getDisabledSectionForMid(mid);
    }
    return section;
  });

  // We construct the new media section using first the new disabled section,
  // then the updated head section, then append the rest which stay the same
  const fullMediaSections = [...disabledMediaSections, ...partialRemoteAnswer.mediaSections, ...currentRemoteDescription.mediaSections.slice(newHeadIndex + 1)];
  return fullMediaSections;
};
var _default = getMediaSectionsForAnswer;
exports.default = _default;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
/**
 * Reconstructs the media section array for the full remote offer SDP from mantis
 * from a partial offer by combining it with the current remote description
 * @param {ParsedSdp} partialRemoteOffer
 * @param {ParsedSdp} currentRemoteDescription
 * @returns SDP in string format
 */
const getMediaSectionsForOffer = (partialRemoteOffer, currentRemoteDescription) => {
  const currentMediaSections = currentRemoteDescription.mediaSections.map(section => [...section]);
  // m-line recycling:  Iterate through current media sections and add new media sections into disabled slots
  // if not disabled slots then append media section to array
  let currentMediaSectionIndex = 0;
  partialRemoteOffer.mediaSections.forEach(mediaSection => {
    for (currentMediaSectionIndex; currentMediaSectionIndex < currentMediaSections.length; currentMediaSectionIndex++) {
      const currentMediaSection = currentMediaSections[currentMediaSectionIndex];
      if (_sdp_helpers.default.isDisabledMediaSection(currentMediaSection)) {
        currentMediaSections[currentMediaSectionIndex] = mediaSection;
        return;
      }
    }
    currentMediaSections.push(mediaSection);
  });
  return currentMediaSections;
};
var _default = getMediaSectionsForOffer;
exports.default = _default;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(23));
var _events = _interopRequireDefault(__webpack_require__(12));
const OBSERVER_INTERVAL = 2 * 1000;

// PressureObserver is currently on supported on recent Chromium browsers
// (Chrome 125+, Edge 125+, and Opera 111+).
// See https://developer.mozilla.org/en-US/docs/Web/API/Compute_Pressure_API &
// https://developer.chrome.com/docs/web-platform/compute-pressure
let CpuPressureMonitor = /*#__PURE__*/function (_EventEmitter) {
  (0, _inheritsLoose2.default)(CpuPressureMonitor, _EventEmitter);
  function CpuPressureMonitor() {
    return _EventEmitter.apply(this, arguments) || this;
  }
  var _proto = CpuPressureMonitor.prototype;
  _proto.initMonitoring = function initMonitoring(PressureObserver) {
    const pressureChangeCallback = pressureRecordArray => {
      const currentState = pressureRecordArray[pressureRecordArray.length - 1].state;
      this.emit('pressureMonitorEvent', currentState);
    };
    if (PressureObserver) {
      this._observer = new PressureObserver(pressureChangeCallback);
    }
  };
  _proto.startMonitoring = /*#__PURE__*/function () {
    var _startMonitoring = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!this._isMonitoring) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return this._observer.observe('cpu', {
              sampleInterval: OBSERVER_INTERVAL
            });
          case 5:
            _context.next = 9;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
          case 9:
            this._isMonitoring = true;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[2, 7]]);
    }));
    function startMonitoring() {
      return _startMonitoring.apply(this, arguments);
    }
    return startMonitoring;
  }();
  _proto.stopMonitoring = function stopMonitoring() {
    this._isMonitoring = false;
    this._observer.unobserve('cpu');
  };
  return CpuPressureMonitor;
}(_events.default);
var _default = CpuPressureMonitor;
exports.default = _default;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var _default = 20000;
exports.default = _default;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = initSessionFactory;
var _objects = _interopRequireDefault(__webpack_require__(27));
var _index = _interopRequireDefault(__webpack_require__(350));
// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign, global-require */

function initSessionFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const Session = deps.Session || (0, _index.default)();
  const sessionObjects = deps.sessionObjects || _objects.default;

  /**
  * The first step in using the Vonage Video API is to call the <code>OT.initSession()</code>
  * method. Other methods of the OT object check for system requirements and set up error logging.
  *
  * @class OT
  */

  /**
  * <p class="mSummary">
  * Initializes and returns the local session object for a specified session ID.
  * </p>
  * <p>
  * You connect to a Vonage Video API session using the <code>connect()</code> method
  * of the Session object returned by the <code>OT.initSession()</code> method.
  * Note that calling <code>OT.initSession()</code> does not initiate communications
  * with the cloud. It simply initializes the Session object that you can use to
  * connect (and to perform other operations once connected).
  * </p>
  *
  * <p>
  * Note that you can initialize only one Session object per session ID. Calling
  * <code>OT.initSession()</code> a second time with the same session ID returns the
  * previously created Session object. However, you can initialize multiple Session objects
  * for different sessions (with different session IDs) to connect to multiple sessions.
  * </p>
  *
  * <p>
  * When the client disconnects from the session (and the session dispatches a
  * <code>sessionDisconnected</code> event), you can reuse the Session object to
  * reconnect to the session. However, the Session object will retain any existing
  * event handlers attached to it. You can remove all event handlers by calling the
  * <code>off()</code> method of the Session object (passing in no parameters).
  * </p>
  *
  *  <p>
  *    For an example, see <a href="Session.html#connect">Session.connect()</a>.
  *  </p>
  *
  * @method OT.initSession
  * @memberof OT
  * @param {String} apiKey Your Vonage Video API key (see your <a href="https://tokbox.com/account">Vonage Video API
  * account page</a>).
  * @param {String} sessionId The session ID identifying the Vonage Video API session. For more
  * information, see <a href="https://tokbox.com/developer/guides/create-session/">Session
  * creation</a>.
  * @param {Object} options An object that includes optional options for initializing the session.
  * This object includes the following properties:
  * <ul>
  *   <li><code>connectionEventsSuppressed</code> &mdash; (Boolean)
  *     Set this property to <code>true</code> to support large interactive video sessions.
  *     This prevents the Session object from dispatching <code>connectionCreated</code> and
  *     <code>connectionDestroyed</code> events when other clients connect to or disconnect from
  *     the session. (Also, the Vonage Video API server does not send these events to the web client.)
  *     For more information, see
  *     <a href="https://tokbox.com/developer/guides/broadcast/live-interactive-video/#suppressing-connection-events">
  *     Suppressing connection events</a> in the Vonage Video API developer guides.
  *   </li>
  *   <li><code>ipWhitelist</code> &mdash; (Boolean) This is available as an
  *     <a href="https://www.vonage.com/communications-apis/video/pricing/" target="_blank">add-on feature</a>.
  *     Set this to <code>true</code> if IP white listing is enabled for your project.
  *     The default value is <code>false</code>.
  *   </li>
  *   <li><code>iceConfig</code> &mdash; (Object) This object includes the following properties:
  *    <p>
  *    <ul>
  *     <li>
  *        <code>includeServers</code> (String) &mdash; Set this to <code>'custom'</code> and client will use only the custom TURN servers you provide in the <code>customServers</code> array. Set this to <code>'all'</code> (the default) and the client will use both the custom TURN servers you provide along with OpenTok TURN servers.
  *     </li>
  *     <li>
  *        <code>transportPolicy</code> (String) &mdash; Set this to <code>'all'</code> (the default) and the client will use all ICE transport types (such as host, srflx, and TURN) to establish media connectivity. Set this to <code>'relay'</code> to force connectivity through TURN always and ignore all other ICE candidates.
  *     </li>
  *     <li>
  *        <code>customServers</code> (Array) &mdash; Set this to an array of objects defining your custom TURN servers. Each object corresponds to one custom TURN server, and it includes the following properties: <code>urls</code> &mdash; a string or an array of strings, where each string is a URL supported by the TURN server (and this may be only one URL); <code>username</code> &mdash; the username (string) for the TURN server defined in this object; <code>credential</code> &mdash; the credential string for the TURN server defined in this object.
  *     </li>
  *    </ul>
  *  </p>
  *  <p>
  * This feature is part of the configurable TURN
  *     <a href="https://www.vonage.com/communications-apis/video/pricing/" target="_blank">add-on feature</a>. For more information
  * and a code sample, see the
  * <a href="https://tokbox.com/developer/guides/configurable-turn-servers/">Configurable TURN servers</a>
  * developer guide.
  * </p>
  *   </li>
  *   <li><code>encryptionSecret</code> &mdash; (String) This is the initial encryption secret used by the
  *   end-to-end encryption feature. See <a href="https://tokbox.com/developer/guides/end-to-end-encryption/">
  *   the developer guide</a>.
  *   </li>
  *   <li><code>singlePeerConnection</code> &mdash; (Boolean) Enables the
  *   <a href="https://tokbox.com/developer/guides/create-session/#single-peer-connection">Single Peer Connection</a>
  *   (SPC) feature. The default is <code>false</code> (SPC is disabled).
  *   </li>
  *   <li><code>sessionMigration</code> &mdash; (Boolean) Enables the session migration feature,
  *   allowing the client to to remain connected during server rotation. The default value is <code>false</code>
  *   (session migration is not enabled). For more information, see
  *   <a href="https://tokbox.com/developer/guides/server-rotation/">Server Rotation and Session Migration</a>.
  *   <p>
  *   <i>This is a beta feature.</i>
  *   </p>
  *   </li>
  * </ul>
  *
  * @returns {Session} The session object through which all further interactions with
  * the session will occur.
  */
  return function initSession(apiKey, sessionId, opt) {
    if (sessionId == null) {
      sessionId = apiKey;
      apiKey = null;
    }

    // Allow buggy legacy behavior to succeed, where the client can connect if sessionId
    // is an array containing one element (the session ID), but fix it so that sessionId
    // is stored as a string (not an array):
    if (Array.isArray(sessionId) && sessionId.length === 1) {
      sessionId = sessionId[0];
    }
    let session = sessionObjects.sessions.get(sessionId);
    if (!session) {
      session = new Session(apiKey, sessionId, opt);
      sessionObjects.sessions.add(session);
    }
    return session;
  };
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _difference = _interopRequireDefault(__webpack_require__(362));
var _uniq = _interopRequireDefault(__webpack_require__(299));
var _exception_codes = _interopRequireDefault(__webpack_require__(10));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _env = _interopRequireDefault(__webpack_require__(3));
var _shouldUsePlanBSDP = _interopRequireDefault(__webpack_require__(76));
var _sdp_helpers = _interopRequireDefault(__webpack_require__(19));
var _createWindowMock = _interopRequireDefault(__webpack_require__(155));
const windowMock = (0, _createWindowMock.default)((typeof window !== undefined ? window : global));
const otError = (0, _otError.default)();
function filterCodecList(codecs) {
  // Chromium uses the payload 'AV1X' pre M95 and 'AV1' after
  return (0, _uniq.default)((0, _difference.default)(codecs, ['AV1X', 'AV1', 'rtx', 'red', 'ulpfec', 'H265', 'X-H264UC', 'x-ulpfecuc']));
}

/**
 * Gets the list of supported codecs for encoding and decoding video streams.
 * <p>
 * The following example gets the list of supported codecs for encoding and
 * decoding video streams:
 * <pre>
 * (async () => {
 *   try {
 *     const supportedCodecs = await OT.getSupportedCodecs();
 *     if (supportedCodecs.videoEncoders.indexOf('H264') < 0 &&
 *         supportedCodecs.videoDecoders.indexOf('H264') < 0) {
 *       // The client does not support encoding or decoding H264.
 *       // Let's recommend using a different browser.
 *     }
 *   } catch(err) {
 *     console.log(err);
 *   }
 * })();
 * </pre>
 * <p>
 * You can use the lists of supported video codecs to determine whether the client
 * supports video, depending on the preferred video codec and the type of session being used.
 * You can set the preferred video codec on the Project page of your
 * <a href="https://tokbox.com/account/">Vonage Video API account</a>. In
 * <a href="https://tokbox.com/developer/guides/create-session/#media-mode">routed sessions</a>
 * (sessions that use the Vonage Video API Media Router), the preferred video codec is used for all
 * clients in the session. In relayed sessions, clients send streams directly to one another,
 * and each publishing-subscribing pair tries to find a common video codec that they can both use.
 * In this regard, the video codec used by the pair in a relayed session may be different from
 * the preferred video codec setting. For more information see the Vonage Video API
 * <a href="https://tokbox.com/developer/guides/codecs/">Video codecs</a> developer guide.
 *
 * @return {Promise} A promise that is resolved when the list of supported codecs is ready.
 * The promise is resolved (on success) with an object that has two properties:
 * <code>videoDecoders</code>, an array of supported video codecs for decoding, and
 * <code>videoEncoders</code>, an array of supported video codecs for encoding, such as:
 * <pre>
 * {
 *    videoDecoders: ['H264', 'VP8', 'VP9'],
 *    videoEncoders: ['H264', 'VP8', 'VP9']
 * }
 * </pre>
 * <p>
 * The promise is rejected if there is an error in getting the list.
 *
 * @method OT.getSupportedCodecs
 * @memberof OT
 */
const getSupportedCodecs = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var RTCPeerConnection, codecs, canvas, stream, localPc, pcConfig, offer;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof window === 'undefined')) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", {
            videoEncoders: [],
            videoDecoders: []
          });
        case 2:
          RTCPeerConnection = windowMock.RTCPeerConnection;
          if (!(window.RTCRtpSender && 'getCapabilities' in window.RTCRtpSender)) {
            _context.next = 7;
            break;
          }
          codecs = window.RTCRtpSender.getCapabilities('video').codecs.map(c => c.mimeType || c.name) // Edge/ORTC does not support mimeType
          .map(mimeTypeOrName => mimeTypeOrName.replace('video/', ''));
          codecs = filterCodecList(codecs);
          return _context.abrupt("return", {
            videoEncoders: codecs,
            videoDecoders: codecs
          });
        case 7:
          if (!(_env.default.name === 'Chrome' && !('captureStream' in window.HTMLCanvasElement.prototype))) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", {
            videoEncoders: ['VP8'],
            videoDecoders: ['VP8']
          });
        case 9:
          if (!_env.default.isLegacyEdge) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", {
            videoEncoders: ['H264', 'VP8'],
            videoDecoders: ['H264', 'VP8']
          });
        case 11:
          canvas = window.document.createElement('canvas'); // Need to make a 2d context for captureStream to work, even though it's not used.
          canvas.getContext('2d');
          stream = canvas.captureStream();
          _context.prev = 14;
          pcConfig = {
            iceServers: []
          };
          if ((0, _shouldUsePlanBSDP.default)()) {
            pcConfig.sdpSemantics = 'plan-b';
          }
          localPc = new RTCPeerConnection(pcConfig);
          if (localPc.addTrack) {
            localPc.addTrack(stream.getVideoTracks()[0], stream);
          } else if (localPc.addStream) {
            localPc.addStream(stream);
          }
          _context.next = 21;
          return localPc.createOffer();
        case 21:
          offer = _context.sent;
          codecs = _sdp_helpers.default.getCodecs(offer.sdp, 'video') || [];
          codecs = filterCodecList(codecs);
          return _context.abrupt("return", {
            videoEncoders: codecs,
            videoDecoders: codecs
          });
        case 27:
          _context.prev = 27;
          _context.t0 = _context["catch"](14);
          throw otError(_Errors.default.UNABLE_TO_ACCESS_MEDIA_ENGINE, new Error('OT.getSupportedCodecs was not able to get the list of supported codecs'), _exception_codes.default.UNABLE_TO_ACCESS_MEDIA_ENGINE);
        case 30:
          _context.prev = 30;
          localPc.close();
          return _context.finish(30);
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 27, 30, 33]]);
  }));
  return function getSupportedCodecs() {
    return _ref.apply(this, arguments);
  };
}();
var _default = getSupportedCodecs;
exports.default = _default;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _ml = _interopRequireDefault(__webpack_require__(346));
/**
 * Whether the client supports media processors, like video and audio filters.
 *
 * <p>
 * The following example enables the background blur filter, if supported
 * by the client:
 * <pre>
 * // Add background blur, if supported
 * if (OT.hasMediaProcessorSupport()) {
 *   publisherOptions.videoFilter = {
 *     type: 'backgroundBlur',
 *   };
 * }
 * // Add advanced noise suppression, if supported
 * if (OT.hasMediaProcessorSupport()) {
 *   publisherOptions.audioFilter = {
 *     type: 'advancedNoiseSuppression',
 *   };
 * }
 *
 * const publisher = OT.initPublisher(publisherOptions);
 * </pre>
 *
 * @return {Boolean} Whether the client supports media processors (<code>true</code>), like
 * video and audio filters, or not (<code>false</code>).
 *
 * @method OT.hasMediaProcessorSupport
 * @memberof OT
 *
 * @see <a href="#initPublisher">OT.initPublisher()</a>
 * @see <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
 * @see <a href="Publisher.html#applyAudioFilter">Publisher.applyAudioFilter()</a>
 */
var _default = _ml.default.isSupported;
exports.default = _default;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _hasE2eeCapability = _interopRequireDefault(__webpack_require__(115));
/**
 * Whether the client supports end-to-end encryption.
 *
 * <p>
 * The following example enables the end-to-end encryption, if supported
 * by the client:
 * <pre>
 * // Publish in a session with end-to-end encryption, if supported
 * if (OT.hasEndToEndEncryptionSupport()) {
 *   session.publish(publisher, error) = {
 *     ...
 *   });
 * }
 * </pre>
 *
 * @return {Boolean} Whether the client supports end-to-end encryption (<code>true</code>),
 *  or not (<code>false</code>).
 *
 * @method OT.hasEndToEndEncryptionSupport
 * @memberof OT
 *
 * @see <a href="#initSession">OT.initSession()</a>
 * @see <a href="Session.html#publish">Session.publish()</a>
 */
var _default = _hasE2eeCapability.default;
exports.default = _default;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = getDevices;
var _deviceHelpers2 = _interopRequireDefault(__webpack_require__(22));
const _deviceHelpers = (0, _deviceHelpers2.default)(),
  getInputMediaDevices = _deviceHelpers.getInputMediaDevices;

/**
 * Enumerates the audio input devices (such as microphones) and video input devices
 * (cameras) available to the browser.
 * <p>
 * The array of devices is passed in as the <code>devices</code> parameter of
 * the <code>callback</code> function passed into the method.
 *
 * @param callback {Function} The callback function invoked when the list of devices
 * devices is available. This function takes two parameters:
 * <ul>
 *   <li><code>error</code> &mdash; This is set to an error object when
 *   there is an error in calling this method; it is set to <code>null</code>
 *   when the call succeeds.</li>
 *
 *   <li><p><code>devices</code> &mdash; An array of objects corresponding to
 *   available microphones and cameras. Each object has three properties: <code>kind</code>,
 *   <code>deviceId</code>, and <code>label</code>, each of which are strings.
 *   <p>
 *   The <code>kind</code> property is set to <code>"audioInput"</code> for audio input
 *   devices or <code>"videoInput"</code> for video input devices.
 *   <p>
 *   The <code>deviceId</code> property is a unique ID for the device. You can pass
 *   the <code>deviceId</code> in as the <code>audioSource</code> or <code>videoSource</code>
 *   property of the <code>options</code> parameter of the
 *   <a href="#initPublisher">OT.initPublisher()</a> method.
 *   <p>
 *   The <code>label</code> property identifies the device. The <code>label</code>
 *   property is set to an empty string if the user has not previously granted access to
 *   a camera and microphone.</li>
 * </ul>
 * <i>Note:</i> The browser may limit the number of returned audio and video input devices
 * to one each before the user has granted access to a camera or microphone.
 *
 * @see <a href="#initPublisher">OT.initPublisher()</a>
 * @method OT.getDevices
 * @memberof OT
 */
function getDevices(callback) {
  getInputMediaDevices().then(devices => callback(undefined, devices), callback);
}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _deviceHelpers = _interopRequireDefault(__webpack_require__(22));
var _otError = _interopRequireDefault(__webpack_require__(15));
var _Errors = _interopRequireDefault(__webpack_require__(8));
var _getAudioOutputDevices = _interopRequireDefault(__webpack_require__(363));
var _updateSubscribersSinkid = _interopRequireDefault(__webpack_require__(365));
/* eslint-disable global-require */
var _default = function _default(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const _ref = deps.deviceHelpers || (0, _deviceHelpers.default)(),
    hasAudioOutputApiSupport = _ref.hasAudioOutputApiSupport,
    hasDevice = _ref.hasDevice;
  const getAudioOutputDevices = deps.getAudioOutputDevices || _getAudioOutputDevices.default;
  const updateSubscribersSinkId = deps.updateSubscribersSinkId || _updateSubscribersSinkid.default;
  const otError = (0, _otError.default)();

  /**
   * Sets the new audio output device.
   * <p>
   *   The method returns a Promise which resolves when the operation completes
   *   successfully. If there is an error, the promise is rejected.
   * </p>
   *
   * <p>
   *  <em>Note</em>: Current browser support is for desktop versions of Chrome 49+,
   * Edge 17+, and Opera 36+.
   * </p>
   *
   * @see <a href="#getAudioOutputDevices">OT.getAudioOutputDevices()</a>
   * @see <a href="#getActiveAudioOutputDevice">OT.getActiveAudioOutputDevice()</a>
   * @method OT.setAudioOutputDevice
   * @memberof OT
   * @return {Promise} A promise that resolves when the operation completes successfully.
   * If there is an error, the promise is rejected.
   */
  const setAudioOutputDevice = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(deviceId) {
      var devices, isValidDevice;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (hasAudioOutputApiSupport()) {
              _context.next = 2;
              break;
            }
            throw otError(_Errors.default.UNSUPPORTED_BROWSER, new Error('setAudioOutputDevice is not supported in your browser.'));
          case 2:
            _context.next = 4;
            return getAudioOutputDevices();
          case 4:
            devices = _context.sent;
            isValidDevice = hasDevice(devices, deviceId);
            if (isValidDevice) {
              _context.next = 8;
              break;
            }
            throw otError(_Errors.default.INVALID_AUDIO_OUTPUT_SOURCE, new Error('The requested device is not valid.'));
          case 8:
            _context.prev = 8;
            _context.next = 11;
            return updateSubscribersSinkId(deviceId);
          case 11:
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](8);
            throw otError(_Errors.default.REQUESTED_DEVICE_PERMISSION_DENIED, new Error('No permission to use the requested device.'));
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 13]]);
    }));
    return function setAudioOutputDevice(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return setAudioOutputDevice;
};
exports.default = _default;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _deviceHelpers2 = _interopRequireDefault(__webpack_require__(22));
var _audioOutputDevicesChangeHandler = _interopRequireDefault(__webpack_require__(843));
const audioOutputDevicesChangeHandler = (0, _audioOutputDevicesChangeHandler.default)();
const _deviceHelpers = (0, _deviceHelpers2.default)(),
  hasAudioOutputApiSupport = _deviceHelpers.hasAudioOutputApiSupport,
  getNativeMediaDevices = _deviceHelpers.getNativeMediaDevices;
var _default = () => {
  // In order to keep the current device ID synchronized, let's listen to the device change event
  if (hasAudioOutputApiSupport()) {
    const mediaDevices = getNativeMediaDevices();
    let isProcessing = false;
    mediaDevices.addEventListener('devicechange', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isProcessing) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            isProcessing = true;
            _context.next = 5;
            return audioOutputDevicesChangeHandler();
          case 5:
            isProcessing = false;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
  }
};
exports.default = _default;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(4));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
var _log = _interopRequireDefault(__webpack_require__(1));
var _currentAudioOutputDevice = _interopRequireDefault(__webpack_require__(107));
var _deviceHelpers = _interopRequireDefault(__webpack_require__(22));
var _updateSubscribersSinkid = _interopRequireDefault(__webpack_require__(365));
/* eslint-disable global-require */

const audioOutputDevicesChangeHandlerFactory = function audioOutputDevicesChangeHandlerFactory(deps) {
  if (deps === void 0) {
    deps = {};
  }
  const _ref = deps.deviceHelpers || (0, _deviceHelpers.default)(),
    getAudioOutputMediaDevices = _ref.getAudioOutputMediaDevices,
    getDefaultAudioOutputDeviceId = _ref.getDefaultAudioOutputDeviceId,
    hasDevice = _ref.hasDevice;
  const _ref2 = deps.currentAudioOutputDevice || _currentAudioOutputDevice.default,
    getCurrentAudioOutputDeviceId = _ref2.getCurrentAudioOutputDeviceId,
    setCurrentAudioOutputDeviceId = _ref2.setCurrentAudioOutputDeviceId;
  const updateSubscribersSinkId = deps.updateSubscribersSinkId || _updateSubscribersSinkid.default;
  const logging = deps.logging || (0, _log.default)('currentAudioOutputDevice');
  const audioOutputDevicesChangeHandler = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var devices, isStillConnected, defaultDeviceId;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAudioOutputMediaDevices();
          case 2:
            devices = _context.sent;
            if (!(devices.length === 0)) {
              _context.next = 6;
              break;
            }
            setCurrentAudioOutputDeviceId('');
            return _context.abrupt("return");
          case 6:
            isStillConnected = hasDevice(devices, getCurrentAudioOutputDeviceId());
            if (!isStillConnected) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return");
          case 9:
            // Since the current output device was removed, let's use the default device.
            defaultDeviceId = getDefaultAudioOutputDeviceId(devices);
            setCurrentAudioOutputDeviceId(defaultDeviceId);

            // Update the current audio output device ID
            _context.prev = 11;
            _context.next = 14;
            return updateSubscribersSinkId(defaultDeviceId);
          case 14:
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](11);
            logging.debug('Failed to set the default audio output device.', _context.t0);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[11, 16]]);
    }));
    return function audioOutputDevicesChangeHandler() {
      return _ref3.apply(this, arguments);
    };
  }();
  return audioOutputDevicesChangeHandler;
};
var _default = audioOutputDevicesChangeHandlerFactory;
exports.default = _default;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(845);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(859)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(846)(false);
// Imports
var urlEscape = __webpack_require__(847);
var ___CSS_LOADER_URL___0___ = urlEscape(__webpack_require__(848));
var ___CSS_LOADER_URL___1___ = urlEscape(__webpack_require__(849));
var ___CSS_LOADER_URL___2___ = urlEscape(__webpack_require__(850));
var ___CSS_LOADER_URL___3___ = urlEscape(__webpack_require__(851));
var ___CSS_LOADER_URL___4___ = urlEscape(__webpack_require__(852));
var ___CSS_LOADER_URL___5___ = urlEscape(__webpack_require__(853));
var ___CSS_LOADER_URL___6___ = urlEscape(__webpack_require__(854));
var ___CSS_LOADER_URL___7___ = urlEscape(__webpack_require__(855));
var ___CSS_LOADER_URL___8___ = urlEscape(__webpack_require__(856));
var ___CSS_LOADER_URL___9___ = urlEscape(__webpack_require__(857));
var ___CSS_LOADER_URL___10___ = urlEscape(__webpack_require__(858));

// Module
exports.push([module.i, "/*!\n * Copyright (c) 2017 TokBox, Inc.\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n */\n\n/**\n * OT Base styles\n */\n\n/* Root OT object, this is where our CSS reset happens */\n.OT_root,\n.OT_root * {\n  color: #ffffff;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: Arial, Helvetica, sans-serif;\n  vertical-align: baseline;\n}\n\n/**\n * Specific Element Reset\n */\n\n.OT_root h1,\n.OT_root h2,\n.OT_root h3,\n.OT_root h4,\n.OT_root h5,\n.OT_root h6 {\n  color: #ffffff;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 100%;\n  font-weight: bold;\n}\n\n.OT_root header {\n\n}\n\n.OT_root footer {\n\n}\n\n.OT_root div {\n\n}\n\n.OT_root section {\n\n}\n\n.OT_root video {\n\n}\n\n.OT_root button {\n\n}\n\n.OT_root strong {\n  font-weight: bold;\n}\n\n.OT_root em {\n  font-style: italic;\n}\n\n.OT_root a,\n.OT_root a:link,\n.OT_root a:visited,\n.OT_root a:hover,\n.OT_root a:active {\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.OT_root ul, .OT_root ol {\n  margin: 1em 1em 1em 2em;\n}\n\n.OT_root ol {\n  list-style: decimal outside;\n}\n\n.OT_root ul {\n  list-style: disc outside;\n}\n\n.OT_root dl {\n  margin: 4px;\n}\n\n.OT_root dl dt,\n.OT_root dl dd {\n  float: left;\n  margin: 0;\n  padding: 0;\n}\n\n.OT_root dl dt {\n  clear: left;\n  text-align: right;\n  width: 50px;\n}\n\n.OT_root dl dd {\n  margin-left: 10px;\n}\n\n.OT_root img {\n  border: 0 none;\n}\n\n/* Modal dialog styles */\n\n/* Modal dialog styles */\n\n.OT_dialog-centering {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n\n.OT_dialog-centering-child {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.OT_dialog {\n  position: relative;\n\n  box-sizing: border-box;\n  max-width: 576px;\n  margin-right: auto;\n  margin-left: auto;\n  padding: 36px;\n  text-align: center; /* centers all the inline content */\n\n  background-color: #363636;\n  color: #fff;\n  box-shadow: 2px 4px 6px #999;\n  font-family: 'Didact Gothic', sans-serif;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.OT_dialog * {\n  font-family: inherit;\n  box-sizing: inherit;\n}\n\n.OT_closeButton {\n  color: #999999;\n  cursor: pointer;\n  font-size: 32px;\n  line-height: 36px;\n  position: absolute;\n  right: 18px;\n  top: 0;\n}\n\n.OT_dialog-messages {\n  text-align: center;\n}\n\n.OT_dialog-messages-main {\n  margin-bottom: 36px;\n  line-height: 36px;\n\n  font-weight: 300;\n  font-size: 24px;\n}\n\n.OT_dialog-messages-minor {\n  margin-bottom: 18px;\n\n  font-size: 13px;\n  line-height: 18px;\n  color: #A4A4A4;\n}\n\n.OT_dialog-messages-minor strong {\n  color: #ffffff;\n}\n\n.OT_dialog-actions-card {\n  display: inline-block;\n}\n\n.OT_dialog-button-title {\n  margin-bottom: 18px;\n  line-height: 18px;\n\n  font-weight: 300;\n  text-align: center;\n  font-size: 14px;\n  color: #999999;\n}\n.OT_dialog-button-title label {\n  color: #999999;\n}\n\n.OT_dialog-button-title a,\n.OT_dialog-button-title a:link,\n.OT_dialog-button-title a:active {\n  color: #02A1DE;\n}\n\n.OT_dialog-button-title strong {\n  color: #ffffff;\n  font-weight: 100;\n  display: block;\n}\n\n.OT_dialog-button {\n  display: inline-block;\n\n  margin-bottom: 18px;\n  padding: 0 1em;\n\n  background-color: #1CA3DC;\n  text-align: center;\n  cursor: pointer;\n}\n\n.OT_dialog-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.OT_dialog-button-large {\n  line-height: 36px;\n  padding-top: 9px;\n  padding-bottom: 9px;\n\n  font-weight: 100;\n  font-size: 24px;\n}\n\n.OT_dialog-button-small {\n  line-height: 18px;\n  padding-top: 9px;\n  padding-bottom: 9px;\n\n  background-color: #444444;\n  color: #999999;\n  font-size: 16px;\n}\n\n.OT_dialog-progress-bar {\n  display: inline-block; /* prevents margin collapse */\n  width: 100%;\n  margin-top: 5px;\n  margin-bottom: 41px;\n\n  border: 1px solid #4E4E4E;\n  height: 8px;\n}\n\n.OT_dialog-progress-bar-fill {\n  height: 100%;\n\n  background-color: #29A4DA;\n}\n\n/* Helpers */\n\n.OT_centered {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin: 0;\n}\n\n.OT_dialog-hidden {\n  display: none;\n}\n\n.OT_dialog-button-block {\n  display: block;\n}\n\n.OT_dialog-no-natural-margin {\n  margin-bottom: 0;\n}\n\n/* Publisher and Subscriber styles */\n\n.OT_publisher, .OT_subscriber {\n  position: relative;\n  min-width: 48px;\n  min-height: 48px;\n}\n\n.OT_publisher .OT_video-element,\n.OT_subscriber .OT_video-element {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n\n  transform-origin: 0 0;\n}\n\n/* Styles that are applied when the video element should be mirrored */\n.OT_publisher.OT_mirrored .OT_video-element {\n  transform: scale(-1, 1);\n  transform-origin: 50% 50%;\n}\n\n.OT_subscriber_error {\n  background-color: #000;\n  color: #fff;\n  text-align: center;\n}\n\n.OT_subscriber_error > p {\n  padding: 20px;\n}\n\n/* The publisher/subscriber name/mute background */\n.OT_publisher .OT_bar,\n.OT_subscriber .OT_bar,\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name,\n.OT_publisher .OT_archiving,\n.OT_subscriber .OT_archiving,\n.OT_publisher .OT_archiving-status,\n.OT_subscriber .OT_archiving-status,\n.OT_publisher .OT_archiving-light-box,\n.OT_subscriber .OT_archiving-light-box {\n  -ms-box-sizing: border-box;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: block;\n  height: 34px;\n  position: absolute;\n}\n\n.OT_publisher .OT_bar,\n.OT_subscriber .OT_bar {\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.OT_publisher .OT_edge-bar-item,\n.OT_subscriber .OT_edge-bar-item {\n  z-index: 1; /* required to get audio level meter underneath */\n}\n\n/* The publisher/subscriber name panel/archiving status bar */\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name {\n  background-color: transparent;\n  color: #ffffff;\n  font-size: 15px;\n  line-height: 34px;\n  font-weight: normal;\n  padding: 0 4px 0 36px;\n  letter-spacing: normal;\n}\n\n.OT_publisher .OT_archiving-status,\n.OT_subscriber .OT_archiving-status {\n  background: rgba(0, 0, 0, 0.4);\n  top: auto;\n  bottom: 0;\n  left: 34px;\n  padding: 0 4px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 15px;\n  line-height: 34px;\n  font-weight: normal;\n  letter-spacing: normal;\n}\n\n.OT_micro .OT_archiving-status,\n.OT_micro:hover .OT_archiving-status,\n.OT_mini .OT_archiving-status,\n.OT_mini:hover .OT_archiving-status {\n  display: none;\n}\n\n.OT_publisher .OT_archiving-light-box,\n.OT_subscriber .OT_archiving-light-box {\n  background: rgba(0, 0, 0, 0.4);\n  top: auto;\n  bottom: 0;\n  right: auto;\n  width: 34px;\n  height: 34px;\n}\n\n.OT_archiving-light {\n  width: 7px;\n  height: 7px;\n  border-radius: 30px;\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  background-color: #575757;\n  box-shadow: 0 0 5px 1px #575757;\n}\n\n.OT_archiving-light.OT_active {\n  background-color: #970d13;\n  -webkit-animation: OT_pulse 1.3s ease-in;\n  -moz-animation: OT_pulse 1.3s ease-in;\n  -webkit-animation: OT_pulse 1.3s ease-in;\n  -webkit-animation-iteration-count: infinite;\n  -moz-animation-iteration-count: infinite;\n  -webkit-animation-iteration-count: infinite;\n}\n\n.OT_mini .OT_bar,\n.OT_bar.OT_mode-mini,\n.OT_bar.OT_mode-mini-auto {\n  bottom: 0;\n  height: auto;\n}\n\n.OT_mini .OT_name.OT_mode-off,\n.OT_mini .OT_name.OT_mode-on,\n.OT_mini .OT_name.OT_mode-auto,\n.OT_mini:hover .OT_name.OT_mode-auto {\n  display: none;\n}\n\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name {\n    left: 10px;\n    right: 37px;\n    height: 34px;\n    padding-left: 0;\n}\n\n.OT_publisher .OT_mute,\n.OT_subscriber .OT_mute {\n    border: none;\n    cursor: pointer;\n    display: block;\n    position: absolute;\n    text-align: center;\n    text-indent: -9999em;\n    background-color: transparent;\n    background-repeat: no-repeat;\n}\n\n.OT_publisher .OT_mute,\n.OT_subscriber .OT_mute {\n  right: 0;\n  top: 0;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  height: 36px;\n  width: 37px;\n}\n\n.OT_mini .OT_mute,\n.OT_publisher.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold,\n.OT_subscriber.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold {\n  top: 50%;\n  left: 50%;\n  right: auto;\n  margin-top: -18px;\n  margin-left: -18.5px;\n  border-left: none;\n}\n\n.OT_publisher .OT_mute {\n  background-image: url(" + ___CSS_LOADER_URL___0___ + ");\n  background-position: 9px 5px;\n}\n\n.OT_publisher .OT_mute.OT_active {\n  background-image: url(" + ___CSS_LOADER_URL___1___ + ");\n  background-position: 9px 4px;\n}\n\n.OT_subscriber .OT_mute {\n  background-image: url(" + ___CSS_LOADER_URL___2___ + ");\n  background-position: 8px 7px;\n}\n\n.OT_subscriber .OT_mute.OT_active {\n  background-image: url(" + ___CSS_LOADER_URL___3___ + ");\n  background-position: 7px 7px;\n}\n\n/**\n * Styles for display modes\n *\n * Note: It's important that these completely control the display and opacity\n * attributes, no other selectors should atempt to change them.\n */\n\n/* Default display mode transitions for various chrome elements */\n.OT_publisher .OT_edge-bar-item,\n.OT_subscriber .OT_edge-bar-item {\n  transition-property: top, bottom, opacity;\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_mode-off,\n.OT_publisher .OT_edge-bar-item.OT_mode-auto,\n.OT_subscriber .OT_edge-bar-item.OT_mode-auto,\n.OT_publisher .OT_edge-bar-item.OT_mode-mini-auto,\n.OT_subscriber .OT_edge-bar-item.OT_mode-mini-auto {\n  top: -25px;\n  opacity: 0;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_mode-off {\n  display: none;\n}\n\n.OT_mini .OT_mute.OT_mode-auto,\n.OT_publisher .OT_mute.OT_mode-mini-auto,\n.OT_subscriber .OT_mute.OT_mode-mini-auto {\n  top: 50%;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto {\n  top: auto;\n  bottom: -25px;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-on,\n.OT_subscriber .OT_edge-bar-item.OT_mode-on,\n.OT_publisher .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,\n.OT_subscriber .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,\n.OT_publisher:hover .OT_edge-bar-item.OT_mode-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_mode-auto,\n.OT_publisher:hover .OT_edge-bar-item.OT_mode-mini-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_mode-mini-auto {\n  top: 0;\n  opacity: 1;\n}\n\n.OT_mini .OT_mute.OT_mode-on,\n.OT_mini:hover .OT_mute.OT_mode-auto,\n.OT_mute.OT_mode-mini,\n.OT_root:hover .OT_mute.OT_mode-mini-auto {\n  top: 50%;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,\n.OT_publisher:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto {\n  top: auto;\n  bottom: 0;\n  opacity: 1;\n}\n\n\n/* Contains the video element, used to fix video letter-boxing */\n.OT_widget-container {\n  position: absolute;\n  background: linear-gradient(60.08deg, #333333 0%, #1A1A1A 100%);\n  overflow: hidden;\n}\n\n.OT_hidden-audio {\n  position: absolute !important;\n  height: 1px !important;\n  width: 1px !important;\n}\n\n/* Load animation */\n.OT_root .OT_video-loading {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: none;\n\n  background-color: rgba(0, 0, 0, .75);\n}\n\n.OT_root .OT_video-loading .OT_video-loading-spinner {\n  background: url(" + ___CSS_LOADER_URL___4___ + ") no-repeat;\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  left: 50%;\n  top: 50%;\n  margin-left: -16px;\n  margin-top: -16px;\n  animation: OT_spin 2s linear infinite;\n}\n@keyframes OT_spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.OT_publisher.OT_loading .OT_video-loading,\n.OT_subscriber.OT_loading .OT_video-loading {\n  display: block;\n}\n\n.OT_publisher.OT_loading .OT_video-element,\n.OT_subscriber.OT_loading .OT_video-element {\n  /*display: none;*/\n}\n\n.OT_video-centering {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n\n.OT_video-container {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.OT_video-poster {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: none;\n\n  opacity: 1.0;\n\n  background-repeat: no-repeat;\n  background-image: url(" + ___CSS_LOADER_URL___5___ + ");\n  background-size: auto 55%;\n}\n\n.OT_fit-mode-cover .OT_video-element {\n  object-fit: cover;\n}\n\n/* Workaround for iOS freezing issue when cropping videos */\n/* https://bugs.webkit.org/show_bug.cgi?id=176439 */\n@media only screen\n  and (orientation: portrait) {\n  .OT_subscriber.OT_ForceContain.OT_fit-mode-cover .OT_video-element {\n    object-fit: contain !important;\n  }\n}\n\n.OT_fit-mode-contain .OT_video-element {\n  object-fit: contain;\n}\n\n.OT_fit-mode-cover .OT_video-poster {\n  background-position: center;\n}\n\n.OT_fit-mode-contain .OT_video-poster {\n  background-position: center;\n}\n\n.OT_audio-level-meter {\n  position: absolute;\n  width: 25%;\n  max-width: 224px;\n  min-width: 21px;\n  top: 0;\n  right: 0;\n  overflow: hidden;\n}\n\n.OT_audio-level-meter:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_audio-level-meter__audio-only-img {\n  position: absolute;\n  top: 22%;\n  right: 15%;\n  width: 40%;\n\n  opacity: .7;\n\n  background: url(" + ___CSS_LOADER_URL___6___ + ") no-repeat center;\n}\n\n.OT_audio-level-meter__audio-only-img:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_audio-level-meter__value {\n  will-change: transform;\n  position: absolute;\n  top: -100%;\n  right: -100%;\n  width: 200%;\n  height: 200%;\n  transform: scale(0);\n  border-radius: 50%;\n  background-image: radial-gradient(circle, rgba(151, 206, 0, 1) 0%, rgba(151, 206, 0, 0) 100%);\n}\n\n.OT_audio-level-meter.OT_mode-off {\n    display: none;\n}\n\n.OT_audio-level-meter.OT_mode-on,\n.OT_audio-only .OT_audio-level-meter.OT_mode-auto {\n  display: block;\n}\n\n.OT_audio-only.OT_publisher .OT_video-element,\n.OT_audio-only.OT_subscriber .OT_video-element {\n  display: none;\n}\n\n\n.OT_video-disabled-indicator {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: bottom right;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 3px;\n  right: 3px;\n}\n\n.OT_video-disabled {\n  background-image: url(" + ___CSS_LOADER_URL___7___ + ");\n  background-size: 33px auto;\n}\n\n.OT_video-disabled-warning {\n  background-image: url(" + ___CSS_LOADER_URL___8___ + ");\n  background-size: 33px auto;\n}\n\n.OT_video-disabled-indicator.OT_active {\n  display: block;\n}\n\n.OT_audio-blocked-indicator {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.OT_audio-blocked {\n  background-image: url(" + ___CSS_LOADER_URL___9___ + ");\n  background-size: 90px auto;\n}\n\n.OT_container-audio-blocked {\n  cursor: pointer;\n}\n\n.OT_container-audio-blocked.OT_mini .OT_edge-bar-item {\n  display: none;\n}\n\n.OT_container-audio-blocked .OT_mute {\n  display: none;\n}\n\n.OT_audio-blocked-indicator.OT_active {\n  display: block;\n}\n\n.OT_video-unsupported {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(" + ___CSS_LOADER_URL___10___ + ");\n  background-size: 58px auto;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin-top: -30px;\n}\n\n.OT_video-unsupported-bar {\n  display: none;\n  position: absolute;\n  width: 192%; /* copy the size of the audio meter bar for symmetry */\n  height: 192%;\n  top: -96% /* half of the size */;\n  left: -96%;\n  border-radius: 50%;\n\n  background-color: rgba(0, 0, 0, .8);\n}\n\n.OT_video-unsupported-img {\n  display: none;\n  position: absolute;\n  top: 11%;\n  left: 15%;\n  width: 70%;\n  opacity: .7;\n  background-image: url(" + ___CSS_LOADER_URL___10___ + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100% auto;\n}\n\n.OT_video-unsupported-img:before {\n  /* makes the height of the container 93% of its width (90/97 px) */\n  content: '';\n  display: block;\n  padding-top: 93%;\n}\n\n.OT_video-unsupported-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n  margin-top: 40px;\n}\n\n.OT_video-unsupported.OT_active {\n  display: block;\n}\n\n.OT_mini .OT_video-unsupported,\n.OT_micro .OT_video-unsupported {\n  position: absolute;\n  width: 25%;\n  max-width: 224px;\n  min-width: 21px;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  background: none;\n  bottom: auto;\n  right: auto;\n  margin: auto;\n}\n\n.OT_mini .OT_video-unsupported:before,\n.OT_micro .OT_video-unsupported:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_mini .OT_video-unsupported-bar,\n.OT_micro .OT_video-unsupported-bar,\n.OT_mini .OT_video-unsupported-img,\n.OT_micro .OT_video-unsupported-img {\n  display: block;\n}\n\n.OT_mini .OT_video-unsupported-text,\n.OT_micro .OT_video-unsupported-text {\n  display: none;\n}\n\n.OT_hide-forced {\n  display: none;\n}\n\n.OT_ModalDialog {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  z-index: 1000;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n#tb_alert {\n  position: fixed;\n  width: 570px;\n  font-family: \"Lucida Grande\", Arial;\n  top: 50%;\n  left: 50%;\n  margin-top: -75px;\n  margin-left: -285px;\n}\n\n#tb_alert * {\n  box-sizing: border-box;\n}\n\n#tb_alert .OT_alert {\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  background-color: #333;\n  position: relative;\n  padding: 30px;\n  overflow: visible;\n  margin-left: 70px;\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n  border-left-color: rgba(255, 255, 255, 0.1);\n\n  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));\n\n  background-image: -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));\n\n  background-size: 4px 4px;\n  background-position: 0 0, 2px 2px;\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n#tb_alert .OT_alert-exclamation {\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n\n  margin: -1px 0;\n\n  font-family: MS Trebuchet;\n  font-weight: bold;\n  font-size: 60px;\n  text-shadow: -1px -1px 2px rgba(0, 0, 0, 0.5);\n\n  color: white;\n  width: 65px;\n  position: absolute;\n  padding: 42px 0;\n  text-align: center;\n  left: -70px;\n  top: 0;\n  bottom: 0;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n\n  border-bottom-color: transparent;\n  border-left: none;\n  border-right: none;\n}\n\n.OT_alert-exclamation {\n  background-color: #9c1408;\n  background-image: linear-gradient(0deg, #dd0c0a 0%, #9c1408 100%);\n}\n\n.OT_alert-exclamation.OT_alert-check {\n  background-color: #0a8a16;\n  background-image: linear-gradient(0deg, #12c722 0%, #0a8a16 100%);\n}\n\n#tb_alert .OT_alert-exclamation:after,\n#tb_alert .OT_alert-exclamation:before {\n  content: \" \";\n  position: absolute;\n  right: -24px;\n  top: 40%;\n  border: 12px solid transparent;\n  border-left-color: #9c1408;\n}\n\n#tb_alert .OT_alert-exclamation.OT_alert-check:after,\n#tb_alert .OT_alert-exclamation.OT_alert-check:before {\n  border-left-color: #0a8a16;\n}\n\n#tb_alert .OT_alert-exclamation:before {\n  border-left-color: #bc3428;\n  top: 39%;\n}\n\n#tb_alert .OT_alert-body {\n  color: #c8c5c5;\n  margin: 0;\n  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);\n  font-size: 14px;\n  line-height: 1.3em;\n}\n\n#tb_alert .continue-text {\n  margin-top: 12px\n}\n\n#tb_alert > * a {\n  color: #a7d8df;\n  text-decoration: none;\n}\n\n#tb_alert .OT_alert-header {\n  font-size: 24px;\n  padding-bottom: 5px;\n  color: #aaa;\n  font-weight: bold;\n  position: relative;\n  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);\n  margin: 0;\n}\n\n#tb_alert .OT_alert-header::before {\n  content: attr(data-text);\n  position: absolute;\n  left: 0;\n  color: white;\n  -webkit-mask-image: -webkit-gradient(\n    linear,\n    left top, left bottom,\n    from(rgba(0, 0, 0, 1)),\n    color-stop(60%, rgba(0, 0, 0, 0)),\n    to(rgba(0, 0, 0, 0))\n  );\n}\n\n#tb_alert .OT_alert-close-button {\n  position: absolute;\n  right: 8px;\n  top: 5px;\n  background-color: #000;\n  color: #666;\n  border: none;\n  font-size: 20px;\n  /** Hack to bring it up to the proper line top */\n  line-height: 14px;\n  padding: 0;\n  padding-bottom: 3px;\n  cursor: pointer;\n}\n\n#tb_alert #section-mobile-unsupported-install,\n#tb_alert #section-mobile-supported-install,\n#tb_alert #section-mobile-upgrade-install {\n  width: 200px;\n  top: 0px;\n  left: 25%;\n  margin-top: 0;\n  margin-left: 0;\n}\n\n@media all and (max-height: 300px) {\n  #tb_alert {\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    margin-left: 0;\n    margin-top: 0;\n  }\n  #tb_alert #section-mobile-unsupported-install,\n  #tb_alert #section-mobile-supported-install,\n  #tb_alert #section-mobile-upgrade-install {\n    margin-left: 0;\n    margin-top: 10px;\n    left: 0;\n  }\n}\n\n#tb_alert #section-supported-install,\n#tb_alert #section-unsupported-install,\n#tb_alert #section-upgrade-install,\n#tb_alert #section-mobile-unsupported-install,\n#tb_alert #section-mobile-supported-install,\n#tb_alert #section-mobile-upgrade-install {\n  display: none;\n}\n", ""]);



/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return '@media ' + item[2] + '{' + content + '}';
      } else {
        return content;
      }
    }).join('');
  }; // import a list of modules into the list


  list.i = function (modules, mediaQuery) {
    if (typeof modules === 'string') {
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    for (var i = 0; i < this.length; i++) {
      var id = this[i][0];

      if (id != null) {
        alreadyImportedModules[id] = true;
      }
    }

    for (i = 0; i < modules.length; i++) {
      var item = modules[i]; // skip already imported module
      // this implementation is not 100% perfect for weird media query combinations
      // when a module is imported multiple times with different media queries.
      // I hope this will never occur (Hey this way we have smaller bundles)

      if (item[0] == null || !alreadyImportedModules[item[0]]) {
        if (mediaQuery && !item[2]) {
          item[2] = mediaQuery;
        } else if (mediaQuery) {
          item[2] = '(' + item[2] + ') and (' + mediaQuery + ')';
        }

        list.push(item);
      }
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || '';
  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
  return '/*# ' + data + ' */';
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function escape(url, needQuotes) {
  if (typeof url !== 'string') {
    return url;
  } // If url is already wrapped in quotes, remove them


  if (/^['"].*['"]$/.test(url)) {
    url = url.slice(1, -1);
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]/.test(url) || needQuotes) {
    return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
  }

  return url;
};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAMAAAC02HQrAAAA1VBMVEUAAAD3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj39/j3+Pj3+Pn4+Pk/JRMlAAAAQ3RSTlMABAUHCQoLDhAQERwdHiAjLjAxOD9ASFBRVl1mbnZ6fH2LjI+QkaWqrrC1uLzAwcXJycrL1NXj5Ofo6u3w9fr7/P3+d4M3+QAAAQBJREFUGBlVwYdCglAABdCLlr5Unijm3hMUtBzlBLSr//9JgUToOQgVJgceJgU8aHgMeA38K50ZOpcQmTPwcyXn+JM8M3JJIqQypiIkeXelTyIkGZPwKS1NMia1lgKTVkaE3oQQGYsmHNqSMWnTgUFbMiZtGlD2dpaxrL1XgM0i4ZK8MeAmFhsAs29MGZniawagS63oMOQUNXYB5D0D1RMDpyoMLw/fiE2og/V+PVDR5AiBl0/2Uwik+vx4xV3a5G5Ye68Nd1czjUjZckm6VhmPciRzeCZICjwTJAViQq+3e+St167rAoHK8sLYZVkBYPCZAZ/eGa+2R5LH7Wrc0YFf/O9J3yBDFaoAAAAASUVORK5CYII="

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAdCAYAAABFRCf7AAADcElEQVRIiaWVXWhcRRTHf7NNd2aDtUKMIjTpg4ufFIuiUOmDEWm0Vi3VYhXRqIggQh4sWJFSig9+oOhTKSpIRUWMIBIr2kptoTbgU6ooxCiIjR+14kcJmf9sNceHnd3ebnc3Uv9wuXfOzPzmnDMz5zozGwdWAbc65w5RUJQ8cC2wDJgFJioh/MJCMrNxq2vOzK4HmIvRRemxKP0RJWt53o7S+d2Yzsx6gQ+AIUDAnUqpBLzXZd4RYFUlhB/bdZacc3PAOmAcCMC7wfvFwLNdoAPAyx09bXyYWRl4E7gDmAdGlNKFwLYu8GolhO9O87RJd64GbMrgEvB68P4osMWdXLtVV7czlooNpVRWSs8DO7NpR/B+3rBHsvetCgtCMTxwQCm9BbyQrc8F7/uBex3uRCeXO0PrUZ4NfKyUPgWeyj3bg/crDNsIRGwBaJQGorQ3Svdn2wHgc2BUKb0DPJHtjwfvbwRucc7tz+N+i9LFUdoXpfVN36I0CVwBTFI/q9e1LPxT8P4qYEdu70q12mYzWw1MYQzjeJF6zq+shHC4B7jklOBPP/TzSunh4P0DwKvAfb5c9krpe+CcwsEoZdbhEvBM9wxRAl5RShcA9wAngE3B+8tLpdLuwrhp4MNmK0pfRWkySr7NXS8+L5nZbWZWy/Vin1IaitJnUTqvwevJ71lgSSWEFKUfHG7Q2m/xqFJaGry/GXgfGPLl8mJgrXPur2JoUC8Qy3OpG+sAbGhEKT0ErAWOA6uBPWbW1wr9BOgFbgKezot0kAPYqJQA1gC/A9cA+82svzksSn1R+jNKX0SpnM/e1x3yqig92JhrZivM7FjO8bSZLSuCR/Ok16K0KMNHojQWpYko7Y7S1igN5PE3ROl4lNaZ2UVmNpPBU01orvZvZPCeKFXbBR+lEKVtUapFaSZKg9njqpl9aWYTrmXCImA7sCWb9lK/jj9TrwkrgA1AH3AQuKsSwkzbrLfxpgpsBtYDxf/R3xm2ExirhNCuHHZXTsmRwiat+S/zSt06eysVA/4pmGr/G3qm6ik28v29FKgCg8BS6pvS0KNRGgZ+Bb4FpsxsOkfUlMuwDcBWYOUZOHYM2AU8WQmhBifDv70O7PjX7KZ+4G7g3FM8zd6uBIaBy4AqxnIcZwFLCovPAhE4Sj38b4BDwEeVEFKD9S94Khjn486v3QAAAABJRU5ErkJggg=="

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAABx0lEQVQ4jaWUv48NURiGn3ONmCs32ZBd28ht1gqyZAkF21ylQkEiSp2ehpDlD1BoFGqqVdJohYKI7MaPxMoVNghCWMF+7ybLUewnOXfcMWO9yeQ857zne8+XmZOBGjJpr0kvTIomvTZpS526UCO4DUwD64FjwCFgqZnnR+oc8LfgzKQ73vGsr42ZtGjSQFV9o8KfBCacZwCaef4YmAf2rzjcpN3A2WSpm/AssKcqPDNpDBjs410CViXzTwk/A7b1C4wxDgOngAsZcAXY2buDfp/6S4F3lDS8DjgBzDWAjX/Y/e/QgYS/AhsKHa+OMQ6GEJ4Cj4BOAxgq6aCowyZtdf4OtAr+FHDO+R4wWnVbihr3cQnICt4boO38GWj9a/icjwOACt4m4K3zEPA+AxaAtTWCnwN3lzHkEL8V/OPAGud9wK2GF9XR1Wae/1zG2AI+pGYI4VUIoRtjHAc2A9cz4LRPevYCZ+i9/4sJt4GXJU10gaPAzdI2TTro/5Tfz8XEe2LSZGmxq/SDNvP8BnA5WRrx4BwYBe6vONx1EnjovGvBLAAd4Adwuyq8UiaNmDTvr+a8SQ9MuvbfwckBHZPe+QEfTdpep+4XZmPBHiHgz74AAAAASUVORK5CYII="

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAACtklEQVQ4jZ2VSYiURxTHf+/T9Nc9iRrBuYySmIsXUU9iFMEFERRBvAjJLUQi5ioiHvSScfTmgqC4XAT1ZIgLuJHkICaaQAgKI2hAUBT30bjUq7bbv4eukXK029F3+eqtv/fqK6qQdEnSNUmT6CDB/bvgfjO4N9zj2RD8007xg1IABkwEzkma0qb4PGAPMBZYLtSD8eNwAEjqTlNI0gNJM4YU7w7ut4O7gvuhZFsR3C8NC5BBLiTIY0mzM8AvqbiC++pk+zLpE95XuwAws3vAQuBPYDRwWtL84P4tsDSLv5oaug4EYOawAMF9jMdoLxqNZcDvQA04UVYqL4G/svj7AF21mhJscrvCksYBFO7xc2AAGGg2mrdjvf4rcAyomNn+slLZmUEGBgsYdh945xZJmgvckDSrEJpK6ySBgV6q12O8ABwGPjGzfWWlsjdN9rpjoSfA+DYDXARGAksK4Is3XC1Ub4z1f4CDQGFmu6tleQSYk0U+p7WVeefLJc00s4fAeWB6Qeunvj0m2ugx9gO7kmlrtSxvBfcy6fXUZS6rgG/S+jLQUwCVNmMC9HqM14EtSe+rluWazN8YEv8IqKZ1E1qnaIDO0ucx3gX6kv6TpM3AM+D/IbGjgP60/gq4WQA33gMA2OQxPgHWJX1ttSwL4FAeZGYLgB2SasBs4A8L7qOBf9M0uXQB3a+TMYSmVctyDrA9mfcBK82smSdKWgCcAaa1bTm4fxbc/8uuCQX3RanAD5Ka6Wo5IGnE0HxJPZ03pQX5Org3MsD3AO5xXLPZXJ9BjkrqdFg6QjZkgG3Jtsw93pG0VFI9QU5K6voYQBHcTydAfwheBI9HgvvPAJIWS3qeIL9JGvUxkO7gfi1BrqTvwkG/pPmSnibIqTzXPgAyEVgBjAEu1qrVPbk/PVTHgb/NbPGg/RVIzOQqzSTBaQAAAABJRU5ErkJggg=="

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMjMuNSIgY3k9IjIzLjUiIHI9IjIzLjUiIGZpbGw9IiMwMDAiLz48cGF0aCBkPSJNMjcuNjM0IDE4LjUwOGE0LjMwNCA0LjMwNCAwIDExLTguNjA5IDAgNC4zMDQgNC4zMDQgMCAwMTguNjA5IDB6bTQuNzEyIDEyLjgwNGMuMTIyLjUwNi0uMjc1Ljk2OS0uNzg2Ljk2OUgxNS4xYy0uNTEyIDAtLjkwOS0uNDYyLS43ODctLjk3Ljk5My00LjEzNyA0LjY1My03LjIwOCA5LjAxNi03LjIwOHM4LjAyMyAzLjA3IDkuMDE3IDcuMjA5eiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg=="

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzkgODYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTkuNzU3IDQwLjkyNGMzLjczOC01LjE5MSAxMi43MTEtNC4zMDggMTIuNzExLTQuMzA4IDIuMjIzIDMuMDE0IDUuMTI2IDI0LjU4NiAzLjYyNCAyOC43MTgtMS40MDEgMS4zMDEtMTEuNjExIDEuNjI5LTEzLjM4LTEuNDM2LTEuMjI2LTguODA0LTIuOTU1LTIyLjk3NS0yLjk1NS0yMi45NzV6bTU4Ljc4NSAwYy0zLjczNy01LjE5MS0xMi43MTEtNC4zMDgtMTIuNzExLTQuMzA4LTIuMjIzIDMuMDE0LTUuMTI2IDI0LjU4Ni0zLjYyNCAyOC43MTggMS40MDEgMS4zMDEgMTEuNjExIDEuNjI5IDEzLjM4LTEuNDM2IDEuMjI2LTguODA0IDIuOTU1LTIyLjk3NSAyLjk1NS0yMi45NzV6Ii8+PHBhdGggZD0iTTY4LjY0NyA1OC42Yy43MjktNC43NTMgMi4zOC05LjU2MSAyLjM4LTE0LjgwNCAwLTIxLjQxMi0xNC4xMTUtMzguNzctMzEuNTI4LTM4Ljc3LTE3LjQxMiAwLTMxLjUyNyAxNy4zNTgtMzEuNTI3IDM4Ljc3IDAgNC41NDEuNTE1IDguOTM2IDEuODAyIDEyLjk1IDEuNjk4IDUuMjk1LTUuNTQyIDYuOTkxLTYuNjE2IDIuMDczQzIuNDEgNTUuMzk0IDAgNTEuNzg3IDAgNDguMTAzIDAgMjEuNTM2IDE3LjY4NSAwIDM5LjUgMCA2MS4zMTYgMCA3OSAyMS41MzYgNzkgNDguMTAzYzAgLjcxOC0yLjg5OSA5LjY5My0zLjI5MiAxMS40MDgtLjc1NCAzLjI5My03Ljc1MSAzLjU4OS03LjA2MS0uOTEyeiIvPjxwYXRoIGQ9Ik01LjA4NCA1MS4zODVjLS44MDQtMy43ODIuNTY5LTcuMzM1IDMuMTM0LTcuOTIxIDIuNjM2LS42MDMgNS40ODUgMi4xNSA2LjI4OSA2LjEzMi43OTcgMy45NDgtLjc1MiA3LjQ1Ny0zLjM4OCA3Ljg1OS0yLjU2Ni4zOTEtNS4yMzctMi4zMTgtNi4wMzQtNi4wN3ptNjguODM0IDBjLjgwNC0zLjc4Mi0uNTY4LTcuMzM1LTMuMTMzLTcuOTIxLTIuNjM2LS42MDMtNS40ODUgMi4xNS02LjI4OSA2LjEzMi0uNzk3IDMuOTQ4Ljc1MiA3LjQ1NyAzLjM4OSA3Ljg1OSAyLjU2NS4zOTEgNS4yMzctMi4zMTggNi4wMzQtNi4wN3ptLTIuMDM4IDguMjg4Yy0uOTI2IDE5LjY1OS0xNS4xMTIgMjQuNzU5LTI1Ljg1OSAyMC40NzUtNS40MDUtLjYwNi0zLjAzNCAxLjI2Mi0zLjAzNCAxLjI2MiAxMy42NjEgMy41NjIgMjYuMTY4IDMuNDk3IDMxLjI3My0yMC41NDktLjU4NS00LjUxMS0yLjM3OS0xLjE4Ny0yLjM3OS0xLjE4N3oiLz48cGF0aCBkPSJNNDEuNjYyIDc4LjQyMmw3LjU1My41NWMxLjE5Mi4xMDcgMi4xMiAxLjE1MyAyLjA3MiAyLjMzNWwtLjEwOSAyLjczOGMtLjA0NyAxLjE4Mi0xLjA1MSAyLjA1NC0yLjI0MyAxLjk0NmwtNy41NTMtLjU1Yy0xLjE5MS0uMTA3LTIuMTE5LTEuMTUzLTIuMDcyLTIuMzM1bC4xMDktMi43MzdjLjA0Ny0xLjE4MiAxLjA1Mi0yLjA1NCAyLjI0My0xLjk0N3oiLz48L2c+PC9zdmc+"

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUwIiBoZWlnaHQ9IjkwIj48ZGVmcz48cGF0aCBkPSJNNjcgMTJMNi40NDggNzIuNTUyIDAgMzFWMThMMjYgMGw0MSAxMnptMyA3bDYgNDctMjkgMTgtMzUuNTAyLTYuNDk4TDcwIDE5eiIgaWQ9ImEiLz48L2RlZnM+PHJlY3Qgd2lkdGg9IjE1MCIgaGVpZ2h0PSI5MCIgcng9IjM1IiByeT0iNDUiIG9wYWNpdHk9Ii41Ii8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNikiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGQ9Ik0zOS4yNDkgNTEuMzEyYy42OTcgMTAuMzcgMi43ODUgMTcuODk3IDUuMjUxIDE3Ljg5NyAzLjAzOCAwIDUuNS0xMS40MTcgNS41LTI1LjVzLTIuNDYyLTI1LjUtNS41LTI1LjVjLTIuNTEgMC00LjYyOCA3Ljc5Ny01LjI4NyAxOC40NTNBOC45ODkgOC45ODkgMCAwMTQzIDQ0YTguOTg4IDguOTg4IDAgMDEtMy43NTEgNy4zMTJ6TTIwLjk4NSAzMi4yMjRsMTUuNzQ2LTE2Ljg3N2E3LjM4NSA3LjM4NSAwIDAxMTAuMzc0LS40MkM1MS43MDIgMTkuMTE0IDU0IDI5LjIwOCA1NCA0NS4yMDhjMCAxNC41MjctMi4zNDMgMjMuODgtNy4wMyAyOC4wNThhNy4yOCA3LjI4IDAgMDEtMTAuMTY4LS40NjhMMjAuNDA1IDU1LjIyNEgxMmE1IDUgMCAwMS01LTV2LTEzYTUgNSAwIDAxNS01aDguOTg1eiIgZmlsbD0iI0ZGRiIgbWFzaz0idXJsKCNiKSIvPjwvZz48cGF0aCBkPSJNMTA2LjUgMTMuNUw0NC45OTggNzUuMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iOTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03MCAxMkw5LjQ0OCA3Mi41NTIgMCA2MmwzLTQ0TDI5IDBsNDEgMTJ6bTggMmwxIDUyLTI5IDE4LTM1LjUwMi02LjQ5OEw3OCAxNHoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCAzKSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTkuMTEgMjAuOTY4SDQ4LjFhNSA1IDAgMDE1IDVWNTguMThhNSA1IDAgMDEtNSA1SDkuMTFhNSA1IDAgMDEtNS01VjI1Ljk3YTUgNSAwIDAxNS01em00Ny4wOCAxMy4zOTRjMC0uMzQ1IDUuNDcyLTMuMTU5IDE2LjQxNS04LjQ0M2EzIDMgMCAwMTQuMzA0IDIuNzAydjI2LjgzNWEzIDMgMCAwMS00LjMwNSAyLjcwMWMtMTAuOTQyLTUuMjg2LTE2LjQxMy04LjEtMTYuNDEzLTguNDQ2VjM0LjM2MnoiIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjYikiLz48L2c+PHBhdGggZD0iTTgxLjUgMTYuNUwxOS45OTggNzguMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(860);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css)
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 860 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ })
/******/ ]);
});
//# sourceMappingURL=opentok.js.map
